webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(27)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, enums_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var App = (function () {
        function App() {
        }
        App.NAME = 'Anchor Glass Production System';
        return App;
    }());
    exports.App = App;
    var Endpoints = (function () {
        function Endpoints() {
        }
        Endpoints.SIGNALR = '/signalr';
        Endpoints.POST_TOKEN = '/connect/token';
        Endpoints.LINESHEET = '/api/lineSheet';
        Endpoints.LINESHEET_LOCK_HOUR = '/api/lineSheet/lockHour';
        Endpoints.LINESHEET_UNLOCK_HOUR = '/api/lineSheet/unlockHour';
        Endpoints.DEFECT = '/api/defect';
        Endpoints.DEFECT_CLASSIFICATION_LIST = '/api/defect/classifications';
        Endpoints.DEFECT_COMMENT = '/api/defect/comment';
        Endpoints.DEFECT_HELD_PALLETS = '/api/defect/held-pallets';
        Endpoints.DEFECT_HELD_PALLETS_DELETE = '/api/defect/held-pallets/delete';
        Endpoints.DEFECT_MOLD_REJECT = '/api/defect/moldReject';
        Endpoints.DEFECT_MOLD_LOSS = '/api/defect/moldLossOption';
        Endpoints.DEFECT_MOLD_LOSS_STATUS = '/api/defect/defectMoldLosses';
        Endpoints.DEFECT_MOLD_REJECT_STATUS = '/api/defect/moldrejectstatus';
        Endpoints.DEFECT_EQUIP_FAIL = '/api/defect/equipFailure';
        Endpoints.DEFECT_DETAILS = '/api/defect/details';
        Endpoints.DEFECT_CRITICAL_REPORT = '/api/defect/criticalReport';
        Endpoints.DEFECT_LOSS_TYPES = '/api/defect/defectLossTypes';
        Endpoints.DEFECT_TYPES = '/api/defect/types';
        Endpoints.DEFECT_TYPES_NO_EXCLUSION = '/api/defect/types_no_exclusion';
        Endpoints.DEFECT_TYPES_ALL = '/api/defect/types/all';
        Endpoints.DEFECT_TYPE_DETAILS = '/api/defect/types/{0}/details';
        Endpoints.DEFECT_TYPE_WARE_CLASS = '/api/Defect/Types/WareClass';
        Endpoints.DEFECT_TYPE_ADD = '/api/defect/types/add';
        Endpoints.DEFECT_CAUSES = '/api/Defect/Causes/{id}';
        Endpoints.DEFECT_CAUSE_DETAILS = '/api/Defect/Causes/{0}/details';
        Endpoints.DEFECT_CAUSE_ADD = '/api/Defect/Causes/Add';
        Endpoints.DEFECT_EQUIPMENT = '/api/defectequipment';
        Endpoints.ACTIVE_MNRS = '/api/defect/activemnrs';
        Endpoints.DOWNTIME = '/api/Downtime';
        Endpoints.DOWNTIME_TYPES = '/api/Downtime/Types';
        Endpoints.DOWNTIME_SECTIONS = '/api/Downtime/Sections';
        Endpoints.TOOLS_AND_TYPES = '/api/tool/toolsAndTypes';
        Endpoints.SECTION_CHANGE = '/api/tool/sectionChange';
        Endpoints.SECTION_CHANGE_SKIP = '/api/tool/sectionChange/skip';
        Endpoints.SECTION_CHANGE_STRATEGY = '/api/sectionChange';
        Endpoints.TOOL = '/api/tool';
        Endpoints.TOOL_COMMENT = '/api/tool/comment';
        Endpoints.TOOL_MOLDS = '/api/tool/molds';
        Endpoints.REQUALIFICATION = '/api/requalification';
        Endpoints.NOTIFICATION = '/api/notification';
        Endpoints.NOTIFICATION_READ = '/api/notification/read';
        Endpoints.NOTIFICATION_COMPLETE = '/api/notification/complete';
        Endpoints.NEWGUID = '/api/utility/newguid';
        Endpoints.SHOP = '/api/shop';
        Endpoints.SHOP_CONFIGURATION = '/api/shop/configuration';
        Endpoints.SHOP_DOWNTIMES = '/api/shop/{0}/downtimes/open';
        Endpoints.PLANT_LISTS = '/api/plantlist';
        Endpoints.CUSTOMERS = '/api/customer';
        Endpoints.GLASS_COLORS = '/api/glasscolor';
        Endpoints.WARE_CLASSES = '/api/wareclass';
        Endpoints.JOBS = '/api/job';
        Endpoints.JOB_CHANGE_ADD = '/api/jobChange';
        Endpoints.JOB_PROCESSES = '/api/job/processes';
        Endpoints.JOB_DESCRIPTIONS = '/api/job/descriptions';
        Endpoints.JOB_MOLDS = '/api/job/molds';
        Endpoints.JOB_FINISHES = '/api/job/finishes';
        Endpoints.JOB_TARGET_MOLDS = '/api/job/targetmolds';
        Endpoints.JOB_TARGET_FINISHES = '/api/job/targetfinishes';
        Endpoints.JOB_RUNS = '/api/jobRun';
        Endpoints.JOB_RUN_RESTORE = '/api/jobrun/restore';
        Endpoints.JOB_RUNS_ACTIVE = '/api/jobRun/active';
        Endpoints.JOB_RUNS_TARGET = '/api/jobrun/getTargetPercent';
        Endpoints.USER_ROLES = '/api/user/roles';
        Endpoints.USER_ROLE_LOCATION = '/api/user/roleLocation';
        Endpoints.NAVIGATION_PLANTS = '/api/navigation/plants';
        Endpoints.NAVIGATION_LOCATIONS = '/api/navigation/locations';
        Endpoints.HOLIDAYS = '/api/admin/holidays';
        Endpoints.PLANT_LIST = '/api/admin/plants';
        Endpoints.PLANT_FEATURE_SETTINGS = '/api/admin/plants/PlantFeatureSettings';
        Endpoints.COURSE_OF_ACTION = '/api/Defect/Courses';
        Endpoints.USERS = '/api/user';
        Endpoints.USER_DATA = '/api/user/data';
        Endpoints.USER_GENERATED_USERNAME = '/api/user/generatedUserName';
        Endpoints.USER_CHANGE_PASSWORD = '/api/user/changePassword';
        Endpoints.ROLES = '/api/role';
        Endpoints.ROLES_ASSIGNABLE = '/api/role/assignable';
        Endpoints.SECURITY_QUESTIONS = '/api/securityQuestion';
        Endpoints.CHANGE_PASSWORD = '/api/account/changepassword';
        Endpoints.USERPROFILE = '/api/userprofile';
        Endpoints.RESET_PASSWORD = '/api/resetPassword';
        Endpoints.SEND_RESET_PASSWORD_EMAIL = '/api/resetPassword/sendResetPasswordEmail';
        Endpoints.RESET_PASSWORD_EMAIL = '/api/resetPassword/resetByEmail';
        Endpoints.RESET_PASSWORD_QUESTION = '/api/resetPassword/resetBySecurityQuestion';
        Endpoints.CHECKLIST = '/api/checkList';
        Endpoints.CHECKLIST_COPY = '/api/checkList/copy';
        Endpoints.CHECK = '/api/checkitem';
        Endpoints.CHECK_OVERRIDE = '/api/checkitem/override';
        Endpoints.CHECK_REORDER = '/api/checkitem/reorder';
        Endpoints.CHECKLIST_OVERRIDE = '/api/checklist/override';
        Endpoints.CHECKLIST_INSTANCE = '/api/checkListInstance';
        Endpoints.CHECKLIST_INSTANCE_SIGNOFF = '/api/checkListInstance/signoff';
        Endpoints.CHECKLIST_WELLKNOWN = '/api/checkListInstance/wellKnownCheckList';
        Endpoints.CHECKLIST_WELLKNOWNCREATE = '/api/checkListInstance/WellKnownCheckListCreate';
        Endpoints.CHECKLIST_INSTANCE_UNFINISHED = '/api/checkListInstance/unfinished';
        Endpoints.CHECKLIST_INSTANCE_RECENT = '/api/checkListInstance/recent';
        Endpoints.CHECKLIST_REPORT = '/api/checklist/report';
        Endpoints.CHECKLIST_REPORT_LISTS = '/api/checklist/reportLists';
        Endpoints.CHECKLIST_REPORT_DETAIL = '/api/checklist/report/detail';
        Endpoints.CHECKLIST_REPORT_HOURLY = '/api/checklist/hourlyReport';
        Endpoints.CHECKLIST_LAST_RESULT = '/api/checklist/lastResult';
        Endpoints.CHECKLIST_MANDATORY = '/api/checklist/isMandatory';
        Endpoints.CHECKLIST_RESUBMIT_TONNAGE_CHECKS = '/api/checklist/resubmitUptimeChecks';
        Endpoints.CHECKS_FAILED_FOR_PLANT = '/api/checkListInstance/failed/plant/';
        Endpoints.CHECKS_FAILED_FOR_SHOP = '/api/checkListInstance/failed/shop/';
        Endpoints.WELL_KNOWN_CHECKS_RESULTS = '/api/wellKnownChecks/results';
        Endpoints.HOURLY_CHECKLIST_REPORT = '/api/checklist/hourlyCheckListReport';
        Endpoints.NOTIFICATION_SEND = '/api/notification/send';
        Endpoints.USERS_NOTIFY = '/api/user/notify';
        Endpoints.DELETED_DEFECTS_REPORT = '/api/report/deletedDefects';
        Endpoints.FURNACE_PULL_REPORT_SHOP = '/api/report/furnacePullShop';
        Endpoints.FURNACE_PULL_REPORT_TANK = '/api/report/furnacePullTank';
        Endpoints.FURNACE_PULL_REPORT_ABANDONED_WEIGHTS = '/api/report/furnacePullAbandonedWeights';
        Endpoints.CRITICAL_DEFECTS_REPORT = '/api/report/criticalDefects';
        Endpoints.CRITICAL_DEFECT_REPORT_DETAILS = '/api/report/criticalDefectDetails';
        Endpoints.WARE_HELD_REPORT = '/api/report/wareHeld';
        Endpoints.TANK_METRICS_REPORT = '/api/report/tankMetrics';
        Endpoints.TOP_N_DEFECTS_REPORT = '/api/report/topDefects';
        Endpoints.DEFECT_REPORT_DETAILS = '/api/report/defectDetails';
        Endpoints.MORNING_MINUTES_REPORT = '/api/report/morningMinutes';
        Endpoints.GENERATE_MORNING_MINUTES_REPORT = '/api/report/morningMinutes/generate';
        Endpoints.SHIFT_DETAIL_REPORT = '/api/report/shiftDetail';
        Endpoints.JOB_REPORT = '/api/report/jobRun';
        Endpoints.JOB_REPORT_DETAILS = '/api/report/jobRunDetails';
        Endpoints.DUMPGATETIME_REPORT = '/api/report/dumpgatetime';
        Endpoints.PRODUCTION_REPORT = '/api/report/getProductionReport';
        Endpoints.JOB_REPORT_MOLDS = '/api/report/jobRunMolds';
        Endpoints.TOOL_CHANGE_REPORT = '/api/report/toolChange';
        Endpoints.TOOL_CHANGE_REPORT_DETAILS = '/api/report/toolChangeDetails';
        Endpoints.DOWNTIME_REPORT = '/api/report/downtimes';
        Endpoints.DOWNTIME_REPORT_DETAILS = '/api/report/downtimes/details';
        Endpoints.QUALIFICATIONS_REPORT = '/api/report/qualifications';
        Endpoints.DEFECTS_REPORT = '/api/report/defects';
        Endpoints.DEFECTS_REPORT_ALL = '/api/report/defectsAll';
        Endpoints.DOWNTIME_SHIFT_REPORTV1 = '/api/report/downtimeSectionsV1';
        Endpoints.DOWNTIME_SHIFT_REPORT_INSIGHT_ALL = '/api/report/downtimeInsight_All';
        Endpoints.PALLET_KPIS = '/api/report/palletKpis';
        Endpoints.PLANT_KPI = '/api/report/plantKpi';
        Endpoints.PLANT_HOTENDBONUS = '/api/report/hotEndBonus';
        Endpoints.SIGNOFF_HOTENDBONUS = '/api/report/signOffHotEndBonus';
        Endpoints.GET_HOTENDBONUSSIGNOFF = '/api/report/getHotEndBonusSignOff';
        Endpoints.GOB_WEIGHT_HISTORY_REPORT = '/api/report/gobWeights';
        Endpoints.WEEKLY_KPI_REPORT = "/api/report/weeklyKPIs";
        Endpoints.DELETED_GOB_WEIGHT_REPORT = '/api/gobWeight/deletedGobWeights';
        Endpoints.CHAT = '/api/chat';
        Endpoints.ALERTROLES = '/api/AlertRole';
        Endpoints.LOCATIONS = '/api/location';
        Endpoints.BATCH_SUMMARY = '/api/batch-summary';
        Endpoints.BATCH_SUMMARY_INFO = '/api/batch-summary/bininfo';
        Endpoints.BATCH_FORMULAS = '/api/batch-formulas';
        Endpoints.BATCH_FORMULA_USAGES = '/api/batch-formula-usages';
        Endpoints.BATCH_FORMULA_USAGE_REPORT = '/api/batch-formula-usages/report';
        Endpoints.COMMODITIES = '/api/commodities';
        Endpoints.COMMODITYPERCENTAGES = '/api/commodities/commoditypercentage';
        Endpoints.COMMODITY_BIN = '/api/commodityBin';
        Endpoints.EQUIPMENT = '/api/equipment';
        Endpoints.EQUIPMENT_SHOP = '/api/equipment/shop';
        Endpoints.SCALES = '/api/scales';
        Endpoints.EQUIPMENT_ACTIVATE = '/api/equipment/activate';
        Endpoints.EQUIPMENT_DISABLE = '/api/equipment/disable';
        Endpoints.SCALE_MODE = '/api/equipment/scaleMode';
        Endpoints.DATAPOINTS = '/api/dataPoint';
        Endpoints.DATAPOINTS_VALIDATE = '/api/dataPoint/validate';
        Endpoints.DATAPOINTS_CALCULATE = '/api/dataPoint/calculate';
        Endpoints.GOB_WEIGHT_COMMENT = '/api/gobWeight/comment';
        Endpoints.GOB_WEIGHT_DELETE = '/api/gobWeight/delete';
        Endpoints.LINE_CONFIG = '/api/line';
        Endpoints.LINE_CONFIG_TOGGLE = '/api/line/toggle';
        Endpoints.LINE_CONFIG_EQUIPMENT = '/api/line/equipment';
        Endpoints.LINE_CONFIG_EQUIPMENT_REORDER = '/api/line/equipment/reorder';
        Endpoints.LINE_CONFIG_EQUIPMENT_TOGGLE = '/api/line/equipment/toggle';
        Endpoints.LINE_CONFIG_JUNCTION = '/api/line/junction';
        Endpoints.LINE_CONFIG_EQUIPMENT_NAME = '/api/line/equipment/name';
        Endpoints.LINE_CONFIG_EQUIPMENT_INCONSISTENCIES = '/api/line/equipment/inconsistencies';
        Endpoints.COUNTS = '/api/counts';
        Endpoints.COUNTS_DETAIL = '/api/counts/detail';
        Endpoints.COUNTS_GROUP_DETAIL = '/api/counts/groupDetail';
        Endpoints.COUNTS_GROUP_REJECTS = '/api/counts/groupRejects';
        Endpoints.COUNTS_CAVITY = '/api/counts/cavityDetail';
        Endpoints.SHOP_COUNT_SUMMARY = '/api/counts/shopCountSummary';
        Endpoints.SHOP_COUNT_SUMMARY_DEFECTS = '/api/counts/shopCountSummaryWithDefects';
        Endpoints.CAVITY_EFFICIENCY = '/api/counts/cavityEfficiency';
        Endpoints.CAVITY_CORRELATION = '/api/counts/cavityCorrelation';
        Endpoints.COUNTS_DATA_POINT_HISTORY = "/api/counts/GetByDatapointID";
        Endpoints.CHECK_DETECTOR_DEFECT_MAPPINGS = '/api/equipment/checkDetectorDefectMappings';
        Endpoints.LINE_EQUIPMENT_NAME = '/api/line/equipment/name';
        Endpoints.PALLETIZERS = '/api/equipment/palletizers';
        Endpoints.EQUIPMENT_DIAGNOSTICS = '/api/equipment/diagnostics';
        Endpoints.TIAMA_DEFECT_MAPPINGS = '/api/defect/tiamaMappings';
        Endpoints.MACHINE_DEFECT_MAPPINGS = '/api/machineDefect/machineDefectMappings';
        Endpoints.MACHINE_DEFECT_MAPPINGS_FOR_CLONING = '/api/machineDefect/machineDefectMappingsForCloning';
        Endpoints.MACHINE_DEFECT_QUESTION = '/api/defect/questions';
        Endpoints.TIAMA_DEFECT_MAPPINGS_DETAIL = '/api/defect/tiamaMappings/{0}/detail';
        Endpoints.TIAMA_DEFECT_MAPPINGS_ADD = '/api/defect/tiamaMappings/add';
        Endpoints.UPDATE_PALLETS = '/api/report/ChangeKpiPallets';
        Endpoints.PACK_CHART_INFO = '/api/dashboard/packchartinfo';
        Endpoints.PLANT_WARE_LOSS_DASHBOARD = '/api/dashboard/plantWareLoss';
        Endpoints.PACK_PRODUCTS_INFO = '/api/dashboard/packproductsinfo';
        Endpoints.PLANT_PERFORMANCE_SNAPSHOT = '/api/dashboard/snapshot';
        Endpoints.FURNACE_CHART_INFO = '/api/dashboard/furnacechartinfo';
        Endpoints.LINE_ITEM_HOLDS_DATA = '/api/dashboard/lineitemholds';
        Endpoints.PRODUCTION_SHIFT_REPORT = '/api/report/productionShiftReport';
        Endpoints.PRODUCTION_SHIFT_REPORTV2 = '/api/productionshiftreport/reportData';
        Endpoints.MEASURE_MINILAB = '/api/measure/getMiniLabData';
        Endpoints.MEASURE_WXG = '/api/measure/getWxgData';
        Endpoints.MEASURE_PLANT_ITEMS = '/api/measure/getPlantItems';
        Endpoints.PRODUCTION_SHIFT_REPORT_EXPORT = '/api/report/productionShiftReportExport';
        Endpoints.PRODUCTION_SHIFT_REPORT_EXCELEXPORT = '/api/productionshiftreport/ExcelExport/';
        Endpoints.DASHBOARD_SHOPSUMMARY = '/api/dashboard/shopSummary';
        Endpoints.SHOP_OPERATOR_DASHBOARD = '/api/dashboard/shopOperator';
        Endpoints.PRODUCTION_KPIS_DAILY = '/api/kpis/daily';
        Endpoints.PRODUCTION_KPIS_MONTHLY = '/api/kpis/monthly';
        Endpoints.PRODUCTION_KPIS_LAST_UPDATED_DATES = '/api/kpis/lastupdateddates';
        Endpoints.FLEX_IS_DETAILS = '/api/machineDetail/FlexIsDash';
        Endpoints.COUNTS_DATA_POINT_LIST = "/api/counts/GetByDatapointList";
        Endpoints.DUMPGATETIME_COUNT = '/api/counts/GetDumpGateTimeCount';
        Endpoints.LINE_EQUIPMENT_BY_SHOP = '/api/line/equipment/namebyshop';
        Endpoints.SCORECARD = '/api/checkList/scorecardCheckListReport';
        Endpoints.RELEASE_NOTE_NOTIFICATION_SEND = '/api/notification/updateReleaseNoteNotification';
        Endpoints.GET_RELEASE_NOTE_NOTIFICATION = '/api/notification/getReleaseNoteNotifications';
        return Endpoints;
    }());
    exports.Endpoints = Endpoints;
    var BroadcastMessages = (function () {
        function BroadcastMessages() {
        }
        BroadcastMessages.FILL_OUT_CHECKLIST_CANCELLED = 'FILL_OUT_CHECKLIST_CANCELLED';
        BroadcastMessages.FURNACE_PULL_AUDIT_COMMENT_DELETE_CANCELLED = 'FURNACE_PULL_AUDIT_COMMENT_DELETE_CANCELLED';
        BroadcastMessages.FURNACE_PULL_AUDIT_COMMENT_DELETE_SUBMIT = 'FURNACE_PULL_AUDIT_COMMENT_DELETE_SUBMIT';
        BroadcastMessages.FURNACE_PULL_AUDIT_COMMENT_UPDATE_CANCELLED = 'FURNACE_PULL_AUDIT_COMMENT_UPDATE_CANCELLED';
        BroadcastMessages.FURNACE_PULL_AUDIT_COMMENT_UPDATE_SUBMIT = 'FURNACE_PULL_AUDIT_COMMENT_UPDATE_SUBMIT';
        return BroadcastMessages;
    }());
    exports.BroadcastMessages = BroadcastMessages;
    var UIInputServiceBroadcastMessages = (function () {
        function UIInputServiceBroadcastMessages() {
        }
        return UIInputServiceBroadcastMessages;
    }());
    exports.UIInputServiceBroadcastMessages = UIInputServiceBroadcastMessages;
    var Enums = (function () {
        function Enums() {
        }
        Enums.FURNACE_PULL_VIEW_OPTIONS = [
            { id: 0, name: 'Tonnage by Shop' },
            { id: 1, name: 'Tonnage by Tank' },
            { id: 2, name: 'Audit' },
            { id: 3, name: 'Abandoned Weights' }
        ];
        Enums.FREQUENCY_TYPES = {
            COUNT: { id: 1, name: 'Count' },
            XOVER4: { id: 1, name: 'X/4' },
            XOVER10: { id: 1, name: 'X/10' }
        };
        Enums.SEVERITY = {
            Critical: { id: 0, name: 'Critical' },
            Major: { id: 1, name: 'Major' },
            Minor: { id: 2, name: 'Minor' },
            Event: { id: 3, name: 'Event' }
        };
        Enums.TOOL_CHANGE_REASON = {
            FixDefect: { id: 0, name: 'Fix a Defect' },
            SectionChange: { id: 1, name: 'Section Change' },
            JobChange: { id: 2, name: 'Job Change' },
            Other: { id: 3, name: 'Other' }
        };
        Enums.JOB_CHANGE_TYPE = {
            Full: { id: 1, name: 'Full' },
            Mold: { id: 2, name: 'Mold' },
            Finish: { id: 3, name: 'Finish' }
        };
        Enums.CHECK_STATUS = {
            Failed: { id: 1, name: 'Failed' },
            Passed: { id: 2, name: 'Passed' },
            NotDone: { id: 3, name: 'Not Done' }
        };
        return Enums;
    }());
    exports.Enums = Enums;
    var States = (function () {
        function States() {
        }
        States.SIGN_IN = 'signIn';
        States.RESET_PASSWORD = 'resetPassword';
        States.SELECT_ROLE = 'selectRole';
        States.ABSTRACT = 'aps';
        States.CHECKLIST_REPORT = 'aps.checkListReport';
        States.HOURLY_CHECKLIST_REPORT = 'aps.hourlyCheckListReport';
        States.ADMIN_DASHBOARD = 'aps.adminDashboard';
        States.PLANT_DASHBOARD = 'aps.plantDashboard';
        States.GLOBAL_NOTIFICATIONS = 'aps.globalNotifications';
        States.GLOBAL_NOTIFICATIONS_V2 = 'aps.globalNotificationsV2';
        States.LINE_SHEET = 'aps.lineSheet';
        States.DASHBOARD = 'aps.dashboard';
        States.SHOP_SUMMARY_DASHBOARD = 'aps.shopSummaryDashboard';
        States.PLANT_WARE_LOSS_DASHBOARD = 'aps.plantWareLossDashboard';
        States.SHOP_OPERATOR_DASHBOARD = 'aps.shopOperatorDashboard';
        States.JOB_RUNS = 'aps.jobRuns';
        States.JOB_RUNS_V2 = 'aps.jobRunsV2';
        States.JOBS = 'aps.jobs';
        States.SHOPS = 'aps.shops';
        States.DEFECT_TYPES = 'aps.defectTypes';
        States.ALERTROLES = 'aps.alertroles';
        States.COMMODITIES = 'aps.commodities';
        States.BATCH_SUMMARY = 'aps.batchSummary';
        States.BATCH_SUMMARY_V2 = 'aps.batchSummaryV2';
        States.BATCH_FORMULAS = 'aps.batchFormulas';
        States.BATCH_FORMULA_USAGES = 'aps.batchFormulaUsages';
        States.BATCH_FORMULA_USAGE_REPORT = 'aps.batchFormulaUsageReport';
        States.COMMODITY_BIN = 'aps.commodityBin';
        States.HOLIDAYS = 'aps.holidays';
        States.PLANTS = 'aps.plants';
        States.PLANT_FEATURE_SETTINGS = 'aps.PlantFeatureSettings';
        States.USERS = 'aps.users';
        States.CHECKLISTS = 'aps.checkLists';
        States.CHECKS = 'aps.checks';
        States.DEFECTS_REPORT = 'aps.defectsReport';
        States.DEFECTS_REPORT_V2 = 'aps.defectsReportV2';
        States.DOWNTIME_REPORT_V2 = 'aps.downtimeReportV2';
        States.CRITICAL_DEFECT_REPORT = 'aps.criticalDefectReport';
        States.WARE_HELD_REPORT = 'aps.wareHeldReport';
        States.TANK_METRICS_REPORT = 'aps.tankMetricsReport';
        States.DELETED_DEFECT_REPORT = 'aps.deletedDefectReport';
        States.DELETED_GOB_WEIGHT_REPORT = 'aps.deletedGobWeightReport';
        States.MORNING_MINUTES_REPORT = 'aps.morningMinutesReport';
        States.SHIFT_DETAIL_REPORT = 'aps.shiftDetailReport';
        States.JOB_RUN_REPORT = 'aps.jobRunReport';
        States.PRODUCTION_REPORT = 'aps.productionReport';
        States.TOOL_CHANGE_REPORT = 'aps.toolChangeReport';
        States.TOOLCHANGE_HISTORY_REPORT = 'aps.toolChangeHistoryV2';
        States.HOTENDBONUS_REPORT_V2 = 'aps.hotendbonusreportV2';
        States.TOP_DEFECTS_REPORT = 'aps.topDefectsReport';
        States.DOWNTIME_REPORT = 'aps.downtimeReport';
        States.DUMPGATETIME_REPORT = 'aps.dumpGateTimeReport';
        States.FURNACE_PULL_REPORT = 'aps.furnacePullReport';
        States.CHAT_REPORT = 'aps.chatReport';
        States.QUALIFICATIONS_REPORT = 'aps.qualificationsReport';
        States.SECTION_CHANGES = 'aps.sectionChanges';
        States.EQUIPMENT = 'aps.equipment';
        States.WEEKLY_KPI_REPORT = 'aps.weeklyKPIReport';
        States.COUNTS_HORIZONTAL = 'aps.counts';
        States.COUNTS_HORIZONTAL_V2 = 'aps.countsv2';
        States.COUNTS_VERTICAL = 'aps.countsVertical';
        States.COUNTS_VERTICAL_V2 = 'aps.countsVerticalv2';
        States.COUNTS_CAVITY_CORRELATION = 'aps.countsCavityCorrelation';
        States.COUNTS_CAVITY_EFFICIENCY = 'aps.countsCavityEfficiency';
        States.COUNTS_DATA_POINT_HISTORY = 'aps.dataPointHistory';
        States.FORMULAS = 'aps.formulas';
        States.LINE_CONFIG = 'aps.lineConfig';
        States.SHOP_COUNT_SUMMARY = 'aps.shopCountSummary';
        States.SHOP_COUNT_SUMMARY_V2 = 'aps.shopCountSummaryV2';
        States.CAVITY_EFFICIENCY = 'aps.cavityEfficiency';
        States.CAVITY_CORRELATION = 'aps.cavityCorrelation';
        States.CHECK_DETECTOR_DEFECT_MAPPING = 'aps.checkDetectorDefectMapping';
        States.LINE_EQUIPMENT_NAMES = 'aps.lineEquipmentNames';
        States.REJECT_RATE_REPORT = 'aps.rejectRateReport';
        States.PALLETIZERS = 'aps.palletizers';
        States.PALLETKPI = 'aps.palletKpis';
        States.VIEW_DEFECT_TYPES = 'aps.viewDefectTypes';
        States.VIEW_TIAMA_DEFECT_MAPPINGS = 'aps.tiamaDefectMappings';
        States.VIEW_MACHINE_DEFECT_MAPPINGS = 'aps.machineDefectMappings';
        States.COUNT_SUMMARY = 'aps.countSummary';
        States.PLANT_PERFORMANCE = 'aps.plantPerformance';
        States.PLANT_PERFORMANCE_CHARTS = 'aps.plantPerformanceCharts';
        States.PRODUCTION_SHIFT_REPORT = 'aps.productionShiftReport';
        States.PRODUCTION_SHIFT_REPORTV2 = 'aps.productionShiftReportV2';
        States.DOWNTIME_SHIFT_REPORT = 'aps.downtimeShiftReport';
        States.DOWNTIME_SHIFT_REPORT_INSIGHT = 'aps.downtimeShiftReportInsight';
        States.KPIS = 'aps.kpis';
        States.FLEX_IS_DETAILS = 'aps.flexIsDetails';
        States.MEASURE = 'aps.measure';
        States.SCORECARD = 'aps.scorecard';
        States.SCORECARDV2 = 'aps.scorecardv2';
        States.HOT_END_BONUS = 'aps.hotEndBonusReport';
        return States;
    }());
    exports.States = States;
    var Strings = (function () {
        function Strings() {
        }
        Strings.ISO_FORMAT = 'YYYY-MM-DDTHH:mm';
        Strings.ISO_DATE_FORMAT = 'YYYY-MM-DD';
        Strings.ISO_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm';
        Strings.TIME_FORMAT = 'M/D/YYYY h:mm A';
        Strings.TIME_FORMAT_WITH_SECONDS = 'M/D/YYYY h:mm:ss A';
        Strings.TIME_ONLY_FORMAT = 'h:mm A';
        Strings.DATE_FORMAT = 'M/D/YYYY';
        Strings.DEFAULT_TIMEZONE = 'US/Eastern';
        return Strings;
    }());
    exports.Strings = Strings;
    var Colors = (function () {
        function Colors() {
        }
        Colors.DEFECT_CRITICAL = '#FF0000';
        Colors.DEFECT_MAJOR = '#ee9b02';
        Colors.DEFECT_MINOR = '#008000';
        Colors.DEFECT_EVENT = '#666666';
        Colors.TOOL_CHANGE = '#336699';
        Colors.REJECT_10 = '#C0C0C0';
        Colors.REJECT_09 = '#909090';
        Colors.REJECT_08 = '#606060';
        Colors.REJECT_07 = '#303030';
        Colors.REJECT_06 = '#000000';
        Colors.REJECT_05 = '#330000';
        Colors.REJECT_04 = '#660000';
        Colors.REJECT_03 = '#990000';
        Colors.REJECT_02 = '#CC0000';
        Colors.REJECT_01 = '#FF0000';
        Colors.EFFICIENCY_HIGH = '#409133';
        Colors.EFFICIENCY_MEDIUM = '#E0AF00';
        Colors.EFFICIENCY_LOW = '#FF6600';
        Colors.EFFICIENCY_WARNING = '#CC0000';
        return Colors;
    }());
    exports.Colors = Colors;
    var FurnacePullReportDetailTypes;
    (function (FurnacePullReportDetailTypes) {
        FurnacePullReportDetailTypes[FurnacePullReportDetailTypes["bottlesPerMinute"] = 0] = "bottlesPerMinute";
        FurnacePullReportDetailTypes[FurnacePullReportDetailTypes["tonnageWeight"] = 1] = "tonnageWeight";
    })(FurnacePullReportDetailTypes = exports.FurnacePullReportDetailTypes || (exports.FurnacePullReportDetailTypes = {}));
    var Counts = (function () {
        function Counts() {
        }
        return Counts;
    }());
    exports.Counts = Counts;
    var Intervals = (function () {
        function Intervals() {
        }
        Intervals.HourInSecs = 3600;
        Intervals.IntervalSeconds = (_a = {},
            _a[enums_1.apsDisplayEnums.CountDisplayInterval.CurrentHour] = Intervals.HourInSecs,
            _a[enums_1.apsDisplayEnums.CountDisplayInterval.PreviousHour] = Intervals.HourInSecs,
            _a[enums_1.apsDisplayEnums.CountDisplayInterval.RollingHour] = Intervals.HourInSecs,
            _a[enums_1.apsDisplayEnums.CountDisplayInterval.CurrentShift] = Intervals.HourInSecs * 8,
            _a[enums_1.apsDisplayEnums.CountDisplayInterval.LastShift] = Intervals.HourInSecs * 8,
            _a[enums_1.apsDisplayEnums.CountDisplayInterval.ShiftBeforeLast] = Intervals.HourInSecs * 8,
            _a[enums_1.apsDisplayEnums.CountDisplayInterval.Last24Hours] = Intervals.HourInSecs * 24,
            _a[enums_1.apsDisplayEnums.CountDisplayInterval.LastTwentyMinutes] = Intervals.HourInSecs / 3,
            _a);
        return Intervals;
    }());
    exports.Intervals = Intervals;
    var _a;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.services.loader', [])
        .service('loaderService', loaderService)
        .name;
    function loaderService() {
        'use strict';
        var _appLoading = false;
        function appLoading() {
            return _appLoading;
        }
        function setAppLoading(newValue) {
            _appLoading = newValue;
        }
        function loadingPromise(promise) {
            if (promise && angular.isFunction(promise.finally)) {
                setAppLoading(true);
                promise.finally(function () {
                    setAppLoading(false);
                });
            }
        }
        return {
            appLoading: appLoading,
            setAppLoading: setAppLoading,
            loadingPromise: loadingPromise
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// AUTO-GENERATED CODE. DO NOT MODIFY!

var apsEnums;
(function (apsEnums) {
    var FrequencyType;
    (function (FrequencyType) {
        FrequencyType[FrequencyType["None"] = 0] = "None";
        FrequencyType[FrequencyType["Count"] = 1] = "Count";
        FrequencyType[FrequencyType["Percentage"] = 2] = "Percentage";
        FrequencyType[FrequencyType["PSI"] = 3] = "PSI";
        FrequencyType[FrequencyType["ThermalShock"] = 4] = "ThermalShock";
    })(FrequencyType = apsEnums.FrequencyType || (apsEnums.FrequencyType = {}));
    var Severity;
    (function (Severity) {
        Severity[Severity["Critical"] = 0] = "Critical";
        Severity[Severity["Major"] = 1] = "Major";
        Severity[Severity["Minor"] = 2] = "Minor";
        Severity[Severity["Event"] = 3] = "Event";
    })(Severity = apsEnums.Severity || (apsEnums.Severity = {}));
    var ToolChangeReason;
    (function (ToolChangeReason) {
        ToolChangeReason[ToolChangeReason["FixDefect"] = 0] = "FixDefect";
        ToolChangeReason[ToolChangeReason["SectionChange"] = 1] = "SectionChange";
        ToolChangeReason[ToolChangeReason["JobChange"] = 2] = "JobChange";
        ToolChangeReason[ToolChangeReason["Other"] = 3] = "Other";
        ToolChangeReason[ToolChangeReason["Dirty"] = 4] = "Dirty";
        ToolChangeReason[ToolChangeReason["Broken"] = 5] = "Broken";
        ToolChangeReason[ToolChangeReason["Worn"] = 6] = "Worn";
        ToolChangeReason[ToolChangeReason["Burned"] = 7] = "Burned";
        ToolChangeReason[ToolChangeReason["WrongNumber"] = 8] = "WrongNumber";
        ToolChangeReason[ToolChangeReason["NewEquipment"] = 9] = "NewEquipment";
        ToolChangeReason[ToolChangeReason["Sticky"] = 10] = "Sticky";
        ToolChangeReason[ToolChangeReason["Plugged"] = 11] = "Plugged";
        ToolChangeReason[ToolChangeReason["MoldSwap"] = 12] = "MoldSwap";
    })(ToolChangeReason = apsEnums.ToolChangeReason || (apsEnums.ToolChangeReason = {}));
    var ToolType;
    (function (ToolType) {
        ToolType[ToolType["Mold"] = 0] = "Mold";
        ToolType[ToolType["Variable"] = 1] = "Variable";
        ToolType[ToolType["Machine"] = 2] = "Machine";
    })(ToolType = apsEnums.ToolType || (apsEnums.ToolType = {}));
    var NotificationType;
    (function (NotificationType) {
        NotificationType[NotificationType["Unknown"] = 0] = "Unknown";
        NotificationType[NotificationType["Requalification"] = 1] = "Requalification";
        NotificationType[NotificationType["CheckList"] = 2] = "CheckList";
        NotificationType[NotificationType["CheckListSignOff"] = 3] = "CheckListSignOff";
        NotificationType[NotificationType["General"] = 4] = "General";
        NotificationType[NotificationType["CriticalDefect"] = 5] = "CriticalDefect";
        NotificationType[NotificationType["SectionChange"] = 6] = "SectionChange";
        NotificationType[NotificationType["CheckListEdited"] = 7] = "CheckListEdited";
        NotificationType[NotificationType["WeightAlarm"] = 8] = "WeightAlarm";
        NotificationType[NotificationType["EquipmentHealthNotification"] = 9] = "EquipmentHealthNotification";
    })(NotificationType = apsEnums.NotificationType || (apsEnums.NotificationType = {}));
    var NotificationStatus;
    (function (NotificationStatus) {
        NotificationStatus[NotificationStatus["Pending"] = 0] = "Pending";
        NotificationStatus[NotificationStatus["Sent"] = 1] = "Sent";
        NotificationStatus[NotificationStatus["Read"] = 2] = "Read";
        NotificationStatus[NotificationStatus["Done"] = 3] = "Done";
        NotificationStatus[NotificationStatus["Removed"] = 4] = "Removed";
    })(NotificationStatus = apsEnums.NotificationStatus || (apsEnums.NotificationStatus = {}));
    var QualificationStatus;
    (function (QualificationStatus) {
        QualificationStatus[QualificationStatus["NotQualified"] = 0] = "NotQualified";
        QualificationStatus[QualificationStatus["Qualified"] = 1] = "Qualified";
    })(QualificationStatus = apsEnums.QualificationStatus || (apsEnums.QualificationStatus = {}));
    var Location;
    (function (Location) {
        Location[Location["None"] = 0] = "None";
        Location[Location["HotEnd"] = 1] = "HotEnd";
        Location[Location["ColdEnd"] = 2] = "ColdEnd";
    })(Location = apsEnums.Location || (apsEnums.Location = {}));
    var LocationType;
    (function (LocationType) {
        LocationType[LocationType["Plant"] = 1] = "Plant";
        LocationType[LocationType["Tank"] = 2] = "Tank";
        LocationType[LocationType["Shop"] = 3] = "Shop";
        LocationType[LocationType["Other"] = 4] = "Other";
    })(LocationType = apsEnums.LocationType || (apsEnums.LocationType = {}));
    var JobChangeType;
    (function (JobChangeType) {
        JobChangeType[JobChangeType["Unknown"] = 0] = "Unknown";
        JobChangeType[JobChangeType["Full"] = 1] = "Full";
        JobChangeType[JobChangeType["Mold"] = 2] = "Mold";
        JobChangeType[JobChangeType["Finish"] = 3] = "Finish";
    })(JobChangeType = apsEnums.JobChangeType || (apsEnums.JobChangeType = {}));
    var TimeUnits;
    (function (TimeUnits) {
        TimeUnits[TimeUnits["Minutes"] = 1] = "Minutes";
        TimeUnits[TimeUnits["Shift"] = 2] = "Shift";
        TimeUnits[TimeUnits["Hours"] = 3] = "Hours";
        TimeUnits[TimeUnits["Days"] = 4] = "Days";
        TimeUnits[TimeUnits["Weeks"] = 5] = "Weeks";
        TimeUnits[TimeUnits["Months"] = 6] = "Months";
    })(TimeUnits = apsEnums.TimeUnits || (apsEnums.TimeUnits = {}));
    var CheckListStatus;
    (function (CheckListStatus) {
        CheckListStatus[CheckListStatus["Pending"] = 0] = "Pending";
        CheckListStatus[CheckListStatus["Scheduled"] = 1] = "Scheduled";
        CheckListStatus[CheckListStatus["Partial"] = 2] = "Partial";
        CheckListStatus[CheckListStatus["Complete"] = 3] = "Complete";
        CheckListStatus[CheckListStatus["NotDone"] = 4] = "NotDone";
        CheckListStatus[CheckListStatus["Expired"] = 5] = "Expired";
    })(CheckListStatus = apsEnums.CheckListStatus || (apsEnums.CheckListStatus = {}));
    var CheckListResult;
    (function (CheckListResult) {
        CheckListResult[CheckListResult["Incomplete"] = 0] = "Incomplete";
        CheckListResult[CheckListResult["Pass"] = 1] = "Pass";
        CheckListResult[CheckListResult["Fail"] = 2] = "Fail";
    })(CheckListResult = apsEnums.CheckListResult || (apsEnums.CheckListResult = {}));
    var CheckListView;
    (function (CheckListView) {
        CheckListView[CheckListView["Scheduled"] = 1] = "Scheduled";
        CheckListView[CheckListView["Unscheduled"] = 2] = "Unscheduled";
        CheckListView[CheckListView["All"] = 3] = "All";
        CheckListView[CheckListView["Blocking"] = 4] = "Blocking";
    })(CheckListView = apsEnums.CheckListView || (apsEnums.CheckListView = {}));
    var CheckAdditionalData;
    (function (CheckAdditionalData) {
        CheckAdditionalData[CheckAdditionalData["None"] = 0] = "None";
        CheckAdditionalData[CheckAdditionalData["LineSelection"] = 1] = "LineSelection";
    })(CheckAdditionalData = apsEnums.CheckAdditionalData || (apsEnums.CheckAdditionalData = {}));
    var CheckListLevel;
    (function (CheckListLevel) {
        CheckListLevel[CheckListLevel["All"] = 1] = "All";
        CheckListLevel[CheckListLevel["Corporate"] = 2] = "Corporate";
        CheckListLevel[CheckListLevel["Plant"] = 3] = "Plant";
        CheckListLevel[CheckListLevel["Shop"] = 4] = "Shop";
    })(CheckListLevel = apsEnums.CheckListLevel || (apsEnums.CheckListLevel = {}));
    var CheckStatus;
    (function (CheckStatus) {
        CheckStatus[CheckStatus["Failed"] = 1] = "Failed";
        CheckStatus[CheckStatus["Passed"] = 2] = "Passed";
        CheckStatus[CheckStatus["NotDone"] = 3] = "NotDone";
        CheckStatus[CheckStatus["NotApplicable"] = 4] = "NotApplicable";
    })(CheckStatus = apsEnums.CheckStatus || (apsEnums.CheckStatus = {}));
    var CheckDataType;
    (function (CheckDataType) {
        CheckDataType[CheckDataType["Text"] = 1] = "Text";
        CheckDataType[CheckDataType["Integer"] = 2] = "Integer";
        CheckDataType[CheckDataType["Decimal"] = 3] = "Decimal";
        CheckDataType[CheckDataType["Boolean"] = 4] = "Boolean";
        CheckDataType[CheckDataType["DateTime"] = 5] = "DateTime";
        CheckDataType[CheckDataType["Percent"] = 6] = "Percent";
        CheckDataType[CheckDataType["Count"] = 7] = "Count";
        CheckDataType[CheckDataType["Instructions"] = 8] = "Instructions";
        CheckDataType[CheckDataType["DefectType"] = 9] = "DefectType";
    })(CheckDataType = apsEnums.CheckDataType || (apsEnums.CheckDataType = {}));
    var CheckEntry;
    (function (CheckEntry) {
        CheckEntry[CheckEntry["PerShop"] = 1] = "PerShop";
        CheckEntry[CheckEntry["PerMachine"] = 2] = "PerMachine";
        CheckEntry[CheckEntry["PerSection"] = 3] = "PerSection";
        CheckEntry[CheckEntry["PerCavity"] = 4] = "PerCavity";
        CheckEntry[CheckEntry["PerDrop"] = 5] = "PerDrop";
    })(CheckEntry = apsEnums.CheckEntry || (apsEnums.CheckEntry = {}));
    var CheckValueType;
    (function (CheckValueType) {
        CheckValueType[CheckValueType["Single"] = 1] = "Single";
        CheckValueType[CheckValueType["Sample"] = 2] = "Sample";
        CheckValueType[CheckValueType["Multiple"] = 3] = "Multiple";
        CheckValueType[CheckValueType["MultipleSample"] = 4] = "MultipleSample";
        CheckValueType[CheckValueType["Aggregate"] = 5] = "Aggregate";
        CheckValueType[CheckValueType["Range"] = 6] = "Range";
    })(CheckValueType = apsEnums.CheckValueType || (apsEnums.CheckValueType = {}));
    var GlobalNotificationType;
    (function (GlobalNotificationType) {
        GlobalNotificationType[GlobalNotificationType["EntireCompany"] = 1] = "EntireCompany";
        GlobalNotificationType[GlobalNotificationType["EntirePlant"] = 2] = "EntirePlant";
        GlobalNotificationType[GlobalNotificationType["EntireShop"] = 3] = "EntireShop";
        GlobalNotificationType[GlobalNotificationType["Individuals"] = 4] = "Individuals";
        GlobalNotificationType[GlobalNotificationType["ReleaseNotes"] = 5] = "ReleaseNotes";
    })(GlobalNotificationType = apsEnums.GlobalNotificationType || (apsEnums.GlobalNotificationType = {}));
    var Shift;
    (function (Shift) {
        Shift[Shift["First"] = 1] = "First";
        Shift[Shift["Second"] = 2] = "Second";
        Shift[Shift["Third"] = 4] = "Third";
    })(Shift = apsEnums.Shift || (apsEnums.Shift = {}));
    var SectionChangeStatus;
    (function (SectionChangeStatus) {
        SectionChangeStatus[SectionChangeStatus["Scheduled"] = 1] = "Scheduled";
        SectionChangeStatus[SectionChangeStatus["Completed"] = 2] = "Completed";
        SectionChangeStatus[SectionChangeStatus["JobEnded"] = 3] = "JobEnded";
        SectionChangeStatus[SectionChangeStatus["Skipped"] = 4] = "Skipped";
    })(SectionChangeStatus = apsEnums.SectionChangeStatus || (apsEnums.SectionChangeStatus = {}));
    var SectionChangeSections;
    (function (SectionChangeSections) {
        SectionChangeSections[SectionChangeSections["Number"] = 1] = "Number";
        SectionChangeSections[SectionChangeSections["Half"] = 2] = "Half";
        SectionChangeSections[SectionChangeSections["All"] = 3] = "All";
    })(SectionChangeSections = apsEnums.SectionChangeSections || (apsEnums.SectionChangeSections = {}));
    var SectionChangeOrder;
    (function (SectionChangeOrder) {
        SectionChangeOrder[SectionChangeOrder["Sequential"] = 1] = "Sequential";
        SectionChangeOrder[SectionChangeOrder["AlternateByHalf"] = 2] = "AlternateByHalf";
    })(SectionChangeOrder = apsEnums.SectionChangeOrder || (apsEnums.SectionChangeOrder = {}));
    var RoleFlags;
    (function (RoleFlags) {
        RoleFlags[RoleFlags["Admin"] = 1] = "Admin";
        RoleFlags[RoleFlags["QC"] = 2] = "QC";
        RoleFlags[RoleFlags["ShiftSupervisor"] = 4] = "ShiftSupervisor";
        RoleFlags[RoleFlags["Operator"] = 8] = "Operator";
        RoleFlags[RoleFlags["MorningMinutes"] = 16] = "MorningMinutes";
        RoleFlags[RoleFlags["SectionChanges"] = 32] = "SectionChanges";
        RoleFlags[RoleFlags["ReceiveNotifications"] = 64] = "ReceiveNotifications";
        RoleFlags[RoleFlags["ColdEndInspector"] = 72] = "ColdEndInspector",
        RoleFlags[RoleFlags["APSIOAdmin"] = 128] = "APSIOAdmin";
        RoleFlags[RoleFlags["EightHourSummary"] = 256] = "EightHourSummary";
        RoleFlags[RoleFlags["ScaleMode"] = 512] = "ScaleMode";
    })(RoleFlags = apsEnums.RoleFlags || (apsEnums.RoleFlags = {}));
    var UnqualificationScope;
    (function (UnqualificationScope) {
        UnqualificationScope[UnqualificationScope["None"] = 0] = "None";
        UnqualificationScope[UnqualificationScope["Cavity"] = 1] = "Cavity";
        UnqualificationScope[UnqualificationScope["Drop"] = 2] = "Drop";
        UnqualificationScope[UnqualificationScope["Section"] = 3] = "Section";
        UnqualificationScope[UnqualificationScope["Machine"] = 4] = "Machine";
    })(UnqualificationScope = apsEnums.UnqualificationScope || (apsEnums.UnqualificationScope = {}));
    var WellKnownCheckType;
    (function (WellKnownCheckType) {
        WellKnownCheckType[WellKnownCheckType["HotEndEfficiency"] = 1] = "HotEndEfficiency";
        WellKnownCheckType[WellKnownCheckType["ShopPackEfficiency"] = 2] = "ShopPackEfficiency";
        WellKnownCheckType[WellKnownCheckType["Weight"] = 3] = "Weight";
        WellKnownCheckType[WellKnownCheckType["ColdEndPackEfficiency"] = 4] = "ColdEndPackEfficiency";
        WellKnownCheckType[WellKnownCheckType["GobsProduced"] = 5] = "GobsProduced";
        WellKnownCheckType[WellKnownCheckType["LehrInput"] = 6] = "LehrInput";
        WellKnownCheckType[WellKnownCheckType["PackedCount"] = 7] = "PackedCount";
        WellKnownCheckType[WellKnownCheckType["LehrOutput"] = 32] = "LehrOutputFirstInspectionDatapoint";
        WellKnownCheckType[WellKnownCheckType["ColdEndInspectionLoss"] = 33] = "ColdEndInspectionLoss";
        WellKnownCheckType[WellKnownCheckType["ColdEndTotalLoss"] = 34] = "ColdEndTotalLoss";
        WellKnownCheckType[WellKnownCheckType["LehrOutputTotal"] = 35] = "LehrOutputTotal";
        WellKnownCheckType[WellKnownCheckType["HeReject"] = 36] = "HeReject";
    })(WellKnownCheckType = apsEnums.WellKnownCheckType || (apsEnums.WellKnownCheckType = {}));
    var WellKnownCheckList;
    (function (WellKnownCheckList) {
        WellKnownCheckList[WellKnownCheckList["CriticalDefectReport"] = 1] = "CriticalDefectReport";
        WellKnownCheckList[WellKnownCheckList["WareHeldReport"] = 2] = "WareHeldReport";
        WellKnownCheckList[WellKnownCheckList["TankMetrics"] = 3] = "TankMetrics";
        WellKnownCheckList[WellKnownCheckList["PlantMetrics"] = 4] = "PlantMetrics";
        WellKnownCheckList[WellKnownCheckList["HourlyDowntime"] = 5] = "HourlyDowntime";
    })(WellKnownCheckList = apsEnums.WellKnownCheckList || (apsEnums.WellKnownCheckList = {}));
    var AggregateFunction;
    (function (AggregateFunction) {
        AggregateFunction[AggregateFunction["Average"] = 1] = "Average";
        AggregateFunction[AggregateFunction["Sum"] = 2] = "Sum";
        AggregateFunction[AggregateFunction["Min"] = 3] = "Min";
        AggregateFunction[AggregateFunction["Max"] = 4] = "Max";
        AggregateFunction[AggregateFunction["Cumulation"] = 5] = "Cumulation";
    })(AggregateFunction = apsEnums.AggregateFunction || (apsEnums.AggregateFunction = {}));
    var ChatItemType;
    (function (ChatItemType) {
        ChatItemType[ChatItemType["Chat"] = 1] = "Chat";
        ChatItemType[ChatItemType["Defect"] = 2] = "Defect";
        ChatItemType[ChatItemType["ToolChange"] = 3] = "ToolChange";
        ChatItemType[ChatItemType["Downtime"] = 4] = "Downtime";
    })(ChatItemType = apsEnums.ChatItemType || (apsEnums.ChatItemType = {}));
    var CheckMetaData;
    (function (CheckMetaData) {
        CheckMetaData[CheckMetaData["DefectType"] = 1] = "DefectType";
        CheckMetaData[CheckMetaData["Location"] = 2] = "Location";
        CheckMetaData[CheckMetaData["WhereFound"] = 3] = "WhereFound";
        CheckMetaData[CheckMetaData["JobItem"] = 4] = "JobItem";
        CheckMetaData[CheckMetaData["MoldNumber"] = 5] = "MoldNumber";
        CheckMetaData[CheckMetaData["Section"] = 6] = "Section";
        CheckMetaData[CheckMetaData["TimeFound"] = 7] = "TimeFound";
        CheckMetaData[CheckMetaData["Shop"] = 8] = "Shop";
        CheckMetaData[CheckMetaData["CreatedBy"] = 9] = "CreatedBy";
        CheckMetaData[CheckMetaData["TimeCorrected"] = 10] = "TimeCorrected";
        CheckMetaData[CheckMetaData["RootCause"] = 11] = "RootCause";
        CheckMetaData[CheckMetaData["Fix"] = 12] = "Fix";
        CheckMetaData[CheckMetaData["ShiftLetter"] = 13] = "ShiftLetter";
        CheckMetaData[CheckMetaData["TankMetricsPull"] = 14] = "TankMetricsPull";
        CheckMetaData[CheckMetaData["TankMetricsCullet"] = 15] = "TankMetricsCullet";
        CheckMetaData[CheckMetaData["TankMetricsGas"] = 16] = "TankMetricsGas";
        CheckMetaData[CheckMetaData["TankMetricsAir"] = 17] = "TankMetricsAir";
        CheckMetaData[CheckMetaData["TankMetricsBoost"] = 18] = "TankMetricsBoost";
        CheckMetaData[CheckMetaData["TankMetricsBWOPT"] = 19] = "TankMetricsBWOPT";
        CheckMetaData[CheckMetaData["TankMetricsBottom3"] = 20] = "TankMetricsBottom3";
        CheckMetaData[CheckMetaData["TankMetricsThroat"] = 21] = "TankMetricsThroat";
        CheckMetaData[CheckMetaData["TankMetricsSeeds"] = 22] = "TankMetricsSeeds";
        CheckMetaData[CheckMetaData["TankMetricsGasEnergy"] = 23] = "TankMetricsGasEnergy";
        CheckMetaData[CheckMetaData["TankMetricsElectricEnergy"] = 24] = "TankMetricsElectricEnergy";
        CheckMetaData[CheckMetaData["TankMetricsNOx"] = 25] = "TankMetricsNOx";
        CheckMetaData[CheckMetaData["TankMetricsSOx"] = 26] = "TankMetricsSOx";
        CheckMetaData[CheckMetaData["TankMetricsGlassDensity"] = 27] = "TankMetricsGlassDensity";
        CheckMetaData[CheckMetaData["TankMetricsCord"] = 28] = "TankMetricsCord";
        CheckMetaData[CheckMetaData["TankMetricsTransmissionAmber"] = 29] = "TankMetricsTransmissionAmber";
        CheckMetaData[CheckMetaData["TankMetricsColorFlint"] = 30] = "TankMetricsColorFlint";
        CheckMetaData[CheckMetaData["TankMetricsPressure"] = 31] = "TankMetricsPressure";
        CheckMetaData[CheckMetaData["TankMetricsBatchLine"] = 32] = "TankMetricsBatchLine";
        CheckMetaData[CheckMetaData["TankMetricsBatchMoisture"] = 33] = "TankMetricsBatchMoisture";        
    })(CheckMetaData = apsEnums.CheckMetaData || (apsEnums.CheckMetaData = {}));
    var DowntimeType;
    (function (DowntimeType) {
        DowntimeType[DowntimeType["All"] = 0] = "All";
        DowntimeType[DowntimeType["Preventative"] = 1] = "Preventative";
        DowntimeType[DowntimeType["Corrective"] = 2] = "Corrective";
    })(DowntimeType = apsEnums.DowntimeType || (apsEnums.DowntimeType = {}));
    var DowntimeLocation;
    (function (DowntimeLocation) {
        DowntimeLocation[DowntimeLocation["All"] = 0] = "All";
        DowntimeLocation[DowntimeLocation["Machine"] = 1] = "Machine";
        DowntimeLocation[DowntimeLocation["Section"] = 2] = "Section";
    })(DowntimeLocation = apsEnums.DowntimeLocation || (apsEnums.DowntimeLocation = {}));
    var DowntimeOrder;
    (function (DowntimeOrder) {
        DowntimeOrder[DowntimeOrder["Time"] = 1] = "Time";
        DowntimeOrder[DowntimeOrder["Type"] = 2] = "Type";
        DowntimeOrder[DowntimeOrder["Duration"] = 3] = "Duration";
        DowntimeOrder[DowntimeOrder["Reason"] = 4] = "Reason";
        DowntimeOrder[DowntimeOrder["Comment"] = 5] = "Comment";
        DowntimeOrder[DowntimeOrder["Tool"] = 6] = "Tool";
        DowntimeOrder[DowntimeOrder["Machine"] = 7] = "Machine";
        DowntimeOrder[DowntimeOrder["Location"] = 8] = "Location";
    })(DowntimeOrder = apsEnums.DowntimeOrder || (apsEnums.DowntimeOrder = {}));
    var TopDefectsFilter;
    (function (TopDefectsFilter) {
        TopDefectsFilter[TopDefectsFilter["Top10Defects"] = 1] = "Top10Defects";
        TopDefectsFilter[TopDefectsFilter["CriticalDefects"] = 2] = "CriticalDefects";
        TopDefectsFilter[TopDefectsFilter["AllDefects"] = 3] = "AllDefects";
    })(TopDefectsFilter = apsEnums.TopDefectsFilter || (apsEnums.TopDefectsFilter = {}));
    var CheckListReportFilter;
    (function (CheckListReportFilter) {
        CheckListReportFilter[CheckListReportFilter["AllCheckLists"] = 1] = "AllCheckLists";
        CheckListReportFilter[CheckListReportFilter["FailedOnly"] = 2] = "FailedOnly";
        CheckListReportFilter[CheckListReportFilter["WithComments"] = 3] = "WithComments";
    })(CheckListReportFilter = apsEnums.CheckListReportFilter || (apsEnums.CheckListReportFilter = {}));
    var EventAction;
    (function (EventAction) {
        EventAction[EventAction["Add"] = 1] = "Add";
        EventAction[EventAction["Update"] = 2] = "Update";
        EventAction[EventAction["Delete"] = 3] = "Delete";
    })(EventAction = apsEnums.EventAction || (apsEnums.EventAction = {}));
    var DefectOrder;
    (function (DefectOrder) {
        DefectOrder[DefectOrder["Time"] = 1] = "Time";
        DefectOrder[DefectOrder["Severity"] = 2] = "Severity";
        DefectOrder[DefectOrder["Location"] = 3] = "Location";
        DefectOrder[DefectOrder["Mold"] = 4] = "Mold";
        DefectOrder[DefectOrder["WhereFound"] = 5] = "WhereFound";
        DefectOrder[DefectOrder["PlantAndShop"] = 6] = "PlantAndShop";
    })(DefectOrder = apsEnums.DefectOrder || (apsEnums.DefectOrder = {}));
    var EquipmentType;
    (function (EquipmentType) {
        EquipmentType[EquipmentType["Scale"] = 1] = "Scale";
        EquipmentType[EquipmentType["PLC"] = 2] = "PLC";
        EquipmentType[EquipmentType["WSI"] = 3] = "WSI";
        EquipmentType[EquipmentType["WBF"] = 4] = "WBF";
        EquipmentType[EquipmentType["HEYE"] = 5] = "HEYE";
        EquipmentType[EquipmentType["SerialConverter"] = 6] = "SerialConverter";
        EquipmentType[EquipmentType["AIServer"] = 7] = "AIServer";
        EquipmentType[EquipmentType["CheckDetector"] = 8] = "CheckDetector";
        EquipmentType[EquipmentType["RaspberryPi"] = 9] = "RaspberryPi";
        EquipmentType[EquipmentType["MX4"] = 10] = "MX4";
        EquipmentType[EquipmentType["Multi"] = 11] = "Multi";
        EquipmentType[EquipmentType["Mcal"] = 12] = "Mcal";
        EquipmentType[EquipmentType["FlexBC"] = 13] = "FlexBC";
        EquipmentType[EquipmentType["FlexM"] = 14] = "FlexM";
        EquipmentType[EquipmentType["FlexIS"] = 15] = "FlexIS";
        EquipmentType[EquipmentType["LineServer"] = 16] = "LineServer";
        EquipmentType[EquipmentType["KepC"] = 17] = "KepC";
        EquipmentType[EquipmentType["SqlC"] = 18] = "SqlC";
        EquipmentType[EquipmentType["PPCScale"] = 19] = "PPCScale";
        EquipmentType[EquipmentType["SqlM"] = 20] = "SqlM";
        EquipmentType[EquipmentType["WSG"] = 21] = "WSG";
        EquipmentType[EquipmentType["WFG"] = 22] = "WFG";
        EquipmentType[EquipmentType["CBIT"] = 23] = "CBIT";
        EquipmentType[EquipmentType["Cyclops"] = 24] = "Cyclops";
    })(EquipmentType = apsEnums.EquipmentType || (apsEnums.EquipmentType = {}));
    var LineEquipmentType;
    (function (LineEquipmentType) {
        LineEquipmentType[LineEquipmentType["InspectReject"] = 1] = "InspectReject";
        LineEquipmentType[LineEquipmentType["WSI"] = 2] = "WSI";
        LineEquipmentType[LineEquipmentType["Counter"] = 3] = "Counter";
        LineEquipmentType[LineEquipmentType["WBF"] = 4] = "WBF";
        LineEquipmentType[LineEquipmentType["HEYE"] = 5] = "HEYE";
        LineEquipmentType[LineEquipmentType["CheckDetector"] = 6] = "CheckDetector";
        LineEquipmentType[LineEquipmentType["Palletizer"] = 7] = "Palletizer";
        LineEquipmentType[LineEquipmentType["MX4"] = 8] = "MX4";
        LineEquipmentType[LineEquipmentType["Multi"] = 9] = "Multi";
        LineEquipmentType[LineEquipmentType["Mcal"] = 10] = "Mcal";
        LineEquipmentType[LineEquipmentType["FlexBC"] = 11] = "FlexBC";   
        LineEquipmentType[LineEquipmentType["FlexM"] = 12] = "FlexM";           
        LineEquipmentType[LineEquipmentType["FlexIS"] = 13] = "FlexIS";    
    })(LineEquipmentType = apsEnums.LineEquipmentType || (apsEnums.LineEquipmentType = {}));
    var ScaleMode;
    (function (ScaleMode) {
        ScaleMode[ScaleMode["Prompted"] = 1] = "Prompted";
        ScaleMode[ScaleMode["Manual"] = 2] = "Manual";
    })(ScaleMode = apsEnums.ScaleMode || (apsEnums.ScaleMode = {}));
    var ScaleDisplay;
    (function (ScaleDisplay) {
        ScaleDisplay[ScaleDisplay["DifferenceFromTarget"] = 0] = "DifferenceFromTarget";
        ScaleDisplay[ScaleDisplay["ActualWeight"] = 1] = "ActualWeight";
    })(ScaleDisplay = apsEnums.ScaleDisplay || (apsEnums.ScaleDisplay = {}));
    var DataPointType;
    var SensorType;
    (function (SensorType) {
        SensorType[SensorType["PlcCounter"] = 1] = "PlcCounter";
        SensorType[SensorType["Monitoring"] = 2] = "Monitoring";
        SensorType[SensorType["Alarm"] = 3] = "Alarm";
        SensorType[SensorType["MachineSpeed"] = 4] = "MachineSpeed";
    })(SensorType = apsEnums.SensorType || (apsEnums.SensorType = {}));
    (function (DataPointType) {
        DataPointType[DataPointType["Inspect"] = 1] = "Inspect";
        DataPointType[DataPointType["Reject"] = 2] = "Reject";
        DataPointType[DataPointType["Alarm"] = 3] = "Alarm";
        DataPointType[DataPointType["NonInspect"] = 4] = "NonInspect";
        DataPointType[DataPointType["Monitoring"] = 5] = "Monitoring";
    })(DataPointType = apsEnums.DataPointType || (apsEnums.DataPointType = {}));
    var DataPointConfigType;
    (function (DataPointConfigType) {
        DataPointConfigType[DataPointConfigType["PlcCounter"] = 1] = "PlcCounter";
        DataPointConfigType[DataPointConfigType["Formula"] = 2] = "Formula";
        DataPointConfigType[DataPointConfigType["WsiCounter"] = 3] = "WsiCounter";
        DataPointConfigType[DataPointConfigType["HEYECounter"] = 4] = "HEYECounter";
        DataPointConfigType[DataPointConfigType["CheckDetectorCounter"] = 5] = "CheckDetectorCounter";
        DataPointConfigType[DataPointConfigType["RaspberryPiCounter"] = 6] = "RaspberryPiCounter";
        DataPointConfigType[DataPointConfigType["MX4Counter"] = 7] = "MX4Counter";
        DataPointConfigType[DataPointConfigType["MultiCounter"] = 8] = "MultiCounter";
        DataPointConfigType[DataPointConfigType["McalCounter"] = 9] = "McalCounter";
        DataPointConfigType[DataPointConfigType["FlexBCCounter"] = 10] = "FlexBCCounter";     
        DataPointConfigType[DataPointConfigType["FlexMCounter"] = 11] = "FlexMCounter";           
        DataPointConfigType[DataPointConfigType["FlexISCounter"] = 12] = "FlexISCounter";   
        DataPointConfigType[DataPointConfigType["CounterSimple"] = 13] = "CounterSimple";   
        DataPointConfigType[DataPointConfigType["PPCScale"] = 14] = "PPCScale";
        DataPointConfigType[DataPointConfigType["CBITCounter"] = 15] = "CBITCounter";   
        DataPointConfigType[DataPointConfigType["CyclopsCounter"] =  16] = "CyclopsCounter";
    })(DataPointConfigType = apsEnums.DataPointConfigType || (apsEnums.DataPointConfigType = {}));
    var VariableType;
    (function (VariableType) {
        VariableType[VariableType["DataPoint"] = 1] = "DataPoint";
        VariableType[VariableType["NumberOfGobs"] = 2] = "NumberOfGobs";
        VariableType[VariableType["NumberOfMachines"] = 3] = "NumberOfMachines";
        VariableType[VariableType["ContainerSpeed"] = 4] = "ContainerSpeed";
        VariableType[VariableType["ContainersPerCase"] = 5] = "ContainersPerCase";
        VariableType[VariableType["CasesPerCycle"] = 6] = "CasesPerCycle";
        VariableType[VariableType["ContainersPerTier"] = 7] = "ContainersPerTier";
        VariableType[VariableType["TiersPerPallet"] = 8] = "TiersPerPallet";
    })(VariableType = apsEnums.VariableType || (apsEnums.VariableType = {}));
    var WXILogEventType;
    (function (WXILogEventType) {
        WXILogEventType[WXILogEventType["Message"] = 1] = "Message";
        WXILogEventType[WXILogEventType["ConsecutiveRejects"] = 2] = "ConsecutiveRejects";
        WXILogEventType[WXILogEventType["ExcessiveRejects"] = 4] = "ExcessiveRejects";
        WXILogEventType[WXILogEventType["LightControlStandard"] = 8] = "LightControlStandard";
        WXILogEventType[WXILogEventType["LightControlStress"] = 16] = "LightControlStress";
        WXILogEventType[WXILogEventType["MissingAcquisition"] = 32] = "MissingAcquisition";
        WXILogEventType[WXILogEventType["MissingRejectSensorStandard"] = 64] = "MissingRejectSensorStandard";
        WXILogEventType[WXILogEventType["MissingRejectSensorMode"] = 128] = "MissingRejectSensorMode";
        WXILogEventType[WXILogEventType["RejectConfirm"] = 256] = "RejectConfirm";
        WXILogEventType[WXILogEventType["AcquisitionTerminated"] = 512] = "AcquisitionTerminated";
        WXILogEventType[WXILogEventType["AcquisitionTooShort"] = 1024] = "AcquisitionTooShort";
        WXILogEventType[WXILogEventType["CameraDisconnected"] = 2048] = "CameraDisconnected";
        WXILogEventType[WXILogEventType["CameraNotAvailable"] = 4096] = "CameraNotAvailable";
        WXILogEventType[WXILogEventType["ContainerMonitorTerminated"] = 8192] = "ContainerMonitorTerminated";
        WXILogEventType[WXILogEventType["IoNotAvailable"] = 16384] = "IoNotAvailable";
        WXILogEventType[WXILogEventType["SystemNotFullyOperational"] = 32768] = "SystemNotFullyOperational";
        WXILogEventType[WXILogEventType["InspectionTerminated"] = 65536] = "InspectionTerminated";
        WXILogEventType[WXILogEventType["SmartKeyReaderMissing"] = 131072] = "SmartKeyReaderMissing";
        WXILogEventType[WXILogEventType["MissingMoldData"] = 262144] = "MissingMoldData";
        WXILogEventType[WXILogEventType["ConveyerTooFast"] = 524288] = "ConveyerTooFast";
        WXILogEventType[WXILogEventType["CameraOffset"] = 1048576] = "CameraOffset";
        WXILogEventType[WXILogEventType["ExitProgramMode"] = 2097152] = "ExitProgramMode";
        WXILogEventType[WXILogEventType["ActiveConfigLoaded"] = 4194304] = "ActiveConfigLoaded";
        WXILogEventType[WXILogEventType["ParameterChanges"] = 8388608] = "ParameterChanges";
        WXILogEventType[WXILogEventType["Reset"] = 16777216] = "Reset";
    })(WXILogEventType = apsEnums.WXILogEventType || (apsEnums.WXILogEventType = {}));
    var WXIEventSeverity;
    (function (WXIEventSeverity) {
        WXIEventSeverity[WXIEventSeverity["Information"] = 1] = "Information";
        WXIEventSeverity[WXIEventSeverity["HardwareMalfunction"] = 2] = "HardwareMalfunction";
        WXIEventSeverity[WXIEventSeverity["SuspiciousReading"] = 4] = "SuspiciousReading";
    })(WXIEventSeverity = apsEnums.WXIEventSeverity || (apsEnums.WXIEventSeverity = {}));
    var EquipmentTimedEventMode;
    (function (EquipmentTimedEventMode) {
        EquipmentTimedEventMode[EquipmentTimedEventMode["None"] = 0] = "None";
        EquipmentTimedEventMode[EquipmentTimedEventMode["OnTheHour"] = 1] = "OnTheHour";
        EquipmentTimedEventMode[EquipmentTimedEventMode["Interval"] = 2] = "Interval";
        EquipmentTimedEventMode[EquipmentTimedEventMode["JobRun"] = 3] = "JobRun";
        EquipmentTimedEventMode[EquipmentTimedEventMode["ShiftInterval"] = 4] = "ShiftInterval";
    })(EquipmentTimedEventMode = apsEnums.EquipmentTimedEventMode || (apsEnums.EquipmentTimedEventMode = {}));
    var EquipmentHealthState;
    (function (EquipmentHealthState) {
        EquipmentHealthState[EquipmentHealthState["Unknown"] = 0] = "Unknown";
        EquipmentHealthState[EquipmentHealthState["Good"] = 1] = "Good";
        EquipmentHealthState[EquipmentHealthState["Warning"] = 2] = "Warning";
        EquipmentHealthState[EquipmentHealthState["Error"] = 3] = "Error";
        EquipmentHealthState[EquipmentHealthState["Inactive"] = 4] = "Inactive";
    })(EquipmentHealthState = apsEnums.EquipmentHealthState || (apsEnums.EquipmentHealthState = {}));
    var CountInterval;
    (function (CountInterval) {
        CountInterval[CountInterval["Minute"] = 1] = "Minute";
        CountInterval[CountInterval["TenMinutes"] = 2] = "TenMinutes";
        CountInterval[CountInterval["Hour"] = 3] = "Hour";
        CountInterval[CountInterval["Shift"] = 4] = "Shift";
        CountInterval[CountInterval["Day"] = 5] = "Day";
    })(CountInterval = apsEnums.CountInterval || (apsEnums.CountInterval = {}));
    var WSIDefect;
    (function (WSIDefect) {
        WSIDefect[WSIDefect["Blemish"] = 1] = "Blemish";
        WSIDefect[WSIDefect["Method1"] = 2] = "Method1";
        WSIDefect[WSIDefect["Method2"] = 3] = "Method2";
        WSIDefect[WSIDefect["Diameter"] = 4] = "Diameter";
        WSIDefect[WSIDefect["Lean"] = 5] = "Lean";
        WSIDefect[WSIDefect["Height"] = 6] = "Height";
        WSIDefect[WSIDefect["UnderHeight"] = 7] = "UnderHeight";
        WSIDefect[WSIDefect["OverHeight"] = 8] = "OverHeight";
        WSIDefect[WSIDefect["Stress"] = 9] = "Stress";
        WSIDefect[WSIDefect["Cosmetic"] = 10] = "Cosmetic";
    })(WSIDefect = apsEnums.WSIDefect || (apsEnums.WSIDefect = {}));
    var CheckDetectorCounterType;
    (function (CheckDetectorCounterType) {
        CheckDetectorCounterType[CheckDetectorCounterType["Select1"] = 1] = "Select1";
        CheckDetectorCounterType[CheckDetectorCounterType["Select2"] = 2] = "Select2";
        CheckDetectorCounterType[CheckDetectorCounterType["Check"] = 3] = "Check";
        CheckDetectorCounterType[CheckDetectorCounterType["Dip"] = 4] = "Dip";
        CheckDetectorCounterType[CheckDetectorCounterType["Gauger"] = 5] = "Gauger";
        CheckDetectorCounterType[CheckDetectorCounterType["MNR"] = 6] = "MNR";
        CheckDetectorCounterType[CheckDetectorCounterType["WallThickness"] = 7] = "WallThickness";
        CheckDetectorCounterType[CheckDetectorCounterType["Bottom"] = 8] = "Bottom";
        CheckDetectorCounterType[CheckDetectorCounterType["Sidewall"] = 9] = "Sidewall";
    })(CheckDetectorCounterType = apsEnums.CheckDetectorCounterType || (apsEnums.CheckDetectorCounterType = {}));
    var CheckDetectorVersion;
    (function (CheckDetectorVersion) {
        CheckDetectorVersion[CheckDetectorVersion["V420"] = 0] = "V420";
        CheckDetectorVersion[CheckDetectorVersion["V309"] = 1] = "V309";
    })(CheckDetectorVersion = apsEnums.CheckDetectorVersion || (apsEnums.CheckDetectorVersion = {}));
    var CountRejectPercent;
    (function (CountRejectPercent) {
        CountRejectPercent[CountRejectPercent["PercentOfInspection"] = 0] = "PercentOfInspection";
        CountRejectPercent[CountRejectPercent["PercentOfGobsProduced"] = 1] = "PercentOfGobsProduced";
    })(CountRejectPercent = apsEnums.CountRejectPercent || (apsEnums.CountRejectPercent = {}));
    var PalletizerSignalType;
    (function (PalletizerSignalType) {
        PalletizerSignalType[PalletizerSignalType["PerPallet"] = 1] = "PerPallet";
        PalletizerSignalType[PalletizerSignalType["PerTier"] = 2] = "PerTier";
    })(PalletizerSignalType = apsEnums.PalletizerSignalType || (apsEnums.PalletizerSignalType = {}));
    var LogLevel;
    (function (LogLevel) {
        LogLevel[LogLevel["Verbose"] = 1] = "Verbose";
        LogLevel[LogLevel["Debug"] = 2] = "Debug";
        LogLevel[LogLevel["Info"] = 3] = "Info";
        LogLevel[LogLevel["Warning"] = 4] = "Warning";
        LogLevel[LogLevel["Error"] = 5] = "Error";
    })(LogLevel = apsEnums.LogLevel || (apsEnums.LogLevel = {}));
    var FlexISDataPointAliases;
    (function (FlexISDataPointAliases) {
        FlexISDataPointAliases[FlexISDataPointAliases["MC_CUT"] = 1] = "MC_CUT";
        FlexISDataPointAliases[FlexISDataPointAliases["MC_CUT_SC_X"]= 2] = "MC_CUT_SC_X";
        FlexISDataPointAliases[FlexISDataPointAliases["MC_NOT_CUT"]= 3] = "MC_NOT_CUT";
        FlexISDataPointAliases[FlexISDataPointAliases["MC_NOT_CUT_SC_X"]= 4] = "MC_NOT_CUT_SC_X";
        FlexISDataPointAliases[FlexISDataPointAliases["MC_DEL"]= 5] = "MC_DEL";
        FlexISDataPointAliases[FlexISDataPointAliases["MC_DEL_SC_X"]= 6] = "MC_DEL_SC_X";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_REQ"]= 7] = "SC_REQ";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_NRQ"]= 8] = "SC_NRQ";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_DEL"]= 9] = "SC_DEL";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_LOST_MS"]= 10] = "SC_LOST_MS";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_NRQ_STOP"]= 11] = "SC_NRQ_STOP";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_NRQ_DEL_OFF"]= 12] = "SC_NRQ_DEL_OFF";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_NRQ_MAN_SWAB"]= 13] = "SC_NRQ_MAN_SWAB";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_NRQ_ALT_SWAB"]= 14] = "SC_NRQ_ALT_SWAB";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_RJ_COMO"]= 15] = "SC_RJ_COMO";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_RJ_MAN_SWAB"]= 16] = "SC_RJ_MAN_SWAB";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_RJ_ALT_SWAB"]= 17] = "SC_RJ_ALT_SWAB";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_RJ_WHC"]= 18] = "SC_RJ_WHC";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_RJ"]= 19] = "SC_RJ";
        FlexISDataPointAliases[FlexISDataPointAliases["WHC_DWR_WIDE"]= 20] = "WHC_DWR_WIDE";
        FlexISDataPointAliases[FlexISDataPointAliases["WHC_DWR_THIN"]= 21] = "WHC_DWR_THIN";
        FlexISDataPointAliases[FlexISDataPointAliases["WHC_DWR_SPACE"]= 22] = "WHC_DWR_SPACE";
        FlexISDataPointAliases[FlexISDataPointAliases["WHC_DWR_OUT"]= 23] = "WHC_DWR_OUT";
        FlexISDataPointAliases[FlexISDataPointAliases["WHC_USR_CNT_1"]= 24] = "WHC_USR_CNT_1";
        FlexISDataPointAliases[FlexISDataPointAliases["WHC_USR_CNT_2"]= 25] = "WHC_USR_CNT_2";
        FlexISDataPointAliases[FlexISDataPointAliases["WHC_USR_CNT_3"]= 26] = "WHC_USR_CNT_3";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_RJ_STA_CON"] = 27] = "SC_RJ_STA_CON";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_RJ_STA_CON_BK_X"] = 28] = "SC_RJ_STA_CON_BK_X";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_RJ_STA_CON_BW_X"] = 29] = "SC_RJ_STA_CON_BW_X";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_RJ_SRV"] = 30] = "SC_RJ_SRV";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_RJ_SRV_X"] = 31] = "SC_RJ_SRV_X";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_RJ_BK"] = 32] = "SC_RJ_BK";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_RJ_BW"] = 33] = "SC_RJ_BW";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_RJ_BK_X"] = 34] = "SC_RJ_BK_X";
        FlexISDataPointAliases[FlexISDataPointAliases["SC_RJ_BW_X"] = 35] = "SC_RJ_BW_X";

    })(FlexISDataPointAliases = apsEnums.FlexISDataPointAliases || (apsEnums.FlexISDataPointAliases = {}));
    var ExcelExports;
    (function (ExcelExports) {
        ExcelExports[ExcelExports["ProductionReport"] = 0] = "ProductionReport";
    })(ExcelExports = apsEnums.ExcelExports || (apsEnums.ExcelExports = {}));
    var TiamaMultiMcalProtocol;
    (function (TiamaMultiMcalProtocol) {
        TiamaMultiMcalProtocol[TiamaMultiMcalProtocol["BaseVersion"] = 0] = "BaseVersion";
        TiamaMultiMcalProtocol[TiamaMultiMcalProtocol["Version_4_2"] = 1] = "Version_4_2";
        TiamaMultiMcalProtocol[TiamaMultiMcalProtocol["Version_10_1"] = 2] = "Version_10_1";
    })(TiamaMultiMcalProtocol = apsEnums.TiamaMultiMcalProtocol || (apsEnums.TiamaMultiMcalProtocol = {}));
})(apsEnums = exports.apsEnums || (exports.apsEnums = {}));

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _) {
    "use strict";
    notifyService.$inject = ["toastr"];
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.services.notify', ['toastr'])
        .service('notifyService', notifyService)
        .name;
    function notifyService(toastr) {
        function success(msg, title) {
            toastr.success(msg, title);
        }
        function error(msg, title) {
            toastr.error(msg, title);
        }
        function warning(msg, title) {
            toastr.warning(msg, title);
        }
        function alertWeigh(checkListInstancesServices, command, msg, title) {
            toastr.error(msg, title, {
                timeOut: 0, closeButton: true, extendedTimeOut: 0, onShown: function () {
                    checkListInstancesServices.wellKnownCreate(command);
                }, onHidden: function () {
                    command.WellKnownCheckListResult = 1;
                    checkListInstancesServices.wellKnownCreate(command);
                }
            });
        }
        function alertMold(checkListInstancesServices, command, msg, title) {
            toastr.error(msg, title, {
                timeOut: 0, closeButton: true, extendedTimeOut: 0, onShown: function () {
                    checkListInstancesServices.wellKnownCreate(command);
                }, onHidden: function () {
                    command.WellKnownCheckListResult = 1;
                    checkListInstancesServices.wellKnownCreate(command);
                }
            });
        }
        function alertBlank(checkListInstancesServices, command, msg, title) {
            toastr.error(msg, title, {
                timeOut: 0, closeButton: true, extendedTimeOut: 0, onShown: function () {
                    checkListInstancesServices.wellKnownCreate(command);
                }, onHidden: function () {
                    command.WellKnownCheckListResult = 1;
                    checkListInstancesServices.wellKnownCreate(command);
                }
            });
        }
        function warning15(msg, title) {
            toastr.warning(msg, title, { timeOut: 0, closeButton: true, extendedTimeOut: 0 });
        }
        function alertCritical(notificationService, notificationId, msg, title) {
            toastr.error(msg, title, {
                timeOut: 0, closeButton: true, extendedTimeOut: 0, preventDuplicates: true, preventOpenDuplicates: true, onHidden: function () {
                    notificationService.readNotification(notificationId);
                }, onShown: function () {
                    $('.toast-error').each(function (i, obj) {
                        if (i > 0) {
                            $(this).hide();
                        }
                    });
                }
            });
        }
        function handleApiErrors(errors, title) {
            if (!errors.data || !errors.data.modelState) {
                if (errors.data) {
                    if (errors.data["exceptionMessage"] != null) {
                        error(errors.data["exceptionMessage"], title);
                    }
                    else if (errors.data[""]) {
                        error(errors.data[""][0]);
                    }
                    else {
                        error('An unknown error occurred', title);
                    }
                    return;
                }
            }
            _.keys(errors.data.modelState).forEach(function (key) {
                _.forEach(errors.data.modelState[key], function (modelError) {
                    error(modelError, title);
                });
            });
        }
        return {
            success: success,
            error: error,
            warning: warning,
            warning15: warning15,
            alertMold: alertMold,
            alertBlank: alertBlank,
            alertWeigh: alertWeigh,
            handleApiErrors: handleApiErrors,
            alertCritical: alertCritical
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(5), __webpack_require__(27)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, aps_enums_1, enums_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.services.authData', [])
        .service('authDataService', ["$window", function ($window) {
        var self = this;
        var authTokenKey = '-authToken';
        var authRolesKey = '-authRoles';
        var countIntervalKey = '-countInterval';
        var currentUserId;
        var currentRoleLocation;
        var DOWNTIME_ENTRY_ALLOWED_ROLE_IDS = [{ roleName: 'Batch & Furnace Supervisor', roleId: 'BBDF0000-3A00-000D-9E9E-08D2E5F92C1A' },
            { roleName: 'CE Inspector', roleId: 'BBDF0000-3A00-000D-A1C4-08D2E5F92BF0' },
            { roleName: 'CE Shift Mechanic', roleId: 'BBDF0000-3A00-000D-2A81-08D2E5F92BFF' },
            { roleName: 'Facilities Maintenance Suprvisor', roleId: 'BBDF0000-3A00-000D-B33E-08D2E5F92C0A' },
            { roleName: 'Finished Ware Manager', roleId: 'BBDF0000-3A00-000D-3760-08D2E5F92C2F' },
            { roleName: 'Machine Operator', roleId: 'BBDF0000-3A00-000D-EE2D-08D2E5F92BE2' },
            { roleName: 'Packed Ware Inspector', roleId: 'BBDF0000-3A00-000D-D0D6-08D2E5F92C14' },
            { roleName: 'Production Clerk', roleId: 'BBDF0000-3A00-000D-7769-08D2E5F92C10' },
            { roleName: 'Quality Control Manager', roleId: 'BBDF0000-3A00-000D-7E8F-08D2E5F92C5E' },
            { roleName: 'Selecting Maintenance Supervisor', roleId: 'BBDF0000-3A00-000D-5F9C-08D2E5F92C23' },
            { roleName: 'Selecting Shift Supervisor', roleId: 'BBDF0000-3A00-000D-5B5A-08D2E5F92BF9' },
            { roleName: 'Selecting Tank Manager', roleId: 'BBDF0000-3A00-000D-4CD5-08D2E5F92C26' }];
        var HOURLY_DOWNTIME_ROLE_IDS = [{ roleName: 'Machine Operator', roleId: 'BBDF0000-3A00-000D-EE2D-08D2E5F92BE2' },
            { roleName: 'Machine Upkeep', roleId: 'BBDF0000-3A00-000D-184E-08D2E5F92BE6' },
            { roleName: 'EH&S Manager', roleId: 'EFFC0000-FF68-0003-1553-08D6B90C1DF6' }];
        self.setUserId = function (userId) {
            currentUserId = userId;
        };
        self.getUserId = function () {
            return currentUserId;
        };
        self.clearUserId = function () {
            currentUserId = null;
        };
        self.getToken = function () {
            var userId = self.getUserId();
            if (!userId) {
                return null;
            }
            return $window.localStorage[userId + authTokenKey];
        };
        self.setToken = function (newToken) {
            var userId = self.getUserId();
            if (!userId) {
                return;
            }
            $window.localStorage[userId + authTokenKey] = newToken;
        };
        self.clearToken = function () {
            var userId = self.getUserId();
            if (!userId) {
                return;
            }
            $window.localStorage.removeItem(userId + authTokenKey);
            $window.localStorage.removeItem(userId + authRolesKey);
            self.clearSelectedRoleLocation();
            self.clearUserData();
        };
        self.getRoles = function () {
            var userId = self.getUserId();
            if (!userId) {
                return [];
            }
            var data = $window.localStorage[userId + authRolesKey];
            if (data) {
                return JSON.parse(data);
            }
            return [];
        };
        self.setRoles = function (roles) {
            var userId = self.getUserId();
            if (!userId) {
                return;
            }
            $window.localStorage[userId + authRolesKey] = JSON.stringify(roles);
            if (roles.length === 1 && !roles[0].roleRequiresPlants) {
                self.setSelectedRoleLocation(roles[0]);
            }
            else {
                self.clearSelectedRoleLocation();
            }
        };
        function addHasFlag(roleLocation) {
            roleLocation.hasFlag = function (flag) {
                return roleLocation.role &&
                    ((roleLocation.role.roleFlags & flag) === flag);
            };
        }
        var selectedRoleLocationKey = '-selectedRoleLocation';
        self.getSelectedRoleLocation = function () {
            if (currentRoleLocation) {
                return currentRoleLocation;
            }
            var userId = self.getUserId();
            if (!userId) {
                return undefined;
            }
            var data = $window.localStorage[userId + selectedRoleLocationKey];
            if (data) {
                var roleLocation = JSON.parse(data);
                addHasFlag(roleLocation);
                currentRoleLocation = roleLocation;
                return currentRoleLocation;
            }
            return undefined;
        };
        self.setSelectedRoleLocation = function (role, plant, shop) {
            var userId = self.getUserId();
            if (!userId) {
                return;
            }
            currentRoleLocation = {
                role: role,
                plant: plant,
                shop: shop,
                hasFlag: null
            };
            addHasFlag(currentRoleLocation);
            $window.localStorage[userId + selectedRoleLocationKey] =
                JSON.stringify(currentRoleLocation);
        };
        self.clearSelectedRoleLocation = function () {
            currentRoleLocation = null;
            var userId = self.getUserId();
            if (!userId) {
                return;
            }
            $window.localStorage.removeItem(userId + selectedRoleLocationKey);
        };
        var userDataKey = '-userData';
        self.setUserData = function (data) {
            var userId = self.getUserId();
            if (!userId) {
                return;
            }
            $window.localStorage[userId + userDataKey] = JSON.stringify(data);
        };
        self.getUserData = function () {
            var userId = self.getUserId();
            if (!userId) {
                return undefined;
            }
            var data = $window.localStorage[userId + userDataKey];
            if (data) {
                return JSON.parse(data);
            }
            return undefined;
        };
        self.clearUserData = function () {
            var userId = self.getUserId();
            if (!userId) {
                return;
            }
            $window.localStorage.removeItem(userId + userDataKey);
        };
        self.isAdmin = function () {
            var userData = self.getUserData();
            return userData.isSysAdmin;
        };
        self.isPlantAdmin = function (plantId) {
            var userData = self.getUserData();
            return userData.isSysAdmin
                || userData.plantAdmins && _.includes(userData.plantAdmins, plantId);
        };
        self.isAnyPlantAdmin = function () {
            var userData = self.getUserData();
            return userData.isSysAdmin
                || userData.plantAdmins && userData.plantAdmins.length > 0;
        };
        self.isPlantAdminForCurrentPlant = function () {
            var loc = self.getSelectedRoleLocation();
            return self.isAdmin() || loc.plant && self.isPlantAdmin(loc.plant.id);
        };
        self.isAPSIOAdmin = function () {
            var loc = self.getSelectedRoleLocation();
            return loc.hasFlag(aps_enums_1.apsEnums.RoleFlags.APSIOAdmin);
        };
        self.isPlantOrAPSIOAdmin = function () { return self.isAPSIOAdmin() || self.isAnyPlantAdmin(); };
        self.isPlantOrAPSIOAdminForPlant = function (plantId) {
            return self.isAPSIOAdminForPlant(plantId) || self.isPlantAdmin(plantId);
        };
        self.isPlantOrAPSIOAdminForCurrentPlant = function () {
            return self.isAPSIOAdminForCurrentPlant() || self.isPlantAdminForCurrentPlant();
        };
        self.isAPSIOAdminForPlant = function (plantId) {
            if (!self.isAuthorizedForPlant(plantId)) {
                return false;
            }
            return self.isAPSIOAdmin();
        };
        self.isAPSIOAdminForCurrentPlant = function () {
            var loc = self.getSelectedRoleLocation();
            return self.isAPSIOAdminForPlant(loc.plant.id);
        };
        self.isAuthorizedForPlant = function (plantId) {
            if (self.isPlantAdmin(plantId)) {
                return true;
            }
            var loc = self.getSelectedRoleLocation();
            return !loc.role.roleRequiresPlants || _.some(loc.role.plants, { id: plantId });
        };
        self.isAuthorizedForCurrentPlant = function () {
            var loc = self.getSelectedRoleLocation();
            return !loc.role.roleRequiresPlants || (loc.plant && self.isAuthorizedForPlant(loc.plant.id));
        };
        self.canDeleteWeights = function () {
            var loc = self.getSelectedRoleLocation();
            if (loc.role.roleName === "APSIO Administrator" ||
                loc.role.roleName === "Quality Control Manager" ||
                loc.role.roleName === "Production Superintendent") {
                return true;
            }
            else {
                return false;
            }
        };
        self.isHEUpkeep = function () {
            var loc = self.getSelectedRoleLocation();
            if (loc.role.roleName === "Machine Upkeep") {
                return true;
            }
            else {
                return false;
            }
        };
        self.isHEMachineOperator = function () {
            var loc = self.getSelectedRoleLocation();
            if (loc.role.roleName === "Machine Operator") {
                return true;
            }
            else {
                return false;
            }
        };
        self.isJobChangeSupervisor = function (plantId) {
            if (!self.isAuthorizedForPlant(plantId)) {
                return false;
            }
            if (self.isAPSIOAdmin()) {
                return true;
            }
            if (self.isPlantAdmin(plantId)) {
                return true;
            }
            var loc = self.getSelectedRoleLocation();
            if (loc.role.roleName === "Job Change Supervisor") {
                return true;
            }
            else {
                return false;
            }
        };
        self.isProductionShiftReport = function () {
            if (_.find(self.getRoles(), function (x) { return x.roleName == 'Production Shift Report'; })) {
                return true;
            }
            return false;
        };
        self.isKpiAudit = function () {
            if (_.find(self.getRoles(), function (x) { return x.roleName == 'KPI Auditor'; })) {
                return true;
            }
            return false;
        };
        self.isHotEndBonusReport = function () {
            if (_.find(self.getRoles(), function (x) { return x.roleName == 'Hot End Bonus Report'; })) {
                return true;
            }
            return false;
        };
        self.isScaleMode = function () {
            return _.some(self.getRoles(), function (r) {
                return ((r.roleFlags & aps_enums_1.apsEnums.RoleFlags.ScaleMode) === aps_enums_1.apsEnums.RoleFlags.ScaleMode);
            });
        };
        self.hasFlag = function (flag) {
            var loc = self.getSelectedRoleLocation();
            return self.isAuthorizedForCurrentPlant() && loc.hasFlag(flag);
        };
        self.isOperator = function () {
            return self.hasFlag(aps_enums_1.apsEnums.RoleFlags.Operator);
        };
        self.isHotEndUpkeep = function () {
            var loc = self.getSelectedRoleLocation();
            return self.isOperator() && loc.role.roleLocation === aps_enums_1.apsEnums.Location.HotEnd;
        };
        self.isHotEndOperator = function () {
            var loc = self.getSelectedRoleLocation();
            return self.isOperator() && loc.role.roleLocation === aps_enums_1.apsEnums.Location.HotEnd;
        };
        self.isColdEndOperator = function () {
            var loc = self.getSelectedRoleLocation();
            return self.isOperator() && loc.role.roleLocation === aps_enums_1.apsEnums.Location.ColdEnd;
        };
        self.isColdEndInspector = function () {
            return self.hasFlag(aps_enums_1.apsEnums.RoleFlags.ColdEndInspector);
        };
        self.isAuthorizedForToolChanges = function () {
            return self.isHotEndOperator();
        };
        self.isAuthorizedForToolChangesComment = function () {
            return self.isColdEndInspector();
        };
        self.isAuthorizedForDefects = function () {
            var loc = self.getSelectedRoleLocation();
            return self.isAdmin() || loc.role.roleFlags > 0;
        };
        var isAuthorizedByRoleList = function (roleList) {
            var loc = self.getSelectedRoleLocation();
            return (_.filter(roleList, function (n) {
                return n.roleId === loc.role.roleId.toUpperCase() && n.roleName == loc.role.roleName;
            }).length > 0) && self.isAuthorizedForCurrentPlant();
        };
        self.isAuthorizedForDowntimeByRole = function () {
            return isAuthorizedByRoleList(DOWNTIME_ENTRY_ALLOWED_ROLE_IDS);
        };
        self.isAuthorizedForDowntime = function () {
            return self.isAuthorizedForDowntimeByRole() || self.isHotEndOperator();
        };
        self.isAuthorizedForHourlyDowntime = function () {
            return isAuthorizedByRoleList(HOURLY_DOWNTIME_ROLE_IDS);
        };
        self.isAuthorizedForQualifications = function () {
            var loc = self.getSelectedRoleLocation();
            return self.isOperator() && loc.role.roleLocation !== aps_enums_1.apsEnums.Location.None;
        };
        self.isAuthorizedForBatchSummary = function () {
            return self.isAdmin() || !!_.find(self.getRoles(), function (x) { return x.roleName == 'Commodities and Batch Summary'; });
        };
        self.getCountInterval = function () {
            var userId = self.getUserId();
            var data = $window.localStorage[userId + countIntervalKey];
            if (data) {
                return JSON.parse(data);
            }
            else {
                return enums_1.apsDisplayEnums.CountDisplayInterval.Last24Hours;
            }
        };
        self.setCountInterval = function (countInterval) {
            var userId = self.getUserId();
            $window.localStorage[userId + countIntervalKey] = countInterval;
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(390), __webpack_require__(7), __webpack_require__(107)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, navigationPlants_service_1, authData_service_1, navigation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [navigationPlants_service_1.default, authData_service_1.default, navigation_1.default];
    var NavigationServiceImpl = (function () {
        NavigationServiceImpl.$inject = ["$q", "navigationPlantsService", "Navigation", "authDataService"];
        function NavigationServiceImpl($q, navigationPlantsService, Navigation, authDataService) {
            this.$q = $q;
            this.navigationPlantsService = navigationPlantsService;
            this.Navigation = Navigation;
            this.authDataService = authDataService;
        }
        NavigationServiceImpl.prototype.getSelectedRoleLocation = function () {
            return this.authDataService.getSelectedRoleLocation();
        };
        NavigationServiceImpl.prototype.getNavigation = function () {
            return this.getDefer().promise;
        };
        NavigationServiceImpl.prototype.getLocations = function (includeDeleted) {
            return this.navigationPlantsService.getLocationNavigation(includeDeleted);
        };
        NavigationServiceImpl.prototype.getPlants = function (includeDeleted) {
            var defer = this.$q.defer();
            this.navigationPlantsService.getPlantNavigation(includeDeleted)
                .then(function (plants) {
                defer.resolve(_.map(plants, function (p) {
                    var plant = _.assign({}, p);
                    plant.shops = _.flatten(_.map(p.tanks, 'shops'));
                    return plant;
                }));
            }, function (error) { return defer.reject(error); });
            return defer.promise;
        };
        NavigationServiceImpl.prototype.getCurrentRole = function () {
            var selected = this.getSelectedRoleLocation();
            if (selected) {
                return selected.role;
            }
            return this.setRole;
        };
        NavigationServiceImpl.prototype.setCurrentRole = function (role) {
            if (this.getCurrentRole() !== role) {
                this.setRole = role;
                if (this.defer) {
                    this.getNavigation().then(function (model) { return model.roleChanged(); });
                }
            }
        };
        NavigationServiceImpl.prototype.clearSetRole = function () {
            this.setRole = undefined;
        };
        NavigationServiceImpl.prototype.getDefer = function () {
            var _this = this;
            if (this.defer) {
                return this.defer;
            }
            this.defer = this.$q.defer();
            this.navigationPlantsService.getPlantNavigation(false)
                .then(function (plants) {
                _this.model = new _this.Navigation(plants, function () { return _this.getCurrentRole(); });
                var selectedRoleLocation = _this.getSelectedRoleLocation();
                if (selectedRoleLocation && selectedRoleLocation.plant) {
                    var plant = _.find(_this.model.plants(), { id: selectedRoleLocation.plant.id });
                    if (plant) {
                        _this.model.selectedPlant = plant;
                    }
                }
                if (selectedRoleLocation && selectedRoleLocation.shop) {
                    var shop = _.find(_this.model.shops(), { id: selectedRoleLocation.shop.id });
                    if (shop) {
                        _this.model.selectedShop = shop;
                    }
                }
                if (!_this.model.selectedShop) {
                    _this.model.selectedShop = _.first(_this.model.shops());
                }
                _this.defer.resolve(_this.model);
            }, function (error) {
                _this.defer.reject(error);
                _this.defer = undefined;
            });
            return this.defer;
        };
        return NavigationServiceImpl;
    }());
    exports.default = angular.module('aps.services.navigation', requires)
        .service('navigationService', NavigationServiceImpl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(5), __webpack_require__(0), __webpack_require__(2), __webpack_require__(3), __webpack_require__(397)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, aps_enums_1, angular, _, constant_module_1, commonConfirmationDialog_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var UICommonConfirmationDialogCtrl = (function () {
        UICommonConfirmationDialogCtrl.$inject = ["$modalInstance", "data"];
        function UICommonConfirmationDialogCtrl($modalInstance, data) {
            this.modalInstance = $modalInstance;
            this.message = data.message;
            this.subject = data.subject ? data.subject : 'Confirm Request';
            this.yes = data.yes ? data.yes : 'Confirm';
            this.no = data.no ? data.no : 'Cancel';
            this.onlyConfirm = data.onlyConfirm;
            this.htmlBinding = data.htmlBinding;
            this.showTip = data.showTip;
        }
        UICommonConfirmationDialogCtrl.prototype.save = function () {
            this.modalInstance.close(true);
        };
        UICommonConfirmationDialogCtrl.prototype.close = function () {
            this.modalInstance.close(false);
        };
        return UICommonConfirmationDialogCtrl;
    }());
    var UIUtilitySvc = (function () {
        UIUtilitySvc.$inject = ["$window", "$modal"];
        function UIUtilitySvc($window, $modal) {
            this.$window = $window;
            this.$modal = $modal;
        }
        UIUtilitySvc.prototype.addEnumOption = function (type, value, options, formatter) {
            formatter = formatter || _.startCase;
            options.push({ text: formatter(type[value]), value: value });
        };
        UIUtilitySvc.prototype.getListOptionsFromEnum = function (type, start, end, formatter) {
            var result = [];
            var i = start || 0;
            while (type[i]) {
                if (end && i > end) {
                    break;
                }
                this.addEnumOption(type, i, result, formatter);
                i++;
            }
            return result;
        };
        UIUtilitySvc.prototype.confirm = function (message, subject, yes, no, onlyConfirm, htmlBinding, showTip) {
            if (onlyConfirm === void 0) { onlyConfirm = false; }
            if (htmlBinding === void 0) { htmlBinding = false; }
            if (showTip === void 0) { showTip = true; }
            var modalConfirmation = this.$modal.open({
                template: commonConfirmationDialog_tpl_html_1.default,
                controller: 'uiCommonConfirmationDialogCtrl as vm',
                resolve: {
                    data: function () { return ({
                        message: message,
                        subject: subject,
                        yes: yes,
                        no: no,
                        onlyConfirm: onlyConfirm,
                        htmlBinding: htmlBinding,
                        showTip: showTip
                    }); }
                }
            });
            return modalConfirmation.result;
        };
        UIUtilitySvc.prototype.getSeverityColor = function (severity) {
            if (severity === aps_enums_1.apsEnums.Severity.Critical) {
                return constant_module_1.Colors.DEFECT_CRITICAL;
            }
            else if (severity === aps_enums_1.apsEnums.Severity.Major) {
                return constant_module_1.Colors.DEFECT_MAJOR;
            }
            else if (severity === aps_enums_1.apsEnums.Severity.Minor) {
                return constant_module_1.Colors.DEFECT_MINOR;
            }
            else if (severity === aps_enums_1.apsEnums.Severity.Event) {
                return constant_module_1.Colors.DEFECT_EVENT;
            }
            return null;
        };
        UIUtilitySvc.prototype.getRejectColor = function (rejectIndex) {
            switch (rejectIndex) {
                case 10:
                    return constant_module_1.Colors.REJECT_10;
                case 9:
                    return constant_module_1.Colors.REJECT_09;
                case 8:
                    return constant_module_1.Colors.REJECT_08;
                case 7:
                    return constant_module_1.Colors.REJECT_07;
                case 6:
                    return constant_module_1.Colors.REJECT_06;
                case 5:
                    return constant_module_1.Colors.REJECT_05;
                case 4:
                    return constant_module_1.Colors.REJECT_04;
                case 3:
                    return constant_module_1.Colors.REJECT_03;
                case 2:
                    return constant_module_1.Colors.REJECT_02;
                default:
                    return constant_module_1.Colors.REJECT_01;
            }
        };
        UIUtilitySvc.prototype.getEfficiencyColor = function (efficiency) {
            if (efficiency >= 97) {
                return constant_module_1.Colors.EFFICIENCY_HIGH;
            }
            else if (efficiency >= 95) {
                return constant_module_1.Colors.EFFICIENCY_MEDIUM;
            }
            else if (efficiency >= 93) {
                return constant_module_1.Colors.EFFICIENCY_LOW;
            }
            else {
                return constant_module_1.Colors.EFFICIENCY_WARNING;
            }
        };
        UIUtilitySvc.prototype.getCavityCorrelationColor = function (efficiency) {
            if (efficiency <= 3.0) {
                return constant_module_1.Colors.EFFICIENCY_HIGH;
            }
            else if (efficiency <= 5.0) {
                return constant_module_1.Colors.EFFICIENCY_MEDIUM;
            }
            else if (efficiency <= 7.0) {
                return constant_module_1.Colors.EFFICIENCY_LOW;
            }
            else {
                return constant_module_1.Colors.EFFICIENCY_WARNING;
            }
        };
        return UIUtilitySvc;
    }());
    exports.default = angular
        .module('ui-common-confirmation', ['mm.foundation'])
        .service('uiUtilityService', UIUtilitySvc)
        .controller('uiCommonConfirmationDialogCtrl', UICommonConfirmationDialogCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(43)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, environment_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var HttpSvc = (function () {
        HttpSvc.$inject = ["$http", "$q", "environment"];
        function HttpSvc($http, $q, environment) {
            this.$http = $http;
            this.$q = $q;
            this.environment = environment;
        }
        HttpSvc.prototype.http = function (method, endpoint, request, params, transformCallback) {
            var defer = this.$q.defer();
            endpoint = this.getUrl(endpoint);
            this.$http({
                method: method,
                params: params,
                data: request,
                url: endpoint,
                transformResponse: transformCallback || this.$http.defaults.transformResponse
            }).then(function (response) { return defer.resolve(response.data); }, function (response) { return defer.reject(response); });
            return defer.promise;
        };
        HttpSvc.prototype.httpRequest = function (method, endpoint, request) {
            var defer = this.$q.defer();
            endpoint = this.getUrl(endpoint);
            this.$http(__assign({ method: method, url: endpoint }, request)).then(function (response) { return defer.resolve(response.data); }, function (response) { return defer.reject(response); });
            return defer.promise;
        };
        HttpSvc.prototype.all = function (requests) {
            var defer = this.$q.defer();
            this.$q.all(requests)
                .then(function (response) { return defer.resolve(response); }, function (response) { return defer.reject(response); });
            return defer.promise;
        };
        HttpSvc.prototype.get = function (endpoint, params, transformCallback) {
            return this.http('GET', endpoint, null, params, transformCallback);
        };
        HttpSvc.prototype.post = function (endpoint, data, transformCallback) {
            return this.http('POST', endpoint, data, null, transformCallback);
        };
        HttpSvc.prototype.postRequest = function (endpoint, request) {
            return this.httpRequest('POST', endpoint, request);
        };
        HttpSvc.prototype.put = function (endpoint, data, transformCallback) {
            return this.http('PUT', endpoint, data, null, transformCallback);
        };
        HttpSvc.prototype.delete = function (endpoint, params, transformCallback) {
            return this.http('DELETE', endpoint, null, params, transformCallback);
        };
        HttpSvc.prototype.getUrl = function (endpoint) {
            if (endpoint.indexOf('http') !== 0) {
                return this.environment.API_PATH + endpoint;
            }
            return endpoint;
        };
        return HttpSvc;
    }());
    exports.default = angular.module('aps.services.http', [environment_1.default])
        .service('httpService', HttpSvc)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(1), __webpack_require__(2), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, moment, _, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var DateUtilityService = (function () {
        function DateUtilityService() {
        }
        DateUtilityService.formatDate = function (date, timeZone) {
            if (date) {
                return moment(date)
                    .tz(timeZone || constant_module_1.Strings.DEFAULT_TIMEZONE)
                    .format(constant_module_1.Strings.DATE_FORMAT);
            }
            return '';
        };
        DateUtilityService.formatTime = function (date, timeZone) {
            return DateUtilityService.formatDateTime(date, timeZone, constant_module_1.Strings.TIME_FORMAT);
        };
        DateUtilityService.formatDateTime = function (date, timeZone, format) {
            if (date) {
                var dateMoment = moment(date);
                timeZone = timeZone || constant_module_1.Strings.DEFAULT_TIMEZONE;
                var output = dateMoment.tz(timeZone).format(format);
                if (DateUtilityService.isSecondHour(dateMoment.toDate(), timeZone)) {
                    return output + ' (second hour)';
                }
                return output;
            }
            return '';
        };
        DateUtilityService.formatTimeOnly = function (date, timeZone) {
            if (date) {
                return moment(date)
                    .tz(timeZone || constant_module_1.Strings.DEFAULT_TIMEZONE)
                    .format(constant_module_1.Strings.TIME_ONLY_FORMAT);
            }
            return '';
        };
        DateUtilityService.stringToDate = function (formattedDate, timeZone) {
            if (formattedDate) {
                var date = moment.tz(formattedDate, constant_module_1.Strings.DATE_FORMAT, timeZone || constant_module_1.Strings.DEFAULT_TIMEZONE);
                if (date.isValid()) {
                    return date;
                }
            }
            return null;
        };
        DateUtilityService.stringToTime = function (formattedDate, timeZone) {
            if (formattedDate) {
                var date = moment.tz(formattedDate, constant_module_1.Strings.TIME_FORMAT, timeZone || constant_module_1.Strings.DEFAULT_TIMEZONE);
                if (date.isValid()) {
                    return date;
                }
            }
            return null;
        };
        DateUtilityService.localToTimeZoneWithFormat = function (date, timeZone, formatString) {
            if (!date) {
                return undefined;
            }
            var localDate = moment(date);
            return moment.tz(localDate.format(formatString), formatString, timeZone || constant_module_1.Strings.DEFAULT_TIMEZONE);
        };
        DateUtilityService.localToTimeZone = function (date, timeZone) {
            return DateUtilityService.localToTimeZoneWithFormat(date, timeZone, constant_module_1.Strings.TIME_FORMAT);
        };
        DateUtilityService.localToTimeZoneWithSeconds = function (date, timeZone) {
            return DateUtilityService.localToTimeZoneWithFormat(date, timeZone, constant_module_1.Strings.TIME_FORMAT_WITH_SECONDS);
        };
        DateUtilityService.timeZoneToLocal = function (date, timeZone) {
            if (!date) {
                return undefined;
            }
            var timeZoneDate = moment.tz(date, timeZone || constant_module_1.Strings.DEFAULT_TIMEZONE);
            return moment(timeZoneDate.format(constant_module_1.Strings.TIME_FORMAT), constant_module_1.Strings.TIME_FORMAT);
        };
        DateUtilityService.getHourRange = function (date, timeZoneId) {
            var range;
            var now = DateUtilityService.currentMinute();
            timeZoneId = timeZoneId || constant_module_1.Strings.DEFAULT_TIMEZONE;
            var dateMoment = moment.tz(date, timeZoneId);
            if (dateMoment.isSame(moment(now), 'hour')) {
                range = {
                    initialTime: moment.tz(now, timeZoneId),
                    minDate: moment(now).minutes(0),
                    maxDate: moment(now)
                };
            }
            else {
                dateMoment = DateUtilityService.roundToMinute(dateMoment);
                range = {
                    initialTime: dateMoment,
                    minDate: moment(date),
                    maxDate: moment(date).add(1, 'hours').subtract(1, 'minutes')
                };
            }
            range.minTime = DateUtilityService.formatISO(range.minDate, timeZoneId);
            range.maxTime = DateUtilityService.formatISO(range.maxDate, timeZoneId);
            return range;
        };
        DateUtilityService.formatISO = function (date, timeZoneId) {
            return moment(date).tz(timeZoneId || constant_module_1.Strings.DEFAULT_TIMEZONE).format(constant_module_1.Strings.ISO_FORMAT);
        };
        DateUtilityService.currentMinute = function () {
            return DateUtilityService.roundToMinute(moment());
        };
        DateUtilityService.roundToMinute = function (date) {
            return date.startOf('minute');
        };
        DateUtilityService.getHourForTimeZone = function (date, hour, timeZoneId) {
            var localDate = moment.tz(date, timeZoneId || constant_module_1.Strings.DEFAULT_TIMEZONE).hours(hour).startOf('hour');
            return localDate.toDate();
        };
        DateUtilityService.getTimeZoneOffset = function (date, timeZoneId) {
            var tzMoment = DateUtilityService.localToTimeZone(date, timeZoneId);
            return tzMoment.zone();
        };
        DateUtilityService.isSecondHour = function (date, timeZoneId) {
            var timeZoneMoment = moment.tz(date, timeZoneId);
            var previousHour = moment.tz(date, timeZoneId || constant_module_1.Strings.DEFAULT_TIMEZONE).subtract(1, 'hours');
            return previousHour.hour() === timeZoneMoment.hour();
        };
        DateUtilityService.setReportDates = function (controller, params, $timeout) {
            if (params.startDate) {
                var startDate = moment(params.startDate);
                if (startDate.isValid()) {
                    var date_1 = startDate.toDate();
                    controller.startDate = date_1;
                    $timeout(function () {
                        controller.startDate = date_1;
                    });
                }
            }
            if (params.endDate) {
                var endDate = moment(params.endDate);
                if (endDate.isValid()) {
                    var date_2 = endDate.toDate();
                    controller.endDate = endDate.toDate();
                    $timeout(function () {
                        controller.endDate = date_2;
                    });
                }
            }
        };
        return DateUtilityService;
    }());
    exports.DateUtilityService = DateUtilityService;
    var TimeZoneService = (function () {
        function TimeZoneService() {
        }
        TimeZoneService.getTimeZones = function () {
            return _.filter(moment.tz.names(), function (tz) { return _.startsWith(tz, 'US'); });
        };
        return TimeZoneService;
    }());
    exports.TimeZoneService = TimeZoneService;
    exports.default = DateUtilityService;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular
        .module('aps.services.newguid', [http_service_1.default])
        .service('newGuidService', ["httpService", function (httpService) {
        var getNewGuid = function (entityType) { return httpService
            .get(constant_module_1.Endpoints.NEWGUID, { entityType: entityType }); };
        var getNewGuids = function (entityType, count) { return httpService
            .get(constant_module_1.Endpoints.NEWGUID, { entityType: entityType, count: count }); };
        return {
            getNewGuid: getNewGuid,
            getNewGuids: getNewGuids
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(10), __webpack_require__(5), __webpack_require__(7), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, moment, http_service_1, aps_enums_1, authData_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [http_service_1.default, authData_service_1.default];
    var ReportSvcImpl = (function () {
        ReportSvcImpl.$inject = ["httpService", "$window", "authDataService", "$q"];
        function ReportSvcImpl(httpService, $window, authDataService, $q) {
            this.httpService = httpService;
            this.$window = $window;
            this.authDataService = authDataService;
            this.$q = $q;
        }
        ReportSvcImpl.prototype.exportToExcel = function (reportType, plantId, reportDate) {
            var _this = this;
            var defer = this.$q.defer();
            var encode = function (component) {
                return (_this.$window).encodeURIComponent(component);
            };
            var params = {
                plantId: plantId,
                reportDate: reportDate
            };
            var url = null;
            var token = this.authDataService.getToken();
            switch (reportType) {
                case aps_enums_1.apsEnums.ExcelExports.ProductionReport:
                    url = constant_module_1.Endpoints.PRODUCTION_SHIFT_REPORT_EXPORT;
                    params = {
                        plantId: plantId,
                        reportDate: reportDate
                    };
                    break;
            }
            if (url) {
                var fileUrl = this.httpService.getUrl(url) +
                    '?plantId=' + encode(plantId) +
                    '&reportDate=' + moment(reportDate).toISOString() +
                    '&accessToken=' + token;
                this.$window.location.href = fileUrl;
                defer.resolve();
            }
            else {
                defer.reject("Report cannot be exported.");
            }
            return defer.promise;
        };
        ReportSvcImpl.prototype.exportToExcelV2 = function (plantName, productionDate, b64Data) {
            var byteCharacters = atob(b64Data);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            var url = window.URL.createObjectURL(blob);
            var anchor = document.createElement('a');
            var reportDate = moment(productionDate).format("MM/DD/YYYY");
            anchor.download = 'Production_Report_' + plantName + '_' + reportDate + '.xlsx';
            anchor.href = url;
            anchor.click();
        };
        ReportSvcImpl.prototype.exportToPDFV2 = function (plantName, productionDate, b64Data) {
            var byteCharacters = atob(b64Data);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var blob = new Blob([byteArray], { type: 'application/pdf' });
            var url = window.URL.createObjectURL(blob);
            var anchor = document.createElement('a');
            var reportDate = moment(productionDate).format("MM/DD/YYYY");
            anchor.download = 'Production_Report_' + plantName + '_' + reportDate + '.pdf';
            anchor.href = url;
            anchor.click();
        };
        ReportSvcImpl.prototype.getDeletedDefectsReport = function (plantId, startDate, endDate) {
            var params = {
                plantId: plantId,
                startDate: startDate,
                endDate: endDate
            };
            return this.httpService.get(constant_module_1.Endpoints.DELETED_DEFECTS_REPORT, params);
        };
        ReportSvcImpl.prototype.getCriticalDefectReportDetails = function (plantId, startDate, endDate, isMissingSignOff) {
            var params = {
                plantId: plantId,
                startDate: startDate,
                endDate: endDate,
                isMissingSignOff: isMissingSignOff
            };
            return this.httpService.get(constant_module_1.Endpoints.CRITICAL_DEFECT_REPORT_DETAILS, params);
        };
        ReportSvcImpl.prototype.getDeletedGobWeightsReport = function (plantId, startDate, endDate) {
            var params = {
                plantId: plantId,
                startDate: startDate,
                endDate: endDate
            };
            return this.httpService.get(constant_module_1.Endpoints.DELETED_GOB_WEIGHT_REPORT, params);
        };
        ReportSvcImpl.prototype.getCriticalDefectsReport = function (plantId, startDate, endDate) {
            var params = {
                plantId: plantId,
                startDate: startDate,
                endDate: endDate
            };
            return this.httpService.get(constant_module_1.Endpoints.CRITICAL_DEFECTS_REPORT, params);
        };
        ReportSvcImpl.prototype.getTopDefectsReport = function (shopId, startDate, endDate, maxDefects, critical, maintenance) {
            var params = {
                shopId: shopId,
                startDate: startDate,
                endDate: endDate,
                maxDefects: maxDefects,
                critical: critical,
                maintenance: maintenance
            };
            return this.httpService.get(constant_module_1.Endpoints.TOP_N_DEFECTS_REPORT, params);
        };
        ReportSvcImpl.prototype.getDefectReportDetails = function (shopId, defectTypeId, startDate, endDate) {
            var params = {
                shopId: shopId,
                defectTypeId: defectTypeId,
                startDate: startDate,
                endDate: endDate
            };
            return this.httpService.get(constant_module_1.Endpoints.DEFECT_REPORT_DETAILS, params);
        };
        ReportSvcImpl.prototype.getFurnacePullReportByShop = function (plantId, startDateTime, endDateTime, auditData, includeDeleted) {
            var params = {
                plantId: plantId,
                startTimeStamp: moment(startDateTime).toISOString(true),
                endTimeStamp: moment(endDateTime).toISOString(true),
                auditData: auditData,
                includeDeleted: includeDeleted
            };
            return this.httpService.get(constant_module_1.Endpoints.FURNACE_PULL_REPORT_SHOP, params);
        };
        ReportSvcImpl.prototype.getFurnacePullReportByTank = function (plantId, startDateTime, endDateTime) {
            var params = {
                plantId: plantId,
                startTimeStamp: moment(startDateTime).toISOString(true),
                endTimeStamp: moment(endDateTime).toISOString(true)
            };
            return this.httpService.get(constant_module_1.Endpoints.FURNACE_PULL_REPORT_TANK, params);
        };
        ReportSvcImpl.prototype.getFurnacePullReportAbandonedWeights = function (plantId, startDateTime, endDateTime) {
            var params = {
                plantId: plantId,
                startTimeStamp: moment(startDateTime).toISOString(true),
                endTimeStamp: moment(endDateTime).toISOString(true)
            };
            return this.httpService.get(constant_module_1.Endpoints.FURNACE_PULL_REPORT_ABANDONED_WEIGHTS, params);
        };
        ReportSvcImpl.prototype.generateMorningMinutesReport = function (plantId, reportDate, regenerate) {
            var params = {
                plantId: plantId,
                date: reportDate,
                regenerate: regenerate
            };
            return this.httpService.post(constant_module_1.Endpoints.GENERATE_MORNING_MINUTES_REPORT, params);
        };
        ReportSvcImpl.prototype.getMorningMinutesReport = function (plantId, reportDate) {
            var _this = this;
            var encode = function (component) {
                return (_this.$window).encodeURIComponent(component);
            };
            var token = this.authDataService.getToken();
            var url = this.httpService.getUrl(constant_module_1.Endpoints.MORNING_MINUTES_REPORT) +
                '?plantId=' + encode(plantId) +
                '&reportDate=' + moment(reportDate).toISOString() +
                '&accessToken=' + token;
            this.$window.location.href = url;
        };
        ReportSvcImpl.prototype.getShiftDetailReport = function (plantId, reportDate, shift, allShifts) {
            var params = {
                plantId: plantId,
                reportDate: reportDate,
                shift: shift,
                allShifts: allShifts
            };
            return this.httpService.post(constant_module_1.Endpoints.SHIFT_DETAIL_REPORT, params);
        };
        ReportSvcImpl.prototype.getProductionReport = function (plantId, shopId, userId, scheduleOn, checklistInstanceId) {
            var params = {
                plantId: plantId,
                shopId: shopId,
                userId: userId,
                scheduleOn: scheduleOn,
                checklistInstanceId: checklistInstanceId
            };
            return this.httpService.get(constant_module_1.Endpoints.PRODUCTION_REPORT, params);
        };
        ReportSvcImpl.prototype.getJobRunReport = function (searchCriteria) {
            return this.httpService.post(constant_module_1.Endpoints.JOB_REPORT, searchCriteria);
        };
        ReportSvcImpl.prototype.getJobRunReportDetails = function (jobRunId) {
            return this.httpService.get(constant_module_1.Endpoints.JOB_REPORT_DETAILS, { jobRunId: jobRunId });
        };
        ReportSvcImpl.prototype.getJobRunReportMolds = function (plantId, shopId) {
            var params = {
                plantId: plantId,
                shopId: shopId
            };
            return this.httpService.get(constant_module_1.Endpoints.JOB_REPORT_MOLDS, params);
        };
        ReportSvcImpl.prototype.getToolChangeReport = function (shopId, reasonId, startDate, endDate) {
            var params = {
                shopId: shopId,
                reason: reasonId,
                startDate: startDate,
                endDate: endDate
            };
            return this.httpService.get(constant_module_1.Endpoints.TOOL_CHANGE_REPORT, params);
        };
        ReportSvcImpl.prototype.getToolChangeReportDetails = function (shopId, reasonId, toolName, startDate, endDate) {
            var params = {
                shopId: shopId,
                reason: reasonId,
                toolName: toolName,
                startDate: startDate,
                endDate: endDate
            };
            return this.httpService.get(constant_module_1.Endpoints.TOOL_CHANGE_REPORT_DETAILS, params);
        };
        ReportSvcImpl.prototype.getDowntimeReport = function (shopId, type, location, startDate, endDate) {
            var params = {
                shopId: shopId,
                type: type,
                location: location,
                startDate: startDate,
                endDate: endDate
            };
            return this.httpService.get(constant_module_1.Endpoints.DOWNTIME_REPORT, params);
        };
        ReportSvcImpl.prototype.getDowntimeReportDetails = function (shopId, type, location, section, startDate, endDate) {
            var params = {
                shopId: shopId,
                type: type,
                location: location,
                section: section,
                startDate: startDate,
                endDate: endDate
            };
            return this.httpService.get(constant_module_1.Endpoints.DOWNTIME_REPORT_DETAILS, params);
        };
        ReportSvcImpl.prototype.getDumpGateTimeReport = function (plantId, shopId, shiftId, startDate, endDate) {
            var params = {
                plantId: plantId,
                shopId: shopId,
                shiftId: shiftId,
                startDate: startDate,
                endDate: endDate
            };
            return this.httpService.get(constant_module_1.Endpoints.DUMPGATETIME_REPORT, params);
        };
        ReportSvcImpl.prototype.getHourlyChecklistReport = function (plantId, location, locationId, checkListId, reportDate, failuresOnly, reportEndDate, completedOnly) {
            return this.httpService.get(constant_module_1.Endpoints.HOURLY_CHECKLIST_REPORT, {
                plantId: plantId,
                locationType: location,
                locationId: locationId,
                checkListId: checkListId,
                reportDate: reportDate,
                failuresOnly: failuresOnly,
                reportEndDate: reportEndDate,
                completedOnly: completedOnly
            });
        };
        ReportSvcImpl.prototype.getQualificationsReport = function (shopId, startDate, endDate, location, exceptionTime, exceptionsOnly) {
            return this.httpService.get(constant_module_1.Endpoints.QUALIFICATIONS_REPORT, {
                shopId: shopId,
                startDate: startDate,
                endDate: endDate,
                location: location,
                exceptionTime: exceptionTime,
                exceptionsOnly: exceptionsOnly
            });
        };
        ReportSvcImpl.prototype.getDefectsReport = function (shopId, defectTypeId, startDate, endDate, severity) {
            return this.httpService.get(constant_module_1.Endpoints.DEFECTS_REPORT, {
                shopId: shopId,
                defectTypeId: defectTypeId,
                startDate: startDate,
                endDate: endDate,
                severity: severity
            });
        };
        ReportSvcImpl.prototype.getDefectsReportAll = function (defectTypeId, startDate, endDate, severity) {
            return this.httpService.get(constant_module_1.Endpoints.DEFECTS_REPORT_ALL, {
                defectTypeId: defectTypeId,
                startDate: startDate,
                endDate: endDate,
                severity: severity
            });
        };
        ReportSvcImpl.prototype.getProductionShiftReport = function (plantId, reportDate) {
            return this.httpService.get(constant_module_1.Endpoints.PRODUCTION_SHIFT_REPORT, {
                plantId: plantId,
                reportDate: reportDate
            });
        };
        ReportSvcImpl.prototype.getProductionShiftReportV2 = function (plantId, reportDate) {
            return this.httpService.get(constant_module_1.Endpoints.PRODUCTION_SHIFT_REPORTV2, {
                plantId: plantId,
                reportDate: reportDate
            });
        };
        ReportSvcImpl.prototype.getDowntimeShiftReport = function (request) {
            return this.httpService.post(constant_module_1.Endpoints.DOWNTIME_SHIFT_REPORTV1, request);
        };
        ReportSvcImpl.prototype.getDowntimeInsight = function (request) {
            return this.httpService.post(constant_module_1.Endpoints.DOWNTIME_SHIFT_REPORT_INSIGHT_ALL, request);
        };
        ReportSvcImpl.prototype.getPalletKpis = function (shopId, reportDate) {
            return this.httpService.get(constant_module_1.Endpoints.PALLET_KPIS, {
                shopId: shopId,
                reportDate: reportDate
            });
        };
        ReportSvcImpl.prototype.updatePalletKpi = function (palletUpdate) {
            return this.httpService.post(constant_module_1.Endpoints.UPDATE_PALLETS, palletUpdate);
        };
        ReportSvcImpl.prototype.getPlantKpis = function (shopId, reportDate) {
            return this.httpService.get(constant_module_1.Endpoints.PLANT_KPI, {
                shopId: shopId,
                reportDate: reportDate
            });
        };
        ReportSvcImpl.prototype.updatePlantKpi = function (command) {
            return this.httpService.put(constant_module_1.Endpoints.PLANT_KPI, command);
        };
        ReportSvcImpl.prototype.updateHotEndBonus = function (command) {
            return this.httpService.put(constant_module_1.Endpoints.PLANT_HOTENDBONUS, command);
        };
        ReportSvcImpl.prototype.getHotEndSignOff = function (plantId, productionDate) {
            var params = {
                plantId: plantId,
                productionDate: productionDate
            };
            return this.httpService.get(constant_module_1.Endpoints.GET_HOTENDBONUSSIGNOFF, params);
        };
        ReportSvcImpl.prototype.updateSignOffUsers = function (hotEndCommand) {
            return this.httpService.put(constant_module_1.Endpoints.SIGNOFF_HOTENDBONUS, hotEndCommand);
        };
        ReportSvcImpl.prototype.getWareHeldReport = function (plantId, shopId, startDate, endDate) {
            var params = {
                plantId: plantId,
                shopId: shopId,
                startDate: startDate,
                endDate: endDate
            };
            return this.httpService.get(constant_module_1.Endpoints.WARE_HELD_REPORT, params);
        };
        ReportSvcImpl.prototype.getTankMetricsReport = function (plantId, startDate, endDate) {
            var params = {
                plantId: plantId,
                startDate: startDate,
                endDate: endDate
            };
            return this.httpService.get(constant_module_1.Endpoints.TANK_METRICS_REPORT, params);
        };
        ReportSvcImpl.prototype.getWeeklyKpisReport = function (plantId) {
            return this.httpService.get(constant_module_1.Endpoints.WEEKLY_KPI_REPORT, {
                plantId: plantId
            });
        };
        ReportSvcImpl.prototype.getPlantHotEndBonus = function (plantId, reportDate) {
            return this.httpService.get(constant_module_1.Endpoints.PLANT_HOTENDBONUS, {
                plantId: plantId,
                reportDate: reportDate
            });
        };
        return ReportSvcImpl;
    }());
    exports.default = angular
        .module('aps.services.reports', requires)
        .service('reportService', ReportSvcImpl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(3), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, constant_module_1, http_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ShopSvc = (function () {
        ShopSvc.$inject = ["httpService"];
        function ShopSvc(httpService) {
            this.httpService = httpService;
        }
        ShopSvc.prototype.getShops = function () {
            return this.httpService.get(constant_module_1.Endpoints.SHOP);
        };
        ShopSvc.prototype.getPlants = function () {
            return this.httpService.get(constant_module_1.Endpoints.PLANT_LISTS);
        };
        ShopSvc.prototype.updateShop = function (shop) {
            return this.httpService.post(constant_module_1.Endpoints.SHOP, shop);
        };
        ShopSvc.prototype.getShopConfiguration = function (shopId, time) {
            return this.httpService.get(constant_module_1.Endpoints.SHOP_CONFIGURATION, {
                shopId: shopId,
                time: time
            });
        };
        return ShopSvc;
    }());
    exports.default = angular
        .module('aps.services.shops', [http_service_1.default])
        .service('shopService', ShopSvc)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(109), __webpack_require__(0), __webpack_require__(10), __webpack_require__(3), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, defectType_1, angular, http_service_1, constant_module_1, _) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.services.defectTypes', [http_service_1.default])
        .service('defectTypeService', ["httpService", function (httpService) {
        function getDefectTypesAndClassifications() {
            return httpService.get(constant_module_1.Endpoints.DEFECT_TYPES)
                .then(function (data) {
                var classifications = [];
                var types = [];
                _.forEach(data, function (viewModel) {
                    types.push(new defectType_1.DefectType(viewModel, classifications));
                });
                return {
                    classifications: classifications,
                    types: types
                };
            });
        }
        function getDefectTypesAndClassificationsNoExclusion() {
            return httpService.get(constant_module_1.Endpoints.DEFECT_TYPES_NO_EXCLUSION)
                .then(function (data) {
                var classifications = [];
                var types = [];
                _.forEach(data, function (viewModel) {
                    types.push(new defectType_1.DefectType(viewModel, classifications));
                });
                return {
                    classifications: classifications,
                    types: types
                };
            });
        }
        function getDefectTypesAll() {
            return httpService.get(constant_module_1.Endpoints.DEFECT_TYPES_ALL);
        }
        function getDefectTypeDetails(defectTypeId) {
            var url = constant_module_1.Endpoints.DEFECT_TYPE_DETAILS.replace('{0}', defectTypeId);
            return httpService.get(url);
        }
        function submitDefectType(defectTypeCommand) {
            var url = constant_module_1.Endpoints.DEFECT_TYPE_DETAILS.replace('{0}', defectTypeCommand.id);
            return httpService.post(url, defectTypeCommand);
        }
        function addDefectType(defectTypeCommand) {
            var url = constant_module_1.Endpoints.DEFECT_TYPE_ADD;
            return httpService.post(url, defectTypeCommand);
        }
        function getDefectTypeWareClasses() {
            return httpService.get(constant_module_1.Endpoints.DEFECT_TYPE_WARE_CLASS);
        }
        return {
            getDefectTypesAll: getDefectTypesAll,
            getDefectTypesAndClassifications: getDefectTypesAndClassifications,
            getDefectTypesAndClassificationsNoExclusion: getDefectTypesAndClassificationsNoExclusion,
            getDefectTypeDetails: getDefectTypeDetails,
            submitDefectType: submitDefectType,
            addDefectType: addDefectType,
            getDefectTypeWareClasses: getDefectTypeWareClasses
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(5), __webpack_require__(0), __webpack_require__(2), __webpack_require__(286), __webpack_require__(3), __webpack_require__(37), __webpack_require__(10), __webpack_require__(23), __webpack_require__(33)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, aps_enums_1, angular, _, lineCounts_1, constant_module_1, hub_service_1, http_service_1, shops_service_1, equipment_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [hub_service_1.default, http_service_1.default, lineCounts_1.default, shops_service_1.default, equipment_service_1.default];
    exports.default = angular
        .module('aps.services.counts', requires)
        .service('countsService', ["httpService", "$q", "$timeout", "$window", "hubService", "lineCountsService", "shopService", "equipmentService", function (httpService, $q, $timeout, $window, hubService, lineCountsService, shopService, equipmentService) {
        var lastRefresh = {};
        function getUsePercentGobs(plant) {
            var userVal = getUsePercentGobsForPlantId(plant.id);
            if (userVal !== null) {
                return userVal;
            }
            return plant.countRejectPercent === aps_enums_1.apsEnums.CountRejectPercent.PercentOfGobsProduced;
        }
        function getUsePercentGobsForPlantId(plantId) {
            var userVal = $window.localStorage.getItem(plantId);
            if (userVal !== null) {
                return userVal === 'true';
            }
            return null;
        }
        function setUsePercentGobs(plantId, usePercentGobs) {
            $window.localStorage.setItem(plantId, usePercentGobs.toString());
        }
        function getCounts(shopId) {
            return httpService.get(constant_module_1.Endpoints.COUNTS, { shopId: shopId });
        }
        function getDetailedCounts(shopId, lineEquipmentId) {
            return httpService.get(constant_module_1.Endpoints.COUNTS_DETAIL, { shopId: shopId, lineEquipmentId: lineEquipmentId });
        }
        function getGroupDetailedCounts(shopId, types) {
            return httpService.get(constant_module_1.Endpoints.COUNTS_GROUP_DETAIL, { shopId: shopId, types: types });
        }
        function getLines(shopId) {
            return httpService.get(constant_module_1.Endpoints.LINE_CONFIG, { shopId: shopId });
        }
        function getLineCounts(shopId, plant, countsInterval, canDisable, isCountV2, iscalcGroupByShears) {
            return $q.all([getLines(shopId), getCounts(shopId), shopService.getShopConfiguration(shopId)]).then(function (results) {
                var lines = results[0];
                var counts = results[1];
                var shopConfig = results[2];
                return lineCountsService.createLineCounts(lines, counts, plant, countsInterval, canDisable, shopConfig, isCountV2, iscalcGroupByShears);
            });
        }
        function getEquipmentCounts(shopId, lineCounts, equipment, countsInterval) {
            return getDetailedCounts(shopId, equipment.id)
                .then(function (results) {
                return lineCountsService.createLineEquipmentCounts(results.tabs, lineCounts, equipment.detailDataPoints, results.counts, countsInterval, equipment, null);
            });
        }
        function getGroupEquipmentCounts(shopId, lineCounts, equipmentGroup, countsInterval) {
            return getGroupDetailedCounts(shopId, equipmentGroup.types)
                .then(function (results) {
                if (results.equipmentTabs && Object.keys(results.equipmentTabs).length > 0) {
                    equipmentGroup.lineLineEquipmentTabs = results.equipmentTabs;
                }
                var details = [];
                for (var id in equipmentGroup.equipment) {
                    var equipment = equipmentGroup.equipment[id];
                    if (equipment.detailDataPoints.length > 0) {
                        details.push.apply(details, equipment.detailDataPoints);
                    }
                }
                return lineCountsService.createLineEquipmentCounts(results.tabs, lineCounts, details, results.counts, countsInterval, null, equipmentGroup);
            });
        }
        function getGroupRejectCounts(shopId, equipmentGroup, startTime, endTime) {
            return httpService.get(constant_module_1.Endpoints.COUNTS_GROUP_REJECTS, {
                shopId: shopId,
                names: equipmentGroup.names,
                startTime: startTime,
                endTime: endTime
            });
        }
        function getDumpGateTimeCount(plantId, shopId, countInterval) {
            return httpService.get(constant_module_1.Endpoints.DUMPGATETIME_COUNT, {
                plantId: plantId,
                shopId: shopId,
                countInterval: countInterval
            });
        }
        function refreshModel(shopId, model) {
            return $q.all([getCounts(shopId), shopService.getShopConfiguration(shopId)]).then(function (results) {
                var counts = results[0];
                var shopConfig = results[1];
                model.updateCounts(counts, shopConfig);
                if (model.currentDetailCounts) {
                    if (model.currentDetailCounts.equipment) {
                        getDetailedCounts(shopId, model.currentDetailCounts.equipment.id).then(function (equipmentCounts) {
                            model.currentDetailCounts.updateCounts(equipmentCounts.counts, shopConfig);
                        });
                    }
                    else {
                        getGroupDetailedCounts(shopId, model.currentDetailCounts.group.types).then(function (equipmentCounts) {
                            model.currentDetailCounts.updateCounts(equipmentCounts.counts, shopConfig);
                        });
                    }
                }
            });
        }
        function refreshModelIfEligible(endDate, shopId, model) {
            var endTime = endDate.getTime();
            if (endTime <= lastRefresh[shopId]) {
                return;
            }
            lastRefresh[shopId] = endTime;
            $timeout(function () {
                refreshModel(shopId, model);
            }, 5000, false);
        }
        function onCountAdded(event, model) {
            $timeout(function () {
                model.handleCount(event);
            });
        }
        function onIntervalAdded(event, model) {
            $timeout(function () {
                model.handleInterval(event);
            });
            if (_.some(event.buckets, function (e) { return e.interval === aps_enums_1.apsEnums.CountInterval.Hour
                || (e.interval === aps_enums_1.apsEnums.CountInterval.TenMinutes && e.intervalEnd.getMinutes() !== 0); })) {
                refreshModelIfEligible(event.buckets[0].intervalEnd, event.shopId, model);
            }
        }
        function onEquipmentHealthUpdated(event, model) {
            $timeout(function () {
                model.handleEquipmentHealthUpdate(event);
            });
        }
        function inconsistentEquipmentConfigurationChanged(event, model) {
            $timeout(function () {
                model.handleInconsistencyChanged(event);
            });
        }
        function createHub(shopId, model) {
            lastRefresh[shopId] = new Date().getTime();
            return hubService.createHub('count', {
                listeners: {
                    countAdded: function (event) {
                        if (onCountAdded && event.shopId === shopId) {
                            onCountAdded(event, model);
                        }
                    },
                    intervalAdded: function (event) {
                        if (onIntervalAdded && event.shopId === shopId) {
                            onIntervalAdded(event, model);
                        }
                    },
                    equipmentHealthUpdated: function (event) {
                        onEquipmentHealthUpdated(event, model);
                    },
                    inconsistentEquipmentConfigurationChanged: function (event) {
                        inconsistentEquipmentConfigurationChanged(event, model);
                    }
                },
                methods: ['leaveGroup', 'joinGroup'],
                postConnect: function (hub) {
                    hub.invokeWithRetry(function () { return hub.joinGroup(shopId); });
                }
            });
        }
        function getEquipmentInconsistencies(shopId, equipmentId, lineConfig) {
            return equipmentService.getShop(shopId).then(function (equipmentResult) {
                var equipmentType = _.find(equipmentResult, { id: equipmentId }).type;
                return httpService.get(constant_module_1.Endpoints.LINE_CONFIG_EQUIPMENT_INCONSISTENCIES, {
                    shopId: shopId, equipmentType: equipmentType
                })
                    .then(function (result) {
                    var inconsistencies = [];
                    if (result) {
                        (result).forEach(function (item) {
                            var inconsistency = {};
                            inconsistency.inconsistencies = [];
                            var nodePath = [];
                            while (item.node.parent !== null) {
                                nodePath.push("" + item.node.name + (item.node.id ? " " + item.node.id : ''));
                                item.node = item.node.parent;
                            }
                            inconsistency.node = (nodePath.length > 0
                                ? nodePath.reverse().toString().replace(',', ' ')
                                : '') + " " + item.attribute;
                            for (var detail = 0; detail < item.detail.length; detail++) {
                                var detailItem = item.detail[detail];
                                var detailEquipment = _.find(equipmentResult, { id: detailItem.equipmentId });
                                if (!detailEquipment) {
                                    detailEquipment = {
                                        id: detailItem.equipmentId,
                                        name: null
                                    };
                                }
                                var lineName = null;
                                for (var line = 0; line < lineConfig.lines.length; line++) {
                                    var lineItem = lineConfig.lines[line];
                                    var equipmentInstance = _.find(lineItem.equipment, { equipmentId: detailItem.equipmentId });
                                    if (equipmentInstance) {
                                        lineName = equipmentInstance.name + "-" + lineItem.name;
                                        break;
                                    }
                                }
                                var isRemoved = false;
                                if (!lineName) {
                                    lineName = '(Equipment Removed)';
                                    isRemoved = true;
                                }
                                inconsistency.inconsistencies.push({
                                    lineName: lineName,
                                    value: detailItem.value
                                        ? detailItem.value
                                        : isRemoved
                                            ? null
                                            : 'Missing'
                                });
                            }
                            inconsistencies.push(inconsistency);
                        });
                    }
                    return inconsistencies;
                });
            });
        }
        function getShopCountSummary(shopId, startDate, endDate, byShift) {
            if (byShift) {
                return httpService.get(constant_module_1.Endpoints.SHOP_COUNT_SUMMARY_DEFECTS, {
                    shopId: shopId,
                    startDate: startDate,
                    endDate: endDate,
                    byShift: byShift
                });
            }
            return httpService.get(constant_module_1.Endpoints.SHOP_COUNT_SUMMARY, {
                shopId: shopId,
                startDate: startDate,
                endDate: endDate
            });
        }
        function getCavityEfficiency(shopId, startTime, endTime) {
            return httpService.get(constant_module_1.Endpoints.CAVITY_EFFICIENCY, { shopId: shopId, startTime: startTime, endTime: endTime });
        }
        function getCavityCorrelation(shopId, startTime, endTime) {
            return httpService.get(constant_module_1.Endpoints.CAVITY_CORRELATION, { shopId: shopId, startTime: startTime, endTime: endTime });
        }
        function getCavityCounts(shopId, types, startTime, endTime) {
            return httpService.get(constant_module_1.Endpoints.COUNTS_CAVITY, {
                shopId: shopId,
                types: types,
                startTime: startTime,
                endTime: endTime
            });
        }
        function getByDatapointId(dataPointId, startDate, endDate, overrideInterval) {
            return httpService.get(constant_module_1.Endpoints.COUNTS_DATA_POINT_HISTORY, {
                dataPointId: dataPointId,
                startDate: startDate,
                endDate: endDate,
                overrideInterval: overrideInterval
            });
        }
        function getByDatapointList(plantLocationId, shopId, dataPoints, startDate, endDate, overrideInterval) {
            return httpService.get(constant_module_1.Endpoints.COUNTS_DATA_POINT_LIST, {
                plantLocationId: plantLocationId,
                shopId: shopId,
                dataPoints: dataPoints,
                startDate: startDate,
                endDate: endDate,
                overrideInterval: overrideInterval
            });
        }
        return {
            getCounts: getCounts,
            getDetailedCounts: getDetailedCounts,
            getGroupDetailedCounts: getGroupDetailedCounts,
            getLineCounts: getLineCounts,
            getEquipmentCounts: getEquipmentCounts,
            getGroupEquipmentCounts: getGroupEquipmentCounts,
            getLines: getLines,
            getDumpGateTimeCount: getDumpGateTimeCount,
            refreshModel: refreshModel,
            createHub: createHub,
            getEquipmentInconsistencies: getEquipmentInconsistencies,
            getShopCountSummary: getShopCountSummary,
            getCavityEfficiency: getCavityEfficiency,
            getCavityCorrelation: getCavityCorrelation,
            getGroupRejectCounts: getGroupRejectCounts,
            getCavityCounts: getCavityCounts,
            getByDatapointId: getByDatapointId,
            getByDatapointList: getByDatapointList,
            getUsePercentGobsForPlantId: getUsePercentGobsForPlantId,
            getUsePercentGobs: getUsePercentGobs,
            setUsePercentGobs: setUsePercentGobs
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// AUTO-GENERATED CODE. DO NOT MODIFY!
exports.__esModule = true;
var apsDisplayEnums;
(function (apsDisplayEnums) {
    var CountDisplayInterval;
    (function (CountDisplayInterval) {
        CountDisplayInterval[CountDisplayInterval["Last24Hours"] = 0] = "Last 24 Hours";
        CountDisplayInterval[CountDisplayInterval["CurrentHour"] = 1] = "Current Hour";
        CountDisplayInterval[CountDisplayInterval["PreviousHour"] = 2] = "Previous Hour";
        CountDisplayInterval[CountDisplayInterval["CurrentShift"] = 3] = "Current Shift";
        CountDisplayInterval[CountDisplayInterval["LastShift"] = 4] = "Shift -1";
        CountDisplayInterval[CountDisplayInterval["ShiftBeforeLast"] = 5] = "Shift -2";
        CountDisplayInterval[CountDisplayInterval["RollingHour"] = 6] = "Rolling Hour";
        CountDisplayInterval[CountDisplayInterval["LastTwentyMinutes"] = 7] = "Rolling 20 Min";
    })(CountDisplayInterval = apsDisplayEnums.CountDisplayInterval || (apsDisplayEnums.CountDisplayInterval = {}));
})(apsDisplayEnums = exports.apsDisplayEnums || (exports.apsDisplayEnums = {}));

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [http_service_1.default];
    exports.default = angular
        .module('aps.services.lineConfigs', requires)
        .service('lineConfigsService', ["httpService", function (httpService) {
        var getLines = function (shopId) {
            return httpService.get(constant_module_1.Endpoints.LINE_CONFIG, {
                shopId: shopId
            });
        };
        var setEquipment = function (equipment, line) {
            equipment.canMoveLeft = equipment.order > _.min(_.map(line.equipment, 'order'));
            equipment.canMoveRight = equipment.order < _.max(_.map(line.equipment, 'order'));
        };
        var updateEquipment = function (line) {
            line.equipment = _.sortBy(line.equipment, 'order');
            line.equipment.forEach(function (equipment) {
                setEquipment(equipment, line);
            });
        };
        var populateEquipment = function (lines) {
            var equipments = {};
            lines.forEach(function (line) {
                line.equipment = _.sortBy(line.equipment, 'order');
                line.equipment.forEach(function (equipment) {
                    setEquipment(equipment, line);
                    equipments[equipment.id] = equipment;
                });
            });
            return equipments;
        };
        var populateLineJunctions = function (shopLines) {
            var lines = shopLines.lines;
            var junctions = shopLines.junctions;
            junctions.forEach(function (junction) {
                junction.inputs = lines.filter(function (line) { return line.endJunctionId === junction.id; });
                junction.inputs.forEach(function (line) { return line.endJunction = junction; });
                junction.outputs = lines.filter(function (line) { return line.startJunctionId === junction.id; });
                junction.outputs.forEach(function (line) { return line.startJunction = junction; });
            });
            var equipment = populateEquipment(lines);
            return {
                lines: lines,
                junctions: junctions,
                equipment: equipment,
                wellKnownMeasures: shopLines.wellKnownMeasures,
                inconsistentEquipmentConfigurations: shopLines.inconsistentEquipmentConfigurations
            };
        };
        var getLineConfiguration = function (shopId) {
            return getLines(shopId).then(function (lines) {
                return populateLineJunctions(lines);
            });
        };
        var addLine = function (line) {
            return httpService.post(constant_module_1.Endpoints.LINE_CONFIG, line);
        };
        var updateLine = function (line) {
            return httpService.put(constant_module_1.Endpoints.LINE_CONFIG, line);
        };
        var addLineEquipment = function (lineEquipment) {
            return httpService.post(constant_module_1.Endpoints.LINE_CONFIG_EQUIPMENT, lineEquipment);
        };
        var updateLineEquipment = function (lineEquipment) {
            return httpService.put(constant_module_1.Endpoints.LINE_CONFIG_EQUIPMENT, lineEquipment);
        };
        var addLineJunction = function (lineJunction) {
            return httpService.post(constant_module_1.Endpoints.LINE_CONFIG_JUNCTION, lineJunction);
        };
        var updateLineJunction = function (lineJunction) {
            return httpService.put(constant_module_1.Endpoints.LINE_CONFIG_JUNCTION, lineJunction);
        };
        var removeLine = function (line) {
            return httpService.delete(constant_module_1.Endpoints.LINE_CONFIG + '/' + line.id, { shopId: line.shopId });
        };
        var removeLineEquipment = function (lineEquipment) {
            return httpService.delete(constant_module_1.Endpoints.LINE_CONFIG_EQUIPMENT + '/' + lineEquipment.id, { shopId: lineEquipment.shopId });
        };
        var removeLineJunction = function (lineJunction) {
            return httpService.delete(constant_module_1.Endpoints.LINE_CONFIG_JUNCTION + '/' + lineJunction.id, { shopId: lineJunction.shopId });
        };
        var getLineEquipmentNames = function () {
            return httpService.get(constant_module_1.Endpoints.LINE_CONFIG_EQUIPMENT_NAME);
        };
        var toggleLine = function (line) {
            return httpService.put(constant_module_1.Endpoints.LINE_CONFIG_TOGGLE, line);
        };
        var toggleLineEquipment = function (lineEquipment) {
            return httpService.put(constant_module_1.Endpoints.LINE_CONFIG_EQUIPMENT_TOGGLE, lineEquipment);
        };
        var addLineEquipmentName = function (lineEquipmentName) {
            return httpService.post(constant_module_1.Endpoints.LINE_EQUIPMENT_NAME, lineEquipmentName);
        };
        var updateLineEquipmentName = function (lineEquipmentName) {
            return httpService.put(constant_module_1.Endpoints.LINE_EQUIPMENT_NAME, lineEquipmentName);
        };
        var removeLineEquipmentName = function (lineEquipmentName) {
            return httpService.delete(constant_module_1.Endpoints.LINE_EQUIPMENT_NAME + '/' + lineEquipmentName.id);
        };
        var reorderLineEquipment = function (lineEquipment) {
            return httpService.put(constant_module_1.Endpoints.LINE_CONFIG_EQUIPMENT_REORDER, lineEquipment);
        };
        return {
            getLineConfiguration: getLineConfiguration,
            addLine: addLine,
            updateLine: updateLine,
            addLineEquipment: addLineEquipment,
            updateLineEquipment: updateLineEquipment,
            addLineJunction: addLineJunction,
            updateLineJunction: updateLineJunction,
            removeLine: removeLine,
            removeLineEquipment: removeLineEquipment,
            removeLineJunction: removeLineJunction,
            getLineEquipmentNames: getLineEquipmentNames,
            toggleLine: toggleLine,
            toggleLineEquipment: toggleLineEquipment,
            addLineEquipmentName: addLineEquipmentName,
            updateLineEquipmentName: updateLineEquipmentName,
            removeLineEquipmentName: removeLineEquipmentName,
            reorderLineEquipment: reorderLineEquipment,
            updateEquipment: updateEquipment
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(7), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, http_service_1, authData_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [http_service_1.default, authData_service_1.default];
    exports.default = angular
        .module('aps.services.checkLists', requires)
        .service('checkListsService', ["httpService", "authDataService", function (httpService, authDataService) {
        var getCheckList = function (id) {
            return httpService
                .get(constant_module_1.Endpoints.CHECKLIST + '/' + id)
                .then(function (data) {
                return data;
            });
        };
        var getCheckListToFillOut = function (id, plantId, shopId) {
            return httpService
                .get(constant_module_1.Endpoints.CHECKLIST + '/' + id, { plantId: plantId, shopId: shopId })
                .then(function (data) {
                return data;
            });
        };
        var getCheckLists = function (plantId, shopId, level, includeDeleted) {
            return httpService
                .get(constant_module_1.Endpoints.CHECKLIST, {
                plantId: plantId || '',
                shopId: shopId || '',
                level: level,
                includeDeleted: includeDeleted
            })
                .then(function (data) {
                return data;
            });
        };
        var addCheckList = function (command) {
            return httpService.post(constant_module_1.Endpoints.CHECKLIST, command);
        };
        var saveCheckList = function (command) {
            return httpService.put(constant_module_1.Endpoints.CHECKLIST, command);
        };
        var copyCheckList = function (command) {
            return httpService.post(constant_module_1.Endpoints.CHECKLIST_COPY, command);
        };
        var deleteCheckList = function (id) {
            return httpService.delete(constant_module_1.Endpoints.CHECKLIST + '/' + id);
        };
        var deleteCheck = function (command) {
            return httpService.delete(constant_module_1.Endpoints.CHECK + '/' + command.id, { checkListId: command.checkListId });
        };
        var addCheck = function (command) {
            return httpService.post(constant_module_1.Endpoints.CHECK, command);
        };
        var saveCheck = function (command) {
            return httpService.put(constant_module_1.Endpoints.CHECK, command);
        };
        var reorderCheck = function (command) {
            return httpService.post(constant_module_1.Endpoints.CHECK_REORDER, command);
        };
        var saveOverride = function (command) {
            return httpService.post(constant_module_1.Endpoints.CHECKLIST_OVERRIDE, command);
        };
        var saveCheckOverride = function (command) {
            return httpService.post(constant_module_1.Endpoints.CHECK_OVERRIDE, command);
        };
        var getCheckListReport = function (criteria) {
            return httpService.post(constant_module_1.Endpoints.CHECKLIST_REPORT, criteria);
        };
        var getCheckListsWithData = function (criteria) {
            return httpService.post(constant_module_1.Endpoints.CHECKLIST_REPORT_LISTS, criteria);
        };
        var getCheckListReportDetail = function (id, plantLocationId, scheduledOn, filter) {
            return httpService.get(constant_module_1.Endpoints.CHECKLIST_REPORT_DETAIL + '/' + id, {
                plantLocationId: plantLocationId,
                scheduledOn: scheduledOn,
                filter: filter
            });
        };
        var getHourlyCheckReport = function (plantId, wellKnownCheck, numHours) {
            var params = {
                plantId: plantId,
                wellKnownCheck: wellKnownCheck,
                numHours: numHours
            };
            return httpService.get(constant_module_1.Endpoints.CHECKLIST_REPORT_HOURLY, params);
        };
        var getLastValue = function (plantId, shopId, wellKnownCheck) {
            var params = {
                plantId: plantId,
                shopId: shopId,
                wellKnownCheck: wellKnownCheck
            };
            return httpService.get(constant_module_1.Endpoints.CHECKLIST_LAST_RESULT, params);
        };
        var getCheckListMandatory = function (id, plantId, shopId) {
            return httpService
                .get(constant_module_1.Endpoints.CHECKLIST_MANDATORY + '/' + id, { plantId: plantId, shopId: shopId });
        };
        var resubmitUptimeChecks = function (command) {
            return httpService.post(constant_module_1.Endpoints.CHECKLIST_RESUBMIT_TONNAGE_CHECKS, command);
        };
        return {
            getCheckList: getCheckList,
            getCheckListToFillOut: getCheckListToFillOut,
            getCheckLists: getCheckLists,
            getCheckListMandatory: getCheckListMandatory,
            addCheckList: addCheckList,
            saveCheckList: saveCheckList,
            copyCheckList: copyCheckList,
            deleteCheckList: deleteCheckList,
            addCheck: addCheck,
            saveCheck: saveCheck,
            deleteCheck: deleteCheck,
            reorderCheck: reorderCheck,
            saveOverride: saveOverride,
            getCheckListReport: getCheckListReport,
            getHourlyCheckReport: getHourlyCheckReport,
            getLastValue: getLastValue,
            saveCheckOverride: saveCheckOverride,
            getCheckListReportDetail: getCheckListReportDetail,
            getCheckListsWithData: getCheckListsWithData,
            resubmitUptimeChecks: resubmitUptimeChecks
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(5), __webpack_require__(0), __webpack_require__(2), __webpack_require__(7), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, aps_enums_1, angular, _, authData_service_1, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [authData_service_1.default, http_service_1.default];
    var CheckListInstancesSvcImpl = (function () {
        CheckListInstancesSvcImpl.$inject = ["httpService", "authDataService"];
        function CheckListInstancesSvcImpl(httpService, authDataService) {
            this.httpService = httpService;
            this.authDataService = authDataService;
        }
        CheckListInstancesSvcImpl.prototype.deleteCheckListInstance = function (instance) {
            return this.httpService.delete(constant_module_1.Endpoints.CHECKLIST_INSTANCE + '/' + instance.id, {
                plantLocationId: instance.plantLocationId,
                scheduledOn: instance.scheduledOn
            });
        };
        CheckListInstancesSvcImpl.prototype.saveCheckListInstance = function (instance) {
            return this.httpService.put(constant_module_1.Endpoints.CHECKLIST_INSTANCE, instance);
        };
        CheckListInstancesSvcImpl.prototype.getCheckListInstance = function (id, plantLocationId, scheduledOn) {
            return this.httpService.get(constant_module_1.Endpoints.CHECKLIST_INSTANCE + '/' + id, { plantLocationId: plantLocationId, scheduledOn: scheduledOn });
        };
        CheckListInstancesSvcImpl.prototype.getWellKnownCheckListInstance = function (shopId, checkList, scheduledOn) {
            return this.httpService.get(constant_module_1.Endpoints.CHECKLIST_WELLKNOWN, { shopId: shopId, checkList: checkList, scheduledOn: scheduledOn });
        };
        CheckListInstancesSvcImpl.prototype.getScheduledCheckListInstances = function (plantId, shopId, roleId, checkListView, viewAll) {
            return this.httpService.get(constant_module_1.Endpoints.CHECKLIST_INSTANCE, {
                plantId: plantId,
                shopId: shopId,
                roleId: roleId,
                checkListView: checkListView,
                viewAll: viewAll
            });
        };
        CheckListInstancesSvcImpl.prototype.getCheckListInstancesOnDate = function (shopId, viewAll, scheduledOn) {
            return this.httpService.get(constant_module_1.Endpoints.CHECKLIST_INSTANCE, {
                shopId: shopId,
                viewAll: viewAll,
                scheduledOn: scheduledOn
            });
        };
        CheckListInstancesSvcImpl.prototype.getByRole = function (plantId, shopId, roleId, checkListView, viewAll) {
            return this.httpService.get(constant_module_1.Endpoints.CHECKLIST_INSTANCE, {
                plantId: plantId,
                shopId: shopId,
                roleId: roleId,
                checkListView: checkListView,
                viewAll: viewAll || false
            });
        };
        CheckListInstancesSvcImpl.prototype.getUnfinishedInstances = function (plantId, shopId) {
            return this.httpService.get(constant_module_1.Endpoints.CHECKLIST_INSTANCE_UNFINISHED, {
                plantId: plantId,
                shopId: shopId
            });
        };
        CheckListInstancesSvcImpl.prototype.getRecentInstances = function (plantId, shopId, roleId, viewAll) {
            return this.httpService.get(constant_module_1.Endpoints.CHECKLIST_INSTANCE_RECENT, {
                plantId: plantId,
                shopId: shopId,
                roleId: roleId,
                viewAll: viewAll
            });
        };
        CheckListInstancesSvcImpl.prototype.getFailedChecksForShop = function (shopId) {
            return this.httpService.get(constant_module_1.Endpoints.CHECKS_FAILED_FOR_SHOP + shopId);
        };
        CheckListInstancesSvcImpl.prototype.getFailedChecksForPlant = function (plantId) {
            return this.httpService.get(constant_module_1.Endpoints.CHECKS_FAILED_FOR_PLANT + plantId);
        };
        CheckListInstancesSvcImpl.prototype.signOff = function (command) {
            return this.httpService.post(constant_module_1.Endpoints.CHECKLIST_INSTANCE_SIGNOFF, command);
        };
        CheckListInstancesSvcImpl.prototype.wellKnownCreate = function (command) {
            return this.httpService.post(constant_module_1.Endpoints.CHECKLIST_WELLKNOWNCREATE, command);
        };
        CheckListInstancesSvcImpl.prototype.isAuthorizedForCurrentPlant = function (instance) {
            var loc = this.authDataService.getSelectedRoleLocation();
            return !loc.role.roleRequiresPlants || (loc.plant && this.isAuthorizedForPlant(instance, loc.plant.id));
        };
        CheckListInstancesSvcImpl.prototype.isAuthorizedForPlant = function (instance, plantId) {
            var currentRole = this.authDataService.getSelectedRoleLocation();
            var role = currentRole.role;
            return this.authDataService.isAuthorizedForPlant(plantId)
                && (this.authDataService.isPlantAdmin(plantId)
                    || role.roleId === instance.roleId
                    || _.some(instance.allowableRoles, function (r) { return r === role.roleId; }));
        };
        CheckListInstancesSvcImpl.prototype.updateStatusAndResult = function (instance, command) {
            if (!command) {
                return;
            }
            var hasFailure = _.some(command.results, function (r) { return r.status === aps_enums_1.apsEnums.CheckStatus.Failed; });
            var incomplete = _.some(command.results, function (r) { return r.status === aps_enums_1.apsEnums.CheckStatus.NotDone; });
            if (incomplete) {
                if (instance.status < aps_enums_1.apsEnums.CheckListStatus.NotDone) {
                    instance.status = aps_enums_1.apsEnums.CheckListStatus.Partial;
                }
                if (!hasFailure) {
                    instance.result = aps_enums_1.apsEnums.CheckListResult.Incomplete;
                }
                else {
                    instance.result = aps_enums_1.apsEnums.CheckListResult.Fail;
                }
            }
            else {
                instance.status = aps_enums_1.apsEnums.CheckListStatus.Complete;
                if (!hasFailure) {
                    instance.result = aps_enums_1.apsEnums.CheckListResult.Pass;
                }
                else {
                    instance.result = aps_enums_1.apsEnums.CheckListResult.Fail;
                }
            }
        };
        return CheckListInstancesSvcImpl;
    }());
    exports.default = angular
        .module('aps.services.checkListInstances', requires)
        .service('checkListInstancesService', CheckListInstancesSvcImpl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(5), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, aps_enums_1, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var EquipmentSvc = (function () {
        EquipmentSvc.$inject = ["httpService"];
        function EquipmentSvc(httpService) {
            this.httpService = httpService;
        }
        EquipmentSvc.prototype.get = function (plantId) {
            return this.httpService.get(constant_module_1.Endpoints.EQUIPMENT, { plantId: plantId });
        };
        EquipmentSvc.prototype.getScales = function (plantId, shopId) {
            return this.httpService.get(constant_module_1.Endpoints.SCALES, {
                plantId: plantId,
                shopId: shopId
            });
        };
        EquipmentSvc.prototype.add = function (command) {
            return this.httpService.post(constant_module_1.Endpoints.EQUIPMENT, command);
        };
        EquipmentSvc.prototype.updateConfig = function (command) {
            return this.httpService.put(constant_module_1.Endpoints.EQUIPMENT, command);
        };
        EquipmentSvc.prototype.setScaleMode = function (command) {
            return this.httpService.put(constant_module_1.Endpoints.SCALE_MODE, command);
        };
        EquipmentSvc.prototype.activate = function (command) {
            return this.httpService.put(constant_module_1.Endpoints.EQUIPMENT_ACTIVATE, command);
        };
        EquipmentSvc.prototype.disable = function (command) {
            return this.httpService.put(constant_module_1.Endpoints.EQUIPMENT_DISABLE, command);
        };
        EquipmentSvc.prototype.remove = function (command) {
            return this.httpService.delete(constant_module_1.Endpoints.EQUIPMENT + '/' + command.id, { plantId: command.plantId });
        };
        EquipmentSvc.prototype.getValidLocationTypes = function (equipmentType) {
            switch (equipmentType) {
                case aps_enums_1.apsEnums.EquipmentType.SerialConverter:
                    return [aps_enums_1.apsEnums.LocationType.Plant];
                case aps_enums_1.apsEnums.EquipmentType.Scale:
                case aps_enums_1.apsEnums.EquipmentType.WSI:
                case aps_enums_1.apsEnums.EquipmentType.WBF:
                case aps_enums_1.apsEnums.EquipmentType.HEYE:
                case aps_enums_1.apsEnums.EquipmentType.CheckDetector:
                case aps_enums_1.apsEnums.EquipmentType.CBIT:
                case aps_enums_1.apsEnums.EquipmentType.Cyclops:
                    return [aps_enums_1.apsEnums.LocationType.Shop];
                case aps_enums_1.apsEnums.EquipmentType.PLC:
                case aps_enums_1.apsEnums.EquipmentType.AIServer:
                case aps_enums_1.apsEnums.EquipmentType.RaspberryPi:
                case aps_enums_1.apsEnums.EquipmentType.MX4:
                case aps_enums_1.apsEnums.EquipmentType.Multi:
                case aps_enums_1.apsEnums.EquipmentType.Mcal:
                case aps_enums_1.apsEnums.EquipmentType.FlexBC:
                case aps_enums_1.apsEnums.EquipmentType.FlexM:
                case aps_enums_1.apsEnums.EquipmentType.FlexIS:
                case aps_enums_1.apsEnums.EquipmentType.LineServer:
                case aps_enums_1.apsEnums.EquipmentType.KepC:
                case aps_enums_1.apsEnums.EquipmentType.SqlC:
                case aps_enums_1.apsEnums.EquipmentType.PPCScale:
                case aps_enums_1.apsEnums.EquipmentType.SqlM:
                case aps_enums_1.apsEnums.EquipmentType.WSG:
                case aps_enums_1.apsEnums.EquipmentType.WFG:
                    return [
                        aps_enums_1.apsEnums.LocationType.Plant,
                        aps_enums_1.apsEnums.LocationType.Tank,
                        aps_enums_1.apsEnums.LocationType.Shop,
                        aps_enums_1.apsEnums.LocationType.Other,
                    ];
            }
            return [];
        };
        EquipmentSvc.prototype.getLineEquipmentType = function (equipmentType) {
            switch (equipmentType) {
                case aps_enums_1.apsEnums.EquipmentType.WSI:
                    return aps_enums_1.apsEnums.LineEquipmentType.WSI;
                case aps_enums_1.apsEnums.EquipmentType.WBF:
                    return aps_enums_1.apsEnums.LineEquipmentType.WBF;
                case aps_enums_1.apsEnums.EquipmentType.HEYE:
                    return aps_enums_1.apsEnums.LineEquipmentType.HEYE;
                case aps_enums_1.apsEnums.EquipmentType.CheckDetector:
                    return aps_enums_1.apsEnums.LineEquipmentType.CheckDetector;
                case aps_enums_1.apsEnums.EquipmentType.MX4:
                    return aps_enums_1.apsEnums.LineEquipmentType.MX4;
                case aps_enums_1.apsEnums.EquipmentType.Multi:
                    return aps_enums_1.apsEnums.LineEquipmentType.Multi;
                case aps_enums_1.apsEnums.EquipmentType.Mcal:
                    return aps_enums_1.apsEnums.LineEquipmentType.Mcal;
                case aps_enums_1.apsEnums.EquipmentType.FlexBC:
                    return aps_enums_1.apsEnums.LineEquipmentType.FlexBC;
                case aps_enums_1.apsEnums.EquipmentType.FlexM:
                    return aps_enums_1.apsEnums.LineEquipmentType.FlexM;
                case aps_enums_1.apsEnums.EquipmentType.FlexIS:
                    return aps_enums_1.apsEnums.LineEquipmentType.FlexIS;
                default:
                    return null;
            }
        };
        EquipmentSvc.prototype.getShop = function (shopId) {
            return this.httpService.get(constant_module_1.Endpoints.EQUIPMENT_SHOP, { shopId: shopId });
        };
        return EquipmentSvc;
    }());
    exports.default = angular
        .module('aps.services.equipment', [http_service_1.default])
        .service('equipmentService', EquipmentSvc)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 Highstock JS v7.2.2 (2020-08-24)

 (c) 2009-2018 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(R,K){"object"===typeof module&&module.exports?(K["default"]=K,module.exports=R.document?K(R):K): true?!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return K(R)}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):(R.Highcharts&&R.Highcharts.error(16,!0),R.Highcharts=K(R))})("undefined"!==typeof window?window:this,function(R){function K(c,e,I,G){c.hasOwnProperty(e)||(c[e]=G.apply(null,I))}var D={};K(D,"parts/Globals.js",[],function(){var c="undefined"!==typeof R?R:"undefined"!==typeof window?window:{},e=c.document,
I=c.navigator&&c.navigator.userAgent||"",G=e&&e.createElementNS&&!!e.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect,H=/(edge|msie|trident)/i.test(I)&&!c.opera,z=-1!==I.indexOf("Firefox"),t=-1!==I.indexOf("Chrome"),x=z&&4>parseInt(I.split("Firefox/")[1],10);return{product:"Highcharts",version:"7.2.2",deg2rad:2*Math.PI/360,doc:e,hasBidiBug:x,hasTouch:!!c.TouchEvent,isMS:H,isWebKit:-1!==I.indexOf("AppleWebKit"),isFirefox:z,isChrome:t,isSafari:!t&&-1!==I.indexOf("Safari"),isTouchDevice:/(Mobile|Android|Windows Phone)/.test(I),
SVG_NS:"http://www.w3.org/2000/svg",chartCount:0,seriesTypes:{},symbolSizes:{},svg:G,win:c,marginNames:["plotTop","marginRight","marginBottom","plotLeft"],noop:function(){},charts:[],dateFormats:{}}});K(D,"parts/Utilities.js",[D["parts/Globals.js"]],function(c){function e(b,a){return parseInt(b,a||10)}function I(b){return"string"===typeof b}function G(b){b=Object.prototype.toString.call(b);return"[object Array]"===b||"[object Array Iterator]"===b}function H(b,a){return!!b&&"object"===typeof b&&(!a||
!G(b))}function z(b){return H(b)&&"number"===typeof b.nodeType}function t(b){var a=b&&b.constructor;return!(!H(b,!0)||z(b)||!a||!a.name||"Object"===a.name)}function x(b){return"number"===typeof b&&!isNaN(b)&&Infinity>b&&-Infinity<b}function C(b){return"undefined"!==typeof b&&null!==b}function E(b,a,f){var d;I(a)?C(f)?b.setAttribute(a,f):b&&b.getAttribute&&((d=b.getAttribute(a))||"class"!==a||(d=b.getAttribute(a+"Name"))):p(a,function(a,d){b.setAttribute(d,a)});return d}function w(b,a){var d;b||(b=
{});for(d in a)b[d]=a[d];return b}function m(){for(var b=arguments,a=b.length,f=0;f<a;f++){var l=b[f];if("undefined"!==typeof l&&null!==l)return l}}function p(b,a,f){for(var d in b)Object.hasOwnProperty.call(b,d)&&a.call(f||b[d],b[d],d,b)}c.timers=[];var q=c.charts,h=c.doc,a=c.win;c.error=function(b,d,f,l){var F=x(b),h=F?"Highcharts error #"+b+": www.highcharts.com/errors/"+b+"/":b.toString(),r=function(){if(d)throw Error(h);a.console&&console.log(h)};if("undefined"!==typeof l){var n="";F&&(h+="?");
c.objectEach(l,function(b,a){n+="\n"+a+": "+b;F&&(h+=encodeURI(a)+"="+encodeURI(b))});h+=n}f?c.fireEvent(f,"displayError",{code:b,message:h,params:l},r):r()};c.Fx=function(b,a,f){this.options=a;this.elem=b;this.prop=f};c.Fx.prototype={dSetter:function(){var b=this.paths[0],a=this.paths[1],f=[],l=this.now,F=b.length;if(1===l)f=this.toD;else if(F===a.length&&1>l)for(;F--;){var h=parseFloat(b[F]);f[F]=isNaN(h)||"A"===a[F-4]||"A"===a[F-5]?a[F]:l*parseFloat(""+(a[F]-h))+h}else f=a;this.elem.attr("d",f,
null,!0)},update:function(){var b=this.elem,a=this.prop,f=this.now,l=this.options.step;if(this[a+"Setter"])this[a+"Setter"]();else b.attr?b.element&&b.attr(a,f,null,!0):b.style[a]=f+this.unit;l&&l.call(b,f,this)},run:function(b,d,f){var l=this,F=l.options,h=function(b){return h.stopped?!1:l.step(b)},r=a.requestAnimationFrame||function(b){setTimeout(b,13)},n=function(){for(var b=0;b<c.timers.length;b++)c.timers[b]()||c.timers.splice(b--,1);c.timers.length&&r(n)};b!==d||this.elem["forceAnimate:"+this.prop]?
(this.startTime=+new Date,this.start=b,this.end=d,this.unit=f,this.now=this.start,this.pos=0,h.elem=this.elem,h.prop=this.prop,h()&&1===c.timers.push(h)&&r(n)):(delete F.curAnim[this.prop],F.complete&&0===Object.keys(F.curAnim).length&&F.complete.call(this.elem))},step:function(b){var a=+new Date,f=this.options,l=this.elem,h=f.complete,c=f.duration,r=f.curAnim;if(l.attr&&!l.element)b=!1;else if(b||a>=c+this.startTime){this.now=this.end;this.pos=1;this.update();var n=r[this.prop]=!0;p(r,function(b){!0!==
b&&(n=!1)});n&&h&&h.call(l);b=!1}else this.pos=f.easing((a-this.startTime)/c),this.now=this.start+(this.end-this.start)*this.pos,this.update(),b=!0;return b},initPath:function(b,a,f){function d(b){for(B=b.length;B--;){var a="M"===b[B]||"L"===b[B];var k=/[a-zA-Z]/.test(b[B+3]);a&&k&&b.splice(B+1,0,b[B+1],b[B+2],b[B+1],b[B+2])}}function h(b,a){for(;b.length<m;){b[0]=a[m-b.length];var g=b.slice(0,k);[].splice.apply(b,[0,0].concat(g));A&&(g=b.slice(b.length-k),[].splice.apply(b,[b.length,0].concat(g)),
B--)}b[0]="M"}function c(b,a){for(var d=(m-b.length)/k;0<d&&d--;)v=b.slice().splice(b.length/u-k,k*u),v[0]=a[m-k-d*k],g&&(v[k-6]=v[k-2],v[k-5]=v[k-1]),[].splice.apply(b,[b.length/u,0].concat(v)),A&&d--}a=a||"";var r=b.startX,n=b.endX,g=-1<a.indexOf("C"),k=g?7:3,v,B;a=a.split(" ");f=f.slice();var A=b.isArea,u=A?2:1;g&&(d(a),d(f));if(r&&n){for(B=0;B<r.length;B++)if(r[B]===n[0]){var J=B;break}else if(r[0]===n[n.length-r.length+B]){J=B;var L=!0;break}else if(r[r.length-1]===n[n.length-r.length+B]){J=
r.length-B;break}"undefined"===typeof J&&(a=[])}if(a.length&&x(J)){var m=f.length+J*u*k;L?(h(a,f),c(f,a)):(h(f,a),c(a,f))}return[a,f]},fillSetter:function(){c.Fx.prototype.strokeSetter.apply(this,arguments)},strokeSetter:function(){this.elem.attr(this.prop,c.color(this.start).tweenTo(c.color(this.end),this.pos),null,!0)}};c.merge=function(){var b,a=arguments,f={},l=function(b,a){"object"!==typeof b&&(b={});p(a,function(d,g){!H(d,!0)||t(d)||z(d)?b[g]=a[g]:b[g]=l(b[g]||{},d)});return b};!0===a[0]&&
(f=a[1],a=Array.prototype.slice.call(a,2));var h=a.length;for(b=0;b<h;b++)f=l(f,a[b]);return f};c.clearTimeout=function(b){C(b)&&clearTimeout(b)};c.css=function(b,a){c.isMS&&!c.svg&&a&&"undefined"!==typeof a.opacity&&(a.filter="alpha(opacity="+100*a.opacity+")");w(b.style,a)};c.createElement=function(b,a,f,l,F){b=h.createElement(b);var d=c.css;a&&w(b,a);F&&d(b,{padding:"0",border:"none",margin:"0"});f&&d(b,f);l&&l.appendChild(b);return b};c.extendClass=function(b,a){var d=function(){};d.prototype=
new b;w(d.prototype,a);return d};c.pad=function(b,a,f){return Array((a||2)+1-String(b).replace("-","").length).join(f||"0")+b};c.relativeLength=function(b,a,f){return/%$/.test(b)?a*parseFloat(b)/100+(f||0):parseFloat(b)};c.wrap=function(b,a,f){var d=b[a];b[a]=function(){var b=Array.prototype.slice.call(arguments),a=arguments,l=this;l.proceed=function(){d.apply(l,arguments.length?arguments:a)};b.unshift(d);b=f.apply(this,b);l.proceed=null;return b}};c.datePropsToTimestamps=function(b){p(b,function(a,
f){H(a)&&"function"===typeof a.getTime?b[f]=a.getTime():(H(a)||G(a))&&c.datePropsToTimestamps(a)})};c.formatSingle=function(b,a,f){var d=/\.([0-9])/,h=c.defaultOptions.lang;/f$/.test(b)?(f=(f=b.match(d))?f[1]:-1,null!==a&&(a=c.numberFormat(a,f,h.decimalPoint,-1<b.indexOf(",")?h.thousandsSep:""))):a=(f||c.time).dateFormat(b,a);return a};c.format=function(b,a,f){for(var d="{",h=!1,m,r,n,g,k=[],v;b;){d=b.indexOf(d);if(-1===d)break;m=b.slice(0,d);if(h){m=m.split(":");r=m.shift().split(".");g=r.length;
v=a;for(n=0;n<g;n++)v&&(v=v[r[n]]);m.length&&(v=c.formatSingle(m.join(":"),v,f));k.push(v)}else k.push(m);b=b.slice(d+1);d=(h=!h)?"}":"{"}k.push(b);return k.join("")};c.getMagnitude=function(b){return Math.pow(10,Math.floor(Math.log(b)/Math.LN10))};c.normalizeTickInterval=function(b,a,f,l,h){var d=b;f=m(f,1);var r=b/f;a||(a=h?[1,1.2,1.5,2,2.5,3,4,5,6,8,10]:[1,2,2.5,5,10],!1===l&&(1===f?a=a.filter(function(b){return 0===b%1}):.1>=f&&(a=[1/f])));for(l=0;l<a.length&&!(d=a[l],h&&d*f>=b||!h&&r<=(a[l]+
(a[l+1]||a[l]))/2);l++);return d=c.correctFloat(d*f,-Math.round(Math.log(.001)/Math.LN10))};c.stableSort=function(b,a){var d=b.length,l,h;for(h=0;h<d;h++)b[h].safeI=h;b.sort(function(b,d){l=a(b,d);return 0===l?b.safeI-d.safeI:l});for(h=0;h<d;h++)delete b[h].safeI};c.correctFloat=function(b,a){return parseFloat(b.toPrecision(a||14))};c.animObject=function(b){return H(b)?c.merge(b):{duration:b?500:0}};c.timeUnits={millisecond:1,second:1E3,minute:6E4,hour:36E5,day:864E5,week:6048E5,month:24192E5,year:314496E5};
c.numberFormat=function(b,a,f,l){b=+b||0;a=+a;var d=c.defaultOptions.lang,h=(b.toString().split(".")[1]||"").split("e")[0].length,r=b.toString().split("e");if(-1===a)a=Math.min(h,20);else if(!x(a))a=2;else if(a&&r[1]&&0>r[1]){var n=a+ +r[1];0<=n?(r[0]=(+r[0]).toExponential(n).split("e")[0],a=n):(r[0]=r[0].split(".")[0]||0,b=20>a?(r[0]*Math.pow(10,r[1])).toFixed(a):0,r[1]=0)}var g=(Math.abs(r[1]?r[0]:b)+Math.pow(10,-Math.max(a,h)-1)).toFixed(a);h=String(e(g));n=3<h.length?h.length%3:0;f=m(f,d.decimalPoint);
l=m(l,d.thousandsSep);b=(0>b?"-":"")+(n?h.substr(0,n)+l:"");b+=h.substr(n).replace(/(\d{3})(?=\d)/g,"$1"+l);a&&(b+=f+g.slice(-a));r[1]&&0!==+b&&(b+="e"+r[1]);return b};Math.easeInOutSine=function(a){return-.5*(Math.cos(Math.PI*a)-1)};c.getStyle=function(b,d,f){if("width"===d)return d=Math.min(b.offsetWidth,b.scrollWidth),f=b.getBoundingClientRect&&b.getBoundingClientRect().width,f<d&&f>=d-1&&(d=Math.floor(f)),Math.max(0,d-c.getStyle(b,"padding-left")-c.getStyle(b,"padding-right"));if("height"===d)return Math.max(0,
Math.min(b.offsetHeight,b.scrollHeight)-c.getStyle(b,"padding-top")-c.getStyle(b,"padding-bottom"));a.getComputedStyle||c.error(27,!0);if(b=a.getComputedStyle(b,void 0))b=b.getPropertyValue(d),m(f,"opacity"!==d)&&(b=e(b));return b};c.inArray=function(a,d,f){return d.indexOf(a,f)};c.find=Array.prototype.find?function(a,d){return a.find(d)}:function(a,d){var b,l=a.length;for(b=0;b<l;b++)if(d(a[b],b))return a[b]};c.keys=Object.keys;c.offset=function(b){var d=h.documentElement;b=b.parentElement||b.parentNode?
b.getBoundingClientRect():{top:0,left:0};return{top:b.top+(a.pageYOffset||d.scrollTop)-(d.clientTop||0),left:b.left+(a.pageXOffset||d.scrollLeft)-(d.clientLeft||0)}};c.stop=function(a,d){for(var b=c.timers.length;b--;)c.timers[b].elem!==a||d&&d!==c.timers[b].prop||(c.timers[b].stopped=!0)};p({map:"map",each:"forEach",grep:"filter",reduce:"reduce",some:"some"},function(a,d){c[d]=function(b){return Array.prototype[a].apply(b,[].slice.call(arguments,1))}});c.addEvent=function(a,d,f,l){void 0===l&&(l=
{});var b=a.addEventListener||c.addEventListenerPolyfill;var h="function"===typeof a&&a.prototype?a.prototype.protoEvents=a.prototype.protoEvents||{}:a.hcEvents=a.hcEvents||{};c.Point&&a instanceof c.Point&&a.series&&a.series.chart&&(a.series.chart.runTrackerClick=!0);b&&b.call(a,d,f,!1);h[d]||(h[d]=[]);h[d].push({fn:f,order:"number"===typeof l.order?l.order:Infinity});h[d].sort(function(a,b){return a.order-b.order});return function(){c.removeEvent(a,d,f)}};c.removeEvent=function(a,d,f){function b(b,
d){var g=a.removeEventListener||c.removeEventListenerPolyfill;g&&g.call(a,b,d,!1)}function h(f){var l;if(a.nodeName){if(d){var g={};g[d]=!0}else g=f;p(g,function(a,g){if(f[g])for(l=f[g].length;l--;)b(g,f[g][l].fn)})}}var m;["protoEvents","hcEvents"].forEach(function(l,n){var g=(n=n?a:a.prototype)&&n[l];g&&(d?(m=g[d]||[],f?(g[d]=m.filter(function(a){return f!==a.fn}),b(d,f)):(h(g),g[d]=[])):(h(g),n[l]={}))})};c.fireEvent=function(a,d,f,l){var b;f=f||{};if(h.createEvent&&(a.dispatchEvent||a.fireEvent)){var c=
h.createEvent("Events");c.initEvent(d,!0,!0);w(c,f);a.dispatchEvent?a.dispatchEvent(c):a.fireEvent(d,c)}else f.target||w(f,{preventDefault:function(){f.defaultPrevented=!0},target:a,type:d}),function(d,l){void 0===d&&(d=[]);void 0===l&&(l=[]);var g=0,k=0,n=d.length+l.length;for(b=0;b<n;b++)!1===(d[g]?l[k]?d[g].order<=l[k].order?d[g++]:l[k++]:d[g++]:l[k++]).fn.call(a,f)&&f.preventDefault()}(a.protoEvents&&a.protoEvents[d],a.hcEvents&&a.hcEvents[d]);l&&!f.defaultPrevented&&l.call(a,f)};c.animate=function(a,
d,f){var b,h="",m,r;if(!H(f)){var n=arguments;f={duration:n[2],easing:n[3],complete:n[4]}}x(f.duration)||(f.duration=400);f.easing="function"===typeof f.easing?f.easing:Math[f.easing]||Math.easeInOutSine;f.curAnim=c.merge(d);p(d,function(g,k){c.stop(a,k);r=new c.Fx(a,f,k);m=null;"d"===k?(r.paths=r.initPath(a,a.d,d.d),r.toD=d.d,b=0,m=1):a.attr?b=a.attr(k):(b=parseFloat(c.getStyle(a,k))||0,"opacity"!==k&&(h="px"));m||(m=g);m&&m.match&&m.match("px")&&(m=m.replace(/px/g,""));r.run(b,m,h)})};c.seriesType=
function(a,d,f,l,h){var b=c.getOptions(),r=c.seriesTypes;b.plotOptions[a]=c.merge(b.plotOptions[d],f);r[a]=c.extendClass(r[d]||function(){},l);r[a].prototype.type=a;h&&(r[a].prototype.pointClass=c.extendClass(c.Point,h));return r[a]};c.uniqueKey=function(){var a=Math.random().toString(36).substring(2,9),d=0;return function(){return"highcharts-"+a+"-"+d++}}();c.isFunction=function(a){return"function"===typeof a};a.jQuery&&(a.jQuery.fn.highcharts=function(){var a=[].slice.call(arguments);if(this[0])return a[0]?
(new (c[I(a[0])?a.shift():"Chart"])(this[0],a[0],a[1]),this):q[E(this[0],"data-highcharts-chart")]});return{arrayMax:function(a){for(var b=a.length,f=a[0];b--;)a[b]>f&&(f=a[b]);return f},arrayMin:function(a){for(var b=a.length,f=a[0];b--;)a[b]<f&&(f=a[b]);return f},attr:E,defined:C,destroyObjectProperties:function(a,d){p(a,function(b,l){b&&b!==d&&b.destroy&&b.destroy();delete a[l]})},discardElement:function(a){var b=c.garbageBin;b||(b=c.createElement("div"));a&&b.appendChild(a);b.innerHTML=""},erase:function(a,
d){for(var b=a.length;b--;)if(a[b]===d){a.splice(b,1);break}},extend:w,isArray:G,isClass:t,isDOMElement:z,isNumber:x,isObject:H,isString:I,objectEach:p,pick:m,pInt:e,setAnimation:function(a,d){d.renderer.globalAnimation=m(a,d.options.chart.animation,!0)},splat:function(a){return G(a)?a:[a]},syncTimeout:function(a,d,f){if(0<d)return setTimeout(a,d,f);a.call(0,f);return-1}}});K(D,"parts/Color.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,e){var I=e.isNumber,G=e.pInt,H=c.merge;c.Color=
function(e){if(!(this instanceof c.Color))return new c.Color(e);this.init(e)};c.Color.prototype={parsers:[{regex:/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,parse:function(c){return[G(c[1]),G(c[2]),G(c[3]),parseFloat(c[4],10)]}},{regex:/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,parse:function(c){return[G(c[1]),G(c[2]),G(c[3]),1]}}],names:{white:"#ffffff",black:"#000000"},init:function(e){var t,x;if((this.input=e=this.names[e&&
e.toLowerCase?e.toLowerCase():""]||e)&&e.stops)this.stops=e.stops.map(function(e){return new c.Color(e[1])});else{if(e&&e.charAt&&"#"===e.charAt()){var C=e.length;e=parseInt(e.substr(1),16);7===C?t=[(e&16711680)>>16,(e&65280)>>8,e&255,1]:4===C&&(t=[(e&3840)>>4|(e&3840)>>8,(e&240)>>4|e&240,(e&15)<<4|e&15,1])}if(!t)for(x=this.parsers.length;x--&&!t;){var z=this.parsers[x];(C=z.regex.exec(e))&&(t=z.parse(C))}}this.rgba=t||[]},get:function(c){var e=this.input,x=this.rgba;if(this.stops){var C=H(e);C.stops=
[].concat(C.stops);this.stops.forEach(function(e,w){C.stops[w]=[C.stops[w][0],e.get(c)]})}else C=x&&I(x[0])?"rgb"===c||!c&&1===x[3]?"rgb("+x[0]+","+x[1]+","+x[2]+")":"a"===c?x[3]:"rgba("+x.join(",")+")":e;return C},brighten:function(c){var e,x=this.rgba;if(this.stops)this.stops.forEach(function(e){e.brighten(c)});else if(I(c)&&0!==c)for(e=0;3>e;e++)x[e]+=G(255*c),0>x[e]&&(x[e]=0),255<x[e]&&(x[e]=255);return this},setOpacity:function(c){this.rgba[3]=c;return this},tweenTo:function(c,e){var x=this.rgba,
t=c.rgba;t.length&&x&&x.length?(c=1!==t[3]||1!==x[3],e=(c?"rgba(":"rgb(")+Math.round(t[0]+(x[0]-t[0])*(1-e))+","+Math.round(t[1]+(x[1]-t[1])*(1-e))+","+Math.round(t[2]+(x[2]-t[2])*(1-e))+(c?","+(t[3]+(x[3]-t[3])*(1-e)):"")+")"):e=c.input||"none";return e}};c.color=function(e){return new c.Color(e)}});K(D,"parts/SvgRenderer.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,e){var I=e.attr,G=e.defined,H=e.destroyObjectProperties,z=e.erase,t=e.extend,x=e.isArray,C=e.isNumber,E=e.isObject,
w=e.isString,m=e.objectEach,p=e.pick,q=e.pInt,h=e.splat,a=c.addEvent,b=c.animate,d=c.charts,f=c.color,l=c.css,F=c.createElement,y=c.deg2rad,r=c.doc,n=c.hasTouch,g=c.isFirefox,k=c.isMS,v=c.isWebKit,B=c.merge,A=c.noop,u=c.removeEvent,J=c.stop,L=c.svg,U=c.SVG_NS,Q=c.symbolSizes,P=c.win;var M=c.SVGElement=function(){return this};t(M.prototype,{opacity:1,SVG_NS:U,textProps:"direction fontSize fontWeight fontFamily fontStyle color lineHeight width textAlign textDecoration textOverflow textOutline cursor".split(" "),
init:function(a,b){this.element="span"===b?F(b):r.createElementNS(this.SVG_NS,b);this.renderer=a;c.fireEvent(this,"afterInit")},animate:function(a,g,k){var u=c.animObject(p(g,this.renderer.globalAnimation,!0));p(r.hidden,r.msHidden,r.webkitHidden,!1)&&(u.duration=0);0!==u.duration?(k&&(u.complete=k),b(this,a,u)):(this.attr(a,void 0,k),m(a,function(a,b){u.step&&u.step.call(this,a,{prop:b,pos:1})},this));return this},complexColor:function(a,b,g){var k=this.renderer,u,A,d,l,N,f,n,v,h,O,r,J=[],F;c.fireEvent(this.renderer,
"complexColor",{args:arguments},function(){a.radialGradient?A="radialGradient":a.linearGradient&&(A="linearGradient");A&&(d=a[A],N=k.gradients,n=a.stops,O=g.radialReference,x(d)&&(a[A]=d={x1:d[0],y1:d[1],x2:d[2],y2:d[3],gradientUnits:"userSpaceOnUse"}),"radialGradient"===A&&O&&!G(d.gradientUnits)&&(l=d,d=B(d,k.getRadialAttr(O,l),{gradientUnits:"userSpaceOnUse"})),m(d,function(a,b){"id"!==b&&J.push(b,a)}),m(n,function(a){J.push(a)}),J=J.join(","),N[J]?r=N[J].attr("id"):(d.id=r=c.uniqueKey(),N[J]=f=
k.createElement(A).attr(d).add(k.defs),f.radAttr=l,f.stops=[],n.forEach(function(a){0===a[1].indexOf("rgba")?(u=c.color(a[1]),v=u.get("rgb"),h=u.get("a")):(v=a[1],h=1);a=k.createElement("stop").attr({offset:a[0],"stop-color":v,"stop-opacity":h}).add(f);f.stops.push(a)})),F="url("+k.url+"#"+r+")",g.setAttribute(b,F),g.gradient=J,a.toString=function(){return F})})},applyTextOutline:function(a){var b=this.element,g;-1!==a.indexOf("contrast")&&(a=a.replace(/contrast/g,this.renderer.getContrast(b.style.fill)));
a=a.split(" ");var k=a[a.length-1];if((g=a[0])&&"none"!==g&&c.svg){this.fakeTS=!0;a=[].slice.call(b.getElementsByTagName("tspan"));this.ySetter=this.xSetter;g=g.replace(/(^[\d\.]+)(.*?)$/g,function(a,b,g){return 2*b+g});this.removeTextOutline(a);var u=b.firstChild;a.forEach(function(a,A){0===A&&(a.setAttribute("x",b.getAttribute("x")),A=b.getAttribute("y"),a.setAttribute("y",A||0),null===A&&b.setAttribute("y",0));a=a.cloneNode(1);I(a,{"class":"highcharts-text-outline",fill:k,stroke:k,"stroke-width":g,
"stroke-linejoin":"round"});b.insertBefore(a,u)})}},removeTextOutline:function(a){for(var b=a.length,g;b--;)g=a[b],"highcharts-text-outline"===g.getAttribute("class")&&z(a,this.element.removeChild(g))},symbolCustomAttribs:"x y width height r start end innerR anchorX anchorY rounded".split(" "),attr:function(a,b,g,k){var u=this.element,A,d=this,l,f,N=this.symbolCustomAttribs;if("string"===typeof a&&void 0!==b){var n=a;a={};a[n]=b}"string"===typeof a?d=(this[a+"Getter"]||this._defaultGetter).call(this,
a,u):(m(a,function(b,g){l=!1;k||J(this,g);this.symbolName&&-1!==c.inArray(g,N)&&(A||(this.symbolAttr(a),A=!0),l=!0);!this.rotation||"x"!==g&&"y"!==g||(this.doTransform=!0);l||(f=this[g+"Setter"]||this._defaultSetter,f.call(this,b,g,u),!this.styledMode&&this.shadows&&/^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(g)&&this.updateShadows(g,b,f))},this),this.afterSetters());g&&g.call(this);return d},afterSetters:function(){this.doTransform&&(this.updateTransform(),this.doTransform=!1)},updateShadows:function(a,
b,g){for(var k=this.shadows,u=k.length;u--;)g.call(k[u],"height"===a?Math.max(b-(k[u].cutHeight||0),0):"d"===a?this.d:b,a,k[u])},addClass:function(a,b){var g=b?"":this.attr("class")||"";a=(a||"").split(/ /g).reduce(function(a,b){-1===g.indexOf(b)&&a.push(b);return a},g?[g]:[]).join(" ");a!==g&&this.attr("class",a);return this},hasClass:function(a){return-1!==(this.attr("class")||"").split(" ").indexOf(a)},removeClass:function(a){return this.attr("class",(this.attr("class")||"").replace(w(a)?new RegExp(" ?"+
a+" ?"):a,""))},symbolAttr:function(a){var b=this;"x y r start end width height innerR anchorX anchorY clockwise".split(" ").forEach(function(g){b[g]=p(a[g],b[g])});b.attr({d:b.renderer.symbols[b.symbolName](b.x,b.y,b.width,b.height,b)})},clip:function(a){return this.attr("clip-path",a?"url("+this.renderer.url+"#"+a.id+")":"none")},crisp:function(a,b){b=b||a.strokeWidth||0;var g=Math.round(b)%2/2;a.x=Math.floor(a.x||this.x||0)+g;a.y=Math.floor(a.y||this.y||0)+g;a.width=Math.floor((a.width||this.width||
0)-2*g);a.height=Math.floor((a.height||this.height||0)-2*g);G(a.strokeWidth)&&(a.strokeWidth=b);return a},css:function(a){var b=this.styles,g={},k=this.element,u="",A=!b,d=["textOutline","textOverflow","width"];a&&a.color&&(a.fill=a.color);b&&m(a,function(a,k){a!==b[k]&&(g[k]=a,A=!0)});if(A){b&&(a=t(b,g));if(a)if(null===a.width||"auto"===a.width)delete this.textWidth;else if("text"===k.nodeName.toLowerCase()&&a.width)var f=this.textWidth=q(a.width);this.styles=a;f&&!L&&this.renderer.forExport&&delete a.width;
if(k.namespaceURI===this.SVG_NS){var n=function(a,b){return"-"+b.toLowerCase()};m(a,function(a,b){-1===d.indexOf(b)&&(u+=b.replace(/([A-Z])/g,n)+":"+a+";")});u&&I(k,"style",u)}else l(k,a);this.added&&("text"===this.element.nodeName&&this.renderer.buildText(this),a&&a.textOutline&&this.applyTextOutline(a.textOutline))}return this},getStyle:function(a){return P.getComputedStyle(this.element||this,"").getPropertyValue(a)},strokeWidth:function(){if(!this.renderer.styledMode)return this["stroke-width"]||
0;var a=this.getStyle("stroke-width");if(a.indexOf("px")===a.length-2)a=q(a);else{var b=r.createElementNS(U,"rect");I(b,{width:a,"stroke-width":0});this.element.parentNode.appendChild(b);a=b.getBBox().width;b.parentNode.removeChild(b)}return a},on:function(a,b){var g=this,k=g.element;n&&"click"===a?(k.ontouchstart=function(a){g.touchEventFired=Date.now();a.preventDefault();b.call(k,a)},k.onclick=function(a){(-1===P.navigator.userAgent.indexOf("Android")||1100<Date.now()-(g.touchEventFired||0))&&b.call(k,
a)}):k["on"+a]=b;return this},setRadialReference:function(a){var b=this.renderer.gradients[this.element.gradient];this.element.radialReference=a;b&&b.radAttr&&b.animate(this.renderer.getRadialAttr(a,b.radAttr));return this},translate:function(a,b){return this.attr({translateX:a,translateY:b})},invert:function(a){this.inverted=a;this.updateTransform();return this},updateTransform:function(){var a=this.translateX||0,b=this.translateY||0,g=this.scaleX,k=this.scaleY,u=this.inverted,A=this.rotation,d=
this.matrix,l=this.element;u&&(a+=this.width,b+=this.height);a=["translate("+a+","+b+")"];G(d)&&a.push("matrix("+d.join(",")+")");u?a.push("rotate(90) scale(-1,1)"):A&&a.push("rotate("+A+" "+p(this.rotationOriginX,l.getAttribute("x"),0)+" "+p(this.rotationOriginY,l.getAttribute("y")||0)+")");(G(g)||G(k))&&a.push("scale("+p(g,1)+" "+p(k,1)+")");a.length&&l.setAttribute("transform",a.join(" "))},toFront:function(){var a=this.element;a.parentNode.appendChild(a);return this},align:function(a,b,g){var k,
u={};var A=this.renderer;var d=A.alignedObjects;var l,f;if(a){if(this.alignOptions=a,this.alignByTranslate=b,!g||w(g))this.alignTo=k=g||"renderer",z(d,this),d.push(this),g=null}else a=this.alignOptions,b=this.alignByTranslate,k=this.alignTo;g=p(g,A[k],A);k=a.align;A=a.verticalAlign;d=(g.x||0)+(a.x||0);var n=(g.y||0)+(a.y||0);"right"===k?l=1:"center"===k&&(l=2);l&&(d+=(g.width-(a.width||0))/l);u[b?"translateX":"x"]=Math.round(d);"bottom"===A?f=1:"middle"===A&&(f=2);f&&(n+=(g.height-(a.height||0))/
f);u[b?"translateY":"y"]=Math.round(n);this[this.placed?"animate":"attr"](u);this.placed=!0;this.alignAttr=u;return this},getBBox:function(a,b){var g,k=this.renderer,u=this.element,A=this.styles,d=this.textStr,l,f=k.cache,n=k.cacheKeys,N=u.namespaceURI===this.SVG_NS;b=p(b,this.rotation,0);var v=k.styledMode?u&&M.prototype.getStyle.call(u,"font-size"):A&&A.fontSize;if(G(d)){var B=d.toString();-1===B.indexOf("<")&&(B=B.replace(/[0-9]/g,"0"));B+=["",b,v,this.textWidth,A&&A.textOverflow].join()}B&&!a&&
(g=f[B]);if(!g){if(N||k.forExport){try{(l=this.fakeTS&&function(a){[].forEach.call(u.querySelectorAll(".highcharts-text-outline"),function(b){b.style.display=a})})&&l("none"),g=u.getBBox?t({},u.getBBox()):{width:u.offsetWidth,height:u.offsetHeight},l&&l("")}catch(Y){""}if(!g||0>g.width)g={width:0,height:0}}else g=this.htmlGetBBox();k.isSVG&&(a=g.width,k=g.height,N&&(g.height=k={"11px,17":14,"13px,20":16}[A&&A.fontSize+","+Math.round(k)]||k),b&&(A=b*y,g.width=Math.abs(k*Math.sin(A))+Math.abs(a*Math.cos(A)),
g.height=Math.abs(k*Math.cos(A))+Math.abs(a*Math.sin(A))));if(B&&0<g.height){for(;250<n.length;)delete f[n.shift()];f[B]||n.push(B);f[B]=g}}return g},show:function(a){return this.attr({visibility:a?"inherit":"visible"})},hide:function(a){a?this.attr({y:-9999}):this.attr({visibility:"hidden"});return this},fadeOut:function(a){var b=this;b.animate({opacity:0},{duration:a||150,complete:function(){b.attr({y:-9999})}})},add:function(a){var b=this.renderer,g=this.element;a&&(this.parentGroup=a);this.parentInverted=
a&&a.inverted;void 0!==this.textStr&&b.buildText(this);this.added=!0;if(!a||a.handleZ||this.zIndex)var k=this.zIndexSetter();k||(a?a.element:b.box).appendChild(g);if(this.onAdd)this.onAdd();return this},safeRemoveChild:function(a){var b=a.parentNode;b&&b.removeChild(a)},destroy:function(){var a=this,b=a.element||{},g=a.renderer,k=g.isSVG&&"SPAN"===b.nodeName&&a.parentGroup,u=b.ownerSVGElement,A=a.clipPath;b.onclick=b.onmouseout=b.onmouseover=b.onmousemove=b.point=null;J(a);A&&u&&([].forEach.call(u.querySelectorAll("[clip-path],[CLIP-PATH]"),
function(a){-1<a.getAttribute("clip-path").indexOf(A.element.id)&&a.removeAttribute("clip-path")}),a.clipPath=A.destroy());if(a.stops){for(u=0;u<a.stops.length;u++)a.stops[u]=a.stops[u].destroy();a.stops=null}a.safeRemoveChild(b);for(g.styledMode||a.destroyShadows();k&&k.div&&0===k.div.childNodes.length;)b=k.parentGroup,a.safeRemoveChild(k.div),delete k.div,k=b;a.alignTo&&z(g.alignedObjects,a);m(a,function(b,g){a[g]&&a[g].parentGroup===a&&a[g].destroy&&a[g].destroy();delete a[g]})},shadow:function(a,
b,g){var k=[],u,A=this.element;if(!a)this.destroyShadows();else if(!this.shadows){var d=p(a.width,3);var l=(a.opacity||.15)/d;var f=this.parentInverted?"(-1,-1)":"("+p(a.offsetX,1)+", "+p(a.offsetY,1)+")";for(u=1;u<=d;u++){var n=A.cloneNode(0);var v=2*d+1-2*u;I(n,{stroke:a.color||"#000000","stroke-opacity":l*u,"stroke-width":v,transform:"translate"+f,fill:"none"});n.setAttribute("class",(n.getAttribute("class")||"")+" highcharts-shadow");g&&(I(n,"height",Math.max(I(n,"height")-v,0)),n.cutHeight=v);
b?b.element.appendChild(n):A.parentNode&&A.parentNode.insertBefore(n,A);k.push(n)}this.shadows=k}return this},destroyShadows:function(){(this.shadows||[]).forEach(function(a){this.safeRemoveChild(a)},this);this.shadows=void 0},xGetter:function(a){"circle"===this.element.nodeName&&("x"===a?a="cx":"y"===a&&(a="cy"));return this._defaultGetter(a)},_defaultGetter:function(a){a=p(this[a+"Value"],this[a],this.element?this.element.getAttribute(a):null,0);/^[\-0-9\.]+$/.test(a)&&(a=parseFloat(a));return a},
dSetter:function(a,b,g){a&&a.join&&(a=a.join(" "));/(NaN| {2}|^$)/.test(a)&&(a="M 0 0");this[b]!==a&&(g.setAttribute(b,a),this[b]=a)},dashstyleSetter:function(a){var b,g=this["stroke-width"];"inherit"===g&&(g=1);if(a=a&&a.toLowerCase()){a=a.replace("shortdashdotdot","3,1,1,1,1,1,").replace("shortdashdot","3,1,1,1").replace("shortdot","1,1,").replace("shortdash","3,1,").replace("longdash","8,3,").replace(/dot/g,"1,3,").replace("dash","4,3,").replace(/,$/,"").split(",");for(b=a.length;b--;)a[b]=q(a[b])*
g;a=a.join(",").replace(/NaN/g,"none");this.element.setAttribute("stroke-dasharray",a)}},alignSetter:function(a){var b={left:"start",center:"middle",right:"end"};b[a]&&(this.alignValue=a,this.element.setAttribute("text-anchor",b[a]))},opacitySetter:function(a,b,g){this[b]=a;g.setAttribute(b,a)},titleSetter:function(a){var b=this.element.getElementsByTagName("title")[0];b||(b=r.createElementNS(this.SVG_NS,"title"),this.element.appendChild(b));b.firstChild&&b.removeChild(b.firstChild);b.appendChild(r.createTextNode(String(p(a,
"")).replace(/<[^>]*>/g,"").replace(/&lt;/g,"<").replace(/&gt;/g,">")))},textSetter:function(a){a!==this.textStr&&(delete this.bBox,delete this.textPxLength,this.textStr=a,this.added&&this.renderer.buildText(this))},setTextPath:function(a,b){var g=this.element,k={textAnchor:"text-anchor"},u=!1,d=this.textPathWrapper,l=!d;b=B(!0,{enabled:!0,attributes:{dy:-5,startOffset:"50%",textAnchor:"middle"}},b);var f=b.attributes;if(a&&b&&b.enabled){this.options&&this.options.padding&&(f.dx=-this.options.padding);
d||(this.textPathWrapper=d=this.renderer.createElement("textPath"),u=!0);var n=d.element;(b=a.element.getAttribute("id"))||a.element.setAttribute("id",b=c.uniqueKey());if(l)for(a=g.getElementsByTagName("tspan");a.length;)a[0].setAttribute("y",0),n.appendChild(a[0]);u&&d.add({element:this.text?this.text.element:g});n.setAttributeNS("http://www.w3.org/1999/xlink","href",this.renderer.url+"#"+b);G(f.dy)&&(n.parentNode.setAttribute("dy",f.dy),delete f.dy);G(f.dx)&&(n.parentNode.setAttribute("dx",f.dx),
delete f.dx);m(f,function(a,b){n.setAttribute(k[b]||b,a)});g.removeAttribute("transform");this.removeTextOutline.call(d,[].slice.call(g.getElementsByTagName("tspan")));this.text&&!this.renderer.styledMode&&this.attr({fill:"none","stroke-width":0});this.applyTextOutline=this.updateTransform=A}else d&&(delete this.updateTransform,delete this.applyTextOutline,this.destroyTextPath(g,a));return this},destroyTextPath:function(a,b){var g;b.element.setAttribute("id","");for(g=this.textPathWrapper.element.childNodes;g.length;)a.firstChild.appendChild(g[0]);
a.firstChild.removeChild(this.textPathWrapper.element);delete b.textPathWrapper},fillSetter:function(a,b,g){"string"===typeof a?g.setAttribute(b,a):a&&this.complexColor(a,b,g)},visibilitySetter:function(a,b,g){"inherit"===a?g.removeAttribute(b):this[b]!==a&&g.setAttribute(b,a);this[b]=a},zIndexSetter:function(a,b){var g=this.renderer,k=this.parentGroup,u=(k||g).element||g.box,A=this.element,d=!1;g=u===g.box;var l=this.added;var f;G(a)?(A.setAttribute("data-z-index",a),a=+a,this[b]===a&&(l=!1)):G(this[b])&&
A.removeAttribute("data-z-index");this[b]=a;if(l){(a=this.zIndex)&&k&&(k.handleZ=!0);b=u.childNodes;for(f=b.length-1;0<=f&&!d;f--){k=b[f];l=k.getAttribute("data-z-index");var n=!G(l);if(k!==A)if(0>a&&n&&!g&&!f)u.insertBefore(A,b[f]),d=!0;else if(q(l)<=a||n&&(!G(a)||0<=a))u.insertBefore(A,b[f+1]||null),d=!0}d||(u.insertBefore(A,b[g?3:0]||null),d=!0)}return d},_defaultSetter:function(a,b,g){g.setAttribute(b,a)}});M.prototype.yGetter=M.prototype.xGetter;M.prototype.translateXSetter=M.prototype.translateYSetter=
M.prototype.rotationSetter=M.prototype.verticalAlignSetter=M.prototype.rotationOriginXSetter=M.prototype.rotationOriginYSetter=M.prototype.scaleXSetter=M.prototype.scaleYSetter=M.prototype.matrixSetter=function(a,b){this[b]=a;this.doTransform=!0};M.prototype["stroke-widthSetter"]=M.prototype.strokeSetter=function(a,b,g){this[b]=a;this.stroke&&this["stroke-width"]?(M.prototype.fillSetter.call(this,this.stroke,"stroke",g),g.setAttribute("stroke-width",this["stroke-width"]),this.hasStroke=!0):"stroke-width"===
b&&0===a&&this.hasStroke?(g.removeAttribute("stroke"),this.hasStroke=!1):this.renderer.styledMode&&this["stroke-width"]&&(g.setAttribute("stroke-width",this["stroke-width"]),this.hasStroke=!0)};e=c.SVGRenderer=function(){this.init.apply(this,arguments)};t(e.prototype,{Element:M,SVG_NS:U,init:function(b,k,u,A,d,f,n){var B=this.createElement("svg").attr({version:"1.1","class":"highcharts-root"});n||B.css(this.getStyle(A));A=B.element;b.appendChild(A);I(b,"dir","ltr");-1===b.innerHTML.indexOf("xmlns")&&
I(A,"xmlns",this.SVG_NS);this.isSVG=!0;this.box=A;this.boxWrapper=B;this.alignedObjects=[];this.url=(g||v)&&r.getElementsByTagName("base").length?P.location.href.split("#")[0].replace(/<[^>]*>/g,"").replace(/([\('\)])/g,"\\$1").replace(/ /g,"%20"):"";this.createElement("desc").add().element.appendChild(r.createTextNode("Created with Highcharts 7.2.2"));this.defs=this.createElement("defs").add();this.allowHTML=f;this.forExport=d;this.styledMode=n;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=
0;this.setSize(k,u,!1);var h;g&&b.getBoundingClientRect&&(k=function(){l(b,{left:0,top:0});h=b.getBoundingClientRect();l(b,{left:Math.ceil(h.left)-h.left+"px",top:Math.ceil(h.top)-h.top+"px"})},k(),this.unSubPixelFix=a(P,"resize",k))},definition:function(a){function b(a,k){var u;h(a).forEach(function(a){var A=g.createElement(a.tagName),d={};m(a,function(a,b){"tagName"!==b&&"children"!==b&&"textContent"!==b&&(d[b]=a)});A.attr(d);A.add(k||g.defs);a.textContent&&A.element.appendChild(r.createTextNode(a.textContent));
b(a.children||[],A);u=A});return u}var g=this;return b(a)},getStyle:function(a){return this.style=t({fontFamily:'"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',fontSize:"12px"},a)},setStyle:function(a){this.boxWrapper.css(this.getStyle(a))},isHidden:function(){return!this.boxWrapper.getBBox().width},destroy:function(){var a=this.defs;this.box=null;this.boxWrapper=this.boxWrapper.destroy();H(this.gradients||{});this.gradients=null;a&&(this.defs=a.destroy());this.unSubPixelFix&&
this.unSubPixelFix();return this.alignedObjects=null},createElement:function(a){var b=new this.Element;b.init(this,a);return b},draw:A,getRadialAttr:function(a,b){return{cx:a[0]-a[2]/2+b.cx*a[2],cy:a[1]-a[2]/2+b.cy*a[2],r:b.r*a[2]}},truncate:function(a,b,g,k,u,A,d){var f=this,l=a.rotation,n,v=k?1:0,B=(g||k).length,h=B,c=[],J=function(a){b.firstChild&&b.removeChild(b.firstChild);a&&b.appendChild(r.createTextNode(a))},F=function(A,l){l=l||A;if(void 0===c[l])if(b.getSubStringLength)try{c[l]=u+b.getSubStringLength(0,
k?l+1:l)}catch(fa){""}else f.getSpanWidth&&(J(d(g||k,A)),c[l]=u+f.getSpanWidth(a,b));return c[l]},m;a.rotation=0;var L=F(b.textContent.length);if(m=u+L>A){for(;v<=B;)h=Math.ceil((v+B)/2),k&&(n=d(k,h)),L=F(h,n&&n.length-1),v===B?v=B+1:L>A?B=h-1:v=h;0===B?J(""):g&&B===g.length-1||J(n||d(g||k,h))}k&&k.splice(0,h);a.actualWidth=L;a.rotation=l;return m},escapes:{"&":"&amp;","<":"&lt;",">":"&gt;","'":"&#39;",'"':"&quot;"},buildText:function(a){var b=a.element,g=this,k=g.forExport,u=p(a.textStr,"").toString(),
A=-1!==u.indexOf("<"),d=b.childNodes,f,n=I(b,"x"),v=a.styles,B=a.textWidth,h=v&&v.lineHeight,c=v&&v.textOutline,J=v&&"ellipsis"===v.textOverflow,F=v&&"nowrap"===v.whiteSpace,N=v&&v.fontSize,y,e=d.length;v=B&&!a.added&&this.box;var w=function(a){var k;g.styledMode||(k=/(px|em)$/.test(a&&a.style.fontSize)?a.style.fontSize:N||g.style.fontSize||12);return h?q(h):g.fontMetrics(k,a.getAttribute("style")?a:b).h},Q=function(a,b){m(g.escapes,function(g,k){b&&-1!==b.indexOf(g)||(a=a.toString().replace(new RegExp(g,
"g"),k))});return a},P=function(a,b){var g=a.indexOf("<");a=a.substring(g,a.indexOf(">")-g);g=a.indexOf(b+"=");if(-1!==g&&(g=g+b.length+1,b=a.charAt(g),'"'===b||"'"===b))return a=a.substring(g+1),a.substring(0,a.indexOf(b))},x=/<br.*?>/g;var M=[u,J,F,h,c,N,B].join();if(M!==a.textCache){for(a.textCache=M;e--;)b.removeChild(d[e]);A||c||J||B||-1!==u.indexOf(" ")&&(!F||x.test(u))?(v&&v.appendChild(b),A?(u=g.styledMode?u.replace(/<(b|strong)>/g,'<span class="highcharts-strong">').replace(/<(i|em)>/g,'<span class="highcharts-emphasized">'):
u.replace(/<(b|strong)>/g,'<span style="font-weight:bold">').replace(/<(i|em)>/g,'<span style="font-style:italic">'),u=u.replace(/<a/g,"<span").replace(/<\/(b|strong|i|em|a)>/g,"</span>").split(x)):u=[u],u=u.filter(function(a){return""!==a}),u.forEach(function(u,A){var d=0,v=0;u=u.replace(/^\s+|\s+$/g,"").replace(/<span/g,"|||<span").replace(/<\/span>/g,"</span>|||");var h=u.split("|||");h.forEach(function(u){if(""!==u||1===h.length){var c={},m=r.createElementNS(g.SVG_NS,"tspan"),p,O;(p=P(u,"class"))&&
I(m,"class",p);if(p=P(u,"style"))p=p.replace(/(;| |^)color([ :])/,"$1fill$2"),I(m,"style",p);if((O=P(u,"href"))&&!k&&-1===O.split(":")[0].toLowerCase().indexOf("javascript")){var q=r.createElementNS(g.SVG_NS,"a");I(q,"href",O);I(m,"class","highcharts-anchor");q.appendChild(m);g.styledMode||l(m,{cursor:"pointer"})}u=Q(u.replace(/<[a-zA-Z\/](.|\n)*?>/g,"")||" ");if(" "!==u){m.appendChild(r.createTextNode(u));d?c.dx=0:A&&null!==n&&(c.x=n);I(m,c);b.appendChild(q||m);!d&&y&&(!L&&k&&l(m,{display:"block"}),
I(m,"dy",w(m)));if(B){var e=u.replace(/([^\^])-/g,"$1- ").split(" ");c=!F&&(1<h.length||A||1<e.length);q=0;O=w(m);if(J)f=g.truncate(a,m,u,void 0,0,Math.max(0,B-parseInt(N||12,10)),function(a,b){return a.substring(0,b)+"\u2026"});else if(c)for(;e.length;)e.length&&!F&&0<q&&(m=r.createElementNS(U,"tspan"),I(m,{dy:O,x:n}),p&&I(m,"style",p),m.appendChild(r.createTextNode(e.join(" ").replace(/- /g,"-"))),b.appendChild(m)),g.truncate(a,m,null,e,0===q?v:0,B,function(a,b){return e.slice(0,b).join(" ").replace(/- /g,
"-")}),v=a.actualWidth,q++}d++}}});y=y||b.childNodes.length}),J&&f&&a.attr("title",Q(a.textStr,["&lt;","&gt;"])),v&&v.removeChild(b),c&&a.applyTextOutline&&a.applyTextOutline(c)):b.appendChild(r.createTextNode(Q(u)))}},getContrast:function(a){a=f(a).rgba;a[0]*=1;a[1]*=1.2;a[2]*=.5;return 459<a[0]+a[1]+a[2]?"#000000":"#FFFFFF"},button:function(b,g,u,A,d,l,f,n,v,h){var c=this.label(b,g,u,v,null,null,h,null,"button"),r=0,J=this.styledMode;c.attr(B({padding:8,r:2},d));if(!J){d=B({fill:"#f7f7f7",stroke:"#cccccc",
"stroke-width":1,style:{color:"#333333",cursor:"pointer",fontWeight:"normal"}},d);var m=d.style;delete d.style;l=B(d,{fill:"#e6e6e6"},l);var F=l.style;delete l.style;f=B(d,{fill:"#e6ebf5",style:{color:"#000000",fontWeight:"bold"}},f);var L=f.style;delete f.style;n=B(d,{style:{color:"#cccccc"}},n);var N=n.style;delete n.style}a(c.element,k?"mouseover":"mouseenter",function(){3!==r&&c.setState(1)});a(c.element,k?"mouseout":"mouseleave",function(){3!==r&&c.setState(r)});c.setState=function(a){1!==a&&
(c.state=r=a);c.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-"+["normal","hover","pressed","disabled"][a||0]);J||c.attr([d,l,f,n][a||0]).css([m,F,L,N][a||0])};J||c.attr(d).css(t({cursor:"default"},m));return c.on("click",function(a){3!==r&&A.call(c,a)})},crispLine:function(a,b){a[1]===a[4]&&(a[1]=a[4]=Math.round(a[1])-b%2/2);a[2]===a[5]&&(a[2]=a[5]=Math.round(a[2])+b%2/2);return a},path:function(a){var b=this.styledMode?{}:{fill:"none"};x(a)?b.d=a:E(a)&&
t(b,a);return this.createElement("path").attr(b)},circle:function(a,b,g){a=E(a)?a:void 0===a?{}:{x:a,y:b,r:g};b=this.createElement("circle");b.xSetter=b.ySetter=function(a,b,g){g.setAttribute("c"+b,a)};return b.attr(a)},arc:function(a,b,g,k,u,A){E(a)?(k=a,b=k.y,g=k.r,a=k.x):k={innerR:k,start:u,end:A};a=this.symbol("arc",a,b,g,g,k);a.r=g;return a},rect:function(a,b,g,k,u,A){u=E(a)?a.r:u;var d=this.createElement("rect");a=E(a)?a:void 0===a?{}:{x:a,y:b,width:Math.max(g,0),height:Math.max(k,0)};this.styledMode||
(void 0!==A&&(a.strokeWidth=A,a=d.crisp(a)),a.fill="none");u&&(a.r=u);d.rSetter=function(a,b,g){d.r=a;I(g,{rx:a,ry:a})};d.rGetter=function(){return d.r};return d.attr(a)},setSize:function(a,b,g){var k=this.alignedObjects,u=k.length;this.width=a;this.height=b;for(this.boxWrapper.animate({width:a,height:b},{step:function(){this.attr({viewBox:"0 0 "+this.attr("width")+" "+this.attr("height")})},duration:p(g,!0)?void 0:0});u--;)k[u].align()},g:function(a){var b=this.createElement("g");return a?b.attr({"class":"highcharts-"+
a}):b},image:function(b,g,k,u,A,d){var l={preserveAspectRatio:"none"},f=function(a,b){a.setAttributeNS?a.setAttributeNS("http://www.w3.org/1999/xlink","href",b):a.setAttribute("hc-svg-href",b)},n=function(a){f(v.element,b);d.call(v,a)};1<arguments.length&&t(l,{x:g,y:k,width:u,height:A});var v=this.createElement("image").attr(l);d?(f(v.element,"data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="),l=new P.Image,a(l,"load",n),l.src=b,l.complete&&n({})):f(v.element,b);return v},
symbol:function(a,b,g,k,u,A){var f=this,n=/^url\((.*?)\)$/,v=n.test(a),B=!v&&(this.symbols[a]?a:"circle"),h=B&&this.symbols[B],c=G(b)&&h&&h.call(this.symbols,Math.round(b),Math.round(g),k,u,A);if(h){var J=this.path(c);f.styledMode||J.attr("fill","none");t(J,{symbolName:B,x:b,y:g,width:k,height:u});A&&t(J,A)}else if(v){var m=a.match(n)[1];J=this.image(m);J.imgwidth=p(Q[m]&&Q[m].width,A&&A.width);J.imgheight=p(Q[m]&&Q[m].height,A&&A.height);var L=function(){J.attr({width:J.width,height:J.height})};
["width","height"].forEach(function(a){J[a+"Setter"]=function(a,b){var g={},k=this["img"+b],u="width"===b?"translateX":"translateY";this[b]=a;G(k)&&(A&&"within"===A.backgroundSize&&this.width&&this.height&&(k=Math.round(k*Math.min(this.width/this.imgwidth,this.height/this.imgheight))),this.element&&this.element.setAttribute(b,k),this.alignByTranslate||(g[u]=((this[b]||0)-k)/2,this.attr(g)))}});G(b)&&J.attr({x:b,y:g});J.isImg=!0;G(J.imgwidth)&&G(J.imgheight)?L():(J.attr({width:0,height:0}),F("img",
{onload:function(){var a=d[f.chartIndex];0===this.width&&(l(this,{position:"absolute",top:"-999em"}),r.body.appendChild(this));Q[m]={width:this.width,height:this.height};J.imgwidth=this.width;J.imgheight=this.height;J.element&&L();this.parentNode&&this.parentNode.removeChild(this);f.imgCount--;if(!f.imgCount&&a&&a.onload)a.onload()},src:m}),this.imgCount++)}return J},symbols:{circle:function(a,b,g,k){return this.arc(a+g/2,b+k/2,g/2,k/2,{start:.5*Math.PI,end:2.5*Math.PI,open:!1})},square:function(a,
b,g,k){return["M",a,b,"L",a+g,b,a+g,b+k,a,b+k,"Z"]},triangle:function(a,b,g,k){return["M",a+g/2,b,"L",a+g,b+k,a,b+k,"Z"]},"triangle-down":function(a,b,g,k){return["M",a,b,"L",a+g,b,a+g/2,b+k,"Z"]},diamond:function(a,b,g,k){return["M",a+g/2,b,"L",a+g,b+k/2,a+g/2,b+k,a,b+k/2,"Z"]},arc:function(a,b,g,k,u){var A=u.start,d=u.r||g,l=u.r||k||g,f=u.end-.001;g=u.innerR;k=p(u.open,.001>Math.abs(u.end-u.start-2*Math.PI));var n=Math.cos(A),v=Math.sin(A),B=Math.cos(f);f=Math.sin(f);A=.001>u.end-A-Math.PI?0:1;
u=["M",a+d*n,b+l*v,"A",d,l,0,A,p(u.clockwise,1),a+d*B,b+l*f];G(g)&&u.push(k?"M":"L",a+g*B,b+g*f,"A",g,g,0,A,0,a+g*n,b+g*v);u.push(k?"":"Z");return u},callout:function(a,b,g,k,u){var A=Math.min(u&&u.r||0,g,k),d=A+6,f=u&&u.anchorX;u=u&&u.anchorY;var l=["M",a+A,b,"L",a+g-A,b,"C",a+g,b,a+g,b,a+g,b+A,"L",a+g,b+k-A,"C",a+g,b+k,a+g,b+k,a+g-A,b+k,"L",a+A,b+k,"C",a,b+k,a,b+k,a,b+k-A,"L",a,b+A,"C",a,b,a,b,a+A,b];f&&f>g?u>b+d&&u<b+k-d?l.splice(13,3,"L",a+g,u-6,a+g+6,u,a+g,u+6,a+g,b+k-A):l.splice(13,3,"L",a+
g,k/2,f,u,a+g,k/2,a+g,b+k-A):f&&0>f?u>b+d&&u<b+k-d?l.splice(33,3,"L",a,u+6,a-6,u,a,u-6,a,b+A):l.splice(33,3,"L",a,k/2,f,u,a,k/2,a,b+A):u&&u>k&&f>a+d&&f<a+g-d?l.splice(23,3,"L",f+6,b+k,f,b+k+6,f-6,b+k,a+A,b+k):u&&0>u&&f>a+d&&f<a+g-d&&l.splice(3,3,"L",f-6,b,f,b-6,f+6,b,g-A,b);return l}},clipRect:function(a,b,g,k){var u=c.uniqueKey()+"-",A=this.createElement("clipPath").attr({id:u}).add(this.defs);a=this.rect(a,b,g,k,0).add(A);a.id=u;a.clipPath=A;a.count=0;return a},text:function(a,b,g,k){var u={};if(k&&
(this.allowHTML||!this.forExport))return this.html(a,b,g);u.x=Math.round(b||0);g&&(u.y=Math.round(g));G(a)&&(u.text=a);a=this.createElement("text").attr(u);k||(a.xSetter=function(a,b,g){var k=g.getElementsByTagName("tspan"),u=g.getAttribute(b),A;for(A=0;A<k.length;A++){var d=k[A];d.getAttribute(b)===u&&d.setAttribute(b,a)}g.setAttribute(b,a)});return a},fontMetrics:function(a,b){a=!this.styledMode&&/px/.test(a)||!P.getComputedStyle?a||b&&b.style&&b.style.fontSize||this.style&&this.style.fontSize:
b&&M.prototype.getStyle.call(b,"font-size");a=/px/.test(a)?q(a):12;b=24>a?a+3:Math.round(1.2*a);return{h:b,b:Math.round(.8*b),f:a}},rotCorr:function(a,b,g){var k=a;b&&g&&(k=Math.max(k*Math.cos(b*y),4));return{x:-a/3*Math.sin(b*y),y:k}},label:function(a,b,g,k,A,d,f,l,n){var v=this,h=v.styledMode,c=v.g("button"!==n&&"label"),J=c.text=v.text("",0,0,f).attr({zIndex:1}),r,m,F=0,L=3,p=0,y,U,q,e,N,O={},w,Q,P=/^url\((.*?)\)$/.test(k),x=h||P,da=function(){return h?r.strokeWidth()%2/2:(w?parseInt(w,10):0)%
2/2};n&&c.addClass("highcharts-"+n);var z=function(){var a=J.element.style,b={};m=(void 0===y||void 0===U||N)&&G(J.textStr)&&J.getBBox();c.width=(y||m.width||0)+2*L+p;c.height=(U||m.height||0)+2*L;Q=L+Math.min(v.fontMetrics(a&&a.fontSize,J).b,m?m.height:Infinity);x&&(r||(c.box=r=v.symbols[k]||P?v.symbol(k):v.rect(),r.addClass(("button"===n?"":"highcharts-label-box")+(n?" highcharts-"+n+"-box":"")),r.add(c),a=da(),b.x=a,b.y=(l?-Q:0)+a),b.width=Math.round(c.width),b.height=Math.round(c.height),r.attr(t(b,
O)),O={})};var S=function(){var a=p+L;var b=l?0:Q;G(y)&&m&&("center"===N||"right"===N)&&(a+={center:.5,right:1}[N]*(y-m.width));if(a!==J.x||b!==J.y)J.attr("x",a),J.hasBoxWidthChanged&&(m=J.getBBox(!0),z()),void 0!==b&&J.attr("y",b);J.x=a;J.y=b};var E=function(a,b){r?r.attr(a,b):O[a]=b};c.onAdd=function(){J.add(c);c.attr({text:a||0===a?a:"",x:b,y:g});r&&G(A)&&c.attr({anchorX:A,anchorY:d})};c.widthSetter=function(a){y=C(a)?a:null};c.heightSetter=function(a){U=a};c["text-alignSetter"]=function(a){N=
a};c.paddingSetter=function(a){G(a)&&a!==L&&(L=c.padding=a,S())};c.paddingLeftSetter=function(a){G(a)&&a!==p&&(p=a,S())};c.alignSetter=function(a){a={left:0,center:.5,right:1}[a];a!==F&&(F=a,m&&c.attr({x:q}))};c.textSetter=function(a){void 0!==a&&J.attr({text:a});z();S()};c["stroke-widthSetter"]=function(a,b){a&&(x=!0);w=this["stroke-width"]=a;E(b,a)};h?c.rSetter=function(a,b){E(b,a)}:c.strokeSetter=c.fillSetter=c.rSetter=function(a,b){"r"!==b&&("fill"===b&&a&&(x=!0),c[b]=a);E(b,a)};c.anchorXSetter=
function(a,b){A=c.anchorX=a;E(b,Math.round(a)-da()-q)};c.anchorYSetter=function(a,b){d=c.anchorY=a;E(b,a-e)};c.xSetter=function(a){c.x=a;F&&(a-=F*((y||m.width)+2*L),c["forceAnimate:x"]=!0);q=Math.round(a);c.attr("translateX",q)};c.ySetter=function(a){e=c.y=Math.round(a);c.attr("translateY",e)};var H=c.css;f={css:function(a){if(a){var b={};a=B(a);c.textProps.forEach(function(g){void 0!==a[g]&&(b[g]=a[g],delete a[g])});J.css(b);"width"in b&&z();"fontSize"in b&&(z(),S())}return H.call(c,a)},getBBox:function(){return{width:m.width+
2*L,height:m.height+2*L,x:m.x-L,y:m.y-L}},destroy:function(){u(c.element,"mouseenter");u(c.element,"mouseleave");J&&(J=J.destroy());r&&(r=r.destroy());M.prototype.destroy.call(c);c=v=z=S=E=null}};h||(f.shadow=function(a){a&&(z(),r&&r.shadow(a));return c});return t(c,f)}});c.Renderer=e});K(D,"parts/Html.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,e){var I=e.attr,G=e.defined,H=e.extend,z=e.pick,t=e.pInt,x=c.createElement,C=c.css,E=c.isFirefox,w=c.isMS,m=c.isWebKit,p=c.SVGElement;
e=c.SVGRenderer;var q=c.win;H(p.prototype,{htmlCss:function(c){var a="SPAN"===this.element.tagName&&c&&"width"in c,b=z(a&&c.width,void 0);if(a){delete c.width;this.textWidth=b;var d=!0}c&&"ellipsis"===c.textOverflow&&(c.whiteSpace="nowrap",c.overflow="hidden");this.styles=H(this.styles,c);C(this.element,c);d&&this.htmlUpdateTransform();return this},htmlGetBBox:function(){var c=this.element;return{x:c.offsetLeft,y:c.offsetTop,width:c.offsetWidth,height:c.offsetHeight}},htmlUpdateTransform:function(){if(this.added){var c=
this.renderer,a=this.element,b=this.translateX||0,d=this.translateY||0,f=this.x||0,l=this.y||0,m=this.textAlign||"left",p={left:0,center:.5,right:1}[m],r=this.styles,n=r&&r.whiteSpace;C(a,{marginLeft:b,marginTop:d});!c.styledMode&&this.shadows&&this.shadows.forEach(function(a){C(a,{marginLeft:b+1,marginTop:d+1})});this.inverted&&[].forEach.call(a.childNodes,function(b){c.invertChild(b,a)});if("SPAN"===a.tagName){r=this.rotation;var g=this.textWidth&&t(this.textWidth),k=[r,m,a.innerHTML,this.textWidth,
this.textAlign].join(),v;(v=g!==this.oldTextWidth)&&!(v=g>this.oldTextWidth)&&((v=this.textPxLength)||(C(a,{width:"",whiteSpace:n||"nowrap"}),v=a.offsetWidth),v=v>g);v&&(/[ \-]/.test(a.textContent||a.innerText)||"ellipsis"===a.style.textOverflow)?(C(a,{width:g+"px",display:"block",whiteSpace:n||"normal"}),this.oldTextWidth=g,this.hasBoxWidthChanged=!0):this.hasBoxWidthChanged=!1;k!==this.cTT&&(n=c.fontMetrics(a.style.fontSize,a).b,!G(r)||r===(this.oldRotation||0)&&m===this.oldAlign||this.setSpanRotation(r,
p,n),this.getSpanCorrection(!G(r)&&this.textPxLength||a.offsetWidth,n,p,r,m));C(a,{left:f+(this.xCorr||0)+"px",top:l+(this.yCorr||0)+"px"});this.cTT=k;this.oldRotation=r;this.oldAlign=m}}else this.alignOnAdd=!0},setSpanRotation:function(c,a,b){var d={},f=this.renderer.getTransformKey();d[f]=d.transform="rotate("+c+"deg)";d[f+(E?"Origin":"-origin")]=d.transformOrigin=100*a+"% "+b+"px";C(this.element,d)},getSpanCorrection:function(c,a,b){this.xCorr=-c*b;this.yCorr=-a}});H(e.prototype,{getTransformKey:function(){return w&&
!/Edge/.test(q.navigator.userAgent)?"-ms-transform":m?"-webkit-transform":E?"MozTransform":q.opera?"-o-transform":""},html:function(c,a,b){var d=this.createElement("span"),f=d.element,l=d.renderer,h=l.isSVG,m=function(a,b){["opacity","visibility"].forEach(function(g){a[g+"Setter"]=function(k,d,f){var A=a.div?a.div.style:b;p.prototype[g+"Setter"].call(this,k,d,f);A&&(A[d]=k)}});a.addedSetters=!0};d.textSetter=function(a){a!==f.innerHTML&&(delete this.bBox,delete this.oldTextWidth);this.textStr=a;f.innerHTML=
z(a,"");d.doTransform=!0};h&&m(d,d.element.style);d.xSetter=d.ySetter=d.alignSetter=d.rotationSetter=function(a,b){"align"===b&&(b="textAlign");d[b]=a;d.doTransform=!0};d.afterSetters=function(){this.doTransform&&(this.htmlUpdateTransform(),this.doTransform=!1)};d.attr({text:c,x:Math.round(a),y:Math.round(b)}).css({position:"absolute"});l.styledMode||d.css({fontFamily:this.style.fontFamily,fontSize:this.style.fontSize});f.style.whiteSpace="nowrap";d.css=d.htmlCss;h&&(d.add=function(a){var b=l.box.parentNode,
g=[];if(this.parentGroup=a){var k=a.div;if(!k){for(;a;)g.push(a),a=a.parentGroup;g.reverse().forEach(function(a){function f(b,g){a[g]=b;"translateX"===g?u.left=b+"px":u.top=b+"px";a.doTransform=!0}var A=I(a.element,"class");k=a.div=a.div||x("div",A?{className:A}:void 0,{position:"absolute",left:(a.translateX||0)+"px",top:(a.translateY||0)+"px",display:a.display,opacity:a.opacity,pointerEvents:a.styles&&a.styles.pointerEvents},k||b);var u=k.style;H(a,{classSetter:function(a){return function(b){this.element.setAttribute("class",
b);a.className=b}}(k),on:function(){g[0].div&&d.on.apply({element:g[0].div},arguments);return a},translateXSetter:f,translateYSetter:f});a.addedSetters||m(a)})}}else k=b;k.appendChild(f);d.added=!0;d.alignOnAdd&&d.htmlUpdateTransform();return d});return d}})});K(D,"parts/Time.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,e){var I=e.defined,G=e.extend,H=e.isObject,z=e.objectEach,t=e.pick,x=e.splat,C=c.merge,E=c.timeUnits,w=c.win;c.Time=function(c){this.update(c,!1)};c.Time.prototype=
{defaultOptions:{Date:void 0,getTimezoneOffset:void 0,timezone:void 0,timezoneOffset:0,useUTC:!0},update:function(c){var m=t(c&&c.useUTC,!0),q=this;this.options=c=C(!0,this.options||{},c);this.Date=c.Date||w.Date||Date;this.timezoneOffset=(this.useUTC=m)&&c.timezoneOffset;this.getTimezoneOffset=this.timezoneOffsetFunction();(this.variableTimezone=!(m&&!c.getTimezoneOffset&&!c.timezone))||this.timezoneOffset?(this.get=function(c,a){var b=a.getTime(),d=b-q.getTimezoneOffset(a);a.setTime(d);c=a["getUTC"+
c]();a.setTime(b);return c},this.set=function(c,a,b){if("Milliseconds"===c||"Seconds"===c||"Minutes"===c&&0===a.getTimezoneOffset()%60)a["set"+c](b);else{var d=q.getTimezoneOffset(a);d=a.getTime()-d;a.setTime(d);a["setUTC"+c](b);c=q.getTimezoneOffset(a);d=a.getTime()+c;a.setTime(d)}}):m?(this.get=function(c,a){return a["getUTC"+c]()},this.set=function(c,a,b){return a["setUTC"+c](b)}):(this.get=function(c,a){return a["get"+c]()},this.set=function(c,a,b){return a["set"+c](b)})},makeTime:function(m,
p,q,h,a,b){if(this.useUTC){var d=this.Date.UTC.apply(0,arguments);var f=this.getTimezoneOffset(d);d+=f;var l=this.getTimezoneOffset(d);f!==l?d+=l-f:f-36E5!==this.getTimezoneOffset(d-36E5)||c.isSafari||(d-=36E5)}else d=(new this.Date(m,p,t(q,1),t(h,0),t(a,0),t(b,0))).getTime();return d},timezoneOffsetFunction:function(){var m=this,p=this.options,q=w.moment;if(!this.useUTC)return function(c){return 6E4*(new Date(c)).getTimezoneOffset()};if(p.timezone){if(q)return function(c){return 6E4*-q.tz(c,p.timezone).utcOffset()};
c.error(25)}return this.useUTC&&p.getTimezoneOffset?function(c){return 6E4*p.getTimezoneOffset(c)}:function(){return 6E4*(m.timezoneOffset||0)}},dateFormat:function(m,p,q){if(!I(p)||isNaN(p))return c.defaultOptions.lang.invalidDate||"";m=t(m,"%Y-%m-%d %H:%M:%S");var h=this,a=new this.Date(p),b=this.get("Hours",a),d=this.get("Day",a),f=this.get("Date",a),l=this.get("Month",a),F=this.get("FullYear",a),y=c.defaultOptions.lang,r=y.weekdays,n=y.shortWeekdays,g=c.pad;a=G({a:n?n[d]:r[d].substr(0,3),A:r[d],
d:g(f),e:g(f,2," "),w:d,b:y.shortMonths[l],B:y.months[l],m:g(l+1),o:l+1,y:F.toString().substr(2,2),Y:F,H:g(b),k:b,I:g(b%12||12),l:b%12||12,M:g(h.get("Minutes",a)),p:12>b?"AM":"PM",P:12>b?"am":"pm",S:g(a.getSeconds()),L:g(Math.floor(p%1E3),3)},c.dateFormats);z(a,function(a,b){for(;-1!==m.indexOf("%"+b);)m=m.replace("%"+b,"function"===typeof a?a.call(h,p):a)});return q?m.substr(0,1).toUpperCase()+m.substr(1):m},resolveDTLFormat:function(c){return H(c,!0)?c:(c=x(c),{main:c[0],from:c[1],to:c[2]})},getTimeTicks:function(c,
p,q,h){var a=this,b=[],d={};var f=new a.Date(p);var l=c.unitRange,m=c.count||1,y;h=t(h,1);if(I(p)){a.set("Milliseconds",f,l>=E.second?0:m*Math.floor(a.get("Milliseconds",f)/m));l>=E.second&&a.set("Seconds",f,l>=E.minute?0:m*Math.floor(a.get("Seconds",f)/m));l>=E.minute&&a.set("Minutes",f,l>=E.hour?0:m*Math.floor(a.get("Minutes",f)/m));l>=E.hour&&a.set("Hours",f,l>=E.day?0:m*Math.floor(a.get("Hours",f)/m));l>=E.day&&a.set("Date",f,l>=E.month?1:Math.max(1,m*Math.floor(a.get("Date",f)/m)));if(l>=E.month){a.set("Month",
f,l>=E.year?0:m*Math.floor(a.get("Month",f)/m));var r=a.get("FullYear",f)}l>=E.year&&a.set("FullYear",f,r-r%m);l===E.week&&(r=a.get("Day",f),a.set("Date",f,a.get("Date",f)-r+h+(r<h?-7:0)));r=a.get("FullYear",f);h=a.get("Month",f);var n=a.get("Date",f),g=a.get("Hours",f);p=f.getTime();a.variableTimezone&&(y=q-p>4*E.month||a.getTimezoneOffset(p)!==a.getTimezoneOffset(q));p=f.getTime();for(f=1;p<q;)b.push(p),p=l===E.year?a.makeTime(r+f*m,0):l===E.month?a.makeTime(r,h+f*m):!y||l!==E.day&&l!==E.week?y&&
l===E.hour&&1<m?a.makeTime(r,h,n,g+f*m):p+l*m:a.makeTime(r,h,n+f*m*(l===E.day?1:7)),f++;b.push(p);l<=E.hour&&1E4>b.length&&b.forEach(function(b){0===b%18E5&&"000000000"===a.dateFormat("%H%M%S%L",b)&&(d[b]="day")})}b.info=G(c,{higherRanks:d,totalRange:l*m});return b}}});K(D,"parts/Options.js",[D["parts/Globals.js"]],function(c){var e=c.color,I=c.merge;c.defaultOptions={colors:"#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" "),symbols:["circle","diamond","square",
"triangle","triangle-down"],lang:{loading:"Loading...",months:"January February March April May June July August September October November December".split(" "),shortMonths:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),weekdays:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),decimalPoint:".",numericSymbols:"kMGTPE".split(""),resetZoom:"Reset zoom",resetZoomTitle:"Reset zoom level 1:1",thousandsSep:" "},global:{},time:c.Time.prototype.defaultOptions,chart:{styledMode:!1,
borderRadius:0,colorCount:10,defaultSeriesType:"line",ignoreHiddenSeries:!0,spacing:[10,10,15,10],resetZoomButton:{theme:{zIndex:6},position:{align:"right",x:-10,y:10}},width:null,height:null,borderColor:"#335cad",backgroundColor:"#ffffff",plotBorderColor:"#cccccc"},title:{text:"Chart title",align:"center",margin:15,widthAdjust:-44},subtitle:{text:"",align:"center",widthAdjust:-44},caption:{margin:15,text:"",align:"left",verticalAlign:"bottom"},plotOptions:{},labels:{style:{position:"absolute",color:"#333333"}},
legend:{enabled:!0,align:"center",alignColumns:!0,layout:"horizontal",labelFormatter:function(){return this.name},borderColor:"#999999",borderRadius:0,navigation:{activeColor:"#003399",inactiveColor:"#cccccc"},itemStyle:{color:"#333333",cursor:"pointer",fontSize:"12px",fontWeight:"bold",textOverflow:"ellipsis"},itemHoverStyle:{color:"#000000"},itemHiddenStyle:{color:"#cccccc"},shadow:!1,itemCheckboxStyle:{position:"absolute",width:"13px",height:"13px"},squareSymbol:!0,symbolPadding:5,verticalAlign:"bottom",
x:0,y:0,title:{style:{fontWeight:"bold"}}},loading:{labelStyle:{fontWeight:"bold",position:"relative",top:"45%"},style:{position:"absolute",backgroundColor:"#ffffff",opacity:.5,textAlign:"center"}},tooltip:{enabled:!0,animation:c.svg,borderRadius:3,dateTimeLabelFormats:{millisecond:"%A, %b %e, %H:%M:%S.%L",second:"%A, %b %e, %H:%M:%S",minute:"%A, %b %e, %H:%M",hour:"%A, %b %e, %H:%M",day:"%A, %b %e, %Y",week:"Week from %A, %b %e, %Y",month:"%B %Y",year:"%Y"},footerFormat:"",padding:8,snap:c.isTouchDevice?
25:10,headerFormat:'<span style="font-size: 10px">{point.key}</span><br/>',pointFormat:'<span style="color:{point.color}">\u25cf</span> {series.name}: <b>{point.y}</b><br/>',backgroundColor:e("#f7f7f7").setOpacity(.85).get(),borderWidth:1,shadow:!0,style:{color:"#333333",cursor:"default",fontSize:"12px",pointerEvents:"none",whiteSpace:"nowrap"}},credits:{enabled:!0,href:"https://www.highcharts.com?credits",position:{align:"right",x:-10,verticalAlign:"bottom",y:-5},style:{cursor:"pointer",color:"#999999",
fontSize:"9px"},text:"Highcharts.com"}};c.setOptions=function(e){c.defaultOptions=I(!0,c.defaultOptions,e);(e.time||e.global)&&c.time.update(I(c.defaultOptions.global,c.defaultOptions.time,e.global,e.time));return c.defaultOptions};c.getOptions=function(){return c.defaultOptions};c.defaultPlotOptions=c.defaultOptions.plotOptions;c.time=new c.Time(I(c.defaultOptions.global,c.defaultOptions.time));c.dateFormat=function(e,H,z){return c.time.dateFormat(e,H,z)};""});K(D,"parts/Tick.js",[D["parts/Globals.js"],
D["parts/Utilities.js"]],function(c,e){var I=e.defined,G=e.destroyObjectProperties,H=e.extend,z=e.isNumber,t=e.pick,x=c.correctFloat,C=c.fireEvent,E=c.merge,w=c.deg2rad;c.Tick=function(c,p,e,h,a){this.axis=c;this.pos=p;this.type=e||"";this.isNewLabel=this.isNew=!0;this.parameters=a||{};this.tickmarkOffset=this.parameters.tickmarkOffset;this.options=this.parameters.options;e||h||this.addLabel()};c.Tick.prototype={addLabel:function(){var c=this,p=c.axis,e=p.options,h=p.chart,a=p.categories,b=p.names,
d=c.pos,f=t(c.options&&c.options.labels,e.labels),l=p.tickPositions,F=d===l[0],y=d===l[l.length-1];a=this.parameters.category||(a?t(a[d],b[d],d):d);var r=c.label;l=l.info;var n,g;if(p.isDatetimeAxis&&l){var k=h.time.resolveDTLFormat(e.dateTimeLabelFormats[!e.grid&&l.higherRanks[d]||l.unitName]);var v=k.main}c.isFirst=F;c.isLast=y;c.formatCtx={axis:p,chart:h,isFirst:F,isLast:y,dateTimeLabelFormat:v,tickPositionInfo:l,value:p.isLog?x(p.lin2log(a)):a,pos:d};e=p.labelFormatter.call(c.formatCtx,this.formatCtx);
if(g=k&&k.list)c.shortenLabel=function(){for(n=0;n<g.length;n++)if(r.attr({text:p.labelFormatter.call(H(c.formatCtx,{dateTimeLabelFormat:g[n]}))}),r.getBBox().width<p.getSlotWidth(c)-2*t(f.padding,5))return;r.attr({text:""})};if(I(r))r&&r.textStr!==e&&(!r.textWidth||f.style&&f.style.width||r.styles.width||r.css({width:null}),r.attr({text:e}),r.textPxLength=r.getBBox().width);else{if(c.label=r=I(e)&&f.enabled?h.renderer.text(e,0,0,f.useHTML).add(p.labelGroup):null)h.styledMode||r.css(E(f.style)),r.textPxLength=
r.getBBox().width;c.rotation=0}},getLabelSize:function(){return this.label?this.label.getBBox()[this.axis.horiz?"height":"width"]:0},handleOverflow:function(c){var m=this.axis,e=m.options.labels,h=c.x,a=m.chart.chartWidth,b=m.chart.spacing,d=t(m.labelLeft,Math.min(m.pos,b[3]));b=t(m.labelRight,Math.max(m.isRadial?0:m.pos+m.len,a-b[1]));var f=this.label,l=this.rotation,F={left:0,center:.5,right:1}[m.labelAlign||f.attr("align")],y=f.getBBox().width,r=m.getSlotWidth(this),n=r,g=1,k,v={};if(l||"justify"!==
t(e.overflow,"justify"))0>l&&h-F*y<d?k=Math.round(h/Math.cos(l*w)-d):0<l&&h+F*y>b&&(k=Math.round((a-h)/Math.cos(l*w)));else if(a=h+(1-F)*y,h-F*y<d?n=c.x+n*(1-F)-d:a>b&&(n=b-c.x+n*F,g=-1),n=Math.min(r,n),n<r&&"center"===m.labelAlign&&(c.x+=g*(r-n-F*(r-Math.min(y,n)))),y>n||m.autoRotation&&(f.styles||{}).width)k=n;k&&(this.shortenLabel?this.shortenLabel():(v.width=Math.floor(k),(e.style||{}).textOverflow||(v.textOverflow="ellipsis"),f.css(v)))},getPosition:function(m,p,e,h){var a=this.axis,b=a.chart,
d=h&&b.oldChartHeight||b.chartHeight;m={x:m?c.correctFloat(a.translate(p+e,null,null,h)+a.transB):a.left+a.offset+(a.opposite?(h&&b.oldChartWidth||b.chartWidth)-a.right-a.left:0),y:m?d-a.bottom+a.offset-(a.opposite?a.height:0):c.correctFloat(d-a.translate(p+e,null,null,h)-a.transB)};m.y=Math.max(Math.min(m.y,1E5),-1E5);C(this,"afterGetPosition",{pos:m});return m},getLabelPosition:function(c,p,e,h,a,b,d,f){var l=this.axis,m=l.transA,y=l.isLinked&&l.linkedParent?l.linkedParent.reversed:l.reversed,r=
l.staggerLines,n=l.tickRotCorr||{x:0,y:0},g=a.y,k=h||l.reserveSpaceDefault?0:-l.labelOffset*("center"===l.labelAlign?.5:1),v={};I(g)||(g=0===l.side?e.rotation?-8:-e.getBBox().height:2===l.side?n.y+8:Math.cos(e.rotation*w)*(n.y-e.getBBox(!1,0).height/2));c=c+a.x+k+n.x-(b&&h?b*m*(y?-1:1):0);p=p+g-(b&&!h?b*m*(y?1:-1):0);r&&(e=d/(f||1)%r,l.opposite&&(e=r-e-1),p+=l.labelOffset/r*e);v.x=c;v.y=Math.round(p);C(this,"afterGetLabelPosition",{pos:v,tickmarkOffset:b,index:d});return v},getMarkPath:function(c,
p,e,h,a,b){return b.crispLine(["M",c,p,"L",c+(a?0:-e),p+(a?e:0)],h)},renderGridLine:function(c,p,e){var h=this.axis,a=h.options,b=this.gridLine,d={},f=this.pos,l=this.type,m=t(this.tickmarkOffset,h.tickmarkOffset),y=h.chart.renderer,r=l?l+"Grid":"grid",n=a[r+"LineWidth"],g=a[r+"LineColor"];a=a[r+"LineDashStyle"];b||(h.chart.styledMode||(d.stroke=g,d["stroke-width"]=n,a&&(d.dashstyle=a)),l||(d.zIndex=1),c&&(p=0),this.gridLine=b=y.path().attr(d).addClass("highcharts-"+(l?l+"-":"")+"grid-line").add(h.gridGroup));
if(b&&(e=h.getPlotLinePath({value:f+m,lineWidth:b.strokeWidth()*e,force:"pass",old:c})))b[c||this.isNew?"attr":"animate"]({d:e,opacity:p})},renderMark:function(c,p,e){var h=this.axis,a=h.options,b=h.chart.renderer,d=this.type,f=d?d+"Tick":"tick",l=h.tickSize(f),m=this.mark,y=!m,r=c.x;c=c.y;var n=t(a[f+"Width"],!d&&h.isXAxis?1:0);a=a[f+"Color"];l&&(h.opposite&&(l[0]=-l[0]),y&&(this.mark=m=b.path().addClass("highcharts-"+(d?d+"-":"")+"tick").add(h.axisGroup),h.chart.styledMode||m.attr({stroke:a,"stroke-width":n})),
m[y?"attr":"animate"]({d:this.getMarkPath(r,c,l[0],m.strokeWidth()*e,h.horiz,b),opacity:p}))},renderLabel:function(c,p,e,h){var a=this.axis,b=a.horiz,d=a.options,f=this.label,l=d.labels,m=l.step;a=t(this.tickmarkOffset,a.tickmarkOffset);var y=!0,r=c.x;c=c.y;f&&z(r)&&(f.xy=c=this.getLabelPosition(r,c,f,b,l,a,h,m),this.isFirst&&!this.isLast&&!t(d.showFirstLabel,1)||this.isLast&&!this.isFirst&&!t(d.showLastLabel,1)?y=!1:!b||l.step||l.rotation||p||0===e||this.handleOverflow(c),m&&h%m&&(y=!1),y&&z(c.y)?
(c.opacity=e,f[this.isNewLabel?"attr":"animate"](c),this.isNewLabel=!1):(f.attr("y",-9999),this.isNewLabel=!0))},render:function(m,p,e){var h=this.axis,a=h.horiz,b=this.pos,d=t(this.tickmarkOffset,h.tickmarkOffset);b=this.getPosition(a,b,d,p);d=b.x;var f=b.y;h=a&&d===h.pos+h.len||!a&&f===h.pos?-1:1;e=t(e,1);this.isActive=!0;this.renderGridLine(p,e,h);this.renderMark(b,e,h);this.renderLabel(b,p,e,m);this.isNew=!1;c.fireEvent(this,"afterRender")},destroy:function(){G(this,this.axis)}}});K(D,"parts/Axis.js",
[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,e){var I=e.arrayMax,G=e.arrayMin,H=e.defined,z=e.destroyObjectProperties,t=e.extend,x=e.isArray,C=e.isNumber,E=e.isString,w=e.objectEach,m=e.pick,p=e.splat,q=e.syncTimeout,h=c.addEvent,a=c.animObject,b=c.color,d=c.correctFloat,f=c.defaultOptions,l=c.deg2rad,F=c.fireEvent,y=c.format,r=c.getMagnitude,n=c.merge,g=c.normalizeTickInterval,k=c.removeEvent,v=c.seriesTypes,B=c.Tick;e=function(){this.init.apply(this,arguments)};t(e.prototype,{defaultOptions:{dateTimeLabelFormats:{millisecond:{main:"%H:%M:%S.%L",
range:!1},second:{main:"%H:%M:%S",range:!1},minute:{main:"%H:%M",range:!1},hour:{main:"%H:%M",range:!1},day:{main:"%e. %b"},week:{main:"%e. %b"},month:{main:"%b '%y"},year:{main:"%Y"}},endOnTick:!1,labels:{enabled:!0,indentation:10,x:0,style:{color:"#666666",cursor:"default",fontSize:"11px"}},maxPadding:.01,minorTickLength:2,minorTickPosition:"outside",minPadding:.01,showEmpty:!0,startOfWeek:1,startOnTick:!1,tickLength:10,tickPixelInterval:100,tickmarkPlacement:"between",tickPosition:"outside",title:{align:"middle",
style:{color:"#666666"}},type:"linear",minorGridLineColor:"#f2f2f2",minorGridLineWidth:1,minorTickColor:"#999999",lineColor:"#ccd6eb",lineWidth:1,gridLineColor:"#e6e6e6",tickColor:"#ccd6eb"},defaultYAxisOptions:{endOnTick:!0,maxPadding:.05,minPadding:.05,tickPixelInterval:72,showLastLabel:!0,labels:{x:-8},startOnTick:!0,title:{rotation:270,text:"Values"},stackLabels:{allowOverlap:!1,enabled:!1,crop:!0,overflow:"justify",formatter:function(){return c.numberFormat(this.total,-1)},style:{color:"#000000",
fontSize:"11px",fontWeight:"bold",textOutline:"1px contrast"}},gridLineWidth:1,lineWidth:0},defaultLeftAxisOptions:{labels:{x:-15},title:{rotation:270}},defaultRightAxisOptions:{labels:{x:15},title:{rotation:90}},defaultBottomAxisOptions:{labels:{autoRotation:[-45],x:0},margin:15,title:{rotation:0}},defaultTopAxisOptions:{labels:{autoRotation:[-45],x:0},margin:15,title:{rotation:0}},init:function(a,b){var g=b.isX,k=this;k.chart=a;k.horiz=a.inverted&&!k.isZAxis?!g:g;k.isXAxis=g;k.coll=k.coll||(g?"xAxis":
"yAxis");F(this,"init",{userOptions:b});k.opposite=b.opposite;k.side=b.side||(k.horiz?k.opposite?0:2:k.opposite?1:3);k.setOptions(b);var u=this.options,A=u.type;k.labelFormatter=u.labels.formatter||k.defaultLabelFormatter;k.userOptions=b;k.minPixelPadding=0;k.reversed=u.reversed;k.visible=!1!==u.visible;k.zoomEnabled=!1!==u.zoomEnabled;k.hasNames="category"===A||!0===u.categories;k.categories=u.categories||k.hasNames;k.names||(k.names=[],k.names.keys={});k.plotLinesAndBandsGroups={};k.isLog="logarithmic"===
A;k.isDatetimeAxis="datetime"===A;k.positiveValuesOnly=k.isLog&&!k.allowNegativeLog;k.isLinked=H(u.linkedTo);k.ticks={};k.labelEdge=[];k.minorTicks={};k.plotLinesAndBands=[];k.alternateBands={};k.len=0;k.minRange=k.userMinRange=u.minRange||u.maxZoom;k.range=u.range;k.offset=u.offset||0;k.stacks={};k.oldStacks={};k.stacksTouched=0;k.max=null;k.min=null;k.crosshair=m(u.crosshair,p(a.options.tooltip.crosshairs)[g?0:1],!1);b=k.options.events;-1===a.axes.indexOf(k)&&(g?a.axes.splice(a.xAxis.length,0,k):
a.axes.push(k),a[k.coll].push(k));k.series=k.series||[];a.inverted&&!k.isZAxis&&g&&void 0===k.reversed&&(k.reversed=!0);w(b,function(a,b){c.isFunction(a)&&h(k,b,a)});k.lin2log=u.linearToLogConverter||k.lin2log;k.isLog&&(k.val2lin=k.log2lin,k.lin2val=k.lin2log);F(this,"afterInit")},setOptions:function(a){this.options=n(this.defaultOptions,"yAxis"===this.coll&&this.defaultYAxisOptions,[this.defaultTopAxisOptions,this.defaultRightAxisOptions,this.defaultBottomAxisOptions,this.defaultLeftAxisOptions][this.side],
n(f[this.coll],a));F(this,"afterSetOptions",{userOptions:a})},defaultLabelFormatter:function(){var a=this.axis,b=this.value,g=a.chart.time,k=a.categories,d=this.dateTimeLabelFormat,l=f.lang,n=l.numericSymbols;l=l.numericSymbolMagnitude||1E3;var v=n&&n.length,B=a.options.labels.format;a=a.isLog?Math.abs(b):a.tickInterval;if(B)var h=y(B,this,g);else if(k)h=b;else if(d)h=g.dateFormat(d,b);else if(v&&1E3<=a)for(;v--&&void 0===h;)g=Math.pow(l,v+1),a>=g&&0===10*b%g&&null!==n[v]&&0!==b&&(h=c.numberFormat(b/
g,-1)+n[v]);void 0===h&&(h=1E4<=Math.abs(b)?c.numberFormat(b,-1):c.numberFormat(b,-1,void 0,""));return h},getSeriesExtremes:function(){var a=this,b=a.chart,g;F(this,"getSeriesExtremes",null,function(){a.hasVisibleSeries=!1;a.dataMin=a.dataMax=a.threshold=null;a.softThreshold=!a.isXAxis;a.buildStacks&&a.buildStacks();a.series.forEach(function(k){if(k.visible||!b.options.chart.ignoreHiddenSeries){var u=k.options,A=u.threshold;a.hasVisibleSeries=!0;a.positiveValuesOnly&&0>=A&&(A=null);if(a.isXAxis){if(u=
k.xData,u.length){g=k.getXExtremes(u);var d=g.min;var f=g.max;C(d)||d instanceof Date||(u=u.filter(C),g=k.getXExtremes(u),d=g.min,f=g.max);u.length&&(a.dataMin=Math.min(m(a.dataMin,d),d),a.dataMax=Math.max(m(a.dataMax,f),f))}}else if(k.getExtremes(),f=k.dataMax,d=k.dataMin,H(d)&&H(f)&&(a.dataMin=Math.min(m(a.dataMin,d),d),a.dataMax=Math.max(m(a.dataMax,f),f)),H(A)&&(a.threshold=A),!u.softThreshold||a.positiveValuesOnly)a.softThreshold=!1}})});F(this,"afterGetSeriesExtremes")},translate:function(a,
b,g,k,d,f){var u=this.linkedParent||this,A=1,l=0,n=k?u.oldTransA:u.transA;k=k?u.oldMin:u.min;var c=u.minPixelPadding;d=(u.isOrdinal||u.isBroken||u.isLog&&d)&&u.lin2val;n||(n=u.transA);g&&(A*=-1,l=u.len);u.reversed&&(A*=-1,l-=A*(u.sector||u.len));b?(a=(a*A+l-c)/n+k,d&&(a=u.lin2val(a))):(d&&(a=u.val2lin(a)),a=C(k)?A*(a-k)*n+l+A*c+(C(f)?n*f:0):void 0);return a},toPixels:function(a,b){return this.translate(a,!1,!this.horiz,null,!0)+(b?0:this.pos)},toValue:function(a,b){return this.translate(a-(b?0:this.pos),
!0,!this.horiz,null,!0)},getPlotLinePath:function(a){var b=this,g=b.chart,k=b.left,d=b.top,A=a.old,f=a.value,l=a.translatedValue,n=a.lineWidth,c=a.force,v,B,h,r,y=A&&g.oldChartHeight||g.chartHeight,p=A&&g.oldChartWidth||g.chartWidth,e,q=b.transB,w=function(a,b,g){if("pass"!==c&&a<b||a>g)c?a=Math.min(Math.max(b,a),g):e=!0;return a};a={value:f,lineWidth:n,old:A,force:c,acrossPanes:a.acrossPanes,translatedValue:l};F(this,"getPlotLinePath",a,function(a){l=m(l,b.translate(f,null,null,A));l=Math.min(Math.max(-1E5,
l),1E5);v=h=Math.round(l+q);B=r=Math.round(y-l-q);C(l)?b.horiz?(B=d,r=y-b.bottom,v=h=w(v,k,k+b.width)):(v=k,h=p-b.right,B=r=w(B,d,d+b.height)):(e=!0,c=!1);a.path=e&&!c?null:g.renderer.crispLine(["M",v,B,"L",h,r],n||1)});return a.path},getLinearTickPositions:function(a,b,g){var k=d(Math.floor(b/a)*a);g=d(Math.ceil(g/a)*a);var u=[],A;d(k+a)===k&&(A=20);if(this.single)return[b];for(b=k;b<=g;){u.push(b);b=d(b+a,A);if(b===f)break;var f=b}return u},getMinorTickInterval:function(){var a=this.options;return!0===
a.minorTicks?m(a.minorTickInterval,"auto"):!1===a.minorTicks?null:a.minorTickInterval},getMinorTickPositions:function(){var a=this,b=a.options,g=a.tickPositions,k=a.minorTickInterval,d=[],f=a.pointRangePadding||0,l=a.min-f;f=a.max+f;var n=f-l;if(n&&n/k<a.len/3)if(a.isLog)this.paddedTicks.forEach(function(b,g,u){g&&d.push.apply(d,a.getLogTickPositions(k,u[g-1],u[g],!0))});else if(a.isDatetimeAxis&&"auto"===this.getMinorTickInterval())d=d.concat(a.getTimeTicks(a.normalizeTimeTickInterval(k),l,f,b.startOfWeek));
else for(b=l+(g[0]-l)%k;b<=f&&b!==d[0];b+=k)d.push(b);0!==d.length&&a.trimTicks(d);return d},adjustForMinRange:function(){var a=this.options,b=this.min,g=this.max,k,d,f,l,n;this.isXAxis&&void 0===this.minRange&&!this.isLog&&(H(a.min)||H(a.max)?this.minRange=null:(this.series.forEach(function(a){l=a.xData;for(d=n=a.xIncrement?1:l.length-1;0<d;d--)if(f=l[d]-l[d-1],void 0===k||f<k)k=f}),this.minRange=Math.min(5*k,this.dataMax-this.dataMin)));if(g-b<this.minRange){var c=this.dataMax-this.dataMin>=this.minRange;
var v=this.minRange;var B=(v-g+b)/2;B=[b-B,m(a.min,b-B)];c&&(B[2]=this.isLog?this.log2lin(this.dataMin):this.dataMin);b=I(B);g=[b+v,m(a.max,b+v)];c&&(g[2]=this.isLog?this.log2lin(this.dataMax):this.dataMax);g=G(g);g-b<v&&(B[0]=g-v,B[1]=m(a.min,g-v),b=I(B))}this.min=b;this.max=g},getClosest:function(){var a;this.categories?a=1:this.series.forEach(function(b){var g=b.closestPointRange,k=b.visible||!b.chart.options.chart.ignoreHiddenSeries;!b.noSharedTooltip&&H(g)&&k&&(a=H(a)?Math.min(a,g):g)});return a},
nameToX:function(a){var b=x(this.categories),g=b?this.categories:this.names,k=a.options.x;a.series.requireSorting=!1;H(k)||(k=!1===this.options.uniqueNames?a.series.autoIncrement():b?g.indexOf(a.name):m(g.keys[a.name],-1));if(-1===k){if(!b)var d=g.length}else d=k;void 0!==d&&(this.names[d]=a.name,this.names.keys[a.name]=d);return d},updateNames:function(){var a=this,b=this.names;0<b.length&&(Object.keys(b.keys).forEach(function(a){delete b.keys[a]}),b.length=0,this.minRange=this.userMinRange,(this.series||
[]).forEach(function(b){b.xIncrement=null;if(!b.points||b.isDirtyData)a.max=Math.max(a.max,b.xData.length-1),b.processData(),b.generatePoints();b.data.forEach(function(g,k){if(g&&g.options&&void 0!==g.name){var u=a.nameToX(g);void 0!==u&&u!==g.x&&(g.x=u,b.xData[k]=u)}})}))},setAxisTranslation:function(a){var b=this,g=b.max-b.min,k=b.axisPointRange||0,d=0,f=0,l=b.linkedParent,A=!!b.categories,n=b.transA,c=b.isXAxis;if(c||A||k){var B=b.getClosest();l?(d=l.minPointOffset,f=l.pointRangePadding):b.series.forEach(function(a){var g=
A?1:c?m(a.options.pointRange,B,0):b.axisPointRange||0,u=a.options.pointPlacement;k=Math.max(k,g);if(!b.single||A)a=v.xrange&&a instanceof v.xrange?!c:c,d=Math.max(d,a&&E(u)?0:g/2),f=Math.max(f,a&&"on"===u?0:g)});l=b.ordinalSlope&&B?b.ordinalSlope/B:1;b.minPointOffset=d*=l;b.pointRangePadding=f*=l;b.pointRange=Math.min(k,b.single&&A?1:g);c&&(b.closestPointRange=B)}a&&(b.oldTransA=n);b.translationSlope=b.transA=n=b.staticScale||b.len/(g+f||1);b.transB=b.horiz?b.left:b.bottom;b.minPixelPadding=n*d;F(this,
"afterSetAxisTranslation")},minFromRange:function(){return this.max-this.range},setTickInterval:function(a){var b=this,k=b.chart,f=b.options,l=b.isLog,A=b.isDatetimeAxis,n=b.isXAxis,v=b.isLinked,B=f.maxPadding,h=f.minPadding,y=f.tickInterval,p=f.tickPixelInterval,e=b.categories,q=C(b.threshold)?b.threshold:null,w=b.softThreshold;A||e||v||this.getTickAmount();var x=m(b.userMin,f.min);var t=m(b.userMax,f.max);if(v){b.linkedParent=k[b.coll][f.linkedTo];var z=b.linkedParent.getExtremes();b.min=m(z.min,
z.dataMin);b.max=m(z.max,z.dataMax);f.type!==b.linkedParent.options.type&&c.error(11,1,k)}else{if(!w&&H(q))if(b.dataMin>=q)z=q,h=0;else if(b.dataMax<=q){var E=q;B=0}b.min=m(x,z,b.dataMin);b.max=m(t,E,b.dataMax)}l&&(b.positiveValuesOnly&&!a&&0>=Math.min(b.min,m(b.dataMin,b.min))&&c.error(10,1,k),b.min=d(b.log2lin(b.min),16),b.max=d(b.log2lin(b.max),16));b.range&&H(b.max)&&(b.userMin=b.min=x=Math.max(b.dataMin,b.minFromRange()),b.userMax=t=b.max,b.range=null);F(b,"foundExtremes");b.beforePadding&&b.beforePadding();
b.adjustForMinRange();!(e||b.axisPointRange||b.usePercentage||v)&&H(b.min)&&H(b.max)&&(k=b.max-b.min)&&(!H(x)&&h&&(b.min-=k*h),!H(t)&&B&&(b.max+=k*B));C(f.softMin)&&!C(b.userMin)&&f.softMin<b.min&&(b.min=x=f.softMin);C(f.softMax)&&!C(b.userMax)&&f.softMax>b.max&&(b.max=t=f.softMax);C(f.floor)&&(b.min=Math.min(Math.max(b.min,f.floor),Number.MAX_VALUE));C(f.ceiling)&&(b.max=Math.max(Math.min(b.max,f.ceiling),m(b.userMax,-Number.MAX_VALUE)));w&&H(b.dataMin)&&(q=q||0,!H(x)&&b.min<q&&b.dataMin>=q?b.min=
b.options.minRange?Math.min(q,b.max-b.minRange):q:!H(t)&&b.max>q&&b.dataMax<=q&&(b.max=b.options.minRange?Math.max(q,b.min+b.minRange):q));b.tickInterval=b.min===b.max||void 0===b.min||void 0===b.max?1:v&&!y&&p===b.linkedParent.options.tickPixelInterval?y=b.linkedParent.tickInterval:m(y,this.tickAmount?(b.max-b.min)/Math.max(this.tickAmount-1,1):void 0,e?1:(b.max-b.min)*p/Math.max(b.len,p));n&&!a&&b.series.forEach(function(a){a.processData(b.min!==b.oldMin||b.max!==b.oldMax)});b.setAxisTranslation(!0);
b.beforeSetTickPositions&&b.beforeSetTickPositions();b.postProcessTickInterval&&(b.tickInterval=b.postProcessTickInterval(b.tickInterval));b.pointRange&&!y&&(b.tickInterval=Math.max(b.pointRange,b.tickInterval));a=m(f.minTickInterval,b.isDatetimeAxis&&b.closestPointRange);!y&&b.tickInterval<a&&(b.tickInterval=a);A||l||y||(b.tickInterval=g(b.tickInterval,null,r(b.tickInterval),m(f.allowDecimals,!(.5<b.tickInterval&&5>b.tickInterval&&1E3<b.max&&9999>b.max)),!!this.tickAmount));this.tickAmount||(b.tickInterval=
b.unsquish());this.setTickPositions()},setTickPositions:function(){var a=this.options,b=a.tickPositions;var g=this.getMinorTickInterval();var k=a.tickPositioner,d=a.startOnTick,f=a.endOnTick;this.tickmarkOffset=this.categories&&"between"===a.tickmarkPlacement&&1===this.tickInterval?.5:0;this.minorTickInterval="auto"===g&&this.tickInterval?this.tickInterval/5:g;this.single=this.min===this.max&&H(this.min)&&!this.tickAmount&&(parseInt(this.min,10)===this.min||!1!==a.allowDecimals);this.tickPositions=
g=b&&b.slice();!g&&(!this.ordinalPositions&&(this.max-this.min)/this.tickInterval>Math.max(2*this.len,200)?(g=[this.min,this.max],c.error(19,!1,this.chart)):g=this.isDatetimeAxis?this.getTimeTicks(this.normalizeTimeTickInterval(this.tickInterval,a.units),this.min,this.max,a.startOfWeek,this.ordinalPositions,this.closestPointRange,!0):this.isLog?this.getLogTickPositions(this.tickInterval,this.min,this.max):this.getLinearTickPositions(this.tickInterval,this.min,this.max),g.length>this.len&&(g=[g[0],
g.pop()],g[0]===g[1]&&(g.length=1)),this.tickPositions=g,k&&(k=k.apply(this,[this.min,this.max])))&&(this.tickPositions=g=k);this.paddedTicks=g.slice(0);this.trimTicks(g,d,f);this.isLinked||(this.single&&2>g.length&&!this.categories&&(this.min-=.5,this.max+=.5),b||k||this.adjustTickAmount());F(this,"afterSetTickPositions")},trimTicks:function(a,b,g){var k=a[0],d=a[a.length-1],f=this.minPointOffset||0;F(this,"trimTicks");if(!this.isLinked){if(b&&-Infinity!==k)this.min=k;else for(;this.min-f>a[0];)a.shift();
if(g)this.max=d;else for(;this.max+f<a[a.length-1];)a.pop();0===a.length&&H(k)&&!this.options.tickPositions&&a.push((d+k)/2)}},alignToOthers:function(){var a={},b,g=this.options;!1===this.chart.options.chart.alignTicks||!1===g.alignTicks||!1===g.startOnTick||!1===g.endOnTick||this.isLog||this.chart[this.coll].forEach(function(g){var k=g.options;k=[g.horiz?k.left:k.top,k.width,k.height,k.pane].join();g.series.length&&(a[k]?b=!0:a[k]=1)});return b},getTickAmount:function(){var a=this.options,b=a.tickAmount,
g=a.tickPixelInterval;!H(a.tickInterval)&&this.len<g&&!this.isRadial&&!this.isLog&&a.startOnTick&&a.endOnTick&&(b=2);!b&&this.alignToOthers()&&(b=Math.ceil(this.len/g)+1);4>b&&(this.finalTickAmt=b,b=5);this.tickAmount=b},adjustTickAmount:function(){var a=this.options,b=this.tickInterval,g=this.tickPositions,k=this.tickAmount,f=this.finalTickAmt,l=g&&g.length,n=m(this.threshold,this.softThreshold?0:null),c;if(this.hasData()){if(l<k){for(c=this.min;g.length<k;)g.length%2||c===n?g.push(d(g[g.length-
1]+b)):g.unshift(d(g[0]-b));this.transA*=(l-1)/(k-1);this.min=a.startOnTick?g[0]:Math.min(this.min,g[0]);this.max=a.endOnTick?g[g.length-1]:Math.max(this.max,g[g.length-1])}else l>k&&(this.tickInterval*=2,this.setTickPositions());if(H(f)){for(b=a=g.length;b--;)(3===f&&1===b%2||2>=f&&0<b&&b<a-1)&&g.splice(b,1);this.finalTickAmt=void 0}}},setScale:function(){var a=this.series.some(function(a){return a.isDirtyData||a.isDirty||a.xAxis&&a.xAxis.isDirty}),b;this.oldMin=this.min;this.oldMax=this.max;this.oldAxisLength=
this.len;this.setAxisSize();(b=this.len!==this.oldAxisLength)||a||this.isLinked||this.forceRedraw||this.userMin!==this.oldUserMin||this.userMax!==this.oldUserMax||this.alignToOthers()?(this.resetStacks&&this.resetStacks(),this.forceRedraw=!1,this.getSeriesExtremes(),this.setTickInterval(),this.oldUserMin=this.userMin,this.oldUserMax=this.userMax,this.isDirty||(this.isDirty=b||this.min!==this.oldMin||this.max!==this.oldMax)):this.cleanStacks&&this.cleanStacks();F(this,"afterSetScale")},setExtremes:function(a,
b,g,k,d){var f=this,l=f.chart;g=m(g,!0);f.series.forEach(function(a){delete a.kdTree});d=t(d,{min:a,max:b});F(f,"setExtremes",d,function(){f.userMin=a;f.userMax=b;f.eventArgs=d;g&&l.redraw(k)})},zoom:function(a,b){var g=this.dataMin,k=this.dataMax,d=this.options,f=Math.min(g,m(d.min,g)),l=Math.max(k,m(d.max,k));a={newMin:a,newMax:b};F(this,"zoom",a,function(a){var b=a.newMin,d=a.newMax;if(b!==this.min||d!==this.max)this.allowZoomOutside||(H(g)&&(b<f&&(b=f),b>l&&(b=l)),H(k)&&(d<f&&(d=f),d>l&&(d=l))),
this.displayBtn=void 0!==b||void 0!==d,this.setExtremes(b,d,!1,void 0,{trigger:"zoom"});a.zoomed=!0});return a.zoomed},setAxisSize:function(){var a=this.chart,b=this.options,g=b.offsets||[0,0,0,0],k=this.horiz,d=this.width=Math.round(c.relativeLength(m(b.width,a.plotWidth-g[3]+g[1]),a.plotWidth)),f=this.height=Math.round(c.relativeLength(m(b.height,a.plotHeight-g[0]+g[2]),a.plotHeight)),l=this.top=Math.round(c.relativeLength(m(b.top,a.plotTop+g[0]),a.plotHeight,a.plotTop));b=this.left=Math.round(c.relativeLength(m(b.left,
a.plotLeft+g[3]),a.plotWidth,a.plotLeft));this.bottom=a.chartHeight-f-l;this.right=a.chartWidth-d-b;this.len=Math.max(k?d:f,0);this.pos=k?b:l},getExtremes:function(){var a=this.isLog;return{min:a?d(this.lin2log(this.min)):this.min,max:a?d(this.lin2log(this.max)):this.max,dataMin:this.dataMin,dataMax:this.dataMax,userMin:this.userMin,userMax:this.userMax}},getThreshold:function(a){var b=this.isLog,g=b?this.lin2log(this.min):this.min;b=b?this.lin2log(this.max):this.max;null===a||-Infinity===a?a=g:Infinity===
a?a=b:g>a?a=g:b<a&&(a=b);return this.translate(a,0,1,0,1)},autoLabelAlign:function(a){var b=(m(a,0)-90*this.side+720)%360;a={align:"center"};F(this,"autoLabelAlign",a,function(a){15<b&&165>b?a.align="right":195<b&&345>b&&(a.align="left")});return a.align},tickSize:function(a){var b=this.options,g=b[a+"Length"],k=m(b[a+"Width"],"tick"===a&&this.isXAxis&&!this.categories?1:0);if(k&&g){"inside"===b[a+"Position"]&&(g=-g);var d=[g,k]}a={tickSize:d};F(this,"afterTickSize",a);return a.tickSize},labelMetrics:function(){var a=
this.tickPositions&&this.tickPositions[0]||0;return this.chart.renderer.fontMetrics(this.options.labels.style&&this.options.labels.style.fontSize,this.ticks[a]&&this.ticks[a].label)},unsquish:function(){var a=this.options.labels,b=this.horiz,g=this.tickInterval,k=g,f=this.len/(((this.categories?1:0)+this.max-this.min)/g),n,c=a.rotation,v=this.labelMetrics(),B,h=Number.MAX_VALUE,r,F=this.max-this.min,y=function(a){var b=a/(f||1);b=1<b?Math.ceil(b):1;b*g>F&&Infinity!==a&&Infinity!==f&&F&&(b=Math.ceil(F/
g));return d(b*g)};b?(r=!a.staggerLines&&!a.step&&(H(c)?[c]:f<m(a.autoRotationLimit,80)&&a.autoRotation))&&r.forEach(function(a){if(a===c||a&&-90<=a&&90>=a){B=y(Math.abs(v.h/Math.sin(l*a)));var b=B+Math.abs(a/360);b<h&&(h=b,n=a,k=B)}}):a.step||(k=y(v.h));this.autoRotation=r;this.labelRotation=m(n,c);return k},getSlotWidth:function(a){var b=this.chart,g=this.horiz,k=this.options.labels,d=Math.max(this.tickPositions.length-(this.categories?0:1),1),f=b.margin[3];return a&&a.slotWidth||g&&2>(k.step||
0)&&!k.rotation&&(this.staggerLines||1)*this.len/d||!g&&(k.style&&parseInt(k.style.width,10)||f&&f-b.spacing[3]||.33*b.chartWidth)},renderUnsquish:function(){var a=this.chart,b=a.renderer,g=this.tickPositions,k=this.ticks,d=this.options.labels,f=d&&d.style||{},l=this.horiz,n=this.getSlotWidth(),c=Math.max(1,Math.round(n-2*(d.padding||5))),v={},B=this.labelMetrics(),h=d.style&&d.style.textOverflow,r=0;E(d.rotation)||(v.rotation=d.rotation||0);g.forEach(function(a){(a=k[a])&&a.label&&a.label.textPxLength>
r&&(r=a.label.textPxLength)});this.maxLabelLength=r;if(this.autoRotation)r>c&&r>B.h?v.rotation=this.labelRotation:this.labelRotation=0;else if(n){var m=c;if(!h){var F="clip";for(c=g.length;!l&&c--;){var y=g[c];if(y=k[y].label)y.styles&&"ellipsis"===y.styles.textOverflow?y.css({textOverflow:"clip"}):y.textPxLength>n&&y.css({width:n+"px"}),y.getBBox().height>this.len/g.length-(B.h-B.f)&&(y.specificTextOverflow="ellipsis")}}}v.rotation&&(m=r>.5*a.chartHeight?.33*a.chartHeight:r,h||(F="ellipsis"));if(this.labelAlign=
d.align||this.autoLabelAlign(this.labelRotation))v.align=this.labelAlign;g.forEach(function(a){var b=(a=k[a])&&a.label,g=f.width,d={};b&&(b.attr(v),a.shortenLabel?a.shortenLabel():m&&!g&&"nowrap"!==f.whiteSpace&&(m<b.textPxLength||"SPAN"===b.element.tagName)?(d.width=m,h||(d.textOverflow=b.specificTextOverflow||F),b.css(d)):b.styles&&b.styles.width&&!d.width&&!g&&b.css({width:null}),delete b.specificTextOverflow,a.rotation=v.rotation)},this);this.tickRotCorr=b.rotCorr(B.b,this.labelRotation||0,0!==
this.side)},hasData:function(){return this.series.some(function(a){return a.hasData()})||this.options.showEmpty&&H(this.min)&&H(this.max)},addTitle:function(a){var b=this.chart.renderer,g=this.horiz,k=this.opposite,d=this.options.title,f,l=this.chart.styledMode;this.axisTitle||((f=d.textAlign)||(f=(g?{low:"left",middle:"center",high:"right"}:{low:k?"right":"left",middle:"center",high:k?"left":"right"})[d.align]),this.axisTitle=b.text(d.text,0,0,d.useHTML).attr({zIndex:7,rotation:d.rotation||0,align:f}).addClass("highcharts-axis-title"),
l||this.axisTitle.css(n(d.style)),this.axisTitle.add(this.axisGroup),this.axisTitle.isNew=!0);l||d.style.width||this.isRadial||this.axisTitle.css({width:this.len});this.axisTitle[a?"show":"hide"](a)},generateTick:function(a){var b=this.ticks;b[a]?b[a].addLabel():b[a]=new B(this,a)},getOffset:function(){var a=this,b=a.chart,g=b.renderer,k=a.options,d=a.tickPositions,f=a.ticks,l=a.horiz,n=a.side,c=b.inverted&&!a.isZAxis?[1,0,3,2][n]:n,v,B=0,h=0,r=k.title,y=k.labels,p=0,e=b.axisOffset;b=b.clipOffset;
var q=[-1,1,1,-1][n],x=k.className,t=a.axisParent;var C=a.hasData();a.showAxis=v=C||m(k.showEmpty,!0);a.staggerLines=a.horiz&&y.staggerLines;a.axisGroup||(a.gridGroup=g.g("grid").attr({zIndex:k.gridZIndex||1}).addClass("highcharts-"+this.coll.toLowerCase()+"-grid "+(x||"")).add(t),a.axisGroup=g.g("axis").attr({zIndex:k.zIndex||2}).addClass("highcharts-"+this.coll.toLowerCase()+" "+(x||"")).add(t),a.labelGroup=g.g("axis-labels").attr({zIndex:y.zIndex||7}).addClass("highcharts-"+a.coll.toLowerCase()+
"-labels "+(x||"")).add(t));C||a.isLinked?(d.forEach(function(b,g){a.generateTick(b,g)}),a.renderUnsquish(),a.reserveSpaceDefault=0===n||2===n||{1:"left",3:"right"}[n]===a.labelAlign,m(y.reserveSpace,"center"===a.labelAlign?!0:null,a.reserveSpaceDefault)&&d.forEach(function(a){p=Math.max(f[a].getLabelSize(),p)}),a.staggerLines&&(p*=a.staggerLines),a.labelOffset=p*(a.opposite?-1:1)):w(f,function(a,b){a.destroy();delete f[b]});if(r&&r.text&&!1!==r.enabled&&(a.addTitle(v),v&&!1!==r.reserveSpace)){a.titleOffset=
B=a.axisTitle.getBBox()[l?"height":"width"];var z=r.offset;h=H(z)?0:m(r.margin,l?5:10)}a.renderLine();a.offset=q*m(k.offset,e[n]?e[n]+(k.margin||0):0);a.tickRotCorr=a.tickRotCorr||{x:0,y:0};g=0===n?-a.labelMetrics().h:2===n?a.tickRotCorr.y:0;h=Math.abs(p)+h;p&&(h=h-g+q*(l?m(y.y,a.tickRotCorr.y+8*q):y.x));a.axisTitleMargin=m(z,h);a.getMaxLabelDimensions&&(a.maxLabelDimensions=a.getMaxLabelDimensions(f,d));l=this.tickSize("tick");e[n]=Math.max(e[n],a.axisTitleMargin+B+q*a.offset,h,d&&d.length&&l?l[0]+
q*a.offset:0);k=k.offset?0:2*Math.floor(a.axisLine.strokeWidth()/2);b[c]=Math.max(b[c],k);F(this,"afterGetOffset")},getLinePath:function(a){var b=this.chart,g=this.opposite,k=this.offset,d=this.horiz,f=this.left+(g?this.width:0)+k;k=b.chartHeight-this.bottom-(g?this.height:0)+k;g&&(a*=-1);return b.renderer.crispLine(["M",d?this.left:f,d?k:this.top,"L",d?b.chartWidth-this.right:f,d?k:b.chartHeight-this.bottom],a)},renderLine:function(){this.axisLine||(this.axisLine=this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup),
this.chart.styledMode||this.axisLine.attr({stroke:this.options.lineColor,"stroke-width":this.options.lineWidth,zIndex:7}))},getTitlePosition:function(){var a=this.horiz,b=this.left,g=this.top,k=this.len,d=this.options.title,f=a?b:g,l=this.opposite,n=this.offset,c=d.x||0,v=d.y||0,B=this.axisTitle,h=this.chart.renderer.fontMetrics(d.style&&d.style.fontSize,B);B=Math.max(B.getBBox(null,0).height-h.h-1,0);k={low:f+(a?0:k),middle:f+k/2,high:f+(a?k:0)}[d.align];b=(a?g+this.height:b)+(a?1:-1)*(l?-1:1)*this.axisTitleMargin+
[-B,B,h.f,-B][this.side];a={x:a?k+c:b+(l?this.width:0)+n+c,y:a?b+v-(l?this.height:0)+n:k+v};F(this,"afterGetTitlePosition",{titlePosition:a});return a},renderMinorTick:function(a){var b=this.chart.hasRendered&&C(this.oldMin),g=this.minorTicks;g[a]||(g[a]=new B(this,a,"minor"));b&&g[a].isNew&&g[a].render(null,!0);g[a].render(null,!1,1)},renderTick:function(a,b){var g=this.isLinked,k=this.ticks,d=this.chart.hasRendered&&C(this.oldMin);if(!g||a>=this.min&&a<=this.max)k[a]||(k[a]=new B(this,a)),d&&k[a].isNew&&
k[a].render(b,!0,-1),k[a].render(b)},render:function(){var b=this,g=b.chart,k=b.options,d=b.isLog,f=b.isLinked,l=b.tickPositions,n=b.axisTitle,v=b.ticks,h=b.minorTicks,r=b.alternateBands,m=k.stackLabels,y=k.alternateGridColor,p=b.tickmarkOffset,e=b.axisLine,x=b.showAxis,t=a(g.renderer.globalAnimation),z,E;b.labelEdge.length=0;b.overlap=!1;[v,h,r].forEach(function(a){w(a,function(a){a.isActive=!1})});if(b.hasData()||f)b.minorTickInterval&&!b.categories&&b.getMinorTickPositions().forEach(function(a){b.renderMinorTick(a)}),
l.length&&(l.forEach(function(a,g){b.renderTick(a,g)}),p&&(0===b.min||b.single)&&(v[-1]||(v[-1]=new B(b,-1,null,!0)),v[-1].render(-1))),y&&l.forEach(function(a,k){E=void 0!==l[k+1]?l[k+1]+p:b.max-p;0===k%2&&a<b.max&&E<=b.max+(g.polar?-p:p)&&(r[a]||(r[a]=new c.PlotLineOrBand(b)),z=a+p,r[a].options={from:d?b.lin2log(z):z,to:d?b.lin2log(E):E,color:y},r[a].render(),r[a].isActive=!0)}),b._addedPlotLB||((k.plotLines||[]).concat(k.plotBands||[]).forEach(function(a){b.addPlotBandOrLine(a)}),b._addedPlotLB=
!0);[v,h,r].forEach(function(a){var b,k=[],d=t.duration;w(a,function(a,b){a.isActive||(a.render(b,!1,0),a.isActive=!1,k.push(b))});q(function(){for(b=k.length;b--;)a[k[b]]&&!a[k[b]].isActive&&(a[k[b]].destroy(),delete a[k[b]])},a!==r&&g.hasRendered&&d?d:0)});e&&(e[e.isPlaced?"animate":"attr"]({d:this.getLinePath(e.strokeWidth())}),e.isPlaced=!0,e[x?"show":"hide"](x));n&&x&&(k=b.getTitlePosition(),C(k.y)?(n[n.isNew?"attr":"animate"](k),n.isNew=!1):(n.attr("y",-9999),n.isNew=!0));m&&m.enabled&&b.renderStackTotals();
b.isDirty=!1;F(this,"afterRender")},redraw:function(){this.visible&&(this.render(),this.plotLinesAndBands.forEach(function(a){a.render()}));this.series.forEach(function(a){a.isDirty=!0})},keepProps:"extKey hcEvents names series userMax userMin".split(" "),destroy:function(a){var b=this,g=b.stacks,d=b.plotLinesAndBands,f;F(this,"destroy",{keepEvents:a});a||k(b);w(g,function(a,b){z(a);g[b]=null});[b.ticks,b.minorTicks,b.alternateBands].forEach(function(a){z(a)});if(d)for(a=d.length;a--;)d[a].destroy();
"stackTotalGroup axisLine axisTitle axisGroup gridGroup labelGroup cross scrollbar".split(" ").forEach(function(a){b[a]&&(b[a]=b[a].destroy())});for(f in b.plotLinesAndBandsGroups)b.plotLinesAndBandsGroups[f]=b.plotLinesAndBandsGroups[f].destroy();w(b,function(a,g){-1===b.keepProps.indexOf(g)&&delete b[g]})},drawCrosshair:function(a,g){var k,d=this.crosshair,f=m(d.snap,!0),l,n=this.cross;F(this,"drawCrosshair",{e:a,point:g});a||(a=this.cross&&this.cross.e);if(this.crosshair&&!1!==(H(g)||!f)){f?H(g)&&
(l=m("colorAxis"!==this.coll?g.crosshairPos:null,this.isXAxis?g.plotX:this.len-g.plotY)):l=a&&(this.horiz?a.chartX-this.pos:this.len-a.chartY+this.pos);H(l)&&(k=this.getPlotLinePath({value:g&&(this.isXAxis?g.x:m(g.stackY,g.y)),translatedValue:l})||null);if(!H(k)){this.hideCrosshair();return}f=this.categories&&!this.isRadial;n||(this.cross=n=this.chart.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-"+(f?"category ":"thin ")+d.className).attr({zIndex:m(d.zIndex,2)}).add(),this.chart.styledMode||
(n.attr({stroke:d.color||(f?b("#ccd6eb").setOpacity(.25).get():"#cccccc"),"stroke-width":m(d.width,1)}).css({"pointer-events":"none"}),d.dashStyle&&n.attr({dashstyle:d.dashStyle})));n.show().attr({d:k});f&&!d.width&&n.attr({"stroke-width":this.transA});this.cross.e=a}else this.hideCrosshair();F(this,"afterDrawCrosshair",{e:a,point:g})},hideCrosshair:function(){this.cross&&this.cross.hide();F(this,"afterHideCrosshair")}});return c.Axis=e});K(D,"parts/DateTimeAxis.js",[D["parts/Globals.js"]],function(c){var e=
c.Axis,I=c.getMagnitude,G=c.normalizeTickInterval,H=c.timeUnits;e.prototype.getTimeTicks=function(){return this.chart.time.getTimeTicks.apply(this.chart.time,arguments)};e.prototype.normalizeTimeTickInterval=function(c,e){var x=e||[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1,2]],["week",[1,2]],["month",[1,2,3,4,6]],["year",null]];e=x[x.length-1];var t=H[e[0]],z=e[1],w;for(w=0;w<x.length&&!(e=x[w],t=H[e[0]],
z=e[1],x[w+1]&&c<=(t*z[z.length-1]+H[x[w+1][0]])/2);w++);t===H.year&&c<5*t&&(z=[1,2,5]);c=G(c/t,z,"year"===e[0]?Math.max(I(c/t),1):1);return{unitRange:t,count:c,unitName:e[0]}}});K(D,"parts/LogarithmicAxis.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,e){var I=e.pick;e=c.Axis;var G=c.getMagnitude,H=c.normalizeTickInterval;e.prototype.getLogTickPositions=function(c,e,x,C){var t=this.options,w=this.len,m=[];C||(this._minorAutoInterval=null);if(.5<=c)c=Math.round(c),m=this.getLinearTickPositions(c,
e,x);else if(.08<=c){w=Math.floor(e);var p,q;for(t=.3<c?[1,2,4]:.15<c?[1,2,4,6,8]:[1,2,3,4,5,6,7,8,9];w<x+1&&!q;w++){var h=t.length;for(p=0;p<h&&!q;p++){var a=this.log2lin(this.lin2log(w)*t[p]);a>e&&(!C||b<=x)&&void 0!==b&&m.push(b);b>x&&(q=!0);var b=a}}}else e=this.lin2log(e),x=this.lin2log(x),c=C?this.getMinorTickInterval():t.tickInterval,c=I("auto"===c?null:c,this._minorAutoInterval,t.tickPixelInterval/(C?5:1)*(x-e)/((C?w/this.tickPositions.length:w)||1)),c=H(c,null,G(c)),m=this.getLinearTickPositions(c,
e,x).map(this.log2lin),C||(this._minorAutoInterval=c/5);C||(this.tickInterval=c);return m};e.prototype.log2lin=function(c){return Math.log(c)/Math.LN10};e.prototype.lin2log=function(c){return Math.pow(10,c)}});K(D,"parts/PlotLineOrBand.js",[D["parts/Globals.js"],D["parts/Axis.js"],D["parts/Utilities.js"]],function(c,e,I){var G=I.arrayMax,H=I.arrayMin,z=I.defined,t=I.destroyObjectProperties,x=I.erase,C=I.extend,E=I.objectEach,w=I.pick,m=c.merge;c.PlotLineOrBand=function(c,m){this.axis=c;m&&(this.options=
m,this.id=m.id)};c.PlotLineOrBand.prototype={render:function(){c.fireEvent(this,"render");var p=this,e=p.axis,h=e.horiz,a=p.options,b=a.label,d=p.label,f=a.to,l=a.from,F=a.value,y=z(l)&&z(f),r=z(F),n=p.svgElem,g=!n,k=[],v=a.color,B=w(a.zIndex,0),A=a.events;k={"class":"highcharts-plot-"+(y?"band ":"line ")+(a.className||"")};var u={},J=e.chart.renderer,L=y?"bands":"lines";e.isLog&&(l=e.log2lin(l),f=e.log2lin(f),F=e.log2lin(F));e.chart.styledMode||(r?(k.stroke=v||"#999999",k["stroke-width"]=w(a.width,
1),a.dashStyle&&(k.dashstyle=a.dashStyle)):y&&(k.fill=v||"#e6ebf5",a.borderWidth&&(k.stroke=a.borderColor,k["stroke-width"]=a.borderWidth)));u.zIndex=B;L+="-"+B;(v=e.plotLinesAndBandsGroups[L])||(e.plotLinesAndBandsGroups[L]=v=J.g("plot-"+L).attr(u).add());g&&(p.svgElem=n=J.path().attr(k).add(v));if(r)k=e.getPlotLinePath({value:F,lineWidth:n.strokeWidth(),acrossPanes:a.acrossPanes});else if(y)k=e.getPlotBandPath(l,f,a);else return;(g||!n.d)&&k&&k.length?(n.attr({d:k}),A&&E(A,function(a,b){n.on(b,
function(a){A[b].apply(p,[a])})})):n&&(k?(n.show(!0),n.animate({d:k})):n.d&&(n.hide(),d&&(p.label=d=d.destroy())));b&&(z(b.text)||z(b.formatter))&&k&&k.length&&0<e.width&&0<e.height&&!k.isFlat?(b=m({align:h&&y&&"center",x:h?!y&&4:10,verticalAlign:!h&&y&&"middle",y:h?y?16:10:y?6:-4,rotation:h&&!y&&90},b),this.renderLabel(b,k,y,B)):d&&d.hide();return p},renderLabel:function(c,m,h,a){var b=this.label,d=this.axis.chart.renderer;b||(b={align:c.textAlign||c.align,rotation:c.rotation,"class":"highcharts-plot-"+
(h?"band":"line")+"-label "+(c.className||"")},b.zIndex=a,a=this.getLabelText(c),this.label=b=d.text(a,0,0,c.useHTML).attr(b).add(),this.axis.chart.styledMode||b.css(c.style));d=m.xBounds||[m[1],m[4],h?m[6]:m[1]];m=m.yBounds||[m[2],m[5],h?m[7]:m[2]];h=H(d);a=H(m);b.align(c,!1,{x:h,y:a,width:G(d)-h,height:G(m)-a});b.show(!0)},getLabelText:function(c){return z(c.formatter)?c.formatter.call(this):c.text},destroy:function(){x(this.axis.plotLinesAndBands,this);delete this.axis;t(this)}};C(e.prototype,
{getPlotBandPath:function(c,m){var h=this.getPlotLinePath({value:m,force:!0,acrossPanes:this.options.acrossPanes}),a=this.getPlotLinePath({value:c,force:!0,acrossPanes:this.options.acrossPanes}),b=[],d=this.horiz,f=1;c=c<this.min&&m<this.min||c>this.max&&m>this.max;if(a&&h){if(c){var l=a.toString()===h.toString();f=0}for(c=0;c<a.length;c+=6)d&&h[c+1]===a[c+1]?(h[c+1]+=f,h[c+4]+=f):d||h[c+2]!==a[c+2]||(h[c+2]+=f,h[c+5]+=f),b.push("M",a[c+1],a[c+2],"L",a[c+4],a[c+5],h[c+4],h[c+5],h[c+1],h[c+2],"z"),
b.isFlat=l}return b},addPlotBand:function(c){return this.addPlotBandOrLine(c,"plotBands")},addPlotLine:function(c){return this.addPlotBandOrLine(c,"plotLines")},addPlotBandOrLine:function(m,e){var h=(new c.PlotLineOrBand(this,m)).render(),a=this.userOptions;if(h){if(e){var b=a[e]||[];b.push(m);a[e]=b}this.plotLinesAndBands.push(h)}return h},removePlotBandOrLine:function(c){for(var m=this.plotLinesAndBands,h=this.options,a=this.userOptions,b=m.length;b--;)m[b].id===c&&m[b].destroy();[h.plotLines||
[],a.plotLines||[],h.plotBands||[],a.plotBands||[]].forEach(function(a){for(b=a.length;b--;)a[b].id===c&&x(a,a[b])})},removePlotBand:function(c){this.removePlotBandOrLine(c)},removePlotLine:function(c){this.removePlotBandOrLine(c)}})});K(D,"parts/Tooltip.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,e){var I=e.defined,G=e.discardElement,H=e.extend,z=e.isNumber,t=e.isString,x=e.pick,C=e.splat,E=e.syncTimeout;"";var w=c.doc,m=c.format,p=c.merge,q=c.timeUnits;c.Tooltip=function(){this.init.apply(this,
arguments)};c.Tooltip.prototype={init:function(c,a){this.chart=c;this.options=a;this.crosshairs=[];this.now={x:0,y:0};this.isHidden=!0;this.split=a.split&&!c.inverted;this.shared=a.shared||this.split;this.outside=x(a.outside,!(!c.scrollablePixelsX&&!c.scrollablePixelsY))},cleanSplit:function(c){this.chart.series.forEach(function(a){var b=a&&a.tt;b&&(!b.isActive||c?a.tt=b.destroy():b.isActive=!1)})},applyFilter:function(){var c=this.chart;c.renderer.definition({tagName:"filter",id:"drop-shadow-"+c.index,
opacity:.5,children:[{tagName:"feGaussianBlur","in":"SourceAlpha",stdDeviation:1},{tagName:"feOffset",dx:1,dy:1},{tagName:"feComponentTransfer",children:[{tagName:"feFuncA",type:"linear",slope:.3}]},{tagName:"feMerge",children:[{tagName:"feMergeNode"},{tagName:"feMergeNode","in":"SourceGraphic"}]}]});c.renderer.definition({tagName:"style",textContent:".highcharts-tooltip-"+c.index+"{filter:url(#drop-shadow-"+c.index+")}"})},getLabel:function(){var h=this,a=this.chart.renderer,b=this.chart.styledMode,
d=this.options,f="tooltip"+(I(d.className)?" "+d.className:""),l;if(!this.label){this.outside&&(this.container=l=c.doc.createElement("div"),l.className="highcharts-tooltip-container",c.css(l,{position:"absolute",top:"1px",pointerEvents:d.style&&d.style.pointerEvents,zIndex:3}),c.doc.body.appendChild(l),this.renderer=a=new c.Renderer(l,0,0,{},void 0,void 0,a.styledMode));this.split?this.label=a.g(f):(this.label=a.label("",0,0,d.shape||"callout",null,null,d.useHTML,null,f).attr({padding:d.padding,r:d.borderRadius}),
b||this.label.attr({fill:d.backgroundColor,"stroke-width":d.borderWidth}).css(d.style).shadow(d.shadow));b&&(this.applyFilter(),this.label.addClass("highcharts-tooltip-"+this.chart.index));if(h.outside&&!h.split){var m={x:this.label.xSetter,y:this.label.ySetter};this.label.xSetter=function(a,b){m[b].call(this.label,h.distance);l.style.left=a+"px"};this.label.ySetter=function(a,b){m[b].call(this.label,h.distance);l.style.top=a+"px"}}this.label.attr({zIndex:8}).add()}return this.label},update:function(c){this.destroy();
p(!0,this.chart.options.tooltip.userOptions,c);this.init(this.chart,p(!0,this.options,c))},destroy:function(){this.label&&(this.label=this.label.destroy());this.split&&this.tt&&(this.cleanSplit(this.chart,!0),this.tt=this.tt.destroy());this.renderer&&(this.renderer=this.renderer.destroy(),G(this.container));c.clearTimeout(this.hideTimer);c.clearTimeout(this.tooltipTimeout)},move:function(h,a,b,d){var f=this,l=f.now,m=!1!==f.options.animation&&!f.isHidden&&(1<Math.abs(h-l.x)||1<Math.abs(a-l.y)),y=
f.followPointer||1<f.len;H(l,{x:m?(2*l.x+h)/3:h,y:m?(l.y+a)/2:a,anchorX:y?void 0:m?(2*l.anchorX+b)/3:b,anchorY:y?void 0:m?(l.anchorY+d)/2:d});f.getLabel().attr(l);m&&(c.clearTimeout(this.tooltipTimeout),this.tooltipTimeout=setTimeout(function(){f&&f.move(h,a,b,d)},32))},hide:function(h){var a=this;c.clearTimeout(this.hideTimer);h=x(h,this.options.hideDelay,500);this.isHidden||(this.hideTimer=E(function(){a.getLabel()[h?"fadeOut":"hide"]();a.isHidden=!0},h))},getAnchor:function(c,a){var b=this.chart,
d=b.pointer,f=b.inverted,l=b.plotTop,h=b.plotLeft,m=0,r=0,n,g;c=C(c);this.followPointer&&a?(void 0===a.chartX&&(a=d.normalize(a)),c=[a.chartX-b.plotLeft,a.chartY-l]):c[0].tooltipPos?c=c[0].tooltipPos:(c.forEach(function(a){n=a.series.yAxis;g=a.series.xAxis;m+=a.plotX+(!f&&g?g.left-h:0);r+=(a.plotLow?(a.plotLow+a.plotHigh)/2:a.plotY)+(!f&&n?n.top-l:0)}),m/=c.length,r/=c.length,c=[f?b.plotWidth-r:m,this.shared&&!f&&1<c.length&&a?a.chartY-l:f?b.plotHeight-m:r]);return c.map(Math.round)},getPosition:function(c,
a,b){var d=this.chart,f=this.distance,l={},h=d.inverted&&b.h||0,m,r=this.outside,n=r?w.documentElement.clientWidth-2*f:d.chartWidth,g=r?Math.max(w.body.scrollHeight,w.documentElement.scrollHeight,w.body.offsetHeight,w.documentElement.offsetHeight,w.documentElement.clientHeight):d.chartHeight,k=d.pointer.getChartPosition(),v=d.containerScaling,B=function(a){return v?a*v.scaleX:a},A=function(a){return v?a*v.scaleY:a},u=function(l){var v="x"===l;return[l,v?n:g,v?c:a].concat(r?[v?B(c):A(a),v?k.left-f+
B(b.plotX+d.plotLeft):k.top-f+A(b.plotY+d.plotTop),0,v?n:g]:[v?c:a,v?b.plotX+d.plotLeft:b.plotY+d.plotTop,v?d.plotLeft:d.plotTop,v?d.plotLeft+d.plotWidth:d.plotTop+d.plotHeight])},e=u("y"),p=u("x"),q=!this.followPointer&&x(b.ttBelow,!d.inverted===!!b.negative),t=function(a,b,g,k,d,c,n){var v="y"===a?A(f):B(f),u=(g-k)/2,r=k<d-f,m=d+f+k<b,F=d-v-g+u;d=d+v-u;if(q&&m)l[a]=d;else if(!q&&r)l[a]=F;else if(r)l[a]=Math.min(n-k,0>F-h?F:F-h);else if(m)l[a]=Math.max(c,d+h+g>b?d:d+h);else return!1},C=function(a,
b,g,k,d){var c;d<f||d>b-f?c=!1:l[a]=d<g/2?1:d>b-k/2?b-k-2:d-g/2;return c},M=function(a){var b=e;e=p;p=b;m=a},N=function(){!1!==t.apply(0,e)?!1!==C.apply(0,p)||m||(M(!0),N()):m?l.x=l.y=0:(M(!0),N())};(d.inverted||1<this.len)&&M();N();return l},defaultFormatter:function(c){var a=this.points||C(this);var b=[c.tooltipFooterHeaderFormatter(a[0])];b=b.concat(c.bodyFormatter(a));b.push(c.tooltipFooterHeaderFormatter(a[0],!0));return b},refresh:function(h,a){var b=this.chart,d=this.options,f=h,l={},m=[],
y=d.formatter||this.defaultFormatter;l=this.shared;var r=b.styledMode;if(d.enabled){c.clearTimeout(this.hideTimer);this.followPointer=C(f)[0].series.tooltipOptions.followPointer;var n=this.getAnchor(f,a);a=n[0];var g=n[1];!l||f.series&&f.series.noSharedTooltip?l=f.getLabelConfig():(b.pointer.applyInactiveState(f),f.forEach(function(a){a.setState("hover");m.push(a.getLabelConfig())}),l={x:f[0].category,y:f[0].y},l.points=m,f=f[0]);this.len=m.length;b=y.call(l,this);y=f.series;this.distance=x(y.tooltipOptions.distance,
16);!1===b?this.hide():(this.split?this.renderSplit(b,C(h)):(h=this.getLabel(),d.style.width&&!r||h.css({width:this.chart.spacingBox.width}),h.attr({text:b&&b.join?b.join(""):b}),h.removeClass(/highcharts-color-[\d]+/g).addClass("highcharts-color-"+x(f.colorIndex,y.colorIndex)),r||h.attr({stroke:d.borderColor||f.color||y.color||"#666666"}),this.updatePosition({plotX:a,plotY:g,negative:f.negative,ttBelow:f.ttBelow,h:n[2]||0})),this.isHidden&&this.label&&this.label.attr({opacity:1}).show(),this.isHidden=
!1);c.fireEvent(this,"refresh")}},renderSplit:function(h,a){var b=this,d=[],f=this.chart,l=f.renderer,m=!0,y=this.options,r=0,n,g=this.getLabel(),k=f.plotTop;t(h)&&(h=[!1,h]);h.slice(0,a.length+1).forEach(function(c,v){if(!1!==c&&""!==c){v=a[v-1]||{isHeader:!0,plotX:a[0].plotX,plotY:f.plotHeight};var B=v.series||b,u=B.tt,h=v.series||{},A="highcharts-color-"+x(v.colorIndex,h.colorIndex,"none");u||(u={padding:y.padding,r:y.borderRadius},f.styledMode||(u.fill=y.backgroundColor,u["stroke-width"]=y.borderWidth),
B.tt=u=l.label(null,null,null,(v.isHeader?y.headerShape:y.shape)||"callout",null,null,y.useHTML).addClass(v.isHeader?"highcharts-tooltip-header ":"highcharts-tooltip-box "+A).attr(u).add(g));u.isActive=!0;u.attr({text:c});f.styledMode||u.css(y.style).shadow(y.shadow).attr({stroke:y.borderColor||v.color||h.color||"#333333"});c=u.getBBox();A=c.width+u.strokeWidth();v.isHeader?(r=c.height,f.xAxis[0].opposite&&(n=!0,k-=r),c=Math.max(0,Math.min(v.plotX+f.plotLeft-A/2,f.chartWidth+(f.scrollablePixelsX?
f.scrollablePixelsX-f.marginRight:0)-A))):c=v.plotX+f.plotLeft-x(y.distance,16)-A;0>c&&(m=!1);v.isHeader?h=n?-r:f.plotHeight+r:(h=h.yAxis,h=h.pos-k+Math.max(0,Math.min(v.plotY||0,h.len)));d.push({target:h,rank:v.isHeader?1:0,size:B.tt.getBBox().height+1,point:v,x:c,tt:u})}});this.cleanSplit();y.positioner&&d.forEach(function(a){var g=y.positioner.call(b,a.tt.getBBox().width,a.size,a.point);a.x=g.x;a.align=0;a.target=g.y;a.rank=x(g.rank,a.rank)});c.distribute(d,f.plotHeight+r);d.forEach(function(a){var g=
a.point,d=g.series,c=d&&d.yAxis;a.tt.attr({visibility:void 0===a.pos?"hidden":"inherit",x:m||g.isHeader||y.positioner?a.x:g.plotX+f.plotLeft+b.distance,y:a.pos+k,anchorX:g.isHeader?g.plotX+f.plotLeft:g.plotX+d.xAxis.pos,anchorY:g.isHeader?f.plotTop+f.plotHeight/2:c.pos+Math.max(0,Math.min(g.plotY,c.len))})});var v=b.container;h=b.renderer;if(b.outside&&v&&h){var B=f.pointer.getChartPosition();v.style.left=B.left+"px";v.style.top=B.top+"px";v=g.getBBox();h.setSize(v.width+v.x,v.height+v.y,!1)}},updatePosition:function(h){var a=
this.chart,b=a.pointer,d=this.getLabel(),f=h.plotX+a.plotLeft,l=h.plotY+a.plotTop;b=b.getChartPosition();h=(this.options.positioner||this.getPosition).call(this,d.width,d.height,h);if(this.outside){var m=(this.options.borderWidth||0)+2*this.distance;this.renderer.setSize(d.width+m,d.height+m,!1);if(a=a.containerScaling)c.css(this.container,{transform:"scale("+a.scaleX+", "+a.scaleY+")"}),f*=a.scaleX,l*=a.scaleY;f+=b.left-h.x;l+=b.top-h.y}this.move(Math.round(h.x),Math.round(h.y||0),f,l)},getDateFormat:function(c,
a,b,d){var f=this.chart.time,l=f.dateFormat("%m-%d %H:%M:%S.%L",a),h={millisecond:15,second:12,minute:9,hour:6,day:3},m="millisecond";for(r in q){if(c===q.week&&+f.dateFormat("%w",a)===b&&"00:00:00.000"===l.substr(6)){var r="week";break}if(q[r]>c){r=m;break}if(h[r]&&l.substr(h[r])!=="01-01 00:00:00.000".substr(h[r]))break;"week"!==r&&(m=r)}if(r)var n=f.resolveDTLFormat(d[r]).main;return n},getXDateFormat:function(c,a,b){a=a.dateTimeLabelFormats;var d=b&&b.closestPointRange;return(d?this.getDateFormat(d,
c.x,b.options.startOfWeek,a):a.day)||a.year},tooltipFooterHeaderFormatter:function(h,a){var b=a?"footer":"header",d=h.series,f=d.tooltipOptions,l=f.xDateFormat,F=d.xAxis,e=F&&"datetime"===F.options.type&&z(h.key),r=f[b+"Format"];a={isFooter:a,labelConfig:h};c.fireEvent(this,"headerFormatter",a,function(a){e&&!l&&(l=this.getXDateFormat(h,f,F));e&&l&&(h.point&&h.point.tooltipDateKeys||["key"]).forEach(function(a){r=r.replace("{point."+a+"}","{point."+a+":"+l+"}")});d.chart.styledMode&&(r=this.styledModeFormat(r));
a.text=m(r,{point:h,series:d},this.chart.time)});return a.text},bodyFormatter:function(c){return c.map(function(a){var b=a.series.tooltipOptions;return(b[(a.point.formatPrefix||"point")+"Formatter"]||a.point.tooltipFormatter).call(a.point,b[(a.point.formatPrefix||"point")+"Format"]||"")})},styledModeFormat:function(c){return c.replace('style="font-size: 10px"','class="highcharts-header"').replace(/style="color:{(point|series)\.color}"/g,'class="highcharts-color-{$1.colorIndex}"')}}});K(D,"parts/Pointer.js",
[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,e){var I=e.attr,G=e.defined,H=e.extend,z=e.isNumber,t=e.isObject,x=e.objectEach,C=e.pick,E=e.splat,w=c.addEvent,m=c.charts,p=c.color,q=c.css,h=c.find,a=c.fireEvent,b=c.offset,d=c.Tooltip;c.Pointer=function(a,b){this.init(a,b)};c.Pointer.prototype={init:function(a,b){this.options=b;this.chart=a;this.runChartClick=b.chart.events&&!!b.chart.events.click;this.pinchDown=[];this.lastValidTouch={};d&&(a.tooltip=new d(a,b.tooltip),this.followTouchMove=
C(b.tooltip.followTouchMove,!0));this.setDOMEvents()},zoomOption:function(a){var b=this.chart,d=b.options.chart,f=d.zoomType||"";b=b.inverted;/touch/.test(a.type)&&(f=C(d.pinchType,f));this.zoomX=a=/x/.test(f);this.zoomY=f=/y/.test(f);this.zoomHor=a&&!b||f&&b;this.zoomVert=f&&!b||a&&b;this.hasZoom=a||f},getChartPosition:function(){return this.chartPosition||(this.chartPosition=b(this.chart.container))},normalize:function(a,b){var d=a.touches?a.touches.length?a.touches.item(0):a.changedTouches[0]:
a;b||(b=this.getChartPosition());var f=d.pageX-b.left;b=d.pageY-b.top;if(d=this.chart.containerScaling)f/=d.scaleX,b/=d.scaleY;return H(a,{chartX:Math.round(f),chartY:Math.round(b)})},getCoordinates:function(a){var b={xAxis:[],yAxis:[]};this.chart.axes.forEach(function(d){b[d.isXAxis?"xAxis":"yAxis"].push({axis:d,value:d.toValue(a[d.horiz?"chartX":"chartY"])})});return b},findNearestKDPoint:function(a,b,d){var f;a.forEach(function(a){var c=!(a.noSharedTooltip&&b)&&0>a.options.findNearestPointBy.indexOf("y");
a=a.searchPoint(d,c);if((c=t(a,!0))&&!(c=!t(f,!0))){c=f.distX-a.distX;var g=f.dist-a.dist,k=(a.series.group&&a.series.group.zIndex)-(f.series.group&&f.series.group.zIndex);c=0<(0!==c&&b?c:0!==g?g:0!==k?k:f.series.index>a.series.index?-1:1)}c&&(f=a)});return f},getPointFromEvent:function(a){a=a.target;for(var b;a&&!b;)b=a.point,a=a.parentNode;return b},getChartCoordinatesFromPoint:function(a,b){var d=a.series,f=d.xAxis;d=d.yAxis;var c=C(a.clientX,a.plotX),l=a.shapeArgs;if(f&&d)return b?{chartX:f.len+
f.pos-c,chartY:d.len+d.pos-a.plotY}:{chartX:c+f.pos,chartY:a.plotY+d.pos};if(l&&l.x&&l.y)return{chartX:l.x,chartY:l.y}},getHoverData:function(a,b,d,c,m,n){var g,k=[];c=!(!c||!a);var f=b&&!b.stickyTracking?[b]:d.filter(function(a){return a.visible&&!(!m&&a.directTouch)&&C(a.options.enableMouseTracking,!0)&&a.stickyTracking});b=(g=c||!n?a:this.findNearestKDPoint(f,m,n))&&g.series;g&&(m&&!b.noSharedTooltip?(f=d.filter(function(a){return a.visible&&!(!m&&a.directTouch)&&C(a.options.enableMouseTracking,
!0)&&!a.noSharedTooltip}),f.forEach(function(a){var b=h(a.points,function(a){return a.x===g.x&&!a.isNull});t(b)&&(a.chart.isBoosting&&(b=a.getPoint(b)),k.push(b))})):k.push(g));return{hoverPoint:g,hoverSeries:b,hoverPoints:k}},runPointActions:function(a,b){var d=this.chart,f=d.tooltip&&d.tooltip.options.enabled?d.tooltip:void 0,l=f?f.shared:!1,n=b||d.hoverPoint,g=n&&n.series||d.hoverSeries;g=this.getHoverData(n,g,d.series,(!a||"touchmove"!==a.type)&&(!!b||g&&g.directTouch&&this.isDirectTouch),l,a);
n=g.hoverPoint;var k=g.hoverPoints;b=(g=g.hoverSeries)&&g.tooltipOptions.followPointer;l=l&&g&&!g.noSharedTooltip;if(n&&(n!==d.hoverPoint||f&&f.isHidden)){(d.hoverPoints||[]).forEach(function(a){-1===k.indexOf(a)&&a.setState()});if(d.hoverSeries!==g)g.onMouseOver();this.applyInactiveState(k);(k||[]).forEach(function(a){a.setState("hover")});d.hoverPoint&&d.hoverPoint.firePointEvent("mouseOut");if(!n.series)return;n.firePointEvent("mouseOver");d.hoverPoints=k;d.hoverPoint=n;f&&f.refresh(l?k:n,a)}else b&&
f&&!f.isHidden&&(n=f.getAnchor([{}],a),f.updatePosition({plotX:n[0],plotY:n[1]}));this.unDocMouseMove||(this.unDocMouseMove=w(d.container.ownerDocument,"mousemove",function(a){var b=m[c.hoverChartIndex];if(b)b.pointer.onDocumentMouseMove(a)}));d.axes.forEach(function(b){var g=C(b.crosshair.snap,!0),d=g?c.find(k,function(a){return a.series[b.coll]===b}):void 0;d||!g?b.drawCrosshair(a,d):b.hideCrosshair()})},applyInactiveState:function(a){var b=[],d;(a||[]).forEach(function(a){d=a.series;b.push(d);
d.linkedParent&&b.push(d.linkedParent);d.linkedSeries&&(b=b.concat(d.linkedSeries));d.navigatorSeries&&b.push(d.navigatorSeries)});this.chart.series.forEach(function(a){-1===b.indexOf(a)?a.setState("inactive",!0):a.options.inactiveOtherPoints&&a.setAllPointsToState("inactive")})},reset:function(a,b){var d=this.chart,c=d.hoverSeries,f=d.hoverPoint,l=d.hoverPoints,g=d.tooltip,k=g&&g.shared?l:f;a&&k&&E(k).forEach(function(b){b.series.isCartesian&&void 0===b.plotX&&(a=!1)});if(a)g&&k&&E(k).length&&(g.refresh(k),
g.shared&&l?l.forEach(function(a){a.setState(a.state,!0);a.series.isCartesian&&(a.series.xAxis.crosshair&&a.series.xAxis.drawCrosshair(null,a),a.series.yAxis.crosshair&&a.series.yAxis.drawCrosshair(null,a))}):f&&(f.setState(f.state,!0),d.axes.forEach(function(a){a.crosshair&&a.drawCrosshair(null,f)})));else{if(f)f.onMouseOut();l&&l.forEach(function(a){a.setState()});if(c)c.onMouseOut();g&&g.hide(b);this.unDocMouseMove&&(this.unDocMouseMove=this.unDocMouseMove());d.axes.forEach(function(a){a.hideCrosshair()});
this.hoverX=d.hoverPoints=d.hoverPoint=null}},scaleGroups:function(a,b){var d=this.chart,f;d.series.forEach(function(c){f=a||c.getPlotBox();c.xAxis&&c.xAxis.zoomEnabled&&c.group&&(c.group.attr(f),c.markerGroup&&(c.markerGroup.attr(f),c.markerGroup.clip(b?d.clipRect:null)),c.dataLabelsGroup&&c.dataLabelsGroup.attr(f))});d.clipRect.attr(b||d.clipBox)},dragStart:function(a){var b=this.chart;b.mouseIsDown=a.type;b.cancelClick=!1;b.mouseDownX=this.mouseDownX=a.chartX;b.mouseDownY=this.mouseDownY=a.chartY},
drag:function(a){var b=this.chart,d=b.options.chart,c=a.chartX,f=a.chartY,n=this.zoomHor,g=this.zoomVert,k=b.plotLeft,v=b.plotTop,B=b.plotWidth,h=b.plotHeight,u=this.selectionMarker,m=this.mouseDownX,e=this.mouseDownY,w=d.panKey&&a[d.panKey+"Key"];if(!u||!u.touch)if(c<k?c=k:c>k+B&&(c=k+B),f<v?f=v:f>v+h&&(f=v+h),this.hasDragged=Math.sqrt(Math.pow(m-c,2)+Math.pow(e-f,2)),10<this.hasDragged){var q=b.isInsidePlot(m-k,e-v);b.hasCartesianSeries&&(this.zoomX||this.zoomY)&&q&&!w&&!u&&(this.selectionMarker=
u=b.renderer.rect(k,v,n?1:B,g?1:h,0).attr({"class":"highcharts-selection-marker",zIndex:7}).add(),b.styledMode||u.attr({fill:d.selectionMarkerFill||p("#335cad").setOpacity(.25).get()}));u&&n&&(c-=m,u.attr({width:Math.abs(c),x:(0<c?0:c)+m}));u&&g&&(c=f-e,u.attr({height:Math.abs(c),y:(0<c?0:c)+e}));q&&!u&&d.panning&&b.pan(a,d.panning)}},drop:function(b){var d=this,c=this.chart,f=this.hasPinched;if(this.selectionMarker){var h={originalEvent:b,xAxis:[],yAxis:[]},n=this.selectionMarker,g=n.attr?n.attr("x"):
n.x,k=n.attr?n.attr("y"):n.y,v=n.attr?n.attr("width"):n.width,B=n.attr?n.attr("height"):n.height,m;if(this.hasDragged||f)c.axes.forEach(function(a){if(a.zoomEnabled&&G(a.min)&&(f||d[{xAxis:"zoomX",yAxis:"zoomY"}[a.coll]])){var c=a.horiz,l="touchend"===b.type?a.minPixelPadding:0,n=a.toValue((c?g:k)+l);c=a.toValue((c?g+v:k+B)-l);h[a.coll].push({axis:a,min:Math.min(n,c),max:Math.max(n,c)});m=!0}}),m&&a(c,"selection",h,function(a){c.zoom(H(a,f?{animation:!1}:null))});z(c.index)&&(this.selectionMarker=
this.selectionMarker.destroy());f&&this.scaleGroups()}c&&z(c.index)&&(q(c.container,{cursor:c._cursor}),c.cancelClick=10<this.hasDragged,c.mouseIsDown=this.hasDragged=this.hasPinched=!1,this.pinchDown=[])},onContainerMouseDown:function(a){a=this.normalize(a);2!==a.button&&(this.zoomOption(a),a.preventDefault&&a.preventDefault(),this.dragStart(a))},onDocumentMouseUp:function(a){m[c.hoverChartIndex]&&m[c.hoverChartIndex].pointer.drop(a)},onDocumentMouseMove:function(a){var b=this.chart,d=this.chartPosition;
a=this.normalize(a,d);!d||this.inClass(a.target,"highcharts-tracker")||b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop)||this.reset()},onContainerMouseLeave:function(a){var b=m[c.hoverChartIndex];b&&(a.relatedTarget||a.toElement)&&(b.pointer.reset(),b.pointer.chartPosition=void 0)},onContainerMouseMove:function(a){var b=this.chart;G(c.hoverChartIndex)&&m[c.hoverChartIndex]&&m[c.hoverChartIndex].mouseIsDown||(c.hoverChartIndex=b.index);a=this.normalize(a);a.preventDefault||(a.returnValue=!1);
"mousedown"===b.mouseIsDown&&this.drag(a);!this.inClass(a.target,"highcharts-tracker")&&!b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop)||b.openMenu||this.runPointActions(a)},inClass:function(a,b){for(var d;a;){if(d=I(a,"class")){if(-1!==d.indexOf(b))return!0;if(-1!==d.indexOf("highcharts-container"))return!1}a=a.parentNode}},onTrackerMouseOut:function(a){var b=this.chart.hoverSeries;a=a.relatedTarget||a.toElement;this.isDirectTouch=!1;if(!(!b||!a||b.stickyTracking||this.inClass(a,"highcharts-tooltip")||
this.inClass(a,"highcharts-series-"+b.index)&&this.inClass(a,"highcharts-tracker")))b.onMouseOut()},onContainerClick:function(b){var d=this.chart,c=d.hoverPoint,f=d.plotLeft,h=d.plotTop;b=this.normalize(b);d.cancelClick||(c&&this.inClass(b.target,"highcharts-tracker")?(a(c.series,"click",H(b,{point:c})),d.hoverPoint&&c.firePointEvent("click",b)):(H(b,this.getCoordinates(b)),d.isInsidePlot(b.chartX-f,b.chartY-h)&&a(d,"click",b)))},setDOMEvents:function(){var a=this,b=a.chart.container,d=b.ownerDocument;
b.onmousedown=function(b){a.onContainerMouseDown(b)};b.onmousemove=function(b){a.onContainerMouseMove(b)};b.onclick=function(b){a.onContainerClick(b)};this.unbindContainerMouseLeave=w(b,"mouseleave",a.onContainerMouseLeave);c.unbindDocumentMouseUp||(c.unbindDocumentMouseUp=w(d,"mouseup",a.onDocumentMouseUp));c.hasTouch&&(w(b,"touchstart",function(b){a.onContainerTouchStart(b)}),w(b,"touchmove",function(b){a.onContainerTouchMove(b)}),c.unbindDocumentTouchEnd||(c.unbindDocumentTouchEnd=w(d,"touchend",
a.onDocumentTouchEnd)))},destroy:function(){var a=this;a.unDocMouseMove&&a.unDocMouseMove();this.unbindContainerMouseLeave();c.chartCount||(c.unbindDocumentMouseUp&&(c.unbindDocumentMouseUp=c.unbindDocumentMouseUp()),c.unbindDocumentTouchEnd&&(c.unbindDocumentTouchEnd=c.unbindDocumentTouchEnd()));clearInterval(a.tooltipTimeout);x(a,function(b,d){a[d]=null})}}});K(D,"parts/TouchPointer.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,e){var I=e.extend,G=e.pick,H=c.charts,z=c.noop;I(c.Pointer.prototype,
{pinchTranslate:function(c,e,C,z,w,m){this.zoomHor&&this.pinchTranslateDirection(!0,c,e,C,z,w,m);this.zoomVert&&this.pinchTranslateDirection(!1,c,e,C,z,w,m)},pinchTranslateDirection:function(c,e,C,z,w,m,p,q){var h=this.chart,a=c?"x":"y",b=c?"X":"Y",d="chart"+b,f=c?"width":"height",l=h["plot"+(c?"Left":"Top")],F,y,r=q||1,n=h.inverted,g=h.bounds[c?"h":"v"],k=1===e.length,v=e[0][d],B=C[0][d],A=!k&&e[1][d],u=!k&&C[1][d];C=function(){!k&&20<Math.abs(v-A)&&(r=q||Math.abs(B-u)/Math.abs(v-A));y=(l-B)/r+v;
F=h["plot"+(c?"Width":"Height")]/r};C();e=y;if(e<g.min){e=g.min;var J=!0}else e+F>g.max&&(e=g.max-F,J=!0);J?(B-=.8*(B-p[a][0]),k||(u-=.8*(u-p[a][1])),C()):p[a]=[B,u];n||(m[a]=y-l,m[f]=F);m=n?1/r:r;w[f]=F;w[a]=e;z[n?c?"scaleY":"scaleX":"scale"+b]=r;z["translate"+b]=m*l+(B-m*v)},pinch:function(c){var e=this,t=e.chart,E=e.pinchDown,w=c.touches,m=w.length,p=e.lastValidTouch,q=e.hasZoom,h=e.selectionMarker,a={},b=1===m&&(e.inClass(c.target,"highcharts-tracker")&&t.runTrackerClick||e.runChartClick),d={};
1<m&&(e.initiated=!0);q&&e.initiated&&!b&&c.preventDefault();[].map.call(w,function(a){return e.normalize(a)});"touchstart"===c.type?([].forEach.call(w,function(a,b){E[b]={chartX:a.chartX,chartY:a.chartY}}),p.x=[E[0].chartX,E[1]&&E[1].chartX],p.y=[E[0].chartY,E[1]&&E[1].chartY],t.axes.forEach(function(a){if(a.zoomEnabled){var b=t.bounds[a.horiz?"h":"v"],d=a.minPixelPadding,c=a.toPixels(Math.min(G(a.options.min,a.dataMin),a.dataMin)),f=a.toPixels(Math.max(G(a.options.max,a.dataMax),a.dataMax)),n=Math.max(c,
f);b.min=Math.min(a.pos,Math.min(c,f)-d);b.max=Math.max(a.pos+a.len,n+d)}}),e.res=!0):e.followTouchMove&&1===m?this.runPointActions(e.normalize(c)):E.length&&(h||(e.selectionMarker=h=I({destroy:z,touch:!0},t.plotBox)),e.pinchTranslate(E,w,a,h,d,p),e.hasPinched=q,e.scaleGroups(a,d),e.res&&(e.res=!1,this.reset(!1,0)))},touch:function(e,x){var t=this.chart,z;if(t.index!==c.hoverChartIndex)this.onContainerMouseLeave({relatedTarget:!0});c.hoverChartIndex=t.index;if(1===e.touches.length)if(e=this.normalize(e),
(z=t.isInsidePlot(e.chartX-t.plotLeft,e.chartY-t.plotTop))&&!t.openMenu){x&&this.runPointActions(e);if("touchmove"===e.type){x=this.pinchDown;var w=x[0]?4<=Math.sqrt(Math.pow(x[0].chartX-e.chartX,2)+Math.pow(x[0].chartY-e.chartY,2)):!1}G(w,!0)&&this.pinch(e)}else x&&this.reset();else 2===e.touches.length&&this.pinch(e)},onContainerTouchStart:function(c){this.zoomOption(c);this.touch(c,!0)},onContainerTouchMove:function(c){this.touch(c)},onDocumentTouchEnd:function(e){H[c.hoverChartIndex]&&H[c.hoverChartIndex].pointer.drop(e)}})});
K(D,"parts/MSPointer.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,e){var I=e.extend,G=e.objectEach,H=c.addEvent,z=c.charts,t=c.css,x=c.doc,C=c.noop;e=c.Pointer;var E=c.removeEvent,w=c.win,m=c.wrap;if(!c.hasTouch&&(w.PointerEvent||w.MSPointerEvent)){var p={},q=!!w.PointerEvent,h=function(){var a=[];a.item=function(a){return this[a]};G(p,function(b){a.push({pageX:b.pageX,pageY:b.pageY,target:b.target})});return a},a=function(a,d,f,l){"touch"!==a.pointerType&&a.pointerType!==a.MSPOINTER_TYPE_TOUCH||
!z[c.hoverChartIndex]||(l(a),l=z[c.hoverChartIndex].pointer,l[d]({type:f,target:a.currentTarget,preventDefault:C,touches:h()}))};I(e.prototype,{onContainerPointerDown:function(b){a(b,"onContainerTouchStart","touchstart",function(a){p[a.pointerId]={pageX:a.pageX,pageY:a.pageY,target:a.currentTarget}})},onContainerPointerMove:function(b){a(b,"onContainerTouchMove","touchmove",function(a){p[a.pointerId]={pageX:a.pageX,pageY:a.pageY};p[a.pointerId].target||(p[a.pointerId].target=a.currentTarget)})},onDocumentPointerUp:function(b){a(b,
"onDocumentTouchEnd","touchend",function(a){delete p[a.pointerId]})},batchMSEvents:function(a){a(this.chart.container,q?"pointerdown":"MSPointerDown",this.onContainerPointerDown);a(this.chart.container,q?"pointermove":"MSPointerMove",this.onContainerPointerMove);a(x,q?"pointerup":"MSPointerUp",this.onDocumentPointerUp)}});m(e.prototype,"init",function(a,d,c){a.call(this,d,c);this.hasZoom&&t(d.container,{"-ms-touch-action":"none","touch-action":"none"})});m(e.prototype,"setDOMEvents",function(a){a.apply(this);
(this.hasZoom||this.followTouchMove)&&this.batchMSEvents(H)});m(e.prototype,"destroy",function(a){this.batchMSEvents(E);a.call(this)})}});K(D,"parts/Legend.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,e){var I=e.defined,G=e.discardElement,H=e.isNumber,z=e.pick,t=e.setAnimation,x=c.addEvent,C=c.css,E=c.fireEvent;e=c.isFirefox;var w=c.marginNames,m=c.merge,p=c.stableSort,q=c.win,h=c.wrap;c.Legend=function(a,b){this.init(a,b)};c.Legend.prototype={init:function(a,b){this.chart=a;this.setOptions(b);
b.enabled&&(this.render(),x(this.chart,"endResize",function(){this.legend.positionCheckboxes()}),this.proximate?this.unchartrender=x(this.chart,"render",function(){this.legend.proximatePositions();this.legend.positionItems()}):this.unchartrender&&this.unchartrender())},setOptions:function(a){var b=z(a.padding,8);this.options=a;this.chart.styledMode||(this.itemStyle=a.itemStyle,this.itemHiddenStyle=m(this.itemStyle,a.itemHiddenStyle));this.itemMarginTop=a.itemMarginTop||0;this.itemMarginBottom=a.itemMarginBottom||
0;this.padding=b;this.initialItemY=b-5;this.symbolWidth=z(a.symbolWidth,16);this.pages=[];this.proximate="proximate"===a.layout&&!this.chart.inverted},update:function(a,b){var d=this.chart;this.setOptions(m(!0,this.options,a));this.destroy();d.isDirtyLegend=d.isDirtyBox=!0;z(b,!0)&&d.redraw();E(this,"afterUpdate")},colorizeItem:function(a,b){a.legendGroup[b?"removeClass":"addClass"]("highcharts-legend-item-hidden");if(!this.chart.styledMode){var d=this.options,c=a.legendItem,l=a.legendLine,h=a.legendSymbol,
m=this.itemHiddenStyle.color;d=b?d.itemStyle.color:m;var r=b?a.color||m:m,n=a.options&&a.options.marker,g={fill:r};c&&c.css({fill:d,color:d});l&&l.attr({stroke:r});h&&(n&&h.isMarker&&(g=a.pointAttribs(),b||(g.stroke=g.fill=m)),h.attr(g))}E(this,"afterColorizeItem",{item:a,visible:b})},positionItems:function(){this.allItems.forEach(this.positionItem,this);this.chart.isResizing||this.positionCheckboxes()},positionItem:function(a){var b=this.options,d=b.symbolPadding;b=!b.rtl;var c=a._legendItemPos,
l=c[0];c=c[1];var h=a.checkbox;if((a=a.legendGroup)&&a.element)a[I(a.translateY)?"animate":"attr"]({translateX:b?l:this.legendWidth-l-2*d-4,translateY:c});h&&(h.x=l,h.y=c)},destroyItem:function(a){var b=a.checkbox;["legendItem","legendLine","legendSymbol","legendGroup"].forEach(function(b){a[b]&&(a[b]=a[b].destroy())});b&&G(a.checkbox)},destroy:function(){function a(a){this[a]&&(this[a]=this[a].destroy())}this.getAllItems().forEach(function(b){["legendItem","legendGroup"].forEach(a,b)});"clipRect up down pager nav box title group".split(" ").forEach(a,
this);this.display=null},positionCheckboxes:function(){var a=this.group&&this.group.alignAttr,b=this.clipHeight||this.legendHeight,d=this.titleHeight;if(a){var c=a.translateY;this.allItems.forEach(function(f){var l=f.checkbox;if(l){var h=c+d+l.y+(this.scrollOffset||0)+3;C(l,{left:a.translateX+f.checkboxOffset+l.x-20+"px",top:h+"px",display:this.proximate||h>c-6&&h<c+b-6?"":"none"})}},this)}},renderTitle:function(){var a=this.options,b=this.padding,d=a.title,c=0;d.text&&(this.title||(this.title=this.chart.renderer.label(d.text,
b-3,b-4,null,null,null,a.useHTML,null,"legend-title").attr({zIndex:1}),this.chart.styledMode||this.title.css(d.style),this.title.add(this.group)),d.width||this.title.css({width:this.maxLegendWidth+"px"}),a=this.title.getBBox(),c=a.height,this.offsetWidth=a.width,this.contentGroup.attr({translateY:c}));this.titleHeight=c},setText:function(a){var b=this.options;a.legendItem.attr({text:b.labelFormat?c.format(b.labelFormat,a,this.chart.time):b.labelFormatter.call(a)})},renderItem:function(a){var b=this.chart,
d=b.renderer,c=this.options,l=this.symbolWidth,h=c.symbolPadding,e=this.itemStyle,r=this.itemHiddenStyle,n="horizontal"===c.layout?z(c.itemDistance,20):0,g=!c.rtl,k=a.legendItem,v=!a.series,B=!v&&a.series.drawLegendSymbol?a.series:a,A=B.options;A=this.createCheckboxForItem&&A&&A.showCheckbox;n=l+h+n+(A?20:0);var u=c.useHTML,p=a.options.className;k||(a.legendGroup=d.g("legend-item").addClass("highcharts-"+B.type+"-series highcharts-color-"+a.colorIndex+(p?" "+p:"")+(v?" highcharts-series-"+a.index:
"")).attr({zIndex:1}).add(this.scrollGroup),a.legendItem=k=d.text("",g?l+h:-h,this.baseline||0,u),b.styledMode||k.css(m(a.visible?e:r)),k.attr({align:g?"left":"right",zIndex:2}).add(a.legendGroup),this.baseline||(this.fontMetrics=d.fontMetrics(b.styledMode?12:e.fontSize,k),this.baseline=this.fontMetrics.f+3+this.itemMarginTop,k.attr("y",this.baseline)),this.symbolHeight=c.symbolHeight||this.fontMetrics.f,B.drawLegendSymbol(this,a),this.setItemEvents&&this.setItemEvents(a,k,u));A&&!a.checkbox&&this.createCheckboxForItem(a);
this.colorizeItem(a,a.visible);!b.styledMode&&e.width||k.css({width:(c.itemWidth||this.widthOption||b.spacingBox.width)-n});this.setText(a);b=k.getBBox();a.itemWidth=a.checkboxOffset=c.itemWidth||a.legendItemWidth||b.width+n;this.maxItemWidth=Math.max(this.maxItemWidth,a.itemWidth);this.totalItemWidth+=a.itemWidth;this.itemHeight=a.itemHeight=Math.round(a.legendItemHeight||b.height||this.symbolHeight)},layoutItem:function(a){var b=this.options,d=this.padding,c="horizontal"===b.layout,l=a.itemHeight,
h=this.itemMarginBottom,m=this.itemMarginTop,r=c?z(b.itemDistance,20):0,n=this.maxLegendWidth;b=b.alignColumns&&this.totalItemWidth>n?this.maxItemWidth:a.itemWidth;c&&this.itemX-d+b>n&&(this.itemX=d,this.lastLineHeight&&(this.itemY+=m+this.lastLineHeight+h),this.lastLineHeight=0);this.lastItemY=m+this.itemY+h;this.lastLineHeight=Math.max(l,this.lastLineHeight);a._legendItemPos=[this.itemX,this.itemY];c?this.itemX+=b:(this.itemY+=m+l+h,this.lastLineHeight=l);this.offsetWidth=this.widthOption||Math.max((c?
this.itemX-d-(a.checkbox?0:r):b)+d,this.offsetWidth)},getAllItems:function(){var a=[];this.chart.series.forEach(function(b){var d=b&&b.options;b&&z(d.showInLegend,I(d.linkedTo)?!1:void 0,!0)&&(a=a.concat(b.legendItems||("point"===d.legendType?b.data:b)))});E(this,"afterGetAllItems",{allItems:a});return a},getAlignment:function(){var a=this.options;return this.proximate?a.align.charAt(0)+"tv":a.floating?"":a.align.charAt(0)+a.verticalAlign.charAt(0)+a.layout.charAt(0)},adjustMargins:function(a,b){var d=
this.chart,c=this.options,l=this.getAlignment();l&&[/(lth|ct|rth)/,/(rtv|rm|rbv)/,/(rbh|cb|lbh)/,/(lbv|lm|ltv)/].forEach(function(f,h){f.test(l)&&!I(a[h])&&(d[w[h]]=Math.max(d[w[h]],d.legend[(h+1)%2?"legendHeight":"legendWidth"]+[1,-1,-1,1][h]*c[h%2?"x":"y"]+z(c.margin,12)+b[h]+(d.titleOffset[h]||0)))})},proximatePositions:function(){var a=this.chart,b=[],d="left"===this.options.align;this.allItems.forEach(function(f){var l=d;if(f.yAxis&&f.points){f.xAxis.options.reversed&&(l=!l);var h=c.find(l?f.points:
f.points.slice(0).reverse(),function(a){return H(a.plotY)});l=this.itemMarginTop+f.legendItem.getBBox().height+this.itemMarginBottom;var m=f.yAxis.top-a.plotTop;f.visible?(h=h?h.plotY:f.yAxis.height,h+=m-.3*l):h=m+f.yAxis.height;b.push({target:h,size:l,item:f})}},this);c.distribute(b,a.plotHeight);b.forEach(function(b){b.item._legendItemPos[1]=a.plotTop-a.spacing[0]+b.pos})},render:function(){var a=this.chart,b=a.renderer,d=this.group,f,l=this.box,h=this.options,e=this.padding;this.itemX=e;this.itemY=
this.initialItemY;this.lastItemY=this.offsetWidth=0;this.widthOption=c.relativeLength(h.width,a.spacingBox.width-e);var r=a.spacingBox.width-2*e-h.x;-1<["rm","lm"].indexOf(this.getAlignment().substring(0,2))&&(r/=2);this.maxLegendWidth=this.widthOption||r;d||(this.group=d=b.g("legend").attr({zIndex:7}).add(),this.contentGroup=b.g().attr({zIndex:1}).add(d),this.scrollGroup=b.g().add(this.contentGroup));this.renderTitle();r=this.getAllItems();p(r,function(a,b){return(a.options&&a.options.legendIndex||
0)-(b.options&&b.options.legendIndex||0)});h.reversed&&r.reverse();this.allItems=r;this.display=f=!!r.length;this.itemHeight=this.totalItemWidth=this.maxItemWidth=this.lastLineHeight=0;r.forEach(this.renderItem,this);r.forEach(this.layoutItem,this);r=(this.widthOption||this.offsetWidth)+e;var n=this.lastItemY+this.lastLineHeight+this.titleHeight;n=this.handleOverflow(n);n+=e;l||(this.box=l=b.rect().addClass("highcharts-legend-box").attr({r:h.borderRadius}).add(d),l.isNew=!0);a.styledMode||l.attr({stroke:h.borderColor,
"stroke-width":h.borderWidth||0,fill:h.backgroundColor||"none"}).shadow(h.shadow);0<r&&0<n&&(l[l.isNew?"attr":"animate"](l.crisp.call({},{x:0,y:0,width:r,height:n},l.strokeWidth())),l.isNew=!1);l[f?"show":"hide"]();a.styledMode&&"none"===d.getStyle("display")&&(r=n=0);this.legendWidth=r;this.legendHeight=n;f&&(b=a.spacingBox,l=b.y,/(lth|ct|rth)/.test(this.getAlignment())&&0<a.titleOffset[0]?l+=a.titleOffset[0]:/(lbh|cb|rbh)/.test(this.getAlignment())&&0<a.titleOffset[2]&&(l-=a.titleOffset[2]),l!==
b.y&&(b=m(b,{y:l})),d.align(m(h,{width:r,height:n,verticalAlign:this.proximate?"top":h.verticalAlign}),!0,b));this.proximate||this.positionItems();E(this,"afterRender")},handleOverflow:function(a){var b=this,d=this.chart,c=d.renderer,l=this.options,h=l.y,m=this.padding;h=d.spacingBox.height+("top"===l.verticalAlign?-h:h)-m;var r=l.maxHeight,n,g=this.clipRect,k=l.navigation,v=z(k.animation,!0),B=k.arrowSize||12,A=this.nav,u=this.pages,e,p=this.allItems,w=function(a){"number"===typeof a?g.attr({height:a}):
g&&(b.clipRect=g.destroy(),b.contentGroup.clip());b.contentGroup.div&&(b.contentGroup.div.style.clip=a?"rect("+m+"px,9999px,"+(m+a)+"px,0)":"auto")},q=function(a){b[a]=c.circle(0,0,1.3*B).translate(B/2,B/2).add(A);d.styledMode||b[a].attr("fill","rgba(0,0,0,0.0001)");return b[a]};"horizontal"!==l.layout||"middle"===l.verticalAlign||l.floating||(h/=2);r&&(h=Math.min(h,r));u.length=0;a>h&&!1!==k.enabled?(this.clipHeight=n=Math.max(h-20-this.titleHeight-m,0),this.currentPage=z(this.currentPage,1),this.fullHeight=
a,p.forEach(function(a,b){var g=a._legendItemPos[1],k=Math.round(a.legendItem.getBBox().height),d=u.length;if(!d||g-u[d-1]>n&&(e||g)!==u[d-1])u.push(e||g),d++;a.pageIx=d-1;e&&(p[b-1].pageIx=d-1);b===p.length-1&&g+k-u[d-1]>n&&g!==e&&(u.push(g),a.pageIx=d);g!==e&&(e=g)}),g||(g=b.clipRect=c.clipRect(0,m,9999,0),b.contentGroup.clip(g)),w(n),A||(this.nav=A=c.g().attr({zIndex:1}).add(this.group),this.up=c.symbol("triangle",0,0,B,B).add(A),q("upTracker").on("click",function(){b.scroll(-1,v)}),this.pager=
c.text("",15,10).addClass("highcharts-legend-navigation"),d.styledMode||this.pager.css(k.style),this.pager.add(A),this.down=c.symbol("triangle-down",0,0,B,B).add(A),q("downTracker").on("click",function(){b.scroll(1,v)})),b.scroll(0),a=h):A&&(w(),this.nav=A.destroy(),this.scrollGroup.attr({translateY:1}),this.clipHeight=0);return a},scroll:function(a,b){var d=this.pages,c=d.length,l=this.currentPage+a;a=this.clipHeight;var h=this.options.navigation,m=this.pager,r=this.padding;l>c&&(l=c);0<l&&(void 0!==
b&&t(b,this.chart),this.nav.attr({translateX:r,translateY:a+this.padding+7+this.titleHeight,visibility:"visible"}),[this.up,this.upTracker].forEach(function(a){a.attr({"class":1===l?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"})}),m.attr({text:l+"/"+c}),[this.down,this.downTracker].forEach(function(a){a.attr({x:18+this.pager.getBBox().width,"class":l===c?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"})},this),this.chart.styledMode||(this.up.attr({fill:1===l?h.inactiveColor:
h.activeColor}),this.upTracker.css({cursor:1===l?"default":"pointer"}),this.down.attr({fill:l===c?h.inactiveColor:h.activeColor}),this.downTracker.css({cursor:l===c?"default":"pointer"})),this.scrollOffset=-d[l-1]+this.initialItemY,this.scrollGroup.animate({translateY:this.scrollOffset}),this.currentPage=l,this.positionCheckboxes())}};c.LegendSymbolMixin={drawRectangle:function(a,b){var d=a.symbolHeight,c=a.options.squareSymbol;b.legendSymbol=this.chart.renderer.rect(c?(a.symbolWidth-d)/2:0,a.baseline-
d+1,c?d:a.symbolWidth,d,z(a.options.symbolRadius,d/2)).addClass("highcharts-point").attr({zIndex:3}).add(b.legendGroup)},drawLineMarker:function(a){var b=this.options,d=b.marker,c=a.symbolWidth,l=a.symbolHeight,h=l/2,e=this.chart.renderer,r=this.legendGroup;a=a.baseline-Math.round(.3*a.fontMetrics.b);var n={};this.chart.styledMode||(n={"stroke-width":b.lineWidth||0},b.dashStyle&&(n.dashstyle=b.dashStyle));this.legendLine=e.path(["M",0,a,"L",c,a]).addClass("highcharts-graph").attr(n).add(r);d&&!1!==
d.enabled&&c&&(b=Math.min(z(d.radius,h),h),0===this.symbol.indexOf("url")&&(d=m(d,{width:l,height:l}),b=0),this.legendSymbol=d=e.symbol(this.symbol,c/2-b,a-b,2*b,2*b,d).addClass("highcharts-point").add(r),d.isMarker=!0)}};(/Trident\/7\.0/.test(q.navigator&&q.navigator.userAgent)||e)&&h(c.Legend.prototype,"positionItem",function(a,b){var d=this,c=function(){b._legendItemPos&&a.call(d,b)};c();d.bubbleLegend||setTimeout(c)})});K(D,"parts/Chart.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,
e){var I=e.attr,G=e.defined,H=e.discardElement,z=e.erase,t=e.extend,x=e.isArray,C=e.isNumber,E=e.isObject,w=e.isString,m=e.objectEach,p=e.pick,q=e.pInt,h=e.setAnimation,a=e.splat,b=e.syncTimeout,d=c.addEvent,f=c.animate,l=c.animObject,F=c.doc,y=c.Axis,r=c.createElement,n=c.defaultOptions,g=c.charts,k=c.css,v=c.find,B=c.fireEvent,A=c.Legend,u=c.marginNames,J=c.merge,L=c.Pointer,U=c.removeEvent,Q=c.seriesTypes,P=c.win,M=c.Chart=function(){this.getArgs.apply(this,arguments)};c.chart=function(a,b,g){return new M(a,
b,g)};t(M.prototype,{callbacks:[],getArgs:function(){var a=[].slice.call(arguments);if(w(a[0])||a[0].nodeName)this.renderTo=a.shift();this.init(a[0],a[1])},init:function(a,b){var k,f=a.series,l=a.plotOptions||{};B(this,"init",{args:arguments},function(){a.series=null;k=J(n,a);m(k.plotOptions,function(a,b){E(a)&&(a.tooltip=l[b]&&J(l[b].tooltip)||void 0)});k.tooltip.userOptions=a.chart&&a.chart.forExport&&a.tooltip.userOptions||a.tooltip;k.series=a.series=f;this.userOptions=a;var v=k.chart,h=v.events;
this.margin=[];this.spacing=[];this.bounds={h:{},v:{}};this.labelCollectors=[];this.callback=b;this.isResizing=0;this.options=k;this.axes=[];this.series=[];this.time=a.time&&Object.keys(a.time).length?new c.Time(a.time):c.time;this.styledMode=v.styledMode;this.hasCartesianSeries=v.showAxes;var u=this;u.index=g.length;g.push(u);c.chartCount++;h&&m(h,function(a,b){c.isFunction(a)&&d(u,b,a)});u.xAxis=[];u.yAxis=[];u.pointCount=u.colorCounter=u.symbolCounter=0;B(u,"afterInit");u.firstRender()})},initSeries:function(a){var b=
this.options.chart;b=a.type||b.type||b.defaultSeriesType;var g=Q[b];g||c.error(17,!0,this,{missingModuleFor:b});b=new g;b.init(this,a);return b},orderSeries:function(a){var b=this.series;for(a=a||0;a<b.length;a++)b[a]&&(b[a].index=a,b[a].name=b[a].getName())},isInsidePlot:function(a,b,g){var k=g?b:a;a=g?a:b;return 0<=k&&k<=this.plotWidth&&0<=a&&a<=this.plotHeight},redraw:function(a){B(this,"beforeRedraw");var b=this.axes,g=this.series,k=this.pointer,d=this.legend,c=this.userOptions.legend,f=this.isDirtyLegend,
l=this.hasCartesianSeries,n=this.isDirtyBox,v=this.renderer,u=v.isHidden(),m=[];this.setResponsive&&this.setResponsive(!1);h(a,this);u&&this.temporaryDisplay();this.layOutTitles();for(a=g.length;a--;){var A=g[a];if(A.options.stacking){var r=!0;if(A.isDirty){var e=!0;break}}}if(e)for(a=g.length;a--;)A=g[a],A.options.stacking&&(A.isDirty=!0);g.forEach(function(a){a.isDirty&&("point"===a.options.legendType?(a.updateTotals&&a.updateTotals(),f=!0):c&&(c.labelFormatter||c.labelFormat)&&(f=!0));a.isDirtyData&&
B(a,"updatedData")});f&&d&&d.options.enabled&&(d.render(),this.isDirtyLegend=!1);r&&this.getStacks();l&&b.forEach(function(a){a.updateNames();a.setScale()});this.getMargins();l&&(b.forEach(function(a){a.isDirty&&(n=!0)}),b.forEach(function(a){var b=a.min+","+a.max;a.extKey!==b&&(a.extKey=b,m.push(function(){B(a,"afterSetExtremes",t(a.eventArgs,a.getExtremes()));delete a.eventArgs}));(n||r)&&a.redraw()}));n&&this.drawChartBox();B(this,"predraw");g.forEach(function(a){(n||a.isDirty)&&a.visible&&a.redraw();
a.isDirtyData=!1});k&&k.reset(!0);v.draw();B(this,"redraw");B(this,"render");u&&this.temporaryDisplay(!0);m.forEach(function(a){a.call()})},get:function(a){function b(b){return b.id===a||b.options&&b.options.id===a}var g=this.series,k;var d=v(this.axes,b)||v(this.series,b);for(k=0;!d&&k<g.length;k++)d=v(g[k].points||[],b);return d},getAxes:function(){var b=this,g=this.options,k=g.xAxis=a(g.xAxis||{});g=g.yAxis=a(g.yAxis||{});B(this,"getAxes");k.forEach(function(a,b){a.index=b;a.isX=!0});g.forEach(function(a,
b){a.index=b});k.concat(g).forEach(function(a){new y(b,a)});B(this,"afterGetAxes")},getSelectedPoints:function(){var a=[];this.series.forEach(function(b){a=a.concat((b[b.hasGroupedData?"points":"data"]||[]).filter(function(a){return p(a.selectedStaging,a.selected)}))});return a},getSelectedSeries:function(){return this.series.filter(function(a){return a.selected})},setTitle:function(a,b,g){this.applyDescription("title",a);this.applyDescription("subtitle",b);this.applyDescription("caption",void 0);
this.layOutTitles(g)},applyDescription:function(a,b){var g=this,k="title"===a?{color:"#333333",fontSize:this.options.isStock?"16px":"18px"}:{color:"#666666"};k=this.options[a]=J(!this.styledMode&&{style:k},this.options[a],b);var d=this[a];d&&b&&(this[a]=d=d.destroy());k&&!d&&(d=this.renderer.text(k.text,0,0,k.useHTML).attr({align:k.align,"class":"highcharts-"+a,zIndex:k.zIndex||4}).add(),d.update=function(b){g[{title:"setTitle",subtitle:"setSubtitle",caption:"setCaption"}[a]](b)},this.styledMode||
d.css(k.style),this[a]=d)},layOutTitles:function(a){var b=[0,0,0],g=this.renderer,k=this.spacingBox;["title","subtitle","caption"].forEach(function(a){var d=this[a],c=this.options[a],f=c.verticalAlign||"top";a="title"===a?-3:"top"===f?b[0]+2:0;if(d){if(!this.styledMode)var l=c.style.fontSize;l=g.fontMetrics(l,d).b;d.css({width:(c.width||k.width+(c.widthAdjust||0))+"px"});var n=Math.round(d.getBBox(c.useHTML).height);d.align(t({y:"bottom"===f?l:a+l,height:n},c),!1,"spacingBox");c.floating||("top"===
f?b[0]=Math.ceil(b[0]+n):"bottom"===f&&(b[2]=Math.ceil(b[2]+n)))}},this);b[0]&&"top"===(this.options.title.verticalAlign||"top")&&(b[0]+=this.options.title.margin);b[2]&&"bottom"===this.options.caption.verticalAlign&&(b[2]+=this.options.caption.margin);var d=!this.titleOffset||this.titleOffset.join(",")!==b.join(",");this.titleOffset=b;B(this,"afterLayOutTitles");!this.isDirtyBox&&d&&(this.isDirtyBox=this.isDirtyLegend=d,this.hasRendered&&p(a,!0)&&this.isDirtyBox&&this.redraw())},getChartSize:function(){var a=
this.options.chart,b=a.width;a=a.height;var g=this.renderTo;G(b)||(this.containerWidth=c.getStyle(g,"width"));G(a)||(this.containerHeight=c.getStyle(g,"height"));this.chartWidth=Math.max(0,b||this.containerWidth||600);this.chartHeight=Math.max(0,c.relativeLength(a,this.chartWidth)||(1<this.containerHeight?this.containerHeight:400))},temporaryDisplay:function(a){var b=this.renderTo;if(a)for(;b&&b.style;)b.hcOrigStyle&&(c.css(b,b.hcOrigStyle),delete b.hcOrigStyle),b.hcOrigDetached&&(F.body.removeChild(b),
b.hcOrigDetached=!1),b=b.parentNode;else for(;b&&b.style;){F.body.contains(b)||b.parentNode||(b.hcOrigDetached=!0,F.body.appendChild(b));if("none"===c.getStyle(b,"display",!1)||b.hcOricDetached)b.hcOrigStyle={display:b.style.display,height:b.style.height,overflow:b.style.overflow},a={display:"block",overflow:"hidden"},b!==this.renderTo&&(a.height=0),c.css(b,a),b.offsetWidth||b.style.setProperty("display","block","important");b=b.parentNode;if(b===F.body)break}},setClassName:function(a){this.container.className=
"highcharts-container "+(a||"")},getContainer:function(){var a=this.options,b=a.chart;var d=this.renderTo;var f=c.uniqueKey(),l,n;d||(this.renderTo=d=b.renderTo);w(d)&&(this.renderTo=d=F.getElementById(d));d||c.error(13,!0,this);var v=q(I(d,"data-highcharts-chart"));C(v)&&g[v]&&g[v].hasRendered&&g[v].destroy();I(d,"data-highcharts-chart",this.index);d.innerHTML="";b.skipClone||d.offsetWidth||this.temporaryDisplay();this.getChartSize();v=this.chartWidth;var h=this.chartHeight;k(d,{overflow:"hidden"});
this.styledMode||(l=t({position:"relative",overflow:"hidden",width:v+"px",height:h+"px",textAlign:"left",lineHeight:"normal",zIndex:0,"-webkit-tap-highlight-color":"rgba(0,0,0,0)"},b.style));this.container=d=r("div",{id:f},l,d);this._cursor=d.style.cursor;this.renderer=new (c[b.renderer]||c.Renderer)(d,v,h,null,b.forExport,a.exporting&&a.exporting.allowHTML,this.styledMode);this.setClassName(b.className);if(this.styledMode)for(n in a.defs)this.renderer.definition(a.defs[n]);else this.renderer.setStyle(b.style);
this.renderer.chartIndex=this.index;B(this,"afterGetContainer")},getMargins:function(a){var b=this.spacing,g=this.margin,k=this.titleOffset;this.resetMargins();k[0]&&!G(g[0])&&(this.plotTop=Math.max(this.plotTop,k[0]+b[0]));k[2]&&!G(g[2])&&(this.marginBottom=Math.max(this.marginBottom,k[2]+b[2]));this.legend&&this.legend.display&&this.legend.adjustMargins(g,b);B(this,"getMargins");a||this.getAxisMargins()},getAxisMargins:function(){var a=this,b=a.axisOffset=[0,0,0,0],g=a.colorAxis,k=a.margin,d=function(a){a.forEach(function(a){a.visible&&
a.getOffset()})};a.hasCartesianSeries?d(a.axes):g&&g.length&&d(g);u.forEach(function(g,d){G(k[d])||(a[g]+=b[d])});a.setChartSize()},reflow:function(a){var g=this,k=g.options.chart,d=g.renderTo,f=G(k.width)&&G(k.height),l=k.width||c.getStyle(d,"width");k=k.height||c.getStyle(d,"height");d=a?a.target:P;if(!f&&!g.isPrinting&&l&&k&&(d===P||d===F)){if(l!==g.containerWidth||k!==g.containerHeight)c.clearTimeout(g.reflowTimeout),g.reflowTimeout=b(function(){g.container&&g.setSize(void 0,void 0,!1)},a?100:
0);g.containerWidth=l;g.containerHeight=k}},setReflow:function(a){var b=this;!1===a||this.unbindReflow?!1===a&&this.unbindReflow&&(this.unbindReflow=this.unbindReflow()):(this.unbindReflow=d(P,"resize",function(a){b.options&&b.reflow(a)}),d(this,"destroy",this.unbindReflow))},setSize:function(a,g,d){var c=this,n=c.renderer;c.isResizing+=1;h(d,c);c.oldChartHeight=c.chartHeight;c.oldChartWidth=c.chartWidth;void 0!==a&&(c.options.chart.width=a);void 0!==g&&(c.options.chart.height=g);c.getChartSize();
if(!c.styledMode){var v=n.globalAnimation;(v?f:k)(c.container,{width:c.chartWidth+"px",height:c.chartHeight+"px"},v)}c.setChartSize(!0);n.setSize(c.chartWidth,c.chartHeight,d);c.axes.forEach(function(a){a.isDirty=!0;a.setScale()});c.isDirtyLegend=!0;c.isDirtyBox=!0;c.layOutTitles();c.getMargins();c.redraw(d);c.oldChartHeight=null;B(c,"resize");b(function(){c&&B(c,"endResize",null,function(){--c.isResizing})},l(v).duration||0)},setChartSize:function(a){var b=this.inverted,g=this.renderer,k=this.chartWidth,
d=this.chartHeight,c=this.options.chart,f=this.spacing,l=this.clipOffset,n,v,h,u;this.plotLeft=n=Math.round(this.plotLeft);this.plotTop=v=Math.round(this.plotTop);this.plotWidth=h=Math.max(0,Math.round(k-n-this.marginRight));this.plotHeight=u=Math.max(0,Math.round(d-v-this.marginBottom));this.plotSizeX=b?u:h;this.plotSizeY=b?h:u;this.plotBorderWidth=c.plotBorderWidth||0;this.spacingBox=g.spacingBox={x:f[3],y:f[0],width:k-f[3]-f[1],height:d-f[0]-f[2]};this.plotBox=g.plotBox={x:n,y:v,width:h,height:u};
k=2*Math.floor(this.plotBorderWidth/2);b=Math.ceil(Math.max(k,l[3])/2);g=Math.ceil(Math.max(k,l[0])/2);this.clipBox={x:b,y:g,width:Math.floor(this.plotSizeX-Math.max(k,l[1])/2-b),height:Math.max(0,Math.floor(this.plotSizeY-Math.max(k,l[2])/2-g))};a||this.axes.forEach(function(a){a.setAxisSize();a.setAxisTranslation()});B(this,"afterSetChartSize",{skipAxes:a})},resetMargins:function(){B(this,"resetMargins");var a=this,b=a.options.chart;["margin","spacing"].forEach(function(g){var k=b[g],d=E(k)?k:[k,
k,k,k];["Top","Right","Bottom","Left"].forEach(function(k,c){a[g][c]=p(b[g+k],d[c])})});u.forEach(function(b,g){a[b]=p(a.margin[g],a.spacing[g])});a.axisOffset=[0,0,0,0];a.clipOffset=[0,0,0,0]},drawChartBox:function(){var a=this.options.chart,b=this.renderer,g=this.chartWidth,k=this.chartHeight,d=this.chartBackground,c=this.plotBackground,f=this.plotBorder,l=this.styledMode,n=this.plotBGImage,v=a.backgroundColor,h=a.plotBackgroundColor,u=a.plotBackgroundImage,m,A=this.plotLeft,r=this.plotTop,e=this.plotWidth,
p=this.plotHeight,J=this.plotBox,F=this.clipRect,y=this.clipBox,w="animate";d||(this.chartBackground=d=b.rect().addClass("highcharts-background").add(),w="attr");if(l)var q=m=d.strokeWidth();else{q=a.borderWidth||0;m=q+(a.shadow?8:0);v={fill:v||"none"};if(q||d["stroke-width"])v.stroke=a.borderColor,v["stroke-width"]=q;d.attr(v).shadow(a.shadow)}d[w]({x:m/2,y:m/2,width:g-m-q%2,height:k-m-q%2,r:a.borderRadius});w="animate";c||(w="attr",this.plotBackground=c=b.rect().addClass("highcharts-plot-background").add());
c[w](J);l||(c.attr({fill:h||"none"}).shadow(a.plotShadow),u&&(n?n.animate(J):this.plotBGImage=b.image(u,A,r,e,p).add()));F?F.animate({width:y.width,height:y.height}):this.clipRect=b.clipRect(y);w="animate";f||(w="attr",this.plotBorder=f=b.rect().addClass("highcharts-plot-border").attr({zIndex:1}).add());l||f.attr({stroke:a.plotBorderColor,"stroke-width":a.plotBorderWidth||0,fill:"none"});f[w](f.crisp({x:A,y:r,width:e,height:p},-f.strokeWidth()));this.isDirtyBox=!1;B(this,"afterDrawChartBox")},propFromSeries:function(){var a=
this,b=a.options.chart,g,k=a.options.series,d,c;["inverted","angular","polar"].forEach(function(f){g=Q[b.type||b.defaultSeriesType];c=b[f]||g&&g.prototype[f];for(d=k&&k.length;!c&&d--;)(g=Q[k[d].type])&&g.prototype[f]&&(c=!0);a[f]=c})},linkSeries:function(){var a=this,b=a.series;b.forEach(function(a){a.linkedSeries.length=0});b.forEach(function(b){var g=b.options.linkedTo;w(g)&&(g=":previous"===g?a.series[b.index-1]:a.get(g))&&g.linkedParent!==b&&(g.linkedSeries.push(b),b.linkedParent=g,b.visible=
p(b.options.visible,g.options.visible,b.visible))});B(this,"afterLinkSeries")},renderSeries:function(){this.series.forEach(function(a){a.translate();a.render()})},renderLabels:function(){var a=this,b=a.options.labels;b.items&&b.items.forEach(function(g){var k=t(b.style,g.style),d=q(k.left)+a.plotLeft,c=q(k.top)+a.plotTop+12;delete k.left;delete k.top;a.renderer.text(g.html,d,c).attr({zIndex:2}).css(k).add()})},render:function(){var a=this.axes,b=this.colorAxis,g=this.renderer,k=this.options,d=0,c=
function(a){a.forEach(function(a){a.visible&&a.render()})};this.setTitle();this.legend=new A(this,k.legend);this.getStacks&&this.getStacks();this.getMargins(!0);this.setChartSize();k=this.plotWidth;a.some(function(a){if(a.horiz&&a.visible&&a.options.labels.enabled&&a.series.length)return d=21,!0});var f=this.plotHeight=Math.max(this.plotHeight-d,0);a.forEach(function(a){a.setScale()});this.getAxisMargins();var l=1.1<k/this.plotWidth;var n=1.05<f/this.plotHeight;if(l||n)a.forEach(function(a){(a.horiz&&
l||!a.horiz&&n)&&a.setTickInterval(!0)}),this.getMargins();this.drawChartBox();this.hasCartesianSeries?c(a):b&&b.length&&c(b);this.seriesGroup||(this.seriesGroup=g.g("series-group").attr({zIndex:3}).add());this.renderSeries();this.renderLabels();this.addCredits();this.setResponsive&&this.setResponsive();this.updateContainerScaling();this.hasRendered=!0},addCredits:function(a){var b=this;a=J(!0,this.options.credits,a);a.enabled&&!this.credits&&(this.credits=this.renderer.text(a.text+(this.mapCredits||
""),0,0).addClass("highcharts-credits").on("click",function(){a.href&&(P.location.href=a.href)}).attr({align:a.position.align,zIndex:8}),b.styledMode||this.credits.css(a.style),this.credits.add().align(a.position),this.credits.update=function(a){b.credits=b.credits.destroy();b.addCredits(a)})},updateContainerScaling:function(){var a=this.container;if(a.offsetWidth&&a.offsetHeight&&a.getBoundingClientRect){var b=a.getBoundingClientRect(),g=b.width/a.offsetWidth;a=b.height/a.offsetHeight;1!==g||1!==
a?this.containerScaling={scaleX:g,scaleY:a}:delete this.containerScaling}},destroy:function(){var a=this,b=a.axes,k=a.series,d=a.container,f,l=d&&d.parentNode;B(a,"destroy");a.renderer.forExport?z(g,a):g[a.index]=void 0;c.chartCount--;a.renderTo.removeAttribute("data-highcharts-chart");U(a);for(f=b.length;f--;)b[f]=b[f].destroy();this.scroller&&this.scroller.destroy&&this.scroller.destroy();for(f=k.length;f--;)k[f]=k[f].destroy();"title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" ").forEach(function(b){var g=
a[b];g&&g.destroy&&(a[b]=g.destroy())});d&&(d.innerHTML="",U(d),l&&H(d));m(a,function(b,g){delete a[g]})},firstRender:function(){var a=this,b=a.options;if(!a.isReadyToRender||a.isReadyToRender()){a.getContainer();a.resetMargins();a.setChartSize();a.propFromSeries();a.getAxes();(x(b.series)?b.series:[]).forEach(function(b){a.initSeries(b)});a.linkSeries();B(a,"beforeRender");L&&(a.pointer=new L(a,b));a.render();if(!a.renderer.imgCount&&a.onload)a.onload();a.temporaryDisplay(!0)}},onload:function(){this.callbacks.concat([this.callback]).forEach(function(a){a&&
void 0!==this.index&&a.apply(this,[this])},this);B(this,"load");B(this,"render");G(this.index)&&this.setReflow(this.options.chart.reflow);this.onload=null}})});K(D,"parts/ScrollablePlotArea.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,e){var I=e.pick,G=c.addEvent;e=c.Chart;"";G(e,"afterSetChartSize",function(e){var z=this.options.chart.scrollablePlotArea,t=z&&z.minWidth;z=z&&z.minHeight;if(!this.renderer.forExport){if(t){if(this.scrollablePixelsX=t=Math.max(0,t-this.chartWidth)){this.plotWidth+=
t;this.inverted?(this.clipBox.height+=t,this.plotBox.height+=t):(this.clipBox.width+=t,this.plotBox.width+=t);var x={1:{name:"right",value:t}}}}else z&&(this.scrollablePixelsY=t=Math.max(0,z-this.chartHeight))&&(this.plotHeight+=t,this.inverted?(this.clipBox.width+=t,this.plotBox.width+=t):(this.clipBox.height+=t,this.plotBox.height+=t),x={2:{name:"bottom",value:t}});x&&!e.skipAxes&&this.axes.forEach(function(e){x[e.side]?e.getPlotLinePath=function(){var t=x[e.side].name,w=this[t];this[t]=w-x[e.side].value;
var m=c.Axis.prototype.getPlotLinePath.apply(this,arguments);this[t]=w;return m}:(e.setAxisSize(),e.setAxisTranslation())})}});G(e,"render",function(){this.scrollablePixelsX||this.scrollablePixelsY?(this.setUpScrolling&&this.setUpScrolling(),this.applyFixed()):this.fixedDiv&&this.applyFixed()});e.prototype.setUpScrolling=function(){var e={WebkitOverflowScrolling:"touch",overflowX:"hidden",overflowY:"hidden"};this.scrollablePixelsX&&(e.overflowX="auto");this.scrollablePixelsY&&(e.overflowY="auto");
this.scrollingContainer=c.createElement("div",{className:"highcharts-scrolling"},e,this.renderTo);this.innerContainer=c.createElement("div",{className:"highcharts-inner-container"},null,this.scrollingContainer);this.innerContainer.appendChild(this.container);this.setUpScrolling=null};e.prototype.moveFixedElements=function(){var c=this.container,e=this.fixedRenderer,t=".highcharts-contextbutton .highcharts-credits .highcharts-legend .highcharts-legend-checkbox .highcharts-navigator-series .highcharts-navigator-xaxis .highcharts-navigator-yaxis .highcharts-navigator .highcharts-reset-zoom .highcharts-scrollbar .highcharts-subtitle .highcharts-title".split(" "),
x;this.scrollablePixelsX&&!this.inverted?x=".highcharts-yaxis":this.scrollablePixelsX&&this.inverted?x=".highcharts-xaxis":this.scrollablePixelsY&&!this.inverted?x=".highcharts-xaxis":this.scrollablePixelsY&&this.inverted&&(x=".highcharts-yaxis");t.push(x,x+"-labels");t.forEach(function(x){[].forEach.call(c.querySelectorAll(x),function(c){(c.namespaceURI===e.SVG_NS?e.box:e.box.parentNode).appendChild(c);c.style.pointerEvents="auto"})})};e.prototype.applyFixed=function(){var e,z=!this.fixedDiv,t=this.options.chart.scrollablePlotArea;
z?(this.fixedDiv=c.createElement("div",{className:"highcharts-fixed"},{position:"absolute",overflow:"hidden",pointerEvents:"none",zIndex:2},null,!0),this.renderTo.insertBefore(this.fixedDiv,this.renderTo.firstChild),this.renderTo.style.overflow="visible",this.fixedRenderer=e=new c.Renderer(this.fixedDiv,this.chartWidth,this.chartHeight),this.scrollableMask=e.path().attr({fill:c.color(this.options.chart.backgroundColor||"#fff").setOpacity(I(t.opacity,.85)).get(),zIndex:-1}).addClass("highcharts-scrollable-mask").add(),
this.moveFixedElements(),G(this,"afterShowResetZoom",this.moveFixedElements),G(this,"afterLayOutTitles",this.moveFixedElements)):this.fixedRenderer.setSize(this.chartWidth,this.chartHeight);e=this.chartWidth+(this.scrollablePixelsX||0);var x=this.chartHeight+(this.scrollablePixelsY||0);c.stop(this.container);this.container.style.width=e+"px";this.container.style.height=x+"px";this.renderer.boxWrapper.attr({width:e,height:x,viewBox:[0,0,e,x].join(" ")});this.chartBackground.attr({width:e,height:x});
this.scrollablePixelsY&&(this.scrollingContainer.style.height=this.chartHeight+"px");z&&(t.scrollPositionX&&(this.scrollingContainer.scrollLeft=this.scrollablePixelsX*t.scrollPositionX),t.scrollPositionY&&(this.scrollingContainer.scrollTop=this.scrollablePixelsY*t.scrollPositionY));x=this.axisOffset;z=this.plotTop-x[0]-1;t=this.plotLeft-x[3]-1;e=this.plotTop+this.plotHeight+x[2]+1;x=this.plotLeft+this.plotWidth+x[1]+1;var C=this.plotLeft+this.plotWidth-(this.scrollablePixelsX||0),E=this.plotTop+this.plotHeight-
(this.scrollablePixelsY||0);z=this.scrollablePixelsX?["M",0,z,"L",this.plotLeft-1,z,"L",this.plotLeft-1,e,"L",0,e,"Z","M",C,z,"L",this.chartWidth,z,"L",this.chartWidth,e,"L",C,e,"Z"]:this.scrollablePixelsY?["M",t,0,"L",t,this.plotTop-1,"L",x,this.plotTop-1,"L",x,0,"Z","M",t,E,"L",t,this.chartHeight,"L",x,this.chartHeight,"L",x,E,"Z"]:["M",0,0];"adjustHeight"!==this.redrawTrigger&&this.scrollableMask.attr({d:z})}});K(D,"parts/Point.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,e){var I=
e.defined,G=e.erase,H=e.extend,z=e.isArray,t=e.isNumber,x=e.isObject,C=e.pick,E,w=c.fireEvent,m=c.format,p=c.uniqueKey,q=c.removeEvent;c.Point=E=function(){};c.Point.prototype={init:function(c,a,b){this.series=c;this.applyOptions(a,b);this.id=I(this.id)?this.id:p();this.resolveColor();c.chart.pointCount++;w(this,"afterInit");return this},resolveColor:function(){var c=this.series;var a=c.chart.options.chart.colorCount;var b=c.chart.styledMode;b||this.options.color||(this.color=c.color);c.options.colorByPoint?
(b||(a=c.options.colors||c.chart.options.colors,this.color=this.color||a[c.colorCounter],a=a.length),b=c.colorCounter,c.colorCounter++,c.colorCounter===a&&(c.colorCounter=0)):b=c.colorIndex;this.colorIndex=C(this.colorIndex,b)},applyOptions:function(c,a){var b=this.series,d=b.options.pointValKey||b.pointValKey;c=E.prototype.optionsToObject.call(this,c);H(this,c);this.options=this.options?H(this.options,c):c;c.group&&delete this.group;c.dataLabels&&delete this.dataLabels;d&&(this.y=this[d]);this.formatPrefix=
(this.isNull=C(this.isValid&&!this.isValid(),null===this.x||!t(this.y)))?"null":"point";this.selected&&(this.state="select");"name"in this&&void 0===a&&b.xAxis&&b.xAxis.hasNames&&(this.x=b.xAxis.nameToX(this));void 0===this.x&&b&&(this.x=void 0===a?b.autoIncrement(this):a);return this},setNestedProperty:function(c,a,b){b.split(".").reduce(function(b,c,l,h){b[c]=h.length-1===l?a:x(b[c],!0)?b[c]:{};return b[c]},c);return c},optionsToObject:function(h){var a={},b=this.series,d=b.options.keys,f=d||b.pointArrayMap||
["y"],l=f.length,m=0,e=0;if(t(h)||null===h)a[f[0]]=h;else if(z(h))for(!d&&h.length>l&&(b=typeof h[0],"string"===b?a.name=h[0]:"number"===b&&(a.x=h[0]),m++);e<l;)d&&void 0===h[m]||(0<f[e].indexOf(".")?c.Point.prototype.setNestedProperty(a,h[m],f[e]):a[f[e]]=h[m]),m++,e++;else"object"===typeof h&&(a=h,h.dataLabels&&(b._hasPointLabels=!0),h.marker&&(b._hasPointMarkers=!0));return a},getClassName:function(){return"highcharts-point"+(this.selected?" highcharts-point-select":"")+(this.negative?" highcharts-negative":
"")+(this.isNull?" highcharts-null-point":"")+(void 0!==this.colorIndex?" highcharts-color-"+this.colorIndex:"")+(this.options.className?" "+this.options.className:"")+(this.zone&&this.zone.className?" "+this.zone.className.replace("highcharts-negative",""):"")},getZone:function(){var c=this.series,a=c.zones;c=c.zoneAxis||"y";var b=0,d;for(d=a[b];this[c]>=d.value;)d=a[++b];this.nonZonedColor||(this.nonZonedColor=this.color);this.color=d&&d.color&&!this.options.color?d.color:this.nonZonedColor;return d},
hasNewShapeType:function(){return this.graphic&&this.graphic.element.nodeName!==this.shapeType},destroy:function(){var c=this.series.chart,a=c.hoverPoints,b;c.pointCount--;a&&(this.setState(),G(a,this),a.length||(c.hoverPoints=null));if(this===c.hoverPoint)this.onMouseOut();if(this.graphic||this.dataLabel||this.dataLabels)q(this),this.destroyElements();this.legendItem&&c.legend.destroyItem(this);for(b in this)this[b]=null},destroyElements:function(c){var a=this,b=[],d;c=c||{graphic:1,dataLabel:1};
c.graphic&&b.push("graphic","shadowGroup");c.dataLabel&&b.push("dataLabel","dataLabelUpper","connector");for(d=b.length;d--;){var f=b[d];a[f]&&(a[f]=a[f].destroy())}["dataLabel","connector"].forEach(function(b){var d=b+"s";c[b]&&a[d]&&(a[d].forEach(function(a){a.element&&a.destroy()}),delete a[d])})},getLabelConfig:function(){return{x:this.category,y:this.y,color:this.color,colorIndex:this.colorIndex,key:this.name||this.category,series:this.series,point:this,percentage:this.percentage,total:this.total||
this.stackTotal}},tooltipFormatter:function(c){var a=this.series,b=a.tooltipOptions,d=C(b.valueDecimals,""),f=b.valuePrefix||"",l=b.valueSuffix||"";a.chart.styledMode&&(c=a.chart.tooltip.styledModeFormat(c));(a.pointArrayMap||["y"]).forEach(function(a){a="{point."+a;if(f||l)c=c.replace(RegExp(a+"}","g"),f+a+"}"+l);c=c.replace(RegExp(a+"}","g"),a+":,."+d+"f}")});return m(c,{point:this,series:this.series},a.chart.time)},firePointEvent:function(c,a,b){var d=this,f=this.series.options;(f.point.events[c]||
d.options&&d.options.events&&d.options.events[c])&&this.importEvents();"click"===c&&f.allowPointSelect&&(b=function(a){d.select&&d.select(null,a.ctrlKey||a.metaKey||a.shiftKey)});w(this,c,a,b)},visible:!0}});K(D,"parts/Series.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,e){var I=e.arrayMax,G=e.arrayMin,H=e.defined,z=e.erase,t=e.extend,x=e.isArray,C=e.isNumber,E=e.isString,w=e.objectEach,m=e.pick,p=e.splat,q=e.syncTimeout,h=c.addEvent,a=c.animObject,b=c.correctFloat,d=c.defaultOptions,
f=c.defaultPlotOptions,l=c.fireEvent,F=c.merge,y=c.removeEvent,r=c.SVGElement,n=c.win;c.Series=c.seriesType("line",null,{lineWidth:2,allowPointSelect:!1,showCheckbox:!1,animation:{duration:1E3},events:{},marker:{lineWidth:0,lineColor:"#ffffff",enabledThreshold:2,radius:4,states:{normal:{animation:!0},hover:{animation:{duration:50},enabled:!0,radiusPlus:2,lineWidthPlus:1},select:{fillColor:"#cccccc",lineColor:"#000000",lineWidth:2}}},point:{events:{}},dataLabels:{align:"center",formatter:function(){return null===
this.y?"":c.numberFormat(this.y,-1)},padding:5,style:{fontSize:"11px",fontWeight:"bold",color:"contrast",textOutline:"1px contrast"},verticalAlign:"bottom",x:0,y:0},cropThreshold:300,opacity:1,pointRange:0,softThreshold:!0,states:{normal:{animation:!0},hover:{animation:{duration:50},lineWidthPlus:1,marker:{},halo:{size:10,opacity:.25}},select:{animation:{duration:0}},inactive:{animation:{duration:50},opacity:.2}},stickyTracking:!0,turboThreshold:1E3,findNearestPointBy:"x"},{axisTypes:["xAxis","yAxis"],
coll:"series",colorCounter:0,cropShoulder:1,directTouch:!1,isCartesian:!0,parallelArrays:["x","y"],pointClass:c.Point,requireSorting:!0,sorted:!0,init:function(a,b){l(this,"init",{options:b});var g=this,k=a.series,d;this.eventOptions=this.eventOptions||{};g.chart=a;g.options=b=g.setOptions(b);g.linkedSeries=[];g.bindAxes();t(g,{name:b.name,state:"",visible:!1!==b.visible,selected:!0===b.selected});var f=b.events;w(f,function(a,b){c.isFunction(a)&&g.eventOptions[b]!==a&&(c.isFunction(g.eventOptions[b])&&
y(g,b,g.eventOptions[b]),g.eventOptions[b]=a,h(g,b,a))});if(f&&f.click||b.point&&b.point.events&&b.point.events.click||b.allowPointSelect)a.runTrackerClick=!0;g.getColor();g.getSymbol();g.parallelArrays.forEach(function(a){g[a+"Data"]||(g[a+"Data"]=[])});g.points||g.data||g.setData(b.data,!1);g.isCartesian&&(a.hasCartesianSeries=!0);k.length&&(d=k[k.length-1]);g._i=m(d&&d._i,-1)+1;a.orderSeries(this.insert(k));l(this,"afterInit")},insert:function(a){var b=this.options.index,g;if(C(b)){for(g=a.length;g--;)if(b>=
m(a[g].options.index,a[g]._i)){a.splice(g+1,0,this);break}-1===g&&a.unshift(this);g+=1}else a.push(this);return m(g,a.length-1)},bindAxes:function(){var a=this,b=a.options,d=a.chart,f;l(this,"bindAxes",null,function(){(a.axisTypes||[]).forEach(function(g){d[g].forEach(function(k){f=k.options;if(b[g]===f.index||void 0!==b[g]&&b[g]===f.id||void 0===b[g]&&0===f.index)a.insert(k.series),a[g]=k,k.isDirty=!0});a[g]||a.optionalAxis===g||c.error(18,!0,d)})})},updateParallelArrays:function(a,b){var g=a.series,
k=arguments,c=C(b)?function(k){var c="y"===k&&g.toYData?g.toYData(a):a[k];g[k+"Data"][b]=c}:function(a){Array.prototype[b].apply(g[a+"Data"],Array.prototype.slice.call(k,2))};g.parallelArrays.forEach(c)},hasData:function(){return this.visible&&void 0!==this.dataMax&&void 0!==this.dataMin||this.visible&&this.yData&&0<this.yData.length},autoIncrement:function(){var a=this.options,b=this.xIncrement,c,d=a.pointIntervalUnit,f=this.chart.time;b=m(b,a.pointStart,0);this.pointInterval=c=m(this.pointInterval,
a.pointInterval,1);d&&(a=new f.Date(b),"day"===d?f.set("Date",a,f.get("Date",a)+c):"month"===d?f.set("Month",a,f.get("Month",a)+c):"year"===d&&f.set("FullYear",a,f.get("FullYear",a)+c),c=a.getTime()-b);this.xIncrement=b+c;return b},setOptions:function(a){var b=this.chart,g=b.options,c=g.plotOptions,f=b.userOptions||{};a=F(a);b=b.styledMode;var n={plotOptions:c,userOptions:a};l(this,"setOptions",n);var h=n.plotOptions[this.type],e=f.plotOptions||{};this.userOptions=n.userOptions;f=F(h,c.series,f.plotOptions&&
f.plotOptions[this.type],a);this.tooltipOptions=F(d.tooltip,d.plotOptions.series&&d.plotOptions.series.tooltip,d.plotOptions[this.type].tooltip,g.tooltip.userOptions,c.series&&c.series.tooltip,c[this.type].tooltip,a.tooltip);this.stickyTracking=m(a.stickyTracking,e[this.type]&&e[this.type].stickyTracking,e.series&&e.series.stickyTracking,this.tooltipOptions.shared&&!this.noSharedTooltip?!0:f.stickyTracking);null===h.marker&&delete f.marker;this.zoneAxis=f.zoneAxis;g=this.zones=(f.zones||[]).slice();
!f.negativeColor&&!f.negativeFillColor||f.zones||(c={value:f[this.zoneAxis+"Threshold"]||f.threshold||0,className:"highcharts-negative"},b||(c.color=f.negativeColor,c.fillColor=f.negativeFillColor),g.push(c));g.length&&H(g[g.length-1].value)&&g.push(b?{}:{color:this.color,fillColor:this.fillColor});l(this,"afterSetOptions",{options:f});return f},getName:function(){return m(this.options.name,"Series "+(this.index+1))},getCyclic:function(a,b,c){var g=this.chart,k=this.userOptions,d=a+"Index",f=a+"Counter",
l=c?c.length:m(g.options.chart[a+"Count"],g[a+"Count"]);if(!b){var n=m(k[d],k["_"+d]);H(n)||(g.series.length||(g[f]=0),k["_"+d]=n=g[f]%l,g[f]+=1);c&&(b=c[n])}void 0!==n&&(this[d]=n);this[a]=b},getColor:function(){this.chart.styledMode?this.getCyclic("color"):this.options.colorByPoint?this.options.color=null:this.getCyclic("color",this.options.color||f[this.type].color,this.chart.options.colors)},getSymbol:function(){this.getCyclic("symbol",this.options.marker.symbol,this.chart.options.symbols)},findPointIndex:function(a,
b){var g=a.id;a=a.x;var k=this.points,c;if(g){var d=(g=this.chart.get(g))&&g.index;void 0!==d&&(c=!0)}void 0===d&&C(a)&&(d=this.xData.indexOf(a,b));-1!==d&&void 0!==d&&this.cropped&&(d=d>=this.cropStart?d-this.cropStart:d);!c&&k[d]&&k[d].touched&&(d=void 0);return d},drawLegendSymbol:c.LegendSymbolMixin.drawLineMarker,updateData:function(a){var b=this.options,g=this.points,c=[],d,f,n,l=this.requireSorting,m=a.length===g.length,h=!0;this.xIncrement=null;a.forEach(function(a,k){var f=H(a)&&this.pointClass.prototype.optionsToObject.call({series:this},
a)||{};var v=f.x;if(f.id||C(v))if(v=this.findPointIndex(f,n),-1===v||void 0===v?c.push(a):g[v]&&a!==b.data[v]?(g[v].update(a,!1,null,!1),g[v].touched=!0,l&&(n=v+1)):g[v]&&(g[v].touched=!0),!m||k!==v||this.hasDerivedData)d=!0},this);if(d)for(a=g.length;a--;)(f=g[a])&&!f.touched&&f.remove(!1);else m?a.forEach(function(a,b){g[b].update&&a!==g[b].y&&g[b].update(a,!1,null,!1)}):h=!1;g.forEach(function(a){a&&(a.touched=!1)});if(!h)return!1;c.forEach(function(a){this.addPoint(a,!1,null,null,!1)},this);return!0},
setData:function(a,b,d,f){var g=this,k=g.points,n=k&&k.length||0,l,v=g.options,B=g.chart,h=null,e=g.xAxis;h=v.turboThreshold;var r=this.xData,p=this.yData,w=(l=g.pointArrayMap)&&l.length,y=v.keys,q=0,F=1,t;a=a||[];l=a.length;b=m(b,!0);!1!==f&&l&&n&&!g.cropped&&!g.hasGroupedData&&g.visible&&!g.isSeriesBoosting&&(t=this.updateData(a));if(!t){g.xIncrement=null;g.colorCounter=0;this.parallelArrays.forEach(function(a){g[a+"Data"].length=0});if(h&&l>h)if(h=g.getFirstValidPoint(a),C(h))for(d=0;d<l;d++)r[d]=
this.autoIncrement(),p[d]=a[d];else if(x(h))if(w)for(d=0;d<l;d++)f=a[d],r[d]=f[0],p[d]=f.slice(1,w+1);else for(y&&(q=y.indexOf("x"),F=y.indexOf("y"),q=0<=q?q:0,F=0<=F?F:1),d=0;d<l;d++)f=a[d],r[d]=f[q],p[d]=f[F];else c.error(12,!1,B);else for(d=0;d<l;d++)void 0!==a[d]&&(f={series:g},g.pointClass.prototype.applyOptions.apply(f,[a[d]]),g.updateParallelArrays(f,d));p&&E(p[0])&&c.error(14,!0,B);g.data=[];g.options.data=g.userOptions.data=a;for(d=n;d--;)k[d]&&k[d].destroy&&k[d].destroy();e&&(e.minRange=
e.userMinRange);g.isDirty=B.isDirtyBox=!0;g.isDirtyData=!!k;d=!1}"point"===v.legendType&&(this.processData(),this.generatePoints());b&&B.redraw(d)},processData:function(a){var b=this.xData,g=this.yData,d=b.length;var f=0;var l=this.xAxis,n=this.options;var h=n.cropThreshold;var m=this.getExtremesFromAll||n.getExtremesFromAll,e=this.isCartesian;n=l&&l.val2lin;var r=l&&l.isLog,p=this.requireSorting;if(e&&!this.isDirty&&!l.isDirty&&!this.yAxis.isDirty&&!a)return!1;if(l){a=l.getExtremes();var w=a.min;
var y=a.max}if(e&&this.sorted&&!m&&(!h||d>h||this.forceCrop))if(b[d-1]<w||b[0]>y)b=[],g=[];else if(this.yData&&(b[0]<w||b[d-1]>y)){f=this.cropData(this.xData,this.yData,w,y);b=f.xData;g=f.yData;f=f.start;var q=!0}for(h=b.length||1;--h;)if(d=r?n(b[h])-n(b[h-1]):b[h]-b[h-1],0<d&&(void 0===F||d<F))var F=d;else 0>d&&p&&(c.error(15,!1,this.chart),p=!1);this.cropped=q;this.cropStart=f;this.processedXData=b;this.processedYData=g;this.closestPointRange=this.basePointRange=F},cropData:function(a,b,d,c,f){var g=
a.length,k=0,l=g,n;f=m(f,this.cropShoulder);for(n=0;n<g;n++)if(a[n]>=d){k=Math.max(0,n-f);break}for(d=n;d<g;d++)if(a[d]>c){l=d+f;break}return{xData:a.slice(k,l),yData:b.slice(k,l),start:k,end:l}},generatePoints:function(){var a=this.options,b=a.data,d=this.data,c,f=this.processedXData,n=this.processedYData,h=this.pointClass,m=f.length,e=this.cropStart||0,r=this.hasGroupedData;a=a.keys;var w=[],y;d||r||(d=[],d.length=b.length,d=this.data=d);a&&r&&(this.options.keys=!1);for(y=0;y<m;y++){var F=e+y;if(r){var q=
(new h).init(this,[f[y]].concat(p(n[y])));q.dataGroup=this.groupMap[y];q.dataGroup.options&&(q.options=q.dataGroup.options,t(q,q.dataGroup.options),delete q.dataLabels)}else(q=d[F])||void 0===b[F]||(d[F]=q=(new h).init(this,b[F],f[y]));q&&(q.index=F,w[y]=q)}this.options.keys=a;if(d&&(m!==(c=d.length)||r))for(y=0;y<c;y++)y!==e||r||(y+=m),d[y]&&(d[y].destroyElements(),d[y].plotX=void 0);this.data=d;this.points=w;l(this,"afterGeneratePoints")},getXExtremes:function(a){return{min:G(a),max:I(a)}},getExtremes:function(a){var b=
this.xAxis,g=this.yAxis,d=this.processedXData||this.xData,c=[],f=0,n=0;var h=0;var m=this.requireSorting?this.cropShoulder:0,e=g?g.positiveValuesOnly:!1,r;a=a||this.stackedYData||this.processedYData||[];g=a.length;b&&(h=b.getExtremes(),n=h.min,h=h.max);for(r=0;r<g;r++){var p=d[r];var y=a[r];var w=(C(y)||x(y))&&(y.length||0<y||!e);p=this.getExtremesFromAll||this.options.getExtremesFromAll||this.cropped||!b||(d[r+m]||p)>=n&&(d[r-m]||p)<=h;if(w&&p)if(w=y.length)for(;w--;)C(y[w])&&(c[f++]=y[w]);else c[f++]=
y}this.dataMin=G(c);this.dataMax=I(c);l(this,"afterGetExtremes")},getFirstValidPoint:function(a){for(var b=null,g=a.length,d=0;null===b&&d<g;)b=a[d],d++;return b},translate:function(){this.processedXData||this.processData();this.generatePoints();var a=this.options,d=a.stacking,c=this.xAxis,f=c.categories,n=this.yAxis,h=this.points,e=h.length,r=!!this.modifyValue,p,y=this.pointPlacementToXValue(),w=C(y),q=a.threshold,F=a.startFromThreshold?q:0,t,z=this.zoneAxis||"y",E=Number.MAX_VALUE;for(p=0;p<e;p++){var G=
h[p],I=G.x;var D=G.y;var T=G.low,K=d&&n.stacks[(this.negStacks&&D<(F?0:q)?"-":"")+this.stackKey];n.positiveValuesOnly&&null!==D&&0>=D&&(G.isNull=!0);G.plotX=t=b(Math.min(Math.max(-1E5,c.translate(I,0,0,0,1,y,"flags"===this.type)),1E5));if(d&&this.visible&&K&&K[I]){var Z=this.getStackIndicator(Z,I,this.index);if(!G.isNull){var aa=K[I];var V=aa.points[Z.key]}}x(V)&&(T=V[0],D=V[1],T===F&&Z.key===K[I].base&&(T=m(C(q)&&q,n.min)),n.positiveValuesOnly&&0>=T&&(T=null),G.total=G.stackTotal=aa.total,G.percentage=
aa.total&&G.y/aa.total*100,G.stackY=D,this.irregularWidths||aa.setOffset(this.pointXOffset||0,this.barW||0));G.yBottom=H(T)?Math.min(Math.max(-1E5,n.translate(T,0,1,0,1)),1E5):null;r&&(D=this.modifyValue(D,G));G.plotY=D="number"===typeof D&&Infinity!==D?Math.min(Math.max(-1E5,n.translate(D,0,1,0,1)),1E5):void 0;G.isInside=void 0!==D&&0<=D&&D<=n.len&&0<=t&&t<=c.len;G.clientX=w?b(c.translate(I,0,0,0,1,y)):t;G.negative=G[z]<(a[z+"Threshold"]||q||0);G.category=f&&void 0!==f[G.x]?f[G.x]:G.x;if(!G.isNull){void 0!==
W&&(E=Math.min(E,Math.abs(t-W)));var W=t}G.zone=this.zones.length&&G.getZone()}this.closestPointRangePx=E;l(this,"afterTranslate")},getValidPoints:function(a,b,d){var g=this.chart;return(a||this.points||[]).filter(function(a){return b&&!g.isInsidePlot(a.plotX,a.plotY,g.inverted)?!1:d||!a.isNull})},getClipBox:function(a,b){var g=this.options,d=this.chart,k=d.inverted,c=this.xAxis,f=c&&this.yAxis;a&&!1===g.clip&&f?a=k?{y:-d.chartWidth+f.len+f.pos,height:d.chartWidth,width:d.chartHeight,x:-d.chartHeight+
c.len+c.pos}:{y:-f.pos,height:d.chartHeight,width:d.chartWidth,x:-c.pos}:(a=this.clipBox||d.clipBox,b&&(a.width=d.plotSizeX,a.x=0));return b?{width:a.width,x:a.x}:a},setClip:function(a){var b=this.chart,g=this.options,d=b.renderer,c=b.inverted,f=this.clipBox,n=this.getClipBox(a),l=this.sharedClipKey||["_sharedClip",a&&a.duration,a&&a.easing,n.height,g.xAxis,g.yAxis].join(),h=b[l],m=b[l+"m"];h||(a&&(n.width=0,c&&(n.x=b.plotSizeX+(!1!==g.clip?0:b.plotTop)),b[l+"m"]=m=d.clipRect(c?b.plotSizeX+99:-99,
c?-b.plotLeft:-b.plotTop,99,c?b.chartWidth:b.chartHeight)),b[l]=h=d.clipRect(n),h.count={length:0});a&&!h.count[this.index]&&(h.count[this.index]=!0,h.count.length+=1);if(!1!==g.clip||a)this.group.clip(a||f?h:b.clipRect),this.markerGroup.clip(m),this.sharedClipKey=l;a||(h.count[this.index]&&(delete h.count[this.index],--h.count.length),0===h.count.length&&l&&b[l]&&(f||(b[l]=b[l].destroy()),b[l+"m"]&&(b[l+"m"]=b[l+"m"].destroy())))},animate:function(b){var g=this.chart,d=a(this.options.animation);
if(b)this.setClip(d);else{var c=this.sharedClipKey;b=g[c];var f=this.getClipBox(d,!0);b&&b.animate(f,d);g[c+"m"]&&g[c+"m"].animate({width:f.width+99,x:f.x-(g.inverted?0:99)},d);this.animate=null}},afterAnimate:function(){this.setClip();l(this,"afterAnimate");this.finishedAnimating=!0},drawPoints:function(){var a=this.points,b=this.chart,d,c=this.options.marker,f=this[this.specialGroup]||this.markerGroup;var n=this.xAxis;var l=m(c.enabled,!n||n.isRadial?!0:null,this.closestPointRangePx>=c.enabledThreshold*
c.radius);if(!1!==c.enabled||this._hasPointMarkers)for(n=0;n<a.length;n++){var h=a[n];var e=(d=h.graphic)?"animate":"attr";var r=h.marker||{};var p=!!h.marker;var y=l&&void 0===r.enabled||r.enabled;var w=!1!==h.isInside;if(y&&!h.isNull){var q=m(r.symbol,this.symbol);y=this.markerAttribs(h,h.selected&&"select");d?d[w?"show":"hide"](w).animate(y):w&&(0<y.width||h.hasImage)&&(h.graphic=d=b.renderer.symbol(q,y.x,y.y,y.width,y.height,p?r:c).add(f));if(d&&!b.styledMode)d[e](this.pointAttribs(h,h.selected&&
"select"));d&&d.addClass(h.getClassName(),!0)}else d&&(h.graphic=d.destroy())}},markerAttribs:function(a,b){var g=this.options.marker,d=a.marker||{},c=d.symbol||g.symbol,k=m(d.radius,g.radius);b&&(g=g.states[b],b=d.states&&d.states[b],k=m(b&&b.radius,g&&g.radius,k+(g&&g.radiusPlus||0)));a.hasImage=c&&0===c.indexOf("url");a.hasImage&&(k=0);a={x:Math.floor(a.plotX)-k,y:a.plotY-k};k&&(a.width=a.height=2*k);return a},pointAttribs:function(a,b){var g=this.options.marker,d=a&&a.options,c=d&&d.marker||{},
k=this.color,f=d&&d.color,n=a&&a.color;d=m(c.lineWidth,g.lineWidth);var l=a&&a.zone&&a.zone.color;a=1;k=f||l||n||k;f=c.fillColor||g.fillColor||k;k=c.lineColor||g.lineColor||k;b=b||"normal";g=g.states[b];b=c.states&&c.states[b]||{};d=m(b.lineWidth,g.lineWidth,d+m(b.lineWidthPlus,g.lineWidthPlus,0));f=b.fillColor||g.fillColor||f;k=b.lineColor||g.lineColor||k;a=m(b.opacity,g.opacity,a);return{stroke:k,"stroke-width":d,fill:f,opacity:a}},destroy:function(a){var b=this,g=b.chart,d=/AppleWebKit\/533/.test(n.navigator.userAgent),
f,h,m=b.data||[],e,p;l(b,"destroy");a||y(b);(b.axisTypes||[]).forEach(function(a){(p=b[a])&&p.series&&(z(p.series,b),p.isDirty=p.forceRedraw=!0)});b.legendItem&&b.chart.legend.destroyItem(b);for(h=m.length;h--;)(e=m[h])&&e.destroy&&e.destroy();b.points=null;c.clearTimeout(b.animationTimeout);w(b,function(a,b){a instanceof r&&!a.survive&&(f=d&&"group"===b?"hide":"destroy",a[f]())});g.hoverSeries===b&&(g.hoverSeries=null);z(g.series,b);g.orderSeries();w(b,function(g,d){a&&"hcEvents"===d||delete b[d]})},
getGraphPath:function(a,b,d){var g=this,c=g.options,k=c.step,f,n=[],l=[],h;a=a||g.points;(f=a.reversed)&&a.reverse();(k={right:1,center:2}[k]||k&&3)&&f&&(k=4-k);!c.connectNulls||b||d||(a=this.getValidPoints(a));a.forEach(function(f,m){var B=f.plotX,e=f.plotY,v=a[m-1];(f.leftCliff||v&&v.rightCliff)&&!d&&(h=!0);f.isNull&&!H(b)&&0<m?h=!c.connectNulls:f.isNull&&!b?h=!0:(0===m||h?m=["M",f.plotX,f.plotY]:g.getPointSpline?m=g.getPointSpline(a,f,m):k?(m=1===k?["L",v.plotX,e]:2===k?["L",(v.plotX+B)/2,v.plotY,
"L",(v.plotX+B)/2,e]:["L",B,v.plotY],m.push("L",B,e)):m=["L",B,e],l.push(f.x),k&&(l.push(f.x),2===k&&l.push(f.x)),n.push.apply(n,m),h=!1)});n.xMap=l;return g.graphPath=n},drawGraph:function(){var a=this,b=this.options,d=(this.gappedPath||this.getGraphPath).call(this),c=this.chart.styledMode,f=[["graph","highcharts-graph"]];c||f[0].push(b.lineColor||this.color||"#cccccc",b.dashStyle);f=a.getZonesGraphs(f);f.forEach(function(g,k){var f=g[0],n=a[f],l=n?"animate":"attr";n?(n.endX=a.preventGraphAnimation?
null:d.xMap,n.animate({d:d})):d.length&&(a[f]=n=a.chart.renderer.path(d).addClass(g[1]).attr({zIndex:1}).add(a.group));n&&!c&&(f={stroke:g[2],"stroke-width":b.lineWidth,fill:a.fillGraph&&a.color||"none"},g[3]?f.dashstyle=g[3]:"square"!==b.linecap&&(f["stroke-linecap"]=f["stroke-linejoin"]="round"),n[l](f).shadow(2>k&&b.shadow));n&&(n.startX=d.xMap,n.isArea=d.isArea)})},getZonesGraphs:function(a){this.zones.forEach(function(b,g){g=["zone-graph-"+g,"highcharts-graph highcharts-zone-graph-"+g+" "+(b.className||
"")];this.chart.styledMode||g.push(b.color||this.color,b.dashStyle||this.options.dashStyle);a.push(g)},this);return a},applyZones:function(){var a=this,b=this.chart,d=b.renderer,c=this.zones,f,n,l=this.clips||[],h,e=this.graph,r=this.area,p=Math.max(b.chartWidth,b.chartHeight),y=this[(this.zoneAxis||"y")+"Axis"],w=b.inverted,q,F,x,t=!1;if(c.length&&(e||r)&&y&&void 0!==y.min){var C=y.reversed;var z=y.horiz;e&&!this.showLine&&e.hide();r&&r.hide();var E=y.getExtremes();c.forEach(function(g,c){f=C?z?
b.plotWidth:0:z?0:y.toPixels(E.min)||0;f=Math.min(Math.max(m(n,f),0),p);n=Math.min(Math.max(Math.round(y.toPixels(m(g.value,E.max),!0)||0),0),p);t&&(f=n=y.toPixels(E.max));q=Math.abs(f-n);F=Math.min(f,n);x=Math.max(f,n);y.isXAxis?(h={x:w?x:F,y:0,width:q,height:p},z||(h.x=b.plotHeight-h.x)):(h={x:0,y:w?x:F,width:p,height:q},z&&(h.y=b.plotWidth-h.y));w&&d.isVML&&(h=y.isXAxis?{x:0,y:C?F:x,height:h.width,width:b.chartWidth}:{x:h.y-b.plotLeft-b.spacingBox.x,y:0,width:h.height,height:b.chartHeight});l[c]?
l[c].animate(h):l[c]=d.clipRect(h);e&&a["zone-graph-"+c].clip(l[c]);r&&a["zone-area-"+c].clip(l[c]);t=g.value>E.max;a.resetZones&&0===n&&(n=void 0)});this.clips=l}else a.visible&&(e&&e.show(!0),r&&r.show(!0))},invertGroups:function(a){function b(){["group","markerGroup"].forEach(function(b){g[b]&&(d.renderer.isVML&&g[b].attr({width:g.yAxis.len,height:g.xAxis.len}),g[b].width=g.yAxis.len,g[b].height=g.xAxis.len,g[b].invert(a))})}var g=this,d=g.chart;if(g.xAxis){var c=h(d,"resize",b);h(g,"destroy",
c);b(a);g.invertGroups=b}},plotGroup:function(a,b,d,c,f){var g=this[a],k=!g;k&&(this[a]=g=this.chart.renderer.g().attr({zIndex:c||.1}).add(f));g.addClass("highcharts-"+b+" highcharts-series-"+this.index+" highcharts-"+this.type+"-series "+(H(this.colorIndex)?"highcharts-color-"+this.colorIndex+" ":"")+(this.options.className||"")+(g.hasClass("highcharts-tracker")?" highcharts-tracker":""),!0);g.attr({visibility:d})[k?"attr":"animate"](this.getPlotBox());return g},getPlotBox:function(){var a=this.chart,
b=this.xAxis,d=this.yAxis;a.inverted&&(b=d,d=this.xAxis);return{translateX:b?b.left:a.plotLeft,translateY:d?d.top:a.plotTop,scaleX:1,scaleY:1}},render:function(){var b=this,d=b.chart,c=b.options,f=!!b.animate&&d.renderer.isSVG&&a(c.animation).duration,n=b.visible?"inherit":"hidden",h=c.zIndex,m=b.hasRendered,e=d.seriesGroup,r=d.inverted;l(this,"render");var p=b.plotGroup("group","series",n,h,e);b.markerGroup=b.plotGroup("markerGroup","markers",n,h,e);f&&b.animate(!0);p.inverted=b.isCartesian||b.invertable?
r:!1;b.drawGraph&&(b.drawGraph(),b.applyZones());b.visible&&b.drawPoints();b.drawDataLabels&&b.drawDataLabels();b.redrawPoints&&b.redrawPoints();b.drawTracker&&!1!==b.options.enableMouseTracking&&b.drawTracker();b.invertGroups(r);!1===c.clip||b.sharedClipKey||m||p.clip(d.clipRect);f&&b.animate();m||(b.animationTimeout=q(function(){b.afterAnimate()},f||0));b.isDirty=!1;b.hasRendered=!0;l(b,"afterRender")},redraw:function(){var a=this.chart,b=this.isDirty||this.isDirtyData,d=this.group,c=this.xAxis,
f=this.yAxis;d&&(a.inverted&&d.attr({width:a.plotWidth,height:a.plotHeight}),d.animate({translateX:m(c&&c.left,a.plotLeft),translateY:m(f&&f.top,a.plotTop)}));this.translate();this.render();b&&delete this.kdTree},kdAxisArray:["clientX","plotY"],searchPoint:function(a,b){var g=this.xAxis,d=this.yAxis,c=this.chart.inverted;return this.searchKDTree({clientX:c?g.len-a.chartY+g.pos:a.chartX-g.pos,plotY:c?d.len-a.chartX+d.pos:a.chartY-d.pos},b,a)},buildKDTree:function(a){function b(a,d,c){var k;if(k=a&&
a.length){var f=g.kdAxisArray[d%c];a.sort(function(a,b){return a[f]-b[f]});k=Math.floor(k/2);return{point:a[k],left:b(a.slice(0,k),d+1,c),right:b(a.slice(k+1),d+1,c)}}}this.buildingKdTree=!0;var g=this,d=-1<g.options.findNearestPointBy.indexOf("y")?2:1;delete g.kdTree;q(function(){g.kdTree=b(g.getValidPoints(null,!g.directTouch),d,d);g.buildingKdTree=!1},g.options.kdNow||a&&"touchstart"===a.type?0:1)},searchKDTree:function(a,b,d){function g(a,b,d,l){var h=b.point,m=c.kdAxisArray[d%l],e=h;var r=H(a[k])&&
H(h[k])?Math.pow(a[k]-h[k],2):null;var B=H(a[f])&&H(h[f])?Math.pow(a[f]-h[f],2):null;B=(r||0)+(B||0);h.dist=H(B)?Math.sqrt(B):Number.MAX_VALUE;h.distX=H(r)?Math.sqrt(r):Number.MAX_VALUE;m=a[m]-h[m];B=0>m?"left":"right";r=0>m?"right":"left";b[B]&&(B=g(a,b[B],d+1,l),e=B[n]<e[n]?B:h);b[r]&&Math.sqrt(m*m)<e[n]&&(a=g(a,b[r],d+1,l),e=a[n]<e[n]?a:e);return e}var c=this,k=this.kdAxisArray[0],f=this.kdAxisArray[1],n=b?"distX":"dist";b=-1<c.options.findNearestPointBy.indexOf("y")?2:1;this.kdTree||this.buildingKdTree||
this.buildKDTree(d);if(this.kdTree)return g(a,this.kdTree,b,b)},pointPlacementToXValue:function(){var a=this.xAxis,b=this.options.pointPlacement;"between"===b&&(b=a.reversed?-.5:.5);C(b)&&(b*=m(this.options.pointRange||a.pointRange));return b}});""});K(D,"parts/Stacking.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,e){var I=e.defined,G=e.destroyObjectProperties,H=e.objectEach,z=e.pick;e=c.Axis;var t=c.Chart,x=c.correctFloat,C=c.format,E=c.Series;c.StackItem=function(c,m,e,q,h){var a=
c.chart.inverted;this.axis=c;this.isNegative=e;this.options=m=m||{};this.x=q;this.total=null;this.points={};this.stack=h;this.rightCliff=this.leftCliff=0;this.alignOptions={align:m.align||(a?e?"left":"right":"center"),verticalAlign:m.verticalAlign||(a?"middle":e?"bottom":"top"),y:m.y,x:m.x};this.textAlign=m.textAlign||(a?e?"right":"left":"center")};c.StackItem.prototype={destroy:function(){G(this,this.axis)},render:function(c){var m=this.axis.chart,e=this.options,w=e.format;w=w?C(w,this,m.time):e.formatter.call(this);
this.label?this.label.attr({text:w,visibility:"hidden"}):(this.label=m.renderer.label(w,null,null,e.shape,null,null,e.useHTML,!1,"stack-labels"),w={text:w,align:this.textAlign,rotation:e.rotation,padding:z(e.padding,0),visibility:"hidden"},this.label.attr(w),m.styledMode||this.label.css(e.style),this.label.added||this.label.add(c));this.label.labelrank=m.plotHeight},setOffset:function(c,m,e,q,h){var a=this.axis,b=a.chart;q=a.translate(a.usePercentage?100:q?q:this.total,0,0,0,1);e=a.translate(e?e:
0);e=I(q)&&Math.abs(q-e);c=z(h,b.xAxis[0].translate(this.x))+c;a=I(q)&&this.getStackBox(b,this,c,q,m,e,a);m=this.label;c=this.isNegative;h="justify"===z(this.options.overflow,"justify");if(m&&a){e=m.getBBox();var d=b.inverted?c?e.width:0:e.width/2,f=b.inverted?e.height/2:c?-4:e.height+4;this.alignOptions.x=z(this.options.x,0);m.align(this.alignOptions,null,a);q=m.alignAttr;m.show();q.y-=f;h&&(q.x-=d,E.prototype.justifyDataLabel.call(this.axis,m,this.alignOptions,q,e,a),q.x+=d);q.x=m.alignAttr.x;m.attr({x:q.x,
y:q.y});z(!h&&this.options.crop,!0)&&((b=b.isInsidePlot(m.x+(b.inverted?0:-e.width/2),m.y)&&b.isInsidePlot(m.x+(b.inverted?c?-e.width:e.width:e.width/2),m.y+e.height))||m.hide())}},getStackBox:function(c,m,e,q,h,a,b){var d=m.axis.reversed,f=c.inverted;c=b.height+b.pos-(f?c.plotLeft:c.plotTop);m=m.isNegative&&!d||!m.isNegative&&d;return{x:f?m?q:q-a:e,y:f?c-e-h:m?c-q-a:c-q,width:f?a:h,height:f?h:a}}};t.prototype.getStacks=function(){var c=this,m=c.inverted;c.yAxis.forEach(function(c){c.stacks&&c.hasVisibleSeries&&
(c.oldStacks=c.stacks)});c.series.forEach(function(e){var p=e.xAxis&&e.xAxis.options||{};!e.options.stacking||!0!==e.visible&&!1!==c.options.chart.ignoreHiddenSeries||(e.stackKey=[e.type,z(e.options.stack,""),m?p.top:p.left,m?p.height:p.width].join())})};e.prototype.buildStacks=function(){var c=this.series,m=z(this.options.reversedStacks,!0),e=c.length,q;if(!this.isXAxis){this.usePercentage=!1;for(q=e;q--;)c[m?q:e-q-1].setStackedPoints();for(q=0;q<e;q++)c[q].modifyStacks()}};e.prototype.renderStackTotals=
function(){var c=this.chart,m=c.renderer,e=this.stacks,q=this.stackTotalGroup;q||(this.stackTotalGroup=q=m.g("stack-labels").attr({visibility:"visible",zIndex:6}).add());q.translate(c.plotLeft,c.plotTop);H(e,function(c){H(c,function(a){a.render(q)})})};e.prototype.resetStacks=function(){var c=this,m=c.stacks;c.isXAxis||H(m,function(m){H(m,function(e,h){e.touched<c.stacksTouched?(e.destroy(),delete m[h]):(e.total=null,e.cumulative=null)})})};e.prototype.cleanStacks=function(){if(!this.isXAxis){if(this.oldStacks)var c=
this.stacks=this.oldStacks;H(c,function(c){H(c,function(c){c.cumulative=c.total})})}};E.prototype.setStackedPoints=function(){if(this.options.stacking&&(!0===this.visible||!1===this.chart.options.chart.ignoreHiddenSeries)){var e=this.processedXData,m=this.processedYData,p=[],q=m.length,h=this.options,a=h.threshold,b=z(h.startFromThreshold&&a,0),d=h.stack;h=h.stacking;var f=this.stackKey,l="-"+f,F=this.negStacks,y=this.yAxis,r=y.stacks,n=y.oldStacks,g,k;y.stacksTouched+=1;for(k=0;k<q;k++){var v=e[k];
var B=m[k];var A=this.getStackIndicator(A,v,this.index);var u=A.key;var J=(g=F&&B<(b?0:a))?l:f;r[J]||(r[J]={});r[J][v]||(n[J]&&n[J][v]?(r[J][v]=n[J][v],r[J][v].total=null):r[J][v]=new c.StackItem(y,y.options.stackLabels,g,v,d));J=r[J][v];null!==B?(J.points[u]=J.points[this.index]=[z(J.cumulative,b)],I(J.cumulative)||(J.base=u),J.touched=y.stacksTouched,0<A.index&&!1===this.singleStacks&&(J.points[u][0]=J.points[this.index+","+v+",0"][0])):J.points[u]=J.points[this.index]=null;"percent"===h?(g=g?f:
l,F&&r[g]&&r[g][v]?(g=r[g][v],J.total=g.total=Math.max(g.total,J.total)+Math.abs(B)||0):J.total=x(J.total+(Math.abs(B)||0))):J.total=x(J.total+(B||0));J.cumulative=z(J.cumulative,b)+(B||0);null!==B&&(J.points[u].push(J.cumulative),p[k]=J.cumulative)}"percent"===h&&(y.usePercentage=!0);this.stackedYData=p;y.oldStacks={}}};E.prototype.modifyStacks=function(){var c=this,m=c.stackKey,e=c.yAxis.stacks,q=c.processedXData,h,a=c.options.stacking;c[a+"Stacker"]&&[m,"-"+m].forEach(function(b){for(var d=q.length,
f,l;d--;)if(f=q[d],h=c.getStackIndicator(h,f,c.index,b),l=(f=e[b]&&e[b][f])&&f.points[h.key])c[a+"Stacker"](l,f,d)})};E.prototype.percentStacker=function(c,m,e){m=m.total?100/m.total:0;c[0]=x(c[0]*m);c[1]=x(c[1]*m);this.stackedYData[e]=c[1]};E.prototype.getStackIndicator=function(c,m,e,q){!I(c)||c.x!==m||q&&c.key!==q?c={x:m,index:0,key:q}:c.index++;c.key=[e,m,c.index].join();return c}});K(D,"parts/Dynamics.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,e){var I=e.defined,G=e.erase,
H=e.extend,z=e.isArray,t=e.isNumber,x=e.isObject,C=e.isString,E=e.objectEach,w=e.pick,m=e.setAnimation,p=e.splat,q=c.addEvent,h=c.animate,a=c.Axis;e=c.Chart;var b=c.createElement,d=c.css,f=c.fireEvent,l=c.merge,F=c.Point,y=c.Series,r=c.seriesTypes;c.cleanRecursively=function(a,b){var g={};E(a,function(d,k){if(x(a[k],!0)&&!a.nodeType&&b[k])d=c.cleanRecursively(a[k],b[k]),Object.keys(d).length&&(g[k]=d);else if(x(a[k])||a[k]!==b[k])g[k]=a[k]});return g};H(e.prototype,{addSeries:function(a,b,c){var g,
d=this;a&&(b=w(b,!0),f(d,"addSeries",{options:a},function(){g=d.initSeries(a);d.isDirtyLegend=!0;d.linkSeries();f(d,"afterAddSeries",{series:g});b&&d.redraw(c)}));return g},addAxis:function(a,b,d,c){return this.createAxis(b?"xAxis":"yAxis",{axis:a,redraw:d,animation:c})},addColorAxis:function(a,b,d){return this.createAxis("colorAxis",{axis:a,redraw:b,animation:d})},createAxis:function(b,g){var d=this.options,f="colorAxis"===b,n=g.redraw,h=g.animation;g=l(g.axis,{index:this[b].length,isX:"xAxis"===
b});var m=f?new c.ColorAxis(this,g):new a(this,g);d[b]=p(d[b]||{});d[b].push(g);f&&(this.isDirtyLegend=!0,this.axes.forEach(function(a){a.series=[]}),this.series.forEach(function(a){a.bindAxes();a.isDirtyData=!0}));w(n,!0)&&this.redraw(h);return m},showLoading:function(a){var g=this,c=g.options,f=g.loadingDiv,l=c.loading,n=function(){f&&d(f,{left:g.plotLeft+"px",top:g.plotTop+"px",width:g.plotWidth+"px",height:g.plotHeight+"px"})};f||(g.loadingDiv=f=b("div",{className:"highcharts-loading highcharts-loading-hidden"},
null,g.container),g.loadingSpan=b("span",{className:"highcharts-loading-inner"},null,f),q(g,"redraw",n));f.className="highcharts-loading";g.loadingSpan.innerHTML=w(a,c.lang.loading,"");g.styledMode||(d(f,H(l.style,{zIndex:10})),d(g.loadingSpan,l.labelStyle),g.loadingShown||(d(f,{opacity:0,display:""}),h(f,{opacity:l.style.opacity||.5},{duration:l.showDuration||0})));g.loadingShown=!0;n()},hideLoading:function(){var a=this.options,b=this.loadingDiv;b&&(b.className="highcharts-loading highcharts-loading-hidden",
this.styledMode||h(b,{opacity:0},{duration:a.loading.hideDuration||100,complete:function(){d(b,{display:"none"})}}));this.loadingShown=!1},propsRequireDirtyBox:"backgroundColor borderColor borderWidth borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),propsRequireReflow:"margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft".split(" "),propsRequireUpdateSeries:"chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions time tooltip".split(" "),
collectionsWithUpdate:"xAxis yAxis zAxis colorAxis series pane".split(" "),update:function(a,b,d,h){var g=this,k={credits:"addCredits",title:"setTitle",subtitle:"setSubtitle",caption:"setCaption"},n,m,e,r=a.isResponsiveOptions,v=[];f(g,"update",{options:a});r||g.setResponsive(!1,!0);a=c.cleanRecursively(a,g.options);l(!0,g.userOptions,a);if(n=a.chart){l(!0,g.options.chart,n);"className"in n&&g.setClassName(n.className);"reflow"in n&&g.setReflow(n.reflow);if("inverted"in n||"polar"in n||"type"in n){g.propFromSeries();
var y=!0}"alignTicks"in n&&(y=!0);E(n,function(a,b){-1!==g.propsRequireUpdateSeries.indexOf("chart."+b)&&(m=!0);-1!==g.propsRequireDirtyBox.indexOf(b)&&(g.isDirtyBox=!0);r||-1===g.propsRequireReflow.indexOf(b)||(e=!0)});!g.styledMode&&"style"in n&&g.renderer.setStyle(n.style)}!g.styledMode&&a.colors&&(this.options.colors=a.colors);a.plotOptions&&l(!0,this.options.plotOptions,a.plotOptions);a.time&&this.time===c.time&&(this.time=new c.Time(a.time));E(a,function(a,b){if(g[b]&&"function"===typeof g[b].update)g[b].update(a,
!1);else if("function"===typeof g[k[b]])g[k[b]](a);"chart"!==b&&-1!==g.propsRequireUpdateSeries.indexOf(b)&&(m=!0)});this.collectionsWithUpdate.forEach(function(b){if(a[b]){if("series"===b){var c=[];g[b].forEach(function(a,b){a.options.isInternal||c.push(w(a.options.index,b))})}p(a[b]).forEach(function(a,k){(k=I(a.id)&&g.get(a.id)||g[b][c?c[k]:k])&&k.coll===b&&(k.update(a,!1),d&&(k.touched=!0));!k&&d&&g.collectionsWithInit[b]&&(g.collectionsWithInit[b][0].apply(g,[a].concat(g.collectionsWithInit[b][1]||
[]).concat([!1])).touched=!0)});d&&g[b].forEach(function(a){a.touched||a.options.isInternal?delete a.touched:v.push(a)})}});v.forEach(function(a){a.remove&&a.remove(!1)});y&&g.axes.forEach(function(a){a.update({},!1)});m&&g.series.forEach(function(a){a.update({},!1)});a.loading&&l(!0,g.options.loading,a.loading);y=n&&n.width;n=n&&n.height;C(n)&&(n=c.relativeLength(n,y||g.chartWidth));e||t(y)&&y!==g.chartWidth||t(n)&&n!==g.chartHeight?g.setSize(y,n,h):w(b,!0)&&g.redraw(h);f(g,"afterUpdate",{options:a,
redraw:b,animation:h})},setSubtitle:function(a,b){this.applyDescription("subtitle",a);this.layOutTitles(b)},setCaption:function(a,b){this.applyDescription("caption",a);this.layOutTitles(b)}});e.prototype.collectionsWithInit={xAxis:[e.prototype.addAxis,[!0]],yAxis:[e.prototype.addAxis,[!1]],colorAxis:[e.prototype.addColorAxis,[!1]],series:[e.prototype.addSeries]};H(F.prototype,{update:function(a,b,d,c){function g(){k.applyOptions(a);null===k.y&&l&&(k.graphic=l.destroy());x(a,!0)&&(l&&l.element&&a&&
a.marker&&void 0!==a.marker.symbol&&(k.graphic=l.destroy()),a&&a.dataLabels&&k.dataLabel&&(k.dataLabel=k.dataLabel.destroy()),k.connector&&(k.connector=k.connector.destroy()));n=k.index;f.updateParallelArrays(k,n);m.data[n]=x(m.data[n],!0)||x(a,!0)?k.options:w(a,m.data[n]);f.isDirty=f.isDirtyData=!0;!f.fixedBox&&f.hasCartesianSeries&&(h.isDirtyBox=!0);"point"===m.legendType&&(h.isDirtyLegend=!0);b&&h.redraw(d)}var k=this,f=k.series,l=k.graphic,n,h=f.chart,m=f.options;b=w(b,!0);!1===c?g():k.firePointEvent("update",
{options:a},g)},remove:function(a,b){this.series.removePoint(this.series.data.indexOf(this),a,b)}});H(y.prototype,{addPoint:function(a,b,d,c,l){var g=this.options,k=this.data,n=this.chart,h=this.xAxis;h=h&&h.hasNames&&h.names;var m=g.data,e=this.xData,r;b=w(b,!0);var B={series:this};this.pointClass.prototype.applyOptions.apply(B,[a]);var v=B.x;var p=e.length;if(this.requireSorting&&v<e[p-1])for(r=!0;p&&e[p-1]>v;)p--;this.updateParallelArrays(B,"splice",p,0,0);this.updateParallelArrays(B,p);h&&B.name&&
(h[v]=B.name);m.splice(p,0,a);r&&(this.data.splice(p,0,null),this.processData());"point"===g.legendType&&this.generatePoints();d&&(k[0]&&k[0].remove?k[0].remove(!1):(k.shift(),this.updateParallelArrays(B,"shift"),m.shift()));!1!==l&&f(this,"addPoint",{point:B});this.isDirtyData=this.isDirty=!0;b&&n.redraw(c)},removePoint:function(a,b,d){var g=this,c=g.data,k=c[a],f=g.points,l=g.chart,n=function(){f&&f.length===c.length&&f.splice(a,1);c.splice(a,1);g.options.data.splice(a,1);g.updateParallelArrays(k||
{series:g},"splice",a,1);k&&k.destroy();g.isDirty=!0;g.isDirtyData=!0;b&&l.redraw()};m(d,l);b=w(b,!0);k?k.firePointEvent("remove",null,n):n()},remove:function(a,b,d,c){function g(){k.destroy(c);k.remove=null;l.isDirtyLegend=l.isDirtyBox=!0;l.linkSeries();w(a,!0)&&l.redraw(b)}var k=this,l=k.chart;!1!==d?f(k,"remove",null,g):g()},update:function(a,b){a=c.cleanRecursively(a,this.userOptions);f(this,"update",{options:a});var g=this,d=g.chart,n=g.userOptions,h=g.initialType||g.type,m=a.type||n.type||d.options.chart.type,
e=!(this.hasDerivedData||a.dataGrouping||m&&m!==this.type||void 0!==a.pointStart||a.pointInterval||a.pointIntervalUnit||a.keys),p=r[h].prototype,y,F=["group","markerGroup","dataLabelsGroup","transformGroup"],q=["eventOptions","navigatorSeries","baseSeries"],x=g.finishedAnimating&&{animation:!1},t={};e&&(q.push("data","isDirtyData","points","processedXData","processedYData","xIncrement","_hasPointMarkers","_hasPointLabels","mapMap","mapData","minY","maxY","minX","maxX"),!1!==a.visible&&q.push("area",
"graph"),g.parallelArrays.forEach(function(a){q.push(a+"Data")}),a.data&&this.setData(a.data,!1));a=l(n,x,{index:void 0===n.index?g.index:n.index,pointStart:w(n.pointStart,g.xData[0])},!e&&{data:g.options.data},a);e&&a.data&&(a.data=g.options.data);q=F.concat(q);q.forEach(function(a){q[a]=g[a];delete g[a]});g.remove(!1,null,!1,!0);for(y in p)g[y]=void 0;r[m||h]?H(g,r[m||h].prototype):c.error(17,!0,d,{missingModuleFor:m||h});q.forEach(function(a){g[a]=q[a]});g.init(d,a);if(e&&this.points){var C=g.options;
!1===C.visible?(t.graphic=1,t.dataLabel=1):g._hasPointLabels||(m=C.marker,p=C.dataLabels,m&&(!1===m.enabled||"symbol"in m)&&(t.graphic=1),p&&!1===p.enabled&&(t.dataLabel=1));this.points.forEach(function(a){a&&a.series&&(a.resolveColor(),Object.keys(t).length&&a.destroyElements(t),!1===C.showInLegend&&a.legendItem&&d.legend.destroyItem(a))},this)}a.zIndex!==n.zIndex&&F.forEach(function(b){g[b]&&g[b].attr({zIndex:a.zIndex})});g.initialType=h;d.linkSeries();f(this,"afterUpdate");w(b,!0)&&d.redraw(e?
void 0:!1)},setName:function(a){this.name=this.options.name=this.userOptions.name=a;this.chart.isDirtyLegend=!0}});H(a.prototype,{update:function(a,b){var g=this.chart,d=a&&a.events||{};a=l(this.userOptions,a);g.options[this.coll].indexOf&&(g.options[this.coll][g.options[this.coll].indexOf(this.userOptions)]=a);E(g.options[this.coll].events,function(a,b){"undefined"===typeof d[b]&&(d[b]=void 0)});this.destroy(!0);this.init(g,H(a,{events:d}));g.isDirtyBox=!0;w(b,!0)&&g.redraw()},remove:function(a){for(var b=
this.chart,d=this.coll,c=this.series,f=c.length;f--;)c[f]&&c[f].remove(!1);G(b.axes,this);G(b[d],this);z(b.options[d])?b.options[d].splice(this.options.index,1):delete b.options[d];b[d].forEach(function(a,b){a.options.index=a.userOptions.index=b});this.destroy();b.isDirtyBox=!0;w(a,!0)&&b.redraw()},setTitle:function(a,b){this.update({title:a},b)},setCategories:function(a,b){this.update({categories:a},b)}})});K(D,"parts/AreaSeries.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,e){var I=
e.objectEach,G=e.pick,H=c.color,z=c.Series;e=c.seriesType;e("area","line",{softThreshold:!1,threshold:0},{singleStacks:!1,getStackPoints:function(c){var e=[],t=[],z=this.xAxis,w=this.yAxis,m=w.stacks[this.stackKey],p={},q=this.index,h=w.series,a=h.length,b=G(w.options.reversedStacks,!0)?1:-1,d;c=c||this.points;if(this.options.stacking){for(d=0;d<c.length;d++)c[d].leftNull=c[d].rightNull=void 0,p[c[d].x]=c[d];I(m,function(a,b){null!==a.total&&t.push(b)});t.sort(function(a,b){return a-b});var f=h.map(function(a){return a.visible});
t.forEach(function(c,h){var l=0,r,n;if(p[c]&&!p[c].isNull)e.push(p[c]),[-1,1].forEach(function(g){var k=1===g?"rightNull":"leftNull",l=0,e=m[t[h+g]];if(e)for(d=q;0<=d&&d<a;)r=e.points[d],r||(d===q?p[c][k]=!0:f[d]&&(n=m[c].points[d])&&(l-=n[1]-n[0])),d+=b;p[c][1===g?"rightCliff":"leftCliff"]=l});else{for(d=q;0<=d&&d<a;){if(r=m[c].points[d]){l=r[1];break}d+=b}l=w.translate(l,0,1,0,1);e.push({isNull:!0,plotX:z.translate(c,0,0,0,1),x:c,plotY:l,yBottom:l})}})}return e},getGraphPath:function(c){var e=z.prototype.getGraphPath,
t=this.options,E=t.stacking,w=this.yAxis,m,p=[],q=[],h=this.index,a=w.stacks[this.stackKey],b=t.threshold,d=Math.round(w.getThreshold(t.threshold));t=G(t.connectNulls,"percent"===E);var f=function(f,l,g){var k=c[f];f=E&&a[k.x].points[h];var n=k[g+"Null"]||0;g=k[g+"Cliff"]||0;k=!0;if(g||n){var m=(n?f[0]:f[1])+g;var e=f[0]+g;k=!!n}else!E&&c[l]&&c[l].isNull&&(m=e=b);void 0!==m&&(q.push({plotX:F,plotY:null===m?d:w.getThreshold(m),isNull:k,isCliff:!0}),p.push({plotX:F,plotY:null===e?d:w.getThreshold(e),
doCurve:!1}))};c=c||this.points;E&&(c=this.getStackPoints(c));for(m=0;m<c.length;m++){E||(c[m].leftCliff=c[m].rightCliff=c[m].leftNull=c[m].rightNull=void 0);var l=c[m].isNull;var F=G(c[m].rectPlotX,c[m].plotX);var y=G(c[m].yBottom,d);if(!l||t)t||f(m,m-1,"left"),l&&!E&&t||(q.push(c[m]),p.push({x:m,plotX:F,plotY:y})),t||f(m,m+1,"right")}m=e.call(this,q,!0,!0);p.reversed=!0;l=e.call(this,p,!0,!0);l.length&&(l[0]="L");l=m.concat(l);e=e.call(this,q,!1,t);l.xMap=m.xMap;this.areaPath=l;return e},drawGraph:function(){this.areaPath=
[];z.prototype.drawGraph.apply(this);var c=this,e=this.areaPath,C=this.options,E=[["area","highcharts-area",this.color,C.fillColor]];this.zones.forEach(function(e,m){E.push(["zone-area-"+m,"highcharts-area highcharts-zone-area-"+m+" "+e.className,e.color||c.color,e.fillColor||C.fillColor])});E.forEach(function(w){var m=w[0],p=c[m],q=p?"animate":"attr",h={};p?(p.endX=c.preventGraphAnimation?null:e.xMap,p.animate({d:e})):(h.zIndex=0,p=c[m]=c.chart.renderer.path(e).addClass(w[1]).add(c.group),p.isArea=
!0);c.chart.styledMode||(h.fill=G(w[3],H(w[2]).setOpacity(G(C.fillOpacity,.75)).get()));p[q](h);p.startX=e.xMap;p.shiftUnit=C.step?2:1})},drawLegendSymbol:c.LegendSymbolMixin.drawRectangle});""});K(D,"parts/SplineSeries.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,e){var I=e.pick;c=c.seriesType;c("spline","line",{},{getPointSpline:function(c,e,z){var t=e.plotX,x=e.plotY,C=c[z-1];z=c[z+1];if(C&&!C.isNull&&!1!==C.doCurve&&!e.isCliff&&z&&!z.isNull&&!1!==z.doCurve&&!e.isCliff){c=C.plotY;
var E=z.plotX;z=z.plotY;var w=0;var m=(1.5*t+C.plotX)/2.5;var p=(1.5*x+c)/2.5;E=(1.5*t+E)/2.5;var q=(1.5*x+z)/2.5;E!==m&&(w=(q-p)*(E-t)/(E-m)+x-q);p+=w;q+=w;p>c&&p>x?(p=Math.max(c,x),q=2*x-p):p<c&&p<x&&(p=Math.min(c,x),q=2*x-p);q>z&&q>x?(q=Math.max(z,x),p=2*x-q):q<z&&q<x&&(q=Math.min(z,x),p=2*x-q);e.rightContX=E;e.rightContY=q}e=["C",I(C.rightContX,C.plotX),I(C.rightContY,C.plotY),I(m,t),I(p,x),t,x];C.rightContX=C.rightContY=null;return e}});""});K(D,"parts/AreaSplineSeries.js",[D["parts/Globals.js"]],
function(c){var e=c.seriesTypes.area.prototype,I=c.seriesType;I("areaspline","spline",c.defaultPlotOptions.area,{getStackPoints:e.getStackPoints,getGraphPath:e.getGraphPath,drawGraph:e.drawGraph,drawLegendSymbol:c.LegendSymbolMixin.drawRectangle});""});K(D,"parts/ColumnSeries.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,e){var I=e.defined,G=e.extend,H=e.isNumber,z=e.pick,t=c.animObject,x=c.color,C=c.merge,E=c.Series;e=c.seriesType;var w=c.svg;e("column","line",{borderRadius:0,crisp:!0,
groupPadding:.2,marker:null,pointPadding:.1,minPointLength:0,cropThreshold:50,pointRange:null,states:{hover:{halo:!1,brightness:.1},select:{color:"#cccccc",borderColor:"#000000"}},dataLabels:{align:null,verticalAlign:null,y:null},softThreshold:!1,startFromThreshold:!0,stickyTracking:!1,tooltip:{distance:6},threshold:0,borderColor:"#ffffff"},{cropShoulder:0,directTouch:!0,trackerGroups:["group","dataLabelsGroup"],negStacks:!0,init:function(){E.prototype.init.apply(this,arguments);var c=this,e=c.chart;
e.hasRendered&&e.series.forEach(function(m){m.type===c.type&&(m.isDirty=!0)})},getColumnMetrics:function(){var c=this,e=c.options,q=c.xAxis,h=c.yAxis,a=q.options.reversedStacks;a=q.reversed&&!a||!q.reversed&&a;var b,d={},f=0;!1===e.grouping?f=1:c.chart.series.forEach(function(a){var l=a.yAxis,g=a.options;if(a.type===c.type&&(a.visible||!c.chart.options.chart.ignoreHiddenSeries)&&h.len===l.len&&h.pos===l.pos){if(g.stacking){b=a.stackKey;void 0===d[b]&&(d[b]=f++);var k=d[b]}else!1!==g.grouping&&(k=
f++);a.columnIndex=k}});var l=Math.min(Math.abs(q.transA)*(q.ordinalSlope||e.pointRange||q.closestPointRange||q.tickInterval||1),q.len),F=l*e.groupPadding,y=(l-2*F)/(f||1);e=Math.min(e.maxPointWidth||q.len,z(e.pointWidth,y*(1-2*e.pointPadding)));c.columnMetrics={width:e,offset:(y-e)/2+(F+((c.columnIndex||0)+(a?1:0))*y-l/2)*(a?-1:1)};return c.columnMetrics},crispCol:function(c,e,q,h){var a=this.chart,b=this.borderWidth,d=-(b%2?.5:0);b=b%2?.5:1;a.inverted&&a.renderer.isVML&&(b+=1);this.options.crisp&&
(q=Math.round(c+q)+d,c=Math.round(c)+d,q-=c);h=Math.round(e+h)+b;d=.5>=Math.abs(e)&&.5<h;e=Math.round(e)+b;h-=e;d&&h&&(--e,h+=1);return{x:c,y:e,width:q,height:h}},translate:function(){var c=this,e=c.chart,q=c.options,h=c.dense=2>c.closestPointRange*c.xAxis.transA;h=c.borderWidth=z(q.borderWidth,h?0:1);var a=c.yAxis,b=q.threshold,d=c.translatedThreshold=a.getThreshold(b),f=z(q.minPointLength,5),l=c.getColumnMetrics(),F=l.width,y=c.barW=Math.max(F,1+2*h),r=c.pointXOffset=l.offset,n=c.dataMin,g=c.dataMax;
e.inverted&&(d-=.5);q.pointPadding&&(y=Math.ceil(y));E.prototype.translate.apply(c);c.points.forEach(function(k){var l=z(k.yBottom,d),h=999+Math.abs(l),m=F;h=Math.min(Math.max(-h,k.plotY),a.len+h);var u=k.plotX+r,p=y,q=Math.min(h,l),w=Math.max(h,l)-q;if(f&&Math.abs(w)<f){w=f;var x=!a.reversed&&!k.negative||a.reversed&&k.negative;k.y===b&&c.dataMax<=b&&a.min<b&&n!==g&&(x=!x);q=Math.abs(q-d)>f?l-f:d-(x?f:0)}I(k.options.pointWidth)&&(m=p=Math.ceil(k.options.pointWidth),u-=Math.round((m-F)/2));k.barX=
u;k.pointWidth=m;k.tooltipPos=e.inverted?[a.len+a.pos-e.plotLeft-h,c.xAxis.len-u-p/2,w]:[u+p/2,h+a.pos-e.plotTop,w];k.shapeType=c.pointClass.prototype.shapeType||"rect";k.shapeArgs=c.crispCol.apply(c,k.isNull?[u,d,p,0]:[u,q,p,w])})},getSymbol:c.noop,drawLegendSymbol:c.LegendSymbolMixin.drawRectangle,drawGraph:function(){this.group[this.dense?"addClass":"removeClass"]("highcharts-dense-data")},pointAttribs:function(c,e){var m=this.options,h=this.pointAttrToOptions||{};var a=h.stroke||"borderColor";
var b=h["stroke-width"]||"borderWidth",d=c&&c.color||this.color,f=c&&c[a]||m[a]||this.color||d,l=c&&c[b]||m[b]||this[b]||0;h=c&&c.options.dashStyle||m.dashStyle;var p=z(m.opacity,1);if(c&&this.zones.length){var y=c.getZone();d=c.options.color||y&&(y.color||c.nonZonedColor)||this.color;y&&(f=y.borderColor||f,h=y.dashStyle||h,l=y.borderWidth||l)}e&&(c=C(m.states[e],c.options.states&&c.options.states[e]||{}),e=c.brightness,d=c.color||void 0!==e&&x(d).brighten(c.brightness).get()||d,f=c[a]||f,l=c[b]||
l,h=c.dashStyle||h,p=z(c.opacity,p));a={fill:d,stroke:f,"stroke-width":l,opacity:p};h&&(a.dashstyle=h);return a},drawPoints:function(){var c=this,e=this.chart,q=c.options,h=e.renderer,a=q.animationLimit||250,b;c.points.forEach(function(d){var f=d.graphic,l=f&&e.pointCount<a?"animate":"attr";if(H(d.plotY)&&null!==d.y){b=d.shapeArgs;f&&d.hasNewShapeType()&&(f=f.destroy());if(f)f[l](C(b));else d.graphic=f=h[d.shapeType](b).add(d.group||c.group);if(q.borderRadius)f[l]({r:q.borderRadius});e.styledMode||
f[l](c.pointAttribs(d,d.selected&&"select")).shadow(!1!==d.allowShadow&&q.shadow,null,q.stacking&&!q.borderRadius);f.addClass(d.getClassName(),!0)}else f&&(d.graphic=f.destroy())})},animate:function(c){var e=this,m=this.yAxis,h=e.options,a=this.chart.inverted,b={},d=a?"translateX":"translateY";if(w)if(c)b.scaleY=.001,c=Math.min(m.pos+m.len,Math.max(m.pos,m.toPixels(h.threshold))),a?b.translateX=c-m.len:b.translateY=c,e.clipBox&&e.setClip(),e.group.attr(b);else{var f=e.group.attr(d);e.group.animate({scaleY:1},
G(t(e.options.animation),{step:function(a,c){b[d]=f+c.pos*(m.pos-f);e.group.attr(b)}}));e.animate=null}},remove:function(){var c=this,e=c.chart;e.hasRendered&&e.series.forEach(function(e){e.type===c.type&&(e.isDirty=!0)});E.prototype.remove.apply(c,arguments)}});""});K(D,"parts/BarSeries.js",[D["parts/Globals.js"]],function(c){c=c.seriesType;c("bar","column",null,{inverted:!0});""});K(D,"parts/ScatterSeries.js",[D["parts/Globals.js"]],function(c){var e=c.Series,I=c.seriesType;I("scatter","line",{lineWidth:0,
findNearestPointBy:"xy",jitter:{x:0,y:0},marker:{enabled:!0},tooltip:{headerFormat:'<span style="color:{point.color}">\u25cf</span> <span style="font-size: 10px"> {series.name}</span><br/>',pointFormat:"x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>"}},{sorted:!1,requireSorting:!1,noSharedTooltip:!0,trackerGroups:["group","markerGroup","dataLabelsGroup"],takeOrdinalPosition:!1,drawGraph:function(){this.options.lineWidth&&e.prototype.drawGraph.call(this)},applyJitter:function(){var c=this,e=this.options.jitter,
z=this.points.length;e&&this.points.forEach(function(t,x){["x","y"].forEach(function(C,E){var w="plot"+C.toUpperCase();if(e[C]&&!t.isNull){var m=c[C+"Axis"];var p=e[C]*m.transA;if(m&&!m.isLog){var q=Math.max(0,t[w]-p);m=Math.min(m.len,t[w]+p);E=1E4*Math.sin(x+E*z);t[w]=q+(m-q)*(E-Math.floor(E));"x"===C&&(t.clientX=t.plotX)}}})})}});c.addEvent(e,"afterTranslate",function(){this.applyJitter&&this.applyJitter()});""});K(D,"mixins/centered-series.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,
e){var I=e.isNumber,G=e.pick,H=c.deg2rad,z=c.relativeLength;c.CenteredSeriesMixin={getCenter:function(){var c=this.options,e=this.chart,C=2*(c.slicedOffset||0),E=e.plotWidth-2*C;e=e.plotHeight-2*C;var w=c.center;w=[G(w[0],"50%"),G(w[1],"50%"),c.size||"100%",c.innerSize||0];var m=Math.min(E,e),p;for(p=0;4>p;++p){var q=w[p];c=2>p||2===p&&/%$/.test(q);w[p]=z(q,[E,e,m,w[2]][p])+(c?C:0)}w[3]>w[2]&&(w[3]=w[2]);return w},getStartAndEndRadians:function(c,e){c=I(c)?c:0;e=I(e)&&e>c&&360>e-c?e:c+360;return{start:H*
(c+-90),end:H*(e+-90)}}}});K(D,"parts/PieSeries.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,e){var I=e.defined,G=e.isNumber,H=e.pick,z=e.setAnimation,t=c.addEvent;e=c.CenteredSeriesMixin;var x=e.getStartAndEndRadians,C=c.merge,E=c.noop,w=c.Point,m=c.Series,p=c.seriesType,q=c.fireEvent;p("pie","line",{center:[null,null],clip:!1,colorByPoint:!0,dataLabels:{allowOverlap:!0,connectorPadding:5,distance:30,enabled:!0,formatter:function(){return this.point.isNull?void 0:this.point.name},
softConnector:!0,x:0,connectorShape:"fixedOffset",crookDistance:"70%"},fillColor:void 0,ignoreHiddenPoint:!0,inactiveOtherPoints:!0,legendType:"point",marker:null,size:null,showInLegend:!1,slicedOffset:10,stickyTracking:!1,tooltip:{followPointer:!0},borderColor:"#ffffff",borderWidth:1,lineWidth:void 0,states:{hover:{brightness:.1}}},{isCartesian:!1,requireSorting:!1,directTouch:!0,noSharedTooltip:!0,trackerGroups:["group","dataLabelsGroup"],axisTypes:[],pointAttribs:c.seriesTypes.column.prototype.pointAttribs,
animate:function(c){var a=this,b=a.points,d=a.startAngleRad;c||(b.forEach(function(b){var c=b.graphic,f=b.shapeArgs;c&&(c.attr({r:b.startR||a.center[3]/2,start:d,end:d}),c.animate({r:f.r,start:f.start,end:f.end},a.options.animation))}),a.animate=null)},hasData:function(){return!!this.processedXData.length},updateTotals:function(){var c,a=0,b=this.points,d=b.length,f=this.options.ignoreHiddenPoint;for(c=0;c<d;c++){var l=b[c];a+=f&&!l.visible?0:l.isNull?0:l.y}this.total=a;for(c=0;c<d;c++)l=b[c],l.percentage=
0<a&&(l.visible||!f)?l.y/a*100:0,l.total=a},generatePoints:function(){m.prototype.generatePoints.call(this);this.updateTotals()},getX:function(c,a,b){var d=this.center,f=this.radii?this.radii[b.index]:d[2]/2;return d[0]+(a?-1:1)*Math.cos(Math.asin(Math.max(Math.min((c-d[1])/(f+b.labelDistance),1),-1)))*(f+b.labelDistance)+(0<b.labelDistance?(a?-1:1)*this.options.dataLabels.padding:0)},translate:function(e){this.generatePoints();var a=0,b=this.options,d=b.slicedOffset,f=d+(b.borderWidth||0),l=x(b.startAngle,
b.endAngle),h=this.startAngleRad=l.start;l=(this.endAngleRad=l.end)-h;var m=this.points,r=b.dataLabels.distance;b=b.ignoreHiddenPoint;var n,g=m.length;e||(this.center=e=this.getCenter());for(n=0;n<g;n++){var k=m[n];var v=h+a*l;if(!b||k.visible)a+=k.percentage/100;var B=h+a*l;k.shapeType="arc";k.shapeArgs={x:e[0],y:e[1],r:e[2]/2,innerR:e[3]/2,start:Math.round(1E3*v)/1E3,end:Math.round(1E3*B)/1E3};k.labelDistance=H(k.options.dataLabels&&k.options.dataLabels.distance,r);k.labelDistance=c.relativeLength(k.labelDistance,
k.shapeArgs.r);this.maxLabelDistance=Math.max(this.maxLabelDistance||0,k.labelDistance);B=(B+v)/2;B>1.5*Math.PI?B-=2*Math.PI:B<-Math.PI/2&&(B+=2*Math.PI);k.slicedTranslation={translateX:Math.round(Math.cos(B)*d),translateY:Math.round(Math.sin(B)*d)};var A=Math.cos(B)*e[2]/2;var u=Math.sin(B)*e[2]/2;k.tooltipPos=[e[0]+.7*A,e[1]+.7*u];k.half=B<-Math.PI/2||B>Math.PI/2?1:0;k.angle=B;v=Math.min(f,k.labelDistance/5);k.labelPosition={natural:{x:e[0]+A+Math.cos(B)*k.labelDistance,y:e[1]+u+Math.sin(B)*k.labelDistance},
"final":{},alignment:0>k.labelDistance?"center":k.half?"right":"left",connectorPosition:{breakAt:{x:e[0]+A+Math.cos(B)*v,y:e[1]+u+Math.sin(B)*v},touchingSliceAt:{x:e[0]+A,y:e[1]+u}}}}q(this,"afterTranslate")},drawEmpty:function(){var c=this.options;if(0===this.total){var a=this.center[0];var b=this.center[1];this.graph||(this.graph=this.chart.renderer.circle(a,b,0).addClass("highcharts-graph").add(this.group));this.graph.animate({"stroke-width":c.borderWidth,cx:a,cy:b,r:this.center[2]/2,fill:c.fillColor||
"none",stroke:c.color||"#cccccc"})}else this.graph&&(this.graph=this.graph.destroy())},redrawPoints:function(){var c=this,a=c.chart,b=a.renderer,d,f,l,e,m=c.options.shadow;this.drawEmpty();!m||c.shadowGroup||a.styledMode||(c.shadowGroup=b.g("shadow").attr({zIndex:-1}).add(c.group));c.points.forEach(function(h){var n={};f=h.graphic;if(!h.isNull&&f){e=h.shapeArgs;d=h.getTranslate();if(!a.styledMode){var g=h.shadowGroup;m&&!g&&(g=h.shadowGroup=b.g("shadow").add(c.shadowGroup));g&&g.attr(d);l=c.pointAttribs(h,
h.selected&&"select")}h.delayedRendering?(f.setRadialReference(c.center).attr(e).attr(d),a.styledMode||f.attr(l).attr({"stroke-linejoin":"round"}).shadow(m,g),h.delayedRendering=!1):(f.setRadialReference(c.center),a.styledMode||C(!0,n,l),C(!0,n,e,d),f.animate(n));f.attr({visibility:h.visible?"inherit":"hidden"});f.addClass(h.getClassName())}else f&&(h.graphic=f.destroy())})},drawPoints:function(){var c=this.chart.renderer;this.points.forEach(function(a){a.graphic||(a.graphic=c[a.shapeType](a.shapeArgs).add(a.series.group),
a.delayedRendering=!0)})},searchPoint:E,sortByAngle:function(c,a){c.sort(function(b,c){return void 0!==b.angle&&(c.angle-b.angle)*a})},drawLegendSymbol:c.LegendSymbolMixin.drawRectangle,getCenter:e.getCenter,getSymbol:E,drawGraph:null},{init:function(){w.prototype.init.apply(this,arguments);var c=this;c.name=H(c.name,"Slice");var a=function(a){c.slice("select"===a.type)};t(c,"select",a);t(c,"unselect",a);return c},isValid:function(){return G(this.y)&&0<=this.y},setVisible:function(c,a){var b=this,
d=b.series,f=d.chart,l=d.options.ignoreHiddenPoint;a=H(a,l);c!==b.visible&&(b.visible=b.options.visible=c=void 0===c?!b.visible:c,d.options.data[d.data.indexOf(b)]=b.options,["graphic","dataLabel","connector","shadowGroup"].forEach(function(a){if(b[a])b[a][c?"show":"hide"](!0)}),b.legendItem&&f.legend.colorizeItem(b,c),c||"hover"!==b.state||b.setState(""),l&&(d.isDirty=!0),a&&f.redraw())},slice:function(c,a,b){var d=this.series;z(b,d.chart);H(a,!0);this.sliced=this.options.sliced=I(c)?c:!this.sliced;
d.options.data[d.data.indexOf(this)]=this.options;this.graphic.animate(this.getTranslate());this.shadowGroup&&this.shadowGroup.animate(this.getTranslate())},getTranslate:function(){return this.sliced?this.slicedTranslation:{translateX:0,translateY:0}},haloPath:function(c){var a=this.shapeArgs;return this.sliced||!this.visible?[]:this.series.chart.renderer.symbols.arc(a.x,a.y,a.r+c,a.r+c,{innerR:a.r-1,start:a.start,end:a.end})},connectorShapes:{fixedOffset:function(c,a,b){var d=a.breakAt;a=a.touchingSliceAt;
return["M",c.x,c.y].concat(b.softConnector?["C",c.x+("left"===c.alignment?-5:5),c.y,2*d.x-a.x,2*d.y-a.y,d.x,d.y]:["L",d.x,d.y]).concat(["L",a.x,a.y])},straight:function(c,a){a=a.touchingSliceAt;return["M",c.x,c.y,"L",a.x,a.y]},crookedLine:function(e,a,b){a=a.touchingSliceAt;var d=this.series,f=d.center[0],l=d.chart.plotWidth,h=d.chart.plotLeft;d=e.alignment;var m=this.shapeArgs.r;b=c.relativeLength(b.crookDistance,1);b="left"===d?f+m+(l+h-f-m)*(1-b):h+(f-m)*b;f=["L",b,e.y];if("left"===d?b>e.x||b<
a.x:b<e.x||b>a.x)f=[];return["M",e.x,e.y].concat(f).concat(["L",a.x,a.y])}},getConnectorPath:function(){var c=this.labelPosition,a=this.series.options.dataLabels,b=a.connectorShape,d=this.connectorShapes;d[b]&&(b=d[b]);return b.call(this,{x:c.final.x,y:c.final.y,alignment:c.alignment},c.connectorPosition,a)}});""});K(D,"parts/DataLabels.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,e){var I=e.arrayMax,G=e.defined,H=e.extend,z=e.isArray,t=e.objectEach,x=e.pick,C=e.splat,E=c.format,
w=c.merge;e=c.noop;var m=c.relativeLength,p=c.Series,q=c.seriesTypes,h=c.stableSort;c.distribute=function(a,b,d){function f(a,b){return a.target-b.target}var l,e=!0,m=a,r=[];var n=0;var g=m.reducedLen||b;for(l=a.length;l--;)n+=a[l].size;if(n>g){h(a,function(a,b){return(b.rank||0)-(a.rank||0)});for(n=l=0;n<=g;)n+=a[l].size,l++;r=a.splice(l-1,a.length)}h(a,f);for(a=a.map(function(a){return{size:a.size,targets:[a.target],align:x(a.align,.5)}});e;){for(l=a.length;l--;)e=a[l],n=(Math.min.apply(0,e.targets)+
Math.max.apply(0,e.targets))/2,e.pos=Math.min(Math.max(0,n-e.size*e.align),b-e.size);l=a.length;for(e=!1;l--;)0<l&&a[l-1].pos+a[l-1].size>a[l].pos&&(a[l-1].size+=a[l].size,a[l-1].targets=a[l-1].targets.concat(a[l].targets),a[l-1].align=.5,a[l-1].pos+a[l-1].size>b&&(a[l-1].pos=b-a[l-1].size),a.splice(l,1),e=!0)}m.push.apply(m,r);l=0;a.some(function(a){var g=0;if(a.targets.some(function(){m[l].pos=a.pos+g;if(Math.abs(m[l].pos-m[l].target)>d)return m.slice(0,l+1).forEach(function(a){delete a.pos}),m.reducedLen=
(m.reducedLen||b)-.1*b,m.reducedLen>.1*b&&c.distribute(m,b,d),!0;g+=m[l].size;l++}))return!0});h(m,f)};p.prototype.drawDataLabels=function(){function a(a,b){var c=b.filter;return c?(b=c.operator,a=a[c.property],c=c.value,">"===b&&a>c||"<"===b&&a<c||">="===b&&a>=c||"<="===b&&a<=c||"=="===b&&a==c||"==="===b&&a===c?!0:!1):!0}function b(a,b){var c=[],g;if(z(a)&&!z(b))c=a.map(function(a){return w(a,b)});else if(z(b)&&!z(a))c=b.map(function(b){return w(a,b)});else if(z(a)||z(b))for(g=Math.max(a.length,
b.length);g--;)c[g]=w(a[g],b[g]);else c=w(a,b);return c}var d=this,f=d.chart,l=d.options,e=l.dataLabels,h=d.points,m,n=d.hasRendered||0,g=c.animObject(l.animation).duration,k=Math.min(g,200),v=!f.renderer.forExport&&x(e.defer,0<k),B=f.renderer;e=b(b(f.options.plotOptions&&f.options.plotOptions.series&&f.options.plotOptions.series.dataLabels,f.options.plotOptions&&f.options.plotOptions[d.type]&&f.options.plotOptions[d.type].dataLabels),e);c.fireEvent(this,"drawDataLabels");if(z(e)||e.enabled||d._hasPointLabels){var A=
d.plotGroup("dataLabelsGroup","data-labels",v&&!n?"hidden":"inherit",e.zIndex||6);v&&(A.attr({opacity:+n}),n||setTimeout(function(){var a=d.dataLabelsGroup;a&&(d.visible&&A.show(!0),a[l.animation?"animate":"attr"]({opacity:1},{duration:k}))},g-k));h.forEach(function(c){m=C(b(e,c.dlOptions||c.options&&c.options.dataLabels));m.forEach(function(b,g){var k=b.enabled&&(!c.isNull||c.dataLabelOnNull)&&a(c,b),n=c.dataLabels?c.dataLabels[g]:c.dataLabel,e=c.connectors?c.connectors[g]:c.connector,h=x(b.distance,
c.labelDistance),m=!n;if(k){var r=c.getLabelConfig();var v=x(b[c.formatPrefix+"Format"],b.format);r=G(v)?E(v,r,f.time):(b[c.formatPrefix+"Formatter"]||b.formatter).call(r,b);v=b.style;var u=b.rotation;f.styledMode||(v.color=x(b.color,v.color,d.color,"#000000"),"contrast"===v.color&&(c.contrastColor=B.getContrast(c.color||d.color),v.color=!G(h)&&b.inside||0>h||l.stacking?c.contrastColor:"#000000"),l.cursor&&(v.cursor=l.cursor));var p={r:b.borderRadius||0,rotation:u,padding:b.padding,zIndex:1};f.styledMode||
(p.fill=b.backgroundColor,p.stroke=b.borderColor,p["stroke-width"]=b.borderWidth);t(p,function(a,b){void 0===a&&delete p[b]})}!n||k&&G(r)?k&&G(r)&&(n?p.text=r:(c.dataLabels=c.dataLabels||[],n=c.dataLabels[g]=u?B.text(r,0,-9999).addClass("highcharts-data-label"):B.label(r,0,-9999,b.shape,null,null,b.useHTML,null,"data-label"),g||(c.dataLabel=n),n.addClass(" highcharts-data-label-color-"+c.colorIndex+" "+(b.className||"")+(b.useHTML?" highcharts-tracker":""))),n.options=b,n.attr(p),f.styledMode||n.css(v).shadow(b.shadow),
n.added||n.add(A),b.textPath&&!b.useHTML&&n.setTextPath(c.getDataLabelPath&&c.getDataLabelPath(n)||c.graphic,b.textPath),d.alignDataLabel(c,n,b,null,m)):(c.dataLabel=c.dataLabel&&c.dataLabel.destroy(),c.dataLabels&&(1===c.dataLabels.length?delete c.dataLabels:delete c.dataLabels[g]),g||delete c.dataLabel,e&&(c.connector=c.connector.destroy(),c.connectors&&(1===c.connectors.length?delete c.connectors:delete c.connectors[g])))})})}c.fireEvent(this,"afterDrawDataLabels")};p.prototype.alignDataLabel=
function(a,b,c,f,l){var d=this.chart,e=this.isCartesian&&d.inverted,h=x(a.dlBox&&a.dlBox.centerX,a.plotX,-9999),n=x(a.plotY,-9999),g=b.getBBox(),k=c.rotation,m=c.align,B=this.visible&&(a.series.forceDL||d.isInsidePlot(h,Math.round(n),e)||f&&d.isInsidePlot(h,e?f.x+1:f.y+f.height-1,e)),A="justify"===x(c.overflow,"justify");if(B){var u=d.renderer.fontMetrics(d.styledMode?void 0:c.style.fontSize,b).b;f=H({x:e?this.yAxis.len-n:h,y:Math.round(e?this.xAxis.len-h:n),width:0,height:0},f);H(c,{width:g.width,
height:g.height});k?(A=!1,h=d.renderer.rotCorr(u,k),h={x:f.x+c.x+f.width/2+h.x,y:f.y+c.y+{top:0,middle:.5,bottom:1}[c.verticalAlign]*f.height},b[l?"attr":"animate"](h).attr({align:m}),n=(k+720)%360,n=180<n&&360>n,"left"===m?h.y-=n?g.height:0:"center"===m?(h.x-=g.width/2,h.y-=g.height/2):"right"===m&&(h.x-=g.width,h.y-=n?0:g.height),b.placed=!0,b.alignAttr=h):(b.align(c,null,f),h=b.alignAttr);A&&0<=f.height?this.justifyDataLabel(b,c,h,g,f,l):x(c.crop,!0)&&(B=d.isInsidePlot(h.x,h.y)&&d.isInsidePlot(h.x+
g.width,h.y+g.height));if(c.shape&&!k)b[l?"attr":"animate"]({anchorX:e?d.plotWidth-a.plotY:a.plotX,anchorY:e?d.plotHeight-a.plotX:a.plotY})}B||(b.hide(!0),b.placed=!1)};p.prototype.justifyDataLabel=function(a,b,c,f,l,e){var d=this.chart,h=b.align,n=b.verticalAlign,g=a.box?0:a.padding||0;var k=c.x+g;if(0>k){"right"===h?(b.align="left",b.inside=!0):b.x=-k;var m=!0}k=c.x+f.width-g;k>d.plotWidth&&("left"===h?(b.align="right",b.inside=!0):b.x=d.plotWidth-k,m=!0);k=c.y+g;0>k&&("bottom"===n?(b.verticalAlign=
"top",b.inside=!0):b.y=-k,m=!0);k=c.y+f.height-g;k>d.plotHeight&&("top"===n?(b.verticalAlign="bottom",b.inside=!0):b.y=d.plotHeight-k,m=!0);m&&(a.placed=!e,a.align(b,null,l));return m};q.pie&&(q.pie.prototype.dataLabelPositioners={radialDistributionY:function(a){return a.top+a.distributeBox.pos},radialDistributionX:function(a,b,c,f){return a.getX(c<b.top+2||c>b.bottom-2?f:c,b.half,b)},justify:function(a,b,c){return c[0]+(a.half?-1:1)*(b+a.labelDistance)},alignToPlotEdges:function(a,b,c,f){a=a.getBBox().width;
return b?a+f:c-a-f},alignToConnectors:function(a,b,c,f){var d=0,e;a.forEach(function(a){e=a.dataLabel.getBBox().width;e>d&&(d=e)});return b?d+f:c-d-f}},q.pie.prototype.drawDataLabels=function(){var a=this,b=a.data,d,f=a.chart,l=a.options.dataLabels,e=l.connectorPadding,h,m=f.plotWidth,n=f.plotHeight,g=f.plotLeft,k=Math.round(f.chartWidth/3),v,B=a.center,A=B[2]/2,u=B[1],q,t,C,z,E=[[],[]],H,D,O,K,S=[0,0,0,0],ca=a.dataLabelPositioners,X;a.visible&&(l.enabled||a._hasPointLabels)&&(b.forEach(function(a){a.dataLabel&&
a.visible&&a.dataLabel.shortened&&(a.dataLabel.attr({width:"auto"}).css({width:"auto",textOverflow:"clip"}),a.dataLabel.shortened=!1)}),p.prototype.drawDataLabels.apply(a),b.forEach(function(a){a.dataLabel&&(a.visible?(E[a.half].push(a),a.dataLabel._pos=null,!G(l.style.width)&&!G(a.options.dataLabels&&a.options.dataLabels.style&&a.options.dataLabels.style.width)&&a.dataLabel.getBBox().width>k&&(a.dataLabel.css({width:.7*k}),a.dataLabel.shortened=!0)):(a.dataLabel=a.dataLabel.destroy(),a.dataLabels&&
1===a.dataLabels.length&&delete a.dataLabels))}),E.forEach(function(b,k){var h=b.length,r=[],v;if(h){a.sortByAngle(b,k-.5);if(0<a.maxLabelDistance){var p=Math.max(0,u-A-a.maxLabelDistance);var y=Math.min(u+A+a.maxLabelDistance,f.plotHeight);b.forEach(function(a){0<a.labelDistance&&a.dataLabel&&(a.top=Math.max(0,u-A-a.labelDistance),a.bottom=Math.min(u+A+a.labelDistance,f.plotHeight),v=a.dataLabel.getBBox().height||21,a.distributeBox={target:a.labelPosition.natural.y-a.top+v/2,size:v,rank:a.y},r.push(a.distributeBox))});
p=y+v-p;c.distribute(r,p,p/5)}for(K=0;K<h;K++){d=b[K];C=d.labelPosition;q=d.dataLabel;O=!1===d.visible?"hidden":"inherit";D=p=C.natural.y;r&&G(d.distributeBox)&&(void 0===d.distributeBox.pos?O="hidden":(z=d.distributeBox.size,D=ca.radialDistributionY(d)));delete d.positionIndex;if(l.justify)H=ca.justify(d,A,B);else switch(l.alignTo){case "connectors":H=ca.alignToConnectors(b,k,m,g);break;case "plotEdges":H=ca.alignToPlotEdges(q,k,m,g);break;default:H=ca.radialDistributionX(a,d,D,p)}q._attr={visibility:O,
align:C.alignment};q._pos={x:H+l.x+({left:e,right:-e}[C.alignment]||0),y:D+l.y-10};C.final.x=H;C.final.y=D;x(l.crop,!0)&&(t=q.getBBox().width,p=null,H-t<e&&1===k?(p=Math.round(t-H+e),S[3]=Math.max(p,S[3])):H+t>m-e&&0===k&&(p=Math.round(H+t-m+e),S[1]=Math.max(p,S[1])),0>D-z/2?S[0]=Math.max(Math.round(-D+z/2),S[0]):D+z/2>n&&(S[2]=Math.max(Math.round(D+z/2-n),S[2])),q.sideOverflow=p)}}}),0===I(S)||this.verifyDataLabelOverflow(S))&&(this.placeDataLabels(),this.points.forEach(function(b){X=w(l,b.options.dataLabels);
if(h=x(X.connectorWidth,1)){var c;v=b.connector;if((q=b.dataLabel)&&q._pos&&b.visible&&0<b.labelDistance){O=q._attr.visibility;if(c=!v)b.connector=v=f.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-"+b.colorIndex+(b.className?" "+b.className:"")).add(a.dataLabelsGroup),f.styledMode||v.attr({"stroke-width":h,stroke:X.connectorColor||b.color||"#666666"});v[c?"attr":"animate"]({d:b.getConnectorPath()});v.attr("visibility",O)}else v&&(b.connector=v.destroy())}}))},q.pie.prototype.placeDataLabels=
function(){this.points.forEach(function(a){var b=a.dataLabel,c;b&&a.visible&&((c=b._pos)?(b.sideOverflow&&(b._attr.width=Math.max(b.getBBox().width-b.sideOverflow,0),b.css({width:b._attr.width+"px",textOverflow:(this.options.dataLabels.style||{}).textOverflow||"ellipsis"}),b.shortened=!0),b.attr(b._attr),b[b.moved?"animate":"attr"](c),b.moved=!0):b&&b.attr({y:-9999}));delete a.distributeBox},this)},q.pie.prototype.alignDataLabel=e,q.pie.prototype.verifyDataLabelOverflow=function(a){var b=this.center,
c=this.options,f=c.center,l=c.minSize||80,e=null!==c.size;if(!e){if(null!==f[0])var h=Math.max(b[2]-Math.max(a[1],a[3]),l);else h=Math.max(b[2]-a[1]-a[3],l),b[0]+=(a[3]-a[1])/2;null!==f[1]?h=Math.max(Math.min(h,b[2]-Math.max(a[0],a[2])),l):(h=Math.max(Math.min(h,b[2]-a[0]-a[2]),l),b[1]+=(a[0]-a[2])/2);h<b[2]?(b[2]=h,b[3]=Math.min(m(c.innerSize||0,h),h),this.translate(b),this.drawDataLabels&&this.drawDataLabels()):e=!0}return e});q.column&&(q.column.prototype.alignDataLabel=function(a,b,c,f,l){var d=
this.chart.inverted,e=a.series,h=a.dlBox||a.shapeArgs,n=x(a.below,a.plotY>x(this.translatedThreshold,e.yAxis.len)),g=x(c.inside,!!this.options.stacking);h&&(f=w(h),0>f.y&&(f.height+=f.y,f.y=0),h=f.y+f.height-e.yAxis.len,0<h&&(f.height-=h),d&&(f={x:e.yAxis.len-f.y-f.height,y:e.xAxis.len-f.x-f.width,width:f.height,height:f.width}),g||(d?(f.x+=n?0:f.width,f.width=0):(f.y+=n?f.height:0,f.height=0)));c.align=x(c.align,!d||g?"center":n?"right":"left");c.verticalAlign=x(c.verticalAlign,d||g?"middle":n?"top":
"bottom");p.prototype.alignDataLabel.call(this,a,b,c,f,l);c.inside&&a.contrastColor&&b.css({color:a.contrastColor})})});K(D,"modules/overlapping-datalabels.src.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,e){var D=e.isArray,G=e.objectEach,H=e.pick;e=c.Chart;var z=c.addEvent,t=c.fireEvent;z(e,"render",function(){var c=[];(this.labelCollectors||[]).forEach(function(e){c=c.concat(e())});(this.yAxis||[]).forEach(function(e){e.options.stackLabels&&!e.options.stackLabels.allowOverlap&&
G(e.stacks,function(e){G(e,function(e){c.push(e.label)})})});(this.series||[]).forEach(function(e){var x=e.options.dataLabels;e.visible&&(!1!==x.enabled||e._hasPointLabels)&&e.points.forEach(function(e){e.visible&&(D(e.dataLabels)?e.dataLabels:e.dataLabel?[e.dataLabel]:[]).forEach(function(m){var p=m.options;m.labelrank=H(p.labelrank,e.labelrank,e.shapeArgs&&e.shapeArgs.height);p.allowOverlap||c.push(m)})})});this.hideOverlappingLabels(c)});e.prototype.hideOverlappingLabels=function(c){var e=this,
x=c.length,w=e.renderer,m,p,q;var h=function(a){var b=a.box?0:a.padding||0;var c=0;if(a&&(!a.alignAttr||a.placed)){var d=a.attr("x");var e=a.attr("y");d="number"===typeof d&&"number"===typeof e?{x:d,y:e}:a.alignAttr;e=a.parentGroup;a.width||(c=a.getBBox(),a.width=c.width,a.height=c.height,c=w.fontMetrics(null,a.element).h);return{x:d.x+(e.translateX||0)+b,y:d.y+(e.translateY||0)+b-c,width:a.width-2*b,height:a.height-2*b}}};for(p=0;p<x;p++)if(m=c[p])m.oldOpacity=m.opacity,m.newOpacity=1,m.absoluteBox=
h(m);c.sort(function(a,b){return(b.labelrank||0)-(a.labelrank||0)});for(p=0;p<x;p++){var a=(h=c[p])&&h.absoluteBox;for(m=p+1;m<x;++m){var b=(q=c[m])&&q.absoluteBox;!a||!b||h===q||0===h.newOpacity||0===q.newOpacity||b.x>a.x+a.width||b.x+b.width<a.x||b.y>a.y+a.height||b.y+b.height<a.y||((h.labelrank<q.labelrank?h:q).newOpacity=0)}}c.forEach(function(a){var b;if(a){var c=a.newOpacity;a.oldOpacity!==c&&(a.alignAttr&&a.placed?(c?a.show(!0):b=function(){a.hide(!0);a.placed=!1},a.alignAttr.opacity=c,a[a.isOld?
"animate":"attr"](a.alignAttr,null,b),t(e,"afterHideOverlappingLabels")):a.attr({opacity:c}));a.isOld=!0}})}});K(D,"parts/Interaction.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,e){var D=e.defined,G=e.extend,H=e.isArray,z=e.isObject,t=e.objectEach,x=e.pick,C=c.addEvent;e=c.Chart;var E=c.createElement,w=c.css,m=c.defaultOptions,p=c.defaultPlotOptions,q=c.fireEvent,h=c.hasTouch,a=c.Legend,b=c.merge,d=c.Point,f=c.Series,l=c.seriesTypes,F=c.svg;var y=c.TrackerMixin={drawTrackerPoint:function(){var a=
this,b=a.chart,c=b.pointer,d=function(a){var b=c.getPointFromEvent(a);void 0!==b&&(c.isDirectTouch=!0,b.onMouseOver(a))},f;a.points.forEach(function(a){f=H(a.dataLabels)?a.dataLabels:a.dataLabel?[a.dataLabel]:[];a.graphic&&(a.graphic.element.point=a);f.forEach(function(b){b.div?b.div.point=a:b.element.point=a})});a._hasTracking||(a.trackerGroups.forEach(function(g){if(a[g]){a[g].addClass("highcharts-tracker").on("mouseover",d).on("mouseout",function(a){c.onTrackerMouseOut(a)});if(h)a[g].on("touchstart",
d);!b.styledMode&&a.options.cursor&&a[g].css(w).css({cursor:a.options.cursor})}}),a._hasTracking=!0);q(this,"afterDrawTracker")},drawTrackerGraph:function(){var a=this,b=a.options,c=b.trackByArea,d=[].concat(c?a.areaPath:a.graphPath),f=d.length,l=a.chart,e=l.pointer,m=l.renderer,p=l.options.tooltip.snap,y=a.tracker,w,x=function(){if(l.hoverSeries!==a)a.onMouseOver()},t="rgba(192,192,192,"+(F?.0001:.002)+")";if(f&&!c)for(w=f+1;w--;)"M"===d[w]&&d.splice(w+1,0,d[w+1]-p,d[w+2],"L"),(w&&"M"===d[w]||w===
f)&&d.splice(w,0,"L",d[w-2]+p,d[w-1]);y?y.attr({d:d}):a.graph&&(a.tracker=m.path(d).attr({visibility:a.visible?"visible":"hidden",zIndex:2}).addClass(c?"highcharts-tracker-area":"highcharts-tracker-line").add(a.group),l.styledMode||a.tracker.attr({"stroke-linejoin":"round",stroke:t,fill:c?t:"none","stroke-width":a.graph.strokeWidth()+(c?0:2*p)}),[a.tracker,a.markerGroup].forEach(function(a){a.addClass("highcharts-tracker").on("mouseover",x).on("mouseout",function(a){e.onTrackerMouseOut(a)});b.cursor&&
!l.styledMode&&a.css({cursor:b.cursor});if(h)a.on("touchstart",x)}));q(this,"afterDrawTracker")}};l.column&&(l.column.prototype.drawTracker=y.drawTrackerPoint);l.pie&&(l.pie.prototype.drawTracker=y.drawTrackerPoint);l.scatter&&(l.scatter.prototype.drawTracker=y.drawTrackerPoint);G(a.prototype,{setItemEvents:function(a,c,g){var k=this,f=k.chart.renderer.boxWrapper,l=a instanceof d,e="highcharts-legend-"+(l?"point":"series")+"-active",n=k.chart.styledMode;(g?c:a.legendGroup).on("mouseover",function(){a.visible&&
k.allItems.forEach(function(b){a!==b&&b.setState("inactive",!l)});a.setState("hover");a.visible&&f.addClass(e);n||c.css(k.options.itemHoverStyle)}).on("mouseout",function(){k.chart.styledMode||c.css(b(a.visible?k.itemStyle:k.itemHiddenStyle));k.allItems.forEach(function(b){a!==b&&b.setState("",!l)});f.removeClass(e);a.setState()}).on("click",function(b){var c=function(){a.setVisible&&a.setVisible();k.allItems.forEach(function(b){a!==b&&b.setState(a.visible?"inactive":"",!l)})};f.removeClass(e);b=
{browserEvent:b};a.firePointEvent?a.firePointEvent("legendItemClick",b,c):q(a,"legendItemClick",b,c)})},createCheckboxForItem:function(a){a.checkbox=E("input",{type:"checkbox",className:"highcharts-legend-checkbox",checked:a.selected,defaultChecked:a.selected},this.options.itemCheckboxStyle,this.chart.container);C(a.checkbox,"click",function(b){q(a.series||a,"checkboxClick",{checked:b.target.checked,item:a},function(){a.select()})})}});G(e.prototype,{showResetZoom:function(){function a(){b.zoomOut()}
var b=this,c=m.lang,d=b.options.chart.resetZoomButton,f=d.theme,l=f.states,e="chart"===d.relativeTo||"spaceBox"===d.relativeTo?null:"plotBox";q(this,"beforeShowResetZoom",null,function(){b.resetZoomButton=b.renderer.button(c.resetZoom,null,null,a,f,l&&l.hover).attr({align:d.position.align,title:c.resetZoomTitle}).addClass("highcharts-reset-zoom").add().align(d.position,!1,e)});q(this,"afterShowResetZoom")},zoomOut:function(){q(this,"selection",{resetSelection:!0},this.zoom)},zoom:function(a){var b=
this,c,d=b.pointer,f=!1,l=b.inverted?d.mouseDownX:d.mouseDownY;!a||a.resetSelection?(b.axes.forEach(function(a){c=a.zoom()}),d.initiated=!1):a.xAxis.concat(a.yAxis).forEach(function(a){var g=a.axis,k=b.inverted?g.left:g.top,e=b.inverted?k+g.width:k+g.height,n=g.isXAxis,h=!1;if(!n&&l>=k&&l<=e||n||!D(l))h=!0;d[n?"zoomX":"zoomY"]&&h&&(c=g.zoom(a.min,a.max),g.displayBtn&&(f=!0))});var e=b.resetZoomButton;f&&!e?b.showResetZoom():!f&&z(e)&&(b.resetZoomButton=e.destroy());c&&b.redraw(x(b.options.chart.animation,
a&&a.animation,100>b.pointCount))},pan:function(a,b){var c=this,d=c.hoverPoints,f;q(this,"pan",{originalEvent:a},function(){d&&d.forEach(function(a){a.setState()});("xy"===b?[1,0]:[1]).forEach(function(b){b=c[b?"xAxis":"yAxis"][0];var g=b.horiz,d=a[g?"chartX":"chartY"];g=g?"mouseDownX":"mouseDownY";var k=c[g],l=(b.pointRange||0)/2,e=b.reversed&&!c.inverted||!b.reversed&&c.inverted?-1:1,n=b.getExtremes(),h=b.toValue(k-d,!0)+l*e;e=b.toValue(k+b.len-d,!0)-l*e;var m=e<h;k=m?e:h;h=m?h:e;e=Math.min(n.dataMin,
l?n.min:b.toValue(b.toPixels(n.min)-b.minPixelPadding));l=Math.max(n.dataMax,l?n.max:b.toValue(b.toPixels(n.max)+b.minPixelPadding));m=e-k;0<m&&(h+=m,k=e);m=h-l;0<m&&(h=l,k-=m);b.series.length&&k!==n.min&&h!==n.max&&(b.setExtremes(k,h,!1,!1,{trigger:"pan"}),f=!0);c[g]=d});f&&c.redraw(!1);w(c.container,{cursor:"move"})})}});G(d.prototype,{select:function(a,b){var c=this,d=c.series,f=d.chart;this.selectedStaging=a=x(a,!c.selected);c.firePointEvent(a?"select":"unselect",{accumulate:b},function(){c.selected=
c.options.selected=a;d.options.data[d.data.indexOf(c)]=c.options;c.setState(a&&"select");b||f.getSelectedPoints().forEach(function(a){var b=a.series;a.selected&&a!==c&&(a.selected=a.options.selected=!1,b.options.data[b.data.indexOf(a)]=a.options,a.setState(f.hoverPoints&&b.options.inactiveOtherPoints?"inactive":""),a.firePointEvent("unselect"))})});delete this.selectedStaging},onMouseOver:function(a){var b=this.series.chart,c=b.pointer;a=a?c.normalize(a):c.getChartCoordinatesFromPoint(this,b.inverted);
c.runPointActions(a,this)},onMouseOut:function(){var a=this.series.chart;this.firePointEvent("mouseOut");this.series.options.inactiveOtherPoints||(a.hoverPoints||[]).forEach(function(a){a.setState()});a.hoverPoints=a.hoverPoint=null},importEvents:function(){if(!this.hasImportedEvents){var a=this,d=b(a.series.options.point,a.options).events;a.events=d;t(d,function(b,d){c.isFunction(b)&&C(a,d,b)});this.hasImportedEvents=!0}},setState:function(a,b){var c=this.series,d=this.state,f=c.options.states[a||
"normal"]||{},l=p[c.type].marker&&c.options.marker,e=l&&!1===l.enabled,n=l&&l.states&&l.states[a||"normal"]||{},h=!1===n.enabled,m=c.stateMarkerGraphic,r=this.marker||{},y=c.chart,w=c.halo,F,t=l&&c.markerAttribs;a=a||"";if(!(a===this.state&&!b||this.selected&&"select"!==a||!1===f.enabled||a&&(h||e&&!1===n.enabled)||a&&r.states&&r.states[a]&&!1===r.states[a].enabled)){this.state=a;t&&(F=c.markerAttribs(this,a));if(this.graphic){d&&this.graphic.removeClass("highcharts-point-"+d);a&&this.graphic.addClass("highcharts-point-"+
a);if(!y.styledMode){var z=c.pointAttribs(this,a);var C=x(y.options.chart.animation,f.animation);c.options.inactiveOtherPoints&&((this.dataLabels||[]).forEach(function(a){a&&a.animate({opacity:z.opacity},C)}),this.connector&&this.connector.animate({opacity:z.opacity},C));this.graphic.animate(z,C)}F&&this.graphic.animate(F,x(y.options.chart.animation,n.animation,l.animation));m&&m.hide()}else{if(a&&n){d=r.symbol||c.symbol;m&&m.currentSymbol!==d&&(m=m.destroy());if(F)if(m)m[b?"animate":"attr"]({x:F.x,
y:F.y});else d&&(c.stateMarkerGraphic=m=y.renderer.symbol(d,F.x,F.y,F.width,F.height).add(c.markerGroup),m.currentSymbol=d);!y.styledMode&&m&&m.attr(c.pointAttribs(this,a))}m&&(m[a&&this.isInside?"show":"hide"](),m.element.point=this)}a=f.halo;f=(m=this.graphic||m)&&m.visibility||"inherit";a&&a.size&&m&&"hidden"!==f?(w||(c.halo=w=y.renderer.path().add(m.parentGroup)),w.show()[b?"animate":"attr"]({d:this.haloPath(a.size)}),w.attr({"class":"highcharts-halo highcharts-color-"+x(this.colorIndex,c.colorIndex)+
(this.className?" "+this.className:""),visibility:f,zIndex:-1}),w.point=this,y.styledMode||w.attr(G({fill:this.color||c.color,"fill-opacity":a.opacity},a.attributes))):w&&w.point&&w.point.haloPath&&w.animate({d:w.point.haloPath(0)},null,w.hide);q(this,"afterSetState")}},haloPath:function(a){return this.series.chart.renderer.symbols.circle(Math.floor(this.plotX)-a,this.plotY-a,2*a,2*a)}});G(f.prototype,{onMouseOver:function(){var a=this.chart,b=a.hoverSeries;if(b&&b!==this)b.onMouseOut();this.options.events.mouseOver&&
q(this,"mouseOver");this.setState("hover");a.hoverSeries=this},onMouseOut:function(){var a=this.options,b=this.chart,c=b.tooltip,d=b.hoverPoint;b.hoverSeries=null;if(d)d.onMouseOut();this&&a.events.mouseOut&&q(this,"mouseOut");!c||this.stickyTracking||c.shared&&!this.noSharedTooltip||c.hide();b.series.forEach(function(a){a.setState("",!0)})},setState:function(a,b){var c=this,d=c.options,f=c.graph,l=d.inactiveOtherPoints,e=d.states,n=d.lineWidth,h=d.opacity,m=x(e[a||"normal"]&&e[a||"normal"].animation,
c.chart.options.chart.animation);d=0;a=a||"";if(c.state!==a&&([c.group,c.markerGroup,c.dataLabelsGroup].forEach(function(b){b&&(c.state&&b.removeClass("highcharts-series-"+c.state),a&&b.addClass("highcharts-series-"+a))}),c.state=a,!c.chart.styledMode)){if(e[a]&&!1===e[a].enabled)return;a&&(n=e[a].lineWidth||n+(e[a].lineWidthPlus||0),h=x(e[a].opacity,h));if(f&&!f.dashstyle)for(e={"stroke-width":n},f.animate(e,m);c["zone-graph-"+d];)c["zone-graph-"+d].attr(e),d+=1;l||[c.group,c.markerGroup,c.dataLabelsGroup,
c.labelBySeries].forEach(function(a){a&&a.animate({opacity:h},m)})}b&&l&&c.points&&c.setAllPointsToState(a)},setAllPointsToState:function(a){this.points.forEach(function(b){b.setState&&b.setState(a)})},setVisible:function(a,b){var c=this,d=c.chart,f=c.legendItem,l=d.options.chart.ignoreHiddenSeries,e=c.visible;var n=(c.visible=a=c.options.visible=c.userOptions.visible=void 0===a?!e:a)?"show":"hide";["group","dataLabelsGroup","markerGroup","tracker","tt"].forEach(function(a){if(c[a])c[a][n]()});if(d.hoverSeries===
c||(d.hoverPoint&&d.hoverPoint.series)===c)c.onMouseOut();f&&d.legend.colorizeItem(c,a);c.isDirty=!0;c.options.stacking&&d.series.forEach(function(a){a.options.stacking&&a.visible&&(a.isDirty=!0)});c.linkedSeries.forEach(function(b){b.setVisible(a,!1)});l&&(d.isDirtyBox=!0);q(c,n);!1!==b&&d.redraw()},show:function(){this.setVisible(!0)},hide:function(){this.setVisible(!1)},select:function(a){this.selected=a=this.options.selected=void 0===a?!this.selected:a;this.checkbox&&(this.checkbox.checked=a);
q(this,a?"select":"unselect")},drawTracker:y.drawTrackerGraph})});K(D,"parts/Responsive.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,e){var D=e.isArray,G=e.isObject,H=e.objectEach,z=e.pick,t=e.splat;e=c.Chart;e.prototype.setResponsive=function(e,t){var x=this.options.responsive,w=[],m=this.currentResponsive;!t&&x&&x.rules&&x.rules.forEach(function(e){void 0===e._id&&(e._id=c.uniqueKey());this.matchResponsiveRule(e,w)},this);t=c.merge.apply(0,w.map(function(e){return c.find(x.rules,
function(c){return c._id===e}).chartOptions}));t.isResponsiveOptions=!0;w=w.toString()||void 0;w!==(m&&m.ruleIds)&&(m&&this.update(m.undoOptions,e,!0),w?(m=this.currentOptions(t),m.isResponsiveOptions=!0,this.currentResponsive={ruleIds:w,mergedOptions:t,undoOptions:m},this.update(t,e,!0)):this.currentResponsive=void 0)};e.prototype.matchResponsiveRule=function(c,e){var t=c.condition;(t.callback||function(){return this.chartWidth<=z(t.maxWidth,Number.MAX_VALUE)&&this.chartHeight<=z(t.maxHeight,Number.MAX_VALUE)&&
this.chartWidth>=z(t.minWidth,0)&&this.chartHeight>=z(t.minHeight,0)}).call(this)&&e.push(c._id)};e.prototype.currentOptions=function(c){function e(c,p,q,h){var a;H(c,function(b,c){if(!h&&-1<x.collectionsWithUpdate.indexOf(c))for(b=t(b),q[c]=[],a=0;a<b.length;a++)p[c][a]&&(q[c][a]={},e(b[a],p[c][a],q[c][a],h+1));else G(b)?(q[c]=D(b)?[]:{},e(b,p[c]||{},q[c],h+1)):q[c]=void 0===p[c]?null:p[c]})}var x=this,w={};e(c,this.options,w,0);return w}});K(D,"masters/highcharts.src.js",[D["parts/Globals.js"],
D["parts/Utilities.js"]],function(c,e){var D=e.extend;D(c,{arrayMax:e.arrayMax,arrayMin:e.arrayMin,attr:e.attr,defined:e.defined,erase:e.erase,extend:e.extend,isArray:e.isArray,isClass:e.isClass,isDOMElement:e.isDOMElement,isNumber:e.isNumber,isObject:e.isObject,isString:e.isString,objectEach:e.objectEach,pick:e.pick,pInt:e.pInt,setAnimation:e.setAnimation,splat:e.splat,syncTimeout:e.syncTimeout});return c});K(D,"parts/Scrollbar.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,e){function D(a,
b,c){this.init(a,b,c)}var G=e.defined,H=e.destroyObjectProperties,z=e.pick,t=c.addEvent;e=c.Axis;var x=c.correctFloat,C=c.defaultOptions,E=c.fireEvent,w=c.hasTouch,m=c.merge,p=c.removeEvent,q,h={height:c.isTouchDevice?20:14,barBorderRadius:0,buttonBorderRadius:0,liveRedraw:void 0,margin:10,minWidth:6,step:.2,zIndex:3,barBackgroundColor:"#cccccc",barBorderWidth:1,barBorderColor:"#cccccc",buttonArrowColor:"#333333",buttonBackgroundColor:"#e6e6e6",buttonBorderColor:"#cccccc",buttonBorderWidth:1,rifleColor:"#333333",
trackBackgroundColor:"#f2f2f2",trackBorderColor:"#f2f2f2",trackBorderWidth:1};C.scrollbar=m(!0,h,C.scrollbar);c.swapXY=q=function(a,b){var c=a.length;if(b)for(b=0;b<c;b+=3){var f=a[b+1];a[b+1]=a[b+2];a[b+2]=f}return a};D.prototype={init:function(a,b,c){this.scrollbarButtons=[];this.renderer=a;this.userOptions=b;this.options=m(h,b);this.chart=c;this.size=z(this.options.size,this.options.height);b.enabled&&(this.render(),this.initEvents(),this.addEvents())},render:function(){var a=this.renderer,b=this.options,
c=this.size,f=this.chart.styledMode,l;this.group=l=a.g("scrollbar").attr({zIndex:b.zIndex,translateY:-99999}).add();this.track=a.rect().addClass("highcharts-scrollbar-track").attr({x:0,r:b.trackBorderRadius||0,height:c,width:c}).add(l);f||this.track.attr({fill:b.trackBackgroundColor,stroke:b.trackBorderColor,"stroke-width":b.trackBorderWidth});this.trackBorderWidth=this.track.strokeWidth();this.track.attr({y:-this.trackBorderWidth%2/2});this.scrollbarGroup=a.g().add(l);this.scrollbar=a.rect().addClass("highcharts-scrollbar-thumb").attr({height:c,
width:c,r:b.barBorderRadius||0}).add(this.scrollbarGroup);this.scrollbarRifles=a.path(q(["M",-3,c/4,"L",-3,2*c/3,"M",0,c/4,"L",0,2*c/3,"M",3,c/4,"L",3,2*c/3],b.vertical)).addClass("highcharts-scrollbar-rifles").add(this.scrollbarGroup);f||(this.scrollbar.attr({fill:b.barBackgroundColor,stroke:b.barBorderColor,"stroke-width":b.barBorderWidth}),this.scrollbarRifles.attr({stroke:b.rifleColor,"stroke-width":1}));this.scrollbarStrokeWidth=this.scrollbar.strokeWidth();this.scrollbarGroup.translate(-this.scrollbarStrokeWidth%
2/2,-this.scrollbarStrokeWidth%2/2);this.drawScrollbarButton(0);this.drawScrollbarButton(1)},position:function(a,b,c,f){var d=this.options.vertical,e=0,h=this.rendered?"animate":"attr";this.x=a;this.y=b+this.trackBorderWidth;this.width=c;this.xOffset=this.height=f;this.yOffset=e;d?(this.width=this.yOffset=c=e=this.size,this.xOffset=b=0,this.barWidth=f-2*c,this.x=a+=this.options.margin):(this.height=this.xOffset=f=b=this.size,this.barWidth=c-2*f,this.y+=this.options.margin);this.group[h]({translateX:a,
translateY:this.y});this.track[h]({width:c,height:f});this.scrollbarButtons[1][h]({translateX:d?0:c-b,translateY:d?f-e:0})},drawScrollbarButton:function(a){var b=this.renderer,c=this.scrollbarButtons,f=this.options,l=this.size;var e=b.g().add(this.group);c.push(e);e=b.rect().addClass("highcharts-scrollbar-button").add(e);this.chart.styledMode||e.attr({stroke:f.buttonBorderColor,"stroke-width":f.buttonBorderWidth,fill:f.buttonBackgroundColor});e.attr(e.crisp({x:-.5,y:-.5,width:l+1,height:l+1,r:f.buttonBorderRadius},
e.strokeWidth()));e=b.path(q(["M",l/2+(a?-1:1),l/2-3,"L",l/2+(a?-1:1),l/2+3,"L",l/2+(a?2:-2),l/2],f.vertical)).addClass("highcharts-scrollbar-arrow").add(c[a]);this.chart.styledMode||e.attr({fill:f.buttonArrowColor})},setRange:function(a,b){var c=this.options,f=c.vertical,l=c.minWidth,e=this.barWidth,h,m=!this.rendered||this.hasDragged||this.chart.navigator&&this.chart.navigator.hasDragged?"attr":"animate";if(G(e)){a=Math.max(a,0);var n=Math.ceil(e*a);this.calculatedWidth=h=x(e*Math.min(b,1)-n);h<
l&&(n=(e-l+h)*a,h=l);l=Math.floor(n+this.xOffset+this.yOffset);e=h/2-.5;this.from=a;this.to=b;f?(this.scrollbarGroup[m]({translateY:l}),this.scrollbar[m]({height:h}),this.scrollbarRifles[m]({translateY:e}),this.scrollbarTop=l,this.scrollbarLeft=0):(this.scrollbarGroup[m]({translateX:l}),this.scrollbar[m]({width:h}),this.scrollbarRifles[m]({translateX:e}),this.scrollbarLeft=l,this.scrollbarTop=0);12>=h?this.scrollbarRifles.hide():this.scrollbarRifles.show(!0);!1===c.showFull&&(0>=a&&1<=b?this.group.hide():
this.group.show());this.rendered=!0}},initEvents:function(){var a=this;a.mouseMoveHandler=function(b){var c=a.chart.pointer.normalize(b),f=a.options.vertical?"chartY":"chartX",e=a.initPositions;!a.grabbedCenter||b.touches&&0===b.touches[0][f]||(c=a.cursorToScrollbarPosition(c)[f],f=a[f],f=c-f,a.hasDragged=!0,a.updatePosition(e[0]+f,e[1]+f),a.hasDragged&&E(a,"changed",{from:a.from,to:a.to,trigger:"scrollbar",DOMType:b.type,DOMEvent:b}))};a.mouseUpHandler=function(b){a.hasDragged&&E(a,"changed",{from:a.from,
to:a.to,trigger:"scrollbar",DOMType:b.type,DOMEvent:b});a.grabbedCenter=a.hasDragged=a.chartX=a.chartY=null};a.mouseDownHandler=function(b){b=a.chart.pointer.normalize(b);b=a.cursorToScrollbarPosition(b);a.chartX=b.chartX;a.chartY=b.chartY;a.initPositions=[a.from,a.to];a.grabbedCenter=!0};a.buttonToMinClick=function(b){var c=x(a.to-a.from)*a.options.step;a.updatePosition(x(a.from-c),x(a.to-c));E(a,"changed",{from:a.from,to:a.to,trigger:"scrollbar",DOMEvent:b})};a.buttonToMaxClick=function(b){var c=
(a.to-a.from)*a.options.step;a.updatePosition(a.from+c,a.to+c);E(a,"changed",{from:a.from,to:a.to,trigger:"scrollbar",DOMEvent:b})};a.trackClick=function(b){var c=a.chart.pointer.normalize(b),f=a.to-a.from,e=a.y+a.scrollbarTop,h=a.x+a.scrollbarLeft;a.options.vertical&&c.chartY>e||!a.options.vertical&&c.chartX>h?a.updatePosition(a.from+f,a.to+f):a.updatePosition(a.from-f,a.to-f);E(a,"changed",{from:a.from,to:a.to,trigger:"scrollbar",DOMEvent:b})}},cursorToScrollbarPosition:function(a){var b=this.options;
b=b.minWidth>this.calculatedWidth?b.minWidth:0;return{chartX:(a.chartX-this.x-this.xOffset)/(this.barWidth-b),chartY:(a.chartY-this.y-this.yOffset)/(this.barWidth-b)}},updatePosition:function(a,b){1<b&&(a=x(1-x(b-a)),b=1);0>a&&(b=x(b-a),a=0);this.from=a;this.to=b},update:function(a){this.destroy();this.init(this.chart.renderer,m(!0,this.options,a),this.chart)},addEvents:function(){var a=this.options.inverted?[1,0]:[0,1],b=this.scrollbarButtons,c=this.scrollbarGroup.element,f=this.mouseDownHandler,
e=this.mouseMoveHandler,h=this.mouseUpHandler;a=[[b[a[0]].element,"click",this.buttonToMinClick],[b[a[1]].element,"click",this.buttonToMaxClick],[this.track.element,"click",this.trackClick],[c,"mousedown",f],[c.ownerDocument,"mousemove",e],[c.ownerDocument,"mouseup",h]];w&&a.push([c,"touchstart",f],[c.ownerDocument,"touchmove",e],[c.ownerDocument,"touchend",h]);a.forEach(function(a){t.apply(null,a)});this._events=a},removeEvents:function(){this._events.forEach(function(a){p.apply(null,a)});this._events.length=
0},destroy:function(){var a=this.chart.scroller;this.removeEvents();["track","scrollbarRifles","scrollbar","scrollbarGroup","group"].forEach(function(a){this[a]&&this[a].destroy&&(this[a]=this[a].destroy())},this);a&&this===a.scrollbar&&(a.scrollbar=null,H(a.scrollbarButtons))}};c.Scrollbar||(t(e,"afterInit",function(){var a=this;a.options&&a.options.scrollbar&&a.options.scrollbar.enabled&&(a.options.scrollbar.vertical=!a.horiz,a.options.startOnTick=a.options.endOnTick=!1,a.scrollbar=new D(a.chart.renderer,
a.options.scrollbar,a.chart),t(a.scrollbar,"changed",function(b){var d=Math.min(z(a.options.min,a.min),a.min,a.dataMin),f=Math.max(z(a.options.max,a.max),a.max,a.dataMax)-d;if(a.horiz&&!a.reversed||!a.horiz&&a.reversed){var e=d+f*this.to;d+=f*this.from}else e=d+f*(1-this.from),d+=f*(1-this.to);z(this.options.liveRedraw,c.svg&&!c.isTouchDevice&&!this.chart.isBoosting)||"mouseup"===b.DOMType||!G(b.DOMType)?a.setExtremes(d,e,!0,"mousemove"!==b.DOMType,b):this.setRange(this.from,this.to)}))}),t(e,"afterRender",
function(){var a=Math.min(z(this.options.min,this.min),this.min,z(this.dataMin,this.min)),b=Math.max(z(this.options.max,this.max),this.max,z(this.dataMax,this.max)),c=this.scrollbar,f=this.axisTitleMargin+(this.titleOffset||0),e=this.chart.scrollbarsOffsets,h=this.options.margin||0;c&&(this.horiz?(this.opposite||(e[1]+=f),c.position(this.left,this.top+this.height+2+e[1]-(this.opposite?h:0),this.width,this.height),this.opposite||(e[1]+=h),f=1):(this.opposite&&(e[0]+=f),c.position(this.left+this.width+
2+e[0]-(this.opposite?0:h),this.top,this.width,this.height),this.opposite&&(e[0]+=h),f=0),e[f]+=c.size+c.options.margin,isNaN(a)||isNaN(b)||!G(this.min)||!G(this.max)||this.min===this.max?c.setRange(0,1):(e=(this.min-a)/(b-a),a=(this.max-a)/(b-a),this.horiz&&!this.reversed||!this.horiz&&this.reversed?c.setRange(e,a):c.setRange(1-a,1-e)))}),t(e,"afterGetOffset",function(){var a=this.horiz?2:1,b=this.scrollbar;b&&(this.chart.scrollbarsOffsets=[0,0],this.chart.axisOffset[a]+=b.size+b.options.margin)}),
c.Scrollbar=D)});K(D,"parts/Navigator.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,e){function D(a){this.init(a)}var G=e.defined,H=e.destroyObjectProperties,z=e.erase,t=e.extend,x=e.isArray,C=e.isNumber,E=e.pick,w=e.splat,m=c.addEvent,p=c.Axis;e=c.Chart;var q=c.color,h=c.defaultOptions,a=c.hasTouch,b=c.isTouchDevice,d=c.merge,f=c.removeEvent,l=c.Scrollbar,F=c.Series,y=function(a){for(var b=[],c=1;c<arguments.length;c++)b[c-1]=arguments[c];b=[].filter.call(b,C);if(b.length)return Math[a].apply(0,
b)};var r=void 0===c.seriesTypes.areaspline?"line":"areaspline";t(h,{navigator:{height:40,margin:25,maskInside:!0,handles:{width:7,height:15,symbols:["navigator-handle","navigator-handle"],enabled:!0,lineWidth:1,backgroundColor:"#f2f2f2",borderColor:"#999999"},maskFill:q("#6685c2").setOpacity(.3).get(),outlineColor:"#cccccc",outlineWidth:1,series:{type:r,fillOpacity:.05,lineWidth:1,compare:null,dataGrouping:{approximation:"average",enabled:!0,groupPixelWidth:2,smoothed:!0,units:[["millisecond",[1,
2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1,2,3,4]],["week",[1,2,3]],["month",[1,3,6]],["year",null]]},dataLabels:{enabled:!1,zIndex:2},id:"highcharts-navigator-series",className:"highcharts-navigator-series",lineColor:null,marker:{enabled:!1},threshold:null},xAxis:{overscroll:0,className:"highcharts-navigator-xaxis",tickLength:0,lineWidth:0,gridLineColor:"#e6e6e6",gridLineWidth:1,tickPixelInterval:200,labels:{align:"left",
style:{color:"#999999"},x:3,y:-4},crosshair:!1},yAxis:{className:"highcharts-navigator-yaxis",gridLineWidth:0,startOnTick:!1,endOnTick:!1,minPadding:.1,maxPadding:.1,labels:{enabled:!1},crosshair:!1,title:{text:null},tickLength:0,tickWidth:0}}});c.Renderer.prototype.symbols["navigator-handle"]=function(a,b,c,d,f){a=f.width/2;b=Math.round(a/3)+.5;f=f.height;return["M",-a-1,.5,"L",a,.5,"L",a,f+.5,"L",-a-1,f+.5,"L",-a-1,.5,"M",-b,4,"L",-b,f-3,"M",b-1,4,"L",b-1,f-3]};p.prototype.toFixedRange=function(a,
b,d,f){var g=this.chart&&this.chart.fixedRange,k=(this.pointRange||0)/2;a=E(d,this.translate(a,!0,!this.horiz));b=E(f,this.translate(b,!0,!this.horiz));var e=g&&(b-a)/g;G(d)||(a=c.correctFloat(a+k));G(f)||(b=c.correctFloat(b-k));.7<e&&1.3>e&&(f?a=b-g:b=a+g);C(a)&&C(b)||(a=b=void 0);return{min:a,max:b}};D.prototype={drawHandle:function(a,b,c,d){var g=this.navigatorOptions.handles.height;this.handles[b][d](c?{translateX:Math.round(this.left+this.height/2),translateY:Math.round(this.top+parseInt(a,10)+
.5-g)}:{translateX:Math.round(this.left+parseInt(a,10)),translateY:Math.round(this.top+this.height/2-g/2-1)})},drawOutline:function(a,b,c,d){var g=this.navigatorOptions.maskInside,k=this.outline.strokeWidth(),f=k/2;k=k%2/2;var e=this.outlineHeight,l=this.scrollbarHeight,n=this.size,h=this.left-l,m=this.top;c?(h-=f,c=m+b+k,b=m+a+k,a=["M",h+e,m-l-k,"L",h+e,c,"L",h,c,"L",h,b,"L",h+e,b,"L",h+e,m+n+l].concat(g?["M",h+e,c-f,"L",h+e,b+f]:[])):(a+=h+l-k,b+=h+l-k,m+=f,a=["M",h,m,"L",a,m,"L",a,m+e,"L",b,m+
e,"L",b,m,"L",h+n+2*l,m].concat(g?["M",a-f,m,"L",b+f,m]:[]));this.outline[d]({d:a})},drawMasks:function(a,b,c,d){var g=this.left,k=this.top,f=this.height;if(c){var e=[g,g,g];var l=[k,k+a,k+b];var n=[f,f,f];var h=[a,b-a,this.size-b]}else e=[g,g+a,g+b],l=[k,k,k],n=[a,b-a,this.size-b],h=[f,f,f];this.shades.forEach(function(a,b){a[d]({x:e[b],y:l[b],width:n[b],height:h[b]})})},renderElements:function(){var a=this,b=a.navigatorOptions,c=b.maskInside,d=a.chart,f=d.renderer,e,l={cursor:d.inverted?"ns-resize":
"ew-resize"};a.navigatorGroup=e=f.g("navigator").attr({zIndex:8,visibility:"hidden"}).add();[!c,c,!c].forEach(function(c,g){a.shades[g]=f.rect().addClass("highcharts-navigator-mask"+(1===g?"-inside":"-outside")).add(e);d.styledMode||a.shades[g].attr({fill:c?b.maskFill:"rgba(0,0,0,0)"}).css(1===g&&l)});a.outline=f.path().addClass("highcharts-navigator-outline").add(e);d.styledMode||a.outline.attr({"stroke-width":b.outlineWidth,stroke:b.outlineColor});b.handles.enabled&&[0,1].forEach(function(c){b.handles.inverted=
d.inverted;a.handles[c]=f.symbol(b.handles.symbols[c],-b.handles.width/2-1,0,b.handles.width,b.handles.height,b.handles);a.handles[c].attr({zIndex:7-c}).addClass("highcharts-navigator-handle highcharts-navigator-handle-"+["left","right"][c]).add(e);if(!d.styledMode){var g=b.handles;a.handles[c].attr({fill:g.backgroundColor,stroke:g.borderColor,"stroke-width":g.lineWidth}).css(l)}})},update:function(a){(this.series||[]).forEach(function(a){a.baseSeries&&delete a.baseSeries.navigatorSeries});this.destroy();
d(!0,this.chart.options.navigator,this.options,a);this.init(this.chart)},render:function(a,b,d,f){var g=this.chart,k=this.scrollbarHeight,e,l=this.xAxis,h=l.pointRange||0;var n=l.fake?g.xAxis[0]:l;var m=this.navigatorEnabled,v,r=this.rendered;var p=g.inverted;var q=g.xAxis[0].minRange,y=g.xAxis[0].options.maxRange;if(!this.hasDragged||G(d)){a=c.correctFloat(a-h/2);b=c.correctFloat(b+h/2);if(!C(a)||!C(b))if(r)d=0,f=E(l.width,n.width);else return;this.left=E(l.left,g.plotLeft+k+(p?g.plotWidth:0));this.size=
v=e=E(l.len,(p?g.plotHeight:g.plotWidth)-2*k);g=p?k:e+2*k;d=E(d,l.toPixels(a,!0));f=E(f,l.toPixels(b,!0));C(d)&&Infinity!==Math.abs(d)||(d=0,f=g);a=l.toValue(d,!0);b=l.toValue(f,!0);var w=Math.abs(c.correctFloat(b-a));c.correctFloat(w-h)<q?this.grabbedLeft?d=l.toPixels(b-q-h,!0):this.grabbedRight&&(f=l.toPixels(a+q+h,!0)):G(y)&&c.correctFloat(w-h)>y&&(this.grabbedLeft?d=l.toPixels(b-y-h,!0):this.grabbedRight&&(f=l.toPixels(a+y+h,!0)));this.zoomedMax=Math.min(Math.max(d,f,0),v);this.zoomedMin=Math.min(Math.max(this.fixedWidth?
this.zoomedMax-this.fixedWidth:Math.min(d,f),0),v);this.range=this.zoomedMax-this.zoomedMin;v=Math.round(this.zoomedMax);d=Math.round(this.zoomedMin);m&&(this.navigatorGroup.attr({visibility:"visible"}),r=r&&!this.hasDragged?"animate":"attr",this.drawMasks(d,v,p,r),this.drawOutline(d,v,p,r),this.navigatorOptions.handles.enabled&&(this.drawHandle(d,0,p,r),this.drawHandle(v,1,p,r)));this.scrollbar&&(p?(p=this.top-k,n=this.left-k+(m||!n.opposite?0:(n.titleOffset||0)+n.axisTitleMargin),k=e+2*k):(p=this.top+
(m?this.height:-k),n=this.left-k),this.scrollbar.position(n,p,g,k),this.scrollbar.setRange(this.zoomedMin/(e||1),this.zoomedMax/(e||1)));this.rendered=!0}},addMouseEvents:function(){var b=this,c=b.chart,d=c.container,f=[],e,l;b.mouseMoveHandler=e=function(a){b.onMouseMove(a)};b.mouseUpHandler=l=function(a){b.onMouseUp(a)};f=b.getPartsEvents("mousedown");f.push(m(c.renderTo,"mousemove",e),m(d.ownerDocument,"mouseup",l));a&&(f.push(m(c.renderTo,"touchmove",e),m(d.ownerDocument,"touchend",l)),f.concat(b.getPartsEvents("touchstart")));
b.eventsToUnbind=f;b.series&&b.series[0]&&f.push(m(b.series[0].xAxis,"foundExtremes",function(){c.navigator.modifyNavigatorAxisExtremes()}))},getPartsEvents:function(a){var b=this,c=[];["shades","handles"].forEach(function(d){b[d].forEach(function(g,k){c.push(m(g.element,a,function(a){b[d+"Mousedown"](a,k)}))})});return c},shadesMousedown:function(a,b){a=this.chart.pointer.normalize(a);var c=this.chart,d=this.xAxis,g=this.zoomedMin,f=this.left,e=this.size,l=this.range,h=a.chartX;c.inverted&&(h=a.chartY,
f=this.top);if(1===b)this.grabbedCenter=h,this.fixedWidth=l,this.dragOffset=h-g;else{a=h-f-l/2;if(0===b)a=Math.max(0,a);else if(2===b&&a+l>=e)if(a=e-l,this.reversedExtremes){a-=l;var n=this.getUnionExtremes().dataMin}else var m=this.getUnionExtremes().dataMax;a!==g&&(this.fixedWidth=l,b=d.toFixedRange(a,a+l,n,m),G(b.min)&&c.xAxis[0].setExtremes(Math.min(b.min,b.max),Math.max(b.min,b.max),!0,null,{trigger:"navigator"}))}},handlesMousedown:function(a,b){this.chart.pointer.normalize(a);a=this.chart;
var c=a.xAxis[0],d=this.reversedExtremes;0===b?(this.grabbedLeft=!0,this.otherHandlePos=this.zoomedMax,this.fixedExtreme=d?c.min:c.max):(this.grabbedRight=!0,this.otherHandlePos=this.zoomedMin,this.fixedExtreme=d?c.max:c.min);a.fixedRange=null},onMouseMove:function(a){var d=this,f=d.chart,e=d.left,l=d.navigatorSize,h=d.range,m=d.dragOffset,n=f.inverted;a.touches&&0===a.touches[0].pageX||(a=f.pointer.normalize(a),f=a.chartX,n&&(e=d.top,f=a.chartY),d.grabbedLeft?(d.hasDragged=!0,d.render(0,0,f-e,d.otherHandlePos)):
d.grabbedRight?(d.hasDragged=!0,d.render(0,0,d.otherHandlePos,f-e)):d.grabbedCenter&&(d.hasDragged=!0,f<m?f=m:f>l+m-h&&(f=l+m-h),d.render(0,0,f-m,f-m+h)),d.hasDragged&&d.scrollbar&&E(d.scrollbar.options.liveRedraw,c.svg&&!b&&!this.chart.isBoosting)&&(a.DOMType=a.type,setTimeout(function(){d.onMouseUp(a)},0)))},onMouseUp:function(a){var b=this.chart,c=this.xAxis,d=this.scrollbar,f=a.DOMEvent||a;if(this.hasDragged&&(!d||!d.hasDragged)||"scrollbar"===a.trigger){d=this.getUnionExtremes();if(this.zoomedMin===
this.otherHandlePos)var e=this.fixedExtreme;else if(this.zoomedMax===this.otherHandlePos)var l=this.fixedExtreme;this.zoomedMax===this.size&&(l=this.reversedExtremes?d.dataMin:d.dataMax);0===this.zoomedMin&&(e=this.reversedExtremes?d.dataMax:d.dataMin);c=c.toFixedRange(this.zoomedMin,this.zoomedMax,e,l);G(c.min)&&b.xAxis[0].setExtremes(Math.min(c.min,c.max),Math.max(c.min,c.max),!0,this.hasDragged?!1:null,{trigger:"navigator",triggerOp:"navigator-drag",DOMEvent:f})}"mousemove"!==a.DOMType&&"touchmove"!==
a.DOMType&&(this.grabbedLeft=this.grabbedRight=this.grabbedCenter=this.fixedWidth=this.fixedExtreme=this.otherHandlePos=this.hasDragged=this.dragOffset=null)},removeEvents:function(){this.eventsToUnbind&&(this.eventsToUnbind.forEach(function(a){a()}),this.eventsToUnbind=void 0);this.removeBaseSeriesEvents()},removeBaseSeriesEvents:function(){var a=this.baseSeries||[];this.navigatorEnabled&&a[0]&&(!1!==this.navigatorOptions.adaptToUpdatedData&&a.forEach(function(a){f(a,"updatedData",this.updatedDataHandler)},
this),a[0].xAxis&&f(a[0].xAxis,"foundExtremes",this.modifyBaseAxisExtremes))},init:function(a){var b=a.options,c=b.navigator,f=c.enabled,e=b.scrollbar,h=e.enabled;b=f?c.height:0;var n=h?e.height:0;this.handles=[];this.shades=[];this.chart=a;this.setBaseSeries();this.height=b;this.scrollbarHeight=n;this.scrollbarEnabled=h;this.navigatorEnabled=f;this.navigatorOptions=c;this.scrollbarOptions=e;this.outlineHeight=b+n;this.opposite=E(c.opposite,!(f||!a.inverted));var r=this;f=r.baseSeries;e=a.xAxis.length;
h=a.yAxis.length;var q=f&&f[0]&&f[0].xAxis||a.xAxis[0]||{options:{}};a.isDirtyBox=!0;r.navigatorEnabled?(r.xAxis=new p(a,d({breaks:q.options.breaks,ordinal:q.options.ordinal},c.xAxis,{id:"navigator-x-axis",yAxis:"navigator-y-axis",isX:!0,type:"datetime",index:e,isInternal:!0,offset:0,keepOrdinalPadding:!0,startOnTick:!1,endOnTick:!1,minPadding:0,maxPadding:0,zoomEnabled:!1},a.inverted?{offsets:[n,0,-n,0],width:b}:{offsets:[0,-n,0,n],height:b})),r.yAxis=new p(a,d(c.yAxis,{id:"navigator-y-axis",alignTicks:!1,
offset:0,index:h,isInternal:!0,zoomEnabled:!1},a.inverted?{width:b}:{height:b})),f||c.series.data?r.updateNavigatorSeries(!1):0===a.series.length&&(r.unbindRedraw=m(a,"beforeRedraw",function(){0<a.series.length&&!r.series&&(r.setBaseSeries(),r.unbindRedraw())})),r.reversedExtremes=a.inverted&&!r.xAxis.reversed||!a.inverted&&r.xAxis.reversed,r.renderElements(),r.addMouseEvents()):r.xAxis={translate:function(b,c){var d=a.xAxis[0],g=d.getExtremes(),f=d.len-2*n,k=y("min",d.options.min,g.dataMin);d=y("max",
d.options.max,g.dataMax)-k;return c?b*d/f+k:f*(b-k)/d},toPixels:function(a){return this.translate(a)},toValue:function(a){return this.translate(a,!0)},toFixedRange:p.prototype.toFixedRange,fake:!0};a.options.scrollbar.enabled&&(a.scrollbar=r.scrollbar=new l(a.renderer,d(a.options.scrollbar,{margin:r.navigatorEnabled?0:10,vertical:a.inverted}),a),m(r.scrollbar,"changed",function(b){var c=r.size,d=c*this.to;c*=this.from;r.hasDragged=r.scrollbar.hasDragged;r.render(0,0,c,d);(a.options.scrollbar.liveRedraw||
"mousemove"!==b.DOMType&&"touchmove"!==b.DOMType)&&setTimeout(function(){r.onMouseUp(b)})}));r.addBaseSeriesEvents();r.addChartEvents()},getUnionExtremes:function(a){var b=this.chart.xAxis[0],c=this.xAxis,d=c.options,f=b.options,e;a&&null===b.dataMin||(e={dataMin:E(d&&d.min,y("min",f.min,b.dataMin,c.dataMin,c.min)),dataMax:E(d&&d.max,y("max",f.max,b.dataMax,c.dataMax,c.max))});return e},setBaseSeries:function(a,b){var d=this.chart,g=this.baseSeries=[];a=a||d.options&&d.options.navigator.baseSeries||
(d.series.length?c.find(d.series,function(a){return!a.options.isInternal}).index:0);(d.series||[]).forEach(function(b,c){b.options.isInternal||!b.options.showInNavigator&&(c!==a&&b.options.id!==a||!1===b.options.showInNavigator)||g.push(b)});this.xAxis&&!this.xAxis.fake&&this.updateNavigatorSeries(!0,b)},updateNavigatorSeries:function(a,b){var c=this,g=c.chart,e=c.baseSeries,l,m,n=c.navigatorOptions.series,r,p={enableMouseTracking:!1,index:null,linkedTo:null,group:"nav",padXAxis:!1,xAxis:"navigator-x-axis",
yAxis:"navigator-y-axis",showInLegend:!1,stacking:!1,isInternal:!0,states:{inactive:{opacity:1}}},q=c.series=(c.series||[]).filter(function(a){var b=a.baseSeries;return 0>e.indexOf(b)?(b&&(f(b,"updatedData",c.updatedDataHandler),delete b.navigatorSeries),a.chart&&a.destroy(),!1):!0});e&&e.length&&e.forEach(function(a){var f=a.navigatorSeries,k=t({color:a.color,visible:a.visible},x(n)?h.navigator.series:n);f&&!1===c.navigatorOptions.adaptToUpdatedData||(p.name="Navigator "+e.length,l=a.options||{},
r=l.navigatorOptions||{},m=d(l,p,k,r),m.pointRange=E(k.pointRange,r.pointRange,h.plotOptions[m.type||"line"].pointRange),k=r.data||k.data,c.hasNavigatorData=c.hasNavigatorData||!!k,m.data=k||l.data&&l.data.slice(0),f&&f.options?f.update(m,b):(a.navigatorSeries=g.initSeries(m),a.navigatorSeries.baseSeries=a,q.push(a.navigatorSeries)))});if(n.data&&(!e||!e.length)||x(n))c.hasNavigatorData=!1,n=w(n),n.forEach(function(a,b){p.name="Navigator "+(q.length+1);m=d(h.navigator.series,{color:g.series[b]&&!g.series[b].options.isInternal&&
g.series[b].color||g.options.colors[b]||g.options.colors[0]},p,a);m.data=a.data;m.data&&(c.hasNavigatorData=!0,q.push(g.initSeries(m)))});a&&this.addBaseSeriesEvents()},addBaseSeriesEvents:function(){var a=this,b=a.baseSeries||[];b[0]&&b[0].xAxis&&m(b[0].xAxis,"foundExtremes",this.modifyBaseAxisExtremes);b.forEach(function(b){m(b,"show",function(){this.navigatorSeries&&this.navigatorSeries.setVisible(!0,!1)});m(b,"hide",function(){this.navigatorSeries&&this.navigatorSeries.setVisible(!1,!1)});!1!==
this.navigatorOptions.adaptToUpdatedData&&b.xAxis&&m(b,"updatedData",this.updatedDataHandler);m(b,"remove",function(){this.navigatorSeries&&(z(a.series,this.navigatorSeries),G(this.navigatorSeries.options)&&this.navigatorSeries.remove(!1),delete this.navigatorSeries)})},this)},getBaseSeriesMin:function(a){return this.baseSeries.reduce(function(a,b){return Math.min(a,b.xData?b.xData[0]:a)},a)},modifyNavigatorAxisExtremes:function(){var a=this.xAxis,b;"undefined"!==typeof a.getExtremes&&(!(b=this.getUnionExtremes(!0))||
b.dataMin===a.min&&b.dataMax===a.max||(a.min=b.dataMin,a.max=b.dataMax))},modifyBaseAxisExtremes:function(){var a=this.chart.navigator,b=this.getExtremes(),c=b.dataMin,d=b.dataMax;b=b.max-b.min;var f=a.stickToMin,e=a.stickToMax,l=E(this.options.overscroll,0),h=a.series&&a.series[0],m=!!this.setExtremes;if(!this.eventArgs||"rangeSelectorButton"!==this.eventArgs.trigger){if(f){var r=c;var p=r+b}e&&(p=d+l,f||(r=Math.max(p-b,a.getBaseSeriesMin(h&&h.xData?h.xData[0]:-Number.MAX_VALUE))));m&&(f||e)&&C(r)&&
(this.min=this.userMin=r,this.max=this.userMax=p)}a.stickToMin=a.stickToMax=null},updatedDataHandler:function(){var a=this.chart.navigator,b=this.navigatorSeries,c=a.getBaseSeriesMin(this.xData[0]);a.stickToMax=a.reversedExtremes?0===Math.round(a.zoomedMin):Math.round(a.zoomedMax)>=Math.round(a.size);a.stickToMin=C(this.xAxis.min)&&this.xAxis.min<=c&&(!this.chart.fixedRange||!a.stickToMax);b&&!a.hasNavigatorData&&(b.options.pointStart=this.xData[0],b.setData(this.options.data,!1,null,!1))},addChartEvents:function(){this.eventsToUnbind||
(this.eventsToUnbind=[]);this.eventsToUnbind.push(m(this.chart,"redraw",function(){var a=this.navigator,b=a&&(a.baseSeries&&a.baseSeries[0]&&a.baseSeries[0].xAxis||a.scrollbar&&this.xAxis[0]);b&&a.render(b.min,b.max)}),m(this.chart,"getMargins",function(){var a=this.navigator,b=a.opposite?"plotTop":"marginBottom";this.inverted&&(b=a.opposite?"marginRight":"plotLeft");this[b]=(this[b]||0)+(a.navigatorEnabled||!this.inverted?a.outlineHeight:0)+a.navigatorOptions.margin}))},destroy:function(){this.removeEvents();
this.xAxis&&(z(this.chart.xAxis,this.xAxis),z(this.chart.axes,this.xAxis));this.yAxis&&(z(this.chart.yAxis,this.yAxis),z(this.chart.axes,this.yAxis));(this.series||[]).forEach(function(a){a.destroy&&a.destroy()});"series xAxis yAxis shades outline scrollbarTrack scrollbarRifles scrollbarGroup scrollbar navigatorGroup rendered".split(" ").forEach(function(a){this[a]&&this[a].destroy&&this[a].destroy();this[a]=null},this);[this.handles].forEach(function(a){H(a)},this)}};c.Navigator||(c.Navigator=D,
m(p,"zoom",function(a){var c=this.chart.options,d=c.chart.zoomType,f=c.chart.pinchType,e=c.navigator;c=c.rangeSelector;this.isXAxis&&(e&&e.enabled||c&&c.enabled)&&("y"===d?a.zoomed=!1:(!b&&"xy"===d||b&&"xy"===f)&&this.options.range&&(d=this.previousZoom,G(a.newMin)?this.previousZoom=[this.min,this.max]:d&&(a.newMin=d[0],a.newMax=d[1],delete this.previousZoom)));void 0!==a.zoomed&&a.preventDefault()}),m(e,"beforeShowResetZoom",function(){var a=this.options,c=a.navigator,d=a.rangeSelector;if((c&&c.enabled||
d&&d.enabled)&&(!b&&"x"===a.chart.zoomType||b&&"x"===a.chart.pinchType))return!1}),m(e,"beforeRender",function(){var a=this.options;if(a.navigator.enabled||a.scrollbar.enabled)this.scroller=this.navigator=new D(this)}),m(e,"afterSetChartSize",function(){var a=this.legend,b=this.navigator;if(b){var c=a&&a.options;var d=b.xAxis;var f=b.yAxis;var e=b.scrollbarHeight;this.inverted?(b.left=b.opposite?this.chartWidth-e-b.height:this.spacing[3]+e,b.top=this.plotTop+e):(b.left=this.plotLeft+e,b.top=b.navigatorOptions.top||
this.chartHeight-b.height-e-this.spacing[2]-(this.rangeSelector&&this.extraBottomMargin?this.rangeSelector.getHeight():0)-(c&&"bottom"===c.verticalAlign&&c.enabled&&!c.floating?a.legendHeight+E(c.margin,10):0)-(this.titleOffset?this.titleOffset[2]:0));d&&f&&(this.inverted?d.options.left=f.options.left=b.left:d.options.top=f.options.top=b.top,d.setAxisSize(),f.setAxisSize())}}),m(e,"update",function(a){var b=a.options.navigator||{},c=a.options.scrollbar||{};this.navigator||this.scroller||!b.enabled&&
!c.enabled||(d(!0,this.options.navigator,b),d(!0,this.options.scrollbar,c),delete a.options.navigator,delete a.options.scrollbar)}),m(e,"afterUpdate",function(a){this.navigator||this.scroller||!this.options.navigator.enabled&&!this.options.scrollbar.enabled||(this.scroller=this.navigator=new D(this),E(a.redraw,!0)&&this.redraw(a.animation))}),m(e,"afterAddSeries",function(){this.navigator&&this.navigator.setBaseSeries(null,!1)}),m(F,"afterUpdate",function(){this.chart.navigator&&!this.options.isInternal&&
this.chart.navigator.setBaseSeries(null,!1)}),e.prototype.callbacks.push(function(a){var b=a.navigator;b&&a.xAxis[0]&&(a=a.xAxis[0].getExtremes(),b.render(a.min,a.max))}))});K(D,"parts/OrdinalAxis.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,e){var D=e.defined,G=e.extend,H=e.pick;e=c.addEvent;var z=c.Axis,t=c.Chart,x=c.css,C=c.noop,E=c.timeUnits;e(c.Series,"updatedData",function(){var c=this.xAxis;c&&c.options.ordinal&&delete c.ordinalIndex});z.prototype.getTimeTicks=function(c,
e,p,q,h,a,b){var d=0,f,l,m={},y=[],r=-Number.MAX_VALUE,n=this.options.tickPixelInterval,g=this.chart.time,k=[];if(!this.options.ordinal&&!this.options.breaks||!h||3>h.length||void 0===e)return g.getTimeTicks.apply(g,arguments);var v=h.length;for(f=0;f<v;f++){var B=f&&h[f-1]>p;h[f]<e&&(d=f);if(f===v-1||h[f+1]-h[f]>5*a||B){if(h[f]>r){for(l=g.getTimeTicks(c,h[d],h[f],q);l.length&&l[0]<=r;)l.shift();l.length&&(r=l[l.length-1]);k.push(y.length);y=y.concat(l)}d=f+1}if(B)break}l=l.info;if(b&&l.unitRange<=
E.hour){f=y.length-1;for(d=1;d<f;d++)if(g.dateFormat("%d",y[d])!==g.dateFormat("%d",y[d-1])){m[y[d]]="day";var w=!0}w&&(m[y[0]]="day");l.higherRanks=m}l.segmentStarts=k;y.info=l;if(b&&D(n)){d=k=y.length;w=[];var u;for(g=[];d--;)f=this.translate(y[d]),u&&(g[d]=u-f),w[d]=u=f;g.sort();g=g[Math.floor(g.length/2)];g<.6*n&&(g=null);d=y[k-1]>p?k-1:k;for(u=void 0;d--;)f=w[d],k=Math.abs(u-f),u&&k<.8*n&&(null===g||k<.8*g)?(m[y[d]]&&!m[y[d+1]]?(k=d+1,u=f):k=d,y.splice(k,1)):u=f}return y};G(z.prototype,{beforeSetTickPositions:function(){var c=
[],e,p=!1,q=this.getExtremes(),h=q.min,a=q.max,b,d=this.isXAxis&&!!this.options.breaks;q=this.options.ordinal;var f=Number.MAX_VALUE,l=this.chart.options.chart.ignoreHiddenSeries,F;if(q||d){this.series.forEach(function(a,b){e=[];if(!(l&&!1===a.visible||!1===a.takeOrdinalPosition&&!d)&&(c=c.concat(a.processedXData),y=c.length,c.sort(function(a,b){return a-b}),f=Math.min(f,H(a.closestPointRange,f)),y)){for(b=0;b<y-1;)c[b]!==c[b+1]&&e.push(c[b+1]),b++;e[0]!==c[0]&&e.unshift(c[0]);c=e}a.isSeriesBoosting&&
(F=!0)});F&&(c.length=0);var y=c.length;if(2<y){var r=c[1]-c[0];for(b=y-1;b--&&!p;)c[b+1]-c[b]!==r&&(p=!0);!this.options.keepOrdinalPadding&&(c[0]-h>r||a-c[c.length-1]>r)&&(p=!0)}else this.options.overscroll&&(2===y?f=c[1]-c[0]:1===y?(f=this.options.overscroll,c=[c[0],c[0]+f]):f=this.overscrollPointsRange);p?(this.options.overscroll&&(this.overscrollPointsRange=f,c=c.concat(this.getOverscrollPositions())),this.ordinalPositions=c,r=this.ordinal2lin(Math.max(h,c[0]),!0),b=Math.max(this.ordinal2lin(Math.min(a,
c[c.length-1]),!0),1),this.ordinalSlope=a=(a-h)/(b-r),this.ordinalOffset=h-r*a):(this.overscrollPointsRange=H(this.closestPointRange,this.overscrollPointsRange),this.ordinalPositions=this.ordinalSlope=this.ordinalOffset=void 0)}this.isOrdinal=q&&p;this.groupIntervalFactor=null},val2lin:function(c,e){var m=this.ordinalPositions;if(m){var q=m.length,h;for(h=q;h--;)if(m[h]===c){var a=h;break}for(h=q-1;h--;)if(c>m[h]||0===h){c=(c-m[h])/(m[h+1]-m[h]);a=h+c;break}e=e?a:this.ordinalSlope*(a||0)+this.ordinalOffset}else e=
c;return e},lin2val:function(c,e){var m=this.ordinalPositions;if(m){var q=this.ordinalSlope,h=this.ordinalOffset,a=m.length-1;if(e)if(0>c)c=m[0];else if(c>a)c=m[a];else{a=Math.floor(c);var b=c-a}else for(;a--;)if(e=q*a+h,c>=e){q=q*(a+1)+h;b=(c-e)/(q-e);break}return void 0!==b&&void 0!==m[a]?m[a]+(b?b*(m[a+1]-m[a]):0):c}return c},getExtendedPositions:function(){var c=this,e=c.chart,p=c.series[0].currentDataGrouping,q=c.ordinalIndex,h=p?p.count+p.unitName:"raw",a=c.options.overscroll,b=c.getExtremes(),
d;q||(q=c.ordinalIndex={});if(!q[h]){var f={series:[],chart:e,getExtremes:function(){return{min:b.dataMin,max:b.dataMax+a}},options:{ordinal:!0},val2lin:z.prototype.val2lin,ordinal2lin:z.prototype.ordinal2lin};c.series.forEach(function(a){d={xAxis:f,xData:a.xData.slice(),chart:e,destroyGroupedData:C};d.xData=d.xData.concat(c.getOverscrollPositions());d.options={dataGrouping:p?{enabled:!0,forced:!0,approximation:"open",units:[[p.unitName,[p.count]]]}:{enabled:!1}};a.processData.apply(d);f.series.push(d)});
c.beforeSetTickPositions.apply(f);q[h]=f.ordinalPositions}return q[h]},getOverscrollPositions:function(){var c=this.options.overscroll,e=this.overscrollPointsRange,p=[],q=this.dataMax;if(D(e))for(p.push(q);q<=this.dataMax+c;)q+=e,p.push(q);return p},getGroupIntervalFactor:function(c,e,p){p=p.processedXData;var m=p.length,h=[];var a=this.groupIntervalFactor;if(!a){for(a=0;a<m-1;a++)h[a]=p[a+1]-p[a];h.sort(function(a,c){return a-c});h=h[Math.floor(m/2)];c=Math.max(c,p[0]);e=Math.min(e,p[m-1]);this.groupIntervalFactor=
a=m*h/(e-c)}return a},postProcessTickInterval:function(c){var e=this.ordinalSlope;return e?this.options.breaks?this.closestPointRange||c:c/(e/this.closestPointRange):c}});z.prototype.ordinal2lin=z.prototype.val2lin;e(t,"pan",function(c){var e=this.xAxis[0],p=e.options.overscroll,q=c.originalEvent.chartX,h=!1;if(e.options.ordinal&&e.series.length){var a=this.mouseDownX,b=e.getExtremes(),d=b.dataMax,f=b.min,l=b.max,w=this.hoverPoints,y=e.closestPointRange||e.overscrollPointsRange;a=(a-q)/(e.translationSlope*
(e.ordinalSlope||y));var r={ordinalPositions:e.getExtendedPositions()};y=e.lin2val;var n=e.val2lin;if(!r.ordinalPositions)h=!0;else if(1<Math.abs(a)){w&&w.forEach(function(a){a.setState()});if(0>a){w=r;var g=e.ordinalPositions?e:r}else w=e.ordinalPositions?e:r,g=r;r=g.ordinalPositions;d>r[r.length-1]&&r.push(d);this.fixedRange=l-f;a=e.toFixedRange(null,null,y.apply(w,[n.apply(w,[f,!0])+a,!0]),y.apply(g,[n.apply(g,[l,!0])+a,!0]));a.min>=Math.min(b.dataMin,f)&&a.max<=Math.max(d,l)+p&&e.setExtremes(a.min,
a.max,!0,!1,{trigger:"pan"});this.mouseDownX=q;x(this.container,{cursor:"move"})}}else h=!0;h?p&&(e.max=e.dataMax+p):c.preventDefault()});e(z,"foundExtremes",function(){this.isXAxis&&D(this.options.overscroll)&&this.max===this.dataMax&&(!this.chart.mouseIsDown||this.isInternal)&&(!this.eventArgs||this.eventArgs&&"navigator"!==this.eventArgs.trigger)&&(this.max+=this.options.overscroll,!this.isInternal&&D(this.userMin)&&(this.min+=this.options.overscroll))});e(z,"afterSetScale",function(){this.horiz&&
!this.isDirty&&(this.isDirty=this.isOrdinal&&this.chart.navigator&&!this.chart.navigator.adaptToUpdatedData)})});K(D,"modules/broken-axis.src.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,e){var D=e.extend,G=e.isArray,H=e.pick;e=c.addEvent;var z=c.find,t=c.fireEvent,x=c.Axis,C=c.Series,E=function(c,e){return z(e,function(e){return e.from<c&&c<e.to})};D(x.prototype,{isInBreak:function(c,e){var m=c.repeat||Infinity,q=c.from,h=c.to-c.from;e=e>=q?(e-q)%m:m-(q-e)%m;return c.inclusive?
e<=h:e<h&&0!==e},isInAnyBreak:function(c,e){var m=this.options.breaks,q=m&&m.length,h;if(q){for(;q--;)if(this.isInBreak(m[q],c)){var a=!0;h||(h=H(m[q].showPoints,!this.isXAxis))}var b=a&&e?a&&!h:a}return b}});e(x,"afterInit",function(){"function"===typeof this.setBreaks&&this.setBreaks(this.options.breaks,!1)});e(x,"afterSetTickPositions",function(){if(this.isBroken){var c=this.tickPositions,e=this.tickPositions.info,p=[],q;for(q=0;q<c.length;q++)this.isInAnyBreak(c[q])||p.push(c[q]);this.tickPositions=
p;this.tickPositions.info=e}});e(x,"afterSetOptions",function(){this.isBroken&&(this.options.ordinal=!1)});x.prototype.setBreaks=function(c,e){function m(a){var b=a,c;for(c=0;c<h.breakArray.length;c++){var e=h.breakArray[c];if(e.to<=a)b-=e.len;else if(e.from>=a)break;else if(h.isInBreak(e,a)){b-=a-e.from;break}}return b}function q(a){var b;for(b=0;b<h.breakArray.length;b++){var c=h.breakArray[b];if(c.from>=a)break;else c.to<a?a+=c.len:h.isInBreak(c,a)&&(a+=c.len)}return a}var h=this,a=G(c)&&!!c.length;
h.isDirty=h.isBroken!==a;h.isBroken=a;h.options.breaks=h.userOptions.breaks=c;h.forceRedraw=!0;a||h.val2lin!==m||(delete h.val2lin,delete h.lin2val);a&&(h.userOptions.ordinal=!1,h.val2lin=m,h.lin2val=q,h.setExtremes=function(a,c,f,e,h){if(this.isBroken){for(var b,d=this.options.breaks;b=E(a,d);)a=b.to;for(;b=E(c,d);)c=b.from;c<a&&(c=a)}x.prototype.setExtremes.call(this,a,c,f,e,h)},h.setAxisTranslation=function(a){x.prototype.setAxisTranslation.call(this,a);this.unitLength=null;if(this.isBroken){a=
h.options.breaks;var b=[],c=[],e=0,m,p=h.userMin||h.min,r=h.userMax||h.max,n=H(h.pointRangePadding,0),g;a.forEach(function(a){m=a.repeat||Infinity;h.isInBreak(a,p)&&(p+=a.to%m-p%m);h.isInBreak(a,r)&&(r-=r%m-a.from%m)});a.forEach(function(a){v=a.from;for(m=a.repeat||Infinity;v-m>p;)v-=m;for(;v<p;)v+=m;for(g=v;g<r;g+=m)b.push({value:g,move:"in"}),b.push({value:g+(a.to-a.from),move:"out",size:a.breakSize})});b.sort(function(a,b){return a.value===b.value?("in"===a.move?0:1)-("in"===b.move?0:1):a.value-
b.value});var k=0;var v=p;b.forEach(function(a){k+="in"===a.move?1:-1;1===k&&"in"===a.move&&(v=a.value);0===k&&(c.push({from:v,to:a.value,len:a.value-v-(a.size||0)}),e+=a.value-v-(a.size||0))});h.breakArray=c;h.unitLength=r-p-e+n;t(h,"afterBreaks");h.staticScale?h.transA=h.staticScale:h.unitLength&&(h.transA*=(r-h.min+n)/h.unitLength);n&&(h.minPixelPadding=h.transA*h.minPointOffset);h.min=p;h.max=r}});H(e,!0)&&this.chart.redraw()};e(C,"afterGeneratePoints",function(){var c=this.xAxis,e=this.yAxis,
p=this.points,q=p.length,h=this.options.connectNulls;if(c&&e&&(c.options.breaks||e.options.breaks))for(;q--;){var a=p[q];var b=null===a.y&&!1===h;b||!c.isInAnyBreak(a.x,!0)&&!e.isInAnyBreak(a.y,!0)||(p.splice(q,1),this.data[q]&&this.data[q].destroyElements())}});e(C,"afterRender",function(){this.drawBreaks(this.xAxis,["x"]);this.drawBreaks(this.yAxis,H(this.pointArrayMap,["y"]))});c.Series.prototype.drawBreaks=function(c,e){var m=this,q=m.points,h,a,b,d;c&&e.forEach(function(f){h=c.breakArray||[];
a=c.isXAxis?c.min:H(m.options.threshold,c.min);q.forEach(function(e){d=H(e["stack"+f.toUpperCase()],e[f]);h.forEach(function(f){b=!1;if(a<f.from&&d>f.to||a>f.from&&d<f.from)b="pointBreak";else if(a<f.from&&d>f.from&&d<f.to||a>f.from&&d>f.to&&d<f.from)b="pointInBreak";b&&t(c,b,{point:e,brk:f})})})})};c.Series.prototype.gappedPath=function(){var e=this.currentDataGrouping,m=e&&e.gapSize;e=this.options.gapSize;var p=this.points.slice(),q=p.length-1,h=this.yAxis;if(e&&0<q)for("value"!==this.options.gapUnit&&
(e*=this.basePointRange),m&&m>e&&m>=this.basePointRange&&(e=m);q--;)p[q+1].x-p[q].x>e&&(m=(p[q].x+p[q+1].x)/2,p.splice(q+1,0,{isNull:!0,x:m}),this.options.stacking&&(m=h.stacks[this.stackKey][m]=new c.StackItem(h,h.options.stackLabels,!1,m,this.stack),m.total=0));return this.getGraphPath(p)}});K(D,"masters/modules/broken-axis.src.js",[],function(){});K(D,"parts/DataGrouping.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,e){var D=e.arrayMax,G=e.arrayMin,H=e.defined,z=e.extend,t=e.isNumber,
x=e.pick;e=c.addEvent;var C=c.Axis,E=c.correctFloat,w=c.defaultPlotOptions,m=c.format,p=c.merge,q=c.Point,h=c.Series,a=c.Tooltip,b=c.approximations={sum:function(a){var b=a.length;if(!b&&a.hasNulls)var c=null;else if(b)for(c=0;b--;)c+=a[b];return c},average:function(a){var c=a.length;a=b.sum(a);t(a)&&c&&(a=E(a/c));return a},averages:function(){var a=[];[].forEach.call(arguments,function(c){a.push(b.average(c))});return void 0===a[0]?void 0:a},open:function(a){return a.length?a[0]:a.hasNulls?null:
void 0},high:function(a){return a.length?D(a):a.hasNulls?null:void 0},low:function(a){return a.length?G(a):a.hasNulls?null:void 0},close:function(a){return a.length?a[a.length-1]:a.hasNulls?null:void 0},ohlc:function(a,c,d,g){a=b.open(a);c=b.high(c);d=b.low(d);g=b.close(g);if(t(a)||t(c)||t(d)||t(g))return[a,c,d,g]},range:function(a,c){a=b.low(a);c=b.high(c);if(t(a)||t(c))return[a,c];if(null===a&&null===c)return null}},d=function(a,c,d,g){var f=this,e=f.data,k=f.options&&f.options.data,l=[],h=[],m=
[],n=a.length,r=!!c,v=[],q=f.pointArrayMap,y=q&&q.length,B=["x"].concat(q||["y"]),A=0,w=0,x;g="function"===typeof g?g:b[g]?b[g]:b[f.getDGApproximation&&f.getDGApproximation()||"average"];y?q.forEach(function(){v.push([])}):v.push([]);var F=y||1;for(x=0;x<=n&&!(a[x]>=d[0]);x++);for(x;x<=n;x++){for(;void 0!==d[A+1]&&a[x]>=d[A+1]||x===n;){var z=d[A];f.dataGroupInfo={start:f.cropStart+w,length:v[0].length};var C=g.apply(f,v);f.pointClass&&!H(f.dataGroupInfo.options)&&(f.dataGroupInfo.options=p(f.pointClass.prototype.optionsToObject.call({series:f},
f.options.data[f.cropStart+w])),B.forEach(function(a){delete f.dataGroupInfo.options[a]}));void 0!==C&&(l.push(z),h.push(C),m.push(f.dataGroupInfo));w=x;for(z=0;z<F;z++)v[z].length=0,v[z].hasNulls=!1;A+=1;if(x===n)break}if(x===n)break;if(q)for(z=f.cropStart+x,C=e&&e[z]||f.pointClass.prototype.applyOptions.apply({series:f},[k[z]]),z=0;z<y;z++){var E=C[q[z]];t(E)?v[z].push(E):null===E&&(v[z].hasNulls=!0)}else z=r?c[x]:null,t(z)?v[0].push(z):null===z&&(v[0].hasNulls=!0)}return{groupedXData:l,groupedYData:h,
groupMap:m}},f={approximations:b,groupData:d},l=h.prototype,F=l.processData,y=l.generatePoints,r={groupPixelWidth:2,dateTimeLabelFormats:{millisecond:["%A, %b %e, %H:%M:%S.%L","%A, %b %e, %H:%M:%S.%L","-%H:%M:%S.%L"],second:["%A, %b %e, %H:%M:%S","%A, %b %e, %H:%M:%S","-%H:%M:%S"],minute:["%A, %b %e, %H:%M","%A, %b %e, %H:%M","-%H:%M"],hour:["%A, %b %e, %H:%M","%A, %b %e, %H:%M","-%H:%M"],day:["%A, %b %e, %Y","%A, %b %e","-%A, %b %e, %Y"],week:["Week from %A, %b %e, %Y","%A, %b %e","-%A, %b %e, %Y"],
month:["%B %Y","%B","-%B %Y"],year:["%Y","%Y","-%Y"]}},n={line:{},spline:{},area:{},areaspline:{},arearange:{},column:{groupPixelWidth:10},columnrange:{groupPixelWidth:10},candlestick:{groupPixelWidth:10},ohlc:{groupPixelWidth:5}},g=c.defaultDataGroupingUnits=[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1]],["week",[1]],["month",[1,3,6]],["year",null]];l.getDGApproximation=function(){return c.seriesTypes.arearange&&
this instanceof c.seriesTypes.arearange?"range":c.seriesTypes.ohlc&&this instanceof c.seriesTypes.ohlc?"ohlc":c.seriesTypes.column&&this instanceof c.seriesTypes.column?"sum":"average"};l.groupData=d;l.processData=function(){var a=this.chart,b=this.options.dataGrouping,c=!1!==this.allowDG&&b&&x(b.enabled,a.options.isStock),d=this.visible||!a.options.chart.ignoreHiddenSeries,f,e=this.currentDataGrouping,h=!1;this.forceCrop=c;this.groupPixelWidth=null;this.hasProcessed=!0;c&&!this.requireSorting&&(this.requireSorting=
h=!0);c=!1===F.apply(this,arguments)||!c;h&&(this.requireSorting=!1);if(!c){this.destroyGroupedData();c=b.groupAll?this.xData:this.processedXData;var m=b.groupAll?this.yData:this.processedYData,n=a.plotSizeX;a=this.xAxis;var r=a.options.ordinal,p=this.groupPixelWidth=a.getGroupPixelWidth&&a.getGroupPixelWidth();if(p){this.isDirty=f=!0;this.points=null;h=a.getExtremes();var q=h.min;h=h.max;r=r&&a.getGroupIntervalFactor(q,h,this)||1;p=p*(h-q)/n*r;n=a.getTimeTicks(a.normalizeTimeTickInterval(p,b.units||
g),Math.min(q,c[0]),Math.max(h,c[c.length-1]),a.options.startOfWeek,c,this.closestPointRange);m=l.groupData.apply(this,[c,m,n,b.approximation]);c=m.groupedXData;r=m.groupedYData;var y=0;if(b.smoothed&&c.length){var t=c.length-1;for(c[t]=Math.min(c[t],h);t--&&0<t;)c[t]+=p/2;c[0]=Math.max(c[0],q)}for(t=1;t<n.length;t++)n.info.segmentStarts&&-1!==n.info.segmentStarts.indexOf(t)||(y=Math.max(n[t]-n[t-1],y));q=n.info;q.gapSize=y;this.closestPointRange=n.info.totalRange;this.groupMap=m.groupMap;if(H(c[0])&&
c[0]<a.min&&d){if(!H(a.options.min)&&a.min<=a.dataMin||a.min===a.dataMin)a.min=Math.min(c[0],a.min);a.dataMin=c[0]}b.groupAll&&(b=this.cropData(c,r,a.min,a.max,1),c=b.xData,r=b.yData);this.processedXData=c;this.processedYData=r}else this.groupMap=null;this.hasGroupedData=f;this.currentDataGrouping=q;this.preventGraphAnimation=(e&&e.totalRange)!==(q&&q.totalRange)}};l.destroyGroupedData=function(){this.groupedData&&(this.groupedData.forEach(function(a,b){a&&(this.groupedData[b]=a.destroy?a.destroy():
null)},this),this.groupedData.length=0)};l.generatePoints=function(){y.apply(this);this.destroyGroupedData();this.groupedData=this.hasGroupedData?this.points:null};e(q,"update",function(){if(this.dataGroup)return c.error(24,!1,this.series.chart),!1});e(a,"headerFormatter",function(a){var b=this.chart.time,c=a.labelConfig,d=c.series,g=d.tooltipOptions,f=d.options.dataGrouping,e=g.xDateFormat,k=d.xAxis,l=g[(a.isFooter?"footer":"header")+"Format"];if(k&&"datetime"===k.options.type&&f&&t(c.key)){var h=
d.currentDataGrouping;f=f.dateTimeLabelFormats||r.dateTimeLabelFormats;if(h)if(g=f[h.unitName],1===h.count)e=g[0];else{e=g[1];var n=g[2]}else!e&&f&&(e=this.getXDateFormat(c,g,k));e=b.dateFormat(e,c.key);n&&(e+=b.dateFormat(n,c.key+h.totalRange-1));d.chart.styledMode&&(l=this.styledModeFormat(l));a.text=m(l,{point:z(c.point,{key:e}),series:d},b);a.preventDefault()}});e(h,"destroy",l.destroyGroupedData);e(h,"afterSetOptions",function(a){a=a.options;var b=this.type,c=this.chart.options.plotOptions,d=
w[b].dataGrouping,g=this.useCommonDataGrouping&&r;if(n[b]||g)d||(d=p(r,n[b])),a.dataGrouping=p(g,d,c.series&&c.series.dataGrouping,c[b].dataGrouping,this.userOptions.dataGrouping)});e(C,"afterSetScale",function(){this.series.forEach(function(a){a.hasProcessed=!1})});C.prototype.getGroupPixelWidth=function(){var a=this.series,b=a.length,c,d=0,g=!1,f;for(c=b;c--;)(f=a[c].options.dataGrouping)&&(d=Math.max(d,x(f.groupPixelWidth,r.groupPixelWidth)));for(c=b;c--;)(f=a[c].options.dataGrouping)&&a[c].hasProcessed&&
(b=(a[c].processedXData||a[c].data).length,a[c].groupPixelWidth||b>this.chart.plotSizeX/d||b&&f.forced)&&(g=!0);return g?d:0};C.prototype.setDataGrouping=function(a,b){var c;b=x(b,!0);a||(a={forced:!1,units:null});if(this instanceof C)for(c=this.series.length;c--;)this.series[c].update({dataGrouping:a},!1);else this.chart.options.series.forEach(function(b){b.dataGrouping=a},!1);this.ordinalSlope=null;b&&this.chart.redraw()};c.dataGrouping=f;"";return f});K(D,"parts/OHLCSeries.js",[D["parts/Globals.js"]],
function(c){var e=c.Point,D=c.seriesType,G=c.seriesTypes;D("ohlc","column",{lineWidth:1,tooltip:{pointFormat:'<span style="color:{point.color}">\u25cf</span> <b> {series.name}</b><br/>Open: {point.open}<br/>High: {point.high}<br/>Low: {point.low}<br/>Close: {point.close}<br/>'},threshold:null,states:{hover:{lineWidth:3}},stickyTracking:!0},{directTouch:!1,pointArrayMap:["open","high","low","close"],toYData:function(c){return[c.open,c.high,c.low,c.close]},pointValKey:"close",pointAttrToOptions:{stroke:"color",
"stroke-width":"lineWidth"},init:function(){G.column.prototype.init.apply(this,arguments);this.options.stacking=!1},pointAttribs:function(c,e){e=G.column.prototype.pointAttribs.call(this,c,e);var t=this.options;delete e.fill;!c.options.color&&t.upColor&&c.open<c.close&&(e.stroke=t.upColor);return e},translate:function(){var c=this,e=c.yAxis,t=!!c.modifyValue,x=["plotOpen","plotHigh","plotLow","plotClose","yBottom"];G.column.prototype.translate.apply(c);c.points.forEach(function(z){[z.open,z.high,
z.low,z.close,z.low].forEach(function(C,w){null!==C&&(t&&(C=c.modifyValue(C)),z[x[w]]=e.toPixels(C,!0))});z.tooltipPos[1]=z.plotHigh+e.pos-c.chart.plotTop})},drawPoints:function(){var c=this,e=c.chart;c.points.forEach(function(t){var x=t.graphic,z=!x;if(void 0!==t.plotY){x||(t.graphic=x=e.renderer.path().add(c.group));e.styledMode||x.attr(c.pointAttribs(t,t.selected&&"select"));var E=x.strokeWidth()%2/2;var w=Math.round(t.plotX)-E;var m=Math.round(t.shapeArgs.width/2);var p=["M",w,Math.round(t.yBottom),
"L",w,Math.round(t.plotHigh)];if(null!==t.open){var q=Math.round(t.plotOpen)+E;p.push("M",w,q,"L",w-m,q)}null!==t.close&&(q=Math.round(t.plotClose)+E,p.push("M",w,q,"L",w+m,q));x[z?"attr":"animate"]({d:p}).addClass(t.getClassName(),!0)}})},animate:null},{getClassName:function(){return e.prototype.getClassName.call(this)+(this.open<this.close?" highcharts-point-up":" highcharts-point-down")}});""});K(D,"parts/CandlestickSeries.js",[D["parts/Globals.js"]],function(c){var e=c.defaultPlotOptions,D=c.merge,
G=c.seriesType,H=c.seriesTypes;G("candlestick","ohlc",D(e.column,{states:{hover:{lineWidth:2}},tooltip:e.ohlc.tooltip,threshold:null,lineColor:"#000000",lineWidth:1,upColor:"#ffffff",stickyTracking:!0}),{pointAttribs:function(c,e){var t=H.column.prototype.pointAttribs.call(this,c,e),z=this.options,E=c.open<c.close,w=z.lineColor||this.color;t["stroke-width"]=z.lineWidth;t.fill=c.options.color||(E?z.upColor||this.color:this.color);t.stroke=c.options.lineColor||(E?z.upLineColor||w:w);e&&(c=z.states[e],
t.fill=c.color||t.fill,t.stroke=c.lineColor||t.stroke,t["stroke-width"]=c.lineWidth||t["stroke-width"]);return t},drawPoints:function(){var c=this,e=c.chart,x=c.yAxis.reversed;c.points.forEach(function(t){var z=t.graphic,w=!z;if(void 0!==t.plotY){z||(t.graphic=z=e.renderer.path().add(c.group));c.chart.styledMode||z.attr(c.pointAttribs(t,t.selected&&"select")).shadow(c.options.shadow);var m=z.strokeWidth()%2/2;var p=Math.round(t.plotX)-m;var q=t.plotOpen;var h=t.plotClose;var a=Math.min(q,h);q=Math.max(q,
h);var b=Math.round(t.shapeArgs.width/2);h=x?q!==t.yBottom:Math.round(a)!==Math.round(t.plotHigh);var d=x?Math.round(a)!==Math.round(t.plotHigh):q!==t.yBottom;a=Math.round(a)+m;q=Math.round(q)+m;m=[];m.push("M",p-b,q,"L",p-b,a,"L",p+b,a,"L",p+b,q,"Z","M",p,a,"L",p,h?Math.round(x?t.yBottom:t.plotHigh):a,"M",p,q,"L",p,d?Math.round(x?t.plotHigh:t.yBottom):q);z[w?"attr":"animate"]({d:m}).addClass(t.getClassName(),!0)}})}});""});K(D,"mixins/on-series.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],
function(c,e){var D=e.defined,G=c.seriesTypes,H=c.stableSort;return{getPlotBox:function(){return c.Series.prototype.getPlotBox.call(this.options.onSeries&&this.chart.get(this.options.onSeries)||this)},translate:function(){G.column.prototype.translate.apply(this);var c=this,e=c.options,x=c.chart,C=c.points,E=C.length-1,w,m=e.onSeries;m=m&&x.get(m);e=e.onKey||"y";var p=m&&m.options.step,q=m&&m.points,h=q&&q.length,a=x.inverted,b=c.xAxis,d=c.yAxis,f=0,l;if(m&&m.visible&&h){f=(m.pointXOffset||0)+(m.barW||
0)/2;x=m.currentDataGrouping;var F=q[h-1].x+(x?x.totalRange:0);H(C,function(a,b){return a.x-b.x});for(e="plot"+e[0].toUpperCase()+e.substr(1);h--&&C[E];){var y=q[h];x=C[E];x.y=y.y;if(y.x<=x.x&&void 0!==y[e]){if(x.x<=F&&(x.plotY=y[e],y.x<x.x&&!p&&(l=q[h+1])&&void 0!==l[e])){var r=(x.x-y.x)/(l.x-y.x);x.plotY+=r*(l[e]-y[e]);x.y+=r*(l.y-y.y)}E--;h++;if(0>E)break}}}C.forEach(function(e,g){e.plotX+=f;if(void 0===e.plotY||a)0<=e.plotX&&e.plotX<=b.len?a?(e.plotY=b.translate(e.x,0,1,0,1),e.plotX=D(e.y)?d.translate(e.y,
0,0,0,1):0):e.plotY=(b.opposite?0:c.yAxis.len)+b.offset:e.shapeArgs={};if((w=C[g-1])&&w.plotX===e.plotX){void 0===w.stackIndex&&(w.stackIndex=0);var l=w.stackIndex+1}e.stackIndex=l});this.onSeries=m}}});K(D,"parts/FlagsSeries.js",[D["parts/Globals.js"],D["parts/Utilities.js"],D["mixins/on-series.js"]],function(c,e,D){function G(a){h[a+"pin"]=function(b,c,f,e,m){var d=m&&m.anchorX;m=m&&m.anchorY;"circle"===a&&e>f&&(b-=Math.round((e-f)/2),f=e);var l=h[a](b,c,f,e);d&&m&&(l.push("M","circle"===a?b+f/
2:l[1]+l[4]/2,c>m?c:c+e,"L",d,m),l=l.concat(h.circle(d-1,m-1,2,2)));return l}}var H=e.defined,z=e.isNumber,t=e.objectEach,x=c.addEvent,C=c.merge;e=c.noop;var E=c.Renderer,w=c.Series,m=c.seriesType,p=c.TrackerMixin,q=c.VMLRenderer,h=c.SVGRenderer.prototype.symbols;m("flags","column",{pointRange:0,allowOverlapX:!1,shape:"flag",stackDistance:12,textAlign:"center",tooltip:{pointFormat:"{point.text}<br/>"},threshold:null,y:-30,fillColor:"#ffffff",lineWidth:1,states:{hover:{lineColor:"#000000",fillColor:"#ccd6eb"}},
style:{fontSize:"11px",fontWeight:"bold"}},{sorted:!1,noSharedTooltip:!0,allowDG:!1,takeOrdinalPosition:!1,trackerGroups:["markerGroup"],forceCrop:!0,init:w.prototype.init,pointAttribs:function(a,b){var c=this.options,f=a&&a.color||this.color,e=c.lineColor,h=a&&a.lineWidth;a=a&&a.fillColor||c.fillColor;b&&(a=c.states[b].fillColor,e=c.states[b].lineColor,h=c.states[b].lineWidth);return{fill:a||f,stroke:e||f,"stroke-width":h||c.lineWidth||0}},translate:D.translate,getPlotBox:D.getPlotBox,drawPoints:function(){var a=
this.points,b=this.chart,d=b.renderer,f=b.inverted,e=this.options,h=e.y,m,r=this.yAxis,n={},g=[];for(m=a.length;m--;){var k=a[m];var p=(f?k.plotY:k.plotX)>this.xAxis.len;var q=k.plotX;var A=k.stackIndex;var u=k.options.shape||e.shape;var w=k.plotY;void 0!==w&&(w=k.plotY+h-(void 0!==A&&A*e.stackDistance));k.anchorX=A?void 0:k.plotX;var x=A?void 0:k.plotY;var z="flag"!==u;A=k.graphic;void 0!==w&&0<=q&&!p?(A||(A=k.graphic=d.label("",null,null,u,null,null,e.useHTML),b.styledMode||A.attr(this.pointAttribs(k)).css(C(e.style,
k.style)),A.attr({align:z?"center":"left",width:e.width,height:e.height,"text-align":e.textAlign}).addClass("highcharts-point").add(this.markerGroup),k.graphic.div&&(k.graphic.div.point=k),b.styledMode||A.shadow(e.shadow),A.isNew=!0),0<q&&(q-=A.strokeWidth()%2),u={y:w,anchorY:x},e.allowOverlapX&&(u.x=q,u.anchorX=k.anchorX),A.attr({text:k.options.title||e.title||"A"})[A.isNew?"attr":"animate"](u),e.allowOverlapX||(n[k.plotX]?n[k.plotX].size=Math.max(n[k.plotX].size,A.width):n[k.plotX]={align:z?.5:
0,size:A.width,target:q,anchorX:q}),k.tooltipPos=[q,w+r.pos-b.plotTop]):A&&(k.graphic=A.destroy())}e.allowOverlapX||(t(n,function(a){a.plotX=a.anchorX;g.push(a)}),c.distribute(g,f?r.len:this.xAxis.len,100),a.forEach(function(a){var b=a.graphic&&n[a.plotX];b&&(a.graphic[a.graphic.isNew?"attr":"animate"]({x:b.pos+b.align*b.size,anchorX:a.anchorX}),H(b.pos)?a.graphic.isNew=!1:(a.graphic.attr({x:-9999,anchorX:-9999}),a.graphic.isNew=!0))}));e.useHTML&&c.wrap(this.markerGroup,"on",function(a){return c.SVGElement.prototype.on.apply(a.apply(this,
[].slice.call(arguments,1)),[].slice.call(arguments,1))})},drawTracker:function(){var a=this.points;p.drawTrackerPoint.apply(this);a.forEach(function(b){var c=b.graphic;c&&x(c.element,"mouseover",function(){0<b.stackIndex&&!b.raised&&(b._y=c.y,c.attr({y:b._y-8}),b.raised=!0);a.forEach(function(a){a!==b&&a.raised&&a.graphic&&(a.graphic.attr({y:a._y}),a.raised=!1)})})})},animate:function(a){a?this.setClip():this.animate=null},setClip:function(){w.prototype.setClip.apply(this,arguments);!1!==this.options.clip&&
this.sharedClipKey&&this.markerGroup.clip(this.chart[this.sharedClipKey])},buildKDTree:e,invertGroups:e},{isValid:function(){return z(this.y)||void 0===this.y}});h.flag=function(a,b,c,e,l){var d=l&&l.anchorX||a;l=l&&l.anchorY||b;return h.circle(d-1,l-1,2,2).concat(["M",d,l,"L",a,b+e,a,b,a+c,b,a+c,b+e,a,b+e,"Z"])};G("circle");G("square");E===q&&["circlepin","flag","squarepin"].forEach(function(a){q.prototype.symbols[a]=h[a]});""});K(D,"parts/RangeSelector.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],
function(c,e){function D(a){this.init(a)}var G=e.defined,H=e.destroyObjectProperties,z=e.discardElement,t=e.extend,x=e.isNumber,C=e.objectEach,E=e.pick,w=e.pInt,m=e.splat,p=c.addEvent,q=c.Axis;e=c.Chart;var h=c.css,a=c.createElement,b=c.defaultOptions,d=c.fireEvent,f=c.merge;t(b,{rangeSelector:{verticalAlign:"top",buttonTheme:{width:28,height:18,padding:2,zIndex:7},floating:!1,x:0,y:0,height:void 0,inputPosition:{align:"right",x:0,y:0},buttonPosition:{align:"left",x:0,y:0},labelStyle:{color:"#666666"}}});
b.lang=f(b.lang,{rangeSelectorZoom:"Zoom",rangeSelectorFrom:"From",rangeSelectorTo:"To"});D.prototype={clickButton:function(a,b){var c=this.chart,d=this.buttonOptions[a],e=c.xAxis[0],g=c.scroller&&c.scroller.getUnionExtremes()||e||{},f=g.dataMin,l=g.dataMax,h=e&&Math.round(Math.min(e.max,E(l,e.max))),t=d.type;g=d._range;var u,w=d.dataGrouping;if(null!==f&&null!==l){c.fixedRange=g;w&&(this.forcedDataGrouping=!0,q.prototype.setDataGrouping.call(e||{chart:this.chart},w,!1),this.frozenStates=d.preserveDataGrouping);
if("month"===t||"year"===t)if(e){t={range:d,max:h,chart:c,dataMin:f,dataMax:l};var z=e.minFromRange.call(t);x(t.newMax)&&(h=t.newMax)}else g=d;else if(g)z=Math.max(h-g,f),h=Math.min(z+g,l);else if("ytd"===t)if(e)void 0===l&&(f=Number.MAX_VALUE,l=Number.MIN_VALUE,c.series.forEach(function(a){a=a.xData;f=Math.min(a[0],f);l=Math.max(a[a.length-1],l)}),b=!1),h=this.getYTDExtremes(l,f,c.time.useUTC),z=u=h.min,h=h.max;else{this.deferredYTDClick=a;return}else"all"===t&&e&&(z=f,h=l);z+=d._offsetMin;h+=d._offsetMax;
this.setSelected(a);if(e)e.setExtremes(z,h,E(b,1),null,{trigger:"rangeSelectorButton",rangeSelectorButton:d});else{var F=m(c.options.xAxis)[0];var C=F.range;F.range=g;var D=F.min;F.min=u;p(c,"load",function(){F.range=C;F.min=D})}}},setSelected:function(a){this.selected=this.options.selected=a},defaultButtons:[{type:"month",count:1,text:"1m"},{type:"month",count:3,text:"3m"},{type:"month",count:6,text:"6m"},{type:"ytd",text:"YTD"},{type:"year",count:1,text:"1y"},{type:"all",text:"All"}],init:function(a){var b=
this,c=a.options.rangeSelector,e=c.buttons||[].concat(b.defaultButtons),f=c.selected,g=function(){var a=b.minInput,c=b.maxInput;a&&a.blur&&d(a,"blur");c&&c.blur&&d(c,"blur")};b.chart=a;b.options=c;b.buttons=[];b.buttonOptions=e;this.unMouseDown=p(a.container,"mousedown",g);this.unResize=p(a,"resize",g);e.forEach(b.computeButtonRange);void 0!==f&&e[f]&&this.clickButton(f,!1);p(a,"load",function(){a.xAxis&&a.xAxis[0]&&p(a.xAxis[0],"setExtremes",function(c){this.max-this.min!==a.fixedRange&&"rangeSelectorButton"!==
c.trigger&&"updatedData"!==c.trigger&&b.forcedDataGrouping&&!b.frozenStates&&this.setDataGrouping(!1,!1)})})},updateButtonStates:function(){var a=this,b=this.chart,c=b.xAxis[0],d=Math.round(c.max-c.min),e=!c.hasVisibleSeries,g=b.scroller&&b.scroller.getUnionExtremes()||c,f=g.dataMin,h=g.dataMax;b=a.getYTDExtremes(h,f,b.time.useUTC);var m=b.min,p=b.max,q=a.selected,t=x(q),w=a.options.allButtonsEnabled,z=a.buttons;a.buttonOptions.forEach(function(b,g){var k=b._range,l=b.type,n=b.count||1,r=z[g],v=0,
u=b._offsetMax-b._offsetMin;b=g===q;var y=k>h-f,x=k<c.minRange,B=!1,A=!1;k=k===d;("month"===l||"year"===l)&&d+36E5>=864E5*{month:28,year:365}[l]*n-u&&d-36E5<=864E5*{month:31,year:366}[l]*n+u?k=!0:"ytd"===l?(k=p-m+u===d,B=!b):"all"===l&&(k=c.max-c.min>=h-f,A=!b&&t&&k);l=!w&&(y||x||A||e);n=b&&k||k&&!t&&!B||b&&a.frozenStates;l?v=3:n&&(t=!0,v=2);r.state!==v&&(r.setState(v),0===v&&q===g&&a.setSelected(null))})},computeButtonRange:function(a){var b=a.type,c=a.count||1,d={millisecond:1,second:1E3,minute:6E4,
hour:36E5,day:864E5,week:6048E5};if(d[b])a._range=d[b]*c;else if("month"===b||"year"===b)a._range=864E5*{month:30,year:365}[b]*c;a._offsetMin=E(a.offsetMin,0);a._offsetMax=E(a.offsetMax,0);a._range+=a._offsetMax-a._offsetMin},setInputValue:function(a,b){var c=this.chart.options.rangeSelector,d=this.chart.time,e=this[a+"Input"];G(b)&&(e.previousValue=e.HCTime,e.HCTime=b);e.value=d.dateFormat(c.inputEditDateFormat||"%Y-%m-%d",e.HCTime);this[a+"DateBox"].attr({text:d.dateFormat(c.inputDateFormat||"%b %e, %Y",
e.HCTime)})},showInput:function(a){var b=this.inputGroup,c=this[a+"DateBox"];h(this[a+"Input"],{left:b.translateX+c.x+"px",top:b.translateY+"px",width:c.width-2+"px",height:c.height-2+"px",border:"2px solid silver"})},hideInput:function(a){h(this[a+"Input"],{border:0,width:"1px",height:"1px"});this.setInputValue(a)},drawInput:function(d){function e(){var a=A.value,b=(k.inputDateParser||Date.parse)(a),c=m.xAxis[0],d=m.scroller&&m.scroller.xAxis?m.scroller.xAxis:c,g=d.dataMin;d=d.dataMax;b!==A.previousValue&&
(A.previousValue=b,x(b)||(b=a.split("-"),b=Date.UTC(w(b[0]),w(b[1])-1,w(b[2]))),x(b)&&(m.time.useUTC||(b+=6E4*(new Date).getTimezoneOffset()),q?b>l.maxInput.HCTime?b=void 0:b<g&&(b=g):b<l.minInput.HCTime?b=void 0:b>d&&(b=d),void 0!==b&&c.setExtremes(q?b:c.min,q?c.max:b,void 0,void 0,{trigger:"rangeSelectorInput"})))}var l=this,m=l.chart,n=m.renderer.style||{},g=m.renderer,k=m.options.rangeSelector,p=l.div,q="min"===d,A,u,z=this.inputGroup;this[d+"Label"]=u=g.label(b.lang[q?"rangeSelectorFrom":"rangeSelectorTo"],
this.inputGroup.offset).addClass("highcharts-range-label").attr({padding:2}).add(z);z.offset+=u.width+5;this[d+"DateBox"]=g=g.label("",z.offset).addClass("highcharts-range-input").attr({padding:2,width:k.inputBoxWidth||90,height:k.inputBoxHeight||17,"text-align":"center"}).on("click",function(){l.showInput(d);l[d+"Input"].focus()});m.styledMode||g.attr({stroke:k.inputBoxBorderColor||"#cccccc","stroke-width":1});g.add(z);z.offset+=g.width+(q?10:0);this[d+"Input"]=A=a("input",{name:d,className:"highcharts-range-selector",
type:"text"},{top:m.plotTop+"px"},p);m.styledMode||(u.css(f(n,k.labelStyle)),g.css(f({color:"#333333"},n,k.inputStyle)),h(A,t({position:"absolute",border:0,width:"1px",height:"1px",padding:0,textAlign:"center",fontSize:n.fontSize,fontFamily:n.fontFamily,top:"-9999em"},k.inputStyle)));A.onfocus=function(){l.showInput(d)};A.onblur=function(){A===c.doc.activeElement&&e();l.hideInput(d);A.blur()};A.onchange=e;A.onkeypress=function(a){13===a.keyCode&&e()}},getPosition:function(){var a=this.chart,b=a.options.rangeSelector;
a="top"===b.verticalAlign?a.plotTop-a.axisOffset[0]:0;return{buttonTop:a+b.buttonPosition.y,inputTop:a+b.inputPosition.y-10}},getYTDExtremes:function(a,b,c){var d=this.chart.time,e=new d.Date(a),g=d.get("FullYear",e);c=c?d.Date.UTC(g,0,1):+new d.Date(g,0,1);b=Math.max(b||0,c);e=e.getTime();return{max:Math.min(a||e,e),min:b}},render:function(c,d){var e=this,f=e.chart,l=f.renderer,g=f.container,k=f.options,h=k.exporting&&!1!==k.exporting.enabled&&k.navigation&&k.navigation.buttonOptions,m=b.lang,p=
e.div,q=k.rangeSelector,t=E(k.chart.style&&k.chart.style.zIndex,0)+1;k=q.floating;var w=e.buttons;p=e.inputGroup;var x=q.buttonTheme,z=q.buttonPosition,F=q.inputPosition,C=q.inputEnabled,D=x&&x.states,G=f.plotLeft,H=e.buttonGroup;var I=e.rendered;var K=e.options.verticalAlign,X=f.legend,R=X&&X.options,T=z.y,ba=F.y,Z=I||!1,aa=Z?"animate":"attr",V=0,W=0,Y;if(!1!==q.enabled){I||(e.group=I=l.g("range-selector-group").attr({zIndex:7}).add(),e.buttonGroup=H=l.g("range-selector-buttons").add(I),e.zoomText=
l.text(m.rangeSelectorZoom,0,15).add(H),f.styledMode||(e.zoomText.css(q.labelStyle),x["stroke-width"]=E(x["stroke-width"],0)),e.buttonOptions.forEach(function(a,b){w[b]=l.button(a.text,0,0,function(c){var d=a.events&&a.events.click,g;d&&(g=d.call(a,c));!1!==g&&e.clickButton(b);e.isActive=!0},x,D&&D.hover,D&&D.select,D&&D.disabled).attr({"text-align":"center"}).add(H)}),!1!==C&&(e.div=p=a("div",null,{position:"relative",height:0,zIndex:t}),g.parentNode.insertBefore(p,g),e.inputGroup=p=l.g("input-group").add(I),
p.offset=0,e.drawInput("min"),e.drawInput("max")));e.zoomText[aa]({x:E(G+z.x,G)});var ea=E(G+z.x,G)+e.zoomText.getBBox().width+5;e.buttonOptions.forEach(function(a,b){w[b][aa]({x:ea});ea+=w[b].width+E(q.buttonSpacing,5)});G=f.plotLeft-f.spacing[3];e.updateButtonStates();h&&this.titleCollision(f)&&"top"===K&&"right"===z.align&&z.y+H.getBBox().height-12<(h.y||0)+h.height&&(V=-40);"left"===z.align?Y=z.x-f.spacing[3]:"right"===z.align&&(Y=z.x+V-f.spacing[1]);H.align({y:z.y,width:H.getBBox().width,align:z.align,
x:Y},!0,f.spacingBox);e.group.placed=Z;e.buttonGroup.placed=Z;!1!==C&&(V=h&&this.titleCollision(f)&&"top"===K&&"right"===F.align&&F.y-p.getBBox().height-12<(h.y||0)+h.height+f.spacing[0]?-40:0,"left"===F.align?Y=G:"right"===F.align&&(Y=-Math.max(f.axisOffset[1],-V)),p.align({y:F.y,width:p.getBBox().width,align:F.align,x:F.x+Y-2},!0,f.spacingBox),g=p.alignAttr.translateX+p.alignOptions.x-V+p.getBBox().x+2,h=p.alignOptions.width,m=H.alignAttr.translateX+H.getBBox().x,Y=H.getBBox().width+20,(F.align===
z.align||m+Y>g&&g+h>m&&T<ba+p.getBBox().height)&&p.attr({translateX:p.alignAttr.translateX+(f.axisOffset[1]>=-V?0:-V),translateY:p.alignAttr.translateY+H.getBBox().height+10}),e.setInputValue("min",c),e.setInputValue("max",d),e.inputGroup.placed=Z);e.group.align({verticalAlign:K},!0,f.spacingBox);c=e.group.getBBox().height+20;d=e.group.alignAttr.translateY;"bottom"===K&&(X=R&&"bottom"===R.verticalAlign&&R.enabled&&!R.floating?X.legendHeight+E(R.margin,10):0,c=c+X-20,W=d-c-(k?0:q.y)-(f.titleOffset?
f.titleOffset[2]:0)-10);if("top"===K)k&&(W=0),f.titleOffset&&f.titleOffset[0]&&(W=f.titleOffset[0]),W+=f.margin[0]-f.spacing[0]||0;else if("middle"===K)if(ba===T)W=0>ba?d+void 0:d;else if(ba||T)W=0>ba||0>T?W-Math.min(ba,T):d-c+NaN;e.group.translate(q.x,q.y+Math.floor(W));!1!==C&&(e.minInput.style.marginTop=e.group.translateY+"px",e.maxInput.style.marginTop=e.group.translateY+"px");e.rendered=!0}},getHeight:function(){var a=this.options,b=this.group,c=a.y,d=a.buttonPosition.y,e=a.inputPosition.y;if(a.height)return a.height;
a=b?b.getBBox(!0).height+13+c:0;b=Math.min(e,d);if(0>e&&0>d||0<e&&0<d)a+=Math.abs(b);return a},titleCollision:function(a){return!(a.options.title.text||a.options.subtitle.text)},update:function(a){var b=this.chart;f(!0,b.options.rangeSelector,a);this.destroy();this.init(b);b.rangeSelector.render()},destroy:function(){var a=this,b=a.minInput,c=a.maxInput;a.unMouseDown();a.unResize();H(a.buttons);b&&(b.onfocus=b.onblur=b.onchange=null);c&&(c.onfocus=c.onblur=c.onchange=null);C(a,function(b,c){b&&"chart"!==
c&&(b.destroy?b.destroy():b.nodeType&&z(this[c]));b!==D.prototype[c]&&(a[c]=null)},this)}};q.prototype.minFromRange=function(){var a=this.range,b={month:"Month",year:"FullYear"}[a.type],c=this.max,d=this.chart.time,e=function(a,c){var e=new d.Date(a),g=d.get(b,e);d.set(b,e,g+c);g===d.get(b,e)&&d.set("Date",e,0);return e.getTime()-a};if(x(a)){var g=c-a;var f=a}else g=c+e(c,-a.count),this.chart&&(this.chart.fixedRange=c-g);var h=E(this.dataMin,Number.MIN_VALUE);x(g)||(g=h);g<=h&&(g=h,void 0===f&&(f=
e(g,a.count)),this.newMax=Math.min(g+f,this.dataMax));x(c)||(g=void 0);return g};c.RangeSelector||(p(e,"afterGetContainer",function(){this.options.rangeSelector.enabled&&(this.rangeSelector=new D(this))}),p(e,"beforeRender",function(){var a=this.axes,b=this.rangeSelector;b&&(x(b.deferredYTDClick)&&(b.clickButton(b.deferredYTDClick),delete b.deferredYTDClick),a.forEach(function(a){a.updateNames();a.setScale()}),this.getAxisMargins(),b.render(),a=b.options.verticalAlign,b.options.floating||("bottom"===
a?this.extraBottomMargin=!0:"middle"!==a&&(this.extraTopMargin=!0)))}),p(e,"update",function(a){var b=a.options.rangeSelector;a=this.rangeSelector;var c=this.extraBottomMargin,d=this.extraTopMargin;b&&b.enabled&&!G(a)&&(this.options.rangeSelector.enabled=!0,this.rangeSelector=new D(this));this.extraTopMargin=this.extraBottomMargin=!1;a&&(a.render(),b=b&&b.verticalAlign||a.options&&a.options.verticalAlign,a.options.floating||("bottom"===b?this.extraBottomMargin=!0:"middle"!==b&&(this.extraTopMargin=
!0)),this.extraBottomMargin!==c||this.extraTopMargin!==d)&&(this.isDirtyBox=!0)}),p(e,"render",function(){var a=this.rangeSelector;a&&!a.options.floating&&(a.render(),a=a.options.verticalAlign,"bottom"===a?this.extraBottomMargin=!0:"middle"!==a&&(this.extraTopMargin=!0))}),p(e,"getMargins",function(){var a=this.rangeSelector;a&&(a=a.getHeight(),this.extraTopMargin&&(this.plotTop+=a),this.extraBottomMargin&&(this.marginBottom+=a))}),e.prototype.callbacks.push(function(a){function b(){c=a.xAxis[0].getExtremes();
x(c.min)&&d.render(c.min,c.max)}var c,d=a.rangeSelector;if(d){var e=p(a.xAxis[0],"afterSetExtremes",function(a){d.render(a.min,a.max)});var g=p(a,"redraw",b);b()}p(a,"destroy",function(){d&&(g(),e())})}),c.RangeSelector=D)});K(D,"parts/StockChart.js",[D["parts/Globals.js"],D["parts/Utilities.js"]],function(c,e){var D=e.arrayMax,G=e.arrayMin,H=e.defined,z=e.extend,t=e.isNumber,x=e.isString,C=e.pick,E=e.splat;e=c.addEvent;var w=c.Axis,m=c.Chart,p=c.format,q=c.merge,h=c.Point,a=c.Renderer,b=c.Series,
d=c.SVGRenderer,f=c.VMLRenderer,l=b.prototype,F=l.init,y=l.processData,r=h.prototype.tooltipFormatter;c.StockChart=c.stockChart=function(a,b,d){var e=x(a)||a.nodeName,g=arguments[e?1:0],f=g,k=g.series,h=c.getOptions(),l,n=C(g.navigator&&g.navigator.enabled,h.navigator.enabled,!0),p=n?{startOnTick:!1,endOnTick:!1}:null;g.xAxis=E(g.xAxis||{}).map(function(a,b){return q({minPadding:0,maxPadding:0,overscroll:0,ordinal:!0,title:{text:null},labels:{overflow:"justify"},showLastLabel:!0},h.xAxis,h.xAxis&&
h.xAxis[b],a,{type:"datetime",categories:null},p)});g.yAxis=E(g.yAxis||{}).map(function(a,b){l=C(a.opposite,!0);return q({labels:{y:-2},opposite:l,showLastLabel:!(!a.categories&&"category"!==a.type),title:{text:null}},h.yAxis,h.yAxis&&h.yAxis[b],a)});g.series=null;g=q({chart:{panning:!0,pinchType:"x"},navigator:{enabled:n},scrollbar:{enabled:C(h.scrollbar.enabled,!0)},rangeSelector:{enabled:C(h.rangeSelector.enabled,!0)},title:{text:null},tooltip:{split:C(h.tooltip.split,!0),crosshairs:!0},legend:{enabled:!1}},
g,{isStock:!0});g.series=f.series=k;return e?new m(a,g,d):new m(g,b)};e(b,"setOptions",function(a){function b(a){return c.seriesTypes[a]&&d instanceof c.seriesTypes[a]}var d=this,e;this.chart.options.isStock&&(b("column")||b("columnrange")?e={borderWidth:0,shadow:!1}:!b("line")||b("scatter")||b("sma")||(e={marker:{enabled:!1,radius:2}}),e&&(a.plotOptions[this.type]=q(a.plotOptions[this.type],e)))});e(w,"autoLabelAlign",function(a){var b=this.chart,c=this.options;b=b._labelPanes=b._labelPanes||{};
var d=this.options.labels;this.chart.options.isStock&&"yAxis"===this.coll&&(c=c.top+","+c.height,!b[c]&&d.enabled&&(15===d.x&&(d.x=0),void 0===d.align&&(d.align="right"),b[c]=this,a.align="right",a.preventDefault()))});e(w,"destroy",function(){var a=this.chart,b=this.options&&this.options.top+","+this.options.height;b&&a._labelPanes&&a._labelPanes[b]===this&&delete a._labelPanes[b]});e(w,"getPlotLinePath",function(a){function b(a){var b="xAxis"===a?"yAxis":"xAxis";a=d.options[b];return t(a)?[f[b][a]]:
x(a)?[f.get(a)]:e.map(function(a){return a[b]})}var d=this,e=this.isLinked&&!this.series?this.linkedParent.series:this.series,f=d.chart,h=f.renderer,l=d.left,m=d.top,n,p,q,r,w=[],y=[],z=a.translatedValue,D=a.value,E=a.force;if(f.options.isStock&&!1!==a.acrossPanes&&"xAxis"===d.coll||"yAxis"===d.coll){a.preventDefault();y=b(d.coll);var F=d.isXAxis?f.yAxis:f.xAxis;F.forEach(function(a){if(H(a.options.id)?-1===a.options.id.indexOf("navigator"):1){var b=a.isXAxis?"yAxis":"xAxis";b=H(a.options[b])?f[b][a.options[b]]:
f[b][0];d===b&&y.push(a)}});var G=y.length?[]:[d.isXAxis?f.yAxis[0]:f.xAxis[0]];y.forEach(function(a){-1!==G.indexOf(a)||c.find(G,function(b){return b.pos===a.pos&&b.len===a.len})||G.push(a)});var I=C(z,d.translate(D,null,null,a.old));t(I)&&(d.horiz?G.forEach(function(a){var b;p=a.pos;r=p+a.len;n=q=Math.round(I+d.transB);"pass"!==E&&(n<l||n>l+d.width)&&(E?n=q=Math.min(Math.max(l,n),l+d.width):b=!0);b||w.push("M",n,p,"L",q,r)}):G.forEach(function(a){var b;n=a.pos;q=n+a.len;p=r=Math.round(m+d.height-
I);"pass"!==E&&(p<m||p>m+d.height)&&(E?p=r=Math.min(Math.max(m,p),d.top+d.height):b=!0);b||w.push("M",n,p,"L",q,r)}));a.path=0<w.length?h.crispPolyLine(w,a.lineWidth||1):null}});d.prototype.crispPolyLine=function(a,b){var c;for(c=0;c<a.length;c+=6)a[c+1]===a[c+4]&&(a[c+1]=a[c+4]=Math.round(a[c+1])-b%2/2),a[c+2]===a[c+5]&&(a[c+2]=a[c+5]=Math.round(a[c+2])+b%2/2);return a};a===f&&(f.prototype.crispPolyLine=d.prototype.crispPolyLine);e(w,"afterHideCrosshair",function(){this.crossLabel&&(this.crossLabel=
this.crossLabel.hide())});e(w,"afterDrawCrosshair",function(a){var b,c;if(H(this.crosshair.label)&&this.crosshair.label.enabled&&this.cross){var d=this.chart,e=this.options.crosshair.label,f=this.horiz,h=this.opposite,l=this.left,m=this.top,n=this.crossLabel,q=e.format,r="",t="inside"===this.options.tickPosition,w=!1!==this.crosshair.snap,x=0,y=a.e||this.cross&&this.cross.e,D=a.point;var E=this.lin2log;if(this.isLog){a=E(this.min);var F=E(this.max)}else a=this.min,F=this.max;E=f?"center":h?"right"===
this.labelAlign?"right":"left":"left"===this.labelAlign?"left":"center";n||(n=this.crossLabel=d.renderer.label(null,null,null,e.shape||"callout").addClass("highcharts-crosshair-label"+(this.series[0]&&" highcharts-color-"+this.series[0].colorIndex)).attr({align:e.align||E,padding:C(e.padding,8),r:C(e.borderRadius,3),zIndex:2}).add(this.labelGroup),d.styledMode||n.attr({fill:e.backgroundColor||this.series[0]&&this.series[0].color||"#666666",stroke:e.borderColor||"","stroke-width":e.borderWidth||0}).css(z({color:"#ffffff",
fontWeight:"normal",fontSize:"11px",textAlign:"center"},e.style)));f?(E=w?D.plotX+l:y.chartX,m+=h?0:this.height):(E=h?this.width+l:0,m=w?D.plotY+m:y.chartY);q||e.formatter||(this.isDatetimeAxis&&(r="%b %d, %Y"),q="{value"+(r?":"+r:"")+"}");r=w?D[this.isXAxis?"x":"y"]:this.toValue(f?y.chartX:y.chartY);n.attr({text:q?p(q,{value:r},d.time):e.formatter.call(this,r),x:E,y:m,visibility:r<a||r>F?"hidden":"visible"});e=n.getBBox();if(f){if(t&&!h||!t&&h)m=n.y-e.height}else m=n.y-e.height/2;f?(b=l-e.x,c=l+
this.width-e.x):(b="left"===this.labelAlign?l:0,c="right"===this.labelAlign?l+this.width:d.chartWidth);n.translateX<b&&(x=b-n.translateX);n.translateX+e.width>=c&&(x=-(n.translateX+e.width-c));n.attr({x:E+x,y:m,anchorX:f?E:this.opposite?0:d.chartWidth,anchorY:f?this.opposite?d.chartHeight:0:m+e.height/2})}});l.init=function(){F.apply(this,arguments);this.setCompare(this.options.compare)};l.setCompare=function(a){this.modifyValue="value"===a||"percent"===a?function(b,c){var d=this.compareValue;return void 0!==
b&&void 0!==d?(b="value"===a?b-d:b/d*100-(100===this.options.compareBase?0:100),c&&(c.change=b),b):0}:null;this.userOptions.compare=a;this.chart.hasRendered&&(this.isDirty=!0)};l.processData=function(a){var b,c=-1,d=!0===this.options.compareStart?0:1;y.apply(this,arguments);if(this.xAxis&&this.processedYData){var e=this.processedXData;var f=this.processedYData;var h=f.length;this.pointArrayMap&&(c=this.pointArrayMap.indexOf(this.options.pointValKey||this.pointValKey||"y"));for(b=0;b<h-d;b++){var l=
f[b]&&-1<c?f[b][c]:f[b];if(t(l)&&e[b+d]>=this.xAxis.min&&0!==l){this.compareValue=l;break}}}};e(b,"afterGetExtremes",function(){if(this.modifyValue){var a=[this.modifyValue(this.dataMin),this.modifyValue(this.dataMax)];this.dataMin=G(a);this.dataMax=D(a)}});w.prototype.setCompare=function(a,b){this.isXAxis||(this.series.forEach(function(b){b.setCompare(a)}),C(b,!0)&&this.chart.redraw())};h.prototype.tooltipFormatter=function(a){a=a.replace("{point.change}",(0<this.change?"+":"")+c.numberFormat(this.change,
C(this.series.tooltipOptions.changeDecimals,2)));return r.apply(this,[a])};e(b,"render",function(){var a=this.chart;if(!(a.is3d&&a.is3d()||a.polar)&&this.xAxis&&!this.xAxis.isRadial){var b=this.yAxis.len;if(this.xAxis.axisLine){var c=a.plotTop+a.plotHeight-this.yAxis.pos-this.yAxis.len,d=Math.floor(this.xAxis.axisLine.strokeWidth()/2);0<=c&&(b-=Math.max(d-c,0))}!this.clipBox&&this.animate?(this.clipBox=q(a.clipBox),this.clipBox.width=this.xAxis.len,this.clipBox.height=b):a[this.sharedClipKey]&&(a[this.sharedClipKey].animate({width:this.xAxis.len,
height:b}),a[this.sharedClipKey+"m"]&&a[this.sharedClipKey+"m"].animate({width:this.xAxis.len}))}});e(m,"update",function(a){a=a.options;"scrollbar"in a&&this.navigator&&(q(!0,this.options.scrollbar,a.scrollbar),this.navigator.update({},!1),delete a.scrollbar)})});K(D,"masters/modules/stock.src.js",[],function(){});K(D,"masters/highstock.src.js",[D["masters/highcharts.src.js"]],function(c){c.product="Highstock";return c});D["masters/highstock.src.js"]._modules=D;return D["masters/highstock.src.js"]});
//# sourceMappingURL=highstock.js.map

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(3), __webpack_require__(388), __webpack_require__(43)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, constant_module_1, signalr_hub_1, environment_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [signalr_hub_1.default, environment_1.default];
    exports.default = angular.module('aps.services.hubs', requires)
        .service('hubService', ["Hub", "environment", function (Hub, environment) {
        var defaultOptions = {
            rootPath: environment.API_PATH + constant_module_1.Endpoints.SIGNALR,
            logging: true
        };
        function createHub(name, options) {
            return (new Hub(_.defaults(options || {}, {
                name: name
            }, defaultOptions)));
        }
        return {
            createHub: createHub
        };
    }]).name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(5), __webpack_require__(0), __webpack_require__(400), __webpack_require__(401), __webpack_require__(32), __webpack_require__(6), __webpack_require__(4), __webpack_require__(30), __webpack_require__(23), __webpack_require__(7), __webpack_require__(3), __webpack_require__(2), __webpack_require__(1), __webpack_require__(54), __webpack_require__(8), __webpack_require__(47), __webpack_require__(25)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, aps_enums_1, angular, fillOutCheckList_tpl_html_1, checkListInstance_1, checkListInstances_service_1, notify_service_1, loader_service_1, checkLists_service_1, shops_service_1, authData_service_1, constant_module_1, _, moment, locations_service_1, navigation_service_1, toolChange_service_1, defectType_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [checkListInstances_service_1.default, notify_service_1.default, loader_service_1.default, checkLists_service_1.default,
        shops_service_1.default, authData_service_1.default, locations_service_1.default, navigation_service_1.default, toolChange_service_1.default,
        defectType_service_1.default];
    function openFillOutCheckList(data, $modal) {
        return $modal.open({
            template: fillOutCheckList_tpl_html_1.default,
            controller: 'FillOutCheckListCtrl as vm',
            resolve: {
                params: function () { return data; }
            }
        }).result;
    }
    exports.openFillOutCheckList = openFillOutCheckList;
    var FillOutCheckListCtrl = (function () {
        FillOutCheckListCtrl.$inject = ["checkListsService", "checkListInstancesService", "shopService", "locationsService", "navigationService", "toolChangeService", "notifyService", "loaderService", "$modalInstance", "$q", "$rootScope", "params", "$stateParams", "defectTypeService", "authDataService"];
        function FillOutCheckListCtrl(checkListsService, checkListInstancesService, shopService, locationsService, navigationService, toolChangeService, notifyService, loaderService, $modalInstance, $q, $rootScope, params, $stateParams, defectTypeService, authDataService) {
            var _this = this;
            this.toolChangeService = toolChangeService;
            this.checkStatus = aps_enums_1.apsEnums.CheckStatus;
            this.checkAdditionalData = aps_enums_1.apsEnums.CheckAdditionalData;
            this.authDataService = authDataService;
            this.checkListInstancesService = checkListInstancesService;
            this.$rootScope = $rootScope;
            this.notifyService = notifyService;
            this.loaderService = loaderService;
            this.$modalInstance = $modalInstance;
            this.statusOptions = _.values(constant_module_1.Enums.CHECK_STATUS);
            this.readOnly = params.readOnly;
            this.preview = params.preview;
            var checkListId = params.checkListId;
            var instanceId = params.instanceId;
            this.plantLocationId = params.plantLocationId;
            var scheduledOn = params.scheduledOn;
            this.plantId = params.plantId;
            this.shopId = $stateParams.shopId;
            this.scheduledOn = moment(params.scheduledOn).format("YYYY-MM-DDTHH:mm:ss");
            this.instanceId = params.instanceId;
            this.userId = $stateParams.userId;
            this.$modalInstance.result.catch(function (ex) {
                _this.cancel();
            });
            var promises = [];
            promises.push(shopService.getPlants()
                .then(function (plants) {
                _this.plant = _.find(plants, { id: params.plantId });
                if (_this.plant) {
                    _this.timeZone = _this.plant.timeZoneId;
                }
            }));
            if (params.shopId) {
                promises.push(shopService.getShopConfiguration(params.shopId)
                    .then(function (shop) {
                    _this.shop = shop;
                }));
            }
            if (params.plantLocationId) {
                promises.push(navigationService.getLocations(false)
                    .then(function (locations) {
                    _this.plantLocation = _.find(locations, { id: params.plantLocationId });
                }));
            }
            promises.push(checkListsService.getCheckListToFillOut(checkListId, params.plantId, params.shopId)
                .then(function (checkList) {
                _this.checkList = checkList;
                if (!checkList) {
                    _this.disabled = true;
                }
            }));
            var setJobRun = function (date) {
                var time = date.getTime();
                _this.jobRun = _.find(_this.shop.jobRuns, function (jr) {
                    return jr.startDate.getTime() <= time && (!jr.endDate || jr.endDate.getTime() > time);
                });
            };
            promises.push(defectTypeService.getDefectTypesAndClassifications()
                .then(function (data) { return _this.allDefectTypes = data; }));
            var loadAll = $q.all(promises)
                .then(function () {
                if (_this.disabled) {
                    return;
                }
                if (instanceId) {
                    return _this.checkListInstancesService.getCheckListInstance(instanceId, _this.plantLocationId, scheduledOn)
                        .then(function (instance) {
                        var checkListInstance = new checkListInstance_1.default(instance);
                        checkListInstance.populateResults(_this.checkList, _this.plant, _this.shop, _this.authDataService);
                        var _loop_1 = function (previous) {
                            var checks = checkListInstance.results.filter(function (x) { return x.checkId === previous.checkId; });
                            for (var _i = 0, checks_1 = checks; _i < checks_1.length; _i++) {
                                var check = checks_1[_i];
                                check.onChange(checkListInstance);
                            }
                        };
                        for (var _i = 0, _a = instance.previousCheckInstances; _i < _a.length; _i++) {
                            var previous = _a[_i];
                            _loop_1(previous);
                        }
                        if (!_.isUndefined(params.itemStatusFilter)) {
                            checkListInstance.results = _.filter(checkListInstance.results, function (c) {
                                return c.status === params.itemStatusFilter;
                            });
                        }
                        if (checkListInstance.status >= aps_enums_1.apsEnums.CheckListStatus.Complete) {
                            var roleLocation = authDataService.getSelectedRoleLocation();
                            var roleId = roleLocation.role.roleId;
                            if (!authDataService.isPlantAdmin(params.plantId)
                                && _this.checkList.roleId !== roleId
                                && !_.includes(_this.checkList.allowedRoles, roleId)) {
                                _this.readOnly = true;
                            }
                        }
                        _this.preFillCheckStatus(checkListInstance);
                        _this.setDefectTypes(checkListInstance);
                        _this.instance = checkListInstance;
                        setJobRun(instance.scheduledOn || new Date());
                        _this.getMolds();
                    });
                }
                else if (!_this.checkList.isScheduled || params.preview) {
                    return checkListsService.getCheckListMandatory(_this.checkList.id, params.plantId, params.shopId)
                        .then(function (checkListMandatory) {
                        var roleLocation = authDataService.getSelectedRoleLocation();
                        var roleId = roleLocation.role.roleId;
                        var checkListInstance = new checkListInstance_1.default({
                            id: null,
                            checkListId: _this.checkList.id,
                            plantId: params.plantId,
                            tankId: params.tankId,
                            shopId: params.shopId,
                            checkInstances: [],
                            status: aps_enums_1.apsEnums.CheckListStatus.Pending,
                            isMandatory: checkListMandatory ? checkListMandatory.isMandatory : false,
                            scheduledOn: null,
                            expiresOn: null,
                            signedOff: false,
                            signedOffById: null,
                            signedOffOn: null,
                            locationType: _this.checkList.locationType,
                            locationId: _this.checkList.locationId,
                            checkListIsGroup: false,
                            checkListName: _this.checkList.name,
                            result: aps_enums_1.apsEnums.CheckListResult.Incomplete,
                            hasFailures: false,
                            roleId: roleId,
                            plantLocationId: params.plantLocationId,
                            previousCheckInstances: []
                        });
                        if (_this.checkList.locationType !== aps_enums_1.apsEnums.LocationType.Tank
                            && _this.checkList.locationType !== aps_enums_1.apsEnums.LocationType.Shop) {
                            checkListInstance.tankId = null;
                            checkListInstance.shopId = null;
                        }
                        else if (_this.checkList.locationType !== aps_enums_1.apsEnums.LocationType.Shop) {
                            checkListInstance.shopId = null;
                        }
                        checkListInstance.populateResults(_this.checkList, _this.plant, _this.shop, _this.authDataService);
                        _this.preFillCheckStatus(checkListInstance);
                        _this.setDefectTypes(checkListInstance);
                        _this.instance = checkListInstance;
                        setJobRun(new Date());
                        _this.getMolds();
                    });
                }
                else {
                    _this.notifyService.error('Cannot create new instance of a scheduled check list');
                    _this.$modalInstance.close();
                }
            });
            this.loaderService.loadingPromise(loadAll);
        }
        FillOutCheckListCtrl.prototype.preFillCheckStatus = function (checkListInstance) {
            _.forEach(checkListInstance.results, function (r) {
                if (checkListInstance.status < aps_enums_1.apsEnums.CheckListStatus.Complete && !checkListInstance.isMandatory && !r.status) {
                    r.status = aps_enums_1.apsEnums.CheckStatus.NotDone;
                }
            });
        };
        FillOutCheckListCtrl.prototype.getMolds = function () {
            var _this = this;
            if (!this.instance.shopId) {
                return;
            }
            if (this.instance.results.filter(function (x) { return x.checkItem.entry === aps_enums_1.apsEnums.CheckEntry.PerCavity; }).length === 0) {
                return;
            }
            this.toolChangeService.getToolMolds(this.instance.shopId, this.instance.scheduledOn || new Date())
                .then(function (molds) { return _this.molds = molds; });
        };
        FillOutCheckListCtrl.prototype.calcTonnage = function (index) {
            var i = 0;
            var totalSeconds = 0;
            var ounces = 0.0;
            var totalPounds = 0.0;
            var totalOunces = 0.0;
            var totalTons = 0.0;
            var numberofrecords = this.instance.results.length;
            if (numberofrecords > 4) {
                _.forEach(this.instance.results, function (r) {
                    if (i === (2 - (index % 2))) {
                        ounces = r.result;
                    }
                    if (i === (4 - (index % 2))) {
                        totalSeconds = r.result * 60;
                    }
                    i++;
                });
                if (!isNaN(totalSeconds)) {
                    totalOunces = (totalSeconds / 5) * ounces;
                    totalPounds = totalOunces / 16;
                    totalTons = totalPounds / 2000;
                    i = 0;
                    _.forEach(this.instance.results, function (r) {
                        if (i === (6 - (index % 2))) {
                            r.result = totalTons.toFixed(2);
                        }
                        i++;
                    });
                }
            }
            else {
                _.forEach(this.instance.results, function (r) {
                    if (i === 1) {
                        ounces = r.result;
                    }
                    if (i === 2) {
                        totalSeconds = r.result * 60;
                    }
                    i++;
                });
                if (!isNaN(totalSeconds)) {
                    totalOunces = (totalSeconds / 5) * ounces;
                    totalPounds = totalOunces / 16;
                    totalTons = totalPounds / 2000;
                    i = 0;
                    _.forEach(this.instance.results, function (r) {
                        if (i === 3) {
                            r.result = totalTons.toFixed(2);
                        }
                        i++;
                    });
                }
            }
        };
        FillOutCheckListCtrl.prototype.submit = function () {
            var _this = this;
            if (this.form.$invalid) {
                var invalidElement = angular.element('input.ng-invalid').first();
                if (invalidElement.length === 1) {
                    var top = angular.element('body').scrollTop();
                    var offset = invalidElement.offset();
                    if (offset.top < (top - 50)) {
                        angular.element('body').animate({ scrollTop: offset.top - 50 });
                    }
                    invalidElement.focus();
                }
                return;
            }
            if (_.some(this.instance.results, function (r) { return r.isStatusInvalid(); })) {
                return;
            }
            _.forEach(this.instance.results, function (r) {
                r.prepareForSubmit();
                if (r.aggregateValues && r.aggregateValues.length > 0) {
                    var check = r.check();
                    if (check.valueType === aps_enums_1.apsEnums.CheckValueType.MultipleSample) {
                        r.result = _.map(check.dimensions, function (d) { return r.aggregateResult(d); }).join(',');
                    }
                    else {
                        r.result = r.aggregateResult();
                    }
                }
            });
            var command = _.clone(this.instance);
            command.results = _.filter(command.results, function (x) {
                return x.check().dataType !== aps_enums_1.apsEnums.CheckDataType.Instructions;
            });
            if (_.some(command.results, { status: aps_enums_1.apsEnums.CheckStatus.NotDone })) {
                if (!confirm('There are incomplete checks. Do you want to submit?')) {
                    return;
                }
            }
            if (this.preview) {
                this.$modalInstance.close();
                this.broadcastMessage(constant_module_1.BroadcastMessages.FILL_OUT_CHECKLIST_CANCELLED, {});
                return;
            }
            if (command.plantId === '00000000-0000-0000-0000-000000000000' && this.plantLocation) {
                command.plantId = this.plantLocation.plantId;
                command.tankId = this.plantLocation.tankId;
                command.shopId = this.plantLocation.shopId;
                command.plantLocationId = this.plantLocation.id;
            }
            this.loaderService.loadingPromise(this.checkListInstancesService.saveCheckListInstance(command)
                .then(function () {
                _this.notifyService.success('Check List Results Saved!');
                _this.$modalInstance.close(command);
            }, this.notifyService.handleApiErrors));
        };
        FillOutCheckListCtrl.prototype.broadcastMessage = function (messageTitle, options) {
            this.$rootScope.$emit(messageTitle, options);
        };
        FillOutCheckListCtrl.prototype.cancel = function () {
            this.$modalInstance.close();
            this.broadcastMessage(constant_module_1.BroadcastMessages.FILL_OUT_CHECKLIST_CANCELLED, {});
        };
        FillOutCheckListCtrl.prototype.setDefectTypes = function (checkListInstance) {
            if (!this.allDefectTypes) {
                return;
            }
            var _loop_2 = function (checkInstance) {
                if (checkInstance.checkItem.dataType !== aps_enums_1.apsEnums.CheckDataType.DefectType) {
                    checkInstance.defectTypes = [];
                    return "continue";
                }
                var defectTypes = this_1.allDefectTypes.types;
                var severity = checkInstance.checkItem.defectTypeSeverity;
                if (severity !== null) {
                    defectTypes = defectTypes.filter(function (x) { return x.severity === severity; });
                }
                checkInstance.defectTypes = defectTypes.sort(function (x, y) { return x.name.localeCompare(y.name); });
            };
            var this_1 = this;
            for (var _i = 0, _a = checkListInstance.results; _i < _a.length; _i++) {
                var checkInstance = _a[_i];
                _loop_2(checkInstance);
            }
            ;
        };
        FillOutCheckListCtrl.prototype.updateStatus = function (checkInstance, status, index) {
            if (this.readOnly) {
                return;
            }
            var check = checkInstance.check();
            var isBoolean = (check.dataType === aps_enums_1.apsEnums.CheckDataType.Boolean);
            if (check && status === aps_enums_1.apsEnums.CheckStatus.NotApplicable && (check.name === '{streamingtime}' || check.name === '{shovelweight}')) {
                checkInstance.validationRangeMin = 0;
                checkInstance.result = 0;
            }
            else {
                checkInstance.validationRangeMin = check.rangeMin;
            }
            if (checkInstance.status === status) {
                if (check && status === aps_enums_1.apsEnums.CheckStatus.NotApplicable && (check.name === '{streamingtime}' || check.name === '{shovelweight}')) {
                    checkInstance.validationRangeMin = check.rangeMin;
                }
                checkInstance.status = aps_enums_1.apsEnums.CheckStatus.NotDone;
                if (isBoolean) {
                    checkInstance.result = null;
                }
            }
            else {
                checkInstance.status = status;
                if (isBoolean) {
                    if (checkInstance.status === aps_enums_1.apsEnums.CheckStatus.NotApplicable) {
                        checkInstance.result = 'N/A';
                    }
                    else if (check.booleanPass !== null) {
                        if (checkInstance.status === aps_enums_1.apsEnums.CheckStatus.Passed) {
                            checkInstance.result = check.booleanPass.toString();
                        }
                        else if (checkInstance.status === aps_enums_1.apsEnums.CheckStatus.Failed) {
                            checkInstance.result = (!check.booleanPass).toString();
                        }
                    }
                }
            }
            if (this.checkList.name === 'Hourly Downtime') {
                this.calcTonnage(index);
            }
        };
        return FillOutCheckListCtrl;
    }());
    exports.default = angular.module('aps.controller.fillOutCheckList', requires)
        .controller('FillOutCheckListCtrl', FillOutCheckListCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var environment;
    var environmentJson = JSON.parse(ENVIRONMENT_JSON);
    environment = {
        'ENV_TYPE': environmentJson.ENV_TYPE,
        'API_PATH': environmentJson.API_PATH,
        'VERSION': environmentJson.VERSION,
        'NAME': environmentJson.NAME,
        'HIGHLIGHT': environmentJson.HIGHLIGHT,
        'APP_INSIGHTS_KEY': environmentJson.APP_INSIGHTS_KEY,
        'EightyToolset': environmentJson.EightyToolset,
        'OneSixtyToolSet': environmentJson.OneSixtyToolSet
    };
    exports.default = angular.module("aps.environment", [])
        .constant("environment", environment)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ToolChangeServiceImpl = (function () {
        ToolChangeServiceImpl.$inject = ["httpService"];
        function ToolChangeServiceImpl(httpService) {
            this.httpService = httpService;
        }
        ToolChangeServiceImpl.prototype.getToolsAndTypes = function () {
            return this.httpService.get(constant_module_1.Endpoints.TOOLS_AND_TYPES);
        };
        ToolChangeServiceImpl.prototype.addToolChange = function (command) {
            return this.httpService.post(constant_module_1.Endpoints.TOOL, command);
        };
        ToolChangeServiceImpl.prototype.getSectionChange = function (id, sectionId, shopId) {
            return this.httpService.get(constant_module_1.Endpoints.SECTION_CHANGE + '/' + id, { shopId: shopId, sectionId: sectionId });
        };
        ToolChangeServiceImpl.prototype.deleteToolChange = function (command) {
            return this.httpService.delete(constant_module_1.Endpoints.TOOL + '/' + command.id);
        };
        ToolChangeServiceImpl.prototype.addComment = function (command) {
            return this.httpService.post(constant_module_1.Endpoints.TOOL_COMMENT, command);
        };
        ToolChangeServiceImpl.prototype.getToolMolds = function (shopId, time) {
            return this.httpService.get(constant_module_1.Endpoints.TOOL_MOLDS, { shopId: shopId, time: time });
        };
        ToolChangeServiceImpl.prototype.getToolChange = function (id) {
            return this.httpService.get(constant_module_1.Endpoints.TOOL + '/' + id);
        };
        ToolChangeServiceImpl.prototype.editToolChange = function (command) {
            return this.httpService.put(constant_module_1.Endpoints.TOOL, command);
        };
        return ToolChangeServiceImpl;
    }());
    exports.default = angular
        .module('aps.services.toolChange', [http_service_1.default])
        .service('toolChangeService', ToolChangeServiceImpl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(26), __webpack_require__(4), __webpack_require__(453)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, counts_service_1, loader_service_1, equipmentGroupRejects_controller_1) {
    "use strict";
    groupRejectsService.$inject = ["$q", "$modal", "countsService", "loaderService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [counts_service_1.default, loader_service_1.default, equipmentGroupRejects_controller_1.default];
    exports.default = angular
        .module('aps.services.groupRejects', requires)
        .service('groupRejectsService', groupRejectsService)
        .name;
    function groupRejectsService($q, $modal, countsService, loaderService) {
        function showGroupRejects(data) {
            var modalPromise = $q.when();
            var hasTabs = false;
            var hasDetails = false;
            for (var key in data.equipmentGroup.equipment) {
                var equipment = data.equipmentGroup.equipment[key];
                if (equipment.hasTabs) {
                    hasTabs = true;
                    break;
                }
                else if (equipment.detailDataPoints && equipment.detailDataPoints.length > 0) {
                    hasDetails = true;
                    break;
                }
            }
            if (hasTabs || hasDetails) {
                modalPromise = countsService.getGroupEquipmentCounts(data.shopId, data.lineCounts, data.equipmentGroup, data.countsInterval)
                    .then(function (counts) {
                    data.lineCounts.currentDetailCounts = counts;
                });
                loaderService.loadingPromise(modalPromise);
            }
            modalPromise.then(function () {
                data.lineCounts.currentGroup = data.equipmentGroup;
                var result = equipmentGroupRejects_controller_1.openEquipmentGroupRejects({
                    equipmentGroup: data.equipmentGroup,
                    shopId: data.shopId,
                    detail: data.lineCounts.currentDetailCounts,
                    lines: data.lineCounts.lines,
                    timeZoneId: data.lineCounts.shopConfig.timeZoneId
                }, $modal);
                result.then(function () {
                    if (data.lineCounts.currentDetailCounts) {
                        delete data.lineCounts.currentDetailCounts;
                    }
                    if (data.lineCounts.currentGroup) {
                        if (data.lineCounts.currentGroup.rejects) {
                            delete data.lineCounts.currentGroup.rejects;
                        }
                        data.lineCounts.currentGroup = null;
                    }
                });
            });
        }
        return {
            showGroupRejects: showGroupRejects
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Interval = (function () {
        function Interval(callBack, $interval, intervalTime) {
            if (intervalTime === void 0) { intervalTime = 60 * 1000; }
            this.stop = null;
            this.interval = null;
            this.intervalTime = null;
            this.interval = $interval;
            this.intervalTime = intervalTime;
            this.callBack = callBack;
        }
        Interval.prototype.trigger = function () {
            if (this.callBack) {
                try {
                    this.callBack();
                }
                catch (err) {
                    console.log(err);
                }
            }
        };
        Interval.prototype.start = function () {
            if (!this.stop) {
                this.stop = this.interval(angular.bind(this, this.trigger), this.intervalTime);
            }
        };
        Interval.prototype.destroy = function () {
            if (angular.isDefined(this.stop)) {
                this.interval.cancel(this.stop);
                this.callBack = null;
                this.stop = undefined;
            }
        };
        return Interval;
    }());
    exports.Interval = Interval;
    exports.default = angular
        .module('intervalFactory', [])
        .factory('intervalFactory', ["$interval", function ($interval) {
            return Interval;
        }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 51 */,
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.services.users', [http_service_1.default])
        .service('userService', ["httpService", function (httpService) {
        return {
            getUsers: getUsers,
            getUser: getUser,
            changePassword: changePassword,
            getGeneratedUserName: getGeneratedUserName,
            getRoles: getRoles,
            getAssignableRoles: getAssignableRoles,
            getSecurityQuestions: getSecurityQuestions,
            addUser: addUser,
            editUser: editUser,
            getUserProfile: getUserProfile,
            saveUserProfile: saveUserProfile,
            getUsersToNotify: getUsersToNotify
        };
        function getUsers(plantId, roleId, includeDeleted) {
            return httpService.get(constant_module_1.Endpoints.USERS, {
                plantId: plantId,
                roleId: roleId,
                includeDeleted: includeDeleted
            });
        }
        function getUsersToNotify() {
            return httpService.get(constant_module_1.Endpoints.USERS_NOTIFY);
        }
        function getUser(id) {
            return httpService.get(constant_module_1.Endpoints.USERS + '/' + id);
        }
        function getSecurityQuestions() {
            return httpService.get(constant_module_1.Endpoints.SECURITY_QUESTIONS);
        }
        function addUser(user) {
            return httpService.post(constant_module_1.Endpoints.USERS, user);
        }
        function editUser(user) {
            return httpService.put(constant_module_1.Endpoints.USERS, user);
        }
        function getUserProfile() {
            return httpService.get(constant_module_1.Endpoints.USERPROFILE);
        }
        function saveUserProfile(data) {
            return httpService.post(constant_module_1.Endpoints.USERPROFILE, data);
        }
        function getRoles() {
            return httpService.get(constant_module_1.Endpoints.ROLES);
        }
        function getAssignableRoles() {
            return httpService.get(constant_module_1.Endpoints.ROLES_ASSIGNABLE);
        }
        function getGeneratedUserName(id, firstName, lastName) {
            return httpService.get(constant_module_1.Endpoints.USER_GENERATED_USERNAME + '/' + id, {
                firstName: firstName,
                lastName: lastName
            });
        }
        function changePassword(changePassword) {
            return httpService.post(constant_module_1.Endpoints.USER_CHANGE_PASSWORD, changePassword);
        }
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(7), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, authData_service_1, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.services.auth', [http_service_1.default, authData_service_1.default])
        .service('authService', ["$q", "$window", "httpService", "authDataService", function ($q, $window, httpService, authDataService) {
        function login(username, password, code) {
            var request = 'grant_type=password' +
                '&username=' + encodeURIComponent(username) +
                '&password=' + encodeURIComponent(password);
            if (code != null)
                request = request + '&scope=' + code;
            return httpService.postRequest(constant_module_1.Endpoints.POST_TOKEN, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                data: request
            })
                .then(function (data) {
                authDataService.setUserId(data.userId);
                authDataService.setToken(data['access_token']);
                return httpService.get(constant_module_1.Endpoints.USER_ROLES).then(function (roles) {
                    authDataService.setRoles(roles);
                });
            });
        }
        function getUserData() {
            var data = authDataService.getUserData();
            if (data) {
                return $q.when(data);
            }
            var roleLocation = authDataService.getSelectedRoleLocation();
            if (!roleLocation) {
                return $q.when(undefined);
            }
            return httpService.get(constant_module_1.Endpoints.USER_DATA, {
                roleId: roleLocation.role.roleId,
                plantId: roleLocation.plant ? roleLocation.plant.id : ''
            }).then(function (userData) {
                authDataService.setUserData(userData);
                return userData;
            });
        }
        function logoff(navigation) {
            if (navigation) {
                navigation.uninitialize();
            }
            authDataService.clearToken();
            authDataService.clearSelectedRoleLocation();
            authDataService.clearUserData();
            authDataService.clearUserId();
        }
        function isAuthenticated() {
            return authDataService.getToken() !== undefined;
        }
        function setRoleLocation(role, plant, shop, shift) {
            return httpService.post(constant_module_1.Endpoints.USER_ROLE_LOCATION, {
                roleId: role.roleId,
                plantId: (plant || {}).id,
                shopId: (shop || {}).id,
                shift: shift
            }).then(function () {
                authDataService.setSelectedRoleLocation(role, plant, shop);
            });
        }
        return {
            login: login,
            logoff: logoff,
            isAuthenticated: isAuthenticated,
            setRoleLocation: setRoleLocation,
            getUserData: getUserData
        };
    }]).name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(5), __webpack_require__(0), __webpack_require__(2), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, aps_enums_1, angular, _, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var LocationsServiceImpl = (function () {
        LocationsServiceImpl.$inject = ["httpService", "$q"];
        function LocationsServiceImpl(httpService, $q) {
            this.httpService = httpService;
            this.$q = $q;
        }
        LocationsServiceImpl.prototype.initialize = function () {
            var _this = this;
            if (this.locations) {
                return this.$q.when(this.getOtherLocations());
            }
            return this.httpService.get(constant_module_1.Endpoints.LOCATIONS)
                .then(function (data) { return _this.locations = data; });
        };
        LocationsServiceImpl.prototype.getOtherLocations = function () {
            return this.locations.concat();
        };
        LocationsServiceImpl.prototype.getPlantLocations = function (plant, locations) {
            var plantLocations = [];
            var plantLocation = {
                id: null,
                name: 'Plant',
                locationType: aps_enums_1.apsEnums.LocationType.Plant,
                children: []
            };
            if (plant) {
                plantLocation.id = plant.id;
                plantLocations.push(plantLocation);
                _.forEach(plant.tanks, function (t) {
                    var tankLocation = {
                        id: t.id,
                        name: 'Tank ' + t.name,
                        locationType: aps_enums_1.apsEnums.LocationType.Tank,
                        children: [],
                        parent: plantLocation
                    };
                    plantLocation.children.push(tankLocation);
                    plantLocations.push(tankLocation);
                    _.forEach(t.shops, function (s) {
                        var shopLocation = {
                            id: s.id,
                            name: 'Shop ' + s.name,
                            locationType: aps_enums_1.apsEnums.LocationType.Shop,
                            children: [],
                            parent: tankLocation
                        };
                        plantLocation.children.push(shopLocation);
                        tankLocation.children.push(shopLocation);
                        plantLocations.push(shopLocation);
                    });
                });
            }
            _.forEach(this.locations, function (l) {
                var otherLocation = {
                    id: l.id,
                    name: l.name,
                    locationType: aps_enums_1.apsEnums.LocationType.Other,
                    parent: plantLocation,
                    children: []
                };
                plantLocation.children.push(otherLocation);
                plantLocations.push(otherLocation);
            });
            if (locations) {
                _.forEach(plantLocations, function (l) {
                    l.location = _.find(locations, { locationType: l.locationType, locationTypeId: l.id });
                });
            }
            return plantLocations;
        };
        return LocationsServiceImpl;
    }());
    exports.default = angular
        .module('aps.services.locations', [http_service_1.default])
        .service('locationsService', LocationsServiceImpl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(3), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, constant_module_1, http_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [http_service_1.default];
    var PlantSvc = (function () {
        PlantSvc.$inject = ["httpService"];
        function PlantSvc(httpService) {
            this.httpService = httpService;
        }
        PlantSvc.prototype.getPlants = function () {
            return this.httpService.get(constant_module_1.Endpoints.PLANT_LIST);
        };
        PlantSvc.prototype.updatePlant = function (plant) {
            var url = constant_module_1.Endpoints.PLANT_LIST + '/' + plant.id;
            return this.httpService.put(url, plant);
        };
        PlantSvc.prototype.getPlatFeatureSettings = function (plantId) {
            var url = constant_module_1.Endpoints.PLANT_LIST + '/PlantFeatureSettings/' + plantId;
            return this.httpService.get(url);
        };
        return PlantSvc;
    }());
    exports.default = angular
        .module('aps.services.plant', requires)
        .service('plantService', PlantSvc)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var CommoditiesSvc = (function () {
        CommoditiesSvc.$inject = ["httpService"];
        function CommoditiesSvc(httpService) {
            this.httpService = httpService;
        }
        CommoditiesSvc.prototype.get = function (plantId) {
            return this.httpService.get(constant_module_1.Endpoints.COMMODITIES, { plantId: plantId });
        };
        CommoditiesSvc.prototype.getCommodityPercentages = function (plantId) {
            return this.httpService.get(constant_module_1.Endpoints.COMMODITYPERCENTAGES, { plantId: plantId });
        };
        CommoditiesSvc.prototype.add = function (command) {
            return this.httpService.post(constant_module_1.Endpoints.COMMODITIES, command);
        };
        CommoditiesSvc.prototype.update = function (command) {
            return this.httpService.put(constant_module_1.Endpoints.COMMODITIES, command);
        };
        CommoditiesSvc.prototype.updateCommodityPercentage = function (command) {
            return this.httpService.put(constant_module_1.Endpoints.COMMODITYPERCENTAGES, command);
        };
        CommoditiesSvc.prototype.remove = function (command) {
            return this.httpService.delete(constant_module_1.Endpoints.COMMODITIES + '/' + command.id, { plantId: command.plantId });
        };
        CommoditiesSvc.prototype.removeCommodityPercentage = function (command) {
            return this.httpService.delete(constant_module_1.Endpoints.COMMODITYPERCENTAGES + '/' + command.id, { plantId: command.plantId });
        };
        return CommoditiesSvc;
    }());
    exports.default = angular
        .module('aps.services.commodities', [http_service_1.default])
        .service('commoditiesService', CommoditiesSvc)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular
        .module('aps.services.dataPoint', [http_service_1.default])
        .service('dataPointService', ["httpService", function (httpService) {
        return {
            get: function (plantId) {
                return httpService.get(constant_module_1.Endpoints.DATAPOINTS, { plantId: plantId });
            },
            add: function (command) {
                return httpService.post(constant_module_1.Endpoints.DATAPOINTS, command);
            },
            update: function (command) {
                return httpService.put(constant_module_1.Endpoints.DATAPOINTS, command);
            },
            remove: function (command) {
                return httpService.delete(constant_module_1.Endpoints.DATAPOINTS + '/' + command.id, { plantId: command.plantId, plantLocationId: command.plantLocationId });
            },
            validateFormula: function (request) {
                return httpService.post(constant_module_1.Endpoints.DATAPOINTS_VALIDATE, request);
            },
            calculateFormula: function (request) {
                return httpService.post(constant_module_1.Endpoints.DATAPOINTS_CALCULATE, request);
            }
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(52)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, user_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('userProfile', [user_service_1.default])
        .factory('userProfile', ["$q", "userService", function ($q, userService) {
        var vm = this;
        var data = null;
        var promise = null;
        vm.read = function () {
            if (data) {
                return $q.when(data);
            }
            if (promise) {
                return promise;
            }
            promise = userService.getUserProfile()
                .then(function (userData) {
                data = userData;
                promise = null;
                return data;
            });
            return promise;
        };
        vm.update = function (userData) {
            data = userData;
        };
        vm.updateEditProfile = function (userData) {
            data.displayDefectsByNumber = userData.displayDefectsByNumber;
            data.email = userData.email;
            data.phoneNumber = userData.phoneNumber;
        };
        return vm;
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(2), __webpack_require__(5), __webpack_require__(11), __webpack_require__(32), __webpack_require__(6), __webpack_require__(4), __webpack_require__(7), __webpack_require__(399)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, moment, _, aps_enums_1, dateutility_service_1, checkListInstances_service_1, notify_service_1, loader_service_1, authData_service_1, checkListReportDetails_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [checkListInstances_service_1.default, notify_service_1.default, loader_service_1.default, authData_service_1.default];
    function openCheckListReportDetails(params, $modal) {
        $modal.open({
            template: checkListReportDetails_tpl_html_1.default,
            controller: 'CheckListReportDetailsCtrl as vm',
            resolve: {
                params: function () { return params; }
            }
        });
    }
    exports.openCheckListReportDetails = openCheckListReportDetails;
    var CheckListReportDetailsCtrl = (function () {
        CheckListReportDetailsCtrl.$inject = ["params", "authDataService", "checkListInstancesService", "notifyService", "loaderService", "$modal", "$stateParams", "$modalInstance"];
        function CheckListReportDetailsCtrl(params, authDataService, checkListInstancesService, notifyService, loaderService, $modal, $stateParams, $modalInstance) {
            this.checkListInstancesService = checkListInstancesService;
            this.notifyService = notifyService;
            this.loaderService = loaderService;
            this.userId = $stateParams.userId;
            this.checkListInstance = params.checkListInstance;
            this.scheduledOn = moment(params.checkListInstance.scheduledOn).format("YYYY-MM-DDTHH:mm:ss");
            this.isReport = false;
            if (this.checkListInstance.checkListId === "df670000-ff45-0003-5041-08d756ef6832") {
                this.isReport = true;
            }
            this.detail = params.detail;
            this.$modalInstance = $modalInstance;
            this.$modal = $modal;
            this.authDataService = authDataService;
            this.status = _.startCase(aps_enums_1.apsEnums.CheckListStatus[params.checkListInstance.status]);
        }
        CheckListReportDetailsCtrl.prototype.formatTime = function (time) {
            return dateutility_service_1.default.formatTime(time, this.checkListInstance.plantTimeZoneId);
        };
        CheckListReportDetailsCtrl.prototype.formatCheckStatus = function (status) {
            return _.startCase(aps_enums_1.apsEnums.CheckStatus[status]);
        };
        CheckListReportDetailsCtrl.prototype.close = function () {
            this.$modalInstance.close();
        };
        CheckListReportDetailsCtrl.prototype.hasAdditionalData = function (additionalData) {
            if (additionalData === null
                || additionalData.length === 0
                || additionalData === '{}') {
                return false;
            }
            return true;
        };
        CheckListReportDetailsCtrl.prototype.formatAdditionalData = function (additionalData) {
            if (!this.hasAdditionalData(additionalData)) {
                return '';
            }
            try {
                var json_1 = JSON.parse(additionalData);
                var selected = Object.keys(json_1)
                    .filter(function (key) { return json_1[key]; });
                return selected.join(', ');
            }
            catch (_a) {
                return '';
            }
        };
        CheckListReportDetailsCtrl.prototype.getResult = function (instance) {
            if (!instance || !instance.status || instance.status === aps_enums_1.apsEnums.CheckStatus.NotDone) {
                return '';
            }
            if ((instance.result || '').length === 0) {
                return 'N/A';
            }
            if (instance.result instanceof Date) {
                return this.formatTime(instance.result);
            }
            return instance.result;
        };
        CheckListReportDetailsCtrl.prototype.canSignOff = function (signOff) {
            if (this.checkListInstance.isArchived
                || this.checkListInstance.status < aps_enums_1.apsEnums.CheckListStatus.Complete) {
                return false;
            }
            var selectedRoleLocation = this.authDataService.getSelectedRoleLocation();
            return selectedRoleLocation.role.roleId === signOff.roleId;
        };
        CheckListReportDetailsCtrl.prototype.signOff = function (signOff, scheduledOn, defectId) {
            var _this = this;
            if (!this.canSignOff(signOff)) {
                return;
            }
            var command = {
                notificationId: null,
                checkListInstanceId: signOff.checkListInstanceId,
                checkListSignOffId: signOff.checkListSignOffId,
                plantLocationId: signOff.plantLocationId,
                scheduledOn: scheduledOn,
                defectId: defectId
            };
            this.loaderService.loadingPromise(this.checkListInstancesService.signOff(command)
                .then(function () {
                _this.notifyService.success('Sign Off', 'Successful');
                signOff.signedOffByFullName = _this.authDataService.getUserData().fullName;
                signOff.signedOffOn = new Date();
            }, this.notifyService.handleApiErrors));
        };
        CheckListReportDetailsCtrl.prototype.print = function () {
            var reportHtml = $('#reportWrapper').html();
            var popup = window.open('', 'my div', 'height=800,width=600');
            popup.document.write('<html><head><title>Checklist Report Details</title>');
            popup.document.write('<style>');
            popup.document.write('body, th, td { font-family: arial; font-size: 70% }');
            popup.document.write('.history-t { width: 100% }');
            popup.document.write('.dialog-footer { display: none }');
            popup.document.write('</style>');
            popup.document.write('</head>');
            popup.document.write('<body>');
            popup.document.write(reportHtml);
            popup.document.write('</body>');
            popup.document.write('</html>');
            popup.document.close();
            popup.focus();
            popup.print();
            popup.close();
        };
        return CheckListReportDetailsCtrl;
    }());
    exports.default = angular.module('aps.controller.checkListReportDetails', requires)
        .controller('CheckListReportDetailsCtrl', CheckListReportDetailsCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(5), __webpack_require__(2), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, aps_enums_1, _, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var CheckListCommon = (function () {
        function CheckListCommon() {
        }
        CheckListCommon.getAllShopsItem = function () {
            return CheckListCommon.shopAllSelection;
        };
        CheckListCommon.getAllPlantsItem = function () {
            return CheckListCommon.plantAllSelection;
        };
        CheckListCommon.getAllWareClassItem = function () {
            return CheckListCommon.wareClassAllSelection;
        };
        CheckListCommon.shopAllSelection = {
            id: null,
            name: 'All',
            defaultNumberOfGobs: 2,
            defaultNumberOfSections: 8,
            defaultPackPercentageTarget: 90,
            plantId: null,
            plantLocationId: null,
            hasLines: false
        };
        CheckListCommon.plantAllSelection = {
            id: null,
            name: 'All',
            shops: [CheckListCommon.shopAllSelection],
            tanks: [],
            plantLocationId: null,
            isDisabled: false,
            timeZoneId: constant_module_1.Strings.DEFAULT_TIMEZONE,
            countRejectPercent: aps_enums_1.apsEnums.CountRejectPercent.PercentOfInspection,
            others: []
        };
        CheckListCommon.wareClassAllSelection = {
            id: null,
            name: 'All'
        };
        return CheckListCommon;
    }());
    exports.CheckListCommon = CheckListCommon;
    var CheckListOverrideModule = (function () {
        function CheckListOverrideModule() {
        }
        CheckListOverrideModule.getOverrideResult = function (item, prop) {
            var _this = this;
            return function (plantId, shopId, jobId) {
                var result = _this.getOverrideProp(item, prop, null, null, null);
                if (result !== null) {
                    return result;
                }
                if (jobId) {
                    result = _this.getOverrideProp(item, prop, null, null, jobId);
                    if (result !== null) {
                        return result;
                    }
                }
                plantId = plantId || item.plantId;
                shopId = shopId || item.shopId;
                if (plantId) {
                    result = _this.getOverrideProp(item, prop, plantId, null, null);
                    if (result !== null) {
                        return result;
                    }
                    if (jobId) {
                        result = _this.getOverrideProp(item, prop, plantId, null, jobId);
                        if (result !== null) {
                            return result;
                        }
                    }
                    if (shopId) {
                        result = _this.getOverrideProp(item, prop, plantId, shopId, null);
                        if (result !== null) {
                            return result;
                        }
                        if (jobId) {
                            result = _this.getOverrideProp(item, prop, plantId, shopId, jobId);
                            if (result !== null) {
                                return result;
                            }
                        }
                    }
                }
                return null;
            };
        };
        CheckListOverrideModule.getOverrideProp = function (item, prop, plantId, shopId, jobId) {
            var override = _.find(item.overrides, { plantId: plantId, shopId: shopId, jobId: jobId });
            return override ? prop(override) : null;
        };
        CheckListOverrideModule.extendOverrideItem = function (item) {
            var extendedItem = _.assign(item, {
                isMandatory: false,
                isDisabled: false
            });
            extendedItem.isMandatoryFor = CheckListOverrideModule.getOverrideResult(extendedItem, function (c) {
                if (c.isMandatory) {
                    return true;
                }
                if (c.isDisabled) {
                    return false;
                }
                return null;
            });
            extendedItem.isOnlyDisabled = CheckListOverrideModule.getOverrideResult(extendedItem, function (c) {
                if (c.isDisabled) {
                    return true;
                }
                return null;
            });
            extendedItem.isDisabledFor = function (plantId, shopId, jobId) {
                return !extendedItem.isMandatoryFor(plantId, shopId, jobId)
                    && extendedItem.isOnlyDisabled(plantId, shopId, jobId);
            };
            return extendedItem;
        };
        CheckListOverrideModule.setOverrideValue = function (item, plantId, shopId, jobId, authDataService) {
            item.isMandatory = item.isMandatoryFor(plantId, shopId, jobId);
            item.isDisabled = item.isDisabledFor(plantId, shopId, jobId);
            var parentIsMandatory = false;
            var parentIsDisabled = false;
            if (shopId && !item.shopId) {
                parentIsMandatory = item.isMandatoryFor(plantId, null, jobId);
                parentIsDisabled = item.isDisabledFor(plantId, null, jobId);
            }
            else if (plantId && !item.plantId) {
                parentIsMandatory = item.isMandatoryFor(null, null, jobId);
                parentIsDisabled = item.isDisabledFor(null, null, jobId);
            }
            var currentPlantId = plantId || item.plantId;
            var isAdmin = currentPlantId ? authDataService.isPlantAdmin(currentPlantId) : authDataService.isAdmin();
            item.canChangeMandatory = isAdmin && !parentIsMandatory && !parentIsDisabled;
            item.canChangeDisabled = isAdmin && !parentIsMandatory && !parentIsDisabled
                && !item.isMandatory;
        };
        CheckListOverrideModule.setOverrideValues = function (items, plantId, shopId, jobId, authDataService) {
            _.forEach(items, function (item) {
                return CheckListOverrideModule.setOverrideValue(item, plantId, shopId, jobId, authDataService);
            });
        };
        CheckListOverrideModule.extendCheckItem = function (check) {
            return _.assign({
                isFirst: false,
                isLast: false,
                dataTypeString: aps_enums_1.apsEnums.CheckDataType[check.dataType],
                entryString: 'Per ' + aps_enums_1.apsEnums.CheckEntry[check.entry].substring(3),
                isMandatory: false,
                isDisabled: false
            }, CheckListOverrideModule.extendOverrideItem(check));
        };
        CheckListOverrideModule.getLocationName = function (checkList, locations) {
            var locationName = null;
            if (checkList.locationType === aps_enums_1.apsEnums.LocationType.Other) {
                var location = _.find(locations, { id: checkList.locationId });
                if (location) {
                    locationName = location.name;
                }
            }
            if (!locationName) {
                locationName = aps_enums_1.apsEnums.LocationType[checkList.locationType];
            }
            return locationName;
        };
        CheckListOverrideModule.getWareClassName = function (checkList, wareClasses) {
            var wareClass = _.find(wareClasses, { id: checkList.wareClassId });
            if (wareClass) {
                return wareClass.name;
            }
            return 'all';
        };
        CheckListOverrideModule.extendCheckList = function (checkList, allCheckLists, plants, shops, locations, wareClasses, plantId, shopId, jobId, authDataService) {
            var checkListPlant = _.find(plants, { 'id': checkList.plantId });
            var checkListShop = _.find(shops, { 'id': checkList.shopId });
            var checkListWareClass = _.find(wareClasses, { 'id': checkList.wareClassId });
            var plantName = checkListPlant ? checkListPlant.name : 'all';
            var shopName = checkListShop ? checkListShop.name : 'all';
            var wareClass = checkListWareClass ? checkListWareClass.name : 'all';
            var result = _.assign({
                plantName: plantName,
                shopName: shopName,
                wareClass: wareClass,
                canEdit: false,
                locationName: CheckListOverrideModule.getLocationName(checkList, locations)
            }, CheckListOverrideModule.extendOverrideItem(checkList));
            CheckListOverrideModule.setOverrideValue(result, plantId, shopId, jobId, authDataService);
            result.canEdit = authDataService.isAdmin()
                || (checkList.plantId && authDataService.isPlantAdmin(checkList.plantId));
            result.canCopy = !checkList.isGroup;
            if (checkList.checkListGroupId) {
                var group = _.find(allCheckLists, { id: checkList.checkListGroupId });
                if (group) {
                    result.checkListGroupName = group.name;
                }
            }
            return result;
        };
        CheckListOverrideModule.extendCheckLists = function (checkLists, plants, shops, locations, wareClasses, plantId, shopId, jobId, authDataService) {
            var result = [];
            _.forEach(checkLists, function (checkList) {
                return result.push(CheckListOverrideModule.extendCheckList(checkList, checkLists, plants, shops, locations, wareClasses, plantId, shopId, jobId, authDataService));
            });
            return result;
        };
        return CheckListOverrideModule;
    }());
    exports.default = CheckListOverrideModule;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var BatchFormulasSvc = (function () {
        BatchFormulasSvc.$inject = ["httpService"];
        function BatchFormulasSvc(httpService) {
            this.httpService = httpService;
        }
        BatchFormulasSvc.prototype.get = function (plantId) {
            return this.httpService.get(constant_module_1.Endpoints.BATCH_FORMULAS, { plantId: plantId });
        };
        BatchFormulasSvc.prototype.getDetail = function (plantId, id) {
            var uri = constant_module_1.Endpoints.BATCH_FORMULAS + "/" + id;
            return this.httpService.get(uri, { plantId: plantId });
        };
        BatchFormulasSvc.prototype.add = function (command) {
            return this.httpService.post(constant_module_1.Endpoints.BATCH_FORMULAS, command);
        };
        BatchFormulasSvc.prototype.update = function (command) {
            return this.httpService.put(constant_module_1.Endpoints.BATCH_FORMULAS, command);
        };
        BatchFormulasSvc.prototype.remove = function (command) {
            return this.httpService.delete(constant_module_1.Endpoints.BATCH_FORMULAS + '/' + command.id, { plantId: command.plantId });
        };
        BatchFormulasSvc.prototype.getUsages = function (plantId, tankId, limit) {
            return this.httpService.get(constant_module_1.Endpoints.BATCH_FORMULA_USAGES, { plantId: plantId, tankId: tankId, limit: limit });
        };
        BatchFormulasSvc.prototype.addUsage = function (command) {
            return this.httpService.post(constant_module_1.Endpoints.BATCH_FORMULA_USAGES, command);
        };
        BatchFormulasSvc.prototype.updateUsage = function (command) {
            return this.httpService.put(constant_module_1.Endpoints.BATCH_FORMULA_USAGES, command);
        };
        BatchFormulasSvc.prototype.removeUsage = function (command) {
            return this.httpService.delete(constant_module_1.Endpoints.BATCH_FORMULA_USAGES + '/' + command.id);
        };
        BatchFormulasSvc.prototype.getUsageReport = function (plantId, tankId, startTime, endTime) {
            return this.httpService.get(constant_module_1.Endpoints.BATCH_FORMULA_USAGE_REPORT, { plantId: plantId, tankId: tankId, startTime: startTime, endTime: endTime });
        };
        return BatchFormulasSvc;
    }());
    exports.default = angular
        .module('aps.services.batchFormulas', [http_service_1.default])
        .service('batchFormulasService', BatchFormulasSvc)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(2), __webpack_require__(3), __webpack_require__(10), __webpack_require__(4), __webpack_require__(275), __webpack_require__(277)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, moment, _, constant_module_1, http_service_1, loader_service_1, lineSheet_service_1, addToolChange_controller_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = ['mm.foundation', http_service_1.default, loader_service_1.default, lineSheet_service_1.default, addToolChange_controller_1.default];
    var SectionChangeServiceImpl = (function () {
        SectionChangeServiceImpl.$inject = ["lineSheetService", "loaderService", "httpService", "$modal"];
        function SectionChangeServiceImpl(lineSheetService, loaderService, httpService, $modal) {
            this.lineSheetService = lineSheetService;
            this.loaderService = loaderService;
            this.$modal = $modal;
            this.httpService = httpService;
        }
        SectionChangeServiceImpl.prototype.openToolChangeForSectionChange = function (lookupData) {
            var _this = this;
            var lineSheetPromise = this.lineSheetService.getLineSheetActivity(lookupData.shopId, moment());
            this.loaderService.loadingPromise(lineSheetPromise);
            lineSheetPromise.then(function (data) {
                var machine = _.find(data.machines, { id: lookupData.isMachineId });
                var section = _.find(machine.sections, { sectionNumber: lookupData.section });
                var gob = section.gobs[0];
                addToolChange_controller_1.openAddToolChange({
                    shopId: lookupData.shopId,
                    activity: data,
                    gob: gob,
                    gobHour: gob.hours[0],
                    date: new Date(),
                    sectionChangeId: lookupData.sectionChangeId,
                    sectionChangeSectionId: lookupData.sectionChangeSectionId
                }, _this.$modal);
            });
        };
        SectionChangeServiceImpl.prototype.skipSectionChange = function (command) {
            return this.httpService.put(constant_module_1.Endpoints.SECTION_CHANGE_SKIP, command);
        };
        SectionChangeServiceImpl.prototype.getStrategies = function () {
            return this.httpService.get(constant_module_1.Endpoints.SECTION_CHANGE_STRATEGY);
        };
        SectionChangeServiceImpl.prototype.getStrategy = function (id) {
            return this.httpService.get(constant_module_1.Endpoints.SECTION_CHANGE_STRATEGY + '/' + id);
        };
        SectionChangeServiceImpl.prototype.getStrategiesForShop = function (shop) {
            return this.getStrategies().then(function (data) {
                return _.filter(data, function (s) {
                    return s.plantId === null || (s.plantId === shop.plantId && (s.shopId === null || s.shopId === shop.id));
                });
            });
        };
        SectionChangeServiceImpl.prototype.addUpdateStrategy = function (command) {
            return this.httpService.post(constant_module_1.Endpoints.SECTION_CHANGE_STRATEGY, command);
        };
        SectionChangeServiceImpl.prototype.deleteStrategy = function (id) {
            return this.httpService.delete(constant_module_1.Endpoints.SECTION_CHANGE_STRATEGY + '/' + id);
        };
        SectionChangeServiceImpl.prototype.copyStrategy = function (command) {
            return this.httpService.put(constant_module_1.Endpoints.SECTION_CHANGE_STRATEGY, command);
        };
        return SectionChangeServiceImpl;
    }());
    exports.default = angular
        .module('aps.services.sectionChange', requires)
        .service('sectionChangeService', SectionChangeServiceImpl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, moment, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.services.defects', [http_service_1.default])
        .service('defectService', ["httpService", function (httpService) {
        var getDefectEquipment = function () {
            return httpService.get(constant_module_1.Endpoints.DEFECT_EQUIPMENT);
        };
        var addDefect = function (defect) {
            return httpService.post(constant_module_1.Endpoints.DEFECT, defect);
        };
        var addMoldLoss = function (moldLoss) {
            if (moldLoss && (moldLoss.isRejectInvalidMolds != undefined || moldLoss.isRejectMold != undefined)) {
                return httpService.post(constant_module_1.Endpoints.DEFECT_MOLD_LOSS, moldLoss);
            }
        };
        var getMoldLossStatus = function (shopId, defectId) {
            return httpService.get(constant_module_1.Endpoints.DEFECT_MOLD_LOSS_STATUS, { shopId: shopId, defectId: defectId });
        };
        var getMoldRejectStatus = function (defectId) {
            return httpService.get(constant_module_1.Endpoints.DEFECT_MOLD_REJECT_STATUS + "/" + defectId);
        };
        var addDefectComment = function (defectComment) {
            return httpService.post(constant_module_1.Endpoints.DEFECT_COMMENT, defectComment);
        };
        var addHeldPallets = function (command) {
            return httpService.post(constant_module_1.Endpoints.DEFECT_HELD_PALLETS, command);
        };
        var deleteHeldPallets = function (command) {
            return httpService.post(constant_module_1.Endpoints.DEFECT_HELD_PALLETS_DELETE, command);
        };
        var updateDefectMoldReject = function (defectMoldReject) {
            return httpService.post(constant_module_1.Endpoints.DEFECT_MOLD_REJECT, defectMoldReject);
        };
        var updateDefectEquipFailure = function (defectEquipFail) {
            return httpService.post(constant_module_1.Endpoints.DEFECT_EQUIP_FAIL, defectEquipFail);
        };
        var deleteDefect = function (defectId, reason) {
            return httpService.delete(constant_module_1.Endpoints.DEFECT + '/' + defectId, { reason: reason });
        };
        var getDefect = function (defectId) {
            return httpService.get(constant_module_1.Endpoints.DEFECT_DETAILS + '/' + defectId);
        };
        var getDefectLossTypes = function () {
            return httpService.get(constant_module_1.Endpoints.DEFECT_LOSS_TYPES);
        };
        var getCriticalReport = function (defectId, shopId, roleId, scheduledOn) {
            return httpService.get(constant_module_1.Endpoints.DEFECT_CRITICAL_REPORT + '/' + defectId, { shopId: shopId, roleId: roleId, scheduledOn: scheduledOn });
        };
        var getMachineDefectQuestion = function (defectId, isMnr) {
            return httpService.get(constant_module_1.Endpoints.MACHINE_DEFECT_QUESTION + '/' + defectId, { isMnr: isMnr });
        };
        var getActiveMnrs = function (shopId, date) {
            var processDate = date ? moment(date).format("MM/DD/YYYY") : moment().format('MM/DD/YYYY');
            return httpService.get(constant_module_1.Endpoints.ACTIVE_MNRS, { shopId: shopId, processDate: processDate });
        };
        return {
            getDefectEquipment: getDefectEquipment,
            addDefect: addDefect,
            addMoldLoss: addMoldLoss,
            addDefectComment: addDefectComment,
            addHeldPallets: addHeldPallets,
            deleteHeldPallets: deleteHeldPallets,
            updateDefectMoldReject: updateDefectMoldReject,
            deleteDefect: deleteDefect,
            getDefect: getDefect,
            getDefectLossTypes: getDefectLossTypes,
            updateDefectEquipFailure: updateDefectEquipFailure,
            getCriticalDefectReportDetails: getCriticalReport,
            getMoldLossStatus: getMoldLossStatus,
            getMachineDefectQuestion: getMachineDefectQuestion,
            getMoldRejectStatus: getMoldRejectStatus,
            getActiveMnrs: getActiveMnrs
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(37)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, hub_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var CheckListInstancesHubCreatorImpl = (function () {
        CheckListInstancesHubCreatorImpl.$inject = ["hubService"];
        function CheckListInstancesHubCreatorImpl(hubService) {
            this.hubService = hubService;
        }
        CheckListInstancesHubCreatorImpl.prototype.createCheckListInstancesHub = function (plantId, shopId, onUpdate, onInstance) {
            return this.hubService.createHub('checkListInstance', {
                listeners: {
                    instanceEventFired: onInstance,
                    instancesUpdated: onUpdate
                },
                allowMultipleListeners: true,
                methods: ['leaveGroup', 'joinGroup'],
                postConnect: function (hub) {
                    hub.invokeWithRetry(function () { return hub.joinGroup(plantId, shopId); });
                }
            });
        };
        return CheckListInstancesHubCreatorImpl;
    }());
    exports.default = angular.module('aps.hubs.checkListInstances', [hub_service_1.default])
        .service('checkListInstancesHubCreator', CheckListInstancesHubCreatorImpl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular
        .module('aps.services.job', [http_service_1.default])
        .service('jobService', ["httpService", function (httpService) {
        var getJobs = function () {
            return httpService.get(constant_module_1.Endpoints.JOBS);
        };
        var addJob = function (command) {
            return httpService.post(constant_module_1.Endpoints.JOBS, command);
        };
        var saveJob = function (command) {
            return httpService.put(constant_module_1.Endpoints.JOBS, command);
        };
        var deleteJob = function (job) {
            return httpService.delete(constant_module_1.Endpoints.JOBS + '/' + job.id);
        };
        var getCustomers = function () {
            return httpService.get(constant_module_1.Endpoints.CUSTOMERS);
        };
        var getGlassColors = function () {
            return httpService.get(constant_module_1.Endpoints.GLASS_COLORS);
        };
        var getWareClasses = function () {
            return httpService.get(constant_module_1.Endpoints.WARE_CLASSES);
        };
        var getProcesses = function () {
            return httpService.get(constant_module_1.Endpoints.JOB_PROCESSES);
        };
        var getDescriptions = function () {
            return httpService.get(constant_module_1.Endpoints.JOB_DESCRIPTIONS);
        };
        var getMolds = function () {
            return httpService.get(constant_module_1.Endpoints.JOB_MOLDS);
        };
        var getFinishes = function () {
            return httpService.get(constant_module_1.Endpoints.JOB_FINISHES);
        };
        var getTargetFinishes = function (plantId, mold) {
            return httpService.get(constant_module_1.Endpoints.JOB_TARGET_FINISHES, { plantId: plantId, mold: mold });
        };
        var getTargetMolds = function (plantId) {
            return httpService.get(constant_module_1.Endpoints.JOB_TARGET_MOLDS, { plantId: plantId });
        };
        return {
            getJobs: getJobs,
            addJob: addJob,
            saveJob: saveJob,
            deleteJob: deleteJob,
            getCustomers: getCustomers,
            getGlassColors: getGlassColors,
            getWareClasses: getWareClasses,
            getProcesses: getProcesses,
            getDescriptions: getDescriptions,
            getMolds: getMolds,
            getFinishes: getFinishes,
            getTargetFinishes: getTargetFinishes,
            getTargetMolds: getTargetMolds
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 80 */,
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(11), __webpack_require__(28), __webpack_require__(9), __webpack_require__(4), __webpack_require__(26), __webpack_require__(5), __webpack_require__(33), __webpack_require__(604), __webpack_require__(605)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, dateutility_service_1, lineConfigs_service_1, uiUtility_service_1, loader_service_1, counts_service_1, aps_enums_1, equipment_service_1, equipmentRejects_tpl_html_1, inconsistentEquipmentConfigurations_controller_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [lineConfigs_service_1.default, uiUtility_service_1.default, loader_service_1.default,
        counts_service_1.default, equipment_service_1.default, inconsistentEquipmentConfigurations_controller_1.default];
    function openEquipmentRejects(data, $modal) {
        return $modal.open({
            template: equipmentRejects_tpl_html_1.default,
            controller: 'EquipmentRejectsCtrl as vm',
            resolve: {
                data: function () { return data; }
            }
        }).result;
    }
    exports.openEquipmentRejects = openEquipmentRejects;
    var EquipmentRejectsControllerImpl = (function () {
        EquipmentRejectsControllerImpl.$inject = ["data", "$modalInstance", "uiUtilityService", "$q", "lineConfigsService", "$modal", "loaderService", "countsService", "equipmentService"];
        function EquipmentRejectsControllerImpl(data, $modalInstance, uiUtilityService, $q, lineConfigsService, $modal, loaderService, countsService, equipmentService) {
            this.tabClass = 'er-details';
            this.equipment = data.equipment;
            this.detail = data.detail;
            this.showHealth = this.detail && this.detail.tabs && this.detail.tabs.length > 0;
            this.line = data.line;
            this.plant = data.plant;
            this.canDisable = data.canDisable;
            this.setTabClass();
            this.shopId = data.shopId;
            this.$modalInstance = $modalInstance;
            this.lineConfigsService = lineConfigsService;
            this.uiUtilityService = uiUtilityService;
            this.$q = $q;
            this.equipmentHealthState = aps_enums_1.apsEnums.EquipmentHealthState;
            this.$modal = $modal;
            this.loaderService = loaderService;
            this.countsService = countsService;
            this.equipmentService = equipmentService;
            var equipmentMetaData = this.equipment.equipmentMetaData
                ? JSON.parse(this.equipment.equipmentMetaData)
                : null;
            this.lineEquipmentName = equipmentMetaData
                ? equipmentMetaData.Name
                : '';
            this.lineConfig = data.lineConfig;
            this.isEquipmentWithInconsistencies = this.setIsEquipmentWithInconsistencies(this.lineConfig);
        }
        EquipmentRejectsControllerImpl.prototype.setTabClass = function () {
            var tabCount = 0;
            if (this.detail) {
                if (this.detail.tabs) {
                    tabCount += this.detail.tabs.length;
                }
                if (this.detail.details && this.detail.details.length > 0) {
                    tabCount++;
                }
            }
            if (tabCount <= 1) {
                this.tabClass = 'tab-title-muted';
            }
        };
        EquipmentRejectsControllerImpl.prototype.close = function () {
            this.$modalInstance.close();
        };
        EquipmentRejectsControllerImpl.prototype.formatTime = function (utcTime) {
            if (!utcTime) {
                return '-';
            }
            return dateutility_service_1.default.formatTime(utcTime, this.plant.timeZoneId);
        };
        EquipmentRejectsControllerImpl.prototype.toggleActive = function () {
            var _this = this;
            if (!this.canDisable) {
                return;
            }
            var fullName = this.equipment.name + "-" + this.line.name;
            var confirmPromise;
            if (!this.equipment.isDisabled) {
                confirmPromise = this.uiUtilityService.confirm("Disable " + fullName + "?", "Are you sure you want to disable the " + this.equipment.name + " on line " + this.line.name + "?");
            }
            else {
                confirmPromise = this.$q.when(true);
            }
            confirmPromise.then(function (confirmed) {
                if (!confirmed) {
                    return;
                }
                var togglePromise = _this.lineConfigsService.toggleLineEquipment({
                    id: _this.equipment.id,
                    lineId: _this.line.id,
                    shopId: _this.equipment.shopId,
                    isDisabled: !_this.equipment.isDisabled
                }).then(function () { return _this.equipment.isDisabled = !_this.equipment.isDisabled; });
                _this.loaderService.loadingPromise(togglePromise);
            });
        };
        EquipmentRejectsControllerImpl.prototype.viewInconsistencies = function () {
            inconsistentEquipmentConfigurations_controller_1.openInconsistentConfigurations({
                shopId: this.shopId,
                equipmentId: this.equipment.equipmentId,
                lineConfig: this.lineConfig,
                equipmentName: this.equipment.name
            }, this.$modal);
        };
        EquipmentRejectsControllerImpl.prototype.setIsEquipmentWithInconsistencies = function (lineConfig) {
            var _this = this;
            if (!lineConfig.inconsistentEquipmentConfigurations) {
                return false;
            }
            return _.some(lineConfig.inconsistentEquipmentConfigurations, function (et) { return et === _this.equipment.equipmentType; });
        };
        return EquipmentRejectsControllerImpl;
    }());
    exports.default = angular.module('aps.controller.equipmentRejects', requires)
        .controller('EquipmentRejectsCtrl', EquipmentRejectsControllerImpl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, _) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function isNullOrUndefined(value) {
        return value === null || _.isUndefined(value);
    }
    exports.default = isNullOrUndefined;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular
        .module('aps.services.jobRun', [http_service_1.default])
        .service('jobRunService', ["httpService", function (httpService) {
        function getJobs() {
            return httpService.get(constant_module_1.Endpoints.JOBS, { includeDeleted: true });
        }
        function addJob(command) {
            return httpService.post(constant_module_1.Endpoints.JOBS, command);
        }
        function saveJob(command) {
            return httpService.put(constant_module_1.Endpoints.JOBS, command);
        }
        function deleteJob(job) {
            return httpService.delete(constant_module_1.Endpoints.JOBS + '/' + job.id);
        }
        function getJobRuns(shopId) {
            return httpService.get(constant_module_1.Endpoints.JOB_RUNS, { shopId: shopId });
        }
        function addJobRun(jobRun) {
            return httpService.post(constant_module_1.Endpoints.JOB_RUNS, jobRun);
        }
        function updateJobRun(jobRun) {
            return httpService.put(constant_module_1.Endpoints.JOB_RUNS, jobRun);
        }
        function restoreJobRun(command) {
            return httpService.put(constant_module_1.Endpoints.JOB_RUN_RESTORE, command);
        }
        function getActive(plantId) {
            return httpService.get(constant_module_1.Endpoints.JOB_RUNS_ACTIVE, { plantId: plantId });
        }
        function getTarget(plantId, mold, finish, color) {
            return httpService.get(constant_module_1.Endpoints.JOB_RUNS_TARGET, { plantId: plantId, mold: mold, finish: finish, color: color });
        }
        function getEquipmentByShopName(shopId) {
            return httpService.get(constant_module_1.Endpoints.LINE_EQUIPMENT_BY_SHOP, { shopId: shopId });
        }
        return {
            getJobs: getJobs,
            addJob: addJob,
            saveJob: saveJob,
            deleteJob: deleteJob,
            getJobRuns: getJobRuns,
            addJobRun: addJobRun,
            updateJobRun: updateJobRun,
            restoreJobRun: restoreJobRun,
            getActive: getActive,
            getTarget: getTarget,
            getEquipmentByShopName: getEquipmentByShopName
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(111), __webpack_require__(3), __webpack_require__(10), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, downtime_1, constant_module_1, http_service_1, _) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [http_service_1.default];
    exports.default = angular.module('aps.services.downtimes', requires)
        .service('downtimeService', ["httpService", function (httpService) {
        function getDowntimeTypesAndReasons() {
            return httpService.get(constant_module_1.Endpoints.DOWNTIME_TYPES)
                .then(function (data) {
                var downtimeTypes = [];
                var downtimeReasons = [];
                _.forEach(data, function (viewModel) {
                    downtimeReasons.push(new downtime_1.DowntimeReason(viewModel, downtimeTypes));
                });
                return {
                    downtimeTypes: downtimeTypes,
                    downtimeReasons: downtimeReasons
                };
            });
        }
        function addDowntime(downtime) {
            return httpService.post(constant_module_1.Endpoints.DOWNTIME, downtime);
        }
        function saveDowntime(downtime) {
            return httpService.put(constant_module_1.Endpoints.DOWNTIME, downtime);
        }
        function getOpenDowntimes(shopId) {
            var url = constant_module_1.Endpoints.SHOP_DOWNTIMES.replace('{0}', shopId);
            return httpService.get(url);
        }
        function deleteDowntime(command) {
            return httpService.delete(constant_module_1.Endpoints.DOWNTIME + '/' + command.id);
        }
        return {
            getDowntimeTypesAndReasons: getDowntimeTypesAndReasons,
            addDowntime: addDowntime,
            saveDowntime: saveDowntime,
            getOpenDowntimes: getOpenDowntimes,
            deleteDowntime: deleteDowntime
        };
    }]).name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(3), __webpack_require__(284), __webpack_require__(0), __webpack_require__(2), __webpack_require__(37), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, constant_module_1, chatMessage_1, angular, _, hub_service_1, http_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [hub_service_1.default, http_service_1.default];
    var ChatSvc = (function () {
        ChatSvc.$inject = ["httpService", "userProfile", "hubService"];
        function ChatSvc(httpService, userProfile, hubService) {
            this.httpService = httpService;
            this.userProfile = userProfile;
            this.hubService = hubService;
        }
        ChatSvc.prototype.sendMessage = function (command) {
            return this.httpService.post(constant_module_1.Endpoints.CHAT, command);
        };
        ChatSvc.prototype.getMessages = function (plantId, shopId, startDate, endDate) {
            var _this = this;
            return this.userProfile.read().then(function (userData) {
                return _this.httpService.get(constant_module_1.Endpoints.CHAT, {
                    plantId: plantId,
                    shopId: shopId,
                    startDate: startDate,
                    endDate: endDate
                }).then(function (data) {
                    return _.map(data, function (item) { return new chatMessage_1.default(item, userData); });
                });
            });
        };
        ChatSvc.prototype.createHub = function (shopId, onAdd) {
            return this.hubService.createHub('chat', {
                allowMultipleListeners: true,
                listeners: {
                    chatMessageAdded: function (chatAdded) {
                        if (onAdd && chatAdded.shopId === shopId) {
                            onAdd(chatAdded);
                        }
                    }
                },
                methods: ['leaveGroup', 'joinGroup'],
                postConnect: function (hub) {
                    hub.invokeWithRetry(function () { return hub.joinGroup(shopId); });
                }
            });
        };
        return ChatSvc;
    }());
    exports.default = angular.module('aps.services.chat', requires)
        .service('chatService', ChatSvc)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 93 */,
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(603), __webpack_require__(5), __webpack_require__(3), __webpack_require__(27), __webpack_require__(26), __webpack_require__(9), __webpack_require__(28), __webpack_require__(4), __webpack_require__(8), __webpack_require__(7), __webpack_require__(48), __webpack_require__(81), __webpack_require__(300)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, count_tpl_html_1, aps_enums_1, constant_module_1, enums_1, counts_service_1, uiUtility_service_1, lineConfigs_service_1, loader_service_1, navigation_service_1, authData_service_1, groupRejects_service_1, equipmentRejects_controller_1, gobWeightsGraph_directive_1) {
    "use strict";
    countsConfig.$inject = ["$stateProvider"];
    countsCtrl.$inject = ["$stateParams", "countsService", "lineConfigsService", "loaderService", "navigationService", "authDataService", "groupRejectsService", "uiUtilityService", "$scope", "$timeout", "$modal", "$state", "$interval"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [counts_service_1.default, uiUtility_service_1.default, lineConfigs_service_1.default, loader_service_1.default,
        navigation_service_1.default, authData_service_1.default, groupRejects_service_1.default, equipmentRejects_controller_1.default, gobWeightsGraph_directive_1.default];
    exports.default = angular.module('aps.controller.counts', requires)
        .config(countsConfig)
        .controller('CountsCtrl', countsCtrl)
        .name;
    function countsConfig($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.COUNTS_HORIZONTAL,
            url: '/counts',
            controller: 'CountsCtrl as vm',
            template: count_tpl_html_1.default,
            data: { pageTitle: 'Counts Data', v2Uri: 'aps/dashboard/shop/counts-dashboard' }
        });
    }
    function setUsePercentGobsChangedMethod(controller) {
        controller.usePercentGobsChanged = function () {
            controller.model.usePercentGobs = !controller.model.usePercentGobs;
            usePercentGobsProducedChanged(controller.countsService, controller.plant.id, controller.model.usePercentGobs);
        };
    }
    exports.setUsePercentGobsChangedMethod = setUsePercentGobsChangedMethod;
    function usePercentGobsProducedChanged(countsService, plantId, usePercentGobs) {
        countsService.setUsePercentGobs(plantId, usePercentGobs);
    }
    exports.usePercentGobsProducedChanged = usePercentGobsProducedChanged;
    function lineCountsLoaded(controller) {
        var usePercentGobs = controller.countsService.getUsePercentGobs(controller.plant);
        controller.model.usePercentGobs = usePercentGobs;
    }
    exports.lineCountsLoaded = lineCountsLoaded;
    function countsCtrl($stateParams, countsService, lineConfigsService, loaderService, navigationService, authDataService, groupRejectsService, uiUtilityService, $scope, $timeout, $modal, $state, $interval) {
        var equipmentRejectTolerances = {};
        var intervalMinutes;
        var vm = {
            $stateParams: $stateParams,
            countsService: countsService,
            model: null,
            areas: [],
            plant: null,
            shop: null,
            hub: null,
            shopId: null,
            canDisableLine: false,
            countDisplayIntervalOptions: uiUtilityService.getListOptionsFromEnum(enums_1.apsDisplayEnums.CountDisplayInterval, null, null, function (o) { return o; }),
            countsInterval: authDataService.getCountInterval(),
            viewRejectDetail: null,
            viewGroupRejectDetail: null,
            calculateSpeed: null,
            countsIntervalChanged: null,
            toggleLineActive: null,
            wareLossClicked: null,
            showHelp: null,
            showHelpWindow: false,
            helpText: null,
            toggleHelpWindow: null,
            getLossPercentClass: null,
            getEquipmentClass: null,
            getRowClass: null,
            getSynchronizedBlinkClass: null,
            cavities: [],
            hasCavities: false,
            userId: null,
            navigationUrls: {
                buttons: [
                    { 'name': 'Horizontal Layout', 'value': 'horizontal', 'selected': true },
                    { 'name': 'Vertical Layout', 'value': 'vertical', 'selected': false },
                    { 'name': 'Vertical Layout (v2)', 'value': 'vc2', 'selected': false },
                ],
                select: function (button) {
                    var stateParams = {
                        plantId: vm.$stateParams.plantId,
                        shopId: vm.$stateParams.shopId,
                        userId: vm.$stateParams.userId
                    };
                    switch (button.value) {
                        case "horizontal":
                            $state.go(constant_module_1.States.COUNTS_HORIZONTAL, stateParams);
                            break;
                        case "vertical":
                            $state.go(constant_module_1.States.COUNTS_VERTICAL, stateParams);
                            break;
                        case "vc2":
                            $state.go(constant_module_1.States.COUNTS_VERTICAL_V2, stateParams);
                            break;
                    }
                }
            },
            dumpGateDuration: 0,
            updateDumpGateDuration: null,
            blinkClass: 'blink-dark-horz',
            usePercentGobsChanged: null
        };
        intervalMinutes = constant_module_1.Intervals.IntervalSeconds[vm.countsInterval];
        vm.updateDumpGateDuration;
        vm.userId = $stateParams.userId;
        var shopId = $stateParams.shopId;
        vm.shopId = shopId;
        vm.canDisableLine = authDataService.isPlantOrAPSIOAdminForCurrentPlant();
        var plantShopsPromise = navigationService.getNavigation().then(function (navModel) {
            vm.plant = navModel.selectedPlant;
            vm.shop = navModel.selectedShop;
        });
        setUsePercentGobsChangedMethod(vm);
        vm.updateDumpGateDuration = function () {
            countsService.getDumpGateTimeCount(vm.plant.id, shopId, vm.countsInterval)
                .then(function (data) {
                return vm.dumpGateDuration = (data > intervalMinutes) ? intervalMinutes : data;
            });
        };
        var dumpGateDurationTimer;
        var createDumpGateDurationTimer = function () {
            vm.updateDumpGateDuration();
            if (dumpGateDurationTimer) {
                $interval.cancel(dumpGateDurationTimer);
            }
            dumpGateDurationTimer = $interval(vm.updateDumpGateDuration, 300000);
        };
        var updateBlinkClass = function () {
            if (vm.blinkClass.indexOf("light") > 0) {
                vm.blinkClass = " blink-dark-horz";
            }
            else {
                vm.blinkClass = " blink-light-horz";
            }
        };
        var blinkTimer;
        var createBlinkTimer = function () {
            updateBlinkClass();
            if (blinkTimer) {
                $interval.cancel(blinkTimer);
            }
            blinkTimer = $interval(updateBlinkClass, 600);
        };
        $scope.$on("$destroy", function () {
            if (dumpGateDurationTimer) {
                $interval.cancel(dumpGateDurationTimer);
                $interval.cancel(blinkTimer);
            }
        });
        var countsPromise = plantShopsPromise.then(function () {
            createDumpGateDurationTimer();
            createBlinkTimer();
            return countsService.getLineCounts(shopId, vm.plant, vm.countsInterval, vm.canDisableLine, true)
                .then(function (result) {
                vm.model = result;
                lineCountsLoaded(vm);
                vm.areas = mapModelToAreas(vm.model);
                var rejects = vm.model.shopConfig.jobRuns[0].machineRejectPercentages;
                if (!!rejects) {
                    vm.areas.forEach(function (area) {
                        area.rows.forEach(function (row) {
                            if (!row.isLine) {
                                return;
                            }
                            row.line.equipment.forEach(function (equipment) {
                                var equipWithRejectPercentage = rejects.filter(function (item) { return item.selectedMachine === equipment.name; });
                                if (equipWithRejectPercentage.length > 0) {
                                    var tolerances = {
                                        rejectMinPercentage: equipWithRejectPercentage[0].rejectedMinPercentage,
                                        rejectMaxPercentage: equipWithRejectPercentage[0].rejectedMaxPercentage
                                    };
                                    equipmentRejectTolerances[equipment.name] = tolerances;
                                }
                            });
                        });
                    });
                }
                for (var id in vm.model.equipment) {
                    if (vm.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.HEYE
                        || vm.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.CheckDetector
                        || vm.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.MX4
                        || vm.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.Mcal
                        || vm.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.Multi
                        || vm.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.FlexBC
                        || vm.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.FlexM) {
                        vm.hasCavities = true;
                        break;
                    }
                }
            });
        });
        vm.wareLossClicked = function () {
            var stateParams = {
                plantId: vm.$stateParams.plantId,
                shopId: vm.$stateParams.shopId,
                userId: vm.$stateParams.userId,
            };
            $state.go(constant_module_1.States.PLANT_WARE_LOSS_DASHBOARD, stateParams);
        };
        vm.toggleHelpWindow = function () {
            vm.showHelpWindow = !vm.showHelpWindow;
        };
        vm.showHelp = function (helpScreen) {
            vm.helpText = getCountsHelpText(helpScreen);
            vm.toggleHelpWindow();
        };
        vm.getLossPercentClass = function (equipment) {
            var rejectTolerance = equipmentRejectTolerances[equipment.name];
            if (equipment.rejectCount && !!rejectTolerance
                && (Number(equipment.rejectCount.percent) > rejectTolerance.rejectMaxPercentage
                    || Number(equipment.rejectCount.percent) < rejectTolerance.rejectMinPercentage)) {
                return 'fail-percentage';
            }
            return 'counts-equipment-details';
        };
        vm.getEquipmentClass = function (equip) {
            if (!equip) {
                return '';
            }
            if (equip.isDisabled) {
                return 'equipment-disabled';
            }
            var rejectTolerance = equipmentRejectTolerances[equip.name];
            var equipmentClass = 'equip-status-good-box';
            if (equip.rejectCount && !!rejectTolerance
                && (Number(equip.rejectCount.percent) > rejectTolerance.rejectMaxPercentage
                    || Number(equip.rejectCount.percent) < rejectTolerance.rejectMinPercentage)) {
                equipmentClass = 'equip-status-error-box';
                if (vm.countsInterval == enums_1.apsDisplayEnums.CountDisplayInterval.CurrentHour
                    || vm.countsInterval == enums_1.apsDisplayEnums.CountDisplayInterval.CurrentShift
                    || vm.countsInterval == enums_1.apsDisplayEnums.CountDisplayInterval.RollingHour
                    || vm.countsInterval == enums_1.apsDisplayEnums.CountDisplayInterval.LastTwentyMinutes) {
                    equipmentClass += ' blinking';
                }
            }
            return equipmentClass;
        };
        vm.getLossPercentClass = function (equipment) {
            var rejectTolerance = equipmentRejectTolerances[equipment.name];
            if (equipment.rejectCount && !!rejectTolerance
                && (Number(equipment.rejectCount.percent) > rejectTolerance.rejectMaxPercentage
                    || Number(equipment.rejectCount.percent) < rejectTolerance.rejectMinPercentage)) {
                return 'fail-percentage';
            }
            return 'counts-equipment-details';
        };
        vm.getEquipmentClass = function (equip) {
            if (!equip) {
                return '';
            }
            var rejectTolerance = equipmentRejectTolerances[equip.name];
            var equipmentClass = 'equip-status-good-box';
            if (equip.rejectCount && !!rejectTolerance
                && (Number(equip.rejectCount.percent) > rejectTolerance.rejectMaxPercentage
                    || Number(equip.rejectCount.percent) < rejectTolerance.rejectMinPercentage)) {
                equipmentClass = 'equip-status-error-box';
                if (vm.countsInterval == enums_1.apsDisplayEnums.CountDisplayInterval.CurrentHour
                    || vm.countsInterval == enums_1.apsDisplayEnums.CountDisplayInterval.CurrentShift
                    || vm.countsInterval == enums_1.apsDisplayEnums.CountDisplayInterval.RollingHour
                    || vm.countsInterval == enums_1.apsDisplayEnums.CountDisplayInterval.LastTwentyMinutes) {
                    equipmentClass = vm.blinkClass;
                }
            }
            return equipmentClass;
        };
        vm.getRowClass = function (equipment) {
            var rejectTolerance = equipmentRejectTolerances[equipment.name];
            var equipmentClass = '';
            if (equipment.rejectCount && !!rejectTolerance
                && (Number(equipment.rejectCount.percent) > rejectTolerance.rejectMaxPercentage
                    || Number(equipment.rejectCount.percent) < rejectTolerance.rejectMinPercentage)) {
                equipmentClass = 'rejectBgVerticals';
                if (vm.countsInterval == enums_1.apsDisplayEnums.CountDisplayInterval.CurrentHour
                    || vm.countsInterval == enums_1.apsDisplayEnums.CountDisplayInterval.CurrentShift
                    || vm.countsInterval == enums_1.apsDisplayEnums.CountDisplayInterval.RollingHour
                    || vm.countsInterval == enums_1.apsDisplayEnums.CountDisplayInterval.LastTwentyMinutes) {
                    equipmentClass = vm.blinkClass;
                }
                return equipmentClass;
            }
        };
        vm.toggleLineActive = function (line) {
            if (!vm.canDisableLine) {
                return;
            }
            var message = "Line " + line.name + " is currently " + (line.isDisabled ? 'disabled' : 'active') + ". "
                + ("Would you like to " + (line.isDisabled ? 'activate' : 'disable') + " it?");
            var subject = (line.isDisabled ? 'Activate' : 'Disable') + " Line " + line.name + "?";
            uiUtilityService.confirm(message, subject, 'Yes', 'No').then(function (confirmed) {
                if (!confirmed) {
                    return;
                }
                var promise = lineConfigsService.toggleLine({
                    id: line.id,
                    shopId: line.shopId,
                    isDisabled: !line.isDisabled
                }).then(function () { return line.isDisabled = !line.isDisabled; });
                loaderService.loadingPromise(promise);
            });
        };
        vm.viewRejectDetail = function (line, equipment) {
            var modalPromise = countsPromise;
            if (equipment.hasTabs || (equipment.detailDataPoints && equipment.detailDataPoints.length > 0)) {
                modalPromise = countsService.getEquipmentCounts(shopId, vm.model, equipment, vm.countsInterval)
                    .then(function (counts) {
                    vm.model.currentDetailCounts = counts;
                });
                loaderService.loadingPromise(modalPromise);
            }
            modalPromise.then(function () {
                var result = equipmentRejects_controller_1.openEquipmentRejects({
                    equipment: equipment,
                    line: line,
                    plant: vm.plant,
                    shopId: shopId,
                    canDisable: vm.canDisableLine,
                    detail: vm.model.currentDetailCounts,
                    lineConfig: vm.model
                }, $modal);
                result.then(function () {
                    if (vm.model.currentDetailCounts) {
                        delete vm.model.currentDetailCounts;
                    }
                });
            });
        };
        vm.viewGroupRejectDetail = function (equipmentGroup) {
            vm.model.currentGroup = equipmentGroup;
            groupRejectsService.showGroupRejects({
                equipmentGroup: equipmentGroup,
                shopId: vm.shop.id,
                lineCounts: vm.model,
                countsInterval: vm.countsInterval
            });
        };
        vm.countsIntervalChanged = function () {
            vm.model.handleIntervalChange(vm.countsInterval);
            authDataService.setCountInterval(vm.countsInterval);
            intervalMinutes = constant_module_1.Intervals.IntervalSeconds[vm.countsInterval];
            vm.updateDumpGateDuration();
        };
        var promise = countsPromise.then(function () {
            vm.hub = countsService.createHub(shopId, vm.model);
            $scope.$on('$destroy', function () {
                if (vm.hub) {
                    vm.hub.leaveGroup(shopId)
                        .then(function () { return vm.hub.uninitialize(); });
                }
            });
        });
        loaderService.loadingPromise(promise);
        return vm;
    }
    function mapLineToRow(line) {
        return {
            isLine: true,
            line: line,
            junction: null,
            cssClass: null
        };
    }
    function mapJunctionToRow(junction) {
        return {
            isLine: false,
            line: null,
            junction: junction,
            cssClass: 'table' + (junction.inputs.length > junction.outputs.length
                ? junction.inputs.length : junction.outputs.length).toString()
        };
    }
    function mapModelToAreas(model) {
        var areas = [];
        var area = {
            rows: _.sortBy(model.lines.filter(function (l) { return l.startJunctionId === null; }), function (r) { return r.number; })
                .map(function (l) { return mapLineToRow(l); })
        };
        var _loop_1 = function () {
            areas.push(area);
            var previousLines = area.rows.filter(function (l) { return l.isLine; }).map(function (l) { return l.line; });
            var rows = [];
            area.rows.forEach(function (row) {
                if (!row.isLine) {
                    _.sortBy(row.junction.outputs, function (l) { return l.number; }).forEach(function (line) {
                        rows.push(mapLineToRow(line));
                    });
                    return;
                }
                var junction = row.line.endJunction;
                if (!junction) {
                    return;
                }
                if (_.some(rows, function (r) { return !r.isLine && r.junction === junction; })) {
                    return;
                }
                if (!junction.inputs.every(function (l) { return _.some(previousLines, function (al) { return al.id === l.id; }); })) {
                    rows.push(mapLineToRow(row.line));
                }
                rows.push(mapJunctionToRow(junction));
            });
            area = { rows: rows };
        };
        while (area.rows.length > 0) {
            _loop_1();
        }
        return areas;
    }
    function getCountsHelpText(helpScreen) {
        var helptext = '';
        switch (helpScreen) {
            case 'EQUIPMENT COUNTS':
                helptext = "  \n\t\t\t<div class=\"header\">\n\t\t\t  Equipment Counts\n\t\t\t</div>         \n\t\t\t<div class=\"subheader\">\n\t\t\t  <u>How the Counts Work</u>:\n\t\t\t</div>\n\t\t\t<div class=\"detail\">\n\t\t\t\tBelow is a sample count object, this is sample data just for instructional purposes.\n\t\t\t</div>\n\t\t\t<div class=\"detail\">\n\t\t\t\t<table>\n\t\t\t\t\t<tbody>\n\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t\t<div class=\"bs-card\">\n\t\t\t\t\t\t\t\t\t<div class=\"equipment-name\">SQR</div>\n\t\t\t\t\t\t\t\t\t<div class=\"count\">11,328</div>\n\t\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t\t<span>166</span>\n\t\t\t\t\t\t\t\t\t\t<span class=\"fail-percentage\">1.5%</span>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t</tbody>\n\t\t\t\t</table>\n\t\t\t</div>\n\t\t\t<div class=\"detail\">\n\t\t\t\tAs you can see the count object is broken up into 4 different rows. Here is the definition of each row:\n\t\t\t</div>  \n\t\t\t<div class=\"detail\">\n\t\t\t\t<ol type = \"1\">\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>Equipment Shorthand:</b> This is a shorthand abreviation of the type of equipment configured on the line.\n\t\t\t\t\t\tIn this case this is a high speed squeezer. This is abreviated as SQR.\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>Inspect Count:</b> The number of bottles going into the machine.\n\t\t\t\t\t\tIn APS the preference is to use a direct integration to the machine for this counter.\n\t\t\t\t\t\tHowever, there are instances that we are dependent on a photoeye before the inspection equipment \n\t\t\t\t\t\tto provide the inspect count.\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>Reject Count:</b>\n\t\t\t\t\t\tThe amount of bottles rejected by the piece of inspection equipment.\n\t\t\t\t\t\tThis value is highlighted in <span class=\"red\">red</span> to help users quickly identify losses.\n\t\t\t\t\t\tFor most equipment we have a direct integration and the equipment keeps counts of rejects.\n\t\t\t\t\t\tHowever, for some equipment integrations we need to calculated it by taking the difference between\n\t\t\t\t\t\tbottles in and bottles out.\n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t<span class=\"formula\">Reject Count = Reject Count from Machine</span><br/>\n\t\t\t\t\t\t<span class=\"count\">- OR -</span><br/>\n\t\t\t\t\t\t<span class=\"formula\">Reject Count = Machine Bottles In - Machine Bottles Out</span><br/>\n\t\t\t\t\t </li>\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>Reject Percent:</b>\n\t\t\t\t\t\tThe percent of loss for each piece of equipment.\n\t\t\t\t\t\tThis calculation is based off the equipment inspects vs. the rejects.\n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t<span class=\"formula\">Reject Percent = Reject Count / Inspect Count</span><br/>\n\n\t\t\t\t\t\tOn each job run, an acceptable percentage range can be set for each equipment type. If the equipment has a tolerance set\n\t\t\t\t\t\tand the current value is outside those parameters, this value is highlighted in \n\t\t\t\t\t\t<span class=\"red\">red</span> to help users quickly identify issues.\n\t\t\t\t\t</li>\n\t\t\t\t</ol>\n\t\t\t</div>\n\t\t\t<div class=\"subheader\">\n\t\t\t\t<u>Equipment Details</u>:\n\t\t\t</div>   \n\t\t\t<div class=\"detail\">\n\t\t\t\tEvery piece of equipment has the ability to drill-down. \n\t\t\t\tAll the user has to do to access this data is to click on the peice of equipment.\n\t\t\t\tDepending on the type of integration some equipment will display more data than others.\n\t\t\t</div>\n\t\t  \t";
                break;
            case 'AREA EFFICIENCY':
                helptext = "  \n\t\t\t<div class=\"header\">\n\t\t\t  Area Efficiency\n\t\t\t</div>         \n\t\t\t<div class=\"subheader\">\n\t\t\t  <u>Metrics per Area</u>:\n\t\t\t</div>\n\t\t\t<div class=\"detail\">\n\t\t\t\tEach area of the production line will have the following metrics, where applicable.\n\t\t\t\tThe metric definitions are as follows.\n\t\t\t</div>\n\t\t\t<div class=\"detail\">\n\t\t\t\t<ol type = \"1\">\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>AREA IN:</b> \n\t\t\t\t\t\tThe total number of bottles going into each area.\n\t\t\t\t\t\tThis number is used as the denominator for efficiency calculations in each area.\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>AREA REJECTS:</b> \n\t\t\t\t\t\tThe total amount of bottles rejected in each area.\n\t\t\t\t\t\tThis value is highlighted in <span class=\"red\">red</span> to help users quickly identify losses.\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>AREA REJECT:</b>\n\t\t\t\t\t\tThe percent of loss for each area.\n\t\t\t\t\t\tThis value is highlighted in <span class=\"red\">red</span> to help users quickly identify losses.\n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t<span class=\"formula\">AREA REJECT = 100 * (Area Rejects / Area In)</span>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>AREA EFFICIENCY:</b>\n\t\t\t\t\t\tThe ammount of bottles to make it through each area compared to how many went in.\n\t\t\t\t\t\tThis is the inverse of the <i>AREA REJECT</i>.\n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t<span class=\"formula\">AREA REJECT = 100 - (100 * (Area Rejects / Area In))</span>\n\t\t\t\t\t</li>\n\t\t\t\t</ol>\n\t\t\t</div>\n\t\t  \t";
                break;
            case 'SHOP KPI':
                helptext = "  \n\t\t\t<div class=\"header\">\n\t\t\t  Shop KPI's\n\t\t\t</div>         \n\t\t\t<div class=\"subheader\">\n\t\t\t  <u>KPI Metric Definitions</u>:\n\t\t\t</div>\n\t\t\t<div class=\"detail\">\n\t\t\t\tThe goal of these KPI's is to see how the shop is performing at each point along the line.\n\t\t\t\tWe use each pulse from the shear cuts to calculate how many gobs are currently being produced.\n\t\t\t</div>\n\t\t\t<div class=\"detail\">\n\t\t\t\t<ol type = \"1\">\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>MACHINE SPEED:</b>\n\t\t\t\t\t\tHow many bottles per minute the machine is producing.\n\t\t\t\t\t\tWhen available we use direct machine integration.\n\t\t\t\t\t\tOtherwise, we use the shear pulses to estimate the speed.\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>LEHR IN %:</b> \n\t\t\t\t\t\tThe percent of bottles going into the lehr, against the shears.\n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t<span class=\"formula\">LEHR IN % = Lehr In Counter / Shears</span>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>LEHR OUT %:</b>\n\t\t\t\t\t\tThe percent of bottles comming out of the lehr, into the cold-end, against the shears.\n\t\t\t\t\t\tUsually we are using the sum of the first peice of inspection equipment.\n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t<span class=\"formula\">LEHR OUT % = Cold-End In / Shears</span>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>PACK %:</b>\n\t\t\t\t\t\tThe percent of bottles that make it to the End of Line (EOL), against the shears.\n\t\t\t\t\t\tThis is usually a photoeye, sometimes it can be the last piece of inspection equipment.\n\t\t\t\t\t\tIt depends on the shop configuration.\n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t<span class=\"formula\">PACK % = EOL / Shears</span>\n\t\t\t\t\t</li>\n\t\t\t\t</ol>\n\t\t\t</div>\n\t\t  \t";
                break;
            case 'WARE LOSS':
                helptext = "  \n\t\t\t<div class=\"header\">\n\t\t\t\tShop Ware Loss\n\t\t\t</div>         \n\t\t\t<div class=\"subheader\">\n\t\t\t\t<u>Shop Ware Loss Definitions</u>:\n\t\t\t</div>\n\t\t\t<div class=\"detail\">\n\t\t\t\tThe goal of these Metrics are quickly identify the areas of most loss compared to bottles created.\n\t\t\t\tWe use each pulse from the shear cuts to calculate how many gobs are produced at the hot-end.\n\t\t\t\tYour total loss should add up to all the other ware loss percentages.\n\t\t\t</div>\n\t\t\t<div class=\"detail\">\n\t\t\t\t<ol type = \"1\">\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>HOT END LOSS:</b>\n\t\t\t\t\t\tThe percent of the bottles produced that did not make it into the lehr.\n\t\t\t\t\t\tThis value is highlighted in <span class=\"red\">red</span> to help users quickly identify losses.\n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t<span class=\"formula\">HOT END LOSS = 100 - (100 * (LEHR IN / SHEARS))</span>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>LEHR LOSS:</b> \n\t\t\t\t\t\tThe percent of bottles that were lost in the lehr, over the shears.\n\t\t\t\t\t\tThis value is highlighted in <span class=\"red\">red</span> to help users quickly identify losses.\n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t<span class=\"formula\">LEHR LOSS = 100 - (100 * ((LEHR IN - LEHR OUT) / SHEARS))</span>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>AIE LOSS:</b>\n\t\t\t\t\t\tThe percent of bottles lost to all inspection equipment, over the shears.\n\t\t\t\t\t\tThis value is highlighted in <span class=\"red\">red</span> to help users quickly identify losses.\n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t<span class=\"formula\">AIE LOSS = 100 - (100 * (AIE LOSS / SHEARS))</span>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>CE DELTA LOSS:</b>\n\t\t\t\t\t\tThe percent of all bottles that made it into the cold end, \n\t\t\t\t\t\tthat were not rejected by inspection equipment,\n\t\t\t\t\t\tbut did not make it to the end of line,\n\t\t\t\t\t\tover the shears.\n\t\t\t\t\t\tThis value is highlighted in <span class=\"red\">red</span> to help users quickly identify losses.\n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t<span class=\"formula\">CE DELTA LOSS = 100 - (100 * (LEHR OUT - AIE LOSS - END OF LINE) / SHEARS)</span>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>TOTAL LOSS:</b>\n\t\t\t\t\t\tThe percent of bottles that did not make it to the End of Line (EOL), compared to the shears.\n\t\t\t\t\t\tThis is usually a photoeye, sometimes it can be the last piece of inspection equipment.\n\t\t\t\t\t\tIt depends on the shop configuration.\n\t\t\t\t\t\tThis value is highlighted in <span class=\"red\">red</span> to help users quickly identify losses.\n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t<span class=\"formula\">TOTAL LOSS = 100 - (100 * (END OF LINE / SHEARS))</span>\n\t\t\t\t\t</li>\n\t\t\t\t</ol>\n\t\t\t</div>\n\t\t  \t";
                break;
            default:
                helptext = 'Selected Help Screen Not Found...';
                break;
        }
        return helptext;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 95 */,
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 Highcharts JS v7.2.2 (2020-08-24)

 (c) 2009-2018 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(P,M){"object"===typeof module&&module.exports?(M["default"]=M,module.exports=P.document?M(P):M): true?!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return M(P)}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):(P.Highcharts&&P.Highcharts.error(16,!0),P.Highcharts=M(P))})("undefined"!==typeof window?window:this,function(P){function M(c,f,F,G){c.hasOwnProperty(f)||(c[f]=G.apply(null,F))}var I={};M(I,"parts/Globals.js",[],function(){var c="undefined"!==typeof P?P:"undefined"!==typeof window?window:{},f=c.document,
F=c.navigator&&c.navigator.userAgent||"",G=f&&f.createElementNS&&!!f.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect,z=/(edge|msie|trident)/i.test(F)&&!c.opera,B=-1!==F.indexOf("Firefox"),t=-1!==F.indexOf("Chrome"),v=B&&4>parseInt(F.split("Firefox/")[1],10);return{product:"Highcharts",version:"7.2.2",deg2rad:2*Math.PI/360,doc:f,hasBidiBug:v,hasTouch:!!c.TouchEvent,isMS:z,isWebKit:-1!==F.indexOf("AppleWebKit"),isFirefox:B,isChrome:t,isSafari:!t&&-1!==F.indexOf("Safari"),isTouchDevice:/(Mobile|Android|Windows Phone)/.test(F),
SVG_NS:"http://www.w3.org/2000/svg",chartCount:0,seriesTypes:{},symbolSizes:{},svg:G,win:c,marginNames:["plotTop","marginRight","marginBottom","plotLeft"],noop:function(){},charts:[],dateFormats:{}}});M(I,"parts/Utilities.js",[I["parts/Globals.js"]],function(c){function f(a,d){return parseInt(a,d||10)}function F(a){return"string"===typeof a}function G(a){a=Object.prototype.toString.call(a);return"[object Array]"===a||"[object Array Iterator]"===a}function z(a,d){return!!a&&"object"===typeof a&&(!d||
!G(a))}function B(a){return z(a)&&"number"===typeof a.nodeType}function t(a){var d=a&&a.constructor;return!(!z(a,!0)||B(a)||!d||!d.name||"Object"===d.name)}function v(a){return"number"===typeof a&&!isNaN(a)&&Infinity>a&&-Infinity<a}function C(a){return"undefined"!==typeof a&&null!==a}function H(a,d,e){var b;F(d)?C(e)?a.setAttribute(d,e):a&&a.getAttribute&&((b=a.getAttribute(d))||"class"!==d||(b=a.getAttribute(d+"Name"))):n(d,function(d,e){a.setAttribute(e,d)});return b}function y(a,d){var e;a||(a=
{});for(e in d)a[e]=d[e];return a}function h(){for(var a=arguments,d=a.length,e=0;e<d;e++){var b=a[e];if("undefined"!==typeof b&&null!==b)return b}}function n(a,d,e){for(var b in a)Object.hasOwnProperty.call(a,b)&&d.call(e||a[b],a[b],b,a)}c.timers=[];var q=c.charts,g=c.doc,b=c.win;c.error=function(a,d,e,l){var g=v(a),h=g?"Highcharts error #"+a+": www.highcharts.com/errors/"+a+"/":a.toString(),p=function(){if(d)throw Error(h);b.console&&console.log(h)};if("undefined"!==typeof l){var u="";g&&(h+="?");
c.objectEach(l,function(a,d){u+="\n"+d+": "+a;g&&(h+=encodeURI(d)+"="+encodeURI(a))});h+=u}e?c.fireEvent(e,"displayError",{code:a,message:h,params:l},p):p()};c.Fx=function(a,d,e){this.options=d;this.elem=a;this.prop=e};c.Fx.prototype={dSetter:function(){var a=this.paths[0],d=this.paths[1],e=[],b=this.now,g=a.length;if(1===b)e=this.toD;else if(g===d.length&&1>b)for(;g--;){var c=parseFloat(a[g]);e[g]=isNaN(c)||"A"===d[g-4]||"A"===d[g-5]?d[g]:b*parseFloat(""+(d[g]-c))+c}else e=d;this.elem.attr("d",e,
null,!0)},update:function(){var a=this.elem,d=this.prop,e=this.now,b=this.options.step;if(this[d+"Setter"])this[d+"Setter"]();else a.attr?a.element&&a.attr(d,e,null,!0):a.style[d]=e+this.unit;b&&b.call(a,e,this)},run:function(a,d,e){var l=this,g=l.options,h=function(a){return h.stopped?!1:l.step(a)},p=b.requestAnimationFrame||function(a){setTimeout(a,13)},u=function(){for(var a=0;a<c.timers.length;a++)c.timers[a]()||c.timers.splice(a--,1);c.timers.length&&p(u)};a!==d||this.elem["forceAnimate:"+this.prop]?
(this.startTime=+new Date,this.start=a,this.end=d,this.unit=e,this.now=this.start,this.pos=0,h.elem=this.elem,h.prop=this.prop,h()&&1===c.timers.push(h)&&p(u)):(delete g.curAnim[this.prop],g.complete&&0===Object.keys(g.curAnim).length&&g.complete.call(this.elem))},step:function(a){var d=+new Date,e=this.options,b=this.elem,g=e.complete,c=e.duration,p=e.curAnim;if(b.attr&&!b.element)a=!1;else if(a||d>=c+this.startTime){this.now=this.end;this.pos=1;this.update();var u=p[this.prop]=!0;n(p,function(a){!0!==
a&&(u=!1)});u&&g&&g.call(b);a=!1}else this.pos=e.easing((d-this.startTime)/c),this.now=this.start+(this.end-this.start)*this.pos,this.update(),a=!0;return a},initPath:function(a,d,e){function b(a){for(A=a.length;A--;){var d="M"===a[A]||"L"===a[A];var e=/[a-zA-Z]/.test(a[A+3]);d&&e&&a.splice(A+1,0,a[A+1],a[A+2],a[A+1],a[A+2])}}function g(a,d){for(;a.length<h;){a[0]=d[h-a.length];var e=a.slice(0,r);[].splice.apply(a,[0,0].concat(e));w&&(e=a.slice(a.length-r),[].splice.apply(a,[a.length,0].concat(e)),
A--)}a[0]="M"}function c(a,d){for(var e=(h-a.length)/r;0<e&&e--;)x=a.slice().splice(a.length/m-r,r*m),x[0]=d[h-r-e*r],k&&(x[r-6]=x[r-2],x[r-5]=x[r-1]),[].splice.apply(a,[a.length/m,0].concat(x)),w&&e--}d=d||"";var p=a.startX,u=a.endX,k=-1<d.indexOf("C"),r=k?7:3,x,A;d=d.split(" ");e=e.slice();var w=a.isArea,m=w?2:1;k&&(b(d),b(e));if(p&&u){for(A=0;A<p.length;A++)if(p[A]===u[0]){var K=A;break}else if(p[0]===u[u.length-p.length+A]){K=A;var J=!0;break}else if(p[p.length-1]===u[u.length-p.length+A]){K=
p.length-A;break}"undefined"===typeof K&&(d=[])}if(d.length&&v(K)){var h=e.length+K*m*r;J?(g(d,e),c(e,d)):(g(e,d),c(d,e))}return[d,e]},fillSetter:function(){c.Fx.prototype.strokeSetter.apply(this,arguments)},strokeSetter:function(){this.elem.attr(this.prop,c.color(this.start).tweenTo(c.color(this.end),this.pos),null,!0)}};c.merge=function(){var a,d=arguments,e={},b=function(a,d){"object"!==typeof a&&(a={});n(d,function(e,k){!z(e,!0)||t(e)||B(e)?a[k]=d[k]:a[k]=b(a[k]||{},e)});return a};!0===d[0]&&
(e=d[1],d=Array.prototype.slice.call(d,2));var g=d.length;for(a=0;a<g;a++)e=b(e,d[a]);return e};c.clearTimeout=function(a){C(a)&&clearTimeout(a)};c.css=function(a,d){c.isMS&&!c.svg&&d&&"undefined"!==typeof d.opacity&&(d.filter="alpha(opacity="+100*d.opacity+")");y(a.style,d)};c.createElement=function(a,d,e,b,L){a=g.createElement(a);var l=c.css;d&&y(a,d);L&&l(a,{padding:"0",border:"none",margin:"0"});e&&l(a,e);b&&b.appendChild(a);return a};c.extendClass=function(a,d){var e=function(){};e.prototype=
new a;y(e.prototype,d);return e};c.pad=function(a,d,e){return Array((d||2)+1-String(a).replace("-","").length).join(e||"0")+a};c.relativeLength=function(a,d,e){return/%$/.test(a)?d*parseFloat(a)/100+(e||0):parseFloat(a)};c.wrap=function(a,d,e){var b=a[d];a[d]=function(){var a=Array.prototype.slice.call(arguments),d=arguments,l=this;l.proceed=function(){b.apply(l,arguments.length?arguments:d)};a.unshift(b);a=e.apply(this,a);l.proceed=null;return a}};c.datePropsToTimestamps=function(a){n(a,function(d,
e){z(d)&&"function"===typeof d.getTime?a[e]=d.getTime():(z(d)||G(d))&&c.datePropsToTimestamps(d)})};c.formatSingle=function(a,d,e){var b=/\.([0-9])/,g=c.defaultOptions.lang;/f$/.test(a)?(e=(e=a.match(b))?e[1]:-1,null!==d&&(d=c.numberFormat(d,e,g.decimalPoint,-1<a.indexOf(",")?g.thousandsSep:""))):d=(e||c.time).dateFormat(a,d);return d};c.format=function(a,d,e){for(var b="{",g=!1,h,p,u,k,r=[],x;a;){b=a.indexOf(b);if(-1===b)break;h=a.slice(0,b);if(g){h=h.split(":");p=h.shift().split(".");k=p.length;
x=d;for(u=0;u<k;u++)x&&(x=x[p[u]]);h.length&&(x=c.formatSingle(h.join(":"),x,e));r.push(x)}else r.push(h);a=a.slice(b+1);b=(g=!g)?"}":"{"}r.push(a);return r.join("")};c.getMagnitude=function(a){return Math.pow(10,Math.floor(Math.log(a)/Math.LN10))};c.normalizeTickInterval=function(a,d,e,b,g){var l=a;e=h(e,1);var p=a/e;d||(d=g?[1,1.2,1.5,2,2.5,3,4,5,6,8,10]:[1,2,2.5,5,10],!1===b&&(1===e?d=d.filter(function(a){return 0===a%1}):.1>=e&&(d=[1/e])));for(b=0;b<d.length&&!(l=d[b],g&&l*e>=a||!g&&p<=(d[b]+
(d[b+1]||d[b]))/2);b++);return l=c.correctFloat(l*e,-Math.round(Math.log(.001)/Math.LN10))};c.stableSort=function(a,d){var b=a.length,l,g;for(g=0;g<b;g++)a[g].safeI=g;a.sort(function(a,b){l=d(a,b);return 0===l?a.safeI-b.safeI:l});for(g=0;g<b;g++)delete a[g].safeI};c.correctFloat=function(a,d){return parseFloat(a.toPrecision(d||14))};c.animObject=function(a){return z(a)?c.merge(a):{duration:a?500:0}};c.timeUnits={millisecond:1,second:1E3,minute:6E4,hour:36E5,day:864E5,week:6048E5,month:24192E5,year:314496E5};
c.numberFormat=function(a,d,b,l){a=+a||0;d=+d;var e=c.defaultOptions.lang,g=(a.toString().split(".")[1]||"").split("e")[0].length,p=a.toString().split("e");if(-1===d)d=Math.min(g,20);else if(!v(d))d=2;else if(d&&p[1]&&0>p[1]){var u=d+ +p[1];0<=u?(p[0]=(+p[0]).toExponential(u).split("e")[0],d=u):(p[0]=p[0].split(".")[0]||0,a=20>d?(p[0]*Math.pow(10,p[1])).toFixed(d):0,p[1]=0)}var k=(Math.abs(p[1]?p[0]:a)+Math.pow(10,-Math.max(d,g)-1)).toFixed(d);g=String(f(k));u=3<g.length?g.length%3:0;b=h(b,e.decimalPoint);
l=h(l,e.thousandsSep);a=(0>a?"-":"")+(u?g.substr(0,u)+l:"");a+=g.substr(u).replace(/(\d{3})(?=\d)/g,"$1"+l);d&&(a+=b+k.slice(-d));p[1]&&0!==+a&&(a+="e"+p[1]);return a};Math.easeInOutSine=function(a){return-.5*(Math.cos(Math.PI*a)-1)};c.getStyle=function(a,d,e){if("width"===d)return d=Math.min(a.offsetWidth,a.scrollWidth),e=a.getBoundingClientRect&&a.getBoundingClientRect().width,e<d&&e>=d-1&&(d=Math.floor(e)),Math.max(0,d-c.getStyle(a,"padding-left")-c.getStyle(a,"padding-right"));if("height"===d)return Math.max(0,
Math.min(a.offsetHeight,a.scrollHeight)-c.getStyle(a,"padding-top")-c.getStyle(a,"padding-bottom"));b.getComputedStyle||c.error(27,!0);if(a=b.getComputedStyle(a,void 0))a=a.getPropertyValue(d),h(e,"opacity"!==d)&&(a=f(a));return a};c.inArray=function(a,d,b){return d.indexOf(a,b)};c.find=Array.prototype.find?function(a,d){return a.find(d)}:function(a,d){var b,l=a.length;for(b=0;b<l;b++)if(d(a[b],b))return a[b]};c.keys=Object.keys;c.offset=function(a){var d=g.documentElement;a=a.parentElement||a.parentNode?
a.getBoundingClientRect():{top:0,left:0};return{top:a.top+(b.pageYOffset||d.scrollTop)-(d.clientTop||0),left:a.left+(b.pageXOffset||d.scrollLeft)-(d.clientLeft||0)}};c.stop=function(a,b){for(var d=c.timers.length;d--;)c.timers[d].elem!==a||b&&b!==c.timers[d].prop||(c.timers[d].stopped=!0)};n({map:"map",each:"forEach",grep:"filter",reduce:"reduce",some:"some"},function(a,b){c[b]=function(b){return Array.prototype[a].apply(b,[].slice.call(arguments,1))}});c.addEvent=function(a,b,e,l){void 0===l&&(l=
{});var d=a.addEventListener||c.addEventListenerPolyfill;var g="function"===typeof a&&a.prototype?a.prototype.protoEvents=a.prototype.protoEvents||{}:a.hcEvents=a.hcEvents||{};c.Point&&a instanceof c.Point&&a.series&&a.series.chart&&(a.series.chart.runTrackerClick=!0);d&&d.call(a,b,e,!1);g[b]||(g[b]=[]);g[b].push({fn:e,order:"number"===typeof l.order?l.order:Infinity});g[b].sort(function(a,b){return a.order-b.order});return function(){c.removeEvent(a,b,e)}};c.removeEvent=function(a,b,e){function d(b,
d){var e=a.removeEventListener||c.removeEventListenerPolyfill;e&&e.call(a,b,d,!1)}function g(e){var l;if(a.nodeName){if(b){var k={};k[b]=!0}else k=e;n(k,function(a,b){if(e[b])for(l=e[b].length;l--;)d(b,e[b][l].fn)})}}var h;["protoEvents","hcEvents"].forEach(function(l,c){var k=(c=c?a:a.prototype)&&c[l];k&&(b?(h=k[b]||[],e?(k[b]=h.filter(function(a){return e!==a.fn}),d(b,e)):(g(k),k[b]=[])):(g(k),c[l]={}))})};c.fireEvent=function(a,b,e,l){var d;e=e||{};if(g.createEvent&&(a.dispatchEvent||a.fireEvent)){var c=
g.createEvent("Events");c.initEvent(b,!0,!0);y(c,e);a.dispatchEvent?a.dispatchEvent(c):a.fireEvent(b,c)}else e.target||y(e,{preventDefault:function(){e.defaultPrevented=!0},target:a,type:b}),function(b,l){void 0===b&&(b=[]);void 0===l&&(l=[]);var k=0,r=0,g=b.length+l.length;for(d=0;d<g;d++)!1===(b[k]?l[r]?b[k].order<=l[r].order?b[k++]:l[r++]:b[k++]:l[r++]).fn.call(a,e)&&e.preventDefault()}(a.protoEvents&&a.protoEvents[b],a.hcEvents&&a.hcEvents[b]);l&&!e.defaultPrevented&&l.call(a,e)};c.animate=function(a,
b,e){var d,g="",h,p;if(!z(e)){var u=arguments;e={duration:u[2],easing:u[3],complete:u[4]}}v(e.duration)||(e.duration=400);e.easing="function"===typeof e.easing?e.easing:Math[e.easing]||Math.easeInOutSine;e.curAnim=c.merge(b);n(b,function(k,l){c.stop(a,l);p=new c.Fx(a,e,l);h=null;"d"===l?(p.paths=p.initPath(a,a.d,b.d),p.toD=b.d,d=0,h=1):a.attr?d=a.attr(l):(d=parseFloat(c.getStyle(a,l))||0,"opacity"!==l&&(g="px"));h||(h=k);h&&h.match&&h.match("px")&&(h=h.replace(/px/g,""));p.run(d,h,g)})};c.seriesType=
function(a,b,e,l,g){var d=c.getOptions(),p=c.seriesTypes;d.plotOptions[a]=c.merge(d.plotOptions[b],e);p[a]=c.extendClass(p[b]||function(){},l);p[a].prototype.type=a;g&&(p[a].prototype.pointClass=c.extendClass(c.Point,g));return p[a]};c.uniqueKey=function(){var a=Math.random().toString(36).substring(2,9),b=0;return function(){return"highcharts-"+a+"-"+b++}}();c.isFunction=function(a){return"function"===typeof a};b.jQuery&&(b.jQuery.fn.highcharts=function(){var a=[].slice.call(arguments);if(this[0])return a[0]?
(new (c[F(a[0])?a.shift():"Chart"])(this[0],a[0],a[1]),this):q[H(this[0],"data-highcharts-chart")]});return{arrayMax:function(a){for(var b=a.length,e=a[0];b--;)a[b]>e&&(e=a[b]);return e},arrayMin:function(a){for(var b=a.length,e=a[0];b--;)a[b]<e&&(e=a[b]);return e},attr:H,defined:C,destroyObjectProperties:function(a,b){n(a,function(d,l){d&&d!==b&&d.destroy&&d.destroy();delete a[l]})},discardElement:function(a){var b=c.garbageBin;b||(b=c.createElement("div"));a&&b.appendChild(a);b.innerHTML=""},erase:function(a,
b){for(var d=a.length;d--;)if(a[d]===b){a.splice(d,1);break}},extend:y,isArray:G,isClass:t,isDOMElement:B,isNumber:v,isObject:z,isString:F,objectEach:n,pick:h,pInt:f,setAnimation:function(a,b){b.renderer.globalAnimation=h(a,b.options.chart.animation,!0)},splat:function(a){return G(a)?a:[a]},syncTimeout:function(a,b,e){if(0<b)return setTimeout(a,b,e);a.call(0,e);return-1}}});M(I,"parts/Color.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.isNumber,G=f.pInt,z=c.merge;c.Color=
function(f){if(!(this instanceof c.Color))return new c.Color(f);this.init(f)};c.Color.prototype={parsers:[{regex:/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,parse:function(c){return[G(c[1]),G(c[2]),G(c[3]),parseFloat(c[4],10)]}},{regex:/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,parse:function(c){return[G(c[1]),G(c[2]),G(c[3]),1]}}],names:{white:"#ffffff",black:"#000000"},init:function(f){var t,v;if((this.input=f=this.names[f&&
f.toLowerCase?f.toLowerCase():""]||f)&&f.stops)this.stops=f.stops.map(function(f){return new c.Color(f[1])});else{if(f&&f.charAt&&"#"===f.charAt()){var C=f.length;f=parseInt(f.substr(1),16);7===C?t=[(f&16711680)>>16,(f&65280)>>8,f&255,1]:4===C&&(t=[(f&3840)>>4|(f&3840)>>8,(f&240)>>4|f&240,(f&15)<<4|f&15,1])}if(!t)for(v=this.parsers.length;v--&&!t;){var B=this.parsers[v];(C=B.regex.exec(f))&&(t=B.parse(C))}}this.rgba=t||[]},get:function(c){var f=this.input,v=this.rgba;if(this.stops){var C=z(f);C.stops=
[].concat(C.stops);this.stops.forEach(function(f,v){C.stops[v]=[C.stops[v][0],f.get(c)]})}else C=v&&F(v[0])?"rgb"===c||!c&&1===v[3]?"rgb("+v[0]+","+v[1]+","+v[2]+")":"a"===c?v[3]:"rgba("+v.join(",")+")":f;return C},brighten:function(c){var f,v=this.rgba;if(this.stops)this.stops.forEach(function(f){f.brighten(c)});else if(F(c)&&0!==c)for(f=0;3>f;f++)v[f]+=G(255*c),0>v[f]&&(v[f]=0),255<v[f]&&(v[f]=255);return this},setOpacity:function(c){this.rgba[3]=c;return this},tweenTo:function(c,f){var v=this.rgba,
t=c.rgba;t.length&&v&&v.length?(c=1!==t[3]||1!==v[3],f=(c?"rgba(":"rgb(")+Math.round(t[0]+(v[0]-t[0])*(1-f))+","+Math.round(t[1]+(v[1]-t[1])*(1-f))+","+Math.round(t[2]+(v[2]-t[2])*(1-f))+(c?","+(t[3]+(v[3]-t[3])*(1-f)):"")+")"):f=c.input||"none";return f}};c.color=function(f){return new c.Color(f)}});M(I,"parts/SvgRenderer.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.attr,G=f.defined,z=f.destroyObjectProperties,B=f.erase,t=f.extend,v=f.isArray,C=f.isNumber,H=f.isObject,
y=f.isString,h=f.objectEach,n=f.pick,q=f.pInt,g=f.splat,b=c.addEvent,a=c.animate,d=c.charts,e=c.color,l=c.css,L=c.createElement,E=c.deg2rad,p=c.doc,u=c.hasTouch,k=c.isFirefox,r=c.isMS,x=c.isWebKit,A=c.merge,w=c.noop,m=c.removeEvent,K=c.stop,J=c.svg,U=c.SVG_NS,S=c.symbolSizes,Q=c.win;var O=c.SVGElement=function(){return this};t(O.prototype,{opacity:1,SVG_NS:U,textProps:"direction fontSize fontWeight fontFamily fontStyle color lineHeight width textAlign textDecoration textOverflow textOutline cursor".split(" "),
init:function(a,b){this.element="span"===b?L(b):p.createElementNS(this.SVG_NS,b);this.renderer=a;c.fireEvent(this,"afterInit")},animate:function(b,d,m){var D=c.animObject(n(d,this.renderer.globalAnimation,!0));n(p.hidden,p.msHidden,p.webkitHidden,!1)&&(D.duration=0);0!==D.duration?(m&&(D.complete=m),a(this,b,D)):(this.attr(b,void 0,m),h(b,function(a,b){D.step&&D.step.call(this,a,{prop:b,pos:1})},this));return this},complexColor:function(a,b,d){var D=this.renderer,m,e,w,N,k,l,g,r,x,p,K,J=[],T;c.fireEvent(this.renderer,
"complexColor",{args:arguments},function(){a.radialGradient?e="radialGradient":a.linearGradient&&(e="linearGradient");e&&(w=a[e],k=D.gradients,g=a.stops,p=d.radialReference,v(w)&&(a[e]=w={x1:w[0],y1:w[1],x2:w[2],y2:w[3],gradientUnits:"userSpaceOnUse"}),"radialGradient"===e&&p&&!G(w.gradientUnits)&&(N=w,w=A(w,D.getRadialAttr(p,N),{gradientUnits:"userSpaceOnUse"})),h(w,function(a,b){"id"!==b&&J.push(b,a)}),h(g,function(a){J.push(a)}),J=J.join(","),k[J]?K=k[J].attr("id"):(w.id=K=c.uniqueKey(),k[J]=l=
D.createElement(e).attr(w).add(D.defs),l.radAttr=N,l.stops=[],g.forEach(function(a){0===a[1].indexOf("rgba")?(m=c.color(a[1]),r=m.get("rgb"),x=m.get("a")):(r=a[1],x=1);a=D.createElement("stop").attr({offset:a[0],"stop-color":r,"stop-opacity":x}).add(l);l.stops.push(a)})),T="url("+D.url+"#"+K+")",d.setAttribute(b,T),d.gradient=J,a.toString=function(){return T})})},applyTextOutline:function(a){var b=this.element,D;-1!==a.indexOf("contrast")&&(a=a.replace(/contrast/g,this.renderer.getContrast(b.style.fill)));
a=a.split(" ");var d=a[a.length-1];if((D=a[0])&&"none"!==D&&c.svg){this.fakeTS=!0;a=[].slice.call(b.getElementsByTagName("tspan"));this.ySetter=this.xSetter;D=D.replace(/(^[\d\.]+)(.*?)$/g,function(a,b,D){return 2*b+D});this.removeTextOutline(a);var m=b.firstChild;a.forEach(function(a,e){0===e&&(a.setAttribute("x",b.getAttribute("x")),e=b.getAttribute("y"),a.setAttribute("y",e||0),null===e&&b.setAttribute("y",0));a=a.cloneNode(1);F(a,{"class":"highcharts-text-outline",fill:d,stroke:d,"stroke-width":D,
"stroke-linejoin":"round"});b.insertBefore(a,m)})}},removeTextOutline:function(a){for(var b=a.length,D;b--;)D=a[b],"highcharts-text-outline"===D.getAttribute("class")&&B(a,this.element.removeChild(D))},symbolCustomAttribs:"x y width height r start end innerR anchorX anchorY rounded".split(" "),attr:function(a,b,d,e){var D=this.element,m,w=this,N,k,l=this.symbolCustomAttribs;if("string"===typeof a&&void 0!==b){var g=a;a={};a[g]=b}"string"===typeof a?w=(this[a+"Getter"]||this._defaultGetter).call(this,
a,D):(h(a,function(b,d){N=!1;e||K(this,d);this.symbolName&&-1!==c.inArray(d,l)&&(m||(this.symbolAttr(a),m=!0),N=!0);!this.rotation||"x"!==d&&"y"!==d||(this.doTransform=!0);N||(k=this[d+"Setter"]||this._defaultSetter,k.call(this,b,d,D),!this.styledMode&&this.shadows&&/^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(d)&&this.updateShadows(d,b,k))},this),this.afterSetters());d&&d.call(this);return w},afterSetters:function(){this.doTransform&&(this.updateTransform(),this.doTransform=!1)},updateShadows:function(a,
b,d){for(var D=this.shadows,e=D.length;e--;)d.call(D[e],"height"===a?Math.max(b-(D[e].cutHeight||0),0):"d"===a?this.d:b,a,D[e])},addClass:function(a,b){var D=b?"":this.attr("class")||"";a=(a||"").split(/ /g).reduce(function(a,b){-1===D.indexOf(b)&&a.push(b);return a},D?[D]:[]).join(" ");a!==D&&this.attr("class",a);return this},hasClass:function(a){return-1!==(this.attr("class")||"").split(" ").indexOf(a)},removeClass:function(a){return this.attr("class",(this.attr("class")||"").replace(y(a)?new RegExp(" ?"+
a+" ?"):a,""))},symbolAttr:function(a){var b=this;"x y r start end width height innerR anchorX anchorY clockwise".split(" ").forEach(function(D){b[D]=n(a[D],b[D])});b.attr({d:b.renderer.symbols[b.symbolName](b.x,b.y,b.width,b.height,b)})},clip:function(a){return this.attr("clip-path",a?"url("+this.renderer.url+"#"+a.id+")":"none")},crisp:function(a,b){b=b||a.strokeWidth||0;var D=Math.round(b)%2/2;a.x=Math.floor(a.x||this.x||0)+D;a.y=Math.floor(a.y||this.y||0)+D;a.width=Math.floor((a.width||this.width||
0)-2*D);a.height=Math.floor((a.height||this.height||0)-2*D);G(a.strokeWidth)&&(a.strokeWidth=b);return a},css:function(a){var b=this.styles,D={},d=this.element,e="",m=!b,w=["textOutline","textOverflow","width"];a&&a.color&&(a.fill=a.color);b&&h(a,function(a,d){a!==b[d]&&(D[d]=a,m=!0)});if(m){b&&(a=t(b,D));if(a)if(null===a.width||"auto"===a.width)delete this.textWidth;else if("text"===d.nodeName.toLowerCase()&&a.width)var k=this.textWidth=q(a.width);this.styles=a;k&&!J&&this.renderer.forExport&&delete a.width;
if(d.namespaceURI===this.SVG_NS){var g=function(a,b){return"-"+b.toLowerCase()};h(a,function(a,b){-1===w.indexOf(b)&&(e+=b.replace(/([A-Z])/g,g)+":"+a+";")});e&&F(d,"style",e)}else l(d,a);this.added&&("text"===this.element.nodeName&&this.renderer.buildText(this),a&&a.textOutline&&this.applyTextOutline(a.textOutline))}return this},getStyle:function(a){return Q.getComputedStyle(this.element||this,"").getPropertyValue(a)},strokeWidth:function(){if(!this.renderer.styledMode)return this["stroke-width"]||
0;var a=this.getStyle("stroke-width");if(a.indexOf("px")===a.length-2)a=q(a);else{var b=p.createElementNS(U,"rect");F(b,{width:a,"stroke-width":0});this.element.parentNode.appendChild(b);a=b.getBBox().width;b.parentNode.removeChild(b)}return a},on:function(a,b){var d=this,D=d.element;u&&"click"===a?(D.ontouchstart=function(a){d.touchEventFired=Date.now();a.preventDefault();b.call(D,a)},D.onclick=function(a){(-1===Q.navigator.userAgent.indexOf("Android")||1100<Date.now()-(d.touchEventFired||0))&&b.call(D,
a)}):D["on"+a]=b;return this},setRadialReference:function(a){var b=this.renderer.gradients[this.element.gradient];this.element.radialReference=a;b&&b.radAttr&&b.animate(this.renderer.getRadialAttr(a,b.radAttr));return this},translate:function(a,b){return this.attr({translateX:a,translateY:b})},invert:function(a){this.inverted=a;this.updateTransform();return this},updateTransform:function(){var a=this.translateX||0,b=this.translateY||0,d=this.scaleX,e=this.scaleY,m=this.inverted,w=this.rotation,k=
this.matrix,l=this.element;m&&(a+=this.width,b+=this.height);a=["translate("+a+","+b+")"];G(k)&&a.push("matrix("+k.join(",")+")");m?a.push("rotate(90) scale(-1,1)"):w&&a.push("rotate("+w+" "+n(this.rotationOriginX,l.getAttribute("x"),0)+" "+n(this.rotationOriginY,l.getAttribute("y")||0)+")");(G(d)||G(e))&&a.push("scale("+n(d,1)+" "+n(e,1)+")");a.length&&l.setAttribute("transform",a.join(" "))},toFront:function(){var a=this.element;a.parentNode.appendChild(a);return this},align:function(a,b,d){var e,
m={};var D=this.renderer;var w=D.alignedObjects;var k,l;if(a){if(this.alignOptions=a,this.alignByTranslate=b,!d||y(d))this.alignTo=e=d||"renderer",B(w,this),w.push(this),d=null}else a=this.alignOptions,b=this.alignByTranslate,e=this.alignTo;d=n(d,D[e],D);e=a.align;D=a.verticalAlign;w=(d.x||0)+(a.x||0);var N=(d.y||0)+(a.y||0);"right"===e?k=1:"center"===e&&(k=2);k&&(w+=(d.width-(a.width||0))/k);m[b?"translateX":"x"]=Math.round(w);"bottom"===D?l=1:"middle"===D&&(l=2);l&&(N+=(d.height-(a.height||0))/
l);m[b?"translateY":"y"]=Math.round(N);this[this.placed?"animate":"attr"](m);this.placed=!0;this.alignAttr=m;return this},getBBox:function(a,b){var d,e=this.renderer,m=this.element,D=this.styles,w=this.textStr,k,l=e.cache,N=e.cacheKeys,g=m.namespaceURI===this.SVG_NS;b=n(b,this.rotation,0);var r=e.styledMode?m&&O.prototype.getStyle.call(m,"font-size"):D&&D.fontSize;if(G(w)){var c=w.toString();-1===c.indexOf("<")&&(c=c.replace(/[0-9]/g,"0"));c+=["",b,r,this.textWidth,D&&D.textOverflow].join()}c&&!a&&
(d=l[c]);if(!d){if(g||e.forExport){try{(k=this.fakeTS&&function(a){[].forEach.call(m.querySelectorAll(".highcharts-text-outline"),function(b){b.style.display=a})})&&k("none"),d=m.getBBox?t({},m.getBBox()):{width:m.offsetWidth,height:m.offsetHeight},k&&k("")}catch(aa){""}if(!d||0>d.width)d={width:0,height:0}}else d=this.htmlGetBBox();e.isSVG&&(a=d.width,e=d.height,g&&(d.height=e={"11px,17":14,"13px,20":16}[D&&D.fontSize+","+Math.round(e)]||e),b&&(D=b*E,d.width=Math.abs(e*Math.sin(D))+Math.abs(a*Math.cos(D)),
d.height=Math.abs(e*Math.cos(D))+Math.abs(a*Math.sin(D))));if(c&&0<d.height){for(;250<N.length;)delete l[N.shift()];l[c]||N.push(c);l[c]=d}}return d},show:function(a){return this.attr({visibility:a?"inherit":"visible"})},hide:function(a){a?this.attr({y:-9999}):this.attr({visibility:"hidden"});return this},fadeOut:function(a){var b=this;b.animate({opacity:0},{duration:a||150,complete:function(){b.attr({y:-9999})}})},add:function(a){var b=this.renderer,d=this.element;a&&(this.parentGroup=a);this.parentInverted=
a&&a.inverted;void 0!==this.textStr&&b.buildText(this);this.added=!0;if(!a||a.handleZ||this.zIndex)var e=this.zIndexSetter();e||(a?a.element:b.box).appendChild(d);if(this.onAdd)this.onAdd();return this},safeRemoveChild:function(a){var b=a.parentNode;b&&b.removeChild(a)},destroy:function(){var a=this,b=a.element||{},d=a.renderer,e=d.isSVG&&"SPAN"===b.nodeName&&a.parentGroup,m=b.ownerSVGElement,w=a.clipPath;b.onclick=b.onmouseout=b.onmouseover=b.onmousemove=b.point=null;K(a);w&&m&&([].forEach.call(m.querySelectorAll("[clip-path],[CLIP-PATH]"),
function(a){-1<a.getAttribute("clip-path").indexOf(w.element.id)&&a.removeAttribute("clip-path")}),a.clipPath=w.destroy());if(a.stops){for(m=0;m<a.stops.length;m++)a.stops[m]=a.stops[m].destroy();a.stops=null}a.safeRemoveChild(b);for(d.styledMode||a.destroyShadows();e&&e.div&&0===e.div.childNodes.length;)b=e.parentGroup,a.safeRemoveChild(e.div),delete e.div,e=b;a.alignTo&&B(d.alignedObjects,a);h(a,function(b,d){a[d]&&a[d].parentGroup===a&&a[d].destroy&&a[d].destroy();delete a[d]})},shadow:function(a,
b,d){var e=[],m,w=this.element;if(!a)this.destroyShadows();else if(!this.shadows){var D=n(a.width,3);var k=(a.opacity||.15)/D;var l=this.parentInverted?"(-1,-1)":"("+n(a.offsetX,1)+", "+n(a.offsetY,1)+")";for(m=1;m<=D;m++){var g=w.cloneNode(0);var r=2*D+1-2*m;F(g,{stroke:a.color||"#000000","stroke-opacity":k*m,"stroke-width":r,transform:"translate"+l,fill:"none"});g.setAttribute("class",(g.getAttribute("class")||"")+" highcharts-shadow");d&&(F(g,"height",Math.max(F(g,"height")-r,0)),g.cutHeight=r);
b?b.element.appendChild(g):w.parentNode&&w.parentNode.insertBefore(g,w);e.push(g)}this.shadows=e}return this},destroyShadows:function(){(this.shadows||[]).forEach(function(a){this.safeRemoveChild(a)},this);this.shadows=void 0},xGetter:function(a){"circle"===this.element.nodeName&&("x"===a?a="cx":"y"===a&&(a="cy"));return this._defaultGetter(a)},_defaultGetter:function(a){a=n(this[a+"Value"],this[a],this.element?this.element.getAttribute(a):null,0);/^[\-0-9\.]+$/.test(a)&&(a=parseFloat(a));return a},
dSetter:function(a,b,d){a&&a.join&&(a=a.join(" "));/(NaN| {2}|^$)/.test(a)&&(a="M 0 0");this[b]!==a&&(d.setAttribute(b,a),this[b]=a)},dashstyleSetter:function(a){var b,d=this["stroke-width"];"inherit"===d&&(d=1);if(a=a&&a.toLowerCase()){a=a.replace("shortdashdotdot","3,1,1,1,1,1,").replace("shortdashdot","3,1,1,1").replace("shortdot","1,1,").replace("shortdash","3,1,").replace("longdash","8,3,").replace(/dot/g,"1,3,").replace("dash","4,3,").replace(/,$/,"").split(",");for(b=a.length;b--;)a[b]=q(a[b])*
d;a=a.join(",").replace(/NaN/g,"none");this.element.setAttribute("stroke-dasharray",a)}},alignSetter:function(a){var b={left:"start",center:"middle",right:"end"};b[a]&&(this.alignValue=a,this.element.setAttribute("text-anchor",b[a]))},opacitySetter:function(a,b,d){this[b]=a;d.setAttribute(b,a)},titleSetter:function(a){var b=this.element.getElementsByTagName("title")[0];b||(b=p.createElementNS(this.SVG_NS,"title"),this.element.appendChild(b));b.firstChild&&b.removeChild(b.firstChild);b.appendChild(p.createTextNode(String(n(a,
"")).replace(/<[^>]*>/g,"").replace(/&lt;/g,"<").replace(/&gt;/g,">")))},textSetter:function(a){a!==this.textStr&&(delete this.bBox,delete this.textPxLength,this.textStr=a,this.added&&this.renderer.buildText(this))},setTextPath:function(a,b){var d=this.element,e={textAnchor:"text-anchor"},m=!1,D=this.textPathWrapper,k=!D;b=A(!0,{enabled:!0,attributes:{dy:-5,startOffset:"50%",textAnchor:"middle"}},b);var l=b.attributes;if(a&&b&&b.enabled){this.options&&this.options.padding&&(l.dx=-this.options.padding);
D||(this.textPathWrapper=D=this.renderer.createElement("textPath"),m=!0);var g=D.element;(b=a.element.getAttribute("id"))||a.element.setAttribute("id",b=c.uniqueKey());if(k)for(a=d.getElementsByTagName("tspan");a.length;)a[0].setAttribute("y",0),g.appendChild(a[0]);m&&D.add({element:this.text?this.text.element:d});g.setAttributeNS("http://www.w3.org/1999/xlink","href",this.renderer.url+"#"+b);G(l.dy)&&(g.parentNode.setAttribute("dy",l.dy),delete l.dy);G(l.dx)&&(g.parentNode.setAttribute("dx",l.dx),
delete l.dx);h(l,function(a,b){g.setAttribute(e[b]||b,a)});d.removeAttribute("transform");this.removeTextOutline.call(D,[].slice.call(d.getElementsByTagName("tspan")));this.text&&!this.renderer.styledMode&&this.attr({fill:"none","stroke-width":0});this.applyTextOutline=this.updateTransform=w}else D&&(delete this.updateTransform,delete this.applyTextOutline,this.destroyTextPath(d,a));return this},destroyTextPath:function(a,b){var d;b.element.setAttribute("id","");for(d=this.textPathWrapper.element.childNodes;d.length;)a.firstChild.appendChild(d[0]);
a.firstChild.removeChild(this.textPathWrapper.element);delete b.textPathWrapper},fillSetter:function(a,b,d){"string"===typeof a?d.setAttribute(b,a):a&&this.complexColor(a,b,d)},visibilitySetter:function(a,b,d){"inherit"===a?d.removeAttribute(b):this[b]!==a&&d.setAttribute(b,a);this[b]=a},zIndexSetter:function(a,b){var d=this.renderer,e=this.parentGroup,m=(e||d).element||d.box,w=this.element,k=!1;d=m===d.box;var D=this.added;var l;G(a)?(w.setAttribute("data-z-index",a),a=+a,this[b]===a&&(D=!1)):G(this[b])&&
w.removeAttribute("data-z-index");this[b]=a;if(D){(a=this.zIndex)&&e&&(e.handleZ=!0);b=m.childNodes;for(l=b.length-1;0<=l&&!k;l--){e=b[l];D=e.getAttribute("data-z-index");var g=!G(D);if(e!==w)if(0>a&&g&&!d&&!l)m.insertBefore(w,b[l]),k=!0;else if(q(D)<=a||g&&(!G(a)||0<=a))m.insertBefore(w,b[l+1]||null),k=!0}k||(m.insertBefore(w,b[d?3:0]||null),k=!0)}return k},_defaultSetter:function(a,b,d){d.setAttribute(b,a)}});O.prototype.yGetter=O.prototype.xGetter;O.prototype.translateXSetter=O.prototype.translateYSetter=
O.prototype.rotationSetter=O.prototype.verticalAlignSetter=O.prototype.rotationOriginXSetter=O.prototype.rotationOriginYSetter=O.prototype.scaleXSetter=O.prototype.scaleYSetter=O.prototype.matrixSetter=function(a,b){this[b]=a;this.doTransform=!0};O.prototype["stroke-widthSetter"]=O.prototype.strokeSetter=function(a,b,d){this[b]=a;this.stroke&&this["stroke-width"]?(O.prototype.fillSetter.call(this,this.stroke,"stroke",d),d.setAttribute("stroke-width",this["stroke-width"]),this.hasStroke=!0):"stroke-width"===
b&&0===a&&this.hasStroke?(d.removeAttribute("stroke"),this.hasStroke=!1):this.renderer.styledMode&&this["stroke-width"]&&(d.setAttribute("stroke-width",this["stroke-width"]),this.hasStroke=!0)};f=c.SVGRenderer=function(){this.init.apply(this,arguments)};t(f.prototype,{Element:O,SVG_NS:U,init:function(a,d,e,m,w,g,r){var D=this.createElement("svg").attr({version:"1.1","class":"highcharts-root"});r||D.css(this.getStyle(m));m=D.element;a.appendChild(m);F(a,"dir","ltr");-1===a.innerHTML.indexOf("xmlns")&&
F(m,"xmlns",this.SVG_NS);this.isSVG=!0;this.box=m;this.boxWrapper=D;this.alignedObjects=[];this.url=(k||x)&&p.getElementsByTagName("base").length?Q.location.href.split("#")[0].replace(/<[^>]*>/g,"").replace(/([\('\)])/g,"\\$1").replace(/ /g,"%20"):"";this.createElement("desc").add().element.appendChild(p.createTextNode("Created with Highcharts 7.2.2"));this.defs=this.createElement("defs").add();this.allowHTML=g;this.forExport=w;this.styledMode=r;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=
0;this.setSize(d,e,!1);var c;k&&a.getBoundingClientRect&&(d=function(){l(a,{left:0,top:0});c=a.getBoundingClientRect();l(a,{left:Math.ceil(c.left)-c.left+"px",top:Math.ceil(c.top)-c.top+"px"})},d(),this.unSubPixelFix=b(Q,"resize",d))},definition:function(a){function b(a,e){var m;g(a).forEach(function(a){var w=d.createElement(a.tagName),k={};h(a,function(a,b){"tagName"!==b&&"children"!==b&&"textContent"!==b&&(k[b]=a)});w.attr(k);w.add(e||d.defs);a.textContent&&w.element.appendChild(p.createTextNode(a.textContent));
b(a.children||[],w);m=w});return m}var d=this;return b(a)},getStyle:function(a){return this.style=t({fontFamily:'"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',fontSize:"12px"},a)},setStyle:function(a){this.boxWrapper.css(this.getStyle(a))},isHidden:function(){return!this.boxWrapper.getBBox().width},destroy:function(){var a=this.defs;this.box=null;this.boxWrapper=this.boxWrapper.destroy();z(this.gradients||{});this.gradients=null;a&&(this.defs=a.destroy());this.unSubPixelFix&&
this.unSubPixelFix();return this.alignedObjects=null},createElement:function(a){var b=new this.Element;b.init(this,a);return b},draw:w,getRadialAttr:function(a,b){return{cx:a[0]-a[2]/2+b.cx*a[2],cy:a[1]-a[2]/2+b.cy*a[2],r:b.r*a[2]}},truncate:function(a,b,d,e,m,w,k){var l=this,D=a.rotation,g,r=e?1:0,c=(d||e).length,x=c,J=[],K=function(a){b.firstChild&&b.removeChild(b.firstChild);a&&b.appendChild(p.createTextNode(a))},N=function(w,D){D=D||w;if(void 0===J[D])if(b.getSubStringLength)try{J[D]=m+b.getSubStringLength(0,
e?D+1:D)}catch(ba){""}else l.getSpanWidth&&(K(k(d||e,w)),J[D]=m+l.getSpanWidth(a,b));return J[D]},A;a.rotation=0;var h=N(b.textContent.length);if(A=m+h>w){for(;r<=c;)x=Math.ceil((r+c)/2),e&&(g=k(e,x)),h=N(x,g&&g.length-1),r===c?r=c+1:h>w?c=x-1:r=x;0===c?K(""):d&&c===d.length-1||K(g||k(d||e,x))}e&&e.splice(0,x);a.actualWidth=h;a.rotation=D;return A},escapes:{"&":"&amp;","<":"&lt;",">":"&gt;","'":"&#39;",'"':"&quot;"},buildText:function(a){var b=a.element,d=this,e=d.forExport,m=n(a.textStr,"").toString(),
w=-1!==m.indexOf("<"),k=b.childNodes,D,g=F(b,"x"),r=a.styles,c=a.textWidth,x=r&&r.lineHeight,K=r&&r.textOutline,A=r&&"ellipsis"===r.textOverflow,u=r&&"nowrap"===r.whiteSpace,L=r&&r.fontSize,E,f=k.length;r=c&&!a.added&&this.box;var S=function(a){var m;d.styledMode||(m=/(px|em)$/.test(a&&a.style.fontSize)?a.style.fontSize:L||d.style.fontSize||12);return x?q(x):d.fontMetrics(m,a.getAttribute("style")?a:b).h},v=function(a,b){h(d.escapes,function(d,m){b&&-1!==b.indexOf(d)||(a=a.toString().replace(new RegExp(d,
"g"),m))});return a},O=function(a,b){var d=a.indexOf("<");a=a.substring(d,a.indexOf(">")-d);d=a.indexOf(b+"=");if(-1!==d&&(d=d+b.length+1,b=a.charAt(d),'"'===b||"'"===b))return a=a.substring(d+1),a.substring(0,a.indexOf(b))},Q=/<br.*?>/g;var t=[m,A,u,x,K,L,c].join();if(t!==a.textCache){for(a.textCache=t;f--;)b.removeChild(k[f]);w||K||A||c||-1!==m.indexOf(" ")&&(!u||Q.test(m))?(r&&r.appendChild(b),w?(m=d.styledMode?m.replace(/<(b|strong)>/g,'<span class="highcharts-strong">').replace(/<(i|em)>/g,'<span class="highcharts-emphasized">'):
m.replace(/<(b|strong)>/g,'<span style="font-weight:bold">').replace(/<(i|em)>/g,'<span style="font-style:italic">'),m=m.replace(/<a/g,"<span").replace(/<\/(b|strong|i|em|a)>/g,"</span>").split(Q)):m=[m],m=m.filter(function(a){return""!==a}),m.forEach(function(m,w){var k=0,r=0;m=m.replace(/^\s+|\s+$/g,"").replace(/<span/g,"|||<span").replace(/<\/span>/g,"</span>|||");var x=m.split("|||");x.forEach(function(m){if(""!==m||1===x.length){var K={},N=p.createElementNS(d.SVG_NS,"tspan"),h,n;(h=O(m,"class"))&&
F(N,"class",h);if(h=O(m,"style"))h=h.replace(/(;| |^)color([ :])/,"$1fill$2"),F(N,"style",h);if((n=O(m,"href"))&&!e&&-1===n.split(":")[0].toLowerCase().indexOf("javascript")){var T=p.createElementNS(d.SVG_NS,"a");F(T,"href",n);F(N,"class","highcharts-anchor");T.appendChild(N);d.styledMode||l(N,{cursor:"pointer"})}m=v(m.replace(/<[a-zA-Z\/](.|\n)*?>/g,"")||" ");if(" "!==m){N.appendChild(p.createTextNode(m));k?K.dx=0:w&&null!==g&&(K.x=g);F(N,K);b.appendChild(T||N);!k&&E&&(!J&&e&&l(N,{display:"block"}),
F(N,"dy",S(N)));if(c){var f=m.replace(/([^\^])-/g,"$1- ").split(" ");K=!u&&(1<x.length||w||1<f.length);T=0;n=S(N);if(A)D=d.truncate(a,N,m,void 0,0,Math.max(0,c-parseInt(L||12,10)),function(a,b){return a.substring(0,b)+"\u2026"});else if(K)for(;f.length;)f.length&&!u&&0<T&&(N=p.createElementNS(U,"tspan"),F(N,{dy:n,x:g}),h&&F(N,"style",h),N.appendChild(p.createTextNode(f.join(" ").replace(/- /g,"-"))),b.appendChild(N)),d.truncate(a,N,null,f,0===T?r:0,c,function(a,b){return f.slice(0,b).join(" ").replace(/- /g,
"-")}),r=a.actualWidth,T++}k++}}});E=E||b.childNodes.length}),A&&D&&a.attr("title",v(a.textStr,["&lt;","&gt;"])),r&&r.removeChild(b),K&&a.applyTextOutline&&a.applyTextOutline(K)):b.appendChild(p.createTextNode(v(m)))}},getContrast:function(a){a=e(a).rgba;a[0]*=1;a[1]*=1.2;a[2]*=.5;return 459<a[0]+a[1]+a[2]?"#000000":"#FFFFFF"},button:function(a,d,m,e,w,k,l,g,c,x){var D=this.label(a,d,m,c,null,null,x,null,"button"),p=0,K=this.styledMode;D.attr(A({padding:8,r:2},w));if(!K){w=A({fill:"#f7f7f7",stroke:"#cccccc",
"stroke-width":1,style:{color:"#333333",cursor:"pointer",fontWeight:"normal"}},w);var J=w.style;delete w.style;k=A(w,{fill:"#e6e6e6"},k);var N=k.style;delete k.style;l=A(w,{fill:"#e6ebf5",style:{color:"#000000",fontWeight:"bold"}},l);var h=l.style;delete l.style;g=A(w,{style:{color:"#cccccc"}},g);var u=g.style;delete g.style}b(D.element,r?"mouseover":"mouseenter",function(){3!==p&&D.setState(1)});b(D.element,r?"mouseout":"mouseleave",function(){3!==p&&D.setState(p)});D.setState=function(a){1!==a&&
(D.state=p=a);D.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-"+["normal","hover","pressed","disabled"][a||0]);K||D.attr([w,k,l,g][a||0]).css([J,N,h,u][a||0])};K||D.attr(w).css(t({cursor:"default"},J));return D.on("click",function(a){3!==p&&e.call(D,a)})},crispLine:function(a,b){a[1]===a[4]&&(a[1]=a[4]=Math.round(a[1])-b%2/2);a[2]===a[5]&&(a[2]=a[5]=Math.round(a[2])+b%2/2);return a},path:function(a){var b=this.styledMode?{}:{fill:"none"};v(a)?b.d=a:H(a)&&
t(b,a);return this.createElement("path").attr(b)},circle:function(a,b,d){a=H(a)?a:void 0===a?{}:{x:a,y:b,r:d};b=this.createElement("circle");b.xSetter=b.ySetter=function(a,b,d){d.setAttribute("c"+b,a)};return b.attr(a)},arc:function(a,b,d,m,e,w){H(a)?(m=a,b=m.y,d=m.r,a=m.x):m={innerR:m,start:e,end:w};a=this.symbol("arc",a,b,d,d,m);a.r=d;return a},rect:function(a,b,d,m,e,w){e=H(a)?a.r:e;var k=this.createElement("rect");a=H(a)?a:void 0===a?{}:{x:a,y:b,width:Math.max(d,0),height:Math.max(m,0)};this.styledMode||
(void 0!==w&&(a.strokeWidth=w,a=k.crisp(a)),a.fill="none");e&&(a.r=e);k.rSetter=function(a,b,d){k.r=a;F(d,{rx:a,ry:a})};k.rGetter=function(){return k.r};return k.attr(a)},setSize:function(a,b,d){var m=this.alignedObjects,e=m.length;this.width=a;this.height=b;for(this.boxWrapper.animate({width:a,height:b},{step:function(){this.attr({viewBox:"0 0 "+this.attr("width")+" "+this.attr("height")})},duration:n(d,!0)?void 0:0});e--;)m[e].align()},g:function(a){var b=this.createElement("g");return a?b.attr({"class":"highcharts-"+
a}):b},image:function(a,d,m,e,w,k){var l={preserveAspectRatio:"none"},g=function(a,b){a.setAttributeNS?a.setAttributeNS("http://www.w3.org/1999/xlink","href",b):a.setAttribute("hc-svg-href",b)},r=function(b){g(c.element,a);k.call(c,b)};1<arguments.length&&t(l,{x:d,y:m,width:e,height:w});var c=this.createElement("image").attr(l);k?(g(c.element,"data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="),l=new Q.Image,b(l,"load",r),l.src=a,l.complete&&r({})):g(c.element,a);return c},
symbol:function(a,b,m,e,w,k){var g=this,r=/^url\((.*?)\)$/,c=r.test(a),D=!c&&(this.symbols[a]?a:"circle"),x=D&&this.symbols[D],K=G(b)&&x&&x.call(this.symbols,Math.round(b),Math.round(m),e,w,k);if(x){var J=this.path(K);g.styledMode||J.attr("fill","none");t(J,{symbolName:D,x:b,y:m,width:e,height:w});k&&t(J,k)}else if(c){var A=a.match(r)[1];J=this.image(A);J.imgwidth=n(S[A]&&S[A].width,k&&k.width);J.imgheight=n(S[A]&&S[A].height,k&&k.height);var h=function(){J.attr({width:J.width,height:J.height})};
["width","height"].forEach(function(a){J[a+"Setter"]=function(a,b){var d={},m=this["img"+b],e="width"===b?"translateX":"translateY";this[b]=a;G(m)&&(k&&"within"===k.backgroundSize&&this.width&&this.height&&(m=Math.round(m*Math.min(this.width/this.imgwidth,this.height/this.imgheight))),this.element&&this.element.setAttribute(b,m),this.alignByTranslate||(d[e]=((this[b]||0)-m)/2,this.attr(d)))}});G(b)&&J.attr({x:b,y:m});J.isImg=!0;G(J.imgwidth)&&G(J.imgheight)?h():(J.attr({width:0,height:0}),L("img",
{onload:function(){var a=d[g.chartIndex];0===this.width&&(l(this,{position:"absolute",top:"-999em"}),p.body.appendChild(this));S[A]={width:this.width,height:this.height};J.imgwidth=this.width;J.imgheight=this.height;J.element&&h();this.parentNode&&this.parentNode.removeChild(this);g.imgCount--;if(!g.imgCount&&a&&a.onload)a.onload()},src:A}),this.imgCount++)}return J},symbols:{circle:function(a,b,d,m){return this.arc(a+d/2,b+m/2,d/2,m/2,{start:.5*Math.PI,end:2.5*Math.PI,open:!1})},square:function(a,
b,d,m){return["M",a,b,"L",a+d,b,a+d,b+m,a,b+m,"Z"]},triangle:function(a,b,d,m){return["M",a+d/2,b,"L",a+d,b+m,a,b+m,"Z"]},"triangle-down":function(a,b,d,m){return["M",a,b,"L",a+d,b,a+d/2,b+m,"Z"]},diamond:function(a,b,d,m){return["M",a+d/2,b,"L",a+d,b+m/2,a+d/2,b+m,a,b+m/2,"Z"]},arc:function(a,b,d,m,e){var w=e.start,k=e.r||d,l=e.r||m||d,g=e.end-.001;d=e.innerR;m=n(e.open,.001>Math.abs(e.end-e.start-2*Math.PI));var r=Math.cos(w),c=Math.sin(w),x=Math.cos(g);g=Math.sin(g);w=.001>e.end-w-Math.PI?0:1;
e=["M",a+k*r,b+l*c,"A",k,l,0,w,n(e.clockwise,1),a+k*x,b+l*g];G(d)&&e.push(m?"M":"L",a+d*x,b+d*g,"A",d,d,0,w,0,a+d*r,b+d*c);e.push(m?"":"Z");return e},callout:function(a,b,d,m,e){var w=Math.min(e&&e.r||0,d,m),k=w+6,l=e&&e.anchorX;e=e&&e.anchorY;var g=["M",a+w,b,"L",a+d-w,b,"C",a+d,b,a+d,b,a+d,b+w,"L",a+d,b+m-w,"C",a+d,b+m,a+d,b+m,a+d-w,b+m,"L",a+w,b+m,"C",a,b+m,a,b+m,a,b+m-w,"L",a,b+w,"C",a,b,a,b,a+w,b];l&&l>d?e>b+k&&e<b+m-k?g.splice(13,3,"L",a+d,e-6,a+d+6,e,a+d,e+6,a+d,b+m-w):g.splice(13,3,"L",a+
d,m/2,l,e,a+d,m/2,a+d,b+m-w):l&&0>l?e>b+k&&e<b+m-k?g.splice(33,3,"L",a,e+6,a-6,e,a,e-6,a,b+w):g.splice(33,3,"L",a,m/2,l,e,a,m/2,a,b+w):e&&e>m&&l>a+k&&l<a+d-k?g.splice(23,3,"L",l+6,b+m,l,b+m+6,l-6,b+m,a+w,b+m):e&&0>e&&l>a+k&&l<a+d-k&&g.splice(3,3,"L",l-6,b,l,b-6,l+6,b,d-w,b);return g}},clipRect:function(a,b,d,m){var e=c.uniqueKey()+"-",w=this.createElement("clipPath").attr({id:e}).add(this.defs);a=this.rect(a,b,d,m,0).add(w);a.id=e;a.clipPath=w;a.count=0;return a},text:function(a,b,d,m){var e={};if(m&&
(this.allowHTML||!this.forExport))return this.html(a,b,d);e.x=Math.round(b||0);d&&(e.y=Math.round(d));G(a)&&(e.text=a);a=this.createElement("text").attr(e);m||(a.xSetter=function(a,b,d){var m=d.getElementsByTagName("tspan"),e=d.getAttribute(b),w;for(w=0;w<m.length;w++){var k=m[w];k.getAttribute(b)===e&&k.setAttribute(b,a)}d.setAttribute(b,a)});return a},fontMetrics:function(a,b){a=!this.styledMode&&/px/.test(a)||!Q.getComputedStyle?a||b&&b.style&&b.style.fontSize||this.style&&this.style.fontSize:
b&&O.prototype.getStyle.call(b,"font-size");a=/px/.test(a)?q(a):12;b=24>a?a+3:Math.round(1.2*a);return{h:b,b:Math.round(.8*b),f:a}},rotCorr:function(a,b,d){var m=a;b&&d&&(m=Math.max(m*Math.cos(b*E),4));return{x:-a/3*Math.sin(b*E),y:m}},label:function(a,b,d,e,w,k,l,g,r){var c=this,x=c.styledMode,J=c.g("button"!==r&&"label"),p=J.text=c.text("",0,0,l).attr({zIndex:1}),K,h,D=0,u=3,L=0,n,N,E,U,f,q={},T,S,v=/^url\((.*?)\)$/.test(e),Q=x||v,y=function(){return x?K.strokeWidth()%2/2:(T?parseInt(T,10):0)%2/
2};r&&J.addClass("highcharts-"+r);var R=function(){var a=p.element.style,b={};h=(void 0===n||void 0===N||f)&&G(p.textStr)&&p.getBBox();J.width=(n||h.width||0)+2*u+L;J.height=(N||h.height||0)+2*u;S=u+Math.min(c.fontMetrics(a&&a.fontSize,p).b,h?h.height:Infinity);Q&&(K||(J.box=K=c.symbols[e]||v?c.symbol(e):c.rect(),K.addClass(("button"===r?"":"highcharts-label-box")+(r?" highcharts-"+r+"-box":"")),K.add(J),a=y(),b.x=a,b.y=(g?-S:0)+a),b.width=Math.round(J.width),b.height=Math.round(J.height),K.attr(t(b,
q)),q={})};var B=function(){var a=L+u;var b=g?0:S;G(n)&&h&&("center"===f||"right"===f)&&(a+={center:.5,right:1}[f]*(n-h.width));if(a!==p.x||b!==p.y)p.attr("x",a),p.hasBoxWidthChanged&&(h=p.getBBox(!0),R()),void 0!==b&&p.attr("y",b);p.x=a;p.y=b};var V=function(a,b){K?K.attr(a,b):q[a]=b};J.onAdd=function(){p.add(J);J.attr({text:a||0===a?a:"",x:b,y:d});K&&G(w)&&J.attr({anchorX:w,anchorY:k})};J.widthSetter=function(a){n=C(a)?a:null};J.heightSetter=function(a){N=a};J["text-alignSetter"]=function(a){f=
a};J.paddingSetter=function(a){G(a)&&a!==u&&(u=J.padding=a,B())};J.paddingLeftSetter=function(a){G(a)&&a!==L&&(L=a,B())};J.alignSetter=function(a){a={left:0,center:.5,right:1}[a];a!==D&&(D=a,h&&J.attr({x:E}))};J.textSetter=function(a){void 0!==a&&p.attr({text:a});R();B()};J["stroke-widthSetter"]=function(a,b){a&&(Q=!0);T=this["stroke-width"]=a;V(b,a)};x?J.rSetter=function(a,b){V(b,a)}:J.strokeSetter=J.fillSetter=J.rSetter=function(a,b){"r"!==b&&("fill"===b&&a&&(Q=!0),J[b]=a);V(b,a)};J.anchorXSetter=
function(a,b){w=J.anchorX=a;V(b,Math.round(a)-y()-E)};J.anchorYSetter=function(a,b){k=J.anchorY=a;V(b,a-U)};J.xSetter=function(a){J.x=a;D&&(a-=D*((n||h.width)+2*u),J["forceAnimate:x"]=!0);E=Math.round(a);J.attr("translateX",E)};J.ySetter=function(a){U=J.y=Math.round(a);J.attr("translateY",U)};var H=J.css;l={css:function(a){if(a){var b={};a=A(a);J.textProps.forEach(function(d){void 0!==a[d]&&(b[d]=a[d],delete a[d])});p.css(b);"width"in b&&R();"fontSize"in b&&(R(),B())}return H.call(J,a)},getBBox:function(){return{width:h.width+
2*u,height:h.height+2*u,x:h.x-u,y:h.y-u}},destroy:function(){m(J.element,"mouseenter");m(J.element,"mouseleave");p&&(p=p.destroy());K&&(K=K.destroy());O.prototype.destroy.call(J);J=c=R=B=V=null}};x||(l.shadow=function(a){a&&(R(),K&&K.shadow(a));return J});return t(J,l)}});c.Renderer=f});M(I,"parts/Html.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.attr,G=f.defined,z=f.extend,B=f.pick,t=f.pInt,v=c.createElement,C=c.css,H=c.isFirefox,y=c.isMS,h=c.isWebKit,n=c.SVGElement;
f=c.SVGRenderer;var q=c.win;z(n.prototype,{htmlCss:function(g){var b="SPAN"===this.element.tagName&&g&&"width"in g,a=B(b&&g.width,void 0);if(b){delete g.width;this.textWidth=a;var d=!0}g&&"ellipsis"===g.textOverflow&&(g.whiteSpace="nowrap",g.overflow="hidden");this.styles=z(this.styles,g);C(this.element,g);d&&this.htmlUpdateTransform();return this},htmlGetBBox:function(){var g=this.element;return{x:g.offsetLeft,y:g.offsetTop,width:g.offsetWidth,height:g.offsetHeight}},htmlUpdateTransform:function(){if(this.added){var g=
this.renderer,b=this.element,a=this.translateX||0,d=this.translateY||0,e=this.x||0,l=this.y||0,c=this.textAlign||"left",h={left:0,center:.5,right:1}[c],p=this.styles,u=p&&p.whiteSpace;C(b,{marginLeft:a,marginTop:d});!g.styledMode&&this.shadows&&this.shadows.forEach(function(b){C(b,{marginLeft:a+1,marginTop:d+1})});this.inverted&&[].forEach.call(b.childNodes,function(a){g.invertChild(a,b)});if("SPAN"===b.tagName){p=this.rotation;var k=this.textWidth&&t(this.textWidth),r=[p,c,b.innerHTML,this.textWidth,
this.textAlign].join(),x;(x=k!==this.oldTextWidth)&&!(x=k>this.oldTextWidth)&&((x=this.textPxLength)||(C(b,{width:"",whiteSpace:u||"nowrap"}),x=b.offsetWidth),x=x>k);x&&(/[ \-]/.test(b.textContent||b.innerText)||"ellipsis"===b.style.textOverflow)?(C(b,{width:k+"px",display:"block",whiteSpace:u||"normal"}),this.oldTextWidth=k,this.hasBoxWidthChanged=!0):this.hasBoxWidthChanged=!1;r!==this.cTT&&(u=g.fontMetrics(b.style.fontSize,b).b,!G(p)||p===(this.oldRotation||0)&&c===this.oldAlign||this.setSpanRotation(p,
h,u),this.getSpanCorrection(!G(p)&&this.textPxLength||b.offsetWidth,u,h,p,c));C(b,{left:e+(this.xCorr||0)+"px",top:l+(this.yCorr||0)+"px"});this.cTT=r;this.oldRotation=p;this.oldAlign=c}}else this.alignOnAdd=!0},setSpanRotation:function(g,b,a){var d={},e=this.renderer.getTransformKey();d[e]=d.transform="rotate("+g+"deg)";d[e+(H?"Origin":"-origin")]=d.transformOrigin=100*b+"% "+a+"px";C(this.element,d)},getSpanCorrection:function(g,b,a){this.xCorr=-g*a;this.yCorr=-b}});z(f.prototype,{getTransformKey:function(){return y&&
!/Edge/.test(q.navigator.userAgent)?"-ms-transform":h?"-webkit-transform":H?"MozTransform":q.opera?"-o-transform":""},html:function(g,b,a){var d=this.createElement("span"),e=d.element,l=d.renderer,c=l.isSVG,h=function(a,b){["opacity","visibility"].forEach(function(d){a[d+"Setter"]=function(e,k,l){var w=a.div?a.div.style:b;n.prototype[d+"Setter"].call(this,e,k,l);w&&(w[k]=e)}});a.addedSetters=!0};d.textSetter=function(a){a!==e.innerHTML&&(delete this.bBox,delete this.oldTextWidth);this.textStr=a;e.innerHTML=
B(a,"");d.doTransform=!0};c&&h(d,d.element.style);d.xSetter=d.ySetter=d.alignSetter=d.rotationSetter=function(a,b){"align"===b&&(b="textAlign");d[b]=a;d.doTransform=!0};d.afterSetters=function(){this.doTransform&&(this.htmlUpdateTransform(),this.doTransform=!1)};d.attr({text:g,x:Math.round(b),y:Math.round(a)}).css({position:"absolute"});l.styledMode||d.css({fontFamily:this.style.fontFamily,fontSize:this.style.fontSize});e.style.whiteSpace="nowrap";d.css=d.htmlCss;c&&(d.add=function(a){var b=l.box.parentNode,
k=[];if(this.parentGroup=a){var g=a.div;if(!g){for(;a;)k.push(a),a=a.parentGroup;k.reverse().forEach(function(a){function e(b,d){a[d]=b;"translateX"===d?m.left=b+"px":m.top=b+"px";a.doTransform=!0}var w=F(a.element,"class");g=a.div=a.div||v("div",w?{className:w}:void 0,{position:"absolute",left:(a.translateX||0)+"px",top:(a.translateY||0)+"px",display:a.display,opacity:a.opacity,pointerEvents:a.styles&&a.styles.pointerEvents},g||b);var m=g.style;z(a,{classSetter:function(a){return function(b){this.element.setAttribute("class",
b);a.className=b}}(g),on:function(){k[0].div&&d.on.apply({element:k[0].div},arguments);return a},translateXSetter:e,translateYSetter:e});a.addedSetters||h(a)})}}else g=b;g.appendChild(e);d.added=!0;d.alignOnAdd&&d.htmlUpdateTransform();return d});return d}})});M(I,"parts/Time.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.defined,G=f.extend,z=f.isObject,B=f.objectEach,t=f.pick,v=f.splat,C=c.merge,H=c.timeUnits,y=c.win;c.Time=function(c){this.update(c,!1)};c.Time.prototype=
{defaultOptions:{Date:void 0,getTimezoneOffset:void 0,timezone:void 0,timezoneOffset:0,useUTC:!0},update:function(c){var h=t(c&&c.useUTC,!0),f=this;this.options=c=C(!0,this.options||{},c);this.Date=c.Date||y.Date||Date;this.timezoneOffset=(this.useUTC=h)&&c.timezoneOffset;this.getTimezoneOffset=this.timezoneOffsetFunction();(this.variableTimezone=!(h&&!c.getTimezoneOffset&&!c.timezone))||this.timezoneOffset?(this.get=function(g,b){var a=b.getTime(),d=a-f.getTimezoneOffset(b);b.setTime(d);g=b["getUTC"+
g]();b.setTime(a);return g},this.set=function(g,b,a){if("Milliseconds"===g||"Seconds"===g||"Minutes"===g&&0===b.getTimezoneOffset()%60)b["set"+g](a);else{var d=f.getTimezoneOffset(b);d=b.getTime()-d;b.setTime(d);b["setUTC"+g](a);g=f.getTimezoneOffset(b);d=b.getTime()+g;b.setTime(d)}}):h?(this.get=function(g,b){return b["getUTC"+g]()},this.set=function(g,b,a){return b["setUTC"+g](a)}):(this.get=function(g,b){return b["get"+g]()},this.set=function(g,b,a){return b["set"+g](a)})},makeTime:function(h,
n,f,g,b,a){if(this.useUTC){var d=this.Date.UTC.apply(0,arguments);var e=this.getTimezoneOffset(d);d+=e;var l=this.getTimezoneOffset(d);e!==l?d+=l-e:e-36E5!==this.getTimezoneOffset(d-36E5)||c.isSafari||(d-=36E5)}else d=(new this.Date(h,n,t(f,1),t(g,0),t(b,0),t(a,0))).getTime();return d},timezoneOffsetFunction:function(){var h=this,n=this.options,f=y.moment;if(!this.useUTC)return function(g){return 6E4*(new Date(g)).getTimezoneOffset()};if(n.timezone){if(f)return function(g){return 6E4*-f.tz(g,n.timezone).utcOffset()};
c.error(25)}return this.useUTC&&n.getTimezoneOffset?function(g){return 6E4*n.getTimezoneOffset(g)}:function(){return 6E4*(h.timezoneOffset||0)}},dateFormat:function(h,n,f){if(!F(n)||isNaN(n))return c.defaultOptions.lang.invalidDate||"";h=t(h,"%Y-%m-%d %H:%M:%S");var g=this,b=new this.Date(n),a=this.get("Hours",b),d=this.get("Day",b),e=this.get("Date",b),l=this.get("Month",b),L=this.get("FullYear",b),E=c.defaultOptions.lang,p=E.weekdays,u=E.shortWeekdays,k=c.pad;b=G({a:u?u[d]:p[d].substr(0,3),A:p[d],
d:k(e),e:k(e,2," "),w:d,b:E.shortMonths[l],B:E.months[l],m:k(l+1),o:l+1,y:L.toString().substr(2,2),Y:L,H:k(a),k:a,I:k(a%12||12),l:a%12||12,M:k(g.get("Minutes",b)),p:12>a?"AM":"PM",P:12>a?"am":"pm",S:k(b.getSeconds()),L:k(Math.floor(n%1E3),3)},c.dateFormats);B(b,function(a,b){for(;-1!==h.indexOf("%"+b);)h=h.replace("%"+b,"function"===typeof a?a.call(g,n):a)});return f?h.substr(0,1).toUpperCase()+h.substr(1):h},resolveDTLFormat:function(c){return z(c,!0)?c:(c=v(c),{main:c[0],from:c[1],to:c[2]})},getTimeTicks:function(c,
n,f,g){var b=this,a=[],d={};var e=new b.Date(n);var l=c.unitRange,h=c.count||1,E;g=t(g,1);if(F(n)){b.set("Milliseconds",e,l>=H.second?0:h*Math.floor(b.get("Milliseconds",e)/h));l>=H.second&&b.set("Seconds",e,l>=H.minute?0:h*Math.floor(b.get("Seconds",e)/h));l>=H.minute&&b.set("Minutes",e,l>=H.hour?0:h*Math.floor(b.get("Minutes",e)/h));l>=H.hour&&b.set("Hours",e,l>=H.day?0:h*Math.floor(b.get("Hours",e)/h));l>=H.day&&b.set("Date",e,l>=H.month?1:Math.max(1,h*Math.floor(b.get("Date",e)/h)));if(l>=H.month){b.set("Month",
e,l>=H.year?0:h*Math.floor(b.get("Month",e)/h));var p=b.get("FullYear",e)}l>=H.year&&b.set("FullYear",e,p-p%h);l===H.week&&(p=b.get("Day",e),b.set("Date",e,b.get("Date",e)-p+g+(p<g?-7:0)));p=b.get("FullYear",e);g=b.get("Month",e);var u=b.get("Date",e),k=b.get("Hours",e);n=e.getTime();b.variableTimezone&&(E=f-n>4*H.month||b.getTimezoneOffset(n)!==b.getTimezoneOffset(f));n=e.getTime();for(e=1;n<f;)a.push(n),n=l===H.year?b.makeTime(p+e*h,0):l===H.month?b.makeTime(p,g+e*h):!E||l!==H.day&&l!==H.week?E&&
l===H.hour&&1<h?b.makeTime(p,g,u,k+e*h):n+l*h:b.makeTime(p,g,u+e*h*(l===H.day?1:7)),e++;a.push(n);l<=H.hour&&1E4>a.length&&a.forEach(function(a){0===a%18E5&&"000000000"===b.dateFormat("%H%M%S%L",a)&&(d[a]="day")})}a.info=G(c,{higherRanks:d,totalRange:l*h});return a}}});M(I,"parts/Options.js",[I["parts/Globals.js"]],function(c){var f=c.color,F=c.merge;c.defaultOptions={colors:"#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" "),symbols:["circle","diamond","square",
"triangle","triangle-down"],lang:{loading:"Loading...",months:"January February March April May June July August September October November December".split(" "),shortMonths:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),weekdays:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),decimalPoint:".",numericSymbols:"kMGTPE".split(""),resetZoom:"Reset zoom",resetZoomTitle:"Reset zoom level 1:1",thousandsSep:" "},global:{},time:c.Time.prototype.defaultOptions,chart:{styledMode:!1,
borderRadius:0,colorCount:10,defaultSeriesType:"line",ignoreHiddenSeries:!0,spacing:[10,10,15,10],resetZoomButton:{theme:{zIndex:6},position:{align:"right",x:-10,y:10}},width:null,height:null,borderColor:"#335cad",backgroundColor:"#ffffff",plotBorderColor:"#cccccc"},title:{text:"Chart title",align:"center",margin:15,widthAdjust:-44},subtitle:{text:"",align:"center",widthAdjust:-44},caption:{margin:15,text:"",align:"left",verticalAlign:"bottom"},plotOptions:{},labels:{style:{position:"absolute",color:"#333333"}},
legend:{enabled:!0,align:"center",alignColumns:!0,layout:"horizontal",labelFormatter:function(){return this.name},borderColor:"#999999",borderRadius:0,navigation:{activeColor:"#003399",inactiveColor:"#cccccc"},itemStyle:{color:"#333333",cursor:"pointer",fontSize:"12px",fontWeight:"bold",textOverflow:"ellipsis"},itemHoverStyle:{color:"#000000"},itemHiddenStyle:{color:"#cccccc"},shadow:!1,itemCheckboxStyle:{position:"absolute",width:"13px",height:"13px"},squareSymbol:!0,symbolPadding:5,verticalAlign:"bottom",
x:0,y:0,title:{style:{fontWeight:"bold"}}},loading:{labelStyle:{fontWeight:"bold",position:"relative",top:"45%"},style:{position:"absolute",backgroundColor:"#ffffff",opacity:.5,textAlign:"center"}},tooltip:{enabled:!0,animation:c.svg,borderRadius:3,dateTimeLabelFormats:{millisecond:"%A, %b %e, %H:%M:%S.%L",second:"%A, %b %e, %H:%M:%S",minute:"%A, %b %e, %H:%M",hour:"%A, %b %e, %H:%M",day:"%A, %b %e, %Y",week:"Week from %A, %b %e, %Y",month:"%B %Y",year:"%Y"},footerFormat:"",padding:8,snap:c.isTouchDevice?
25:10,headerFormat:'<span style="font-size: 10px">{point.key}</span><br/>',pointFormat:'<span style="color:{point.color}">\u25cf</span> {series.name}: <b>{point.y}</b><br/>',backgroundColor:f("#f7f7f7").setOpacity(.85).get(),borderWidth:1,shadow:!0,style:{color:"#333333",cursor:"default",fontSize:"12px",pointerEvents:"none",whiteSpace:"nowrap"}},credits:{enabled:!0,href:"https://www.highcharts.com?credits",position:{align:"right",x:-10,verticalAlign:"bottom",y:-5},style:{cursor:"pointer",color:"#999999",
fontSize:"9px"},text:"Highcharts.com"}};c.setOptions=function(f){c.defaultOptions=F(!0,c.defaultOptions,f);(f.time||f.global)&&c.time.update(F(c.defaultOptions.global,c.defaultOptions.time,f.global,f.time));return c.defaultOptions};c.getOptions=function(){return c.defaultOptions};c.defaultPlotOptions=c.defaultOptions.plotOptions;c.time=new c.Time(F(c.defaultOptions.global,c.defaultOptions.time));c.dateFormat=function(f,z,B){return c.time.dateFormat(f,z,B)};""});M(I,"parts/Tick.js",[I["parts/Globals.js"],
I["parts/Utilities.js"]],function(c,f){var F=f.defined,G=f.destroyObjectProperties,z=f.extend,B=f.isNumber,t=f.pick,v=c.correctFloat,C=c.fireEvent,H=c.merge,y=c.deg2rad;c.Tick=function(c,n,f,g,b){this.axis=c;this.pos=n;this.type=f||"";this.isNewLabel=this.isNew=!0;this.parameters=b||{};this.tickmarkOffset=this.parameters.tickmarkOffset;this.options=this.parameters.options;f||g||this.addLabel()};c.Tick.prototype={addLabel:function(){var c=this,n=c.axis,f=n.options,g=n.chart,b=n.categories,a=n.names,
d=c.pos,e=t(c.options&&c.options.labels,f.labels),l=n.tickPositions,L=d===l[0],E=d===l[l.length-1];b=this.parameters.category||(b?t(b[d],a[d],d):d);var p=c.label;l=l.info;var u,k;if(n.isDatetimeAxis&&l){var r=g.time.resolveDTLFormat(f.dateTimeLabelFormats[!f.grid&&l.higherRanks[d]||l.unitName]);var x=r.main}c.isFirst=L;c.isLast=E;c.formatCtx={axis:n,chart:g,isFirst:L,isLast:E,dateTimeLabelFormat:x,tickPositionInfo:l,value:n.isLog?v(n.lin2log(b)):b,pos:d};f=n.labelFormatter.call(c.formatCtx,this.formatCtx);
if(k=r&&r.list)c.shortenLabel=function(){for(u=0;u<k.length;u++)if(p.attr({text:n.labelFormatter.call(z(c.formatCtx,{dateTimeLabelFormat:k[u]}))}),p.getBBox().width<n.getSlotWidth(c)-2*t(e.padding,5))return;p.attr({text:""})};if(F(p))p&&p.textStr!==f&&(!p.textWidth||e.style&&e.style.width||p.styles.width||p.css({width:null}),p.attr({text:f}),p.textPxLength=p.getBBox().width);else{if(c.label=p=F(f)&&e.enabled?g.renderer.text(f,0,0,e.useHTML).add(n.labelGroup):null)g.styledMode||p.css(H(e.style)),p.textPxLength=
p.getBBox().width;c.rotation=0}},getLabelSize:function(){return this.label?this.label.getBBox()[this.axis.horiz?"height":"width"]:0},handleOverflow:function(c){var h=this.axis,f=h.options.labels,g=c.x,b=h.chart.chartWidth,a=h.chart.spacing,d=t(h.labelLeft,Math.min(h.pos,a[3]));a=t(h.labelRight,Math.max(h.isRadial?0:h.pos+h.len,b-a[1]));var e=this.label,l=this.rotation,L={left:0,center:.5,right:1}[h.labelAlign||e.attr("align")],E=e.getBBox().width,p=h.getSlotWidth(this),u=p,k=1,r,x={};if(l||"justify"!==
t(f.overflow,"justify"))0>l&&g-L*E<d?r=Math.round(g/Math.cos(l*y)-d):0<l&&g+L*E>a&&(r=Math.round((b-g)/Math.cos(l*y)));else if(b=g+(1-L)*E,g-L*E<d?u=c.x+u*(1-L)-d:b>a&&(u=a-c.x+u*L,k=-1),u=Math.min(p,u),u<p&&"center"===h.labelAlign&&(c.x+=k*(p-u-L*(p-Math.min(E,u)))),E>u||h.autoRotation&&(e.styles||{}).width)r=u;r&&(this.shortenLabel?this.shortenLabel():(x.width=Math.floor(r),(f.style||{}).textOverflow||(x.textOverflow="ellipsis"),e.css(x)))},getPosition:function(h,n,f,g){var b=this.axis,a=b.chart,
d=g&&a.oldChartHeight||a.chartHeight;h={x:h?c.correctFloat(b.translate(n+f,null,null,g)+b.transB):b.left+b.offset+(b.opposite?(g&&a.oldChartWidth||a.chartWidth)-b.right-b.left:0),y:h?d-b.bottom+b.offset-(b.opposite?b.height:0):c.correctFloat(d-b.translate(n+f,null,null,g)-b.transB)};h.y=Math.max(Math.min(h.y,1E5),-1E5);C(this,"afterGetPosition",{pos:h});return h},getLabelPosition:function(c,n,f,g,b,a,d,e){var l=this.axis,h=l.transA,E=l.isLinked&&l.linkedParent?l.linkedParent.reversed:l.reversed,p=
l.staggerLines,u=l.tickRotCorr||{x:0,y:0},k=b.y,r=g||l.reserveSpaceDefault?0:-l.labelOffset*("center"===l.labelAlign?.5:1),x={};F(k)||(k=0===l.side?f.rotation?-8:-f.getBBox().height:2===l.side?u.y+8:Math.cos(f.rotation*y)*(u.y-f.getBBox(!1,0).height/2));c=c+b.x+r+u.x-(a&&g?a*h*(E?-1:1):0);n=n+k-(a&&!g?a*h*(E?1:-1):0);p&&(f=d/(e||1)%p,l.opposite&&(f=p-f-1),n+=l.labelOffset/p*f);x.x=c;x.y=Math.round(n);C(this,"afterGetLabelPosition",{pos:x,tickmarkOffset:a,index:d});return x},getMarkPath:function(c,
n,f,g,b,a){return a.crispLine(["M",c,n,"L",c+(b?0:-f),n+(b?f:0)],g)},renderGridLine:function(c,n,f){var g=this.axis,b=g.options,a=this.gridLine,d={},e=this.pos,l=this.type,h=t(this.tickmarkOffset,g.tickmarkOffset),E=g.chart.renderer,p=l?l+"Grid":"grid",u=b[p+"LineWidth"],k=b[p+"LineColor"];b=b[p+"LineDashStyle"];a||(g.chart.styledMode||(d.stroke=k,d["stroke-width"]=u,b&&(d.dashstyle=b)),l||(d.zIndex=1),c&&(n=0),this.gridLine=a=E.path().attr(d).addClass("highcharts-"+(l?l+"-":"")+"grid-line").add(g.gridGroup));
if(a&&(f=g.getPlotLinePath({value:e+h,lineWidth:a.strokeWidth()*f,force:"pass",old:c})))a[c||this.isNew?"attr":"animate"]({d:f,opacity:n})},renderMark:function(c,n,f){var g=this.axis,b=g.options,a=g.chart.renderer,d=this.type,e=d?d+"Tick":"tick",l=g.tickSize(e),h=this.mark,E=!h,p=c.x;c=c.y;var u=t(b[e+"Width"],!d&&g.isXAxis?1:0);b=b[e+"Color"];l&&(g.opposite&&(l[0]=-l[0]),E&&(this.mark=h=a.path().addClass("highcharts-"+(d?d+"-":"")+"tick").add(g.axisGroup),g.chart.styledMode||h.attr({stroke:b,"stroke-width":u})),
h[E?"attr":"animate"]({d:this.getMarkPath(p,c,l[0],h.strokeWidth()*f,g.horiz,a),opacity:n}))},renderLabel:function(c,n,f,g){var b=this.axis,a=b.horiz,d=b.options,e=this.label,l=d.labels,h=l.step;b=t(this.tickmarkOffset,b.tickmarkOffset);var E=!0,p=c.x;c=c.y;e&&B(p)&&(e.xy=c=this.getLabelPosition(p,c,e,a,l,b,g,h),this.isFirst&&!this.isLast&&!t(d.showFirstLabel,1)||this.isLast&&!this.isFirst&&!t(d.showLastLabel,1)?E=!1:!a||l.step||l.rotation||n||0===f||this.handleOverflow(c),h&&g%h&&(E=!1),E&&B(c.y)?
(c.opacity=f,e[this.isNewLabel?"attr":"animate"](c),this.isNewLabel=!1):(e.attr("y",-9999),this.isNewLabel=!0))},render:function(h,n,f){var g=this.axis,b=g.horiz,a=this.pos,d=t(this.tickmarkOffset,g.tickmarkOffset);a=this.getPosition(b,a,d,n);d=a.x;var e=a.y;g=b&&d===g.pos+g.len||!b&&e===g.pos?-1:1;f=t(f,1);this.isActive=!0;this.renderGridLine(n,f,g);this.renderMark(a,f,g);this.renderLabel(a,n,f,h);this.isNew=!1;c.fireEvent(this,"afterRender")},destroy:function(){G(this,this.axis)}}});M(I,"parts/Axis.js",
[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.arrayMax,G=f.arrayMin,z=f.defined,B=f.destroyObjectProperties,t=f.extend,v=f.isArray,C=f.isNumber,H=f.isString,y=f.objectEach,h=f.pick,n=f.splat,q=f.syncTimeout,g=c.addEvent,b=c.animObject,a=c.color,d=c.correctFloat,e=c.defaultOptions,l=c.deg2rad,L=c.fireEvent,E=c.format,p=c.getMagnitude,u=c.merge,k=c.normalizeTickInterval,r=c.removeEvent,x=c.seriesTypes,A=c.Tick;f=function(){this.init.apply(this,arguments)};t(f.prototype,{defaultOptions:{dateTimeLabelFormats:{millisecond:{main:"%H:%M:%S.%L",
range:!1},second:{main:"%H:%M:%S",range:!1},minute:{main:"%H:%M",range:!1},hour:{main:"%H:%M",range:!1},day:{main:"%e. %b"},week:{main:"%e. %b"},month:{main:"%b '%y"},year:{main:"%Y"}},endOnTick:!1,labels:{enabled:!0,indentation:10,x:0,style:{color:"#666666",cursor:"default",fontSize:"11px"}},maxPadding:.01,minorTickLength:2,minorTickPosition:"outside",minPadding:.01,showEmpty:!0,startOfWeek:1,startOnTick:!1,tickLength:10,tickPixelInterval:100,tickmarkPlacement:"between",tickPosition:"outside",title:{align:"middle",
style:{color:"#666666"}},type:"linear",minorGridLineColor:"#f2f2f2",minorGridLineWidth:1,minorTickColor:"#999999",lineColor:"#ccd6eb",lineWidth:1,gridLineColor:"#e6e6e6",tickColor:"#ccd6eb"},defaultYAxisOptions:{endOnTick:!0,maxPadding:.05,minPadding:.05,tickPixelInterval:72,showLastLabel:!0,labels:{x:-8},startOnTick:!0,title:{rotation:270,text:"Values"},stackLabels:{allowOverlap:!1,enabled:!1,crop:!0,overflow:"justify",formatter:function(){return c.numberFormat(this.total,-1)},style:{color:"#000000",
fontSize:"11px",fontWeight:"bold",textOutline:"1px contrast"}},gridLineWidth:1,lineWidth:0},defaultLeftAxisOptions:{labels:{x:-15},title:{rotation:270}},defaultRightAxisOptions:{labels:{x:15},title:{rotation:90}},defaultBottomAxisOptions:{labels:{autoRotation:[-45],x:0},margin:15,title:{rotation:0}},defaultTopAxisOptions:{labels:{autoRotation:[-45],x:0},margin:15,title:{rotation:0}},init:function(a,b){var d=b.isX,m=this;m.chart=a;m.horiz=a.inverted&&!m.isZAxis?!d:d;m.isXAxis=d;m.coll=m.coll||(d?"xAxis":
"yAxis");L(this,"init",{userOptions:b});m.opposite=b.opposite;m.side=b.side||(m.horiz?m.opposite?0:2:m.opposite?1:3);m.setOptions(b);var e=this.options,w=e.type;m.labelFormatter=e.labels.formatter||m.defaultLabelFormatter;m.userOptions=b;m.minPixelPadding=0;m.reversed=e.reversed;m.visible=!1!==e.visible;m.zoomEnabled=!1!==e.zoomEnabled;m.hasNames="category"===w||!0===e.categories;m.categories=e.categories||m.hasNames;m.names||(m.names=[],m.names.keys={});m.plotLinesAndBandsGroups={};m.isLog="logarithmic"===
w;m.isDatetimeAxis="datetime"===w;m.positiveValuesOnly=m.isLog&&!m.allowNegativeLog;m.isLinked=z(e.linkedTo);m.ticks={};m.labelEdge=[];m.minorTicks={};m.plotLinesAndBands=[];m.alternateBands={};m.len=0;m.minRange=m.userMinRange=e.minRange||e.maxZoom;m.range=e.range;m.offset=e.offset||0;m.stacks={};m.oldStacks={};m.stacksTouched=0;m.max=null;m.min=null;m.crosshair=h(e.crosshair,n(a.options.tooltip.crosshairs)[d?0:1],!1);b=m.options.events;-1===a.axes.indexOf(m)&&(d?a.axes.splice(a.xAxis.length,0,m):
a.axes.push(m),a[m.coll].push(m));m.series=m.series||[];a.inverted&&!m.isZAxis&&d&&void 0===m.reversed&&(m.reversed=!0);y(b,function(a,b){c.isFunction(a)&&g(m,b,a)});m.lin2log=e.linearToLogConverter||m.lin2log;m.isLog&&(m.val2lin=m.log2lin,m.lin2val=m.lin2log);L(this,"afterInit")},setOptions:function(a){this.options=u(this.defaultOptions,"yAxis"===this.coll&&this.defaultYAxisOptions,[this.defaultTopAxisOptions,this.defaultRightAxisOptions,this.defaultBottomAxisOptions,this.defaultLeftAxisOptions][this.side],
u(e[this.coll],a));L(this,"afterSetOptions",{userOptions:a})},defaultLabelFormatter:function(){var a=this.axis,b=this.value,d=a.chart.time,k=a.categories,l=this.dateTimeLabelFormat,g=e.lang,r=g.numericSymbols;g=g.numericSymbolMagnitude||1E3;var x=r&&r.length,p=a.options.labels.format;a=a.isLog?Math.abs(b):a.tickInterval;if(p)var h=E(p,this,d);else if(k)h=b;else if(l)h=d.dateFormat(l,b);else if(x&&1E3<=a)for(;x--&&void 0===h;)d=Math.pow(g,x+1),a>=d&&0===10*b%d&&null!==r[x]&&0!==b&&(h=c.numberFormat(b/
d,-1)+r[x]);void 0===h&&(h=1E4<=Math.abs(b)?c.numberFormat(b,-1):c.numberFormat(b,-1,void 0,""));return h},getSeriesExtremes:function(){var a=this,b=a.chart,d;L(this,"getSeriesExtremes",null,function(){a.hasVisibleSeries=!1;a.dataMin=a.dataMax=a.threshold=null;a.softThreshold=!a.isXAxis;a.buildStacks&&a.buildStacks();a.series.forEach(function(m){if(m.visible||!b.options.chart.ignoreHiddenSeries){var e=m.options,w=e.threshold;a.hasVisibleSeries=!0;a.positiveValuesOnly&&0>=w&&(w=null);if(a.isXAxis){if(e=
m.xData,e.length){d=m.getXExtremes(e);var k=d.min;var c=d.max;C(k)||k instanceof Date||(e=e.filter(C),d=m.getXExtremes(e),k=d.min,c=d.max);e.length&&(a.dataMin=Math.min(h(a.dataMin,k),k),a.dataMax=Math.max(h(a.dataMax,c),c))}}else if(m.getExtremes(),c=m.dataMax,k=m.dataMin,z(k)&&z(c)&&(a.dataMin=Math.min(h(a.dataMin,k),k),a.dataMax=Math.max(h(a.dataMax,c),c)),z(w)&&(a.threshold=w),!e.softThreshold||a.positiveValuesOnly)a.softThreshold=!1}})});L(this,"afterGetSeriesExtremes")},translate:function(a,
b,d,e,k,c){var m=this.linkedParent||this,w=1,l=0,g=e?m.oldTransA:m.transA;e=e?m.oldMin:m.min;var r=m.minPixelPadding;k=(m.isOrdinal||m.isBroken||m.isLog&&k)&&m.lin2val;g||(g=m.transA);d&&(w*=-1,l=m.len);m.reversed&&(w*=-1,l-=w*(m.sector||m.len));b?(a=(a*w+l-r)/g+e,k&&(a=m.lin2val(a))):(k&&(a=m.val2lin(a)),a=C(e)?w*(a-e)*g+l+w*r+(C(c)?g*c:0):void 0);return a},toPixels:function(a,b){return this.translate(a,!1,!this.horiz,null,!0)+(b?0:this.pos)},toValue:function(a,b){return this.translate(a-(b?0:this.pos),
!0,!this.horiz,null,!0)},getPlotLinePath:function(a){var b=this,d=b.chart,e=b.left,w=b.top,k=a.old,c=a.value,l=a.translatedValue,g=a.lineWidth,r=a.force,x,p,A,u,f=k&&d.oldChartHeight||d.chartHeight,n=k&&d.oldChartWidth||d.chartWidth,E,q=b.transB,v=function(a,b,d){if("pass"!==r&&a<b||a>d)r?a=Math.min(Math.max(b,a),d):E=!0;return a};a={value:c,lineWidth:g,old:k,force:r,acrossPanes:a.acrossPanes,translatedValue:l};L(this,"getPlotLinePath",a,function(a){l=h(l,b.translate(c,null,null,k));l=Math.min(Math.max(-1E5,
l),1E5);x=A=Math.round(l+q);p=u=Math.round(f-l-q);C(l)?b.horiz?(p=w,u=f-b.bottom,x=A=v(x,e,e+b.width)):(x=e,A=n-b.right,p=u=v(p,w,w+b.height)):(E=!0,r=!1);a.path=E&&!r?null:d.renderer.crispLine(["M",x,p,"L",A,u],g||1)});return a.path},getLinearTickPositions:function(a,b,e){var m=d(Math.floor(b/a)*a);e=d(Math.ceil(e/a)*a);var w=[],k;d(m+a)===m&&(k=20);if(this.single)return[b];for(b=m;b<=e;){w.push(b);b=d(b+a,k);if(b===c)break;var c=b}return w},getMinorTickInterval:function(){var a=this.options;return!0===
a.minorTicks?h(a.minorTickInterval,"auto"):!1===a.minorTicks?null:a.minorTickInterval},getMinorTickPositions:function(){var a=this,b=a.options,d=a.tickPositions,e=a.minorTickInterval,k=[],c=a.pointRangePadding||0,l=a.min-c;c=a.max+c;var g=c-l;if(g&&g/e<a.len/3)if(a.isLog)this.paddedTicks.forEach(function(b,d,m){d&&k.push.apply(k,a.getLogTickPositions(e,m[d-1],m[d],!0))});else if(a.isDatetimeAxis&&"auto"===this.getMinorTickInterval())k=k.concat(a.getTimeTicks(a.normalizeTimeTickInterval(e),l,c,b.startOfWeek));
else for(b=l+(d[0]-l)%e;b<=c&&b!==k[0];b+=e)k.push(b);0!==k.length&&a.trimTicks(k);return k},adjustForMinRange:function(){var a=this.options,b=this.min,d=this.max,e,k,c,l,g;this.isXAxis&&void 0===this.minRange&&!this.isLog&&(z(a.min)||z(a.max)?this.minRange=null:(this.series.forEach(function(a){l=a.xData;for(k=g=a.xIncrement?1:l.length-1;0<k;k--)if(c=l[k]-l[k-1],void 0===e||c<e)e=c}),this.minRange=Math.min(5*e,this.dataMax-this.dataMin)));if(d-b<this.minRange){var r=this.dataMax-this.dataMin>=this.minRange;
var x=this.minRange;var p=(x-d+b)/2;p=[b-p,h(a.min,b-p)];r&&(p[2]=this.isLog?this.log2lin(this.dataMin):this.dataMin);b=F(p);d=[b+x,h(a.max,b+x)];r&&(d[2]=this.isLog?this.log2lin(this.dataMax):this.dataMax);d=G(d);d-b<x&&(p[0]=d-x,p[1]=h(a.min,d-x),b=F(p))}this.min=b;this.max=d},getClosest:function(){var a;this.categories?a=1:this.series.forEach(function(b){var d=b.closestPointRange,m=b.visible||!b.chart.options.chart.ignoreHiddenSeries;!b.noSharedTooltip&&z(d)&&m&&(a=z(a)?Math.min(a,d):d)});return a},
nameToX:function(a){var b=v(this.categories),d=b?this.categories:this.names,e=a.options.x;a.series.requireSorting=!1;z(e)||(e=!1===this.options.uniqueNames?a.series.autoIncrement():b?d.indexOf(a.name):h(d.keys[a.name],-1));if(-1===e){if(!b)var k=d.length}else k=e;void 0!==k&&(this.names[k]=a.name,this.names.keys[a.name]=k);return k},updateNames:function(){var a=this,b=this.names;0<b.length&&(Object.keys(b.keys).forEach(function(a){delete b.keys[a]}),b.length=0,this.minRange=this.userMinRange,(this.series||
[]).forEach(function(b){b.xIncrement=null;if(!b.points||b.isDirtyData)a.max=Math.max(a.max,b.xData.length-1),b.processData(),b.generatePoints();b.data.forEach(function(d,e){if(d&&d.options&&void 0!==d.name){var m=a.nameToX(d);void 0!==m&&m!==d.x&&(d.x=m,b.xData[e]=m)}})}))},setAxisTranslation:function(a){var b=this,d=b.max-b.min,e=b.axisPointRange||0,k=0,w=0,c=b.linkedParent,l=!!b.categories,g=b.transA,r=b.isXAxis;if(r||l||e){var p=b.getClosest();c?(k=c.minPointOffset,w=c.pointRangePadding):b.series.forEach(function(a){var d=
l?1:r?h(a.options.pointRange,p,0):b.axisPointRange||0,m=a.options.pointPlacement;e=Math.max(e,d);if(!b.single||l)a=x.xrange&&a instanceof x.xrange?!r:r,k=Math.max(k,a&&H(m)?0:d/2),w=Math.max(w,a&&"on"===m?0:d)});c=b.ordinalSlope&&p?b.ordinalSlope/p:1;b.minPointOffset=k*=c;b.pointRangePadding=w*=c;b.pointRange=Math.min(e,b.single&&l?1:d);r&&(b.closestPointRange=p)}a&&(b.oldTransA=g);b.translationSlope=b.transA=g=b.staticScale||b.len/(d+w||1);b.transB=b.horiz?b.left:b.bottom;b.minPixelPadding=g*k;L(this,
"afterSetAxisTranslation")},minFromRange:function(){return this.max-this.range},setTickInterval:function(a){var b=this,e=b.chart,w=b.options,l=b.isLog,g=b.isDatetimeAxis,r=b.isXAxis,x=b.isLinked,A=w.maxPadding,u=w.minPadding,f=w.tickInterval,n=w.tickPixelInterval,E=b.categories,q=C(b.threshold)?b.threshold:null,v=b.softThreshold;g||E||x||this.getTickAmount();var t=h(b.userMin,w.min);var y=h(b.userMax,w.max);if(x){b.linkedParent=e[b.coll][w.linkedTo];var B=b.linkedParent.getExtremes();b.min=h(B.min,
B.dataMin);b.max=h(B.max,B.dataMax);w.type!==b.linkedParent.options.type&&c.error(11,1,e)}else{if(!v&&z(q))if(b.dataMin>=q)B=q,u=0;else if(b.dataMax<=q){var H=q;A=0}b.min=h(t,B,b.dataMin);b.max=h(y,H,b.dataMax)}l&&(b.positiveValuesOnly&&!a&&0>=Math.min(b.min,h(b.dataMin,b.min))&&c.error(10,1,e),b.min=d(b.log2lin(b.min),16),b.max=d(b.log2lin(b.max),16));b.range&&z(b.max)&&(b.userMin=b.min=t=Math.max(b.dataMin,b.minFromRange()),b.userMax=y=b.max,b.range=null);L(b,"foundExtremes");b.beforePadding&&b.beforePadding();
b.adjustForMinRange();!(E||b.axisPointRange||b.usePercentage||x)&&z(b.min)&&z(b.max)&&(e=b.max-b.min)&&(!z(t)&&u&&(b.min-=e*u),!z(y)&&A&&(b.max+=e*A));C(w.softMin)&&!C(b.userMin)&&w.softMin<b.min&&(b.min=t=w.softMin);C(w.softMax)&&!C(b.userMax)&&w.softMax>b.max&&(b.max=y=w.softMax);C(w.floor)&&(b.min=Math.min(Math.max(b.min,w.floor),Number.MAX_VALUE));C(w.ceiling)&&(b.max=Math.max(Math.min(b.max,w.ceiling),h(b.userMax,-Number.MAX_VALUE)));v&&z(b.dataMin)&&(q=q||0,!z(t)&&b.min<q&&b.dataMin>=q?b.min=
b.options.minRange?Math.min(q,b.max-b.minRange):q:!z(y)&&b.max>q&&b.dataMax<=q&&(b.max=b.options.minRange?Math.max(q,b.min+b.minRange):q));b.tickInterval=b.min===b.max||void 0===b.min||void 0===b.max?1:x&&!f&&n===b.linkedParent.options.tickPixelInterval?f=b.linkedParent.tickInterval:h(f,this.tickAmount?(b.max-b.min)/Math.max(this.tickAmount-1,1):void 0,E?1:(b.max-b.min)*n/Math.max(b.len,n));r&&!a&&b.series.forEach(function(a){a.processData(b.min!==b.oldMin||b.max!==b.oldMax)});b.setAxisTranslation(!0);
b.beforeSetTickPositions&&b.beforeSetTickPositions();b.postProcessTickInterval&&(b.tickInterval=b.postProcessTickInterval(b.tickInterval));b.pointRange&&!f&&(b.tickInterval=Math.max(b.pointRange,b.tickInterval));a=h(w.minTickInterval,b.isDatetimeAxis&&b.closestPointRange);!f&&b.tickInterval<a&&(b.tickInterval=a);g||l||f||(b.tickInterval=k(b.tickInterval,null,p(b.tickInterval),h(w.allowDecimals,!(.5<b.tickInterval&&5>b.tickInterval&&1E3<b.max&&9999>b.max)),!!this.tickAmount));this.tickAmount||(b.tickInterval=
b.unsquish());this.setTickPositions()},setTickPositions:function(){var a=this.options,b=a.tickPositions;var d=this.getMinorTickInterval();var e=a.tickPositioner,k=a.startOnTick,l=a.endOnTick;this.tickmarkOffset=this.categories&&"between"===a.tickmarkPlacement&&1===this.tickInterval?.5:0;this.minorTickInterval="auto"===d&&this.tickInterval?this.tickInterval/5:d;this.single=this.min===this.max&&z(this.min)&&!this.tickAmount&&(parseInt(this.min,10)===this.min||!1!==a.allowDecimals);this.tickPositions=
d=b&&b.slice();!d&&(!this.ordinalPositions&&(this.max-this.min)/this.tickInterval>Math.max(2*this.len,200)?(d=[this.min,this.max],c.error(19,!1,this.chart)):d=this.isDatetimeAxis?this.getTimeTicks(this.normalizeTimeTickInterval(this.tickInterval,a.units),this.min,this.max,a.startOfWeek,this.ordinalPositions,this.closestPointRange,!0):this.isLog?this.getLogTickPositions(this.tickInterval,this.min,this.max):this.getLinearTickPositions(this.tickInterval,this.min,this.max),d.length>this.len&&(d=[d[0],
d.pop()],d[0]===d[1]&&(d.length=1)),this.tickPositions=d,e&&(e=e.apply(this,[this.min,this.max])))&&(this.tickPositions=d=e);this.paddedTicks=d.slice(0);this.trimTicks(d,k,l);this.isLinked||(this.single&&2>d.length&&!this.categories&&(this.min-=.5,this.max+=.5),b||e||this.adjustTickAmount());L(this,"afterSetTickPositions")},trimTicks:function(a,b,d){var e=a[0],m=a[a.length-1],k=this.minPointOffset||0;L(this,"trimTicks");if(!this.isLinked){if(b&&-Infinity!==e)this.min=e;else for(;this.min-k>a[0];)a.shift();
if(d)this.max=m;else for(;this.max+k<a[a.length-1];)a.pop();0===a.length&&z(e)&&!this.options.tickPositions&&a.push((m+e)/2)}},alignToOthers:function(){var a={},b,d=this.options;!1===this.chart.options.chart.alignTicks||!1===d.alignTicks||!1===d.startOnTick||!1===d.endOnTick||this.isLog||this.chart[this.coll].forEach(function(d){var e=d.options;e=[d.horiz?e.left:e.top,e.width,e.height,e.pane].join();d.series.length&&(a[e]?b=!0:a[e]=1)});return b},getTickAmount:function(){var a=this.options,b=a.tickAmount,
d=a.tickPixelInterval;!z(a.tickInterval)&&this.len<d&&!this.isRadial&&!this.isLog&&a.startOnTick&&a.endOnTick&&(b=2);!b&&this.alignToOthers()&&(b=Math.ceil(this.len/d)+1);4>b&&(this.finalTickAmt=b,b=5);this.tickAmount=b},adjustTickAmount:function(){var a=this.options,b=this.tickInterval,e=this.tickPositions,k=this.tickAmount,c=this.finalTickAmt,l=e&&e.length,g=h(this.threshold,this.softThreshold?0:null),r;if(this.hasData()){if(l<k){for(r=this.min;e.length<k;)e.length%2||r===g?e.push(d(e[e.length-
1]+b)):e.unshift(d(e[0]-b));this.transA*=(l-1)/(k-1);this.min=a.startOnTick?e[0]:Math.min(this.min,e[0]);this.max=a.endOnTick?e[e.length-1]:Math.max(this.max,e[e.length-1])}else l>k&&(this.tickInterval*=2,this.setTickPositions());if(z(c)){for(b=a=e.length;b--;)(3===c&&1===b%2||2>=c&&0<b&&b<a-1)&&e.splice(b,1);this.finalTickAmt=void 0}}},setScale:function(){var a=this.series.some(function(a){return a.isDirtyData||a.isDirty||a.xAxis&&a.xAxis.isDirty}),b;this.oldMin=this.min;this.oldMax=this.max;this.oldAxisLength=
this.len;this.setAxisSize();(b=this.len!==this.oldAxisLength)||a||this.isLinked||this.forceRedraw||this.userMin!==this.oldUserMin||this.userMax!==this.oldUserMax||this.alignToOthers()?(this.resetStacks&&this.resetStacks(),this.forceRedraw=!1,this.getSeriesExtremes(),this.setTickInterval(),this.oldUserMin=this.userMin,this.oldUserMax=this.userMax,this.isDirty||(this.isDirty=b||this.min!==this.oldMin||this.max!==this.oldMax)):this.cleanStacks&&this.cleanStacks();L(this,"afterSetScale")},setExtremes:function(a,
b,d,e,k){var m=this,w=m.chart;d=h(d,!0);m.series.forEach(function(a){delete a.kdTree});k=t(k,{min:a,max:b});L(m,"setExtremes",k,function(){m.userMin=a;m.userMax=b;m.eventArgs=k;d&&w.redraw(e)})},zoom:function(a,b){var d=this.dataMin,e=this.dataMax,m=this.options,k=Math.min(d,h(m.min,d)),w=Math.max(e,h(m.max,e));a={newMin:a,newMax:b};L(this,"zoom",a,function(a){var b=a.newMin,m=a.newMax;if(b!==this.min||m!==this.max)this.allowZoomOutside||(z(d)&&(b<k&&(b=k),b>w&&(b=w)),z(e)&&(m<k&&(m=k),m>w&&(m=w))),
this.displayBtn=void 0!==b||void 0!==m,this.setExtremes(b,m,!1,void 0,{trigger:"zoom"});a.zoomed=!0});return a.zoomed},setAxisSize:function(){var a=this.chart,b=this.options,d=b.offsets||[0,0,0,0],e=this.horiz,k=this.width=Math.round(c.relativeLength(h(b.width,a.plotWidth-d[3]+d[1]),a.plotWidth)),l=this.height=Math.round(c.relativeLength(h(b.height,a.plotHeight-d[0]+d[2]),a.plotHeight)),g=this.top=Math.round(c.relativeLength(h(b.top,a.plotTop+d[0]),a.plotHeight,a.plotTop));b=this.left=Math.round(c.relativeLength(h(b.left,
a.plotLeft+d[3]),a.plotWidth,a.plotLeft));this.bottom=a.chartHeight-l-g;this.right=a.chartWidth-k-b;this.len=Math.max(e?k:l,0);this.pos=e?b:g},getExtremes:function(){var a=this.isLog;return{min:a?d(this.lin2log(this.min)):this.min,max:a?d(this.lin2log(this.max)):this.max,dataMin:this.dataMin,dataMax:this.dataMax,userMin:this.userMin,userMax:this.userMax}},getThreshold:function(a){var b=this.isLog,d=b?this.lin2log(this.min):this.min;b=b?this.lin2log(this.max):this.max;null===a||-Infinity===a?a=d:Infinity===
a?a=b:d>a?a=d:b<a&&(a=b);return this.translate(a,0,1,0,1)},autoLabelAlign:function(a){var b=(h(a,0)-90*this.side+720)%360;a={align:"center"};L(this,"autoLabelAlign",a,function(a){15<b&&165>b?a.align="right":195<b&&345>b&&(a.align="left")});return a.align},tickSize:function(a){var b=this.options,d=b[a+"Length"],e=h(b[a+"Width"],"tick"===a&&this.isXAxis&&!this.categories?1:0);if(e&&d){"inside"===b[a+"Position"]&&(d=-d);var k=[d,e]}a={tickSize:k};L(this,"afterTickSize",a);return a.tickSize},labelMetrics:function(){var a=
this.tickPositions&&this.tickPositions[0]||0;return this.chart.renderer.fontMetrics(this.options.labels.style&&this.options.labels.style.fontSize,this.ticks[a]&&this.ticks[a].label)},unsquish:function(){var a=this.options.labels,b=this.horiz,e=this.tickInterval,k=e,c=this.len/(((this.categories?1:0)+this.max-this.min)/e),g,r=a.rotation,x=this.labelMetrics(),p,A=Number.MAX_VALUE,u,f=this.max-this.min,n=function(a){var b=a/(c||1);b=1<b?Math.ceil(b):1;b*e>f&&Infinity!==a&&Infinity!==c&&f&&(b=Math.ceil(f/
e));return d(b*e)};b?(u=!a.staggerLines&&!a.step&&(z(r)?[r]:c<h(a.autoRotationLimit,80)&&a.autoRotation))&&u.forEach(function(a){if(a===r||a&&-90<=a&&90>=a){p=n(Math.abs(x.h/Math.sin(l*a)));var b=p+Math.abs(a/360);b<A&&(A=b,g=a,k=p)}}):a.step||(k=n(x.h));this.autoRotation=u;this.labelRotation=h(g,r);return k},getSlotWidth:function(a){var b=this.chart,d=this.horiz,e=this.options.labels,k=Math.max(this.tickPositions.length-(this.categories?0:1),1),c=b.margin[3];return a&&a.slotWidth||d&&2>(e.step||
0)&&!e.rotation&&(this.staggerLines||1)*this.len/k||!d&&(e.style&&parseInt(e.style.width,10)||c&&c-b.spacing[3]||.33*b.chartWidth)},renderUnsquish:function(){var a=this.chart,b=a.renderer,d=this.tickPositions,e=this.ticks,k=this.options.labels,c=k&&k.style||{},l=this.horiz,g=this.getSlotWidth(),r=Math.max(1,Math.round(g-2*(k.padding||5))),x={},p=this.labelMetrics(),h=k.style&&k.style.textOverflow,A=0;H(k.rotation)||(x.rotation=k.rotation||0);d.forEach(function(a){(a=e[a])&&a.label&&a.label.textPxLength>
A&&(A=a.label.textPxLength)});this.maxLabelLength=A;if(this.autoRotation)A>r&&A>p.h?x.rotation=this.labelRotation:this.labelRotation=0;else if(g){var u=r;if(!h){var f="clip";for(r=d.length;!l&&r--;){var n=d[r];if(n=e[n].label)n.styles&&"ellipsis"===n.styles.textOverflow?n.css({textOverflow:"clip"}):n.textPxLength>g&&n.css({width:g+"px"}),n.getBBox().height>this.len/d.length-(p.h-p.f)&&(n.specificTextOverflow="ellipsis")}}}x.rotation&&(u=A>.5*a.chartHeight?.33*a.chartHeight:A,h||(f="ellipsis"));if(this.labelAlign=
k.align||this.autoLabelAlign(this.labelRotation))x.align=this.labelAlign;d.forEach(function(a){var b=(a=e[a])&&a.label,d=c.width,k={};b&&(b.attr(x),a.shortenLabel?a.shortenLabel():u&&!d&&"nowrap"!==c.whiteSpace&&(u<b.textPxLength||"SPAN"===b.element.tagName)?(k.width=u,h||(k.textOverflow=b.specificTextOverflow||f),b.css(k)):b.styles&&b.styles.width&&!k.width&&!d&&b.css({width:null}),delete b.specificTextOverflow,a.rotation=x.rotation)},this);this.tickRotCorr=b.rotCorr(p.b,this.labelRotation||0,0!==
this.side)},hasData:function(){return this.series.some(function(a){return a.hasData()})||this.options.showEmpty&&z(this.min)&&z(this.max)},addTitle:function(a){var b=this.chart.renderer,d=this.horiz,e=this.opposite,k=this.options.title,c,l=this.chart.styledMode;this.axisTitle||((c=k.textAlign)||(c=(d?{low:"left",middle:"center",high:"right"}:{low:e?"right":"left",middle:"center",high:e?"left":"right"})[k.align]),this.axisTitle=b.text(k.text,0,0,k.useHTML).attr({zIndex:7,rotation:k.rotation||0,align:c}).addClass("highcharts-axis-title"),
l||this.axisTitle.css(u(k.style)),this.axisTitle.add(this.axisGroup),this.axisTitle.isNew=!0);l||k.style.width||this.isRadial||this.axisTitle.css({width:this.len});this.axisTitle[a?"show":"hide"](a)},generateTick:function(a){var b=this.ticks;b[a]?b[a].addLabel():b[a]=new A(this,a)},getOffset:function(){var a=this,b=a.chart,d=b.renderer,e=a.options,k=a.tickPositions,c=a.ticks,l=a.horiz,g=a.side,r=b.inverted&&!a.isZAxis?[1,0,3,2][g]:g,x,p=0,A=0,u=e.title,n=e.labels,f=0,E=b.axisOffset;b=b.clipOffset;
var q=[-1,1,1,-1][g],v=e.className,t=a.axisParent;var C=a.hasData();a.showAxis=x=C||h(e.showEmpty,!0);a.staggerLines=a.horiz&&n.staggerLines;a.axisGroup||(a.gridGroup=d.g("grid").attr({zIndex:e.gridZIndex||1}).addClass("highcharts-"+this.coll.toLowerCase()+"-grid "+(v||"")).add(t),a.axisGroup=d.g("axis").attr({zIndex:e.zIndex||2}).addClass("highcharts-"+this.coll.toLowerCase()+" "+(v||"")).add(t),a.labelGroup=d.g("axis-labels").attr({zIndex:n.zIndex||7}).addClass("highcharts-"+a.coll.toLowerCase()+
"-labels "+(v||"")).add(t));C||a.isLinked?(k.forEach(function(b,d){a.generateTick(b,d)}),a.renderUnsquish(),a.reserveSpaceDefault=0===g||2===g||{1:"left",3:"right"}[g]===a.labelAlign,h(n.reserveSpace,"center"===a.labelAlign?!0:null,a.reserveSpaceDefault)&&k.forEach(function(a){f=Math.max(c[a].getLabelSize(),f)}),a.staggerLines&&(f*=a.staggerLines),a.labelOffset=f*(a.opposite?-1:1)):y(c,function(a,b){a.destroy();delete c[b]});if(u&&u.text&&!1!==u.enabled&&(a.addTitle(x),x&&!1!==u.reserveSpace)){a.titleOffset=
p=a.axisTitle.getBBox()[l?"height":"width"];var B=u.offset;A=z(B)?0:h(u.margin,l?5:10)}a.renderLine();a.offset=q*h(e.offset,E[g]?E[g]+(e.margin||0):0);a.tickRotCorr=a.tickRotCorr||{x:0,y:0};d=0===g?-a.labelMetrics().h:2===g?a.tickRotCorr.y:0;A=Math.abs(f)+A;f&&(A=A-d+q*(l?h(n.y,a.tickRotCorr.y+8*q):n.x));a.axisTitleMargin=h(B,A);a.getMaxLabelDimensions&&(a.maxLabelDimensions=a.getMaxLabelDimensions(c,k));l=this.tickSize("tick");E[g]=Math.max(E[g],a.axisTitleMargin+p+q*a.offset,A,k&&k.length&&l?l[0]+
q*a.offset:0);e=e.offset?0:2*Math.floor(a.axisLine.strokeWidth()/2);b[r]=Math.max(b[r],e);L(this,"afterGetOffset")},getLinePath:function(a){var b=this.chart,d=this.opposite,e=this.offset,k=this.horiz,c=this.left+(d?this.width:0)+e;e=b.chartHeight-this.bottom-(d?this.height:0)+e;d&&(a*=-1);return b.renderer.crispLine(["M",k?this.left:c,k?e:this.top,"L",k?b.chartWidth-this.right:c,k?e:b.chartHeight-this.bottom],a)},renderLine:function(){this.axisLine||(this.axisLine=this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup),
this.chart.styledMode||this.axisLine.attr({stroke:this.options.lineColor,"stroke-width":this.options.lineWidth,zIndex:7}))},getTitlePosition:function(){var a=this.horiz,b=this.left,d=this.top,e=this.len,k=this.options.title,c=a?b:d,l=this.opposite,g=this.offset,r=k.x||0,x=k.y||0,p=this.axisTitle,A=this.chart.renderer.fontMetrics(k.style&&k.style.fontSize,p);p=Math.max(p.getBBox(null,0).height-A.h-1,0);e={low:c+(a?0:e),middle:c+e/2,high:c+(a?e:0)}[k.align];b=(a?d+this.height:b)+(a?1:-1)*(l?-1:1)*this.axisTitleMargin+
[-p,p,A.f,-p][this.side];a={x:a?e+r:b+(l?this.width:0)+g+r,y:a?b+x-(l?this.height:0)+g:e+x};L(this,"afterGetTitlePosition",{titlePosition:a});return a},renderMinorTick:function(a){var b=this.chart.hasRendered&&C(this.oldMin),d=this.minorTicks;d[a]||(d[a]=new A(this,a,"minor"));b&&d[a].isNew&&d[a].render(null,!0);d[a].render(null,!1,1)},renderTick:function(a,b){var d=this.isLinked,e=this.ticks,k=this.chart.hasRendered&&C(this.oldMin);if(!d||a>=this.min&&a<=this.max)e[a]||(e[a]=new A(this,a)),k&&e[a].isNew&&
e[a].render(b,!0,-1),e[a].render(b)},render:function(){var a=this,d=a.chart,e=a.options,k=a.isLog,l=a.isLinked,g=a.tickPositions,r=a.axisTitle,x=a.ticks,p=a.minorTicks,h=a.alternateBands,u=e.stackLabels,f=e.alternateGridColor,n=a.tickmarkOffset,E=a.axisLine,v=a.showAxis,t=b(d.renderer.globalAnimation),B,H;a.labelEdge.length=0;a.overlap=!1;[x,p,h].forEach(function(a){y(a,function(a){a.isActive=!1})});if(a.hasData()||l)a.minorTickInterval&&!a.categories&&a.getMinorTickPositions().forEach(function(b){a.renderMinorTick(b)}),
g.length&&(g.forEach(function(b,d){a.renderTick(b,d)}),n&&(0===a.min||a.single)&&(x[-1]||(x[-1]=new A(a,-1,null,!0)),x[-1].render(-1))),f&&g.forEach(function(b,e){H=void 0!==g[e+1]?g[e+1]+n:a.max-n;0===e%2&&b<a.max&&H<=a.max+(d.polar?-n:n)&&(h[b]||(h[b]=new c.PlotLineOrBand(a)),B=b+n,h[b].options={from:k?a.lin2log(B):B,to:k?a.lin2log(H):H,color:f},h[b].render(),h[b].isActive=!0)}),a._addedPlotLB||((e.plotLines||[]).concat(e.plotBands||[]).forEach(function(b){a.addPlotBandOrLine(b)}),a._addedPlotLB=
!0);[x,p,h].forEach(function(a){var b,e=[],k=t.duration;y(a,function(a,b){a.isActive||(a.render(b,!1,0),a.isActive=!1,e.push(b))});q(function(){for(b=e.length;b--;)a[e[b]]&&!a[e[b]].isActive&&(a[e[b]].destroy(),delete a[e[b]])},a!==h&&d.hasRendered&&k?k:0)});E&&(E[E.isPlaced?"animate":"attr"]({d:this.getLinePath(E.strokeWidth())}),E.isPlaced=!0,E[v?"show":"hide"](v));r&&v&&(e=a.getTitlePosition(),C(e.y)?(r[r.isNew?"attr":"animate"](e),r.isNew=!1):(r.attr("y",-9999),r.isNew=!0));u&&u.enabled&&a.renderStackTotals();
a.isDirty=!1;L(this,"afterRender")},redraw:function(){this.visible&&(this.render(),this.plotLinesAndBands.forEach(function(a){a.render()}));this.series.forEach(function(a){a.isDirty=!0})},keepProps:"extKey hcEvents names series userMax userMin".split(" "),destroy:function(a){var b=this,d=b.stacks,e=b.plotLinesAndBands,k;L(this,"destroy",{keepEvents:a});a||r(b);y(d,function(a,b){B(a);d[b]=null});[b.ticks,b.minorTicks,b.alternateBands].forEach(function(a){B(a)});if(e)for(a=e.length;a--;)e[a].destroy();
"stackTotalGroup axisLine axisTitle axisGroup gridGroup labelGroup cross scrollbar".split(" ").forEach(function(a){b[a]&&(b[a]=b[a].destroy())});for(k in b.plotLinesAndBandsGroups)b.plotLinesAndBandsGroups[k]=b.plotLinesAndBandsGroups[k].destroy();y(b,function(a,d){-1===b.keepProps.indexOf(d)&&delete b[d]})},drawCrosshair:function(b,d){var e,k=this.crosshair,c=h(k.snap,!0),l,g=this.cross;L(this,"drawCrosshair",{e:b,point:d});b||(b=this.cross&&this.cross.e);if(this.crosshair&&!1!==(z(d)||!c)){c?z(d)&&
(l=h("colorAxis"!==this.coll?d.crosshairPos:null,this.isXAxis?d.plotX:this.len-d.plotY)):l=b&&(this.horiz?b.chartX-this.pos:this.len-b.chartY+this.pos);z(l)&&(e=this.getPlotLinePath({value:d&&(this.isXAxis?d.x:h(d.stackY,d.y)),translatedValue:l})||null);if(!z(e)){this.hideCrosshair();return}c=this.categories&&!this.isRadial;g||(this.cross=g=this.chart.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-"+(c?"category ":"thin ")+k.className).attr({zIndex:h(k.zIndex,2)}).add(),this.chart.styledMode||
(g.attr({stroke:k.color||(c?a("#ccd6eb").setOpacity(.25).get():"#cccccc"),"stroke-width":h(k.width,1)}).css({"pointer-events":"none"}),k.dashStyle&&g.attr({dashstyle:k.dashStyle})));g.show().attr({d:e});c&&!k.width&&g.attr({"stroke-width":this.transA});this.cross.e=b}else this.hideCrosshair();L(this,"afterDrawCrosshair",{e:b,point:d})},hideCrosshair:function(){this.cross&&this.cross.hide();L(this,"afterHideCrosshair")}});return c.Axis=f});M(I,"parts/DateTimeAxis.js",[I["parts/Globals.js"]],function(c){var f=
c.Axis,F=c.getMagnitude,G=c.normalizeTickInterval,z=c.timeUnits;f.prototype.getTimeTicks=function(){return this.chart.time.getTimeTicks.apply(this.chart.time,arguments)};f.prototype.normalizeTimeTickInterval=function(c,f){var v=f||[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1,2]],["week",[1,2]],["month",[1,2,3,4,6]],["year",null]];f=v[v.length-1];var t=z[f[0]],B=f[1],y;for(y=0;y<v.length&&!(f=v[y],t=z[f[0]],
B=f[1],v[y+1]&&c<=(t*B[B.length-1]+z[v[y+1][0]])/2);y++);t===z.year&&c<5*t&&(B=[1,2,5]);c=G(c/t,B,"year"===f[0]?Math.max(F(c/t),1):1);return{unitRange:t,count:c,unitName:f[0]}}});M(I,"parts/LogarithmicAxis.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.pick;f=c.Axis;var G=c.getMagnitude,z=c.normalizeTickInterval;f.prototype.getLogTickPositions=function(c,f,v,C){var t=this.options,y=this.len,h=[];C||(this._minorAutoInterval=null);if(.5<=c)c=Math.round(c),h=this.getLinearTickPositions(c,
f,v);else if(.08<=c){y=Math.floor(f);var n,q;for(t=.3<c?[1,2,4]:.15<c?[1,2,4,6,8]:[1,2,3,4,5,6,7,8,9];y<v+1&&!q;y++){var g=t.length;for(n=0;n<g&&!q;n++){var b=this.log2lin(this.lin2log(y)*t[n]);b>f&&(!C||a<=v)&&void 0!==a&&h.push(a);a>v&&(q=!0);var a=b}}}else f=this.lin2log(f),v=this.lin2log(v),c=C?this.getMinorTickInterval():t.tickInterval,c=F("auto"===c?null:c,this._minorAutoInterval,t.tickPixelInterval/(C?5:1)*(v-f)/((C?y/this.tickPositions.length:y)||1)),c=z(c,null,G(c)),h=this.getLinearTickPositions(c,
f,v).map(this.log2lin),C||(this._minorAutoInterval=c/5);C||(this.tickInterval=c);return h};f.prototype.log2lin=function(c){return Math.log(c)/Math.LN10};f.prototype.lin2log=function(c){return Math.pow(10,c)}});M(I,"parts/PlotLineOrBand.js",[I["parts/Globals.js"],I["parts/Axis.js"],I["parts/Utilities.js"]],function(c,f,F){var G=F.arrayMax,z=F.arrayMin,B=F.defined,t=F.destroyObjectProperties,v=F.erase,C=F.extend,H=F.objectEach,y=F.pick,h=c.merge;c.PlotLineOrBand=function(c,h){this.axis=c;h&&(this.options=
h,this.id=h.id)};c.PlotLineOrBand.prototype={render:function(){c.fireEvent(this,"render");var f=this,q=f.axis,g=q.horiz,b=f.options,a=b.label,d=f.label,e=b.to,l=b.from,L=b.value,E=B(l)&&B(e),p=B(L),u=f.svgElem,k=!u,r=[],x=b.color,A=y(b.zIndex,0),w=b.events;r={"class":"highcharts-plot-"+(E?"band ":"line ")+(b.className||"")};var m={},K=q.chart.renderer,J=E?"bands":"lines";q.isLog&&(l=q.log2lin(l),e=q.log2lin(e),L=q.log2lin(L));q.chart.styledMode||(p?(r.stroke=x||"#999999",r["stroke-width"]=y(b.width,
1),b.dashStyle&&(r.dashstyle=b.dashStyle)):E&&(r.fill=x||"#e6ebf5",b.borderWidth&&(r.stroke=b.borderColor,r["stroke-width"]=b.borderWidth)));m.zIndex=A;J+="-"+A;(x=q.plotLinesAndBandsGroups[J])||(q.plotLinesAndBandsGroups[J]=x=K.g("plot-"+J).attr(m).add());k&&(f.svgElem=u=K.path().attr(r).add(x));if(p)r=q.getPlotLinePath({value:L,lineWidth:u.strokeWidth(),acrossPanes:b.acrossPanes});else if(E)r=q.getPlotBandPath(l,e,b);else return;(k||!u.d)&&r&&r.length?(u.attr({d:r}),w&&H(w,function(a,b){u.on(b,
function(a){w[b].apply(f,[a])})})):u&&(r?(u.show(!0),u.animate({d:r})):u.d&&(u.hide(),d&&(f.label=d=d.destroy())));a&&(B(a.text)||B(a.formatter))&&r&&r.length&&0<q.width&&0<q.height&&!r.isFlat?(a=h({align:g&&E&&"center",x:g?!E&&4:10,verticalAlign:!g&&E&&"middle",y:g?E?16:10:E?6:-4,rotation:g&&!E&&90},a),this.renderLabel(a,r,E,A)):d&&d.hide();return f},renderLabel:function(c,h,g,b){var a=this.label,d=this.axis.chart.renderer;a||(a={align:c.textAlign||c.align,rotation:c.rotation,"class":"highcharts-plot-"+
(g?"band":"line")+"-label "+(c.className||"")},a.zIndex=b,b=this.getLabelText(c),this.label=a=d.text(b,0,0,c.useHTML).attr(a).add(),this.axis.chart.styledMode||a.css(c.style));d=h.xBounds||[h[1],h[4],g?h[6]:h[1]];h=h.yBounds||[h[2],h[5],g?h[7]:h[2]];g=z(d);b=z(h);a.align(c,!1,{x:g,y:b,width:G(d)-g,height:G(h)-b});a.show(!0)},getLabelText:function(c){return B(c.formatter)?c.formatter.call(this):c.text},destroy:function(){v(this.axis.plotLinesAndBands,this);delete this.axis;t(this)}};C(f.prototype,
{getPlotBandPath:function(c,h){var g=this.getPlotLinePath({value:h,force:!0,acrossPanes:this.options.acrossPanes}),b=this.getPlotLinePath({value:c,force:!0,acrossPanes:this.options.acrossPanes}),a=[],d=this.horiz,e=1;c=c<this.min&&h<this.min||c>this.max&&h>this.max;if(b&&g){if(c){var l=b.toString()===g.toString();e=0}for(c=0;c<b.length;c+=6)d&&g[c+1]===b[c+1]?(g[c+1]+=e,g[c+4]+=e):d||g[c+2]!==b[c+2]||(g[c+2]+=e,g[c+5]+=e),a.push("M",b[c+1],b[c+2],"L",b[c+4],b[c+5],g[c+4],g[c+5],g[c+1],g[c+2],"z"),
a.isFlat=l}return a},addPlotBand:function(c){return this.addPlotBandOrLine(c,"plotBands")},addPlotLine:function(c){return this.addPlotBandOrLine(c,"plotLines")},addPlotBandOrLine:function(h,f){var g=(new c.PlotLineOrBand(this,h)).render(),b=this.userOptions;if(g){if(f){var a=b[f]||[];a.push(h);b[f]=a}this.plotLinesAndBands.push(g)}return g},removePlotBandOrLine:function(c){for(var h=this.plotLinesAndBands,g=this.options,b=this.userOptions,a=h.length;a--;)h[a].id===c&&h[a].destroy();[g.plotLines||
[],b.plotLines||[],g.plotBands||[],b.plotBands||[]].forEach(function(b){for(a=b.length;a--;)b[a].id===c&&v(b,b[a])})},removePlotBand:function(c){this.removePlotBandOrLine(c)},removePlotLine:function(c){this.removePlotBandOrLine(c)}})});M(I,"parts/Tooltip.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.defined,G=f.discardElement,z=f.extend,B=f.isNumber,t=f.isString,v=f.pick,C=f.splat,H=f.syncTimeout;"";var y=c.doc,h=c.format,n=c.merge,q=c.timeUnits;c.Tooltip=function(){this.init.apply(this,
arguments)};c.Tooltip.prototype={init:function(c,b){this.chart=c;this.options=b;this.crosshairs=[];this.now={x:0,y:0};this.isHidden=!0;this.split=b.split&&!c.inverted;this.shared=b.shared||this.split;this.outside=v(b.outside,!(!c.scrollablePixelsX&&!c.scrollablePixelsY))},cleanSplit:function(c){this.chart.series.forEach(function(b){var a=b&&b.tt;a&&(!a.isActive||c?b.tt=a.destroy():a.isActive=!1)})},applyFilter:function(){var c=this.chart;c.renderer.definition({tagName:"filter",id:"drop-shadow-"+c.index,
opacity:.5,children:[{tagName:"feGaussianBlur","in":"SourceAlpha",stdDeviation:1},{tagName:"feOffset",dx:1,dy:1},{tagName:"feComponentTransfer",children:[{tagName:"feFuncA",type:"linear",slope:.3}]},{tagName:"feMerge",children:[{tagName:"feMergeNode"},{tagName:"feMergeNode","in":"SourceGraphic"}]}]});c.renderer.definition({tagName:"style",textContent:".highcharts-tooltip-"+c.index+"{filter:url(#drop-shadow-"+c.index+")}"})},getLabel:function(){var g=this,b=this.chart.renderer,a=this.chart.styledMode,
d=this.options,e="tooltip"+(F(d.className)?" "+d.className:""),l;if(!this.label){this.outside&&(this.container=l=c.doc.createElement("div"),l.className="highcharts-tooltip-container",c.css(l,{position:"absolute",top:"1px",pointerEvents:d.style&&d.style.pointerEvents,zIndex:3}),c.doc.body.appendChild(l),this.renderer=b=new c.Renderer(l,0,0,{},void 0,void 0,b.styledMode));this.split?this.label=b.g(e):(this.label=b.label("",0,0,d.shape||"callout",null,null,d.useHTML,null,e).attr({padding:d.padding,r:d.borderRadius}),
a||this.label.attr({fill:d.backgroundColor,"stroke-width":d.borderWidth}).css(d.style).shadow(d.shadow));a&&(this.applyFilter(),this.label.addClass("highcharts-tooltip-"+this.chart.index));if(g.outside&&!g.split){var h={x:this.label.xSetter,y:this.label.ySetter};this.label.xSetter=function(a,b){h[b].call(this.label,g.distance);l.style.left=a+"px"};this.label.ySetter=function(a,b){h[b].call(this.label,g.distance);l.style.top=a+"px"}}this.label.attr({zIndex:8}).add()}return this.label},update:function(c){this.destroy();
n(!0,this.chart.options.tooltip.userOptions,c);this.init(this.chart,n(!0,this.options,c))},destroy:function(){this.label&&(this.label=this.label.destroy());this.split&&this.tt&&(this.cleanSplit(this.chart,!0),this.tt=this.tt.destroy());this.renderer&&(this.renderer=this.renderer.destroy(),G(this.container));c.clearTimeout(this.hideTimer);c.clearTimeout(this.tooltipTimeout)},move:function(g,b,a,d){var e=this,l=e.now,h=!1!==e.options.animation&&!e.isHidden&&(1<Math.abs(g-l.x)||1<Math.abs(b-l.y)),f=
e.followPointer||1<e.len;z(l,{x:h?(2*l.x+g)/3:g,y:h?(l.y+b)/2:b,anchorX:f?void 0:h?(2*l.anchorX+a)/3:a,anchorY:f?void 0:h?(l.anchorY+d)/2:d});e.getLabel().attr(l);h&&(c.clearTimeout(this.tooltipTimeout),this.tooltipTimeout=setTimeout(function(){e&&e.move(g,b,a,d)},32))},hide:function(g){var b=this;c.clearTimeout(this.hideTimer);g=v(g,this.options.hideDelay,500);this.isHidden||(this.hideTimer=H(function(){b.getLabel()[g?"fadeOut":"hide"]();b.isHidden=!0},g))},getAnchor:function(c,b){var a=this.chart,
d=a.pointer,e=a.inverted,l=a.plotTop,g=a.plotLeft,h=0,p=0,f,k;c=C(c);this.followPointer&&b?(void 0===b.chartX&&(b=d.normalize(b)),c=[b.chartX-a.plotLeft,b.chartY-l]):c[0].tooltipPos?c=c[0].tooltipPos:(c.forEach(function(a){f=a.series.yAxis;k=a.series.xAxis;h+=a.plotX+(!e&&k?k.left-g:0);p+=(a.plotLow?(a.plotLow+a.plotHigh)/2:a.plotY)+(!e&&f?f.top-l:0)}),h/=c.length,p/=c.length,c=[e?a.plotWidth-p:h,this.shared&&!e&&1<c.length&&b?b.chartY-l:e?a.plotHeight-h:p]);return c.map(Math.round)},getPosition:function(c,
b,a){var d=this.chart,e=this.distance,l={},g=d.inverted&&a.h||0,h,p=this.outside,f=p?y.documentElement.clientWidth-2*e:d.chartWidth,k=p?Math.max(y.body.scrollHeight,y.documentElement.scrollHeight,y.body.offsetHeight,y.documentElement.offsetHeight,y.documentElement.clientHeight):d.chartHeight,r=d.pointer.getChartPosition(),x=d.containerScaling,A=function(a){return x?a*x.scaleX:a},w=function(a){return x?a*x.scaleY:a},m=function(l){var m="x"===l;return[l,m?f:k,m?c:b].concat(p?[m?A(c):w(b),m?r.left-e+
A(a.plotX+d.plotLeft):r.top-e+w(a.plotY+d.plotTop),0,m?f:k]:[m?c:b,m?a.plotX+d.plotLeft:a.plotY+d.plotTop,m?d.plotLeft:d.plotTop,m?d.plotLeft+d.plotWidth:d.plotTop+d.plotHeight])},n=m("y"),J=m("x"),q=!this.followPointer&&v(a.ttBelow,!d.inverted===!!a.negative),t=function(a,b,d,c,k,m,r){var x="y"===a?w(e):A(e),p=(d-c)/2,h=c<k-e,f=k+e+c<b,u=k-x-d+p;k=k+x-p;if(q&&f)l[a]=k;else if(!q&&h)l[a]=u;else if(h)l[a]=Math.min(r-c,0>u-g?u:u-g);else if(f)l[a]=Math.max(m,k+g+d>b?k:k+g);else return!1},C=function(a,
b,d,k,c){var m;c<e||c>b-e?m=!1:l[a]=c<d/2?1:c>b-k/2?b-k-2:c-d/2;return m},O=function(a){var b=n;n=J;J=b;h=a},D=function(){!1!==t.apply(0,n)?!1!==C.apply(0,J)||h||(O(!0),D()):h?l.x=l.y=0:(O(!0),D())};(d.inverted||1<this.len)&&O();D();return l},defaultFormatter:function(c){var b=this.points||C(this);var a=[c.tooltipFooterHeaderFormatter(b[0])];a=a.concat(c.bodyFormatter(b));a.push(c.tooltipFooterHeaderFormatter(b[0],!0));return a},refresh:function(g,b){var a=this.chart,d=this.options,e=g,l={},h=[],
f=d.formatter||this.defaultFormatter;l=this.shared;var p=a.styledMode;if(d.enabled){c.clearTimeout(this.hideTimer);this.followPointer=C(e)[0].series.tooltipOptions.followPointer;var u=this.getAnchor(e,b);b=u[0];var k=u[1];!l||e.series&&e.series.noSharedTooltip?l=e.getLabelConfig():(a.pointer.applyInactiveState(e),e.forEach(function(a){a.setState("hover");h.push(a.getLabelConfig())}),l={x:e[0].category,y:e[0].y},l.points=h,e=e[0]);this.len=h.length;a=f.call(l,this);f=e.series;this.distance=v(f.tooltipOptions.distance,
16);!1===a?this.hide():(this.split?this.renderSplit(a,C(g)):(g=this.getLabel(),d.style.width&&!p||g.css({width:this.chart.spacingBox.width}),g.attr({text:a&&a.join?a.join(""):a}),g.removeClass(/highcharts-color-[\d]+/g).addClass("highcharts-color-"+v(e.colorIndex,f.colorIndex)),p||g.attr({stroke:d.borderColor||e.color||f.color||"#666666"}),this.updatePosition({plotX:b,plotY:k,negative:e.negative,ttBelow:e.ttBelow,h:u[2]||0})),this.isHidden&&this.label&&this.label.attr({opacity:1}).show(),this.isHidden=
!1);c.fireEvent(this,"refresh")}},renderSplit:function(g,b){var a=this,d=[],e=this.chart,l=e.renderer,h=!0,f=this.options,p=0,u,k=this.getLabel(),r=e.plotTop;t(g)&&(g=[!1,g]);g.slice(0,b.length+1).forEach(function(c,m){if(!1!==c&&""!==c){m=b[m-1]||{isHeader:!0,plotX:b[0].plotX,plotY:e.plotHeight};var g=m.series||a,x=g.tt,w=m.series||{},A="highcharts-color-"+v(m.colorIndex,w.colorIndex,"none");x||(x={padding:f.padding,r:f.borderRadius},e.styledMode||(x.fill=f.backgroundColor,x["stroke-width"]=f.borderWidth),
g.tt=x=l.label(null,null,null,(m.isHeader?f.headerShape:f.shape)||"callout",null,null,f.useHTML).addClass(m.isHeader?"highcharts-tooltip-header ":"highcharts-tooltip-box "+A).attr(x).add(k));x.isActive=!0;x.attr({text:c});e.styledMode||x.css(f.style).shadow(f.shadow).attr({stroke:f.borderColor||m.color||w.color||"#333333"});c=x.getBBox();A=c.width+x.strokeWidth();m.isHeader?(p=c.height,e.xAxis[0].opposite&&(u=!0,r-=p),c=Math.max(0,Math.min(m.plotX+e.plotLeft-A/2,e.chartWidth+(e.scrollablePixelsX?
e.scrollablePixelsX-e.marginRight:0)-A))):c=m.plotX+e.plotLeft-v(f.distance,16)-A;0>c&&(h=!1);m.isHeader?w=u?-p:e.plotHeight+p:(w=w.yAxis,w=w.pos-r+Math.max(0,Math.min(m.plotY||0,w.len)));d.push({target:w,rank:m.isHeader?1:0,size:g.tt.getBBox().height+1,point:m,x:c,tt:x})}});this.cleanSplit();f.positioner&&d.forEach(function(b){var d=f.positioner.call(a,b.tt.getBBox().width,b.size,b.point);b.x=d.x;b.align=0;b.target=d.y;b.rank=v(d.rank,b.rank)});c.distribute(d,e.plotHeight+p);d.forEach(function(b){var d=
b.point,c=d.series,k=c&&c.yAxis;b.tt.attr({visibility:void 0===b.pos?"hidden":"inherit",x:h||d.isHeader||f.positioner?b.x:d.plotX+e.plotLeft+a.distance,y:b.pos+r,anchorX:d.isHeader?d.plotX+e.plotLeft:d.plotX+c.xAxis.pos,anchorY:d.isHeader?e.plotTop+e.plotHeight/2:k.pos+Math.max(0,Math.min(d.plotY,k.len))})});var x=a.container;g=a.renderer;if(a.outside&&x&&g){var A=e.pointer.getChartPosition();x.style.left=A.left+"px";x.style.top=A.top+"px";x=k.getBBox();g.setSize(x.width+x.x,x.height+x.y,!1)}},updatePosition:function(g){var b=
this.chart,a=b.pointer,d=this.getLabel(),e=g.plotX+b.plotLeft,l=g.plotY+b.plotTop;a=a.getChartPosition();g=(this.options.positioner||this.getPosition).call(this,d.width,d.height,g);if(this.outside){var h=(this.options.borderWidth||0)+2*this.distance;this.renderer.setSize(d.width+h,d.height+h,!1);if(b=b.containerScaling)c.css(this.container,{transform:"scale("+b.scaleX+", "+b.scaleY+")"}),e*=b.scaleX,l*=b.scaleY;e+=a.left-g.x;l+=a.top-g.y}this.move(Math.round(g.x),Math.round(g.y||0),e,l)},getDateFormat:function(c,
b,a,d){var e=this.chart.time,l=e.dateFormat("%m-%d %H:%M:%S.%L",b),g={millisecond:15,second:12,minute:9,hour:6,day:3},h="millisecond";for(p in q){if(c===q.week&&+e.dateFormat("%w",b)===a&&"00:00:00.000"===l.substr(6)){var p="week";break}if(q[p]>c){p=h;break}if(g[p]&&l.substr(g[p])!=="01-01 00:00:00.000".substr(g[p]))break;"week"!==p&&(h=p)}if(p)var f=e.resolveDTLFormat(d[p]).main;return f},getXDateFormat:function(c,b,a){b=b.dateTimeLabelFormats;var d=a&&a.closestPointRange;return(d?this.getDateFormat(d,
c.x,a.options.startOfWeek,b):b.day)||b.year},tooltipFooterHeaderFormatter:function(g,b){var a=b?"footer":"header",d=g.series,e=d.tooltipOptions,l=e.xDateFormat,f=d.xAxis,n=f&&"datetime"===f.options.type&&B(g.key),p=e[a+"Format"];b={isFooter:b,labelConfig:g};c.fireEvent(this,"headerFormatter",b,function(a){n&&!l&&(l=this.getXDateFormat(g,e,f));n&&l&&(g.point&&g.point.tooltipDateKeys||["key"]).forEach(function(a){p=p.replace("{point."+a+"}","{point."+a+":"+l+"}")});d.chart.styledMode&&(p=this.styledModeFormat(p));
a.text=h(p,{point:g,series:d},this.chart.time)});return b.text},bodyFormatter:function(c){return c.map(function(b){var a=b.series.tooltipOptions;return(a[(b.point.formatPrefix||"point")+"Formatter"]||b.point.tooltipFormatter).call(b.point,a[(b.point.formatPrefix||"point")+"Format"]||"")})},styledModeFormat:function(c){return c.replace('style="font-size: 10px"','class="highcharts-header"').replace(/style="color:{(point|series)\.color}"/g,'class="highcharts-color-{$1.colorIndex}"')}}});M(I,"parts/Pointer.js",
[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.attr,G=f.defined,z=f.extend,B=f.isNumber,t=f.isObject,v=f.objectEach,C=f.pick,H=f.splat,y=c.addEvent,h=c.charts,n=c.color,q=c.css,g=c.find,b=c.fireEvent,a=c.offset,d=c.Tooltip;c.Pointer=function(a,b){this.init(a,b)};c.Pointer.prototype={init:function(a,b){this.options=b;this.chart=a;this.runChartClick=b.chart.events&&!!b.chart.events.click;this.pinchDown=[];this.lastValidTouch={};d&&(a.tooltip=new d(a,b.tooltip),this.followTouchMove=
C(b.tooltip.followTouchMove,!0));this.setDOMEvents()},zoomOption:function(a){var b=this.chart,d=b.options.chart,e=d.zoomType||"";b=b.inverted;/touch/.test(a.type)&&(e=C(d.pinchType,e));this.zoomX=a=/x/.test(e);this.zoomY=e=/y/.test(e);this.zoomHor=a&&!b||e&&b;this.zoomVert=e&&!b||a&&b;this.hasZoom=a||e},getChartPosition:function(){return this.chartPosition||(this.chartPosition=a(this.chart.container))},normalize:function(a,b){var d=a.touches?a.touches.length?a.touches.item(0):a.changedTouches[0]:
a;b||(b=this.getChartPosition());var e=d.pageX-b.left;b=d.pageY-b.top;if(d=this.chart.containerScaling)e/=d.scaleX,b/=d.scaleY;return z(a,{chartX:Math.round(e),chartY:Math.round(b)})},getCoordinates:function(a){var b={xAxis:[],yAxis:[]};this.chart.axes.forEach(function(d){b[d.isXAxis?"xAxis":"yAxis"].push({axis:d,value:d.toValue(a[d.horiz?"chartX":"chartY"])})});return b},findNearestKDPoint:function(a,b,d){var e;a.forEach(function(a){var c=!(a.noSharedTooltip&&b)&&0>a.options.findNearestPointBy.indexOf("y");
a=a.searchPoint(d,c);if((c=t(a,!0))&&!(c=!t(e,!0))){c=e.distX-a.distX;var k=e.dist-a.dist,l=(a.series.group&&a.series.group.zIndex)-(e.series.group&&e.series.group.zIndex);c=0<(0!==c&&b?c:0!==k?k:0!==l?l:e.series.index>a.series.index?-1:1)}c&&(e=a)});return e},getPointFromEvent:function(a){a=a.target;for(var b;a&&!b;)b=a.point,a=a.parentNode;return b},getChartCoordinatesFromPoint:function(a,b){var d=a.series,e=d.xAxis;d=d.yAxis;var c=C(a.clientX,a.plotX),l=a.shapeArgs;if(e&&d)return b?{chartX:e.len+
e.pos-c,chartY:d.len+d.pos-a.plotY}:{chartX:c+e.pos,chartY:a.plotY+d.pos};if(l&&l.x&&l.y)return{chartX:l.x,chartY:l.y}},getHoverData:function(a,b,d,c,h,f){var e,l=[];c=!(!c||!a);var x=b&&!b.stickyTracking?[b]:d.filter(function(a){return a.visible&&!(!h&&a.directTouch)&&C(a.options.enableMouseTracking,!0)&&a.stickyTracking});b=(e=c||!f?a:this.findNearestKDPoint(x,h,f))&&e.series;e&&(h&&!b.noSharedTooltip?(x=d.filter(function(a){return a.visible&&!(!h&&a.directTouch)&&C(a.options.enableMouseTracking,
!0)&&!a.noSharedTooltip}),x.forEach(function(a){var b=g(a.points,function(a){return a.x===e.x&&!a.isNull});t(b)&&(a.chart.isBoosting&&(b=a.getPoint(b)),l.push(b))})):l.push(e));return{hoverPoint:e,hoverSeries:b,hoverPoints:l}},runPointActions:function(a,b){var d=this.chart,e=d.tooltip&&d.tooltip.options.enabled?d.tooltip:void 0,l=e?e.shared:!1,g=b||d.hoverPoint,k=g&&g.series||d.hoverSeries;k=this.getHoverData(g,k,d.series,(!a||"touchmove"!==a.type)&&(!!b||k&&k.directTouch&&this.isDirectTouch),l,a);
g=k.hoverPoint;var r=k.hoverPoints;b=(k=k.hoverSeries)&&k.tooltipOptions.followPointer;l=l&&k&&!k.noSharedTooltip;if(g&&(g!==d.hoverPoint||e&&e.isHidden)){(d.hoverPoints||[]).forEach(function(a){-1===r.indexOf(a)&&a.setState()});if(d.hoverSeries!==k)k.onMouseOver();this.applyInactiveState(r);(r||[]).forEach(function(a){a.setState("hover")});d.hoverPoint&&d.hoverPoint.firePointEvent("mouseOut");if(!g.series)return;g.firePointEvent("mouseOver");d.hoverPoints=r;d.hoverPoint=g;e&&e.refresh(l?r:g,a)}else b&&
e&&!e.isHidden&&(g=e.getAnchor([{}],a),e.updatePosition({plotX:g[0],plotY:g[1]}));this.unDocMouseMove||(this.unDocMouseMove=y(d.container.ownerDocument,"mousemove",function(a){var b=h[c.hoverChartIndex];if(b)b.pointer.onDocumentMouseMove(a)}));d.axes.forEach(function(b){var d=C(b.crosshair.snap,!0),e=d?c.find(r,function(a){return a.series[b.coll]===b}):void 0;e||!d?b.drawCrosshair(a,e):b.hideCrosshair()})},applyInactiveState:function(a){var b=[],d;(a||[]).forEach(function(a){d=a.series;b.push(d);
d.linkedParent&&b.push(d.linkedParent);d.linkedSeries&&(b=b.concat(d.linkedSeries));d.navigatorSeries&&b.push(d.navigatorSeries)});this.chart.series.forEach(function(a){-1===b.indexOf(a)?a.setState("inactive",!0):a.options.inactiveOtherPoints&&a.setAllPointsToState("inactive")})},reset:function(a,b){var d=this.chart,e=d.hoverSeries,c=d.hoverPoint,g=d.hoverPoints,k=d.tooltip,l=k&&k.shared?g:c;a&&l&&H(l).forEach(function(b){b.series.isCartesian&&void 0===b.plotX&&(a=!1)});if(a)k&&l&&H(l).length&&(k.refresh(l),
k.shared&&g?g.forEach(function(a){a.setState(a.state,!0);a.series.isCartesian&&(a.series.xAxis.crosshair&&a.series.xAxis.drawCrosshair(null,a),a.series.yAxis.crosshair&&a.series.yAxis.drawCrosshair(null,a))}):c&&(c.setState(c.state,!0),d.axes.forEach(function(a){a.crosshair&&a.drawCrosshair(null,c)})));else{if(c)c.onMouseOut();g&&g.forEach(function(a){a.setState()});if(e)e.onMouseOut();k&&k.hide(b);this.unDocMouseMove&&(this.unDocMouseMove=this.unDocMouseMove());d.axes.forEach(function(a){a.hideCrosshair()});
this.hoverX=d.hoverPoints=d.hoverPoint=null}},scaleGroups:function(a,b){var d=this.chart,e;d.series.forEach(function(c){e=a||c.getPlotBox();c.xAxis&&c.xAxis.zoomEnabled&&c.group&&(c.group.attr(e),c.markerGroup&&(c.markerGroup.attr(e),c.markerGroup.clip(b?d.clipRect:null)),c.dataLabelsGroup&&c.dataLabelsGroup.attr(e))});d.clipRect.attr(b||d.clipBox)},dragStart:function(a){var b=this.chart;b.mouseIsDown=a.type;b.cancelClick=!1;b.mouseDownX=this.mouseDownX=a.chartX;b.mouseDownY=this.mouseDownY=a.chartY},
drag:function(a){var b=this.chart,d=b.options.chart,e=a.chartX,c=a.chartY,g=this.zoomHor,k=this.zoomVert,r=b.plotLeft,h=b.plotTop,A=b.plotWidth,w=b.plotHeight,m=this.selectionMarker,f=this.mouseDownX,J=this.mouseDownY,v=d.panKey&&a[d.panKey+"Key"];if(!m||!m.touch)if(e<r?e=r:e>r+A&&(e=r+A),c<h?c=h:c>h+w&&(c=h+w),this.hasDragged=Math.sqrt(Math.pow(f-e,2)+Math.pow(J-c,2)),10<this.hasDragged){var q=b.isInsidePlot(f-r,J-h);b.hasCartesianSeries&&(this.zoomX||this.zoomY)&&q&&!v&&!m&&(this.selectionMarker=
m=b.renderer.rect(r,h,g?1:A,k?1:w,0).attr({"class":"highcharts-selection-marker",zIndex:7}).add(),b.styledMode||m.attr({fill:d.selectionMarkerFill||n("#335cad").setOpacity(.25).get()}));m&&g&&(e-=f,m.attr({width:Math.abs(e),x:(0<e?0:e)+f}));m&&k&&(e=c-J,m.attr({height:Math.abs(e),y:(0<e?0:e)+J}));q&&!m&&d.panning&&b.pan(a,d.panning)}},drop:function(a){var d=this,e=this.chart,c=this.hasPinched;if(this.selectionMarker){var g={originalEvent:a,xAxis:[],yAxis:[]},h=this.selectionMarker,k=h.attr?h.attr("x"):
h.x,r=h.attr?h.attr("y"):h.y,x=h.attr?h.attr("width"):h.width,A=h.attr?h.attr("height"):h.height,w;if(this.hasDragged||c)e.axes.forEach(function(b){if(b.zoomEnabled&&G(b.min)&&(c||d[{xAxis:"zoomX",yAxis:"zoomY"}[b.coll]])){var e=b.horiz,m="touchend"===a.type?b.minPixelPadding:0,l=b.toValue((e?k:r)+m);e=b.toValue((e?k+x:r+A)-m);g[b.coll].push({axis:b,min:Math.min(l,e),max:Math.max(l,e)});w=!0}}),w&&b(e,"selection",g,function(a){e.zoom(z(a,c?{animation:!1}:null))});B(e.index)&&(this.selectionMarker=
this.selectionMarker.destroy());c&&this.scaleGroups()}e&&B(e.index)&&(q(e.container,{cursor:e._cursor}),e.cancelClick=10<this.hasDragged,e.mouseIsDown=this.hasDragged=this.hasPinched=!1,this.pinchDown=[])},onContainerMouseDown:function(a){a=this.normalize(a);2!==a.button&&(this.zoomOption(a),a.preventDefault&&a.preventDefault(),this.dragStart(a))},onDocumentMouseUp:function(a){h[c.hoverChartIndex]&&h[c.hoverChartIndex].pointer.drop(a)},onDocumentMouseMove:function(a){var b=this.chart,d=this.chartPosition;
a=this.normalize(a,d);!d||this.inClass(a.target,"highcharts-tracker")||b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop)||this.reset()},onContainerMouseLeave:function(a){var b=h[c.hoverChartIndex];b&&(a.relatedTarget||a.toElement)&&(b.pointer.reset(),b.pointer.chartPosition=void 0)},onContainerMouseMove:function(a){var b=this.chart;G(c.hoverChartIndex)&&h[c.hoverChartIndex]&&h[c.hoverChartIndex].mouseIsDown||(c.hoverChartIndex=b.index);a=this.normalize(a);a.preventDefault||(a.returnValue=!1);
"mousedown"===b.mouseIsDown&&this.drag(a);!this.inClass(a.target,"highcharts-tracker")&&!b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop)||b.openMenu||this.runPointActions(a)},inClass:function(a,b){for(var d;a;){if(d=F(a,"class")){if(-1!==d.indexOf(b))return!0;if(-1!==d.indexOf("highcharts-container"))return!1}a=a.parentNode}},onTrackerMouseOut:function(a){var b=this.chart.hoverSeries;a=a.relatedTarget||a.toElement;this.isDirectTouch=!1;if(!(!b||!a||b.stickyTracking||this.inClass(a,"highcharts-tooltip")||
this.inClass(a,"highcharts-series-"+b.index)&&this.inClass(a,"highcharts-tracker")))b.onMouseOut()},onContainerClick:function(a){var d=this.chart,e=d.hoverPoint,c=d.plotLeft,g=d.plotTop;a=this.normalize(a);d.cancelClick||(e&&this.inClass(a.target,"highcharts-tracker")?(b(e.series,"click",z(a,{point:e})),d.hoverPoint&&e.firePointEvent("click",a)):(z(a,this.getCoordinates(a)),d.isInsidePlot(a.chartX-c,a.chartY-g)&&b(d,"click",a)))},setDOMEvents:function(){var a=this,b=a.chart.container,d=b.ownerDocument;
b.onmousedown=function(b){a.onContainerMouseDown(b)};b.onmousemove=function(b){a.onContainerMouseMove(b)};b.onclick=function(b){a.onContainerClick(b)};this.unbindContainerMouseLeave=y(b,"mouseleave",a.onContainerMouseLeave);c.unbindDocumentMouseUp||(c.unbindDocumentMouseUp=y(d,"mouseup",a.onDocumentMouseUp));c.hasTouch&&(y(b,"touchstart",function(b){a.onContainerTouchStart(b)}),y(b,"touchmove",function(b){a.onContainerTouchMove(b)}),c.unbindDocumentTouchEnd||(c.unbindDocumentTouchEnd=y(d,"touchend",
a.onDocumentTouchEnd)))},destroy:function(){var a=this;a.unDocMouseMove&&a.unDocMouseMove();this.unbindContainerMouseLeave();c.chartCount||(c.unbindDocumentMouseUp&&(c.unbindDocumentMouseUp=c.unbindDocumentMouseUp()),c.unbindDocumentTouchEnd&&(c.unbindDocumentTouchEnd=c.unbindDocumentTouchEnd()));clearInterval(a.tooltipTimeout);v(a,function(b,d){a[d]=null})}}});M(I,"parts/TouchPointer.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.extend,G=f.pick,z=c.charts,B=c.noop;F(c.Pointer.prototype,
{pinchTranslate:function(c,f,C,B,y,h){this.zoomHor&&this.pinchTranslateDirection(!0,c,f,C,B,y,h);this.zoomVert&&this.pinchTranslateDirection(!1,c,f,C,B,y,h)},pinchTranslateDirection:function(c,f,C,B,y,h,n,q){var g=this.chart,b=c?"x":"y",a=c?"X":"Y",d="chart"+a,e=c?"width":"height",l=g["plot"+(c?"Left":"Top")],v,t,p=q||1,u=g.inverted,k=g.bounds[c?"h":"v"],r=1===f.length,x=f[0][d],A=C[0][d],w=!r&&f[1][d],m=!r&&C[1][d];C=function(){!r&&20<Math.abs(x-w)&&(p=q||Math.abs(A-m)/Math.abs(x-w));t=(l-A)/p+x;
v=g["plot"+(c?"Width":"Height")]/p};C();f=t;if(f<k.min){f=k.min;var K=!0}else f+v>k.max&&(f=k.max-v,K=!0);K?(A-=.8*(A-n[b][0]),r||(m-=.8*(m-n[b][1])),C()):n[b]=[A,m];u||(h[b]=t-l,h[e]=v);h=u?1/p:p;y[e]=v;y[b]=f;B[u?c?"scaleY":"scaleX":"scale"+a]=p;B["translate"+a]=h*l+(A-h*x)},pinch:function(c){var f=this,t=f.chart,z=f.pinchDown,y=c.touches,h=y.length,n=f.lastValidTouch,q=f.hasZoom,g=f.selectionMarker,b={},a=1===h&&(f.inClass(c.target,"highcharts-tracker")&&t.runTrackerClick||f.runChartClick),d={};
1<h&&(f.initiated=!0);q&&f.initiated&&!a&&c.preventDefault();[].map.call(y,function(a){return f.normalize(a)});"touchstart"===c.type?([].forEach.call(y,function(a,b){z[b]={chartX:a.chartX,chartY:a.chartY}}),n.x=[z[0].chartX,z[1]&&z[1].chartX],n.y=[z[0].chartY,z[1]&&z[1].chartY],t.axes.forEach(function(a){if(a.zoomEnabled){var b=t.bounds[a.horiz?"h":"v"],d=a.minPixelPadding,e=a.toPixels(Math.min(G(a.options.min,a.dataMin),a.dataMin)),c=a.toPixels(Math.max(G(a.options.max,a.dataMax),a.dataMax)),g=Math.max(e,
c);b.min=Math.min(a.pos,Math.min(e,c)-d);b.max=Math.max(a.pos+a.len,g+d)}}),f.res=!0):f.followTouchMove&&1===h?this.runPointActions(f.normalize(c)):z.length&&(g||(f.selectionMarker=g=F({destroy:B,touch:!0},t.plotBox)),f.pinchTranslate(z,y,b,g,d,n),f.hasPinched=q,f.scaleGroups(b,d),f.res&&(f.res=!1,this.reset(!1,0)))},touch:function(f,v){var t=this.chart,z;if(t.index!==c.hoverChartIndex)this.onContainerMouseLeave({relatedTarget:!0});c.hoverChartIndex=t.index;if(1===f.touches.length)if(f=this.normalize(f),
(z=t.isInsidePlot(f.chartX-t.plotLeft,f.chartY-t.plotTop))&&!t.openMenu){v&&this.runPointActions(f);if("touchmove"===f.type){v=this.pinchDown;var y=v[0]?4<=Math.sqrt(Math.pow(v[0].chartX-f.chartX,2)+Math.pow(v[0].chartY-f.chartY,2)):!1}G(y,!0)&&this.pinch(f)}else v&&this.reset();else 2===f.touches.length&&this.pinch(f)},onContainerTouchStart:function(c){this.zoomOption(c);this.touch(c,!0)},onContainerTouchMove:function(c){this.touch(c)},onDocumentTouchEnd:function(f){z[c.hoverChartIndex]&&z[c.hoverChartIndex].pointer.drop(f)}})});
M(I,"parts/MSPointer.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.extend,G=f.objectEach,z=c.addEvent,B=c.charts,t=c.css,v=c.doc,C=c.noop;f=c.Pointer;var H=c.removeEvent,y=c.win,h=c.wrap;if(!c.hasTouch&&(y.PointerEvent||y.MSPointerEvent)){var n={},q=!!y.PointerEvent,g=function(){var a=[];a.item=function(a){return this[a]};G(n,function(b){a.push({pageX:b.pageX,pageY:b.pageY,target:b.target})});return a},b=function(a,b,e,l){"touch"!==a.pointerType&&a.pointerType!==a.MSPOINTER_TYPE_TOUCH||
!B[c.hoverChartIndex]||(l(a),l=B[c.hoverChartIndex].pointer,l[b]({type:e,target:a.currentTarget,preventDefault:C,touches:g()}))};F(f.prototype,{onContainerPointerDown:function(a){b(a,"onContainerTouchStart","touchstart",function(a){n[a.pointerId]={pageX:a.pageX,pageY:a.pageY,target:a.currentTarget}})},onContainerPointerMove:function(a){b(a,"onContainerTouchMove","touchmove",function(a){n[a.pointerId]={pageX:a.pageX,pageY:a.pageY};n[a.pointerId].target||(n[a.pointerId].target=a.currentTarget)})},onDocumentPointerUp:function(a){b(a,
"onDocumentTouchEnd","touchend",function(a){delete n[a.pointerId]})},batchMSEvents:function(a){a(this.chart.container,q?"pointerdown":"MSPointerDown",this.onContainerPointerDown);a(this.chart.container,q?"pointermove":"MSPointerMove",this.onContainerPointerMove);a(v,q?"pointerup":"MSPointerUp",this.onDocumentPointerUp)}});h(f.prototype,"init",function(a,b,e){a.call(this,b,e);this.hasZoom&&t(b.container,{"-ms-touch-action":"none","touch-action":"none"})});h(f.prototype,"setDOMEvents",function(a){a.apply(this);
(this.hasZoom||this.followTouchMove)&&this.batchMSEvents(z)});h(f.prototype,"destroy",function(a){this.batchMSEvents(H);a.call(this)})}});M(I,"parts/Legend.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.defined,G=f.discardElement,z=f.isNumber,B=f.pick,t=f.setAnimation,v=c.addEvent,C=c.css,H=c.fireEvent;f=c.isFirefox;var y=c.marginNames,h=c.merge,n=c.stableSort,q=c.win,g=c.wrap;c.Legend=function(b,a){this.init(b,a)};c.Legend.prototype={init:function(b,a){this.chart=b;this.setOptions(a);
a.enabled&&(this.render(),v(this.chart,"endResize",function(){this.legend.positionCheckboxes()}),this.proximate?this.unchartrender=v(this.chart,"render",function(){this.legend.proximatePositions();this.legend.positionItems()}):this.unchartrender&&this.unchartrender())},setOptions:function(b){var a=B(b.padding,8);this.options=b;this.chart.styledMode||(this.itemStyle=b.itemStyle,this.itemHiddenStyle=h(this.itemStyle,b.itemHiddenStyle));this.itemMarginTop=b.itemMarginTop||0;this.itemMarginBottom=b.itemMarginBottom||
0;this.padding=a;this.initialItemY=a-5;this.symbolWidth=B(b.symbolWidth,16);this.pages=[];this.proximate="proximate"===b.layout&&!this.chart.inverted},update:function(b,a){var d=this.chart;this.setOptions(h(!0,this.options,b));this.destroy();d.isDirtyLegend=d.isDirtyBox=!0;B(a,!0)&&d.redraw();H(this,"afterUpdate")},colorizeItem:function(b,a){b.legendGroup[a?"removeClass":"addClass"]("highcharts-legend-item-hidden");if(!this.chart.styledMode){var d=this.options,e=b.legendItem,c=b.legendLine,g=b.legendSymbol,
h=this.itemHiddenStyle.color;d=a?d.itemStyle.color:h;var f=a?b.color||h:h,u=b.options&&b.options.marker,k={fill:f};e&&e.css({fill:d,color:d});c&&c.attr({stroke:f});g&&(u&&g.isMarker&&(k=b.pointAttribs(),a||(k.stroke=k.fill=h)),g.attr(k))}H(this,"afterColorizeItem",{item:b,visible:a})},positionItems:function(){this.allItems.forEach(this.positionItem,this);this.chart.isResizing||this.positionCheckboxes()},positionItem:function(b){var a=this.options,d=a.symbolPadding;a=!a.rtl;var e=b._legendItemPos,
c=e[0];e=e[1];var g=b.checkbox;if((b=b.legendGroup)&&b.element)b[F(b.translateY)?"animate":"attr"]({translateX:a?c:this.legendWidth-c-2*d-4,translateY:e});g&&(g.x=c,g.y=e)},destroyItem:function(b){var a=b.checkbox;["legendItem","legendLine","legendSymbol","legendGroup"].forEach(function(a){b[a]&&(b[a]=b[a].destroy())});a&&G(b.checkbox)},destroy:function(){function b(a){this[a]&&(this[a]=this[a].destroy())}this.getAllItems().forEach(function(a){["legendItem","legendGroup"].forEach(b,a)});"clipRect up down pager nav box title group".split(" ").forEach(b,
this);this.display=null},positionCheckboxes:function(){var b=this.group&&this.group.alignAttr,a=this.clipHeight||this.legendHeight,d=this.titleHeight;if(b){var e=b.translateY;this.allItems.forEach(function(c){var g=c.checkbox;if(g){var l=e+d+g.y+(this.scrollOffset||0)+3;C(g,{left:b.translateX+c.checkboxOffset+g.x-20+"px",top:l+"px",display:this.proximate||l>e-6&&l<e+a-6?"":"none"})}},this)}},renderTitle:function(){var b=this.options,a=this.padding,d=b.title,e=0;d.text&&(this.title||(this.title=this.chart.renderer.label(d.text,
a-3,a-4,null,null,null,b.useHTML,null,"legend-title").attr({zIndex:1}),this.chart.styledMode||this.title.css(d.style),this.title.add(this.group)),d.width||this.title.css({width:this.maxLegendWidth+"px"}),b=this.title.getBBox(),e=b.height,this.offsetWidth=b.width,this.contentGroup.attr({translateY:e}));this.titleHeight=e},setText:function(b){var a=this.options;b.legendItem.attr({text:a.labelFormat?c.format(a.labelFormat,b,this.chart.time):a.labelFormatter.call(b)})},renderItem:function(b){var a=this.chart,
d=a.renderer,e=this.options,c=this.symbolWidth,g=e.symbolPadding,f=this.itemStyle,p=this.itemHiddenStyle,u="horizontal"===e.layout?B(e.itemDistance,20):0,k=!e.rtl,r=b.legendItem,x=!b.series,A=!x&&b.series.drawLegendSymbol?b.series:b,w=A.options;w=this.createCheckboxForItem&&w&&w.showCheckbox;u=c+g+u+(w?20:0);var m=e.useHTML,n=b.options.className;r||(b.legendGroup=d.g("legend-item").addClass("highcharts-"+A.type+"-series highcharts-color-"+b.colorIndex+(n?" "+n:"")+(x?" highcharts-series-"+b.index:
"")).attr({zIndex:1}).add(this.scrollGroup),b.legendItem=r=d.text("",k?c+g:-g,this.baseline||0,m),a.styledMode||r.css(h(b.visible?f:p)),r.attr({align:k?"left":"right",zIndex:2}).add(b.legendGroup),this.baseline||(this.fontMetrics=d.fontMetrics(a.styledMode?12:f.fontSize,r),this.baseline=this.fontMetrics.f+3+this.itemMarginTop,r.attr("y",this.baseline)),this.symbolHeight=e.symbolHeight||this.fontMetrics.f,A.drawLegendSymbol(this,b),this.setItemEvents&&this.setItemEvents(b,r,m));w&&!b.checkbox&&this.createCheckboxForItem(b);
this.colorizeItem(b,b.visible);!a.styledMode&&f.width||r.css({width:(e.itemWidth||this.widthOption||a.spacingBox.width)-u});this.setText(b);a=r.getBBox();b.itemWidth=b.checkboxOffset=e.itemWidth||b.legendItemWidth||a.width+u;this.maxItemWidth=Math.max(this.maxItemWidth,b.itemWidth);this.totalItemWidth+=b.itemWidth;this.itemHeight=b.itemHeight=Math.round(b.legendItemHeight||a.height||this.symbolHeight)},layoutItem:function(b){var a=this.options,d=this.padding,e="horizontal"===a.layout,c=b.itemHeight,
g=this.itemMarginBottom,h=this.itemMarginTop,f=e?B(a.itemDistance,20):0,u=this.maxLegendWidth;a=a.alignColumns&&this.totalItemWidth>u?this.maxItemWidth:b.itemWidth;e&&this.itemX-d+a>u&&(this.itemX=d,this.lastLineHeight&&(this.itemY+=h+this.lastLineHeight+g),this.lastLineHeight=0);this.lastItemY=h+this.itemY+g;this.lastLineHeight=Math.max(c,this.lastLineHeight);b._legendItemPos=[this.itemX,this.itemY];e?this.itemX+=a:(this.itemY+=h+c+g,this.lastLineHeight=c);this.offsetWidth=this.widthOption||Math.max((e?
this.itemX-d-(b.checkbox?0:f):a)+d,this.offsetWidth)},getAllItems:function(){var b=[];this.chart.series.forEach(function(a){var d=a&&a.options;a&&B(d.showInLegend,F(d.linkedTo)?!1:void 0,!0)&&(b=b.concat(a.legendItems||("point"===d.legendType?a.data:a)))});H(this,"afterGetAllItems",{allItems:b});return b},getAlignment:function(){var b=this.options;return this.proximate?b.align.charAt(0)+"tv":b.floating?"":b.align.charAt(0)+b.verticalAlign.charAt(0)+b.layout.charAt(0)},adjustMargins:function(b,a){var d=
this.chart,e=this.options,c=this.getAlignment();c&&[/(lth|ct|rth)/,/(rtv|rm|rbv)/,/(rbh|cb|lbh)/,/(lbv|lm|ltv)/].forEach(function(g,l){g.test(c)&&!F(b[l])&&(d[y[l]]=Math.max(d[y[l]],d.legend[(l+1)%2?"legendHeight":"legendWidth"]+[1,-1,-1,1][l]*e[l%2?"x":"y"]+B(e.margin,12)+a[l]+(d.titleOffset[l]||0)))})},proximatePositions:function(){var b=this.chart,a=[],d="left"===this.options.align;this.allItems.forEach(function(e){var g=d;if(e.yAxis&&e.points){e.xAxis.options.reversed&&(g=!g);var h=c.find(g?e.points:
e.points.slice(0).reverse(),function(a){return z(a.plotY)});g=this.itemMarginTop+e.legendItem.getBBox().height+this.itemMarginBottom;var f=e.yAxis.top-b.plotTop;e.visible?(h=h?h.plotY:e.yAxis.height,h+=f-.3*g):h=f+e.yAxis.height;a.push({target:h,size:g,item:e})}},this);c.distribute(a,b.plotHeight);a.forEach(function(a){a.item._legendItemPos[1]=b.plotTop-b.spacing[0]+a.pos})},render:function(){var b=this.chart,a=b.renderer,d=this.group,e,g=this.box,f=this.options,q=this.padding;this.itemX=q;this.itemY=
this.initialItemY;this.lastItemY=this.offsetWidth=0;this.widthOption=c.relativeLength(f.width,b.spacingBox.width-q);var p=b.spacingBox.width-2*q-f.x;-1<["rm","lm"].indexOf(this.getAlignment().substring(0,2))&&(p/=2);this.maxLegendWidth=this.widthOption||p;d||(this.group=d=a.g("legend").attr({zIndex:7}).add(),this.contentGroup=a.g().attr({zIndex:1}).add(d),this.scrollGroup=a.g().add(this.contentGroup));this.renderTitle();p=this.getAllItems();n(p,function(a,b){return(a.options&&a.options.legendIndex||
0)-(b.options&&b.options.legendIndex||0)});f.reversed&&p.reverse();this.allItems=p;this.display=e=!!p.length;this.itemHeight=this.totalItemWidth=this.maxItemWidth=this.lastLineHeight=0;p.forEach(this.renderItem,this);p.forEach(this.layoutItem,this);p=(this.widthOption||this.offsetWidth)+q;var u=this.lastItemY+this.lastLineHeight+this.titleHeight;u=this.handleOverflow(u);u+=q;g||(this.box=g=a.rect().addClass("highcharts-legend-box").attr({r:f.borderRadius}).add(d),g.isNew=!0);b.styledMode||g.attr({stroke:f.borderColor,
"stroke-width":f.borderWidth||0,fill:f.backgroundColor||"none"}).shadow(f.shadow);0<p&&0<u&&(g[g.isNew?"attr":"animate"](g.crisp.call({},{x:0,y:0,width:p,height:u},g.strokeWidth())),g.isNew=!1);g[e?"show":"hide"]();b.styledMode&&"none"===d.getStyle("display")&&(p=u=0);this.legendWidth=p;this.legendHeight=u;e&&(a=b.spacingBox,g=a.y,/(lth|ct|rth)/.test(this.getAlignment())&&0<b.titleOffset[0]?g+=b.titleOffset[0]:/(lbh|cb|rbh)/.test(this.getAlignment())&&0<b.titleOffset[2]&&(g-=b.titleOffset[2]),g!==
a.y&&(a=h(a,{y:g})),d.align(h(f,{width:p,height:u,verticalAlign:this.proximate?"top":f.verticalAlign}),!0,a));this.proximate||this.positionItems();H(this,"afterRender")},handleOverflow:function(b){var a=this,d=this.chart,e=d.renderer,c=this.options,g=c.y,h=this.padding;g=d.spacingBox.height+("top"===c.verticalAlign?-g:g)-h;var f=c.maxHeight,u,k=this.clipRect,r=c.navigation,x=B(r.animation,!0),A=r.arrowSize||12,w=this.nav,m=this.pages,n,J=this.allItems,q=function(b){"number"===typeof b?k.attr({height:b}):
k&&(a.clipRect=k.destroy(),a.contentGroup.clip());a.contentGroup.div&&(a.contentGroup.div.style.clip=b?"rect("+h+"px,9999px,"+(h+b)+"px,0)":"auto")},v=function(b){a[b]=e.circle(0,0,1.3*A).translate(A/2,A/2).add(w);d.styledMode||a[b].attr("fill","rgba(0,0,0,0.0001)");return a[b]};"horizontal"!==c.layout||"middle"===c.verticalAlign||c.floating||(g/=2);f&&(g=Math.min(g,f));m.length=0;b>g&&!1!==r.enabled?(this.clipHeight=u=Math.max(g-20-this.titleHeight-h,0),this.currentPage=B(this.currentPage,1),this.fullHeight=
b,J.forEach(function(a,b){var d=a._legendItemPos[1],e=Math.round(a.legendItem.getBBox().height),c=m.length;if(!c||d-m[c-1]>u&&(n||d)!==m[c-1])m.push(n||d),c++;a.pageIx=c-1;n&&(J[b-1].pageIx=c-1);b===J.length-1&&d+e-m[c-1]>u&&d!==n&&(m.push(d),a.pageIx=c);d!==n&&(n=d)}),k||(k=a.clipRect=e.clipRect(0,h,9999,0),a.contentGroup.clip(k)),q(u),w||(this.nav=w=e.g().attr({zIndex:1}).add(this.group),this.up=e.symbol("triangle",0,0,A,A).add(w),v("upTracker").on("click",function(){a.scroll(-1,x)}),this.pager=
e.text("",15,10).addClass("highcharts-legend-navigation"),d.styledMode||this.pager.css(r.style),this.pager.add(w),this.down=e.symbol("triangle-down",0,0,A,A).add(w),v("downTracker").on("click",function(){a.scroll(1,x)})),a.scroll(0),b=g):w&&(q(),this.nav=w.destroy(),this.scrollGroup.attr({translateY:1}),this.clipHeight=0);return b},scroll:function(b,a){var d=this.pages,e=d.length,c=this.currentPage+b;b=this.clipHeight;var g=this.options.navigation,h=this.pager,f=this.padding;c>e&&(c=e);0<c&&(void 0!==
a&&t(a,this.chart),this.nav.attr({translateX:f,translateY:b+this.padding+7+this.titleHeight,visibility:"visible"}),[this.up,this.upTracker].forEach(function(a){a.attr({"class":1===c?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"})}),h.attr({text:c+"/"+e}),[this.down,this.downTracker].forEach(function(a){a.attr({x:18+this.pager.getBBox().width,"class":c===e?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"})},this),this.chart.styledMode||(this.up.attr({fill:1===c?g.inactiveColor:
g.activeColor}),this.upTracker.css({cursor:1===c?"default":"pointer"}),this.down.attr({fill:c===e?g.inactiveColor:g.activeColor}),this.downTracker.css({cursor:c===e?"default":"pointer"})),this.scrollOffset=-d[c-1]+this.initialItemY,this.scrollGroup.animate({translateY:this.scrollOffset}),this.currentPage=c,this.positionCheckboxes())}};c.LegendSymbolMixin={drawRectangle:function(b,a){var d=b.symbolHeight,e=b.options.squareSymbol;a.legendSymbol=this.chart.renderer.rect(e?(b.symbolWidth-d)/2:0,b.baseline-
d+1,e?d:b.symbolWidth,d,B(b.options.symbolRadius,d/2)).addClass("highcharts-point").attr({zIndex:3}).add(a.legendGroup)},drawLineMarker:function(b){var a=this.options,d=a.marker,e=b.symbolWidth,c=b.symbolHeight,g=c/2,f=this.chart.renderer,p=this.legendGroup;b=b.baseline-Math.round(.3*b.fontMetrics.b);var u={};this.chart.styledMode||(u={"stroke-width":a.lineWidth||0},a.dashStyle&&(u.dashstyle=a.dashStyle));this.legendLine=f.path(["M",0,b,"L",e,b]).addClass("highcharts-graph").attr(u).add(p);d&&!1!==
d.enabled&&e&&(a=Math.min(B(d.radius,g),g),0===this.symbol.indexOf("url")&&(d=h(d,{width:c,height:c}),a=0),this.legendSymbol=d=f.symbol(this.symbol,e/2-a,b-a,2*a,2*a,d).addClass("highcharts-point").add(p),d.isMarker=!0)}};(/Trident\/7\.0/.test(q.navigator&&q.navigator.userAgent)||f)&&g(c.Legend.prototype,"positionItem",function(b,a){var d=this,e=function(){a._legendItemPos&&b.call(d,a)};e();d.bubbleLegend||setTimeout(e)})});M(I,"parts/Chart.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,
f){var F=f.attr,G=f.defined,z=f.discardElement,B=f.erase,t=f.extend,v=f.isArray,C=f.isNumber,H=f.isObject,y=f.isString,h=f.objectEach,n=f.pick,q=f.pInt,g=f.setAnimation,b=f.splat,a=f.syncTimeout,d=c.addEvent,e=c.animate,l=c.animObject,L=c.doc,E=c.Axis,p=c.createElement,u=c.defaultOptions,k=c.charts,r=c.css,x=c.find,A=c.fireEvent,w=c.Legend,m=c.marginNames,K=c.merge,J=c.Pointer,U=c.removeEvent,S=c.seriesTypes,Q=c.win,O=c.Chart=function(){this.getArgs.apply(this,arguments)};c.chart=function(a,b,d){return new O(a,
b,d)};t(O.prototype,{callbacks:[],getArgs:function(){var a=[].slice.call(arguments);if(y(a[0])||a[0].nodeName)this.renderTo=a.shift();this.init(a[0],a[1])},init:function(a,b){var e,g=a.series,m=a.plotOptions||{};A(this,"init",{args:arguments},function(){a.series=null;e=K(u,a);h(e.plotOptions,function(a,b){H(a)&&(a.tooltip=m[b]&&K(m[b].tooltip)||void 0)});e.tooltip.userOptions=a.chart&&a.chart.forExport&&a.tooltip.userOptions||a.tooltip;e.series=a.series=g;this.userOptions=a;var r=e.chart,l=r.events;
this.margin=[];this.spacing=[];this.bounds={h:{},v:{}};this.labelCollectors=[];this.callback=b;this.isResizing=0;this.options=e;this.axes=[];this.series=[];this.time=a.time&&Object.keys(a.time).length?new c.Time(a.time):c.time;this.styledMode=r.styledMode;this.hasCartesianSeries=r.showAxes;var f=this;f.index=k.length;k.push(f);c.chartCount++;l&&h(l,function(a,b){c.isFunction(a)&&d(f,b,a)});f.xAxis=[];f.yAxis=[];f.pointCount=f.colorCounter=f.symbolCounter=0;A(f,"afterInit");f.firstRender()})},initSeries:function(a){var b=
this.options.chart;b=a.type||b.type||b.defaultSeriesType;var d=S[b];d||c.error(17,!0,this,{missingModuleFor:b});b=new d;b.init(this,a);return b},orderSeries:function(a){var b=this.series;for(a=a||0;a<b.length;a++)b[a]&&(b[a].index=a,b[a].name=b[a].getName())},isInsidePlot:function(a,b,d){var e=d?b:a;a=d?a:b;return 0<=e&&e<=this.plotWidth&&0<=a&&a<=this.plotHeight},redraw:function(a){A(this,"beforeRedraw");var b=this.axes,d=this.series,e=this.pointer,c=this.legend,k=this.userOptions.legend,m=this.isDirtyLegend,
r=this.hasCartesianSeries,h=this.isDirtyBox,l=this.renderer,f=l.isHidden(),x=[];this.setResponsive&&this.setResponsive(!1);g(a,this);f&&this.temporaryDisplay();this.layOutTitles();for(a=d.length;a--;){var w=d[a];if(w.options.stacking){var p=!0;if(w.isDirty){var u=!0;break}}}if(u)for(a=d.length;a--;)w=d[a],w.options.stacking&&(w.isDirty=!0);d.forEach(function(a){a.isDirty&&("point"===a.options.legendType?(a.updateTotals&&a.updateTotals(),m=!0):k&&(k.labelFormatter||k.labelFormat)&&(m=!0));a.isDirtyData&&
A(a,"updatedData")});m&&c&&c.options.enabled&&(c.render(),this.isDirtyLegend=!1);p&&this.getStacks();r&&b.forEach(function(a){a.updateNames();a.setScale()});this.getMargins();r&&(b.forEach(function(a){a.isDirty&&(h=!0)}),b.forEach(function(a){var b=a.min+","+a.max;a.extKey!==b&&(a.extKey=b,x.push(function(){A(a,"afterSetExtremes",t(a.eventArgs,a.getExtremes()));delete a.eventArgs}));(h||p)&&a.redraw()}));h&&this.drawChartBox();A(this,"predraw");d.forEach(function(a){(h||a.isDirty)&&a.visible&&a.redraw();
a.isDirtyData=!1});e&&e.reset(!0);l.draw();A(this,"redraw");A(this,"render");f&&this.temporaryDisplay(!0);x.forEach(function(a){a.call()})},get:function(a){function b(b){return b.id===a||b.options&&b.options.id===a}var d=this.series,e;var c=x(this.axes,b)||x(this.series,b);for(e=0;!c&&e<d.length;e++)c=x(d[e].points||[],b);return c},getAxes:function(){var a=this,d=this.options,e=d.xAxis=b(d.xAxis||{});d=d.yAxis=b(d.yAxis||{});A(this,"getAxes");e.forEach(function(a,b){a.index=b;a.isX=!0});d.forEach(function(a,
b){a.index=b});e.concat(d).forEach(function(b){new E(a,b)});A(this,"afterGetAxes")},getSelectedPoints:function(){var a=[];this.series.forEach(function(b){a=a.concat((b[b.hasGroupedData?"points":"data"]||[]).filter(function(a){return n(a.selectedStaging,a.selected)}))});return a},getSelectedSeries:function(){return this.series.filter(function(a){return a.selected})},setTitle:function(a,b,d){this.applyDescription("title",a);this.applyDescription("subtitle",b);this.applyDescription("caption",void 0);
this.layOutTitles(d)},applyDescription:function(a,b){var d=this,e="title"===a?{color:"#333333",fontSize:this.options.isStock?"16px":"18px"}:{color:"#666666"};e=this.options[a]=K(!this.styledMode&&{style:e},this.options[a],b);var c=this[a];c&&b&&(this[a]=c=c.destroy());e&&!c&&(c=this.renderer.text(e.text,0,0,e.useHTML).attr({align:e.align,"class":"highcharts-"+a,zIndex:e.zIndex||4}).add(),c.update=function(b){d[{title:"setTitle",subtitle:"setSubtitle",caption:"setCaption"}[a]](b)},this.styledMode||
c.css(e.style),this[a]=c)},layOutTitles:function(a){var b=[0,0,0],d=this.renderer,e=this.spacingBox;["title","subtitle","caption"].forEach(function(a){var c=this[a],k=this.options[a],g=k.verticalAlign||"top";a="title"===a?-3:"top"===g?b[0]+2:0;if(c){if(!this.styledMode)var m=k.style.fontSize;m=d.fontMetrics(m,c).b;c.css({width:(k.width||e.width+(k.widthAdjust||0))+"px"});var r=Math.round(c.getBBox(k.useHTML).height);c.align(t({y:"bottom"===g?m:a+m,height:r},k),!1,"spacingBox");k.floating||("top"===
g?b[0]=Math.ceil(b[0]+r):"bottom"===g&&(b[2]=Math.ceil(b[2]+r)))}},this);b[0]&&"top"===(this.options.title.verticalAlign||"top")&&(b[0]+=this.options.title.margin);b[2]&&"bottom"===this.options.caption.verticalAlign&&(b[2]+=this.options.caption.margin);var c=!this.titleOffset||this.titleOffset.join(",")!==b.join(",");this.titleOffset=b;A(this,"afterLayOutTitles");!this.isDirtyBox&&c&&(this.isDirtyBox=this.isDirtyLegend=c,this.hasRendered&&n(a,!0)&&this.isDirtyBox&&this.redraw())},getChartSize:function(){var a=
this.options.chart,b=a.width;a=a.height;var d=this.renderTo;G(b)||(this.containerWidth=c.getStyle(d,"width"));G(a)||(this.containerHeight=c.getStyle(d,"height"));this.chartWidth=Math.max(0,b||this.containerWidth||600);this.chartHeight=Math.max(0,c.relativeLength(a,this.chartWidth)||(1<this.containerHeight?this.containerHeight:400))},temporaryDisplay:function(a){var b=this.renderTo;if(a)for(;b&&b.style;)b.hcOrigStyle&&(c.css(b,b.hcOrigStyle),delete b.hcOrigStyle),b.hcOrigDetached&&(L.body.removeChild(b),
b.hcOrigDetached=!1),b=b.parentNode;else for(;b&&b.style;){L.body.contains(b)||b.parentNode||(b.hcOrigDetached=!0,L.body.appendChild(b));if("none"===c.getStyle(b,"display",!1)||b.hcOricDetached)b.hcOrigStyle={display:b.style.display,height:b.style.height,overflow:b.style.overflow},a={display:"block",overflow:"hidden"},b!==this.renderTo&&(a.height=0),c.css(b,a),b.offsetWidth||b.style.setProperty("display","block","important");b=b.parentNode;if(b===L.body)break}},setClassName:function(a){this.container.className=
"highcharts-container "+(a||"")},getContainer:function(){var a=this.options,b=a.chart;var d=this.renderTo;var e=c.uniqueKey(),g,m;d||(this.renderTo=d=b.renderTo);y(d)&&(this.renderTo=d=L.getElementById(d));d||c.error(13,!0,this);var h=q(F(d,"data-highcharts-chart"));C(h)&&k[h]&&k[h].hasRendered&&k[h].destroy();F(d,"data-highcharts-chart",this.index);d.innerHTML="";b.skipClone||d.offsetWidth||this.temporaryDisplay();this.getChartSize();h=this.chartWidth;var l=this.chartHeight;r(d,{overflow:"hidden"});
this.styledMode||(g=t({position:"relative",overflow:"hidden",width:h+"px",height:l+"px",textAlign:"left",lineHeight:"normal",zIndex:0,"-webkit-tap-highlight-color":"rgba(0,0,0,0)"},b.style));this.container=d=p("div",{id:e},g,d);this._cursor=d.style.cursor;this.renderer=new (c[b.renderer]||c.Renderer)(d,h,l,null,b.forExport,a.exporting&&a.exporting.allowHTML,this.styledMode);this.setClassName(b.className);if(this.styledMode)for(m in a.defs)this.renderer.definition(a.defs[m]);else this.renderer.setStyle(b.style);
this.renderer.chartIndex=this.index;A(this,"afterGetContainer")},getMargins:function(a){var b=this.spacing,d=this.margin,e=this.titleOffset;this.resetMargins();e[0]&&!G(d[0])&&(this.plotTop=Math.max(this.plotTop,e[0]+b[0]));e[2]&&!G(d[2])&&(this.marginBottom=Math.max(this.marginBottom,e[2]+b[2]));this.legend&&this.legend.display&&this.legend.adjustMargins(d,b);A(this,"getMargins");a||this.getAxisMargins()},getAxisMargins:function(){var a=this,b=a.axisOffset=[0,0,0,0],d=a.colorAxis,e=a.margin,c=function(a){a.forEach(function(a){a.visible&&
a.getOffset()})};a.hasCartesianSeries?c(a.axes):d&&d.length&&c(d);m.forEach(function(d,c){G(e[c])||(a[d]+=b[c])});a.setChartSize()},reflow:function(b){var d=this,e=d.options.chart,k=d.renderTo,g=G(e.width)&&G(e.height),m=e.width||c.getStyle(k,"width");e=e.height||c.getStyle(k,"height");k=b?b.target:Q;if(!g&&!d.isPrinting&&m&&e&&(k===Q||k===L)){if(m!==d.containerWidth||e!==d.containerHeight)c.clearTimeout(d.reflowTimeout),d.reflowTimeout=a(function(){d.container&&d.setSize(void 0,void 0,!1)},b?100:
0);d.containerWidth=m;d.containerHeight=e}},setReflow:function(a){var b=this;!1===a||this.unbindReflow?!1===a&&this.unbindReflow&&(this.unbindReflow=this.unbindReflow()):(this.unbindReflow=d(Q,"resize",function(a){b.options&&b.reflow(a)}),d(this,"destroy",this.unbindReflow))},setSize:function(b,d,c){var k=this,m=k.renderer;k.isResizing+=1;g(c,k);k.oldChartHeight=k.chartHeight;k.oldChartWidth=k.chartWidth;void 0!==b&&(k.options.chart.width=b);void 0!==d&&(k.options.chart.height=d);k.getChartSize();
if(!k.styledMode){var h=m.globalAnimation;(h?e:r)(k.container,{width:k.chartWidth+"px",height:k.chartHeight+"px"},h)}k.setChartSize(!0);m.setSize(k.chartWidth,k.chartHeight,c);k.axes.forEach(function(a){a.isDirty=!0;a.setScale()});k.isDirtyLegend=!0;k.isDirtyBox=!0;k.layOutTitles();k.getMargins();k.redraw(c);k.oldChartHeight=null;A(k,"resize");a(function(){k&&A(k,"endResize",null,function(){--k.isResizing})},l(h).duration||0)},setChartSize:function(a){var b=this.inverted,d=this.renderer,e=this.chartWidth,
c=this.chartHeight,k=this.options.chart,g=this.spacing,m=this.clipOffset,r,h,l,f;this.plotLeft=r=Math.round(this.plotLeft);this.plotTop=h=Math.round(this.plotTop);this.plotWidth=l=Math.max(0,Math.round(e-r-this.marginRight));this.plotHeight=f=Math.max(0,Math.round(c-h-this.marginBottom));this.plotSizeX=b?f:l;this.plotSizeY=b?l:f;this.plotBorderWidth=k.plotBorderWidth||0;this.spacingBox=d.spacingBox={x:g[3],y:g[0],width:e-g[3]-g[1],height:c-g[0]-g[2]};this.plotBox=d.plotBox={x:r,y:h,width:l,height:f};
e=2*Math.floor(this.plotBorderWidth/2);b=Math.ceil(Math.max(e,m[3])/2);d=Math.ceil(Math.max(e,m[0])/2);this.clipBox={x:b,y:d,width:Math.floor(this.plotSizeX-Math.max(e,m[1])/2-b),height:Math.max(0,Math.floor(this.plotSizeY-Math.max(e,m[2])/2-d))};a||this.axes.forEach(function(a){a.setAxisSize();a.setAxisTranslation()});A(this,"afterSetChartSize",{skipAxes:a})},resetMargins:function(){A(this,"resetMargins");var a=this,b=a.options.chart;["margin","spacing"].forEach(function(d){var e=b[d],c=H(e)?e:[e,
e,e,e];["Top","Right","Bottom","Left"].forEach(function(e,k){a[d][k]=n(b[d+e],c[k])})});m.forEach(function(b,d){a[b]=n(a.margin[d],a.spacing[d])});a.axisOffset=[0,0,0,0];a.clipOffset=[0,0,0,0]},drawChartBox:function(){var a=this.options.chart,b=this.renderer,d=this.chartWidth,e=this.chartHeight,c=this.chartBackground,k=this.plotBackground,g=this.plotBorder,m=this.styledMode,r=this.plotBGImage,h=a.backgroundColor,l=a.plotBackgroundColor,f=a.plotBackgroundImage,x,w=this.plotLeft,p=this.plotTop,u=this.plotWidth,
n=this.plotHeight,J=this.plotBox,K=this.clipRect,q=this.clipBox,v="animate";c||(this.chartBackground=c=b.rect().addClass("highcharts-background").add(),v="attr");if(m)var y=x=c.strokeWidth();else{y=a.borderWidth||0;x=y+(a.shadow?8:0);h={fill:h||"none"};if(y||c["stroke-width"])h.stroke=a.borderColor,h["stroke-width"]=y;c.attr(h).shadow(a.shadow)}c[v]({x:x/2,y:x/2,width:d-x-y%2,height:e-x-y%2,r:a.borderRadius});v="animate";k||(v="attr",this.plotBackground=k=b.rect().addClass("highcharts-plot-background").add());
k[v](J);m||(k.attr({fill:l||"none"}).shadow(a.plotShadow),f&&(r?r.animate(J):this.plotBGImage=b.image(f,w,p,u,n).add()));K?K.animate({width:q.width,height:q.height}):this.clipRect=b.clipRect(q);v="animate";g||(v="attr",this.plotBorder=g=b.rect().addClass("highcharts-plot-border").attr({zIndex:1}).add());m||g.attr({stroke:a.plotBorderColor,"stroke-width":a.plotBorderWidth||0,fill:"none"});g[v](g.crisp({x:w,y:p,width:u,height:n},-g.strokeWidth()));this.isDirtyBox=!1;A(this,"afterDrawChartBox")},propFromSeries:function(){var a=
this,b=a.options.chart,d,e=a.options.series,c,k;["inverted","angular","polar"].forEach(function(g){d=S[b.type||b.defaultSeriesType];k=b[g]||d&&d.prototype[g];for(c=e&&e.length;!k&&c--;)(d=S[e[c].type])&&d.prototype[g]&&(k=!0);a[g]=k})},linkSeries:function(){var a=this,b=a.series;b.forEach(function(a){a.linkedSeries.length=0});b.forEach(function(b){var d=b.options.linkedTo;y(d)&&(d=":previous"===d?a.series[b.index-1]:a.get(d))&&d.linkedParent!==b&&(d.linkedSeries.push(b),b.linkedParent=d,b.visible=
n(b.options.visible,d.options.visible,b.visible))});A(this,"afterLinkSeries")},renderSeries:function(){this.series.forEach(function(a){a.translate();a.render()})},renderLabels:function(){var a=this,b=a.options.labels;b.items&&b.items.forEach(function(d){var e=t(b.style,d.style),c=q(e.left)+a.plotLeft,k=q(e.top)+a.plotTop+12;delete e.left;delete e.top;a.renderer.text(d.html,c,k).attr({zIndex:2}).css(e).add()})},render:function(){var a=this.axes,b=this.colorAxis,d=this.renderer,e=this.options,c=0,k=
function(a){a.forEach(function(a){a.visible&&a.render()})};this.setTitle();this.legend=new w(this,e.legend);this.getStacks&&this.getStacks();this.getMargins(!0);this.setChartSize();e=this.plotWidth;a.some(function(a){if(a.horiz&&a.visible&&a.options.labels.enabled&&a.series.length)return c=21,!0});var g=this.plotHeight=Math.max(this.plotHeight-c,0);a.forEach(function(a){a.setScale()});this.getAxisMargins();var m=1.1<e/this.plotWidth;var r=1.05<g/this.plotHeight;if(m||r)a.forEach(function(a){(a.horiz&&
m||!a.horiz&&r)&&a.setTickInterval(!0)}),this.getMargins();this.drawChartBox();this.hasCartesianSeries?k(a):b&&b.length&&k(b);this.seriesGroup||(this.seriesGroup=d.g("series-group").attr({zIndex:3}).add());this.renderSeries();this.renderLabels();this.addCredits();this.setResponsive&&this.setResponsive();this.updateContainerScaling();this.hasRendered=!0},addCredits:function(a){var b=this;a=K(!0,this.options.credits,a);a.enabled&&!this.credits&&(this.credits=this.renderer.text(a.text+(this.mapCredits||
""),0,0).addClass("highcharts-credits").on("click",function(){a.href&&(Q.location.href=a.href)}).attr({align:a.position.align,zIndex:8}),b.styledMode||this.credits.css(a.style),this.credits.add().align(a.position),this.credits.update=function(a){b.credits=b.credits.destroy();b.addCredits(a)})},updateContainerScaling:function(){var a=this.container;if(a.offsetWidth&&a.offsetHeight&&a.getBoundingClientRect){var b=a.getBoundingClientRect(),d=b.width/a.offsetWidth;a=b.height/a.offsetHeight;1!==d||1!==
a?this.containerScaling={scaleX:d,scaleY:a}:delete this.containerScaling}},destroy:function(){var a=this,b=a.axes,d=a.series,e=a.container,g,m=e&&e.parentNode;A(a,"destroy");a.renderer.forExport?B(k,a):k[a.index]=void 0;c.chartCount--;a.renderTo.removeAttribute("data-highcharts-chart");U(a);for(g=b.length;g--;)b[g]=b[g].destroy();this.scroller&&this.scroller.destroy&&this.scroller.destroy();for(g=d.length;g--;)d[g]=d[g].destroy();"title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" ").forEach(function(b){var d=
a[b];d&&d.destroy&&(a[b]=d.destroy())});e&&(e.innerHTML="",U(e),m&&z(e));h(a,function(b,d){delete a[d]})},firstRender:function(){var a=this,b=a.options;if(!a.isReadyToRender||a.isReadyToRender()){a.getContainer();a.resetMargins();a.setChartSize();a.propFromSeries();a.getAxes();(v(b.series)?b.series:[]).forEach(function(b){a.initSeries(b)});a.linkSeries();A(a,"beforeRender");J&&(a.pointer=new J(a,b));a.render();if(!a.renderer.imgCount&&a.onload)a.onload();a.temporaryDisplay(!0)}},onload:function(){this.callbacks.concat([this.callback]).forEach(function(a){a&&
void 0!==this.index&&a.apply(this,[this])},this);A(this,"load");A(this,"render");G(this.index)&&this.setReflow(this.options.chart.reflow);this.onload=null}})});M(I,"parts/ScrollablePlotArea.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.pick,G=c.addEvent;f=c.Chart;"";G(f,"afterSetChartSize",function(f){var z=this.options.chart.scrollablePlotArea,t=z&&z.minWidth;z=z&&z.minHeight;if(!this.renderer.forExport){if(t){if(this.scrollablePixelsX=t=Math.max(0,t-this.chartWidth)){this.plotWidth+=
t;this.inverted?(this.clipBox.height+=t,this.plotBox.height+=t):(this.clipBox.width+=t,this.plotBox.width+=t);var v={1:{name:"right",value:t}}}}else z&&(this.scrollablePixelsY=t=Math.max(0,z-this.chartHeight))&&(this.plotHeight+=t,this.inverted?(this.clipBox.width+=t,this.plotBox.width+=t):(this.clipBox.height+=t,this.plotBox.height+=t),v={2:{name:"bottom",value:t}});v&&!f.skipAxes&&this.axes.forEach(function(f){v[f.side]?f.getPlotLinePath=function(){var t=v[f.side].name,y=this[t];this[t]=y-v[f.side].value;
var h=c.Axis.prototype.getPlotLinePath.apply(this,arguments);this[t]=y;return h}:(f.setAxisSize(),f.setAxisTranslation())})}});G(f,"render",function(){this.scrollablePixelsX||this.scrollablePixelsY?(this.setUpScrolling&&this.setUpScrolling(),this.applyFixed()):this.fixedDiv&&this.applyFixed()});f.prototype.setUpScrolling=function(){var f={WebkitOverflowScrolling:"touch",overflowX:"hidden",overflowY:"hidden"};this.scrollablePixelsX&&(f.overflowX="auto");this.scrollablePixelsY&&(f.overflowY="auto");
this.scrollingContainer=c.createElement("div",{className:"highcharts-scrolling"},f,this.renderTo);this.innerContainer=c.createElement("div",{className:"highcharts-inner-container"},null,this.scrollingContainer);this.innerContainer.appendChild(this.container);this.setUpScrolling=null};f.prototype.moveFixedElements=function(){var c=this.container,f=this.fixedRenderer,t=".highcharts-contextbutton .highcharts-credits .highcharts-legend .highcharts-legend-checkbox .highcharts-navigator-series .highcharts-navigator-xaxis .highcharts-navigator-yaxis .highcharts-navigator .highcharts-reset-zoom .highcharts-scrollbar .highcharts-subtitle .highcharts-title".split(" "),
v;this.scrollablePixelsX&&!this.inverted?v=".highcharts-yaxis":this.scrollablePixelsX&&this.inverted?v=".highcharts-xaxis":this.scrollablePixelsY&&!this.inverted?v=".highcharts-xaxis":this.scrollablePixelsY&&this.inverted&&(v=".highcharts-yaxis");t.push(v,v+"-labels");t.forEach(function(v){[].forEach.call(c.querySelectorAll(v),function(c){(c.namespaceURI===f.SVG_NS?f.box:f.box.parentNode).appendChild(c);c.style.pointerEvents="auto"})})};f.prototype.applyFixed=function(){var f,B=!this.fixedDiv,t=this.options.chart.scrollablePlotArea;
B?(this.fixedDiv=c.createElement("div",{className:"highcharts-fixed"},{position:"absolute",overflow:"hidden",pointerEvents:"none",zIndex:2},null,!0),this.renderTo.insertBefore(this.fixedDiv,this.renderTo.firstChild),this.renderTo.style.overflow="visible",this.fixedRenderer=f=new c.Renderer(this.fixedDiv,this.chartWidth,this.chartHeight),this.scrollableMask=f.path().attr({fill:c.color(this.options.chart.backgroundColor||"#fff").setOpacity(F(t.opacity,.85)).get(),zIndex:-1}).addClass("highcharts-scrollable-mask").add(),
this.moveFixedElements(),G(this,"afterShowResetZoom",this.moveFixedElements),G(this,"afterLayOutTitles",this.moveFixedElements)):this.fixedRenderer.setSize(this.chartWidth,this.chartHeight);f=this.chartWidth+(this.scrollablePixelsX||0);var v=this.chartHeight+(this.scrollablePixelsY||0);c.stop(this.container);this.container.style.width=f+"px";this.container.style.height=v+"px";this.renderer.boxWrapper.attr({width:f,height:v,viewBox:[0,0,f,v].join(" ")});this.chartBackground.attr({width:f,height:v});
this.scrollablePixelsY&&(this.scrollingContainer.style.height=this.chartHeight+"px");B&&(t.scrollPositionX&&(this.scrollingContainer.scrollLeft=this.scrollablePixelsX*t.scrollPositionX),t.scrollPositionY&&(this.scrollingContainer.scrollTop=this.scrollablePixelsY*t.scrollPositionY));v=this.axisOffset;B=this.plotTop-v[0]-1;t=this.plotLeft-v[3]-1;f=this.plotTop+this.plotHeight+v[2]+1;v=this.plotLeft+this.plotWidth+v[1]+1;var C=this.plotLeft+this.plotWidth-(this.scrollablePixelsX||0),H=this.plotTop+this.plotHeight-
(this.scrollablePixelsY||0);B=this.scrollablePixelsX?["M",0,B,"L",this.plotLeft-1,B,"L",this.plotLeft-1,f,"L",0,f,"Z","M",C,B,"L",this.chartWidth,B,"L",this.chartWidth,f,"L",C,f,"Z"]:this.scrollablePixelsY?["M",t,0,"L",t,this.plotTop-1,"L",v,this.plotTop-1,"L",v,0,"Z","M",t,H,"L",t,this.chartHeight,"L",v,this.chartHeight,"L",v,H,"Z"]:["M",0,0];"adjustHeight"!==this.redrawTrigger&&this.scrollableMask.attr({d:B})}});M(I,"parts/Point.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=
f.defined,G=f.erase,z=f.extend,B=f.isArray,t=f.isNumber,v=f.isObject,C=f.pick,H,y=c.fireEvent,h=c.format,n=c.uniqueKey,q=c.removeEvent;c.Point=H=function(){};c.Point.prototype={init:function(c,b,a){this.series=c;this.applyOptions(b,a);this.id=F(this.id)?this.id:n();this.resolveColor();c.chart.pointCount++;y(this,"afterInit");return this},resolveColor:function(){var c=this.series;var b=c.chart.options.chart.colorCount;var a=c.chart.styledMode;a||this.options.color||(this.color=c.color);c.options.colorByPoint?
(a||(b=c.options.colors||c.chart.options.colors,this.color=this.color||b[c.colorCounter],b=b.length),a=c.colorCounter,c.colorCounter++,c.colorCounter===b&&(c.colorCounter=0)):a=c.colorIndex;this.colorIndex=C(this.colorIndex,a)},applyOptions:function(c,b){var a=this.series,d=a.options.pointValKey||a.pointValKey;c=H.prototype.optionsToObject.call(this,c);z(this,c);this.options=this.options?z(this.options,c):c;c.group&&delete this.group;c.dataLabels&&delete this.dataLabels;d&&(this.y=this[d]);this.formatPrefix=
(this.isNull=C(this.isValid&&!this.isValid(),null===this.x||!t(this.y)))?"null":"point";this.selected&&(this.state="select");"name"in this&&void 0===b&&a.xAxis&&a.xAxis.hasNames&&(this.x=a.xAxis.nameToX(this));void 0===this.x&&a&&(this.x=void 0===b?a.autoIncrement(this):b);return this},setNestedProperty:function(c,b,a){a.split(".").reduce(function(a,e,c,g){a[e]=g.length-1===c?b:v(a[e],!0)?a[e]:{};return a[e]},c);return c},optionsToObject:function(g){var b={},a=this.series,d=a.options.keys,e=d||a.pointArrayMap||
["y"],h=e.length,f=0,n=0;if(t(g)||null===g)b[e[0]]=g;else if(B(g))for(!d&&g.length>h&&(a=typeof g[0],"string"===a?b.name=g[0]:"number"===a&&(b.x=g[0]),f++);n<h;)d&&void 0===g[f]||(0<e[n].indexOf(".")?c.Point.prototype.setNestedProperty(b,g[f],e[n]):b[e[n]]=g[f]),f++,n++;else"object"===typeof g&&(b=g,g.dataLabels&&(a._hasPointLabels=!0),g.marker&&(a._hasPointMarkers=!0));return b},getClassName:function(){return"highcharts-point"+(this.selected?" highcharts-point-select":"")+(this.negative?" highcharts-negative":
"")+(this.isNull?" highcharts-null-point":"")+(void 0!==this.colorIndex?" highcharts-color-"+this.colorIndex:"")+(this.options.className?" "+this.options.className:"")+(this.zone&&this.zone.className?" "+this.zone.className.replace("highcharts-negative",""):"")},getZone:function(){var c=this.series,b=c.zones;c=c.zoneAxis||"y";var a=0,d;for(d=b[a];this[c]>=d.value;)d=b[++a];this.nonZonedColor||(this.nonZonedColor=this.color);this.color=d&&d.color&&!this.options.color?d.color:this.nonZonedColor;return d},
hasNewShapeType:function(){return this.graphic&&this.graphic.element.nodeName!==this.shapeType},destroy:function(){var c=this.series.chart,b=c.hoverPoints,a;c.pointCount--;b&&(this.setState(),G(b,this),b.length||(c.hoverPoints=null));if(this===c.hoverPoint)this.onMouseOut();if(this.graphic||this.dataLabel||this.dataLabels)q(this),this.destroyElements();this.legendItem&&c.legend.destroyItem(this);for(a in this)this[a]=null},destroyElements:function(c){var b=this,a=[],d;c=c||{graphic:1,dataLabel:1};
c.graphic&&a.push("graphic","shadowGroup");c.dataLabel&&a.push("dataLabel","dataLabelUpper","connector");for(d=a.length;d--;){var e=a[d];b[e]&&(b[e]=b[e].destroy())}["dataLabel","connector"].forEach(function(a){var d=a+"s";c[a]&&b[d]&&(b[d].forEach(function(a){a.element&&a.destroy()}),delete b[d])})},getLabelConfig:function(){return{x:this.category,y:this.y,color:this.color,colorIndex:this.colorIndex,key:this.name||this.category,series:this.series,point:this,percentage:this.percentage,total:this.total||
this.stackTotal}},tooltipFormatter:function(c){var b=this.series,a=b.tooltipOptions,d=C(a.valueDecimals,""),e=a.valuePrefix||"",g=a.valueSuffix||"";b.chart.styledMode&&(c=b.chart.tooltip.styledModeFormat(c));(b.pointArrayMap||["y"]).forEach(function(a){a="{point."+a;if(e||g)c=c.replace(RegExp(a+"}","g"),e+a+"}"+g);c=c.replace(RegExp(a+"}","g"),a+":,."+d+"f}")});return h(c,{point:this,series:this.series},b.chart.time)},firePointEvent:function(c,b,a){var d=this,e=this.series.options;(e.point.events[c]||
d.options&&d.options.events&&d.options.events[c])&&this.importEvents();"click"===c&&e.allowPointSelect&&(a=function(a){d.select&&d.select(null,a.ctrlKey||a.metaKey||a.shiftKey)});y(this,c,b,a)},visible:!0}});M(I,"parts/Series.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.arrayMax,G=f.arrayMin,z=f.defined,B=f.erase,t=f.extend,v=f.isArray,C=f.isNumber,H=f.isString,y=f.objectEach,h=f.pick,n=f.splat,q=f.syncTimeout,g=c.addEvent,b=c.animObject,a=c.correctFloat,d=c.defaultOptions,
e=c.defaultPlotOptions,l=c.fireEvent,L=c.merge,E=c.removeEvent,p=c.SVGElement,u=c.win;c.Series=c.seriesType("line",null,{lineWidth:2,allowPointSelect:!1,showCheckbox:!1,animation:{duration:1E3},events:{},marker:{lineWidth:0,lineColor:"#ffffff",enabledThreshold:2,radius:4,states:{normal:{animation:!0},hover:{animation:{duration:50},enabled:!0,radiusPlus:2,lineWidthPlus:1},select:{fillColor:"#cccccc",lineColor:"#000000",lineWidth:2}}},point:{events:{}},dataLabels:{align:"center",formatter:function(){return null===
this.y?"":c.numberFormat(this.y,-1)},padding:5,style:{fontSize:"11px",fontWeight:"bold",color:"contrast",textOutline:"1px contrast"},verticalAlign:"bottom",x:0,y:0},cropThreshold:300,opacity:1,pointRange:0,softThreshold:!0,states:{normal:{animation:!0},hover:{animation:{duration:50},lineWidthPlus:1,marker:{},halo:{size:10,opacity:.25}},select:{animation:{duration:0}},inactive:{animation:{duration:50},opacity:.2}},stickyTracking:!0,turboThreshold:1E3,findNearestPointBy:"x"},{axisTypes:["xAxis","yAxis"],
coll:"series",colorCounter:0,cropShoulder:1,directTouch:!1,isCartesian:!0,parallelArrays:["x","y"],pointClass:c.Point,requireSorting:!0,sorted:!0,init:function(a,b){l(this,"init",{options:b});var d=this,e=a.series,k;this.eventOptions=this.eventOptions||{};d.chart=a;d.options=b=d.setOptions(b);d.linkedSeries=[];d.bindAxes();t(d,{name:b.name,state:"",visible:!1!==b.visible,selected:!0===b.selected});var m=b.events;y(m,function(a,b){c.isFunction(a)&&d.eventOptions[b]!==a&&(c.isFunction(d.eventOptions[b])&&
E(d,b,d.eventOptions[b]),d.eventOptions[b]=a,g(d,b,a))});if(m&&m.click||b.point&&b.point.events&&b.point.events.click||b.allowPointSelect)a.runTrackerClick=!0;d.getColor();d.getSymbol();d.parallelArrays.forEach(function(a){d[a+"Data"]||(d[a+"Data"]=[])});d.points||d.data||d.setData(b.data,!1);d.isCartesian&&(a.hasCartesianSeries=!0);e.length&&(k=e[e.length-1]);d._i=h(k&&k._i,-1)+1;a.orderSeries(this.insert(e));l(this,"afterInit")},insert:function(a){var b=this.options.index,d;if(C(b)){for(d=a.length;d--;)if(b>=
h(a[d].options.index,a[d]._i)){a.splice(d+1,0,this);break}-1===d&&a.unshift(this);d+=1}else a.push(this);return h(d,a.length-1)},bindAxes:function(){var a=this,b=a.options,d=a.chart,e;l(this,"bindAxes",null,function(){(a.axisTypes||[]).forEach(function(k){d[k].forEach(function(d){e=d.options;if(b[k]===e.index||void 0!==b[k]&&b[k]===e.id||void 0===b[k]&&0===e.index)a.insert(d.series),a[k]=d,d.isDirty=!0});a[k]||a.optionalAxis===k||c.error(18,!0,d)})})},updateParallelArrays:function(a,b){var d=a.series,
c=arguments,e=C(b)?function(c){var e="y"===c&&d.toYData?d.toYData(a):a[c];d[c+"Data"][b]=e}:function(a){Array.prototype[b].apply(d[a+"Data"],Array.prototype.slice.call(c,2))};d.parallelArrays.forEach(e)},hasData:function(){return this.visible&&void 0!==this.dataMax&&void 0!==this.dataMin||this.visible&&this.yData&&0<this.yData.length},autoIncrement:function(){var a=this.options,b=this.xIncrement,d,c=a.pointIntervalUnit,e=this.chart.time;b=h(b,a.pointStart,0);this.pointInterval=d=h(this.pointInterval,
a.pointInterval,1);c&&(a=new e.Date(b),"day"===c?e.set("Date",a,e.get("Date",a)+d):"month"===c?e.set("Month",a,e.get("Month",a)+d):"year"===c&&e.set("FullYear",a,e.get("FullYear",a)+d),d=a.getTime()-b);this.xIncrement=b+d;return b},setOptions:function(a){var b=this.chart,c=b.options,e=c.plotOptions,k=b.userOptions||{};a=L(a);b=b.styledMode;var g={plotOptions:e,userOptions:a};l(this,"setOptions",g);var f=g.plotOptions[this.type],p=k.plotOptions||{};this.userOptions=g.userOptions;k=L(f,e.series,k.plotOptions&&
k.plotOptions[this.type],a);this.tooltipOptions=L(d.tooltip,d.plotOptions.series&&d.plotOptions.series.tooltip,d.plotOptions[this.type].tooltip,c.tooltip.userOptions,e.series&&e.series.tooltip,e[this.type].tooltip,a.tooltip);this.stickyTracking=h(a.stickyTracking,p[this.type]&&p[this.type].stickyTracking,p.series&&p.series.stickyTracking,this.tooltipOptions.shared&&!this.noSharedTooltip?!0:k.stickyTracking);null===f.marker&&delete k.marker;this.zoneAxis=k.zoneAxis;c=this.zones=(k.zones||[]).slice();
!k.negativeColor&&!k.negativeFillColor||k.zones||(e={value:k[this.zoneAxis+"Threshold"]||k.threshold||0,className:"highcharts-negative"},b||(e.color=k.negativeColor,e.fillColor=k.negativeFillColor),c.push(e));c.length&&z(c[c.length-1].value)&&c.push(b?{}:{color:this.color,fillColor:this.fillColor});l(this,"afterSetOptions",{options:k});return k},getName:function(){return h(this.options.name,"Series "+(this.index+1))},getCyclic:function(a,b,d){var c=this.chart,e=this.userOptions,k=a+"Index",g=a+"Counter",
f=d?d.length:h(c.options.chart[a+"Count"],c[a+"Count"]);if(!b){var r=h(e[k],e["_"+k]);z(r)||(c.series.length||(c[g]=0),e["_"+k]=r=c[g]%f,c[g]+=1);d&&(b=d[r])}void 0!==r&&(this[k]=r);this[a]=b},getColor:function(){this.chart.styledMode?this.getCyclic("color"):this.options.colorByPoint?this.options.color=null:this.getCyclic("color",this.options.color||e[this.type].color,this.chart.options.colors)},getSymbol:function(){this.getCyclic("symbol",this.options.marker.symbol,this.chart.options.symbols)},findPointIndex:function(a,
b){var d=a.id;a=a.x;var c=this.points,e;if(d){var k=(d=this.chart.get(d))&&d.index;void 0!==k&&(e=!0)}void 0===k&&C(a)&&(k=this.xData.indexOf(a,b));-1!==k&&void 0!==k&&this.cropped&&(k=k>=this.cropStart?k-this.cropStart:k);!e&&c[k]&&c[k].touched&&(k=void 0);return k},drawLegendSymbol:c.LegendSymbolMixin.drawLineMarker,updateData:function(a){var b=this.options,d=this.points,c=[],e,k,g,h=this.requireSorting,f=a.length===d.length,l=!0;this.xIncrement=null;a.forEach(function(a,k){var m=z(a)&&this.pointClass.prototype.optionsToObject.call({series:this},
a)||{};var r=m.x;if(m.id||C(r))if(r=this.findPointIndex(m,g),-1===r||void 0===r?c.push(a):d[r]&&a!==b.data[r]?(d[r].update(a,!1,null,!1),d[r].touched=!0,h&&(g=r+1)):d[r]&&(d[r].touched=!0),!f||k!==r||this.hasDerivedData)e=!0},this);if(e)for(a=d.length;a--;)(k=d[a])&&!k.touched&&k.remove(!1);else f?a.forEach(function(a,b){d[b].update&&a!==d[b].y&&d[b].update(a,!1,null,!1)}):l=!1;d.forEach(function(a){a&&(a.touched=!1)});if(!l)return!1;c.forEach(function(a){this.addPoint(a,!1,null,null,!1)},this);return!0},
setData:function(a,b,d,e){var k=this,g=k.points,f=g&&g.length||0,r,l=k.options,p=k.chart,x=null,A=k.xAxis;x=l.turboThreshold;var u=this.xData,n=this.yData,q=(r=k.pointArrayMap)&&r.length,y=l.keys,t=0,E=1,L;a=a||[];r=a.length;b=h(b,!0);!1!==e&&r&&f&&!k.cropped&&!k.hasGroupedData&&k.visible&&!k.isSeriesBoosting&&(L=this.updateData(a));if(!L){k.xIncrement=null;k.colorCounter=0;this.parallelArrays.forEach(function(a){k[a+"Data"].length=0});if(x&&r>x)if(x=k.getFirstValidPoint(a),C(x))for(d=0;d<r;d++)u[d]=
this.autoIncrement(),n[d]=a[d];else if(v(x))if(q)for(d=0;d<r;d++)e=a[d],u[d]=e[0],n[d]=e.slice(1,q+1);else for(y&&(t=y.indexOf("x"),E=y.indexOf("y"),t=0<=t?t:0,E=0<=E?E:1),d=0;d<r;d++)e=a[d],u[d]=e[t],n[d]=e[E];else c.error(12,!1,p);else for(d=0;d<r;d++)void 0!==a[d]&&(e={series:k},k.pointClass.prototype.applyOptions.apply(e,[a[d]]),k.updateParallelArrays(e,d));n&&H(n[0])&&c.error(14,!0,p);k.data=[];k.options.data=k.userOptions.data=a;for(d=f;d--;)g[d]&&g[d].destroy&&g[d].destroy();A&&(A.minRange=
A.userMinRange);k.isDirty=p.isDirtyBox=!0;k.isDirtyData=!!g;d=!1}"point"===l.legendType&&(this.processData(),this.generatePoints());b&&p.redraw(d)},processData:function(a){var b=this.xData,d=this.yData,e=b.length;var k=0;var g=this.xAxis,h=this.options;var f=h.cropThreshold;var l=this.getExtremesFromAll||h.getExtremesFromAll,p=this.isCartesian;h=g&&g.val2lin;var u=g&&g.isLog,n=this.requireSorting;if(p&&!this.isDirty&&!g.isDirty&&!this.yAxis.isDirty&&!a)return!1;if(g){a=g.getExtremes();var q=a.min;
var v=a.max}if(p&&this.sorted&&!l&&(!f||e>f||this.forceCrop))if(b[e-1]<q||b[0]>v)b=[],d=[];else if(this.yData&&(b[0]<q||b[e-1]>v)){k=this.cropData(this.xData,this.yData,q,v);b=k.xData;d=k.yData;k=k.start;var y=!0}for(f=b.length||1;--f;)if(e=u?h(b[f])-h(b[f-1]):b[f]-b[f-1],0<e&&(void 0===t||e<t))var t=e;else 0>e&&n&&(c.error(15,!1,this.chart),n=!1);this.cropped=y;this.cropStart=k;this.processedXData=b;this.processedYData=d;this.closestPointRange=this.basePointRange=t},cropData:function(a,b,d,e,c){var k=
a.length,g=0,f=k,r;c=h(c,this.cropShoulder);for(r=0;r<k;r++)if(a[r]>=d){g=Math.max(0,r-c);break}for(d=r;d<k;d++)if(a[d]>e){f=d+c;break}return{xData:a.slice(g,f),yData:b.slice(g,f),start:g,end:f}},generatePoints:function(){var a=this.options,b=a.data,d=this.data,e,c=this.processedXData,g=this.processedYData,f=this.pointClass,h=c.length,p=this.cropStart||0,u=this.hasGroupedData;a=a.keys;var q=[],v;d||u||(d=[],d.length=b.length,d=this.data=d);a&&u&&(this.options.keys=!1);for(v=0;v<h;v++){var y=p+v;if(u){var E=
(new f).init(this,[c[v]].concat(n(g[v])));E.dataGroup=this.groupMap[v];E.dataGroup.options&&(E.options=E.dataGroup.options,t(E,E.dataGroup.options),delete E.dataLabels)}else(E=d[y])||void 0===b[y]||(d[y]=E=(new f).init(this,b[y],c[v]));E&&(E.index=y,q[v]=E)}this.options.keys=a;if(d&&(h!==(e=d.length)||u))for(v=0;v<e;v++)v!==p||u||(v+=h),d[v]&&(d[v].destroyElements(),d[v].plotX=void 0);this.data=d;this.points=q;l(this,"afterGeneratePoints")},getXExtremes:function(a){return{min:G(a),max:F(a)}},getExtremes:function(a){var b=
this.xAxis,d=this.yAxis,e=this.processedXData||this.xData,c=[],k=0,g=0;var f=0;var h=this.requireSorting?this.cropShoulder:0,p=d?d.positiveValuesOnly:!1,u;a=a||this.stackedYData||this.processedYData||[];d=a.length;b&&(f=b.getExtremes(),g=f.min,f=f.max);for(u=0;u<d;u++){var n=e[u];var q=a[u];var y=(C(q)||v(q))&&(q.length||0<q||!p);n=this.getExtremesFromAll||this.options.getExtremesFromAll||this.cropped||!b||(e[u+h]||n)>=g&&(e[u-h]||n)<=f;if(y&&n)if(y=q.length)for(;y--;)C(q[y])&&(c[k++]=q[y]);else c[k++]=
q}this.dataMin=G(c);this.dataMax=F(c);l(this,"afterGetExtremes")},getFirstValidPoint:function(a){for(var b=null,d=a.length,e=0;null===b&&e<d;)b=a[e],e++;return b},translate:function(){this.processedXData||this.processData();this.generatePoints();var b=this.options,d=b.stacking,e=this.xAxis,c=e.categories,g=this.yAxis,m=this.points,f=m.length,p=!!this.modifyValue,u,n=this.pointPlacementToXValue(),q=C(n),y=b.threshold,t=b.startFromThreshold?y:0,E,L=this.zoneAxis||"y",B=Number.MAX_VALUE;for(u=0;u<f;u++){var H=
m[u],G=H.x;var F=H.y;var I=H.low,M=d&&g.stacks[(this.negStacks&&F<(t?0:y)?"-":"")+this.stackKey];g.positiveValuesOnly&&null!==F&&0>=F&&(H.isNull=!0);H.plotX=E=a(Math.min(Math.max(-1E5,e.translate(G,0,0,0,1,n,"flags"===this.type)),1E5));if(d&&this.visible&&M&&M[G]){var X=this.getStackIndicator(X,G,this.index);if(!H.isNull){var P=M[G];var Y=P.points[X.key]}}v(Y)&&(I=Y[0],F=Y[1],I===t&&X.key===M[G].base&&(I=h(C(y)&&y,g.min)),g.positiveValuesOnly&&0>=I&&(I=null),H.total=H.stackTotal=P.total,H.percentage=
P.total&&H.y/P.total*100,H.stackY=F,this.irregularWidths||P.setOffset(this.pointXOffset||0,this.barW||0));H.yBottom=z(I)?Math.min(Math.max(-1E5,g.translate(I,0,1,0,1)),1E5):null;p&&(F=this.modifyValue(F,H));H.plotY=F="number"===typeof F&&Infinity!==F?Math.min(Math.max(-1E5,g.translate(F,0,1,0,1)),1E5):void 0;H.isInside=void 0!==F&&0<=F&&F<=g.len&&0<=E&&E<=e.len;H.clientX=q?a(e.translate(G,0,0,0,1,n)):E;H.negative=H[L]<(b[L+"Threshold"]||y||0);H.category=c&&void 0!==c[H.x]?c[H.x]:H.x;if(!H.isNull){void 0!==
Z&&(B=Math.min(B,Math.abs(E-Z)));var Z=E}H.zone=this.zones.length&&H.getZone()}this.closestPointRangePx=B;l(this,"afterTranslate")},getValidPoints:function(a,b,d){var e=this.chart;return(a||this.points||[]).filter(function(a){return b&&!e.isInsidePlot(a.plotX,a.plotY,e.inverted)?!1:d||!a.isNull})},getClipBox:function(a,b){var d=this.options,e=this.chart,c=e.inverted,k=this.xAxis,g=k&&this.yAxis;a&&!1===d.clip&&g?a=c?{y:-e.chartWidth+g.len+g.pos,height:e.chartWidth,width:e.chartHeight,x:-e.chartHeight+
k.len+k.pos}:{y:-g.pos,height:e.chartHeight,width:e.chartWidth,x:-k.pos}:(a=this.clipBox||e.clipBox,b&&(a.width=e.plotSizeX,a.x=0));return b?{width:a.width,x:a.x}:a},setClip:function(a){var b=this.chart,d=this.options,e=b.renderer,c=b.inverted,k=this.clipBox,g=this.getClipBox(a),f=this.sharedClipKey||["_sharedClip",a&&a.duration,a&&a.easing,g.height,d.xAxis,d.yAxis].join(),h=b[f],l=b[f+"m"];h||(a&&(g.width=0,c&&(g.x=b.plotSizeX+(!1!==d.clip?0:b.plotTop)),b[f+"m"]=l=e.clipRect(c?b.plotSizeX+99:-99,
c?-b.plotLeft:-b.plotTop,99,c?b.chartWidth:b.chartHeight)),b[f]=h=e.clipRect(g),h.count={length:0});a&&!h.count[this.index]&&(h.count[this.index]=!0,h.count.length+=1);if(!1!==d.clip||a)this.group.clip(a||k?h:b.clipRect),this.markerGroup.clip(l),this.sharedClipKey=f;a||(h.count[this.index]&&(delete h.count[this.index],--h.count.length),0===h.count.length&&f&&b[f]&&(k||(b[f]=b[f].destroy()),b[f+"m"]&&(b[f+"m"]=b[f+"m"].destroy())))},animate:function(a){var d=this.chart,e=b(this.options.animation);
if(a)this.setClip(e);else{var c=this.sharedClipKey;a=d[c];var k=this.getClipBox(e,!0);a&&a.animate(k,e);d[c+"m"]&&d[c+"m"].animate({width:k.width+99,x:k.x-(d.inverted?0:99)},e);this.animate=null}},afterAnimate:function(){this.setClip();l(this,"afterAnimate");this.finishedAnimating=!0},drawPoints:function(){var a=this.points,b=this.chart,d,e=this.options.marker,c=this[this.specialGroup]||this.markerGroup;var g=this.xAxis;var f=h(e.enabled,!g||g.isRadial?!0:null,this.closestPointRangePx>=e.enabledThreshold*
e.radius);if(!1!==e.enabled||this._hasPointMarkers)for(g=0;g<a.length;g++){var l=a[g];var p=(d=l.graphic)?"animate":"attr";var u=l.marker||{};var n=!!l.marker;var q=f&&void 0===u.enabled||u.enabled;var v=!1!==l.isInside;if(q&&!l.isNull){var y=h(u.symbol,this.symbol);q=this.markerAttribs(l,l.selected&&"select");d?d[v?"show":"hide"](v).animate(q):v&&(0<q.width||l.hasImage)&&(l.graphic=d=b.renderer.symbol(y,q.x,q.y,q.width,q.height,n?u:e).add(c));if(d&&!b.styledMode)d[p](this.pointAttribs(l,l.selected&&
"select"));d&&d.addClass(l.getClassName(),!0)}else d&&(l.graphic=d.destroy())}},markerAttribs:function(a,b){var d=this.options.marker,e=a.marker||{},c=e.symbol||d.symbol,k=h(e.radius,d.radius);b&&(d=d.states[b],b=e.states&&e.states[b],k=h(b&&b.radius,d&&d.radius,k+(d&&d.radiusPlus||0)));a.hasImage=c&&0===c.indexOf("url");a.hasImage&&(k=0);a={x:Math.floor(a.plotX)-k,y:a.plotY-k};k&&(a.width=a.height=2*k);return a},pointAttribs:function(a,b){var d=this.options.marker,e=a&&a.options,c=e&&e.marker||{},
k=this.color,g=e&&e.color,f=a&&a.color;e=h(c.lineWidth,d.lineWidth);var l=a&&a.zone&&a.zone.color;a=1;k=g||l||f||k;g=c.fillColor||d.fillColor||k;k=c.lineColor||d.lineColor||k;b=b||"normal";d=d.states[b];b=c.states&&c.states[b]||{};e=h(b.lineWidth,d.lineWidth,e+h(b.lineWidthPlus,d.lineWidthPlus,0));g=b.fillColor||d.fillColor||g;k=b.lineColor||d.lineColor||k;a=h(b.opacity,d.opacity,a);return{stroke:k,"stroke-width":e,fill:g,opacity:a}},destroy:function(a){var b=this,d=b.chart,e=/AppleWebKit\/533/.test(u.navigator.userAgent),
k,g,f=b.data||[],h,n;l(b,"destroy");a||E(b);(b.axisTypes||[]).forEach(function(a){(n=b[a])&&n.series&&(B(n.series,b),n.isDirty=n.forceRedraw=!0)});b.legendItem&&b.chart.legend.destroyItem(b);for(g=f.length;g--;)(h=f[g])&&h.destroy&&h.destroy();b.points=null;c.clearTimeout(b.animationTimeout);y(b,function(a,b){a instanceof p&&!a.survive&&(k=e&&"group"===b?"hide":"destroy",a[k]())});d.hoverSeries===b&&(d.hoverSeries=null);B(d.series,b);d.orderSeries();y(b,function(d,e){a&&"hcEvents"===e||delete b[e]})},
getGraphPath:function(a,b,d){var e=this,c=e.options,k=c.step,g,f=[],h=[],l;a=a||e.points;(g=a.reversed)&&a.reverse();(k={right:1,center:2}[k]||k&&3)&&g&&(k=4-k);!c.connectNulls||b||d||(a=this.getValidPoints(a));a.forEach(function(g,m){var r=g.plotX,p=g.plotY,u=a[m-1];(g.leftCliff||u&&u.rightCliff)&&!d&&(l=!0);g.isNull&&!z(b)&&0<m?l=!c.connectNulls:g.isNull&&!b?l=!0:(0===m||l?m=["M",g.plotX,g.plotY]:e.getPointSpline?m=e.getPointSpline(a,g,m):k?(m=1===k?["L",u.plotX,p]:2===k?["L",(u.plotX+r)/2,u.plotY,
"L",(u.plotX+r)/2,p]:["L",r,u.plotY],m.push("L",r,p)):m=["L",r,p],h.push(g.x),k&&(h.push(g.x),2===k&&h.push(g.x)),f.push.apply(f,m),l=!1)});f.xMap=h;return e.graphPath=f},drawGraph:function(){var a=this,b=this.options,d=(this.gappedPath||this.getGraphPath).call(this),e=this.chart.styledMode,c=[["graph","highcharts-graph"]];e||c[0].push(b.lineColor||this.color||"#cccccc",b.dashStyle);c=a.getZonesGraphs(c);c.forEach(function(c,k){var g=c[0],f=a[g],h=f?"animate":"attr";f?(f.endX=a.preventGraphAnimation?
null:d.xMap,f.animate({d:d})):d.length&&(a[g]=f=a.chart.renderer.path(d).addClass(c[1]).attr({zIndex:1}).add(a.group));f&&!e&&(g={stroke:c[2],"stroke-width":b.lineWidth,fill:a.fillGraph&&a.color||"none"},c[3]?g.dashstyle=c[3]:"square"!==b.linecap&&(g["stroke-linecap"]=g["stroke-linejoin"]="round"),f[h](g).shadow(2>k&&b.shadow));f&&(f.startX=d.xMap,f.isArea=d.isArea)})},getZonesGraphs:function(a){this.zones.forEach(function(b,d){d=["zone-graph-"+d,"highcharts-graph highcharts-zone-graph-"+d+" "+(b.className||
"")];this.chart.styledMode||d.push(b.color||this.color,b.dashStyle||this.options.dashStyle);a.push(d)},this);return a},applyZones:function(){var a=this,b=this.chart,d=b.renderer,e=this.zones,c,g,f=this.clips||[],l,p=this.graph,u=this.area,n=Math.max(b.chartWidth,b.chartHeight),q=this[(this.zoneAxis||"y")+"Axis"],v=b.inverted,y,t,E,C=!1;if(e.length&&(p||u)&&q&&void 0!==q.min){var L=q.reversed;var z=q.horiz;p&&!this.showLine&&p.hide();u&&u.hide();var B=q.getExtremes();e.forEach(function(e,k){c=L?z?
b.plotWidth:0:z?0:q.toPixels(B.min)||0;c=Math.min(Math.max(h(g,c),0),n);g=Math.min(Math.max(Math.round(q.toPixels(h(e.value,B.max),!0)||0),0),n);C&&(c=g=q.toPixels(B.max));y=Math.abs(c-g);t=Math.min(c,g);E=Math.max(c,g);q.isXAxis?(l={x:v?E:t,y:0,width:y,height:n},z||(l.x=b.plotHeight-l.x)):(l={x:0,y:v?E:t,width:n,height:y},z&&(l.y=b.plotWidth-l.y));v&&d.isVML&&(l=q.isXAxis?{x:0,y:L?t:E,height:l.width,width:b.chartWidth}:{x:l.y-b.plotLeft-b.spacingBox.x,y:0,width:l.height,height:b.chartHeight});f[k]?
f[k].animate(l):f[k]=d.clipRect(l);p&&a["zone-graph-"+k].clip(f[k]);u&&a["zone-area-"+k].clip(f[k]);C=e.value>B.max;a.resetZones&&0===g&&(g=void 0)});this.clips=f}else a.visible&&(p&&p.show(!0),u&&u.show(!0))},invertGroups:function(a){function b(){["group","markerGroup"].forEach(function(b){d[b]&&(e.renderer.isVML&&d[b].attr({width:d.yAxis.len,height:d.xAxis.len}),d[b].width=d.yAxis.len,d[b].height=d.xAxis.len,d[b].invert(a))})}var d=this,e=d.chart;if(d.xAxis){var c=g(e,"resize",b);g(d,"destroy",
c);b(a);d.invertGroups=b}},plotGroup:function(a,b,d,e,c){var k=this[a],g=!k;g&&(this[a]=k=this.chart.renderer.g().attr({zIndex:e||.1}).add(c));k.addClass("highcharts-"+b+" highcharts-series-"+this.index+" highcharts-"+this.type+"-series "+(z(this.colorIndex)?"highcharts-color-"+this.colorIndex+" ":"")+(this.options.className||"")+(k.hasClass("highcharts-tracker")?" highcharts-tracker":""),!0);k.attr({visibility:d})[g?"attr":"animate"](this.getPlotBox());return k},getPlotBox:function(){var a=this.chart,
b=this.xAxis,d=this.yAxis;a.inverted&&(b=d,d=this.xAxis);return{translateX:b?b.left:a.plotLeft,translateY:d?d.top:a.plotTop,scaleX:1,scaleY:1}},render:function(){var a=this,d=a.chart,e=a.options,c=!!a.animate&&d.renderer.isSVG&&b(e.animation).duration,g=a.visible?"inherit":"hidden",f=e.zIndex,h=a.hasRendered,p=d.seriesGroup,u=d.inverted;l(this,"render");var n=a.plotGroup("group","series",g,f,p);a.markerGroup=a.plotGroup("markerGroup","markers",g,f,p);c&&a.animate(!0);n.inverted=a.isCartesian||a.invertable?
u:!1;a.drawGraph&&(a.drawGraph(),a.applyZones());a.visible&&a.drawPoints();a.drawDataLabels&&a.drawDataLabels();a.redrawPoints&&a.redrawPoints();a.drawTracker&&!1!==a.options.enableMouseTracking&&a.drawTracker();a.invertGroups(u);!1===e.clip||a.sharedClipKey||h||n.clip(d.clipRect);c&&a.animate();h||(a.animationTimeout=q(function(){a.afterAnimate()},c||0));a.isDirty=!1;a.hasRendered=!0;l(a,"afterRender")},redraw:function(){var a=this.chart,b=this.isDirty||this.isDirtyData,d=this.group,e=this.xAxis,
c=this.yAxis;d&&(a.inverted&&d.attr({width:a.plotWidth,height:a.plotHeight}),d.animate({translateX:h(e&&e.left,a.plotLeft),translateY:h(c&&c.top,a.plotTop)}));this.translate();this.render();b&&delete this.kdTree},kdAxisArray:["clientX","plotY"],searchPoint:function(a,b){var d=this.xAxis,e=this.yAxis,c=this.chart.inverted;return this.searchKDTree({clientX:c?d.len-a.chartY+d.pos:a.chartX-d.pos,plotY:c?e.len-a.chartX+e.pos:a.chartY-e.pos},b,a)},buildKDTree:function(a){function b(a,e,c){var g;if(g=a&&
a.length){var k=d.kdAxisArray[e%c];a.sort(function(a,b){return a[k]-b[k]});g=Math.floor(g/2);return{point:a[g],left:b(a.slice(0,g),e+1,c),right:b(a.slice(g+1),e+1,c)}}}this.buildingKdTree=!0;var d=this,e=-1<d.options.findNearestPointBy.indexOf("y")?2:1;delete d.kdTree;q(function(){d.kdTree=b(d.getValidPoints(null,!d.directTouch),e,e);d.buildingKdTree=!1},d.options.kdNow||a&&"touchstart"===a.type?0:1)},searchKDTree:function(a,b,d){function e(a,b,d,h){var l=b.point,m=c.kdAxisArray[d%h],p=l;var r=z(a[g])&&
z(l[g])?Math.pow(a[g]-l[g],2):null;var u=z(a[k])&&z(l[k])?Math.pow(a[k]-l[k],2):null;u=(r||0)+(u||0);l.dist=z(u)?Math.sqrt(u):Number.MAX_VALUE;l.distX=z(r)?Math.sqrt(r):Number.MAX_VALUE;m=a[m]-l[m];u=0>m?"left":"right";r=0>m?"right":"left";b[u]&&(u=e(a,b[u],d+1,h),p=u[f]<p[f]?u:l);b[r]&&Math.sqrt(m*m)<p[f]&&(a=e(a,b[r],d+1,h),p=a[f]<p[f]?a:p);return p}var c=this,g=this.kdAxisArray[0],k=this.kdAxisArray[1],f=b?"distX":"dist";b=-1<c.options.findNearestPointBy.indexOf("y")?2:1;this.kdTree||this.buildingKdTree||
this.buildKDTree(d);if(this.kdTree)return e(a,this.kdTree,b,b)},pointPlacementToXValue:function(){var a=this.xAxis,b=this.options.pointPlacement;"between"===b&&(b=a.reversed?-.5:.5);C(b)&&(b*=h(this.options.pointRange||a.pointRange));return b}});""});M(I,"parts/Stacking.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.defined,G=f.destroyObjectProperties,z=f.objectEach,B=f.pick;f=c.Axis;var t=c.Chart,v=c.correctFloat,C=c.format,H=c.Series;c.StackItem=function(c,f,n,q,g){var b=
c.chart.inverted;this.axis=c;this.isNegative=n;this.options=f=f||{};this.x=q;this.total=null;this.points={};this.stack=g;this.rightCliff=this.leftCliff=0;this.alignOptions={align:f.align||(b?n?"left":"right":"center"),verticalAlign:f.verticalAlign||(b?"middle":n?"bottom":"top"),y:f.y,x:f.x};this.textAlign=f.textAlign||(b?n?"right":"left":"center")};c.StackItem.prototype={destroy:function(){G(this,this.axis)},render:function(c){var f=this.axis.chart,n=this.options,q=n.format;q=q?C(q,this,f.time):n.formatter.call(this);
this.label?this.label.attr({text:q,visibility:"hidden"}):(this.label=f.renderer.label(q,null,null,n.shape,null,null,n.useHTML,!1,"stack-labels"),q={text:q,align:this.textAlign,rotation:n.rotation,padding:B(n.padding,0),visibility:"hidden"},this.label.attr(q),f.styledMode||this.label.css(n.style),this.label.added||this.label.add(c));this.label.labelrank=f.plotHeight},setOffset:function(c,f,n,q,g){var b=this.axis,a=b.chart;q=b.translate(b.usePercentage?100:q?q:this.total,0,0,0,1);n=b.translate(n?n:
0);n=F(q)&&Math.abs(q-n);c=B(g,a.xAxis[0].translate(this.x))+c;b=F(q)&&this.getStackBox(a,this,c,q,f,n,b);f=this.label;c=this.isNegative;g="justify"===B(this.options.overflow,"justify");if(f&&b){n=f.getBBox();var d=a.inverted?c?n.width:0:n.width/2,e=a.inverted?n.height/2:c?-4:n.height+4;this.alignOptions.x=B(this.options.x,0);f.align(this.alignOptions,null,b);q=f.alignAttr;f.show();q.y-=e;g&&(q.x-=d,H.prototype.justifyDataLabel.call(this.axis,f,this.alignOptions,q,n,b),q.x+=d);q.x=f.alignAttr.x;f.attr({x:q.x,
y:q.y});B(!g&&this.options.crop,!0)&&((a=a.isInsidePlot(f.x+(a.inverted?0:-n.width/2),f.y)&&a.isInsidePlot(f.x+(a.inverted?c?-n.width:n.width:n.width/2),f.y+n.height))||f.hide())}},getStackBox:function(c,f,n,q,g,b,a){var d=f.axis.reversed,e=c.inverted;c=a.height+a.pos-(e?c.plotLeft:c.plotTop);f=f.isNegative&&!d||!f.isNegative&&d;return{x:e?f?q:q-b:n,y:e?c-n-g:f?c-q-b:c-q,width:e?b:g,height:e?g:b}}};t.prototype.getStacks=function(){var c=this,f=c.inverted;c.yAxis.forEach(function(c){c.stacks&&c.hasVisibleSeries&&
(c.oldStacks=c.stacks)});c.series.forEach(function(h){var n=h.xAxis&&h.xAxis.options||{};!h.options.stacking||!0!==h.visible&&!1!==c.options.chart.ignoreHiddenSeries||(h.stackKey=[h.type,B(h.options.stack,""),f?n.top:n.left,f?n.height:n.width].join())})};f.prototype.buildStacks=function(){var c=this.series,f=B(this.options.reversedStacks,!0),n=c.length,q;if(!this.isXAxis){this.usePercentage=!1;for(q=n;q--;)c[f?q:n-q-1].setStackedPoints();for(q=0;q<n;q++)c[q].modifyStacks()}};f.prototype.renderStackTotals=
function(){var c=this.chart,f=c.renderer,n=this.stacks,q=this.stackTotalGroup;q||(this.stackTotalGroup=q=f.g("stack-labels").attr({visibility:"visible",zIndex:6}).add());q.translate(c.plotLeft,c.plotTop);z(n,function(c){z(c,function(b){b.render(q)})})};f.prototype.resetStacks=function(){var c=this,f=c.stacks;c.isXAxis||z(f,function(f){z(f,function(h,g){h.touched<c.stacksTouched?(h.destroy(),delete f[g]):(h.total=null,h.cumulative=null)})})};f.prototype.cleanStacks=function(){if(!this.isXAxis){if(this.oldStacks)var c=
this.stacks=this.oldStacks;z(c,function(c){z(c,function(c){c.cumulative=c.total})})}};H.prototype.setStackedPoints=function(){if(this.options.stacking&&(!0===this.visible||!1===this.chart.options.chart.ignoreHiddenSeries)){var f=this.processedXData,h=this.processedYData,n=[],q=h.length,g=this.options,b=g.threshold,a=B(g.startFromThreshold&&b,0),d=g.stack;g=g.stacking;var e=this.stackKey,l="-"+e,t=this.negStacks,E=this.yAxis,p=E.stacks,u=E.oldStacks,k,r;E.stacksTouched+=1;for(r=0;r<q;r++){var x=f[r];
var A=h[r];var w=this.getStackIndicator(w,x,this.index);var m=w.key;var K=(k=t&&A<(a?0:b))?l:e;p[K]||(p[K]={});p[K][x]||(u[K]&&u[K][x]?(p[K][x]=u[K][x],p[K][x].total=null):p[K][x]=new c.StackItem(E,E.options.stackLabels,k,x,d));K=p[K][x];null!==A?(K.points[m]=K.points[this.index]=[B(K.cumulative,a)],F(K.cumulative)||(K.base=m),K.touched=E.stacksTouched,0<w.index&&!1===this.singleStacks&&(K.points[m][0]=K.points[this.index+","+x+",0"][0])):K.points[m]=K.points[this.index]=null;"percent"===g?(k=k?e:
l,t&&p[k]&&p[k][x]?(k=p[k][x],K.total=k.total=Math.max(k.total,K.total)+Math.abs(A)||0):K.total=v(K.total+(Math.abs(A)||0))):K.total=v(K.total+(A||0));K.cumulative=B(K.cumulative,a)+(A||0);null!==A&&(K.points[m].push(K.cumulative),n[r]=K.cumulative)}"percent"===g&&(E.usePercentage=!0);this.stackedYData=n;E.oldStacks={}}};H.prototype.modifyStacks=function(){var c=this,f=c.stackKey,n=c.yAxis.stacks,q=c.processedXData,g,b=c.options.stacking;c[b+"Stacker"]&&[f,"-"+f].forEach(function(a){for(var d=q.length,
e,f;d--;)if(e=q[d],g=c.getStackIndicator(g,e,c.index,a),f=(e=n[a]&&n[a][e])&&e.points[g.key])c[b+"Stacker"](f,e,d)})};H.prototype.percentStacker=function(c,f,n){f=f.total?100/f.total:0;c[0]=v(c[0]*f);c[1]=v(c[1]*f);this.stackedYData[n]=c[1]};H.prototype.getStackIndicator=function(c,f,n,q){!F(c)||c.x!==f||q&&c.key!==q?c={x:f,index:0,key:q}:c.index++;c.key=[n,f,c.index].join();return c}});M(I,"parts/Dynamics.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.defined,G=f.erase,
z=f.extend,B=f.isArray,t=f.isNumber,v=f.isObject,C=f.isString,H=f.objectEach,y=f.pick,h=f.setAnimation,n=f.splat,q=c.addEvent,g=c.animate,b=c.Axis;f=c.Chart;var a=c.createElement,d=c.css,e=c.fireEvent,l=c.merge,L=c.Point,E=c.Series,p=c.seriesTypes;c.cleanRecursively=function(a,b){var d={};H(a,function(e,g){if(v(a[g],!0)&&!a.nodeType&&b[g])e=c.cleanRecursively(a[g],b[g]),Object.keys(e).length&&(d[g]=e);else if(v(a[g])||a[g]!==b[g])d[g]=a[g]});return d};z(f.prototype,{addSeries:function(a,b,d){var c,
g=this;a&&(b=y(b,!0),e(g,"addSeries",{options:a},function(){c=g.initSeries(a);g.isDirtyLegend=!0;g.linkSeries();e(g,"afterAddSeries",{series:c});b&&g.redraw(d)}));return c},addAxis:function(a,b,d,c){return this.createAxis(b?"xAxis":"yAxis",{axis:a,redraw:d,animation:c})},addColorAxis:function(a,b,d){return this.createAxis("colorAxis",{axis:a,redraw:b,animation:d})},createAxis:function(a,d){var e=this.options,g="colorAxis"===a,k=d.redraw,f=d.animation;d=l(d.axis,{index:this[a].length,isX:"xAxis"===
a});var h=g?new c.ColorAxis(this,d):new b(this,d);e[a]=n(e[a]||{});e[a].push(d);g&&(this.isDirtyLegend=!0,this.axes.forEach(function(a){a.series=[]}),this.series.forEach(function(a){a.bindAxes();a.isDirtyData=!0}));y(k,!0)&&this.redraw(f);return h},showLoading:function(b){var c=this,e=c.options,f=c.loadingDiv,h=e.loading,l=function(){f&&d(f,{left:c.plotLeft+"px",top:c.plotTop+"px",width:c.plotWidth+"px",height:c.plotHeight+"px"})};f||(c.loadingDiv=f=a("div",{className:"highcharts-loading highcharts-loading-hidden"},
null,c.container),c.loadingSpan=a("span",{className:"highcharts-loading-inner"},null,f),q(c,"redraw",l));f.className="highcharts-loading";c.loadingSpan.innerHTML=y(b,e.lang.loading,"");c.styledMode||(d(f,z(h.style,{zIndex:10})),d(c.loadingSpan,h.labelStyle),c.loadingShown||(d(f,{opacity:0,display:""}),g(f,{opacity:h.style.opacity||.5},{duration:h.showDuration||0})));c.loadingShown=!0;l()},hideLoading:function(){var a=this.options,b=this.loadingDiv;b&&(b.className="highcharts-loading highcharts-loading-hidden",
this.styledMode||g(b,{opacity:0},{duration:a.loading.hideDuration||100,complete:function(){d(b,{display:"none"})}}));this.loadingShown=!1},propsRequireDirtyBox:"backgroundColor borderColor borderWidth borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),propsRequireReflow:"margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft".split(" "),propsRequireUpdateSeries:"chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions time tooltip".split(" "),
collectionsWithUpdate:"xAxis yAxis zAxis colorAxis series pane".split(" "),update:function(a,b,d,g){var k=this,f={credits:"addCredits",title:"setTitle",subtitle:"setSubtitle",caption:"setCaption"},h,p,r,u=a.isResponsiveOptions,q=[];e(k,"update",{options:a});u||k.setResponsive(!1,!0);a=c.cleanRecursively(a,k.options);l(!0,k.userOptions,a);if(h=a.chart){l(!0,k.options.chart,h);"className"in h&&k.setClassName(h.className);"reflow"in h&&k.setReflow(h.reflow);if("inverted"in h||"polar"in h||"type"in h){k.propFromSeries();
var x=!0}"alignTicks"in h&&(x=!0);H(h,function(a,b){-1!==k.propsRequireUpdateSeries.indexOf("chart."+b)&&(p=!0);-1!==k.propsRequireDirtyBox.indexOf(b)&&(k.isDirtyBox=!0);u||-1===k.propsRequireReflow.indexOf(b)||(r=!0)});!k.styledMode&&"style"in h&&k.renderer.setStyle(h.style)}!k.styledMode&&a.colors&&(this.options.colors=a.colors);a.plotOptions&&l(!0,this.options.plotOptions,a.plotOptions);a.time&&this.time===c.time&&(this.time=new c.Time(a.time));H(a,function(a,b){if(k[b]&&"function"===typeof k[b].update)k[b].update(a,
!1);else if("function"===typeof k[f[b]])k[f[b]](a);"chart"!==b&&-1!==k.propsRequireUpdateSeries.indexOf(b)&&(p=!0)});this.collectionsWithUpdate.forEach(function(b){if(a[b]){if("series"===b){var c=[];k[b].forEach(function(a,b){a.options.isInternal||c.push(y(a.options.index,b))})}n(a[b]).forEach(function(a,e){(e=F(a.id)&&k.get(a.id)||k[b][c?c[e]:e])&&e.coll===b&&(e.update(a,!1),d&&(e.touched=!0));!e&&d&&k.collectionsWithInit[b]&&(k.collectionsWithInit[b][0].apply(k,[a].concat(k.collectionsWithInit[b][1]||
[]).concat([!1])).touched=!0)});d&&k[b].forEach(function(a){a.touched||a.options.isInternal?delete a.touched:q.push(a)})}});q.forEach(function(a){a.remove&&a.remove(!1)});x&&k.axes.forEach(function(a){a.update({},!1)});p&&k.series.forEach(function(a){a.update({},!1)});a.loading&&l(!0,k.options.loading,a.loading);x=h&&h.width;h=h&&h.height;C(h)&&(h=c.relativeLength(h,x||k.chartWidth));r||t(x)&&x!==k.chartWidth||t(h)&&h!==k.chartHeight?k.setSize(x,h,g):y(b,!0)&&k.redraw(g);e(k,"afterUpdate",{options:a,
redraw:b,animation:g})},setSubtitle:function(a,b){this.applyDescription("subtitle",a);this.layOutTitles(b)},setCaption:function(a,b){this.applyDescription("caption",a);this.layOutTitles(b)}});f.prototype.collectionsWithInit={xAxis:[f.prototype.addAxis,[!0]],yAxis:[f.prototype.addAxis,[!1]],colorAxis:[f.prototype.addColorAxis,[!1]],series:[f.prototype.addSeries]};z(L.prototype,{update:function(a,b,d,c){function e(){g.applyOptions(a);null===g.y&&f&&(g.graphic=f.destroy());v(a,!0)&&(f&&f.element&&a&&
a.marker&&void 0!==a.marker.symbol&&(g.graphic=f.destroy()),a&&a.dataLabels&&g.dataLabel&&(g.dataLabel=g.dataLabel.destroy()),g.connector&&(g.connector=g.connector.destroy()));h=g.index;k.updateParallelArrays(g,h);p.data[h]=v(p.data[h],!0)||v(a,!0)?g.options:y(a,p.data[h]);k.isDirty=k.isDirtyData=!0;!k.fixedBox&&k.hasCartesianSeries&&(l.isDirtyBox=!0);"point"===p.legendType&&(l.isDirtyLegend=!0);b&&l.redraw(d)}var g=this,k=g.series,f=g.graphic,h,l=k.chart,p=k.options;b=y(b,!0);!1===c?e():g.firePointEvent("update",
{options:a},e)},remove:function(a,b){this.series.removePoint(this.series.data.indexOf(this),a,b)}});z(E.prototype,{addPoint:function(a,b,d,c,g){var k=this.options,f=this.data,h=this.chart,l=this.xAxis;l=l&&l.hasNames&&l.names;var p=k.data,r=this.xData,n;b=y(b,!0);var u={series:this};this.pointClass.prototype.applyOptions.apply(u,[a]);var q=u.x;var x=r.length;if(this.requireSorting&&q<r[x-1])for(n=!0;x&&r[x-1]>q;)x--;this.updateParallelArrays(u,"splice",x,0,0);this.updateParallelArrays(u,x);l&&u.name&&
(l[q]=u.name);p.splice(x,0,a);n&&(this.data.splice(x,0,null),this.processData());"point"===k.legendType&&this.generatePoints();d&&(f[0]&&f[0].remove?f[0].remove(!1):(f.shift(),this.updateParallelArrays(u,"shift"),p.shift()));!1!==g&&e(this,"addPoint",{point:u});this.isDirtyData=this.isDirty=!0;b&&h.redraw(c)},removePoint:function(a,b,d){var c=this,e=c.data,g=e[a],k=c.points,f=c.chart,l=function(){k&&k.length===e.length&&k.splice(a,1);e.splice(a,1);c.options.data.splice(a,1);c.updateParallelArrays(g||
{series:c},"splice",a,1);g&&g.destroy();c.isDirty=!0;c.isDirtyData=!0;b&&f.redraw()};h(d,f);b=y(b,!0);g?g.firePointEvent("remove",null,l):l()},remove:function(a,b,d,c){function g(){k.destroy(c);k.remove=null;f.isDirtyLegend=f.isDirtyBox=!0;f.linkSeries();y(a,!0)&&f.redraw(b)}var k=this,f=k.chart;!1!==d?e(k,"remove",null,g):g()},update:function(a,b){a=c.cleanRecursively(a,this.userOptions);e(this,"update",{options:a});var d=this,g=d.chart,k=d.userOptions,f=d.initialType||d.type,h=a.type||k.type||g.options.chart.type,
n=!(this.hasDerivedData||a.dataGrouping||h&&h!==this.type||void 0!==a.pointStart||a.pointInterval||a.pointIntervalUnit||a.keys),u=p[f].prototype,q,v=["group","markerGroup","dataLabelsGroup","transformGroup"],t=["eventOptions","navigatorSeries","baseSeries"],E=d.finishedAnimating&&{animation:!1},C={};n&&(t.push("data","isDirtyData","points","processedXData","processedYData","xIncrement","_hasPointMarkers","_hasPointLabels","mapMap","mapData","minY","maxY","minX","maxX"),!1!==a.visible&&t.push("area",
"graph"),d.parallelArrays.forEach(function(a){t.push(a+"Data")}),a.data&&this.setData(a.data,!1));a=l(k,E,{index:void 0===k.index?d.index:k.index,pointStart:y(k.pointStart,d.xData[0])},!n&&{data:d.options.data},a);n&&a.data&&(a.data=d.options.data);t=v.concat(t);t.forEach(function(a){t[a]=d[a];delete d[a]});d.remove(!1,null,!1,!0);for(q in u)d[q]=void 0;p[h||f]?z(d,p[h||f].prototype):c.error(17,!0,g,{missingModuleFor:h||f});t.forEach(function(a){d[a]=t[a]});d.init(g,a);if(n&&this.points){var L=d.options;
!1===L.visible?(C.graphic=1,C.dataLabel=1):d._hasPointLabels||(h=L.marker,u=L.dataLabels,h&&(!1===h.enabled||"symbol"in h)&&(C.graphic=1),u&&!1===u.enabled&&(C.dataLabel=1));this.points.forEach(function(a){a&&a.series&&(a.resolveColor(),Object.keys(C).length&&a.destroyElements(C),!1===L.showInLegend&&a.legendItem&&g.legend.destroyItem(a))},this)}a.zIndex!==k.zIndex&&v.forEach(function(b){d[b]&&d[b].attr({zIndex:a.zIndex})});d.initialType=f;g.linkSeries();e(this,"afterUpdate");y(b,!0)&&g.redraw(n?
void 0:!1)},setName:function(a){this.name=this.options.name=this.userOptions.name=a;this.chart.isDirtyLegend=!0}});z(b.prototype,{update:function(a,b){var d=this.chart,c=a&&a.events||{};a=l(this.userOptions,a);d.options[this.coll].indexOf&&(d.options[this.coll][d.options[this.coll].indexOf(this.userOptions)]=a);H(d.options[this.coll].events,function(a,b){"undefined"===typeof c[b]&&(c[b]=void 0)});this.destroy(!0);this.init(d,z(a,{events:c}));d.isDirtyBox=!0;y(b,!0)&&d.redraw()},remove:function(a){for(var b=
this.chart,d=this.coll,c=this.series,e=c.length;e--;)c[e]&&c[e].remove(!1);G(b.axes,this);G(b[d],this);B(b.options[d])?b.options[d].splice(this.options.index,1):delete b.options[d];b[d].forEach(function(a,b){a.options.index=a.userOptions.index=b});this.destroy();b.isDirtyBox=!0;y(a,!0)&&b.redraw()},setTitle:function(a,b){this.update({title:a},b)},setCategories:function(a,b){this.update({categories:a},b)}})});M(I,"parts/AreaSeries.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=
f.objectEach,G=f.pick,z=c.color,B=c.Series;f=c.seriesType;f("area","line",{softThreshold:!1,threshold:0},{singleStacks:!1,getStackPoints:function(c){var f=[],t=[],z=this.xAxis,y=this.yAxis,h=y.stacks[this.stackKey],n={},q=this.index,g=y.series,b=g.length,a=G(y.options.reversedStacks,!0)?1:-1,d;c=c||this.points;if(this.options.stacking){for(d=0;d<c.length;d++)c[d].leftNull=c[d].rightNull=void 0,n[c[d].x]=c[d];F(h,function(a,b){null!==a.total&&t.push(b)});t.sort(function(a,b){return a-b});var e=g.map(function(a){return a.visible});
t.forEach(function(c,g){var l=0,p,u;if(n[c]&&!n[c].isNull)f.push(n[c]),[-1,1].forEach(function(k){var f=1===k?"rightNull":"leftNull",l=0,v=h[t[g+k]];if(v)for(d=q;0<=d&&d<b;)p=v.points[d],p||(d===q?n[c][f]=!0:e[d]&&(u=h[c].points[d])&&(l-=u[1]-u[0])),d+=a;n[c][1===k?"rightCliff":"leftCliff"]=l});else{for(d=q;0<=d&&d<b;){if(p=h[c].points[d]){l=p[1];break}d+=a}l=y.translate(l,0,1,0,1);f.push({isNull:!0,plotX:z.translate(c,0,0,0,1),x:c,plotY:l,yBottom:l})}})}return f},getGraphPath:function(c){var f=B.prototype.getGraphPath,
t=this.options,z=t.stacking,y=this.yAxis,h,n=[],q=[],g=this.index,b=y.stacks[this.stackKey],a=t.threshold,d=Math.round(y.getThreshold(t.threshold));t=G(t.connectNulls,"percent"===z);var e=function(e,f,k){var h=c[e];e=z&&b[h.x].points[g];var l=h[k+"Null"]||0;k=h[k+"Cliff"]||0;h=!0;if(k||l){var p=(l?e[0]:e[1])+k;var u=e[0]+k;h=!!l}else!z&&c[f]&&c[f].isNull&&(p=u=a);void 0!==p&&(q.push({plotX:L,plotY:null===p?d:y.getThreshold(p),isNull:h,isCliff:!0}),n.push({plotX:L,plotY:null===u?d:y.getThreshold(u),
doCurve:!1}))};c=c||this.points;z&&(c=this.getStackPoints(c));for(h=0;h<c.length;h++){z||(c[h].leftCliff=c[h].rightCliff=c[h].leftNull=c[h].rightNull=void 0);var l=c[h].isNull;var L=G(c[h].rectPlotX,c[h].plotX);var E=G(c[h].yBottom,d);if(!l||t)t||e(h,h-1,"left"),l&&!z&&t||(q.push(c[h]),n.push({x:h,plotX:L,plotY:E})),t||e(h,h+1,"right")}h=f.call(this,q,!0,!0);n.reversed=!0;l=f.call(this,n,!0,!0);l.length&&(l[0]="L");l=h.concat(l);f=f.call(this,q,!1,t);l.xMap=h.xMap;this.areaPath=l;return f},drawGraph:function(){this.areaPath=
[];B.prototype.drawGraph.apply(this);var c=this,f=this.areaPath,C=this.options,H=[["area","highcharts-area",this.color,C.fillColor]];this.zones.forEach(function(f,h){H.push(["zone-area-"+h,"highcharts-area highcharts-zone-area-"+h+" "+f.className,f.color||c.color,f.fillColor||C.fillColor])});H.forEach(function(v){var h=v[0],n=c[h],q=n?"animate":"attr",g={};n?(n.endX=c.preventGraphAnimation?null:f.xMap,n.animate({d:f})):(g.zIndex=0,n=c[h]=c.chart.renderer.path(f).addClass(v[1]).add(c.group),n.isArea=
!0);c.chart.styledMode||(g.fill=G(v[3],z(v[2]).setOpacity(G(C.fillOpacity,.75)).get()));n[q](g);n.startX=f.xMap;n.shiftUnit=C.step?2:1})},drawLegendSymbol:c.LegendSymbolMixin.drawRectangle});""});M(I,"parts/SplineSeries.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.pick;c=c.seriesType;c("spline","line",{},{getPointSpline:function(c,f,B){var t=f.plotX,v=f.plotY,C=c[B-1];B=c[B+1];if(C&&!C.isNull&&!1!==C.doCurve&&!f.isCliff&&B&&!B.isNull&&!1!==B.doCurve&&!f.isCliff){c=C.plotY;
var z=B.plotX;B=B.plotY;var y=0;var h=(1.5*t+C.plotX)/2.5;var n=(1.5*v+c)/2.5;z=(1.5*t+z)/2.5;var q=(1.5*v+B)/2.5;z!==h&&(y=(q-n)*(z-t)/(z-h)+v-q);n+=y;q+=y;n>c&&n>v?(n=Math.max(c,v),q=2*v-n):n<c&&n<v&&(n=Math.min(c,v),q=2*v-n);q>B&&q>v?(q=Math.max(B,v),n=2*v-q):q<B&&q<v&&(q=Math.min(B,v),n=2*v-q);f.rightContX=z;f.rightContY=q}f=["C",F(C.rightContX,C.plotX),F(C.rightContY,C.plotY),F(h,t),F(n,v),t,v];C.rightContX=C.rightContY=null;return f}});""});M(I,"parts/AreaSplineSeries.js",[I["parts/Globals.js"]],
function(c){var f=c.seriesTypes.area.prototype,F=c.seriesType;F("areaspline","spline",c.defaultPlotOptions.area,{getStackPoints:f.getStackPoints,getGraphPath:f.getGraphPath,drawGraph:f.drawGraph,drawLegendSymbol:c.LegendSymbolMixin.drawRectangle});""});M(I,"parts/ColumnSeries.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.defined,G=f.extend,z=f.isNumber,B=f.pick,t=c.animObject,v=c.color,C=c.merge,H=c.Series;f=c.seriesType;var y=c.svg;f("column","line",{borderRadius:0,crisp:!0,
groupPadding:.2,marker:null,pointPadding:.1,minPointLength:0,cropThreshold:50,pointRange:null,states:{hover:{halo:!1,brightness:.1},select:{color:"#cccccc",borderColor:"#000000"}},dataLabels:{align:null,verticalAlign:null,y:null},softThreshold:!1,startFromThreshold:!0,stickyTracking:!1,tooltip:{distance:6},threshold:0,borderColor:"#ffffff"},{cropShoulder:0,directTouch:!0,trackerGroups:["group","dataLabelsGroup"],negStacks:!0,init:function(){H.prototype.init.apply(this,arguments);var c=this,f=c.chart;
f.hasRendered&&f.series.forEach(function(f){f.type===c.type&&(f.isDirty=!0)})},getColumnMetrics:function(){var c=this,f=c.options,q=c.xAxis,g=c.yAxis,b=q.options.reversedStacks;b=q.reversed&&!b||!q.reversed&&b;var a,d={},e=0;!1===f.grouping?e=1:c.chart.series.forEach(function(b){var f=b.yAxis,k=b.options;if(b.type===c.type&&(b.visible||!c.chart.options.chart.ignoreHiddenSeries)&&g.len===f.len&&g.pos===f.pos){if(k.stacking){a=b.stackKey;void 0===d[a]&&(d[a]=e++);var h=d[a]}else!1!==k.grouping&&(h=
e++);b.columnIndex=h}});var l=Math.min(Math.abs(q.transA)*(q.ordinalSlope||f.pointRange||q.closestPointRange||q.tickInterval||1),q.len),v=l*f.groupPadding,t=(l-2*v)/(e||1);f=Math.min(f.maxPointWidth||q.len,B(f.pointWidth,t*(1-2*f.pointPadding)));c.columnMetrics={width:f,offset:(t-f)/2+(v+((c.columnIndex||0)+(b?1:0))*t-l/2)*(b?-1:1)};return c.columnMetrics},crispCol:function(c,f,q,g){var b=this.chart,a=this.borderWidth,d=-(a%2?.5:0);a=a%2?.5:1;b.inverted&&b.renderer.isVML&&(a+=1);this.options.crisp&&
(q=Math.round(c+q)+d,c=Math.round(c)+d,q-=c);g=Math.round(f+g)+a;d=.5>=Math.abs(f)&&.5<g;f=Math.round(f)+a;g-=f;d&&g&&(--f,g+=1);return{x:c,y:f,width:q,height:g}},translate:function(){var c=this,f=c.chart,q=c.options,g=c.dense=2>c.closestPointRange*c.xAxis.transA;g=c.borderWidth=B(q.borderWidth,g?0:1);var b=c.yAxis,a=q.threshold,d=c.translatedThreshold=b.getThreshold(a),e=B(q.minPointLength,5),l=c.getColumnMetrics(),v=l.width,t=c.barW=Math.max(v,1+2*g),p=c.pointXOffset=l.offset,u=c.dataMin,k=c.dataMax;
f.inverted&&(d-=.5);q.pointPadding&&(t=Math.ceil(t));H.prototype.translate.apply(c);c.points.forEach(function(g){var h=B(g.yBottom,d),l=999+Math.abs(h),r=v;l=Math.min(Math.max(-l,g.plotY),b.len+l);var m=g.plotX+p,n=t,q=Math.min(l,h),y=Math.max(l,h)-q;if(e&&Math.abs(y)<e){y=e;var E=!b.reversed&&!g.negative||b.reversed&&g.negative;g.y===a&&c.dataMax<=a&&b.min<a&&u!==k&&(E=!E);q=Math.abs(q-d)>e?h-e:d-(E?e:0)}F(g.options.pointWidth)&&(r=n=Math.ceil(g.options.pointWidth),m-=Math.round((r-v)/2));g.barX=
m;g.pointWidth=r;g.tooltipPos=f.inverted?[b.len+b.pos-f.plotLeft-l,c.xAxis.len-m-n/2,y]:[m+n/2,l+b.pos-f.plotTop,y];g.shapeType=c.pointClass.prototype.shapeType||"rect";g.shapeArgs=c.crispCol.apply(c,g.isNull?[m,d,n,0]:[m,q,n,y])})},getSymbol:c.noop,drawLegendSymbol:c.LegendSymbolMixin.drawRectangle,drawGraph:function(){this.group[this.dense?"addClass":"removeClass"]("highcharts-dense-data")},pointAttribs:function(c,f){var h=this.options,g=this.pointAttrToOptions||{};var b=g.stroke||"borderColor";
var a=g["stroke-width"]||"borderWidth",d=c&&c.color||this.color,e=c&&c[b]||h[b]||this.color||d,l=c&&c[a]||h[a]||this[a]||0;g=c&&c.options.dashStyle||h.dashStyle;var n=B(h.opacity,1);if(c&&this.zones.length){var t=c.getZone();d=c.options.color||t&&(t.color||c.nonZonedColor)||this.color;t&&(e=t.borderColor||e,g=t.dashStyle||g,l=t.borderWidth||l)}f&&(c=C(h.states[f],c.options.states&&c.options.states[f]||{}),f=c.brightness,d=c.color||void 0!==f&&v(d).brighten(c.brightness).get()||d,e=c[b]||e,l=c[a]||
l,g=c.dashStyle||g,n=B(c.opacity,n));b={fill:d,stroke:e,"stroke-width":l,opacity:n};g&&(b.dashstyle=g);return b},drawPoints:function(){var c=this,f=this.chart,q=c.options,g=f.renderer,b=q.animationLimit||250,a;c.points.forEach(function(d){var e=d.graphic,l=e&&f.pointCount<b?"animate":"attr";if(z(d.plotY)&&null!==d.y){a=d.shapeArgs;e&&d.hasNewShapeType()&&(e=e.destroy());if(e)e[l](C(a));else d.graphic=e=g[d.shapeType](a).add(d.group||c.group);if(q.borderRadius)e[l]({r:q.borderRadius});f.styledMode||
e[l](c.pointAttribs(d,d.selected&&"select")).shadow(!1!==d.allowShadow&&q.shadow,null,q.stacking&&!q.borderRadius);e.addClass(d.getClassName(),!0)}else e&&(d.graphic=e.destroy())})},animate:function(c){var f=this,h=this.yAxis,g=f.options,b=this.chart.inverted,a={},d=b?"translateX":"translateY";if(y)if(c)a.scaleY=.001,c=Math.min(h.pos+h.len,Math.max(h.pos,h.toPixels(g.threshold))),b?a.translateX=c-h.len:a.translateY=c,f.clipBox&&f.setClip(),f.group.attr(a);else{var e=f.group.attr(d);f.group.animate({scaleY:1},
G(t(f.options.animation),{step:function(b,c){a[d]=e+c.pos*(h.pos-e);f.group.attr(a)}}));f.animate=null}},remove:function(){var c=this,f=c.chart;f.hasRendered&&f.series.forEach(function(f){f.type===c.type&&(f.isDirty=!0)});H.prototype.remove.apply(c,arguments)}});""});M(I,"parts/BarSeries.js",[I["parts/Globals.js"]],function(c){c=c.seriesType;c("bar","column",null,{inverted:!0});""});M(I,"parts/ScatterSeries.js",[I["parts/Globals.js"]],function(c){var f=c.Series,F=c.seriesType;F("scatter","line",{lineWidth:0,
findNearestPointBy:"xy",jitter:{x:0,y:0},marker:{enabled:!0},tooltip:{headerFormat:'<span style="color:{point.color}">\u25cf</span> <span style="font-size: 10px"> {series.name}</span><br/>',pointFormat:"x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>"}},{sorted:!1,requireSorting:!1,noSharedTooltip:!0,trackerGroups:["group","markerGroup","dataLabelsGroup"],takeOrdinalPosition:!1,drawGraph:function(){this.options.lineWidth&&f.prototype.drawGraph.call(this)},applyJitter:function(){var c=this,f=this.options.jitter,
B=this.points.length;f&&this.points.forEach(function(t,v){["x","y"].forEach(function(C,z){var y="plot"+C.toUpperCase();if(f[C]&&!t.isNull){var h=c[C+"Axis"];var n=f[C]*h.transA;if(h&&!h.isLog){var q=Math.max(0,t[y]-n);h=Math.min(h.len,t[y]+n);z=1E4*Math.sin(v+z*B);t[y]=q+(h-q)*(z-Math.floor(z));"x"===C&&(t.clientX=t.plotX)}}})})}});c.addEvent(f,"afterTranslate",function(){this.applyJitter&&this.applyJitter()});""});M(I,"mixins/centered-series.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,
f){var F=f.isNumber,G=f.pick,z=c.deg2rad,B=c.relativeLength;c.CenteredSeriesMixin={getCenter:function(){var c=this.options,f=this.chart,C=2*(c.slicedOffset||0),z=f.plotWidth-2*C;f=f.plotHeight-2*C;var y=c.center;y=[G(y[0],"50%"),G(y[1],"50%"),c.size||"100%",c.innerSize||0];var h=Math.min(z,f),n;for(n=0;4>n;++n){var q=y[n];c=2>n||2===n&&/%$/.test(q);y[n]=B(q,[z,f,h,y[2]][n])+(c?C:0)}y[3]>y[2]&&(y[3]=y[2]);return y},getStartAndEndRadians:function(c,f){c=F(c)?c:0;f=F(f)&&f>c&&360>f-c?f:c+360;return{start:z*
(c+-90),end:z*(f+-90)}}}});M(I,"parts/PieSeries.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.defined,G=f.isNumber,z=f.pick,B=f.setAnimation,t=c.addEvent;f=c.CenteredSeriesMixin;var v=f.getStartAndEndRadians,C=c.merge,H=c.noop,y=c.Point,h=c.Series,n=c.seriesType,q=c.fireEvent;n("pie","line",{center:[null,null],clip:!1,colorByPoint:!0,dataLabels:{allowOverlap:!0,connectorPadding:5,distance:30,enabled:!0,formatter:function(){return this.point.isNull?void 0:this.point.name},
softConnector:!0,x:0,connectorShape:"fixedOffset",crookDistance:"70%"},fillColor:void 0,ignoreHiddenPoint:!0,inactiveOtherPoints:!0,legendType:"point",marker:null,size:null,showInLegend:!1,slicedOffset:10,stickyTracking:!1,tooltip:{followPointer:!0},borderColor:"#ffffff",borderWidth:1,lineWidth:void 0,states:{hover:{brightness:.1}}},{isCartesian:!1,requireSorting:!1,directTouch:!0,noSharedTooltip:!0,trackerGroups:["group","dataLabelsGroup"],axisTypes:[],pointAttribs:c.seriesTypes.column.prototype.pointAttribs,
animate:function(c){var b=this,a=b.points,d=b.startAngleRad;c||(a.forEach(function(a){var c=a.graphic,e=a.shapeArgs;c&&(c.attr({r:a.startR||b.center[3]/2,start:d,end:d}),c.animate({r:e.r,start:e.start,end:e.end},b.options.animation))}),b.animate=null)},hasData:function(){return!!this.processedXData.length},updateTotals:function(){var c,b=0,a=this.points,d=a.length,e=this.options.ignoreHiddenPoint;for(c=0;c<d;c++){var f=a[c];b+=e&&!f.visible?0:f.isNull?0:f.y}this.total=b;for(c=0;c<d;c++)f=a[c],f.percentage=
0<b&&(f.visible||!e)?f.y/b*100:0,f.total=b},generatePoints:function(){h.prototype.generatePoints.call(this);this.updateTotals()},getX:function(c,b,a){var d=this.center,e=this.radii?this.radii[a.index]:d[2]/2;return d[0]+(b?-1:1)*Math.cos(Math.asin(Math.max(Math.min((c-d[1])/(e+a.labelDistance),1),-1)))*(e+a.labelDistance)+(0<a.labelDistance?(b?-1:1)*this.options.dataLabels.padding:0)},translate:function(g){this.generatePoints();var b=0,a=this.options,d=a.slicedOffset,e=d+(a.borderWidth||0),f=v(a.startAngle,
a.endAngle),h=this.startAngleRad=f.start;f=(this.endAngleRad=f.end)-h;var n=this.points,p=a.dataLabels.distance;a=a.ignoreHiddenPoint;var u,k=n.length;g||(this.center=g=this.getCenter());for(u=0;u<k;u++){var r=n[u];var x=h+b*f;if(!a||r.visible)b+=r.percentage/100;var A=h+b*f;r.shapeType="arc";r.shapeArgs={x:g[0],y:g[1],r:g[2]/2,innerR:g[3]/2,start:Math.round(1E3*x)/1E3,end:Math.round(1E3*A)/1E3};r.labelDistance=z(r.options.dataLabels&&r.options.dataLabels.distance,p);r.labelDistance=c.relativeLength(r.labelDistance,
r.shapeArgs.r);this.maxLabelDistance=Math.max(this.maxLabelDistance||0,r.labelDistance);A=(A+x)/2;A>1.5*Math.PI?A-=2*Math.PI:A<-Math.PI/2&&(A+=2*Math.PI);r.slicedTranslation={translateX:Math.round(Math.cos(A)*d),translateY:Math.round(Math.sin(A)*d)};var w=Math.cos(A)*g[2]/2;var m=Math.sin(A)*g[2]/2;r.tooltipPos=[g[0]+.7*w,g[1]+.7*m];r.half=A<-Math.PI/2||A>Math.PI/2?1:0;r.angle=A;x=Math.min(e,r.labelDistance/5);r.labelPosition={natural:{x:g[0]+w+Math.cos(A)*r.labelDistance,y:g[1]+m+Math.sin(A)*r.labelDistance},
"final":{},alignment:0>r.labelDistance?"center":r.half?"right":"left",connectorPosition:{breakAt:{x:g[0]+w+Math.cos(A)*x,y:g[1]+m+Math.sin(A)*x},touchingSliceAt:{x:g[0]+w,y:g[1]+m}}}}q(this,"afterTranslate")},drawEmpty:function(){var c=this.options;if(0===this.total){var b=this.center[0];var a=this.center[1];this.graph||(this.graph=this.chart.renderer.circle(b,a,0).addClass("highcharts-graph").add(this.group));this.graph.animate({"stroke-width":c.borderWidth,cx:b,cy:a,r:this.center[2]/2,fill:c.fillColor||
"none",stroke:c.color||"#cccccc"})}else this.graph&&(this.graph=this.graph.destroy())},redrawPoints:function(){var c=this,b=c.chart,a=b.renderer,d,e,f,h,n=c.options.shadow;this.drawEmpty();!n||c.shadowGroup||b.styledMode||(c.shadowGroup=a.g("shadow").attr({zIndex:-1}).add(c.group));c.points.forEach(function(g){var l={};e=g.graphic;if(!g.isNull&&e){h=g.shapeArgs;d=g.getTranslate();if(!b.styledMode){var k=g.shadowGroup;n&&!k&&(k=g.shadowGroup=a.g("shadow").add(c.shadowGroup));k&&k.attr(d);f=c.pointAttribs(g,
g.selected&&"select")}g.delayedRendering?(e.setRadialReference(c.center).attr(h).attr(d),b.styledMode||e.attr(f).attr({"stroke-linejoin":"round"}).shadow(n,k),g.delayedRendering=!1):(e.setRadialReference(c.center),b.styledMode||C(!0,l,f),C(!0,l,h,d),e.animate(l));e.attr({visibility:g.visible?"inherit":"hidden"});e.addClass(g.getClassName())}else e&&(g.graphic=e.destroy())})},drawPoints:function(){var c=this.chart.renderer;this.points.forEach(function(b){b.graphic||(b.graphic=c[b.shapeType](b.shapeArgs).add(b.series.group),
b.delayedRendering=!0)})},searchPoint:H,sortByAngle:function(c,b){c.sort(function(a,d){return void 0!==a.angle&&(d.angle-a.angle)*b})},drawLegendSymbol:c.LegendSymbolMixin.drawRectangle,getCenter:f.getCenter,getSymbol:H,drawGraph:null},{init:function(){y.prototype.init.apply(this,arguments);var c=this;c.name=z(c.name,"Slice");var b=function(a){c.slice("select"===a.type)};t(c,"select",b);t(c,"unselect",b);return c},isValid:function(){return G(this.y)&&0<=this.y},setVisible:function(c,b){var a=this,
d=a.series,e=d.chart,f=d.options.ignoreHiddenPoint;b=z(b,f);c!==a.visible&&(a.visible=a.options.visible=c=void 0===c?!a.visible:c,d.options.data[d.data.indexOf(a)]=a.options,["graphic","dataLabel","connector","shadowGroup"].forEach(function(b){if(a[b])a[b][c?"show":"hide"](!0)}),a.legendItem&&e.legend.colorizeItem(a,c),c||"hover"!==a.state||a.setState(""),f&&(d.isDirty=!0),b&&e.redraw())},slice:function(c,b,a){var d=this.series;B(a,d.chart);z(b,!0);this.sliced=this.options.sliced=F(c)?c:!this.sliced;
d.options.data[d.data.indexOf(this)]=this.options;this.graphic.animate(this.getTranslate());this.shadowGroup&&this.shadowGroup.animate(this.getTranslate())},getTranslate:function(){return this.sliced?this.slicedTranslation:{translateX:0,translateY:0}},haloPath:function(c){var b=this.shapeArgs;return this.sliced||!this.visible?[]:this.series.chart.renderer.symbols.arc(b.x,b.y,b.r+c,b.r+c,{innerR:b.r-1,start:b.start,end:b.end})},connectorShapes:{fixedOffset:function(c,b,a){var d=b.breakAt;b=b.touchingSliceAt;
return["M",c.x,c.y].concat(a.softConnector?["C",c.x+("left"===c.alignment?-5:5),c.y,2*d.x-b.x,2*d.y-b.y,d.x,d.y]:["L",d.x,d.y]).concat(["L",b.x,b.y])},straight:function(c,b){b=b.touchingSliceAt;return["M",c.x,c.y,"L",b.x,b.y]},crookedLine:function(f,b,a){b=b.touchingSliceAt;var d=this.series,e=d.center[0],g=d.chart.plotWidth,h=d.chart.plotLeft;d=f.alignment;var n=this.shapeArgs.r;a=c.relativeLength(a.crookDistance,1);a="left"===d?e+n+(g+h-e-n)*(1-a):h+(e-n)*a;e=["L",a,f.y];if("left"===d?a>f.x||a<
b.x:a<f.x||a>b.x)e=[];return["M",f.x,f.y].concat(e).concat(["L",b.x,b.y])}},getConnectorPath:function(){var c=this.labelPosition,b=this.series.options.dataLabels,a=b.connectorShape,d=this.connectorShapes;d[a]&&(a=d[a]);return a.call(this,{x:c.final.x,y:c.final.y,alignment:c.alignment},c.connectorPosition,b)}});""});M(I,"parts/DataLabels.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.arrayMax,G=f.defined,z=f.extend,B=f.isArray,t=f.objectEach,v=f.pick,C=f.splat,H=c.format,
y=c.merge;f=c.noop;var h=c.relativeLength,n=c.Series,q=c.seriesTypes,g=c.stableSort;c.distribute=function(b,a,d){function e(a,b){return a.target-b.target}var f,h=!0,n=b,p=[];var u=0;var k=n.reducedLen||a;for(f=b.length;f--;)u+=b[f].size;if(u>k){g(b,function(a,b){return(b.rank||0)-(a.rank||0)});for(u=f=0;u<=k;)u+=b[f].size,f++;p=b.splice(f-1,b.length)}g(b,e);for(b=b.map(function(a){return{size:a.size,targets:[a.target],align:v(a.align,.5)}});h;){for(f=b.length;f--;)h=b[f],u=(Math.min.apply(0,h.targets)+
Math.max.apply(0,h.targets))/2,h.pos=Math.min(Math.max(0,u-h.size*h.align),a-h.size);f=b.length;for(h=!1;f--;)0<f&&b[f-1].pos+b[f-1].size>b[f].pos&&(b[f-1].size+=b[f].size,b[f-1].targets=b[f-1].targets.concat(b[f].targets),b[f-1].align=.5,b[f-1].pos+b[f-1].size>a&&(b[f-1].pos=a-b[f-1].size),b.splice(f,1),h=!0)}n.push.apply(n,p);f=0;b.some(function(b){var e=0;if(b.targets.some(function(){n[f].pos=b.pos+e;if(Math.abs(n[f].pos-n[f].target)>d)return n.slice(0,f+1).forEach(function(a){delete a.pos}),n.reducedLen=
(n.reducedLen||a)-.1*a,n.reducedLen>.1*a&&c.distribute(n,a,d),!0;e+=n[f].size;f++}))return!0});g(n,e)};n.prototype.drawDataLabels=function(){function b(a,b){var d=b.filter;return d?(b=d.operator,a=a[d.property],d=d.value,">"===b&&a>d||"<"===b&&a<d||">="===b&&a>=d||"<="===b&&a<=d||"=="===b&&a==d||"==="===b&&a===d?!0:!1):!0}function a(a,b){var d=[],c;if(B(a)&&!B(b))d=a.map(function(a){return y(a,b)});else if(B(b)&&!B(a))d=b.map(function(b){return y(a,b)});else if(B(a)||B(b))for(c=Math.max(a.length,
b.length);c--;)d[c]=y(a[c],b[c]);else d=y(a,b);return d}var d=this,e=d.chart,f=d.options,g=f.dataLabels,h=d.points,p,n=d.hasRendered||0,k=c.animObject(f.animation).duration,r=Math.min(k,200),q=!e.renderer.forExport&&v(g.defer,0<r),A=e.renderer;g=a(a(e.options.plotOptions&&e.options.plotOptions.series&&e.options.plotOptions.series.dataLabels,e.options.plotOptions&&e.options.plotOptions[d.type]&&e.options.plotOptions[d.type].dataLabels),g);c.fireEvent(this,"drawDataLabels");if(B(g)||g.enabled||d._hasPointLabels){var w=
d.plotGroup("dataLabelsGroup","data-labels",q&&!n?"hidden":"inherit",g.zIndex||6);q&&(w.attr({opacity:+n}),n||setTimeout(function(){var a=d.dataLabelsGroup;a&&(d.visible&&w.show(!0),a[f.animation?"animate":"attr"]({opacity:1},{duration:r}))},k-r));h.forEach(function(c){p=C(a(g,c.dlOptions||c.options&&c.options.dataLabels));p.forEach(function(a,g){var k=a.enabled&&(!c.isNull||c.dataLabelOnNull)&&b(c,a),h=c.dataLabels?c.dataLabels[g]:c.dataLabel,l=c.connectors?c.connectors[g]:c.connector,p=v(a.distance,
c.labelDistance),m=!h;if(k){var n=c.getLabelConfig();var r=v(a[c.formatPrefix+"Format"],a.format);n=G(r)?H(r,n,e.time):(a[c.formatPrefix+"Formatter"]||a.formatter).call(n,a);r=a.style;var u=a.rotation;e.styledMode||(r.color=v(a.color,r.color,d.color,"#000000"),"contrast"===r.color&&(c.contrastColor=A.getContrast(c.color||d.color),r.color=!G(p)&&a.inside||0>p||f.stacking?c.contrastColor:"#000000"),f.cursor&&(r.cursor=f.cursor));var q={r:a.borderRadius||0,rotation:u,padding:a.padding,zIndex:1};e.styledMode||
(q.fill=a.backgroundColor,q.stroke=a.borderColor,q["stroke-width"]=a.borderWidth);t(q,function(a,b){void 0===a&&delete q[b]})}!h||k&&G(n)?k&&G(n)&&(h?q.text=n:(c.dataLabels=c.dataLabels||[],h=c.dataLabels[g]=u?A.text(n,0,-9999).addClass("highcharts-data-label"):A.label(n,0,-9999,a.shape,null,null,a.useHTML,null,"data-label"),g||(c.dataLabel=h),h.addClass(" highcharts-data-label-color-"+c.colorIndex+" "+(a.className||"")+(a.useHTML?" highcharts-tracker":""))),h.options=a,h.attr(q),e.styledMode||h.css(r).shadow(a.shadow),
h.added||h.add(w),a.textPath&&!a.useHTML&&h.setTextPath(c.getDataLabelPath&&c.getDataLabelPath(h)||c.graphic,a.textPath),d.alignDataLabel(c,h,a,null,m)):(c.dataLabel=c.dataLabel&&c.dataLabel.destroy(),c.dataLabels&&(1===c.dataLabels.length?delete c.dataLabels:delete c.dataLabels[g]),g||delete c.dataLabel,l&&(c.connector=c.connector.destroy(),c.connectors&&(1===c.connectors.length?delete c.connectors:delete c.connectors[g])))})})}c.fireEvent(this,"afterDrawDataLabels")};n.prototype.alignDataLabel=
function(b,a,d,c,f){var e=this.chart,g=this.isCartesian&&e.inverted,h=v(b.dlBox&&b.dlBox.centerX,b.plotX,-9999),l=v(b.plotY,-9999),k=a.getBBox(),n=d.rotation,q=d.align,A=this.visible&&(b.series.forceDL||e.isInsidePlot(h,Math.round(l),g)||c&&e.isInsidePlot(h,g?c.x+1:c.y+c.height-1,g)),w="justify"===v(d.overflow,"justify");if(A){var m=e.renderer.fontMetrics(e.styledMode?void 0:d.style.fontSize,a).b;c=z({x:g?this.yAxis.len-l:h,y:Math.round(g?this.xAxis.len-h:l),width:0,height:0},c);z(d,{width:k.width,
height:k.height});n?(w=!1,h=e.renderer.rotCorr(m,n),h={x:c.x+d.x+c.width/2+h.x,y:c.y+d.y+{top:0,middle:.5,bottom:1}[d.verticalAlign]*c.height},a[f?"attr":"animate"](h).attr({align:q}),l=(n+720)%360,l=180<l&&360>l,"left"===q?h.y-=l?k.height:0:"center"===q?(h.x-=k.width/2,h.y-=k.height/2):"right"===q&&(h.x-=k.width,h.y-=l?0:k.height),a.placed=!0,a.alignAttr=h):(a.align(d,null,c),h=a.alignAttr);w&&0<=c.height?this.justifyDataLabel(a,d,h,k,c,f):v(d.crop,!0)&&(A=e.isInsidePlot(h.x,h.y)&&e.isInsidePlot(h.x+
k.width,h.y+k.height));if(d.shape&&!n)a[f?"attr":"animate"]({anchorX:g?e.plotWidth-b.plotY:b.plotX,anchorY:g?e.plotHeight-b.plotX:b.plotY})}A||(a.hide(!0),a.placed=!1)};n.prototype.justifyDataLabel=function(b,a,d,c,f,g){var e=this.chart,h=a.align,l=a.verticalAlign,k=b.box?0:b.padding||0;var n=d.x+k;if(0>n){"right"===h?(a.align="left",a.inside=!0):a.x=-n;var q=!0}n=d.x+c.width-k;n>e.plotWidth&&("left"===h?(a.align="right",a.inside=!0):a.x=e.plotWidth-n,q=!0);n=d.y+k;0>n&&("bottom"===l?(a.verticalAlign=
"top",a.inside=!0):a.y=-n,q=!0);n=d.y+c.height-k;n>e.plotHeight&&("top"===l?(a.verticalAlign="bottom",a.inside=!0):a.y=e.plotHeight-n,q=!0);q&&(b.placed=!g,b.align(a,null,f));return q};q.pie&&(q.pie.prototype.dataLabelPositioners={radialDistributionY:function(b){return b.top+b.distributeBox.pos},radialDistributionX:function(b,a,d,c){return b.getX(d<a.top+2||d>a.bottom-2?c:d,a.half,a)},justify:function(b,a,d){return d[0]+(b.half?-1:1)*(a+b.labelDistance)},alignToPlotEdges:function(b,a,d,c){b=b.getBBox().width;
return a?b+c:d-b-c},alignToConnectors:function(b,a,d,c){var e=0,f;b.forEach(function(a){f=a.dataLabel.getBBox().width;f>e&&(e=f)});return a?e+c:d-e-c}},q.pie.prototype.drawDataLabels=function(){var b=this,a=b.data,d,e=b.chart,f=b.options.dataLabels,g=f.connectorPadding,h,p=e.plotWidth,u=e.plotHeight,k=e.plotLeft,r=Math.round(e.chartWidth/3),q,A=b.center,w=A[2]/2,m=A[1],t,z,C,B,H=[[],[]],I,D,N,M,R=[0,0,0,0],P=b.dataLabelPositioners,W;b.visible&&(f.enabled||b._hasPointLabels)&&(a.forEach(function(a){a.dataLabel&&
a.visible&&a.dataLabel.shortened&&(a.dataLabel.attr({width:"auto"}).css({width:"auto",textOverflow:"clip"}),a.dataLabel.shortened=!1)}),n.prototype.drawDataLabels.apply(b),a.forEach(function(a){a.dataLabel&&(a.visible?(H[a.half].push(a),a.dataLabel._pos=null,!G(f.style.width)&&!G(a.options.dataLabels&&a.options.dataLabels.style&&a.options.dataLabels.style.width)&&a.dataLabel.getBBox().width>r&&(a.dataLabel.css({width:.7*r}),a.dataLabel.shortened=!0)):(a.dataLabel=a.dataLabel.destroy(),a.dataLabels&&
1===a.dataLabels.length&&delete a.dataLabels))}),H.forEach(function(a,h){var l=a.length,n=[],r;if(l){b.sortByAngle(a,h-.5);if(0<b.maxLabelDistance){var q=Math.max(0,m-w-b.maxLabelDistance);var x=Math.min(m+w+b.maxLabelDistance,e.plotHeight);a.forEach(function(a){0<a.labelDistance&&a.dataLabel&&(a.top=Math.max(0,m-w-a.labelDistance),a.bottom=Math.min(m+w+a.labelDistance,e.plotHeight),r=a.dataLabel.getBBox().height||21,a.distributeBox={target:a.labelPosition.natural.y-a.top+r/2,size:r,rank:a.y},n.push(a.distributeBox))});
q=x+r-q;c.distribute(n,q,q/5)}for(M=0;M<l;M++){d=a[M];C=d.labelPosition;t=d.dataLabel;N=!1===d.visible?"hidden":"inherit";D=q=C.natural.y;n&&G(d.distributeBox)&&(void 0===d.distributeBox.pos?N="hidden":(B=d.distributeBox.size,D=P.radialDistributionY(d)));delete d.positionIndex;if(f.justify)I=P.justify(d,w,A);else switch(f.alignTo){case "connectors":I=P.alignToConnectors(a,h,p,k);break;case "plotEdges":I=P.alignToPlotEdges(t,h,p,k);break;default:I=P.radialDistributionX(b,d,D,q)}t._attr={visibility:N,
align:C.alignment};t._pos={x:I+f.x+({left:g,right:-g}[C.alignment]||0),y:D+f.y-10};C.final.x=I;C.final.y=D;v(f.crop,!0)&&(z=t.getBBox().width,q=null,I-z<g&&1===h?(q=Math.round(z-I+g),R[3]=Math.max(q,R[3])):I+z>p-g&&0===h&&(q=Math.round(I+z-p+g),R[1]=Math.max(q,R[1])),0>D-B/2?R[0]=Math.max(Math.round(-D+B/2),R[0]):D+B/2>u&&(R[2]=Math.max(Math.round(D+B/2-u),R[2])),t.sideOverflow=q)}}}),0===F(R)||this.verifyDataLabelOverflow(R))&&(this.placeDataLabels(),this.points.forEach(function(a){W=y(f,a.options.dataLabels);
if(h=v(W.connectorWidth,1)){var d;q=a.connector;if((t=a.dataLabel)&&t._pos&&a.visible&&0<a.labelDistance){N=t._attr.visibility;if(d=!q)a.connector=q=e.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-"+a.colorIndex+(a.className?" "+a.className:"")).add(b.dataLabelsGroup),e.styledMode||q.attr({"stroke-width":h,stroke:W.connectorColor||a.color||"#666666"});q[d?"attr":"animate"]({d:a.getConnectorPath()});q.attr("visibility",N)}else q&&(a.connector=q.destroy())}}))},q.pie.prototype.placeDataLabels=
function(){this.points.forEach(function(b){var a=b.dataLabel,d;a&&b.visible&&((d=a._pos)?(a.sideOverflow&&(a._attr.width=Math.max(a.getBBox().width-a.sideOverflow,0),a.css({width:a._attr.width+"px",textOverflow:(this.options.dataLabels.style||{}).textOverflow||"ellipsis"}),a.shortened=!0),a.attr(a._attr),a[a.moved?"animate":"attr"](d),a.moved=!0):a&&a.attr({y:-9999}));delete b.distributeBox},this)},q.pie.prototype.alignDataLabel=f,q.pie.prototype.verifyDataLabelOverflow=function(b){var a=this.center,
d=this.options,c=d.center,f=d.minSize||80,g=null!==d.size;if(!g){if(null!==c[0])var n=Math.max(a[2]-Math.max(b[1],b[3]),f);else n=Math.max(a[2]-b[1]-b[3],f),a[0]+=(b[3]-b[1])/2;null!==c[1]?n=Math.max(Math.min(n,a[2]-Math.max(b[0],b[2])),f):(n=Math.max(Math.min(n,a[2]-b[0]-b[2]),f),a[1]+=(b[0]-b[2])/2);n<a[2]?(a[2]=n,a[3]=Math.min(h(d.innerSize||0,n),n),this.translate(a),this.drawDataLabels&&this.drawDataLabels()):g=!0}return g});q.column&&(q.column.prototype.alignDataLabel=function(b,a,d,c,f){var e=
this.chart.inverted,g=b.series,h=b.dlBox||b.shapeArgs,l=v(b.below,b.plotY>v(this.translatedThreshold,g.yAxis.len)),k=v(d.inside,!!this.options.stacking);h&&(c=y(h),0>c.y&&(c.height+=c.y,c.y=0),h=c.y+c.height-g.yAxis.len,0<h&&(c.height-=h),e&&(c={x:g.yAxis.len-c.y-c.height,y:g.xAxis.len-c.x-c.width,width:c.height,height:c.width}),k||(e?(c.x+=l?0:c.width,c.width=0):(c.y+=l?c.height:0,c.height=0)));d.align=v(d.align,!e||k?"center":l?"right":"left");d.verticalAlign=v(d.verticalAlign,e||k?"middle":l?"top":
"bottom");n.prototype.alignDataLabel.call(this,b,a,d,c,f);d.inside&&b.contrastColor&&a.css({color:b.contrastColor})})});M(I,"modules/overlapping-datalabels.src.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.isArray,G=f.objectEach,z=f.pick;f=c.Chart;var B=c.addEvent,t=c.fireEvent;B(f,"render",function(){var c=[];(this.labelCollectors||[]).forEach(function(f){c=c.concat(f())});(this.yAxis||[]).forEach(function(f){f.options.stackLabels&&!f.options.stackLabels.allowOverlap&&
G(f.stacks,function(f){G(f,function(f){c.push(f.label)})})});(this.series||[]).forEach(function(f){var v=f.options.dataLabels;f.visible&&(!1!==v.enabled||f._hasPointLabels)&&f.points.forEach(function(f){f.visible&&(F(f.dataLabels)?f.dataLabels:f.dataLabel?[f.dataLabel]:[]).forEach(function(h){var n=h.options;h.labelrank=z(n.labelrank,f.labelrank,f.shapeArgs&&f.shapeArgs.height);n.allowOverlap||c.push(h)})})});this.hideOverlappingLabels(c)});f.prototype.hideOverlappingLabels=function(c){var f=this,
v=c.length,y=f.renderer,h,n,q;var g=function(a){var b=a.box?0:a.padding||0;var d=0;if(a&&(!a.alignAttr||a.placed)){var c=a.attr("x");var f=a.attr("y");c="number"===typeof c&&"number"===typeof f?{x:c,y:f}:a.alignAttr;f=a.parentGroup;a.width||(d=a.getBBox(),a.width=d.width,a.height=d.height,d=y.fontMetrics(null,a.element).h);return{x:c.x+(f.translateX||0)+b,y:c.y+(f.translateY||0)+b-d,width:a.width-2*b,height:a.height-2*b}}};for(n=0;n<v;n++)if(h=c[n])h.oldOpacity=h.opacity,h.newOpacity=1,h.absoluteBox=
g(h);c.sort(function(a,b){return(b.labelrank||0)-(a.labelrank||0)});for(n=0;n<v;n++){var b=(g=c[n])&&g.absoluteBox;for(h=n+1;h<v;++h){var a=(q=c[h])&&q.absoluteBox;!b||!a||g===q||0===g.newOpacity||0===q.newOpacity||a.x>b.x+b.width||a.x+a.width<b.x||a.y>b.y+b.height||a.y+a.height<b.y||((g.labelrank<q.labelrank?g:q).newOpacity=0)}}c.forEach(function(a){var b;if(a){var d=a.newOpacity;a.oldOpacity!==d&&(a.alignAttr&&a.placed?(d?a.show(!0):b=function(){a.hide(!0);a.placed=!1},a.alignAttr.opacity=d,a[a.isOld?
"animate":"attr"](a.alignAttr,null,b),t(f,"afterHideOverlappingLabels")):a.attr({opacity:d}));a.isOld=!0}})}});M(I,"parts/Interaction.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.defined,G=f.extend,z=f.isArray,B=f.isObject,t=f.objectEach,v=f.pick,C=c.addEvent;f=c.Chart;var H=c.createElement,y=c.css,h=c.defaultOptions,n=c.defaultPlotOptions,q=c.fireEvent,g=c.hasTouch,b=c.Legend,a=c.merge,d=c.Point,e=c.Series,l=c.seriesTypes,I=c.svg;var E=c.TrackerMixin={drawTrackerPoint:function(){var a=
this,b=a.chart,d=b.pointer,c=function(a){var b=d.getPointFromEvent(a);void 0!==b&&(d.isDirectTouch=!0,b.onMouseOver(a))},e;a.points.forEach(function(a){e=z(a.dataLabels)?a.dataLabels:a.dataLabel?[a.dataLabel]:[];a.graphic&&(a.graphic.element.point=a);e.forEach(function(b){b.div?b.div.point=a:b.element.point=a})});a._hasTracking||(a.trackerGroups.forEach(function(e){if(a[e]){a[e].addClass("highcharts-tracker").on("mouseover",c).on("mouseout",function(a){d.onTrackerMouseOut(a)});if(g)a[e].on("touchstart",
c);!b.styledMode&&a.options.cursor&&a[e].css(y).css({cursor:a.options.cursor})}}),a._hasTracking=!0);q(this,"afterDrawTracker")},drawTrackerGraph:function(){var a=this,b=a.options,d=b.trackByArea,c=[].concat(d?a.areaPath:a.graphPath),e=c.length,f=a.chart,h=f.pointer,l=f.renderer,n=f.options.tooltip.snap,v=a.tracker,t,y=function(){if(f.hoverSeries!==a)a.onMouseOver()},z="rgba(192,192,192,"+(I?.0001:.002)+")";if(e&&!d)for(t=e+1;t--;)"M"===c[t]&&c.splice(t+1,0,c[t+1]-n,c[t+2],"L"),(t&&"M"===c[t]||t===
e)&&c.splice(t,0,"L",c[t-2]+n,c[t-1]);v?v.attr({d:c}):a.graph&&(a.tracker=l.path(c).attr({visibility:a.visible?"visible":"hidden",zIndex:2}).addClass(d?"highcharts-tracker-area":"highcharts-tracker-line").add(a.group),f.styledMode||a.tracker.attr({"stroke-linejoin":"round",stroke:z,fill:d?z:"none","stroke-width":a.graph.strokeWidth()+(d?0:2*n)}),[a.tracker,a.markerGroup].forEach(function(a){a.addClass("highcharts-tracker").on("mouseover",y).on("mouseout",function(a){h.onTrackerMouseOut(a)});b.cursor&&
!f.styledMode&&a.css({cursor:b.cursor});if(g)a.on("touchstart",y)}));q(this,"afterDrawTracker")}};l.column&&(l.column.prototype.drawTracker=E.drawTrackerPoint);l.pie&&(l.pie.prototype.drawTracker=E.drawTrackerPoint);l.scatter&&(l.scatter.prototype.drawTracker=E.drawTrackerPoint);G(b.prototype,{setItemEvents:function(b,c,e){var f=this,g=f.chart.renderer.boxWrapper,k=b instanceof d,h="highcharts-legend-"+(k?"point":"series")+"-active",l=f.chart.styledMode;(e?c:b.legendGroup).on("mouseover",function(){b.visible&&
f.allItems.forEach(function(a){b!==a&&a.setState("inactive",!k)});b.setState("hover");b.visible&&g.addClass(h);l||c.css(f.options.itemHoverStyle)}).on("mouseout",function(){f.chart.styledMode||c.css(a(b.visible?f.itemStyle:f.itemHiddenStyle));f.allItems.forEach(function(a){b!==a&&a.setState("",!k)});g.removeClass(h);b.setState()}).on("click",function(a){var c=function(){b.setVisible&&b.setVisible();f.allItems.forEach(function(a){b!==a&&a.setState(b.visible?"inactive":"",!k)})};g.removeClass(h);a=
{browserEvent:a};b.firePointEvent?b.firePointEvent("legendItemClick",a,c):q(b,"legendItemClick",a,c)})},createCheckboxForItem:function(a){a.checkbox=H("input",{type:"checkbox",className:"highcharts-legend-checkbox",checked:a.selected,defaultChecked:a.selected},this.options.itemCheckboxStyle,this.chart.container);C(a.checkbox,"click",function(b){q(a.series||a,"checkboxClick",{checked:b.target.checked,item:a},function(){a.select()})})}});G(f.prototype,{showResetZoom:function(){function a(){b.zoomOut()}
var b=this,c=h.lang,d=b.options.chart.resetZoomButton,e=d.theme,f=e.states,g="chart"===d.relativeTo||"spaceBox"===d.relativeTo?null:"plotBox";q(this,"beforeShowResetZoom",null,function(){b.resetZoomButton=b.renderer.button(c.resetZoom,null,null,a,e,f&&f.hover).attr({align:d.position.align,title:c.resetZoomTitle}).addClass("highcharts-reset-zoom").add().align(d.position,!1,g)});q(this,"afterShowResetZoom")},zoomOut:function(){q(this,"selection",{resetSelection:!0},this.zoom)},zoom:function(a){var b=
this,c,d=b.pointer,e=!1,f=b.inverted?d.mouseDownX:d.mouseDownY;!a||a.resetSelection?(b.axes.forEach(function(a){c=a.zoom()}),d.initiated=!1):a.xAxis.concat(a.yAxis).forEach(function(a){var g=a.axis,k=b.inverted?g.left:g.top,h=b.inverted?k+g.width:k+g.height,l=g.isXAxis,m=!1;if(!l&&f>=k&&f<=h||l||!F(f))m=!0;d[l?"zoomX":"zoomY"]&&m&&(c=g.zoom(a.min,a.max),g.displayBtn&&(e=!0))});var g=b.resetZoomButton;e&&!g?b.showResetZoom():!e&&B(g)&&(b.resetZoomButton=g.destroy());c&&b.redraw(v(b.options.chart.animation,
a&&a.animation,100>b.pointCount))},pan:function(a,b){var c=this,d=c.hoverPoints,e;q(this,"pan",{originalEvent:a},function(){d&&d.forEach(function(a){a.setState()});("xy"===b?[1,0]:[1]).forEach(function(b){b=c[b?"xAxis":"yAxis"][0];var d=b.horiz,f=a[d?"chartX":"chartY"];d=d?"mouseDownX":"mouseDownY";var g=c[d],k=(b.pointRange||0)/2,h=b.reversed&&!c.inverted||!b.reversed&&c.inverted?-1:1,l=b.getExtremes(),n=b.toValue(g-f,!0)+k*h;h=b.toValue(g+b.len-f,!0)-k*h;var p=h<n;g=p?h:n;n=p?n:h;h=Math.min(l.dataMin,
k?l.min:b.toValue(b.toPixels(l.min)-b.minPixelPadding));k=Math.max(l.dataMax,k?l.max:b.toValue(b.toPixels(l.max)+b.minPixelPadding));p=h-g;0<p&&(n+=p,g=h);p=n-k;0<p&&(n=k,g-=p);b.series.length&&g!==l.min&&n!==l.max&&(b.setExtremes(g,n,!1,!1,{trigger:"pan"}),e=!0);c[d]=f});e&&c.redraw(!1);y(c.container,{cursor:"move"})})}});G(d.prototype,{select:function(a,b){var c=this,d=c.series,e=d.chart;this.selectedStaging=a=v(a,!c.selected);c.firePointEvent(a?"select":"unselect",{accumulate:b},function(){c.selected=
c.options.selected=a;d.options.data[d.data.indexOf(c)]=c.options;c.setState(a&&"select");b||e.getSelectedPoints().forEach(function(a){var b=a.series;a.selected&&a!==c&&(a.selected=a.options.selected=!1,b.options.data[b.data.indexOf(a)]=a.options,a.setState(e.hoverPoints&&b.options.inactiveOtherPoints?"inactive":""),a.firePointEvent("unselect"))})});delete this.selectedStaging},onMouseOver:function(a){var b=this.series.chart,c=b.pointer;a=a?c.normalize(a):c.getChartCoordinatesFromPoint(this,b.inverted);
c.runPointActions(a,this)},onMouseOut:function(){var a=this.series.chart;this.firePointEvent("mouseOut");this.series.options.inactiveOtherPoints||(a.hoverPoints||[]).forEach(function(a){a.setState()});a.hoverPoints=a.hoverPoint=null},importEvents:function(){if(!this.hasImportedEvents){var b=this,d=a(b.series.options.point,b.options).events;b.events=d;t(d,function(a,d){c.isFunction(a)&&C(b,d,a)});this.hasImportedEvents=!0}},setState:function(a,b){var c=this.series,d=this.state,e=c.options.states[a||
"normal"]||{},f=n[c.type].marker&&c.options.marker,g=f&&!1===f.enabled,h=f&&f.states&&f.states[a||"normal"]||{},l=!1===h.enabled,p=c.stateMarkerGraphic,u=this.marker||{},t=c.chart,y=c.halo,z,B=f&&c.markerAttribs;a=a||"";if(!(a===this.state&&!b||this.selected&&"select"!==a||!1===e.enabled||a&&(l||g&&!1===h.enabled)||a&&u.states&&u.states[a]&&!1===u.states[a].enabled)){this.state=a;B&&(z=c.markerAttribs(this,a));if(this.graphic){d&&this.graphic.removeClass("highcharts-point-"+d);a&&this.graphic.addClass("highcharts-point-"+
a);if(!t.styledMode){var C=c.pointAttribs(this,a);var H=v(t.options.chart.animation,e.animation);c.options.inactiveOtherPoints&&((this.dataLabels||[]).forEach(function(a){a&&a.animate({opacity:C.opacity},H)}),this.connector&&this.connector.animate({opacity:C.opacity},H));this.graphic.animate(C,H)}z&&this.graphic.animate(z,v(t.options.chart.animation,h.animation,f.animation));p&&p.hide()}else{if(a&&h){d=u.symbol||c.symbol;p&&p.currentSymbol!==d&&(p=p.destroy());if(z)if(p)p[b?"animate":"attr"]({x:z.x,
y:z.y});else d&&(c.stateMarkerGraphic=p=t.renderer.symbol(d,z.x,z.y,z.width,z.height).add(c.markerGroup),p.currentSymbol=d);!t.styledMode&&p&&p.attr(c.pointAttribs(this,a))}p&&(p[a&&this.isInside?"show":"hide"](),p.element.point=this)}a=e.halo;e=(p=this.graphic||p)&&p.visibility||"inherit";a&&a.size&&p&&"hidden"!==e?(y||(c.halo=y=t.renderer.path().add(p.parentGroup)),y.show()[b?"animate":"attr"]({d:this.haloPath(a.size)}),y.attr({"class":"highcharts-halo highcharts-color-"+v(this.colorIndex,c.colorIndex)+
(this.className?" "+this.className:""),visibility:e,zIndex:-1}),y.point=this,t.styledMode||y.attr(G({fill:this.color||c.color,"fill-opacity":a.opacity},a.attributes))):y&&y.point&&y.point.haloPath&&y.animate({d:y.point.haloPath(0)},null,y.hide);q(this,"afterSetState")}},haloPath:function(a){return this.series.chart.renderer.symbols.circle(Math.floor(this.plotX)-a,this.plotY-a,2*a,2*a)}});G(e.prototype,{onMouseOver:function(){var a=this.chart,b=a.hoverSeries;if(b&&b!==this)b.onMouseOut();this.options.events.mouseOver&&
q(this,"mouseOver");this.setState("hover");a.hoverSeries=this},onMouseOut:function(){var a=this.options,b=this.chart,c=b.tooltip,d=b.hoverPoint;b.hoverSeries=null;if(d)d.onMouseOut();this&&a.events.mouseOut&&q(this,"mouseOut");!c||this.stickyTracking||c.shared&&!this.noSharedTooltip||c.hide();b.series.forEach(function(a){a.setState("",!0)})},setState:function(a,b){var c=this,d=c.options,e=c.graph,f=d.inactiveOtherPoints,g=d.states,h=d.lineWidth,l=d.opacity,n=v(g[a||"normal"]&&g[a||"normal"].animation,
c.chart.options.chart.animation);d=0;a=a||"";if(c.state!==a&&([c.group,c.markerGroup,c.dataLabelsGroup].forEach(function(b){b&&(c.state&&b.removeClass("highcharts-series-"+c.state),a&&b.addClass("highcharts-series-"+a))}),c.state=a,!c.chart.styledMode)){if(g[a]&&!1===g[a].enabled)return;a&&(h=g[a].lineWidth||h+(g[a].lineWidthPlus||0),l=v(g[a].opacity,l));if(e&&!e.dashstyle)for(g={"stroke-width":h},e.animate(g,n);c["zone-graph-"+d];)c["zone-graph-"+d].attr(g),d+=1;f||[c.group,c.markerGroup,c.dataLabelsGroup,
c.labelBySeries].forEach(function(a){a&&a.animate({opacity:l},n)})}b&&f&&c.points&&c.setAllPointsToState(a)},setAllPointsToState:function(a){this.points.forEach(function(b){b.setState&&b.setState(a)})},setVisible:function(a,b){var c=this,d=c.chart,e=c.legendItem,f=d.options.chart.ignoreHiddenSeries,g=c.visible;var h=(c.visible=a=c.options.visible=c.userOptions.visible=void 0===a?!g:a)?"show":"hide";["group","dataLabelsGroup","markerGroup","tracker","tt"].forEach(function(a){if(c[a])c[a][h]()});if(d.hoverSeries===
c||(d.hoverPoint&&d.hoverPoint.series)===c)c.onMouseOut();e&&d.legend.colorizeItem(c,a);c.isDirty=!0;c.options.stacking&&d.series.forEach(function(a){a.options.stacking&&a.visible&&(a.isDirty=!0)});c.linkedSeries.forEach(function(b){b.setVisible(a,!1)});f&&(d.isDirtyBox=!0);q(c,h);!1!==b&&d.redraw()},show:function(){this.setVisible(!0)},hide:function(){this.setVisible(!1)},select:function(a){this.selected=a=this.options.selected=void 0===a?!this.selected:a;this.checkbox&&(this.checkbox.checked=a);
q(this,a?"select":"unselect")},drawTracker:E.drawTrackerGraph})});M(I,"parts/Responsive.js",[I["parts/Globals.js"],I["parts/Utilities.js"]],function(c,f){var F=f.isArray,G=f.isObject,z=f.objectEach,B=f.pick,t=f.splat;f=c.Chart;f.prototype.setResponsive=function(f,t){var v=this.options.responsive,y=[],h=this.currentResponsive;!t&&v&&v.rules&&v.rules.forEach(function(f){void 0===f._id&&(f._id=c.uniqueKey());this.matchResponsiveRule(f,y)},this);t=c.merge.apply(0,y.map(function(f){return c.find(v.rules,
function(c){return c._id===f}).chartOptions}));t.isResponsiveOptions=!0;y=y.toString()||void 0;y!==(h&&h.ruleIds)&&(h&&this.update(h.undoOptions,f,!0),y?(h=this.currentOptions(t),h.isResponsiveOptions=!0,this.currentResponsive={ruleIds:y,mergedOptions:t,undoOptions:h},this.update(t,f,!0)):this.currentResponsive=void 0)};f.prototype.matchResponsiveRule=function(c,f){var t=c.condition;(t.callback||function(){return this.chartWidth<=B(t.maxWidth,Number.MAX_VALUE)&&this.chartHeight<=B(t.maxHeight,Number.MAX_VALUE)&&
this.chartWidth>=B(t.minWidth,0)&&this.chartHeight>=B(t.minHeight,0)}).call(this)&&f.push(c._id)};f.prototype.currentOptions=function(c){function f(c,n,q,g){var b;z(c,function(a,c){if(!g&&-1<v.collectionsWithUpdate.indexOf(c))for(a=t(a),q[c]=[],b=0;b<a.length;b++)n[c][b]&&(q[c][b]={},f(a[b],n[c][b],q[c][b],g+1));else G(a)?(q[c]=F(a)?[]:{},f(a,n[c]||{},q[c],g+1)):q[c]=void 0===n[c]?null:n[c]})}var v=this,y={};f(c,this.options,y,0);return y}});M(I,"masters/highcharts.src.js",[I["parts/Globals.js"],
I["parts/Utilities.js"]],function(c,f){var F=f.extend;F(c,{arrayMax:f.arrayMax,arrayMin:f.arrayMin,attr:f.attr,defined:f.defined,erase:f.erase,extend:f.extend,isArray:f.isArray,isClass:f.isClass,isDOMElement:f.isDOMElement,isNumber:f.isNumber,isObject:f.isObject,isString:f.isString,objectEach:f.objectEach,pick:f.pick,pInt:f.pInt,setAnimation:f.setAnimation,splat:f.splat,syncTimeout:f.syncTimeout});return c});I["masters/highcharts.src.js"]._modules=I;return I["masters/highcharts.src.js"]});
//# sourceMappingURL=highcharts.js.map

/***/ }),
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, authData_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var NavigationImpl = (function () {
        function NavigationImpl(data, getCurrentRole) {
            this.allPlants = _.map(data, function (p) {
                var plant = _.assign({}, p);
                plant.shops = _.flatten(_.map(p.tanks, 'shops'));
                return plant;
            });
            this.getCurrentRole = getCurrentRole;
            this.roleChanged();
        }
        NavigationImpl.prototype.initialize = function (notificationHub, userData) {
            this.notificationHub = notificationHub;
            this.userData = userData;
        };
        NavigationImpl.prototype.uninitialize = function () {
            if (this.notificationHub) {
                this.notificationHub.uninitialize();
                this.notificationHub.disconnect();
            }
        };
        NavigationImpl.prototype.plants = function () {
            var role = this.getCurrentRole();
            if (!role) {
                return undefined;
            }
            return this.allPlants.concat([]);
        };
        NavigationImpl.prototype.shops = function () {
            if (this.selectedPlant) {
                return this.selectedPlant.shops.concat([]);
            }
            return undefined;
        };
        NavigationImpl.prototype.allShops = function () {
            var shops = [];
            _.forEach(this.allPlants, function (plant) {
                shops = shops.concat(plant.shops);
            });
            return shops;
        };
        NavigationImpl.prototype.plantChanged = function () {
            var oldShop = this.selectedShop;
            this.selectedShop = undefined;
            var role = this.getCurrentRole();
            if (oldShop) {
                this.selectedShop = _.find(this.shops(), { id: oldShop.id });
            }
            if (!this.selectedShop && role && role.lastShopId) {
                this.selectedShop = _.find(this.shops(), { id: role.lastShopId });
            }
            if (!this.selectedShop) {
                this.selectedShop = _.first(this.shops());
            }
        };
        NavigationImpl.prototype.roleChanged = function () {
            var oldPlant = this.selectedPlant;
            this.selectedPlant = undefined;
            var role = this.getCurrentRole();
            if (oldPlant) {
                this.selectedPlant = _.find(this.plants(), { id: oldPlant.id });
            }
            if (!this.selectedPlant && role && role.roleRequiresPlants && role.lastPlantId) {
                this.selectedPlant = _.find(this.plants(), { id: role.lastPlantId });
            }
            if (!this.selectedPlant) {
                this.selectedPlant = _.first(this.plants());
            }
            this.plantChanged();
        };
        NavigationImpl.prototype.selectPlant = function (plant) {
            if (!plant) {
                return false;
            }
            return this.selectPlantShop(plant, _.first(plant.shops));
        };
        NavigationImpl.prototype.selectPlantShop = function (plant, shop) {
            if (!shop || this.selectedShop === shop) {
                return false;
            }
            var plantChanged = (this.selectedPlant !== plant);
            if (plantChanged) {
                this.selectedPlant = plant;
            }
            this.selectedShop = shop;
            var role = this.getCurrentRole();
            NavigationImpl.authDataService.setSelectedRoleLocation(role, this.selectedPlant, this.selectedShop);
            return true;
        };
        return NavigationImpl;
    }());
    exports.default = angular.module('navigation', [authData_service_1.default])
        .factory('Navigation', ["authDataService", function (authDataService) {
        NavigationImpl.authDataService = authDataService;
        return NavigationImpl;
    }]).name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var GobUtil = (function () {
        function GobUtil() {
        }
        GobUtil.getGobName = function (gob, maxGobs) {
            if (!gob || !maxGobs || gob > 4 || maxGobs > 4) {
                return undefined;
            }
            if (gob === 1) {
                return 'F';
            }
            if (gob === maxGobs) {
                return 'B';
            }
            if (maxGobs === 3) {
                return 'M';
            }
            if (gob === 2) {
                return 'FM';
            }
            return 'BM';
        };
        return GobUtil;
    }());
    exports.default = GobUtil;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var DefectClassification = (function () {
        function DefectClassification(id, name) {
            this.id = id;
            this.name = name;
        }
        return DefectClassification;
    }());
    exports.DefectClassification = DefectClassification;
    function padLegacyId(legacyId) {
        return _.padStart(legacyId.toString(), 3, '0');
    }
    exports.padLegacyId = padLegacyId;
    ;
    var DefectType = (function () {
        function DefectType(viewModel, classifications) {
            _.assign(this, viewModel || {});
            if (this.legacyId) {
                var paddedLegacyId = padLegacyId(this.legacyId);
                this.listName = this.name + ' (' + paddedLegacyId + ')';
            }
            else {
                this.listName = this.name;
            }
            if (this.defectClassificationId) {
                var classification = _.find(classifications, { id: this.defectClassificationId });
                if (!classification) {
                    classification = new DefectClassification(this.defectClassificationId, this.defectClassificationName);
                    classifications.push(classification);
                }
                this.classification = classification;
            }
        }
        return DefectType;
    }());
    exports.DefectType = DefectType;
    exports.default = angular.module('aps.models', [])
        .service('defectTypeDetailsViewModelService', function () {
        return {
            apply: apply
        };
        function apply(viewModel) {
            var createFriendlyPercentageProperty = function (viewModel, basePropertyName) {
                var trimValueToFourDecimalSpaces = function (toConvert) {
                    return parseFloat(toConvert.toFixed(4));
                };
                Object.defineProperty(viewModel, basePropertyName + 'Friendly', {
                    get: function () {
                        var val = _.isUndefined(viewModel) ? undefined : viewModel[basePropertyName];
                        return _.isUndefined(val) || _.isNull(val) ? val : trimValueToFourDecimalSpaces(val * 100);
                    },
                    set: function (newValue) {
                        viewModel[basePropertyName] = _.isUndefined(newValue)
                            || _.isNull(newValue) ? newValue : trimValueToFourDecimalSpaces(newValue / 100);
                    }
                });
            };
            createFriendlyPercentageProperty(viewModel, 'criticalThreshold');
            createFriendlyPercentageProperty(viewModel, 'requalificationThreshold');
        }
    })
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(2), __webpack_require__(402), __webpack_require__(5), __webpack_require__(4), __webpack_require__(74), __webpack_require__(278), __webpack_require__(6), __webpack_require__(7), __webpack_require__(11), __webpack_require__(9), __webpack_require__(12), __webpack_require__(55), __webpack_require__(3), __webpack_require__(404), __webpack_require__(89), __webpack_require__(33)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, moment, _, deleteDefect_controller_1, aps_enums_1, loader_service_1, defect_service_1, criticalDefectService_1, notify_service_1, authData_service_1, dateutility_service_1, uiUtility_service_1, newguid_service_1, plant_service_1, constant_module_1, viewDefect_tpl_html_1, isNullOrUndefined_1, equipment_service_1) {
    "use strict";
    viewDefectCtrl.$inject = ["$modalInstance", "$modal", "loaderService", "defectService", "criticalDefectService", "data", "notifyService", "authDataService", "uiUtilityService", "newGuidService", "plantService", "$stateParams", "$interval", "equipmentService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [
        deleteDefect_controller_1.default,
        loader_service_1.default,
        defect_service_1.default,
        criticalDefectService_1.default,
        notify_service_1.default,
        authData_service_1.default,
        uiUtility_service_1.default,
        newguid_service_1.default,
        plant_service_1.default,
        equipment_service_1.default
    ];
    function openViewDefect(data, $modal) {
        return $modal.open({
            template: viewDefect_tpl_html_1.default,
            controller: "ViewDefectCtrl as vm",
            resolve: {
                data: function () { return data; },
            },
        }).result;
    }
    exports.openViewDefect = openViewDefect;
    exports.default = angular
        .module("aps.controller.viewDefects", requires)
        .controller("ViewDefectCtrl", viewDefectCtrl).name;
    function viewDefectCtrl($modalInstance, $modal, loaderService, defectService, criticalDefectService, data, notifyService, authDataService, uiUtilityService, newGuidService, plantService, $stateParams, $interval, equipmentService) {
        var vm = this;
        var shopActivity = {};
        vm.timeZoneId = "";
        var shopId = "";
        vm.readOnly = data ? data.readOnly : false;
        vm.canComment = data ? data.canComment : false;
        vm.isMaintenance = false;
        vm.isCERole = false;
        vm.isHERole = false;
        var role = authDataService.getSelectedRoleLocation();
        vm.role = role.role.roleName;
        if (vm.role === "CE Day Mechanic" ||
            vm.role === "CE Shift Mechanic" ||
            vm.role === "Maintenance Manager" ||
            vm.role === "Selecting Tank Manager" ||
            vm.role === "Selecting Shift Supervisor" ||
            vm.role === "Finished Ware Manager" ||
            vm.role === "Quality Control Supervisor" ||
            vm.role === "Selecting Maintenance Supervisor" ||
            vm.role === "Shift Electrician" ||
            vm.role === "Day Electrician" ||
            vm.role === "APSIO Administrator") {
            vm.isMaintenance = true;
        }
        if (vm.role === "Quality Control Supervisor" ||
            vm.role === "Quality Control Manager" ||
            vm.role === "CE Inspector" ||
            vm.role === "Finished Ware Manager" ||
            vm.role === "Tank Manager" ||
            vm.role === "CE Shift Supervisor" ||
            vm.role === "Plant Manager") {
            vm.isCERole = true;
        }
        else if (vm.role === "Machine Operator") {
            vm.isHERole = true;
        }
        vm.canRequalify = authDataService.isColdEndOperator();
        vm.isFoodCertifiable = false;
        var setTheFuture = function () {
            var nextFuture = moment().endOf("minute").toDate();
            if (vm.theFuture !== nextFuture) {
                vm.theFuture = nextFuture;
            }
        };
        setTheFuture();
        $interval(setTheFuture, 1000);
        var getDefectEquipment = function () {
            defectService.getDefectEquipment().then(function (data) {
                var equipment = _.find(data, { id: vm.defect.equipmentId });
                if (equipment) {
                    vm.equipment = equipment.name;
                }
            });
        };
        var getMoldLossData = function () {
            var moldLoss = vm.moldLoss;
            moldLoss.isRejectInvalidMolds = vm.discardInvalidMolds;
            moldLoss.isRejectMold = vm.discardMold;
            return moldLoss;
        };
        vm.discardMoldOptions = [
            { name: true, value: "YES" },
            { name: false, value: "NO" },
            { name: undefined, value: "N/A" },
        ];
        vm.setMoldLossOptions = function () {
            var _this = this;
            plantService.getPlants().then(function (plants) {
                _this.plants = plants;
                _this.selectedPlant = _this.plants.filter(function (p) { return p.id === data.plantId; })[0];
                vm.moldLossEquipments = [];
                if (_this.selectedPlant.name === 'Lawrenceburg') {
                    vm.moldLossEquipments.push({
                        value: null,
                        text: 'N/A'
                    });
                }
                equipmentService.getShop(shopId)
                    .then(function (activeEquipment) {
                    if (activeEquipment.some(function (e) { return e.type === aps_enums_1.apsEnums.EquipmentType.Multi; })) {
                        vm.moldLossEquipments.push({
                            value: aps_enums_1.apsEnums.EquipmentType.Multi,
                            text: 'Multi'
                        });
                    }
                    if (activeEquipment.some(function (e) { return e.type === aps_enums_1.apsEnums.EquipmentType.MX4; })) {
                        vm.moldLossEquipments.push({
                            value: aps_enums_1.apsEnums.EquipmentType.MX4,
                            text: 'MX4'
                        });
                    }
                    if (activeEquipment.some(function (e) { return e.type === aps_enums_1.apsEnums.EquipmentType.FlexM; })) {
                        vm.moldLossEquipments.push({
                            value: aps_enums_1.apsEnums.EquipmentType.FlexM,
                            text: 'FlexM'
                        });
                    }
                    if (activeEquipment.some(function (e) { return e.type === aps_enums_1.apsEnums.EquipmentType.WBF; }) && _this.selectedPlant.name !== 'Elmira') {
                        vm.moldLossEquipments.push({
                            value: aps_enums_1.apsEnums.EquipmentType.WBF,
                            text: 'WBF'
                        });
                    }
                    var currentValueIsValid = vm.moldLossEquipments.some(function (x) { return x.value === vm.defect.moldLossEquipment; });
                    if (currentValueIsValid) {
                        vm.moldLossEquipment = vm.defect.moldLossEquipment;
                    }
                    else if (_this.selectedPlant.name === "Elmira") {
                        vm.moldLossEquipment = aps_enums_1.apsEnums.EquipmentType.FlexM;
                    }
                    else if (_this.selectedPlant.name === "Lawrenceburg") {
                        vm.moldLossEquipment = null;
                    }
                });
            });
        };
        plantService
            .getPlatFeatureSettings($stateParams.plantId)
            .then(function (tmpDat) {
            if (tmpDat && tmpDat.config) {
                var tmp = JSON.parse(tmpDat.config);
                var userRoleLocation = authDataService.getSelectedRoleLocation();
                if (tmp && tmp.moldLoss && tmp.moldLoss.shops) {
                    vm.showMoldLoss =
                        (_.includes(tmp.moldLoss.shops, "*") ||
                            _.includes(tmp.moldLoss.shops, vm.machine.shop.id)) &&
                            (_.includes(tmp.moldLoss.roles, "*") ||
                                _.includes(tmp.moldLoss.roles, userRoleLocation.role.roleId));
                    if (vm.showMoldLoss) {
                        vm.setMoldLossOptions();
                        vm.discardInvalidMolds = undefined;
                        if (vm.isHERole) {
                            defectService
                                .getMoldRejectStatus(vm.defect.id)
                                .then(function (data) {
                                vm.discardMold = data;
                            });
                        }
                        else {
                            vm.discardMold = (aps_enums_1.apsEnums.EquipmentType[vm.defect.moldLossEquipment] === undefined);
                        }
                    }
                }
            }
        });
        vm.toggleMoldLossStatus = function () {
            vm.showMoldLossStatus = !vm.showMoldLossStatus;
            if (vm.showMoldLossStatus) {
                defectService
                    .getMoldLossStatus(vm.machine.shop.id, vm.defect.id)
                    .then(function (data) {
                    vm.moldLossStatusList = data;
                });
            }
        };
        var defectMarkIdentifier = "defectMarkID";
        var bottleIdentifier = "defectBottleID";
        vm.drawDefect = function () {
            if (!vm.defect || !vm.defect.locationX || !vm.defect.locationY) {
                return;
            }
            var elm = angular.element("#" + bottleIdentifier);
            if (!elm || !elm[0]) {
                return;
            }
            var x = vm.defect.locationX;
            var y = vm.defect.locationY;
            var img = new Image();
            img.className = "defect-mark";
            img.id = defectMarkIdentifier;
            img.style.position = "absolute";
            img.style.left = elm[0].offsetLeft + x - 5 + "px";
            img.style.top = elm[0].offsetTop + y + 12 + "px";
            elm.append(img);
        };
        var getSeverityName = function (severity) {
            return _.find(_.toArray(constant_module_1.Enums.SEVERITY), { id: severity }).name;
        };
        var updateMoldRejectInputs = function () {
            if (vm.rejectStart) {
                vm.rejectStart = moment(vm.rejectStart).startOf("minute").toDate();
                vm.defect.rejectStart = vm.rejectStart;
            }
            if (vm.rejectEnd) {
                vm.rejectEnd = moment(vm.rejectEnd).startOf("minute").toDate();
                vm.defect.rejectEnd = vm.rejectEnd;
            }
            var timeZoneMoment = moment
                .tz(vm.defect.timeFound, vm.timeZoneId)
                .add(-30, "minutes");
            vm.minTime = moment(timeZoneMoment.format(constant_module_1.Strings.TIME_FORMAT), constant_module_1.Strings.TIME_FORMAT).toDate();
        };
        vm.invokeMachineDefectQuestions = function (isMnr) {
            vm.machineDefectQuestions = [];
            if (vm.defect.severity === 1 ||
                vm.defect.severity === 2 ||
                (vm.defect.severity === 3 && vm.defect.defectTypeLegacyId === 901)) {
                defectService
                    .getMachineDefectQuestion(vm.defect.id, isMnr)
                    .then(function (data) {
                    vm.machineDefectQuestions = data.map(function (i) {
                        return __assign({}, i, { isHEQuestion: i.question.indexOf("HE ") === 0 });
                    });
                    vm.defaultMachineDefectQuestions = angular.copy(vm.machineDefectQuestions);
                });
            }
        };
        vm.minRejectEnd = function () {
            if (vm.rejectStart) {
                var timeZoneMoment = moment.tz(vm.rejectStart, vm.timeZoneId);
                return moment(timeZoneMoment.format(constant_module_1.Strings.TIME_FORMAT), constant_module_1.Strings.TIME_FORMAT).toDate();
            }
            return vm.minTime;
        };
        vm.showCauses = false;
        if (data.defectId && data.defectId.length > 0 && !data.defect) {
            defectService
                .getDefect(data.defectId)
                .then(function (defectData) {
                vm.defect = defectData;
                vm.moldLossEquipment = defectData.moldLossEquipment;
                shopId = defectData.isMachineShopId;
                vm.timeZoneId = defectData.isMachineShopPlantTimeZoneId;
                vm.machineNumber = defectData.isMachineNumber;
                vm.dropName = defectData.dropName;
                vm.sectionName = _.isNull(defectData.section)
                    ? null
                    : defectData.section.toString();
                vm.gobName = defectData.gobName;
                vm.severityName = getSeverityName(defectData.severity);
                vm.isMoldRejectInUse = defectData.isMoldRejectInUse;
                vm.isEquipmentFailure = defectData.isEquipmentFailure;
                vm.rejectStart = defectData.rejectStart;
                vm.rejectEnd = defectData.rejectEnd;
                vm.maintenanceStart = defectData.maintenanceStart;
                vm.maintenanceEnd = defectData.maintenanceEnd;
                vm.isFoodCertifiable = defectData.isFoodCertifiable;
                vm.maintenanceResolution = defectData.maintenanceResolution;
                vm.disableEquipment =
                    aps_enums_1.apsEnums.EquipmentType[vm.moldLossEquipment] !== undefined
                        ? true
                        : false;
                vm.invokeMachineDefectQuestions(false);
                updateMoldRejectInputs();
                getDefectEquipment();
            });
        }
        else {
            vm.defect = data.defect;
            vm.moldLossEquipment = data.defect.moldLossEquipment;
            vm.isMoldRejectInUse = data.defect.isMoldRejectInUse;
            vm.isEquipmentFailure = data.defect.isEquipmentFailure;
            vm.rejectStart = data.defect.rejectStart;
            vm.rejectEnd = data.defect.rejectEnd;
            vm.maintenanceStart = data.defect.maintenanceStart;
            vm.maintenanceEnd = data.defect.maintenanceEnd;
            vm.isFoodCertifiable = data.defect.isFoodCertifiable;
            vm.maintenanceResolution = data.defect.maintenanceResolution;
            vm.gob = data.gob;
            vm.section = _.isNull(vm.gob) ? null : vm.gob.section;
            vm.machine = _.isNull(vm.section) ? null : vm.section.machine;
            vm.machineNumber = vm.machine.number;
            vm.dropName = data.defect.dropName;
            vm.sectionName =
                _.isNull(vm.section) ||
                    _.isUndefined(vm.section.name) ||
                    _.isNull(vm.section.name)
                    ? null
                    : vm.section.name.toString();
            vm.gobName =
                _.isNull(vm.gob) || _.isUndefined(vm.gob.name) || _.isNull(vm.gob.name)
                    ? null
                    : vm.gob.name.toString();
            shopActivity = vm.machine.shop;
            shopId = shopActivity.id;
            vm.timeZoneId = shopActivity.timeZoneId;
            vm.severityName = getSeverityName(vm.defect.severity);
            vm.showCauses = true;
            vm.disableEquipment =
                aps_enums_1.apsEnums.EquipmentType[vm.moldLossEquipment] !== undefined ? true : false;
            newGuidService.getNewGuid("moldLoss").then(function (x) {
                var moldLoss = {
                    id: x,
                    defectId: data.defect ? data.defect.id : undefined,
                    plantId: $stateParams.plantId,
                    critical: vm.defect.severity === aps_enums_1.apsEnums.Severity.Critical ? "Yes" : "No",
                    isRejectInvalidMolds: vm.discardInvalidMolds,
                    isRejectMold: vm.discardMold,
                    shopId: shopId,
                    moldId: data.defect && data.defect.toolNumber
                        ? data.defect.toolNumber.toString()
                        : undefined,
                    reason: data.defect && data.defect.defectType && data.defect.defectType.name
                        ? data.defect.defectType.name
                        : "",
                    requestedByUserId: $stateParams.userId,
                    section: vm.section ? vm.section.sectionNumber : undefined,
                    gob: data.gob ? data.gob.gobNumber : undefined,
                    gobName: data.gob ? data.gob.name : undefined,
                };
                vm.moldLoss = moldLoss;
            });
            if (vm.maintenanceResolution !== null) {
                vm.isMaintenance = false;
            }
            vm.invokeMachineDefectQuestions(false);
            updateMoldRejectInputs();
            getDefectEquipment();
        }
        vm.defectNewComment = "";
        vm.cancel = function () {
            if (vm.hasMNRDataChange()) {
                uiUtilityService
                    .confirm("Mold Reject updates are present.  Proceed with close?")
                    .then(function (result) {
                    if (result) {
                        $modalInstance.close();
                    }
                });
            }
            else {
                $modalInstance.close();
            }
        };
        vm.formatTime = function (time) {
            return dateutility_service_1.default.formatTime(time, vm.timeZoneId);
        };
        vm.defectCommentIsValid = function () {
            return (vm.defectNewComment || "").trim() !== "";
        };
        vm.addDefectComment = function () {
            if (vm.commentForm.$invalid) {
                return;
            }
            var defectComment = {
                shopId: shopId,
                defectId: vm.defect.id,
                comment: vm.defectNewComment,
            };
            var promise = defectService
                .addDefectComment(defectComment)
                .then(function () {
                $modalInstance.close();
            }, notifyService.handleApiErrors);
            loaderService.loadingPromise(promise);
        };
        vm.addHeldPallets = function () {
            if (vm.addHeldPalletsForm.$invalid) {
                return;
            }
            var command = {
                id: null,
                shopId: shopId,
                defectId: vm.defect.id,
                palletStart: vm.heldPalletStart,
                palletEnd: vm.heldPalletEnd,
            };
            var promise = defectService.addHeldPallets(command).then(function () {
                vm.heldPalletStart = null;
                vm.heldPalletEnd = null;
                vm.addHeldPalletsForm.$setPristine();
            }, notifyService.handleApiErrors);
            loaderService.loadingPromise(promise);
        };
        vm.removeHeldPallet = function (heldPallet) {
            if (!heldPallet || heldPallet.id === "") {
                return;
            }
            var index = vm.defect.heldPallets.indexOf(heldPallet);
            if (index < 0) {
                return;
            }
            var command = {
                defectHeldPalletsId: heldPallet.id,
                shopId: shopId,
                defectId: vm.defect.id,
            };
            var promise = defectService
                .deleteHeldPallets(command)
                .then(function () { }, notifyService.handleApiErrors);
            loaderService.loadingPromise(promise);
        };
        vm.deleteDefect = function () {
            var result = deleteDefect_controller_1.openDeleteDefect({
                defectName: vm.defect.name,
            }, $modal);
            result.then(function (reason) {
                if (!reason) {
                    return;
                }
                var promise = defectService
                    .deleteDefect(vm.defect.id, reason)
                    .then(function () {
                    $modalInstance.close();
                }, notifyService.handleApiErrors);
                loaderService.loadingPromise(promise);
            });
        };
        vm.reviewCausesAndCoursesOfAction = function () {
            $modalInstance.close(true);
        };
        vm.updateMNTData = function () {
            if (vm.defect.comments.length === 0) {
                vm.mntForm.maintenanceEnd.$setValidity("commentRequired", false);
            }
            if (vm.maintenanceResolution === null || !vm.isFoodCertifiable) {
                vm.mntForm.maintenanceEnd.$setValidity("maintRequired", false);
            }
            if (vm.mntForm.$invalid) {
                if (vm.mntForm.maintenanceStart) {
                    vm.mntForm.maintenanceStart.$dirty = true;
                }
                if (vm.mntForm.maintenanceEnd) {
                    vm.mntForm.maintenanceEnd.$dirty = true;
                }
                return;
            }
            var defectMNTData = {
                defectId: vm.defect.id,
                maintenanceStart: vm.isEquipmentFailure ? vm.maintenanceStart : null,
                maintenanceEnd: vm.isEquipmentFailure ? vm.maintenanceEnd : null,
                maintenanceResolution: vm.maintenanceResolution,
                isFoodCertifiable: vm.isFoodCertifiable,
            };
            var promise = defectService
                .updateDefectEquipFailure(defectMNTData)
                .then(function () {
                vm.defect.maintenanceStart = vm.maintenanceStart;
                vm.defect.maintenanceEnd = vm.maintenanceEnd;
            })
                .catch(notifyService.handleApiErrors);
            loaderService.loadingPromise(promise);
        };
        vm.updateMNTResolution = function () {
            vm.mntForm.maintenanceEnd = null;
            vm.maintenanceEnd = null;
            var resolutionTime = dateutility_service_1.default.localToTimeZone(new Date(), vm.timeZoneId).toDate();
            data.defect.resolutionTime = resolutionTime;
            data.defect.resolvedBy = authDataService.getUserData().fullName;
            data.defect.maintenanceResolution = vm.maintenanceResolution;
            data.defect.isFoodCertifiable = vm.isFoodCertifiable;
            var defectMNTData = {
                defectId: vm.defect.id,
                maintenanceStart: vm.isEquipmentFailure ? vm.maintenanceStart : null,
                maintenanceEnd: vm.isEquipmentFailure ? vm.maintenanceEnd : null,
                maintenanceResolution: vm.maintenanceResolution,
                isFoodCertifiable: vm.isFoodCertifiable,
                resolvedBy: authDataService.getUserId(),
                resolutionTime: resolutionTime
            };
            var promise = defectService
                .updateDefectEquipFailure(defectMNTData)
                .then(function () {
                vm.defect.maintenanceStart = vm.maintenanceStart;
                vm.defect.maintenanceEnd = vm.maintenanceEnd;
                $modalInstance.close();
            })
                .catch(notifyService.handleApiErrors);
            loaderService.loadingPromise(promise);
        };
        vm.updateMNRData = function () {
            if (vm.mnrForm.$invalid) {
                if (vm.mnrForm.rejectStart) {
                    vm.mnrForm.rejectStart.$dirty = true;
                }
                if (vm.mnrForm.rejectEnd) {
                    vm.mnrForm.rejectEnd.$dirty = true;
                }
                return;
            }
            if (vm.defectQAForm.$invalid) {
                vm.machineDefectQuestions
                    .filter(function (q) { return !q.isHEQuestion; })
                    .forEach(function (q) {
                    if (q.questionValue === null || q.questionValue === undefined) {
                        vm.defectQAForm[q.questionId].$dirty = true;
                    }
                });
                return;
            }
            if (vm.moldLossEquipment === undefined || vm.moldLossEquipment === null) {
                if (vm.isMoldRejectInUse) {
                    vm.moldLossForm.moldLossEquipment.$dirty = true;
                    return;
                }
            }
            var defectMNRData = {
                defectId: vm.defect.id,
                isMoldRejectInUse: vm.isMoldRejectInUse,
                rejectStart: vm.isMoldRejectInUse ? vm.rejectStart : null,
                rejectEnd: vm.isMoldRejectInUse ? vm.rejectEnd : null,
                moldLossEquipment: vm.isMoldRejectInUse
                    ? vm.moldLossEquipment
                    : undefined,
                requalification: vm.showRequalification() ? vm.requalification : null,
                requalificationDateTime: vm.showRequalification() && vm.requalification
                    ? vm.requalificationDateTime
                    : null,
                questions: vm.getSelectedDefectsQuestions(),
            };
            var promise = defectService
                .updateDefectMoldReject(defectMNRData)
                .then(function () {
                vm.defect.isMoldRejectInUse = vm.isMoldRejectInUse;
                vm.defect.rejectStart = vm.rejectStart;
                vm.defect.rejectEnd = vm.rejectEnd;
                vm.defect.moldLossEquipment = vm.moldLossEquipment;
                vm.requalification = false;
                vm.requalificationDateTime = null;
                vm.disableEquipment =
                    aps_enums_1.apsEnums.EquipmentType[vm.moldLossEquipment] !== undefined
                        ? true
                        : false;
                var moldLoss = getMoldLossData();
                defectService.addMoldLoss(moldLoss);
                $modalInstance.close();
            })
                .catch(notifyService.handleApiErrors);
            loaderService.loadingPromise(promise);
        };
        vm.getSelectedDefectsQuestions = function () {
            var selectedQuestions = [];
            var currentTimeInTimeZone = moment().tz(vm.timeZoneId);
            var currentTime = currentTimeInTimeZone.utc().toISOString();
            if (vm.machineDefectQuestions) {
                selectedQuestions = vm.machineDefectQuestions.map(function (question) {
                    var defaultValue = vm.defaultMachineDefectQuestions.filter(function (q) { return q.questionId === question.questionId; })[0].questionValue;
                    var userInput = question.questionValue;
                    return {
                        questionId: question.questionId,
                        question: question.question,
                        sequence: question.sequence,
                        questionValue: userInput !== defaultValue ? userInput : defaultValue,
                        lastUpdatedDate: userInput !== defaultValue ? currentTime : question.lastUpdatedDate,
                        lastUpdatedBy: userInput !== defaultValue
                            ? authDataService.getUserData().userName
                            : question.lastUpdatedBy,
                    };
                });
            }
            else {
                selectedQuestions = vm.defaultMachineDefectQuestions || null;
            }
            return selectedQuestions;
        };
        vm.hasMNRDataChange = function () {
            if (!vm.defect) {
                return false;
            }
            if (vm.defect.isMoldRejectInUse !== vm.isMoldRejectInUse) {
                return true;
            }
            if (vm.rejectStart) {
                if (!vm.defect.rejectStart ||
                    vm.rejectStart.getTime() !== vm.defect.rejectStart.getTime()) {
                    return true;
                }
            }
            else if (vm.defect.rejectStart) {
                return true;
            }
            if (vm.rejectEnd) {
                if (!vm.defect.rejectEnd ||
                    vm.rejectEnd.getTime() !== vm.defect.rejectEnd.getTime()) {
                    return true;
                }
            }
            else if (vm.defect.rejectEnd) {
                return true;
            }
            if (vm.requalification) {
                return true;
            }
            if (vm.machineDefectQuestions) {
                for (var _i = 0, _a = vm.machineDefectQuestions; _i < _a.length; _i++) {
                    var defect = _a[_i];
                    var defaultValue = vm.defaultMachineDefectQuestions.filter(function (x) { return x.questionId === defect.questionId; })[0].questionValue;
                    var currentValue = defect.questionValue;
                    if (currentValue !== defaultValue) {
                        return true;
                    }
                }
            }
            return false;
        };
        vm.hasMNTDataChange = function () {
            if (!vm.defect) {
                return false;
            }
            if (vm.defect.isEquipmentFailure !== vm.isEquipmentFailure) {
                return true;
            }
            if (vm.maintenanceStart) {
                if (!vm.defect.maintenanceStart ||
                    vm.maintenanceStart.getTime() !== vm.defect.maintenanceStart.getTime()) {
                    return true;
                }
            }
            else if (vm.defect.maintenanceStart) {
                return true;
            }
            if (vm.maintenanceEnd) {
                if (!vm.defect.maintenanceEnd ||
                    vm.maintenanceEnd.getTime() !== vm.defect.maintenanceEnd.getTime()) {
                    return true;
                }
            }
            else if (vm.defect.maintenanceEnd) {
                return true;
            }
            return false;
        };
        vm.openCriticalDefectReport = function () {
            criticalDefectService.openReport(shopId, vm.defect).then(function (data) {
                if (data) {
                    $modalInstance.close();
                }
            });
        };
        vm.requalificationToggled = function () {
            if (vm.requalification) {
                vm.requalificationDateTime = vm.rejectEnd;
            }
            else {
                vm.requalificationDateTime = null;
            }
        };
        vm.showRequalification = function () {
            return (vm.canRequalify &&
                vm.isMoldRejectInUse &&
                !isNullOrUndefined_1.default(vm.rejectEnd) &&
                moment(vm.rejectEnd).isValid() &&
                isNullOrUndefined_1.default(vm.defect.rejectEnd));
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, _) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var DowntimeType = (function () {
        function DowntimeType(downtimeTypeId, downtimeTypeDescription) {
            this.downtimeTypeId = downtimeTypeId;
            this.downtimeTypeDescription = downtimeTypeDescription;
        }
        return DowntimeType;
    }());
    exports.DowntimeType = DowntimeType;
    var DowntimeReason = (function () {
        function DowntimeReason(viewModel, downtimeTypes) {
            this.id = viewModel.id;
            this.code = viewModel.code;
            this.description = viewModel.description;
            this.entireMachine = viewModel.entireMachine;
            var downtimeType = _.find(downtimeTypes, { downtimeTypeId: viewModel.downtimeTypeId });
            if (!downtimeType) {
                downtimeType = new DowntimeType(viewModel.downtimeTypeId, viewModel.downtimeTypeDescription);
                downtimeTypes.push(downtimeType);
            }
            this.downtimeType = downtimeType;
        }
        return DowntimeReason;
    }());
    exports.DowntimeReason = DowntimeReason;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(37)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, hub_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.hubs.kpiChecks', [hub_service_1.default])
        .service('kpiChecksHubService', ["hubService", function (hubService) {
        function createKPIChecksHub(updateResult, shopId, wellKnownCheck) {
            return hubService.createHub('wellKnownCheck', {
                allowMultipleListeners: true,
                listeners: {
                    wellKnownCheckUpdated: function (wellKnownCheckUpdated) {
                        if (wellKnownCheckUpdated
                            && (wellKnownCheckUpdated.shopId === shopId)
                            && (wellKnownCheckUpdated.wellKnownCheck === wellKnownCheck)) {
                            updateResult(wellKnownCheckUpdated);
                        }
                    }
                },
                methods: ['leaveGroup', 'joinGroup'],
                postConnect: function (hub) {
                    hub.invokeWithRetry(function () { return hub.joinGroup(shopId, wellKnownCheck); });
                }
            });
        }
        return {
            createKPIChecksHub: createKPIChecksHub
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 113 */,
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular
        .module('aps.services.defectCauses', [http_service_1.default])
        .service('defectCausesService', ["httpService", function (httpService) {
        var getDefectCauseSelections = function (defectTypeId) {
            return httpService
                .get(constant_module_1.Endpoints.DEFECT_CAUSES.replace('{id}', defectTypeId));
        };
        var submitDefectCause = function (defectTypeCommand) {
            var url = constant_module_1.Endpoints.DEFECT_CAUSE_DETAILS.replace('{0}', defectTypeCommand.id);
            return httpService.post(url, defectTypeCommand);
        };
        var addDefectCause = function (defectTypeCommand) {
            var url = constant_module_1.Endpoints.DEFECT_CAUSE_ADD;
            return httpService.post(url, defectTypeCommand);
        };
        var getCourseOfActions = function () {
            var url = constant_module_1.Endpoints.COURSE_OF_ACTION;
            return httpService.get(url);
        };
        return {
            getDefectCauseSelections: getDefectCauseSelections,
            getCourseOfActions: getCourseOfActions,
            submitDefectCause: submitDefectCause,
            addDefectCause: addDefectCause
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular
        .module('aps.services.resetPassword', [http_service_1.default])
        .service('resetPasswordService', ["httpService", function (httpService) {
        var getResetOptions = function (userName) {
            return httpService.get(constant_module_1.Endpoints.RESET_PASSWORD, {
                userName: userName
            });
        };
        var submitEmailPasswordReset = function (payload) {
            return httpService.post(constant_module_1.Endpoints.RESET_PASSWORD_EMAIL, payload);
        };
        var submitQuestionPasswordReset = function (payload) {
            return httpService.post(constant_module_1.Endpoints.RESET_PASSWORD_QUESTION, payload);
        };
        var sendResetPasswordEmail = function (userName) {
            return httpService.post(constant_module_1.Endpoints.SEND_RESET_PASSWORD_EMAIL, {
                userName: userName
            });
        };
        return {
            getResetOptions: getResetOptions,
            submitEmailPasswordReset: submitEmailPasswordReset,
            submitQuestionPasswordReset: submitQuestionPasswordReset,
            sendResetPasswordEmail: sendResetPasswordEmail
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.services.tiamaDefectMapping', [http_service_1.default])
        .service('tiamaDefectMappingService', ["httpService", function (httpService) {
        function addTiamaDefectMapping(tiamaDefect) {
            return httpService.post(constant_module_1.Endpoints.TIAMA_DEFECT_MAPPINGS_ADD, tiamaDefect);
        }
        function updateTiamaDefectMapping(tiamaDefect) {
            var url = constant_module_1.Endpoints.TIAMA_DEFECT_MAPPINGS_DETAIL.replace('{0}', tiamaDefect.id);
            return httpService.post(url, tiamaDefect);
        }
        function getTiamaDefectMappings() {
            return httpService.get(constant_module_1.Endpoints.TIAMA_DEFECT_MAPPINGS);
        }
        function getTiamaDefectMapping(tiamaDefectId) {
            var url = constant_module_1.Endpoints.TIAMA_DEFECT_MAPPINGS_DETAIL.replace('{0}', tiamaDefectId);
            return httpService.get(url);
        }
        return {
            addTiamaDefectMapping: addTiamaDefectMapping,
            updateTiamaDefectMapping: updateTiamaDefectMapping,
            getTiamaDefectMappings: getTiamaDefectMappings,
            getTiamaDefectMapping: getTiamaDefectMapping
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 Highcharts JS v7.2.2 (2020-08-24)

 (c) 2009-2018 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(u){"object"===typeof module&&module.exports?(u["default"]=u,module.exports=u): true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(96)], __WEBPACK_AMD_DEFINE_RESULT__ = (function(B){u(B);u.Highcharts=B;return u}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):u("undefined"!==typeof Highcharts?Highcharts:void 0)})(function(u){function B(b,a,h,g){b.hasOwnProperty(a)||(b[a]=g.apply(null,h))}u=u?u._modules:{};B(u,"parts-more/Pane.js",[u["parts/Globals.js"],u["parts/Utilities.js"]],function(b,a){function h(e,c){this.init(e,c)}var g=a.extend,
m=a.splat,n=b.CenteredSeriesMixin,q=b.merge;g(h.prototype,{coll:"pane",init:function(e,c){this.chart=c;this.background=[];c.pane.push(this);this.setOptions(e)},setOptions:function(e){this.options=q(this.defaultOptions,this.chart.angular?{background:{}}:void 0,e)},render:function(){var e=this.options,c=this.options.background,a=this.chart.renderer;this.group||(this.group=a.g("pane-group").attr({zIndex:e.zIndex||0}).add());this.updateCenter();if(c)for(c=m(c),e=Math.max(c.length,this.background.length||
0),a=0;a<e;a++)c[a]&&this.axis?this.renderBackground(q(this.defaultBackgroundOptions,c[a]),a):this.background[a]&&(this.background[a]=this.background[a].destroy(),this.background.splice(a,1))},renderBackground:function(a,c){var e="animate",v={"class":"highcharts-pane "+(a.className||"")};this.chart.styledMode||g(v,{fill:a.backgroundColor,stroke:a.borderColor,"stroke-width":a.borderWidth});this.background[c]||(this.background[c]=this.chart.renderer.path().add(this.group),e="attr");this.background[c][e]({d:this.axis.getPlotBandPath(a.from,
a.to,a)}).attr(v)},defaultOptions:{center:["50%","50%"],size:"85%",startAngle:0},defaultBackgroundOptions:{shape:"circle",borderWidth:1,borderColor:"#cccccc",backgroundColor:{linearGradient:{x1:0,y1:0,x2:0,y2:1},stops:[[0,"#ffffff"],[1,"#e6e6e6"]]},from:-Number.MAX_VALUE,innerRadius:0,to:Number.MAX_VALUE,outerRadius:"105%"},updateCenter:function(a){this.center=(a||this.axis||{}).center=n.getCenter.call(this)},update:function(a,c){q(!0,this.options,a);q(!0,this.chart.options.pane,a);this.setOptions(this.options);
this.render();this.chart.axes.forEach(function(a){a.pane===this&&(a.pane=null,a.update({},c))},this)}});b.Pane=h});B(u,"parts-more/RadialAxis.js",[u["parts/Globals.js"],u["parts/Utilities.js"]],function(b,a){var h=a.extend,g=a.pick,m=a.pInt;a=b.addEvent;var n=b.Axis,q=b.merge,e=b.noop,c=b.Tick,f=b.wrap,v=b.correctFloat,t=n.prototype,p=c.prototype;var x={getOffset:e,redraw:function(){this.isDirty=!1},render:function(){this.isDirty=!1},createLabelCollector:function(){return!1},setScale:e,setCategories:e,
setTitle:e};var z={defaultRadialGaugeOptions:{labels:{align:"center",x:0,y:null},minorGridLineWidth:0,minorTickInterval:"auto",minorTickLength:10,minorTickPosition:"inside",minorTickWidth:1,tickLength:10,tickPosition:"inside",tickWidth:2,title:{rotation:0},zIndex:2},defaultRadialXOptions:{gridLineWidth:1,labels:{align:null,distance:15,x:0,y:null,style:{textOverflow:"none"}},maxPadding:0,minPadding:0,showLastLabel:!1,tickLength:0},defaultRadialYOptions:{gridLineInterpolation:"circle",labels:{align:"right",
x:-3,y:-2},showLastLabel:!1,title:{x:4,text:null,rotation:90}},setOptions:function(l){l=this.options=q(this.defaultOptions,this.defaultRadialOptions,l);l.plotBands||(l.plotBands=[]);b.fireEvent(this,"afterSetOptions")},getOffset:function(){t.getOffset.call(this);this.chart.axisOffset[this.side]=0},getLinePath:function(l,d){l=this.center;var k=this.chart,r=g(d,l[2]/2-this.offset);this.isCircular||void 0!==d?(d=this.chart.renderer.symbols.arc(this.left+l[0],this.top+l[1],r,r,{start:this.startAngleRad,
end:this.endAngleRad,open:!0,innerR:0}),d.xBounds=[this.left+l[0]],d.yBounds=[this.top+l[1]-r]):(d=this.postTranslate(this.angleRad,r),d=["M",l[0]+k.plotLeft,l[1]+k.plotTop,"L",d.x,d.y]);return d},setAxisTranslation:function(){t.setAxisTranslation.call(this);this.center&&(this.transA=this.isCircular?(this.endAngleRad-this.startAngleRad)/(this.max-this.min||1):this.center[2]/2/(this.max-this.min||1),this.minPixelPadding=this.isXAxis?this.transA*this.minPointOffset:0)},beforeSetTickPositions:function(){if(this.autoConnect=
this.isCircular&&void 0===g(this.userMax,this.options.max)&&v(this.endAngleRad-this.startAngleRad)===v(2*Math.PI))this.max+=this.categories&&1||this.pointRange||this.closestPointRange||0},setAxisSize:function(){t.setAxisSize.call(this);this.isRadial&&(this.pane.updateCenter(this),this.isCircular&&(this.sector=this.endAngleRad-this.startAngleRad),this.len=this.width=this.height=this.center[2]*g(this.sector,1)/2)},getPosition:function(l,d){return this.postTranslate(this.isCircular?this.translate(l):
this.angleRad,g(this.isCircular?d:this.translate(l),this.center[2]/2)-this.offset)},postTranslate:function(l,d){var k=this.chart,r=this.center;l=this.startAngleRad+l;return{x:k.plotLeft+r[0]+Math.cos(l)*d,y:k.plotTop+r[1]+Math.sin(l)*d}},getPlotBandPath:function(l,d,k){var r=this.center,w=this.startAngleRad,c=r[2]/2,a=[g(k.outerRadius,"100%"),k.innerRadius,g(k.thickness,10)],e=Math.min(this.offset,0),v=/%$/;var p=this.isCircular;if("polygon"===this.options.gridLineInterpolation)a=this.getPlotLinePath({value:l}).concat(this.getPlotLinePath({value:d,
reverse:!0}));else{l=Math.max(l,this.min);d=Math.min(d,this.max);p||(a[0]=this.translate(l),a[1]=this.translate(d));a=a.map(function(d){v.test(d)&&(d=m(d,10)*c/100);return d});if("circle"!==k.shape&&p)l=w+this.translate(l),d=w+this.translate(d);else{l=-Math.PI/2;d=1.5*Math.PI;var t=!0}a[0]-=e;a[2]-=e;a=this.chart.renderer.symbols.arc(this.left+r[0],this.top+r[1],a[0],a[0],{start:Math.min(l,d),end:Math.max(l,d),innerR:g(a[1],a[0]-a[2]),open:t});p&&(p=(d+l)/2,e=this.left+r[0]+r[2]/2*Math.cos(p),a.xBounds=
p>-Math.PI/2&&p<Math.PI/2?[e,this.chart.plotWidth]:[0,e],a.yBounds=[this.top+r[1]+r[2]/2*Math.sin(p)],a.yBounds[0]+=p>-Math.PI&&0>p||p>Math.PI?-10:10)}return a},getPlotLinePath:function(c){var d=this,k=d.center,r=d.chart,w=c.value;c=c.reverse;var l=d.getPosition(w),a=d.pane.options.background?d.pane.options.background[0]||d.pane.options.background:{},e=a.innerRadius||"0%",p=a.outerRadius||"100%";a=k[0]+r.plotLeft;k=k[1]+r.plotTop;var v=l.x;l=l.y;var t,f;if(d.isCircular){r="string"===typeof e?b.relativeLength(e,
1):e/Math.sqrt(Math.pow(v-a,2)+Math.pow(l-k,2));c="string"===typeof p?b.relativeLength(p,1):p/Math.sqrt(Math.pow(v-a,2)+Math.pow(l-k,2));var g=["M",a+r*(v-a),k-r*(k-l),"L",v-(1-c)*(v-a),l+(1-c)*(k-l)]}else"circle"===d.options.gridLineInterpolation?(w=d.translate(w),g=d.getLinePath(0,w)):(r.xAxis.forEach(function(k){k.pane===d.pane&&(t=k)}),g=[],w=d.translate(w),r=t.tickPositions,t.autoConnect&&(r=r.concat([r[0]])),c&&(r=[].concat(r).reverse()),r.forEach(function(d,k){f=t.getPosition(d,w);g.push(k?
"L":"M",f.x,f.y)}));return g},getTitlePosition:function(){var c=this.center,d=this.chart,k=this.options.title;return{x:d.plotLeft+c[0]+(k.x||0),y:d.plotTop+c[1]-{high:.5,middle:.25,low:0}[k.align]*c[2]+(k.y||0)}},createLabelCollector:function(){var c=this;return function(){if(c.isRadial&&c.tickPositions&&!0!==c.options.labels.allowOverlap)return c.tickPositions.map(function(d){return c.ticks[d]&&c.ticks[d].label}).filter(function(d){return!!d})}}};a(n,"init",function(c){var d=this.chart,k=d.angular,
r=d.polar,w=this.isXAxis,a=k&&w,l,e=d.options;c=c.userOptions.pane||0;c=this.pane=d.pane&&d.pane[c];if("colorAxis"===this.coll)this.isRadial=!1;else{if(k){if(h(this,a?x:z),l=!w)this.defaultRadialOptions=this.defaultRadialGaugeOptions}else r&&(h(this,z),this.defaultRadialOptions=(l=w)?this.defaultRadialXOptions:q(this.defaultYAxisOptions,this.defaultRadialYOptions));k||r?(this.isRadial=!0,d.inverted=!1,e.chart.zoomType=null,this.labelCollector||(this.labelCollector=this.createLabelCollector()),this.labelCollector&&
d.labelCollectors.push(this.labelCollector)):this.isRadial=!1;c&&l&&(c.axis=this);this.isCircular=l}});a(n,"afterInit",function(){var c=this.chart,d=this.options,k=this.pane,r=k&&k.options;c.angular&&this.isXAxis||!k||!c.angular&&!c.polar||(this.angleRad=(d.angle||0)*Math.PI/180,this.startAngleRad=(r.startAngle-90)*Math.PI/180,this.endAngleRad=(g(r.endAngle,r.startAngle+360)-90)*Math.PI/180,this.offset=d.offset||0)});a(n,"autoLabelAlign",function(c){this.isRadial&&(c.align=void 0,c.preventDefault())});
a(n,"destroy",function(){if(this.chart&&this.chart.labelCollectors){var c=this.chart.labelCollectors.indexOf(this.labelCollector);0<=c&&this.chart.labelCollectors.splice(c,1)}});a(c,"afterGetPosition",function(c){this.axis.getPosition&&h(c.pos,this.axis.getPosition(this.pos))});a(c,"afterGetLabelPosition",function(c){var d=this.axis,k=this.label,r=k.getBBox(),w=d.options.labels,a=w.y,l=20,e=w.align,v=(d.translate(this.pos)+d.startAngleRad+Math.PI/2)/Math.PI*180%360,p=Math.round(v),t="end",f=0>p?p+
360:p,m=f,h=0,n=0,z=null===w.y?.3*-r.height:0;if(d.isRadial){var x=d.getPosition(this.pos,d.center[2]/2+b.relativeLength(g(w.distance,-25),d.center[2]/2,-d.center[2]/2));"auto"===w.rotation?k.attr({rotation:v}):null===a&&(a=d.chart.renderer.fontMetrics(k.styles&&k.styles.fontSize).b-r.height/2);null===e&&(d.isCircular?(r.width>d.len*d.tickInterval/(d.max-d.min)&&(l=0),e=v>l&&v<180-l?"left":v>180+l&&v<360-l?"right":"center"):e="center",k.attr({align:e}));if("auto"===e&&2===d.tickPositions.length&&
d.isCircular){90<f&&180>f?f=180-f:270<f&&360>=f&&(f=540-f);180<m&&360>=m&&(m=360-m);if(d.pane.options.startAngle===p||d.pane.options.startAngle===p+360||d.pane.options.startAngle===p-360)t="start";e=-90<=p&&90>=p||-360<=p&&-270>=p||270<=p&&360>=p?"start"===t?"right":"left":"start"===t?"left":"right";70<m&&110>m&&(e="center");15>f||180<=f&&195>f?h=.3*r.height:15<=f&&35>=f?h="start"===t?0:.75*r.height:195<=f&&215>=f?h="start"===t?.75*r.height:0:35<f&&90>=f?h="start"===t?.25*-r.height:r.height:215<f&&
270>=f&&(h="start"===t?r.height:.25*-r.height);15>m?n="start"===t?.15*-r.height:.15*r.height:165<m&&180>=m&&(n="start"===t?.15*r.height:.15*-r.height);k.attr({align:e});k.translate(n,h+z)}c.pos.x=x.x+w.x;c.pos.y=x.y+a}});f(p,"getMarkPath",function(c,d,k,r,w,a,e){var l=this.axis;l.isRadial?(c=l.getPosition(this.pos,l.center[2]/2+r),d=["M",d,k,"L",c.x,c.y]):d=c.call(this,d,k,r,w,a,e);return d})});B(u,"parts-more/AreaRangeSeries.js",[u["parts/Globals.js"],u["parts/Utilities.js"]],function(b,a){var h=
a.defined,g=a.extend,m=a.isArray,n=a.isNumber,q=a.pick;a=b.seriesType;var e=b.seriesTypes,c=b.Series.prototype,f=b.Point.prototype;a("arearange","area",{lineWidth:1,threshold:null,tooltip:{pointFormat:'<span style="color:{series.color}">\u25cf</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>'},trackByArea:!0,dataLabels:{align:null,verticalAlign:null,xLow:0,xHigh:0,yLow:0,yHigh:0}},{pointArrayMap:["low","high"],pointValKey:"low",deferTranslatePolar:!0,toYData:function(c){return[c.low,
c.high]},highToXY:function(c){var a=this.chart,e=this.xAxis.postTranslate(c.rectPlotX,this.yAxis.len-c.plotHigh);c.plotHighX=e.x-a.plotLeft;c.plotHigh=e.y-a.plotTop;c.plotLowX=c.plotX},translate:function(){var c=this,a=c.yAxis,p=!!c.modifyValue;e.area.prototype.translate.apply(c);c.points.forEach(function(e){var f=e.high,l=e.plotY;e.isNull?e.plotY=null:(e.plotLow=l,e.plotHigh=a.translate(p?c.modifyValue(f,e):f,0,1,0,1),p&&(e.yBottom=e.plotHigh))});this.chart.polar&&this.points.forEach(function(a){c.highToXY(a);
a.tooltipPos=[(a.plotHighX+a.plotLowX)/2,(a.plotHigh+a.plotLow)/2]})},getGraphPath:function(c){var a=[],p=[],f,g=e.area.prototype.getGraphPath;var l=this.options;var d=this.chart.polar&&!1!==l.connectEnds,k=l.connectNulls,r=l.step;c=c||this.points;for(f=c.length;f--;){var w=c[f];w.isNull||d||k||c[f+1]&&!c[f+1].isNull||p.push({plotX:w.plotX,plotY:w.plotY,doCurve:!1});var F={polarPlotY:w.polarPlotY,rectPlotX:w.rectPlotX,yBottom:w.yBottom,plotX:q(w.plotHighX,w.plotX),plotY:w.plotHigh,isNull:w.isNull};
p.push(F);a.push(F);w.isNull||d||k||c[f-1]&&!c[f-1].isNull||p.push({plotX:w.plotX,plotY:w.plotY,doCurve:!1})}c=g.call(this,c);r&&(!0===r&&(r="left"),l.step={left:"right",center:"center",right:"left"}[r]);a=g.call(this,a);p=g.call(this,p);l.step=r;l=[].concat(c,a);this.chart.polar||"M"!==p[0]||(p[0]="L");this.graphPath=l;this.areaPath=c.concat(p);l.isArea=!0;l.xMap=c.xMap;this.areaPath.xMap=c.xMap;return l},drawDataLabels:function(){var a=this.points,e=a.length,f,b=[],h=this.options.dataLabels,l,d=
this.chart.inverted;if(m(h))if(1<h.length){var k=h[0];var r=h[1]}else k=h[0],r={enabled:!1};else k=g({},h),k.x=h.xHigh,k.y=h.yHigh,r=g({},h),r.x=h.xLow,r.y=h.yLow;if(k.enabled||this._hasPointLabels){for(f=e;f--;)if(l=a[f]){var w=k.inside?l.plotHigh<l.plotLow:l.plotHigh>l.plotLow;l.y=l.high;l._plotY=l.plotY;l.plotY=l.plotHigh;b[f]=l.dataLabel;l.dataLabel=l.dataLabelUpper;l.below=w;d?k.align||(k.align=w?"right":"left"):k.verticalAlign||(k.verticalAlign=w?"top":"bottom")}this.options.dataLabels=k;c.drawDataLabels&&
c.drawDataLabels.apply(this,arguments);for(f=e;f--;)if(l=a[f])l.dataLabelUpper=l.dataLabel,l.dataLabel=b[f],delete l.dataLabels,l.y=l.low,l.plotY=l._plotY}if(r.enabled||this._hasPointLabels){for(f=e;f--;)if(l=a[f])w=r.inside?l.plotHigh<l.plotLow:l.plotHigh>l.plotLow,l.below=!w,d?r.align||(r.align=w?"left":"right"):r.verticalAlign||(r.verticalAlign=w?"bottom":"top");this.options.dataLabels=r;c.drawDataLabels&&c.drawDataLabels.apply(this,arguments)}if(k.enabled)for(f=e;f--;)if(l=a[f])l.dataLabels=[l.dataLabelUpper,
l.dataLabel].filter(function(d){return!!d});this.options.dataLabels=h},alignDataLabel:function(){e.column.prototype.alignDataLabel.apply(this,arguments)},drawPoints:function(){var a=this.points.length,e;c.drawPoints.apply(this,arguments);for(e=0;e<a;){var f=this.points[e];f.origProps={plotY:f.plotY,plotX:f.plotX,isInside:f.isInside,negative:f.negative,zone:f.zone,y:f.y};f.lowerGraphic=f.graphic;f.graphic=f.upperGraphic;f.plotY=f.plotHigh;h(f.plotHighX)&&(f.plotX=f.plotHighX);f.y=f.high;f.negative=
f.high<(this.options.threshold||0);f.zone=this.zones.length&&f.getZone();this.chart.polar||(f.isInside=f.isTopInside=void 0!==f.plotY&&0<=f.plotY&&f.plotY<=this.yAxis.len&&0<=f.plotX&&f.plotX<=this.xAxis.len);e++}c.drawPoints.apply(this,arguments);for(e=0;e<a;)f=this.points[e],f.upperGraphic=f.graphic,f.graphic=f.lowerGraphic,g(f,f.origProps),delete f.origProps,e++},setStackedPoints:b.noop},{setState:function(){var c=this.state,a=this.series,e=a.chart.polar;h(this.plotHigh)||(this.plotHigh=a.yAxis.toPixels(this.high,
!0));h(this.plotLow)||(this.plotLow=this.plotY=a.yAxis.toPixels(this.low,!0));a.stateMarkerGraphic&&(a.lowerStateMarkerGraphic=a.stateMarkerGraphic,a.stateMarkerGraphic=a.upperStateMarkerGraphic);this.graphic=this.upperGraphic;this.plotY=this.plotHigh;e&&(this.plotX=this.plotHighX);f.setState.apply(this,arguments);this.state=c;this.plotY=this.plotLow;this.graphic=this.lowerGraphic;e&&(this.plotX=this.plotLowX);a.stateMarkerGraphic&&(a.upperStateMarkerGraphic=a.stateMarkerGraphic,a.stateMarkerGraphic=
a.lowerStateMarkerGraphic,a.lowerStateMarkerGraphic=void 0);f.setState.apply(this,arguments)},haloPath:function(){var c=this.series.chart.polar,a=[];this.plotY=this.plotLow;c&&(this.plotX=this.plotLowX);this.isInside&&(a=f.haloPath.apply(this,arguments));this.plotY=this.plotHigh;c&&(this.plotX=this.plotHighX);this.isTopInside&&(a=a.concat(f.haloPath.apply(this,arguments)));return a},destroyElements:function(){["lowerGraphic","upperGraphic"].forEach(function(c){this[c]&&(this[c]=this[c].destroy())},
this);this.graphic=null;return f.destroyElements.apply(this,arguments)},isValid:function(){return n(this.low)&&n(this.high)}});""});B(u,"parts-more/AreaSplineRangeSeries.js",[u["parts/Globals.js"]],function(b){var a=b.seriesType;a("areasplinerange","arearange",null,{getPointSpline:b.seriesTypes.spline.prototype.getPointSpline});""});B(u,"parts-more/ColumnRangeSeries.js",[u["parts/Globals.js"],u["parts/Utilities.js"]],function(b,a){var h=a.pick;a=b.defaultPlotOptions;var g=b.merge,m=b.noop,n=b.seriesType,
q=b.seriesTypes.column.prototype;n("columnrange","arearange",g(a.column,a.arearange,{pointRange:null,marker:null,states:{hover:{halo:!1}}}),{translate:function(){var a=this,c=a.yAxis,f=a.xAxis,g=f.startAngleRad,m,b=a.chart,n=a.xAxis.isRadial,z=Math.max(b.chartWidth,b.chartHeight)+999,l;q.translate.apply(a);a.points.forEach(function(d){var k=d.shapeArgs,r=a.options.minPointLength;d.plotHigh=l=Math.min(Math.max(-z,c.translate(d.high,0,1,0,1)),z);d.plotLow=Math.min(Math.max(-z,d.plotY),z);var w=l;var e=
h(d.rectPlotY,d.plotY)-l;Math.abs(e)<r?(r-=e,e+=r,w-=r/2):0>e&&(e*=-1,w-=e);n?(m=d.barX+g,d.shapeType="path",d.shapeArgs={d:a.polarArc(w+e,w,m,m+d.pointWidth)}):(k.height=e,k.y=w,d.tooltipPos=b.inverted?[c.len+c.pos-b.plotLeft-w-e/2,f.len+f.pos-b.plotTop-k.x-k.width/2,e]:[f.left-b.plotLeft+k.x+k.width/2,c.pos-b.plotTop+w+e/2,e])})},directTouch:!0,trackerGroups:["group","dataLabelsGroup"],drawGraph:m,getSymbol:m,crispCol:function(){return q.crispCol.apply(this,arguments)},drawPoints:function(){return q.drawPoints.apply(this,
arguments)},drawTracker:function(){return q.drawTracker.apply(this,arguments)},getColumnMetrics:function(){return q.getColumnMetrics.apply(this,arguments)},pointAttribs:function(){return q.pointAttribs.apply(this,arguments)},animate:function(){return q.animate.apply(this,arguments)},polarArc:function(){return q.polarArc.apply(this,arguments)},translate3dPoints:function(){return q.translate3dPoints.apply(this,arguments)},translate3dShapes:function(){return q.translate3dShapes.apply(this,arguments)}},
{setState:q.pointClass.prototype.setState});""});B(u,"parts-more/ColumnPyramidSeries.js",[u["parts/Globals.js"],u["parts/Utilities.js"]],function(b,a){var h=a.pick;a=b.seriesType;var g=b.seriesTypes.column.prototype;a("columnpyramid","column",{},{translate:function(){var a=this,b=a.chart,q=a.options,e=a.dense=2>a.closestPointRange*a.xAxis.transA;e=a.borderWidth=h(q.borderWidth,e?0:1);var c=a.yAxis,f=q.threshold,v=a.translatedThreshold=c.getThreshold(f),t=h(q.minPointLength,5),p=a.getColumnMetrics(),
x=p.width,z=a.barW=Math.max(x,1+2*e),l=a.pointXOffset=p.offset;b.inverted&&(v-=.5);q.pointPadding&&(z=Math.ceil(z));g.translate.apply(a);a.points.forEach(function(d){var k=h(d.yBottom,v),r=999+Math.abs(k),w=Math.min(Math.max(-r,d.plotY),c.len+r);r=d.plotX+l;var e=z/2,C=Math.min(w,k);k=Math.max(w,k)-C;d.barX=r;d.pointWidth=x;d.tooltipPos=b.inverted?[c.len+c.pos-b.plotLeft-w,a.xAxis.len-r-e,k]:[r+e,w+c.pos-b.plotTop,k];w=f+(d.total||d.y);"percent"===q.stacking&&(w=f+(0>d.y)?-100:100);w=c.toPixels(w,
!0);var g=b.plotHeight-w-(b.plotHeight-v);var m=e*(C-w)/g;var p=e*(C+k-w)/g;g=r-m+e;m=r+m+e;var n=r+p+e;p=r-p+e;var E=C-t;var D=C+k;0>d.y&&(E=C,D=C+k+t);b.inverted&&(n=b.plotWidth-C,g=w-(b.plotWidth-v),m=e*(w-n)/g,p=e*(w-(n-k))/g,g=r+e+m,m=g-2*m,n=r-p+e,p=r+p+e,E=C,D=C+k-t,0>d.y&&(D=C+k+t));d.shapeType="path";d.shapeArgs={x:g,y:E,width:m-g,height:k,d:["M",g,E,"L",m,E,n,D,p,D,"Z"]}})}});""});B(u,"parts-more/GaugeSeries.js",[u["parts/Globals.js"],u["parts/Utilities.js"]],function(b,a){var h=a.isNumber,
g=a.pick,m=a.pInt,n=b.merge,q=b.Series;a=b.seriesType;var e=b.TrackerMixin;a("gauge","line",{dataLabels:{borderColor:"#cccccc",borderRadius:3,borderWidth:1,crop:!1,defer:!1,enabled:!0,verticalAlign:"top",y:15,zIndex:2},dial:{},pivot:{},tooltip:{headerFormat:""},showInLegend:!1},{angular:!0,directTouch:!0,drawGraph:b.noop,fixedBox:!0,forceDL:!0,noSharedTooltip:!0,trackerGroups:["group","dataLabelsGroup"],translate:function(){var c=this.yAxis,a=this.options,e=c.center;this.generatePoints();this.points.forEach(function(f){var b=
n(a.dial,f.dial),v=m(g(b.radius,"80%"))*e[2]/200,t=m(g(b.baseLength,"70%"))*v/100,l=m(g(b.rearLength,"10%"))*v/100,d=b.baseWidth||3,k=b.topWidth||1,r=a.overshoot,w=c.startAngleRad+c.translate(f.y,null,null,null,!0);h(r)?(r=r/180*Math.PI,w=Math.max(c.startAngleRad-r,Math.min(c.endAngleRad+r,w))):!1===a.wrap&&(w=Math.max(c.startAngleRad,Math.min(c.endAngleRad,w)));w=180*w/Math.PI;f.shapeType="path";f.shapeArgs={d:b.path||["M",-l,-d/2,"L",t,-d/2,v,-k/2,v,k/2,t,d/2,-l,d/2,"z"],translateX:e[0],translateY:e[1],
rotation:w};f.plotX=e[0];f.plotY=e[1]})},drawPoints:function(){var c=this,a=c.chart,e=c.yAxis.center,b=c.pivot,m=c.options,h=m.pivot,q=a.renderer;c.points.forEach(function(e){var d=e.graphic,k=e.shapeArgs,r=k.d,w=n(m.dial,e.dial);d?(d.animate(k),k.d=r):e.graphic=q[e.shapeType](k).attr({rotation:k.rotation,zIndex:1}).addClass("highcharts-dial").add(c.group);if(!a.styledMode)e.graphic[d?"animate":"attr"]({stroke:w.borderColor||"none","stroke-width":w.borderWidth||0,fill:w.backgroundColor||"#000000"})});
b?b.animate({translateX:e[0],translateY:e[1]}):(c.pivot=q.circle(0,0,g(h.radius,5)).attr({zIndex:2}).addClass("highcharts-pivot").translate(e[0],e[1]).add(c.group),a.styledMode||c.pivot.attr({"stroke-width":h.borderWidth||0,stroke:h.borderColor||"#cccccc",fill:h.backgroundColor||"#000000"}))},animate:function(c){var a=this;c||(a.points.forEach(function(c){var e=c.graphic;e&&(e.attr({rotation:180*a.yAxis.startAngleRad/Math.PI}),e.animate({rotation:c.shapeArgs.rotation},a.options.animation))}),a.animate=
null)},render:function(){this.group=this.plotGroup("group","series",this.visible?"visible":"hidden",this.options.zIndex,this.chart.seriesGroup);q.prototype.render.call(this);this.group.clip(this.chart.clipRect)},setData:function(c,a){q.prototype.setData.call(this,c,!1);this.processData();this.generatePoints();g(a,!0)&&this.chart.redraw()},hasData:function(){return!!this.points.length},drawTracker:e&&e.drawTrackerPoint},{setState:function(c){this.state=c}});""});B(u,"parts-more/BoxPlotSeries.js",[u["parts/Globals.js"],
u["parts/Utilities.js"]],function(b,a){var h=a.pick;a=b.noop;var g=b.seriesType,m=b.seriesTypes;g("boxplot","column",{threshold:null,tooltip:{pointFormat:'<span style="color:{point.color}">\u25cf</span> <b> {series.name}</b><br/>Maximum: {point.high}<br/>Upper quartile: {point.q3}<br/>Median: {point.median}<br/>Lower quartile: {point.q1}<br/>Minimum: {point.low}<br/>'},whiskerLength:"50%",fillColor:"#ffffff",lineWidth:1,medianWidth:2,whiskerWidth:2},{pointArrayMap:["low","q1","median","q3","high"],
toYData:function(a){return[a.low,a.q1,a.median,a.q3,a.high]},pointValKey:"high",pointAttribs:function(){return{}},drawDataLabels:a,translate:function(){var a=this.yAxis,b=this.pointArrayMap;m.column.prototype.translate.apply(this);this.points.forEach(function(e){b.forEach(function(c){null!==e[c]&&(e[c+"Plot"]=a.translate(e[c],0,1,0,1))})})},drawPoints:function(){var a=this,b=a.options,e=a.chart,c=e.renderer,f,g,m,p,x,z,l=0,d,k,r,w,F=!1!==a.doQuartiles,C,H=a.options.whiskerLength;a.points.forEach(function(A){var v=
A.graphic,t=v?"animate":"attr",n=A.shapeArgs,q={},G={},y={},I={},u=A.color||a.color;void 0!==A.plotY&&(d=n.width,k=Math.floor(n.x),r=k+d,w=Math.round(d/2),f=Math.floor(F?A.q1Plot:A.lowPlot),g=Math.floor(F?A.q3Plot:A.lowPlot),m=Math.floor(A.highPlot),p=Math.floor(A.lowPlot),v||(A.graphic=v=c.g("point").add(a.group),A.stem=c.path().addClass("highcharts-boxplot-stem").add(v),H&&(A.whiskers=c.path().addClass("highcharts-boxplot-whisker").add(v)),F&&(A.box=c.path(void 0).addClass("highcharts-boxplot-box").add(v)),
A.medianShape=c.path(void 0).addClass("highcharts-boxplot-median").add(v)),e.styledMode||(G.stroke=A.stemColor||b.stemColor||u,G["stroke-width"]=h(A.stemWidth,b.stemWidth,b.lineWidth),G.dashstyle=A.stemDashStyle||b.stemDashStyle,A.stem.attr(G),H&&(y.stroke=A.whiskerColor||b.whiskerColor||u,y["stroke-width"]=h(A.whiskerWidth,b.whiskerWidth,b.lineWidth),A.whiskers.attr(y)),F&&(q.fill=A.fillColor||b.fillColor||u,q.stroke=b.lineColor||u,q["stroke-width"]=b.lineWidth||0,A.box.attr(q)),I.stroke=A.medianColor||
b.medianColor||u,I["stroke-width"]=h(A.medianWidth,b.medianWidth,b.lineWidth),A.medianShape.attr(I)),z=A.stem.strokeWidth()%2/2,l=k+w+z,A.stem[t]({d:["M",l,g,"L",l,m,"M",l,f,"L",l,p]}),F&&(z=A.box.strokeWidth()%2/2,f=Math.floor(f)+z,g=Math.floor(g)+z,k+=z,r+=z,A.box[t]({d:["M",k,g,"L",k,f,"L",r,f,"L",r,g,"L",k,g,"z"]})),H&&(z=A.whiskers.strokeWidth()%2/2,m+=z,p+=z,C=/%$/.test(H)?w*parseFloat(H)/100:H/2,A.whiskers[t]({d:["M",l-C,m,"L",l+C,m,"M",l-C,p,"L",l+C,p]})),x=Math.round(A.medianPlot),z=A.medianShape.strokeWidth()%
2/2,x+=z,A.medianShape[t]({d:["M",k,x,"L",r,x]}))})},setStackedPoints:a});""});B(u,"parts-more/ErrorBarSeries.js",[u["parts/Globals.js"]],function(b){var a=b.noop,h=b.seriesType,g=b.seriesTypes;h("errorbar","boxplot",{color:"#000000",grouping:!1,linkedTo:":previous",tooltip:{pointFormat:'<span style="color:{point.color}">\u25cf</span> {series.name}: <b>{point.low}</b> - <b>{point.high}</b><br/>'},whiskerWidth:null},{type:"errorbar",pointArrayMap:["low","high"],toYData:function(a){return[a.low,a.high]},
pointValKey:"high",doQuartiles:!1,drawDataLabels:g.arearange?function(){var a=this.pointValKey;g.arearange.prototype.drawDataLabels.call(this);this.data.forEach(function(b){b.y=b[a]})}:a,getColumnMetrics:function(){return this.linkedParent&&this.linkedParent.columnMetrics||g.column.prototype.getColumnMetrics.call(this)}});""});B(u,"parts-more/WaterfallSeries.js",[u["parts/Globals.js"],u["parts/Utilities.js"]],function(b,a){var h=a.arrayMax,g=a.arrayMin,m=a.isNumber,n=a.objectEach,q=a.pick,e=b.correctFloat;
a=b.addEvent;var c=b.Axis,f=b.Chart,v=b.Point,t=b.Series,p=b.StackItem,x=b.seriesType,z=b.seriesTypes;a(c,"afterInit",function(){this.isXAxis||(this.waterfallStacks={changed:!1})});a(f,"beforeRedraw",function(){for(var a=this.axes,d=this.series,k=d.length;k--;)d[k].options.stacking&&(a.forEach(function(d){d.isXAxis||(d.waterfallStacks.changed=!0)}),k=0)});a(c,"afterRender",function(){var a=this.options.stackLabels;a&&a.enabled&&this.waterfallStacks&&this.renderWaterfallStackTotals()});c.prototype.renderWaterfallStackTotals=
function(){var a=this.waterfallStacks,d=this.stackTotalGroup,k=new p(this,this.options.stackLabels,!1,0,void 0);this.dummyStackItem=k;n(a,function(a){n(a,function(a){k.total=a.stackTotal;a.label&&(k.label=a.label);p.prototype.render.call(k,d);a.label=k.label;delete k.label})});k.total=null};x("waterfall","column",{dataLabels:{inside:!0},lineWidth:1,lineColor:"#333333",dashStyle:"Dot",borderColor:"#333333",states:{hover:{lineWidthPlus:0}}},{pointValKey:"y",showLine:!0,generatePoints:function(){var a;
z.column.prototype.generatePoints.apply(this);var d=0;for(a=this.points.length;d<a;d++){var k=this.points[d];var c=this.processedYData[d];if(k.isIntermediateSum||k.isSum)k.y=e(c)}},translate:function(){var a=this.options,d=this.yAxis,k,c=q(a.minPointLength,5),e=c/2,f=a.threshold,b=a.stacking,g=d.waterfallStacks[this.stackKey];z.column.prototype.translate.apply(this);var m=k=f;var h=this.points;var v=0;for(a=h.length;v<a;v++){var p=h[v];var t=this.processedYData[v];var n=p.shapeArgs;var y=[0,t];var x=
p.y;if(b){if(g){y=g[v];if("overlap"===b){var u=y.stackState[y.stateIndex--];u=0<=x?u:u-x;Object.hasOwnProperty.call(y,"absolutePos")&&delete y.absolutePos;Object.hasOwnProperty.call(y,"absoluteNeg")&&delete y.absoluteNeg}else 0<=x?(u=y.threshold+y.posTotal,y.posTotal-=x):(u=y.threshold+y.negTotal,y.negTotal-=x,u-=x),!y.posTotal&&Object.hasOwnProperty.call(y,"absolutePos")&&(y.posTotal=y.absolutePos,delete y.absolutePos),!y.negTotal&&Object.hasOwnProperty.call(y,"absoluteNeg")&&(y.negTotal=y.absoluteNeg,
delete y.absoluteNeg);p.isSum||(y.connectorThreshold=y.threshold+y.stackTotal);d.reversed?(t=0<=x?u-x:u+x,x=u):(t=u,x=u-x);p.below=t<=q(f,0);n.y=d.translate(t,0,1,0,1);n.height=Math.abs(n.y-d.translate(x,0,1,0,1))}if(x=d.dummyStackItem)x.x=v,x.label=g[v].label,x.setOffset(this.pointXOffset||0,this.barW||0,this.stackedYNeg[v],this.stackedYPos[v])}else u=Math.max(m,m+x)+y[0],n.y=d.translate(u,0,1,0,1),p.isSum?(n.y=d.translate(y[1],0,1,0,1),n.height=Math.min(d.translate(y[0],0,1,0,1),d.len)-n.y):p.isIntermediateSum?
(0<=x?(t=y[1]+k,x=k):(t=k,x=y[1]+k),d.reversed&&(t^=x,x^=t,t^=x),n.y=d.translate(t,0,1,0,1),n.height=Math.abs(n.y-Math.min(d.translate(x,0,1,0,1),d.len)),k+=y[1]):(n.height=0<t?d.translate(m,0,1,0,1)-n.y:d.translate(m,0,1,0,1)-d.translate(m-t,0,1,0,1),m+=t,p.below=m<q(f,0)),0>n.height&&(n.y+=n.height,n.height*=-1);p.plotY=n.y=Math.round(n.y)-this.borderWidth%2/2;n.height=Math.max(Math.round(n.height),.001);p.yBottom=n.y+n.height;n.height<=c&&!p.isNull?(n.height=c,n.y-=e,p.plotY=n.y,p.minPointLengthOffset=
0>p.y?-e:e):(p.isNull&&(n.width=0),p.minPointLengthOffset=0);n=p.plotY+(p.negative?n.height:0);this.chart.inverted?p.tooltipPos[0]=d.len-n:p.tooltipPos[1]=n}},processData:function(a){var d=this.options,k=this.yData,c=d.data,w=k.length,f=d.threshold||0,l,b,g,m,h;for(h=b=l=g=m=0;h<w;h++){var p=k[h];var v=c&&c[h]?c[h]:{};"sum"===p||v.isSum?k[h]=e(b):"intermediateSum"===p||v.isIntermediateSum?(k[h]=e(l),l=0):(b+=p,l+=p);g=Math.min(b,g);m=Math.max(b,m)}t.prototype.processData.call(this,a);d.stacking||
(this.dataMin=g+f,this.dataMax=m)},toYData:function(a){return a.isSum?"sum":a.isIntermediateSum?"intermediateSum":a.y},updateParallelArrays:function(a,d){t.prototype.updateParallelArrays.call(this,a,d);if("sum"===this.yData[0]||"intermediateSum"===this.yData[0])this.yData[0]=null},pointAttribs:function(a,d){var k=this.options.upColor;k&&!a.options.color&&(a.color=0<a.y?k:null);a=z.column.prototype.pointAttribs.call(this,a,d);delete a.dashstyle;return a},getGraphPath:function(){return["M",0,0]},getCrispPath:function(){var a=
this.data,d=this.yAxis,k=a.length,c=Math.round(this.graph.strokeWidth())%2/2,e=Math.round(this.borderWidth)%2/2,f=this.xAxis.reversed,b=this.yAxis.reversed,g=this.options.stacking,m=[],h;for(h=1;h<k;h++){var p=a[h].shapeArgs;var v=a[h-1];var n=a[h-1].shapeArgs;var t=d.waterfallStacks[this.stackKey];var y=0<v.y?-n.height:0;if(t){t=t[h-1];g?(t=t.connectorThreshold,y=Math.round(d.translate(t,0,1,0,1)+(b?y:0))-c):y=n.y+v.minPointLengthOffset+e-c;var q=["M",n.x+(f?0:n.width),y,"L",p.x+(f?p.width:0),y]}if(!g&&
0>v.y&&!b||0<v.y&&b)q[2]+=n.height,q[5]+=n.height;m=m.concat(q)}return m},drawGraph:function(){t.prototype.drawGraph.call(this);this.graph.attr({d:this.getCrispPath()})},setStackedPoints:function(){function a(d,a,k,c){if(B)for(k;k<B;k++)q.stackState[k]+=c;else q.stackState[0]=d,B=q.stackState.length;q.stackState.push(q.stackState[B-1]+a)}var d=this.options,k=this.yAxis.waterfallStacks,c=d.threshold,e=c||0,f=e,b=this.stackKey,g=this.xData,m=g.length,h,p;this.yAxis.usePercentage=!1;var v=h=p=e;if(this.visible||
!this.chart.options.chart.ignoreHiddenSeries){k[b]||(k[b]={});b=k[b];for(var n=0;n<m;n++){var t=g[n];if(!b[t]||k.changed)b[t]={negTotal:0,posTotal:0,stackTotal:0,threshold:0,stateIndex:0,stackState:[],label:k.changed&&b[t]?b[t].label:void 0};var q=b[t];var x=this.yData[n];0<=x?q.posTotal+=x:q.negTotal+=x;var z=d.data[n];t=q.absolutePos=q.posTotal;var u=q.absoluteNeg=q.negTotal;q.stackTotal=t+u;var B=q.stackState.length;z&&z.isIntermediateSum?(a(p,h,0,p),p=h,h=c,e^=f,f^=e,e^=f):z&&z.isSum?(a(c,v,B),
e=c):(a(e,x,0,v),z&&(v+=x,h+=x));q.stateIndex++;q.threshold=e;e+=q.stackTotal}k.changed=!1}},getExtremes:function(){var a=this.options.stacking;if(a){var d=this.yAxis;d=d.waterfallStacks;var k=this.stackedYNeg=[];var c=this.stackedYPos=[];"overlap"===a?n(d[this.stackKey],function(d){k.push(g(d.stackState));c.push(h(d.stackState))}):n(d[this.stackKey],function(d){k.push(d.negTotal+d.threshold);c.push(d.posTotal+d.threshold)});this.dataMin=g(k);this.dataMax=h(c)}}},{getClassName:function(){var a=v.prototype.getClassName.call(this);
this.isSum?a+=" highcharts-sum":this.isIntermediateSum&&(a+=" highcharts-intermediate-sum");return a},isValid:function(){return m(this.y)||this.isSum||this.isIntermediateSum}});""});B(u,"parts-more/PolygonSeries.js",[u["parts/Globals.js"]],function(b){var a=b.Series,h=b.seriesType,g=b.seriesTypes;h("polygon","scatter",{marker:{enabled:!1,states:{hover:{enabled:!1}}},stickyTracking:!1,tooltip:{followPointer:!0,pointFormat:""},trackByArea:!0},{type:"polygon",getGraphPath:function(){for(var b=a.prototype.getGraphPath.call(this),
g=b.length+1;g--;)(g===b.length||"M"===b[g])&&0<g&&b.splice(g,0,"z");return this.areaPath=b},drawGraph:function(){this.options.fillColor=this.color;g.area.prototype.drawGraph.call(this)},drawLegendSymbol:b.LegendSymbolMixin.drawRectangle,drawTracker:a.prototype.drawTracker,setStackedPoints:b.noop});""});B(u,"parts-more/BubbleLegend.js",[u["parts/Globals.js"],u["parts/Utilities.js"]],function(b,a){var h=a.arrayMax,g=a.arrayMin,m=a.isNumber,n=a.objectEach,q=a.pick;a=b.Series;var e=b.Legend,c=b.Chart,
f=b.addEvent,v=b.wrap,t=b.color,p=b.numberFormat,x=b.merge,z=b.noop,l=b.stableSort,d=b.setOptions;d({legend:{bubbleLegend:{borderColor:void 0,borderWidth:2,className:void 0,color:void 0,connectorClassName:void 0,connectorColor:void 0,connectorDistance:60,connectorWidth:1,enabled:!1,labels:{className:void 0,allowOverlap:!1,format:"",formatter:void 0,align:"right",style:{fontSize:10,color:void 0},x:0,y:0},maxSize:60,minSize:10,legendIndex:0,ranges:{value:void 0,borderColor:void 0,color:void 0,connectorColor:void 0},
sizeBy:"area",sizeByAbsoluteValue:!1,zIndex:1,zThreshold:0}}});b.BubbleLegend=function(d,a){this.init(d,a)};b.BubbleLegend.prototype={init:function(d,a){this.options=d;this.visible=!0;this.chart=a.chart;this.legend=a},setState:z,addToLegend:function(d){d.splice(this.options.legendIndex,0,this)},drawLegendSymbol:function(d){var a=this.chart,c=this.options,k=q(d.options.itemDistance,20),e=c.ranges;var f=c.connectorDistance;this.fontMetrics=a.renderer.fontMetrics(c.labels.style.fontSize.toString()+"px");
e&&e.length&&m(e[0].value)?(l(e,function(d,a){return a.value-d.value}),this.ranges=e,this.setOptions(),this.render(),a=this.getMaxLabelSize(),e=this.ranges[0].radius,d=2*e,f=f-e+a.width,f=0<f?f:0,this.maxLabel=a,this.movementX="left"===c.labels.align?f:0,this.legendItemWidth=d+f+k,this.legendItemHeight=d+this.fontMetrics.h/2):d.options.bubbleLegend.autoRanges=!0},setOptions:function(){var d=this.ranges,a=this.options,c=this.chart.series[a.seriesIndex],e=this.legend.baseline,f={"z-index":a.zIndex,
"stroke-width":a.borderWidth},b={"z-index":a.zIndex,"stroke-width":a.connectorWidth},g=this.getLabelStyles(),l=c.options.marker.fillOpacity,h=this.chart.styledMode;d.forEach(function(k,r){h||(f.stroke=q(k.borderColor,a.borderColor,c.color),f.fill=q(k.color,a.color,1!==l?t(c.color).setOpacity(l).get("rgba"):c.color),b.stroke=q(k.connectorColor,a.connectorColor,c.color));d[r].radius=this.getRangeRadius(k.value);d[r]=x(d[r],{center:d[0].radius-d[r].radius+e});h||x(!0,d[r],{bubbleStyle:x(!1,f),connectorStyle:x(!1,
b),labelStyle:g})},this)},getLabelStyles:function(){var d=this.options,a={},c="left"===d.labels.align,e=this.legend.options.rtl;n(d.labels.style,function(d,c){"color"!==c&&"fontSize"!==c&&"z-index"!==c&&(a[c]=d)});return x(!1,a,{"font-size":d.labels.style.fontSize,fill:q(d.labels.style.color,"#000000"),"z-index":d.zIndex,align:e||c?"right":"left"})},getRangeRadius:function(d){var a=this.options;return this.chart.series[this.options.seriesIndex].getRadius.call(this,a.ranges[a.ranges.length-1].value,
a.ranges[0].value,a.minSize,a.maxSize,d)},render:function(){var d=this.chart.renderer,a=this.options.zThreshold;this.symbols||(this.symbols={connectors:[],bubbleItems:[],labels:[]});this.legendSymbol=d.g("bubble-legend");this.legendItem=d.g("bubble-legend-item");this.legendSymbol.translateX=0;this.legendSymbol.translateY=0;this.ranges.forEach(function(d){d.value>=a&&this.renderRange(d)},this);this.legendSymbol.add(this.legendItem);this.legendItem.add(this.legendGroup);this.hideOverlappingLabels()},
renderRange:function(d){var a=this.options,c=a.labels,k=this.chart.renderer,e=this.symbols,f=e.labels,b=d.center,g=Math.abs(d.radius),l=a.connectorDistance,h=c.align,m=c.style.fontSize;l=this.legend.options.rtl||"left"===h?-l:l;c=a.connectorWidth;var p=this.ranges[0].radius,v=b-g-a.borderWidth/2+c/2;m=m/2-(this.fontMetrics.h-m)/2;var t=k.styledMode;"center"===h&&(l=0,a.connectorDistance=0,d.labelStyle.align="center");h=v+a.labels.y;var n=p+l+a.labels.x;e.bubbleItems.push(k.circle(p,b+((v%1?1:.5)-
(c%2?0:.5)),g).attr(t?{}:d.bubbleStyle).addClass((t?"highcharts-color-"+this.options.seriesIndex+" ":"")+"highcharts-bubble-legend-symbol "+(a.className||"")).add(this.legendSymbol));e.connectors.push(k.path(k.crispLine(["M",p,v,"L",p+l,v],a.connectorWidth)).attr(t?{}:d.connectorStyle).addClass((t?"highcharts-color-"+this.options.seriesIndex+" ":"")+"highcharts-bubble-legend-connectors "+(a.connectorClassName||"")).add(this.legendSymbol));d=k.text(this.formatLabel(d),n,h+m).attr(t?{}:d.labelStyle).addClass("highcharts-bubble-legend-labels "+
(a.labels.className||"")).add(this.legendSymbol);f.push(d);d.placed=!0;d.alignAttr={x:n,y:h+m}},getMaxLabelSize:function(){var d,a;this.symbols.labels.forEach(function(c){a=c.getBBox(!0);d=d?a.width>d.width?a:d:a});return d||{}},formatLabel:function(d){var a=this.options,c=a.labels.formatter;return(a=a.labels.format)?b.format(a,d):c?c.call(d):p(d.value,1)},hideOverlappingLabels:function(){var d=this.chart,a=this.symbols;!this.options.labels.allowOverlap&&a&&(d.hideOverlappingLabels(a.labels),a.labels.forEach(function(d,
c){d.newOpacity?d.newOpacity!==d.oldOpacity&&a.connectors[c].show():a.connectors[c].hide()}))},getRanges:function(){var d=this.legend.bubbleLegend,a=d.options.ranges,c,e=Number.MAX_VALUE,f=-Number.MAX_VALUE;d.chart.series.forEach(function(d){d.isBubble&&!d.ignoreSeries&&(c=d.zData.filter(m),c.length&&(e=q(d.options.zMin,Math.min(e,Math.max(g(c),!1===d.options.displayNegative?d.options.zThreshold:-Number.MAX_VALUE))),f=q(d.options.zMax,Math.max(f,h(c)))))});var b=e===f?[{value:f}]:[{value:e},{value:(e+
f)/2},{value:f,autoRanges:!0}];a.length&&a[0].radius&&b.reverse();b.forEach(function(d,c){a&&a[c]&&(b[c]=x(!1,a[c],d))});return b},predictBubbleSizes:function(){var d=this.chart,a=this.fontMetrics,c=d.legend.options,e="horizontal"===c.layout,f=e?d.legend.lastLineHeight:0,b=d.plotSizeX,g=d.plotSizeY,l=d.series[this.options.seriesIndex];d=Math.ceil(l.minPxSize);var h=Math.ceil(l.maxPxSize);l=l.options.maxSize;var m=Math.min(g,b);if(c.floating||!/%$/.test(l))a=h;else if(l=parseFloat(l),a=(m+f-a.h/2)*
l/100/(l/100+1),e&&g-a>=b||!e&&b-a>=g)a=h;return[d,Math.ceil(a)]},updateRanges:function(d,a){var c=this.legend.options.bubbleLegend;c.minSize=d;c.maxSize=a;c.ranges=this.getRanges()},correctSizes:function(){var d=this.legend,a=this.chart.series[this.options.seriesIndex];1<Math.abs(Math.ceil(a.maxPxSize)-this.options.maxSize)&&(this.updateRanges(this.options.minSize,a.maxPxSize),d.render())}};f(b.Legend,"afterGetAllItems",function(d){var a=this.bubbleLegend,c=this.options,e=c.bubbleLegend,k=this.chart.getVisibleBubbleSeriesIndex();
a&&a.ranges&&a.ranges.length&&(e.ranges.length&&(e.autoRanges=!!e.ranges[0].autoRanges),this.destroyItem(a));0<=k&&c.enabled&&e.enabled&&(e.seriesIndex=k,this.bubbleLegend=new b.BubbleLegend(e,this),this.bubbleLegend.addToLegend(d.allItems))});c.prototype.getVisibleBubbleSeriesIndex=function(){for(var d=this.series,a=0;a<d.length;){if(d[a]&&d[a].isBubble&&d[a].visible&&d[a].zData.length)return a;a++}return-1};e.prototype.getLinesHeights=function(){var d=this.allItems,a=[],c=d.length,e,f=0;for(e=0;e<
c;e++)if(d[e].legendItemHeight&&(d[e].itemHeight=d[e].legendItemHeight),d[e]===d[c-1]||d[e+1]&&d[e]._legendItemPos[1]!==d[e+1]._legendItemPos[1]){a.push({height:0});var b=a[a.length-1];for(f;f<=e;f++)d[f].itemHeight>b.height&&(b.height=d[f].itemHeight);b.step=e}return a};e.prototype.retranslateItems=function(d){var a,c,e,k=this.options.rtl,f=0;this.allItems.forEach(function(b,r){a=b.legendGroup.translateX;c=b._legendItemPos[1];if((e=b.movementX)||k&&b.ranges)e=k?a-b.options.maxSize/2:a+e,b.legendGroup.attr({translateX:e});
r>d[f].step&&f++;b.legendGroup.attr({translateY:Math.round(c+d[f].height/2)});b._legendItemPos[1]=c+d[f].height/2})};f(a,"legendItemClick",function(){var d=this.chart,a=this.visible,c=this.chart.legend;c&&c.bubbleLegend&&(this.visible=!a,this.ignoreSeries=a,d=0<=d.getVisibleBubbleSeriesIndex(),c.bubbleLegend.visible!==d&&(c.update({bubbleLegend:{enabled:d}}),c.bubbleLegend.visible=d),this.visible=a)});v(c.prototype,"drawChartBox",function(d,a,c){var e=this.legend,k=0<=this.getVisibleBubbleSeriesIndex();
if(e&&e.options.enabled&&e.bubbleLegend&&e.options.bubbleLegend.autoRanges&&k){var f=e.bubbleLegend.options;k=e.bubbleLegend.predictBubbleSizes();e.bubbleLegend.updateRanges(k[0],k[1]);f.placed||(e.group.placed=!1,e.allItems.forEach(function(d){d.legendGroup.translateY=null}));e.render();this.getMargins();this.axes.forEach(function(d){d.visible&&d.render();f.placed||(d.setScale(),d.updateNames(),n(d.ticks,function(d){d.isNew=!0;d.isNewLabel=!0}))});f.placed=!0;this.getMargins();d.call(this,a,c);e.bubbleLegend.correctSizes();
e.retranslateItems(e.getLinesHeights())}else d.call(this,a,c),e&&e.options.enabled&&e.bubbleLegend&&(e.render(),e.retranslateItems(e.getLinesHeights()))})});B(u,"parts-more/BubbleSeries.js",[u["parts/Globals.js"],u["parts/Utilities.js"]],function(b,a){var h=a.arrayMax,g=a.arrayMin,m=a.extend,n=a.isNumber,q=a.pick,e=a.pInt;a=b.Axis;var c=b.color,f=b.noop,v=b.Point,t=b.Series,p=b.seriesType,x=b.seriesTypes;p("bubble","scatter",{dataLabels:{formatter:function(){return this.point.z},inside:!0,verticalAlign:"middle"},
animationLimit:250,marker:{lineColor:null,lineWidth:1,fillOpacity:.5,radius:null,states:{hover:{radiusPlus:0}},symbol:"circle"},minSize:8,maxSize:"20%",softThreshold:!1,states:{hover:{halo:{size:5}}},tooltip:{pointFormat:"({point.x}, {point.y}), Size: {point.z}"},turboThreshold:0,zThreshold:0,zoneAxis:"z"},{pointArrayMap:["y","z"],parallelArrays:["x","y","z"],trackerGroups:["group","dataLabelsGroup"],specialGroup:"group",bubblePadding:!0,zoneAxis:"z",directTouch:!0,isBubble:!0,pointAttribs:function(a,
e){var d=this.options.marker.fillOpacity;a=t.prototype.pointAttribs.call(this,a,e);1!==d&&(a.fill=c(a.fill).setOpacity(d).get("rgba"));return a},getRadii:function(a,c,d){var e=this.zData,f=this.yData,b=d.minPxSize,g=d.maxPxSize,l=[];var h=0;for(d=e.length;h<d;h++){var m=e[h];l.push(this.getRadius(a,c,b,g,m,f[h]))}this.radii=l},getRadius:function(a,c,d,e,f,b){var k=this.options,r="width"!==k.sizeBy,g=k.zThreshold,l=c-a,h=.5;if(null===b||null===f)return null;if(n(f)){k.sizeByAbsoluteValue&&(f=Math.abs(f-
g),l=Math.max(c-g,Math.abs(a-g)),a=0);if(f<a)return d/2-1;0<l&&(h=(f-a)/l)}r&&0<=h&&(h=Math.sqrt(h));return Math.ceil(d+h*(e-d))/2},animate:function(a){!a&&this.points.length<this.options.animationLimit&&(this.points.forEach(function(a){var d=a.graphic;if(d&&d.width){var c={x:d.x,y:d.y,width:d.width,height:d.height};d.attr({x:a.plotX,y:a.plotY,width:1,height:1});d.animate(c,this.options.animation)}},this),this.animate=null)},hasData:function(){return!!this.processedXData.length},translate:function(){var a,
c=this.data,d=this.radii;x.scatter.prototype.translate.call(this);for(a=c.length;a--;){var e=c[a];var f=d?d[a]:0;n(f)&&f>=this.minPxSize/2?(e.marker=m(e.marker,{radius:f,width:2*f,height:2*f}),e.dlBox={x:e.plotX-f,y:e.plotY-f,width:2*f,height:2*f}):e.shapeArgs=e.plotY=e.dlBox=void 0}},alignDataLabel:x.column.prototype.alignDataLabel,buildKDTree:f,applyZones:f},{haloPath:function(a){return v.prototype.haloPath.call(this,0===a?0:(this.marker?this.marker.radius||0:0)+a)},ttBelow:!1});a.prototype.beforePadding=
function(){var a=this,c=this.len,d=this.chart,f=0,b=c,m=this.isXAxis,p=m?"xData":"yData",t=this.min,v={},x=Math.min(d.plotWidth,d.plotHeight),u=Number.MAX_VALUE,B=-Number.MAX_VALUE,E=this.max-t,D=c/E,G=[];this.series.forEach(function(c){var f=c.options;!c.bubblePadding||!c.visible&&d.options.chart.ignoreHiddenSeries||(a.allowZoomOutside=!0,G.push(c),m&&(["minSize","maxSize"].forEach(function(d){var a=f[d],c=/%$/.test(a);a=e(a);v[d]=c?x*a/100:a}),c.minPxSize=v.minSize,c.maxPxSize=Math.max(v.maxSize,
v.minSize),c=c.zData.filter(n),c.length&&(u=q(f.zMin,Math.min(u,Math.max(g(c),!1===f.displayNegative?f.zThreshold:-Number.MAX_VALUE))),B=q(f.zMax,Math.max(B,h(c))))))});G.forEach(function(d){var c=d[p],e=c.length;m&&d.getRadii(u,B,d);if(0<E)for(;e--;)if(n(c[e])&&a.dataMin<=c[e]&&c[e]<=a.dataMax){var k=d.radii?d.radii[e]:0;f=Math.min((c[e]-t)*D-k,f);b=Math.max((c[e]-t)*D+k,b)}});G.length&&0<E&&!this.isLog&&(b-=c,D*=(c+Math.max(0,f)-Math.min(b,c))/c,[["min","userMin",f],["max","userMax",b]].forEach(function(d){void 0===
q(a.options[d[0]],a[d[1]])&&(a[d[0]]+=d[2]/D)}))};""});B(u,"modules/networkgraph/integrations.js",[u["parts/Globals.js"]],function(b){b.networkgraphIntegrations={verlet:{attractiveForceFunction:function(a,b){return(b-a)/a},repulsiveForceFunction:function(a,b){return(b-a)/a*(b>a?1:0)},barycenter:function(){var a=this.options.gravitationalConstant,b=this.barycenter.xFactor,g=this.barycenter.yFactor;b=(b-(this.box.left+this.box.width)/2)*a;g=(g-(this.box.top+this.box.height)/2)*a;this.nodes.forEach(function(a){a.fixedPosition||
(a.plotX-=b/a.mass/a.degree,a.plotY-=g/a.mass/a.degree)})},repulsive:function(a,b,g){b=b*this.diffTemperature/a.mass/a.degree;a.fixedPosition||(a.plotX+=g.x*b,a.plotY+=g.y*b)},attractive:function(a,b,g){var h=a.getMass(),n=-g.x*b*this.diffTemperature;b=-g.y*b*this.diffTemperature;a.fromNode.fixedPosition||(a.fromNode.plotX-=n*h.fromNode/a.fromNode.degree,a.fromNode.plotY-=b*h.fromNode/a.fromNode.degree);a.toNode.fixedPosition||(a.toNode.plotX+=n*h.toNode/a.toNode.degree,a.toNode.plotY+=b*h.toNode/
a.toNode.degree)},integrate:function(a,b){var g=-a.options.friction,m=a.options.maxSpeed,h=(b.plotX+b.dispX-b.prevX)*g;g*=b.plotY+b.dispY-b.prevY;var q=Math.abs,e=q(h)/(h||1);q=q(g)/(g||1);h=e*Math.min(m,Math.abs(h));g=q*Math.min(m,Math.abs(g));b.prevX=b.plotX+b.dispX;b.prevY=b.plotY+b.dispY;b.plotX+=h;b.plotY+=g;b.temperature=a.vectorLength({x:h,y:g})},getK:function(a){return Math.pow(a.box.width*a.box.height/a.nodes.length,.5)}},euler:{attractiveForceFunction:function(a,b){return a*a/b},repulsiveForceFunction:function(a,
b){return b*b/a},barycenter:function(){var a=this.options.gravitationalConstant,b=this.barycenter.xFactor,g=this.barycenter.yFactor;this.nodes.forEach(function(m){if(!m.fixedPosition){var h=m.getDegree();h*=1+h/2;m.dispX+=(b-m.plotX)*a*h/m.degree;m.dispY+=(g-m.plotY)*a*h/m.degree}})},repulsive:function(a,b,g,m){a.dispX+=g.x/m*b/a.degree;a.dispY+=g.y/m*b/a.degree},attractive:function(a,b,g,m){var h=a.getMass(),q=g.x/m*b;b*=g.y/m;a.fromNode.fixedPosition||(a.fromNode.dispX-=q*h.fromNode/a.fromNode.degree,
a.fromNode.dispY-=b*h.fromNode/a.fromNode.degree);a.toNode.fixedPosition||(a.toNode.dispX+=q*h.toNode/a.toNode.degree,a.toNode.dispY+=b*h.toNode/a.toNode.degree)},integrate:function(a,b){b.dispX+=b.dispX*a.options.friction;b.dispY+=b.dispY*a.options.friction;var g=b.temperature=a.vectorLength({x:b.dispX,y:b.dispY});0!==g&&(b.plotX+=b.dispX/g*Math.min(Math.abs(b.dispX),a.temperature),b.plotY+=b.dispY/g*Math.min(Math.abs(b.dispY),a.temperature))},getK:function(a){return Math.pow(a.box.width*a.box.height/
a.nodes.length,.3)}}}});B(u,"modules/networkgraph/QuadTree.js",[u["parts/Globals.js"],u["parts/Utilities.js"]],function(b,a){a=a.extend;var h=b.QuadTreeNode=function(a){this.box=a;this.boxSize=Math.min(a.width,a.height);this.nodes=[];this.body=this.isInternal=!1;this.isEmpty=!0};a(h.prototype,{insert:function(a,b){this.isInternal?this.nodes[this.getBoxPosition(a)].insert(a,b-1):(this.isEmpty=!1,this.body?b?(this.isInternal=!0,this.divideBox(),!0!==this.body&&(this.nodes[this.getBoxPosition(this.body)].insert(this.body,
b-1),this.body=!0),this.nodes[this.getBoxPosition(a)].insert(a,b-1)):(b=new h({top:a.plotX,left:a.plotY,width:.1,height:.1}),b.body=a,b.isInternal=!1,this.nodes.push(b)):(this.isInternal=!1,this.body=a))},updateMassAndCenter:function(){var a=0,b=0,h=0;this.isInternal?(this.nodes.forEach(function(g){g.isEmpty||(a+=g.mass,b+=g.plotX*g.mass,h+=g.plotY*g.mass)}),b/=a,h/=a):this.body&&(a=this.body.mass,b=this.body.plotX,h=this.body.plotY);this.mass=a;this.plotX=b;this.plotY=h},divideBox:function(){var a=
this.box.width/2,b=this.box.height/2;this.nodes[0]=new h({left:this.box.left,top:this.box.top,width:a,height:b});this.nodes[1]=new h({left:this.box.left+a,top:this.box.top,width:a,height:b});this.nodes[2]=new h({left:this.box.left+a,top:this.box.top+b,width:a,height:b});this.nodes[3]=new h({left:this.box.left,top:this.box.top+b,width:a,height:b})},getBoxPosition:function(a){var b=a.plotY<this.box.top+this.box.height/2;return a.plotX<this.box.left+this.box.width/2?b?0:3:b?1:2}});b=b.QuadTree=function(a,
b,n,q){this.box={left:a,top:b,width:n,height:q};this.maxDepth=25;this.root=new h(this.box,"0");this.root.isInternal=!0;this.root.isRoot=!0;this.root.divideBox()};a(b.prototype,{insertNodes:function(a){a.forEach(function(a){this.root.insert(a,this.maxDepth)},this)},visitNodeRecursive:function(a,b,h){var g;a||(a=this.root);a===this.root&&b&&(g=b(a));!1!==g&&(a.nodes.forEach(function(a){if(a.isInternal){b&&(g=b(a));if(!1===g)return;this.visitNodeRecursive(a,b,h)}else a.body&&b&&b(a.body);h&&h(a)},this),
a===this.root&&h&&h(a))},calculateMassAndCenter:function(){this.visitNodeRecursive(null,null,function(a){a.updateMassAndCenter()})}})});B(u,"modules/networkgraph/layouts.js",[u["parts/Globals.js"],u["parts/Utilities.js"]],function(b,a){var h=a.defined,g=a.extend,m=a.pick,n=a.setAnimation;a=b.addEvent;var q=b.Chart;b.layouts={"reingold-fruchterman":function(){}};g(b.layouts["reingold-fruchterman"].prototype,{init:function(a){this.options=a;this.nodes=[];this.links=[];this.series=[];this.box={x:0,y:0,
width:0,height:0};this.setInitialRendering(!0);this.integration=b.networkgraphIntegrations[a.integration];this.attractiveForce=m(a.attractiveForce,this.integration.attractiveForceFunction);this.repulsiveForce=m(a.repulsiveForce,this.integration.repulsiveForceFunction);this.approximation=a.approximation},start:function(){var a=this.series,c=this.options;this.currentStep=0;this.forces=a[0]&&a[0].forces||[];this.initialRendering&&(this.initPositions(),a.forEach(function(a){a.render()}));this.setK();
this.resetSimulation(c);c.enableSimulation&&this.step()},step:function(){var a=this,c=this.series,f=this.options;a.currentStep++;"barnes-hut"===a.approximation&&(a.createQuadTree(),a.quadTree.calculateMassAndCenter());a.forces.forEach(function(c){a[c+"Forces"](a.temperature)});a.applyLimits(a.temperature);a.temperature=a.coolDown(a.startTemperature,a.diffTemperature,a.currentStep);a.prevSystemTemperature=a.systemTemperature;a.systemTemperature=a.getSystemTemperature();f.enableSimulation&&(c.forEach(function(a){a.chart&&
a.render()}),a.maxIterations--&&isFinite(a.temperature)&&!a.isStable()?(a.simulation&&b.win.cancelAnimationFrame(a.simulation),a.simulation=b.win.requestAnimationFrame(function(){a.step()})):a.simulation=!1)},stop:function(){this.simulation&&b.win.cancelAnimationFrame(this.simulation)},setArea:function(a,c,b,g){this.box={left:a,top:c,width:b,height:g}},setK:function(){this.k=this.options.linkLength||this.integration.getK(this)},addElementsToCollection:function(a,c){a.forEach(function(a){-1===c.indexOf(a)&&
c.push(a)})},removeElementFromCollection:function(a,c){a=c.indexOf(a);-1!==a&&c.splice(a,1)},clear:function(){this.nodes.length=0;this.links.length=0;this.series.length=0;this.resetSimulation()},resetSimulation:function(){this.forcedStop=!1;this.systemTemperature=0;this.setMaxIterations();this.setTemperature();this.setDiffTemperature()},setMaxIterations:function(a){this.maxIterations=m(a,this.options.maxIterations)},setTemperature:function(){this.temperature=this.startTemperature=Math.sqrt(this.nodes.length)},
setDiffTemperature:function(){this.diffTemperature=this.startTemperature/(this.options.maxIterations+1)},setInitialRendering:function(a){this.initialRendering=a},createQuadTree:function(){this.quadTree=new b.QuadTree(this.box.left,this.box.top,this.box.width,this.box.height);this.quadTree.insertNodes(this.nodes)},initPositions:function(){var a=this.options.initialPositions;b.isFunction(a)?(a.call(this),this.nodes.forEach(function(a){h(a.prevX)||(a.prevX=a.plotX);h(a.prevY)||(a.prevY=a.plotY);a.dispX=
0;a.dispY=0})):"circle"===a?this.setCircularPositions():this.setRandomPositions()},setCircularPositions:function(){function a(c){c.linksFrom.forEach(function(d){n[d.toNode.id]||(n[d.toNode.id]=!0,p.push(d.toNode),a(d.toNode))})}var c=this.box,b=this.nodes,g=2*Math.PI/(b.length+1),h=b.filter(function(a){return 0===a.linksTo.length}),p=[],n={},q=this.options.initialPositionRadius;h.forEach(function(c){p.push(c);a(c)});p.length?b.forEach(function(a){-1===p.indexOf(a)&&p.push(a)}):p=b;p.forEach(function(a,
d){a.plotX=a.prevX=m(a.plotX,c.width/2+q*Math.cos(d*g));a.plotY=a.prevY=m(a.plotY,c.height/2+q*Math.sin(d*g));a.dispX=0;a.dispY=0})},setRandomPositions:function(){function a(a){a=a*a/Math.PI;return a-=Math.floor(a)}var c=this.box,b=this.nodes,g=b.length+1;b.forEach(function(b,e){b.plotX=b.prevX=m(b.plotX,c.width*a(e));b.plotY=b.prevY=m(b.plotY,c.height*a(g+e));b.dispX=0;b.dispY=0})},force:function(a){this.integration[a].apply(this,Array.prototype.slice.call(arguments,1))},barycenterForces:function(){this.getBarycenter();
this.force("barycenter")},getBarycenter:function(){var a=0,c=0,b=0;this.nodes.forEach(function(e){c+=e.plotX*e.mass;b+=e.plotY*e.mass;a+=e.mass});return this.barycenter={x:c,y:b,xFactor:c/a,yFactor:b/a}},barnesHutApproximation:function(a,c){var b=this.getDistXY(a,c),e=this.vectorLength(b);if(a!==c&&0!==e)if(c.isInternal)if(c.boxSize/e<this.options.theta&&0!==e){var g=this.repulsiveForce(e,this.k);this.force("repulsive",a,g*c.mass,b,e);var h=!1}else h=!0;else g=this.repulsiveForce(e,this.k),this.force("repulsive",
a,g*c.mass,b,e);return h},repulsiveForces:function(){var a=this;"barnes-hut"===a.approximation?a.nodes.forEach(function(c){a.quadTree.visitNodeRecursive(null,function(b){return a.barnesHutApproximation(c,b)})}):a.nodes.forEach(function(c){a.nodes.forEach(function(b){if(c!==b&&!c.fixedPosition){var e=a.getDistXY(c,b);var f=a.vectorLength(e);if(0!==f){var g=a.repulsiveForce(f,a.k);a.force("repulsive",c,g*b.mass,e,f)}}})})},attractiveForces:function(){var a=this,c,b,g;a.links.forEach(function(e){e.fromNode&&
e.toNode&&(c=a.getDistXY(e.fromNode,e.toNode),b=a.vectorLength(c),0!==b&&(g=a.attractiveForce(b,a.k),a.force("attractive",e,g,c,b)))})},applyLimits:function(){var a=this;a.nodes.forEach(function(c){c.fixedPosition||(a.integration.integrate(a,c),a.applyLimitBox(c,a.box),c.dispX=0,c.dispY=0)})},applyLimitBox:function(a,c){var b=a.radius;a.plotX=Math.max(Math.min(a.plotX,c.width-b),c.left+b);a.plotY=Math.max(Math.min(a.plotY,c.height-b),c.top+b)},coolDown:function(a,c,b){return a-c*b},isStable:function(){return.00001>
Math.abs(this.systemTemperature-this.prevSystemTemperature)||0>=this.temperature},getSystemTemperature:function(){return this.nodes.reduce(function(a,c){return a+c.temperature},0)},vectorLength:function(a){return Math.sqrt(a.x*a.x+a.y*a.y)},getDistR:function(a,c){a=this.getDistXY(a,c);return this.vectorLength(a)},getDistXY:function(a,c){var b=a.plotX-c.plotX;a=a.plotY-c.plotY;return{x:b,y:a,absX:Math.abs(b),absY:Math.abs(a)}}});a(q,"predraw",function(){this.graphLayoutsLookup&&this.graphLayoutsLookup.forEach(function(a){a.stop()})});
a(q,"render",function(){function a(a){a.maxIterations--&&isFinite(a.temperature)&&!a.isStable()&&!a.options.enableSimulation&&(a.beforeStep&&a.beforeStep(),a.step(),b=!1,c=!0)}var c=!1;if(this.graphLayoutsLookup){n(!1,this);for(this.graphLayoutsLookup.forEach(function(a){a.start()});!b;){var b=!0;this.graphLayoutsLookup.forEach(a)}c&&this.series.forEach(function(a){a&&a.layout&&a.render()})}})});B(u,"modules/networkgraph/draggable-nodes.js",[u["parts/Globals.js"]],function(b){var a=b.Chart,h=b.addEvent;
b.dragNodesMixin={onMouseDown:function(a,b){b=this.chart.pointer.normalize(b);a.fixedPosition={chartX:b.chartX,chartY:b.chartY,plotX:a.plotX,plotY:a.plotY};a.inDragMode=!0},onMouseMove:function(a,b){if(a.fixedPosition&&a.inDragMode){var g=this.chart,h=g.pointer.normalize(b);b=a.fixedPosition.chartX-h.chartX;h=a.fixedPosition.chartY-h.chartY;if(5<Math.abs(b)||5<Math.abs(h))b=a.fixedPosition.plotX-b,h=a.fixedPosition.plotY-h,g.isInsidePlot(b,h)&&(a.plotX=b,a.plotY=h,a.hasDragged=!0,this.redrawHalo(a),
this.layout.simulation?this.layout.resetSimulation():(this.layout.setInitialRendering(!1),this.layout.enableSimulation?this.layout.start():this.layout.setMaxIterations(1),this.chart.redraw(),this.layout.setInitialRendering(!0)))}},onMouseUp:function(a,b){a.fixedPosition&&a.hasDragged&&(this.layout.enableSimulation?this.layout.start():this.chart.redraw(),a.inDragMode=a.hasDragged=!1,this.options.fixedDraggable||delete a.fixedPosition)},redrawHalo:function(a){a&&this.halo&&this.halo.attr({d:a.haloPath(this.options.states.hover.halo.size)})}};
h(a,"load",function(){var a=this,b,n,q;a.container&&(b=h(a.container,"mousedown",function(b){var c=a.hoverPoint;c&&c.series&&c.series.hasDraggableNodes&&c.series.options.draggable&&(c.series.onMouseDown(c,b),n=h(a.container,"mousemove",function(a){return c&&c.series&&c.series.onMouseMove(c,a)}),q=h(a.container.ownerDocument,"mouseup",function(a){n();q();return c&&c.series&&c.series.onMouseUp(c,a)}))}));h(a,"destroy",function(){b()})})});B(u,"parts-more/PackedBubbleSeries.js",[u["parts/Globals.js"],
u["parts/Utilities.js"]],function(b,a){var h=a.defined,g=a.extend,m=a.isArray,n=a.isNumber,q=a.pick;a=b.seriesType;var e=b.Series,c=b.Point,f=b.addEvent,v=b.fireEvent,t=b.Chart,p=b.Color,x=b.layouts["reingold-fruchterman"],u=b.seriesTypes.bubble.prototype.pointClass,l=b.dragNodesMixin;b.networkgraphIntegrations.packedbubble={repulsiveForceFunction:function(a,c,b,e){return Math.min(a,(b.marker.radius+e.marker.radius)/2)},barycenter:function(){var a=this,c=a.options.gravitationalConstant,b=a.box,e=
a.nodes,f,h;e.forEach(function(d){a.options.splitSeries&&!d.isParentNode?(f=d.series.parentNode.plotX,h=d.series.parentNode.plotY):(f=b.width/2,h=b.height/2);d.fixedPosition||(d.plotX-=(d.plotX-f)*c/(d.mass*Math.sqrt(e.length)),d.plotY-=(d.plotY-h)*c/(d.mass*Math.sqrt(e.length)))})},repulsive:function(a,c,b,e){var d=c*this.diffTemperature/a.mass/a.degree;c=b.x*d;b=b.y*d;a.fixedPosition||(a.plotX+=c,a.plotY+=b);e.fixedPosition||(e.plotX-=c,e.plotY-=b)},integrate:b.networkgraphIntegrations.verlet.integrate,
getK:b.noop};b.layouts.packedbubble=b.extendClass(x,{beforeStep:function(){this.options.marker&&this.series.forEach(function(a){a&&a.calculateParentRadius()})},setCircularPositions:function(){var a=this,c=a.box,b=a.nodes,e=2*Math.PI/(b.length+1),f,h,g=a.options.initialPositionRadius;b.forEach(function(d,b){a.options.splitSeries&&!d.isParentNode?(f=d.series.parentNode.plotX,h=d.series.parentNode.plotY):(f=c.width/2,h=c.height/2);d.plotX=d.prevX=q(d.plotX,f+g*Math.cos(d.index||b*e));d.plotY=d.prevY=
q(d.plotY,h+g*Math.sin(d.index||b*e));d.dispX=0;d.dispY=0})},repulsiveForces:function(){var a=this,c,b,e,f=a.options.bubblePadding;a.nodes.forEach(function(d){d.degree=d.mass;d.neighbours=0;a.nodes.forEach(function(k){c=0;d===k||d.fixedPosition||!a.options.seriesInteraction&&d.series!==k.series||(e=a.getDistXY(d,k),b=a.vectorLength(e)-(d.marker.radius+k.marker.radius+f),0>b&&(d.degree+=.01,d.neighbours++,c=a.repulsiveForce(-b/Math.sqrt(d.neighbours),a.k,d,k)),a.force("repulsive",d,c*k.mass,e,k,b))})})},
applyLimitBox:function(a){if(this.options.splitSeries&&!a.isParentNode&&this.options.parentNodeLimit){var d=this.getDistXY(a,a.series.parentNode);var c=a.series.parentNodeRadius-a.marker.radius-this.vectorLength(d);0>c&&c>-2*a.marker.radius&&(a.plotX-=.01*d.x,a.plotY-=.01*d.y)}x.prototype.applyLimitBox.apply(this,arguments)},isStable:function(){return.00001>Math.abs(this.systemTemperature-this.prevSystemTemperature)||0>=this.temperature||0<this.systemTemperature&&.02>this.systemTemperature/this.nodes.length&&
this.enableSimulation}});a("packedbubble","bubble",{minSize:"10%",maxSize:"50%",sizeBy:"area",zoneAxis:"y",tooltip:{pointFormat:"Value: {point.value}"},draggable:!0,useSimulation:!0,dataLabels:{formatter:function(){return this.point.value},parentNodeFormatter:function(){return this.name},parentNodeTextPath:{enabled:!0},padding:0},layoutAlgorithm:{initialPositions:"circle",initialPositionRadius:20,bubblePadding:5,parentNodeLimit:!1,seriesInteraction:!0,dragBetweenSeries:!1,parentNodeOptions:{maxIterations:400,
gravitationalConstant:.03,maxSpeed:50,initialPositionRadius:100,seriesInteraction:!0,marker:{fillColor:null,fillOpacity:1,lineWidth:1,lineColor:null,symbol:"circle"}},enableSimulation:!0,type:"packedbubble",integration:"packedbubble",maxIterations:1E3,splitSeries:!1,maxSpeed:5,gravitationalConstant:.01,friction:-.981}},{hasDraggableNodes:!0,forces:["barycenter","repulsive"],pointArrayMap:["value"],pointValKey:"value",isCartesian:!1,axisTypes:[],noSharedTooltip:!0,accumulateAllPoints:function(a){var d=
a.chart,c=[],b,e;for(b=0;b<d.series.length;b++)if(a=d.series[b],a.visible||!d.options.chart.ignoreHiddenSeries)for(e=0;e<a.yData.length;e++)c.push([null,null,a.yData[e],a.index,e,{id:e,marker:{radius:0}}]);return c},init:function(){e.prototype.init.apply(this,arguments);f(this,"updatedData",function(){this.chart.series.forEach(function(a){a.type===this.type&&(a.isDirty=!0)},this)});return this},render:function(){var a=[];e.prototype.render.apply(this,arguments);this.options.dataLabels.allowOverlap||
(this.data.forEach(function(d){m(d.dataLabels)&&d.dataLabels.forEach(function(d){a.push(d)})}),this.chart.hideOverlappingLabels(a))},setVisible:function(){var a=this;e.prototype.setVisible.apply(a,arguments);a.parentNodeLayout&&a.graph?a.visible?(a.graph.show(),a.parentNode.dataLabel&&a.parentNode.dataLabel.show()):(a.graph.hide(),a.parentNodeLayout.removeElementFromCollection(a.parentNode,a.parentNodeLayout.nodes),a.parentNode.dataLabel&&a.parentNode.dataLabel.hide()):a.layout&&(a.visible?a.layout.addElementsToCollection(a.points,
a.layout.nodes):a.points.forEach(function(d){a.layout.removeElementFromCollection(d,a.layout.nodes)}))},drawDataLabels:function(){var a=this.options.dataLabels.textPath,c=this.points;e.prototype.drawDataLabels.apply(this,arguments);this.parentNode&&(this.parentNode.formatPrefix="parentNode",this.points=[this.parentNode],this.options.dataLabels.textPath=this.options.dataLabels.parentNodeTextPath,e.prototype.drawDataLabels.apply(this,arguments),this.points=c,this.options.dataLabels.textPath=a)},seriesBox:function(){var a=
this.chart,c=Math.max,b=Math.min,e,f=[a.plotLeft,a.plotLeft+a.plotWidth,a.plotTop,a.plotTop+a.plotHeight];this.data.forEach(function(a){h(a.plotX)&&h(a.plotY)&&a.marker.radius&&(e=a.marker.radius,f[0]=b(f[0],a.plotX-e),f[1]=c(f[1],a.plotX+e),f[2]=b(f[2],a.plotY-e),f[3]=c(f[3],a.plotY+e))});return n(f.width/f.height)?f:null},calculateParentRadius:function(){var a=this.seriesBox();this.parentNodeRadius=Math.min(Math.max(Math.sqrt(2*this.parentNodeMass/Math.PI)+20,20),a?Math.max(Math.sqrt(Math.pow(a.width,
2)+Math.pow(a.height,2))/2+20,20):Math.sqrt(2*this.parentNodeMass/Math.PI)+20);this.parentNode&&(this.parentNode.marker.radius=this.parentNode.radius=this.parentNodeRadius)},drawGraph:function(){if(this.layout&&this.layout.options.splitSeries){var a=this.chart,c=this.layout.options.parentNodeOptions.marker;c={fill:c.fillColor||p(this.color).brighten(.4).get(),opacity:c.fillOpacity,stroke:c.lineColor||this.color,"stroke-width":c.lineWidth};var e=this.visible?"inherit":"hidden";this.parentNodesGroup||
(this.parentNodesGroup=this.plotGroup("parentNodesGroup","parentNode",e,.1,a.seriesGroup),this.group.attr({zIndex:2}));this.calculateParentRadius();e=b.merge({x:this.parentNode.plotX-this.parentNodeRadius,y:this.parentNode.plotY-this.parentNodeRadius,width:2*this.parentNodeRadius,height:2*this.parentNodeRadius},c);this.parentNode.graphic||(this.graph=this.parentNode.graphic=a.renderer.symbol(c.symbol).add(this.parentNodesGroup));this.parentNode.graphic.attr(e)}},createParentNodes:function(){var a=
this,c=a.chart,b=a.parentNodeLayout,e,f=a.parentNode;a.parentNodeMass=0;a.points.forEach(function(d){a.parentNodeMass+=Math.PI*Math.pow(d.marker.radius,2)});a.calculateParentRadius();b.nodes.forEach(function(d){d.seriesIndex===a.index&&(e=!0)});b.setArea(0,0,c.plotWidth,c.plotHeight);e||(f||(f=(new u).init(this,{mass:a.parentNodeRadius/2,marker:{radius:a.parentNodeRadius},dataLabels:{inside:!1},dataLabelOnNull:!0,degree:a.parentNodeRadius,isParentNode:!0,seriesIndex:a.index})),a.parentNode&&(f.plotX=
a.parentNode.plotX,f.plotY=a.parentNode.plotY),a.parentNode=f,b.addElementsToCollection([a],b.series),b.addElementsToCollection([f],b.nodes))},addSeriesLayout:function(){var a=this.options.layoutAlgorithm,c=this.chart.graphLayoutsStorage,e=this.chart.graphLayoutsLookup,f=b.merge(a,a.parentNodeOptions,{enableSimulation:this.layout.options.enableSimulation});var h=c[a.type+"-series"];h||(c[a.type+"-series"]=h=new b.layouts[a.type],h.init(f),e.splice(h.index,0,h));this.parentNodeLayout=h;this.createParentNodes()},
addLayout:function(){var a=this.options.layoutAlgorithm,c=this.chart.graphLayoutsStorage,e=this.chart.graphLayoutsLookup,f=this.chart.options.chart;c||(this.chart.graphLayoutsStorage=c={},this.chart.graphLayoutsLookup=e=[]);var g=c[a.type];g||(a.enableSimulation=h(f.forExport)?!f.forExport:a.enableSimulation,c[a.type]=g=new b.layouts[a.type],g.init(a),e.splice(g.index,0,g));this.layout=g;this.points.forEach(function(a){a.mass=2;a.degree=1;a.collisionNmb=1});g.setArea(0,0,this.chart.plotWidth,this.chart.plotHeight);
g.addElementsToCollection([this],g.series);g.addElementsToCollection(this.points,g.nodes)},deferLayout:function(){var a=this.options.layoutAlgorithm;this.visible&&(this.addLayout(),a.splitSeries&&this.addSeriesLayout())},translate:function(){var a=this.chart,c=this.data,b=this.index,e,f=this.options.useSimulation;this.processedXData=this.xData;this.generatePoints();h(a.allDataPoints)||(a.allDataPoints=this.accumulateAllPoints(this),this.getPointRadius());if(f)var l=a.allDataPoints;else l=this.placeBubbles(a.allDataPoints),
this.options.draggable=!1;for(e=0;e<l.length;e++)if(l[e][3]===b){var p=c[l[e][4]];var t=l[e][2];f||(p.plotX=l[e][0]-a.plotLeft+a.diffX,p.plotY=l[e][1]-a.plotTop+a.diffY);p.marker=g(p.marker,{radius:t,width:2*t,height:2*t});p.radius=t}f&&this.deferLayout();v(this,"afterTranslate")},checkOverlap:function(a,c){var d=a[0]-c[0],b=a[1]-c[1];return-.001>Math.sqrt(d*d+b*b)-Math.abs(a[2]+c[2])},positionBubble:function(a,c,b){var d=Math.sqrt,e=Math.asin,f=Math.acos,k=Math.pow,h=Math.abs;d=d(k(a[0]-c[0],2)+
k(a[1]-c[1],2));f=f((k(d,2)+k(b[2]+c[2],2)-k(b[2]+a[2],2))/(2*(b[2]+c[2])*d));e=e(h(a[0]-c[0])/d);a=(0>a[1]-c[1]?0:Math.PI)+f+e*(0>(a[0]-c[0])*(a[1]-c[1])?1:-1);return[c[0]+(c[2]+b[2])*Math.sin(a),c[1]-(c[2]+b[2])*Math.cos(a),b[2],b[3],b[4]]},placeBubbles:function(a){var c=this.checkOverlap,d=this.positionBubble,b=[],e=1,f=0,h=0;var g=[];var l;a=a.sort(function(a,c){return c[2]-a[2]});if(a.length){b.push([[0,0,a[0][2],a[0][3],a[0][4]]]);if(1<a.length)for(b.push([[0,0-a[1][2]-a[0][2],a[1][2],a[1][3],
a[1][4]]]),l=2;l<a.length;l++)a[l][2]=a[l][2]||1,g=d(b[e][f],b[e-1][h],a[l]),c(g,b[e][0])?(b.push([]),h=0,b[e+1].push(d(b[e][f],b[e][0],a[l])),e++,f=0):1<e&&b[e-1][h+1]&&c(g,b[e-1][h+1])?(h++,b[e].push(d(b[e][f],b[e-1][h],a[l])),f++):(f++,b[e].push(g));this.chart.stages=b;this.chart.rawPositions=[].concat.apply([],b);this.resizeRadius();g=this.chart.rawPositions}return g},resizeRadius:function(){var a=this.chart,c=a.rawPositions,b=Math.min,e=Math.max,f=a.plotLeft,h=a.plotTop,g=a.plotHeight,l=a.plotWidth,
p,t,m;var n=p=Number.POSITIVE_INFINITY;var v=t=Number.NEGATIVE_INFINITY;for(m=0;m<c.length;m++){var q=c[m][2];n=b(n,c[m][0]-q);v=e(v,c[m][0]+q);p=b(p,c[m][1]-q);t=e(t,c[m][1]+q)}m=[v-n,t-p];b=b.apply([],[(l-f)/m[0],(g-h)/m[1]]);if(1e-10<Math.abs(b-1)){for(m=0;m<c.length;m++)c[m][2]*=b;this.placeBubbles(c)}else a.diffY=g/2+h-p-(t-p)/2,a.diffX=l/2+f-n-(v-n)/2},calculateZExtremes:function(){var a=this.options.zMin,c=this.options.zMax,b=Infinity,e=-Infinity;if(a&&c)return[a,c];this.chart.series.forEach(function(a){a.yData.forEach(function(a){h(a)&&
(a>e&&(e=a),a<b&&(b=a))})});a=q(a,b);c=q(c,e);return[a,c]},getPointRadius:function(){var a=this,c=a.chart,b=a.options,e=b.useSimulation,f=Math.min(c.plotWidth,c.plotHeight),h={},g=[],l=c.allDataPoints,p,t,m,n;["minSize","maxSize"].forEach(function(a){var c=parseInt(b[a],10),d=/%$/.test(b[a]);h[a]=d?f*c/100:c*Math.sqrt(l.length)});c.minRadius=p=h.minSize/Math.sqrt(l.length);c.maxRadius=t=h.maxSize/Math.sqrt(l.length);var v=e?a.calculateZExtremes():[p,t];(l||[]).forEach(function(c,b){m=e?Math.max(Math.min(c[2],
v[1]),v[0]):c[2];n=a.getRadius(v[0],v[1],p,t,m);0===n&&(n=null);l[b][2]=n;g.push(n)});a.radii=g},redrawHalo:l.redrawHalo,onMouseDown:l.onMouseDown,onMouseMove:l.onMouseMove,onMouseUp:function(a){if(a.fixedPosition&&!a.removed){var c,d,e=this.layout,f=this.parentNodeLayout;f&&e.options.dragBetweenSeries&&f.nodes.forEach(function(f){a&&a.marker&&f!==a.series.parentNode&&(c=e.getDistXY(a,f),d=e.vectorLength(c)-f.marker.radius-a.marker.radius,0>d&&(f.series.addPoint(b.merge(a.options,{plotX:a.plotX,plotY:a.plotY}),
!1),e.removeElementFromCollection(a,e.nodes),a.remove()))});l.onMouseUp.apply(this,arguments)}},destroy:function(){this.chart.graphLayoutsLookup&&this.chart.graphLayoutsLookup.forEach(function(a){a.removeElementFromCollection(this,a.series)},this);this.parentNode&&(this.parentNodeLayout.removeElementFromCollection(this.parentNode,this.parentNodeLayout.nodes),this.parentNode.dataLabel&&(this.parentNode.dataLabel=this.parentNode.dataLabel.destroy()));b.Series.prototype.destroy.apply(this,arguments)},
alignDataLabel:b.Series.prototype.alignDataLabel},{destroy:function(){this.series.layout&&this.series.layout.removeElementFromCollection(this,this.series.layout.nodes);return c.prototype.destroy.apply(this,arguments)}});f(t,"beforeRedraw",function(){this.allDataPoints&&delete this.allDataPoints});""});B(u,"parts-more/Polar.js",[u["parts/Globals.js"],u["parts/Utilities.js"]],function(b,a){var h=a.pick,g=a.splat,m=b.Series,n=b.seriesTypes;a=b.wrap;var q=m.prototype,e=b.Pointer.prototype;q.searchPointByAngle=
function(a){var c=this.chart,b=this.xAxis.pane.center;return this.searchKDTree({clientX:180+-180/Math.PI*Math.atan2(a.chartX-b[0]-c.plotLeft,a.chartY-b[1]-c.plotTop)})};q.getConnectors=function(a,b,e,h){var c=h?1:0;var f=0<=b&&b<=a.length-1?b:0>b?a.length-1+b:0;b=0>f-1?a.length-(1+c):f-1;c=f+1>a.length-1?c:f+1;var g=a[b];c=a[c];var l=g.plotX;g=g.plotY;var d=c.plotX;var k=c.plotY;c=a[f].plotX;f=a[f].plotY;l=(1.5*c+l)/2.5;g=(1.5*f+g)/2.5;d=(1.5*c+d)/2.5;var t=(1.5*f+k)/2.5;k=Math.sqrt(Math.pow(l-c,
2)+Math.pow(g-f,2));var m=Math.sqrt(Math.pow(d-c,2)+Math.pow(t-f,2));l=Math.atan2(g-f,l-c);t=Math.PI/2+(l+Math.atan2(t-f,d-c))/2;Math.abs(l-t)>Math.PI/2&&(t-=Math.PI);l=c+Math.cos(t)*k;g=f+Math.sin(t)*k;d=c+Math.cos(Math.PI+t)*m;t=f+Math.sin(Math.PI+t)*m;c={rightContX:d,rightContY:t,leftContX:l,leftContY:g,plotX:c,plotY:f};e&&(c.prevPointCont=this.getConnectors(a,b,!1,h));return c};q.toXY=function(a){var c=this.chart,b=a.plotX;var e=a.plotY;a.rectPlotX=b;a.rectPlotY=e;e=this.xAxis.postTranslate(a.plotX,
this.yAxis.len-e);a.plotX=a.polarPlotX=e.x-c.plotLeft;a.plotY=a.polarPlotY=e.y-c.plotTop;this.kdByAngle?(c=(b/Math.PI*180+this.xAxis.pane.options.startAngle)%360,0>c&&(c+=360),a.clientX=c):a.clientX=a.plotX};n.spline&&(a(n.spline.prototype,"getPointSpline",function(a,b,e,g){this.chart.polar?g?(a=this.getConnectors(b,g,!0,this.connectEnds),a=["C",a.prevPointCont.rightContX,a.prevPointCont.rightContY,a.leftContX,a.leftContY,a.plotX,a.plotY]):a=["M",e.plotX,e.plotY]:a=a.call(this,b,e,g);return a}),n.areasplinerange&&
(n.areasplinerange.prototype.getPointSpline=n.spline.prototype.getPointSpline));b.addEvent(m,"afterTranslate",function(){var a=this.chart,e;if(a.polar&&this.xAxis){(this.kdByAngle=a.tooltip&&a.tooltip.shared)?this.searchPoint=this.searchPointByAngle:this.options.findNearestPointBy="xy";if(!this.preventPostTranslate){var g=this.points;for(e=g.length;e--;)this.toXY(g[e]),!a.hasParallelCoordinates&&!this.yAxis.reversed&&g[e].y<this.yAxis.min&&(g[e].isNull=!0)}this.hasClipCircleSetter||(this.hasClipCircleSetter=
!!b.addEvent(this,"afterRender",function(){if(a.polar){var c=this.yAxis.center;this.group.clip(a.renderer.clipCircle(c[0],c[1],c[2]/2));this.setClip=b.noop}}))}},{order:2});a(q,"getGraphPath",function(a,b){var c=this,e;if(this.chart.polar){b=b||this.points;for(e=0;e<b.length;e++)if(!b[e].isNull){var f=e;break}if(!1!==this.options.connectEnds&&void 0!==f){this.connectEnds=!0;b.splice(b.length,0,b[f]);var g=!0}b.forEach(function(a){void 0===a.polarPlotY&&c.toXY(a)})}e=a.apply(this,[].slice.call(arguments,
1));g&&b.pop();return e});m=function(a,b){var c=this.chart,e=this.options.animation,f=this.group,g=this.markerGroup,h=this.xAxis.center,l=c.plotLeft,d=c.plotTop;c.polar?c.renderer.isSVG&&(!0===e&&(e={}),b?(a={translateX:h[0]+l,translateY:h[1]+d,scaleX:.001,scaleY:.001},f.attr(a),g&&g.attr(a)):(a={translateX:l,translateY:d,scaleX:1,scaleY:1},f.animate(a,e),g&&g.animate(a,e),this.animate=null)):a.call(this,b)};a(q,"animate",m);n.column&&(n=n.column.prototype,n.polarArc=function(a,b,e,g){var c=this.xAxis.center,
f=this.yAxis.len;return this.chart.renderer.symbols.arc(c[0],c[1],f-b,null,{start:e,end:g,innerR:f-h(a,f)})},a(n,"animate",m),a(n,"translate",function(a){var b=this.xAxis,c=b.startAngleRad,e;this.preventPostTranslate=!0;a.call(this);if(b.isRadial){var g=this.points;for(e=g.length;e--;){var h=g[e];a=h.barX+c;h.shapeType="path";h.shapeArgs={d:this.polarArc(h.yBottom,h.plotY,a,a+h.pointWidth)};this.toXY(h);h.tooltipPos=[h.plotX,h.plotY];h.ttBelow=h.plotY>b.center[1]}}}),a(n,"alignDataLabel",function(a,
b,e,g,h,m){this.chart.polar?(a=b.rectPlotX/Math.PI*180,null===g.align&&(g.align=20<a&&160>a?"left":200<a&&340>a?"right":"center"),null===g.verticalAlign&&(g.verticalAlign=45>a||315<a?"bottom":135<a&&225>a?"top":"middle"),q.alignDataLabel.call(this,b,e,g,h,m)):a.call(this,b,e,g,h,m)}));a(e,"getCoordinates",function(a,b){var c=this.chart,e={xAxis:[],yAxis:[]};c.polar?c.axes.forEach(function(a){var f=a.isXAxis,g=a.center;if("colorAxis"!==a.coll){var h=b.chartX-g[0]-c.plotLeft;g=b.chartY-g[1]-c.plotTop;
e[f?"xAxis":"yAxis"].push({axis:a,value:a.translate(f?Math.PI-Math.atan2(h,g):Math.sqrt(Math.pow(h,2)+Math.pow(g,2)),!0)})}}):e=a.call(this,b);return e});b.SVGRenderer.prototype.clipCircle=function(a,e,g){var c=b.uniqueKey(),f=this.createElement("clipPath").attr({id:c}).add(this.defs);a=this.circle(a,e,g).add(f);a.id=c;a.clipPath=f;return a};b.addEvent(b.Chart,"getAxes",function(){this.pane||(this.pane=[]);g(this.options.pane).forEach(function(a){new b.Pane(a,this)},this)});b.addEvent(b.Chart,"afterDrawChartBox",
function(){this.pane.forEach(function(a){a.render()})});a(b.Chart.prototype,"get",function(a,e){return b.find(this.pane,function(a){return a.options.id===e})||a.call(this,e)})});B(u,"masters/highcharts-more.src.js",[],function(){})});
//# sourceMappingURL=highcharts-more.js.map

/***/ }),
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var dateTimeRegEx = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{1,2}(\.\d+)?)?(Z)?$/;
    function stringToDate(input) {
        if (typeof input !== 'object') {
            return input;
        }
        for (var key in input) {
            if (!input.hasOwnProperty(key)) {
                continue;
            }
            var value = input[key];
            var match;
            if (typeof value === 'string' && (match = value.match(dateTimeRegEx))) {
                var dateValue = match[0];
                if (!match[3]) {
                    dateValue = dateValue + 'Z';
                }
                var milliseconds = Date.parse(dateValue);
                if (!isNaN(milliseconds)) {
                    input[key] = new Date(milliseconds);
                }
            }
            else if (typeof value === 'object') {
                stringToDate(value);
            }
        }
        return input;
    }
    exports.default = stringToDate;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(5), __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(6), __webpack_require__(8), __webpack_require__(7), __webpack_require__(4), __webpack_require__(73), __webpack_require__(30), __webpack_require__(32), __webpack_require__(12), __webpack_require__(61), __webpack_require__(38), __webpack_require__(110), __webpack_require__(405), __webpack_require__(279), __webpack_require__(90)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, aps_enums_1, angular, _, moment, notify_service_1, navigation_service_1, authData_service_1, loader_service_1, sectionChange_service_1, checkLists_service_1, checkListInstances_service_1, newguid_service_1, checkListReportDetails_controller_1, fillOutCheckList_controller_1, viewDefect_controller_1, notificationComment_controller_1, cron_1, jobRun_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [authData_service_1.default, notify_service_1.default, navigation_service_1.default, loader_service_1.default,
        sectionChange_service_1.default, checkLists_service_1.default, checkListInstances_service_1.default, checkListReportDetails_controller_1.default,
        fillOutCheckList_controller_1.default, viewDefect_controller_1.default, notificationComment_controller_1.default, jobRun_service_1.default, newguid_service_1.default];
    var NotificationImpl = (function () {
        function NotificationImpl(data, parent, notificationService, authDataService) {
            _.assign(this, data);
            this.parent = parent;
            this.notificationService = notificationService;
            switch (this.type) {
                case aps_enums_1.apsEnums.NotificationType.CriticalDefect:
                    this.doneLabel = 'View Defect';
                    break;
                case aps_enums_1.apsEnums.NotificationType.CheckList:
                    this.doneLabel = 'Not able to complete';
                    this.doneCommentTitle = 'Dismiss Check List';
                    break;
                default:
                    this.doneLabel = 'Done';
            }
        }
        NotificationImpl.prototype.isReadAvailable = function () {
            return this.status === aps_enums_1.apsEnums.NotificationStatus.Sent;
        };
        NotificationImpl.prototype.isDoneAvailable = function () {
            return this.status < aps_enums_1.apsEnums.NotificationStatus.Done
                && this.type !== aps_enums_1.apsEnums.NotificationType.CheckListSignOff
                && this.type !== aps_enums_1.apsEnums.NotificationType.SectionChange;
        };
        NotificationImpl.prototype.isFillOutAvailable = function () {
            return this.type === aps_enums_1.apsEnums.NotificationType.CheckList;
        };
        NotificationImpl.prototype.isSignOffAvailable = function () {
            return this.type === aps_enums_1.apsEnums.NotificationType.CheckListSignOff;
        };
        NotificationImpl.prototype.isSectionChangeAvailable = function () {
            return this.type === aps_enums_1.apsEnums.NotificationType.SectionChange;
        };
        NotificationImpl.prototype.isViewCheckListDetailsAvailable = function () {
            return this.type === aps_enums_1.apsEnums.NotificationType.CheckListEdited;
        };
        NotificationImpl.prototype.go = function () {
            this.read();
            NotificationImpl.$window.open(this.url);
        };
        NotificationImpl.prototype.read = function () {
            var _this = this;
            if (!this.isReadAvailable()) {
                return;
            }
            this.notificationService.readNotification(this.id)
                .then(function () {
                _this.status = aps_enums_1.apsEnums.NotificationStatus.Read;
            }, NotificationImpl.notifyService.handleApiErrors);
        };
        NotificationImpl.prototype.done = function () {
            var _this = this;
            if (!this.isDoneAvailable()) {
                return;
            }
            var doneComment = null;
            var submitDone = function () {
                var promise = _this.notificationService.completeNotification(_this.id, doneComment)
                    .then(function () {
                    _this.parent.remove(_this);
                    if (_this.type === aps_enums_1.apsEnums.NotificationType.CriticalDefect) {
                        _this.viewDefect();
                    }
                }, NotificationImpl.notifyService.handleApiErrors);
                NotificationImpl.loaderService.loadingPromise(promise);
            };
            if (this.doneRequiresComment) {
                var result = notificationComment_controller_1.openNotificationComment({
                    title: this.doneCommentTitle
                }, NotificationImpl.$modal);
                result.then(function (comment) {
                    doneComment = comment;
                    submitDone();
                });
            }
            else {
                submitDone();
            }
        };
        NotificationImpl.prototype.sectionChange = function () {
            if (!this.isSectionChangeAvailable()) {
                return;
            }
            NotificationImpl.sectionChangeService.openToolChangeForSectionChange({
                sectionChangeId: this.detail,
                sectionChangeSectionId: this.id,
                shopId: this.shopId,
                isMachineId: this.isMachineId,
                section: this.section
            });
        };
        NotificationImpl.prototype.skipSectionChange = function () {
            if (!this.isSectionChangeAvailable()) {
                return;
            }
            NotificationImpl.sectionChangeService.skipSectionChange({
                sectionChangeId: this.detail,
                id: this.id,
                shopId: this.shopId
            }).catch(NotificationImpl.notifyService.handleApiErrors);
        };
        NotificationImpl.prototype.viewDefect = function () {
            viewDefect_controller_1.openViewDefect({
                defectId: this.detail,
                defect: null,
                canComment: null,
                gob: null,
                readOnly: null,
                plantId: null
            }, NotificationImpl.$modal);
        };
        NotificationImpl.prototype.fillOut = function () {
            var _this = this;
            if (!this.isFillOutAvailable()) {
                return;
            }
            this.read();
            if (this.type === aps_enums_1.apsEnums.NotificationType.CheckList) {
                NotificationImpl.navigationService.getNavigation().then(function (nav) {
                    var plantLocationId = null;
                    var plant = _.find(nav.plants(), { id: _this.plantId });
                    if (_this.tankId) {
                        var tank = _.find(plant.tanks, { id: _this.tankId });
                        if (_this.shopId) {
                            var shop = _.find(tank.shops, { id: _this.shopId });
                            plantLocationId = shop.plantLocationId;
                        }
                        else {
                            plantLocationId = tank.plantLocationId;
                        }
                    }
                    else {
                        plantLocationId = plant.plantLocationId;
                    }
                    fillOutCheckList_controller_1.openFillOutCheckList({
                        checkListId: _this.detail,
                        instanceId: _this.id,
                        shopId: _this.shopId,
                        plantId: _this.plantId,
                        tankId: _this.tankId,
                        readOnly: false,
                        plantLocationId: plantLocationId,
                        scheduledOn: _this.sendOn
                    }, NotificationImpl.$modal);
                });
            }
        };
        NotificationImpl.prototype.viewCheckListDetails = function () {
            if (!this.isViewCheckListDetailsAvailable() && !this.isSignOffAvailable()) {
                return;
            }
            this.read();
            var data = JSON.parse(this.detail);
            var promise = NotificationImpl.checkListsService
                .getCheckListReportDetail(data.instanceId, data.plantLocationId, data.scheduledOn, aps_enums_1.apsEnums.CheckListReportFilter.AllCheckLists)
                .then(function (detail) {
                checkListReportDetails_controller_1.openCheckListReportDetails({
                    checkListInstance: detail.reportItem,
                    detail: detail
                }, NotificationImpl.$modal);
            });
            NotificationImpl.loaderService.loadingPromise(promise);
        };
        return NotificationImpl;
    }());
    var NotificationsImpl = (function () {
        function NotificationsImpl(data, notificationService, $window, $scope) {
            var _this = this;
            this.notifications = [];
            this.showNotification = false;
            this.notificationService = notificationService;
            if (NotificationImpl.authDataService.isHEMachineOperator() || NotificationImpl.authDataService.isHEUpkeep()) {
                NotificationImpl.navigationService.getNavigation().then(function (nav) {
                    _this.shopId = nav.selectedShop.id;
                    NotificationImpl.jobRunService.getJobRuns(_this.shopId)
                        .then(function (jobRuns) {
                        _.forEach(jobRuns, function (jobRun) {
                            if (jobRun.endDate == null) {
                                if (jobRun.alertTimeWeighBottle != null && jobRun.alertTimeWeighBottle !== 0) {
                                    var cron1 = new cron_1.CronJob('1 */' + jobRun.alertTimeWeighBottle + ' * * * *', function () {
                                        var command = {
                                            Id: null,
                                            WellknownCheckId: 9,
                                            PlantId: nav.selectedPlant.id,
                                            ShopId: nav.selectedShop.id,
                                            WellKnownCheckListResult: 0,
                                            dateTimeString: moment(new Date()).format('MM/DD/YYYY hh:mm A')
                                        };
                                        NotificationImpl.newGuidService.getNewGuid('checkListInstance').then(function (id) { return command.Id = id; });
                                        NotificationImpl.notifyService.alertWeigh(NotificationImpl.checkListInstancesService, command, moment(new Date()).format('MM/DD/YYYY hh:mm A')
                                            + " : \n\r Please Record Bottle Weights");
                                    }, null, true, 'America/Los_Angeles');
                                    _this.notificationService.setCronJob1(cron1);
                                }
                                else {
                                    _this.notificationService.stopCronJob1();
                                }
                                if (jobRun.alertTimeSwabMold != null && jobRun.alertTimeSwabMold !== 0) {
                                    var cron2 = new cron_1.CronJob('2 */' + jobRun.alertTimeSwabMold + ' * * * *', function () {
                                        var command = {
                                            Id: null,
                                            WellknownCheckId: 11,
                                            PlantId: nav.selectedPlant.id,
                                            ShopId: nav.selectedShop.id,
                                            WellKnownCheckListResult: 0,
                                            dateTimeString: moment(new Date()).format('MM/DD/YYYY hh:mm A')
                                        };
                                        NotificationImpl.newGuidService.getNewGuid('checkListInstance').then(function (id) { return command.Id = id; });
                                        NotificationImpl.notifyService.alertMold(NotificationImpl.checkListInstancesService, command, moment(new Date()).format('MM/DD/YYYY hh:mm A')
                                            + " : \n\r Time To Swab The Mold Side");
                                    }, null, true, 'America/Los_Angeles');
                                    _this.notificationService.setCronJob2(cron2);
                                }
                                else {
                                    _this.notificationService.stopCronJob2();
                                }
                                if (jobRun.alertTimeSwabBlank != null && jobRun.alertTimeSwabBlank !== 0) {
                                    var cron3 = new cron_1.CronJob('3 */' + jobRun.alertTimeSwabBlank + ' * * * *', function () {
                                        var command = {
                                            Id: null,
                                            WellknownCheckId: 10,
                                            PlantId: nav.selectedPlant.id,
                                            ShopId: nav.selectedShop.id,
                                            WellKnownCheckListResult: 0,
                                            dateTimeString: moment(new Date()).format('MM/DD/YYYY hh:mm A')
                                        };
                                        NotificationImpl.newGuidService.getNewGuid('checkListInstance').then(function (id) { return command.Id = id; });
                                        NotificationImpl.notifyService.alertBlank(NotificationImpl.checkListInstancesService, command, moment(new Date()).format('MM/DD/YYYY hh:mm A')
                                            + " : \n\r Time To Swab The Blank Side");
                                    }, null, true, 'America/Los_Angeles');
                                    _this.notificationService.setCronJob3(cron3);
                                }
                                else {
                                    _this.notificationService.stopCronJob3();
                                }
                            }
                        });
                    });
                });
            }
            _.forEach(data, function (notification) {
                if (!_this.checkPlant(notification)) {
                    return;
                }
                _this.notifications.push(new NotificationsImpl.Notification(notification, _this, _this.notificationService));
                if (notification.type === aps_enums_1.apsEnums.NotificationType.CriticalDefect) {
                    if (notification.status !== aps_enums_1.apsEnums.NotificationStatus.Read) {
                        NotificationImpl.notifyService.alertCritical(_this.notificationService, notification.id, notification.description, notification.title + " - " + notification.sentOn.toLocaleDateString() + " " + notification.sentOn.toLocaleTimeString());
                    }
                }
            });
            $($window).click(function () {
                if (_this.showNotification) {
                    NotificationsImpl.$timeout(function () {
                        _this.showNotification = false;
                    });
                }
            });
        }
        NotificationsImpl.prototype.checkPlant = function (notification) {
            if (!notification.plantId) {
                return true;
            }
            var role = NotificationsImpl.authDataService.getSelectedRoleLocation().role;
            return !role.roleRequiresPlants || _.some(role.plants, function (p) { return p.id === notification.plantId; });
        };
        NotificationsImpl.prototype.showNotifications = function () {
            return this.showNotification;
        };
        NotificationsImpl.prototype.toggleShowNotifications = function (event) {
            this.showNotification = !this.showNotification;
            event.stopPropagation();
        };
        NotificationsImpl.prototype.unreadNotifications = function () {
            return _.filter(this.notifications, { status: aps_enums_1.apsEnums.NotificationStatus.Sent }).length;
        };
        NotificationsImpl.prototype.showUnread = function () {
            return this.unreadNotifications() > 0;
        };
        NotificationsImpl.prototype.addNotification = function (notification) {
            if (!this.checkPlant(notification)) {
                return;
            }
            this.notifications.unshift(new NotificationsImpl.Notification(notification, this, this.notificationService));
            if (notification.type === aps_enums_1.apsEnums.NotificationType.CriticalDefect) {
                NotificationImpl.notifyService.alertCritical(this.notificationService, notification.id, notification.description, notification.title + " - " + notification.sentOn.toLocaleDateString() + " " + notification.sentOn.toLocaleTimeString());
            }
            this.showNotification = true;
        };
        NotificationsImpl.prototype.getNotification = function (notification) {
            return _.find(this.notifications, { id: notification.id });
        };
        NotificationsImpl.prototype.setStatus = function (notification, status) {
            var existing = this.getNotification(notification);
            if (existing) {
                existing.status = status;
            }
        };
        NotificationsImpl.prototype.markRead = function (notification) {
            this.setStatus(notification, aps_enums_1.apsEnums.NotificationStatus.Read);
        };
        NotificationsImpl.prototype.remove = function (notification) {
            _.remove(this.notifications, { id: notification.id });
        };
        return NotificationsImpl;
    }());
    exports.default = angular.module('aps.models.notifications', requires)
        .factory('Notification', ["loaderService", "notifyService", "newGuidService", "$state", "$window", "$modal", "sectionChangeService", "jobRunService", "navigationService", "authDataService", "checkListsService", "checkListInstancesService", function (loaderService, notifyService, newGuidService, $state, $window, $modal, sectionChangeService, jobRunService, navigationService, authDataService, checkListsService, checkListInstancesService) {
        NotificationImpl.loaderService = loaderService;
        NotificationImpl.notifyService = notifyService;
        NotificationImpl.newGuidService = newGuidService;
        NotificationImpl.checkListInstancesService = checkListInstancesService;
        NotificationImpl.$state = $state;
        NotificationImpl.$window = $window;
        NotificationImpl.$modal = $modal;
        NotificationImpl.sectionChangeService = sectionChangeService;
        NotificationImpl.checkListsService = checkListsService;
        NotificationImpl.navigationService = navigationService;
        NotificationImpl.jobRunService = jobRunService;
        NotificationImpl.authDataService = authDataService;
        return NotificationImpl;
    }])
        .factory('Notifications', ["Notification", "$timeout", "$", "authDataService", function (Notification, $timeout, $, authDataService) {
        NotificationsImpl.Notification = Notification;
        NotificationsImpl.authDataService = authDataService;
        NotificationsImpl.$timeout = $timeout;
        NotificationsImpl.$ = $;
        return NotificationsImpl;
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(3), __webpack_require__(10), __webpack_require__(276), __webpack_require__(25), __webpack_require__(47), __webpack_require__(60)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, constant_module_1, http_service_1, shopActivity_1, defectType_service_1, toolChange_service_1, userProfile_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [http_service_1.default, defectType_service_1.default, toolChange_service_1.default, userProfile_1.default];
    exports.default = angular.module('aps.services.lineSheet', requires)
        .service('lineSheetService', ["$q", "httpService", "defectTypeService", "userProfile", "toolChangeService", function ($q, httpService, defectTypeService, userProfile, toolChangeService) {
        function getLineSheetActivity(shopId, date) {
            var _this = this;
            return $q.all([
                httpService.get(constant_module_1.Endpoints.LINESHEET, {
                    shopId: shopId,
                    date: date ? date.format() : null
                }),
                defectTypeService.getDefectTypesAndClassifications(),
                toolChangeService.getToolsAndTypes(),
                userProfile.read()
            ]).then(function (response) {
                return new shopActivity_1.ShopActivity(response[0], response[1], response[3], response[2], _this.jobs, _this.jobProcess, _this.eightyHrTools, _this.oneSixtyHrTools);
            });
        }
        function getLineSheetActivityData(shopId, date) {
            return httpService.get(constant_module_1.Endpoints.LINESHEET, {
                shopId: shopId,
                date: date ? date.format() : null
            });
        }
        function lockHour(command) {
            return httpService.post(constant_module_1.Endpoints.LINESHEET_LOCK_HOUR, command);
        }
        function unlockHour(command) {
            return httpService.post(constant_module_1.Endpoints.LINESHEET_UNLOCK_HOUR, command);
        }
        return {
            getLineSheetActivity: getLineSheetActivity,
            getLineSheetActivityData: getLineSheetActivityData,
            lockHour: lockHour,
            unlockHour: unlockHour
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(391), __webpack_require__(395), __webpack_require__(396), __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, gobActivity_1, jobRunActivity_1, hourActivity_1, moment, _) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ShopActivity = (function () {
        function ShopActivity(data, defectTypesAndClassifications, userProfileData, toolsAndTypes, jobs, jobProcess, eightyHrTools, oneSixtyHrTools) {
            var _this = this;
            this.userProfileData = userProfileData;
            this.numberOfColumns = 30;
            this.id = data.id;
            this.name = data.name;
            this.timeZoneId = data.timeZoneId;
            this.maxNumberOfSections = 0;
            this.maxNumberOfGobs = 0;
            this.defectTypes = defectTypesAndClassifications.types;
            this.tools = toolsAndTypes;
            this.jobs = jobs;
            this.jobProcess = jobProcess;
            this.eightyHrTools = eightyHrTools;
            this.oneSixtyHrTools = oneSixtyHrTools;
            this.initializeHours(data);
            this.jobRuns = _.map(data.jobRuns, function (jobRun) { return new jobRunActivity_1.default(jobRun); });
            _.forEach(this.jobRuns, function (jobRun) {
                if (jobRun.numberOfSections > _this.maxNumberOfSections) {
                    _this.maxNumberOfSections = jobRun.numberOfSections;
                }
                if (jobRun.numberOfGobs > _this.maxNumberOfGobs) {
                    _this.maxNumberOfGobs = jobRun.numberOfGobs;
                }
                _this.updateHoursFromJobRun(jobRun);
            });
            this.initializeHoursAndJobs();
            this.machines = [];
            this.sections = [];
            this.gobs = [];
            var activeJobRuns = this.jobRuns.filter(function (x) { return !x.endDate; });
            var currentJobRun = activeJobRuns.length > 0 ? activeJobRuns[0] : null;
            _.forEach(data.machines, function (machine) {
                _this.initializeMachine(machine, currentJobRun);
            });
            this.initializeAllActivity();
            this.addDefects(data.defects);
            this.addToolChanges(data.toolChanges);
            this.addDowntime(data.downtime);
            this.addQualifications(data.qualifications);
            this.addCheckLists(data.checkLists);
        }
        ShopActivity.prototype.updateHours = function () {
            var _this = this;
            var startTime = moment().startOf('hour').toDate();
            var endTime = moment(startTime).add(1, 'hours').toDate();
            var lastUnlockedHour = moment(startTime)
                .subtract(this.numberOfUnlockedHours - 1, 'hours').toDate();
            var index = 0;
            while (startTime.getTime() >= this.hours[0].endTime.getTime()) {
                this.hours.splice(index, 0, new hourActivity_1.default(startTime, endTime, (startTime.getTime() < lastUnlockedHour.getTime()), this.timeZoneId));
                _.forEach(this.allActivity, function (a) { return a.insertHour(index, _this.hours[index]); });
                endTime = startTime;
                startTime = moment(startTime).subtract(1, 'hours').toDate();
                index++;
            }
            _.forEach(_.filter(this.hours, function (h) { return !h.overridden &&
                !h.isLocked && h.startTime.getTime() < lastUnlockedHour.getTime(); }), function (h) { return h.isLocked = true; });
            var lastHour = moment().startOf('hour').subtract(23, 'hours').toDate().getTime();
            _.remove(this.hours, function (h) { return h.endTime.getTime() <= lastHour; });
            _.forEach(this.jobRuns, function (jobRun) { return _this.updateHoursFromJobRun(jobRun); });
            this.initializeHoursAndJobs();
        };
        ShopActivity.prototype.initializeHours = function (data) {
            var _this = this;
            var hours = [];
            this.numberOfUnlockedHours = data.numberOfUnlockedHours;
            var lastUnlockedHour = moment().startOf('hour')
                .subtract(data.numberOfUnlockedHours - 1, 'hours').toDate();
            var startTime = data.lastHour;
            var endTime = moment(startTime).add(1, 'hours').toDate();
            while (startTime.getTime() >= data.firstHour.getTime()) {
                hours.push(new hourActivity_1.default(startTime, endTime, (startTime.getTime() < lastUnlockedHour.getTime()), data.timeZoneId));
                endTime = startTime;
                startTime = moment(startTime).subtract(1, 'hours').toDate();
            }
            this.hours = hours;
            _.forEach(data.lockedHours, function (hour) {
                _this.lockUnlockHourFromEvent(hour.hour, hour.isLocked);
            });
        };
        ShopActivity.prototype.initializeAllActivity = function () {
            var all = [];
            _.forEach(this.machines, function (machine) {
                all.push(machine.machineLevelActivity);
                all = all.concat(machine.gobs);
            });
            this.allActivity = all;
        };
        ShopActivity.prototype.addCheckLists = function (checkLists) {
            var _this = this;
            _.forEach(checkLists, function (checkList) {
                var index = _this.getHourIndex(checkList.scheduledOn);
                if (index === null) {
                    return;
                }
                _this.hours[index].addOrUpdateCheckList(checkList);
            });
        };
        ShopActivity.prototype.addDefects = function (defects) {
            var _this = this;
            _.forEach(defects, function (defect) {
                var gobs = _this.findGobs(defect.isMachineId, defect.section, defect.gob, true);
                _.forEach(gobs, function (gob) { return gob.addDefect(defect); });
            });
        };
        ShopActivity.prototype.addToolChanges = function (toolChanges) {
            var _this = this;
            _.forEach(toolChanges, function (toolChange) {
                var gobs = _this.findGobs(toolChange.isMachineId, toolChange.section, toolChange.gob, true);
                _.forEach(gobs, function (gob) { return gob.addToolChange(toolChange); });
            });
        };
        ShopActivity.prototype.addDowntime = function (downtimes) {
            var _this = this;
            _.forEach(downtimes, function (downtime) {
                var gobs = _this.findGobs(downtime.isMachineId, downtime.section);
                _.forEach(gobs, function (gob) { return gob.addDowntime(downtime); });
            });
        };
        ShopActivity.prototype.addQualifications = function (qualifications) {
            var _this = this;
            _.forEach(qualifications, function (qualification) {
                var gobs = _this.findGobs(qualification.isMachineId, qualification.section, qualification.gob);
                _.forEach(gobs, function (gob) { return gob.addQualification(qualification); });
            });
        };
        ShopActivity.prototype.updateHoursFromJobRun = function (jobRun) {
            if (!jobRun.endDate || this.isFuture(jobRun.endDate)) {
                return;
            }
            var hourIndex = this.getHourIndex(jobRun.endDate);
            if (hourIndex === null) {
                return;
            }
            var hour = this.hours[hourIndex];
            if (moment.utc(jobRun.endDate).isSame(moment.utc(hour.startTime))) {
                return;
            }
            var newHour = new hourActivity_1.default(jobRun.endDate, hour.endTime, hour.isLocked, this.timeZoneId);
            this.hours.splice(hourIndex, 0, newHour);
            hour.endTime = jobRun.endDate;
        };
        ShopActivity.prototype.initializeHoursAndJobs = function () {
            var _this = this;
            this.hoursAndJobs = [];
            var currentJob = _.last(this.jobRuns);
            var noEndTime = !currentJob || !(currentJob.endDate);
            _.forEach(this.hours, function (hour) {
                if (currentJob && hour.startTime.getTime() >= currentJob.startDate.getTime()
                    && (noEndTime || hour.startTime.getTime() < currentJob.endDate.getTime())) {
                    hour.jobRun = currentJob;
                    currentJob.hours.push(hour);
                }
                _this.hoursAndJobs.push(hour);
                var jobRun = _.find(_this.jobRuns, { endDate: hour.startTime });
                if (jobRun) {
                    _this.hoursAndJobs.push(jobRun);
                    currentJob = jobRun;
                    noEndTime = false;
                }
            });
        };
        ShopActivity.prototype.displayHoursAndJobs = function () {
            return _.take(this.hoursAndJobs, this.numberOfColumns);
        };
        ShopActivity.prototype.createLatestTools = function (typeName) {
            var latestTools = {};
            _.filter(this.tools, { typeName: typeName }).forEach(function (tool) {
                latestTools[tool.id] = {
                    name: tool.name,
                    toolChange: undefined
                };
            });
            return latestTools;
        };
        ShopActivity.prototype.initializeMachine = function (machine, jobRunActivity) {
            var machineActivity = {
                id: machine.id,
                name: machine.name,
                number: machine.number,
                shop: this,
                sections: [],
                gobs: [],
                machineLevelActivity: undefined,
                latestTools: this.createLatestTools('Machine')
            };
            machineActivity.machineLevelActivity = this.createMachineLevelActivity(machineActivity);
            this.machines.push(machineActivity);
            this.initializeSections(machineActivity, jobRunActivity);
        };
        ShopActivity.prototype.createMachineLevelActivity = function (machineActivity) {
            var sectionZero = {
                name: '',
                sectionNumber: undefined,
                machine: machineActivity,
                gobs: [],
                latestTools: this.createLatestTools('Variable')
            };
            var activity = new gobActivity_1.default(undefined, this.maxNumberOfGobs, sectionZero, this.tools, this.userProfileData, this.defectTypes, this.jobs, this.jobProcess, this.eightyHrTools, this.oneSixtyHrTools);
            sectionZero.gobs.push(activity);
            return activity;
        };
        ShopActivity.prototype.initializeSections = function (machineActivity, jobRunActivity) {
            var _this = this;
            _.forEach(_.range(1, this.maxNumberOfSections + 1), function (section) {
                var sectionActivity = {
                    name: (machineActivity.number === 2
                        ? (section + _this.maxNumberOfSections)
                        : section).toString(),
                    sectionNumber: section,
                    machine: machineActivity,
                    gobs: [],
                    latestTools: _this.createLatestTools('Variable')
                };
                machineActivity.sections.push(sectionActivity);
                _this.sections.push(sectionActivity);
                _this.initializeGobs(machineActivity, sectionActivity);
            });
        };
        ShopActivity.prototype.initializeGobs = function (machineActivity, sectionActivity) {
            var _this = this;
            _.forEach(_.range(1, this.maxNumberOfGobs + 1), function (gob) {
                var gobActivity = new gobActivity_1.default(gob, _this.maxNumberOfGobs, sectionActivity, _this.tools, _this.userProfileData, _this.defectTypes, _this.jobs, _this.jobProcess, _this.eightyHrTools, _this.oneSixtyHrTools);
                sectionActivity.gobs.push(gobActivity);
                machineActivity.gobs.push(gobActivity);
                _this.gobs.push(gobActivity);
            });
        };
        ShopActivity.prototype.addDefectFromEvent = function (event) {
            if (this.getHourIndex(event.timeFound) === null) {
                return;
            }
            var gobs = this.findGobs(event.isMachineId, event.section, event.gob, true);
            if (gobs.length === 0) {
                throw 'Unable to find gobs for event: ' + event;
            }
            var defectType = _.find(this.defectTypes, { id: event.defectTypeId });
            if (!defectType) {
                throw 'Unable to find defect type for event: ' + event;
            }
            var defectActivity = _.assign({}, event);
            if (!defectActivity.createdOn) {
                defectActivity.createdOn = event.eventDate;
            }
            if (defectActivity.comments.length > 0) {
                defectActivity.comments[0].createdOn = event.comments[0].eventDate;
            }
            _.forEach(gobs, function (gob) {
                gob.addDefect(defectActivity);
            });
        };
        ShopActivity.prototype.deleteDefectFromEvent = function (event) {
            var index = this.getHourIndex(event.timeFound);
            if (index === null) {
                return;
            }
            var gobs = this.findGobs(event.isMachineId, event.section, event.gob, true);
            if (gobs.length === 0) {
                throw 'Unable to find gobs for event: ' + event;
            }
            _.forEach(gobs, function (gob) {
                var defect = _.find(gob.hours[index].activity, { id: event.id });
                if (defect) {
                    _.remove(gob.hours[index].activity, defect);
                }
                defect = _.find(gob.defects, { id: event.id });
                if (defect) {
                    _.remove(gob.defects, defect);
                }
            });
        };
        ShopActivity.prototype.addDowntimeFromEvent = function (event) {
            if (this.getHourIndex(event.downtimeStart) === null) {
                return;
            }
            var gobs = this.findGobs(event.isMachineId, event.section);
            if (gobs.length === 0) {
                throw 'Unable to find gobs for event: ' + event;
            }
            var downtimeActivity = _.assign({}, event);
            downtimeActivity.comments = [];
            _.forEach(gobs, function (gob) {
                gob.addDowntime(downtimeActivity);
                _.forEach(event.comments, function (commentAdded) {
                    gob.addDowntimeComment(commentAdded);
                });
            });
        };
        ShopActivity.prototype.deleteDowntimeFromEvent = function (event) {
            var index = this.getHourIndex(event.downtimeStart);
            if (index === null) {
                return;
            }
            var gobs = this.findGobs(event.isMachineId, event.section);
            if (gobs.length === 0) {
                throw 'Unable to find gobs for event: ' + event;
            }
            _.forEach(gobs, function (gob) {
                var downtime = _.find(gob.hours[index].activity, { id: event.id });
                if (downtime) {
                    _.remove(gob.hours[index].activity, downtime);
                }
            });
        };
        ShopActivity.prototype.addQualificationFromEvent = function (event) {
            if (this.getHourIndex(event.qualificationTime) === null) {
                return;
            }
            var gobs = this.findGobs(event.isMachineId, event.section, event.gob);
            if (gobs.length === 0) {
                throw 'Unable to find gobs for event: ' + event;
            }
            _.forEach(gobs, function (gob) {
                gob.addQualification(event);
            });
        };
        ShopActivity.prototype.deleteQualificationFromEvent = function (event) {
            if (this.getHourIndex(event.qualificationTime) === null) {
                return;
            }
            var gobs = this.findGobs(event.isMachineId, event.section, event.gob);
            if (gobs.length === 0) {
                throw 'Unable to find gobs for event: ' + event;
            }
            _.forEach(gobs, function (gob) {
                gob.deleteQualification(event);
            });
        };
        ShopActivity.prototype.addDefectCommentFromEvent = function (commentEvent) {
            var index = this.getHourIndex(commentEvent.timeFound);
            if (index === null) {
                return;
            }
            var gobs = this.findGobs(commentEvent.isMachineId, commentEvent.section, commentEvent.gob, true);
            if (gobs.length === 0) {
                throw 'Unable to find gobs for event: ' + event;
            }
            var comment = _.assign({}, commentEvent);
            comment.createdOn = commentEvent.eventDate;
            _.forEach(gobs, function (gob) {
                var defect = _.find(gob.hours[index].activity, { id: commentEvent.defectId });
                if (defect) {
                    defect.comments.push(comment);
                }
            });
        };
        ShopActivity.prototype.addDefectHeldPalletsFromEvent = function (addHeldPallets) {
            var index = this.getHourIndex(addHeldPallets.timeFound);
            if (index === null) {
                return;
            }
            var gobs = this.findGobs(addHeldPallets.isMachineId, addHeldPallets.section, addHeldPallets.gob, true);
            if (gobs.length === 0) {
                throw 'Unable to find gobs for event: ' + event;
            }
            var heldPallets = _.assign({}, addHeldPallets);
            _.forEach(gobs, function (gob) {
                var defect = _.find(gob.hours[index].activity, { id: addHeldPallets.defectId });
                if (defect) {
                    var heldPallet = _.find(defect.heldPallets, { id: addHeldPallets.id });
                    if (heldPallet) {
                        return;
                    }
                    defect.heldPallets.push(heldPallets);
                }
            });
        };
        ShopActivity.prototype.deleteDefectHeldPalletsFromEvent = function (deleteHeldPallets) {
            var index = this.getHourIndex(deleteHeldPallets.timeFound);
            if (index === null) {
                return;
            }
            var gobs = this.findGobs(deleteHeldPallets.isMachineId, deleteHeldPallets.section, deleteHeldPallets.gob, true);
            if (gobs.length === 0) {
                throw 'Unable to find gobs for event: ' + event;
            }
            _.forEach(gobs, function (gob) {
                var defect = _.find(gob.hours[index].activity, { id: deleteHeldPallets.defectId });
                if (defect) {
                    var heldPallet = _.find(defect.heldPallets, { id: deleteHeldPallets.id });
                    if (!heldPallet) {
                        return;
                    }
                    _.remove(defect.heldPallets, heldPallet);
                }
            });
        };
        ShopActivity.prototype.addToolChangeFromEvent = function (toolChangeEvent) {
            var _this = this;
            if (this.getHourIndex(toolChangeEvent.timeChanged) === null) {
                return;
            }
            _.forEach(toolChangeEvent.toolChanges, function (toolChange) {
                var gobs = _this.findGobs(toolChangeEvent.isMachineId, toolChange.section, toolChange.gob, true);
                if (gobs.length === 0) {
                    throw 'Unable to find gobs for event: ' + toolChange;
                }
                var tool = _.find(_this.tools, { id: toolChange.toolId });
                if (!tool) {
                    throw 'Unable to find tool for event: ' + toolChange;
                }
                _.forEach(gobs, function (gob) {
                    gob.addToolChange({
                        id: toolChange.id,
                        shopId: toolChangeEvent.shopId,
                        isMachineId: toolChangeEvent.isMachineId,
                        section: toolChange.section,
                        gob: toolChange.gob,
                        gobName: toolChange.gobName,
                        unlistedDefect: toolChange.unlistedDefect,
                        defectId: toolChange.defectId,
                        defectTypeId: toolChange.defectTypeId,
                        defectTypeName: toolChange.defectTypeName,
                        duration: toolChangeEvent.duration,
                        timeChanged: toolChangeEvent.timeChanged,
                        toolNumber: toolChange.toolNumber,
                        toolId: toolChange.toolId,
                        toolName: tool.name,
                        toolIsMold: tool.isMold,
                        reason: toolChange.reason,
                        otherReason: toolChange.otherReason,
                        toolChangeId: toolChangeEvent.id,
                        createdByFullName: toolChangeEvent.createdByFullName,
                        comment: toolChange.comment,
                        toolType: tool.type,
                        rootComments: _.map(toolChangeEvent.rootComments, function (comment) {
                            return {
                                id: comment.id,
                                toolChangeId: toolChangeEvent.id,
                                comment: comment.comment,
                                createdOn: toolChangeEvent.eventDate,
                                createdByFullName: toolChangeEvent.createdByFullName
                            };
                        })
                    });
                });
            });
        };
        ShopActivity.prototype.editToolChangeForGob = function (event, gob, gobHour) {
            var _this = this;
            if (!event || !gob || !gobHour) {
                return;
            }
            var toolChange = _.find(gobHour.activity, { id: event.id });
            var toolChanges = [];
            if (toolChange) {
                toolChange.timeChanged = event.timeChanged;
                toolChanges = _.filter(toolChange.tools, function (tc) {
                    return (tc.section || 0) === (gob.section.sectionNumber || 0)
                        && (((tc.gob || 0) === (gob.gobNumber || 0)) || ((tc.gob || 0) === 0));
                });
            }
            var eventChanges = _.filter(event.toolChanges, function (tc) {
                return (tc.section || 0) === (gob.section.sectionNumber || 0)
                    && (((tc.gob || 0) === (gob.gobNumber || 0)) || ((tc.gob || 0) === 0));
            });
            if (toolChanges.length === 0 && eventChanges.length === 0) {
                return;
            }
            _.forEach(eventChanges, function (ec) {
                var detail = _.find(toolChanges, { id: ec.id });
                if (detail) {
                    detail.comment = ec.comment;
                    detail.defectId = ec.defectId;
                    detail.defectTypeName = ec.defectTypeName;
                    detail.duration = event.duration;
                    detail.otherReason = ec.otherReason;
                    detail.reason = ec.reason;
                    detail.timeChanged = event.timeChanged;
                    detail.toolNumber = ec.toolNumber;
                }
                else {
                    var tool = _.find(_this.tools, { id: ec.toolId });
                    if (!tool) {
                        throw 'Unable to find tool for event: ' + ec;
                    }
                    var comments = [];
                    _.forEach(event.rootComments, function (c) {
                        comments.push({
                            id: c.id,
                            toolChangeId: c.toolChangeId,
                            comment: c.comment,
                            createdOn: c.eventDate,
                            createdByFullName: c.createdByFullName
                        });
                    });
                    gob.addToolChange({
                        id: ec.id,
                        comment: ec.comment,
                        createdByFullName: event.createdByFullName,
                        unlistedDefect: ec.unlistedDefect,
                        defectId: ec.defectId,
                        defectTypeName: ec.defectTypeName,
                        defectTypeId: ec.defectTypeId,
                        duration: event.duration,
                        gob: ec.gob,
                        gobName: ec.gobName,
                        isMachineId: event.isMachineId,
                        otherReason: ec.otherReason,
                        reason: ec.reason,
                        rootComments: comments,
                        section: ec.section,
                        shopId: event.shopId,
                        timeChanged: event.timeChanged,
                        toolChangeId: event.id,
                        toolId: ec.toolId,
                        toolIsMold: ec.toolIsMold,
                        toolName: ec.toolName,
                        toolNumber: ec.toolNumber,
                        toolType: tool.type
                    });
                }
            });
            _.forEach(toolChanges, function (tc) {
                if (!_.some(eventChanges, { id: tc.id })) {
                    gob.removeToolChange(tc, toolChange, gobHour);
                }
            });
        };
        ShopActivity.prototype.editToolChangeFromEvent = function (event) {
            var _this = this;
            var index = this.getHourIndex(event.timeChanged);
            if (index === null) {
                return;
            }
            var machine = _.find(this.machines, { id: event.isMachineId });
            if (machine === null) {
                return;
            }
            this.editToolChangeForGob(event, machine.machineLevelActivity, machine.machineLevelActivity.hours[index]);
            _.forEach(machine.gobs, function (gob) {
                _this.editToolChangeForGob(event, gob, gob.hours[index]);
            });
        };
        ShopActivity.prototype.deleteToolChangeFromEvent = function (event) {
            var _this = this;
            var index = this.getHourIndex(event.timeChanged);
            if (index === null) {
                return;
            }
            _.forEach(event.toolChanges, function (toolChange) {
                var gobs = _this.findGobs(event.isMachineId, toolChange.section, toolChange.gob, true);
                if (gobs.length === 0) {
                    throw 'Unable to find gobs for event: ' + toolChange;
                }
                _.forEach(gobs, function (gob) {
                    var tc = _.find(gob.hours[index].activity, { id: event.id });
                    if (tc) {
                        tc.tools.forEach(function (tool) {
                            gob.removeToolChange(tool, tc, gob.hours[index]);
                        });
                    }
                });
            });
        };
        ShopActivity.prototype.deleteToolChangeDefectFromEvent = function (event) {
            var index = this.getHourIndex(event.timeChanged);
            if (index === null) {
                return;
            }
            var gobs = this.findGobs(event.isMachineId, event.section, event.gob, true);
            if (gobs.length === 0) {
                throw 'Unable to find gobs for event: ' + event;
            }
            _.forEach(gobs, function (gob) {
                var tc = _.find(gob.hours[index].activity, { id: event.id });
                if (tc) {
                    var detail = _.find(tc.tools, { id: event.toolChangeDetailId });
                    if (detail) {
                        detail.defectId = null;
                        detail.unlistedDefect = true;
                    }
                }
            });
        };
        ShopActivity.prototype.addToolChangeCommentFromEvent = function (event) {
            var index = this.getHourIndex(event.timeChanged);
            if (index === null) {
                return;
            }
            var gobs = this.findGobs(event.isMachineId, event.section, event.gob, true);
            if (gobs.length === 0) {
                throw 'Unable to find gobs for event: ' + event;
            }
            var comment = _.assign({}, event);
            comment.id = event.id;
            comment.createdOn = event.eventDate;
            _.forEach(gobs, function (gob) {
                var tc = _.find(gob.hours[index].activity, { id: event.toolChangeId });
                if (tc) {
                    var existing = _.find(tc.comments, { id: comment.id });
                    if (!existing) {
                        tc.comments.push(comment);
                    }
                }
            });
        };
        ShopActivity.prototype.lockUnlockHourFromEvent = function (startTime, lock) {
            var hour = _.find(this.hours, { startTime: startTime });
            if (hour) {
                hour.isLocked = lock;
                hour.overridden = true;
            }
        };
        ShopActivity.prototype.lockHourFromEvent = function (event) {
            this.lockUnlockHourFromEvent(event.hour, true);
        };
        ShopActivity.prototype.unlockHourFromEvent = function (event) {
            this.lockUnlockHourFromEvent(event.hour, false);
        };
        ShopActivity.prototype.addDowntimeDurationFromEvent = function (event) {
            if (this.getHourIndex(event.downtimeStart) === null) {
                return;
            }
            var gobs = this.findGobs(event.isMachineId, event.section);
            if (gobs.length === 0) {
                throw 'Unable to find gobs for event: ' + event;
            }
            _.forEach(gobs, function (gob) {
                gob.addDowntimeDuration(event);
            });
        };
        ShopActivity.prototype.updateDefectMoldRejectFromEvent = function (event) {
            var index = this.getHourIndex(event.timeFound);
            if (index === null) {
                return;
            }
            var gobs = this.findGobs(event.isMachineId, event.section, event.gob);
            if (gobs.length === 0) {
                throw 'Unable to find gobs for event: ' + event;
            }
            _.forEach(gobs, function (gob) {
                var defect = _.find(gob.hours[index].activity, { id: event.defectId });
                if (defect) {
                    defect.setMoldReject(event);
                }
            });
        };
        ShopActivity.prototype.updateDefectEquipFailureFromEvent = function (event) {
            var index = this.getHourIndex(event.timeFound);
            if (index === null) {
                return;
            }
            var machine = _.find(this.machines, { id: event.isMachineId });
            var machineDefect = _.find(machine.machineLevelActivity.defects, { id: event.defectId });
            if (machineDefect) {
                machineDefect.setEquipFailure(event);
            }
            else {
                var gobs = this.findGobs(event.isMachineId, event.section, event.gob);
                if (gobs.length === 0) {
                    throw 'Unable to find gobs for event: ' + event;
                }
                _.forEach(gobs, function (gob) {
                    var defect = _.find(gob.hours[index].activity, { id: event.defectId });
                    if (defect) {
                        defect.setEquipFailure(event);
                    }
                });
            }
        };
        ShopActivity.prototype.getHourIndex = function (date) {
            for (var i = 0; i < this.hours.length; i++) {
                if (this.hours[i].withinHour(date)) {
                    return i;
                }
            }
            return null;
        };
        ShopActivity.prototype.isFuture = function (date) {
            return date.getTime() >= this.hours[0].endTime.getTime();
        };
        ShopActivity.prototype.findGobs = function (isMachineId, sectionNumber, gobNumber, includeMachineLevel) {
            var machine = _.find(this.machines, { id: isMachineId });
            if (!machine) {
                return [];
            }
            if ((sectionNumber || 0) === 0) {
                if (includeMachineLevel) {
                    return [machine.machineLevelActivity];
                }
                if ((gobNumber || 0) === 0) {
                    return machine.gobs;
                }
                else {
                    var gobs = [];
                    _.forEach(machine.sections, function (section) {
                        var gob = _.find(section.gobs, { gobNumber: gobNumber });
                        if (gob !== undefined) {
                            gobs.push(gob);
                        }
                    });
                    return gobs;
                }
            }
            var section = _.find(machine.sections, { sectionNumber: sectionNumber });
            if (!section) {
                return [];
            }
            if ((gobNumber || 0) === 0) {
                return section.gobs;
            }
            var gob = _.find(section.gobs, { gobNumber: gobNumber });
            if (!gob) {
                return [];
            }
            return [gob];
        };
        ShopActivity.prototype.addDowntimeCommentFromEvent = function (event) {
            if (this.getHourIndex(event.downtimeStart) === null) {
                return;
            }
            var gobs = this.findGobs(event.isMachineId, event.section);
            if (gobs.length === 0) {
                throw 'Unable to find gobs for event: ' + event;
            }
            _.forEach(gobs, function (gob) {
                gob.addDowntimeComment(event);
            });
        };
        ShopActivity.prototype.checkListActivityFromEvent = function (event) {
            var index = this.getHourIndex(event.scheduledOn);
            if (index === null) {
                return;
            }
            this.hours[index].addOrUpdateCheckList(event);
        };
        return ShopActivity;
    }());
    exports.ShopActivity = ShopActivity;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(5), __webpack_require__(9), __webpack_require__(4), __webpack_require__(47), __webpack_require__(25), __webpack_require__(6), __webpack_require__(11), __webpack_require__(12), __webpack_require__(53), __webpack_require__(398)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, aps_enums_1, uiUtility_service_1, loader_service_1, toolChange_service_1, defectType_service_1, notify_service_1, dateutility_service_1, newguid_service_1, auth_service_1, addToolChange_tpl_html_1) {
    "use strict";
    addToolChangeCtrl.$inject = ["$modalInstance", "loaderService", "toolChangeService", "defectTypeService", "data", "notifyService", "uiUtilityService", "$q", "newGuidService", "authService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [uiUtility_service_1.default, loader_service_1.default, toolChange_service_1.default, defectType_service_1.default,
        notify_service_1.default, newguid_service_1.default, auth_service_1.default];
    function openAddToolChange(data, $modal) {
        return $modal.open({
            template: addToolChange_tpl_html_1.default,
            controller: 'AddToolChangeCtrl as vm',
            resolve: {
                data: function () {
                    return data;
                }
            }
        }).result;
    }
    exports.openAddToolChange = openAddToolChange;
    exports.default = angular.module('aps.controller.toolChange', requires)
        .controller('AddToolChangeCtrl', addToolChangeCtrl)
        .name;
    function addToolChangeCtrl($modalInstance, loaderService, toolChangeService, defectTypeService, data, notifyService, uiUtilityService, $q, newGuidService, authService) {
        var vm = this;
        vm.shopId = data.shopId;
        vm.activity = data.activity;
        vm.gob = data.gob;
        vm.section = vm.gob.section;
        vm.machine = vm.section.machine;
        vm.sections = vm.machine.sections;
        vm.timeZone = vm.activity.timeZoneId;
        vm.machineTabActive = data.gob.isMachineLevel;
        vm.readyForSubmit = false;
        vm.loadingSectionChange = false;
        vm.defectCause = data.defectCause;
        var range = dateutility_service_1.default.getHourRange(data.date, vm.activity.timeZoneId);
        vm.minTime = range.minTime;
        vm.maxTime = range.maxTime;
        if (data.sectionChangeId) {
            var hourIndex = 0;
            while (hourIndex < vm.activity.hours.length && !vm.activity.hours[hourIndex].isLocked) {
                hourIndex++;
            }
            var startTime = moment(vm.activity.hours[hourIndex].startTime);
            vm.minTime = dateutility_service_1.default.formatISO(startTime, vm.activity.timeZoneId);
        }
        if (data.toolChanges) {
            vm.timeChanged = data.toolChanges.timeChanged;
        }
        else {
            vm.timeChanged = range.initialTime.toDate();
        }
        var id, commentId, userData;
        var promises = [];
        promises.push(authService.getUserData().then(function (x) { return userData = x; }));
        if (data.toolChanges) {
            vm.isEdit = true;
        }
        else {
            promises.push(newGuidService.getNewGuid('toolChange').then(function (x) { return id = x; }));
            promises.push(newGuidService.getNewGuid('toolChangeComment').then(function (x) { return commentId = x; }));
        }
        vm.requalificationDateTime = vm.timeChanged;
        vm.requalificationMinTime = function () {
            if (vm.timeChanged) {
                return dateutility_service_1.default.formatISO(vm.timeChanged, vm.timeZone);
            }
            return vm.minTime;
        };
        vm.requalification = false;
        var getCurrentMold = function (gob) {
            return function () {
                var mold = gob.moldOnDate(vm.timeChanged);
                if (mold) {
                    return mold.toolNumber;
                }
                return gob.section.name + gob.name;
            };
        };
        vm.gobs = vm.sections[0].gobs;
        var selections = [];
        vm.defects = function () {
            var defects = [];
            _.forEach(vm.selections, function (sectionSelection) {
                defects = defects.concat(sectionSelection.defects());
            });
            _.forEach(vm.machine.machineLevelActivity.defects, function (defect) {
                if (!_.find(defects, { id: defect.id })) {
                    defect.nameAndLocation = defect.name;
                    defects.push(defect);
                }
            });
            return defects;
        };
        _.forEach(vm.sections, function (section) {
            var sectionSelection = {
                section: section,
                gobs: [],
                toolChanges: [],
                selected: !vm.isEdit && vm.section === section,
                defects: function () {
                    var defects = [];
                    _.forEach(sectionSelection.gobs, function (gobSelection) {
                        defects = defects.concat(gobSelection.defects());
                    });
                    return defects;
                }
            };
            _.forEach(section.gobs, function (gob) {
                sectionSelection.gobs.push({
                    gob: gob,
                    currentMold: getCurrentMold(gob),
                    toolChanges: [],
                    selected: !vm.isEdit && vm.gob === gob,
                    defects: function () {
                        var defects = [];
                        _.forEach(gob.defects, function (defect) {
                            if (!_.find(defects, { id: defect.id })) {
                                defect.nameAndLocation = defect.name + ' (' +
                                    gob.section.name + gob.name + ')';
                                defects.push(defect);
                            }
                        });
                        return defects;
                    }
                });
            });
            selections.push(sectionSelection);
        });
        vm.selections = selections;
        vm.machineToolChanges = [];
        vm.defectFixed = data.defectFixed;
        vm.reasons = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.ToolChangeReason, 0);
        vm.reason = vm.defectFixed ? aps_enums_1.apsEnums.ToolChangeReason.FixDefect : undefined;
        vm.useDefaultReason = true;
        vm.otherReason = null;
        vm.isFixDefect = function () { return (vm.reason === aps_enums_1.apsEnums.ToolChangeReason.FixDefect); };
        vm.useDefaultReasonChanged = function () {
            var fixDefect = vm.isFixDefect();
            if (vm.useDefaultReason !== true) {
                return;
            }
            _.forEach(vm.toolChanges(), function (toolChange) {
                toolChange.reason = vm.reason;
                if (fixDefect && vm.defectFixed) {
                    toolChange.defectFixed = _.find(toolChange.defects(), { id: vm.defectFixed.id });
                }
                else if (fixDefect && !vm.defectFixed) {
                    var defects = toolChange.defects();
                    if (defects && defects.length > 0) {
                        toolChange.defectFixed = defects[0];
                    }
                }
                else {
                    toolChange.defectFixed = undefined;
                }
            });
        };
        var getAlreadyChanged = function (toolChange) {
            var index = data.activity.getHourIndex(vm.timeChanged);
            var gobHour;
            if (toolChange.tool.type === aps_enums_1.apsEnums.ToolType.Machine) {
                gobHour = vm.machine.machineLevelActivity.hours[index];
            }
            else if (toolChange.tool.type === aps_enums_1.apsEnums.ToolType.Variable) {
                gobHour = toolChange.section.gobs[0].hours[index];
            }
            else {
                gobHour = toolChange.gob.hours[index];
            }
            return _.some(gobHour.activity, function (a) {
                return a.isToolChange
                    && a.timeChanged.getTime() === vm.timeChanged.getTime()
                    && _.some(a.tools, function (t) { return t.toolId === toolChange.tool.id && t.id !== toolChange.id; });
            });
        };
        var getMoldInUse = function (toolChange) {
            if (!toolChange.moldNumber) {
                return false;
            }
            var inUse = false;
            var toolChanges = vm.toolChanges();
            var moldChanges = _.filter(toolChanges, function (t) { return t.tool.isMold; });
            _.forEach(moldChanges, function (mc) {
                if (mc !== toolChange && mc.moldNumber === toolChange.moldNumber) {
                    inUse = true;
                }
            });
            if (inUse
                || toolChange.reason === aps_enums_1.apsEnums.ToolChangeReason.JobChange
                || toolChange.reason === aps_enums_1.apsEnums.ToolChangeReason.MoldSwap) {
                return inUse;
            }
            _.forEach(vm.activity.gobs, function (gob) {
                var mold = gob.moldOnDate(vm.timeChanged, toolChange.id);
                if (mold.toolNumber === toolChange.moldNumber) {
                    inUse = true;
                }
            });
            return inUse;
        };
        var getToolChanges = function (toolChanges, typeName, sectionSelection, gobSelection) {
            var tools = _.filter(vm.tools, { typeName: typeName, selected: true });
            var matchingToolChanges = [];
            _.forEach(tools, function (tool) {
                var toolChange = _.find(toolChanges, { tool: tool });
                if (!toolChange) {
                    toolChange = {
                        id: undefined,
                        section: sectionSelection ? sectionSelection.section : undefined,
                        gob: gobSelection ? gobSelection.gob : undefined,
                        tool: tool,
                        exclude: false,
                        moldNumber: undefined,
                        reason: vm.useDefaultReason ? vm.reason : undefined,
                        unlistedDefect: false,
                        defectFixed: undefined,
                        defectTypeId: undefined,
                        comment: undefined,
                        alphaNumber: undefined,
                        otherReason: vm.otherReason,
                        moldInUse: function () { return false; },
                        alreadyChanged: function () { return false; },
                        defects: function () {
                            if (sectionSelection) {
                                if (gobSelection) {
                                    return gobSelection.defects();
                                }
                                return sectionSelection.defects();
                            }
                            return vm.defects();
                        },
                        reasonChanged: function () {
                            if (toolChange.isFixDefect()) {
                                toolChange.defectFixed = undefined;
                            }
                        },
                        isFixDefect: function () { return toolChange.reason === aps_enums_1.apsEnums.ToolChangeReason.FixDefect; },
                        max: tool.isMold ? 127 : 999
                    };
                    if (!vm.loadingSectionChange) {
                        vm.readyForSubmit = false;
                        newGuidService.getNewGuid('toolChangeDetail').then(function (id) {
                            toolChange.id = id;
                            vm.readyForSubmit = true;
                        });
                    }
                    if (vm.defectFixed && toolChange.isFixDefect()) {
                        toolChange.defectFixed = _.find(toolChange.defects(), { id: vm.defectFixed.id });
                    }
                    if (!vm.defectFixed && toolChange.isFixDefect()) {
                        var defects = toolChange.defects();
                        if (defects && defects.length > 0) {
                            toolChange.defectFixed = defects[0];
                        }
                    }
                    if (tool.isMold) {
                        toolChange.moldInUse = function () { return getMoldInUse(toolChange); };
                    }
                    toolChange.alreadyChanged = function () { return getAlreadyChanged(toolChange); };
                    toolChanges.push(toolChange);
                }
                matchingToolChanges.push(toolChange);
            });
            return matchingToolChanges;
        };
        vm.toolChanges = function () {
            var toolChanges = [];
            _.forEach(vm.selections, function (selection) {
                _.forEach(selection.gobs, function (gobSelection) {
                    if (!gobSelection.selected) {
                        return;
                    }
                    _.forEach(getToolChanges(gobSelection.toolChanges, 'Mold', selection, gobSelection), function (toolChange) {
                        toolChanges.push(toolChange);
                    });
                });
                if (!selection.selected) {
                    return;
                }
                _.forEach(getToolChanges(selection.toolChanges, 'Variable', selection), function (toolChange) {
                    toolChanges.push(toolChange);
                });
            });
            _.forEach(getToolChanges(vm.machineToolChanges, 'Machine'), function (toolChange) {
                toolChanges.push(toolChange);
            });
            return toolChanges;
        };
        var toolPromise = toolChangeService.getToolsAndTypes()
            .then(function (toolsAndTypes) {
            _.forEach(toolsAndTypes, function (tool) {
                tool.selected = false;
            });
            vm.tools = toolsAndTypes;
        });
        promises.push(toolPromise);
        var sectionChange;
        if (data.sectionChangeId) {
            var sectionChangePromise = toolChangeService
                .getSectionChange(data.sectionChangeId, data.sectionChangeSectionId, data.shopId)
                .then(function (data) {
                sectionChange = data;
            });
            promises.push(sectionChangePromise);
        }
        var editToolChange;
        if (data.toolChanges) {
            promises.push(toolChangeService
                .getToolChange(data.toolChanges.id)
                .then(function (data) {
                editToolChange = data;
            }));
        }
        var populateToolChange = function () {
            var reason = undefined;
            var multipleReasons = false;
            _.forEach(editToolChange.toolChanges, function (tc) {
                var toolMatch = _.find(vm.tools, { id: tc.toolId });
                toolMatch.selected = true;
                if (toolMatch.type === aps_enums_1.apsEnums.ToolType.Mold || toolMatch.type === aps_enums_1.apsEnums.ToolType.Variable) {
                    var sectionSelection = _.find(vm.selections, function (s) { return s.section.sectionNumber === tc.section; });
                    if (sectionSelection) {
                        if (toolMatch.type === aps_enums_1.apsEnums.ToolType.Mold) {
                            var gobSelection = _.find(sectionSelection.gobs, function (g) { return g.gob.gobNumber === tc.gob; });
                            if (gobSelection) {
                                gobSelection.selected = true;
                            }
                        }
                        else {
                            sectionSelection.selected = true;
                        }
                    }
                }
            });
            _.forEach(vm.toolChanges(), function (tc) {
                var toolChange = _.find(editToolChange.toolChanges, {
                    section: tc.section ? tc.section.sectionNumber : null,
                    gob: tc.gob ? tc.gob.gobNumber : null,
                    toolId: tc.tool.id
                });
                if (toolChange) {
                    tc.id = toolChange.id;
                    tc.comment = toolChange.comment;
                    tc.alphaNumber = toolChange.alphaNumber;
                    tc.reason = toolChange.reason;
                    if (!reason) {
                        reason = tc.reason;
                    }
                    else if (reason !== tc.reason) {
                        multipleReasons = true;
                    }
                    if (toolChange.defectId) {
                        tc.defectFixed = _.find(tc.defects(), { id: toolChange.defectId });
                    }
                    else if (toolChange.unlistedDefect && toolChange.defectTypeId) {
                        tc.unlistedDefect = true;
                        tc.defectTypeId = toolChange.defectTypeId;
                    }
                    tc.otherReason = toolChange.otherReason;
                    tc.moldNumber = toolChange.toolNumber;
                }
                else {
                    tc.exclude = true;
                }
            });
            if (multipleReasons) {
                vm.useDefaultReason = false;
            }
            else {
                vm.useDefaultReason = true;
                vm.reason = reason;
            }
            vm.duration = editToolChange.duration;
            vm.timeChanged = editToolChange.timeChanged;
        };
        var jobRun = _.find(vm.activity.jobRuns, function (jr) { return jr.startDate <= vm.timeChanged && (!jr.endDate || vm.timeChanged < jr.endDate); });
        var defectTypesPromise = defectTypeService.getDefectTypesAndClassifications()
            .then(function (data) {
            if (jobRun && jobRun.excludedDefectTypeIds && jobRun.excludedDefectTypeIds.length > 0) {
                data.types = _.filter(data.types, function (dt) { return _.every(jobRun.excludedDefectTypeIds, function (xt) { return xt !== dt.id; }); });
            }
            _.forEach(data.types, function (type) {
                if (jobRun && type.wareClasses) {
                    var override = _.find(type.wareClasses, function (w) { return w.wareClassId === jobRun.wareClassId; });
                    if (override && override.severity !== null) {
                        type.severity = override.severity;
                    }
                }
            });
            vm.defectTypes = data.types;
        });
        promises.push(defectTypesPromise);
        loaderService.loadingPromise($q.all(promises).then(function () {
            if (editToolChange) {
                vm.loadingSectionChange = true;
                populateToolChange();
                vm.loadingSectionChange = false;
                vm.readyForSubmit = true;
                return;
            }
            if (vm.defectCause) {
                if (vm.defectCause.toolId) {
                    var tool = _.find(vm.tools, { id: vm.defectCause.toolId });
                    if (tool) {
                        tool.selected = true;
                    }
                }
                if (vm.defectCause.reason) {
                    vm.reason = vm.defectCause.reason;
                }
            }
            if (!sectionChange) {
                vm.readyForSubmit = true;
                return;
            }
            vm.reason = aps_enums_1.apsEnums.ToolChangeReason.SectionChange;
            _.forEach(sectionChange.tools, function (tool) {
                var toolMatch = _.find(vm.tools, { id: tool.id });
                toolMatch.selected = true;
            });
            var sectionSelection = _.find(vm.selections, function (s) { return s.section.sectionNumber === sectionChange.section; });
            sectionSelection.selected = true;
            _.forEach(sectionSelection.gobs, function (gob) { return gob.selected = true; });
            vm.loadingSectionChange = true;
            var sectionChangePromises = [];
            _.forEach(_.filter(vm.toolChanges(), function (t) { return !t.id; }), function (t) {
                sectionChangePromises.push(newGuidService.getNewGuid('toolChangeDetail').then(function (id) { return t.id = id; }));
            });
            if (sectionChangePromises.length > 0) {
                $q.all(sectionChangePromises).then(function () { return vm.readyForSubmit = true; });
            }
            vm.loadingSectionChange = false;
        }));
        vm.cancel = function () {
            $modalInstance.close();
        };
        vm.addToolChange = function () {
            if (!vm.readyForSubmit || vm.form.$invalid) {
                return;
            }
            var toolChanges = vm.toolChanges();
            if (toolChanges.length === 0) {
                return;
            }
            var invalid = false;
            var commandToolChanges = [];
            _.forEach(toolChanges, function (tc) {
                if (tc.exclude) {
                    return;
                }
                if (tc.moldInUse() || tc.alreadyChanged()) {
                    invalid = true;
                    return false;
                }
                if (tc.isFixDefect()) {
                    if (tc.unlistedDefect ? !tc.defectTypeId : !tc.defectFixed) {
                        invalid = true;
                        return false;
                    }
                }
                commandToolChanges.push({
                    id: tc.id,
                    section: tc.section ? tc.section.sectionNumber : undefined,
                    gob: tc.gob ? tc.gob.gobNumber : undefined,
                    unlistedDefect: tc.isFixDefect() ? tc.unlistedDefect : undefined,
                    defectId: tc.isFixDefect() && !tc.unlistedDefect ? tc.defectFixed.id : undefined,
                    defectTypeId: tc.isFixDefect() && tc.unlistedDefect ? tc.defectTypeId : undefined,
                    reason: tc.reason,
                    toolId: tc.tool.id,
                    toolNumber: tc.moldNumber,
                    comment: tc.comment,
                    alphaNumber: tc.alphaNumber,
                    otherReason: tc.otherReason
                });
            });
            if (invalid) {
                return;
            }
            var toolAddedEvents = [];
            _.forEach(_.filter(toolChanges, function (tc) { return !tc.exclude; }), function (tc) {
                toolAddedEvents.push({
                    id: tc.id,
                    section: tc.section ? tc.section.sectionNumber : undefined,
                    gob: tc.gob ? tc.gob.gobNumber : undefined,
                    gobName: tc.gob ? tc.gob.name : undefined,
                    unlistedDefect: tc.isFixDefect() ? tc.unlistedDefect : undefined,
                    defectId: tc.isFixDefect() && !tc.unlistedDefect
                        ? tc.defectFixed.id
                        : undefined,
                    defectTypeId: tc.isFixDefect()
                        ? (tc.unlistedDefect
                            ? tc.defectTypeId
                            : tc.defectFixed.defectTypeId)
                        : undefined,
                    defectTypeName: tc.isFixDefect()
                        ? (tc.unlistedDefect
                            ? (_.find(vm.defectTypes, function (dt) { return dt.id === tc.defectTypeId; }).name)
                            : tc.defectFixed.name)
                        : undefined,
                    reason: tc.reason,
                    otherReason: tc.otherReason,
                    toolId: tc.tool.id,
                    toolNumber: tc.moldNumber,
                    toolName: tc.tool.name,
                    toolIsMold: tc.tool.isMold,
                    comment: tc.comment,
                    legacyId: null
                });
            });
            if (editToolChange) {
                var editCommand = {
                    id: editToolChange.id,
                    shopId: vm.shopId,
                    isMachineId: vm.machine.id,
                    timeChanged: vm.timeChanged,
                    duration: vm.duration,
                    toolChanges: commandToolChanges
                };
                var comments = [];
                _.forEach(editToolChange.comments, function (c) {
                    comments.push({
                        shopId: null,
                        plantId: undefined,
                        isMachineId: null,
                        section: null,
                        gob: null,
                        gobName: null,
                        toolChangeId: editToolChange.id,
                        comment: c.comment,
                        createdByFullName: c.createdByFullName,
                        timeChanged: vm.timeChanged,
                        id: c.id,
                        userId: null,
                        eventDate: c.createdOn
                    });
                });
                var editEvent = {
                    id: editCommand.id,
                    plantId: undefined,
                    shopId: editCommand.shopId,
                    isMachineId: editCommand.isMachineId,
                    jobRunId: undefined,
                    duration: editCommand.duration,
                    toolChanges: toolAddedEvents,
                    timeChanged: editCommand.timeChanged,
                    createdByFullName: userData.fullName,
                    rootComments: comments,
                    userId: userData.id,
                    eventDate: editCommand.timeChanged,
                    deletedToolChanges: []
                };
                loaderService.loadingPromise(toolChangeService.editToolChange(editCommand)
                    .then(function () {
                    $modalInstance.close(editEvent);
                }, notifyService.handleApiErrors));
            }
            else {
                var addCommand = {
                    id: id,
                    shopId: vm.shopId,
                    isMachineId: vm.machine.id,
                    timeChanged: vm.timeChanged,
                    duration: vm.duration,
                    comment: vm.comment,
                    commentId: vm.comment ? commentId : undefined,
                    toolChanges: commandToolChanges,
                    requalification: vm.requalification,
                    requalificationDateTime: vm.requalification
                        ? vm.requalificationDateTime
                        : undefined
                };
                var addEvent = {
                    id: addCommand.id,
                    plantId: undefined,
                    shopId: addCommand.shopId,
                    isMachineId: addCommand.isMachineId,
                    jobRunId: undefined,
                    duration: addCommand.duration,
                    toolChanges: toolAddedEvents,
                    timeChanged: addCommand.timeChanged,
                    createdByFullName: userData.fullName,
                    rootComments: [],
                    userId: userData.id,
                    eventDate: addCommand.timeChanged
                };
                if (addCommand.comment) {
                    addEvent.rootComments.push({
                        id: addCommand.commentId,
                        plantId: undefined,
                        shopId: addCommand.shopId,
                        isMachineId: addCommand.isMachineId,
                        section: undefined,
                        gob: undefined,
                        gobName: undefined,
                        toolChangeId: addCommand.id,
                        comment: addCommand.comment,
                        createdByFullName: userData.fullName,
                        timeChanged: addCommand.timeChanged,
                        userId: userData.id,
                        eventDate: addCommand.timeChanged
                    });
                }
                loaderService.loadingPromise(toolChangeService.addToolChange(addCommand)
                    .then(function () {
                    $modalInstance.close(addEvent);
                }, notifyService.handleApiErrors));
            }
        };
        vm.otherReasonRequired = function () {
            return aps_enums_1.apsEnums.ToolChangeReason.Other === vm.reason;
        };
        vm.otherReasonChanged = function () {
            var otherReasonToSet = vm.otherReasonRequired() ? vm.otherReason : null;
            _.forEach(vm.toolChanges(), function (toolChange) {
                toolChange.otherReason = otherReasonToSet;
            });
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(7), __webpack_require__(4), __webpack_require__(74), __webpack_require__(6), __webpack_require__(61), __webpack_require__(38)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, authData_service_1, loader_service_1, defect_service_1, notify_service_1, checkListReportDetails_controller_1, fillOutCheckList_controller_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [authData_service_1.default, loader_service_1.default, defect_service_1.default, notify_service_1.default,
        checkListReportDetails_controller_1.default, fillOutCheckList_controller_1.default];
    exports.default = angular
        .module('aps.services.criticalDefects', requires)
        .service('criticalDefectService', ["authDataService", "loaderService", "defectService", "notifyService", "$modal", function (authDataService, loaderService, defectService, notifyService, $modal) {
        var openReport = function (shopId, defect) {
            var roleId = authDataService.getSelectedRoleLocation().role.roleId;
            var promise = defectService.getCriticalDefectReportDetails(defect.id, shopId, roleId, defect.timeFound);
            promise.then(function (data) {
                if (!data) {
                    notifyService.error('Could not find Critical Defect Report for this defect');
                    return;
                }
                if (data.fillOut) {
                    fillOutCheckList_controller_1.openFillOutCheckList({
                        checkListId: data.checkListId,
                        instanceId: data.instanceId,
                        shopId: data.shopId,
                        plantId: data.plantId,
                        tankId: data.tankId,
                        plantLocationId: data.plantLocationId,
                        scheduledOn: data.scheduledOn
                    }, $modal);
                }
                else {
                    checkListReportDetails_controller_1.openCheckListReportDetails({
                        checkListInstance: data.reportDetails.reportItem,
                        detail: data.reportDetails
                    }, $modal);
                }
            });
            loaderService.loadingPromise(promise);
            return promise;
        };
        return {
            openReport: openReport
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 279 */,
/* 280 */,
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(147), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, notifications_1, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [http_service_1.default, notifications_1.default];
    var NotificationSvcImpl = (function () {
        NotificationSvcImpl.$inject = ["httpService", "Notifications"];
        function NotificationSvcImpl(httpService, Notifications) {
            this.httpService = httpService;
            this.Notifications = Notifications;
        }
        NotificationSvcImpl.prototype.setCronJob1 = function (cron) {
            if (this.cron1) {
                this.cron1.stop();
            }
            this.cron1 = cron;
            this.cron1.start();
        };
        NotificationSvcImpl.prototype.stopCronJob1 = function () {
            if (this.cron1) {
                this.cron1.stop();
            }
        };
        NotificationSvcImpl.prototype.setCronJob2 = function (cron) {
            if (this.cron2) {
                this.cron2.stop();
            }
            this.cron2 = cron;
            this.cron2.start();
        };
        NotificationSvcImpl.prototype.stopCronJob2 = function () {
            if (this.cron2) {
                this.cron2.stop();
            }
        };
        NotificationSvcImpl.prototype.setCronJob3 = function (cron) {
            if (this.cron3) {
                this.cron3.stop();
            }
            this.cron3 = cron;
            this.cron3.start();
        };
        NotificationSvcImpl.prototype.stopCronJob3 = function () {
            if (this.cron3) {
                this.cron3.stop();
            }
        };
        NotificationSvcImpl.prototype.getNotifications = function (shopId, roleId, shift, $window, $scope) {
            var _this = this;
            return this.httpService.get(constant_module_1.Endpoints.NOTIFICATION, {
                shopId: shopId,
                roleId: roleId,
                shift: shift
            }).then(function (data) {
                return new _this.Notifications(data, _this, $window, $scope);
            });
        };
        NotificationSvcImpl.prototype.readNotification = function (notificationId) {
            return this.httpService.post(constant_module_1.Endpoints.NOTIFICATION_READ, {
                id: notificationId
            });
        };
        NotificationSvcImpl.prototype.completeNotification = function (notificationId, comment) {
            return this.httpService.post(constant_module_1.Endpoints.NOTIFICATION_COMPLETE, {
                id: notificationId,
                comment: comment
            });
        };
        NotificationSvcImpl.prototype.sendNotification = function (notification) {
            return this.httpService.post(constant_module_1.Endpoints.NOTIFICATION_SEND, notification);
        };
        NotificationSvcImpl.prototype.sendReleaseNotesNotification = function (notification) {
            return this.httpService.post(constant_module_1.Endpoints.RELEASE_NOTE_NOTIFICATION_SEND, notification);
        };
        NotificationSvcImpl.prototype.getReleaseNotesNotification = function () {
            return this.httpService.get(constant_module_1.Endpoints.GET_RELEASE_NOTE_NOTIFICATION);
        };
        return NotificationSvcImpl;
    }());
    exports.default = angular
        .module('aps.services.notification', requires)
        .service('notificationService', NotificationSvcImpl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, authData_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [authData_service_1.default];
    var StateRolesSvc = (function () {
        StateRolesSvc.$inject = ["$state", "authDataService"];
        function StateRolesSvc($state, authDataService) {
            this.$state = $state;
            this.authDataService = authDataService;
        }
        StateRolesSvc.prototype.stateRoleRequirementsSatisfied = function (stateData) {
            if (!stateData) {
                return true;
            }
            var authorized = false;
            var noSecurity = true;
            if (stateData.authorizeAPSIOAdmin) {
                noSecurity = false;
                authorized = this.authDataService.isAPSIOAdmin();
            }
            if (stateData.authorizeAdmin) {
                noSecurity = false;
                authorized = this.authDataService.isAdmin() || authorized;
            }
            if (stateData.authorizePlantAdmin) {
                noSecurity = false;
                authorized = this.authDataService.isAnyPlantAdmin() || authorized;
            }
            return authorized || noSecurity;
        };
        StateRolesSvc.prototype.stateRoleRequirementsSatisfiedForStateName = function (stateName) {
            var state = this.$state.get(stateName) || {};
            return this.stateRoleRequirementsSatisfied(state.data);
        };
        return StateRolesSvc;
    }());
    exports.default = angular
        .module('aps.services.stateRoles', requires)
        .service('stateRolesService', StateRolesSvc)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(4), __webpack_require__(6), __webpack_require__(11), __webpack_require__(91), __webpack_require__(53), __webpack_require__(12), __webpack_require__(416)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, loader_service_1, notify_service_1, dateutility_service_1, downtime_service_1, auth_service_1, newguid_service_1, addDowntime_tpl_html_1) {
    "use strict";
    addDowntimeCtrl.$inject = ["$modalInstance", "$q", "loaderService", "downtimeService", "data", "notifyService", "$timeout", "authService", "newGuidService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, notify_service_1.default, downtime_service_1.default, auth_service_1.default, newguid_service_1.default];
    exports.default = angular.module('aps.controller.downtimes', requires)
        .controller('AddDowntimeCtrl', addDowntimeCtrl)
        .name;
    function openAddDowntime(data, $modal) {
        return $modal.open({
            template: addDowntime_tpl_html_1.default,
            controller: 'AddDowntimeCtrl as vm',
            resolve: {
                data: function () { return data; }
            }
        }).result;
    }
    exports.openAddDowntime = openAddDowntime;
    function addDowntimeCtrl($modalInstance, $q, loaderService, downtimeService, data, notifyService, $timeout, authService, newGuidService) {
        var vm = this;
        vm.canAddDuration = true;
        vm.editMode = false;
        vm.section = data.section;
        vm.shopId = data.shopId;
        vm.sections = data.section.machine.sections;
        vm.isMachineId = data.section.machine.id;
        vm.readyForSubmit = false;
        vm.duration = '';
        vm.downtimeComment = '';
        vm.entireMachine = false;
        vm.displaySections = false;
        vm.timeZoneId = data.timeZoneId;
        vm.readOnly = data.readOnly;
        vm.canComment = data.canComment;
        if (data.downtime) {
            vm.editMode = true;
            vm.comments = data.downtime.comments;
        }
        var range = dateutility_service_1.default.getHourRange(data.date, vm.timeZoneId);
        vm.startTime = vm.editMode ? data.downtime.downtimeStart : range.initialTime.toDate();
        vm.minTime = range.minTime;
        vm.maxTime = range.maxTime;
        vm.formatTime = function (time) {
            return dateutility_service_1.default.formatTime(time, vm.timeZoneId);
        };
        if (vm.editMode) {
            vm.canAddDuration = !(data.downtime.duration > 0);
            if (data.downtime.duration) {
                vm.duration = data.downtime.duration.toString(10);
            }
            vm.displaySections = data.downtime.section > 0;
            vm.entireMachine = !vm.displaySections;
            vm.downtimeReasonDescription = data.downtime.downtimeReasonDescription;
            vm.createdBy = data.downtime.createdByFullName;
        }
        var selections = [];
        _.forEach(vm.sections, function (section) {
            var sectionSelection = {
                section: section,
                selected: data.section === section
            };
            selections.push(sectionSelection);
        });
        vm.selections = selections;
        var ids = [], commentIds = [];
        var updateIsReady = function () {
            if (vm.editMode) {
                vm.readyForSubmit = true;
                return;
            }
            if (vm.sectionNumbers && vm.sectionNumbers.length > 0) {
                vm.readyForSubmit = ids.length >= vm.sectionNumbers.length
                    && commentIds.length >= vm.sectionNumbers.length;
            }
            else {
                vm.readyForSubmit = ids.length >= 1 && commentIds.length >= 1;
            }
        };
        vm.sectionAndMachineSelectionIsValid = function () {
            if (vm.downtimeReason && vm.downtimeReason.entireMachine) {
                vm.entireMachine = true;
                vm.sectionNumbers = [];
                return true;
            }
            vm.entireMachine = false;
            vm.sectionNumbers =
                _.map(_.filter(vm.selections, function (selection) {
                    return selection.selected === true;
                }), 'section.sectionNumber');
            updateIsReady();
            return vm.sectionNumbers.length > 0;
        };
        var getTypesAndReasons = downtimeService.getDowntimeTypesAndReasons()
            .then(function (data) {
            vm.downtimeReasons = data.downtimeReasons;
            vm.downtimeTypes = data.downtimeTypes;
        });
        loaderService.loadingPromise(getTypesAndReasons);
        vm.filterDowntimeReasons = function (downtimeReason) {
            return !vm.downtimeType ||
                downtimeReason.downtimeType === vm.downtimeType;
        };
        vm.typeChanged = function () {
            if (vm.downtimeReason && vm.downtimeType && vm.downtimeReason.downtimeType !== vm.downtimeType) {
                vm.downtimeReason = undefined;
                vm.toggleSections();
            }
        };
        vm.toggleSections = function () {
            vm.displaySections = vm.downtimeReason && !vm.downtimeReason.entireMachine;
            vm.entireMachine = !vm.displaySections;
            if (!vm.displaySections) {
                vm.sectionNumbers = [];
            }
        };
        vm.cancel = function () {
            $modalInstance.close();
        };
        var userData;
        var promises = [
            authService.getUserData().then(function (x) { return userData = x; }),
            newGuidService.getNewGuid('downtimeComment').then(function (x) { return commentIds.push(x); })
        ];
        if (!vm.editMode) {
            promises.push(newGuidService.getNewGuid('downtime').then(function (x) { return ids.push(x); }));
        }
        $q.all(promises).then(function () { return updateIsReady(); });
        vm.sectionsUpdated = function () {
            $timeout(function () {
                vm.sectionAndMachineSelectionIsValid();
                if (!vm.readyForSubmit) {
                    $q.all([
                        newGuidService.getNewGuid('downtime').then(function (x) { return ids.push(x); }),
                        newGuidService.getNewGuid('downtimeComment').then(function (x) { return commentIds.push(x); })
                    ]).then(function () { return updateIsReady(); });
                }
            }, 100);
        };
        vm.addDowntime = function () {
            if (vm.form.$invalid || !vm.sectionAndMachineSelectionIsValid() || !vm.readyForSubmit) {
                return false;
            }
            var downtimes = [];
            if (vm.entireMachine) {
                downtimes.push({
                    id: ids[0],
                    entireMachine: true,
                    sectionNumber: null,
                    comment: vm.downtimeComment,
                    commentId: vm.downtimeComment ? commentIds[0] : undefined
                });
            }
            else {
                for (var i = 0; i < vm.sectionNumbers.length; i++) {
                    downtimes.push({
                        id: ids[i],
                        entireMachine: false,
                        sectionNumber: vm.sectionNumbers[i],
                        comment: vm.downtimeComment,
                        commentId: vm.downtimeComment ? commentIds[i] : undefined
                    });
                }
            }
            var cmd = {
                shopId: vm.shopId,
                isMachineId: vm.isMachineId,
                downtimeReasonId: vm.downtimeReason.id,
                duration: vm.duration ? parseInt(vm.duration, 10) : null,
                downtimeStart: vm.startTime,
                downtimes: downtimes
            };
            var events = [];
            _.forEach(cmd.downtimes, function (section) {
                var event = {
                    id: section.id,
                    plantId: undefined,
                    shopId: cmd.shopId,
                    isMachineId: cmd.isMachineId,
                    jobRunId: undefined,
                    downtimeStart: cmd.downtimeStart,
                    duration: cmd.duration,
                    section: section.sectionNumber,
                    createdByFullName: userData.fullName,
                    downtimeReasonId: cmd.downtimeReasonId,
                    downtimeReasonCode: vm.downtimeReason.code,
                    downtimeReasonDescription: vm.downtimeReason.description,
                    comments: [],
                    userId: userData.id,
                    eventDate: new Date()
                };
                if (section.comment) {
                    event.comments = [{
                            id: section.commentId,
                            plantId: undefined,
                            jobRunId: undefined,
                            shopId: cmd.shopId,
                            isMachineId: cmd.isMachineId,
                            section: event.section,
                            duration: cmd.duration,
                            downtimeId: section.id,
                            downtimeStart: cmd.downtimeStart,
                            comment: section.comment,
                            createdByFullName: event.createdByFullName,
                            userId: event.userId,
                            eventDate: event.eventDate
                        }];
                }
                events.push(event);
            });
            var promise = downtimeService.addDowntime(cmd)
                .then(function () {
                $modalInstance.close(events);
            }, notifyService.handleApiErrors);
            loaderService.loadingPromise(promise);
        };
        vm.saveDowntime = function () {
            if (!vm.editMode) {
                vm.addDowntime();
                return;
            }
            if (vm.form.$invalid) {
                return false;
            }
            var cmd = {
                id: data.downtime.id,
                duration: vm.duration ? parseInt(vm.duration, 10) : null,
                comment: vm.downtimeComment,
                downtimeStart: data.downtime.downtimeStart,
                shopId: vm.shopId
            };
            var promise = downtimeService.saveDowntime(cmd)
                .then(function () {
                $modalInstance.close();
            }, notifyService.handleApiErrors);
            loaderService.loadingPromise(promise);
        };
        vm.deleteDowntime = function () {
            var promise = downtimeService
                .deleteDowntime({ id: data.downtime.id })
                .then(function () {
                $modalInstance.close();
            }, notifyService.handleApiErrors);
            loaderService.loadingPromise(promise);
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(5), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, aps_enums_1, _) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ChatMessage = (function () {
        function ChatMessage(data, userProfileData) {
            this.userProfileData = userProfileData;
            _.assign(this, data);
            switch (this.type) {
                case aps_enums_1.apsEnums.ChatItemType.Chat:
                    this.isChat = true;
                    break;
                case aps_enums_1.apsEnums.ChatItemType.Defect:
                    this.isDefect = true;
                    break;
                case aps_enums_1.apsEnums.ChatItemType.Downtime:
                    this.isDowntime = true;
                    break;
                case aps_enums_1.apsEnums.ChatItemType.ToolChange:
                    this.isToolChange = true;
                    break;
            }
        }
        ChatMessage.prototype.getDefectLabel = function () {
            return (this.userProfileData && this.userProfileData.displayDefectsByNumber)
                ? this.defectLegacyId.toString()
                : this.defectAbbr;
        };
        ChatMessage.prototype.defectLabel = function () {
            var label = this.isDefect ? this.getDefectLabel() : '';
            return label;
        };
        ChatMessage.prototype.location = function (shopConfig) {
            var machine;
            if (this.machineId && shopConfig) {
                machine = _.find(shopConfig.machineConfigurations, { id: this.machineId });
            }
            else {
                return '';
            }
            var jobRun = _.first(shopConfig.jobRuns);
            var section = this.section;
            if (machine) {
                if (section && machine.number === 2 && jobRun) {
                    section = section + jobRun.numberOfSections;
                }
            }
            else {
                return '';
            }
            if (section) {
                if (this.gobName) {
                    return section.toString() + this.gobName;
                }
                else {
                    return section.toString();
                }
            }
            return machine.name;
        };
        return ChatMessage;
    }());
    exports.default = ChatMessage;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(2), __webpack_require__(452), __webpack_require__(3), __webpack_require__(5), __webpack_require__(27), __webpack_require__(11), __webpack_require__(9), __webpack_require__(26), __webpack_require__(23), __webpack_require__(16), __webpack_require__(4), __webpack_require__(48), __webpack_require__(287), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, moment, _, dashboard_tpl_html_1, constant_module_1, aps_enums_1, enums_1, dateutility_service_1, uiUtility_service_1, counts_service_1, shops_service_1, report_service_1, loader_service_1, groupRejects_service_1, topDefects_hub_1, navigation_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [uiUtility_service_1.default, counts_service_1.default,
        shops_service_1.default, report_service_1.default, loader_service_1.default,
        groupRejects_service_1.default, topDefects_hub_1.default,
        navigation_service_1.default];
    var DashboardTab;
    (function (DashboardTab) {
        DashboardTab[DashboardTab["Weights"] = 1] = "Weights";
        DashboardTab[DashboardTab["TopDefects"] = 2] = "TopDefects";
        DashboardTab[DashboardTab["TopRejects"] = 3] = "TopRejects";
    })(DashboardTab || (DashboardTab = {}));
    var DashboardController = (function () {
        DashboardController.$inject = ["$stateParams", "shopService", "loaderService", "groupRejectsService", "reportService", "topDefectsHubCreator", "$scope", "$sce", "uiUtilityService", "$timeout", "$state", "countsService", "navigationService", "$q", "$interval"];
        function DashboardController($stateParams, shopService, loaderService, groupRejectsService, reportService, topDefectsHubCreator, $scope, $sce, uiUtilityService, $timeout, $state, countsService, navigationService, $q, $interval) {
            var _this = this;
            this.selectedTab = DashboardTab.TopDefects;
            this.dashboardTab = DashboardTab;
            var $ctrl = this;
            this.$name = "dashboard.controller";
            this.plantId = $stateParams.plantId;
            this.shopId = $stateParams.shopId;
            this.reportService = reportService;
            this.loaderService = loaderService;
            this.groupRejectsService = groupRejectsService;
            this.shopService = shopService;
            this.$sce = $sce;
            this.shopName = null;
            this.plantName = null;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.uiUtilityService = uiUtilityService;
            this.packEfficiency = aps_enums_1.apsEnums.WellKnownCheckType.ShopPackEfficiency;
            this.heEfficiency = aps_enums_1.apsEnums.WellKnownCheckType.HotEndEfficiency;
            this.weightHtml = null;
            this.weightHourOptions = [4, 24];
            this.countsService = countsService;
            this.model = null;
            this.countsInterval = enums_1.apsDisplayEnums.CountDisplayInterval.Last24Hours;
            this.$q = $q;
            this.hasLines = false;
            this.showMaintenance = false;
            this.showMaintCheckbox = true;
            this.$interval = $interval;
            this.shiftSelectors = {
                buttons: [],
                select: null
            };
            this.topTenDefects = {
                chart: {
                    type: 'column'
                },
                title: {
                    text: ''
                },
                yAxis: {
                    title: { enabled: false }
                },
                xAxis: {
                    categories: []
                },
                legend: { enabled: false },
                credits: {
                    enabled: false
                },
                exporting: { enabled: false },
                tooltip: {
                    formatter: function () {
                        return 'Defect: <b>' + this.x + '</b><br />'
                            + this.series.name + ': <b>' + this.y + '</b>';
                    }
                },
                series: [],
                reflow: true,
                callBack: null
            };
            var shopPromise = shopService.getShopConfiguration(this.shopId).then(function (shop) {
                _this.shopName = shop.name;
                _this.plantName = shop.plantName;
                _this.hasScale = shop.hasScale;
                _this.hasLines = shop.hasLines;
                if (shop.hasLines) {
                    var countsPromise = navigationService.getNavigation().then(function (nav) {
                        countsService.getLineCounts(_this.shopId, nav.selectedPlant, _this.countsInterval, false)
                            .then(function (countsResult) {
                            _this.model = countsResult;
                        });
                    });
                    loaderService.loadingPromise(countsPromise);
                }
                var now = moment();
                var twentyFourHoursAgo = now.clone().subtract(24, 'hours');
                _this.defectQueryEnd = dateutility_service_1.default.localToTimeZone(now.toDate(), shop.timeZoneId).toDate();
                _this.defectQueryStart = dateutility_service_1.default.localToTimeZone(twentyFourHoursAgo.toDate(), shop.timeZoneId).toDate();
                _this.populateShiftSelectors(_this.defectQueryStart, _this.defectQueryEnd, shop.shiftsInLast24Hours);
                if (!_this.hasScale) {
                    _this.loadDefectsReport(_this.defectQueryStart);
                }
            });
            this.hub = topDefectsHubCreator.createTopDefectsHub(this.shopId, function (d) { return _this.onDefectAdded(d); }, function (d) { return _this.onDefectRemoved(d); });
            this.$scope.$on('$destroy', function () {
                if (_this.hub) {
                    _this.hub.uninitialize();
                }
            });
            this.viewGroupRejects = function (dimpleEvent) {
                if (dimpleEvent && dimpleEvent.category) {
                    var equipmentGroup = _.find(_this.model.equipmentGroups, { name: dimpleEvent.category });
                    _this.model.currentGroup = equipmentGroup;
                    _this.groupRejectsService.showGroupRejects({
                        equipmentGroup: equipmentGroup,
                        shopId: _this.shopId,
                        lineCounts: _this.model,
                        countsInterval: _this.countsInterval
                    });
                }
            };
            this.chartClickWorkaround = {
                defectBarClick: function (evt) {
                    if (evt && evt.y && evt.category) {
                        var selectedDefect = _.find(_this.defects, {
                            defectTypeName: evt.category,
                            count: evt.y
                        });
                        if (selectedDefect) {
                            _this.defectBarClick(selectedDefect);
                        }
                    }
                }
            };
            this.topTenDefects.callBack = angular.bind(this, this.chartClickWorkaround.defectBarClick);
            loaderService.loadingPromise(shopPromise);
        }
        DashboardController.prototype.setSelectedTab = function (tab) {
            var _this = this;
            if (this.hasScale) {
                if (tab === 2) {
                    this.loadDefectsReport(this.defectQueryStart);
                }
            }
            this.$timeout(function () { return _this.selectedTab = tab; }, 50);
        };
        DashboardController.prototype.updateTopTenDefectsBot = function () {
            var vm = this;
            this.topTenDefects.xAxis.categories = this.defectsPretty.map(function (item) { return item.Defect; });
            this.topTenDefects.series = [{
                    name: 'Count',
                    data: this.defectsPretty.map(function (item) {
                        return {
                            y: item.Count,
                            color: vm.defectNameToColor[item.Defect],
                            defects: vm.defects,
                            events: {
                                click: function (event) {
                                    var selectedDefect = _.find(this.options.defects, {
                                        defectTypeName: this.category,
                                        count: this.y
                                    });
                                    if (selectedDefect) {
                                        vm.defectBarClick(selectedDefect);
                                    }
                                }
                            }
                        };
                    })
                }];
        };
        DashboardController.prototype.updateDefects = function () {
            var _this = this;
            this.defectNameToColor = {};
            _.forEach(this.defects, function (d) {
                var color = _this.uiUtilityService.getSeverityColor(d.severity);
                if (color) {
                    _this.defectNameToColor[d.defectTypeName] = color;
                }
            });
            var unSortedDefectsPretty = _.map(this.defects, function (d) {
                return {
                    'Defect': d.defectTypeName,
                    'Count': d.count,
                    'Sort Value': (d.count * 100) + (10 - d.severity)
                };
            });
            this.defectsPretty = _.orderBy(unSortedDefectsPretty, ['Count', 'Severity'], ['desc', 'asc']);
            this.$timeout(function () {
                _this.updateTopTenDefectsBot();
            }, 50);
        };
        DashboardController.prototype.onDefectAdded = function (defect) {
            var _this = this;
            if (!this.defects || this.defectQueryStart.getTime() > defect.timeFound.getTime()) {
                return;
            }
            this.$timeout(function () {
                var existing = _.find(_this.defects, { defectTypeId: defect.defectTypeId });
                if (existing) {
                    existing.count = existing.count + 1;
                    if (existing.severity > defect.severity) {
                        existing.severity = defect.severity;
                    }
                }
                else {
                    _this.defects.push(_.assign({ count: 1 }, defect));
                }
                _this.updateDefects();
            });
        };
        DashboardController.prototype.onDefectRemoved = function (defect) {
            var _this = this;
            if (!this.defects || this.defectQueryStart.getTime() > defect.timeFound.getTime()) {
                return;
            }
            var existing = _.find(this.defects, { defectTypeId: defect.defectTypeId });
            if (!existing) {
                return;
            }
            this.$timeout(function () {
                existing.count = existing.count - 1;
                if (existing.count <= 0) {
                    _.remove(_this.defects, existing);
                }
                _this.updateDefects();
            });
        };
        DashboardController.prototype.loadDefectsReport = function (queryStart, queryEnd) {
            var _this = this;
            this.defectQueryStart = queryStart;
            this.defectQueryEnd = queryEnd;
            return this.reportService.getTopDefectsReport(this.shopId, queryStart, queryEnd, undefined, undefined, this.showMaintenance)
                .then(function (defects) {
                _this.defects = defects;
                _this.updateDefects();
            });
        };
        DashboardController.prototype.populateShiftSelectors = function (allStart, allEnd, shopShifts) {
            var _this = this;
            var allShifts = [];
            allShifts.push({
                name: 'All',
                value: {
                    start: allStart,
                    end: null,
                },
                selected: true,
            });
            _.forEach(shopShifts, function (s, i) {
                var shiftName = (i === 0) ? 'Current' : 'Shift -' + i;
                if (allStart < s.startTime) {
                    allShifts.push({
                        name: shiftName,
                        value: {
                            start: s.startTime,
                            end: s.stopTime,
                        },
                        selected: false
                    });
                }
            });
            this.shiftSelectors = {
                buttons: allShifts,
                select: function (button) {
                    _this.selectShift(button);
                }
            };
        };
        DashboardController.prototype.selectShift = function (shift) {
            this.loaderService.loadingPromise(this.loadDefectsReport(shift.value.start, shift.value.end));
        };
        DashboardController.prototype.IncludeMaintenence = function () {
            this.loaderService.loadingPromise(this.loadDefectsReport(this.defectQueryStart, this.defectQueryEnd));
        };
        DashboardController.prototype.defectBarClick = function (defect) {
            var reportStateParams = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportPlantId: undefined,
                reportShopId: undefined,
                startDate: this.defectQueryStart.toISOString(),
                endDate: this.defectQueryEnd ? this.defectQueryEnd.toISOString() : undefined,
                defectTypeId: defect.defectTypeId,
                filter: aps_enums_1.apsEnums.TopDefectsFilter.Top10Defects,
                autoRun: true
            };
            this.$state.go(constant_module_1.States.TOP_DEFECTS_REPORT, reportStateParams);
        };
        return DashboardController;
    }());
    exports.DashboardController = DashboardController;
    exports.default = angular.module('aps.controller.dashboard', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.DASHBOARD,
            url: '/dashboard',
            controller: 'DashboardCtrl as vm',
            template: dashboard_tpl_html_1.default,
            data: { pageTitle: 'Shop Dashboard' }
        });
    }])
        .controller('DashboardCtrl', DashboardController)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(5), __webpack_require__(0), __webpack_require__(1), __webpack_require__(2), __webpack_require__(27), __webpack_require__(33), __webpack_require__(55), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, aps_enums_1, angular, moment, _, enums_1, equipment_service_1, plant_service_1, loader_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [equipment_service_1.default, plant_service_1.default, loader_service_1.default];
    var LineEquipmentDetailImpl = (function () {
        function LineEquipmentDetailImpl(name, count) {
            this.name = name;
            this.actualCount = count;
        }
        Object.defineProperty(LineEquipmentDetailImpl.prototype, "count", {
            get: function () {
                return this.actualCount.count;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(LineEquipmentDetailImpl.prototype, "percent", {
            get: function () {
                return this.actualCount.percent;
            },
            enumerable: true,
            configurable: true
        });
        LineEquipmentDetailImpl.prototype.getPercent = function () {
            return this.actualCount.getPercent();
        };
        Object.defineProperty(LineEquipmentDetailImpl.prototype, "showTrend", {
            get: function () {
                return this.actualCount.showTrend;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(LineEquipmentDetailImpl.prototype, "trend", {
            get: function () {
                return this.actualCount.trend;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(LineEquipmentDetailImpl.prototype, "trendCounts", {
            get: function () {
                return this.actualCount.trendCounts;
            },
            enumerable: true,
            configurable: true
        });
        return LineEquipmentDetailImpl;
    }());
    exports.LineEquipmentDetailImpl = LineEquipmentDetailImpl;
    exports.default = angular
        .module('counts', requires)
        .service('lineCountsService', ["equipmentService", "plantService", "loaderService", "$stateParams", function (equipmentService, plantService, loaderService, $stateParams) {
        var kpiPairs = [
            {
                numerator: aps_enums_1.apsEnums.WellKnownCheckType.LehrInput,
                denominator: aps_enums_1.apsEnums.WellKnownCheckType.GobsProduced,
                efficiency: 'H/E Efficiency',
                losses: 'H/E Losses'
            },
            {
                numerator: aps_enums_1.apsEnums.WellKnownCheckType.PackedCount,
                denominator: aps_enums_1.apsEnums.WellKnownCheckType.LehrInput,
                efficiency: 'C/E Efficiency',
                losses: 'C/E Losses'
            },
            {
                numerator: aps_enums_1.apsEnums.WellKnownCheckType.PackedCount,
                denominator: aps_enums_1.apsEnums.WellKnownCheckType.GobsProduced,
                efficiency: 'Pack Efficiency',
                losses: 'Overall Losses'
            }
        ];
        var kpiPairsV1 = [
            {
                numerator: aps_enums_1.apsEnums.WellKnownCheckType.LehrInput,
                denominator: aps_enums_1.apsEnums.WellKnownCheckType.GobsProduced,
                efficiencyText: 'LEHR IN',
                efficiencyFormula: '100 * (LEHR IN / SHEARS)',
                lossText: 'HOT END LOSS',
                lossFormula: '100 - (100 * (LEHR IN / SHEARS))',
                name: 'HE',
                order: 1
            },
            {
                numerator: aps_enums_1.apsEnums.WellKnownCheckType.LehrOutput,
                denominator: aps_enums_1.apsEnums.WellKnownCheckType.GobsProduced,
                efficiencyText: 'LEHR OUT',
                efficiencyFormula: '100 * (LEHR OUT / SHEARS)',
                lossText: 'LEHR LOSS',
                lossFormula: '100 - (100 * ((LEHR IN - LEHR OUT) / SHEARS))',
                name: 'LEHR',
                order: 2
            },
            {
                numerator: aps_enums_1.apsEnums.WellKnownCheckType.ColdEndInspectionLoss,
                denominator: aps_enums_1.apsEnums.WellKnownCheckType.GobsProduced,
                efficiencyText: null,
                efficiencyFormula: null,
                lossText: 'AIE LOSS',
                lossFormula: '100 - (100 * (AIE LOSS / SHEARS))',
                name: 'AIE',
                order: 3
            },
            {
                numerator: aps_enums_1.apsEnums.WellKnownCheckType.ColdEndTotalLoss,
                denominator: aps_enums_1.apsEnums.WellKnownCheckType.GobsProduced,
                efficiencyText: null,
                efficiencyFormula: null,
                lossText: 'CE DELTA LOSS',
                lossFormula: '100 - (100 * (LEHR OUT - AIE LOSS - END OF LINE) / SHEARS)',
                name: 'CE DELTA',
                order: 4
            },
            {
                numerator: aps_enums_1.apsEnums.WellKnownCheckType.PackedCount,
                denominator: aps_enums_1.apsEnums.WellKnownCheckType.GobsProduced,
                efficiencyText: 'PACK',
                efficiencyFormula: '100 * (END OF LINE / SHEARS)',
                lossText: 'TOTAL LOSS',
                lossFormula: '100 - (100 * (END OF LINE / SHEARS))',
                name: 'PACK',
                order: 5
            }
        ];
        function calcEfficiency(numerator, denominator) {
            return numerator && denominator && denominator.count > 0
                ? ((numerator.count / denominator.count) * 100).toFixed(1) + '%'
                : 'N/A';
        }
        function calcLosses(numerator, denominator) {
            return numerator && denominator && denominator.count >= numerator.count
                ? denominator.count - numerator.count
                : 0;
        }
        function calcLossPercent(losses, denominator) {
            return denominator && denominator.count > 0
                ? ((losses / denominator.count) * 100).toFixed(1) + '%'
                : 'N/A';
        }
        function calcSpeed(count) {
            if (!count) {
                return '';
            }
            var batchCounts = count.filteredCounts.filter(function (x) { return !x.lastEndTime; });
            var speedCount = batchCounts.map(function (x) { return x.value; }).reduce(function (p, c) { return p + c; }, 0);
            if (speedCount === 0) {
                return '';
            }
            var minValue = _.min(_.map(batchCounts, 'intervalStartTime'));
            var maxValue = _.max(_.map(batchCounts, 'intervalEndTime'));
            var interval = moment(maxValue).diff(moment(minValue), 'minutes', true);
            return Math.round(speedCount / interval) + ' BPM';
        }
        function createCurrentBucket() {
            return {
                value: 0,
                interval: aps_enums_1.apsEnums.CountInterval.Minute,
                intervalStartTime: moment().startOf('m').toDate().getTime(),
                intervalEndTime: moment().add(1, 'm').startOf('m').toDate().getTime(),
                moldCounts: {}
            };
        }
        function isPlantCheck($stateParams) {
            return ($stateParams.plantId === 'bbdf0000-3a00-000d-9cf9-08d2e5fa8dba' ||
                $stateParams.plantId === 'bbdf0000-3a00-000f-724d-08d2e5fa8e34');
        }
        var rejectDecimalOveride = 1;
        if (isPlantCheck($stateParams)) {
            rejectDecimalOveride = 2;
        }
        var defaultCount = {
            count: 0,
            percent: '0.0',
            gobPercent: '0.0',
            trend: { flat: true },
            rejectPercentDecimals: rejectDecimalOveride,
            lineCounts: null,
            getPercent: function () { return '0.0'; }
        };
        function mapMoldCount(moldCounts, mc) {
            if (!mc.count) {
                return;
            }
            var moldCount = moldCounts[mc.mold];
            if (moldCount) {
                moldCount.value += mc.count;
            }
            else {
                moldCount = { value: mc.count };
                moldCounts[mc.mold] = moldCount;
            }
            if (mc.mnrCount) {
                if (moldCount.mnrCount) {
                    moldCount.mnrCount += mc.mnrCount;
                }
                else {
                    moldCount.mnrCount = mc.mnrCount;
                }
            }
        }
        function mapMoldCounts(moldCounts) {
            var mappedCounts = {};
            moldCounts.forEach(function (mc) { return mapMoldCount(mappedCounts, mc); });
            return mappedCounts;
        }
        function getTotalMnrCount(moldCounts) {
            var mnrCount = null;
            moldCounts.forEach(function (mc) {
                if (mc.mnrCount) {
                    if (mnrCount) {
                        mnrCount += mc.mnrCount;
                    }
                    else {
                        mnrCount = mc.mnrCount;
                    }
                }
            });
            return mnrCount;
        }
        function mapCount(count) {
            return {
                value: count.value,
                interval: count.interval,
                intervalStartTime: count.intervalStart.getTime(),
                intervalEndTime: count.intervalEnd.getTime(),
                moldCounts: count.moldCounts
                    ? mapMoldCounts(count.moldCounts)
                    : {},
                mnrCount: count.moldCounts
                    ? getTotalMnrCount(count.moldCounts)
                    : undefined
            };
        }
        function calcPercent(numerator, denominator) {
            if (numerator <= 0 || denominator <= 0) {
                return 0;
            }
            return Math.round((numerator * 10000.0) / denominator) / 100.0;
        }
        function calcPercentStr(numerator, denominator) {
            if (numerator == 0 || denominator == 0) {
                return "0";
            }
            return numerator && denominator > 0
                ? ((numerator / denominator) * 100).toFixed(1)
                : 'N/A';
        }
        function calcPercentStrTwoDecimals(numerator, denominator) {
            if (numerator == 0 || denominator == 0) {
                return "0";
            }
            return numerator && denominator > 0
                ? ((numerator / denominator) * 100).toFixed(2)
                : 'N/A';
        }
        function calcPercentFromOneStr(numerator, denominator) {
            if (numerator <= 0 || denominator <= 0) {
                return "0";
            }
            return numerator && denominator > 0
                ? ((1 - (numerator / denominator)) * 100).toFixed(1)
                : 'N/A';
        }
        function calcCountRejectPercent(count) {
            return calcRejectPercent(count, count.inspectCount);
        }
        function calcCountRejectGobPercent(count) {
            return calcRejectPercent(count, !count.lineCounts ? null : count.lineCounts.gobsProduced);
        }
        function calcRejectPercent(count, denominatorCount) {
            if (!count || !denominatorCount || count.count <= 0 || denominatorCount.count <= 0) {
                return defaultCount.percent;
            }
            if (isPlantCheck($stateParams)) {
                return calcPercent(count.count, denominatorCount.count).toFixed(2);
            }
            else {
                return calcPercent(count.count, denominatorCount.count).toFixed(1);
            }
        }
        function trendCountsFilter(count) {
            return count.interval === aps_enums_1.apsEnums.CountInterval.TenMinutes
                || count.interval === aps_enums_1.apsEnums.CountInterval.Hour;
        }
        function getTrendCounts(counts) {
            return _.take(_.orderBy(counts.counts.filter(trendCountsFilter), ['intervalEndTime'], ['desc']), 4);
        }
        function calcTrend(inspectCounts, rejectCounts) {
            if (!inspectCounts || !rejectCounts || inspectCounts.length !== rejectCounts.length) {
                return defaultCount.trend;
            }
            var direction = 0;
            var previous = null;
            var current = null;
            for (var i = 0; i < inspectCounts.length; i++) {
                current = calcPercent(rejectCounts[i], inspectCounts[i]);
                if (previous !== null) {
                    if (current > previous) {
                        direction--;
                    }
                    else if (current < previous) {
                        direction++;
                    }
                }
                previous = current;
            }
            if (direction === (inspectCounts.length - 1)) {
                return { up: true };
            }
            if (direction === (1 - inspectCounts.length)) {
                return { down: true };
            }
            return defaultCount.trend;
        }
        function setCountTrendCounts(count) {
            var parent = count;
            do {
                if (parent.setTrendCounts) {
                    parent.setTrendCounts();
                    break;
                }
                parent = parent.parent;
            } while (parent);
        }
        function calcCountRejectTrend(count) {
            if (!count || !count.inspectCount || !count.trendCounts) {
                return defaultCount.trend;
            }
            if (!count.inspectCount.trendCounts) {
                setCountTrendCounts(count.inspectCount);
            }
            if (!count.inspectCount.trendCounts) {
                return defaultCount.trend;
            }
            return calcTrend(count.inspectCount.trendCounts, count.trendCounts);
        }
        function mnrTrendMap(i) { return i.mnrCount || 0; }
        function setTrendCounts(counts) {
            var trendCounts = getTrendCounts(counts);
            counts.trendCounts = trendCounts.map(function (i) { return i.value; });
            if (!counts.hasMolds) {
                return;
            }
            for (var mold in counts.moldCounts) {
                var moldCount = counts.moldCounts[mold];
                var moldMap = function (i) {
                    var count = i.moldCounts[mold];
                    return count ? count.value : 0;
                };
                moldCount.trendCounts = trendCounts.map(moldMap);
            }
            if (counts.mnrCount) {
                counts.mnrCount.trendCounts = trendCounts.map(mnrTrendMap);
            }
            for (var mold in counts.moldMnrCounts) {
                var mnrCount = counts.moldMnrCounts[mold];
                var moldMnrMap = function (i) {
                    var count = i.moldCounts[mold];
                    return count ? (count.mnrCount || 0) : 0;
                };
                mnrCount.trendCounts = trendCounts.map(moldMnrMap);
            }
        }
        function recalculatePercentTrend(count) {
            if (!count.inspectCount) {
                return;
            }
            if (count.showPercent) {
                count.percent = calcCountRejectPercent(count);
                count.gobPercent = calcCountRejectGobPercent(count);
            }
            if (count.showTrend) {
                count.trend = calcCountRejectTrend(count);
            }
        }
        function createSubCount(model, count) {
            var rejectDecimalOveride = 1;
            if (isPlantCheck($stateParams)) {
                rejectDecimalOveride = 2;
            }
            var countModel = {
                count: count,
                inspectCount: model.inspectCount,
                showPercent: model.showPercent,
                showTrend: model.showTrend,
                percent: defaultCount.percent,
                gobPercent: defaultCount.gobPercent,
                trend: defaultCount.trend,
                parent: model,
                rejectPercentDecimals: rejectDecimalOveride,
                lineCounts: model.lineCounts,
                getPercent: null
            };
            countModel.getPercent = createGetPercentMethod(countModel);
            return countModel;
        }
        function createGetPercentMethod(count) {
            return function () { return count.lineCounts && count.lineCounts.usePercentGobs
                ? count.gobPercent : count.percent; };
        }
        function calculateAggregates(count) {
            if (count.aggregateCounts) {
                count.aggregateCounts.forEach(function (ac) { return ac.calculateCount(); });
            }
        }
        function updateRowsAndCells(count) {
            if (count.rows) {
                var isNoCount_1 = (count.count <= 0);
                count.rows.forEach(function (row) { return row.isNoCount = isNoCount_1; });
            }
            if (count.cells && count.cells.length > 0) {
                count.cells.filter(function (c) { return c.affectsRowDisplay; }).forEach(function (cell) {
                    cell.row.setRowsUpdateNeeded();
                });
            }
        }
        function recalculateDependencies(count) {
            if (count.showTrend || (count.rejectCounts && _.some(count.rejectCounts, function (x) { return x.showTrend; }))) {
                setCountTrendCounts(count);
            }
            if (count.rejectCounts) {
                count.rejectCounts.forEach(function (c) { return recalculatePercentTrend(c); });
            }
            recalculatePercentTrend(count);
            calculateAggregates(count);
            updateRowsAndCells(count);
        }
        function calculateMoldCounts(model, counts) {
            var moldNumbers = {};
            var countChanged = false;
            var previousMoldCounts = {};
            var previousMoldMnrCounts = {};
            for (var key in model.moldCounts) {
                previousMoldCounts[key] = model.moldCounts[key].count;
                previousMoldMnrCounts[key] = model.moldMnrCounts[key].count;
                model.moldMnrCounts[key].count = 0;
                model.moldCounts[key].count = 0;
            }
            if (!model.mnrCount) {
                model.mnrCount = createSubCount(model, 0);
            }
            var previousMnrCount = model.mnrCount.count;
            model.mnrCount.count = 0;
            counts.forEach(function (c) {
                if (!c.moldCounts) {
                    return;
                }
                for (var mold in c.moldCounts) {
                    if (!moldNumbers[mold]) {
                        moldNumbers[mold] = true;
                    }
                    var count = c.moldCounts[mold];
                    if (!count.value) {
                        continue;
                    }
                    var moldCount = model.moldCounts[mold];
                    if (moldCount) {
                        moldCount.count += count.value;
                        if (count.mnrCount > 0) {
                            model.moldMnrCounts[mold].count += count.mnrCount;
                        }
                    }
                    else {
                        countChanged = true;
                        model.moldCounts[mold] = createSubCount(model, count.value);
                        model.moldMnrCounts[mold] = createSubCount(model, count.mnrCount || 0);
                    }
                    if (count.mnrCount) {
                        model.mnrCount.count += count.mnrCount;
                    }
                }
            });
            if (model.rows && _.xor(Object.keys(moldNumbers), Object.keys(previousMoldCounts)).length > 0) {
                countChanged = true;
                model.rows.forEach(function (row) {
                    if (!row.isMold) {
                        return;
                    }
                    row.setRowsUpdateNeeded();
                });
            }
            if (previousMnrCount !== model.mnrCount.count) {
                countChanged = true;
                recalculateDependencies(model.mnrCount);
            }
            else {
                for (var key in model.moldCounts) {
                    var moldCount = model.moldCounts[key];
                    if (moldCount.count !== previousMoldCounts[key]) {
                        countChanged = true;
                        recalculateDependencies(moldCount);
                    }
                    var mnrCount = model.moldMnrCounts[key];
                    if (mnrCount.count !== previousMoldMnrCounts[key]) {
                        countChanged = true;
                        recalculateDependencies(mnrCount);
                    }
                }
            }
            return countChanged;
        }
        function getShift(model, newest) {
            var shift;
            if (newest) {
                shift = model.shopConfig.shiftsInLast24Hours[1];
            }
            else {
                shift = model.shopConfig.shiftsInLast24Hours[2];
            }
            return _.filter(model.counts, function (c) { return c.interval === aps_enums_1.apsEnums.CountInterval.Hour
                && c.intervalStartTime >= shift.startTime.getTime()
                && c.intervalEndTime <= shift.stopTime.getTime(); });
        }
        function filterCountsByInterval(model) {
            var startTime;
            var endTime;
            var now = moment();
            var remainderMinutes = now.minute() % 10;
            var remainderSeconds = now.second();
            var remainderMilliSeconds = now.millisecond();
            switch (model.countsInterval) {
                case enums_1.apsDisplayEnums.CountDisplayInterval.RollingHour:
                    endTime = moment(now)
                        .subtract(remainderMinutes, 'minute')
                        .subtract(remainderSeconds, 'second')
                        .subtract(remainderMilliSeconds, 'millisecond')
                        .toDate()
                        .getTime();
                    startTime = moment(endTime)
                        .subtract(1, 'hour')
                        .toDate()
                        .getTime();
                    return _.filter(model.counts, function (c) { return c.intervalStartTime >= startTime
                        && c.intervalStartTime < endTime; });
                case enums_1.apsDisplayEnums.CountDisplayInterval.LastTwentyMinutes:
                    endTime = moment(now)
                        .subtract(remainderMinutes, 'minute')
                        .subtract(remainderSeconds, 'second')
                        .subtract(remainderMilliSeconds, 'millisecond')
                        .toDate()
                        .getTime();
                    startTime = moment(endTime)
                        .subtract(20, 'minute')
                        .toDate()
                        .getTime();
                    return _.filter(model.counts, function (c) { return c.intervalStartTime >= startTime
                        && c.intervalStartTime < endTime; });
                case enums_1.apsDisplayEnums.CountDisplayInterval.CurrentHour:
                    startTime = moment().startOf('hour').toDate().getTime();
                    return _.filter(model.counts, function (c) { return c.intervalStartTime >= startTime; });
                case enums_1.apsDisplayEnums.CountDisplayInterval.PreviousHour:
                    endTime = moment().startOf('hour').toDate().getTime();
                    startTime = moment(endTime).subtract(1, 'hour').toDate().getTime();
                    return _.filter(model.counts, function (c) { return c.intervalStartTime >= startTime
                        && c.intervalStartTime < endTime; });
                case enums_1.apsDisplayEnums.CountDisplayInterval.CurrentShift:
                    startTime = model.shopConfig.shiftsInLast24Hours[0].startTime.getTime();
                    return _.filter(model.counts, function (c) { return c.intervalStartTime >= startTime; });
                case enums_1.apsDisplayEnums.CountDisplayInterval.LastShift:
                    var lastShift = getShift(model, true);
                    return lastShift ? lastShift : [];
                case enums_1.apsDisplayEnums.CountDisplayInterval.ShiftBeforeLast:
                    var shiftBeforeLast = getShift(model, false);
                    return shiftBeforeLast ? shiftBeforeLast : [];
                default:
                    endTime = moment().startOf('hour').toDate().getTime();
                    startTime = moment(endTime).subtract(1, 'days').toDate().getTime();
                    return _.filter(model.counts, function (c) { return c.interval !== aps_enums_1.apsEnums.CountInterval.Shift
                        && c.intervalStartTime >= startTime
                        && c.intervalStartTime < endTime; });
            }
        }
        function calculateCounts(model) {
            var previousCount = model.count;
            model.filteredCounts = filterCountsByInterval(model);
            if (model.filteredCounts.length === 0) {
                model.count = 0;
            }
            else {
                model.count = model.filteredCounts.map(function (c) { return c.value; }).reduce(function (prev, current) { return prev + current; });
            }
            var countChanged = (previousCount !== model.count);
            if (countChanged) {
                recalculateDependencies(model);
                if (model.showSpeed) {
                    model.speed = calcSpeed(model);
                }
            }
            if (model.hasMolds) {
                countChanged = calculateMoldCounts(model, model.filteredCounts) || countChanged;
            }
            for (var key in model.countsUpdated) {
                model.countsUpdated[key] = true;
            }
            return countChanged;
        }
        function setAggregateTrendCounts(count) {
            var finalCounts = count.finalCounts.filter(function (x) { return x !== defaultCount; });
            finalCounts.filter(function (x) { return !x.trendCounts; }).forEach(function (x) { return setCountTrendCounts(x); });
            var countTrendCounts = finalCounts
                .filter(function (x) { return x.trendCounts !== undefined; })
                .map(function (c) { return c.trendCounts; });
            count.trendCounts = countTrendCounts.length > 0
                ? countTrendCounts.reduce(function (p, c) {
                    c.forEach(function (v, i) { return p[i] = (p[i] || 0) + v; });
                    return p;
                })
                : [];
        }
        function calculateAggregateCount(count) {
            var previousCount = count.count;
            if (count.countsMissing) {
                populateMissingFinalCounts(count);
            }
            count.count = _.sum(count.finalCounts.filter(function (c) { return c !== defaultCount; }).map(function (c) { return c.count; }));
            if (previousCount !== count.count) {
                recalculateDependencies(count);
            }
        }
        function addRejectCount(inspectCount, rejectCount) {
            if (inspectCount.rejectCounts) {
                inspectCount.rejectCounts.push(rejectCount);
            }
            else {
                inspectCount.rejectCounts = [rejectCount];
            }
        }
        function addAggregateCount(count, aggregateCount) {
            if (count.aggregateCounts) {
                count.aggregateCounts.push(aggregateCount);
            }
            else {
                count.aggregateCounts = [aggregateCount];
            }
        }
        function getAggregateFinalCount(count, memberCount) {
            var finalCount = defaultCount;
            if (count.mold) {
                if (count.isMnr) {
                    if (memberCount.moldMnrCounts) {
                        finalCount = memberCount.moldMnrCounts[count.mold] || defaultCount;
                    }
                }
                else {
                    if (memberCount.moldCounts) {
                        finalCount = memberCount.moldCounts[count.mold] || defaultCount;
                    }
                }
            }
            else if (count.isMnr) {
                finalCount = memberCount.mnrCount || defaultCount;
            }
            else {
                finalCount = memberCount;
            }
            if (finalCount !== defaultCount) {
                addAggregateCount(finalCount, count);
            }
            return finalCount;
        }
        function setFinalCountsMissing(count) {
            count.countsMissing = _.some(count.finalCounts, function (x) { return x === defaultCount; });
        }
        function populateMissingFinalCounts(count) {
            for (var i in count.finalCounts) {
                if (count.finalCounts[i] === defaultCount) {
                    count.finalCounts[i] = getAggregateFinalCount(count, count.memberCounts[i]);
                }
            }
            setFinalCountsMissing(count);
        }
        function createAggregateCount(lineCounts, usePlantPercentPreference, counts, mold, isMnr, showPercent, showTrend, inspectCount) {
            var rejectDecimalOveride = 1;
            if (isPlantCheck($stateParams)) {
                rejectDecimalOveride = 2;
            }
            var rejectPercentDecimals = rejectDecimalOveride;
            if (usePlantPercentPreference && inspectCount
                && lineCounts.gobsProduced
                && lineCounts.countRejectPercent === aps_enums_1.apsEnums.CountRejectPercent.PercentOfGobsProduced) {
                inspectCount = lineCounts.gobsProduced;
                rejectPercentDecimals = rejectPercentDecimals;
            }
            var aggregateCount = {
                calculateCount: null,
                showPercent: showPercent,
                showTrend: showTrend,
                mold: mold,
                isMnr: isMnr,
                count: 0,
                memberCounts: counts,
                inspectCount: inspectCount,
                finalCounts: null,
                countsMissing: false,
                percent: defaultCount.percent,
                gobPercent: defaultCount.gobPercent,
                trend: defaultCount.trend,
                rejectPercentDecimals: rejectPercentDecimals,
                lineCounts: lineCounts,
                getPercent: null
            };
            aggregateCount.getPercent = createGetPercentMethod(aggregateCount);
            aggregateCount.finalCounts = counts.map(function (c) { return getAggregateFinalCount(aggregateCount, c); });
            aggregateCount.setTrendCounts = function () { return setAggregateTrendCounts(aggregateCount); };
            aggregateCount.calculateCount = function () { return calculateAggregateCount(aggregateCount); };
            aggregateCount.calculateCount();
            setFinalCountsMissing(aggregateCount);
            return aggregateCount;
        }
        function createCounts(lineCounts, usePlantPercentPreference, id, rawCounts, countsInterval, shopConfig, inspectCount, showPercent, showTrend, hasMolds, showSpeed) {
            var rejectPercentDecimals = 1;
            if (usePlantPercentPreference && inspectCount
                && lineCounts.gobsProduced
                && lineCounts.countRejectPercent === aps_enums_1.apsEnums.CountRejectPercent.PercentOfGobsProduced) {
                inspectCount = lineCounts.gobsProduced;
                rejectPercentDecimals = 2;
            }
            var model = {
                id: id,
                counts: rawCounts ? rawCounts.map(mapCount) : [],
                filteredCounts: null,
                showPercent: showPercent,
                showTrend: showTrend,
                hasMolds: hasMolds,
                count: 0,
                inspectCount: inspectCount,
                countsInterval: countsInterval,
                showPerformance: false,
                moldCounts: hasMolds ? {} : undefined,
                moldMnrCounts: hasMolds ? {} : undefined,
                mnrCount: hasMolds ? {
                    count: 0,
                    inspectCount: inspectCount,
                    showPercent: showPercent,
                    showTrend: showTrend,
                    percent: defaultCount.percent,
                    gobPercent: defaultCount.gobPercent,
                    trend: defaultCount.trend,
                    rejectPercentDecimals: 1,
                    lineCounts: lineCounts,
                    getPercent: null
                } : undefined,
                countsUpdated: {},
                speed: '',
                showSpeed: showSpeed,
                percent: defaultCount.percent,
                gobPercent: defaultCount.gobPercent,
                trend: defaultCount.trend,
                rejectPercentDecimals: rejectPercentDecimals,
                shopConfig: shopConfig,
                lineCounts: lineCounts,
                getPercent: null
            };
            model.getPercent = createGetPercentMethod(model);
            if (model.mnrCount) {
                model.mnrCount.getPercent = createGetPercentMethod(model.mnrCount);
            }
            model.filteredCounts = model.counts;
            var current = null;
            model.calculateCount = function () { return calculateCounts(model); };
            model.updateCounts = function (counts, shopConfig) {
                model.shopConfig = shopConfig;
                model.counts = counts ? counts.map(mapCount) : [];
                var newCurrentBucket = createCurrentBucket();
                if (current !== null && current.intervalStartTime === newCurrentBucket.intervalStartTime) {
                    model.counts.push(current);
                }
                return model.calculateCount();
            };
            model.handleCount = function (event, count) {
                var intervalStart = event.startTime.getTime();
                if (current === null || intervalStart >= current.intervalEndTime) {
                    current = createCurrentBucket();
                    model.counts.push(current);
                }
                if (intervalStart < current.intervalStartTime) {
                    return false;
                }
                current.value += count.count;
                current.lastEndTime = event.endTime.getTime();
                if (model.hasMolds && count.moldCounts) {
                    count.moldCounts.forEach(function (mc) {
                        if (!mc.count) {
                            return;
                        }
                        mapMoldCount(current.moldCounts, mc);
                        if (mc.mnrCount) {
                            if (current.mnrCount) {
                                current.mnrCount += mc.mnrCount;
                            }
                            else {
                                current.mnrCount = mc.mnrCount;
                            }
                        }
                    });
                }
                return model.calculateCount();
            };
            model.handleInterval = function (event, count) {
                var intervalEnd = event.intervalEnd.getTime();
                if (_.some(model.counts, function (c) { return c.interval > event.interval && c.intervalEndTime >= intervalEnd; })) {
                    return false;
                }
                var matching = _.find(model.counts, function (c) {
                    return c.interval === event.interval && c.intervalEndTime === intervalEnd;
                });
                if (matching) {
                    _.remove(model.counts, matching);
                }
                var intervalStart = event.intervalStart.getTime();
                switch (event.interval) {
                    case aps_enums_1.apsEnums.CountInterval.Minute:
                        break;
                    case aps_enums_1.apsEnums.CountInterval.TenMinutes:
                    case aps_enums_1.apsEnums.CountInterval.Hour:
                        _.remove(model.counts, function (c) {
                            return c.interval < event.interval
                                && c.intervalEndTime <= intervalEnd && c.intervalStartTime >= intervalStart;
                        });
                        break;
                    default:
                        return false;
                }
                model.counts.push(mapCount({
                    intervalStart: event.intervalStart,
                    intervalEnd: event.intervalEnd,
                    interval: event.interval,
                    value: count.value,
                    moldCounts: count.moldCounts
                }));
                return model.calculateCount();
            };
            model.setTrendCounts = function () { return setTrendCounts(model); };
            if (inspectCount && showTrend && !inspectCount.trendCounts) {
                setCountTrendCounts(inspectCount);
            }
            model.calculateCount();
            return model;
        }
        function getRowId(row) {
            var id = row.name;
            if (row.mold !== null) {
                id += '-' + row.mold;
            }
            else if (row.isSpacer && !row.name) {
                id = 'spacer-' + row.order;
            }
            if (row.parent.id) {
                id = row.parent.id + '-' + id;
            }
            return id;
        }
        function getRowDisplayName(row) {
            if (row.displayBlankName || row.isSpacer) {
                return ' ';
            }
            if (row.isMold && row.useMoldAsName) {
                if (row.mold !== null) {
                    return row.mold === 0 ? 'UNR' : row.mold.toString(10);
                }
                return 'No molds read';
            }
            return row.name;
        }
        function setRowNameAndId(row) {
            row.displayName = getRowDisplayName(row);
            row.id = getRowId(row);
        }
        function getOrCreateEquipmentCounts(lineCounts, usePlantPercentPreference, counts, rawCounts, dataPointId, countsInterval, shopConfig, inspectCount, showPercent, showTrend, hasMolds, showSpeed) {
            if (!dataPointId) {
                return null;
            }
            var dpCount;
            var dpCounts = counts[dataPointId];
            if (dpCounts) {
                for (var c in dpCounts) {
                    var dpCount_1 = dpCounts[c];
                    if (inspectCount) {
                        if (dpCount_1.inspectCount === inspectCount
                            && dpCount_1.showPercent === showPercent
                            && dpCount_1.showTrend === showTrend
                            && dpCount_1.hasMolds === hasMolds
                            && dpCount_1.showSpeed === showSpeed) {
                            return dpCount_1;
                        }
                    }
                    else if (!dpCount_1.inspectCount && dpCount_1.hasMolds === hasMolds) {
                        return dpCount_1;
                    }
                }
            }
            dpCount = createCounts(lineCounts, usePlantPercentPreference, dataPointId, rawCounts ? rawCounts[dataPointId] : [], countsInterval, shopConfig, inspectCount, showPercent, showTrend, hasMolds, showSpeed);
            if (dpCounts) {
                dpCounts.push(dpCount);
            }
            else {
                counts[dataPointId] = [dpCount];
            }
            return dpCount;
        }
        function getCountForRowCell(row, cellCount) {
            if (row.isMold || row.parent.isMold) {
                var mold = row.mold;
                if (mold === null && row.parent.isMold) {
                    mold = row.parent.mold;
                }
                if (mold === null) {
                    return defaultCount;
                }
                else if (row.isMNR) {
                    var mnrCount = cellCount.moldMnrCounts[mold];
                    return mnrCount || defaultCount;
                }
                else {
                    var moldCount = cellCount.moldCounts[mold];
                    return moldCount || defaultCount;
                }
            }
            else if (row.isMNR) {
                if (row.parent.isMold && row.parent.mold !== null) {
                    var mnrCount = cellCount.moldMnrCounts[row.parent.mold];
                    return mnrCount || defaultCount;
                }
                else {
                    return cellCount.mnrCount || defaultCount;
                }
            }
            return cellCount;
        }
        function populateCell(cell, row, lineCounts, cellCount) {
            if (!cellCount || (cell.count && cell.count !== defaultCount)) {
                return;
            }
            var cellCounts = cellCount;
            if ((row.isMold || row.parent.isMold) && !(row.mold || row.parent.mold)) {
                cell.count = defaultCount;
            }
            else if (cellCounts.length > 0) {
                cell.count = createAggregateCount(lineCounts, false, cellCounts, row.mold || row.parent.mold, row.isMNR, cellCounts[0].showPercent, cellCounts[0].showTrend, row.count);
            }
            else {
                cell.count = getCountForRowCell(row, cellCount);
            }
            if (cell.count !== defaultCount) {
                if (cell.count.showPercent || cell.count.showTrend) {
                    addRejectCount(row.count, cell.count);
                }
                if (cell.count.cells) {
                    cell.count.cells.push(cell);
                }
                else {
                    cell.count.cells = [cell];
                }
            }
        }
        function getCellCounts(row, tab, lineCounts, counts, rawCounts, countsInterval, shopConfig) {
            return row.cells.map(function (cell, c) {
                if (cell.isFixed) {
                    return null;
                }
                var column = tab.columns[c];
                if (cell.dataPointIds) {
                    return cell.dataPointIds.map(function (id) { return getOrCreateEquipmentCounts(lineCounts, false, counts, rawCounts, id, countsInterval, shopConfig, row.count, column.showPercent, column.showTrend, row.isMold || row.isMNR || row.parent.isMold); });
                }
                return getOrCreateEquipmentCounts(lineCounts, false, counts, rawCounts, cell.dataPointId, countsInterval, shopConfig, row.count, column.showPercent, column.showTrend, row.isMold || row.isMNR || row.parent.isMold);
            });
        }
        function populateRowChildren(row, tab, lineCounts, counts, rawCounts, countsInterval, shopConfig) {
            if (!row.children || row.children.length === 0) {
                return;
            }
            if (row.isMold && !row.mold) {
                return;
            }
            var rowChildren = [];
            row.children.forEach(function (childRow) {
                childRow.isChild = true;
                childRow.parent = row;
                if (childRow.isSpacer) {
                    setRowNameAndId(childRow);
                    rowChildren.push(childRow);
                    return;
                }
                var rowRows = createRowRows(childRow, tab, lineCounts, counts, rawCounts, countsInterval, shopConfig);
                rowRows.forEach(function (r) { return rowChildren.push(r); });
            });
            row.expandedChildren = rowChildren;
        }
        function populateRow(row, tab, lineCounts, counts, rawCounts, countsInterval, shopConfig) {
            if (row.count) {
                if (row.count.rows) {
                    row.count.rows.push(row);
                }
                else {
                    row.count.rows = [row];
                }
            }
            row.cells.forEach(function (cell, c) {
                cell.row = row;
                if (cell.isFixed) {
                    return;
                }
                var cellCount = row.cellCounts[c];
                if (!cellCount) {
                    return;
                }
                if (row.hideIfCellIndexZero === c
                    || row.orderByCellIndex === c
                    || ((row.hasMNR || row.parent.hasMNR) && row.isMNR)) {
                    cell.affectsRowDisplay = true;
                }
                populateCell(cell, row, lineCounts, cellCount);
            });
            populateRowChildren(row, tab, lineCounts, counts, rawCounts, countsInterval, shopConfig);
        }
        function copyCell(c, row) {
            return {
                count: undefined,
                fixedValue: c.fixedValue,
                isFixed: c.isFixed,
                type: c.type,
                dataPointId: c.dataPointId,
                dataPointIds: c.dataPointIds,
                row: row,
                affectsRowDisplay: c.affectsRowDisplay,
                rightJustify: c.rightJustify
            };
        }
        function setRowsUpdateNeeded(row) {
            var parent = row.parent;
            while (parent.parent) {
                parent = parent.parent;
            }
            parent.needsRowUpdate = true;
        }
        function copyRow(row, parent) {
            var copiedRow = {
                name: row.name,
                isMold: row.isMold,
                inspectDataPointId: row.inspectDataPointId,
                inspectDataPointIds: row.inspectDataPointIds,
                cells: null,
                children: null,
                hasMNR: row.hasMNR,
                isMNR: row.isMNR,
                isSpacer: row.isSpacer,
                mold: row.mold,
                useMoldAsName: row.useMoldAsName,
                parent: parent,
                cellCounts: row.cellCounts,
                count: row.count,
                displayBlankName: row.displayBlankName,
                hideIfCellIndexZero: row.hideIfCellIndexZero,
                order: row.order,
                orderByCellIndex: row.orderByCellIndex,
                orderByCellIndexDescending: row.orderByCellIndexDescending,
                isChild: row.isChild,
                useFullInspectCount: row.useFullInspectCount,
                headerRow: row.headerRow,
                isNoCount: false,
                displayName: null,
                expandedChildren: null,
                outputRows: null,
                setRowsUpdateNeeded: null
            };
            copiedRow.setRowsUpdateNeeded = function () { return setRowsUpdateNeeded(copiedRow); };
            copiedRow.cells = row.cells.map(function (c) { return copyCell(c, copiedRow); });
            if (row.children) {
                copiedRow.children = row.children.map(function (c) { return copyRow(c, copiedRow); });
            }
            return copiedRow;
        }
        function createMoldRow(row, lineCounts, mold) {
            var moldRow = copyRow(row, row.parent);
            if (row.isChild || row.useFullInspectCount) {
                moldRow.count = row.count;
            }
            else if (row.inspectDataPointIds) {
                var aggregateCount = row.count;
                var counts = aggregateCount.memberCounts;
                moldRow.count = createAggregateCount(lineCounts, false, counts, mold, row.isMNR);
            }
            else {
                moldRow.count = row.count.moldCounts[mold];
            }
            moldRow.mold = mold;
            setRowNameAndId(moldRow);
            return moldRow;
        }
        function getRowMoldNumbers(row) {
            var moldNumbers = [];
            if (row.count.moldCounts) {
                moldNumbers = Object.keys(row.count.moldCounts);
            }
            else if (row.count.memberCounts) {
                row.count.memberCounts.forEach(function (c) {
                    if (c.moldCounts) {
                        moldNumbers = moldNumbers.concat(Object.keys(c.moldCounts));
                    }
                });
            }
            row.cellCounts.forEach(function (c) {
                if (!c) {
                    return;
                }
                if (c.moldCounts) {
                    moldNumbers = moldNumbers.concat(Object.keys(c.moldCounts));
                }
                else if (c.length > 0) {
                    c.forEach(function (count) {
                        if (count.moldCounts) {
                            moldNumbers = moldNumbers.concat(Object.keys(count.moldCounts));
                        }
                    });
                }
            });
            return _.uniq(moldNumbers).map(function (x) { return parseInt(x, 10); });
        }
        function idsMatch(ids1, ids2) {
            return ids1 && ids2 && _.xor(ids1, ids2).length === 0;
        }
        function setRowCountFromParent(row) {
            if (!row.parent.cells) {
                row.count = defaultCount;
            }
            var rowCountCell = _.find(row.parent.cells, function (c) {
                return (row.inspectDataPointId && c.dataPointId === row.inspectDataPointId)
                    || idsMatch(row.inspectDataPointIds, c.dataPointIds);
            });
            if (rowCountCell) {
                row.count = rowCountCell.count;
            }
            else {
                row.count = defaultCount;
            }
        }
        function createRowRows(row, tab, lineCounts, counts, rawCounts, countsInterval, shopConfig) {
            if (row.parent.cells) {
                setRowCountFromParent(row);
            }
            else {
                if (row.inspectDataPointIds) {
                    var inspectCounts = row.inspectDataPointIds.map(function (id) { return getOrCreateEquipmentCounts(lineCounts, false, counts, rawCounts, id, countsInterval, shopConfig, null, false, false, row.isMold || row.isMNR || row.parent.isMold); });
                    row.count = createAggregateCount(lineCounts, false, inspectCounts);
                }
                else {
                    row.count = getOrCreateEquipmentCounts(lineCounts, false, counts, rawCounts, row.inspectDataPointId, countsInterval, shopConfig, null, false, false, row.isMold || row.isMNR || row.parent.isMold);
                }
            }
            row.cellCounts = getCellCounts(row, tab, lineCounts, counts, rawCounts, countsInterval, shopConfig);
            row.setRowsUpdateNeeded = function () { return setRowsUpdateNeeded(row); };
            setRowNameAndId(row);
            var rowRows = [row];
            if (row.isMold && row.mold === null) {
                var moldNumbers = getRowMoldNumbers(row);
                if (moldNumbers.length > 0) {
                    moldNumbers.forEach(function (mold) {
                        var moldRow = createMoldRow(row, lineCounts, mold);
                        rowRows.push(moldRow);
                    });
                }
            }
            rowRows.forEach(function (rowRow) { return populateRow(rowRow, tab, lineCounts, counts, rawCounts, countsInterval, shopConfig); });
            return rowRows;
        }
        function cellsHaveMNR(row) {
            return _.some(row.cells, function (x) { return x.count && x.count.count > 0; });
        }
        function rowHasMNR(row, childRows) {
            if (row.isMNR) {
                return cellsHaveMNR(row);
            }
            if (childRows.length === 0) {
                return false;
            }
            var mnrChildRow = _.find(childRows, function (x) { return x.isMNR; });
            if (!mnrChildRow) {
                return false;
            }
            return cellsHaveMNR(mnrChildRow);
        }
        function getRowOrder(r) {
            var order = r.order * 1000000;
            if (r.orderByCellIndex === null
                || r.cells.length <= r.orderByCellIndex) {
                if (r.isMold && r.mold > 0) {
                    order += r.mold;
                }
                return order;
            }
            var count = r.cells[r.orderByCellIndex].count;
            if (!count) {
                return order;
            }
            if (r.orderByCellIndexDescending) {
                return order - count.count;
            }
            return order + count.count;
        }
        function setSortOrder(row) {
            row.sortOrder = getRowOrder(row);
        }
        function sortRows(rows) {
            return _.sortBy(rows, 'sortOrder');
        }
        function updateRow(row, lineCounts, tab) {
            var rowRows = [];
            if (row.isSpacer) {
                setSortOrder(row);
                return [row];
            }
            if (row.parent.expandedChildren == null || row.parent.expandedChildren.filter == null) {
                return;
            }
            var expandedRows = row.parent.expandedChildren.filter(function (c) {
                return ((!row.inspectDataPointId && !c.inspectDataPointId)
                    || (row.inspectDataPointId && c.inspectDataPointId === row.inspectDataPointId)
                    || idsMatch(row.inspectDataPointIds, c.inspectDataPointIds))
                    && ((row.isMold && c.isMold) || c.name === row.name);
            });
            if (row.isMold && row.mold === null) {
                var noMoldRow_1 = expandedRows[0];
                var moldNumbers = getRowMoldNumbers(noMoldRow_1);
                moldNumbers.forEach(function (mold) {
                    var moldRow = _.find(expandedRows, { mold: mold });
                    if (!moldRow) {
                        moldRow = createMoldRow(noMoldRow_1, lineCounts, mold);
                        expandedRows.push(moldRow);
                        row.parent.expandedChildren.push(moldRow);
                    }
                });
                var toRemove = _.xor(moldNumbers, expandedRows.filter(function (x) { return x.mold !== null; }).map(function (x) { return x.mold; }));
                toRemove.forEach(function (mold) {
                    var removeRow = _.remove(expandedRows, { mold: mold });
                    _.remove(row.parent.expandedChildren, removeRow);
                });
            }
            if (row.isMold && row.mold !== null && expandedRows.length === 1) {
                return expandedRows;
            }
            expandedRows.forEach(function (rowRow) {
                if (rowRow.isMold && rowRow.mold === null) {
                    return;
                }
                if (rowRow.count === defaultCount) {
                    setRowCountFromParent(rowRow);
                }
                if (rowRow.count !== defaultCount) {
                    rowRow.cells.forEach(function (cell, c) { return populateCell(cell, rowRow, lineCounts, rowRow.cellCounts[c]); });
                }
                if (rowRow.hideIfCellIndexZero !== null && rowRow.cells.length > rowRow.hideIfCellIndexZero) {
                    var cellCount = rowRow.cells[rowRow.hideIfCellIndexZero].count;
                    if (!cellCount || cellCount.count === 0) {
                        return;
                    }
                }
                if (rowRow.children && !rowRow.expandedChildren) {
                    populateRowChildren(rowRow, tab, lineCounts, tab.counts.counts, null, null, null);
                }
                var childRowRows = [];
                if (rowRow.children) {
                    rowRow.children.forEach(function (childRow) {
                        var childRows = updateRow(childRow, lineCounts, tab);
                        childRowRows.push.apply(childRowRows, childRows);
                    });
                }
                if (rowRow.hasMNR && !rowHasMNR(rowRow, childRowRows)) {
                    return;
                }
                if (childRowRows.length > 0) {
                    rowRow.outputRows = sortRows(childRowRows);
                }
                setSortOrder(rowRow);
                rowRows.push(rowRow);
            });
            return rowRows;
        }
        function createOutputRows(rows) {
            var outputRows = [];
            rows.forEach(function (row) {
                outputRows.push(row);
                if (row.outputRows) {
                    var childOutputRows = createOutputRows(row.outputRows);
                    outputRows.push.apply(outputRows, childOutputRows);
                }
            });
            return outputRows;
        }
        function setOutputRows(tab, outputRows) {
            if (!tab.outputRows || tab.outputRows.length === 0) {
                tab.outputRows = outputRows;
                return;
            }
            var existingIds = tab.outputRows.map(function (x) { return x.id; });
            var newIds = outputRows.map(function (x) { return x.id; });
            var removeIds = _.difference(existingIds, newIds);
            if (removeIds.length > 0) {
                removeIds.forEach(function (id) { return _.remove(tab.outputRows, { id: id }); });
            }
            for (var i = 0; i < outputRows.length; i++) {
                var newRow = outputRows[i];
                var index = _.findIndex(tab.outputRows, { id: newRow.id });
                if (index < 0) {
                    tab.outputRows.splice(i, 0, newRow);
                }
                else if (index !== i) {
                    var row = tab.outputRows.splice(index, 1)[0];
                    tab.outputRows.splice(i, 0, row);
                }
            }
        }
        function updateTabRows(tab, lineCounts) {
            var tabRows = [];
            tab.needsRowUpdate = false;
            tab.rows.forEach(function (row) {
                var rowRows = updateRow(row, lineCounts, tab);
                tabRows.push.apply(tabRows, rowRows);
            });
            tabRows = sortRows(tabRows);
            setOutputRows(tab, createOutputRows(tabRows));
            tab.needsRowUpdate = false;
        }
        function populateTab(counts, tab, lineCounts, rawCounts, countsInterval, shopConfig) {
            var tabChildren = [];
            tab.counts = counts;
            tab.rows.forEach(function (row) {
                row.parent = tab;
                if (row.isSpacer) {
                    setRowNameAndId(row);
                    tabChildren.push(row);
                    return;
                }
                var rowRows = createRowRows(row, tab, lineCounts, counts.counts, rawCounts, countsInterval, shopConfig);
                rowRows.forEach(function (r) { return tabChildren.push(r); });
            });
            tab.expandedChildren = tabChildren;
            tab.updateRows = function () { return updateTabRows(tab, lineCounts); };
            tab.updateRows();
        }
        function populateCounts(equipment, rawCounts, countsInterval, shopConfig, lineCounts) {
            var counts = {};
            equipment.inspectCount = getOrCreateEquipmentCounts(lineCounts, true, counts, rawCounts, equipment.inspectionDataPointId, countsInterval, shopConfig, null, null, null, null, true);
            if (equipment.rejectDataPointId) {
                equipment.rejectCount = getOrCreateEquipmentCounts(lineCounts, true, counts, rawCounts, equipment.rejectDataPointId, countsInterval, shopConfig, equipment.inspectCount, true, true);
                var inspectCount = lineCounts.gobsProduced
                    && lineCounts.countRejectPercent === aps_enums_1.apsEnums.CountRejectPercent.PercentOfGobsProduced
                    ? lineCounts.gobsProduced : equipment.inspectCount;
                addRejectCount(inspectCount, equipment.rejectCount);
            }
            return counts;
        }
        function handleEquipmentCounts(event, counts, equipmentCounts) {
            var updated = false;
            counts.forEach(function (count) {
                var dpCounts = equipmentCounts[count.dataPointId];
                if (!dpCounts) {
                    return;
                }
                dpCounts.forEach(function (c) {
                    updated = c.handleCount(event, count) || updated;
                });
            });
            return updated;
        }
        function handleEquipmentIntervals(event, counts, equipmentCounts) {
            var updated = false;
            counts.forEach(function (count) {
                var dpCounts = equipmentCounts[count.dataPointId];
                if (!dpCounts) {
                    return;
                }
                dpCounts.forEach(function (c) {
                    updated = c.handleInterval(event, count) || updated;
                });
            });
            return updated;
        }
        function updateEquipmentCounts(counts, equipmentCounts, shopConfig) {
            var updated = false;
            var _loop_1 = function (key) {
                equipmentCounts[key].forEach(function (c) {
                    updated = c.updateCounts(counts[key], shopConfig) || updated;
                });
            };
            for (var key in equipmentCounts) {
                _loop_1(key);
            }
            return updated;
        }
        function handleEquipmentIntervalChanged(changedInterval, counts) {
            for (var dataPointId in counts) {
                var equipCounts = counts[dataPointId];
                equipCounts.forEach(function (count) {
                    count.countsInterval = changedInterval;
                    count.calculateCount();
                });
            }
        }
        function setHealthCssClasses(equipment) {
            var cssPrefix;
            var cssLinePrefix;
            if (equipment.equipmentHealthState) {
                var stateName = aps_enums_1.apsEnums.EquipmentHealthState[equipment.equipmentHealthState].toLowerCase();
                var lineStateName = equipment.equipmentHealthState === aps_enums_1.apsEnums.EquipmentHealthState.Good
                    && equipment.hasInconsistentConfiguration
                    ? aps_enums_1.apsEnums.EquipmentHealthState[aps_enums_1.apsEnums.EquipmentHealthState.Warning].toLowerCase()
                    : stateName;
                cssPrefix = 'equip-status-' + stateName + '-';
                cssLinePrefix = 'equip-status-' + lineStateName + '-';
            }
            else {
                cssPrefix = 'equip-status-unknown-';
                cssLinePrefix = 'equip-status-unknown-';
            }
            equipment.lineHealthCssBox = cssLinePrefix + 'box';
            equipment.healthCssBox = cssPrefix + 'box';
            equipment.healthCssText = cssPrefix + 'text';
        }
        function handleInconsistencyChanged(event, equipment) {
            var type = equipmentService.getLineEquipmentType(event.equipmentType);
            if (!type) {
                return;
            }
            for (var id in equipment) {
                if (equipment[id].type === type) {
                    equipment[id].hasInconsistentConfiguration = event.isDetected;
                    setHealthCssClasses(equipment[id]);
                }
            }
        }
        function setEquipment(equipment, rawCounts, countsInterval, line, inconsistencies, lineCounts) {
            equipment.line = line;
            equipment.counts = populateCounts(equipment, rawCounts, countsInterval, lineCounts.shopConfig, lineCounts);
            equipment.hasInconsistentConfiguration = _.some(inconsistencies, function (i) { return i === equipment.equipmentType; });
            setHealthCssClasses(equipment);
            equipment.handleCount = function (event, counts) {
                return handleEquipmentCounts(event, counts, equipment.counts);
            };
            equipment.handleInterval = function (event, counts) {
                return handleEquipmentIntervals(event, counts, equipment.counts);
            };
            equipment.handleEquipmentHealthUpdate = function (event) {
                equipment.equipmentHealthState = event.equipmentHealthState;
                equipment.equipmentLastHealthStateUpdate = event.eventDate;
                equipment.equipmentHealthStateDetail = event.detail;
                setHealthCssClasses(equipment);
            };
            equipment.updateCounts = function (counts, shopConfig) {
                return updateEquipmentCounts(counts, equipment.counts, shopConfig);
            };
            equipment.handleIntervalChange = function (changedInterval) {
                handleEquipmentIntervalChanged(changedInterval, equipment.counts);
            };
        }
        function populateEquipment(lineCounts, rawCounts, countsInterval, canDisable, inconsistencies) {
            var equipments = {};
            lineCounts.lines.forEach(function (line) {
                if (!canDisable) {
                    line.equipment = _.filter(line.equipment, { isDisabled: false });
                }
                line.equipment = _.sortBy(line.equipment, 'order');
                line.equipment.forEach(function (equipment) {
                    setEquipment(equipment, rawCounts, countsInterval, line, inconsistencies, lineCounts);
                    equipments[equipment.id] = equipment;
                });
            });
            return equipments;
        }
        function updateRows(tabs) {
            tabs.filter(function (t) { return t.needsRowUpdate; }).forEach(function (t) { return t.updateRows(); });
        }
        function createLineEquipmentDetails(model, lineCounts, equipmentCounts, details, rawCounts, countsInterval, equipment, group) {
            model.details = [];
            var groupedDetails = _.groupBy(details, 'name');
            var _loop_2 = function (name_1) {
                var points = groupedDetails[name_1];
                var point = points[0];
                var order = point.order;
                var hasInspect = point.type === aps_enums_1.apsEnums.DataPointType.Reject;
                var inspectCount = hasInspect ? (group ? group.inspectCount : equipment.inspectCount) : null;
                var count = void 0;
                var counts = points.map(function (p) {
                    return getOrCreateEquipmentCounts(lineCounts, true, equipmentCounts, rawCounts, p.dataPointId, countsInterval, lineCounts.shopConfig, inspectCount, hasInspect, hasInspect);
                });
                if (counts.length === 1) {
                    count = counts[0];
                }
                else {
                    count = createAggregateCount(lineCounts, true, counts, null, null, hasInspect, hasInspect, inspectCount);
                    order = _.max(_.map(points, 'order'));
                }
                model.details.push({ name: name_1, count: count, order: order });
            };
            for (var name_1 in groupedDetails) {
                _loop_2(name_1);
            }
            model.details = _.sortBy(model.details, ['order', 'name']);
        }
        function createLineEquipmentCounts(tabs, lineCounts, details, rawCounts, countsInterval, equipment, group) {
            var equipmentTabs = tabs;
            var equipmentCounts = {};
            var lineEquipmentIds = equipment ? [equipment.id] : Object.keys(group.equipment);
            var model = {
                tabs: equipmentTabs,
                details: null,
                counts: equipmentCounts,
                onUpdated: [],
                handleCount: null,
                handleInterval: null,
                updateCounts: null,
                handleIntervalChange: null,
                equipment: equipment,
                group: group
            };
            if (equipmentTabs) {
                equipmentTabs.forEach(function (tab) { return populateTab(model, tab, lineCounts, rawCounts, countsInterval, lineCounts.shopConfig); });
            }
            if (details && details.length > 0) {
                createLineEquipmentDetails(model, lineCounts, equipmentCounts, details, rawCounts, countsInterval, equipment, group);
            }
            var handleUpdate = function () {
                if (model.onUpdated.length > 0) {
                    model.onUpdated.forEach(function (f) { return f(); });
                }
            };
            model.handleCount = function (event, counts) {
                counts = counts.filter(function (c) { return _.some(lineEquipmentIds, function (id) { return c.lineEquipmentId === id; }); });
                if (counts.length === 0) {
                    return false;
                }
                if (handleEquipmentCounts(event, counts, equipmentCounts)) {
                    if (equipmentTabs) {
                        updateRows(equipmentTabs);
                    }
                    handleUpdate();
                    return true;
                }
                return false;
            };
            model.handleInterval = function (event, counts) {
                counts = counts.filter(function (c) { return _.some(lineEquipmentIds, function (id) { return c.lineEquipmentId === id; }); });
                if (counts.length === 0) {
                    return false;
                }
                if (handleEquipmentIntervals(event, counts, equipmentCounts)) {
                    if (equipmentTabs) {
                        updateRows(equipmentTabs);
                    }
                    handleUpdate();
                    return true;
                }
                return false;
            };
            model.updateCounts = function (counts, shopConfig) {
                if (updateEquipmentCounts(counts, equipmentCounts, shopConfig)) {
                    handleUpdate();
                    return true;
                }
                return false;
            };
            model.handleIntervalChange = function (changedInterval) {
                handleEquipmentIntervalChanged(changedInterval, equipmentCounts);
                handleUpdate();
            };
            return model;
        }
        function createEquipmentGroup(id, name, type) {
            return {
                lineEquipmentNameIds: [id],
                types: [type],
                names: [name],
                name: name,
                equipment: {},
                inspectCount: null,
                hasRejects: false,
                lineLineEquipmentTabs: null,
                lineStartJunctionId: null
            };
        }
        function populateEquipmentGroups(lineCounts) {
            var groups = [];
            Object.keys(lineCounts.equipment).forEach(function (key) {
                var e = lineCounts.equipment[key];
                var group = _.find(groups, function (x) { return _.some(x.lineEquipmentNameIds, function (id) { return id === e.lineEquipmentNameId; }); });
                if (!group
                    && (e.type === aps_enums_1.apsEnums.LineEquipmentType.CheckDetector
                        || e.type === aps_enums_1.apsEnums.LineEquipmentType.HEYE)) {
                    if (e.type === aps_enums_1.apsEnums.LineEquipmentType.CheckDetector) {
                        group = _.find(groups, function (x) { return _.some(x.types, function (t) { return t === aps_enums_1.apsEnums.LineEquipmentType.HEYE; }); });
                    }
                    else if (e.type === aps_enums_1.apsEnums.LineEquipmentType.HEYE) {
                        group = _.find(groups, function (x) { return _.some(x.types, function (t) { return t === aps_enums_1.apsEnums.LineEquipmentType.CheckDetector; }); });
                    }
                    if (group) {
                        group.lineEquipmentNameIds.push(e.lineEquipmentNameId);
                        group.types.push(e.type);
                        group.names.push(e.name);
                        group.name = group.name + '/' + e.name;
                    }
                }
                if (!group) {
                    group = createEquipmentGroup(e.lineEquipmentNameId, e.name, e.type);
                    groups.push(group);
                }
                group.equipment[e.id] = e;
            });
            groups.forEach(function (group) {
                var inspectCounts = [];
                var rejectCounts = [];
                for (var key in group.equipment) {
                    var equipment = group.equipment[key];
                    inspectCounts.push(equipment.inspectCount);
                    if (equipment.rejectDataPointId) {
                        rejectCounts.push(equipment.rejectCount);
                    }
                }
                if (inspectCounts.length === 1) {
                    group.inspectCount = inspectCounts[0];
                }
                else {
                    group.inspectCount = createAggregateCount(lineCounts, false, inspectCounts);
                }
                if (rejectCounts.length > 0) {
                    group.hasRejects = true;
                    if (rejectCounts.length === 1) {
                        group.rejectCount = rejectCounts[0];
                    }
                    else {
                        group.rejectCount = createAggregateCount(lineCounts, true, rejectCounts, null, null, true, true, (lineCounts.isCalcGroupByShears) ? lineCounts.gobsProduced : group.inspectCount);
                    }
                    var inspectCount = lineCounts.gobsProduced
                        && lineCounts.countRejectPercent === aps_enums_1.apsEnums.CountRejectPercent.PercentOfGobsProduced
                        ? lineCounts.gobsProduced : group.inspectCount;
                    addRejectCount(inspectCount, group.rejectCount);
                    if (group.rejectCount && lineCounts.isCalcGroupByShears && group.rejectCount && lineCounts.gobsProduced) {
                        group.rejectCount.percent = calcPercentStrTwoDecimals(group.rejectCount.count, lineCounts.gobsProduced.count);
                    }
                }
            });
            return groups;
        }
        function populateEquipmentGroupsV1(lineCounts) {
            var groups = [];
            var aieGroups = [];
            var aieFirst;
            Object.keys(lineCounts.equipment).forEach(function (key) {
                var e = lineCounts.equipment[key];
                var group = _.find(groups, function (x) { return _.some(x.lineEquipmentNameIds, function (id) { return id === e.lineEquipmentNameId; }); });
                if (!group
                    && (e.type === aps_enums_1.apsEnums.LineEquipmentType.CheckDetector
                        || e.type === aps_enums_1.apsEnums.LineEquipmentType.HEYE)) {
                    if (e.type === aps_enums_1.apsEnums.LineEquipmentType.CheckDetector) {
                        group = _.find(groups, function (x) { return _.some(x.types, function (t) { return t === aps_enums_1.apsEnums.LineEquipmentType.HEYE; }); });
                    }
                    else if (e.type === aps_enums_1.apsEnums.LineEquipmentType.HEYE) {
                        group = _.find(groups, function (x) { return _.some(x.types, function (t) { return t === aps_enums_1.apsEnums.LineEquipmentType.CheckDetector; }); });
                    }
                    if (group) {
                        group.lineEquipmentNameIds.push(e.lineEquipmentNameId);
                        group.types.push(e.type);
                        group.names.push(e.name);
                        group.name = group.name + '/' + e.name;
                    }
                }
                if (!group) {
                    group = createEquipmentGroup(e.lineEquipmentNameId, e.name, e.type);
                    if (e.inspectionDataPointId == lineCounts.heInId) {
                        group.name = 'HE';
                        group.order = 1;
                        group.kpiName = group.name;
                        groups.push(group);
                    }
                    else if (e.inspectionDataPointId == lineCounts.lehrInId) {
                        group.name = 'LEHR';
                        group.order = 2;
                        group.kpiName = group.name;
                        groups.push(group);
                    }
                    else if (e.inspectionDataPointId == lineCounts.packedCountId) {
                        group.name = 'PACK';
                        group.order = 5;
                        group.kpiName = group.name;
                        groups.push(group);
                    }
                    else {
                        if (e.type === aps_enums_1.apsEnums.LineEquipmentType.InspectReject ||
                            e.type === aps_enums_1.apsEnums.LineEquipmentType.WSI ||
                            e.type === aps_enums_1.apsEnums.LineEquipmentType.WBF ||
                            e.type === aps_enums_1.apsEnums.LineEquipmentType.HEYE ||
                            e.type === aps_enums_1.apsEnums.LineEquipmentType.CheckDetector ||
                            e.type === aps_enums_1.apsEnums.LineEquipmentType.MX4 ||
                            e.type === aps_enums_1.apsEnums.LineEquipmentType.Multi ||
                            e.type === aps_enums_1.apsEnums.LineEquipmentType.Mcal ||
                            e.type === aps_enums_1.apsEnums.LineEquipmentType.FlexBC ||
                            e.type === aps_enums_1.apsEnums.LineEquipmentType.FlexM) {
                            aieGroups.push(group);
                            if (!aieFirst && e.inspectionDataPointId == lineCounts.firstInspectionId) {
                                aieFirst = group;
                                group.name = 'AIE';
                                group.order = 3;
                                group.kpiName = group.name;
                                group.lineStartJunctionId = e.line.startJunctionId;
                                groups.push(aieFirst);
                                var aieOther = createEquipmentGroup(-1, 'CE DELTA', aps_enums_1.apsEnums.LineEquipmentType.InspectReject);
                                aieOther.kpiName = aieOther.name;
                                aieOther.order = 4;
                                groups.push(aieOther);
                            }
                        }
                    }
                }
                group.equipment[e.id] = e;
            });
            groups.forEach(function (group) {
                var inspectCounts = [];
                var rejectCounts = [];
                for (var key in group.equipment) {
                    var equipment = group.equipment[key];
                    inspectCounts.push(equipment.inspectCount);
                    if (equipment.rejectDataPointId) {
                        rejectCounts.push(equipment.rejectCount);
                    }
                }
                if (inspectCounts.length === 1) {
                    group.inspectCount = inspectCounts[0];
                }
                else {
                    group.inspectCount = createAggregateCount(lineCounts, false, inspectCounts);
                }
                if (rejectCounts.length > 0) {
                    group.hasRejects = true;
                    if (rejectCounts.length === 1) {
                        group.rejectCount = rejectCounts[0];
                    }
                    else {
                        group.rejectCount = createAggregateCount(lineCounts, true, rejectCounts, null, null, true, true, group.inspectCount);
                    }
                    var inspectCount = lineCounts.gobsProduced
                        && lineCounts.countRejectPercent === aps_enums_1.apsEnums.CountRejectPercent.PercentOfGobsProduced
                        ? lineCounts.gobsProduced : group.inspectCount;
                    addRejectCount(inspectCount, group.rejectCount);
                }
            });
            populateAieGroup(lineCounts, aieGroups, aieFirst);
            return groups;
        }
        function populateAieGroup(lineCounts, aieGroups, aieFirst) {
            var inspectCounts1 = [];
            var rejectCounts1 = [];
            if (aieFirst) {
                aieGroups.forEach(function (group) {
                    for (var key in group.equipment) {
                        var equipment = group.equipment[key];
                        if (aieFirst.lineStartJunctionId && aieFirst.lineStartJunctionId === equipment.line.startJunctionId && equipment.order === 1) {
                            inspectCounts1.push(equipment.inspectCount);
                        }
                        if (equipment.rejectDataPointId) {
                            rejectCounts1.push(equipment.rejectCount);
                        }
                    }
                    if (inspectCounts1.length === 1) {
                        group.inspectCount = inspectCounts1[0];
                    }
                    else {
                        group.inspectCount = createAggregateCount(lineCounts, false, inspectCounts1);
                    }
                    if (rejectCounts1.length > 0) {
                        group.hasRejects = true;
                        if (rejectCounts1.length === 1) {
                            group.rejectCount = rejectCounts1[0];
                        }
                        else {
                            group.rejectCount = createAggregateCount(lineCounts, true, rejectCounts1, null, null, true, true, group.inspectCount);
                        }
                        var inspectCount = group.inspectCount;
                        addRejectCount(inspectCount, group.rejectCount);
                    }
                });
                aieFirst.inspectCount = createAggregateCount(lineCounts, false, inspectCounts1);
                aieFirst.rejectCount = createAggregateCount(lineCounts, false, rejectCounts1);
            }
        }
        function reCalcGroupPercents(lineCounts) {
            var groups = lineCounts.equipmentGroupsV1;
            var he = _.find(groups, function (x) { return x.name === 'HE'; });
            var lehr = _.find(groups, function (x) { return x.name === 'LEHR'; });
            var aie = _.find(groups, function (x) { return x.name === 'AIE'; });
            var aieOther = _.find(groups, function (x) { return x.name === 'CE DELTA'; });
            var ptp = _.find(groups, function (x) { return x.name === 'PACK'; });
            if (he && lehr && aie && ptp) {
                var shears = (he != null && he.inspectCount != null && he.inspectCount.count != null) ? he.inspectCount.count : 0;
                var heReject = (he != null && he.rejectCount != null && he.rejectCount.count != null) ? he.rejectCount.count : 0;
                var lehrIn = (lehr != null && lehr.inspectCount != null && lehr.inspectCount != null) ? lehr.inspectCount.count : 0;
                var lehrOut = (aie != null && aie.inspectCount != null && aie.inspectCount.count != null) ? aie.inspectCount.count : 0;
                var ceReject = (aie != null && aie.rejectCount != null && aie.rejectCount.count != null) ? aie.rejectCount.count : 0;
                var eol = (ptp != null && ptp.inspectCount != null && ptp.inspectCount.count != null) ? ptp.inspectCount.count : 0;
                var heOut = shears - heReject || 0;
                he.inspectCount.percent = calcPercentStr(heOut, shears);
                he.rejectCount.percent = calcPercentFromOneStr(heOut, shears);
                he.wareLossPercent = calcPercentFromOneStr(lehrIn, shears);
                he.efficiencyAgainstShears = calcPercentStr(lehrIn, shears);
                var lehrReject = lehrIn - lehrOut;
                lehr.inspectCount.percent = calcPercentStr(lehrOut, lehrIn);
                lehr.rejectCount.percent = calcPercentFromOneStr(lehrOut, lehrIn);
                lehr.rejectCount.count = lehrReject;
                lehr.wareLossPercent = calcPercentStr(lehrReject, shears);
                lehr.efficiencyAgainstShears = calcPercentStr(lehrOut, shears);
                aie.inspectCount.percent = calcPercentFromOneStr(ceReject, lehrOut);
                aie.rejectCount.percent = calcPercentStr(ceReject, lehrOut);
                aie.wareLossPercent = calcPercentStr(ceReject, shears);
                var cdDelta = (lehrOut - ceReject - eol);
                var tmpRejectCount_1 = {
                    count: cdDelta,
                    percent: calcPercentStr(cdDelta, lehrOut),
                    trend: { flat: true },
                    rejectPercentDecimals: 2,
                    lineCounts: null,
                    getPercent: null
                };
                tmpRejectCount_1.getPercent = function () { return tmpRejectCount_1.percent; };
                aieOther.hasRejects = true;
                aieOther.rejectCount = tmpRejectCount_1;
                aieOther.inspectCount = null;
                aieOther.wareLossPercent = calcPercentStr(cdDelta, shears);
                ptp.inspectCount.percent = calcPercentStr(eol, shears);
                ptp.wareLossPercent = calcPercentFromOneStr(eol, shears);
                ptp.efficiencyAgainstShears = calcPercentStr(eol, shears);
                lineCounts.kpisV1.forEach(function (kp) { return kp.recalculate(); });
            }
        }
        function recalculateKpis(lineCounts) {
            lineCounts.kpis.forEach(function (kp) { return kp.recalculate(); });
            if (lineCounts && lineCounts.isV2) {
                reCalcGroupPercents(lineCounts);
            }
        }
        function createShopCounts(lineCounts, shopCounts, shopCountsById, rawCounts, shopConfig, type, dataPointId, countsInterval, showSpeed) {
            var dpCount = createCounts(lineCounts, false, dataPointId, rawCounts[dataPointId], countsInterval, shopConfig, null, null, null, null, showSpeed);
            shopCounts[type] = dpCount;
            shopCountsById[dataPointId] = dpCount;
            if (showSpeed) {
                lineCounts.gobsProduced = dpCount;
            }
            if (type === aps_enums_1.apsEnums.WellKnownCheckType.PackedCount) {
                lineCounts.packedCount = dpCount;
            }
        }
        function createLineCounts(shopLines, rawCounts, plant, countsInterval, canDisable, shopConfig, isCountsV2, calcGroupByShears) {
            var lineCounts = {
                lines: shopLines.lines,
                junctions: shopLines.junctions,
                wellKnownMeasures: shopLines.wellKnownMeasures,
                inconsistentEquipmentConfigurations: shopLines.inconsistentEquipmentConfigurations,
                countRejectPercent: plant.countRejectPercent,
                shopConfig: shopConfig,
                equipmentGroups: [],
                equipmentGroupsV1: [],
                equipment: {},
                kpis: [],
                kpisV1: [],
                gobsProduced: null,
                packedCount: null,
                handleInterval: null,
                handleCount: null,
                handleEquipmentHealthUpdate: null,
                updateCounts: null,
                handleIntervalChange: null,
                handleInconsistencyChanged: null,
                kpiCalculations: [],
                heInId: null,
                lehrInId: null,
                packedCountId: null,
                firstInspectionId: null,
                isV2: isCountsV2,
                isCalcGroupByShears: calcGroupByShears,
                usePercentGobs: plant.countRejectPercent === aps_enums_1.apsEnums.CountRejectPercent.PercentOfGobsProduced
            };
            if (!canDisable) {
                lineCounts.lines = lineCounts.lines.filter(function (x) { return !x.isDisabled; });
            }
            lineCounts.junctions.forEach(function (junction) {
                junction.inputs = lineCounts.lines.filter(function (line) { return line.endJunctionId === junction.id; });
                junction.inputs.forEach(function (line) { return line.endJunction = junction; });
                junction.outputs = lineCounts.lines.filter(function (line) { return line.startJunctionId === junction.id; });
                junction.outputs.forEach(function (line) { return line.startJunction = junction; });
            });
            var shopCounts = {};
            var shopCountsById = {};
            var checkTypes = [aps_enums_1.apsEnums.WellKnownCheckType.GobsProduced,
                aps_enums_1.apsEnums.WellKnownCheckType.LehrInput,
                aps_enums_1.apsEnums.WellKnownCheckType.PackedCount,
                aps_enums_1.apsEnums.WellKnownCheckType.LehrOutput,
                aps_enums_1.apsEnums.WellKnownCheckType.ColdEndInspectionLoss,
                aps_enums_1.apsEnums.WellKnownCheckType.ColdEndTotalLoss
            ];
            checkTypes.forEach(function (ct) {
                var dataPoint = _.find(shopLines.wellKnownMeasures, { type: ct });
                if (!dataPoint) {
                    return;
                }
                createShopCounts(lineCounts, shopCounts, shopCountsById, rawCounts, shopConfig, ct, dataPoint.dataPointId, countsInterval, ct === aps_enums_1.apsEnums.WellKnownCheckType.GobsProduced);
                if (ct === aps_enums_1.apsEnums.WellKnownCheckType.GobsProduced) {
                    lineCounts.heInId = dataPoint.dataPointId;
                }
                if (ct === aps_enums_1.apsEnums.WellKnownCheckType.LehrInput) {
                    lineCounts.lehrInId = dataPoint.dataPointId;
                }
                if (ct === aps_enums_1.apsEnums.WellKnownCheckType.PackedCount) {
                    lineCounts.packedCountId = dataPoint.dataPointId;
                }
                if (ct === aps_enums_1.apsEnums.WellKnownCheckType.LehrOutput) {
                    lineCounts.firstInspectionId = dataPoint.dataPointId;
                }
            });
            kpiPairs.forEach(function (kp) {
                var numerator = shopCounts[kp.numerator];
                var denominator = shopCounts[kp.denominator];
                if (!numerator || !denominator) {
                    return;
                }
                var newKpi = {
                    numerator: numerator,
                    denominator: denominator,
                    efficiency: null,
                    lossPercent: null,
                    losses: null,
                    efficiencyName: kp.efficiency,
                    efficiencyFormula: null,
                    lossesName: kp.losses,
                    recalculate: null
                };
                numerator.countsUpdated[kp.efficiency] = true;
                denominator.countsUpdated[kp.efficiency] = true;
                newKpi.recalculate = function () {
                    if (!numerator.countsUpdated[newKpi.efficiencyName] || !denominator.countsUpdated[newKpi.efficiencyName]) {
                        return;
                    }
                    numerator.countsUpdated[newKpi.efficiencyName] = false;
                    denominator.countsUpdated[newKpi.efficiencyName] = false;
                    newKpi.efficiency = calcEfficiency(numerator, denominator);
                    newKpi.losses = calcLosses(numerator, denominator);
                    newKpi.lossPercent = calcLossPercent(newKpi.losses, denominator);
                };
                newKpi.recalculate();
                lineCounts.kpis.push(newKpi);
            });
            lineCounts.equipment = populateEquipment(lineCounts, rawCounts, countsInterval, canDisable, shopLines.inconsistentEquipmentConfigurations);
            lineCounts.equipmentGroups = populateEquipmentGroups(lineCounts);
            if (lineCounts.isV2) {
                lineCounts.equipmentGroupsV1 = populateEquipmentGroupsV1(lineCounts);
                kpiPairsV1.forEach(function (kp) {
                    var numerator = shopCounts[kp.numerator];
                    var denominator = shopCounts[kp.denominator];
                    var kpiV1 = {
                        numerator: numerator,
                        denominator: denominator,
                        efficiency: null,
                        lossPercent: null,
                        losses: null,
                        efficiencyName: kp.efficiencyText,
                        efficiencyFormula: kp.efficiencyFormula,
                        lossesName: kp.lossText,
                        lossesFormula: kp.lossFormula,
                        recalculate: null,
                        name: kp.name,
                        order: kp.order
                    };
                    if (numerator) {
                        numerator.countsUpdated[kp.efficiencyText] = true;
                        denominator.countsUpdated[kp.efficiencyText] = true;
                    }
                    kpiV1.recalculate = function () {
                        var group = _.find(lineCounts.equipmentGroupsV1, function (x) { return x.kpiName === kpiV1.name; });
                        if (numerator) {
                            numerator.countsUpdated[kpiV1.efficiencyName] = false;
                            denominator.countsUpdated[kpiV1.efficiencyName] = false;
                        }
                        if (group) {
                            kpiV1.efficiency = (group.efficiencyAgainstShears || '0.0') + '%';
                            kpiV1.lossPercent = (group.wareLossPercent || '0.0') + '%';
                        }
                    };
                    lineCounts.kpisV1.push(kpiV1);
                });
                reCalcGroupPercents(lineCounts);
            }
            lineCounts.handleCount = function (event) {
                var equipmentIds = Object.keys(lineCounts.equipment);
                var updatedEquipmentIds = {};
                var lineEquipmentIds = _.intersection(equipmentIds, _.uniq(_.map(event.counts, 'lineEquipmentId')));
                var result = false;
                var shopCountsToUpdate = event.counts.filter(function (c) { return !c.lineEquipmentId; });
                shopCountsToUpdate.forEach(function (sc) {
                    if (shopCountsById[sc.dataPointId]) {
                        result = shopCountsById[sc.dataPointId].handleCount(event, sc) || result;
                    }
                });
                lineEquipmentIds.forEach(function (id) {
                    var updated = lineCounts.equipment[id].handleCount(event, event.counts.filter(function (c) { return c.lineEquipmentId === id; }));
                    if (updated) {
                        updatedEquipmentIds[id] = true;
                        result = true;
                    }
                });
                if (lineCounts.currentDetailCounts) {
                    result = lineCounts.currentDetailCounts.handleCount(event, event.counts) || result;
                }
                if (lineCounts.currentGroup
                    && lineCounts.currentGroup.groupUpdated
                    && _.some(Object.keys(lineCounts.currentGroup.equipment), function (key) { return updatedEquipmentIds[key] === true; })) {
                    lineCounts.currentGroup.groupUpdated();
                }
                recalculateKpis(lineCounts);
                return result;
            };
            lineCounts.handleInterval = function (event) {
                var result = false;
                var equipmentIds = Object.keys(lineCounts.equipment);
                var updatedEquipmentIds = {};
                event.buckets.forEach(function (bucket) {
                    var shopCountsToUpdate = bucket.counts.filter(function (c) { return !c.lineEquipmentId; });
                    shopCountsToUpdate.forEach(function (sc) {
                        if (shopCountsById[sc.dataPointId]) {
                            result = shopCountsById[sc.dataPointId].handleInterval(bucket, sc) || result;
                        }
                    });
                    var lineEquipmentIds = _.intersection(equipmentIds, _.uniq(_.map(bucket.counts, 'lineEquipmentId')));
                    lineEquipmentIds.forEach(function (id) {
                        var updated = lineCounts.equipment[id].handleInterval(bucket, bucket.counts.filter(function (c) { return c.lineEquipmentId === id; }));
                        if (updated) {
                            updatedEquipmentIds[id] = true;
                            result = true;
                        }
                    });
                    if (lineCounts.currentDetailCounts) {
                        result = lineCounts.currentDetailCounts.handleInterval(bucket, bucket.counts) || result;
                    }
                    if (lineCounts.currentGroup
                        && lineCounts.currentGroup.groupUpdated
                        && _.some(Object.keys(lineCounts.currentGroup.equipment), function (key) { return updatedEquipmentIds[key] === true; })) {
                        lineCounts.currentGroup.groupUpdated();
                    }
                });
                recalculateKpis(lineCounts);
                return result;
            };
            lineCounts.handleEquipmentHealthUpdate = function (event) {
                var lineEquipmentItem = lineCounts.equipment[event.lineEquipmentId];
                if (lineEquipmentItem) {
                    lineEquipmentItem.handleEquipmentHealthUpdate(event);
                }
            };
            lineCounts.updateCounts = function (counts, shopConfig) {
                var updated = false;
                lineCounts.shopConfig = shopConfig;
                for (var key in shopCounts) {
                    var count = shopCounts[key];
                    updated = count.updateCounts(counts[count.id], shopConfig) || updated;
                }
                lineCounts.lines.forEach(function (line) { return line.equipment.forEach(function (equipment) {
                    updated = equipment.updateCounts(counts, shopConfig) || updated;
                }); });
                recalculateKpis(lineCounts);
                return updated;
            };
            lineCounts.handleIntervalChange = function (changedInterval) {
                for (var key in shopCounts) {
                    var count = shopCounts[key];
                    count.countsInterval = changedInterval;
                    count.calculateCount();
                }
                for (var equipmentId in lineCounts.equipment) {
                    lineCounts.equipment[equipmentId].handleIntervalChange(changedInterval);
                }
                recalculateKpis(lineCounts);
            };
            lineCounts.handleInconsistencyChanged = function (event) {
                handleInconsistencyChanged(event, lineCounts.equipment);
            };
            return lineCounts;
        }
        return {
            createLineCounts: createLineCounts,
            createLineEquipmentCounts: createLineEquipmentCounts
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(37)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, hub_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var TopDefectsHubCreatorImpl = (function () {
        TopDefectsHubCreatorImpl.$inject = ["hubService"];
        function TopDefectsHubCreatorImpl(hubService) {
            this.hubService = hubService;
        }
        TopDefectsHubCreatorImpl.prototype.createTopDefectsHub = function (shopId, onAdd, onRemove) {
            return this.hubService.createHub('topDefects', {
                listeners: {
                    topDefectAdded: function (d) {
                        if (d.shopId !== shopId) {
                            return;
                        }
                        onAdd(d);
                    },
                    topDefectRemoved: function (d) {
                        if (d.shopId !== shopId) {
                            return;
                        }
                        onRemove(d);
                    }
                },
                allowMultipleListeners: true,
                methods: ['leaveGroup', 'joinGroup'],
                postConnect: function (hub) {
                    hub.invokeWithRetry(function () { return hub.joinGroup(shopId); });
                }
            });
        };
        return TopDefectsHubCreatorImpl;
    }());
    exports.default = angular.module('aps.hubs.topDefects', [hub_service_1.default])
        .service('topDefectsHubCreator', TopDefectsHubCreatorImpl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var BatchSummarySvc = (function () {
        BatchSummarySvc.$inject = ["httpService"];
        function BatchSummarySvc(httpService) {
            this.httpService = httpService;
        }
        BatchSummarySvc.prototype.get = function (plantId, tankId, productionDate) {
            return this.httpService.get(constant_module_1.Endpoints.BATCH_SUMMARY, { plantId: plantId, tankId: tankId, productionDate: productionDate });
        };
        BatchSummarySvc.prototype.getDetail = function (id) {
            var uri = constant_module_1.Endpoints.BATCH_SUMMARY + "/" + id;
            return this.httpService.get(uri);
        };
        BatchSummarySvc.prototype.getBinSummaryInfo = function (plantId, tankId, productionDate) {
            return this.httpService.get(constant_module_1.Endpoints.BATCH_SUMMARY_INFO, { plantId: plantId, tankId: tankId, productionDate: productionDate });
        };
        BatchSummarySvc.prototype.add = function (command, tankId) {
            var uri = constant_module_1.Endpoints.BATCH_SUMMARY + "/" + tankId;
            return this.httpService.post(uri, command);
        };
        BatchSummarySvc.prototype.update = function (command, tankId) {
            var uri = constant_module_1.Endpoints.BATCH_SUMMARY + "/" + tankId;
            return this.httpService.put(uri, command);
        };
        BatchSummarySvc.prototype.remove = function (command) {
            return this.httpService.delete(constant_module_1.Endpoints.BATCH_SUMMARY + '/' + command.id);
        };
        return BatchSummarySvc;
    }());
    exports.default = angular
        .module('aps.services.batchSummary', [http_service_1.default])
        .service('batchSummaryService', BatchSummarySvc)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var CheckDetectorDefectMappingSvc = (function () {
        CheckDetectorDefectMappingSvc.$inject = ["httpService"];
        function CheckDetectorDefectMappingSvc(httpService) {
            this.httpService = httpService;
        }
        CheckDetectorDefectMappingSvc.prototype.getCheckDetectorDefectMappings = function () {
            return (this.httpService.get(constant_module_1.Endpoints.CHECK_DETECTOR_DEFECT_MAPPINGS));
        };
        ;
        CheckDetectorDefectMappingSvc.prototype.addCheckDetectorDefectMapping = function (command) {
            return this.httpService.put(constant_module_1.Endpoints.CHECK_DETECTOR_DEFECT_MAPPINGS, command);
        };
        ;
        CheckDetectorDefectMappingSvc.prototype.updateCheckDetectorDefectMapping = function (command) {
            return this.httpService.post(constant_module_1.Endpoints.CHECK_DETECTOR_DEFECT_MAPPINGS, command);
        };
        ;
        return CheckDetectorDefectMappingSvc;
    }());
    exports.default = angular
        .module('aps.services.checkDetector', [http_service_1.default])
        .service('checkDetectorDefectMappingService', CheckDetectorDefectMappingSvc)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(607), __webpack_require__(608)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, gobWeightsGraph_tpl_html_1, gobWeightsGraph_controller_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.directive.gobWeightsGraph', [gobWeightsGraph_controller_1.default])
        .directive('apsGobWeightsGraph', gobWeightsGraphDef)
        .name;
    function gobWeightsGraphDef() {
        return {
            restrict: 'E',
            template: gobWeightsGraph_tpl_html_1.default,
            replace: true,
            controller: 'GobWeightsGraphCtrl',
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                shopId: '=',
                width: '@?',
                height: '@?',
                isScaleButtonVisible: '=?',
                hoursToShow: '=?'
            }
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var GobWeightsServiceImpl = (function () {
        GobWeightsServiceImpl.$inject = ["httpService"];
        function GobWeightsServiceImpl(httpService) {
            this.httpService = httpService;
        }
        GobWeightsServiceImpl.prototype.addWeightComment = function (comment) {
            return this.httpService.post(constant_module_1.Endpoints.GOB_WEIGHT_COMMENT, comment);
        };
        GobWeightsServiceImpl.prototype.getGobWeightHistoryReport = function (shopId, startDate, endDate) {
            return this.httpService.get(constant_module_1.Endpoints.GOB_WEIGHT_HISTORY_REPORT, {
                shopId: shopId,
                startDate: startDate,
                endDate: endDate
            });
        };
        GobWeightsServiceImpl.prototype.deleteGobWeight = function (deleteWeight) {
            return this.httpService.post(constant_module_1.Endpoints.GOB_WEIGHT_DELETE, deleteWeight);
        };
        return GobWeightsServiceImpl;
    }());
    exports.default = angular.module('aps.services.gobWeights', [http_service_1.default])
        .service('gobWeightsService', GobWeightsServiceImpl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(618)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, counts_header_template_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function CountsHeaderDirective() {
        return {
            restrict: 'E',
            template: counts_header_template_html_1.default,
            replace: true,
            scope: {
                navigationUrls: '=',
                countDisplayIntervalOptions: '=',
                countsInterval: '=',
                plant: '=plant',
                shop: '=shop',
            }
        };
    }
    exports.default = angular.module('aps.directive.countsHeader', [])
        .directive('countsHeader', ['btnArray', CountsHeaderDirective])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 303 */
/***/ (function(module, exports) {

// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value: function(predicate) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return undefined.
      return undefined;
    },
    configurable: true,
    writable: true
  });
}

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular
        .module('aps.services.defectClassification', [http_service_1.default])
        .service('defectClassificationService', ["httpService", function (httpService) {
        var getDefectClassifications = function () {
            return httpService.get(constant_module_1.Endpoints.DEFECT_CLASSIFICATION_LIST);
        };
        return {
            getDefectClassifications: getDefectClassifications
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(664), __webpack_require__(665), __webpack_require__(667), __webpack_require__(669), __webpack_require__(671), __webpack_require__(673), __webpack_require__(675), __webpack_require__(677)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, dataPointsSelector_tpl_html_1, heyeDataPoints_directive_1, plcDataPoints_directive_1, flexIsDataPoints_directive_1, raspberryPiDataPoints_directive_1, CounterSimpleDataPoints_directive_1, MonitoringDataPoints_directive_1, cbitDataPoints_directive_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [plcDataPoints_directive_1.default, heyeDataPoints_directive_1.default, raspberryPiDataPoints_directive_1.default, flexIsDataPoints_directive_1.default, CounterSimpleDataPoints_directive_1.default, MonitoringDataPoints_directive_1.default, cbitDataPoints_directive_1.default];
    exports.default = angular.module('aps.controller.dataPointsSelector', requires)
        .directive('apsDataPointsSelector', function () {
        return {
            restrict: 'E',
            template: dataPointsSelector_tpl_html_1.default
        };
    })
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(679), __webpack_require__(680), __webpack_require__(682), __webpack_require__(684), __webpack_require__(686), __webpack_require__(688), __webpack_require__(690), __webpack_require__(692), __webpack_require__(694), __webpack_require__(696), __webpack_require__(698), __webpack_require__(700), __webpack_require__(702), __webpack_require__(704), __webpack_require__(706), __webpack_require__(708)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, configSelector_tpl_html_1, aiServerConfig_directive_1, checkDetectorConfig_directive_1, heyeConfig_directive_1, plcConfig_directive_1, scaleConfig_directive_1, ppcScaleConfig_directive_1, serialConverterConfig_directive_1, wsiConfig_directive_1, raspberryPiConfig_directive_1, tiamaConfig_directive_1, flexInspectConfig_directive_1, lineServerConfig_directive_1, flexIsConfig_directive_1, kepwareCounterConfig_directive_1, sqlCounterConfig_directive_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [
        scaleConfig_directive_1.default,
        plcConfig_directive_1.default,
        heyeConfig_directive_1.default,
        serialConverterConfig_directive_1.default,
        wsiConfig_directive_1.default,
        aiServerConfig_directive_1.default,
        checkDetectorConfig_directive_1.default,
        raspberryPiConfig_directive_1.default,
        tiamaConfig_directive_1.default,
        flexInspectConfig_directive_1.default,
        flexIsConfig_directive_1.default,
        lineServerConfig_directive_1.default,
        kepwareCounterConfig_directive_1.default,
        sqlCounterConfig_directive_1.default,
        ppcScaleConfig_directive_1.default
    ];
    exports.default = angular.module('aps.controller.configSelector', requires)
        .directive('apsConfigSelector', function () {
        return {
            restrict: 'E',
            template: configSelector_tpl_html_1.default
        };
    })
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular
        .module('aps.services.holidays', [http_service_1.default])
        .service('holidaysService', ["httpService", function (httpService) {
        var getHolidays = function (year) {
            return (httpService.get(constant_module_1.Endpoints.HOLIDAYS + '?year=' + year.toString())
                .then(function (data) {
                return data;
            }));
        };
        var addHoliday = function (command) {
            return httpService.put(constant_module_1.Endpoints.HOLIDAYS, command);
        };
        var deleteHoliday = function (command) {
            return httpService.delete(constant_module_1.Endpoints.HOLIDAYS + '/' + command.id);
        };
        return {
            getHolidays: getHolidays,
            addHoliday: addHoliday,
            deleteHoliday: deleteHoliday
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(3), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, constant_module_1, http_service_1) {
    "use strict";
    palletizerService.$inject = ["httpService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular
        .module('aps.services.palletizers', [http_service_1.default])
        .service('palletizerService', palletizerService)
        .name;
    function palletizerService(httpService) {
        function get(plantId) {
            return httpService.get(constant_module_1.Endpoints.PALLETIZERS, { plantId: plantId });
        }
        function add(command) {
            return httpService.post(constant_module_1.Endpoints.PALLETIZERS, command);
        }
        function update(command) {
            return httpService.put(constant_module_1.Endpoints.PALLETIZERS, command);
        }
        function remove(command) {
            return httpService.delete(constant_module_1.Endpoints.PALLETIZERS + '/' + command.id, { plantId: command.plantId });
        }
        return {
            get: get,
            add: add,
            update: update,
            remove: remove
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(9), __webpack_require__(96)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, uiUtility_service_1, Highcharts) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [
        uiUtility_service_1.default
    ];
    var CavityEfficiencySummaryGraphController = (function () {
        CavityEfficiencySummaryGraphController.$inject = ["uiUtilityService"];
        function CavityEfficiencySummaryGraphController(uiUtilityService) {
            var _this = this;
            this.options = {
                chart: {
                    type: 'column'
                },
                title: {
                    text: ''
                },
                subtitle: {
                    text: ''
                },
                accessibility: {
                    announceNewData: {
                        enabled: true
                    }
                },
                xAxis: {
                    type: 'category',
                    title: {
                        text: 'Machine Position'
                    }
                },
                yAxis: {
                    title: {
                        text: 'Passed Inspection / (% Good)'
                    }
                },
                legend: {
                    enabled: false
                },
                credits: {
                    enabled: false
                },
                plotOptions: {
                    series: {
                        borderWidth: 0,
                        dataLabels: {
                            enabled: true,
                            format: '{point.y:.0f}<br />{point.z:.2f}%'
                        }
                    }
                },
                tooltip: {
                    formatter: function () {
                        return 'Cavity: <b>' + this.point.name + '</b><br />Count: <b>'
                            + Highcharts.numberFormat(this.point.y, 0)
                            + '</b><br />Cavity Efficiency: <b>' + Highcharts.numberFormat(this.point.z, 1) + '%</b>';
                    }
                },
                reflow: true,
                series: [],
                click: null
            };
            this.uiUtilityService = uiUtilityService;
            this.options.click = angular.bind(this, function (cavity) {
                if (cavity) {
                    var selectedCavity = _.find(_this.cavities, { cavity: cavity });
                    if (selectedCavity && _this.cavitySelected) {
                        _this.cavitySelected(selectedCavity);
                    }
                }
            });
        }
        CavityEfficiencySummaryGraphController.prototype.setCavities = function (cavities) {
            var _this = this;
            var series = [{
                    name: "Counts",
                    data: this.cavities.map(function (cavity) {
                        var count = cavity.inspectCount - cavity.rejectCount;
                        var cavityEfficiency = (count / cavity.inspectCount) * 100.0;
                        var color = _this.uiUtilityService.getEfficiencyColor(cavityEfficiency);
                        return {
                            name: cavity.cavity,
                            y: count,
                            color: color,
                            z: cavityEfficiency,
                            select: angular.bind(_this, function (cavity) {
                                if (cavity) {
                                    var selectedCavity = _.find(_this.cavities, { cavity: cavity });
                                    if (selectedCavity && _this.cavitySelected) {
                                        _this.cavitySelected(selectedCavity);
                                    }
                                }
                            }),
                            events: {
                                click: function () {
                                    this.select(this.name);
                                }
                            }
                        };
                    })
                }];
            this.options.series = series;
        };
        return CavityEfficiencySummaryGraphController;
    }());
    exports.default = angular.module('aps.controller.cavityEfficiencySummaryGraph', requires)
        .controller('CavityEfficiencySummaryGraphCtrl', CavityEfficiencySummaryGraphController)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, uiUtility_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [uiUtility_service_1.default];
    var CavityCorrelationSummaryGraphController = (function () {
        CavityCorrelationSummaryGraphController.$inject = ["uiUtilityService"];
        function CavityCorrelationSummaryGraphController(uiUtilityService) {
            this.uiUtilityService = uiUtilityService;
        }
        CavityCorrelationSummaryGraphController.prototype.cavityClicked = function (cavityName) {
            var selectedCavity = _.find(this.cavities, { cavity: cavityName });
            if (selectedCavity && this.cavitySelected) {
                this.cavitySelected(selectedCavity);
            }
        };
        CavityCorrelationSummaryGraphController.prototype.setTopDefects = function () {
            var topDefects = [];
            _.forEach(this.cavities, function (cavity) {
                if (cavity.details && cavity.details.length) {
                    var moldList = cavity.moldNumbers.split(',');
                    var firstMoldNumber = Number(moldList[0]) || 0;
                    var cavityDetails = {
                        cavity: cavity.cavity,
                        mold: firstMoldNumber,
                        defect: cavity.details[0].defect,
                        rejectCount: cavity.details[0].rejectCount,
                        inspectCount: cavity.inspectCount,
                        rejectPercent: (cavity.details[0].rejectCount / cavity.inspectCount) * 100
                    };
                    topDefects.push(cavityDetails);
                }
            });
            topDefects = _.orderBy(topDefects, ['rejectCount'], 'desc');
            topDefects = topDefects.slice(0, 5);
            this.topDefects = topDefects;
        };
        CavityCorrelationSummaryGraphController.prototype.setCavities = function () {
            var _this = this;
            this.cavitiesFront = [];
            this.cavitiesMiddle = [];
            this.cavitiesBack = [];
            this.sectionList = [];
            this.cavityMNR = {};
            this.cavityQuestion = {};
            _.forEach(this.cavities, function (cavity) {
                var cavityCorrelationForPercent = (cavity.rejectCount / cavity.inspectCount) * 100.0 || 0.00;
                var color = _this.getCorrelationColor(cavityCorrelationForPercent);
                var section = _this.getCavitySection(cavity.cavity);
                var location = _this.getCavityLocation(cavity.cavity);
                var cavityForList = {
                    'MoldNumbers': _this.getPreviousCavities(cavity.moldNumbers),
                    'MostRecentCavity': _this.getMostRecentCavity(cavity.moldNumbers),
                    'Cavity': cavity.cavity,
                    'Inspect': cavity.inspectCount,
                    'Reject': cavity.rejectCount,
                    'SortValue': cavity.order,
                    'Percent': cavityCorrelationForPercent.toFixed(2) + "%",
                    'Section': section,
                    'Location': location,
                    'Color': color,
                    'TopDefect': _this.getTopDefect(cavity)
                };
                if (cavityForList.Section && _this.sectionList.indexOf(cavityForList.Section) === -1) {
                    _this.sectionList.push(cavityForList.Section);
                }
                if (location === 'F') {
                    _this.cavitiesFront.push(cavityForList);
                }
                else if (location === 'M') {
                    _this.cavitiesMiddle.push(cavityForList);
                }
                else if (location === 'B') {
                    _this.cavitiesBack.push(cavityForList);
                }
                else if (cavity.cavity === 'M+U') {
                    _this.cavityMNR = cavityForList;
                }
                else if (cavity.cavity === '?') {
                    _this.cavityQuestion = cavityForList;
                }
            });
        };
        CavityCorrelationSummaryGraphController.prototype.getPreviousCavities = function (moldNumbers) {
            var separator = ", ";
            if (!moldNumbers || moldNumbers.indexOf(separator) < 0) {
                return "";
            }
            var split = moldNumbers.split(separator);
            split.reverse().pop();
            return split.join(separator) + separator;
        };
        CavityCorrelationSummaryGraphController.prototype.getMostRecentCavity = function (moldNumbers) {
            var mostRecentMold = moldNumbers;
            if (moldNumbers && moldNumbers.length > 0 && moldNumbers.indexOf(", ") > 0) {
                var split = moldNumbers.split(", ");
                return split[0];
            }
            return mostRecentMold;
        };
        CavityCorrelationSummaryGraphController.prototype.getCorrelationColor = function (effeciencyPercent) {
            var color = '000000';
            if (effeciencyPercent || effeciencyPercent === 0.0) {
                color = this.uiUtilityService.getCavityCorrelationColor(effeciencyPercent) + 'A0';
            }
            return color;
        };
        CavityCorrelationSummaryGraphController.prototype.getTopDefect = function (cavity) {
            var topDefect = '';
            if (cavity.details && cavity.details.length) {
                topDefect = cavity.details[0].defect;
            }
            else if (cavity.rejectCount && cavity.details.length === 0) {
                topDefect = 'Unmapped Defect';
            }
            return topDefect;
        };
        CavityCorrelationSummaryGraphController.prototype.getCavityLocation = function (cavity) {
            var location = cavity.charAt(cavity.length - 1);
            if (location === 'F' || location === 'M' || location === 'B') {
                return location;
            }
            return null;
        };
        CavityCorrelationSummaryGraphController.prototype.getCavitySection = function (cavity) {
            var section = parseInt(cavity, 10);
            return section;
        };
        return CavityCorrelationSummaryGraphController;
    }());
    exports.default = angular.module('aps.controller.cavityCorrelationSummaryGraph', requires)
        .controller('CavityCorrelationSummaryGraphCtrl', CavityCorrelationSummaryGraphController)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PlantPerformanceServiceImpl = (function () {
        PlantPerformanceServiceImpl.$inject = ["httpService"];
        function PlantPerformanceServiceImpl(httpService) {
            this.httpService = httpService;
        }
        PlantPerformanceServiceImpl.prototype.getPackChartData = function (location, month) {
            return this.httpService.get(constant_module_1.Endpoints.PACK_CHART_INFO, {
                selectedMonth: month,
                locationId: location.id,
                locationType: location.locationType
            });
        };
        PlantPerformanceServiceImpl.prototype.getSnapshotData = function () {
            return this.httpService.get(constant_module_1.Endpoints.PLANT_PERFORMANCE_SNAPSHOT);
        };
        PlantPerformanceServiceImpl.prototype.getPackProductsInfo = function (location, month) {
            return this.httpService.get(constant_module_1.Endpoints.PACK_PRODUCTS_INFO, {
                selectedMonth: month,
                locationId: location.id,
                locationType: location.locationType
            });
        };
        PlantPerformanceServiceImpl.prototype.getFurnaceChartData = function (location, month) {
            return this.httpService.get(constant_module_1.Endpoints.FURNACE_CHART_INFO, {
                selectedMonth: month,
                locationId: location.id,
                locationType: location.locationType
            });
        };
        PlantPerformanceServiceImpl.prototype.getLineItemHoldsData = function (location, month) {
            return this.httpService.get(constant_module_1.Endpoints.LINE_ITEM_HOLDS_DATA, {
                selectedMonth: month,
                locationId: location.id,
                locationType: location.locationType
            });
        };
        return PlantPerformanceServiceImpl;
    }());
    exports.default = angular
        .module('aps.services.plantPerformance', [http_service_1.default])
        .service('plantPerformanceService', PlantPerformanceServiceImpl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 Highcharts JS v7.2.2 (2020-08-24)

 Solid angular gauge module

 (c) 2010-2019 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(b){"object"===typeof module&&module.exports?(b["default"]=b,module.exports=b): true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(96),__webpack_require__(117)], __WEBPACK_AMD_DEFINE_RESULT__ = (function(k){b(k);b.Highcharts=k;return b}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):b("undefined"!==typeof Highcharts?Highcharts:void 0)})(function(b){function k(b,f,k,m){b.hasOwnProperty(f)||(b[f]=m.apply(null,k))}b=b?b._modules:{};k(b,"modules/solid-gauge.src.js",[b["parts/Globals.js"],b["parts/Utilities.js"]],function(b,f){var k=
f.extend,m=f.isNumber,u=f.pick,v=f.pInt;f=b.wrap;f(b.Renderer.prototype.symbols,"arc",function(a,b,e,d,g,c){a=a(b,e,d,g,c);c.rounded&&(d=((c.r||d)-c.innerR)/2,c=["A",d,d,0,1,1,a[12],a[13]],a.splice.apply(a,[a.length-1,0].concat(["A",d,d,0,1,1,a[1],a[2]])),a.splice.apply(a,[11,3].concat(c)));return a});var w={initDataClasses:function(a){var t=this.chart,e,d=0,g=this.options;this.dataClasses=e=[];a.dataClasses.forEach(function(c,h){c=b.merge(c);e.push(c);c.color||("category"===g.dataClassColor?(h=t.options.colors,
c.color=h[d++],d===h.length&&(d=0)):c.color=b.color(g.minColor).tweenTo(b.color(g.maxColor),h/(a.dataClasses.length-1)))})},initStops:function(a){this.stops=a.stops||[[0,this.options.minColor],[1,this.options.maxColor]];this.stops.forEach(function(a){a.color=b.color(a[1])})},toColor:function(a,b){var e=this.stops,d=this.dataClasses,g;if(d)for(g=d.length;g--;){var c=d[g];var h=c.from;e=c.to;if((void 0===h||a>=h)&&(void 0===e||a<=e)){var t=c.color;b&&(b.dataClass=g);break}}else{this.isLog&&(a=this.val2lin(a));
a=1-(this.max-a)/(this.max-this.min);for(g=e.length;g--&&!(a>e[g][0]););h=e[g]||e[g+1];e=e[g+1]||h;a=1-(e[0]-a)/(e[0]-h[0]||1);t=h.color.tweenTo(e.color,a)}return t}};b.seriesType("solidgauge","gauge",{colorByPoint:!0,dataLabels:{y:0}},{drawLegendSymbol:b.LegendSymbolMixin.drawRectangle,translate:function(){var a=this.yAxis;k(a,w);!a.dataClasses&&a.options.dataClasses&&a.initDataClasses(a.options);a.initStops(a.options);b.seriesTypes.gauge.prototype.translate.call(this)},drawPoints:function(){var a=
this,b=a.yAxis,e=b.center,d=a.options,g=a.chart.renderer,c=d.overshoot,h=m(c)?c/180*Math.PI:0,f;m(d.threshold)&&(f=b.startAngleRad+b.translate(d.threshold,null,null,null,!0));this.thresholdAngleRad=u(f,b.startAngleRad);a.points.forEach(function(c){if(!c.isNull){var f=c.graphic,l=b.startAngleRad+b.translate(c.y,null,null,null,!0),r=v(u(c.options.radius,d.radius,100))*e[2]/200,n=v(u(c.options.innerRadius,d.innerRadius,60))*e[2]/200,p=b.toColor(c.y,c),q=Math.min(b.startAngleRad,b.endAngleRad),m=Math.max(b.startAngleRad,
b.endAngleRad);"none"===p&&(p=c.color||a.color||"none");"none"!==p&&(c.color=p);l=Math.max(q-h,Math.min(m+h,l));!1===d.wrap&&(l=Math.max(q,Math.min(m,l)));q=Math.min(l,a.thresholdAngleRad);l=Math.max(l,a.thresholdAngleRad);l-q>2*Math.PI&&(l=q+2*Math.PI);c.shapeArgs=n={x:e[0],y:e[1],r:r,innerR:n,start:q,end:l,rounded:d.rounded};c.startR=r;f?(r=n.d,f.animate(k({fill:p},n)),r&&(n.d=r)):(c.graphic=f=g.arc(n).attr({fill:p,"sweep-flag":0}).add(a.group),a.chart.styledMode||("square"!==d.linecap&&f.attr({"stroke-linecap":"round",
"stroke-linejoin":"round"}),f.attr({stroke:d.borderColor||"none","stroke-width":d.borderWidth||0})));f&&f.addClass(c.getClassName(),!0)}})},animate:function(a){a||(this.startAngleRad=this.thresholdAngleRad,b.seriesTypes.pie.prototype.animate.call(this,a))}});""});k(b,"masters/modules/solid-gauge.src.js",[],function(){})});
//# sourceMappingURL=solid-gauge.js.map

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c13f4ad3813f0db0aaf225fea38f55bc.png";

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "0c84923bb9c683aa999bbf80a4cda2de.png";

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8c2e43191823f43284168d64f51a62d0.png";

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8842bf0946a9d3e5287d8365a1b68602.png";

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2e6494748fe0bf28221a81292c659a22.png";

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2), __webpack_require__(1), __webpack_require__(27)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, _, moment, enums_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function mapLineToRow(line) {
        return {
            isLine: true,
            line: line,
            junction: null,
            cssClass: null
        };
    }
    exports.mapLineToRow = mapLineToRow;
    function mapJunctionToRow(junction) {
        return {
            isLine: false,
            line: null,
            junction: junction,
            cssClass: 'table' + (junction.inputs.length > junction.outputs.length
                ? junction.inputs.length : junction.outputs.length).toString()
        };
    }
    exports.mapJunctionToRow = mapJunctionToRow;
    function mapModelToAreas(model) {
        var areas = [];
        var area = {
            rows: _.sortBy(model.lines.filter(function (l) { return l.startJunctionId === null; }), function (r) { return r.number; })
                .map(function (l) { return mapLineToRow(l); })
        };
        var _loop_1 = function () {
            areas.push(area);
            var previousLines = area.rows.filter(function (l) { return l.isLine; }).map(function (l) { return l.line; });
            var rows = [];
            area.rows.forEach(function (row) {
                if (!row.isLine) {
                    _.sortBy(row.junction.outputs, function (l) { return l.number; }).forEach(function (line) {
                        rows.push(mapLineToRow(line));
                    });
                    return;
                }
                var junction = row.line.endJunction;
                if (!junction) {
                    return;
                }
                if (_.some(rows, function (r) { return !r.isLine && r.junction === junction; })) {
                    return;
                }
                if (!junction.inputs.every(function (l) { return _.some(previousLines, function (al) { return al.id === l.id; }); })) {
                    rows.push(mapLineToRow(row.line));
                }
                rows.push(mapJunctionToRow(junction));
            });
            area = { rows: rows };
        };
        while (area.rows.length > 0) {
            _loop_1();
        }
        return areas;
    }
    exports.mapModelToAreas = mapModelToAreas;
    function getReportDate(shopConfig, countsInterval) {
        var endDate = moment().toDate();
        var now = moment();
        var remainderMinutes = now.minute() % 10;
        var remainderSeconds = now.second();
        var remainderMilliSeconds = now.millisecond();
        var reportDate = {
            Start: null,
            End: endDate
        };
        switch (countsInterval) {
            case enums_1.apsDisplayEnums.CountDisplayInterval.CurrentHour:
                reportDate.Start = moment().startOf('hour').toDate();
                break;
            case enums_1.apsDisplayEnums.CountDisplayInterval.PreviousHour:
                reportDate.End = moment().startOf('hour').toDate();
                reportDate.Start = moment(reportDate.End).subtract(1, 'hour').toDate();
                break;
            case enums_1.apsDisplayEnums.CountDisplayInterval.CurrentShift:
                reportDate.Start = shopConfig.shiftsInLast24Hours[0].startTime;
                break;
            case enums_1.apsDisplayEnums.CountDisplayInterval.LastShift:
                reportDate.End = shopConfig.shiftsInLast24Hours[1].stopTime;
                reportDate.Start = shopConfig.shiftsInLast24Hours[1].startTime;
                break;
            case enums_1.apsDisplayEnums.CountDisplayInterval.ShiftBeforeLast:
                reportDate.End = shopConfig.shiftsInLast24Hours[2].stopTime;
                reportDate.Start = shopConfig.shiftsInLast24Hours[2].startTime;
                break;
            case enums_1.apsDisplayEnums.CountDisplayInterval.RollingHour:
                reportDate.End = moment(now)
                    .subtract(remainderMinutes, 'minute')
                    .subtract(remainderSeconds, 'second')
                    .subtract(remainderMilliSeconds, 'millisecond')
                    .toDate();
                reportDate.Start = moment(reportDate.End)
                    .subtract(1, 'hour')
                    .toDate();
                break;
            case enums_1.apsDisplayEnums.CountDisplayInterval.LastTwentyMinutes:
                reportDate.End = moment(now)
                    .subtract(remainderMinutes, 'minute')
                    .subtract(remainderSeconds, 'second')
                    .subtract(remainderMilliSeconds, 'millisecond')
                    .toDate();
                reportDate.Start = moment(reportDate.End)
                    .subtract(20, 'minute')
                    .toDate();
                break;
            default:
                reportDate.End = moment().startOf('hour').toDate();
                reportDate.Start = moment(reportDate.End).subtract(1, 'days').toDate();
                break;
        }
        return reportDate;
    }
    exports.getReportDate = getReportDate;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(146), __webpack_require__(3), __webpack_require__(380), __webpack_require__(381), __webpack_require__(43), __webpack_require__(382), __webpack_require__(426), __webpack_require__(443), __webpack_require__(445), __webpack_require__(448), __webpack_require__(920), __webpack_require__(6), __webpack_require__(7), __webpack_require__(282), __webpack_require__(921), __webpack_require__(322), __webpack_require__(1046), __webpack_require__(1057), __webpack_require__(1058), __webpack_require__(303)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, stringToDate_1, constant_module_1, app_tpl_html_1, popups_1, environment_1, index_1, index_2, index_3, loader_directive_1, index_4, http_interceptors_1, notify_service_1, authData_service_1, stateRoles_service_1, material) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    popups_1.default();
    angular.module('aps', [
        'ngAnimate',
        'ngSanitize',
        'ngMessages',
        'ui.router',
        'mm.foundation',
        'angularMoment',
        'react',
        'ngCsv',
        'nvd3',
        'as.sortable',
        'angular-dimple',
        'aps.services.appInsights',
        'textAngular',
        environment_1.default,
        index_1.default,
        index_2.default,
        loader_directive_1.default,
        index_4.default,
        http_interceptors_1.default,
        notify_service_1.default,
        authData_service_1.default,
        stateRoles_service_1.default,
        material,
        index_3.default
    ])
        .run(["$rootScope", "$state", "$stateParams", "$window", "$timeout", "$http", "$q", "$transitions", "environment", "authDataService", "notifyService", "appInsightsService", "stateRolesService", function ($rootScope, $state, $stateParams, $window, $timeout, $http, $q, $transitions, environment, authDataService, notifyService, appInsightsService, stateRolesService) {
        $rootScope.$state = $state;
        $rootScope.$stateParams = $stateParams;
        var checkInterval = 60 * 60 * 1000;
        var promiseProto = Object.getPrototypeOf($q.defer().promise);
        promiseProto.success = function (fn) {
            this.then(function (result) {
                fn(result.data);
            });
            return this;
        };
        promiseProto.error = function (fn) {
            this.then(null, fn);
            return this;
        };
        $transitions.onBefore({}, function (trans) {
            var toState = trans.$to();
            var toParams = trans.params('to');
            if (toState.name === constant_module_1.States.SIGN_IN || toState.name === constant_module_1.States.RESET_PASSWORD) {
                var uri_1 = "v2/#/";
                setTimeout(function () {
                    $window.location.href = uri_1;
                });
                return false;
            }
            var userId = authDataService.getUserId();
            if (!userId && toParams.userId) {
                userId = toParams.userId;
                authDataService.setUserId(toParams.userId);
            }
            var roles = authDataService.getRoles();
            if (!userId || !roles || roles.length === 0) {
                if (!_.find([constant_module_1.States.SIGN_IN, constant_module_1.States.RESET_PASSWORD], toState.name)) {
                    return $state.target(constant_module_1.States.SIGN_IN);
                }
                return;
            }
            if (toState.name === constant_module_1.States.SELECT_ROLE) {
                var uri_2 = "v2/#/auth/select-role?userId=" + userId;
                setTimeout(function () {
                    $window.location.href = uri_2;
                });
                return false;
            }
            if (toState.data && toState.data.v2Uri) {
                var uri_3 = "v2/#/" + toState.data.v2Uri + "?plantId=" + toParams.plantId + "&shopId=" + toParams.shopId + "&userId=" + toParams.userId;
                _.forEach(toState.data.v2Params || [], function (name) {
                    var value = toParams[name];
                    if (value !== undefined && value !== null && value !== '') {
                        uri_3 += "&" + name + "=" + encodeURIComponent(value);
                    }
                });
                setTimeout(function () {
                    $window.location.href = uri_3;
                });
                return;
            }
            var selectedRoleLocation = authDataService.getSelectedRoleLocation();
            if (!stateRolesService.stateRoleRequirementsSatisfied(toState.data)) {
                notifyService.error('Current role not permitted to access requested functionality');
                return false;
            }
            if (!selectedRoleLocation) {
                if (toState.name !== constant_module_1.States.SELECT_ROLE) {
                    return $state.target(constant_module_1.States.SELECT_ROLE, { userId: userId });
                }
            }
        });
        function checkForNewVersion() {
            $http.get('/environment.js?v=' + Date.now(), { cache: "reload" })
                .then(function (data) {
                var newVersion = extractVersion(data.data);
                var currentVersion = localStorage.getItem('appVersion');
                if (newVersion && currentVersion && currentVersion !== newVersion) {
                    if (confirm('A new version is available. Reload to update?')) {
                        localStorage.setItem('appVersion', newVersion);
                        $window.location.reload();
                    }
                }
                else {
                    localStorage.setItem('appVersion', newVersion);
                }
            })
                .catch(function (error) {
                console.error('Error checking version:', error);
            });
        }
        function extractVersion(data) {
            var versionMatch = /"VERSION"\s*:\s*["']([\d.]+)["']/.exec(data);
            return versionMatch ? versionMatch[1] : null;
        }
        checkForNewVersion();
        $timeout(checkForNewVersion, checkInterval);
        appInsightsService.initialize($transitions);
    }])
        .config(["environment", "$stateProvider", "$urlRouterProvider", "$locationProvider", "$compileProvider", "$httpProvider", function (environment, $stateProvider, $urlRouterProvider, $locationProvider, $compileProvider, $httpProvider) {
        if (environment.ENV_TYPE === 'working') {
            $compileProvider.debugInfoEnabled(false);
        }
        $stateProvider
            .state({
            name: constant_module_1.States.ABSTRACT,
            url: '/aps?plantId&shopId&userId',
            abstract: true,
            params: {
                plantId: null,
                shopId: null,
                userId: null
            },
            template: app_tpl_html_1.default
        });
        $stateProvider.state({
            name: constant_module_1.States.DOWNTIME_REPORT_V2,
            url: '/downtime-report',
            data: {
                v2Uri: 'aps/reports/downtime-report'
            }
        });
        $stateProvider.state({
            name: constant_module_1.States.TOOLCHANGE_HISTORY_REPORT,
            url: '/toolchange-report',
            data: {
                v2Uri: 'aps/reports/toolchange-report'
            }
        });
        $stateProvider.state({
            name: constant_module_1.States.HOTENDBONUS_REPORT_V2,
            url: '/hotendbonus-report',
            data: {
                v2Uri: 'aps/reports/hotendbonus-report'
            }
        });
        $stateProvider.state({
            name: constant_module_1.States.SHOP_COUNT_SUMMARY_V2,
            url: '/shop-count-summary',
            data: {
                v2Uri: 'aps/reports/shop-count-summary'
            }
        });
        var transformResponse = $httpProvider.defaults.transformResponse;
        transformResponse.push(stringToDate_1.default);
        $httpProvider.interceptors.push('httpInterceptors');
        $locationProvider.hashPrefix('');
        $urlRouterProvider.otherwise('/signIn');
    }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 379 */,
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<!-- header component --> <aps-header></aps-header> <section class=columns-w> <div class=columns-inner> <div class=internal-c> <!-- main navigation component --> <aps-nav class=\"is-hidden-small showable\"></aps-nav> <article class=content-center> <!-- current ui.router state --> <div ui-view></div> </article> </div> </div> </section> <connection-status></connection-status>");

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(46)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, $) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function showInMainPane(button, popup, fixWidth) {
        popup.show();
        var height = popup.outerHeight();
        var width = popup.outerWidth();
        var innerWidth = popup.width();
        var leftPaneWidth = $('.left-line').outerWidth();
        var sheetOffset = $('.linesheet-w').offset();
        var buttonOffset = button.offset();
        var windowWidth = $(window).innerWidth();
        var top = buttonOffset.top - height;
        var left = buttonOffset.left - (width / 2);
        var padding = 10;
        if (top < (sheetOffset.top + padding)) {
            top = sheetOffset.top + padding;
        }
        if ((top + height) > buttonOffset.top) {
            var newTop = buttonOffset.top + button.outerHeight();
            if ((newTop + height) < $(window).innerHeight()) {
                top = newTop;
            }
        }
        var minLeft = sheetOffset.left + leftPaneWidth + padding;
        if (left < minLeft) {
            left = minLeft;
        }
        else if ((left + width + padding) > windowWidth) {
            left = windowWidth - width - padding;
        }
        popup.offset({ top: top, left: left });
        if (fixWidth) {
            popup.width(innerWidth);
        }
    }
    function initializePopups() {
        $(window.document).ready(function () {
            $(window.document).on('click', '.add-menu-trigger', function (event) {
                var menuButton = $(this);
                var menu = menuButton.prev('.add-menu');
                if (menu.is(':hidden')) {
                    $('.add-menu:visible').hide();
                    $('.lineitem-hoverover:visible').hide();
                    showInMainPane(menuButton, menu, true);
                }
                else {
                    menu.hide();
                }
                event.stopPropagation();
            });
            $(window.document).on('click', '.size-toggler', function (event) {
                $('.showable').toggleClass('is-hidden-small');
                $('.content-center').toggleClass('move-right-80');
                event.stopPropagation();
            });
            var currentHover = null;
            var shownHover = null;
            var hideHover = null;
            var hoverShowTimeout = null;
            var hoverHideTimeout = null;
            var setHoverShowTimeout = function (hover, lineItem, event) {
                hoverShowTimeout = setTimeout(function () {
                    hoverShowTimeout = null;
                    shownHover = hover[0];
                    if (hover.is(':hidden')) {
                        $('.add-menu:visible').hide();
                        $('.lineitem-hoverover:visible').hide();
                    }
                    else {
                        $('.lineitem-hoverover:visible').show();
                    }
                    showInMainPane(lineItem, hover);
                }, 500);
                event.stopPropagation();
            };
            var setHoverHideTimeout = function (hover) {
                if (hover === hideHover) {
                    return;
                }
                hideHover = hover;
                if (hoverShowTimeout) {
                    clearTimeout(hoverShowTimeout);
                    hoverShowTimeout = null;
                }
                hoverHideTimeout = setTimeout(function () {
                    hoverHideTimeout = null;
                    hideHover = null;
                    if (hover === shownHover) {
                        $(shownHover).hide();
                        shownHover = null;
                    }
                }, 500);
                event.stopPropagation();
            };
            var onMouseOut = function (event) {
                if (!currentHover) {
                    return;
                }
                if (event.currentTarget !== event.target) {
                    return;
                }
                for (var i = 0; i < event.currentTarget.children.length; i++) {
                    if (event.toElement === event.currentTarget.children[i]) {
                        return;
                    }
                }
                setHoverHideTimeout(currentHover);
            };
            $(window.document).on('mouseover', 'span.lineitem', function (event) {
                var lineItem = $(this);
                var hover = lineItem.prev('.lineitem-hoverover');
                if (hover.length === 0) {
                    return;
                }
                var thisHover = hover[0];
                if (thisHover === shownHover) {
                    if (hoverHideTimeout) {
                        clearTimeout(hoverHideTimeout);
                        hoverHideTimeout = null;
                        hideHover = null;
                    }
                }
                if (hoverShowTimeout) {
                    clearTimeout(hoverShowTimeout);
                    hoverShowTimeout = null;
                }
                setHoverShowTimeout(hover, lineItem, event);
                currentHover = thisHover;
            });
            $(window.document).on('mouseover', '.lineitem-hoverover', function () {
                var hover = $(this);
                if (hover.length === 0) {
                    return;
                }
                if (shownHover === hover[0] && hoverHideTimeout) {
                    clearTimeout(hoverHideTimeout);
                    hoverHideTimeout = null;
                    hideHover = null;
                }
                event.stopPropagation();
            });
            $(window.document).on('mouseout', 'span.lineitem', onMouseOut);
            $(window.document).on('mouseout', '.lineitem-hoverover', onMouseOut);
            $(window.document).on('click', '.lineitem-hoverover', function (event) {
                event.stopPropagation();
            });
            $(window.document).on('click', function () {
                $('.add-menu:visible').hide();
                $('.lineitem-hoverover:visible').hide();
            });
            $(window.document).on('click', '.toggle-zoom', function () {
                $('.linesheet-w').toggleClass('zoom-out-eighty');
                $('.toggle-zoom i').toggleClass('fa-search-minus fa-search-plus');
            });
            $(window.document).on('click', '.toggle-collapse', function () {
                $('.linedash-w, .topbox').slideToggle('slow');
                $('.toggle-collapse i').toggleClass('fa-eye-slash fa-eye');
            });
            $(window.document).on('click', '.toggle-hiding', function () {
                $('.hideable').slideToggle('fast');
                $('.hourly-zoomable').toggleClass('zoom-in-onethirty');
                $('.toggle-hiding i').toggleClass('fa-plus fa-minus');
            });
            $(window.document).on('click', '.expand-mobile', function () {
                $('.hideable-mobile').slideToggle('fast');
                $('.hours-columns').toggleClass('collapsed expanded');
                $('.expand-mobile i').toggleClass('fa-plus fa-minus');
                if ($('.expand-mobile span').text() === "Expand") {
                    $('.expand-mobile span').text('Collapse');
                }
                else {
                    $('.expand-mobile span').text('Expand');
                }
            });
        });
    }
    exports.default = initializePopups;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(383), __webpack_require__(419)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, header_directive_1, nav_directive_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [header_directive_1.default, nav_directive_1.default];
    exports.default = angular.module("aps.layout", requires).name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(384), __webpack_require__(386)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, header_tpl_html_1, header_controller_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [header_controller_1.default];
    exports.default = angular.module('aps.directive.header', requires)
        .directive('apsHeader', headerDef)
        .name;
    function headerDef() {
        return {
            restrict: 'E',
            scope: {},
            template: header_tpl_html_1.default,
            replace: false,
            controller: 'HeaderCtrl',
            controllerAs: 'vm',
            bindToController: true
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<style>#toast-container .toast{opacity:1!important}.toast-error .toast-title{padding:10px 0 10px}</style> <nav class=t-menu> <img class=\"aps-logo pull-left header-logo is-hidden-small\"/> <span class=is-hidden-small ng-style=\"{'font-size': '.8em', 'font-weight': 'Regular', 'background-color': 'White', 'padding': '25px 25px 5px 0px', 'float': 'left', 'bottom':'0' }\"> v1.{{vm.environmentVersion}} </span> <span ng-if=vm.environmentHighlight class=is-hidden-small ng-style=\"{'font-size': '1.8em', 'font-weight': 'bold', 'background-color': vm.environmentHighlight, 'padding': '5px 15px 5px 15px', 'float': 'left' }\"> {{vm.environmentName}} </span> <span ng-if=vm.releaseNoteNotification class=\"banner is-desktop\"> <span><img src=" + __webpack_require__(385) + " width=25 height=25 style=margin-right:10px><b>New!</b> Check out the new APS features <span style=cursor:pointer;color:#008cba;text-decoration:underline ng-click=vm.showReleaseNotes();>here</span>.</span> </span> <ul class=menu> <li> <div class=\"role-icon is-hidden-small\" title=\"User Profile\" ng-click=vm.showProfileEditor()> <i class=\"fa fa-user\"></i> </div> <p ng-click=vm.showProfileEditor() style=cursor:pointer class=is-hidden-small> {{vm.userData.fullName}}</p> <p class=down ng-click=vm.changeRole() style=cursor:pointer>{{vm.roleName}}</p> <div class=logout-btn ng-click=vm.signOff()> <i class=\"fa fa-sign-out\"></i> </div> </li> <li class=upper ng-if=\"vm.navigation && vm.navigation.selectedPlant\" style=position:relative> <p ng-click=vm.toggleSelectPlant($event) style=cursor:pointer;margin-top:-1px> {{vm.navigation.selectedPlant.name}} <span class=down>Plant</span> </p> <ul ng-show=vm.showSelectPlant class=\"ng-hide notification-list\" style=\"position:absolute;top:54px;left:-1px;background:#fff;border-bottom:1px solid #e7e7e7;border-right:1px solid #e7e7e7\"> <li ng-repeat=\"plant in vm.plants\" ng-click=vm.selectPlant(plant)> <div style=cursor:pointer class=notification-title>{{plant.name}}</div> </li> </ul> <p> <span class=down>Shop:</span> <span ng-repeat=\"shop in vm.navigation.shops() | orderBy: 'name'\" class=plant-t ng-click=vm.selectShop(shop) ng-class=\"{'active-p': shop === vm.navigation.selectedShop}\" style=cursor:pointer>{{shop.name}}</span> </p> </li> <!-- alarm notifications --> <li class=\"notification-w is-hidden-small showable\" ng-click=vm.notifications.toggleShowNotifications($event)> <i class=\"fa fa-bell\"></i> <span ng-if=vm.notifications.showUnread() class=notification-count>{{vm.notifications.unreadNotifications()}}</span> <span id=alertIt class=notification-count style=display:none>HELLO</span> <ul ng-show=vm.notifications.showNotifications() class=\"ng-hide notification-list\"> <li ng-repeat=\"notification in vm.notifications.notifications\"> <div class=notification-title>{{notification.title}}</div> <div class=notification-body>{{notification.description}}</div> <div> <button class=\"button tiny success\" ng-if=notification.url ng-click=notification.go()>Go</button> <button class=\"button tiny info\" ng-if=notification.isReadAvailable() ng-click=notification.read()>Mark Read</button> <button class=\"button tiny\" ng-if=notification.isDoneAvailable() ng-click=notification.done(false)>{{notification.doneLabel}}</button> <button class=\"button tiny\" ng-if=notification.isFillOutAvailable() ng-click=notification.fillOut()>Fill Out</button> <button class=\"button tiny\" ng-if=notification.isViewCheckListDetailsAvailable() ng-click=notification.viewCheckListDetails()>View Details</button> <button class=\"button tiny\" ng-if=notification.isSignOffAvailable() ng-click=notification.viewCheckListDetails()>Sign Off</button> <button class=\"button tiny\" ng-if=notification.isSectionChangeAvailable() ng-click=notification.sectionChange()>Section Change</button> <button class=\"button tiny\" ng-if=notification.isSectionChangeAvailable() ng-click=notification.skipSectionChange()>Skip</button> <div class=\"notification-timespan right\"> <span am-time-ago=notification.sentOn am-preprocess=utc></span> </div> </div> </li> <li ng-if=\"vm.notifications.notifications.length === 0\"> <i class=\"fa fa-bell-slash-o\"></i> No Notifications Found </li> </ul> </li> <!-- config dropdown --> <li class=\"notification-w is-hidden-small showable\" ng-if=vm.adminMenu.userIsPermitted ng-click=vm.adminMenu.toggleMenu($event)> <span style=padding-top:30px;padding-bottom:30px> <i class=\"fa fa-cogs\"></i> </span> <ul ng-show=vm.showAdminMenu class=\"ng-hide notification-list\"> <li style=cursor:pointer ng-repeat=\"menuItem in vm.adminMenu.menuItems | orderBy: 'text'\" ng-click=vm.adminMenu.goTo(menuItem)> <div class=notification-title>{{menuItem.text}}</div> </li> </ul> </li> <!-- reports drop down --> <li class=\"notification-w is-hidden-small showable\" ng-if=vm.reportMenu.userIsPermitted ng-click=vm.reportMenu.toggleMenu($event)> <span style=padding-top:30px;padding-bottom:30px> <i class=\"fa fa-bar-chart\"></i> </span> <ul ng-show=vm.showReportMenu class=\"ng-hide notification-list reportsList\"> <li style=cursor:pointer ng-repeat=\"menuItem in vm.reportMenu.menuItems | orderBy: 'text'\" ng-click=vm.reportMenu.goTo(menuItem)> <div class=notification-title>{{menuItem.text}} <span ng-if=menuItem.icon><i class=\"fa fa-star\" aria-hidden=true>New</i></span></div> </li> </ul> </li> <!-- machine pages --> <li class=\"notification-w is-hidden-small showable\" ng-if=vm.machineMenu.userIsPermitted ng-click=vm.machineMenu.toggleMenu($event)> <span style=padding-top:30px;padding-bottom:30px> <i class=\"fa fa-desktop\"></i> </span> <ul ng-show=vm.showMachineMenu class=\"ng-hide notification-list\"> <li style=cursor:pointer ng-repeat=\"menuItem in vm.machineMenu.menuItems | orderBy: 'text'\" ng-click=vm.machineMenu.goTo(menuItem)> <div class=notification-title>{{menuItem.text}}</div> </li> </ul> </li> <li class=\"notification-w burger-menu\"> <span style=padding-top:30px;padding-bottom:30px> <div class=title-bar-left> <a class=size-toggler> <i class=\"fa fa-bars\"></i> </a> </div> </span> </li> </ul> </nav>");

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4d0e586bd89bd1be0f7b849100eee387.png";

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(5), __webpack_require__(387), __webpack_require__(147), __webpack_require__(107), __webpack_require__(281), __webpack_require__(43), __webpack_require__(53), __webpack_require__(7), __webpack_require__(8), __webpack_require__(91), __webpack_require__(32), __webpack_require__(4), __webpack_require__(60), __webpack_require__(282), __webpack_require__(3), __webpack_require__(409), __webpack_require__(414), __webpack_require__(417)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, aps_enums_1, notification_hub_1, notifications_1, navigation_1, notification_service_1, environment_1, auth_service_1, authData_service_1, navigation_service_1, downtime_service_1, checkListInstances_service_1, loader_service_1, userProfile_1, stateRoles_service_1, constant_module_1, userProfile_controller_1, blockedSignOff_controller_1, openReleaseNotes_controller_1) {
    "use strict";
    headerCtrl.$inject = ["$state", "notificationHub", "notificationService", "environment", "authService", "authDataService", "navigationService", "downtimeService", "checkListInstancesService", "loaderService", "userProfile", "stateRolesService", "$q", "$stateParams", "$window", "$scope", "$timeout", "$modal"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [
        'ui.router',
        notification_hub_1.default,
        notifications_1.default,
        navigation_1.default,
        notification_service_1.default,
        environment_1.default,
        auth_service_1.default,
        authData_service_1.default,
        navigation_service_1.default,
        downtime_service_1.default,
        checkListInstances_service_1.default,
        loader_service_1.default,
        userProfile_1.default,
        stateRoles_service_1.default,
        userProfile_controller_1.default,
        blockedSignOff_controller_1.default,
        openReleaseNotes_controller_1.default
    ];
    exports.default = angular.module('aps.controller.header', requires)
        .controller('HeaderCtrl', headerCtrl)
        .name;
    function headerCtrl($state, notificationHub, notificationService, environment, authService, authDataService, navigationService, downtimeService, checkListInstancesService, loaderService, userProfile, stateRolesService, $q, $stateParams, $window, $scope, $timeout, $modal) {
        'use strict';
        var _this = this;
        var vm = this;
        vm.environmentVersion = environment.VERSION;
        vm.environmentName = environment.NAME;
        vm.environmentHighlight = environment.HIGHLIGHT;
        vm.plants = [];
        vm.releaseNoteNotification;
        var getShopId = function (selectedRoleLocation) {
            selectedRoleLocation = selectedRoleLocation || authDataService.getSelectedRoleLocation();
            return selectedRoleLocation.role.roleRequiresShops && selectedRoleLocation.shop ?
                selectedRoleLocation.shop.id :
                $stateParams.shopId;
        };
        var loadNavigation = function (selectedRoleLocation) {
            return navigationService.getNavigation()
                .then(function (navigation) {
                vm.plants = navigation.plants().filter(function (x) { return !x.isDisabled; });
                if (!navigation.selectedPlant) {
                    _.forEach(navigation.plants(), function (plant) {
                        var shop = _.find(plant.shops, { id: getShopId(selectedRoleLocation) });
                        if (shop) {
                            navigation.selectedPlant = plant;
                            navigation.selectedShop = shop;
                        }
                    });
                }
                vm.navigation = navigation;
                return navigation;
            });
        };
        var initializeNotifications = function () {
            var selectedRoleLocation = authDataService.getSelectedRoleLocation();
            loadNavigation(selectedRoleLocation).then(function () {
                var shopId = vm.navigation.selectedShop.id;
                var role = selectedRoleLocation.role;
                notificationService
                    .getNotifications(shopId, role.roleId, vm.userData.shift, $window, $scope)
                    .then(function (notifications) {
                    vm.notifications = notifications;
                    notificationService.getReleaseNotesNotification().then(function (releaseNotes) {
                        vm.releaseNoteNotification = releaseNotes;
                    });
                    vm.notificationsHub = notificationHub.createNotificationHub(shopId, role.roleId, vm.userData.shift, function () { return vm.notifications; });
                    vm.navigation.initialize(vm.notificationsHub, vm.userData);
                });
            });
        };
        $scope.$on('$destroy', function () {
            if (_this.notificationsHub) {
                _this.notificationsHub.stop();
            }
        });
        var performSignOff = function () {
            authService.logoff(vm.navigation);
            userProfile.update(null);
            $state.go(constant_module_1.States.SIGN_IN);
        };
        var userId = authDataService.getUserId();
        vm.signOff = function () {
            var selectedRoleLocation = authDataService.getSelectedRoleLocation();
            var role = selectedRoleLocation.role;
            var isOperator = selectedRoleLocation.hasFlag(aps_enums_1.apsEnums.RoleFlags.Operator);
            var isHotEnd = isOperator && role.roleLocation === aps_enums_1.apsEnums.Location.HotEnd;
            var openDowntimes = [];
            var blockingChecklists = [];
            var signOffBlockingPromises = [];
            if (isHotEnd) {
                signOffBlockingPromises.push(downtimeService.getOpenDowntimes($stateParams.shopId).
                    then(function (retOpenDowntimes) {
                    openDowntimes = retOpenDowntimes;
                }));
            }
            if ($stateParams.plantId && $stateParams.shopId) {
                signOffBlockingPromises.push(checkListInstancesService.getByRole($stateParams.plantId, $stateParams.shopId, role.roleId, aps_enums_1.apsEnums.CheckListView.Blocking, false).
                    then(function (checkLists) {
                    blockingChecklists = checkLists;
                }));
            }
            loaderService.loadingPromise($q.all(signOffBlockingPromises).then(function () {
                if ((openDowntimes && openDowntimes.length)
                    || (blockingChecklists && blockingChecklists.length)) {
                    showBlockingLogoffDialog(openDowntimes, blockingChecklists);
                }
                else {
                    performSignOff();
                }
            }));
        };
        vm.switchPlantShop = function () {
            $state.go($state.current.name, {
                plantId: vm.navigation.selectedPlant.id,
                shopId: vm.navigation.selectedShop.id,
                userId: userId
            });
        };
        vm.showSelectPlant = false;
        vm.toggleSelectPlant = function (event) {
            if (vm.navigation.plants().length > 1) {
                vm.showSelectPlant = !vm.showSelectPlant;
            }
            vm.showAdminMenu = false;
            vm.showReportMenu = false;
            vm.showMachineMenu = false;
            event.stopPropagation();
        };
        angular.element($window).click(function () {
            if (vm.showSelectPlant || vm.showAdminMenu || vm.showReportMenu || vm.showMachineMenu) {
                $timeout(function () {
                    vm.showSelectPlant = false;
                    vm.showAdminMenu = false;
                    vm.showReportMenu = false;
                    vm.showMachineMenu = false;
                });
            }
        });
        vm.selectPlant = function (plant) {
            vm.showSelectPlant = false;
            if (vm.navigation.selectPlant(plant)) {
                vm.switchPlantShop();
            }
        };
        vm.selectShop = function (shop) {
            if (vm.navigation.selectPlantShop(vm.navigation.selectedPlant, shop)) {
                vm.switchPlantShop();
            }
        };
        var initializeUserProfileSection = function () {
            var selectedRoleLocation = authDataService.getSelectedRoleLocation();
            if (selectedRoleLocation) {
                if (selectedRoleLocation.role) {
                    vm.roleName = selectedRoleLocation.role.roleName;
                }
            }
        };
        vm.showAdminMenu = false;
        var initializeAdminMenu = function () {
            vm.adminMenu = {
                userIsPermitted: authDataService.isPlantOrAPSIOAdmin(),
                toggleMenu: function (event) {
                    vm.showReportMenu = false;
                    vm.showAdminMenu = !vm.showAdminMenu;
                    vm.showSelectPlant = false;
                    vm.showMachineMenu = false;
                    event.stopPropagation();
                },
                goTo: function (menuItem) {
                    $state.go(menuItem.state);
                },
                menuItems: []
            };
            var menuItems = [{ text: 'Alert Roles', state: constant_module_1.States.ALERTROLES },
                { text: 'Defect Types', state: constant_module_1.States.DEFECT_TYPES },
                { text: 'Defect Types Mappings', state: constant_module_1.States.VIEW_MACHINE_DEFECT_MAPPINGS },
                { text: 'Holidays', state: constant_module_1.States.HOLIDAYS },
                { text: 'Jobs', state: constant_module_1.States.JOBS },
                { text: 'Job Runs', state: constant_module_1.States.JOB_RUNS },
                { text: 'Equipment', state: constant_module_1.States.EQUIPMENT },
                { text: 'Formulas', state: constant_module_1.States.FORMULAS },
                { text: 'Plants', state: constant_module_1.States.PLANTS },
                { text: 'Plant Feature Settings', state: constant_module_1.States.PLANT_FEATURE_SETTINGS },
                { text: 'Shops', state: constant_module_1.States.SHOPS },
                { text: 'Users', state: constant_module_1.States.USERS },
                { text: 'Check Lists', state: constant_module_1.States.CHECKLISTS },
                { text: 'Send Notifications', state: constant_module_1.States.GLOBAL_NOTIFICATIONS },
                { text: 'Section Changes', state: constant_module_1.States.SECTION_CHANGES },
                { text: 'Line Configuration', state: constant_module_1.States.LINE_CONFIG },
                { text: 'Palletizers', state: constant_module_1.States.PALLETIZERS },
                { text: 'Line Equipment Types', state: constant_module_1.States.LINE_EQUIPMENT_NAMES }
            ];
            vm.adminMenu.menuItems = _.filter(menuItems, function (item) {
                return stateRolesService.stateRoleRequirementsSatisfiedForStateName(item.state);
            });
            if (authDataService.isAuthorizedForBatchSummary()) {
                vm.adminMenu.menuItems.splice(1, 0, { text: 'Commodities', state: constant_module_1.States.COMMODITIES }, { text: 'Commodity Bin Mapping', state: constant_module_1.States.COMMODITY_BIN }, { text: 'Batch Summary', state: constant_module_1.States.BATCH_SUMMARY });
            }
        };
        vm.showReportMenu = false;
        var initializeReportMenu = function () {
            vm.reportMenu = {
                userIsPermitted: true,
                toggleMenu: function (event) {
                    vm.showAdminMenu = false;
                    vm.showReportMenu = !vm.showReportMenu;
                    vm.showSelectPlant = false;
                    vm.showMachineMenu = false;
                    event.stopPropagation();
                },
                goTo: function (menuItem) {
                    $state.go(menuItem.state);
                },
                menuItems: []
            };
            var menuItems = [
                { text: 'Batch Formula Usage', state: constant_module_1.States.BATCH_FORMULA_USAGE_REPORT },
                { text: 'Chat and Comments', state: constant_module_1.States.CHAT_REPORT },
                { text: 'Check List', state: constant_module_1.States.CHECKLIST_REPORT },
                { text: 'Check List Hourly', state: constant_module_1.States.HOURLY_CHECKLIST_REPORT },
                { text: 'Critical Defects', state: constant_module_1.States.CRITICAL_DEFECT_REPORT },
                { text: 'Defects', state: constant_module_1.States.DEFECTS_REPORT },
                { text: 'Downtime V2', state: constant_module_1.States.DOWNTIME_REPORT_V2 },
                { text: 'Defect Types', state: constant_module_1.States.VIEW_DEFECT_TYPES },
                { text: 'Deleted Defects', state: constant_module_1.States.DELETED_DEFECT_REPORT },
                { text: 'Deleted Gob Weights', state: constant_module_1.States.DELETED_GOB_WEIGHT_REPORT },
                { text: 'Downtime', state: constant_module_1.States.DOWNTIME_REPORT },
                { text: 'Furnace Pull', state: constant_module_1.States.FURNACE_PULL_REPORT },
                { text: 'Job Runs', state: constant_module_1.States.JOB_RUN_REPORT },
                { text: 'Production Summary', state: constant_module_1.States.COUNT_SUMMARY },
                { text: 'Tank Metrics', state: constant_module_1.States.TANK_METRICS_REPORT },
                { text: 'Tool Change', state: constant_module_1.States.TOOL_CHANGE_REPORT },
                { text: 'Tool Change History', state: constant_module_1.States.TOOLCHANGE_HISTORY_REPORT },
                { text: 'Top Defects', state: constant_module_1.States.TOP_DEFECTS_REPORT },
                { text: 'Qualifications', state: constant_module_1.States.QUALIFICATIONS_REPORT },
                { text: 'Reject Rate', state: constant_module_1.States.REJECT_RATE_REPORT },
                { text: 'Shift Detail', state: constant_module_1.States.SHIFT_DETAIL_REPORT },
                { text: 'Shop Count Summary', state: constant_module_1.States.SHOP_COUNT_SUMMARY_V2 },
                { text: 'Shop Cavity Efficiency', state: constant_module_1.States.CAVITY_EFFICIENCY },
                { text: 'Shop Cavity Correlation', state: constant_module_1.States.CAVITY_CORRELATION },
                { text: 'LPA Scorecard Report', state: constant_module_1.States.SCORECARD },
                { text: 'Data Point History', state: constant_module_1.States.COUNTS_DATA_POINT_HISTORY },
                { text: 'Downtime Shift Report', state: constant_module_1.States.DOWNTIME_SHIFT_REPORT },
                { text: 'Downtime Shift Report Insight', state: constant_module_1.States.DOWNTIME_SHIFT_REPORT_INSIGHT },
                { text: 'Dump Gate Time Report', state: constant_module_1.States.DUMPGATETIME_REPORT },
            ];
            if (authDataService.isProductionShiftReport()) {
                menuItems.push({ text: 'Production Shift Report v2', state: constant_module_1.States.PRODUCTION_SHIFT_REPORTV2 });
            }
            menuItems.push({ text: 'Held Ware', state: constant_module_1.States.WARE_HELD_REPORT });
            if (authDataService.isProductionShiftReport()) {
                menuItems.push({ text: 'Weekly KPIs', state: constant_module_1.States.WEEKLY_KPI_REPORT });
            }
            if (authDataService.isKpiAudit()) {
                menuItems.push({ text: 'Edit Production Report Records', state: constant_module_1.States.PALLETKPI });
            }
            if (authDataService.isHotEndBonusReport()) {
                menuItems.push({ text: 'Hot End Bonus Report', state: constant_module_1.States.HOTENDBONUS_REPORT_V2 });
            }
            vm.reportMenu.menuItems = _.filter(menuItems, function (item) {
                return stateRolesService.stateRoleRequirementsSatisfiedForStateName(item.state);
            });
        };
        vm.showMachineMenu = false;
        var initializeMachineMenu = function () {
            vm.machineMenu = {
                userIsPermitted: authDataService.isPlantOrAPSIOAdmin(),
                toggleMenu: function (event) {
                    vm.showAdminMenu = false;
                    vm.showReportMenu = false;
                    vm.showSelectPlant = false;
                    vm.showMachineMenu = !vm.showMachineMenu;
                    event.stopPropagation();
                },
                goTo: function (menuItem) {
                    $state.go(menuItem.state);
                },
                menuItems: []
            };
            var menuItems = [
                { text: 'FlexIS Details', state: constant_module_1.States.FLEX_IS_DETAILS },
            ];
            vm.machineMenu.menuItems = _.filter(menuItems, function (item) {
                return stateRolesService.stateRoleRequirementsSatisfiedForStateName(item.state);
            });
        };
        vm.showProfileEditor = function () {
            userProfile_controller_1.openUserProfile($modal);
        };
        vm.changeRole = function () {
            if (authDataService.getRoles().length > 1) {
                $state.go(constant_module_1.States.SELECT_ROLE, { userId: userId });
            }
            else {
                vm.showProfileEditor();
            }
        };
        vm.showReleaseNotes = function () {
            openReleaseNotes_controller_1.openReleaseNotes($modal, _this.releaseNoteNotification);
        };
        authService.getUserData().then(function (userData) {
            vm.userData = userData;
            initializeNotifications();
            initializeUserProfileSection();
            initializeAdminMenu();
            initializeReportMenu();
            initializeMachineMenu();
        });
        function showBlockingLogoffDialog(openDowntimes, blockingChecklists) {
            blockedSignOff_controller_1.openBlockedSignOff({
                openDowntimes: openDowntimes,
                blockingChecklists: blockingChecklists,
                shopId: vm.navigation.selectedShop.id,
                signOff: performSignOff
            }, $modal);
        }
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(37)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, hub_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.hubs.notification', [hub_service_1.default])
        .service('notificationHub', ["$timeout", "hubService", function ($timeout, hubService) {
        var createNotificationHub = function (shopId, roleId, shift, getNotifications) {
            var notificationHub = hubService.createHub('notifications', {
                listeners: {
                    notificationSent: function (notification) {
                        $timeout(function () { return getNotifications().addNotification(notification); });
                    },
                    notificationRead: function (notification) {
                        $timeout(function () { return getNotifications().markRead(notification); });
                    },
                    notificationCompleted: function (notification) {
                        $timeout(function () { return getNotifications().remove(notification); });
                    },
                    notificationRemoved: function (notification) {
                        $timeout(function () { return getNotifications().remove(notification); });
                    }
                },
                methods: ['getNotifications', 'stopNotifications'],
                postConnect: function (hub) {
                    hub.invokeWithRetry(function () { return hub.getNotifications({
                        shopId: shopId,
                        roleId: roleId,
                        shift: shift
                    }); });
                }
            });
            notificationHub.stop = function () {
                return notificationHub.stopNotifications()
                    .then(function () {
                    return notificationHub.uninitialize();
                });
            };
            return notificationHub;
        };
        return {
            createNotificationHub: createNotificationHub
        };
    }]).name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, jQuery) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(3), __webpack_require__(7), __webpack_require__(146)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, constant_module_1, authData_service_1, stringToDate_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [authData_service_1.default];
    var SignalRHubImpl = (function () {
        function SignalRHubImpl(options) {
            this.connection = SignalRHubImpl.initNewConnection(options);
            this.options = options;
            this.initialize();
        }
        SignalRHubImpl.initNewConnection = function (options) {
            var useLogging = (options && options.logging ? true : false);
            var connectionBuilder = new signalR.HubConnectionBuilder()
                .withUrl(options.rootPath + '/' + options.name, {
                accessTokenFactory: function () { return SignalRHubImpl.authDataService.getToken(); },
                transport: options.transport || signalR.HttpTransportType.WebSockets
            });
            if (useLogging) {
                connectionBuilder = connectionBuilder.configureLogging({
                    log: function (logLevel, message) {
                        if (message === 'Failed to start the HttpConnection before stop() was called.') {
                            return;
                        }
                        switch (logLevel) {
                            case signalR.LogLevel.Information:
                                SignalRHubImpl.$log.info(message);
                                break;
                            case signalR.LogLevel.Error:
                            case signalR.LogLevel.Critical:
                                SignalRHubImpl.$log.error(message);
                                break;
                            case signalR.LogLevel.Warning:
                                SignalRHubImpl.$log.warn(message);
                                break;
                        }
                    }
                });
            }
            return connectionBuilder.withAutomaticReconnect().build();
        };
        SignalRHubImpl.prototype.invoke = function (method) {
            var _this = this;
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            if (this.connection.state !== signalR.HubConnectionState.Connected) {
                return $.when(null);
            }
            return this.connection.invoke.apply(this.connection, arguments)
                .catch(function (error) {
                if (error && error.context && error.context.status === 401) {
                    _this.connection.stop();
                    SignalRHubImpl.$state.go(constant_module_1.States.SIGN_IN);
                }
                else {
                    throw error;
                }
            });
        };
        SignalRHubImpl.prototype.invokeWithRetry = function (method) {
            var _this = this;
            return method().catch(function () {
                if (_this.connection.state !== signalR.HubConnectionState.Connected) {
                    return $.when(null);
                }
                return _this.invokeWithRetry(method);
            });
        };
        SignalRHubImpl.prototype.connect = function () {
            var _this = this;
            return this.connection.start().then(function () {
                _this.runOnStateChange({
                    newState: signalR.HubConnectionState.Connected,
                    oldState: signalR.HubConnectionState.Disconnected
                });
            }, function (e) {
                if (e.message !== 'Failed to start the HttpConnection before stop() was called.') {
                    throw e;
                }
            });
        };
        SignalRHubImpl.prototype.disconnect = function () {
            this.promise = null;
            return this.connection.stop().catch(function (e) {
                if (e.message !== 'The connection was stopped before the hub handshake could complete.') {
                    throw e;
                }
            });
        };
        SignalRHubImpl.prototype.deregisterListeners = function () {
            if (this.options && this.options.listeners) {
                for (var event_1 in this.options.listeners) {
                    this.connection.off(event_1, function () { });
                }
            }
        };
        SignalRHubImpl.prototype.runPostConnect = function () {
            if (this.options && this.options.postConnect) {
                this.options.postConnect(this);
            }
        };
        SignalRHubImpl.prototype.runOnStateChange = function (change) {
            if (this.options && this.options.onStateChange) {
                this.options.onStateChange(change);
            }
            if (change.newState === signalR.HubConnectionState.Connected
                && change.oldState !== signalR.HubConnectionState.Connected) {
                this.runPostConnect();
            }
        };
        SignalRHubImpl.prototype.registerListeners = function () {
            if (!this.options.listeners) {
                return;
            }
            var _loop_1 = function (event_2) {
                if (!this_1.options.allowMultipleListeners) {
                    this_1.connection.off(event_2, function () { });
                }
                hub = this_1;
                var fn = this_1.options.listeners[event_2];
                this_1.connection.on(event_2, function () {
                    stringToDate_1.default(arguments);
                    return fn.apply(hub, arguments);
                });
            };
            var this_1 = this, hub;
            for (var event_2 in this.options.listeners) {
                _loop_1(event_2);
            }
        };
        SignalRHubImpl.prototype.registerMethods = function () {
            if (!this.options.methods) {
                return;
            }
            var hub = this;
            var _loop_2 = function (method) {
                hub[method] = function () {
                    var args = $.makeArray(arguments);
                    args.unshift(method);
                    return hub.invoke.apply(hub, args);
                };
            };
            for (var _i = 0, _a = this.options.methods; _i < _a.length; _i++) {
                var method = _a[_i];
                _loop_2(method);
            }
        };
        SignalRHubImpl.prototype.initialize = function () {
            var _this = this;
            this.registerListeners();
            this.registerMethods();
            this.connection.onclose(function () {
                _this.runOnStateChange({
                    newState: signalR.HubConnectionState.Disconnected,
                    oldState: signalR.HubConnectionState.Connected
                });
            });
            this.connection.onreconnecting(function () {
                _this.runOnStateChange({
                    newState: signalR.HubConnectionState.Reconnecting,
                    oldState: signalR.HubConnectionState.Disconnected
                });
            });
            this.connection.onreconnected(function () {
                _this.runOnStateChange({
                    newState: signalR.HubConnectionState.Connected,
                    oldState: signalR.HubConnectionState.Reconnecting
                });
            });
            this.promise = this.connect();
        };
        SignalRHubImpl.prototype.uninitialize = function () {
            this.deregisterListeners();
            this.disconnect();
        };
        return SignalRHubImpl;
    }());
    exports.default = angular.module('SignalR', requires)
        .constant('$', jQuery)
        .factory('Hub', ["$", "$state", "$window", "$log", "authDataService", function ($, $state, $window, $log, authDataService) {
        SignalRHubImpl.$ = $;
        SignalRHubImpl.$state = $state;
        SignalRHubImpl.$window = $window;
        SignalRHubImpl.$log = $log;
        SignalRHubImpl.authDataService = authDataService;
        return SignalRHubImpl;
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46), __webpack_require__(46)))

/***/ }),
/* 389 */,
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(3), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, constant_module_1, http_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [http_service_1.default];
    var NavigationPlantsSvc = (function () {
        NavigationPlantsSvc.$inject = ["httpService"];
        function NavigationPlantsSvc(httpService) {
            this.httpService = httpService;
        }
        NavigationPlantsSvc.prototype.getPlantNavigation = function (includeDeleted) {
            return this.httpService.get(constant_module_1.Endpoints.NAVIGATION_PLANTS, { includeDeleted: includeDeleted });
        };
        NavigationPlantsSvc.prototype.getLocationNavigation = function (includeDeleted) {
            return this.httpService.get(constant_module_1.Endpoints.NAVIGATION_LOCATIONS, { includeDeleted: includeDeleted });
        };
        return NavigationPlantsSvc;
    }());
    exports.default = angular.module('aps.services.navigationPlants', requires)
        .service('navigationPlantsService', NavigationPlantsSvc)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(392), __webpack_require__(393), __webpack_require__(394), __webpack_require__(108), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, defectActivity_1, toolActivity_1, qualificationHistory_1, gob_utility_1, _) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var GobActivity = (function () {
        function GobActivity(gobNumber, maxGobs, section, tools, userProfileData, defectTypes, jobs, jobProcess, eightyHrTools, oneSixtyHrTools) {
            this.gobNumber = gobNumber;
            this.userProfileData = userProfileData;
            this.isMachineLevel = (!gobNumber);
            this.name = gob_utility_1.default.getGobName(gobNumber, maxGobs);
            this.section = section;
            this.tools = tools;
            this.defectTypes = defectTypes;
            this.qualificationHistory = new qualificationHistory_1.QualificationHistory();
            this.defects = [];
            this.id = section.machine.id + '.' + section.sectionNumber + '.' + this.gobNumber;
            this.lastMold = undefined;
            this.currentMolds = [];
            this.toolChanges = [];
            this.jobs = jobs;
            this.jobProcess = jobProcess;
            this.eightyHrTools = eightyHrTools;
            this.oneSixtyHrTools = oneSixtyHrTools;
            this.initializeLatestTools();
            this.initializeHours();
            this.initializeJobRunsAndMolds();
            this.initializeHoursAndJobs();
        }
        GobActivity.prototype.initializeLatestTools = function () {
            var _this = this;
            this.latestTools = {};
            _.filter(this.tools, { typeName: 'Mold' }).forEach(function (tool) {
                _this.latestTools[tool.id] = {
                    name: tool.name,
                    toolChange: undefined
                };
            });
        };
        GobActivity.prototype.createGobHourActivity = function (hour) {
            var _this = this;
            var jobRuns = this.section.machine.shop.jobRuns;
            var jobRun = _.find(jobRuns, function (jr) {
                return jr.startDate.getTime() <= hour.startTime.getTime()
                    && (!jr.endDate || jr.endDate.getTime() > hour.startTime.getTime());
            });
            return {
                id: hour.id,
                isHour: true,
                hour: hour,
                activity: [],
                disabled: this.getDisabledSections(this.section.machine, jobRun)
                    .some(function (x) { return _this.section.sectionNumber === x; })
            };
        };
        GobActivity.prototype.getDisabledSections = function (machineActivity, jobRunActivity) {
            if (!jobRunActivity
                || jobRunActivity.machineDisabledSections === null) {
                return [];
            }
            var disabledSections = jobRunActivity.machineDisabledSections.filter(function (x) { return x.machineId == machineActivity.id; });
            if (disabledSections.length === 0) {
                return [];
            }
            return disabledSections[0].disabledSections ? disabledSections[0].disabledSections : [];
        };
        GobActivity.prototype.initializeHours = function () {
            var _this = this;
            this.hours = [];
            var hours = this.section.machine.shop.hours;
            _.forEach(hours, function (hour) {
                _this.hours.push(_this.createGobHourActivity(hour));
            });
        };
        GobActivity.prototype.initializeJobRunsAndMolds = function () {
            var _this = this;
            this.molds = [];
            this.jobRuns = [];
            var jobRuns = this.section.machine.shop.jobRuns;
            _.forEach(jobRuns, function (jobRun) {
                _this.jobRuns.push({
                    id: jobRun.id,
                    isJobRun: true,
                    jobRun: jobRun,
                    molds: []
                });
            });
        };
        GobActivity.prototype.initializeHoursAndJobs = function () {
            var _this = this;
            this.hoursAndJobs = [];
            _.forEach(this.hours, function (hour) {
                _this.hoursAndJobs.push(hour);
                var jobRun = _.find(_this.jobRuns, function (jr) {
                    return jr.jobRun.endDate && jr.jobRun.endDate.getTime() === hour.hour.startTime.getTime();
                });
                if (jobRun) {
                    _this.hoursAndJobs.push(jobRun);
                }
            });
        };
        GobActivity.prototype.insertHour = function (index, hour) {
            this.hours.splice(index, 0, this.createGobHourActivity(hour));
            var toDelete = this.hours.length - 24;
            if (toDelete > 0) {
                this.hours.splice(23, toDelete);
            }
            this.initializeHoursAndJobs();
        };
        GobActivity.prototype.displayHoursAndJobs = function () {
            return _.take(this.hoursAndJobs, this.section.machine.shop.numberOfColumns);
        };
        GobActivity.prototype.moldOnDate = function (date, excludeId) {
            var sortedMolds = _.sortBy(this.molds, function (mold) { return 0 - mold.timeChanged.getTime(); });
            for (var i = 0; i < sortedMolds.length; i++) {
                var mold = sortedMolds[i];
                if (date.getTime() > mold.timeChanged.getTime() && mold.id !== excludeId) {
                    return mold;
                }
            }
            return undefined;
        };
        GobActivity.prototype.addDefect = function (defect) {
            var existing = _.find(this.defects, { id: defect.id });
            if (existing) {
                return;
            }
            var index = this.getHourIndex(defect.timeFound);
            if (index === null) {
                return;
            }
            var hour = this.hours[index];
            var jobRun = hour.hour.jobRun;
            if (jobRun) {
                jobRun.updateHasActivity(this, true);
            }
            var defectActivity = new defectActivity_1.default(defect, this.userProfileData, this.defectTypes);
            hour.activity.push(defectActivity);
            this.defects.push(defectActivity);
        };
        GobActivity.prototype.addToolChange = function (toolChange) {
            var shop = this.section.machine.shop;
            var jobRun;
            var hour;
            var index = this.getHourIndex(toolChange.timeChanged);
            if (index !== null) {
                hour = this.hours[index];
                jobRun = hour.hour.jobRun;
                if (jobRun) {
                    jobRun.addToolChange(this, toolChange);
                }
            }
            else if (this.isFuture(toolChange.timeChanged)) {
                jobRun = _.last(shop.jobRuns);
                if (jobRun && jobRun.withinJob(toolChange.timeChanged)) {
                    jobRun.addToolChange(this, toolChange);
                }
            }
            else {
                jobRun = _.first(shop.jobRuns);
                if (jobRun && jobRun.withinJob(toolChange.timeChanged)) {
                    jobRun.addToolChange(this, toolChange);
                }
            }
            var toolActivity = new toolActivity_1.default(toolChange, shop.timeZoneId, jobRun, this.section.machine.number, this.jobs, this.jobProcess, this.eightyHrTools, this.oneSixtyHrTools);
            if (hour) {
                var topToolChange = _.find(hour.activity, { id: toolChange.toolChangeId });
                if (!topToolChange) {
                    topToolChange = {
                        id: toolChange.toolChangeId,
                        timeChanged: toolChange.timeChanged,
                        tools: [],
                        isToolChange: true,
                        comments: toolChange.rootComments
                    };
                    hour.activity.push(topToolChange);
                }
                var existing = _.find(topToolChange.tools, { id: toolActivity.id });
                if (!existing) {
                    topToolChange.tools.push(toolActivity);
                }
            }
            if (!_.some(this.toolChanges, { id: toolActivity.id })) {
                this.toolChanges.push(toolActivity);
                this.updateLatestTools(toolActivity);
            }
            if (toolActivity.toolIsMold && !_.some(this.molds, { id: toolActivity.id })) {
                this.molds.push(toolActivity);
                this.updateMolds(toolActivity);
            }
        };
        GobActivity.prototype.updateToolChange = function (toolChange) {
            var existing = _.find(this.toolChanges, { id: toolChange.id });
            if (!existing) {
                return;
            }
            this.updateLatestTools(toolChange);
            this.updateMolds(toolChange);
        };
        GobActivity.prototype.removeToolChange = function (toolChange, topToolChange, gobHour) {
            var _this = this;
            if (!toolChange) {
                return;
            }
            var existing = _.find(this.toolChanges, { id: toolChange.id });
            if (!existing) {
                return;
            }
            var shop = this.section.machine.shop;
            if (gobHour) {
                var jobRun = gobHour.hour.jobRun;
                if (jobRun) {
                    jobRun.removeToolChange(this, toolChange.toolChangeId);
                }
            }
            else if (this.isFuture(toolChange.timeChanged)) {
                var jobRun = _.last(shop.jobRuns);
                if (jobRun && jobRun.withinJob(toolChange.timeChanged)) {
                    jobRun.removeToolChange(this, toolChange.toolChangeId);
                }
            }
            else {
                var jobRun = _.first(shop.jobRuns);
                if (jobRun && jobRun.withinJob(toolChange.timeChanged)) {
                    jobRun.removeToolChange(this, toolChange.toolChangeId);
                }
            }
            _.remove(this.toolChanges, toolChange);
            if (topToolChange) {
                _.remove(topToolChange.tools, toolChange);
                if (topToolChange.tools.length === 0 && gobHour) {
                    _.remove(gobHour.activity, topToolChange);
                }
            }
            this.updateLatestTools(toolChange);
            if (toolChange.toolIsMold) {
                _.remove(this.molds, toolChange);
                _.forEach(this.jobRuns, function (jr) {
                    _.remove(jr.molds, toolChange);
                });
                this.currentMolds = _.filter(this.molds, function (t) { return !_this.isFuture(t.timeChanged); });
                this.lastMold = _.last(this.currentMolds);
            }
        };
        GobActivity.prototype.addDowntime = function (downtime) {
            var index = this.getHourIndex(downtime.downtimeStart);
            if (index === null) {
                return;
            }
            var downtimeActivity = _.assign({ isDowntime: true }, downtime);
            var hour = this.hours[index];
            var jobRun = hour.hour.jobRun;
            if (jobRun) {
                jobRun.updateHasActivity(this, true);
            }
            var existing = _.find(hour.activity, { id: downtimeActivity.id });
            if (!existing) {
                hour.activity.push(downtimeActivity);
            }
        };
        GobActivity.prototype.addQualification = function (qualification) {
            this.qualificationHistory.addQualification(qualification);
        };
        GobActivity.prototype.deleteQualification = function (qualification) {
            this.qualificationHistory.deleteQualification(qualification);
        };
        GobActivity.prototype.addDowntimeDuration = function (downtime) {
            var index = this.getHourIndex(downtime.downtimeStart);
            if (index === null) {
                return;
            }
            var downtimeFound = _.find(this.hours[index].activity, { id: downtime.id });
            if (downtimeFound !== undefined) {
                downtimeFound.duration = downtime.duration;
            }
        };
        GobActivity.prototype.updateLatestTools = function (toolChange) {
            var toolChanges = _.sortBy(_.filter(this.toolChanges, { toolId: toolChange.toolId }), function (t) { return t.timeChanged.getTime(); });
            var index = _.indexOf(toolChanges, toolChange);
            if (index > 0) {
                toolChanges[index - 1].timeRemoved = toolChange.timeChanged;
            }
            if (index >= 0 && index < (toolChanges.length - 1)) {
                toolChange.timeRemoved = toolChanges[index + 1].timeChanged;
            }
            index = toolChanges.length - 1;
            if (index >= 0 && index < toolChanges.length) {
                toolChanges[index].timeRemoved = null;
            }
            var latestTool = this.latestTools[toolChange.toolId];
            if (!latestTool) {
                latestTool = this.section.latestTools[toolChange.toolId];
                if (!latestTool) {
                    latestTool = this.section.machine.latestTools[toolChange.toolId];
                }
            }
            if (latestTool.toolChange !== toolChange
                && (!latestTool.toolChange || latestTool.toolChange.id !== toolChange.id)) {
                latestTool.toolChange = toolChange;
            }
        };
        GobActivity.prototype.updateMolds = function (mold) {
            var _this = this;
            if (!mold.toolIsMold) {
                return;
            }
            this.molds = _.sortBy(this.molds, function (t) { return t.timeChanged.getTime(); });
            var time = mold.timeChanged.getTime();
            _.forEach(this.jobRuns, function (jr) {
                if (jr.jobRun.startDate.getTime() > time) {
                    _.remove(jr.molds, mold);
                }
                else if ((!jr.jobRun.endDate || jr.jobRun.endDate.getTime() > time)
                    && !_.some(jr.molds, { id: mold.id })) {
                    jr.molds.push(mold);
                }
                jr.molds = _.sortBy(jr.molds, function (t) { return t.timeChanged.getTime(); });
            });
            this.currentMolds = _.filter(this.molds, function (t) { return !_this.isFuture(t.timeChanged); });
            this.lastMold = _.last(this.currentMolds);
        };
        GobActivity.prototype.getHourIndex = function (date) {
            for (var i = 0; i < this.hours.length; i++) {
                if (this.hours[i].hour.withinHour(date)) {
                    return i;
                }
            }
            return null;
        };
        GobActivity.prototype.isFuture = function (date) {
            return date.getTime() >= this.hours[0].hour.endTime.getTime();
        };
        GobActivity.prototype.addDowntimeComment = function (downtimeCommentAdded) {
            var index = this.getHourIndex(downtimeCommentAdded.downtimeStart);
            if (index === null) {
                return;
            }
            var downtimeFound = _.find(this.hours[index].activity, { id: downtimeCommentAdded.downtimeId });
            if (!downtimeFound) {
                return;
            }
            var commentFound = _.find(downtimeFound.comments, { id: downtimeCommentAdded.id });
            if (!commentFound) {
                var comments = [];
                if (!_.isEmpty(downtimeFound.comments)) {
                    comments = downtimeFound.comments;
                }
                var comment = {
                    id: downtimeCommentAdded.id,
                    downtimeId: downtimeCommentAdded.downtimeId,
                    comment: downtimeCommentAdded.comment,
                    createdOn: downtimeCommentAdded.eventDate,
                    createdByFullName: downtimeCommentAdded.createdByFullName
                };
                comments.push(comment);
                downtimeFound.comments = comments;
            }
        };
        return GobActivity;
    }());
    exports.default = GobActivity;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(5), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, aps_enums_1, _) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var DefectActivity = (function () {
        function DefectActivity(data, userProfileData, defectTypes) {
            _.assign(this, data);
            this.isDefect = true;
            this.severityName = aps_enums_1.apsEnums.Severity[this.severity];
            this.severityClass = 'severity-' + this.severity;
            this.defectType = _.find(defectTypes, { id: this.defectTypeId });
            this.hasOpenMoldReject = this.isMoldRejectInUse && !this.rejectEnd;
            this.userProfileData = userProfileData;
            this.heldPallets = this.heldPallets || [];
        }
        DefectActivity.prototype.idAbbr = function () {
            if (!this.defectType) {
                return undefined;
            }
            if (this.userProfileData
                && this.userProfileData.displayDefectsByNumber
                && this.defectType.legacyId) {
                return this.defectType.legacyId.toString();
            }
            else {
                return this.defectType.abbreviation;
            }
        };
        DefectActivity.prototype.isFrequencyCount = function () {
            return this.frequencyType === aps_enums_1.apsEnums.FrequencyType.Count;
        };
        DefectActivity.prototype.isFrequencyPercentage = function () {
            return this.frequencyType === aps_enums_1.apsEnums.FrequencyType.Percentage;
        };
        DefectActivity.prototype.isFrequencyPSI = function () {
            return this.frequencyType === aps_enums_1.apsEnums.FrequencyType.PSI;
        };
        DefectActivity.prototype.isFrequencyThermal = function () {
            return this.frequencyType === aps_enums_1.apsEnums.FrequencyType.ThermalShock;
        };
        DefectActivity.prototype.setEquipFailure = function (data) {
            this.maintenanceStart = data.maintenanceStart;
            this.maintenanceEnd = data.maintenanceEnd;
        };
        DefectActivity.prototype.setMoldReject = function (data) {
            this.isMoldRejectInUse = data.isMoldRejectInUse;
            this.rejectStart = data.rejectStart;
            this.rejectEnd = data.rejectEnd;
            this.hasOpenMoldReject = this.isMoldRejectInUse && !this.rejectEnd;
        };
        return DefectActivity;
    }());
    exports.default = DefectActivity;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(5), __webpack_require__(1), __webpack_require__(2), __webpack_require__(3), __webpack_require__(108)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, aps_enums_1, moment, _, constant_module_1, gob_utility_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ToolActivity = (function () {
        function ToolActivity(toolActivity, timeZone, jobRun, machineNumber, jobs, jobProcess, eightyHrTools, oneSixtyHrTools) {
            _.assign(this, toolActivity);
            this.timeZone = timeZone;
            this.jobRun = jobRun;
            this.machineNumber = machineNumber;
            this.jobs = jobs;
            this.jobProcess = jobProcess;
            this.eightyHrTools = eightyHrTools;
            this.oneSixtyHrTools = oneSixtyHrTools;
        }
        ToolActivity.prototype.formatTime = function (time) {
            if (time) {
                return moment.utc(time).tz(this.timeZone).format(constant_module_1.Strings.TIME_FORMAT);
            }
            return '';
        };
        ToolActivity.prototype.getTimeChanged = function () {
            return this.formatTime(this.timeChanged);
        };
        ToolActivity.prototype.getTimeRemoved = function () {
            return this.formatTime(this.timeRemoved);
        };
        ToolActivity.prototype.getGobName = function () {
            return gob_utility_1.default.getGobName(this.gob, this.jobRun.numberOfGobs);
        };
        ToolActivity.prototype.getSectionName = function () {
            if (!this.section) {
                return null;
            }
            return this.machineNumber < 2 ? this.section.toString()
                : (((this.machineNumber - 1) * this.jobRun.numberOfSections) + this.section).toString();
        };
        ToolActivity.prototype.getColorCode = function () {
            var _this = this;
            var currentJob = this.jobs.filter(function (x) { return x.id === _this.jobRun.jobId; })[0];
            var process = this.jobProcess.filter(function (x) { return x.id == currentJob.processId; })[0];
            var eightyHrTools = this.eightyHrTools.split(',');
            var oneSixtyHrTools = this.oneSixtyHrTools.split(',');
            eightyHrTools = process.name == "B&B" ? eightyHrTools.filter(function (x) { return x !== 'Plunger Clip'; }) : eightyHrTools;
            var totalHours = moment.utc().diff(this.timeChanged, 'hours');
            var toolhrstype = _.includes(eightyHrTools, this.toolName) ? 'Eighty'
                : _.includes(oneSixtyHrTools, this.toolName) ? 'OneSixty' : 'N/A';
            if ((toolhrstype == 'Eighty' && totalHours > 92) || (toolhrstype == 'OneSixty' && totalHours > 160)) {
                return 'Red';
            }
            else if ((toolhrstype == 'Eighty' && (totalHours >= 84 && totalHours <= 92)) || (toolhrstype == 'OneSixty' && (totalHours >= 154 && totalHours <= 160))) {
                return 'Orange';
            }
            else if (toolhrstype == 'N/A') {
                return null;
            }
            else {
                return 'Green';
            }
        };
        ToolActivity.prototype.getDuration = function () {
            var startTime = moment.utc(this.timeChanged);
            if (this.timeRemoved) {
                var endTime = moment.utc(this.timeRemoved);
                return startTime.to(endTime, true);
            }
            return startTime.toNow(true);
        };
        ToolActivity.prototype.getDurationAndHours = function () {
            var displayTime = this.getDuration();
            var startTime = moment.utc(this.timeChanged);
            var endTime = moment.utc();
            if (this.timeRemoved) {
                endTime = moment.utc(this.timeRemoved);
            }
            if (displayTime.search('day|week|month|year') > 0) {
                displayTime += ' / ' + endTime.diff(startTime, 'hour') + ' total hours';
            }
            return displayTime;
        };
        ToolActivity.prototype.getReason = function () {
            if (this.reason === aps_enums_1.apsEnums.ToolChangeReason.Other) {
                return this.otherReason;
            }
            return _.startCase(aps_enums_1.apsEnums.ToolChangeReason[this.reason]);
        };
        return ToolActivity;
    }());
    exports.default = ToolActivity;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(5), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, aps_enums_1, _) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var QualificationHistory = (function () {
        function QualificationHistory() {
            this.hotEndQualifications = [];
            this.coldEndQualifications = [];
        }
        QualificationHistory.prototype.heQualifications = function () {
            return QualificationHistory.sortQualifications(this.hotEndQualifications);
        };
        QualificationHistory.prototype.ceQualifications = function () {
            return QualificationHistory.sortQualifications(this.coldEndQualifications);
        };
        QualificationHistory.prototype.addQualification = function (qualification) {
            switch (qualification.location) {
                case aps_enums_1.apsEnums.Location.HotEnd:
                    this.hotEndQualifications.unshift(qualification);
                    this.currentHE = QualificationHistory.getCurrent(this.hotEndQualifications);
                    this.heIsQualified = QualificationHistory.isQualified(this.currentHE);
                    break;
                case aps_enums_1.apsEnums.Location.ColdEnd:
                    this.coldEndQualifications.unshift(qualification);
                    this.currentCE = QualificationHistory.getCurrent(this.coldEndQualifications);
                    this.ceIsQualified = QualificationHistory.isQualified(this.currentCE);
                    break;
                default:
                    throw 'Invalid Qualification PlantLocation';
            }
        };
        QualificationHistory.prototype.deleteQualification = function (qualification) {
            switch (qualification.location) {
                case aps_enums_1.apsEnums.Location.HotEnd:
                    _.remove(this.hotEndQualifications, function (q) { return q.id === qualification.id; });
                    this.currentHE = QualificationHistory.getCurrent(this.hotEndQualifications);
                    this.heIsQualified = QualificationHistory.isQualified(this.currentHE);
                    break;
                case aps_enums_1.apsEnums.Location.ColdEnd:
                    _.remove(this.coldEndQualifications, function (q) { return q.id === qualification.id; });
                    this.currentCE = QualificationHistory.getCurrent(this.coldEndQualifications);
                    this.ceIsQualified = QualificationHistory.isQualified(this.currentCE);
                    break;
                default:
                    throw 'Invalid Qualification PlantLocation';
            }
        };
        QualificationHistory.sortQualifications = function (qualifications) {
            return _.orderBy(qualifications, ['qualificationTime', 'status'], ['desc', 'asc']);
        };
        QualificationHistory.getCurrent = function (qualifications) {
            return _.first(QualificationHistory.sortQualifications(qualifications));
        };
        QualificationHistory.isQualified = function (qualification) {
            if (qualification) {
                return qualification.status === aps_enums_1.apsEnums.QualificationStatus.Qualified;
            }
            return false;
        };
        return QualificationHistory;
    }());
    exports.QualificationHistory = QualificationHistory;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, _) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var JobRunActivity = (function () {
        function JobRunActivity(data) {
            _.assign(this, data);
            this.isJobRun = true;
            this.hours = [];
            this.machinesHaveActivity = {};
            this.machinesHaveToolChange = {};
            if (this.jobMold && this.jobFinish) {
                this.shortName = this.jobMold + ' ' + this.jobFinish;
            }
            else {
                this.shortName = 'Maintenance';
            }
        }
        JobRunActivity.prototype.hasActivity = function (gob) {
            return this.machinesHaveActivity[gob.section.machine.id];
        };
        JobRunActivity.prototype.hasToolChange = function (gob) {
            return this.machinesHaveToolChange[gob.section.machine.id]
                && this.machinesHaveToolChange[gob.section.machine.id].length > 0;
        };
        JobRunActivity.prototype.updateHasActivity = function (gob, value) {
            this.machinesHaveActivity[gob.section.machine.id] = value;
        };
        JobRunActivity.prototype.addToolChange = function (gob, toolChange) {
            this.updateHasActivity(gob, true);
            var machineId = gob.section.machine.id;
            var id = toolChange.toolChangeId;
            if (this.machinesHaveToolChange[machineId]) {
                if (!this.machinesHaveToolChange[machineId].some(function (x) { return x === id; })) {
                    this.machinesHaveToolChange[machineId].push(id);
                }
            }
            else {
                this.machinesHaveToolChange[machineId] = [id];
            }
        };
        JobRunActivity.prototype.removeToolChange = function (gob, toolChangeId) {
            var machineId = gob.section.machine.id;
            if (!this.machinesHaveToolChange[machineId])
                return;
            this.machinesHaveToolChange[machineId] = this.machinesHaveToolChange[machineId].filter(function (x) { return x !== toolChangeId; });
        };
        JobRunActivity.prototype.withinJob = function (time) {
            if (time.getTime() < this.startDate.getTime()) {
                return false;
            }
            if (this.endDate) {
                return time.getTime() < this.endDate.getTime();
            }
            return true;
        };
        return JobRunActivity;
    }());
    exports.default = JobRunActivity;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, moment, _) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var HourActivity = (function () {
        function HourActivity(startTime, endTime, isLocked, timeZoneId) {
            this.startTime = startTime;
            this.endTime = endTime;
            this.isLocked = isLocked;
            var momentStartTime = moment.tz(this.startTime, timeZoneId);
            this.id = momentStartTime.format();
            this.isHour = true;
            this.hour = momentStartTime.format('h');
            this.period = momentStartTime.format('a');
            this.checkLists = [];
            this.hasFailedChecks = false;
            this.hasPassedChecks = false;
            this.hasNoChecks = true;
            this.overridden = false;
        }
        HourActivity.prototype.withinHour = function (time) {
            return this.startTime.getTime() <= time.getTime()
                && time.getTime() < this.endTime.getTime();
        };
        HourActivity.prototype.updateCheckListStatus = function (checkList) {
            this.hasNoChecks = false;
            if (checkList.hasFailures || _.some(this.checkLists, function (cl) { return cl.hasFailures; })) {
                this.hasFailedChecks = true;
                this.hasPassedChecks = false;
                return;
            }
            this.hasFailedChecks = false;
            this.hasPassedChecks = true;
        };
        HourActivity.prototype.addOrUpdateCheckList = function (checkList) {
            var index = _.findIndex(this.checkLists, { id: checkList.id });
            if (index < 0) {
                this.checkLists.push(checkList);
            }
            else {
                this.checkLists[index] = checkList;
            }
            this.updateCheckListStatus(checkList);
        };
        return HourActivity;
    }());
    exports.default = HourActivity;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <form name=vm.form ng-submit=vm.save() novalidate> <h2 class=modal-header>{{vm.subject}}</h2> <div class=container> <label> <p ng-if=!vm.htmlBinding>{{vm.message}}</p> <p ng-if=vm.htmlBinding ng-bind-html=vm.message></p> <p ng-if=vm.showTip> Click <em>{{vm.yes}}</em> to continue.<br/> <span ng-if=!vm.onlyConfirm>Click <em>{{vm.no}}</em> to cancel.</span> </p> </label> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-12 columns\"> <div class=dialog-footer> <input type=submit class=button value=\"{{vm.yes}}\"/> <button type=button class=\"button secondary\" ng-if=!vm.onlyConfirm ng-click=vm.close()>{{vm.no}}</button> </div> </div> </div> </form> </div>");

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=add-tool-change> <h2 class=modal-header>{{vm.isEdit ? 'Edit' : 'Add'}} a Tool Change</h2> <form name=vm.form ng-submit=vm.addToolChange() novalidate> <div class=\"container tabbed-view-w\"> <div class=center> <tabset> <tab heading=\"Mold Equipment\"> <table class=mold-selection> <thead> <tr> <th>&nbsp;</th> <th ng-repeat=\"selection in vm.selections\"> {{selection.section.name}} </th> </tr> </thead> <tbody> <tr ng-repeat=\"gob in vm.gobs\"> <th>{{gob.name}}</th> <td ng-repeat=\"selection in vm.selections\"> <button type=button class=\"button button-small\" ng-model=selection.gobs[$parent.$index].selected btn-checkbox> {{selection.gobs[$parent.$index].currentMold()}} </button> </td> </tr> </tbody> </table> <div ng-repeat=\"tool in vm.tools | filter: {typeName: 'Mold'}\" class=change-select> <label> <input type=checkbox ng-model=tool.selected /> {{tool.name}} </label> </div> </tab> <tab heading=\"Variable Equipment\"> <table class=mold-selection> <tbody> <tr> <th>Section</th> <th ng-repeat=\"selection in vm.selections\"> <button type=button class=\"button button-small\" ng-model=selection.selected btn-checkbox> {{selection.section.name}} </button> </th> </tr> </tbody> </table> <div ng-repeat=\"tool in vm.tools | filter: {typeName: 'Variable'}\" class=change-select> <label> <input type=checkbox ng-model=tool.selected /> {{tool.name}} </label> </div> </tab> <tab heading=\"Machine Equipment\" active=vm.machineTabActive> <div ng-repeat=\"tool in vm.tools | filter: {typeName: 'Machine'}\" class=change-select> <label> <input type=checkbox ng-model=tool.selected /> {{tool.name}} </label> </div> </tab> </tabset> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns\"> <label> Time Changed: <input name=timeChanged type=datetime-local ng-model=vm.timeChangedLocal min=\"{{vm.minTime}}\" max=\"{{vm.maxTime}}\" required date-time-picker time-model=vm.timeChanged time-zone=vm.timeZone single-hour=true /> <div ng-messages=vm.form.timeChanged.$error ng-if=\"vm.form.timeChanged.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be within the hour</div> <div ng-message=max class=req-w><div class=arrow-up></div>Must be within the hour</div> </div> </label> </div> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>Downtime (minutes): <input name=duration type=number ng-model=vm.duration min=1 max=1439 required/> <div ng-messages=vm.form.duration.$error ng-if=\"vm.form.duration.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=max class=req-w> <div class=arrow-up></div> Must be between greater than 0 </div> <div ng-message=max class=req-w> <div class=arrow-up></div> Must be less than 24 hours </div> </div> </label> </div> <div class=\"small-6 columns\"> <div class=row> <label> <span class=\"required notated\">*</span>Reason: <select name=reason ng-model=vm.reason ng-options=\"r.value as r.text for r in vm.reasons | orderBy: 'text'\" ng-change=vm.useDefaultReasonChanged() ng-required=vm.useDefaultReason> <option value=\"\">-- Select a Reason --</option> </select> <div ng-messages=vm.form.reason.$error ng-if=\"vm.form.reason.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=row ng-if=vm.otherReasonRequired()> <label> Other Reason: <input type=text name=otherReason ng-model=vm.otherReason ng-change=vm.otherReasonChanged() ng-required=vm.otherReasonRequired()>  <div ng-messages=vm.form.otherReason.$error ng-if=\"vm.form.otherReason.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=row> <label> <input type=checkbox ng-model=vm.useDefaultReason ng-change=vm.useDefaultReasonChanged() /> Use above as reason for all tool changes </label> </div> </div> </div> <span class=error ng-if=\"vm.form.$submitted && vm.toolChanges().length === 0\"> You must add a minimum of one tool change </span> <table class=tool-change-items ng-if=\"vm.toolChanges().length > 0\"> <thead> <tr> <th style=\"width:8%;vertical-align:top;padding:6px 8px\">Section</th> <th style=\"width:8%;vertical-align:top;padding:6px 8px\">Gob</th> <th style=\"width:7%;vertical-align:top;padding:6px 8px\">Tool</th> <th style=\"width:9%;vertical-align:top;padding:6px 8px\">No</th> <th style=\"width:18%;vertical-align:top;padding:6px 8px\">Alpha Number</th> <th style=\"width:10%;vertical-align:top;padding:6px 8px\">Reason</th> <th style=\"width:12%;vertical-align:top;padding:6px 8px\">Defect</th> <th style=\"width:12%;vertical-align:top;padding:6px 8px\">Comment</th> <th style=\"width:6%;vertical-align:top;padding:6px 8px;text-align:center\">Remove</th> </tr> </thead> <tbody> <tr ng-repeat=\"tc in vm.toolChanges()\" ng-class=\"{excluded: tc.exclude}\"> <td>{{tc.section.name}}</td> <td>{{tc.gob.name}}</td> <td> <div>{{tc.tool.name}}</div> <div class=req-w ng-if=tc.alreadyChanged() style=margin-top:2em> <div class=arrow-up></div>Already changed at this time </div> </td> <td> <input name=\"moldNumber{{$index}}\" type=number min=1 max=\"{{tc.max}}\" ng-model=tc.moldNumber ng-if=\"tc.tool.allowToolNumber && !tc.exclude\" ng-required=\"tc.tool.isMold || tc.tool.name==='Blank'\"/> <div ng-messages=\"vm.form['moldNumber' + $index].$error\" ng-if=\"vm.form['moldNumber' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>Number must be greater than 0</div> <div ng-message=max class=req-w><div class=arrow-up></div>Number must be less than {{tc.max+1}}</div> </div> <div class=req-w ng-if=tc.moldInUse()> <div class=arrow-up></div>Mold number must be unique in the shop </div> </td> <td style=\"vertical-align:top;padding:6px 8px\"> <input type=text ng-if=\"tc.tool.allowAlphaNumber && !tc.exclude\" ng-model=tc.alphaNumber style=width:100%;margin:0 /> <span ng-if=\"!tc.tool.allowToolNumber || tc.exclude\" style=display:inline-block;height:32px></span> </td> <td ng-if=!vm.useDefaultReason> <select name=\"reason{{$index}}\" ng-model=tc.reason ng-options=\"r.value as r.text for r in vm.reasons\" ng-if=!tc.exclude ng-change=tc.reasonChanged() required> <option value=\"\">-- Select a Reason --</option> </select> <div ng-messages=\"vm.form['reason' + $index].$error\" ng-if=\"vm.form['reason' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </td> <td ng-if=vm.useDefaultReason> <span ng-if=tc.reason ng-if=!tc.exclude>{{tc.reason.name}}</span> </td> <td> <div ng-if=tc.isFixDefect()> <label> <input type=checkbox name=\"unlistedDefect{{$index}}\" ng-model=tc.unlistedDefect /> Unlisted defect </label> <!-- existing defect --> <select name=\"defect{{$index}}\" ng-if=\"!tc.exclude && !tc.unlistedDefect\" ng-model=tc.defectFixed ng-options=\"d.nameAndLocation for d in tc.defects()\" required> <option value=\"\">-- Select a Defect --</option> </select> <div ng-messages=\"vm.form['defect' + $index].$error\" ng-if=\"vm.form['defect' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> <!-- unlisted defect --> <select name=\"defectTypeId{{$index}}\" ng-if=\"!tc.exclude && tc.unlistedDefect\" ng-model=tc.defectTypeId required> <option value=\"\">-- Select Defect Type --</option> <option ng-repeat=\"dt in vm.defectTypes | orderBy: 'name'\" value=\"{{ dt.id }}\" ng-class=\"{ 'defect-severity-0' : dt.severity === 0, 'defect-severity-1' : dt.severity === 1, 'defect-severity-2' : dt.severity === 2, 'defect-severity-3' : dt.severity === 3 }\"> {{ dt.listName }} </option> </select> <div ng-messages=\"vm.form['defectTypeId' + $index].$error\" ng-if=\"vm.form['defectTypeId' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> </td> <td><input type=text ng-model=tc.comment style=width:70%;margin:0 ng-if=!tc.exclude /></td> <td><input type=checkbox ng-model=tc.exclude /></td> </tr> </tbody> </table> <div class=row ng-if=!vm.isEdit style=\"margin:0 -30px;width:auto\"> <div class=\"small-12 columns\"> <label style=font-size:larger;font-weight:700> <input type=checkbox ng-model=vm.requalification /> Requalification </label> </div> </div> <div class=row ng-if=vm.requalification style=\"margin:0 -30px;width:auto\"> <div class=\"small-12 columns\"> <label> Requalification Time: <input name=requalificationTime type=datetime-local ng-model=vm.requalificationDateTimeLocal min=\"{{vm.requalificationMinTime()}}\" max=\"{{vm.maxTime}}\" required date-time-picker time-model=vm.requalificationDateTime time-zone=vm.timeZone single-hour=true /> </label> <div ng-messages=vm.form.requalificationTime.$error ng-if=\"vm.form.requalificationTime.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be within the hour</div> <div ng-message=max class=req-w><div class=arrow-up></div>Must be within the hour</div> </div> </div> </div> <div ng-if=!vm.isEdit class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-12 columns\"> <label> Comment: <textarea ng-model=vm.comment rows=4></textarea> </label> </div> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-12 columns\"> <span class=required>* Required Fields</span> <div class=\"right dialog-footer\"> <button type=submit class=button ng-disabled=!vm.readyForSubmit> {{vm.isEdit ? 'Save Changes' : 'Add Tool Change'}} </button> <button type=button class=\"button secondary\" value=Cancel ng-click=vm.cancel()> Cancel </button> </div> </div> </div> </div> </div> </form> </div> ");

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div id=reportWrapper> <h2 class=modal-header>Check List Report Details - {{ vm.checkListInstance.checkListName }}</h2> <table class=history-t> <tr> <td>Name</td> <td>{{ vm.checkListInstance.checkListName }}</td> </tr> <tr> <td>Status</td> <td>{{ vm.status }}</td> </tr> <tr ng-if=vm.checkListInstance.comment> <td>Comment</td> <td>{{ vm.checkListInstance.comment }}</td> </tr> <tr> <td>Plant</td> <td>{{ vm.checkListInstance.plantName }}</td> </tr> <tr> <td>Location</td> <td>{{ vm.checkListInstance.locationName }}</td> </tr> <tr> <td>Scheduled On</td> <td>{{ vm.formatTime(vm.checkListInstance.scheduledOn) }}</td> </tr> <tr ng-if=vm.checkListInstance.expiresOn> <td>Expires On</td> <td>{{ vm.formatTime(vm.checkListInstance.expiresOn) }}</td> </tr> <tr ng-if=vm.checkListInstance.isMandatory> <td>Mandatory</td> <td>{{ vm.checkListInstance.isMandatory }}</td> </tr> </table> <div ng-if=\"vm.detail.signOffs.length > 0\"> <div>Sign Offs</div> <table class=history-t> <tr ng-repeat=\"signOff in vm.detail.signOffs\"> <td>{{signOff.roleName}}</td> <td ng-if=signOff.signedOffByFullName>Signed off by {{signOff.signedOffByFullName}} on {{vm.formatTime(signOff.signedOffOn)}}</td> <td ng-if=!signOff.signedOffByFullName>Not signed off <button type=button class=button style=\"padding:7px;margin:0 0 0 20px\" ng-if=vm.canSignOff(signOff) ng-click=vm.signOff(signOff,vm.detail.reportItem.scheduledOn,vm.detail.reportItem.id)>Sign Off</button> </td> </tr> </table> </div> <table class=history-t> <tr> <th>Location</th> <th>Name</th> <th>Result</th> <th>Status</th> <th>Last Modified By</th> <th>Last Modified On</th> </tr> <tr ng-repeat-start=\"checkInstance in vm.detail.checkInstances\"> <td> {{ checkInstance.machineName }} {{ checkInstance.section }} {{ checkInstance.gobName }} </td> <td>{{ checkInstance.checkName }}<span ng-if=checkInstance.dimensionName>: {{ checkInstance.dimensionName }}</span></td> <td>{{ vm.getResult(checkInstance) }} <span ng-if=\"checkInstance.aggregateValues.length > 1\"> {{ checkInstance.aggregateValues.concat() }} </span> <span ng-if=vm.hasAdditionalData(checkInstance.additionalData)>- {{ vm.formatAdditionalData(checkInstance.additionalData) }} </span> </td> <td>{{ vm.formatCheckStatus(checkInstance.status) }}</td> <td>{{ checkInstance.lastModifiedByFullName }}</td> <td>{{ vm.formatTime(checkInstance.lastModifiedOn) }}</td> </tr> <tr ng-if=checkInstance.comment ng-repeat-end> <td>&nbsp;&nbsp;<i>Comment</i></td> <td colspan=8>{{checkInstance.comment}}</td> </tr> <tr ng-if=\"!vm.detail.checkInstances || !vm.detail.checkInstances.length\"> <td colspan=8>No Check Instances</td> </tr> </table> <div class=\"small-12 columns\"> <div class=dialog-footer> <button type=button ng-click=vm.print(); class=\"button secondary\">Print</button> <button type=button ng-click=\"vm.close(); $event.preventDefault();\" class=button>Close</button> </div> </div> <div class=\"small-12 columns\" ng-if=vm.isReport> <div class=dialog-footer> <a target=_blank href=\"/#/aps/admin/reports/productionReport?plantId={{vm.checkListInstance.plantId}}&shopId=00000000-0000-0000-0000-000000000000&userId={{vm.userId}}&&scheduleOn={{vm.scheduledOn}}&checklistInstanceId={{vm.checkListInstance.id}}\">Run Prod Report</a> </div> </div> </div>");

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div ng-if=vm.disabled> <h2 class=modal-header>Disabled or Deleted</h2> <div>This check list has been disabled or deleted.</div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-12 columns\" style=\"margin:20px 0 0 0\"> <div class=\"right dialog-footer\"> <button type=button class=button ng-click=vm.cancel()>OK</button> </div> </div> </div> </div> <div ng-if=vm.instance> <form name=vm.form ng-submit=vm.submit() novalidate class=checks-m-w> <h2 class=modal-header>{{ vm.instance.checkList().name }}</h2> <!-- containter--> <div class=check-contain> <!-- item --> <div ng-repeat=\"result in vm.instance.results\" class=check-selector> <!-- heading --> <div ng-if=result.showHeading class=row> <h5 style=\"width:100%;float:left;margin:0 -30px 25px\">{{ result.check().heading }}</h5> </div> <!-- name --> <div ng-if=\"result.showName && result.check().name !== '{ProdReport}' && result.check().name !== '{tonnage}' && result.check().name !== '{streamingtime}' && result.check().name !== '{shovelweight}' && result.check().name !== '{shovelweight}' && result.check().name !== ':'\" class=\"row sub-header-result\"> <strong style=float:left>{{ result.check().name }}: </strong> <span style=font-family:arial;position:relative;top:1px;left:5px>{{ result.check().description }}</span> </div> <div ng-if=\"result.showName && result.check().name === '{tonnage}'\" class=\"row sub-header-result\"> <strong style=float:left>Calculated Tonnage: </strong> <span style=font-family:arial;position:relative;top:1px;left:5px>{{ result.check().description }}</span> </div> <div ng-if=\"result.showName && result.check().name === '{streamingtime}'\" class=\"row sub-header-result\"> <strong style=float:left>Time (in minutes) machine was on drain (Must be 30 - 60 Minutes): </strong> <span style=font-family:arial;position:relative;top:1px;left:5px>{{ result.check().description }}</span> </div> <div ng-if=\"result.showName && result.check().name === '{shovelweight}'\" class=\"row sub-header-result\"> <strong style=float:left>Weight (in ounces) of 5 second shovel test: </strong> <span style=font-family:arial;position:relative;top:1px;left:5px>{{ result.check().description }}</span> </div> <div ng-if=\"result.check().name === '{ProdReport}'\"> <a target=_blank href=\"/#/aps/admin/reports/productionReport?plantId={{vm.plantId}}&shopId={{vm.shopId}}&userId={{vm.userId}}&&scheduleOn={{vm.scheduledOn}}&checklistInstanceId={{vm.instanceId}}\">Run Report</a> </div> <div class=\"check-wrap row\"> <!-- machine, section, gob --> <div class=\"small-3 columns\" style=\"padding:5px 0 0 0;white-space:nowrap;overflow:visible\"> &nbsp; <span ng-if=result.machine().name class=label>{{ result.machine().name }}</span> <span ng-if=result.section class=\"warning label\">{{ result.getSection(vm.jobRun) }}</span> <span ng-if=result.gobName() class=\"success label\">{{ result.gobName() }}</span> <span ng-if=result.hasMold(vm.molds) class=label>{{ result.moldNumber(vm.molds) }}</span> <span ng-if=result.dimensionName()>{{ result.dimensionName() }}</span> </div> <!-- controls --> <div class=\"small-3 columns\" style=white-space:nowrap ng-if=\"result.checkItem.aggregatesCount < 2\"> <!-- Text = 1, Integer = 2, Decimal = 3, Boolean = 4, DateTime = 5, Percent = 6, Count = 7, Instructions = 8 --> <!-- choices --> <select ng-if=\"result.checkItem.choices.length > 0\" name=\"result{{$index}}\" ng-readonly=vm.readOnly ng-disabled=vm.readOnly ng-model=result.result ng-change=result.choiceChanged() ng-options=\"item.value as item.value for item in result.checkItem.choices\" ng-required=result.isRequired()> </select> <!-- text --> <input ng-if=\"result.checkItem.choices.length == 0 && result.checkItem.dataType == 1\" type=text name=\"result{{$index}}\" ng-readonly=vm.readOnly ng-disabled=vm.readOnly ng-model=result.result ng-required=result.isRequired() /> <!-- boolean --> <div ng-if=\"result.checkItem.dataType == 4\"> <label style=float:left;margin-right:6px> <input type=radio value=true name=\"result{{$index}}\" ng-model=result.result ng-required=\"result.isRequired() && !result.result\" ng-change=result.booleanChanged()> {{ result.checkItem.trueText || 'Yes' }} </label> <label> <input type=radio value=false name=\"result{{$index}}\" ng-model=result.result ng-required=\"result.isRequired() && !result.result\" ng-change=result.booleanChanged()> {{ result.checkItem.falseText || 'No' }} </label> </div> <!-- date --> <input ng-if=\"result.checkItem.dataType == 5\" type=datetime-local name=\"result{{$index}}\" ng-readonly=vm.readOnly ng-disabled=vm.readOnly ng-model=result.resultLocal ng-required=result.isRequired() date-time-picker time-model=result.result time-zone=vm.timeZone /> <!-- instruction --> <div style=display:none> <input ng-if=\"result.checkItem.dataType == 8\" type=text name=\"result{{$index}}\" ng-readonly=vm.readOnly ng-disabled=vm.readOnly ng-model=result.resultLocal ng-required=false time-model=result.result /> </div> <!-- defect type --> <select ng-if=\"result.checkItem.dataType === 9\" name=\"result{{$index}}\" ng-readonly=vm.readOnly ng-disabled=vm.readOnly ng-model=result.result ng-options=\"t.name as t.listName for t in result.defectTypes\" ng-required=result.isRequired()> </select> <div ng-if=\"result.checkItem.aggregateCheckId !== null\"> <input type=text name=\"result{{$index}}\" ng-model=result.result ng-disabled=vm.readOnly ng-required=result.isRequired() readonly=readonly /> <div ng-messages=\"vm.form['result' + $index].$error\" ng-if=\"vm.form['result' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div ng-if=\"result.checkItem.aggregateCheckId === null\"> <!--result.validationRangeMin: {{ result.validationRangeMin }} --> <!-- numeric with range --> <input ng-if=\"result.isNumeric && result.hasRange && result.checkItem.name !== '{streamingtime}' && result.checkItem.name !== '{tonnage}' && result.checkItem.name !== '{shovelweight}'\" name=\"result{{$index}}\" ng-readonly=vm.readOnly ng-disabled=vm.readOnly ng-model=result.result ng-required=result.isRequired() ng-change=result.onChange(vm.instance) type=number string-to-number min=\"{{ result.validationRangeMin }}\" max=\"{{ result.validationRangeMax }}\" step=\"{{ result.step }}\"/> <input ng-if=\"result.isNumeric && result.hasRange && result.checkItem.name === '{streamingtime}'\" name=\"result{{$index}}\" ng-readonly=vm.readOnly ng-disabled=\"vm.readOnly || result.status === vm.checkStatus.NotApplicable\" ng-model=result.result ng-required=result.isRequired() type=number string-to-number min=\"{{ result.validationRangeMin }}\" max=\"{{ result.validationRangeMax }}\" step=\"{{ result.step }}\" ng-change=\"vm.calcTonnage({{$index}})\"/> <input ng-if=\"result.isNumeric && result.hasRange && result.checkItem.name === '{shovelweight}'\" name=\"result{{$index}}\" ng-readonly=vm.readOnly ng-disabled=\"vm.readOnly || result.status === vm.checkStatus.NotApplicable\" ng-model=result.result ng-required=result.isRequired() type=number string-to-number min=\"{{ result.validationRangeMin }}\" max=\"{{ result.validationRangeMax }}\" step=\"{{ result.step }}\" ng-change=\"vm.calcTonnage({{$index}})\"/> <!-- numeric, no range --> <input ng-if=\"result.isNumeric && !result.hasRange && result.checkItem.name !== '{tonnage}'\" name=\"result{{$index}}\" ng-readonly=vm.readOnly ng-disabled=vm.readOnly ng-model=result.result ng-change=result.onChange(vm.instance) ng-required=result.isRequired() type=number string-to-number step=\"{{ result.step }}\"/> <input ng-if=\"result.isNumeric && !result.hasRange && result.checkItem.name === '{tonnage}'\" name=\"result{{$index}}\" ng-readonly=true ng-disabled=true ng-model=result.result ng-required=false type=number string-to-number step=\"{{ result.step }}\" ng-change=\"vm.calcTonnage({{$index}})\"/> <!-- required --> <div ng-messages=\"vm.form['result' + $index].$error\" ng-if=\"vm.form['result' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a valid number</div> <div ng-message=min class=req-w><div class=arrow-up></div>May not be less than {{result.validationRangeMin}}</div> <div ng-message=max class=req-w><div class=arrow-up></div>May not be greater than {{result.validationRangeMax}}</div> <div ng-message=step class=req-w><div class=arrow-up></div>{{result.stepError}}</div> </div> <!-- total (for count) --> <div ng-if=\"result.checkItem.dataType == 7\"> <label>Total: <input type=number string-to-number name=\"total{{$index}}\" ng-readonly=vm.readOnly ng-disabled=vm.readOnly ng-model=result.total ng-required=result.isRequired() /></label> <!-- total required --> <div ng-messages=\"vm.form['total' + $index].$error\" ng-if=\"vm.form['total' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a valid number</div> </div> </div> </div> <div ng-if=\"result.additionalDataType === 1\"> <line-selection ng-model=result.additionalDataModel ng-readonly=vm.readOnly ng-disabled=vm.readOnly ng-required=true ng-name=\"'resultData' + $index\" form=vm.form /> </div> </div> <!-- aggregates --> <div class=\"small-3 columns\" ng-if=\"result.checkItem.aggregatesCount > 1\"> Samples: <div ng-repeat=\"aggVal in result.aggregateValues track by $index\"> <!-- range --> <input type=number string-to-number ng-if=\"result.validationRangeMin && result.validationRangeMax\" name=\"result{{$parent.$index}}_{{$index}}\" ng-model=result.aggregateValues[$index] ng-readonly=vm.readOnly ng-required=result.isRequired() min=\"{{ result.validationRangeMin }}\" max=\"{{ result.validationRangeMax }}\" style=width:100% /> <!-- no range --> <input type=number string-to-number ng-if=\"!(result.validationRangeMin && result.validationRangeMax)\" name=\"result{{$parent.$index}}_{{$index}}\" ng-model=result.aggregateValues[$index] ng-readonly=vm.readOnly ng-required=result.isRequired() style=width:100% /> <!-- % --> <div ng-messages=\"vm.form['result' + $parent.$index + '_' + $index].$error\" ng-if=\"vm.form['result' + $parent.$index + '_' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a valid number</div> <div ng-message=min class=req-w><div class=arrow-up></div>May not be less than {{result.validationRangeMin}}</div> <div ng-message=max class=req-w><div class=arrow-up></div>May not be greater than {{result.validationRangeMax}}</div> </div> </div> <div ng-if=\"result.checkItem.valueType === 2\"> <span>{{ result.aggregateFunction }}:</span> <input ng-value=result.aggregateResult() disabled=disabled /> </div> <div ng-if=\"result.checkItem.valueType === 4\"> <div ng-repeat=\"dim in result.checkItem.dimensions\"> <span>{{ dim.name }}:</span> <input ng-value=result.aggregateResult(dim) disabled=disabled /> </div> </div> </div> <!-- comments --> <div class=\"small-3 columns\" ng-if=\"result.checkItem.dataType != 8 && (result.checkItem.allowComments || result.comment)\"> <input type=text name=\"comment{{index}}\" ng-model=result.comment ng-readonly=vm.readOnly ng-disabled=vm.readOnly placeholder=\"Enter Comment\" tabindex=-1 /> </div> <!-- buttons --> <div class=\"small-3 columns\" style=text-align:center> <input type=hidden value=\"{{ result.autoStatus(vm.instance) }}\"/> <div class=button-bar ng-if=\"result.checkItem.dataType != 8\" style=text-align:center> <ul class=\"button-group round\" style=width:100%> <li><a class=\"tiny button\" style=font-size:.5em;margin:0 ng-class=\"{ success: result.status === 2, secondary: result.status !== 2, disabled: vm.readOnly }\" ng-click=\"vm.updateStatus(result, vm.checkStatus.Passed,$index)\">Pass</a></li> <li ng-if=result.checkItem.allowNotApplicable><a class=\"tiny button\" style=font-size:.5em;margin:0 ng-class=\"{ warning: result.status === 4, secondary: result.status !== 4, disabled: vm.readOnly }\" ng-click=\"vm.updateStatus(result, vm.checkStatus.NotApplicable,$index)\">N/A</a></li> <li><a class=\"tiny button\" style=font-size:.5em;margin:0 ng-class=\"{ alert: result.status === 1, secondary: result.status !== 1, disabled: vm.readOnly }\" ng-click=\"vm.updateStatus(result, vm.checkStatus.Failed,$index)\">Fail</a></li> </ul> <input type=hidden ng-model=result.status name=\"status{{$index}}\" required/> </div> <div class=checks-validate ng-if=\"(vm.form['status' + $index].$dirty || vm.form.$submitted) && result.isStatusInvalid()\" role=alert> <div class=req-w><div class=arrow-up></div>Required</div> </div> </div> </div> </div> </div> <!-- footer --> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-12 columns\" style=\"margin:20px 0 0 0\"> <div class=\"right dialog-footer\"> <button type=button class=button ng-if=\"vm.readOnly && vm.allowSignOff\" ng-click=vm.signOff()>Sign Off</button> <button type=submit class=button ng-if=!vm.readOnly>Submit Results</button> <button type=button class=\"button secondary\" ng-click=vm.cancel()>{{ vm.readOnly && !vm.allowSignOff ? 'OK' : 'Cancel' }}</button> </div> </div> </div> </form> </div>");

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(5), __webpack_require__(62), __webpack_require__(108), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, aps_enums_1, checkListOverride_module_1, gob_utility_1, _) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var CheckInstance = (function () {
        function CheckInstance(checkList, data, check, machine, jobRun) {
            _.assign(this, data);
            this.checkItem = check;
            this.machineConfiguration = machine || {};
            this.jobRun = jobRun;
            this.status = data.status || aps_enums_1.apsEnums.CheckStatus.NotDone;
            this.validationRangeMin = this.checkItem.rangeMin;
            this.validationRangeMax = this.checkItem.rangeMax;
            this.aggregateCheckIds = null;
            this.additionalDataType = this.getAdditionalDataType();
            this.additionalDataModel = this.setAdditionalDataModel();
            if (checkList.status <= aps_enums_1.apsEnums.CheckListStatus.Complete && check.prepopulate && !this.result) {
                switch (check.dataType) {
                    case aps_enums_1.apsEnums.CheckDataType.DateTime:
                        var d = new Date();
                        d.setSeconds(0);
                        d.setMilliseconds(0);
                        this.result = d;
                        break;
                    case aps_enums_1.apsEnums.CheckDataType.Count:
                        this.total = check.frequencyTotal.toString();
                        break;
                }
            }
            this.isNumeric = check.dataType === aps_enums_1.apsEnums.CheckDataType.Integer
                || check.dataType === aps_enums_1.apsEnums.CheckDataType.Decimal
                || check.dataType === aps_enums_1.apsEnums.CheckDataType.Percent
                || check.dataType === aps_enums_1.apsEnums.CheckDataType.Count;
            this.hasRange = this.isNumeric && _.isNumber(check.rangeMin) && _.isNumber(check.rangeMax);
            this.step = 1;
            this.stepError = 'Must be an integer';
            if (check.dataType === aps_enums_1.apsEnums.CheckDataType.Decimal || check.dataType === aps_enums_1.apsEnums.CheckDataType.Percent) {
                var places = check.numberOfDecimalPlaces || 2;
                for (var place = 0; place < places; place++) {
                    this.step = this.step / 10.0;
                }
                this.stepError = 'Up to ' + places + ' decimal places are allowed';
            }
        }
        CheckInstance.prototype.getAdditionalDataType = function () {
            var _this = this;
            if (this.checkItem.dataType === aps_enums_1.apsEnums.CheckDataType.Boolean) {
                if (this.result === true || this.result === 'true')
                    return this.checkItem.trueAdditionalData;
                if (this.result === false || this.result === 'false')
                    return this.checkItem.falseAdditionalData;
            }
            if (this.checkItem.choices !== null && this.checkItem.choices.length > 1) {
                var choice = this.checkItem.choices.filter(function (x) { return x.value === _this.result; });
                if (!!choice && choice.length > 0) {
                    return choice[0].additionalData;
                }
            }
            return null;
        };
        CheckInstance.prototype.prepareForSubmit = function () {
            if (this.additionalDataType === null
                || this.additionalDataType === aps_enums_1.apsEnums.CheckAdditionalData.None
                || !this.additionalDataModel) {
                this.additionalData = null;
            }
            else {
                this.additionalData = JSON.stringify(this.additionalDataModel);
            }
        };
        CheckInstance.prototype.setAdditionalDataModel = function () {
            if (!this.additionalData
                || this.additionalData.length < 1) {
                return {};
            }
            return JSON.parse(this.additionalData);
        };
        CheckInstance.prototype.calculateAggregate = function (aggregateFunction, checkList) {
            var _this = this;
            var aggregateValues = this.aggregateValues;
            if (this.checkItem.aggregateCheckId !== null && checkList) {
                var previousValues = checkList.previousCheckValues.filter(function (x) { return x.checkId === _this.checkItem.aggregateCheckId
                    && x.frequency === _this.checkItem.aggregateFrequencyUnits; })
                    .map(function (x) { return x.instances; })
                    .reduce(function (a, b) { return a.concat(b); }, []).filter(function (x) {
                    return (_this.machineId === null || x.machineId === _this.machineId)
                        && (_this.section === null || x.section === _this.section)
                        && (_this.gob === null || x.gob === _this.gob)
                        && (_this.sequence === null || x.sequence === _this.sequence);
                })
                    .map(function (x) { return x.result; });
                aggregateValues = checkList.results.filter(function (x) {
                    return x.checkId === _this.checkItem.aggregateCheckId
                        && (_this.machineId === null || x.machineId === _this.machineId)
                        && (_this.section === null || x.section === _this.section)
                        && (_this.gob === null || x.gob === _this.gob)
                        && (_this.sequence === null || x.sequence === _this.sequence);
                })
                    .map(function (x) { return x.result; }).concat(previousValues);
            }
            if (_.some(aggregateValues, function (x) { return _.isUndefined(x) || _.isNull(x) || x === 'null'; })) {
                return '';
            }
            var result;
            var numericValues = aggregateValues.map(function (x) { return _.isNumber(x) ? x : parseFloat(x); });
            switch (aggregateFunction) {
                case aps_enums_1.apsEnums.AggregateFunction.Average:
                    result = _.sum(numericValues) / aggregateValues.length;
                    break;
                case aps_enums_1.apsEnums.AggregateFunction.Min:
                    result = _.min(numericValues);
                    break;
                case aps_enums_1.apsEnums.AggregateFunction.Max:
                    result = _.max(numericValues);
                    break;
                case aps_enums_1.apsEnums.AggregateFunction.Sum:
                case aps_enums_1.apsEnums.AggregateFunction.Cumulation:
                    result = _.sum(numericValues);
                    break;
                default:
                    return '';
            }
            return (Math.round(result * 100) / 100).toString();
        };
        CheckInstance.prototype.onChange = function (checkList) {
            var _this = this;
            if (!this.aggregateCheckIds) {
                this.aggregateCheckIds = checkList.checkList().checks.filter(function (x) { return x.aggregateCheckId === _this.checkId; }).map(function (x) { return x.id; });
            }
            if (this.aggregateCheckIds.length === 0) {
                return;
            }
            var aggregates = checkList.results.filter(function (x) { return _this.aggregateCheckIds.some(function (id) { return id === x.checkId; }); });
            for (var _i = 0, aggregates_1 = aggregates; _i < aggregates_1.length; _i++) {
                var check = aggregates_1[_i];
                var result = check.aggregateResult(null, checkList);
                if (result !== check.result) {
                    check.result = result;
                    check.onChange(checkList);
                }
            }
        };
        CheckInstance.prototype.aggregateResult = function (checkDim, checkList) {
            if (this.checkItem.valueType === aps_enums_1.apsEnums.CheckValueType.MultipleSample) {
                return this.calculateAggregate(checkDim.aggregateFunction, checkList);
            }
            else {
                return this.calculateAggregate(this.checkItem.aggregateFunction, checkList);
            }
        };
        CheckInstance.prototype.booleanChanged = function () {
            if (this.checkItem.dataType !== aps_enums_1.apsEnums.CheckDataType.Boolean) {
                return;
            }
            this.updateAdditionalDataType();
            if (this.checkItem.booleanPass !== null) {
                if (this.result === this.checkItem.booleanPass.toString()) {
                    this.status = aps_enums_1.apsEnums.CheckStatus.Passed;
                }
                else if (this.result === (!this.checkItem.booleanPass).toString()) {
                    this.status = aps_enums_1.apsEnums.CheckStatus.Failed;
                }
            }
        };
        CheckInstance.prototype.choiceChanged = function () {
            var _this = this;
            if (!this.checkItem.choices || this.checkItem.choices.length === 0) {
                return;
            }
            this.updateAdditionalDataType();
            var choice = this.checkItem.choices.filter(function (x) { return x.value === _this.result; });
            if (!!choice && choice.length > 0) {
                var outcome = choice[0].outcome;
                if (outcome) {
                    this.status = outcome;
                }
            }
        };
        CheckInstance.prototype.updateAdditionalDataType = function () {
            var additionalDataType = this.getAdditionalDataType();
            if (additionalDataType !== this.additionalDataType) {
                this.additionalDataModel = {};
                this.additionalDataType = additionalDataType;
            }
        };
        CheckInstance.prototype.getSection = function (jobRun) {
            if (this.section && jobRun) {
                return (((this.machineConfiguration.number - 1) * jobRun.numberOfSections) + this.section).toString();
            }
            return '';
        };
        CheckInstance.prototype.check = function () {
            return this.checkItem;
        };
        CheckInstance.prototype.machine = function () {
            return this.machineConfiguration;
        };
        CheckInstance.prototype.gobName = function () {
            if (this.gob && this.jobRun) {
                return gob_utility_1.default.getGobName(this.gob, this.jobRun.numberOfGobs);
            }
            return undefined;
        };
        CheckInstance.prototype.dimensionName = function () {
            if (!this.checkItem.dimensions
                || this.checkItem.valueType === aps_enums_1.apsEnums.CheckValueType.MultipleSample
                || this.checkItem.dimensions.length < (this.sequence + 1)) {
                return null;
            }
            return this.checkItem.dimensions[this.sequence].name;
        };
        CheckInstance.prototype.getMold = function (molds) {
            var _this = this;
            if (!molds || molds.length === 0 || !this.gob || !this.section || !this.machineId) {
                return null;
            }
            var mold = molds.filter(function (x) { return x.isMachineId === _this.machineId
                && x.section === _this.section
                && x.gob === _this.gob; });
            if (mold.length === 0) {
                return null;
            }
            return mold[0];
        };
        CheckInstance.prototype.hasMold = function (molds) {
            return this.getMold(molds) !== null;
        };
        CheckInstance.prototype.moldNumber = function (molds) {
            var mold = this.getMold(molds);
            if (mold) {
                return mold.moldNumber;
            }
            return null;
        };
        CheckInstance.prototype.isStatusInvalid = function () {
            if (!this.checkItem.isMandatory) {
                return false;
            }
            return !this.status || this.status === aps_enums_1.apsEnums.CheckStatus.NotDone;
        };
        CheckInstance.prototype.isRequired = function () {
            return (this.status === aps_enums_1.apsEnums.CheckStatus.Passed
                || this.status === aps_enums_1.apsEnums.CheckStatus.Failed);
        };
        CheckInstance.prototype.autoStatus = function (checkList) {
            var _this = this;
            if (this.checkItem.dataType === aps_enums_1.apsEnums.CheckDataType.Count) {
                if (this.result && this.total) {
                    var failPercent = this.checkItem.frequencyFail / this.checkItem.frequencyTotal;
                    var actualPercent = this.result / +this.total;
                    if (actualPercent >= failPercent) {
                        this.status = aps_enums_1.apsEnums.CheckStatus.Failed;
                    }
                    else {
                        this.status = aps_enums_1.apsEnums.CheckStatus.Passed;
                    }
                }
                else {
                    this.status = aps_enums_1.apsEnums.CheckStatus.NotDone;
                }
            }
            else if (!!this.checkItem.passFailRangeCheckId && this.result) {
                var rangeCheck = checkList.results.filter(function (x) { return x.checkId === _this.checkItem.passFailRangeCheckId; });
                if (rangeCheck.length > 0 && !!rangeCheck[0].result && typeof (rangeCheck[0].result) === 'string') {
                    var range = rangeCheck[0].result.split("-");
                    if (range.length === 2) {
                        try {
                            var min = parseFloat(range[0]);
                            var max = parseFloat(range[1]);
                            if (min <= this.result && max >= this.result) {
                                this.status = aps_enums_1.apsEnums.CheckStatus.Passed;
                            }
                            else {
                                this.status = aps_enums_1.apsEnums.CheckStatus.Failed;
                            }
                        }
                        catch (_a) {
                        }
                    }
                }
            }
            return this.status;
        };
        return CheckInstance;
    }());
    exports.CheckInstance = CheckInstance;
    var CheckListInstance = (function () {
        function CheckListInstance(data) {
            this.id = data.id;
            this.checkListId = data.checkListId;
            this.shopId = data.shopId;
            this.tankId = data.tankId;
            this.plantId = data.plantId;
            this.status = data.status;
            this.isMandatory = data.isMandatory;
            this.scheduledOn = data.scheduledOn;
            this.results = [];
            this.existingChecks = data.checkInstances;
            this.plantLocationId = data.plantLocationId;
            this.previousCheckValues = data.previousCheckInstances;
        }
        CheckListInstance.prototype.checkList = function () {
            return this.checkListItem;
        };
        CheckListInstance.prototype.populateResults = function (checkList, plant, shop, authDataService) {
            var _this = this;
            this.checkListItem = checkList;
            this.plant = plant;
            this.shop = shop;
            this.jobRun = shop && shop.jobRuns ? _.last(shop.jobRuns) : null;
            _.forEach(_.sortBy(checkList.checks, 'order'), function (check) {
                var checkItem = checkListOverride_module_1.default.extendCheckItem(check);
                checkListOverride_module_1.default.setOverrideValue(checkItem, plant.id, shop ? shop.id : null, _this.jobRun ? _this.jobRun.id : null, authDataService);
                _this.populateCheck(checkItem);
            });
            var prevHeading = '';
            var prevName = '';
            _.forEach(this.results, function (item) {
                item.showHeading = item.check().heading !== prevHeading;
                item.showName = item.check().name !== prevName;
                prevHeading = item.check().heading;
                prevName = item.check().name;
            });
        };
        CheckListInstance.prototype.populateCheck = function (check) {
            switch (check.entry) {
                case aps_enums_1.apsEnums.CheckEntry.PerMachine:
                    this.populateMachineCheck(check);
                    return;
                case aps_enums_1.apsEnums.CheckEntry.PerSection:
                    this.populateSectionCheck(check);
                    return;
                case aps_enums_1.apsEnums.CheckEntry.PerCavity:
                    this.populateCavityCheck(check);
                    return;
                case aps_enums_1.apsEnums.CheckEntry.PerDrop:
                    this.populateDropCheck(check);
                    return;
                default:
                    this.populateShopCheck(check);
            }
        };
        CheckListInstance.prototype.addCheckDimension = function (check, machine, section, gob, sequence) {
            var machineId = machine ? machine.id : null;
            section = section || null;
            gob = gob || null;
            if (check.valueType === aps_enums_1.apsEnums.CheckValueType.MultipleSample) {
                sequence = 0;
            }
            var checkInstance = _.find(this.existingChecks, {
                checkId: check.id,
                machineId: machineId,
                section: section,
                gob: gob,
                sequence: sequence
            });
            if (!checkInstance) {
                checkInstance = {
                    id: null,
                    status: check.defaultOutcome,
                    result: this.getDefaultResult(check),
                    total: null,
                    checkId: check.id,
                    machineId: machineId,
                    section: section,
                    gob: gob,
                    sequence: sequence,
                    allowComments: false,
                    comment: null,
                    aggregateFunction: null,
                    aggregateValues: [],
                    additionalData: null
                };
                if (check.aggregatesCount > 1) {
                    checkInstance.aggregateValues = new Array(check.aggregatesCount);
                }
            }
            else if (!checkInstance.result) {
                checkInstance.result = this.getDefaultResult(check);
            }
            if (check.aggregateFunction) {
                checkInstance.aggregateFunction = _.startCase(aps_enums_1.apsEnums.AggregateFunction[check.aggregateFunction]);
            }
            this.results.push(new CheckInstance(this, checkInstance, check, machine, this.jobRun));
        };
        CheckListInstance.prototype.getDefaultResult = function (check) {
            var isBooleanWithDefault = check.dataType === aps_enums_1.apsEnums.CheckDataType.Boolean
                && check.booleanPass !== null
                && check.defaultOutcome
                && check.defaultOutcome !== aps_enums_1.apsEnums.CheckStatus.NotDone;
            if (!isBooleanWithDefault) {
                return null;
            }
            if (check.defaultOutcome === aps_enums_1.apsEnums.CheckStatus.Passed) {
                return check.booleanPass.toString();
            }
            if (check.defaultOutcome === aps_enums_1.apsEnums.CheckStatus.Failed) {
                return (!check.booleanPass).toString();
            }
            if (check.defaultOutcome === aps_enums_1.apsEnums.CheckStatus.NotApplicable) {
                return 'N/A';
            }
            return null;
        };
        CheckListInstance.prototype.populateShopCheck = function (check) {
            this.addCheck(check);
        };
        CheckListInstance.prototype.populateMachineCheck = function (check) {
            var _this = this;
            _.forEach(this.shop.machineConfigurations, function (machine) {
                _this.addCheck(check, machine);
            });
        };
        CheckListInstance.prototype.populateSectionCheck = function (check) {
            var _this = this;
            _.forEach(this.shop.machineConfigurations, function (machine) {
                _.forEach(_.range(1, _this.jobRun.numberOfSections + 1), function (section) {
                    _this.addCheck(check, machine, section);
                });
            });
        };
        CheckListInstance.prototype.populateCavityCheck = function (check) {
            var _this = this;
            _.forEach(this.shop.machineConfigurations, function (machine) {
                _.forEach(_.range(1, _this.jobRun.numberOfSections + 1), function (section) {
                    _.forEach(_.range(1, _this.jobRun.numberOfGobs + 1), function (gob) {
                        _this.addCheck(check, machine, section, gob);
                    });
                });
            });
        };
        CheckListInstance.prototype.populateDropCheck = function (check) {
            var _this = this;
            _.forEach(this.shop.machineConfigurations, function (machine) {
                _.forEach(_.range(1, _this.jobRun.numberOfGobs + 1), function (gob) {
                    _this.addCheck(check, machine, undefined, gob);
                });
            });
        };
        CheckListInstance.prototype.addCheck = function (check, machine, section, gob) {
            if (check.dimensions.length === 0 || check.valueType === aps_enums_1.apsEnums.CheckValueType.MultipleSample) {
                this.addCheckDimension(check, machine, section, gob, null);
            }
            else {
                for (var i = 0; i < check.dimensions.length; i++) {
                    this.addCheckDimension(check, machine, section, gob, i);
                }
            }
        };
        return CheckListInstance;
    }());
    exports.default = CheckListInstance;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(403)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, deleteDefect_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function openDeleteDefect(data, $modal) {
        return $modal.open({
            template: deleteDefect_tpl_html_1.default,
            controller: 'DeleteDefectCtrl as vm',
            resolve: {
                data: function () { return data; }
            }
        }).result;
    }
    exports.openDeleteDefect = openDeleteDefect;
    exports.default = angular.module('aps.controller.deleteDefect', [])
        .controller('DeleteDefectCtrl', ["$modalInstance", "data", function ($modalInstance, data) {
        var vm = {
            defectName: data.defectName,
            comment: null,
            form: null,
            cancel: function () { return $modalInstance.close(); },
            submit: function () {
                if (vm.form.$invalid) {
                    return;
                }
                $modalInstance.close(vm.comment);
            }
        };
        return vm;
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <form name=vm.form ng-submit=vm.submit() novalidate class=checks-m-w> <h2 class=modal-header>Delete Defect</h2> <div class=row> <div class=\"large-12 columns\"> Are you sure you want to delete defect {{vm.defectName}}?<br/> If so, please enter the reason you are deleting it and press 'Delete'. Otherwise, press 'Cancel'. <br/>&nbsp; </div> </div> <div class=row> <div class=\"large-12 columns\"> <label> <span style=color:red>*</span>Reason: <textarea name=comment ng-model=vm.comment rows=4 required/> </label> <div ng-messages=vm.form.comment.$error ng-if=\"vm.form.comment.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=\"required req-w\"><div class=arrow-up></div>Required</div> </div> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-12 columns\" style=\"margin:20px 0 0 0\"> <div class=\"right dialog-footer\"> <button type=submit class=button>Delete</button> <button type=button class=\"button secondary\" ng-click=vm.cancel()>Cancel</button> </div> </div> </div> </form> </div>");

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=view-defect> <h2 class=modal-header>Defect Details</h2> <div class=container> <div class=row style=\"margin:0 -30px;width:auto\" ng-if=!vm.showMoldLossStatus> <div class=\"small-7 columns defect-details-w\" style=padding:15px> <div class=add-defect-l ng-show=\"vm.defect.locationX && vm.defect.locationY\" id=defectBottleID element-ready=vm.drawDefect()> <img class=\"full-bottle bottle-selector\"/> </div> <div class=\"small-6 left\"> <label> <strong>Defect:</strong> <span ng-bind=vm.defect.name></span> </label> <label> <strong>Machine:</strong> <span ng-bind=vm.machineNumber></span> </label> <label ng-if=vm.dropName> <strong>Drop:</strong> <span ng-bind=vm.dropName></span> </label> <label ng-if=vm.defect.section> <strong>Section:</strong> <span ng-bind=vm.sectionName></span> </label> <label ng-if=vm.defect.gob> <strong>Gob:</strong> <span ng-bind=vm.gobName></span> </label> <label> <strong>Severity:</strong> <span ng-bind=vm.severityName></span> <button ng-if=\"vm.defect.severity === 0\" type=button class=button style=\"padding:7px;margin:0 0 0 15px\" ng-click=vm.openCriticalDefectReport()> Critical Defect Report </button> </label> </div> <div class=\"small-6 right\"> <label> <strong>Time Found:</strong> <span ng-bind=vm.formatTime(vm.defect.timeFound)></span> </label> <label> <strong>Created By:</strong> <span ng-bind=vm.defect.createdByFullName></span> </label> <label> <strong>Created On:</strong> <span ng-bind=vm.formatTime(vm.defect.createdOn)></span> </label> <div ng-if=vm.defect.isFrequencyCount()> <label> <strong>Frequency:</strong> {{vm.defect.frequencyCount}} out of {{vm.defect.frequencyTotal}} </label> </div> <div ng-if=\"vm.defect.isFrequencyPSI() || vm.defect.isFrequencyThermal()\"> <label> <strong ng-if=vm.defect.isFrequencyPSI()>PSI:</strong> <strong ng-if=vm.defect.isFrequencyThermal()>Thermal Shock:</strong> # Failed: {{vm.defect.frequencyCount}}, # Tested: {{vm.defect.frequencyTotal}} </label> </div> <div ng-if=vm.defect.isFrequencyPercentage()> <label> <strong>Frequency:</strong> {{vm.defect.frequencyPercent}}% </label> </div> <div ng-if=vm.equipment> <label> <strong>Where Found:</strong> {{vm.equipment}} </label> </div> </div> <div> <form name=vm.mntForm ng-submit=vm.updateMNTData() novalidate class=clearfix> <label ng-if=vm.isEquipmentFailure> <strong>Maintenance Start:</strong> <input name=maintenanceStart type=datetime-local ng-model=vm.maintenanceStartUI time-model=vm.maintenanceStart min=\"{{vm.minTime}}\" max=\"{{vm.theFuture}}\" required time-zone=vm.timeZoneId ng-readonly=vm.readOnly ng-disabled=vm.readOnly date-time-picker show-current-time-link=true show-found-time-link=true found-time=vm.defect.timeFound /> <div ng-messages=vm.mntForm.maintenanceStart.$error ng-if=\"vm.mntForm.maintenanceStart.$dirty || vm.mntForm.$submitted\" role=alert> <div ng-message=required class=req-w style=top:-35px!important><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w style=top:-35px!important><div class=arrow-up></div>Must be not earlier than 30 min before the time found</div> <div ng-message=max class=req-w style=top:-35px!important><div class=arrow-up></div>May not be in the future</div> </div> </label> <label ng-if=vm.isEquipmentFailure> <strong>Maintenance End:</strong> <input name=maintenanceEnd type=datetime-local ng-model=vm.maintenanceEndUI time-model=vm.maintenanceEnd min=\"{{vm.minmaintenanceEnd()}}\" max=\"{{vm.theFuture}}\" time-zone=vm.timeZoneId ng-readonly=vm.readOnly ng-disabled=vm.readOnly date-time-picker show-current-time-link=true /> <div ng-messages=vm.mntForm.maintenanceEnd.$error ng-if=\"vm.mntForm.maintenanceEnd.$dirty || vm.mntForm.$submitted\" role=alert> <div ng-message=required class=req-w style=top:-35px!important><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w style=top:-35px!important><div class=arrow-up></div>Must be greater than or equal to the start time</div> <div ng-message=max class=req-w style=top:-35px!important><div class=arrow-up></div>May not be in the future</div> <div ng-message=commentRequired class=req-w style=top:-35px!important>At least one comment is required to close this maintenance item</div> <div ng-message=maintRequired class=req-w style=top:-35px!important>Maintenance resolution must be filled out and Food certification box must be checked</div> </div> </label> </form> <form name=vm.mnrForm ng-submit=vm.updateMNRData() novalidate class=clearfix ng-if=vm.defect.gob> <label ng-if=!vm.isEquipmentFailure> <strong>Is Mold Reject In Use?:</strong> <input type=checkbox ng-model=vm.isMoldRejectInUse name=isMoldRejectInUse ng-readonly=vm.readOnly ng-disabled=vm.readOnly ng-click=vm.invokeMachineDefectQuestions(vm.isMoldRejectInUse) /> </label> <div ng-if=vm.isMoldRejectInUse style=display:inline-flex> <label class=small-6 style=margin-right:35px> <strong>Reject Start:</strong> <input name=rejectStart type=datetime-local ng-model=vm.rejectStartUI time-model=vm.rejectStart min=\"{{vm.minTime}}\" max=\"{{vm.theFuture}}\" required time-zone=vm.timeZoneId ng-readonly=vm.readOnly ng-disabled=vm.readOnly date-time-picker show-current-time-link=true show-found-time-link=true found-time=vm.defect.timeFound /> <div ng-messages=vm.mnrForm.rejectStart.$error ng-if=\"vm.mnrForm.rejectStart.$dirty || vm.mnrForm.$submitted\" role=alert> <div ng-message=required class=req-w style=top:-35px!important><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w style=top:-35px!important><div class=arrow-up></div>Must be not earlier than 30 min before the time found</div> <div ng-message=max class=req-w style=top:-35px!important><div class=arrow-up></div>May not be in the future</div> </div> </label> <label class=small-6> <strong>Reject End:</strong> <input name=rejectEnd type=datetime-local ng-model=vm.rejectEndUI time-model=vm.rejectEnd min=\"{{vm.minRejectEnd()}}\" max=\"{{vm.theFuture}}\" time-zone=vm.timeZoneId ng-readonly=true ng-disabled=true date-time-picker show-current-time-link=\"{{vm.isHERole? 'false': 'true'}}\" ng-required=\"vm.isMoldRejectInUse && vm.showMoldLoss && vm.isCERole && vm.discardMold === false\"/> <div ng-messages=vm.mnrForm.rejectEnd.$error ng-if=\"vm.mnrForm.rejectEnd.$dirty || vm.mnrForm.$submitted\" role=alert> <div ng-message=required class=req-w style=top:-35px!important><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w style=top:-35px!important><div class=arrow-up></div>Must be greater than or equal to the start time</div> <div ng-message=max class=req-w style=top:-35px!important><div class=arrow-up></div>May not be in the future</div> </div> </label> </div> <div ng-if=vm.showRequalification()> <label> <input type=checkbox ng-model=vm.requalification ng-change=vm.requalificationToggled() /> Requalification </label> </div> <div ng-if=vm.requalification> <label> Requalification Time: <input name=requalificationTime type=datetime-local ng-model=vm.requalificationDateTimeLocal min=\"{{vm.rejectEndUI}}\" max=\"{{vm.theFuture}}\" required date-time-picker time-model=vm.requalificationDateTime time-zone=vm.timeZoneId /> </label> <div ng-messages=vm.mnrForm.requalificationTime.$error ng-if=\"vm.mnrForm.requalificationTime.$dirty || vm.mnrForm.$submitted\" role=alert> <div ng-message=required class=req-w style=top:-35px!important><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w style=top:-35px!important><div class=arrow-up></div>May not be less than reject end time</div> <div ng-message=max class=req-w style=top:-35px!important><div class=arrow-up></div>May not be in the future</div> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\" ng-if=\"vm.isMoldRejectInUse && vm.showMoldLoss\"> <div class=\"small-12 columns\" style=float:left;justify-content:center;align-items:center> <fieldset style=\"border:1px #ccc solid;border-radius:5px;margin-inline-start:0;padding-block-start:0;padding-inline-start:0;margin-inline-end:0;padding-block-end:0;margin:5px\"> <legend style=margin-left:1em;padding:0;font-size:.875rem;font-weight:400><strong>Mold Loss</strong></legend> <form name=vm.moldLossForm ng-submit=vm.updateMNRData() novalidate> <div class=\"small-3 columns\"> <label> Equipment &nbsp;</label> <select ng-disabled=\"vm.moldLossEquipment !== null && vm.disableEquipment\" ng-model=vm.moldLossEquipment required name=moldLossEquipment id=moldLossEquipment ng-required=vm.isMoldRejectInUse style=margin-top:20px> <option ng-repeat=\"types in vm.moldLossEquipments | orderBy : 'text'\" ng-value=types.value>{{types.text}}</option> </select> <div ng-messages=vm.moldLossForm.moldLossEquipment.$error ng-if=\"vm.moldLossForm.moldLossEquipment.$dirty || vm.moldLossForm.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> </form> <div class=\"small-3 columns\"> <label> Discard Mold <strong>{{vm.moldLoss.moldId}} </strong> &nbsp;</label> <select ng-model=vm.discardMold id=discardMold style=width:60px ng-disabled=!vm.isCERole> <option ng-repeat=\"o in vm.discardMoldOptions\" ng-value=o.name>{{o.value}}</option> </select> </div> <div class=\"small-4 columns\"> <label> Discard All Invalid Molds </label> <select ng-model=vm.discardInvalidMolds id=dicardInvalidMold style=width:60px ng-required=vm.discardInvalidMolds ng-disabled=!vm.isCERole> <option ng-repeat=\"o in vm.discardMoldOptions\" ng-value=o.name>{{o.value}}</option> </select> </div> <div class=\"small-2 columns\"> <button type=button class=button style=padding:10px;margin-top:46px ng-click=vm.toggleMoldLossStatus()>status</button> </div> </fieldset> </div> </div> <div ng-if=vm.machineDefectQuestions style=margin-top:10px> <form name=vm.defectQAForm ng-submit=vm.updateMNRData() novalidate> <div ng-repeat=\"q in vm.machineDefectQuestions | orderBy:'sequence'\"> <label><strong>{{q.question}}</strong></label> <div class=row style=\"margin:0 -30px;width:auto;display:flex\"> <div class=\"columns small-2\"><label><input type=radio ng-model=q.questionValue name=\"{{q.questionId }}\" ng-value=true ng-disabled=\"(vm.isCERole && q.isHEQuestion) || (vm.isHERole && !q.isHEQuestion)\" ng-required=\"vm.vm.rejectEnd && !vm.isHERole && !q.isHEQuestion\"/> Yes </label></div> <div class=\"columns small-2\"><label><input type=radio ng-model=q.questionValue name=\"{{q.questionId }}\" ng-value=false ng-disabled=\"(vm.isCERole && q.isHEQuestion) || (vm.isHERole && !q.isHEQuestion)\" ng-required=\"vm.rejectEnd && !vm.isHERole && !q.isHEQuestion\"/> No </label></div> <label ng-if=\"q.lastUpdatedBy && q.lastUpdatedDate\" class=\"columns small-12\" style=padding:0!important>(<b>Updated By:</b> {{q.lastUpdatedBy }}-{{ vm.formatTime(q.lastUpdatedDate) }})</label> </div> <div ng-messages=vm.defectQAForm[q.questionId].$error ng-if=\"vm.defectQAForm[q.questionId].$dirty || vm.defectQAForm.$submitted\" role=alert> <div ng-message=required class=req-w style=top:-20px!important><div class=arrow-up></div>Required</div> </div> </div> </form> </div> </form> </div> </div> <div class=right ng-if=\"vm.showCauses && !vm.readOnly\"> <button class=button ng-click=vm.reviewCausesAndCoursesOfAction()> Review Causes And Courses Of Action </button> </div> <div class=\"small-5 columns\" style=padding:15px;background:#f3f3f3> <div> <div ng-repeat=\"comment in vm.defect.comments\" style=color:#fff;background:#1791cc;padding:8px;border-radius:5px;font-size:.75em;margin-bottom:8px;width:100%;float:left> <span ng-bind=comment.createdByFullName></span> <br> <span ng-bind=comment.comment></span> <span ng-bind=vm.formatTime(comment.createdOn) style=width:100%;float:left;clear:both;font-size:.65em;color:#98d1ec></span> </div> </div> <div ng-if=vm.canComment> <form name=vm.commentForm ng-submit=vm.addDefectComment() novalidate> <label> New Comment: <textarea name=comment ng-model=vm.defectNewComment rows=4 cols=40 required></textarea> <div ng-messages=vm.commentForm.comment.$error ng-if=\"vm.commentForm.comment.$dirty || vm.commentForm.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> <label class=right> <input type=submit class=\"button small\" value=\"Add Comment\"/> </label> </form> </div> <div ng-if=vm.defect.isEquipmentFailure style=\"padding-top:12px;border-top:1px solid\"> <label for=resolution style=font-weight:700>Maintenance Resolution:</label> <textarea ng-if=vm.isMaintenance name=comment ng-model=vm.maintenanceResolution rows=4 cols=40 required></textarea> <div ng-if=!vm.isMaintenance> <div style=\"padding:4px 0;font-size:smaller\"><span ng-bind=vm.formatTime(vm.defect.resolutionTime)></span> {{vm.defect.resolvedBy}}</div> <div style=\"margin:10px 0;font-style:italic\">{{vm.maintenanceResolution}}</div> </div> <div> <input type=checkbox ng-model=vm.isFoodCertifiable style=margin-top:5px ng-disabled=!vm.isMaintenance><label style=float:right;width:88%>Tools, spare parts, and excess lubrication have been removed from the machine.<br/>Returning machine for food safety operation.<br/>Machine is clean of contamination.</label> <label class=right ng-if=vm.isMaintenance> <input type=button class=\"button small\" value=\"Update Resolution\" ng-click=vm.updateMNTResolution() style=margin-top:10px /> </label> </div> </div> </div> <div class=\"small-5 columns\" style=padding:15px> <div ng-if=\"vm.defect.heldPallets.length > 0\"> Held Pallets: <ul> <li ng-repeat=\"heldPallet in vm.defect.heldPallets | orderBy:'palletStart'\"> <span ng-if=heldPallet.palletEnd>Pallets {{heldPallet.palletStart}} to {{heldPallet.palletEnd}}</span> <span ng-if=!heldPallet.palletEnd>Pallet {{heldPallet.palletStart}}</span> <a ng-if=heldPallet.id ng-click=vm.removeHeldPallet(heldPallet) style=font-size:.65em> <i class=\"fa fa-times\" style=color:red></i> Remove </a> </li> </ul> </div> <div ng-if=vm.canComment> <form name=vm.addHeldPalletsForm ng-submit=vm.addHeldPallets() novalidate> Add Held Pallets: <label> Start Pallet: <input name=palletStart type=number ng-model=vm.heldPalletStart required min=1 step=1 /> <div ng-messages=vm.addHeldPalletsForm.palletStart.$error ng-if=\"vm.addHeldPalletsForm.palletStart.$dirty || vm.addHeldPalletsForm.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=step class=req-w><div class=arrow-up></div>Must be an integer</div> </div> </label> <label> End Pallet (leave empty for a single pallet): <input name=palletEnd type=number ng-disabled=!vm.heldPalletStart ng-model=vm.heldPalletEnd min=\"{{vm.heldPalletStart + 1}}\" step=1 /> <div ng-messages=vm.addHeldPalletsForm.palletEnd.$error ng-if=\"vm.addHeldPalletsForm.palletEnd.$dirty || vm.addHeldPalletsForm.$submitted\" role=alert> <div ng-message=step class=req-w><div class=arrow-up></div>Must be an integer</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be greater than Start Pallet</div> </div> </label> <input type=submit class=\"button small\" value=\"Add Held Pallets\"/> </form> </div> </div> </div> <div style=\"margin:0 -30px;width:auto;max-height:400px;overflow:auto\" ng-if=vm.showMoldLossStatus> <table class=history-t style=\"border:1px #ccc solid\"> <tr style=vertical-align:top> <thead> <th style=width:30px;padding:2px>Critical</th> <th style=width:30px;padding:2px>Mold</th> <th style=width:60px;padding:2px>Discard Mold</th> <th style=width:60px;padding:2px>Discard Invalid Molds</th> <th style=width:100px;padding:2px>Time</th> <th style=width:290px>Equipment Responses</th> </thead> </tr> <tr ng-repeat=\"status in vm.moldLossStatusList  | orderBy:'-createdOn'\" style=vertical-align:top> <td ng-bind=status.critical></td> <td ng-bind=status.moldId></td> <td ng-bind=status.rejectMold></td> <td ng-bind=status.rejectInvalidMolds></td> <td ng-bind=vm.formatTime(status.createdOn)></td> <td> <table> <tr ng-repeat=\"r in status.defectMoldLossResponses | orderBy: ['lineNumber', 'equipmentName']\"> <td>{{r.lineNumber}}|</td> <td>{{r.equipmentName}}</td> <td><span ng-if=\"status.isRejectMold != undefined\">|Mold: {{r.rejectMoldStatus ? 'Success': 'Error'}}</span></td> <td><span ng-if=\"status.isRejectInvalidMolds != undefined && r.rejectInvalidMoldStatus !== null\">|Invalid Molds: {{r.rejectInvalidMoldStatus ? 'Success' : 'Error'}}</span></td> </tr> </table> </td> </tr> </table> </div> <div class=row style=\"margin:0 -30px;width:auto\" ng-if=\"vm.showMoldLoss && vm.showMoldLossStatus\"> <div class=\"small-12 columns\" style=float:left;justify-content:center;align-items:center> <fieldset style=\"border:1px #ccc solid;border-radius:5px;margin-inline-start:0;padding-block-start:0;padding-inline-start:0;margin-inline-end:0;padding-block-end:0;margin:5px\"> <legend style=margin-left:1em;padding:0;font-size:.875rem;font-weight:400><strong>Mold Loss</strong></legend> <form name=vm.moldLossForm ng-submit=vm.updateMNRData() novalidate> <div class=\"small-3 columns\"> <label> Equipment &nbsp;</label> <select ng-disabled=\"vm.moldLossEquipment !== undefined && vm.disableEquipment\" ng-model=vm.moldLossEquipment required name=moldLossEquipment id=moldLossEquipment ng-required=vm.isMoldRejectInUse> <option ng-repeat=\"types in vm.moldLossEquipments | orderBy : 'text'\" ng-value=\"{{types.value}}\">{{types.text}}</option> </select> <div ng-messages=vm.moldLossForm.moldLossEquipment.$error ng-if=\"vm.moldLossForm.moldLossEquipment.$dirty || vm.moldLossForm.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> </form> <div class=\"small-3 columns\"> <label> Discard Mold <strong>{{vm.moldLoss.moldId}} </strong> &nbsp;</label> <select ng-model=vm.discardMold id=discardMold style=width:60px ng-disabled=!vm.isCERole> <option ng-repeat=\"o in vm.discardMoldOptions\" ng-value=o.name>{{o.value}}</option> </select> </div> <div class=\"small-4 columns\"> <label> Discard All Invalid Molds </label> <select ng-model=vm.discardInvalidMolds id=dicardInvalidMold style=width:60px ng-required=vm.discardInvalidMolds ng-disabled=!vm.isCERole> <option ng-repeat=\"o in vm.discardMoldOptions\" ng-value=o.name>{{o.value}}</option> </select> </div> <div class=\"small-2 columns\"> <button type=button class=button style=padding:10px;margin-top:16px ng-click=vm.toggleMoldLossStatus()>status</button> </div> </fieldset> </div> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-12 columns\"> <div class=dialog-footer> <div class=left ng-if=!vm.readOnly> <button type=button class=\"button alert\" ng-click=vm.deleteDefect()> Delete </button> </div> <div class=right> <button type=button class=\"button secondary\" ng-click=vm.cancel()> Close </button> </div> <div class=right ng-if=\"vm.hasMNRDataChange() && !vm.readOnly && !vm.showMoldLossStatus\"> <button type=button class=button ng-click=vm.updateMNRData()>{{(!vm.isMoldRejectInUse && vm.defect.defectTypeLegacyId === 901) ? 'Submit':'Update Mold Reject Status'}}</button> </div> <div class=right ng-if=\"vm.hasMNTDataChange() && !vm.readOnly && !vm.showMoldLossStatus\"> <button type=button class=button ng-click=vm.updateMNTData()>Update Equipment Failure Status</button> </div> </div> </div> </div> </div> </div>");

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(406)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, notificationComment_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function openNotificationComment(data, $modal) {
        return $modal.open({
            template: notificationComment_tpl_html_1.default,
            controller: 'NotificationCommentCtrl as vm',
            resolve: {
                data: function () {
                    return data;
                }
            }
        }).result;
    }
    exports.openNotificationComment = openNotificationComment;
    var NotificationCommentCtrl = (function () {
        NotificationCommentCtrl.$inject = ["$modalInstance", "data"];
        function NotificationCommentCtrl($modalInstance, data) {
            this.$modalInstance = $modalInstance;
            if (data) {
                this.title = data.title;
            }
        }
        NotificationCommentCtrl.prototype.submit = function () {
            if (this.form.$invalid) {
                return;
            }
            this.$modalInstance.close(this.comment);
        };
        NotificationCommentCtrl.prototype.cancel = function () {
            this.$modalInstance.close();
        };
        return NotificationCommentCtrl;
    }());
    exports.default = angular.module('aps.controller.notificationComment', [])
        .controller('NotificationCommentCtrl', NotificationCommentCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <form name=vm.form ng-submit=vm.submit() novalidate class=checks-m-w> <h2 class=modal-header>{{vm.title || 'Dismiss Notification'}}</h2> <div class=row> <div class=\"large-12 columns\"> <label> <span style=color:red>*</span>Comment: <textarea name=comment ng-model=vm.comment rows=4 required/> </label> <div ng-messages=vm.form.comment.$error ng-if=\"vm.form.comment.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=\"required req-w\"><div class=arrow-up></div>Required</div> </div> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-12 columns\" style=\"margin:20px 0 0 0\"> <div class=\"right dialog-footer\"> <button type=submit class=button>OK</button> <button type=button class=\"button secondary\" ng-click=vm.cancel()>Cancel</button> </div> </div> </div> </form> </div>");

/***/ }),
/* 407 */,
/* 408 */,
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(4), __webpack_require__(6), __webpack_require__(60), __webpack_require__(52), __webpack_require__(2), __webpack_require__(410), __webpack_require__(411), __webpack_require__(89)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, loader_service_1, notify_service_1, userProfile_1, user_service_1, _, userProfile_tpl_html_1, changeUserPassword_controller_1, isNullOrUndefined_1) {
    "use strict";
    userProfileCtrl.$inject = ["$modalInstance", "$modal", "loaderService", "notifyService", "userProfile", "userService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, notify_service_1.default, userProfile_1.default, user_service_1.default, changeUserPassword_controller_1.default];
    function openUserProfile($modal) {
        return $modal.open({
            template: userProfile_tpl_html_1.default,
            controller: 'UserProfileCtrl as vm'
        });
    }
    exports.openUserProfile = openUserProfile;
    exports.default = angular.module('aps.controller.userProfile', requires)
        .controller('UserProfileCtrl', userProfileCtrl)
        .name;
    function userProfileCtrl($modalInstance, $modal, loaderService, notifyService, userProfile, userService) {
        var vm = this;
        vm.defectDisplayOptions = ['By Abbreviation', 'By Number'];
        vm.securityQuestions = [];
        vm.user = undefined;
        var numberFormat = function () {
            var phoneNumber = vm.user.phoneNumber;
            if ((phoneNumber || '') === '') {
                return;
            }
            if (phoneNumber.length > 7) {
                phoneNumber = '(' + phoneNumber.substr(0, 3) + ') ' + phoneNumber.substr(3, 3) + '-' + phoneNumber.substr(6);
            }
            else {
                phoneNumber = phoneNumber.substr(0, 3) + '-' + phoneNumber.substr(3);
            }
            vm.user.phoneNumber = phoneNumber;
        };
        var promise = userProfile.read().then(function (userData) {
            vm.user = userData;
            vm.user.displayDefectsByNumber = isNullOrUndefined_1.default(userData.displayDefectsByNumber)
                ? true : userData.displayDefectsByNumber;
            vm.defectDisplay = vm.defectDisplayOptions[(vm.user.displayDefectsByNumber ? 1 : 0)];
            vm.userName = vm.user.userName;
            numberFormat();
            return userService.getSecurityQuestions().then(function (questions) {
                vm.securityQuestions = questions;
                if (vm.user.securityQuestion) {
                    vm.securityQuestion = _.find(vm.securityQuestions, { question: vm.user.securityQuestion });
                }
            });
        });
        loaderService.loadingPromise(promise);
        vm.save = function () {
            vm.user.displayDefectsByNumber = (vm.defectDisplayOptions.indexOf(vm.defectDisplay) > 0);
            var saveData = {
                id: vm.user.id,
                email: vm.user.email,
                phoneNumber: vm.user.phoneNumber,
                securityQuestionId: undefined,
                securityAnswer: undefined,
                displayDefectsByNumber: vm.user.displayDefectsByNumber
            };
            if (vm.securityQuestion) {
                saveData.securityQuestionId = vm.securityQuestion.id;
                saveData.securityAnswer = (vm.securityAnswer || '').toString().toLowerCase();
            }
            if (!saveData.email) {
                saveData.email = undefined;
            }
            if (saveData.phoneNumber) {
                saveData.phoneNumber = saveData.phoneNumber.replace(/\D/g, '');
            }
            else {
                saveData.phoneNumber = undefined;
            }
            loaderService.loadingPromise(userService.saveUserProfile(saveData).then(function () {
                notifyService.success('Saved', 'User Profile');
                userProfile.updateEditProfile(saveData);
                $modalInstance.close();
            }, notifyService.handleApiErrors));
        };
        vm.close = function () {
            $modalInstance.close();
        };
        vm.changePassword = function () {
            changeUserPassword_controller_1.openChangeUserPassword(vm.user, $modal);
        };
        return vm;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=view-defect> <h2 class=modal-header>User Profile</h2> <form name=vm.form ng-submit=vm.save() novalidate> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-4 columns\"> <label> <strong>User Name:</strong> {{vm.userName}} </label> </div> <div class=\"small-4 columns\"> <label> <strong>First Name:</strong> {{vm.user.firstName}} </label> </div> <div class=\"small-4 columns\"> <label> <strong>Last Name:</strong> {{vm.user.lastName}} </label> </div> </div> <br> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-4 columns\"> <label> <strong>Email:</strong> <input name=email type=email ng-model=vm.user.email /> </label> <div ng-messages=vm.form.email.$error ng-if=\"vm.form.email.$dirty || vm.form.$submitted\" role=alert> <div ng-message=email>Must be a valid email address</div> </div> </div> <div class=\"small-4 columns\"> <label> <strong>Phone Number:</strong> <input name=phoneNumber type=tel ng-model=vm.user.phoneNumber /> </label> <div ng-messages=vm.form.phoneNumber.$error ng-if=\"vm.form.phoneNumber.$dirty || vm.form.$submitted\" role=alert> <div ng-message=tel>Must be a valid telephone number</div> </div> </div> <div class=\"small-4 columns\"> <label> <strong>Defect Display:</strong> <select name=displayDefectsAs ng-model=vm.defectDisplay ng-options=\"defectDisplayOption for defectDisplayOption in vm.defectDisplayOptions\"> </select> </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-6 columns\"> <label> <strong>Security Question:</strong> <select name=securityQuestion ng-model=vm.securityQuestion ng-options=\"securityQuestion.question for securityQuestion in vm.securityQuestions\"> <option value=\"\">-- Select a security question --</option> </select> </label> </div> <div class=\"small-6 columns\"> <div ng-if=vm.securityQuestion> <label> <strong>Security Answer:</strong> <input name=securityAnswer type=text ng-model=vm.securityAnswer required/> </label> <div ng-messages=vm.form.securityAnswer.$error ng-if=\"vm.form.securityAnswer.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required>Required</div> </div> </div> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-12 columns\"> <div class=dialog-footer> <input type=submit class=button value=Save /> <button type=button ng-click=vm.close() class=\"button secondary\">Close</button> <button type=button ng-click=vm.changePassword() class=\"left button\">Change Password</button> </div> </div> </div> </form> </div>");

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(4), __webpack_require__(6), __webpack_require__(412), __webpack_require__(413)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, loader_service_1, notify_service_1, changePassword_service_1, changeUserPassword_tpl_html_1) {
    "use strict";
    userChangePasswordCtrl.$inject = ["$modalInstance", "loaderService", "notifyService", "changePwdService", "data"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, notify_service_1.default, changePassword_service_1.default];
    function openChangeUserPassword(data, $modal) {
        return $modal.open({
            template: changeUserPassword_tpl_html_1.default,
            controller: 'UserChangePasswordCtrl as vm',
            resolve: {
                data: function () {
                    return data;
                }
            }
        }).result;
    }
    exports.openChangeUserPassword = openChangeUserPassword;
    exports.default = angular.module('aps.controller.changeUserPassword', requires)
        .controller('UserChangePasswordCtrl', userChangePasswordCtrl)
        .name;
    function userChangePasswordCtrl($modalInstance, loaderService, notifyService, changePwdService, data) {
        var vm = this;
        vm.userProfile = data;
        vm.oldPassword = '';
        vm.newPassword = '';
        vm.confirmPassword = '';
        vm.close = function () {
            $modalInstance.close();
        };
        vm.changePassword = function () {
            var data = {
                id: vm.userProfile.id,
                oldPassword: vm.oldPassword,
                password: vm.newPassword,
                passwordConfirm: vm.confirmPassword
            };
            loaderService.loadingPromise(changePwdService.changePassword(data).then(function () {
                notifyService.success('Password Changed', 'User Profile');
                $modalInstance.close();
            }, notifyService.handleApiErrors));
        };
        return vm;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.services.changepassword', [http_service_1.default])
        .service('changePwdService', ["httpService", function (httpService) {
        var changePassword = function (data) {
            return httpService.post(constant_module_1.Endpoints.CHANGE_PASSWORD, data);
        };
        return {
            changePassword: changePassword
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=view-defect> <h2 class=modal-header>Change Password</h2> <div class=container> <form name=vm.form ng-submit=vm.changePassword() novalidate> <label> <strong>User Name:</strong> <span ng-bind=vm.userProfile.userName></span> </label> <label> <strong>Old Password:</strong> <input name=oldPassword type=password ng-model=vm.oldPassword required/> <div ng-messages=vm.form.oldPassword.$error ng-if=\"vm.form.oldPassword.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required>Required</div> </div> </label> <label> <strong>Password:</strong> <input name=newPassword type=password ng-model=vm.newPassword ng-minlength=8 required has-lower has-upper has-number/> <div ng-messages=vm.form.newPassword.$error ng-if=\"vm.form.newPassword.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required>Required</div> <div ng-message=minlength class=req-w><div class=arrow-up></div>Password must be a minimum of 8 characters long</div> <div ng-message=hasLower class=req-w><div class=arrow-up></div>Password must have one or more lowercase letters</div> <div ng-message=hasUpper class=req-w><div class=arrow-up></div>Password must have one or more uppercase letters</div> <div ng-message=hasNumber class=req-w><div class=arrow-up></div>Password must have one or more numbers</div> </div> </label> <label> <strong>Confirm:</strong> <input name=confirmPassword type=password ng-model=vm.confirmPassword required compare-to=vm.newPassword /> <div ng-messages=vm.form.confirmPassword.$error ng-if=\"vm.form.confirmPassword.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=compareTo class=req-w><div class=arrow-up></div>Passwords must match</div> </div> </label> <button type=submit>Change Password</button> <button type=button ng-click=vm.close()>Close</button> </form> </div> </div>");

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(3), __webpack_require__(11), __webpack_require__(23), __webpack_require__(38), __webpack_require__(415), __webpack_require__(283)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, constant_module_1, dateutility_service_1, shops_service_1, fillOutCheckList_controller_1, blockedSignOff_tpl_html_1, addDowntime_controller_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [shops_service_1.default, fillOutCheckList_controller_1.default, addDowntime_controller_1.default];
    function openBlockedSignOff(params, $modal) {
        return $modal.open({
            template: blockedSignOff_tpl_html_1.default,
            controller: 'BlockedSignOffCtrl as vm',
            resolve: {
                params: function () { return params; }
            }
        });
    }
    exports.openBlockedSignOff = openBlockedSignOff;
    var BlockedSignOffCtrl = (function () {
        BlockedSignOffCtrl.$inject = ["params", "shopService", "$modal", "$modalInstance"];
        function BlockedSignOffCtrl(params, shopService, $modal, $modalInstance) {
            var _this = this;
            this.loading = true;
            this.timeZoneId = constant_module_1.Strings.DEFAULT_TIMEZONE;
            this.$modal = $modal;
            this.$modalInstance = $modalInstance;
            this.signOffImpl = params.signOff;
            shopService.getShopConfiguration(params.shopId)
                .then(function (shop) {
                _this.shop = shop;
                _this.timeZoneId = shop.timeZoneId;
                _this.openDowntimes = params.openDowntimes;
                _this.blockingChecklists = params.blockingChecklists;
                _this.loading = false;
            });
        }
        BlockedSignOffCtrl.prototype.formatTime = function (time) {
            return dateutility_service_1.default.formatTime(time, this.timeZoneId);
        };
        BlockedSignOffCtrl.prototype.openDowntime = function (downtime) {
            var vm = this;
            var fakeSectionForAddDowntimeCtrl = {
                name: null,
                machine: {
                    id: downtime.isMachineId,
                    sections: [],
                    latestTools: null,
                    gobs: [],
                    name: '',
                    machineLevelActivity: null,
                    shop: null,
                    number: null
                },
                gobs: [],
                latestTools: null,
                sectionNumber: null
            };
            if (!_.isNull(downtime.section)) {
                fakeSectionForAddDowntimeCtrl.name = downtime.section.toString(10);
                fakeSectionForAddDowntimeCtrl.machine.sections.push(fakeSectionForAddDowntimeCtrl);
            }
            this.$modalInstance.close();
            addDowntime_controller_1.openAddDowntime({
                section: fakeSectionForAddDowntimeCtrl,
                shopId: this.shop.id,
                date: downtime.downtimeStart,
                timeZoneId: vm.timeZoneId,
                downtime: downtime,
                canComment: null,
                readOnly: null
            }, this.$modal);
        };
        BlockedSignOffCtrl.prototype.openChecklist = function (checklist) {
            this.$modalInstance.close();
            fillOutCheckList_controller_1.openFillOutCheckList({
                checkListId: checklist.checkListId,
                instanceId: checklist.id,
                shopId: this.shop.id,
                plantId: this.shop.plantId,
                tankId: this.shop.tankId,
                plantLocationId: checklist.plantLocationId,
                scheduledOn: checklist.scheduledOn
            }, this.$modal);
        };
        BlockedSignOffCtrl.prototype.dismissDowntime = function (downtime) {
            downtime.userSignoffDismissed = true;
        };
        BlockedSignOffCtrl.prototype.dismissChecklist = function (checklist) {
            checklist.userSignoffDismissed = true;
        };
        BlockedSignOffCtrl.prototype.workItemsNotDismissed = function () {
            var checklistsActive = this.blockingChecklists && _.some(this.blockingChecklists, function (c) {
                return !c.userSignoffDismissed;
            });
            var downtimesActive = this.openDowntimes && _.some(this.openDowntimes, function (d) {
                return !d.userSignoffDismissed;
            });
            return checklistsActive || downtimesActive;
        };
        BlockedSignOffCtrl.prototype.signOff = function () {
            if (this.workItemsNotDismissed()) {
                return;
            }
            if (this.signOffImpl) {
                this.$modalInstance.close();
                this.signOffImpl();
            }
        };
        return BlockedSignOffCtrl;
    }());
    exports.default = angular.module('aps.controller.blockedSignOff', requires)
        .controller('BlockedSignOffCtrl', BlockedSignOffCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<form ng-submit=vm.signOff() novalidate> <h2 class=modal-header>Unfinished Work</h2> <div ng-if=vm.loading>Loading unfinished work. Please wait ...</div> <div class=main-table-w ng-if=!vm.loading> <div ng-if=\"vm.openDowntimes && vm.openDowntimes.length\"> <h3>Open Downtimes</h3> <table cellpadding=1 cellspacing=1 class=history-t> <thead> <tr> <th>Reason</th> <th>Start Time</th> <th>&nbsp;</th> </tr> </thead> <tbody> <tr ng-repeat=\"openDowntime in vm.openDowntimes | orderBy: 'downtimeStart'\" ng-click=vm.openDowntime(openDowntime)> <td>{{ openDowntime.downtimeReasonDescription }}</td> <td>{{ vm.formatTime(openDowntime.downtimeStart) }}</td> <td> <button type=button class=\"button alert tiny\" ng-click=\"vm.dismissDowntime(openDowntime); $event.stopPropagation()\" ng-class=\"{ disabled : openDowntime.userSignoffDismissed }\" tabindex=0 style=margin:0>Dismiss</button> </td> </tr> </tbody> </table> </div> <div ng-if=\"vm.blockingChecklists && vm.blockingChecklists.length\"> <h3>Blocking Checklists</h3> <table cellpadding=1 cellspacing=1 class=history-t> <thead> <tr> <th>Name</th> <th>Schedule</th> <th>Scheduled On</th> <th>&nbsp;</th> </tr> </thead> <tbody> <tr ng-repeat=\"checkList in vm.blockingChecklists | orderBy: 'scheduledOn'\" ng-click=vm.openChecklist(checkList)> <td>{{checkList.checkListName}}</td> <td ng-if=checkList.isScheduled>Scheduled</td> <td ng-if=!checkList.isScheduled>Unscheduled</td> <td>{{ vm.formatTime(checkList.scheduledOn) }}</td> <td> <button type=button class=\"button alert tiny\" ng-click=\"vm.dismissChecklist(checkList); $event.stopPropagation()\" ng-class=\"{ disabled: checkList.userSignoffDismissed }\" tabindex=0 style=margin:0>Dismiss</button> </td> </tr> </tbody> </table> </div> <div class=row ng-if=!vm.loading> <div class=\"large-12 columns\"> <div class=\"right dialog-footer\"> <button type=submit ng-disabled=vm.workItemsNotDismissed() class=\"button secondary\" ng-class=\"{ secondary : vm.workItemsNotDismissed() }\" ng-attr-title=\"{{ vm.workItemsNotDismissed() ? 'Dismiss all unfinished work to sign off' : '' }}\">Sign Off</button> </div> </div> </div> </div> </form> ");

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=add-downtime> <h2 class=modal-header ng-if=vm.editMode>Downtime Details</h2> <h2 class=modal-header ng-if=!vm.editMode>Add Downtime</h2> <br/> <form name=vm.form ng-submit=vm.saveDowntime() novalidate> <div ng-if=\"vm.editMode === false\"> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-6 columns\"> <label> Area: <select name=type ng-model=vm.downtimeType ng-options=\"cls.downtimeTypeDescription for cls in vm.downtimeTypes | orderBy: 'downtimeTypeDescription' \" ng-change=vm.typeChanged()> <option value=\"\">-- Select an Area --</option> </select> </label> </div> <div class=\"small-6 columns\"> <label> <span class=\"required notated\">*</span>Reason: <select name=reason ng-model=vm.downtimeReason ng-options=\"reason.description for reason in vm.downtimeReasons\r\n                 | filter: vm.filterDowntimeReasons | orderBy : 'description' \" ng-change=vm.toggleSections() required> <option value=\"\">-- Select a Reason --</option> </select> </label> <div ng-messages=vm.form.reason.$error ng-if=\"vm.form.reason.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> </div> <div ng-if=vm.displaySections> <table class=mold-selection> <thead> <tr> <th>&nbsp;</th> <th colspan=\"{{vm.selections.length}}\"></th> </tr> </thead> <tbody> <tr> <th>Section</th> <th ng-repeat=\"selection in vm.selections\"> <button type=button class=\"button button-small\" ng-model=selection.selected ng-click=vm.sectionsUpdated() btn-checkbox> {{selection.section.name}} </button> </th> </tr> </tbody></table> <div class=req-w ng-if=\"vm.form.$submitted && !vm.sectionAndMachineSelectionIsValid()\"> <div class=arrow-up></div> Please select at least one Section </div> </div> </div> <div ng-if=vm.editMode class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-6 columns\"> <label> Created By: <span ng-bind=vm.createdBy></span> </label> </div> </div> <div ng-if=vm.editMode class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-6 columns\"> <label> Reason: <span ng-bind=vm.downtimeReasonDescription></span> </label> </div> <div class=\"small-6 columns\" ng-if=vm.editMode> <label> Section: <span ng-bind=vm.section.name ng-if=vm.displaySections></span> <span ng-if=vm.entireMachine>Entire Machine</span> </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-6 columns\" ng-if=vm.editMode> <label> Start Time: <span ng-bind=vm.formatTime(vm.startTime)></span> </label> </div> <div class=\"small-6 columns\" ng-if=!vm.editMode> <label> Start Time: <input name=startTime type=datetime-local ng-model=vm.startTimeLocal min=\"{{vm.minTime}}\" max=\"{{vm.maxTime}}\" required date-time-picker time-model=vm.startTime time-zone=vm.timeZoneId single-hour=true /> <div ng-messages=vm.form.startTime.$error ng-if=\"vm.form.startTime.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be within the hour</div> <div ng-message=max class=req-w><div class=arrow-up></div>Must be within the hour</div> </div> </label> </div> <div class=\"small-6 columns\" ng-if=vm.canAddDuration> <label> Duration (minutes): <input name=duration type=number ng-model=vm.duration min=1 max=1439 /> <div ng-messages=vm.form.duration.$error ng-if=\"vm.form.duration.$dirty || vm.form.$submitted\" role=alert> <div ng-message=min class=req-w><div class=arrow-up></div>Must be between greater than 0</div> <div ng-message=max class=req-w><div class=arrow-up></div>Must be less than 24 hours</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> </div> </label> </div> <div class=\"small-6 columns\" ng-if=!vm.canAddDuration> <label> Duration: <span>{{vm.duration}} minutes</span> </label> </div> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div> <div ng-repeat=\"comment in vm.comments\" style=color:#fff;background:#1791cc;padding:8px;border-radius:5px;font-size:.75em;margin-bottom:8px;width:100%;float:left> <span ng-bind=comment.comment></span> <span ng-bind=vm.formatTime(comment.createdOn) style=width:100%;float:left;clear:both;font-size:.65em;color:#98d1ec></span> <br> <span ng-bind=comment.createdByFullName></span> </div> </div> <div class=\"small-12 columns\" ng-if=vm.canComment> <label> Comment: <textarea name=comment ng-model=vm.downtimeComment rows=4 cols=40></textarea> </label> </div> </div> <div class=row style=\"margin:30px -30px -30px -45px;width:auto\"> <div class=\"small-12 columns\"> <div class=dialog-footer> <div class=left> <input type=button class=\"button alert\" value=Delete ng-if=\"vm.editMode && !vm.readOnly\" ng-click=vm.deleteDowntime() /> </div> <div class=right> <input type=button class=\"button secondary\" value=Cancel ng-click=vm.cancel() /> <input type=submit class=button value=\"Add Downtime\" ng-if=!vm.editMode ng-disabled=!vm.readyForSubmit /> <input type=submit class=button value=\"Save Downtime\" ng-if=\"vm.editMode && vm.canComment\" ng-disabled=!vm.readyForSubmit /> </div> </div> </div> </div> </form> </div>");

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(418)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, openReleaseNotes_tpl_html_1) {
    "use strict";
    openReleaseNotesCtrl.$inject = ["$modalInstance", "releaseData"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [];
    function openReleaseNotes($modal, data) {
        return $modal.open({
            template: openReleaseNotes_tpl_html_1.default,
            controller: "OpenReleaseNotesCtrl as vm",
            resolve: {
                releaseData: function () { return data; }
            }
        });
    }
    exports.openReleaseNotes = openReleaseNotes;
    function openReleaseNotesCtrl($modalInstance, releaseData) {
        var vm = this;
        vm.notification = releaseData;
        vm.title = releaseData.title;
        vm.description = releaseData.description;
        vm.openRleaseNotes = function () {
        };
        vm.close = function () {
            $modalInstance.close();
        };
        vm.getDescriptionList = function () {
            if (!vm.description)
                return [];
            return vm.description
                .split(/\d+\.\s/)
                .filter(function (item) {
                return item.trim() !== '';
            });
        };
    }
    exports.default = angular
        .module("aps.controller.openReleaseNotes", requires)
        .controller("OpenReleaseNotesCtrl", openReleaseNotesCtrl).name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<form novalidate> <h2 class=modal-header>Release Notes</h2> <div class=main-table-w> <div class=row> <div class=\"large-12 columns\"> <div> <b>Title:</b>{{vm.title}} </div> <br> <div ng-bind-html=vm.description> <!-- <b>Description:</b>\r\n             <ul>\r\n              <li ng-repeat=\"item in vm.getDescriptionList() track by $index\"> {{ item }} </li>\r\n            </ul> --> </div> <div class=\"right dialog-footer\"> <button type=button class=\"button secondary\" ng-click=vm.close()>Close</button> </div> </div> </div> </div> </form> ");

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(420), __webpack_require__(423)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, nav_controller_1, nav_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.directive.nav', [nav_controller_1.default])
        .directive('apsNav', navDef)
        .name;
    function navDef() {
        return {
            restrict: 'E',
            template: nav_tpl_html_1.default,
            replace: false,
            controller: 'NavCtrl',
            controllerAs: 'vm',
            bindToController: true
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(421), __webpack_require__(8), __webpack_require__(7), __webpack_require__(92), __webpack_require__(3), __webpack_require__(5), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, sendChat_1, navigation_service_1, authData_service_1, chat_service_1, constant_module_1, aps_enums_1, _) {
    "use strict";
    navController.$inject = ["$stateParams", "$modal", "navigationService", "authDataService", "chatService", "$state", "$scope", "$timeout"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [sendChat_1.default, navigation_service_1.default, authData_service_1.default, chat_service_1.default];
    exports.default = angular.module('aps.controller.nav', requires)
        .controller('NavCtrl', navController)
        .name;
    function navController($stateParams, $modal, navigationService, authDataService, chatService, $state, $scope, $timeout) {
        var vm = this;
        vm.states = constant_module_1.States;
        vm.chatUnreadCount = 0;
        vm.hasCounts = false;
        vm.showPlantPerformanceDashboard = false;
        var sendOpen = false;
        var lastChat = {
            message: ''
        };
        var hub;
        $scope.$on('$destroy', function () {
            if (hub) {
                hub.uninitialize();
            }
        });
        vm.openChatDialog = function () {
            sendOpen = true;
            vm.chatUnreadCount = 0;
            sendChat_1.openSendChat({
                shopId: vm.shopId,
                plantId: vm.plantId
            }, $modal).then(function (data) {
                if (data) {
                    lastChat = data;
                }
                sendOpen = false;
            });
        };
        navigationService.getNavigation().then(function (navigation) {
            if (!navigation.selectedPlant) {
                navigation.selectedPlant = _.first(navigation.plants());
            }
            vm.hasCounts = navigation.selectedShop.hasLines;
            vm.plantId = navigation.selectedPlant ? navigation.selectedPlant.id : $stateParams.plantId;
            if (!navigation.selectedShop) {
                navigation.selectedShop = _.first(navigation.shops());
            }
            vm.shopId = navigation.selectedShop ? navigation.selectedShop.id : $stateParams.shopId;
            var selectedRoleLocation = authDataService.getSelectedRoleLocation();
            vm.canSendChat = selectedRoleLocation.hasFlag(aps_enums_1.apsEnums.RoleFlags.Operator);
            var userId = authDataService.getUserId();
            if (authDataService.isPlantOrAPSIOAdminForCurrentPlant()) {
                vm.canSendChat = true;
            }
            vm.companyLinks = [
                { text: 'Snapshot', state: constant_module_1.States.ADMIN_DASHBOARD, visible: true },
                { text: 'Performance', state: constant_module_1.States.PLANT_PERFORMANCE, visible: true },
                { text: 'KPIs', state: constant_module_1.States.KPIS, visible: authDataService.isProductionShiftReport() }
            ];
            vm.plantLinks = [
                { text: 'Snapshot', state: constant_module_1.States.PLANT_DASHBOARD },
                { text: 'Ware Loss', state: constant_module_1.States.PLANT_WARE_LOSS_DASHBOARD },
                { text: 'Measurements', state: constant_module_1.States.MEASURE }
            ];
            vm.shopLinks = [
                { text: 'Dashboard', state: constant_module_1.States.DASHBOARD },
                { text: 'Summary', state: constant_module_1.States.SHOP_SUMMARY_DASHBOARD },
                { text: 'Shop Ops.', state: constant_module_1.States.SHOP_OPERATOR_DASHBOARD },
                { text: 'Counts', state: constant_module_1.States.COUNTS_HORIZONTAL },
            ];
            vm.hotEndLinks = [
                { text: 'Flex IS', state: constant_module_1.States.FLEX_IS_DETAILS },
            ];
            vm.operatorLinks = [
                { text: 'Cavity Corr.', state: constant_module_1.States.COUNTS_CAVITY_CORRELATION },
                { text: 'Cavity Eff.', state: constant_module_1.States.COUNTS_CAVITY_EFFICIENCY },
                { text: 'Checklist', state: constant_module_1.States.CHECKS },
                { text: 'Linesheet', state: constant_module_1.States.LINE_SHEET },
            ];
            if (_.find(authDataService.getRoles(), function (x) { return x.roleName === 'Plant Performance Dashboard'; })) {
                vm.showPlantPerformanceDashboard = true;
            }
            hub = chatService.createHub(vm.shopId, function (chatAdded) {
                if (sendOpen
                    || chatAdded.createdById === userId
                    || $state.current.name === constant_module_1.States.DASHBOARD
                    || lastChat.message === chatAdded.message) {
                    return;
                }
                $timeout(function () {
                    vm.chatUnreadCount = vm.chatUnreadCount + 1;
                });
            });
        });
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(92), __webpack_require__(4), __webpack_require__(6), __webpack_require__(422)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, chat_service_1, loader_service_1, notify_service_1, sendChat_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = ['mm.foundation', chat_service_1.default, loader_service_1.default, notify_service_1.default];
    function openSendChat(chatData, $modal) {
        return $modal.open({
            template: sendChat_tpl_html_1.default,
            controller: 'SendChatCtrl as vm',
            resolve: {
                data: function () { return chatData; }
            }
        }).result;
    }
    exports.openSendChat = openSendChat;
    var SendChatCtrl = (function () {
        SendChatCtrl.$inject = ["$modalInstance", "chatService", "loaderService", "notifyService", "data"];
        function SendChatCtrl($modalInstance, chatService, loaderService, notifyService, data) {
            this.$modalInstance = $modalInstance;
            this.chatService = chatService;
            this.loaderService = loaderService;
            this.notifyService = notifyService;
            this.data = data;
            this.count = 5;
            this.desc = true;
        }
        SendChatCtrl.prototype.sendMessage = function () {
            var _this = this;
            if (this.form.$invalid) {
                return;
            }
            var cmd = {
                plantId: this.data.plantId,
                shopId: this.data.shopId,
                message: this.message
            };
            this.loaderService.loadingPromise(this.chatService.sendMessage(cmd).then(function () {
                _this.$modalInstance.close(cmd);
            }, this.notifyService.handleApiErrors));
        };
        SendChatCtrl.prototype.cancel = function () {
            this.$modalInstance.close();
        };
        return SendChatCtrl;
    }());
    exports.default = angular.module('aps.controller.sendChat', requires)
        .controller('SendChatCtrl', SendChatCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <form name=vm.form ng-submit=vm.sendMessage() novalidate> <h2 class=modal-header>Send Chat Message</h2> <aps-view-chat count=vm.count desc=vm.desc></aps-view-chat> <div style=\"margin:0 -30px;width:auto\"> <!-- class=\"container\" ??? --> <div class=row> <div class=\"small-12 columns\"> <label><span class=\"required notated\">*</span>Message: <textarea name=message ng-model=vm.message required></textarea> </label> <div ng-messages=vm.form.message.$error ng-if=\"vm.form.message.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> </div> </div> <div class=row> <div class=\"small-12 columns\" style=\"margin:10px 0 -20px\"> <span class=required>* Required Fields</span> <div class=\"right dialog-footer\"> <input type=submit class=button value=\"Send Message\"/> <button type=button class=\"button secondary\" ng-click=vm.cancel()>Cancel</button> </div> </div> </div> </form> </div>");

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<aside class=column-l> <ul> <!-- company links --> <li ui-sref=\"{{vm.states.ADMIN_DASHBOARD}}\" ui-sref-active=active> <img src=" + __webpack_require__(424) + " width=25 height=25 style=margin-top:5px> <span><b>Company</b></span> </li> <li class=action-panel ng-repeat=\"companyLink in vm.companyLinks | filter: { visible: 'true' }\" ui-sref=\"{{companyLink.state}}\" ui-sref-active=active> <a> <span>{{companyLink.text}}</span> </a> </li> <!-- <hr/> --> <!-- plant level links --> <li ui-sref=\"{{vm.states.PLANT_DASHBOARD}}\" ui-sref-active=active> <img src=" + __webpack_require__(425) + " width=35 height=35> <span><b>Plant</b></span> </li> <li class=action-panel ng-repeat=\"plantLink in vm.plantLinks\" ui-sref=\"{{plantLink.state}}\" ui-sref-active=active> <a> <span>{{plantLink.text}}</span> </a> </li> <!-- shop level links --> <li ui-sref=\"{{vm.states.DASHBOARD}}\" ui-sref-active=active> <i class=\"fa fa-dashboard\"></i> <span><b>Shop</b></span> </li> <li class=action-panel ng-repeat=\"shopLink in vm.shopLinks\" ui-sref=\"{{shopLink.state}}\" ui-sref-active=active> <a> <span>{{shopLink.text}}</span> </a> </li> <!-- hot end links --> <li ui-sref=\"{{vm.states.FLEX_IS_DETAILS}}\" ui-sref-active=active> <i class=\"fa fa-fire\"></i> <span><b>Hot End</b></span> </li> <li class=action-panel ng-repeat=\"hotEndLink in vm.hotEndLinks\" ui-sref=\"{{hotEndLink.state}}\" ui-sref-active=active> <a> <span>{{hotEndLink.text}}</span> </a> </li> <!-- operator links --> <li ui-sref=\"{{vm.states.COUNTS_CAVITY_CORRELATION}}\" ui-sref-active=active> <i class=\"fa fa-id-card-o\" aria-hidden=true></i> <span><b>Operator</b></span> </li> <li class=action-panel ng-repeat=\"operatorLink in vm.operatorLinks\" ui-sref=\"{{operatorLink.state}}\" ui-sref-active=active> <a> <span>{{operatorLink.text}}</span> </a> </li> <!-- i guess everyone can chat --> <li ng-if=vm.canSendChat ng-click=vm.openChatDialog()> <a> <i class=\"fa fa-comments\"></i> <span><b>Chat</b></span> <span ng-if=\"vm.chatUnreadCount > 0\" class=chat-count style=width:20px>{{vm.chatUnreadCount}}</span> </a> </li> </ul> </aside>");

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "33b4b4571a7919961f84da040d072a3c.png";

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9cf753cfa2bad5c7c1dbc17f9010d536.png";

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(427), __webpack_require__(428), __webpack_require__(429), __webpack_require__(430), __webpack_require__(431), __webpack_require__(432), __webpack_require__(433), __webpack_require__(435), __webpack_require__(437), __webpack_require__(439), __webpack_require__(441)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, connectionStatus_directive_1, date_picker_1, date_time_picker_1, element_ready_1, input_enter_submit_directive_1, validation_directives_1, kpi_directive_1, equipment_group_1, vertical_trend_1, equipment_box_directive_1, line_selection_directive_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [
        connectionStatus_directive_1.default,
        date_picker_1.default,
        date_time_picker_1.default,
        element_ready_1.default,
        validation_directives_1.default,
        input_enter_submit_directive_1.default,
        kpi_directive_1.default,
        equipment_group_1.default,
        vertical_trend_1.default,
        equipment_box_directive_1.default,
        line_selection_directive_1.default
    ];
    exports.default = angular.module('aps.directives', requires).name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(37)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, hub_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular
        .module('aps.directives.connectionStatus', [hub_service_1.default])
        .directive('connectionStatus', ["hubService", "$timeout", function (hubService, $timeout) {
        return {
            scope: {},
            template: '<span class="not-connected" ng-if="notConnected" title="Not Connected"><i class="fa fa-ban" /></span>',
            link: function (scope) {
                scope.notConnected = true;
                var hub = hubService.createHub('chat', {
                    listeners: null,
                    methods: null,
                    onStateChange: function (change) {
                        $timeout(function () {
                            scope.notConnected = (change.newState !== signalR.HubConnectionState.Connected);
                        });
                    }
                });
                scope.$on('$destroy', function () {
                    if (hub) {
                        hub.uninitialize();
                    }
                });
            }
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.directives.datePicker', [])
        .directive('datePicker', function () {
        return {
            scope: {
                datePickerDate: '=',
                datePickerMaxDate: '=',
                datePickerOnChange: '&'
            },
            template: '<a>{{formattedDate()}}</a>',
            link: function (scope, element) {
                scope.formattedDate = function () { return scope.datePickerDate.format(constant_module_1.Strings.DATE_FORMAT); };
                element.fdatepicker({
                    endDate: scope.datePickerMaxDate.toDate()
                })
                    .on('changeDate', function (ev) {
                    scope.datePickerOnChange()(ev.date);
                    element.fdatepicker('hide');
                });
                element.fdatepicker('update', scope.datePickerDate.toDate());
                scope.$watch('datePickerDate', function () {
                    element.fdatepicker('update', scope.datePickerDate.toDate());
                });
            }
        };
    })
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, moment, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.directives.dateTimePicker', [])
        .directive('dateTimePicker', ["$compile", "$timeout", function ($compile, $timeout) {
        return {
            require: 'ngModel',
            restrict: 'A',
            scope: {
                ngModel: '=',
                timeModel: '=',
                timeZone: '=',
                foundTime: '=',
                singleHour: '@',
                showCurrentTimeLink: '@',
                showFoundTimeLink: '@',
                timeChanged: '&'
            },
            link: function (scope, element, attributes, ngModel) {
                scope.singleHour = (scope.singleHour === 'true');
                scope.showCurrentTimeLink = (scope.showCurrentTimeLink === 'true');
                scope.showFoundTimeLink = (scope.showFoundTimeLink === 'true');
                scope.isSecondHour = false;
                scope.showSecondHour = false;
                var enableDisableSecondHour = function () {
                    var timeZoneMoment = moment.tz(scope.timeModel, scope.timeZone);
                    var secondHour = moment.tz(scope.timeModel, scope.timeZone).subtract(1, 'hours').hour() === timeZoneMoment.hour();
                    if (scope.isSecondHour !== secondHour) {
                        scope.isSecondHour = secondHour;
                    }
                    scope.showSecondHour = secondHour ||
                        (moment.tz(scope.timeModel, scope.timeZone).add(1, 'hours').hour() === timeZoneMoment.hour());
                };
                var setTimeZoneTime = function (value) {
                    if (!scope.timeModel || !value || scope.timeModel.getTime() !== value.getTime()) {
                        scope.timeModel = value;
                        enableDisableSecondHour();
                        if (scope.timeChanged) {
                            $timeout(function () { return scope.timeChanged(); });
                        }
                    }
                };
                var getTimeZoneTime = function (value) {
                    if (!value) {
                        return value;
                    }
                    var newDate = moment.tz(moment(value).format(constant_module_1.Strings.TIME_FORMAT), constant_module_1.Strings.TIME_FORMAT, scope.timeZone).toDate();
                    if (scope.showSecondHour && scope.isSecondHour) {
                        newDate = moment.tz(newDate, scope.timeZone).add(1, 'hours').toDate();
                    }
                    return newDate;
                };
                var getLocalTime = function (value) {
                    if (!value) {
                        scope.showSecondHour = false;
                        scope.isSecondHour = false;
                        return value;
                    }
                    var timeZoneMoment = moment.tz(value, scope.timeZone);
                    return moment(timeZoneMoment.format(constant_module_1.Strings.TIME_FORMAT), constant_module_1.Strings.TIME_FORMAT).toDate();
                };
                var setLocalTime = function (value) {
                    if (!value) {
                        if (!scope.ngModel) {
                            return;
                        }
                    }
                    else if (scope.ngModel && scope.ngModel.getTime() === value.getTime()) {
                        return;
                    }
                    scope.ngModel = value;
                    enableDisableSecondHour();
                    if (scope.timeChanged) {
                        $timeout(function () { return scope.timeChanged(); });
                    }
                };
                if (scope.timeModel) {
                    scope.ngModel = getLocalTime(scope.timeModel);
                    enableDisableSecondHour();
                }
                ngModel.$parsers.push(function (val) {
                    setTimeZoneTime(getTimeZoneTime(val));
                    return val;
                });
                scope.setCurrentTime = function () {
                    scope.timeModel = moment().startOf('minute').toDate();
                    scope.ngModel = getLocalTime(scope.timeModel);
                    enableDisableSecondHour();
                };
                scope.setFoundTime = function () {
                    scope.timeModel = moment(scope.foundTime).startOf('minute').toDate();
                    scope.ngModel = getLocalTime(scope.timeModel);
                    enableDisableSecondHour();
                };
                var templateElement = angular.element('<label ng-show="showSecondHour" class="ng-hide" />');
                templateElement.append('Is Second Hour ');
                templateElement.append('<input type="checkbox" ng-model="isSecondHour" ng-disabled="singleHour" />');
                var compiledElement = $compile(templateElement)(scope);
                element.after(compiledElement);
                if (scope.showCurrentTimeLink || scope.showFoundTimeLink) {
                    var linkTemplate = angular.element('<div style="position: relative; top: 7px; right: 0;" />');
                    if (scope.showCurrentTimeLink) {
                        linkTemplate.append('<a ng-click="setCurrentTime()">current time</a>');
                    }
                    if (scope.showFoundTimeLink) {
                        if (scope.showCurrentTimeLink) {
                            linkTemplate.append(' | ');
                        }
                        linkTemplate.append('<a ng-click="setFoundTime()">found time</a>');
                    }
                    compiledElement = $compile(linkTemplate)(scope);
                    element.after(compiledElement);
                }
                scope.$watch('isSecondHour', function () {
                    setTimeZoneTime(getTimeZoneTime(ngModel.$modelValue));
                });
                scope.$watch('timeZone', function () {
                    setTimeZoneTime(getTimeZoneTime(ngModel.$modelValue));
                });
                scope.$watch('timeModel', function (value) {
                    setLocalTime(getLocalTime(value));
                });
            }
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.directives.elementReady', [])
        .directive('elementReady', ["$parse", function ($parse) {
        return {
            restrict: 'A',
            link: function (scope, element, attributes) {
                var func = $parse(attributes.elementReady);
                func(scope);
            }
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.directives.inputEnterSubmit', [])
        .directive('inputEnterSubmit', ["$parse", function ($parse) {
        return {
            restrict: 'A',
            link: function (scope, element, attributes) {
                element.bind('keydown keypress', function (event) {
                    switch (event.which) {
                        case 13:
                            var func = $parse(attributes.inputEnterSubmit);
                            func(scope);
                            event.preventDefault();
                            break;
                    }
                });
            }
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(89)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, moment, constant_module_1, isNullOrUndefined_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function isNullOrUndefinedString(value) {
        return isNullOrUndefined_1.default(value) || value === 'null';
    }
    var NUMBER_REGEXP = /\d+/;
    var LOWER_REGEXP = /[a-z]+/;
    var UPPER_REGEXP = /[A-Z]+/;
    exports.default = angular.module('aps.validation.directives', [])
        .directive('date', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attributes, ngModel) {
                ngModel.$validators.date = function (modelValue) {
                    if (modelValue) {
                        return moment(modelValue, constant_module_1.Strings.DATE_FORMAT, true).isValid();
                    }
                    return true;
                };
            }
        };
    })
        .directive('dateTime', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attributes, ngModel) {
                ngModel.$validators.dateTime = function (modelValue) {
                    if (modelValue) {
                        return moment(modelValue, constant_module_1.Strings.TIME_FORMAT, true).isValid();
                    }
                    return true;
                };
            }
        };
    })
        .directive('compareTo', function () {
        return {
            require: 'ngModel',
            scope: {
                otherModelValue: '=compareTo'
            },
            link: function (scope, element, attributes, ngModel) {
                ngModel.$validators.compareTo = function (modelValue) {
                    if (modelValue) {
                        return modelValue == scope.otherModelValue;
                    }
                    return true;
                };
                scope.$watch('otherModelValue', function () {
                    ngModel.$validate();
                });
            }
        };
    })
        .directive('convertToNumber', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attributes, ngModel) {
                ngModel.$parsers.push(function (val) {
                    if (isNullOrUndefined_1.default(val)) {
                        return null;
                    }
                    return parseInt(val, 10);
                });
                ngModel.$formatters.push(function (val) {
                    if (isNullOrUndefinedString(val)) {
                        return null;
                    }
                    return '' + val;
                });
            }
        };
    })
        .directive('convertToBoolean', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attributes, ngModel) {
                ngModel.$parsers.push(function (val) {
                    return val === 'true' ? true : (val === 'false' ? false : null);
                });
                ngModel.$formatters.push(function (val) {
                    if (isNullOrUndefinedString(val)) {
                        return null;
                    }
                    return val ? 'true' : 'false';
                });
            }
        };
    })
        .directive('stringToNumber', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attributes, ngModel) {
                ngModel.$parsers.push(function (value) {
                    if (isNullOrUndefinedString(value)) {
                        return null;
                    }
                    return '' + value;
                });
                ngModel.$formatters.push(function (value) {
                    if (isNullOrUndefined_1.default(value)) {
                        return value;
                    }
                    return parseFloat(value);
                });
            }
        };
    })
        .directive('hasNumber', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attributes, ngModel) {
                ngModel.$validators.hasNumber = function (modelValue, viewValue) {
                    if (ngModel.$isEmpty(modelValue)) {
                        return true;
                    }
                    if (NUMBER_REGEXP.test(viewValue)) {
                        return true;
                    }
                    return false;
                };
            }
        };
    })
        .directive('hasLower', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attributes, ngModel) {
                ngModel.$validators.hasLower = function (modelValue, viewValue) {
                    if (ngModel.$isEmpty(modelValue)) {
                        return true;
                    }
                    if (LOWER_REGEXP.test(viewValue)) {
                        return true;
                    }
                    return false;
                };
            }
        };
    })
        .directive('hasUpper', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attributes, ngModel) {
                ngModel.$validators.hasUpper = function (modelValue, viewValue) {
                    if (ngModel.$isEmpty(modelValue)) {
                        return true;
                    }
                    if (UPPER_REGEXP.test(viewValue)) {
                        return true;
                    }
                    return false;
                };
            }
        };
    })
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(434)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, kpi_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular
        .module('aps.directives.kpi', [])
        .directive('kpi', function () {
        return {
            replace: true,
            scope: {
                kpis: '=kpis'
            },
            template: kpi_tpl_html_1.default
        };
    })
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <div class=\"small-4 columns\" ng-repeat=\"kpi in kpis\"> <div> <label style=display:inline>{{kpi.efficiencyName}}:</label> {{kpi.efficiency}} </div> <div> <label style=display:inline>{{kpi.lossesName}}:</label> {{kpi.losses}} </div> <div ng-if=\"$index === 0\"> <label style=display:inline>Speed:</label> {{kpi.denominator.speed}} </div> </div> </div>");

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(436)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, equipment_group_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular
        .module('aps.directives.kpi', [])
        .directive('equipmentGroup', function () {
        return {
            replace: true,
            scope: {
                group: '=group'
            },
            template: equipment_group_tpl_html_1.default
        };
    })
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div style=cursor:pointer> <div class=equipment-name>{{group.name}}</div> <div class=count>{{group.inspectCount.count}}</div> <div ng-if=group.hasRejects> <span class=fail-rate>{{group.rejectCount.count}}</span> <span class=fail-percentage> <span>{{group.rejectCount.percent + \"%\"}}</span> <vert-trend trend=group.rejectCount.trend style=margin-top:.1em /> </span> </div> </div> ");

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(438)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, vertical_trend_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular
        .module('aps.directives.vertTrend', [])
        .directive('vertTrend', function () {
        return {
            replace: true,
            scope: {
                trend: '=trend'
            },
            template: vertical_trend_tpl_html_1.default,
        };
    })
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<i class=\"trend fa\" ng-class=\"{'fa-angle-up':trend.up,'fa-angle-down':trend.down}\"></i>");

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(440)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, equipment_box_directive_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular
        .module('aps.directives.equipmentBox', [])
        .directive('equipmentBox', function () {
        return {
            replace: true,
            scope: {
                equipment: '=',
                options: '=',
                losspercentclass: '@',
                borderclass: '@',
            },
            template: equipment_box_directive_tpl_html_1.default,
        };
    })
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=eq-box> <table class=\"\" cellspacing=0 cellpadding=0 ng-class=borderclass> <tbody> <tr> <td> <div class=\"eq-col eq-idx\" ng-class=\"{'line-disabled': row.line.isDisabled}\"> <span>{{equipment.line.name}}</span> </div> </td> <td> <div class=\"eq-col eq-ict\"> <span>{{equipment.inspectCount.count | number}}</span> </div> </td> <td> <div class=\"eq-col eq-sparkline\"> <span class=ng-binding>{{equipment.rejectCount.count | number}}</span> <i class=\"vc-trend fa\" ng-class=\"{'fa-angle-up': equipment.rejectCount.trend.up, 'fa-angle-down': equipment.rejectCount.trend.down}\"></i> </div> </td> <td> <div ng-if=!equipment.rejectPercentHidden class=\"eq-col eq-rpt\" ng-class=losspercentclass> <b>{{equipment.rejectCount.percent.value}}</b> &nbsp; </div> </td> <td> <div class=\"eq-col eq-sparkline\"> <span> <sparkline-chart-v2 options=options data=\"{{equipment.rejectCount.trendCounts}}\"> </sparkline-chart-v2> </span> </div> </td> </tr> </tbody> </table> </div>");

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(442)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, line_selection_directive_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular
        .module('aps.directives.lineSelection', [])
        .directive('lineSelection', function () {
        return {
            replace: true,
            scope: {
                ngModel: '=',
                ngReadonly: '=',
                ngDisabled: '=',
                ngRequired: '=',
                ngName: '=',
                form: '='
            },
            link: function (scope) {
                var setLinesSelected = function () {
                    if (!scope.ngModel) {
                        scope.linesSelected = '';
                        return;
                    }
                    var selected = Object.keys(scope.ngModel)
                        .filter(function (key) { return scope.ngModel[key]; });
                    if (selected.length === 0) {
                        scope.linesSelected = '';
                        return;
                    }
                    scope.linesSelected = 'yes';
                };
                setLinesSelected();
                scope.modelChanged = setLinesSelected;
            },
            template: line_selection_directive_tpl_html_1.default,
        };
    })
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div style=display:flex;flex-direction:row> <label style=margin-right:1rem>L1: <input type=checkbox name=\"{{ngName}}L1\" ng-model=ngModel.L1 ng-readonly=ngReadonly ng-disabled=ngDisabled ng-change=modelChanged() /> </label> <label style=margin-right:1rem>L2: <input type=checkbox name=\"{{ngName}}L2\" ng-model=ngModel.L2 ng-readonly=ngReadonly ng-disabled=ngDisabled ng-change=modelChanged() /> </label> <label style=margin-right:1rem>L3: <input type=checkbox name=\"{{ngName}}L3\" ng-model=ngModel.L3 ng-readonly=ngReadonly ng-disabled=ngDisabled ng-change=modelChanged() /> </label> <label style=margin-right:1rem>L4: <input type=checkbox name=\"{{ngName}}L4\" ng-model=ngModel.L4 ng-readonly=ngReadonly ng-disabled=ngDisabled ng-change=modelChanged() /> </label> <input name=\"{{ngName}}\" type=hidden ng-model=linesSelected ng-required=ngRequired /> <div ng-messages=form[ngName].$error ng-if=\"ngRequired && (form[ngName].$dirty || form.$submitted)\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div>");

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(444)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, pfmt_filter_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [
        pfmt_filter_1.default
    ];
    exports.default = angular.module('aps.filters', requires).name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PercentFormatFilter = (function () {
        function PercentFormatFilter() {
        }
        PercentFormatFilter.Factory = function () {
            var factoryFunc = function () {
                return function (input) {
                    return angular.isDefined(input) ? input + "%" : "";
                };
            };
            return factoryFunc;
        };
        return PercentFormatFilter;
    }());
    exports.PercentFormatFilter = PercentFormatFilter;
    exports.default = angular
        .module('aps.filters', [])
        .filter('pfmt', PercentFormatFilter.Factory())
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(446), __webpack_require__(447)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, loader_tpl_html_1, loader_controller_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.directive.loader', [loader_controller_1.default])
        .directive('apsLoader', loaderDef)
        .name;
    function loaderDef() {
        return {
            restrict: 'E',
            scope: {},
            template: loader_tpl_html_1.default,
            replace: true,
            controller: 'LoaderCtrl',
            controllerAs: 'vm',
            bindToController: true
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<!-- loading --> <div ng-show=vm.appLoading id=appLoading> <div class=page-splash> <div class=page-splash-message ng-bind=vm.loadingMessage> </div> <div class=loading> <div><i class=\"fa fa-refresh fa-spin fa-5x\"></i></div> </div> </div> </div>");

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, loader_service_1) {
    "use strict";
    LoaderCtrl.$inject = ["loaderService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.controller.loader', [loader_service_1.default])
        .controller('LoaderCtrl', LoaderCtrl)
        .name;
    function LoaderCtrl(loaderService) {
        'use strict';
        var vm = this;
        vm.loadingMessage = 'loading...';
        Object.defineProperty(vm, 'appLoading', {
            get: function () {
                return loaderService.appLoading();
            }
        });
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(449), __webpack_require__(451), __webpack_require__(455), __webpack_require__(458), __webpack_require__(461), __webpack_require__(464), __webpack_require__(467), __webpack_require__(470), __webpack_require__(473), __webpack_require__(522), __webpack_require__(525), __webpack_require__(528), __webpack_require__(531), __webpack_require__(534), __webpack_require__(537), __webpack_require__(545), __webpack_require__(549), __webpack_require__(555), __webpack_require__(559), __webpack_require__(561), __webpack_require__(564), __webpack_require__(568), __webpack_require__(576), __webpack_require__(580), __webpack_require__(582), __webpack_require__(601), __webpack_require__(94), __webpack_require__(614), __webpack_require__(616), __webpack_require__(619), __webpack_require__(622), __webpack_require__(626), __webpack_require__(627), __webpack_require__(629), __webpack_require__(285), __webpack_require__(631), __webpack_require__(634), __webpack_require__(637), __webpack_require__(300), __webpack_require__(640), __webpack_require__(643), __webpack_require__(653), __webpack_require__(657), __webpack_require__(661), __webpack_require__(717), __webpack_require__(723), __webpack_require__(727), __webpack_require__(731), __webpack_require__(735), __webpack_require__(743), __webpack_require__(747), __webpack_require__(772), __webpack_require__(774), __webpack_require__(778), __webpack_require__(782), __webpack_require__(787), __webpack_require__(309), __webpack_require__(791), __webpack_require__(310), __webpack_require__(795), __webpack_require__(798), __webpack_require__(800), __webpack_require__(802), __webpack_require__(804), __webpack_require__(806), __webpack_require__(808), __webpack_require__(810), __webpack_require__(812), __webpack_require__(814), __webpack_require__(816), __webpack_require__(823), __webpack_require__(825), __webpack_require__(828), __webpack_require__(830), __webpack_require__(833), __webpack_require__(835), __webpack_require__(837), __webpack_require__(839), __webpack_require__(841), __webpack_require__(843), __webpack_require__(845), __webpack_require__(847), __webpack_require__(849), __webpack_require__(851), __webpack_require__(853), __webpack_require__(859), __webpack_require__(863), __webpack_require__(869), __webpack_require__(875), __webpack_require__(881), __webpack_require__(883), __webpack_require__(887), __webpack_require__(890), __webpack_require__(892), __webpack_require__(894), __webpack_require__(896), __webpack_require__(898), __webpack_require__(900), __webpack_require__(904), __webpack_require__(907), __webpack_require__(910), __webpack_require__(914), __webpack_require__(916), __webpack_require__(918)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, chatReport_1, dashboard_directives_1, viewChat_directive_1, failedChecks_directive_1, hourlyCheckReport_directive_1, scheduledCheckLists_directive_1, recentCheckLists_directive_1, unfinishedCheckLists_directive_1, equipmentGroupMoldDistributionGraph_directive_1, equipmentGroupRejectsGraph_directive_1, topDefects_directive_1, topDefectsGraph_directive_1, topRejectsGraph_directive_1, btnArray_directive_1, commodities_controller_1, batchSummary_controller_1, batchFormulas_controller_1, batchFormulaUsages_controller_1, batchUsageReport_controller_1, commodityBin_controller_1, checkDetectorDefectMapping_controller_1, checkLists_controller_1, checkListKPI_directive_1, checkListReport_controller_1, checkListReportReact_1, checks_controller_1, count_controller_1, countv2_controller_1, countVertical_controller_1, countVerticalv2_controller_1, plantFeatureSettings_controller_1, countDetail_1, summary_controller_1, adminDashboard_controller_1, dashboard_controller_1, shopSummaryDashboard_controller_1, plantWareLossDashboard_controller_1, shopOperatorDashboard_controller_1, gobWeightsGraph_directive_1, plantDashboard_controller_1, defectTypes_controller_1, defectTypes_controller_2, alertRole_controller_1, equipmentList_controller_1, formula_controller_1, holidays_controller_1, jobList_controller_1, jobRun_controller_1, lineConfigs_controller_1, lineEquipmentNames_controller_1, lineSheet_controller_1, sendNotification_controller_1, palletizer_controller_1, palletKpis_controller_1, plants_controller_1, cavityEfficiencyReport_controller_1, cavityEfficiencySummaryGraph_controller_1, cavityCorrelationReport_controller_1, cavityCorrelationSummaryGraph_controller_1, flexIsDetails_controller_1, commonReportLocationRow_directive_1, commonReportQueryCriteriaRow_directive_1, criticalDefectReport_controller_1, wareHeldReport_controller_1, tankMetricsReport_controller_1, defectsReport_controller_1, deletedDefectReport_controller_1, deletedGobWeightReport_controller_1, downtimeReport_controller_1, furnacePullReport_controller_1, weeklyKPIsReport_controller_1, dropAndTimeLineGraphs_directive_1, hourlyChecklistReport_controller_1, morningMinutesReport_controller_1, shiftDetailReport_controller_1, jobRunReport_controller_1, productionReport_controller_1, qualificationsReport_controller_1, rejectRateReport_controller_1, shopCountSummaryReport_controller_1, toolChangeReport_controller_1, topDefectsReport_controller_1, resetPassword_controller_1, roleLocation_controller_1, sectionChange_1, shops_controller_1, signIn_controller_1, users_controller_1, tiamaDefectMappings_controller_1, plantPerformance_controller_1, plantPerformanceCharts_controller_1, machineDefectMappings_controller_1, productionShiftReport_controller_1, productionShiftReportV2_controller_1, downtimeShiftReport_controller_1, downtimeShiftReportInsight_controller_1, dumpGateTimeReport_controller_1, productionKPIs_controller_1, measure_controller_1, scorecardChecklist_controller_1, hotEndBonusReport_controller_1, ccc_controller_1, cce_controller_1, dataPointHistoryReport_controller_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [chatReport_1.default, viewChat_directive_1.default, checkDetectorDefectMapping_controller_1.default, checkLists_controller_1.default, checkListKPI_directive_1.default, checkListReport_controller_1.default,
        checkListReportReact_1.default, failedChecks_directive_1.default, hourlyCheckReport_directive_1.default, scheduledCheckLists_directive_1.default, checks_controller_1.default, recentCheckLists_directive_1.default,
        unfinishedCheckLists_directive_1.default, equipmentGroupMoldDistributionGraph_directive_1.default, equipmentGroupRejectsGraph_directive_1.default, summary_controller_1.default, alertRole_controller_1.default,
        adminDashboard_controller_1.default, dashboard_controller_1.default, gobWeightsGraph_directive_1.default, plantDashboard_controller_1.default, topDefects_directive_1.default, topDefectsGraph_directive_1.default, topRejectsGraph_directive_1.default,
        defectTypes_controller_1.default, defectTypes_controller_2.default, equipmentList_controller_1.default, formula_controller_1.default, holidays_controller_1.default, jobList_controller_1.default, jobRun_controller_1.default, lineConfigs_controller_1.default, lineEquipmentNames_controller_1.default,
        lineSheet_controller_1.default, sendNotification_controller_1.default, palletizer_controller_1.default, palletKpis_controller_1.default, plants_controller_1.default, cavityEfficiencyReport_controller_1.default, cavityEfficiencySummaryGraph_controller_1.default, cavityCorrelationSummaryGraph_controller_1.default,
        cavityCorrelationReport_controller_1.default, commonReportLocationRow_directive_1.default, commonReportQueryCriteriaRow_directive_1.default, criticalDefectReport_controller_1.default, defectsReport_controller_1.default, deletedDefectReport_controller_1.default, downtimeReport_controller_1.default,
        wareHeldReport_controller_1.default, tankMetricsReport_controller_1.default, weeklyKPIsReport_controller_1.default,
        furnacePullReport_controller_1.default, dropAndTimeLineGraphs_directive_1.default, hourlyChecklistReport_controller_1.default, jobRunReport_controller_1.default, productionReport_controller_1.default, qualificationsReport_controller_1.default, rejectRateReport_controller_1.default,
        shopCountSummaryReport_controller_1.default, toolChangeReport_controller_1.default, topDefectsReport_controller_1.default, resetPassword_controller_1.default, roleLocation_controller_1.default, sectionChange_1.default, shops_controller_1.default,
        signIn_controller_1.default, users_controller_1.default, morningMinutesReport_controller_1.default, shiftDetailReport_controller_1.default, deletedGobWeightReport_controller_1.default, tiamaDefectMappings_controller_1.default, plantPerformance_controller_1.default, plantPerformanceCharts_controller_1.default,
        machineDefectMappings_controller_1.default, shopSummaryDashboard_controller_1.default, plantWareLossDashboard_controller_1.default, shopOperatorDashboard_controller_1.default, dashboard_directives_1.default,
        productionShiftReport_controller_1.default,
        productionShiftReportV2_controller_1.default,
        downtimeShiftReport_controller_1.default,
        downtimeShiftReportInsight_controller_1.default,
        dumpGateTimeReport_controller_1.default,
        productionKPIs_controller_1.default,
        measure_controller_1.default,
        scorecardChecklist_controller_1.default,
        hotEndBonusReport_controller_1.default,
        flexIsDetails_controller_1.default,
        count_controller_1.default,
        countv2_controller_1.default,
        countVertical_controller_1.default,
        countVerticalv2_controller_1.default,
        ccc_controller_1.default,
        cce_controller_1.default,
        countDetail_1.default,
        commodities_controller_1.default, batchFormulas_controller_1.default, batchFormulaUsages_controller_1.default, batchUsageReport_controller_1.default, commodityBin_controller_1.default, batchSummary_controller_1.default,
        dataPointHistoryReport_controller_1.default,
        plantFeatureSettings_controller_1.default
    ];
    requires.push(btnArray_directive_1.default);
    exports.default = angular.module('aps.controllers', requires).name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(2), __webpack_require__(11), __webpack_require__(4), __webpack_require__(8), __webpack_require__(23), __webpack_require__(92), __webpack_require__(3), __webpack_require__(450)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, moment, _, dateutility_service_1, loader_service_1, navigation_service_1, shops_service_1, chat_service_1, constant_module_1, chatReport_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, navigation_service_1.default, shops_service_1.default, chat_service_1.default];
    var ChatReportCtrl = (function () {
        ChatReportCtrl.$inject = ["chatService", "navigationService", "loaderService", "shopService", "$state", "$stateParams", "$q"];
        function ChatReportCtrl(chatService, navigationService, loaderService, shopService, $state, $stateParams, $q) {
            var _this = this;
            this.chatService = chatService;
            this.loaderService = loaderService;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.$q = $q;
            this.shopService = shopService;
            this.requirePlantSelection = true;
            this.requireShopSelection = true;
            var now = moment().add(1, 'hours').startOf('hour');
            this.uiEndDate = now.toDate();
            this.uiStartDate = now.clone().subtract(1, 'days').toDate();
            var promise = navigationService.getNavigation()
                .then(function (navModel) {
                _this.plants = navModel.plants();
                _this.selectedPlant = navModel.selectedPlant;
                _this.updatePlant();
                _this.selectedShop = navModel.selectedShop;
                return _this.loadState($stateParams);
            });
            this.loaderService.loadingPromise(promise);
        }
        ChatReportCtrl.prototype.exportToCsv = function () {
            var _this = this;
            return _.map(this.chatItems, function (x) {
                var type = ((x.isDefect) ? x.defectLabel() :
                    ((x.isDowntime) ? 'Downtime' :
                        ((x.isToolChange) ? 'Tool Change' : '')));
                return {
                    createdOn: _this.displayDate(x.createdOn),
                    message: x.message,
                    createdByFullName: x.createdByFullName,
                    type: type,
                    area: !x.isChat ? _this.getLocation(x) : ''
                };
            });
        };
        ChatReportCtrl.prototype.displayDate = function (date) {
            return dateutility_service_1.default.formatTime(date, this.selectedPlant ? this.selectedPlant.timeZoneId : null);
        };
        ChatReportCtrl.prototype.getLocation = function (chatItem) {
            var location = chatItem.location(this.shopConfig);
            return location;
        };
        ChatReportCtrl.prototype.updatePlant = function () {
            this.selectedShop = null;
        };
        ChatReportCtrl.prototype.loadState = function (params) {
            if (params.reportPlantId && params.reportShopId && params.reportShopId !== params.shopId) {
                var plant = _.find(this.plants, { id: params.reportPlantId });
                if (plant) {
                    var shop = _.find(plant.shops, { id: params.reportShopId });
                    if (shop) {
                        this.selectedPlant = plant;
                        this.selectedShop = shop;
                    }
                }
            }
            if (params.startDate) {
                var startDate = moment(params.startDate);
                if (startDate.isValid()) {
                    this.startDate = startDate.toDate();
                }
            }
            if (params.endDate) {
                var endDate = moment(params.endDate);
                if (endDate.isValid()) {
                    this.endDate = endDate.toDate();
                }
            }
            if (params.autoRun) {
                return this.runChatReport();
            }
            return this.$q.when();
        };
        ChatReportCtrl.prototype.saveState = function () {
            var reportShopId = this.selectedShop ? this.selectedShop.id : undefined;
            if (reportShopId === this.$stateParams.shopId) {
                reportShopId = undefined;
            }
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportPlantId: (reportShopId && this.selectedPlant) ? this.selectedPlant.id : undefined,
                reportShopId: reportShopId,
                startDate: this.startDate ? this.startDate.toISOString() : undefined,
                endDate: this.endDate ? this.endDate.toISOString() : undefined,
                autoRun: true
            };
            this.$state.transitionTo(this.$state.current.name, params);
        };
        ChatReportCtrl.prototype.generateReport = function () {
            if (this.form.$invalid) {
                return;
            }
            this.saveState();
            this.loaderService.loadingPromise(this.runChatReport());
        };
        ChatReportCtrl.prototype.runChatReport = function () {
            var _this = this;
            this.endDate = this.endDate || new Date();
            this.chatItems = undefined;
            var shopPromise = this.shopService.getShopConfiguration(this.selectedShop.id)
                .then(function (shop) { return _this.shopConfig = shop; });
            var chatPromise = this.chatService.getMessages(this.selectedPlant.id, this.selectedShop.id, this.startDate, this.endDate)
                .then(function (data) { return _this.chatItems = data; });
            return this.$q.all([shopPromise, chatPromise]);
        };
        return ChatReportCtrl;
    }());
    exports.default = angular.module('aps.controller.chatReport', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.CHAT_REPORT,
            url: '/report/chat?startDate&endDate&autoRun&reportPlantId&reportShopId',
            params: {
                startDate: { dynamic: true },
                endDate: { dynamic: true },
                autoRun: { dynamic: true },
                reportPlantId: { dynamic: true },
                reportShopId: { dynamic: true },
            },
            controller: 'ChatReportCtrl as vm',
            template: chatReport_tpl_html_1.default,
            data: {
                pageTitle: 'Chat and Comments Report'
            }
        });
    }])
        .controller('ChatReportCtrl', ChatReportCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div class=body-header> <h2>Chat and Comment History Report</h2> </div> <aps-common-report-query-criteria-row vm=vm></aps-common-report-query-criteria-row> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-12 columns\"> <button type=submit class=button>Generate Report</button> </div> </div> </form> <div ng-if=\"vm.chatItems && vm.shopConfig\"> <a ng-csv=vm.exportToCsv() ng-if=\"vm.chatItems.length > 0\" filename=chatAndCommentHistoryReportExport.csv class=right>Save as CSV</a> <table cellpadding=1 cellspacing=1 ng-if=\"vm.chatItems.length > 0\" class=history-t> <thead> <tr> <th>Time</th> <th>Comment</th> <th>User</th> <th>Type</th> <th>Area</th> </tr></thead> <tbody> <tr ng-repeat=\"item in vm.chatItems\"> <td>{{vm.displayDate(item.createdOn)}}</td> <td>{{item.message}}</td> <td>{{item.createdByFullName}}</td> <!-- Type --> <td ng-if=item.isChat></td> <td ng-if=item.isDefect> <span class=\"lineitem severity-{{item.severity}}\" style=color:#fff;font-size:.9em;padding:4px>{{item.defectLabel()}}</span> </td> <td ng-if=item.isDowntime> <span class=\"lineitem downtime\"><i class=\"fa fa-clock-o\"></i></span> </td> <td ng-if=item.isToolChange> <span class=\"lineitem toolchange\"><i class=\"fa fa-wrench\"></i></span> </td> <!-- Area --> <td ng-if=item.isChat></td> <td ng-if=!item.isChat>{{vm.getLocation(item)}}</td> </tr> </tbody> </table> <div ng-if=\"vm.chatItems.length === 0\"> No chat history or comments found </div> </div> </div>");

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(34), __webpack_require__(285)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, Highcharts, dashboard_controller_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.directive.highChart', [dashboard_controller_1.default])
        .directive('highChart', ['$window', highChart])
        .name;
    function highChart($window) {
        return {
            restrict: 'E',
            template: '<div></div>',
            scope: {
                options: '='
            },
            link: function (scope, element, attrs) {
                var el = element;
                var onResize = function (event) {
                    if (chart) {
                        chart.reflow();
                        scope.$apply();
                    }
                };
                var cleanUp = function () {
                    angular.element($window).off('resize', onResize);
                };
                angular.element($window).bind('resize', onResize);
                scope.$watch('options', function (newVal) {
                    if (newVal) {
                        chart = Highcharts.chart(element[0], scope.options);
                    }
                }, true);
                scope.$on('$destroy', cleanUp);
                var chart = Highcharts.chart(attrs["id"], scope.options);
                chart.reflow();
            }
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <div class=dashboard-l> <div class=dashboard-l-w> <h2><span ng-if=vm.plantName>{{vm.plantName}}</span></h2> <h3><span ng-if=vm.shopName>Shop {{vm.shopName}}</span></h3> </div> <div class=dashboard-l-status> <h2>Current Status</h2> <ul class=status-main> <li> <aps-check-list-kpi-dashboard plant-id=vm.plantId shop-id=vm.shopId well-known-check=vm.heEfficiency></aps-check-list-kpi-dashboard> </li> <li> <aps-check-list-kpi-dashboard plant-id=vm.plantId shop-id=vm.shopId well-known-check=vm.packEfficiency></aps-check-list-kpi-dashboard> </li> </ul> </div> </div> <div class=dashboard-r> <div class=dashboard-r-g> <!-- Tabs for plants that have a weight tab (broken out in order to default weights as selected tab) --> <tabset ng-if=vm.hasScale> <tab heading=Weights select=vm.setSelectedTab(vm.dashboardTab.Weights)> <div class=dashboard-r-g-w> <!-- Scale Weights, visible if vm.hasScale --> <aps-gob-weights-graph ng-if=\"vm.hasScale && vm.selectedTab === vm.dashboardTab.Weights\" shop-id=vm.shopId hours-to-show=4 width=1000 height=400></aps-gob-weights-graph> </div> </tab> <!-- FYI, defects code is duplicated below--> <tab heading=\"Top 10 Defects\" select=vm.setSelectedTab(vm.dashboardTab.TopDefects)> <div class=dashboard-r-g-w> <div> <div class=\"row row-flex row-no-padding\" ng-if=vm.showMaintCheckbox> <div class=\"col-md-6 text-align-right\" style=padding-right:3px> <input type=checkbox ng-model=vm.showMaintenance ng-change=vm.IncludeMaintenence() /> </div> <div class=\"col-md-6 text-align-left\" style=padding-left:0> Include Maintenance Codes </div> </div> <div class=card> <div class=card-body> <div ng-if=\"!vm.showIfEmpty && vm.defectsPretty && !vm.defectsPretty.length\"> No Defects for this Shop </div> <div ng-click=vm.chartClickWorkaround.defectBarClick> <high-chart options=vm.topTenDefects id=top10DefectsBot style=display:block;width:100% /> </div> </div> </div> </div> <div class=text-center> <btn-array options=vm.shiftSelectors /> </div> </div> </tab> <tab heading=\"Top 10 Rejects\" ng-if=vm.hasLines select=vm.setSelectedTab(vm.dashboardTab.TopRejects)> <aps-top-rejects-graph ng-if=\"vm.selectedTab === vm.dashboardTab.TopRejects && vm.model\" equipment-selected=vm.viewGroupRejects shop-id=vm.shopId model=vm.model interval=vm.countsInterval></aps-top-rejects-graph> </tab> </tabset> <!-- tabs for plants that do not have a weight tab (ONLY LAWRENCEBURG - REMOVE THIS SECTION WHEN LAWRENCEBURG HAS WEIGHTS) --> <tabset ng-if=!vm.hasScale> <tab heading=\"Top 10 Defects\" select=vm.setSelectedTab(vm.dashboardTab.TopDefects)> <div class=dashboard-r-g-w> <div> <div class=\"row row-flex row-no-padding\" ng-if=vm.showMaintCheckbox> <div class=\"col-md-6 text-align-right\" style=padding-right:3px> <input type=checkbox ng-model=vm.showMaintenance ng-change=vm.IncludeMaintenence() /> </div> <div class=\"col-md-6 text-align-left\" style=padding-left:0> Include Maintenance Codes </div> </div> <div class=card> <div class=card-body> <div ng-if=\"!vm.showIfEmpty && vm.defectsPretty && !vm.defectsPretty.length\"> No Defects for this Shop </div> <div ng-click=vm.chartClickWorkaround.defectBarClick> <high-chart options=vm.topTenDefects id=top10DefectsBot style=display:block;width:100% /> </div> </div> </div> </div> <div class=text-center> <btn-array options=vm.shiftSelectors /> </div> </div> </tab> <tab heading=\"Top 10 Rejects\" ng-if=vm.hasLines select=vm.setSelectedTab(vm.dashboardTab.TopRejects)> <aps-top-rejects-graph ng-if=\"vm.selectedTab === vm.dashboardTab.TopRejects && vm.model\" equipment-selected=vm.viewGroupRejects shop-id=vm.shopId model=vm.model interval=vm.countsInterval></aps-top-rejects-graph> </tab> </tabset> </div> </div> <div class=dashboard-r-tier2> <div class=\"medium-6 columns\"> <h4>Chat and Comment History</h4> <aps-view-chat></aps-view-chat> </div> <div class=\"medium-6 columns dash-checks\"> <tabset> <tab heading=\"Upcoming Checks\"> <aps-scheduled-check-lists check-list-view=Scheduled /> <a ui-sref=\"{{vm.states.CHECKS}}\" class=checks-btn>View All Checks</a> </tab> <tab heading=\"Failed Checks\"> <aps-failed-checks/> </tab> </tabset> </div> </div> </div>");

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(26), __webpack_require__(4), __webpack_require__(5), __webpack_require__(454)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, counts_service_1, loader_service_1, aps_enums_1, equipmentGroupRejects_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [counts_service_1.default, loader_service_1.default];
    function openEquipmentGroupRejects(data, $modal) {
        return $modal.open({
            template: equipmentGroupRejects_tpl_html_1.default,
            controller: 'EquipmentGroupRejectsCtrl as vm',
            resolve: {
                data: function () { return data; }
            }
        }).result;
    }
    exports.openEquipmentGroupRejects = openEquipmentGroupRejects;
    var EquipmentGroupRejectsControllerImpl = (function () {
        EquipmentGroupRejectsControllerImpl.$inject = ["data", "$modalInstance", "countsService", "loaderService", "$timeout", "$document"];
        function EquipmentGroupRejectsControllerImpl(data, $modalInstance, countsService, loaderService, $timeout, $document) {
            this.tabClass = 'er-details';
            this.equipmentGroup = data.equipmentGroup;
            this.$modalInstance = $modalInstance;
            this.countsService = countsService;
            this.loaderService = loaderService;
            this.$document = $document;
            this.$timeout = $timeout;
            this.rejectRateRange = 'LastHour';
            this.equipmentCount = Object.keys(this.equipmentGroup.equipment).length;
            this.detail = data.detail;
            this.shopId = data.shopId;
            this.timeZoneId = data.timeZoneId;
            if (data.equipmentGroup.lineLineEquipmentTabs && data.lines) {
                this.showDistribution = true;
                this.lines = data.lines;
            }
            if (_.some(this.equipmentGroup.types, function (t) {
                return t === aps_enums_1.apsEnums.LineEquipmentType.CheckDetector
                    || t === aps_enums_1.apsEnums.LineEquipmentType.HEYE;
            })) {
                this.showMoldDistribution = true;
            }
            this.setTabClass();
            this.tabOptions = {
                RejectRateGraph: 'RejectRateGraph',
                DistributionGraph: 'DistributionGraph',
                MoldDistributionGraph: 'MoldDistributionGraph'
            };
            this.dimpleFunctions = {
                getToolTip: function (e) {
                    return [
                        e.aggField[0].substring(2),
                        'Defect: ' + e.cx,
                        'Reject Count: ' + e.cy
                    ];
                }
            };
            if (this.equipmentGroup.hasRejects) {
                this.createRejectRatePromise();
            }
        }
        EquipmentGroupRejectsControllerImpl.prototype.setTabClass = function () {
            if (this.getTabCount() < 2) {
                this.tabClass = 'tab-title-muted';
            }
        };
        EquipmentGroupRejectsControllerImpl.prototype.getTabCount = function () {
            var tabCount = 0;
            if (this.equipmentGroup.hasRejects) {
                tabCount++;
            }
            if (this.detail) {
                if (this.detail.details && this.detail.details.length > 0) {
                    tabCount++;
                }
                if (this.detail.tabs) {
                    tabCount += this.detail.tabs.length;
                }
            }
            if (this.showDistribution) {
                tabCount++;
            }
            if (this.showMoldDistribution) {
                tabCount++;
            }
            return tabCount;
        };
        EquipmentGroupRejectsControllerImpl.prototype.createRejectRatePromise = function () {
            var _this = this;
            var now = moment().startOf('minute');
            if (now.minute() % 10 !== 0) {
                now = now.subtract('minute', now.minute() % 10);
            }
            var endTime = now.toDate();
            var startTime = this.rejectRateRange === 'LastHour'
                ? now.subtract('minute', 60).toDate()
                : now.subtract('hour', 24).toDate();
            this.rejectRatePromise = this.countsService.getGroupRejectCounts(this.shopId, this.equipmentGroup, startTime, endTime)
                .then(function (data) { return _this.equipmentGroup.rejects = data; });
        };
        EquipmentGroupRejectsControllerImpl.prototype.updateRejectRateRange = function () {
            var _this = this;
            this.selectedTab = 'none';
            this.createRejectRatePromise();
            this.loaderService.loadingPromise(this.rejectRatePromise.then(function () {
                _this.selectedTab = _this.tabOptions.RejectRateGraph;
            }));
        };
        EquipmentGroupRejectsControllerImpl.prototype.setSelectedTab = function (tab) {
            var _this = this;
            this.$timeout(function () {
                if (tab === _this.tabOptions.DistributionGraph) {
                    _this.determineDistribution();
                }
                else if (tab === _this.tabOptions.RejectRateGraph) {
                    _this.loaderService.loadingPromise(_this.rejectRatePromise.then(function () {
                        _this.selectedTab = tab;
                    }));
                    return;
                }
                _this.selectedTab = tab;
            }, 50);
        };
        EquipmentGroupRejectsControllerImpl.prototype.close = function () {
            this.$modalInstance.close();
        };
        EquipmentGroupRejectsControllerImpl.prototype.determineDistribution = function () {
            var _this = this;
            this.distributionPretty = [];
            var equipmentIds = Object.keys(this.equipmentGroup.lineLineEquipmentTabs);
            equipmentIds.forEach(function (equipmentId) {
                var tabs = _this.equipmentGroup.lineLineEquipmentTabs[equipmentId];
                var equipment = null;
                var line = null;
                for (var i = 0; i < _this.lines.length; i++) {
                    var targetLine = _this.lines[i];
                    equipment = _.find(targetLine.equipment, { id: equipmentId });
                    if (equipment) {
                        line = targetLine;
                        break;
                    }
                }
                var getCountTotal = function (dataPointId, cell, isAggregate) {
                    if (!cell.count) {
                        return 0;
                    }
                    if (!isAggregate) {
                        if (!cell || !cell.count) {
                            return;
                        }
                        return cell.count.count;
                    }
                    var count = cell.count;
                    var memberIndex = _.findIndex(count.memberCounts, { id: dataPointId });
                    if (memberIndex < 0) {
                        return 0;
                    }
                    return count.finalCounts[memberIndex].count;
                };
                tabs[0].rows.forEach(function (row) {
                    if (row.isSpacer || row.name.toLowerCase().indexOf('camera') > -1) {
                        return;
                    }
                    var cell = row.cells[0];
                    var rowFromDetail = _.find(_this.detail.tabs[0].rows, { name: row.name });
                    var cellFromDetail = rowFromDetail.cells[0];
                    var total = 0;
                    var isRowAggregate = cell.dataPointIds && cell.dataPointIds.length > 0;
                    var isDetailRowAggregate = cellFromDetail.dataPointIds && cellFromDetail.dataPointIds.length > 0;
                    switch (isRowAggregate) {
                        case true:
                            row.cells[0].dataPointIds.forEach(function (dataPointId) {
                                total += getCountTotal(dataPointId, cellFromDetail, isDetailRowAggregate);
                            });
                            break;
                        default:
                            total = getCountTotal(cell.dataPointId, cellFromDetail, isDetailRowAggregate);
                            break;
                    }
                    if (total === 0) {
                        return;
                    }
                    _this.distributionPretty.push({
                        Line: line.number + "-" + equipment.name + "-" + line.name,
                        Defect: row.name,
                        Count: total
                    });
                });
            });
            this.$timeout(function () {
                return _this.$document.find('text.dimple-legend').each(function (i, e) {
                    e.innerHTML = e.innerHTML.substring(2);
                });
            });
        };
        return EquipmentGroupRejectsControllerImpl;
    }());
    exports.default = angular.module('aps.controller.equipmentGroupRejects', requires)
        .controller('EquipmentGroupRejectsCtrl', EquipmentGroupRejectsControllerImpl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <h2 class=modal-header> <div class=wsi-detail-header-left>{{vm.equipmentGroup.name}} ({{vm.equipmentCount}} total)</div> <div class=wsi-detail-header-center></div> <div class=wsi-detail-header-right></div> </h2> <!-- inspect reject section --> <div class=modal-subheader> <div class=inspected>Inspected: {{vm.equipmentGroup.inspectCount.count}}</div> <div class=rejected ng-if=vm.equipmentGroup.hasRejects> Rejected: {{vm.equipmentGroup.rejectCount.count}}&nbsp;&nbsp; {{vm.equipmentGroup.rejectCount.percent}}%&nbsp;&nbsp; <i class=trend ng-class=\"{'trend-up': vm.equipmentGroup.rejectCount.trend.up, 'trend-down': vm.equipmentGroup.rejectCount.trend.down}\"></i> </div> </div> <tabset> <tab class=\"{{vm.tabClass}}\" heading=\"Rej Rate\" alt=\"Reject Rate Over Time\" title=\"Reject Rate Over Time\" ng-if=vm.equipmentGroup.hasRejects select=vm.setSelectedTab(vm.tabOptions.RejectRateGraph)> <select ng-model=vm.rejectRateRange ng-change=vm.updateRejectRateRange()> <option value=LastHour>Last 60 Minutes</option> <option value=Last24Hours>Last 24 Hours</option> </select> <aps-equipment-group-rejects-graph ng-if=\"vm.selectedTab === vm.tabOptions.RejectRateGraph\" group=vm.equipmentGroup time-zone-id=vm.timeZoneId> </aps-equipment-group-rejects-graph> </tab> <tab class=\"{{vm.tabClass}}\" ng-if=\"vm.detail.details.length > 0\" heading=Detail select=\"vm.setSelectedTab('Detail')\"> <div class=row ng-repeat=\"detail in vm.detail.details\"> <div class=\"small-5 large-2 columns\">{{detail.name}}:</div> <div class=\"small-2 large-1 columns rightJustify\">{{detail.count.count}}</div> <div class=\"small-2 large-1 columns\" ng-if=detail.count.showPercent>{{detail.count.percent}}%</div> <div class=\"small-2 large-1 columns\" ng-if=detail.count.showTrend> <i class=trend ng-class=\"{'trend-up': detail.count.trend.up, 'trend-down': detail.count.trend.down}\"></i> </div> <div class=\"small-1 large-7 columns\">&nbsp;</div> </div> </tab> <tab class=\"{{vm.tabClass}}\" ng-repeat=\"tab in vm.detail.tabs\" alt=\"{{tab.toolTip}}\" title=\"{{tab.toolTip}}\" heading=\"{{tab.name}}\" select=vm.setSelectedTab(tab.name)> <react-component name=CountDetailComponent props=tab watch-depth=collection></react-component> </tab> <tab ng-if=vm.showDistribution class=\"{{vm.tabClass}}\" heading=\"Def Distr\" alt=\"Defect Distribution\" title=\"Defect Distribution\" select=vm.setSelectedTab(vm.tabOptions.DistributionGraph)> <dimple-graph ng-if=\"vm.selectedTab === vm.tabOptions.DistributionGraph && vm.distributionPretty && vm.distributionPretty.length > 0\" data=vm.distributionPretty on-tooltip=vm.dimpleFunctions.getToolTip wrap-x-labels=true transition=0 width=100% height=300px> <dimple-x field=Defect title=Defect font-size=9px order-by-desc=Count></dimple-x> <dimple-y field=Count title=\"Reject Count\"></dimple-y> <dimple-graph-legend position=right></dimple-graph-legend> <dimple-stacked-bar field=Line order-by-desc=Line></dimple-stacked-bar> </dimple-graph> <div ng-if=\"!vm.distributionPretty || vm.distributionPretty && vm.distributionPretty.length === 0\"> No {{vm.equipmentGroup.name}} Defects for this Shop </div> </tab> <tab ng-if=vm.showMoldDistribution class=\"{{vm.tabClass}}\" heading=\"Mld Distr\" alt=\"Mold Distribution\" title=\"Mold Distribution\" select=vm.setSelectedTab(vm.tabOptions.MoldDistributionGraph)> <aps-equipment-group-mold-distribution-graph group=vm.equipmentGroup intervalminutes=10></aps-equipment-group-mold-distribution-graph> </tab> </tabset> <!-- bottom button --> <button type=button class=\"button counts-close-button\" ng-click=vm.close()>Close</button> </div>");

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(456), __webpack_require__(457)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, viewChat_controller_1, viewChat_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.directive.viewChat', [viewChat_controller_1.default])
        .directive('apsViewChat', viewChatDirective)
        .name;
    function viewChatDirective() {
        return {
            restrict: 'E',
            template: viewChat_tpl_html_1.default,
            replace: true,
            controller: 'ViewChatCtrl',
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                count: '=',
                desc: '='
            }
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(284), __webpack_require__(23), __webpack_require__(8), __webpack_require__(92), __webpack_require__(60), __webpack_require__(11), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, chatMessage_1, shops_service_1, navigation_service_1, chat_service_1, userProfile_1, dateutility_service_1, _) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [shops_service_1.default, navigation_service_1.default, chat_service_1.default, userProfile_1.default];
    var ViewChatCtrl = (function () {
        ViewChatCtrl.$inject = ["chatService", "navigationService", "$scope", "$timeout", "$modal", "shopService", "userProfile", "$stateParams"];
        function ViewChatCtrl(chatService, navigationService, $scope, $timeout, $modal, shopService, userProfile, $stateParams) {
            var _this = this;
            this.$modal = $modal;
            this.userProfile = userProfile;
            this.plantId = $stateParams.plantId;
            this.shopId = $stateParams.shopId;
            $timeout(function () {
                navigationService.getNavigation()
                    .then(function (navigation) {
                    _this.plant = _.find(navigation.plants(), { id: _this.plantId });
                    if (_this.plant) {
                        _this.shop = _.find(_this.plant.shops, { id: _this.shopId });
                    }
                });
                shopService.getShopConfiguration(_this.shopId)
                    .then(function (shop) { return _this.shopConfig = shop; });
                userProfile.read().then(function (userData) {
                    chatService.getMessages(_this.plantId, _this.shopId)
                        .then(function (data) {
                        _this.chatItems = data;
                        _this.filterAndSortMessages();
                        _this.hub = chatService.createHub(_this.shopId, function (chatAdded) {
                            $timeout(function () {
                                var message = new chatMessage_1.default(chatAdded, userData);
                                if (_this.desc) {
                                    _this.chatItems.push(message);
                                    if (_this.count && _this.chatItems.length > _this.count) {
                                        _this.chatItems.splice(0, 1);
                                    }
                                }
                                else {
                                    _this.chatItems.unshift(message);
                                    if (_this.count && _this.chatItems.length > _this.count) {
                                        _this.chatItems.pop();
                                    }
                                }
                            });
                        });
                    });
                });
            });
            $scope.$on('$destroy', function () {
                if (_this.hub) {
                    _this.hub.uninitialize();
                }
            });
        }
        ViewChatCtrl.prototype.filterAndSortMessages = function () {
            if (!this.chatItems || this.chatItems.length === 0) {
                return;
            }
            this.chatItems.forEach(function (element) {
                if (element.defectLegacyId === null)
                    return element.defectLegacyId = parseInt('');
            });
            if (!this.desc && (!this.count || this.count >= this.chatItems.length)) {
                return;
            }
            var items = _(this.chatItems);
            if (this.count && this.count < this.chatItems.length) {
                items = items.take(this.count);
            }
            if (this.desc) {
                items = items.reverse();
            }
            this.chatItems = items.value();
        };
        ViewChatCtrl.prototype.displayDate = function (date) {
            return dateutility_service_1.default.formatTimeOnly(date, this.plant ? this.plant.timeZoneId : null);
        };
        ViewChatCtrl.prototype.getLocation = function (chatItem) {
            return chatItem.location(this.shopConfig);
        };
        return ViewChatCtrl;
    }());
    exports.default = angular.module('aps.controller.viewChat', requires)
        .controller('ViewChatCtrl', ViewChatCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <div ng-if=!vm.chatItems> Loading chat. Please wait... </div> <div class=main-table-w ng-if=vm.chatItems> <table cellpadding=1 cellspacing=1 ng-if=\"vm.chatItems.length > 0\" class=history-t> <thead> <tr> <th>Time</th> <th>Comment</th> <th>User</th> <th>Type</th> <th>Area</th> </tr></thead> <tbody> <tr ng-repeat=\"item in vm.chatItems\"> <td>{{vm.displayDate(item.createdOn)}}</td> <td>{{item.message}}</td> <td>{{item.createdByFullName}}</td> <!-- Type --> <td ng-if=item.isChat></td> <td ng-if=item.isDefect> <span class=\"lineitem severity-{{item.severity}}\" style=color:#fff;font-size:.9em;padding:4px>{{item.defectLabel()}}</span> </td> <td ng-if=item.isDowntime> <span class=\"lineitem downtime\"><i class=\"fa fa-clock-o\"></i></span> </td> <td ng-if=item.isToolChange> <span class=\"lineitem toolchange\"><i class=\"fa fa-wrench\"></i></span> </td> <!-- Area --> <td ng-if=item.isChat></td> <td ng-if=!item.isChat>{{vm.getLocation(item)}}</td> </tr> </tbody> </table> <div ng-if=\"vm.chatItems.length === 0\"> No chat history or comments found </div> </div> </div>");

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(459), __webpack_require__(460)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, failedChecks_tpl_html_1, failedChecks_controller_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.directive.failedChecks', [failedChecks_controller_1.default])
        .directive('apsFailedChecks', failedChecksDef)
        .name;
    function failedChecksDef() {
        return {
            restrict: 'E',
            template: failedChecks_tpl_html_1.default,
            replace: true,
            controller: 'FailedChecksCtrl',
            controllerAs: 'vm',
            bindToController: true,
            scope: {}
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <div ng-if=vm.loading> Loading failed checks. Please wait... </div> <div class=main-table-w ng-if=!vm.loading> <div ng-if=\"vm.failedCheckLists && !vm.failedCheckLists.length\"> No Failed Checks </div> <table cellpadding=1 cellspacing=1 ng-if=\"vm.failedCheckLists.length > 0\" class=history-t> <thead> <tr> <th>Name</th> <th>Time</th> <th>Role</th> </tr> </thead> <tbody> <tr ng-repeat=\"checkListInstance in vm.failedCheckLists\" ng-click=vm.open(checkListInstance);> <td>{{checkListInstance.checkListName}}</td> <td>{{vm.formatTime(checkListInstance.scheduledOn)}}</td> <td>{{checkListInstance.roleName}}</td> </tr> </tbody> </table> </div> </div> ");

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(5), __webpack_require__(3), __webpack_require__(11), __webpack_require__(30), __webpack_require__(32), __webpack_require__(4), __webpack_require__(75), __webpack_require__(23), __webpack_require__(61)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, aps_enums_1, constant_module_1, dateutility_service_1, checkLists_service_1, checkListInstances_service_1, loader_service_1, checkListInstances_hub_1, shops_service_1, checkListReportDetails_controller_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [checkListReportDetails_controller_1.default, checkLists_service_1.default, checkListInstances_service_1.default, loader_service_1.default,
        checkListInstances_hub_1.default, shops_service_1.default];
    var FailedChecksCtrl = (function () {
        FailedChecksCtrl.$inject = ["checkListsService", "checkListInstancesService", "shopService", "loaderService", "checkListInstancesHubCreator", "$modal", "$scope", "$timeout", "$q", "$stateParams"];
        function FailedChecksCtrl(checkListsService, checkListInstancesService, shopService, loaderService, checkListInstancesHubCreator, $modal, $scope, $timeout, $q, $stateParams) {
            var _this = this;
            this.loading = true;
            this.checkListsService = checkListsService;
            this.checkListInstancesService = checkListInstancesService;
            this.loaderService = loaderService;
            this.plantId = $stateParams.plantId;
            this.shopId = $stateParams.shopId;
            this.timeZoneId = constant_module_1.Strings.DEFAULT_TIMEZONE;
            this.$modal = $modal;
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.$q = $q;
            var failedChecksPromise = (this.shopId ?
                checkListInstancesService.getFailedChecksForShop(this.shopId) :
                checkListInstancesService.getFailedChecksForPlant(this.plantId))
                .then(function (failedCheckLists) {
                _this.failedCheckLists = _.filter(failedCheckLists, function (instance) { return checkListInstancesService.isAuthorizedForCurrentPlant(instance); });
            });
            var promises = [failedChecksPromise];
            if (!_.isUndefined(this.shopId) && !_.isNull(this.shopId)) {
                promises.push(shopService.getShopConfiguration(this.shopId)
                    .then(function (shop) {
                    _this.timeZoneId = shop.timeZoneId;
                }));
            }
            this.hub = checkListInstancesHubCreator.createCheckListInstancesHub(this.plantId, this.shopId, function (updated) { return _this.handleUpdated(updated); }, function (instance) { return _this.handleInstance(instance); });
            this.$scope.$on('$destroy', function () {
                if (_this.hub) {
                    _this.hub.uninitialize();
                }
            });
            $q.all(promises).then(function () { _this.loading = false; });
        }
        FailedChecksCtrl.prototype.handleUpdated = function (updated) {
            var _this = this;
            if (!this.failedCheckLists) {
                return;
            }
            if (updated.instances.length > 0) {
                _.forEach(updated.instances, function (i) { return _this.handleUpdated(i); });
            }
            var existing = _.find(this.failedCheckLists, { id: updated.id });
            if (!existing) {
                return;
            }
            this.$timeout(function () {
                if (updated.action === aps_enums_1.apsEnums.EventAction.Delete
                    || updated.result !== aps_enums_1.apsEnums.CheckListResult.Fail) {
                    _.remove(_this.failedCheckLists, existing);
                }
                else {
                    existing.status = updated.status;
                }
            });
        };
        FailedChecksCtrl.prototype.handleNewInstance = function (instance) {
            if (instance.result !== aps_enums_1.apsEnums.CheckListResult.Fail || instance.checkListIsGroup) {
                return false;
            }
            this.failedCheckLists.push(instance);
            return true;
        };
        FailedChecksCtrl.prototype.handleInstance = function (instance) {
            var _this = this;
            if (!this.failedCheckLists) {
                return;
            }
            if (instance.instances.length > 0) {
                _.forEach(instance.instances, function (i) { return _this.handleInstance(i); });
            }
            this.$timeout(function () {
                if (instance.action === aps_enums_1.apsEnums.EventAction.Add) {
                    if (!_this.handleNewInstance(instance)) {
                        return;
                    }
                }
                else {
                    var existing = _.find(_this.failedCheckLists, { id: instance.id });
                    if (!existing) {
                        if (!_this.handleNewInstance(instance)) {
                            return;
                        }
                    }
                    else if (instance.result !== aps_enums_1.apsEnums.CheckListResult.Fail) {
                        _.remove(_this.failedCheckLists, existing);
                    }
                    else {
                        existing.status = instance.status;
                    }
                }
            });
        };
        FailedChecksCtrl.prototype.formatTime = function (time) {
            return dateutility_service_1.default.formatTimeOnly(time, this.timeZoneId);
        };
        FailedChecksCtrl.prototype.open = function (checkListInstance) {
            var _this = this;
            this.loaderService.loadingPromise(this.checkListsService
                .getCheckListReportDetail(checkListInstance.id, checkListInstance.plantLocationId, checkListInstance.scheduledOn, aps_enums_1.apsEnums.CheckListReportFilter.FailedOnly)
                .then(function (detail) {
                checkListReportDetails_controller_1.openCheckListReportDetails({
                    checkListInstance: detail.reportItem,
                    detail: detail
                }, _this.$modal);
            }));
        };
        return FailedChecksCtrl;
    }());
    exports.default = angular.module('aps.controller.failedChecks', requires)
        .controller('FailedChecksCtrl', FailedChecksCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(462), __webpack_require__(463)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, hourlyCheckReport_controller_1, hourlyCheckReport_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.directive.hourlyCheckReport', [hourlyCheckReport_controller_1.default])
        .directive('apsHourlyCheckReport', hourlyCheckReportDef)
        .name;
    function hourlyCheckReportDef() {
        return {
            restrict: 'E',
            template: hourlyCheckReport_tpl_html_1.default,
            replace: true,
            controller: 'HourlyCheckReportCtrl',
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                plant: '=',
                numHours: '=',
                wellKnownCheck: '=',
                showDetails: '='
            }
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(2), __webpack_require__(5), __webpack_require__(7), __webpack_require__(4), __webpack_require__(30), __webpack_require__(3), __webpack_require__(112), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, moment, _, aps_enums_1, authData_service_1, loader_service_1, checkLists_service_1, constant_module_1, kpiChecks_hub_1, navigation_service_1) {
    "use strict";
    hourlyCheckReportCtrl.$inject = ["loaderService", "checkListsService", "navigationService", "kpiChecksHubService", "authDataService", "$scope", "$timeout", "$stateParams", "$state"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, checkLists_service_1.default, kpiChecks_hub_1.default, navigation_service_1.default, authData_service_1.default];
    exports.default = angular.module('aps.controller.hourlyCheckReport', requires)
        .controller('HourlyCheckReportCtrl', hourlyCheckReportCtrl)
        .name;
    function calculateDay(jobRun) {
        return moment().diff(moment(jobRun.startDate), 'days') + 1;
    }
    function hourlyCheckReportCtrl(loaderService, checkListsService, navigationService, kpiChecksHubService, authDataService, $scope, $timeout, $stateParams, $state) {
        var vm = this;
        var dataTimeout = [];
        vm.hubs = [];
        RefreshScreen(true, false);
        $scope.$on('$destroy', function () {
            if (vm.hubs) {
                _.forEach(vm.hubs, function (h) { return h.uninitialize(); });
            }
            vm.hubs = [];
            dataTimeout.forEach(function (timeout) {
                $timeout.cancel(timeout);
            });
            dataTimeout = [];
            RefreshScreen(false, true);
        });
        function RefreshScreen(firsttime, topofthehour) {
            if (topofthehour) {
                var now = new Date();
                var topOfTheHour = ((59 - now.getMinutes()) * 60000) + ((59 - now.getSeconds()) * 1000) + 5000;
                $timeout(function () {
                    var currentHour = createHourEntry(0, new Date());
                    vm.hours.unshift(currentHour);
                    vm.hours.splice(vm.hours.length - 1, 1);
                    _.forEach(vm.shopJobItems, function (i) {
                        i.hours.unshift({ result: null, status: aps_enums_1.apsEnums.CheckStatus.NotDone, isCaution: false, jobRunId: null });
                        i.hours.splice(vm.hours.length - 1, 1);
                    });
                    RefreshScreen(false, true);
                }, topOfTheHour);
            }
            else {
                var refreshtime = 0;
                if (firsttime)
                    refreshtime;
                else {
                    refreshtime = (((~(new Date().getMinutes() / 20) * 20) * -1) - new Date().getMinutes()) * 60000;
                }
                var timeOut = $timeout(function () {
                    populateHours();
                    navigationService.getNavigation().then(function (nav) { return vm.navigation = nav; });
                    var loadReportPromise = checkListsService.getHourlyCheckReport(vm.plant.id, vm.wellKnownCheck, vm.numHours)
                        .then(function (results) {
                        vm.hourlyReportItems = results;
                        populateShopJobItems();
                        _.forEach(vm.plant.shops, function (shop) {
                            vm.hubs.push(kpiChecksHubService.createKPIChecksHub(function (updated) {
                                var row = _.find(vm.shopJobItems, { shop: shop });
                                if (!row) {
                                    return;
                                }
                                var diff = moment().startOf('hour').diff(updated.eventDate, 'hours');
                                if (diff > vm.numHours) {
                                    return;
                                }
                                var hour = moment(updated.eventDate).utc().hour();
                                var index = _.findIndex(vm.hours, { utcHour: hour });
                                if (index < 0) {
                                    return;
                                }
                                $timeout(function () {
                                    row.hours[index].result = updated.result;
                                    row.hours[index].status = updated.status;
                                });
                            }, shop.id, vm.wellKnownCheck));
                        });
                    });
                    loaderService.loadingPromise(loadReportPromise);
                    RefreshScreen(false, false);
                }, refreshtime);
                dataTimeout.push(timeOut);
            }
        }
        function getHourValue(offset, now) {
            return moment.tz(now, vm.plant.timeZoneId).add(-1 * offset, 'hours').hour();
        }
        function getUTCHourValue(offset, now) {
            return moment(now).utc().add(-1 * offset, 'hours').hour();
        }
        function createHourEntry(offset, now) {
            var hour = getHourValue(offset, now);
            var utcHour = getUTCHourValue(offset, now);
            return {
                hour: hour,
                utcHour: utcHour,
                paddedHour: _.padStart(hour.toString(), 2, '0')
            };
        }
        function populateHours() {
            var now = new Date();
            vm.hours = _.map(_.range(vm.numHours), function (i) { return createHourEntry(i, now); });
        }
        function getCheckItem(hourlyItem, utcHour) {
            if (!hourlyItem) {
                return null;
            }
            return _.find(hourlyItem.checkInstances, function (ci) {
                return ci.utcHour === utcHour;
            });
        }
        function goToShopDashboard(plant, shop) {
            vm.navigation.selectPlantShop(plant, shop);
            $state.go(constant_module_1.States.DASHBOARD, { plantId: plant.id, shopId: shop.id, userId: $stateParams.userId });
        }
        vm.goToShopDashboard = goToShopDashboard;
        function goToProductionSummary(plant, shop) {
            vm.navigation.selectPlantShop(plant, shop);
            $state.go(constant_module_1.States.COUNT_SUMMARY, { plantId: plant.id, shopId: shop.id, userId: $stateParams.userId });
        }
        vm.goToProductionSummary = goToProductionSummary;
        function populateShopJobItems() {
            var items = [];
            var shopCount = 0;
            var shopDailyTotal = 0;
            _.forEach(vm.plant.shops, function (shop) {
                var hourStatus = [];
                var dailyStatus = [];
                var isJCIndicator = false;
                var reportItem = _.find(vm.hourlyReportItems, { shopId: shop.id });
                _.forEach(vm.hours, function (hour) {
                    var checkItem = getCheckItem(reportItem, hour.utcHour);
                    if (checkItem) {
                        if (hour.utcHour === 99) {
                            if (checkItem.result !== "00.0") {
                                shopCount++;
                            }
                            shopDailyTotal = (shopDailyTotal + parseFloat(checkItem.result));
                            dailyStatus.push({ result: checkItem.result, status: checkItem.status, isCaution: false, jobRunId: checkItem.jobRunId });
                        }
                        else {
                            hourStatus.push({ result: checkItem.result, status: checkItem.status, isCaution: false, jobRunId: checkItem.jobRunId });
                        }
                    }
                    else {
                        hourStatus.push({ result: null, status: aps_enums_1.apsEnums.CheckStatus.NotDone, isCaution: false, jobRunId: null });
                    }
                });
                if (!reportItem) {
                    items.push({
                        shop: shop,
                        jobRun: {
                            id: 'N/A',
                            jobId: 'N/A',
                            jobName: 'N/A',
                            jobDescription: 'N/A',
                            jobMold: 'N/A',
                            jobFinish: 'N/A',
                            jobGlassColorName: 'N/A',
                            startDate: '',
                            endDate: null,
                            numberOfSections: 'N/A',
                            machineDisabledSections: [],
                            numberOfGobs: 'N/A',
                            lehrTime: 'N/A',
                            wareClassId: 'N/A'
                        },
                        day: 'N/A',
                        hours: hourStatus,
                        index: 0,
                        jobRunCount: 1,
                        isJCIndicator: isJCIndicator
                    });
                    return;
                }
                var index = 0;
                var jobRunCount = reportItem.jobRuns.length;
                _.forEach(reportItem.jobRuns, function (jobRun, index) {
                    isJCIndicator = false;
                    jobRun.currentRunAverageStr = jobRun.currentRunAverage.toFixed(1);
                    if (index === 0 &&
                        jobRunCount > 1 &&
                        index < jobRunCount - 1 &&
                        jobRun.jobId !== reportItem.jobRuns[index + 1].jobId &&
                        jobRun.jobMold !== "9999") {
                        isJCIndicator = true;
                    }
                    _.forEach(hourStatus, function (hrs) {
                        var hrResult = parseFloat(hrs.result);
                        if (hrResult != null) {
                            var foundJobRun = _.filter(reportItem.jobRuns, function (x) { return x.id === hrs.jobRunId; });
                            if (foundJobRun.length > 0) {
                                var percentDistance = foundJobRun[0].packPercentageTarget - hrResult;
                                if (percentDistance > 0 && percentDistance <= 2) {
                                    hrs.isCaution = true;
                                }
                            }
                        }
                        if (hrs.result != null) {
                            if (hrs.result.indexOf('0') === 0) {
                                hrs.result = "\u00A0" + hrs.result.substr(1);
                            }
                        }
                    });
                    items.push({
                        shop: shop,
                        jobRun: jobRun,
                        hours: hourStatus,
                        dailies: dailyStatus,
                        index: index,
                        day: calculateDay(jobRun),
                        jobRunCount: jobRunCount,
                        isJCIndicator: isJCIndicator
                    });
                    index++;
                });
            });
            vm.shopJobItems = items;
            vm.plantAvg = (shopDailyTotal / shopCount).toFixed(1);
        }
        vm.showDetails = false;
        vm.toggleHidding = function toggleHidding() {
            vm.showDetails = !vm.showDetails;
        };
        vm.showYieldColumn = authDataService.isProductionShiftReport();
        return vm;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <table style=font-size:.75em ng-if=vm.shopJobItems> <thead> <tr> <th>Shop</th> <th class=hideable-mobile style=white-space:nowrap>Mold <span> <a ng-click=vm.toggleHidding()> <i ng-if=vm.showDetails class=\"fa fa-minus\"></i> <i ng-if=!vm.showDetails class=\"fa fa-plus\"></i> </a> </span> </th> <th class=\"hideable hideable-mobile\" ng-class=\"{'is-hidden': !vm.showDetails}\">Finish</th> <th class=\"hideable hideable-mobile\" ng-class=\"{'is-hidden': !vm.showDetails}\">Color</th> <th class=\"hideable hideable-mobile\" ng-class=\"{'is-hidden': !vm.showDetails}\" style=padding-right:100px>Description</th> <th class=\"hideable hideable-mobile\" ng-class=\"{'is-hidden': !vm.showDetails}\" style=padding-right:10px>Day&nbsp;</th> <th class=\"hideable hideable-mobile\" ng-class=\"{'is-hidden': !vm.showDetails}\" style=padding-right:10px>Process</th> <th class=\"hideable hideable-mobile\" ng-class=\"{'is-hidden': !vm.showDetails}\" style=padding-right:10px>Speed</th> <!-- <th class=\"hideable hideable-mobile\" ng-class=\"{'is-hidden': !vm.showDetails || !vm.showYieldColumn}\" style=\"padding-right: 20px;\">Yield&nbsp;</th> --> <th class=\"hideable hideable-mobile\" ng-class=\"{'is-hidden': !vm.showDetails}\" style=padding-right:20px>Best Run&nbsp;</th> <th class=\"hideable hideable-mobile\" ng-class=\"{'is-hidden': !vm.showDetails}\" style=padding-right:10px>Current Run&nbsp;</th> <th class=\"hideable hours-columns collapsed\" ng-repeat=\"hour in vm.hours\" ng-if=\"hour.paddedHour !== 'MTH'\"> {{ hour.paddedHour }} </th> </tr> </thead> <tbody> <tr ng-repeat=\"item in vm.shopJobItems | orderBy: 'shop.name'\" style=cursor:pointer> {{item.jobRunCount}} <td ng-if=\"item.index == 0\" rowspan=\"{{item.jobRunCount}}\" style=white-space:nowrap;width:10%> {{item.shop.name}} &nbsp; <i ng-click=\"vm.goToShopDashboard(vm.plant, item.shop)\" class=\"fa fa-dashboard hideable-mobile\"></i> &nbsp; <i ng-click=\"vm.goToProductionSummary(vm.plant, item.shop)\" class=\"fa fa-table hideable-mobile\"></i> &nbsp; <span ng-if=item.isJCIndicator class=notification-title style=\"color:#fff;background-color:#000;padding:1px 3px;margin:0 1em\">JC</span> <span ng-if=\"(item.index == 1 && item.jobRunCount > 1) || (item.jobRunCount === 1)\" style=\"padding:1px 10px\">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span> </td><td class=hideable-mobile style=width:.7%>{{item.jobRun.jobDescription==='Shop Down'?  '':item.jobRun.jobMold}}</td>  <td class=\"hideable hideable-mobile\" ng-class=\"{'is-hidden': !vm.showDetails}\">{{ item.jobRun.jobDescription==='Shop Down'?  '':item.jobRun.jobFinish}}</td> <td class=\"hideable hideable-mobile\" ng-class=\"{'is-hidden': !vm.showDetails}\">{{item.jobRun.jobDescription==='Shop Down'?  '': item.jobRun.jobGlassColorName}}</td> <td class=\"hideable hideable-mobile\" ng-class=\"{'is-hidden': !vm.showDetails}\" style=width:.7%>{{item.jobRun.jobDescription}}</td> <td class=\"hideable hideable-mobile\" ng-class=\"{'is-hidden': !vm.showDetails, 'first-day': item.day < 2}\">{{item.day}}</td> <td class=\"hideable hideable-mobile\" ng-class=\"{'is-hidden': !vm.showDetails}\">{{item.jobRun.jobDescription==='Shop Down'?  '':item.jobRun.processName}}</td> <td class=\"hideable hideable-mobile\" ng-class=\"{'is-hidden': !vm.showDetails}\">{{item.jobRun.jobDescription==='Shop Down'?  '':item.jobRun.containerSpeed}}</td> <td class=\"hideable hideable-mobile\" ng-class=\"{'is-hidden': !vm.showDetails}\"> <span>{{item.jobRun.jobDescription==='Shop Down'?  '': item.jobRun.packPercentageTarget}}</span> <span ng-if=\"item.jobRun.isOverridenByAdmin == true && item.jobRun.jobDescription !== 'Shop Down'\" style=color:#006400>*</span>  </td> <td class=\"hideable hideable-mobile\" ng-class=\"{'is-hidden': !vm.showDetails}\"> <span ng-if=\"item.jobRun.jobDescription !=='Shop Down'\" ng-class=\"{'pass' : item.jobRun.packPercentageTarget <=  item.jobRun.currentRunAverage,\r\n              'caution' : item.jobRun.packPercentageTarget <= item.jobRun.currentRunAverage + 2 && item.jobRun.packPercentageTarget > item.jobRun.currentRunAverage, \r\n              'fail' : item.jobRun.packPercentageTarget >  item.jobRun.currentRunAverage + 2, \r\n              'na' : item.jobRun.currentRunAverage == 0 }\" style=padding-left:2px;padding-right:2px> <span ng-if=\"item.jobRun.currentRunAverage != 0\">{{item.jobRun.currentRunAverageStr}}</span> <span ng-if=\"item.jobRun.currentRunAverage == 0\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> </span> </td> <td class=\"hours-columns collapsed\" ng-if=\"item.index == 0\" rowspan=\"{{item.jobRunCount}}\" ng-repeat=\"hour in item.hours\" style=width:2em;height:2em> <span class=hourly-zoomable ng-class=\"{'label success' : 2 == hour.status, 'label alert' : 1 == hour.status, 'label info' : 3 == hour.status, 'label caution' : hour.isCaution, 'zoom-in-onethirty': !vm.showDetails }\"> {{ hour.result || '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' }} </span> </td> </tr> </tbody> </table> </div>");

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(465), __webpack_require__(466)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, scheduledCheckLists_controller_1, scheduledCheckLists_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.directive.scheduledCheckLists', [scheduledCheckLists_controller_1.default])
        .directive('apsScheduledCheckLists', scheduledCheckListsDef)
        .name;
    function scheduledCheckListsDef() {
        return {
            restrict: 'E',
            template: scheduledCheckLists_tpl_html_1.default,
            replace: true,
            controller: 'ScheduledCheckListsCtrl',
            controllerAs: 'vm',
            scope: {
                checkListView: '@',
                checkListViewAll: '='
            },
            bindToController: true,
            link: function ($scope) {
                $scope.$watch('vm.checkListViewAll', function (viewAll) {
                    $scope.vm.viewAllChanged(viewAll);
                });
            }
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(5), __webpack_require__(3), __webpack_require__(11), __webpack_require__(32), __webpack_require__(7), __webpack_require__(75), __webpack_require__(23), __webpack_require__(38)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, aps_enums_1, constant_module_1, dateutility_service_1, checkListInstances_service_1, authData_service_1, checkListInstances_hub_1, shops_service_1, fillOutCheckList_controller_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [checkListInstances_service_1.default, authData_service_1.default, checkListInstances_hub_1.default, shops_service_1.default,
        fillOutCheckList_controller_1.default];
    var ScheduledCheckListsCtrl = (function () {
        ScheduledCheckListsCtrl.$inject = ["checkListInstancesService", "$modal", "$q", "authDataService", "shopService", "checkListInstancesHubCreator", "$scope", "$timeout", "$stateParams"];
        function ScheduledCheckListsCtrl(checkListInstancesService, $modal, $q, authDataService, shopService, checkListInstancesHubCreator, $scope, $timeout, $stateParams) {
            var _this = this;
            this.plantId = $stateParams.plantId;
            this.shopId = $stateParams.shopId;
            this.timeZoneId = constant_module_1.Strings.DEFAULT_TIMEZONE;
            this.$modal = $modal;
            this.checkListInstancesService = checkListInstancesService;
            this.authDataService = authDataService;
            this.loading = true;
            this.$q = $q;
            this.viewAll = false;
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.shopPromise = shopService
                .getShopConfiguration(this.shopId)
                .then(function (result) {
                _this.shop = result;
                _this.timeZoneId = result.timeZoneId;
                _this.hub = checkListInstancesHubCreator.createCheckListInstancesHub(_this.plantId, _this.shopId, function (updated) { return _this.handleUpdated(updated); }, function (instance) { return _this.handleInstance(instance); });
            });
            this.$scope.$on('$destroy', function () {
                if (_this.hub) {
                    _this.hub.uninitialize();
                }
            });
        }
        ScheduledCheckListsCtrl.prototype.handleUpdated = function (updated) {
            var _this = this;
            if (!this.list) {
                return;
            }
            if (updated.instances.length > 0) {
                _.forEach(updated.instances, function (i) { return _this.handleUpdated(i); });
            }
            var existing = _.find(this.list, { id: updated.id });
            if (!existing) {
                return;
            }
            this.$timeout(function () {
                if (updated.action === aps_enums_1.apsEnums.EventAction.Delete
                    || updated.status >= aps_enums_1.apsEnums.CheckListStatus.Complete) {
                    _.remove(_this.list, existing);
                }
                else {
                    existing.status = updated.status;
                    existing.result = updated.result;
                }
            });
        };
        ScheduledCheckListsCtrl.prototype.handleNewInstance = function (instance) {
            if (instance.status >= aps_enums_1.apsEnums.CheckListStatus.Complete || instance.checkListIsGroup) {
                return false;
            }
            var currentRole = this.authDataService.getSelectedRoleLocation();
            var roleId = currentRole.role.roleId;
            if (instance.roleId !== roleId
                && !_.some(instance.allowableRoles, function (r) { return r === roleId; })) {
                return false;
            }
            var newItem = this.transformCheckListInstance(instance);
            var index = _.findLastIndex(this.list, function (i) { return i.scheduledOn; }) + 1;
            if (index > this.list.length) {
                this.list.push(newItem);
            }
            else {
                this.list.splice(index, 0, newItem);
            }
            return true;
        };
        ScheduledCheckListsCtrl.prototype.handleInstance = function (instance) {
            var _this = this;
            if (!this.list) {
                return;
            }
            if (instance.instances.length > 0) {
                _.forEach(instance.instances, function (i) { return _this.handleInstance(i); });
            }
            this.$timeout(function () {
                if (instance.action === aps_enums_1.apsEnums.EventAction.Add) {
                    if (!_this.handleNewInstance(instance)) {
                        return;
                    }
                }
                else {
                    var existing = _.find(_this.list, { id: instance.id });
                    if (!existing) {
                        if (!_this.handleNewInstance(instance)) {
                            return;
                        }
                    }
                    else if (instance.status >= aps_enums_1.apsEnums.CheckListStatus.Complete) {
                        _.remove(_this.list, existing);
                    }
                    else {
                        existing.status = instance.status;
                        existing.result = instance.result;
                    }
                }
            });
        };
        ScheduledCheckListsCtrl.prototype.getData = function () {
            var _this = this;
            var currentRole = this.authDataService.getSelectedRoleLocation();
            var roleId = currentRole.role.roleId;
            return this.checkListInstancesService
                .getByRole(this.plantId, this.shopId, roleId, this.checkListView, this.viewAll)
                .then(function (data) {
                var filteredInstances = _.filter(data, function (instance) { return _this.checkListInstancesService.isAuthorizedForCurrentPlant(instance); });
                _this.list = _.map(filteredInstances, function (instance) { return _this.transformCheckListInstance(instance); });
            });
        };
        ScheduledCheckListsCtrl.prototype.viewAllChanged = function (viewAll) {
            var _this = this;
            this.viewAll = viewAll;
            this.loading = true;
            this.$q.all([this.shopPromise, this.getData()]).then(function () { return _this.loading = false; });
        };
        ScheduledCheckListsCtrl.prototype.transformCheckListInstance = function (instance) {
            var checkListItem = _.assign({}, instance);
            checkListItem.isPending = instance.isScheduled && instance.status === aps_enums_1.apsEnums.CheckListStatus.Pending;
            checkListItem.isNotPending = instance.isScheduled && instance.status !== aps_enums_1.apsEnums.CheckListStatus.Pending;
            checkListItem.isNotScheduled = !instance.isScheduled;
            checkListItem.canOpen = function () {
                return checkListItem.isNotScheduled || checkListItem.isNotPending;
            };
            return checkListItem;
        };
        ScheduledCheckListsCtrl.prototype.formatTime = function (time) {
            return dateutility_service_1.default.formatTime(time, this.timeZoneId);
        };
        ScheduledCheckListsCtrl.prototype.open = function (checkListInstance) {
            var _this = this;
            var result = fillOutCheckList_controller_1.openFillOutCheckList({
                checkListId: checkListInstance.checkListId,
                instanceId: checkListInstance.id,
                plantId: checkListInstance.plantId,
                tankId: checkListInstance.tankId,
                shopId: checkListInstance.shopId,
                plantLocationId: checkListInstance.plantLocationId,
                readOnly: false,
                scheduledOn: checkListInstance.scheduledOn
            }, this.$modal);
            if (!checkListInstance.scheduledOn) {
                return;
            }
            result.then(function (cmd) {
                var data = {
                    status: checkListInstance.status,
                    result: aps_enums_1.apsEnums.CheckListResult.Incomplete
                };
                _this.checkListInstancesService.updateStatusAndResult(data, cmd);
                if (data.status === aps_enums_1.apsEnums.CheckListStatus.Complete) {
                    _.remove(_this.list, checkListInstance);
                }
            });
        };
        return ScheduledCheckListsCtrl;
    }());
    exports.default = angular.module('aps.controller.scheduledCheckLists', requires)
        .controller('ScheduledCheckListsCtrl', ScheduledCheckListsCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <div ng-if=vm.loading> Loading check lists. Please wait... </div> <div class=main-table-w ng-if=!vm.loading> <div ng-if=\"vm.list.length === 0\"> No Check Lists </div> <table cellpadding=1 cellspacing=1 ng-if=\"vm.list.length > 0\" class=history-t> <thead> <tr> <th>Name</th> <th>Schedule</th> <th>Scheduled On</th> <th></th> </tr> </thead> <tbody> <tr ng-repeat=\"checkList in vm.list\"> <td>{{checkList.checkListName}}</td> <td ng-if=checkList.isPending>Upcoming</td> <td ng-if=checkList.isNotPending>Scheduled</td> <td ng-if=checkList.isNotScheduled>Unscheduled</td> <td>{{vm.formatTime(checkList.scheduledOn)}}</td> <td> <button class=\"button tiny\" style=margin:0 ng-if=checkList.canOpen() ng-click=vm.open(checkList)> Open </button> </td> </tr> </tbody> </table> </div> </div>");

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(468), __webpack_require__(469)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, recentCheckLists_tpl_html_1, recentCheckLists_controller_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.directive.recentCheckLists', [recentCheckLists_controller_1.default])
        .directive('apsRecentCheckLists', recentCheckListsDirective)
        .name;
    function recentCheckListsDirective() {
        return {
            restrict: 'E',
            template: recentCheckLists_tpl_html_1.default,
            replace: true,
            controller: 'RecentCheckListsCtrl',
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                checkListViewAll: '='
            },
            link: function ($scope) {
                $scope.$watch('vm.checkListViewAll', function (viewAll) {
                    $scope.vm.viewAllChanged(viewAll);
                });
            }
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <div ng-if=vm.loading> Loading check lists. Please wait... </div> <div class=main-table-w ng-if=!vm.loading> <div ng-if=\"vm.list.length === 0\"> No Recent Check Lists </div> <table cellpadding=1 cellspacing=1 ng-if=\"vm.list.length > 0\" class=history-t> <thead> <tr> <th>Name</th> <th>Status</th> <th>Scheduled On</th> <th></th> </tr> </thead> <tbody> <tr ng-repeat=\"checkList in vm.list\"> <td>{{checkList.checkListName}}</td> <th>{{vm.getStatusName(checkList.status)}}</th> <td>{{vm.formatTime(checkList.scheduledOn)}}</td> <td> <button class=\"button tiny\" style=margin:0 ng-click=vm.open(checkList)> Open </button> </td> </tr> </tbody> </table> </div> </div>");

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(5), __webpack_require__(3), __webpack_require__(11), __webpack_require__(38), __webpack_require__(32), __webpack_require__(7), __webpack_require__(23), __webpack_require__(75)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, aps_enums_1, constant_module_1, dateutility_service_1, fillOutCheckList_controller_1, checkListInstances_service_1, authData_service_1, shops_service_1, checkListInstances_hub_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [fillOutCheckList_controller_1.default, checkListInstances_service_1.default, authData_service_1.default, shops_service_1.default,
        checkListInstances_hub_1.default];
    var RecentCheckListsCtrl = (function () {
        RecentCheckListsCtrl.$inject = ["checkListInstancesService", "$modal", "$q", "authDataService", "shopService", "checkListInstancesHubCreator", "$scope", "$timeout", "$stateParams"];
        function RecentCheckListsCtrl(checkListInstancesService, $modal, $q, authDataService, shopService, checkListInstancesHubCreator, $scope, $timeout, $stateParams) {
            var _this = this;
            this.plantId = $stateParams.plantId;
            this.shopId = $stateParams.shopId;
            this.timeZoneId = constant_module_1.Strings.DEFAULT_TIMEZONE;
            this.$modal = $modal;
            this.checkListInstancesService = checkListInstancesService;
            this.$q = $q;
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.loading = true;
            this.viewAll = false;
            this.authDataService = authDataService;
            this.shopPromise = shopService
                .getShopConfiguration(this.shopId)
                .then(function (result) {
                _this.shop = result;
                _this.timeZoneId = result.timeZoneId;
            });
            this.hub = checkListInstancesHubCreator.createCheckListInstancesHub(this.plantId, this.shopId, function (updated) { return _this.handleUpdated(updated); }, function (instance) { return _this.handleInstance(instance); });
            this.$scope.$on('$destroy', function () {
                if (_this.hub) {
                    _this.hub.uninitialize();
                }
            });
        }
        RecentCheckListsCtrl.prototype.handleUpdated = function (updated) {
            var _this = this;
            if (!this.list) {
                return;
            }
            if (updated.instances.length > 0) {
                _.forEach(updated.instances, function (i) { return _this.handleUpdated(i); });
            }
            var existing = _.find(this.list, { id: updated.id });
            if (!existing) {
                return;
            }
            this.$timeout(function () {
                if (updated.action === aps_enums_1.apsEnums.EventAction.Delete
                    || updated.status < aps_enums_1.apsEnums.CheckListStatus.Complete) {
                    _.remove(_this.list, existing);
                }
                else {
                    existing.status = updated.status;
                    existing.result = updated.result;
                }
            });
        };
        RecentCheckListsCtrl.prototype.handleNewInstance = function (instance) {
            if (instance.status < aps_enums_1.apsEnums.CheckListStatus.Complete || instance.checkListIsGroup) {
                return false;
            }
            var currentRole = this.authDataService.getSelectedRoleLocation();
            var roleId = currentRole.role.roleId;
            if (instance.roleId !== roleId
                && !_.some(instance.allowableRoles, function (r) { return r === roleId; })) {
                return false;
            }
            this.list.splice(0, 0, instance);
            return true;
        };
        RecentCheckListsCtrl.prototype.handleInstance = function (instance) {
            var _this = this;
            if (!this.list) {
                return;
            }
            if (instance.instances.length > 0) {
                _.forEach(instance.instances, function (i) { return _this.handleInstance(i); });
            }
            this.$timeout(function () {
                if (instance.action === aps_enums_1.apsEnums.EventAction.Add) {
                    if (!_this.handleNewInstance(instance)) {
                        return;
                    }
                }
                else {
                    var existing = _.find(_this.list, { id: instance.id });
                    if (!existing) {
                        if (!_this.handleNewInstance(instance)) {
                            return;
                        }
                    }
                    else if (instance.status < aps_enums_1.apsEnums.CheckListStatus.Complete) {
                        _.remove(_this.list, existing);
                    }
                    else {
                        existing.status = instance.status;
                        existing.result = instance.result;
                    }
                }
            });
        };
        RecentCheckListsCtrl.prototype.getData = function () {
            var _this = this;
            var currentRole = this.authDataService.getSelectedRoleLocation();
            var roleId = currentRole.role.roleId;
            return this.checkListInstancesService
                .getRecentInstances(this.plantId, this.shopId, roleId, this.viewAll)
                .then(function (data) {
                _this.list = _.filter(data, function (instance) { return _this.checkListInstancesService.isAuthorizedForCurrentPlant(instance); });
            });
        };
        RecentCheckListsCtrl.prototype.viewAllChanged = function (viewAll) {
            var _this = this;
            this.viewAll = viewAll;
            this.loading = true;
            this.$q.all([this.shopPromise, this.getData()]).then(function () { return _this.loading = false; });
        };
        RecentCheckListsCtrl.prototype.formatTime = function (time) {
            return dateutility_service_1.default.formatTime(time, this.timeZoneId);
        };
        RecentCheckListsCtrl.prototype.getStatusName = function (status) {
            return _.startCase(aps_enums_1.apsEnums.CheckListStatus[status]);
        };
        RecentCheckListsCtrl.prototype.open = function (checkListInstance) {
            var _this = this;
            var result = fillOutCheckList_controller_1.openFillOutCheckList({
                checkListId: checkListInstance.checkListId,
                instanceId: checkListInstance.id,
                plantId: checkListInstance.plantId,
                tankId: checkListInstance.tankId,
                shopId: checkListInstance.shopId,
                plantLocationId: checkListInstance.plantLocationId,
                readOnly: false,
                scheduledOn: checkListInstance.scheduledOn
            }, this.$modal);
            result.then(function (cmd) {
                var data = {
                    status: checkListInstance.status,
                    result: aps_enums_1.apsEnums.CheckListResult.Incomplete
                };
                _this.checkListInstancesService.updateStatusAndResult(data, cmd);
                checkListInstance.status = data.status;
            });
        };
        return RecentCheckListsCtrl;
    }());
    exports.default = angular.module('aps.controller.recentCheckLists', requires)
        .controller('RecentCheckListsCtrl', RecentCheckListsCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(471), __webpack_require__(472)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, unfinishedCheckLists_controller_1, unfinishedCheckLists_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.directive.unfinishedCheckLists', [unfinishedCheckLists_controller_1.default])
        .directive('apsUnfinishedCheckLists', unfinishedCheckListsDirective)
        .name;
    function unfinishedCheckListsDirective() {
        return {
            restrict: 'E',
            template: unfinishedCheckLists_tpl_html_1.default,
            replace: true,
            controller: 'UnfinishedCheckListsCtrl',
            controllerAs: 'vm',
            bindToController: true,
            scope: {}
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(5), __webpack_require__(3), __webpack_require__(11), __webpack_require__(32), __webpack_require__(23), __webpack_require__(75), __webpack_require__(38)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, aps_enums_1, constant_module_1, dateutility_service_1, checkListInstances_service_1, shops_service_1, checkListInstances_hub_1, fillOutCheckList_controller_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [checkListInstances_service_1.default, shops_service_1.default, checkListInstances_hub_1.default, fillOutCheckList_controller_1.default];
    var UnfinishedCheckListsCtrl = (function () {
        UnfinishedCheckListsCtrl.$inject = ["checkListInstancesService", "$modal", "$q", "shopService", "checkListInstancesHubCreator", "$scope", "$timeout", "$stateParams"];
        function UnfinishedCheckListsCtrl(checkListInstancesService, $modal, $q, shopService, checkListInstancesHubCreator, $scope, $timeout, $stateParams) {
            var _this = this;
            this.plantId = $stateParams.plantId;
            this.shopId = $stateParams.shopId;
            this.timeZoneId = constant_module_1.Strings.DEFAULT_TIMEZONE;
            this.$modal = $modal;
            this.loading = true;
            this.checkListInstancesService = checkListInstancesService;
            this.$scope = $scope;
            this.$timeout = $timeout;
            var shopPromise = shopService
                .getShopConfiguration(this.shopId)
                .then(function (result) {
                _this.shop = result;
                _this.timeZoneId = result.timeZoneId;
            });
            var instancesPromise = checkListInstancesService
                .getUnfinishedInstances(this.plantId, this.shopId)
                .then(function (data) {
                _this.list = _.filter(data, function (instance) { return checkListInstancesService.isAuthorizedForCurrentPlant(instance); });
            });
            $q.all([shopPromise, instancesPromise]).then(function () { return _this.loading = false; });
            this.hub = checkListInstancesHubCreator.createCheckListInstancesHub(this.plantId, this.shopId, function (updated) { return _this.handleUpdated(updated); }, function (instance) { return _this.handleInstance(instance); });
            this.$scope.$on('$destroy', function () {
                if (_this.hub) {
                    _this.hub.uninitialize();
                }
            });
        }
        UnfinishedCheckListsCtrl.prototype.handleUpdated = function (updated) {
            var _this = this;
            if (!this.list) {
                return;
            }
            if (updated.instances.length > 0) {
                _.forEach(updated.instances, function (i) { return _this.handleUpdated(i); });
            }
            var existing = _.find(this.list, { id: updated.id });
            if (!existing) {
                return;
            }
            this.$timeout(function () {
                if (updated.action === aps_enums_1.apsEnums.EventAction.Delete
                    || updated.status === aps_enums_1.apsEnums.CheckListStatus.Pending
                    || updated.status === aps_enums_1.apsEnums.CheckListStatus.Complete) {
                    _.remove(_this.list, existing);
                }
                else {
                    existing.status = updated.status;
                    existing.result = updated.result;
                }
            });
        };
        UnfinishedCheckListsCtrl.prototype.handleNewInstance = function (instance) {
            if (instance.status === aps_enums_1.apsEnums.CheckListStatus.Complete
                || instance.status === aps_enums_1.apsEnums.CheckListStatus.Pending
                || instance.checkListIsGroup) {
                return false;
            }
            this.list.push(instance);
            return true;
        };
        UnfinishedCheckListsCtrl.prototype.handleInstance = function (instance) {
            var _this = this;
            if (!this.list) {
                return;
            }
            if (instance.instances.length > 0) {
                _.forEach(instance.instances, function (i) { return _this.handleInstance(i); });
            }
            this.$timeout(function () {
                if (instance.action === aps_enums_1.apsEnums.EventAction.Add) {
                    if (!_this.handleNewInstance(instance)) {
                        return;
                    }
                }
                else {
                    var existing = _.find(_this.list, { id: instance.id });
                    if (!existing) {
                        if (!_this.handleNewInstance(instance)) {
                            return;
                        }
                    }
                    else if (instance.status === aps_enums_1.apsEnums.CheckListStatus.Complete
                        || instance.status === aps_enums_1.apsEnums.CheckListStatus.Pending) {
                        _.remove(_this.list, existing);
                    }
                    else {
                        existing.status = instance.status;
                        existing.result = instance.result;
                    }
                }
            });
        };
        UnfinishedCheckListsCtrl.prototype.formatTime = function (time) {
            return dateutility_service_1.default.formatTime(time, this.timeZoneId);
        };
        UnfinishedCheckListsCtrl.prototype.getStatusName = function (status) {
            return _.startCase(aps_enums_1.apsEnums.CheckListStatus[status]);
        };
        UnfinishedCheckListsCtrl.prototype.open = function (checkListInstance) {
            var _this = this;
            var result = fillOutCheckList_controller_1.openFillOutCheckList({
                checkListId: checkListInstance.checkListId,
                instanceId: checkListInstance.id,
                plantId: checkListInstance.plantId,
                tankId: checkListInstance.tankId,
                shopId: checkListInstance.shopId,
                plantLocationId: checkListInstance.plantLocationId,
                readOnly: false,
                scheduledOn: checkListInstance.scheduledOn
            }, this.$modal);
            result.then(function (cmd) {
                var data = {
                    status: checkListInstance.status,
                    result: aps_enums_1.apsEnums.CheckListResult.Incomplete
                };
                _this.checkListInstancesService.updateStatusAndResult(data, cmd);
                if (data.status === aps_enums_1.apsEnums.CheckListStatus.Complete) {
                    _.remove(_this.list, checkListInstance);
                }
            });
        };
        return UnfinishedCheckListsCtrl;
    }());
    exports.default = angular.module('aps.controller.unfinishedCheckLists', requires)
        .controller('UnfinishedCheckListsCtrl', UnfinishedCheckListsCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <div ng-if=vm.loading> Loading check lists. Please wait... </div> <div class=main-table-w ng-if=!vm.loading> <ul ng-if=\"vm.list.length === 0\"> <li>No Unfinished Check Lists</li> </ul> <table cellpadding=1 cellspacing=1 ng-if=\"vm.list.length > 0\" class=history-t> <thead> <tr> <th>Name</th> <th>Status</th> <th>Scheduled On</th> <th></th> </tr> </thead> <tbody> <tr ng-repeat=\"checkList in vm.list\"> <td>{{checkList.checkListName}}</td> <th>{{vm.getStatusName(checkList.status)}}</th> <td>{{vm.formatTime(checkList.scheduledOn)}}</td> <td> <button class=\"button tiny\" style=margin:0 ng-click=vm.open(checkList)> Open </button> </td> </tr> </tbody> </table> </div> </div>");

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(474), __webpack_require__(521)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, equipmentGroupMoldDistributionGraph_controller_1, equipmentGroupMoldDistributionGraph_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.directive.equipmentGroupMoldDistributionGraph', [equipmentGroupMoldDistributionGraph_controller_1.default])
        .directive('apsEquipmentGroupMoldDistributionGraph', equipmentGroupMoldDistributionGraphDirective)
        .name;
    function equipmentGroupMoldDistributionGraphDirective() {
        return {
            restrict: 'E',
            template: equipmentGroupMoldDistributionGraph_tpl_html_1.default,
            replace: true,
            controller: 'EquipmentGroupMoldDistributionGraphCtrl',
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                group: '=',
                end: '=',
                width: '@?',
                height: '@?'
            }
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(76), __webpack_require__(1), __webpack_require__(2), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, Chart, moment, _, aps_enums_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var EquipmentGroupMoldDistributionGraphController = (function () {
        EquipmentGroupMoldDistributionGraphController.$inject = ["$scope", "$timeout", "$document"];
        function EquipmentGroupMoldDistributionGraphController($scope, $timeout, $document) {
            var _this = this;
            this.width = 400;
            this.height = 200;
            this.pointInterval = aps_enums_1.apsEnums.CountInterval.TenMinutes;
            this.equipment = [];
            this.equipmentUpdated = {};
            this.moldList = [];
            this.$document = $document;
            $timeout(function () {
                for (var key in _this.group.equipment) {
                    _this.equipment.push(_this.group.equipment[key]);
                }
                _this.dataSets = _this.createChartDataSets(_this.equipment);
                _this.pointIntervalMs = _this.getPointIntervalMs(_this.pointInterval);
                var ctx = $document.find('#chart')[0];
                _this.chart = new Chart(ctx.getContext('2d'), {
                    type: 'bar',
                    data: {
                        datasets: _this.dataSets,
                        labels: _this.moldList
                    },
                    options: {
                        tooltips: {
                            mode: 'index',
                            callbacks: {
                                label: function (item, data) { return data.datasets[item.datasetIndex].label + ': ' + data.datasets[item.datasetIndex].data[item.index]; }
                            }
                        },
                        scales: {
                            xAxes: [{
                                    stacked: true
                                }],
                            yAxes: [{
                                    type: 'linear',
                                    stacked: true
                                }]
                        }
                    }
                });
                _this.updateData();
                _this.group.groupUpdated = _this.updateData;
            });
            $scope.$on('$destroy', function () {
                _this.group.groupUpdated = null;
            });
        }
        EquipmentGroupMoldDistributionGraphController.prototype.getPointIntervalMs = function (interval) {
            var minute = 1000 * 60;
            switch (interval) {
                case (aps_enums_1.apsEnums.CountInterval.Minute):
                    return minute;
                case (aps_enums_1.apsEnums.CountInterval.TenMinutes):
                    return minute * 10;
                case (aps_enums_1.apsEnums.CountInterval.Hour):
                    return minute * 60;
                case (aps_enums_1.apsEnums.CountInterval.Day):
                    return minute * 60 * 24;
            }
        };
        EquipmentGroupMoldDistributionGraphController.prototype.updateData = function () {
            var newCountsAdded = false;
            var _loop_1 = function (i) {
                var newestCount = _.first(_.orderBy(this_1.equipment[i].inspectCount.filteredCounts, ['intervalEndTime'], ['desc']));
                var data = this_1.dataSets[i].data;
                if (newestCount.intervalEndTime > this_1.equipmentUpdated[this_1.equipment[i].id]) {
                    var updatedTimeBracket_1 = this_1.getTimeBracket(this_1.equipmentUpdated[this_1.equipment[i].id]);
                    var newPoints = this_1.createIntervalDataPoints(this_1.equipment[i], updatedTimeBracket_1);
                    var oldestCount_1 = _.first(_.orderBy(this_1.equipment[i].inspectCount.filteredCounts, 'intervalEndTime'));
                    _.remove(data, function (p) { return p.x === updatedTimeBracket_1; });
                    _.remove(data, function (p) { return p.x < oldestCount_1.intervalEndTime; });
                    (_a = data).push.apply(_a, newPoints);
                    newCountsAdded = true;
                }
                var _a;
            };
            var this_1 = this;
            for (var i = 0; i < this.equipment.length; i++) {
                _loop_1(i);
            }
            if (newCountsAdded) {
                this.chart.update();
            }
        };
        EquipmentGroupMoldDistributionGraphController.prototype.createChartDataSets = function (equipments) {
            var _this = this;
            var lineColors = [
                'rgba(181, 14, 9, 0.5)', 'rgba(10, 88, 214, 0.5)', 'rgba(13, 150, 59, 0.5)', 'rgba(181, 115, 9, 0.5)'
            ];
            var index = -1;
            equipments = _.sortBy(equipments, function (x) { return -x.line.number; });
            var dataSets = equipments.map(function (x) {
                index++;
                return {
                    label: x.name + "-" + x.line.name,
                    data: _this.createIntervalDataPoints(x),
                    backgroundColor: lineColors[index % 4]
                };
            });
            var moldList = [];
            dataSets.forEach(function (ds) {
                for (var i = 0; i < 128; i++) {
                    if (ds.data[i]) {
                        moldList.push(i.toString(10));
                    }
                }
            });
            moldList = moldList.filter(function (v, i, s) {
                return s.indexOf(v) === i;
            }).sort(function (x1, x2) { return Number(x1) - Number(x2); });
            moldList.forEach(function (mold) {
                var anyCount = false;
                dataSets.forEach(function (ds) {
                    if (ds.data[mold] && ds.data[mold] > 0) {
                        anyCount = true;
                    }
                });
                if (anyCount) {
                    dataSets.forEach(function (ds) {
                        if (!ds.data[mold]) {
                            ds.data[mold] = 0;
                        }
                    });
                }
            });
            dataSets.forEach(function (ds) {
                var newData = [];
                moldList.forEach(function (m) {
                    newData.push(ds.data[m]);
                });
                ds.data = newData;
            });
            this.moldList = moldList;
            return dataSets;
        };
        EquipmentGroupMoldDistributionGraphController.prototype.getTimeBracket = function (time, intervalMinutes) {
            if (intervalMinutes === void 0) { intervalMinutes = 10; }
            var end = moment(time);
            return end.add('minutes', intervalMinutes - end.minute() % intervalMinutes).valueOf();
        };
        EquipmentGroupMoldDistributionGraphController.prototype.createIntervalDataPoints = function (equipment, lastUpdatedBracket) {
            var _this = this;
            if (lastUpdatedBracket === void 0) { lastUpdatedBracket = null; }
            var inspectCounts = _.sortBy(equipment.inspectCount.filteredCounts, function (x) { return x.intervalEndTime; });
            var startIndex = 0;
            if (lastUpdatedBracket) {
                startIndex = _.findIndex(inspectCounts, function (x) { return x.intervalEndTime > lastUpdatedBracket - _this.pointIntervalMs
                    && x.intervalEndTime <= lastUpdatedBracket; });
            }
            var count = [];
            for (var i = startIndex; i < inspectCounts.length; i++) {
                for (var mc in inspectCounts[i].moldCounts) {
                    if (!count[mc]) {
                        count[mc] = 0;
                    }
                    count[mc] += inspectCounts[i].moldCounts[mc].value;
                }
            }
            return count;
        };
        return EquipmentGroupMoldDistributionGraphController;
    }());
    exports.default = angular.module('aps.controller.equipmentGroupMoldDistributionGraph', [])
        .controller('EquipmentGroupMoldDistributionGraphCtrl', EquipmentGroupMoldDistributionGraphController)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div id=groupMoldDistributionChart> <canvas id=chart width=\"{{vm.width}}\" height=\"{{vm.height}}\"></canvas> </div>");

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(523), __webpack_require__(524)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, equipmentGroupRejectsGraph_controller_1, equipmentGroupRejectsGraph_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.directive.equipmentGroupRejectsGraph', [equipmentGroupRejectsGraph_controller_1.default])
        .directive('apsEquipmentGroupRejectsGraph', equipmentGroupRejectsGraphDirective)
        .name;
    function equipmentGroupRejectsGraphDirective() {
        return {
            restrict: 'E',
            template: equipmentGroupRejectsGraph_tpl_html_1.default,
            replace: true,
            controller: 'EquipmentGroupRejectsGraphCtrl',
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                group: '=',
                timeZoneId: '='
            }
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(76), __webpack_require__(2), __webpack_require__(1), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, Chart, _, moment, dateutility_service_1) {
    "use strict";
    equipmentGroupRejectsGraphCtrl.$inject = ["$scope", "$timeout", "$document"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [];
    function updateModel(count) {
        count.intervalEndTime = count.intervalEnd.getTime();
    }
    exports.default = angular.module('aps.controller.equipmentGroupRejectsGraph', requires)
        .controller('EquipmentGroupRejectsGraphCtrl', equipmentGroupRejectsGraphCtrl)
        .name;
    function renderChart(vm, $document) {
        vm.dataSets = createChartDataSets(vm);
        var ctx = $document.find('#chart')[0];
        return new Chart(ctx.getContext('2d'), {
            type: 'line',
            data: {
                datasets: vm.dataSets
            },
            options: {
                maintainAspectRatio: true,
                elements: {
                    point: {
                        hitRadius: 4,
                        hoverRadius: 2
                    },
                    line: {
                        tension: 0.001
                    }
                },
                tooltips: {
                    mode: 'index',
                    callbacks: {
                        label: function (item, data) { return data.datasets[item.datasetIndex].label + ': ' + Number(item.yLabel).toFixed(2) + '%'; }
                    }
                },
                scales: {
                    xAxes: [{
                            type: 'time',
                            time: {
                                tooltipFormat: 'M/D h:mm A',
                                displayFormats: {
                                    minute: 'M/D h:mm A',
                                    hour: 'M/D h:mm A',
                                    day: 'M/D'
                                }
                            },
                            ticks: {
                                maxRotation: 30,
                                minRotation: 30
                            }
                        }],
                    yAxes: [{
                            ticks: {
                                min: 0
                            }
                        }]
                }
            }
        });
    }
    function getSortedEquipment(group) {
        return _.sortBy(group.rejects, 'lineOrder').map(function (x) {
            var equipment;
            if (group.equipment) {
                for (var key in group.equipment) {
                    var equip = group.equipment[key];
                    if (equip.name === x.equipmentName && equip.line.name === x.lineName) {
                        equipment = equip;
                        break;
                    }
                }
            }
            return {
                equipment: equipment,
                rejects: x
            };
        });
    }
    function createChartDataSets(vm) {
        var lineColors = [
            'rgba(181, 14, 9, 0.5)', 'rgba(10, 88, 214, 0.5)', 'rgba(13, 150, 59, 0.5)', 'rgba(181, 115, 9, 0.5)'
        ];
        return getSortedEquipment(vm.group).map(function (x, i) {
            return {
                label: x.rejects.equipmentName + "-" + x.rejects.lineName,
                fill: false,
                pointRadius: 0,
                data: createIntervalDataPoints(x.rejects.counts, x.equipment, vm),
                borderColor: lineColors[i % 4],
                backgroundColor: lineColors[i % 4],
                borderWidth: 1
            };
        });
    }
    function updateChart(chart, vm) {
        var currentMinute = moment().startOf('minute');
        var minutesPast10 = currentMinute.minute() % 10;
        var endTime = currentMinute.subtract('minute', minutesPast10).toDate().getTime();
        var updated = false;
        getSortedEquipment(vm.group).forEach(function (e, i) {
            var data = vm.dataSets[i].data;
            var lastBucket = getLastBucket(e.equipment, endTime);
            var currentLast = _.last(data);
            if (!lastBucket) {
                return;
            }
            if (!currentLast || currentLast.x <= endTime) {
                data.push(lastBucket);
                updated = true;
            }
            else if (currentLast.x !== lastBucket.x || currentLast.y !== lastBucket.y) {
                currentLast.x = lastBucket.x;
                currentLast.y = lastBucket.y;
                updated = true;
            }
        });
        if (updated) {
            chart.update();
        }
    }
    function createIntervalDataPoints(data, equipment, vm) {
        var points = [];
        data.inspectCounts.forEach(updateModel);
        data.rejectCounts.forEach(updateModel);
        var inspectCounts = _.sortBy(data.inspectCounts, function (x) { return x.intervalEndTime; });
        var rejectCounts = data.rejectCounts;
        var startTime = inspectCounts[0].intervalEndTime;
        var endTime = inspectCounts[inspectCounts.length - 1].intervalEndTime;
        var currentTime = startTime;
        var currentIndex = 0;
        var interval = null;
        var intervalStart = null;
        inspectCounts.forEach(function (c, i) {
            if (i === 0) {
                intervalStart = c.intervalEndTime;
                return;
            }
            var currentInterval = c.intervalEndTime - intervalStart;
            if (!interval || interval > currentInterval) {
                interval = currentInterval;
            }
            intervalStart = c.intervalEndTime;
        });
        if (!interval) {
            interval = 600000;
        }
        while (currentTime <= endTime && currentIndex < inspectCounts.length) {
            var inspectCount = 0;
            var inspect = inspectCounts[currentIndex];
            if (inspect.intervalEndTime === currentTime) {
                inspectCount = inspect.value;
                currentIndex++;
            }
            var rejectCount = 0;
            var reject = _.find(rejectCounts, { intervalEndTime: currentTime });
            if (reject) {
                rejectCount = reject.value;
            }
            var rejectPercent = 0;
            if (inspectCount !== 0 && rejectCount !== 0) {
                rejectPercent = rejectCount * 100 / inspectCount;
            }
            pushPoint(currentTime, rejectPercent, points, vm);
            currentTime += interval;
        }
        if (equipment) {
            setLastBucket(equipment, points, vm, endTime);
        }
        return points;
    }
    function getLastBucket(equipment, endTime) {
        if (!equipment) {
            return null;
        }
        var lastInspectCounts = equipment.inspectCount.counts.filter(function (x) { return x.intervalStartTime >= endTime; });
        if (lastInspectCounts.length === 0) {
            return null;
        }
        var maxTime = _.max(_.map(lastInspectCounts, 'intervalEndTime'));
        var inspectCount = _.sum(_.map(lastInspectCounts, 'value'));
        var rejectCount = 0;
        var lastRejectCounts = equipment.rejectCount.counts.filter(function (x) {
            return x.intervalStartTime >= endTime && x.intervalEndTime <= maxTime;
        });
        if (lastRejectCounts.length > 0) {
            rejectCount = _.sum(_.map(lastRejectCounts, 'value'));
        }
        var rejectPercent = 0;
        if (inspectCount !== 0 && rejectCount !== 0) {
            rejectPercent = rejectCount * 100 / inspectCount;
        }
        return { x: maxTime, y: rejectPercent };
    }
    function setLastBucket(equipment, points, vm, endTime) {
        var lastBucket = getLastBucket(equipment, endTime);
        if (lastBucket) {
            pushPoint(lastBucket.x, lastBucket.y, points, vm);
        }
    }
    function pushPoint(time, rejectPercent, points, vm) {
        var localTime = vm.getLocalTime(new Date(time)).getTime();
        points.push({ x: localTime, y: rejectPercent });
    }
    function equipmentGroupRejectsGraphCtrl($scope, $timeout, $document) {
        var vm = this;
        function getLocalTime(plantTime) {
            return dateutility_service_1.default.timeZoneToLocal(plantTime, vm.timeZoneId).toDate();
        }
        vm.getLocalTime = getLocalTime;
        $timeout(function () {
            var chart = renderChart(vm, $document);
            function groupUpdated() {
                updateChart(chart, vm);
            }
            vm.group.groupUpdated = groupUpdated;
        });
        $scope.$on('$destroy', function () {
            vm.group.groupUpdated = null;
        });
        return vm;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div id=groupRejectsChart> <canvas id=chart></canvas> </div>");

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(526), __webpack_require__(527)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, topDefects_tpl_html_1, topDefects_controller_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.directive.topDefects', [topDefects_controller_1.default])
        .directive('apsTopDefects', topDefectsDef)
        .name;
    function topDefectsDef() {
        return {
            restrict: 'E',
            template: topDefects_tpl_html_1.default,
            replace: true,
            controller: 'TopDefectsCtrl',
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                shop: '=',
                queryStart: '=',
                queryEnd: '=',
                maxDefects: '=',
                plantTimeZoneId: '='
            }
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <h5>Shop: {{vm.shop.name}}</h5> <table class=history-t ng-if=\"vm.defects && vm.defects.length\"> <thead> <tr> <th>Defect</th> <th>Instances</th> </tr> </thead> <tbody> <tr ng-repeat=\"defect in vm.defects | orderBy:['-count','severity']\" style=cursor:auto> <td>{{ defect.defectTypeName }} <span ng-if=defect.defectTypeLegacyId>[{{ defect.defectTypeLegacyId }}]</span></td> <td>{{ defect.count }}</td> </tr> </tbody> </table> <div ng-if=\"!vm.defects || !vm.defects.length\">No Defects</div> </div>");

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(4), __webpack_require__(16), __webpack_require__(287)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, loader_service_1, report_service_1, topDefects_hub_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, report_service_1.default, topDefects_hub_1.default];
    var TopDefectsCtrl = (function () {
        TopDefectsCtrl.$inject = ["loaderService", "topDefectsHubCreator", "$scope", "$timeout", "reportService"];
        function TopDefectsCtrl(loaderService, topDefectsHubCreator, $scope, $timeout, reportService) {
            var _this = this;
            this.loaderService = loaderService;
            this.reportService = reportService;
            this.critical = false;
            this.$scope = $scope;
            this.$timeout = $timeout;
            $timeout(function () {
                _this.loadData();
                _this.hub = topDefectsHubCreator.createTopDefectsHub(_this.shop.id, function (d) { return _this.onDefectAdded(d); }, function (d) { return _this.onDefectRemoved(d); });
            });
            this.$scope.$on('$destroy', function () {
                if (_this.hub) {
                    _this.hub.uninitialize();
                }
            });
        }
        TopDefectsCtrl.prototype.onDefectAdded = function (defect) {
            var _this = this;
            if (!this.defects || this.queryStart.getTime() > defect.timeFound.getTime()) {
                return;
            }
            this.$timeout(function () {
                var existing = _.find(_this.defects, { defectTypeId: defect.defectTypeId });
                if (existing) {
                    existing.count = existing.count + 1;
                    if (existing.severity > defect.severity) {
                        existing.severity = defect.severity;
                    }
                }
                else {
                    _this.defects.push(_.assign({ count: 1 }, defect));
                }
            });
        };
        TopDefectsCtrl.prototype.onDefectRemoved = function (defect) {
            var _this = this;
            if (!this.defects || this.queryStart.getTime() > defect.timeFound.getTime()) {
                return;
            }
            var existing = _.find(this.defects, { defectTypeId: defect.defectTypeId });
            if (!existing) {
                return;
            }
            this.$timeout(function () {
                existing.count = existing.count - 1;
                if (existing.count <= 0) {
                    _.remove(_this.defects, existing);
                }
            });
        };
        TopDefectsCtrl.prototype.loadData = function () {
            var _this = this;
            var loadPromise = this.reportService.getTopDefectsReport(this.shop.id, this.queryStart, this.queryEnd, this.maxDefects, this.critical).then(function (defects) {
                _this.defects = defects;
            });
            this.loaderService.loadingPromise(loadPromise);
        };
        return TopDefectsCtrl;
    }());
    exports.default = angular.module('aps.controller.topDefects', requires)
        .controller('TopDefectsCtrl', TopDefectsCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(529), __webpack_require__(530)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, topDefectsGraph_tpl_html_1, topDefectsGraph_controller_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.directive.topDefectsGraph', [topDefectsGraph_controller_1.default])
        .directive('apsTopDefectsGraph', topDefectsGraphDef)
        .name;
    function topDefectsGraphDef() {
        return {
            restrict: 'E',
            template: topDefectsGraph_tpl_html_1.default,
            replace: true,
            controller: 'TopDefectsGraphCtrl',
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                defects: '=',
                defectSelected: '=',
                showIfEmpty: '='
            },
            link: function ($scope, elm, attrs) {
                $scope.$watchCollection('vm.defects', function (newVal) {
                    $scope.vm.setDefects(newVal);
                });
            }
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <dimple-graph ng-if=\"vm.showIfEmpty || (vm.defectsPretty && vm.defectsPretty.length)\" data=vm.defectsPretty dimple-click=vm.chartClickWorkaround.barClick bar-color-override=vm.defectNameToColor wrap-x-labels=true transition=0 width=100% height=200px> <dimple-x field=Defect title=null font-size=9px order-by-desc=\"Sort Value\"></dimple-x> <dimple-y field=Count title=null></dimple-y> <dimple-bar field=Defect></dimple-bar> </dimple-graph> <div ng-if=\"!vm.showIfEmpty && vm.defectsPretty && !vm.defectsPretty.length\"> No Defects for this Shop </div> </div>");

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(4), __webpack_require__(9)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, loader_service_1, uiUtility_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, uiUtility_service_1.default];
    var TopDefectsGraphCtrl = (function () {
        TopDefectsGraphCtrl.$inject = ["uiUtilityService"];
        function TopDefectsGraphCtrl(uiUtilityService) {
            var _this = this;
            this.uiUtilityService = uiUtilityService;
            this.chartClickWorkaround = {
                barClick: function (dimpleEvent) {
                    if (dimpleEvent && dimpleEvent.xValue) {
                        var selectedDefect = _.find(_this.defects, { defectTypeName: dimpleEvent.xValue, count: dimpleEvent.yValue });
                        if (selectedDefect && _this.defectSelected) {
                            _this.defectSelected(selectedDefect);
                        }
                    }
                }
            };
        }
        TopDefectsGraphCtrl.prototype.setDefects = function (defects) {
            var _this = this;
            this.defects = defects;
            this.defectNameToColor = {};
            _.forEach(defects, function (d) {
                var color = _this.uiUtilityService.getSeverityColor(d.severity);
                if (color) {
                    _this.defectNameToColor[d.defectTypeName] = color;
                }
            });
            var unSortedDefectsPretty = _.map(defects, function (d) {
                return {
                    'Defect': d.defectTypeName,
                    'Count': d.count,
                    'Sort Value': (d.count * 100) + (10 - d.severity)
                };
            });
            this.defectsPretty = _.orderBy(unSortedDefectsPretty, ['Count', 'Severity'], ['desc', 'asc']);
        };
        return TopDefectsGraphCtrl;
    }());
    exports.default = angular.module('aps.controller.topDefectsGraph', requires)
        .controller('TopDefectsGraphCtrl', TopDefectsGraphCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(532), __webpack_require__(533)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, topRejectsGraph_controller_1, topRejectsGraph_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular
        .module('aps.directive.topRejectsGraph', [topRejectsGraph_controller_1.default])
        .directive('apsTopRejectsGraph', topRejectsGraphDef)
        .name;
    function topRejectsGraphDef() {
        return {
            restrict: 'E',
            template: topRejectsGraph_tpl_html_1.default,
            replace: true,
            controller: 'TopRejectsGraphCtrl',
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                model: '=',
                interval: '=',
                equipmentSelected: '='
            },
            link: function ($scope, elm, attrs) {
                $scope.vm.setShift($scope.vm.interval);
                $scope.vm.model.equipmentGroups.forEach(function (group, i) {
                    if (group.hasRejects) {
                        $scope.$watch('vm.model.equipmentGroups[' + i + '].rejectCount', function () { return $scope.vm.renderChart(); });
                    }
                });
                $scope.vm.renderChart();
            }
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(27)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, enums_1) {
    "use strict";
    topRejectsGraphCtrl.$inject = ["$scope", "uiUtilityService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular
        .module('aps.controller.topRejectsGraph', [])
        .controller('TopRejectsGraphCtrl', topRejectsGraphCtrl)
        .name;
    function topRejectsGraphCtrl($scope, uiUtilityService) {
        var vm = {
            showIfEmpty: true,
            equipmentSelected: $scope.equipmentSelected,
            model: $scope.model,
            renderChart: null,
            rejectNameToColor: {},
            shiftSelectors: {
                buttons: [],
                select: null
            },
            setShift: null,
            selectShift: null,
            interval: $scope.interval,
            rejectsPretty: {
                chart: {
                    type: 'column'
                },
                title: {
                    text: ''
                },
                yAxis: {
                    title: { enabled: false }
                },
                xAxis: {
                    categories: []
                },
                legend: { enabled: false },
                credits: {
                    enabled: false
                },
                exporting: { enabled: false },
                tooltip: {
                    formatter: function () {
                        return 'Defect: <b>' + this.x + '</b><br />'
                            + this.series.name + ': <b>' + this.y + '</b>';
                    }
                },
                series: [],
                reflow: true,
                callBack: null
            }
        };
        var intervals = enums_1.apsDisplayEnums.CountDisplayInterval;
        var interval = enums_1.apsDisplayEnums.CountDisplayInterval.Last24Hours;
        while (intervals[interval]) {
            vm.shiftSelectors.buttons.push({
                name: intervals[interval],
                value: interval,
                selected: vm.shiftSelectors.buttons.length === 0
            });
            interval++;
        }
        vm.renderChart = function () {
            var data = vm.model.equipmentGroups
                .filter(function (e) { return e.hasRejects; });
            vm.rejectsPretty.xAxis.categories = data.map(function (e) { return e.name; });
            for (var i = 0; i < data.length; i++) {
                var color = uiUtilityService.getRejectColor(i);
                if (color) {
                    vm.rejectNameToColor[vm.rejectsPretty.xAxis.categories[i]] = color;
                }
            }
            vm.rejectsPretty.xAxis.categories = data.map(function (e) { return e.name; });
            vm.rejectsPretty.series = [{
                    name: 'Count',
                    data: data.map(function (d) {
                        return {
                            y: d.rejectCount.count,
                            color: vm.rejectNameToColor[d.name],
                            events: {
                                click: function (event) {
                                    vm.equipmentSelected({
                                        category: this.category,
                                        y: this.y
                                    });
                                }
                            }
                        };
                    })
                }];
        };
        vm.setShift = function (shiftValue) {
            vm.shiftSelectors.buttons.forEach(function (s) {
                s.selected = (s.value === shiftValue);
            });
        };
        vm.selectShift = function (shift) {
            vm.interval = shift.value;
            vm.model.handleIntervalChange(shift.value);
            vm.renderChart();
        };
        vm.shiftSelectors.select = function (button) {
            vm.selectShift(button);
        };
        return vm;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=dashboard-r-g-w> <div ng-if=\"vm.showIfEmpty || (vm.rejectsPretty && vm.rejectsPretty.length)\"> <div> <high-chart options=vm.rejectsPretty id=rejectsChart style=display:block;width:100% /> </div> <div class=text-center> <btn-array options=vm.shiftSelectors id=rejectsButtons /> </div> </div> <div ng-if=\"!vm.showIfEmpty && vm.rejectsPretty && !vm.rejectsPretty.length\"> <div> No rejects for this Shop </div> </div> </div>");

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(535), __webpack_require__(536)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, btnarray_controller_1, btnarray_directive_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var btnArray = function () {
        return {
            restrict: 'E',
            template: btnarray_directive_tpl_html_1.default,
            replace: true,
            controller: 'btnArrayCtrl',
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                options: '='
            },
            link: function ($scope, el, attrs) {
                $scope.$watch('options', function (newVal) {
                }, true);
            }
        };
    };
    exports.default = angular.module('aps.directive.btnarray', [btnarray_controller_1.default])
        .directive('btnArray', btnArray)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var btnArrayCtrl = function ($scope) {
        var vm = {
            select: function (button) {
                if ($scope.vm.options.select !== null) {
                    $scope.vm.options.select(button);
                }
                $scope.vm.options.buttons.forEach(function (button) {
                    button.selected = false;
                });
                button.selected = true;
            },
            scope: $scope
        };
        return vm;
    };
    btnArrayCtrl.$inject = ["$scope"];
    exports.default = angular.module('aps.controller.btnArray', [])
        .controller('btnArrayCtrl', btnArrayCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <button ng-repeat=\"button in vm.options.buttons\" class=btn-array ng-class=\"{'default':button.selected,'secondary':!button.selected}\" ng-disabled=button.selected ng-click=vm.select(button)>{{button.name}}</button> </div>");

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(538), __webpack_require__(540), __webpack_require__(542), __webpack_require__(3), __webpack_require__(544), __webpack_require__(4), __webpack_require__(8), __webpack_require__(56), __webpack_require__(7), __webpack_require__(9), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, addCommodity_controller_1, updateCommodity_controller_1, updateCommodityPercentage_controller_1, constant_module_1, commodities_tpl_html_1, loader_service_1, navigation_service_1, commodities_service_1, authData_service_1, uiUtility_service_1, notify_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [addCommodity_controller_1.default, updateCommodity_controller_1.default, updateCommodityPercentage_controller_1.default, loader_service_1.default, notify_service_1.default, commodities_service_1.default,
        authData_service_1.default, uiUtility_service_1.default, navigation_service_1.default];
    var CommoditiesCtrl = (function () {
        CommoditiesCtrl.$inject = ["loaderService", "commoditiesService", "navigationService", "authDataService", "uiUtilityService", "notifyService", "$modal", "$q"];
        function CommoditiesCtrl(loaderService, commoditiesService, navigationService, authDataService, uiUtilityService, notifyService, $modal, $q) {
            var _this = this;
            this.loaderService = loaderService;
            this.navigationService = navigationService;
            this.commoditiesService = commoditiesService;
            this.uiUtilityService = uiUtilityService;
            this.notifyService = notifyService;
            this.$modal = $modal;
            this.$q = $q;
            var promise = this.navigationService.getNavigation().then(function (nav) {
                _this.plants = nav.plants();
                if (nav.selectedPlant && _.includes(_this.plants, nav.selectedPlant)) {
                    _this.selectedPlant = nav.selectedPlant;
                }
                else {
                    _this.selectedPlant = _.first(_this.plants);
                }
                return _this.plantChanged();
            });
            this.loaderService.loadingPromise(promise);
        }
        CommoditiesCtrl.prototype.loadCommodities = function () {
            var _this = this;
            return this.commoditiesService
                .get(this.selectedPlant.id)
                .then(function (commodities) {
                _this.commodities = commodities;
            });
        };
        CommoditiesCtrl.prototype.loadCommodityPercentages = function () {
            var _this = this;
            return this.commoditiesService
                .getCommodityPercentages(this.selectedPlant.id)
                .then(function (percentages) {
                _this.commoditypercentages = percentages;
            });
        };
        CommoditiesCtrl.prototype.getCommodityName = function (commodityId) {
            var commodity = this.commodities.filter(function (x) { return x.id == commodityId; });
            if (commodity)
                return commodity[0].name;
            return '';
        };
        CommoditiesCtrl.prototype.plantChanged = function () {
            var promises = [];
            promises.push(this.loadCommodities());
            promises.push(this.loadCommodityPercentages());
            this.loaderService.loadingPromise(this.$q.all(promises));
        };
        CommoditiesCtrl.prototype.add = function () {
            var _this = this;
            var result = addCommodity_controller_1.openAddCommodity({
                plant: this.selectedPlant,
                allCommodities: this.commodities
            }, this.$modal);
            result.then(function (instance) {
                if (!instance) {
                    return;
                }
                _this.commodities.push(instance);
            });
        };
        CommoditiesCtrl.prototype.edit = function (instance) {
            var _this = this;
            var result = updateCommodity_controller_1.openUpdateCommodity({
                instance: instance,
                allCommodities: this.commodities
            }, this.$modal);
            result.then(function (updated) {
                if (!updated) {
                    return;
                }
                _.remove(_this.commodities, instance);
                _this.commodities.push(updated);
            });
        };
        CommoditiesCtrl.prototype.editPercentage = function (instance) {
            var _this = this;
            var result = updateCommodityPercentage_controller_1.openUpdateCommodityPercentage({
                instance: instance,
                allCommodities: this.commodities
            }, this.$modal);
            result.then(function (updated) {
                if (!updated) {
                    return;
                }
                _.remove(_this.commoditypercentages, instance);
                _this.commoditypercentages.push(updated);
            });
        };
        CommoditiesCtrl.prototype.remove = function (instance) {
            var _this = this;
            this.uiUtilityService.confirm('Are you sure you want to delete this commodity?').then(function (confirmed) {
                if (!confirmed) {
                    return;
                }
                _this.loaderService.loadingPromise(_this.commoditiesService.remove({
                    id: instance.id,
                    plantId: _this.selectedPlant.id
                }).then(function () {
                    _.remove(_this.commodities, instance);
                }, _this.notifyService.handleApiErrors));
            });
        };
        CommoditiesCtrl.prototype.removePercentage = function (instance) {
            var _this = this;
            this.uiUtilityService.confirm('Are you sure you want to delete this commodity percentage?').then(function (confirmed) {
                if (!confirmed) {
                    return;
                }
                _this.loaderService.loadingPromise(_this.commoditiesService.removeCommodityPercentage({
                    id: instance.id,
                    plantId: _this.selectedPlant.id
                }).then(function () {
                    _.remove(_this.commoditypercentages, instance);
                }, _this.notifyService.handleApiErrors));
            });
        };
        return CommoditiesCtrl;
    }());
    exports.default = angular.module('aps.controller.commodities', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.COMMODITIES,
            url: '/admin/commodities',
            controller: 'CommoditiesCtrl as vm',
            template: commodities_tpl_html_1.default,
            data: {
                pageTitle: 'Commodities',
                authorizePlantAdmin: true
            }
        });
    }])
        .controller('CommoditiesCtrl', CommoditiesCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(56), __webpack_require__(6), __webpack_require__(4), __webpack_require__(12), __webpack_require__(539)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, commodities_service_1, notify_service_1, loader_service_1, newguid_service_1, addCommodity_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [commodities_service_1.default, notify_service_1.default, loader_service_1.default, newguid_service_1.default];
    function openAddCommodity(data, $modal) {
        return $modal.open({
            template: addCommodity_tpl_html_1.default,
            controller: 'AddCommodityCtrl as vm',
            resolve: {
                data: function () { return data; }
            }
        }).result;
    }
    exports.openAddCommodity = openAddCommodity;
    var AddCommodityCtrl = (function () {
        AddCommodityCtrl.$inject = ["data", "newGuidService", "commoditiesService", "$modalInstance", "notifyService", "loaderService"];
        function AddCommodityCtrl(data, newGuidService, commoditiesService, $modalInstance, notifyService, loaderService) {
            var _this = this;
            this.commoditiesService = commoditiesService;
            this.$modalInstance = $modalInstance;
            this.notifyService = notifyService;
            this.loaderService = loaderService;
            this.instance = {
                plantId: data.plant.id,
                plantName: data.plant.name
            };
            this.allCommodities = data.allCommodities;
            newGuidService.getNewGuid('Commodity').then(function (id) { return _this.instance.id = id; });
        }
        AddCommodityCtrl.prototype.add = function () {
            var _this = this;
            if (this.form.$invalid) {
                return;
            }
            var command = this.instance;
            this.loaderService.loadingPromise(this.commoditiesService.add(command)
                .then(function () {
                _this.$modalInstance.close(_this.instance);
            }, this.notifyService.handleApiErrors));
        };
        AddCommodityCtrl.prototype.cancel = function () {
            this.$modalInstance.close();
        };
        return AddCommodityCtrl;
    }());
    exports.default = angular.module('aps.controller.addCommodity', requires)
        .controller('AddCommodityCtrl', AddCommodityCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <h2 class=modal-header>Add Commodity</h2> <form name=vm.form ng-submit=vm.add() novalidate> <div class=container style=\"margin:0 -30px\"> <div class=row> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Name: <input name=name type=text maxlength=100 ng-model=vm.instance.name required/> </label> <div ng-messages=vm.form.name.$error ng-if=\"vm.form.name.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=maxlength class=req-w><div class=arrow-up></div>Must be 100 characters or less</div> </div> </div> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Code: <input name=materialCode type=text maxlength=4 ng-model=vm.instance.materialCode required/> </label> <div ng-messages=vm.form.materialCode.$error ng-if=\"vm.form.materialCode.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=maxlength class=req-w><div class=arrow-up></div>Must be 4 characters or less</div> </div> </div> </div> <div class=row> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Short Item: <input name=shortItem type=text maxlength=20 ng-model=vm.instance.shortItem required/> </label> <div ng-messages=vm.form.shortItem.$error ng-if=\"vm.form.shortItem.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=maxlength class=req-w><div class=arrow-up></div>Must be 20 characters or less</div> </div> </div> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Yield: <input name=yield type=number min=0.001 max=999999999999999.999 ng-model=vm.instance.yield required/> </label> <div ng-messages=vm.form.yield.$error ng-if=\"vm.form.yield.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be greater than 0</div> <div ng-message=max class=req-w><div class=arrow-up></div>Too large</div> </div> </div> </div> <div class=row> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Unit Cost: <input name=unitCost type=number min=0.001 max=999999999999999.999 ng-model=vm.instance.unitCost required/> </label> <div ng-messages=vm.form.unitCost.$error ng-if=\"vm.form.unitCost.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be greater than 0</div> <div ng-message=max class=req-w><div class=arrow-up></div>Too large</div> </div> </div> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Budgeted Unit Cost: <input name=budgetedUnitCost type=number min=0.001 max=999999999999999.999 ng-model=vm.instance.budgetedUnitCost required/> </label> <div ng-messages=vm.form.budgetedUnitCost.$error ng-if=\"vm.form.budgetedUnitCost.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be greater than 0</div> <div ng-message=max class=req-w><div class=arrow-up></div>Too large</div> </div> </div> </div> <div class=row> <div class=\"large-12 columns\"> <span class=required>* Required Fields</span> <div class=\"right dialog-footer\"> <button ng-click=vm.cancel() type=button class=\"button secondary\">Cancel</button> <button class=button type=submit>Add Commodity</button> </div> </div> </div> </div> </form> </div>");

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(56), __webpack_require__(6), __webpack_require__(4), __webpack_require__(12), __webpack_require__(541)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, commodities_service_1, notify_service_1, loader_service_1, newguid_service_1, updateCommodity_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [commodities_service_1.default, notify_service_1.default, loader_service_1.default, newguid_service_1.default];
    function openUpdateCommodity(data, $modal) {
        return $modal.open({
            template: updateCommodity_tpl_html_1.default,
            controller: 'UpdateCommodityCtrl as vm',
            resolve: {
                data: function () { return data; }
            }
        }).result;
    }
    exports.openUpdateCommodity = openUpdateCommodity;
    var UpdateCommodityCtrl = (function () {
        UpdateCommodityCtrl.$inject = ["$modalInstance", "commoditiesService", "data", "notifyService", "newGuidService", "loaderService"];
        function UpdateCommodityCtrl($modalInstance, commoditiesService, data, notifyService, newGuidService, loaderService) {
            var _this = this;
            this.$modalInstance = $modalInstance;
            this.commoditiesService = commoditiesService;
            this.notifyService = notifyService;
            this.loaderService = loaderService;
            this.instance = __assign({}, data.instance);
            this.loaderService.loadingPromise(newGuidService.getNewGuid('Commodity')
                .then(function (id) { return _this.newId = id; }));
        }
        UpdateCommodityCtrl.prototype.save = function () {
            var _this = this;
            if (this.form.$invalid) {
                return;
            }
            var command = __assign({}, this.instance, { newId: this.newId });
            this.loaderService.loadingPromise(this.commoditiesService.update(command)
                .then(function () {
                _this.$modalInstance.close(_this.instance);
            }, this.notifyService.handleApiErrors));
        };
        UpdateCommodityCtrl.prototype.cancel = function () {
            this.$modalInstance.close();
        };
        return UpdateCommodityCtrl;
    }());
    exports.default = angular.module('aps.controller.updateCommodity', requires)
        .controller('UpdateCommodityCtrl', UpdateCommodityCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <h2 class=modal-header>Update Commodity</h2> <form name=vm.form ng-submit=vm.save() novalidate> <div class=container style=\"margin:0 -30px\"> <div class=row> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Name: <input name=name type=text maxlength=100 ng-model=vm.instance.name required/> </label> <div ng-messages=vm.form.name.$error ng-if=\"vm.form.name.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=maxlength class=req-w><div class=arrow-up></div>Must be 100 characters or less</div> </div> </div> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Code: <input name=materialCode type=text maxlength=4 ng-model=vm.instance.materialCode required/> </label> <div ng-messages=vm.form.materialCode.$error ng-if=\"vm.form.materialCode.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=maxlength class=req-w><div class=arrow-up></div>Must be 4 characters or less</div> </div> </div> </div> <div class=row> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Short Item: <input name=shortItem type=text maxlength=20 ng-model=vm.instance.shortItem required/> </label> <div ng-messages=vm.form.shortItem.$error ng-if=\"vm.form.shortItem.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=maxlength class=req-w><div class=arrow-up></div>Must be 20 characters or less</div> </div> </div> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Yield: <input name=yield type=number min=0.001 max=999999999999999.999 ng-model=vm.instance.yield required/> </label> <div ng-messages=vm.form.yield.$error ng-if=\"vm.form.yield.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be greater than 0</div> <div ng-message=max class=req-w><div class=arrow-up></div>Too large</div> </div> </div> </div> <div class=row> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Unit Cost: <input name=unitCost type=number min=0.001 max=999999999999999.999 ng-model=vm.instance.unitCost required/> </label> <div ng-messages=vm.form.unitCost.$error ng-if=\"vm.form.unitCost.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be greater than 0</div> <div ng-message=max class=req-w><div class=arrow-up></div>Too large</div> </div> </div> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Budgeted Unit Cost: <input name=budgetedUnitCost type=number min=0.001 max=999999999999999.999 ng-model=vm.instance.budgetedUnitCost required/> </label> <div ng-messages=vm.form.budgetedUnitCost.$error ng-if=\"vm.form.budgetedUnitCost.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be greater than 0</div> <div ng-message=max class=req-w><div class=arrow-up></div>Too large</div> </div> </div> </div> <div class=row> <div class=\"large-12 columns\"> <span class=required>* Required Fields</span> <div class=\"right dialog-footer\"> <button ng-click=vm.cancel() type=button class=\"button secondary\">Cancel</button> <button class=button type=submit>Save Commodity</button> </div> </div> </div> </div> </form> </div>");

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(56), __webpack_require__(6), __webpack_require__(4), __webpack_require__(12), __webpack_require__(543)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, commodities_service_1, notify_service_1, loader_service_1, newguid_service_1, updateCommodityPercentage_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [commodities_service_1.default, notify_service_1.default, loader_service_1.default, newguid_service_1.default];
    function openUpdateCommodityPercentage(data, $modal) {
        return $modal.open({
            template: updateCommodityPercentage_tpl_html_1.default,
            controller: 'UpdateCommodityPrcntCtrl as vm',
            resolve: {
                data: function () { return data; }
            }
        }).result;
    }
    exports.openUpdateCommodityPercentage = openUpdateCommodityPercentage;
    var UpdateCommodityPrcntCtrl = (function () {
        UpdateCommodityPrcntCtrl.$inject = ["$modalInstance", "commoditiesService", "data", "notifyService", "loaderService"];
        function UpdateCommodityPrcntCtrl($modalInstance, commoditiesService, data, notifyService, loaderService) {
            var _this = this;
            this.$modalInstance = $modalInstance;
            this.commoditiesService = commoditiesService;
            this.notifyService = notifyService;
            this.loaderService = loaderService;
            this.allCommodities = __assign({}, data.allCommodities);
            this.instance = __assign({}, data.instance);
            this.commodityName = _.find(this.allCommodities, function (x) { return x.id === _this.instance.commodityId; }).name;
            this.primaryCommodity = _.find(this.allCommodities, function (x) { return x.id === _this.instance.primaryCommodityId; });
            this.secondaryCommodity = _.find(this.allCommodities, function (x) { return x.id === _this.instance.secondaryCommodityId; });
        }
        UpdateCommodityPrcntCtrl.prototype.save = function () {
            var _this = this;
            if (this.form.$invalid) {
                return;
            }
            if (this.primaryCommodity.id === this.secondaryCommodity.id) {
                this.notifyService.error('Primary Commodity and Secondary Commodity cannot be the same');
                return;
            }
            if (this.instance.primaryPercentage + this.instance.secondaryPercentage != 100) {
                this.notifyService.error('Percentages of Primary and Secondary should be equal to 100');
                return;
            }
            var command = __assign({}, this.instance);
            command.primaryCommodityId = this.primaryCommodity.id;
            command.secondaryCommodityId = this.secondaryCommodity.id;
            this.loaderService.loadingPromise(this.commoditiesService.updateCommodityPercentage(command)
                .then(function () {
                _this.instance.primaryCommodityId = _this.primaryCommodity.id;
                _this.instance.secondaryCommodityId = _this.secondaryCommodity.id;
                _this.$modalInstance.close(_this.instance);
            }, this.notifyService.handleApiErrors));
        };
        UpdateCommodityPrcntCtrl.prototype.cancel = function () {
            this.$modalInstance.close();
        };
        return UpdateCommodityPrcntCtrl;
    }());
    exports.default = angular.module('aps.controller.updateCommodityPercentage', requires)
        .controller('UpdateCommodityPrcntCtrl', UpdateCommodityPrcntCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <h2 class=modal-header>Update Commodity Percentage</h2> <form name=vm.form ng-submit=vm.save() novalidate> <div class=container style=\"margin:0 -30px\"> <div class=row> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>CommodityName: <input name=name type=text maxlength=100 ng-model=vm.commodityName required disabled=disabled /> </label> <div ng-messages=vm.form.name.$error ng-if=\"vm.form.name.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Tank: <input name=tankName type=text maxlength=4 ng-model=vm.instance.tankName required disabled=disabled /> </label> <div ng-messages=vm.form.tankName.$error ng-if=\"vm.form.tankName.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> </div> <div class=row> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>PrimaryCommodity: <select ng-model=vm.primaryCommodity ng-options=\"commodity.name for commodity in vm.allCommodities\"> </select> </label> <div ng-messages=vm.form.primaryCommodityId.$error ng-if=\"vm.form.primaryCommodityId.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>PrimaryPercent: <input name=primaryPercentage type=number min=0.1 max=100 ng-model=vm.instance.primaryPercentage required/> </label> <div ng-messages=vm.form.primaryPercentage.$error ng-if=\"vm.form.primaryPercentage.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be greater than 0</div> <div ng-message=max class=req-w><div class=arrow-up></div>Too large</div> </div> </div> </div> <div class=row> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>SecondaryCommodity: <select ng-model=vm.secondaryCommodity ng-options=\"commodity.name for commodity in vm.allCommodities\" disabled=disabled> </select> </label> <div ng-messages=vm.form.secondaryCommodityId.$error ng-if=\"vm.form.secondaryCommodityId.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>SecondaryPercent: <input name=secondaryPercentage type=number min=0.1 max=100 ng-model=vm.instance.secondaryPercentage required/> </label> <div ng-messages=vm.form.secondaryPercentage.$error ng-if=\"vm.form.secondaryPercentage.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be greater than 0</div> <div ng-message=max class=req-w><div class=arrow-up></div>Too large</div> </div> </div> </div> <div class=row> <div class=\"large-12 columns\"> <span class=required>* Required Fields</span> <div class=\"right dialog-footer\"> <button ng-click=vm.cancel() type=button class=\"button secondary\">Cancel</button> <button class=button type=submit>Save</button> </div> </div> </div> </div> </form> </div>");

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <div class=body-header><h2>Commodities</h2></div> <div class=container> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-5 columns\"> <label> <span class=\"required notated\">*</span>Plant: <select ng-model=vm.selectedPlant ng-options=\"plant.name for plant in vm.plants\" ng-change=vm.plantChanged()> </select> </label> </div> <div class=\"small-2 columns\"> <button ng-click=vm.add() class=\"button small\" style=position:relative;top:14px>Add Commodity</button> </div> </div> <div ng-if=\"vm.commodities && vm.commodities.length === 0\" style=width:100%;clear:both;float:left;margin-top:30px> Currently there are no Commodities for this Plant </div> <table cellpadding=1 cellspacing=1 ng-if=\"vm.commodities && vm.commodities.length > 0\" class=history-t> <tr> <th>Name</th> <th>Code</th> <th>Yield</th> <th>Unit Cost</th> <th>Budgeted Unit Cost</th> <th>Short Item</th> <th></th> <th></th> </tr> <tr ng-repeat=\"item in vm.commodities | orderBy: 'name'\"> <td ng-bind=item.name></td> <td ng-bind=item.materialCode></td> <td ng-bind=item.yield></td> <td ng-bind=item.unitCost></td> <td ng-bind=item.budgetedUnitCost></td> <td ng-bind=item.shortItem></td> <td><button ng-click=vm.edit(item) class=\"button tiny\" style=margin:0>Edit</button></td> <td><button ng-click=vm.remove(item) class=\"button tiny alert\" style=margin:0>Delete</button></td> </tr> </table> <div ng-if=\"vm.commoditypercentages && vm.commoditypercentages.length > 0\"> <hr style=\"border-top:dotted 2px\"/> <table cellpadding=1 cellspacing=1 class=history-t> <tr> <th>Name</th> <th>Tank</th> <th>PrimaryCommodity</th> <th>PrimaryPercent</th> <th>SecondayCommodity</th> <th>SecondaryPercent</th> <th></th> <th></th> </tr> <tr ng-repeat=\"item in vm.commoditypercentages | orderBy: 'tankName'\"> <td>{{vm.getCommodityName(item.commodityId)}}</td> <td class=centerAlign>{{item.tankName}}</td> <td class=centerAlign>{{vm.getCommodityName(item.primaryCommodityId)}}</td> <td class=centerAlign>{{item.primaryPercentage}}%</td> <td class=centerAlign>{{vm.getCommodityName(item.secondaryCommodityId)}}</td> <td class=centerAlign>{{item.secondaryPercentage}}%</td> <td><button ng-click=vm.editPercentage(item) class=\"button tiny\" style=margin:0>Edit</button></td> <td><button ng-click=vm.removePercentage(item) class=\"button tiny alert\" style=margin:0>Delete</button></td> </tr> </table> </div> </div> </div>");

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(2), __webpack_require__(546), __webpack_require__(3), __webpack_require__(548), __webpack_require__(4), __webpack_require__(8), __webpack_require__(293), __webpack_require__(7), __webpack_require__(9), __webpack_require__(6), __webpack_require__(79), __webpack_require__(56)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, moment, _, addBatchSummary_controller_1, constant_module_1, batchSummary_tpl_html_1, loader_service_1, navigation_service_1, batchSummary_service_1, authData_service_1, uiUtility_service_1, notify_service_1, job_service_1, commodities_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [addBatchSummary_controller_1.default, , loader_service_1.default, notify_service_1.default, batchSummary_service_1.default,
        authData_service_1.default, uiUtility_service_1.default, navigation_service_1.default, job_service_1.default, commodities_service_1.default];
    var BatchSummaryCtrl = (function () {
        BatchSummaryCtrl.$inject = ["loaderService", "batchSummaryService", "jobService", "$q", "navigationService", "authDataService", "uiUtilityService", "notifyService", "$modal", "holidaysService"];
        function BatchSummaryCtrl(loaderService, batchSummaryService, jobService, $q, navigationService, authDataService, uiUtilityService, notifyService, $modal, holidaysService) {
            var _this = this;
            this.loaderService = loaderService;
            this.batchSummaryService = batchSummaryService;
            this.uiUtilityService = uiUtilityService;
            this.notifyService = notifyService;
            var holidayService = holidaysService;
            this.$modal = $modal;
            this.$q = $q;
            this.productionDate = moment().add(-1, 'days').toDate();
            this.maxDate = moment().format(constant_module_1.Strings.ISO_DATE_FORMAT);
            var promises = [];
            promises.push(navigationService.getNavigation().then(function (nav) {
                var plants = nav.plants();
                _this.plants = plants;
                if (nav.selectedPlant && _.includes(_this.plants, nav.selectedPlant)) {
                    _this.selectedPlant = nav.selectedPlant;
                }
                else {
                    _this.selectedPlant = _.first(_this.plants);
                }
                return _this.plantChanged();
            }));
            promises.push(holidayService.getHolidays(moment().year())
                .then(function (h) {
                _this.holidays = h;
                _this.canEdit = _this.canBatchBeEdited();
            }));
            this.loaderService.loadingPromise(this.$q.all(promises));
        }
        BatchSummaryCtrl.prototype.plantChangedPrivate = function () {
            this.tanks = this.selectedPlant.tanks;
            this.selectedTank = _.first(this.tanks);
            var promises = [];
            return this.$q.all(promises);
        };
        BatchSummaryCtrl.prototype.loadBatchSummary = function () {
            var _this = this;
            var promises = [];
            this.currentselectedPlant = this.selectedPlant;
            this.currentselectedTank = this.selectedTank;
            this.formattedReportDate = moment(this.productionDate).format("MM/DD/YYYY");
            this.batchSummary = [];
            if (this.selectedPlant && this.selectedTank && this.productionDate)
                promises.push(this.batchSummaryService
                    .get(this.selectedPlant.id, this.selectedTank.id, moment(this.productionDate).format(constant_module_1.Strings.ISO_DATE_FORMAT))
                    .then(function (batchSummary) {
                    _this.batchSummary = batchSummary;
                }));
            return this.$q.all(promises);
        };
        BatchSummaryCtrl.prototype.plantChanged = function () {
            this.loaderService.loadingPromise(this.plantChangedPrivate());
        };
        BatchSummaryCtrl.prototype.filterChanged = function () {
            this.loaderService.loadingPromise(this.loadBatchSummary());
            this.canEdit = this.canBatchBeEdited();
        };
        BatchSummaryCtrl.prototype.dateChanged = function () {
            this.canEdit = this.canBatchBeEdited();
        };
        BatchSummaryCtrl.prototype.getmeltedTons = function () {
            var meltedtons = 0;
            this.batchSummary.filter(function (x) { return x.isChild == false && x.binName !== 'Batch'; }).forEach(function (a) { return meltedtons += a.tons; });
            this.batchData = this.batchSummary.filter(function (x) { return x.binName === 'Batch'; })[0];
            return Math.round(meltedtons * 100.0) / 100.0;
        };
        BatchSummaryCtrl.prototype.add = function () {
            var _this = this;
            this.batchSummaryService
                .getBinSummaryInfo(this.selectedPlant.id, this.selectedTank.id, moment(this.productionDate).format(constant_module_1.Strings.ISO_DATE_FORMAT))
                .then(function (batchSummaryInfo) {
                var result = addBatchSummary_controller_1.openAddBatchSummary({
                    plant: _this.selectedPlant,
                    tank: _this.selectedTank,
                    productionDate: _this.productionDate,
                    batchSummaryInfo: batchSummaryInfo.map(function (bi) { bi.pounds = (bi.pounds ? bi.pounds : null); return bi; }),
                }, _this.$modal);
                result.then(function (added) {
                    if (!added) {
                        return;
                    }
                    _this.loaderService.loadingPromise(_this.loadBatchSummary());
                });
            });
        };
        BatchSummaryCtrl.prototype.edit = function (instance) {
            var _this = this;
            this.batchSummaryService.getDetail(instance.id)
                .then(function (detail) {
                var result = addBatchSummary_controller_1.openAddBatchSummary({
                    plant: _this.selectedPlant,
                    tank: _this.selectedTank,
                    productionDate: _this.productionDate,
                    batchSummaryInfo: [detail],
                }, _this.$modal);
                result.then(function (updated) {
                    if (!updated) {
                        return;
                    }
                    _this.loaderService.loadingPromise(_this.loadBatchSummary());
                });
            });
        };
        BatchSummaryCtrl.prototype.remove = function (instance) {
            var _this = this;
            this.uiUtilityService.confirm('Are you sure you want to delete this Summary Item?').then(function (confirmed) {
                if (!confirmed) {
                    return;
                }
                _this.loaderService.loadingPromise(_this.batchSummaryService.remove({
                    id: instance.id
                }).then(function () {
                    _this.loaderService.loadingPromise(_this.loadBatchSummary());
                }, _this.notifyService.handleApiErrors));
            });
        };
        BatchSummaryCtrl.prototype.createCountSummary = function (summaries, plant, tank) {
            var report = [];
            summaries.forEach(function (item) {
                var reportItem = {
                    plantName: plant,
                    tankName: tank,
                    commodityName: item.commodityName,
                    binName: item.binName,
                    pounds: item.pounds,
                    tons: item.tons,
                    productionDate: item.productionDate
                };
                report.push(reportItem);
            });
            return report;
        };
        BatchSummaryCtrl.prototype.exportToCsv = function () {
            var _this = this;
            var titles = [];
            titles.push("Plant", "Tank", "CommodityName", "BinName", "Pounds", "GlassTons");
            var result = [];
            result.push(titles);
            if (this.currentselectedPlant && this.currentselectedTank && this.productionDate)
                return this.batchSummaryService
                    .get(this.selectedPlant.id, this.selectedTank.id, moment(this.productionDate).format(constant_module_1.Strings.ISO_DATE_FORMAT))
                    .then(function (batchSummary) {
                    var exportReport = _this.createCountSummary(batchSummary, _this.currentselectedPlant.name, _this.currentselectedTank.name);
                    exportReport.forEach(function (x) {
                        result.push({
                            plant: x.plantName,
                            tank: x.tankName,
                            commodityName: x.commodityName,
                            binName: x.binName,
                            pounds: x.pounds,
                            glassTons: x.tons
                        });
                    });
                    return result;
                });
        };
        BatchSummaryCtrl.prototype.canBatchBeEdited = function () {
            var today = new Date();
            var currentDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            if (!this.productionDate || this.productionDate > currentDate) {
                return false;
            }
            var firBusMonth = this.productionDate.getMonth() === 11 ? 0 : this.productionDate.getMonth() + 1;
            var firstBusDay = this.firstBusinessDay(firBusMonth);
            return (today.getMonth() >= this.productionDate.getMonth() || (today.getMonth() < this.productionDate.getMonth() && today.getFullYear() > this.productionDate.getFullYear())) && currentDate <= firstBusDay;
        };
        BatchSummaryCtrl.prototype.firstBusinessDay = function (month) {
            var first = moment().month(month).startOf('month');
            while (((first.day() % 7)) === 0 || (first.day() % 7) === 6) {
                first = first.add(1, 'd');
            }
            if (this.holidays.filter(function (h) { return h.date.getTime() === first.toDate().getTime(); }).length === 1) {
                first = first.add(1, 'd');
            }
            return first.toDate();
        };
        return BatchSummaryCtrl;
    }());
    exports.default = angular.module('aps.controller.batchSummary', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.BATCH_SUMMARY,
            url: '/admin/batchSummary',
            controller: 'BatchSummaryCtrl as vm',
            template: batchSummary_tpl_html_1.default,
            data: {
                pageTitle: 'Batch Summary',
                authorizePlantAdmin: true,
                v2Uri: 'aps/settings/batch-summary'
            }
        });
    }])
        .controller('BatchSummaryCtrl', BatchSummaryCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(293), __webpack_require__(6), __webpack_require__(4), __webpack_require__(12), __webpack_require__(547)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, batchSummary_service_1, notify_service_1, loader_service_1, newguid_service_1, addBatchSummary_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [batchSummary_service_1.default, notify_service_1.default, loader_service_1.default, newguid_service_1.default];
    function openAddBatchSummary(data, $modal) {
        return $modal.open({
            template: addBatchSummary_tpl_html_1.default,
            controller: 'AddBatchSummaryCtrl as vm',
            resolve: {
                data: function () { return data; }
            }
        }).result;
    }
    exports.openAddBatchSummary = openAddBatchSummary;
    var AddBatchSummaryCtrl = (function () {
        AddBatchSummaryCtrl.$inject = ["data", "newGuidService", "batchSummaryService", "$modalInstance", "notifyService", "loaderService"];
        function AddBatchSummaryCtrl(data, newGuidService, batchSummaryService, $modalInstance, notifyService, loaderService) {
            this.batchSummaryService = batchSummaryService;
            this.$modalInstance = $modalInstance;
            this.notifyService = notifyService;
            this.loaderService = loaderService;
            this.newGuidService = newGuidService;
            this.plant = data.plant;
            this.tank = data.tank;
            this.batchSummaryInfo = data.batchSummaryInfo;
            this.setBatchRow = this.batchSummaryInfo.filter(function (x) { return x.binName.toLowerCase() == 'batch'; })[0] !== undefined ? true : false;
        }
        AddBatchSummaryCtrl.prototype.checkRecordExist = function () {
            var batchRecords = this.batchSummaryInfo.filter(function (x) { return x.binName.toLowerCase() != 'batch'; });
            return batchRecords.length > 0;
        };
        AddBatchSummaryCtrl.prototype.add = function () {
            var _this = this;
            if (this.form.$invalid) {
                return;
            }
            if (this.batchSummaryInfo.length == 1 && this.batchSummaryInfo[0].id) {
                var command = this.batchSummaryInfo.map(function (bi) { return bi; })[0];
                this.loaderService.loadingPromise(this.batchSummaryService.update(command, this.tank.id)
                    .then(function (summary) {
                    _this.$modalInstance.close([summary]);
                }, this.notifyService.handleApiErrors));
            }
            else {
                var command = this.batchSummaryInfo.map(function (bi) { return bi; });
                this.loaderService.loadingPromise(this.batchSummaryService.add(command, this.tank.id)
                    .then(function (summary) {
                    _this.$modalInstance.close(summary);
                }, this.notifyService.handleApiErrors));
            }
        };
        AddBatchSummaryCtrl.prototype.cancel = function () {
            this.$modalInstance.close();
        };
        return AddBatchSummaryCtrl;
    }());
    exports.default = angular.module('aps.controller.addBatchSummary', requires)
        .controller('AddBatchSummaryCtrl', AddBatchSummaryCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <h2 class=modal-header>Add Batch Summary</h2> <form name=vm.form ng-submit=vm.add() novalidate> <div class=container style=\"margin:0 -30px\"> <div class=row> <div class=\"large-5 columns\"> <label>Plant: {{vm.plant.name}} </label> </div> <div class=\"large-6 columns\"> <label> Tank: {{vm.tank.name}} </label> </div> </div> <div class=row ng-repeat=\"item in vm.batchSummaryInfo track by $index\"> <div ng-if=\"item.binName !== 'Batch'\"> <div class=\"large-5 columns\"> <label> Commodity: {{item.commodityName}} </label> </div> <div class=\"large-5 columns\"> <label> Bin: {{item.binName}} </label> </div> <div class=\"large-2 columns\"> <div> <label style=margin-top:-10%><span class=\"required notated\">*</span> Pounds <input name=\"pounds{{$index}}\" type=number min=0 max=99999999.999 ng-model=item.pounds required/> </label> </div> <div ng-messages=\"vm.form['pounds' + $index].$error\" ng-if=\"vm.form['pounds' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=min class=req-w> <div class=arrow-up></div>Must be greater than 0 </div> <div ng-message=max class=req-w> <div class=arrow-up></div>Too large </div> </div> </div> </div> </div> <div class=row ng-if=vm.checkRecordExist()> <hr style=\"border-top:dotted 2px\"/> </div> <div ng-if=vm.setBatchRow class=row ng-repeat=\"item in vm.batchSummaryInfo track by $index\"> <div ng-if=\"item.binName === 'Batch'\"> <div ng-if=\"item.binName !== 'Batch'\" class=\"large-5 columns\"> <label> Commodity: {{item.commodityName}} </label> </div> <div class=\"large-5 columns\"> <label> Bin: {{item.binName}} </label> </div> <div class=\"large-2 columns\"> <div> <label style=margin-top:-10%><span class=\"required notated\">*</span> Count <input name=\"pounds{{$index}}\" type=number min=0 max=99999999.999 ng-model=item.pounds required/> </label> </div> <div ng-messages=\"vm.form['pounds' + $index].$error\" ng-if=\"vm.form['pounds' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=min class=req-w> <div class=arrow-up></div>Must be greater than 0 </div> <div ng-message=max class=req-w> <div class=arrow-up></div>Too large </div> </div> </div> </div> </div> <div class=row> <div class=\"large-12 columns\"> <span class=required>* Required Fields</span> <div class=\"right dialog-footer\"> <button ng-click=vm.cancel() type=button class=\"button secondary\">Cancel</button> <button ng-disabled=!vm.batchSummaryInfo.length class=button type=submit>{{ (vm.batchSummaryInfo.length == 1 && vm.batchSummaryInfo[0].id) ? \"Save Summary Item\" :\"Add Batch Summary\"}}</button> </div> </div> </div> </div> </form> </div>");

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <div class=body-header> <h2>Batch Summary</h2> </div> <div class=container> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-4 columns\"> <label> <span class=\"required notated\">*</span>Plant: <select ng-model=vm.selectedPlant ng-options=\"plant.name for plant in vm.plants\" ng-change=vm.plantChanged()> </select> </label> </div> <div class=\"small-2 columns\"> <label> <span class=\"required notated\">*</span>Tank: <select ng-model=vm.selectedTank ng-options=\"tank.name for tank in vm.tanks\"> </select> </label> </div> <div class=\"small-2 columns\"> <label> <span class=\"required notated\">*</span>Date: <input type=date name=productionDate ng-model=vm.productionDate required max=\"{{vm.maxDate}}\" ng-change=vm.dateChanged() /> <div ng-messages=vm.form.date.$error ng-if=\"vm.form.date.$dirty || vm.form.$submitted\"> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=max class=req-w> <div class=arrow-up></div>Must not be greater than today </div> </div> </label> </div> <div class=\"small-2 columns\"> <button ng-click=vm.filterChanged() class=\"button small\" style=position:relative;top:14px>Get Summary</button> </div> <div class=\"small-2 columns\"> <button ng-click=vm.add() ng-disabled=!vm.canEdit class=\"button small\" style=position:relative;top:14px>Add Summary</button> </div> </div> <div ng-if=\"vm.batchSummary && vm.batchSummary.length === 0\" style=\"margin:0 -250px 0 250px;width:100%;width:100%;clear:both;float:left;margin-top:30px\"> <b>Currently there are no Batch Summary Data for selected criteria </b> </div> <div ng-if=\"vm.batchSummary && vm.batchSummary.length > 0\" style=\"margin:0 -250px 0 250px;width:100%;clear:both;float:none;margin-top:30px\"> <b>Batch Summary Report - {{vm.currentselectedPlant.name}} Tank-{{vm.currentselectedTank.name}}, {{vm.formattedReportDate}}</b> </div> <div class=right ng-if=\"vm.batchSummary && vm.batchSummary.length > 0\"> <a ng-csv=vm.exportToCsv() filename=\"BatchSummary-{{vm.currentselectedPlant.name}}Tank-{{vm.currentselectedTank.name}}.csv\">Save as CSV</a> </div> <table cellpadding=1 cellspacing=1 ng-if=\"vm.batchSummary && vm.batchSummary.length > 0\" class=history-t> <tr> <th>Commodity Name</th> <th>Bin Name</th> <th>Pounds</th> <th>Glass Tons</th> <th></th> <th></th> </tr> <tr ng-repeat=\"item in vm.batchSummary | filter: {binName: '!' + 'Batch'}\"> <td ng-if=\"item.isChild === false\" ng-bind=item.commodityName></td> <td ng-if=\"item.isChild === true\" ng-bind=item.commodityName style=text-align:center></td> <td ng-if=\"item.isChild === false\" ng-bind=item.binName></td> <td ng-if=\"item.isChild === true\"></td> <td ng-bind=\"item.pounds | number\"></td> <td ng-bind=item.tons></td> <td ng-if=\"item.isChild === false\"><button ng-disabled=!vm.canEdit ng-click=vm.edit(item) class=\"button tiny\" style=margin:0>Edit</button></td> <td ng-if=\"item.isChild === true\"></td> <td ng-if=\"item.isChild === false\"><button ng-disabled=!vm.canEdit ng-click=vm.remove(item) class=\"button tiny alert\" style=margin:0>Delete</button></td> <td ng-if=\"item.isChild === true\"></td> </tr> </table> <div ng-if=\"vm.batchSummary && vm.batchSummary.length > 0 && vm.batchData !== undefined\"> <hr style=\"border-top:dotted 2px\"/> <table cellpadding=1 cellspacing=1 class=history-t> <tr> <th>Batch</th> <th></th> <th><span style=margin:0;margin-left:25%></span>Total No Of Batches</th> <th></th> <th></th> <th></th> </tr> <tr ng-repeat=\"item in vm.batchSummary | filter: {binName: 'Batch'}\"> <td>{{item.binName}}</td> <td></td> <td><span style=margin:0;margin-left:35%></span> {{item.pounds}}</td> <td></td> <td width=-250px><button ng-disabled=!vm.canEdit ng-click=vm.edit(item) class=\"button tiny\" style=margin:0;margin-left:70%>Edit</button></td> <td width=-250px><button ng-disabled=!vm.canEdit ng-click=vm.remove(item) class=\"button tiny alert\" style=margin:0;margin-left:32%>Delete</button></td> </tr> </table> </div> <div ng-if=\"vm.batchSummary && vm.batchSummary.length > 0\" style=width:100%;clear:both;float:none;margin-top:30px> <hr> </div> <div ng-if=\"vm.batchSummary && vm.batchSummary.length > 0\" style=\"margin:0 -400px 0 480px;width:100%;clear:both;float:none;margin-top:30px\"> <b>Total Melted Tons - {{vm.getmeltedTons()}}</b> </div> </div> </div>");

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(550), __webpack_require__(552), __webpack_require__(3), __webpack_require__(554), __webpack_require__(4), __webpack_require__(8), __webpack_require__(63), __webpack_require__(7), __webpack_require__(9), __webpack_require__(6), __webpack_require__(79), __webpack_require__(56)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, addBatchFormula_controller_1, updateBatchFormula_controller_1, constant_module_1, batchFormulas_tpl_html_1, loader_service_1, navigation_service_1, batchFormulas_service_1, authData_service_1, uiUtility_service_1, notify_service_1, job_service_1, commodities_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [addBatchFormula_controller_1.default, updateBatchFormula_controller_1.default, loader_service_1.default, notify_service_1.default, batchFormulas_service_1.default,
        authData_service_1.default, uiUtility_service_1.default, navigation_service_1.default, job_service_1.default, commodities_service_1.default];
    var BatchFormulasCtrl = (function () {
        BatchFormulasCtrl.$inject = ["loaderService", "batchFormulasService", "commoditiesService", "jobService", "$q", "navigationService", "authDataService", "uiUtilityService", "notifyService", "$modal"];
        function BatchFormulasCtrl(loaderService, batchFormulasService, commoditiesService, jobService, $q, navigationService, authDataService, uiUtilityService, notifyService, $modal) {
            var _this = this;
            this.loaderService = loaderService;
            this.batchFormulasService = batchFormulasService;
            this.commoditiesService = commoditiesService;
            this.uiUtilityService = uiUtilityService;
            this.notifyService = notifyService;
            this.$modal = $modal;
            this.$q = $q;
            var promises = [];
            promises.push(navigationService.getNavigation().then(function (nav) {
                var plants = nav.plants();
                _this.plants = _.filter(plants, function (plant) {
                    return authDataService.isAPSIOAdminForPlant(plant.id);
                });
                if (nav.selectedPlant && _.includes(_this.plants, nav.selectedPlant)) {
                    _this.selectedPlant = nav.selectedPlant;
                }
                else {
                    _this.selectedPlant = _.first(_this.plants);
                }
                return _this.loadBatchFormulas();
            }));
            promises.push(jobService.getGlassColors().then(function (colors) { return _this.glassColors = colors; }));
            this.loaderService.loadingPromise(this.$q.all(promises));
        }
        BatchFormulasCtrl.prototype.loadBatchFormulas = function () {
            var _this = this;
            var promises = [];
            promises.push(this.batchFormulasService
                .get(this.selectedPlant.id)
                .then(function (batchFormulas) { return _this.batchFormulas = batchFormulas; }));
            promises.push(this.commoditiesService
                .get(this.selectedPlant.id)
                .then(function (commodities) { return _this.commodities = commodities; }));
            return this.$q.all(promises);
        };
        BatchFormulasCtrl.prototype.plantChanged = function () {
            this.loaderService.loadingPromise(this.loadBatchFormulas());
        };
        BatchFormulasCtrl.prototype.add = function () {
            var _this = this;
            var result = addBatchFormula_controller_1.openAddBatchFormula({
                plant: this.selectedPlant,
                allBatchFormulas: this.batchFormulas,
                commodities: this.commodities,
                glassColors: this.glassColors
            }, this.$modal);
            result.then(function (instance) {
                if (!instance) {
                    return;
                }
                _this.batchFormulas.push(instance);
            });
        };
        BatchFormulasCtrl.prototype.edit = function (instance) {
            var _this = this;
            this.batchFormulasService.getDetail(instance.plantId, instance.id)
                .then(function (detail) {
                var result = updateBatchFormula_controller_1.openUpdateBatchFormula({
                    instance: detail,
                    allBatchFormulas: _this.batchFormulas,
                    commodities: _this.commodities,
                    glassColors: _this.glassColors
                }, _this.$modal);
                result.then(function (updated) {
                    if (!updated) {
                        return;
                    }
                    _.remove(_this.batchFormulas, instance);
                    _this.batchFormulas.push(updated);
                });
            });
        };
        BatchFormulasCtrl.prototype.remove = function (instance) {
            var _this = this;
            this.uiUtilityService.confirm('Are you sure you want to delete this Formula?').then(function (confirmed) {
                if (!confirmed) {
                    return;
                }
                _this.loaderService.loadingPromise(_this.batchFormulasService.remove({
                    id: instance.id,
                    plantId: _this.selectedPlant.id
                }).then(function () {
                    _.remove(_this.batchFormulas, instance);
                }, _this.notifyService.handleApiErrors));
            });
        };
        return BatchFormulasCtrl;
    }());
    exports.default = angular.module('aps.controller.batchFormulas', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.BATCH_FORMULAS,
            url: '/admin/batchFormulas',
            controller: 'BatchFormulasCtrl as vm',
            template: batchFormulas_tpl_html_1.default,
            data: {
                pageTitle: 'Batch Formulas',
                authorizeAPSIOAdmin: true
            }
        });
    }])
        .controller('BatchFormulasCtrl', BatchFormulasCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(63), __webpack_require__(6), __webpack_require__(4), __webpack_require__(12), __webpack_require__(551)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, batchFormulas_service_1, notify_service_1, loader_service_1, newguid_service_1, addBatchFormula_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [batchFormulas_service_1.default, notify_service_1.default, loader_service_1.default, newguid_service_1.default];
    function openAddBatchFormula(data, $modal) {
        return $modal.open({
            template: addBatchFormula_tpl_html_1.default,
            controller: 'AddBatchFormulaCtrl as vm',
            resolve: {
                data: function () { return data; }
            }
        }).result;
    }
    exports.openAddBatchFormula = openAddBatchFormula;
    var AddBatchFormulaCtrl = (function () {
        AddBatchFormulaCtrl.$inject = ["data", "newGuidService", "batchFormulasService", "$modalInstance", "notifyService", "loaderService"];
        function AddBatchFormulaCtrl(data, newGuidService, batchFormulasService, $modalInstance, notifyService, loaderService) {
            var _this = this;
            this.batchFormulasService = batchFormulasService;
            this.$modalInstance = $modalInstance;
            this.notifyService = notifyService;
            this.loaderService = loaderService;
            this.newGuidService = newGuidService;
            this.instance = {
                plantId: data.plant.id,
                plantName: data.plant.name,
                material: []
            };
            this.allBatchFormulas = data.allBatchFormulas;
            this.commodities = data.commodities;
            this.glassColors = data.glassColors;
            this.newGuidService.getNewGuid('BatchFormula').then(function (id) { return _this.instance.id = id; });
        }
        AddBatchFormulaCtrl.prototype.add = function () {
            var _this = this;
            if (this.form.$invalid) {
                return;
            }
            var command = this.instance;
            this.loaderService.loadingPromise(this.batchFormulasService.add(command)
                .then(function () {
                _this.instance.colorName = _.find(_this.glassColors, { id: _this.instance.colorId }).name;
                _this.$modalInstance.close(_this.instance);
            }, this.notifyService.handleApiErrors));
        };
        AddBatchFormulaCtrl.prototype.addMaterial = function () {
            var _this = this;
            var material = {};
            this.loaderService.loadingPromise(this.newGuidService.getNewGuid('BatchMaterial')
                .then(function (id) {
                material.id = id;
                _this.instance.material.push(material);
            }));
        };
        AddBatchFormulaCtrl.prototype.removeMaterial = function (material) {
            _.remove(this.instance.material, material);
        };
        AddBatchFormulaCtrl.prototype.cancel = function () {
            this.$modalInstance.close();
        };
        return AddBatchFormulaCtrl;
    }());
    exports.default = angular.module('aps.controller.addBatchFormula', requires)
        .controller('AddBatchFormulaCtrl', AddBatchFormulaCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <h2 class=modal-header>Add Batch Formula</h2> <form name=vm.form ng-submit=vm.add() novalidate> <div class=container style=\"margin:0 -30px\"> <div class=row> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Formula Sequence: <input name=formulaSequence type=text maxlength=100 ng-model=vm.instance.formulaSequence required/> </label> <div ng-messages=vm.form.formulaSequence.$error ng-if=\"vm.form.formulaSequence.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=maxlength class=req-w><div class=arrow-up></div>Must be 20 characters or less</div> </div> </div> <div class=\"large-6 columns\"> <label> <span class=\"required notated\">*</span>Glass Color: <select name=glassColor ng-model=vm.instance.colorId required> <option value=\"\">-- Select a Glass Color --</option> <option ng-repeat=\"gc in vm.glassColors | orderBy: 'name'\" ng-value=gc.id>{{gc.name}}</option> </select> <div ng-messages=vm.form.glassColor.$error ng-if=\"vm.form.glassColor.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> </div> <div class=row> <div class=\"large-12 columns\"> Material </div> </div> <div class=row ng-repeat=\"item in vm.instance.material track by $index\"> <div class=\"large-5 columns\"> <label> <span class=\"required notated\">*</span>Commodity: <select name=\"commodity{{$index}}\" ng-model=item.commodityId required> <option value=\"\">-- Select a Commodity --</option> <option ng-repeat=\"c in vm.commodities | orderBy: 'name'\" ng-value=c.id>{{c.name}} ({{c.shortItem}})</option> </select> <div ng-messages=\"vm.form['commodity' + $index].$error\" ng-if=\"vm.form['commodity' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"large-5 columns\"> <label><span class=\"required notated\">*</span>Pounds: <input name=\"pounds{{$index}}\" type=number min=0.001 max=999999999999999.999 ng-model=item.pounds required/> </label> <div ng-messages=\"vm.form['pounds' + $index].$error\" ng-if=\"vm.form['pounds' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be greater than 0</div> <div ng-message=max class=req-w><div class=arrow-up></div>Too large</div> </div> </div> <div class=\"large-2 columns\"> <button ng-click=vm.removeMaterial(item) type=button class=\"button tiny alert\" style=margin:0>Delete</button> </div> </div> <div class=row> <div class=\"large-12 columns\"> <button class=button type=button ng-click=vm.addMaterial()>Add Material</button> </div> </div> <div class=row> <div class=\"large-12 columns\"> <span class=required>* Required Fields</span> <div class=\"right dialog-footer\"> <button ng-click=vm.cancel() type=button class=\"button secondary\">Cancel</button> <button class=button type=submit>Add Batch Formula</button> </div> </div> </div> </div> </form> </div>");

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(63), __webpack_require__(6), __webpack_require__(4), __webpack_require__(12), __webpack_require__(553)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, batchFormulas_service_1, notify_service_1, loader_service_1, newguid_service_1, updateBatchFormula_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [batchFormulas_service_1.default, notify_service_1.default, loader_service_1.default, newguid_service_1.default];
    function openUpdateBatchFormula(data, $modal) {
        return $modal.open({
            template: updateBatchFormula_tpl_html_1.default,
            controller: 'UpdateBatchFormulaCtrl as vm',
            resolve: {
                data: function () { return data; }
            }
        }).result;
    }
    exports.openUpdateBatchFormula = openUpdateBatchFormula;
    var UpdateBatchFormulaCtrl = (function () {
        UpdateBatchFormulaCtrl.$inject = ["$modalInstance", "batchFormulasService", "data", "notifyService", "newGuidService", "loaderService"];
        function UpdateBatchFormulaCtrl($modalInstance, batchFormulasService, data, notifyService, newGuidService, loaderService) {
            var _this = this;
            this.$modalInstance = $modalInstance;
            this.batchFormulasService = batchFormulasService;
            this.notifyService = notifyService;
            this.loaderService = loaderService;
            this.newGuidService = newGuidService;
            this.instance = __assign({}, data.instance);
            this.commodities = data.commodities;
            this.glassColors = data.glassColors;
            this.loaderService.loadingPromise(this.newGuidService.getNewGuid('BatchFormula')
                .then(function (id) { return _this.newId = id; }));
        }
        UpdateBatchFormulaCtrl.prototype.save = function () {
            var _this = this;
            if (this.form.$invalid) {
                return;
            }
            var command = __assign({}, this.instance, { newId: this.newId });
            this.loaderService.loadingPromise(this.batchFormulasService.update(command)
                .then(function () {
                _this.instance.id = _this.newId;
                _this.instance.colorName = _.find(_this.glassColors, { id: _this.instance.colorId }).name;
                _this.$modalInstance.close(_this.instance);
            }, this.notifyService.handleApiErrors));
        };
        UpdateBatchFormulaCtrl.prototype.addMaterial = function () {
            var _this = this;
            var material = {};
            this.loaderService.loadingPromise(this.newGuidService.getNewGuid('BatchMaterial')
                .then(function (id) {
                material.id = id;
                _this.instance.material.push(material);
            }));
        };
        UpdateBatchFormulaCtrl.prototype.removeMaterial = function (material) {
            _.remove(this.instance.material, material);
        };
        UpdateBatchFormulaCtrl.prototype.cancel = function () {
            this.$modalInstance.close();
        };
        return UpdateBatchFormulaCtrl;
    }());
    exports.default = angular.module('aps.controller.updateBatchFormula', requires)
        .controller('UpdateBatchFormulaCtrl', UpdateBatchFormulaCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <h2 class=modal-header>Update Batch Formula</h2> <form name=vm.form ng-submit=vm.save() novalidate> <div class=container style=\"margin:0 -30px\"> <div class=row> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Formula Sequence: <input name=formulaSequence type=text maxlength=100 ng-model=vm.instance.formulaSequence required/> </label> <div ng-messages=vm.form.formulaSequence.$error ng-if=\"vm.form.formulaSequence.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=maxlength class=req-w><div class=arrow-up></div>Must be 20 characters or less</div> </div> </div> <div class=\"large-6 columns\"> <label> <span class=\"required notated\">*</span>Glass Color: <select name=glassColor ng-model=vm.instance.colorId required> <option value=\"\">-- Select a Glass Color --</option> <option ng-repeat=\"gc in vm.glassColors | orderBy: 'name'\" ng-value=gc.id>{{gc.name}}</option> </select> <div ng-messages=vm.form.glassColor.$error ng-if=\"vm.form.glassColor.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> </div> <div class=row> <div class=\"large-12 columns\"> Material </div> </div> <div class=row ng-repeat=\"item in vm.instance.material track by $index\"> <div class=\"large-5 columns\"> <label> <span class=\"required notated\">*</span>Commodity: <select name=\"commodity{{$index}}\" ng-model=item.commodityId required> <option value=\"\">-- Select a Commodity --</option> <option ng-repeat=\"c in vm.commodities | orderBy: 'name'\" ng-value=c.id>{{c.name}} ({{c.shortItem}})</option> </select> <div ng-messages=\"vm.form['commodity' + $index].$error\" ng-if=\"vm.form['commodity' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"large-5 columns\"> <label><span class=\"required notated\">*</span>Pounds: <input name=\"pounds{{$index}}\" type=number min=0.001 max=999999999999999.999 ng-model=item.pounds required/> </label> <div ng-messages=\"vm.form['pounds' + $index].$error\" ng-if=\"vm.form['pounds' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be greater than 0</div> <div ng-message=max class=req-w><div class=arrow-up></div>Too large</div> </div> </div> <div class=\"large-2 columns\"> <button ng-click=vm.removeMaterial(item) type=button class=\"button tiny alert\" style=margin:0>Delete</button> </div> </div> <div class=row> <div class=\"large-12 columns\"> <button class=button type=button ng-click=vm.addMaterial()>Add Material</button> </div> </div> <div class=row> <div class=\"large-12 columns\"> <span class=required>* Required Fields</span> <div class=\"right dialog-footer\"> <button ng-click=vm.cancel() type=button class=\"button secondary\">Cancel</button> <button class=button type=submit>Save Batch Formula</button> </div> </div> </div> </div> </form> </div>");

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <div class=body-header><h2>Batch Formulas</h2></div> <div class=container> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-5 columns\"> <label> <span class=\"required notated\">*</span>Plant: <select ng-model=vm.selectedPlant ng-options=\"plant.name for plant in vm.plants\" ng-change=vm.plantChanged()> </select> </label> </div> <div class=\"small-2 columns\"> <button ng-click=vm.add() class=\"button small\" style=position:relative;top:14px>Add Formula</button> </div> </div> <div ng-if=\"vm.batchFormulas && vm.batchFormulas.length === 0\" style=width:100%;clear:both;float:left;margin-top:30px> Currently there are no Batch Formulas for this Plant </div> <table cellpadding=1 cellspacing=1 ng-if=\"vm.batchFormulas && vm.batchFormulas.length > 0\" class=history-t> <tr> <th>Formula Sequence</th> <th>Color</th> <th></th> <th></th> </tr> <tr ng-repeat=\"item in vm.batchFormulas | orderBy: 'formulaSequence'\"> <td ng-bind=item.formulaSequence></td> <td ng-bind=item.colorName></td> <td><button ng-click=vm.edit(item) class=\"button tiny\" style=margin:0>Edit</button></td> <td><button ng-click=vm.remove(item) class=\"button tiny alert\" style=margin:0>Delete</button></td> </tr> </table> </div> </div>");

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(556), __webpack_require__(3), __webpack_require__(558), __webpack_require__(4), __webpack_require__(8), __webpack_require__(63), __webpack_require__(7), __webpack_require__(9), __webpack_require__(6), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, editBatchFormulaUsage_controller_1, constant_module_1, batchFormulaUsages_tpl_html_1, loader_service_1, navigation_service_1, batchFormulas_service_1, authData_service_1, uiUtility_service_1, notify_service_1, dateutility_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [editBatchFormulaUsage_controller_1.default, loader_service_1.default, notify_service_1.default, batchFormulas_service_1.default,
        authData_service_1.default, uiUtility_service_1.default, navigation_service_1.default];
    var BatchFormulaUsagesCtrl = (function () {
        BatchFormulaUsagesCtrl.$inject = ["loaderService", "batchFormulasService", "$q", "navigationService", "authDataService", "uiUtilityService", "notifyService", "$modal"];
        function BatchFormulaUsagesCtrl(loaderService, batchFormulasService, $q, navigationService, authDataService, uiUtilityService, notifyService, $modal) {
            var _this = this;
            this.loaderService = loaderService;
            this.batchFormulasService = batchFormulasService;
            this.uiUtilityService = uiUtilityService;
            this.notifyService = notifyService;
            this.$modal = $modal;
            this.$q = $q;
            var promises = [];
            promises.push(navigationService.getNavigation().then(function (nav) {
                var plants = nav.plants();
                _this.plants = _.filter(plants, function (plant) {
                    return authDataService.isAPSIOAdminForPlant(plant.id);
                });
                if (nav.selectedPlant && _.includes(_this.plants, nav.selectedPlant)) {
                    _this.selectedPlant = nav.selectedPlant;
                }
                else {
                    _this.selectedPlant = _.first(_this.plants);
                }
                return _this.plantChangedPrivate();
            }));
            this.loaderService.loadingPromise(this.$q.all(promises));
        }
        BatchFormulaUsagesCtrl.prototype.displayDate = function (date) {
            return dateutility_service_1.default.formatDate(date, this.selectedPlant ? this.selectedPlant.timeZoneId : null);
        };
        BatchFormulaUsagesCtrl.prototype.plantChangedPrivate = function () {
            var _this = this;
            this.tanks = this.selectedPlant.tanks;
            this.selectedTank = _.first(this.tanks);
            var promises = [];
            promises.push(this.batchFormulasService
                .get(this.selectedPlant.id)
                .then(function (batchFormulas) { return _this.batchFormulas = batchFormulas; }));
            promises.push(this.tankChangedPrivate());
            return this.$q.all(promises);
        };
        BatchFormulaUsagesCtrl.prototype.tankChangedPrivate = function () {
            var _this = this;
            return this.batchFormulasService
                .getUsages(this.selectedPlant.id, this.selectedTank.id)
                .then(function (usages) { return _this.usages = usages; });
        };
        BatchFormulaUsagesCtrl.prototype.plantChanged = function () {
            this.loaderService.loadingPromise(this.plantChangedPrivate());
        };
        BatchFormulaUsagesCtrl.prototype.tankChanged = function () {
            this.loaderService.loadingPromise(this.tankChangedPrivate());
        };
        BatchFormulaUsagesCtrl.prototype.add = function () {
            var _this = this;
            var result = editBatchFormulaUsage_controller_1.openEditBatchFormulaUsage({
                plant: this.selectedPlant,
                tank: this.selectedTank,
                batchFormulas: this.batchFormulas
            }, this.$modal);
            result.then(function (instance) {
                if (!instance) {
                    return;
                }
                _this.usages.push(instance);
            });
        };
        BatchFormulaUsagesCtrl.prototype.edit = function (instance) {
            var _this = this;
            var result = editBatchFormulaUsage_controller_1.openEditBatchFormulaUsage({
                instance: instance,
                plant: this.selectedPlant,
                tank: this.selectedTank,
                batchFormulas: this.batchFormulas
            }, this.$modal);
            result.then(function (updated) {
                if (!updated) {
                    return;
                }
                _.remove(_this.usages, instance);
                _this.usages.push(updated);
            });
        };
        BatchFormulaUsagesCtrl.prototype.remove = function (instance) {
            var _this = this;
            this.uiUtilityService.confirm('Are you sure you want to delete this Formula Usage?').then(function (confirmed) {
                if (!confirmed) {
                    return;
                }
                _this.loaderService.loadingPromise(_this.batchFormulasService.removeUsage({
                    id: instance.id
                }).then(function () {
                    _.remove(_this.usages, instance);
                }, _this.notifyService.handleApiErrors));
            });
        };
        return BatchFormulaUsagesCtrl;
    }());
    exports.default = angular.module('aps.controller.batchFormulaUsages', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.BATCH_FORMULA_USAGES,
            url: '/admin/batchFormulaUsages',
            controller: 'BatchFormulaUsagesCtrl as vm',
            template: batchFormulaUsages_tpl_html_1.default,
            data: {
                pageTitle: 'Batch Formula Usages',
                authorizeAPSIOAdmin: true
            }
        });
    }])
        .controller('BatchFormulaUsagesCtrl', BatchFormulaUsagesCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(63), __webpack_require__(6), __webpack_require__(4), __webpack_require__(12), __webpack_require__(557)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, batchFormulas_service_1, notify_service_1, loader_service_1, newguid_service_1, editBatchFormulaUsage_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [batchFormulas_service_1.default, notify_service_1.default, loader_service_1.default, newguid_service_1.default];
    function openEditBatchFormulaUsage(data, $modal) {
        return $modal.open({
            template: editBatchFormulaUsage_tpl_html_1.default,
            controller: 'EditBatchFormulaUsageCtrl as vm',
            resolve: {
                data: function () { return data; }
            }
        }).result;
    }
    exports.openEditBatchFormulaUsage = openEditBatchFormulaUsage;
    var EditBatchFormulaUsageCtrl = (function () {
        EditBatchFormulaUsageCtrl.$inject = ["data", "newGuidService", "batchFormulasService", "$modalInstance", "notifyService", "loaderService"];
        function EditBatchFormulaUsageCtrl(data, newGuidService, batchFormulasService, $modalInstance, notifyService, loaderService) {
            var _this = this;
            this.batchFormulasService = batchFormulasService;
            this.$modalInstance = $modalInstance;
            this.notifyService = notifyService;
            this.loaderService = loaderService;
            this.newGuidService = newGuidService;
            if (data.instance) {
                this.mode = 'Update';
                this.isNew = false;
                this.instance = __assign({}, data.instance);
            }
            else {
                this.mode = 'Add';
                this.isNew = true;
                this.instance = {
                    plantId: data.plant.id,
                    plantName: data.plant.name,
                    tankId: data.tank.id,
                    tankName: data.tank.name,
                    usageDate: moment().startOf('day').toDate()
                };
                this.newGuidService.getNewGuid('BatchFormulaUsage').then(function (id) { return _this.instance.id = id; });
            }
            this.batchFormulas = data.batchFormulas;
        }
        EditBatchFormulaUsageCtrl.prototype.submit = function () {
            var _this = this;
            if (this.form.$invalid) {
                return;
            }
            var commandPromise;
            if (this.isNew) {
                var command = this.instance;
                commandPromise = this.batchFormulasService.addUsage(command);
            }
            else {
                var command = this.instance;
                commandPromise = this.batchFormulasService.updateUsage(command);
            }
            this.loaderService.loadingPromise(commandPromise
                .then(function () {
                _this.instance.batchFormulaSequence = _.find(_this.batchFormulas, { id: _this.instance.batchFormulaId }).formulaSequence;
                _this.$modalInstance.close(_this.instance);
            }, this.notifyService.handleApiErrors));
        };
        EditBatchFormulaUsageCtrl.prototype.cancel = function () {
            this.$modalInstance.close();
        };
        return EditBatchFormulaUsageCtrl;
    }());
    exports.default = angular.module('aps.controller.editBatchFormulaUsage', requires)
        .controller('EditBatchFormulaUsageCtrl', EditBatchFormulaUsageCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <h2 class=modal-header>{{vm.mode}} Batch Formula Usage</h2> <form name=vm.form ng-submit=vm.submit() novalidate> <div class=container style=\"margin:0 -30px\"> <div class=row> <div class=\"large-4 columns\"> <label><span class=\"required notated\">*</span>Formula Sequence: <select name=batchFormula ng-model=vm.instance.batchFormulaId required> <option value=\"\">-- Select a Formula --</option> <option ng-repeat=\"item in vm.batchFormulas | orderBy: 'formulaSequence'\" ng-value=item.id>{{item.formulaSequence}}</option> </select> </label> <div ng-messages=vm.form.batchFormula.$error ng-if=\"vm.form.batchFormula.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-4 columns\"> <label> <span class=\"required notated\">*</span>Usage Date: <input type=date ng-model=vm.instance.usageDate name=usageDate required/> </label> <div ng-messages=vm.form.usageDate.$error ng-if=\"vm.form.usageDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-4 columns\"> <label><span class=\"required notated\">*</span>Number of Batches: <input name=numberOfBatches type=number min=0.001 max=999999999999999.999 ng-model=vm.instance.numberOfBatches required/> </label> <div ng-messages=vm.form.numberOfBatches.$error ng-if=\"vm.form.numberOfBatches.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be greater than 0</div> <div ng-message=max class=req-w><div class=arrow-up></div>Too large</div> </div> </div> </div> <div class=row> <div class=\"large-12 columns\"> <span class=required>* Required Fields</span> <div class=\"right dialog-footer\"> <button ng-click=vm.cancel() type=button class=\"button secondary\">Cancel</button> <button class=button type=submit>{{vm.mode}} Batch Formula Usage</button> </div> </div> </div> </div> </form> </div>");

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <div class=body-header><h2>Batch Formula Usages</h2></div> <div class=container> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-5 columns\"> <label> <span class=\"required notated\">*</span>Plant: <select ng-model=vm.selectedPlant ng-options=\"plant.name for plant in vm.plants\" ng-change=vm.plantChanged()> </select> </label> </div> <div class=\"small-5 columns\"> <label> <span class=\"required notated\">*</span>Tank: <select ng-model=vm.selectedTank ng-options=\"tank.name for tank in vm.tanks\" ng-change=vm.tankChanged()> </select> </label> </div> <div class=\"small-2 columns\"> <button ng-click=vm.add() class=\"button small\" style=position:relative;top:14px>Add Usage</button> </div> </div> <div ng-if=\"vm.usages && vm.usages.length === 0\" style=width:100%;clear:both;float:left;margin-top:30px> Currently there are no Batch Formula Usages for this Plant and Tank </div> <table cellpadding=1 cellspacing=1 ng-if=\"vm.usages && vm.usages.length > 0\" class=history-t> <tr> <th>Usage Date</th> <th>Formula Sequence</th> <th>Number of Batches</th> <th></th> <th></th> </tr> <tr ng-repeat=\"item in vm.usages | orderBy: '-usageDate'\"> <td>{{vm.displayDate(item.usageDate)}}</td> <td ng-bind=item.batchFormulaSequence></td> <td ng-bind=item.numberOfBatches></td> <td><button ng-click=vm.edit(item) class=\"button tiny\" style=margin:0>Edit</button></td> <td><button ng-click=vm.remove(item) class=\"button tiny alert\" style=margin:0>Delete</button></td> </tr> </table> </div> </div>");

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(3), __webpack_require__(560), __webpack_require__(4), __webpack_require__(11), __webpack_require__(63), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, constant_module_1, batchUsageReport_tpl_html_1, loader_service_1, dateutility_service_1, batchFormulas_service_1, navigation_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, batchFormulas_service_1.default, navigation_service_1.default];
    var BatchUsageReportCtrl = (function () {
        BatchUsageReportCtrl.$inject = ["$stateParams", "$state", "$q", "navigationService", "batchFormulasService", "loaderService"];
        function BatchUsageReportCtrl($stateParams, $state, $q, navigationService, batchFormulasService, loaderService) {
            var _this = this;
            this.$q = $q;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.loaderService = loaderService;
            this.batchFormulasService = batchFormulasService;
            var today = moment().startOf('day');
            this.startDate = today.clone().subtract(1, 'month').toDate();
            this.endDate = today.toDate();
            var promise = navigationService.getNavigation().then(function (navModel) {
                _this.plants = navModel.plants();
                _this.selectedPlant = navModel.selectedPlant;
                _this.updatePlant();
                return _this.loadState($stateParams);
            });
            loaderService.loadingPromise(promise);
        }
        BatchUsageReportCtrl.prototype.loadState = function (params) {
            if (params.reportPlantId && params.reportPlantId !== params.plantId) {
                var plant = _.find(this.plants, { id: params.reportPlantId });
                if (plant) {
                    this.selectedPlant = plant;
                    this.updatePlant();
                }
            }
            if (params.reportTankId) {
                var tank = _.find(this.tanks, { id: params.reportTankId });
                if (tank) {
                    this.selectedTank = tank;
                }
            }
            if (params.startDate) {
                var startDate = moment(params.startDate);
                if (startDate.isValid()) {
                    this.startDate = startDate.toDate();
                }
            }
            if (params.endDate) {
                var endDate = moment(params.endDate);
                if (endDate.isValid()) {
                    this.endDate = endDate.toDate();
                }
            }
            if (params.autoRun) {
                return this.runUsageReport();
            }
            return this.$q.when();
        };
        BatchUsageReportCtrl.prototype.saveState = function () {
            var reportPlantId = this.selectedPlant ? this.selectedPlant.id : undefined;
            if (reportPlantId === this.$stateParams.plantId) {
                reportPlantId = undefined;
            }
            var reportTankId = this.selectedTank ? this.selectedTank.id : undefined;
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportPlantId: reportPlantId,
                reportTankId: reportTankId,
                startDate: this.startDate ? this.startDate.toISOString() : undefined,
                endDate: this.endDate ? this.endDate.toISOString() : undefined,
                autoRun: true
            };
            this.$state.transitionTo(constant_module_1.States.BATCH_FORMULA_USAGE_REPORT, params);
        };
        BatchUsageReportCtrl.prototype.generateReport = function () {
            if (this.form.$invalid) {
                return;
            }
            this.saveState();
            this.loaderService.loadingPromise(this.runUsageReport());
        };
        BatchUsageReportCtrl.prototype.runUsageReport = function () {
            var _this = this;
            var startDateStart = moment(this.startDate).startOf('day').toDate();
            var tzOffsetStartDate = dateutility_service_1.default.localToTimeZone(startDateStart, this.selectedPlant.timeZoneId).toDate();
            var endDateEnd = moment(this.endDate || new Date()).endOf('day').toDate();
            var tzOffsetEndDate = dateutility_service_1.default.localToTimeZone(endDateEnd, this.selectedPlant.timeZoneId).toDate();
            return this.batchFormulasService
                .getUsageReport(this.selectedPlant.id, this.selectedTank.id, tzOffsetStartDate, tzOffsetEndDate)
                .then(function (reportItems) {
                _this.results = reportItems;
                _this.searchPerformed = true;
            });
        };
        BatchUsageReportCtrl.prototype.formatTime = function (time) {
            return dateutility_service_1.default.formatDate(time, this.selectedPlant.timeZoneId);
        };
        BatchUsageReportCtrl.prototype.formatNumber = function (number) {
            return number.toFixed(4);
        };
        BatchUsageReportCtrl.prototype.updatePlant = function () {
            this.tanks = this.selectedPlant.tanks;
            this.selectedTank = this.tanks[0];
        };
        return BatchUsageReportCtrl;
    }());
    exports.default = angular.module('aps.controller.batchUsageReport', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.BATCH_FORMULA_USAGE_REPORT,
            url: '/admin/reports/batchUsage?startDate&endDate&autoRun&reportPlantId&reportTankId',
            params: {
                startDate: { dynamic: true },
                endDate: { dynamic: true },
                autoRun: { dynamic: true },
                reportPlantId: { dynamic: true },
                reportTankId: { dynamic: true }
            },
            controller: 'BatchUsageReportCtrl as vm',
            template: batchUsageReport_tpl_html_1.default,
            data: {
                pageTitle: 'Batch Formula Usage Report'
            }
        });
    }])
        .controller('BatchUsageReportCtrl', BatchUsageReportCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div class=body-header> <h2>Batch Formula Usage Report</h2> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>Plant <select ng-model=vm.selectedPlant ng-options=\"plant as plant.name for plant in vm.plants\" ng-change=vm.updatePlant() name=selectedPlant required> <option value=\"\">-- Select a Plant --</option> </select> <div ng-messages=vm.form.selectedPlant.$error ng-if=\"vm.form.selectedPlant.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>Tank <select ng-model=vm.selectedTank ng-options=\"tank as tank.name for tank in vm.tanks\" name=selectedTank required> <option value=\"\">-- Select a Tank --</option> </select> <div ng-messages=vm.form.selectedTank.$error ng-if=\"vm.form.selectedTank.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>Start Date <input type=date ng-model=vm.startDate name=startDate required/> <div ng-messages=vm.form.startDate.$error ng-if=\"vm.form.startDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>End Date <input type=date ng-model=vm.endDate name=endDate min=\"{{ vm.startDate }}\" required/> <div ng-messages=vm.form.endDate.$error ng-if=\"vm.form.endDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=min class=req-w> <div class=arrow-up></div>Must be greater than or equal to the Start Date </div> </div> </label> </div> </div> <button type=submit class=button>Generate Report</button> </form> <table class=history-t ng-if=\"vm.results && vm.results.length\"> <thead> <tr> <th>Short Item</th> <th>Plant</th> <th>Tank</th> <th>Usage Date</th> <th>Formula</th> <th>Material</th> <th>Pounds</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in vm.results\"> <td>{{item.commodityShortItem}}</td> <td>{{item.plantName}}</td> <td>{{item.tankName}}</td> <td>{{vm.formatTime(item.usageDate)}}</td> <td>{{item.batchFormulaSequence}}</td> <td>{{item.commodityMaterialCode}}</td> <td>{{vm.formatNumber(item.pounds)}}</td> </tr> </tbody> </table> <div ng-if=\"(!vm.results || !vm.results.length) && vm.searchPerformed\">No results found</div> </div>");

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(3), __webpack_require__(562), __webpack_require__(4), __webpack_require__(8), __webpack_require__(6), __webpack_require__(563), __webpack_require__(56)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, constant_module_1, commodityBin_tpl_html_1, loader_service_1, navigation_service_1, notify_service_1, commodityBin_service_1, commodities_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, commodityBin_service_1.default, commodities_service_1.default,
        navigation_service_1.default, notify_service_1.default];
    var CommodityBinCtrl = (function () {
        CommodityBinCtrl.$inject = ["loaderService", "commodityBinService", "commoditiesService", "navigationService", "notifyService", "$q"];
        function CommodityBinCtrl(loaderService, commodityBinService, commoditiesService, navigationService, notifyService, $q) {
            var _this = this;
            this.backupcommodityBins = [];
            this.commodityBins = [];
            this.changes = false;
            this.commodities = [];
            this.loaderService = loaderService;
            this.navigationService = navigationService;
            this.commodityBinService = commodityBinService;
            this.commoditiesService = commoditiesService;
            this.notifyService = notifyService;
            this.$q = $q;
            var promise = this.navigationService.getNavigation()
                .then(function (nav) {
                _this.plants = nav.plants();
                if (nav.selectedPlant && _.includes(_this.plants, nav.selectedPlant)) {
                    _this.selectedPlant = nav.selectedPlant;
                }
                else {
                    _this.selectedPlant = _.first(_this.plants);
                }
                _this.plantChanged();
                _this.loadCommodities();
            });
            this.loaderService.loadingPromise(promise);
        }
        CommodityBinCtrl.prototype.plantChanged = function () {
            this.selectedTank = _.first(this.selectedPlant.tanks);
            var promises = [];
            promises.push(this.loadMappings());
            promises.push(this.loadCommodities());
            this.loaderService.loadingPromise(this.$q.all(promises));
        };
        CommodityBinCtrl.prototype.tankChanged = function () {
            this.loaderService.loadingPromise(this.loadMappings());
        };
        CommodityBinCtrl.prototype.loadCommodities = function () {
            var _this = this;
            return this.commoditiesService
                .get(this.selectedPlant.id)
                .then(function (commodities) {
                _this.changes = false;
                _this.commodities = commodities.sort(function (a, b) {
                    if (a.name < b.name) {
                        return -1;
                    }
                    if (a.name > b.name) {
                        return 1;
                    }
                    return 0;
                });
            });
        };
        CommodityBinCtrl.prototype.loadMappings = function () {
            var _this = this;
            return this.commodityBinService
                .get(this.selectedPlant.id, this.selectedTank.id)
                .then(function (mappings) {
                _this.backupcommodityBins = angular.copy(mappings);
                _this.commodityBins = mappings;
            });
        };
        CommodityBinCtrl.prototype.edit = function (instance) {
            instance.commodityId = undefined;
            instance.commodityName = undefined;
            this.changes = true;
        };
        CommodityBinCtrl.prototype.changeCommodity = function (instance) {
            instance.commodityName = this.currentselectedCommodity.name + ' (' + this.currentselectedCommodity.shortItem + ')';
            instance.commodityId = this.currentselectedCommodity.id;
            this.changes = true;
            this.currentselectedCommodity = undefined;
        };
        CommodityBinCtrl.prototype.save = function () {
            var _this = this;
            var command = {
                mappings: this.commodityBins
            };
            this.loaderService.loadingPromise(this.commodityBinService.update(command)
                .then(function (result) {
                _this.changes = false;
                _this.notifyService.success("Updated mappings successfully");
                _this.backupcommodityBins = angular.copy(_this.commodityBins);
            })
                .catch(this.notifyService.handleApiErrors));
        };
        CommodityBinCtrl.prototype.reset = function () {
            this.commodityBins = angular.copy(this.backupcommodityBins);
            this.changes = false;
        };
        return CommodityBinCtrl;
    }());
    exports.default = angular.module('aps.controller.commodityBin', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.COMMODITY_BIN,
            url: '/admin/commodityBin',
            controller: 'CommodityBinCtrl as vm',
            template: commodityBin_tpl_html_1.default,
            data: {
                pageTitle: 'Commodity Bin Mapping',
                authorizePlantAdmin: true
            }
        });
    }])
        .controller('CommodityBinCtrl', CommodityBinCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <div class=body-header> <h2>Commodity Bin Mapping</h2> </div> <div class=container> <div class=row> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>Plant: <select ng-model=vm.selectedPlant ng-options=\"plant.name for plant in vm.plants\" ng-change=vm.plantChanged()> </select> </label> </div> <div class=\"small-2 columns\"> <label> <span class=\"required notated\">*</span>Tank: <select ng-model=vm.selectedTank ng-options=\"tank.name for tank in vm.selectedPlant.tanks\" ng-change=vm.tankChanged()> </select> </label> </div> <div class=\"small-9 columns\"></div> </div> <div class=row> <div class=\"small-7 columns\"> <div ng-if=\"vm.commodityBins && vm.commodityBins.length === 0\"> Currently there are no mappings for this plant </div> <div ng-if=\"vm.commodityBins && vm.commodityBins.length > 0\" style=text-align:right> <table class=history-t> <tr> <th>Bin</th> <th>Commodity</th> <th></th> </tr> <tr ng-repeat=\"item in vm.commodityBins  track by $index\"> <td style=width:30%> <span ng-if=!!item.binName>{{item.binName}}</span> </td> <td> <span ng-if=!!item.commodityName>{{item.commodityName}}</span> <span ng-if=!item.commodityId> <select ng-model=vm.currentselectedCommodity ng-options=\"comm.name + '('+ comm.shortItem + ')' for comm in vm.commodities\" ng-change=vm.changeCommodity(item)> </select> </span> </td> <td style=width:30%;text-align:center> <button ng-if=item.commodityId ng-click=vm.edit(item) class=\"button tiny\" style=\"margin:.5em 0\">Edit</button> </td> </tr> </table> <button ng-click=vm.reset() class=\"button small secondary\" ng-disabled=!vm.changes>Cancel</button> <button ng-click=vm.save() class=\"button small\" ng-disabled=!vm.changes>Save Mapping</button> </div> </div> </div> </div> </div>");

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var CommodityBinSvc = (function () {
        CommodityBinSvc.$inject = ["httpService"];
        function CommodityBinSvc(httpService) {
            this.httpService = httpService;
        }
        CommodityBinSvc.prototype.get = function (plantId, tankId) {
            return this.httpService.get(constant_module_1.Endpoints.COMMODITY_BIN, { plantId: plantId, tankId: tankId });
        };
        CommodityBinSvc.prototype.update = function (command) {
            return this.httpService.put(constant_module_1.Endpoints.COMMODITY_BIN, command);
        };
        return CommodityBinSvc;
    }());
    exports.default = angular
        .module('aps.services.commodityBin', [http_service_1.default])
        .service('commodityBinService', CommodityBinSvc)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2), __webpack_require__(0), __webpack_require__(4), __webpack_require__(6), __webpack_require__(294), __webpack_require__(25), __webpack_require__(565), __webpack_require__(566), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, _, angular, loader_service_1, notify_service_1, checkDetectorDefectMapping_service_1, defectType_service_1, checkDetectorDefectMapping_tpl_html_1, editCheckDetectorDefectMapping_controller_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, notify_service_1.default, checkDetectorDefectMapping_service_1.default, defectType_service_1.default,
        editCheckDetectorDefectMapping_controller_1.default];
    var CheckDetectorDefectMappingCtrl = (function () {
        CheckDetectorDefectMappingCtrl.$inject = ["loaderService", "notifyService", "$modal", "$q", "defectTypeService", "checkDetectorDefectMappingService"];
        function CheckDetectorDefectMappingCtrl(loaderService, notifyService, $modal, $q, defectTypeService, checkDetectorDefectMappingService) {
            var _this = this;
            this.loaderService = loaderService;
            this.notifyService = notifyService;
            this.$modal = $modal;
            this.defectTypeService = defectTypeService;
            this.$q = $q;
            this.checkDetectorDefectMappingService = checkDetectorDefectMappingService;
            var mappingPromise = this.checkDetectorDefectMappingService.getCheckDetectorDefectMappings();
            var defectPromise = this.defectTypeService.getDefectTypesAndClassifications();
            this.$q.all([mappingPromise, defectPromise])
                .then(function (promises) {
                _this.checkDetectorDefectMappings = promises[0];
                _this.defectTypes = _.orderBy(promises[1].types, 'name');
            }, notifyService.handleApiErrors);
        }
        CheckDetectorDefectMappingCtrl.prototype.openAddNew = function () {
            var _this = this;
            editCheckDetectorDefectMapping_controller_1.openEditCheckDetectorDefectMapping({
                checkDetectorText: '',
                defectTypes: this.defectTypes,
                defectType: null
            }, this.$modal).then(function (response) {
                if (response) {
                    _this.checkDetectorDefectMappings.push(response);
                }
            });
        };
        CheckDetectorDefectMappingCtrl.prototype.getDefectType = function (defectId) {
            return _.find(this.defectTypes, { 'id': defectId });
        };
        CheckDetectorDefectMappingCtrl.prototype.editCheckDetector = function (checkDetectorDefectMapping) {
            var _this = this;
            editCheckDetectorDefectMapping_controller_1.openEditCheckDetectorDefectMapping({
                checkDetectorText: checkDetectorDefectMapping.checkDetectorText,
                defectType: this.getDefectType(checkDetectorDefectMapping.defectTypeId),
                defectTypes: this.defectTypes
            }, this.$modal).then(function (response) {
                if (response) {
                    var index = _.findIndex(_this.checkDetectorDefectMappings, { checkDetectorText: response.checkDetectorText });
                    _this.checkDetectorDefectMappings[index] = response;
                }
            });
        };
        return CheckDetectorDefectMappingCtrl;
    }());
    exports.default = angular.module('aps.controller.checkDetectorDefectMapping', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.CHECK_DETECTOR_DEFECT_MAPPING,
            url: '/admin/checkDetectorDefectMapping',
            controller: 'CheckDetectorDefectMappingCtrl as vm',
            template: checkDetectorDefectMapping_tpl_html_1.default,
            data: {
                pageTitle: 'Check Detector Defect Mapping',
                vmTitle: 'Check Detector Defect Mapping',
                authorizeAPSIOAdmin: true
            }
        });
    }])
        .controller('CheckDetectorDefectMappingCtrl', CheckDetectorDefectMappingCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <div class=body-header> <h2>Check Detector Defect Mapping</h2> <div class=right> <button type=\"button secondary small\" ng-click=vm.openAddNew()>Add New Mapping</button> </div> </div> <table class=history-t> <thead> <tr> <th width=30%>Check Detector Text</th> <th width=60%>Defect Type Name</th> </tr> </thead> <tbody> <tr ng-repeat=\"cddm in vm.checkDetectorDefectMappings | orderBy: 'checkDetectorText'\" ng-click=vm.editCheckDetector(cddm)> <td>{{ cddm.checkDetectorText }}</td> <td>{{ cddm.defectTypeName }}</td> </tr> <tr ng-if=\"!vm.checkDetectorDefectMappings || vm.checkDetectorDefectMappings === null || vm.checkDetectorDefectMappings.length == 0\"> <td colspan=3> There are no Check Detector Defect Mappings defined. </td> </tr> </tbody> </table> </div>");

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(567), __webpack_require__(6), __webpack_require__(294)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, editCheckDetectorDefectMapping_tpl_html_1, notify_service_1, checkDetectorDefectMapping_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [notify_service_1.default, checkDetectorDefectMapping_service_1.default];
    function openEditCheckDetectorDefectMapping(data, $modal) {
        var modalInstance = $modal.open({
            template: editCheckDetectorDefectMapping_tpl_html_1.default,
            controller: 'EditCheckDetectorDefectMappingCtrl as vm',
            resolve: {
                data: function () { return data; }
            }
        });
        return modalInstance.result;
    }
    exports.openEditCheckDetectorDefectMapping = openEditCheckDetectorDefectMapping;
    var EditCheckDetectorDefectMappingCtrl = (function () {
        EditCheckDetectorDefectMappingCtrl.$inject = ["notifyService", "checkDetectorDefectMappingService", "$q", "data", "$modalInstance", "$modal"];
        function EditCheckDetectorDefectMappingCtrl(notifyService, checkDetectorDefectMappingService, $q, data, $modalInstance, $modal) {
            this.$modalInstance = $modalInstance;
            this.$modal = $modal;
            this.notifyService = notifyService;
            this.checkDetectorDefectMappingService = checkDetectorDefectMappingService;
            this.$q = $q;
            this.defectTypes = _.sortBy(data.defectTypes, 'name');
            this.checkDetectorText = data.checkDetectorText;
            this.defectType = data.defectType;
            this.mode = data.checkDetectorText.length > 0 ? 'Update' : 'Add';
            this.readOnly = data.checkDetectorText.length > 0;
        }
        EditCheckDetectorDefectMappingCtrl.prototype.submit = function () {
            var _this = this;
            if (this.form.$invalid) {
                return;
            }
            var mapping = {
                checkDetectorText: this.checkDetectorText,
                defectTypeId: this.defectType.id,
                defectTypeName: this.defectType.name
            };
            var submit = this.mode === 'Add'
                ? this.checkDetectorDefectMappingService.addCheckDetectorDefectMapping(mapping)
                : this.checkDetectorDefectMappingService.updateCheckDetectorDefectMapping(mapping);
            submit.then(function () { return _this.$modalInstance.close(mapping); }, this.notifyService.handleApiErrors);
        };
        EditCheckDetectorDefectMappingCtrl.prototype.cancel = function () {
            this.$modalInstance.close();
        };
        return EditCheckDetectorDefectMappingCtrl;
    }());
    exports.default = angular.module('aps.controller.editCheckDetectorDefectMapping', requires)
        .controller('EditCheckDetectorDefectMappingCtrl', EditCheckDetectorDefectMappingCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<form name=vm.form ng-submit=vm.submit() novalidate> <div> <h3>{{vm.mode}} Check Detector Defect Mapping</h3> <label> <span class=\"required notated\">*</span>Check Detector Text <input type=text name=checkDetectorText ng-model=vm.checkDetectorText ng-readonly=vm.readOnly /> <div ng-messages=vm.form.checkDetectorText.$error ng-if=\"vm.form.checkDetectorText.$dirty || vm.form.$submitted\"> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> <label> <span class=\"required notated\">*</span>Defect Type: <select name=defectType ng-model=vm.defectType ng-options=\"defectTypeItem as defectTypeItem.name for defectTypeItem in vm.defectTypes track by defectTypeItem.id\"> </select> <div ng-messages=vm.form.defectType.$error ng-if=\"vm.form.defectType.$dirty || vm.form.$submitted\"> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-12 columns\"> <span class=required>* Required Fields</span> <div class=\"right dialog-footer\"> <button type=submit class=button>{{vm.mode}} Mapping</button> <button type=button ng-click=vm.cancel() class=\"button secondary\">Cancel</button> </div> </div> </div> </form> ");

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(3), __webpack_require__(569), __webpack_require__(62), __webpack_require__(5), __webpack_require__(9), __webpack_require__(7), __webpack_require__(30), __webpack_require__(4), __webpack_require__(54), __webpack_require__(6), __webpack_require__(12), __webpack_require__(8), __webpack_require__(570), __webpack_require__(574), __webpack_require__(90), __webpack_require__(25)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, constant_module_1, checkLists_tpl_html_1, checkListOverride_module_1, aps_enums_1, uiUtility_service_1, authData_service_1, checkLists_service_1, loader_service_1, locations_service_1, notify_service_1, newguid_service_1, navigation_service_1, checkList_controller_1, copyCheckList_controller_1, jobRun_service_1, defectType_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [uiUtility_service_1.default, authData_service_1.default, checkLists_service_1.default, loader_service_1.default,
        locations_service_1.default, notify_service_1.default, newguid_service_1.default, navigation_service_1.default, checkList_controller_1.default,
        copyCheckList_controller_1.default, jobRun_service_1.default, defectType_service_1.default];
    var CheckListsCtrl = (function () {
        CheckListsCtrl.$inject = ["$modal", "checkListsService", "jobRunService", "loaderService", "locationsService", "notifyService", "uiUtilityService", "newGuidService", "navigationService", "defectTypeService", "$q", "authDataService"];
        function CheckListsCtrl($modal, checkListsService, jobRunService, loaderService, locationsService, notifyService, uiUtilityService, newGuidService, navigationService, defectTypeService, $q, authDataService) {
            var _this = this;
            this.$modal = $modal;
            this.uiUtilityService = uiUtilityService;
            this.checkListsService = checkListsService;
            this.newGuidService = newGuidService;
            this.level = aps_enums_1.apsEnums.CheckListLevel.All;
            this.plantsAllSelection = checkListOverride_module_1.CheckListCommon.getAllPlantsItem();
            this.shopsAllSelection = checkListOverride_module_1.CheckListCommon.getAllShopsItem();
            this.wareClassAllSelection = checkListOverride_module_1.CheckListCommon.getAllWareClassItem();
            this.plant = this.plantsAllSelection;
            this.shop = this.shopsAllSelection;
            this.wareClass = this.wareClassAllSelection;
            this.orderBy = 'name';
            this.levels = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.CheckListLevel, aps_enums_1.apsEnums.CheckListLevel.All);
            this.plants = [];
            this.shops = [];
            this.wareClasses = [];
            this.loaderService = loaderService;
            this.authDataService = authDataService;
            this.notifyService = notifyService;
            var locationsPromise = locationsService.initialize().then(function () {
                return navigationService.getPlants(true).then(function (plants) {
                    _this.plants = plants;
                    _this.shops = [_this.shopsAllSelection];
                    _this.allShops = _.flatten(_.map(plants, 'shops'));
                    _this.locations = locationsService.getOtherLocations();
                    _this.plants.unshift(_this.plantsAllSelection);
                    if (_this.shops.length === 1) {
                        _this.shop = _this.shops[0];
                    }
                    return _this.loadCheckLists();
                });
            }, notifyService.handleApiErrors);
            var jobsPromise = jobRunService.getJobs()
                .then(function (jobs) { return _this.jobs = jobs.filter(function (x) { return !x.isDeleted; }); }, notifyService.handleApiErrors);
            var wareClassPromise = defectTypeService.getDefectTypeWareClasses()
                .then(function (wareClasses) { return _this.wareClasses = [_this.wareClassAllSelection].concat(wareClasses); });
            loaderService.loadingPromise($q.all([locationsPromise, jobsPromise, wareClassPromise]));
        }
        CheckListsCtrl.prototype.levelChanged = function () {
            switch (this.level) {
                case aps_enums_1.apsEnums.CheckListLevel.Corporate:
                    this.plant = this.plantsAllSelection;
                    this.plantChanged();
                    break;
                case aps_enums_1.apsEnums.CheckListLevel.Plant:
                    this.shop = this.shopsAllSelection;
                    this.shopChanged();
                    break;
                default:
                    this.refresh();
                    break;
            }
        };
        CheckListsCtrl.prototype.plantChanged = function () {
            this.shops = this.plantShops();
            this.shop = _.first(this.shops);
            this.shopChanged();
        };
        CheckListsCtrl.prototype.shopChanged = function () {
            this.refresh();
        };
        CheckListsCtrl.prototype.jobNameChanged = function () {
            this.job = _.find(this.jobs, { name: this.jobName });
            this.refresh();
        };
        CheckListsCtrl.prototype.clearJob = function () {
            if (!this.job) {
                return;
            }
            this.job = null;
            this.jobName = null;
            this.refresh();
        };
        CheckListsCtrl.prototype.refresh = function () {
            this.loaderService.loadingPromise(this.loadCheckLists()
                .then(null, this.notifyService.handleApiErrors));
        };
        CheckListsCtrl.prototype.updateClassificationLists = function () {
            this.departments = _.uniq(_.filter(_.map(this.checkLists, 'department'), function (x) { return !!x; }));
            this.pasTypes = _.uniq(_.filter(_.map(this.checkLists, 'pasType'), function (x) { return !!x; }));
        };
        CheckListsCtrl.prototype.loadCheckLists = function () {
            var _this = this;
            return this.checkListsService
                .getCheckLists(this.plant.id, this.shop.id, this.level)
                .then(function (checkLists) {
                _this.checkLists = checkListOverride_module_1.default.extendCheckLists(checkLists, _this.plants, _this.allShops, _this.locations, _this.wareClasses, _this.plant.id, _this.shop.id, _this.job ? _this.job.id : null, _this.authDataService);
                _this.updateClassificationLists();
            });
        };
        CheckListsCtrl.prototype.plantShops = function () {
            var shops = this.plant.shops;
            if (shops.length === 0 || shops[0] !== this.shopsAllSelection) {
                shops.unshift(this.shopsAllSelection);
            }
            return shops;
        };
        CheckListsCtrl.prototype.checkLists_filtered = function () {
            var _this = this;
            var result = _(this.checkLists);
            if (this.wareClass.id !== null) {
                result = result.filter(function (x) { return x.wareClassId == _this.wareClass.id; });
            }
            if (this.department) {
                result = result.filter(function (x) { return x.department === _this.department; });
            }
            if (this.pasType) {
                result = result.filter(function (x) { return x.pasType === _this.pasType; });
            }
            if (this.topNumber) {
                result = result.filter(function (x) { return x.topNumber && x.topNumber.indexOf(_this.topNumber) >= 0; });
            }
            if (this.name) {
                var name = this.name.toLowerCase();
                result = result.filter(function (x) { return x.name.toLowerCase().indexOf(name) >= 0; });
            }
            return result.value();
        };
        CheckListsCtrl.prototype.getNonGroupCheckLists = function (plant, shop) {
            var plantId = plant ? plant.id : null;
            var shopId = shop ? shop.id : null;
            return _.filter(this.checkLists, { isGroup: false, isDisabled: false, plantId: plantId, shopId: shopId });
        };
        CheckListsCtrl.prototype.canAddCheckList = function () {
            if (this.plant) {
                return this.authDataService.isPlantAdmin(this.plant.id);
            }
            else {
                return this.authDataService.isAdmin();
            }
        };
        CheckListsCtrl.prototype.addCheckList = function () {
            var _this = this;
            var plants = this.plants.concat();
            var shops = [];
            if (this.plant.id) {
                plants = [this.plant];
                shops = [this.shopsAllSelection].concat(this.plant.shops);
                if (this.shop.id) {
                    shops = [this.shop];
                }
            }
            checkList_controller_1.openEditCheckList({
                id: null,
                mode: 'add',
                plants: plants,
                shops: shops,
                jobs: this.jobs,
                job: this.job,
                plant: this.plant,
                shop: this.shop,
                wareClasses: this.wareClasses,
                wareClass: this.wareClass,
                checkLists: _.filter(this.getNonGroupCheckLists(this.plant, this.shop), function (c) { return c.checkListGroupId === null; }),
                locations: this.locations,
                departments: this.departments,
                pasTypes: this.pasTypes,
                onAdd: function (data) {
                    if (!data) {
                        return;
                    }
                    var checkList = {
                        id: data.id,
                        name: data.name,
                        department: data.department,
                        pasType: data.pasType,
                        topNumber: data.topNumber,
                        plantId: data.plantId,
                        shopId: data.shopId,
                        wareClassId: data.wareClassId,
                        locationType: data.locationType,
                        locationId: data.locationId,
                        isGroup: data.isGroup,
                        checkListGroupId: null,
                        overrides: [],
                        isDeleted: false,
                        createdOn: new Date(),
                        deletedOn: null
                    };
                    var jobId = _this.job ? _this.job.id : null;
                    var item = checkListOverride_module_1.default.extendCheckList(checkList, _this.checkLists, _this.plants, _this.allShops, _this.locations, _this.wareClasses, _this.plant.id, _this.shop.id, jobId, _this.authDataService);
                    _this.checkLists.push(item);
                    _this.updateClassificationLists();
                    _this.applyGroupToChildLists(data);
                },
                checkListGroupName: null
            }, this.$modal);
        };
        CheckListsCtrl.prototype.openCheckList = function (checkList) {
            var _this = this;
            var plants = this.plants.concat();
            var shops = [];
            var plant = this.plant;
            var shop = this.shop;
            if (checkList.plantId) {
                plant = _.find(plants, { id: checkList.plantId });
                plants = [plant];
                shops = [this.shopsAllSelection].concat(plant.shops);
                if (checkList.shopId) {
                    shop = _.find(shops, { id: checkList.shopId });
                    shops = [shop];
                }
            }
            var wareClass = this.wareClassAllSelection;
            if (checkList.wareClassId) {
                wareClass = _.find(this.wareClasses, { id: checkList.wareClassId });
            }
            var checkLists = _.filter(this.getNonGroupCheckLists(plant, shop), function (c) { return c !== checkList && c.checkListGroupId === null; });
            checkLists = checkLists.concat(_.filter(this.checkLists, function (c) { return c.checkListGroupId === checkList.id; }));
            var result = checkList_controller_1.openEditCheckList({
                id: checkList.id,
                mode: checkList.canEdit ? 'edit' : 'view',
                plants: plants,
                shops: shops,
                plant: plant,
                shop: shop,
                wareClasses: this.wareClasses,
                wareClass: wareClass,
                jobs: this.jobs,
                job: this.job,
                checkLists: checkLists,
                checkListGroupName: checkList.checkListGroupName,
                locations: this.locations,
                departments: this.departments,
                pasTypes: this.pasTypes
            }, this.$modal);
            result.then(function (response) {
                if (!response) {
                    return;
                }
                if (response.action === 'override') {
                    var data = response.data;
                    var checkList = _.find(_this.checkLists, { id: data.checkListId });
                    var override = _.find(checkList.overrides, { plantId: data.plantId, shopId: data.shopId, jobId: data.jobId });
                    if (override) {
                        override.roleId = data.roleId;
                    }
                    else {
                        checkList.overrides.push({
                            id: null,
                            checkListId: data.checkListId,
                            plantId: data.plantId,
                            shopId: data.shopId,
                            jobId: data.jobId,
                            roleId: data.roleId,
                            isMandatory: data.isMandatory,
                            isDisabled: data.isDisabled
                        });
                    }
                    return;
                }
                var cmd = response.data;
                var checkList = _.find(_this.checkLists, { id: cmd.id });
                checkList.name = cmd.name;
                checkList.department = cmd.department;
                checkList.pasType = cmd.pasType;
                checkList.topNumber = cmd.topNumber;
                checkList.locationId = cmd.locationId;
                checkList.locationType = cmd.locationType;
                checkList.locationName = checkListOverride_module_1.default.getLocationName(checkList, _this.locations);
                checkList.wareClassId = cmd.wareClassId;
                checkList.wareClass = checkListOverride_module_1.default.getWareClassName(checkList, _this.wareClasses);
                _this.applyGroupToChildLists(cmd);
                _this.updateClassificationLists();
            });
        };
        CheckListsCtrl.prototype.applyGroupToChildLists = function (data) {
            var _this = this;
            if (data.isGroup) {
                _.forEach(_.filter(this.checkLists, { checkListGroupId: data.id }), function (c) {
                    c.checkListGroupId = null;
                    c.checkListGroupName = null;
                    checkListOverride_module_1.default.setOverrideValue(c, _this.plant ? _this.plant.id : null, _this.shop ? _this.shop.id : null, _this.job ? _this.job.id : null, _this.authDataService);
                });
                _.forEach(data.childCheckLists, function (child) {
                    var childList = _.find(_this.checkLists, { id: child.id });
                    if (childList) {
                        childList.checkListGroupId = data.id;
                        childList.checkListGroupName = data.name;
                        checkListOverride_module_1.default.setOverrideValue(childList, _this.plant ? _this.plant.id : null, _this.shop ? _this.shop.id : null, _this.job ? _this.job.id : null, _this.authDataService);
                    }
                });
            }
        };
        CheckListsCtrl.prototype.copyCheckList = function (checkList) {
            var _this = this;
            var result = copyCheckList_controller_1.openCopyCheckList({
                originalCheckList: checkList,
                plants: this.plants
            }, this.$modal);
            result.then(function (data) {
                if (!data) {
                    return;
                }
                var checkList = _.assign({}, data);
                var item = checkListOverride_module_1.default.extendCheckList(checkList, _this.checkLists, _this.plants, _this.allShops, _this.locations, _this.wareClasses, _this.plant.id, _this.shop.id, _this.job ? _this.job.id : null, _this.authDataService);
                _this.checkLists.push(item);
            });
        };
        CheckListsCtrl.prototype.deleteCheckList = function (checkList) {
            var _this = this;
            this.uiUtilityService.confirm('Delete checklist?').then(function (result) {
                if (result) {
                    _this.loaderService.loadingPromise(_this.checkListsService.deleteCheckList(checkList.id).then(function () {
                        _.remove(_this.checkLists, checkList);
                    }, _this.notifyService.handleApiErrors));
                }
            });
        };
        CheckListsCtrl.prototype.saveOverride = function (cmd, checkList) {
            var _this = this;
            var idx = _.findIndex(checkList.overrides, { plantId: cmd.plantId, shopId: cmd.shopId, jobId: cmd.jobId });
            var successAction = function () {
                if (checkList.overrides === null) {
                    checkList.overrides = [];
                }
                if (idx >= 0) {
                    var override = checkList.overrides[idx];
                    override.isMandatory = cmd.isMandatory;
                    override.isDisabled = cmd.isDisabled;
                    override.roleId = cmd.roleId;
                }
                else {
                    checkList.overrides.push({
                        id: null,
                        checkListId: checkList.id,
                        plantId: cmd.plantId,
                        shopId: cmd.shopId,
                        jobId: cmd.jobId,
                        roleId: cmd.roleId,
                        isMandatory: cmd.isMandatory,
                        isDisabled: cmd.isDisabled
                    });
                }
                checkListOverride_module_1.default.setOverrideValue(checkList, cmd.plantId, cmd.shopId, cmd.jobId, _this.authDataService);
            };
            this.loaderService.loadingPromise(this.checkListsService.saveOverride(cmd).then(successAction, this.notifyService.handleApiErrors));
        };
        CheckListsCtrl.prototype.toggleOverride = function (checkList) {
            var plantId = checkList.plantId || this.plant.id;
            var shopId = checkList.shopId || this.shop.id;
            var jobId = this.job ? this.job.id : null;
            var override = _.find(checkList.overrides, { plantId: plantId, shopId: shopId, jobId: jobId });
            var cmd = {
                checkListId: checkList.id,
                plantId: plantId,
                shopId: shopId,
                jobId: jobId,
                roleId: override ? override.roleId : null,
                isMandatory: checkList.isMandatory || false,
                isDisabled: checkList.isMandatory ? false : checkList.isDisabled
            };
            checkList.isDisabled = cmd.isDisabled;
            this.saveOverride(cmd, checkList);
        };
        return CheckListsCtrl;
    }());
    exports.CheckListsCtrl = CheckListsCtrl;
    exports.default = angular.module('aps.controller.checkLists', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.CHECKLISTS,
            url: '/admin/checkLists',
            controller: 'CheckListsCtrl as vm',
            template: checkLists_tpl_html_1.default,
            data: {
                pageTitle: 'Check Lists',
                authorizePlantAdmin: true,
                v2Uri: 'aps/settings/check-lists'
            }
        });
    }])
        .controller('CheckListsCtrl', CheckListsCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w ng-if=vm.checkLists> <div class=body-header> <h2> Check Lists </h2> </div> <div class=row style=margin-left:-30px> <div class=\"large-2 columns\"> <label>Level: <select name=level ng-model=vm.level ng-change=vm.levelChanged() ng-options=\"x.value as x.text for x in vm.levels\"> </select> </label> </div> <div class=\"large-2 columns\"> <label>Plant: <select name=plant ng-model=vm.plant ng-change=vm.plantChanged() ng-options=\"plant.name for plant in vm.plants\"> </select> </label> </div> <div class=\"large-2 columns\"> <label>Shop: <select name=shop ng-model=vm.shop ng-change=vm.shopChanged() ng-options=\"shop.name for shop in vm.shops\"> </select> </label> </div> <div class=\"large-2 columns\"> <label>Ware Class: <select name=wareclass ng-model=vm.wareClass ng-options=\"wareClass.name for wareClass in vm.wareClasses\"> </select> </label> </div> <div class=\"large-2 columns\"> <label>Job: <span ng-if=vm.job ng-click=vm.clearJob() style=color:#8b0000>(clear)</span> <input name=job type=text ng-model=vm.jobName ng-select=vm.jobNameChanged() typeahead-on-select=vm.jobNameChanged() typeahead=\"job.name for job in vm.jobs | filter:$viewValue | limitTo:8\" autofill=off autocomplete=off /> </label> </div> <!--<div class=\"large-3 columns\">--> <!--<label>Sort By:--> <!--<select name=\"orderBy\" ng-model=\"vm.orderBy\">--> <!--<option value=\"name\">TOP Title</option>--> <!--<option value=\"department\">Department</option>--> <!--<option value=\"pasType\">PAS Type</option>--> <!--<option value=\"topNumber\">TOP Number</option>--> <!--</select>--> <!--</label>--> <!--</div>--> <div class=\"large-2 columns\"> <a href=\"\" class=\"button small right\" ng-if=vm.canAddCheckList() ng-click=vm.addCheckList() style=\"margin:15px 0 0 0\">Add Check List</a> </div> </div> <div class=row style=margin-left:-30px> <div class=\"large-2 columns\"> <label>Department: <select name=department ng-model=vm.department ng-options=\"x for x in vm.departments | orderBy\"> <option value=\"\">All</option> </select> </label> </div> <div class=\"large-2 columns\"> <label>PAS Type: <select name=pasType ng-model=vm.pasType ng-options=\"x for x in vm.pasTypes | orderBy\"> <option value=\"\">All</option> </select> </label> </div> <div class=\"large-2 columns\"> <label>TOP Number: <input type=text name=topNumber ng-model=vm.topNumber maxlength=4 /> </label> </div> <div class=\"large-6 columns\"> <label>TOP Title: <input type=text name=name ng-model=vm.name /> </label> </div> </div></div> <table class=\"history-t cltable\"> <tr> <thead> <th width=10%>Classification</th> <th width=30%>TOP Title</th> <th width=10%>Plant</th> <th width=10%>Shop</th> <th>Ware&nbsp;Class</th> <th>Location</th> <th>Group</th> <th width=7%>Mandatory</th> <th width=7%>Disabled</th> <th width=20%>&nbsp;</th> </thead> </tr> <tr ng-repeat=\"checkList in vm.checkLists_filtered() | orderBy: vm.orderBy \"> <td> {{ checkList.department }} {{ checkList.pasType }} {{ checkList.topNumber }} </td> <td>{{ checkList.name }}</td> <td>{{ checkList.plantName }}</td> <td>{{ checkList.shopName }}</td> <td>{{ checkList.wareClass }}</td> <td>{{ checkList.locationName }}</td> <td>{{ checkList.checkListGroupName }}</td> <td> <input type=checkbox ng-model=checkList.isMandatory ng-click=vm.toggleOverride(checkList) ng-disabled=!checkList.canChangeMandatory /> </td> <td> <input type=checkbox ng-model=checkList.isDisabled ng-click=vm.toggleOverride(checkList) ng-disabled=!checkList.canChangeDisabled /> </td> <td> <button class=\"button tiny\" ng-click=vm.openCheckList(checkList) style=margin:0>Open</button> <button ng-if=checkList.canCopy class=\"button tiny\" ng-click=vm.copyCheckList(checkList) style=margin:0>Copy</button> <butfton ng-if=checkList.canEdit class=\"button tiny alert\" ng-click=vm.deleteCheckList(checkList) style=margin:0>Delete</butfton> </td> </tr> <tr ng-if=\"vm.checkLists.length == 0\"> <td colspan=3> There are no check lists defined. </td> </tr> </table> ");

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(571), __webpack_require__(5), __webpack_require__(62), __webpack_require__(30), __webpack_require__(52), __webpack_require__(7), __webpack_require__(4), __webpack_require__(6), __webpack_require__(9), __webpack_require__(12), __webpack_require__(2), __webpack_require__(573), __webpack_require__(38), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, checkEditor_controller_1, aps_enums_1, checkListOverride_module_1, checkLists_service_1, user_service_1, authData_service_1, loader_service_1, notify_service_1, uiUtility_service_1, newguid_service_1, _, checkList_tpl_html_1, fillOutCheckList_controller_1, navigation_service_1) {
    "use strict";
    checkListCtrl.$inject = ["$modalInstance", "$modal", "data", "checkListsService", "userService", "navigationService", "authDataService", "loaderService", "notifyService", "uiUtilityService", "newGuidService", "$q"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [checkEditor_controller_1.default, checkLists_service_1.default, user_service_1.default, authData_service_1.default, loader_service_1.default,
        notify_service_1.default, uiUtility_service_1.default, newguid_service_1.default, fillOutCheckList_controller_1.default, navigation_service_1.default];
    function openEditCheckList(data, $modal) {
        return $modal.open({
            template: checkList_tpl_html_1.default,
            controller: 'CheckListCtrl as vm',
            resolve: {
                data: function () { return data; }
            }
        }).result;
    }
    exports.openEditCheckList = openEditCheckList;
    exports.default = angular.module('aps.controller.checkList', requires)
        .controller('CheckListCtrl', checkListCtrl)
        .name;
    function generateOffsets(count, unit, startPeriod, prefix) {
        prefix = prefix || '';
        return _.range(count).map(function (i) {
            var plural = i > 1 ? 's' : '';
            return {
                offset: i,
                description: i === 0 ? prefix + "at " + startPeriod : "" + prefix + i + " " + unit + plural + " after " + startPeriod
            };
        });
    }
    function getDay(day) {
        switch (day) {
            case 1:
                return '1st';
            case 2:
                return '2nd';
            case 3:
                return '3rd';
            case 21:
                return '21st';
            case 22:
                return '22nd';
            case 23:
                return '23rd';
        }
        return day + "th";
    }
    function getDayDescription(day) {
        return "on the " + getDay(day) + " of the month";
    }
    function checkListCtrl($modalInstance, $modal, data, checkListsService, userService, navigationService, authDataService, loaderService, notifyService, uiUtilityService, newGuidService, $q) {
        'use strict';
        var shopsAllSelection = checkListOverride_module_1.CheckListCommon.getAllShopsItem();
        var plantsAllSelection = checkListOverride_module_1.CheckListCommon.getAllPlantsItem();
        var vm = this;
        var reOrderChecks = function (checks) {
            _.each(checks, function (check) {
                check.isFirst = check.isLast = false;
            });
            checks[0].isFirst = true;
            checks[checks.length - 1].isLast = true;
        };
        var loadChecks = function (checks) {
            if (vm.checks.length > 0) {
                vm.checks = [];
            }
            _.sortBy(checks, 'order').forEach(function (check) {
                var checkItem = checkListOverride_module_1.default.extendCheckItem(check);
                vm.checks.push((checkItem));
            });
            if (vm.checks.length > 0) {
                vm.canBeGroup = false;
                vm.checks[0].isFirst = true;
                vm.checks[vm.checks.length - 1].isLast = true;
            }
            vm.reloadChecks();
        };
        vm.plants = [];
        vm.shops = [];
        vm.checks = [];
        vm.wareClasses = [];
        vm.jobs = data.jobs;
        vm.job = data.job;
        if (data.job) {
            vm.jobName = data.job.name;
            vm.jobId = data.job.id;
            vm.initialJobName = vm.jobName;
        }
        else {
            vm.jobName = null;
            vm.jobId = null;
            vm.initialJobName = null;
        }
        var existingSignOffs = [];
        vm.signOffRoleToAdd = undefined;
        vm.availableSignOffRoles = [];
        vm.signOffRoles = [];
        vm.canBeGroup = true;
        vm.isGroup = false;
        vm.canHaveRole = true;
        vm.canBeScheduled = true;
        vm.checkLists = data.checkLists;
        vm.childLists = [];
        vm.isShopLocation = true;
        vm.checksTabActive = false;
        vm.isGroupChanged = function () {
            vm.canHaveRole = !vm.isGroup;
            if (!vm.canHaveRole) {
                vm.role = null;
                vm.signOffRoles = [];
            }
        };
        vm.childAdded = function () {
            var childList = _.find(vm.checkLists, { name: vm.childName });
            if (!childList) {
                return;
            }
            vm.childName = null;
            vm.childLists.push(childList);
        };
        vm.removeChild = function (checkList) {
            _.remove(vm.childLists, checkList);
        };
        vm.frequencyChanged = function () {
            vm.frequencyOffsetSelection = vm.frequencySelection.offsets[0];
        };
        vm.wareClassChanged = function () {
            if (vm.wareClass.id) {
                restrictToShop();
            }
            else {
                unrestrictLocation();
            }
        };
        vm.frequencySelections = [
            { frequencyUnits: aps_enums_1.apsEnums.TimeUnits.Minutes, frequency: 30, name: 'Every 30 minutes', offsets: [{ offset: 0, description: '' }] },
            { frequencyUnits: aps_enums_1.apsEnums.TimeUnits.Hours, frequency: 1, name: 'Once per hour', offsets: [{ offset: 0, description: '' }] },
            { frequencyUnits: aps_enums_1.apsEnums.TimeUnits.Hours, frequency: 2, name: 'Every 2 hours', offsets: generateOffsets(2, 'hour', 'shift start', 'starting ') },
            { frequencyUnits: aps_enums_1.apsEnums.TimeUnits.Hours, frequency: 4, name: 'Every 4 hours', offsets: generateOffsets(4, 'hour', 'shift start', 'starting ') },
            { frequencyUnits: aps_enums_1.apsEnums.TimeUnits.Shift, frequency: 1, name: 'Once per shift', offsets: generateOffsets(8, 'hour', 'shift start') },
            { frequencyUnits: aps_enums_1.apsEnums.TimeUnits.Days, frequency: 1, name: 'Once per day', offsets: generateOffsets(24, 'hour', 'the start of the first shift') },
            { frequencyUnits: aps_enums_1.apsEnums.TimeUnits.Weeks, frequency: 1, name: 'Once per week', offsets: [{
                        offset: 0, description: 'on Sunday'
                    }, {
                        offset: 1, description: 'on Monday'
                    }, {
                        offset: 2, description: 'on Tuesday'
                    }, {
                        offset: 3, description: 'on Wednesday'
                    }, {
                        offset: 4, description: 'on Thursday'
                    }, {
                        offset: 5, description: 'on Friday'
                    }, {
                        offset: 6, description: 'on Saturday'
                    }] },
            { frequencyUnits: aps_enums_1.apsEnums.TimeUnits.Months, frequency: 1, name: 'Once per month', offsets: _.range(0, 28).map(function (day) {
                    return {
                        offset: day,
                        description: getDayDescription(day + 1)
                    };
                }) },
        ];
        vm.frequencySelection = _.first(vm.frequencySelections);
        vm.frequencyChanged();
        var promises = [];
        vm.jobNameChanged = function () {
            vm.job = _.find(vm.jobs, { name: vm.jobName });
            vm.reloadChecks();
        };
        vm.clearJob = function () {
            if (!vm.job) {
                return;
            }
            vm.job = null;
            vm.jobName = null;
            vm.reloadChecks();
        };
        vm.reloadChecks = function () {
            var plantId = vm.checkPlant.id;
            var shopId = null;
            var jobId = vm.job ? vm.job.id : null;
            if (plantId && vm.checkShop && vm.checkShop.plantId === plantId) {
                shopId = vm.checkShop.id;
            }
            else {
                vm.checkShop = shopsAllSelection;
            }
            checkListOverride_module_1.default.setOverrideValues(vm.checks, plantId, shopId, jobId, authDataService);
        };
        var saveOverride = function (check, isMandatory, isDisabled) {
            var plantId = vm.checkPlant.id;
            var shopId = vm.checkShop.id;
            var jobId = vm.job ? vm.job.id : null;
            var override = _.find(check.overrides, { plantId: plantId, shopId: shopId, jobId: jobId });
            checkListsService.saveCheckOverride({
                checkId: check.id,
                checkListId: vm.id,
                plantId: plantId,
                shopId: shopId,
                jobId: jobId,
                isMandatory: isMandatory,
                isDisabled: isDisabled
            }).then(function () {
                if (!override) {
                    override = {
                        id: _.uniqueId('checkOverride'),
                        checkId: check.id,
                        plantId: plantId,
                        shopId: shopId,
                        jobId: jobId,
                        isMandatory: isMandatory,
                        isDisabled: isDisabled
                    };
                    check.overrides.push(override);
                }
                else {
                    override.isMandatory = isMandatory;
                    override.isDisabled = isDisabled;
                }
                vm.reloadChecks();
            });
        };
        vm.toggleMandatory = function (check) {
            saveOverride(check, check.isMandatory, false);
        };
        vm.toggleDisabled = function (check) {
            saveOverride(check, false, check.isDisabled);
        };
        var loadSignOffs = function () {
            vm.signOffRoles = [];
            _.each(vm.roles, function (role) {
                var r = {
                    id: role.id,
                    name: role.name
                };
                var existing = _.find(existingSignOffs, { 'roleId': role.id });
                if (existing) {
                    r.failuresOnly = existing.failuresOnly;
                    vm.signOffRoles.push(r);
                }
                else {
                    r.failuresOnly = false;
                    vm.availableSignOffRoles.push(r);
                }
            });
        };
        var rolesPromise = userService.getRoles().then(function (roles) {
            vm.roles = roles;
            loadSignOffs();
        });
        vm.availableRoles = function () {
            var roles = [];
            if (!vm.roles) {
                return roles;
            }
            _.forEach(vm.roles, function (role) {
                if (vm.role === role || _.includes(vm.allowedRoles, role.id)) {
                    return;
                }
                roles.push(role);
            });
            return roles;
        };
        promises.push(rolesPromise);
        vm.plants = data.plants;
        vm.shops = data.shops;
        vm.plant = data.plant;
        vm.shop = data.shop;
        vm.wareClasses = data.wareClasses;
        vm.wareClass = data.wareClass;
        vm.checkPlant = data.plant;
        vm.checkShop = data.shop;
        vm.checkShops = data.shops;
        vm.locations = data.locations;
        vm.allLocationTypes = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.LocationType, 1);
        vm.locationTypes = vm.allLocationTypes;
        vm.departments = data.departments;
        vm.pasTypes = data.pasTypes;
        vm.isOther = function () {
            return vm.locationType && vm.locationType.value === aps_enums_1.apsEnums.LocationType.Other;
        };
        vm.locationType = _.find(vm.allLocationTypes, { value: aps_enums_1.apsEnums.LocationType.Shop });
        var restrictToShop = function () {
            vm.locationTypes = _.filter(vm.allLocationTypes, { value: aps_enums_1.apsEnums.LocationType.Shop });
            if (vm.locationType.value !== aps_enums_1.apsEnums.LocationType.Shop) {
                vm.locationType = vm.locationTypes[0];
                vm.locationTypeChanged();
            }
        };
        var unrestrictLocation = function () {
            if ((vm.shop && vm.shop.id) || (vm.wareClass && vm.wareClass.id)) {
                return;
            }
            vm.locationTypes = vm.allLocationTypes;
        };
        var switchToEditMode = function () {
            vm.isNew = false;
            vm.checksTabActive = true;
        };
        if (data.mode === 'add') {
            vm.isNew = true;
            vm.isReadOnly = false;
            vm.name = '';
            vm.description = '';
            vm.department = '';
            vm.pasType = '';
            vm.topNumber = '';
            vm.isScheduled = false;
            vm.role = null;
            vm.allowedRoles = [];
            newGuidService.getNewGuid('checkList').then(function (id) { return vm.id = id; });
            vm.requiresSignOff = false;
            vm.availableSignOffRoles = [];
            vm.signOffRoles = [];
            if ((data.shop && data.shop.id)
                || (data.wareClass && data.wareClass.id)) {
                restrictToShop();
            }
            loadSignOffs();
        }
        else {
            vm.isNew = false;
            vm.isReadOnly = data.mode === 'view';
            vm.id = data.id;
            vm.checkListGroupName = data.checkListGroupName;
            vm.childLists = _.filter(data.checkLists, { checkListGroupId: vm.id });
            promises.push(checkListsService.getCheckList(data.id).then(function (checkList) {
                vm.name = checkList.name;
                vm.description = checkList.description;
                vm.department = checkList.department;
                vm.pasType = checkList.pasType;
                vm.topNumber = checkList.topNumber;
                vm.isScheduled = checkList.isScheduled;
                vm.allowedRoles = checkList.allowedRoles;
                if (checkList.isScheduled) {
                    vm.frequencySelection = _.find(vm.frequencySelections, {
                        frequency: checkList.frequency,
                        frequencyUnits: checkList.frequencyUnits
                    });
                    vm.frequencyOffsetSelection = vm.frequencySelection
                        ? _.find(vm.frequencySelection.offsets, { offset: checkList.frequencyOffset || 0 })
                        : null;
                }
                vm.isGroup = checkList.isGroup;
                vm.canBeGroup = (checkList.checkListGroupId === null);
                vm.canBeScheduled = vm.canBeGroup;
                vm.canHaveRole = !vm.isGroup;
                vm.isShopLocation = checkList.locationType === aps_enums_1.apsEnums.LocationType.Shop;
                if (checkList.shopId
                    || checkList.wareClassId
                    || _.some(checkList.checks, function (c) { return c.entry !== aps_enums_1.apsEnums.CheckEntry.PerShop; })) {
                    restrictToShop();
                }
                var locationType = _.find(vm.locationTypes, { value: checkList.locationType });
                if (locationType) {
                    vm.locationType = locationType;
                    if (checkList.locationType === aps_enums_1.apsEnums.LocationType.Other) {
                        vm.location = _.find(vm.locations, { id: checkList.locationId });
                    }
                }
                rolesPromise.then(function () {
                    vm.role = _.find(vm.roles, { id: checkList.roleId });
                    if (vm.plant.id) {
                        vm.override = _.find(checkList.overrides, {
                            plantId: vm.plant.id,
                            shopId: vm.shop.id
                        });
                        if (vm.override) {
                            vm.overrideRole = _.find(vm.roles, { id: vm.override.roleId });
                        }
                        else if (!vm.shop.id) {
                            vm.override = _.find(checkList.overrides, {
                                plantId: vm.plant.id,
                                shopId: null
                            });
                            if (vm.override) {
                                vm.overrideRole = _.find(vm.roles, { id: vm.override.roleId });
                            }
                        }
                    }
                });
                vm.requiresSignOff = checkList.signOffs && checkList.signOffs.length > 0;
                vm.availableSignOffRoles = [];
                if (!vm.isReadOnly) {
                    if ((!checkList.plantId && vm.plant.id)
                        || (!checkList.shopId && vm.shop.id)
                        || (checkList.plantId && checkList.plantId !== vm.plant.id)
                        || (checkList.shopId && checkList.shopId !== vm.shop.id)) {
                        vm.isReadOnly = true;
                    }
                }
                existingSignOffs = checkList.signOffs || [];
                vm.signOffRoles = [];
                loadSignOffs();
                loadChecks(checkList.checks);
            }));
        }
        vm.canOverrideRole = function () {
            return vm.plant.id && authDataService.isPlantAdmin(vm.plant.id);
        };
        loaderService.loadingPromise($q.all(promises));
        vm.shops_filtered = function () {
            return _.filter(vm.shops, function (shop) {
                return vm.plant && shop.plantId === vm.plant.id;
            });
        };
        vm.plantShops = function () {
            if (vm.checkPlant === plantsAllSelection) {
                return [shopsAllSelection];
            }
            if (vm.checkShops.length > 0) {
                return vm.checkShops;
            }
            return [shopsAllSelection].concat(vm.checkPlant.shops);
        };
        var addSignOffs = function (command) {
            var signOffs = [];
            if (vm.requiresSignOff) {
                _.each(vm.signOffRoles, function (role) {
                    var existing = _.find(existingSignOffs, { 'roleId': role.id });
                    if (existing) {
                        signOffs.push(existing);
                    }
                    else {
                        signOffs.push({ id: '', roleId: role.id, failuresOnly: role.failuresOnly });
                    }
                });
                command.signOffs = signOffs;
                command.requiresSignOff = signOffs.length > 0;
            }
            else {
                command.signOffs = undefined;
                command.requiresSignOff = false;
            }
        };
        function childListsInvalid() {
            return vm.isGroup && vm.childLists.length === 0;
        }
        function getChildListIds() {
            var ids = [];
            _.forEach(vm.childLists, function (c) { return ids.push({ id: c.id }); });
            return ids;
        }
        vm.locationTypeChanged = function () {
            if (vm.locationType.value !== aps_enums_1.apsEnums.LocationType.Other) {
                vm.location = undefined;
            }
            vm.isShopLocation = vm.locationType.value === aps_enums_1.apsEnums.LocationType.Shop;
        };
        vm.addCheckList = function () {
            if (vm.checkListForm.$invalid || childListsInvalid()) {
                return;
            }
            var command = {
                id: vm.id,
                name: vm.name,
                description: vm.description,
                department: vm.department,
                pasType: vm.pasType,
                topNumber: vm.topNumber ? ('0000' + vm.topNumber).slice(-4) : null,
                plantId: vm.plant ? vm.plant.id : null,
                shopId: vm.shop ? vm.shop.id : null,
                roleId: vm.role ? vm.role.id : null,
                locationType: vm.locationType ? vm.locationType.value : null,
                locationId: vm.location ? vm.location.id : null,
                wareClassId: vm.wareClass.id,
                isScheduled: vm.isScheduled,
                frequency: null,
                frequencyUnits: null,
                frequencyOffset: null,
                isGroup: vm.isGroup,
                childCheckLists: getChildListIds(),
                allowedRoles: vm.allowedRoles,
                requiresSignOff: vm.requiresSignOff,
                signOffs: []
            };
            addSignOffs(command);
            if (command.isScheduled) {
                command.frequency = vm.frequencySelection.frequency;
                command.frequencyUnits = vm.frequencySelection.frequencyUnits;
                command.frequencyOffset = vm.frequencyOffsetSelection.offset;
            }
            loaderService.loadingPromise(checkListsService.addCheckList(command)
                .then(function () {
                if (data.onAdd) {
                    data.onAdd(command);
                }
                if (vm.isGroup) {
                    $modalInstance.close();
                }
                else {
                    switchToEditMode();
                }
            }, notifyService.handleApiErrors));
        };
        vm.saveCheckList = function () {
            if (vm.isNew) {
                vm.addCheckList();
                return;
            }
            if (vm.checkListForm.$invalid || childListsInvalid()) {
                return;
            }
            var command = {
                id: vm.id,
                name: vm.name,
                description: vm.description,
                department: vm.department,
                pasType: vm.pasType,
                topNumber: vm.topNumber ? ('0000' + vm.topNumber).slice(-4) : null,
                roleId: vm.role ? vm.role.id : null,
                locationType: vm.locationType ? vm.locationType.value : null,
                locationId: vm.location ? vm.location.id : null,
                wareClassId: vm.wareClass.id,
                isScheduled: vm.isScheduled,
                frequency: null,
                frequencyUnits: null,
                frequencyOffset: null,
                isGroup: vm.isGroup,
                childCheckLists: getChildListIds(),
                allowedRoles: vm.allowedRoles,
                requiresSignOff: vm.requiresSignOff,
                signOffs: []
            };
            addSignOffs(command);
            if (command.isScheduled) {
                command.frequency = vm.frequencySelection.frequency;
                command.frequencyUnits = vm.frequencySelection.frequencyUnits;
                command.frequencyOffset = vm.frequencyOffsetSelection.offset;
            }
            loaderService.loadingPromise(checkListsService.saveCheckList(command)
                .then(function () {
                $modalInstance.close({ action: 'save', data: command });
            }, notifyService.handleApiErrors));
        };
        vm.cancel = function () {
            $modalInstance.close();
        };
        var launchCheckEditor = function (check) {
            var addingCheck = (!check);
            var headings = _.uniq(_.map(vm.checks, 'heading')).sort();
            var result = checkEditor_controller_1.openCheckEditor({
                checkListId: vm.id,
                checkList: vm,
                check: check,
                checks: vm.checks,
                headings: headings,
                isReadOnly: vm.isReadOnly,
                isShopCheckList: vm.locationType && vm.locationType.value === aps_enums_1.apsEnums.LocationType.Shop
            }, $modal);
            result.then(function (data) {
                if (!data) {
                    return;
                }
                if (check) {
                    data.overrides = check.overrides;
                }
                var checkData = checkListOverride_module_1.default.extendCheckItem(data);
                if (addingCheck) {
                    checkData.order = (vm.checks.length > 0) ?
                        _.max(_.map(vm.checks, 'order')) + 1 : 0;
                    vm.checks.push(checkData);
                }
                else {
                    var index = vm.checks.indexOf(check);
                    if (index > -1) {
                        vm.checks[index] = _.assign(checkData, {
                            isFirst: check.isFirst,
                            isLast: check.isLast
                        });
                    }
                }
                if (data.entry !== aps_enums_1.apsEnums.CheckEntry.PerShop) {
                    restrictToShop();
                }
                reOrderChecks(vm.checks);
                vm.reloadChecks();
            });
        };
        vm.addCheck = function () {
            launchCheckEditor();
        };
        vm.openCheck = function (check) {
            launchCheckEditor(check);
        };
        vm.deleteCheck = function (check) {
            uiUtilityService.confirm('Delete the check: ' + check.name).then(function (result) {
                if (result) {
                    loaderService.loadingPromise(checkListsService.deleteCheck({
                        id: check.id,
                        checkListId: vm.id
                    })
                        .then(function () {
                        _.remove(vm.checks, check);
                        reOrderChecks(vm.checks);
                    }, notifyService.handleApiErrors));
                }
            });
        };
        vm.previewChecklist = function () {
            navigationService.getNavigation().then(function (nav) {
                var plantId = nav.selectedPlant.id;
                var shopId = nav.selectedShop.id;
                if (vm.checkShop && vm.checkShop.id) {
                    shopId = vm.checkShop.id;
                    plantId = vm.checkShop.plantId;
                }
                else if (vm.checkPlant && vm.checkPlant.id) {
                    var plant = nav.plants().filter(function (x) { return x.id === vm.checkPlant.id; })[0];
                    var shop = plant.shops[0];
                    shopId = shop.id;
                    plantId = plant.id;
                }
                fillOutCheckList_controller_1.openFillOutCheckList({
                    checkListId: vm.id,
                    plantId: plantId,
                    tankId: null,
                    shopId: shopId,
                    instanceId: null,
                    plantLocationId: null,
                    preview: true
                }, $modal);
            });
        };
        vm.shopDisplayName = function () {
            return vm.shop ? vm.shop.name : 'All';
        };
        vm.plantDisplayName = function () {
            return vm.plant ? vm.plant.name : 'All';
        };
        vm.addSignOffRole = function () {
            if (vm.signOffRoleToAdd) {
                _.remove(vm.availableSignOffRoles, { 'id': vm.signOffRoleToAdd.id });
                vm.signOffRoles.push(vm.signOffRoleToAdd);
            }
            vm.signOffRoleToAdd = undefined;
        };
        vm.removeSignOffRole = function (role) {
            _.remove(vm.signOffRoles, { 'id': role.id });
            vm.availableSignOffRoles.push(role);
        };
        vm.addAllowedRole = function () {
            if (!vm.roleToAdd) {
                return;
            }
            vm.allowedRoles.push(vm.roleToAdd.id);
        };
        vm.removeAllowedRole = function (roleId) {
            _.remove(vm.allowedRoles, function (r) { return r === roleId; });
        };
        vm.getRoleName = function (roleId) {
            var role = _.find(vm.roles, { id: roleId });
            if (role) {
                return role.name;
            }
            return '';
        };
        vm.availableChildLists = function () {
            return _.filter(vm.checkLists, function (c) {
                return !_.some(vm.childLists, { id: c.id });
            });
        };
        vm.overrideRoles = function () {
            if (vm.role) {
                return _.filter(vm.roles, function (r) { return r.id !== vm.role.id; });
            }
            return [];
        };
        vm.saveRoleOverride = function () {
            if ((vm.override && vm.overrideRole && vm.override.roleId === vm.overrideRole.id)
                || (!vm.override && !vm.overrideRole)) {
                vm.cancel();
            }
            var cmd = {
                checkListId: vm.id,
                plantId: vm.plant.id,
                shopId: vm.shop.id,
                jobId: vm.jobId,
                roleId: vm.overrideRole ? vm.overrideRole.id : null,
                isMandatory: vm.override ? vm.override.isMandatory : false,
                isDisabled: vm.override ? vm.override.isDisabled : false
            };
            loaderService.loadingPromise(checkListsService.saveOverride(cmd).then(function () {
                $modalInstance.close({ action: 'override', data: cmd });
            }, notifyService.handleApiErrors));
        };
        vm.dragDropListeners = {
            orderChanged: function (event) {
                if (vm.isReadOnly) {
                    return;
                }
                loaderService.loadingPromise(checkListsService.reorderCheck({
                    checkListId: vm.id,
                    fromIndex: event.source.index,
                    toIndex: event.dest.index
                }));
            }
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(5), __webpack_require__(9), __webpack_require__(30), __webpack_require__(6), __webpack_require__(4), __webpack_require__(12), __webpack_require__(2), __webpack_require__(572)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, aps_enums_1, uiUtility_service_1, checkLists_service_1, notify_service_1, loader_service_1, newguid_service_1, _, checkEditor_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [uiUtility_service_1.default, checkLists_service_1.default, notify_service_1.default, loader_service_1.default, newguid_service_1.default];
    function openCheckEditor(data, $modal) {
        return $modal.open({
            template: checkEditor_tpl_html_1.default,
            controller: 'CheckEditorCtrl as vm',
            resolve: {
                data: function () { return data; }
            }
        }).result;
    }
    exports.openCheckEditor = openCheckEditor;
    var CheckEditorController = (function () {
        CheckEditorController.$inject = ["$modalInstance", "checkListsService", "data", "notifyService", "loaderService", "uiUtilityService", "newGuidService"];
        function CheckEditorController($modalInstance, checkListsService, data, notifyService, loaderService, uiUtilityService, newGuidService) {
            var _this = this;
            this.$modalInst = $modalInstance;
            this.checkListsService = checkListsService;
            this.notifyService = notifyService;
            this.loaderService = loaderService;
            this.newGuidService = newGuidService;
            this.headings = data.headings;
            this.isNew = !data.check;
            this.isReadOnly = data.isReadOnly;
            this.isShopCheckList = data.isShopCheckList;
            this.data = data;
            this.checkList = data.checkList;
            this.checkDataTypes = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.CheckDataType, 1);
            this.checkEntryTypes = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.CheckEntry, 1);
            this.aggregateFunctions = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.AggregateFunction, 1);
            this.defaultOutcomes = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.CheckStatus, 1);
            this.metaDatas = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.CheckMetaData, 1);
            this.valueTypes = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.CheckValueType, 1);
            this.severities = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.Severity, 0);
            this.additionalDataTypes = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.CheckAdditionalData, 0);
            this.aggregateFrequencies = [{
                    text: "Start of Shift",
                    value: aps_enums_1.apsEnums.TimeUnits.Shift
                }, {
                    text: "Start of Day",
                    value: aps_enums_1.apsEnums.TimeUnits.Days
                }];
            this.rangeChecks = data.checks.filter(function (x) { return x.valueType === aps_enums_1.apsEnums.CheckValueType.Range; });
            if (data.check) {
                this.rangeChecks = this.rangeChecks.filter(function (x) { return x.id !== data.check.id; });
            }
            this.aggregateCheck = null;
            this.passFailRangeCheck = null;
            if (this.isNew) {
                this.editedCheck = {
                    id: '',
                    checkListId: data.checkListId,
                    name: '',
                    heading: '',
                    description: '',
                    dataType: undefined,
                    defaultOutcome: aps_enums_1.apsEnums.CheckStatus.NotDone,
                    allowComments: true,
                    numberOfDecimalPlaces: undefined,
                    entry: aps_enums_1.apsEnums.CheckEntry.PerShop,
                    choices: [],
                    rangeMin: undefined,
                    rangeMax: undefined,
                    frequencyFail: undefined,
                    frequencyTotal: undefined,
                    prepopulate: false,
                    trueText: 'Yes',
                    falseText: 'No',
                    trueAdditionalData: null,
                    falseAdditionalData: null,
                    booleanPass: null,
                    aggregatesCount: null,
                    aggregateFunction: null,
                    metaData: null,
                    allowNotApplicable: false,
                    valueType: aps_enums_1.apsEnums.CheckValueType.Single,
                    dimensions: [],
                    aggregateCheckId: null,
                    aggregateFrequencyUnits: null,
                    passFailRangeCheckId: null,
                    defectTypeSeverity: null
                };
                this.newGuidService.getNewGuid('check')
                    .then(function (newGuid) {
                    _this.editedCheck.id = newGuid;
                });
            }
            else {
                this.editedCheck = _.clone(data.check);
                this.editedCheck.choices = data.check.choices.concat();
                if (this.editedCheck.aggregatesCount === 0) {
                    this.editedCheck.aggregatesCount = 1;
                }
                if (this.editedCheck.aggregateCheckId) {
                    this.aggregateCheck = _.find(this.data.checks, function (x) { return x.id === _this.editedCheck.aggregateCheckId; });
                    if (!this.aggregateCheck) {
                        this.editedCheck.aggregateCheckId = null;
                    }
                }
                if (this.editedCheck.passFailRangeCheckId) {
                    this.passFailRangeCheck = _.find(this.rangeChecks, function (x) { return x.id === _this.editedCheck.passFailRangeCheckId; });
                    if (this.passFailRangeCheck) {
                        this.usePassFailRange = true;
                    }
                    else {
                        this.editedCheck.passFailRangeCheckId = null;
                    }
                }
            }
        }
        CheckEditorController.prototype.getAggregateChecks = function () {
            var _this = this;
            var checks = this.editedCheck.aggregateFunction === aps_enums_1.apsEnums.AggregateFunction.Cumulation
                ? this.data.checks.filter(function (x) { return x.aggregateFunction === null; })
                : this.data.checks.filter(function (x) { return x.entry !== aps_enums_1.apsEnums.CheckEntry.PerShop; });
            if (!this.isNew) {
                checks = checks.filter(function (x) { return x.id !== _this.editedCheck.id; });
            }
            return checks;
        };
        CheckEditorController.prototype.aggregateFunctionChanged = function () {
            if (this.editedCheck.aggregateFunction === aps_enums_1.apsEnums.AggregateFunction.Cumulation) {
                return;
            }
            this.editedCheck.aggregateFrequencyUnits = null;
        };
        CheckEditorController.prototype.getAggregateFunctions = function () {
            var functions = this.aggregateFunctions;
            if (!this.checkList.isScheduled
                || !this.checkList.frequencySelection
                || this.checkList.frequencySelection.frequencyUnits !== aps_enums_1.apsEnums.TimeUnits.Hours) {
                functions = functions.filter(function (x) {
                    return x.value !== aps_enums_1.apsEnums.AggregateFunction.Cumulation;
                });
            }
            if (!this.isShopCheckList) {
                functions = functions.filter(function (x) { return x.value === aps_enums_1.apsEnums.AggregateFunction.Cumulation; });
            }
            return functions;
        };
        CheckEditorController.prototype.hasAggregateFrequency = function () {
            return this.editedCheck.aggregateFunction === aps_enums_1.apsEnums.AggregateFunction.Cumulation;
        };
        CheckEditorController.prototype.getAggregateFrequencies = function () {
            return this.aggregateFrequencies;
        };
        CheckEditorController.prototype.getDefaultOutcomes = function () {
            if (this.editedCheck && this.editedCheck.allowNotApplicable) {
                return this.defaultOutcomes;
            }
            return _.filter(this.defaultOutcomes, function (vt) { return vt.value !== aps_enums_1.apsEnums.CheckStatus.NotApplicable; });
        };
        CheckEditorController.prototype.getDataTypes = function () {
            var dataTypes = this.checkDataTypes;
            if (this.editedCheck.valueType === aps_enums_1.apsEnums.CheckValueType.Range) {
                return dataTypes.filter(function (x) { return x.value === aps_enums_1.apsEnums.CheckDataType.Text; });
            }
            return dataTypes;
        };
        CheckEditorController.prototype.dataTypeChange = function () {
            if (this.editedCheck.dataType === aps_enums_1.apsEnums.CheckDataType.Percent) {
                if (!this.editedCheck.rangeMin) {
                    this.editedCheck.rangeMin = 0;
                }
                if (!this.editedCheck.rangeMax) {
                    this.editedCheck.rangeMax = 100;
                }
            }
            if (this.editedCheck.dataType !== aps_enums_1.apsEnums.CheckDataType.DefectType) {
                this.editedCheck.defectTypeSeverity = null;
            }
        };
        CheckEditorController.prototype.getValueTypes = function () {
            var valueTypes = this.valueTypes;
            if (!this.showAggregates()) {
                valueTypes = _.filter(valueTypes, function (vt) {
                    return vt.value !== aps_enums_1.apsEnums.CheckValueType.Sample
                        && vt.value !== aps_enums_1.apsEnums.CheckValueType.MultipleSample
                        && vt.value !== aps_enums_1.apsEnums.CheckValueType.Aggregate;
                });
            }
            else if (!this.isShopCheckList && (!this.checkList.isScheduled
                || !this.checkList.frequencySelection
                || this.checkList.frequencySelection.frequencyUnits !== aps_enums_1.apsEnums.TimeUnits.Hours)) {
                valueTypes = _.filter(valueTypes, function (vt) { return vt.value !== aps_enums_1.apsEnums.CheckValueType.Aggregate; });
            }
            return valueTypes;
        };
        CheckEditorController.prototype.valueTypeChange = function () {
            if (this.editedCheck.valueType !== aps_enums_1.apsEnums.CheckValueType.Sample
                && this.editedCheck.valueType !== aps_enums_1.apsEnums.CheckValueType.MultipleSample
                && this.editedCheck.valueType !== aps_enums_1.apsEnums.CheckValueType.Aggregate) {
                this.editedCheck.aggregateFunction = null;
            }
            if (this.editedCheck.valueType !== aps_enums_1.apsEnums.CheckValueType.Sample
                && this.editedCheck.valueType !== aps_enums_1.apsEnums.CheckValueType.MultipleSample) {
                this.editedCheck.aggregatesCount = null;
                this.editedCheck.dimensions = [];
            }
            if (this.editedCheck.valueType === aps_enums_1.apsEnums.CheckValueType.Multiple
                || this.editedCheck.valueType === aps_enums_1.apsEnums.CheckValueType.MultipleSample) {
                this.editedCheck.dimensions = [
                    { name: '', aggregateFunction: null },
                    { name: '', aggregateFunction: null }
                ];
            }
            if (this.editedCheck.valueType === aps_enums_1.apsEnums.CheckValueType.Range) {
                this.editedCheck.dataType = aps_enums_1.apsEnums.CheckDataType.Text;
                this.editedCheck.entry = aps_enums_1.apsEnums.CheckEntry.PerShop;
            }
        };
        CheckEditorController.prototype.getEntryTypes = function () {
            var entryTypes = this.checkEntryTypes;
            if (this.editedCheck.valueType === aps_enums_1.apsEnums.CheckValueType.Range) {
                return entryTypes.filter(function (x) { return x.value === aps_enums_1.apsEnums.CheckEntry.PerShop; });
            }
            if (this.editedCheck.valueType !== aps_enums_1.apsEnums.CheckValueType.Aggregate
                || !this.aggregateCheck) {
                return entryTypes;
            }
            switch (this.aggregateCheck.entry) {
                case aps_enums_1.apsEnums.CheckEntry.PerCavity:
                    return entryTypes.filter(function (x) { return x.value !== aps_enums_1.apsEnums.CheckEntry.PerCavity; });
                case aps_enums_1.apsEnums.CheckEntry.PerDrop:
                case aps_enums_1.apsEnums.CheckEntry.PerSection:
                    return entryTypes.filter(function (x) { return x.value === aps_enums_1.apsEnums.CheckEntry.PerMachine
                        || x.value === aps_enums_1.apsEnums.CheckEntry.PerShop; });
                default:
                    return entryTypes.filter(function (x) { return x.value === aps_enums_1.apsEnums.CheckEntry.PerShop; });
            }
        };
        CheckEditorController.prototype.aggregateCheckChange = function () {
            if (this.aggregateCheck) {
                this.editedCheck.aggregateCheckId = this.aggregateCheck.id;
            }
            else {
                this.editedCheck.aggregateCheckId = null;
            }
        };
        CheckEditorController.prototype.passFailRangeCheckChange = function () {
            if (this.passFailRangeCheck) {
                this.editedCheck.passFailRangeCheckId = this.passFailRangeCheck.id;
            }
            else {
                this.editedCheck.passFailRangeCheckId = null;
            }
        };
        CheckEditorController.prototype.showNumberOfDecimals = function () {
            return this.editedCheck.dataType === aps_enums_1.apsEnums.CheckDataType.Decimal || this.editedCheck.dataType === aps_enums_1.apsEnums.CheckDataType.Percent;
        };
        CheckEditorController.prototype.showRange = function () {
            return this.editedCheck.dataType === aps_enums_1.apsEnums.CheckDataType.Decimal
                || this.editedCheck.dataType === aps_enums_1.apsEnums.CheckDataType.Integer
                || this.editedCheck.dataType === aps_enums_1.apsEnums.CheckDataType.Percent;
        };
        CheckEditorController.prototype.showFrequency = function () {
            return this.editedCheck.dataType === aps_enums_1.apsEnums.CheckDataType.Count;
        };
        CheckEditorController.prototype.showAllowNA = function () {
            return this.editedCheck.dataType !== aps_enums_1.apsEnums.CheckDataType.Instructions;
        };
        CheckEditorController.prototype.checkChoiceType = function () {
            return this.showFixedValues()
                && this.editedCheck.dataType !== aps_enums_1.apsEnums.CheckDataType.Text
                ? 'number'
                : 'text';
        };
        CheckEditorController.prototype.showFixedValues = function () {
            return this.editedCheck.dataType === aps_enums_1.apsEnums.CheckDataType.Text
                || this.editedCheck.dataType === aps_enums_1.apsEnums.CheckDataType.Decimal
                || this.editedCheck.dataType === aps_enums_1.apsEnums.CheckDataType.Integer;
        };
        CheckEditorController.prototype.showAggregates = function () {
            return this.editedCheck.dataType === aps_enums_1.apsEnums.CheckDataType.Decimal
                || this.editedCheck.dataType === aps_enums_1.apsEnums.CheckDataType.Integer
                || this.editedCheck.dataType === aps_enums_1.apsEnums.CheckDataType.Percent;
        };
        CheckEditorController.prototype.choicesInvalid = function () {
            return this.showFixedValues() && this.editedCheck.choices.length === 1;
        };
        CheckEditorController.prototype.showDefaultToToday = function () {
            return this.editedCheck.dataType === aps_enums_1.apsEnums.CheckDataType.DateTime;
        };
        CheckEditorController.prototype.isInstructions = function () {
            return this.editedCheck.dataType === aps_enums_1.apsEnums.CheckDataType.Instructions;
        };
        CheckEditorController.prototype.isBoolean = function () {
            return this.editedCheck.dataType === aps_enums_1.apsEnums.CheckDataType.Boolean;
        };
        CheckEditorController.prototype.isSample = function () {
            return this.editedCheck.valueType === aps_enums_1.apsEnums.CheckValueType.Sample;
        };
        CheckEditorController.prototype.isAggregate = function () {
            return this.editedCheck.valueType === aps_enums_1.apsEnums.CheckValueType.Aggregate;
        };
        CheckEditorController.prototype.isMultiple = function () {
            return !this.isInstructions() && this.editedCheck.valueType === aps_enums_1.apsEnums.CheckValueType.Multiple;
        };
        CheckEditorController.prototype.isMultipleSample = function () {
            return this.editedCheck.valueType === aps_enums_1.apsEnums.CheckValueType.MultipleSample;
        };
        CheckEditorController.prototype.save = function () {
            var _this = this;
            if (this.form.$invalid || this.choicesInvalid()) {
                return;
            }
            var submit;
            if (this.isNew) {
                submit = this.checkListsService.addCheck;
            }
            else {
                submit = this.checkListsService.saveCheck;
            }
            var promise = submit(this.editedCheck).then(function () {
                _this.$modalInst.close(_this.editedCheck);
            }, this.notifyService.handleApiErrors);
            this.loaderService.loadingPromise(promise);
        };
        CheckEditorController.prototype.cancel = function () {
            this.$modalInst.close();
        };
        CheckEditorController.prototype.addChoice = function () {
            var choice = {
                id: undefined,
                value: ''
            };
            this.editedCheck.choices.push(choice);
            this.newGuidService.getNewGuid('checkChoice')
                .then(function (id) {
                choice.id = id;
            });
        };
        CheckEditorController.prototype.removeChoice = function (choice) {
            _.remove(this.editedCheck.choices, choice);
        };
        CheckEditorController.prototype.addDimension = function () {
            this.editedCheck.dimensions.push({ name: '', aggregateFunction: null });
        };
        CheckEditorController.prototype.removeDimension = function (index) {
            this.editedCheck.dimensions.splice(index, 1);
        };
        CheckEditorController.prototype.dimsInvalid = function () {
            return this.editedCheck.valueType === aps_enums_1.apsEnums.CheckValueType.Multiple && this.editedCheck.dimensions.length < 2;
        };
        return CheckEditorController;
    }());
    exports.default = angular.module('aps.controller.checkEditor', requires)
        .controller('CheckEditorCtrl', CheckEditorController)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <form name=vm.form ng-submit=vm.save() novalidate> <h2 class=modal-header ng-show=vm.isNew>Add a Check</h2> <h2 class=modal-header ng-hide=vm.isNew>Edit a Check</h2> <div class=container style=\"margin:0 -30px\"> <div class=row> <div class=\"small-12 columns\"> <label>Heading: <input name=checkHeading type=text ng-model=vm.editedCheck.heading typeahead=\"heading for heading in vm.headings | filter:$viewValue | limitTo:8\"/> </label> <div ng-messages=vm.form.checkHeading.$error ng-if=\"vm.form.checkHeading.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> </div> <div class=row> <div class=\"small-12 columns\"> <label>Name: <span style=color:red>*</span> <input name=checkName type=text ng-model=vm.editedCheck.name required/> </label> <div ng-messages=vm.form.checkName.$error ng-if=\"vm.form.checkName.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> </div> <div class=row> <div class=\"small-12 columns\"> <label>Description: <textarea rows=3 cols=60 name=description type=text ng-model=vm.editedCheck.description></textarea> </label> <div ng-messages=vm.form.description.$error ng-if=\"vm.form.description.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> </div> <!-- data Type, entry, default outcome  --> <div class=row> <div class=\"small-3 columns\"> <label>Data Type: <span style=color:red>*</span> <select name=checkDataType ng-model=vm.editedCheck.dataType ng-change=vm.dataTypeChange() ng-options=\"ct.value as ct.text for ct in vm.getDataTypes() | orderBy: 'text'\" required> <option value=\"\">-- Select a Data Type --</option> </select> </label> <div ng-messages=vm.form.checkDataType.$error ng-if=\"vm.form.checkDataType.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"small-3 columns\" ng-if=\"vm.isShopCheckList && !vm.isInstructions()\"> <label>Entry: <span style=color:red>*</span> <select name=checkEntryType ng-model=vm.editedCheck.entry ng-options=\"ct.value as ct.text for ct in vm.getEntryTypes()\" required> </select> </label> <div ng-messages=vm.form.checkEntryType.$error ng-if=\"vm.form.checkEntryType.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"small-3 columns\" ng-if=!vm.isInstructions()> <label>Default outcome: <select name=defaultOutcome ng-model=vm.editedCheck.defaultOutcome ng-options=\"ct.value as ct.text for ct in vm.getDefaultOutcomes()\"> </select> </label> <div ng-messages=vm.form.defaultOutcome.$error ng-if=\"vm.form.defaultOutcome.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"small-3 columns\" ng-if=!vm.isInstructions()> <label> Meta Data <select name=metaData ng-model=vm.editedCheck.metaData ng-options=\"md.value as md.text for md in vm.metaDatas | orderBy: 'text'\"> <option value=\"\">No Meta Data</option> </select> </label> </div> <div class=\"small-9 columns\" ng-if=vm.isInstructions()> &nbsp; </div> <div class=\"small-3 columns\" ng-if=\"!vm.isShopCheckList && !vm.isInstructions()\"> &nbsp; </div> </div> <!-- defect type: severity filter --> <div class=row ng-if=\"vm.editedCheck.dataType == 9\"> <div class=\"small-3 columns\"> <label>Defect Severity: <select name=defectTypeSeverity ng-model=vm.editedCheck.defectTypeSeverity ng-options=\"ct.value as ct.text for ct in vm.severities\"> <option value=\"\">All Severities</option> </select> </label> </div> <div class=\"small-9 columns\"> &nbsp; </div> </div> <!-- numeric: Range Min, Range Max, Decimal Places  --> <div class=row ng-if=vm.showRange()> <div class=\"small-3 columns\"> <label>Range Min: <input type=number name=rangeMin ng-model=vm.editedCheck.rangeMin max=\"{{vm.editedCheck.rangeMax || 1000000}}\" ng-required=\"vm.editedCheck.rangeMax || vm.editedCheck.rangeMax == 0\"/> </label> <div ng-messages=vm.form.rangeMin.$error ng-if=\"vm.form.rangeMin.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=max class=req-w><div class=arrow-up></div>May not be greater than Max</div> </div> </div> <div class=\"small-3 columns\"> <label>Range Max: <input type=number name=rangeMax ng-model=vm.editedCheck.rangeMax min=\"{{vm.editedCheck.rangeMin || -1000000}}\" ng-required=\"vm.editedCheck.rangeMin || vm.editedCheck.rangeMin == 0\"/> </label> <div ng-messages=vm.form.rangeMax.$error ng-if=\"vm.form.rangeMax.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>May not be less than Min</div> </div> </div> <div class=\"small-3 columns\" ng-if=vm.showNumberOfDecimals()> <label>Number of Decimals: <input type=number name=numberOfDecimalPlaces ng-model=vm.editedCheck.numberOfDecimalPlaces min=0 max=8 step=1 /> </label> <div ng-messages=vm.form.numberOfDecimalPlaces.$error ng-if=\"vm.form.numberOfDecimalPlaces.$dirty || vm.form.$submitted\" role=alert> <div ng-message=min class=req-w><div class=arrow-up></div>Must be 0 or more</div> <div ng-message=max class=req-w><div class=arrow-up></div>Must be 8 or less</div> <div ng-message=step class=req-w><div class=arrow-up></div>Must be an integer</div> </div> </div> <div class=\"small-3 columns\" ng-if=!vm.showNumberOfDecimals()> &nbsp; </div> </div> <div class=row ng-if=\"vm.rangeChecks.length > 0 && vm.showRange()\"> <div class=\"small-3 columns\"> <label> <br/> <input type=checkbox name=usePassFailRange ng-model=vm.usePassFailRange /> Use Pass/Fail Range </label> </div> <div class=\"small-9 columns\" ng-if=vm.usePassFailRange> <label>Pass/Fail Range Check: <span style=color:red>*</span> <select name=passFailRangeCheck ng-model=vm.passFailRangeCheck ng-options=\"ct as ct.name for ct in vm.rangeChecks\" ng-change=vm.passFailRangeCheckChange() required> <option value=\"\">-- Select a Check --</option> </select> </label> <div ng-messages=vm.form.passFailRangeCheck.$error ng-if=\"vm.form.passFailRangeCheck.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"small-9 columns\" ng-if=!vm.usePassFailRange> &nbsp; </div> </div> <!-- boolean: True vale, False value, N/A value, Passing value  --> <div class=row ng-if=vm.isBoolean()> <div class=\"small-3 columns\"> <label>True Value: <span style=color:red>*</span> <input type=text name=trueText ng-model=vm.editedCheck.trueText required/> </label> <div ng-messages=vm.form.trueText.$error ng-if=\"vm.form.trueText.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"small-3 columns\"> <label>False Value: <span style=color:red>*</span> <input type=text name=falseText ng-model=vm.editedCheck.falseText required/> </label> <div ng-messages=vm.form.falseText.$error ng-if=\"vm.form.falseText.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"small-3 columns\"> <label>Passing Value: <select ng-model=vm.editedCheck.booleanPass convert-to-boolean> <option value=\"\">No Default</option> <option value=true>{{ vm.editedCheck.trueText || 'True'}}</option> <option value=false>{{ vm.editedCheck.falseText || 'False'}}</option> </select> </label> </div> <div class=\"small-3 columns\"> &nbsp; </div> </div> <div class=row ng-if=vm.isBoolean()> <div class=\"small-3 columns\"> <label>True Additional Data: <span style=color:red>*</span> <select name=trueAdditionalData ng-model=vm.editedCheck.trueAdditionalData ng-options=\"x.value as x.text for x in vm.additionalDataTypes\" required> </select> </label> <div ng-messages=vm.form.trueAdditionalData.$error ng-if=\"vm.form.trueAdditionalData.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"small-3 columns\"> <label>False Additional Data: <span style=color:red>*</span> <select name=falseAdditionalData ng-model=vm.editedCheck.falseAdditionalData ng-options=\"x.value as x.text for x in vm.additionalDataTypes\" required> </select> </label> <div ng-messages=vm.form.falseAdditionalData.$error ng-if=\"vm.form.falseAdditionalData.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"small-6 columns\"> &nbsp; </div> </div> <!-- date: default to today  --> <div class=row ng-if=vm.showDefaultToToday()> <div class=\"small-3 columns\"> <label> <br/> <input type=checkbox name=defaultToToday ng-model=vm.editedCheck.prepopulate> Default to today </label> </div> <div class=\"small-3 columns\"> &nbsp; </div> <div class=\"small-3 columns\"> &nbsp; </div> <div class=\"small-3 columns\"> &nbsp; </div> </div> <!-- count: freq fail, freq total, default to total  --> <div class=row ng-if=vm.showFrequency()> <div class=\"small-3 columns\"> <label>Frequency (fail): <span style=color:red>*</span> <input type=number name=frequencyFail ng-model=vm.editedCheck.frequencyFail min=1 max=\"{{vm.editedCheck.frequencyTotal || 1000000}}\" required/> </label> <div ng-messages=vm.form.frequencyFail.$error ng-if=\"vm.form.frequencyFail.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be 1 or more</div> <div ng-message=max class=req-w><div class=arrow-up></div>May not be greater than total</div> </div> </div> <div class=\"small-3 columns\"> <label>Frequency (total): <span style=color:red>*</span> <input type=number name=frequencyTotal ng-model=vm.editedCheck.frequencyTotal min=\"{{vm.editedCheck.frequencyFail || 1}}\" required/> </label> <div ng-messages=vm.form.frequencyTotal.$error ng-if=\"vm.form.frequencyTotal.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>May not be less than fail</div> </div> </div> <div class=\"small-6 columns\"> <label> <br/> <input type=checkbox name=defaultToTotal ng-model=vm.editedCheck.prepopulate> Default to total value </label> </div> </div> <!-- aggregates: take multiple samples, samples count, aggregate --> <div class=row ng-if=!vm.isInstructions()> <div class=\"small-3 columns\"> <label>Value Type: <span style=color:red>*</span> <select name=valueType ng-model=vm.editedCheck.valueType ng-options=\"x.value as x.text for x in vm.getValueTypes()\" ng-change=vm.valueTypeChange() required> </select> </label> </div> <div class=\"small-3 columns\" ng-if=\"vm.isSample() || vm.isMultipleSample()\"> <label>Samples Count: <span style=color:red>*</span> <input type=number name=aggregatesCount ng-model=vm.editedCheck.aggregatesCount min=2 required/> </label> <div ng-messages=vm.form.aggregatesCount.$error ng-if=\"vm.form.aggregatesCount.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be more than 1</div> </div> </div> <div class=\"small-3 columns\" ng-if=\"vm.isSample() || vm.isAggregate()\"> <label>Aggregate Function: <span style=color:red>*</span> <select name=aggregateFunction ng-model=vm.editedCheck.aggregateFunction ng-options=\"ct.value as ct.text for ct in vm.getAggregateFunctions()\" required> <option value=\"\">-- Select an Aggregate --</option> </select> </label> <div ng-messages=vm.form.aggregateFunction.$error ng-if=\"vm.form.aggregateFunction.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"small-3 columns\" ng-if=vm.hasAggregateFrequency()> <label>Aggregate Frequency: <span style=color:red>*</span> <select name=aggregateFrequencyUnits ng-model=vm.editedCheck.aggregateFrequencyUnits ng-options=\"ct.value as ct.text for ct in vm.getAggregateFrequencies()\" required> <option value=\"\">-- Select a Frequency --</option> </select> </label> <div ng-messages=vm.form.aggregateFrequencyUnits.$error ng-if=\"vm.form.aggregateFrequencyUnits.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"small-3 columns\" ng-if=vm.isAggregate()> <label>Check to Aggregate: <span style=color:red>*</span> <select name=aggregateCheck ng-model=vm.aggregateCheck ng-options=\"ct as ct.name for ct in vm.getAggregateChecks()\" ng-change=vm.aggregateCheckChange() required> <option value=\"\">-- Select a Check --</option> </select> </label> <div ng-messages=vm.form.aggregateCheck.$error ng-if=\"vm.form.aggregateCheck.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"small-3 columns\" ng-if=vm.showAllowNA()> <label> <br/> <input type=checkbox name=allowNotApplicable ng-model=vm.editedCheck.allowNotApplicable /> Allow N/A </label> </div> <div class=\"small-3 columns\" ng-if=\"!vm.isSample() && !vm.isMultipleSample() && !vm.hasAggregateFrequency()\"> &nbsp; </div> <div class=\"small-3 columns\" ng-if=!vm.isSample()> &nbsp; </div> </div> <div class=row ng-if=\"vm.isMultiple() || vm.isMultipleSample()\"> <div class=\"small-12 large-12 columns\"> <label>Check Dimensions:</label> </div> <div ng-repeat=\"dim in vm.editedCheck.dimensions track by $index\" class=\"small-12 large-12 columns\"> <div class=\"small-3 large-3 columns\"> <label> <input type=text name=\"dim{{$index}}\" ng-model=dim.name placeholder=Name required/> </label> <div ng-messages=\"vm.form['dim' + $index].$error\" ng-if=\"vm.form['dim' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"small-3 large-3 columns\" ng-if=vm.isMultipleSample()> <select name=\"dimAggregate{{$index}}\" ng-model=dim.aggregateFunction ng-options=\"ct.value as ct.text for ct in vm.getAggregateFunctions()\" required> <option value=\"\">-- Select an Aggregate --</option> </select> <div ng-messages=\"vm.form['dimAggregate' + $index].$error\" ng-if=\"vm.form['dimAggregate' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"small-3 large-3 columns\"> <a ng-click=vm.removeDimension($index) style=font-size:.65em ng-if=\"vm.editedCheck.dimensions.length > 2\"> <i class=\"fa fa-times\" style=color:red></i> Remove Dimension </a> </div> <div class=\"small-3 large-3 columns\" ng-if=!vm.isMultipleSample()>&nbsp;</div> <div class=\"small-3 large-3 columns\">&nbsp;</div> </div> <div class=\"small-12 large-12 columns\"> <button type=button ng-click=vm.addDimension()>Add a Dimension</button> <div ng-if=\"vm.dimsInvalid() && vm.form.$submitted\"> <div class=req-w><div class=arrow-up></div>Must have 2 or more dimensions</div> </div> </div> </div> <!-- fixed values --> <div class=row ng-if=vm.showFixedValues()> <div class=\"small-12 large-12 columns\"> <label>Drop Down Choices:</label> </div> <div ng-repeat=\"choice in vm.editedCheck.choices\" class=\"small-12 large-12 columns\"> <div class=\"small-3 large-3 columns\"> <label>Value: <span style=color:red>*</span> <input name=\"choice{{$index}}\" type=\"{{vm.checkChoiceType()}}\" ng-model=choice.value required/> </label> <div ng-messages=\"vm.form['choice' + $index].$error\" ng-if=\"vm.form['choice' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"small-3 large-3 columns\"> <label>Outcome: <select name=outcome ng-model=choice.outcome ng-options=\"ct.value as ct.text for ct in vm.getDefaultOutcomes()\"> <option value=\"\">None</option> </select> </label> </div> <div class=\"small-3 columns\"> <label>Additional Data: <span style=color:red>*</span> <select name=\"choiceAdditionalData{{$index}}\" ng-model=choice.additionalData ng-options=\"x.value as x.text for x in vm.additionalDataTypes\" required> </select> </label> <div ng-messages=\"vm.form['choiceAdditionalData' + $index].$error\" ng-if=\"vm.form['choiceAdditionalData' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"small-3 large-3 columns\"> <a ng-click=vm.removeChoice(choice) style=font-size:.65em> <i class=\"fa fa-times\" style=color:red></i> Remove Choice </a> </div> </div> <div class=\"small-12 large-12 columns\"> <button type=button ng-click=vm.addChoice()>Add a Choice</button> <div ng-if=\"vm.choicesInvalid() && vm.form.$submitted\"> <div class=req-w><div class=arrow-up></div>Must have 2 or more choices</div> </div> </div> </div> <!-- comments --> <div class=row ng-if=!vm.isInstructions()> <div class=\"small-12 columns\"> <label> <input type=checkbox name=allowComments ng-model=vm.editedCheck.allowComments /> Allow comments </label> </div> </div> </div> <!-- buttons --> <div class=row> <div class=\"small-12 columns\"> <span class=required>* Required Fields</span> <div class=\"right dialog-footer\"> <button ng-click=vm.cancel() type=button class=\"button secondary\">Cancel</button> <button class=button type=submit ng-if=vm.isNew>Add Check</button> <button class=button type=submit ng-if=\"!vm.isNew && !vm.isReadOnly\">Save Check</button> </div> </div> </div> </form> </div>");

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=tabbed-view-w style=margin-bottom:-30px> <h2 ng-if=vm.isNew class=modal-header>Add Check List</h2> <h2 ng-if=!vm.isNew class=modal-header>Edit Check List</h2> <tabset> <tab heading=Details> <form name=vm.checkListForm ng-submit=vm.saveRoleOverride() novalidate ng-if=vm.isReadOnly> <div class=container> <label ng-if=vm.department><strong>Department:</strong> {{vm.department}}</label> <label ng-if=vm.pasType><strong>PAS Type:</strong> {{vm.pasType}}</label> <label ng-if=vm.topNumber><strong>TOP Number:</strong> {{vm.topNumber}}</label> <label><strong>TOP Title:</strong> {{vm.name}}</label> <label><strong>Description:</strong> {{vm.description}}</label> <div ng-if=vm.isGroup> <label><strong>Check Lists in Group:</strong></label> <ul> <li ng-repeat=\"cl in vm.childLists\"><label>{{cl.name}}</label></li> </ul> </div> <label ng-if=vm.wareClass.id><strong>Ware Class:</strong> {{vm.wareClass.name}}</label> <label ng-if=vm.canBeScheduled><strong>Location Type:</strong> {{vm.locationType.text}}</label> <label ng-if=vm.location><strong>Location:</strong> {{vm.location.name}}</label> <label ng-if=vm.isScheduled><strong>Schedule:</strong> {{vm.frequencySelection.name}}</label> <label ng-if=vm.checkListGroupName><strong>Group:</strong> {{vm.checkListGroupName}}</label> <label ng-if=vm.role><strong>Role:</strong> {{vm.role.name}}</label> <div ng-if=\"vm.allowedRoles.length > 0\"> <label><strong>Additional Roles:</strong></label> <ul> <li ng-repeat=\"roleId in vm.allowedRoles\"><label>{{vm.getRoleName(roleId)}}</label></li> </ul> </div> <div ng-if=vm.requiresSignOff> <label><strong>Sign Offs:</strong></label> <ul> <li ng-repeat=\"role in vm.signOffRoles\"><label>{{role.name}}{{role.failuresOnly ? ' (failure only)' : ''}}</label></li> </ul> </div> <div ng-if=\"vm.role && vm.canOverrideRole()\" class=\"columns small-6\"> <label> <strong>Override Role for {{ vm.plant.name }}<span ng-if=vm.shop.id> Shop {{vm.shop.name}}</span><span ng-if=vm.jobId><br/> Job: {{vm.initialJobName}}</span>:</strong> <select name=role ng-model=vm.overrideRole ng-options=\"role.name for role in vm.overrideRoles() | orderBy: 'name'\"> <option value=\"\">-- No Override --</option> </select> </label> </div> <div class=\"large-12 columns\"> <div class=\"right dialog-footer\"> <button type=submit ng-if=\"vm.role && vm.canOverrideRole()\" class=button>Save Override</button> <button type=button ng-click=vm.cancel() class=\"button secondary\">Cancel</button> </div> </div> </div> </form> <form name=vm.checkListForm ng-submit=vm.saveCheckList() novalidate ng-if=!vm.isReadOnly> <div class=container style=\"margin:0 -30px\"> <div class=row> <div class=\"large-1 columns\"> <label>Dept: <input type=text name=department ng-model=vm.department ng-pattern=/^\\S{2,3}$/ maxlength=3 typeahead=\"x for x in vm.departments | filter:$viewValue | limitTo:8\"/> </label> <div ng-messages=vm.checkListForm.department.$error ng-if=\"vm.checkListForm.department.$dirty || vm.checkListForm.$submitted\" role=alert> <div ng-message=pattern class=\"required req-w\"><div class=arrow-up></div>Must be 2 or 3 characters</div> </div> </div> <div class=\"large-1 columns\"> <label>PAS: <input type=text name=pasType ng-model=vm.pasType ng-pattern=/^\\S{3,4}$/ maxlength=4 typeahead=\"x for x in vm.pasTypes | filter:$viewValue | limitTo:8\"/> </label> <div ng-messages=vm.checkListForm.pasType.$error ng-if=\"vm.checkListForm.pasType.$dirty || vm.checkListForm.$submitted\" role=alert> <div ng-message=pattern class=\"required req-w\"><div class=arrow-up></div>Must be 3 or 4 characters</div> </div> </div> <div class=\"large-1 columns\"> <label>TOP #: <input type=text name=topNumber ng-model=vm.topNumber ng-pattern=/^[0-9]{4}$/ maxlength=4 /> </label> <div ng-messages=vm.checkListForm.topNumber.$error ng-if=\"vm.checkListForm.topNumber.$dirty || vm.checkListForm.$submitted\" role=alert> <div ng-message=pattern class=\"required req-w\"><div class=arrow-up></div>Must be 4 digits</div> </div> </div> <div class=\"large-6 columns\"> <label>TOP Title: <span style=color:red>*</span> <input type=text name=name ng-model=vm.name required/> </label> <div ng-messages=vm.checkListForm.name.$error ng-if=\"vm.checkListForm.name.$dirty || vm.checkListForm.$submitted\" role=alert> <div ng-message=required class=\"required req-w\"><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-2 columns\"> <label>Plant: <h4>{{ vm.plantDisplayName() }}</h4> </label> </div> <div class=\"large-1 columns\"> <label>Shop: <h4>{{ vm.shopDisplayName() }}</h4> </label> </div> </div> <div class=row> <div class=\"large-12 columns\"> <label>Description: <textarea name=description ng-model=vm.description rows=4></textarea> </label> </div> </div> <div class=row ng-if=vm.canBeGroup> <div class=\"large-3 columns\"> <label> Check List Group <input type=checkbox ng-model=vm.isGroup ng-change=vm.isGroupChanged() /> </label> </div> <div class=\"large-9 columns\">&nbsp;</div> </div> <div class=row> <div class=\"large-3 columns\"> <label> Ware Class: <select name=wareClass ng-model=vm.wareClass ng-change=vm.wareClassChanged() required ng-options=\"wc.name for wc in vm.wareClasses\"> </select> </label> <div ng-messages=vm.checkListForm.locationType.$error ng-if=\"vm.checkListForm.locationType.$dirty || vm.checkListForm.$submitted\" role=alert> <div ng-message=required class=\"required req-w\"><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-3 columns\" ng-if=vm.canBeScheduled> <label> Location Type: <span style=color:red>*</span> <select name=locationType ng-model=vm.locationType ng-change=vm.locationTypeChanged() required ng-options=\"lt.text for lt in vm.locationTypes | orderBy: 'text'\"> <option>-- Select Type --</option> </select> </label> <div ng-messages=vm.checkListForm.locationType.$error ng-if=\"vm.checkListForm.locationType.$dirty || vm.checkListForm.$submitted\" role=alert> <div ng-message=required class=\"required req-w\"><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-6 columns\" ng-if=vm.isOther() ng-if=vm.canBeScheduled> <label> Location: <span style=color:red>*</span> <select name=location ng-model=vm.location required ng-options=\"l.name for l in vm.locations | orderBy: 'name'\"> <option>-- Select Location --</option> </select> </label> <div ng-messages=vm.checkListForm.location.$error ng-if=\"vm.checkListForm.location.$dirty || vm.checkListForm.$submitted\" role=alert> <div ng-message=required class=\"required req-w\"><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-6 columns\" ng-if=!vm.isOther() ng-if=vm.canBeScheduled> &nbsp; </div> <div class=\"large-3 columns\" ng-if=!vm.canBeScheduled> &nbsp; </div> </div> <div class=row> <div class=\"large-3 columns\" ng-if=vm.canHaveRole> <label>Role: <span style=color:red>*</span> <select name=role ng-model=vm.role required ng-options=\"role.name for role in vm.roles | orderBy: 'name'\"> <option>-- Select Role --</option> </select> </label> <div ng-messages=vm.checkListForm.role.$error ng-if=\"vm.checkListForm.role.$dirty || vm.checkListForm.$submitted\" role=alert> <div ng-message=required class=\"required req-w\"><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-3 columns\" ng-if=vm.canBeScheduled> <br/> <br/> <label> <input type=checkbox name=isScheduled ng-model=vm.isScheduled> Scheduled? </label> </div> <div class=\"large-6 columns\" ng-if=vm.canBeScheduled> <label ng-if=vm.isScheduled>Frequency: <select name=frequencyUnits ng-model=vm.frequencySelection ng-change=vm.frequencyChanged() ng-options=\"f.name for f in vm.frequencySelections\"></select> <select ng-if=\"vm.frequencySelection.offsets.length > 1\" name=frequencyUnits ng-model=vm.frequencyOffsetSelection ng-options=\"f.description for f in vm.frequencySelection.offsets\"></select> </label> </div> <div class=\"large-6 columns\" ng-if=vm.checkListGroupName> <label>Group:</label> <br/> <strong>{{vm.checkListGroupName}}</strong> </div> <div class=\"large-3 columns\" ng-if=!vm.canHaveRole> &nbsp; </div> <div class=\"large-9 columns\" ng-if=\"!vm.canBeScheduled && !vm.checkListGroupName\"> &nbsp; </div> <div class=\"large-3 columns\" ng-if=\"!vm.canBeScheduled && vm.checkListGroupName\"> &nbsp; </div> </div> <div class=row ng-if=\"vm.allowedRoles.length > 0\"> <table class=history-t> <tr> <th> Additional Roles </th> <th>&nbsp;</th> </tr> <tr ng-repeat=\"roleId in vm.allowedRoles\"> <td> {{vm.getRoleName(roleId)}} </td> <td> <button type=button class=\"button small alert\" ng-click=vm.removeAllowedRole(roleId)><i class=\"fa fa-trash\"></i></button> </td> </tr> </table> </div> <div class=row ng-if=\"vm.canHaveRole && vm.availableRoles().length > 0\"> <div class=\"large-3 columns\"> <label>Add Additional Role: <select name=roleToAdd ng-model=vm.roleToAdd ng-options=\"role.name for role in vm.availableRoles() | orderBy: 'name'\"> </select> </label> </div> <div class=\"large-9 columns\"> <button type=button class=button style=\"padding:4px 10px 9px;margin:21px 0 0 0\" ng-click=vm.addAllowedRole()>+</button> </div> </div> <div class=row> <div class=\"large-3 columns\"> <label> <br/> <input type=checkbox name=requiresSignOff ng-model=vm.requiresSignOff /> Sign off? </label> </div> <div class=\"large-3 columns\" ng-if=vm.requiresSignOff> <label>Role: <select name=signOff ng-model=vm.signOffRoleToAdd ng-options=\"role.name for role in vm.availableSignOffRoles\"> <option></option> </select> </label> </div> <div class=\"large-3 columns\" ng-if=vm.requiresSignOff> <label> <br/> <input type=checkbox name=failuresOnly ng-model=vm.signOffRoleToAdd.failuresOnly /> Failures only </label> </div> <div class=\"large-3 columns\" ng-if=vm.requiresSignOff> <button type=button class=button style=\"padding:4px 10px 9px;margin:21px 0 0 0\" ng-click=vm.addSignOffRole()>+</button> </div> </div> <div class=row ng-if=\"vm.requiresSignOff && vm.signOffRoles.length > 0\" style=max-height:800px;overflow-y:scroll> <table class=history-t> <tr> <th width=60%> Role </th> <th> Failures only </th> <th>&nbsp;</th> </tr> <tr ng-repeat=\"role in vm.signOffRoles\"> <td> {{role.name}} </td> <td> <i class=\"fa fa-check\" ng-if=role.failuresOnly></i> </td> <td> <button ng-click=vm.removeSignOffRole(role) class=\"button alert\">delete</button> </td> </tr> </table> </div> <div class=row ng-if=vm.isGroup> <div class=\"large-6 columns\"> <label>Add List to Group <input name=child type=text ng-model=vm.childName ng-select=vm.childAdded() typeahead-on-select=vm.childAdded() typeahead=\"cl.name for cl in vm.availableChildLists() | filter:$viewValue | limitTo:8\"/> </label> <div ng-if=\"vm.childLists.length === 0 && vm.checkListForm.$submitted\" role=alert> <div class=\"required req-w\"><div class=arrow-up></div>Required</div> </div> </div> </div> <div class=row ng-if=\"vm.isGroup && vm.childLists.length > 0\"> <div class=\"large-12 columns\"> <label>Check Lists In Group</label> <ul> <li ng-repeat=\"cl in vm.childLists\"> {{cl.name}} <button type=button class=\"button tiny alert\" ng-click=vm.removeChild(cl)>Remove</button> </li> </ul> </div> </div> <div class=row> <div class=\"large-12 columns\"> <span class=required>* Required Fields</span> <div class=\"right dialog-footer\"> <button type=submit ng-if=vm.isNew class=button>Add Check List</button> <button type=submit ng-if=!vm.isNew class=button>Save Check List</button> <button type=button ng-click=vm.cancel() class=\"button secondary\">Cancel</button> <button type=button ng-if=\"!vm.isNew && vm.checks.length > 0\" ng-click=vm.previewChecklist() class=\"button secondary\">Preview Check List</button> </div> </div> </div> </div> </form> </tab> <tab heading=Checks ng-if=\"!vm.isNew && !vm.isGroup\" active=vm.checksTabActive> <div class=container> <div class=body-header> <label>Plant: <select name=plant ng-model=vm.checkPlant ng-if=\"vm.plants.length > 1\" ng-change=vm.reloadChecks() ng-options=\"plant.name for plant in vm.plants\"> </select> <span ng-if=\"vm.plants.length == 1\">{{vm.checkPlant.name}}</span> </label> <label ng-if=vm.checkPlant.id>Shop: <select name=shop ng-model=vm.checkShop ng-if=\"vm.plantShops().length > 1\" ng-change=vm.reloadChecks() ng-options=\"shop.name for shop in vm.plantShops()\"> </select> <span ng-if=\"vm.plantShops().length == 1\">{{vm.checkShop.name}}</span> </label> <label>Job: <span ng-if=vm.job ng-click=vm.clearJob() style=color:#8b0000>(clear)</span> <input name=job type=text ng-model=vm.jobName ng-select=vm.jobNameChanged() typeahead-on-select=vm.jobNameChanged() typeahead=\"job.name for job in vm.jobs | filter:$viewValue | limitTo:8\" autofill=off autocomplete=off /> </label> <a href=\"\" class=\"button small\" ng-if=!vm.isReadOnly ng-click=vm.addCheck()>Add Check</a> </div> <table class=history-t> <tbody as-sortable=vm.dragDropListeners ng-model=vm.checks> <tr ng-repeat=\"check in vm.checks\" as-sortable-item> <td ng-if=!vm.isReadOnly> <i class=\"fa fa-bars\" as-sortable-item-handle></i> </td> <td ng-if=vm.isReadOnly> &nbsp;&nbsp;&nbsp; </td> <td width=80%> {{ check.heading }}<br/> <strong>{{ check.name }}</strong><br/> <i>{{ check.dataTypeString }}</i> <div class=right> <input type=checkbox ng-model=check.isMandatory ng-click=vm.toggleMandatory(check) ng-disabled=!check.canChangeMandatory /> Mandatory <input type=checkbox ng-model=check.isDisabled ng-click=vm.toggleDisabled(check) ng-disabled=!check.canChangeDisabled /> Disabled </div> </td> <td> <button class=\"button tiny\" ng-click=vm.openCheck(check) style=margin:0>Open</button> <button class=\"button tiny alert\" ng-if=!vm.isReadOnly ng-click=vm.deleteCheck(check) style=margin:0>Delete</button> </td> </tr> </tbody> </table> <div class=row> <div class=\"large-12 columns\"> <div class=\"right dialog-footer\"> <button type=button ng-click=vm.cancel() class=\"button secondary\">Close</button> </div> </div> </div> </div> </tab> </tabset> </div> ");

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(62), __webpack_require__(30), __webpack_require__(4), __webpack_require__(6), __webpack_require__(12), __webpack_require__(7), __webpack_require__(575)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, checkListOverride_module_1, checkLists_service_1, loader_service_1, notify_service_1, newguid_service_1, authData_service_1, copyCheckList_tpl_html_1) {
    "use strict";
    copyCheckListCtrl.$inject = ["$modalInstance", "data", "checkListsService", "loaderService", "notifyService", "newGuidService", "authDataService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [checkLists_service_1.default, loader_service_1.default, notify_service_1.default, newguid_service_1.default, authData_service_1.default];
    function openCopyCheckList(data, $modal) {
        return $modal.open({
            template: copyCheckList_tpl_html_1.default,
            controller: 'CopyCheckListCtrl as vm',
            resolve: {
                data: function () { return data; }
            }
        }).result;
    }
    exports.openCopyCheckList = openCopyCheckList;
    exports.default = angular.module('aps.controller.copyCheckList', requires)
        .controller('CopyCheckListCtrl', copyCheckListCtrl)
        .name;
    function copyCheckListCtrl($modalInstance, data, checkListsService, loaderService, notifyService, newGuidService, authDataService) {
        'use strict';
        var vm = this;
        var isAdmin = authDataService.isAdmin();
        vm.originalCheckList = data.originalCheckList;
        vm.name = 'Copy of ' + vm.originalCheckList.name;
        var shopsAllSelection = checkListOverride_module_1.CheckListCommon.getAllShopsItem();
        var plantsAllSelection = checkListOverride_module_1.CheckListCommon.getAllPlantsItem();
        if (isAdmin) {
            vm.plants = data.plants;
            vm.plant = plantsAllSelection;
        }
        else {
            vm.plants = _.filter(data.plants, function (plant) { return authDataService.isPlantAdmin(plant.id); });
            vm.plant = vm.plants[0];
        }
        vm.shop = shopsAllSelection;
        newGuidService.getNewGuid('checkList').then(function (id) { return vm.id = id; });
        vm.submit = function () {
            if (vm.copyCheckListForm.$invalid) {
                return;
            }
            var plant = vm.plant !== plantsAllSelection ? vm.plant : undefined;
            var shop = vm.shop !== shopsAllSelection ? vm.shop : undefined;
            var command = {
                id: vm.id,
                originalCheckListId: vm.originalCheckList.id,
                name: vm.name,
                plantId: plant ? plant.id : null,
                shopId: shop ? shop.id : null
            };
            var promise = checkListsService.copyCheckList(command).then(function () {
                var checkList = {
                    id: vm.id,
                    name: vm.name,
                    department: vm.originalCheckList.department,
                    pasType: vm.originalCheckList.pasType,
                    topNumber: vm.originalCheckList.topNumber,
                    plantId: plant ? plant.id : null,
                    shopId: shop ? shop.id : null,
                    locationType: vm.originalCheckList.locationType,
                    locationId: vm.originalCheckList.locationId,
                    wareClassId: vm.originalCheckList.wareClassId,
                    isGroup: false,
                    checkListGroupId: null,
                    overrides: [],
                    createdOn: new Date(),
                    isDeleted: false,
                    deletedOn: null
                };
                $modalInstance.close(checkList);
            }, notifyService.handleApiErrors);
            loaderService.loadingPromise(promise);
        };
        vm.cancel = function () {
            $modalInstance.close();
        };
        vm.shops_filtered = function () {
            var result = vm.plant.shops.concat([]);
            if (result.length === 0 || result[0] !== shopsAllSelection) {
                result.unshift(shopsAllSelection);
            }
            if (result.length === 1) {
                vm.shop = result[0];
            }
            return result;
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (" <h2 class=modal-header>Copy Check List</h2> <form name=vm.copyCheckListForm ng-submit=vm.submit() novalidate> <div class=row style=margin-left:-30px> <div class=\"large-12 columns\"> <label>Name: <span ng-show=vm.copyCheckListForm.name.$error.required style=color:red>*</span> <input type=text name=name ng-model=vm.name required/> </label> <div ng-messages=vm.copyCheckListForm.name.$error ng-if=\"vm.copyCheckListForm.name.$dirty || vm.copyCheckListForm.$submitted\" role=alert> <div ng-message=required class=\"required req-w\"><div class=arrow-up></div>Required</div> </div> </div> </div> <div class=row style=margin-left:-30px> <div class=\"large-4 columns\"> <label>Plant: <select name=plant ng-model=vm.plant ng-options=\"plant.name for plant in vm.plants\"> </select> </label> </div> <div class=\"large-4 columns\"> <label>Shop: <select name=shop ng-model=vm.shop ng-options=\"shop.name for shop in vm.shops_filtered()\"> </select> </label> </div> <div class=\"large-4 columns\"> &nbsp; </div> </div> <div class=row> <div class=\"small-12 columns\"> <div class=\"right dialog-footer\"> <button type=submit class=button>Submit</button> <button type=button ng-click=vm.cancel() class=\"button secondary\">Cancel</button> </div> </div> </div> </form>");

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(577), __webpack_require__(578), __webpack_require__(579)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, checkListKPI_controller_1, checkListKPI_dashboard_tpl_html_1, checkListKPI_linesheet_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var name = 'aps.directive.checkListKPI';
    exports.default = name;
    var ngModule = angular.module(name, [checkListKPI_controller_1.default]);
    function registerDirective(name, template) {
        var checkListKPIDef = function () {
            return {
                restrict: 'E',
                template: template,
                replace: true,
                controller: 'CheckListKPICtrl',
                controllerAs: 'vm',
                bindToController: true,
                scope: {
                    plantId: '=',
                    shopId: '=',
                    wellKnownCheck: '='
                }
            };
        };
        var directiveName = 'apsCheckListKpi' + name;
        ngModule.directive(directiveName, checkListKPIDef);
    }
    registerDirective("Dashboard", checkListKPI_dashboard_tpl_html_1.default);
    registerDirective("Linesheet", checkListKPI_linesheet_tpl_html_1.default);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(30), __webpack_require__(112)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, checkLists_service_1, kpiChecks_hub_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [checkLists_service_1.default, kpiChecks_hub_1.default];
    var CheckListKPICtrl = (function () {
        CheckListKPICtrl.$inject = ["checkListsService", "kpiChecksHubService", "$timeout", "$scope"];
        function CheckListKPICtrl(checkListsService, kpiChecksHubService, $timeout, $scope) {
            var _this = this;
            this.checkListsService = checkListsService;
            this.loading = true;
            var updateResult = function (update) {
                $timeout(function () {
                    _this.kpiCheckResults.result = update.result;
                    _this.kpiCheckResults.status = update.status;
                    _this.kpiCheckResults.checkName = update.checkName;
                });
            };
            $timeout(function () {
                _this.checkListsService.getLastValue(_this.plantId, _this.shopId, _this.wellKnownCheck)
                    .then(function (result) {
                    _this.kpiCheckResults = result;
                    _this.loading = false;
                    if (result) {
                        _this.kpiChecksHub = kpiChecksHubService.createKPIChecksHub(updateResult, _this.shopId, result.wellKnownCheckId);
                    }
                });
            });
            $scope.$on('$destroy', function () {
                if (_this.kpiChecksHub) {
                    _this.kpiChecksHub.deregisterListeners();
                    _this.kpiChecksHub.leaveGroup(_this.shopId, _this.kpiCheckResults.wellKnownCheckId);
                }
            });
        }
        return CheckListKPICtrl;
    }());
    exports.default = angular.module('aps.controller.checkListKPI', requires)
        .controller('CheckListKPICtrl', CheckListKPICtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<span ng-class=\"{ 'label success' : 2 == vm.kpiCheckResults.status, 'label alert' : 1 == vm.kpiCheckResults.status }\"> <span ng-if=vm.loading>...</span> <span ng-if=!vm.loading>{{ vm.kpiCheckResults.result ? vm.kpiCheckResults.result + '%' : 'n/a' }}</span> <span ng-if=!vm.loading>{{ vm.kpiCheckResults.checkName }}</span> </span>");

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<ul> <li ng-if=vm.loading>...</li> <li ng-if=!vm.loading>{{ vm.kpiCheckResults.checkName }}</li> <li ng-if=!vm.loading>{{ vm.kpiCheckResults.result ? vm.kpiCheckResults.result + '%' : 'n/a' }}</li> </ul>");

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(9), __webpack_require__(5), __webpack_require__(30), __webpack_require__(4), __webpack_require__(32), __webpack_require__(7), __webpack_require__(3), __webpack_require__(54), __webpack_require__(8), __webpack_require__(6), __webpack_require__(581), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, uiUtility_service_1, aps_enums_1, checkLists_service_1, loader_service_1, checkListInstances_service_1, authData_service_1, constant_module_1, locations_service_1, navigation_service_1, notify_service_1, checkListReport_tpl_html_1, dateutility_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [checkLists_service_1.default, loader_service_1.default, checkListInstances_service_1.default, authData_service_1.default,
        locations_service_1.default, navigation_service_1.default, uiUtility_service_1.default, notify_service_1.default];
    var CheckListReportCtrl = (function () {
        CheckListReportCtrl.$inject = ["navigationService", "loaderService", "checkListsService", "checkListInstancesService", "uiUtilityService", "$state", "$stateParams", "authDataService", "locationsService", "notifyService", "$q", "$scope", "$timeout", "$modal"];
        function CheckListReportCtrl(navigationService, loaderService, checkListsService, checkListInstancesService, uiUtilityService, $state, $stateParams, authDataService, locationsService, notifyService, $q, $scope, $timeout, $modal) {
            var _this = this;
            this.requirePlantSelection = true;
            this.requireLocationSelection = false;
            this.$q = $q;
            this.checkListsService = checkListsService;
            this.checkListInstancesService = checkListInstancesService;
            this.loaderService = loaderService;
            this.$modal = $modal;
            this.$scope = $scope;
            this.timeZone = constant_module_1.Strings.DEFAULT_TIMEZONE;
            this.$timeout = $timeout;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.notifyService = notifyService;
            this.authDataService = authDataService;
            this.locationsService = locationsService;
            this.statuses = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.CheckListStatus);
            this.filters = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.CheckListReportFilter, 1);
            var now = moment().add(1, 'hours').startOf('hour');
            this.uiEndDate = now.toDate();
            this.uiStartDate = now.clone().subtract(1, 'days').toDate();
            this.filter = aps_enums_1.apsEnums.CheckListReportFilter.AllCheckLists;
            var promise = locationsService.initialize().then(function () {
                return navigationService.getNavigation().then(function (nav) {
                    _this.plants = nav.plants();
                    _this.selectedPlant = nav.selectedPlant;
                    _this.updatePlant(true);
                    return _this.loadState($stateParams).then(function () {
                        return _this.loadCheckLists();
                    });
                });
            });
            loaderService.loadingPromise(promise);
        }
        CheckListReportCtrl.prototype.loadCheckLists = function (throttle) {
            var _this = this;
            if (this.loadCheckListTimeout) {
                this.$timeout.cancel(this.loadCheckListTimeout);
                this.loadCheckListTimeout = null;
            }
            this.loadCheckListTimeout = this.$timeout(function () {
                var criteria = {
                    plantId: _this.selectedPlant ? _this.selectedPlant.id : null,
                    locationType: undefined,
                    locationId: undefined,
                    startDate: _this.startDate,
                    endDate: _this.endDate
                };
                if (_this.selectedLocation) {
                    criteria.locationType = _this.selectedLocation.locationType;
                    criteria.locationId = _this.selectedLocation.id;
                }
                _this.loadCheckListTimeout = null;
                return _this.checkListsService.getCheckListsWithData(criteria)
                    .then(function (data) { return _this.checkLists = data; });
            }, throttle ? 500 : null);
            return this.loadCheckListTimeout;
        };
        CheckListReportCtrl.prototype.getPlantId = function () {
            return this.selectedPlant ? this.selectedPlant.id : null;
        };
        CheckListReportCtrl.prototype.getShopId = function () {
            return (this.selectedLocation
                && this.selectedLocation.locationType === aps_enums_1.apsEnums.LocationType.Shop)
                ? this.selectedLocation.id : null;
        };
        CheckListReportCtrl.prototype.updatePlant = function (skipChecklists) {
            this.timeZone = this.selectedPlant ? this.selectedPlant.timeZoneId : constant_module_1.Strings.DEFAULT_TIMEZONE;
            this.selectedLocation = undefined;
            this.locations = this.locationsService.getPlantLocations(this.selectedPlant);
            if (skipChecklists !== true) {
                this.loadCheckLists(true);
            }
        };
        CheckListReportCtrl.prototype.updateLocation = function () {
            this.loadCheckLists(true);
        };
        CheckListReportCtrl.prototype.updateStartDate = function () {
            this.loadCheckLists(true);
        };
        CheckListReportCtrl.prototype.updateEndDate = function () {
            this.loadCheckLists(true);
        };
        CheckListReportCtrl.prototype.setReportData = function (results) {
            this.reportData = {
                results: results,
                plantId: this.getPlantId(),
                shopId: this.getShopId(),
                filter: this.filter
            };
        };
        CheckListReportCtrl.prototype.runReport = function (criteria) {
            var _this = this;
            this.setReportData(null);
            return this.checkListsService.getCheckListReport(criteria).then(function (reportItems) {
                _this.setReportData(reportItems);
                _this.searchPerformed = true;
            }, this.notifyService.handleApiErrors);
        };
        CheckListReportCtrl.prototype.loadState = function (params) {
            if (params.reportPlantId && params.locationId && params.locationId !== params.shopId) {
                var plant = _.find(this.plants, { id: params.reportPlantId });
                if (plant) {
                    var location = _.find(this.locations, { id: params.locationId });
                    if (location) {
                        this.selectedPlant = plant;
                        this.selectedLocation = location;
                    }
                }
            }
            if (!this.selectedLocation) {
                this.selectedLocation = _.find(this.locations, { id: params.shopId });
            }
            dateutility_service_1.default.setReportDates(this, params, this.$timeout);
            if (params.checkListId) {
                this.checkListId = params.checkListId;
            }
            if (params.status !== undefined) {
                var status = _.find(this.statuses, { value: +params.status });
                if (status) {
                    this.status = status.value;
                }
            }
            if (params.filter !== undefined) {
                var filter = _.find(this.filters, { value: +params.filter });
                if (filter) {
                    this.filter = filter.value;
                }
            }
            if (params.autoRun) {
                return this.runCheckListReport();
            }
            return this.$q.when();
        };
        CheckListReportCtrl.prototype.saveState = function () {
            var locationId = this.selectedLocation ? this.selectedLocation.id : undefined;
            if (locationId === this.$stateParams.shopId) {
                locationId = undefined;
            }
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportPlantId: (locationId && this.selectedPlant) ? this.selectedPlant.id : undefined,
                locationId: locationId,
                startDate: this.startDate ? this.startDate.toISOString() : undefined,
                endDate: this.endDate ? this.endDate.toISOString() : undefined,
                checkListId: this.checkListId,
                status: this.status,
                filter: this.filter,
                autoRun: true
            };
            this.$state.transitionTo(this.$state.current.name, params);
        };
        CheckListReportCtrl.prototype.generateReport = function () {
            if (this.form.$invalid) {
                return;
            }
            this.saveState();
            this.loaderService.loadingPromise(this.runCheckListReport());
        };
        CheckListReportCtrl.prototype.runCheckListReport = function () {
            var criteria = {
                plantId: this.getPlantId(),
                locationType: undefined,
                locationId: undefined,
                startDate: this.startDate,
                endDate: this.endDate,
                checkListId: this.checkListId,
                status: this.status,
                filter: this.filter
            };
            if (this.selectedLocation) {
                criteria.locationType = this.selectedLocation.locationType;
                criteria.locationId = this.selectedLocation.id;
            }
            return this.runReport(criteria);
        };
        return CheckListReportCtrl;
    }());
    exports.default = angular.module('aps.controller.checkListReport', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.CHECKLIST_REPORT,
            url: '/admin/checkLists/report?locationId&startDate&endDate&checkListId&status&filter&autoRun&reportPlantId',
            params: {
                startDate: { dynamic: true },
                endDate: { dynamic: true },
                checkListId: { dynamic: true },
                status: { dynamic: true },
                autoRun: { dynamic: true },
                filter: { dynamic: true },
                reportPlantId: { dynamic: true }
            },
            controller: 'CheckListReportCtrl as vm',
            template: checkListReport_tpl_html_1.default,
            data: {
                pageTitle: 'Check List Report',
                v2Uri: 'aps/reports/check-list-report',
                v2Params: ['startDate', 'endDate']
            }
        });
    }])
        .controller('CheckListReportCtrl', CheckListReportCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div class=body-header> <h2>Check List Report</h2> </div> <aps-common-report-location-row vm=vm></aps-common-report-location-row> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-6 columns\"> <label> Check List <select ng-model=vm.checkListId ng-options=\"c.id as c.name for c in vm.checkLists | orderBy: 'name'\"> <option value=\"\">-- Any Check List --</option> </select> </label> </div> <div class=\"small-3 columns\"> <label> Status <select ng-model=vm.status ng-options=\"status.value as status.text for status in vm.statuses\"> <option value=\"\">-- Any Status --</option> </select> </label> </div> <div class=\"small-3 columns\"> <label> Filter <select ng-model=vm.filter ng-options=\"x.value as x.text for x in vm.filters\"> </select> </label> </div> <div class=\"small-12 columns\"> <button type=submit class=button>Generate Report</button> </div> </div> </form> <react-component ng-if=vm.reportData name=CheckListReportComponent props=vm.reportData watch-depth=reference /> </div>");

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(64), __webpack_require__(5), __webpack_require__(11), __webpack_require__(32), __webpack_require__(30), __webpack_require__(4), __webpack_require__(75), __webpack_require__(61), __webpack_require__(38)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, React, aps_enums_1, dateutility_service_1, checkListInstances_service_1, checkLists_service_1, loader_service_1, checkListInstances_hub_1, checkListReportDetails_controller_1, fillOutCheckList_controller_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [checkListReportDetails_controller_1.default, checkListInstances_service_1.default, checkLists_service_1.default, loader_service_1.default,
        checkListInstances_hub_1.default, fillOutCheckList_controller_1.default];
    var CheckListReportComponent = (function (_super) {
        __extends(CheckListReportComponent, _super);
        function CheckListReportComponent() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        CheckListReportComponent.prototype.componentDidMount = function () {
            if (!this.props && !this.props.results) {
                this.setState({ results: null });
                return;
            }
            this.setState({ results: this.props.results });
            this.createOrSubscribeHub(this.props);
        };
        CheckListReportComponent.prototype.createOrSubscribeHub = function (props) {
            var _this = this;
            if (!props || !props.plantId) {
                return;
            }
            if (this.hub) {
                this.hub.joinGroup(props.plantId, props.shopId);
            }
            else {
                this.hub = CheckListReportComponent.checkListInstancesHubCreator
                    .createCheckListInstancesHub(props.plantId, props.shopId, function (updated) { return _this.handleUpdated(updated); }, function (instance) { return _this.handleInstance(instance); });
            }
        };
        CheckListReportComponent.prototype.componentWillReceiveProps = function (props) {
            if (!props && !props.results) {
                this.setState({ results: null });
                return;
            }
            this.setState({ results: props.results });
            this.createOrSubscribeHub(props);
        };
        CheckListReportComponent.prototype.componentWillUnmount = function () {
            if (this.hub) {
                this.hub.uninitialize();
            }
        };
        CheckListReportComponent.prototype.findExistingInstance = function (instance) {
            var group = _.find(this.state.results, { checkListId: instance.checkListId });
            if (group) {
                return _.find(group.checkListInstances, { id: instance.id });
            }
            return null;
        };
        CheckListReportComponent.prototype.handleUpdated = function (updated) {
            var _this = this;
            if (!this.state.results) {
                return;
            }
            if (updated.instances.length > 0) {
                _.forEach(updated.instances, function (i) { return _this.handleUpdated(i); });
            }
            var existing = this.findExistingInstance(updated);
            if (!existing) {
                return;
            }
            if (updated.action === aps_enums_1.apsEnums.EventAction.Delete) {
                var group = _.find(this.state.results, { checkListId: updated.checkListId });
                if (group) {
                    _.remove(group.checkListInstances, existing);
                    if (group.checkListInstances.length === 0) {
                        _.remove(this.state.results, group);
                    }
                }
            }
            else {
                existing.status = updated.status;
                existing.result = updated.result;
            }
            this.setState({ results: this.state.results });
        };
        CheckListReportComponent.prototype.handleInstance = function (instance) {
            var _this = this;
            if (!this.state.results || instance.action === aps_enums_1.apsEnums.EventAction.Add) {
                return;
            }
            if (instance.instances.length > 0) {
                _.forEach(instance.instances, function (i) { return _this.handleInstance(i); });
            }
            var existing = this.findExistingInstance(instance);
            if (!existing) {
                return;
            }
            existing.status = instance.status;
            existing.result = instance.result;
            this.setState({ results: this.state.results });
        };
        CheckListReportComponent.prototype.render = function () {
            if (!this.state || !this.state.results) {
                return React.createElement('div', { key: 'results' }, ' ');
            }
            if (this.state.results.length === 0) {
                return React.createElement('div', { key: 'results' }, 'No results found. Please select a different plant, location, date range and/or check list.');
            }
            var rows = this.createRows();
            return React.createElement('table', { key: 'results', className: 'history-t' }, React.createElement('thead', { key: 'results-head' }, React.createElement('tr', { key: 'results-head-tr' }, React.createElement('th', { key: 'head-name' }, 'Name'), React.createElement('th', { key: 'head-schedule' }, 'Scheduled On'), React.createElement('th', { key: 'head-status' }, 'Status'), React.createElement('th', { key: 'head-plant' }, 'Plant'), React.createElement('th', { key: 'head-location' }, 'Location'), React.createElement('th', { key: 'head-result' }, 'Results'), React.createElement('th', { key: 'head-open' }, ' '))), React.createElement('tbody', { key: 'results-body' }, rows));
        };
        CheckListReportComponent.prototype.createRows = function () {
            var _this = this;
            var rows = [];
            _.forEach(this.state.results, function (checkGroup) {
                var instances = _.sortBy(checkGroup.checkListInstances, ['scheduledOn', 'plantName', 'location'], [false, true, true]);
                rows.push(React.createElement('tr', { key: 'group-' + checkGroup.checkListId }), React.createElement('td', { key: 'name' + checkGroup.checkListId, colSpan: '7' }, checkGroup.checkListName + ' (' + instances.length.toString() + ')'));
                _.forEach(instances, function (instance) {
                    var resultClass = instance.result
                        ? (instance.result === aps_enums_1.apsEnums.CheckListResult.Pass
                            ? 'checklist-pass'
                            : (instance.result === aps_enums_1.apsEnums.CheckListResult.Fail
                                ? 'checklist-fail'
                                : 'checklist-incomplete'))
                        : 'checklist-incomplete';
                    var buttons = [
                        React.createElement('button', {
                            className: 'button tiny',
                            style: { margin: '0' },
                            onClick: function () { return _this.view(instance); }
                        }, 'View')
                    ];
                    if (_this.canEdit(instance)) {
                        buttons.push(React.createElement('button', {
                            className: 'button tiny',
                            style: { margin: '0 0 0 7px' },
                            onClick: function () { return _this.edit(instance); }
                        }, 'Edit'));
                    }
                    rows.push(React.createElement('tr', { key: instance.id }, React.createElement('td', { key: 'name' }, [
                        React.createElement('span', { style: { width: '20px', display: 'inline-block' } }, ' '),
                        instance.checkListName
                    ]), React.createElement('td', { key: 'schedule' }, _this.formatTime(instance.scheduledOn, instance.plantTimeZoneId)), React.createElement('td', { key: 'status' }, _this.formatStatus(instance.status)), React.createElement('td', { key: 'plantName' }, instance.plantName), React.createElement('td', { key: 'location' }, instance.locationName), React.createElement('td', { key: 'result' }, React.createElement('span', { className: resultClass }, _this.formatResult(instance.result))), React.createElement('td', { key: 'open', className: 'right' }, buttons)));
                });
            });
            return rows;
        };
        CheckListReportComponent.prototype.formatStatus = function (status) {
            return _.startCase(aps_enums_1.apsEnums.CheckListStatus[status]);
        };
        CheckListReportComponent.prototype.formatResult = function (result) {
            return _.startCase(aps_enums_1.apsEnums.CheckListResult[result]);
        };
        CheckListReportComponent.prototype.formatTime = function (time, timeZoneId) {
            return dateutility_service_1.default.formatTime(time, timeZoneId);
        };
        CheckListReportComponent.prototype.canEdit = function (checkListInstance) {
            if (checkListInstance.checkListIsGroup) {
                return false;
            }
            if (checkListInstance.status === aps_enums_1.apsEnums.CheckListStatus.Pending) {
                return false;
            }
            return CheckListReportComponent.checkListInstancesService
                .isAuthorizedForPlant(checkListInstance, this.props.plantId);
        };
        CheckListReportComponent.prototype.view = function (instance) {
            var promise = CheckListReportComponent.checkListsService
                .getCheckListReportDetail(instance.id, instance.plantLocationId, instance.scheduledOn, this.props.filter);
            CheckListReportComponent.loaderService.loadingPromise(promise);
            promise.then(function (data) {
                checkListReportDetails_controller_1.openCheckListReportDetails({
                    checkListInstance: instance,
                    detail: data
                }, CheckListReportComponent.$modal);
            });
        };
        CheckListReportComponent.prototype.edit = function (checkListInstance) {
            var result = fillOutCheckList_controller_1.openFillOutCheckList({
                checkListId: checkListInstance.checkListId,
                instanceId: checkListInstance.id,
                plantId: checkListInstance.plantId,
                tankId: checkListInstance.tankId,
                shopId: checkListInstance.shopId,
                plantLocationId: checkListInstance.plantLocationId,
                readOnly: false,
                scheduledOn: checkListInstance.scheduledOn
            }, CheckListReportComponent.$modal);
            result.then(function (cmd) {
                CheckListReportComponent.checkListInstancesService
                    .updateStatusAndResult(checkListInstance, cmd);
            });
        };
        return CheckListReportComponent;
    }(React.Component));
    exports.default = angular.module('aps.controller.checkListReport.react', requires)
        .factory('CheckListReportComponent', ["checkListInstancesService", "checkListsService", "loaderService", "$modal", "checkListInstancesHubCreator", function (checkListInstancesService, checkListsService, loaderService, $modal, checkListInstancesHubCreator) {
        CheckListReportComponent.checkListInstancesService = checkListInstancesService;
        CheckListReportComponent.checkListsService = checkListsService;
        CheckListReportComponent.loaderService = loaderService;
        CheckListReportComponent.$modal = $modal;
        CheckListReportComponent.checkListInstancesHubCreator = checkListInstancesHubCreator;
        return CheckListReportComponent;
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(3), __webpack_require__(5), __webpack_require__(602), __webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, constant_module_1, aps_enums_1, checks_tpl_html_1, authData_service_1) {
    "use strict";
    checksConfig.$inject = ["$stateProvider"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [authData_service_1.default];
    function checksConfig($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.CHECKS,
            url: "/checks",
            controller: "ChecksCtrl as vm",
            template: checks_tpl_html_1.default,
            data: { pageTitle: "Checks", v2Uri: "aps/dashboard/operator/check-list" },
        });
    }
    var ChecksCtrl = (function () {
        ChecksCtrl.$inject = ["authDataService", "$stateParams"];
        function ChecksCtrl(authDataService, $stateParams) {
            this.isSupervisor =
                authDataService.isPlantAdmin($stateParams.plantId) ||
                    authDataService.hasFlag(aps_enums_1.apsEnums.RoleFlags.ShiftSupervisor);
            this.viewAll = false;
        }
        return ChecksCtrl;
    }());
    exports.default = angular
        .module("aps.controller.checks", requires)
        .config(checksConfig)
        .controller("ChecksCtrl", ChecksCtrl).name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <div> <div class=body-header> <h2>Check Lists</h2> </div> <select ng-model=vm.viewAll convert-to-boolean> <option value=false>My Check Lists</option> <option value=true>All Check Lists</option> </select> </div> <div> <div class=body-header> <h2>Available and Upcoming Check Lists</h2> </div> <div class=cltable2> <aps-scheduled-check-lists check-list-view=All check-list-view-all=vm.viewAll /> </div> </div> <div> <div class=body-header> <h2>Recent Check Lists</h2> </div> <div class=cltable2> <aps-recent-check-lists check-list-view-all=vm.viewAll /> </div> </div> <div> <div class=body-header> <h2>Failed Checks</h2> </div> <div class=cltable2> <aps-failed-checks/> </div> </div> <div ng-if=vm.isSupervisor> <div class=body-header> <h2>Unfinished Check Lists</h2> </div> <div class=cltable2> <aps-unfinished-check-lists/> </div> </div> </div>");

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row-flex ag-header\"> <div class=\"ag-header-plant ag-header-box\"> <span class=ag-plant-name>{{vm.plant.name || \"...\"}}</span> <span class=ag-shop>Shop {{vm.shop.name}}</span> </div> <div class=\"ag-header-count-interval ag-header-box\"> <label> <span>Viewing Count Data For:</span> <select style=width:120px id=countsInterval ng-model=vm.countsInterval ng-options=\"t.value as t.text for t in vm.countDisplayIntervalOptions\" ng-change=vm.countsIntervalChanged() class=form-control></select> </label> </div> <div class=\"ag-header-btnarray ag-header-box\"> <btn-array options=vm.navigationUrls /> </div> </div> <div> <div style=\"padding:.625em 1.6%\"> <!-- body of the counts along the line --> <div> <h6> <b>EQUIPMENT COUNTS</b>&nbsp;<a ng-click=\"vm.showHelp('EQUIPMENT COUNTS')\"><i class=\"fa fa-info-circle fa-bigger\"></i></a> <div class=btn-switch-container> <div class=mb-2><h6><b>Denominator Toggle</b></h6></div> <div style=display:flex;align-items:center;justify-content:center> <span>Equipment</span> <div class=btn-switch ng-class=\"{'btn-switch--on':vm.model.usePercentGobs}\" ng-model=vm.model.usePercentGobs ng-click=vm.usePercentGobsChanged();> <div class=btn-switch-circle ng-class=\"{'btn-switch-circle--on':vm.model.usePercentGobs}\" ng-model=vm.model.usePercentGobs> </div> </div> <span>Shears</span> </div> </div> </h6> <div class=counts-body ng-class=vm.plant.name> <div class=\"c-columns area\" ng-repeat=\"area in vm.areas\"> <div class=c-row ng-repeat=\"row in area.rows\" ng-class=row.cssClass> <div class=connector ng-if=\"row.isLine && !$parent.$first\"></div> <div class=\"linerow equipment-groups\" ng-if=row.isLine ng-class=\"{'line-disabled': row.line.isDisabled, 'can-disable-line': vm.canDisableLine}\"> <div class=linenumber ng-click=vm.toggleLineActive(row.line)>{{row.line.name}}</div> <div ng-repeat=\"equip in row.line.equipment\" ng-click=\"vm.viewRejectDetail(row.line, equip)\" class=equipment style=cursor:pointer ng-class=\"{'equipment-disabled': equip.isDisabled}\"> <div ng-class=vm.getEquipmentClass(equip)></div> <div class=equipment-name ng-class=vm.getRowClass(equip)>{{equip.name}}</div> <div class=count>{{!equip.inspectCountHidden? (equip.inspectCount.count|number:0.0) : ''}}</div> <div ng-if=equip.rejectCount> <div class=count>{{equip.rejectCount.count|number:0.0}}<br/> <span ng-if=!equip.rejectPercentHidden ng-class=vm.getLossPercentClass(equip)> {{equip.rejectCount.getPercent()}}%&nbsp;<vert-trend trend=equip.rejectCount.trend style=margin-top:.1em /> </span> </div> </div> <div class=count>{{equip.inspectPercentVisible ? equip.inspectCount.percent + '%': ' '}}</div> </div> </div> <div class=connector ng-if=\"row.isLine && !$parent.$last\"></div> </div> </div> <div class=\"small-1 columns\"></div> <!--  effeciencies --> <div class=\"small-3 columns\"> <table class=history-t style=\"border:1px solid #d3d3d3\"> <caption> <b>AREA EFFICIENCY (% INSPECT VS. REJECT)</b>&nbsp;<a ng-click=\"vm.showHelp('AREA EFFICIENCY')\"><i class=\"fa fa-info-circle fa-bigger\"></i></a> </caption> <thead> <tr> <th></th> <th ng-repeat=\"group in vm.model.equipmentGroupsV1  | orderBy :'order'\" style=text-align:right;padding-right:1em> {{group.name}} </th> </tr> </thead> <tbody> <tr> <td style=font-weight:700>AREA IN</td> <td ng-repeat=\"group in vm.model.equipmentGroupsV1 | orderBy :'order'\" style=font-weight:700;text-align:right;padding-right:1.5em> {{group.inspectCount ? (group.inspectCount.count|number:0.0): '-' }} </td> </tr> <tr> <td style=font-weight:700>AREA REJECTS</td> <td ng-repeat=\"group in vm.model.equipmentGroupsV1  | orderBy :'order'\" class=checklist-fail style=text-align:right;padding-right:1.5em> {{group.rejectCount ? (group.rejectCount.count|number:0.0): '-' }} </td> </tr> <tr> <td style=font-weight:700>AREA REJECT</td> <td ng-repeat=\"group in vm.model.equipmentGroupsV1  | orderBy :'order'\" class=checklist-fail style=text-align:right> {{group.rejectCount ? (group.rejectCount.percent|number:0.0) + '%': '-' }} </td> </tr> <tr> <td style=font-weight:700>AREA EFFICIENCY</td> <td ng-repeat=\"group in vm.model.equipmentGroupsV1  | orderBy :'order'\" style=font-weight:700;text-align:right> {{group.inspectCount ? (group.inspectCount.percent|number:0.0) + '%': '-' }} </td> </tr> </tbody> </table> <table class=history-t style=\"border:1px solid #d3d3d3\"> <caption> <b>WARE LOSS (% OF SHEARS)</b>&nbsp;<a ng-click=\"vm.showHelp('WARE LOSS')\"><i class=\"fa fa-info-circle fa-bigger\"></i></a> </caption> <thead> <tr> <th>AREA LOSS</th> <th style=text-align:right>% OF SHEARS</th> </tr> </thead> <tbody> <tr ng-repeat=\"kpi in vm.model.kpisV1 | orderBy :'order'\"> <td style=font-weight:700> {{kpi.lossesName}} </td> <td style=color:red;font-weight:700;text-align:right> {{kpi.lossPercent}} </td> </tr> </tbody> </table> </div> </div> <br/> <div class=\"small-2 columns\"> <div class=kpi-row-label> <div class=\"center ag-card ag-card-footer\"> <div class=center style=font-weight:700>MACHINE SPEED</div> <div class=center> {{vm.model.kpisV1[0].denominator.speed}} </div> </div> </div> </div> <div class=\"columns small-2\" ng-if=kpi.efficiencyName ng-repeat=\"kpi in vm.model.kpisV1 | orderBy :'order'\"> <div class=kpi-row-label> <div class=\"center ag-card ag-card-footer\"> <div class=center style=font-weight:700>{{kpi.efficiencyName}}</div> <div class=center> {{kpi.efficiency}} </div> </div> </div> </div> <div class=\"columns small-2\"> <div class=kpi-row-label> <div class=\"center ag-card ag-card-footer\"> <div class=center style=font-weight:700>DUMP GATE TIME</div> <div class=center ng-class=\"(vm.dumpGateDuration != '')?'fail-rate':''\"> {{vm.dumpGateDuration/3600 - (vm.dumpGateDuration/3600%1)}}:{{ (vm.dumpGateDuration *1000) | date:'mm:ss' }} </div> </div> </div> </div> <div class=\"columns small-2\"></div> </div> <div ng-if=vm.showHelpWindow class=charthelpdetails> <div class=windowclose> <a><i class=\"fa fa-times-circle fa-bigger\" ng-click=vm.toggleHelpWindow()></i></a> </div> <div class=tooltiptext ng-bind-html=vm.helpText> </div> </div> </div></div>");

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <h2 class=modal-header> <div class=wsi-detail-header-left>{{vm.equipment.name}}-{{vm.line.name}}</div> <div class=wsi-detail-header-center>{{vm.lineEquipmentName}}</div> <div class=wsi-detail-header-right>{{vm.equipment.inspectCount.speed}}</div> </h2> <!-- inspect reject section --> <div class=modal-subheader> <div class=inspected>Inspected: {{vm.equipment.inspectCount.count}}</div> <div class=rejected ng-if=vm.equipment.rejectCount> Rejected: {{vm.equipment.rejectCount.count}}&nbsp;&nbsp; {{vm.equipment.rejectCount.getPercent()}}%&nbsp;&nbsp; <i class=trend ng-class=\"{'trend-up': vm.equipment.rejectCount.trend.up, 'trend-down': vm.equipment.rejectCount.trend.down}\"></i> </div> </div> <!-- dialog tab navigation --> <tabset ng-if=vm.detail> <tab class=\"{{vm.tabClass}}\" ng-if=\"vm.detail.details.length > 0 && vm.equipment.name != 'MX4'\" heading=Detail> <table class=er-table> <tbody> <tr class=count-detail-row ng-repeat=\"detail in vm.detail.details\"> <td class=er-spacer style=width:10em>{{detail.name}}</td> <td class=rightJustify style=width:5em>{{detail.count.count}}</td> <td class=rightJustify style=width:5em ng-if=detail.count.showPercent>{{detail.count.getPercent()}}</td> <td ng-if=detail.count.showTrend style=width:3em> <i class=trend ng-class=\"{'trend-up': detail.count.trend.up, 'trend-down': detail.count.trend.down}\"></i> </td> </tr> </tbody> </table> </tab> <tab class=\"{{vm.tabClass}}\" ng-repeat=\"tab in vm.detail.tabs\" heading=\"{{tab.name}}\" alt=\"{{tab.toolTip}}\" title=\"{{tab.toolTip}}\"> <react-component name=CountDetailComponent props=tab watch-depth=collection></react-component> </tab> <tab class=\"{{vm.tabClass}}\" ng-if=\"vm.detail.details.length > 0 && vm.equipment.name == 'MX4'\" heading=Cnts> <table class=er-table> <tbody> <tr class=count-detail-row ng-repeat=\"detail in vm.detail.details\"> <td class=er-spacer style=width:10em>{{detail.name}}</td> <td class=rightJustify style=width:5em>{{detail.count.count}}</td> <td class=rightJustify style=width:5em ng-if=detail.count.showPercent>{{detail.count.getPercent()}}</td> <td ng-if=detail.count.showTrend style=width:3em> <i class=trend ng-class=\"{'trend-up': detail.count.trend.up, 'trend-down': detail.count.trend.down}\"></i> </td> </tr> </tbody> </table> </tab> </tabset> <div class=row style=margin-bottom:1em ng-if=vm.showHealth> <div class=\"columns large-3\"> Health State:<br/> <span ng-class=vm.equipment.healthCssText> {{vm.equipmentHealthState[vm.equipment.equipmentHealthState] || 'Unknown'}} </span> </div> <div class=\"columns large-3\"> Last Health Change:<br/> {{vm.formatTime(vm.equipment.equipmentLastHealthStateUpdate)}} </div> <div class=\"columns large-6\" ng-if=vm.equipment.equipmentHealthStateDetail> Reason:<br/> {{vm.equipment.equipmentHealthStateDetail}} </div> </div> <div class=dialog-footer> <div class=left ng-if=vm.canDisable> <button type=button class=button ng-class=\"{'alert': !vm.equipment.isDisabled}\" ng-click=vm.toggleActive()> {{vm.equipment.isDisabled ? 'Activate' : 'Disable'}} </button> </div> <div class=right> <button type=button class=\"button secondary\" ng-click=vm.close()>Close</button> <button type=button class=\"button primary\" ng-if=vm.isEquipmentWithInconsistencies ng-click=vm.viewInconsistencies()>View Inconsistencies</button> </div> </div> </div>");

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(4), __webpack_require__(26), __webpack_require__(606)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, loader_service_1, counts_service_1, inconsistentEquipmentConfigurations_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, counts_service_1.default];
    function openInconsistentConfigurations(data, $modal) {
        return $modal.open({
            template: inconsistentEquipmentConfigurations_tpl_html_1.default,
            controller: 'InconsistentEquipmentConfigurationsCtrl as vm',
            resolve: {
                data: function () { return data; }
            }
        }).result;
    }
    exports.openInconsistentConfigurations = openInconsistentConfigurations;
    var InconsistentEquipmentConfigurationsControllerImpl = (function () {
        InconsistentEquipmentConfigurationsControllerImpl.$inject = ["data", "$modalInstance", "loaderService", "countsService"];
        function InconsistentEquipmentConfigurationsControllerImpl(data, $modalInstance, loaderService, countsService) {
            var _this = this;
            this.$modalInstance = $modalInstance;
            this.loaderService = loaderService;
            this.countsService = countsService;
            this.equipmentName = data.equipmentName;
            var dataPromise = this.countsService.getEquipmentInconsistencies(data.shopId, data.equipmentId, data.lineConfig)
                .then(function (inconsistenciesResult) {
                _this.inconsistencies = inconsistenciesResult;
            });
            this.loaderService.loadingPromise(dataPromise);
        }
        InconsistentEquipmentConfigurationsControllerImpl.prototype.close = function () {
            this.$modalInstance.close();
        };
        return InconsistentEquipmentConfigurationsControllerImpl;
    }());
    exports.default = angular.module('aps.controller.counts.inconsistentEquipmentConfigurations', requires)
        .controller('InconsistentEquipmentConfigurationsCtrl', InconsistentEquipmentConfigurationsControllerImpl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <h2 class=modal-header> <div class=wsi-detail-header-left> {{vm.equipmentName}} Configuration Inconsistencies {{((!vm.inconsistencies || vm.inconsistencies.length < 100) ? '' : ' (showing first 100)')}} </div> <div class=wsi-detail-header-center></div> <div class=wsi-detail-header-right></div> </h2> <div class=modal-subheader> </div> <!-- if there are no inconsistencies to show --> <div class=er-details style=margin-bottom:1rem ng-if=\"vm.inconsistencies && vm.inconsistencies.length === 0\"> <div>No inconsistencies to display.</div> </div> <!-- if there are inconsistencies to show --> <div ng-if=\"vm.inconsistencies && vm.inconsistencies.length > 0\" style=max-height:500px;overflow-y:auto> <div class=er-details style=margin-bottom:1rem ng-repeat=\"inconsistencyGroup in vm.inconsistencies\"> <div style=font-weight:600>{{inconsistencyGroup.node}}</div> <div style=margin-top:.25rem;padding-left:1rem ng-repeat=\"item in inconsistencyGroup.inconsistencies\"> {{item.lineName}}<span ng-if=\"item.value !== null\">: </span>{{item.value}} </div> </div> </div> <!-- bottom button --> <div style=margin-top:.3rem> <button type=button class=\"button counts-close-button\" ng-click=vm.close()>Close</button> </div> </div>");

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div id=weightChart class=dashboard-gob-weights> <nvd3 options=vm.chartOptions data=vm.gobWeightsPretty api=vm.api config=\"{deepWatchData: true}\"></nvd3> <div class=row> <div style=display:flex> <div class=\"small-6 large-6\" ng-if=vm.isScaleButtonVisible> <button ng-repeat=\"hour in vm.weightHourOptions\" ng-class=\"{ 'default btn-array' : vm.hoursToShow === hour, 'secondary btn-array': vm.hoursToShow !== hour }\" ng-click=vm.changeWeightHours(hour) ng-disabled=\"vm.hoursToShow === hour\"> {{hour}} Hours </button> <button ng-class=\"{ 'default btn-array' : !vm.isRelativeToNow, 'secondary btn-array': vm.isRelativeToNow }\" ng-click=vm.applyCustomRange() ng-disabled=!vm.isRelativeToNow> Custom Range </button> </div> <div class=\"small-6 large-6\"> <table class=scaleMode> <tr ng-repeat=\"eq in vm.scales\" class=scaleMode> <td class=td-spacer>&nbsp;</td> <td class=scaleMode> {{eq.name}} is in {{eq.modeName}} mode </td> <td class=td-spacer2>&nbsp;</td> <td align=right ng-repeat=\"mode in eq.availableModes\" class=scaleMode2 ng-if=vm.isScaleMode> Switch to <button align=right ng-click=\"vm.toggleScaleMode(eq, mode.value)\" class=\"button tiny button-toggle\">{{mode.text}}</button> </td> </tr> </table> </div> </div> <div class=\"small-4 large-6\"> <div ng-if=!vm.isRelativeToNow> <label>Start Date <input type=datetime-local date-time-picker ng-model=vm.uiStart time-model=vm.start time-zone=vm.timeZoneId name=startDate required/> </label> <label>End Date <input type=datetime-local ng-model=vm.uiEnd date-time-picker time-model=vm.end time-zone=vm.timeZoneId name=endDate min=\"{{ vm.uiStart }}\" required/> </label> <button ng-class=\"{ 'secondary btn-array': true }\" ng-click=vm.applyCustomRange()> Submit </button> </div> <div ng-if=vm.isZoomed> <button ng-class=\"{ 'default btn-array' : !vm.isZoomed, 'secondary btn-array': vm.isZoomed }\" ng-click=vm.endZoom()> Reset View </button> </div> </div> </div> </div>");

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(95), __webpack_require__(5), __webpack_require__(11), __webpack_require__(23), __webpack_require__(4), __webpack_require__(609), __webpack_require__(301), __webpack_require__(53), __webpack_require__(33), __webpack_require__(7), __webpack_require__(6), __webpack_require__(610), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, moment, d3, aps_enums_1, dateutility_service_1, shops_service_1, loader_service_1, gobWeights_hub_1, gobWeights_service_1, auth_service_1, equipment_service_1, authData_service_1, notify_service_1, gobWeightDetail_controller_1, _) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [shops_service_1.default, loader_service_1.default, gobWeights_hub_1.default, gobWeights_service_1.default, auth_service_1.default,
        equipment_service_1.default, authData_service_1.default, notify_service_1.default, gobWeightDetail_controller_1.default];
    var GobWeightsGraphCtrl = (function () {
        GobWeightsGraphCtrl.$inject = ["gobWeightsService", "loaderService", "shopService", "$q", "$timeout", "uiUtilityService", "gobWeightsHubService", "$interval", "$scope", "$modal", "authService", "equipmentService", "authDataService", "notifyService"];
        function GobWeightsGraphCtrl(gobWeightsService, loaderService, shopService, $q, $timeout, uiUtilityService, gobWeightsHubService, $interval, $scope, $modal, authService, equipmentService, authDataService, notifyService) {
            var _this = this;
            this.padding = 20;
            this.isRelativeToNow = true;
            this.isScaleButtonVisible = true;
            this.chartUpdateInterval = 60000;
            this.allowZoom = false;
            this.chartInitialized = false;
            this.machineNameMap = {};
            this.scale = 1;
            this.scaleExtent = [1, 10];
            this.translate = [0, 0];
            this.zoomLevel = 1;
            this.$scope = $scope;
            this.$modal = $modal;
            this.$interval = $interval;
            this.gobWeightsService = gobWeightsService;
            this.loaderService = loaderService;
            this.shopService = shopService;
            this.authService = authService;
            this.equipmentService = equipmentService;
            this.authDataService = authDataService;
            this.isScaleMode = this.authDataService.isScaleMode();
            this.notifyService = notifyService;
            this.scaleModes = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.ScaleMode, 1);
            this.$q = $q;
            $timeout(function () {
                _this.gobWeightsHub = gobWeightsHubService.createGobWeightsHub(_this.shopId, function (w) { return _this.addIncomingGobWeight(w); }, function (c) { return _this.addIncomingGobWeightComment(c); });
                _this.weightHourOptions = [4, 24];
                _this.xScale1 = d3.time.scale();
                _this.chartOptions = {
                    chart: {
                        type: 'lineChart',
                        useInteractiveGuideline: false,
                        width: _this.width || 1200,
                        height: _this.height || 500,
                        margin: {
                            top: 50,
                            right: 50,
                            bottom: 50,
                            left: 75
                        },
                        pointSize: 20,
                        x: function (w) { return w.x; },
                        y: function (w) { return w.y; },
                        tooltip: {
                            contentGenerator: function (d) {
                                var label = moment(_this.getLocalTime(d.value)).format('ddd, MMM DD h:mmA');
                                var formatted = "<table><thead><tr><td colspan=\"3\"><strong>" + label + "</strong></td></tr></thead>";
                                formatted += "<tbody><tr><td class=\"legend-color-guide\"><div style=\"background-color: " + d.series[0].color + ";\"></div></td>";
                                formatted += "<td class=\"key\">" + d.series[0].key + "</td><td class=\"value\">" + d.series[0].value + "</td></tr></tbody></table>";
                                return formatted;
                            }
                        },
                        xAxis: {
                            axisLabel: 'Hour',
                            showMaxMin: false,
                            ticks: d3.time.hour,
                            tickFormat: function (d) {
                                return d3.time.format('%H')(_this.getLocalTime(new Date(d)));
                            }
                        },
                        xScale: _this.xScale1,
                        yAxis: {
                            axisLabel: 'Weight (oz)',
                            showMaxMin: false,
                            tickFormat: function (d) {
                                var digitsOfPrecision = _this.zoomLevel >= 4 ? 3 : 2;
                                return d.toFixed(digitsOfPrecision);
                            }
                        },
                        title: {
                            enabled: true,
                            text: 'Gob Weight Samples, ' + _this.getFriendlyTimespanName()
                        },
                        dispatch: {
                            renderEnd: function (e) {
                                if (!_this.chartInitialized) {
                                    _this.initZoom();
                                    _this.formatChart();
                                    _this.chartInitialized = true;
                                }
                            }
                        },
                        zoom: {
                            enabled: _this.allowZoom
                        }
                    }
                };
                _this.initializeData();
            });
            $scope.$on('$destroy', function () {
                if (_this.gobWeightsHub) {
                    _this.gobWeightsHub.leaveGroup(_this.shopId)
                        .then(function () { return _this.gobWeightsHub.uninitialize(); });
                }
            });
        }
        GobWeightsGraphCtrl.prototype.initializeData = function () {
            var _this = this;
            this.shopService.getShopConfiguration(this.shopId)
                .then(function (shop) {
                var rawStart = moment().subtract(_this.hoursToShow, 'hours');
                _this.shop = shop;
                _this.timeZoneId = shop.timeZoneId;
                _this.uiStart = _this.getPlantTime(rawStart.toDate());
                _this.uiEnd = _this.getPlantTime(moment().toDate());
                _this.start = _this.getLocalTime(_this.uiStart);
                _this.end = _this.getLocalTime(_this.uiEnd);
                _.each(_this.shop.machineConfigurations, function (m) {
                    _this.machineNameMap[m.id] = m.name[m.name.length - 1];
                });
                _this.loadGobWeightHistoryReport();
                _this.loadScales();
            });
        };
        GobWeightsGraphCtrl.prototype.getPlantTime = function (localTime) {
            return dateutility_service_1.default.localToTimeZone(localTime, this.timeZoneId).toDate();
        };
        GobWeightsGraphCtrl.prototype.getLocalTime = function (plantTime) {
            return dateutility_service_1.default.timeZoneToLocal(plantTime, this.timeZoneId).toDate();
        };
        GobWeightsGraphCtrl.prototype.formatChart = function () {
            var _this = this;
            var scope = this.api.getScope();
            this.api.refresh();
            if (scope) {
                var chart = scope.chart;
                chart.lines.dispatch.on('elementClick', function (e) {
                    _this.viewWeightDetail(e);
                });
            }
            scope.chart.yScale = d3.scale.linear().domain([this.getGlobalMinWeight(), this.getGlobalMaxWeight()])
                .range([this.height * 0.85, this.height * 0.15]);
            this.updatePointCssClasses();
            var elems = document.getElementsByClassName('nv-legend-symbol');
            var observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutationRecord) {
                    _this.updatePointCssClasses();
                });
            });
            for (var ctr = 0; ctr < elems.length; ctr++) {
                observer.observe(elems[ctr], { attributes: true, attributeFilter: ['style'] });
            }
        };
        GobWeightsGraphCtrl.prototype.getGlobalMinWeight = function () {
            return d3.min(this.gobWeightsPretty, function (s) { return d3.min(s.values, function (w) { return w.y; }); });
        };
        GobWeightsGraphCtrl.prototype.getGlobalMaxWeight = function () {
            return d3.max(this.gobWeightsPretty, function (s) { return d3.max(s.values, function (w) { return w.y; }); });
        };
        GobWeightsGraphCtrl.prototype.initZoom = function () {
            if (!this.allowZoom) {
                return;
            }
            var scope = this.api.getScope();
            var xDomain = scope.chart.xDomain || this.xScale.domain;
            var yDomain = scope.chart.yDomain || this.yScale.domain;
            var unzoomEventType = 'dblclick.zoom';
            var d3zoom;
            var zoomed;
            var unzoomed;
            var self = this;
            var rect = d3.select('rect');
            var width = parseInt(rect.attr('width'), 10);
            var height = parseInt(rect.attr('height'), 10);
            var xBoundary = d3.time.scale().domain([this.start, this.end]).range([0, width]);
            var yBoundary = d3.scale.linear().domain([this.getGlobalMinWeight(), this.getGlobalMaxWeight()])
                .range([height * 0.85, height * 0.15]);
            if (this.zoomLevel === 1 || !this.xScale || !this.yScale) {
                this.xScale = xBoundary;
                this.yScale = yBoundary;
            }
            zoomed = function () {
                self.zoomLevel = d3.event.scale;
                xDomain(self.xScale.domain());
                yDomain(self.yScale.domain());
                if (scope.chart) {
                    scope.chart.update();
                }
            };
            unzoomed = function () {
                self.zoomLevel = d3.event.scale;
                xDomain([self.start, self.end]);
                yDomain([self.getGlobalMinWeight(), self.getGlobalMaxWeight()]);
                d3zoom.scale(self.scale).translate(self.translate);
                if (scope.chart) {
                    scope.chart.update();
                }
            };
            d3zoom = d3.behavior.zoom()
                .x(this.xScale)
                .y(this.yScale)
                .scaleExtent(this.scaleExtent)
                .on('zoom', zoomed);
            if (scope.svg) {
                scope.svg.call(d3zoom);
                d3zoom.scale(this.scale).translate(this.translate);
                if (this.zoomLevel === 1) {
                    d3zoom.event(scope.svg);
                }
                scope.svg.on(unzoomEventType, unzoomed);
            }
        };
        GobWeightsGraphCtrl.prototype.loadGobWeightHistoryReport = function () {
            var _this = this;
            this.chartInitialized = false;
            if (this.chartIntervalPromise) {
                this.$interval.cancel(this.chartIntervalPromise);
                this.chartIntervalPromise = null;
            }
            return this.gobWeightsService.getGobWeightHistoryReport(this.shopId, this.start, this.end)
                .then(function (weightChart) {
                _this.gobWeightsReport = weightChart;
                _this.prepareGobWeightsForChart();
                _this.formatChart();
                if (_this.isRelativeToNow) {
                    _this.chartIntervalPromise = _this.$interval(function () { return _this.updateRelativeTimeframe(); }, _this.chartUpdateInterval);
                }
            });
        };
        GobWeightsGraphCtrl.prototype.addIncomingGobWeight = function (weight) {
            if (weight.shopId !== this.shopId) {
                return;
            }
            if (!this.isRelativeToNow) {
                var time = weight.timeWeighed.getTime();
                if (time < this.start.getTime() || time >= this.end.getTime()) {
                    return;
                }
            }
            this.gobWeightsReport.gobWeights.push(weight);
            this.updateRelativeTimeframe();
            this.updatePointCssClasses();
        };
        GobWeightsGraphCtrl.prototype.addIncomingGobWeightComment = function (comment) {
            if (comment.shopId !== this.shopId) {
                return;
            }
            var commentTime = comment.createdOn.getTime();
            var weight = _.find(this.gobWeightsReport.gobWeights, function (w) { return w.timeWeighed.getTime() === commentTime
                && w.gob === comment.gob
                && w.isMachineId === comment.isMachineId; });
            if (!weight) {
                return;
            }
            if (_.some(weight.comments, function (c) { return c.createdOn.getTime() === commentTime; })) {
                return;
            }
            weight.comments.push(comment);
            this.prepareGobWeightsForChart();
        };
        GobWeightsGraphCtrl.prototype.updateRelativeTimeframe = function () {
            if (!this.isRelativeToNow) {
                return;
            }
            var end = moment();
            this.end = end.toDate();
            this.start = end.subtract(this.hoursToShow, 'hours').toDate();
            this.pruneExpiredData();
            this.initZoom();
        };
        GobWeightsGraphCtrl.prototype.pruneExpiredData = function () {
            var _this = this;
            _.remove(this.gobWeightsReport.gobWeights, function (w) { return w.timeWeighed < _this.start; });
            this.prepareGobWeightsForChart();
        };
        GobWeightsGraphCtrl.prototype.changeWeightHours = function (hours) {
            if (hours === this.hoursToShow) {
                return;
            }
            this.isRelativeToNow = true;
            this.start = moment().subtract(hours, 'hours').toDate();
            this.end = moment().toDate();
            this.hoursToShow = hours;
            this.loadGobWeightHistoryReport();
        };
        GobWeightsGraphCtrl.prototype.applyCustomRange = function () {
            this.isRelativeToNow = false;
            this.hoursToShow = null;
            this.loadGobWeightHistoryReport();
        };
        GobWeightsGraphCtrl.prototype.getFriendlyTimespanName = function () {
            var name = (this.isRelativeToNow) ? 'Past ' : '';
            var start = moment(this.start);
            var end = this.end ? moment(this.end) : moment();
            var span = moment.duration(end.diff(start));
            name += span.humanize(true);
            return name;
        };
        GobWeightsGraphCtrl.prototype.prepareGobWeightsForChart = function () {
            var gobs = [];
            var numericGobs = [];
            var colorIndex = 0;
            var colors = ['#1F77B4', '#FF7F0E', '#0F645F', '#800080', '#20B2AA', '#B22222'];
            for (var _i = 0, _a = this.gobWeightsReport.gobWeights; _i < _a.length; _i++) {
                var w = _a[_i];
                var name = w.gobName;
                if (this.shop.machineConfigurations.length > 1) {
                    name = this.machineNameMap[w.isMachineId] + '-' + w.gobName;
                }
                if (!gobs[name]) {
                    gobs[name] = {
                        values: [],
                        key: name
                    };
                    if (colors.length >= colorIndex + 1) {
                        gobs[name].color = colors[colorIndex++];
                    }
                }
                gobs[name].values.unshift({
                    instance: w,
                    x: w.timeWeighed,
                    y: w.weight.toFixed(2)
                });
            }
            var boundaries = [
                { name: 'Target', key: 'weightTarget', color: 'green', calc: function (w) { return w.target; } },
                { name: 'Alarm Low', key: 'weightAlarmLower', color: 'red', calc: function (w) { return w.target * (1.0 - w.alarmMargin); } },
                { name: 'Alarm High', key: 'weightAlarmUpper', color: 'red', calc: function (w) { return w.target * (1.0 + w.alarmMargin); } },
                { name: 'Warn Low', key: 'weightWarningLower', color: 'orange', calc: function (w) { return w.target * (1.0 - w.warnMargin); } },
                { name: 'Warn High', key: 'weightWarningUpper', color: 'orange', calc: function (w) { return w.target * (1.0 + w.warnMargin); } },
                { name: ' ', key: 'top', color: 'white', calc: function (w) { return w.target * (1.0 + w.alarmMargin * 1.1); } },
                { name: '  ', key: 'bottom', color: 'white', calc: function (w) { return w.target * (1.0 - w.alarmMargin * 0.9); } }
            ];
            for (var _b = 0, boundaries_1 = boundaries; _b < boundaries_1.length; _b++) {
                var b = boundaries_1[_b];
                gobs[b.name] = {
                    values: [],
                    key: b.name,
                    color: b.color
                };
                for (var _c = 0, _d = this.gobWeightsReport.weightTargets; _c < _d.length; _c++) {
                    var t = _d[_c];
                    gobs[b.name].values.push({
                        x: t.startDate < this.start ? this.start : t.startDate,
                        y: t[b.key]
                    }, {
                        x: (t.endDate && t.endDate < this.end) ? t.endDate : this.end,
                        y: t[b.key]
                    });
                    if (b.key === 'top') {
                        gobs[b.name].values.push({
                            x: t.startDate < this.start ? this.start : t.startDate,
                            y: t.weightTarget + (t.weightAlarmUpper - t.weightTarget) * 1.5
                        }, {
                            x: (t.endDate && t.endDate < this.end) ? t.endDate : this.end,
                            y: t.weightTarget + (t.weightAlarmUpper - t.weightTarget) * 1.5
                        });
                    }
                    if (b.key === 'bottom') {
                        gobs[b.name].values.push({
                            x: t.startDate < this.start ? this.start : t.startDate,
                            y: t.weightTarget - (t.weightTarget - t.weightAlarmLower) * 1.5
                        }, {
                            x: (t.endDate && t.endDate < this.end) ? t.endDate : this.end,
                            y: t.weightTarget - (t.weightTarget - t.weightAlarmLower) * 1.5
                        });
                    }
                }
            }
            for (var g in gobs) {
                gobs[g].values = _.sortBy(gobs[g].values, function (w) { return w.x; });
                numericGobs.push(gobs[g]);
            }
            numericGobs = _.sortBy(numericGobs, function (g) {
                var value = 0;
                if (g.key.length > 3) {
                    value = 100000;
                }
                else {
                    if (g.key.length >= 3) {
                        value += g.key[0].charCodeAt(0) * 500;
                        value += g.key[2] === 'B' ? 200 : g.key[2].charCodeAt(0);
                    }
                    else {
                        value += g.key[0] === 'B' ? 200 : g.key[0].charCodeAt(0);
                    }
                }
                return value;
            });
            this.gobWeightsPretty = numericGobs;
        };
        GobWeightsGraphCtrl.prototype.updatePointCssClasses = function () {
            var points = d3.selectAll('.nv-point')[0];
            for (var _i = 0, points_1 = points; _i < points_1.length; _i++) {
                var p = points_1[_i];
                var d = d3.select(p).data()[0][0];
                if (!d.instance) {
                    continue;
                }
                d3.select(p).classed('nv-point-comments', d.instance.comments && d.instance.comments.length > 0);
                d3.select(p).classed('nv-point-nocomments', !d.instance.comments || d.instance.comments.length === 0);
            }
        };
        GobWeightsGraphCtrl.prototype.viewWeightDetail = function (weight) {
            var _this = this;
            var chart = this.api.getScope().chart;
            chart.tooltip.hidden(true);
            var userPromise = this.currentUser ? this.$q.when(this.currentUser) : this.authService.getUserData();
            userPromise.then(function (user) {
                _this.currentUser = user;
                var result = gobWeightDetail_controller_1.openGobWeightDetail({
                    plantId: _this.shop.plantId,
                    shop: _this.shop,
                    weight: weight.point.instance,
                    user: _this.currentUser
                }, _this.$modal);
                result.then(function (resultData) {
                    if (resultData.gobWeightDeleted) {
                        var deletedWeight = weight.point.instance;
                        _.remove(_this.gobWeightsReport.gobWeights, deletedWeight);
                    }
                    if (resultData.commentsAdded || resultData.gobWeightDeleted) {
                        _this.prepareGobWeightsForChart();
                        _this.updatePointCssClasses();
                    }
                    chart.lines.clearHighlights();
                });
            });
        };
        GobWeightsGraphCtrl.prototype.setMode = function (instance, newMode) {
            instance.scaleConfig.Mode = newMode;
            instance.modeName = aps_enums_1.apsEnums.ScaleMode[newMode];
            instance.availableModes = this.scaleModes.filter(function (x) { return x.value !== newMode; });
        };
        GobWeightsGraphCtrl.prototype.loadScales = function () {
            var _this = this;
            this.equipmentService.getScales(this.shop.plantId, this.shop.id).then(function (scaleList) {
                _this.scales = scaleList;
                _this.scales.forEach(function (s) {
                    s.scaleConfig = JSON.parse(s.config);
                    _this.setMode(s, s.scaleConfig.Mode);
                });
            });
        };
        GobWeightsGraphCtrl.prototype.toggleScaleMode = function (instance, newMode) {
            var _this = this;
            this.loaderService.loadingPromise(this.equipmentService.setScaleMode({
                id: instance.id,
                plantId: this.shop.plantId,
                mode: newMode
            }).then(function () { _this.setMode(instance, newMode); }, this.notifyService.handleApiErrors));
        };
        return GobWeightsGraphCtrl;
    }());
    exports.default = angular.module('aps.controller.gobWeightsGraph', requires)
        .controller('GobWeightsGraphCtrl', GobWeightsGraphCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(37)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, hub_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var GobWeightsHubServiceImpl = (function () {
        GobWeightsHubServiceImpl.$inject = ["$timeout", "hubService"];
        function GobWeightsHubServiceImpl($timeout, hubService) {
            this.$timeout = $timeout;
            this.hubService = hubService;
        }
        GobWeightsHubServiceImpl.prototype.createGobWeightsHub = function (shopId, addGobWeight, addGobWeightComment) {
            var self = this;
            var gobWeightsHub = this.hubService.createHub('gobWeights', {
                listeners: {
                    gobWeightAdded: function (gobWeight) {
                        self.$timeout(function () { return addGobWeight(gobWeight); });
                    },
                    gobWeightCommentAdded: function (gobWeightComment) {
                        self.$timeout(function () { return addGobWeightComment(gobWeightComment); });
                    }
                },
                methods: ['leaveGroup', 'joinGroup'],
                postConnect: function (hub) {
                    hub.invokeWithRetry(function () { return hub.joinGroup(shopId); });
                }
            });
            return gobWeightsHub;
        };
        return GobWeightsHubServiceImpl;
    }());
    exports.default = angular.module('aps.hubs.gobWeights', [hub_service_1.default])
        .service('gobWeightsHubService', GobWeightsHubServiceImpl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(301), __webpack_require__(4), __webpack_require__(611), __webpack_require__(6), __webpack_require__(7), __webpack_require__(11), __webpack_require__(12), __webpack_require__(613)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, gobWeights_service_1, loader_service_1, deleteGobWeight_controller_1, notify_service_1, authData_service_1, dateutility_service_1, newguid_service_1, gobWeightDetail_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [deleteGobWeight_controller_1.default, gobWeights_service_1.default, authData_service_1.default, loader_service_1.default, notify_service_1.default, newguid_service_1.default];
    function openGobWeightDetail(data, $modal) {
        return $modal.open({
            template: gobWeightDetail_tpl_html_1.default,
            controller: 'GobWeightDetailCtrl as vm',
            resolve: {
                data: function () { return data; }
            }
        }).result;
    }
    exports.openGobWeightDetail = openGobWeightDetail;
    var GobWeightDetailCtrl = (function () {
        GobWeightDetailCtrl.$inject = ["data", "$modalInstance", "$modal", "gobWeightsService", "newGuidService", "loaderService", "authDataService", "notifyService"];
        function GobWeightDetailCtrl(data, $modalInstance, $modal, gobWeightsService, newGuidService, loaderService, authDataService, notifyService) {
            var _this = this;
            this.commentsAdded = false;
            this.commentText = '';
            this.canDeleteWeight = false;
            this.deleteGobWeight = function () {
                var result = deleteGobWeight_controller_1.openDeleteGobWeight(_this.$modal);
                result.then(function (reason) {
                    if (!reason) {
                        return;
                    }
                    var deleteWeight = {
                        shopId: _this.shop.id,
                        gob: _this.weight.gob,
                        isMachineId: _this.weight.isMachineId,
                        timeWeighed: _this.weight.timeWeighed,
                        comment: reason
                    };
                    var results = {
                        commentsAdded: true,
                        gobWeightDeleted: true
                    };
                    var promise = _this.gobWeightsService.deleteGobWeight(deleteWeight)
                        .then(function () { return _this.$modalInstance.close(results); }, _this.notifyService.handleApiErrors);
                    _this.loaderService.loadingPromise(promise);
                });
            };
            this.weight = data.weight;
            this.plantId = data.plantId;
            this.shop = data.shop;
            this.$modalInstance = $modalInstance;
            this.$modal = $modal;
            this.loaderService = loaderService;
            this.gobWeightsService = gobWeightsService;
            this.notifyService = notifyService;
            this.newGuidService = newGuidService;
            this.authDataService = authDataService;
            this.currentUser = data.user;
            this.canDeleteWeight = false;
            if (authDataService.canDeleteWeights()) {
                this.canDeleteWeight = true;
            }
        }
        GobWeightDetailCtrl.prototype.ok = function () {
            this.$modalInstance.close(this.commentsAdded);
        };
        GobWeightDetailCtrl.prototype.addWeightComment = function () {
            var _this = this;
            if (this.commentForm.$invalid) {
                return;
            }
            var weightComment = {
                shopId: this.shop.id,
                comment: this.commentText,
                gob: this.weight.gob,
                isMachineId: this.weight.isMachineId,
                timeWeighed: this.weight.timeWeighed,
                createdOn: new Date()
            };
            var promise = this.gobWeightsService.addWeightComment(weightComment).then(function () {
                _this.handleAddGobWeightComments(weightComment);
                _this.commentsAdded = true;
                _this.commentText = '';
                _this.commentForm.$setPristine();
            }, this.notifyService.handleApiErrors);
            this.loaderService.loadingPromise(promise);
        };
        GobWeightDetailCtrl.prototype.getPlantTime = function (time) {
            return dateutility_service_1.default.formatTime(time, this.shop.timeZoneId);
        };
        GobWeightDetailCtrl.prototype.handleAddGobWeightComments = function (cmd) {
            if (!_.some(this.weight.comments, (function (c) { return c.createdOn.getTime() === cmd.createdOn.getTime(); }))) {
                this.weight.comments.push({
                    comment: cmd.comment,
                    createdOn: cmd.createdOn,
                    createdByFullName: this.currentUser.fullName
                });
            }
        };
        return GobWeightDetailCtrl;
    }());
    exports.default = angular.module('aps.controller.gobWeightDetail', requires)
        .controller('GobWeightDetailCtrl', GobWeightDetailCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(612)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, deleteGobWeight_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function openDeleteGobWeight($modal) {
        return $modal.open({
            template: deleteGobWeight_tpl_html_1.default,
            controller: 'DeleteGobWeightCtrl as vm',
        }).result;
    }
    exports.openDeleteGobWeight = openDeleteGobWeight;
    exports.default = angular.module('aps.controller.deleteGobWeight', [])
        .controller('DeleteGobWeightCtrl', ["$modalInstance", function ($modalInstance) {
        var vm = {
            comment: null,
            form: null,
            cancel: function () { return $modalInstance.close(); },
            submit: function () {
                if (vm.form.$invalid) {
                    return;
                }
                $modalInstance.close(vm.comment);
            }
        };
        return vm;
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <form name=vm.form ng-submit=vm.submit() novalidate class=checks-m-w> <h2 class=modal-header>Delete Defect</h2> <div class=row> <div class=\"large-12 columns\"> Are you sure you want to delete this gob weight?<br/> If so, please enter the reason you are deleting it and press 'Delete'. Otherwise, press 'Cancel'. <br/>&nbsp; </div> </div> <div class=row> <div class=\"large-12 columns\"> <label> <span style=color:red>*</span>Reason: <textarea name=comment ng-model=vm.comment rows=4 required/> </label> <div ng-messages=vm.form.comment.$error ng-if=\"vm.form.comment.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=\"required req-w\"><div class=arrow-up></div>Required</div> </div> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-12 columns\" style=\"margin:20px 0 0 0\"> <div class=\"right dialog-footer\"> <button type=submit class=button>Delete</button> <button type=button class=\"button secondary\" ng-click=vm.cancel()>Cancel</button> </div> </div> </div> </form> </div>");

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <h2 class=modal-header>Weight Detail</h2> <div class=container style=\"margin:0 -30px\"> <div class=row> <div class=\"large-6 columns\"> <label>Time Taken:</label> <div>{{vm.getPlantTime(vm.weight.timeWeighed)}}</div> </div> <div class=\"large-6 columns\"> <label>Weight:</label> <div>{{vm.weight.weight.toFixed(2)}}</div> </div> </div> <div class=row style=margin-top:20px> <div class=\"large-6 columns\"> <label>Machine:</label> <div>{{vm.weight.isMachineName}}</div> </div> <div class=\"large-6 columns\"> <label>Gob:</label> <div>{{vm.weight.gobName}}</div> </div> </div> <div class=row style=margin-top:20px> <div class=\"large-12 columns\"> Comments: </div> </div> <div class=row style=margin-top:10px> <div class=\"small-6 columns\" style=\"padding:0 15px 0 15px\"> <div ng-repeat=\"comment in vm.weight.comments\" class=dashboard-gob-weight-comment> <span ng-bind=comment.comment></span> <span ng-bind=vm.getPlantTime(comment.createdOn) class=dashboard-gob-weight-comment-time></span> <br> <span ng-bind=comment.createdByFullName></span> </div> </div> </div> <div class=row style=margin-top:10px> <div class=\"small-12 columns\" style=margin-top:10px> <form name=vm.commentForm ng-submit=vm.addWeightComment() novalidate> <label><span class=\"required notated\">*</span>New Comment: <textarea name=comment ng-model=vm.commentText rows=4 cols=40 required></textarea> <div ng-messages=vm.commentForm.comment.$error ng-if=\"vm.commentForm.comment.$dirty || vm.commentForm.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> <span class=required>* Required Fields</span> <label class=right> <input type=submit class=\"button small\" value=\"Add Comment\"/> </label> </form> </div> </div> <div class=row> <div class=\"large-12 columns\"> <div class=\"left dialog-footer\"> <div ng-show=vm.canDeleteWeight> <button ng-click=vm.deleteGobWeight() type=button class=\"button alert\">Delete</button> </div> </div> <div class=\"right dialog-footer\"> <button ng-click=vm.ok() type=button class=\"button secondary\">Close</button> </div> </div> </div> </div> </div>");

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(615), __webpack_require__(5), __webpack_require__(3), __webpack_require__(27), __webpack_require__(26), __webpack_require__(9), __webpack_require__(28), __webpack_require__(4), __webpack_require__(8), __webpack_require__(7), __webpack_require__(48), __webpack_require__(81)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, countv2_tpl_html_1, aps_enums_1, constant_module_1, enums_1, counts_service_1, uiUtility_service_1, lineConfigs_service_1, loader_service_1, navigation_service_1, authData_service_1, groupRejects_service_1, equipmentRejects_controller_1) {
    "use strict";
    countsConfig.$inject = ["$stateProvider"];
    countsCtrlv2.$inject = ["$stateParams", "countsService", "lineConfigsService", "loaderService", "navigationService", "authDataService", "groupRejectsService", "uiUtilityService", "$scope", "$timeout", "$modal", "$state", "$interval"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [counts_service_1.default, uiUtility_service_1.default, lineConfigs_service_1.default, loader_service_1.default,
        navigation_service_1.default, authData_service_1.default, groupRejects_service_1.default, equipmentRejects_controller_1.default];
    exports.default = angular.module('aps.controller.countsv2', requires)
        .config(countsConfig)
        .controller('CountsCtrlv2', countsCtrlv2)
        .name;
    function countsConfig($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.COUNTS_HORIZONTAL_V2,
            url: '/countsv2',
            controller: 'CountsCtrlv2 as vm',
            template: countv2_tpl_html_1.default,
            data: { pageTitle: 'Counts' }
        });
    }
    function countsCtrlv2($stateParams, countsService, lineConfigsService, loaderService, navigationService, authDataService, groupRejectsService, uiUtilityService, $scope, $timeout, $modal, $state, $interval) {
        var vm = {
            $stateParams: $stateParams,
            model: null,
            areas: [],
            plant: null,
            shop: null,
            hub: null,
            canDisableLine: false,
            countDisplayIntervalOptions: uiUtilityService.getListOptionsFromEnum(enums_1.apsDisplayEnums.CountDisplayInterval, null, null, function (o) { return o; }),
            countsInterval: authDataService.getCountInterval(),
            viewRejectDetail: null,
            viewGroupRejectDetail: null,
            calculateSpeed: null,
            countsIntervalChanged: null,
            toggleLineActive: null,
            wareLossClicked: null,
            showHelp: null,
            showHelpWindow: false,
            helpText: null,
            toggleHelpWindow: null,
            cavities: [],
            hasCavities: false,
            userId: null,
            navigationUrls: {
                buttons: [
                    { 'name': 'Horizontal Layout', 'value': 'horizontal', 'selected': false },
                    { 'name': 'Vertical Layout', 'value': 'vertical', 'selected': false },
                    { 'name': 'Vertical Layout (v2)', 'value': 'vc2', 'selected': false },
                ],
                select: function (button) {
                    var stateParams = {
                        plantId: vm.$stateParams.plantId,
                        shopId: vm.$stateParams.shopId,
                        userId: vm.$stateParams.userId,
                    };
                    switch (button.value) {
                        case "horizontal":
                            $state.go(constant_module_1.States.COUNTS_HORIZONTAL, stateParams);
                            break;
                        case "horizontalv2":
                            $state.go(constant_module_1.States.COUNTS_HORIZONTAL_V2, stateParams);
                            break;
                        case "vertical":
                            $state.go(constant_module_1.States.COUNTS_VERTICAL, stateParams);
                            break;
                        case "vc2":
                            $state.go(constant_module_1.States.COUNTS_VERTICAL_V2, stateParams);
                            break;
                    }
                }
            }
        };
        vm.userId = $stateParams.userId;
        var shopId = $stateParams.shopId;
        vm.canDisableLine = authDataService.isPlantOrAPSIOAdminForCurrentPlant();
        var plantShopsPromise = navigationService.getNavigation().then(function (navModel) {
            vm.plant = navModel.selectedPlant;
            vm.shop = navModel.selectedShop;
        });
        var countsPromise = plantShopsPromise.then(function () {
            return countsService.getLineCounts(shopId, vm.plant, vm.countsInterval, vm.canDisableLine)
                .then(function (result) {
                vm.model = result;
                vm.areas = mapModelToAreas(vm.model);
                var rejects = vm.model.shopConfig.jobRuns[0].machineRejectPercentages;
                if (!!rejects) {
                    vm.areas.forEach(function (area) {
                        area.rows.forEach(function (row) {
                            if (!row.isLine) {
                                return;
                            }
                            row.line.equipment.forEach(function (equipment) {
                                var equipWithRejectPercentage = rejects.filter(function (item) { return item.selectedMachine === equipment.name; });
                                if (equipWithRejectPercentage.length > 0) {
                                    equipment.rejectMinPercentage = equipWithRejectPercentage[0].rejectedMinPercentage;
                                    equipment.rejectMaxPercentage = equipWithRejectPercentage[0].rejectedMaxPercentage;
                                }
                            });
                        });
                    });
                }
                for (var id in vm.model.equipment) {
                    if (vm.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.HEYE
                        || vm.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.CheckDetector
                        || vm.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.MX4
                        || vm.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.Mcal
                        || vm.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.Multi
                        || vm.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.FlexBC
                        || vm.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.FlexM) {
                        vm.hasCavities = true;
                        break;
                    }
                }
            });
        });
        vm.wareLossClicked = function () {
            var stateParams = {
                plantId: vm.$stateParams.plantId,
                shopId: vm.$stateParams.shopId,
                userId: vm.$stateParams.userId,
            };
            $state.go(constant_module_1.States.PLANT_WARE_LOSS_DASHBOARD, stateParams);
        };
        vm.toggleHelpWindow = function () {
            vm.showHelpWindow = !vm.showHelpWindow;
        };
        vm.showHelp = function (helpScreen) {
            vm.helpText = getCountsHelpText(helpScreen);
            vm.toggleHelpWindow();
        };
        vm.toggleLineActive = function (line) {
            if (!vm.canDisableLine) {
                return;
            }
            var message = "Line " + line.name + " is currently " + (line.isDisabled ? 'disabled' : 'active') + ". "
                + ("Would you like to " + (line.isDisabled ? 'activate' : 'disable') + " it?");
            var subject = (line.isDisabled ? 'Activate' : 'Disable') + " Line " + line.name + "?";
            uiUtilityService.confirm(message, subject, 'Yes', 'No').then(function (confirmed) {
                if (!confirmed) {
                    return;
                }
                var promise = lineConfigsService.toggleLine({
                    id: line.id,
                    shopId: line.shopId,
                    isDisabled: !line.isDisabled
                }).then(function () { return line.isDisabled = !line.isDisabled; });
                loaderService.loadingPromise(promise);
            });
        };
        vm.viewRejectDetail = function (line, equipment) {
            var modalPromise = countsPromise;
            if (equipment.hasTabs || (equipment.detailDataPoints && equipment.detailDataPoints.length > 0)) {
                modalPromise = countsService.getEquipmentCounts(shopId, vm.model, equipment, vm.countsInterval)
                    .then(function (counts) {
                    vm.model.currentDetailCounts = counts;
                });
                loaderService.loadingPromise(modalPromise);
            }
            modalPromise.then(function () {
                var result = equipmentRejects_controller_1.openEquipmentRejects({
                    equipment: equipment,
                    line: line,
                    plant: vm.plant,
                    shopId: shopId,
                    canDisable: vm.canDisableLine,
                    detail: vm.model.currentDetailCounts,
                    lineConfig: vm.model
                }, $modal);
                result.then(function () {
                    if (vm.model.currentDetailCounts) {
                        delete vm.model.currentDetailCounts;
                    }
                });
            });
        };
        vm.viewGroupRejectDetail = function (equipmentGroup) {
            vm.model.currentGroup = equipmentGroup;
            groupRejectsService.showGroupRejects({
                equipmentGroup: equipmentGroup,
                shopId: vm.shop.id,
                lineCounts: vm.model,
                countsInterval: vm.countsInterval
            });
        };
        vm.countsIntervalChanged = function () {
            vm.model.handleIntervalChange(vm.countsInterval);
            authDataService.setCountInterval(vm.countsInterval);
        };
        var promise = countsPromise.then(function () {
            vm.hub = countsService.createHub(shopId, vm.model);
            $scope.$on('$destroy', function () {
                if (vm.hub) {
                    vm.hub.leaveGroup(shopId)
                        .then(function () { return vm.hub.uninitialize(); });
                }
            });
        });
        loaderService.loadingPromise(promise);
        return vm;
    }
    function mapLineToRow(line) {
        return {
            isLine: true,
            line: line,
            junction: null,
            cssClass: null
        };
    }
    function mapJunctionToRow(junction) {
        return {
            isLine: false,
            line: null,
            junction: junction,
            cssClass: 'table' + (junction.inputs.length > junction.outputs.length
                ? junction.inputs.length : junction.outputs.length).toString()
        };
    }
    function mapModelToAreas(model) {
        var areas = [];
        var area = {
            rows: _.sortBy(model.lines.filter(function (l) { return l.startJunctionId === null; }), function (r) { return r.number; })
                .map(function (l) { return mapLineToRow(l); })
        };
        var _loop_1 = function () {
            areas.push(area);
            var previousLines = area.rows.filter(function (l) { return l.isLine; }).map(function (l) { return l.line; });
            var rows = [];
            area.rows.forEach(function (row) {
                if (!row.isLine) {
                    _.sortBy(row.junction.outputs, function (l) { return l.number; }).forEach(function (line) {
                        rows.push(mapLineToRow(line));
                    });
                    return;
                }
                var junction = row.line.endJunction;
                if (!junction) {
                    return;
                }
                if (_.some(rows, function (r) { return !r.isLine && r.junction === junction; })) {
                    return;
                }
                if (!junction.inputs.every(function (l) { return _.some(previousLines, function (al) { return al.id === l.id; }); })) {
                    rows.push(mapLineToRow(row.line));
                }
                rows.push(mapJunctionToRow(junction));
            });
            area = { rows: rows };
        };
        while (area.rows.length > 0) {
            _loop_1();
        }
        return areas;
    }
    function getCountsHelpText(helpScreen) {
        var helptext = '';
        switch (helpScreen) {
            case 'EQUIPMENT COUNTS':
                helptext = "  \n\t\t\t<div class=\"header\">\n\t\t\t  Equipment Counts\n\t\t\t</div>         \n\t\t\t<div class=\"subheader\">\n\t\t\t  <u>How the Counts Work</u>:\n\t\t\t</div>\n\t\t\t<div class=\"detail\">\n\t\t\t\tBelow is a sample count object, this is sample data just for instructional purposes.\n\t\t\t</div>\n\t\t\t<div class=\"detail\">\n\t\t\t\t<table>\n\t\t\t\t\t<tbody>\n\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t\t<div class=\"bs-card\">\n\t\t\t\t\t\t\t\t\t<div class=\"equipment-name\">SQR</div>\n\t\t\t\t\t\t\t\t\t<div class=\"count\">11328</div>\n\t\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t\t<span class=\"fail-rate\">166</span>\n\t\t\t\t\t\t\t\t\t\t<span class=\"fail-percentage\">1.5%</span>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t</tbody>\n\t\t\t\t</table>\n\t\t\t</div>\n\t\t\t<div class=\"detail\">\n\t\t\t\tAs you can see the count object is broken up into 4 different rows. Here is the definition of each row:\n\t\t\t</div>  \n\t\t\t<div class=\"detail\">\n\t\t\t\t<ol type = \"1\">\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>Equipment Shorthand:</b> This is a shorthand abreviation of the type of equipment configured on the line.\n\t\t\t\t\t\tIn this case this is a high speed squeezer. This is abreviated as SQR.\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>Inspect Count:</b> The number of bottles going into the machine.\n\t\t\t\t\t\tIn APS the preference is to use a direct integration to the machine for this counter.\n\t\t\t\t\t\tHowever, there are instances that we are dependent on a photoeye before the inspection equipment \n\t\t\t\t\t\tto provide the inspect count.\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>Reject Count:</b>\n\t\t\t\t\t\tThe amount of bottles rejected by the piece of inspection equipment.\n\t\t\t\t\t\tThis value is highlighted in <span class=\"red\">red</span> to help users quickly identify losses.\n\t\t\t\t\t\tFor most equipment we have a direct integration and the equipment keeps counts of rejects.\n\t\t\t\t\t\tHowever, for some equipment integrations we need to calculated it by taking the difference between\n\t\t\t\t\t\tbottles in and bottles out.\n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t<span class=\"formula\">Reject Count = Reject Count from Machine</span><br/>\n\t\t\t\t\t\t<span class=\"footnote\">[where machine has direct integration]</span><br/>\n\t\t\t\t\t\t<span class=\"formula\">Reject Count = Machine Bottles In - Machine Bottles Out</span><br/>\n\t\t\t\t\t\t<span class=\"footnote\">[where machine only has input/output]</span><br/>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>Reject Percent:</b>\n\t\t\t\t\t\tThe percent of loss for each piece of equipment.\n\t\t\t\t\t\tThis value is highlighted in <span class=\"red\">red</span> to help users quickly identify losses.\n\t\t\t\t\t\tThis calculation is based off the equipment inspects vs. the rejects.\n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t<span class=\"formula\">Reject Percent = Reject Count / Inspect Count</span><br/>\n\t\t\t\t\t</li>\n\t\t\t\t</ol>\n\t\t\t</div>\n\t\t\t<div class=\"subheader\">\n\t\t\t\t<u>Equipment Details</u>:\n\t\t\t</div>   \n\t\t\t<div class=\"detail\">\n\t\t\t\tEvery piece of equipment has the ability to drill-down. \n\t\t\t\tAll the user has to do to access this data is to click on the peice of equipment.\n\t\t\t\tDepending on the type of integration some equipment will display more data than others.\n\t\t\t</div>\n\t\t  \t";
                break;
            case 'AREA EFFICIENCY':
                helptext = "  \n\t\t\t<div class=\"header\">\n\t\t\t  Area Efficiency\n\t\t\t</div>         \n\t\t\t<div class=\"subheader\">\n\t\t\t  <u>Metrics per Area</u>:\n\t\t\t</div>\n\t\t\t<div class=\"detail\">\n\t\t\t\tEach area of the production line will have the following metrics, where applicable.\n\t\t\t\tThe metric definitions are as follows.\n\t\t\t</div>\n\t\t\t<div class=\"detail\">\n\t\t\t\t<ol type = \"1\">\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>AREA IN:</b> \n\t\t\t\t\t\tThe total number of bottles going into each area.\n\t\t\t\t\t\tThis number is used as the denominator for efficiency calculations in each area.\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>AREA REJECTS:</b> \n\t\t\t\t\t\tThe total amount of bottles rejected in each area.\n\t\t\t\t\t\tThis value is highlighted in <span class=\"red\">red</span> to help users quickly identify losses.\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>AREA REJECT:</b>\n\t\t\t\t\t\tThe percent of loss for each area.\n\t\t\t\t\t\tThis value is highlighted in <span class=\"red\">red</span> to help users quickly identify losses.\n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t<span class=\"formula\">AREA REJECT = 100 * (Area Rejects / Area In)</span>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>AREA EFFICIENCY:</b>\n\t\t\t\t\t\tThe ammount of bottles to make it through each area compared to how many went in.\n\t\t\t\t\t\tThis is the inverse of the <i>AREA REJECT %</i>.\n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t<span class=\"formula\">AREA REJECT = 100 - (100 * (Area Rejects / Area In))</span>\n\t\t\t\t\t</li>\n\t\t\t\t</ol>\n\t\t\t</div>\n\t\t  \t";
                break;
            case 'SHOP KPI':
                helptext = "  \n\t\t\t<div class=\"header\">\n\t\t\t  Shop KPI's\n\t\t\t</div>         \n\t\t\t<div class=\"subheader\">\n\t\t\t  <u>KPI Metric Definitions</u>:\n\t\t\t</div>\n\t\t\t<div class=\"detail\">\n\t\t\t\tThe goal of these KPI's is to see how the shop is preforming at each point along the line.\n\t\t\t\tWe use each pulse from the shear cuts to calculate how many gobs are currently being produced.\n\t\t\t</div>\n\t\t\t<div class=\"detail\">\n\t\t\t\t<ol type = \"1\">\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>MACHINE SPEED:</b>\n\t\t\t\t\t\tHow many bottles per minute is the machine producing.\n\t\t\t\t\t\tWhere available we use a direct machine integration.\n\t\t\t\t\t\tOtherwise, we use the shear pulses to estimate the speed.\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>LEHR IN:</b> \n\t\t\t\t\t\tThe percent of bottles going into the lehr, compared to the shears.\n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t<span class=\"formula\">LEHR IN = Lehr In Counter / Shears</span>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>LEHR OUT:</b>\n\t\t\t\t\t\tThe percent of bottles comming out of the lehr, into the cold-end, compared to the shears.\n\t\t\t\t\t\tUsually we are using the sum of the first peice of inspection equipment.\n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t<span class=\"formula\">LEHR OUT = Cold-End In / Shears</span>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>PACK:</b>\n\t\t\t\t\t\tThe percent of bottles that make it to the End of Line (EOL), compared to the shears.\n\t\t\t\t\t\tThis is usually a photoeye, sometimes it can be the last piece of inspection equipment.\n\t\t\t\t\t\tIt depends on the shop configuration.\n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t<span class=\"formula\">PACK = EOL / Shears</span>\n\t\t\t\t\t</li>\n\t\t\t\t</ol>\n\t\t\t</div>\n\t\t  \t";
                break;
            case 'WARE LOSS':
                helptext = "  \n\t\t\t<div class=\"header\">\n\t\t\t\tShop Ware Loss\n\t\t\t</div>         \n\t\t\t<div class=\"subheader\">\n\t\t\t\t<u>Shop Ware Loss Definitions</u>:\n\t\t\t</div>\n\t\t\t<div class=\"detail\">\n\t\t\t\tThe goal of these Metrics are quickly identify the areas of most loss compared to bottles created.\n\t\t\t\tWe use each pulse from the shear cuts to calculate how many gobs are produced at the hot-end.\n\t\t\t\tYour total loss should add up to all the other ware loss percentages.\n\t\t\t</div>\n\t\t\t<div class=\"detail\">\n\t\t\t\t<ol type = \"1\">\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>HOT END LOSS:</b>\n\t\t\t\t\t\tThe percent of the bottles produced that did not make it into the lehr.\n\t\t\t\t\t\tThis value is highlighted in <span class=\"red\">red</span> to help users quickly identify losses.\n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t<span class=\"formula\">HOT END LOSS = 100 - (100 * (LEHR IN / SHEARS))</span>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>LEHR LOSS:</b> \n\t\t\t\t\t\tThe percent of bottles that were lost in the lehr, over the shears.\n\t\t\t\t\t\tThis value is highlighted in <span class=\"red\">red</span> to help users quickly identify losses.\n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t<span class=\"formula\">LEHR LOSS = 100 - (100 * ((LEHR IN - LEHR OUT) / SHEARS))</span>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>AIE LOSS:</b>\n\t\t\t\t\t\tThe percent of bottles lost to all inspection equipment, over the shears.\n\t\t\t\t\t\tThis value is highlighted in <span class=\"red\">red</span> to help users quickly identify losses.\n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t<span class=\"formula\">AIE LOSS = 100 - (100 * (AIE LOSS / SHEARS))</span>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>CE DELTA LOSS:</b>\n\t\t\t\t\t\tThe percent of all bottles that made it into the cold end, \n\t\t\t\t\t\tthat were not rejected by inspection equipment,\n\t\t\t\t\t\tbut did not make it to the end of line,\n\t\t\t\t\t\tover the shears.\n\t\t\t\t\t\tThis value is highlighted in <span class=\"red\">red</span> to help users quickly identify losses.\n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t<span class=\"formula\">CE DELTA LOSS = 100 - (100 * (LEHR OUT - AIE LOSS - END OF LINE) / SHEARS)</span>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class=\"detail\">\n\t\t\t\t\t\t<b>TOTAL LOSS:</b>\n\t\t\t\t\t\tThe percent of bottles that did not make it to the End of Line (EOL), compared to the shears.\n\t\t\t\t\t\tThis is usually a photoeye, sometimes it can be the last piece of inspection equipment.\n\t\t\t\t\t\tIt depends on the shop configuration.\n\t\t\t\t\t\tThis value is highlighted in <span class=\"red\">red</span> to help users quickly identify losses.\n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t<span class=\"formula\">TOTAL LOSS = 100 - (100 * (END OF LINE / SHEARS))</span>\n\t\t\t\t\t</li>\n\t\t\t\t</ol>\n\t\t\t</div>\n\t\t  \t";
                break;
            default:
                helptext = 'Selected Help Screen Not Found...';
                break;
        }
        return helptext;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row-flex ag-header\"> <div class=\"ag-header-plant ag-header-box\"> <span class=ag-plant-name>{{vm.plant.name || \"...\"}}</span> <span class=ag-shop>Shop {{vm.shop.name}}</span> </div> <div class=\"ag-header-count-interval ag-header-box\"> <label> <span>Viewing Count Data For:</span> <select style=width:120px id=countsInterval ng-model=vm.countsInterval ng-options=\"t.value as t.text for t in vm.countDisplayIntervalOptions\" ng-change=vm.countsIntervalChanged() class=form-control></select> </label> </div> <div class=\"ag-header-btnarray ag-header-box\"> <btn-array options=vm.navigationUrls /> </div> </div> <div> <div style=\"padding:.625em 1.6%\"> <div class=counts-body> <div class=\"c-columns area\" ng-repeat=\"area in vm.areas\"> <div class=c-row ng-repeat=\"row in area.rows\" ng-class=row.cssClass> <div class=connector ng-if=\"row.isLine && !$parent.$first\"></div> <div class=linerow ng-if=row.isLine ng-class=\"{'line-disabled': row.line.isDisabled, 'can-disable-line': vm.canDisableLine}\"> <div class=linenumber ng-click=vm.toggleLineActive(row.line)>{{row.line.name}}</div> <div ng-repeat=\"equip in row.line.equipment\" ng-click=\"vm.viewRejectDetail(row.line, equip)\" class=equipment style=cursor:pointer ng-class=\"{'equipment-disabled': equip.isDisabled}\"> <div ng-class=equip.lineHealthCssBox></div> <div class=equipment-name>{{equip.name}}</div> <div class=count>{{equip.inspectCount.count}}</div> <div ng-if=equip.rejectCount> <span class=count>{{equip.rejectCount.count}}</span> <span ng-class=\"(equip.rejectCount.percent > equip.rejectMaxPercentage \r\n\t\t\t\t\t\t\t\t\t|| equip.rejectCount.percent < equip.rejectMinPercentage)\r\n\t\t\t\t\t\t\t\t\t? 'fail-rate' : 'counts-equipment-details'\"> <span>{{equip.rejectCount.percent ? equip.rejectCount.percent + '%' : ''}}</span> <vert-trend trend=equip.rejectCount.trend style=margin-top:.1em /> </span> </div> </div> </div> <div class=connector ng-if=\"row.isLine && !$parent.$last\"></div> </div> </div> </div> <div class=linerow> <div ng-repeat=\"group in vm.model.equipmentGroups\" ng-click=vm.viewGroupRejectDetail(group) ng-class=\"{equipmentsummaryfirst:$first, equipmentsummary:!$first}\" style=cursor:pointer> <div class=equipment-name>{{group.name}}</div> <div class=count>{{group.inspectCount.count}}</div> <div ng-if=group.hasRejects> <span class=fail-rate>{{group.rejectCount.count}}</span> <span class=fail-percentage> {{group.rejectCount.percent}}% <vert-trend trend=group.rejectCount.trend style=margin-top:.1em /> </span> </div> </div> </div> <!-- kpi --> <!-- <kpi class=\"row count-performance\" kpis=\"vm.model.kpis\" /> --> <div class=\"row count-performance\"> <div class=\"small-4 columns\" ng-repeat=\"kpi in vm.model.kpis\"> <div> <label style=display:inline>{{kpi.efficiencyName}}:</label> {{kpi.efficiency}} </div> <div> <label style=display:inline>{{kpi.lossesName}}:</label> {{kpi.losses}} </div> <div ng-if=\"$index === 0\"> <label style=display:inline>Speed:</label> {{kpi.denominator.speed}} </div> </div> </div> </div> </div>");

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(617), __webpack_require__(286), __webpack_require__(5), __webpack_require__(3), __webpack_require__(27), __webpack_require__(26), __webpack_require__(9), __webpack_require__(28), __webpack_require__(4), __webpack_require__(8), __webpack_require__(7), __webpack_require__(48), __webpack_require__(81), __webpack_require__(34), __webpack_require__(50), __webpack_require__(302), __webpack_require__(94)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, countVertical_tpl_html_1, lineCounts_1, aps_enums_1, constant_module_1, enums_1, counts_service_1, uiUtility_service_1, lineConfigs_service_1, loader_service_1, navigation_service_1, authData_service_1, groupRejects_service_1, equipmentRejects_controller_1, Highcharts, interval_factory_1, counts_header_directive_1, count_controller_1) {
    "use strict";
    countsConfig.$inject = ["$stateProvider"];
    countsVerticalCtrl.$inject = ["$stateParams", "countsService", "lineConfigsService", "loaderService", "navigationService", "authDataService", "groupRejectsService", "uiUtilityService", "$scope", "$modal", "$state", "$interval"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [counts_service_1.default, uiUtility_service_1.default, lineConfigs_service_1.default, loader_service_1.default,
        navigation_service_1.default, authData_service_1.default, groupRejects_service_1.default, equipmentRejects_controller_1.default,
        counts_header_directive_1.default
    ];
    function mapLineToRow(line) {
        return {
            isLine: true,
            line: line,
            junction: null,
            cssClass: null
        };
    }
    function mapJunctionToRow(junction) {
        return {
            isLine: false,
            line: null,
            junction: junction,
            cssClass: 'table' + (junction.inputs.length > junction.outputs.length
                ? junction.inputs.length : junction.outputs.length).toString()
        };
    }
    function mapModelToAreas(model) {
        var areas = [];
        var area = {
            rows: _.sortBy(model.lines.filter(function (l) { return l.startJunctionId === null; }), function (r) { return r.number; })
                .map(function (l) { return mapLineToRow(l); })
        };
        var _loop_1 = function () {
            areas.push(area);
            var previousLines = area.rows.filter(function (l) { return l.isLine; }).map(function (l) { return l.line; });
            var rows = [];
            area.rows.forEach(function (row) {
                if (!row.isLine) {
                    _.sortBy(row.junction.outputs, function (l) { return l.number; }).forEach(function (line) {
                        rows.push(mapLineToRow(line));
                    });
                    return;
                }
                var junction = row.line.endJunction;
                if (!junction) {
                    return;
                }
                if (_.some(rows, function (r) { return !r.isLine && r.junction === junction; })) {
                    return;
                }
                if (!junction.inputs.every(function (l) { return _.some(previousLines, function (al) { return al.id === l.id; }); })) {
                    rows.push(mapLineToRow(row.line));
                }
                rows.push(mapJunctionToRow(junction));
            });
            area = { rows: rows };
        };
        while (area.rows.length > 0) {
            _loop_1();
        }
        return areas;
    }
    var sparklineChart = function () {
        return {
            restrict: 'E',
            template: '<div></div>',
            scope: {
                options: '='
            },
            link: function (scope, element, attributes) {
                var options = {
                    title: {
                        text: ''
                    },
                    credits: false,
                    chart: {
                        width: 60,
                        height: 21,
                        borderWidth: 0,
                        margin: [2, 0, 2, 0],
                        type: 'area',
                        style: {
                            overflow: 'visible'
                        },
                        skipClone: true
                    },
                    yAxis: {
                        endOnTick: false,
                        startOnTick: false,
                        labels: {
                            enabled: false
                        },
                        title: {
                            text: null
                        },
                        tickPositions: [0],
                        showEmpty: false,
                    },
                    xAxis: {
                        labels: {
                            enabled: false
                        },
                        title: {
                            text: null
                        },
                        startOnTick: false,
                        endOnTick: false,
                        tickPositions: [],
                        showEmpty: false,
                    },
                    legend: {
                        enabled: false
                    },
                    tooltip: {
                        pointFormat: '{point.y}',
                        headerFormat: '',
                        hideDelay: 0,
                        outside: true,
                        shared: true
                    },
                    plotOptions: {
                        series: {
                            animation: false,
                            lineWidth: 1,
                            shadow: false,
                            states: {
                                hover: {
                                    lineWidth: 1
                                }
                            },
                            marker: {
                                radius: 1,
                                states: {
                                    hover: {
                                        radius: 2
                                    }
                                }
                            },
                            fillOpacity: 0.25
                        },
                        column: {
                            negativeColor: '#910000',
                            borderColor: 'silver'
                        }
                    },
                    series: [],
                    lang: {
                        noData: "No Data"
                    }
                };
                angular.element(document).ready(function () {
                    try {
                        var jsonData = JSON.parse(attributes.data);
                        if (jsonData.length === 0)
                            jsonData = [0, 0, 0, 0];
                        options.series = [{ data: jsonData }];
                        var chart = new Highcharts.Chart(element[0], options);
                    }
                    catch (e) {
                        return false;
                    }
                    scope.$watch(function () {
                        return element.attr('data');
                    }, function (newValue) {
                        try {
                            if (newValue !== null) {
                                var jsonData = JSON.parse(attributes.data);
                                if (jsonData.length === 0)
                                    jsonData = [0, 0, 0, 0];
                                options.series = [{ data: jsonData }];
                                var chart = new Highcharts.Chart(element[0], options);
                            }
                        }
                        catch (e) {
                            return false;
                        }
                    });
                });
            }
        };
    };
    function countsConfig($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.COUNTS_VERTICAL,
            url: '/countsvertical',
            controller: 'CountsVerticalCtrl as vm',
            template: countVertical_tpl_html_1.default,
            data: { pageTitle: 'Vertical Counts' }
        });
    }
    function countsVerticalCtrl($stateParams, countsService, lineConfigsService, loaderService, navigationService, authDataService, groupRejectsService, uiUtilityService, $scope, $modal, $state, $interval) {
        var countsPromise;
        var equipmentRejectTolerances = {};
        function getDetailChartConfig() {
            return {
                chart: {
                    alignTicks: true,
                    zoomType: 'xy',
                    styleMode: true,
                },
                legend: {
                    enabled: false
                },
                credits: {
                    enabled: false
                },
                title: {
                    text: null
                },
                xAxis: {
                    categories: ['', '', '', ''],
                    labels: {
                        enabled: false
                    }
                },
                yAxis: {
                    title: {
                        text: null
                    },
                    labels: {
                        enabled: true
                    },
                    allowDecimals: false
                },
                plotOptions: {
                    series: {
                        marker: {
                            enabled: true
                        },
                        animation: false
                    }
                },
                tooltip: {
                    useHtml: true,
                    pointFormat: '<b>{point.y}</b>',
                },
                series: [{
                        type: 'spline',
                        data: [],
                        color: '#919391',
                        name: ''
                    }]
            };
        }
        var vm = {
            $stateParams: $stateParams,
            $state: $state,
            countsService: countsService,
            interval: null,
            model: null,
            areas: [],
            plant: null,
            shop: null,
            hub: null,
            updatedModel: null,
            updatedAreas: null,
            canDisableLine: false,
            countDisplayIntervalOptions: uiUtilityService.getListOptionsFromEnum(enums_1.apsDisplayEnums.CountDisplayInterval, null, null, function (o) { return o; }),
            countsInterval: authDataService.getCountInterval(),
            viewRejectDetail: null,
            viewGroupRejectDetail: null,
            calculateSpeed: null,
            countsIntervalChanged: null,
            getLossPercentClass: null,
            getEquipmentClass: null,
            getRowClass: null,
            toggleLineActive: null,
            cavities: [],
            hasCavities: false,
            detailChartConfig: getDetailChartConfig(),
            showCharts: true,
            showHelpWindow: false,
            toggleHelpWindow: null,
            showHelp: null,
            helpText: '',
            navigationUrls: {
                buttons: [
                    { 'name': 'Horizontal Layout', 'value': 'horizontal', 'selected': false },
                    { 'name': 'Vertical Layout', 'value': 'vertical', 'selected': true },
                    { 'name': 'Vertical Layout (v2)', 'value': 'vc2', 'selected': false },
                ],
                select: function (button) {
                    var stateParams = {
                        plantId: vm.$stateParams.plantId,
                        shopId: vm.$stateParams.shopId,
                        userId: vm.$stateParams.userId,
                    };
                    switch (button.value) {
                        case "horizontal":
                            $state.go(constant_module_1.States.COUNTS_HORIZONTAL, stateParams);
                            break;
                        case "vertical":
                            $state.go(constant_module_1.States.COUNTS_VERTICAL, stateParams);
                            break;
                        case "vc2":
                            $state.go(constant_module_1.States.COUNTS_VERTICAL_V2, stateParams);
                            break;
                    }
                }
            },
            blinkClass: " blink-dark",
            usePercentGobsChanged: null,
        };
        count_controller_1.setUsePercentGobsChangedMethod(vm);
        var shopId = $stateParams.shopId;
        function getDetailCounts() {
            _.forEach(vm.updatedAreas, function (updatedArea) {
                _.forEach(updatedArea.rows, function (updatedRow) {
                    if (updatedRow.line === null) {
                        return;
                    }
                    _.forEach(updatedRow.line.equipment, function (updatedEquip) {
                        _.forEach(vm.areas, function (area) {
                            _.forEach(area.rows, function (row) {
                                if (row.line === null) {
                                    return;
                                }
                                _.forEach(row.line.equipment, function (equip) {
                                    if (equip.id === updatedEquip.id) {
                                        equip.inspectCount.count = updatedEquip.inspectCount.count;
                                        if (updatedEquip.rejectCount != null) {
                                            equip.rejectCount.count = updatedEquip.rejectCount.count;
                                            equip.rejectCount.percent = updatedEquip.rejectCount.percent;
                                            equip.rejectCount.gobPercent = updatedEquip.rejectCount.gobPercent;
                                        }
                                        if (typeof equip.inspectCount !== 'undefined') {
                                            if (typeof equip.rejectCount !== 'undefined') {
                                                if (typeof equip.inspectCount.count !== 'undefined') {
                                                    if (typeof equip.rejectCount.count !== 'undefined') {
                                                        if (equip.inspectCount.count === 0 && equip.rejectCount.count === 0) {
                                                            var resetLineEquipDetail = [];
                                                            equip.lineEquipmentDetail = resetLineEquipDetail;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                });
                            });
                        });
                    });
                });
            });
            _.forEach(vm.areas, function (area) {
                _.forEach(area.rows, function (row) {
                    if (row.line === null) {
                        return;
                    }
                    _.forEach(row.line.equipment, function (equip) {
                        var detailPromise = countsService.getEquipmentCounts(shopId, vm.model, equip, vm.countsInterval)
                            .then(function (counts) {
                            vm.model.currentDetailCounts = counts;
                            if (!Array.isArray(equip.lineEquipmentDetail) || !equip.lineEquipmentDetail.length) {
                                equip.lineEquipmentDetail = [];
                            }
                            var updatedLineEquipDetail = [];
                            if (typeof counts.tabs[0] !== 'undefined' && typeof counts.tabs[0].outputRows !== 'undefined') {
                                _.forEach(counts.tabs[0].outputRows, function (outputRow) {
                                    if (outputRow !== null) {
                                        if (outputRow.cells !== null && outputRow.cells[0].count != null) {
                                            var detailCount = outputRow.cells[0].count;
                                            if (detailCount.count > 0) {
                                                updatedLineEquipDetail.push(new lineCounts_1.LineEquipmentDetailImpl(outputRow.displayName, detailCount));
                                            }
                                        }
                                    }
                                });
                                _.forEach(updatedLineEquipDetail, function (updateRow) {
                                    var rowToUpdate = _.find(equip.lineEquipmentDetail, { name: updateRow.name });
                                    if (typeof rowToUpdate === 'undefined') {
                                        equip.lineEquipmentDetail.push(updateRow);
                                    }
                                    else {
                                        rowToUpdate.actualCount = updateRow.actualCount;
                                    }
                                });
                            }
                            else if (typeof counts.details !== 'undefined') {
                                _.forEach(counts.details, function (outputRow) {
                                    updatedLineEquipDetail.push(new lineCounts_1.LineEquipmentDetailImpl(outputRow.name, outputRow.count));
                                });
                                _.forEach(updatedLineEquipDetail, function (updateRow) {
                                    var rowToUpdate = _.find(equip.lineEquipmentDetail, { name: updateRow.name });
                                    if (typeof rowToUpdate === 'undefined') {
                                        equip.lineEquipmentDetail.push(updateRow);
                                    }
                                    else {
                                        rowToUpdate.actualCount = updateRow.actualCount;
                                    }
                                });
                            }
                        });
                    });
                });
            });
        }
        function refreshCounts() {
            var plantShopsPromise = navigationService.getNavigation().then(function (navModel) {
                vm.plant = navModel.selectedPlant;
                vm.shop = navModel.selectedShop;
            });
            var countsByShears = true;
            countsPromise = plantShopsPromise.then(function () {
                return countsService.getLineCounts(shopId, vm.plant, vm.countsInterval, vm.canDisableLine, false, countsByShears)
                    .then(function (result) {
                    vm.model = result;
                    count_controller_1.lineCountsLoaded(vm);
                    vm.areas = mapModelToAreas(vm.model);
                    getDetailCounts();
                    var rejects = vm.model.shopConfig.jobRuns[0].machineRejectPercentages;
                    if (!!rejects) {
                        vm.areas.forEach(function (area) {
                            area.rows.forEach(function (row) {
                                if (!row.isLine) {
                                    return;
                                }
                                row.line.equipment.forEach(function (equipment) {
                                    var equipWithRejectPercentage = rejects.filter(function (item) { return item.selectedMachine === equipment.name; });
                                    if (equipWithRejectPercentage.length > 0) {
                                        var tolerances = {
                                            rejectMinPercentage: equipWithRejectPercentage[0].rejectedMinPercentage,
                                            rejectMaxPercentage: equipWithRejectPercentage[0].rejectedMaxPercentage
                                        };
                                        equipmentRejectTolerances[equipment.name] = tolerances;
                                    }
                                });
                            });
                        });
                    }
                    for (var id in vm.model.equipment) {
                        if (vm.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.HEYE
                            || vm.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.CheckDetector
                            || vm.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.MX4
                            || vm.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.Mcal
                            || vm.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.Multi) {
                            vm.hasCavities = true;
                            break;
                        }
                    }
                });
            });
        }
        function update() {
            refreshCounts();
            if (vm) {
                if (vm.model)
                    vm.model.handleIntervalChange(vm.countsInterval);
                authDataService.setCountInterval(vm.countsInterval);
            }
        }
        vm.countsIntervalChanged = function () {
            update();
        };
        vm.canDisableLine = authDataService.isPlantOrAPSIOAdminForCurrentPlant();
        update();
        vm.getLossPercentClass = function (equipment) {
            var rejectTolerance = equipmentRejectTolerances[equipment.name];
            if (equipment.rejectCount && !!rejectTolerance
                && (Number(equipment.rejectCount.percent) > rejectTolerance.rejectMaxPercentage
                    || Number(equipment.rejectCount.percent) < rejectTolerance.rejectMinPercentage)) {
                return 'fail-percentage';
            }
            return 'counts-equipment-details';
        };
        vm.getEquipmentClass = function (equip) {
            var rejectTolerance = equipmentRejectTolerances[equip.name];
            var equipmentClass = '';
            if (equip.rejectCount && !!rejectTolerance
                && (Number(equip.rejectCount.percent) > rejectTolerance.rejectMaxPercentage
                    || Number(equip.rejectCount.percent) < rejectTolerance.rejectMinPercentage)) {
                equipmentClass = 'rejectBgVerticals';
                if (vm.countsInterval == enums_1.apsDisplayEnums.CountDisplayInterval.CurrentHour
                    || vm.countsInterval == enums_1.apsDisplayEnums.CountDisplayInterval.CurrentShift
                    || vm.countsInterval == enums_1.apsDisplayEnums.CountDisplayInterval.RollingHour
                    || vm.countsInterval == enums_1.apsDisplayEnums.CountDisplayInterval.LastTwentyMinutes) {
                    equipmentClass = vm.blinkClass;
                }
            }
            return equipmentClass;
        };
        vm.getRowClass = function (equipment) {
            if (!equipment) {
                return '';
            }
            if (equipment.isDisabled) {
                return 'equipment-disabled';
            }
            var rejectTolerance = equipmentRejectTolerances[equipment.name];
            var equipmentClass = '';
            if (equipment.rejectCount && !!rejectTolerance
                && (Number(equipment.rejectCount.percent) > rejectTolerance.rejectMaxPercentage
                    || Number(equipment.rejectCount.percent) < rejectTolerance.rejectMinPercentage)) {
                equipmentClass = 'rejectEquipVerticals';
            }
            return equipmentClass;
        };
        update();
        vm.toggleLineActive = function (line) {
            if (!vm.canDisableLine) {
                return;
            }
            var message = "Line " + line.name + " is currently " + (line.isDisabled ? 'disabled' : 'active') + ". "
                + ("Would you like to " + (line.isDisabled ? 'activate' : 'disable') + " it?");
            var subject = (line.isDisabled ? 'Activate' : 'Disable') + " Line " + line.name + "?";
            uiUtilityService.confirm(message, subject, 'Yes', 'No').then(function (confirmed) {
                if (!confirmed) {
                    return;
                }
                var promise = lineConfigsService.toggleLine({
                    id: line.id,
                    shopId: line.shopId,
                    isDisabled: !line.isDisabled
                }).then(function () { return line.isDisabled = !line.isDisabled; });
                loaderService.loadingPromise(promise);
            });
        };
        vm.viewRejectDetail = function (line, equipment) {
            var modalPromise = countsPromise;
            if (equipment.hasTabs || (equipment.detailDataPoints && equipment.detailDataPoints.length > 0)) {
                modalPromise = countsService.getEquipmentCounts(shopId, vm.model, equipment, vm.countsInterval)
                    .then(function (counts) {
                    vm.model.currentDetailCounts = counts;
                });
                loaderService.loadingPromise(modalPromise);
            }
            modalPromise.then(function () {
                var result = equipmentRejects_controller_1.openEquipmentRejects({
                    equipment: equipment,
                    line: line,
                    plant: vm.plant,
                    shopId: shopId,
                    canDisable: vm.canDisableLine,
                    detail: vm.model.currentDetailCounts,
                    lineConfig: vm.model
                }, $modal);
                result.then(function () {
                    if (vm.model.currentDetailCounts) {
                        delete vm.model.currentDetailCounts;
                    }
                });
            });
        };
        vm.viewGroupRejectDetail = function (equipmentGroup) {
            vm.model.currentGroup = equipmentGroup;
            groupRejectsService.showGroupRejects({
                equipmentGroup: equipmentGroup,
                shopId: vm.shop.id,
                lineCounts: vm.model,
                countsInterval: vm.countsInterval
            });
        };
        vm.toggleHelpWindow = function () {
            vm.showHelpWindow = !vm.showHelpWindow;
        };
        vm.showHelp = function (helpScreen) {
            vm.helpText = getCountsHelpText(helpScreen);
            vm.toggleHelpWindow();
        };
        var updateBlinkClass = function () {
            if (vm.blinkClass.indexOf("light") > 0) {
                vm.blinkClass = " blink-dark-vert";
            }
            else {
                vm.blinkClass = " blink-light-vert";
            }
        };
        var blinkTimer;
        var createBlinkTimer = function () {
            updateBlinkClass();
            if (blinkTimer) {
                $interval.cancel(blinkTimer);
            }
            blinkTimer = $interval(updateBlinkClass, 600);
        };
        $scope.$on("$destroy", function () {
            if (blinkTimer) {
                $interval.cancel(blinkTimer);
            }
        });
        var promise = countsPromise.then(function () {
            vm.interval = new interval_factory_1.Interval(update, $interval, 5 * 60 * 1000);
            vm.interval.start();
            $scope.$on('$destroy', function () {
                if (vm.interval != null) {
                    vm.interval.destroy();
                    vm.interval = null;
                }
            });
            createBlinkTimer();
        });
        loaderService.loadingPromise(promise);
        return vm;
    }
    exports.default = angular.module('aps.controller.countsVertical', requires)
        .config(countsConfig)
        .controller('CountsVerticalCtrl', countsVerticalCtrl)
        .directive('sparklineChart', sparklineChart)
        .name;
    function getCountsHelpText(helpScreen) {
        var helptext = '';
        switch (helpScreen) {
            case 'EQUIPMENT COUNTS':
                helptext = "  \n        <div class=\"header\">\n          Equipment Counts\n        </div>         \n        <div class=\"subheader\">\n          <u>How the Counts Work</u>:\n        </div>\n        <div class=\"detail\">\n          Below is a sample count object, this is sample data just for instructional purposes.\n\n          <div style=\"width:50%\">\n            <table class=\"history-t no-padding bs-table bs-table-striped\" style=\"width:30%\">\n              <thead>\n                <tr>\n                  <th class=\"text-center\" colspan=\"4\">X</th>\n                </tr>\n              </thead>\n              <tbody>\n                <tr>\n                  <td>SQR</td>\n                  <td>11328</td>\n                  <td>166</td>\n                  <td class=\"fail-percentage\">1.5%</td>\n                </tr>\n              </tbody>\n            </table>\n          </div>\n        </div>\n        <div class=\"detail\">\n          As you can see the count object is broken up into 4 different fields. Here is the definition of each:\n        </div>  \n        <div class=\"detail\">\n          <ol type = \"1\">\n            <li class=\"detail\">\n              <b>Equipment Shorthand:</b> This is a shorthand abreviation of the type of equipment configured on the line.\n              In this case this is a high speed squeezer. This is abreviated as SQR.\n            </li>\n            <li class=\"detail\">\n              <b>Inspect Count:</b> The number of bottles going into the machine.\n              In APS the preference is to use a direct integration to the machine for this counter.\n              However, there are instances that we are dependent on a photoeye before the inspection equipment \n              to provide the inspect count.\n            </li>\n            <li class=\"detail\">\n              <b>Reject Count:</b>\n              The amount of bottles rejected by the piece of inspection equipment.\n              For most equipment we have a direct integration and the equipment keeps counts of rejects.\n              However, for some equipment integrations we need to calculated it by taking the difference between\n              bottles in and bottles out.\n              <br/>\n              <span class=\"formula\">Reject Count = Reject Count from Machine</span><br/>\n              <span class=\"count\">- OR -</span><br/>\n              <span class=\"formula\">Reject Count = Machine Bottles In - Machine Bottles Out</span><br/>\n             </li>\n            <li class=\"detail\">\n              <b>Reject Percent:</b>\n              The percent of loss for each piece of equipment.\n              This calculation is based off the equipment inspects vs. the rejects.\n              <br/>\n              <span class=\"formula\">Reject Percent = Reject Count / Inspect Count</span><br/>\n\n              On each job run, an acceptable percentage range can be set for each equipment type. If the equipment has a tolerance set\n              and the current value is outside those parameters, this value is highlighted in \n              <span class=\"red\">red</span> to help users quickly identify issues.\n            </li>\n          </ol>\n        </div>\n        <div class=\"subheader\">\n          <u>Equipment Details</u>:\n        </div>   \n        <div class=\"detail\">\n          Every piece of equipment has the ability to drill-down. \n          All the user has to do to access this data is to click on the peice of equipment.\n          Depending on the type of integration some equipment will display more data than others.\n        </div>\n          ";
                break;
            case 'EQUIPMENT GROUP':
                helptext = "  \n        <div class=\"header\">\n          EQUIPMENT COUNTS by CATEGORY against SHEARS\n        </div>         \n        <div class=\"subheader\">\n          <u>Metrics per Category</u>:\n        </div>\n        <div class=\"detail\">\n          This metric measures the total losses by equipment type against shear cuts.\n          The metric definitions are as follows.\n        </div>\n        <div class=\"detail\">\n          <ol type = \"1\">\n            <li class=\"detail\">\n              <b>REJECTS:</b> \n              The total amount of bottles rejected in each equipment category.\n              This value is highlighted in <span class=\"red\">red</span> to help users quickly identify losses.\n            </li>\n            <li class=\"detail\">\n              <b>REJECT:</b>\n              The percent loss for each equipment categor.\n              This value is highlighted in <span class=\"red\">red</span> to help users quickly identify losses.\n              <br/>\n              <span class=\"formula\">REJECT = 100 * (Rejects by Category/ Shears)</span>\n            </li>\n          </ol>\n        </div>\n          ";
                break;
            case 'SHOP KPI':
                helptext = "  \n        <div class=\"header\">\n          Shop KPI's\n        </div>         \n        <div class=\"subheader\">\n          <u>KPI Metric Definitions</u>:\n        </div>\n        <div class=\"detail\">\n          The goal of these KPI's is to see how the shop is performing at each point along the line.\n          We use each pulse from the shear cuts to calculate how many gobs are currently being produced.\n        </div>\n        <div class=\"detail\">\n          <ol type = \"1\">\n            <li class=\"detail\">\n              <b>MACHINE SPEED:</b>\n              How many bottles per minute the machine is producing.\n              When available we use direct machine integration.\n              Otherwise, we use the shear pulses to estimate the speed.\n            </li>\n            <li class=\"detail\">\n              <b>H/E Efficiency:</b> \n              The percent of bottles going into the lehr, against the shears.\n              <br/>\n              <span class=\"formula\">H/E Efficiency = Lehr In Counter / Shears</span>\n            </li><style>\n            .cur-ptr {\n              cursor: pointer;\n            }\n          \n            .noColor {\n              background-color: transparent;\n            }\n          \n            .noPadding {\n              padding: 0px;\n            }\n          \n            .no-bg {\n              background-color: transparent;\n            }\n          \n            .aps-info {\n              background-color: #1690CB;\n              color: white;\n            }\n          \n            .vc-count-name {\n              white-space: nowrap;\n            }\n          \n            .vc-bordered {\n              border: solid 1px silver;\n            }\n          \n            .vc-td-nm {\n              text-align: left;\n              height: 100%;\n              vertical-align: middle;\n            }\n          \n            .eq-box {\n              border: solid 1px silver;\n              display: inline-block;\n              z-index: 4;\n              height: 19px;\n              padding: 0;\n              margin-bottom: 0;\n              margin-right: 2px;\n              margin-left: 0;\n              margin-top: 2px;\n            }\n          \n            .eq-tb {\n              background-color: transparent;\n            }\n          \n            .eq-tb>tbody>tr>td,\n            .eq-tb>thead>tr>th {\n              border: none;\n              text-align: center;\n              vertical-align: middle;\n            }\n          \n            .eq-td-idx {\n              text-align: center;\n            }\n          \n            .eq-col {\n              height: 17px;\n              z-index: 5;\n              padding-top: 1px;\n              font-weight: bold;\n            }\n          \n            .eq-idx {\n              width: 13px;\n              text-align: center;\n              background-color: #1690CB !important;\n              color: white;\n            }\n          \n            .eq-ict {\n              width: 60px;\n              text-align: right;\n            }\n          \n            .eq-rct {\n              width: 50px;\n              text-align: right;\n            }\n          \n            .eq-rpt {\n              width: 50px;\n              text-align: center;\n              padding-bottom:1px;\n            }\n            .eq-sparkline {\n              width: 60px;\n              background-color: transparent;\n              z-index: 1002;\n              text-align: center;\n              height: 18px;\n            }\n          \n            .eq-td-nm {\n              width: 195px;\n              white-space: nowrap;\n              text-overflow: ellipsis;\n            }\n          \n            .vc-header {\n              height: 24px;\n            }\n          \n            .vc-text-white {\n              color: white;\n            }\n          \n            .vc-bg-warning {\n              background-color: yellow !important;\n            }\n          \n            .vc-bg-err {\n              background-color: red !important;\n            }\n          \n            .ag-eq-rows>div[data-type='row']:nth-of-type(odd) {\n              background-color: #dedddd;\n            }\n          \n            .ag-eq-rows>div[data-type='row']:nth-of-type(even) {\n              background-color: #F2F2F2;\n            }\n          \n            .ag-eq-rows>div[data-type='header'] {\n              background-color: #1690CB !important;\n              color: white;\n              font-weight: bold;\n            }\n          \n            .vc-col,\n            .eq-box>table>tbody>tr>td {\n              font-size: 13.6px;\n              font-weight: 400;\n              font-style: normal;\n              font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n              letter-spacing: 0.8px;\n            }\n          \n            .vc-trend {\n              margin-left: -4px;\n              width: 9px;\n              height: 14px;\n            }\n          \n            .vc-col-th {\n              margin-top: 3px;\n              text-align: center;\n            }\n          \n            .bs-btn-unselected {\n              color: #000000;\n              background-color: #e7e7e7;\n              border-color: #b9b9b9;\n            }\n          \n            .bs-btn-unselected:hover {\n              background-color: #dedddd;\n            }\n          \n            .bs-btn-selected {\n              color: #fff;\n              background-color: #008CBA;\n              border-color: #007095;\n            }\n          \n            .bs-btn-selected:hover {\n              color: #fff;\n              background-color: #007095;\n              border-color: #007095;\n            }\n          \n            .bs-btn {\n              margin-bottom: 2px;\n            }\n          \n            .bs-row {\n              margin-left: 0;\n              margin-right: 0;\n            }\n          \n            .bs-card-equipmentbox {\n              margin: 4px;\n              cursor: pointer;\n            }\n          \n            .bs-card-equipmentbox>.bs-card-body {\n              padding: 8px;\n            }\n          \n            .bs-card-kpi {\n              margin: 4px;\n              cursor: pointer;\n            }\n          \n            .bs-card-kpi>.bs-card-body {\n              padding: 10px;\n            }\n          \n            .ag-toolbar {\n              margin: 0;\n              padding: 0 0 0 0;\n              vertical-align: middle;\n              display: inline-flex;\n            }\n          \n            button,\n            select {\n              margin: 0;\n            }\n          \n            .ag-plant-info {\n              display: inline-block;\n              padding: 6px 6px 6px 0;\n              margin: 0;\n            }\n          \n            .ag-interval-info {\n              padding: 5px 5px 0 5px;\n              margin: 0 0 0 0;\n              display: inline-block;\n            }\n          \n            .ag-interval-info>span {\n              font-size: 14px;\n              font-weight: 400;\n            }\n          \n            .ag-buttonarray-info {\n              padding: 3px 3px 0px 3px;\n              margin: 0;\n              display: inline-block;\n            }\n          \n            .ag-plant-label {\n              color: #1178A8;\n              font-size: 1em;\n              font-weight: 500;\n              display: block;\n            }\n          \n            .ag-shop-label {\n              font-weight: 400;\n              font-size: .75em;\n              color: #000000;\n              display: block;\n            }\n          \n            .ag-header {\n              padding: 0 0 0 0;\n              margin-top: 6px;\n            }\n          </style>\n          \n          <!-- header -->\n          <div class=\"row-flex ag-header\">\n            <div class=\"bs-col-12\">\n              <div class=\"ag-toolbar\">\n                <div class=\"ag-plant-info\">\n                  <span class=\"ag-plant-label\">{{vm.plant.name || \"...\"}}</span>\n                  <span class=\"ag-shop-label\">Shop {{vm.shop.name}}</span>\n                </div>\n                <div class=\"ag-interval-info\">\n                  <span>Viewing Count Data For:</span>\n                  <select style=\"width: 120px;\" id=\"countsInterval\" ng-model=\"vm.countsInterval\"\n                    ng-options=\"t.value as t.text for t in vm.countDisplayIntervalOptions\"\n                    ng-change=\"vm.countsIntervalChanged()\" class=\"form-control\"></select>\n                </div>\n                <div class=\"ag-buttonarray-info\">\n                  <btn-array options=\"vm.navigationUrls\" />\n                </div>\n              </div>\n            </div>\n          </div>\n          \n          <!-- use bootstrap columns instead of tables -->\n          <div class=\"row-flex\">\n            <div class=\"bs-col-12\">\n              <h6>\n                <b>EQUIPMENT COUNTS (% INSPECT VS. REJECT)</b>&nbsp;<a ng-click=\"vm.showHelp('EQUIPMENT COUNTS')\"><i class=\"fa fa-info-circle fa-bigger\"></i></a>\n              </h6>\n              <div class=\"ag-eq-rows\">\n                <div class=\"row-flex vc-header\" data-type=\"header\">\n                  <div class=\"bs-col-3\">\n                    <div class=\"vc-col-th\">\n                      <span>Device</span>\n                    </div>\n                  </div>\n                  <div class=\"bs-col-9\">\n                    <div class=\"vc-col-th\">\n                      <span>Split Line Counters</span>\n                    </div>\n                  </div>\n                </div>\n          \n                <!-- data -->\n                <div class=\"row-flex\" data-type=\"row\" ng-repeat-start=\"count in vm.vc\">\n                  <div class=\"bs-col-3 no-margin\">\n                    <div class=\"vc-col cur-ptr\" style=\"margin-top: 4px;\" ng-click=\"vm.viewDetails(count,'parent')\">\n                      <span class=\"bs-text-nowrap count\" title=\"{{count.id}}\"  ng-class=\"vm.getEquipmentClass(count.equipment)\">{{count.name}}</span>\n                    </div>\n                  </div>\n                  <div class=\"bs-col-9 no-margin\">\n                    <div class=\"vc-col\">\t\t\n                      <equipment-box equipment=\"equipment\"\n                                     options=\"vm.detailChartConfig\"\n                                     lossPercentClass={{vm.getLossPercentClass(equipment)}}\n                                     borderClass={{vm.getRowClass(equipment)}}\n                          class=\"cur-ptr\" title=\"rejectCountId: {{equipment.rejectCount.id}}\"\n                        ng-repeat=\"equipment in count.equipment | orderBy: 'line.name'\"\n                        ng-click=\"vm.viewRejectDetail(count)\"> {{vm.getEquipmentClass(equipment)}}</equipment-box>\n                    </div>\n                  </div>\n                </div>\n          \n                <!-- children -->\n                <div class=\"row-flex\" data-type=\"row\" ng-repeat=\"ct in count.children | orderBy:'name'\">\n                  <div class=\"bs-col-3\">\n                    <div class=\"vc-col cur-ptr\" style=\"margin-left: 20px; margin-top: 4px;\" ng-click=\"vm.viewDetails(ct,'child')\">\n                      <span class=\"\" title=\"{{ct.id}}\">\n                        <b>{{ct.name}}</b>\n                      </span>\n                    </div>\n                  </div>\n                  <div class=\"bs-col-9\">\n                    <div class=\"vc-col\">\n                      <equipment-box equipment=\"eq\" options=\"vm.detailChartConfig\"\n                        class=\"cur-ptr\" title=\"{{eq.id}}\"\n                        ng-repeat=\"eq in ct.equipment | orderBy: 'line.name'\" ng-click=\"vm.viewRejectDetail(ct)\">\n                      </equipment-box>\n                    </div>\n                  </div>\n                </div>\n          \n                <div ng-repeat-end data-type=\"row\" ng-if=\"false\"></div>\n              </div>\n            </div>\n          </div>\n          <br/>\n          <!-- equipment groups -->\n          <div class=\"row-flex\">\n            \n            <div class=\"bs-col-12\">\n              <h6>\n                <b>EQUIPMENT COUNTS by CATEGORY (% OF SHEARS)</b>&nbsp;<a ng-click=\"vm.showHelp('EQUIPMENT GROUP')\"><i class=\"fa fa-info-circle fa-bigger\"></i></a>\n              </h6>\n              <div ng-repeat=\"group in vm.model.equipmentGroups\" style=\"display: inline-block;\"\n                ng-click=\"vm.viewGroupRejectDetail(group)\">\n                <div class=\"bs-card bs-card-equipmentbox\"  ng-class=\"vm.getRowClass(group)\">\n                  <div class=\"bs-card-body\">\n                    <div class=\"bs-card-title\">\n                      <b>{{group.name}}</b>\n                    </div>\n                    <div class=\"bs-card-text\">\n                      <div class=\"bs-text-right\">\n                        <b>{{group.inspectCount.count | number}}</b>\n                      </div>\n                    </div>\n                    <div class=\"bs-card-text\">\n                      <div class=\"bs-text-right\" style=\"margin-top: 0.3125em;\">\n                        <b>{{(group.rejectCount.count | number) || \"-\"}}</b>\n                      </div>\n                    </div>\n                    <div class=\"bs-card-text\">\n                      <div class=\"bs-text-right\" ng-class=\"vm.getLossPercentClass(group)\"> \n                          <b>{{(group.rejectCount.getPercent() || \"0\") + \"%\"}}</b>\n                          <vert-trend trend=\"group.rejectCount.trend\" style=\"margin-top: .1em\" />\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <br/>\n          \n          <!-- kpi -->\n          <div class=\"bs-row\">\n            <div class=\"bs-col-12\">\n              <h6>\n                <b>SHOP KPI (% INSPECT VS. REJECT)</b>&nbsp;<a ng-click=\"vm.showHelp('SHOP KPI')\"><i class=\"fa fa-info-circle fa-bigger\"></i></a>\n              </h6>\n              <div ng-repeat=\"kpi in vm.model.kpis\" style=\"display: inline-block;\">\n                <div class=\"bs-card bs-card-kpi\">\n                  <div class=\"bs-card-body\">\n                    <div class=\"bs-card-text\">\n                      <label style=\"display: inline;\">{{kpi.efficiencyName}}:</label>\n                      <span>{{kpi.efficiency}}</span>\n                    </div>\n                    <div class=\"bs-card-text\">\n                      <span>\n                        <label style=\"display: inline;\">{{kpi.lossesName}}:</label>\n                        <span>{{kpi.losses | number}}</span>\n                      </span>\n                    </div>\n                    <div class=\"bs-card-text\">\n                      <span ng-if=\"$index === 0\">\n                        <label style=\"display: inline;\">Speed:</label>\n                        <span>{{kpi.denominator.speed}}</span>\n                      </span>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div ng-if=\"vm.showHelpWindow\" class=\"charthelpdetails\">\n            <div class=\"windowclose\">\n              <a><i class=\"fa fa-times-circle fa-bigger\" ng-click=\"vm.toggleHelpWindow()\"></i></a>\n            </div>\n            <div class=\"tooltiptext\" ng-bind-html=\"vm.helpText\">\n            </div>\n          </div>\n            <li class=\"detail\">\n              <b>C/E Efficiency:</b>\n              The percent of bottles that make it to the End of Line (EOL), compared to the lehr. \n              This is usually a photoeye, sometimes it can be the last piece of inspection equipment. It depends on the shop configuration.\n              <br/>\n              <span class=\"formula\">C/E Efficiency = EOL / Lehr In Counter</span>\n            </li>\n            <li class=\"detail\">\n              <b>Pack Efficiency:</b>\n              The percent of bottles that make it to the End of Line (EOL), against the shears. \n              This is usually a photoeye, sometimes it can be the last piece of inspection equipment. It depends on the shop configuration.\n              <br/>\n              <span class=\"formula\">Pack Efficiency = EOL / Shears</span>\n            </li>\n          </ol>\n        </div>\n          ";
                break;
            default:
                helptext = 'Selected Help Screen Not Found...';
                break;
        }
        return helptext;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<style>.cursor-hand{cursor:pointer}.row{padding-top:15px;padding-bottom:15px}.line-h{background-color:#1690cb;text-align:center;height:20px;color:#fff;padding-top:2px;border-style:solid;border-width:1px 1px 0 1px;border-color:#cdcccc}.line-rej{color:red}.equip{padding-left:0;padding-right:0;padding-top:3px;border-style:solid;border-width:0 1px 0 1px;border-color:#cdcccc}.equipment-disabled{background-color:#cb727e!important;color:#fff}.line-disabled{background-color:#cb727e!important}.line-eq{font-weight:700}.eq-hd{background-color:#fff;min-height:25px}.eq-hd div{padding-top:5px}.dtl-line{background-color:#f2f2f2!important;border-style:solid;border-width:1px 0 0 0;border-color:#ddd;min-height:20px}.dtl{color:#7d7e7d;padding-left:25px;margin-top:2px;font-weight:700!important}.dtl-rej{font-size:12px!important;font-weight:300!important;color:red;margin-top:2px}.divider{height:20px;background-color:#fff;padding:10px;border-style:solid;border-width:1px 0 0 0;border-color:#cdcccc}.eq-divider{background-color:#afe7b1;height:5px}.vert-trend{float:right;margin-right:2px}.vert-trend-detail{float:right;margin-right:2px;margin-top:-15px}.line-rej-percent{float:left;margin-top:-5px}.detail-chart{width:100%;padding-top:10px}.detail-chart .chart{width:100%;display:block}.offset-1col{margin-left:32%}.offset-2col{margin-left:24.33%}.offset-3col{margin-left:12.33%}.col-sm-2Plus{flex:0 0 20%;max-width:20%;padding-right:15px;padding-left:15px}.stats{text-align:center;margin:5px 5px 5px 5px}.bs-btn-unselected{color:#000;background-color:#e7e7e7;border-color:#b9b9b9}.bs-btn-unselected:hover{background-color:#dedddd}.bs-btn-selected{color:#fff;background-color:#008cba;border-color:#007095}.bs-btn-selected:hover{color:#fff;background-color:#007095;border-color:#007095}.bs-btn{margin-bottom:2px}.bs-row{margin-left:0;margin-right:0}.bs-card-equipmentbox{margin:4px;cursor:pointer}.bs-card-equipmentbox>.bs-card-body{padding:8px}.bs-card-kpi{margin:4px;cursor:pointer}.bs-card-kpi>.bs-card-body{padding:10px}@media screen and (max-width:1600px){.col-sm-2Plus{padding-right:3px;padding-left:3px}.dtl-rej,.line-rej{padding-left:3px!important;padding-right:0!important}.col-md-3{padding-left:2px}.det-rej-percent,.line-rej-percent{margin-left:-10px}}@media screen and (max-width:1050px){.dtl-rej{max-width:50px;padding-left:25px!important}.line-rej-percent{margin-left:0}.col-sm-2Plus{padding-right:15px;padding-left:15px}.vert-trend-detail{margin-right:-25px}}@media screen and (max-width:642px){.col-sm-2Plus{position:relative;width:100%;flex:none;max-width:100%}.detail-chart{padding-left:20px}.dtl{width:200px}.dtl-rej{padding-left:0}.tabs{padding-left:30px}.offset-1col,.offset-2col,.offset-3col,.offset-4col,.offset-5col{margin-left:0}}table.history-t tr:nth-child(even){background:0 0}.x-tr{background:#ececec}table.history-t{padding:0;border:none}.no-padding{padding:0}.no-margin{margin:0}.box{border:solid 1px #d3d3d3;margin:4px 4px 4px 5px;padding:0;overflow-y:hidden;overflow-x:auto}.x-box{border:solid 1px #d3d3d3;margin:4px 4px 4px 5px;padding:0}.ag-card{border:solid 1px #d3d3d3;margin:0;padding:10px 10px 10px 10px}.highcharts-background{fill:transparent}.td-sparkline{width:60px}.chart-sparkline{margin:0;padding:0;width:60px;height:21px;display:inline-block}</style> <div class=\"row-flex ag-header\"> <div class=\"ag-header-plant ag-header-box\"> <span class=ag-plant-name>{{vm.plant.name || \"...\"}}</span> <span class=ag-shop>Shop {{vm.shop.name}}</span> </div> <div class=\"ag-header-count-interval ag-header-box\"> <label> <span>Viewing Count Data For:</span> <select style=width:120px id=countsInterval ng-model=vm.countsInterval ng-options=\"t.value as t.text for t in vm.countDisplayIntervalOptions\" ng-change=vm.countsIntervalChanged() class=form-control></select> </label> </div> <div class=\"ag-header-btnarray ag-header-box\"> <btn-array options=vm.navigationUrls /> </div> </div> <div> <div class=row-flex> <div class=bs-col-12> <h6> <b>EQUIPMENT COUNTS (% INSPECT VS. REJECT)</b> &nbsp;<a ng-click=\"vm.showHelp('EQUIPMENT COUNTS')\"><i class=\"fa fa-info-circle fa-bigger\"></i></a> <div class=btn-switch-container> <div class=mb-2><h6><b>Denominator Toggle</b></h6></div> <div style=display:flex;align-items:center;justify-content:center> <span>Equipment</span> <div class=btn-switch ng-class=\"{'btn-switch--on':vm.model.usePercentGobs}\" ng-model=vm.model.usePercentGobs ng-click=vm.usePercentGobsChanged();> <div class=btn-switch-circle ng-class=\"{'btn-switch-circle--on':vm.model.usePercentGobs}\" ng-model=vm.model.usePercentGobs> </div> </div> <span>Shears</span> </div> </div> </h6> <!-- data --> <div ng-repeat=\"area in vm.areas\" class=row-flex ng-if=\"area.rows.length == 1 && area.rows[0].line.equipment.length > 0 || area.rows.length > 1\"> <div ng-repeat=\"row in area.rows\" class=\"col-lg-3 col-md-6 col-xs-12 no-margin no-padding\" ng-if=\"row.line.equipment.length > 0\" ng-class=\"{\r\n\t\t\t\t\t\t'd-flex justify-content-center': area.rows.length == 1,\r\n\t\t\t\t\t\t'd-flex justify-content-center': area.rows.length == 2,\r\n\t\t\t\t\t\t'd-flex justify-content-center': area.rows.length == 3,\r\n\t\t\t\t\t\t'': area.rows.length == 4}\"> <div class=box> <table ng-if=\"row.line.equipment && row.line.equipment.length > 0\" class=\"history-t no-margin no-padding bs-table bs-table-striped\"> <thead ng-click=vm.toggleLineActive(row.line)> <tr> <th colspan=5 class=\"text-center cursor-hand\" ng-class=\"{'line-disabled': row.line.isDisabled}\">{{row.line.name}}</th> </tr> </thead> <tbody> <tr ng-repeat-start=\"equip in row.line.equipment\" class=cursor-hand ng-class=vm.getRowClass(equip) ng-click=\"vm.viewRejectDetail(row.line, equip)\"> <td ng-class=vm.getEquipmentClass(equip)> <span>{{equip.name}}</span> </td> <td class=text-right> <span>{{equip.inspectCount.count | number}}</span> </td> <td class=text-right> <div style=display:inline-block;text-overflow:clip;white-space:nowrap> <span>{{equip.rejectCount.count | number}}</span> <vert-trend trend=equip.rejectCount.trend /> </div> </td> <td class=text-right ng-class=vm.getLossPercentClass(equip)> <span>{{equip.rejectCount.getPercent()}}%</span> </td> <td class=\"text-center no-margin no-padding td-sparkline\" style=margin:0;padding:0> <sparkline-chart data=\"{{equip.rejectCount.trendCounts}}\" options=vm.detailChartConfig class=\"no-padding no-margin chart-sparkline\"> </sparkline-chart> </td> </tr> <tr ng-repeat=\"detail in equip.lineEquipmentDetail\"> <!-- name --> <td colspan=2 style=overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:240px> <span style=margin-left:20px title=\"{{detail.name}}\">{{detail.name}}</span> </td> <!--- count --> <td class=text-right> <div style=display:inline-block;white-space:nowrap> <span>{{detail.count | number}}</span> <vert-trend trend=detail.trend /> </div> </td> <!-- percent --> <td class=text-right> <span>{{detail.getPercent()}}%</span> </td> <!-- trend counts --> <td class=\"text-center no-margin no-padding td-sparkline\" style=margin:0;padding:0> <sparkline-chart data=\"{{detail.trendCounts}}\" options=vm.detailChartConfig class=\"no-padding no-margin chart-sparkline\"> </sparkline-chart> </td> </tr> <tr ng-repeat-end ng-if=false></tr> </tbody> </table> </div> </div> </div> </div> </div> <!-- stats --> <!-- <div class=\"row-flex flex-column-mobile\" style=\"margin: 5px;\">\r\n\t\t<equipment-group ng-repeat=\"group in vm.model.equipmentGroups\" group=\"group\"\r\n\t\t\tng-click=\"vm.viewGroupRejectDetail(group)\"\r\n\t\t\tng-class=\"{equipmentsummaryfirst:$first, equipmentsummary:!$first}\" />\r\n\t</div> --> <div class=row-flex> <div class=bs-col-12> <h6> <b>EQUIPMENT COUNTS by CATEGORY (% OF SHEARS)</b>&nbsp;<a ng-click=\"vm.showHelp('EQUIPMENT GROUP')\"><i class=\"fa fa-info-circle fa-bigger\"></i></a> </h6> <div ng-repeat=\"group in vm.model.equipmentGroups\" style=display:inline-block ng-click=vm.viewGroupRejectDetail(group)> <div class=\"bs-card bs-card-equipmentbox\" ng-class=vm.getRowClass(group)> <div class=bs-card-body> <div class=bs-card-title> <b>{{group.name}}</b> </div> <div class=bs-card-text> <div class=\"bs-text-right count\"> <b>{{group.inspectCount.count | number}}</b> </div> </div> <div class=bs-card-text> <div class=\"bs-text-right count\"> {{(group.rejectCount.count | number) || \"-\"}} </div> </div> <div class=bs-card-text> <div class=bs-text-right ng-class=vm.getLossPercentClass(group)> <b>{{(group.rejectCount.percent || \"0\") + \"%\"}}</b> <vert-trend trend=group.rejectCount.trend style=margin-top:.1em /> </div> </div> </div> </div> </div> </div> </div> <!-- kpi --> <!-- <kpi class=\"row count-performance\" kpis=\"vm.model.kpis\" /> --> <!-- <div class=\"row count-performance\">\r\n\t\t<div class=\"small-4 columns\" ng-repeat=\"kpi in vm.model.kpis\">\r\n\t\t\t<div>\r\n\t\t\t\t<label style=\"display: inline;\">{{kpi.efficiencyName}}:</label> {{kpi.efficiency}} </div>\r\n\t\t\t<div>\r\n\t\t\t\t<label style=\"display: inline;\">{{kpi.lossesName}}:</label> {{kpi.losses}} </div>\r\n\t\t\t<div ng-if=\"$index === 0\">\r\n\t\t\t\t<label style=\"display: inline;\">Speed:</label> {{kpi.denominator.speed}} </div>\r\n\t\t</div>\r\n\t</div> --> <div class=row-flex> <div class=bs-col-12> <h6> <b>SHOP KPI (% INSPECT VS. REJECT)</b>&nbsp;<a ng-click=\"vm.showHelp('SHOP KPI')\"><i class=\"fa fa-info-circle fa-bigger\"></i></a> </h6> <div ng-repeat=\"kpi in vm.model.kpis\" style=display:inline-block> <div class=\"bs-card bs-card-kpi\"> <div class=bs-card-body> <div class=bs-card-text> <label style=display:inline>{{kpi.efficiencyName}}:</label> <span>{{kpi.efficiency}}</span> </div> <div class=bs-card-text> <span> <label style=display:inline>{{kpi.lossesName}}:</label> <span>{{kpi.losses | number}}</span> </span> </div> <div class=bs-card-text> <span ng-if=\"$index === 0\"> <label style=display:inline>Speed:</label> <span>{{kpi.denominator.speed}}</span> </span> </div> </div> </div> </div> </div> </div> <div ng-if=vm.showHelpWindow class=charthelpdetails> <div class=windowclose> <a><i class=\"fa fa-times-circle fa-bigger\" ng-click=vm.toggleHelpWindow()></i></a> </div> <div class=tooltiptext ng-bind-html=vm.helpText> </div> </div></div>");

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div style=height:46px> <div> <span class=plant-name>{{plant.name}}</span> <span class=shop>Shop {{shop.name}}</span> </div> <div style=display:inline-block> <label> <span>Viewing Count Data For:</span> <select style=width:120px id=countsInterval ng-model=countsInterval ng-options=\"t.value as t.text for t in countDisplayIntervalOptions\" ng-change=countsIntervalChanged></select> </label> </div> <div style=display:inline-block;height:46px;margin-left:10px> <btn-array options=navigationUrls /> </div> </div>");

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(620), __webpack_require__(621), __webpack_require__(5), __webpack_require__(3), __webpack_require__(27), __webpack_require__(26), __webpack_require__(9), __webpack_require__(28), __webpack_require__(4), __webpack_require__(8), __webpack_require__(7), __webpack_require__(48), __webpack_require__(57), __webpack_require__(34), __webpack_require__(50), __webpack_require__(302), __webpack_require__(94), __webpack_require__(303)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, sparklineChartsV2_1, countVerticalv2_tpl_html_1, aps_enums_1, constant_module_1, enums_1, counts_service_1, uiUtility_service_1, lineConfigs_service_1, loader_service_1, navigation_service_1, authData_service_1, groupRejects_service_1, dataPoints_service_1, Highcharts, interval_factory_1, counts_header_directive_1, count_controller_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [counts_service_1.default, uiUtility_service_1.default, lineConfigs_service_1.default, loader_service_1.default,
        navigation_service_1.default, authData_service_1.default, groupRejects_service_1.default, counts_header_directive_1.default, dataPoints_service_1.default
    ];
    var validate = function (i) {
        return i !== null && angular.isDefined(i);
    };
    var VertCtRequest = (function () {
        function VertCtRequest() {
        }
        return VertCtRequest;
    }());
    var VertCtPercent = (function () {
        function VertCtPercent() {
        }
        return VertCtPercent;
    }());
    var VertCtTrend = (function () {
        function VertCtTrend() {
        }
        return VertCtTrend;
    }());
    var VertCt = (function () {
        function VertCt() {
        }
        return VertCt;
    }());
    var VertCtRejectCount = (function () {
        function VertCtRejectCount() {
        }
        return VertCtRejectCount;
    }());
    var VertCtRejectChildCount = (function () {
        function VertCtRejectChildCount() {
        }
        return VertCtRejectChildCount;
    }());
    var VertCtInspectCount = (function () {
        function VertCtInspectCount() {
        }
        return VertCtInspectCount;
    }());
    var VertCtEquipment = (function () {
        function VertCtEquipment() {
        }
        return VertCtEquipment;
    }());
    var VertCtChildEquipment = (function () {
        function VertCtChildEquipment() {
        }
        return VertCtChildEquipment;
    }());
    var VertCtDevice = (function () {
        function VertCtDevice(id, name, equipment) {
            this.id = id;
            this.name = name;
            this.equipment = equipment;
        }
        return VertCtDevice;
    }());
    var VertCtChildDevice = (function () {
        function VertCtChildDevice(id, name, equipment) {
            this.id = id;
            this.name = name;
            this.equipment = equipment;
        }
        return VertCtChildDevice;
    }());
    var VertCtDataPointHistoryRequest = (function () {
        function VertCtDataPointHistoryRequest() {
        }
        return VertCtDataPointHistoryRequest;
    }());
    var VertCtDatapointListRequest = (function () {
        function VertCtDatapointListRequest() {
        }
        return VertCtDatapointListRequest;
    }());
    var VertCtDatapointListReportItem = (function () {
        function VertCtDatapointListReportItem() {
        }
        return VertCtDatapointListReportItem;
    }());
    var VertCtDataPointHistoryReportItem = (function () {
        function VertCtDataPointHistoryReportItem() {
            this.request = new VertCtDataPointHistoryRequest();
        }
        return VertCtDataPointHistoryReportItem;
    }());
    var CountsVerticalCtrlV2 = (function () {
        CountsVerticalCtrlV2.$inject = ["$stateParams", "$q", "$scope", "$modal", "$state", "$interval", "countsService", "lineConfigsService", "loaderService", "navigationService", "authDataService", "groupRejectsService", "uiUtilityService", "dataPointService"];
        function CountsVerticalCtrlV2($stateParams, $q, $scope, $modal, $state, $interval, countsService, lineConfigsService, loaderService, navigationService, authDataService, groupRejectsService, uiUtilityService, dataPointService) {
            var _this = this;
            this.vc = [];
            this.showCharts = true;
            this.equipmentRejectTolerances = {};
            this.blinkClass = " blinkingVerticals";
            this.toggleHelpWindow = function () {
                _this.showHelpWindow = !_this.showHelpWindow;
            };
            this.$scope = $scope;
            this.$modal = $modal;
            this.$state = $state;
            this.$interval = $interval;
            this.$q = $q;
            this.countDisplayIntervalOptions = uiUtilityService.getListOptionsFromEnum(enums_1.apsDisplayEnums.CountDisplayInterval, null, null, function (o) { return o; });
            this.countsInterval = authDataService.getCountInterval();
            this.detailChartConfig = this.getDetailsChartConfig();
            this.$stateParams = $stateParams;
            this.countsService = countsService;
            this.lineConfigsService = lineConfigsService;
            this.loaderService = loaderService;
            this.navigationService = navigationService;
            this.authDataService = authDataService;
            this.groupRejectsService = groupRejectsService;
            this.dataPointService = dataPointService;
            this.uiUtilityService = uiUtilityService;
            this.helpText = null;
            this.shopId = this.$stateParams.shopId;
            this.navigationUrls = {
                buttons: [
                    { 'name': 'Horizontal Layout', 'value': 'horizontal', 'selected': false },
                    { 'name': 'Vertical Layout', 'value': 'vertical', 'selected': false },
                    { 'name': 'Vertical Layout (v2)', 'value': 'vc2', 'selected': true },
                ],
                select: function (button) {
                    var stateParams = {
                        plantId: $stateParams.plantId,
                        shopId: $stateParams.shopId,
                        userId: $stateParams.userId,
                    };
                    switch (button.value) {
                        case "horizontal":
                            $state.go(constant_module_1.States.COUNTS_HORIZONTAL, stateParams);
                            break;
                        case "vertical":
                            $state.go(constant_module_1.States.COUNTS_VERTICAL, stateParams);
                            break;
                        case "vc2":
                            $state.go(constant_module_1.States.COUNTS_VERTICAL_V2, stateParams);
                            break;
                    }
                }
            };
            this.canDisableLine = authDataService.isPlantOrAPSIOAdminForCurrentPlant();
            var updateBlinkClass = function () {
                if (_this.blinkClass.indexOf("light") > 0) {
                    _this.blinkClass = " blink-dark-vert";
                }
                else {
                    _this.blinkClass = " blink-light-vert";
                }
            };
            var blinkTimer;
            var createBlinkTimer = function () {
                updateBlinkClass();
                if (blinkTimer) {
                    $interval.cancel(blinkTimer);
                }
                blinkTimer = $interval(updateBlinkClass, 600);
            };
            $scope.$on("$destroy", function () {
                if (blinkTimer) {
                    $interval.cancel(blinkTimer);
                }
            });
            var updateFunc = function () {
                _this.update();
            };
            this.countsPromise = this.setupNavigationPromise();
            var promise = this.countsPromise.then(function () {
                createBlinkTimer();
                _this.interval = new interval_factory_1.Interval(updateFunc, _this.$interval, 5 * 60 * 1000);
                _this.interval.start();
                $scope.$on('$destroy', function () {
                    if (_this.interval != null) {
                        _this.interval.destroy();
                        _this.interval = null;
                    }
                });
            });
            loaderService.loadingPromise(promise);
        }
        CountsVerticalCtrlV2.prototype.usePercentGobsChanged = function () {
            this.model.usePercentGobs = !this.model.usePercentGobs;
            count_controller_1.usePercentGobsProducedChanged(this.countsService, this.plant.id, this.model.usePercentGobs);
            this.lineCountsHandler(this.model);
        };
        CountsVerticalCtrlV2.prototype.mapToNewFormat = function (mappedResult) {
            var o = {};
            mappedResult.forEach(function (x) {
                var device = o[x.name];
                if (angular.isUndefined(device)) {
                    device = new VertCtDevice(x.id, x.name, []);
                }
                o[x.name] = device;
                var equipment = {
                    line: {
                        name: x.lineName,
                        id: x.lineId,
                        number: x.lineNumber,
                        state: 'normal'
                    },
                    id: x.id,
                    name: x.name,
                    inspectCount: {
                        count: x.count
                    },
                    rejectCount: {
                        id: x.rejectCount ? x.rejectCount.id : "",
                        name: x.rejectCount ? x.rejectCount.name : "",
                        count: x.rejectCount ? x.rejectCount.count : 0,
                        percent: {
                            value: (x.rejectCount ? x.rejectCount.percent : 0) + '%',
                            error: false,
                        },
                        trendCounts: [0],
                        trend: x.rejectCount ? x.rejectCount.trend : { flat: true }
                    }
                };
                device.equipment.push(equipment);
            });
            var result = Object.keys(o).map(function (key) { return o[key]; });
            return result;
        };
        CountsVerticalCtrlV2.prototype.mapLineToRow = function (line) {
            return {
                isLine: true,
                line: line,
                junction: null,
                cssClass: null
            };
        };
        CountsVerticalCtrlV2.prototype.mapJunctionToRow = function (junction) {
            return {
                isLine: false,
                line: null,
                junction: junction,
                cssClass: 'table' + (junction.inputs.length > junction.outputs.length
                    ? junction.inputs.length : junction.outputs.length).toString()
            };
        };
        CountsVerticalCtrlV2.prototype.mapModelToAreas = function (model) {
            var _this = this;
            var areas = [];
            var area = {
                rows: _.sortBy(model.lines.filter(function (l) { return l.startJunctionId === null; }), function (r) { return r.number; })
                    .map(function (l) { return _this.mapLineToRow(l); })
            };
            var _loop_1 = function () {
                areas.push(area);
                var previousLines = area.rows.filter(function (l) { return l.isLine; }).map(function (l) { return l.line; });
                var rows = [];
                area.rows.forEach(function (row) {
                    if (!row.isLine) {
                        _.sortBy(row.junction.outputs, function (l) { return l.number; }).forEach(function (line) {
                            rows.push(_this.mapLineToRow(line));
                        });
                        return;
                    }
                    var junction = row.line.endJunction;
                    if (!junction) {
                        return;
                    }
                    if (_.some(rows, function (r) { return !r.isLine && r.junction === junction; })) {
                        return;
                    }
                    if (!junction.inputs.every(function (l) { return _.some(previousLines, function (al) { return al.id === l.id; }); })) {
                        rows.push(_this.mapLineToRow(row.line));
                    }
                    rows.push(_this.mapJunctionToRow(junction));
                });
                area = { rows: rows };
            };
            while (area.rows.length > 0) {
                _loop_1();
            }
            return areas;
        };
        CountsVerticalCtrlV2.prototype.mapRejectCount = function (rc, id, name) {
            if (rc) {
                return {
                    type: "rejectCount",
                    id: id,
                    name: name,
                    count: rc.count,
                    percent: rc.percent ? rc.getPercent() : '0',
                    trendCounts: [0],
                    trend: rc.trend ? rc.trend : { flat: true }
                };
            }
            else {
                return null;
            }
        };
        CountsVerticalCtrlV2.prototype.mapLine = function (line) {
            var _this = this;
            return {
                type: "line",
                name: line.name,
                id: line.id,
                shopId: line.shopId,
                number: 1,
                equipment: line.equipment ? line.equipment.filter(validate).map(function (e) {
                    var ic = e.inspectCount;
                    return {
                        lineId: line.id,
                        lineName: line.name,
                        lineNumber: line.number,
                        type: "equipment",
                        id: e.id,
                        name: e.name,
                        order: e.order,
                        count: ic.count,
                        trend: ic.trend,
                        trendCounts: [0],
                        rejectCount: ic.rejectCounts ? _this.mapRejectCount(ic.rejectCounts.filter(validate)[0], e.rejectDataPointId, e.rejectDataPointName) : null
                    };
                }) : [],
            };
        };
        CountsVerticalCtrlV2.prototype.update = function () {
            if (this) {
                this.countsPromise = this.setupNavigationPromise();
                this.loaderService.loadingPromise(this.countsPromise);
                if (this.model) {
                    this.model.handleIntervalChange(this.countsInterval);
                }
                this.authDataService.setCountInterval(this.countsInterval);
            }
        };
        CountsVerticalCtrlV2.prototype.lineCountsHandler = function (result) {
            var _this = this;
            this.model = result;
            count_controller_1.lineCountsLoaded(this);
            try {
                var mappedResult_1 = [];
                result.lines
                    .filter(validate)
                    .forEach(function (line) {
                    var l = _this.mapLine(line);
                    l.equipment.forEach(function (e) { return mappedResult_1.push(e); });
                });
                this.vc = this.mapToNewFormat(mappedResult_1);
                this.parents = {
                    dataPoints: new Array(),
                    hash: {}
                };
                this.children = {
                    dataPoints: new Array(),
                    hash: {}
                };
                _.forEach(this.vc, function (line) {
                    _.forEach(line.equipment, function (eq) {
                        if (angular.isDefined(eq.rejectCount.id)) {
                            _this.parents.hash[eq.rejectCount.id] = eq;
                        }
                    });
                    _.forEach(line.children, function (child) {
                        _.forEach(child.equipment, function (eq) {
                            if (angular.isDefined(eq.id)) {
                                _this.children.hash[eq.id] = eq;
                            }
                        });
                    });
                });
                console.log('vc', this.vc);
            }
            catch (e) {
                console.log('unexpected error', e);
            }
            this.areas = this.mapModelToAreas(this.model);
            var rejects = this.model.shopConfig.jobRuns[0].machineRejectPercentages;
            if (!!rejects) {
                this.areas.forEach(function (area) {
                    area.rows.forEach(function (row) {
                        if (!row.isLine) {
                            return;
                        }
                        row.line.equipment.forEach(function (equipment) {
                            var equipWithRejectPercentage = rejects.filter(function (item) { return item.selectedMachine === equipment.name; });
                            if (equipWithRejectPercentage.length > 0) {
                                var tolerances = {
                                    rejectMinPercentage: equipWithRejectPercentage[0].rejectedMinPercentage,
                                    rejectMaxPercentage: equipWithRejectPercentage[0].rejectedMaxPercentage
                                };
                                _this.equipmentRejectTolerances[equipment.name] = tolerances;
                            }
                        });
                    });
                });
            }
            for (var id in this.model.equipment) {
                if (this.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.HEYE
                    || this.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.CheckDetector
                    || this.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.MX4
                    || this.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.Mcal
                    || this.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.Multi) {
                    this.hasCavities = true;
                    break;
                }
            }
        };
        CountsVerticalCtrlV2.prototype.populatePlantAndShopHandler = function (navModel) {
            this.plant = navModel.selectedPlant;
            this.shop = navModel.selectedShop;
        };
        CountsVerticalCtrlV2.prototype.getLineCountsPromise = function () {
            var _this = this;
            return this.executePromise(function () {
                var countsByShears = true;
                console.log("getLineCounts(shopId:" + _this.shopId + ", plant:" + _this.plant + ", countsInterval:" + _this.countsInterval + ")");
                return _this.countsService.getLineCounts(_this.shopId, _this.plant, _this.countsInterval, _this.canDisableLine, false, countsByShears)
                    .then(function (data) { return _this.lineCountsHandler(data); })
                    .then(function () { return _this.getDetailCounts(); })
                    .then(function () { return _this.getParentTrendCounts(); })
                    .catch(function (reason) {
                    console.log("failed getLineCountsPromise: ", reason);
                });
            }, "getLineCounts");
        };
        CountsVerticalCtrlV2.prototype.setupNavigationPromise = function () {
            var _this = this;
            return this.navigationService.getNavigation()
                .then(function (data) { return _this.populatePlantAndShopHandler(data); })
                .then(function () { return _this.getLineCountsPromise(); })
                .catch(function (reason) {
                console.log("failed getnavigation: ", reason);
            });
        };
        CountsVerticalCtrlV2.prototype.execute = function (method, info) {
            console.log('started ' + info + '...');
            try {
                var result = method();
                console.log('completed ' + info + '.');
                return result;
            }
            catch (_a) {
                console.log('failed ' + info + '.');
            }
        };
        CountsVerticalCtrlV2.prototype.executePromise = function (method, info) {
            console.log('started ' + info + '...');
            return method()
                .finally(function () {
                console.log('completed ' + info + '.');
            }).catch(function (reason) {
                console.log('failed ' + info + '.  ' + reason);
            });
        };
        CountsVerticalCtrlV2.prototype.createChildFromTabCell = function (line, o) {
            var count = o.cells[0].count;
            return {
                line: {
                    id: line.id,
                    name: line.name,
                    number: 0,
                    state: 'normal'
                },
                id: count.cells[0].dataPointIds,
                name: o.displayName,
                inspectCount: {
                    count: null
                },
                rejectCount: {
                    id: null,
                    name: null,
                    count: count.count,
                    percent: {
                        value: count.getPercent(),
                        error: false,
                    },
                    trendCounts: [0],
                    trend: count.showTrend ? count.trend : null
                },
            };
        };
        CountsVerticalCtrlV2.prototype.createChildFromDetail = function (line, o) {
            var count = o.count;
            return {
                line: {
                    id: line.id,
                    name: line.name,
                    number: 0,
                    state: 'normal'
                },
                id: "",
                name: "",
                inspectCount: {
                    count: null
                },
                rejectCount: {
                    id: "",
                    name: "",
                    count: count.count,
                    percent: {
                        value: count.getPercent(),
                        error: false,
                    },
                    trendCounts: [0],
                    trend: count.showTrend ? count.trend : null
                },
            };
        };
        CountsVerticalCtrlV2.prototype.detailCountsHandler = function (counts, equip) {
            var _this = this;
            var request = this.requests[equip.id];
            request.result = counts;
            var eq = counts.equipment;
            var line = counts.equipment.line;
            var subEquipment = {
                equipment: {
                    id: eq.id,
                    name: eq.name,
                },
                line: {
                    id: line.id,
                    name: line.name
                },
                children: angular.isDefined(counts.tabs[0]) && angular.isDefined(counts.tabs[0].outputRows)
                    ? counts.tabs[0].rows.map(function (o) { return _this.createChildFromTabCell(line, o); })
                    : (counts.details != null ? counts.details.map(function (o) { return _this.createChildFromDetail(line, o); }) : [])
            };
            request.test = subEquipment;
            var device = _.find(this.vc, function (e) {
                return e.name === subEquipment.equipment.name;
            });
            if (angular.isDefined(device)) {
                _.forEach(subEquipment.children, function (child) {
                    if (!angular.isDefined(device.children)) {
                        device.children = [];
                    }
                    var cg = _.find(device.children, function (c) {
                        return c.name === child.name;
                    });
                    if (angular.isUndefined(cg)) {
                        cg = {
                            name: child.name,
                            id: child.id,
                            equipment: []
                        };
                        device.children.push(cg);
                    }
                    cg.equipment.push(child);
                });
            }
        };
        CountsVerticalCtrlV2.prototype.getDetailCounts = function () {
            var _this = this;
            var promises = [];
            _.forEach(this.updatedAreas, function (updatedArea) {
                _.forEach(updatedArea.rows, function (updatedRow) {
                    if (updatedRow.line === null) {
                        return;
                    }
                    _.forEach(updatedRow.line.equipment, function (updatedEquip) {
                        _.forEach(_this.areas, function (area) {
                            _.forEach(area.rows, function (row) {
                                if (row.line === null) {
                                    return;
                                }
                                _.forEach(row.line.equipment, function (equip) {
                                    if (equip.id === updatedEquip.id) {
                                        equip.inspectCount.count = updatedEquip.inspectCount.count;
                                        if (updatedEquip.rejectCount != null) {
                                            equip.rejectCount.count = updatedEquip.rejectCount.count;
                                            equip.rejectCount.percent = updatedEquip.rejectCount.percent;
                                            equip.rejectCount.gobPercent = updatedEquip.rejectCount.gobPercent;
                                        }
                                        if (!angular.isDefined(equip.inspectCount)
                                            && !angular.isDefined(equip.rejectCount)
                                            && !angular.isDefined(equip.inspectCount.count)
                                            && !angular.isDefined(equip.rejectCount.count)) {
                                            if (equip.inspectCount.count === 0 && equip.rejectCount.count === 0) {
                                                var resetLineEquipDetail = [];
                                                equip.lineEquipmentDetail = resetLineEquipDetail;
                                            }
                                        }
                                    }
                                });
                            });
                        });
                    });
                });
            });
            this.requests = {};
            _.forEach(this.areas, function (area) {
                _.forEach(area.rows, function (row) {
                    if (row.line === null) {
                        return;
                    }
                    _.forEach(row.line.equipment, function (equip) {
                        _this.requests[equip.id] = {
                            request: {
                                shopId: _this.shopId,
                                equipmentId: equip.id,
                            },
                            result: {}
                        };
                        var promise = _this.countsService.getEquipmentCounts(_this.shopId, _this.model, equip, _this.countsInterval)
                            .then(function (counts) { return _this.detailCountsHandler(counts, equip); });
                        promises.push(promise);
                    });
                });
            });
            return this.$q
                .all(promises)
                .then(function () {
                console.log("getDetailsCounts finished.");
            })
                .catch(function (reason) {
                console.log('error:', reason);
            });
        };
        CountsVerticalCtrlV2.prototype.toggleLineActive = function (line) {
            var _this = this;
            if (!this.canDisableLine) {
                return;
            }
            var message = "Line " + line.name + " is currently " + (line.isDisabled ? 'disabled' : 'active') + ". "
                + ("Would you like to " + (line.isDisabled ? 'activate' : 'disable') + " it?");
            var subject = (line.isDisabled ? 'Activate' : 'Disable') + " Line " + line.name + "?";
            this.uiUtilityService.confirm(message, subject, 'Yes', 'No').then(function (confirmed) {
                if (!confirmed) {
                    return;
                }
                var promise = _this.lineConfigsService.toggleLine({
                    id: line.id,
                    shopId: line.shopId,
                    isDisabled: !line.isDisabled
                }).then(function () { return line.isDisabled = !line.isDisabled; });
                _this.loaderService.loadingPromise(promise);
            });
        };
        CountsVerticalCtrlV2.prototype.viewGroupRejectDetail = function (equipmentGroup) {
            this.model.currentGroup = equipmentGroup;
            this.groupRejectsService.showGroupRejects({
                equipmentGroup: equipmentGroup,
                shopId: this.shop.id,
                lineCounts: this.model,
                countsInterval: this.countsInterval
            });
        };
        CountsVerticalCtrlV2.prototype.showHelp = function (helpScreen) {
            console.log(helpScreen);
            this.helpText = getCountsHelpText(helpScreen);
            this.toggleHelpWindow();
        };
        CountsVerticalCtrlV2.prototype.getDetailsChartConfig = function () {
            return {
                chart: {
                    alignTicks: true,
                    zoomType: 'xy',
                    styleMode: true,
                },
                legend: {
                    enabled: false
                },
                credits: {
                    enabled: false
                },
                title: {
                    text: null
                },
                xAxis: {
                    categories: ['', '', '', ''],
                    labels: {
                        enabled: false
                    }
                },
                yAxis: {
                    title: {
                        text: null
                    },
                    labels: {
                        enabled: true
                    },
                    allowDecimals: false
                },
                plotOptions: {
                    series: {
                        marker: {
                            enabled: true
                        },
                        animation: false
                    }
                },
                tooltip: {
                    useHtml: true,
                    pointFormat: '<b>{point.y}</b>',
                },
                series: [{
                        type: 'spline',
                        data: [],
                        color: '#919391',
                        name: ''
                    }]
            };
        };
        CountsVerticalCtrlV2.prototype.getLossPercentClass = function (equipment) {
            if (!equipment) {
                return '';
            }
            var rejectTolerance = this.equipmentRejectTolerances[equipment.name];
            if (!equipment.rejectCount || !rejectTolerance) {
                return '';
            }
            if (this.isRejectPercentWithinTolerance(equipment, rejectTolerance)) {
                var percentageClass = '';
                if (equipment.rejectCount.percent.error) {
                    percentageClass = 'vc-bg-warning ';
                }
                percentageClass += 'text-danger';
                return percentageClass;
            }
            return '';
        };
        CountsVerticalCtrlV2.prototype.getEquipmentClass = function (equip) {
            equip = equip[0];
            if (!equip) {
                return '';
            }
            if (equip.isDisabled) {
                return 'equipment-disabled';
            }
            var rejectTolerance = this.equipmentRejectTolerances[equip.name];
            var equipmentClass = '';
            if (equip.rejectCount && !!rejectTolerance &&
                this.isRejectPercentWithinTolerance(equip, rejectTolerance)) {
                equipmentClass = 'rejectBgVerticals';
                if (this.countsInterval == enums_1.apsDisplayEnums.CountDisplayInterval.CurrentHour
                    || this.countsInterval == enums_1.apsDisplayEnums.CountDisplayInterval.CurrentShift
                    || this.countsInterval == enums_1.apsDisplayEnums.CountDisplayInterval.RollingHour
                    || this.countsInterval == enums_1.apsDisplayEnums.CountDisplayInterval.LastTwentyMinutes) {
                    equipmentClass = this.blinkClass;
                }
            }
            return equipmentClass;
        };
        CountsVerticalCtrlV2.prototype.getRowClass = function (equipment) {
            var rejectTolerance = this.equipmentRejectTolerances[equipment.name];
            if (!equipment.rejectCount || !rejectTolerance) {
                return '';
            }
            if (this.isRejectPercentWithinTolerance(equipment, rejectTolerance)) {
                return 'rejectEquipVerticals';
            }
        };
        CountsVerticalCtrlV2.prototype.isRejectPercentWithinTolerance = function (equipment, tolerance) {
            var rejectPercentage = equipment.rejectCount.percent;
            if (angular.isString(rejectPercentage)) {
                return Number(rejectPercentage) > tolerance.rejectMaxPercentage
                    || Number(rejectPercentage) < tolerance.rejectMinPercentage;
            }
            else {
                return Number(rejectPercentage.value.replace("%", "")) > tolerance.rejectMaxPercentage
                    || Number(rejectPercentage.value.replace("%", "")) < tolerance.rejectMinPercentage;
            }
        };
        CountsVerticalCtrlV2.prototype.countsIntervalChanged = function () {
            this.update();
        };
        CountsVerticalCtrlV2.prototype.viewDetails = function (count, type) {
            this.$scope.count = count;
        };
        CountsVerticalCtrlV2.prototype.dateRange = function () {
            return {
                dataPointId: null,
                countInterval: aps_enums_1.apsEnums.CountInterval.TenMinutes,
                start: function () { return moment().subtract(2, 'hour').toDate(); },
                end: function () { return moment().toDate(); }
            };
        };
        CountsVerticalCtrlV2.prototype.createGetDataPointIdRequestForParent = function (id, startDate, endDate, countInterval, eq) {
            var _this = this;
            var rq = {
                dataPointId: id,
                start: startDate,
                end: endDate,
                countInterval: countInterval,
                type: "parent",
                eq: eq
            };
            var dp = new VertCtDataPointHistoryReportItem();
            dp.request = rq;
            var promise = this.countsService.getByDatapointId(rq.dataPointId, rq.start, rq.end, rq.countInterval.toString())
                .then(function (response) {
                dp.result = response.map(function (x) { return x.value; });
                _this.parents.dataPoints.push(dp);
            });
            return promise;
        };
        CountsVerticalCtrlV2.prototype.createGetDataPointIdRequestForChild = function (plantLocationId, shopId, ids, startDate, endDate, countInterval, eq) {
            var rq = {
                plantLocationId: plantLocationId,
                shopId: shopId,
                datapointIds: ids,
                startDate: startDate,
                endDate: endDate,
                countInterval: countInterval,
                type: "child",
                eq: eq
            };
            var dp = new VertCtDatapointListReportItem();
            dp.request = rq;
            var promise = this.countsService.getByDatapointList(rq.plantLocationId, rq.shopId, rq.datapointIds, rq.startDate, rq.endDate, rq.countInterval.toString())
                .then(function (response) {
                var trendCounts = response.map(function (x) { return x.value; });
                rq.eq.rejectCount.trendCounts = trendCounts;
                dp.result = trendCounts;
            });
            return promise;
        };
        CountsVerticalCtrlV2.prototype.getChildrenTrendCounts = function () {
            var _this = this;
            console.log('child trend counts started...');
            var promises = [];
            var startDate = moment().subtract(2, 'hour').toDate();
            var endDate = moment().toDate();
            var countInterval = aps_enums_1.apsEnums.CountInterval.TenMinutes;
            _.forEach(this.vc, function (ct) {
                _.forEach(ct.children, function (child) {
                    _.forEach(child.equipment, function (eq) {
                        if (angular.isDefined(eq.id)) {
                            var promise = _this.createGetDataPointIdRequestForChild(_this.plant.id, _this.shop.id, [], startDate, endDate, countInterval, eq);
                            promises.push(promise);
                        }
                    });
                });
            });
            return this.$q.all(promises).then(function () {
                _.forEach(_this.children.dataPoints, function (dp) {
                    var i = _this.children.hash[dp.request.dataPointId];
                    if (angular.isDefined(i)) {
                        i.rejectCount.trendCounts = dp.result;
                    }
                });
                console.log("child trend counts completed.", _this.children);
            }).catch(function (response) {
                console.log(response);
            });
        };
        CountsVerticalCtrlV2.prototype.getParentTrendCounts = function () {
            var _this = this;
            console.log('parent trend counts started...');
            var promises = [];
            var startDate = moment().subtract(2, 'hour').toDate();
            var endDate = moment().toDate();
            var countInterval = aps_enums_1.apsEnums.CountInterval.TenMinutes;
            _.forEach(this.vc, function (ct) {
                _.forEach(ct.equipment, function (eq) {
                    if (angular.isDefined(eq.rejectCount) && angular.isDefined(eq.rejectCount.id) && eq.rejectCount.id != "") {
                        var promise = _this.createGetDataPointIdRequestForParent(eq.rejectCount.id, startDate, endDate, countInterval, eq);
                        promises.push(promise);
                    }
                });
            });
            return this.$q.all(promises).then(function () {
                _.forEach(_this.parents.dataPoints, function (dp) {
                    var i = _this.parents.hash[dp.request.dataPointId];
                    if (angular.isDefined(i)) {
                        i.rejectCount.trendCounts = dp.result;
                    }
                });
                console.log("parent trend counts completed.", _this.parents);
            }).catch(function (response) {
                console.log(response);
            });
        };
        return CountsVerticalCtrlV2;
    }());
    exports.CountsVerticalCtrlV2 = CountsVerticalCtrlV2;
    var sortDate = function (a, b) {
        return b.valueOf() - a.valueOf();
    };
    var fmt = function (x) { return moment(x).format("L LT"); };
    var detailChartv2 = function () {
        return {
            restrict: 'E',
            template: '<div></div>',
            scope: {
                options: '='
            },
            link: function (scope, element, attributes) {
                angular.element(document).ready(function () {
                    try {
                        var jsonData = JSON.parse(attributes.data);
                        if (attributes.data !== null && jsonData.length > 1 && attributes.data !== '[0,0,0,0]') {
                            scope.options.series[0].data = jsonData;
                            var chart = new Highcharts.Chart(element[0], scope.options);
                        }
                    }
                    catch (e) {
                        return false;
                    }
                    scope.$watch(function () {
                        return element.attr('data');
                    }, function (newValue) {
                        try {
                            var jsonData = JSON.parse(attributes.data);
                            if (newValue !== null && jsonData.length > 1 && newValue !== '[0,0,0,0]') {
                                scope.options.series[0].data = jsonData;
                                var chart = new Highcharts.Chart(element[0], scope.options);
                            }
                        }
                        catch (e) {
                            return false;
                        }
                    });
                });
            }
        };
    };
    var countsConfig = function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.COUNTS_VERTICAL_V2,
            url: '/countsverticalv2',
            controller: 'CountsVerticalCtrlV2 as vm',
            template: countVerticalv2_tpl_html_1.default,
            data: {
                pageTitle: 'Vertical Counts',
                authorizeAPSIOAdmin: true
            }
        });
    };
    countsConfig.$inject = ["$stateProvider"];
    exports.default = angular.module('aps.controller.countsVerticalv2', requires)
        .config(countsConfig)
        .controller('CountsVerticalCtrlV2', CountsVerticalCtrlV2)
        .directive('detailChartv2', detailChartv2)
        .directive('sparklineChartV2', sparklineChartsV2_1.sparklineChartV2)
        .name;
    function getCountsHelpText(helpScreen) {
        var helptext = '';
        switch (helpScreen) {
            case 'EQUIPMENT COUNTS':
                helptext = "  \n        <div class=\"header\">\n          Equipment Counts\n        </div>         \n        <div class=\"subheader\">\n          <u>How the Counts Work</u>:\n        </div>\n        <div class=\"detail\">\n          Below is a sample count object, this is sample data just for instructional purposes.\n        </div>\n        <div class=\"counts-equipment-details\">\n          <div class=\"row-flex\">\n            <div class=\"bs-col-3\">\n              <div class=\"vc-col cur-ptr\">\n                <span class=\"bs-text-nowrap count\" title=\"809b0000-ff45-0003-8918-08d563f1a496\">SQR</span>\n              </div>\n            </div>\n            <div class=\"bs-col-9 no-margin\">\n              <div class=\"vc-col\"  class=\"borderclass\">\n                <div class=\"cur-ptr eq-box\">\n                <table cellspacing=\"0\" cellpadding=\"0\">\n                  <tbody>\n                    <tr>\n                      <td>\n                        <div class=\"eq-col eq-idx\">\n                          <span>H</span>\n                        </div>\n                      </td>\n                      <td>\n                        <div class=\"eq-col eq-ict\">\n                          <span>6,447</span>\n                        </div>\n                      </td>\n\n                      <td>\n                        <div class=\"eq-col eq-sparkline\">\n                            <span class=\"ng-binding\">258</span>\n                            <i class=\"vc-trend fa  fa-angle-down\" ng-class=\"{'fa-angle-up': equipment.rejectCount.trend.up, 'fa-angle-down': equipment.rejectCount.trend.down}\"></i>\n                        </div>\n                      </td>\n                      <td>\n                        <div class=\"eq-col eq-rpt\">\n                            <b>4.00%</b> &nbsp;\n                        </div>\n                      </td>\n                      </tr>\n                    </tbody>\n                  </table>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class=\"detail\">\n          As you can see the count object is broken up into 4 different columns. Here is the definition of each columns:\n        </div>  \n        <div class=\"detail\">\n          <ol type = \"1\">\n            <li class=\"detail\">\n              <b>Equipment Shorthand:</b> This is a shorthand abreviation of the type of equipment configured on the line.\n              In this case this is a high speed squeezer. This is abreviated as SQR.\n            </li>\n            <li class=\"detail\">\n              <b>Inspect Count:</b> The number of bottles going into the machine.\n              In APS the preference is to use a direct integration to the machine for this counter.\n              However, there are instances that we are dependent on a photoeye before the inspection equipment \n              to provide the inspect count.\n            </li>\n            <li class=\"detail\">\n              <b>Reject Count:</b>\n              The amount of bottles rejected by the piece of inspection equipment.\n              However, for some equipment integrations we need to calculated it by taking the difference between\n              bottles in and bottles out.\n              <br/>\n              <span class=\"formula\">Reject Count = Reject Count from Machine</span><br/>\n              <span class=\"footnote\">[where machine has direct integration]</span><br/>\n              <span class=\"formula\">Reject Count = Machine Bottles In - Machine Bottles Out</span><br/>\n              <span class=\"footnote\">[where machine only has input/output]</span><br/>\n            </li>\n            <li class=\"detail\">\n              <b>Reject Percent:</b>\n              The percent of loss for each piece of equipment.\n              This calculation is based off the equipment inspects vs. the rejects.\n              <br/>\n              <span class=\"formula\">Reject Percent = Reject Count / Inspect Count</span><br/>\n\n              On each job run, an acceptable percentage range can be set for each equipment type. If the equipment has a tolerance set\n              and the current value is outside those parameters, this value is highlighted in \n              <span class=\"red\">red</span> to help users quickly identify issues.\n            </li>\n          </ol>\n        </div>\n        <div class=\"subheader\">\n          <u>Equipment Details</u>:\n        </div>   \n        <div class=\"detail\">\n          On some equipment, there is detail data listed under the summary row.\n          Depending on the type of integration some equipment will display more data than others.\n        </div>\n          ";
                break;
            case 'EQUIPMENT GROUP':
                helptext = "  \n        <div class=\"header\">\n          EQUIPMENT COUNTS by CATEGORY (% of SHEARS)\n        </div>         \n        <div class=\"subheader\">\n          <u>Metrics per Category</u>:\n        </div>\n        <div class=\"detail\">\n          This metric measures the total losses by equipment type against shear cuts.\n          The metric definitions are as follows.\n        </div>\n        <div class=\"detail\">\n          <ol type = \"1\">\n            <li class=\"detail\">\n            <b>INSPECTS:</b> The total number of bottles going into each equipment category.\n            </li>\n            <li class=\"detail\">\n              <b>REJECTS:</b> \n              The total amount of bottles rejected in each equipment category.\n            </li>\n            <li class=\"detail\">\n              <b>REJECT %:</b>\n              The percent loss for each equipment category.\n              On each job run, an acceptable percentage range can be set for each equipment type. If the equipment has a tolerance set\n              and the current value is outside those parameters, this value is highlighted in \n              <span class=\"red\">red</span> to help users quickly identify issues.\n              <br/>\n              <span class=\"formula\">REJECT % = 100 * (Rejects by Category/ Shears)</span>\n            </li>\n          </ol>\n        </div>\n          ";
                break;
            case 'SHOP KPI':
                helptext = "  \n        <div class=\"header\">\n          Shop KPI's\n        </div>         \n        <div class=\"subheader\">\n          <u>KPI Metric Definitions</u>:\n        </div>\n        <div class=\"detail\">\n          The goal of these KPI's is to see how the shop is performing at each point along the line.\n          We use each pulse from the shear cuts to calculate how many gobs are currently being produced.\n        </div>\n        <div class=\"detail\">\n          <ol type = \"1\">\n            <li class=\"detail\">\n              <b>MACHINE SPEED:</b>\n              How many bottles per minute the machine is producing.\n              When available we use direct machine integration.\n              Otherwise, we use the shear pulses to estimate the speed.\n            </li>\n            <li class=\"detail\">\n              <b>H/E Efficiency:</b> \n              The percent of bottles going into the lehr, against the shears.\n              <br/>\n              <span class=\"formula\">H/E Efficiency = Lehr In Counter / Shears</span>\n            </li>\n            <li class=\"detail\">\n              <b>C/E Efficiency:</b>\n              The percent of bottles that make it to the End of Line (EOL), compared to the lehr. \n              This is usually a photoeye, sometimes it can be the last piece of inspection equipment. It depends on the shop configuration.\n              <br/>\n              <span class=\"formula\">C/E Efficiency = EOL / Lehr In Counter</span>\n            </li>\n            <li class=\"detail\">\n              <b>Pack Efficiency:</b>\n              The percent of bottles that make it to the End of Line (EOL), against the shears. \n              This is usually a photoeye, sometimes it can be the last piece of inspection equipment. It depends on the shop configuration.\n              <br/>\n              <span class=\"formula\">Pack Efficiency = EOL / Shears</span>\n            </li>\n          </ol>\n        </div>\n          ";
                break;
            default:
                helptext = 'Selected Help Screen Not Found...';
                break;
        }
        return helptext;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(34)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, Highcharts) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function sparklineChartV2() {
        return {
            restrict: 'E',
            template: '<div></div>',
            scope: {
                options: '='
            },
            link: function (scope, element, attributes) {
                var options = {
                    title: {
                        text: ''
                    },
                    credits: false,
                    chart: {
                        width: 58,
                        height: 16,
                        borderWidth: 0,
                        margin: [1, 1, 1, 0],
                        type: 'area',
                        style: {
                            overflow: 'visible'
                        },
                        skipClone: true,
                        zIndex: 100,
                        backgroundColor: 'transparent',
                    },
                    yAxis: {
                        endOnTick: false,
                        startOnTick: false,
                        labels: {
                            enabled: false
                        },
                        title: {
                            text: null
                        },
                        tickPositions: [0],
                        showEmpty: false,
                    },
                    xAxis: {
                        labels: {
                            enabled: false
                        },
                        title: {
                            text: null
                        },
                        startOnTick: false,
                        endOnTick: false,
                        tickPositions: [],
                        showEmpty: false,
                    },
                    legend: {
                        enabled: false
                    },
                    tooltip: {
                        pointFormat: '{point.y}',
                        headerFormat: '',
                        hideDelay: 0,
                        outside: true,
                        shared: true
                    },
                    plotOptions: {
                        series: {
                            animation: false,
                            lineWidth: 1,
                            shadow: false,
                            states: {
                                hover: {
                                    lineWidth: 1
                                }
                            },
                            marker: {
                                radius: 1,
                                states: {
                                    hover: {
                                        radius: 2
                                    }
                                }
                            },
                            fillOpacity: 0.25
                        },
                        column: {
                            negativeColor: '#910000',
                            borderColor: 'silver'
                        }
                    },
                    series: [],
                    lang: {
                        noData: "No Data"
                    }
                };
                angular.element(document).ready(function () {
                    try {
                        var jsonData = JSON.parse(attributes.data);
                        if (jsonData.length === 0) {
                            jsonData = [0, 0, 0, 0];
                        }
                        options.series = [{ data: jsonData }];
                        var chart = new Highcharts.Chart(element[0], options);
                    }
                    catch (e) {
                        return false;
                    }
                    scope.$watch(function () {
                        return element.attr('data');
                    }, function (newValue) {
                        try {
                            if (newValue !== null) {
                                var jsonData = JSON.parse(attributes.data);
                                if (jsonData.length === 0) {
                                    jsonData = [0, 0, 0, 0];
                                }
                                options.series = [{ data: jsonData }];
                                var chart = new Highcharts.Chart(element[0], options);
                            }
                        }
                        catch (e) {
                            return false;
                        }
                    });
                });
            }
        };
    }
    exports.sparklineChartV2 = sparklineChartV2;
    ;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<style>.cur-ptr{cursor:pointer}.noColor{background-color:transparent}.noPadding{padding:0}.no-bg{background-color:transparent}.aps-info{background-color:#1690cb;color:#fff}.vc-count-name{white-space:nowrap}.vc-bordered{border:solid 1px silver}.vc-td-nm{text-align:left;height:100%;vertical-align:middle}.eq-box{border:solid 1px silver;display:inline-block;z-index:4;height:19px;padding:0;margin-bottom:0;margin-right:2px;margin-left:0;margin-top:2px}.eq-tb{background-color:transparent}.eq-tb>tbody>tr>td,.eq-tb>thead>tr>th{border:none;text-align:center;vertical-align:middle}.equipment-disabled{background-color:#cb727e!important;color:#fff}.line-disabled{background-color:#cb727e!important}.eq-td-idx{text-align:center}.eq-col{height:17px;z-index:5;padding-top:1px;font-weight:700}.eq-idx{width:13px;text-align:center;background-color:#1690cb!important;color:#fff}.eq-ict{width:60px;text-align:right}.eq-rct{width:50px;text-align:right}.eq-rpt{width:50px;text-align:center;padding-bottom:1px}.eq-sparkline{width:60px;background-color:transparent;z-index:1002;text-align:center;height:18px}.eq-td-nm{width:195px;white-space:nowrap;text-overflow:ellipsis}.vc-header{height:24px}.vc-text-white{color:#fff}.vc-bg-warning{background-color:#ff0!important}.vc-bg-err{background-color:red!important}.ag-eq-rows>div[data-type=row]:nth-of-type(odd){background-color:#dedddd}.ag-eq-rows>div[data-type=row]:nth-of-type(even){background-color:#f2f2f2}.ag-eq-rows>div[data-type=header]{background-color:#1690cb!important;color:#fff;font-weight:700}.eq-box>table>tbody>tr>td,.vc-col{font-size:13.6px;font-weight:400;font-style:normal;font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif;letter-spacing:.8px}.vc-trend{margin-left:-4px;width:9px;height:14px}.vc-col-th{margin-top:3px;text-align:center}.bs-btn-unselected{color:#000;background-color:#e7e7e7;border-color:#b9b9b9}.bs-btn-unselected:hover{background-color:#dedddd}.bs-btn-selected{color:#fff;background-color:#008cba;border-color:#007095}.bs-btn-selected:hover{color:#fff;background-color:#007095;border-color:#007095}.bs-btn{margin-bottom:2px}.bs-row{margin-left:0;margin-right:0}.bs-card-equipmentbox{margin:4px;cursor:pointer}.bs-card-equipmentbox>.bs-card-body{padding:8px}.bs-card-kpi{margin:4px;cursor:pointer}.bs-card-kpi>.bs-card-body{padding:10px}.ag-toolbar{margin:0;padding:0;vertical-align:middle;display:inline-flex}button,select{margin:0}.ag-plant-info{display:inline-block;padding:6px 6px 6px 0;margin:0}.ag-interval-info{padding:5px 5px 0 5px;margin:0;display:inline-block}.ag-interval-info>span{font-size:14px;font-weight:400}.ag-buttonarray-info{padding:3px 3px 0 3px;margin:0;display:inline-block}.ag-plant-label{color:#1178a8;font-size:1em;font-weight:500;display:block}.ag-shop-label{font-weight:400;font-size:.75em;color:#000;display:block}.ag-header{padding:0;margin-top:6px}</style> <!-- header --> <div class=\"row-flex ag-header\"> <div class=bs-col-12> <div class=ag-toolbar> <div class=ag-plant-info> <span class=ag-plant-label>{{vm.plant.name || \"...\"}}</span> <span class=ag-shop-label>Shop {{vm.shop.name}}</span> </div> <div class=ag-interval-info> <span>Viewing Count Data For:</span> <select style=width:120px id=countsInterval ng-model=vm.countsInterval ng-options=\"t.value as t.text for t in vm.countDisplayIntervalOptions\" ng-change=vm.countsIntervalChanged() class=form-control></select> </div> <div class=ag-buttonarray-info> <btn-array options=vm.navigationUrls /> </div> </div> </div> </div> <!-- use bootstrap columns instead of tables --> <div class=row-flex> <h6 class=bs-col-12> <b>EQUIPMENT COUNTS (% INSPECT VS. REJECT)</b>&nbsp;<a ng-click=\"vm.showHelp('EQUIPMENT COUNTS')\"><i class=\"fa fa-info-circle fa-bigger\"></i></a> <div class=btn-switch-container> <div class=mb-2><h6><b>Denominator Toggle</b></h6></div> <div style=display:flex;align-items:center;justify-content:center> <span>Equipment</span> <div class=btn-switch ng-class=\"{'btn-switch--on':vm.model.usePercentGobs}\" ng-model=vm.model.usePercentGobs ng-click=vm.usePercentGobsChanged();> <div class=btn-switch-circle ng-class=\"{'btn-switch-circle--on':vm.model.usePercentGobs}\" ng-model=vm.model.usePercentGobs> </div> </div> <span>Shears</span> </div> </div> </h6> <div class=bs-col-12> <div class=ag-eq-rows> <div class=\"row-flex vc-header\" data-type=header> <div class=bs-col-3> <div class=vc-col-th> <span>Device</span> </div> </div> <div class=bs-col-9> <div class=vc-col-th> <span>Split Line Counters</span> </div> </div> </div> <!-- data --> <div class=row-flex data-type=row ng-repeat-start=\"count in vm.vc\"> <div class=\"bs-col-3 no-margin\"> <div class=\"vc-col cur-ptr\" style=margin-top:4px ng-click=\"vm.viewDetails(count,'parent')\"> <span class=\"bs-text-nowrap count\" title=\"{{count.id}}\" ng-class=vm.getEquipmentClass(count.equipment)>{{count.name}}</span> </div> </div> <div class=\"bs-col-9 no-margin\"> <div class=vc-col> <equipment-box equipment=equipment options=vm.detailChartConfig losspercentclass=\"{{vm.getLossPercentClass(equipment)}} \" borderclass=\"{{vm.getRowClass(equipment)}} \" class=cur-ptr title=\"rejectCountId: {{equipment.rejectCount.id}}\" ng-repeat=\"equipment in count.equipment | orderBy: 'line.name'\" ng-click=vm.viewRejectDetail(count)> {{vm.getEquipmentClass(equipment)}}</equipment-box> </div> </div> </div> <!-- children --> <div class=row-flex data-type=row ng-repeat=\"ct in count.children | orderBy:'name'\"> <div class=bs-col-3> <div class=\"vc-col cur-ptr\" style=margin-left:20px;margin-top:4px ng-click=\"vm.viewDetails(ct,'child')\"> <span class=\"\" title=\"{{ct.id}}\"> <b>{{ct.name}}</b> </span> </div> </div> <div class=bs-col-9> <div class=vc-col> <equipment-box equipment=eq options=vm.detailChartConfig class=cur-ptr title=\"{{eq.id}}\" ng-repeat=\"eq in ct.equipment | orderBy: 'line.name'\" ng-click=vm.viewRejectDetail(ct)> </equipment-box> </div> </div> </div> <div ng-repeat-end data-type=row ng-if=false></div> </div> </div> </div> <br/> <!-- equipment groups --> <div class=row-flex> <div class=bs-col-12> <h6> <b>EQUIPMENT COUNTS by CATEGORY (% OF SHEARS)</b>&nbsp;<a ng-click=\"vm.showHelp('EQUIPMENT GROUP')\"><i class=\"fa fa-info-circle fa-bigger\"></i></a> </h6> <div ng-repeat=\"group in vm.model.equipmentGroups\" style=display:inline-block ng-click=vm.viewGroupRejectDetail(group)> <div class=\"bs-card bs-card-equipmentbox\" ng-class=vm.getRowClass(group)> <div class=bs-card-body> <div class=bs-card-title> <b>{{group.name}}</b> </div> <div class=bs-card-text> <div class=bs-text-right> <b>{{group.inspectCount.count | number}}</b> </div> </div> <div class=bs-card-text> <div class=bs-text-right style=margin-top:.3125em> <b>{{(group.rejectCount.count | number) || \"-\"}}</b> </div> </div> <div class=bs-card-text> <div class=bs-text-right ng-class=vm.getLossPercentClass(group)> <b>{{(group.rejectCount.percent || \"0\") + \"%\"}}</b> <vert-trend trend=group.rejectCount.trend style=margin-top:.1em /> </div> </div> </div> </div> </div> </div> <br/> <!-- kpi --> <div class=bs-row> <div class=bs-col-12> <h6> <b>SHOP KPI (% INSPECT VS. REJECT)</b>&nbsp;<a ng-click=\"vm.showHelp('SHOP KPI')\"><i class=\"fa fa-info-circle fa-bigger\"></i></a> </h6> <div ng-repeat=\"kpi in vm.model.kpis\" style=display:inline-block> <div class=\"bs-card bs-card-kpi\"> <div class=bs-card-body> <div class=bs-card-text> <label style=display:inline>{{kpi.efficiencyName}}:</label> <span>{{kpi.efficiency}}</span> </div> <div class=bs-card-text> <span> <label style=display:inline>{{kpi.lossesName}}:</label> <span>{{kpi.losses | number}}</span> </span> </div> <div class=bs-card-text> <span ng-if=\"$index === 0\"> <label style=display:inline>Speed:</label> <span>{{kpi.denominator.speed}}</span> </span> </div> </div> </div> </div> </div> </div> <div ng-if=vm.showHelpWindow class=charthelpdetails> <div class=windowclose> <a><i class=\"fa fa-times-circle fa-bigger\" ng-click=vm.toggleHelpWindow()></i></a> </div> <div class=tooltiptext ng-bind-html=vm.helpText> </div> </div></div>");

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(623), __webpack_require__(107), __webpack_require__(55), __webpack_require__(4), __webpack_require__(12), __webpack_require__(6), __webpack_require__(7), __webpack_require__(8), __webpack_require__(624), __webpack_require__(625), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, plantFeatureSettings_tpl_html_1, navigation_1, plant_service_1, loader_service_1, newguid_service_1, notify_service_1, authData_service_1, navigation_service_1, plantFeatureSettings_service_1, plantFeatureSettings_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [navigation_1.default, plant_service_1.default, loader_service_1.default,
        newguid_service_1.default, notify_service_1.default, authData_service_1.default, navigation_service_1.default, plantFeatureSettings_service_1.default];
    var plantFeatureSettingsConfig = function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.PLANT_FEATURE_SETTINGS,
            url: '/admin/plantFeatureSettings',
            controller: 'PlantFeatureSettingsController as vm',
            template: plantFeatureSettings_tpl_html_1.default,
            data: {
                pageTitle: 'Plant Feature Settings',
                authorizeAdmin: true
            }
        });
    };
    plantFeatureSettingsConfig.$inject = ["$stateProvider"];
    var jsonData = {
        "id": "3999f366-42bf-41a7-a054-8815dc5e4537",
        "plantId": "bbdf0000-3a00-000f-724d-08d2e5fa8e34",
        "config": {
            "moldLoss": {
                "shops": [
                    "bbdf0000-3a00-000f-72d2-08d2e5fa8e34",
                    "bbdf0000-3a00-000f-60f2-08d2e5fa8e3a"
                ],
                "roles": [
                    "bbdf0000-3a00-000d-76be-08d2e5f92bdb",
                    "7a000000-9a3c-0005-4910-08d5f172afc7"
                ]
            },
            "defectMappingEquipmentList": [
                8,
                10,
                11,
                12,
                13,
                14
            ],
            "calculations": [
                {
                    "order": 0,
                    "name": "HE",
                    "displayName": "HE",
                    "numerator": 3,
                    "denominator": 3
                },
                {
                    "order": 1,
                    "name": "LEHR",
                    "displayName": "LEHR",
                    "numerator": 3,
                    "denominator": 3
                },
                {
                    "order": 3,
                    "name": "AIE",
                    "displayName": "AIE",
                    "numerator": 3,
                    "denominator": 3
                },
                {
                    "order": 4,
                    "name": "CE LOSS",
                    "displayName": "CE LOSS",
                    "numerator": 3,
                    "denominator": 3
                },
                {
                    "order": 5,
                    "name": "PACK",
                    "displayName": "PACK",
                    "numerator": 3,
                    "denominator": 3
                },
            ]
        }
    };
    var PlantFeatureSettingsController = (function () {
        PlantFeatureSettingsController.$inject = ["$state", "authDataService", "navigationService", "plantFeatureSettingsService"];
        function PlantFeatureSettingsController($state, authDataService, navigationService, plantFeatureSettingsService) {
            var _this = this;
            this.isNew = true;
            this.error = null;
            this.data = jsonData;
            this.$state = $state;
            this.userId = authDataService.getUserId();
            this.calculationInput = new plantFeatureSettings_1.Calculation();
            this.plantFeatureSettingsService = plantFeatureSettingsService;
            navigationService.getNavigation().then(function (nav) {
                _this.plants = nav.plants();
                _this.selectedPlant = nav.selectedPlant;
                _this.data.plantId = nav.selectedPlant.id;
                _this.getPromise();
            });
        }
        PlantFeatureSettingsController.prototype.selectPlant = function (plant) {
            if (this.navigation.selectPlant(plant)) {
                this.switchPlantShop();
            }
        };
        PlantFeatureSettingsController.prototype.switchPlantShop = function (plantChanged) {
            this.$state.go(this.$state.current.name, {
                plantId: this.navigation.selectedPlant.id,
                shopId: this.navigation.selectedShop.id,
                userId: this.userId
            });
        };
        PlantFeatureSettingsController.prototype.plantChanged = function ($event) {
            this.error = null;
            this.getPromise().then(function () {
            });
            return false;
        };
        PlantFeatureSettingsController.prototype.deleteShopId = function ($event, shopId) {
            this.data.config.moldLoss.shops = this.data.config.moldLoss.shops.filter(function (value) { return value !== shopId; });
            return false;
        };
        PlantFeatureSettingsController.prototype.addShopId = function ($event) {
            if (this.shopIdInput != null && this.data.config.moldLoss.shops.indexOf(this.shopIdInput) === -1) {
                this.data.config.moldLoss.shops.push(this.shopIdInput);
                this.shopIdInput = null;
            }
        };
        PlantFeatureSettingsController.prototype.deleteRoleId = function ($event, roleId) {
            this.data.config.moldLoss.roles = this.data.config.moldLoss.roles.filter(function (value) { return value !== roleId; });
            return false;
        };
        PlantFeatureSettingsController.prototype.addRoleId = function ($event) {
            if (this.roleIdInput != null && this.data.config.moldLoss.roles.indexOf(this.roleIdInput) === -1) {
                this.data.config.moldLoss.roles.push(this.roleIdInput);
                this.roleIdInput = null;
            }
        };
        PlantFeatureSettingsController.prototype.deleteDefectMappingEquipment = function ($event, defectMappingEquipment) {
            this.data.config.defectMappingEquipmentList =
                this.data.config.defectMappingEquipmentList.filter(function (value) { return value !== defectMappingEquipment; });
        };
        PlantFeatureSettingsController.prototype.addDefectMappingEquipment = function () {
            if (this.defectMappingEquipmentListInput != null &&
                this.data.config.defectMappingEquipmentList.indexOf(this.defectMappingEquipmentListInput) === -1) {
                var defectMappingEquipment = Number(this.defectMappingEquipmentListInput);
                this.data.config.defectMappingEquipmentList.push(defectMappingEquipment);
                this.defectMappingEquipmentListInput = null;
            }
            return false;
        };
        PlantFeatureSettingsController.prototype.deleteCalculation = function ($event, calculation) {
            this.data.config.calculations =
                this.data.config.calculations.filter(function (value) { return value !== calculation && value.name !== calculation.name; });
        };
        PlantFeatureSettingsController.prototype.addCalculation = function () {
            var calculation = new plantFeatureSettings_1.Calculation();
            calculation.order = Number(this.calculationInput.order);
            calculation.name = this.calculationInput.name;
            calculation.displayName = this.calculationInput.displayName;
            calculation.numerator = Number(this.calculationInput.numerator);
            calculation.denominator = Number(this.calculationInput.denominator);
            this.data.config.calculations.push(calculation);
            this.calculationInput = new plantFeatureSettings_1.Calculation();
        };
        PlantFeatureSettingsController.prototype.moveItem = function (data, from, to) {
            var f = data.splice(from, 1)[0];
            data.splice(to, 0, f);
        };
        PlantFeatureSettingsController.prototype.getPayload = function () {
            var payload = {
                id: this.data.plantId,
                plantId: this.data.plantId,
                config: JSON.stringify(this.data.config)
            };
            return payload;
        };
        PlantFeatureSettingsController.prototype.parse = function (payload) {
            var result = new plantFeatureSettings_1.PlantFeatureSetting();
            this.isNew = !payload;
            if (payload === null || !payload) {
                result.id = this.data.plantId;
                result.plantId = this.data.plantId;
                result.config = new plantFeatureSettings_1.Config();
            }
            else {
                result.id = payload.id;
                result.plantId = payload.plantId;
                result.config = JSON.parse(payload.config);
                if (result.config.moldLoss === undefined) {
                    result.config.moldLoss = new plantFeatureSettings_1.MoldLoss();
                }
            }
            return result;
        };
        PlantFeatureSettingsController.prototype.getPromise = function () {
            var _this = this;
            console.log("getPromise - started...");
            return this.plantFeatureSettingsService.get(this.data.plantId)
                .then(function (data) {
                console.log("getPromise - completed.");
                _this.data = _this.parse(data);
            })
                .catch(function (err) { return _this.handleError(err); });
        };
        PlantFeatureSettingsController.prototype.savePromise = function () {
            var _this = this;
            var payload = this.getPayload();
            var promise = (this.isNew
                ? this.plantFeatureSettingsService.post(payload).then(function () { return console.log("post"); })
                : this.plantFeatureSettingsService.put(payload).then(function () { return console.log("put"); })).then(function () { return _this.getPromise(); })
                .catch(function (err) { return _this.handleError(err); });
            return promise;
        };
        PlantFeatureSettingsController.prototype.handleError = function (err) {
            this.error = err;
            alert(err);
        };
        PlantFeatureSettingsController.prototype.submit = function () {
            this.error = null;
            this.savePromise();
        };
        return PlantFeatureSettingsController;
    }());
    exports.PlantFeatureSettingsController = PlantFeatureSettingsController;
    exports.default = angular.module('aps.controller.plantFeatureSettings', requires)
        .config(plantFeatureSettingsConfig)
        .controller('PlantFeatureSettingsController', PlantFeatureSettingsController)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=bs-container-fluid> <div class=body-header><h2>Plants Feature Settings</h2></div> <style>.box{border:solid 1px silver;padding:6px 8px 4px 8px;margin:2px;border-radius:5px}.pointer{cursor:pointer}.trash{text-align:center;vertical-align:text-top;cursor:pointer}label{font-weight:700}</style> <form> <div class=form-check> <input type=checkbox class=form-check-input id=isNew ng-model=vm.isNew ng-disabled=true> <label class=form-check-label for=isNew>New?</label> </div> <div class=bs-form-group> <label for=plant>Plant</label> <select id=plant class=bs-form-control ng-model=vm.data.plantId ng-change=vm.plantChanged($event)> <!--<option value=\"\">---Please select---</option>--> <option ng-repeat=\"plant in vm.plants\" value=\"{{plant.id}}\">{{plant.name}}</option> </select> <!--<input type=\"text\" name=\"plant\" id=\"plant\" aria-describedby=\"plant\" placeholder=\"Plant\" class=\"bs-form-control\" ng-model=\"vm.data.plantId\" />--> </div> <div ng-show=\"vm.error != null\" class=\"bs-alert bs-alert-danger\"> <pre>\r\n\t\t\t\t{{vm.error | json}}\r\n\t\t\t</pre> </div> <!-- config --> <label>Config</label> <div> <div class=bs-card> <div class=bs-card-body> <div class=box> <label>Mold Loss</label> <div class=bs-row> <div class=bs-col-md-6> <div class=box> <div> <label>Shop</label> <div class=bs-form-group> <div class=\"bs-input-group bs-input-group-sm\"> <input type=text name=shopIdInput id=shopIdInput aria-describedby=shopIdInput placeholder=\"Shop Id\" class=bs-form-control ng-model=vm.shopIdInput /> <div class=bs-input-group-append> <button class=\"bs-btn bs-btn-sm bs-btn-primary\" type=button ng-click=vm.addShopId($event)> Add </button> </div> </div> </div> </div> <div> <label>Shops <span>({{vm.data.config.moldLoss.shops.length}})</span></label> <div class=box ng-repeat=\"shop in vm.data.config.moldLoss.shops\"> <span>{{shop}}</span> <span class=\"bs-text-danger bs-small\" style=cursor:pointer ng-click=\"vm.deleteShopId(event, shop);\"> <i class=\"fa fa-trash\"></i> </span> </div> </div> </div> </div> <div class=bs-col-md-6> <div class=box> <div> <label>Role</label> <div class=bs-form-group> <div class=\"bs-input-group bs-input-group-sm\"> <input type=text name=roleIdInput id=roleIdInput aria-describedby=roleIdInput placeholder=\"Role Id\" class=bs-form-control ng-model=vm.roleIdInput /> <div class=bs-input-group-append> <button class=\"bs-btn bs-btn-sm bs-btn-primary\" type=button ng-click=vm.addRoleId($event)> Add </button> </div> </div> </div> </div> <div> <label>Roles <span>({{vm.data.config.moldLoss.roles.length}})</span></label> <div class=box ng-repeat=\"role in vm.data.config.moldLoss.roles\"> <span>{{role}}</span> <span class=\"bs-text-danger bs-small\" style=cursor:pointer ng-click=\"vm.deleteRoleId(event, role);\"> <i class=\"fa fa-trash\"></i> </span> </div> </div> </div> </div> </div> </div> <div class=bs-row> <div class=bs-col-md-6> <!-- defectMappingEquipmentList --> <div class=box> <div class=bs-form-group style=\"\"> <label for=defectMappingEquipmentList>Defect Mapping Equipment</label> <div class=\"bs-input-group bs-input-group-sm\" style=\"\"> <input type=text name=defectMappingEquipmentList id=defectMappingEquipmentList aria-describedby=defectMappingEquipmentList placeholder=\"Defect Mapping Equipment Id\" class=bs-form-control ng-model=vm.defectMappingEquipmentListInput /> <div class=bs-input-group-append> <button class=\"bs-btn bs-btn-sm bs-btn-primary\" type=button ng-click=vm.addDefectMappingEquipment($event)> Add </button> </div> </div> </div> <div class=bs-form-group> <label for=defectMappingEquipmentList>Defect Mapping Equipment List <span>({{vm.data.config.defectMappingEquipmentList.length}})</span></label> <div style=white-space:normal> <div class=box ng-repeat=\"val in vm.data.config.defectMappingEquipmentList\" style=white-space:normal;display:inline-block> <span style=white-space:nowrap> {{val}} <span class=\"bs-text-danger bs-small trash\" ng-click=\"vm.deleteDefectMappingEquipment($event, val)\"> <i class=\"fa fa-trash\"></i> </span> </span> </div> </div> </div> </div> </div> </div> <div class=bs-row> <div class=bs-col-md-12> <div class=box> <div> <label>Calculation</label> <div class=bs-form-group> <label>Order</label> <input type=text id=calculationOrder name=calculationOrder aria-describedby=calculationOrder placeholder=Order class=bs-form-control ng-model=vm.calculationInput.order /> </div> <div class=bs-form-group> <label>Name</label> <input type=text id=calculationName name=calculationName aria-describedby=calculationName placeholder=Name class=bs-form-control ng-model=vm.calculationInput.name /> </div> <div class=bs-form-group> <label>Display Name</label> <input type=text id=calculationDisplayName name=calculationDisplayName aria-describedby=calculationDisplayName placeholder=\"Display Name\" class=bs-form-control ng-model=vm.calculationInput.displayName /> </div> <div class=bs-form-group> <label>Numerator</label> <input type=text name=calculationNumerator id=calculationNumerator aria-describedby=calculationNumerator placeholder=Numerator class=bs-form-control ng-model=vm.calculationInput.numerator /> </div> <div class=bs-form-group> <label>Denominator</label> <input type=text name=calculationDenominator id=calculationDenominator aria-describedby=calculationDenominator placeholder=Denominator class=bs-form-control ng-model=vm.calculationInput.denominator /> </div> <button class=\"bs-btn bs-btn-sm bs-btn-primary\" type=button ng-click=vm.addCalculation($event)> Add </button> </div> <div> <label>Calculations</label> <table class=\"bs-table bs-table-striped bs-table-sm\"> <thead> <tr> <th>order</th> <th>name</th> <th>displayName</th> <th>numerator</th> <th>denominator</th> <th>action</th> </tr> </thead> <tbody> <tr ng-repeat=\"calculation in vm.data.config.calculations\"> <th scope=row>{{calculation.order}}</th> <td>{{calculation.name}}</td> <td>{{calculation.displayName}}</td> <td>{{calculation.numerator}}</td> <td>{{calculation.denominator}}</td> <td> <span class=\"bs-text-danger bs-small\" style=cursor:pointer ng-click=\"vm.deleteCalculation(event, calculation);\"> <i class=\"fa fa-trash\"></i> </span> </td> </tr> </tbody> </table> </div> </div> </div> </div> </div> </div> </div> <button id=submit name=submit class=\"bs-btn bs-btn-sm bs-btn-primary\" ng-click=vm.submit()> Submit </button> </form> <div class=well> <pre>\r\n\t\t\t{{vm.data | json}}\r\n\t\t</pre> </div> </div> ");

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(3), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, constant_module_1, http_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [http_service_1.default];
    var PlantFeatureSettingsService = (function () {
        PlantFeatureSettingsService.$inject = ["httpService"];
        function PlantFeatureSettingsService(httpService) {
            this.httpService = httpService;
        }
        PlantFeatureSettingsService.prototype.get = function (plantId) {
            var url = constant_module_1.Endpoints.PLANT_FEATURE_SETTINGS + '/' + plantId;
            return this.httpService.get(url);
        };
        PlantFeatureSettingsService.prototype.post = function (setting) {
            var url = constant_module_1.Endpoints.PLANT_FEATURE_SETTINGS;
            return this.httpService.post(url, setting);
        };
        PlantFeatureSettingsService.prototype.put = function (setting) {
            var url = constant_module_1.Endpoints.PLANT_FEATURE_SETTINGS;
            return this.httpService.put(url, setting);
        };
        return PlantFeatureSettingsService;
    }());
    exports.PlantFeatureSettingsService = PlantFeatureSettingsService;
    exports.default = angular
        .module('aps.services.plantFeatureSettings', requires)
        .service('plantFeatureSettingsService', PlantFeatureSettingsService)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Calculation = (function () {
        function Calculation() {
        }
        return Calculation;
    }());
    exports.Calculation = Calculation;
    var MoldLoss = (function () {
        function MoldLoss() {
            this.shops = [];
            this.roles = [];
        }
        return MoldLoss;
    }());
    exports.MoldLoss = MoldLoss;
    var Config = (function () {
        function Config() {
            this.moldLoss = new MoldLoss();
            this.defectMappingEquipmentList = [];
            this.calculations = [];
        }
        return Config;
    }());
    exports.Config = Config;
    var PlantFeatureSetting = (function () {
        function PlantFeatureSetting() {
        }
        return PlantFeatureSetting;
    }());
    exports.PlantFeatureSetting = PlantFeatureSetting;
    var PlantFeatureSettingPayload = (function () {
        function PlantFeatureSettingPayload() {
        }
        return PlantFeatureSettingPayload;
    }());
    exports.PlantFeatureSettingPayload = PlantFeatureSettingPayload;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(64)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var CountDetailComponent = (function (_super) {
        __extends(CountDetailComponent, _super);
        function CountDetailComponent() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        CountDetailComponent.prototype.componentDidMount = function () {
            var _this = this;
            this.setState(this.props);
            this.props.counts.onUpdated.push(function () { return _this.setState(_this.props); });
        };
        CountDetailComponent.prototype.render = function () {
            if (!this.state) {
                return React.createElement('div', { key: 'main', className: 'er-data' });
            }
            var tab = this.state;
            var rows = [];
            rows.push(this.createHeader(tab));
            rows.push(this.createBody(tab));
            return React.createElement('div', { key: 'main', className: 'er-data' }, React.createElement('table', { key: 'table', className: 'er-table' }, rows));
        };
        CountDetailComponent.prototype.createHeader = function (tab) {
            var columns = [];
            var className = !tab.showHeader ? 'er-spacer' : undefined;
            var width = '5em';
            if (!tab.hideRowColumn) {
                if (tab.rowColumnWidthEm) {
                    width = tab.rowColumnWidthEm + "em";
                }
                columns.push(React.createElement('th', {
                    key: 'rowColumn',
                    className: className,
                    style: { width: width }
                }, tab.showHeader ? tab.rowHeader || ' ' : ' '));
            }
            tab.columns.forEach(function (column, i) {
                className = undefined;
                if (!tab.showHeader) {
                    className = 'er-spacer';
                }
                else if (tab.outputRows[0].cells[i].rightJustify) {
                    className = 'rightJustify';
                }
                width = '5em';
                if (column.widthEm) {
                    width = column.widthEm + "em";
                }
                columns.push(React.createElement('th', {
                    key: 'column' + i,
                    className: className,
                    style: { width: width }
                }, tab.showHeader ? column.name : ' '));
                className = 'rightJustify';
                if (column.showPercent) {
                    columns.push(React.createElement('th', {
                        key: 'columnP' + i,
                        className: className,
                        style: { width: '5em' }
                    }));
                }
                if (column.showTrend) {
                    columns.push(React.createElement('th', {
                        key: 'columnT' + i,
                        className: className,
                        style: { width: '3em' }
                    }));
                }
            });
            return React.createElement('thead', { key: 'head' }, React.createElement('tr', { key: 'headTr', className: 'count-header' }, columns));
        };
        CountDetailComponent.prototype.createBody = function (tab) {
            var rows = [];
            tab.outputRows.forEach(function (row) {
                var cells = [];
                if (!tab.hideRowColumn) {
                    if (row.displayName === "9999") {
                        row.displayName = "MNR";
                    }
                    cells.push(React.createElement('td', { key: 'rowColumn', className: 'er-spacer' }, row.displayName));
                }
                var createRow = true;
                if (row.cells) {
                    row.cells.forEach(function (cell, i) {
                        var value = cell.fixedValue;
                        if (!cell.isFixed && cell.count && cell) {
                            if (row.isNoCount) {
                                value = 'NC';
                            }
                            else {
                                value = cell.count.count.toFixed(0);
                            }
                        }
                        var options = { key: row.id + "-" + i, className: undefined };
                        if (cell.rightJustify) {
                            options.className = 'rightJustify';
                        }
                        cells.push(React.createElement('td', options, value));
                        if (cell.count) {
                            if (cell.count.showPercent) {
                                var percent = '';
                                if (!row.isNoCount) {
                                    percent = cell.count.getPercent() + '%';
                                    if (cell.count.count === 0) {
                                        createRow = false;
                                    }
                                }
                                cells.push(React.createElement('td', { key: row.id + "-p" + i, className: 'rightJustify' }, percent));
                            }
                            if (cell.count.showTrend) {
                                var trend = '';
                                if (!row.isNoCount) {
                                    var trendClass = 'trend';
                                    if (cell.count.trend && cell.count.trend.down) {
                                        trendClass += ' trend-down';
                                    }
                                    else if (cell.count.trend && cell.count.trend.up) {
                                        trendClass += ' trend-up';
                                    }
                                    trend = React.createElement('i', { className: trendClass }, '');
                                }
                                cells.push(React.createElement('td', { key: row.id + "-t" + i }, trend));
                            }
                        }
                    });
                }
                if (createRow) {
                    rows.push(React.createElement('tr', {
                        key: row.id,
                        className: row.isChild ? 'sub-count-detail-row'
                            : (row.headerRow ? 'count-header-row' : 'count-detail-row')
                    }, cells));
                }
            });
            return React.createElement('tbody', { key: 'body' }, rows);
        };
        return CountDetailComponent;
    }(React.Component));
    exports.default = angular.module('aps.controller.countDetail', [])
        .factory('CountDetailComponent', function () {
        return CountDetailComponent;
    })
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(5), __webpack_require__(27), __webpack_require__(3), __webpack_require__(4), __webpack_require__(8), __webpack_require__(26), __webpack_require__(48), __webpack_require__(628)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, aps_enums_1, enums_1, constant_module_1, loader_service_1, navigation_service_1, counts_service_1, groupRejects_service_1, summary_tpl_html_1) {
    "use strict";
    countSummaryConfig.$inject = ["$stateProvider"];
    countSummaryCtrl.$inject = ["loaderService", "navigationService", "countsService", "groupRejectsService", "$q", "$state", "$stateParams"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, navigation_service_1.default, counts_service_1.default, groupRejects_service_1.default];
    var commonColumns = ['Last 24 Hours', 'Current Hour', 'Previous Hour', 'Current Shift', 'Shift -1', 'Shift -2', 'Rolling Hour'];
    exports.default = angular.module('aps.controller.countSummary', requires)
        .config(countSummaryConfig)
        .controller('CountSummaryCtrl', countSummaryCtrl)
        .name;
    function countSummaryConfig($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.COUNT_SUMMARY,
            url: '/countSummary?autoRun&reportPlantId&reportShopId',
            params: {
                autoRun: { dynamic: true },
                reportPlantId: { dynamic: true },
                reportShopId: { dynamic: true },
            },
            controller: 'CountSummaryCtrl as vm',
            template: summary_tpl_html_1.default,
            data: {
                pageTitle: 'Production Summary'
            }
        });
    }
    function countSummaryCtrl(loaderService, navigationService, countsService, groupRejectsService, $q, $state, $stateParams) {
        var vm = {};
        function getOrCreateRow(name, section) {
            var row = _.find(section.rows, { name: name });
            if (row) {
                return row;
            }
            row = {
                name: name,
                results: []
            };
            section.rows.push(row);
            return row;
        }
        function completeDataProcess(data, model) {
            vm.summaryData = data;
            vm.lineCounts = model;
        }
        function processCavityData(data, model, detail) {
            if (detail.length > 5) {
                detail = detail.slice(0, 5);
            }
            data.sections[3].rows = detail.map(function (d) { return ({
                name: d.defect,
                results: [
                    d.mold < 0 ? 'UNR' : d.mold.toString(10),
                    d.cavity,
                    d.rejectPercent.toFixed(1)
                ]
            }); });
            completeDataProcess(data, model);
        }
        function processData(model) {
            var data = {
                sections: [{
                        heading: 'Performance',
                        columns: [''],
                        rows: []
                    }, {
                        heading: 'Losses (% of Shear Cuts)',
                        columns: [''],
                        rows: []
                    }, {
                        heading: 'All Inspection Devices',
                        columns: ['Top Losses (% of Inspected)'],
                        rows: []
                    }]
            };
            data.sections.forEach(function (s) {
                return (_a = s.columns).push.apply(_a, commonColumns);
                var _a;
            });
            data.sections.push({
                heading: 'Cavity Reading Inspection Devices',
                columns: ['Top Defects (% of Inspected)', 'Mld', 'Cav', '10 Mins'],
                rows: []
            });
            model.handleIntervalChange(enums_1.apsDisplayEnums.CountDisplayInterval.PreviousHour);
            var groups = model.equipmentGroups.filter(function (g) { return g.hasRejects; });
            groups.sort(function (a, b) { return parseFloat(b.rejectCount.percent)
                - parseFloat(a.rejectCount.percent); });
            if (groups.length > 5) {
                groups = groups.slice(0, 5);
            }
            var interval = enums_1.apsDisplayEnums.CountDisplayInterval.Last24Hours;
            while (enums_1.apsDisplayEnums.CountDisplayInterval[interval]) {
                model.handleIntervalChange(interval);
                var section = data.sections[0];
                if (model.gobsProduced) {
                    var speed = getOrCreateRow('Speed', section);
                    speed.results.push(model.gobsProduced.speed);
                }
                if (model.packedCount) {
                    var packedCount = getOrCreateRow('Packed', section);
                    packedCount.results.push(model.packedCount.count.toString(10));
                }
                var heEff = _.find(model.kpis, { efficiencyName: 'H/E Efficiency' });
                if (heEff) {
                    var heRow = getOrCreateRow(heEff.efficiencyName, section);
                    heRow.results.push(heEff.efficiency);
                }
                var packEff = _.find(model.kpis, { efficiencyName: 'Pack Efficiency' });
                if (packEff) {
                    var packRow = getOrCreateRow(packEff.efficiencyName, section);
                    packRow.results.push(packEff.efficiency);
                }
                section = data.sections[1];
                if (heEff) {
                    var heLoss = getOrCreateRow('H/E Losses', section);
                    heLoss.results.push(heEff.lossPercent);
                }
                var ceEff = _.find(model.kpis, { efficiencyName: 'C/E Efficiency' });
                if (ceEff && model.gobsProduced) {
                    var ceLoss = getOrCreateRow('C/E Inspection Equip Rejects', section);
                    var ceLossPercent = 'N/A';
                    if (model.gobsProduced.count > 0) {
                        ceLossPercent = ((ceEff.losses / model.gobsProduced.count) * 100).toFixed(1) + '%';
                    }
                    ceLoss.results.push(ceLossPercent);
                }
                section = data.sections[2];
                for (var i = 0; i < groups.length; i++) {
                    var group = groups[i];
                    if (!group.hasRejects) {
                        continue;
                    }
                    var row = getOrCreateRow(group.name, section);
                    row.results.push(group.rejectCount.percent);
                }
                interval++;
            }
            model.handleIntervalChange(vm.interval);
            var cdHeye = _.find(model.equipmentGroups, function (g) {
                return _.some(g.types, function (t) { return t === aps_enums_1.apsEnums.LineEquipmentType.CheckDetector
                    || t === aps_enums_1.apsEnums.LineEquipmentType.HEYE; });
            });
            if (cdHeye) {
                var now = moment().startOf('minute');
                if (now.minute() % 10 !== 0) {
                    now = now.subtract(now.minute() % 10, 'minute');
                }
                var endTime = now.toDate();
                var startTime = now.subtract(10, 'minute').toDate();
                return countsService.getCavityCounts(vm.selectedShop.id, cdHeye.types, startTime, endTime).then(function (detail) { return processCavityData(data, model, detail); });
            }
            completeDataProcess(data, model);
            return $q.when();
        }
        function runReport() {
            vm.summaryData = null;
            vm.lineCounts = null;
            vm.interval = enums_1.apsDisplayEnums.CountDisplayInterval.CurrentHour;
            return countsService.getLineCounts(vm.selectedShop.id, vm.selectedPlant, enums_1.apsDisplayEnums.CountDisplayInterval.Last24Hours, false).then(processData);
        }
        function loadState() {
            if ($stateParams.reportPlantId && $stateParams.reportShopId
                && $stateParams.reportShopId !== $stateParams.shopId) {
                var plant = _.find(vm.plants, { id: $stateParams.reportPlantId });
                if (plant) {
                    var shop = _.find(plant.shops, { id: $stateParams.reportShopId });
                    if (shop) {
                        vm.selectedPlant = plant;
                        vm.selectedShop = shop;
                    }
                }
            }
            return runReport();
        }
        function saveState() {
            var reportShopId = vm.selectedShop ? vm.selectedShop.id : undefined;
            if (reportShopId === $stateParams.shopId) {
                reportShopId = undefined;
            }
            var params = {
                plantId: $stateParams.plantId,
                shopId: $stateParams.shopId,
                userId: $stateParams.userId,
                reportPlantId: (reportShopId && vm.selectedPlant) ? vm.selectedPlant.id : undefined,
                reportShopId: reportShopId,
                autoRun: true
            };
            $state.transitionTo($state.current.name, params);
        }
        function generateReport() {
            if (vm.form.$invalid) {
                return;
            }
            saveState();
            loaderService.loadingPromise(runReport());
        }
        vm.generateReport = generateReport;
        function viewGroupRejects(dimpleEvent) {
            if (!dimpleEvent || !dimpleEvent.xValue) {
                return;
            }
            var equipmentGroup = _.find(vm.lineCounts.equipmentGroups, { name: dimpleEvent.xValue });
            groupRejectsService.showGroupRejects({
                equipmentGroup: equipmentGroup,
                shopId: vm.selectedShop.id,
                lineCounts: vm.lineCounts,
                countsInterval: vm.interval
            });
        }
        vm.viewGroupRejects = viewGroupRejects;
        function updatePlant() {
            vm.selectedShop = vm.selectedPlant.shops[0];
        }
        vm.updatePlant = updatePlant;
        vm.interval = enums_1.apsDisplayEnums.CountDisplayInterval.Last24Hours;
        var promise = navigationService.getNavigation().then(function (nav) {
            vm.plants = nav.plants();
            vm.selectedPlant = nav.selectedPlant;
            vm.updatePlant();
            vm.selectedShop = nav.selectedShop;
            return loadState();
        });
        loaderService.loadingPromise(promise);
        return vm;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div class=body-header> <h2>Production Summary</h2> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns\"> <label> Plant <select ng-model=vm.selectedPlant ng-options=\"plant as plant.name for plant in vm.plants\" ng-change=vm.updatePlant()> </select> </label> </div> <div class=\"small-3 columns\"> <label> Shop <select ng-model=vm.selectedShop ng-options=\"shop as shop.name for shop in vm.selectedPlant.shops\"> </select> </label> </div> <div class=\"small-6 columns\"> <button type=submit class=button>Generate Report</button> </div> </div> </form> <div class=row ng-if=vm.lineCounts style=\"border-bottom:1px solid #000\"> <aps-top-rejects-graph shop-id=vm.shopId model=vm.lineCounts interval=vm.interval equipment-selected=vm.viewGroupRejects></aps-top-rejects-graph> </div> <div ng-if=vm.summaryData class=row> <div class=\"small-12 large-6 columns\" ng-repeat=\"section in vm.summaryData.sections\"> <table class=history-t style=min-height:11em> <thead> <tr> <th colspan=\"{{section.columns.length}}\">{{section.heading}}</th> </tr> <tr ng-if=\"section.rows.length > 0\"> <th ng-repeat=\"col in section.columns\">{{col}}</th> </tr> </thead> <tbody ng-if=\"section.rows.length > 0\"> <tr ng-repeat=\"row in section.rows\"> <td>{{row.name}}</td> <td ng-repeat=\"data in row.results track by $index\">{{data}}</td> </tr> </tbody> <tbody ng-if=\"section.rows.length === 0\"> <tr> <td colspan=\"{{section.columns.length}}\">No data in the last 24 hours</td> </tr> </tbody> </table> </div> </div> </div>");

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(630), __webpack_require__(5), __webpack_require__(3), __webpack_require__(8), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, adminDashboard_tpl_html_1, aps_enums_1, constant_module_1, navigation_service_1, loader_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [navigation_service_1.default, loader_service_1.default];
    var AdminDashboardCtrl = (function () {
        AdminDashboardCtrl.$inject = ["navigationService", "loaderService", "$state", "$stateParams"];
        function AdminDashboardCtrl(navigationService, loaderService, $state, $stateParams) {
            var _this = this;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.packEfficiency = aps_enums_1.apsEnums.WellKnownCheckType.ShopPackEfficiency;
            var loadNavPromise = navigationService.getNavigation().then(function (navModel) {
                _this.navigation = navModel;
                _this.plants = navModel.plants().filter(function (x) { return !x.isDisabled; });
            });
            loaderService.loadingPromise(loadNavPromise);
        }
        AdminDashboardCtrl.prototype.goToPlant = function (plant) {
            this.navigation.selectPlant(plant);
            this.$state.go(constant_module_1.States.PLANT_DASHBOARD, {
                plantId: plant.id,
                shopId: _.first(plant.shops).id,
                userId: this.$stateParams.userId
            });
        };
        return AdminDashboardCtrl;
    }());
    exports.default = angular.module('aps.controller.adminDashboard', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.ADMIN_DASHBOARD,
            url: '/overview/dashboard',
            controller: 'AdminDashboardCtrl as vm',
            template: adminDashboard_tpl_html_1.default,
            data: {
                pageTitle: 'Company Snapshot',
                v2Uri: 'aps/dashboard/company/plant-overview'
            },
        });
    }])
        .controller('AdminDashboardCtrl', AdminDashboardCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <div class=body-header> <h2>Company Snapshot</h2> <button class=\"btn-icon mobile-only expand-mobile\"> <i class=\"fa fa-plus\"></i> <span>Expand</span> </button> </div> <hr> <div ng-if=\"vm.plants && vm.plants.length\" style=padding:0;margin:0> <h3 style=font-size:1.2em>Anchor Glass <span class=pill>8 Furnaces</span> <span class=pill>24 Shops</span> </h3> <div ng-repeat=\"plant in vm.plants | orderBy : 'name'\" class=plant-dash> <h3 style=font-size:1.2em><a ng-click=vm.goToPlant(plant)>{{::plant.name}}</a> <!-- Conditional Pills --> <span ng-switch=plant.name> <!-- Elmira --> <span ng-switch-when=Elmira> <span class=pill>2 Furnaces</span> <span class=pill>5 Shops</span> </span> <!-- Henryetta --> <span ng-switch-when=Henryetta> <span class=pill>2 Furnaces</span> <span class=pill>6 Shops</span> </span> <!-- Lawrenceburg --> <span ng-switch-when=Lawrenceburg> <span class=pill>1 Furnace</span> <span class=pill>4 Shops</span> </span> <span ng-switch-when=Shakopee> <span class=pill>2 Furnaces</span> <span class=pill>6 Shops</span> </span> <span ng-switch-when=\"Warner Robins\"> <span class=pill>1 Furnace</span> <span class=pill>3 Shops</span> </span> <span ng-switch-when=Test> <span class=pill>2 Furnaces</span> <span class=pill>5 Shops</span> </span> </span> </h3> <aps-hourly-check-report plant=plant show-details=true num-hours=24 well-known-check=vm.packEfficiency></aps-hourly-check-report> </div> </div> <div ng-if=\"!vm.plants || !vm.plants.length\"> No Plants Found </div> </div> ");

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(632), __webpack_require__(3), __webpack_require__(9), __webpack_require__(23), __webpack_require__(4), __webpack_require__(633), __webpack_require__(7), __webpack_require__(50), __webpack_require__(94)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, shopSummaryDashboard_tpl_html_1, constant_module_1, uiUtility_service_1, shops_service_1, loader_service_1, shopSummary_service_1, authData_service_1, interval_factory_1, count_controller_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [
        uiUtility_service_1.default,
        shops_service_1.default,
        loader_service_1.default,
        shopSummary_service_1.default,
        authData_service_1.default
    ];
    var ShopSummaryDashboardController = (function () {
        ShopSummaryDashboardController.$inject = ["$filter", "$timeout", "$stateParams", "$interval", "shopService", "loaderService", "countsService", "$scope", "uiUtilityService", "$state", "$q", "shopSummaryService"];
        function ShopSummaryDashboardController($filter, $timeout, $stateParams, $interval, shopService, loaderService, countsService, $scope, uiUtilityService, $state, $q, shopSummaryService) {
            var _this = this;
            this.chartDataHash = {
                'previousProductionDay': [],
                'currentHour': [],
                'previousHour': [],
                'currentShift': [],
                'shiftMinus1': [],
                'shiftMinus2': []
            };
            this.shiftSelectors = {
                buttons: [
                    { 'name': 'Current Hour', 'value': 'currentHour', 'selected': true },
                    { 'name': 'Previous Hour', 'value': 'previousHour', 'selected': false },
                    { 'name': 'Current Shift', 'value': 'currentShift', 'selected': false },
                    { 'name': 'Shift - 1', 'value': 'shiftMinus1', 'selected': false },
                    { 'name': 'Shift - 2', 'value': 'shiftMinus2', 'selected': false },
                    { 'name': 'Prev. Prod. Day', 'value': 'previousProductionDay', 'selected': false }
                ],
                select: function (button) {
                    _this.barchartOptions.series = [];
                    _this.$timeout(function () {
                        try {
                            _this.barchartOptions.series = [{
                                    name: "Inspection Equipment",
                                    data: _this.chartDataHash[button.value]
                                }];
                        }
                        finally {
                            console.log('Chart Data Changed');
                        }
                    }, 250);
                }
            };
            this.usePercentGobs = countsService.getUsePercentGobsForPlantId($stateParams.plantId);
            this.$timeout = $timeout;
            this.$filter = $filter;
            this.$interval = $interval;
            this.plantId = $stateParams.plantId;
            this.shopId = $stateParams.shopId;
            this.countsService = countsService;
            this.loaderService = loaderService;
            this.shopService = shopService;
            this.shopName = null;
            this.plantName = null;
            this.$state = $state;
            this.$scope = $scope;
            this.uiUtilityService = uiUtilityService;
            this.$q = $q;
            this.shopSummaryService = shopSummaryService;
            this.barchartOptions = this.getBarChartOptions();
            this.navigationUrls = {
                buttons: [
                    { 'name': 'Summary', 'value': 'summary', 'selected': true },
                    { 'name': 'Linesheet', 'value': 'linesheet', 'selected': false },
                    { 'name': 'Horizontal Counts', 'value': 'horizontal', 'selected': false },
                    { 'name': 'Vertical Counts', 'value': 'vertical', 'selected': false },
                    { 'name': 'Vertical Counts (v2)', 'value': 'vc2', 'selected': false },
                ],
                select: function (button) {
                    var stateParams = {
                        plantId: $stateParams.plantId,
                        shopId: $stateParams.shopId,
                        userId: $stateParams.userId,
                    };
                    switch (button.value) {
                        case "summary":
                            $state.go(constant_module_1.States.SHOP_SUMMARY_DASHBOARD, stateParams);
                            break;
                        case "linesheet":
                            $state.go(constant_module_1.States.LINE_SHEET, stateParams);
                            break;
                        case "horizontalv2":
                            $state.go(constant_module_1.States.COUNTS_HORIZONTAL_V2, stateParams);
                            break;
                        case "horizontal":
                            $state.go(constant_module_1.States.COUNTS_HORIZONTAL, stateParams);
                            break;
                        case "vertical":
                            $state.go(constant_module_1.States.COUNTS_VERTICAL, stateParams);
                            break;
                        case "vc2":
                            $state.go(constant_module_1.States.COUNTS_VERTICAL_V2, stateParams);
                            break;
                    }
                }
            };
            this.$scope.$on('$destroy', function () {
                _this.destroyInterval();
            });
            this.createInterval();
            this.updateData();
        }
        ShopSummaryDashboardController.prototype.usePercentGobsChanged = function () {
            this.usePercentGobs = !this.usePercentGobs;
            count_controller_1.usePercentGobsProducedChanged(this.countsService, this.plantId, this.usePercentGobs);
            this.barchartOptions = this.getBarChartOptions();
            this.mapShopSummaryResults(this.data);
        };
        ShopSummaryDashboardController.prototype.getBarChartOptions = function () {
            return {
                chart: {
                    type: 'bar',
                    animation: false
                },
                title: {
                    text: this.usePercentGobs ? 'Percentage of Gobs Produced Rejected' : 'Percentage of Inspected Ware Rejected'
                },
                accessibility: {
                    announceNewData: {
                        enabled: true
                    }
                },
                xAxis: {
                    type: 'category',
                    labels: {
                        style: {
                            color: 'black',
                            fontSize: '28px'
                        }
                    }
                },
                yAxis: {
                    title: {
                        enabled: false
                    },
                    labels: {
                        style: {
                            color: 'black',
                            fontSize: '28px'
                        }
                    },
                    plotBands: [
                        {
                            from: 0,
                            to: 3,
                            color: '#E6F9F2'
                        },
                        {
                            from: 3,
                            to: 5,
                            color: '#FFFDE6'
                        },
                        {
                            from: 5,
                            to: 7,
                            color: '#FFF2EA'
                        },
                        {
                            from: 7,
                            to: 100,
                            color: '#FFEAE8'
                        }
                    ],
                    minTickInterval: 1,
                    ceiling: 100,
                    min: 0
                },
                legend: {
                    enabled: false
                },
                plotOptions: {
                    series: {
                        borderWidth: 0,
                        shadow: true,
                        dataLabels: {
                            enabled: true,
                            format: '{point.y:.2f}%',
                            inside: false,
                            style: {
                                color: 'contrast',
                                fontSize: '28px',
                                fontWeight: 'bold'
                            }
                        }
                    }
                },
                tooltip: {
                    enabled: false
                },
                credits: {
                    enabled: false
                },
                series: [{
                        data: []
                    }]
            };
        };
        ShopSummaryDashboardController.prototype.destroyInterval = function () {
            this.interval.destroy();
            this.interval = null;
        };
        ShopSummaryDashboardController.prototype.createInterval = function () {
            var _this = this;
            this.interval = new interval_factory_1.Interval(function () {
                _this.updateData();
            }, this.$interval, 1000 * 60 * 5);
            this.interval.start();
        };
        ShopSummaryDashboardController.prototype.updateData = function () {
            var _this = this;
            this.inspectionDeviceLosses = [];
            this.loaderService.setAppLoading(true);
            this.shopService.getShopConfiguration(this.shopId)
                .then(function (shop) {
                _this.shopName = shop.name;
                _this.plantName = shop.plantName;
            }).then(function () {
                _this.shopSummaryService.getShopSummary(_this.shopId)
                    .then(function (shopSummaryResults) {
                    _this.data = shopSummaryResults;
                    _this.mapShopSummaryResults(shopSummaryResults);
                    _this.loaderService.setAppLoading(false);
                });
            });
        };
        ShopSummaryDashboardController.prototype.mapShopSummaryResults = function (shopSummaryResults) {
            this.mapInspectionDeviceLosses(shopSummaryResults);
            this.mapLocationLosses(shopSummaryResults);
            this.mapCeDetailLosses(shopSummaryResults);
            this.mapShopPerformance(shopSummaryResults);
            this.mapChartData(shopSummaryResults);
            this.mapTopDefects(shopSummaryResults);
            var button = this.shiftSelectors.buttons.filter(function (button) { return button.selected; })[0];
            this.shiftSelectors.select(button);
        };
        ShopSummaryDashboardController.prototype.mapTopDefects = function (shopSummaryResults) {
            if (shopSummaryResults.topDefects && shopSummaryResults.topDefects.length >= 1) {
                this.topDefects = shopSummaryResults.topDefects.slice(0, 5);
            }
        };
        ShopSummaryDashboardController.prototype.mapChartData = function (shopSummaryResults) {
            var _this = this;
            Object.keys(this.chartDataHash).forEach(function (timeframe) {
                _this.mapChartDataForTimeframe(shopSummaryResults, timeframe);
            });
        };
        ShopSummaryDashboardController.prototype.mapShopPerformance = function (shopSummaryResults) {
            this.getDefaultShopPerformance();
            this.mapShopPerformanceForTimeframe(shopSummaryResults, 'previousProductionDay');
            this.mapShopPerformanceForTimeframe(shopSummaryResults, 'currentHour');
            this.mapShopPerformanceForTimeframe(shopSummaryResults, 'previousHour');
            this.mapShopPerformanceForTimeframe(shopSummaryResults, 'currentShift');
            this.mapShopPerformanceForTimeframe(shopSummaryResults, 'shiftMinus1');
            this.mapShopPerformanceForTimeframe(shopSummaryResults, 'shiftMinus2');
        };
        ShopSummaryDashboardController.prototype.mapShopPerformanceForTimeframe = function (shopSummaryResults, timeframe) {
            var shopSummaryTimeframe = shopSummaryResults[timeframe].countSummaries || [];
            var heItem = this.getHotEnd(shopSummaryTimeframe);
            var lehrItem = this.getLehrItem(shopSummaryTimeframe);
            var ceItems = this.getColdEndItems(shopSummaryTimeframe);
            var gobsProduced = (heItem && heItem.inspectCount)
                ? heItem.inspectCount
                : 0;
            var bottlesPerMinute = (shopSummaryResults[timeframe] && shopSummaryResults[timeframe].bottlesPerMinute)
                ? shopSummaryResults[timeframe].bottlesPerMinute
                : 0;
            var bpmIndex = _.findIndex(this.shopPerformance, { metricName: 'Bottles Per Minute' });
            this.shopPerformance[bpmIndex][timeframe + 'Metric'] = bottlesPerMinute.toLocaleString();
            var gobCountIndex = _.findIndex(this.shopPerformance, { metricName: 'Gobs Produced' });
            this.shopPerformance[gobCountIndex][timeframe + 'Metric'] = gobsProduced.toLocaleString();
            var shearsIndex = _.findIndex(this.shopPerformance, { metricName: 'Shears' });
            this.shopPerformance[shearsIndex][timeframe + 'Metric'] = '100.00%';
            if (lehrItem) {
                var lehrInIndex = _.findIndex(this.shopPerformance, { metricName: 'Lehr In %' });
                this.shopPerformance[lehrInIndex][timeframe + 'Metric'] =
                    this.mapNumberToPercent((lehrItem.inspectCount / gobsProduced) * 100.0);
                var lehrOutIndex = _.findIndex(this.shopPerformance, { metricName: 'Lehr Out %' });
                this.shopPerformance[lehrOutIndex][timeframe + 'Metric'] =
                    this.mapNumberToPercent(((lehrItem.inspectCount - lehrItem.rejectCount) / gobsProduced) * 100.0);
            }
            if (heItem && ceItems && ceItems.length > 0) {
                var countLen = shopSummaryTimeframe.length;
                var lastItem = shopSummaryTimeframe[countLen - 1];
                var bottlesOut = (lastItem.rejectCount && lastItem.rejectCount > 0.0)
                    ? lastItem.inspectCount - lastItem.rejectCount
                    : lastItem.inspectCount;
                var packedCountIndex = _.findIndex(this.shopPerformance, { metricName: 'Packed Count' });
                this.shopPerformance[packedCountIndex][timeframe + 'Metric'] = bottlesOut.toLocaleString();
                var packEffeciencyIndex = _.findIndex(this.shopPerformance, { metricName: 'Percent Packed' });
                this.shopPerformance[packEffeciencyIndex][timeframe + 'Metric'] = this.mapNumberToPercent((bottlesOut / gobsProduced) * 100.0);
            }
        };
        ShopSummaryDashboardController.prototype.getDefaultShopPerformance = function () {
            var performanceTags = ['Bottles Per Minute', 'Gobs Produced', 'Packed Count', 'Shears', 'Lehr In %', 'Lehr Out %', 'Percent Packed'];
            var shopPerformance = [];
            _.forEach(performanceTags, function (lt) {
                var metricItem = {
                    metricName: lt,
                    previousProductionDayMetric: '-',
                    last24HoursMetric: '-',
                    currentHourMetric: '-',
                    previousHourMetric: '-',
                    currentShiftMetric: '-',
                    shiftMinus1Metric: '-',
                    shiftMinus2Metric: '-'
                };
                shopPerformance.push(metricItem);
            });
            this.shopPerformance = shopPerformance;
        };
        ShopSummaryDashboardController.prototype.mapLocationLosses = function (shopSummaryResults) {
            this.getDefaultLocationLosses();
            this.mapLocationLossesForTimeframe(shopSummaryResults, 'previousProductionDay');
            this.mapLocationLossesForTimeframe(shopSummaryResults, 'currentHour');
            this.mapLocationLossesForTimeframe(shopSummaryResults, 'previousHour');
            this.mapLocationLossesForTimeframe(shopSummaryResults, 'currentShift');
            this.mapLocationLossesForTimeframe(shopSummaryResults, 'shiftMinus1');
            this.mapLocationLossesForTimeframe(shopSummaryResults, 'shiftMinus2');
        };
        ShopSummaryDashboardController.prototype.mapCeDetailLosses = function (shopSummaryResults) {
            this.getDefaultCeDetailLosses();
            this.mapCeDetailLossesForTimeframe(shopSummaryResults, 'previousProductionDay');
            this.mapCeDetailLossesForTimeframe(shopSummaryResults, 'currentHour');
            this.mapCeDetailLossesForTimeframe(shopSummaryResults, 'previousHour');
            this.mapCeDetailLossesForTimeframe(shopSummaryResults, 'currentShift');
            this.mapCeDetailLossesForTimeframe(shopSummaryResults, 'shiftMinus1');
            this.mapCeDetailLossesForTimeframe(shopSummaryResults, 'shiftMinus2');
        };
        ShopSummaryDashboardController.prototype.mapLocationLossesForTimeframe = function (shopSummaryResults, timeframe) {
            var shopSummaryTimeframe = shopSummaryResults[timeframe].countSummaries || [];
            var heItem = this.getHotEnd(shopSummaryTimeframe);
            var lehrItem = this.getLehrItem(shopSummaryTimeframe);
            var ceItems = this.getColdEndItems(shopSummaryTimeframe);
            if (heItem && lehrItem && ceItems && ceItems.length > 0) {
                var countLen = shopSummaryTimeframe.length;
                var lastItem = shopSummaryTimeframe[countLen - 1];
                var bottlesOut = (lastItem.rejectCount && lastItem.rejectCount > 0.0)
                    ? lastItem.inspectCount - lastItem.rejectCount
                    : lastItem.inspectCount;
                var lehrOut = lehrItem.inspectCount - lehrItem.rejectCount;
                var ceTotal = (lehrOut - bottlesOut);
                var hotEndLoss = (heItem.inspectCount - lehrItem.inspectCount) / heItem.inspectCount * 100 || 0.0;
                var heLossIndex = _.findIndex(this.locationLosses, { metricName: 'Hot-End' });
                this.locationLosses[heLossIndex][timeframe + 'Metric'] =
                    this.mapNumberToPercent(hotEndLoss);
                var lehrLossIndex = _.findIndex(this.locationLosses, { metricName: 'Lehr Loss' });
                this.locationLosses[lehrLossIndex][timeframe + 'Metric'] =
                    this.mapNumberToPercent((lehrItem.rejectCount / heItem.inspectCount) * 100.0);
                var ceTotalIndex = _.findIndex(this.locationLosses, { metricName: 'Cold-End Total' });
                this.locationLosses[ceTotalIndex][timeframe + 'Metric'] =
                    this.mapNumberToPercent((ceTotal / heItem.inspectCount) * 100.0);
            }
        };
        ShopSummaryDashboardController.prototype.mapCeDetailLossesForTimeframe = function (shopSummaryResults, timeframe) {
            var shopSummaryTimeframe = shopSummaryResults[timeframe].countSummaries || [];
            var heItem = this.getHotEnd(shopSummaryTimeframe);
            var lehrItem = this.getLehrItem(shopSummaryTimeframe);
            var ceItems = this.getColdEndItems(shopSummaryTimeframe);
            if (heItem && ceItems && ceItems.length > 0) {
                var countLen = shopSummaryTimeframe.length;
                var bottlesCeIn = ceItems[0].inspectCount;
                var lastItem = shopSummaryTimeframe[countLen - 1];
                var bottlesOut = (lastItem.rejectCount && lastItem.rejectCount > 0.0)
                    ? lastItem.inspectCount - lastItem.rejectCount
                    : lastItem.inspectCount;
                var coldEndRejects = _.reduce(ceItems, function (sum, x) {
                    return sum + x.rejectCount;
                }, 0);
                var ceInspectionIndex = _.findIndex(this.ceDetailLosses, { metricName: 'CE Inspection Losses' });
                this.ceDetailLosses[ceInspectionIndex][timeframe + 'Metric'] =
                    this.mapNumberToPercent((coldEndRejects / heItem.inspectCount) * 100.0);
                var ceDelta = (bottlesCeIn - bottlesOut) - coldEndRejects;
                var ceDeltaIndex = _.findIndex(this.ceDetailLosses, { metricName: 'CE Inspection Delta' });
                this.ceDetailLosses[ceDeltaIndex][timeframe + 'Metric'] = this.mapNumberToPercent((ceDelta / heItem.inspectCount) * 100.0);
            }
        };
        ShopSummaryDashboardController.prototype.getColdEndItems = function (shopSummaryTimeframe) {
            var coldEndInspectionItems = _.filter(shopSummaryTimeframe, function (cs) {
                return cs.name !== "HE" && cs.name !== "CUTS" && cs.name !== "LEHR"
                    && cs.name !== "EOL" && cs.name !== "TOTL" && cs.name !== "LOut"
                    && cs.name !== "CP" && cs.name !== "SPRY" && cs.name !== "STKR";
            });
            return coldEndInspectionItems;
        };
        ShopSummaryDashboardController.prototype.getLehrItem = function (shopSummaryTimeframe) {
            var lehrItem = _.findLast(shopSummaryTimeframe, function (cs) {
                return cs.name === "LEHR" || cs.name === "L-L";
            });
            return lehrItem;
        };
        ShopSummaryDashboardController.prototype.getHotEnd = function (shopSummaryTimeframe) {
            var hotEndItem = _.findLast(shopSummaryTimeframe, function (cs) {
                return cs.name === "HE" || cs.name === "CUTS";
            });
            return hotEndItem;
        };
        ShopSummaryDashboardController.prototype.getDefaultLocationLosses = function () {
            var locationTags = ['Hot-End', 'Lehr Loss', 'Cold-End Total'];
            var locationLosses = [];
            _.forEach(locationTags, function (lt) {
                var metricItem = {
                    metricName: lt,
                    previousProductionDayMetric: '-',
                    last24HoursMetric: '-',
                    currentHourMetric: '-',
                    previousHourMetric: '-',
                    currentShiftMetric: '-',
                    shiftMinus1Metric: '-',
                    shiftMinus2Metric: '-'
                };
                locationLosses.push(metricItem);
            });
            this.locationLosses = locationLosses;
        };
        ShopSummaryDashboardController.prototype.getDefaultCeDetailLosses = function () {
            var ceDetailTags = ['CE Inspection Losses', 'CE Inspection Delta'];
            var ceDetailLosses = [];
            _.forEach(ceDetailTags, function (lt) {
                var metricItem = {
                    metricName: lt,
                    previousProductionDayMetric: '-',
                    last24HoursMetric: '-',
                    currentHourMetric: '-',
                    previousHourMetric: '-',
                    currentShiftMetric: '-',
                    shiftMinus1Metric: '-',
                    shiftMinus2Metric: '-'
                };
                ceDetailLosses.push(metricItem);
            });
            this.ceDetailLosses = ceDetailLosses;
        };
        ShopSummaryDashboardController.prototype.mapInspectionDeviceLosses = function (shopSummaryResults) {
            this.mapInspectionDeviceLossesForTimeframe(shopSummaryResults, 'currentHour');
            this.mapInspectionDeviceLossesForTimeframe(shopSummaryResults, 'previousHour');
            this.mapInspectionDeviceLossesForTimeframe(shopSummaryResults, 'currentShift');
            this.mapInspectionDeviceLossesForTimeframe(shopSummaryResults, 'shiftMinus1');
            this.mapInspectionDeviceLossesForTimeframe(shopSummaryResults, 'shiftMinus2');
            this.mapInspectionDeviceLossesForTimeframe(shopSummaryResults, 'previousProductionDay');
        };
        ShopSummaryDashboardController.prototype.mapInspectionDeviceLossesForTimeframe = function (shopSummaryResults, timeframe) {
            var _this = this;
            var shopSummaryTimeframe = shopSummaryResults[timeframe].countSummaries || [];
            var ceItems = this.getColdEndItems(shopSummaryTimeframe);
            if (!this.inspectionDeviceLosses || this.inspectionDeviceLosses.length === 0) {
                this.inspectionDeviceLosses = [];
            }
            _.forEach(ceItems, function (item) {
                var index = _.findIndex(_this.inspectionDeviceLosses, { metricName: item.name });
                var rejectPercent = (_this.usePercentGobs ? item.rejectPercent : _this.getRejectInspectPercent(item)) || 0.0;
                var stringPercent = _this.mapNumberToPercent(rejectPercent);
                if (index < 0) {
                    var inspectionLossItem = _this.getDefaultPercentLoss(item.name);
                    inspectionLossItem[timeframe + 'Metric'] = stringPercent;
                    _this.inspectionDeviceLosses.push(inspectionLossItem);
                }
                else {
                    _this.inspectionDeviceLosses[index][timeframe + 'Metric'] = stringPercent;
                }
            });
        };
        ShopSummaryDashboardController.prototype.getRejectInspectPercent = function (item) {
            if (item.inspectCount > 0 && item.rejectCount > 0) {
                return (item.rejectCount * 100.0) / item.inspectCount;
            }
            return 0.0;
        };
        ShopSummaryDashboardController.prototype.getDefaultPercentLoss = function (equipmentName) {
            var inspectionDeviceLosses = {
                metricName: equipmentName,
                previousProductionDayMetric: '-',
                last24HoursMetric: '-',
                currentHourMetric: '-',
                previousHourMetric: '-',
                currentShiftMetric: '-',
                shiftMinus1Metric: '-',
                shiftMinus2Metric: '-'
            };
            return inspectionDeviceLosses;
        };
        ShopSummaryDashboardController.prototype.mapChartDataForTimeframe = function (shopSummaryResults, timeframe) {
            var shopSummaryTimeframe = shopSummaryResults[timeframe].countSummaries || [];
            var dataForTimefame = this.getDataForTimeframe(shopSummaryTimeframe);
            this.chartDataHash[timeframe] = dataForTimefame;
        };
        ShopSummaryDashboardController.prototype.getDataForTimeframe = function (shopSummaryTimeframe) {
            var _this = this;
            var rawData = [];
            var sortedData = [];
            var filterData = [];
            var filterName = [];
            _.forEach(shopSummaryTimeframe, function (item) {
                rawData.push({
                    name: item.name,
                    y: (_this.usePercentGobs ? item.rejectPercent : _this.getRejectInspectPercent(item))
                });
            });
            filterData = _.filter(rawData, function (_a) {
                var y = _a.y;
                return y > 0.0;
            });
            filterName = _.filter(filterData, function (_a) {
                var name = _a.name;
                return name !== 'HE' && name !== 'CUTS' && name !== 'LEHR';
            });
            sortedData = _.orderBy(filterName, ['y'], ['desc']);
            sortedData.splice(5);
            return sortedData;
        };
        ShopSummaryDashboardController.prototype.mapNumberToPercent = function (num) {
            return (num) ? num.toFixed(2) + '%' : '-';
        };
        return ShopSummaryDashboardController;
    }());
    exports.ShopSummaryDashboardController = ShopSummaryDashboardController;
    exports.default = angular.module('aps.controller.shopSummaryDashboard', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.SHOP_SUMMARY_DASHBOARD,
            url: '/shopSummaryDashboard',
            controller: 'ShopSummaryDashboardCtrl as vm',
            template: shopSummaryDashboard_tpl_html_1.default,
            data: {
                pageTitle: 'Shop Summary Dashboard',
                v2Uri: 'aps/dashboard/shop/summary-dashboard'
            }
        });
    }])
        .controller('ShopSummaryDashboardCtrl', ShopSummaryDashboardController)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=container-fluid> <div class=row-flex> <div class=col-lg-4> <h4>Shop Summary Dashboard - {{vm.plantName}} <small class=text-muted>Shop - {{vm.shopName}}</small></h4> </div> <div class=col-lg-8> <div class=\"ag-header-btnarray ag-header-box\"> <btn-array options=vm.navigationUrls /> </div> </div> </div> <div class=row-flex> <div class=col-lg-6> <!-- performance table --> <table class=history-t style=\"border:1px solid #d3d3d3\"> <caption> <b>Shop Performance Metrics</b> </caption> <thead> <tr> <th>Metric</th> <th style=text-align:right>Curr. Hr.</th> <th style=text-align:right>Prev. Hr.</th> <th style=text-align:right>Curr. Shift</th> <th style=text-align:right>Shift - 1</th> <th style=text-align:right>Shift - 2</th> <th style=text-align:right>Prev. Prod. Day</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in vm.shopPerformance\" ng-style=\"{'font-weight':($last ?'bold':'normal')}\"> <td>{{item.metricName}}</td> <td> <div class=text-right>{{item.currentHourMetric}}</div> </td> <td> <div class=text-right>{{item.previousHourMetric}}</div> </td> <td> <div class=text-right>{{item.currentShiftMetric}}</div> </td> <td> <div class=text-right>{{item.shiftMinus1Metric}}</div> </td> <td> <div class=text-right>{{item.shiftMinus2Metric}}</div> </td> <td> <div class=text-right>{{item.previousProductionDayMetric}}</div> </td> </tr> </tbody> </table> <!--  losses table  --> <table class=history-t style=\"border:1px solid #d3d3d3\"> <caption> <b>Losses (% of Shear Cuts)</b> </caption> <thead> <tr> <th>Location</th> <th style=text-align:right>Curr. Hr.</th> <th style=text-align:right>Prev Hr.</th> <th style=text-align:right>Curr. Shift</th> <th style=text-align:right>Shift - 1</th> <th style=text-align:right>Shift - 2</th> <th style=text-align:right>Prev. Prod. Day</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in vm.locationLosses\"> <td>{{item.metricName}}</td> <td> <div class=text-right>{{item.currentHourMetric}}</div> </td> <td> <div class=text-right>{{item.previousHourMetric}}</div> </td> <td> <div class=text-right>{{item.currentShiftMetric}}</div> </td> <td> <div class=text-right>{{item.shiftMinus1Metric}}</div> </td> <td> <div class=text-right>{{item.shiftMinus2Metric}}</div> </td> <td> <div class=text-right>{{item.previousProductionDayMetric}}</div> </td> </tr> <tr ng-repeat=\"item in vm.ceDetailLosses\"> <td>&nbsp;&nbsp;{{item.metricName}}</td> <td> <div class=text-right>{{item.currentHourMetric}}</div> </td> <td> <div class=text-right>{{item.previousHourMetric}}</div> </td> <td> <div class=text-right>{{item.currentShiftMetric}}</div> </td> <td> <div class=text-right>{{item.shiftMinus1Metric}}</div> </td> <td> <div class=text-right>{{item.shiftMinus2Metric}}</div> </td> <td> <div class=text-right>{{item.previousProductionDayMetric}}</div> </td> </tr> </tbody> </table> <!-- inspection losses table --> <table class=history-t style=\"border:1px solid #d3d3d3\"> <div class=btn-switch-container> <div style=display:flex;align-items:center;justify-content:center> <span>Equipment</span> <div class=btn-switch ng-class=\"{'btn-switch--on':vm.usePercentGobs}\" ng-model=vm.usePercentGobs ng-click=vm.usePercentGobsChanged();> <div class=btn-switch-circle ng-class=\"{'btn-switch-circle--on':vm.usePercentGobs}\" ng-model=vm.usePercentGobs> </div> </div> <span>Shears</span> </div> </div> <caption> <b>Inspection Losses (% of {{vm.usePercentGobs ? 'Shear Cuts' : 'Inspect Count'}})</b> </caption> <thead> <tr> <th>Inspection</th> <th style=text-align:right>Curr. Hr.</th> <th style=text-align:right>Prev Hr.</th> <th style=text-align:right>Curr. Shift</th> <th style=text-align:right>Shift - 1</th> <th style=text-align:right>Shift - 2</th> <th style=text-align:right>Prev. Prod. Day</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in vm.inspectionDeviceLosses\"> <td>{{item.metricName}}</td> <td> <div class=text-right>{{item.currentHourMetric}}</div> </td> <td> <div class=text-right>{{item.previousHourMetric}}</div> </td> <td> <div class=text-right>{{item.currentShiftMetric}}</div> </td> <td> <div class=text-right>{{item.shiftMinus1Metric}}</div> </td> <td> <div class=text-right>{{item.shiftMinus2Metric}}</div> </td> <td> <div class=text-right>{{item.previousProductionDayMetric}}</div> </td> </tr> </tbody> </table> <!-- cavity correlation table --> <table class=history-t style=\"border:1px solid #d3d3d3\"> <caption> <b>Cavity Reading Inspection Devices</b><br/> <small>Top Rejects in Rolling Last 20 Minutes</small> </caption> <thead> <tr> <th>Defect</th> <th style=text-align:right>Mold</th> <th style=text-align:right>Cavity</th> <th style=text-align:right>Reject Count</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in vm.topDefects\"> <td>{{item.defect}}</td> <td style=text-align:right>{{item.mold}}</td> <td style=text-align:right>{{item.cavity}}</td> <td style=text-align:right>{{item.rejectCount}}</td> </tr> </tbody> </table> </div> <div class=col-lg-6 ng-if=vm.barchartOptions> <btn-array options=vm.shiftSelectors class=text-center></btn-array> <high-chart options=vm.barchartOptions id=barchart style=display:block;height:650px> </high-chart> </div> </div> <br/> <br/> </div>");

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ShopSummaryServiceImpl = (function () {
        ShopSummaryServiceImpl.$inject = ["httpService"];
        function ShopSummaryServiceImpl(httpService) {
            this.httpService = httpService;
        }
        ShopSummaryServiceImpl.prototype.getShopSummary = function (shopId) {
            return this.httpService.get(constant_module_1.Endpoints.DASHBOARD_SHOPSUMMARY, {
                shopId: shopId
            });
        };
        return ShopSummaryServiceImpl;
    }());
    exports.ShopSummaryServiceImpl = ShopSummaryServiceImpl;
    exports.default = angular
        .module('aps.services.shopSummary', [http_service_1.default])
        .service('shopSummaryService', ShopSummaryServiceImpl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(635), __webpack_require__(3), __webpack_require__(9), __webpack_require__(23), __webpack_require__(4), __webpack_require__(7), __webpack_require__(636), __webpack_require__(50), __webpack_require__(1), __webpack_require__(27)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, plantWareLossDashboard_tpl_html_1, constant_module_1, uiUtility_service_1, shops_service_1, loader_service_1, authData_service_1, plantWareLoss_service_1, interval_factory_1, moment, enums_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [
        uiUtility_service_1.default,
        shops_service_1.default,
        loader_service_1.default,
        plantWareLoss_service_1.default,
        authData_service_1.default
    ];
    var PlantWareLossDashboardController = (function () {
        PlantWareLossDashboardController.$inject = ["$stateParams", "shopService", "loaderService", "$scope", "uiUtilityService", "$state", "plantWareLossService", "authDataService", "$q", "$interval"];
        function PlantWareLossDashboardController($stateParams, shopService, loaderService, $scope, uiUtilityService, $state, plantWareLossService, authDataService, $q, $interval) {
            var _this = this;
            this.interval = null;
            this.shopId = $stateParams.shopId;
            this.plantId = $stateParams.plantId;
            this.loaderService = loaderService;
            this.shopName = null;
            this.plantName = null;
            this.plantWareLossInfo = null;
            this.$state = $state;
            this.$scope = $scope;
            this.uiUtilityService = uiUtilityService;
            this.plantWareLossService = plantWareLossService;
            this.$q = $q;
            this.shopService = shopService;
            this.uiUtilityService = uiUtilityService;
            this.$interval = $interval;
            this.authDataService = authDataService;
            this.$scope.$on('$destroy', function () {
                _this.destroyInterval();
            });
            this.createInterval();
            this.initPage();
        }
        PlantWareLossDashboardController.prototype.destroyInterval = function () {
            this.interval.destroy();
            this.interval = null;
        };
        PlantWareLossDashboardController.prototype.createInterval = function () {
            var _this = this;
            this.interval = new interval_factory_1.Interval(function () {
                _this.update();
            }, this.$interval, 1000 * 60 * 5);
            this.interval.start();
        };
        PlantWareLossDashboardController.prototype.update = function () {
            var _this = this;
            this.mapCountInterval();
            this.loaderService.setAppLoading(true);
            this.plantWareLossService
                .getPlantWareLoss(this.plantId, this.startDate, this.endDate)
                .then(function (plantWareLossType) {
                _this.mapPlantWareLossType(plantWareLossType);
                _this.loaderService.setAppLoading(false);
            });
        };
        PlantWareLossDashboardController.prototype.initPage = function () {
            var _this = this;
            this.loaderService.setAppLoading(true);
            this.shopService.getShopConfiguration(this.shopId)
                .then(function (shop) {
                _this.shopName = shop.name;
                _this.plantName = shop.plantName;
                _this.shopConfig = shop;
            })
                .then(function () {
                _this.countDisplayIntervalOptions = _this.uiUtilityService
                    .getListOptionsFromEnum(enums_1.apsDisplayEnums.CountDisplayInterval, null, null, function (o) { return o; });
            })
                .then(function () {
                _this.countsInterval = _this.authDataService.getCountInterval();
                _this.mapCountInterval();
            })
                .then(function () {
                _this.plantWareLossService
                    .getPlantWareLoss(_this.plantId, _this.startDate, _this.endDate)
                    .then(function (plantWareLossType) {
                    _this.mapPlantWareLossType(plantWareLossType);
                    _this.loaderService.setAppLoading(false);
                });
            });
        };
        PlantWareLossDashboardController.prototype.mapCountInterval = function () {
            this.authDataService.setCountInterval(this.countsInterval);
            this.endDate = moment().toDate();
            var now = moment();
            var remainderMinutes = now.minute() % 10;
            var remainderSeconds = now.second();
            var remainderMilliSeconds = now.millisecond();
            switch (this.countsInterval) {
                case enums_1.apsDisplayEnums.CountDisplayInterval.CurrentHour:
                    this.startDate = moment().startOf('hour').toDate();
                    break;
                case enums_1.apsDisplayEnums.CountDisplayInterval.PreviousHour:
                    this.endDate = moment().startOf('hour').toDate();
                    this.startDate = moment(this.endDate).subtract(1, 'hour').toDate();
                    break;
                case enums_1.apsDisplayEnums.CountDisplayInterval.CurrentShift:
                    this.startDate = this.shopConfig.shiftsInLast24Hours[0].startTime;
                    break;
                case enums_1.apsDisplayEnums.CountDisplayInterval.LastShift:
                    this.endDate = this.shopConfig.shiftsInLast24Hours[1].stopTime;
                    this.startDate = this.shopConfig.shiftsInLast24Hours[1].startTime;
                    break;
                case enums_1.apsDisplayEnums.CountDisplayInterval.ShiftBeforeLast:
                    this.endDate = this.shopConfig.shiftsInLast24Hours[2].stopTime;
                    this.startDate = this.shopConfig.shiftsInLast24Hours[2].startTime;
                    break;
                case enums_1.apsDisplayEnums.CountDisplayInterval.RollingHour:
                    this.endDate = moment(now)
                        .subtract(remainderMinutes, 'minute')
                        .subtract(remainderSeconds, 'second')
                        .subtract(remainderMilliSeconds, 'millisecond')
                        .toDate();
                    this.startDate = moment(this.endDate)
                        .subtract(1, 'hour')
                        .toDate();
                    break;
                case enums_1.apsDisplayEnums.CountDisplayInterval.LastTwentyMinutes:
                    this.endDate = moment(now)
                        .subtract(remainderMinutes, 'minute')
                        .subtract(remainderSeconds, 'second')
                        .subtract(remainderMilliSeconds, 'millisecond')
                        .toDate();
                    this.startDate = moment(this.endDate)
                        .subtract(20, 'minute')
                        .toDate();
                    break;
                default:
                    this.endDate = moment().startOf('hour').toDate();
                    this.startDate = moment(this.endDate).subtract(1, 'days').toDate();
                    break;
            }
        };
        PlantWareLossDashboardController.prototype.mapPlantWareLossType = function (plantWareLossType) {
            var _this = this;
            var plantWareLossInfo = [];
            _.forEach(plantWareLossType, function (plant) {
                var shopName = plant.shopName;
                var equipmentCounts = _this.getEquipmentCounts(plant.countSummaries);
                var backCavities = _this.getCavityCorrelations(plant.cavityCorrelations, 'B');
                var middleCavities = _this.getCavityCorrelations(plant.cavityCorrelations, 'M');
                var frontCavities = _this.getCavityCorrelations(plant.cavityCorrelations, 'F');
                var locationLosses = _this.getLocationLosses(plant.countSummaries);
                var areaEffeciency = _this.getAreaEffeciency(plant.countSummaries);
                var shopWareLoss = {
                    shopName: shopName,
                    equipmentCounts: equipmentCounts,
                    backCavities: backCavities,
                    middleCavities: middleCavities,
                    frontCavities: frontCavities,
                    locationLosses: locationLosses,
                    areaEffeciency: areaEffeciency
                };
                plantWareLossInfo.push(shopWareLoss);
            });
            this.plantWareLossInfo = plantWareLossInfo;
        };
        PlantWareLossDashboardController.prototype.getAreaEffeciency = function (countSummaries) {
            var heSummary = this.getHotEndSummary(countSummaries);
            var lehrSummary = this.getLehrSummary(countSummaries);
            var lehrInEfficiency = (lehrSummary.inspectCount / heSummary.inspectCount * 100) || 0.0;
            var lehrOutEfficiency = ((lehrSummary.inspectCount - lehrSummary.rejectCount) / heSummary.inspectCount * 100) || 0.0;
            var packPercent = this.getPackPercent(countSummaries);
            return {
                lehrInEffeciency: lehrInEfficiency,
                lehrOutEffeciency: lehrOutEfficiency,
                packPercent: packPercent
            };
        };
        PlantWareLossDashboardController.prototype.getPackPercent = function (countSummaries) {
            var bottlesIn = 0.0;
            var bottlesOut = 0.0;
            var countLen = countSummaries.length || 0;
            if (countLen === 0) {
                return 0.0;
            }
            var lastItem = countSummaries[countLen - 1];
            bottlesIn = countSummaries[0].inspectCount;
            bottlesOut = (lastItem.rejectCount && lastItem.rejectCount > 0.0)
                ? lastItem.inspectCount - lastItem.rejectCount
                : lastItem.inspectCount;
            return (bottlesOut / bottlesIn) * 100.0;
        };
        PlantWareLossDashboardController.prototype.getBottlesOut = function (countSummaries) {
            var bottlesOut = 0.0;
            var countLen = countSummaries.length || 0;
            if (countLen === 0) {
                return 0.0;
            }
            var lastItem = countSummaries[countLen - 1];
            bottlesOut = (lastItem.rejectCount && lastItem.rejectCount > 0.0)
                ? lastItem.inspectCount - lastItem.rejectCount
                : lastItem.inspectCount;
            return bottlesOut;
        };
        PlantWareLossDashboardController.prototype.getLocationLosses = function (countSummaries) {
            var heItem = this.getHotEndSummary(countSummaries);
            var lehrItem = this.getLehrSummary(countSummaries);
            var coldEndRejectCount = this.getColdEndInspectionLoss(countSummaries);
            var coldEndInspectionPercent = (coldEndRejectCount / heItem.inspectCount * 100) || 0.0;
            var bottlesOut = this.getBottlesOut(countSummaries);
            var lehrOut = (lehrItem.inspectCount - lehrItem.rejectCount) || 0.0;
            var coldEndDelta = ((lehrOut - bottlesOut - coldEndRejectCount) / heItem.inspectCount * 100) || 0.0;
            var coldEndTotal = ((lehrOut - bottlesOut) / heItem.inspectCount * 100) || 0.0;
            var hotEndLoss = (heItem.inspectCount - lehrItem.inspectCount) / heItem.inspectCount * 100 || 0.0;
            return {
                hotEndLoss: hotEndLoss,
                lehrLoss: lehrItem.rejectPercent,
                coldEndTotal: coldEndTotal,
                coldEndInspection: coldEndInspectionPercent,
                coldEndDelta: coldEndDelta
            };
        };
        PlantWareLossDashboardController.prototype.getLehrSummary = function (countSummaries) {
            var lehrItem = _.findLast(countSummaries, function (c) {
                return c.name === 'LEHR';
            });
            if (!lehrItem) {
                lehrItem = {
                    name: 'LEHR',
                    inspectCount: 0.0,
                    rejectCount: 0.0,
                    rejectPercent: 0.0,
                    equipmentCounts: [],
                };
            }
            return lehrItem;
        };
        PlantWareLossDashboardController.prototype.getHotEndSummary = function (countSummaries) {
            var heItem = _.findLast(countSummaries, function (c) {
                return c.name === 'HE' || c.name === 'CUTS';
            });
            if (!heItem) {
                heItem = {
                    name: 'HE',
                    inspectCount: 0.0,
                    rejectCount: 0.0,
                    rejectPercent: 0.0,
                    equipmentCounts: [],
                };
            }
            return heItem;
        };
        PlantWareLossDashboardController.prototype.getColdEndInspectionLoss = function (countSummaries) {
            var inspectionLoss = 0.0;
            var inspectionEquipmentItems = this.getColdEndInspectionItems(countSummaries);
            if (inspectionEquipmentItems && inspectionEquipmentItems.length > 0) {
                _.forEach(inspectionEquipmentItems, function (cs) {
                    if (cs.rejectCount) {
                        inspectionLoss += cs.rejectCount;
                    }
                });
            }
            return inspectionLoss;
        };
        PlantWareLossDashboardController.prototype.getColdEndDeltaLoss = function (countSummaries) {
            var coldEndDeltaCount = 0.0;
            var inspectionLoss = 0.0;
            var coldEndOut = 0.0;
            var coldEndInspected = 0.0;
            var coldEndInspectionEquipmentItems = this.getColdEndInspectionItems(countSummaries);
            if (coldEndInspectionEquipmentItems && coldEndInspectionEquipmentItems.length > 0) {
                coldEndInspected = coldEndInspectionEquipmentItems[0].inspectCount;
                var countLen = countSummaries.length;
                var lastItem = countSummaries[countLen - 1];
                coldEndOut = (lastItem.rejectCount && lastItem.rejectCount > 0.0)
                    ? lastItem.inspectCount - lastItem.rejectCount
                    : lastItem.inspectCount;
            }
            if (coldEndInspectionEquipmentItems && coldEndInspectionEquipmentItems.length > 0) {
                _.forEach(coldEndInspectionEquipmentItems, function (cs) {
                    inspectionLoss += cs.rejectCount;
                });
            }
            coldEndDeltaCount = (coldEndInspected - coldEndOut) - inspectionLoss;
            return (coldEndDeltaCount / coldEndInspected) * 100;
        };
        PlantWareLossDashboardController.prototype.getColdEndInspectionItems = function (countSummaries) {
            var coldEndInspectionItems = _.filter(countSummaries, function (cs) {
                return cs.name !== "HE" && cs.name !== "CUTS" && cs.name !== "LEHR";
            });
            return coldEndInspectionItems;
        };
        PlantWareLossDashboardController.prototype.getHotEndItem = function (countSummaries) {
            var hotEndItem = _.findLast(countSummaries, function (cs) {
                return cs.name === "HE" || cs.name === "CUTS";
            });
            return hotEndItem;
        };
        PlantWareLossDashboardController.prototype.getLehrItem = function (countSummaries) {
            var lehrItem = _.findLast(countSummaries, function (cs) {
                return cs.name === "LEHR" || cs.name === "L-L";
            });
            return lehrItem;
        };
        PlantWareLossDashboardController.prototype.getCavityCorrelations = function (cavitiesFromRequest, cavityLocation) {
            var _this = this;
            var cavityCorrelation = [];
            _.forEach(cavitiesFromRequest, function (cavityInfo) {
                if (cavityInfo.cavity.indexOf(cavityLocation) > -1 && cavityInfo.cavity !== "M+U") {
                    var cavityName = cavityInfo.cavity;
                    var color = _this.getCorrelationColor(cavityInfo.inspectCount, cavityInfo.rejectCount);
                    var cavityItem = {
                        cavityName: cavityName,
                        color: color
                    };
                    cavityCorrelation.push(cavityItem);
                }
            });
            return cavityCorrelation;
        };
        PlantWareLossDashboardController.prototype.getCorrelationColor = function (inspectCount, rejectCount) {
            var color = '000000';
            var effeciencyPercent = 100 * (rejectCount / inspectCount) || 0.0;
            if (effeciencyPercent || effeciencyPercent === 0.0) {
                color = this.uiUtilityService.getCavityCorrelationColor(effeciencyPercent) + 'A0';
            }
            return color;
        };
        PlantWareLossDashboardController.prototype.getEquipmentCounts = function (countSummaries) {
            var equipmentCounts = [];
            _.forEach(countSummaries, function (equipCount) {
                if (equipCount.name !== "HE" && equipCount.name !== "CUTS"
                    && equipCount.name !== "LEHR" && equipCount.rejectPercent) {
                    var eqCount = {
                        name: equipCount.name,
                        percentLoss: equipCount.rejectPercent
                    };
                    equipmentCounts.push(eqCount);
                }
            });
            return equipmentCounts;
        };
        PlantWareLossDashboardController.prototype.countsIntervalChanged = function () {
            var _this = this;
            this.mapCountInterval();
            var dataPromise = this.plantWareLossService
                .getPlantWareLoss(this.plantId, this.startDate, this.endDate)
                .then(function (plantWareLossType) {
                _this.mapPlantWareLossType(plantWareLossType);
            });
            this.loaderService.loadingPromise(dataPromise);
        };
        return PlantWareLossDashboardController;
    }());
    exports.PlantWareLossDashboardController = PlantWareLossDashboardController;
    exports.default = angular.module('aps.controller.plantWareLossDashboard', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.PLANT_WARE_LOSS_DASHBOARD,
            url: '/plantWareLossDashboard',
            controller: 'PlantWareLossDashboardCtrl as vm',
            template: plantWareLossDashboard_tpl_html_1.default,
            data: {
                pageTitle: 'Plant Ware Loss Dashboard'
            }
        });
    }])
        .controller('PlantWareLossDashboardCtrl', PlantWareLossDashboardController)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=container-fluid> <div class=row-flex> <div class=col-md-3> <h4>{{vm.plantName}} - Plant Ware Loss</h4> </div> <div class=col-md-3> <!-- <label style=\"margin-top: 1em;\"> --> <label style=margin-top:5px> Viewing Count Data For: <select style=width:120px id=countsInterval ng-model=vm.countsInterval ng-options=\"t.value as t.text for t in vm.countDisplayIntervalOptions\" ng-change=vm.countsIntervalChanged()></select> </label> </div> </div> <div ng-if=\"vm.plantWareLossInfo && vm.plantWareLossInfo.length > 0\"> <div class=row-flex> <div class=col-md-3 ng-repeat=\"shopWareLoss in vm.plantWareLossInfo\"> <div style=text-align:center> <h5> <strong>Shop: {{shopWareLoss.shopName}}</strong> </h5> </div> <div style=\"border-right:1px solid #d3d3d3;border-left:1px solid #d3d3d3;border-top:1px solid #d3d3d3\"> <!-- cavity correlation table --> <table style=width:100%> <tbody> <tr ng-if=\"shopWareLoss.backCavities && shopWareLoss.backCavities.length > 0\"> <td ng-repeat=\"cavity in shopWareLoss.backCavities\" style=\"border:1px solid #000;background-color: {{cavity.color}}\"> <div style=height:15px></div> </td> </tr> <tr ng-if=\"shopWareLoss.middleCavities && shopWareLoss.middleCavities.length > 0\"> <td ng-repeat=\"cavity in shopWareLoss.middleCavities\" style=\"border:1px solid #000;background-color: {{cavity.color}}\"> <div style=height:15px></div> </td> </tr> <tr ng-if=\"shopWareLoss.frontCavities && shopWareLoss.frontCavities.length > 0\"> <td ng-repeat=\"cavity in shopWareLoss.frontCavities\" style=\"border:1px solid #000;background-color: {{cavity.color}}\"> <div style=height:15px></div> </td> </tr> </tbody> </table> <!-- area effeciency table --> <table class=history-t style=\"border-bottom:1px solid #d3d3d3\"> <caption> <b>Area Effeciency</b> </caption> <thead> <tr> <th>Area</th> <th style=text-align:right>% Effeciency</th> </tr> </thead> <tbody> <tr> <td>Shears</td> <td style=text-align:right> 100.00 % </td> </tr> <tr> <td>Lehr In %</td> <td style=text-align:right> {{shopWareLoss.areaEffeciency.lehrInEffeciency | number : 2}} % </td> </tr> <tr> <td>Lehr Out %</td> <td style=text-align:right> {{shopWareLoss.areaEffeciency.lehrOutEffeciency | number : 2}} % </td> </tr> <tr> <td><b>Pack Percent</b></td> <td style=text-align:right> <b>{{shopWareLoss.areaEffeciency.packPercent | number : 2}} %</b> </td> </tr> </tbody> </table> <!-- location losses table --> <table class=history-t style=\"border-bottom:1px solid #d3d3d3\"> <caption> <b>Location Losses</b> </caption> <thead> <tr> <th>Location</th> <th style=text-align:right>% Losses</th> </tr> </thead> <tbody> <tr> <td>Hot-End</td> <td style=text-align:right> {{shopWareLoss.locationLosses.hotEndLoss | number : 2}} % </td> </tr> <tr> <td>Lehr</td> <td style=text-align:right> {{shopWareLoss.locationLosses.lehrLoss | number : 2}} % </td> </tr> <tr> <td>Cold-End Total</td> <td style=text-align:right> {{shopWareLoss.locationLosses.coldEndTotal | number : 2}} % </td> </tr> <tr> <td>&nbsp;&nbsp;Cold-End Inspection</td> <td style=text-align:right> {{shopWareLoss.locationLosses.coldEndInspection | number : 2}} % </td> </tr> <tr> <td>&nbsp;&nbsp;Cold-End Delta</td> <td style=text-align:right> {{shopWareLoss.locationLosses.coldEndDelta | number : 2}} % </td> </tr> </tbody> </table> <!-- equipment losses table --> <table class=history-t style=\"border-bottom:1px solid #d3d3d3\"> <caption> <b>Equipment Losses</b> </caption> <thead> <tr> <th>Equipment</th> <th style=text-align:right>% Losses</th> </tr> </thead> <tbody> <tr ng-repeat=\"equipment in shopWareLoss.equipmentCounts\"> <td>{{equipment.name}}</td> <td style=text-align:right>{{equipment.percentLoss | number : 2}} %</td> </tr> </tbody> </table> </div> <br/> <br/> </div> </div> </div> </div>");

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PlantWareLossServiceImpl = (function () {
        PlantWareLossServiceImpl.$inject = ["httpService"];
        function PlantWareLossServiceImpl(httpService) {
            this.httpService = httpService;
        }
        PlantWareLossServiceImpl.prototype.getPlantWareLoss = function (plantId, startDate, endDate) {
            return this.httpService.get(constant_module_1.Endpoints.PLANT_WARE_LOSS_DASHBOARD, {
                plantId: plantId,
                startDate: startDate,
                endDate: endDate
            });
        };
        return PlantWareLossServiceImpl;
    }());
    exports.default = angular
        .module('aps.services.plantWareLossService', [http_service_1.default])
        .service('plantWareLossService', PlantWareLossServiceImpl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(638), __webpack_require__(3), __webpack_require__(9), __webpack_require__(23), __webpack_require__(4), __webpack_require__(34), __webpack_require__(27), __webpack_require__(50), __webpack_require__(7), __webpack_require__(1), __webpack_require__(639)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, shopOperatorDashboard_tpl_html_1, constant_module_1, uiUtility_service_1, shops_service_1, loader_service_1, Highcharts, enums_1, interval_factory_1, authData_service_1, moment, shopOperator_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [
        uiUtility_service_1.default,
        shops_service_1.default,
        loader_service_1.default,
        authData_service_1.default,
        shopOperator_service_1.default
    ];
    var ShopOperatorDashboardController = (function () {
        ShopOperatorDashboardController.$inject = ["$stateParams", "shopService", "loaderService", "$scope", "uiUtilityService", "authDataService", "shopOperatorService", "$state", "$interval", "$q"];
        function ShopOperatorDashboardController($stateParams, shopService, loaderService, $scope, uiUtilityService, authDataService, shopOperatorService, $state, $interval, $q) {
            var _this = this;
            this.interval = null;
            this.plantId = $stateParams.plantId;
            this.shopId = $stateParams.shopId;
            this.loaderService = loaderService;
            this.shopService = shopService;
            this.shopOperatorService = shopOperatorService;
            this.shopName = null;
            this.plantName = null;
            this.$state = $state;
            this.$scope = $scope;
            this.$interval = $interval;
            this.uiUtilityService = uiUtilityService;
            this.authDataService = authDataService;
            this.$q = $q;
            this.$scope.$on('$destroy', function () {
                _this.destroyInterval();
            });
            this.createInterval();
            this.initPage();
        }
        ShopOperatorDashboardController.prototype.initPage = function () {
            var _this = this;
            this.loaderService.setAppLoading(true);
            this.shopService.getShopConfiguration(this.shopId).then(function (shop) {
                _this.shopName = shop.name;
                _this.plantName = shop.plantName;
                _this.shopConfig = shop;
            })
                .then(function () {
                _this.countDisplayIntervalOptions = _this.uiUtilityService
                    .getListOptionsFromEnum(enums_1.apsDisplayEnums.CountDisplayInterval, null, null, function (o) { return o; });
            })
                .then(function () {
                _this.countsInterval = _this.authDataService.getCountInterval();
                _this.mapCountInterval();
            })
                .then(function () {
                _this.shopOperatorService
                    .getShopOperator(_this.shopId, _this.startDate, _this.endDate)
                    .then(function (result) {
                    _this.mapShopOperatorResult(result);
                    _this.loaderService.setAppLoading(false);
                });
            });
        };
        ShopOperatorDashboardController.prototype.mapShopOperatorResult = function (result) {
            var backCavities = this.getCavityCorrelations(result.cavityCorrelations, 'B');
            var middleCavities = this.getCavityCorrelations(result.cavityCorrelations, 'M');
            var frontCavities = this.getCavityCorrelations(result.cavityCorrelations, 'F');
            var areaPercent = this.getAreaPercent(result.countSummaries);
            var heSummary = this.getHotEndSummary(result.countSummaries);
            var lossTypeInfo = this.getLossTypeInfo(result.lossTypeSummary, heSummary.inspectCount);
            var bottlesPerMinute = result.bottlesPerMinute || 0;
            this.shopOperatorInfo = {
                backCavities: backCavities,
                middleCavities: middleCavities,
                frontCavities: frontCavities,
                areaPercent: areaPercent,
                lossTypeInfo: lossTypeInfo,
                bottlesPerMinute: bottlesPerMinute
            };
            this.mapSwabbingData(result.swabbingTrendSummary);
        };
        ShopOperatorDashboardController.prototype.getLossTypeValue = function (lossTypeSummary, lossTypeName, heInspect) {
            var item = _.find(lossTypeSummary.details, function (x) {
                if (x.lossTypeName === lossTypeName) {
                    return true;
                }
                return false;
            });
            var value = (item && item.rejectCount && heInspect)
                ? (item.rejectCount / heInspect) * 100
                : 0.0;
            return value;
        };
        ShopOperatorDashboardController.prototype.getLossTypeInfo = function (lossTypeSummary, heInspect) {
            var checkLosses = this.getLossTypeValue(lossTypeSummary, 'Checks', heInspect);
            var dimensionalLosses = this.getLossTypeValue(lossTypeSummary, 'Dimensional', heInspect);
            var dipPlugLosses = this.getLossTypeValue(lossTypeSummary, 'Dip/Plug Loss', heInspect);
            var moldLosses = this.getLossTypeValue(lossTypeSummary, 'Mold Loss', heInspect);
            var thinwareLosses = this.getLossTypeValue(lossTypeSummary, 'Thinware Loss', heInspect);
            var topBottomLosses = this.getLossTypeValue(lossTypeSummary, 'Top/Bottom Insp', heInspect);
            var visualLosses = this.getLossTypeValue(lossTypeSummary, 'Visual Loss', heInspect);
            var nonMappedLosses = this.getLossTypeValue(lossTypeSummary, 'Not Mapped', heInspect);
            var lossTypeInfo = {
                checkLosses: checkLosses,
                checkClass: this.getLossTypeClass(checkLosses),
                dimensionalLosses: dimensionalLosses,
                dimensionalClass: this.getLossTypeClass(dimensionalLosses),
                dipPlugLosses: dipPlugLosses,
                dipPlugClass: this.getLossTypeClass(dipPlugLosses),
                moldLosses: moldLosses,
                moldClass: this.getLossTypeClass(moldLosses),
                thinwareLosses: thinwareLosses,
                thinwareClass: this.getLossTypeClass(thinwareLosses),
                topBottomLosses: topBottomLosses,
                topBottomClass: this.getLossTypeClass(topBottomLosses),
                visualLosses: visualLosses,
                visualClass: this.getLossTypeClass(visualLosses),
                nonMappedLosses: nonMappedLosses,
                nonMappedClass: this.getLossTypeClass(nonMappedLosses),
            };
            return lossTypeInfo;
        };
        ShopOperatorDashboardController.prototype.getLossTypeClass = function (checkLosses) {
            var lossTypeClass = 'bg-success';
            if (checkLosses > 1.0) {
                lossTypeClass = 'bg-warning';
            }
            if (checkLosses > 2.0) {
                lossTypeClass = 'bg-danger';
            }
            return lossTypeClass;
        };
        ShopOperatorDashboardController.prototype.getCavityCorrelations = function (cavitiesFromRequest, cavityLocation) {
            var _this = this;
            var cavityCorrelation = [];
            _.forEach(cavitiesFromRequest, function (cavityInfo) {
                if (cavityInfo.cavity.indexOf(cavityLocation) > -1 && cavityInfo.cavity !== "M+U") {
                    var cavityName = cavityInfo.cavity;
                    var color = _this.getCorrelationColor(cavityInfo.inspectCount, cavityInfo.rejectCount);
                    var cavityValue = _this.getCavityValue(cavityInfo.inspectCount, cavityInfo.rejectCount);
                    var cavityItem = {
                        cavityName: cavityName,
                        color: color,
                        cavityValue: cavityValue
                    };
                    cavityCorrelation.push(cavityItem);
                }
            });
            return cavityCorrelation;
        };
        ShopOperatorDashboardController.prototype.getCavityValue = function (inspectCount, rejectCount) {
            var value = 0.0;
            if (inspectCount && rejectCount) {
                value = 100 * (rejectCount / inspectCount) || 0.0;
            }
            return value.toFixed(2);
        };
        ShopOperatorDashboardController.prototype.getCorrelationColor = function (inspectCount, rejectCount) {
            var color = '000000';
            var effeciencyPercent = 100 * (rejectCount / inspectCount) || 0.0;
            if (effeciencyPercent || effeciencyPercent === 0.0) {
                color = this.uiUtilityService.getCavityCorrelationColor(effeciencyPercent) + 'A0';
            }
            return color;
        };
        ShopOperatorDashboardController.prototype.getAreaPercent = function (countSummaries) {
            var heSummary = this.getHotEndSummary(countSummaries);
            var lehrSummary = this.getLehrSummary(countSummaries);
            var lehrInPercent = (lehrSummary.inspectCount / heSummary.inspectCount * 100) || 0.0;
            var lehrOutPercent = ((lehrSummary.inspectCount - lehrSummary.rejectCount) / heSummary.inspectCount * 100) || 0.0;
            ;
            var packPercent = this.getPackPercent(countSummaries);
            return {
                lehrInPercent: lehrInPercent,
                lehrInPercentClass: this.getLehrPercentClass(lehrInPercent),
                lehrOutPercent: lehrOutPercent,
                lehrOutPercentClass: this.getLehrPercentClass(lehrOutPercent),
                packPercent: packPercent,
                packPercentClass: this.getPackPercentClass(packPercent)
            };
        };
        ShopOperatorDashboardController.prototype.getHotEndSummary = function (countSummaries) {
            var heItem = _.findLast(countSummaries, function (c) {
                return c.name === 'HE' || c.name === 'CUTS';
            });
            if (!heItem) {
                heItem = {
                    name: 'HE',
                    inspectCount: 0.0,
                    rejectCount: 0.0,
                    rejectPercent: 0.0,
                    equipmentCounts: [],
                };
            }
            return heItem;
        };
        ShopOperatorDashboardController.prototype.getLehrSummary = function (countSummaries) {
            var lehrItem = _.findLast(countSummaries, function (c) {
                return c.name === 'LEHR';
            });
            if (!lehrItem) {
                lehrItem = {
                    name: 'LEHR',
                    inspectCount: 0.0,
                    rejectCount: 0.0,
                    rejectPercent: 0.0,
                    equipmentCounts: [],
                };
            }
            return lehrItem;
        };
        ShopOperatorDashboardController.prototype.getPackPercentClass = function (packPercent) {
            var styleClass = 'bg-success';
            if (packPercent && packPercent < 95) {
                styleClass = 'bg-warning';
            }
            if (packPercent && packPercent < 90) {
                styleClass = 'bg-danger';
            }
            return styleClass;
        };
        ShopOperatorDashboardController.prototype.getLehrPercentClass = function (lehrPercent) {
            var styleClass = 'bg-success';
            if (lehrPercent && lehrPercent < 98.5) {
                styleClass = 'bg-warning';
            }
            if (lehrPercent && lehrPercent < 97) {
                styleClass = 'bg-danger';
            }
            return styleClass;
        };
        ShopOperatorDashboardController.prototype.getPackPercent = function (countSummaries) {
            var bottlesIn = 0.0;
            var bottlesOut = 0.0;
            var countLen = countSummaries.length || 0;
            if (countLen === 0) {
                return 0.0;
            }
            var lastItem = countSummaries[countLen - 1];
            bottlesIn = countSummaries[0].inspectCount;
            bottlesOut = (lastItem.rejectCount && lastItem.rejectCount > 0.0)
                ? lastItem.inspectCount - lastItem.rejectCount
                : lastItem.inspectCount;
            return (bottlesOut / bottlesIn) * 100.0;
        };
        ShopOperatorDashboardController.prototype.getColdEndInspectionLoss = function (countSummaries) {
            var inspectionLoss = 0.0;
            var inspectionEquipmentItems = this.getColdEndInspectionItems(countSummaries);
            if (inspectionEquipmentItems && inspectionEquipmentItems.length > 0) {
                var totalInspected_1 = 0.0;
                var totalRejected_1 = 0.0;
                _.forEach(inspectionEquipmentItems, function (cs) {
                    totalInspected_1 += cs.inspectCount;
                    totalRejected_1 += cs.rejectCount;
                });
                inspectionLoss = (totalRejected_1 / totalInspected_1) * 100;
            }
            return inspectionLoss;
        };
        ShopOperatorDashboardController.prototype.getColdEndInspectionItems = function (countSummaries) {
            var coldEndInspectionItems = _.filter(countSummaries, function (cs) {
                return cs.name !== "HE" && cs.name !== "CUTS" && cs.name !== "LEHR"
                    && cs.name !== "EOL" && cs.name !== "TOTL" && cs.name !== "LOut"
                    && cs.name !== "CP" && cs.name !== "SPRY" && cs.name !== "STKR";
            });
            return coldEndInspectionItems;
        };
        ShopOperatorDashboardController.prototype.getHotEndLoss = function (countSummaries) {
            var heLosses = 0.0;
            var heItem = _.findLast(countSummaries, function (c) {
                return c.name === 'HE' || c.name === 'CUTS';
            });
            if (heItem && heItem.inspectCount && heItem.rejectCount) {
                heLosses = (heItem.rejectCount / heItem.inspectCount) * 100;
            }
            return heLosses;
        };
        ShopOperatorDashboardController.prototype.mapSwabbingData = function (swabbingTrendSummary) {
            this.chartOptions = this.getChartOptions(swabbingTrendSummary);
            Highcharts.chart('container', this.chartOptions);
        };
        ShopOperatorDashboardController.prototype.countsIntervalChanged = function () {
            this.mapCountInterval();
            this.update();
        };
        ShopOperatorDashboardController.prototype.update = function () {
            var _this = this;
            this.loaderService.setAppLoading(true);
            this.shopOperatorService
                .getShopOperator(this.shopId, this.startDate, this.endDate)
                .then(function (result) {
                _this.mapShopOperatorResult(result);
                _this.loaderService.setAppLoading(false);
            });
        };
        ShopOperatorDashboardController.prototype.createInterval = function () {
            var _this = this;
            this.interval = new interval_factory_1.Interval(function () {
                _this.update();
            }, this.$interval, 1000 * 60 * 5);
            this.interval.start();
        };
        ShopOperatorDashboardController.prototype.destroyInterval = function () {
            this.interval.destroy();
            this.interval = null;
        };
        ShopOperatorDashboardController.prototype.mapCountInterval = function () {
            this.authDataService.setCountInterval(this.countsInterval);
            this.endDate = moment().toDate();
            var now = moment();
            var remainderMinutes = now.minute() % 10;
            var remainderSeconds = now.second();
            var remainderMilliSeconds = now.millisecond();
            switch (this.countsInterval) {
                case enums_1.apsDisplayEnums.CountDisplayInterval.CurrentHour:
                    this.startDate = moment().startOf('hour').toDate();
                    break;
                case enums_1.apsDisplayEnums.CountDisplayInterval.PreviousHour:
                    this.endDate = moment().startOf('hour').toDate();
                    this.startDate = moment(this.endDate).subtract(1, 'hour').toDate();
                    break;
                case enums_1.apsDisplayEnums.CountDisplayInterval.CurrentShift:
                    this.startDate = this.shopConfig.shiftsInLast24Hours[0].startTime;
                    break;
                case enums_1.apsDisplayEnums.CountDisplayInterval.LastShift:
                    this.endDate = this.shopConfig.shiftsInLast24Hours[1].stopTime;
                    this.startDate = this.shopConfig.shiftsInLast24Hours[1].startTime;
                    break;
                case enums_1.apsDisplayEnums.CountDisplayInterval.ShiftBeforeLast:
                    this.endDate = this.shopConfig.shiftsInLast24Hours[2].stopTime;
                    this.startDate = this.shopConfig.shiftsInLast24Hours[2].startTime;
                    break;
                case enums_1.apsDisplayEnums.CountDisplayInterval.RollingHour:
                    this.endDate = moment(now)
                        .subtract(remainderMinutes, 'minute')
                        .subtract(remainderSeconds, 'second')
                        .subtract(remainderMilliSeconds, 'millisecond')
                        .toDate();
                    this.startDate = moment(this.endDate)
                        .subtract(1, 'hour')
                        .toDate();
                    break;
                case enums_1.apsDisplayEnums.CountDisplayInterval.LastTwentyMinutes:
                    this.endDate = moment(now)
                        .subtract(remainderMinutes, 'minute')
                        .subtract(remainderSeconds, 'second')
                        .subtract(remainderMilliSeconds, 'millisecond')
                        .toDate();
                    this.startDate = moment(this.endDate)
                        .subtract(20, 'minute')
                        .toDate();
                    break;
                default:
                    this.endDate = moment().startOf('hour').toDate();
                    this.startDate = moment(this.endDate).subtract(1, 'days').toDate();
                    break;
            }
        };
        ShopOperatorDashboardController.prototype.getSampleData = function (details) {
            var sampleSeries = [];
            details.forEach(function (x) {
                var dateTime = new Date(x.isoTimeStamp);
                var datapoint = {
                    x: moment(dateTime).toDate().getTime(),
                    y: x.count
                };
                sampleSeries.push(datapoint);
            });
            return sampleSeries;
        };
        ShopOperatorDashboardController.prototype.getSeries = function (swabbingTrendSummary) {
            var _this = this;
            var seriesData = [];
            swabbingTrendSummary.forEach(function (x) {
                var item = {
                    name: 'Section ' + x.section,
                    data: _this.getSampleData(x.details),
                    legendIndex: x.section
                };
                seriesData.push(item);
            });
            return seriesData;
        };
        ShopOperatorDashboardController.prototype.getChartOptions = function (swabbingTrendSummary) {
            var seriesData = this.getSeries(swabbingTrendSummary);
            return {
                chart: {
                    zoomType: 'x'
                },
                time: {
                    useUTC: false
                },
                title: {
                    text: ''
                },
                yAxis: {
                    title: {
                        text: 'Number of Gobs Lost'
                    }
                },
                xAxis: {
                    type: 'datetime',
                    title: {
                        text: 'Date/Time'
                    },
                    dateTimeLabelFormats: {
                        second: '%l:%M:%S %p',
                        minute: '%l:%M %p',
                        hour: '%l %p',
                        day: '%m/%d/%Y',
                        month: '%m/%d/%Y',
                        year: '%m/%d/%Y'
                    }
                },
                tooltip: {
                    xDateFormat: '%m/%d/%Y %l:%M %p'
                },
                legend: {
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'middle'
                },
                plotOptions: {
                    series: {
                        marker: {
                            enabled: false
                        }
                    }
                },
                series: seriesData,
                credits: {
                    enabled: false
                },
                responsive: {
                    rules: [{
                            condition: {
                                maxWidth: 500
                            },
                            chartOptions: {
                                legend: {
                                    layout: 'horizontal',
                                    align: 'center',
                                    verticalAlign: 'bottom'
                                }
                            }
                        }]
                }
            };
        };
        return ShopOperatorDashboardController;
    }());
    exports.ShopOperatorDashboardController = ShopOperatorDashboardController;
    exports.default = angular.module('aps.controller.shopOperatorDashboard', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.SHOP_OPERATOR_DASHBOARD,
            url: '/shopOperatorDashboard',
            controller: 'ShopOperatorDashboardCtrl as vm',
            template: shopOperatorDashboard_tpl_html_1.default,
            data: {
                pageTitle: 'Shop Operator Dashboard'
            }
        });
    }])
        .controller('ShopOperatorDashboardCtrl', ShopOperatorDashboardController)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=container-fluid> <div class=row-flex> <div class=col-md-3> <h4>Shop {{vm.shopName}} - Operator Dashboard</h4> </div> <div class=col-md-3> <label style=margin-top:5px> Viewing Count Data For: <select style=width:120px id=countsInterval ng-model=vm.countsInterval ng-options=\"t.value as t.text for t in vm.countDisplayIntervalOptions\" ng-change=vm.countsIntervalChanged()></select> </label> </div> </div> <!-- Area Efficiency data --> <div class=row-flex> <div class=col-lg-3> <div class=\"card text-white border-dark mb-3 text-center\"> <div class=card-header> <h4><b>Machine Speed</b></h4> </div> <div class=card-body> <h4 class=card-title><b>{{vm.shopOperatorInfo.bottlesPerMinute | number : 0 }} BPM</b></h4> </div> </div> <br/> </div> <div class=col-lg-3> <div class=\"card text-center\" ng-class=vm.shopOperatorInfo.areaPercent.lehrInPercentClass> <div class=card-header> <h4><b>Lehr In %</b></h4> </div> <div class=card-body> <h3 class=card-title><b>{{vm.shopOperatorInfo.areaPercent.lehrInPercent | number : 2}} %</b></h3> </div> </div> <br/> </div> <div class=col-lg-3> <div class=\"card text-center\" ng-class=vm.shopOperatorInfo.areaPercent.lehrOutPercentClass> <div class=card-header> <h4><b>Lehr Out %</b></h4> </div> <div class=card-body> <h3 class=card-title><b>{{vm.shopOperatorInfo.areaPercent.lehrOutPercent | number : 2}} %</b></h3> </div> </div> <br/> </div> <div class=col-lg-3> <div class=\"card text-center\" ng-class=vm.shopOperatorInfo.areaPercent.packPercentClass> <div class=card-header> <h4><b>Pack %</b></h4> </div> <div class=card-body> <h3 class=card-title><b>{{vm.shopOperatorInfo.areaPercent.packPercent | number : 2}} %</b></h3> </div> </div> <br/> </div> </div> <hr/> <!-- cavity correlation and swabbing data --> <div class=row-flex> <!-- cavity correlation --> <div class=col-lg-6> <div class=\"text-center col-lg-12\"> <h4>Cavity Correlation</h4> </div> <!-- cavity correlation table --> <table style=width:100%;height:225px> <tbody> <tr ng-if=\"vm.shopOperatorInfo.backCavities && vm.shopOperatorInfo.backCavities.length > 0\"> <td ng-repeat=\"cavity in vm.shopOperatorInfo.backCavities\" style=\"border:1px solid #000;background-color: {{cavity.color}}\"> <div class=text-center> <p> <b> {{cavity.cavityValue}} </b> </p> </div> </td> </tr> <tr ng-if=\"vm.shopOperatorInfo.middleCavities && vm.shopOperatorInfo.middleCavities.length > 0\"> <td ng-repeat=\"cavity in vm.shopOperatorInfo.middleCavities\" style=\"border:1px solid #000;background-color: {{cavity.color}}\"> <div class=text-center> <p> <b> {{cavity.cavityValue}} </b> </p> </div> </td> </tr> <tr ng-if=\"vm.shopOperatorInfo.frontCavities && vm.shopOperatorInfo.frontCavities.length > 0\"> <td ng-repeat=\"cavity in vm.shopOperatorInfo.frontCavities\" style=\"border:1px solid #000;background-color: {{cavity.color}}\"> <div class=text-center> <p> <b> {{cavity.cavityValue}} </b> </p> </div> </td> </tr> </tbody> </table> </div> <!-- swabbing chart --> <div class=col-lg-6> <div class=\"text-center col-lg-12\"> <h4>Gobs Lost to Swabbing</h4> </div> <div id=container style=width:100%;height:250px></div> </div> </div> <hr/> <!-- defect mapping loss types --> <div class=row-flex> <div class=\"text-center col-lg-12\"> <h4>Loss Type by Defect Mapping</h4> </div> <div class=\"card-group col-lg-12\"> <div class=\"card text-center\"> <div class=card-header> <h4><b>Checks</b></h4> </div> <div class=card-body ng-class=vm.shopOperatorInfo.lossTypeInfo.checkClass> <h3 class=card-title><b>{{vm.shopOperatorInfo.lossTypeInfo.checkLosses | number : 2}} %</b></h3> </div> </div> <div class=\"card text-center\"> <div class=card-header> <h4><b>Dimensional</b></h4> </div> <div class=card-body ng-class=vm.shopOperatorInfo.lossTypeInfo.dimensionalClass> <h3 class=card-title><b>{{vm.shopOperatorInfo.lossTypeInfo.dimensionalLosses | number : 2}} %</b></h3> </div> </div> <div class=\"card text-center\"> <div class=card-header> <h4><b>Dip/Plug</b></h4> </div> <div class=card-body ng-class=vm.shopOperatorInfo.lossTypeInfo.dipPlugClass> <h3 class=card-title><b>{{vm.shopOperatorInfo.lossTypeInfo.dipPlugLosses | number : 2}} %</b></h3> </div> </div> <div class=\"card text-center\"> <div class=card-header> <h4><b>Mold</b></h4> </div> <div class=card-body ng-class=vm.shopOperatorInfo.lossTypeInfo.moldClass> <h3 class=card-title><b>{{vm.shopOperatorInfo.lossTypeInfo.moldLosses | number : 2}} %</b></h3> </div> </div> <div class=\"card text-center\"> <div class=card-header> <h4><b>Thinware</b></h4> </div> <div class=card-body ng-class=vm.shopOperatorInfo.lossTypeInfo.thinwareClass> <h3 class=card-title><b>{{vm.shopOperatorInfo.lossTypeInfo.thinwareLosses | number : 2}} %</b></h3> </div> </div> <div class=\"card text-center\"> <div class=card-header> <h4><b>Top/Bottom</b></h4> </div> <div class=card-body ng-class=vm.shopOperatorInfo.lossTypeInfo.topBottomClass> <h3 class=card-title><b>{{vm.shopOperatorInfo.lossTypeInfo.topBottomLosses | number : 2}} %</b></h3> </div> </div> <div class=\"card text-center\"> <div class=card-header> <h4><b>Visual</b></h4> </div> <div class=card-body ng-class=vm.shopOperatorInfo.lossTypeInfo.visualClass> <h3 class=card-title><b>{{vm.shopOperatorInfo.lossTypeInfo.visualLosses | number : 2}} %</b></h3> </div> </div> <div class=\"card text-center\"> <div class=card-header> <h4><b>Not Mapped</b></h4> </div> <div class=card-body ng-class=vm.shopOperatorInfo.lossTypeInfo.nonMappedClass> <h3 class=card-title><b>{{vm.shopOperatorInfo.lossTypeInfo.nonMappedLosses | number : 2}} %</b></h3> </div> </div> </div> </div> </div> <br/> <br/> ");

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ShopOperatorServiceImpl = (function () {
        ShopOperatorServiceImpl.$inject = ["httpService"];
        function ShopOperatorServiceImpl(httpService) {
            this.httpService = httpService;
        }
        ShopOperatorServiceImpl.prototype.getShopOperator = function (shopId, startDate, endDate) {
            return this.httpService.get(constant_module_1.Endpoints.SHOP_OPERATOR_DASHBOARD, {
                shopId: shopId,
                startDate: startDate,
                endDate: endDate
            });
        };
        return ShopOperatorServiceImpl;
    }());
    exports.default = angular
        .module('aps.services.shopOperatorService', [http_service_1.default])
        .service('shopOperatorService', ShopOperatorServiceImpl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(641), __webpack_require__(11), __webpack_require__(16), __webpack_require__(4), __webpack_require__(5), __webpack_require__(8), __webpack_require__(642), __webpack_require__(110), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, plantDashboard_tpl_html_1, dateutility_service_1, report_service_1, loader_service_1, aps_enums_1, navigation_service_1, date_service_1, viewDefect_controller_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [report_service_1.default, loader_service_1.default, navigation_service_1.default, date_service_1.default, viewDefect_controller_1.default];
    var PlantDashboardCtrl = (function () {
        PlantDashboardCtrl.$inject = ["navigationService", "loaderService", "dateService", "reportService", "topDefectsHubCreator", "$scope", "$timeout", "$modal"];
        function PlantDashboardCtrl(navigationService, loaderService, dateService, reportService, topDefectsHubCreator, $scope, $timeout, $modal) {
            var _this = this;
            this.packEfficiency = aps_enums_1.apsEnums.WellKnownCheckType.ShopPackEfficiency;
            this.reportService = reportService;
            this.dateService = dateService;
            this.loaderService = loaderService;
            this.navigationService = navigationService;
            this.$modal = $modal;
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.topDefectsHubCreator = topDefectsHubCreator;
            this.criticalDefectsLoaded = false;
            this.loadData();
            this.hubs = [];
            this.$scope.$on('$destroy', function () {
                _.forEach(_this.hubs, function (hub) { return hub.uninitialize(); });
                _this.hubs = [];
            });
        }
        PlantDashboardCtrl.prototype.onDefectAdded = function (defect) {
            var _this = this;
            if (!this.criticalDefects
                || defect.severity !== aps_enums_1.apsEnums.Severity.Critical
                || this.queryStartUTC.getTime() > defect.timeFound.getTime()) {
                return;
            }
            var shop = _.find(this.plant.shops, { id: defect.shopId });
            if (!shop) {
                return;
            }
            this.$timeout(function () {
                _this.criticalDefects.push(_.assign({ shopName: shop.name }, defect));
            });
        };
        PlantDashboardCtrl.prototype.onDefectRemoved = function (defect) {
            var _this = this;
            if (!this.criticalDefects
                || defect.severity !== aps_enums_1.apsEnums.Severity.Critical
                || this.queryStartUTC.getTime() > defect.timeFound.getTime()) {
                return;
            }
            var existing = _.find(this.criticalDefects, { id: defect.id });
            if (!existing) {
                return;
            }
            this.$timeout(function () {
                _.remove(_this.criticalDefects, existing);
            });
        };
        PlantDashboardCtrl.prototype.loadData = function () {
            var _this = this;
            var loadPromise = this.navigationService.getNavigation()
                .then(function (navModel) {
                var end = _this.dateService.now();
                var start = moment(end).subtract(24, 'hours').toDate();
                var timeZoneId = navModel.selectedPlant.timeZoneId;
                _this.queryEndUTC = dateutility_service_1.default.localToTimeZoneWithSeconds(end, timeZoneId).toDate();
                _this.queryStartUTC = dateutility_service_1.default.localToTimeZoneWithSeconds(start, timeZoneId).toDate();
                _this.plant = navModel.selectedPlant;
                _.forEach(_this.plant.shops, function (shop) {
                    _this.hubs.push(_this.topDefectsHubCreator.createTopDefectsHub(shop.id, function (d) { return _this.onDefectAdded(d); }, function (d) { return _this.onDefectRemoved(d); }));
                });
            })
                .then(function () {
                _this.reportService.getCriticalDefectsReport(_this.plant.id, _this.queryStartUTC).then(function (results) {
                    _this.criticalDefects = results;
                    _this.criticalDefectsLoaded = true;
                });
            });
            this.loaderService.loadingPromise(loadPromise);
        };
        PlantDashboardCtrl.prototype.formatTimeOnly = function (time) {
            return dateutility_service_1.default.formatTimeOnly(time, this.plant.timeZoneId);
        };
        PlantDashboardCtrl.prototype.viewDefect = function (defectId) {
            viewDefect_controller_1.openViewDefect({
                defectId: defectId,
                readOnly: true,
                gob: null,
                canComment: null,
                defect: null,
                plantId: null
            }, this.$modal);
        };
        return PlantDashboardCtrl;
    }());
    exports.default = angular.module('aps.controller.plantDashboard', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.PLANT_DASHBOARD,
            url: '/plant/dashboard',
            controller: 'PlantDashboardCtrl as vm',
            template: plantDashboard_tpl_html_1.default,
            data: {
                pageTitle: 'Plant Snapshot',
                allowPlantLevel: true,
                v2Uri: "aps/dashboard/plant/plant-dashboard",
            }
        });
    }])
        .controller('PlantDashboardCtrl', PlantDashboardCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <div class=body-header style=\"border-bottom:1px solid #ccc;margin-bottom:10px\"><h2>Plant Snapshot - {{ vm.plant.name }}</h2></div> <div> <div class=plant-dash> <h5>Critical Defects</h5> <div class=dashboard-p> <div ng-if=!vm.criticalDefectsLoaded> Loading critical defects. Please wait... </div> <div class=main-table-w ng-if=\"vm.criticalDefectsLoaded && !vm.criticalDefects.length\"> No Critical Defects </div> <div class=main-table-w ng-if=\"vm.criticalDefectsLoaded && vm.criticalDefects.length > 0\" style=padding:0> <table cellpadding=1 cellspacing=1 class=history-t> <thead> <tr> <th>Time</th> <th>Defect</th> <th>Shop</th> <th>Drop</th> </tr> </thead> <tbody> <tr ng-repeat=\"defect in vm.criticalDefects | orderBy:['-timeFound','shopName','defectTypeName','dropName']\" ng-click=vm.viewDefect(defect.id)> <td>{{vm.formatTimeOnly(defect.timeFound)}}</td> <td>{{defect.defectTypeName}} <span ng-if=defect.defectTypeLegacyId>[{{defect.defectTypeLegacyId}}]</span></td> <td>{{defect.shopName}}</td> <td>{{defect.dropName}}</td> </tr> </tbody> </table> </div> </div> </div> <div class=plant-dash> <h5>Pack Efficiency</h5> <div class=dashboard-p> <div ng-if=!vm.plant> Loading pack efficiency. Please wait... </div> <div ng-if=vm.plant> <aps-hourly-check-report plant=vm.plant show-details=false num-hours=24 well-known-check=vm.packEfficiency class=plant-dash style=min-height:auto!important> </aps-hourly-check-report> </div> </div> </div> </div> <div> <div class=plant-dash> <br/> <h5>Top 10 Defects by Shop</h5> <div ng-if=!vm.plant class=dashboard-p> Loading top 10 defects. Please wait... </div> <div class=dashboard-p> <ul class=\"small-block-grid-1 large-block-grid-3\" ng-if=vm.plant> <li ng-repeat=\"shop in vm.plant.shops | orderBy: 'name'\"> <aps-top-defects shop=shop query-start=vm.queryStartUTC max-defects=10 plant-time-zone-id=vm.plant.timeZoneId> </aps-top-defects> </li> </ul> </div> </div> </div> </div>");

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var DateSvc = (function () {
        function DateSvc() {
        }
        DateSvc.prototype.now = function () {
            return new Date();
        };
        return DateSvc;
    }());
    exports.default = angular
        .module('date', [])
        .service('dateService', DateSvc)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(3), __webpack_require__(5), __webpack_require__(644), __webpack_require__(646), __webpack_require__(6), __webpack_require__(4), __webpack_require__(25), __webpack_require__(648), __webpack_require__(649), __webpack_require__(651)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, constant_module_1, aps_enums_1, addDefectCause_controller_1, addDefectType_controller_1, notify_service_1, loader_service_1, defectType_service_1, defectTypes_tpl_html_1, editDefectType_controller_1, editDefectCause_controller_1) {
    "use strict";
    defectTypesCtrl.$inject = ["$modal", "notifyService", "loaderService", "defectTypeService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [addDefectCause_controller_1.default, addDefectType_controller_1.default, editDefectType_controller_1.default, notify_service_1.default, loader_service_1.default,
        defectType_service_1.default, editDefectCause_controller_1.default];
    exports.default = angular.module('aps.controller.defectTypes', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.DEFECT_TYPES,
            url: '/admin/defectTypes',
            controller: 'DefectTypesCtrl as defectTypesCtrl',
            template: defectTypes_tpl_html_1.default,
            data: {
                pageTitle: 'Defect Types',
                authorizeAdmin: true
            }
        });
    }])
        .controller('DefectTypesCtrl', defectTypesCtrl)
        .name;
    function defectTypesCtrl($modal, notifyService, loaderService, defectTypeService) {
        'use strict';
        var vm = this;
        vm.sortBy = 'name';
        var updateDefectType = function (defectTypeDetails) {
            if ((defectTypeDetails || '') !== '') {
                var defectTypeUpdated = _.find(vm.defectTypes, function (item) {
                    return item.id === defectTypeDetails.id;
                });
                if ((defectTypeUpdated || '') !== '') {
                    defectTypeUpdated.legacyId = defectTypeDetails.legacyId;
                    defectTypeUpdated.name = defectTypeDetails.name;
                    defectTypeUpdated.description = defectTypeDetails.description;
                    defectTypeUpdated.courseOfActionName = defectTypeDetails.courseOfActionName;
                    defectTypeUpdated.priority = defectTypeDetails.priority;
                    defectTypeUpdated.enabled = defectTypeDetails.enabled;
                    defectTypeUpdated.defaultInspectionSampleSize = defectTypeDetails.defaultInspectionSampleSize;
                    defectTypeUpdated.probability = defectTypeDetails.probability;
                }
            }
        };
        var addDefectCauseModal = function (defectTypeId) {
            var result = addDefectCause_controller_1.openAddDefectCause({
                defectTypeId: defectTypeId
            }, $modal);
            result.then(function (data) {
                if (data) {
                    vm.editDefectType(defectTypeId);
                }
            });
        };
        var editDefectCauseModal = function (modalData) {
            var result = editDefectCause_controller_1.openEditDefectCause({
                defectCause: modalData.defectCause
            }, $modal);
            result.then(function () {
                vm.editDefectType(modalData.defectTypeId);
            });
        };
        vm.addDefectType = function () {
            var result = addDefectType_controller_1.openAddDefectType($modal);
            result.then(function (data) {
                if ((data || '') !== '') {
                    var item = {
                        id: data.id,
                        legacyId: data.legacyId,
                        name: data.name,
                        defaultInspectionSampleSize: data.defaultInspectionSampleSize,
                        description: data.description
                    };
                    vm.defectTypes.push(item);
                }
            });
        };
        vm.editDefectType = function (defectTypeId) {
            var result = editDefectType_controller_1.openEditDefectType({
                defectTypeId: defectTypeId
            }, $modal);
            result.then(function (data) {
                if ((data || '') !== '') {
                    if ((data.action || '') !== '') {
                        switch (data.action) {
                            case 'editCause':
                                editDefectCauseModal(data);
                                break;
                            case 'addCause':
                                addDefectCauseModal(data.defectTypeId);
                                break;
                            case 'return':
                                updateDefectType(data.defectTypeDetails);
                                break;
                            default:
                                break;
                        }
                    }
                }
            });
        };
        vm.severityName = function (severity) {
            return aps_enums_1.apsEnums.Severity[severity];
        };
        var promise = defectTypeService.getDefectTypesAndClassifications()
            .then(function (defectTypesAndClassifications) {
            vm.defectTypes = defectTypesAndClassifications.types;
        }, notifyService.handleApiErrors);
        loaderService.loadingPromise(promise);
        return vm;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(5), __webpack_require__(114), __webpack_require__(47), __webpack_require__(9), __webpack_require__(12), __webpack_require__(6), __webpack_require__(4), __webpack_require__(645)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, aps_enums_1, defectCause_service_1, toolChange_service_1, uiUtility_service_1, newguid_service_1, notify_service_1, loader_service_1, addDefectCause_tpl_html_1) {
    "use strict";
    addDefectCauseCtrl.$inject = ["$modalInstance", "data", "loaderService", "notifyService", "newGuidService", "defectCausesService", "toolChangeService", "uiUtilityService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [defectCause_service_1.default, toolChange_service_1.default, uiUtility_service_1.default, newguid_service_1.default,
        notify_service_1.default, loader_service_1.default];
    exports.default = angular.module('aps.controller.addDefectCause', requires)
        .controller('AddDefectCauseCtrl', addDefectCauseCtrl)
        .name;
    function openAddDefectCause(data, $modal) {
        return $modal.open({
            template: addDefectCause_tpl_html_1.default,
            controller: 'AddDefectCauseCtrl as addDefectCauseCtrl',
            resolve: {
                data: function () { return data; }
            }
        }).result;
    }
    exports.openAddDefectCause = openAddDefectCause;
    function addDefectCauseCtrl($modalInstance, data, loaderService, notifyService, newGuidService, defectCausesService, toolChangeService, uiUtilityService) {
        'use strict';
        var vm = this;
        vm.defectCause = {
            defectTypeId: data.defectTypeId,
            priority: 0,
            probability: 0.00,
            enabled: true
        };
        vm.reasons = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.ToolChangeReason, 0);
        toolChangeService.getToolsAndTypes().then(function (tools) {
            vm.tools = tools;
        });
        newGuidService.getNewGuid('defectCause')
            .then(function (data) {
            vm.defectCause.id = data;
        });
        defectCausesService.getCourseOfActions().then(function (courseOfActions) {
            vm.courseOfActions = courseOfActions;
        });
        vm.submitDefectCause = function () {
            if (!vm.defectCause.courseOfActionId) {
                vm.defectCause.toolId = null;
                vm.reason = null;
            }
            if (((vm.defectCause || '') !== '') && ((vm.defectCause.courseOfActionId || '') !== '')) {
                var defectCauseUpdated = _.find(vm.courseOfActions, function (item) {
                    return item.id === vm.defectCause.courseOfActionId;
                });
                if ((defectCauseUpdated || '') !== '') {
                    vm.defectCause.courseOfActionName = defectCauseUpdated.name;
                    vm.defectCause.courseOfActionToolChange = defectCauseUpdated.toolChange;
                }
            }
            var promise = defectCausesService.addDefectCause(vm.defectCause)
                .then(function () {
                $modalInstance.close(vm.defectCause);
            }, notifyService.handleApiErrors);
            loaderService.loadingPromise(promise);
        };
        vm.cancel = function () {
            $modalInstance.close();
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=add-defectCauses> <h2 class=modal-header>Add Defect Causes</h2> <form name=addDefectCauseCtrl.defectCauseForm ng-submit=addDefectCauseCtrl.submitDefectCause() novalidate> <div class=row> <label class=\"small-12 columns\"> <span class=\"required notated\">*</span> Name: <input type=text name=name required ng-model=addDefectCauseCtrl.defectCause.name /> <div role=alert ng-messages=addDefectCauseCtrl.defectCauseForm.name.$error ng-if=\"addDefectCauseCtrl.defectCauseForm.name.$dirty || addDefectCauseCtrl.defectCauseForm.$submitted\"> <div ng-message=required class=required>Required</div> </div> </label> </div> <div class=row> <label class=\"small-12 columns\"> Description: <input type=text name=description ng-model=addDefectCauseCtrl.defectCause.description /> </label> </div> <div class=row> <label class=\"small-4 columns\"> Course Of Action: <select name=courseOfActionId ng-model=addDefectCauseCtrl.defectCause.courseOfActionId> <option value=\"\">None</option> <option value=\"{{x.id}}\" ng-repeat=\"x in addDefectCauseCtrl.courseOfActions\">{{x.name}}</option> </select> </label> <label class=\"small-4 columns\" ng-if=addDefectCauseCtrl.defectCause.courseOfActionId> Tool: <select name=toolId ng-model=addDefectCauseCtrl.defectCause.toolId ng-options=\"x.id as x.name for x in addDefectCauseCtrl.tools | orderBy: 'text'\"> <option value=\"\">-- Select Tool --</option> </select> </label> <label class=\"small-4 columns\" ng-if=addDefectCauseCtrl.defectCause.courseOfActionId> Reason: <select name=reason ng-model=addDefectCauseCtrl.defectCause.reason ng-options=\"x.value as x.text for x in addDefectCauseCtrl.reasons | orderBy: 'text'\"> <option value=\"\">-- Select Tool Change Reason --</option> </select> </label> </div> <div class=row> <label class=\"small-4 columns\"> <span class=\"required notated\">*</span> Priority: <input type=number name=priority min=0 step=1 ng-model=addDefectCauseCtrl.defectCause.priority /> <div role=alert ng-messages=addDefectCauseCtrl.defectCauseForm.priority.$error ng-if=\"addDefectCauseCtrl.defectCauseForm.priority.$dirty || addDefectCauseCtrl.defectCauseForm.$submitted\"> <div ng-message=min class=required>Must be 0 or more</div> <div ng-message=number class=required>Must be a number</div> <div ng-message=step class=required>Must be an integer</div> </div> </label> <label class=\"small-4 columns\"> <span class=\"required notated\">*</span> Probability: <input type=number min=0.00 max=100.00 name=probability ng-model=addDefectCauseCtrl.defectCause.probability /> <div role=alert ng-messages=addDefectCauseCtrl.defectCauseForm.probability.$error ng-if=\"addDefectCauseCtrl.defectCauseForm.probability.$dirty || addDefectCauseCtrl.defectCauseForm.$submitted\"> <div ng-message=min class=required>Must be 0 or more</div> <div ng-message=max class=required>Must be 100 or less</div> <div ng-message=number class=required>Must be a number</div> </div> </label> <label class=\"small-4 columns\"> <br/> Enabled: <input type=checkbox ng-model=addDefectCauseCtrl.defectCause.enabled name=enabled /> </label> </div> <div class=row> <div class=\"small-12 columns\"> <span class=required>* Required Fields</span> <div class=\"right dialog-footer\"> <input type=submit class=button ng-disabled=addDefectCauseCtrl.defectCauseForm.$invalid value=Submit /> <button type=button class=button value=Close ng-click=addDefectCauseCtrl.cancel()>Close</button> </div> </div> </div> </form> </div>");

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(5), __webpack_require__(9), __webpack_require__(304), __webpack_require__(6), __webpack_require__(4), __webpack_require__(12), __webpack_require__(25), __webpack_require__(3), __webpack_require__(2), __webpack_require__(647)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, aps_enums_1, uiUtility_service_1, defectClassification_service_1, notify_service_1, loader_service_1, newguid_service_1, defectType_service_1, constant_module_1, _, addDefectType_tpl_html_1) {
    "use strict";
    addDefectTypeCtrl.$inject = ["$modalInstance", "notifyService", "loaderService", "newGuidService", "defectTypeService", "defectClassificationService", "defectTypeDetailsViewModelService", "uiUtilityService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [uiUtility_service_1.default, defectClassification_service_1.default, notify_service_1.default, loader_service_1.default,
        newguid_service_1.default, defectType_service_1.default];
    function openAddDefectType($modal) {
        return $modal.open({
            template: addDefectType_tpl_html_1.default,
            controller: 'AddDefectTypeCtrl as vm'
        }).result;
    }
    exports.openAddDefectType = openAddDefectType;
    exports.default = angular.module('aps.controller.addDefectType', requires)
        .controller('AddDefectTypeCtrl', addDefectTypeCtrl)
        .name;
    function addDefectTypeCtrl($modalInstance, notifyService, loaderService, newGuidService, defectTypeService, defectClassificationService, defectTypeDetailsViewModelService, uiUtilityService) {
        var vm = this;
        var defectTypeImageFileIdentifier = 'defectTypeImage';
        var defectTypeImageSrcIdentifier = 'defectTypeImageSrc';
        var fileReader = new FileReader();
        vm.defectTypeDetails = {
            wareClasses: [],
            defectImage: '',
            hotEndUnqualificationScope: aps_enums_1.apsEnums.UnqualificationScope.None,
            coldEndUnqualificationScope: aps_enums_1.apsEnums.UnqualificationScope.None,
        };
        vm.displayWareClasses = false;
        vm.severities = _.toArray(constant_module_1.Enums.SEVERITY);
        vm.unqualificationScopes = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.UnqualificationScope);
        vm.wareClassesArray = [];
        var loadWareClasses = function () {
            if ((vm.wareClasses || '') !== '') {
                _.each(vm.wareClasses, function (wCItem) {
                    vm.wareClassesArray.push({
                        id: '',
                        wareClass: wCItem,
                        severity: null
                    });
                });
            }
        };
        var fillWareClasses = function () {
            _.each(vm.wareClassesArray, function (defectWareClass) {
                var itemFound = false;
                var severity = vm.displayWareClasses ? defectWareClass.severity : '';
                var wc = _.find(vm.defectTypeDetails.wareClasses, function (item) {
                    return item.wareClassId === defectWareClass.wareClass.id;
                });
                if ((wc || '') !== '') {
                    itemFound = true;
                    wc.severity = severity;
                }
                if (itemFound === false) {
                    vm.defectTypeDetails.wareClasses.push({
                        id: null,
                        wareClassId: defectWareClass.wareClass.id,
                        defectTypeId: vm.defectTypeDetails.id,
                        severity: severity
                    });
                }
            });
        };
        var postDefectType = function () {
            var promise = defectTypeService.addDefectType(vm.defectTypeDetails)
                .then(function () {
                $modalInstance.close(vm.defectTypeDetails);
            }, notifyService.handleApiErrors);
            loaderService.loadingPromise(promise);
        };
        defectTypeDetailsViewModelService.apply(vm.defectTypeDetails);
        newGuidService.getNewGuid('defectType').then(function (data) {
            vm.defectTypeDetails.id = data;
        });
        defectClassificationService.getDefectClassifications().then(function (defectClassifications) {
            vm.defectClassifications = defectClassifications;
        });
        defectTypeService.getDefectTypeWareClasses().then(function (wareClasses) {
            vm.wareClasses = wareClasses;
            loadWareClasses();
        });
        fileReader.onload = function (event) {
            if ((event.target.result || '') !== '') {
                var uri = event.target.result;
                vm.defectTypeDetails.defectImage = uri;
                var defectTypeImageSrc = angular.element('#' + defectTypeImageSrcIdentifier);
                if ((defectTypeImageSrc || '') !== '') {
                    if ((defectTypeImageSrc[0] || '') !== '') {
                        defectTypeImageSrc[0].src = uri;
                    }
                }
            }
        };
        vm.fileNameChanged = function () {
            var defectTypeImageFile = angular.element('#' + defectTypeImageFileIdentifier);
            if ((defectTypeImageFile || '') !== '') {
                if ((defectTypeImageFile[0] || '') !== '') {
                    if ((defectTypeImageFile[0].files[0] || '') !== '') {
                        fileReader.readAsDataURL(defectTypeImageFile[0].files[0]);
                    }
                }
            }
        };
        vm.submitDefectType = function () {
            if (vm.form.$invalid) {
                return;
            }
            if (vm.displayWareClasses === true) {
                fillWareClasses();
            }
            postDefectType();
        };
        vm.cancel = function () {
            $modalInstance.close();
        };
        return vm;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=add-defectType> <h2 class=modal-header>Add Defect Type</h2> <form name=vm.form ng-submit=vm.submitDefectType() novalidate> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-6 columns\"> <label> Legacy Id <input type=number name=legacyId min=1 ng-model=vm.defectTypeDetails.legacyId /> <div ng-messages=vm.form.legacyId.$error ng-if=\"vm.form.legacyId.$dirty || vm.form.$submitted\" role=alert> <div ng-message=min class=req-w><div class=arrow-up></div>Must be 1 or more</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> </div> </label> </div> <div class=\"small-6 columns\"> <label> <span class=\"required notated\">*</span>Abbreviation <input type=text name=abbreviation required maxlength=6 ng-model=vm.defectTypeDetails.abbreviation /> <div ng-messages=vm.form.abbreviation.$error ng-if=\"vm.form.abbreviation.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=maxlength class=req-w><div class=arrow-up></div>May not be more than 6 characters</div> </div> </label> </div> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-6 columns\"> <label> <span class=\"required notated\">*</span>Name <input type=text name=defectTypeName ng-model=vm.defectTypeDetails.name required/> <div ng-messages=vm.form.defectTypeName.$error ng-if=\"vm.form.defectTypeName.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-6 columns\"> <label> <span class=\"required notated\">*</span>Description <input type=text name=description ng-model=vm.defectTypeDetails.description required/> <div ng-messages=vm.form.description.$error ng-if=\"vm.form.description.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-6 columns\"> <label> <span class=\"required notated\">*</span>Severity <select ng-model=vm.defectTypeDetails.severity name=severity required> <option value=\"{{sev.id}}\" ng-repeat=\"sev in vm.severities | orderBy : 'id'\">{{sev.name}}</option> </select> <div ng-messages=vm.form.severity.$error ng-if=\"vm.form.severity.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-6 columns\"> <label style=margin-top:28px> <br/> <input type=checkbox name=displayWareClasses ng-model=vm.displayWareClasses /> Override Ware Classes </label> <table class=\"ware-class history-t\" ng-if=\"vm.displayWareClasses === true\"> <thead> <tr> <th>Ware Class</th> <th>Severity</th> </tr> </thead> <tbody> <tr ng-repeat=\"wc in vm.wareClassesArray\"> <td ng-model=wc.wareClass> {{wc.wareClass.name}} </td> <td> <select ng-model=wc.severity ng-options=\"cls.id as cls.name for cls in vm.severities\"> <option value=\"\">None</option> <option value=\"{{cls.id}}\" ng-repeat=\"cls in vm.severities\"> {{cls.name}} </option> </select> </td> </tr> </tbody> </table> </div> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-6 columns\"> <label> Default Inspection Sample Size <input type=number name=defaultInspectionSampleSize min=1 ng-model=vm.defectTypeDetails.defaultInspectionSampleSize /> <div ng-messages=vm.form.defaultInspectionSampleSize.$error ng-if=\"vm.form.defaultInspectionSampleSize.$dirty || vm.form.$submitted\" role=alert> <div ng-message=min class=req-w><div class=arrow-up></div>Must be 1 or more</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> </div> </label> </div> <div class=\"small-6 columns\"> <label> Critical Threshold <input type=number min=0 max=100 name=criticalThresholdFriendly ng-model=vm.defectTypeDetails.criticalThresholdFriendly /> <div ng-messages=vm.form.criticalThresholdFriendly.$error ng-if=\"vm.form.criticalThresholdFriendly.$dirty || vm.form.$submitted\" role=alert> <div ng-message=min class=req-w><div class=arrow-up></div>Must be between 0 and 100</div> <div ng-message=max class=req-w><div class=arrow-up></div>Must be between 0 and 100</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> </div> </label> </div> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-6 columns\"> <label> Requalification Threshold <input type=number min=0 max=100 name=requalificationThresholdFriendly ng-model=vm.defectTypeDetails.requalificationThresholdFriendly /> <div ng-messages=vm.form.requalificationThresholdFriendly.$error ng-if=\"vm.form.requalificationThresholdFriendly.$dirty || vm.form.$submitted\" role=alert> <div ng-message=min class=req-w><div class=arrow-up></div>Must be between 0 and 100</div> <div ng-message=max class=req-w><div class=arrow-up></div>Must be between 0 and 100</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> </div> </label> </div> <div class=\"small-6 columns\"> <label> <span class=\"required notated\">*</span>Defect Location <select name=defectClassificationId required ng-model=vm.defectTypeDetails.defectClassificationId> <option value=\"{{cls.id}}\" ng-repeat=\"cls in vm.defectClassifications | orderBy: 'name'\">{{cls.name}}</option> </select> <div ng-messages=vm.form.defectClassificationId.$error ng-if=\"vm.form.defectClassificationId.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-6 columns\"> <label> Hot End Requalification Scope <select name=hotEndUnqualificationScope required ng-model=vm.defectTypeDetails.hotEndUnqualificationScope ng-options=\"scope.value as scope.text for scope in vm.unqualificationScopes\"></select> <div ng-messages=vm.form.hotEndUnqualificationScope.$error ng-if=\"vm.form.hotEndUnqualificationScope.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-6 columns\"> <label> Cold End Requalification Scope <select name=coldEndUnqualificationScope required ng-model=vm.defectTypeDetails.coldEndUnqualificationScope ng-options=\"scope.value as scope.text for scope in vm.unqualificationScopes\"></select> <div ng-messages=vm.form.coldEndUnqualificationScope.$error ng-if=\"vm.form.coldEndUnqualificationScope.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\" ng-if=\"0 < vm.defectTypeDetails.coldEndUnqualificationScope\"> <div class=\"small-6 columns\"> </div> <div class=\"small-6 columns\"> <label> <input type=checkbox name=immediateColdEndRequalification ng-model=vm.defectTypeDetails.immediateColdEndRequalification /> Immediate Cold End Requalification </label> </div> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-6 columns\"> <label> Image <img ng-src=\"{{vm.defectTypeDetails.defectImage}}\" id=defectTypeImageSrc> <input type=file id=defectTypeImage ng-blur=vm.fileNameChanged()><br> </label> </div> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-12 columns\"> <span class=required>* Required Fields</span> <div class=\"right dialog-footer\"> <button type=submit class=button>Add Defect Type</button> <button type=button class=\"button secondary\" ng-click=vm.cancel()> Close </button> </div> </div> </div> </form> </div>");

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <div class=body-header> <h2>Defect Types</h2> <a href=\"\" class=\"button small\" ng-click=defectTypesCtrl.addDefectType()>Add Defect Type</a> </div> <table class=history-t> <tr> <thead> <th>Legacy&nbsp;ID</th> <th>Abbreviation</th> <th>Name</th> <th>Severity</th> <th>Location</th> <th>Measurable / Non-measurable</th> <th>Default Sample Size</th> <th>Description</th> </thead> </tr> <tr ng-repeat=\"defectType in defectTypesCtrl.defectTypes | orderBy: 'name' track by defectType.id\" ng-click=defectTypesCtrl.editDefectType(defectType.id)> <td ng-bind=defectType.legacyId></td> <td ng-bind=defectType.abbreviation></td> <td ng-bind=defectType.name></td> <td ng-bind=defectTypesCtrl.severityName(defectType.severity)></td> <td ng-bind=defectType.defectClassificationName></td> <td>{{defectType.defaultInspectionSampleSize == undefined ? 'N/A' : (defectType.defaultInspectionSampleSize == 4 ? 'Measureable' : 'Non-measurable')}}</td> <td ng-bind=defectType.defaultInspectionSampleSize></td> <td ng-bind=defectType.description></td> </tr> </table> </div> ");

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(6), __webpack_require__(4), __webpack_require__(25), __webpack_require__(304), __webpack_require__(9), __webpack_require__(109), __webpack_require__(5), __webpack_require__(3), __webpack_require__(2), __webpack_require__(650)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, notify_service_1, loader_service_1, defectType_service_1, defectClassification_service_1, uiUtility_service_1, defectType_1, aps_enums_1, constant_module_1, _, editDefectType_tpl_html_1) {
    "use strict";
    editDefectTypeCtrl.$inject = ["$modalInstance", "$timeout", "notifyService", "loaderService", "data", "defectTypeService", "defectClassificationService", "defectTypeDetailsViewModelService", "uiUtilityService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [notify_service_1.default, loader_service_1.default, defectType_service_1.default, defectClassification_service_1.default,
        uiUtility_service_1.default, defectType_1.default];
    exports.default = angular.module('aps.controller.editDefectType', requires)
        .controller('EditDefectTypeCtrl', editDefectTypeCtrl)
        .name;
    function openEditDefectType(data, $modal) {
        return $modal.open({
            template: editDefectType_tpl_html_1.default,
            controller: 'EditDefectTypeCtrl as vm',
            resolve: {
                data: function () {
                    return data;
                }
            }
        }).result;
    }
    exports.openEditDefectType = openEditDefectType;
    function editDefectTypeCtrl($modalInstance, $timeout, notifyService, loaderService, data, defectTypeService, defectClassificationService, defectTypeDetailsViewModelService, uiUtilityService) {
        var vm = this;
        var defectTypeImageFileIdentifier = 'defectTypeImage';
        var defectTypeImageSrcIdentifier = 'defectTypeImageSrc';
        var fileReader = new FileReader();
        vm.displayWareClasses = false;
        vm.defectTypeId = data.defectTypeId;
        vm.severities = _.toArray(constant_module_1.Enums.SEVERITY);
        vm.unqualificationScopes = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.UnqualificationScope);
        vm.wareClassesArray = [];
        var loadWareClasses = function () {
            if (((vm.defectTypeDetails || '') !== '') && ((vm.wareClasses || '') !== '')) {
                var wareClassesSeverityFound = false;
                _.each(vm.wareClasses, function (wCItem) {
                    var id = '';
                    var severity = '';
                    var wareClass = _.find(vm.defectTypeDetails.wareClasses, function (item) {
                        return item.wareClassId === wCItem.id;
                    });
                    if ((wareClass || '') !== '') {
                        wareClassesSeverityFound = ((wareClass.severity || '') !== '') ? true : wareClassesSeverityFound;
                        id = wareClass.id;
                        severity = wareClass.severity;
                    }
                    vm.wareClassesArray.push({
                        id: id,
                        wareClass: wCItem,
                        severity: severity
                    });
                });
                vm.displayWareClasses = wareClassesSeverityFound;
            }
        };
        var fillWareClasses = function () {
            _.each(vm.wareClassesArray, function (defectWareClass) {
                var itemFound = false;
                var severity = vm.displayWareClasses ? defectWareClass.severity : '';
                var wc = _.find(vm.defectTypeDetails.wareClasses, function (item) {
                    return item.wareClassId === defectWareClass.wareClass.id;
                });
                if ((wc || '') !== '') {
                    itemFound = true;
                    wc.severity = severity;
                }
                if (itemFound === false) {
                    vm.defectTypeDetails.wareClasses.push({
                        wareClassId: defectWareClass.wareClass.id,
                        defectTypeId: vm.defectTypeDetails.id,
                        severity: severity
                    });
                }
            });
        };
        var postDefectType = function () {
            var promise = defectTypeService.submitDefectType(vm.defectTypeDetails)
                .then(function () {
                var data = {
                    action: 'return',
                    defectTypeDetails: vm.defectTypeDetails
                };
                $modalInstance.close(data);
            }, notifyService.handleApiErrors);
            loaderService.loadingPromise(promise);
        };
        defectClassificationService.getDefectClassifications().then(function (defectClassifications) {
            vm.defectClassifications = defectClassifications;
        });
        defectTypeService.getDefectTypeWareClasses().then(function (wareClasses) {
            vm.wareClasses = wareClasses;
            loadWareClasses();
        });
        var promise = defectTypeService.getDefectTypeDetails(vm.defectTypeId)
            .then(function (defectTypeDetails) {
            defectTypeDetailsViewModelService.apply(defectTypeDetails);
            vm.defectTypeDetails = defectTypeDetails;
            loadWareClasses();
        }, notifyService.handleApiErrors);
        loaderService.loadingPromise(promise);
        fileReader.onload = function (event) {
            if ((event.target.result || '') !== '') {
                var uri = event.target.result;
                vm.defectTypeDetails.defectImage = uri;
                var defectTypeImageSrc = angular.element('#' + defectTypeImageSrcIdentifier);
                if ((defectTypeImageSrc || '') !== '') {
                    if ((defectTypeImageSrc[0] || '') !== '') {
                        defectTypeImageSrc[0].src = uri;
                    }
                }
            }
        };
        vm.fileNameChanged = function (value) {
            var defectTypeImageFile = angular.element('#' + defectTypeImageFileIdentifier);
            if ((defectTypeImageFile || '') !== '') {
                if ((defectTypeImageFile[0] || '') !== '') {
                    if ((defectTypeImageFile[0].files[0] || '') !== '') {
                        fileReader.readAsDataURL(defectTypeImageFile[0].files[0]);
                    }
                }
            }
        };
        vm.submitDefectType = function () {
            if (vm.form.$invalid) {
                return;
            }
            fillWareClasses();
            postDefectType();
        };
        var scrollToHeader = function () {
            var top = angular.element('body').scrollTop();
            var offset = angular.element('.modal-header').offset();
            if (offset.top < (top - 50)) {
                angular.element('body').animate({ scrollTop: offset.top - 50 }, 50);
            }
        };
        vm.editDefectCauseModal = function (defectCause) {
            scrollToHeader();
            $timeout(function () {
                var data = {
                    action: 'editCause',
                    defectCause: defectCause,
                    defectTypeId: vm.defectTypeId
                };
                $modalInstance.close(data);
            }, 250);
        };
        vm.addDefectCauseModal = function () {
            scrollToHeader();
            $timeout(function () {
                var data = {
                    action: 'addCause',
                    defectTypeId: vm.defectTypeId
                };
                $modalInstance.close(data);
            }, 250);
        };
        vm.cancel = function () {
            $modalInstance.close({
                action: 'close',
                defectTypeId: vm.defectTypeId
            });
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=edit-defectType> <h2 class=modal-header>Edit Defect Type</h2> <form name=vm.form ng-submit=vm.submitDefectType() novalidate> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-6 columns\"> <label> Legacy Id <input type=number name=legacyId min=1 ng-model=vm.defectTypeDetails.legacyId /> <div ng-messages=vm.form.legacyId.$error ng-if=\"vm.form.legacyId.$dirty || vm.form.$submitted\" role=alert> <div ng-message=min class=req-w><div class=arrow-up></div>Must be 1 or more</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> </div> </label> </div> <div class=\"small-6 columns\"> <label> <span class=\"required notated\">*</span>Abbreviation <input type=text name=abbreviation required maxlength=6 ng-model=vm.defectTypeDetails.abbreviation /> <div ng-messages=vm.form.abbreviation.$error ng-if=\"vm.form.abbreviation.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=maxlength class=req-w><div class=arrow-up></div>May not be more than 6 characters</div> </div> </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-6 columns\"> <label> <span class=\"required notated\">*</span>Name <input type=text name=defectTypeName ng-model=vm.defectTypeDetails.name required/> <div ng-messages=vm.form.defectTypeName.$error ng-if=\"vm.form.defectTypeName.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-6 columns\"> <label> <span class=\"required notated\">*</span>Description <input type=text name=description ng-model=vm.defectTypeDetails.description required/> <div ng-messages=vm.form.description.$error ng-if=\"vm.form.description.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-6 columns\"> <label> <span class=\"required notated\">*</span>Severity <select ng-model=vm.defectTypeDetails.severity name=severity required ng-options=\"s.id as s.name for s in vm.severities\"></select>  <!--<option value=\"{{sev.id}}\" ng-repeat=\"sev in vm.severities | orderBy : 'id'\">{{sev.name}}</option>--> <div ng-messages=vm.form.severity.$error ng-if=\"vm.form.severity.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-6 columns\"> <label> <br/> <input type=checkbox name=displayWareClasses ng-model=vm.displayWareClasses /> Override Ware Classes </label> <table class=\"ware-class history-t\" ng-if=\"vm.displayWareClasses === true\"> <thead> <tr> <th>Ware Class</th> <th>Severity</th> </tr> </thead> <tbody> <tr ng-repeat=\"wc in vm.wareClassesArray\"> <td ng-model=wc.wareClass> {{wc.wareClass.name}} </td> <td> <select ng-model=wc.severity ng-options=\"cls.id as cls.name for cls in vm.severities\"> <option value=\"\">None</option> <option value=\"{{cls.id}}\" ng-repeat=\"cls in vm.severities\"> {{cls.name}} </option> </select> </td> </tr> </tbody> </table> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-6 columns\"> <label> Default Inspection Sample Size <input type=number name=defaultInspectionSampleSize min=1 ng-model=vm.defectTypeDetails.defaultInspectionSampleSize /> <div ng-messages=vm.form.defaultInspectionSampleSize.$error ng-if=\"vm.form.defaultInspectionSampleSize.$dirty || vm.form.$submitted\" role=alert> <div ng-message=min class=req-w><div class=arrow-up></div>Must be 1 or more</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> </div> </label> </div> <div class=\"small-6 columns\"> <label> Critical Threshold <input type=number min=0 max=100 name=criticalThresholdFriendly ng-model=vm.defectTypeDetails.criticalThresholdFriendly /> <div ng-messages=vm.form.criticalThresholdFriendly.$error ng-if=\"vm.form.criticalThresholdFriendly.$dirty || vm.form.$submitted\" role=alert> <div ng-message=min class=req-w><div class=arrow-up></div>Must be between 0 and 100</div> <div ng-message=max class=req-w><div class=arrow-up></div>Must be between 0 and 100</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> </div> </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-6 columns\"> <label> Requalification Threshold <input type=number min=0 max=100 name=requalificationThresholdFriendly ng-model=vm.defectTypeDetails.requalificationThresholdFriendly /> <div ng-messages=vm.form.requalificationThresholdFriendly.$error ng-if=\"vm.form.requalificationThresholdFriendly.$dirty || vm.form.$submitted\" role=alert> <div ng-message=min class=req-w><div class=arrow-up></div>Must be between 0 and 100</div> <div ng-message=max class=req-w><div class=arrow-up></div>Must be between 0 and 100</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> </div> </label> </div> <div class=\"small-6 columns\"> <label> <span class=\"required notated\">*</span>Defect Location <select name=defectClassificationId required ng-model=vm.defectTypeDetails.defectClassificationId> <option value=\"{{cls.id}}\" ng-repeat=\"cls in vm.defectClassifications\">{{cls.name}}</option> </select> <div ng-messages=vm.form.defectClassificationId.$error ng-if=\"vm.form.defectClassificationId.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-6 columns\"> <label> Hot End Requalification Scope <select name=hotEndUnqualificationScope required ng-model=vm.defectTypeDetails.hotEndUnqualificationScope ng-options=\"scope.value as scope.text for scope in vm.unqualificationScopes\"></select> <div ng-messages=vm.form.hotEndUnqualificationScope.$error ng-if=\"vm.form.hotEndUnqualificationScope.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-6 columns\"> <label> Cold End Requalification Scope <select name=coldEndUnqualificationScope required ng-model=vm.defectTypeDetails.coldEndUnqualificationScope ng-options=\"scope.value as scope.text for scope in vm.unqualificationScopes\"></select> <div ng-messages=vm.form.coldEndUnqualificationScope.$error ng-if=\"vm.form.coldEndUnqualificationScope.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\" ng-if=\"0 < vm.defectTypeDetails.coldEndUnqualificationScope\"> <div class=\"small-6 columns\"> </div> <div class=\"small-6 columns\"> <label> <input type=checkbox name=immediateColdEndRequalification ng-model=vm.defectTypeDetails.immediateColdEndRequalification /> Immediate Cold End Requalification </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-6 columns\"> <label> Image <img ng-src=\"{{vm.defectTypeDetails.defectImage}}\" id=defectTypeImageSrc> <input type=file id=defectTypeImage ng-blur=vm.fileNameChanged()><br> </label> </div> </div> <div> <br/> <br/> <h4>Defect Causes</h4> <table class=history-t> <tr> <thead> <th>Name</th> <th>Description</th> <th>Course Of Action</th> <th>Priority</th> <th>Enabled</th> <th>Probability</th> </thead> </tr> <tr ng-repeat=\"possibleCause in vm.defectTypeDetails.possibleCauses | orderBy: '-probability'\" ng-click=vm.editDefectCauseModal(possibleCause)> <td ng-bind=possibleCause.name></td> <td ng-bind=possibleCause.description></td> <td ng-bind=possibleCause.courseOfActionName></td> <td ng-bind=possibleCause.priority></td> <td>{{ possibleCause.enabled ? \"Yes\" : \"No\" }}</td> <td ng-bind=possibleCause.probability></td> </tr> </table> <button type=button class=\"button secondary small\" ng-click=vm.addDefectCauseModal()> Add Defect Cause </button> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-12 columns\"> <span class=required>* Required Fields</span> <div class=\"right dialog-footer\"> <button type=submit class=button>Save</button> <button type=button class=\"button secondary\" ng-click=vm.cancel()>Close</button> </div> </div> </div> </form> </div> ");

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(4), __webpack_require__(6), __webpack_require__(114), __webpack_require__(47), __webpack_require__(9), __webpack_require__(5), __webpack_require__(652)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, loader_service_1, notify_service_1, defectCause_service_1, toolChange_service_1, uiUtility_service_1, aps_enums_1, editDefectCause_tpl_html_1) {
    "use strict";
    editDefectCauseCtrl.$inject = ["$modalInstance", "data", "loaderService", "notifyService", "defectCausesService", "toolChangeService", "uiUtilityService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, notify_service_1.default, defectCause_service_1.default, toolChange_service_1.default,
        uiUtility_service_1.default];
    exports.default = angular.module('aps.controller.editDefectCause', requires)
        .controller('EditDefectCauseCtrl', editDefectCauseCtrl)
        .name;
    function openEditDefectCause(data, $modal) {
        return $modal.open({
            template: editDefectCause_tpl_html_1.default,
            controller: 'EditDefectCauseCtrl as editDefectCauseCtrl',
            resolve: {
                data: function () {
                    return data;
                }
            }
        }).result;
    }
    exports.openEditDefectCause = openEditDefectCause;
    function editDefectCauseCtrl($modalInstance, data, loaderService, notifyService, defectCausesService, toolChangeService, uiUtilityService) {
        'use strict';
        var vm = this;
        vm.defectCause = data.defectCause;
        vm.reasons = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.ToolChangeReason, 0);
        toolChangeService.getToolsAndTypes().then(function (tools) {
            vm.tools = tools;
        });
        defectCausesService.getCourseOfActions().then(function (courseOfActions) {
            vm.courseOfActions = courseOfActions;
        });
        vm.submitDefectCause = function () {
            if (!vm.defectCause.courseOfActionId) {
                vm.defectCause.toolId = null;
                vm.reason = null;
            }
            var promise = defectCausesService.submitDefectCause(vm.defectCause)
                .then(function () {
                $modalInstance.close(vm.defectCause);
            }, notifyService.handleApiErrors);
            loaderService.loadingPromise(promise);
        };
        vm.cancel = function () {
            $modalInstance.close();
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=edit-defectCauses> <h2 class=modal-header>Edit Defect Cause</h2> <form name=editDefectCauseCtrl.defectCauseForm ng-submit=editDefectCauseCtrl.submitDefectCause() novalidate> <div class=row> <label class=\"small-12 columns\"> <span class=\"required notated\">*</span> Name: <input type=text name=name required ng-model=editDefectCauseCtrl.defectCause.name /> <div role=alert ng-messages=editDefectCauseCtrl.defectCauseForm.name.$error ng-if=\"editDefectCauseCtrl.defectCauseForm.name.$dirty || editDefectCauseCtrl.defectCauseForm.$submitted\"> <div ng-message=required class=required>Required</div> </div> </label> </div> <div class=row> <label class=\"small-12 columns\"> Description: <input type=text ng-model=editDefectCauseCtrl.defectCause.description name=description /> </label> </div> <div class=row> <label class=\"small-4 columns\"> Course Of Action: <select name=courseOfActionId ng-model=editDefectCauseCtrl.defectCause.courseOfActionId> <option value=\"\">None</option> <option value=\"{{cls.id}}\" ng-repeat=\"cls in editDefectCauseCtrl.courseOfActions\">{{cls.name}}</option> </select> </label> <label class=\"small-4 columns\" ng-if=editDefectCauseCtrl.defectCause.courseOfActionId> Tool: <select name=toolId ng-model=editDefectCauseCtrl.defectCause.toolId ng-options=\"x.id as x.name for x in editDefectCauseCtrl.tools | orderBy: 'text'\"> <option value=\"\">-- Select Tool --</option> </select> </label> <label class=\"small-4 columns\" ng-if=editDefectCauseCtrl.defectCause.courseOfActionId> Reason: <select name=reason ng-model=editDefectCauseCtrl.defectCause.reason ng-options=\"x.value as x.text for x in editDefectCauseCtrl.reasons | orderBy: 'text'\"> <option value=\"\">-- Select Tool Change Reason --</option> </select> </label> </div> <div class=row> <label class=\"small-4 columns\"> <span class=\"required notated\">*</span> Priority: <input type=number name=priority min=0 step=1 ng-model=editDefectCauseCtrl.defectCause.priority /> <div role=alert ng-messages=editDefectCauseCtrl.defectCauseForm.priority.$error ng-if=\"editDefectCauseCtrl.defectCauseForm.priority.$dirty || editDefectCauseCtrl.defectCauseForm.$submitted\"> <div ng-message=min class=required>Must be 0 or more</div> <div ng-message=number class=required>Must be a number</div> <div ng-message=step class=required>Must be an integer</div> </div> </label> <label class=\"small-4 columns\"> <span class=\"required notated\">*</span> Probability: <input type=number min=0.00 max=100.00 name=probability ng-model=editDefectCauseCtrl.defectCause.probability /> <div role=alert ng-messages=editDefectCauseCtrl.defectCauseForm.probability.$error ng-if=\"editDefectCauseCtrl.defectCauseForm.probability.$dirty || editDefectCauseCtrl.defectCauseForm.$submitted\"> <div ng-message=min class=required>Must be 0 or more</div> <div ng-message=max class=required>Must be 100 or less</div> <div ng-message=number class=required>Must be a number</div> </div> </label> <label class=\"small-4 columns\"> <br/> <input type=checkbox ng-model=editDefectCauseCtrl.defectCause.enabled name=enabled /> Enabled </label> </div> <div class=row> <div class=\"small-12 columns\"> <div class=\"right dialog-footer\"> <input type=submit class=button ng-disabled=editDefectCauseCtrl.defectCauseForm.$invalid value=Submit /> <button type=button class=\"button secondary\" value=Close ng-click=editDefectCauseCtrl.cancel()>Close</button> </div> </div> </div> </form> </div>");

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(5), __webpack_require__(3), __webpack_require__(654), __webpack_require__(4), __webpack_require__(25), __webpack_require__(655)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, aps_enums_1, constant_module_1, defectTypes_tpl_html_1, loader_service_1, defectType_service_1, viewDefectType_controller_1) {
    "use strict";
    viewDefectTypesCtrl.$inject = ["$modal", "loaderService", "defectTypeService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, defectType_service_1.default, viewDefectType_controller_1.default];
    function getSeverityName(severity) {
        return aps_enums_1.apsEnums.Severity[severity];
    }
    exports.default = angular.module('aps.controller.viewDefectTypes', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.VIEW_DEFECT_TYPES,
            url: '/defectTypes',
            controller: 'ViewDefectTypesCtrl as vm',
            template: defectTypes_tpl_html_1.default,
            data: {
                pageTitle: 'Defect Types'
            }
        });
    }])
        .controller('ViewDefectTypesCtrl', viewDefectTypesCtrl)
        .name;
    function viewDefectTypesCtrl($modal, loaderService, defectTypeService) {
        var vm = {};
        vm.sortBy = 'name';
        loaderService.loadingPromise(defectTypeService
            .getDefectTypesAndClassifications().then(function (data) {
            vm.defectTypes = data.types;
        }));
        var wcPromise = defectTypeService.getDefectTypeWareClasses();
        function viewDefectType(defectType) {
            loaderService.loadingPromise(wcPromise.then(function (wareClasses) {
                return defectTypeService.getDefectTypeDetails(defectType.id).then(function (detail) {
                    viewDefectType_controller_1.openViewDefectType({
                        defectType: detail,
                        wareClasses: wareClasses
                    }, $modal);
                });
            }));
        }
        vm.viewDefectType = viewDefectType;
        vm.getSeverityName = getSeverityName;
        vm.exportToCsv = function () {
            var _this = this;
            return _.orderBy(_.map(this.defectTypes, function (x) {
                return {
                    legacyId: x.legacyId,
                    abbreviation: x.abbreviation,
                    name: x.name,
                    severity: _this.getSeverityName(x.severity),
                    location: x.defectClassificationName,
                    defaultSampleSize: x.defaultInspectionSampleSize,
                    description: x.description
                };
            }), [vm.sortBy], ['asc']);
        };
        return vm;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <div class=body-header> <h2>Defect Types</h2> </div> <a ng-csv=vm.exportToCsv() filename=defectTypeReportExport.csv class=right>Save as CSV</a> <table class=history-t> <tr> <thead> <th>Legacy&nbsp;ID</th> <th>Abbreviation</th> <th>Name</th> <th>Severity</th> <th>Location</th> <th>Measurable / Non-measurable</th> <th>Default Sample Size</th> <th>Description</th> </thead> </tr> <tr ng-repeat=\"defectType in vm.defectTypes | orderBy: 'name' track by defectType.id\" ng-click=vm.viewDefectType(defectType)> <td ng-bind=defectType.legacyId></td> <td ng-bind=defectType.abbreviation></td> <td ng-bind=defectType.name></td> <td ng-bind=vm.getSeverityName(defectType.severity)></td> <td ng-bind=defectType.defectClassificationName></td> <td>{{defectType.defaultInspectionSampleSize == undefined ? 'N/A' : (defectType.defaultInspectionSampleSize == 4 ? 'Measureable' : 'Non-measurable')}}</td> <td ng-bind=defectType.defaultInspectionSampleSize></td> <td ng-bind=defectType.description></td> </tr> </table> </div> ");

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(5), __webpack_require__(9), __webpack_require__(656)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, aps_enums_1, uiUtility_service_1, viewDefectType_tpl_html_1) {
    "use strict";
    viewDefectTypeCtrl.$inject = ["$modalInstance", "data", "uiUtilityService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [uiUtility_service_1.default];
    function openViewDefectType(data, $modal) {
        return $modal.open({
            template: viewDefectType_tpl_html_1.default,
            controller: 'ViewDefectTypeCtrl as vm',
            resolve: {
                data: function () {
                    return data;
                }
            }
        }).result;
    }
    exports.openViewDefectType = openViewDefectType;
    function getSeverityName(severity) {
        return aps_enums_1.apsEnums.Severity[severity];
    }
    function getThreshold(threshold) {
        if (threshold === 0) {
            return 'None';
        }
        if (threshold > 0) {
            return (threshold * 100).toFixed() + '%';
        }
        return 'All';
    }
    exports.default = angular.module('aps.controller.viewDefectType', requires)
        .controller('ViewDefectTypeCtrl', viewDefectTypeCtrl)
        .name;
    function viewDefectTypeCtrl($modalInstance, data, uiUtilityService) {
        var vm = {};
        vm.defectType = data.defectType;
        var unqualificationScopes = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.UnqualificationScope);
        vm.wareClasses = [];
        vm.defectType.wareClasses.forEach(function (wc) {
            if (wc.severity === vm.defectType.severity) {
                return;
            }
            var wareClass = _.find(data.wareClasses, { id: wc.wareClassId });
            if (!wareClass) {
                return;
            }
            vm.wareClasses.push({
                name: wareClass.name,
                severity: getSeverityName(wc.severity)
            });
        });
        function getScopeName(scope) {
            var scopeItem = _.find(unqualificationScopes, { value: scope });
            return scopeItem ? scopeItem.text : '';
        }
        vm.getScopeName = getScopeName;
        vm.getSeverityName = getSeverityName;
        vm.getThreshold = getThreshold;
        vm.close = function () {
            $modalInstance.close();
        };
        return vm;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=edit-defectType> <h2 class=modal-header> {{vm.defectType.name}} {{(vm.defectType.legacyId ? '(' + vm.defectType.legacyId + ')' : '')}} </h2> <div class=row style=\"margin:1em -30px;width:auto\"> <div class=\"small-6 columns\"> <label> Legacy Id: </label> <div>{{vm.defectType.legacyId}}</div> </div> <div class=\"small-6 columns\"> <label> Abbreviation: </label> <div>{{vm.defectType.abbreviation}}</div> </div> </div> <div class=row style=\"margin:1em -30px;width:auto\"> <div class=\"small-6 columns\"> <label> Name: </label> <div>{{vm.defectType.name}}</div> </div> <div class=\"small-6 columns\"> <label> Description: </label> <div> {{vm.defectType.description}} </div> </div> </div> <div class=row style=\"margin:1em -30px;width:auto\"> <div class=\"small-6 columns\"> <label> Severity: </label> <div>{{vm.getSeverityName(vm.defectType.severity)}}</div> </div> <div class=\"small-6 columns\" ng-if=\"vm.wareClasses.length > 0\"> <label> Overridden Ware Classes </label> <table class=\"ware-class history-t\"> <thead> <tr> <th>Ware Class</th> <th>Severity</th> </tr> </thead> <tbody> <tr ng-repeat=\"wc in vm.wareClasses\"> <td>{{wc.name}}</td> <td>{{wc.severity}}</td> </tr> </tbody> </table> </div> </div> <div class=row style=\"margin:1em -30px;width:auto\" ng-if=\"vm.defectType.defaultInspectionSampleSize || vm.defectType.criticalThreshold\"> <div class=\"small-6 columns\" ng-if=vm.defectType.defaultInspectionSampleSize> <label> Default Inspection Sample Size: </label> <div>{{vm.defectType.defaultInspectionSampleSize}}</div> </div> <div class=\"small-6 columns\" ng-if=vm.defectType.criticalThreshold> <label> Critical Threshold: </label> <div>{{vm.getThreshold(vm.defectType.criticalThreshold)}}</div> </div> </div> <div class=row style=\"margin:1em -30px;width:auto\" ng-if=\"vm.defectType.requalificationThreshold || vm.defectType.defectClassificationId\"> <div class=\"small-6 columns\" ng-if=vm.defectType.requalificationThreshold> <label> Requalification Threshold: </label> <div>{{vm.getThreshold(vm.defectType.requalificationThreshold)}}</div> </div> <div class=\"small-6 columns\" ng-if=vm.defectType.defectClassificationId> <label> Defect Location: </label> <div>{{vm.defectType.defectClassificationName}}</div> </div> </div> <div class=row style=\"margin:1em -30px;width:auto\" ng-if=\"vm.defectType.hotEndUnqualificationScope || vm.defectType.coldEndUnqualificationScope\"> <div class=\"small-6 columns\" ng-if=vm.defectType.hotEndUnqualificationScope> <label> Hot End Requalification Scope: </label> <div>{{vm.getScopeName(vm.defectType.hotEndUnqualificationScope)}}</div> </div> <div class=\"small-6 columns\" ng-if=vm.defectType.coldEndUnqualificationScope> <label> Cold End Requalification Scope: </label> <div>{{vm.getScopeName(vm.defectType.coldEndUnqualificationScope)}}</div> </div> </div> <div class=row style=\"margin:1em -30px;width:auto\" ng-if=vm.defectType.coldEndUnqualificationScope> <div class=\"small-6 columns\" ng-if=vm.defectType.hotEndUnqualificationScope> </div> <div class=\"small-6 columns\" ng-if=vm.defectType.coldEndUnqualificationScope> <label> Immediate Cold End Requalification: </label> <div>{{(vm.defectType.immediateColdEndRequalification ? 'Yes' : 'No')}}</div> </div> </div> <div class=row style=\"margin:1em -30px;width:auto\" ng-if=vm.defectType.defectImage> <div class=\"small-6 columns\"> <label> Image: </label> <div><img ng-src=\"{{vm.defectType.defectImage}}\" id=defectTypeImageSrc /></div> </div> </div> <div ng-if=\"vm.defectType.possibleCauses.length > 0\"> <label>Defect Causes</label> <table class=history-t> <tr> <thead> <th>Name</th> <th>Description</th> <th>Course Of Action</th> <th>Priority</th> <th>Enabled</th> <th>Probability</th> </thead> </tr> <tr ng-repeat=\"possibleCause in vm.defectType.possibleCauses | orderBy: '-probability'\"> <td ng-bind=possibleCause.name></td> <td ng-bind=possibleCause.description></td> <td ng-bind=possibleCause.courseOfActionName></td> <td ng-bind=possibleCause.priority></td> <td>{{ possibleCause.enabled ? \"Yes\" : \"No\" }}</td> <td ng-bind=possibleCause.probability></td> </tr> </table> </div> <div class=row style=\"margin:1em -30px;width:auto\"> <div class=\"small-12 columns\"> <div class=\"right dialog-footer\"> <button type=button class=\"button secondary\" ng-click=vm.close()>Close</button> </div> </div> </div> </div> ");

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(3), __webpack_require__(6), __webpack_require__(4), __webpack_require__(658), __webpack_require__(660)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, constant_module_1, notify_service_1, loader_service_1, alertRoleService_1, alertRole_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [notify_service_1.default, loader_service_1.default, alertRoleService_1.default];
    var AlertRolesCtrl = (function () {
        AlertRolesCtrl.$inject = ["loaderService", "notifyService", "AlertRolesService", "$modal", "$timeout"];
        function AlertRolesCtrl(loaderService, notifyService, AlertRolesService, $modal, $timeout) {
            this.alertRoles = new Array();
            this.cancel = function () { };
            this.getRoles = function () {
                var _this = this;
                this.AlertRolesService.getalertroles()
                    .then(function (data) {
                    _this.alertRoles = data;
                });
            };
            this.saveRoles = function () {
                var _this = this;
                if (!this.postingAlerts) {
                    this.postingAlerts = true;
                    var command_1 = { alertRoles: Array() };
                    _.forEach(this.alertRoles, function (ar) {
                        _.forEach((ar.plants), function (arp) {
                            command_1.alertRoles.push({
                                alertRoleMappingId: arp.alertRoleMappingId,
                                Active: arp.active
                            });
                        });
                    });
                    this.AlertRolesService.postalertroles(command_1)
                        .finally(function () {
                        _this.$timeout(function () {
                            _this.getRoles();
                            _this.postingAlerts = false;
                        }, 1500);
                    })
                        .then(function () {
                        _this.notifyService.success('Alert Roles - Updated successfully');
                    }, this.notifyService.handleApiErrors);
                }
            };
            this.AlertRolesService = AlertRolesService;
            this.$timeout = $timeout;
            this.notifyService = notifyService;
            this.getRoles();
        }
        return AlertRolesCtrl;
    }());
    exports.default = angular.module('aps.controller.alertroles', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.ALERTROLES,
            url: '/admin/alertroles',
            controller: 'AlertRolesCtrl as vm',
            template: alertRole_tpl_html_1.default,
            data: {
                pageTitle: 'Alert Roles Enable/Disable for plant',
                authorizeAdmin: true
            }
        });
    }])
        .controller('AlertRolesCtrl', AlertRolesCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(659), __webpack_require__(2), __webpack_require__(0), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, alertRoleModels_1, _, angular, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [http_service_1.default];
    var AlertRolesSvc = (function () {
        AlertRolesSvc.$inject = ["httpService"];
        function AlertRolesSvc(httpService) {
            this.httpService = httpService;
        }
        AlertRolesSvc.prototype.getalertroles = function () {
            return this.httpService.get(constant_module_1.Endpoints.ALERTROLES)
                .then(function (alertRoles) {
                return _.map(alertRoles, function (alertRole) { return new alertRoleModels_1.AlertRoleMappingModel(alertRole); });
            });
        };
        AlertRolesSvc.prototype.postalertroles = function (command) {
            return this.httpService.post(constant_module_1.Endpoints.ALERTROLES, command);
        };
        return AlertRolesSvc;
    }());
    exports.default = angular.module('aps.services.alertRoleservice', requires)
        .service('AlertRolesService', AlertRolesSvc)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, _) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var AlertRoleMappingModel = (function () {
        function AlertRoleMappingModel(alertRole) {
            if (alertRole === void 0) { alertRole = null; }
            if (alertRole) {
                this.roleId = alertRole.roleId;
                this.roleName = alertRole.roleName;
                this.plants = _.map(alertRole.plants, function (plant) {
                    return _.assign(plant, new AlertRolePlant(plant));
                });
            }
        }
        return AlertRoleMappingModel;
    }());
    exports.AlertRoleMappingModel = AlertRoleMappingModel;
    var AlertRolePlant = (function () {
        function AlertRolePlant(plant) {
            if (plant) {
                this.alertRoleMappingId = plant.alertRoleMappingId;
                this.plantId = plant.plantId;
                this.plantName = plant.plantName,
                    this.active = plant.active;
            }
        }
        return AlertRolePlant;
    }());
    exports.AlertRolePlant = AlertRolePlant;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <form name=vm.form ng-submit=vm.saveRoles() novalidate> <div class=body-header> <h2> Alert Roles Toggle </h2> </div> <table class=\"history-t cltable\"> <tr> <thead> <th width=50%>Role</th> <th width=50%>Plants (Active/Inactive)</th> </thead> </tr> <tr ng-repeat=\"alertRole in vm.alertRoles\"> <td> {{ alertRole.roleName }} </td> <td style=display:inline-flex> <div ng-repeat=\"plant in alertRole.plants\" style=display:table> <div style=display:table-row> <div style=display:table-cell> <input type=checkbox ng-model=plant.active /> </div> <div style=\"display:table-cell;padding:10px 10px 0 10px\"> {{ plant.plantName }} </div> </div> </div> </td> </tr> <tr ng-if=\"vm.alertRoles.length == 0\"> <td colspan=3> There are no alert roles defined. </td> </tr> </table> <div ng-if=\"vm.alertRoles.length > 0\" style=width:100%> <button class=\"button pull-right\" type=submit>Save</button> </div> </form> </div>");

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(662), __webpack_require__(3), __webpack_require__(710), __webpack_require__(5), __webpack_require__(4), __webpack_require__(8), __webpack_require__(33), __webpack_require__(7), __webpack_require__(9), __webpack_require__(6), __webpack_require__(54), __webpack_require__(43), __webpack_require__(711), __webpack_require__(713)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, addEquipment_controller_1, constant_module_1, equipmentList_tpl_html_1, aps_enums_1, loader_service_1, navigation_service_1, equipment_service_1, authData_service_1, uiUtility_service_1, notify_service_1, locations_service_1, environment_1, updateConfig_controller_1, diagnostics_controller_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [addEquipment_controller_1.default, loader_service_1.default, notify_service_1.default, equipment_service_1.default, authData_service_1.default,
        uiUtility_service_1.default, locations_service_1.default, environment_1.default, navigation_service_1.default, updateConfig_controller_1.default,
        diagnostics_controller_1.default];
    var ipAddressPattern = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    var EquipmentListCtrl = (function () {
        EquipmentListCtrl.$inject = ["loaderService", "equipmentService", "navigationService", "authDataService", "uiUtilityService", "notifyService", "environment", "locationsService", "$modal"];
        function EquipmentListCtrl(loaderService, equipmentService, navigationService, authDataService, uiUtilityService, notifyService, environment, locationsService, $modal) {
            var _this = this;
            this.loaderService = loaderService;
            this.navigationService = navigationService;
            this.equipmentService = equipmentService;
            this.authDataService = authDataService;
            this.uiUtilityService = uiUtilityService;
            this.notifyService = notifyService;
            this.locationsService = locationsService;
            this.$modal = $modal;
            this.isNotProd = environment.ENV_TYPE !== 'Prod';
            var promise = this.navigationService.getNavigation().then(function (nav) {
                var plants = nav.plants();
                _this.plants = _.filter(plants, function (plant) {
                    return authDataService.isPlantAdmin(plant.id) || authDataService.isAPSIOAdminForPlant(plant.id);
                });
                if (nav.selectedPlant && _.includes(_this.plants, nav.selectedPlant)) {
                    _this.selectedPlant = nav.selectedPlant;
                }
                else {
                    _this.selectedPlant = _.first(_this.plants);
                }
                _this.navigationService.getLocations(false).then(function (locations) {
                    _this.plantLocations = locations;
                    _this.loadLocations();
                });
                return _this.loadEquipment();
            });
            this.loaderService.loadingPromise(promise);
        }
        EquipmentListCtrl.prototype.loadEquipment = function () {
            var _this = this;
            return this.equipmentService
                .get(this.selectedPlant.id)
                .then(function (equipment) {
                _this.equipment = equipment;
                _this.filterEquipment();
            });
        };
        EquipmentListCtrl.prototype.filterEquipment = function () {
            if (this.selectedLocation) {
                this.filteredEquipment = _.filter(this.equipment, { plantLocationId: this.selectedLocation.location.id });
            }
            else {
                this.filteredEquipment = this.equipment;
            }
        };
        EquipmentListCtrl.prototype.loadLocations = function () {
            this.locations = this.locationsService
                .getPlantLocations(this.selectedPlant, this.plantLocations);
            this.selectedLocation = null;
        };
        EquipmentListCtrl.prototype.plantChanged = function () {
            this.loadLocations();
            this.loaderService.loadingPromise(this.loadEquipment());
        };
        EquipmentListCtrl.prototype.locationChanged = function () {
            this.filterEquipment();
        };
        EquipmentListCtrl.prototype.getTypeName = function (type) {
            return _.startCase(aps_enums_1.apsEnums.EquipmentType[type]);
        };
        EquipmentListCtrl.prototype.addEquipment = function () {
            var _this = this;
            var result = addEquipment_controller_1.openAddEquipment({
                plant: this.selectedPlant,
                locations: this.locations,
                isNotProd: this.isNotProd,
                allEquipment: this.equipment,
                ipAddressPattern: ipAddressPattern
            }, this.$modal);
            result.then(function (instance) {
                if (!instance) {
                    return;
                }
                _this.equipment.push(instance);
                _this.filterEquipment();
            });
        };
        EquipmentListCtrl.prototype.editConfig = function (instance) {
            updateConfig_controller_1.openUpdateConfig({
                instance: instance,
                plantId: this.selectedPlant.id,
                locations: this.locations,
                allEquipment: this.equipment,
                isNotProd: this.isNotProd,
                ipAddressPattern: ipAddressPattern
            }, this.$modal);
        };
        EquipmentListCtrl.prototype.toggleActive = function (instance) {
            var _this = this;
            if (instance.active) {
                this.uiUtilityService.confirm('Are you sure you want to disable this equipment?').then(function (confirmed) {
                    if (!confirmed) {
                        return;
                    }
                    _this.loaderService.loadingPromise(_this.equipmentService.disable({
                        id: instance.id,
                        plantId: _this.selectedPlant.id
                    }).then(function () {
                        instance.active = false;
                    }, _this.notifyService.handleApiErrors));
                });
            }
            else {
                this.loaderService.loadingPromise(this.equipmentService.activate({
                    id: instance.id,
                    plantId: this.selectedPlant.id
                }).then(function () {
                    instance.active = true;
                }, this.notifyService.handleApiErrors));
            }
        };
        EquipmentListCtrl.prototype.remove = function (instance) {
            var _this = this;
            this.uiUtilityService.confirm('Are you sure you want to delete this equipment?').then(function (confirmed) {
                if (!confirmed) {
                    return;
                }
                _this.loaderService.loadingPromise(_this.equipmentService.remove({
                    id: instance.id,
                    plantId: _this.selectedPlant.id
                }).then(function () {
                    _.remove(_this.equipment, instance);
                    _this.filterEquipment();
                }, _this.notifyService.handleApiErrors));
            });
        };
        EquipmentListCtrl.prototype.openDiagnostics = function (instance) {
            diagnostics_controller_1.openEquipmentDiagnostics({
                plantId: this.selectedPlant.id,
                equipment: instance,
                timeZoneId: this.selectedPlant.timeZoneId
            }, this.$modal);
        };
        return EquipmentListCtrl;
    }());
    exports.default = angular.module('aps.controller.equipmentList', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.EQUIPMENT,
            url: '/admin/equipment',
            controller: 'EquipmentListCtrl as vm',
            template: equipmentList_tpl_html_1.default,
            data: {
                pageTitle: 'Equipment',
                authorizeAPSIOAdmin: true
            }
        });
    }])
        .controller('EquipmentListCtrl', EquipmentListCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(33), __webpack_require__(6), __webpack_require__(4), __webpack_require__(12), __webpack_require__(5), __webpack_require__(663), __webpack_require__(305), __webpack_require__(306)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, equipment_service_1, notify_service_1, loader_service_1, newguid_service_1, aps_enums_1, addEquipment_tpl_html_1, dataPointsSelector_directive_1, configSelector_directive_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [equipment_service_1.default, notify_service_1.default, loader_service_1.default, newguid_service_1.default, dataPointsSelector_directive_1.default,
        configSelector_directive_1.default];
    function openAddEquipment(data, $modal) {
        return $modal.open({
            template: addEquipment_tpl_html_1.default,
            controller: 'AddEquipmentCtrl as vm',
            resolve: {
                data: function () { return data; }
            }
        }).result;
    }
    exports.openAddEquipment = openAddEquipment;
    var AddEquipmentCtrl = (function () {
        AddEquipmentCtrl.$inject = ["data", "newGuidService", "equipmentService", "$modalInstance", "notifyService", "loaderService", "uiUtilityService"];
        function AddEquipmentCtrl(data, newGuidService, equipmentService, $modalInstance, notifyService, loaderService, uiUtilityService) {
            var _this = this;
            this.equipmentService = equipmentService;
            this.$modalInstance = $modalInstance;
            this.notifyService = notifyService;
            this.loaderService = loaderService;
            this.plant = data.plant;
            this.allLocations = data.locations;
            this.config = {};
            this.instance = {
                isSimulator: false,
                active: false
            };
            this.dataPoints = [];
            this.isNotProd = data.isNotProd;
            this.allEquipment = data.allEquipment;
            this.ipAddressPattern = data.ipAddressPattern;
            newGuidService.getNewGuid('equipment').then(function (id) { return _this.instance.id = id; });
            this.types = _.sortBy(uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.EquipmentType, 1), function (x) { return x.text; });
            this.filterLocations();
        }
        AddEquipmentCtrl.prototype.filterLocations = function () {
            var locationTypes = this.equipmentService.getValidLocationTypes(this.instance.type);
            if (locationTypes.length === 0) {
                this.locations = [];
                return;
            }
            this.locations = _.filter(this.allLocations, function (l) {
                return _.some(locationTypes, function (lt) { return l.locationType === lt; });
            });
        };
        AddEquipmentCtrl.prototype.typeChanged = function () {
            var _this = this;
            this.filterLocations();
            if (this.location) {
                if (!_.some(this.locations, function (l) { return l.id === _this.location.id; })) {
                    this.location = null;
                }
            }
        };
        AddEquipmentCtrl.prototype.add = function () {
            var _this = this;
            if (this.form.$invalid) {
                return;
            }
            _.forEach(this.dataPoints, function (dp) {
                dp.config = JSON.stringify(dp.jsonConfig);
            });
            var command = {
                id: this.instance.id,
                plantId: this.plant.id,
                config: JSON.stringify(this.config),
                type: this.instance.type,
                active: this.instance.active,
                isSimulator: this.instance.isSimulator,
                plantLocationId: this.location.location.id,
                name: this.instance.name,
                dataPoints: JSON.parse(JSON.stringify(this.dataPoints))
            };
            _.forEach(command.dataPoints, function (dp) {
                dp.jsonConfig = undefined;
            });
            this.loaderService.loadingPromise(this.equipmentService.add(command)
                .then(function () {
                _this.instance.config = command.config;
                _this.instance.plantLocationId = command.plantLocationId;
                _this.instance.plantLocationLocationType = _this.location.locationType;
                _this.instance.plantLocationLocationTypeId = _this.location.id;
                if (_this.location.locationType === aps_enums_1.apsEnums.LocationType.Plant) {
                    _this.instance.plantLocationName = _this.plant.name;
                }
                else {
                    _this.instance.plantLocationName = _this.location.name;
                }
                _this.instance.plantLocationPlantId = _this.plant.id;
                _this.instance.dataPoints = command.dataPoints;
                _.forEach(_this.instance.dataPoints, function (dp) {
                    dp.plantId = _this.plant.id;
                });
                _this.$modalInstance.close(_this.instance);
            }, this.notifyService.handleApiErrors));
        };
        AddEquipmentCtrl.prototype.cancel = function () {
            this.$modalInstance.close();
        };
        return AddEquipmentCtrl;
    }());
    exports.default = angular.module('aps.controller.addEquipment', requires)
        .controller('AddEquipmentCtrl', AddEquipmentCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <h2 class=modal-header>Add Equipment</h2> <form name=vm.form ng-submit=vm.add() novalidate> <div class=container style=\"margin:0 -30px\"> <div class=row> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Name: <input name=name type=text ng-model=vm.instance.name required/> </label> <div ng-messages=vm.form.name.$error ng-if=\"vm.form.name.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-6 columns\"> <label>Active <input type=checkbox ng-model=vm.instance.active /> </label> </div> </div> <div class=row> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Type: <select name=type ng-model=vm.instance.type required ng-options=\"t.value as t.text for t in vm.types\" ng-change=vm.typeChanged()> <option value=\"\">-- Select a Type --</option> </select> </label> <div ng-messages=vm.form.type.$error ng-if=\"vm.form.type.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-6 columns\" ng-if=\"vm.isNotProd && vm.instance.type && vm.instance.type < 5\"> <label>Simulator <input type=checkbox ng-model=vm.instance.isSimulator /> </label> </div> </div> <div class=row ng-if=\"vm.locations && vm.locations.length > 0\"> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Location: <select name=location ng-model=vm.location required ng-options=\"l.name for l in vm.locations\"> <option value=\"\">-- Select a Location --</option> </select> </label> <div ng-messages=vm.form.location.$error ng-if=\"vm.form.location.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> </div> <aps-config-selector ng-if=\"vm.location && vm.instance.type\"></aps-config-selector> <aps-data-points-selector ng-if=\"vm.location && vm.instance.type\"></aps-data-points-selector> <div class=row> <div class=\"large-12 columns\"> <span class=required>* Required Fields</span> <div class=\"right dialog-footer\"> <button ng-click=vm.cancel() type=button class=\"button secondary\">Cancel</button> <button class=button type=submit>Add Equipment</button> </div> </div> </div> </div> </form> </div>");

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div ng-if=\"vm.instance.type === 2\"> <aps-plc-data-points></aps-plc-data-points> </div> <div ng-if=\"vm.instance.type === 5\"> <aps-heye-data-points></aps-heye-data-points> </div> <div ng-if=\"vm.instance.type === 9\"> <aps-raspberry-pi-data-points></aps-raspberry-pi-data-points> </div> <div ng-if=\"vm.instance.type === 15\"> <aps-flex-is-data-points></aps-flex-is-data-points> </div> <div ng-if=\"vm.instance.type === 17 || vm.instance.type === 18 || vm.instance.type === 19\"> <aps-counter-simple-data-points></aps-counter-simple-data-points> </div> <div ng-if=\"vm.instance.type === 20\"> <aps-monitoring-data-points></aps-monitoring-data-points> </div> <div ng-if=\"vm.instance.type === 23 || vm.instance.type === 24\"> <aps-cbit-data-points></aps-cbit-data-points> </div> ");

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(12), __webpack_require__(25), __webpack_require__(4), __webpack_require__(5), __webpack_require__(666)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, newguid_service_1, defectType_service_1, loader_service_1, aps_enums_1, heyeDataPoints_tpl_html_1) {
    "use strict";
    heyeDataPoints.$inject = ["newGuidService", "defectTypeService", "loaderService", "$q"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [newguid_service_1.default, defectType_service_1.default, loader_service_1.default];
    exports.default = angular.module('aps.controller.heyeDataPoints', requires)
        .directive('apsHeyeDataPoints', heyeDataPoints)
        .name;
    function heyeDataPoints(newGuidService, defectTypeService, loaderService, $q) {
        return {
            restrict: 'E',
            template: heyeDataPoints_tpl_html_1.default,
            link: function (scope) {
                var promises = [defectTypeService.getDefectTypesAndClassificationsNoExclusion().then(function (results) {
                        scope.types = _.sortBy(results.types, function (x) { return x.name; });
                    })];
                var createDataPoint = function (active, type, channel) {
                    return {
                        type: type,
                        config: null,
                        jsonConfig: { Channel: channel, Active: active },
                        configType: aps_enums_1.apsEnums.DataPointConfigType.HEYECounter,
                        id: null,
                        name: '',
                        plantLocationId: null
                    };
                };
                var setPlantLocationId = function () { return scope.vm.dataPoints.forEach(function (dp) {
                    return dp.plantLocationId = scope.vm.location ? scope.vm.location.location.id : null;
                }); };
                if (scope.vm.dataPoints.length === 0) {
                    scope.vm.dataPoints.push(createDataPoint(true, aps_enums_1.apsEnums.DataPointType.Inspect));
                    scope.vm.dataPoints.push(createDataPoint(true, aps_enums_1.apsEnums.DataPointType.Reject));
                    for (var i = 1; i <= 32; i++) {
                        scope.vm.dataPoints.push(createDataPoint(false, aps_enums_1.apsEnums.DataPointType.Reject, i));
                    }
                    scope.vm.dataPoints.push(createDataPoint(false, aps_enums_1.apsEnums.DataPointType.Reject, 33));
                    scope.vm.dataPoints.push(createDataPoint(false, aps_enums_1.apsEnums.DataPointType.Reject, 34));
                    promises.push(newGuidService.getNewGuids('dataPoint', scope.vm.dataPoints.length)
                        .then(function (ids) { return scope.vm.dataPoints.forEach(function (dp, i) { return dp.id = ids[i]; }); }));
                    setPlantLocationId();
                }
                scope.$watch('vm.location', setPlantLocationId);
                scope.channels = scope.vm.dataPoints.filter(function (x) { return x.jsonConfig.Channel > 0; });
                loaderService.loadingPromise($q.all(promises));
                var setNames = function () {
                    var heyeName = (scope.vm.instance.name || 'HEYE');
                    scope.vm.dataPoints.forEach(function (dp) {
                        if (dp.jsonConfig.Channel) {
                            if (dp.jsonConfig.Channel <= 32) {
                                dp.name = heyeName + ' CH' + ('00' + dp.jsonConfig.Channel).slice(-2);
                            }
                            else {
                                dp.name = heyeName + ' CH' + dp.jsonConfig.Channel;
                            }
                            console.log(dp.jsonConfig.Channel);
                            console.log(dp.name);
                        }
                        else if (dp.type === aps_enums_1.apsEnums.DataPointType.Inspect) {
                            dp.name = heyeName + ' Inspect';
                        }
                        else {
                            dp.name = heyeName + ' Reject';
                        }
                    });
                };
                setNames();
                scope.$watch('vm.instance.name', setNames);
            }
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <div class=row> <h3>Channels</h3> </div> <div class=row> <div class=\"large-6 small-12 columns\" ng-repeat=\"dp in channels\"> <div class=row> <div class=\"large-8 small-12 columns\"> <label ng-if=\"$index <= 31\">Channel {{($index + 1)}}</label> <label ng-if=\"$index === 32\">Channel {{($index + 1)}} (MNR Reject)</label> <label ng-if=\"$index === 33\">Channel {{($index + 1)}} (System Reject)</label> </div> <div class=\"large-4 small-12 column\" ng-repeat-end> <label>Active: <input type=checkbox name=\"active{{$index}}\" ng-model=dp.jsonConfig.Active /> </label> </div> </div> <div class=row> <div class=\"large-12 small-12 column\"> <select name=\"defect{{$index}}\" ng-model=dp.jsonConfig.DefectTypeId ng-required=dp.jsonConfig.Active ng-options=\"t.id as t.name for t in types\"> <option value=\"\">-- Select Defect --</option> </select> <div ng-messages=\"vm.form['defect' + $index].$error\" ng-if=\"vm.form['defect' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> </div> </div> </div> </div> ");

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(9), __webpack_require__(12), __webpack_require__(5), __webpack_require__(668)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, uiUtility_service_1, newguid_service_1, aps_enums_1, plcDataPoints_tpl_html_1) {
    "use strict";
    plcDataPoints.$inject = ["newGuidService", "uiUtilityService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [newguid_service_1.default, uiUtility_service_1.default];
    exports.default = angular.module('aps.controller.plcDataPoints', requires)
        .directive('apsPlcDataPoints', plcDataPoints)
        .name;
    function plcDataPoints(newGuidService, uiUtilityService) {
        return {
            restrict: 'E',
            template: plcDataPoints_tpl_html_1.default,
            link: function (scope) {
                scope.types = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.DataPointType, 1);
                scope.vm.dataPoints = _.sortBy(scope.vm.dataPoints, ['jsonConfig.Dbw', 'name']);
                scope.addDataPoint = function () {
                    var dataPoint = {
                        config: null,
                        jsonConfig: {},
                        configType: aps_enums_1.apsEnums.DataPointConfigType.PlcCounter,
                        id: null,
                        name: '',
                        type: null,
                        plantLocationId: scope.vm.location.location.id
                    };
                    newGuidService.getNewGuid('dataPoint').then(function (id) { return dataPoint.id = id; });
                    scope.vm.dataPoints.push(dataPoint);
                };
                var setDataPointLocations = function () {
                    scope.locations = [scope.vm.location].concat(scope.vm.location.children);
                    scope.vm.dataPoints.forEach(function (dp) {
                        if (_.some(scope.locations, function (l) { return l.location.id === dp.plantLocationId; })) {
                            return;
                        }
                        dp.plantLocationId = scope.vm.location.location.id;
                    });
                };
                scope.$watch('vm.location', setDataPointLocations);
                setDataPointLocations();
                scope.removeDataPoint = function (dataPoint) {
                    return _.remove(scope.vm.dataPoints, dataPoint);
                };
            }
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div ng-if=vm.location> <div class=row> <h3>Data Points</h3> </div> <div class=row ng-repeat=\"dp in vm.dataPoints\"> <div class=\"large-3 column\"> <label><span class=\"required notated\">*</span>Name: <input name=\"name{{$index}}\" type=text ng-model=dp.name required/> </label> <div ng-messages=\"vm.form['name' + $index].$error\" ng-if=\"vm.form['name' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-3 column\"> <label><span class=\"required notated\">*</span>Location: <select name=\"location{{$index}}\" ng-model=dp.plantLocationId ng-options=\"t.location.id as t.name for t in locations\"> </select> </label> </div> <div class=\"large-3 column\"> <label><span class=\"required notated\">*</span>Type: <select name=\"type{{$index}}\" ng-model=dp.type required ng-options=\"t.value as t.text for t in types\"> <option value=\"\">-- Select Type --</option> </select> </label> <div ng-messages=\"vm.form['type' + $index].$error\" ng-if=\"vm.form['type' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-2 column\" ng-if=!vm.instance.isSimulator> <label><span class=\"required notated\">*</span>DBW: <input name=\"dbw{{$index}}\" type=number ng-model=dp.jsonConfig.Dbw required min=0 /> </label> <div ng-messages=\"vm.form['dbw' + $index].$error\" ng-if=\"vm.form['dbw' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be 0 or more</div> </div> </div> <div class=\"large-2 column\" ng-if=vm.instance.isSimulator> <label><span class=\"required notated\">*</span>BPH: <input name=\"count{{$index}}\" type=number ng-model=dp.jsonConfig.CountPerHour required min=0 /> </label> <div ng-messages=\"vm.form['count' + $index].$error\" ng-if=\"vm.form['count' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be 0 or more</div> </div> </div> <div class=\"large-1 column\"> <button type=button class=\"button alert\" ng-click=removeDataPoint(dp)><i class=\"fa fa-trash\"></i></button> </div> </div> <div class=row> <div class=\"large-4 columns\"> <button type=button class=button ng-click=addDataPoint()>Add Data Point</button> </div> <div class=\"large-8 columns\"> &nbsp; </div> </div> </div> ");

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(9), __webpack_require__(12), __webpack_require__(5), __webpack_require__(670)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, uiUtility_service_1, newguid_service_1, aps_enums_1, flexIsDataPoints_tpl_html_1) {
    "use strict";
    flexIsDataPoints.$inject = ["newGuidService", "uiUtilityService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [newguid_service_1.default, uiUtility_service_1.default];
    exports.default = angular.module('aps.controller.flexIsDataPoints', requires)
        .directive('apsFlexIsDataPoints', flexIsDataPoints)
        .name;
    function flexIsDataPoints(newGuidService, uiUtilityService) {
        return {
            restrict: 'E',
            template: flexIsDataPoints_tpl_html_1.default,
            link: function (scope) {
                scope.types = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.DataPointType, 1);
                scope.flxIsDataPointAliases = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.FlexISDataPointAliases, 1);
                scope.vm.dataPoints = _.sortBy(scope.vm.dataPoints, ['jsonConfig.Signal', 'name']);
                scope.addDataPoint = function () {
                    var dataPoint = {
                        config: null,
                        jsonConfig: {},
                        configType: aps_enums_1.apsEnums.DataPointConfigType.FlexISCounter,
                        id: null,
                        name: '',
                        type: null,
                        plantLocationId: scope.vm.location.location.id
                    };
                    newGuidService.getNewGuid('dataPoint').then(function (id) { return dataPoint.id = id; });
                    scope.vm.dataPoints.push(dataPoint);
                };
                var setDataPointLocations = function () {
                    scope.locations = [scope.vm.location].concat(scope.vm.location.children);
                    scope.vm.dataPoints.forEach(function (dp) {
                        if (_.some(scope.locations, function (l) { return l.location.id === dp.plantLocationId; })) {
                            return;
                        }
                        dp.plantLocationId = scope.vm.location.location.id;
                    });
                };
                scope.$watch('vm.location', setDataPointLocations);
                setDataPointLocations();
                scope.removeDataPoint = function (dataPoint) {
                    return _.remove(scope.vm.dataPoints, dataPoint);
                };
            }
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div ng-if=vm.location> <div class=row> <h3>Data Points</h3> </div> <div class=row ng-repeat=\"dp in vm.dataPoints\"> <div class=row> <div class=\"large-3 column\"> <label><span class=\"required notated\">*</span>Name: <input name=\"name{{$index}}\" type=text ng-model=dp.name required/> </label> <div ng-messages=\"vm.form['name' + $index].$error\" ng-if=\"vm.form['name' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-2 column\"> <label><span class=\"required notated\">*</span>Location: <select name=\"location{{$index}}\" ng-model=dp.plantLocationId ng-options=\"t.location.id as t.name for t in locations\"> </select> </label> </div> <div class=\"large-2 column\"> <label><span class=\"required notated\">*</span>Type: <select name=\"type{{$index}}\" ng-model=dp.type required ng-options=\"t.value as t.text for t in types\"> <option value=\"\">-- Select Type --</option> </select> </label> <div ng-messages=\"vm.form['type' + $index].$error\" ng-if=\"vm.form['type' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-1 column\"> <label>Source: <input name=\"source{{$index}}\" type=text ng-model=dp.jsonConfig.Source min=0 /> </label> </div> <div class=\"large-3 column\"> <label><span class=\"required notated\">*</span>Signal: <input name=\"signal{{$index}}\" type=text ng-model=dp.jsonConfig.Signal required min=0 /> </label> <div ng-messages=\"vm.form['signal' + $index].$error\" ng-if=\"vm.form['signal' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-1 column\"> <label style=padding-top:20px>Off: <input name=\"source{{$index}}\" type=checkbox ng-model=dp.jsonConfig.Off /> </label> </div> </div> <div class=row> <div class=\"large-3 column\"> <label>Alias: <select name=\"alias{{$index}}\" ng-model=dp.jsonConfig.Alias ng-options=\"t.value as t.text for t in flxIsDataPointAliases\"> <option value=\"\">-- Select Type --</option> </select> </label> <div ng-messages=\"vm.form['alias' + $index].$error\" ng-if=\"vm.form['alias' + $index].$dirty || vm.form.$submitted\" role=alert> </div> </div> <div class=\"large-1 column\"> <button type=button class=\"button alert\" ng-click=removeDataPoint(dp)><i class=\"fa fa-trash\"></i></button> </div> </div> </div> <div class=row> <div class=\"large-4 columns\"> <button type=button class=button ng-click=addDataPoint()>Add Data Point</button> </div> <div class=\"large-8 columns\"> &nbsp; </div> </div> </div> ");

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(9), __webpack_require__(12), __webpack_require__(5), __webpack_require__(672)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, uiUtility_service_1, newguid_service_1, aps_enums_1, raspberryPiDataPoints_tpl_html_1) {
    "use strict";
    raspberryPiDataPoints.$inject = ["newGuidService", "uiUtilityService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [newguid_service_1.default, uiUtility_service_1.default];
    exports.default = angular.module('aps.controller.raspberryPiDataPoints', requires)
        .directive('apsRaspberryPiDataPoints', raspberryPiDataPoints)
        .name;
    function raspberryPiDataPoints(newGuidService, uiUtilityService) {
        return {
            restrict: 'E',
            template: raspberryPiDataPoints_tpl_html_1.default,
            link: function (scope) {
                scope.types = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.DataPointType, 1);
                scope.vm.dataPoints = _.sortBy(scope.vm.dataPoints, ['jsonConfig.Channel', 'name']);
                scope.addDataPoint = function () {
                    var dataPoint = {
                        config: null,
                        jsonConfig: {},
                        configType: aps_enums_1.apsEnums.DataPointConfigType.RaspberryPiCounter,
                        id: null,
                        name: '',
                        type: null,
                        plantLocationId: scope.vm.location.location.id
                    };
                    newGuidService.getNewGuid('dataPoint').then(function (id) { return dataPoint.id = id; });
                    scope.vm.dataPoints.push(dataPoint);
                };
                var setDataPointLocations = function () {
                    scope.locations = [scope.vm.location].concat(scope.vm.location.children);
                    scope.vm.dataPoints.forEach(function (dp) {
                        if (_.some(scope.locations, function (l) { return l.location.id === dp.plantLocationId; })) {
                            return;
                        }
                        dp.plantLocationId = scope.vm.location.location.id;
                    });
                };
                scope.$watch('vm.location', setDataPointLocations);
                setDataPointLocations();
                scope.removeDataPoint = function (dataPoint) {
                    return _.remove(scope.vm.dataPoints, dataPoint);
                };
            }
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div ng-if=vm.location> <div class=row> <h3>Data Points</h3> </div> <div class=row ng-repeat=\"dp in vm.dataPoints\"> <div class=\"large-3 column\"> <label><span class=\"required notated\">*</span>Name: <input name=\"name{{$index}}\" type=text ng-model=dp.name required/> </label> <div ng-messages=\"vm.form['name' + $index].$error\" ng-if=\"vm.form['name' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-3 column\"> <label><span class=\"required notated\">*</span>Location: <select name=\"location{{$index}}\" ng-model=dp.plantLocationId ng-options=\"t.location.id as t.name for t in locations\"> </select> </label> </div> <div class=\"large-3 column\"> <label><span class=\"required notated\">*</span>Type: <select name=\"type{{$index}}\" ng-model=dp.type required ng-options=\"t.value as t.text for t in types\"> <option value=\"\">-- Select Type --</option> </select> </label> <div ng-messages=\"vm.form['type' + $index].$error\" ng-if=\"vm.form['type' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-2 column\" ng-if=!vm.instance.isSimulator> <label><span class=\"required notated\">*</span>Channel: <input name=\"dbw{{$index}}\" type=number ng-model=dp.jsonConfig.Channel required min=0 /> </label> <div ng-messages=\"vm.form['dbw' + $index].$error\" ng-if=\"vm.form['dbw' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be 0 or more</div> </div> </div> <div class=\"large-1 column\"> <button type=button class=\"button alert\" ng-click=removeDataPoint(dp)><i class=\"fa fa-trash\"></i></button> </div> </div> <div class=row> <div class=\"large-4 columns\"> <button type=button class=button ng-click=addDataPoint()>Add Data Point</button> </div> <div class=\"large-8 columns\"> &nbsp; </div> </div> </div> ");

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(9), __webpack_require__(12), __webpack_require__(5), __webpack_require__(674)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, uiUtility_service_1, newguid_service_1, aps_enums_1, CounterSimpleDataPoints_tpl_html_1) {
    "use strict";
    counterSimpleDataPoints.$inject = ["newGuidService", "uiUtilityService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [newguid_service_1.default, uiUtility_service_1.default];
    exports.default = angular.module('aps.controller.CounterSimpleDataPoints', requires)
        .directive('apsCounterSimpleDataPoints', counterSimpleDataPoints)
        .name;
    function counterSimpleDataPoints(newGuidService, uiUtilityService) {
        return {
            restrict: 'E',
            template: CounterSimpleDataPoints_tpl_html_1.default,
            link: function (scope) {
                var dataPointTypes = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.DataPointType, 1);
                scope.types = _.filter(dataPointTypes, function (dp) { return dp.value === 1 || dp.value === 2; });
                scope.sensorTypes = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.SensorType, 1);
                scope.vm.dataPoints = _.sortBy(scope.vm.dataPoints, ['jsonConfig.Signal', 'name']);
                scope.addDataPoint = function () {
                    var dataPoint = {
                        config: null,
                        jsonConfig: { On: true, SensorType: aps_enums_1.apsEnums.SensorType.PlcCounter },
                        configType: aps_enums_1.apsEnums.DataPointConfigType.CounterSimple,
                        id: null,
                        name: '',
                        type: null,
                        plantLocationId: scope.vm.location.location.id
                    };
                    newGuidService.getNewGuid('dataPoint').then(function (id) { return dataPoint.id = id; });
                    scope.vm.dataPoints.push(dataPoint);
                };
                var setDataPointLocations = function () {
                    scope.locations = [scope.vm.location].concat(scope.vm.location.children);
                    scope.vm.dataPoints.forEach(function (dp) {
                        if (_.some(scope.locations, function (l) { return l.location.id === dp.plantLocationId; })) {
                            return;
                        }
                        dp.plantLocationId = scope.vm.location.location.id;
                    });
                };
                scope.$watch('vm.location', setDataPointLocations);
                setDataPointLocations();
                scope.removeDataPoint = function (dataPoint) {
                    return _.remove(scope.vm.dataPoints, dataPoint);
                };
            }
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div ng-if=vm.location> <div class=row> <h3>Data Points</h3> </div> <div class=row ng-repeat=\"dp in vm.dataPoints\"> <div class=row> <div class=\"large-3 column\"> <label><span class=\"required notated\">*</span>Name: <input name=\"name{{$index}}\" type=text ng-model=dp.name required/> </label> <div ng-messages=\"vm.form['name' + $index].$error\" ng-if=\"vm.form['name' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-9 column\"> <label><span class=\"required notated\">*</span>Tag: <input name=\"tag{{$index}}\" type=text ng-model=dp.jsonConfig.Tag required/> </label> <div ng-messages=\"vm.form['tag' + $index].$error\" ng-if=\"vm.form['tag' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> </div> <div class=row> <div class=\"large-2 column\"> <label><span class=\"required notated\">*</span>Location: <select name=\"location{{$index}}\" ng-model=dp.plantLocationId ng-options=\"t.location.id as t.name for t in locations\"> </select> </label> </div> <div class=\"large-2 column\"> <label><span class=\"required notated\">*</span>Type: <select name=\"type{{$index}}\" ng-model=dp.type required ng-options=\"t.value as t.text for t in types\"> <option value=\"\">-- Select Type --</option> </select> </label> <div ng-messages=\"vm.form['type' + $index].$error\" ng-if=\"vm.form['type' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-2 column\"> <label><span class=\"required notated\">*</span>Rollover Value: <input name=\"rollOver{{$index}}\" type=text ng-model=dp.jsonConfig.RollOverValue required/> </label> <div ng-messages=\"vm.form['rollOver' + $index].$error\" ng-if=\"vm.form['rollOver' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-2 column\"> <label><span class=\"required notated\">*</span>Sensor Type: <select name=\"sesnorType{{$index}}\" ng-model=dp.jsonConfig.SensorType required ng-options=\"t.value as t.text for t in sensorTypes\" disabled=disabled> <option value=\"\">-- Select Type --</option> </select> </label> <div ng-messages=\"vm.form['sesnorType' + $index].$error\" ng-if=\"vm.form['sesnorType' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-1 column\"> <button type=button class=\"button alert\" ng-click=removeDataPoint(dp)><i class=\"fa fa-trash\"></i></button> </div> </div> </div> <div class=row> <div class=\"large-4 columns\"> <button type=button class=button ng-click=addDataPoint()>Add Data Point</button> </div> <div class=\"large-8 columns\"> &nbsp; </div> </div> </div> ");

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(9), __webpack_require__(12), __webpack_require__(5), __webpack_require__(676)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, uiUtility_service_1, newguid_service_1, aps_enums_1, MonitoringDataPoints_tpl_html_1) {
    "use strict";
    monitoringDataPoints.$inject = ["newGuidService", "uiUtilityService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [newguid_service_1.default, uiUtility_service_1.default];
    exports.default = angular.module('aps.controller.MonitoringDataPoints', requires)
        .directive('apsMonitoringDataPoints', monitoringDataPoints)
        .name;
    function monitoringDataPoints(newGuidService, uiUtilityService) {
        return {
            restrict: 'E',
            template: MonitoringDataPoints_tpl_html_1.default,
            link: function (scope) {
                var dataPointTypes = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.DataPointType, 1);
                var sensorTypes = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.SensorType, 1);
                scope.types = _.filter(dataPointTypes, function (dp) { return dp.value === 3 || dp.value === 5; });
                scope.sensorTypes = _.filter(sensorTypes, function (dp) { return dp.value > 1; });
                scope.vm.dataPoints = _.sortBy(scope.vm.dataPoints, ['jsonConfig.Signal', 'name']);
                scope.addDataPoint = function () {
                    var dataPoint = {
                        config: null,
                        jsonConfig: { On: true, SensorType: aps_enums_1.apsEnums.SensorType.Monitoring },
                        configType: aps_enums_1.apsEnums.DataPointConfigType.CounterSimple,
                        id: null,
                        name: '',
                        type: aps_enums_1.apsEnums.DataPointType.Monitoring,
                        plantLocationId: scope.vm.location.location.id
                    };
                    newGuidService.getNewGuid('dataPoint').then(function (id) { return dataPoint.id = id; });
                    scope.vm.dataPoints.push(dataPoint);
                };
                var setDataPointLocations = function () {
                    scope.locations = [scope.vm.location].concat(scope.vm.location.children);
                    scope.vm.dataPoints.forEach(function (dp) {
                        if (_.some(scope.locations, function (l) { return l.location.id === dp.plantLocationId; })) {
                            return;
                        }
                        dp.plantLocationId = scope.vm.location.location.id;
                    });
                };
                scope.$watch('vm.location', setDataPointLocations);
                setDataPointLocations();
                scope.removeDataPoint = function (dataPoint) {
                    return _.remove(scope.vm.dataPoints, dataPoint);
                };
            }
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div ng-if=vm.location> <div class=row> <h3>Data Points</h3> </div> <div class=row ng-repeat=\"dp in vm.dataPoints\"> <div class=row> <div class=\"large-3 column\"> <label><span class=\"required notated\">*</span>Name: <input name=\"name{{$index}}\" type=text ng-model=dp.name required/> </label> <div ng-messages=\"vm.form['name' + $index].$error\" ng-if=\"vm.form['name' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-9 column\"> <label><span class=\"required notated\">*</span>Tag: <input name=\"tag{{$index}}\" type=text ng-model=dp.jsonConfig.Tag required/> </label> <div ng-messages=\"vm.form['tag' + $index].$error\" ng-if=\"vm.form['tag' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> </div> <div class=row> <div class=\"large-2 column\"> <label><span class=\"required notated\">*</span>Location: <select name=\"location{{$index}}\" ng-model=dp.plantLocationId ng-options=\"t.location.id as t.name for t in locations\"> </select> </label> </div> <div class=\"large-2 column\"> <label><span class=\"required notated\">*</span>Type: <select name=\"type{{$index}}\" ng-model=dp.type required ng-options=\"t.value as t.text for t in types\"> <option value=\"\">-- Select Type --</option> </select> </label> <div ng-messages=\"vm.form['type' + $index].$error\" ng-if=\"vm.form['type' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-2 column\"> <label><span class=\"required notated\">*</span>Sensor Type: <select name=\"sesnorType{{$index}}\" ng-model=dp.jsonConfig.SensorType required ng-options=\"t.value as t.text for t in sensorTypes\"> <option value=\"\">-- Select Type --</option> </select> </label> <div ng-messages=\"vm.form['sesnorType' + $index].$error\" ng-if=\"vm.form['sesnorType' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-1 column\"> <button type=button class=\"button alert\" ng-click=removeDataPoint(dp)><i class=\"fa fa-trash\"></i></button> </div> </div> </div> <div class=row> <div class=\"large-4 columns\"> <button type=button class=button ng-click=addDataPoint()>Add Data Point</button> </div> <div class=\"large-8 columns\"> &nbsp; </div> </div> </div> ");

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(9), __webpack_require__(12), __webpack_require__(5), __webpack_require__(678)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, uiUtility_service_1, newguid_service_1, aps_enums_1, cbitDataPoints_tpl_html_1) {
    "use strict";
    cbitDataPoints.$inject = ["newGuidService", "uiUtilityService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [newguid_service_1.default, uiUtility_service_1.default];
    exports.default = angular
        .module("aps.controller.cbitDataPoints", requires)
        .directive("apsCbitDataPoints", cbitDataPoints).name;
    function cbitDataPoints(newGuidService, uiUtilityService) {
        return {
            restrict: "E",
            template: cbitDataPoints_tpl_html_1.default,
            link: function (scope) {
                var dataPointTypes = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.DataPointType, 1);
                scope.types = _.filter(dataPointTypes, function (dp) { return dp.value === 1 || dp.value === 2; });
                scope.vm.dataPoints = _.sortBy(scope.vm.dataPoints, [
                    "jsonConfig.Channel",
                    "name",
                ]);
                scope.addDataPoint = function () {
                    var dataPoint = {
                        config: null,
                        jsonConfig: { Defect: false },
                        configType: scope.vm.instance.type === aps_enums_1.apsEnums.EquipmentType.CBIT ? aps_enums_1.apsEnums.DataPointConfigType.CBITCounter : aps_enums_1.apsEnums.DataPointConfigType.CyclopsCounter,
                        id: null,
                        name: "",
                        type: null,
                        plantLocationId: scope.vm.location.location.id,
                    };
                    newGuidService
                        .getNewGuid("dataPoint")
                        .then(function (id) { return (dataPoint.id = id); });
                    scope.vm.dataPoints.push(dataPoint);
                };
                var setDataPointLocations = function () {
                    scope.locations = [scope.vm.location].concat(scope.vm.location.children);
                    scope.vm.dataPoints.forEach(function (dp) {
                        if (_.some(scope.locations, function (l) { return l.location.id === dp.plantLocationId; })) {
                            return;
                        }
                        dp.plantLocationId = scope.vm.location.location.id;
                    });
                };
                var watchLocation = scope.$watch("vm.location", setDataPointLocations);
                setDataPointLocations();
                scope.removeDataPoint = function (dataPoint) {
                    return _.remove(scope.vm.dataPoints, dataPoint);
                };
                scope.$on("$destroy", function () { return watchLocation(); });
            },
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div ng-if=vm.location> <div class=row> <h3>Data Points</h3> </div> <div class=row ng-repeat=\"dp in vm.dataPoints\"> <div class=row> <div class=\"large-3 column\"> <label><span class=\"required notated\">*</span>Name: <input name=\"name{{$index}}\" type=text ng-model=dp.name required/> </label> <div ng-messages=\"vm.form['name' + $index].$error\" ng-if=\"vm.form['name' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div> Required </div> </div> </div> <div class=\"large-2 column\"> <label><span class=\"required notated\">*</span>Location: <select name=\"location{{$index}}\" ng-model=dp.plantLocationId ng-options=\"t.location.id as t.name for t in locations\"></select> </label> </div> <div class=\"large-2 column\"> <label><span class=\"required notated\">*</span>Type: <select name=\"type{{$index}}\" ng-model=dp.type required ng-options=\"t.value as t.text for t in types\"> <option value=\"\">-- Select Type --</option> </select> </label> <div ng-messages=\"vm.form['type' + $index].$error\" ng-if=\"vm.form['type' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div> Required </div> </div> </div> <div class=\"large-2 column\" ng-if=\"(vm.instance.type === 23 && dp.type === 2)\"> <label><span class=\"required notated\">*</span> Defect Name: <input name=\"defectName{{$index}}\" type=text ng-model=dp.jsonConfig.DefectName /> </label> <div ng-messages=\"vm.form['defectName' + $index].$error\" ng-if=\"vm.form['defectName' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div> Required </div> </div> </div> <div class=\"large-2 column\" ng-if=\"(vm.instance.type === 24)\"> <label><span class=\"required notated\">*</span> Tag Name: <input name=\"tagName{{$index}}\" type=text ng-model=dp.jsonConfig.TagName required/> </label> <div ng-messages=\"vm.form['tagName' + $index].$error\" ng-if=\"vm.form['tagName' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div> Required </div> </div> </div> <div class=\"large-2 column\" ng-if=\"!vm.instance.isSimulator && (vm.instance.type === 23 && dp.type === 2) || (vm.instance.type === 24)\"> <label><span class=\"required notated\">*</span>Channel: <input name=\"channel{{$index}}\" type=number ng-model=dp.jsonConfig.Channel ng-change=\"dp.jsonConfig.Defect = (vm.instance.type ===23 && dp.jsonConfig.Channel >= 0) \r\n\t\t\t\t\t\t                                 || ((vm.instance.type === 24 && (dp.jsonConfig.TagName != 'GoodParts' && dp.jsonConfig.TagName != 'BadParts')))\" ng-required=\"(vm.instance.type === 24) ? dp.jsonConfig.TagName : dp.jsonConfig.DefectName\" min=0 /> </label> <div ng-messages=\"vm.form['channel' + $index].$error\" ng-if=\"vm.form['channel' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div> Required </div> <div ng-message=number class=req-w> <div class=arrow-up></div> Must be a number </div> <div ng-message=min class=req-w> <div class=arrow-up></div> Must be 0 or more </div> </div> </div> <div class=\"large-1 column\"> <button type=button class=\"button alert\" ng-click=removeDataPoint(dp)> <i class=\"fa fa-trash\"></i> </button> </div> </div> </div> <div class=row> <div class=\"large-4 columns\"> <button type=button class=button ng-click=addDataPoint()> Add Data Point </button> </div> <div class=\"large-8 columns\">&nbsp;</div> </div> </div> ");

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div ng-if=\"vm.instance.type === 1\"> <aps-scale-config></aps-scale-config> </div> <div ng-if=\"vm.instance.type === 2\"> <aps-plc-config></aps-plc-config> </div> <div ng-if=\"vm.instance.type === 3 || vm.instance.type === 4\"> <aps-wsi-config></aps-wsi-config> </div> <div ng-if=\"vm.instance.type === 5\"> <aps-heye-config></aps-heye-config> </div> <div ng-if=\"vm.instance.type === 6\"> <aps-serial-converter-config></aps-serial-converter-config> </div> <div ng-if=\"vm.instance.type === 7\"> <aps-ai-server-config></aps-ai-server-config> </div> <div ng-if=\"vm.instance.type === 8\"> <aps-check-detector-config></aps-check-detector-config> </div> <div ng-if=\"vm.instance.type === 9 || vm.instance.type === 23 || vm.instance.type === 24\"> <aps-raspberry-pi-config></aps-raspberry-pi-config> </div> <div ng-if=\"vm.instance.type === 10\"> <tiama-config></tiama-config> </div> <div ng-if=\"vm.instance.type === 11\"> <tiama-config></tiama-config> </div> <div ng-if=\"vm.instance.type === 12\"> <tiama-config></tiama-config> </div> <div ng-if=\"vm.instance.type === 13 || vm.instance.type === 14\"> <aps-flex-inspect-config></aps-flex-inspect-config> </div> <div ng-if=\"vm.instance.type === 15\"> <aps-flex-is-config></aps-flex-is-config> </div> <div ng-if=\"vm.instance.type === 16\"> <aps-line-server-config></aps-line-server-config> </div> <div ng-if=\"vm.instance.type === 17 || vm.instance.type === 21 || vm.instance.type === 22\"> <aps-kepware-counter-config></aps-kepware-counter-config> </div> <div ng-if=\"vm.instance.type === 18 || vm.instance.type === 20\"> <aps-sql-counter-config></aps-sql-counter-config> </div> <div ng-if=\"vm.instance.type === 19\"> <aps-ppc-scale-config></aps-ppc-scale-config> </div>");

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(681)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, aiServerConfig_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.controller.aiServerConfig', [])
        .directive('apsAiServerConfig', function () {
        return {
            restrict: 'E',
            template: aiServerConfig_tpl_html_1.default
        };
    })
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <div class=row ng-if=!vm.instance.isSimulator> <div class=\"large-4 columns\"> <label><span class=\"required notated\">*</span>IP Address: <input name=hostName type=text ng-model=vm.config.HostName required ng-pattern=vm.ipAddressPattern /> </label> <div ng-messages=vm.form.hostName.$error ng-if=\"vm.form.hostName.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=pattern class=req-w><div class=arrow-up></div>Invalid IP Address</div> </div> </div> <div class=\"large-4 columns\"> <label><span class=\"required notated\">*</span>Port: <input name=port type=number ng-model=vm.config.TcpPort required/> </label> <div ng-messages=vm.form.port.$error ng-if=\"vm.form.port.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> </div> </div> <div class=\"large-4 columns\"> <label><span class=\"required notated\">*</span>Arcnet Node: <input name=arcnetNode type=number ng-model=vm.config.ArcnetNode required min=1 max=255 /> </label> <div ng-messages=vm.form.arcnetNode.$error ng-if=\"vm.form.arcnetNode.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be between 1 and 255</div> <div ng-message=max class=req-w><div class=arrow-up></div>Must be between 1 and 255</div> </div> </div> </div> </div>");

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(5), __webpack_require__(683)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, aps_enums_1, checkDetectorConfig_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.controller.checkDetectorConfig', [])
        .directive('apsCheckDetectorConfig', ["uiUtilityService", function (uiUtilityService) {
        return {
            restrict: 'E',
            template: checkDetectorConfig_tpl_html_1.default,
            link: function (scope) {
                scope.aiServers = scope.vm.allEquipment.filter(function (e) { return e.type === aps_enums_1.apsEnums.EquipmentType.AIServer; });
                scope.versions = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.CheckDetectorVersion);
            }
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <div class=row ng-if=!vm.instance.isSimulator> <div class=\"large-3 columns\"> <label> <span class=\"required notated\">*</span>AI Server: <select name=aiServer ng-model=vm.config.aiServerId required ng-options=\"a.id as a.name for a in aiServers\"> <option value=\"\">-- Select an AI Server --</option> </select> </label> <div ng-messages=vm.form.aiServer.$error ng-if=\"vm.form.aiServer.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </div> <div class=\"large-3 columns\"> <label> <span class=\"required notated\">*</span>Line: <input name=line type=number ng-model=vm.config.Line required min=1 max=4 /> </label> <div ng-messages=vm.form.line.$error ng-if=\"vm.form.line.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=number class=req-w> <div class=arrow-up></div>Must be a number </div> <div ng-message=min class=req-w> <div class=arrow-up></div>Must be between 1 and 4 </div> <div ng-message=max class=req-w> <div class=arrow-up></div>Must be between 1 and 4 </div> </div> </div> <div class=\"large-3 columns\"> <label> <span class=\"required notated\">*</span>Arcnet Node: <input name=arcnetNode type=number ng-model=vm.config.ArcnetNode required min=1 max=255 /> </label> <div ng-messages=vm.form.arcnetNode.$error ng-if=\"vm.form.arcnetNode.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=number class=req-w> <div class=arrow-up></div>Must be a number </div> <div ng-message=min class=req-w> <div class=arrow-up></div>Must be between 1 and 255 </div> <div ng-message=max class=req-w> <div class=arrow-up></div>Must be between 1 and 255 </div> </div> </div> <div class=\"large-3 columns\"> <label> <span class=\"required notated\">*</span>Version: <select name=version ng-model=vm.config.version required ng-options=\"l.value as l.text for l in versions\"> <option value=\"\">-- Select a version --</option> </select> </label> <div ng-messages=vm.form.version.$error ng-if=\"vm.form.version.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </div> </div> </div>");

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(5), __webpack_require__(685)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, aps_enums_1, heyeConfig_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.controller.heyeConfig', [])
        .directive('apsHeyeConfig', function () {
        return {
            restrict: 'E',
            template: heyeConfig_tpl_html_1.default,
            link: function (scope) {
                scope.serialConverters = scope.vm.allEquipment
                    .filter(function (e) { return e.type === aps_enums_1.apsEnums.EquipmentType.SerialConverter; });
            }
        };
    })
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <div class=row ng-if=!vm.instance.isSimulator> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Serial-to-TCP Converter: <select name=serialConverter ng-model=vm.config.SerialConverterId required ng-options=\"s.id as s.name for s in serialConverters\"> <option value=\"\">-- Select a Serial-to-TCP Converter --</option> </select> </label> <div ng-messages=vm.form.serialConverter.$error ng-if=\"vm.form.serialConverter.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-3 columns\"> <label><span class=\"required notated\">*</span>Machine Number: <input name=machineNumber type=number ng-model=vm.config.MachineNumber required min=1 max=4 /> </label> <div ng-messages=vm.form.machineNumber.$error ng-if=\"vm.form.machineNumber.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be between 1 and 4</div> <div ng-message=max class=req-w><div class=arrow-up></div>Must be between 1 and 4</div> </div> </div> <div class=\"large-3 columns\"> <label><span class=\"required notated\">*</span>Port Number: <input name=portNumber type=number ng-model=vm.config.portNumber required min=0 max=90000 /> </label> <div ng-messages=vm.form.portNumber.$error ng-if=\"vm.form.portNumber.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be between 0 and 90000</div> <div ng-message=max class=req-w><div class=arrow-up></div>Must be between 0 and 90000</div> </div> </div> </div> </div>");

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(687)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, plcConfig_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.controller.plcConfig', [])
        .directive('apsPlcConfig', function () {
        return {
            restrict: 'E',
            template: plcConfig_tpl_html_1.default
        };
    })
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <div class=row ng-if=!vm.instance.isSimulator> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>IP Address: <input name=ipAddress type=text ng-model=vm.config.IpAddress required ng-pattern=vm.ipAddressPattern /> </label> <div ng-messages=vm.form.ipAddress.$error ng-if=\"vm.form.ipAddress.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=pattern class=req-w><div class=arrow-up></div>Invalid IP Address</div> </div> </div> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>DB: <input name=db type=number ng-model=vm.config.Db required min=0 /> </label> <div ng-messages=vm.form.db.$error ng-if=\"vm.form.db.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be 0 or more</div> </div> </div> </div> <div class=row ng-if=\"!vm.instance.isSimulator && vm.isNotProd\"> <div class=\"large-6 columns\"> <label>Emulator <input type=checkbox ng-model=vm.config.IsEmulator /> </label> </div> <div class=\"large-6 columns\" ng-if=vm.config.IsEmulator> <label><span class=\"required notated\">*</span>Port: <input name=port type=number ng-model=vm.config.Port required/> </label> <div ng-messages=vm.form.port.$error ng-if=\"vm.form.port.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> </div> </div> </div> </div>");

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(9), __webpack_require__(4), __webpack_require__(23), __webpack_require__(5), __webpack_require__(689), __webpack_require__(89)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, uiUtility_service_1, loader_service_1, shops_service_1, aps_enums_1, scaleConfig_tpl_html_1, isNullOrUndefined_1) {
    "use strict";
    scaleConfig.$inject = ["uiUtilityService", "loaderService", "shopService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [uiUtility_service_1.default, loader_service_1.default, shops_service_1.default];
    exports.default = angular.module('aps.controller.scaleConfig', requires)
        .directive('apsScaleConfig', scaleConfig)
        .name;
    function scaleConfig(uiUtilityService, loaderService, shopService) {
        return {
            restrict: 'E',
            template: scaleConfig_tpl_html_1.default,
            link: function (scope) {
                scope.locations = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.Location, 1);
                scope.modes = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.ScaleMode, 1);
                scope.displays = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.ScaleDisplay, 0);
                if (isNullOrUndefined_1.default(scope.vm.config.Display)) {
                    scope.vm.config.Display = aps_enums_1.apsEnums.ScaleDisplay.DifferenceFromTarget;
                }
                var updateMachines = function () {
                    if (!scope.vm.location) {
                        return;
                    }
                    var getMachines = shopService.getShopConfiguration(scope.vm.location.id)
                        .then(function (shop) { return scope.machines = shop.machineConfigurations; });
                    loaderService.loadingPromise(getMachines);
                };
                updateMachines();
                scope.$watch('vm.location', updateMachines);
            }
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <div class=row ng-if=!vm.instance.isSimulator> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>IP Address: <input name=hostName type=text ng-model=vm.config.HostName required ng-pattern=vm.ipAddressPattern /> </label> <div ng-messages=vm.form.hostName.$error ng-if=\"vm.form.hostName.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=pattern class=req-w><div class=arrow-up></div>Invalid IP Address</div> </div> </div> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Port: <input name=port type=number ng-model=vm.config.Port required/> </label> <div ng-messages=vm.form.port.$error ng-if=\"vm.form.port.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> </div> </div> </div> <div class=row ng-if=vm.instance.isSimulator> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Minutes between Weights: <input name=minutes type=number ng-model=vm.config.MinutesBetweenWeights required/> </label> <div ng-messages=vm.form.minutes.$error ng-if=\"vm.form.minutes.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> </div> </div> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Seconds between Gobs: <input name=seconds type=number ng-model=vm.config.SecondsBetweenGobs required/> </label> <div ng-messages=vm.form.seconds.$error ng-if=\"vm.form.seconds.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> </div> </div> </div> <div class=row> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Area: <select name=area ng-model=vm.config.Location required ng-options=\"l.value as l.text for l in locations\"> <option value=\"\">-- Select Area --</option> </select> </label> <div ng-messages=vm.form.area.$error ng-if=\"vm.form.area.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Mode: <select name=mode ng-model=vm.config.Mode required ng-options=\"m.value as m.text for m in modes\"> <option value=\"\">-- Select Mode --</option> </select> </label> <div ng-messages=vm.form.mode.$error ng-if=\"vm.form.mode.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> </div> <div class=row> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Display Preference: <select name=display ng-model=vm.config.Display ng-options=\"d.value as d.text for d in displays\" required> <option value=\"\">-- Select Preference --</option> </select> </label> <div ng-messages=vm.form.display.$error ng-if=\"vm.form.display.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-6 columns\" ng-if=\"machines.length > 1\"> <label><span class=\"required notated\">*</span>Machine: <select name=machine ng-model=vm.config.MachineId ng-options=\"m.id as m.name for m in machines\"> <option value=\"\">All</option> </select> </label> </div> </div> <div class=row> <div class=\"large-3 columns\"> <label>Unit of Conversion <select name=unitOfConversion ng-model=vm.config.unitOfConversion> <option value=1 ng-selected=selected>NA</option> <option value=0.035274>Gram to OZ</option> </select> </label> </div> <div class=\"large-3 columns\"> <label>Communication Options <select name=communicationOption ng-model=vm.config.communicationOption> <option value=APS ng-selected=selected>APS</option> <option value=PPC>APS & PPC</option> </select> </label> </div> </div> </div>");

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(691)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, ppcScaleConfig_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.controller.ppcScaleConfig', [])
        .directive('apsPpcScaleConfig', ["loaderService", "shopService", function (loaderService, shopService) {
        return {
            restrict: 'E',
            template: ppcScaleConfig_tpl_html_1.default,
            link: function (scope) {
                var updateMachines = function () {
                    if (!scope.vm.location) {
                        return;
                    }
                    var getMachines = shopService.getShopConfiguration(scope.vm.location.id)
                        .then(function (shop) { return scope.machines = shop.machineConfigurations; });
                    loaderService.loadingPromise(getMachines);
                };
                updateMachines();
                scope.$watch('vm.location', updateMachines);
            }
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <div class=row> <div class=\"large-3 columns\"> <label><span class=\"required notated\">*</span>Server: <input name=database type=text ng-model=vm.config.DatabaseServer required/> </label> <div ng-messages=vm.form.server.$error ng-if=\"vm.form.server.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-3 columns\"> <label><span class=\"required notated\">*</span>Database: <input name=database type=text ng-model=vm.config.DatabaseName required/> </label> <div ng-messages=vm.form.database.$error ng-if=\"vm.form.database.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-2 column\"> <label><span class=\"required notated\">*</span>QueryType: <select name=QueryType ng-model=vm.config.QueryType required> <option value=\"\">-- Select --</option> <option value=\"Dynamic SQL\">Dynamic SQL</option> <option value=StoredProcure>StoredProcured</option> </select> </label> <div ng-messages=vm.form.QueryType.$error ng-if=\"vm.form.QueryType.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> </div> <div class=row> <div class=\"large-12 columns\"> <label><span class=\"required notated\">*</span>Query String: <textarea name=QueryString rows=2 cols=10 ng-model=vm.config.QueryString required/> </label> <div ng-messages=vm.form.QueryString.$error ng-if=\"vm.form.QueryString.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> </div> <div class=row> <div class=\"large-2 column\"> <label><span class=\"required notated\">*</span>Driver: <select name=driver ng-model=vm.config.StorageDriver required> <option value=\"SQL Server\" ng-selected=true>SQL Server</option> </select> </label> <div ng-messages=vm.form.driver.$error ng-if=\"vm.form.driver.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-3 columns\"> <label>Count Interval Seconds <input name=countIntervalSeconds type=text maxlength=10 ng-model=vm.config.CountIntervalSeconds required/> </label> </div> <div class=\"large-2 columns\"> <label>End Time Offset <input name=endTimeOffsetSeconds type=text maxlength=10 ng-model=vm.config.EndTimeOffsetSeconds required/> </label> </div> <div class=\"large-3 columns\"> <label>Unit of Conversion <select name=unitOfConversion ng-model=vm.config.CustomConfig> <option value=1 ng-selected=selected>NA</option> <option value=0.035274>Gram to OZ</option> </select> </label> </div> <div class=\"large-2 columns\" ng-if=\"machines.length > 1\"> <label><span class=\"required notated\">*</span>Machine <select name=machine ng-model=vm.config.MachineId ng-options=\"m.id as m.name for m in machines\"> <option value=\"\">All</option> </select> </label> </div> </div> </div>");

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(693)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, serialConverterConfig_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.controller.serialConverterConfig', [])
        .directive('apsSerialConverterConfig', function () {
        return {
            restrict: 'E',
            template: serialConverterConfig_tpl_html_1.default
        };
    })
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <div class=row ng-if=!vm.instance.isSimulator> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>IP Address: <input name=hostName type=text ng-model=vm.config.HostName required ng-pattern=vm.ipAddressPattern /> </label> <div ng-messages=vm.form.hostName.$error ng-if=\"vm.form.hostName.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=pattern class=req-w><div class=arrow-up></div>Invalid IP Address</div> </div> </div> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Port: <input name=port type=number ng-model=vm.config.TcpPort required/> </label> <div ng-messages=vm.form.port.$error ng-if=\"vm.form.port.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> </div> </div> </div> </div>");

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(695)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, wsiConfig_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.controller.wsiConfig', [])
        .directive('apsWsiConfig', function () {
        return {
            restrict: 'E',
            template: wsiConfig_tpl_html_1.default,
            link: function (scope) {
                scope.vm.dataPoints = [];
            }
        };
    })
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <div class=row ng-if=!vm.instance.isSimulator> <div class=\"large-4 columns\"> <label><span class=\"required notated\">*</span>IP Address: <input name=ipAddress type=text ng-model=vm.config.HostName required ng-pattern=vm.ipAddressPattern /> </label> <div ng-messages=vm.form.ipAddress.$error ng-if=\"vm.form.ipAddress.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=pattern class=req-w><div class=arrow-up></div>Invalid IP Address</div> </div> </div> <div class=\"large-4 columns\"> <label><span class=\"required notated\">*</span>HTTP Port: <input name=httpPort type=number ng-model=vm.config.HttpPort required min=1 /> </label> <div ng-messages=vm.form.httpPort.$error ng-if=\"vm.form.httpPort.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be 1 or greater</div> </div> </div> <div class=\"large-4 columns\"> <label><span class=\"required notated\">*</span>TCP Port: <input name=tcpPort type=number ng-model=vm.config.TcpPort required min=1 /> </label> <div ng-messages=vm.form.tcpPort.$error ng-if=\"vm.form.tcpPort.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be 1 or greater</div> </div> </div> </div> <div class=row ng-if=vm.instance.isSimulator> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Bottles per minute: <input name=bpm type=number ng-model=vm.config.BottlesPerMinute required min=1 /> </label> <div ng-messages=vm.form.bpm.$error ng-if=\"vm.form.bpm.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be 1 or greater</div> </div> </div> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Reject Rate: <input name=rejectRate type=number ng-model=vm.config.RejectRate required min=0 max=0.99 /> </label> <div ng-messages=vm.form.rejectRate.$error ng-if=\"vm.form.rejectRate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be between 0.00 and 0.99</div> <div ng-message=max class=req-w><div class=arrow-up></div>Must be between 0.00 and 0.99</div> </div> </div> </div> </div>");

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(697)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, raspberryPiConfig_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.controller.raspberryPiConfig', [])
        .directive('apsRaspberryPiConfig', function () {
        return {
            restrict: 'E',
            template: raspberryPiConfig_tpl_html_1.default
        };
    })
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>IP Address: <input name=ipAddress type=text ng-model=vm.config.IpAddress required ng-pattern=vm.ipAddressPattern /> </label> <div ng-messages=vm.form.ipAddress.$error ng-if=\"vm.form.ipAddress.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=pattern class=req-w><div class=arrow-up></div>Invalid IP Address</div> </div> </div> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Port: <input name=port type=number ng-model=vm.config.Port required min=0 /> </label> <div ng-messages=vm.form.port.$error ng-if=\"vm.form.port.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be 0 or more</div> </div> </div> </div> ");

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(699), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, tiamaConfig_tpl_html_1, aps_enums_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.controller.tiamaConfig', [])
        .directive('tiamaConfig', ["uiUtilityService", function (uiUtilityService) {
        return {
            restrict: 'E',
            template: tiamaConfig_tpl_html_1.default,
            link: function (scope) {
                scope.equipment = scope.vm.allEquipment.filter(function (e) { return e.type === aps_enums_1.apsEnums.EquipmentType.Mcal; });
                scope.versions = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.TiamaMultiMcalProtocol);
            }
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <div class=row ng-if=!vm.instance.isSimulator> <div class=\"large-5 columns\"> <label><span class=\"required notated\">*</span>Service Address: <input name=serviceAddress type=text ng-model=vm.config.ServiceAddress required/> </label> <div ng-messages=vm.form.serviceAddress.$error ng-if=\"vm.form.serviceAddress.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </div> <div ng-if=\"vm.instance.type == 11\" style=background-color:#0ff> <div class=\"large-1 columns\">&nbsp;</div> <div class=\"large-4 columns\"> <label> Linked Equipment: <select name=equipment ng-model=vm.config.linkedEquipmentId ng-options=\"e.id as e.name for e in equipment\"> <option value=\"\">-- Select an MCAL To Link --</option> </select> </label> </div> <div class=\"medium-2 columns\"> <label> Version: <select name=version ng-model=vm.config.ProtocolVersion ng-init=\"vm.config.ProtocolVersion = (vm.config.ProtocolVersion) ? vm.config.ProtocolVersion : 0\" ng-options=\"l.value as l.text for l in versions\"> </select> </label> </div> </div> </div> </div>");

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(701)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, flexInpectConfig_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.controller.flexInspectConfig', [])
        .directive('apsFlexInspectConfig', function () {
        return {
            restrict: 'E',
            template: flexInpectConfig_tpl_html_1.default
        };
    })
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <div class=\"large-3 columns\"> <label><span class=\"required notated\">*</span>IP Address: <input name=ipAddress type=text ng-model=vm.config.IpAddress required ng-pattern=vm.ipAddressPattern /> </label> <div ng-messages=vm.form.ipAddress.$error ng-if=\"vm.form.ipAddress.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=pattern class=req-w><div class=arrow-up></div>Invalid IP Address</div> </div> </div> <div class=\"large-3 columns\"> <label><span class=\"required notated\">*</span>Inspection Port: <input name=port type=number ng-model=vm.config.Port required min=0 /> </label> <div ng-messages=vm.form.port.$error ng-if=\"vm.form.port.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be 0 or more</div> </div> </div> <div class=\"large-3 columns\"> <label><span class=\"required notated\">*</span>System Setting Port: <input name=sys_port type=number ng-model=vm.config.SystemSettingPort required min=0 /> </label> <div ng-messages=vm.form.port.$error ng-if=\"vm.form.sys_port.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be 0 or more</div> </div> </div> <div class=\"large-3 columns\"> <label><span class=\"required notated\">*</span>Auto Reset Counter: <input name=auto_reset_counter type=number ng-model=vm.config.AutoResetCounter required min=0 /> </label> <div ng-messages=vm.form.port.$error ng-if=\"vm.form.auto_reset_counter.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be 0 or more</div> </div> </div> </div> ");

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(703)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, lineServerConfig_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.controller.lineServerConfig', [])
        .directive('apsLineServerConfig', function () {
        return {
            restrict: 'E',
            template: lineServerConfig_tpl_html_1.default
        };
    })
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <div class=row ng-if=!vm.instance.isSimulator> <div class=\"large-2 columns\"> <label><span class=\"required notated\">*</span>IP Address: <input name=ipAddress type=text ng-model=vm.config.IpAddress required ng-pattern=vm.ipAddressPattern /> </label> <div ng-messages=vm.form.ipAddress.$error ng-if=\"vm.form.ipAddress.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=pattern class=req-w><div class=arrow-up></div>Invalid IP Address</div> </div> </div> <div class=\"large-2 columns\"> <label><span class=\"required notated\">*</span>Port: <input name=port type=number ng-model=vm.config.TcpPort required/> </label> <div ng-messages=vm.form.port.$error ng-if=\"vm.form.port.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> </div> </div> <div class=\"large-2 columns\"> <label>Is Debug <input name=isDebug type=text maxlength=10 ng-model=vm.config.IsDebug required/> </label> </div> <div class=\"large-2 columns\"> <label>Count Interval <input name=countInterval type=text maxlength=10 ng-model=vm.config.CountIntervalSeconds required/> </label> </div> <div class=\"large-2 columns\"> <label>Due Time Offset <input name=dueTimeOffsetSeconds type=text maxlength=10 ng-model=vm.config.DueTimeOffsetSeconds required/> </label> </div> <div class=\"large-2 columns\"> <label>End Time Offset <input name=endTimeOffsetSeconds type=text maxlength=10 ng-model=vm.config.EndTimeOffsetSeconds required/> </label> </div> </div> </div>");

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(5), __webpack_require__(705)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, aps_enums_1, flexIsConfig_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.controller.flexIsConfig', [])
        .directive('apsFlexIsConfig', ["uiUtilityService", function (uiUtilityService) {
        return {
            restrict: 'E',
            template: flexIsConfig_tpl_html_1.default,
            link: function (scope) {
                scope.lineServers = scope.vm.allEquipment.filter(function (e) { return e.type === aps_enums_1.apsEnums.EquipmentType.LineServer; });
            }
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <div class=row ng-if=!vm.instance.isSimulator> <div class=\"large-3 columns\"> <label> <span class=\"required notated\">*</span>Line Server: <select name=lineServer ng-model=vm.config.lineServerId required ng-options=\"a.id as a.name for a in lineServers\"> <option value=\"\">-- Select a Line Server --</option> </select> </label> <div ng-messages=vm.form.aiServer.$error ng-if=\"vm.form.aiServer.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-3 columns\"> <label> <span class=\"required notated\">*</span>Line: <input name=line type=text ng-model=vm.config.Line required min=0 maxlength=32 /> </label> <div ng-messages=vm.form.line.$error ng-if=\"vm.form.line.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-2 columns\"> <label> <span class=\"required notated\">*</span>IS Machine #: <input name=isMachineNumber type=number ng-model=vm.config.ISMachineNumber required/> </label> <div ng-messages=vm.form.isMachineNumber.$error ng-if=\"vm.form.isMachineNumber.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-3 columns\"></div> </div> </div>");

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(707)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, kepwareCounterConfig_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.controller.kepwareCounterConfig', [])
        .directive('apsKepwareCounterConfig', function () {
        return {
            restrict: 'E',
            template: kepwareCounterConfig_tpl_html_1.default,
            link: function (scope) {
                var updateFormValidation = function () {
                    scope.isRequired = scope.vm.instance.type === 21 || scope.vm.instance.type === 22 ? false : true;
                };
                scope.$watch('vm.instance.type', updateFormValidation);
            },
        };
    })
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <div class=row ng-if=!vm.instance.isSimulator> <div class=\"large-9 columns\"> <label><span class=\"required notated\">*</span>Endpoint: <input name=endpoint type=text ng-model=vm.config.Endpoint required/> </label> <div ng-messages=vm.form.endpoint.$error ng-if=\"vm.form.endpoint.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-3 columns\" ng-if=isRequired> <label>Count Interval Seconds <input name=countIntervalSeconds type=text maxlength=10 ng-model=vm.config.CountIntervalSeconds ng-required=isRequired /> </label> </div> </div> <div class=row ng-if=isRequired> <div class=\"large-9 columns\"> <label>FailOver Endpoint: <input name=endpoint type=text ng-model=vm.config.FailOverEndpoint ng-required=isRequired /> </label> </div> </div> </div>");

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(709)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, sqlCounterConfig_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.controller.sqlCounterConfig', [])
        .directive('apsSqlCounterConfig', function () {
        return {
            restrict: 'E',
            template: sqlCounterConfig_tpl_html_1.default
        };
    })
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <div class=row> <div class=\"large-3 columns\"> <label><span class=\"required notated\">*</span>Server: <input name=database type=text ng-model=vm.config.DatabaseServer required/> </label> <div ng-messages=vm.form.server.$error ng-if=\"vm.form.server.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-3 columns\"> <label><span class=\"required notated\">*</span>Database: <input name=database type=text ng-model=vm.config.DatabaseName required/> </label> <div ng-messages=vm.form.database.$error ng-if=\"vm.form.database.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-2 column\"> <label><span class=\"required notated\">*</span>QueryType: <select name=QueryType ng-model=vm.config.QueryType required> <option value=\"\">-- Select --</option> <option value=\"Dynamic SQL\">Dynamic SQL</option> <option value=StoredProcure>StoredProcured</option> </select> </label> <div ng-messages=vm.form.QueryType.$error ng-if=\"vm.form.QueryType.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> </div> <div class=row> <div class=\"large-12 columns\"> <label><span class=\"required notated\">*</span>Query String: <textarea name=QueryString rows=2 cols=10 ng-model=vm.config.QueryString required/> </label> <div ng-messages=vm.form.QueryString.$error ng-if=\"vm.form.QueryString.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> </div> <div class=row> <div class=\"large-2 column\"> <label><span class=\"required notated\">*</span>Driver: <select name=driver ng-model=vm.config.StorageDriver required> <option value=\"SQL Server\" ng-selected=selected>SQL Server</option> </select> </label> <div ng-messages=vm.form.driver.$error ng-if=\"vm.form.driver.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-3 columns\"> <label>Count Interval Seconds <input name=countIntervalSeconds type=text maxlength=10 ng-model=vm.config.CountIntervalSeconds required/> </label> </div> <div class=\"large-2 columns\"> <label>End Time Offset <input name=endTimeOffsetSeconds type=text maxlength=10 ng-model=vm.config.EndTimeOffsetSeconds required/> </label> </div> <div class=\"large-3 columns\"> <label>SQL Interval Seconds <input name=queryIntervalSeconds type=text maxlength=10 ng-model=vm.config.QueryIntervalSeconds required/> </label> </div> <div class=\"large-2 columns\"> <label>Use Timestamp <input name=endTimeOffsetSeconds type=checkbox ng-model=vm.config.UseTimeStamp /> </label> </div> </div> </div>");

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <div class=body-header><h2>Equipment</h2></div> <div class=container> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-5 columns\"> <label> <span class=\"required notated\">*</span>Plant: <select ng-model=vm.selectedPlant ng-options=\"plant.name for plant in vm.plants\" ng-change=vm.plantChanged()> </select> </label> </div> <div class=\"small-3 columns\"> <label> Location <select name=selectedLocation ng-model=vm.selectedLocation ng-options=\"location as location.name for location in vm.locations\" ng-change=vm.locationChanged()> <option value=\"\">-- Any Location --</option> </select> </label> </div> <div class=\"small-2 columns\"> <button ng-click=vm.addEquipment() class=\"button small\" style=position:relative;top:14px>Add Equipment</button> </div> </div> <div ng-if=\"vm.filteredEquipment && vm.filteredEquipment.length === 0\" style=width:100%;clear:both;float:left;margin-top:30px> Currently there is no Equipment for this Plant / Location </div> <table cellpadding=1 cellspacing=1 ng-if=\"vm.filteredEquipment && vm.filteredEquipment.length > 0\" class=history-t> <tr> <th>Name</th> <th>Location</th> <th>Type</th> <th ng-if=vm.isNotProd>Sim</th> <th>Active</th> <th></th> <th></th> <th></th> <th></th> </tr> <tr ng-repeat=\"instance in vm.filteredEquipment\" ng-if=\"vm.filteredEquipment.length > 0\"> <td>{{ instance.name }}</td> <td>{{ instance.plantLocationName }}</td> <td>{{ vm.getTypeName(instance.type) }}</td> <td ng-if=vm.isNotProd>{{ instance.isSimulator ? 'Yes' : 'No' }}</td> <td>{{ instance.active ? 'Active' : 'Disabled' }}</td> <td><button ng-click=vm.editConfig(instance) class=\"button tiny\" style=margin:0>Configure</button></td> <td><button ng-click=vm.toggleActive(instance) class=\"button tiny\" style=margin:0>{{ instance.active ? 'Disable' : 'Activate' }}</button></td> <td><button ng-click=vm.remove(instance) class=\"button tiny alert\" style=margin:0>Delete</button></td> <td><button ng-click=vm.openDiagnostics(instance) class=\"button tiny\" style=margin:0>Diagnostics</button></td> </tr> </table> </div> </div>");

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(33), __webpack_require__(6), __webpack_require__(4), __webpack_require__(712), __webpack_require__(305), __webpack_require__(306)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, equipment_service_1, notify_service_1, loader_service_1, updateConfig_tpl_html_1, dataPointsSelector_directive_1, configSelector_directive_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [equipment_service_1.default, notify_service_1.default, loader_service_1.default, dataPointsSelector_directive_1.default, configSelector_directive_1.default];
    function openUpdateConfig(data, $modal) {
        return $modal.open({
            template: updateConfig_tpl_html_1.default,
            controller: 'UpdateConfigCtrl as vm',
            resolve: {
                data: function () { return data; }
            }
        }).result;
    }
    exports.openUpdateConfig = openUpdateConfig;
    var UpdateConfigCtrl = (function () {
        UpdateConfigCtrl.$inject = ["$modalInstance", "equipmentService", "data", "notifyService", "loaderService"];
        function UpdateConfigCtrl($modalInstance, equipmentService, data, notifyService, loaderService) {
            this.$modalInstance = $modalInstance;
            this.equipmentService = equipmentService;
            this.notifyService = notifyService;
            this.loaderService = loaderService;
            this.instance = data.instance;
            this.plantId = data.plantId;
            this.allEquipment = data.allEquipment;
            this.isNotProd = data.isNotProd;
            this.ipAddressPattern = data.ipAddressPattern;
            this.config = JSON.parse(data.instance.config);
            this.locations = data.locations;
            this.location = _.find(data.locations, {
                locationType: data.instance.plantLocationLocationType,
                id: data.instance.plantLocationLocationTypeId
            });
            this.dataPoints = JSON.parse(JSON.stringify(data.instance.dataPoints));
            _.forEach(this.dataPoints, function (dp) {
                dp.jsonConfig = JSON.parse(dp.config);
            });
        }
        UpdateConfigCtrl.prototype.save = function () {
            var _this = this;
            if (this.form.$invalid) {
                return;
            }
            _.forEach(this.dataPoints, function (dp) {
                dp.config = JSON.stringify(dp.jsonConfig);
            });
            var command = {
                id: this.instance.id,
                plantId: this.plantId,
                config: JSON.stringify(this.config),
                dataPoints: JSON.parse(JSON.stringify(this.dataPoints))
            };
            _.forEach(command.dataPoints, function (dp) {
                dp.jsonConfig = undefined;
            });
            this.loaderService.loadingPromise(this.equipmentService.updateConfig(command)
                .then(function () {
                _this.instance.config = command.config;
                _this.instance.dataPoints = command.dataPoints;
                _.forEach(_this.instance.dataPoints, function (dp) {
                    dp.plantId = _this.plantId;
                });
                _this.$modalInstance.close();
            }, this.notifyService.handleApiErrors));
        };
        UpdateConfigCtrl.prototype.cancel = function () {
            this.$modalInstance.close();
        };
        return UpdateConfigCtrl;
    }());
    exports.default = angular.module('aps.controller.updateConfig', requires)
        .controller('UpdateConfigCtrl', UpdateConfigCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <h2 class=modal-header>Update Config for {{vm.instance.name}}</h2> <form name=vm.form ng-submit=vm.save() novalidate> <div class=container style=\"margin:0 -30px\"> <aps-config-selector></aps-config-selector> <aps-data-points-selector></aps-data-points-selector> <div class=row> <div class=\"large-12 columns\"> <span class=required>* Required Fields</span> <div class=\"right dialog-footer\"> <button ng-click=vm.cancel() type=button class=\"button secondary\">Cancel</button> <button class=button type=submit>Save Config</button> </div> </div> </div> </div> </form> </div>");

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(5), __webpack_require__(10), __webpack_require__(37), __webpack_require__(714), __webpack_require__(3), __webpack_require__(4), __webpack_require__(6), __webpack_require__(11), __webpack_require__(9), __webpack_require__(715)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, aps_enums_1, http_service_1, hub_service_1, diagnostics_tpl_html_1, constant_module_1, loader_service_1, notify_service_1, dateutility_service_1, uiUtility_service_1, diagnosticsDetail_controller_1) {
    "use strict";
    diagnosticsCtrl.$inject = ["httpService", "hubService", "data", "$scope", "$timeout", "$modal", "$modalInstance", "$q", "uiUtilityService", "loaderService", "notifyService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [http_service_1.default, hub_service_1.default, loader_service_1.default, notify_service_1.default, uiUtility_service_1.default,
        diagnosticsDetail_controller_1.default];
    function openEquipmentDiagnostics(data, $modal) {
        return $modal.open({
            template: diagnostics_tpl_html_1.default,
            controller: 'EquipmentDiagnosticsCtrl as vm',
            resolve: {
                data: function () { return data; }
            }
        }).result;
    }
    exports.openEquipmentDiagnostics = openEquipmentDiagnostics;
    exports.default = angular.module('aps.controller.equipmentDiagnostics', requires)
        .controller('EquipmentDiagnosticsCtrl', diagnosticsCtrl)
        .name;
    function logLevelName(logLevel) {
        return aps_enums_1.apsEnums.LogLevel[logLevel];
    }
    function truncateMessage(message) {
        if (message && message.length > 75) {
            return message.substring(0, 75) + '...';
        }
        return message;
    }
    function diagnosticsCtrl(httpService, hubService, data, $scope, $timeout, $modal, $modalInstance, $q, uiUtilityService, loaderService, notifyService) {
        var vm = {};
        var equipment = data.equipment;
        var hub;
        vm.name = equipment.name;
        vm.events = [];
        vm.logLevel = equipment.diagnosticsLogLevel;
        vm.logLevels = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.LogLevel, 1);
        vm.maxRows = equipment.maxLogEntries;
        function formatTime(time) {
            return dateutility_service_1.default.formatDateTime(time, data.timeZoneId, constant_module_1.Strings.TIME_FORMAT_WITH_SECONDS);
        }
        vm.formatTime = formatTime;
        vm.logLevelName = logLevelName;
        vm.truncateMessage = truncateMessage;
        function diagnosticsLogged(e) {
            if (e.equipmentInstanceId !== equipment.instanceId) {
                return;
            }
            $timeout(function () {
                addIndexToEvent(e);
                vm.events.unshift(e);
                while (vm.events.length > vm.maxRows) {
                    vm.events.pop();
                }
            });
        }
        var index = 0;
        function addIndexToEvent(event) {
            event.index = index;
            index++;
        }
        function createHub() {
            return hubService.createHub('equipment', {
                listeners: {
                    diagnosticsLogged: diagnosticsLogged
                },
                methods: ['joinGroup', 'leaveGroup'],
                postConnect: function (hub) {
                    hub.invokeWithRetry(function () {
                        return hub.joinGroup(data.plantId, equipment.instanceId);
                    });
                }
            });
        }
        function getLogs() {
            return httpService.get(constant_module_1.Endpoints.EQUIPMENT_DIAGNOSTICS, {
                plantId: data.plantId,
                instanceId: equipment.instanceId
            }).then(function (logs) {
                logs.forEach(addIndexToEvent);
                vm.events = logs;
                hub = createHub();
            });
        }
        function changeLogLevel() {
            var command = {
                plantId: data.plantId,
                id: equipment.id,
                diagnosticsLogLevel: vm.logLevel,
                maxLogEntries: vm.maxRows || equipment.maxLogEntries
            };
            return httpService.put(constant_module_1.Endpoints.EQUIPMENT_DIAGNOSTICS, command)
                .then(function () {
                if (!vm.logLevel && equipment.diagnosticsLogLevel) {
                    hub.leaveGroup(data.plantId, equipment.instanceId);
                }
                else if (vm.logLevel && !equipment.diagnosticsLogLevel) {
                    hub.joinGroup(data.plantId, equipment.instanceId);
                }
                equipment.diagnosticsLogLevel = vm.logLevel;
                equipment.maxLogEntries = vm.maxRows;
            }, function (errors) {
                vm.logLevel = equipment.diagnosticsLogLevel;
                vm.maxRows = equipment.maxLogEntries;
                notifyService.handleApiErrors(errors);
            });
        }
        function logLevelChanged() {
            var promise;
            if (vm.logLevel && !hub) {
                promise = getLogs().then(changeLogLevel);
            }
            else {
                promise = changeLogLevel();
            }
            loaderService.loadingPromise(promise);
        }
        vm.levelChanged = logLevelChanged;
        function maxRowsChanged() {
            if (this.form.$invalid) {
                return;
            }
            loaderService.loadingPromise(changeLogLevel());
        }
        vm.maxRowsChanged = maxRowsChanged;
        function viewEvent(e) {
            diagnosticsDetail_controller_1.openEquipmentDiagnosticsDetail({
                name: vm.name,
                time: formatTime(e.eventDate),
                logLevel: logLevelName(e.logLevel),
                message: e.message
            }, $modal);
        }
        vm.viewEvent = viewEvent;
        function preClose() {
            if (!vm.logLevel || vm.logLevel > aps_enums_1.apsEnums.LogLevel.Debug) {
                return $q.when(true);
            }
            return uiUtilityService.confirm('You currently have logging set to '
                + logLevelName(vm.logLevel)
                + '. This will impact performance at the plant. Are you sure you want to leave it on?', 'Leave Logging On?');
        }
        function close() {
            preClose().then(function (confirmed) {
                if (confirmed) {
                    $modalInstance.close();
                }
            });
        }
        vm.close = close;
        if (vm.logLevel) {
            loaderService.loadingPromise(getLogs());
        }
        $scope.$on('$destroy', function () {
            if (hub) {
                hub.leaveGroup(data.plantId, equipment.instanceId)
                    .then(function () { return hub.uninitialize(); });
            }
        });
        return vm;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <h2 class=modal-header>Diagnostics for {{vm.name}}</h2> <div class=container> <div class=row> <form name=vm.form novalidate> <div class=\"large-4 columns\"> <label>Log Level: <select name=logLevel ng-model=vm.logLevel ng-options=\"l.value as l.text for l in vm.logLevels\" ng-change=vm.levelChanged()> <option value=\"\">No Logging</option> </select> </label> </div> <div class=\"large-4 columns\"> <label>Max Number of Entries: <input type=number name=maxRows ng-model=vm.maxRows ng-model-options=\"{ debounce: 1000 }\" step=1 min=10 max=200 required ng-change=vm.maxRowsChanged() /> </label> <div ng-messages=vm.form.maxRows.$error ng-if=vm.form.maxRows.$dirty role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a number</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be between 10 and 200</div> <div ng-message=max class=req-w><div class=arrow-up></div>Must be between 10 and 200</div> </div> </div> <div class=\"large-4 columns\"> <button class=button type=button ng-click=vm.close()>Close</button> </div> </form> </div> <h4>Last Log Entries</h4> <table cellpadding=1 cellspacing=1 class=history-t> <tr> <th>Time</th> <th>Level</th> <th>Message</th> </tr> <tr ng-repeat=\"e in vm.events track by e.index\" ng-click=vm.viewEvent(e) style=cursor:pointer> <td>{{ vm.formatTime(e.eventDate) }}</td> <td>{{ vm.logLevelName(e.logLevel) }}</td> <td>{{ vm.truncateMessage(e.message) }}</td> </tr> </table> </div> </div>");

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(716)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, diagnosticsDetail_tpl_html_1) {
    "use strict";
    diagnosticsDetailCtrl.$inject = ["data", "$modalInstance"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [];
    function openEquipmentDiagnosticsDetail(data, $modal) {
        return $modal.open({
            template: diagnosticsDetail_tpl_html_1.default,
            controller: 'EquipmentDiagnosticsDetailCtrl as vm',
            resolve: {
                data: function () { return data; }
            }
        }).result;
    }
    exports.openEquipmentDiagnosticsDetail = openEquipmentDiagnosticsDetail;
    exports.default = angular.module('aps.controller.equipmentDiagnosticsDetail', requires)
        .controller('EquipmentDiagnosticsDetailCtrl', diagnosticsDetailCtrl)
        .name;
    function diagnosticsDetailCtrl(data, $modalInstance) {
        var vm = _.extend({}, data);
        vm.close = function () {
            $modalInstance.close();
        };
        return vm;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <h2 class=modal-header>Diagnostics Detail for {{vm.name}}</h2> <div class=container> <div class=row> <div class=\"large-2 small-12 columns\">Time</div> <div class=\"large-10 small-12 columns\">{{ vm.time }}</div> </div> <div class=row style=margin-top:1em> <div class=\"large-2 small-12 columns\">Log Level</div> <div class=\"large-10 small-12 columns\">{{ vm.logLevel }}</div> </div> <div class=row style=margin-top:1em> <div class=\"large-2 small-12 columns\">Message</div> <div class=\"large-10 small-12 columns\"> <textarea readonly=readonly cols=200 rows=20 style=white-space:pre>{{ vm.message }}</textarea> </div> </div> <div class=row> <div class=\"large-12 columns\"> <div class=\"right dialog-footer\"> <button class=button type=button ng-click=vm.close()>Close</button> </div> </div> </div> </div> </div>");

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(3), __webpack_require__(5), __webpack_require__(718), __webpack_require__(722), __webpack_require__(54), __webpack_require__(4), __webpack_require__(8), __webpack_require__(57), __webpack_require__(7), __webpack_require__(9), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, constant_module_1, aps_enums_1, editFormula_controller_1, formula_tpl_html_1, locations_service_1, loader_service_1, navigation_service_1, dataPoints_service_1, authData_service_1, uiUtility_service_1, notify_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [editFormula_controller_1.default, locations_service_1.default, loader_service_1.default, navigation_service_1.default, dataPoints_service_1.default,
        authData_service_1.default, uiUtility_service_1.default, notify_service_1.default];
    var FormulaCtrl = (function () {
        FormulaCtrl.$inject = ["loaderService", "dataPointService", "navigationService", "authDataService", "uiUtilityService", "notifyService", "locationsService", "$modal"];
        function FormulaCtrl(loaderService, dataPointService, navigationService, authDataService, uiUtilityService, notifyService, locationsService, $modal) {
            var _this = this;
            this.loaderService = loaderService;
            this.navigationService = navigationService;
            this.dataPointService = dataPointService;
            this.authDataService = authDataService;
            this.uiUtilityService = uiUtilityService;
            this.notifyService = notifyService;
            this.locationsService = locationsService;
            this.$modal = $modal;
            var promise = this.navigationService.getNavigation().then(function (nav) {
                var plants = nav.plants();
                _this.plants = _.filter(plants, function (plant) {
                    return authDataService.isPlantAdmin(plant.id) || authDataService.isAPSIOAdminForPlant(plant.id);
                });
                if (nav.selectedPlant && _.includes(_this.plants, nav.selectedPlant)) {
                    _this.selectedPlant = nav.selectedPlant;
                }
                else {
                    _this.selectedPlant = _.first(_this.plants);
                }
                _this.locationPromise = _this.navigationService.getLocations(false).then(function (locations) {
                    _this.plantLocations = locations;
                    _this.loadLocations();
                });
                return _this.loadDataPoints();
            });
            this.loaderService.loadingPromise(promise);
        }
        FormulaCtrl.prototype.loadLocations = function () {
            this.locations = this.locationsService
                .getPlantLocations(this.selectedPlant, this.plantLocations);
            this.selectedLocation = null;
        };
        FormulaCtrl.prototype.locationChanged = function () {
            this.filterFormulas();
        };
        FormulaCtrl.prototype.setFormulaDetail = function (dp) {
            dp.location = _.find(this.locations, function (l) { return l.location.id === dp.plantLocationId; }).name;
            dp.typeName = this.getTypeName(dp.type);
        };
        FormulaCtrl.prototype.loadDataPoints = function () {
            var _this = this;
            return this.dataPointService
                .get(this.selectedPlant.id)
                .then(function (dataPoints) {
                return _this.locationPromise.then(function () {
                    _this.allDataPoints = dataPoints;
                    _this.allDataPoints.forEach(function (dp) { return _this.setFormulaDetail(dp); });
                    _this.filterFormulas();
                });
            });
        };
        FormulaCtrl.prototype.filterFormulas = function () {
            this.formulas = _.filter(this.allDataPoints, function (dp) {
                return dp.configType === aps_enums_1.apsEnums.DataPointConfigType.Formula;
            });
            if (this.selectedLocation) {
                this.formulas = _.filter(this.formulas, { plantLocationId: this.selectedLocation.location.id });
            }
        };
        FormulaCtrl.prototype.plantChanged = function () {
            this.loadLocations();
            this.loaderService.loadingPromise(this.loadDataPoints());
        };
        FormulaCtrl.prototype.add = function () {
            this.edit(null);
        };
        FormulaCtrl.prototype.edit = function (instance) {
            var _this = this;
            var result = editFormula_controller_1.openEditFormula({
                plant: this.selectedPlant,
                allDataPoints: this.allDataPoints,
                instance: instance,
                locations: this.locations,
                selectedLocation: this.selectedLocation
            }, this.$modal);
            result.then(function (newInstance) {
                if (!newInstance) {
                    return;
                }
                _this.setFormulaDetail(newInstance);
                if (instance == null) {
                    _this.allDataPoints.push(newInstance);
                }
                else {
                    var index = _.indexOf(_this.allDataPoints, instance);
                    _this.allDataPoints[index] = newInstance;
                }
                _this.filterFormulas();
            });
        };
        FormulaCtrl.prototype.remove = function (instance) {
            var _this = this;
            this.uiUtilityService.confirm('Are you sure you want to delete this formula?').then(function (confirmed) {
                if (!confirmed) {
                    return;
                }
                _this.loaderService.loadingPromise(_this.dataPointService.remove({
                    id: instance.id,
                    plantId: _this.selectedPlant.id,
                    plantLocationId: instance.plantLocationId
                }).then(function () {
                    _.remove(_this.allDataPoints, instance);
                    _this.filterFormulas();
                }, _this.notifyService.handleApiErrors));
            });
        };
        FormulaCtrl.prototype.getTypeName = function (type) {
            return aps_enums_1.apsEnums.DataPointType[type];
        };
        return FormulaCtrl;
    }());
    exports.default = angular.module('aps.controller.formula', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.FORMULAS,
            url: '/admin/formulas',
            controller: 'FormulaCtrl as vm',
            template: formula_tpl_html_1.default,
            data: {
                pageTitle: 'Formulas',
                authorizeAPSIOAdmin: true
            }
        });
    }])
        .controller('FormulaCtrl', FormulaCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(719), __webpack_require__(57), __webpack_require__(6), __webpack_require__(4), __webpack_require__(12), __webpack_require__(5), __webpack_require__(721)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, formulaTester_controller_1, dataPoints_service_1, notify_service_1, loader_service_1, newguid_service_1, aps_enums_1, editFormula_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [formulaTester_controller_1.default, dataPoints_service_1.default, notify_service_1.default, loader_service_1.default, newguid_service_1.default];
    function openEditFormula(data, $modal) {
        return $modal.open({
            template: editFormula_tpl_html_1.default,
            controller: 'EditFormulaCtrl as vm',
            resolve: {
                data: function () { return data; }
            }
        }).result;
    }
    exports.openEditFormula = openEditFormula;
    var EditFormulaCtrl = (function () {
        EditFormulaCtrl.$inject = ["data", "newGuidService", "dataPointService", "$modalInstance", "$modal", "notifyService", "loaderService", "uiUtilityService"];
        function EditFormulaCtrl(data, newGuidService, dataPointService, $modalInstance, $modal, notifyService, loaderService, uiUtilityService) {
            var _this = this;
            this.dataPointService = dataPointService;
            this.$modalInstance = $modalInstance;
            this.notifyService = notifyService;
            this.loaderService = loaderService;
            this.newGuidService = newGuidService;
            this.$modal = $modal;
            this.errors = [];
            this.plant = data.plant;
            this.allDataPoints = data.allDataPoints;
            this.locations = data.locations;
            this.selectedLocation = data.selectedLocation;
            if (data.instance) {
                this.selectedLocation = _.find(this.locations, function (l) { return l.location.id === data.instance.plantLocationId; });
            }
            if (!this.selectedLocation) {
                this.selectedLocation = data.locations[0];
            }
            if (data.instance) {
                this.dataPoint = JSON.parse(JSON.stringify(data.instance));
                this.dataPoint.variables.forEach(function (v) {
                    if (v.referenceDataPointId) {
                        var dataPoint = _.find(_this.allDataPoints, { id: v.referenceDataPointId });
                        if (dataPoint) {
                            v.dataPointName = dataPoint.name;
                        }
                    }
                });
                this.add = false;
            }
            else {
                this.dataPoint = {
                    configType: aps_enums_1.apsEnums.DataPointConfigType.Formula,
                    variables: [],
                    plantId: this.plant.id,
                    id: null,
                    config: '',
                    name: '',
                    type: null,
                    plantLocationId: null
                };
                newGuidService.getNewGuid('dataPoint').then(function (id) { return _this.dataPoint.id = id; });
                this.add = true;
            }
            this.types = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.DataPointType, 1);
            this.allVariableTypes = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.VariableType, 1);
            this.locationChanged();
        }
        EditFormulaCtrl.prototype.locationChanged = function () {
            var _this = this;
            this.dataPoint.plantLocationId = this.selectedLocation.location.id;
            var currentLocation = this.selectedLocation;
            var locationIds = [];
            while (currentLocation) {
                locationIds.push(currentLocation.location.id);
                currentLocation = currentLocation.parent;
            }
            this.shops = [this.selectedLocation]
                .concat(this.selectedLocation.children)
                .filter(function (l) { return l.locationType === aps_enums_1.apsEnums.LocationType.Shop; });
            if (this.shops.length === 0) {
                this.variableTypes = this.allVariableTypes.filter(function (v) { return v.value === aps_enums_1.apsEnums.VariableType.DataPoint; });
                this.dataPoint.variables.filter(function (x) { return x.type !== aps_enums_1.apsEnums.VariableType.DataPoint; })
                    .forEach(function (x) { return x.type = aps_enums_1.apsEnums.VariableType.DataPoint; });
            }
            else {
                this.variableTypes = this.allVariableTypes;
                if (this.shops.length === 1) {
                    this.dataPoint.variables.filter(function (x) { return x.type !== aps_enums_1.apsEnums.VariableType.DataPoint; })
                        .forEach(function (x) { return x.shopId = _this.shops[0].id; });
                }
            }
            this.refDataPoints = _.filter(this.allDataPoints, function (dp) { return dp.id !== _this.dataPoint.id
                && _.some(locationIds, function (id) { return dp.plantLocationId === id; }); });
        };
        EditFormulaCtrl.prototype.getDataPoints = function (variable) {
            var refIds = _.map(_.filter(this.dataPoint.variables, function (v) { return v !== variable && !!v.referenceDataPointId; }), 'referenceDataPointId');
            return _.filter(this.refDataPoints, function (dp) { return _.every(refIds, function (x) { return x !== dp.id; }); });
        };
        EditFormulaCtrl.prototype.detailDataPointChanged = function (variable) {
            var dataPoint = _.find(this.refDataPoints, { name: variable.dataPointName });
            if (dataPoint) {
                variable.referenceDataPointId = dataPoint.id;
                return;
            }
            variable.dataPointName = '';
            variable.referenceDataPointId = null;
        };
        EditFormulaCtrl.prototype.addVariable = function () {
            var variable = {
                id: null,
                type: null,
                name: '',
                referenceDataPointId: null,
                shopId: null
            };
            this.newGuidService.getNewGuid('formulaVariable').then(function (id) { return variable.id = id; });
            this.dataPoint.variables.push(variable);
        };
        EditFormulaCtrl.prototype.removeVariable = function (variable) {
            _.remove(this.dataPoint.variables, variable);
        };
        EditFormulaCtrl.prototype.clearErrors = function () {
            this.errors = [];
        };
        EditFormulaCtrl.prototype.save = function () {
            var _this = this;
            if (this.form.$invalid) {
                return;
            }
            this.errors = [];
            this.dataPoint.variables.forEach(function (v) {
                if (v.type === aps_enums_1.apsEnums.VariableType.DataPoint) {
                    v.shopId = null;
                }
                else {
                    v.referenceDataPointId = null;
                }
            });
            var promise = this.dataPointService.validateFormula({
                formula: this.dataPoint.config,
                variableNames: _.map(this.dataPoint.variables, 'name')
            }).then(function (errors) {
                if (errors.length > 0) {
                    _this.errors = errors;
                    return;
                }
                var method = _this.add ? _this.dataPointService.add : _this.dataPointService.update;
                return method(_this.dataPoint)
                    .then(function () {
                    _this.$modalInstance.close(_this.dataPoint);
                }, _this.notifyService.handleApiErrors);
            }, this.notifyService.handleApiErrors);
            this.loaderService.loadingPromise(promise);
        };
        EditFormulaCtrl.prototype.testFormula = function () {
            formulaTester_controller_1.openFormulaTester({
                formula: this.dataPoint.config,
                variables: _.map(this.dataPoint.variables, 'name')
            }, this.$modal);
        };
        EditFormulaCtrl.prototype.cancel = function () {
            this.$modalInstance.close();
        };
        return EditFormulaCtrl;
    }());
    exports.default = angular.module('aps.controller.editFormula', requires)
        .controller('EditFormulaCtrl', EditFormulaCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(6), __webpack_require__(4), __webpack_require__(57), __webpack_require__(2), __webpack_require__(720)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, notify_service_1, loader_service_1, dataPoints_service_1, _, formulaTester_tpl_html_1) {
    "use strict";
    formulaTester.$inject = ["data", "dataPointService", "$modalInstance", "notifyService", "loaderService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [notify_service_1.default, loader_service_1.default, dataPoints_service_1.default];
    function openFormulaTester(data, $modal) {
        return $modal.open({
            template: formulaTester_tpl_html_1.default,
            controller: 'FormulaTesterCtrl as vm',
            resolve: {
                data: function () { return data; }
            }
        }).result;
    }
    exports.openFormulaTester = openFormulaTester;
    exports.default = angular.module('aps.controller.formulaTester', requires)
        .controller('FormulaTesterCtrl', formulaTester)
        .name;
    function formulaTester(data, dataPointService, $modalInstance, notifyService, loaderService) {
        var vm = {
            formula: data.formula,
            errors: [],
            result: null,
            values: _.map(data.variables, function (v) {
                return { key: v, value: 1 };
            })
        };
        vm.test = function () {
            if (vm.form.$invalid) {
                return;
            }
            vm.errors = [];
            vm.result = null;
            var promise = dataPointService.validateFormula({
                formula: vm.formula,
                variableNames: _.map(vm.values, 'key')
            }).then(function (errors) {
                if (errors.length > 0) {
                    vm.errors = errors;
                    return;
                }
                return dataPointService.calculateFormula({
                    formula: vm.formula,
                    variables: vm.values
                }).then(function (result) {
                    vm.result = result;
                }, function () { return errors = ['Unknown error occurred during calculation']; });
            }, notifyService.handleApiErrors);
            loaderService.loadingPromise(promise);
        };
        vm.cancel = function () { return $modalInstance.close(); };
        return vm;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <h2 class=modal-header>Formula Tester</h2> <form name=vm.form ng-submit=vm.test() novalidate> <div class=container style=\"margin:0 -30px\"> <div class=row> <div class=\"large-12 columns\"> <label><span class=\"required notated\">*</span>Formula: <input name=formula type=text ng-model=vm.formula required/> </label> <div ng-messages=vm.form.formula.$error ng-if=\"vm.form.formula.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> </div> <div class=row ng-repeat=\"v in vm.values\"> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Name: <input name=\"name{{$index}}\" type=text ng-model=v.key required/> </label> <div ng-messages=\"vm.form['name' + $index].$error\" ng-if=\"vm.form['name' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-6 columns\"> <label><span class=\"required notated\">*</span>Value: <input name=\"val{{$index}}\" type=number ng-model=v.value required/> </label> <div ng-messages=\"vm.form['val' + $index].$error\" ng-if=\"vm.form['val' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> </div> <div class=row ng-repeat=\"error in vm.errors\"> <div class=\"large-12 columns\"> <div role=alert> <div class=req-w>{{error}}</div> </div> </div> </div> <div class=row ng-if=\"vm.result !== null\"> <div class=\"large-12 columns\"> <label>Result: <span style=font-weight:700>{{vm.result}}</span></label> </div> </div> <div class=row> <div class=\"large-12 columns\"> <span class=required>* Required Fields</span> <div class=\"right dialog-footer\"> <button ng-click=vm.cancel() type=button class=\"button secondary\">Close</button> <button class=button type=submit>Test Formula</button> </div> </div> </div> </div> </form> </div>");

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <h2 class=modal-header>Formula</h2> <form name=vm.form ng-submit=vm.save() novalidate> <div class=container style=\"margin:0 -30px\"> <div class=row> <div class=\"large-4 columns\"> <label><span class=\"required notated\">*</span>Name: <input name=name type=text ng-model=vm.dataPoint.name required/> </label> <div ng-messages=vm.form.name.$error ng-if=\"vm.form.name.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-4 columns\"> <label><span class=\"required notated\">*</span>Type: <select name=type ng-model=vm.dataPoint.type required ng-options=\"t.value as t.text for t in vm.types\"> <option value=\"\">-- Select a Type --</option> </select> </label> <div ng-messages=vm.form.type.$error ng-if=\"vm.form.type.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"small-4 columns\"> <label> Location <select name=selectedLocation ng-model=vm.selectedLocation ng-options=\"location as location.name for location in vm.locations\" ng-change=vm.locationChanged()> </select> </label> </div> </div> <div class=row> <div class=\"large-12 columns\"> <label><span class=\"required notated\">*</span>Formula: <input name=formula type=text ng-change=vm.clearErrors() ng-model=vm.dataPoint.config required/> </label> <div ng-messages=vm.form.formula.$error ng-if=\"vm.form.formula.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> <div ng-repeat=\"error in vm.errors\" role=alert> <div class=req-w><div class=arrow-up></div>{{error}}</div> </div> </div> </div> <div class=row ng-repeat=\"v in vm.dataPoint.variables\"> <div class=\"large-4 columns\"> <label><span class=\"required notated\">*</span>Name: <input name=\"name{{$index}}\" type=text ng-model=v.name required/> </label> <div ng-messages=\"vm.form['name' + $index].$error\" ng-if=\"vm.form['name' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-3 columns\"> <label><span class=\"required notated\">*</span>Type: <select name=\"type{{$index}}\" ng-model=v.type required ng-options=\"t.value as t.text for t in vm.variableTypes\"> <option value=\"\">-- Select a Type --</option> </select> </label> <div ng-messages=\"vm.form['type' + $index].$error\" ng-if=\"vm.form['type' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-4 columns\" ng-if=\"v.type === 1\"> <label><span class=\"required notated\">*</span>Data Point: <input name=\"dp{{$index}}\" type=text ng-model=v.dataPointName ng-select=vm.detailDataPointChanged(v) typeahead-on-select=vm.detailDataPointChanged(v) typeahead=\"dp.name for dp in vm.getDataPoints(v) | orderBy: 'name' | filter:$viewValue | limitTo:8\" required/> </label> <div ng-messages=\"vm.form['dp' + $index].$error\" ng-if=\"vm.form['dp' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-4 columns\" ng-if=\"v.type > 1\"> <label><span class=\"required notated\">*</span>Shop: <select name=\"shop{{$index}}\" ng-model=v.shopId required ng-options=\"t.id as t.name for t in vm.shops\"> <option value=\"\">-- Select a Shop --</option> </select> </label> <div ng-messages=\"vm.form['shop' + $index].$error\" ng-if=\"vm.form['shop' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-1 column\"> <button type=button class=\"button alert\" ng-click=vm.removeVariable(v)><i class=\"fa fa-trash\"></i></button> </div> </div> <div class=row> <div class=\"large-3 columns\"> <button class=button type=button ng-click=vm.addVariable()>Add Variable</button> </div> </div> <div class=row> <div class=\"large-12 columns\"> <span class=required>* Required Fields</span> <div class=dialog-footer> <div class=left> <button type=button class=button ng-click=vm.testFormula()>Test Formula</button> </div> <div class=right> <button ng-click=vm.cancel() type=button class=\"button secondary\">Cancel</button> <button class=button type=submit>Save Formula</button> </div> </div> </div> </div> </div> </form> </div>");

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <div class=body-header><h2>Formulas</h2></div> <div class=container> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>Plant: <select ng-model=vm.selectedPlant ng-options=\"plant.name for plant in vm.plants\" ng-change=vm.plantChanged()> </select> </label> </div> <div class=\"small-3 columns\"> <label> Location <select name=selectedLocation ng-model=vm.selectedLocation ng-options=\"location as location.name for location in vm.locations\" ng-change=vm.locationChanged()> <option value=\"\">-- Any Location --</option> </select> </label> </div> <div class=\"small-2 columns\"> <button ng-click=vm.add() class=\"button small\" style=position:relative;top:14px>Add Formula</button> </div> </div> <div ng-if=\"vm.formulas && vm.formulas.length === 0\" style=width:100%;clear:both;float:left;margin-top:30px> Currently there are no Formulas for {{vm.selectedLocation ? vm.selectedLocation.name : 'any location in this Plant'}} </div> <table cellpadding=1 cellspacing=1 ng-if=\"vm.formulas && vm.formulas.length > 0\" class=history-t> <tr> <th>Name</th> <th>Type</th> <th>Location</th> <th></th> </tr> <tr ng-repeat=\"instance in vm.formulas\"> <td>{{ instance.name }}</td> <td>{{ instance.typeName }}</td> <td>{{ instance.location }}</td> <td> <button ng-click=vm.edit(instance) class=\"button tiny\" style=margin:0>Edit</button> <button ng-click=vm.remove(instance) class=\"button tiny alert\" style=margin:0>Delete</button> </td> </tr> </table> </div> </div>");

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(724), __webpack_require__(726), __webpack_require__(3), __webpack_require__(307)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, addHoliday_controller_1, holidays_tpl_html_1, constant_module_1, holidays_service_1) {
    "use strict";
    holidaysRoute.$inject = ["$stateProvider"];
    holidaysCtrl.$inject = ["$modal", "holidaysService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [addHoliday_controller_1.default, holidays_service_1.default];
    exports.default = angular.module('aps.controller.holidays', requires)
        .config(holidaysRoute)
        .controller('HolidaysCtrl', holidaysCtrl)
        .name;
    function holidaysRoute($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.HOLIDAYS,
            url: '/admin/holidays',
            controller: 'HolidaysCtrl as holidaysCtrl',
            template: holidays_tpl_html_1.default,
            data: {
                pageTitle: 'Holidays',
                authorizeAdmin: true
            }
        });
    }
    function holidaysCtrl($modal, holidaysService) {
        'use strict';
        var vm = this;
        vm.year = new Date().getFullYear();
        loadHolidays();
        vm.prevYear = function () {
            vm.year--;
            loadHolidays();
        };
        vm.nextYear = function () {
            vm.year++;
            loadHolidays();
        };
        function loadHolidays() {
            holidaysService.getHolidays(vm.year).then(function (result) {
                vm.holidays = result;
            });
        }
        vm.addHoliday = function () {
            var result = addHoliday_controller_1.openAddHoliday({
                year: vm.year
            }, $modal);
            result.then(function () {
                loadHolidays();
            });
        };
        vm.deleteHoliday = function (holiday) {
            var command = {
                id: holiday.id
            };
            holidaysService.deleteHoliday(command).then(function () {
                loadHolidays();
            });
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(307), __webpack_require__(6), __webpack_require__(3), __webpack_require__(725)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, moment, holidays_service_1, notify_service_1, constant_module_1, addHoliday_tpl_html_1) {
    "use strict";
    addHolidayCtrl.$inject = ["data", "$modalInstance", "holidaysService", "notifyService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [holidays_service_1.default, notify_service_1.default];
    function openAddHoliday(data, $modal) {
        return $modal.open({
            template: addHoliday_tpl_html_1.default,
            controller: 'AddHolidayCtrl as vm',
            resolve: {
                data: function () {
                    return data;
                }
            }
        }).result;
    }
    exports.openAddHoliday = openAddHoliday;
    exports.default = angular.module('aps.controller.addHoliday', requires)
        .controller('AddHolidayCtrl', addHolidayCtrl)
        .name;
    function addHolidayCtrl(data, $modalInstance, holidaysService, notifyService) {
        'use strict';
        var vm = this;
        vm.year = data.year;
        vm.minDate = moment([data.year, 0, 1]).format(constant_module_1.Strings.ISO_DATE_FORMAT);
        vm.maxDate = moment([data.year + 1, 0, 1]).subtract(1, 'days').format(constant_module_1.Strings.ISO_DATE_FORMAT);
        vm.submit = function () {
            if (vm.form.$invalid) {
                return;
            }
            var command = {
                date: vm.date,
                name: vm.name
            };
            holidaysService.addHoliday(command)
                .then(function () {
                $modalInstance.close();
            }, notifyService.handleApiErrors);
        };
        vm.cancel = function () {
            $modalInstance.close();
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<form name=vm.form ng-submit=vm.submit() novalidate> <div> <h3>Add Holiday for {{ vm.year }}</h3> <label> <span class=\"required notated\">*</span>Date: <input type=date name=date ng-model=vm.date required min=\"{{vm.minDate}}\" max=\"{{vm.maxDate}}\"/> <div ng-messages=vm.form.date.$error ng-if=\"vm.form.date.$dirty || vm.form.$submitted\"> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be in {{ vm.year }}</div> <div ng-message=max class=req-w><div class=arrow-up></div>Must be in {{ vm.year }}</div> </div> </label> <label> <span class=\"required notated\">*</span>Name: <input type=text name=name ng-model=vm.name required/> <div ng-messages=vm.form.name.$error ng-if=\"vm.form.name.$dirty || vm.form.$submitted\"> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-12 columns\"> <span class=required>* Required Fields</span> <div class=\"right dialog-footer\"> <button type=submit class=button>Add Holiday</button> <button type=button ng-click=vm.cancel() class=\"button secondary\">Cancel</button> </div> </div> </div> </form> ");

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <div class=body-header><h2>{{ holidaysCtrl.year }} Holidays</h2> <a href=\"\" class=\"button small\" ng-click=holidaysCtrl.addHoliday()>Add Holiday</a> <a href=\"\" ng-click=holidaysCtrl.nextYear() style=\"float:right;margin:5px 25px\">Next Year <i class=\"fa fa-arrow-circle-o-right\"></i></a> <a href=\"\" ng-click=holidaysCtrl.prevYear() style=\"float:right;margin:5px 0\"><i class=\"fa fa-arrow-circle-o-left\"></i> Prev Year</a> </div> <table class=history-t> <tr> <thead> <th width=30%>Date</th> <th width=60%>Name</th> <th>&nbsp;</th> </thead> </tr> <tr ng-repeat=\"holiday in holidaysCtrl.holidays\"> <td>{{ holiday.date | date : 'd MMMM, yyyy' : 'UTC' }}</td> <td>{{ holiday.name }}</td> <td> <button ng-click=holidaysCtrl.deleteHoliday(holiday) class=\"button tiny\" style=margin:0>Delete</button> </td> </tr> <tr ng-if=\"holidaysCtrl.holidays.length == 0\"> <td colspan=3> There are no holidays defined for {{ holidaysCtrl.year }}. </td> </tr> </table> </div>");

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(728), __webpack_require__(9), __webpack_require__(4), __webpack_require__(79), __webpack_require__(6), __webpack_require__(3), __webpack_require__(730), __webpack_require__(2), __webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, jobEditor_controller_1, uiUtility_service_1, loader_service_1, job_service_1, notify_service_1, constant_module_1, jobList_tpl_html_1, _, authData_service_1) {
    "use strict";
    jobListRoute.$inject = ["$stateProvider"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [jobEditor_controller_1.default, uiUtility_service_1.default, loader_service_1.default, job_service_1.default, notify_service_1.default, authData_service_1.default];
    var JobListCtlr = (function () {
        JobListCtlr.$inject = ["$modal", "jobService", "loaderService", "uiUtilityService", "authDataService", "notifyService"];
        function JobListCtlr($modal, jobService, loaderService, uiUtilityService, authDataService, notifyService) {
            var _this = this;
            this.$modal = $modal;
            this.jobService = jobService;
            this.loaderService = loaderService;
            this.uiUtilityService = uiUtilityService;
            this.notifyService = notifyService;
            this.authDataService = authDataService;
            this.isAdmin = false;
            if (_.find(this.authDataService.getRoles(), function (x) { return x.roleName === 'APSIO Administrator'; })) {
                this.isAdmin = true;
            }
            loaderService.loadingPromise(jobService.getJobs().then(function (jobData) {
                _this.jobs = jobData;
            }, notifyService.handleApiErrors));
        }
        JobListCtlr.prototype.loadModalJobEditor = function (job) {
            var _this = this;
            var result = jobEditor_controller_1.openEditJob(job, this.$modal);
            result.then(function (editedJob) {
                if (!editedJob) {
                    return;
                }
                if (job) {
                    _.assign(job, editedJob);
                    return;
                }
                _this.jobs.unshift(editedJob);
            });
        };
        JobListCtlr.prototype.addJob = function () {
            this.loadModalJobEditor();
        };
        JobListCtlr.prototype.editJob = function (job) {
            this.loadModalJobEditor(job);
        };
        JobListCtlr.prototype.deleteJob = function (job) {
            var _this = this;
            this.uiUtilityService.confirm('Mark ' + job.name + ' as deleted?')
                .then(function (result) {
                if (!result) {
                    return;
                }
                _this.loaderService.loadingPromise(_this.jobService.deleteJob(job).then(function () {
                    _.remove(_this.jobs, { id: job.id });
                }, _this.notifyService.handleApiErrors));
            });
        };
        return JobListCtlr;
    }());
    exports.default = angular.module('aps.controller.joblist', requires)
        .config(jobListRoute)
        .controller('JobListCtrl', JobListCtlr)
        .name;
    function jobListRoute($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.JOBS,
            url: '/admin/jobs',
            controller: 'JobListCtrl as vm',
            template: jobList_tpl_html_1.default,
            data: {
                pageTitle: 'Jobs',
                authorizePlantAdmin: true,
                v2Uri: "aps/settings/job-list",
            }
        });
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(79), __webpack_require__(25), __webpack_require__(4), __webpack_require__(6), __webpack_require__(12), __webpack_require__(2), __webpack_require__(729)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, job_service_1, defectType_service_1, loader_service_1, notify_service_1, newguid_service_1, _, jobEditor_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [job_service_1.default, defectType_service_1.default, loader_service_1.default, notify_service_1.default, newguid_service_1.default];
    function openEditJob(data, $modal) {
        return $modal.open({
            template: jobEditor_tpl_html_1.default,
            controller: 'JobEditorCtrl as vm',
            resolve: {
                data: function () {
                    return data;
                }
            }
        }).result;
    }
    exports.openEditJob = openEditJob;
    var JobEditorCtlr = (function () {
        JobEditorCtlr.$inject = ["data", "$modalInstance", "jobService", "defectTypeService", "loaderService", "notifyService", "newGuidService", "$stateParams", "$q"];
        function JobEditorCtlr(data, $modalInstance, jobService, defectTypeService, loaderService, notifyService, newGuidService, $stateParams, $q) {
            var _this = this;
            this.$modalInstance = $modalInstance;
            this.jobService = jobService;
            this.defectTypeService = defectTypeService;
            this.loaderService = loaderService;
            this.notifyService = notifyService;
            this.newGuidService = newGuidService;
            this.$q = $q;
            this.isAdding = !data;
            var promises = [];
            this.excludedDefectTypes = [];
            this.selectedPlant = $stateParams.plantId;
            this.selectedShop = $stateParams.shopId;
            if (this.isAdding) {
                this.editJob = {
                    id: '',
                    name: '',
                    customerId: '',
                    customerName: '',
                    processId: '',
                    processName: '',
                    note: '',
                    description: '',
                    mold: '',
                    finish: '',
                    wareClassId: '',
                    wareClassName: '',
                    glassColorId: '',
                    glassColorName: '',
                    isDeleted: false,
                    finishSize: '',
                    excludedDefectTypeIds: []
                };
                promises.push(this.newGuidService.getNewGuid('job').then(function (id) {
                    _this.editJob.id = id;
                }, this.notifyService.handleApiErrors));
            }
            else {
                this.editJob = {};
                _.assign(this.editJob, data);
            }
            promises.push(this.jobService.getCustomers().then(function (customers) {
                _this.customers = customers;
            }, this.notifyService.handleApiErrors));
            promises.push(this.jobService.getProcesses().then(function (processes) {
                _this.processes = processes;
                if (_this.editJob.processId !== '') {
                    _this.selectedProcess = _.find(_this.processes, { id: _this.editJob.processId });
                }
            }, this.notifyService.handleApiErrors));
            promises.push(this.jobService.getGlassColors().then(function (glassColors) {
                _this.glassColors = glassColors;
                if (_this.editJob.glassColorId !== '') {
                    _this.selectedGlassColor = _.find(_this.glassColors, { id: _this.editJob.glassColorId });
                }
            }, this.notifyService.handleApiErrors));
            promises.push(this.jobService.getWareClasses().then(function (wareClasses) {
                _this.wareClasses = wareClasses;
                if (_this.editJob.wareClassId !== '') {
                    _this.selectedWareClass = _.find(_this.wareClasses, { id: _this.editJob.wareClassId });
                }
            }, this.notifyService.handleApiErrors));
            promises.push(this.jobService.getDescriptions().then(function (descriptions) {
                _this.descriptions = descriptions;
            }, this.notifyService.handleApiErrors));
            promises.push(this.jobService.getTargetFinishes(this.selectedPlant, "").then(function (finishes) {
                _this.finishes = finishes;
            }, this.notifyService.handleApiErrors));
            promises.push(this.jobService.getTargetMolds(this.selectedPlant).then(function (molds) {
                _this.molds = molds;
            }, this.notifyService.handleApiErrors));
            promises.push(this.defectTypeService.getDefectTypesAndClassifications()
                .then(function (data) {
                if (_this.editJob.excludedDefectTypeIds && _this.editJob.excludedDefectTypeIds.length > 0) {
                    _this.excludedDefectTypes = _.filter(data.types, function (dt) { return _.some(_this.editJob.excludedDefectTypeIds, function (id) { return id === dt.id; }); });
                }
                _this.allDefectTypes = data.types;
                _this.availableDefectTypes = _.difference(_this.allDefectTypes, _this.excludedDefectTypes);
            }));
            this.loaderService.loadingPromise(this.$q.all(promises));
        }
        JobEditorCtlr.prototype.save = function () {
            var _this = this;
            if (this.form.$invalid) {
                if (this.form.mold.$invalid || this.form.mold.$dirty) {
                    var moldVal = this.form.mold;
                    if (this.molds.indexOf(moldVal.$viewValue) > -1) {
                        this.form.$removeControl(this.form.mold);
                    }
                    if (this.form.$invalid) {
                        console.log('form invalid', this.form);
                        return;
                    }
                }
                else {
                    console.log('form invalid', this.form);
                    return;
                }
            }
            if (this.selectedProcess) {
                this.editJob.processId = this.selectedProcess.id;
                this.editJob.processName = this.selectedProcess.name;
            }
            if (this.selectedGlassColor) {
                this.editJob.glassColorId = this.selectedGlassColor.id;
                this.editJob.glassColorName = this.selectedGlassColor.name;
            }
            if (this.selectedWareClass) {
                this.editJob.wareClassId = this.selectedWareClass.id;
                this.editJob.wareClassName = this.selectedWareClass.name;
            }
            this.editJob.excludedDefectTypeIds = _.map(this.excludedDefectTypes, 'id');
            var cmd = {
                id: this.editJob.id,
                name: this.editJob.name,
                customerName: this.editJob.customerName,
                processId: this.editJob.processId,
                note: this.editJob.note,
                description: this.editJob.description,
                mold: this.editJob.mold,
                finish: this.editJob.finish,
                finishSize: this.editJob.finishSize,
                wareClassId: this.editJob.wareClassId,
                glassColorId: this.editJob.glassColorId,
                excludedDefectTypeIds: this.editJob.excludedDefectTypeIds,
                sectionChangeStrategyId: null
            };
            var promise;
            if (this.isAdding) {
                promise = this.jobService.addJob(cmd);
            }
            else {
                promise = this.jobService.saveJob(cmd);
            }
            this.loaderService.loadingPromise(promise.then(function () {
                _this.$modalInstance.close(_this.editJob);
            }, this.notifyService.handleApiErrors));
        };
        JobEditorCtlr.prototype.cancel = function () {
            this.$modalInstance.close();
        };
        JobEditorCtlr.prototype.moldChange = function () {
            var _this = this;
            if (this.editJob.mold) {
                this.jobService.getTargetFinishes(this.selectedPlant, this.editJob.mold).then(function (finishes) {
                    _this.finishes = finishes;
                }, this.notifyService.handleApiErrors);
            }
        };
        JobEditorCtlr.prototype.defectTypeAdded = function () {
            var defectType = _.find(this.allDefectTypes, { name: this.defectType });
            if (!defectType) {
                return;
            }
            this.defectType = null;
            this.excludedDefectTypes.push(defectType);
            _.remove(this.availableDefectTypes, defectType);
        };
        ;
        JobEditorCtlr.prototype.removeDefectType = function (defectType) {
            _.remove(this.excludedDefectTypes, defectType);
            this.availableDefectTypes.push(defectType);
        };
        return JobEditorCtlr;
    }());
    exports.default = angular.module('aps.controller.jobedit', requires)
        .controller('JobEditorCtrl', JobEditorCtlr)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("﻿<div class=edit-job> <form name=vm.form ng-submit=vm.save() novalidate> <h2 class=modal-header ng-if=vm.isAdding style=margin-top:-48px>Add Job</h2> <h2 class=modal-header ng-if=!vm.isAdding style=margin-top:-48px>Edit Job</h2> <div class=container> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-6 columns\"> <label> <span class=\"required notated\">*</span>Mold: <input name=mold type=text required ng-model=vm.editJob.mold ng-blur=vm.moldChange() typeahead=\"x for x in vm.molds | filter:$viewValue | limitTo:8\" typeahead-editable=false autofill=off autocomplete=off /> <div ng-messages=vm.form.mold.$error ng-if=\"vm.form.mold.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> <div class=req-i ng-if=!vm.editJob.mold> <div class=arrow-up-blue></div>Select An Existing Mold </div> </label> </div> <div class=\"small-2 columns\"> <label> Finish Size: <input name=finish type=text ng-model=vm.editJob.finishSize autofill=true autocomplete=off /> </label> </div> <div class=\"small-4 columns\"> <label> <span class=\"required notated\">*</span>Finish: <input name=finish type=text required ng-model=vm.editJob.finish typeahead=\"x for x in vm.finishes | filter:$viewValue | limitTo:8\" typeahead-editable=false autofill=true autocomplete=off /> <div ng-messages=vm.form.finish.$error ng-if=\"vm.form.finish.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> <div class=req-i ng-if=!vm.editJob.finish> <div class=arrow-up-blue></div>Select An Existing Finish </div> </label> </div> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-4 columns\"> <label> <span class=\"required notated\">*</span>Job Name: <input name=name type=text ng-model=vm.editJob.name required autofill=true autocomplete=off /> <div ng-messages=vm.form.name.$error ng-if=\"vm.form.name.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> <div class=\"small-4 columns\"> <label> <span class=\"required notated\">*</span>Customer: <input name=customer type=text required ng-model=vm.editJob.customerName typeahead=\"customer.name for customer in vm.customers | filter:$viewValue | limitTo:8\" autocomplete=off /> <div ng-messages=vm.form.customer.$error ng-if=\"vm.form.customer.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> <div class=\"small-4 columns\"> <label> <span class=\"required notated\">*</span>Process: <select name=process ng-model=vm.selectedProcess ng-options=\"process.name for process in vm.processes | orderBy: 'name'\" required> <option value=\"\">-- Select a Process --</option> </select> <div ng-messages=vm.form.process.$error ng-if=\"vm.form.process.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-12 columns\"> <label> Note: <textarea name=note type=text rows=3 ng-model=vm.editJob.note /> </label> </div> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-12 columns\"> <label> <span class=\"required notated\">*</span>Description: <input name=description type=text required ng-model=vm.editJob.description typeahead=\"x for x in vm.descriptions | filter:$viewValue | limitTo:8\" autocomplete=off /> <div ng-messages=vm.form.description.$error ng-if=\"vm.form.description.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-6 columns\"> <label> <span class=\"required notated\">*</span>Ware Class: <select name=wareClass ng-model=vm.selectedWareClass ng-options=\"wc.name for wc in vm.wareClasses | orderBy: 'name'\" required> <option value=\"\">-- Select a Ware Class --</option> </select> <div ng-messages=vm.form.wareClass.$error ng-if=\"vm.form.wareClass.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-6 columns\"> <label> <span class=\"required notated\">*</span>Glass Color: <select name=glassColor ng-model=vm.selectedGlassColor ng-options=\"gc.name for gc in vm.glassColors | orderBy: 'name'\" required> <option value=\"\">-- Select a Glass Color --</option> </select> <div ng-messages=vm.form.glassColor.$error ng-if=\"vm.form.glassColor.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> </div> <div class=row ng-if=\"vm.availableDefectTypes && vm.availableDefectTypes.length > 0\"> <div class=\"small-6 large-6 columns\"> <label>Add Excluded Defect Type <input name=defectType type=text ng-model=vm.defectType ng-select=vm.defectTypeAdded() typeahead-on-select=vm.defectTypeAdded() typeahead=\"dt.name for dt in vm.availableDefectTypes | filter:$viewValue | limitTo:8\"/> </label> </div> </div> <div class=row ng-if=\"vm.excludedDefectTypes.length > 0\"> <div class=\"small-12 large-12 columns\"> <label>Excluded Defect Types</label> <ul> <li ng-repeat=\"dt in vm.excludedDefectTypes\"> {{dt.name}} <button type=button class=\"button tiny alert\" ng-click=vm.removeDefectType(dt)>Remove</button> </li> </ul> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-12 columns\"> <span class=required>* Required Fields</span> <div class=\"right dialog-footer\"> <button type=submit class=button> <span ng-if=vm.isAdding>Add Job</span> <span ng-if=!vm.isAdding>Save Job</span> </button> <button type=button class=\"button secondary\" value=Cancel ng-click=vm.cancel()> Cancel </button> </div> </div> </div> </div> </form> </div>");

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <div class=body-header> <h2>Jobs</h2> <div class=container> <div class=\"columns small-6\"> <input type=text placeholder=Search ng-model=vm.filter ng-if=\"vm.jobs && vm.jobs.length > 0\"/> </div> <button ng-click=vm.addJob() class=\"button small\">Add Job</button> </div> <div ng-if=\"vm.jobs && vm.jobs.length === 0\" style=width:100%;clear:both;float:left;margin-top:30px> There are no Jobs. Please add one to get started. </div> <table cellpadding=1 cellspacing=1 ng-if=\"vm.jobs && vm.jobs.length > 0\" class=history-t> <tr> <th>Name</th> <th>Process</th> <th>Customer</th> <th>Description</th> <th>Mold</th> <th>Finish</th> <th>Ware Class</th> <th>Color</th> <th width=20%></th> </tr> <tr ng-repeat=\"job in vm.jobs | filter: vm.filter \" ng-if=\"vm.jobs.length > 0\"> <td>{{ job.name }}</td> <td>{{ job.processName }}</td> <td>{{ job.customerName }}</td> <td>{{ job.description }}</td> <td>{{ job.mold }}</td> <td>{{ job.finish }}</td> <td>{{ job.wareClassName }}</td> <td>{{ job.glassColorName }}</td> <td><button ng-click=vm.editJob(job) class=\"button tiny\" style=margin:0>Edit</button> <button ng-hide=!vm.isAdmin ng-click=vm.deleteJob(job) class=\"button tiny alert\" style=\"margin:0 5px 0 0\">Delete</button></td> </tr> </table> </div> </div>");

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(732), __webpack_require__(90), __webpack_require__(4), __webpack_require__(8), __webpack_require__(7), __webpack_require__(3), __webpack_require__(11), __webpack_require__(734), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, editJobRun_controller_1, jobRun_service_1, loader_service_1, navigation_service_1, authData_service_1, constant_module_1, dateutility_service_1, jobRun_tpl_html_1, _) {
    "use strict";
    jobRunsConfig.$inject = ["$stateProvider"];
    jobRunsCtrl.$inject = ["$modal", "$q", "jobRunService", "loaderService", "navigationService", "authDataService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [
        editJobRun_controller_1.default,
        jobRun_service_1.default,
        loader_service_1.default,
        navigation_service_1.default,
        authData_service_1.default,
    ];
    exports.default = angular
        .module("aps.controller.jobRun", requires)
        .config(jobRunsConfig)
        .controller("JobRunsCtrl", jobRunsCtrl).name;
    function jobRunsConfig($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.JOB_RUNS,
            url: "/admin/jobRuns",
            controller: "JobRunsCtrl as vm",
            template: jobRun_tpl_html_1.default,
            data: {
                pageTitle: "Job Runs",
                authorizePlantAdmin: true,
                v2Uri: "aps/settings/job-runs",
            },
        });
    }
    function jobRunsCtrl($modal, $q, jobRunService, loaderService, navigationService, authDataService) {
        var _this = this;
        var vm = this;
        vm.isApsioAdmin = false;
        var timeZoneId = constant_module_1.Strings.DEFAULT_TIMEZONE;
        vm.formatTime = function (date) {
            return dateutility_service_1.default.formatTime(date, timeZoneId);
        };
        function getJobsRuns() {
            return jobRunService.getJobRuns(vm.selectedShop.id).then(function (jobRuns) {
                _.forEach(jobRuns, function (jobRun) {
                    jobRun.job = _.find(vm.jobs, { id: jobRun.jobId });
                });
                vm.jobRuns = jobRuns;
                return vm.jobRuns;
            });
        }
        vm.plants = [];
        var navPromise = navigationService
            .getNavigation()
            .then(function (navigation) {
            vm.navigation = navigation;
            var plants = navigation.plants();
            vm.plants = _.filter(plants, function (plant) {
                return authDataService.isPlantAdmin(plant.id);
            });
            if (vm.navigation.selectedPlant &&
                _.includes(vm.plants, vm.navigation.selectedPlant)) {
                vm.selectedPlant = vm.navigation.selectedPlant;
            }
            else {
                vm.selectedPlant = _.first(vm.plants);
            }
            vm.isApsioAdmin = authDataService.isAPSIOAdmin();
        });
        var jobPromise = jobRunService.getJobs().then(function (jobs) { return (vm.jobs = jobs); });
        loaderService.loadingPromise($q.all([navPromise, jobPromise]).then(function () {
            vm.plantChanged();
        }));
        vm.plantChanged = function () {
            timeZoneId = vm.selectedPlant.timeZoneId;
            if (vm.navigation.selectedShop &&
                _.includes(vm.selectedPlant.shops, vm.navigation.selectedShop)) {
                vm.selectedShop = vm.navigation.selectedShop;
            }
            else {
                vm.selectedShop = _.first(vm.selectedPlant.shops);
            }
            vm.shopChanged();
        };
        vm.shopChanged = function () {
            vm.jobRuns = undefined;
            loaderService.loadingPromise(getJobsRuns());
        };
        var loadModalJobRunEditor = function (jobRun) {
            var result = editJobRun_controller_1.openEditJobRun({
                jobRun: jobRun,
                shop: vm.selectedShop,
                plant: vm.selectedPlant,
                jobRuns: vm.jobRuns,
                jobs: vm.jobs,
            }, $modal);
            result.then(function (editedJobRun) {
                if (editedJobRun) {
                    var job = _.find(vm.jobs, { id: editedJobRun.jobId });
                    if (jobRun) {
                        _.assign(jobRun, {
                            job: job,
                        }, editedJobRun);
                    }
                    else {
                        vm.jobRuns.unshift(_.assign({
                            legacyId: null,
                            job: job,
                        }, editedJobRun));
                    }
                }
            });
        };
        vm.editJobRun = function (jobRun) {
            if ((jobRun || "") !== "") {
                loadModalJobRunEditor(jobRun);
            }
        };
        vm.canAddJobRun = function () {
            if (!!vm.jobRuns && vm.jobRuns.length > 0) {
                var jobrunStart = vm.formatTime(vm.jobRuns[0].startDate).substring(0, 10);
                var today = vm.formatTime(new Date()).substring(0, 10);
                return !(vm.jobRuns.length > 0 &&
                    jobrunStart === today &&
                    !_this.isApsioAdmin);
            }
            return true;
        };
        vm.addJobRun = function () {
            loadModalJobRunEditor(undefined);
        };
        vm.canRestore = function (jobRun) {
            if (!_this.isApsioAdmin) {
                return false;
            }
            return vm.jobRuns && vm.jobRuns.length > 1 && vm.jobRuns[1] === jobRun;
        };
        vm.restoreJobRun = function (jobRun) {
            loaderService.loadingPromise(jobRunService
                .restoreJobRun({
                id: jobRun.id,
                shopId: jobRun.shopId,
            })
                .then(function () {
                jobRun.endDate = null;
                vm.jobRuns.splice(0, 1);
            }));
        };
        return vm;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(2), __webpack_require__(4), __webpack_require__(12), __webpack_require__(6), __webpack_require__(11), __webpack_require__(73), __webpack_require__(90), __webpack_require__(733), __webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, moment, _, loader_service_1, newguid_service_1, notify_service_1, dateutility_service_1, sectionChange_service_1, jobRun_service_1, editJobRun_tpl_html_1, authData_service_1) {
    "use strict";
    editJobRunCtrl.$inject = ["$modalInstance", "loaderService", "newGuidService", "notifyService", "jobRunService", "sectionChangeService", "authDataService", "data"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, newguid_service_1.default, notify_service_1.default, sectionChange_service_1.default, jobRun_service_1.default, authData_service_1.default];
    function setPackingCheckBoxes(vm, jobRun) {
        vm.casePacker = !!(jobRun.containersPerCase || jobRun.casesPerCycle);
        vm.palletizer = !!(jobRun.containersPerTier || jobRun.tiersPerPallet);
    }
    exports.default = angular.module('aps.controller.editJobRun', requires)
        .controller('EditJobRunCtrl', editJobRunCtrl)
        .name;
    function openEditJobRun(data, $modal) {
        return $modal.open({
            template: editJobRun_tpl_html_1.default,
            controller: 'EditJobRunCtrl as vm',
            resolve: {
                data: function () {
                    return data;
                }
            }
        }).result;
    }
    exports.openEditJobRun = openEditJobRun;
    function editJobRunCtrl($modalInstance, loaderService, newGuidService, notifyService, jobRunService, sectionChangeService, authDataService, data) {
        var _this = this;
        var vm = this;
        vm.showHelp = null;
        vm.showHelpWindow = false;
        vm.isAdmin = false;
        vm.helpText = null;
        vm.equipmentNames = [];
        vm.toggleHelpWindow = null;
        var plant = data.plant;
        var shop = data.shop;
        var jobRun = data.jobRun;
        vm.jobs = _.filter(data.jobs, { isDeleted: false });
        var previousJobRun;
        var nextJobRun;
        vm.isNewJob = false;
        var now = dateutility_service_1.default.currentMinute();
        vm.timeZone = plant.timeZoneId;
        this.showAlertFields = true;
        this.targetDoesNotExist = false;
        if (jobRun) {
            vm.editJob = _.assign({}, jobRun);
            if (vm.editJob["machineRejectPercentage"] != undefined) {
                vm.editJob.selectedRejectedEquipment = JSON.parse(vm.editJob["machineRejectPercentage"]);
            }
            else {
                vm.editJob.selectedRejectedEquipment = [];
            }
            setPackingCheckBoxes(vm, jobRun);
            previousJobRun = _.first(_.filter(_.orderBy(data.jobRuns, ['startDate'], ['desc']), function (j) { return j.startDate.getTime() < jobRun.startDate.getTime(); }));
            nextJobRun = _.first(_.filter(_.sortBy(data.jobRuns, 'startDate'), function (j) { return j.startDate.getTime() > jobRun.startDate.getTime(); }));
        }
        else {
            vm.isNewJob = true;
            vm.editJob = {};
            vm.editJob.shopId = shop.id;
            vm.editJob.startDate = dateutility_service_1.default.getHourForTimeZone(now.toDate(), 7, plant.timeZoneId);
            newGuidService.getNewGuid('jobRun').then(function (id) {
                vm.editJob.id = id;
            });
            vm.editJob.numberOfSections = data.shop.defaultNumberOfSections;
            vm.editJob.numberOfGobs = data.shop.defaultNumberOfGobs;
            previousJobRun = _.first(_.orderBy(data.jobRuns, ['startDate'], ['desc']));
            if (previousJobRun && previousJobRun.containerSpeed > 0) {
                vm.editJob.containerSpeed = previousJobRun.containerSpeed;
            }
            if (vm.editJob["machineRejectPercentage"] != undefined) {
                vm.editJob.selectedRejectedEquipment = JSON.parse(vm.editJob["machineRejectPercentage"]);
            }
            else {
                vm.editJob.selectedRejectedEquipment = [];
            }
        }
        jobRunService.getEquipmentByShopName(shop.id).then(function (result) {
            _.forEach(result, function (equipmentEntity) {
                if (vm.editJob.selectedRejectedEquipment == undefined || vm.editJob.selectedRejectedEquipment.filter(function (m) { return m.selectedMachine == equipmentEntity; }).length == 0) {
                    vm.equipmentNames.push(equipmentEntity);
                }
            });
        });
        vm.isAdmin = authDataService.isAPSIOAdmin();
        var isStrategyIdValid = function (strategyId) {
            if (strategyId) {
                return _.some(vm.strategies, function (s) { return s.id === strategyId; });
            }
            return false;
        };
        var clearStrategyIdIfInvalid = function () {
            if (!isStrategyIdValid(vm.editJob.sectionChangeStrategyId)) {
                vm.editJob.sectionChangeStrategyId = null;
            }
        };
        loaderService.loadingPromise(sectionChangeService.getStrategiesForShop(shop).then(function (data) {
            vm.strategies = data;
            clearStrategyIdIfInvalid();
            if (vm.isNewJob) {
                var strategy = _.find(vm.strategies, function (s) {
                    return s.isDefault && s.shopId === shop.id;
                });
                if (!strategy) {
                    strategy = _.find(vm.strategies, function (s) {
                        return s.isDefault && s.shopId === null && s.plantId === shop.plantId;
                    });
                    if (!strategy) {
                        strategy = _.find(vm.strategies, function (s) {
                            return s.isDefault && s.shopId === null && s.plantId === null;
                        });
                    }
                }
                if (strategy) {
                    vm.editJob.sectionChangeStrategyId = strategy.id;
                }
            }
        }));
        vm.jobName = vm.editJob.job ? vm.editJob.job.name : '';
        vm.minDate = moment([2000]);
        if (previousJobRun) {
            vm.minDate = moment(previousJobRun.startDate).add(1, 'minutes');
        }
        vm.maxDate = function () {
            if (nextJobRun) {
                return moment(nextJobRun.startDate);
            }
            return moment().add(1, 'years');
        };
        vm.minStartDate = dateutility_service_1.default.formatISO(vm.minDate, plant.timeZoneId);
        vm.maxEndDate = dateutility_service_1.default.formatISO(vm.maxDate(), plant.timeZoneId);
        vm.maxStartDate = function () {
            if (vm.editJob.endDate) {
                return dateutility_service_1.default.formatISO(vm.editJob.endDate, plant.timeZoneId);
            }
            return vm.maxEndDate;
        };
        vm.minEndDate = function () {
            if (vm.editJob.startDate) {
                var minEndDate = moment(vm.editJob.startDate).add(1, 'minutes').toDate();
                return dateutility_service_1.default.formatISO(minEndDate, plant.timeZoneId);
            }
            return vm.minStartDate;
        };
        vm.endDateRequired = function () {
            return !!nextJobRun;
        };
        vm.jobNameChanged = function () {
            vm.editJob.job = _.find(vm.jobs, { name: vm.jobName });
            if (!vm.editJob.job) {
                return;
            }
            jobRunService.getTarget(plant.id, vm.editJob.job.mold, vm.editJob.job.finish, vm.editJob.job.glassColorName).then(function (result) {
                if (result === null) {
                    vm.targetDoesNotExist = true;
                }
                else {
                    vm.targetDoesNotExist = false;
                    vm.currentPlantTarget = result;
                    vm.editJob.packPercentageTarget = result;
                }
            });
            var previousJobRun = _.find(data.jobRuns, { jobId: vm.editJob.job.id });
            if (!previousJobRun) {
                return;
            }
            vm.editJob.lehrTime = previousJobRun.lehrTime;
            vm.editJob.numberOfSections = previousJobRun.numberOfSections;
            vm.editJob.numberOfGobs = previousJobRun.numberOfGobs;
            if (previousJobRun.containerSpeed > 0) {
                vm.editJob.containerSpeed = previousJobRun.containerSpeed;
            }
            if (previousJobRun.containersPerCase > 0) {
                vm.editJob.containersPerCase = previousJobRun.containersPerCase;
                vm.editJob.casesPerCycle = previousJobRun.casesPerCycle;
            }
            if (previousJobRun.containersPerTier > 0) {
                vm.editJob.containersPerTier = previousJobRun.containersPerTier;
                vm.editJob.tiersPerPallet = previousJobRun.tiersPerPallet;
            }
            vm.editJob.weightTarget = previousJobRun.weightTarget;
            vm.editJob.weightAlarmUpper = previousJobRun.weightAlarmUpper;
            vm.editJob.weightAlarmLower = previousJobRun.weightAlarmLower;
            vm.editJob.weightWarningUpper = previousJobRun.weightWarningUpper;
            vm.editJob.weightWarningLower = previousJobRun.weightWarningLower;
            vm.editJob.automaticSectionChanges = previousJobRun.automaticSectionChanges;
            if (isStrategyIdValid(previousJobRun.sectionChangeStrategyId)) {
                vm.editJob.sectionChangeStrategyId = previousJobRun.sectionChangeStrategyId;
            }
            setPackingCheckBoxes(vm, previousJobRun);
        };
        vm.save = function () {
            if (vm.form.$invalid) {
                return;
            }
            vm.editJob.jobId = vm.editJob.job.id;
            var startDate = moment(vm.editJob.startDate);
            if (startDate < vm.minDate) {
                notifyService.error('Start Date may not be before ' +
                    dateutility_service_1.default.formatTime(vm.minDate, plant.timeZoneId));
                return;
            }
            if (vm.editJob.endDate) {
                var endDate = moment(vm.editJob.endDate);
                var maxDate = vm.maxDate();
                if (endDate > maxDate) {
                    notifyService.error('End Date may not be after ' +
                        dateutility_service_1.default.formatTime(maxDate, plant.timeZoneId));
                    return;
                }
                if (endDate < maxDate) {
                    notifyService.error('End Date must be same as next job Start Date ' +
                        dateutility_service_1.default.formatTime(maxDate, plant.timeZoneId));
                    return;
                }
                var minEndDate = startDate.add(1, 'minutes');
                if (endDate < minEndDate) {
                    notifyService.error('End Date may not be on or before Start Date');
                    return;
                }
            }
            vm.editJob.MachineRejectPercentage = JSON.stringify(vm.editJob.selectedRejectedEquipment, function (key, value) {
                if (key === "$$hashKey") {
                    return undefined;
                }
                return value;
            });
            if (!vm.editJob.automaticSectionChanges) {
                vm.editJob.sectionChangeStrategyId = null;
            }
            if (!vm.casePacker) {
                vm.editJob.containersPerCase = null;
                vm.editJob.casesPerCycle = null;
            }
            if (!vm.palletizer) {
                vm.editJob.containersPerTier = null;
                vm.editJob.tiersPerPallet = null;
            }
            if (!vm.editJob.activeSections) {
                vm.editJob.activeSections = vm.editJob.numberOfSections;
            }
            var isTargetChangedForNew = vm.editJob.packPercentageTarget !== null &&
                vm.currentPlantTarget !== vm.editJob.packPercentageTarget;
            var isTargetChangedForExisting = vm.editJob.packPercentageTarget !== null &&
                !jobRun.isOverridenByAdmin &&
                (vm.currentPlantTarget !== vm.editJob.packPercentageTarget ||
                    jobRun.packPercentageTarget !== vm.editJob.packPercentageTarget);
            vm.editJob.isOverridenByAdmin =
                vm.isAdmin &&
                    (vm.isNewJob ? isTargetChangedForNew : isTargetChangedForExisting);
            var submit;
            if (vm.isNewJob) {
                submit = jobRunService.addJobRun(vm.editJob);
            }
            else {
                submit = jobRunService.updateJobRun(vm.editJob).then(function () {
                    if (previousJobRun && previousJobRun.endDate.getTime() !== vm.editJob.startDate.getTime()) {
                        previousJobRun.endDate = vm.editJob.startDate;
                        submit = jobRunService.updateJobRun(previousJobRun);
                    }
                });
            }
            vm.editJob["machineRejectPercentage"] = vm.editJob.MachineRejectPercentage;
            loaderService.loadingPromise(submit.then(function () {
                if (previousJobRun && previousJobRun.endDate) {
                    previousJobRun.endDate = vm.editJob.startDate;
                }
                $modalInstance.close(vm.editJob);
            }, notifyService.handleApiErrors));
        };
        vm.close = function () {
            $modalInstance.close();
        };
        vm.toggleHelpWindow = function () {
            vm.showHelpWindow = !vm.showHelpWindow;
        };
        vm.showHelp = function () {
            vm.helpText = getHelpText();
            vm.toggleHelpWindow();
        };
        vm.equipmentAdd = function () {
            if (_this.equipment == undefined || _this.equipment.selectedMachine == undefined) {
                notifyService.error('Please select a Machine');
                return;
            }
            if (_this.equipment !== null && _this.equipment !== undefined && _this.equipment.selectedMachine !== undefined) {
                if (_this.equipment.rejectedMinPercentage == undefined || _this.equipment.rejectedMinPercentage == null || _this.equipment.rejectedMinPercentage < 0) {
                    notifyService.error('Please enter a valid Min Percentage ');
                    return;
                }
                if (_this.equipment.rejectedMaxPercentage == undefined || _this.equipment.rejectedMaxPercentage == null) {
                    notifyService.error('Please enter a valid Max percentage');
                    return;
                }
                vm.editJob.selectedRejectedEquipment.push(vm.equipment);
                _this.equipmentNames = _this.equipmentNames.filter(function (obj) { return obj !== vm.equipment.selectedMachine; });
                vm.equipment = null;
            }
        };
        vm.equipmentRemove = function (equipment) {
            _.remove(vm.editJob.selectedRejectedEquipment, equipment);
            vm.equipmentNames.push(equipment.selectedMachine);
        };
        function getHelpText() {
            return "  \n    <div class=\"header\">\n      Job Change Difficulties\n    </div>         \n    <div class=\"detail\">\n      (0-7) are the different types of Difficulties\n    </div>  \n    <div class=\"detail\">\n      <ol type = \"1\" start =\"0\">\n        <li class=\"detail\">\n          <b>Exceptions</b> <br>\n          <ol type = \"a\">\n            <li class=\"detail\">Unforseen Mechanical failure causing more than 4 hours of downtime</li>\n            <li class=\"detail\">PM causing more than 4 hours of downtime</li>\n            <li class=\"detail\">Job Change occurs within a color change (glass is not salable)</li>\n            <li class=\"detail\">Problems with production due to circumstances outside plant control (e.g. poor blank/mold design)</li>\n            <li class=\"detail\">Problems with the glass quality preventing pack</li>\n            <li class=\"detail\">Production period is less than 12 hours</li>\n            <li class=\"detail\">Sampling</li>\n            <li class=\"detail\">Other (describe in comments)</li>\n          </ol>\n        </li>\n        <li class=\"detail\">\n          <b>Finish/Bottom Plate Change</b> <br>Only the Neck Ring or Bottom Plate is changed.\n        </li>\n        <li class=\"detail\">\n          <b>Mold Change</b> <br>Only the molds are changed.\n        </li>\n        <li class=\"detail\">\n          <b>Small Job Change</b> <br>Any combination of the following:\n            <ol type = \"a\">\n              <li class=\"detail\">Mold Change</li>\n              <li class=\"detail\">Blank Change</li>\n              <li class=\"detail\">Neck Rings / Neck Ring Arm Adjustment</li>\n              <li class=\"detail\">Adjustment to invert level</li>\n            </ol>\n        </li>\n        <li class=\"detail\">\n          <b>Medium Job Change</b> <br>1 Set of hangers is changed out or delivery equipment is changed.\n        </li>\n        <li class=\"detail\">\n          <b>Large Job Change</b> <br>Both sets of hangers are changed out.\n        </li>\n        <li class=\"detail\">\n          <b>Process Change</b> <br>Any job change where the production process is changed between NNPB, PB and B&B.\n        </li>\n        <li class=\"detail\">\n          <b>Mechanical Conversion</b> <br>A machine change between single, double, or triple gob production.\n        </li>\n      </ol>\n    </div>\n      ";
        }
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<h2 class=modal-header ng-if=vm.isNewJob>Add Job Run</h2> <h2 class=modal-header ng-if=!vm.isNewJob>Edit Job Run</h2> <form name=vm.form ng-submit=vm.save() novalidatem> <div style=\"margin:0 -2em\"> <div class=row> <div class=\"small-12 columns\"> <span class=required>* Required Fields</span> </div> </div> <div class=row> <div class=\"small-6 columns\"> <label>Job</label> <input name=job type=text ng-model=vm.jobName ng-select=vm.jobNameChanged() typeahead-on-select=vm.jobNameChanged() typeahead=\"job.name for job in vm.jobs | filter:$viewValue | limitTo:8\" autofill=off autocomplete=off /> <div ng-messages=vm.form.job.$error ng-if=\"vm.form.job.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </div> <div class=\"small-6 columns\"> <label><span class=\"required notated\">*</span> Lehr Time </label> <input type=number name=lehrTime ng-model=vm.editJob.lehrTime required min=1 max=120 /> <div ng-messages=vm.form.lehrTime.$error ng-if=\"vm.form.lehrTime.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=\"min, max\" class=req-w> <div class=arrow-up></div>Must be between 1 and 120 minutes </div> </div> </div> </div> <div class=row> <div class=\"small-6 columns\"> <label>Start Date </label> <input type=datetime-local name=startDate ng-model=vm.startDateLocal min=\"{{vm.minStartDate}}\" max=\"{{vm.maxStartDate()}}\" required date-time-picker time-model=vm.editJob.startDate time-zone=vm.timeZone /> <div ng-messages=vm.form.startDate.$error ng-if=\"vm.form.startDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=min class=req-w> <div class=arrow-up></div>May not overlap with previous job run </div> <div ng-message=max class=req-w> <div class=arrow-up></div>May not be on or after End Date, be in the future, or overlap with next job run </div> </div> </div> <div class=\"small-6 columns\" ng-if=!vm.isNewJob> <label>End Date</label> <input type=datetime-local name=endDate ng-model=vm.endDateLocal min=\"{{vm.minEndDate()}}\" max=\"{{vm.maxEndDate}}\" ng-required=vm.endDateRequired() date-time-picker time-model=vm.editJob.endDate time-zone=vm.timeZone /> <div ng-messages=vm.form.endDate.$error ng-if=\"vm.form.endDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=min class=req-w> <div class=arrow-up></div>May not be on or before Start Date </div> <div ng-message=max class=req-w> <div class=arrow-up></div>May not overlap with next job run or be more than 1 year in the future </div> </div> </div> </div> <div class=row> <div class=\"small-6 columns\"> <label>Short Item Number <br/>(For Job Runs with multiple short items, leave BLANK)</label> <input name=shortItemNumber type=text ng-model=vm.editJob.shortItemNumber /> <!-- <div ng-messages=\"vm.form.shortItemNumber.$error\"\r\n                    ng-if=\"vm.form.shortItemNumber.$dirty || vm.form.$submitted\" role=\"alert\">\r\n                    <div ng-message=\"required\" class=\"req-w\">\r\n                        <div class=\"arrow-up\"></div>Required\r\n                    </div>\r\n                </div> --> </div> <div class=\"small-3 columns\"> <label><span class=\"required notated\">*</span> Job Change Difficulty <a ng-click=vm.showHelp()><i class=\"fa fa-info-circle fa-bigger\"></i></a> <br>(0 - 7) <input type=number name=jobChangeDifficulty ng-model=vm.editJob.jobChangeDifficulty required step=1 min=0 max=7 /> </label> <div ng-messages=vm.form.jobChangeDifficulty.$error ng-if=\"vm.form.jobChangeDifficulty.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=\"min, max\" class=req-w> <div class=arrow-up></div>Must be between 0 and 7 </div> </div> </div> <div class=\"small-3 columns\"> </div> </div> <div class=row> <div class=\"small-3 columns\"> <label>Number of Sections</label> <input type=number name=numberOfSections ng-model=vm.editJob.numberOfSections required min=1 max=10 /> <div ng-messages=vm.form.numberOfSections.$error ng-if=\"vm.form.numberOfSections.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=\"min, max\" class=req-w> <div class=arrow-up></div>Must be between 1 and 10 section </div> </div> </div> <div class=\"small-3 columns\"> <label>Number of Gobs</label> <input type=number name=numberOfGobs ng-model=vm.editJob.numberOfGobs required min=1 max=4 /> <div ng-messages=vm.form.numberOfGobs.$error ng-if=\"vm.form.numberOfGobs.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=\"min, max\" class=req-w> <div class=arrow-up></div>Must be between 1 and 4 gobs </div> </div> </div> <div class=\"small-3 columns\"> <label>Container Speed (bpm)</label> <input type=number name=containerSpeed ng-model=vm.editJob.containerSpeed required min=1 max=10000 /> <div ng-messages=vm.form.containerSpeed.$error ng-if=\"vm.form.containerSpeed.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=\"min, max\" class=req-w> <div class=arrow-up></div>Must be between 1 and 10000 bpm </div> </div> </div> <div class=\"small-3 columns\"> <label>Pack % Target</label> <input type=number name=packPercentageTarget ng-model=vm.editJob.packPercentageTarget step=0.1 ng-disabled=!vm.isAdmin /> <div ng-messages=vm.form.packPercentageTarget.$error ng-if=\"vm.form.packPercentageTarget.$dirty || vm.form.$submitted\" role=alert> <div ng-message=\"min, max\" class=req-w> <div class=arrow-up></div>Must be between 1 and 100 </div> <div ng-message=step class=req-w> <div class=arrow-up></div>Up to 1 decimal places are allowed </div> </div> <div class=req-w ng-show=vm.targetDoesNotExist> <div class=arrow-up></div>No Previous Pack % Target Found </div> </div> </div> <div class=row> <div class=\"small-2 columns\"> <label> Weight </label> </div> <div class=\"small-2 columns\"> <label> <span class=\"required notated\">*</span> Alarm Lower <input type=number name=weightAlarmLower ng-model=vm.editJob.weightAlarmLower step=0.01 required/> <div ng-messages=vm.form.weightAlarmLower.$error ng-if=\"vm.form.weightAlarmLower.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=step class=req-w> <div class=arrow-up></div>Up to 2 decimal places are allowed </div> </div> </label> </div> <div class=\"small-2 columns\"> <label> <span class=\"required notated\">*</span> Warning Lower <input type=number name=weightWarningLower ng-model=vm.editJob.weightWarningLower step=0.01 required/> <div ng-messages=vm.form.weightWarningLower.$error ng-if=\"vm.form.weightWarningLower.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=step class=req-w> <div class=arrow-up></div>Up to 2 decimal places are allowed </div> </div> </label> </div> <div class=\"small-2 columns\"> <label> <span class=\"required notated\">*</span> Target <input type=number name=weightTarget ng-model=vm.editJob.weightTarget step=0.01 required/> <div ng-messages=vm.form.weightTarget.$error ng-if=\"vm.form.weightTarget.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=step class=req-w> <div class=arrow-up></div>Up to 2 decimal places are allowed </div> </div> </label> </div> <div class=\"small-2 columns\"> <label> <span class=\"required notated\">*</span> Warning Upper <input type=number name=weightWarningUpper ng-model=vm.editJob.weightWarningUpper step=0.01 required/> <div ng-messages=vm.form.weightWarningUpper.$error ng-if=\"vm.form.weightWarningUpper.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=step class=req-w> <div class=arrow-up></div>Up to 2 decimal places are allowed </div> </div> </label> </div> <div class=\"small-2 columns\"> <label> <span class=\"required notated\">*</span> Alarm Upper <input type=number name=weightAlarmUpper ng-model=vm.editJob.weightAlarmUpper step=0.01 required/> <div ng-messages=vm.form.weightAlarmUpper.$error ng-if=\"vm.form.weightAlarmUpper.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=step class=req-w> <div class=arrow-up></div>Up to 2 decimal places are allowed </div> </div> </label> </div> </div> <div class=row> <div class=\"small-6 columns\"> <label> <input type=checkbox name=casePacker ng-model=vm.casePacker /> Case Packer </label> </div> <div class=\"small-6 columns\"> <label> <input type=checkbox name=palletizer ng-model=vm.palletizer /> Palletizer </label> </div> </div> <div class=row ng-if=\"vm.casePacker || vm.palletizer\"> <div class=\"small-3 columns\" ng-if=vm.casePacker> <label> <span class=\"required notated\">*</span> Containers Per Case <input type=number name=containersPerCase ng-model=vm.editJob.containersPerCase required/> <div ng-messages=vm.form.containersPerCase.$error ng-if=\"vm.form.containersPerCase.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> <div class=\"small-3 columns\" ng-if=vm.casePacker> <label> <span class=\"required notated\">*</span> Cases Per Cycle <input type=number name=casesPerCycle ng-model=vm.editJob.casesPerCycle required/> <div ng-messages=vm.form.casesPerCycle.$error ng-if=\"vm.form.casesPerCycle.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> <div class=\"small-6 columns\" ng-if=!vm.casePacker>&nbsp;</div> <div class=\"small-6 columns\" ng-if=!vm.palletizer>&nbsp;</div> <div class=\"small-3 columns\" ng-if=vm.palletizer> <label> <span class=\"required notated\">*</span> Containers Per Tier <input type=number name=containersPerTier ng-model=vm.editJob.containersPerTier required/> <div ng-messages=vm.form.containersPerTier.$error ng-if=\"vm.form.containersPerTier.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> <div class=\"small-3 columns\" ng-if=vm.palletizer> <label> <span class=\"required notated\">*</span> Tiers Per Pallet <input type=number name=tiersPerPallet ng-model=vm.editJob.tiersPerPallet required/> <div ng-messages=vm.form.tiersPerPallet.$error ng-if=\"vm.form.tiersPerPallet.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> </div> <div class=row> <div class=\"small-4 columns\"> <label> <input type=checkbox name=automaticSectionChanges ng-model=vm.editJob.automaticSectionChanges /> Automatic Section Changes </label> </div> <div class=\"small-8 columns\" ng-if=vm.editJob.automaticSectionChanges> <label> <span class=\"required notated\">*</span> Strategy <select name=strategy ng-model=vm.editJob.sectionChangeStrategyId ng-options=\"s.id as s.name for s in vm.strategies | orderBy: 'name'\" required> <option value=\"\">-- Select a Strategy --</option> </select> <div ng-messages=vm.form.strategy.$error ng-if=\"vm.form.strategy.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> </div> <div class=row ng-if=vm.showAlertFields> <div class=\"small-2 columns\"> <label> Blank Swab Time <input type=number name=alertTimeSwabBlank ng-model=vm.editJob.alertTimeSwabBlank step=1 /> </label> </div> <div class=\"small-2 columns\"> <label> Mold Swab Time <input type=number name=alertTimeSwabMold ng-model=vm.editJob.alertTimeSwabMold step=1 /> </label> </div> <div class=\"small-2 columns\"> <label> Weigh Time <input type=number name=alertTimeWeighBottle ng-model=vm.editJob.alertTimeWeighBottle step=1 /> </label> </div> <div class=\"small-2 columns\"> &nbsp; </div> <div class=\"small-2 columns\"> </div> <div class=\"small-2 columns\"> <i>JCI: {{vm.editJob.jobChangeIndex | number: 2}}</i> <!--        <label>\r\n                    JCI\r\n                    {<input type=\"number\" name=\"jobChangeIndex\" ng-model=\"{{vm.editJob.jobChangeIndex}}\"\r\n                        step=\"1\" />\r\n                </label> --> &nbsp; </div> </div> <div class=row> <h6 style=margin-left:15px><b>Expected Machine Reject % Range</b></h6> </div> <div class=row> <div class=\"small-2 columns\"> <label> <b>Machines:</b> <br>(Select Machine) <select ng-model=vm.equipment.selectedMachine name=equipment ng-options=\"shop for shop in vm.equipmentNames | orderBy: ''\"> <option value=\"\">--All Machines--</option> </select> </label> </div> <div class=\"small-2 columns\"> <label> <b>Min %</b> <br>(Ex: 1% = 1) <input type=number step=any name=rejectedMinPercentage ng-model=vm.equipment.rejectedMinPercentage max=99 /> </label> </div> <div class=\"small-2 columns\"> <label><b>Max %</b> <br>(Ex: 2.25% = 2.25) <input type=number step=any name=rejectedMinPercentage ng-model=vm.equipment.rejectedMaxPercentage min=0 max=99 /> </label> </div> <div class=\"small-2 columns\" style=padding-top:1.3em> <label> <button type=button ng-click=vm.equipmentAdd() class=\"button tiny\">Add</button> </label> </div> <div class=\"small-2 columns\">&nbsp;</div> </div> <div class=row ng-show=\"vm.editJob.selectedRejectedEquipment.length>0\"> <div class=\"small-7 columns\" style=\"border:1px solid #cdcdcd;margin:0 .8em\"> <div class=row ng-repeat=\"machine in vm.editJob.selectedRejectedEquipment\" style=font-size:.8em;padding:.5em> <div class=\"small-2 columns center\"> <strong>{{machine.selectedMachine}}</strong> </div> <div class=\"small-3 columns\"> {{machine.rejectedMinPercentage}}&ndash;{{machine.rejectedMaxPercentage}} % </div> <div class=\"small-5 columns reorder-left\"> <a ng-click=vm.equipmentRemove(machine)><i class=\"fa fa-times remove-lnrw\"></i> Remove Equipment </a> </div> </div> </div> </div> <div class=row> <div class=\"small-12 columns\"> <div class=\"right dialog-footer\"> <button type=submit class=button>Save</button> <button type=button class=\"button secondary\" ng-click=vm.close()>Close</button> </div> </div> </div> </div> <div ng-if=vm.showHelpWindow class=modalhelpdetails> <div class=windowclose> <a><i class=\"fa fa-times-circle fa-bigger\" ng-click=vm.toggleHelpWindow()></i></a> </div> <div class=tooltiptext ng-bind-html=vm.helpText> </div> </div> </form>");

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <div class=body-header><h2>Job Runs</h2></div> <div class=container> <div ng-if=!vm.canAddJobRun() class=fail-rate>Cannot add another job run today</div> <div class=row> <div class=\"small-5 columns\"> <label> Plant: <select ng-model=vm.selectedPlant ng-options=\"plant.name for plant in vm.plants\" ng-change=vm.plantChanged()> </select> </label> </div> <div class=\"small-3 columns\"> <label> Shop: <select ng-model=vm.selectedShop ng-options=\"shop.name for shop in vm.selectedPlant.shops\" ng-change=vm.shopChanged()> </select> </label> </div> <div class=\"small-1 columns\">&nbsp;</div> <div class=\"small-3 columns\" style=margin-top:.6em;margin-top:.6em;text-align:right> <button ng-disabled=!vm.canAddJobRun() ng-click=vm.addJobRun() class=\"button small\">Add Job Run</button> </div> </div> <div ng-if=\"vm.jobRuns && vm.jobRuns.length === 0\" style=width:100%;clear:both;float:left;margin-top:30px> Currently there are no Job Runs for this Shop </div> <table cellpadding=1 cellspacing=1 ng-if=\"vm.jobRuns && vm.jobRuns.length > 0\" class=history-t> <tr> <th>From</th> <th>To</th> <th>Sects</th> <th>Gobs</th> <th>Speed</th> <th>Description</th> <th>Job Number</th> <th>Ware Class</th> <th>Customer</th> <th>Mold</th> <th>Finish</th> <th>Color</th> <th>Process</th> <th>Pack Target</th> <th></th> </tr> <tr ng-repeat=\"jobRun in vm.jobRuns\" ng-if=\"vm.jobRuns.length > 0\"> <td>{{ vm.formatTime(jobRun.startDate) }}</td> <td>{{ vm.formatTime(jobRun.endDate) }}</td> <td>{{ jobRun.numberOfSections }}</td> <td>{{ jobRun.numberOfGobs }}</td> <td>{{ jobRun.containerSpeed }}</td> <td>{{ jobRun.job.description }}</td> <td>{{ jobRun.legacyId }}</td> <td>{{ jobRun.job.wareClassName }}</td> <td>{{ jobRun.job.customerName }}</td> <td>{{ jobRun.job.mold }}</td> <td>{{ jobRun.job.finish }}</td> <td>{{ jobRun.job.glassColorName }}</td> <td>{{ jobRun.job.processName }}</td> <td>{{ jobRun.packPercentageTarget }}</td> <td> <button ng-click=vm.editJobRun(jobRun) class=\"button tiny\" style=margin:0>Edit</button> <button ng-if=vm.canRestore(jobRun) ng-click=vm.restoreJobRun(jobRun) class=\"button tiny\" style=margin:0>Restore as Current</button> </td> </tr> </table> </div> </div>");

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(736), __webpack_require__(28), __webpack_require__(3), __webpack_require__(738), __webpack_require__(6), __webpack_require__(4), __webpack_require__(8), __webpack_require__(7), __webpack_require__(57), __webpack_require__(33), __webpack_require__(9), __webpack_require__(2), __webpack_require__(739), __webpack_require__(741)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, editLine_controller_1, lineConfigs_service_1, constant_module_1, lineConfigs_tpl_html_1, notify_service_1, loader_service_1, navigation_service_1, authData_service_1, dataPoints_service_1, equipment_service_1, uiUtility_service_1, _, editLineEquipment_controller_1, editLineJunction_controller_1) {
    "use strict";
    lineConfigConfig.$inject = ["$stateProvider"];
    lineConfigCtrl.$inject = ["notifyService", "lineConfigsService", "loaderService", "navigationService", "authDataService", "dataPointService", "equipmentService", "$q", "$modal", "uiUtilityService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [editLine_controller_1.default, lineConfigs_service_1.default, notify_service_1.default, loader_service_1.default, navigation_service_1.default,
        authData_service_1.default, dataPoints_service_1.default, equipment_service_1.default, uiUtility_service_1.default, editLineEquipment_controller_1.default,
        editLineJunction_controller_1.default];
    exports.default = angular.module('aps.controller.lineConfig', requires)
        .config(lineConfigConfig)
        .controller('LineConfigurationCtrl', lineConfigCtrl)
        .name;
    function lineConfigConfig($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.LINE_CONFIG,
            url: '/admin/lineConfigs',
            controller: 'LineConfigurationCtrl as vm',
            template: lineConfigs_tpl_html_1.default,
            data: {
                pageTitle: 'Line Configuration',
                authorizeAPSIOAdmin: true
            }
        });
    }
    var mapLineToRow = function (line) {
        return {
            isLine: true,
            line: line,
            junction: null,
            cssClass: null
        };
    };
    var mapJunctionToRow = function (junction) {
        return {
            isLine: false,
            line: null,
            junction: junction,
            cssClass: 'addtable' + (junction.inputs.length > junction.outputs.length
                ? junction.inputs.length : junction.outputs.length).toString()
        };
    };
    var mapModelToAreas = function (model) {
        var areas = [];
        var area = {
            rows: _.sortBy(model.lines.filter(function (l) { return l.startJunctionId === null; }), function (r) { return r.number; })
                .map(function (l) { return mapLineToRow(l); })
        };
        var _loop_1 = function () {
            areas.push(area);
            var previousLines = area.rows.filter(function (l) { return l.isLine; }).map(function (l) { return l.line; });
            var rows = [];
            area.rows.forEach(function (row) {
                if (!row.isLine) {
                    _.sortBy(row.junction.outputs, function (l) { return l.number; }).forEach(function (line) {
                        rows.push(mapLineToRow(line));
                    });
                    return;
                }
                var junction = row.line.endJunction;
                if (!junction) {
                    return;
                }
                if (_.some(rows, function (r) { return !r.isLine && r.junction === junction; })) {
                    return;
                }
                if (!junction.inputs.every(function (l) { return _.some(previousLines, function (al) { return al.id === l.id; }); })) {
                    rows.push(mapLineToRow(row.line));
                }
                rows.push(mapJunctionToRow(junction));
            });
            area = { rows: rows };
        };
        while (area.rows.length > 0) {
            _loop_1();
        }
        return areas;
    };
    function lineConfigCtrl(notifyService, lineConfigsService, loaderService, navigationService, authDataService, dataPointService, equipmentService, $q, $modal, uiUtilityService) {
        var vm = {};
        var lineEquipmentNamesPromise = lineConfigsService.getLineEquipmentNames().then(function (names) {
            return vm.lineEquipmentNames = names;
        });
        var equipmentPromise;
        var dataPointsPromise;
        var loadLineConfigs = function () {
            var lineConfigsPromise = lineConfigsService.getLineConfiguration(vm.shop.id)
                .then(function (result) {
                vm.model = result;
                vm.areas = mapModelToAreas(vm.model);
            });
            loaderService.loadingPromise(lineConfigsPromise);
            return;
        };
        var determineAllowedLineEquipmentMovement = function (lineEquipment, minOrder, maxOrder) {
            lineEquipment.canMoveLeft = lineEquipment.order > minOrder;
            lineEquipment.canMoveRight = lineEquipment.order < maxOrder;
        };
        var updateLineEquipmentOrder = function (movedEquipment, newOrder) {
            var newOrderIsIncreasing = movedEquipment.order < newOrder;
            var line = _.find(vm.model.lines, { id: movedEquipment.lineId });
            var minOrder = _.min(_.map(line.equipment, 'order'));
            var maxOrder = _.max(_.map(line.equipment, 'order'));
            line.equipment.forEach(function (equipment) {
                if (equipment.id === movedEquipment.id) {
                    return;
                }
                if (newOrderIsIncreasing) {
                    if (equipment.order <= newOrder && equipment.order > movedEquipment.order) {
                        equipment.order -= 1;
                    }
                }
                else {
                    if (equipment.order >= newOrder && equipment.order < movedEquipment.order) {
                        equipment.order += 1;
                    }
                }
                determineAllowedLineEquipmentMovement(equipment, minOrder, maxOrder);
            });
            var movedEquipmentInstance = _.assign({
                canMoveLeft: false,
                canMoveRight: false
            }, movedEquipment);
            movedEquipmentInstance.order = newOrder;
            determineAllowedLineEquipmentMovement(movedEquipmentInstance, minOrder, maxOrder);
            line.equipment = _.sortBy(line.equipment, 'order');
        };
        var launchLineEquipmentAdd = function (line) {
            $q.all({
                equipmentNames: lineEquipmentNamesPromise,
                equipment: equipmentPromise,
                dataPoints: dataPointsPromise
            }).then(function () {
                var result = editLineEquipment_controller_1.openEditLineEquipment({
                    lineEquipment: undefined,
                    line: line,
                    shop: vm.shop,
                    lineEquipmentNames: vm.lineEquipmentNames,
                    equipment: vm.equipment.filter(function (e) { return e.plantLocationId === vm.shop.plantLocationId; }),
                    dataPoints: vm.dataPoints.filter(function (e) { return e.plantLocationId === vm.shop.plantLocationId; })
                }, $modal);
                result.then(function (addedLineEquipment) {
                    if (!addedLineEquipment) {
                        return;
                    }
                    if (!line.equipment) {
                        line.equipment = [];
                    }
                    line.equipment.push(addedLineEquipment);
                    lineConfigsService.updateEquipment(line);
                    vm.areas = mapModelToAreas(vm.model);
                });
            });
        };
        var launchLineEquipmentEdit = function (lineEquipment) {
            $q.all({
                equipmentNames: lineEquipmentNamesPromise,
                equipment: equipmentPromise,
                dataPoints: dataPointsPromise
            }).then(function () {
                var result = editLineEquipment_controller_1.openEditLineEquipment({
                    lineEquipment: lineEquipment,
                    line: undefined,
                    shop: vm.shop,
                    lineEquipmentNames: vm.lineEquipmentNames,
                    equipment: vm.equipment.filter(function (e) { return e.plantLocationId === vm.shop.plantLocationId; }),
                    dataPoints: vm.dataPoints.filter(function (e) { return e.plantLocationId === vm.shop.plantLocationId; })
                }, $modal);
                result.then(function (editedLineEquipment) {
                    if (!editedLineEquipment) {
                        return;
                    }
                    _.assign(lineEquipment, editedLineEquipment);
                });
            });
        };
        var getEligibleEndJunctions = function (lineJunction) {
            var junctions = [];
            if (!lineJunction) {
                return junctions;
            }
            lineJunction.outputs.forEach(function (line) {
                if (line.endJunction && junctions.indexOf(line.endJunction) < 0) {
                    junctions.push(line.endJunction);
                }
            });
            return junctions;
        };
        var launchLineAdd = function (lineJunction) {
            var result = editLine_controller_1.openEditLine({
                line: undefined,
                shop: vm.shop,
                startJunction: lineJunction,
                eligibleEndJunctions: getEligibleEndJunctions(lineJunction)
            }, $modal);
            result.then(function (addedLine) {
                if (addedLine) {
                    vm.model.lines.push(addedLine);
                    if (addedLine.startJunctionId) {
                        var lineJunction_1 = _.find(vm.model.junctions, { id: addedLine.startJunctionId });
                        if (lineJunction_1) {
                            addedLine.startJunction = lineJunction_1;
                            lineJunction_1.outputs.push(addedLine);
                        }
                    }
                    loadLineConfigs();
                }
            });
        };
        var launchLineEdit = function (line) {
            var result = editLine_controller_1.openEditLine({
                line: line,
                shop: vm.shop,
                startJunction: line.startJunction,
                eligibleEndJunctions: getEligibleEndJunctions(line.startJunction)
            }, $modal);
            result.then(function (editedLine) {
                if (editedLine) {
                    if (line) {
                        _.assign(line, editedLine);
                        vm.areas = mapModelToAreas(vm.model);
                        return;
                    }
                    vm.model.lines.push(editedLine);
                    if (editedLine.startJunctionId) {
                        var lineJunction = _.find(vm.model.junctions, { id: editedLine.startJunctionId });
                        if (lineJunction) {
                            editedLine.startJunction = lineJunction;
                            lineJunction.outputs.push(editedLine);
                        }
                    }
                    vm.areas = mapModelToAreas(vm.model);
                }
            });
        };
        var launchLineJunctionAdd = function (line) {
            var result = editLineJunction_controller_1.openEditLineJunction({
                lineJunction: undefined,
                line: line,
                shop: vm.shop,
                lineConfig: vm.model
            }, $modal);
            result.then(function (editedLineJunction) {
                if (editedLineJunction) {
                    editedLineJunction.inputs.forEach(function (line) {
                        line.endJunction = editedLineJunction;
                        line.endJunctionId = editedLineJunction.id;
                        var modelLines = _.filter(vm.model.lines, { id: line.id });
                        if (modelLines) {
                            modelLines.forEach(function (mLine) {
                                mLine.endJunction = editedLineJunction;
                                mLine.endJunctionId = editedLineJunction.id;
                            });
                        }
                    });
                    if (!editedLineJunction.outputs) {
                        editedLineJunction.outputs = [];
                    }
                    if (!vm.model.junctions) {
                        vm.model.junctions = [];
                    }
                    vm.model.junctions.push(editedLineJunction);
                    vm.areas = mapModelToAreas(vm.model);
                }
            });
        };
        var launchLineJunctionEdit = function (lineJunction) {
            var result = editLineJunction_controller_1.openEditLineJunction({
                lineJunction: lineJunction,
                line: undefined,
                shop: vm.shop,
                lineConfig: vm.model
            }, $modal);
            result.then(function (editedLineJunction) {
                if (editedLineJunction) {
                    editedLineJunction.inputs.forEach(function (line) {
                        line.endJunction = editedLineJunction;
                        line.endJunctionId = editedLineJunction.id;
                        var modelLines = _.filter(vm.model.lines, { id: line.id });
                        if (modelLines) {
                            modelLines.forEach(function (mLine) {
                                mLine.endJunction = editedLineJunction;
                                mLine.endJunctionId = editedLineJunction.id;
                            });
                        }
                    });
                    _.assign(lineJunction, editedLineJunction);
                    vm.areas = mapModelToAreas(vm.model);
                }
            });
        };
        var getPlantShopsDataPromise = navigationService.getNavigation()
            .then(function (navModel) {
            var plantsList = navModel.plants();
            vm.plants = _.filter(plantsList, function (plant) {
                return authDataService.isPlantAdmin(plant.id) || authDataService.isAPSIOAdminForPlant(plant.id);
            });
            if (navModel.selectedPlant && _.includes(vm.plants, navModel.selectedPlant)) {
                vm.plant = navModel.selectedPlant;
            }
            else {
                vm.plant = _.first(vm.plants);
            }
            vm.plantChanged(true);
            vm.shops = vm.plant.shops;
            if (navModel.selectedShop) {
                vm.shop = navModel.selectedShop;
            }
            loadLineConfigs();
        });
        vm.plantChanged = function (skipShopChanged) {
            vm.shop = _.first(vm.plant.shops);
            dataPointsPromise = dataPointService.get(vm.plant.id).then(function (data) {
                vm.dataPoints = data;
            });
            equipmentPromise = equipmentService.get(vm.plant.id).then(function (data) {
                vm.equipment = data;
            });
            if (skipShopChanged) {
                return;
            }
            vm.shopChanged();
        };
        vm.shopChanged = function () {
            loadLineConfigs();
        };
        vm.addLineEquipment = launchLineEquipmentAdd;
        vm.editLineEquipment = function (lineEquipment) {
            launchLineEquipmentEdit(lineEquipment);
        };
        vm.addLine = function (lineJunction) {
            launchLineAdd(lineJunction);
        };
        vm.editLine = function (line) {
            launchLineEdit(line);
        };
        vm.addLineJunction = function (line) {
            launchLineJunctionAdd(line);
        };
        vm.editLineJunction = function (lineJunction) {
            launchLineJunctionEdit(lineJunction);
        };
        vm.removeLine = function (line) {
            var message = "Are you sure you want to remove Line " + line.name + "?";
            var subject = 'Confirm Line Removal';
            var modalInstanceRemoveLine = uiUtilityService.confirm(message, subject);
            modalInstanceRemoveLine.then(function (confirmed) {
                if (!confirmed) {
                    return;
                }
                var removeLinePromise = lineConfigsService.removeLine({
                    id: line.id,
                    shopId: line.shopId
                }).then(function () {
                    _.remove(vm.model.lines, { id: line.id });
                    var startJunction = line.startJunction;
                    if (startJunction) {
                        _.remove(startJunction.outputs, line);
                    }
                    vm.areas = mapModelToAreas(vm.model);
                }, notifyService.handleApiErrors);
                loaderService.loadingPromise(removeLinePromise);
            });
        };
        vm.removeLineEquipment = function (line, lineEquipment) {
            var message = "Are you sure you want to remove " + lineEquipment.name + "?";
            var subject = "Confirm Remove Equipment From Line " + line.name;
            var modalInstanceRemoveLineEquipment = uiUtilityService.confirm(message, subject);
            modalInstanceRemoveLineEquipment.then(function (confirmed) {
                if (!confirmed) {
                    return;
                }
                var removeLineEquipmentPromise = lineConfigsService.removeLineEquipment({
                    shopId: lineEquipment.shopId,
                    id: lineEquipment.id
                })
                    .then(function () {
                    _.remove(line.equipment, { id: lineEquipment.id });
                    lineConfigsService.updateEquipment(line);
                }, notifyService.handleApiErrors);
                loaderService.loadingPromise(removeLineEquipmentPromise);
                return;
            });
        };
        vm.removeLineJunction = function (lineJunction) {
            var message = "Are you sure you want to remove Line Junction " + lineJunction.name + "?";
            var subject = 'Confirm Line Junction Removal';
            var modalInstanceRemoveLineJunction = uiUtilityService.confirm(message, subject);
            modalInstanceRemoveLineJunction.then(function (confirmed) {
                if (!confirmed) {
                    return;
                }
                var removeLineJunctionPromise = lineConfigsService.removeLineJunction({
                    id: lineJunction.id,
                    shopId: lineJunction.shopId
                }).then(function () {
                    _.remove(vm.model.junctions, { id: lineJunction.id });
                    lineJunction.inputs.forEach(function (line) {
                        line.endJunctionId = null;
                        line.endJunction = null;
                    });
                    vm.areas = mapModelToAreas(vm.model);
                }, notifyService.handleApiErrors);
                loaderService.loadingPromise(removeLineJunctionPromise);
            });
        };
        vm.toggleLine = function (line) {
            var toggleType = line.isDisabled ? 'Disable' : 'Enable';
            var message = "Are you sure you want to " + toggleType.toLowerCase() + " Line " + line.name + "?";
            var subject = toggleType + " Line";
            var modalInstanceToggleLine = uiUtilityService.confirm(message, subject);
            var revertState = function () { return line.isDisabled = !line.isDisabled; };
            modalInstanceToggleLine.then(function (confirmed) {
                if (confirmed) {
                    var command = { id: line.id, shopId: line.shopId, isDisabled: line.isDisabled };
                    var toggleLinePromise = lineConfigsService.toggleLine(command).then(function () {
                    }, function (errors) {
                        notifyService.handleApiErrors(errors);
                        revertState();
                    });
                    loaderService.loadingPromise(toggleLinePromise);
                }
                else {
                    revertState();
                }
            });
        };
        vm.toggleLineEquipment = function (line, lineEquipment) {
            var toggleType = lineEquipment.isDisabled ? 'Disable' : 'Enable';
            var message = "Are you sure you want to " + toggleType.toLowerCase() + " Equipment " + lineEquipment.name + " on Line " +
                (line.name + "?");
            var subject = toggleType + " Line Equipment";
            var modalInstanceToggleLineEquipment = uiUtilityService.confirm(message, subject);
            var revertState = function () { return lineEquipment.isDisabled = !lineEquipment.isDisabled; };
            modalInstanceToggleLineEquipment.then(function (confirmed) {
                if (confirmed) {
                    var command = {
                        id: lineEquipment.id,
                        lineId: lineEquipment.lineId,
                        shopId: lineEquipment.shopId,
                        isDisabled: lineEquipment.isDisabled
                    };
                    var toggleLineEquipmentPromise = lineConfigsService.toggleLineEquipment(command).then(function () {
                    }, function (errors) {
                        notifyService.handleApiErrors(errors);
                        revertState();
                    });
                    loaderService.loadingPromise(toggleLineEquipmentPromise);
                }
                else {
                    revertState();
                }
            });
        };
        var reorderLineEquipment = function (movedEquipment, newOrder) {
            var command = {
                shopId: movedEquipment.shopId,
                lineId: movedEquipment.lineId,
                id: movedEquipment.id,
                newOrder: newOrder
            };
            lineConfigsService.reorderLineEquipment(command).then(function () {
                updateLineEquipmentOrder(movedEquipment, newOrder);
            });
        };
        vm.moveLineEquipmentLeft = function (lineEquipment) {
            reorderLineEquipment(lineEquipment, lineEquipment.order - 1);
        };
        vm.moveLineEquipmentRight = function (lineEquipment) {
            reorderLineEquipment(lineEquipment, lineEquipment.order + 1);
        };
        loaderService.loadingPromise(getPlantShopsDataPromise);
        return vm;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(28), __webpack_require__(12), __webpack_require__(4), __webpack_require__(6), __webpack_require__(737)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, lineConfigs_service_1, newguid_service_1, loader_service_1, notify_service_1, editLine_tpl_html_1) {
    "use strict";
    editLineCtrl.$inject = ["newGuidService", "loaderService", "notifyService", "lineConfigsService", "$modalInstance", "data"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [lineConfigs_service_1.default, newguid_service_1.default, loader_service_1.default, notify_service_1.default];
    function openEditLine(data, $modal) {
        return $modal.open({
            template: editLine_tpl_html_1.default,
            controller: 'EditLineCtrl as vm',
            resolve: {
                data: function () {
                    return data;
                }
            }
        }).result;
    }
    exports.openEditLine = openEditLine;
    exports.default = angular.module('aps.controller.editLine', requires)
        .controller('EditLineCtrl', editLineCtrl)
        .name;
    function editLineCtrl(newGuidService, loaderService, notifyService, lineConfigsService, $modalInstance, data) {
        var vm = {};
        vm.dialogHeaderText = 'Add Line';
        vm.editedLine = {};
        vm.eligibleEndJunctions = data.eligibleEndJunctions;
        if (data.line) {
            _.assign(vm.editedLine, data.line);
            vm.dialogHeaderText = 'Edit Line Name';
            vm.isNew = false;
        }
        else {
            vm.isNew = true;
            newGuidService.getNewGuid('line').then(function (id) { return vm.editedLine.id = id.toString(); });
            vm.editedLine.shopId = data.shop.id;
            vm.editedLine.startJunctionId = data.startJunction ? data.startJunction.id : undefined;
            vm.editedLine.startJunction = data.startJunction;
            var maxNumber = 0;
            if (data.startJunction && data.startJunction.outputs.length > 0) {
                maxNumber = _.max(data.startJunction.outputs.map(function (n) { return n.number; }));
            }
            vm.editedLine.number = maxNumber + 1;
        }
        vm.save = function () {
            if (vm.form.$invalid) {
                return;
            }
            vm.editedLine.name = vm.editedLine.name.toUpperCase();
            var promise = vm.isNew
                ? lineConfigsService.addLine({
                    id: vm.editedLine.id,
                    shopId: data.shop.id,
                    name: vm.editedLine.name,
                    number: vm.editedLine.number,
                    endJunctionId: vm.editedLine.endJunctionId,
                    startJunctionId: vm.editedLine.startJunctionId
                })
                : lineConfigsService.updateLine({
                    id: vm.editedLine.id,
                    shopId: data.shop.id,
                    name: vm.editedLine.name
                });
            loaderService.loadingPromise(promise.then(function () {
                $modalInstance.close(vm.editedLine);
            }, notifyService.handleApiErrors));
        };
        vm.close = function () {
            $modalInstance.close();
        };
        return vm;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <form name=vm.form ng-submit=vm.save() novalidate> <h2 class=modal-header>{{vm.dialogHeaderText}}</h2> <div class=container> <div> <label><span class=\"required notated\">*</span>Name <input name=lineName type=text ng-model=vm.editedLine.name maxlength=1 required/> </label> <div ng-messages=vm.form.lineName.$error ng-if=\"vm.form.lineName.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div> Required </div> </div> </div> <div ng-if=\"vm.eligibleEndJunctions.length > 0\"> <label>End Junction <select name=endJunctionId ng-model=vm.editedLine.endJunctionId ng-options=\"j.id as j.name for j in vm.eligibleEndJunctions | orderBy: 'name'\"> <option value=\"\">None</option> </select> </label> </div> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-12 columns\"> <span class=required>* Required Fields</span> <div class=dialog-footer> <input type=submit class=button value=Save /> <button type=button class=\"button secondary\" ng-click=vm.close()>Close</button> </div> </div> </div> </form> </div>");

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=lineconfig> <div class=body-header><h2>Line Configuration</h2></div> <div class=lineconfig-details> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>Plant: <select ng-model=vm.plant ng-options=\"plant.name for plant in vm.plants\" ng-change=vm.plantChanged()> </select> </label> </div> <div class=\"small-9 columns\"> <label> Location <select name=shop ng-model=vm.shop ng-options=\"shop as shop.name for shop in vm.shops\" ng-change=vm.shopChanged()> </select> </label> </div> </div> <div ng-if=\"vm.areas.length === 0\"> <div ng-if=vm.shop class=row style=text-align:left> No lines are configured for Shop {{vm.shop.name}}. </div> <div ng-if=vm.shop ng-click=vm.addLine(null) class=\"row add-line\" style=text-align:left> + Click here to add one </div> </div> </div> <div class=container> <div class=lineconfig-body ng-if=\"vm.areas.length > 0\"> <div class=\"c-columns area\" ng-repeat=\"area in vm.areas\"> <div class=c-row ng-repeat=\"row in area.rows\" ng-class=row.cssClass> <!-- ending line connector --> <div class=connector ng-if=\"row.isLine && !$parent.$first\"></div> <!-- regular line with equipment --> <div ng-class=\"{ linerow: !row.line.isDisabled, linerowdisabled: row.line.isDisabled }\" ng-if=row.isLine> <div ng-class=\"{ linenumber: !row.line.isDisabled, linenumberdisabled: row.line.isDisabled }\"> <span>&nbsp;</span> <span style=cursor:pointer ng-click=vm.editLine(row.line)>{{row.line.name}}</span> <span ng-click=vm.removeLine(row.line) class=remove-lnrw>x</span> <span> <input type=checkbox title=\"Disable Line\" ng-model=row.line.isDisabled ng-change=vm.toggleLine(row.line)> </span> </div> <div ng-repeat=\"equip in row.line.equipment\" ng-class=\"{ equipment: !equip.isDisabled, equipmentdisabled: equip.isDisabled }\"> <div ng-click=vm.editLineEquipment(equip) class=equipment-name style=cursor:pointer>{{equip.name}} </div> <div ng-click=\"vm.removeLineEquipment(row.line, equip)\" class=remove-eqp>x</div> <input type=checkbox title=\"Disable Line Equipment\" ng-model=equip.isDisabled ng-change=\"vm.toggleLineEquipment(row.line, equip)\"> <div class=reorder-container> <span class=\"reorder-left fa fa-arrow-left\" ng-if=equip.canMoveLeft ng-click=vm.moveLineEquipmentLeft(equip)></span> <span class=\"reorder-right fa fa-arrow-right\" ng-if=equip.canMoveRight ng-click=vm.moveLineEquipmentRight(equip)></span> </div> </div> <!-- add equipment & junction/table placeholder --> <div class=equipment2> <!-- add equipment --> <div ng-click=vm.addLineEquipment(row.line) class=\"equipment-name add-equipment\"> <span class=add>+ </span>Eqp </div> <!-- add junction/table (visible when eligible) --> <div ng-if=\"row.isLine && row.line.equipment.length > 0\r\n                    && !row.line.endJunctionId\" ng-click=vm.addLineJunction(row.line) class=\"equipment-name add-line-junction\"> <span class=add>+ </span>Jct </div> </div> </div> <!-- add line placeholder --> <div class=addlinerow ng-if=!row.isLine> <div class=linenumber2></div> <!-- add line placeholder --> <div class=equipment2> <!-- add line --> <div ng-click=vm.addLine(row.junction) class=\"equipment-name add-line\"> <span class=add>+ </span> Line </div> <div ng-click=vm.removeLineJunction(row.junction) class=\"equipment-name add-line\"> <span class=remove-jct>x </span>Jct </div> </div> </div> <!-- beginning line connector --> <div class=connector ng-if=\"row.isLine && !$parent.$last\"></div> </div> </div> </div> </div> ");

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(28), __webpack_require__(9), __webpack_require__(5), __webpack_require__(12), __webpack_require__(4), __webpack_require__(6), __webpack_require__(740)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, lineConfigs_service_1, uiUtility_service_1, aps_enums_1, newguid_service_1, loader_service_1, notify_service_1, editLineEquipment_tpl_html_1) {
    "use strict";
    editLineEquipmentCtrl.$inject = ["newGuidService", "loaderService", "notifyService", "lineConfigsService", "$modalInstance", "uiUtilityService", "data"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [lineConfigs_service_1.default, uiUtility_service_1.default, newguid_service_1.default, loader_service_1.default, notify_service_1.default];
    function openEditLineEquipment(data, $modal) {
        return $modal.open({
            template: editLineEquipment_tpl_html_1.default,
            controller: 'EditLineEquipmentCtrl as vm',
            resolve: {
                data: function () {
                    return data;
                }
            }
        }).result;
    }
    exports.openEditLineEquipment = openEditLineEquipment;
    exports.default = angular.module('aps.controller.editLineEquipment', requires)
        .controller('EditLineEquipmentCtrl', editLineEquipmentCtrl)
        .name;
    function editLineEquipmentCtrl(newGuidService, loaderService, notifyService, lineConfigsService, $modalInstance, uiUtilityService, data) {
        var vm = {};
        vm.requiresEquipment = false;
        vm.requiresInspect = true;
        vm.requiresReject = true;
        vm.allowCalculatedInspect = false;
        vm.calculatedInspect = false;
        vm.allowSubordinateCounts = false;
        vm.dataPointTypes = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.DataPointType, 1);
        function setEligibleDataPoints(type, dataPoints) {
            return _.filter(dataPoints, function (dp) {
                return dp.type === type;
            });
        }
        function setDataPointsBasedOnSelectedEquipment() {
            vm.inspectionDataPoints = setEligibleDataPoints(aps_enums_1.apsEnums.DataPointType.Inspect, vm.dataPoints);
            vm.rejectDataPoints = setEligibleDataPoints(aps_enums_1.apsEnums.DataPointType.Reject, vm.dataPoints);
            vm.alarmDataPoints = setEligibleDataPoints(aps_enums_1.apsEnums.DataPointType.Alarm, vm.dataPoints);
        }
        vm.dataPoints = data.dataPoints;
        setDataPointsBasedOnSelectedEquipment();
        vm.lineEquipmentNames = data.lineEquipmentNames;
        vm.equipment = data.equipment;
        vm.dialogHeaderText = 'Add Line Equipment';
        vm.editedLineEquipment = {};
        vm.line = data.line;
        var wsiCalculatedConfig = '{"Calculated":true}';
        var wsiDefaultConfig = '{}';
        var wbfDefaultConfig = '{"MoldIndex":0}';
        var wbfRejectConfig = '{"MoldIndex":2}';
        var heyeDefaultConfig = '{"Active":true}';
        var checkDetectorDefaultConfig = '{}';
        var mX4DefaultConfig = '{}';
        var mcalDefaultConfig = '{}';
        var multiDefaultConfig = '{}';
        var flexInspectDefaultConfig = '{}';
        var defaultConfig = '{}';
        function retrieveDataPointIfFound(isInspection) {
            var nameToCheck = isInspection
                ? vm.editedLineEquipment.inspectionDataPointName
                : vm.editedLineEquipment.rejectDataPointName;
            var idToCheck = isInspection
                ? vm.editedLineEquipment.inspectionDataPointId
                : vm.editedLineEquipment.rejectDataPointId;
            var dataPoint = _.find(vm.dataPoints, { name: nameToCheck });
            if (!dataPoint) {
                dataPoint = _.find(vm.dataPoints, { id: idToCheck });
                if (!dataPoint) {
                    return;
                }
            }
            if (isInspection) {
                if (vm.calculatedInspect) {
                    if (dataPoint.config !== wsiCalculatedConfig) {
                        vm.calculatedInspect = false;
                    }
                }
                vm.editedLineEquipment.inspectionDataPointId = dataPoint.id;
                if (!vm.editedLineEquipment.inspectionDataPointName) {
                    vm.editedLineEquipment.inspectionDataPointName = dataPoint.name;
                }
            }
            else {
                vm.editedLineEquipment.rejectDataPointId = dataPoint.id;
                if (!vm.editedLineEquipment.rejectDataPointName) {
                    vm.editedLineEquipment.rejectDataPointName = dataPoint.name;
                }
            }
        }
        vm.inspectionDataPointChanged = function () {
            retrieveDataPointIfFound(true);
        };
        vm.rejectDataPointChanged = function () {
            retrieveDataPointIfFound(false);
        };
        vm.detailDataPointChanged = function (detail) {
            var dataPoint = _.find(vm.dataPoints, { name: detail.dataPointName });
            if (dataPoint) {
                detail.dataPointId = dataPoint.id;
                return;
            }
            detail.dataPointName = '';
            detail.dataPointId = null;
        };
        vm.lineEquipmentNameChanged = function () {
            var lineEquipmentName = _.find(vm.lineEquipmentNames, { id: vm.editedLineEquipment.lineEquipmentNameId });
            var equipmentType = null;
            vm.requiresInspect = true;
            vm.requiresReject = true;
            vm.allowCalculatedInspect = false;
            vm.allowSubordinateCounts = false;
            if (lineEquipmentName) {
                if (lineEquipmentName.type === aps_enums_1.apsEnums.LineEquipmentType.WSI) {
                    equipmentType = aps_enums_1.apsEnums.EquipmentType.WSI;
                }
                else if (lineEquipmentName.type === aps_enums_1.apsEnums.LineEquipmentType.WBF) {
                    equipmentType = aps_enums_1.apsEnums.EquipmentType.WBF;
                }
                else if (lineEquipmentName.type === aps_enums_1.apsEnums.LineEquipmentType.HEYE) {
                    equipmentType = aps_enums_1.apsEnums.EquipmentType.HEYE;
                    vm.requiresInspect = false;
                    vm.requiresReject = false;
                }
                else if (lineEquipmentName.type === aps_enums_1.apsEnums.LineEquipmentType.Counter) {
                    vm.requiresReject = false;
                    vm.allowSubordinateCounts = true;
                }
                else if (lineEquipmentName.type === aps_enums_1.apsEnums.LineEquipmentType.Palletizer) {
                    vm.requiresReject = false;
                }
                else if (lineEquipmentName.type === aps_enums_1.apsEnums.LineEquipmentType.InspectReject) {
                    vm.allowSubordinateCounts = true;
                }
                else if (lineEquipmentName.type === aps_enums_1.apsEnums.LineEquipmentType.CheckDetector) {
                    equipmentType = aps_enums_1.apsEnums.EquipmentType.CheckDetector;
                    vm.requiresInspect = false;
                    vm.requiresReject = false;
                }
                else if (lineEquipmentName.type === aps_enums_1.apsEnums.LineEquipmentType.MX4) {
                    equipmentType = aps_enums_1.apsEnums.EquipmentType.MX4;
                    vm.requiresInspect = true;
                    vm.requiresReject = false;
                    vm.allowSubordinateCounts = true;
                }
                else if (lineEquipmentName.type === aps_enums_1.apsEnums.LineEquipmentType.Multi) {
                    equipmentType = aps_enums_1.apsEnums.EquipmentType.Multi;
                    vm.requiresInspect = false;
                    vm.requiresReject = false;
                }
                else if (lineEquipmentName.type === aps_enums_1.apsEnums.LineEquipmentType.Mcal) {
                    equipmentType = aps_enums_1.apsEnums.EquipmentType.Mcal;
                    vm.requiresInspect = false;
                    vm.requiresReject = false;
                }
                else if (lineEquipmentName.type === aps_enums_1.apsEnums.LineEquipmentType.FlexBC) {
                    equipmentType = aps_enums_1.apsEnums.EquipmentType.FlexBC;
                    vm.requiresInspect = true;
                    vm.requiresReject = true;
                }
                else if (lineEquipmentName.type === aps_enums_1.apsEnums.LineEquipmentType.FlexM) {
                    equipmentType = aps_enums_1.apsEnums.EquipmentType.FlexM;
                    vm.requiresInspect = true;
                    vm.requiresReject = true;
                }
                else if (lineEquipmentName.type === aps_enums_1.apsEnums.LineEquipmentType.FlexIS) {
                    equipmentType = aps_enums_1.apsEnums.EquipmentType.FlexIS;
                    vm.requiresInspect = true;
                    vm.requiresReject = true;
                }
                vm.editedLineEquipment.name = lineEquipmentName.name;
                vm.editedLineEquipment.type = lineEquipmentName.type;
            }
            else {
                vm.editedLineEquipment.name = null;
                vm.editedLineEquipment.type = null;
            }
            if (equipmentType) {
                var equipment = _.find(vm.equipment, { id: vm.editedLineEquipment.equipmentId });
                if (equipment && equipment.type !== equipmentType) {
                    vm.editedLineEquipment.equipmentId = null;
                    equipment = null;
                }
                if (equipment) {
                    if (equipment.type === aps_enums_1.apsEnums.EquipmentType.WSI || equipment.type === aps_enums_1.apsEnums.EquipmentType.WBF) {
                        if (!equipment.isSimulator) {
                            vm.allowCalculatedInspect = true;
                            var dataPoint = _.find(vm.dataPoints, { id: vm.editedLineEquipment.inspectionDataPointId });
                            if (dataPoint && dataPoint.config === wsiCalculatedConfig) {
                                vm.calculatedInspect = true;
                            }
                        }
                    }
                }
                vm.requiresEquipment = true;
                vm.filteredEquipment = data.equipment.filter(function (e) { return e.type === equipmentType; });
            }
            else {
                vm.editedLineEquipment.equipmentId = null;
                vm.requiresEquipment = false;
                vm.filteredEquipment = [];
            }
            if (!vm.editedLineEquipment.detailDataPoints
                || (!vm.allowSubordinateCounts
                    && vm.editedLineEquipment.detailDataPoints.length > 0)) {
                vm.editedLineEquipment.detailDataPoints = [];
            }
        };
        function setWsiInspectDataPoint(equipment) {
            var inspectDataPoint = _.find(equipment.dataPoints, {
                type: aps_enums_1.apsEnums.DataPointType.Inspect,
                config: vm.calculatedInspect ? wsiCalculatedConfig
                    : (equipment.type === aps_enums_1.apsEnums.EquipmentType.WBF ? wbfDefaultConfig : wsiDefaultConfig)
            });
            if (inspectDataPoint) {
                vm.editedLineEquipment.inspectionDataPointId = inspectDataPoint.id;
                vm.editedLineEquipment.inspectionDataPointName = inspectDataPoint.name;
            }
        }
        function setWsiDataPoints(equipment) {
            if (!equipment.isSimulator) {
                vm.allowCalculatedInspect = true;
            }
            setWsiInspectDataPoint(equipment);
            var rejectConfig = wsiDefaultConfig;
            if (equipment.type === aps_enums_1.apsEnums.EquipmentType.WBF) {
                rejectConfig = wbfRejectConfig;
            }
            var rejectDataPoint = _.find(equipment.dataPoints, { type: aps_enums_1.apsEnums.DataPointType.Reject, config: rejectConfig });
            if (rejectDataPoint) {
                vm.editedLineEquipment.rejectDataPointId = rejectDataPoint.id;
                vm.editedLineEquipment.rejectDataPointName = rejectDataPoint.name;
            }
        }
        function setHeyeDataPoints(equipment) {
            var inspectDataPoint = _.find(equipment.dataPoints, { type: aps_enums_1.apsEnums.DataPointType.Inspect, config: heyeDefaultConfig });
            if (inspectDataPoint) {
                vm.editedLineEquipment.inspectionDataPointId = inspectDataPoint.id;
                vm.editedLineEquipment.inspectionDataPointName = inspectDataPoint.name;
            }
            var rejectDataPoint = _.find(equipment.dataPoints, { type: aps_enums_1.apsEnums.DataPointType.Reject, config: heyeDefaultConfig });
            if (rejectDataPoint) {
                vm.editedLineEquipment.rejectDataPointId = rejectDataPoint.id;
                vm.editedLineEquipment.rejectDataPointName = rejectDataPoint.name;
            }
        }
        function setCheckDetectorDataPoints(equipment) {
            var inspectFilter = { type: aps_enums_1.apsEnums.DataPointType.Inspect, config: checkDetectorDefaultConfig };
            var inspectDataPoint = _.find(equipment.dataPoints, inspectFilter);
            if (inspectDataPoint) {
                vm.editedLineEquipment.inspectionDataPointId = inspectDataPoint.id;
                vm.editedLineEquipment.inspectionDataPointName = inspectDataPoint.name;
            }
            var rejectFilter = { type: aps_enums_1.apsEnums.DataPointType.Reject, config: checkDetectorDefaultConfig };
            var rejectDataPoint = _.find(equipment.dataPoints, rejectFilter);
            if (rejectDataPoint) {
                vm.editedLineEquipment.rejectDataPointId = rejectDataPoint.id;
                vm.editedLineEquipment.rejectDataPointName = rejectDataPoint.name;
            }
        }
        function setMX4DataPoints(equipment) {
            var inspectFilter = { type: aps_enums_1.apsEnums.DataPointType.Inspect, config: mX4DefaultConfig };
            var inspectDataPoint = _.find(equipment.dataPoints, inspectFilter);
            if (inspectDataPoint) {
                vm.editedLineEquipment.inspectionDataPointId = inspectDataPoint.id;
                vm.editedLineEquipment.inspectionDataPointName = inspectDataPoint.name;
            }
            var rejectFilter = { type: aps_enums_1.apsEnums.DataPointType.Reject, config: mX4DefaultConfig };
            var rejectDataPoint = _.find(equipment.dataPoints, rejectFilter);
            if (rejectDataPoint) {
                vm.editedLineEquipment.rejectDataPointId = rejectDataPoint.id;
                vm.editedLineEquipment.rejectDataPointName = rejectDataPoint.name;
            }
        }
        function setMcalDataPoints(equipment) {
            var inspectFilter = { type: aps_enums_1.apsEnums.DataPointType.Inspect, config: mcalDefaultConfig };
            var inspectDataPoint = _.find(equipment.dataPoints, inspectFilter);
            if (inspectDataPoint) {
                vm.editedLineEquipment.inspectionDataPointId = inspectDataPoint.id;
                vm.editedLineEquipment.inspectionDataPointName = inspectDataPoint.name;
            }
            var rejectFilter = { type: aps_enums_1.apsEnums.DataPointType.Reject, config: mcalDefaultConfig };
            var rejectDataPoint = _.find(equipment.dataPoints, rejectFilter);
            if (rejectDataPoint) {
                vm.editedLineEquipment.rejectDataPointId = rejectDataPoint.id;
                vm.editedLineEquipment.rejectDataPointName = rejectDataPoint.name;
            }
        }
        function setMultiDataPoints(equipment) {
            var inspectFilter = { type: aps_enums_1.apsEnums.DataPointType.Inspect, config: multiDefaultConfig };
            var inspectDataPoint = _.find(equipment.dataPoints, inspectFilter);
            if (inspectDataPoint) {
                vm.editedLineEquipment.inspectionDataPointId = inspectDataPoint.id;
                vm.editedLineEquipment.inspectionDataPointName = inspectDataPoint.name;
            }
            var rejectFilter = { type: aps_enums_1.apsEnums.DataPointType.Reject, config: multiDefaultConfig };
            var rejectDataPoint = _.find(equipment.dataPoints, rejectFilter);
            if (rejectDataPoint) {
                vm.editedLineEquipment.rejectDataPointId = rejectDataPoint.id;
                vm.editedLineEquipment.rejectDataPointName = rejectDataPoint.name;
            }
        }
        function setFlexInspectDataPoints(equipment) {
            var inspectFilter = { type: aps_enums_1.apsEnums.DataPointType.Inspect, config: flexInspectDefaultConfig };
            var inspectDataPoint = _.find(equipment.dataPoints, inspectFilter);
            if (inspectDataPoint) {
                vm.editedLineEquipment.inspectionDataPointId = inspectDataPoint.id;
                vm.editedLineEquipment.inspectionDataPointName = inspectDataPoint.name;
            }
            var rejectFilter = { type: aps_enums_1.apsEnums.DataPointType.Reject, config: flexInspectDefaultConfig };
            var rejectDataPoint = _.find(equipment.dataPoints, rejectFilter);
            if (rejectDataPoint) {
                vm.editedLineEquipment.rejectDataPointId = rejectDataPoint.id;
                vm.editedLineEquipment.rejectDataPointName = rejectDataPoint.name;
            }
        }
        function setInspectDataPoints(equipment, defaultConfiguration) {
            var inspectFilter = { type: aps_enums_1.apsEnums.DataPointType.Inspect, config: defaultConfiguration };
            var inspectDataPoint = _.find(equipment.dataPoints, inspectFilter);
            if (inspectDataPoint) {
                vm.editedLineEquipment.inspectionDataPointId = inspectDataPoint.id;
                vm.editedLineEquipment.inspectionDataPointName = inspectDataPoint.name;
            }
            var rejectFilter = { type: aps_enums_1.apsEnums.DataPointType.Reject, config: defaultConfiguration };
            var rejectDataPoint = _.find(equipment.dataPoints, rejectFilter);
            if (rejectDataPoint) {
                vm.editedLineEquipment.rejectDataPointId = rejectDataPoint.id;
                vm.editedLineEquipment.rejectDataPointName = rejectDataPoint.name;
            }
        }
        vm.equipmentChanged = function () {
            vm.allowCalculatedInspect = false;
            var equipment = _.find(vm.equipment, { id: vm.editedLineEquipment.equipmentId });
            if (equipment) {
                if (equipment.type === aps_enums_1.apsEnums.EquipmentType.WSI || equipment.type === aps_enums_1.apsEnums.EquipmentType.WBF) {
                    setWsiDataPoints(equipment);
                }
                else if (equipment.type === aps_enums_1.apsEnums.EquipmentType.HEYE) {
                    setHeyeDataPoints(equipment);
                }
                else if (equipment.type === aps_enums_1.apsEnums.EquipmentType.CheckDetector) {
                    setCheckDetectorDataPoints(equipment);
                }
                else if (equipment.type === aps_enums_1.apsEnums.EquipmentType.MX4) {
                    setMX4DataPoints(equipment);
                }
                else if (equipment.type === aps_enums_1.apsEnums.EquipmentType.Mcal) {
                    setMcalDataPoints(equipment);
                }
                else if (equipment.type === aps_enums_1.apsEnums.EquipmentType.Multi) {
                    setMultiDataPoints(equipment);
                }
                else if (equipment.type === aps_enums_1.apsEnums.EquipmentType.FlexBC || equipment.type === aps_enums_1.apsEnums.EquipmentType.FlexM) {
                    setFlexInspectDataPoints(equipment);
                }
                else if (equipment.type === aps_enums_1.apsEnums.EquipmentType.FlexIS) {
                    setInspectDataPoints(equipment, defaultConfig);
                }
            }
        };
        vm.calculatedInspectChanged = function () {
            var equipment = _.find(vm.equipment, { id: vm.editedLineEquipment.equipmentId });
            if (equipment && (equipment.type === aps_enums_1.apsEnums.EquipmentType.WSI
                || equipment.type === aps_enums_1.apsEnums.EquipmentType.WBF)) {
                setWsiInspectDataPoint(equipment);
            }
        };
        var showAll = function (filterValue) {
            var fv = filterValue.toLocaleLowerCase();
            return _.findIndex(['al', 'all'], function (o) { return o === fv; }) > -1;
        };
        vm.filterDataPoint = function (filterValue) {
            return showAll(filterValue) ? null : filterValue;
        };
        vm.filteredDataPointLimit = function (filterValue) {
            return showAll(filterValue) ? null : 8;
        };
        if (data.lineEquipment) {
            vm.dialogHeaderText = 'Edit Line Equipment';
            vm.isNew = false;
            var details_1 = [];
            data.lineEquipment.detailDataPoints.forEach(function (detail) {
                return details_1.push(_.assign({}, detail));
            });
            _.assign(vm.editedLineEquipment, data.lineEquipment);
            vm.editedLineEquipment.detailDataPoints = details_1;
            vm.inspectionDataPointChanged();
            vm.rejectDataPointChanged();
            vm.lineEquipmentNameChanged();
        }
        else {
            var lineOrderMax_1 = 0;
            if (vm.line) {
                if (vm.line && vm.line.equipment) {
                    vm.line.equipment.forEach(function (equipmentItem) {
                        if (equipmentItem.order > lineOrderMax_1) {
                            lineOrderMax_1 = equipmentItem.order;
                        }
                    });
                }
                vm.editedLineEquipment.lineId = data.line.id;
            }
            newGuidService.getNewGuid('lineEquipment').then(function (id) { return vm.editedLineEquipment.id = id.toString(); });
            vm.editedLineEquipment.shopId = data.shop.id;
            vm.editedLineEquipment.order = lineOrderMax_1 + 1;
            vm.isNew = true;
        }
        vm.save = function () {
            if (vm.form.$invalid) {
                return;
            }
            var command = {
                id: vm.editedLineEquipment.id,
                shopId: vm.editedLineEquipment.shopId,
                equipmentId: vm.editedLineEquipment.equipmentId,
                inspectionDataPointId: vm.editedLineEquipment.inspectionDataPointId,
                lineEquipmentNameId: vm.editedLineEquipment.lineEquipmentNameId,
                lineId: vm.editedLineEquipment.lineId,
                rejectDataPointId: vm.editedLineEquipment.rejectDataPointId,
                detailDataPoints: vm.editedLineEquipment.detailDataPoints
            };
            var promise = vm.isNew
                ? lineConfigsService.addLineEquipment(command)
                : lineConfigsService.updateLineEquipment(command);
            loaderService.loadingPromise(promise.then(function () {
                $modalInstance.close(vm.editedLineEquipment);
            }, notifyService.handleApiErrors));
        };
        vm.close = function () {
            $modalInstance.close();
        };
        vm.addDataPoint = function () {
            if (!vm.allowSubordinateCounts) {
                return;
            }
            if (!vm.editedLineEquipment.detailDataPoints) {
                vm.editedLineEquipment.detailDataPoints = [];
            }
            var dataPoint = {
                lineId: vm.editedLineEquipment.lineId,
                shopId: vm.editedLineEquipment.shopId,
                lineEquipmentId: vm.editedLineEquipment.id,
                dataPointId: null,
                dataPointName: '',
                type: vm.editedLineEquipment.type === aps_enums_1.apsEnums.LineEquipmentType.InspectReject
                    ? aps_enums_1.apsEnums.DataPointType.Reject : aps_enums_1.apsEnums.DataPointType.Inspect,
                order: vm.editedLineEquipment.detailDataPoints.length,
                id: null,
                name: ''
            };
            newGuidService.getNewGuid('lineEquipmentDataPoint').then(function (id) { return dataPoint.id = id; });
            vm.editedLineEquipment.detailDataPoints.push(dataPoint);
        };
        vm.detailDataPoints = function (type) {
            switch (type) {
                case aps_enums_1.apsEnums.DataPointType.Inspect:
                    return vm.inspectionDataPoints;
                case aps_enums_1.apsEnums.DataPointType.Reject:
                    return vm.rejectDataPoints;
                case aps_enums_1.apsEnums.DataPointType.Alarm:
                    return vm.alarmDataPoints;
            }
            return vm.dataPoints;
        };
        vm.detailTypeChanged = function (detail) {
            if (!detail.dataPointId) {
                return;
            }
            var dataPoint = _.find(vm.dataPoints, { id: detail.dataPointId });
            if (dataPoint.type !== detail.type) {
                detail.dataPointId = null;
                detail.dataPointName = '';
            }
        };
        vm.deleteDetail = function (detail) {
            _.remove(vm.editedLineEquipment.detailDataPoints, detail);
        };
        return vm;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <form name=vm.form ng-submit=vm.save() novalidate> <h2 class=modal-header>{{vm.dialogHeaderText}}</h2> <div class=container> <div> <label> <span class=\"required notated\">*</span>Name <select name=equipmentName ng-model=vm.editedLineEquipment.lineEquipmentNameId ng-options=\"x.id as x.name for x in vm.lineEquipmentNames | orderBy: 'name'\" ng-change=vm.lineEquipmentNameChanged() required> <option value=\"\">-- Select Equipment Name --</option> </select> </label> <div ng-messages=vm.form.equipmentName.$error ng-if=\"vm.form.equipmentName.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div> Required </div> </div> </div> <div ng-if=vm.requiresEquipment> <label> <span class=\"required notated\">*</span>Equipment <select name=equipment ng-model=vm.editedLineEquipment.equipmentId ng-options=\"x.id as x.name for x in vm.filteredEquipment | orderBy: 'name'\" ng-change=vm.equipmentChanged() required> <option value=\"\">-- Select Equipment --</option> </select> </label> <div ng-messages=vm.form.equipment.$error ng-if=\"vm.form.equipment.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div> Required </div> </div> </div> <div ng-if=vm.allowCalculatedInspect> <label> <input type=checkbox ng-model=vm.calculatedInspect ng-change=vm.calculatedInspectChanged() /> Use Median Camera Inspect Count </label> </div> <div ng-if=vm.requiresInspect> <label> <span class=\"required notated\">*</span>Inspection Data Point <input name=inspectionDataPointId type=text ng-model=vm.editedLineEquipment.inspectionDataPointName ng-select=vm.inspectionDataPointChanged() typeahead-on-select=vm.inspectionDataPointChanged() typeahead=\"dp.name for dp in vm.inspectionDataPoints | orderBy: 'name' | filter: vm.filterDataPoint($viewValue) | limitTo: vm.filteredDataPointLimit($viewValue)\" typeahead-min-length=0 ng-required=true /> </label> <div ng-messages=vm.form.inspectionDataPointId.$error ng-if=\"vm.form.inspectionDataPointId.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div> Required </div> </div> </div> <div> <label ng-if=vm.requiresReject> <span class=\"required notated\">*</span>Reject Data Point <input name=rejectDataPointId type=text ng-model=vm.editedLineEquipment.rejectDataPointName ng-select=vm.rejectDataPointChanged() typeahead-on-select=vm.rejectDataPointChanged() typeahead=\"dp.name for dp in vm.rejectDataPoints | orderBy: 'name' | filter: vm.filterDataPoint($viewValue) | limitTo: vm.filteredDataPointLimit($viewValue)\" ng-required=true /> </label> <div ng-messages=vm.form.rejectDataPointId.$error ng-if=\"vm.form.rejectDataPointId.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div> Required </div> </div> </div> <div ng-if=vm.allowSubordinateCounts> <div ng-if=\"vm.editedLineEquipment.detailDataPoints.length > 0\"> <h4>Detail Data Points</h4> </div> <div class=row ng-repeat=\"detail in vm.editedLineEquipment.detailDataPoints\"> <div class=\"small-12 large-4 columns\"> <label> <span class=\"required notated\">*</span>Name <input name=\"name{{$index}}\" type=text ng-model=detail.name required/> </label> <div ng-messages=\"vm.form['name' + $index].$error\" ng-if=\"vm.form['name' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div> Required </div> </div> </div> <div class=\"small-12 large-3 columns\"> <label> <span class=\"required notated\">*</span>Type <select name=\"type{{$index}}\" ng-model=detail.type ng-options=\"x.value as x.text for x in vm.dataPointTypes\" ng-change=vm.detailTypeChanged(detail) required></select> </label> <div ng-messages=\"vm.form['type' + $index].$error\" ng-if=\"vm.form['type' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div> Required </div> </div> </div> <div class=\"small-12 large-4 columns\"> <label> <span class=\"required notated\">*</span>Data Point <input name=\"dataPoint{{$index}}\" type=text ng-model=detail.dataPointName ng-select=vm.detailDataPointChanged(detail) typeahead-on-select=vm.detailDataPointChanged(detail) typeahead=\"dp.name for dp in vm.detailDataPoints(detail.type) | orderBy: 'name' | filter: vm.filterDataPoint($viewValue) | limitTo: vm.filteredDataPointLimit($viewValue)\" ng-required=true /> </label> <div ng-messages=\"vm.form['dataPoint' + $index].$error\" ng-if=\"vm.form['dataPoint' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div> Required </div> </div> </div> <div class=\"small-12 large-1 columns\"> <button type=button class=\"button tiny alert\" ng-click=vm.deleteDetail(detail)><i class=\"fa fa-trash\"></i></button> </div> </div> <div> <button type=button class=button ng-click=vm.addDataPoint()>Add Detail Data Point</button> </div> </div> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-12 columns\"> <span class=required>* Required Fields</span> <div class=dialog-footer> <input type=submit class=button value=Save /> <button type=button class=\"button secondary\" ng-click=vm.close()>Close</button> </div> </div> </div> </form> </div>");

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(28), __webpack_require__(12), __webpack_require__(4), __webpack_require__(6), __webpack_require__(2), __webpack_require__(742)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, lineConfigs_service_1, newguid_service_1, loader_service_1, notify_service_1, _, editLineJunction_tpl_html_1) {
    "use strict";
    editLineJunctionCtrl.$inject = ["newGuidService", "loaderService", "notifyService", "lineConfigsService", "$modalInstance", "data"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [lineConfigs_service_1.default, newguid_service_1.default, loader_service_1.default, notify_service_1.default];
    function openEditLineJunction(data, $modal) {
        return $modal.open({
            template: editLineJunction_tpl_html_1.default,
            controller: 'EditLineJunctionCtrl as vm',
            resolve: {
                data: function () {
                    return data;
                }
            }
        }).result;
    }
    exports.openEditLineJunction = openEditLineJunction;
    exports.default = angular.module('aps.controller.editLineJunction', requires)
        .controller('EditLineJunctionCtrl', editLineJunctionCtrl)
        .name;
    function editLineJunctionCtrl(newGuidService, loaderService, notifyService, lineConfigsService, $modalInstance, data) {
        var vm = {};
        vm.dialogHeaderText = 'Add Line Junction';
        vm.editedLineJunction = {};
        if (data.lineJunction) {
            _.assign(vm.editedLineJunction, data.lineJunction);
            vm.dialogHeaderText = 'Edit Line Junction';
        }
        else {
            newGuidService.getNewGuid('lineJunction').then(function (id) { return vm.editedLineJunction.id = id.toString(); });
            vm.editedLineJunction.shopId = data.shop.id;
            if (!vm.editedLineJunction.inputs) {
                vm.editedLineJunction.inputs = [];
            }
            if (data.line) {
                vm.editedLineJunction.inputs.push(data.line);
            }
        }
        vm.eligibleInputs = _.filter(data.lineConfig.lines, function (line) {
            return !line.endJunction;
        });
        vm.lineIsSelected = function (lineId) {
            return _.some(vm.editedLineJunction.inputs, { id: lineId });
        };
        vm.toggleInputLine = function (line) {
            var lineIsAnInput = _.some(vm.editedLineJunction.inputs, line);
            if (lineIsAnInput) {
                _.remove(vm.editedLineJunction.inputs, line);
            }
            else {
                vm.editedLineJunction.inputs.push(line);
            }
        };
        vm.save = function () {
            if (vm.form.$invalid) {
                return;
            }
            vm.editedLineJunction.name = vm.editedLineJunction.name.toUpperCase();
            var promise = data.lineJunction
                ? lineConfigsService.updateLineJunction({
                    id: vm.editedLineJunction.id,
                    isTable: vm.editedLineJunction.isTable,
                    name: vm.editedLineJunction.name,
                    shopId: data.shop.id
                })
                : lineConfigsService.addLineJunction({
                    id: vm.editedLineJunction.id,
                    inputLineIds: _.map(vm.editedLineJunction.inputs, 'id'),
                    isTable: vm.editedLineJunction.isTable,
                    name: vm.editedLineJunction.name,
                    shopId: data.shop.id
                });
            loaderService.loadingPromise(promise.then(function () {
                $modalInstance.close(vm.editedLineJunction);
            }, notifyService.handleApiErrors));
        };
        vm.close = function () {
            $modalInstance.close();
        };
        return vm;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <form name=vm.form ng-submit=vm.save() novalidate> <h2 class=modal-header>{{vm.dialogHeaderText}}</h2> <div class=container> <label><span class=\"required notated\">*</span>Name</label> <input name=lineJunctionName type=text ng-model=vm.editedLineJunction.name maxlength=4 required/> <div ng-messages=vm.form.lineJunctionName.$error ng-if=\"vm.form.lineJunctionName.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div> Required </div> </div> <label><input type=checkbox value=true name=isTable ng-model=vm.editedLineJunction.isTable /> Is Table</label> <label><span class=\"required notated\">*</span>Input Lines</label> <span ng-repeat=\"line in vm.eligibleInputs\"> <input ng-checked=\"vm.lineIsSelected('{{line.id}}')\" ng-click=vm.toggleInputLine(line) type=checkbox name=\"inputLineId_{{line.id}}\"/> {{line.name}} &nbsp; </span> <div ng-messages=vm.form.lineJunctionName.$error ng-if=\"vm.form.lineJunctionName.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div> Required </div> </div> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-12 columns\"> <span class=required>* Required Fields</span> <div class=dialog-footer> <input type=submit class=button value=Save /> <button type=button class=\"button secondary\" ng-click=vm.close()>Close</button> </div> </div> </div> </form> </div>");

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(4), __webpack_require__(6), __webpack_require__(28), __webpack_require__(9), __webpack_require__(5), __webpack_require__(744), __webpack_require__(2), __webpack_require__(3), __webpack_require__(746)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, loader_service_1, notify_service_1, lineConfigs_service_1, uiUtility_service_1, aps_enums_1, editLineEquipmentName_controller_1, _, constant_module_1, lineEquipmentNames_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [editLineEquipmentName_controller_1.default, loader_service_1.default, notify_service_1.default, lineConfigs_service_1.default,
        uiUtility_service_1.default];
    var LineEquipmentNamesCtrl = (function () {
        LineEquipmentNamesCtrl.$inject = ["loaderService", "notifyService", "uiUtilityService", "$modal", "lineConfigsService", "$q"];
        function LineEquipmentNamesCtrl(loaderService, notifyService, uiUtilityService, $modal, lineConfigsService, $q) {
            var _this = this;
            this.loaderService = loaderService;
            this.notifyService = notifyService;
            this.uiUtilityService = uiUtilityService;
            this.$modal = $modal;
            this.$q = $q;
            this.lineConfigsService = lineConfigsService;
            this.locations = _.sortBy(uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.Location, 0), function (x) { return x.text; });
            this.types = _.sortBy(uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.LineEquipmentType, 1), function (x) { return x.text; });
            var lineEquipmentNamesPromise = this.lineConfigsService.getLineEquipmentNames()
                .then(function (results) {
                _this.lineEquipmentNames = results;
                _this.lineEquipmentNames.forEach(function (item) { return _this.setLocationAndTypeNames(item); });
            });
            loaderService.loadingPromise(lineEquipmentNamesPromise);
        }
        LineEquipmentNamesCtrl.prototype.setLocationAndTypeNames = function (item) {
            item.locationName = _.find(this.locations, { value: item.location }).text;
            item.typeName = _.find(this.types, { value: item.type }).text;
        };
        LineEquipmentNamesCtrl.prototype.addLineEquipmentName = function () {
            var _this = this;
            var result = editLineEquipmentName_controller_1.openEditLineEquipmentName({
                lineEquipmentName: {
                    id: _.max(_.map(this.lineEquipmentNames, 'id')) + 1,
                    location: null,
                    locationName: null,
                    name: null,
                    type: null,
                    typeName: null
                },
                locations: this.locations,
                types: this.types
            }, this.$modal);
            result.then(function (addedLineEquipmentName) {
                if (addedLineEquipmentName) {
                    _this.lineEquipmentNames.push(addedLineEquipmentName);
                }
            });
        };
        LineEquipmentNamesCtrl.prototype.editLineEquipmentName = function (lineEquipmentName) {
            var _this = this;
            var result = editLineEquipmentName_controller_1.openEditLineEquipmentName({
                lineEquipmentName: _.assign({}, lineEquipmentName),
                locations: this.locations,
                types: this.types
            }, this.$modal);
            result.then(function (updatedLineEquipmentName) {
                if (updatedLineEquipmentName) {
                    var index = _.findIndex(_this.lineEquipmentNames, { id: updatedLineEquipmentName.id });
                    _this.lineEquipmentNames[index] = updatedLineEquipmentName;
                }
            });
        };
        LineEquipmentNamesCtrl.prototype.removeLineEquipmentName = function (lineEquipmentName) {
            var _this = this;
            var message = "Are you sure you want to permanently delete " + lineEquipmentName.name + "?";
            var subject = "Confirm Delete Line Equipment Type " + lineEquipmentName.name;
            var result = this.uiUtilityService.confirm(message, subject);
            result.then(function (confirmed) {
                if (!confirmed) {
                    return;
                }
                var removeLineEquipmentPromise = _this.lineConfigsService.removeLineEquipmentName({ id: lineEquipmentName.id })
                    .then(function () {
                    _.remove(_this.lineEquipmentNames, { id: lineEquipmentName.id });
                }, _this.notifyService.handleApiErrors);
                _this.loaderService.loadingPromise(removeLineEquipmentPromise);
            });
        };
        return LineEquipmentNamesCtrl;
    }());
    exports.default = angular.module('aps.controller.lineEquipmentNames', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.LINE_EQUIPMENT_NAMES,
            url: '/admin/lineConfigs/lineEquipmentTypes',
            controller: 'LineEquipmentNamesCtrl as vm',
            template: lineEquipmentNames_tpl_html_1.default,
            data: {
                pageTitle: 'Line Equipment Types',
                authorizeAPSIOAdmin: true
            }
        });
    }])
        .controller('LineEquipmentNamesCtrl', LineEquipmentNamesCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(9), __webpack_require__(4), __webpack_require__(6), __webpack_require__(28), __webpack_require__(2), __webpack_require__(745)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, uiUtility_service_1, loader_service_1, notify_service_1, lineConfigs_service_1, _, editLineEquipmentName_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [uiUtility_service_1.default, loader_service_1.default, notify_service_1.default, lineConfigs_service_1.default];
    function openEditLineEquipmentName(data, $modal) {
        return $modal.open({
            template: editLineEquipmentName_tpl_html_1.default,
            controller: 'EditLineEquipmentNameCtrl as vm',
            resolve: {
                data: function () {
                    return data;
                }
            }
        }).result;
    }
    exports.openEditLineEquipmentName = openEditLineEquipmentName;
    var EditLineEquipmentNameCtrl = (function () {
        EditLineEquipmentNameCtrl.$inject = ["data", "loaderService", "notifyService", "uiUtilityService", "$modalInstance", "lineConfigsService"];
        function EditLineEquipmentNameCtrl(data, loaderService, notifyService, uiUtilityService, $modalInstance, lineConfigsService) {
            var _this = this;
            this.loaderService = loaderService;
            this.notifyService = notifyService;
            this.uiUtilityService = uiUtilityService;
            this.$modalInstance = $modalInstance;
            this.lineConfigsService = lineConfigsService;
            this.isNew = !data.lineEquipmentName.type;
            this.dialogHeaderText = (this.isNew ? 'Add' : 'Edit') + " Line Equipment Type";
            this.editedLineEquipmentName = data.lineEquipmentName;
            this.locations = data.locations;
            this.types = [];
            var eligibleTypes = ['inspect reject', 'counter'];
            data.types.forEach(function (type) {
                var canPush = !_this.isNew || _.find(eligibleTypes, function (et) { return et === type.text.toLowerCase(); });
                if (canPush) {
                    _this.types.push(type);
                }
            });
        }
        EditLineEquipmentNameCtrl.prototype.setLocationAndTypeNames = function (item) {
            item.locationName = _.find(this.locations, { value: item.location }).text;
            if (this.isNew) {
                item.typeName = _.find(this.types, { value: item.type }).text;
            }
        };
        EditLineEquipmentNameCtrl.prototype.save = function () {
            var _this = this;
            if (this.form.$invalid) {
                return;
            }
            this.setLocationAndTypeNames(this.editedLineEquipmentName);
            var command = {
                id: this.editedLineEquipmentName.id,
                location: this.editedLineEquipmentName.location,
                name: this.editedLineEquipmentName.name,
                type: this.editedLineEquipmentName.type
            };
            var promise = this.isNew
                ? this.lineConfigsService.addLineEquipmentName(command)
                : this.lineConfigsService.updateLineEquipmentName(command);
            this.loaderService.loadingPromise(promise.then(function () {
                _this.$modalInstance.close(_this.editedLineEquipmentName);
            }, this.notifyService.handleApiErrors));
        };
        EditLineEquipmentNameCtrl.prototype.close = function () {
            this.$modalInstance.close();
        };
        return EditLineEquipmentNameCtrl;
    }());
    exports.default = angular.module('aps.controller.editLineEquipmentName', requires)
        .controller('EditLineEquipmentNameCtrl', EditLineEquipmentNameCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <form name=vm.form ng-submit=vm.save() novalidate> <h2 class=modal-header>{{vm.dialogHeaderText}}</h2> <div class=container> <div class=row> <div class=\"small-12 large-4 columns\"> <label> <span class=\"required notated\">*</span>Type: <select name=type ng-model=vm.editedLineEquipmentName.type ng-disabled=\"vm.isNew === false\" required ng-options=\"t.value as t.text for t in vm.types\"> <option value=\"\">-- Select a Type --</option> </select> </label> <div ng-messages=vm.form.type.$error ng-if=\"vm.form.type.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"small-12 large-4 columns\"> <label> <span class=\"required notated\">*</span>Location: <select name=location ng-model=vm.editedLineEquipmentName.location required ng-options=\"l.value as l.text for l in vm.locations\"> <option value=\"\">-- Select a Location --</option> </select> </label> <div ng-messages=vm.form.location.$error ng-if=\"vm.form.location.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"small-12 large-4 columns\"> <label> <span class=\"required notated\">*</span>Name: <input name=name type=text ng-model=vm.editedLineEquipmentName.name maxlength=4 required/> </label> <div ng-messages=vm.form.name.$error ng-if=\"vm.form.name.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> </div> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-12 columns\"> <span class=required>* Required Fields</span> <div class=dialog-footer> <input type=submit class=button value=Save /> <button type=button class=\"button secondary\" ng-click=vm.close()>Close</button> </div> </div> </div> </form> </div>");

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <div class=body-header><h2>Line Equipment Types</h2></div> <div class=container> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-12 columns\"> <button ng-click=vm.addLineEquipmentName() class=\"button small\" style=position:relative;top:14px>Add Line Equipment Type</button> </div> </div> <div ng-if=\"vm.lineEquipmentNames && vm.lineEquipmentNames.length === 0\" style=width:100%;clear:both;float:left;margin-top:30px> Currently there are no Line Equipment Types </div> <table cellpadding=1 cellspacing=1 ng-if=\"vm.lineEquipmentNames && vm.lineEquipmentNames.length > 0\" class=history-t> <tr> <th>Name</th> <th>Location</th> <th>Type</th> <th></th> <th></th> </tr> <tr ng-repeat=\"instance in vm.lineEquipmentNames | orderBy: 'name'\" ng-if=\"vm.lineEquipmentNames.length > 0\"> <td>{{ instance.name }}</td> <td>{{ instance.locationName }}</td> <td>{{ instance.typeName }}</td> <td><button ng-click=vm.editLineEquipmentName(instance) class=\"button tiny\" style=margin:0>Edit</button></td> <td><button ng-click=vm.removeLineEquipmentName(instance) class=\"button tiny alert\" style=margin:0>Delete</button></td> </tr> </table> </div> </div>");

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(748), __webpack_require__(749), __webpack_require__(3), __webpack_require__(43)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, lineSheetReact_tpl_html_1, lineSheet_react_1, constant_module_1, environment_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [lineSheet_react_1.default, environment_1.default];
    var LineSheetReactCtrl = (function () {
        LineSheetReactCtrl.$inject = ["$stateParams", "environment"];
        function LineSheetReactCtrl($stateParams, environment) {
            this.plantId = $stateParams.plantId;
            this.shopId = $stateParams.shopId;
            this.userId = $stateParams.userId;
            this.initialDate = $stateParams.initialDate ? new Date($stateParams.initialDate) : null;
            this.eightyHrTools = environment.EightyToolset;
            this.oneSixtyHrTools = environment.OneSixtyToolSet;
        }
        return LineSheetReactCtrl;
    }());
    exports.default = angular.module('aps.controller.lineSheet', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.LINE_SHEET,
            url: '/lineSheet?initialDate',
            params: {
                initialDate: { dynamic: true }
            },
            controller: 'LineSheetReactCtrl as vm',
            template: lineSheetReact_tpl_html_1.default,
            data: { pageTitle: 'Line Sheet' }
        });
    }])
        .controller('LineSheetReactCtrl', LineSheetReactCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<react-component name=LineSheetComponent props=vm />");

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(64), __webpack_require__(1), __webpack_require__(2), __webpack_require__(5), __webpack_require__(276), __webpack_require__(30), __webpack_require__(32), __webpack_require__(112), __webpack_require__(750), __webpack_require__(752), __webpack_require__(110), __webpack_require__(283), __webpack_require__(754), __webpack_require__(757), __webpack_require__(277), __webpack_require__(760), __webpack_require__(275), __webpack_require__(4), __webpack_require__(7), __webpack_require__(762), __webpack_require__(74), __webpack_require__(47), __webpack_require__(8), __webpack_require__(763), __webpack_require__(60), __webpack_require__(3), __webpack_require__(11), __webpack_require__(764), __webpack_require__(766), __webpack_require__(768), __webpack_require__(770), __webpack_require__(38), __webpack_require__(79)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, React, moment, _, aps_enums_1, shopActivity_1, checkLists_service_1, checkListInstances_service_1, kpiChecks_hub_1, defectCauses_controller_1, addDefect_controller_1, viewDefect_controller_1, addDowntime_controller_1, addJobChange_controller_1, addRequalification_controller_1, addToolChange_controller_1, viewToolChange_controller_1, lineSheet_service_1, loader_service_1, authData_service_1, tempDataService_1, defect_service_1, toolChange_service_1, navigation_service_1, lineSheet_hub_1, userProfile_1, constant_module_1, dateutility_service_1, cavityHistory_controller_1, moldHistory_controller_1, qualificationHistory_1, sectionHistory_controller_1, fillOutCheckList_controller_1, job_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [
        kpiChecks_hub_1.default,
        checkLists_service_1.default,
        lineSheet_service_1.default,
        loader_service_1.default,
        authData_service_1.default,
        defectCauses_controller_1.default,
        addDefect_controller_1.default,
        viewDefect_controller_1.default,
        addDowntime_controller_1.default,
        addJobChange_controller_1.default,
        tempDataService_1.default,
        defect_service_1.default,
        toolChange_service_1.default,
        navigation_service_1.default,
        lineSheet_hub_1.default,
        userProfile_1.default,
        addRequalification_controller_1.default,
        addToolChange_controller_1.default,
        viewToolChange_controller_1.default,
        cavityHistory_controller_1.default,
        moldHistory_controller_1.default,
        qualificationHistory_1.default,
        sectionHistory_controller_1.default,
        checkListInstances_service_1.default,
        fillOutCheckList_controller_1.default,
        job_service_1.default,
    ];
    var KpiComponent = (function (_super) {
        __extends(KpiComponent, _super);
        function KpiComponent() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        KpiComponent.prototype.updateResult = function (update) {
            if (this.isUnmounted ||
                (this.state &&
                    this.state.scheduledOn.getDate() > update.eventDate.getDate())) {
                return;
            }
            this.setState({
                id: update.id,
                checkId: update.checkId,
                status: update.status,
                result: update.result,
                checkName: update.checkName,
                wellKnownCheckId: update.wellKnownCheck,
                scheduledOn: update.eventDate,
            });
        };
        KpiComponent.prototype.componentDidMount = function () {
            var _this = this;
            this.isUnmounted = false;
            KpiComponent.checkListsService
                .getLastValue(this.props.plantId, this.props.shopId, this.props.wellKnownCheck)
                .then(function (result) {
                if (_this.isUnmounted) {
                    return;
                }
                if (result === "") {
                    return;
                }
                _this.setState(result);
                _this.hub = KpiComponent.kpiChecksHubService.createKPIChecksHub(function (update) { return _this.updateResult(update); }, _this.props.shopId, _this.props.wellKnownCheck);
            });
        };
        KpiComponent.prototype.componentWillUnmount = function () {
            var _this = this;
            this.isUnmounted = true;
            if (this.hub) {
                this.hub
                    .leaveGroup(this.props.shopId, this.props.wellKnownCheck)
                    .then(function () {
                    return _this.hub.uninitialize();
                });
            }
        };
        KpiComponent.prototype.render = function () {
            if (this.state === null) {
                return React.createElement("ul", { key: "kpi" }, React.createElement("li", { key: "loading" }, "..."));
            }
            return React.createElement("ul", { key: "kpi" }, React.createElement("li", { key: "name" }, this.state.checkName), React.createElement("li", { key: "result" }, this.state.result ? this.state.result : "n/a"));
        };
        return KpiComponent;
    }(React.Component));
    var LineSheetComponent = (function (_super) {
        __extends(LineSheetComponent, _super);
        function LineSheetComponent() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        LineSheetComponent.prototype.initializePermissions = function () {
            var auth = LineSheetComponent.authDataService;
            this.flags = {
                isAuthorized: auth.isAuthorizedForCurrentPlant(),
                isAdmin: auth.isPlantAdminForCurrentPlant(),
                isOperator: auth.isOperator(),
                isHotEndOperator: auth.isHotEndOperator(),
                isAuthorizedForQualifications: auth.isAuthorizedForQualifications(),
                isAuthorizedForDefects: auth.isAuthorizedForDefects(),
                isAuthorizedForToolChanges: auth.isAuthorizedForToolChanges(),
                isAuthorizedForToolChangesComment: auth.isAuthorizedForToolChangesComment(),
                isAuthorizedForDowntime: auth.isAuthorizedForDowntime(),
                isAuthorizedForHourlyDowntime: auth.isAuthorizedForHourlyDowntime(),
                location: auth.getSelectedRoleLocation().role.roleLocation,
            };
        };
        LineSheetComponent.prototype.componentDidMount = function () {
            var _this = this;
            this.isUnmounted = false;
            this.datePickerInitialized = false;
            var navPromise = LineSheetComponent.navigationService
                .getNavigation()
                .then(function (navModel) {
                _this.initializePermissions();
                var plant = _.find(navModel.plants(), function (p) {
                    return _.some(p.shops, function (s) { return s.id === _this.props.shopId; });
                });
                var date = _this.getLineSheetRequestDate(_this.props.initialDate, plant.timeZoneId);
                return LineSheetComponent.$q
                    .all([
                    LineSheetComponent.lineSheetService.getLineSheetActivityData(_this.props.shopId, date),
                    LineSheetComponent.defectTypeService.getDefectTypesAndClassifications(),
                    LineSheetComponent.toolChangeService.getToolsAndTypes(),
                    LineSheetComponent.defectService.getDefectEquipment(),
                    LineSheetComponent.defectService.getActiveMnrs(_this.props.shopId, date),
                    LineSheetComponent.userProfile.read(),
                    LineSheetComponent.jobService.getJobs(),
                    LineSheetComponent.jobService.getProcesses(),
                ])
                    .then(function (response) {
                    if (_this.isUnmounted) {
                        return;
                    }
                    var activityData = response[0];
                    var defectTypes = response[1];
                    var tools = response[2];
                    var equipments = response[3];
                    var activeMnr = response[4];
                    var userProfileData = response[5];
                    var jobs = response[6];
                    var processes = response[7];
                    var activity = new shopActivity_1.ShopActivity(activityData, defectTypes, userProfileData, tools, jobs, processes, _this.props.eightyHrTools, _this.props.oneSixtyHrTools);
                    var dates = _this.initializeDates(_this.props.initialDate, activity.timeZoneId);
                    var machineVisibility = {};
                    _.forEach(activity.machines, function (machine) { return (machineVisibility[machine.id] = true); });
                    _this.setState({
                        activityData: activityData,
                        defectTypes: defectTypes,
                        tools: tools,
                        equipment: equipments,
                        activity: activity,
                        maxDate: dates.maxDate,
                        currentDate: dates.currentDate,
                        initialDate: dates.initialDate,
                        timeZone: dates.timeZone,
                        activeMnr: activeMnr,
                        userProfileData: userProfileData,
                        machineVisibility: machineVisibility,
                        jobs: jobs,
                        jobProcesses: processes,
                    });
                    _this.createActiveMnr();
                    _this.createCriticalDefectsIndicator();
                    if (!date) {
                        _this.scheduleRefresh();
                    }
                    LineSheetComponent.$timeout(function () { return (_this.initialLoadComplete = true); }, 60000);
                    _this.hub =
                        LineSheetComponent.lineSheetHub.createLineSheetHubForReact(function () { return _this.state.activity; }, function (updatedActivity) { return _this.updateActivity(updatedActivity); }, function () {
                            if (_this.initialLoadComplete) {
                                _this.getLineSheetActivityWithoutBlocking();
                            }
                        }, _this.props.shopId);
                });
            });
            LineSheetComponent.loaderService.loadingPromise(navPromise);
        };
        LineSheetComponent.prototype.scheduleRefresh = function () {
            var _this = this;
            this.cancelRefresh();
            var now = new Date();
            var topOfTheHour = (59 - now.getMinutes()) * 60000 + (59 - now.getSeconds()) * 1000 + 5000;
            this.refreshTimeout = LineSheetComponent.$timeout(function () {
                if (_this.isUnmounted) {
                    return;
                }
                var activity = _this.state.activity;
                activity.updateHours();
                var dates = _this.initializeDates(null, _this.state.timeZone);
                _this.setState({
                    activityData: _this.state.activityData,
                    defectTypes: _this.state.defectTypes,
                    tools: _this.state.tools,
                    equipment: _this.state.equipment,
                    activity: activity,
                    maxDate: dates.maxDate,
                    currentDate: dates.currentDate,
                    initialDate: dates.initialDate,
                    timeZone: _this.state.timeZone,
                    activeMnr: _this.state.activeMnr,
                    userProfileData: _this.state.userProfileData,
                    machineVisibility: _this.state.machineVisibility,
                    jobs: _this.state.jobs,
                    jobProcesses: _this.state.jobProcesses,
                });
                _this.scheduleRefresh();
            }, topOfTheHour);
        };
        LineSheetComponent.prototype.cancelRefresh = function () {
            if (this.refreshTimeout) {
                LineSheetComponent.$timeout.cancel(this.refreshTimeout);
                this.refreshTimeout = undefined;
            }
        };
        LineSheetComponent.prototype.componentWillUnmount = function () {
            var _this = this;
            this.isUnmounted = true;
            this.cancelRefresh();
            if (this.hub) {
                this.hub.leaveGroup(this.props.shopId).then(function () {
                    return _this.hub.uninitialize();
                });
            }
        };
        LineSheetComponent.prototype.goToLive = function () {
            if (this.isLive()) {
                return;
            }
            this.getLineSheetActivity();
        };
        LineSheetComponent.prototype.nextDate = function () {
            if (this.isLive()) {
                return;
            }
            var date = moment(this.state.currentDate).add(1, "d");
            if (date.isAfter(this.state.maxDate)) {
                this.goToLive();
                return;
            }
            if (this.isDateLive(date)) {
                this.getLineSheetActivity();
            }
            else {
                this.getLineSheetActivity(date);
            }
        };
        LineSheetComponent.prototype.prevDate = function () {
            var date = moment(this.state.currentDate).subtract(1, "d");
            this.getLineSheetActivity(date);
        };
        LineSheetComponent.prototype.getLineSheetRequestDate = function (date, timeZoneId) {
            if (date) {
                return moment(date).tz(timeZoneId).hours(23);
            }
            return null;
        };
        LineSheetComponent.prototype.saveAngularState = function (initialDate) {
            var params = {
                plantId: this.props.plantId,
                shopId: this.props.shopId,
                userId: this.props.userId,
                initialDate: initialDate ? initialDate.toISOString() : undefined,
            };
            LineSheetComponent.$state.transitionTo(constant_module_1.States.LINE_SHEET, params);
        };
        LineSheetComponent.prototype.getLineSheetActivityWithoutBlocking = function (date) {
            var _this = this;
            var currentDate = date !== undefined ? moment(date) : undefined;
            date = this.getLineSheetRequestDate(date, this.state.timeZone);
            this.cancelRefresh();
            return LineSheetComponent.lineSheetService
                .getLineSheetActivityData(this.props.shopId, date)
                .then(function (response) {
                var activityData = response;
                if (_this.isUnmounted) {
                    return;
                }
                var activity = new shopActivity_1.ShopActivity(activityData, _this.state.defectTypes, _this.state.userProfileData, _this.state.tools, _this.state.jobs, _this.state.jobProcesses, _this.props.eightyHrTools, _this.props.oneSixtyHrTools);
                var initialDate = currentDate ? currentDate.toDate() : undefined;
                var dates = _this.initializeDates(initialDate, activity.timeZoneId);
                _this.setState({
                    activityData: activityData,
                    defectTypes: _this.state.defectTypes,
                    tools: _this.state.tools,
                    equipment: _this.state.equipment,
                    activity: activity,
                    maxDate: dates.maxDate,
                    currentDate: currentDate || dates.currentDate,
                    initialDate: initialDate,
                    timeZone: dates.timeZone,
                    activeMnr: _this.state.activeMnr,
                    userProfileData: _this.state.userProfileData,
                    machineVisibility: _this.state.machineVisibility,
                });
                _this.saveAngularState(initialDate);
                if (!currentDate) {
                    _this.scheduleRefresh();
                }
            });
        };
        LineSheetComponent.prototype.getLineSheetActivity = function (date) {
            var promise = this.getLineSheetActivityWithoutBlocking(date);
            LineSheetComponent.loaderService.loadingPromise(promise);
        };
        LineSheetComponent.prototype.updateDate = function (newDate) {
            var newMoment = moment(newDate).tz(this.state.timeZone);
            newMoment.add(0 - newMoment.utcOffset(), "m");
            if (newMoment.isSame(this.state.currentDate)) {
                return;
            }
            if (newMoment.isAfter(this.state.maxDate)) {
                this.goToLive();
                return;
            }
            if (this.isDateLive(newMoment)) {
                this.getLineSheetActivity();
            }
            else {
                this.getLineSheetActivity(newMoment);
            }
            this.updateActiveMnr();
        };
        LineSheetComponent.prototype.componentDidUpdate = function (prevProps, prevState) {
            var _this = this;
            if (this.datePickerInitialized) {
                return;
            }
            var element = $(this.datePicker);
            element
                .fdatepicker({
                endDate: this.state.maxDate.toDate(),
            })
                .on("changeDate", function (ev) {
                _this.updateDate(ev.date);
                element.fdatepicker("hide");
            });
            element.fdatepicker("update", this.state.currentDate.toDate());
            this.datePickerInitialized = true;
        };
        LineSheetComponent.prototype.isDateLive = function (newDate) {
            return newDate.isSame(this.state.maxDate);
        };
        LineSheetComponent.prototype.isLive = function () {
            return this.isDateLive(this.state.currentDate);
        };
        LineSheetComponent.prototype.getEquipmentName = function (equipmentId) {
            return _.find(this.state.equipment, { id: equipmentId }).name;
        };
        LineSheetComponent.prototype.initializeDates = function (initialDate, timeZone) {
            timeZone = timeZone || constant_module_1.Strings.DEFAULT_TIMEZONE;
            var maxDate = moment().tz(timeZone).startOf("day");
            var currentDate = moment(initialDate ? initialDate : maxDate);
            return {
                maxDate: maxDate,
                currentDate: currentDate,
                initialDate: initialDate,
                timeZone: timeZone,
            };
        };
        LineSheetComponent.prototype.currentJob = function () {
            if (this.state && this.state.activity.jobRuns.length > 0) {
                var job = _.last(this.state.activity.jobRuns);
                var hour = this.state.activity.hours[0];
                if (!job.endDate || job.endDate.getTime() > hour.endTime.getTime()) {
                    return job;
                }
            }
            return undefined;
        };
        LineSheetComponent.prototype.viewSectionHistory = function (section) {
            sectionHistory_controller_1.openSectionHistory({
                section: section,
            }, LineSheetComponent.$modal);
        };
        LineSheetComponent.prototype.viewCavityHistory = function (gob) {
            cavityHistory_controller_1.openCavityHistory({
                gob: gob,
            }, LineSheetComponent.$modal);
        };
        LineSheetComponent.prototype.viewMoldHistory = function (mold) {
            moldHistory_controller_1.openMoldHistory({
                mold: mold,
            }, LineSheetComponent.$modal);
        };
        LineSheetComponent.prototype.viewQualificationHistory = function (gob, location) {
            var _this = this;
            var result = qualificationHistory_1.openQualificationHistory({
                activity: this.state.activity,
                gob: gob,
                location: location,
                timeZone: this.state.timeZone,
                isAuthorizedForRequalification: this.flags.isAuthorizedForQualifications &&
                    this.flags.location === location &&
                    (this.flags.isAdmin || !gob.hours[0].disabled),
            }, LineSheetComponent.$modal);
            result.then(function (action) {
                if (action === "add") {
                    _this.addRequalification(gob, _this.state.activity.hours[0]);
                }
            });
        };
        LineSheetComponent.prototype.getSideRows = function () {
            var _this = this;
            var rows = [];
            var job = this.state.jobs.filter(function (x) { return x.id == _this.currentJob().jobId; })[0];
            var process = this.state.jobProcesses.filter(function (x) { return x.id == job.processId; })[0];
            var eightyHrTools = this.props.eightyHrTools.split(",");
            var oneSixtyHrTools = this.props.oneSixtyHrTools.split(",");
            eightyHrTools =
                process.name == "B&B"
                    ? eightyHrTools.filter(function (x) { return x !== "Plunger Clip"; })
                    : eightyHrTools;
            _.forEach(this.state.activity.machines, function (machine) {
                var machineVisible = !!_this.state.machineVisibility[machine.id];
                rows.push(React.createElement("tr", { key: machine.id }, React.createElement("td", {
                    colSpan: "5",
                    key: "name",
                    onClick: function () {
                        _this.state.machineVisibility[machine.id] = !machineVisible;
                        _this.setState(_this.state);
                    },
                }, React.createElement("span", {}, machine.name + " "), React.createElement("i", {
                    className: machineVisible ? "fa fa-minus" : "fa fa-plus",
                }))));
                if (!machineVisible) {
                    return;
                }
                _.forEach(machine.gobs, function (gob) {
                    var toolSetOne = [];
                    var toolSetTwo = [];
                    var colorCode = [];
                    var color;
                    _.forEach(gob.toolChanges, function (tool) {
                        if (_.includes(eightyHrTools, tool.toolName) &&
                            tool.timeRemoved === null) {
                            toolSetOne.push(tool);
                        }
                        if (_.includes(oneSixtyHrTools, tool.toolName) &&
                            tool.timeRemoved === null) {
                            toolSetTwo.push(tool);
                        }
                    });
                    _.forEach(toolSetOne, function (toolChange) {
                        var startTime = moment.utc(toolChange.timeChanged);
                        var endTime = moment.utc();
                        var totalHours = endTime.diff(startTime, "hour");
                        var clr = totalHours > 92
                            ? "Red"
                            : totalHours >= 84 && totalHours <= 92
                                ? "Orange"
                                : "Green";
                        colorCode.push(clr);
                    });
                    _.forEach(toolSetTwo, function (toolChange) {
                        var startTime = moment.utc(toolChange.timeChanged);
                        var endTime = moment.utc();
                        var totalHours = endTime.diff(startTime, "hour");
                        var clr = totalHours > 160
                            ? "Red"
                            : totalHours >= 154 && totalHours <= 160
                                ? "Orange"
                                : "Green";
                        colorCode.push(clr);
                    });
                    if (_.includes(colorCode, "Red")) {
                        color = "Red";
                    }
                    else if (_.includes(colorCode, "Orange")) {
                        color = "Orange";
                    }
                    else {
                        color = "Green";
                    }
                    var columns = [];
                    if (gob.gobNumber === 1) {
                        var section = gob.section;
                        columns.push(React.createElement("td", {
                            key: section.name,
                            className: "major-row",
                            rowSpan: section.gobs.length,
                            onClick: function () { return _this.viewSectionHistory(section); },
                        }, React.createElement("span", { key: "name" }, section.name)));
                    }
                    columns.push(React.createElement("td", {
                        key: gob.section.name + gob.name + "-mold",
                        className: "mould-area",
                        style: { backgroundColor: color },
                        onClick: function () { return _this.viewCavityHistory(gob); },
                    }, React.createElement("span", { key: "name" }, gob.name)));
                    columns.push(React.createElement("td", {
                        key: gob.section.name + gob.name + "-gob",
                        className: "gob-box",
                    }, _.map(gob.currentMolds, function (mold) {
                        return React.createElement("span", {
                            key: mold.id,
                            style: { margin: "0 2px" },
                            onClick: function () { return _this.viewMoldHistory(mold); },
                            className: "mold-item",
                        }, mold.toolNumber);
                    })));
                    columns.push(React.createElement("td", {
                        key: gob.section.name + gob.name + "-he",
                        className: gob.qualificationHistory.heIsQualified
                            ? "qualified is-hidden-small"
                            : "not-qualified is-hidden-small",
                        onClick: function () {
                            return _this.viewQualificationHistory(gob, aps_enums_1.apsEnums.Location.HotEnd);
                        },
                    }, "H"));
                    columns.push(React.createElement("td", {
                        key: gob.section.name + gob.name + "-ce",
                        className: gob.qualificationHistory.ceIsQualified
                            ? "qualified is-hidden-small"
                            : "not-qualified is-hidden-small",
                        onClick: function () {
                            return _this.viewQualificationHistory(gob, aps_enums_1.apsEnums.Location.ColdEnd);
                        },
                    }, "C"));
                    rows.push(React.createElement("tr", {
                        key: gob.section.name + gob.name,
                    }, columns));
                });
            });
            return rows;
        };
        LineSheetComponent.prototype.goToChecks = function (hour) {
            var params = {
                plantId: this.props.plantId,
                shopId: this.props.shopId,
                userId: this.props.userId,
                reportPlantId: undefined,
                locationId: undefined,
                startDate: hour.startTime.toISOString(),
                endDate: hour.endTime.toISOString(),
                checkListId: null,
                status: null,
                filter: aps_enums_1.apsEnums.CheckListReportFilter.AllCheckLists,
                autoRun: true,
            };
            LineSheetComponent.$state.go(constant_module_1.States.CHECKLIST_REPORT, params);
        };
        LineSheetComponent.prototype.createCheckStatus = function (hour) {
            var _this = this;
            var divClassName = "check-bottomleft-pending";
            var iClassName = "fa fa-clock-o";
            if (hour.hasPassedChecks) {
                divClassName = "check-bottomleft-success";
                iClassName = "fa fa-check";
            }
            else if (hour.hasFailedChecks) {
                divClassName = "check-bottomleft-failed";
                iClassName = "fa fa-close";
            }
            return React.createElement("div", {
                key: "checkStatus",
                className: divClassName,
                onClick: function () { return _this.goToChecks(hour); },
            }, React.createElement("i", { key: "icon", className: iClassName }));
        };
        LineSheetComponent.prototype.toggleLock = function (hour) {
            if (!this.flags.isAdmin) {
                return;
            }
            var command = {
                shopId: this.props.shopId,
                hour: hour.startTime,
            };
            if (hour.isLocked) {
                LineSheetComponent.lineSheetService.unlockHour(command);
            }
            else {
                LineSheetComponent.lineSheetService.lockHour(command);
            }
        };
        LineSheetComponent.prototype.createLockUnlock = function (hour) {
            var _this = this;
            var className = "fa fa-unlock";
            if (hour.isLocked) {
                className = "fa fa-lock";
            }
            return React.createElement("i", {
                key: "lock",
                className: className,
                onClick: function () { return _this.toggleLock(hour); },
            });
        };
        LineSheetComponent.prototype.getHeader = function () {
            var _this = this;
            var columns = [];
            _.forEach(this.state.activity.hoursAndJobs, function (item) {
                if (item.isHour) {
                    var hour = item;
                    columns.push(React.createElement("th", {
                        key: hour.id,
                    }, React.createElement("div", { key: "hourDiv" }, React.createElement("span", { key: "hour", className: "hour" }, hour.hour), React.createElement("span", { key: "period", className: "period" }, hour.period), _this.createCheckStatus(hour), _this.createLockUnlock(hour))));
                }
                else {
                    var job = item;
                    columns.push(React.createElement("th", {
                        key: job.id,
                    }, React.createElement("div", { key: "jobDiv", style: { fontSize: ".55em" } }, React.createElement("nobr", { key: "jobName" }, job.shortName))));
                }
            });
            return React.createElement("tr", { key: "headerRow" }, columns);
        };
        LineSheetComponent.prototype.getBody = function () {
            var _this = this;
            var rows = [];
            _.forEach(this.state.activity.allActivity, function (gob) {
                if (!gob.isMachineLevel &&
                    !_this.state.machineVisibility[gob.section.machine.id]) {
                    return;
                }
                rows.push(React.createElement("tr", {
                    key: gob.name
                        ? gob.section.name + gob.name
                        : gob.section.machine.name,
                }, _this.getBodyColumns(gob)));
            });
            return rows;
        };
        LineSheetComponent.prototype.getBodyColumns = function (gob) {
            var _this = this;
            var columns = [];
            _.forEach(gob.hoursAndJobs, function (item) {
                if (item.isHour) {
                    var hour = item;
                    columns.push(React.createElement("td", {
                        key: hour.id,
                        className: hour.hour.isLocked || hour.disabled ? "locked" : null,
                    }, _this.getCellDetail(gob, hour)));
                }
                else {
                    var jobRun = item;
                    columns.push(React.createElement("td", {
                        key: jobRun.id,
                    }, React.createElement("div", { key: "molds" }, _.map(jobRun.molds, function (mold) {
                        return React.createElement("span", {
                            key: mold.id,
                            onClick: function () { return _this.viewMoldHistory(mold); },
                            className: "lineitem toolchange",
                        }, mold.toolNumber);
                    }))));
                }
            });
            return columns;
        };
        LineSheetComponent.prototype.createHoverOverWrapper = function (elements, id, open, noCancelOrOpen) {
            var closeHoverOver = function () {
                return angular.element(".lineitem-hoverover:visible").hide();
            };
            var hoverOverElements = elements;
            if (noCancelOrOpen !== true) {
                var footer = React.createElement("div", {
                    key: "footer",
                    className: "row",
                    style: { marginTop: "5px" },
                }, React.createElement("div", {
                    key: "cancelDiv",
                    className: "small-6 columns",
                }, React.createElement("button", {
                    key: "cancelButton",
                    type: "button",
                    className: "tiny button secondary",
                    style: { marginBottom: 0, padding: "10px" },
                    onClick: closeHoverOver,
                }, "Cancel")), React.createElement("div", {
                    key: "openDiv",
                    className: "small-6 columns",
                    style: { textAlign: "right" },
                }, React.createElement("button", {
                    key: "openButton",
                    type: "button",
                    className: "tiny button",
                    style: { marginBottom: 0, padding: "10px" },
                    onClick: function () {
                        if (open) {
                            open();
                        }
                        closeHoverOver();
                    },
                }, "Open")));
                hoverOverElements = elements.concat(footer);
            }
            return React.createElement("div", { key: id + "-hover", className: "lineitem-hoverover" }, hoverOverElements);
        };
        LineSheetComponent.prototype.createCreatedByRow = function (createdBy, time) {
            return React.createElement("div", {
                key: "addedByDiv",
                className: "row",
            }, React.createElement("div", { key: "addedBy", className: "small-8 columns" }, "Added by " + createdBy), React.createElement("div", {
                key: "addedOn",
                className: "small-4 columns",
                style: { textAlign: "right" },
            }, dateutility_service_1.default.formatTime(time, this.state.timeZone)));
        };
        LineSheetComponent.prototype.createCommentRows = function (comments, elements) {
            var _this = this;
            if (!comments) {
                return;
            }
            _.forEach(comments, function (comment) {
                var commentElements = [];
                if (comment.createdByFullName && comment.createdOn) {
                    commentElements.push(React.createElement("div", {
                        key: "createdByRow",
                        className: "row name-time",
                    }, React.createElement("div", { key: "createdBy", className: "small-8 columns" }, comment.createdByFullName), React.createElement("div", {
                        key: "createdOn",
                        className: "small-4 columns",
                        style: { textAlign: "right" },
                    }, dateutility_service_1.default.formatTime(comment.createdOn, _this.state.timeZone))));
                }
                commentElements.push(React.createElement("div", { key: "commentRow", className: "row" }, React.createElement("div", {
                    key: "comment",
                    className: "small-12 columns",
                    style: { whiteSpace: "normal" },
                }, comment.comment)));
                elements.push(React.createElement("div", {
                    key: comment.id,
                    className: "hover-comment",
                }, commentElements));
            });
        };
        LineSheetComponent.prototype.updateActiveMnr = function () {
            var _this = this;
            LineSheetComponent.defectService
                .getActiveMnrs(this.props.shopId, null)
                .then(function (activeMnrs) {
                _this.setState({ activeMnr: activeMnrs });
                _this.createActiveMnr();
            });
            LineSheetComponent.lineSheetService
                .getLineSheetActivityData(this.props.shopId, null)
                .then(function (response) {
                _this.setState({ activityData: response });
                _this.createCriticalDefectsIndicator();
            });
        };
        LineSheetComponent.prototype.createActiveMnr = function () {
            var elements = [];
            var defects = this.state.activeMnr;
            var id = "active-mnr";
            var className = "lineitem active-mnr";
            if (defects.length > 0) {
                className = className + " workflow-indicator";
                elements.push(this.createMnrHoverOver(defects, id));
            }
            else {
                className = className + " is-hidden";
            }
            elements.push(React.createElement("span", {
                key: id,
                className: className,
            }, "Active MNR"));
            return React.createElement("div", {
                key: "active-mnr-container",
                className: "active-mnr-container linedetails is-hidden-small",
            }, elements);
        };
        LineSheetComponent.prototype.createMnrHoverOver = function (defects, id) {
            var elements = [];
            var wrapperElements = [];
            var iClassName = "fa fa-bolt";
            elements.push(React.createElement("div", {
                key: id + "Header",
                className: "row",
            }, React.createElement("div", {
                key: "title",
                className: "small-12 columns",
                style: {
                    textAlign: "center",
                    verticalAlign: "middle",
                    fontWeight: "bold",
                    margin: "5px 0",
                    fontStyle: "italic",
                },
            }, React.createElement("i", {
                key: "icon",
                className: iClassName,
                style: { color: "#1791CC", marginRight: "5px" },
            }), "Active MNR (Last 48 hrs)")));
            defects.forEach(function (defect, i) {
                var rowClassName = "";
                if (i % 2 == 0) {
                    rowClassName += " even";
                }
                var wrapper = React.createElement("div", {
                    key: id + "-" + i + "-row-" + defect.gobName,
                    className: rowClassName,
                    style: {
                        padding: "5px",
                        textAlign: "center",
                        flex: "1 1 43%",
                        background: "#f1f1effd",
                    },
                }, [
                    React.createElement("span", {
                        key: "name",
                        className: "bs-m-2",
                    }, defect.gobName),
                    React.createElement("span", {
                        key: "toolNum",
                        className: "bs-m-2",
                    }, defect.toolNumber),
                    React.createElement("span", {
                        key: "timeFound",
                        className: "bs-m-2",
                    }, defect.timeFound),
                ]);
                wrapperElements = wrapperElements.concat([wrapper]);
            });
            elements = elements.concat([
                React.createElement("div", {
                    key: "body",
                    className: "active-mnr-body",
                    style: {
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "5px",
                        overflow: "auto",
                    },
                }, wrapperElements),
            ]);
            return this.createHoverOverWrapper(elements, id, null, true);
        };
        LineSheetComponent.prototype.createCriticalDefectsIndicator = function () {
            if (!this.isLive())
                return;
            var elements = [];
            var currentJob = this.currentJob();
            var defects = this.state.activityData.defects.filter(function (d) { return d.severity === 0 && d.createdOn >= currentJob.startDate; });
            var id = "critical-defects";
            var className = "lineitem critical-defects-indicator";
            if (defects.length > 0) {
                className = className + " workflow-indicator";
                elements.push(this.createCriticalDefectHoverOver(defects, id));
            }
            else {
                className = className + " is-hidden";
            }
            elements.push(React.createElement("span", {
                key: id,
                className: className,
            }, "Critical Defects"));
            return React.createElement("div", {
                key: "critical-defects-indicator-container",
                className: "critical-defects-indicator-container linedetails is-hidden-small",
            }, elements);
        };
        LineSheetComponent.prototype.createCriticalDefectHoverOver = function (defects, id) {
            var _this = this;
            var elements = [];
            var wrapperElements = [];
            var iClassName = "fa fa-exclamation";
            elements.push(React.createElement("div", {
                key: id + "Header",
                className: "row",
            }, React.createElement("div", {
                key: "title",
                className: "small-12 columns",
                style: {
                    display: "ruby",
                    textAlign: "center",
                    verticalAlign: "middle",
                    fontWeight: "bold",
                    margin: "5px 0",
                    fontStyle: "italic",
                },
            }, React.createElement("i", {
                key: "icon",
                className: iClassName,
                style: { color: "rgb(248, 78, 78)", marginRight: "5px" },
            }), "Critical Defects (Last 24 hrs)", React.createElement("span", {
                key: "tile",
                style: {
                    textAlign: "center",
                    verticalAlign: "middle",
                    fontWeight: "bold",
                    background: "#696969",
                    margin: "5px",
                    padding: "2px",
                    fontStyle: "italic",
                    color: "white",
                    width: "auto",
                },
            }, "1000"))));
            defects.forEach(function (defect, i) {
                var rowClassName = "";
                if (i % 2 == 0) {
                    rowClassName += " even";
                }
                var sectionName = null;
                if (_this.state &&
                    _this.state.activity &&
                    _this.state.activity.sections) {
                    var currentSection = _this.state.activity.sections
                        .filter(function (s) { return s.machine && s.machine.id === defect.isMachineId; })
                        .filter(function (s) { return s.sectionNumber === defect.section; });
                    if (currentSection.length > 0) {
                        sectionName = currentSection[0].name;
                    }
                }
                var wrapper = React.createElement("div", {
                    key: id + "-" + i + "-row-" + defect.gobName,
                    className: rowClassName,
                    style: {
                        padding: "5px",
                        textAlign: "center",
                        flex: "1 1 46%",
                        background: "#f1f1effd",
                    },
                }, [
                    React.createElement("span", {
                        key: "name",
                        className: "bs-m-2",
                    }, sectionName + "-" + defect.gobName),
                    React.createElement("span", {
                        key: "rejectEnd",
                        className: "bs-m-2",
                    }, defect.rejectEnd ? dateutility_service_1.default.formatTime(defect.rejectEnd, _this.state.timeZone) : ""),
                    React.createElement("div", {
                        key: "timeLeft",
                        className: "bs-m-2",
                        style: {
                            fontWeight: "bold",
                        },
                    }, "Time Left: " +
                        (defect.rejectEnd
                            ? _this.calcTimeLeft(defect.rejectEnd)
                            : "Reject End Not Set")),
                ]);
                wrapperElements = wrapperElements.concat([wrapper]);
            });
            elements = elements.concat([
                React.createElement("div", {
                    key: "body",
                    className: "critical-defects-body",
                    style: {
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "5px",
                        overflow: "auto",
                    },
                }, wrapperElements),
            ]);
            return this.createHoverOverWrapper(elements, id, null, true);
        };
        LineSheetComponent.prototype.calcTimeLeft = function (rejectEnd) {
            var dueTime = dateutility_service_1.default.timeZoneToLocal(new Date(rejectEnd.getTime() + 24 * 60 * 60 * 1000), this.state.timeZone).toDate();
            var now = dateutility_service_1.default.timeZoneToLocal(new Date(), this.state.timeZone).toDate();
            var timeLeftMs = dueTime.getTime() - now.getTime();
            if (timeLeftMs > 0) {
                var hours = Math.floor(timeLeftMs / (1000 * 60 * 60));
                return hours ? hours + "h" : "-";
            }
        };
        LineSheetComponent.prototype.createDefectHoverOver = function (defect, open) {
            var elements = [];
            elements.push(this.createCreatedByRow(defect.createdByFullName, defect.timeFound));
            var headerText = defect.name;
            if (defect.defectTypeLegacyId) {
                headerText = defect.defectTypeLegacyId + " " + headerText;
            }
            var defectHeaderElements = [
                React.createElement("div", { key: "name", className: "small-7 columns" }, headerText),
            ];
            if (defect.equipmentId) {
                defectHeaderElements.push(React.createElement("div", {
                    key: "equipName",
                    className: "small-3 columns",
                    style: { textAlign: "center" },
                }, React.createElement("span", {
                    key: "equipNameSpan",
                    className: "defectequipment",
                    style: { padding: "3px" },
                }, this.getEquipmentName(defect.equipmentId))));
            }
            if (defect.toolNumber) {
                defectHeaderElements.push(React.createElement("div", {
                    key: "toolNumber",
                    className: "small-2 columns",
                    style: { textAlign: "right" },
                }, React.createElement("span", {
                    key: "toolNumberSpan",
                    className: "toolchange",
                    style: { padding: "3px" },
                }, defect.toolNumber)));
            }
            elements.push(React.createElement("div", {
                key: "defectHeader",
                className: "row " + defect.severityClass,
                style: { marginTop: "5px", padding: "5px", color: "#FFFFFF" },
            }, defectHeaderElements));
            if (defect.isMoldRejectInUse) {
                var startTime = dateutility_service_1.default.formatTimeOnly(defect.rejectStart, this.state.timeZone);
                var endTime = defect.rejectEnd
                    ? dateutility_service_1.default.formatTimeOnly(defect.rejectEnd, this.state.timeZone)
                    : null;
                elements.push(React.createElement("div", {
                    key: "moldReject",
                    className: "row",
                    style: { marginTop: "5px", color: "#FF0000" },
                }, "Rejected from " + startTime + (endTime ? " to " + endTime : "")));
            }
            if (defect.isFrequencyCount()) {
                elements.push(React.createElement("div", {
                    key: "frequencyCount",
                    className: "row",
                    style: { marginTop: "5px" },
                }, "Frequency: " + defect.frequencyCount + " / " + defect.frequencyTotal));
            }
            if (defect.isFrequencyPercentage()) {
                elements.push(React.createElement("div", {
                    key: "frequencyPercent",
                    className: "row",
                    style: { marginTop: "5px" },
                }, "Frequency: " + defect.frequencyPercent + "%"));
            }
            if (defect.isFrequencyPSI()) {
                elements.push(React.createElement("div", {
                    key: "frequencyPSI",
                    className: "row",
                    style: { marginTop: "5px" },
                }, "PSI: " +
                    defect.frequencyCount +
                    " failed / " +
                    defect.frequencyTotal +
                    " tested"));
            }
            if (defect.isFrequencyThermal()) {
                elements.push(React.createElement("div", {
                    key: "frequencyThermal",
                    className: "row",
                    style: { marginTop: "5px" },
                }, "Thermal Shock: " +
                    defect.frequencyCount +
                    " failed / " +
                    defect.frequencyTotal +
                    " tested"));
            }
            this.createCommentRows(defect.comments, elements);
            return this.createHoverOverWrapper(elements, defect.id, open);
        };
        LineSheetComponent.prototype.createToolTable = function (header, tools) {
            if (!tools || tools.length === 0) {
                return null;
            }
            var elements = [];
            var sortedTools = _.sortBy(tools, "toolName");
            _.forEach(sortedTools, function (tool) {
                elements.push(React.createElement("tr", {
                    key: tool.id,
                }, React.createElement("td", { key: "toolName" }, tool.toolName), React.createElement("td", { key: "toolNumber" }, tool.toolIsMold
                    ? React.createElement("span", {
                        key: "moldNumber",
                        className: "toolchange",
                        style: { padding: "3px", color: "#FFFFFF" },
                    }, tool.toolNumber)
                    : tool.toolNumber
                        ? tool.toolNumber.toString()
                        : ""), React.createElement("td", { key: "reason" }, tool.getReason()), React.createElement("td", { key: "defectName" }, tool.defectTypeName)));
            });
            return React.createElement("table", {
                key: header,
                className: "history-t",
                style: { marginTop: "5px" },
            }, React.createElement("thead", { key: "header" }, React.createElement("tr", { key: "topHeader" }, React.createElement("th", {
                key: "headerText",
                colSpan: "4",
            }, header)), React.createElement("tr", { key: "secondHeader" }, React.createElement("th", { key: "tool" }, "Tool"), React.createElement("th", { key: "number" }, "No."), React.createElement("th", { key: "reason" }, "Reason"), React.createElement("th", { key: "defectTypeName" }, "Defect"))), React.createElement("tbody", { key: "body" }, elements));
        };
        LineSheetComponent.prototype.createToolChangeHoverOver = function (toolChange, gob, open) {
            var elements = [];
            var firstToolChange = toolChange.tools[0];
            elements.push(this.createCreatedByRow(firstToolChange.createdByFullName, toolChange.timeChanged));
            var toolNames = _.map(_.sortBy(toolChange.tools, "toolName"), "toolName").join(", ");
            elements.push(React.createElement("div", {
                key: "toolNames",
                className: "row",
                style: { marginTop: "5px", whiteSpace: "normal" },
            }, toolNames));
            elements.push(React.createElement("div", {
                key: "duration",
                className: "row",
                style: { marginTop: "5px" },
            }, "Downtime: " + firstToolChange.duration + " minutes"));
            var gobTools = _.filter(toolChange.tools, function (t) { return t.toolType === aps_enums_1.apsEnums.ToolType.Mold; });
            var section = gob.section;
            if (gobTools.length > 0) {
                elements.push(this.createToolTable("Cavity " + section.name + gob.name, gobTools));
            }
            var sectionTools = _.filter(toolChange.tools, function (t) { return t.toolType === aps_enums_1.apsEnums.ToolType.Variable; });
            if (sectionTools.length > 0) {
                elements.push(this.createToolTable("Section " + section.name, sectionTools));
            }
            var machineTools = _.filter(toolChange.tools, function (t) { return t.toolType === aps_enums_1.apsEnums.ToolType.Machine; });
            if (machineTools.length > 0) {
                elements.push(this.createToolTable(section.machine.name, machineTools));
            }
            this.createCommentRows(toolChange.comments, elements);
            return this.createHoverOverWrapper(elements, toolChange.id, open);
        };
        LineSheetComponent.prototype.createDowntimeHoverOver = function (downtime, gob, open) {
            var elements = [];
            elements.push(this.createCreatedByRow(downtime.createdByFullName, downtime.downtimeStart));
            elements.push(React.createElement("div", {
                key: "section",
                className: "row",
                style: { marginTop: "5px" },
            }, "Section: " +
                (downtime.section ? gob.section.name : gob.section.machine.name)));
            if (downtime.duration) {
                elements.push(React.createElement("div", {
                    key: "duration",
                    className: "row",
                    style: { marginTop: "5px" },
                }, "Downtime: " + downtime.duration + " minutes"));
            }
            elements.push(React.createElement("div", {
                key: "reason",
                className: "row",
                style: { marginTop: "5px" },
            }, "Reason: " +
                downtime.downtimeReasonDescription +
                " (" +
                downtime.downtimeReasonCode +
                ")"));
            this.createCommentRows(downtime.comments, elements);
            return this.createHoverOverWrapper(elements, downtime.id, open);
        };
        LineSheetComponent.prototype.getCellDetail = function (gob, hour) {
            var _this = this;
            var elements = [];
            if (!hour.hour.jobRun) {
                return elements;
            }
            var activity = _.sortBy(hour.activity, function (a) {
                return 0 - (a.timeFound || a.timeChanged || a.downtimeStart).getTime();
            });
            _.forEach(activity, function (activity) {
                var className = "lineitem";
                var open = null;
                if (activity.isDefect) {
                    var defect = activity;
                    open = function () {
                        return _this.viewDefect(gob, hour, defect, !_this.flags.isAuthorizedForDefects);
                    };
                    elements.push(_this.createDefectHoverOver(defect, open));
                    className = className + " " + defect.severityClass;
                    if (defect.hasOpenMoldReject) {
                        className = className + " workflow-indicator";
                    }
                    if (defect.isEquipmentFailure && !defect.maintenanceEnd) {
                        className = className + " workflow-indicator-maint";
                    }
                    if (defect.rejectStart) {
                        className = className + " mnr";
                    }
                    elements.push(React.createElement("span", {
                        key: defect.id,
                        className: className,
                        onClick: open,
                    }, defect.idAbbr()));
                }
                else if (activity.isToolChange) {
                    var toolChange = activity;
                    open = function () {
                        return _this.viewToolChange(gob, hour, toolChange, !_this.flags.isAuthorizedForToolChanges);
                    };
                    elements.push(_this.createToolChangeHoverOver(toolChange, gob, open));
                    var mold = _.find(toolChange.tools, function (t) { return t.toolIsMold; });
                    className = className + " toolchange";
                    elements.push(React.createElement("span", {
                        key: toolChange.id,
                        className: className,
                        onClick: open,
                    }, React.createElement("i", {
                        key: "icon",
                        className: "fa fa-wrench",
                    }), React.createElement("span", { key: "toolNumber" }, mold ? mold.toolNumber : "")));
                }
                else if (activity.isDowntime) {
                    var downtime = activity;
                    open = function () {
                        return _this.viewDowntime(gob.section, hour, downtime, !_this.flags.isAuthorizedForDowntime);
                    };
                    elements.push(_this.createDowntimeHoverOver(downtime, gob, open));
                    className = className + " downtime";
                    if (!(downtime.duration > 0)) {
                        className = className + " workflow-indicator";
                    }
                    elements.push(React.createElement("span", {
                        key: downtime.id,
                        className: className,
                        onClick: open,
                    }, React.createElement("i", {
                        key: "icon",
                        className: "fa fa-clock-o",
                    })));
                }
            });
            var menu = this.createMenu(gob, hour);
            if (menu) {
                elements.push(menu);
                if (this.flags.isAdmin || (!hour.hour.isLocked && !hour.disabled)) {
                    elements.push(React.createElement("i", {
                        key: "openMenu",
                        className: "fa fa-plus-square add-menu-trigger",
                    }));
                }
            }
            return elements;
        };
        LineSheetComponent.prototype.createAddJobChangeMenuElement = function (elements, gob, hour) {
            var _this = this;
            elements.push(React.createElement("a", {
                key: "addJobChange",
                onClick: function () { return _this.addJobChange(gob, hour.hour); },
            }, "Add Job Change"));
        };
        LineSheetComponent.prototype.createMenu = function (gob, hour) {
            var _this = this;
            var elements = [];
            if (!this.flags.isAuthorized) {
                return null;
            }
            var jobRun = hour.hour.jobRun;
            if (!jobRun) {
                return null;
            }
            var hasActivity = jobRun.hasActivity(gob);
            if (!hasActivity && !this.flags.isAuthorizedForToolChanges) {
                return null;
            }
            if (hasActivity) {
                if (this.flags.isAuthorizedForDefects) {
                    elements.push(React.createElement("a", {
                        key: "addDefect",
                        onClick: function () { return _this.addDefect(gob, hour, _this.props.plantId); },
                    }, "Add Defect"));
                }
                if (this.flags.isAuthorizedForToolChanges) {
                    if (_.every(_.filter(this.state.activity.allActivity, "gobNumber"), function (g) { return g.currentMolds.length > 0; })) {
                        var hasToolChange = jobRun.hasToolChange(gob);
                        elements.push(React.createElement("a", {
                            key: "addToolChange",
                            onClick: function () { return _this.addToolChange(gob, hour, null); }
                        }, "Add Tool Change"));
                    }
                    else {
                        this.createAddJobChangeMenuElement(elements, gob, hour);
                    }
                }
                if (this.flags.isAuthorizedForDowntime) {
                    elements.push(React.createElement("a", {
                        key: "addDowntime",
                        onClick: function () { return _this.addDowntime(gob.section, hour); },
                    }, "Add Downtime"));
                }
                if (this.flags.isAuthorizedForQualifications) {
                    elements.push(React.createElement("a", {
                        key: "addRequalification",
                        onClick: function () { return _this.addRequalification(gob, hour.hour); },
                    }, "Add Requalification"));
                }
                if (this.flags.isAuthorizedForHourlyDowntime) {
                    elements.push(React.createElement("a", {
                        key: "addStreaming",
                        onClick: function () { return _this.addHourlyDowntime(hour.hour); },
                    }, "Add Streaming"));
                }
            }
            else {
                this.createAddJobChangeMenuElement(elements, gob, hour);
            }
            if (elements.length > 0) {
                return React.createElement("div", { key: "addMenu", className: "add-menu" }, elements);
            }
            else {
                return null;
            }
        };
        LineSheetComponent.prototype.createDatePicker = function () {
            var _this = this;
            var formattedDate = this.state.currentDate.format(constant_module_1.Strings.DATE_FORMAT);
            var elements = [];
            if (!this.isLive()) {
                elements.push(React.createElement("i", {
                    key: "next",
                    className: "fa fa-arrow-circle-o-left",
                    onClick: function () { return _this.nextDate(); },
                }));
            }
            elements.push(React.createElement("a", {
                key: "picker",
                ref: function (r) { return (_this.datePicker = r); },
            }, formattedDate));
            elements.push(React.createElement("i", {
                key: "prev",
                className: "fa fa-arrow-circle-o-right",
                onClick: function () { return _this.prevDate(); },
            }));
            elements.push(React.createElement("br", { key: "break" }));
            if (!this.isLive()) {
                elements.push(React.createElement("span", {
                    key: "goLive",
                    onClick: function () { return _this.goToLive(); },
                }, "Go to Live"));
            }
            return React.createElement("tr", { key: "datePicker" }, React.createElement("th", { key: "datePickerTh", colSpan: "5" }, elements));
        };
        LineSheetComponent.prototype.render = function () {
            if (this.state === null) {
                return React.createElement("div", {
                    key: "lineSheet",
                    className: "lineSheet",
                });
            }
            var currentJob = this.currentJob();
            var jobName = "No job currently running";
            var days = "";
            if (currentJob) {
                jobName = currentJob.jobName;
                days =
                    "(Day " +
                        (moment(this.state.currentDate).diff(moment(currentJob.startDate), "days") +
                            1) +
                        ")";
            }
            return React.createElement("div", { key: "lineSheet", className: "lineSheet" }, React.createElement("div", { key: "header", className: "linesheet-head" }, React.createElement("div", { key: "topBox", className: "topbox linedetails is-hidden-small" }, React.createElement("h2", { key: "shop" }, "Shop " + this.state.activity.name), React.createElement("h1", { key: "days" }, days), React.createElement("h3", { key: "job" }, jobName)), this.createActiveMnr(), this.createCriticalDefectsIndicator(), React.createElement("div", { key: "wnk", className: "linedash-w" }, React.createElement("div", { key: "wnkHE", className: "linedashitem" }, React.createElement("div", { key: "icon", className: "dash-ref is-hidden-small" }, React.createElement("img", {
                key: "bottle",
                className: "bottle-icon",
            })), React.createElement(KpiComponent, {
                plantId: this.props.plantId,
                shopId: this.props.shopId,
                wellKnownCheck: aps_enums_1.apsEnums.WellKnownCheckType.HotEndEfficiency,
            })), React.createElement("div", { key: "wnkPE", className: "linedashitem" }, React.createElement("div", { key: "icon", className: "dash-ref is-hidden-small" }, React.createElement("i", {
                key: "dropBox",
                className: "fa fa-dropbox",
            })), React.createElement(KpiComponent, {
                plantId: this.props.plantId,
                shopId: this.props.shopId,
                wellKnownCheck: aps_enums_1.apsEnums.WellKnownCheckType.ShopPackEfficiency,
            })))), React.createElement("div", { key: "detail", className: "linesheet-w" }, React.createElement("div", { key: "side", className: "left-line" }, React.createElement("table", {
                key: "sideTable",
                cellPadding: "0",
                cellSpacing: "0",
            }, React.createElement("thead", { key: "header" }, this.createDatePicker()), React.createElement("tbody", { key: "body" }, this.getSideRows()))), React.createElement("div", { key: "main", className: "linesheet-main" }, React.createElement("table", {
                key: "mainTable",
                id: "linesheet-data",
                cellPadding: "0",
                cellSpacing: "0",
                className: this.isLive() ? "live" : null,
            }, React.createElement("thead", { key: "header" }, this.getHeader()), React.createElement("tbody", { key: "body" }, this.getBody())))));
        };
        LineSheetComponent.prototype.addToolChange = function (gob, gobHour, defect, toolChanges, defectCause) {
            var _this = this;
            var hour = gobHour.hour;
            var result = addToolChange_controller_1.openAddToolChange({
                shopId: this.props.shopId,
                gob: gob,
                gobHour: gobHour,
                date: hour ? hour.startTime : new Date(),
                activity: this.state.activity,
                defectFixed: defect,
                toolChanges: toolChanges,
                defectCause: defectCause,
            }, LineSheetComponent.$modal);
            result.then(function (event) {
                if (event) {
                    var activity = _this.state.activity;
                    if (toolChanges) {
                        activity.editToolChangeFromEvent(event);
                    }
                    else {
                        activity.addToolChangeFromEvent(event);
                    }
                    _this.updateActivity(activity);
                }
            });
        };
        LineSheetComponent.prototype.reviewDefectCause = function (gob, gobHour, defect) {
            var _this = this;
            var result = defectCauses_controller_1.openDefectCauses({
                defect: defect,
            }, LineSheetComponent.$modal);
            if (this.flags.isAuthorizedForToolChanges) {
                result.then(function (defectCause) {
                    if (defectCause) {
                        _this.addToolChange(gob, gobHour, defect, null, defectCause);
                    }
                });
            }
        };
        LineSheetComponent.prototype.viewDefect = function (gob, gobHour, defect, readOnly) {
            var _this = this;
            var hour = gobHour.hour;
            var result = viewDefect_controller_1.openViewDefect({
                defectId: null,
                defect: defect,
                gob: gob,
                readOnly: readOnly ||
                    (!this.flags.isAdmin && (hour.isLocked || gobHour.disabled)),
                canComment: this.flags.isAdmin ||
                    (!(hour.isLocked || gobHour.disabled) && !readOnly),
                plantId: this.props.plantId,
            }, LineSheetComponent.$modal);
            result.then(function (reviewDefect) {
                if ((reviewDefect || "") === true) {
                    _this.reviewDefectCause(gob, gobHour, defect);
                }
            });
        };
        LineSheetComponent.prototype.viewToolChange = function (gob, gobHour, toolChanges, readOnly) {
            var _this = this;
            var hour = gobHour.hour;
            var result = viewToolChange_controller_1.openViewToolChange({
                timeZoneId: this.state.activity.timeZoneId,
                toolChanges: toolChanges,
                readOnly: readOnly ||
                    (!this.flags.isAdmin && (hour.isLocked || gobHour.disabled)),
                canComment: (this.flags.isAdmin || !(hour.isLocked || gobHour.disabled)) &&
                    (this.flags.isAuthorizedForToolChanges ||
                        this.flags.isAuthorizedForToolChangesComment),
                canEdit: (this.flags.isAdmin || !(hour.isLocked || gobHour.disabled)) &&
                    this.flags.isAuthorizedForToolChanges,
            }, LineSheetComponent.$modal);
            result.then(function (data) {
                if (data && data.action) {
                    if (data.action === "edit") {
                        _this.addToolChange(gob, gobHour, null, toolChanges);
                    }
                    else if (data.action === "delete") {
                        _this.updateActiveMnr();
                    }
                    else if (data.action === "addComment") {
                    }
                }
            });
        };
        LineSheetComponent.prototype.viewDowntime = function (section, gobHour, downtime, readOnly) {
            var _this = this;
            var hour = gobHour.hour;
            var result = addDowntime_controller_1.openAddDowntime({
                section: section,
                shopId: this.props.shopId,
                date: hour.startTime,
                timeZoneId: this.state.timeZone,
                downtime: downtime,
                readOnly: readOnly ||
                    (!this.flags.isAdmin && (hour.isLocked || gobHour.disabled)),
                canComment: this.flags.isAdmin ||
                    (!(hour.isLocked || gobHour.disabled) && !readOnly),
            }, LineSheetComponent.$modal);
            result.then(function (events) {
                if (events) {
                    var activity = _this.state.activity;
                    _.forEach(events, function (event) {
                        activity.addDowntimeFromEvent(event);
                    });
                    _this.updateActivity(activity);
                }
            });
        };
        LineSheetComponent.prototype.addDowntime = function (section, gobHour) {
            this.viewDowntime(section, gobHour, null, false);
        };
        LineSheetComponent.prototype.addDefect = function (gob, gobHour, plantId) {
            var _this = this;
            var hour = gobHour.hour;
            var result = addDefect_controller_1.openAddDefect({
                gob: gob,
                date: hour.startTime,
                plantId: plantId,
            }, LineSheetComponent.$modal);
            result.then(function (result) {
                if (result) {
                    var activity = _this.state.activity;
                    activity.addDefectFromEvent(result.event);
                    _this.updateActivity(activity);
                    _this.getLineSheetActivityWithoutBlocking();
                    if (_this.flags.isHotEndOperator) {
                        var cavity;
                        if (result.event.section) {
                            cavity = _.find(activity.gobs, function (g) {
                                return g.gobNumber === result.event.gob &&
                                    g.section.sectionNumber === result.event.section;
                            });
                        }
                        else {
                            cavity = gob.section.machine.machineLevelActivity;
                        }
                        _this.reviewDefectCause(cavity, gobHour, result.command);
                    }
                }
            });
        };
        LineSheetComponent.prototype.addHourlyDowntime = function (hour) {
            LineSheetComponent.checkListInstancesService
                .getWellKnownCheckListInstance(this.props.shopId, aps_enums_1.apsEnums.WellKnownCheckList.HourlyDowntime, hour.startTime)
                .then(function (data) {
                if (!data) {
                    return;
                }
                fillOutCheckList_controller_1.openFillOutCheckList({
                    checkListId: data.checkListId,
                    instanceId: data.id,
                    plantId: data.plantId,
                    plantLocationId: data.plantLocationId,
                    shopId: data.shopId,
                    tankId: data.tankId,
                    scheduledOn: data.scheduledOn,
                }, LineSheetComponent.$modal);
            });
        };
        LineSheetComponent.prototype.addRequalification = function (gob, hour) {
            addRequalification_controller_1.openAddRequalification({
                shopId: this.props.shopId,
                gob: gob,
                date: hour.startTime,
                activity: this.state.activity,
                section: null,
            }, LineSheetComponent.$modal);
        };
        LineSheetComponent.prototype.addJobChange = function (gob, hour) {
            addJobChange_controller_1.openAddJobChange({
                gob: gob,
                hour: hour,
                shopId: this.props.shopId,
                activity: this.state.activity,
            }, LineSheetComponent.$modal);
        };
        LineSheetComponent.prototype.updateActivity = function (activity) {
            var _this = this;
            if (this.isUnmounted) {
                return;
            }
            setTimeout(function () {
                _this.updateActiveMnr();
            }, 2000);
            this.setState({
                activityData: this.state.activityData,
                defectTypes: this.state.defectTypes,
                tools: this.state.tools,
                equipment: this.state.equipment,
                activity: activity,
                maxDate: this.state.maxDate,
                currentDate: this.state.currentDate,
                initialDate: this.state.initialDate,
                timeZone: this.state.timeZone,
                activeMnr: this.state.activeMnr,
                userProfileData: this.state.userProfileData,
                machineVisibility: this.state.machineVisibility,
                jobs: this.state.jobs,
                jobProcesses: this.state.jobProcesses,
            });
        };
        return LineSheetComponent;
    }(React.Component));
    exports.default = angular
        .module("aps.controller.lineSheet.react", requires)
        .factory("LineSheetComponent", ["lineSheetService", "loaderService", "$q", "$state", "authDataService", "lineSheetHub", "tempDataService", "defectTypeService", "defectService", "toolChangeService", "$timeout", "checkListsService", "checkListInstancesService", "kpiChecksHubService", "navigationService", "jobService", "userProfile", "$modal", function (lineSheetService, loaderService, $q, $state, authDataService, lineSheetHub, tempDataService, defectTypeService, defectService, toolChangeService, $timeout, checkListsService, checkListInstancesService, kpiChecksHubService, navigationService, jobService, userProfile, $modal) {
        LineSheetComponent.lineSheetService = lineSheetService;
        LineSheetComponent.loaderService = loaderService;
        LineSheetComponent.$q = $q;
        LineSheetComponent.userProfile = userProfile;
        LineSheetComponent.$state = $state;
        LineSheetComponent.defectTypeService = defectTypeService;
        LineSheetComponent.toolChangeService = toolChangeService;
        LineSheetComponent.defectService = defectService;
        LineSheetComponent.$modal = $modal;
        LineSheetComponent.tempDataService = tempDataService;
        LineSheetComponent.authDataService = authDataService;
        LineSheetComponent.lineSheetHub = lineSheetHub;
        LineSheetComponent.$timeout = $timeout;
        LineSheetComponent.navigationService = navigationService;
        LineSheetComponent.checkListInstancesService = checkListInstancesService;
        KpiComponent.checkListsService = checkListsService;
        KpiComponent.kpiChecksHubService = kpiChecksHubService;
        LineSheetComponent.jobService = jobService;
        return LineSheetComponent;
    }]).name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(114), __webpack_require__(751)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, defectCause_service_1, defectCauses_tpl_html_1) {
    "use strict";
    defectCausesCtrl.$inject = ["$modalInstance", "data", "defectCausesService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [defectCause_service_1.default];
    exports.default = angular.module('aps.controller.defectCauses', requires)
        .controller('DefectCausesCtrl', defectCausesCtrl)
        .name;
    function openDefectCauses(data, $modal) {
        return $modal.open({
            template: defectCauses_tpl_html_1.default,
            controller: 'DefectCausesCtrl as defectCausesCtrl',
            resolve: {
                data: function () { return data; }
            }
        }).result;
    }
    exports.openDefectCauses = openDefectCauses;
    function defectCausesCtrl($modalInstance, data, defectCausesService) {
        'use strict';
        var vm = this;
        vm.defect = data.defect;
        var defectTypeId = vm.defect.defectTypeId;
        defectCausesService.getDefectCauseSelections(defectTypeId).then(function (defectCauses) {
            vm.defectCauses = _.filter(defectCauses, function (x) { return x.enabled === true; });
            if (vm.defectCauses.length === 0) {
                $modalInstance.close();
            }
        });
        vm.kickoffCourseOfAction = function (defectCause) {
            $modalInstance.close(defectCause);
        };
        vm.cancel = function () {
            $modalInstance.close();
        };
        return vm;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=defectCauses> <h2 class=modal-header>Defect Causes</h2> <table class=history-t> <tr> <thead> <th>Name</th> <th>Description</th> <th>Priority</th> <th>Probability</th> <th>Course Of Action</th> </thead> </tr> <tr ng-repeat=\"defectCause in defectCausesCtrl.defectCauses | orderBy: '-probability'\"> <td ng-bind=defectCause.name></td> <td ng-bind=defectCause.description></td> <td ng-bind=defectCause.priority></td> <td ng-bind=defectCause.probability></td> <td> <button class=\"button primary tiny\" ng-if=\"defectCause.courseOfActionName == 'Tool Change'\" ng-click=defectCausesCtrl.kickoffCourseOfAction(defectCause)>{{ defectCause.courseOfActionName }}</button> </td> </tr> </table> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-12 columns\"> <div class=\"right dialog-footer\"> <button type=button class=\"button secondary\" value=Close ng-click=defectCausesCtrl.cancel()> Close </button> </div> </div> </div> </div>");

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(5), __webpack_require__(3), __webpack_require__(109), __webpack_require__(11), __webpack_require__(4), __webpack_require__(74), __webpack_require__(25), __webpack_require__(9), __webpack_require__(6), __webpack_require__(53), __webpack_require__(7), __webpack_require__(55), __webpack_require__(12), __webpack_require__(753), __webpack_require__(33)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, aps_enums_1, constant_module_1, defectType_1, dateutility_service_1, loader_service_1, defect_service_1, defectType_service_1, uiUtility_service_1, notify_service_1, auth_service_1, authData_service_1, plant_service_1, newguid_service_1, addDefect_tpl_html_1, equipment_service_1) {
    "use strict";
    addDefectCtrl.$inject = ["$modalInstance", "$q", "loaderService", "defectService", "defectTypeService", "data", "notifyService", "authService", "authDataService", "newGuidService", "plantService", "$stateParams", "equipmentService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, defect_service_1.default, defectType_service_1.default, notify_service_1.default, auth_service_1.default,
        authData_service_1.default, newguid_service_1.default, plant_service_1.default, uiUtility_service_1.default, equipment_service_1.default];
    function openAddDefect(data, $modal) {
        return $modal.open({
            template: addDefect_tpl_html_1.default,
            controller: 'AddDefectCtrl as vm',
            resolve: {
                data: function () { return data; }
            }
        }).result;
    }
    exports.openAddDefect = openAddDefect;
    exports.default = angular.module('aps.controller.defects', requires)
        .controller('AddDefectCtrl', addDefectCtrl)
        .name;
    function addDefectCtrl($modalInstance, $q, loaderService, defectService, defectTypeService, data, notifyService, authService, authDataService, newGuidService, plantService, $stateParams, equipmentService) {
        var vm = this;
        var defectMarkIdentifier = 'defectMarkID';
        var bottleIdentifier = 'defectBottleID';
        vm.defectTypeSelectSize = 6;
        vm.isMoldRejectInUse = false;
        vm.defectFilter = '';
        vm.machineLevel = (data.gob.gobNumber || 0) <= 0;
        vm.readyForSubmit = false;
        vm.isEquipmentFailure = false;
        vm.defectComment = '';
        vm.isCritical = false;
        vm.machine = data.gob.section.machine;
        vm.activity = vm.machine.shop;
        vm.timeZone = vm.activity.timeZoneId;
        vm.sections = vm.activity.sections;
        vm.drops = vm.sections[0].gobs;
        var range = dateutility_service_1.default.getHourRange(data.date, vm.activity.timeZoneId);
        vm.timeFound = range.initialTime.toDate();
        vm.minTime = range.minTime;
        vm.maxTime = range.maxTime;
        vm.showMaintCheckbox = false;
        vm.defectTypeId = null;
        vm.showMaintCheckbox = true;
        vm.frequencyTypes = [
            constant_module_1.Enums.FREQUENCY_TYPES.COUNT,
            constant_module_1.Enums.FREQUENCY_TYPES.XOVER4,
            constant_module_1.Enums.FREQUENCY_TYPES.XOVER10
        ];
        vm.discardMoldOptions = [{ name: true, value: 'YES' }, { name: false, value: 'NO' }, { name: undefined, value: 'N/A' }];
        vm.setMoldLossOptions = function () {
            var _this = this;
            plantService.getPlants().then(function (plants) {
                _this.plants = plants;
                _this.selectedPlant = _this.plants.filter(function (p) { return p.id === data.plantId; })[0];
                vm.moldLossEquipments = [];
                if (_this.selectedPlant.name === 'Lawrenceburg') {
                    vm.moldLossEquipments.push({
                        value: undefined,
                        text: 'N/A'
                    });
                }
                equipmentService.getShop(_this.shopId)
                    .then(function (activeEquipment) {
                    if (activeEquipment.some(function (e) { return e.type === aps_enums_1.apsEnums.EquipmentType.Multi; })) {
                        vm.moldLossEquipments.push({
                            value: aps_enums_1.apsEnums.EquipmentType.Multi,
                            text: 'Multi'
                        });
                    }
                    if (activeEquipment.some(function (e) { return e.type === aps_enums_1.apsEnums.EquipmentType.MX4; })) {
                        vm.moldLossEquipments.push({
                            value: aps_enums_1.apsEnums.EquipmentType.MX4,
                            text: 'MX4'
                        });
                    }
                    if (activeEquipment.some(function (e) { return e.type === aps_enums_1.apsEnums.EquipmentType.FlexM; })) {
                        vm.moldLossEquipments.push({
                            value: aps_enums_1.apsEnums.EquipmentType.FlexM,
                            text: 'FlexM'
                        });
                    }
                    if (activeEquipment.some(function (e) { return e.type === aps_enums_1.apsEnums.EquipmentType.WBF; }) && _this.selectedPlant.name !== 'Elmira') {
                        vm.moldLossEquipments.push({
                            value: aps_enums_1.apsEnums.EquipmentType.WBF,
                            text: 'WBF'
                        });
                    }
                    if (vm.moldLossEquipments.length > 0) {
                        vm.moldLossEquipment = vm.moldLossEquipments[0].value;
                    }
                });
            });
        };
        plantService.getPlatFeatureSettings($stateParams.plantId)
            .then(function (tmpDat) {
            if (tmpDat && tmpDat.config) {
                var tmp = JSON.parse(tmpDat.config);
                var userRoleLocation = authDataService.getSelectedRoleLocation();
                if (tmp && tmp.moldLoss && tmp.moldLoss.shops) {
                    vm.throwSelectEquipmentError = false;
                    vm.showMoldLoss = (_.includes(tmp.moldLoss.shops, '*') || _.includes(tmp.moldLoss.shops, vm.shopId))
                        && (_.includes(tmp.moldLoss.roles, '*') || _.includes(tmp.moldLoss.roles, userRoleLocation.role.roleId));
                    if (vm.showMoldLoss) {
                        vm.setMoldLossOptions();
                        vm.discardMold = true;
                        vm.discardInvalidMolds = undefined;
                        vm.throwSelectEquipmentError = true;
                    }
                }
            }
        });
        vm.gobs = function () {
            if (vm.section) {
                return vm.section.gobs;
            }
            return [];
        };
        vm.molds = function () {
            var molds = [];
            _.forEach(vm.sections, function (section) {
                _.forEach(section.gobs, function (gob) {
                    molds.push(gob.moldOnDate(vm.timeFound));
                });
            });
            return molds;
        };
        vm.sectionChanged = function () {
            if (vm.section) {
                vm.gob = _.find(vm.section.gobs, { name: vm.lastGob.name });
                vm.lastGob = vm.gob;
                vm.mold = vm.gob.moldOnDate(vm.timeFound);
            }
        };
        vm.gobChanged = function () {
            vm.lastGob = vm.gob;
            vm.mold = vm.gob.moldOnDate(vm.timeFound);
        };
        vm.moldChanged = function () {
            _.forEach(vm.sections, function (section) {
                _.forEach(section.gobs, function (gob) {
                    if (vm.mold === gob.moldOnDate(vm.timeFound)) {
                        vm.section = section;
                        vm.gob = gob;
                        vm.lastGob = gob;
                        return false;
                    }
                    return true;
                });
            });
        };
        vm.frequencyTypeChanged = function () {
            switch (vm.frequencyType) {
                case constant_module_1.Enums.FREQUENCY_TYPES.XOVER4:
                    vm.frequencyPercent = undefined;
                    vm.frequencyTotal = 4;
                    break;
                case constant_module_1.Enums.FREQUENCY_TYPES.XOVER10:
                    vm.frequencyPercent = undefined;
                    vm.frequencyTotal = 10;
                    break;
                default:
                    vm.frequencyPercent = undefined;
                    vm.frequencyTotal = undefined;
                    break;
            }
        };
        vm.isCount = function () {
            return vm.frequencyType
                && vm.frequencyType.id !== aps_enums_1.apsEnums.FrequencyType.Percentage
                && vm.frequencyType.id !== aps_enums_1.apsEnums.FrequencyType.None;
        };
        vm.isPercentage = function () {
            return vm.frequencyType && vm.frequencyType.id === aps_enums_1.apsEnums.FrequencyType.Percentage;
        };
        vm.isPSI = function () {
            return vm.frequencyType && vm.frequencyType.id === aps_enums_1.apsEnums.FrequencyType.PSI;
        };
        vm.isThermal = function () {
            return vm.frequencyType && vm.frequencyType.id === aps_enums_1.apsEnums.FrequencyType.ThermalShock;
        };
        vm.isPsiOrThermal = function () {
            return vm.frequencyType && (vm.frequencyType.id === aps_enums_1.apsEnums.FrequencyType.PSI
                || vm.frequencyType.id === aps_enums_1.apsEnums.FrequencyType.ThermalShock);
        };
        vm.shopId = vm.activity.id;
        vm.lastGob = data.gob;
        if (!vm.machineLevel) {
            vm.section = data.gob.section;
            vm.gob = data.gob;
            vm.mold = data.gob.moldOnDate(vm.timeFound);
        }
        function filterDefectTypes(defectType) {
            return (!defectType) ||
                (!vm.classification ||
                    defectType.classification === vm.classification) &&
                    (vm.defectFilter.length === 0 ||
                        defectType.name.toLowerCase().indexOf(vm.defectFilter.toLowerCase()) > -1 ||
                        (defectType.legacyId && _.startsWith(defectType_1.padLegacyId(defectType.legacyId), vm.defectFilter)));
        }
        vm.filteredDefectTypes = function () {
            var defectTypes = _.filter(vm.defectTypes, filterDefectTypes);
            if (vm.isEquipmentFailure) {
                defectTypes = _.filter(defectTypes, function (dt) { return dt.legacyId > 1999 && dt.legacyId < 3000; });
            }
            else {
                defectTypes = _.filter(defectTypes, function (dt) { return dt.legacyId < 2000 || dt.legacyId > 2999; });
            }
            if (vm.machineLevel) {
                return defectTypes.filter(function (x) { return x.entireMachine === true; });
            }
            else {
                return defectTypes.filter(function (x) { return x.entireMachine === false; });
            }
        };
        vm.defectTypeChanged = function () {
            if (vm.defectTypeId) {
                var defect = vm.defectTypes.filter(function (x) { return x.id === vm.defectTypeId; });
                vm.isCritical = defect.length > 0
                    && (defect[0].severity === aps_enums_1.apsEnums.Severity.Critical || defect[0].severity === aps_enums_1.apsEnums.Severity.Major);
                var defectDefaultSize = defect[0].defaultInspectionSampleSize;
                vm.frequencyType = (defectDefaultSize === 10) ? constant_module_1.Enums.FREQUENCY_TYPES.XOVER10
                    : (defectDefaultSize === 4 ? constant_module_1.Enums.FREQUENCY_TYPES.XOVER4
                        : constant_module_1.Enums.FREQUENCY_TYPES.COUNT);
                vm.frequencyTypeChanged();
            }
            else {
                vm.isCritical = false;
            }
        };
        var jobRun = _.find(vm.activity.jobRuns, function (jr) { return jr.startDate <= vm.timeFound && (!jr.endDate || vm.timeFound < jr.endDate); });
        defectTypeService.getDefectTypesAndClassifications()
            .then(function (defectTypeData) {
            if (jobRun && jobRun.excludedDefectTypeIds && jobRun.excludedDefectTypeIds.length > 0) {
                defectTypeData.types = _.filter(defectTypeData.types, function (dt) { return _.every(jobRun.excludedDefectTypeIds, function (xt) { return xt !== dt.id; }); });
            }
            _.forEach(defectTypeData.types, function (type) {
                if (jobRun && type.wareClasses) {
                    var override = _.find(type.wareClasses, function (w) { return w.wareClassId === jobRun.wareClassId; });
                    if (override && override.severity !== null) {
                        type.severity = override.severity;
                    }
                }
            });
            vm.defectTypes = defectTypeData.types;
            vm.classifications = defectTypeData.classifications;
        });
        defectService.getDefectEquipment()
            .then(function (data) {
            vm.equipmentList = data;
        });
        vm.drawDefect = function (x, y) {
            var img = new Image();
            img.className = 'defect-mark';
            img.id = defectMarkIdentifier;
            img.style.position = 'absolute';
            var wrappedbottle = angular.element('#' + bottleIdentifier);
            if (wrappedbottle && wrappedbottle[0]) {
                img.style.left = (wrappedbottle[0].offsetLeft + x - 5) + 'px';
                img.style.top = (wrappedbottle[0].offsetTop + y + 12) + 'px';
            }
            var defect = document.getElementById(defectMarkIdentifier);
            if (defect != null) {
                defect.parentNode.removeChild(defect);
            }
            wrappedbottle.append(img);
        };
        vm.addOnClick = function (event) {
            vm.locationX = event.offsetX;
            vm.locationY = event.offsetY;
            vm.drawDefect(vm.locationX, vm.locationY);
        };
        vm.equipmentFailureClick = function () {
            if (vm.isEquipmentFailure === false) {
                vm.isEquipmentFailure = true;
            }
            else {
                vm.isEquipmentFailure = false;
            }
            vm.filteredDefectTypes();
        };
        vm.changeMachineLevel = function () {
            vm.filteredDefectTypes();
        };
        var id, commentId, userData, moldLossId;
        $q.all([
            authService.getUserData().then(function (x) { return userData = x; }),
            newGuidService.getNewGuid('defect').then(function (x) { return id = x; }),
            newGuidService.getNewGuid('defectComment').then(function (x) { return commentId = x; }),
            newGuidService.getNewGuid('moldLoss').then(function (x) { return moldLossId = x; })
        ]).then(function () { return vm.readyForSubmit = true; });
        vm.addDefect = function () {
            var _this = this;
            if (!vm.readyForSubmit || vm.form.$invalid) {
                return;
            }
            var roleLocation = authDataService.getSelectedRoleLocation();
            var cmd = {
                id: id,
                shopId: vm.shopId,
                isMachineId: vm.machineLevel ? vm.machine.id : vm.section.machine.id,
                machineLevelDrop: vm.machineLevel && vm.machineLevelDrop ? vm.machineLevelDrop.gobNumber : undefined,
                section: !vm.machineLevel ? vm.section.sectionNumber : undefined,
                gob: !vm.machineLevel ? vm.gob.gobNumber : undefined,
                toolNumber: vm.mold ? vm.mold.toolNumber : undefined,
                currentRoleId: roleLocation.role.roleId,
                defectTypeId: vm.defectTypeId,
                isMoldRejectInUse: vm.isMoldRejectInUse,
                timeFound: vm.timeFound,
                locationX: vm.locationX,
                locationY: vm.locationY,
                comment: vm.defectComment,
                commentId: vm.defectComment ? commentId : undefined,
                frequencyType: vm.frequencyType && vm.frequencyTotal ? aps_enums_1.apsEnums.FrequencyType.Count : aps_enums_1.apsEnums.FrequencyType.None,
                frequencyCount: vm.frequencyCount,
                frequencyTotal: vm.frequencyTotal,
                frequencyPercent: vm.frequencyPercent,
                equipmentId: vm.equipment ? vm.equipment.id : undefined,
                isEquipmentFailure: vm.isEquipmentFailure,
                moldLossEquipment: vm.isMoldRejectInUse ? vm.moldLossEquipment : undefined
            };
            var defectType = _.find(vm.defectTypes, { id: vm.defectTypeId });
            var severity = defectType.severity;
            if (defectType.criticalThreshold !== null) {
                var percent = 0;
                if (cmd.frequencyType === aps_enums_1.apsEnums.FrequencyType.Count) {
                    percent = cmd.frequencyCount / cmd.frequencyTotal;
                }
                else if (cmd.frequencyType === aps_enums_1.apsEnums.FrequencyType.Percentage) {
                    percent = cmd.frequencyPercent / 100;
                }
                if (percent >= defectType.criticalThreshold) {
                    severity = aps_enums_1.apsEnums.Severity.Critical;
                }
            }
            var moldLoss = {
                id: moldLossId,
                defectId: id,
                plantId: $stateParams.plantId,
                critical: severity === aps_enums_1.apsEnums.Severity.Critical ? "Yes" : "No",
                isRejectInvalidMolds: vm.discardInvalidMolds,
                isRejectMold: vm.discardMold,
                shopId: vm.shopId,
                moldId: vm.mold && vm.mold.toolNumber ? vm.mold.toolNumber.toString() : undefined,
                reason: defectType.name,
                requestedByUserId: $stateParams.userId,
                section: vm.section ? vm.section.sectionNumber : undefined,
                gob: vm.gob ? vm.gob.gobNumber : undefined,
                gobName: vm.gob ? vm.gob.name : undefined
            };
            var event = {
                id: cmd.id,
                plantId: undefined,
                shopId: cmd.shopId,
                isMachineId: cmd.isMachineId,
                machineLevelDrop: cmd.machineLevelDrop,
                dropName: vm.machineLevel && vm.machineLevelDrop ? vm.machineLevelDrop.name : undefined,
                section: cmd.section,
                gob: cmd.gob,
                gobName: !vm.machineLevel ? vm.gob.name : undefined,
                toolNumber: cmd.toolNumber,
                defectTypeId: cmd.defectTypeId,
                jobRunId: undefined,
                isMoldRejectInUse: cmd.isMoldRejectInUse,
                isEquipmentFailure: cmd.isEquipmentFailure,
                timeFound: cmd.timeFound,
                rejectStart: cmd.isMoldRejectInUse ? new Date() : undefined,
                maintenanceStart: cmd.isEquipmentFailure ? new Date() : undefined,
                severity: severity,
                frequencyType: cmd.frequencyType,
                frequencyCount: cmd.frequencyCount,
                frequencyTotal: cmd.frequencyTotal,
                frequencyPercent: cmd.frequencyPercent,
                equipmentId: cmd.equipmentId,
                locationX: cmd.locationX,
                locationY: cmd.locationY,
                createdByFullName: userData.fullName,
                name: defectType.name,
                abbreviation: defectType.abbreviation,
                defectTypeLegacyId: defectType.legacyId,
                comments: [],
                userId: userData.id,
                eventDate: new Date(),
                moldLossEquipment: cmd.moldLossEquipment
            };
            if (cmd.comment) {
                var comment = cmd.comment;
                event.comments = [{
                        id: cmd.comment,
                        plantId: undefined,
                        shopId: cmd.shopId,
                        isMachineId: cmd.isMachineId,
                        section: cmd.section,
                        gob: cmd.gob,
                        defectId: cmd.id,
                        timeFound: cmd.timeFound,
                        comment: comment,
                        createdByFullName: event.createdByFullName,
                        gobName: event.gobName,
                        abbreviation: event.abbreviation,
                        defectTypeLegacyId: event.defectTypeLegacyId,
                        severity: event.severity,
                        userId: event.userId,
                        eventDate: event.eventDate
                    }];
            }
            loaderService.loadingPromise(defectService.addDefect(cmd)
                .then(function () {
                if (vm.isMoldRejectInUse) {
                    if ((vm.moldLossEquipment == null || vm.moldLossEquipment == undefined) && vm.throwSelectEquipmentError) {
                        _this.notifyService.error('Please select an equipment for Auto Mold rejection');
                        return;
                    }
                    defectService.addMoldLoss(moldLoss);
                }
                $modalInstance.close({ command: cmd, event: event });
            }, notifyService.handleApiErrors));
        };
        vm.cancel = function () {
            $modalInstance.close();
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=add-defect> <h2 class=modal-header style=margin-top:-50px>Add a Defect</h2> <form name=vm.form ng-submit=vm.addDefect() novalidate> <div class=container> <div class=add-defect-l id=defectBottleID ng-click=vm.addOnClick($event)> <img class=\"full-bottle bottle-selector\"> <p>Select Defect <br>Location</p> </div> <div class=add-defect-r> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-4 columns\"> <label> <input type=checkbox ng-model=vm.machineLevel ng-click=vm.changeMachineLevel() disabled=disabled /> Machine Level Defect </label> </div> <div style=display:inline-block ng-if=\"vm.showMaintCheckbox && vm.machineLevel\"> <label> <input type=checkbox ng-click=vm.equipmentFailureClick() /> Equipment Failure </label> </div> <div class=\"small-4 columns\"> <label ng-if=vm.machineLevel> Drop: <select name=machineLevelDrop ng-model=vm.machineLevelDrop ng-options=\"x.name for x in vm.drops\"> <option value=\"\">-- Select a Drop --</option> </select> </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\" ng-if=!vm.machineLevel> <div class=\"small-4 columns\"> <label> Section: <select name=section ng-model=vm.section ng-options=\"cls.name for cls in vm.sections\" ng-change=vm.sectionChanged() required> <option value=\"\">-- Select a Section --</option> </select> <div ng-messages=vm.form.section.$error ng-if=\"vm.form.section.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-4 columns\"> <label> Gob: <select name=gob ng-model=vm.gob ng-options=\"cls.name for cls in vm.gobs()\" ng-change=vm.gobChanged() required> <option value=\"\">-- Select a Gob --</option> </select> <div ng-messages=vm.form.gob.$error ng-if=\"vm.form.gob.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-4 columns\"> <label> Mold: <select name=mold ng-model=vm.mold ng-options=\"mold.toolNumber for mold in vm.molds()\" ng-change=vm.moldChanged() required> <option value=\"\">-- Select a Mold --</option> </select> <div ng-messages=vm.form.mold.$error ng-if=\"vm.form.mold.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-8 columns\"> <div class=\"small-6 columns\" style=padding-left:0> <label> Location: <select ng-model=vm.classification id=DefectClassificationSelect ng-options=\"cls.name for cls in vm.classifications | orderBy: 'name'\"> <option value=\"\">-- Select to Filter Defects --</option> </select> </label> </div> <div class=\"small-6 columns\"> <label> Filter: <input type=text ng-model=vm.defectFilter /> </label> </div> <div class=\"small-6 columns\" style=padding-left:0> <label> Time Found: <input name=timeFound type=datetime-local ng-model=vm.timeFoundLocal min=\"{{vm.minTime}}\" max=\"{{vm.maxTime}}\" required time-zone=vm.timeZone time-model=vm.timeFound single-hour=true date-time-picker/> <div ng-messages=vm.form.timeFound.$error ng-if=\"vm.form.timeFound.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be within the hour</div> <div ng-message=max class=req-w><div class=arrow-up></div>Must be within the hour</div> </div> </label> </div> <div class=\"small-6 columns\" ng-if=\"!vm.machineLevel && !vm.isEquipmentFailure\"> <label style=position:relative;top:28px> <input type=checkbox ng-model=vm.isMoldRejectInUse /> Is Mold Reject In Use? </label> </div> <div class=\"small-6 columns\" ng-if=\"vm.machineLevel || vm.isEquipmentFailure\"> &nbsp; </div> </div> <div class=\"small-4 columns\"> <label> <span class=\"required notated\">*</span>Defect: <select name=defectType ng-model=vm.defectTypeId data-ng-attr-size=\"{{ vm.defectTypeSelectSize }}\" ng-change=vm.defectTypeChanged() required> <option value=\"\">-- Select a Defect --</option> <option ng-repeat=\"dt in vm.filteredDefectTypes() | orderBy: 'name'\" value=\"{{ dt.id }}\" ng-class=\"{ 'defect-severity-0' : dt.severity === 0, 'defect-severity-1' : dt.severity === 1, 'defect-severity-2' : dt.severity === 2, 'defect-severity-3' : dt.severity === 3 }\"> {{ dt.listName }} </option> </select> <div ng-messages=vm.form.defectType.$error ng-if=\"vm.form.defectType.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns\"> <label> <span class=\"required notated\" ng-if=vm.isCritical>*</span>Where Found: <select ng-model=vm.equipment id=Equipment name=equipment ng-options=\"equip.name for equip in vm.equipmentList | orderBy: 'name'\" ng-required=vm.isCritical> <option value=\"\"></option> </select> <div ng-messages=vm.form.equipment.$error ng-if=\"vm.form.equipment.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-2 columns\"> <div><label>Frequency: </label> <div style=line-height:2.2em;font-weight:500>{{vm.frequencyType.name}}</div> </div> </div> <div class=\"small-3 columns\"> <label> <span class=\"required notated\" ng-if=\"vm.frequencyType.name!='Count'\">*</span># Defects Found: <input name=count type=number ng-model=vm.frequencyCount ng-required=\"vm.frequencyType.name!='Count'\" min=0 max=\"{{vm.frequencyTotal}}\"/> <div ng-messages=vm.form.count.$error ng-if=\"vm.form.count.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be more than 0</div> <div ng-message=max class=req-w><div class=arrow-up></div>Must be less than {{vm.frequencyTotal}}</div> </div> </label> </div> <div class=\"small-3 columns\"> <label> <span class=\"required notated\" ng-if=\"vm.frequencyType.name!='Count'\">*</span><span>Total # Examined:</span> <input name=total type=number ng-model=vm.frequencyTotal ng-required=\"vm.frequencyType.name!='Count'\" ng-disabled=\"vm.frequencyType.name!='Count'\"/> <div ng-messages=vm.form.total.$error ng-if=\"vm.form.total.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\" ng-if=\"!vm.machineLevel && !vm.isEquipmentFailure && vm.showMoldLoss && vm.isMoldRejectInUse\"> <div class=\"small-12 columns\" style=float:left> <fieldset style=\"border:1px #ccc solid;border-radius:5px;margin-inline-start:0;padding-block-start:0;padding-inline-start:0;margin-inline-end:0;padding-block-end:0\"> <legend style=margin-left:1em;padding:0;font-size:.875rem;font-weight:400>Mold Loss</legend> <!-- ng-options=\"equip.name for equip in vm.equipmentList | orderBy: 'name'\" --> <div class=\"small-4 columns\" style=padding-left:100px> <label> Equipment &nbsp; <select ng-model=vm.moldLossEquipment name=moldLossEquipment id=moldLossEquipment ng-required=vm.isMoldRejectInUse> <option ng-repeat=\"types in vm.moldLossEquipments | orderBy : 'text'\" ng-value=\"{{types.value}}\">{{types.text}}</option> </select> <div ng-messages=vm.form.moldLossEquipment.$error ng-if=\"vm.form.moldLossEquipment.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-4 columns\" style=padding-left:100px> <label> Discard Mold <strong>{{vm.mold.toolNumber}} </strong> &nbsp; <select ng-model=vm.discardMold id=discardMold style=width:60px ng-required=vm.discardMold> <option ng-repeat=\"o in vm.discardMoldOptions\" ng-value=o.name>{{o.value}}</option> </select> </label> </div> <div class=\"small-4 columns\"> <label> Discard All Invalid Molds <select ng-model=vm.discardInvalidMolds id=dicardInvalidMold style=width:60px ng-required=vm.discardInvalidMolds> <option ng-repeat=\"o in vm.discardMoldOptions\" ng-value=o.name>{{o.value}}</option> </select> </label> </div> </fieldset> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-12 columns\"> <label for=comment>Comment:</label> <textarea name=comment ng-model=vm.defectComment rows=4></textarea> <div ng-messages=vm.form.comment.$error ng-if=\"vm.form.comment.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-12 columns\"> <span class=required>* Required Fields</span> <div class=\"right dialog-footer\"> <button type=submit class=button ng-disabled=!vm.readyForSubmit> Add Defect </button> <button type=button class=\"button secondary\" value=Cancel ng-click=vm.cancel()> Cancel </button> </div> </div> </div> </div> </div> </form> </div> ");

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(6), __webpack_require__(4), __webpack_require__(755), __webpack_require__(11), __webpack_require__(9), __webpack_require__(5), __webpack_require__(2), __webpack_require__(756)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, notify_service_1, loader_service_1, jobChange_service_1, dateutility_service_1, uiUtility_service_1, aps_enums_1, _, addJobChange_tpl_html_1) {
    "use strict";
    addJobChangeCtrl.$inject = ["$modalInstance", "data", "notifyService", "loaderService", "jobChangeService", "uiUtilityService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [notify_service_1.default, loader_service_1.default, jobChange_service_1.default, uiUtility_service_1.default];
    exports.default = angular.module('aps.controller.addJobChange', requires)
        .controller('AddJobChangeCtrl', addJobChangeCtrl)
        .name;
    function openAddJobChange(data, $modal) {
        return $modal.open({
            template: addJobChange_tpl_html_1.default,
            controller: 'AddJobChangeCtrl as vm',
            resolve: {
                data: function () {
                    return data;
                }
            }
        }).result;
    }
    exports.openAddJobChange = openAddJobChange;
    function addJobChangeCtrl($modalInstance, data, notifyService, loaderService, jobChangeService, uiUtilityService) {
        'use strict';
        var vm = this;
        vm.gob = data.gob;
        vm.shopId = data.shopId;
        vm.activity = data.activity;
        vm.timeZone = vm.activity.timeZoneId;
        vm.section = vm.gob.section;
        vm.machine = vm.section.machine;
        vm.sections = vm.machine.sections;
        vm.gobs = _.first(vm.sections).gobs;
        vm.range = dateutility_service_1.default.getHourRange(data.hour.startTime, vm.timeZone);
        vm.timeChanged = vm.range.initialTime.toDate();
        vm.jobChangeTypes = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.JobChangeType, 1);
        vm.selections = [];
        vm.addJobChangeCommand = {
            shopId: vm.shopId,
            isMachineId: vm.machine.id,
            jobRunId: data.hour.jobRun.id,
            type: undefined,
            endTime: vm.timeChanged,
            duration: undefined,
            details: []
        };
        vm.displaySectionsGobsAndMolds = function () {
            return !vm.addJobChangeCommand.type ||
                vm.addJobChangeCommand.type !== aps_enums_1.apsEnums.JobChangeType.Finish;
        };
        vm.validateMoldNumbers = function () {
            if (!vm.displaySectionsGobsAndMolds()) {
                return true;
            }
            var moldNumbers = [];
            _.forEach(vm.selections, function (selection) {
                _.forEach(selection.gobs, function (gobSelection) {
                    moldNumbers.push({ moldNumber: gobSelection.moldNumber });
                });
            });
            return _.uniq(_.map(moldNumbers, function (x) { return JSON.stringify(x); })).length === moldNumbers.length;
        };
        _.forEach(vm.sections, function (section) {
            var sectionSelection = {
                section: section,
                gobs: []
            };
            _.forEach(section.gobs, function (gob) {
                sectionSelection.gobs.push({
                    gob: gob,
                    currentMold: ''
                });
            });
            vm.selections.push(sectionSelection);
        });
        var fillJobChangeDetails = function () {
            vm.addJobChangeCommand.details = [];
            if (!vm.displaySectionsGobsAndMolds()) {
                return;
            }
            _.forEach(vm.selections, function (selection) {
                var section = selection.section.sectionNumber;
                _.forEach(selection.gobs, function (gobSelection) {
                    var gob = gobSelection.gob.gobNumber;
                    if (section > 0 || gob > 0) {
                        vm.addJobChangeCommand.details.push({
                            section: section,
                            gob: gob,
                            moldNumber: gobSelection.moldNumber
                        });
                    }
                });
            });
        };
        vm.addJobChange = function () {
            if (vm.form.$invalid || vm.validateMoldNumbers() === false) {
                return false;
            }
            fillJobChangeDetails();
            var promise = jobChangeService.addJobChange(vm.addJobChangeCommand)
                .then(function () {
                $modalInstance.close(true);
            }, notifyService.handleApiErrors);
            loaderService.loadingPromise(promise);
        };
        vm.cancel = function () {
            $modalInstance.close();
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var JobChangeSvc = (function () {
        JobChangeSvc.$inject = ["httpService"];
        function JobChangeSvc(httpService) {
            this.httpService = httpService;
        }
        JobChangeSvc.prototype.addJobChange = function (addJobChangeCommand) {
            return this.httpService.put(constant_module_1.Endpoints.JOB_CHANGE_ADD, addJobChangeCommand);
        };
        return JobChangeSvc;
    }());
    exports.default = angular
        .module('aps.services.jobChange', [http_service_1.default])
        .service('jobChangeService', JobChangeSvc)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=addJobChange> <h2 class=modal-header>Job Change</h2> <form name=vm.form ng-submit=vm.addJobChange() novalidate> <div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-4 columns\"> <label> Type: <select name=jobChangeType ng-model=vm.addJobChangeCommand.type ng-options=\"cls.value as cls.text for cls in vm.jobChangeTypes\" required tabindex=1> <option value=\"\">-- Select a Type --</option> </select> <div ng-messages=vm.form.jobChangeType.$error ng-if=\"vm.form.jobChangeType.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-4 columns\"> <label> Duration: <input name=duration type=number ng-model=vm.addJobChangeCommand.duration required min=1 tabindex=2 /> <div ng-messages=vm.form.duration.$error ng-if=\"vm.form.duration.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>Too small</div> </div> </label> </div> <div class=\"small-4 columns\"> <label> Time Changed: <input name=endTime type=datetime-local required date-time-picker ng-model=vm.addJobChangeCommand.endTimeLocal min=\"{{vm.range.minTime}}\" max=\"{{vm.range.maxTime}}\" time-model=vm.addJobChangeCommand.endTime time-zone=vm.timeZone single-hour=true tabindex=3 /> <div ng-messages=vm.form.endTime.$error ng-if=\"vm.form.timeChanged.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be within the hour</div> <div ng-message=max class=req-w><div class=arrow-up></div>Must be within the hour</div> </div> </label> </div> </div> <table class=mold-selection ng-if=vm.displaySectionsGobsAndMolds() style=font-size:.65em> <thead> <tr> <th>&nbsp;</th> <th colspan=\"{{vm.selections.length}}\">Line</th> </tr> <tr> <th>&nbsp;</th> <th ng-repeat=\"selection in vm.selections\"> {{selection.section.name}} </th> </tr> </thead> <tbody> <tr ng-repeat=\"gob in vm.gobs\"> <th width=5%>{{gob.name}}</th> <td ng-repeat=\"selection in vm.selections\" style=padding:5px> <ng-form name=moldForm> <input name=mold style=\"margin:5px 0;width:50px;display:inline\" type=number min=1 max=256 step=1 ng-model=selection.gobs[$parent.$index].moldNumber required tabindex=\"{{ 4 + 3 * $index + $parent.$index }}\"/> <div ng-messages=moldForm.mold.$error ng-if=\"moldForm.mold.$dirty || moldForm.mold.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be between 1 and 256</div> <div ng-message=max class=req-w><div class=arrow-up></div>Must be between 1 and 256</div> <div ng-message=step class=req-w><div class=arrow-up></div>Must be an integer</div> </div> </ng-form> </td> </tr> </tbody> </table> <div ng-if=\"vm.validateMoldNumbers() === false && vm.form.$submitted\"> <div class=req-w><div class=arrow-up></div>All Mold Numbers must be unique numbers</div> </div> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-12 columns\"> <div class=dialog-footer> <input type=submit class=button value=\"Add Job Change\" tabindex=100 /> </div></div></div></form> <button type=button class=\"button secondary\" value=Close ng-click=vm.cancel() tabindex=101>Close</button> </div> ");

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(758), __webpack_require__(11), __webpack_require__(4), __webpack_require__(6), __webpack_require__(759), __webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, addRequalification_tpl_html_1, dateutility_service_1, loader_service_1, notify_service_1, requalification_service_1, authData_service_1) {
    "use strict";
    addRequalificationCtrl.$inject = ["$modalInstance", "loaderService", "notifyService", "requalificationService", "data", "authDataService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, notify_service_1.default, requalification_service_1.default, authData_service_1.default];
    exports.default = angular.module('aps.controller.requalification', requires)
        .controller('AddRequalificationCtrl', addRequalificationCtrl)
        .name;
    function openAddRequalification(data, $modal) {
        return $modal.open({
            template: addRequalification_tpl_html_1.default,
            controller: 'AddRequalificationCtrl as vm',
            resolve: {
                data: function () {
                    return data;
                }
            }
        }).result;
    }
    exports.openAddRequalification = openAddRequalification;
    function addRequalificationCtrl($modalInstance, loaderService, notifyService, requalificationService, data, authDataService) {
        var vm = this;
        vm.shopId = data.shopId;
        vm.activity = data.activity;
        vm.gob = data.gob;
        vm.section = vm.gob.section;
        vm.machine = vm.section.machine;
        vm.sections = vm.machine.sections;
        vm.gobs = _.first(vm.sections).gobs;
        vm.timeZone = vm.activity.timeZoneId;
        vm.hourRange = dateutility_service_1.default.getHourRange(data.date, vm.activity.timeZoneId);
        vm.requalificationDateTime = vm.hourRange.initialTime.toDate();
        var getCurrentMold = function (gob) {
            return function () {
                var mold = gob.moldOnDate(vm.requalificationDateTime);
                return mold ? mold.toolNumber : '';
            };
        };
        var selections = [];
        _.forEach(vm.sections, function (section) {
            var sectionSelection = {
                section: section,
                gobs: [],
                selected: data.section === section
            };
            _.forEach(section.gobs, function (gob) {
                sectionSelection.gobs.push({
                    gob: gob,
                    currentMold: getCurrentMold(gob),
                    selected: data.gob === gob
                });
            });
            selections.push(sectionSelection);
        });
        vm.selections = selections;
        vm.setOut = (vm.gob.gobNumber || 0) <= 0;
        vm.cause = '';
        vm.isSelectionValid = function () {
            if (vm.setOut) {
                return true;
            }
            var result = false;
            _.forEach(vm.selections, function (sectionSelection) {
                if (sectionSelection.selected) {
                    result = true;
                    return false;
                }
                _.forEach(sectionSelection.gobs, function (gobSelection) {
                    if (gobSelection.selected) {
                        result = true;
                        return false;
                    }
                });
            });
            return result;
        };
        vm.addRequalification = function () {
            if (vm.form.$invalid || !vm.isSelectionValid()) {
                return;
            }
            var role = authDataService.getSelectedRoleLocation().role;
            var command = {
                shopId: vm.shopId,
                machineId: vm.machine.id,
                requalificationDateTime: vm.requalificationDateTime,
                location: role.roleLocation,
                cause: vm.cause,
                entireMachine: vm.setOut,
                machineLocations: []
            };
            if (!vm.setOut) {
                _.forEach(vm.selections, function (sectionSelection) {
                    if (sectionSelection.selected) {
                        command.machineLocations.push({
                            id: undefined,
                            section: sectionSelection.section.sectionNumber,
                            gob: null,
                            skip: false
                        });
                    }
                    else {
                        _.forEach(sectionSelection.gobs, function (gobSelection) {
                            if (gobSelection.selected) {
                                command.machineLocations.push({
                                    id: undefined,
                                    section: sectionSelection.section.sectionNumber,
                                    gob: gobSelection.gob.gobNumber,
                                    skip: false
                                });
                            }
                        });
                    }
                });
            }
            var promise = requalificationService.addRequalification(command)
                .then(function () {
                $modalInstance.close();
            }, notifyService.handleApiErrors);
            loaderService.loadingPromise(promise);
        };
        vm.cancel = function () {
            $modalInstance.close();
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <form name=vm.form ng-submit=vm.addRequalification() novalidate> <h2 class=modal-header>Add Requalification</h2> <div class=\"container tabbed-view-w\"> <div class=center> <table class=mold-selection> <thead> <tr> <th>&nbsp</th> <th colspan=\"{{ vm.selections.length }}\">Sections</th> </tr> </thead> <tbody> <tr> <th> <button type=button class=\"button button-small\" ng-model=vm.setOut btn-checkbox> Set out </button> </th> <th ng-repeat=\"selection in vm.selections\"> <button type=button class=\"button button-small\" ng-model=selection.selected btn-checkbox> {{ selection.section.name }} </button> </th> </tr> <thead> <tr> <th>&nbsp;</th> <th colspan=\"{{ vm.selections.length }}\">Gobs</th> </tr> </thead> <tbody> <tr ng-repeat=\"gob in vm.gobs\"> <th>{{ gob.name }}</th> <td ng-repeat=\"selection in vm.selections\"> <button type=button class=\"button button-small\" ng-model=selection.gobs[$parent.$index].selected btn-checkbox> {{ selection.gobs[$parent.$index].currentMold() }} </button> </td> </tr> </tbody> </tbody></table> <div ng-if=!vm.isSelectionValid() class=req-w><div class=arrow-up></div> Please select Set Out or at least one section or gob </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-12 columns\"> <label> Requalification Time: <input name=requalificationDateTime type=datetime-local ng-model=vm.requalificationDateTimeLocal min=\"{{vm.hourRange.minTime}}\" max=\"{{vm.hourRange.maxTime}}\" required date-time-picker time-model=vm.requalificationDateTime time-zone=vm.timeZone single-hour=true /> <div ng-messages=vm.form.requalificationDateTime.$error ng-if=\"vm.form.requalificationDateTime.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be within the hour</div> <div ng-message=max class=req-w><div class=arrow-up></div>Must be within the hour</div> </div> </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <label class=\"small-12 columns\"> Comments/Cause: <textarea ng-model=vm.cause rows=4></textarea> </label> </div> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-12 columns\"> <div class=\"right dialog-footer\"> <button type=submit class=button>Add Requalification</button> <button type=button class=\"button secondary\" ng-click=vm.cancel()>Cancel</button> </div> </div> </div> </div> </form> </div>");

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [http_service_1.default];
    var RequalificationSvc = (function () {
        RequalificationSvc.$inject = ["httpService"];
        function RequalificationSvc(httpService) {
            this.httpService = httpService;
        }
        RequalificationSvc.prototype.addRequalification = function (requalification) {
            return this.httpService.post(constant_module_1.Endpoints.REQUALIFICATION, requalification);
        };
        return RequalificationSvc;
    }());
    exports.default = angular
        .module('aps.services.requalification', requires)
        .service('requalificationService', RequalificationSvc)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(4), __webpack_require__(6), __webpack_require__(47), __webpack_require__(11), __webpack_require__(761)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, loader_service_1, notify_service_1, toolChange_service_1, dateutility_service_1, viewToolChange_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, notify_service_1.default, toolChange_service_1.default];
    function openViewToolChange(data, $modal) {
        return $modal.open({
            template: viewToolChange_tpl_html_1.default,
            controller: 'ViewToolChangeCtrl as vm',
            resolve: {
                data: function () {
                    return data;
                }
            }
        }).result;
    }
    exports.openViewToolChange = openViewToolChange;
    var ViewToolChangeCtrl = (function () {
        ViewToolChangeCtrl.$inject = ["$modalInstance", "loaderService", "notifyService", "toolChangeService", "data"];
        function ViewToolChangeCtrl($modalInstance, loaderService, notifyService, toolChangeService, data) {
            this.$modalInstance = $modalInstance;
            this.loaderService = loaderService;
            this.notifyService = notifyService;
            this.toolChangeService = toolChangeService;
            this.data = data;
            this.timeZoneId = data.timeZoneId;
            var tool = data.toolChanges.tools[0];
            this.timeChangedString = tool.getTimeChanged();
            this.tools = data.toolChanges.tools;
            this.duration = tool.duration;
            this.createdBy = tool.createdByFullName;
            this.comments = data.toolChanges.comments;
            this.toolChangeId = tool.toolChangeId;
            this.readOnly = data.readOnly;
            this.canComment = data.canComment;
            this.canEdit = !data.readOnly && data.canEdit;
        }
        ViewToolChangeCtrl.prototype.close = function () {
            this.$modalInstance.close();
        };
        ViewToolChangeCtrl.prototype.deleteChange = function () {
            var _this = this;
            var promise = this.toolChangeService
                .deleteToolChange({ id: this.data.toolChanges.id })
                .then(function () {
                _this.$modalInstance.close({ action: 'delete' });
            }, this.notifyService.handleApiErrors);
            this.loaderService.loadingPromise(promise);
        };
        ViewToolChangeCtrl.prototype.edit = function () {
            this.$modalInstance.close({ action: 'edit' });
        };
        ViewToolChangeCtrl.prototype.addComment = function () {
            var _this = this;
            if (this.commentForm.$invalid) {
                return;
            }
            var command = {
                toolChangeId: this.toolChangeId,
                comment: this.comment
            };
            var promise = this.toolChangeService.addComment(command)
                .then(function () {
                _this.$modalInstance.close({ action: 'addComment', detail: command });
            }, this.notifyService.handleApiErrors);
            this.loaderService.loadingPromise(promise);
        };
        ViewToolChangeCtrl.prototype.formatTime = function (time) {
            return dateutility_service_1.default.formatTime(time, this.timeZoneId);
        };
        return ViewToolChangeCtrl;
    }());
    exports.ViewToolChangeCtrl = ViewToolChangeCtrl;
    exports.default = angular
        .module('aps.controller.viewToolChange', requires)
        .controller('ViewToolChangeCtrl', ViewToolChangeCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=view-tool-change> <h2 class=modal-header>Tool Change Detail</h2> <div class=container> <div class=center> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-4 columns\"> <label> Created By: <span ng-bind=vm.createdBy /> </label> </div> <div class=\"small-4 columns\"> <label> Time Changed: <span ng-bind=vm.timeChangedString /> </label> </div> <div class=\"small-4 columns\"> <label> Downtime (minutes): <span ng-bind=vm.duration /> </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <table class=tool-change-items> <thead> <tr> <th>Section</th> <th>Gob</th> <th>Tool</th> <th>No.</th> <th>Reason</th> <th>Defect</th> <th>Comment</th> </tr> </thead> <tbody> <tr ng-repeat=\"tc in vm.tools | orderBy: ['section', 'gob', 'toolName']\"> <td><span ng-bind=tc.getSectionName() /></td> <td><span ng-bind=tc.getGobName() /></td> <td><span ng-bind=tc.toolName /></td> <td><span ng-bind=tc.toolNumber /></td> <td><span ng-bind=tc.getReason() /></td> <td><span ng-bind=tc.defectTypeName /></td> <td><span type=text ng-bind=tc.comment style=width:70%;margin:0 /></td> </tr> </tbody> </table> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-6 columns\" ng-if=vm.canComment> <form name=vm.commentForm ng-submit=vm.addComment() novalidate> <label> New Comment: <textarea name=comment ng-model=vm.comment rows=4 cols=40 required></textarea> <div ng-messages=vm.commentForm.comment.$error ng-if=\"vm.commentForm.comment.$dirty || vm.commentForm.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> <label class=right> <input type=submit class=\"button small\" value=\"Add Comment\"/> </label> </form> </div> <div class=\"small-6 columns\"> <div ng-repeat=\"comment in vm.comments\" style=color:#fff;background:#1791cc;padding:8px;border-radius:5px;font-size:.75em;margin-bottom:8px;width:100%;float:left> <span ng-bind=comment.createdByFullName></span> <br> <span ng-bind=comment.comment></span> <span ng-bind=vm.formatTime(comment.createdOn) style=width:100%;float:left;clear:both;font-size:.65em;color:#98d1ec></span> </div> </div> </div> <div class=row style=\"margin:30px -30px -30px -45px;width:auto\"> <div class=\"small-12 columns\"> <div class=dialog-footer> <div class=left> <input type=button class=\"button alert\" value=Delete ng-click=vm.deleteChange() ng-if=!vm.readOnly /> </div> <div class=right> <input type=button class=\"button secondary\" value=Close ng-click=vm.close() /> <input type=button class=\"button primary\" value=Edit ng-click=vm.edit() ng-if=vm.canEdit /> </div> </div> </div> </div> </div> </div> </div>");

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var TempDataServiceImpl = (function () {
        function TempDataServiceImpl() {
            this.dataStore = {};
        }
        TempDataServiceImpl.prototype.getAndClearData = function (key) {
            var data = this.dataStore[key];
            if (data !== undefined) {
                delete this.dataStore[key];
                return data;
            }
            return undefined;
        };
        TempDataServiceImpl.prototype.setData = function (key, data) {
            this.dataStore[key] = data;
        };
        return TempDataServiceImpl;
    }());
    exports.default = angular
        .module('tempData', [])
        .service('tempDataService', TempDataServiceImpl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular) {
    "use strict";
    lineSheetHub.$inject = ["hubService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.hubs.lineSheet', ['aps.services.hubs'])
        .service('lineSheetHub', lineSheetHub)
        .name;
    function lineSheetHub(hubService) {
        function createLineSheetHubForReact(getActivity, setState, postConnect, shopId) {
            return hubService.createHub('lineSheet', {
                listeners: {
                    defectAdded: function (event) {
                        var activity = getActivity();
                        if (event.shopId !== activity.id) {
                            return;
                        }
                        activity.addDefectFromEvent(event);
                        setState(activity);
                    },
                    defectDeleted: function (event) {
                        var activity = getActivity();
                        if (event.shopId !== activity.id) {
                            return;
                        }
                        activity.deleteDefectFromEvent(event);
                        setState(activity);
                    },
                    defectCommentAdded: function (event) {
                        var activity = getActivity();
                        if (event.shopId !== activity.id) {
                            return;
                        }
                        activity.addDefectCommentFromEvent(event);
                        setState(activity);
                    },
                    toolChangeAdded: function (event) {
                        var activity = getActivity();
                        if (event.shopId !== activity.id) {
                            return;
                        }
                        activity.addToolChangeFromEvent(event);
                        setState(activity);
                    },
                    toolChangeEdited: function (event) {
                        var activity = getActivity();
                        if (event.shopId !== activity.id) {
                            return;
                        }
                        activity.editToolChangeFromEvent(event);
                        setState(activity);
                    },
                    toolChangeDeleted: function (event) {
                        var activity = getActivity();
                        if (event.shopId !== activity.id) {
                            return;
                        }
                        activity.deleteToolChangeFromEvent(event);
                        setState(activity);
                    },
                    toolChangeCommentAdded: function (event) {
                        var activity = getActivity();
                        if (event.shopId !== activity.id) {
                            return;
                        }
                        activity.addToolChangeCommentFromEvent(event);
                        setState(activity);
                    },
                    toolChangeDefectDeleted: function (event) {
                        var activity = getActivity();
                        if (event.shopId !== activity.id) {
                            return;
                        }
                        activity.deleteToolChangeDefectFromEvent(event);
                        setState(activity);
                    },
                    downtimeAdded: function (event) {
                        var activity = getActivity();
                        if (event.shopId !== activity.id) {
                            return;
                        }
                        activity.addDowntimeFromEvent(event);
                        setState(activity);
                    },
                    downtimeDeleted: function (event) {
                        var activity = getActivity();
                        if (event.shopId !== activity.id) {
                            return;
                        }
                        activity.deleteDowntimeFromEvent(event);
                        setState(activity);
                    },
                    qualificationAdded: function (event) {
                        var activity = getActivity();
                        if (event.shopId !== activity.id) {
                            return;
                        }
                        activity.addQualificationFromEvent(event);
                        setState(activity);
                    },
                    qualificationDeleted: function (event) {
                        var activity = getActivity();
                        if (event.shopId !== activity.id) {
                            return;
                        }
                        activity.deleteQualificationFromEvent(event);
                        setState(activity);
                    },
                    defectMoldRejectUpdated: function (event) {
                        var activity = getActivity();
                        if (event.shopId !== activity.id) {
                            return;
                        }
                        activity.updateDefectMoldRejectFromEvent(event);
                        setState(activity);
                    },
                    defectEquipFailureUpdated: function (event) {
                        var activity = getActivity();
                        if (event.shopId !== activity.id) {
                            return;
                        }
                        activity.updateDefectEquipFailureFromEvent(event);
                        setState(activity);
                    },
                    hourLocked: function (event) {
                        var activity = getActivity();
                        if (event.shopId !== activity.id) {
                            return;
                        }
                        activity.lockHourFromEvent(event);
                        setState(activity);
                    },
                    hourUnlocked: function (event) {
                        var activity = getActivity();
                        if (event.shopId !== activity.id) {
                            return;
                        }
                        activity.unlockHourFromEvent(event);
                        setState(activity);
                    },
                    downtimeDurationAdded: function (event) {
                        var activity = getActivity();
                        if (event.shopId !== activity.id) {
                            return;
                        }
                        activity.addDowntimeDurationFromEvent(event);
                        setState(activity);
                    },
                    downtimeCommentAdded: function (event) {
                        var activity = getActivity();
                        if (event.shopId !== activity.id) {
                            return;
                        }
                        activity.addDowntimeCommentFromEvent(event);
                        setState(activity);
                    },
                    checkListActivity: function (event) {
                        var activity = getActivity();
                        if (event.shopId !== activity.id) {
                            return;
                        }
                        activity.checkListActivityFromEvent(event);
                        setState(activity);
                    },
                    defectHeldPalletsAdded: function (event) {
                        var activity = getActivity();
                        if (event.shopId !== activity.id) {
                            return;
                        }
                        activity.addDefectHeldPalletsFromEvent(event);
                        setState(activity);
                    },
                    defectHeldPalletsDeleted: function (event) {
                        var activity = getActivity();
                        if (event.shopId !== activity.id) {
                            return;
                        }
                        activity.deleteDefectHeldPalletsFromEvent(event);
                        setState(activity);
                    }
                },
                methods: ['leaveGroup', 'joinGroup'],
                postConnect: function (hub) {
                    hub.invokeWithRetry(function () { return hub.joinGroup(shopId); });
                    if (postConnect) {
                        postConnect();
                    }
                }
            });
        }
        return {
            createLineSheetHubForReact: createLineSheetHubForReact
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(765)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, cavityHistory_tpl_html_1) {
    "use strict";
    cavityHistoryCtrl.$inject = ["$modalInstance", "data"];
    Object.defineProperty(exports, "__esModule", { value: true });
    function openCavityHistory(data, $modal) {
        return $modal.open({
            template: cavityHistory_tpl_html_1.default,
            controller: 'CavityHistoryCtrl as historyCtrl',
            resolve: {
                data: function () {
                    return data;
                }
            }
        }).result;
    }
    exports.openCavityHistory = openCavityHistory;
    exports.default = angular.module('aps.controller.cavityHistory', [])
        .controller('CavityHistoryCtrl', cavityHistoryCtrl)
        .name;
    function cavityHistoryCtrl($modalInstance, data) {
        var vm = this;
        vm.gob = data.gob;
        vm.section = data.gob.section;
        vm.latestTools = _.values(vm.gob.latestTools);
        vm.close = function () {
            $modalInstance.close();
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <h2 class=modal-header>Cavity Tools History: {{historyCtrl.section.name}}{{historyCtrl.gob.name}}</h2> <div class=container> <table class=history-t> <thead> <tr> <th>Tool</th> <th>Number</th> <th>Duration</th> <th>Reason</th> </tr> </thead> <tbody> <tr ng-repeat=\"tool in historyCtrl.latestTools\"> <td>{{tool.name}}</td> <td ng-if=tool.toolChange>{{tool.toolChange.toolNumber}}</td> <td ng-style=\"{'background-color':'{{tool.toolChange.getColorCode()}}'}\" ng-if=tool.toolChange>{{tool.toolChange.getDurationAndHours()}}</td> <td ng-if=tool.toolChange>{{tool.toolChange.getReason()}}</td> <td ng-if=!tool.toolChange></td> <td ng-if=!tool.toolChange>None Installed</td> <td ng-if=!tool.toolChange></td> </tr> </tbody> </table> <div class=row style=\"margin:0 -30px -30px -30px;width:auto\"> <div class=\"small-12 columns\"> <div class=\"left dialog-footer\"> <label> <span ng-style=\"{'background-color':'Green','color':'Green'}\"> Color</span> <span ng-style=\"{'font-weight':'bold'}\"> &#60;84 hrs BlankSide or &#60;154 hrs MoldSide</span> </label> <label> <span ng-style=\"{'background-color':'Orange','color':'Orange'}\"> Color</span> <span ng-style=\"{'font-weight':'bold'}\"> 84-92 hrs BlankSide or 154-160 hrs MoldSide</span> </label> <label> <span ng-style=\"{'background-color':'Red','color':'Red'}\"> Color</span> <span ng-style=\"{'font-weight':'bold'}\"> &#62;92hrs BlankSide or &#62;160hrs MoldSide</span> </label> </div> <div class=\"right dialog-footer\"> <button class=\"button secondary\" value=Close ng-click=historyCtrl.close()> Close History </button> </div> </div> </div> </div> </div>");

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(767)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, moldHistory_tpl_html_1) {
    "use strict";
    moldHistoryCtrl.$inject = ["$modalInstance", "data"];
    Object.defineProperty(exports, "__esModule", { value: true });
    function openMoldHistory(data, $modal) {
        return $modal.open({
            template: moldHistory_tpl_html_1.default,
            controller: 'MoldHistoryCtrl as historyCtrl',
            windowClass: 'small-dialog',
            resolve: {
                data: function () {
                    return data;
                }
            }
        }).result;
    }
    exports.openMoldHistory = openMoldHistory;
    exports.default = angular.module('aps.controller.moldHistory', [])
        .controller('MoldHistoryCtrl', moldHistoryCtrl)
        .name;
    function moldHistoryCtrl($modalInstance, data) {
        var vm = this;
        vm.mold = data.mold;
        vm.close = function () {
            $modalInstance.close();
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <h2 class=modal-header>Mold History: {{historyCtrl.mold.toolNumber}}</h2> <div class=container> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-6 columns\"> <div class=history-r> <strong>Time On:</strong> <span>{{historyCtrl.mold.getTimeChanged()}}</span> </div> <div class=history-r> <strong>Time Off:</strong> <span ng-if=historyCtrl.mold.timeRemoved>{{historyCtrl.mold.getTimeRemoved()}}</span> <span ng-if=!historyCtrl.mold.timeRemoved>Running</span> </div> </div> <div class=\"small-6 columns\"> <div class=history-r> <strong>Duration:</strong> <span>{{historyCtrl.mold.getDurationAndHours()}}</span> </div> <div class=history-r> <strong>Reason:</strong> <span>{{historyCtrl.mold.getReason()}}</span> </div> </div> <div class=\"small-12 columns\"> <div ng-if=historyCtrl.mold.comment class=history-r> <strong>Comment:</strong> <span>{{historyCtrl.mold.comment}}</span> </div> </div> </div> <div class=row style=\"margin:20px -30px -30px 0;width:auto\"> <div class=\"small-12 columns\"> <div class=\"right dialog-footer\"> <button class=\"button secondary\" value=Close ng-click=historyCtrl.close()> Close History </button> </div> </div> </div> </div> </div>");

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(5), __webpack_require__(3), __webpack_require__(769)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, moment, aps_enums_1, constant_module_1, qualificationHistory_tpl_html_1) {
    "use strict";
    qualificationHistoryCtrl.$inject = ["$modalInstance", "data"];
    Object.defineProperty(exports, "__esModule", { value: true });
    function openQualificationHistory(data, $modal) {
        return $modal.open({
            template: qualificationHistory_tpl_html_1.default,
            controller: 'QualificationHistoryCtrl as historyCtrl',
            resolve: {
                data: function () {
                    return data;
                }
            }
        }).result;
    }
    exports.openQualificationHistory = openQualificationHistory;
    exports.default = angular
        .module('aps.controller.qualificationHistory', [])
        .controller('QualificationHistoryCtrl', qualificationHistoryCtrl)
        .name;
    function qualificationHistoryCtrl($modalInstance, data) {
        var vm = this;
        vm.gob = data.gob;
        vm.section = vm.gob.section;
        vm.location = data.location;
        vm.locationName = vm.location === aps_enums_1.apsEnums.Location.HotEnd ? 'Hot End' : 'Cold End';
        if (vm.location === aps_enums_1.apsEnums.Location.HotEnd) {
            vm.history = vm.gob.qualificationHistory.heQualifications();
        }
        else {
            vm.history = vm.gob.qualificationHistory.ceQualifications();
        }
        vm.timeZone = data.timeZone;
        vm.formatTime = function (time) {
            return moment.utc(time).tz(vm.timeZone).format(constant_module_1.Strings.TIME_FORMAT);
        };
        vm.close = function () {
            $modalInstance.close();
        };
        vm.canAddRequalification = data.isAuthorizedForRequalification;
        vm.addRequalification = function () {
            $modalInstance.close('add');
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <h2 class=modal-header>{{ historyCtrl.locationName }} Qualification History: Section {{ historyCtrl.section.name }} / Gob {{ historyCtrl.gob.name }}</h2> <div class=container> <table class=history-t> <thead> <tr> <th>Time</th> <th>Status</th> <th>Comment</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in historyCtrl.history\"> <td>{{ historyCtrl.formatTime(item.qualificationTime) }}</td> <td> <span ng-if=\"item.status == 0\">Unqualified</span> <span ng-if=\"item.status == 1\">Qualified</span> </td> <td>{{ item.cause }}</td> </tr> </tbody> </table> <div class=row style=\"margin:0 -30px -30px 0;width:auto\"> <div class=\"small-12 columns\"> <div class=\"right dialog-footer\"> <button class=\"button primary\" value=\"Add Requalification\" ng-click=historyCtrl.addRequalification() ng-if=historyCtrl.canAddRequalification> Add Requalification </button> <button class=\"button secondary\" value=Close ng-click=historyCtrl.close()> Close History </button> </div> </div> </div> </div> </div>");

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(771)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, sectionHistory_tpl_html_1) {
    "use strict";
    sectionHistoryCtrl.$inject = ["$modalInstance", "data"];
    Object.defineProperty(exports, "__esModule", { value: true });
    function openSectionHistory(data, $modal) {
        return $modal.open({
            template: sectionHistory_tpl_html_1.default,
            controller: 'SectionHistoryCtrl as historyCtrl',
            resolve: {
                data: function () {
                    return data;
                }
            }
        }).result;
    }
    exports.openSectionHistory = openSectionHistory;
    exports.default = angular.module('aps.controller.sectionHistory', [])
        .controller('SectionHistoryCtrl', sectionHistoryCtrl)
        .name;
    function sectionHistoryCtrl($modalInstance, data) {
        var vm = this;
        vm.section = data.section;
        vm.latestTools = _.values(data.section.latestTools);
        vm.close = function () {
            $modalInstance.close();
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <h2 class=modal-header>Section Tools History: {{historyCtrl.section.name}}</h2> <div class=container> <table class=history-t> <thead> <tr> <th>Tool</th> <th>Duration</th> <th>Reason</th> </tr> </thead> <tbody> <tr ng-repeat=\"tool in historyCtrl.latestTools\"> <td>{{tool.name}}</td> <td ng-if=tool.toolChange>{{tool.toolChange.getDurationAndHours()}}</td> <td ng-if=tool.toolChange>{{tool.toolChange.getReason()}}</td> <td ng-if=!tool.toolChange>None Installed</td> <td ng-if=!tool.toolChange></td> </tr> </tbody> </table> <div class=row style=\"margin:0 -30px -30px 0;width:auto\"> <div class=\"small-12 columns\"> <div class=\"right dialog-footer\"> <button class=\"button secondary\" value=Close ng-click=historyCtrl.close()> Close History </button> </div> </div> </div> </div> </div>");

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(3), __webpack_require__(773), __webpack_require__(9), __webpack_require__(6), __webpack_require__(4), __webpack_require__(281), __webpack_require__(8), __webpack_require__(7), __webpack_require__(52), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, constant_module_1, sendNotification_tpl_html_1, uiUtility_service_1, notify_service_1, loader_service_1, notification_service_1, navigation_service_1, authData_service_1, user_service_1, aps_enums_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [uiUtility_service_1.default, notify_service_1.default, loader_service_1.default, notify_service_1.default, navigation_service_1.default,
        notification_service_1.default, authData_service_1.default, user_service_1.default];
    var SendNotificationCtrl = (function () {
        SendNotificationCtrl.$inject = ["notificationService", "navigationService", "authDataService", "loaderService", "notifyService", "uiUtilityService", "userService"];
        function SendNotificationCtrl(notificationService, navigationService, authDataService, loaderService, notifyService, uiUtilityService, userService) {
            var _this = this;
            this.notificationService = notificationService;
            this.notifyService = notifyService;
            this.loaderService = loaderService;
            this.isAdmin = authDataService.isAdmin();
            var promise = navigationService.getNavigation().then(function (navigation) {
                var plants = navigation.plants();
                _this.plants = _.filter(plants, function (plant) {
                    return authDataService.isPlantAdmin(plant.id);
                });
                if (!_this.isAdmin) {
                    _this.selectedPlant = _this.plants[0];
                }
            });
            var startEnum = aps_enums_1.apsEnums.GlobalNotificationType.EntireCompany;
            var endEnum = aps_enums_1.apsEnums.GlobalNotificationType.ReleaseNotes;
            if (!this.isAdmin) {
                startEnum = aps_enums_1.apsEnums.GlobalNotificationType.EntirePlant;
            }
            if (!authDataService.isAPSIOAdmin()) {
                endEnum = aps_enums_1.apsEnums.GlobalNotificationType.Individuals;
            }
            this.options = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.GlobalNotificationType, startEnum, endEnum);
            userService.getUsersToNotify().then(function (users) {
                _this.users = users;
            });
            this.notification = {
                type: startEnum,
                plantId: undefined,
                shopId: undefined,
                userIds: [],
                title: undefined,
                description: undefined,
                url: undefined
            };
            this.releaseNote = {
                title: undefined,
                description: undefined,
            };
            this.selectedUsers = [];
            this.loaderService.loadingPromise(promise);
        }
        SendNotificationCtrl.prototype.userSelected = function () {
            var user = _.find(this.users, { name: this.user });
            if (!user) {
                return;
            }
            this.user = undefined;
            this.selectedUsers.push(user);
        };
        SendNotificationCtrl.prototype.removeUser = function (user) {
            _.remove(this.selectedUsers, user);
        };
        SendNotificationCtrl.prototype.typeChanged = function () {
            if (this.showPlants()) {
                this.notification.plantId = _.first(this.plants).id;
            }
        };
        SendNotificationCtrl.prototype.plantChanged = function () {
            this.selectedShop = null;
        };
        SendNotificationCtrl.prototype.showPlants = function () {
            return this.notification.type === aps_enums_1.apsEnums.GlobalNotificationType.EntirePlant
                || this.notification.type === aps_enums_1.apsEnums.GlobalNotificationType.EntireShop;
        };
        SendNotificationCtrl.prototype.showShops = function () {
            return this.notification.type === aps_enums_1.apsEnums.GlobalNotificationType.EntireShop;
        };
        SendNotificationCtrl.prototype.showIndividuals = function () {
            return this.notification.type === aps_enums_1.apsEnums.GlobalNotificationType.Individuals;
        };
        SendNotificationCtrl.prototype.usersRequired = function () {
            if (!this.showIndividuals()) {
                return false;
            }
            return this.selectedUsers.length === 0;
        };
        SendNotificationCtrl.prototype.send = function () {
            var _this = this;
            if (this.form.$invalid || this.usersRequired()) {
                return;
            }
            this.notification.plantId = this.showPlants() ? this.selectedPlant.id : undefined;
            this.notification.shopId = this.showShops() ? this.selectedShop.id : undefined;
            if (this.notification.type === aps_enums_1.apsEnums.GlobalNotificationType.ReleaseNotes) {
                this.releaseNote.description = this.notification.description;
                this.releaseNote.title = this.notification.title;
                this.notificationService.sendReleaseNotesNotification(this.releaseNote).then(function () {
                    _this.notifyService.success('Notification Sent!');
                    _this.resetNotificationForm();
                }, this.notifyService.handleApiErrors);
                return;
            }
            if (this.showIndividuals()) {
                this.notification.userIds = _.map(this.selectedUsers, 'id');
            }
            else {
                this.notification.userIds = [];
            }
            this.loaderService.loadingPromise(this.notificationService.sendNotification(this.notification)
                .then(function () {
                _this.notifyService.success('Notification Sent!');
                _this.resetNotificationForm();
            }, this.notifyService.handleApiErrors));
        };
        SendNotificationCtrl.prototype.resetNotificationForm = function () {
            this.notification.title = '';
            this.notification.description = '';
            this.notification.url = '';
            this.notification.userIds = [];
            this.selectedUsers = [];
            this.form.$setPristine();
        };
        return SendNotificationCtrl;
    }());
    exports.default = angular.module('aps.controller.sendNotification', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.GLOBAL_NOTIFICATIONS,
            url: '/sendNotification',
            controller: 'SendNotificationCtrl as vm',
            template: sendNotification_tpl_html_1.default,
            data: {
                pageTitle: 'Send Notification',
                authorizePlantAdmin: true,
                v2Uri: 'aps/settings/globalNotifications'
            }
        });
    }])
        .controller('SendNotificationCtrl', SendNotificationCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div ng-if=vm.plants class=main-table-w> <div class=body-header> <h2>Send a Notification</h2> </div> <form name=vm.form ng-submit=vm.send() novalidate> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-6 columns\"> <label>Send To <select ng-model=vm.notification.type ng-options=\"type.value as type.text for type in vm.options\" ng-change=vm.typeChanged()></select> </label> </div> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\" ng-if=vm.showPlants()> <div class=\"small-6 columns\"> <label><span class=\"required notated\">*</span>Plant <select name=selectedPlant ng-model=vm.selectedPlant ng-options=\"plant.name for plant in vm.plants\" ng-change=vm.plantChanged() required> <option value=\"\" ng-show=vm.isAdmin>-- Select a Plant --</option> </select> <div ng-messages=vm.form.selectedPlant.$error ng-if=\"vm.form.selectedPlant.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\" ng-if=vm.showShops()> <div class=\"small-6 columns\"> <label><span class=\"required notated\">*</span>Shop <select name=selectedShop ng-model=vm.selectedShop ng-options=\"shop as shop.name for shop in vm.selectedPlant.shops\" required> <option value=\"\">-- Select a Shop --</option> </select> <div ng-messages=vm.form.selectedShop.$error ng-if=\"vm.form.selectedShop.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\" ng-if=vm.showIndividuals()> <div class=\"small-6 columns\"> <div ng-if=!vm.users> Loading individuals. Please wait... </div> <label ng-if=vm.users><span class=\"required notated\">*</span> Individuals <input name=job type=text placeholder=\"Type a user's name to add them\" ng-model=vm.user ng-select=vm.userSelected() typeahead-on-select=vm.userSelected() typeahead=\"user.name for user in vm.users | filter:$viewValue | limitTo:8\"/> </label> <ul ng-repeat=\"user in vm.selectedUsers\"> <li> {{user.name}} <button type=button ng-click=vm.removeUser(user)>Remove</button> </li> </ul> <div class=req-w ng-if=\"vm.usersRequired() && vm.form.$submitted\"> <div class=arrow-up></div> You must add one or more individuals </div> </div> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-6 columns\"> <label><span class=\"required notated\">*</span>Subject <input type=text name=title ng-model=vm.notification.title required/> </label> <div ng-messages=vm.form.title.$error ng-if=\"vm.form.title.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-6 columns\"> <label><span class=\"required notated\">*</span>Body <textarea rows=4 name=description ng-model=vm.notification.description required></textarea> </label> <div ng-messages=vm.form.description.$error ng-if=\"vm.form.description.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-6 columns\"> <label>Link (url) <input type=url name=url ng-model=vm.notification.url /> </label> <div ng-messages=vm.form.url.$error ng-if=\"vm.form.url.$dirty || vm.form.$submitted\" role=alert> <div ng-message=url class=req-w><div class=arrow-up></div>Invalid URL</div> </div> </div> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-6 columns\"> <button type=submit class=button>Send Notification</button> </div> </div> </form> </div>");

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(775), __webpack_require__(3), __webpack_require__(4), __webpack_require__(308), __webpack_require__(8), __webpack_require__(7), __webpack_require__(33), __webpack_require__(9), __webpack_require__(6), __webpack_require__(2), __webpack_require__(5), __webpack_require__(777)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, editPalletizer_controller_1, constant_module_1, loader_service_1, palletizer_service_1, navigation_service_1, authData_service_1, equipment_service_1, uiUtility_service_1, notify_service_1, _, aps_enums_1, palletizer_tpl_html_1) {
    "use strict";
    palletizerConfig.$inject = ["$stateProvider"];
    palletizerController.$inject = ["loaderService", "palletizerService", "navigationService", "authDataService", "equipmentService", "uiUtilityService", "notifyService", "$modal"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [editPalletizer_controller_1.default, loader_service_1.default, palletizer_service_1.default, navigation_service_1.default,
        authData_service_1.default, equipment_service_1.default, uiUtility_service_1.default, notify_service_1.default];
    exports.default = angular.module('aps.controller.palletizer', requires)
        .config(palletizerConfig)
        .controller('PalletizerCtrl', palletizerController)
        .name;
    function palletizerConfig($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.PALLETIZERS,
            url: '/admin/palletizers',
            controller: 'PalletizerCtrl as vm',
            template: palletizer_tpl_html_1.default,
            data: {
                pageTitle: 'Palletizers',
                authorizeAPSIOAdmin: true
            }
        });
    }
    function palletizerController(loaderService, palletizerService, navigationService, authDataService, equipmentService, uiUtilityService, notifyService, $modal) {
        var vm = {};
        var equipmentPromise = null;
        var plcs = null;
        var loadingPromise = navigationService.getNavigation().then(function (nav) {
            var plants = nav.plants();
            vm.plants = _.filter(plants, function (plant) {
                return authDataService.isAPSIOAdminForPlant(plant.id);
            });
            if (nav.selectedPlant && _.includes(vm.plants, nav.selectedPlant)) {
                vm.selectedPlant = nav.selectedPlant;
            }
            else {
                vm.selectedPlant = _.first(vm.plants);
            }
            return loadPlantData();
        });
        loaderService.loadingPromise(loadingPromise);
        vm.plantChanged = plantChanged;
        vm.addPalletizer = add;
        vm.edit = edit;
        vm.remove = remove;
        return vm;
        function loadPlantData() {
            equipmentPromise = equipmentService.get(vm.selectedPlant.id)
                .then(function (equipment) {
                return plcs = equipment.filter(function (e) { return e.type === aps_enums_1.apsEnums.EquipmentType.PLC; });
            });
            return palletizerService.get(vm.selectedPlant.id)
                .then(function (palletizers) { return vm.palletizers = palletizers; });
        }
        function plantChanged() {
            vm.palletizers = null;
            loaderService.loadingPromise(loadPlantData());
        }
        function add() {
            edit(null);
        }
        function edit(instance) {
            if (!equipmentPromise) {
                return;
            }
            equipmentPromise.then(function () {
                var result = editPalletizer_controller_1.openEditPalletizer({
                    plant: vm.selectedPlant,
                    palletizer: instance,
                    plcs: plcs
                }, $modal);
                result.then(function (result) {
                    if (!result) {
                        return;
                    }
                    var shopName = 'No Shop';
                    if (result.shopId) {
                        shopName = _.find(vm.selectedPlant.shops, { id: result.shopId }).name;
                    }
                    var plc = _.find(plcs, { id: result.equipmentId });
                    var dataPoint = _.find(plc.dataPoints, { id: result.dataPointId });
                    if (instance) {
                        _.assign(instance, result);
                    }
                    else {
                        instance = _.assign({}, result);
                        vm.palletizers.push(instance);
                    }
                    instance.shopName = shopName;
                    instance.equipmentName = plc.name;
                    instance.dataPointName = dataPoint.name;
                });
            });
        }
        function remove(instance) {
            uiUtilityService.confirm('Are you sure you want to remove palletizer: ' + instance.name + '?', 'Remove Palletizer?').then(function (confirmed) {
                if (!confirmed) {
                    return;
                }
                loaderService.loadingPromise(palletizerService.remove({
                    id: instance.id,
                    plantId: instance.plantId
                }).then(function () {
                    _.remove(vm.palletizers, instance);
                }, notifyService.handleApiErrors));
            });
        }
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(9), __webpack_require__(4), __webpack_require__(6), __webpack_require__(28), __webpack_require__(12), __webpack_require__(5), __webpack_require__(308), __webpack_require__(776)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, uiUtility_service_1, loader_service_1, notify_service_1, lineConfigs_service_1, newguid_service_1, aps_enums_1, palletizer_service_1, editPalletizer_tpl_html_1) {
    "use strict";
    editPalletizer.$inject = ["loaderService", "palletizerService", "notifyService", "lineConfigsService", "newGuidService", "uiUtilityService", "data", "$modalInstance"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [uiUtility_service_1.default, loader_service_1.default, notify_service_1.default, lineConfigs_service_1.default, newguid_service_1.default,
        palletizer_service_1.default];
    function openEditPalletizer(data, $modal) {
        return $modal.open({
            template: editPalletizer_tpl_html_1.default,
            controller: 'EditPalletizerCtrl as vm',
            resolve: {
                data: function () {
                    return data;
                }
            }
        }).result;
    }
    exports.openEditPalletizer = openEditPalletizer;
    exports.default = angular.module('aps.controller.editPalletizer', requires)
        .controller('EditPalletizerCtrl', editPalletizer)
        .name;
    function editPalletizer(loaderService, palletizerService, notifyService, lineConfigsService, newGuidService, uiUtilityService, data, $modalInstance) {
        var vm = {};
        vm.shops = data.plant.shops;
        vm.plcs = data.plcs;
        vm.lines = [];
        vm.signalTypes = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.PalletizerSignalType, 1);
        var initializeLineId = false;
        vm.isNew = false;
        vm.shopChanged = shopChanged;
        vm.plcChanged = plcChanged;
        vm.save = save;
        vm.cancel = cancel;
        if (data.palletizer) {
            vm.palletizer = {
                id: data.palletizer.id,
                plantId: data.plant.id,
                name: data.palletizer.name,
                lineId: null,
                shopId: data.palletizer.shopId,
                equipmentId: data.palletizer.equipmentId,
                dataPointId: data.palletizer.dataPointId,
                signalType: data.palletizer.signalType
            };
            setDataPoints();
            if (vm.palletizer.shopId) {
                initializeLineId = true;
                vm.shopChanged();
            }
        }
        else {
            vm.isNew = true;
            vm.palletizer = {
                id: null,
                plantId: data.plant.id,
                name: null,
                lineId: null,
                shopId: null,
                equipmentId: null,
                dataPointId: null,
                signalType: null
            };
            newGuidService.getNewGuid('palletizer').then(function (id) { return vm.palletizer.id = id; });
        }
        return vm;
        function setDataPoints() {
            vm.dataPoints = null;
            if (!vm.palletizer.equipmentId) {
                return;
            }
            var plc = _.find(vm.plcs, { id: vm.palletizer.equipmentId });
            if (!plc) {
                return;
            }
            vm.dataPoints = plc.dataPoints;
        }
        function shopChanged() {
            vm.lines = [];
            vm.palletizer.lineId = null;
            if (!vm.palletizer.shopId) {
                return;
            }
            lineConfigsService.getLineConfiguration(vm.palletizer.shopId)
                .then(function (lineConfig) {
                vm.lines = lineConfig.lines.filter(function (l) { return !l.endJunctionId; });
                if (!initializeLineId) {
                    return;
                }
                var line = vm.lines.filter(function (l) { return _.some(l.equipment, function (e) { return e.type === aps_enums_1.apsEnums.LineEquipmentType.Palletizer; }); });
                if (line.length > 0) {
                    vm.palletizer.lineId = line[0].id;
                }
                initializeLineId = false;
            });
        }
        function plcChanged() {
            vm.palletizer.dataPointId = null;
            setDataPoints();
        }
        function save() {
            if (vm.form.$invalid) {
                return;
            }
            var saveFunc = vm.isNew ? palletizerService.add : palletizerService.update;
            loaderService.loadingPromise(saveFunc(vm.palletizer)
                .then(function () { return $modalInstance.close(vm.palletizer); }, notifyService.handleApiErrors));
        }
        function cancel() {
            $modalInstance.close();
        }
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <h2 class=modal-header>{{ vm.isNew ? 'Add' : 'Edit' }} Palletizer</h2> <form name=vm.form ng-submit=vm.save() novalidate> <div class=container style=\"margin:0 -30px\"> <div class=row> <div class=\"large-4 columns\"> <label><span class=\"required notated\">*</span>Name: <input name=name type=text ng-model=vm.palletizer.name required/> </label> <div ng-messages=vm.form.name.$error ng-if=\"vm.form.name.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-4 columns\"> <label>Shop: <select name=shop ng-model=vm.palletizer.shopId ng-options=\"t.id as t.name for t in vm.shops\" ng-change=vm.shopChanged()> <option value=\"\">No Shop</option> </select> </label> </div> <div class=\"large-4 columns\" ng-if=vm.palletizer.shopId> <label><span class=\"required notated\">*</span>Line: <select name=line ng-model=vm.palletizer.lineId required ng-options=\"t.id as t.name for t in vm.lines\"> <option value=\"\">-- Select a Line --</option> </select> </label> <div ng-messages=vm.form.line.$error ng-if=\"vm.form.line.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> </div> <div class=row> <div class=\"large-4 columns\"> <label><span class=\"required notated\">*</span>PLC: <select name=plc ng-model=vm.palletizer.equipmentId required ng-options=\"t.id as t.name for t in vm.plcs\" ng-change=vm.plcChanged()> <option value=\"\">-- Select a PLC --</option> </select> </label> <div ng-messages=vm.form.plc.$error ng-if=\"vm.form.plc.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-4 columns\"> <label><span class=\"required notated\">*</span>Data Point: <select name=dataPoint ng-model=vm.palletizer.dataPointId required ng-options=\"t.id as t.name for t in vm.dataPoints\"> <option value=\"\">-- Select a Data Point --</option> </select> </label> <div ng-messages=vm.form.dataPoint.$error ng-if=\"vm.form.dataPoint.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-4 columns\"> <label><span class=\"required notated\">*</span>Signal Type: <select name=signalType ng-model=vm.palletizer.signalType ng-options=\"t.value as t.text for t in vm.signalTypes\" required> <option value=\"\">-- Select a Signal Type --</option> </select> </label> <div ng-messages=vm.form.signalType.$error ng-if=\"vm.form.signalType.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> </div> <div class=row> <div class=\"large-12 columns\"> <span class=required>* Required Fields</span> <div class=\"right dialog-footer\"> <button ng-click=vm.cancel() type=button class=\"button secondary\">Cancel</button> <button class=button type=submit>{{ vm.isNew ? 'Add' : 'Save' }} Palletizer</button> </div> </div> </div> </div> </form> </div>");

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <div class=body-header><h2>Palletizers</h2></div> <div class=container> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-5 columns\"> <label> <span class=\"required notated\">*</span>Plant: <select ng-model=vm.selectedPlant ng-options=\"plant.name for plant in vm.plants\" ng-change=vm.plantChanged()> </select> </label> </div> <div class=\"small-5 columns\"> &nbsp; </div> <div class=\"small-2 columns\"> <button ng-click=vm.addPalletizer() class=\"button small\" style=position:relative;top:14px>Add Palletizer</button> </div> </div> <div ng-if=\"vm.palletizers && vm.palletizers.length === 0\" style=width:100%;clear:both;float:left;margin-top:30px> Currently there are no Palletizers for this Plant </div> <table cellpadding=1 cellspacing=1 ng-if=\"vm.palletizers && vm.palletizers.length > 0\" class=history-t> <tr> <th>Name</th> <th>PLC</th> <th>Data Point</th> <th>Shop</th> <th></th> <th></th> </tr> <tr ng-repeat=\"instance in vm.palletizers\"> <td>{{ instance.name }}</td> <td>{{ instance.equipmentName }}</td> <td>{{ instance.dataPointName }}</td> <td>{{ instance.shopName }}</td> <td><button ng-click=vm.edit(instance) class=\"button tiny\" style=margin:0>Edit</button></td> <td><button ng-click=vm.remove(instance) class=\"button tiny alert\" style=margin:0>Delete</button></td> </tr> </table> </div> </div>");

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(779), __webpack_require__(3), __webpack_require__(4), __webpack_require__(6), __webpack_require__(16), __webpack_require__(8), __webpack_require__(7), __webpack_require__(2), __webpack_require__(781)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, moment, editPalletKpi_controller_1, constant_module_1, loader_service_1, notify_service_1, report_service_1, navigation_service_1, authData_service_1, _, palletKPIs_tpl_html_1) {
    "use strict";
    palletizerKpisConfig.$inject = ["$stateProvider"];
    palletKpisController.$inject = ["loaderService", "reportService", "notifyService", "navigationService", "authDataService", "$modal"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, report_service_1.default, navigation_service_1.default, editPalletKpi_controller_1.default,
        authData_service_1.default, notify_service_1.default];
    exports.default = angular.module('aps.controller.palletKPIs', requires)
        .config(palletizerKpisConfig)
        .controller('PalletKpisCtrl', palletKpisController)
        .name;
    function palletizerKpisConfig($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.PALLETKPI,
            url: '/admin/palletkpis',
            controller: 'PalletKpisCtrl as vm',
            template: palletKPIs_tpl_html_1.default,
            data: {
                pageTitle: 'Pallet Edit'
            }
        });
    }
    function palletKpisController(loaderService, reportService, notifyService, navigationService, authDataService, $modal) {
        var vm = {};
        var dtToday = new Date();
        var day = dtToday.setDate(dtToday.getDate() - 1);
        var loadingPromise = navigationService.getNavigation().then(function (nav) {
            var plants = nav.plants();
            vm.plants = plants;
            if (nav.selectedPlant && _.includes(vm.plants, nav.selectedPlant)) {
                vm.selectedPlant = nav.selectedPlant;
            }
            else {
                vm.selectedPlant = _.first(vm.plants);
                vm.selectedShop = nav.selectedShop;
            }
        });
        loaderService.loadingPromise(loadingPromise);
        vm.edit = edit;
        vm.reportDate = moment().add(-1, 'days').toDate();
        vm.minDate = moment().add(-14, 'days').toDate();
        vm.generateReport = generateReport;
        return vm;
        function generateReport() {
            var promise = runReport();
            loaderService.loadingPromise(promise);
            return promise;
        }
        function runReport() {
            return reportService.getPlantKpis(vm.selectedShop.id, vm.reportDate).then(function (reportItem) {
                vm.palletKPIs = reportItem;
            }, notifyService.handleApiErrors);
        }
        function edit(instance) {
            var result = editPalletKpi_controller_1.openEditPalletKpi({
                plant: vm.selectedPlant,
                palletKpiItem: instance,
                productionDate: vm.reportDate
            }, $modal);
            result.then(function (result) {
                if (!result) {
                    return;
                }
                vm.palletKPIs.splice(vm.palletKPIs.indexOf(instance), 1, result);
            });
        }
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(4), __webpack_require__(6), __webpack_require__(16), __webpack_require__(780)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, loader_service_1, notify_service_1, report_service_1, editPalletKpi_tpl_html_1) {
    "use strict";
    editPalletKpi.$inject = ["reportService", "loaderService", "notifyService", "data", "$modalInstance"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, notify_service_1.default, report_service_1.default];
    function openEditPalletKpi(data, $modal) {
        return $modal.open({
            template: editPalletKpi_tpl_html_1.default,
            controller: 'EditPalletKpiCtrl as vm',
            resolve: {
                data: function () {
                    return data;
                }
            }
        }).result;
    }
    exports.openEditPalletKpi = openEditPalletKpi;
    exports.default = angular.module('aps.controller.editPalletKpi', requires)
        .controller('EditPalletKpiCtrl', editPalletKpi)
        .name;
    function editPalletKpi(reportService, loaderService, notifyService, data, $modalInstance) {
        var vm = {};
        vm.shops = data.plant.shops;
        vm.save = save;
        vm.cancel = cancel;
        vm.goodBottles = goodBottles;
        vm.onValueChange = onValueChange;
        vm.packedGlass = packedGlass;
        vm.meltedGlass = meltedGlass;
        vm.ptm = ptm;
        vm.ptp = ptp;
        if (data.palletKpiItem) {
            vm.originalKpi = data.palletKpiItem;
            vm.palletQuantity = data.palletKpiItem.goodBottles / (data.palletKpiItem.goodPallets + data.palletKpiItem.heldPallets - data.palletKpiItem.reintroducedPallets);
            vm.palletKpiCommand = {
                id: data.palletKpiItem.id,
                plantId: data.plant.id,
                speed: Math.round(data.palletKpiItem.speed),
                weight: data.palletKpiItem.weight,
                goodPallets: data.palletKpiItem.goodPallets,
                heldPallets: data.palletKpiItem.heldPallets,
                reintroducedPallets: data.palletKpiItem.reintroducedPallets,
                goodBottles: data.palletKpiItem.goodBottles,
                heldBottles: data.palletKpiItem.heldBottles,
                reintroducedBottles: data.palletKpiItem.reintroducedBottles,
                totalMinutes: data.palletKpiItem.totalMinutes,
                meltedGlass: data.palletKpiItem.meltedGlass,
                currentjci: data.palletKpiItem.jci,
                previousjci: data.palletKpiItem.jci,
                updateRaw: false
            };
        }
        return vm;
        function goodBottles() {
            return (vm.palletKpiCommand.goodPallets + vm.palletKpiCommand.heldPallets - vm.palletKpiCommand.reintroducedPallets)
                * vm.palletQuantity;
        }
        function onValueChange(inputModel) {
            vm.palletKpiCommand.updateRaw = true;
            if (inputModel == 'goodPallets') {
                vm.palletKpiCommand.goodBottles = null;
            }
            else if (inputModel == 'heldPallets') {
                vm.palletKpiCommand.heldBottles = null;
            }
            else if (inputModel == 'reintroducedPallets') {
                vm.palletKpiCommand.reintroducedBottles = null;
            }
        }
        function packedGlass() {
            return roundDecimal(goodBottles() * vm.palletKpiCommand.weight);
        }
        function meltedGlass() {
            return roundDecimal(((vm.palletKpiCommand.totalMinutes - vm.originalKpi.streamingDowntimeMinutes) * vm.palletKpiCommand.weight * vm.palletKpiCommand.speed) + (vm.originalKpi.streamingDowntimeTons * 32000));
        }
        function ptm() {
            return roundDecimal((packedGlass() / meltedGlass()) * 100.0);
        }
        function ptp() {
            return roundDecimal((packedGlass() / meltedGlass()) * 100.0);
        }
        function roundDecimal(value) {
            return Math.round(value * 100.0) / 100.0;
        }
        function save() {
            if (vm.form.$invalid) {
                return;
            }
            loaderService.loadingPromise(reportService.updatePlantKpi(vm.palletKpiCommand)
                .then(function () { return $modalInstance.close(__assign({}, vm.originalKpi, vm.palletKpiCommand, { goodBottles: vm.palletKpiCommand.goodBottles, heldBottles: vm.palletKpiCommand.heldBottles, reintroducedBottles: vm.palletKpiCommand.reintroducedBottles, packedGlass: packedGlass(), meltedGlass: meltedGlass(), ptm: ptm(), ptp: ptp() })); }, notifyService.handleApiErrors));
        }
        function cancel() {
            $modalInstance.close();
        }
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <h2 class=modal-header>Edit Production Report Record</h2> <form name=vm.form ng-submit=vm.save() novalidate> <div class=container style=\"margin:0 -30px\"> <div class=row> <div class=\"large-3 columns\"> <label><span class=\"required notated\">*</span>Pallets Accepted: <input name=goodPallets type=number ng-model=vm.palletKpiCommand.goodPallets ng-change=\"vm.onValueChange('goodPallets')\" required step=1 min=0 /> <div ng-messages=vm.form.goodPallets.$error ng-if=\"vm.form.goodPallets.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=min class=req-w> <div class=arrow-up></div>Must be between 0 or more </div> </div> </label> </div> <div class=\"large-3 columns\"> <label><span class=\"required notated\">*</span>Pallets Held: <input name=heldPallets type=number ng-model=vm.palletKpiCommand.heldPallets ng-change=\"vm.onValueChange('heldPallets')\" required step=1 min=0 /> <div ng-messages=vm.form.heldPallets.$error ng-if=\"vm.form.heldPallets.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=min class=req-w> <div class=arrow-up></div>Must be between 0 or more </div> </div> </label> </div> <div class=\"large-3 columns\"> <label><span class=\"required notated\">*</span>Pallets Reintroduced: <input name=reintroducedPallets type=number ng-model=vm.palletKpiCommand.reintroducedPallets ng-change=\"vm.onValueChange('reintroducedPallets')\" required step=1 min=0 /> <div ng-messages=vm.form.reintroducedPallets.$error ng-if=\"vm.form.reintroducedPallets.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=min class=req-w> <div class=arrow-up></div>Must be between 0 or more </div> </div> </label> </div> <div class=\"large-3 columns\"> <label><span class=\"required notated\">*</span>Job Change Index: <input name=currentjci type=number ng-model=vm.palletKpiCommand.currentjci required step=0.01 min=0 /> <div ng-messages=vm.form.currentjci.$error ng-if=\"vm.form.currentjci.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=min class=req-w> <div class=arrow-up></div>Must be between 0 or more </div> <div ng-message=step class=req-w> <div class=arrow-up></div>Can't enter more than two decimals </div> </div> </label> </div> </div> <div class=row> <div class=\"large-4 columns\"> <label><span class=\"required notated\">*</span>Minutes: <input name=totalMinutes type=number ng-model=vm.palletKpiCommand.totalMinutes required step=1 min=1 /> <div ng-messages=vm.form.totalMinutes.$error ng-if=\"vm.form.totalMinutes.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=min class=req-w> <div class=arrow-up></div>Must be between 1 or more </div> </div> </label> </div> <div class=\"large-4 columns\"> <label><span class=\"required notated\">*</span>Weight: <input name=weight type=number ng-model=vm.palletKpiCommand.weight required step=0.01 min=0.01 /> <div ng-messages=vm.form.weight.$error ng-if=\"vm.form.weight.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=min class=req-w> <div class=arrow-up></div>Must be between 0.01 or more </div> </div> </label> </div> <div class=\"large-4 columns\"> <label><span class=\"required notated\">*</span>Speed: <input name=speed type=number ng-model=vm.palletKpiCommand.speed required step=1 min=1 /> <div ng-messages=vm.form.speed.$error ng-if=\"vm.form.speed.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=min class=req-w> <div class=arrow-up></div>Must be between 1 or more </div> <div ng-message=step class=req-w> <div class=arrow-up></div>Speed cannot be a decimal </div> </div> </label> </div> </div> <!--<div class=\"row\">\r\n        <div class=\"large-3 columns\">\r\n          <label>Pieces Per Pallet:\r\n            <span>{{vm.palletQuantity}}</span>\r\n          </label>\r\n        </div>\r\n        <div class=\"large-3 columns\">\r\n          <label>Bottles Accepted:\r\n            <span>{{vm.goodBottles()}}</span>\r\n          </label>\r\n        </div>\r\n        <div class=\"large-3 columns\">\r\n          <label>Bottles Held:\r\n            <span>{{vm.heldBottles()}}</span>\r\n          </label>\r\n        </div>\r\n        <div class=\"large-3 columns\">\r\n          <label>Bottles Reintroduced:\r\n            <span>{{vm.reintroducedBottles()}}</span>\r\n          </label>\r\n        </div>\r\n      </div>--> <div class=row> <div class=\"large-3 columns\"> <label>Packed Glass: <span>{{vm.packedGlass() | number}}</span> </label> </div> <div class=\"large-3 columns\"> <label>Melted Glass: <span>{{vm.meltedGlass() | number}}</span> </label> </div> <div class=\"large-3 columns\"> <label>PTM: <span>{{vm.ptm()}}</span> </label> </div> <div class=\"large-3 columns\"> <label>PTP: <span>{{vm.ptp()}}</span> </label> </div> </div> <div class=row> <div class=\"large-4 columns\"> <label><span class=\"required notated\"></span> (Advanced) Update Bottle Counts: <input name=goodBottles type=checkbox ng-model=vm.palletKpiCommand.updateRaw /> </label> </div> </div> <div class=row ng-show=vm.palletKpiCommand.updateRaw> <div class=\"large-4 columns\"> <label><span class=\"required notated\">*</span>Total Bottles: <input name=goodBottles type=number ng-model=vm.palletKpiCommand.goodBottles required step=1 min=0 /> <div ng-messages=vm.form.goodBottles.$error ng-if=\"vm.form.goodBottles.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=min class=req-w> <div class=arrow-up></div>Must be between 0 or more </div> </div> </label> </div> <div class=\"large-4 columns\"> <label><span class=\"required notated\">*</span>Held Bottles: <input name=heldBottles type=number ng-model=vm.palletKpiCommand.heldBottles required step=1 min=0 /> <div ng-messages=vm.form.heldBottles.$error ng-if=\"vm.form.heldBottles.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=min class=req-w> <div class=arrow-up></div>Must be greater than 0 </div> </div> </label> </div> <div class=\"large-4 columns\"> <label><span class=\"required notated\">*</span>Reintroduced Bottles: <input name=reintroducedBottles type=number ng-model=vm.palletKpiCommand.reintroducedBottles required step=1 min=0 /> <div ng-messages=vm.form.reintroducedBottles.$error ng-if=\"vm.form.reintroducedBottles.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=min class=req-w> <div class=arrow-up></div>Must be greater than 0 </div> </div> </label> </div> </div> <div class=row> <div class=\"large-12 columns\"> <span class=required>* Required Fields</span> <div class=\"right dialog-footer\"> <button ng-click=vm.cancel() type=button class=\"button secondary\">Cancel</button> <button class=button type=submit>Save Data</button> </div> </div> </div> </div> </form> </div>");

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div class=body-header> <h2>Production Report Records By Shift</h2> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-6 columns\"> <label> <span class=\"required notated\" ng-if=vm.requireShopSelection>*</span>Shop <select name=selectedShop ng-model=vm.selectedShop ng-options=\"shop as shop.name for shop in vm.selectedPlant.shops\"></select> <div ng-messages=commonReportQueryForm.selectedShop.$error ng-if=\"commonReportQueryForm.selectedShop.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div> </div> </div> </label> </div> <div class=\"small-6 columns\"> <label> <span class=\"required notated\">*</span>Date <input type=date ng-model=vm.reportDate name=reportDate min=\"{{vm.minDate | date: 'yyyy-MM-dd'}}\" required/> <div ng-messages=vm.form.reportDate.$error ng-if=\"vm.form.reportDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=\"min, max\" class=req-w> <div class=arrow-up></div>Past Date can be 14 days from today </div> </div> </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns\"> <button type=submit class=button>Get Data</button> </div> </div> </form> <div class=container> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-5 columns\"> </div> <div class=\"small-5 columns\"> &nbsp; </div> </div> <div ng-if=\"vm.palletKPIs && vm.palletKPIs.length === 0\" style=width:100%;clear:both;float:left;margin-top:30px> Currently No Pallets for this Shop </div> <table cellpadding=1 cellspacing=1 ng-if=\"vm.palletKPIs && vm.palletKPIs.length > 0\" class=history-t> <tr> <th>Shift</th> <th>Mold</th> <th>Finish</th> <th>Short Item</th> <th>Accepted Pallets</th> <th>Held Pallets</th> <th>Reintroduced Pallets</th> <th>PTM</th> <th>Minutes</th> <th>Streaming Downtime Minutes</th> <th>Streaming Downtime Tons</th> <th></th> </tr> <tr ng-repeat=\"instance in vm.palletKPIs\"> <td>{{ instance.shift }}</td> <td>{{ instance.mold }}</td> <td>{{ instance.finish }}</td> <td>{{ instance.shortItem }}</td> <td>{{ instance.goodPallets }}</td> <td>{{ instance.heldPallets }}</td> <td>{{ instance.reintroducedPallets }}</td> <td>{{ instance.ptm }}</td> <td>{{ instance.totalMinutes }}</td> <td>{{ instance.streamingDowntimeMinutes }}</td> <td>{{ instance.streamingDowntimeTons }}</td> <td><button ng-click=vm.edit(instance) class=\"button tiny\" style=margin:0>Edit</button></td> </tr> </table> </div> </div>");

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(783), __webpack_require__(3), __webpack_require__(786), __webpack_require__(55), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, editPlant_controller_1, constant_module_1, plants_tpl_html_1, plant_service_1, loader_service_1) {
    "use strict";
    plantsConfig.$inject = ["$stateProvider"];
    plantsCtrl.$inject = ["plantService", "loaderService", "$modal", "authDataService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [editPlant_controller_1.default, plant_service_1.default, loader_service_1.default];
    exports.default = angular.module('aps.controller.plants', requires)
        .config(plantsConfig)
        .controller('PlantsCtrl', plantsCtrl)
        .name;
    function plantsConfig($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.PLANTS,
            url: '/admin/plants',
            controller: 'PlantsCtrl as plantsCtrl',
            template: plants_tpl_html_1.default,
            data: {
                pageTitle: 'Plants',
                authorizeAdmin: true
            }
        });
    }
    function plantsCtrl(plantService, loaderService, $modal, authDataService) {
        var vm = this;
        vm.plants = [];
        vm.hasPlants = function () {
            return vm.plants && vm.plants.length > 0;
        };
        vm.editPlant = function (plant) {
            if (authDataService.isAPSIOAdmin) {
                editPlant_controller_1.openEditPlant({
                    plant: plant,
                    plants: vm.plants
                }, $modal);
            }
        };
        loaderService.loadingPromise(plantService.getPlants().then(function (plants) {
            vm.plants = plants;
        }));
        return vm;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(2), __webpack_require__(55), __webpack_require__(4), __webpack_require__(12), __webpack_require__(6), __webpack_require__(784), __webpack_require__(9), __webpack_require__(11), __webpack_require__(5), __webpack_require__(785)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, moment, _, plant_service_1, loader_service_1, newguid_service_1, notify_service_1, shiftschedulevalidation_service_1, uiUtility_service_1, dateutility_service_1, aps_enums_1, editPlant_tpl_html_1) {
    "use strict";
    editPlantCtrl.$inject = ["data", "$modalInstance", "plantService", "loaderService", "newGuidService", "notifyService", "shiftScheduleValidationService", "uiUtilityService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [plant_service_1.default, loader_service_1.default, newguid_service_1.default, notify_service_1.default,
        shiftschedulevalidation_service_1.default, uiUtility_service_1.default];
    function openEditPlant(data, $modal) {
        return $modal.open({
            template: editPlant_tpl_html_1.default,
            controller: 'EditPlantCtrl as editPlantCtrl',
            resolve: {
                data: function () {
                    return data;
                }
            }
        }).result;
    }
    exports.openEditPlant = openEditPlant;
    exports.default = angular.module('aps.controller.editPlant', requires)
        .controller('EditPlantCtrl', editPlantCtrl)
        .name;
    function editPlantCtrl(data, $modalInstance, plantService, loaderService, newGuidService, notifyService, shiftScheduleValidationService, uiUtilityService) {
        var vm = this;
        function plantPersisted() {
            _.assign(data.plant, vm.plant);
            vm.close();
        }
        vm.close = function () {
            $modalInstance.close();
        };
        function deriveMinutesFromDate(date) {
            var m = moment(date);
            return m.hour() * 60 + m.minute();
        }
        vm.save = function () {
            if (vm.form.$invalid) {
                return;
            }
            var validationResults = shiftScheduleValidationService.getValidationErrors(vm.plant.shiftSchedules);
            if (validationResults && validationResults.length) {
                _.each(validationResults, function (result) {
                    notifyService.error(result);
                });
                return;
            }
            vm.plant.morningMinutesStartMinute = deriveMinutesFromDate(vm.morningMinutesTime);
            var submit = plantService.updatePlant(vm.plant);
            loaderService.loadingPromise(submit.then(plantPersisted, notifyService.handleApiErrors));
        };
        vm.addShift = function () {
            loaderService.loadingPromise(newGuidService.getNewGuid('shift').then(function (newGuid) {
                vm.plant.shiftSchedules = vm.plant.shiftSchedules || [];
                vm.plant.shiftSchedules.push({
                    id: newGuid,
                    startMinute: null,
                    stopMinute: null,
                    name: null
                });
            }, notifyService.handleApiErrors));
        };
        vm.deleteShift = function (shift) {
            _.remove(vm.plant.shiftSchedules, { id: shift.id });
        };
        function getIntervals(minuteInterval) {
            var shiftTimes = [];
            var startOfDay = moment().startOf('day');
            for (var i = 0; i < 24 * 60; i += minuteInterval) {
                shiftTimes.push({ minute: i, clockTime: startOfDay.clone().add(i, 'm').format('LT') });
            }
            return shiftTimes;
        }
        function getMorningMinutesTime() {
            return moment().startOf('day').add(data.plant.morningMinutesStartMinute, 'm').toDate();
        }
        function getShiftTimes() {
            return getIntervals(60);
        }
        vm.plant = _.cloneDeep(data.plant);
        vm.plants = data.plants;
        vm.timeZones = dateutility_service_1.TimeZoneService.getTimeZones();
        vm.shiftTimes = getShiftTimes();
        vm.morningMinutesTime = getMorningMinutesTime();
        vm.countRejectPercents = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.CountRejectPercent);
        return vm;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var minutesInDay = 24 * 60;
    var ShiftScheduleValidationSvc = (function () {
        function ShiftScheduleValidationSvc() {
        }
        ShiftScheduleValidationSvc.prototype.getValidationErrors = function (shiftSchedules) {
            if (!shiftSchedules || !shiftSchedules.length) {
                return ['Shift schedule is required'];
            }
            var errors = [];
            var validateEntireDayCoverage = function () {
                var shiftIntervalSum = _.sum(_.map(shiftSchedules, function (shift) {
                    var stop = (shift.startMinute >= shift.stopMinute) ? shift.stopMinute + minutesInDay : shift.stopMinute;
                    return stop - shift.startMinute;
                }));
                if (shiftIntervalSum < minutesInDay) {
                    errors.push('Shift schedule must cover the entire day');
                }
            };
            var validateShiftOverlaps = function () {
                var sortedShifts = _.sortBy(shiftSchedules, 'startMinute');
                var lastStop = _.last(sortedShifts).stopMinute;
                _.each(sortedShifts, function (shift) {
                    if (shift.startMinute !== lastStop) {
                        errors.push('Shift schedule must not overlap');
                        return false;
                    }
                    lastStop = shift.stopMinute;
                });
            };
            validateEntireDayCoverage();
            if (0 === errors.length) {
                validateShiftOverlaps();
            }
            return errors;
        };
        return ShiftScheduleValidationSvc;
    }());
    exports.default = angular
        .module('aps.services.shiftschedulevalidation', [])
        .service('shiftScheduleValidationService', ShiftScheduleValidationSvc)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <form name=editPlantCtrl.form ng-submit=editPlantCtrl.save() novalidate> <h2 class=modal-header>Edit Plant</h2> <div class=container> <label> <span class=\"required notated\">*</span>Name <input type=text name=name ng-model=editPlantCtrl.plant.name required/> <div ng-messages=editPlantCtrl.form.name.$error ng-if=\"editPlantCtrl.form.name.$dirty || editPlantCtrl.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> <label> <span class=\"required notated\">*</span>Plant Number <input type=text name=plantNumber ng-model=editPlantCtrl.plant.plantNumber required/> <div ng-messages=editPlantCtrl.form.plantNumber.$error ng-if=\"editPlantCtrl.form.plantNumber.$dirty || editPlantCtrl.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> <label> <span class=\"required notated\">*</span>Time Zone ID <select name=timeZoneId required ng-model=editPlantCtrl.plant.timeZoneId ng-options=\"tz for tz in editPlantCtrl.timeZones\"> <option value=\"\">-- Select a Time Zone --</option> </select> <div ng-messages=editPlantCtrl.form.timeZoneId.$error ng-if=\"editPlantCtrl.form.timeZoneId.$dirty || editPlantCtrl.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> <label> <span class=\"required notated\">*</span>Morning Minutes Report Schedule <input type=time ng-model=editPlantCtrl.morningMinutesTime /> </label> <label> <span class=\"required notated\">*</span>Count Reject Percent Preference <select name=countRejectPercent required ng-model=editPlantCtrl.plant.countRejectPercent ng-options=\"t.value as t.text for t in editPlantCtrl.countRejectPercents\"> <option value=\"\">-- Select a Percent Preference --</option> </select> <div ng-messages=editPlantCtrl.form.countRejectPercent.$error ng-if=\"editPlantCtrl.form.countRejectPercent.$dirty || editPlantCtrl.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> <div> <label>Shift Schedule</label> <table class=history-t> <thead> <th>Name</th> <th>Start</th> <th>Stop</th> <th></th> </thead> <tr ng-repeat=\"shift in editPlantCtrl.plant.shiftSchedules | orderBy: 'startMinute'\"> <td> <input type=text name=\"shiftName_{{$index}}\" ng-model=shift.name required/> <span class=error ng-show=\"editPlantCtrl.form.shiftName_{{$index}}.$error.required && (editPlantCtrl.form.shiftName_{{$index}}.$dirty || editPlantCtrl.form.$submitted)\">Required!</span> </td> <td> <select name=\"startMinute_{{$index}}\" ng-model=shift.startMinute ng-options=\"st.minute as st.clockTime for st in editPlantCtrl.shiftTimes\" required> <option value=\"\">-- Select a Start Time --</option> </select> <span class=error ng-show=\"editPlantCtrl.form.startMinute_{{$index}}.$error.required && (editPlantCtrl.form.startMinute_{{$index}}.$dirty || editPlantCtrl.form.$submitted)\">Required!</span> </td> <td> <select name=\"stopMinute_{{$index}}\" ng-model=shift.stopMinute ng-options=\"st.minute as st.clockTime for st in editPlantCtrl.shiftTimes\" required> <option value=\"\">-- Select a Stop Time --</option> </select> <span class=error ng-show=\"editPlantCtrl.form.stopMinute_{{$index}}.$error.required && (editPlantCtrl.form.stopMinute_{{$index}}.$dirty || editPlantCtrl.form.$submitted)\">Required!</span> </td> <td><a ng-click=editPlantCtrl.deleteShift(shift) style=color:red;position:relative;top:-6px><i class=\"fa fa-times\"></i></a></td> </tr> <tr> <td colspan=3><a ng-click=editPlantCtrl.addShift()>Add Shift</a></td> </tr> </table> </div> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-12 columns\"> <span class=required>* Required Fields</span> <div class=dialog-footer> <input type=submit class=button value=Save /> <button ng-click=\"editPlantCtrl.close(); $event.preventDefault();\" class=\"button secondary\">Close</button> </div> </div> </div> </form> </div> ");

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <div class=body-header><h2>Plants</h2></div> <table cellpadding=1 cellspacing=1 class=history-t> <tr> <th>Plant Number</th> <th>Plant Name</th> <th>Time Zone ID</th> </tr> <tr ng-repeat=\"plant in plantsCtrl.plants | orderBy: 'name'\" ng-click=plantsCtrl.editPlant(plant)> <td>{{ plant.plantNumber }}</td> <td>{{ plant.name }}</td> <td>{{ plant.timeZoneId }}</td> </tr> <tr colspan=3 ng-if=!plantsCtrl.hasPlants()> <td>No Plants Loaded</td> </tr> </table> <div></div> </div> ");

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(2), __webpack_require__(788), __webpack_require__(4), __webpack_require__(26), __webpack_require__(11), __webpack_require__(9), __webpack_require__(8), __webpack_require__(3), __webpack_require__(789)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, moment, _, cavityEfficiencyReport_tpl_html_1, loader_service_1, counts_service_1, dateutility_service_1, uiUtility_service_1, navigation_service_1, constant_module_1, cavityEfficiencySummaryGraph_directive_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, counts_service_1.default, uiUtility_service_1.default, navigation_service_1.default, cavityEfficiencySummaryGraph_directive_1.default];
    var CavityEfficiencyReportCtrl = (function () {
        CavityEfficiencyReportCtrl.$inject = ["navigationService", "countsService", "uiUtilityService", "loaderService", "$anchorScroll", "$location", "$state", "$q", "$stateParams", "$timeout"];
        function CavityEfficiencyReportCtrl(navigationService, countsService, uiUtilityService, loaderService, $anchorScroll, $location, $state, $q, $stateParams, $timeout) {
            var _this = this;
            this.loaderService = loaderService;
            this.countsService = countsService;
            this.uiUtilityService = uiUtilityService;
            this.$anchorScroll = $anchorScroll;
            this.$location = $location;
            this.$state = $state;
            this.$q = $q;
            this.$stateParams = $stateParams;
            this.$timeout = $timeout;
            this.requirePlantSelection = true;
            this.requireShopSelection = true;
            this.detailGraphHeight = '500px';
            this.detailHorizontalBarHeight = 40;
            var now = moment().add(1, 'hours').startOf('hour');
            this.uiEndDate = now.toDate();
            this.uiStartDate = now.clone().subtract(1, 'days').toDate();
            var promise = navigationService.getNavigation().then(function (nav) {
                _this.plants = nav.plants();
                _this.selectedPlant = nav.selectedPlant;
                _this.updatePlant();
                _this.selectedShop = nav.selectedShop;
                return _this.loadState($stateParams);
            });
            loaderService.loadingPromise(promise);
            this.scopeWorkaround = {
                cavityBarClick: function (summary) {
                    _this.generateDetailReport(summary);
                }
            };
        }
        CavityEfficiencyReportCtrl.prototype.generateReport = function () {
            if (this.form.$invalid) {
                return;
            }
            this.saveState(undefined);
            var promise = this.runReport();
            this.loaderService.loadingPromise(promise);
            return promise;
        };
        CavityEfficiencyReportCtrl.prototype.runReport = function () {
            var _this = this;
            this.reportShopId = this.selectedShop.id;
            this.reportShopName = this.selectedShop.name;
            this.reportStartDate = this.startDate;
            this.reportEndDate = this.endDate;
            this.reportTimeZoneId = this.selectedPlant.timeZoneId;
            this.cavities = [];
            this.detailResultsPretty = [];
            this.searchPerformed = false;
            return this.countsService.getCavityEfficiency(this.reportShopId, this.reportStartDate, this.reportEndDate)
                .then(function (cavities) {
                _this.cavities = cavities;
                _this.searchPerformed = true;
                return _this.$q.when();
            });
        };
        CavityEfficiencyReportCtrl.prototype.formatTime = function (time) {
            return dateutility_service_1.default.formatTime(time, this.reportTimeZoneId);
        };
        CavityEfficiencyReportCtrl.prototype.updatePlant = function () {
            this.selectedShop = null;
        };
        CavityEfficiencyReportCtrl.prototype.generateDetailReport = function (summary) {
            var cavity = summary ? summary.cavity : '';
            this.saveState(cavity);
            this.runDetailReport(summary);
        };
        CavityEfficiencyReportCtrl.prototype.runDetailReport = function (summary) {
            var _this = this;
            this.$timeout(function () {
                _this.detailResultsPretty = [];
            });
            this.$timeout(function () {
                if (summary.details) {
                    var totalDefectCount_1 = _.sum(_.map(summary.details, function (detail) { return detail.rejectCount; }));
                    _.forEach(summary.details, function (detail) {
                        var rejectPct = parseFloat(((detail.rejectCount / totalDefectCount_1) * 100).toFixed(1));
                        _this.detailResultsPretty.push({
                            'Defect': detail.defect,
                            'Reject Pct': rejectPct,
                            'Label': [detail.defect, rejectPct + "%", detail.rejectCount]
                        });
                    });
                    _this.detailGraphHeight = (100 + _this.detailResultsPretty.length * _this.detailHorizontalBarHeight) + "px";
                }
            });
        };
        CavityEfficiencyReportCtrl.prototype.loadState = function (params) {
            var _this = this;
            if (params.reportPlantId && params.reportShopId && params.reportShopId !== params.shopId) {
                var plant = _.find(this.plants, { id: params.reportPlantId });
                if (plant) {
                    var shop = _.find(plant.shops, { id: params.reportShopId });
                    if (shop) {
                        this.selectedPlant = plant;
                        this.selectedShop = shop;
                    }
                }
            }
            dateutility_service_1.default.setReportDates(this, params, this.$timeout);
            if (params.autoRun) {
                return this.runReport().then(function () {
                    var targetSummary = _.find(_this.cavities, { cavity: params.cavity });
                    if (targetSummary) {
                        _this.runDetailReport(targetSummary);
                        _this.$location.hash('detailResultsMarker');
                        _this.$anchorScroll();
                    }
                });
            }
            return this.$q.when();
        };
        CavityEfficiencyReportCtrl.prototype.saveState = function (cavity) {
            var reportShopId = this.selectedShop ? this.selectedShop.id : undefined;
            if (reportShopId === this.$stateParams.shopId) {
                reportShopId = undefined;
            }
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportPlantId: (reportShopId && this.selectedPlant) ? this.selectedPlant.id : undefined,
                reportShopId: reportShopId,
                startDate: this.startDate ? this.startDate.toISOString() : undefined,
                endDate: this.endDate ? this.endDate.toISOString() : undefined,
                autoRun: true,
                cavity: cavity
            };
            this.$state.transitionTo(this.$state.current.name, params);
        };
        return CavityEfficiencyReportCtrl;
    }());
    exports.default = angular.module('aps.controller.cavityEfficiencyReport', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.CAVITY_EFFICIENCY,
            url: '/admin/reports/cavityEfficiency?startDate&endDate&autoRun&reportPlantId&reportShopId&cavity',
            params: {
                startDate: { dynamic: true },
                endDate: { dynamic: true },
                autoRun: { dynamic: true },
                reportPlantId: { dynamic: true },
                reportShopId: { dynamic: true },
                cavity: { dynamic: true }
            },
            controller: 'CavityEfficiencyReportCtrl as vm',
            template: cavityEfficiencyReport_tpl_html_1.default,
            data: {
                pageTitle: 'Cavity Efficiency Report'
            }
        });
    }])
        .controller('CavityEfficiencyReportCtrl', CavityEfficiencyReportCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div class=body-header> <h2>Cavity Efficiency Report</h2> </div> <aps-common-report-query-criteria-row vm=vm></aps-common-report-query-criteria-row> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-12 columns\"> <button type=submit class=button>Generate Report</button> </div> </div> </form> <div ng-if=\"vm.cavities \"> <label> Cavities on Shop {{ vm.reportShopName }} from {{ vm.formatTime(vm.reportStartDate) }} to {{ vm.formatTime(vm.reportEndDate) }} </label> <div> <aps-cavity-efficiency-summary-graph cavities=vm.cavities cavity-selected=vm.scopeWorkaround.cavityBarClick> </aps-cavity-efficiency-summary-graph> </div> <div> <dimple-graph ng-if=\"vm.detailResultsPretty && vm.detailResultsPretty.length > 0\" data=vm.detailResultsPretty wrap-x-labels=false wrap-y-labels=true transition=0 width=100% height=\"{{ vm.detailGraphHeight }}\" margin=4%,20px|40px|2%|10%,20px> <dimple-x field=\"Reject Pct\" type=Measure title=\"Percentage of inspected ware with defect\" font-size=9px></dimple-x> <dimple-y field=Defect type=Category title=null order-by=\"Reject Pct\"></dimple-y> <dimple-bar field=Defect show-labels=true is-horizontal=true text-anchor=end></dimple-bar> </dimple-graph> </div> </div> </div>");

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(309), __webpack_require__(790)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, cavityEfficiencySummaryGraph_controller_1, cavityEfficiencySummaryGraph_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function cavityEfficiencySummaryGraphDef() {
        return {
            restrict: 'E',
            template: cavityEfficiencySummaryGraph_tpl_html_1.default,
            replace: true,
            controller: 'CavityEfficiencySummaryGraphCtrl',
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                cavities: '=',
                cavitySelected: '=',
                showIfEmpty: '='
            },
            link: function ($scope) {
                $scope.$watchCollection('vm.cavities', function (newVal) {
                    $scope.vm.setCavities(newVal);
                });
            }
        };
    }
    exports.default = angular.module('aps.directive.cavityEfficiencySummaryGraph', [cavityEfficiencySummaryGraph_controller_1.default])
        .directive('apsCavityEfficiencySummaryGraph', cavityEfficiencySummaryGraphDef)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <high-chart options=vm.options style=height:500px;width:100%;display:block;overflow:hidden /> <div ng-if=\"!vm.showIfEmpty && vm.options.series && !vm.options.series.length\"> No Cavities for this Shop </div> </div>");

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(2), __webpack_require__(792), __webpack_require__(4), __webpack_require__(26), __webpack_require__(11), __webpack_require__(9), __webpack_require__(8), __webpack_require__(3), __webpack_require__(793), __webpack_require__(34)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, moment, _, cavityCorrelationReport_tpl_html_1, loader_service_1, counts_service_1, dateutility_service_1, uiUtility_service_1, navigation_service_1, constant_module_1, cavityCorrelationSummaryGraph_directive_1, Highcharts) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, counts_service_1.default, uiUtility_service_1.default, navigation_service_1.default, cavityCorrelationSummaryGraph_directive_1.default];
    function genericBarChart() {
        return {
            restrict: 'E',
            template: '<div></div>',
            scope: {
                options: '='
            },
            link: function (scope, element, attributes) {
                angular.element(document).ready(function () {
                    try {
                        var jsonData = JSON.parse(attributes.data);
                        if (attributes.data !== null && jsonData.length >= 1 && attributes.data !== '[0,0,0,0]') {
                            scope.options.series[0].data = jsonData;
                            var chart = new Highcharts.Chart(element[0], scope.options);
                            chart.redraw();
                        }
                    }
                    catch (e) {
                        return false;
                    }
                    scope.$watch(function () {
                        return element.attr('data');
                    }, function (newValue) {
                        try {
                            var jsonData = JSON.parse(attributes.data);
                            if (newValue !== null && jsonData.length >= 1 && newValue !== '[0,0,0,0]') {
                                scope.options.series[0].data = jsonData;
                                var chart = new Highcharts.Chart(element[0], scope.options);
                                chart.redraw();
                            }
                        }
                        catch (e) {
                            return false;
                        }
                    });
                });
            }
        };
    }
    var CavityCorrelationReportCtrl = (function () {
        CavityCorrelationReportCtrl.$inject = ["navigationService", "countsService", "uiUtilityService", "loaderService", "$anchorScroll", "$location", "$state", "$q", "$stateParams", "$timeout"];
        function CavityCorrelationReportCtrl(navigationService, countsService, uiUtilityService, loaderService, $anchorScroll, $location, $state, $q, $stateParams, $timeout) {
            var _this = this;
            this.loaderService = loaderService;
            this.countsService = countsService;
            this.uiUtilityService = uiUtilityService;
            this.$anchorScroll = $anchorScroll;
            this.$location = $location;
            this.$state = $state;
            this.$q = $q;
            this.$stateParams = $stateParams;
            this.$timeout = $timeout;
            this.requirePlantSelection = true;
            this.requireShopSelection = true;
            this.detailGraphHeight = '500px';
            this.detailHorizontalBarHeight = 40;
            var now = moment().add(1, 'hours').startOf('hour');
            this.uiEndDate = now.toDate();
            this.uiStartDate = now.clone().subtract(1, 'days').toDate();
            var promise = navigationService.getNavigation().then(function (nav) {
                _this.plants = nav.plants();
                _this.selectedPlant = nav.selectedPlant;
                _this.updatePlant();
                _this.selectedShop = nav.selectedShop;
                return _this.loadState($stateParams);
            });
            loaderService.loadingPromise(promise);
            this.scopeWorkaround = {
                cavityBarClick: function (summary) {
                    _this.showCharts = false;
                    _this.generateDetailReport(summary);
                }
            };
        }
        CavityCorrelationReportCtrl.prototype.getCorrelationChart = function () {
            return {
                chart: {
                    type: 'bar',
                    height: (100 + this.defectData.length * this.detailHorizontalBarHeight) + "px"
                },
                credits: {
                    enabled: false
                },
                yAxis: {
                    title: {
                        enabled: false
                    }
                },
                xAxis: {
                    type: 'category'
                },
                title: {
                    text: 'Defects for Cavity'
                },
                legend: {
                    enabled: false
                },
                series: [{
                        colorByPoint: true,
                        name: 'Reject Count',
                        data: this.defectData
                    }]
            };
        };
        CavityCorrelationReportCtrl.prototype.generateReport = function () {
            if (this.form.$invalid) {
                return;
            }
            this.saveState(undefined);
            var promise = this.runReport();
            this.loaderService.loadingPromise(promise);
            return promise;
        };
        CavityCorrelationReportCtrl.prototype.runReport = function () {
            var _this = this;
            this.reportShopId = this.selectedShop.id;
            this.reportShopName = this.selectedShop.name;
            this.reportStartDate = this.startDate;
            this.reportEndDate = this.endDate;
            this.reportTimeZoneId = this.selectedPlant.timeZoneId;
            this.cavities = [];
            this.searchPerformed = false;
            return this.countsService.getCavityCorrelation(this.reportShopId, this.reportStartDate, this.reportEndDate)
                .then(function (cavities) {
                _this.cavities = cavities;
                _this.searchPerformed = true;
                return _this.$q.when();
            });
        };
        CavityCorrelationReportCtrl.prototype.formatTime = function (time) {
            return dateutility_service_1.default.formatTime(time, this.reportTimeZoneId);
        };
        CavityCorrelationReportCtrl.prototype.updatePlant = function () {
            this.selectedShop = null;
        };
        CavityCorrelationReportCtrl.prototype.generateDetailReport = function (summary) {
            var cavity = summary ? summary.cavity : '';
            this.saveState(cavity);
            this.runDetailReport(summary);
        };
        CavityCorrelationReportCtrl.prototype.runDetailReport = function (summary) {
            var _this = this;
            this.$timeout(function () {
                _this.defectData = [];
                _this.selectedCavity = {};
            });
            this.$timeout(function () {
                if (summary.details) {
                    _this.defectData = [];
                    _.map(summary.details, function (detail) {
                        var point = {
                            name: detail.defect,
                            y: detail.rejectCount
                        };
                        _this.defectData.push(point);
                    });
                }
                _this.selectedCavity = summary;
                _this.correlationChartConfig = _this.getCorrelationChart();
                _this.showCharts = true;
                console.log('showcharts/summary', _this.showCharts, _this.selectedCavity);
            });
        };
        CavityCorrelationReportCtrl.prototype.loadState = function (params) {
            var _this = this;
            if (params.reportPlantId && params.reportShopId && params.reportShopId !== params.shopId) {
                var plant = _.find(this.plants, { id: params.reportPlantId });
                if (plant) {
                    var shop = _.find(plant.shops, { id: params.reportShopId });
                    if (shop) {
                        this.selectedPlant = plant;
                        this.selectedShop = shop;
                    }
                }
            }
            dateutility_service_1.default.setReportDates(this, params, this.$timeout);
            if (params.autoRun) {
                return this.runReport().then(function () {
                    var targetSummary = _.find(_this.cavities, { cavity: params.cavity });
                    if (targetSummary) {
                        _this.runDetailReport(targetSummary);
                        _this.$location.hash('detailResultsMarker');
                        _this.$anchorScroll();
                    }
                });
            }
            return this.$q.when();
        };
        CavityCorrelationReportCtrl.prototype.saveState = function (cavity) {
            var reportShopId = this.selectedShop ? this.selectedShop.id : undefined;
            if (reportShopId === this.$stateParams.shopId) {
                reportShopId = undefined;
            }
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportPlantId: (reportShopId && this.selectedPlant) ? this.selectedPlant.id : undefined,
                reportShopId: reportShopId,
                startDate: this.startDate ? this.startDate.toISOString() : undefined,
                endDate: this.endDate ? this.endDate.toISOString() : undefined,
                autoRun: true,
                cavity: cavity
            };
            this.$state.transitionTo(this.$state.current.name, params);
        };
        return CavityCorrelationReportCtrl;
    }());
    exports.default = angular.module('aps.controller.cavityCorrelationReport', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.CAVITY_CORRELATION,
            url: '/admin/reports/cavityCorrelation?startDate&endDate&autoRun&reportPlantId&reportShopId&cavity',
            params: {
                startDate: { dynamic: true },
                endDate: { dynamic: true },
                autoRun: { dynamic: true },
                reportPlantId: { dynamic: true },
                reportShopId: { dynamic: true },
                cavity: { dynamic: true }
            },
            controller: 'CavityCorrelationReportCtrl as vm',
            template: cavityCorrelationReport_tpl_html_1.default,
            data: {
                pageTitle: 'Cavity Correlation Report'
            }
        });
    }])
        .controller('CavityCorrelationReportCtrl', CavityCorrelationReportCtrl)
        .directive('correlationChart', genericBarChart)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div class=body-header> <h2>Cavity Correlation Report</h2> </div> <aps-common-report-query-criteria-row vm=vm></aps-common-report-query-criteria-row> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-12 columns\"> <button type=submit class=button>Generate Report</button> </div> </div> </form> <div ng-if=vm.cavities> <label> Cavities on Shop {{ vm.reportShopName }} from {{ vm.formatTime(vm.reportStartDate) }} to {{ vm.formatTime(vm.reportEndDate) }} </label> <div> <aps-cavity-correlation-summary-graph cavities=vm.cavities cavity-selected=vm.scopeWorkaround.cavityBarClick> </aps-cavity-correlation-summary-graph> </div> <div ng-if=vm.selectedCavity> <h5 class=text-center><b>Selected Cavity: {{vm.selectedCavity.cavity}}</b></h5> <h5 class=text-center>Total Inspected for Cavity: {{vm.selectedCavity.inspectCount}}</h5> <h5 class=text-center>Total Rejected for Cavity: {{vm.selectedCavity.rejectCount}}</h5> </div> <div ng-if=vm.showCharts> <correlation-chart options=vm.correlationChartConfig data=\"{{vm.defectData}}\" style=display:block;width:100%> </correlation-chart> </div> </div> </div>");

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(310), __webpack_require__(794)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, cavityCorrelationSummaryGraph_controller_1, cavityCorrelationSummaryGraph_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.directive.cavityCorrelationSummaryGraph', [cavityCorrelationSummaryGraph_controller_1.default])
        .directive('apsCavityCorrelationSummaryGraph', cavityCorrelationSummaryGraphDef)
        .name;
    function cavityCorrelationSummaryGraphDef() {
        return {
            restrict: 'E',
            template: cavityCorrelationSummaryGraph_tpl_html_1.default,
            replace: true,
            controller: 'CavityCorrelationSummaryGraphCtrl',
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                cavities: '=',
                cavitySelected: '=',
                showIfEmpty: '='
            },
            link: function ($scope) {
                $scope.$watchCollection('vm.cavities', function () {
                    $scope.vm.setCavities();
                    $scope.vm.setTopDefects();
                });
            }
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <div class=bs-row> <div class=bs-col-md-3> <table class=history-t ng-if=\"vm.showIfEmpty || (vm.topDefects && vm.topDefects.length)\" style=\"border:1px solid #d3d3d3\"> <caption> <b>Top 5 Defects by Total Bottles Rejected</b> </caption> <thead> <tr> <th>Defect</th> <th style=text-align:right>Mold</th> <th style=text-align:right>Cavity</th> <th style=text-align:right>Reject Count</th> </tr> </thead> <tbody> <tr ng-repeat=\"topDefect in vm.topDefects\"> <td><b>{{topDefect.defect}}</b></td> <td style=text-align:right><b>{{topDefect.mold}}</b></td> <td style=text-align:right><b>{{topDefect.cavity}}</b></td> <td style=text-align:right><b>{{topDefect.rejectCount}}</b></td> </tr> </tbody> </table> </div> <!-- MNR's and ?? --> <div class=bs-col-md-9> <table ng-if=\"vm.showIfEmpty || (vm.cavityMNR && vm.cavityQuestion)\" style=margin-left:auto;margin-right:auto> <tbody> <tr> <td style=\"border:'1px solid black';vertical-align:text-top\" ng-style=\"{'background-color': vm.cavityMNR.Color}\" ng-click=vm.cavityClicked(vm.cavityMNR.Cavity)> <div style=\"padding:15px 5px 5px 5px;text-align:center;min-width:200px;max-width:1100px\"> <b>Mold Not Readable</b><br/><br/><br/> <b>Inspect: {{vm.cavityMNR.Inspect}}</b><br/> <b>Reject: {{vm.cavityMNR.Reject}}</b><br/> <b>{{vm.cavityMNR.Percent}}</b><br/> <b>{{vm.cavityMNR.TopDefect}}</b> </div> </td> <td ng-style=\"{'border': '1px solid black', 'background-color': vm.cavityQuestion.Color, 'vertical-align': 'text-top'}\" ng-click=vm.cavityClicked(vm.cavityQuestion.Cavity)> <div style=\"padding:15px 5px 5px 5px;text-align:center;min-width:200px;max-width:1100px\"> <b>Mold Not Mapped</b><br/> <b>{{vm.cavityQuestion.MoldNumbers}}</b><br/><br/> <b>Inspect: {{vm.cavityQuestion.Inspect}}</b><br/> <b>Reject: {{vm.cavityQuestion.Reject}}</b><br/> <b>{{vm.cavityQuestion.Percent}}</b><br/> <b>{{vm.cavityQuestion.TopDefect}}</b> </div> </td> </tr> </tbody> </table> </div> </div> <hr style=\"border-top:0 solid grey\"/> <!-- Cavity Correlations --> <div> <table ng-if=\"vm.showIfEmpty || (vm.cavities && vm.cavities.length)\" style=width:100%> <thead> <tr> <th></th> <th ng-repeat=\"section in vm.sectionList | orderBy:'section'\">{{section}}</th> </tr> </thead> <tbody> <tr ng-if=\"vm.showIfEmpty || (vm.cavitiesBack && vm.cavitiesBack.length)\"> <th style=transform:rotate(-90deg);font-size:12px>Back</th> <td ng-repeat=\"cavity in vm.cavitiesBack | orderBy:'Section'\" ng-style=\"{'border': '1px solid black', 'background-color': cavity.Color, 'vertical-align': 'text-top'}\" ng-click=vm.cavityClicked(cavity.Cavity)> <div style=\"padding:15px 2px 5px 2px;text-align:center;min-width:95px\"> <b><span style=color:#fff8dc>{{cavity.MoldNumbers}}</span>{{cavity.MostRecentCavity}}</b><br/><br/> <b>{{cavity.Percent}}</b><br/> <b>{{cavity.TopDefect}}</b> </div> </td> </tr> <tr ng-if=\"vm.showIfEmpty || (vm.cavitiesMiddle && vm.cavitiesMiddle.length)\"> <th style=transform:rotate(-90deg);font-size:12px>Middle</th> <td ng-repeat=\"cavity in vm.cavitiesMiddle | orderBy:'Section'\" ng-style=\"{'border': '1px solid black', 'background-color': cavity.Color, 'vertical-align': 'text-top'}\" ng-click=vm.cavityClicked(cavity.Cavity)> <div style=\"padding:15px 2px 5px 2px;text-align:center;min-width:95px\"> <b><span style=color:#fff8dc>{{cavity.MoldNumbers}}</span>{{cavity.MostRecentCavity}}</b><br/><br/> <b>{{cavity.Percent}}</b><br/> <b>{{cavity.TopDefect}}</b> </div> </td> </tr> <tr ng-if=\"vm.showIfEmpty || (vm.cavitiesFront && vm.cavitiesFront.length)\"> <th style=transform:rotate(-90deg);font-size:12px>Front</th> <td ng-repeat=\"cavity in vm.cavitiesFront | orderBy:'Section'\" ng-style=\"{'border': '1px solid black', 'background-color': cavity.Color, 'vertical-align': 'text-top'}\" ng-click=vm.cavityClicked(cavity.Cavity)> <div style=\"padding:15px 2px 5px 2px;text-align:center;min-width:95px\"> <b><span style=color:#fff8dc>{{cavity.MoldNumbers}}</span>{{cavity.MostRecentCavity}}</b><br/><br/> <b>{{cavity.Percent}}</b><br/> <b>{{cavity.TopDefect}}</b> </div> </td> </tr> </tbody> </table> </div> <!-- show if no cavities --> <div ng-if=\"!vm.showIfEmpty && vm.cavities && !vm.cavities.length\"> No Cavities for this Shop </div> </div>");

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(796), __webpack_require__(3), __webpack_require__(9), __webpack_require__(23), __webpack_require__(4), __webpack_require__(34), __webpack_require__(27), __webpack_require__(50), __webpack_require__(7), __webpack_require__(1), __webpack_require__(797), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, flexIsDetails_tpl_html_1, constant_module_1, uiUtility_service_1, shops_service_1, loader_service_1, Highcharts, enums_1, interval_factory_1, authData_service_1, moment, flexIsDetails_service_1, aps_enums_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [
        uiUtility_service_1.default,
        shops_service_1.default,
        loader_service_1.default,
        authData_service_1.default,
        flexIsDetails_service_1.default
    ];
    var FlexIsDetailsController = (function () {
        FlexIsDetailsController.$inject = ["$stateParams", "shopService", "loaderService", "$scope", "uiUtilityService", "authDataService", "flexIsDetailsService", "$state", "$interval", "$q"];
        function FlexIsDetailsController($stateParams, shopService, loaderService, $scope, uiUtilityService, authDataService, flexIsDetailsService, $state, $interval, $q) {
            var _this = this;
            this.interval = null;
            this.plantId = $stateParams.plantId;
            this.shopId = $stateParams.shopId;
            this.loaderService = loaderService;
            this.shopService = shopService;
            this.shopName = null;
            this.plantName = null;
            this.flexIsDetailsService = flexIsDetailsService;
            this.$state = $state;
            this.$scope = $scope;
            this.uiUtilityService = uiUtilityService;
            this.authDataService = authDataService;
            this.$interval = $interval;
            this.$q = $q;
            this.$scope.$on('$destroy', function () {
                _this.destroyInterval();
            });
            this.createInterval();
            this.initPage();
        }
        FlexIsDetailsController.prototype.createInterval = function () {
            var _this = this;
            this.interval = new interval_factory_1.Interval(function () {
                _this.update();
            }, this.$interval, 1000 * 60 * 5);
            this.interval.start();
        };
        FlexIsDetailsController.prototype.destroyInterval = function () {
            this.interval.destroy();
            this.interval = null;
        };
        FlexIsDetailsController.prototype.countsIntervalChanged = function () {
            this.mapCountInterval();
            this.update();
        };
        FlexIsDetailsController.prototype.initPage = function () {
            var _this = this;
            this.loaderService.setAppLoading(true);
            this.shopService.getShopConfiguration(this.shopId)
                .then(function (shop) {
                _this.shopName = shop.name;
                _this.plantName = shop.plantName;
                _this.shopConfig = shop;
            })
                .then(function () {
                _this.countDisplayIntervalOptions = _this.uiUtilityService
                    .getListOptionsFromEnum(enums_1.apsDisplayEnums.CountDisplayInterval, null, null, function (o) { return o; });
            })
                .then(function () {
                _this.countsInterval = _this.authDataService.getCountInterval();
                _this.mapCountInterval();
            })
                .then(function () {
                _this.flexIsDetailsService
                    .getFlexIsDetails(_this.shopId, _this.startDate, _this.endDate)
                    .then(function (result) {
                    _this.mapResult(result);
                    _this.loaderService.setAppLoading(false);
                });
            });
        };
        FlexIsDetailsController.prototype.update = function () {
            var _this = this;
            this.loaderService.setAppLoading(true);
            this.flexIsDetailsService
                .getFlexIsDetails(this.shopId, this.startDate, this.endDate)
                .then(function (result) {
                _this.mapResult(result);
                _this.loaderService.setAppLoading(false);
            });
        };
        FlexIsDetailsController.prototype.mapResult = function (result) {
            this.bottlesPerMinute = result.bottlesPerMinute || 0.0;
            this.mapSwabbingData(result.swabbingTrendSummaries);
            this.mapWareHandlingInfo(result.warehandling);
            this.mapSectionStatistics(result.sectionCountSummaries);
            this.mapSectionCavitySummary(result.sectionCavityCountSummaries);
            this.mapMachineControllerInfo(result.machineControllerInfo);
            this.hasFlexIS = result.hasFlexIS;
        };
        FlexIsDetailsController.prototype.mapMachineControllerInfo = function (machineControllerInfo) {
            var mcEfficiency = machineControllerInfo.mcEfficiency || 0.0;
            var mcEfficiencyClass = this.getEfficiencyColor(mcEfficiency);
            this.machineControllerInfo = {
                mcEfficiency: mcEfficiency,
                mcEfficiencyClass: mcEfficiencyClass
            };
        };
        FlexIsDetailsController.prototype.mapSectionCavitySummary = function (sectionCavityCountSummaries) {
            var rpcRejectsBack = [];
            var rpcRejectsMiddle = [];
            var rpcRejectsFront = [];
            var blankPanelRejectsBack = [];
            var blankPanelRejectsMiddle = [];
            var blankPanelRejectsFront = [];
            var blowPanelRejectsBack = [];
            var blowPanelRejectsMiddle = [];
            var blowPanelRejectsFront = [];
            sectionCavityCountSummaries.forEach(function (x) {
                x.details.forEach(function (y) {
                    if (y.aliasId === aps_enums_1.apsEnums.FlexISDataPointAliases.SC_RJ_SRV_X && y.cavity === "B") {
                        rpcRejectsBack.push({
                            section: x.displaySection,
                            count: y.count
                        });
                    }
                    else if (y.aliasId === aps_enums_1.apsEnums.FlexISDataPointAliases.SC_RJ_SRV_X && y.cavity === "M") {
                        rpcRejectsMiddle.push({
                            section: x.displaySection,
                            count: y.count
                        });
                    }
                    else if (y.aliasId === aps_enums_1.apsEnums.FlexISDataPointAliases.SC_RJ_SRV_X && y.cavity === "F") {
                        rpcRejectsFront.push({
                            section: x.displaySection,
                            count: y.count
                        });
                    }
                    else if (y.aliasId === aps_enums_1.apsEnums.FlexISDataPointAliases.SC_RJ_BK_X && y.cavity === "B") {
                        blankPanelRejectsBack.push({
                            section: x.displaySection,
                            count: y.count
                        });
                    }
                    else if (y.aliasId === aps_enums_1.apsEnums.FlexISDataPointAliases.SC_RJ_BK_X && y.cavity === "M") {
                        blankPanelRejectsMiddle.push({
                            section: x.displaySection,
                            count: y.count
                        });
                    }
                    else if (y.aliasId === aps_enums_1.apsEnums.FlexISDataPointAliases.SC_RJ_BK_X && y.cavity === "F") {
                        blankPanelRejectsFront.push({
                            section: x.displaySection,
                            count: y.count
                        });
                    }
                    else if (y.aliasId === aps_enums_1.apsEnums.FlexISDataPointAliases.SC_RJ_BW_X && y.cavity === "B") {
                        blowPanelRejectsBack.push({
                            section: x.displaySection,
                            count: y.count
                        });
                    }
                    else if (y.aliasId === aps_enums_1.apsEnums.FlexISDataPointAliases.SC_RJ_BW_X && y.cavity === "M") {
                        blowPanelRejectsMiddle.push({
                            section: x.displaySection,
                            count: y.count
                        });
                    }
                    else if (y.aliasId === aps_enums_1.apsEnums.FlexISDataPointAliases.SC_RJ_BW_X && y.cavity === "F") {
                        blowPanelRejectsFront.push({
                            section: x.displaySection,
                            count: y.count
                        });
                    }
                });
            });
            this.cavityStatistics = {
                rpcRejectsBack: rpcRejectsBack,
                rpcRejectsMiddle: rpcRejectsMiddle,
                rpcRejectsFront: rpcRejectsFront,
                blankPanelRejectsBack: blankPanelRejectsBack,
                blankPanelRejectsMiddle: blankPanelRejectsMiddle,
                blankPanelRejectsFront: blankPanelRejectsFront,
                blowPanelRejectsBack: blowPanelRejectsBack,
                blowPanelRejectsMiddle: blowPanelRejectsMiddle,
                blowPanelRejectsFront: blowPanelRejectsFront
            };
        };
        FlexIsDetailsController.prototype.mapSectionStatistics = function (sectionCountSummaries) {
            this.sectionNumbers = this.mapSectionNumbers(sectionCountSummaries);
            var sectionEfficiency = this.mapSectionEfficiency(sectionCountSummaries);
            var sectionDetails = _.chain(sectionCountSummaries)
                .map('details')
                .flatten()
                .value();
            var mcGobsCut = this.mapSectionValues(sectionDetails, aps_enums_1.apsEnums.FlexISDataPointAliases.MC_CUT_SC_X);
            var mcGobsNotCut = this.mapSectionValues(sectionDetails, aps_enums_1.apsEnums.FlexISDataPointAliases.MC_NOT_CUT_SC_X);
            var mcGobsDelivered = this.mapSectionValues(sectionDetails, aps_enums_1.apsEnums.FlexISDataPointAliases.MC_DEL_SC_X);
            var scGobsRequested = this.mapSectionValues(sectionDetails, aps_enums_1.apsEnums.FlexISDataPointAliases.SC_REQ);
            var scGobsNotRequested = this.mapSectionValues(sectionDetails, aps_enums_1.apsEnums.FlexISDataPointAliases.SC_NRQ);
            var scGobsDelivered = this.mapSectionValues(sectionDetails, aps_enums_1.apsEnums.FlexISDataPointAliases.SC_DEL);
            var scLostMs = this.mapSectionValues(sectionDetails, aps_enums_1.apsEnums.FlexISDataPointAliases.SC_LOST_MS);
            var scNrqStop = this.mapSectionValues(sectionDetails, aps_enums_1.apsEnums.FlexISDataPointAliases.SC_NRQ_STOP);
            var scDelOff = this.mapSectionValues(sectionDetails, aps_enums_1.apsEnums.FlexISDataPointAliases.SC_NRQ_DEL_OFF);
            var scNrqManSwab = this.mapSectionValues(sectionDetails, aps_enums_1.apsEnums.FlexISDataPointAliases.SC_NRQ_MAN_SWAB);
            var scNrqAltSwab = this.mapSectionValues(sectionDetails, aps_enums_1.apsEnums.FlexISDataPointAliases.SC_NRQ_ALT_SWAB);
            var scRjComo = this.mapSectionValues(sectionDetails, aps_enums_1.apsEnums.FlexISDataPointAliases.SC_RJ_COMO);
            var scRjManSwab = this.mapSectionValues(sectionDetails, aps_enums_1.apsEnums.FlexISDataPointAliases.SC_RJ_MAN_SWAB);
            var scRjAltSwab = this.mapSectionValues(sectionDetails, aps_enums_1.apsEnums.FlexISDataPointAliases.SC_RJ_ALT_SWAB);
            var scRjRpcLoss = this.mapSectionValues(sectionDetails, aps_enums_1.apsEnums.FlexISDataPointAliases.SC_RJ_SRV);
            var scRjBlankPanelLoss = this.mapSectionValues(sectionDetails, aps_enums_1.apsEnums.FlexISDataPointAliases.SC_RJ_BK);
            var scRjBlowPanelLoss = this.mapSectionValues(sectionDetails, aps_enums_1.apsEnums.FlexISDataPointAliases.SC_RJ_BW);
            var scRjWhc = this.mapSectionValues(sectionDetails, aps_enums_1.apsEnums.FlexISDataPointAliases.SC_RJ_WHC);
            var scRjTotal = this.mapSectionValues(sectionDetails, aps_enums_1.apsEnums.FlexISDataPointAliases.SC_RJ);
            this.sectionStatistics = {
                mcGobsCut: mcGobsCut,
                mcGobsNotCut: mcGobsNotCut,
                mcGobsDelivered: mcGobsDelivered,
                scGobsRequested: scGobsRequested,
                scGobsNotRequested: scGobsNotRequested,
                scGobsDelivered: scGobsDelivered,
                scLostMs: scLostMs,
                scNrqStop: scNrqStop,
                scDelOff: scDelOff,
                scNrqManSwab: scNrqManSwab,
                scNrqAltSwab: scNrqAltSwab,
                scRjComo: scRjComo,
                scRjManSwab: scRjManSwab,
                scRjAltSwab: scRjAltSwab,
                scRjRpcLoss: scRjRpcLoss,
                scRjBlankPanelLoss: scRjBlankPanelLoss,
                scRjBlowPanelLoss: scRjBlowPanelLoss,
                scRjWhc: scRjWhc,
                scRjTotal: scRjTotal,
                sectionEfficiency: sectionEfficiency
            };
        };
        FlexIsDetailsController.prototype.mapSectionEfficiency = function (sectionCountSummaries) {
            var sectionEfficiency = [];
            var numberOfSections = sectionCountSummaries.length;
            for (var i = 0; i < numberOfSections; i++) {
                var efficiency = sectionCountSummaries[i].sectionEfficiency || 0.0;
                var efficiencyColor = this.getEfficiencyColor(efficiency);
                sectionEfficiency.push({
                    efficiency: efficiency,
                    efficiencyColor: efficiencyColor
                });
            }
            return sectionEfficiency;
        };
        FlexIsDetailsController.prototype.getEfficiencyColor = function (efficiency) {
            var efficiencyColor = 'danger';
            if (efficiency >= 99) {
                efficiencyColor = 'success';
            }
            else if (efficiency >= 98) {
                efficiencyColor = 'warning';
            }
            return efficiencyColor;
        };
        FlexIsDetailsController.prototype.mapSectionValues = function (sectionDetails, aliasEnum) {
            var sectionValues = _.filter(sectionDetails, { aliasId: aliasEnum });
            return sectionValues;
        };
        FlexIsDetailsController.prototype.mapSectionNumbers = function (sectionCountSummaries) {
            var numberArray = _.flatMap(sectionCountSummaries, function (s) {
                return s.section;
            });
            this.numberOfSections = numberArray.length;
            return numberArray;
        };
        FlexIsDetailsController.prototype.mapWareHandlingInfo = function (warehandling) {
            this.wareHandlingInfo = warehandling;
        };
        FlexIsDetailsController.prototype.mapSwabbingData = function (swabbingTrendSummary) {
            this.chartOptions = this.getChartOptions(swabbingTrendSummary);
            Highcharts.chart('container', this.chartOptions);
        };
        FlexIsDetailsController.prototype.mapCountInterval = function () {
            this.authDataService.setCountInterval(this.countsInterval);
            this.endDate = moment().toDate();
            var now = moment();
            var remainderMinutes = now.minute() % 10;
            var remainderSeconds = now.second();
            var remainderMilliSeconds = now.millisecond();
            switch (this.countsInterval) {
                case enums_1.apsDisplayEnums.CountDisplayInterval.CurrentHour:
                    this.startDate = moment().startOf('hour').toDate();
                    break;
                case enums_1.apsDisplayEnums.CountDisplayInterval.PreviousHour:
                    this.endDate = moment().startOf('hour').toDate();
                    this.startDate = moment(this.endDate).subtract(1, 'hour').toDate();
                    break;
                case enums_1.apsDisplayEnums.CountDisplayInterval.CurrentShift:
                    this.startDate = this.shopConfig.shiftsInLast24Hours[0].startTime;
                    break;
                case enums_1.apsDisplayEnums.CountDisplayInterval.LastShift:
                    this.endDate = this.shopConfig.shiftsInLast24Hours[1].stopTime;
                    this.startDate = this.shopConfig.shiftsInLast24Hours[1].startTime;
                    break;
                case enums_1.apsDisplayEnums.CountDisplayInterval.ShiftBeforeLast:
                    this.endDate = this.shopConfig.shiftsInLast24Hours[2].stopTime;
                    this.startDate = this.shopConfig.shiftsInLast24Hours[2].startTime;
                    break;
                case enums_1.apsDisplayEnums.CountDisplayInterval.RollingHour:
                    this.endDate = moment(now)
                        .subtract(remainderMinutes, 'minute')
                        .subtract(remainderSeconds, 'second')
                        .subtract(remainderMilliSeconds, 'millisecond')
                        .toDate();
                    this.startDate = moment(this.endDate)
                        .subtract(1, 'hour')
                        .toDate();
                    break;
                case enums_1.apsDisplayEnums.CountDisplayInterval.LastTwentyMinutes:
                    this.endDate = moment(now)
                        .subtract(remainderMinutes, 'minute')
                        .subtract(remainderSeconds, 'second')
                        .subtract(remainderMilliSeconds, 'millisecond')
                        .toDate();
                    this.startDate = moment(this.endDate)
                        .subtract(20, 'minute')
                        .toDate();
                    break;
                default:
                    this.endDate = moment().startOf('hour').toDate();
                    this.startDate = moment(this.endDate).subtract(1, 'days').toDate();
                    break;
            }
        };
        FlexIsDetailsController.prototype.getCategories = function () {
            var categoryList = [];
            for (var i = 1; i <= 16; i++) {
                categoryList.push('Section ' + i);
            }
            return categoryList;
        };
        FlexIsDetailsController.prototype.getSampleData = function (details) {
            var sampleSeries = [];
            details.forEach(function (x) {
                var dateTime = new Date(x.isoTimeStamp);
                var datapoint = {
                    x: moment(dateTime).toDate().getTime(),
                    y: x.count
                };
                sampleSeries.push(datapoint);
            });
            return sampleSeries;
        };
        FlexIsDetailsController.prototype.getSeries = function (swabbingTrendSummary) {
            var _this = this;
            var seriesData = [];
            swabbingTrendSummary.forEach(function (x) {
                var item = {
                    name: 'Section ' + x.section,
                    data: _this.getSampleData(x.details),
                    legendIndex: x.section
                };
                seriesData.push(item);
            });
            return seriesData;
        };
        FlexIsDetailsController.prototype.getChartOptions = function (swabbingTrendSummary) {
            var seriesData = this.getSeries(swabbingTrendSummary);
            return {
                chart: {
                    zoomType: 'x'
                },
                time: {
                    useUTC: false
                },
                title: {
                    text: ''
                },
                yAxis: {
                    title: {
                        text: 'Number of Gobs Lost'
                    }
                },
                xAxis: {
                    type: 'datetime',
                    title: {
                        text: 'Date/Time'
                    },
                    dateTimeLabelFormats: {
                        second: '%l:%M:%S %p',
                        minute: '%l:%M %p',
                        hour: '%l %p',
                        day: '%m/%d/%Y',
                        month: '%m/%d/%Y',
                        year: '%m/%d/%Y'
                    }
                },
                tooltip: {
                    xDateFormat: '%m/%d/%Y %l:%M %p'
                },
                legend: {
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'middle'
                },
                plotOptions: {
                    series: {
                        marker: {
                            enabled: false
                        }
                    }
                },
                series: seriesData,
                credits: {
                    enabled: false
                },
                responsive: {
                    rules: [{
                            condition: {
                                maxWidth: 500
                            },
                            chartOptions: {
                                legend: {
                                    layout: 'horizontal',
                                    align: 'center',
                                    verticalAlign: 'bottom'
                                }
                            }
                        }]
                }
            };
        };
        return FlexIsDetailsController;
    }());
    exports.FlexIsDetailsController = FlexIsDetailsController;
    exports.default = angular.module('aps.controller.flexIsDetails', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.FLEX_IS_DETAILS,
            url: '/flexIsDetails',
            controller: 'FlexIsDetailsCtrl as vm',
            template: flexIsDetails_tpl_html_1.default,
            data: {
                pageTitle: 'FlexIS Details'
            }
        });
    }])
        .controller('FlexIsDetailsCtrl', FlexIsDetailsController)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=container-fluid> <div class=bs-row> <div class=col-md-3> <h4>Shop {{vm.shopName}} - FlexIS Machine Details</h4> </div> <div class=col-md-3> <label style=margin-top:5px> Viewing Count Data For: <select style=width:120px id=countsInterval ng-model=vm.countsInterval ng-options=\"t.value as t.text for t in vm.countDisplayIntervalOptions\" ng-change=vm.countsIntervalChanged()></select> </label> </div> </div> <!-- if there is no FlexIS data --> <div ng-if=!vm.hasFlexIS> <h4>Current shop does not have a FlexIS...</h4> </div> <!-- main page --> <div> <!-- first row - notifications and alarms --> <div class=bs-row> <!-- machine stats --> <div class=col-lg-6> <div class=card-deck> <div class=\"card text-white border-secondary mb-3 text-center\"> <div class=\"card-header bg-secondary\">Machine Speed</div> <div class=card-body> <h4 class=card-title><b>{{vm.bottlesPerMinute | number : 0 }} BPM</b></h4> </div> </div> <div class=\"card bg-{{vm.machineControllerInfo.mcEfficiencyClass}} text-white mb-3 text-center\"> <div class=card-header>Efficiency</div> <div class=card-body> <h4 class=card-title><b>{{vm.machineControllerInfo.mcEfficiency | number : 2}} %</b></h4> </div> </div> </div> </div> <!-- ware Handeling stats --> <div class=col-lg-6> <div class=card-group> <div class=\"card border-dark mb-3 text-center\"> <div class=card-header>Too Wide</div> <div class=\"card-body text-dark\"> <h4 class=card-title><b>{{vm.wareHandlingInfo.whcWide}}</b></h4> </div> </div> <div class=\"card border-dark mb-3 text-center\"> <div class=card-header>Too Thin</div> <div class=\"card-body text-dark\"> <h4 class=card-title><b>{{vm.wareHandlingInfo.whcThin}}</b></h4> </div> </div> <div class=\"card border-dark mb-3 text-center\"> <div class=card-header>Wrong Spacing</div> <div class=\"card-body text-dark\"> <h4 class=card-title><b>{{vm.wareHandlingInfo.whcSpace}}</b></h4> </div> </div> <div class=\"card border-dark mb-3 text-center\"> <div class=card-header>WHC Out</div> <div class=\"card-body text-dark\"> <h4 class=card-title><b>{{vm.wareHandlingInfo.whcOut}}</b></h4> </div> </div> </div> </div> </div> <hr/> <!-- section forming stats and swabbing data --> <div class=bs-row> <!-- section forming stats --> <div class=col-lg-7> <div class=text-center> <h4>Section Statistics</h4> </div> <table class=history-t style=\"border:1px solid #d3d3d3;width:100%\"> <thead class=thead-dark> <tr> <th scope=col>Section</th> <th ng-repeat=\"section in vm.sectionNumbers\"> {{section}} </th> </tr> </thead> <tbody> <tr> <td><b>Efficiency</b></td> <td ng-repeat=\"sectionValue in vm.sectionStatistics.sectionEfficiency\" class=\"bs-table-{{sectionValue.efficiencyColor}}\"> <b>{{sectionValue.efficiency | number : 2}}</b> </td> </tr> <tr> <td colspan=\"{{vm.numberOfSections + 1}}\" class=text-center><b>Machine Controller Opportunity</b></td> </tr> <tr> <td><b>Gobs Cut</b></td> <td ng-repeat=\"sectionValue in vm.sectionStatistics.mcGobsCut\"> {{sectionValue.count}} </td> </tr> <tr> <td><b>Gobs Not Cut</b></td> <td ng-repeat=\"sectionValue in vm.sectionStatistics.mcGobsNotCut\"> {{sectionValue.count}} </td> </tr> <tr> <td><b>Gobs Delivered</b></td> <td ng-repeat=\"sectionValue in vm.sectionStatistics.mcGobsDelivered\"> {{sectionValue.count}} </td> </tr> <tr> <td colspan=\"{{vm.numberOfSections + 1}}\" class=text-center><b>Section Controller Opportunity</b></td> </tr> <tr> <td><b>Gobs Requested</b></td> <td ng-repeat=\"sectionValue in vm.sectionStatistics.scGobsRequested\"> {{sectionValue.count}} </td> </tr> <tr> <td><b>Gobs Not Requested</b></td> <td ng-repeat=\"sectionValue in vm.sectionStatistics.scGobsNotRequested\"> {{sectionValue.count}} </td> </tr> <tr> <td><b>Gobs Delivered</b></td> <td ng-repeat=\"sectionValue in vm.sectionStatistics.scGobsDelivered\"> {{sectionValue.count}} </td> </tr> <tr> <td colspan=\"{{vm.numberOfSections + 1}}\" class=text-center><b>Gob Not Requested Per Section(Events)</b></td> </tr> <tr> <td><b>MS Loss</b></td> <td ng-repeat=\"sectionValue in vm.sectionStatistics.scLostMs\"> {{sectionValue.count}} </td> </tr> <tr> <td><b>Stop Loss</b></td> <td ng-repeat=\"sectionValue in vm.sectionStatistics.scNrqStop\"> {{sectionValue.count}} </td> </tr> <tr> <td><b>Delivery Off</b></td> <td ng-repeat=\"sectionValue in vm.sectionStatistics.scDelOff\"> {{sectionValue.count}} </td> </tr> <tr> <td><b>Manual Swab</b></td> <td ng-repeat=\"sectionValue in vm.sectionStatistics.scNrqManSwab\"> {{sectionValue.count}} </td> </tr> <tr> <td><b>Alternate Swab</b></td> <td ng-repeat=\"sectionValue in vm.sectionStatistics.scNrqAltSwab\"> {{sectionValue.count}} </td> </tr> <tr> <td colspan=\"{{vm.numberOfSections + 1}}\" class=text-center><b>Gob Rejected Per Section</b></td> </tr> <tr> <td><b>Cold Mold</b></td> <td ng-repeat=\"sectionValue in vm.sectionStatistics.scRjComo\"> {{sectionValue.count}} </td> </tr> <tr> <td><b>Manual Swab</b></td> <td ng-repeat=\"sectionValue in vm.sectionStatistics.scRjManSwab\"> {{sectionValue.count}} </td> </tr> <tr> <td><b>Alternate Swab</b></td> <td ng-repeat=\"sectionValue in vm.sectionStatistics.scRjAltSwab\"> {{sectionValue.count}} </td> </tr> <tr> <td><b>RPC Loss</b></td> <td ng-repeat=\"sectionValue in vm.sectionStatistics.scRjRpcLoss\"> {{sectionValue.count}} </td> </tr> <tr> <td><b>Blank Panel Loss</b></td> <td ng-repeat=\"sectionValue in vm.sectionStatistics.scRjBlankPanelLoss\"> {{sectionValue.count}} </td> </tr> <tr> <td><b>Blow Panel Loss</b></td> <td ng-repeat=\"sectionValue in vm.sectionStatistics.scRjBlowPanelLoss\"> {{sectionValue.count}} </td> </tr> <tr> <td><b>Ware Handeling</b></td> <td ng-repeat=\"sectionValue in vm.sectionStatistics.scRjWhc\"> {{sectionValue.count}} </td> </tr> <tr> <td><b>Total Rejects</b></td> <td ng-repeat=\"sectionValue in vm.sectionStatistics.scRjTotal\"> {{sectionValue.count}} </td> </tr> </tbody> </table> </div> <!-- swabbing chart --> <div class=col-lg-5> <div class=text-center> <h4>Gobs Lost Swabbing</h4> </div> <div id=container style=width:100%;height:600px></div> </div> </div> <hr/> <!-- third row - cavity rejects and status --> <div class=text-center> <h4>Cavity Statistics</h4> </div> <table class=history-t style=\"border:1px solid #d3d3d3;width:100%\"> <caption style=caption-side:top class=text-center> <b>Cavities Rejected by RPC</b> </caption> <thead class=thead-dark> <tr> <th scope=col>Section</th> <th ng-repeat=\"section in vm.sectionNumbers\"> {{section}} </th> </tr> </thead> <tbody> <tr ng-if=\"vm.cavityStatistics.rpcRejectsBack && vm.cavityStatistics.rpcRejectsBack.length\"> <td><b>Back</b></td> <td ng-repeat=\"cavity in vm.cavityStatistics.rpcRejectsBack\"> {{cavity.count}} </td> </tr> <tr ng-if=\"vm.cavityStatistics.rpcRejectsMiddle && vm.cavityStatistics.rpcRejectsMiddle.length\"> <td><b>Middle</b></td> <td ng-repeat=\"cavity in vm.cavityStatistics.rpcRejectsMiddle\"> {{cavity.count}} </td> </tr> <tr ng-if=\"vm.cavityStatistics.rpcRejectsFront && vm.cavityStatistics.rpcRejectsFront.length\"> <td><b>Front</b></td> <td ng-repeat=\"cavity in vm.cavityStatistics.rpcRejectsFront\"> {{cavity.count}} </td> </tr> </tbody> </table> <table class=history-t style=\"border:1px solid #d3d3d3;width:100%\"> <caption style=caption-side:top class=text-center> <b>Blank Side Rejects by Panel Controller</b> </caption> <thead class=thead-dark> <tr> <th scope=col>Section</th> <th ng-repeat=\"section in vm.sectionNumbers\"> {{section}} </th> </tr> </thead> <tbody> <tr ng-if=\"vm.cavityStatistics.blankPanelRejectsBack && vm.cavityStatistics.blankPanelRejectsBack.length\"> <td><b>Back</b></td> <td ng-repeat=\"cavity in vm.cavityStatistics.blankPanelRejectsBack\"> {{cavity.count}} </td> </tr> <tr ng-if=\"vm.cavityStatistics.blankPanelRejectsMiddle && vm.cavityStatistics.blankPanelRejectsMiddle.length\"> <td><b>Middle</b></td> <td ng-repeat=\"cavity in vm.cavityStatistics.blankPanelRejectsMiddle\"> {{cavity.count}} </td> </tr> <tr ng-if=\"vm.cavityStatistics.blankPanelRejectsFront && vm.cavityStatistics.blankPanelRejectsFront.length\"> <td><b>Front</b></td> <td ng-repeat=\"cavity in vm.cavityStatistics.blankPanelRejectsFront\"> {{cavity.count}} </td> </tr> </tbody> </table> <table class=history-t style=\"border:1px solid #d3d3d3;width:100%\"> <caption style=caption-side:top class=text-center> <b>Blow Side Rejects by Panel Controller</b> </caption> <thead class=thead-dark> <tr> <th scope=col>Section</th> <th ng-repeat=\"section in vm.sectionNumbers\"> {{section}} </th> </tr> </thead> <tbody> <tr ng-if=\"vm.cavityStatistics.blowPanelRejectsBack && vm.cavityStatistics.blowPanelRejectsBack.length\"> <td><b>Back</b></td> <td ng-repeat=\"cavity in vm.cavityStatistics.blowPanelRejectsBack\"> {{cavity.count}} </td> </tr> <tr ng-if=\"vm.cavityStatistics.blowPanelRejectsMiddle && vm.cavityStatistics.blowPanelRejectsMiddle.length\"> <td><b>Middle</b></td> <td ng-repeat=\"cavity in vm.cavityStatistics.blowPanelRejectsMiddle\"> {{cavity.count}} </td> </tr> <tr ng-if=\"vm.cavityStatistics.blowPanelRejectsFront && vm.cavityStatistics.blowPanelRejectsFront.length\"> <td><b>Front</b></td> <td ng-repeat=\"cavity in vm.cavityStatistics.blowPanelRejectsFront\"> {{cavity.count}} </td> </tr> </tbody> </table> </div> </div>");

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var FlexIsDetailsServiceImpl = (function () {
        FlexIsDetailsServiceImpl.$inject = ["httpService"];
        function FlexIsDetailsServiceImpl(httpService) {
            this.httpService = httpService;
        }
        FlexIsDetailsServiceImpl.prototype.getFlexIsDetails = function (shopId, startDate, endDate) {
            return this.httpService.get(constant_module_1.Endpoints.FLEX_IS_DETAILS, {
                shopId: shopId,
                startDate: startDate,
                endDate: endDate
            });
        };
        return FlexIsDetailsServiceImpl;
    }());
    exports.default = angular
        .module('aps.services.flexIsDetailsService', [http_service_1.default])
        .service('flexIsDetailsService', FlexIsDetailsServiceImpl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(799)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, commonReportLocationRow_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.directive.commonReportLocationRow', [])
        .directive('apsCommonReportLocationRow', commonReportLocationRowDef)
        .name;
    function commonReportLocationRowDef() {
        return {
            restrict: 'E',
            template: commonReportLocationRow_tpl_html_1.default,
            replace: true,
            scope: {
                vm: '='
            }
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<ng-form name=commonForm> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns\"> <label> <span class=\"required notated\" ng-if=vm.requirePlantSelection>*</span>Plant <select ng-model=vm.selectedPlant ng-options=\"plant as plant.name for plant in vm.plants\" ng-change=vm.updatePlant() name=selectedPlant ng-required=vm.requirePlantSelection> </select> <div ng-messages=commonForm.selectedPlant.$error ng-if=\"commonForm.selectedPlant.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-3 columns\"> <label> <span class=\"required notated\" ng-if=vm.requireLocationSelection>*</span>Location <select name=selectedLocation ng-model=vm.selectedLocation ng-options=\"location as location.name for location in vm.locations\" ng-required=vm.requireLocationSelection ng-change=vm.updateLocation()> <option value=\"\">-- {{vm.requireLocationSelection ? 'Select a Location' : 'Any Location' }} --</option> </select> <div ng-messages=commonForm.selectedLocation.$error ng-if=\"commonForm.selectedLocation.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>Start Date <input type=datetime-local date-time-picker ng-model=vm.uiStartDate time-model=vm.startDate time-zone=vm.selectedPlant.timeZoneId time-changed=vm.updateStartDate() name=startDate required/> <div ng-messages=commonForm.startDate.$error ng-if=\"commonForm.startDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>End Date <input type=datetime-local ng-model=vm.uiEndDate date-time-picker time-model=vm.endDate time-zone=vm.selectedPlant.timeZoneId time-changed=vm.updateEndDate() name=endDate min=\"{{ vm.uiStartDate }}\" required/> <div ng-messages=commonForm.endDate.$error ng-if=\"commonForm.endDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be greater than or equal to the Start Date</div> </div> </label> </div> </div> </ng-form>");

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(801)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, commonReportQueryCriteriaRow_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.directive.commonReportQueryCriteriaRow', [])
        .directive('apsCommonReportQueryCriteriaRow', commonReportQueryCriteriaRowDef)
        .name;
    function commonReportQueryCriteriaRowDef() {
        return {
            restrict: 'E',
            template: commonReportQueryCriteriaRow_tpl_html_1.default,
            replace: true,
            scope: {
                vm: '='
            }
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (" <ng-form name=commonReportQueryForm> <div class=row style=\"margin:0 -30px;width:100%\"> <div class=\"small-2 columns\"> <label> <span class=\"required notated\" ng-if=vm.requirePlantSelection>*</span>Plant <select id=plantSelectionDropdown ng-model=vm.selectedPlant on ng-options=\"plant as plant.name for plant in vm.plants\" ng-change=vm.updatePlant() name=selectedPlant ng-required=vm.requirePlantSelection style=display:block> </select> <div ng-messages=commonReportQueryForm.selectedPlant.$error ng-if=\"vm.allowErrorCheckForSelectedPlant && (commonReportQueryForm.selectedPlant.$dirty || vm.form.$submitted)\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-1 columns\" ng-if=!vm.hideShopSelection> <label> <span class=\"required notated\" ng-if=vm.requireShopSelection>*</span>Shop <select id=shopDropdown name=selectedShop ng-model=vm.selectedShop ng-options=\"shop as shop.name for shop in vm.selectedPlant.shops\" ng-disabled=\"vm.requirePlantSelection && !vm.selectedPlant\" ng-required=vm.requireShopSelection ng-change=vm.updateShop()> <option value=\"\">-- {{vm.requireShopSelection ? 'Select a Shop' : 'all' }} --</option> </select> <div ng-messages=commonReportQueryForm.selectedShop.$error ng-if=\"commonReportQueryForm.selectedShop.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div ng-show=!vm.byShift> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>Start Date <input type=datetime-local date-time-picker ng-model=vm.uiStartDate time-model=vm.startDate time-zone=vm.selectedPlant.timeZoneId name=startDate required/> <div ng-messages=commonReportQueryForm.startDate.$error ng-if=\"commonReportQueryForm.startDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>End Date <input type=datetime-local ng-model=vm.uiEndDate date-time-picker time-model=vm.endDate time-zone=vm.selectedPlant.timeZoneId name=endDate min=\"{{ vm.uiStartDate }}\" required/> <div ng-messages=commonReportQueryForm.endDate.$error ng-if=\"commonReportQueryForm.endDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=min class=req-w><div class=arrow-up></div>Must be greater than or equal to the Start Date</div> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-3 columns\" style=padding-top:2em ng-if=vm.showByShiftOption> <label> <input type=checkbox id=byShift ng-model=vm.byShift /> Breakdown by Shift </label> </div> </div> <div ng-show=vm.byShift> <div class=\"small-2 columns\"> <label> <span class=\"required notated\">*</span>Start Date <input type=date ng-model=vm.uiStartDate time-model=vm.startDate time-zone=vm.selectedPlant.timeZoneId name=startDate required/> <div ng-messages=vm.form.reportDate.$error ng-if=\"vm.form.reportDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> <div class=\"small-2 columns\"> <label> <span class=\"required notated\">*</span>End Date <input type=date ng-model=vm.uiEndDate time-model=vm.endDate time-zone=vm.selectedPlant.timeZoneId name=endDate min=\"{{ vm.uiStartDate }}\" required/> <div ng-messages=vm.form.reportDate.$error ng-if=\"vm.form.reportDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> <div class=\"small-3 columns\" style=padding-top:2em ng-if=vm.showByShiftOption> <label> <input type=checkbox id=byShift ng-model=vm.byShift /> Breakdown by Shift </label> </div> </div> <div class=columns></div> </div> </ng-form>");

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(3), __webpack_require__(803), __webpack_require__(4), __webpack_require__(16), __webpack_require__(11), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, constant_module_1, criticalDefectReport_tpl_html_1, loader_service_1, report_service_1, dateutility_service_1, navigation_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, report_service_1.default, navigation_service_1.default];
    var CriticalDefectReportCtrl = (function () {
        CriticalDefectReportCtrl.$inject = ["$stateParams", "$state", "$q", "navigationService", "reportService", "loaderService"];
        function CriticalDefectReportCtrl($stateParams, $state, $q, navigationService, reportService, loaderService) {
            var _this = this;
            this.$q = $q;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.loaderService = loaderService;
            this.reportService = reportService;
            this.requirePlantSelection = true;
            var today = moment().startOf('day');
            this.startDate = today.clone().subtract(1, 'month').toDate();
            this.endDate = today.toDate();
            var promise = navigationService.getNavigation().then(function (navModel) {
                _this.plants = navModel.plants();
                _this.selectedPlant = navModel.selectedPlant;
                _this.updatePlant();
                _this.selectedShop = navModel.selectedShop;
                return _this.loadState($stateParams);
            });
            loaderService.loadingPromise(promise);
        }
        CriticalDefectReportCtrl.prototype.filteredResults = function () {
            var _this = this;
            var results = _(this.results);
            if (this.selectedShift) {
                results = results.filter(function (x) { return x.shiftLetter === _this.selectedShift; });
            }
            if (this.selectedItem) {
                results = results.filter(function (x) { return x.item === _this.selectedItem; });
            }
            if (this.selectedDefect) {
                results = results.filter(function (x) { return x.defect === _this.selectedDefect; });
            }
            if (this.selectedSection) {
                results = results.filter(function (x) { return x.sectionNumber === _this.selectedSection; });
            }
            if (this.selectedLocation) {
                results = results.filter(function (x) { return x.location === _this.selectedLocation; });
            }
            if (this.selectedMold) {
                results = results.filter(function (x) { return x.moldNumber === _this.selectedMold; });
            }
            return results.value();
        };
        CriticalDefectReportCtrl.prototype.updateDropdowns = function () {
            this.shifts = _.uniq(_.filter(_.map(this.results, 'shiftLetter'), function (x) { return !!x; }));
            this.items = _.uniq(_.filter(_.map(this.results, 'item'), function (x) { return !!x; }));
            this.defects = _.uniq(_.filter(_.map(this.results, 'defect'), function (x) { return !!x; }));
            this.sections = _.uniq(_.filter(_.map(this.results, 'sectionNumber'), function (x) { return !!x; }));
            this.locations = _.uniq(_.filter(_.map(this.results, 'location'), function (x) { return !!x; }));
            this.molds = _.uniq(_.filter(_.map(this.results, 'moldNumber'), function (x) { return !!x; }));
        };
        CriticalDefectReportCtrl.prototype.updatePlant = function () {
            this.selectedShop = null;
        };
        CriticalDefectReportCtrl.prototype.toggleMissingSignOff = function (detail) {
            detail.showMissingSignOff = !detail.showMissingSignOff;
        };
        CriticalDefectReportCtrl.prototype.formatMissingSignOff = function (detail) {
            return _.join(detail.missingSignOffFrom, ", ");
        };
        CriticalDefectReportCtrl.prototype.loadState = function (params) {
            if (params.reportPlantId && params.reportPlantId !== params.plantId) {
                var plant = _.find(this.plants, { id: params.reportPlantId });
                if (plant) {
                    this.selectedPlant = plant;
                    var shop = _.find(plant.shops, { id: params.reportShopId });
                    if (shop) {
                        this.selectedPlant = plant;
                        this.selectedShop = shop;
                    }
                }
            }
            if (params.startDate) {
                var startDate = moment(params.startDate);
                if (startDate.isValid()) {
                    this.startDate = startDate.toDate();
                }
            }
            if (params.endDate) {
                var endDate = moment(params.endDate);
                if (endDate.isValid()) {
                    this.endDate = endDate.toDate();
                }
            }
            if (params.autoRun) {
                return this.runDefectReport();
            }
            return this.$q.when();
        };
        CriticalDefectReportCtrl.prototype.saveState = function () {
            var reportPlantId = this.selectedPlant ? this.selectedPlant.id : undefined;
            if (reportPlantId === this.$stateParams.plantId) {
                reportPlantId = undefined;
            }
            var reportShopId = this.selectedShop ? this.selectedShop.id : undefined;
            if (reportShopId === this.$stateParams.shopId) {
                reportShopId = undefined;
            }
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportPlantId: reportPlantId,
                reportShopId: reportShopId,
                startDate: this.startDate ? this.startDate.toISOString() : undefined,
                endDate: this.endDate ? this.endDate.toISOString() : undefined,
                autoRun: true
            };
            this.$state.transitionTo(constant_module_1.States.CRITICAL_DEFECT_REPORT, params);
        };
        CriticalDefectReportCtrl.prototype.generateReport = function () {
            if (this.form.$invalid) {
                return;
            }
            this.saveState();
            this.loaderService.loadingPromise(this.runDefectReport());
        };
        CriticalDefectReportCtrl.prototype.runDefectReport = function () {
            var _this = this;
            var startDateStart = moment(this.startDate).startOf('day').toDate();
            var tzOffsetStartDate = dateutility_service_1.default.localToTimeZone(startDateStart, this.selectedPlant.timeZoneId).toDate();
            var endDateEnd = moment(this.endDate || new Date()).endOf('day').toDate();
            var tzOffsetEndDate = dateutility_service_1.default.localToTimeZone(endDateEnd, this.selectedPlant.timeZoneId).toDate();
            return this.reportService.getCriticalDefectReportDetails(this.selectedPlant.id, tzOffsetStartDate, tzOffsetEndDate, this.isMissingSignOff)
                .then(function (reportItems) {
                _this.results = reportItems;
                _this.searchPerformed = true;
                _this.updateDropdowns();
            });
        };
        CriticalDefectReportCtrl.prototype.exportToCsv = function () {
            var _this = this;
            return _.map(this.filteredResults(), function (x) {
                return {
                    plant: _this.selectedPlant.name,
                    shop: x.shop,
                    shiftLetter: x.shiftLetter,
                    timeFound: _this.formatTime(x.timeFound),
                    item: x.item,
                    defect: x.defect,
                    sectionNumber: x.sectionNumber,
                    location: x.location,
                    moldNumber: x.moldNumber,
                    originator: x.originator,
                    whereFound: x.whereFound,
                    rootCause: x.rootCause,
                    fix: x.fix,
                    timeCorrected: x.timeCorrected,
                    isMissingSignOff: x.isMissingSignOff ? "Missing Sign Off" : "Sign Off Complete"
                };
            });
        };
        CriticalDefectReportCtrl.prototype.formatTime = function (time) {
            return dateutility_service_1.default.formatTime(time, this.selectedPlant.timeZoneId);
        };
        return CriticalDefectReportCtrl;
    }());
    exports.default = angular.module('aps.controller.criticalDefectReport', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.CRITICAL_DEFECT_REPORT,
            url: '/admin/reports/criticalDefects?startDate&endDate&autoRun&reportPlantId',
            params: {
                startDate: { dynamic: true },
                endDate: { dynamic: true },
                autoRun: { dynamic: true },
                reportPlantId: { dynamic: true },
            },
            controller: 'CriticalDefectReportCtrl as vm',
            template: criticalDefectReport_tpl_html_1.default,
            data: {
                pageTitle: 'Critical Defect Report'
            }
        });
    }])
        .controller('CriticalDefectReportCtrl', CriticalDefectReportCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div class=body-header> <h2>Critical Defects Report</h2> </div> <aps-common-report-query-criteria-row vm=vm></aps-common-report-query-criteria-row> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns\"> <label> <br/> <input type=checkbox ng-model=vm.isMissingSignOff /> Sign Off Missing </label> </div> <div class=\"small-9 columns\"> <button type=submit class=button>Generate Report</button> </div> </div> </form> <div class=row style=margin-left:-30px ng-if=\"vm.results && vm.results.length\"> <div class=\"small-4 columns\"> <label>Shift: <select name=selectedShift ng-model=vm.selectedShift ng-options=\"x for x in vm.shifts | orderBy\"> <option value=\"\">All</option> </select> </label> </div> <div class=\"small-4 columns\"> <label>Item: <select name=selectedItem ng-model=vm.selectedItem ng-options=\"x for x in vm.items | orderBy\"> <option value=\"\">All</option> </select> </label> </div> <div class=\"small-4 columns\"> <label>Defect: <select name=selectedDefect ng-model=vm.selectedDefect ng-options=\"x for x in vm.defects | orderBy\"> <option value=\"\">All</option> </select> </label> </div> </div> <div class=row style=margin-left:-30px ng-if=\"vm.results && vm.results.length\"> <div class=\"small-4 columns\"> <label>Section: <select name=selectedSection ng-model=vm.selectedSection ng-options=\"x for x in vm.sections | orderBy\"> <option value=\"\">All</option> </select> </label> </div> <div class=\"small-4 columns\"> <label>Location: <select name=selectedLocation ng-model=vm.selectedLocation ng-options=\"x for x in vm.locations | orderBy\"> <option value=\"\">All</option> </select> </label> </div> <div class=\"small-4 columns\"> <label>Mold: <select name=selectedMold ng-model=vm.selectedMold ng-options=\"x for x in vm.molds | orderBy\"> <option value=\"\">All</option> </select> </label> </div> </div> <div ng-if=\"vm.filteredResults() && vm.filteredResults().length\"> <a ng-csv=vm.exportToCsv() filename=criticalDefects.csv class=right>Save as CSV</a> <table class=history-t> <thead> <tr> <th>Shop</th> <th>Shift Letter</th> <th>Time Found</th> <th>Item</th> <th>Defect</th> <th>Section Number</th> <th>Location</th> <th>Mold Number</th> <th>Originator</th> <th>Where Found</th> <th>Root Cause</th> <th>Fix</th> <th>Time Corrected</th> <th>Missing Sign Off</th> </tr> </thead> <tbody> <tr ng-repeat-start=\"detail in vm.filteredResults() | orderBy:['shopName', 'timeFound']\"> <td>{{detail.shop}}</td> <td>{{detail.shiftLetter}}</td> <td>{{vm.formatTime(detail.timeFound)}}</td> <td>{{detail.item}}</td> <td>{{detail.defect}}</td> <td>{{detail.sectionNumber}}</td> <td>{{detail.location}}</td> <td>{{detail.moldNumber}}</td> <td>{{detail.originator}}</td> <td>{{detail.whereFound}}</td> <td>{{detail.rootCause}}</td> <td>{{detail.fix}}</td> <td>{{detail.timeCorrected}}</td> <td ng-if=detail.isMissingSignOff>Yes <a ng-if=!detail.showMissingSignOff ng-click=vm.toggleMissingSignOff(detail)>(Show)</a> <a ng-if=detail.showMissingSignOff ng-click=vm.toggleMissingSignOff(detail)>(Hide)</a> </td> <td ng-if=!detail.isMissingSignOff>No</td> </tr> <tr ng-if=detail.showMissingSignOff ng-repeat-end> <td colspan=13>{{vm.formatMissingSignOff(detail)}}</td> </tr> </tbody> </table> </div> <div ng-if=\"(vm.results && vm.results.length > 0) && vm.searchPerformed && vm.filteredResults().length === 0\">No results found with those filters</div> <div ng-if=\"(!vm.results || !vm.results.length) && vm.searchPerformed\">No results found</div> </div>");

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(3), __webpack_require__(805), __webpack_require__(4), __webpack_require__(16), __webpack_require__(11), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, constant_module_1, wareHeldReport_tpl_html_1, loader_service_1, report_service_1, dateutility_service_1, navigation_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, report_service_1.default, navigation_service_1.default];
    var WareHeldReportCtrl = (function () {
        WareHeldReportCtrl.$inject = ["$stateParams", "$state", "$q", "navigationService", "reportService", "loaderService"];
        function WareHeldReportCtrl($stateParams, $state, $q, navigationService, reportService, loaderService) {
            var _this = this;
            this.$q = $q;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.loaderService = loaderService;
            this.reportService = reportService;
            this.requirePlantSelection = true;
            var today = moment().startOf('day');
            this.startDate = today.clone().subtract(1, 'month').toDate();
            this.endDate = today.toDate();
            var promise = navigationService.getNavigation().then(function (navModel) {
                _this.plants = navModel.plants();
                _this.selectedPlant = navModel.selectedPlant;
                _this.updatePlant();
                _this.selectedShop = navModel.selectedShop;
                return _this.loadState($stateParams);
            });
            loaderService.loadingPromise(promise);
        }
        WareHeldReportCtrl.prototype.filteredResults = function () {
            var _this = this;
            var results = _(this.results);
            if (this.selectedShift) {
                results = results.filter(function (x) { return x.shift === _this.selectedShift; });
            }
            if (this.selectedItem) {
                results = results.filter(function (x) { return x.item === _this.selectedItem; });
            }
            if (this.selectedDefect) {
                results = results.filter(function (x) { return x.defect === _this.selectedDefect; });
            }
            return results.value();
        };
        WareHeldReportCtrl.prototype.updateDropdowns = function () {
            this.shifts = _.uniq(_.filter(_.map(this.results, 'shift'), function (x) { return !!x; }));
            this.items = _.uniq(_.filter(_.map(this.results, 'item'), function (x) { return !!x; }));
            this.defects = _.uniq(_.filter(_.map(this.results, 'defect'), function (x) { return !!x; }));
        };
        WareHeldReportCtrl.prototype.updatePlant = function () {
            this.selectedShop = null;
        };
        WareHeldReportCtrl.prototype.loadState = function (params) {
            if (params.reportPlantId && params.reportPlantId !== params.plantId) {
                var plant = _.find(this.plants, { id: params.reportPlantId });
                if (plant) {
                    this.selectedPlant = plant;
                    var shop = _.find(plant.shops, { id: params.reportShopId });
                    if (shop) {
                        this.selectedPlant = plant;
                        this.selectedShop = shop;
                    }
                }
            }
            if (params.startDate) {
                var startDate = moment(params.startDate);
                if (startDate.isValid()) {
                    this.startDate = startDate.toDate();
                }
            }
            if (params.endDate) {
                var endDate = moment(params.endDate);
                if (endDate.isValid()) {
                    this.endDate = endDate.toDate();
                }
            }
            if (params.autoRun) {
                return this.runReport();
            }
            return this.$q.when();
        };
        WareHeldReportCtrl.prototype.saveState = function () {
            var reportPlantId = this.selectedPlant ? this.selectedPlant.id : undefined;
            if (reportPlantId === this.$stateParams.plantId) {
                reportPlantId = undefined;
            }
            var reportShopId = this.selectedShop ? this.selectedShop.id : undefined;
            if (reportShopId === this.$stateParams.shopId) {
                reportShopId = undefined;
            }
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportPlantId: reportPlantId,
                reportShopId: reportShopId,
                startDate: this.startDate ? this.startDate.toISOString() : undefined,
                endDate: this.endDate ? this.endDate.toISOString() : undefined,
                autoRun: true
            };
            this.$state.transitionTo(constant_module_1.States.WARE_HELD_REPORT, params);
        };
        WareHeldReportCtrl.prototype.generateReport = function () {
            if (this.form.$invalid) {
                return;
            }
            this.saveState();
            this.loaderService.loadingPromise(this.runReport());
        };
        WareHeldReportCtrl.prototype.runReport = function () {
            var _this = this;
            var startDateStart = this.startDate;
            var endDateEnd = this.endDate;
            return this.reportService.getWareHeldReport(this.selectedPlant.id, this.selectedShop
                ? this.selectedShop.id : null, startDateStart, endDateEnd)
                .then(function (reportItems) {
                _this.results = reportItems;
                _this.searchPerformed = true;
                _this.updateDropdowns();
            });
        };
        WareHeldReportCtrl.prototype.exportToCsv = function () {
            var _this = this;
            return _.map(this.filteredResults(), function (x) {
                return {
                    plant: _this.selectedPlant.name,
                    shop: x.shop,
                    dateTime: _this.formatTime(x.scheduledOn),
                    shift: x.shift,
                    item: x.item,
                    defect: x.defect,
                    molds: x.molds,
                    affectedPallets: x.affectedPallets,
                    palletRange: x.palletRange,
                    reprocessedPallets: x.reprocessedPallets,
                    comment: x.comment
                };
            });
        };
        WareHeldReportCtrl.prototype.formatTime = function (time) {
            return dateutility_service_1.default.formatTime(time, this.selectedPlant.timeZoneId);
        };
        return WareHeldReportCtrl;
    }());
    exports.default = angular.module('aps.controller.wareHeldReport', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.WARE_HELD_REPORT,
            url: '/admin/reports/wareHeld?startDate&endDate&autoRun&reportPlantId&reportShopId',
            params: {
                startDate: { dynamic: true },
                endDate: { dynamic: true },
                autoRun: { dynamic: true },
                reportPlantId: { dynamic: true },
                reportShopId: { dynamic: true }
            },
            controller: 'WareHeldReportCtrl as vm',
            template: wareHeldReport_tpl_html_1.default,
            data: {
                pageTitle: 'Held Ware Report'
            }
        });
    }])
        .controller('WareHeldReportCtrl', WareHeldReportCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div class=body-header> <h2>Held Ware Report</h2> </div> <aps-common-report-query-criteria-row vm=vm></aps-common-report-query-criteria-row> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-12 columns\"> <button type=submit class=button>Generate Report</button> </div> </div> </form> <div class=row style=margin-left:-30px ng-if=\"vm.results && vm.results.length\"> <div class=\"small-4 columns\"> <label>Shift: <select name=selectedShift ng-model=vm.selectedShift ng-options=\"x for x in vm.shifts | orderBy\"> <option value=\"\">All</option> </select> </label> </div> <div class=\"small-4 columns\"> <label>Item: <select name=selectedItem ng-model=vm.selectedItem ng-options=\"x for x in vm.items | orderBy\"> <option value=\"\">All</option> </select> </label> </div> <div class=\"small-4 columns\"> <label>Defect: <select name=selectedDefect ng-model=vm.selectedDefect ng-options=\"x for x in vm.defects | orderBy\"> <option value=\"\">All</option> </select> </label> </div> </div> <div ng-if=\"vm.filteredResults() && vm.filteredResults().length\"> <a ng-csv=vm.exportToCsv() filename=heldWare.csv class=right>Save as CSV</a> <table class=history-t> <thead> <tr> <th>Shop</th> <th>Date Time</th> <th>Shift</th> <th>Item</th> <th>Defect</th> <th>Molds</th> <th>Total # of Pallets Held</th> <th>Pallet Range</th> <th>Reprocessed Pallets</th> <th>Comment</th> </tr> </thead> <tbody> <tr ng-repeat=\"detail in vm.filteredResults() | orderBy:['shopName', 'timeFound']\"> <td>{{detail.shop}}</td> <td>{{vm.formatTime(detail.scheduledOn)}}</td> <td>{{detail.shift}}</td> <td>{{detail.item}}</td> <td>{{detail.defect}}</td> <td>{{detail.molds}}</td> <td>{{detail.affectedPallets}}</td> <td>{{detail.palletRange}}</td> <td>{{detail.reprocessedPallets}}</td> <td>{{detail.comment}}</td> </tr> </tbody> </table> </div> <div ng-if=\"(vm.results && vm.results.length > 0) && vm.searchPerformed && vm.filteredResults().length === 0\">No results found with those filters</div> <div ng-if=\"(!vm.results || !vm.results.length) && vm.searchPerformed\">No results found</div> </div>");

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(3), __webpack_require__(807), __webpack_require__(4), __webpack_require__(16), __webpack_require__(11), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, constant_module_1, tankMetricsReport_tpl_html_1, loader_service_1, report_service_1, dateutility_service_1, navigation_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, report_service_1.default, navigation_service_1.default];
    var TankMetricsReportCtrl = (function () {
        TankMetricsReportCtrl.$inject = ["$stateParams", "$state", "$q", "navigationService", "reportService", "loaderService"];
        function TankMetricsReportCtrl($stateParams, $state, $q, navigationService, reportService, loaderService) {
            var _this = this;
            this.$q = $q;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.loaderService = loaderService;
            this.reportService = reportService;
            this.requirePlantSelection = true;
            this.hideShopSelection = true;
            var today = moment().startOf('day');
            this.startDate = today.clone().subtract(1, 'month').toDate();
            this.endDate = today.toDate();
            var promise = navigationService.getNavigation().then(function (navModel) {
                _this.plants = navModel.plants();
                _this.selectedPlant = navModel.selectedPlant;
                _this.updatePlant();
                return _this.loadState($stateParams);
            });
            loaderService.loadingPromise(promise);
        }
        TankMetricsReportCtrl.prototype.filteredResults = function () {
            return this.results;
        };
        TankMetricsReportCtrl.prototype.updatePlant = function () { };
        TankMetricsReportCtrl.prototype.loadState = function (params) {
            if (params.reportPlantId && params.reportPlantId !== params.plantId) {
                var plant = _.find(this.plants, { id: params.reportPlantId });
                if (plant) {
                    this.selectedPlant = plant;
                }
            }
            if (params.startDate) {
                var startDate = moment(params.startDate);
                if (startDate.isValid()) {
                    this.startDate = startDate.toDate();
                }
            }
            if (params.endDate) {
                var endDate = moment(params.endDate);
                if (endDate.isValid()) {
                    this.endDate = endDate.toDate();
                }
            }
            if (params.autoRun) {
                return this.runReport();
            }
            return this.$q.when();
        };
        TankMetricsReportCtrl.prototype.saveState = function () {
            var reportPlantId = this.selectedPlant ? this.selectedPlant.id : undefined;
            if (reportPlantId === this.$stateParams.plantId) {
                reportPlantId = undefined;
            }
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportPlantId: reportPlantId,
                startDate: this.startDate ? this.startDate.toISOString() : undefined,
                endDate: this.endDate ? this.endDate.toISOString() : undefined,
                autoRun: true
            };
            this.$state.transitionTo(constant_module_1.States.TANK_METRICS_REPORT, params);
        };
        TankMetricsReportCtrl.prototype.generateReport = function () {
            if (this.form.$invalid) {
                return;
            }
            this.saveState();
            this.loaderService.loadingPromise(this.runReport());
        };
        TankMetricsReportCtrl.prototype.runReport = function () {
            var _this = this;
            var startDateStart = moment(this.startDate).startOf('day').toDate();
            var tzOffsetStartDate = dateutility_service_1.default.localToTimeZone(startDateStart, this.selectedPlant.timeZoneId).toDate();
            var endDateEnd = moment(this.endDate || new Date()).endOf('day').toDate();
            var tzOffsetEndDate = dateutility_service_1.default.localToTimeZone(endDateEnd, this.selectedPlant.timeZoneId).toDate();
            return this.reportService.getTankMetricsReport(this.selectedPlant.id, tzOffsetStartDate, tzOffsetEndDate)
                .then(function (reportItems) {
                _this.results = reportItems;
                _this.searchPerformed = true;
            });
        };
        TankMetricsReportCtrl.prototype.exportToCsv = function () {
            var _this = this;
            function repeat(value, total) {
                var arr = [value];
                for (var i = 1; i < total; i++) {
                    arr.push('');
                }
                return arr;
            }
            var headerRow1 = ['', '', '']
                .concat(repeat('KPI', 13))
                .concat(repeat('KPO', 12));
            var headerRow2 = [
                '', '', '',
                'Pull', 'Cullet', 'Gas', 'Air/Fuel',
                'Boost A', 'Boost B', 'Boost C', 'Total Boost',
                'Gas', 'Electric', 'Melt Energy', 'Melt Energy Kcal kg', 'Glass Density',
                'BW OPT', 'Bottom 3', 'Throat', 'Seeds',
                'NOx', 'SOx', 'Cord',
                'Transmission (Amber)', 'Color (Flint)',
                'Pressure', 'Batch Line', 'Batch Moisture'
            ];
            var headerRow3 = [
                '', 'Tank', 'Date',
                'TPD', '%', 'MCFH', 'Ratio',
                'KW', 'KW', 'KW', 'KW',
                'MMBTU/ton', 'MMBTU/ton', 'MMBTU/ton',
                '',
                'Gm/CC',
                'F', 'F', 'F',
                'in3', '#/ton', '#/ton',
                '', '', '', '', '', ''
            ];
            var dataRows = _.map(this.filteredResults(), function (x) {
                return {
                    plant: _this.selectedPlant.name,
                    tank: x.tank,
                    date: _this.formatTime(x.scheduledOn),
                    pull: x.pull,
                    cullet: x.cullet,
                    gas: x.gas,
                    air: x.air,
                    boostA: x.boostA,
                    boostB: x.boostB,
                    boostC: x.boostC,
                    totalBoost: x.totalBoost,
                    gasEnergy: x.gasEnergy,
                    electricEnergy: x.electricEnergy,
                    meltEnergy: x.meltEnergy,
                    meltEnergyKcalKg: x.meltEnergyKcalKg,
                    glassDensity: x.glassDensity,
                    BWOPT: x.BWOPT,
                    bottom3: x.bottom3,
                    throat: x.throat,
                    seeds: x.seeds,
                    NOx: x.NOx,
                    SOx: x.SOx,
                    cord: x.cord,
                    transmissionAmber: x.transmissionAmber,
                    colorFlint: x.colorFlint,
                    pressure: x.pressure,
                    batchLine: x.batchLine,
                    batchMoisture: x.batchMoisture
                };
            });
            return [headerRow1, headerRow2, headerRow3].concat(dataRows);
        };
        TankMetricsReportCtrl.prototype.formatTime = function (time) {
            return dateutility_service_1.default.formatDate(time, this.selectedPlant.timeZoneId);
        };
        return TankMetricsReportCtrl;
    }());
    exports.default = angular.module('aps.controller.tankMetricsReport', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.TANK_METRICS_REPORT,
            url: '/admin/reports/tankMetrics?startDate&endDate&autoRun&reportPlantId',
            params: {
                startDate: { dynamic: true },
                endDate: { dynamic: true },
                autoRun: { dynamic: true },
                reportPlantId: { dynamic: true },
                reportShopId: { dynamic: true }
            },
            controller: 'TankMetricsReportCtrl as vm',
            template: tankMetricsReport_tpl_html_1.default,
            data: {
                pageTitle: 'Tank Metrics Report'
            }
        });
    }])
        .controller('TankMetricsReportCtrl', TankMetricsReportCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div class=body-header> <h2>Tank Metrics Report</h2> </div> <aps-common-report-query-criteria-row vm=vm></aps-common-report-query-criteria-row> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-12 columns\"> <button type=submit class=button>Generate Report</button> </div> </div> </form> <div ng-if=\"vm.filteredResults() && vm.filteredResults().length\"> <a ng-csv=vm.exportToCsv() filename=tankMetrics.csv class=right>Save as CSV</a> <table class=history-t> <thead> <tr> <th colspan=2></th> <th colspan=12>KPI</th> <th colspan=12>KPO</th> </tr> <tr> <th colspan=2></th> <th>Pull</th> <th>Cullet</th> <th>Gas</th> <th>Air/Fuel</th> <th>Boost A</th> <th>Boost B</th> <th>Boost C</th> <th>Total Boost</th> <th>Gas</th> <th>Electric</th> <th>Melt Energy</th> <th>Glass Density</th> <th>BW OPT</th> <th>Bottom 3</th> <th>Throat</th> <th>Seeds</th> <th>NOx</th> <th>SOx</th> <th>Cord</th> <th>Transmission (Amber)</th> <th>Color (Flint)</th> <th>Pressure</th> <th>Batch Line</th> <th>Batch Moisture</th> </tr> <tr> <th>Tank</th> <th>Date</th> <th>TPD</th> <th>%</th> <th>MCFH</th> <th>Ratio</th> <th>KW</th> <th>KW</th> <th>KW</th> <th>KW</th> <th>MMBTU/ton</th> <th>MMBTU/ton</th> <th>MMBTU/ton</th> <th>Gm/CC</th> <th>F</th> <th>F</th> <th>F</th> <th>in3</th> <th>#/ton</th> <th>#/ton</th> <th colspan=6></th> </tr> </thead> <tbody> <tr ng-repeat=\"detail in vm.filteredResults() | orderBy:['scheduledOn', 'tank']\"> <td>{{detail.tank || detail.plant}}</td> <td>{{vm.formatTime(detail.scheduledOn)}}</td> <td>{{detail.pull}}</td> <td>{{detail.cullet}}</td> <td>{{detail.gas}}</td> <td>{{detail.air}}</td> <td>{{detail.boostA}}</td> <td>{{detail.boostB}}</td> <td>{{detail.boostC}}</td> <td>{{detail.totalBoost}}</td> <td>{{detail.gasEnergy}}</td> <td>{{detail.electricEnergy}}</td> <td>{{detail.meltEnergy}}</td> <td>{{detail.glassDensity}}</td> <td>{{detail.BWOPT}}</td> <td>{{detail.bottom3}}</td> <td>{{detail.throat}}</td> <td>{{detail.seeds}}</td> <td>{{detail.NOx}}</td> <td>{{detail.SOx}}</td> <td>{{detail.cord}}</td> <td>{{detail.transmissionAmber}}</td> <td>{{detail.colorFlint}}</td> <td>{{detail.pressure}}</td> <td>{{detail.batchLine}}</td> <td>{{detail.batchMoisture}}</td> </tr> </tbody> </table> </div> <div ng-if=\"(vm.results && vm.results.length > 0) && vm.searchPerformed && vm.filteredResults().length === 0\">No results found with those filters</div> <div ng-if=\"(!vm.results || !vm.results.length) && vm.searchPerformed\">No results found</div> </div>");

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(5), __webpack_require__(9), __webpack_require__(4), __webpack_require__(16), __webpack_require__(809), __webpack_require__(11), __webpack_require__(8), __webpack_require__(25), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, aps_enums_1, uiUtility_service_1, loader_service_1, report_service_1, defectsReport_tpl_html_1, dateutility_service_1, navigation_service_1, defectType_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [uiUtility_service_1.default, loader_service_1.default, report_service_1.default, navigation_service_1.default,
        defectType_service_1.default];
    var DefectsReportCtrl = (function () {
        DefectsReportCtrl.$inject = ["$state", "$stateParams", "$q", "$timeout", "navigationService", "reportService", "loaderService", "uiUtilityService", "defectTypeService"];
        function DefectsReportCtrl($state, $stateParams, $q, $timeout, navigationService, reportService, loaderService, uiUtilityService, defectTypeService) {
            var vm = this;
            vm.$state = $state;
            vm.$stateParams = $stateParams;
            vm.loaderService = loaderService;
            vm.reportService = reportService;
            vm.uiUtilityService = uiUtilityService;
            vm.$q = $q;
            vm.$timeout = $timeout;
            vm.requirePlantSelection = true;
            vm.requireShopSelection = true;
            var now = moment().add(1, 'hours').startOf('hour');
            vm.uiEndDate = now.toDate();
            vm.uiStartDate = now.clone().subtract(1, 'days').toDate();
            defectTypeService.getDefectTypesAndClassifications()
                .then(function (defectTypeData) { return vm.defectTypes = defectTypeData.types; });
            vm.severities = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.Severity);
            vm.orderBys = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.DefectOrder, 1, 6);
            vm.defectTypeId = undefined;
            vm.orderBy = aps_enums_1.apsEnums.DefectOrder.Time;
            vm.showDefectComments = false;
            vm.showMaintCodes = false;
            vm.displayMaintCheckbox = false;
            vm.displayMaintCheckbox = true;
            var promise = navigationService.getNavigation().then(function (nav) {
                vm.plants = nav.plants();
                vm.selectedPlant = nav.selectedPlant;
                vm.updatePlant();
                vm.selectedShop = nav.selectedShop;
                var option = document.createElement("option");
                option.text = "-- all --";
                option.accessKey = "AllPlants";
                document.getElementById("plantSelectionDropdown").appendChild(option);
                return vm.loadState($stateParams);
            });
            loaderService.loadingPromise(promise);
        }
        DefectsReportCtrl.prototype.loadState = function (params) {
            if (params.reportPlantId && params.reportShopId && params.reportShopId !== params.shopId) {
                var plant = _.find(this.plants, { id: params.reportPlantId });
                if (plant) {
                    var shop = _.find(plant.shops, { id: params.reportShopId });
                    if (shop) {
                        this.selectedPlant = plant;
                        this.selectedShop = shop;
                    }
                }
            }
            dateutility_service_1.default.setReportDates(this, params, this.$timeout);
            if (params.severity !== undefined) {
                var severity = _.find(this.severities, { value: +params.severity });
                if (severity) {
                    this.severity = severity.value;
                }
            }
            if (params.defectTypeId !== undefined) {
                this.defectTypeId = params.defectTypeId;
            }
            if (params.orderBy !== undefined) {
                var orderBy = _.find(this.orderBys, { value: +params.orderBy });
                if (orderBy) {
                    this.orderBy = orderBy.value;
                }
            }
            if (params.showDefectComments === 'true') {
                this.showDefectComments = true;
            }
            if (params.autoRun) {
                return this.runReport();
            }
            return this.$q.when();
        };
        DefectsReportCtrl.prototype.saveState = function () {
            var reportShopId = this.selectedShop ? this.selectedShop.id : undefined;
            if (reportShopId === this.$stateParams.shopId) {
                reportShopId = undefined;
            }
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportPlantId: (reportShopId && this.selectedPlant) ? this.selectedPlant.id : undefined,
                reportShopId: reportShopId,
                startDate: this.startDate ? this.startDate.toISOString() : undefined,
                endDate: this.endDate ? this.endDate.toISOString() : undefined,
                defectTypeId: this.defectTypeId,
                severity: this.severity,
                orderBy: this.orderBy,
                showDefectComments: this.showDefectComments.toString(),
                autoRun: true
            };
            this.$state.transitionTo(this.$state.current.name, params);
        };
        DefectsReportCtrl.prototype.runReport = function () {
            var _this = this;
            var selectedPlantFromDropdown = document.getElementById('plantSelectionDropdown').value;
            this.reportStartDate = this.startDate;
            this.reportEndDate = this.endDate || new Date();
            if (selectedPlantFromDropdown == '-- all --') {
                return this.reportService
                    .getDefectsReportAll(this.defectTypeId, this.reportStartDate, this.reportEndDate, this.severity)
                    .then(function (report) {
                    _this.report = report;
                    _this.searchPerformed = true;
                });
            }
            this.reportTimeZoneId = this.selectedPlant.timeZoneId;
            this.reportShopId = this.selectedShop.id;
            this.reportShopName = this.selectedShop.name;
            this.report = null;
            this.searchPerformed = false;
            return this.reportService
                .getDefectsReport(this.reportShopId, this.defectTypeId, this.reportStartDate, this.reportEndDate, this.severity)
                .then(function (report) {
                _this.report = report;
                _this.searchPerformed = true;
            });
        };
        DefectsReportCtrl.prototype.generateReport = function () {
            if (this.form.$invalid && (document.getElementById('plantSelectionDropdown').value != '-- all --')) {
                return;
            }
            this.saveState();
            var loadPromise = this.runReport();
            this.loaderService.loadingPromise(loadPromise);
            return loadPromise;
        };
        DefectsReportCtrl.prototype.disableOtherDropdowns = function () {
            if (document.getElementById('plantSelectionDropdown').value == '-- all --') {
                this.AllPlantsSelected = true;
                this.requireShopSelection = false;
                this.severity = null;
                this.defectTypeId = null;
                if (document.getElementById('shopDropdown') != null)
                    document.getElementById('shopDropdown').disabled = true;
                if (document.getElementById('severityDropdown') != null)
                    document.getElementById('severityDropdown').disabled = true;
                if (document.getElementById('defectTypeDropdown') != null)
                    document.getElementById('defectTypeDropdown').disabled = true;
            }
            else {
                this.AllPlantsSelected = false;
                this.requireShopSelection = true;
                if (document.getElementById('shopDropdown') != null)
                    document.getElementById('shopDropdown').disabled = false;
                if (document.getElementById('severityDropdown') != null)
                    document.getElementById('severityDropdown').disabled = false;
                if (document.getElementById('defectTypeDropdown') != null)
                    document.getElementById('defectTypeDropdown').disabled = false;
            }
        };
        DefectsReportCtrl.prototype.getOrderBy = function () {
            switch (this.orderBy) {
                case aps_enums_1.apsEnums.DefectOrder.Time:
                    return ['time'];
                case aps_enums_1.apsEnums.DefectOrder.Severity:
                    return ['severity', 'time'];
                case aps_enums_1.apsEnums.DefectOrder.Location:
                    return ['machineName', 'section', 'gob', 'time'];
                case aps_enums_1.apsEnums.DefectOrder.Mold:
                    return ['toolNumber', 'time'];
                case aps_enums_1.apsEnums.DefectOrder.WhereFound:
                    return ['equipmentName', 'time'];
                case aps_enums_1.apsEnums.DefectOrder.PlantAndShop:
                    return ['plantName', 'shopName', 'time'];
                default:
                    return ['time'];
            }
        };
        DefectsReportCtrl.prototype.exportToCsv = function () {
            var heading = ["Plant Name", "Shop Name", "Date", "Time", "Item", "Defect", "ID", "Machine", "Location", "Mold", "Severity", "MNR", "Frequency", "Where Found", "Found By", "StartTime", "EndTime", "Duration"];
            var csv = [];
            csv.push(heading);
            this.report.sort(function (a, b) {
                var timeA = a.time, timeB = b.time;
                if (timeA < timeB)
                    return -1;
                if (timeA > timeB)
                    return 1;
                return 0;
            });
            for (var _i = 0, _a = this.report; _i < _a.length; _i++) {
                var row = _a[_i];
                var rowData = [];
                rowData.push(row.plantName, row.shopName, dateutility_service_1.default.formatDate(row.time, this.reportTimeZoneId), dateutility_service_1.default.formatTimeOnly(row.time, this.reportTimeZoneId), row.mold + "-" + row.finish, row.abbreviation, row.legacyId, row.machineName, row.section ? row.section + row.gobName : '', row.toolNumber ? row.toolNumber : '', row.severity, row.isMoldRejectInUse ? 'Yes' : 'No', row.frequencyType === 1
                    ? (row.frequencyCount ? row.frequencyCount + ' of ' + row.frequencyTotal : '')
                    : (row.frequencyType === 2 ? row.frequencyPercent + '%' : ''), row.equipmentName, row.foundBy, row.isMoldRejectInUse ? dateutility_service_1.default.formatTimeOnly(row.rejectStart, this.reportTimeZoneId) : '', row.isMoldRejectInUse ? dateutility_service_1.default.formatTimeOnly(row.rejectEnd, this.reportTimeZoneId) : '', row.isMoldRejectInUse ? row.totalDuration : '');
                csv.push(rowData);
            }
            return csv;
        };
        DefectsReportCtrl.prototype.updatePlant = function () {
            if (document.getElementById('plantSelectionDropdown').value == '-- all --') {
                this.allowErrorCheckForSelectedPlant = false;
                this.AllPlantsSelected = true;
                this.requireShopSelection = false;
                this.severity = null;
                this.defectTypeId = null;
                if (document.getElementById('shopDropdown') != null)
                    document.getElementById('shopDropdown').disabled = true;
                if (document.getElementById('severityDropdown') != null)
                    document.getElementById('severityDropdown').disabled = true;
                if (document.getElementById('defectTypeDropdown') != null)
                    document.getElementById('defectTypeDropdown').disabled = true;
            }
            else {
                this.allowErrorCheckForSelectedPlant = false;
                this.selectedShop = null;
                this.AllPlantsSelected = false;
                this.requireShopSelection = true;
                if (document.getElementById('shopDropdown') != null)
                    document.getElementById('shopDropdown').disabled = false;
                if (document.getElementById('severityDropdown') != null)
                    document.getElementById('severityDropdown').disabled = false;
                if (document.getElementById('defectTypeDropdown') != null)
                    document.getElementById('defectTypeDropdown').disabled = false;
            }
        };
        DefectsReportCtrl.prototype.formatTime = function (time) {
            return dateutility_service_1.default.formatTime(time, this.reportTimeZoneId);
        };
        DefectsReportCtrl.prototype.formatToTime = function (time) {
            return dateutility_service_1.default.formatTimeOnly(time, this.reportTimeZoneId);
        };
        return DefectsReportCtrl;
    }());
    exports.default = angular.module('aps.controller.defectsReport', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.DEFECTS_REPORT,
            url: '/admin/reports/defects?startDate&endDate&defectTypeId&severity&orderBy&showDefectComments&autoRun&reportPlantId&reportShopId',
            params: {
                startDate: { dynamic: true },
                endDate: { dynamic: true },
                defectTypeId: { dynamic: true },
                severity: { dynamic: true },
                orderBy: { dynamic: true },
                showDefectComments: { dynamic: true },
                autoRun: { dynamic: true },
                reportPlantId: { dynamic: true },
                reportShopId: { dynamic: true },
            },
            controller: 'DefectsReportCtrl as vm',
            template: defectsReport_tpl_html_1.default,
            data: {
                pageTitle: 'Defects Report',
                v2Uri: 'aps/reports/defects-report'
            }
        });
    }])
        .controller('DefectsReportCtrl', DefectsReportCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div class=body-header> <h2>Defects Report</h2> </div> <aps-common-report-query-criteria-row vm=vm></aps-common-report-query-criteria-row> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns\"> <label> Defect Severity <select id=severityDropdown ng-model=vm.severity ng-options=\"x.value as x.text for x in vm.severities\"> <option value=\"\">-- all --</option> </select> </label> </div> <div class=\"small-3 columns\"> <label> Defect <select id=defectTypeDropdown ng-model=vm.defectTypeId ng-options=\"x.id as x.name + ' (' + x.legacyId + ')' for x in vm.defectTypes | orderBy: 'name'\"> <option value=\"\">-- all --</option> </select> </label> </div> <div class=\"small-3 columns\"> <label> Order by <select ng-model=vm.orderBy ng-options=\"x.value as x.text for x in vm.orderBys\"> </select> </label> </div> <div class=\"small-3 columns\"> <label> <br/> <input type=checkbox ng-model=vm.showDefectComments /> Show Defect Comments </label> <div ng-if=vm.displayMaintCheckbox style=margin-top:-30px> <label> <br/> <input type=checkbox ng-model=vm.showMaintCodes /> Show Maintenance Codes </label> </div> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns\"> <button type=submit class=button>Generate Report</button> </div> </div> </form> <div ng-if=\"vm.report && vm.report.length\"> <a ng-csv=vm.exportToCsv() filename=\"Defects-{{vm.selectedPlant.name}}{{vm.selectedShop.name}}.csv\" class=right>Save as CSV</a> <table class=history-t> <thead> <tr> <th>Plant Name</th> <th>Shop Name</th> <th>Time Found</th> <th>Item</th> <th>Defect</th> <th>Machine</th> <th>Location</th> <th>Mold</th> <th>Severity</th> <th>MNR</th> <th>Frequency</th> <th>Where Found</th> <th>Found By</th> <th>Start</th> <th>End</th> <th>Duration</th> </tr> </thead> <tbody ng-repeat=\"item in vm.report | orderBy: vm.getOrderBy()\" ng-if=\"!vm.showMaintCodes && (item.legacyId < 2000 || item.legacyId > 2999)\"> <tr> <td>{{ item.plantName }}</td> <td>{{ item.shopName }}</td> <td>{{ vm.formatTime(item.time) }}</td> <td>{{ item.mold}}-{{item.finish}}</td> <td>{{ item.abbreviation }} ({{ item.legacyId }})</td> <td>{{ item.machineName }}</td> <td>{{ item.section }}{{ item.gobName }}</td> <td>{{ item.toolNumber }}</td> <td>{{ item.severity }}</td> <td>{{ item.isMoldRejectInUse ? \"Yes\" : \"No\" }}</td> <td> <span ng-if=\"item.frequencyType===1\">{{ item.frequencyCount }} / {{ item.frequencyTotal }}</span> <span ng-if=\"item.frequencyType===2\">{{ item.frequencyPercent }}%</span> </td> <td>{{ item.equipmentName }}</td> <td>{{ item.foundBy }}</td> <td>{{ item.isMoldRejectInUse ? vm.formatToTime(item.rejectStart) : '' }}</td> <td>{{ item.isMoldRejectInUse ? vm.formatToTime(item.rejectEnd): ''  }}</td> <td>{{ item.isMoldRejectInUse ? item.totalDuration : ''}}</td> </tr> <tr ng-repeat=\"comment in item.comments\" ng-if=vm.showDefectComments> <td colspan=10><i style=padding-left:25px>{{ comment.createdByFullName }} @ {{ vm.formatTime(comment.createdOn) }} : {{ comment.comment }}</i></td> </tr> </tbody> <tbody ng-repeat=\"item in vm.report | orderBy: vm.getOrderBy()\" ng-if=\"vm.showMaintCodes && item.legacyId > 1999 && item.legacyId < 3000\"> <tr> <td>{{ item.plantName }}</td> <td>{{ item.shopName }}</td> <td>{{ vm.formatTime(item.time) }}</td> <td>{{ item.mold}}-{{item.finish}}</td> <td>{{ item.abbreviation }} ({{ item.legacyId }})</td> <td>{{ item.machineName }}</td> <td>{{ item.section }}{{ item.gobName }}</td> <td>{{ item.toolNumber }}</td> <td>{{ item.severity }}</td> <td>{{ item.isMoldRejectInUse ? \"Yes\" : \"No\" }}</td> <td> <span ng-if=\"item.frequencyType===1\">{{ item.frequencyCount }} / {{ item.frequencyTotal }}</span> <span ng-if=\"item.frequencyType===2\">{{ item.frequencyPercent }}%</span> </td> <td>{{ item.equipmentName }}</td> <td>{{ item.foundBy }}</td> <td>{{ item.isMoldRejectInUse ? vm.formatToTime(item.rejectStart) : '' }}</td> <td>{{ item.isMoldRejectInUse ? vm.formatToTime(item.rejectEnd): ''  }}</td> <td>{{ item.isMoldRejectInUse ? item.totalDuration : ''}}</td> </tr> <tr ng-repeat=\"comment in item.comments\" ng-if=vm.showDefectComments> <td colspan=10><i style=padding-left:25px>{{ comment.createdByFullName }} @ {{ vm.formatTime(comment.createdOn) }} : {{ comment.comment }}</i></td> </tr> </tbody> </table> </div> <div ng-if=\"(!vm.report || !vm.report.length) && vm.searchPerformed\">No Defects found</div> </div>");

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(3), __webpack_require__(811), __webpack_require__(4), __webpack_require__(16), __webpack_require__(11), __webpack_require__(278), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, constant_module_1, deletedDefectReport_tpl_html_1, loader_service_1, report_service_1, dateutility_service_1, criticalDefectService_1, navigation_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, report_service_1.default, criticalDefectService_1.default, navigation_service_1.default];
    var DeletedDefectReportCtrl = (function () {
        DeletedDefectReportCtrl.$inject = ["$stateParams", "$state", "$q", "navigationService", "criticalDefectService", "reportService", "loaderService"];
        function DeletedDefectReportCtrl($stateParams, $state, $q, navigationService, criticalDefectService, reportService, loaderService) {
            var _this = this;
            this.$q = $q;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.loaderService = loaderService;
            this.reportService = reportService;
            this.criticalDefectService = criticalDefectService;
            var today = moment().startOf('day');
            this.startDate = today.clone().subtract(1, 'month').toDate();
            this.endDate = today.toDate();
            var promise = navigationService.getNavigation().then(function (navModel) {
                _this.plants = navModel.plants();
                _this.selectedPlant = navModel.selectedPlant;
                return _this.loadState($stateParams);
            });
            loaderService.loadingPromise(promise);
        }
        DeletedDefectReportCtrl.prototype.openReport = function (defect) {
            this.criticalDefectService.openReport(defect.shopId, defect);
        };
        DeletedDefectReportCtrl.prototype.loadState = function (params) {
            if (params.reportPlantId && params.reportPlantId !== params.plantId) {
                var plant = _.find(this.plants, { id: params.reportPlantId });
                if (plant) {
                    this.selectedPlant = plant;
                }
            }
            if (params.startDate) {
                var startDate = moment(params.startDate);
                if (startDate.isValid()) {
                    this.startDate = startDate.toDate();
                }
            }
            if (params.endDate) {
                var endDate = moment(params.endDate);
                if (endDate.isValid()) {
                    this.endDate = endDate.toDate();
                }
            }
            if (params.autoRun) {
                return this.runDefectReport();
            }
            return this.$q.when();
        };
        DeletedDefectReportCtrl.prototype.exportToCsv = function () {
            var _this = this;
            return _.orderBy(_.map(this.results, function (x) {
                var comments = '';
                _.each(x.comments, function (c) {
                    comments = "" + (comments + (comments.length > 0 ? ' - ' : '') + c.comment);
                });
                return {
                    shopName: x.shopName,
                    jobRunLegacyId: x.jobRunLegacyId,
                    jobDescription: x.jobDescription,
                    section: x.section,
                    gobName: x.gobName,
                    toolNumber: x.toolNumber,
                    severity: x.severity,
                    defectTypeLegacyId: x.defectTypeLegacyId,
                    defectTypeName: x.defectTypeName,
                    createdDetail: x.createdByFullName + " " + x.createdByLastRoleName + " " + dateutility_service_1.default.formatTime(x.createdOn, _this.selectedPlant.timeZoneId),
                    createdOn: x.createdOn,
                    comments: comments,
                    deletedDetail: x.deletedByFullName + " " + x.deletedByLastRoleName + " " + dateutility_service_1.default.formatTime(x.deletedOn, _this.selectedPlant.timeZoneId),
                    deletedOn: x.deletedOn,
                    reasonDeleted: x.reasonDeleted
                };
            }), ['shopName', 'deletedOn'], ['asc', 'asc']);
        };
        DeletedDefectReportCtrl.prototype.saveState = function () {
            var reportPlantId = this.selectedPlant ? this.selectedPlant.id : undefined;
            if (reportPlantId === this.$stateParams.plantId) {
                reportPlantId = undefined;
            }
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportPlantId: reportPlantId,
                startDate: this.startDate ? this.startDate.toISOString() : undefined,
                endDate: this.endDate ? this.endDate.toISOString() : undefined,
                autoRun: true
            };
            this.$state.transitionTo(constant_module_1.States.DELETED_DEFECT_REPORT, params);
        };
        DeletedDefectReportCtrl.prototype.generateReport = function () {
            if (this.form.$invalid) {
                return;
            }
            this.saveState();
            this.loaderService.loadingPromise(this.runDefectReport());
        };
        DeletedDefectReportCtrl.prototype.runDefectReport = function () {
            var _this = this;
            var startDateStart = moment(this.startDate).startOf('day').toDate();
            var tzOffsetStartDate = dateutility_service_1.default.localToTimeZone(startDateStart, this.selectedPlant.timeZoneId).toDate();
            var endDateEnd = moment(this.endDate || new Date()).endOf('day').toDate();
            var tzOffsetEndDate = dateutility_service_1.default.localToTimeZone(endDateEnd, this.selectedPlant.timeZoneId).toDate();
            return this.reportService.getDeletedDefectsReport(this.selectedPlant.id, tzOffsetStartDate, tzOffsetEndDate)
                .then(function (reportItems) {
                _this.results = reportItems;
                _this.searchPerformed = true;
            });
        };
        DeletedDefectReportCtrl.prototype.formatTime = function (time) {
            return dateutility_service_1.default.formatTime(time, this.selectedPlant.timeZoneId);
        };
        return DeletedDefectReportCtrl;
    }());
    exports.default = angular.module('aps.controller.deletedDefectReport', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.DELETED_DEFECT_REPORT,
            url: '/admin/reports/deletedDefects?startDate&endDate&autoRun&reportPlantId',
            params: {
                startDate: { dynamic: true },
                endDate: { dynamic: true },
                autoRun: { dynamic: true },
                reportPlantId: { dynamic: true },
            },
            controller: 'DeletedDefectReportCtrl as vm',
            template: deletedDefectReport_tpl_html_1.default,
            data: {
                pageTitle: 'Deleted Defect Report'
            }
        });
    }])
        .controller('DeletedDefectReportCtrl', DeletedDefectReportCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div class=body-header> <h2>Deleted Defects Report</h2> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-4 columns\"> <label> <span class=\"required notated\">*</span>Plant <select ng-model=vm.selectedPlant ng-options=\"plant as plant.name for plant in vm.plants\" ng-change=vm.updatePlant() name=selectedPlant required> <option value=\"\">-- Select a Plant --</option> </select> <div ng-messages=vm.form.selectedPlant.$error ng-if=\"vm.form.selectedPlant.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-4 columns\"> <label> <span class=\"required notated\">*</span>Start Date <input type=date ng-model=vm.startDate name=startDate required/> <div ng-messages=vm.form.startDate.$error ng-if=\"vm.form.startDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-4 columns\"> <label> <span class=\"required notated\">*</span>End Date <input type=date ng-model=vm.endDate name=endDate min=\"{{ vm.startDate }}\" required/> <div ng-messages=vm.form.endDate.$error ng-if=\"vm.form.endDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required </div> <div ng-message=min class=req-w> <div class=arrow-up> </div>Must be greater than or equal to the Start Date</div> </div> </label> </div> </div> <button type=submit class=button>Generate Report</button> </form> <a ng-csv=vm.exportToCsv() ng-if=\"vm.results && vm.results.length\" filename=deletedDefectReportExport.csv class=right>Save as CSV</a> <table class=history-t ng-if=\"vm.results && vm.results.length\"> <thead> <tr> <th>Shop</th> <th>Job No</th> <th>Part Desc</th> <th>Sec</th> <th>Gob</th> <th>Mld No</th> <th>Defect Abbr.</th> <th>Id</th> <th>Defect Name</th> <th>Created By</th> <th>Comment</th> <th>Deleted By</th> <th>Reason</th> <th>&nbsp;</th> </tr> </thead> <tbody> <tr ng-repeat=\"deletedDefect in vm.results | orderBy:['shopName', 'deletedOn']\"> <td>{{deletedDefect.shopName}}</td> <td>{{deletedDefect.jobRunLegacyId}}</td> <td>{{deletedDefect.jobDescription}}</td> <td>{{deletedDefect.section}}</td> <td>{{deletedDefect.gobName}}</td> <td>{{deletedDefect.toolNumber}}</td> <td> <span class=\"lineitem severity-{{deletedDefect.severity}}\" style=color:#fff;font-size:.9em;padding:4px>{{deletedDefect.defectTypeAbbreviation}}<span> </span></span></td> <td>{{deletedDefect.defectTypeLegacyId}}</td> <td>{{deletedDefect.defectTypeName}}</td> <td> <div>{{deletedDefect.createdByFullName}}</div> <div><b>{{deletedDefect.createdByLastRoleName}}</b> {{vm.formatTime(deletedDefect.createdOn)}}</div> </td> <td> <div ng-repeat=\"comment in deletedDefect.comments\">{{ comment.comment }}</div> </td> <td> <div>{{deletedDefect.deletedByFullName}}</div> <div><b>{{deletedDefect.deletedByLastRoleName}}</b> {{vm.formatTime(deletedDefect.deletedOn)}}</div> </td> <td>{{deletedDefect.reasonDeleted}}</td> <td> <button type=button class=\"button tiny\" ng-if=\"deletedDefect.severity === 0\" ng-click=vm.openReport(deletedDefect)>Report</button> </td> </tr> </tbody> </table> <div ng-if=\"(!vm.results || !vm.results.length) && vm.searchPerformed\">No results found</div> </div>");

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(3), __webpack_require__(813), __webpack_require__(4), __webpack_require__(16), __webpack_require__(11), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, constant_module_1, deletedGobWeightReport_tpl_html_1, loader_service_1, report_service_1, dateutility_service_1, navigation_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, report_service_1.default, navigation_service_1.default];
    var DeletedGobWeightReportCtrl = (function () {
        DeletedGobWeightReportCtrl.$inject = ["$stateParams", "$state", "$q", "navigationService", "reportService", "loaderService"];
        function DeletedGobWeightReportCtrl($stateParams, $state, $q, navigationService, reportService, loaderService) {
            var _this = this;
            this.exportToCsv = function () {
                var _this = this;
                return _.orderBy(_.map(this.results, function (x) {
                    var comments = '';
                    _.each(x.comments, function (c) {
                        comments = "" + (comments + (comments.length > 0 ? ' - ' : '') + c.comment);
                    });
                    return {
                        shop: x.shopName,
                        jobRunLegacyId: x.jobRunLegacyId,
                        jobDescription: x.jobDescription,
                        gobName: x.gobName,
                        weight: x.weight,
                        weightTarget: x.weightTarget,
                        createdDetail: x.createdByFullName + " - " + dateutility_service_1.default.formatTime(x.createdOn, _this.selectedPlant.timeZoneId),
                        comments: comments,
                        deletedDetail: x.deletedByFullName + " - " + dateutility_service_1.default.formatTime(x.deletedOn, _this.selectedPlant.timeZoneId),
                    };
                }), ['shopName', 'deletedOn'], ['asc', 'asc']);
            };
            this.$q = $q;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.loaderService = loaderService;
            this.reportService = reportService;
            var today = moment().startOf('day');
            this.startDate = today.clone().subtract(1, 'month').toDate();
            this.endDate = today.toDate();
            var promise = navigationService.getNavigation().then(function (navModel) {
                _this.plants = navModel.plants();
                _this.selectedPlant = navModel.selectedPlant;
                return _this.loadState($stateParams);
            });
            loaderService.loadingPromise(promise);
        }
        DeletedGobWeightReportCtrl.prototype.loadState = function (params) {
            if (params.reportPlantId && params.reportPlantId !== params.plantId) {
                var plant = _.find(this.plants, { id: params.reportPlantId });
                if (plant) {
                    this.selectedPlant = plant;
                }
            }
            if (params.startDate) {
                var startDate = moment(params.startDate);
                if (startDate.isValid()) {
                    this.startDate = startDate.toDate();
                }
            }
            if (params.endDate) {
                var endDate = moment(params.endDate);
                if (endDate.isValid()) {
                    this.endDate = endDate.toDate();
                }
            }
            if (params.autoRun) {
                return this.runGobWeightReport();
            }
            return this.$q.when();
        };
        DeletedGobWeightReportCtrl.prototype.saveState = function () {
            var reportPlantId = this.selectedPlant ? this.selectedPlant.id : undefined;
            if (reportPlantId === this.$stateParams.plantId) {
                reportPlantId = undefined;
            }
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportPlantId: reportPlantId,
                startDate: this.startDate ? this.startDate.toISOString() : undefined,
                endDate: this.endDate ? this.endDate.toISOString() : undefined,
                autoRun: true
            };
            this.$state.transitionTo(constant_module_1.States.DELETED_GOB_WEIGHT_REPORT, params);
        };
        DeletedGobWeightReportCtrl.prototype.generateReport = function () {
            if (this.form.$invalid) {
                return;
            }
            this.saveState();
            this.loaderService.loadingPromise(this.runGobWeightReport());
        };
        DeletedGobWeightReportCtrl.prototype.runGobWeightReport = function () {
            var _this = this;
            var startDateStart = moment(this.startDate).startOf('day').toDate();
            var tzOffsetStartDate = dateutility_service_1.default.localToTimeZone(startDateStart, this.selectedPlant.timeZoneId).toDate();
            var endDateEnd = moment(this.endDate || new Date()).endOf('day').toDate();
            var tzOffsetEndDate = dateutility_service_1.default.localToTimeZone(endDateEnd, this.selectedPlant.timeZoneId).toDate();
            return this.reportService.getDeletedGobWeightsReport(this.selectedPlant.id, tzOffsetStartDate, tzOffsetEndDate)
                .then(function (reportItems) {
                _this.results = reportItems;
                _this.searchPerformed = true;
            });
        };
        DeletedGobWeightReportCtrl.prototype.formatTime = function (time) {
            return dateutility_service_1.default.formatTime(time, this.selectedPlant.timeZoneId);
        };
        return DeletedGobWeightReportCtrl;
    }());
    exports.default = angular.module('aps.controller.deletedGobWeightReport', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.DELETED_GOB_WEIGHT_REPORT,
            url: '/admin/reports/deletedGobWeights?startDate&endDate&autoRun&reportPlantId',
            params: {
                startDate: { dynamic: true },
                endDate: { dynamic: true },
                autoRun: { dynamic: true },
                reportPlantId: { dynamic: true },
            },
            controller: 'DeletedGobWeightReportCtrl as vm',
            template: deletedGobWeightReport_tpl_html_1.default,
            data: {
                pageTitle: 'Deleted Gob Weight Report'
            }
        });
    }])
        .controller('DeletedGobWeightReportCtrl', DeletedGobWeightReportCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div class=body-header> <h2>Deleted Gob Weights Report</h2> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-4 columns\"> <label> <span class=\"required notated\">*</span>Plant <select ng-model=vm.selectedPlant ng-options=\"plant as plant.name for plant in vm.plants\" ng-change=vm.updatePlant() name=selectedPlant required> <option value=\"\">-- Select a Plant --</option> </select> <div ng-messages=vm.form.selectedPlant.$error ng-if=\"vm.form.selectedPlant.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-4 columns\"> <label> <span class=\"required notated\">*</span>Start Date <input type=date ng-model=vm.startDate name=startDate required/> <div ng-messages=vm.form.startDate.$error ng-if=\"vm.form.startDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-4 columns\"> <label> <span class=\"required notated\">*</span>End Date <input type=date ng-model=vm.endDate name=endDate min=\"{{ vm.startDate }}\" required/> <div ng-messages=vm.form.endDate.$error ng-if=\"vm.form.endDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be greater than or equal to the Start Date</div> </div> </label> </div> </div> <button type=submit class=button>Generate Report</button> </form> <a ng-csv=vm.exportToCsv() ng-if=\"vm.results && vm.results.length\" filename=deletedGobWeightReportExport.csv class=right>Save as CSV</a> <table class=history-t ng-if=\"vm.results && vm.results.length\"> <thead> <tr> <th>Shop</th> <th>Job No</th> <th>Part Desc</th> <th>Gob</th> <th>Weight</th> <th>Target</th> <th>Created By</th> <th>Comment</th> <th>Deleted By / On</th> <th>&nbsp;</th> </tr> </thead> <tbody> <tr ng-repeat=\"deletedGobWeight in vm.results | orderBy:['shopName', 'deletedOn']\"> <td>{{deletedGobWeight.shopName}}</td> <td>{{deletedGobWeight.jobRunLegacyId}}</td> <td>{{deletedGobWeight.jobDescription}}</td> <td>{{deletedGobWeight.gobName}}</td> <td>{{deletedGobWeight.weight}}</td> <td>{{deletedGobWeight.weightTarget}}</td> <td> <div>{{deletedGobWeight.createdByFullName}}</div> <div><b>{{deletedGobWeight.createdByLastRoleName}}</b> {{vm.formatTime(deletedGobWeight.createdOn)}}</div> </td> <td> <div ng-repeat=\"comment in deletedGobWeight.comments\">{{ comment.comment }}</div> </td> <td> <div>{{deletedGobWeight.deletedByFullName}}</div> <div><b>{{deletedGobWeight.deletedByLastRoleName}}</b> {{vm.formatTime(deletedGobWeight.deletedOn)}}</div> </td> <td> <button type=button class=\"button tiny\" ng-if=\"deletedGobWeight.severity === 0\" ng-click=vm.openReport(deletedGobWeight)>Report</button> </td> </tr> </tbody> </table> <div ng-if=\"(!vm.results || !vm.results.length) && vm.searchPerformed\">No results found</div> </div>");

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(815), __webpack_require__(5), __webpack_require__(9), __webpack_require__(4), __webpack_require__(16), __webpack_require__(11), __webpack_require__(3), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, downtimeReport_tpl_html_1, aps_enums_1, uiUtility_service_1, loader_service_1, report_service_1, dateutility_service_1, constant_module_1, navigation_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [uiUtility_service_1.default, loader_service_1.default, report_service_1.default, navigation_service_1.default];
    var DowntimeReportCtrl = (function () {
        DowntimeReportCtrl.$inject = ["$state", "$stateParams", "navigationService", "reportService", "loaderService", "uiUtilityService", "$timeout", "$q"];
        function DowntimeReportCtrl($state, $stateParams, navigationService, reportService, loaderService, uiUtilityService, $timeout, $q) {
            var vm = this;
            vm.$state = $state;
            vm.$stateParams = $stateParams;
            vm.loaderService = loaderService;
            vm.reportService = reportService;
            vm.uiUtilityService = uiUtilityService;
            vm.$q = $q;
            vm.$timeout = $timeout;
            vm.defectType = '';
            vm.preventativeText = 'Preventative';
            vm.nonPreventativeText = 'Corrective';
            vm.typeToColor = this.getTypeToColorMappings();
            vm.requirePlantSelection = true;
            vm.requireShopSelection = true;
            var now = moment().add(1, 'hours').startOf('hour');
            vm.uiEndDate = now.toDate();
            vm.uiStartDate = now.clone().subtract(1, 'days').toDate();
            vm.types = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.DowntimeType);
            vm.locations = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.DowntimeLocation);
            vm.orderBys = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.DowntimeOrder, 1);
            vm.type = aps_enums_1.apsEnums.DowntimeType.All;
            vm.location = aps_enums_1.apsEnums.DowntimeLocation.All;
            vm.orderBy = aps_enums_1.apsEnums.DowntimeOrder.Time;
            vm.showAll = false;
            vm.scopeWorkaround = {
                downtimeBarClick: function (dimpleEvent) {
                    if (dimpleEvent
                        && !_.isUndefined(dimpleEvent.xValue)
                        && dimpleEvent.seriesValue
                        && dimpleEvent.seriesValue[0]) {
                        var section = dimpleEvent.xValue;
                        var isPreventative = vm.preventativeText === dimpleEvent.seriesValue[0];
                        vm.getReportDetails(section, isPreventative ? aps_enums_1.apsEnums.DowntimeType.Preventative : aps_enums_1.apsEnums.DowntimeType.Corrective);
                    }
                }
            };
            var promise = navigationService.getNavigation().then(function (navModel) {
                vm.plants = navModel.plants();
                vm.selectedPlant = navModel.selectedPlant;
                vm.updatePlant();
                vm.selectedShop = navModel.selectedShop;
                return vm.loadState($stateParams);
            });
            loaderService.loadingPromise(promise);
        }
        DowntimeReportCtrl.prototype.runReport = function () {
            var _this = this;
            return this.reportService
                .getDowntimeReport(this.reportShopId, this.type, this.location, this.reportStartDate, this.reportEndDate)
                .then(function (downtimeSummaries) {
                _this.downtimeSummaries = downtimeSummaries;
                _this.downtimeSummariesPretty = _this.transformDowntimeSummariesPretty(downtimeSummaries);
                _this.searchPerformed = true;
            });
        };
        DowntimeReportCtrl.prototype.defectTypes = function () {
            if (!this.detailsReportGenerated || !this.downtimeDetails || !this.downtimeDetails.length) {
                return [];
            }
            return _.uniq(_.filter(this.downtimeDetails, function (x) { return !!x.defectTypeName; })
                .map(function (x) { return x.defectTypeName; }));
        };
        DowntimeReportCtrl.prototype.downtimeDetailsFiltered = function () {
            var _this = this;
            if (!this.defectType) {
                return this.downtimeDetails;
            }
            return _.filter(this.downtimeDetails, function (x) { return x.defectTypeName === _this.defectType; });
        };
        DowntimeReportCtrl.prototype.loadState = function (params) {
            if (params.reportPlantId && params.reportShopId && params.reportShopId !== params.shopId) {
                var plant = _.find(this.plants, { id: params.reportPlantId });
                if (plant) {
                    var shop = _.find(plant.shops, { id: params.reportShopId });
                    if (shop) {
                        this.selectedPlant = plant;
                        this.selectedShop = shop;
                    }
                }
            }
            dateutility_service_1.default.setReportDates(this, params, this.$timeout);
            if (params.type !== undefined) {
                var type = _.find(this.types, { value: +params.type });
                if (type) {
                    this.type = type.value;
                }
            }
            if (params.location !== undefined) {
                var location = _.find(this.locations, { value: +params.location });
                if (location) {
                    this.location = location.value;
                }
            }
            if (params.orderBy !== undefined) {
                var orderBy = _.find(this.orderBys, { value: +params.orderBy });
                if (orderBy) {
                    this.orderBy = orderBy.value;
                }
            }
            if (params.showAll === 'true') {
                this.showAll = true;
            }
            if (params.autoRun) {
                return this.runDowntimeReport();
            }
            return this.$q.when();
        };
        DowntimeReportCtrl.prototype.saveState = function () {
            var reportShopId = this.selectedShop ? this.selectedShop.id : undefined;
            if (reportShopId === this.$stateParams.shopId) {
                reportShopId = undefined;
            }
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportPlantId: (reportShopId && this.selectedPlant) ? this.selectedPlant.id : undefined,
                reportShopId: reportShopId,
                startDate: this.startDate ? this.startDate.toISOString() : undefined,
                endDate: this.endDate ? this.endDate.toISOString() : undefined,
                type: this.type,
                location: this.location,
                orderBy: this.orderBy,
                showAll: this.showAll.toString(),
                autoRun: true
            };
            this.$state.transitionTo(this.$state.current.name, params);
        };
        DowntimeReportCtrl.prototype.runDowntimeReport = function () {
            this.reportShopId = this.selectedShop.id;
            this.reportShopName = this.selectedShop.name;
            this.reportStartDate = this.startDate;
            this.reportEndDate = this.endDate || new Date();
            this.reportTimeZoneId = this.selectedPlant.timeZoneId;
            this.downtimeSummaries = null;
            this.downtimeSummariesPretty = null;
            this.downtimeDetails = null;
            this.searchPerformed = false;
            this.detailsReportGenerated = false;
            if (this.showAll) {
                return this.getReportDetails('', this.type);
            }
            return this.runReport();
        };
        DowntimeReportCtrl.prototype.generateReport = function () {
            if (this.form.$invalid) {
                return;
            }
            this.saveState();
            var loadPromise = this.runDowntimeReport();
            this.loaderService.loadingPromise(loadPromise);
            return loadPromise;
        };
        DowntimeReportCtrl.prototype.transformDowntimeSummariesPretty = function (downtimeSummaries) {
            var _this = this;
            return _.map(downtimeSummaries, function (dts) {
                return {
                    'Section Number': (dts.machineName === 'A' ? 100 : 200) + (_.isNull(dts.section) ? 99 : dts.section),
                    'Section Name': dts.machineName + (_.isNull(dts.section) ? '' : '/' + dts.section),
                    'Total Minutes': dts.totalMinutes,
                    Type: dts.preventative ? _this.preventativeText : _this.nonPreventativeText,
                    'Type Order': dts.preventative ? 0 : 1
                };
            });
        };
        DowntimeReportCtrl.prototype.getReportDetails = function (section, type) {
            var _this = this;
            this.reportDetailsSection = section;
            this.reportDetailsType = type;
            var loadPromise = this.reportService
                .getDowntimeReportDetails(this.reportShopId, type, this.location, section, this.reportStartDate, this.reportEndDate)
                .then(function (downtimeDetails) {
                _this.downtimeDetails = downtimeDetails;
                _this.detailsReportGenerated = true;
                _this.defectType = '';
            });
            this.loaderService.loadingPromise(loadPromise);
            return loadPromise;
        };
        DowntimeReportCtrl.prototype.getTypeToColorMappings = function () {
            var typeToColor = {};
            typeToColor[this.nonPreventativeText] = constant_module_1.Colors.TOOL_CHANGE;
            return typeToColor;
        };
        DowntimeReportCtrl.prototype.formatTime = function (time) {
            return dateutility_service_1.default.formatTime(time, this.reportTimeZoneId);
        };
        DowntimeReportCtrl.prototype.updatePlant = function () {
            this.selectedShop = null;
        };
        DowntimeReportCtrl.prototype.getOrderBy = function () {
            switch (this.orderBy) {
                case aps_enums_1.apsEnums.DowntimeOrder.Time:
                    return ['startTime', 'downtimeType', '-duration', 'reason', 'tool', 'machineName', 'section', 'gob'];
                case aps_enums_1.apsEnums.DowntimeOrder.Type:
                    return ['downtimeType', 'startTime', '-duration', 'reason', 'tool', 'machineName', 'section', 'gob'];
                case aps_enums_1.apsEnums.DowntimeOrder.Duration:
                    return ['-duration', 'startTime', 'downtimeType', 'reason', 'tool', 'machineName', 'section', 'gob'];
                case aps_enums_1.apsEnums.DowntimeOrder.Reason:
                    return ['reason', 'startTime', 'downtimeType', '-duration', 'tool', 'machineName', 'section', 'gob'];
                case aps_enums_1.apsEnums.DowntimeOrder.Comment:
                    return ['comment', 'startTime', 'downtimeType', '-duration', 'reason', 'tool', 'machineName', 'section', 'gob'];
                case aps_enums_1.apsEnums.DowntimeOrder.Tool:
                    return ['tool', 'startTime', 'downtimeType', '-duration', 'reason', 'machineName', 'section', 'gob'];
                case aps_enums_1.apsEnums.DowntimeOrder.Machine:
                    return ['machineName', 'section', 'gob', 'startTime', 'downtimeType', '-duration', 'reason', 'tool'];
                case aps_enums_1.apsEnums.DowntimeOrder.Location:
                    return ['section', 'gob', 'machineName', 'startTime', 'downtimeType', '-duration', 'reason', 'tool'];
                default:
                    return ['startTime', 'downtimeType', '-duration', 'reason', 'tool', 'machineName', 'section', 'gob'];
            }
        };
        DowntimeReportCtrl.prototype.exportToCsv = function () {
            var _this = this;
            return _.map(this.downtimeDetailsFiltered(), function (x) {
                return {
                    time: _this.formatTime(x.startTime),
                    type: x.downtimeType,
                    defectType: x.defectTypeName,
                    duration: x.duration,
                    reason: x.reason,
                    comment: x.comment,
                    tool: x.tool,
                    machine: x.machineName,
                    section: x.section,
                    gob: x.gobName
                };
            });
        };
        return DowntimeReportCtrl;
    }());
    var DowntimeReportItem = (function () {
        function DowntimeReportItem() {
        }
        return DowntimeReportItem;
    }());
    exports.default = angular.module('aps.controller.downtimeReport', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.DOWNTIME_REPORT,
            url: '/admin/reports/downtime?startDate&endDate&type&location&orderBy&showAll&autoRun&reportPlantId&reportShopId',
            params: {
                startDate: { dynamic: true },
                endDate: { dynamic: true },
                type: { dynamic: true },
                location: { dynamic: true },
                orderBy: { dynamic: true },
                showAll: { dynamic: true },
                autoRun: { dynamic: true },
                reportPlantId: { dynamic: true },
                reportShopId: { dynamic: true },
            },
            controller: 'DowntimeReportCtrl as vm',
            template: downtimeReport_tpl_html_1.default,
            data: {
                pageTitle: 'Downtime Report'
            }
        });
    }])
        .controller('DowntimeReportCtrl', DowntimeReportCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div class=body-header> <h2>Downtime Report</h2> </div> <aps-common-report-query-criteria-row vm=vm></aps-common-report-query-criteria-row> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns\"> <label> Downtime Type <select ng-model=vm.type ng-options=\"x.value as x.text for x in vm.types\"> </select> </label> </div> <div class=\"small-3 columns\"> <label> Downtime Location <select ng-model=vm.location ng-options=\"x.value as x.text for x in vm.locations\"> </select> </label> </div> <div class=\"small-3 columns\"> <label> Order by <select ng-model=vm.orderBy ng-options=\"x.value as x.text for x in vm.orderBys\"> </select> </label> </div> <div class=\"small-3 columns\"> <label> <br/> <input type=checkbox ng-model=vm.showAll /> Show all Downtime </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns\"> <button type=submit class=button>Generate Report</button> </div> <div class=\"small-3 columns\" ng-if=\"vm.defectTypes() && vm.defectTypes().length\"> <label> Defect Type <select ng-model=vm.defectType> <option value=\"\">All</option> <option ng-repeat=\"defectType in vm.defectTypes()\" value=\"{{defectType}}\">{{defectType}}</option> </select> </label> </div> <div class=\"small-6 columns\"> &nbsp; </div> </div> </form> <div ng-if=\"vm.downtimeSummaries && vm.downtimeSummaries.length\"> <label>Downtime on Shop {{ vm.reportShopName }} from {{ vm.formatTime(vm.reportStartDate) }} to {{ vm.formatTime(vm.reportEndDate) }}</label> <dimple-graph data=vm.downtimeSummariesPretty bar-color-override=vm.typeToColor dimple-click=vm.scopeWorkaround.downtimeBarClick width=100% height=275px> <dimple-x field=\"Section Name\" order-by=\"Section Number\" title=\"Machine / Section\"></dimple-x> <dimple-y field=\"Total Minutes\" title=Minutes></dimple-y> <dimple-graph-legend position=right></dimple-graph-legend> <dimple-stacked-bar field=Type order-by=\"Type Order\"></dimple-stacked-bar> </dimple-graph> </div> <div ng-if=\"vm.downtimeDetailsFiltered() && vm.downtimeDetailsFiltered().length\"> <label ng-if=!vm.showAll> <span ng-if=\"vm.reportDetailsType === apsEnums.DowntimeType.All\">All</span> <span ng-if=\"vm.reportDetailsType === apsEnums.DowntimeType.Preventative\">Preventative</span> <span ng-if=\"vm.reportDetailsType === apsEnums.DowntimeType.Corrective\">Corrective</span> Downtime for {{ vm.reportDetailsSection ? 'Section ' + vm.reportDetailsSection : 'Machine'}} </label> <a ng-csv=vm.exportToCsv() filename=downtime.csv class=right>Save as CSV</a> <table class=history-t> <thead> <tr> <th>Time</th> <th>Type</th> <th>Defect Type</th> <th>Duration</th> <th>Reason</th> <th>Comment</th> <th>Tool</th> <th>Machine</th> <th>Location</th> </tr> </thead> <tbody> <tr ng-repeat=\"downtime in vm.downtimeDetailsFiltered() | orderBy: vm.getOrderBy()\"> <td>{{ vm.formatTime(downtime.startTime) }}</td> <td>{{ downtime.downtimeType }}</td> <td>{{ downtime.defectTypeName }}</td> <td>{{ downtime.duration }}</td> <td>{{ downtime.reason }}</td> <td>{{ downtime.comment }}</td> <td>{{ downtime.tool }}</td> <td>{{ downtime.machineName }}</td> <td>{{ downtime.section }}{{ downtime.gobName }}</td> </tr> </tbody> </table> </div> <div ng-if=\"(!vm.downtimeDetails || !vm.downtimeDetails.length) && vm.detailsReportGenerated\">No Downtime Details found</div> <div ng-if=\"(!vm.downtimeSummaries || !vm.downtimeSummaries.length) && vm.searchPerformed\">No Downtime found</div> </div>");

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(5), __webpack_require__(3), __webpack_require__(3), __webpack_require__(32), __webpack_require__(817), __webpack_require__(9), __webpack_require__(818), __webpack_require__(820), __webpack_require__(11), __webpack_require__(7), __webpack_require__(822), __webpack_require__(43), __webpack_require__(4), __webpack_require__(54), __webpack_require__(6), __webpack_require__(8), __webpack_require__(38), __webpack_require__(30)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, aps_enums_1, constant_module_1, constant_module_2, checkListInstances_service_1, wellKnownChecks_service_1, uiUtility_service_1, uiTextInput_service_1, uiAudit_service_1, dateutility_service_1, authData_service_1, furnacePullReport_tpl_html_1, environment_1, loader_service_1, locations_service_1, notify_service_1, navigation_service_1, fillOutCheckList_controller_1, checkLists_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, locations_service_1.default, navigation_service_1.default, uiUtility_service_1.default,
        notify_service_1.default, checkLists_service_1.default, checkListInstances_service_1.default, authData_service_1.default,
        wellKnownChecks_service_1.default, uiUtility_service_1.default, uiTextInput_service_1.default, uiAudit_service_1.default,
        environment_1.default];
    var FurnacePullReportCtrl = (function () {
        FurnacePullReportCtrl.$inject = ["environment", "authService", "authDataService", "checkListsService", "checkListInstancesService", "wellKnownChecksService", "locationsService", "navigationService", "loaderService", "reportService", "notifyService", "uiUtilityService", "uiAuditService", "uiTextInputService", "$state", "$rootScope", "$stateParams", "$q", "$timeout", "$modal"];
        function FurnacePullReportCtrl(environment, authService, authDataService, checkListsService, checkListInstancesService, wellKnownChecksService, locationsService, navigationService, loaderService, reportService, notifyService, uiUtilityService, uiAuditService, uiTextInputService, $state, $rootScope, $stateParams, $q, $timeout, $modal) {
            var _this = this;
            this.searchPerformed = false;
            this.hideShopSelection = true;
            this.showMissingWeightsOnly = false;
            this.viewOptions = constant_module_1.Enums.FURNACE_PULL_VIEW_OPTIONS;
            this.selectedView = this.viewOptions[0];
            this.detailTypes = constant_module_2.FurnacePullReportDetailTypes;
            this.generatingReport = false;
            this.exportToCsv = function () {
                var _this = this;
                var reportExportData = null;
                switch (this.selectedView.id) {
                    case this.viewOptions[0].id:
                        reportExportData = _.map(this.report, function (r) {
                            var weights = [];
                            weights = _.map(r.bottleWeights, function (bw) {
                                return bw.bottleWeight;
                            });
                            return {
                                dateTime: _this.formatTime(r.dateHour, r.timeZone),
                                plant: r.plant,
                                shop: r.shop,
                                tank: r.tank,
                                containerSpeed: r.bottlesPerHour.toString(),
                                shearCuts: r.shearCutsPerHour.toString(),
                                uptimeTonnage: r.uptimeTonnage.toString(),
                                downtimeTonnage: r.downtimeTonnage.toString(),
                                totalTonnage: r.totalTonnage.toString(),
                                weightTarget: r.weightTarget.toString(),
                                weightList: weights.join(', ')
                            };
                        });
                        break;
                    case this.viewOptions[1].id:
                        reportExportData = _.map(this.report, function (r) {
                            return {
                                dateTime: _this.formatTime(r.timeStamp, r.timeZone),
                                plant: r.plant,
                                tank: r.tank,
                                totalTonnage: r.value.toString()
                            };
                        });
                        break;
                }
                return reportExportData;
            };
            var now = moment().add(1, 'hours').startOf('hour');
            this.authService = authService;
            this.checkListInstancesService = checkListInstancesService;
            this.wellKnownChecksService = wellKnownChecksService;
            this.uiUtilityService = uiUtilityService;
            this.uiAuditService = uiAuditService;
            this.uiTextInputService = uiTextInputService;
            this.uiEndDate = now.toDate();
            this.uiStartDate = now.clone().subtract(1, 'days').toDate();
            this.authDataService = authDataService;
            this.loaderService = loaderService;
            this.reportService = reportService;
            this.notifyService = notifyService;
            this.checkListsService = checkListsService;
            this.$q = $q;
            this.$state = $state;
            this.$modal = $modal;
            this.checkLists = [];
            this.locationsService = locationsService;
            this.reportDate = moment().startOf('day').toDate();
            this.timeZone = constant_module_2.Strings.DEFAULT_TIMEZONE;
            this.$stateParams = $stateParams;
            this.$timeout = $timeout;
            this.$rootScope = $rootScope;
            this.showMissingWeightsOnly = false;
            this.checkListInstance = null;
            this.addWeightModalOpen = false;
            var promise = locationsService.initialize().then(function () {
                return navigationService.getNavigation().then(function (navModel) {
                    _this.plants = navModel.plants();
                    _this.selectedPlant = navModel.selectedPlant;
                    _this.loadState($stateParams);
                });
            });
            loaderService.loadingPromise(promise);
            promise = navigationService.getNavigation().then(function (navModel) {
                _this.plants = navModel.plants();
                _this.selectedPlant = navModel.selectedPlant;
                _this.selectedShop = navModel.selectedShop;
                return _this.loadState($stateParams);
            });
            loaderService.loadingPromise(promise);
            this.$rootScope.$on(constant_module_1.BroadcastMessages.FILL_OUT_CHECKLIST_CANCELLED, function () {
                if (_this.checkListInstance) {
                    _this.checkListInstancesService.deleteCheckListInstance(_this.checkListInstance)
                        .then(function () {
                        if (!_this.generatingReport) {
                            _this.$timeout(function () {
                                _this.generateReport();
                                _this.addWeightModalOpen = false;
                            }, 1500);
                        }
                    })
                        .catch(function (ex) {
                        _this.addWeightModalOpen = false;
                    });
                }
            });
            if (typeof this.$rootScope['$$listenerCount'].FURNACE_PULL_AUDIT_COMMENT_DELETE_CANCELLED === 'undefined') {
                this.$rootScope.$on(constant_module_1.BroadcastMessages.FURNACE_PULL_AUDIT_COMMENT_DELETE_CANCELLED, function () {
                    _this.notifyService.warning('You must enter a comment to delete a weight', 'Delete Weight Cancelled');
                });
            }
            if (typeof this.$rootScope['$$listenerCount'].FURNACE_PULL_AUDIT_COMMENT_UPDATE_CANCELLED === 'undefined') {
                this.$rootScope.$on(constant_module_1.BroadcastMessages.FURNACE_PULL_AUDIT_COMMENT_UPDATE_CANCELLED, function (event, returnData) {
                    var weightItem = returnData.returnItem;
                    _this.notifyService.warning('You must enter a comment to update a weight', 'Update Weight Cancelled');
                    weightItem.bottleWeightEditValue = weightItem.bottleWeight;
                    _this.toggleWeightEdit(weightItem, false);
                });
            }
            if (typeof this.$rootScope['$$listenerCount'].FURNACE_PULL_AUDIT_COMMENT_DELETE_SUBMIT === 'undefined') {
                this.$rootScope.$on(constant_module_1.BroadcastMessages.FURNACE_PULL_AUDIT_COMMENT_DELETE_SUBMIT, function (event, returnData) {
                    var weightItem = returnData.returnItem;
                    var comment = returnData.userInput;
                    var suffix = (weightItem.comments ? " |~| " + weightItem.comments : '');
                    var now = new Date();
                    weightItem.comments = _this.formatTime(now, _this.selectedPlant.timeZoneId) + " - DELETED - " + _this.userData.fullName + ": \"" + comment + "\"" + suffix;
                    _this.loaderService.loadingPromise(_this.wellKnownChecksService.saveWellKnownCheckResult(weightItem)
                        .then(function () {
                        _this.wellKnownChecksService.deleteWellKnownCheckResult(weightItem)
                            .then(function () {
                            _.each(_this.report, function (ri) {
                                ri.bottleWeights = _.filter(ri.bottleWeights, function (bw) {
                                    return bw.wellKnownCheckResultId !== weightItem.wellKnownCheckResultId;
                                });
                            });
                            _this.notifyService.success('Weight deleted sucessfully', 'Delete Weight');
                            _this.loaderService.setAppLoading(true);
                            setTimeout(function () {
                                _this.checkListsService.resubmitUptimeChecks({ ShopId: weightItem.shopId, Date: weightItem.dateHour })
                                    .then(function () {
                                    setTimeout(function () {
                                        _this.generateReport(false);
                                        _this.loaderService.setAppLoading(false);
                                    }, 1000);
                                });
                            }, 2000);
                        }, _this.notifyService.handleApiErrors);
                    }, _this.notifyService.handleApiErrors));
                });
            }
            if (typeof this.$rootScope['$$listenerCount'].FURNACE_PULL_AUDIT_COMMENT_UPDATE_SUBMIT === 'undefined') {
                this.$rootScope.$on(constant_module_1.BroadcastMessages.FURNACE_PULL_AUDIT_COMMENT_UPDATE_SUBMIT, function (event, returnData) {
                    var weightItem = returnData.returnItem;
                    var comment = returnData.userInput;
                    var suffix = (weightItem.comments ? " |~| " + weightItem.comments : '');
                    var now = new Date();
                    weightItem.comments = _this.formatTime(now, _this.selectedPlant.timeZoneId) + " - UPDATED - " + _this.userData.fullName + ": \"" + comment + "\"" + suffix;
                    weightItem.lastModifiedOn = now;
                    weightItem.bottleWeightOriginalValue = weightItem.bottleWeight;
                    weightItem.bottleWeight = weightItem.bottleWeightEditValue;
                    weightItem.editing = false;
                    _this.wellKnownChecksService.saveWellKnownCheckResult(weightItem)
                        .then(function () {
                        weightItem.bottleWeightOriginalValue = weightItem.bottleWeightEditValue;
                        _this.loaderService.setAppLoading(true);
                        setTimeout(function () {
                            _this.checkListsService.resubmitUptimeChecks({ ShopId: weightItem.shopId, Date: weightItem.dateHour })
                                .then(function () {
                                setTimeout(function () {
                                    _this.generateReport(false);
                                    _this.loaderService.setAppLoading(false);
                                }, 1000);
                            });
                        }, 2000);
                    }, function (ex) {
                        weightItem.bottleWeight = weightItem.bottleWeightOriginalValue;
                        _this.notifyService.handleApiErrors(ex);
                    });
                });
            }
            this.authService.getUserData().then(function (userData) {
                _this.userData = userData;
            });
        }
        FurnacePullReportCtrl.prototype.loadState = function (params) {
            this.showMissingWeightsOnly = (typeof params.showMissingWeightsOnly !== 'undefined') ? (params.showMissingWeightsOnly.toLowerCase() === 'true') : false;
            this.selectedView = (typeof params.showMissingWeightsOnly !== 'undefined') ? JSON.parse(params.selectedView) : this.viewOptions[0];
            dateutility_service_1.default.setReportDates(this, params, this.$timeout);
            if (params.reportPlantId && params.reportShopId && params.reportShopId !== params.shopId) {
                var plant = _.find(this.plants, { id: params.reportPlantId });
                if (plant) {
                    var shop = _.find(plant.shops, { id: params.reportShopId });
                    if (shop) {
                        this.selectedPlant = plant;
                        this.selectedShop = shop;
                    }
                }
            }
        };
        FurnacePullReportCtrl.prototype.saveState = function () {
            var reportShopId = this.selectedShop ? this.selectedShop.id : undefined;
            if (reportShopId === this.$stateParams.shopId) {
                reportShopId = undefined;
            }
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                showMissingWeightsOnly: this.showMissingWeightsOnly.toString(),
                reportPlantId: (reportShopId && this.selectedPlant) ? this.selectedPlant.id : undefined,
                reportShopId: reportShopId,
                startDate: this.startDate ? this.startDate.toISOString() : undefined,
                endDate: this.endDate ? this.endDate.toISOString() : undefined,
                selectedView: JSON.stringify(this.selectedView)
            };
            this.$state.transitionTo(this.$state.current.name, params);
        };
        FurnacePullReportCtrl.prototype.generateReport = function (loadPromise) {
            if (loadPromise === void 0) { loadPromise = true; }
            if (this.form && this.form.$invalid) {
                return;
            }
            this.generatingReport = true;
            this.saveState();
            this.report = [];
            if (loadPromise)
                this.loaderService.loadingPromise(this.runFurnacePullReport());
            else
                this.runFurnacePullReport();
        };
        FurnacePullReportCtrl.prototype.updatePlant = function () {
        };
        FurnacePullReportCtrl.prototype.updateLocation = function () {
        };
        FurnacePullReportCtrl.prototype.updateStartDate = function () {
        };
        FurnacePullReportCtrl.prototype.updateEndDate = function () {
        };
        FurnacePullReportCtrl.prototype.formatTime = function (time, timeZoneId) {
            return dateutility_service_1.default.formatTime(time, timeZoneId);
        };
        FurnacePullReportCtrl.prototype.editWeight = function (weightItem) {
            var subject = 'You must enter a comment to be able to update the weight.';
            var headerText = 'Comment Entry';
            var placeHolderText = 'Enter a comment...';
            this.uiTextInputService.openTextInputModal(subject, headerText, placeHolderText, weightItem, {
                submit: constant_module_1.BroadcastMessages.FURNACE_PULL_AUDIT_COMMENT_UPDATE_SUBMIT,
                cancel: constant_module_1.BroadcastMessages.FURNACE_PULL_AUDIT_COMMENT_UPDATE_CANCELLED
            }, 1, 128);
        };
        FurnacePullReportCtrl.prototype.toggleWeightEdit = function (weightItem, editing) {
            weightItem.editing = editing;
            weightItem.bottleWeightEditValue = weightItem.bottleWeight;
        };
        FurnacePullReportCtrl.prototype.deleteWeight = function (weightItem) {
            var _this = this;
            var message = "Are you sure you want to remove the weight " + weightItem.bottleWeight + " from " + this.formatTime(weightItem.dateHour, weightItem.timeZone) + "?";
            var subject = "Confirm Remove Bottle Weight " + weightItem.bottleWeight;
            var bottleWeightDeleteModal = this.uiUtilityService.confirm(message, subject);
            bottleWeightDeleteModal.then(function (confirm) {
                if (!confirm)
                    return;
                var subject = 'You must enter a comment to be able to delete the weight.';
                var headerText = 'Comment Entry';
                var placeHolderText = 'Enter a comment...';
                _this.uiTextInputService.openTextInputModal(subject, headerText, placeHolderText, weightItem, {
                    submit: constant_module_1.BroadcastMessages.FURNACE_PULL_AUDIT_COMMENT_DELETE_SUBMIT,
                    cancel: constant_module_1.BroadcastMessages.FURNACE_PULL_AUDIT_COMMENT_DELETE_CANCELLED
                }, 1, 48);
            });
        };
        FurnacePullReportCtrl.prototype.openAddWeightModal = function (item) {
            var _this = this;
            var results = [];
            if (!this.generatingReport && !this.addWeightModalOpen) {
                this.addWeightModalOpen = true;
                item.isMachines.forEach(function (machine) {
                    for (var gobIndex = 1; gobIndex <= item.numberOfGobs; gobIndex++) {
                        results.push({
                            id: null,
                            checkId: item.checkId,
                            status: aps_enums_1.apsEnums.CheckStatus.Passed,
                            result: 3.0,
                            total: '0.00',
                            machineId: machine.id,
                            section: null,
                            gob: gobIndex,
                            sequence: null,
                            comment: '',
                            aggregateValues: null
                        });
                    }
                });
                this.checkListInstancesService.saveCheckListInstance({
                    id: null,
                    checkListId: item.checkListId,
                    plantId: item.plantId,
                    tankId: item.tankId,
                    shopId: item.shopId,
                    results: results,
                    scheduledOn: item.dateHour
                }).then(function () {
                    var cliGetPromise = _this.checkListInstancesService.getCheckListInstancesOnDate(item.shopId, true, item.dateHour);
                    cliGetPromise.then(function (checkListInstance) {
                        if (checkListInstance) {
                            _this.checkListInstance = checkListInstance;
                            var fillOutCheckListParms = {
                                checkListId: item.checkListId,
                                instanceId: checkListInstance.id,
                                plantId: item.plantId,
                                tankId: item.tankId,
                                shopId: item.shopId,
                                plantLocationId: item.plantLocationId,
                                readOnly: false,
                                scheduledOn: item.dateHour
                            };
                            var result = fillOutCheckList_controller_1.openFillOutCheckList(fillOutCheckListParms, _this.$modal);
                            _this.loaderService.setAppLoading(true);
                            result
                                .then(function () {
                                if (!_this.generatingReport) {
                                    setTimeout(function () {
                                        _this.loaderService.setAppLoading(true);
                                        _this.checkListsService.resubmitUptimeChecks({ ShopId: item.shopId, Date: item.dateHour })
                                            .then(function () {
                                            setTimeout(function () {
                                                _this.generateReport(false);
                                                _this.loaderService.setAppLoading(false);
                                                _this.addWeightModalOpen = false;
                                            }, 1000);
                                        });
                                    }, 2000);
                                }
                            });
                        }
                    }, _this.notifyService.handleApiErrors);
                    _this.loaderService.loadingPromise(cliGetPromise);
                });
            }
        };
        ;
        FurnacePullReportCtrl.prototype.openAuditModal = function (weightItem) {
            var subject = 'Bottle Weight Audit Details';
            this.uiAuditService.openAuditModal(weightItem, subject);
        };
        FurnacePullReportCtrl.prototype.openAuditCommentsModal = function (weightItem) {
            var message = '';
            var subject = "Audit Comments for Shop: " + weightItem.shop + ", Tank: " + weightItem.tank + ", Weight: " + weightItem.bottleWeight;
            var suffix = '<br>';
            var comments = weightItem.comments ? weightItem.comments.split('|~|') : [];
            _.forEach(comments, function (comment) {
                message += comment + suffix;
            });
            this.uiUtilityService.confirm(message, subject, 'Ok', null, true, true, false);
        };
        FurnacePullReportCtrl.prototype.runFurnacePullReport = function () {
            var _this = this;
            var promise = null;
            this.generatingReport = true;
            switch (this.selectedView.id) {
                case this.viewOptions[0].id:
                case this.viewOptions[2].id:
                    var includeDeleted = (this.selectedView.id === this.viewOptions[2].id);
                    promise = this.reportService.getFurnacePullReportByShop(this.selectedPlant.id, this.startDate, this.endDate, true, includeDeleted);
                    break;
                case this.viewOptions[1].id:
                    promise = this.reportService.getFurnacePullReportByTank(this.selectedPlant.id, this.startDate, this.endDate);
                    break;
                case this.viewOptions[3].id:
                    promise = this.reportService.getFurnacePullReportAbandonedWeights(this.selectedPlant.id, this.startDate, this.endDate);
                    break;
            }
            promise.then(function (report) {
                _this.report = report;
                _this.generatingReport = false;
                _this.searchPerformed = true;
            });
            return promise;
        };
        return FurnacePullReportCtrl;
    }());
    exports.default = angular.module('aps.controller.furnacePullReport', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_2.States.FURNACE_PULL_REPORT,
            url: '/admin/reports/furnacePull?startDate&endDate&reportPlantId&showMissingWeightsOnly&selectedView',
            params: {
                startDate: { dynamic: true },
                endDate: { dynamic: true },
                reportPlantId: { dynamic: true },
                reportShopId: { dynamic: true },
                showMissingWeightsOnly: { dynamic: true },
                selectedView: { dynamic: true }
            },
            controller: 'FurnacePullReportCtrl as vm',
            template: furnacePullReport_tpl_html_1.default,
            data: {
                pageTitle: 'Furnace Pull Report'
            }
        });
    }])
        .controller('FurnacePullReportCtrl', FurnacePullReportCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(7), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, http_service_1, authData_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [http_service_1.default, authData_service_1.default];
    exports.default = angular
        .module('aps.services.wellKnownChecks', requires)
        .service('wellKnownChecksService', ["httpService", "authDataService", function (httpService, authDataService) {
        var saveWellKnownCheckResult = function (weightItem) {
            return httpService
                .post(constant_module_1.Endpoints.WELL_KNOWN_CHECKS_RESULTS + '/' + weightItem.wellKnownCheckResultId, {
                bottleWeight: weightItem.bottleWeight,
                comments: weightItem.comments
            })
                .then(function (data) {
                return data;
            });
        };
        var deleteWellKnownCheckResult = function (weightItem) {
            return httpService
                .delete(constant_module_1.Endpoints.WELL_KNOWN_CHECKS_RESULTS + '/' + weightItem.wellKnownCheckResultId)
                .then(function (data) {
                return data;
            });
        };
        return {
            saveWellKnownCheckResult: saveWellKnownCheckResult,
            deleteWellKnownCheckResult: deleteWellKnownCheckResult,
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(819), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, textInput_tpl_html_1, dateutility_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = ['mm.foundation'];
    var UITextInputDialogCtrl = (function () {
        UITextInputDialogCtrl.$inject = ["$modalInstance", "$rootScope", "data"];
        function UITextInputDialogCtrl($modalInstance, $rootScope, data) {
            var _this = this;
            this.$modalInstance = $modalInstance;
            this.subject = data.subject;
            this.headerText = data.headerText;
            this.placeHolderText = data.placeHolderText;
            this.returnItem = data.returnItem;
            this.broadcastMessages = data.broadcastMessages;
            this.minLength = data.minLength;
            this.maxLength = data.maxLength;
            this.$rootScope = $rootScope;
            this.$modalInstance.result.catch(function (ex) {
                _this.cancel();
            });
        }
        UITextInputDialogCtrl.prototype.broadcastMessage = function (messageTitle, options) {
            this.$rootScope.$emit(messageTitle, options);
        };
        UITextInputDialogCtrl.prototype.save = function () {
            this.$modalInstance.close(false);
            this.broadcastMessage(this.broadcastMessages.submit, { returnItem: this.returnItem, userInput: this.userInput });
        };
        UITextInputDialogCtrl.prototype.cancel = function () {
            this.$modalInstance.close(false);
            this.broadcastMessage(this.broadcastMessages.cancel, { returnItem: this.returnItem });
        };
        UITextInputDialogCtrl.prototype.formatTime = function (time, timeZoneId) {
            return dateutility_service_1.default.formatTime(time, timeZoneId);
        };
        return UITextInputDialogCtrl;
    }());
    var UITextInputSvc = (function () {
        UITextInputSvc.$inject = ["$window", "$modal"];
        function UITextInputSvc($window, $modal) {
            this.$window = $window;
            this.$modal = $modal;
        }
        UITextInputSvc.prototype.openTextInputModal = function (subject, headerText, placeHolderText, returnItem, broadcastMessages, minLength, maxLength) {
            var modalConfirmation = this.$modal.open({
                template: textInput_tpl_html_1.default,
                controller: 'uiTextInputDialogCtrl as vm',
                resolve: {
                    data: function () { return ({
                        subject: subject,
                        headerText: headerText,
                        placeHolderText: placeHolderText,
                        returnItem: returnItem,
                        broadcastMessages: broadcastMessages,
                        minLength: minLength,
                        maxLength: maxLength
                    }); }
                }
            });
            return modalConfirmation.result;
        };
        return UITextInputSvc;
    }());
    exports.default = angular
        .module('ui-text-input', ['mm.foundation'])
        .service('uiTextInputService', UITextInputSvc)
        .controller('uiTextInputDialogCtrl', UITextInputDialogCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <form name=textInputForm novalidate> <h2 class=modal-header>{{vm.headerText}}</h2> <div class=container> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-12 columns float-left\"> <h4> {{vm.subject}} </h4> </div> <div class=\"small-12 columns float-left\"> <input type=text ng-minlength=\"{{vm.minLength}}\" maxlength=\"{{vm.maxLength}}\" placeholder=\"{{vm.placeHolderText}}\" ng-model=vm.userInput ng-required=true> </div> </div> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-12 columns\"> <div class=dialog-footer> <button type=submit class=button ng-disabled=!textInputForm.$valid ng-click=vm.save()>submit</button> <button type=button class=\"button secondary\" ng-click=vm.cancel()>cancel</button> </div> </div> </div> </form> </div>");

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(821), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, auditDialog_tpl_html_1, dateutility_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var UIAuditDialogCtrl = (function () {
        UIAuditDialogCtrl.$inject = ["$modalInstance", "data"];
        function UIAuditDialogCtrl($modalInstance, data) {
            this.modalInstance = $modalInstance;
            this.content = data.content;
            this.comments = (data.content.comments && (data.content.comments.length > 0)) ? data.content.comments.split('|~|') : [];
            this.subject = data.subject;
        }
        UIAuditDialogCtrl.prototype.close = function () {
            this.modalInstance.close(false);
        };
        UIAuditDialogCtrl.prototype.formatTime = function (time, timeZoneId) {
            return dateutility_service_1.default.formatTime(time, timeZoneId);
        };
        return UIAuditDialogCtrl;
    }());
    var UIAuditSvc = (function () {
        UIAuditSvc.$inject = ["$window", "$modal"];
        function UIAuditSvc($window, $modal) {
            this.$window = $window;
            this.$modal = $modal;
        }
        UIAuditSvc.prototype.openAuditModal = function (content, subject) {
            var modalConfirmation = this.$modal.open({
                template: auditDialog_tpl_html_1.default,
                controller: 'uiAuditDialogCtrl as vm',
                resolve: {
                    data: function () { return ({
                        content: content,
                        subject: subject
                    }); }
                }
            });
            return modalConfirmation.result;
        };
        return UIAuditSvc;
    }());
    exports.default = angular
        .module('ui-audit', ['mm.foundation'])
        .service('uiAuditService', UIAuditSvc)
        .controller('uiAuditDialogCtrl', UIAuditDialogCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <form name=vm.form novalidate> <h2 class=modal-header>{{vm.subject}}</h2> <div ng-if=\"!vm.content.createdOn && !vm.content.lastModifiedOn && !vm.content.deletedOn\" class=container> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-9 columns float-left\"> <h3> No Audit Data available for this item. </h3> </div> </div> </div> <div ng-if=\"vm.content.createdOn || vm.content.lastModifiedOn || vm.content.deletedOn\" class=container> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns float-left\"> <label> Date Hour: </label> {{vm.formatTime(vm.content.dateHour, vm.content.timeZone)}} </div> </div> <br> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns float-left\"> <label> Created By: </label> {{vm.content.createdBy ? vm.content.createdBy : 'N/A'}} </div> <div class=\"small-3 columns float-left\"> <label> Created On: </label> {{vm.content.createdOn ? vm.formatTime(vm.content.createdOn, vm.content.timeZone) : 'N/A'}} </div> <div class=\"small-3 columns float-left\"> <label> Last Modified By: </label> {{vm.content.lastModifiedBy ? vm.content.lastModifiedBy : 'N/A'}} </div> <div class=\"small-3 columns float-left\"> <label> Last Modified On: </label> {{vm.content.lastModifiedOn ? vm.formatTime(vm.content.lastModifiedOn, vm.content.timeZone) : 'N/A'}} </div> </div> <br> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns float-left\"> <label> Deleted By: </label> {{vm.content.deletedBy ? vm.content.deletedBy : 'N/A'}} </div> <div class=\"small-3 columns float-left\"> <label> Deleted On: </label> {{vm.content.deletedOn ? vm.formatTime(vm.content.deletedOn, vm.content.timeZone) : 'N/A'}} </div> <div ng-if=\"vm.comments.length > 0\" class=\"small-6 columns float-left\"> <label> Comments: </label> <div ng-repeat=\"comment in vm.comments\"> <p>{{comment}} </p> </div> </div> </div> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-12 columns\"> <div class=dialog-footer> <button type=button class=\"button secondary\" ng-click=vm.close()>close</button> </div> </div> </div> </form> </div>");

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div class=body-header> <h2>Furnace Pull Report</h2> </div> <aps-common-report-query-criteria-row vm=vm></aps-common-report-query-criteria-row> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns float-left\" style=font-size:14px> <label> View <select ng-options=\"item as item.name for item in vm.viewOptions track by item.id\" ng-model=vm.selectedView ng-change=\"vm.saveState(); vm.generateReport();\"> </select> </label> </div> <div class=\"small-6 columns float-left\"> <input type=checkbox ng-if=\"vm.selectedView.id == vm.viewOptions[2].id\" ng-model=vm.showDeletedOnly ng-click=vm.saveState() /><span ng-if=\"vm.selectedView.id == vm.viewOptions[2].id\"> Deleted Only &nbsp;</span> <input type=checkbox ng-if=\"vm.selectedView.id == vm.viewOptions[0].id\" ng-model=vm.showMissingWeightsOnly ng-click=vm.saveState() /><span ng-if=\"vm.selectedView.id == vm.viewOptions[0].id\"> Missing Weights Only</span> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns\"> <button type=submit class=button>Generate Report</button> </div> </div> <div class=row ng-if=\"vm.report.length > 0\" style=\"margin:0 -30px;width:auto\"> <div ng-if=\"vm.selectedView.id == vm.viewOptions[0].id\"> <div style=width:900px> <a ng-csv=vm.exportToCsv() filename=furnacePullReport_TonnageByShop.csv class=right>Save as CSV</a> </div> <table class=\"history-t furnace-pull-report-table cltable\"> <thead> <tr> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-large\">Date Time</th> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-small\">Plant</th> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-small\">Shop</th> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-small\">Tank</th> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-small\">Container Speed</th> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-small\">Shears / Hr</th> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-small\">Up Tng.</th> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-small\">Down Tng.</th> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-small\">Total Tng.</th> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-small\">Weight Target</th> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-medium\">Avg. Bottle Weight</th> </tr> </thead> <tbody> <tr style=\"background:0 0\" ng-repeat=\"item in vm.report\" ng-if=\"(!vm.showMissingWeightsOnly || (vm.showMissingWeightsOnly && item.bottleWeights[0].bottleWeight == 0))\"> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-large\">{{vm.formatTime(item.dateHour, item.timeZone)}}</td> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-small\">{{item.plant}}</td> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-small\">{{item.shop}}</td> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-small\">{{item.tank}}</td> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-small\">{{item.bottlesPerHour.toString()}}</td> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-small\">{{item.shearCutsPerHour.toString()}}</td> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-small\">{{item.uptimeTonnage.toString()}}</td> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-small\">{{item.downtimeTonnage.toString()}}</td> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-small\">{{item.totalTonnage.toString()}}</td> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-small\">{{item.weightTarget.toString()}}</td> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-medium\" ng-if=\"(item.bottleWeights.length > 0 && item.bottleWeights[0].bottleWeight > 0)\" style=vertical-align:top;padding:0> <table style=width:150px> <tr> <td ng-click=\"item.showWeightDetails = !item.showWeightDetails;\"> {{item.averageBottleWeight.toString()}} <i class=\"fa fa-angle-down float-right\" ng-if=item.showWeightDetails></i> <i class=\"fa fa-angle-up float-right\" ng-if=!item.showWeightDetails></i> </td> </tr> <tr> <td ng-if=\"item.bottleWeights.length > 0 && item.bottleWeights[0].bottleWeight > 0 && item.showWeightDetails;\" style=padding:0> <table class=furnace-pull-report-bottle-weights-table> <tr ng-repeat=\"w in item.bottleWeights\"> <td class=furnace-pull-report-bottle-weights-table-item> <div ng-if=!w.editing> <span ng-click=vm.openAuditModal(w)>{{w.bottleWeight}}</span> <i class=\"fa fa-pencil float-right\" ng-click=\"vm.toggleWeightEdit(w, true)\"></i> <i class=\"fa fa-trash float-right\" ng-click=vm.deleteWeight(w) style=padding-right:5px></i> </div> <div ng-if=w.editing class=furnace-pull-report-edit-input> <input type=number ng-model=w.bottleWeightEditValue input-enter-submit=vm.editWeight(w)> <i class=\"fa fa-times-circle float-right furnace-pull-report-edit-x\" ng-click=\"vm.toggleWeightEdit(w, false)\"></i> </div> </td> </tr> </table> </td> </tr> </table> </td> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-medium\" ng-if=\"(item.bottleWeights[0].bottleWeight == 0 || item.bottleWeights.length == 0)\"> <button type=button class=\"button tiny\" style=margin:0 ng-click=vm.openAddWeightModal(item);>Add Weight</button> </td> </tr> </tbody> </table> </div> </div> <div ng-if=\"vm.selectedView.id == vm.viewOptions[1].id && vm.report.length > 0\"> <div style=width:900px> <a ng-csv=vm.exportToCsv() filename=furnacePullReport_TonnageByTank.csv class=right>Save as CSV</a> </div> <table ng-if=\"vm.report.length > 0\" class=\"history-t furnace-pull-report-table cltable\"> <thead> <tr> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-medium\">Date Time</th> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-small\">Plant</th> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-small\">Tank</th> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-medium\">Total Tonnage</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in vm.report\" style=\"background:0 0\"> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-medium border-bottom-1px-black\">{{vm.formatTime(item.timeStamp, item.timeZone)}}</td> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-small border-bottom-1px-black\">{{item.plant}}</td> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-small border-bottom-1px-black\">{{item.tank}}</td> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-medium border-bottom-1px-black\">{{item.value.toString()}}</td> </tr> </tbody> </table> </div> <div ng-if=\"vm.selectedView.id == vm.viewOptions[2].id\"> <div ng-repeat=\"item in vm.report\"> <table class=\"history-t furnace-pull-report-table cltable\"> <thead> <tr ng-if=$first> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-medium\">Date Time</th> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-small\">Sh/Tk/Wght</th> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-medium\">Created By</th> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-medium\">Created On</th> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-medium\">Last Mod. By</th> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-medium\">Last Mod. On</th> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-medium\">Deleted By</th> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-medium\">Deleted On</th> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-small\"></th> </tr> </thead> <tbody> <tr ng-repeat=\"w in item.bottleWeights\" ng-if=\"((!vm.showDeletedOnly) || (vm.showDeletedOnly && w.deletedOn)) && (w.createdOn)\" style=\"background:0 0\"> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-medium border-bottom-1px-black\">{{vm.formatTime(item.dateHour, item.timeZone)}}</td> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-small border-bottom-1px-black\">{{w.shop + '/' + w.tank + '/' + w.bottleWeight}}</td> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-medium border-bottom-1px-black\">{{(w.createdBy) ? w.createdBy : 'N/A'}}</td> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-medium border-bottom-1px-black\">{{(w.createdOn) ? vm.formatTime(w.createdOn, item.timeZone) : 'N/A'}}</td> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-medium border-bottom-1px-black\">{{(w.lastModifiedBy) ? w.lastModifiedBy : 'N/A'}}</td> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-medium border-bottom-1px-black\">{{(w.lastModifiedOn) ? vm.formatTime(w.lastModifiedOn, item.timeZone) : 'N/A'}}</td> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-medium border-bottom-1px-black\">{{(w.deletedBy) ? w.deletedBy : 'N/A'}}</td> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-medium border-bottom-1px-black\">{{(w.deletedOn) ? vm.formatTime(w.deletedOn, item.timeZone) : 'N/A'}}</td> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-small border-bottom-1px-black\"> <button type=button class=\"button tiny\" ng-if=\"w.comments.length > 0\" ng-click=vm.openAuditCommentsModal(w) style=margin:0>comments</button> </td> </tr> </tbody> </table> </div> </div> <div ng-if=\"vm.selectedView.id == vm.viewOptions[3].id && vm.report.length > 0\"> <div ng-repeat=\"item in vm.report\"> <table class=\"history-t furnace-pull-report-table cltable\"> <thead> <tr ng-if=$first> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-medium\">Date Hour</th> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-medium\">Timestamp</th> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-small\">Plant</th> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-small\">Shop</th> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-small\">Gob</th> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-small\">Gob Name</th> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-small\">Weight</th> <th class=\"furnace-pull-report-cell furnace-pull-report-cell-small\">Weight Target</th> </tr> </thead> <tbody> <tr style=\"background:0 0\"> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-medium border-bottom-1px-black\">{{vm.formatTime(item.dateHour, item.timeZone)}}</td> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-medium border-bottom-1px-black\">{{vm.formatTime(item.timeStamp, item.timeZone)}}</td> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-small border-bottom-1px-black\">{{item.plant}}</td> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-small border-bottom-1px-black\">{{item.shop}}</td> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-small border-bottom-1px-black\">{{item.gob}}</td> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-small border-bottom-1px-black\">{{item.gobName}}</td> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-small border-bottom-1px-black\">{{item.weight}}</td> <td class=\"furnace-pull-report-cell furnace-pull-report-cell-small border-bottom-1px-black\">{{item.weightTarget}}</td> </tr> </tbody> </table> </div> </div> </form></div> ");

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(3), __webpack_require__(824), __webpack_require__(4), __webpack_require__(16), __webpack_require__(8), __webpack_require__(34)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, constant_module_1, weeklyKPIsReport_tpl_html_1, loader_service_1, report_service_1, navigation_service_1, Highcharts) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, report_service_1.default, navigation_service_1.default];
    function genericChart() {
        return {
            restrict: 'E',
            template: '<div></div>',
            scope: {
                options: '='
            },
            link: function (scope, element, attributes) {
                angular.element(document).ready(function () {
                    try {
                        var jsonData = JSON.parse(attributes.data);
                        if (attributes.data != null && jsonData.length > 1) {
                            scope.options.series[0].data = jsonData;
                            new Highcharts.Chart(element[0], scope.options);
                        }
                    }
                    catch (e) {
                        return false;
                    }
                    scope.$watch(function () {
                        return element.attr('data');
                    }, function (newValue) {
                        try {
                            var jsonData = JSON.parse(attributes.data);
                            if (newValue != null && jsonData.length > 1) {
                                scope.options.series[0].data = jsonData;
                                new Highcharts.Chart(element[0], scope.options);
                            }
                        }
                        catch (e) {
                            return false;
                        }
                    });
                });
            }
        };
    }
    function getDetailChartConfig() {
        return {
            chart: {
                alignTicks: true,
                zoomType: 'xy',
                height: 20,
                spacing: [0, 0, 0, 0],
                margin: [0, 0, 0, 0],
                events: {
                    load: function () {
                        var chart = this;
                        var xAxisMin = chart.xAxis[0].dataMin, xAxisMax = chart.xAxis[0].dataMax, yAxisMin = chart.yAxis[0].dataMin, yAxisMax = chart.yAxis[0].dataMax;
                        chart.update({
                            xAxis: {
                                min: xAxisMin + 1,
                                max: xAxisMax - 1
                            },
                            yAxis: {
                                min: yAxisMin - 1,
                                max: yAxisMax + 1
                            }
                        });
                    }
                }
            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            title: {
                text: null,
                margin: 0,
                style: {
                    display: 'none'
                }
            },
            subtitle: {
                style: {
                    display: 'none'
                }
            },
            xAxis: {
                categories: ['', '', '', ''],
                labels: {
                    enabled: false
                },
                gridLineWidth: 0,
                visible: false
            },
            yAxis: {
                title: {
                    text: null
                },
                labels: {
                    enabled: false
                },
                allowDecimals: false,
                gridLineWidth: 0,
                visible: false
            },
            plotOptions: {
                series: {
                    states: {
                        hover: {
                            enabled: false
                        }
                    },
                    marker: {
                        enabled: false,
                        states: {
                            hover: {
                                enabled: false
                            }
                        }
                    },
                    animation: false
                }
            },
            tooltip: {
                enabled: false
            },
            series: [{
                    type: 'spline',
                    data: [],
                    color: '#919391',
                    name: ''
                }]
        };
    }
    var WeeklyKPIReportCtrl = (function () {
        WeeklyKPIReportCtrl.$inject = ["$stateParams", "$state", "$q", "navigationService", "reportService", "loaderService"];
        function WeeklyKPIReportCtrl($stateParams, $state, $q, navigationService, reportService, loaderService) {
            var _this = this;
            this.$q = $q;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.loaderService = loaderService;
            this.reportService = reportService;
            this.requirePlantSelection = true;
            this.detailChartConfig = getDetailChartConfig();
            var promise = navigationService.getNavigation().then(function (navModel) {
                _this.plants = navModel.plants();
                _this.selectedPlant = navModel.selectedPlant;
                return _this.loadState($stateParams);
            });
            loaderService.loadingPromise(promise);
        }
        WeeklyKPIReportCtrl.prototype.loadState = function (params) {
            if (params.reportPlantId && params.reportPlantId !== params.plantId) {
                var plant = _.find(this.plants, { id: params.reportPlantId });
                if (plant) {
                    this.selectedPlant = plant;
                }
            }
            return this.$q.when();
        };
        WeeklyKPIReportCtrl.prototype.saveState = function () {
            var reportPlantId = this.selectedPlant ? this.selectedPlant.id : undefined;
            if (reportPlantId === this.$stateParams.plantId) {
                reportPlantId = undefined;
            }
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportPlantId: reportPlantId
            };
            this.$state.transitionTo(constant_module_1.States.WEEKLY_KPI_REPORT, params);
        };
        WeeklyKPIReportCtrl.prototype.generateReport = function () {
            if (this.form.$invalid) {
                return;
            }
            this.saveState();
            this.loaderService.loadingPromise(this.runReport());
        };
        WeeklyKPIReportCtrl.prototype.runReport = function () {
            var _this = this;
            return this.reportService.getWeeklyKpisReport(this.selectedPlant.id)
                .then(function (report) {
                _this.results = report;
                _this.searchPerformed = true;
                _this.weekEndingDates = angular.copy(_this.results.safetyKPI.weeklyItems);
                for (var index = 0; index < 4; index++) {
                    _this.weekEndingDates[index].endDate = moment(_this.weekEndingDates[index].endDate).add(1, 'day').format("MM/DD");
                }
                _this.currentMonth = moment().format("MMMM");
                _this.safetyData = _this.results.safetyKPI;
                _this.tonsMelted = _this.results.tonsMeltedKPI;
                _this.tonsPacked = _this.results.tonsPackedKPI;
                _this.ptm = _this.results.ptmKPI;
                _this.speed = _this.results.speedKPI;
                _this.furnaceUtilization = _this.results.furnaceUtilizationKPI;
                _this.lineHolds = _this.results.lineHoldKPI;
                _this.heldware = _this.results.heldwareKPI;
                _this.citDefects = _this.results.citKPI;
            });
        };
        WeeklyKPIReportCtrl.prototype.getCellColor = function (value, target, defect) {
            if (value == null)
                return 'gray';
            if (defect) {
                switch (value <= target) {
                    case true:
                        return 'green';
                    case false:
                        return 'red';
                }
            }
            else {
                switch (value >= target) {
                    case true:
                        return 'green';
                    case false:
                        return 'red';
                }
            }
        };
        WeeklyKPIReportCtrl.prototype.getChartData = function (items) {
            return items.map(function (x) { return x.value; });
        };
        WeeklyKPIReportCtrl.prototype.updatePlant = function () {
            this.results = null;
        };
        return WeeklyKPIReportCtrl;
    }());
    exports.default = angular.module('aps.controller.weeklyKPIReport', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.WEEKLY_KPI_REPORT,
            url: '/admin/reports/weeklyKPIReport?reportPlantId',
            params: {
                reportPlantId: { dynamic: true }
            },
            controller: 'WeeklyKPIReportCtrl as vm',
            template: weeklyKPIsReport_tpl_html_1.default,
            data: {
                pageTitle: 'Weekly KPIs Report'
            }
        });
    }])
        .controller('WeeklyKPIReportCtrl', WeeklyKPIReportCtrl)
        .directive('detailChart', genericChart)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div class=body-header> <h2>Weekly KPIs Report</h2> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns\"> <label> <span class=\"required notated\" ng-if=vm.requirePlantSelection>*</span>Plant <select ng-model=vm.selectedPlant ng-options=\"plant as plant.name for plant in vm.plants\" ng-change=vm.updatePlant() name=selectedPlant ng-required=vm.requirePlantSelection> <option value=\"\">-- {{vm.requirePlantSelection ? 'Select a Plant' : 'Any Plant' }} --</option> </select> <div ng-messages=commonReportQueryForm.selectedPlant.$error ng-if=\"commonReportQueryForm.selectedPlant.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-12 columns\"> <button type=submit class=button>Generate Report</button> </div> </div> </form> <div class=\"row weeklyKPI\" ng-if=vm.results> <table> <thead> <tr> <th class=rowLabel>KPI</th> <th>Measurement Period</th> <th>Units</th> <th>{{vm.currentMonth}} AOP</th> <th>Weekly Target</th> <th ng-repeat=\"item in vm.weekEndingDates\">Week Ending {{item.endDate | date:'MM/dd'}}</th> <th>% of Target Complete</th> <th class=trendLabel>Trend</th> </tr> </thead> <tbody> <!-- Safety Data --> <tr> <td class=rowLabel>{{vm.safetyData.label}}</td> <td class=helptext>Friday - Thursday</td> <td class=helptext>{{vm.safetyData.unit}}</td> <td class=numberfield>{{vm.safetyData.currentMonthAOP}}</td> <td class=numberfield>{{vm.safetyData.weeklyTarget}}</td> <td class=\"numberfield {{ vm.getCellColor(weekItem.value, vm.safetyData.weeklyTarget, true)}}\" ng-repeat=\"weekItem in vm.safetyData.weeklyItems\">{{weekItem.value}}</td> <td></td> <td> <div class=detail-chart> <detail-chart data=\"{{vm.getChartData(vm.safetyData.weeklyItems)}}\" options=vm.detailChartConfig class=chart></detail-chart> </div> </td> </tr> <!-- Tons Melted --> <tr> <td>{{vm.tonsMelted.label}}</td> <td class=helptext>Friday - Thursday</td> <td class=helptext>{{vm.tonsMelted.unit}}</td> <td class=numberfield>{{vm.tonsMelted.currentMonthAOP}}</td> <td class=numberfield>{{vm.tonsMelted.weeklyTarget}}</td> <td class=\"numberfield {{ vm.getCellColor(weekItem.value, vm.tonsMelted.weeklyTarget, false)}}\" ng-repeat=\"weekItem in vm.tonsMelted.weeklyItems\">{{weekItem.value}}</td> <td class=numberfield>{{vm.tonsMelted.percentTargetComplete | number: 1}}%</td> <td> <div class=detail-chart> <detail-chart data=\"{{vm.getChartData(vm.tonsMelted.weeklyItems)}}\" options=vm.detailChartConfig class=chart></detail-chart> </div> </td> </tr> <!-- Tons Packed --> <tr ng-repeat=\"item in vm.tonsPacked\"> <td ng-class=\"{'rightJustify':item.level ==3}\">{{item.label}}</td> <td class=helptext>Friday - Thursday</td> <td class=helptext>{{item.unit}}</td> <td class=numberfield>{{item.currentMonthAOP}}</td> <td class=numberfield>{{item.weeklyTarget}}</td> <td class=\"numberfield {{ vm.getCellColor(weekItem.value, item.weeklyTarget, false)}}\" ng-repeat=\"weekItem in item.weeklyItems\">{{weekItem.value}}</td> <td class=numberfield>{{item.percentTargetComplete | number: 1}}%</td> <td> <div class=detail-chart> <detail-chart data=\"{{vm.getChartData(item.weeklyItems)}}\" options=vm.detailChartConfig class=chart></detail-chart> </div> </td> </tr> <!-- PTM --> <tr> <td>{{vm.ptm.label}}</td> <td class=helptext>Friday - Thursday</td> <td class=helptext>{{vm.ptm.unit}}</td> <td class=numberfield>{{vm.ptm.currentMonthAOP}}%</td> <td class=numberfield>{{vm.ptm.weeklyTarget}}%</td> <td class=\"numberfield {{ vm.getCellColor(weekItem.value, vm.ptm.weeklyTarget, false)}}\" ng-repeat=\"weekItem in vm.ptm.weeklyItems\">{{weekItem.value}}%</td> <td class=numberfield>{{vm.ptm.percentTargetComplete | number: 1}}%</td> <td> <div class=detail-chart> <detail-chart data=\"{{vm.getChartData(vm.ptm.weeklyItems)}}\" options=vm.detailChartConfig class=chart></detail-chart> </div> </td> </tr> <!-- Speed --> <tr ng-repeat=\"item in vm.speed\"> <td ng-class=\"{'rightJustify':item.level ==3}\">{{item.label}}</td> <td class=helptext>Friday - Thursday</td> <td class=helptext>{{item.unit}}</td> <td class=numberfield>{{item.currentMonthAOP}}</td> <td class=numberfield>{{item.weeklyTarget}}</td> <td class=numberfield ng-repeat=\"weekItem in item.weeklyItems\">{{weekItem.value | number: 1}}</td> <td class=numberfield>{{item.percentTargetComplete | number: 1}}%</td> <td> <div class=detail-chart> <detail-chart data=\"{{vm.getChartData(item.weeklyItems)}}\" options=vm.detailChartConfig class=chart></detail-chart> </div> </td> </tr> <!-- Furnace Utilization --> <tr ng-repeat=\"item in vm.furnaceUtilization\"> <td>{{item.label}}</td> <td class=helptext>Friday - Thursday</td> <td class=helptext>{{item.unit}}</td> <td class=numberfield>{{item.currentMonthAOP}}%</td> <td class=numberfield>{{item.weeklyTarget}}%</td> <td class=\"numberfield {{ vm.getCellColor(weekItem.value, item.weeklyTarget, false)}}\" ng-repeat=\"weekItem in item.weeklyItems\">{{weekItem.value}}%</td> <td class=numberfield>{{item.percentTargetComplete | number: 1}}%</td> <td> <div class=detail-chart> <detail-chart data=\"{{vm.getChartData(item.weeklyItems)}}\" options=vm.detailChartConfig class=chart></detail-chart> </div> </td> </tr> <!-- Line Holds --> <tr> <td>{{vm.lineHolds.label}}</td> <td class=helptext>Friday - Thursday</td> <td class=helptext>{{vm.lineHolds.unit}}</td> <td class=numberfield>{{vm.lineHolds.currentMonthAOP}}</td> <td class=numberfield>{{vm.lineHolds.weeklyTarget}}</td> <td class=numberfield ng-repeat=\"weekItem in vm.lineHolds.weeklyItems\">{{weekItem.value}}%</td> <td></td> <td></td> </tr> <!-- Heldware --> <tr> <td>{{vm.heldware.label}}</td> <td class=helptext>Friday - Thursday</td> <td class=helptext>{{vm.heldware.unit}}</td> <td class=numberfield>{{vm.heldware.currentMonthAOP}}</td> <td class=numberfield>{{vm.heldware.weeklyTarget}}</td> <td class=numberfield ng-repeat=\"weekItem in vm.heldware.weeklyItems\">{{weekItem.value}}</td> <td></td> <td></td> </tr> <!-- CIT defects --> <tr> <td>{{vm.citDefects.label}}</td> <td class=helptext>Friday - Thursday</td> <td class=helptext>{{vm.citDefects.unit}}</td> <td class=numberfield>{{vm.citDefects.currentMonthAOP}}</td> <td class=numberfield>{{vm.citDefects.weeklyTarget}}</td> <td class=\"numberfield {{ vm.getCellColor(weekItem.value, 1, true)}}\" ng-repeat=\"weekItem in vm.citDefects.weeklyItems\">{{weekItem.value}}</td> <td></td> <td> <div class=detail-chart> <detail-chart data=\"{{vm.getChartData(vm.citDefects.weeklyItems)}}\" options=vm.detailChartConfig class=chart></detail-chart> </div> </td> </tr> </tbody> </table> </div> </div>");

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(826), __webpack_require__(827)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, dropAndTimelineGraphs_controller_1, dropAndTimelineGraphs_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.directive.dropAndTimelineGraphs', [dropAndTimelineGraphs_controller_1.default])
        .directive('apsDropAndTimelineGraphs', dropAndTimelineGraphsDef)
        .name;
    function dropAndTimelineGraphsDef() {
        return {
            restrict: 'E',
            template: dropAndTimelineGraphs_tpl_html_1.default,
            replace: true,
            controller: 'DropAndTimelineGraphsCtrl',
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                data: '=',
                description: '=',
                graphColor: '=',
                formatTime: '=',
                timeZoneId: '=',
                reportStartDate: '=',
                reportEndDate: '='
            },
            link: function ($scope) {
                $scope.$watch('vm.data', function (newVal) {
                    $scope.vm.setData(newVal);
                });
            }
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [];
    var DropAndTimelineGraphsCtrl = (function () {
        function DropAndTimelineGraphsCtrl() {
            this.prettyDataArray = [];
            var vm = this;
            this.tooltipWorkaround = {
                getDetailTooltip: function (e) {
                    return vm.getDetailTooltip(e);
                }
            };
        }
        DropAndTimelineGraphsCtrl.prototype.setData = function (data) {
            this.data = data;
            this.prettyDataArray = [];
            if (data) {
                this.prettyDataArray.push({
                    dropPrettyData: this.transformDropDataPretty(data.dropItems),
                    timelinePrettyData: this.transformCavityHistoryDataPretty(data)
                });
            }
        };
        DropAndTimelineGraphsCtrl.prototype.transformDropDataPretty = function (dropResults) {
            return _.map(dropResults, function (dr) {
                return {
                    'Machine Section': dr.machineSection,
                    'Drop Name': dr.dropName,
                    'Count': dr.count,
                    'Section': dr.section,
                    'Gob': dr.gobName,
                    'Gob Number': dr.gob,
                    'OrderBy': (dr.machineNumber * 10000) + (dr.section * 100) + dr.gob
                };
            });
        };
        DropAndTimelineGraphsCtrl.prototype.transformCavityHistoryDataPretty = function (detailResults) {
            var _this = this;
            var cavityItems = _.map(detailResults.timelineItems, function (defect) {
                return {
                    'Machine Section': defect.machineSection,
                    'Drop Name': defect.dropName,
                    'Section': defect.section,
                    'Gob Number': defect.gob,
                    'Time': _this.mapDateToSpecifiedTimeZoneToWorkAroundD3Limitations(defect.time),
                    'isMoldReject': defect.isMoldReject,
                    'Dot Size': defect.isMoldReject ? 15 : 5,
                    'Fixed': 1,
                    'OrderBy': (defect.machineNumber * 1000) + (defect.section * 10) + defect.gob
                };
            });
            _.forEach(detailResults.dropItems, function (di) {
                if (_.find(cavityItems, { 'Drop Name': di.dropName })) {
                    return;
                }
                cavityItems.push({
                    'Machine Section': di.machineSection,
                    'Drop Name': di.dropName,
                    'Section': di.section,
                    'Gob Number': di.gob,
                    'Time': null,
                    'isMoldReject': null,
                    'Dot Size': 0,
                    'Fixed': 1,
                    'OrderBy': (di.machineNumber * 1000) + (di.section * 10) + di.gob
                });
            });
            return cavityItems;
        };
        DropAndTimelineGraphsCtrl.prototype.calculateTimeZoneOffsetDifference = function (date) {
            if (!this.timeZoneId) {
                return 0;
            }
            var currentOffset = moment(date).utcOffset();
            var offsetInTargetTz = moment(date).tz(this.timeZoneId).utcOffset();
            return offsetInTargetTz - currentOffset;
        };
        DropAndTimelineGraphsCtrl.prototype.mapDateToSpecifiedTimeZoneToWorkAroundD3Limitations = function (date) {
            var offsetDifference = this.calculateTimeZoneOffsetDifference(date);
            if (0 === offsetDifference) {
                return date;
            }
            var fakeMomentInTz = moment(date).add(offsetDifference, 'minutes');
            return fakeMomentInTz.toDate();
        };
        DropAndTimelineGraphsCtrl.prototype.mapBackFromSpecifiedTimeZone = function (date) {
            var offsetDifference = this.calculateTimeZoneOffsetDifference(date);
            if (0 === offsetDifference) {
                return date;
            }
            var fakeMomentInTz = moment(date).subtract(offsetDifference, 'minutes');
            return fakeMomentInTz.toDate();
        };
        DropAndTimelineGraphsCtrl.prototype.getDetailTooltip = function (e) {
            if ((e.y.getTime() < this.reportStartDate.getTime())
                || (this.reportEndDate.getTime() < e.y.getTime())) {
                return null;
            }
            var time = this.mapBackFromSpecifiedTimeZone(e.y);
            return ['Gob: ' + e.x,
                'Time: ' + this.formatTime(time)];
        };
        return DropAndTimelineGraphsCtrl;
    }());
    exports.default = angular.module('aps.controller.dropAndTimelineGraphs', requires)
        .controller('DropAndTimelineGraphsCtrl', DropAndTimelineGraphsCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <label>{{ vm.description }} by Cavity</label> <div ng-if=\"prettyData.dropPrettyData && prettyData.dropPrettyData.length\" ng-repeat=\"prettyData in vm.prettyDataArray\"> <div> <dimple-graph data=prettyData.dropPrettyData default-color=\"{{ vm.graphColor }}\" width=100% height=200px> <dimple-x field=\"Machine Section\" type=Category order-by=OrderBy title=null></dimple-x> <dimple-y field=Gob type=Category order-by=\"Gob Number\" title=null></dimple-y> <dimple-scaled-color field=Count></dimple-scaled-color> <dimple-bar field=Section></dimple-bar> </dimple-graph> </div> </div> <label>History of {{ vm.description }} by Cavity</label> <div ng-if=\"prettyData.timelinePrettyData && prettyData.timelinePrettyData.length\" ng-repeat=\"prettyData in vm.prettyDataArray\"> <div> <dimple-graph data=prettyData.timelinePrettyData width=100% height=600px dimple-margin-left=100 default-color=\"{{ vm.graphColor }}\" override-min=vm.reportStartDate override-max=vm.reportEndDate override-tooltip=vm.tooltipWorkaround.getDetailTooltip> <dimple-x field=\"Drop Name\" type=Category order-by=OrderBy order-with-data=true title=null show-gridlines=true></dimple-x> <dimple-y field=Time title=null type=Time format=\"%m/%d %I:%M %p\" show-gridlines=true></dimple-y> <dimple-scatter-plot field=Fixed dot-size-scaler=\"Dot Size\"></dimple-scatter-plot> </dimple-graph> </div> </div> </div>");

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(61), __webpack_require__(3), __webpack_require__(829), __webpack_require__(4), __webpack_require__(16), __webpack_require__(30), __webpack_require__(11), __webpack_require__(54), __webpack_require__(8), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, checkListReportDetails_controller_1, constant_module_1, hourlyChecklistReport_tpl_html_1, loader_service_1, report_service_1, checkLists_service_1, dateutility_service_1, locations_service_1, navigation_service_1, aps_enums_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [checkListReportDetails_controller_1.default, loader_service_1.default, report_service_1.default, checkLists_service_1.default,
        locations_service_1.default, navigation_service_1.default];
    var HourlyChecklistReportCtrl = (function () {
        HourlyChecklistReportCtrl.$inject = ["navigationService", "loaderService", "reportService", "checkListsService", "locationsService", "$state", "$stateParams", "$q", "$timeout", "$modal"];
        function HourlyChecklistReportCtrl(navigationService, loaderService, reportService, checkListsService, locationsService, $state, $stateParams, $q, $timeout, $modal) {
            var _this = this;
            this.loaderService = loaderService;
            this.reportService = reportService;
            this.checkListsService = checkListsService;
            this.$q = $q;
            this.$state = $state;
            this.$modal = $modal;
            this.checkLists = [];
            this.locationsService = locationsService;
            this.reportDate = moment().startOf('day').toDate();
            this.reportEndDate = moment().startOf('day').toDate();
            this.failuresOnly = false;
            this.multipleDays = false;
            this.completedOnly = false;
            this.$stateParams = $stateParams;
            this.$timeout = $timeout;
            var promise = locationsService.initialize().then(function () {
                return navigationService.getNavigation().then(function (nav) {
                    _this.plants = nav.plants();
                    _this.selectedPlant = nav.selectedPlant;
                    _this.updatePlant(true);
                    _this.loadState($stateParams);
                    return _this.loadCheckLists().then(function () {
                        return _this.loadState2($stateParams);
                    });
                });
            });
            loaderService.loadingPromise(promise);
        }
        HourlyChecklistReportCtrl.prototype.getPlantId = function () {
            return this.selectedPlant ? this.selectedPlant.id : null;
        };
        HourlyChecklistReportCtrl.prototype.isFail = function (val) {
            return val && val.status === aps_enums_1.apsEnums.CheckStatus.Failed;
        };
        HourlyChecklistReportCtrl.prototype.isPass = function (val) {
            return val && val.status === aps_enums_1.apsEnums.CheckStatus.Passed;
        };
        HourlyChecklistReportCtrl.prototype.getResult = function (val) {
            if (!val || !val.status || val.status === aps_enums_1.apsEnums.CheckStatus.NotDone) {
                return '';
            }
            if ((val.result || '').length === 0) {
                return 'N/A';
            }
            if (val.result instanceof Date) {
                return dateutility_service_1.default.formatTime(val.result, this.report.plantTimeZoneId);
            }
            return val.result;
        };
        HourlyChecklistReportCtrl.prototype.updatePlant = function (skipChecklists) {
            this.selectedLocation = undefined;
            this.locations = this.locationsService.getPlantLocations(this.selectedPlant);
            if (skipChecklists !== true) {
                this.loadCheckLists(true);
            }
        };
        HourlyChecklistReportCtrl.prototype.formatTime = function (time, timeZoneId) {
            return dateutility_service_1.default.formatTimeOnly(time, timeZoneId);
        };
        HourlyChecklistReportCtrl.prototype.updateLocation = function () {
            this.loadCheckLists(true);
        };
        HourlyChecklistReportCtrl.prototype.updateDate = function () {
            this.loadCheckLists(true);
        };
        HourlyChecklistReportCtrl.prototype.updateEndDate = function () {
            this.loadCheckLists(true);
        };
        HourlyChecklistReportCtrl.prototype.updateMultipleDays = function () {
            this.report = null;
        };
        HourlyChecklistReportCtrl.prototype.loadCheckLists = function (throttle) {
            var _this = this;
            if (this.loadCheckListTimeout) {
                this.$timeout.cancel(this.loadCheckListTimeout);
                this.loadCheckListTimeout = null;
            }
            this.loadCheckListTimeout = this.$timeout(function () {
                var criteria = {
                    plantId: _this.getPlantId(),
                    locationType: undefined,
                    locationId: undefined,
                    startDate: _this.reportDate,
                    endDate: moment(_this.multipleDays ? _this.reportEndDate : _this.reportDate).add(1, 'day').toDate()
                };
                if (_this.selectedLocation) {
                    criteria.locationType = _this.selectedLocation.locationType;
                    criteria.locationId = _this.selectedLocation.id;
                }
                _this.loadCheckListTimeout = null;
                return _this.checkListsService.getCheckListsWithData(criteria)
                    .then(function (data) { return _this.checkLists = data; });
            }, throttle ? 500 : null);
            return this.loadCheckListTimeout;
        };
        HourlyChecklistReportCtrl.prototype.loadState = function (params) {
            if (params.reportPlantId && params.locationId && params.locationId !== params.shopId) {
                var plant = _.find(this.plants, { id: params.reportPlantId });
                if (plant) {
                    var location = _.find(this.locations, { id: params.locationId });
                    if (location) {
                        this.selectedPlant = plant;
                        this.selectedLocation = location;
                    }
                }
            }
            if (!this.selectedLocation) {
                this.selectedLocation = _.find(this.locations, { id: params.shopId });
            }
            if (params.checkListId) {
                this.selectedChecklistId = params.checkListId;
            }
            if (params.reportDate) {
                var reportDate = moment(params.reportDate);
                if (reportDate.isValid()) {
                    this.reportDate = reportDate.toDate();
                }
            }
            if (params.reportEndDate) {
                var reportEndDate = moment(params.reportEndDate);
                if (reportEndDate.isValid()) {
                    this.reportEndDate = reportEndDate.toDate();
                }
            }
            this.failuresOnly = (params.failuresOnly === 'true');
            this.multipleDays = (params.multipleDays === 'true');
            this.completedOnly = (params.completedOnly === 'true');
        };
        HourlyChecklistReportCtrl.prototype.loadState2 = function (params) {
            if (params.autoRun && !this.multipleDays) {
                return this.runCheckListReport();
            }
            return this.$q.when();
        };
        HourlyChecklistReportCtrl.prototype.saveState = function () {
            var locationId = this.selectedLocation ? this.selectedLocation.id : undefined;
            if (locationId === this.$stateParams.shopId) {
                locationId = undefined;
            }
            var reportDate = this.reportDate ? this.reportDate.toISOString() : undefined;
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportPlantId: (locationId && this.selectedPlant) ? this.selectedPlant.id : undefined,
                locationId: locationId,
                reportDate: reportDate,
                multipleDays: this.multipleDays.toString(),
                reportEndDate: (this.multipleDays && this.reportEndDate) ? this.reportEndDate.toISOString() : reportDate,
                checkListId: this.selectedChecklistId,
                failuresOnly: this.failuresOnly.toString(),
                completedOnly: this.completedOnly.toString(),
                autoRun: true
            };
            this.$state.transitionTo(this.$state.current.name, params);
        };
        HourlyChecklistReportCtrl.prototype.generateReport = function () {
            if (this.form && this.form.$invalid) {
                return;
            }
            this.saveState();
            this.loaderService.loadingPromise(this.runCheckListReport());
        };
        HourlyChecklistReportCtrl.prototype.runCheckListReport = function () {
            var _this = this;
            this.report = null;
            var plantId = this.getPlantId();
            var locationType = null;
            var locationId = null;
            if (this.selectedLocation) {
                locationType = this.selectedLocation.locationType;
                locationId = this.selectedLocation.id;
            }
            var checkListId = this.selectedChecklistId;
            return this.reportService
                .getHourlyChecklistReport(plantId, locationType, locationId, checkListId, this.reportDate, this.failuresOnly, this.multipleDays ? this.reportEndDate : this.reportDate, this.completedOnly)
                .then(function (report) {
                _this.report = report;
            });
        };
        HourlyChecklistReportCtrl.prototype.viewDetails = function (val) {
            var _this = this;
            if (val && val.checkListInstanceId) {
                var promise = this.checkListsService
                    .getCheckListReportDetail(val.checkListInstanceId, val.plantLocationId, val.scheduledOn, this.failuresOnly ? aps_enums_1.apsEnums.CheckListReportFilter.FailedOnly : aps_enums_1.apsEnums.CheckListReportFilter.AllCheckLists)
                    .then(function (data) {
                    checkListReportDetails_controller_1.openCheckListReportDetails({
                        checkListInstance: data.reportItem,
                        detail: data
                    }, _this.$modal);
                });
                this.loaderService.loadingPromise(promise);
            }
        };
        HourlyChecklistReportCtrl.prototype.exportToCsv = function () {
            var _this = this;
            var result = [];
            var titles = [];
            var location = [];
            titles.push("Check Name");
            titles.push("Location");
            this.report.columns.forEach(function (x) {
                var time = _this.multipleDays
                    ? dateutility_service_1.default.formatTime(x.scheduledOn, _this.report.plantTimeZoneId)
                    : dateutility_service_1.default.formatTimeOnly(x.scheduledOn, _this.report.plantTimeZoneId);
                titles.push(time);
            });
            result.push(titles);
            var source = _.map(this.report.rows, function (x) {
                return {
                    checkName: x.checkName,
                    machine: x.machine,
                    section: x.section,
                    gobName: x.gobName,
                    dimensionName: x.dimensionName,
                    values: x.values
                };
            });
            source.forEach(function (x) {
                var rowValues = [];
                x.values.forEach(function (k) {
                    rowValues.push(_this.getResult(k));
                });
                result.push({
                    checkName: x.checkName,
                    machine: (x.machine != null ? x.machine + " " : "") + (x.section != null ? x.section + " " : "")
                        + (x.gobName != null ? x.gobName + " " : "") + (x.dimensionName != null ? x.dimensionName + " " : ""),
                    times: rowValues
                });
            });
            return result;
        };
        return HourlyChecklistReportCtrl;
    }());
    exports.default = angular.module('aps.controller.hourlyChecklistReport', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.HOURLY_CHECKLIST_REPORT,
            url: '/admin/reports/hourlyChecklistReport?locationId&reportDate&checkListId&failuresOnly&autoRun&reportPlantId',
            params: {
                locationId: { dynamic: true },
                reportDate: { dynamic: true },
                reportEndDate: { dynamic: true },
                failuresOnly: { dynamic: true },
                completedOnly: { dynamic: true },
                multipleDays: { dynamic: true },
                autoRun: { dynamic: true },
                reportPlantId: { dynamic: true },
                checkListId: { dynamic: true },
            },
            controller: 'HourlyChecklistReportCtrl as vm',
            template: hourlyChecklistReport_tpl_html_1.default,
            data: {
                pageTitle: 'Hourly Check List Report',
                v2Uri: 'aps/reports/check-list-hourly-report'
            }
        });
    }])
        .controller('HourlyChecklistReportCtrl', HourlyChecklistReportCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div class=body-header> <h2>Check List Hourly Report</h2> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>Plant <select ng-model=vm.selectedPlant ng-options=\"plant as plant.name for plant in vm.plants\" ng-change=vm.updatePlant() name=selectedPlant required> </select> <div ng-messages=vm.form.selectedPlant.$error ng-if=\"vm.form.selectedPlant.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-3 columns\"> <label> <span class=\"required notated\" ng-if=vm.requireLocationSelection>*</span>Location <select name=selectedLocation ng-model=vm.selectedLocation ng-options=\"location as location.name for location in vm.locations\" ng-change=vm.updateLocation() required> <option value=\"\">-- Select a Location --</option> </select> <div ng-messages=vm.form.selectedLocation.$error ng-if=\"vm.form.selectedLocation.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>Report <span ng-if=vm.multipleDays>Start </span>Date <input type=date ng-model=vm.reportDate ng-change=vm.updateDate() name=reportDate required/> <div ng-messages=vm.form.reportDate.$error ng-if=\"vm.form.reportDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-3 columns\"> <label ng-if=vm.multipleDays> <span class=\"required notated\">*</span>Report End Date <input type=date ng-model=vm.reportEndDate min=\"{{vm.reportDate}}\" ng-change=vm.updateEndDate() name=reportEndDate required/> <div ng-messages=vm.form.reportEndDate.$error ng-if=\"vm.form.reportEndDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be greater than or equal to the Start Date</div> </div> </label> <label> <input type=checkbox ng-model=vm.multipleDays ng-change=vm.updateMultipleDays() /> Select Date Range </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-5 columns\"> <label> <span class=\"required notated\">*</span>Check List <select ng-model=vm.selectedChecklistId ng-options=\"checkList.id as checkList.name for checkList in vm.checkLists | orderBy: 'name'\" name=selectedChecklist required> <option value=\"\">-- Select a Checklist --</option> </select> <div ng-messages=vm.form.selectedChecklist.$error ng-if=\"vm.form.selectedChecklist.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-2 columns\"> <br/> <br/> <label> <input type=checkbox ng-model=vm.failuresOnly /> Show only failures </label> </div> <div class=\"small-2 columns\"> <br/> <br/> <label> <input type=checkbox ng-model=vm.completedOnly /> Show only completed </label> </div> <div class=\"small-3 columns\"> <br/> <button type=submit class=button>Generate Report</button> </div> </div> </form> <div ng-if=\"vm.report && vm.report.rows && vm.report.rows.length === 0\"> No results found. Please select a different plant, location, date and/or check list. </div> <div style=font-size:larger ng-if=\"vm.report && vm.report.rows && vm.report.rows.length > 0 && vm.multipleDays\"> Date Range Report Ready: <a ng-csv=vm.exportToCsv() filename=HourlyChecklistReport.csv>Save as CSV</a> </div> <div class=col-lg-12 ng-if=\"vm.report && vm.report.rows && vm.report.rows.length > 0 && !vm.multipleDays\"> <a ng-csv=vm.exportToCsv() filename=HourlyChecklistReport.csv class=right>Save as CSV</a> <table class=history-t> <thead> <tr> <th>Check Name</th> <th>Location</th> <th ng-repeat=\"column in vm.report.columns\">{{ vm.formatTime(column.scheduledOn, vm.report.plantTimeZoneId) }}</th> </tr> </thead> <tbody> <tr ng-repeat=\"row in vm.report.rows\"> <td nowrap=nowrap>{{ row.checkName }}</td> <td nowrap=nowrap> <span class=label ng-if=row.machine>{{ row.machine }}</span> <span class=\"warning label\" ng-if=row.section>{{ row.section }}</span> <span class=\"success label\" ng-if=row.gobName>{{ row.gobName }}</span> <span ng-if=row.dimensionName>{{ row.dimensionName }}</span> </td> <td ng-repeat=\"val in row.values track by $index\" ng-click=vm.viewDetails(val); style=cursor:pointer nowrap=nowrap> <span ng-class=\"{ 'checklist-fail': vm.isFail(val), 'checklist-pass': vm.isPass(val) }\"> {{ vm.getResult(val) }} </span> <i class=\"fa fa-comment\" ng-if=val.comment title=\"{{ val.comment }}\"></i> </td> </tr> </tbody> </table> </div> </div>");

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(3), __webpack_require__(831), __webpack_require__(4), __webpack_require__(16), __webpack_require__(7), __webpack_require__(832), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, constant_module_1, morningMinutesReport_tpl_html_1, loader_service_1, report_service_1, authData_service_1, morningMinutesReport_hub_1, navigation_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, report_service_1.default, authData_service_1.default, morningMinutesReport_hub_1.default, navigation_service_1.default];
    var MorningMinutesReportCtrl = (function () {
        MorningMinutesReportCtrl.$inject = ["$state", "$stateParams", "navigationService", "reportService", "loaderService", "authDataService", "morningMinutesReportHubService", "$q"];
        function MorningMinutesReportCtrl($state, $stateParams, navigationService, reportService, loaderService, authDataService, morningMinutesReportHubService, $q) {
            var _this = this;
            var vm = this;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.loaderService = loaderService;
            this.reportService = reportService;
            this.authDataService = authDataService;
            this.morningMinutesReportHubService = morningMinutesReportHubService;
            this.$q = $q;
            this.reportDate = moment().clone().startOf('day').toDate();
            var promise = navigationService.getNavigation().then(function (navModel) {
                _this.plants = navModel.plants();
                _this.selectedPlant = navModel.selectedPlant;
                _this.loadState($stateParams);
            });
            loaderService.loadingPromise(promise);
            this.reportAvailableThisWorkaround = {
                workaround: function (reportAvailable) {
                    vm.reportAvailable(reportAvailable);
                }
            };
        }
        MorningMinutesReportCtrl.prototype.isAdmin = function () {
            return this.selectedPlant
                && this.authDataService.isPlantAdmin(this.selectedPlant.id);
        };
        MorningMinutesReportCtrl.prototype.loadState = function (params) {
            if (params.reportPlantId && params.reportPlantId !== params.plantId) {
                var plant = _.find(this.plants, { id: params.reportPlantId });
                if (plant) {
                    this.selectedPlant = plant;
                }
            }
            if (params.reportDate) {
                var reportDate = moment(params.reportDate);
                if (reportDate.isValid()) {
                    this.reportDate = reportDate.toDate();
                }
            }
        };
        MorningMinutesReportCtrl.prototype.saveState = function () {
            var reportPlantId = this.selectedPlant ? this.selectedPlant.id : undefined;
            if (reportPlantId === this.$stateParams.plantId) {
                reportPlantId = undefined;
            }
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportPlantId: reportPlantId,
                reportDate: this.reportDate ? this.reportDate.toISOString() : undefined
            };
            this.$state.transitionTo(this.$state.current.name, params);
        };
        MorningMinutesReportCtrl.prototype.generateReport = function (regenerate) {
            if (this.form.$invalid) {
                return;
            }
            this.saveState();
            this.loaderService.loadingPromise(this.runReport(regenerate));
        };
        MorningMinutesReportCtrl.prototype.runReport = function (regenerate) {
            var _this = this;
            this.morningMinutesReportHub = this.morningMinutesReportHubService
                .createMorningMinutesReportHub(this.reportAvailableThisWorkaround.workaround, this.selectedPlant.id, this.reportDate, regenerate);
            var loadingPromise = this.morningMinutesReportHub.promise.then(function () {
                return _this.reportService.generateMorningMinutesReport(_this.selectedPlant.id, _this.reportDate, regenerate || false);
            });
            this.reportLoadingPromise = this.$q.defer();
            return this.$q.all([loadingPromise, this.reportLoadingPromise.promise]);
        };
        MorningMinutesReportCtrl.prototype.reportAvailable = function (reportAvailable) {
            var _this = this;
            var resolveLoadingPromise = function () {
                _this.reportService.getMorningMinutesReport(reportAvailable.plantId, reportAvailable.date);
                if (_this.reportLoadingPromise) {
                    _this.reportLoadingPromise.resolve();
                }
            };
            if (this.morningMinutesReportHub) {
                this.morningMinutesReportHub.deregisterListeners();
                this.morningMinutesReportHub.leaveGroup(this.selectedPlant.id).then(function () {
                    resolveLoadingPromise();
                });
            }
            else {
                resolveLoadingPromise();
            }
        };
        return MorningMinutesReportCtrl;
    }());
    exports.default = angular.module('aps.controller.morningMinutesReport', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.MORNING_MINUTES_REPORT,
            url: '/admin/reports/morningMinutes?reportDate&reportPlantId',
            params: {
                reportDate: { dynamic: true },
                reportPlantId: { dynamic: true }
            },
            controller: 'MorningMinutesReportCtrl as vm',
            template: morningMinutesReport_tpl_html_1.default,
            data: {
                pageTitle: 'Morning Minutes Report'
            }
        });
    }])
        .controller('MorningMinutesReportCtrl', MorningMinutesReportCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div class=body-header> <h2>Morning Minutes Report</h2> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-6 columns\"> <label> <span class=\"required notated\">*</span>Plant <select ng-model=vm.selectedPlant ng-options=\"plant as plant.name for plant in vm.plants\" ng-change=vm.updatePlant() name=selectedPlant required> <option value=\"\">-- Select a Plant --</option> </select> <div ng-messages=vm.form.selectedPlant.$error ng-if=\"vm.form.selectedPlant.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-6 columns\"> <label> <span class=\"required notated\">*</span>Report Date <input type=date ng-model=vm.reportDate name=reportDate required/> <div ng-messages=vm.form.reportDate.$error ng-if=\"vm.form.reportDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> </div> <button type=submit class=button ng-if=!vm.isAdmin()>Generate Report</button> <a class=\"button split\" ng-if=vm.isAdmin() ng-click=vm.generateReport()> Generate Report <span dropdown-toggle=#admin-generate-dropdown></span> </a> <ul id=admin-generate-dropdown class=f-dropdown ng-if=vm.isAdmin()> <li> <a ng-click=vm.generateReport(true)>Regenerate Report</a> </li> </ul> </form> </div>");

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(37)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, moment, hub_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.hubs.morningMinutesReports', [hub_service_1.default])
        .service('morningMinutesReportHubService', ["hubService", function (hubService) {
        function createMorningMinutesReportHub(updateResult, plantId, reportDate, requireNewReport) {
            var reportDay = moment(reportDate).startOf('day').toDate().getTime();
            return hubService.createHub('morningMinutes', {
                allowMultipleListeners: true,
                listeners: {
                    morningMinutesAvailable: function (morningMinutesReportInstanceAvailable) {
                        if (morningMinutesReportInstanceAvailable
                            && (morningMinutesReportInstanceAvailable.plantId === plantId)
                            && moment(morningMinutesReportInstanceAvailable.date).startOf('day').toDate().getTime() === reportDay
                            && (!requireNewReport || morningMinutesReportInstanceAvailable.newReportInstance)) {
                            updateResult(morningMinutesReportInstanceAvailable);
                        }
                    }
                },
                methods: ['leaveGroup', 'joinGroup'],
                postConnect: function (hub) {
                    return hub.invokeWithRetry(function () { return hub.joinGroup(plantId); });
                }
            });
        }
        return {
            createMorningMinutesReportHub: createMorningMinutesReportHub
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(834), __webpack_require__(4), __webpack_require__(16), __webpack_require__(7), __webpack_require__(8), __webpack_require__(55), __webpack_require__(6), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, moment, constant_module_1, shiftDetailReport_tpl_html_1, loader_service_1, report_service_1, authData_service_1, navigation_service_1, plant_service_1, notify_service_1, dateutility_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, report_service_1.default, authData_service_1.default,
        navigation_service_1.default, plant_service_1.default, notify_service_1.default];
    var ShiftDetailReportControllerImplementation = (function () {
        ShiftDetailReportControllerImplementation.$inject = ["plantService", "navigationService", "reportService", "loaderService", "authDataService", "notifyService", "$q", "$window"];
        function ShiftDetailReportControllerImplementation(plantService, navigationService, reportService, loaderService, authDataService, notifyService, $q, $window) {
            var _this = this;
            this.loaderService = loaderService;
            this.reportService = reportService;
            this.authDataService = authDataService;
            this.notifyService = notifyService;
            this.$window = $window;
            this.reportDate = moment().clone().startOf('day').toDate();
            var selectedPlantId = null;
            var navPromise = navigationService.getNavigation().then(function (navModel) {
                selectedPlantId = navModel.selectedPlant.id;
            });
            var plantsPromise = plantService.getPlants().then(function (plants) {
                _this.plants = plants;
            });
            var promise = $q.all([navPromise, plantsPromise]).then(function () {
                _this.selectedPlant = _this.plants.filter(function (p) { return p.id === selectedPlantId; })[0];
                _this.updatePlant();
            });
            loaderService.loadingPromise(promise);
        }
        ShiftDetailReportControllerImplementation.prototype.updatePlant = function () {
            this.shifts = this.selectedPlant.shiftSchedules.map(function (s, i) {
                return {
                    id: i + 1,
                    name: s.name
                };
            });
            this.selectedShift = this.shifts[this.shifts.length - 1];
        };
        ShiftDetailReportControllerImplementation.prototype.getReport = function () {
            if (this.form.$invalid) {
                return;
            }
            this.loaderService.loadingPromise(this.runReport());
        };
        ShiftDetailReportControllerImplementation.prototype.shiftChecked = function (shift) {
            if (shift == true) {
                this.selectedShift = this.shifts[this.shifts.length - 1];
            }
        };
        ShiftDetailReportControllerImplementation.prototype.runReport = function () {
            var _this = this;
            var reportDate = dateutility_service_1.default.localToTimeZone(this.reportDate, this.selectedPlant.timeZoneId).toDate();
            return this.reportService.getShiftDetailReport(this.selectedPlant.id, reportDate, this.selectedShift.id, this.allShifts).then(function (html) {
                var newWindow = _this.$window.open();
                newWindow.document.write(html);
            }, function (errors) {
                if (errors.status === 404) {
                    _this.notifyService.error("Report Not Found");
                    return;
                }
                _this.notifyService.handleApiErrors(errors);
            });
        };
        return ShiftDetailReportControllerImplementation;
    }());
    exports.default = angular.module('aps.controller.shiftDetailReport', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.SHIFT_DETAIL_REPORT,
            url: '/admin/reports/shiftDetail',
            controller: 'ShiftDetailReportControllerImplementation as vm',
            template: shiftDetailReport_tpl_html_1.default,
            data: {
                pageTitle: 'Shift Detail Report'
            }
        });
    }])
        .controller('ShiftDetailReportControllerImplementation', ShiftDetailReportControllerImplementation)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <form name=vm.form ng-submit=vm.getReport() novalidate> <div class=body-header> <h2>Shift Detail Report</h2> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>Plant <select ng-model=vm.selectedPlant ng-options=\"plant as plant.name for plant in vm.plants\" ng-change=vm.updatePlant() name=selectedPlant required> <option value=\"\">-- Select a Plant --</option> </select> <div ng-messages=vm.form.selectedPlant.$error ng-if=\"vm.form.selectedPlant.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>Report Date <input type=date ng-model=vm.reportDate name=reportDate required/> <div ng-messages=vm.form.reportDate.$error ng-if=\"vm.form.reportDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>Shift <select ng-model=vm.selectedShift ng-options=\"shift as shift.name for shift in vm.shifts\" name=selectedShift ng-disabled=\"vm.allShifts==true\" required> <option value=\"\">-- Select a Shift --</option> </select> <div ng-messages=vm.form.selectedShift.$error ng-if=\"vm.form.selectedShift.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-3 columns\"> <label> 24 Hour Report <input type=checkbox ng-model=vm.allShifts ng-change=vm.shiftChecked(vm.allShifts) /> </label> </div> </div> <button type=submit class=button>Generate Report</button> </form> </div>");

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(3), __webpack_require__(836), __webpack_require__(4), __webpack_require__(16), __webpack_require__(11), __webpack_require__(8), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, constant_module_1, jobRunReport_tpl_html_1, loader_service_1, report_service_1, dateutility_service_1, navigation_service_1, aps_enums_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, report_service_1.default, navigation_service_1.default];
    var JobRunReportCtrl = (function () {
        JobRunReportCtrl.$inject = ["navigationService", "reportService", "loaderService", "$anchorScroll", "$location", "$q", "$stateParams", "$state"];
        function JobRunReportCtrl(navigationService, reportService, loaderService, $anchorScroll, $location, $q, $stateParams, $state) {
            var _this = this;
            this.groupByArea = function () {
                var groupedResults = {};
                this.detailsResults.downtimeAreas.forEach(function (item) {
                    if (!groupedResults[item.area]) {
                        groupedResults[item.area] = {
                            area: item.area,
                            reasons: [],
                            totalDowntime: 0
                        };
                    }
                    groupedResults[item.area].reasons.push({
                        reason: item.reason,
                        downtimeTotal: item.downtimeTotal
                    });
                    groupedResults[item.area].totalDowntime += item.downtimeTotal;
                });
                this.groupedResults = groupedResults;
            };
            this.loaderService = loaderService;
            this.reportService = reportService;
            this.$anchorScroll = $anchorScroll;
            this.$location = $location;
            this.$state = $state;
            this.$q = $q;
            this.$stateParams = $stateParams;
            this.requirePlantSelection = navigationService.getCurrentRole().roleRequiresPlants;
            var today = moment().startOf('day');
            this.endDate = today.toDate();
            this.startDate = today.clone().subtract(1, 'month').toDate();
            this.molds = [];
            var promise = navigationService.getNavigation().then(function (nav) {
                _this.plants = nav.plants();
                _this.selectedPlant = nav.selectedPlant;
                _this.selectedShop = nav.selectedShop;
                return _this.loadState($stateParams);
            });
            loaderService.loadingPromise(promise);
        }
        JobRunReportCtrl.prototype.loadState = function (params) {
            var _this = this;
            if (params.reportPlantId && params.reportShopId && params.reportShopId !== params.shopId) {
                var plant = _.find(this.plants, { id: params.reportPlantId });
                if (plant) {
                    var shop = _.find(plant.shops, { id: params.reportShopId });
                    if (shop) {
                        this.selectedPlant = plant;
                        this.selectedShop = shop;
                    }
                }
            }
            if (params.moldName) {
                this.selectedMoldName = params.moldName;
            }
            if (params.startDate) {
                var startDate = moment(params.startDate);
                if (startDate.isValid()) {
                    this.startDate = startDate.toDate();
                }
            }
            if (params.endDate) {
                var endDate = moment(params.endDate);
                if (endDate.isValid()) {
                    this.endDate = endDate.toDate();
                }
            }
            if (!params.autoRun) {
                return this.$q.when(true);
            }
            return this.runReport().then(function () {
                if (!params.jobRunId) {
                    return _this.$q.when(true);
                }
                var jobRun = _.find(_this.results, { id: params.jobRunId });
                if (!jobRun) {
                    return _this.$q.when(true);
                }
                _this.selectedJobRun = jobRun;
                return _this.loadJobRunReport(jobRun.id);
            });
        };
        JobRunReportCtrl.prototype.exportToCsv = function () {
            var _this = this;
            return _.orderBy(_.map(this.results, function (x) {
                return {
                    from: _this.formatTime(x.startDate, x.shopPlantTimeZoneId),
                    to: _this.formatTime(x.endDate, x.shopPlantTimeZoneId) || 'Running',
                    days: x.duration.toString(),
                    shop: x.shopName,
                    mold: x.jobMold,
                    finish: x.jobFinish,
                    description: x.jobDescription,
                    sects: x.numberOfSections,
                    gobs: x.numberOfGobs,
                    averagePackPercentage: x.averagePackPercentage
                };
            }), ['to'], ['desc']);
        };
        JobRunReportCtrl.prototype.runReport = function () {
            var _this = this;
            var startDateStart = moment(this.startDate).startOf('day').toDate();
            var endDateEnd = moment(this.endDate).endOf('day').toDate();
            if (this.selectedPlant) {
                startDateStart = dateutility_service_1.default.localToTimeZone(startDateStart, this.selectedPlant.timeZoneId).toDate();
                endDateEnd = dateutility_service_1.default.localToTimeZone(endDateEnd, this.selectedPlant.timeZoneId).toDate();
            }
            var searchCriteria = {
                plantId: this.selectedPlant ? this.selectedPlant.id : null,
                shopId: this.selectedShop ? this.selectedShop.id : null,
                moldName: this.selectedMoldName,
                startDate: startDateStart,
                endDate: endDateEnd
            };
            return this.reportService
                .getJobRunReport(searchCriteria)
                .then(function (reportItems) {
                _this.results = reportItems;
                _this.searchPerformed = true;
            });
        };
        JobRunReportCtrl.prototype.saveState = function () {
            var reportShopId = this.selectedShop ? this.selectedShop.id : undefined;
            if (reportShopId === this.$stateParams.shopId) {
                reportShopId = undefined;
            }
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportPlantId: (reportShopId && this.selectedPlant) ? this.selectedPlant.id : undefined,
                reportShopId: reportShopId,
                moldName: this.selectedMoldName,
                startDate: this.startDate ? this.startDate.toISOString() : undefined,
                endDate: this.endDate ? this.endDate.toISOString() : undefined,
                jobRunId: this.selectedJobRun ? this.selectedJobRun.id : undefined,
                autoRun: true
            };
            this.$state.transitionTo(this.$state.current.name, params);
        };
        JobRunReportCtrl.prototype.generateReport = function () {
            if (this.form.$invalid) {
                return;
            }
            this.saveState();
            this.detailsResults = null;
            this.loaderService.loadingPromise(this.runReport());
        };
        JobRunReportCtrl.prototype.refreshMolds = function () {
            var _this = this;
            var plantId = this.selectedPlant ? this.selectedPlant.id : null;
            var shopId = this.selectedShop ? this.selectedShop.id : null;
            this.molds = [];
            this.moldsLoading = true;
            this.reportService.getJobRunReportMolds(plantId, shopId).then(function (results) {
                _this.molds = results;
                _this.moldsLoading = false;
            });
        };
        JobRunReportCtrl.prototype.loadJobRunReport = function (jobRunId) {
            var _this = this;
            return this.reportService.getJobRunReportDetails(jobRunId)
                .then(function (reportDetails) {
                reportDetails.checkTypes = [
                    { name: 'Line Checks', checks: reportDetails.lineChecks, numDecimals: 1 },
                    { name: 'Gob Checks', checks: reportDetails.gobChecks, numDecimals: 2 }
                ];
                _this.detailsResults = reportDetails;
                _this.groupByArea();
                _this.$location.hash('detailResults');
                _this.$anchorScroll();
            });
        };
        JobRunReportCtrl.prototype.getJobRunReportDetails = function (jobRun) {
            this.selectedJobRun = jobRun;
            this.saveState();
            this.loaderService.loadingPromise(this.loadJobRunReport(jobRun.id));
        };
        JobRunReportCtrl.prototype.formatTime = function (time, timeZoneId) {
            return dateutility_service_1.default.formatTime(time, timeZoneId);
        };
        JobRunReportCtrl.prototype.goToTopDefectsReport = function (defectTypeId) {
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportPlantId: this.$stateParams.shopId !== this.selectedJobRun.shopId
                    ? this.selectedJobRun.shopPlantId : undefined,
                reportShopId: this.$stateParams.shopId !== this.selectedJobRun.shopId
                    ? this.selectedJobRun.shopId : undefined,
                startDate: this.selectedJobRun.startDate.toISOString(),
                endDate: this.selectedJobRun.endDate ? this.selectedJobRun.endDate.toISOString() : undefined,
                defectTypeId: defectTypeId,
                filter: aps_enums_1.apsEnums.TopDefectsFilter.Top10Defects,
                autoRun: true
            };
            this.$state.go(constant_module_1.States.TOP_DEFECTS_REPORT, params);
        };
        JobRunReportCtrl.prototype.goToDowntimeReport = function () {
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportPlantId: this.$stateParams.shopId !== this.selectedJobRun.shopId
                    ? this.selectedJobRun.shopPlantId : undefined,
                reportShopId: this.$stateParams.shopId !== this.selectedJobRun.shopId
                    ? this.selectedJobRun.shopId : undefined,
                startDate: this.selectedJobRun.startDate.toISOString(),
                endDate: this.selectedJobRun.endDate ? this.selectedJobRun.endDate.toISOString() : undefined,
                type: aps_enums_1.apsEnums.DowntimeType.All,
                location: aps_enums_1.apsEnums.DowntimeLocation.All,
                orderBy: aps_enums_1.apsEnums.DowntimeOrder.Time,
                showAll: 'false',
                autoRun: true
            };
            this.$state.go(constant_module_1.States.DOWNTIME_REPORT, params);
        };
        return JobRunReportCtrl;
    }());
    exports.default = angular.module('aps.controller.jobRunReport', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.JOB_RUN_REPORT,
            url: '/admin/reports/jobRun?startDate&endDate&jobRunId&moldName&autoRun&reportPlantId&reportShopId',
            params: {
                startDate: { dynamic: true },
                endDate: { dynamic: true },
                jobRunId: { dynamic: true },
                moldName: { dynamic: true },
                autoRun: { dynamic: true },
                reportPlantId: { dynamic: true },
                reportShopId: { dynamic: true },
            },
            controller: 'JobRunReportCtrl as vm',
            template: jobRunReport_tpl_html_1.default,
            data: {
                pageTitle: 'Production Report'
            }
        });
    }])
        .controller('JobRunReportCtrl', JobRunReportCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div class=body-header> <h2>Job Runs Report</h2> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns\"> <label> <span ng-if=vm.requirePlantSelection class=\"required notated\">*</span>Plant <select ng-model=vm.selectedPlant ng-options=\"plant as plant.name for plant in vm.plants\" name=selectedPlant ng-required=vm.requirePlantSelection ng-change=vm.refreshMolds()> <option value=\"\">-- {{vm.requirePlantSelection ? 'Select a Plant' : 'Any Plant' }} --</option> </select> <div ng-messages=vm.form.selectedPlant.$error ng-if=\"vm.form.selectedPlant.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> <div class=\"small-3 columns\"> <label> Shop <select ng-model=vm.selectedShop ng-options=\"shop as shop.name for shop in vm.selectedPlant.shops\" name=selectedShop ng-change=vm.refreshMolds()> <option value=\"\">-- Any Shop --</option> </select> </label> </div> <div class=\"small-2 columns\"> <label> Mold <input type=text ng-model=vm.selectedMoldName name=selectedMoldName typeahead=\"mold for mold in vm.molds | filter: $viewValue | limitTo: 8\"/> </label> </div> <div class=\"small-2 columns\"> <label> <span class=\"required notated\">*</span>Start Date <input type=date ng-model=vm.startDate name=startDate required/> <div ng-messages=vm.form.startDate.$error ng-if=\"vm.form.startDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> <div class=\"small-2 columns\"> <label> <span class=\"required notated\">*</span>End Date <input type=date ng-model=vm.endDate name=endDate min=\"{{ vm.startDate }}\" required/> <div ng-messages=vm.form.endDate.$error ng-if=\"vm.form.endDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=min class=req-w> <div class=arrow-up></div>Must be greater than or equal to the Start Date </div> </div> </label> </div> </div> <button type=submit class=button>Generate Report</button> </form> <a ng-csv=vm.exportToCsv() ng-if=\"vm.results && vm.results.length\" filename=jobRunReportExport.csv class=right>Save as CSV</a> <table class=history-t ng-if=\"vm.results && vm.results.length\"> <thead> <tr> <th>From</th> <th>To</th> <th>Days</th> <th ng-if=!vm.selectedPlant>Plant</th> <th>Shop</th> <th>Mold</th> <th>Finish</th> <th>Description</th> <th>Sects</th> <th>Gobs</th> <th>Average Pack Percentage</th> </tr> </thead> <tbody> <tr ng-repeat=\"jobRunItem in vm.results | orderBy: '-startDate'\" ng-click=vm.getJobRunReportDetails(jobRunItem) ng-class=\"{ 't-selected' : jobRunItem.id == vm.selectedJobRun.id }\"> <td>{{ vm.formatTime(jobRunItem.startDate, jobRunItem.shopPlantTimeZoneId) }}</td> <td>{{ jobRunItem.endDate ? vm.formatTime(jobRunItem.endDate, jobRunItem.shopPlantTimeZoneId) : 'Running' }} </td> <td>{{jobRunItem.duration}}</td> <td ng-if=!vm.selectedPlant>{{jobRunItem.plantName}}</td> <td>{{jobRunItem.shopName}}</td> <td>{{jobRunItem.jobMold}}</td> <td>{{jobRunItem.jobFinish}}</td> <td>{{jobRunItem.jobDescription}}</td> <td>{{jobRunItem.activeSections}}</td> <td>{{jobRunItem.numberOfGobs}}</td> <td>{{jobRunItem.averagePackPercentage}}</td> </tr> </tbody> </table> <div ng-if=\"(!vm.results || !vm.results.length) && vm.searchPerformed\">No results found</div> <table id=detailResults ng-if=vm.detailsResults width=100% class=plain-table> <tbody> <tr> <td valign=top> <table class=plain-table> <thead> <tr> <th><span class=label style=width:100%>Key Check Results</span></th> </tr> </thead> <tbody> <tr> <td> <table class=history-t ng-repeat=\"checkType in vm.detailsResults.checkTypes\"> <thead> <tr> <th>{{checkType.name}}</th> <th>No. Checks</th> <th>Min</th> <th>Max</th> <th>Avg</th> <th>STDEV</th> </tr> </thead> <tbody> <tr ng-repeat=\"checkSummary in checkType.checks\"> <td>{{checkSummary.checkName}}</td> <td style=text-align:right>{{checkSummary.numChecks}}</td> <td style=text-align:right>{{checkSummary.minCheck | number:checkType.numDecimals }}</td> <td style=text-align:right>{{checkSummary.maxCheck | number:checkType.numDecimals }}</td> <td style=text-align:right>{{checkSummary.avgCheck | number:checkType.numDecimals }}</td> <td style=text-align:right>{{checkSummary.standardDeviation | number:checkType.numDecimals }} </td> </tr> </tbody> </table> </td> </tr> </tbody> </table> </td> <td valign=top rowspan=2> <table class=plain-table> <thead> <tr> <th colspan=2> <span class=label style=width:100% ng-click=vm.goToTopDefectsReport(null)>Defects (click here to view report)</span> </th> </tr> </thead> <tbody> <tr> <td valign=top> <table class=history-t ng-if=\"vm.detailsResults.topTenDefects && vm.detailsResults.topTenDefects.length\"> <thead> <tr> <th>Top 10</th> <th>Instances</th> </tr> </thead> <tbody> <tr ng-repeat=\"defect in vm.detailsResults.topTenDefects\" ng-click=vm.goToTopDefectsReport(defect.defectTypeId)> <td>{{ defect.defectTypeName }} [{{ defect.defectTypeLegacyId }}]</td> <td style=text-align:right>{{ defect.count }}</td> </tr> </tbody> </table> <div ng-if=\"!vm.detailsResults.topTenDefects || !vm.detailsResults.topTenDefects.length\">No Defects </div> </td> <td valign=top> <table class=history-t ng-if=\"vm.detailsResults.criticalDefects && vm.detailsResults.criticalDefects.length\"> <thead> <tr> <th>Critical</th> <th>Time</th> <th>Mld</th> <th>MNR</th> </tr> </thead> <tbody> <tr ng-repeat=\"defect in vm.detailsResults.criticalDefects | orderBy:'-timeFound'\" ng-click=vm.goToTopDefectsReport(defect.defectTypeId)> <td>{{ defect.defectTypeName }} [{{ defect.defectTypeLegacyId }}]</td> <td>{{ vm.formatTime(defect.timeFound, vm.selectedJobRun.shopPlantTimeZoneId) }}</td> <td style=text-align:right>{{ defect.toolNumber }}</td> <td>{{ defect.isMoldRejectInUse }}</td> </tr> </tbody> </table> <div ng-if=\"!vm.detailsResults.criticalDefects || !vm.detailsResults.criticalDefects.length\">No Critical Defects</div> </td> </tr> </tbody> </table> </td> <td valign=top rowspan=2> <table class=plain-table> <thead> <tr> <th> <span class=label style=width:100% ng-click=vm.goToDowntimeReport()>Downtime</span> </th> </tr> </thead> <tbody> <tr> <td> <table class=history-t ng-click=vm.goToDowntimeReport()> <tbody> <tr> <td>Preventative Downtime:</td> <td style=text-align:right>{{vm.detailsResults.totalPreventativeDowntime}} minutes</td> </tr> <tr> <td>Corrective Downtime:</td> <td style=text-align:right>{{vm.detailsResults.totalCorrectiveDowntime}} minutes</td> </tr> <tr> <td>Total Downtime:</td> <td style=text-align:right>{{vm.detailsResults.totalDowntime}} minutes</td> </tr> </tbody> </table> </td> </tr> </tbody> </table> <table class=plain-table> <thead> <tr> <th> <span class=label style=width:100%>Downtime By Area</span> </th> </tr> </thead> <tbody> <tr> <td> <table class=history-t> <thead> <tr> <th>Area</th> <th>Reason</th> <th>Duration</th> </tr> </thead> <tbody> <tr ng-repeat-start=\"result in vm.groupedResults\" ng-style=\"{'background': '#fff'}\"> <td colspan=2><b>{{ result.area }}</b></td> <td><b>{{ result.totalDowntime }}</b></td> </tr> <tr ng-repeat-end ng-repeat=\"reason in result.reasons\" ng-style=\"{'background': '#dedddd'}\"> <td></td> <td> {{ reason.reason }} </td> <td> {{ reason.downtimeTotal }}</td> </tr> </tbody> </table> </td> </tr> </tbody> </table> </td> </tr> <tr ng-if=\"vm.detailsResults.counts.length > 0\"> <td valign=top> <table class=plain-table> <thead> <tr> <th><span class=label style=width:100%>Counts</span></th> </tr> </thead> <tbody> <tr> <td> <table class=history-t> <thead> <tr> <th>Equipment</th> <th>Inspect</th> <th>Reject</th> <th>Reject Rate</th> </tr> </thead> <tbody> <tr ng-repeat-start=\"count in vm.detailsResults.counts\"> <td>{{count.equipmentName}}</td> <td>{{count.inspectCount}}</td> <td style=text-align:right> <span ng-if=count.hasRejects>{{count.rejectCount}}</span> </td> <td style=text-align:right> <span ng-if=count.hasRejects>{{count.rejectRate}}%</span> </td> </tr> <tr ng-repeat-end ng-if=\"count.details.length > 1\" ng-repeat=\"detail in count.details\"> <td>{{count.equipmentName}}-{{detail.lineName}}</td> <td style=text-align:right>{{detail.inspectCount}}</td> <td style=text-align:right> <span ng-if=detail.hasRejects>{{detail.rejectCount}}</span> </td> <td style=text-align:right> <span ng-if=detail.hasRejects>{{detail.rejectRate}}%</span> </td> </tr> </tbody> </table> </td> </tr> </tbody> </table> </td> </tr> </tbody> </table> </div>");

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(3), __webpack_require__(838), __webpack_require__(4), __webpack_require__(16), __webpack_require__(7), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, moment, constant_module_1, productionReport_tpl_html_1, loader_service_1, report_service_1, authData_service_1, navigation_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, report_service_1.default, authData_service_1.default,
        navigation_service_1.default];
    var ProductionReportCtrl = (function () {
        ProductionReportCtrl.$inject = ["$state", "$stateParams", "$location", "navigationService", "reportService", "loaderService", "authDataService", "$q"];
        function ProductionReportCtrl($state, $stateParams, $location, navigationService, reportService, loaderService, authDataService, $q) {
            var _this = this;
            var vm = this;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.$location = $location;
            this.loaderService = loaderService;
            this.reportService = reportService;
            this.authDataService = authDataService;
            this.$q = $q;
            this.reportDate = moment().clone().startOf('day').toDate();
            this.generateReport();
            var promise = navigationService.getNavigation().then(function (navModel) {
                _this.plants = navModel.plants();
                _this.selectedPlant = navModel.selectedPlant;
            });
            loaderService.loadingPromise(promise);
        }
        ProductionReportCtrl.prototype.generateReport = function () {
            var promise = this.runReport();
            this.loaderService.loadingPromise(promise);
            return promise;
        };
        ProductionReportCtrl.prototype.runReport = function () {
            var _this = this;
            var plantId = this.$location.search().plantId;
            var shopId = this.$location.search().shopId;
            var userId = this.$location.search().userId;
            var scheduleOn = this.$location.search().scheduleOn;
            var checklistInstanceId = this.$location.search().checklistInstanceId;
            return this.reportService.getProductionReport(plantId, shopId, userId, scheduleOn, checklistInstanceId).then(function (reportItem) {
                _this.results = reportItem;
            });
        };
        return ProductionReportCtrl;
    }());
    exports.default = angular.module('aps.controller.productionReport', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.PRODUCTION_REPORT,
            url: '/admin/reports/productionReport',
            params: {
                reportDate: { dynamic: true },
                reportPlantId: { dynamic: true }
            },
            controller: 'ProductionReportCtrl as vm',
            template: productionReport_tpl_html_1.default,
            data: {
                pageTitle: 'Production Report'
            }
        });
    }])
        .controller('ProductionReportCtrl', ProductionReportCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <style type=text/css>*{margin:0;padding:0;font-size:100%;line-height:1}table{font-family:Calibri;font-size:x-small}.t-menu{display:none}aside.column-l{display:none}td{padding:0!important}.main-table-w{padding:0!important}.columns-w{border-top:0 solid transparent!important}#scrollableDiv{width:100%;height:100%}.visible-print{display:block;width:auto;height:auto;overflow:visible}</style> <div class=page-splash ng-show=!vm.results> <div class=page-splash-message>loading...</div> <div class=loading> <div><i class=\"fa fa-refresh fa-spin fa-5x\"></i></div> </div> </div> <div id=scrollableDiv class=visible-print> <table cellspacing=0 border=0 ng-show=vm.results> <colgroup width=156></colgroup> <colgroup span=12 width=57></colgroup> <colgroup width=62></colgroup> <colgroup span=3 width=57></colgroup> <tr> <td height=17 align=left> <font face=Arial><br></font> </td> <td align=left> <font face=Arial><br></font> </td> <td align=left> <font face=Arial><br></font> </td> <td align=left> <font face=Arial><br></font> </td> <td align=left> <font face=Arial><br></font> </td> <td align=left> <font face=Arial><br></font> </td> <td align=left> <font face=Arial><br></font> </td> <td align=left> <font face=Arial><br></font> </td> <td align=left> <font face=Arial><br></font> </td> <td align=left> <font face=Arial><br></font> </td> <td align=left> <font face=Arial><br></font> </td> <td align=left> <font face=Arial><br></font> </td> <td align=left> <font face=Arial><br></font> </td> <td align=left> <font face=Arial><br></font> </td> <td align=left> <font face=Arial><br></font> </td> <td align=right sdval=3 sdnum=1033;> <font face=Arial></font> </td> <td align=left> <font face=Arial><br></font> </td> </tr> <tr> <td rowspan=6 height=176 align=left> <font face=Arial><br> <!--<img src=\"/src/app/shared/assets/images/icon.png\" width=150 height=158 hspace=3\r\n            vspace=11> --> </font> </td> <td style=\"border-top:1px solid #000;border-left:1px solid #000\" align=left colspan=9><b> <font face=Arial size=3>Anchor Glass Shift Production Report</font> </b></td> <td style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-left:1px solid #000\" align=left bgcolor=#00CCFF><b> <font face=Arial size=2>Date:</font> </b></td> <td style=\"border-top:1px solid #000;border-bottom:1px solid #000\" colspan=2 align=center> <b> <font face=Arial size=3>{{vm.results.reportDate}}</font> </b></td> <td style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" colspan=4 align=center><b> <font face=Arial size=3>Plantwide Numbers</font> </b></td> </tr> <tr> <td style=\"border-bottom:1px solid #000;border-left:1px solid #000\" align=left colspan=9><b> <font face=Arial size=3>{{vm.results.plantName}}</font> </b></td> <td style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-left:1px solid #000\" align=left bgcolor=#00CCFF><b> <font face=Arial size=1.7>Shift:</font> </b></td> <td style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-right:1px solid #000\" colspan=2 align=center valign=middle><b> <font face=Arial size=1.7>{{vm.results.currentShift}}</font> </b></td> <td style=\"border-bottom:1px solid #000\" align=left><b> <font face=Arial size=1.7>Ware Made:</font> </b></td> <td style=\"border-bottom:1px solid #000\" align=right><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-right:1px solid #000\" colspan=2 align=center sdnum=1033;0;0><b> <font face=Arial size=1.7>{{vm.results.wareMade}}</font> </b></td> </tr> <tr> <td style=\"border-top:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" align=left><b> <font face=Arial>Hr 2</font> </b></td> <td style=\"border-top:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" align=left><b> <font face=Arial>Hr 4</font> </b></td> <td style=\"border-top:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" align=left><b> <font face=Arial>Hr 6</font> </b></td> <td style=\"border-top:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" align=left><b> <font face=Arial>Mrkr</font> </b></td> <td align=left> <font face=Arial size=1.7><br></font> </td> <td colspan=4 rowspan=2 align=left> <font face=Arial size=1.7><br> </font> </td> <td style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-left:1px solid #000\" align=left bgcolor=#00CCFF><b> <font face=Arial size=1.7>Hour:</font> </b></td> <td style=\"border-top:1px solid #000;border-bottom:1px solid #000\" colspan=2 align=center><b> <font face=Arial size=1.7>{{vm.results.shiftHour}}</font> </b></td> <td style=\"border-left:1px solid #000;border-top:1px solid #000;border-bottom:1px solid #000\" align=left><b> <font face=Arial size=1.7>Ware Packed:</font> </b></td> <td style=\"border-top:1px solid #000;border-bottom:1px solid #000\" align=right><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-right:1px solid #000\" colspan=2 align=center><b> <font face=Arial size=1.7>{{vm.results.warePacked}}</font> </b></td> </tr> <tr> <td style=\"border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" align=center><b> <font face=Arial>{{vm.results.twoHourStatus}}</font> </b></td> <td style=\"border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" align=center><b> <font face=Arial>{{vm.results.fourHourStatus}}</font> </b></td> <td style=\"border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" align=center><b> <font face=Arial>{{vm.results.sixHourStatus}}</font> </b></td> <td style=\"border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" align=center><b> <font face=Arial>{{vm.results.eightHourStatus}}</font> </b></td> <td align=left> <font face=Arial size=1.7><br></font> </td> <td style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-left:1px solid #000\" align=left><b> <font face=Arial size=1.7>Crew:</font> </b></td> <td style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-right:1px solid #000\" colspan=2 align=center><b> <font face=Arial size=1.7>{{vm.results.crew}}</font> </b></td> <td style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-left:1px solid #000\" align=left><b> <font face=Arial size=1.7>Lehr Input %:</font> </b></td> <td style=\"border-top:1px solid #000;border-bottom:1px solid #000\" align=right><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-right:1px solid #000\" colspan=2 align=center sdval=98.0979144095341 sdnum=1033;0;0.00><b> <font face=Arial size=1.7>{{vm.results.lehrInPercent | number:2}}</font> </b></td> </tr> <tr> <td style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-left:1px solid #000\" align=left><b> <font face=Arial size=1.7>Shift Leaders:</font> </b></td> <td style=\"border-top:1px solid #000;border-bottom:1px solid #000\" align=left> <font face=Arial size=1.7><br></font> </td> <td style=\"border-top:1px solid #000;border-bottom:1px solid #000\" align=right><b> <font face=Arial size=1.7>HE:</font> </b></td> <td style=\"border-top:1px solid #000;border-bottom:1px solid #000\" colspan=4 align=left><b> <font face=Arial size=1.7>{{vm.results.heLeader}}</font> </b></td> <td style=\"border-top:1px solid #000;border-bottom:1px solid #000\" align=right><b> <font face=Arial size=1.7>CE:</font> </b></td> <td style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-right:1px solid #000\" colspan=4 align=left><b> <font face=Arial size=1.7>{{vm.results.ceLeader}}</font> </b></td> <td style=\"border-top:1px solid #000;border-bottom:1px solid #000\" align=left><b> <font face=Arial size=1.7>Mold Loss %:</font> </b></td> <td style=\"border-top:1px solid #000;border-bottom:1px solid #000\" align=right><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-right:1px solid #000\" colspan=2 align=center sdval=0 sdnum=1033;0;0.00><b> <font face=Arial size=1.7>{{vm.results.moldLossPercent | number:2}}</font> </b></td> </tr> <tr> <td align=left><b> <font face=Arial size=1.7><br></font> </b></td> <td align=left> <font face=Arial size=1.7><br></font> </td> <td align=right><b> <font face=Arial size=1.7><br></font> </b></td> <td align=left> <font face=Arial size=1.7><br></font> </td> <td align=left> <font face=Arial size=1.7><br></font> </td> <td align=left> <font face=Arial size=1.7><br></font> </td> <td align=left> <font face=Arial size=1.7><br></font> </td> <td align=right><b> <font face=Arial size=1.7><br></font> </b></td> <td align=left> <font face=Arial size=1.7><br></font> </td> <td align=left> <font face=Arial size=1.7><br></font> </td> <td align=left> <font face=Arial size=1.7><br></font> </td> <td align=left> <font face=Arial size=1.7><br></font> </td> <td style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-left:1px solid #000\" align=left><b> <font face=Arial size=1.7>Line Average %:</font> </b></td> <td style=\"border-top:1px solid #000;border-bottom:1px solid #000\" align=right><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-right:1px solid #000\" colspan=2 align=center sdval=95.6351570964247 sdnum=1033;0;0.00><b> <font face=Arial size=1.7>{{vm.results.lineAveragePercent | number:2}}</font> </b></td> </tr> <tr> <td style=\"border-bottom:3px double #000\" height=25 align=left> <font face=Arial size=1.7><br></font> </td> <td style=\"border-bottom:3px double #000\" align=left> <font face=Arial size=1.7><br></font> </td> <td style=\"border-bottom:3px double #000\" align=left sdnum=1033;0;0.0%><b> <font face=Arial><br></font> </b></td> <td style=\"border-bottom:3px double #000\" align=left> <font face=Arial size=1.7><br></font> </td> <td style=\"border-bottom:3px double #000\" align=left> <font face=Arial size=1.7><br></font> </td> <td style=\"border-bottom:3px double #000\" align=left> <font face=Arial size=1.7><br></font> </td> <td style=\"border-bottom:3px double #000\" align=left> <font face=Arial size=1.7><br></font> </td> <td style=\"border-bottom:3px double #000\" align=left> <font face=Arial size=1.7><br></font> </td> <td style=\"border-bottom:3px double #000\" align=left> <font face=Arial size=1.7><br></font> </td> <td style=\"border-bottom:3px double #000\" align=left> <font face=Arial size=1.7><br></font> </td> <td style=\"border-bottom:3px double #000\" align=left> <font face=Arial size=1.7><br></font> </td> <td style=\"border-bottom:3px double #000\" align=left> <font face=Arial size=1.7><br></font> </td> <td style=\"border-bottom:3px double #000\" align=left> <font face=Arial size=1.7><br></font> </td> <td style=\"border-bottom:3px double #000\" align=left> <font face=Arial size=1.7><br></font> </td> <td style=\"border-bottom:3px double #000\" align=left> <font face=Arial size=1.7><br></font> </td> <td style=\"border-bottom:3px double #000\" align=left> <font face=Arial size=1.7><br></font> </td> <td style=\"border-top:1px solid #000;border-bottom:3px double #000;border-right:1px solid #000\" align=left> <font face=Arial size=1.7><br></font> </td> </tr> <tr> <td style=\"border-top:3px double #000;border-left:1px solid #000;border-right:1px solid #000\" height=22 align=left><b> <font face=Arial size=1.7>Shop:</font> </b></td> <td ng-repeat=\"shop in vm.results.shopReports\" style=\"border-top:3px double #000;border-left:1px solid #000;border-right:1px solid #000\" colspan=4 align=center><b> <font face=Arial size=1.7>{{shop.shopName}}&nbsp;Shop</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>Job Number:</font> </b></td> <td ng-repeat=\"shop in vm.results.shopReports\" style=\"border-left:1px solid #000;border-right:1px solid #000\" colspan=4 align=center sdnum=\"1033;1033;H:MM AM/PM\"><b> <font face=Arial size=1.7>{{shop.jobNumber}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>Speed (BPM):</font> </b></td> <td ng-repeat=\"shop in vm.results.shopReports\" style=\"border-left:1px solid #000;border-right:1px solid #000\" colspan=4 align=center sdval=472 sdnum=1033;0;0> <span><b> <font face=Arial size=1.7>{{shop.jobSpeed}}</font> </b></span> <span bgcolor=#C0C0C0><a class=comment-indicator></a> <comment>Actual</comment> <b> <font face=Arial size=1.7 color=#333333>{{shop.speed  | number: 2 }}</font> </b> </span> </td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>Count Time:</font> </b></td> <td ng-repeat=\"shop in vm.results.shopReports\" style=\"border-left:1px solid #000;border-right:1px solid #000\" colspan=4 align=center sdval=0.461805555555556 sdnum=\"1033;1033;H:MM AM/PM\"><b> <font face=Arial size=1.7>{{shop.time}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>Shear cuts (Bottles):</font> </b></td> <td ng-repeat=\"shop in vm.results.shopReports\" style=\"border-left:1px solid #000;border-right:1px solid #000\" colspan=4 align=center sdval=113280 sdnum=1033;0;0><b> <font face=Arial size=1.7>{{shop.gobs}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-left:1px solid #000\" align=center bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=center bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=center bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-right:1px solid #000\" align=center bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-left:1px solid #000\" align=center bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=center bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=center bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-right:1px solid #000\" align=center bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-left:1px solid #000\" align=center bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=center bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=center bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-right:1px solid #000\" align=center bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-left:1px solid #000\" align=center bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=center bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=center bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-right:1px solid #000\" align=center bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>Estimated % Pack:</font> </b></td> <td ng-repeat=\"shop in vm.results.shopReports\" style=\"border-left:1px solid #000;border-right:1px solid #000\" colspan=4 align=center sdval=95.9560381355932 sdnum=1033;0;0.00><b> <font face=Arial size=1.7>{{shop.estimatedPercentPack}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>Primary EOL Count:</font> </b></td> <td ng-repeat=\"shop in vm.results.shopReports\" style=\"border-left:1px solid #000;border-right:1px solid #000\" colspan=4 align=center sdval=109010 sdnum=1033;0;0><b> <font face=Arial size=1.7>{{shop.counts}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>Manual EOL Count:</font> </b></td> <td ng-repeat=\"shop in vm.results.shopEOL2s\" style=\"border-left:1px solid #000;border-right:1px solid #000\" colspan=4 align=center sdval=109010 sdnum=1033;0;0><b> <font face=Arial size=1.7>{{shop.value}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-left:1px solid #000\" align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-right:1px solid #000\" align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-left:1px solid #000\" align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-right:1px solid #000\" align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-left:1px solid #000\" align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-right:1px solid #000\" align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-left:1px solid #000\" align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-right:1px solid #000\" align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>Accum % Pack</font> </b></td> <td ng-repeat=\"shop in vm.results.shopReports\" style=\"border-left:1px solid #000;border-right:1px solid #000\" colspan=4 align=center sdval=96.2323446327684 sdnum=1033;0;0.00><b> <font face=Arial size=1.7>{{shop.realPercentPack | number:2}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>2 Hr % Pack:</font> </b></td> <td ng-repeat=\"shop in vm.results.shopTwoHourPercents\" style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" align=center sdval=96.1034604519774 sdnum=1033;0;0.00><b> <font face=Arial>{{shop.value | number:2}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>Manual % Pack</font> </b></td> <td ng-repeat=\"shop in vm.results.shopReports\" style=\"border-left:1px solid #000;border-right:1px solid #000\" colspan=4 align=center sdval=96.2323446327684 sdnum=1033;0;0.00><b> <font face=Arial size=1.7>{{shop.manPercentPack | number:2}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" colspan=4 align=center bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" colspan=4 align=center bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" colspan=4 align=center bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" colspan=4 align=center bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>Lehr Input %:</font> </b></td> <td ng-repeat=\"shop in vm.results.shopReports\" style=\"border-left:1px solid #000;border-right:1px solid #000\" colspan=4 align=center sdval=98.8877118644068 sdnum=1033;0;0.00><b> <font face=Arial size=1.7>{{shop.lehrInputPercent | number:2}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" colspan=4 align=center bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" colspan=4 align=center bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" colspan=4 align=center bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" colspan=4 align=center bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>Lehr Exit:</font> </b></td> <td ng-repeat=\"shop in vm.results.shopReports\" style=\"border-left:1px solid #000;border-right:1px solid #000\" colspan=4 align=center sdval=98.8179731638418 sdnum=1033;0;0.00><b> <font face=Arial size=1.7>{{shop.lehrExitPercent | number:2}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b><u> <font face=Arial size=1.7>Equipment Loss</font> </u></b></td> <td ng-repeat=\"lineName in vm.results.lineNames\" style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" align=center><b> <font face=Arial size=1.7>{{lineName.line}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>Impact Simulator %:</font> </b></td> <td ng-repeat=\"shop in vm.results.shopImpactLosses\" style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" align=center sdval=0.00353107344632768 sdnum=1033;0;0.00><b> <font face=Arial size=1.7>{{shop.value | number:2 }}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>DHG - Dip %:</font> </b></td> <td ng-repeat=\"shop in vm.results.shopDipLosses\" style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" align=center sdval=0.00353107344632768 sdnum=1033;0;0.00><b> <font face=Arial size=1.7>{{shop.value | number:2}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>DHG - Plug %:</font> </b></td> <td ng-repeat=\"shop in vm.results.shopPlugLosses\" style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" align=center sdval=0.00971045197740113 sdnum=1033;0;0.00><b> <font face=Arial size=1.7>{{shop.value | number:2}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>Check Detector %:</font> </b></td> <td ng-repeat=\"shop in vm.results.shopCDLosses\" style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" align=center sdval=0.00353107344632768 sdnum=1033;0;0.00><b> <font face=Arial size=1.7>{{shop.value | number:2}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>Check Detector MNR %:</font> </b></td> <td ng-repeat=\"shop in vm.results.shopMLDLosses\" style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" align=center sdval=0.00353107344632768 sdnum=1033;0;0.00><b> <font face=Arial size=1.7>{{shop.value | number:2}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>AGR / Thinwall %:</font> </b></td> <td ng-repeat=\"shop in vm.results.shopAGRLosses\" style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" align=center sdval=0.00353107344632768 sdnum=1033;0;0.00><b> <font face=Arial size=1.7>{{shop.value | number:2}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>SI Loss %:</font> </b></td> <td ng-repeat=\"shop in vm.results.shopWsiLosses\" style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" colspan=2 align=center sdval=0.590572033898305 sdnum=1033;0;0.00><b> <font face=Arial size=1.7>{{shop.value | number:2}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>SI Detail:</font> </b></td> <td ng-repeat=\"shop in vm.results.shopBlemishLosses\" style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" align=center colspan=2><b> <font face=Arial size=1.7>{{shop.countName}} - {{shop.value}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7><br></font> </b></td> <td ng-repeat=\"shop in vm.results.shopDiameterLosses\" style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" align=center colspan=2><b> <font face=Arial size=1.7>{{shop.countName}} - {{shop.value}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7><br></font> </b></td> <td ng-repeat=\"shop in vm.results.shopLeanLosses\" style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" align=center colspan=2><b> <font face=Arial size=1.7>{{shop.countName}} - {{shop.value}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7><br></font> </b></td> <td ng-repeat=\"shop in vm.results.shopHeightLosses\" style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" align=center colspan=2><b> <font face=Arial size=1.7>{{shop.countName}} - {{shop.value}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7><br></font> </b></td> <td ng-repeat=\"shop in vm.results.shopStressLosses\" style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" align=center colspan=2><b> <font face=Arial size=1.7>{{shop.countName}} - {{shop.value}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>Btm. Scan. Loss %:</font> </b></td> <td ng-repeat=\"shop in vm.results.shopBtmLosses\" style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" colspan=2 align=center sdval=0.00794491525423729 sdnum=1033;0;0.00><b> <font face=Arial size=1.7>{{shop.value | number:2}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>LOF Loss %:</font> </b></td> <td ng-repeat=\"shop in vm.results.shopTopLosses\" style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" colspan=2 align=center sdval=0.0123587570621469 sdnum=1033;0;0.00><b><u> <font face=Arial size=1.7>{{shop.value | number:2}}</font> </u></b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>Equip Loss Total %:</font> </b></td> <td ng-repeat=\"shop in vm.results.shopReports\" style=\"border-left:1px solid #000;border-right:1px solid #000\" colspan=4 align=center sdval=2.86193502824859 sdnum=1033;0;0.00><b> <font face=Arial size=1.7>{{shop.equipLossTotal | number:2}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>Mold Loss %:</font> </b></td> <td ng-repeat=\"shop in vm.results.shopReports\" style=\"border-left:1px solid #000;border-right:1px solid #000\" colspan=4 align=center sdval=0 sdnum=1033;0;0.00><b> <font face=Arial size=1.7>{{shop.moldLossPercentTotal | number:2}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>Total Loss %:</font> </b></td> <td ng-repeat=\"shop in vm.results.shopReports\" style=\"border-left:1px solid #000;border-right:1px solid #000\" colspan=4 align=center sdval=2.86193502824859 sdnum=1033;0;0.00><b> <font face=Arial size=1.7>{{shop.totalLossTotal | number:2}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-left:1px solid #000\" align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-right:1px solid #000\" align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-left:1px solid #000\" align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-right:1px solid #000\" align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-left:1px solid #000\" align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-right:1px solid #000\" align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-left:1px solid #000\" align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-right:1px solid #000\" align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>Defect 1</font> </b></td> <td ng-repeat=\"shop in vm.results.topDefects1\" style=\"border-left:1px solid #000;border-right:1px solid #000\" align=center sdval=22 sdnum=1033; colspan=4><b> <font face=Arial size=1.7>{{shop.defectName}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>Defect 2</font> </b></td> <td ng-repeat=\"shop in vm.results.topDefects2\" style=\"border-left:1px solid #000;border-right:1px solid #000\" align=center sdval=22 sdnum=1033; colspan=4><b> <font face=Arial size=1.7>{{shop.defectName}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>Defect 3</font> </b></td> <td ng-repeat=\"shop in vm.results.topDefects3\" style=\"border-left:1px solid #000;border-right:1px solid #000\" align=center sdval=22 sdnum=1033; colspan=4><b> <font face=Arial size=1.7>{{shop.defectName}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>Defect 4</font> </b></td> <td ng-repeat=\"shop in vm.results.topDefects4\" style=\"border-left:1px solid #000;border-right:1px solid #000\" align=center sdval=22 sdnum=1033; colspan=4><b> <font face=Arial size=1.7>{{shop.defectName}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>Defect 5</font> </b></td> <td ng-repeat=\"shop in vm.results.topDefects5\" style=\"border-left:1px solid #000;border-right:1px solid #000\" align=center sdval=22 sdnum=1033; colspan=4><b> <font face=Arial size=1.7>{{shop.defectName}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" colspan=4 align=center bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" colspan=4 align=center bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" colspan=4 align=center bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" colspan=4 align=center bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> </tr> <tr> <td style=\"border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7># of Spray Alarms:</font> </b></td> <td ng-repeat=\"shop in vm.results.shopSprayers\" style=\"border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" colspan=4 align=center sdval=10 sdnum=1033;><b> <font face=Arial size=1.7>{{shop.value}}</font> </b></td> </tr> <tr> <td style=\"border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7># of Stacker Alarms:</font> </b></td> <td ng-repeat=\"shop in vm.results.shopstackers\" style=\"border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" colspan=4 align=center sdval=4 sdnum=1033;><b> <font face=Arial size=1.7>{{shop.value}}</font> </b></td> </tr> <tr> <td style=\"border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-left:1px solid #000\" align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-right:1px solid #000\" align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-left:1px solid #000\" align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-right:1px solid #000\" align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-left:1px solid #000\" align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-right:1px solid #000\" align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-left:1px solid #000\" align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> <td style=\"border-right:1px solid #000\" align=left bgcolor=#C0C0C0><b> <font face=Arial size=1.7><br></font> </b></td> </tr> <tr> <td style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" height=21 align=left><b> <font face=Arial size=1.7>Comments:</font> </b></td> <td style=\"border-top:1px solid #000;border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" colspan=16 align=center sdval=4 sdnum=1033;><b> <font face=Arial size=1.7>{{vm.results.comments}}</font> </b></td> </tr> </table> </div> </div>");

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(3), __webpack_require__(840), __webpack_require__(5), __webpack_require__(8), __webpack_require__(11), __webpack_require__(16), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, constant_module_1, qualificationsReport_tpl_html_1, aps_enums_1, navigation_service_1, dateutility_service_1, report_service_1, loader_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [navigation_service_1.default, report_service_1.default, loader_service_1.default];
    var QualificationsReportCtrl = (function () {
        QualificationsReportCtrl.$inject = ["$q", "$timeout", "$state", "$stateParams", "navigationService", "reportService", "uiUtilityService", "loaderService"];
        function QualificationsReportCtrl($q, $timeout, $state, $stateParams, navigationService, reportService, uiUtilityService, loaderService) {
            var _this = this;
            this.exportToCsv = function () {
                var _this = this;
                return _.map(this.qualifications, function (x) {
                    return {
                        cavity: x.cavity,
                        category: x.category,
                        startTime: _this.formatTime(x.startTime),
                        endTime: _this.formatTime(x.endTime),
                        duration: x.duration,
                        cause: x.cause
                    };
                });
            };
            this.$q = $q;
            this.$timeout = $timeout;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.navigationService = navigationService;
            this.reportService = reportService;
            this.uiUtilityService = uiUtilityService;
            this.loaderService = loaderService;
            this.requirePlantSelection = true;
            this.requireShopSelection = true;
            var now = moment().add(1, 'hours').startOf('hour');
            this.uiEndDate = now.toDate();
            this.uiStartDate = now.clone().subtract(1, 'days').toDate();
            this.location = aps_enums_1.apsEnums.Location.ColdEnd;
            this.locations = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.Location, 1);
            this.exceptionsOnly = false;
            this.searchPerformed = false;
            this.qualifications = [];
            var promise = navigationService.getNavigation().then(function (navModel) {
                _this.plants = navModel.plants();
                _this.selectedPlant = navModel.selectedPlant;
                _this.updatePlant();
                _this.selectedShop = navModel.selectedShop;
                return _this.loadState($stateParams);
            });
            loaderService.loadingPromise(promise);
        }
        QualificationsReportCtrl.prototype.updatePlant = function () {
            this.selectedShop = null;
        };
        QualificationsReportCtrl.prototype.loadState = function (params) {
            if (params.reportPlantId && params.reportShopId && params.reportShopId !== params.shopId) {
                var plant = _.find(this.plants, { id: params.reportPlantId });
                if (plant) {
                    var shop = _.find(plant.shops, { id: params.reportShopId });
                    if (shop) {
                        this.selectedPlant = plant;
                        this.selectedShop = shop;
                    }
                }
            }
            dateutility_service_1.default.setReportDates(this, params, this.$timeout);
            if (params.location) {
                var location = _.find(this.locations, { value: +params.location });
                if (location) {
                    this.location = location.value;
                }
            }
            if (params.exceptionTime !== undefined) {
                this.exceptionTime = +params.exceptionTime;
            }
            if (params.exceptionsOnly === 'true') {
                this.exceptionsOnly = true;
            }
            if (params.autoRun) {
                return this.runReport();
            }
            return this.$q.when();
        };
        QualificationsReportCtrl.prototype.saveState = function () {
            var reportShopId = this.selectedShop ? this.selectedShop.id : undefined;
            if (reportShopId === this.$stateParams.shopId) {
                reportShopId = undefined;
            }
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportPlantId: (reportShopId && this.selectedPlant) ? this.selectedPlant.id : undefined,
                reportShopId: reportShopId,
                startDate: this.startDate ? this.startDate.toISOString() : undefined,
                endDate: this.endDate ? this.endDate.toISOString() : undefined,
                location: this.location,
                exceptionTime: this.exceptionTime ? this.exceptionTime.toString() : undefined,
                exceptionsOnly: this.exceptionsOnly.toString(),
                autoRun: true
            };
            this.$state.transitionTo(this.$state.current.name, params);
        };
        QualificationsReportCtrl.prototype.generateReport = function () {
            if (this.form.$invalid) {
                return;
            }
            this.saveState();
            var promise = this.runReport();
            this.loaderService.loadingPromise(promise);
            return promise;
        };
        QualificationsReportCtrl.prototype.formatTime = function (time) {
            return dateutility_service_1.default.formatTime(time, this.selectedPlant.timeZoneId);
        };
        QualificationsReportCtrl.prototype.runReport = function () {
            var _this = this;
            return this.reportService.getQualificationsReport(this.selectedShop.id, this.startDate, this.endDate, this.location, this.exceptionTime, this.exceptionsOnly)
                .then(function (qualifications) {
                _this.qualifications = qualifications;
                _this.searchPerformed = true;
            });
        };
        return QualificationsReportCtrl;
    }());
    exports.default = angular.module('aps.controller.qualificationsReport', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.QUALIFICATIONS_REPORT,
            url: '/admin/reports/qualifications?startDate&endDate&location&exceptionTime&exceptionsOnly&autoRun&reportPlantId&reportShopId',
            params: {
                startDate: { dynamic: true },
                endDate: { dynamic: true },
                location: { dynamic: true },
                exceptionTime: { dynamic: true },
                exceptionsOnly: { dynamic: true },
                autoRun: { dynamic: true },
                reportPlantId: { dynamic: true },
                reportShopId: { dynamic: true },
            },
            controller: 'QualificationsReportCtrl as vm',
            template: qualificationsReport_tpl_html_1.default,
            data: {
                pageTitle: 'Qualification Exceptions Report'
            }
        });
    }])
        .controller('QualificationsReportCtrl', QualificationsReportCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div class=body-header> <h2>Qualification Exceptions Report</h2> </div> <aps-common-report-query-criteria-row vm=vm></aps-common-report-query-criteria-row> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>Location <select ng-model=vm.location ng-options=\"x.value as x.text for x in vm.locations | orderBy: 'text'\"> </select> </label> </div> <div class=\"small-3 columns\"> <label> <span class=\"required notated\" ng-if=vm.exceptionsOnly>*</span>Exception Time (min) <input type=number name=exceptionTime ng-model=vm.exceptionTime ng-required=vm.exceptionsOnly /> <div ng-messages=vm.form.exceptionTime.$error ng-if=\"vm.form.exceptionTime.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-3 columns\"> <label> <br/> <input type=checkbox ng-model=vm.exceptionsOnly /> Exceptions Only </label> </div> <div class=\"small-3 columns\"> <button type=submit class=button>Generate Report</button> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\" ng-if=\"vm.searchPerformed && vm.qualifications && vm.qualifications.length\"> <a ng-csv=vm.exportToCsv() filename=qualificationExceptionReportExport.csv class=right>Save as CSV</a> <table class=\"history-t cltable\"> <thead> <tr> <th>Cavity</th> <th>Category</th> <th>Time Start</th> <th>Time End</th> <th>Duration<br/>(minutes)</th> <th>Cause</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in vm.qualifications\"> <td>{{item.cavity}}</td> <td>{{item.category}}</td> <td>{{vm.formatTime(item.startTime)}}</td> <td>{{vm.formatTime(item.endTime)}}</td> <td>{{item.duration}}</td> <td>{{item.cause}}</td> </tr> </tbody> </table> </div> </form> </div>");

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(842), __webpack_require__(3), __webpack_require__(8), __webpack_require__(26), __webpack_require__(28), __webpack_require__(11), __webpack_require__(4), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, rejectRateReport_tpl_html_1, constant_module_1, navigation_service_1, counts_service_1, lineConfigs_service_1, dateutility_service_1, loader_service_1, aps_enums_1) {
    "use strict";
    rejectRateController.$inject = ["$state", "$stateParams", "$q", "navigationService", "countsService", "lineConfigsService", "loaderService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [navigation_service_1.default, counts_service_1.default, lineConfigs_service_1.default, loader_service_1.default];
    exports.default = angular.module('aps.controller.rejectRateReport', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.REJECT_RATE_REPORT,
            url: '/admin/reports/rejectRate?startDate&endDate&equipmentTypeId&autoRun&reportPlantId&reportShopId',
            params: {
                startDate: { dynamic: true },
                endDate: { dynamic: true },
                equipmentTypeId: { dynamic: true },
                autoRun: { dynamic: true },
                reportPlantId: { dynamic: true },
                reportShopId: { dynamic: true },
            },
            controller: 'RejectRateReportCtrl as vm',
            template: rejectRateReport_tpl_html_1.default,
            data: {
                pageTitle: 'Reject Rate Report',
                authorizeAPSIOAdmin: true
            }
        });
    }])
        .controller('RejectRateReportCtrl', rejectRateController)
        .name;
    function rejectRateController($state, $stateParams, $q, navigationService, countsService, lineConfigsService, loaderService) {
        var vm = {};
        var shopsDefer = $q.defer();
        var shopTypes = shopsDefer.promise;
        var shopTypesInitialized = false;
        function initialize() {
            vm.requirePlantSelection = true;
            vm.requireShopSelection = true;
            var now = moment().add(1, 'hours').startOf('hour');
            vm.uiEndDate = now.toDate();
            vm.uiStartDate = now.clone().subtract(1, 'days').toDate();
            var typesPromise = lineConfigsService.getLineEquipmentNames()
                .then(function (types) {
                vm.allTypes = _.sortBy(types
                    .filter(function (t) { return t.type !== aps_enums_1.apsEnums.LineEquipmentType.Counter; }), 'name');
            });
            var navPromise = navigationService.getNavigation()
                .then(function (nav) {
                vm.plants = nav.plants();
                vm.selectedPlant = nav.selectedPlant;
                vm.updatePlant();
                vm.selectedShop = nav.selectedShop;
                return updateShopPromise();
            });
            loaderService.loadingPromise($q.all([typesPromise, navPromise])
                .then(function () { return loadState($stateParams); }));
        }
        function loadState(params) {
            var allowAutoRun = true;
            if (params.reportPlantId && params.reportShopId && params.reportShopId !== params.shopId) {
                var plant = _.find(vm.plants, { id: params.reportPlantId });
                if (plant) {
                    var shop = _.find(plant.shops, { id: params.reportShopId });
                    if (shop && shop !== vm.selectedShop) {
                        vm.selectedPlant = plant;
                        updatePlant();
                        vm.selectedShop = shop;
                        updateShopPromise();
                    }
                }
            }
            if (params.startDate) {
                var startDate = moment(params.startDate);
                if (startDate.isValid()) {
                    vm.startDate = startDate.toDate();
                    vm.uiStartDate = dateutility_service_1.default.timeZoneToLocal(startDate, vm.timeZoneId).toDate();
                }
            }
            if (params.endDate) {
                var endDate = moment(params.endDate);
                if (endDate.isValid()) {
                    vm.endDate = endDate.toDate();
                    vm.uiEndDate = dateutility_service_1.default.timeZoneToLocal(endDate, vm.timeZoneId).toDate();
                }
            }
            if (params.equipmentTypeId) {
                var id_1 = parseInt(params.equipmentTypeId, 10);
                shopTypes.then(function (shopTypes) {
                    vm.equipmentType = _.find(shopTypes, { id: id_1 });
                });
            }
            return shopTypes.then(function () {
                if (!vm.selectedPlant
                    || !vm.selectedShop
                    || !vm.equipmentType) {
                    allowAutoRun = false;
                }
                if (allowAutoRun && params.autoRun) {
                    return runReport();
                }
                return $q.when();
            });
        }
        function saveState() {
            var reportShopId = vm.selectedShop ? vm.selectedShop.id : undefined;
            if (reportShopId === $stateParams.shopId) {
                reportShopId = undefined;
            }
            var params = {
                plantId: $stateParams.plantId,
                shopId: $stateParams.shopId,
                userId: $stateParams.userId,
                reportPlantId: (reportShopId && vm.selectedPlant) ? vm.selectedPlant.id : undefined,
                reportShopId: reportShopId,
                startDate: vm.startDate ? vm.startDate.toISOString() : undefined,
                endDate: vm.endDate ? vm.endDate.toISOString() : undefined,
                equipmentTypeId: vm.equipmentType ? vm.equipmentType.id.toString() : undefined,
                autoRun: true
            };
            $state.transitionTo($state.current.name, params);
        }
        function runReport() {
            vm.group = null;
            vm.dataFound = false;
            var group = {
                types: [vm.equipmentType.type],
                name: vm.equipmentType.name,
                inspectCount: null,
                equipment: null,
                groupUpdated: null,
                rejectCount: null,
                names: [vm.equipmentType.name],
                hasRejects: true,
                lineEquipmentNameIds: [vm.equipmentType.id],
                lineLineEquipmentTabs: null
            };
            return countsService.getGroupRejectCounts(vm.selectedShop.id, group, vm.startDate, vm.endDate).then(function (results) {
                group.rejects = results;
                vm.group = group;
                for (var id in results) {
                    if (results[id].counts.inspectCounts.length > 0) {
                        vm.dataFound = true;
                        break;
                    }
                }
                vm.reportOptions = {
                    shop: vm.selectedShop.name,
                    equipment: vm.equipmentType.name,
                    startDate: formatTime(vm.startDate),
                    endDate: formatTime(vm.endDate)
                };
            });
        }
        function generateReport() {
            if (vm.form.$invalid) {
                return;
            }
            saveState();
            loaderService.loadingPromise(runReport());
        }
        vm.generateReport = generateReport;
        function typeChanged() {
            if (vm.group && (!vm.equipmentType || vm.group.name !== vm.equipmentType.name)) {
                vm.group = null;
            }
        }
        vm.typeChanged = typeChanged;
        function updatePlant() {
            vm.timeZoneId = vm.selectedPlant
                ? vm.selectedPlant.timeZoneId : null;
            vm.selectedShop = null;
        }
        vm.updatePlant = updatePlant;
        function updateShopPromise() {
            var nameIds = [];
            if (shopTypesInitialized) {
                shopsDefer = $q.defer();
                shopTypes = shopsDefer.promise;
            }
            return lineConfigsService.getLineConfiguration(vm.selectedShop.id)
                .then(function (result) {
                result.lines.forEach(function (line) {
                    line.equipment.forEach(function (eq) {
                        nameIds.push(eq.lineEquipmentNameId);
                    });
                });
                var shopNameIds = _.uniq(nameIds);
                vm.types = _.filter(vm.allTypes, function (v) {
                    return shopNameIds.indexOf(v.id) > -1;
                });
                shopTypesInitialized = true;
                shopsDefer.resolve(vm.types);
            }, function (error) {
                shopTypesInitialized = true;
                shopsDefer.reject(error);
            });
        }
        function updateShop() {
            loaderService.loadingPromise(updateShopPromise());
        }
        vm.updateShop = updateShop;
        function formatTime(time) {
            return dateutility_service_1.default.formatTime(time, vm.timeZoneId);
        }
        initialize();
        return vm;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div class=body-header> <h2>Reject Rate Report</h2> </div> <aps-common-report-query-criteria-row vm=vm></aps-common-report-query-criteria-row> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>Equipment Type <select ng-model=vm.equipmentType ng-options=\"type as type.name for type in vm.types\" name=equipmentType ng-change=vm.typeChanged() required> <option value=\"\">-- Select Equipment Type --</option> </select> <div ng-messages=vm.form.equipmentType.$error ng-if=\"vm.form.equipmentType.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-6 columns\"> &nbsp; </div> <div class=\"small-3 columns\"> <button type=submit class=button>Generate Report</button> </div> </div> </form> <div ng-if=\"vm.group && vm.dataFound\"> <label> Reject Rate on Shop {{ vm.reportOptions.shop }} for {{ vm.reportOptions.equipment }} from {{ vm.reportOptions.startDate }} to {{ vm.reportOptions.endDate }} </label> <aps-equipment-group-rejects-graph group=vm.group time-zone-id=vm.timeZoneId style=width:1000px> </aps-equipment-group-rejects-graph> </div> <div ng-if=\"vm.group && !vm.dataFound\"> <label> No Count data was found on Shop {{ vm.reportOptions.shop }} for {{ vm.reportOptions.equipment }} from {{ vm.reportOptions.startDate }} to {{ vm.reportOptions.endDate }} </label> </div> </div>");

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(844), __webpack_require__(3), __webpack_require__(5), __webpack_require__(9), __webpack_require__(4), __webpack_require__(26), __webpack_require__(11), __webpack_require__(23), __webpack_require__(8), __webpack_require__(25)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, shopCountSummaryReport_tpl_html_1, constant_module_1, aps_enums_1, uiUtility_service_1, loader_service_1, counts_service_1, dateutility_service_1, shops_service_1, navigation_service_1, defectType_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [uiUtility_service_1.default, loader_service_1.default, counts_service_1.default, shops_service_1.default, navigation_service_1.default,
        defectType_service_1.default];
    var ShopCountSummaryReportCtrl = (function () {
        ShopCountSummaryReportCtrl.$inject = ["$q", "$timeout", "$state", "$stateParams", "navigationService", "countsService", "loaderService", "uiUtilityService", "defectTypeService", "notifyService"];
        function ShopCountSummaryReportCtrl($q, $timeout, $state, $stateParams, navigationService, countsService, loaderService, uiUtilityService, defectTypeService, notifyService) {
            var vm = this;
            vm.$q = $q;
            this.$timeout = $timeout;
            vm.$state = $state;
            vm.$stateParams = $stateParams;
            vm.loaderService = loaderService;
            vm.countsService = countsService;
            this.notifyService = notifyService;
            vm.requirePlantSelection = true;
            vm.requireShopSelection = true;
            var now = moment().add(1, 'hours').startOf('hour');
            vm.uiEndDate = now.toDate();
            vm.uiStartDate = now.clone().subtract(1, 'days').toDate();
            defectTypeService.getDefectTypesAndClassifications()
                .then(function (defectTypeData) { return vm.defectTypes = defectTypeData.types; });
            vm.orderBys = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.DefectOrder, 1);
            vm.orderBy = aps_enums_1.apsEnums.DefectOrder.Time;
            vm.showDefectComments = false;
            vm.showByShiftOption = true;
            var promise = navigationService.getNavigation().then(function (nav) {
                vm.plants = nav.plants();
                vm.selectedPlant = nav.selectedPlant;
                vm.selectedShop = nav.selectedShop;
                vm.startDate = vm.uiStartDate;
                vm.endDate = vm.uiEndDate;
                return vm.loadState($stateParams);
            });
            loaderService.loadingPromise(promise);
        }
        ShopCountSummaryReportCtrl.prototype.loadState = function (params) {
            if (params.reportPlantId && params.reportShopId && params.reportShopId !== params.shopId) {
                var plant = _.find(this.plants, { id: params.reportPlantId });
                if (plant) {
                    var shop = _.find(plant.shops, { id: params.reportShopId });
                    if (shop) {
                        this.selectedPlant = plant;
                        this.selectedShop = shop;
                    }
                }
            }
            dateutility_service_1.default.setReportDates(this, params, this.$timeout);
            if (params.orderBy !== undefined) {
                var orderBy = _.find(this.orderBys, { value: +params.orderBy });
                if (orderBy) {
                    this.orderBy = orderBy.value;
                }
            }
            if (params.autoRun) {
                var loadPromise = this.generateReport();
                this.loaderService.loadingPromise(loadPromise);
                return loadPromise;
            }
            return this.$q.when();
        };
        ShopCountSummaryReportCtrl.prototype.saveState = function () {
            var reportShopId = this.selectedShop ? this.selectedShop.id : undefined;
            if (reportShopId === this.$stateParams.shopId) {
                reportShopId = undefined;
            }
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportPlantId: (reportShopId && this.selectedPlant) ? this.selectedPlant.id : undefined,
                reportShopId: reportShopId,
                startDate: this.startDate ? this.startDate.toISOString() : undefined,
                endDate: this.endDate ? this.endDate.toISOString() : undefined,
                orderBy: this.orderBy,
                showByShiftOption: true,
                autoRun: !this.byShift
            };
            this.$state.transitionTo(this.$state.current.name, params);
        };
        ShopCountSummaryReportCtrl.prototype.updatePlant = function () {
            this.selectedShop = null;
            this.searchPerformed = false;
        };
        ShopCountSummaryReportCtrl.prototype.setupReport = function () {
            if (this.form.$invalid) {
                return;
            }
            this.saveState();
            this.report = null;
            this.searchPerformed = false;
        };
        ShopCountSummaryReportCtrl.prototype.generateReport = function () {
            this.setupReport();
            var loadPromise = this.runReport();
            this.loaderService.loadingPromise(loadPromise);
            return loadPromise;
        };
        ShopCountSummaryReportCtrl.prototype.runReport = function () {
            var _this = this;
            return this.countsService
                .getShopCountSummary(this.selectedShop.id, this.startDate, this.endDate, false)
                .then(function (summaries) {
                _this.report = _this.createCountSummary(summaries);
                _this.searchPerformed = true;
            }, this.notifyService.handleApiErrors);
        };
        ShopCountSummaryReportCtrl.prototype.createCountSummary = function (summaries) {
            var report = [];
            summaries.forEach(function (item) {
                var reportItem = {
                    date: item.date,
                    shift: item.shift,
                    name: item.name,
                    inspectCount: item.inspectCount,
                    rejectCount: item.rejectCount || 0.0,
                    rejectPercent: item.rejectPercent || 0.0,
                    equipmentCounts: null
                };
                if (item.equipmentCounts) {
                    reportItem.summaryCounts = [];
                    item.equipmentCounts.forEach(function (ecItem) {
                        var ecReportItem = {
                            date: item.date,
                            shift: item.shift,
                            name: ecItem.name.indexOf('-') > -1 ? ecItem.name : ecItem.name + "-" + ecItem.line,
                            inspectCount: ecItem.inspectCount || 0.0,
                            rejectCount: ecItem.rejectCount || 0.0,
                            rejectPercent: ecItem.rejectPercent || 0.0,
                            equipmentCounts: null
                        };
                        reportItem.summaryCounts.push(ecReportItem);
                    });
                }
                report.push(reportItem);
            });
            return report;
        };
        ShopCountSummaryReportCtrl.prototype.formatTime = function (time) {
            return dateutility_service_1.default.formatTime(time, this.reportTimeZoneId);
        };
        ShopCountSummaryReportCtrl.prototype.exportToCsv = function () {
            this.setupReport();
            if (this.byShift) {
                this.reportStartDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate(), 0, 0, 0);
                this.reportEndDate = new Date(this.endDate.getFullYear(), this.endDate.getMonth(), this.endDate.getDate(), 0, 0, 0);
            }
            var titles = [];
            if (this.byShift) {
                titles.push("Date", "Shift");
            }
            titles.push("Equipment", "Inspect", "Reject", "Reject %", "Rej/Ins");
            var result = [];
            result.push(titles);
            var loadPromise = this.getCountSummaryWithDefects(result);
            this.loaderService.loadingPromise(loadPromise);
            return loadPromise;
        };
        ShopCountSummaryReportCtrl.prototype.getCountSummaryWithDefects = function (result) {
            var _this = this;
            return this.countsService
                .getShopCountSummary(this.selectedShop.id, this.startDate, this.endDate, this.byShift)
                .then(function (summaries) {
                _this.searchPerformed = true;
                var exportReport = _this.createCountSummary(summaries);
                exportReport.forEach(function (x) {
                    result.push({
                        date: _this.formatTime(x.date),
                        shift: x.shift,
                        equipment: "\"" + x.name + "\"",
                        inspect: x.inspectCount,
                        reject: x.rejectCount,
                        rejectPercent: x.rejectPercent,
                        division: x.rejectCount / x.inspectCount
                    });
                    if (x.summaryCounts && x.summaryCounts.length > 1) {
                        x.summaryCounts.forEach(function (y) {
                            result.push({
                                date: _this.formatTime(x.date),
                                shift: y.shift,
                                equipment: "\"" + y.name + "\"",
                                inspect: y.inspectCount,
                                reject: y.rejectCount,
                                rejectPercent: y.rejectPercent,
                                division: (y.inspectCount > 0) ? y.rejectCount / y.inspectCount : ""
                            });
                        });
                    }
                });
                _this.createDownload(result);
            }, this.notifyService.handleApiErrors);
        };
        ShopCountSummaryReportCtrl.prototype.createDownload = function (data) {
            var fileName = "ShopCountSummary-" + this.selectedPlant.name + this.selectedShop.name + "-";
            if (this.byShift) {
                fileName += moment(this.reportStartDate).format(constant_module_1.Strings.DATE_FORMAT) + "-" + moment(this.reportEndDate).format(constant_module_1.Strings.DATE_FORMAT);
                fileName += "-ByShift";
            }
            else {
                fileName += moment(this.reportStartDate).format(constant_module_1.Strings.ISO_FORMAT) + "-" + moment(this.reportEndDate).format(constant_module_1.Strings.ISO_FORMAT);
            }
            fileName += ".csv";
            var csv = data[0].join(',') + "\n";
            for (var i = 1; i < data.length; i++) {
                if (this.byShift) {
                    csv += moment(data[i].date).format(constant_module_1.Strings.DATE_FORMAT) + ',' + data[i].shift + ',';
                }
                csv += data[i].equipment + ',' + data[i].inspect + ',' + data[i].reject + ',' + data[i].rejectPercent + ',' + data[i].division + "\n";
            }
            var a = document.createElement("a");
            a.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(csv);
            a.target = '_blank';
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
        };
        return ShopCountSummaryReportCtrl;
    }());
    exports.default = angular.module('aps.controller.shopCountSummaryReport', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.SHOP_COUNT_SUMMARY,
            url: '/admin/reports/shopCountSummary?startDate&endDate&orderBy&autoRun&reportPlantId&reportShopId',
            params: {
                startDate: { dynamic: true },
                endDate: { dynamic: true },
                orderBy: { dynamic: true },
                autoRun: { dynamic: true },
                reportPlantId: { dynamic: true },
                reportShopId: { dynamic: true },
            },
            controller: 'ShopCountSummaryReportCtrl as vm',
            template: shopCountSummaryReport_tpl_html_1.default,
            data: {
                pageTitle: 'Shop Count Summary'
            }
        });
    }])
        .controller('ShopCountSummaryReportCtrl', ShopCountSummaryReportCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <form name=vm.form ng-submit=\"vm.byShift ? vm.exportToCsv() : vm.generateReport()\" novalidate> <div class=body-header> <h2>Shop Count Summary Report</h2> </div> <aps-common-report-query-criteria-row vm=vm></aps-common-report-query-criteria-row> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns\"> <button type=submit class=button>{{vm.byShift ? 'Save as CSV' : 'Generate Report'}}</button> </div> <div class=\"small-9 columns\" style=padding-top:1em> <!-- <button type=\"button\" class=\"button secondary\" ng-click=\"vm.generateReportFromShift(0)\">Current</button>\r\n        <button type=\"button\" class=\"button secondary\" ng-click=\"vm.generateReportFromShift(1)\">Shift -1</button>\r\n        <button type=\"button\" class=\"button secondary\" ng-click=\"vm.generateReportFromShift(2)\">Shift -2</button> --> <p>*Note: This report does not take minute data into account, only the full hour.</p> </div> </div> </form> <div class=\"small-10 columns\" ng-if=\"vm.report && vm.report.length\"> <div class=right ng-if=!vm.byShift> <a href=# ng-click=$event.preventDefault();vm.exportToCsv()>Save as CSV</a> </div> <table class=history-t> <thead> <tr> <th>Equipment</th> <th align=center>Inspect</th> <th align=center>Reject</th> <th align=center>Reject % of HE</th> </tr> </thead> <tbody ng-repeat=\"item in vm.report\" style=\"border-bottom:1px solid #a9a9a9\"> <tr> <td>{{ item.name }}</td> <td width=20% align=right>{{ item.inspectCount | number}}</td> <td width=20% align=right>{{ item.rejectCount | number}}</td> <td width=20% align=right>{{ item.rejectPercent | number: 2 }} %</td> </tr> <tr ng-repeat=\"equipment in item.summaryCounts\" ng-if=\"item.summaryCounts && item.summaryCounts.length > 1\"> <td>{{ equipment.name }}</td> <td align=right>{{ equipment.inspectCount | number}}</td> <td align=right>{{ equipment.rejectCount | number}}</td> <td align=right>{{ equipment.rejectPercent | number: 2  }} %</td> </tr> </tbody> </table> </div> <div ng-if=\"vm.report.length === 0 && vm.searchPerformed\">No counts found.</div> </div>");

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(846), __webpack_require__(3), __webpack_require__(9), __webpack_require__(4), __webpack_require__(16), __webpack_require__(11), __webpack_require__(8), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, toolChangeReport_tpl_html_1, constant_module_1, uiUtility_service_1, loader_service_1, report_service_1, dateutility_service_1, navigation_service_1, aps_enums_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [uiUtility_service_1.default, loader_service_1.default, report_service_1.default, navigation_service_1.default];
    var ToolChangeReportCtrl = (function () {
        ToolChangeReportCtrl.$inject = ["$state", "$q", "$stateParams", "navigationService", "reportService", "loaderService", "uiUtilityService"];
        function ToolChangeReportCtrl($state, $q, $stateParams, navigationService, reportService, loaderService, uiUtilityService) {
            var _this = this;
            var vm = this;
            this.$q = $q;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.loaderService = loaderService;
            this.uiUtilityService = uiUtilityService;
            this.reportService = reportService;
            this.requirePlantSelection = true;
            this.requireShopSelection = true;
            var now = moment().add(1, 'hours').startOf('hour');
            this.uiEndDate = now.toDate();
            this.uiStartDate = now.clone().subtract(1, 'days').toDate();
            this.reasons = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.ToolChangeReason);
            var promise = navigationService.getNavigation().then(function (navModel) {
                _this.plants = navModel.plants();
                _this.selectedPlant = navModel.selectedPlant;
                _this.updatePlant();
                _this.selectedShop = navModel.selectedShop;
                return _this.loadState($stateParams);
            });
            loaderService.loadingPromise(promise);
            this.scopeWorkaround = {
                summaryBarClick: function (dimpleEvent) {
                    if (dimpleEvent && dimpleEvent.xValue) {
                        vm.selectTool(dimpleEvent.xValue);
                    }
                },
                formatTime: function (date) {
                    return vm.formatTime(date);
                }
            };
        }
        ToolChangeReportCtrl.prototype.loadState = function (params) {
            var _this = this;
            if (params.reportPlantId && params.reportShopId && params.reportShopId !== params.shopId) {
                var plant = _.find(this.plants, { id: params.reportPlantId });
                if (plant) {
                    var shop = _.find(plant.shops, { id: params.reportShopId });
                    if (shop) {
                        this.selectedPlant = plant;
                        this.selectedShop = shop;
                    }
                }
            }
            if (params.startDate) {
                var startDate = moment(params.startDate);
                if (startDate.isValid()) {
                    this.startDate = startDate.toDate();
                }
            }
            if (params.endDate) {
                var endDate = moment(params.endDate);
                if (endDate.isValid()) {
                    this.endDate = endDate.toDate();
                }
            }
            if (params.reason !== undefined) {
                var reason = _.find(this.reasons, { value: +params.reason });
                if (reason) {
                    this.selectedReason = reason;
                }
            }
            if (params.autoRun) {
                return this.runReport().then(function () {
                    if (_this.summaryResults && _this.summaryResults.length && params.tool) {
                        return _this.runDetailReport(params.tool);
                    }
                });
            }
            return this.$q.when();
        };
        ToolChangeReportCtrl.prototype.saveState = function (tool) {
            var selectedReasonId = this.selectedReason ? this.selectedReason.value : null;
            var reportShopId = this.selectedShop ? this.selectedShop.id : undefined;
            if (reportShopId === this.$stateParams.shopId) {
                reportShopId = undefined;
            }
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportPlantId: (reportShopId && this.selectedPlant) ? this.selectedPlant.id : undefined,
                reportShopId: reportShopId,
                startDate: this.startDate ? this.startDate.toISOString() : undefined,
                endDate: this.endDate ? this.endDate.toISOString() : undefined,
                reason: selectedReasonId,
                tool: tool,
                autoRun: true
            };
            this.$state.transitionTo(this.$state.current.name, params);
        };
        ToolChangeReportCtrl.prototype.generateReport = function () {
            if (this.form.$invalid) {
                return;
            }
            this.saveState(null);
            var promise = this.runReport();
            this.loaderService.loadingPromise(promise);
            return promise;
        };
        ToolChangeReportCtrl.prototype.runReport = function () {
            var _this = this;
            var selectedReasonId = this.selectedReason ? this.selectedReason.value : null;
            return this.reportService.getToolChangeReport(this.selectedShop.id, selectedReasonId, this.startDate, this.endDate)
                .then(function (summaryResults) {
                _this.summaryResults = summaryResults;
                _this.summaryResultsPretty = _.map(summaryResults, function (result) {
                    return {
                        'Tool Name': result.toolName,
                        'Count': result.count
                    };
                });
                _this.searchPerformed = true;
                _this.reportStartDate = _this.startDate;
                _this.reportEndDate = _this.endDate;
                _this.reportShopName = _this.selectedShop.name;
                _this.reportReason = _this.selectedReason;
                _this.reportTimeZoneId = _this.selectedPlant.timeZoneId;
                _this.detailResults = null;
            });
        };
        ToolChangeReportCtrl.prototype.generateDetailReport = function (toolName) {
            if (this.form.$invalid) {
                return;
            }
            this.saveState(toolName);
            this.loaderService.loadingPromise(this.runDetailReport(toolName));
        };
        ToolChangeReportCtrl.prototype.runDetailReport = function (toolName) {
            var _this = this;
            var reportReasonId = this.reportReason ? this.reportReason.value : null;
            return this.reportService.getToolChangeReportDetails(this.selectedShop.id, reportReasonId, toolName, this.reportStartDate, this.reportEndDate)
                .then(function (detailResults) {
                _this.detailResults = detailResults;
                _this.selectedToolName = toolName;
            });
        };
        ToolChangeReportCtrl.prototype.formatTime = function (time) {
            return dateutility_service_1.default.formatTime(time, this.reportTimeZoneId);
        };
        ToolChangeReportCtrl.prototype.selectTool = function (toolName) {
            this.generateDetailReport(toolName);
        };
        ToolChangeReportCtrl.prototype.getCavityHistoryColor = function () {
            return constant_module_1.Colors.TOOL_CHANGE;
        };
        ToolChangeReportCtrl.prototype.updatePlant = function () {
            this.selectedShop = null;
        };
        return ToolChangeReportCtrl;
    }());
    exports.default = angular.module('aps.controller.toolChangeReport', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.TOOL_CHANGE_REPORT,
            url: '/admin/reports/toolChange?startDate&endDate&reason&tool&autoRun&reportPlantId&reportShopId',
            params: {
                startDate: { dynamic: true },
                endDate: { dynamic: true },
                reason: { dynamic: true },
                tool: { dynamic: true },
                autoRun: { dynamic: true },
                reportPlantId: { dynamic: true },
                reportShopId: { dynamic: true },
            },
            controller: 'ToolChangeReportCtrl as vm',
            template: toolChangeReport_tpl_html_1.default,
            data: {
                pageTitle: 'Tool Change Report'
            }
        });
    }])
        .controller('ToolChangeReportCtrl', ToolChangeReportCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div class=body-header> <h2>Tool Change Report</h2> </div> <aps-common-report-query-criteria-row vm=vm></aps-common-report-query-criteria-row> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns\"> <label> Reason <select ng-model=vm.selectedReason ng-options=\"reason as reason.text for reason in vm.reasons | orderBy: 'text'\"> <option value=\"\">-- Select a Reason --</option> </select> </label> </div> <div class=\"small-9 columns\"> <button type=submit class=button>Generate Report</button> </div> </div> </form> <div ng-if=\"vm.searchPerformed && (!vm.summaryResultsPretty || !vm.summaryResultsPretty.length)\">No Tool Changes found</div> <div ng-if=\"vm.summaryResultsPretty && vm.summaryResultsPretty.length\"> <label>Tool changes <span ng-if=vm.reportReason>for {{ vm.reportReason.text }} </span>on Shop {{ vm.reportShopName }} from {{ vm.formatTime(vm.reportStartDate) }} to {{ vm.formatTime(vm.reportEndDate) }}</label> <div> <dimple-graph data=vm.summaryResultsPretty width=100% height=200px default-color=\"{{ vm.getCavityHistoryColor() }}\" dimple-click=vm.scopeWorkaround.summaryBarClick wrap-x-labels=true> <dimple-x field=\"Tool Name\" order-by-desc=Count title=null font-size=9px></dimple-x> <dimple-y field=Count title=null></dimple-y> <dimple-bar field=\"Tool Name\"></dimple-bar> </dimple-graph> </div> </div> <aps-drop-and-timeline-graphs ng-if=vm.detailResults data=vm.detailResults description=\"vm.selectedToolName + ' changes' + (vm.reportReason ? ' for ' + vm.reportReason.text : '')\" graph-color=vm.getCavityHistoryColor() format-time=vm.scopeWorkaround.formatTime time-zone-id=vm.reportTimeZoneId report-start-date=vm.reportStartDate report-end-date=vm.reportEndDate> </aps-drop-and-timeline-graphs> </div>");

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(848), __webpack_require__(3), __webpack_require__(5), __webpack_require__(9), __webpack_require__(4), __webpack_require__(16), __webpack_require__(11), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, topDefectsReport_tpl_html_1, constant_module_1, aps_enums_1, uiUtility_service_1, loader_service_1, report_service_1, dateutility_service_1, navigation_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [uiUtility_service_1.default, loader_service_1.default, report_service_1.default, navigation_service_1.default];
    var TopDefectsReportCtrl = (function () {
        TopDefectsReportCtrl.$inject = ["navigationService", "reportService", "uiUtilityService", "loaderService", "$anchorScroll", "$location", "$state", "$q", "$stateParams"];
        function TopDefectsReportCtrl(navigationService, reportService, uiUtilityService, loaderService, $anchorScroll, $location, $state, $q, $stateParams) {
            var _this = this;
            this.loaderService = loaderService;
            this.reportService = reportService;
            this.uiUtilityService = uiUtilityService;
            this.$anchorScroll = $anchorScroll;
            this.$location = $location;
            this.$state = $state;
            this.$q = $q;
            this.$stateParams = $stateParams;
            this.requirePlantSelection = true;
            this.requireShopSelection = true;
            var now = moment().add(1, 'hours').startOf('hour');
            this.uiEndDate = now.toDate();
            this.uiStartDate = now.clone().subtract(1, 'days').toDate();
            this.filters = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.TopDefectsFilter, 1);
            this.filter = aps_enums_1.apsEnums.TopDefectsFilter.Top10Defects;
            var promise = navigationService.getNavigation().then(function (nav) {
                _this.plants = nav.plants();
                _this.selectedPlant = nav.selectedPlant;
                _this.updatePlant();
                _this.selectedShop = nav.selectedShop;
                return _this.loadState($stateParams);
            });
            loaderService.loadingPromise(promise);
            this.scopeWorkaround = {
                defectBarClick: function (defect) {
                    _this.generateDetailReport(defect);
                },
                formatTime: function (time) {
                    return _this.formatTime(time);
                }
            };
        }
        TopDefectsReportCtrl.prototype.generateReport = function () {
            if (this.form.$invalid) {
                return;
            }
            this.saveState(undefined);
            var promise = this.runReport();
            this.loaderService.loadingPromise(promise);
            return promise;
        };
        TopDefectsReportCtrl.prototype.runReport = function () {
            var _this = this;
            this.reportShopId = this.selectedShop.id;
            this.reportShopName = this.selectedShop.name;
            this.reportStartDate = this.startDate;
            this.reportEndDate = this.endDate;
            this.reportTimeZoneId = this.selectedPlant.timeZoneId;
            this.reportFilter = this.filter;
            return this.reportService.getTopDefectsReport(this.reportShopId, this.reportStartDate, this.reportEndDate, 10, this.filter === aps_enums_1.apsEnums.TopDefectsFilter.CriticalDefects)
                .then(function (defects) {
                _this.defects = defects;
                _this.searchPerformed = true;
                _this.detailResults = null;
                if (_this.reportFilter === aps_enums_1.apsEnums.TopDefectsFilter.AllDefects) {
                    return _this.runDetailReport(null);
                }
                return _this.$q.when();
            });
        };
        TopDefectsReportCtrl.prototype.formatTime = function (time) {
            return dateutility_service_1.default.formatTime(time, this.reportTimeZoneId);
        };
        TopDefectsReportCtrl.prototype.updatePlant = function () {
            this.selectedShop = null;
        };
        TopDefectsReportCtrl.prototype.generateDetailReport = function (defect) {
            var defectTypeId = defect ? defect.defectTypeId : '';
            this.saveState(defectTypeId);
            var promise = this.runDetailReport(defect);
            this.loaderService.loadingPromise(promise);
            return promise;
        };
        TopDefectsReportCtrl.prototype.runDetailReport = function (defect) {
            var _this = this;
            this.reportDefect = defect;
            var defectTypeId = defect ? defect.defectTypeId : '';
            return this.reportService.getDefectReportDetails(this.reportShopId, defectTypeId, this.reportStartDate, this.reportEndDate).then(function (defectDetails) {
                _this.detailResults = defectDetails;
            });
        };
        TopDefectsReportCtrl.prototype.getDefectDetailsColor = function () {
            return this.uiUtilityService.getSeverityColor(this.reportDefect ? this.reportDefect.severity : 0);
        };
        TopDefectsReportCtrl.prototype.loadState = function (params) {
            var _this = this;
            if (params.reportPlantId && params.reportShopId && params.reportShopId !== params.shopId) {
                var plant = _.find(this.plants, { id: params.reportPlantId });
                if (plant) {
                    var shop = _.find(plant.shops, { id: params.reportShopId });
                    if (shop) {
                        this.selectedPlant = plant;
                        this.selectedShop = shop;
                    }
                }
            }
            if (params.startDate) {
                var startDate = moment(params.startDate);
                if (startDate.isValid()) {
                    this.uiStartDate = this.startDate = startDate.toDate();
                }
            }
            if (params.endDate) {
                var endDate = moment(params.endDate);
                if (endDate.isValid()) {
                    this.uiEndDate = this.endDate = endDate.toDate();
                }
            }
            if (params.filter !== undefined) {
                var filter = _.find(this.filters, { value: +params.filter });
                if (filter) {
                    this.filter = filter.value;
                }
            }
            if (params.autoRun) {
                return this.runReport().then(function () {
                    var targetDefect = _.find(_this.defects, { defectTypeId: params.defectTypeId });
                    if (targetDefect) {
                        return _this.runDetailReport(targetDefect).then(function () {
                            _this.$location.hash('detailResultsMarker');
                            _this.$anchorScroll();
                        });
                    }
                });
            }
            return this.$q.when();
        };
        TopDefectsReportCtrl.prototype.saveState = function (defectTypeId) {
            var reportShopId = this.selectedShop ? this.selectedShop.id : undefined;
            if (reportShopId === this.$stateParams.shopId) {
                reportShopId = undefined;
            }
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportPlantId: (reportShopId && this.selectedPlant) ? this.selectedPlant.id : undefined,
                reportShopId: reportShopId,
                defectTypeId: defectTypeId,
                startDate: this.startDate ? this.startDate.toISOString() : undefined,
                endDate: this.endDate ? this.endDate.toISOString() : undefined,
                filter: this.filter,
                autoRun: true
            };
            this.$state.transitionTo(this.$state.current.name, params);
        };
        return TopDefectsReportCtrl;
    }());
    exports.default = angular.module('aps.controller.topDefectsReport', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.TOP_DEFECTS_REPORT,
            url: '/admin/reports/topDefects?startDate&endDate&defectTypeId&filter&autoRun&reportPlantId&reportShopId',
            params: {
                startDate: { dynamic: true },
                endDate: { dynamic: true },
                defectTypeId: { dynamic: true },
                filter: { dynamic: true },
                autoRun: { dynamic: true },
                reportPlantId: { dynamic: true },
                reportShopId: { dynamic: true },
            },
            controller: 'TopDefectsReportCtrl as vm',
            template: topDefectsReport_tpl_html_1.default,
            data: {
                pageTitle: 'Top Defects Report'
            }
        });
    }])
        .controller('TopDefectsReportCtrl', TopDefectsReportCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div class=body-header> <h2>Top Defects Report</h2> </div> <aps-common-report-query-criteria-row vm=vm></aps-common-report-query-criteria-row> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns\"> <label> Defects Filter <select ng-model=vm.filter ng-options=\"x.value as x.text for x in vm.filters\"> </select> </label> </div> <div class=\"small-9 columns\"> <button type=submit class=button>Generate Report</button> </div> </div> </form> <div ng-if=\"vm.reportFilter !== 3 && vm.defects && vm.defects.length\"> <label> <span ng-if=\"vm.reportFilter === 1\">Top 10</span> <span ng-if=\"vm.reportFilter === 2\">Critical</span> Defects on Shop {{ vm.reportShopName }} from {{ vm.formatTime(vm.reportStartDate) }} to {{ vm.formatTime(vm.reportEndDate) }}</label> <aps-top-defects-graph defects=vm.defects defect-selected=vm.scopeWorkaround.defectBarClick> </aps-top-defects-graph> </div> <div ng-if=\"(!vm.defects || !vm.defects.length) && vm.searchPerformed && vm.reportFilter !== 3\">No results found</div> <div id=detailResultsMarker></div> <aps-drop-and-timeline-graphs ng-if=vm.detailResults data=vm.detailResults description=\"(vm.reportDefect ? vm.reportDefect.defectTypeName : 'All') + ' defects'\" graph-color=vm.getDefectDetailsColor() format-time=vm.scopeWorkaround.formatTime time-zone-id=vm.reportTimeZoneId report-start-date=vm.reportStartDate report-end-date=vm.reportEndDate> </aps-drop-and-timeline-graphs> </div>");

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(850), __webpack_require__(3), __webpack_require__(4), __webpack_require__(115), __webpack_require__(6)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, resetPassword_tpl_html_1, constant_module_1, loader_service_1, resetPassword_service_1, notify_service_1) {
    "use strict";
    resetPasswordCtrl.$inject = ["loaderService", "$stateParams", "resetPasswordService", "$state", "notifyService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, resetPassword_service_1.default, notify_service_1.default];
    exports.default = angular.module('aps.controller.resetPassword', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.RESET_PASSWORD,
            url: '/resetPassword?userId&token',
            controller: 'ResetPasswordCtrl as resetPasswordCtrl',
            template: resetPassword_tpl_html_1.default,
            data: { pageTitle: 'Reset Password' }
        });
    }])
        .controller('ResetPasswordCtrl', resetPasswordCtrl)
        .name;
    function resetPasswordCtrl(loaderService, $stateParams, resetPasswordService, $state, notifyService) {
        var vm = this;
        var submitSuccess = function () {
            notifyService.success('Password changed. You may now sign in!');
            $state.go(constant_module_1.States.SIGN_IN);
        };
        vm.setPassword = function () {
            if (vm.form.$invalid) {
                return;
            }
            var submission = {
                userId: $stateParams.userId,
                token: $stateParams.token,
                password: vm.password,
                confirmPassword: vm.confirmPassword
            };
            loaderService.loadingPromise(resetPasswordService.submitEmailPasswordReset(submission)
                .then(submitSuccess, notifyService.handleApiErrors));
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <div class=row> <div class=\"large-12 columns\"> <form name=resetPasswordCtrl.form ng-submit=resetPasswordCtrl.resetPassword() novalidate> <h4>Reset Password</h4> <input type=password name=password ng-model=resetPasswordCtrl.password placeholder=\"New Password\" required ng-minlength=8 has-lower has-upper has-number/> <div ng-messages=resetPasswordCtrl.form.password.$error ng-if=\"resetPasswordCtrl.form.password.$dirty || resetPasswordCtrl.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=minlength class=req-w><div class=arrow-up></div>Password must be a minimum of 8 characters long</div> <div ng-message=hasLower class=req-w><div class=arrow-up></div>Password must have one or more lowercase letters</div> <div ng-message=hasUpper class=req-w><div class=arrow-up></div>Password must have one or more uppercase letters</div> <div ng-message=hasNumber class=req-w><div class=arrow-up></div>Password must have one or more numbers</div> </div> <input type=password name=confirmPassword ng-model=resetPasswordCtrl.confirmPassword placeholder=\"Confirm New Password\" required compare-to=resetPasswordCtrl.password /> <div ng-messages=resetPasswordCtrl.form.confirmPassword.$error ng-if=\"resetPasswordCtrl.form.confirmPassword.$dirty || resetPasswordCtrl.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=compareTo class=req-w><div class=arrow-up></div>Passwords must match</div> </div> <button class=\"button radius right\" ng-click=resetPasswordCtrl.setPassword()>Set Password</button> </form> </div> </div> </div> ");

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(852), __webpack_require__(3), __webpack_require__(7), __webpack_require__(53), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, roleLocation_tpl_html_1, constant_module_1, authData_service_1, auth_service_1, navigation_service_1) {
    "use strict";
    roleLocationCtrl.$inject = ["authDataService", "authService", "navigationService", "$state", "$stateParams"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [authData_service_1.default, auth_service_1.default, navigation_service_1.default];
    exports.default = angular.module('aps.controller.roleLocation', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.SELECT_ROLE,
            url: '/selectRole?userId&shift',
            controller: 'RoleLocationCtrl as vm',
            template: roleLocation_tpl_html_1.default,
            data: { pageTitle: 'Select Role and PlantLocation' }
        });
    }])
        .controller('RoleLocationCtrl', roleLocationCtrl)
        .name;
    function roleLocationCtrl(authDataService, authService, navigationService, $state, $stateParams) {
        var vm = this;
        vm.roles = authDataService.getRoles().filter(function (x) { return x.roleName != 'Plant Performance Dashboard'; });
        var currentRole = authDataService.getSelectedRoleLocation();
        if (currentRole && currentRole.role) {
            vm.selectedRole = _.find(vm.roles, { roleId: currentRole.role.roleId });
        }
        else {
            vm.selectedRole = _.find(vm.roles, { lastSelected: true });
        }
        if (!vm.selectedRole) {
            vm.selectedRole = vm.roles[0];
        }
        vm.roleChanged = function () {
            navigationService.setCurrentRole(vm.selectedRole);
        };
        vm.roleChanged();
        var ignoreErrors = false;
        vm.plants = function () {
            if (!vm.navigation) {
                return [];
            }
            if (vm.selectedRole && vm.selectedRole.roleRequiresPlants && vm.selectedRole.plants) {
                return _.filter(vm.navigation.plants(), function (p) { return _.some(vm.selectedRole.plants, function (rp) { return rp.id === p.id; }); });
            }
            return vm.navigation.plants();
        };
        navigationService.getNavigation().then(function (navigation) {
            vm.navigation = navigation;
            if (vm.roles.length === 1 &&
                (!vm.selectedRole.roleRequiresPlants || (vm.selectedRole.plants.length === 1 &&
                    !vm.selectedRole.roleRequiresShops))) {
                ignoreErrors = true;
                vm.continue();
                return;
            }
            if (currentRole && currentRole.plant) {
                vm.navigation.selectedPlant = _.find(vm.plants(), { id: currentRole.plant.id });
                vm.navigation.plantChanged();
                if (currentRole.shop) {
                    vm.navigation.selectedShop = _.find(vm.navigation.shops(), { id: currentRole.shop.id });
                }
            }
        });
        vm.continue = function () {
            if (!ignoreErrors && vm.form.$invalid) {
                return;
            }
            authService.setRoleLocation(vm.selectedRole, vm.navigation.selectedPlant, vm.navigation.selectedShop, $stateParams.shift).then(function () {
                navigationService.clearSetRole();
                var params = {
                    plantId: vm.navigation.selectedPlant.id,
                    shopId: vm.navigation.selectedShop.id,
                    userId: $stateParams.userId
                };
                authService.getUserData().then(function () {
                    if (!vm.selectedRole.roleRequiresPlants) {
                        $state.go(constant_module_1.States.ADMIN_DASHBOARD, params);
                        return;
                    }
                    else if (!vm.selectedRole.roleRequiresShops) {
                        $state.go(constant_module_1.States.PLANT_DASHBOARD, params);
                        return;
                    }
                    $state.go(constant_module_1.States.DASHBOARD, params);
                });
            });
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"\" style=\"margin:100px auto;background:#fff;padding:20px;max-width:500px;border-radius:5px;-webkit-box-shadow:0 0 5px 0 rgba(0,0,0,.75);-moz-box-shadow:0 0 5px 0 rgba(0,0,0,.75);box-shadow:0 0 5px 0 rgba(0,0,0,.75)\"> <div class=row> <div class=\"large-12 columns\"> <form name=vm.form novalidate ng-submit=vm.continue()> <h4>Select <span ng-if=\"vm.roles.length > 1\">Role </span>and Location</h4> <div ng-if=\"vm.roles.length > 1\"> <label> Role: <select name=role ng-model=vm.selectedRole ng-options=\"r.roleName for r in vm.roles\" ng-change=vm.roleChanged()> </select> </label> </div> <div ng-if=\"vm.selectedRole && vm.selectedRole.roleRequiresPlants\"> <label> Plant: <select name=plant ng-model=vm.navigation.selectedPlant ng-options=\"p.name for p in vm.plants()\" ng-change=vm.navigation.plantChanged()> </select> </label> </div> <div ng-if=\"vm.navigation.selectedPlant && vm.selectedRole.roleRequiresShops\"> <label> Shop: <select name=shop ng-model=vm.navigation.selectedShop ng-options=\"s.name for s in vm.navigation.shops()\"> </select> </label> </div> <input type=submit class=\"button radius right\" value=Continue /> </form> </div> </div> </div>");

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(854), __webpack_require__(3), __webpack_require__(5), __webpack_require__(62), __webpack_require__(9), __webpack_require__(8), __webpack_require__(7), __webpack_require__(4), __webpack_require__(6), __webpack_require__(73), __webpack_require__(12), __webpack_require__(47), __webpack_require__(855), __webpack_require__(857)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, sectionChange_tpl_html_1, constant_module_1, aps_enums_1, checkListOverride_module_1, uiUtility_service_1, navigation_service_1, authData_service_1, loader_service_1, notify_service_1, sectionChange_service_1, newguid_service_1, toolChange_service_1, copySectionChange_controller_1, editSectionChange_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [copySectionChange_controller_1.default, uiUtility_service_1.default, navigation_service_1.default, authData_service_1.default,
        loader_service_1.default, notify_service_1.default, sectionChange_service_1.default, newguid_service_1.default, toolChange_service_1.default,
        editSectionChange_1.default];
    var SectionChangeCtrl = (function () {
        SectionChangeCtrl.$inject = ["navigationService", "authDataService", "loaderService", "notifyService", "sectionChangeService", "uiUtilityService", "newGuidService", "toolChangeService", "$q", "$modal"];
        function SectionChangeCtrl(navigationService, authDataService, loaderService, notifyService, sectionChangeService, uiUtilityService, newGuidService, toolChangeService, $q, $modal) {
            var _this = this;
            this.navigationService = navigationService;
            this.authDataService = authDataService;
            this.loaderService = loaderService;
            this.notifyService = notifyService;
            this.sectionChangeService = sectionChangeService;
            this.uiUtilityService = uiUtilityService;
            this.newGuidService = newGuidService;
            this.toolChangeService = toolChangeService;
            this.$modal = $modal;
            this.$q = $q;
            this.levels = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.CheckListLevel, aps_enums_1.apsEnums.CheckListLevel.All);
            this.level = aps_enums_1.apsEnums.CheckListLevel.All;
            this.plantsAllSelection = checkListOverride_module_1.CheckListCommon.getAllPlantsItem();
            this.shopsAllSelection = checkListOverride_module_1.CheckListCommon.getAllShopsItem();
            this.plant = this.plantsAllSelection;
            this.shop = this.shopsAllSelection;
            this.toolChangeService.getToolsAndTypes().then(function (tools) { return _this.tools = tools; });
            loaderService.loadingPromise(this.navigationService.getPlants(false).then(function (plants) {
                _this.plants = plants;
                _this.shops = [_this.shopsAllSelection];
                _this.allShops = _.flatten(_.map(plants, 'shops'));
                _this.plants.unshift(_this.plantsAllSelection);
                _this.plantChanged();
                return _this.sectionChangeService.getStrategies().then(function (strategies) {
                    _this.strategies = strategies;
                    _.forEach(_this.strategies, function (strategy) {
                        var plant = null;
                        var shop = null;
                        if (strategy.plantId) {
                            plant = _.find(_this.plants, function (p) { return p.id === strategy.plantId; });
                            if (strategy.shopId) {
                                shop = _.find(plant.shops, function (s) { return s.id === strategy.shopId; });
                            }
                            strategy.canEdit = _this.authDataService.isPlantAdmin(strategy.plantId);
                        }
                        else {
                            strategy.canEdit = _this.authDataService.isAdmin();
                        }
                        if (plant) {
                            strategy.plantName = plant.name;
                        }
                        else {
                            strategy.plantName = 'All';
                        }
                        if (shop) {
                            strategy.shopName = shop.name;
                        }
                        else {
                            strategy.shopName = 'All';
                        }
                        _this.updateConfigShifts(strategy);
                    });
                    _this.filterStrategies();
                });
            }));
        }
        SectionChangeCtrl.prototype.updateConfigShifts = function (strategy) {
            _.forEach(strategy.configs, function (config) {
                config.shift1 = ((config.shifts & aps_enums_1.apsEnums.Shift.First) === aps_enums_1.apsEnums.Shift.First);
                config.shift2 = ((config.shifts & aps_enums_1.apsEnums.Shift.Second) === aps_enums_1.apsEnums.Shift.Second);
                config.shift3 = ((config.shifts & aps_enums_1.apsEnums.Shift.Third) === aps_enums_1.apsEnums.Shift.Third);
            });
        };
        SectionChangeCtrl.prototype.filterStrategies = function () {
            var _this = this;
            if (!this.strategies) {
                this.filteredStrategies = null;
                return;
            }
            this.filteredStrategies = _.filter(this.strategies, function (s) {
                return (_this.level === aps_enums_1.apsEnums.CheckListLevel.All
                    || (_this.level === aps_enums_1.apsEnums.CheckListLevel.Corporate && !s.plantId && !s.shopId)
                    || (_this.level === aps_enums_1.apsEnums.CheckListLevel.Plant && s.plantId && !s.shopId)
                    || (_this.level === aps_enums_1.apsEnums.CheckListLevel.Shop && s.plantId && s.shopId))
                    && (_this.plant === _this.plantsAllSelection || _this.plant.id === s.plantId)
                    && (_this.shop === _this.shopsAllSelection || _this.shop.id === s.shopId);
            });
        };
        SectionChangeCtrl.prototype.plantShops = function () {
            var shops = this.plant.shops;
            if (shops.length === 0 || shops[0] !== this.shopsAllSelection) {
                shops.unshift(this.shopsAllSelection);
            }
            return shops;
        };
        SectionChangeCtrl.prototype.plantChanged = function () {
            this.shops = this.plantShops();
            this.shop = _.first(this.shops);
            if (this.plant === this.plantsAllSelection) {
                this.canAddStrategy = this.authDataService.isAdmin();
            }
            else {
                this.canAddStrategy = this.authDataService.isPlantAdmin(this.plant.id);
            }
            this.filterStrategies();
        };
        SectionChangeCtrl.prototype.canBeDefault = function (id, plant, shop) {
            plant = plant || this.plant;
            shop = shop || this.shop;
            return !_.some(this.strategies, function (s) {
                return s.isDefault && s.id !== id
                    && ((!s.plantId && !plant.id) || s.plantId === plant.id)
                    && ((!s.shopId && !shop.id) || s.shopId === shop.id);
            });
        };
        SectionChangeCtrl.prototype.addStrategy = function () {
            var _this = this;
            if (!this.canAddStrategy) {
                return;
            }
            var result = editSectionChange_1.openEditSectionChange({
                readOnly: false,
                canBeDefault: this.canBeDefault(),
                plant: this.plant,
                shop: this.shop,
                tools: this.tools,
                strategy: null
            }, this.$modal);
            result.then(function (strategy) {
                if (strategy) {
                    _this.strategies.push(strategy);
                    _this.filterStrategies();
                }
            });
        };
        SectionChangeCtrl.prototype.editStrategy = function (strategy) {
            var _this = this;
            var plant = this.plantsAllSelection;
            var shop = this.shopsAllSelection;
            if (strategy.plantId) {
                plant = _.find(this.plants, { id: strategy.plantId });
                if (strategy.shopId) {
                    shop = _.find(plant.shops, { id: strategy.shopId });
                }
            }
            var promise;
            if (strategy.configs === null) {
                promise = this.sectionChangeService.getStrategy(strategy.id).then(function (data) {
                    strategy.configs = data.configs;
                    _this.updateConfigShifts(strategy);
                });
                this.loaderService.loadingPromise(promise);
            }
            else {
                promise = this.$q.when();
            }
            promise.then(function () {
                var result = editSectionChange_1.openEditSectionChange({
                    readOnly: !strategy.canEdit,
                    canBeDefault: _this.canBeDefault(strategy.id, plant, shop),
                    plant: plant,
                    shop: shop,
                    tools: _this.tools,
                    strategy: strategy
                }, _this.$modal);
                result.then(function (data) {
                    if (data) {
                        var index = _.indexOf(_this.strategies, strategy);
                        if (index >= 0) {
                            _this.strategies[index] = data;
                            _this.filterStrategies();
                        }
                    }
                });
            });
        };
        SectionChangeCtrl.prototype.copyStrategy = function (strategy) {
            var _this = this;
            var result = copySectionChange_controller_1.openCopySectionChange({
                originalStrategy: strategy,
                plants: this.plants
            }, this.$modal);
            result.then(function (copy) {
                if (copy) {
                    _this.strategies.unshift(copy);
                    _this.filterStrategies();
                }
            });
        };
        SectionChangeCtrl.prototype.deleteStrategy = function (strategy) {
            var _this = this;
            if (!strategy || !strategy.canEdit) {
                return;
            }
            this.uiUtilityService.confirm('Are you sure you want to remove this Section Change Strategy?').then(function (result) {
                if (result) {
                    _this.loaderService.loadingPromise(_this.sectionChangeService.deleteStrategy(strategy.id).then(function () {
                        _.remove(_this.strategies, strategy);
                        _this.filterStrategies();
                    }, _this.notifyService.handleApiErrors));
                }
            });
        };
        return SectionChangeCtrl;
    }());
    exports.default = angular.module('aps.controller.sectionChange', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.SECTION_CHANGES,
            url: '/sectionChanges',
            controller: 'SectionChangeCtrl as vm',
            template: sectionChange_tpl_html_1.default,
            data: { pageTitle: 'Section Change Strategies',
                authorizeAdmin: true,
                authorizePlantAdmin: true
            }
        });
    }])
        .controller('SectionChangeCtrl', SectionChangeCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w ng-if=vm.strategies> <div class=body-header> <h2> Section Change Strategies </h2> </div> <div class=row style=margin-left:-30px> <div class=\"large-2 columns\"> <label>Level: <select name=level ng-model=vm.level ng-change=vm.filterStrategies() ng-options=\"x.value as x.text for x in vm.levels\"> </select> </label> </div> <div class=\"large-2 columns\"> <label>Plant: <select name=plant ng-model=vm.plant ng-change=vm.plantChanged() ng-options=\"plant.name for plant in vm.plants\"> </select> </label> </div> <div class=\"large-2 columns\"> <label>Shop: <select name=shop ng-model=vm.shop ng-change=vm.filterStrategies() ng-options=\"shop.name for shop in vm.shops\"> </select> </label> </div> <div class=\"large-6 columns\"> <a href=\"\" class=\"button small right\" ng-if=vm.canAddStrategy ng-click=vm.addStrategy() style=\"margin:15px 0 0 0\">Add Strategy</a> </div> </div> <table class=history-t ng-if=\"vm.filteredStrategies.length > 0\"> <thead> <tr> <th>Name</th> <th>Plant</th> <th>Shop</th> <th>Default</th> <th></th> </tr> </thead> <tbody> <tr ng-repeat=\"s in vm.filteredStrategies\"> <td>{{ s.name }}</td> <td>{{ s.plantName }}</td> <td>{{ s.shopName }}</td> <td>{{ s.isDefault ? 'Yes' : 'No' }}</td> <td> <button class=\"button tiny\" ng-click=vm.editStrategy(s) style=margin:0>Open</button> <button class=\"button tiny\" ng-click=vm.copyStrategy(s) style=margin:0>Copy</button> <button class=\"button tiny alert\" ng-if=s.canEdit ng-click=vm.deleteStrategy(s) style=margin:0>Remove</button> </td> </tr> </tbody> </table> <div ng-if=\"vm.filteredStrategies.length == 0\"> There are no strategies defined that match your criteria. </div> </div> ");

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(856), __webpack_require__(73), __webpack_require__(4), __webpack_require__(6), __webpack_require__(12), __webpack_require__(62), __webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, copySectionChange_tpl_html_1, sectionChange_service_1, loader_service_1, notify_service_1, newguid_service_1, checkListOverride_module_1, authData_service_1) {
    "use strict";
    copySectionChangeCtrl.$inject = ["$modalInstance", "data", "sectionChangeService", "loaderService", "notifyService", "newGuidService", "authDataService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [sectionChange_service_1.default, loader_service_1.default, notify_service_1.default, newguid_service_1.default,
        authData_service_1.default];
    function openCopySectionChange(data, $modal) {
        return $modal.open({
            template: copySectionChange_tpl_html_1.default,
            controller: 'CopySectionChangeCtrl as vm',
            resolve: {
                data: function () {
                    return data;
                }
            }
        }).result;
    }
    exports.openCopySectionChange = openCopySectionChange;
    exports.default = angular.module('aps.controller.copySectionChange', requires)
        .controller('CopySectionChangeCtrl', copySectionChangeCtrl)
        .name;
    function copySectionChangeCtrl($modalInstance, data, sectionChangeService, loaderService, notifyService, newGuidService, authDataService) {
        var vm = {};
        var isAdmin = authDataService.isAdmin();
        vm.originalStrategy = data.originalStrategy;
        vm.name = 'Copy of ' + vm.originalStrategy.name;
        var shopsAllSelection = checkListOverride_module_1.CheckListCommon.getAllShopsItem();
        var plantsAllSelection = checkListOverride_module_1.CheckListCommon.getAllPlantsItem();
        if (isAdmin) {
            vm.plants = data.plants;
            vm.plant = plantsAllSelection;
        }
        else {
            vm.plants = _.filter(data.plants, function (plant) { return authDataService.isPlantAdmin(plant.id); });
            vm.plant = vm.plants[0];
        }
        vm.shop = shopsAllSelection;
        newGuidService.getNewGuid('checkList').then(function (id) { return vm.id = id; });
        vm.submit = function () {
            if (vm.form.$invalid) {
                return;
            }
            var plant = vm.plant !== plantsAllSelection ? vm.plant : undefined;
            var shop = vm.shop !== shopsAllSelection ? vm.shop : undefined;
            var command = {
                id: vm.id,
                originalId: vm.originalStrategy.id,
                name: vm.name,
                plantId: plant ? plant.id : null,
                shopId: shop ? shop.id : null
            };
            var promise = sectionChangeService.copyStrategy(command).then(function () {
                var strategy = {
                    id: vm.id,
                    name: vm.name,
                    canEdit: true,
                    configs: null,
                    isDefault: false,
                    plantId: command.plantId,
                    plantName: plant ? plant.name : 'All',
                    shopId: command.shopId,
                    shopName: shop ? shop.name : 'All'
                };
                $modalInstance.close(strategy);
            }, notifyService.handleApiErrors);
            loaderService.loadingPromise(promise);
        };
        vm.cancel = function () {
            $modalInstance.close();
        };
        vm.shops_filtered = function () {
            var result = vm.plant.shops.concat([]);
            if (result.length === 0 || result[0] !== shopsAllSelection) {
                result.unshift(shopsAllSelection);
            }
            if (result.length === 1) {
                vm.shop = result[0];
            }
            return result;
        };
        return vm;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <h2 class=modal-header>Copy Section Change Strategy</h2> <form name=vm.form ng-submit=vm.submit() novalidate> <div class=row style=margin-left:-30px> <div class=\"large-12 columns\"> <label>Name: <span ng-show=vm.form.name.$error.required style=color:red>*</span> <input type=text name=name ng-model=vm.name required/> </label> <div ng-messages=vm.form.name.$error ng-if=\"vm.form.name.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=\"required req-w\"><div class=arrow-up></div>Required</div> </div> </div> </div> <div class=row style=margin-left:-30px> <div class=\"large-4 columns\"> <label>Plant: <select name=plant ng-model=vm.plant ng-options=\"plant.name for plant in vm.plants\"> </select> </label> </div> <div class=\"large-4 columns\"> <label>Shop: <select name=shop ng-model=vm.shop ng-options=\"shop.name for shop in vm.shops_filtered()\"> </select> </label> </div> <div class=\"large-4 columns\"> &nbsp; </div> </div> <div class=row> <div class=\"small-12 columns\"> <div class=\"right dialog-footer\"> <button type=submit class=button>Copy</button> <button type=button ng-click=vm.cancel() class=\"button secondary\">Cancel</button> </div> </div> </div> </form> </div>");

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(858), __webpack_require__(9), __webpack_require__(4), __webpack_require__(6), __webpack_require__(73), __webpack_require__(12), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, editSectionChange_tpl_html_1, uiUtility_service_1, loader_service_1, notify_service_1, sectionChange_service_1, newguid_service_1, aps_enums_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [uiUtility_service_1.default, loader_service_1.default, notify_service_1.default, sectionChange_service_1.default,
        newguid_service_1.default];
    function openEditSectionChange(data, $modal) {
        return $modal.open({
            template: editSectionChange_tpl_html_1.default,
            controller: 'SectionChangeEditCtrl as vm',
            resolve: {
                params: function () {
                    return data;
                }
            }
        }).result;
    }
    exports.openEditSectionChange = openEditSectionChange;
    var SectionChangeEditCtrl = (function () {
        SectionChangeEditCtrl.$inject = ["params", "loaderService", "notifyService", "sectionChangeService", "newGuidService", "uiUtilityService", "$modalInstance"];
        function SectionChangeEditCtrl(params, loaderService, notifyService, sectionChangeService, newGuidService, uiUtilityService, $modalInstance) {
            var _this = this;
            this.loaderService = loaderService;
            this.notifyService = notifyService;
            this.sectionChangeService = sectionChangeService;
            this.newGuidService = newGuidService;
            this.uiUtilityService = uiUtilityService;
            this.$modalInstance = $modalInstance;
            this.plant = params.plant;
            this.shop = params.shop;
            this.canBeDefault = params.canBeDefault;
            this.tools = params.tools;
            this.orders = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.SectionChangeOrder, 1);
            this.sections = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.SectionChangeSections, 1);
            if (params.strategy) {
                this.strategy = JSON.parse(JSON.stringify(params.strategy));
            }
            else {
                this.strategy = {
                    id: null,
                    isDefault: false,
                    name: '',
                    plantId: this.plant.id,
                    plantName: this.plant.name,
                    shopId: this.shop.id,
                    shopName: this.shop.name,
                    canEdit: true,
                    configs: []
                };
                this.addShiftGroup();
                this.newGuidService
                    .getNewGuid('sectionChangeStrategy')
                    .then(function (id) { return _this.strategy.id = id; });
            }
        }
        SectionChangeEditCtrl.prototype.shiftsInvalid = function () {
            var _this = this;
            return !this.strategy.id || this.shiftsRequired()
                || _.some(this.strategy.configs, function (c) { return !c.id
                    || _this.toolsRequired(c)
                    || _this.shiftRequired(c)
                    || _.some(c.details, function (d) { return !d.id; }); });
        };
        SectionChangeEditCtrl.prototype.shiftsRequired = function () {
            return this.form.$submitted
                && this.strategy.configs.length === 0;
        };
        SectionChangeEditCtrl.prototype.toolsRequired = function (config) {
            return this.form.$submitted
                && config.details.length === 0;
        };
        SectionChangeEditCtrl.prototype.shiftRequired = function (config) {
            return this.form.$submitted
                && !(config.shift1 || config.shift2 || config.shift3);
        };
        SectionChangeEditCtrl.prototype.submit = function () {
            var _this = this;
            if (this.form.$invalid
                || this.shiftsInvalid()) {
                return;
            }
            _.forEach(this.strategy.configs, function (c) {
                c.shifts = c.shift1 ? aps_enums_1.apsEnums.Shift.First : 0
                    | (c.shift2 ? aps_enums_1.apsEnums.Shift.Second : 0)
                    | (c.shift3 ? aps_enums_1.apsEnums.Shift.Third : 0);
                _.forEach(c.details, function (d) {
                    if (d.sections !== aps_enums_1.apsEnums.SectionChangeSections.Number) {
                        d.numberOfSections = null;
                    }
                });
            });
            this.sectionChangeService.addUpdateStrategy(this.strategy)
                .then(function () {
                _this.$modalInstance.close(_this.strategy);
            }, this.notifyService.handleApiErrors);
        };
        SectionChangeEditCtrl.prototype.cancel = function () {
            this.$modalInstance.close();
        };
        SectionChangeEditCtrl.prototype.disableShift = function (config, shift) {
            if (shift === 1) {
                if (config.shift1) {
                    return false;
                }
                return _.some(this.strategy.configs, function (c) { return c.shift1; });
            }
            if (shift === 2) {
                if (config.shift2) {
                    return false;
                }
                return _.some(this.strategy.configs, function (c) { return c.shift2; });
            }
            if (config.shift3) {
                return false;
            }
            return _.some(this.strategy.configs, function (c) { return c.shift3; });
        };
        SectionChangeEditCtrl.prototype.addShiftGroup = function () {
            var config = {
                shift1: false,
                shift2: false,
                shift3: false,
                id: null,
                shifts: 0,
                runOnHolidays: false,
                runOnWeekends: false,
                delayDays: 0,
                details: []
            };
            this.addTool(config);
            this.strategy.configs.push(config);
            this.newGuidService.getNewGuid('sectionChangeConfig').then(function (id) { return config.id = id; });
        };
        SectionChangeEditCtrl.prototype.canAddShiftGroup = function () {
            return this.strategy.configs.length === 0
                || _.every(this.strategy.configs, function (c) { return !c.shift1; })
                || _.every(this.strategy.configs, function (c) { return !c.shift2; })
                || _.every(this.strategy.configs, function (c) { return !c.shift3; });
        };
        SectionChangeEditCtrl.prototype.removeShiftGroup = function (config) {
            _.remove(this.strategy.configs, config);
        };
        SectionChangeEditCtrl.prototype.addTool = function (config) {
            var detail = {
                id: null,
                toolId: null,
                sections: aps_enums_1.apsEnums.SectionChangeSections.Number,
                numberOfSections: 1,
                order: aps_enums_1.apsEnums.SectionChangeOrder.Sequential
            };
            config.details.push(detail);
            this.newGuidService.getNewGuid('sectionChangeConfigDetail').then(function (id) { return detail.id = id; });
        };
        SectionChangeEditCtrl.prototype.removeTool = function (config, detail) {
            _.remove(config.details, detail);
        };
        SectionChangeEditCtrl.prototype.getTools = function (detail) {
            var toolIds = _.map(_.xor(_.flatten(_.map(this.strategy.configs, 'details')), [detail]), 'toolId');
            return _.filter(this.tools, function (t) { return _.every(toolIds, function (id) { return id !== t.id; }); });
        };
        SectionChangeEditCtrl.prototype.canRemoveShiftGroup = function () {
            return this.strategy.configs.length > 1;
        };
        SectionChangeEditCtrl.prototype.canRemoveTool = function (config) {
            return config.details.length > 1;
        };
        return SectionChangeEditCtrl;
    }());
    exports.default = angular.module('aps.controller.editSectionChange', requires)
        .controller('SectionChangeEditCtrl', SectionChangeEditCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <form name=vm.form ng-submit=vm.submit() novalidate> <h2 class=modal-header>Section Change Strategy</h2> <div class=container> <div class=row> <div class=\"large-6 columns\"> <label>Name: <span style=color:red>*</span> <input type=text name=name ng-model=vm.strategy.name required ng-disabled=vm.readOnly /> </label> <div ng-messages=vm.form.name.$error ng-if=\"vm.form.name.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=\"required req-w\"> <div class=arrow-up></div>Required </div> </div> </div> <div class=\"large-3 columns\"> <label>Plant <h4>{{vm.plant.name}}</h4> </label> </div> <div class=\"large-3 columns\"> <label>Shop <h4>{{vm.shop.name}}</h4> </label> </div> </div> <div class=row ng-if=\"vm.canBeDefault && !vm.readOnly\"> <div class=\"large-12 columns\"> <label> Default Strategy <input type=checkbox ng-model=vm.strategy.isDefault /> </label> </div> </div> <div ng-repeat=\"config in vm.strategy.configs\" style=\"margin-top:.5em;margin-bottom:.5em;padding:3pt 3pt 3pt 3pt\" ng-class=\"{'shift-group': ($index%2) === 0}\"> <div class=row> <div class=\"large-3 columns\"> <h5>Shifts</h5> </div> <div class=\"large-3 columns\"> <label>First <input type=checkbox ng-model=config.shift1 ng-disabled=\"vm.readOnly || vm.disableShift(config, 1)\"/> </label> </div> <div class=\"large-3 columns\"> <label>Second <input type=checkbox ng-model=config.shift2 ng-disabled=\"vm.readOnly || vm.disableShift(config, 2)\"/> </label> </div> <div class=\"large-3 columns\"> <label>Third <input type=checkbox ng-model=config.shift3 ng-disabled=\"vm.readOnly || vm.disableShift(config, 3)\"/> </label> </div> </div> <div class=row ng-if=vm.shiftRequired(config)> <div class=\"large-3 columns\"> </div> <div class=\"large-9 columns\"> <div role=alert> <div class=req-w><div class=arrow-up></div>Must select one or more shifts</div> </div> </div> </div> <div class=row> <div class=\"large-3 columns\"> <label for=\"delayDays{{$index}}\">Days before start</label> </div> <div class=\"large-1 columns\"> <input type=number step=1 min=0 ng-model=config.delayDays name=\"delayDays{{$index}}\" required ng-disabled=vm.readOnly /> <div ng-messages=\"vm.form['delayDays' + $index].$error\" ng-if=\"vm.form['delayDays' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a valid number</div> <div ng-message=min class=req-w><div class=arrow-up></div>May not be less than 0</div> <div ng-message=step class=req-w><div class=arrow-up></div>Must be an integer</div> </div> </div> <div class=\"large-3 columns\"> <label>Run on Weekends <input type=checkbox ng-model=config.runOnWeekends ng-disabled=vm.readOnly /> </label> </div> <div class=\"large-3 columns\"> <label>Run on Holidays <input type=checkbox ng-model=config.runOnHolidays ng-disabled=vm.readOnly /> </label> </div> <div class=\"large-2 columns\"> </div> </div> <div ng-if=\"config.details.length > 0\"> <div class=row> <div class=\"large-3 columns\"> <h5>Tools</h5> </div> <div class=\"large-3 columns\"> <h5>Order</h5> </div> <div class=\"large-6 columns\"> <h5>Sections</h5> </div> </div> <div class=row ng-repeat=\"detail in config.details track by $index\"> <div class=\"large-3 columns\"> <select name=\"tool{{$parent.$parent.$index}}_{{$index}}\" ng-model=detail.toolId ng-options=\"x.id as x.name for x in vm.getTools(detail) | orderBy: 'name'\" ng-disabled=vm.readOnly required> <option value=\"\">-- Select a Tool --</option> </select> <div ng-messages=\"vm.form['tool' + $parent.$parent.$index + '_' + $index].$error\" ng-if=\"vm.form['tool' + $parent.$parent.$index + '_' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </div> <div class=\"large-3 columns\"> <select name=order ng-model=detail.order ng-options=\"x.value as x.text for x in vm.orders\" ng-disabled=vm.readOnly> </select> </div> <div class=\"large-2 columns\"> <select name=sections ng-model=detail.sections ng-options=\"x.value as x.text for x in vm.sections\" ng-disabled=vm.readOnly> </select> </div> <div class=\"large-2 columns\"> <input type=number step=1 min=1 max=12 ng-model=detail.numberOfSections ng-if=\"detail.sections === 1\" placeholder=\"# of Sections\" name=\"numberOfSections{{$parent.$parent.$index}}_{{$index}}\" required ng-disabled=vm.readOnly /> <div ng-messages=\"vm.form['numberOfSections' + $parent.$parent.$index + '_' + $index].$error\" ng-if=\"vm.form['numberOfSections' + $parent.$parent.$index + '_' + $index].$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=number class=req-w><div class=arrow-up></div>Must be a valid number</div> <div ng-message=min class=req-w><div class=arrow-up></div>May not be less than 1</div> <div ng-message=max class=req-w><div class=arrow-up></div>May not be more than 12</div> <div ng-message=step class=req-w><div class=arrow-up></div>Must be an integer</div> </div> </div> <div class=\"large-2 columns\"> <button type=button class=\"button tiny alert\" ng-if=\"!vm.readOnly && vm.canRemoveTool(config)\" style=margin-left:5pt ng-click=\"vm.removeTool(config, detail)\">Remove</button> </div> </div> </div> <div ng-if=vm.toolsRequired(config) role=alert> <div class=req-w><div class=arrow-up></div>Must have one or more tools</div> </div> <div class=row> <div class=\"large-12 columns\"> <button type=button class=\"button tiny\" ng-if=!vm.readOnly ng-click=vm.addTool(config)>Add Tool</button> <button type=button class=\"button tiny alert\" ng-if=\"!vm.readOnly && vm.canRemoveShiftGroup()\" ng-click=vm.removeShiftGroup(config)>Remove Shift Group</button> </div> </div> </div> <div ng-if=vm.shiftsRequired() role=alert> <div class=req-w><div class=arrow-up></div>Must have one or more shift groups</div> </div> <!-- footer --> <div class=row> <div class=\"large-4 columns\"> <div> <button type=button class=button ng-if=!vm.readOnly ng-click=vm.addShiftGroup() ng-disabled=!vm.canAddShiftGroup()>Add Shift Group</button> </div> </div> <div class=\"large-8 columns\"> <div class=\"right dialog-footer\"> <button type=submit class=button ng-if=!vm.readOnly>Save Strategy</button> <button type=button class=\"button secondary\" ng-click=vm.cancel()>{{ vm.readOnly ? 'OK' : 'Cancel' }}</button> </div> </div> </div> </div> </form> </div>");

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(860), __webpack_require__(861), __webpack_require__(3), __webpack_require__(23), __webpack_require__(4), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, shops_tpl_html_1, editShop_controller_1, constant_module_1, shops_service_1, loader_service_1, navigation_service_1) {
    "use strict";
    shopsCtrl.$inject = ["$modal", "shopService", "navigationService", "loaderService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [editShop_controller_1.default, shops_service_1.default, loader_service_1.default, navigation_service_1.default];
    exports.default = angular.module('aps.controller.shops', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.SHOPS,
            url: '/admin/shops',
            controller: 'ShopsCtrl as shopsCtrl',
            template: shops_tpl_html_1.default,
            data: {
                pageTitle: 'Shops',
                authorizeAdmin: true
            }
        });
    }])
        .controller('ShopsCtrl', shopsCtrl)
        .name;
    function shopsCtrl($modal, shopService, navigationService, loaderService) {
        var vm = {};
        loaderService.loadingPromise(shopService.getShops().then(function (data) {
            vm.shops = data;
            vm.plantNames = _.uniq(_.map(vm.shops, 'plantName')).sort();
            return navigationService.getNavigation().then(function (nav) {
                vm.plantName = nav.selectedPlant.name;
            });
        }));
        var launchEditor = function (shop) {
            var result = editShop_controller_1.openEditShop({
                shop: shop
            }, $modal);
            result.then(function (editedShop) {
                if (editedShop) {
                    if (shop) {
                        _.assign(shop, editedShop);
                        return;
                    }
                    vm.shops.unshift(editedShop);
                }
            });
        };
        vm.editShop = function (shop) {
            launchEditor(shop);
        };
        return vm;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w ng-if=shopsCtrl.shops> <div class=body-header><h2>Shops</h2></div> <div ng-if=\"shopsCtrl.shops.length === 0\"> Currently there are no shops in the system </div> <div class=\"small-3 columns\" ng-if=\"shopsCtrl.plantNames.length > 0\"> <label> Plant: <select ng-model=shopsCtrl.plantName ng-options=\"plantName for plantName in shopsCtrl.plantNames\"> </select> </label> </div> <table cellpadding=1 cellspacing=1 ng-if=\"shopsCtrl.shops.length > 0\" class=history-t> <tr> <th>Plant</th> <th>Tank</th> <th>Name</th> <th>Machine count</th> <th>Sects</th> <th>Gobs</th> <th></th> </tr> <tr ng-repeat=\"shop in shopsCtrl.shops | filter : shopsCtrl.plantName | orderBy: ['plantName','tankName','name']\"> <td>{{ shop.plantName }}</td> <td>{{ shop.tankName }}</td> <td>{{ shop.name }}</td> <td>{{ shop.numberOfMachines }}</td> <td>{{ shop.defaultNumberOfSections }}</td> <td>{{ shop.defaultNumberOfGobs }}</td> <td><button ng-click=shopsCtrl.editShop(shop) class=\"button tiny\" style=margin:0>Edit</button></td> </tr> </table> </div> ");

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(862), __webpack_require__(5), __webpack_require__(9), __webpack_require__(4), __webpack_require__(6), __webpack_require__(57), __webpack_require__(12), __webpack_require__(23)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, editShop_tpl_html_1, aps_enums_1, uiUtility_service_1, loader_service_1, notify_service_1, dataPoints_service_1, newguid_service_1, shops_service_1) {
    "use strict";
    editShopCtrl.$inject = ["$modalInstance", "loaderService", "notifyService", "data", "dataPointService", "newGuidService", "shopService", "uiUtilityService", "$q"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [uiUtility_service_1.default, loader_service_1.default, notify_service_1.default, dataPoints_service_1.default,
        newguid_service_1.default, shops_service_1.default];
    function openEditShop(data, $modal) {
        return $modal.open({
            template: editShop_tpl_html_1.default,
            controller: 'EditShopCtrl as vm',
            resolve: {
                data: function () {
                    return data;
                }
            }
        }).result;
    }
    exports.openEditShop = openEditShop;
    exports.default = angular.module('aps.controller.editShop', requires)
        .controller('EditShopCtrl', editShopCtrl)
        .name;
    function editShopCtrl($modalInstance, loaderService, notifyService, data, dataPointService, newGuidService, shopService, uiUtilityService, $q) {
        var vm = this;
        vm.editedShop = {};
        _.assign(vm.editedShop, data.shop);
        shopService.getPlants().then(function (plantData) {
            vm.plants = plantData;
            if (vm.editedShop.plantId) {
                vm.editedShop.plant = _.find(vm.plants, { id: vm.editedShop.plantId });
                if (vm.editedShop.plant) {
                    vm.tanks = vm.editedShop.plant.tanks;
                    if (vm.editedShop.tankId) {
                        vm.editedShop.tank = _.find(vm.tanks, { id: vm.editedShop.tankId });
                    }
                }
            }
        });
        vm.wellKnownCheckTypes = uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.WellKnownCheckType, 1, 2)
            .concat(uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.WellKnownCheckType, 4, 6))
            .concat(uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.WellKnownCheckType, 7, 7))
            .concat(uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.WellKnownCheckType, 32, 32))
            .concat(uiUtilityService.getListOptionsFromEnum(aps_enums_1.apsEnums.WellKnownCheckType, 35, 36));
        var newGuids = [];
        var missingDataPoints = vm.wellKnownCheckTypes.length - data.shop.dataPoints.length;
        for (var i = 0; i < missingDataPoints; i++) {
            newGuids.push(newGuidService.getNewGuid('ShopDataPoint'));
        }
        var getFormulas = function () {
            return dataPointService.get(data.shop.plantId)
                .then(function (dataPointDetails) {
                return _.filter(dataPointDetails, function (dp) { return dp.plantLocationId === data.shop.plantLocationId; });
            });
        };
        var updateShopDataPointDetails = function () {
            return $q.all(newGuids).then(function (resolvedGuids) {
                var _loop_1 = function (key) {
                    var enumKey = parseInt(key, 10);
                    var value = vm.shopDataPoints[key];
                    if (value.id === null) {
                        return "continue";
                    }
                    var matchingSdp = _.find(data.shop.dataPoints, function (x) {
                        return x.wellKnownCheckType === enumKey;
                    });
                    var id = matchingSdp ? matchingSdp.id : resolvedGuids.pop();
                    var sdp = {
                        id: id,
                        wellKnownCheckType: enumKey,
                        dataPointId: value.id
                    };
                    vm.editedShop.dataPoints.push(sdp);
                };
                for (var key in vm.shopDataPoints) {
                    _loop_1(key);
                }
            });
        };
        vm.save = function () {
            if (vm.form.$invalid) {
                return;
            }
            vm.editedShop.dataPoints = [];
            loaderService.loadingPromise(updateShopDataPointDetails()
                .then(function () {
                return shopService.updateShop(vm.editedShop).then(function () {
                    $modalInstance.close(vm.editedShop);
                }, notifyService.handleApiErrors);
            }));
        };
        vm.close = function () {
            $modalInstance.close();
        };
        getFormulas().then(function (formulas) {
            var notConfigured = {
                id: null,
                name: 'Not configured'
            };
            formulas.unshift(notConfigured);
            vm.plantDataPoints = formulas;
            vm.shopDataPoints = {};
            var _loop_2 = function (t) {
                var sdp = _.find(data.shop.dataPoints, function (x) { return x.wellKnownCheckType === t.value; });
                if (sdp) {
                    var dataPoint = _.find(formulas, function (x) { return x.id === sdp.dataPointId; });
                    vm.shopDataPoints[t.value] = dataPoint || notConfigured;
                }
                else {
                    vm.shopDataPoints[t.value] = notConfigured;
                }
            };
            for (var _i = 0, _a = vm.wellKnownCheckTypes; _i < _a.length; _i++) {
                var t = _a[_i];
                _loop_2(t);
            }
        });
        return vm;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <form name=vm.form ng-submit=vm.save() novalidate> <h2 class=modal-header>Edit a Shop</h2> <div class=container> <label> Plant <span>{{ vm.editedShop.plantName }}</span> </label> <label> Tank <span>{{ vm.editedShop.tankName }}</span> </label> <label> <span class=\"required notated\">*</span>Name <input name=shopName type=text ng-model=vm.editedShop.name required/> <div ng-messages=vm.form.shopName.$error ng-if=\"vm.form.shopName.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> <label> Number of Machines <span>{{ vm.editedShop.numberOfMachines }}</span> </label> <label> <span class=\"required notated\">*</span>Default Number of Sections <input name=defaultNumberOfSections type=number ng-model=vm.editedShop.defaultNumberOfSections min=1 max=255 step=1 required/> <div ng-messages=vm.form.defaultNumberOfSections.$error ng-if=\"vm.form.defaultNumberOfSections.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be 1 or more</div> <div ng-message=max class=req-w><div class=arrow-up></div>Must be less than 256</div> <div ng-message=step class=req-w><div class=arrow-up></div>Must be an integer</div> </div> </label> <label> <span class=\"required notated\">*</span>Default Number of Gobs <input name=defaultNumberOfGobs type=number ng-model=vm.editedShop.defaultNumberOfGobs min=1 max=255 step=1 required/> <div ng-messages=vm.form.defaultNumberOfGobs.$error ng-if=\"vm.form.defaultNumberOfGobs.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=min class=req-w><div class=arrow-up></div>Must be 1 or more</div> <div ng-message=max class=req-w><div class=arrow-up></div>Must be less than 256</div> <div ng-message=step class=req-w><div class=arrow-up></div>Must be an integer</div> </div> </label> <label ng-repeat=\"type in vm.wellKnownCheckTypes\"> {{ type.text }} <select ng-model=vm.shopDataPoints[type.value] ng-options=\"formula.name for formula in vm.plantDataPoints track by formula.id\"> </select> </label> </div> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-12 columns\"> <span class=required>* Required Fields</span> <div class=dialog-footer> <input type=submit class=button value=Save /> <button type=button class=\"button secondary\" ng-click=vm.close()>Close</button> </div> </div> </div> </form> </div> ");

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(864), __webpack_require__(866), __webpack_require__(3), __webpack_require__(868), __webpack_require__(53), __webpack_require__(7), __webpack_require__(6), __webpack_require__(4), __webpack_require__(115), __webpack_require__(8), __webpack_require__(60)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, resetByQuestion_1, selectResetOption_1, constant_module_1, signIn_tpl_html_1, auth_service_1, authData_service_1, notify_service_1, loader_service_1, resetPassword_service_1, navigation_service_1, userProfile_1) {
    "use strict";
    signInCtrl.$inject = ["$state", "authService", "authDataService", "notifyService", "loaderService", "resetPasswordService", "navigationService", "userProfile", "$modal"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [resetByQuestion_1.default, selectResetOption_1.default, auth_service_1.default, authData_service_1.default, notify_service_1.default,
        loader_service_1.default, resetPassword_service_1.default, navigation_service_1.default, userProfile_1.default];
    exports.default = angular.module('aps.controller.signIn', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.SIGN_IN,
            url: '/signIn',
            controller: 'SignIn as signIn',
            template: signIn_tpl_html_1.default,
            data: { pageTitle: 'Login' }
        });
    }])
        .controller('SignIn', signInCtrl)
        .name;
    function signInCtrl($state, authService, authDataService, notifyService, loaderService, resetPasswordService, navigationService, userProfile, $modal) {
        var vm = this;
        authService.logoff(null);
        userProfile.update(null);
        function signIn() {
            if (vm.form.$invalid) {
                return;
            }
            var promise = authService.login(vm.username, vm.password, vm.code)
                .then(function () {
                userProfile.read();
                var userId = authDataService.getUserId();
                var selectedRole = authDataService.getSelectedRoleLocation();
                if (selectedRole) {
                    var plantId = selectedRole.plant ? selectedRole.plant.id : undefined;
                    var shopId = selectedRole.shop ? selectedRole.shop.id : undefined;
                    var goToDashboard = function () {
                        authService.getUserData().then(function () {
                            $state.go(constant_module_1.States.ADMIN_DASHBOARD, {
                                plantId: plantId,
                                shopId: shopId,
                                userId: userId
                            });
                        });
                    };
                    if (plantId && shopId) {
                        goToDashboard();
                    }
                    else {
                        return navigationService.getNavigation().then(function (navigation) {
                            plantId = navigation.selectedPlant.id;
                            shopId = navigation.selectedShop.id;
                            authDataService.setSelectedRoleLocation(selectedRole.role, navigation.selectedPlant, navigation.selectedShop);
                            goToDashboard();
                        });
                    }
                }
                else {
                    $state.go(constant_module_1.States.SELECT_ROLE, { userId: userId });
                }
            }, function (resp) {
                if (resp.data != null && resp.data.error != null && resp.data.error == "MFA") {
                    vm.form.tokenMode = true;
                    vm.form.message = resp.data.error_description;
                }
                else {
                    notifyService.error('Username or password is incorrect');
                }
            });
            loaderService.loadingPromise(promise);
        }
        function forgotPassword() {
            if (vm.form.username.$invalid) {
                notifyService.error('Please enter your username to reset your password.');
                return;
            }
            resetPasswordService.getResetOptions(vm.username)
                .then(optionsSuccess, notifyService.handleApiErrors);
            function resetByEmail() {
                var submitForgot = resetPasswordService
                    .sendResetPasswordEmail(vm.username)
                    .then(function () {
                    notifyService.success('Your password has been reset. Please check your email.');
                }, notifyService.handleApiErrors);
                loaderService.loadingPromise(submitForgot);
            }
            function resetByQuestion(options) {
                resetByQuestion_1.openResetByQuestion(vm.username, options, $modal);
            }
            function openSelectOptions(options) {
                var result = selectResetOption_1.openSelectResetOption($modal);
                result.then(function (selected) {
                    if (!selected) {
                        return;
                    }
                    if (selected.question) {
                        resetByQuestion(options);
                        return;
                    }
                    if (selected.email) {
                        resetByEmail();
                    }
                });
            }
            function optionsSuccess(options) {
                if (options.canResetWithEmail && options.canResetWithQuestion) {
                    openSelectOptions(options);
                    return;
                }
                if (options.canResetWithEmail) {
                    resetByEmail();
                    return;
                }
                if (options.canResetWithQuestion) {
                    resetByQuestion(options);
                    return;
                }
                notifyService.error('Unable to reset your password. Please check your username or contact an administrator.');
            }
        }
        vm.signIn = signIn;
        vm.forgotPassword = forgotPassword;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(865), __webpack_require__(115), __webpack_require__(6), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, resetByQuestion_tpl_html_1, resetPassword_service_1, notify_service_1, loader_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [resetPassword_service_1.default, notify_service_1.default, loader_service_1.default];
    function openResetByQuestion(userName, options, $modal) {
        return $modal.open({
            template: resetByQuestion_tpl_html_1.default,
            controller: 'ResetByQuestionCtrl as vm',
            resolve: {
                userName: function () { return userName; },
                options: function () { return options; }
            }
        }).result;
    }
    exports.openResetByQuestion = openResetByQuestion;
    var ResetByQuestion = (function () {
        ResetByQuestion.$inject = ["$modalInstance", "resetPasswordService", "notifyService", "loaderService", "userName", "options"];
        function ResetByQuestion($modalInstance, resetPasswordService, notifyService, loaderService, userName, options) {
            this.instance = $modalInstance;
            this.resetPasswordService = resetPasswordService;
            this.notifyService = notifyService;
            this.loaderService = loaderService;
            this.command = {
                userName: userName
            };
            this.question = options.securityQuestionText;
        }
        ResetByQuestion.prototype.changePassword = function () {
            var _this = this;
            if (this.form.$invalid) {
                return;
            }
            var promise = this.resetPasswordService
                .submitQuestionPasswordReset(this.command)
                .then(function () {
                _this.notifyService.success('Password changed. You may now sign in!');
                _this.instance.close();
            }, this.notifyService.handleApiErrors);
            this.loaderService.loadingPromise(promise);
        };
        ResetByQuestion.prototype.close = function () {
            this.instance.close();
        };
        return ResetByQuestion;
    }());
    exports.default = angular.module('aps.controller.resetByQuestion', requires)
        .controller('ResetByQuestionCtrl', ResetByQuestion)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<form name=vm.form ng-submit=vm.changePassword() novalidate> <h2 class=modal-header>Change Password</h2> <div class=container> <label> <strong>User Name:</strong> <span ng-bind=vm.command.userName></span> </label> <label> <strong>Security Question:</strong> <span ng-bind=vm.question></span> </label> <label> <strong>Security Answer:</strong> <input name=answer type=text ng-model=vm.command.questionAnswer required/> <div ng-messages=vm.form.answer.$error ng-if=\"vm.form.answer.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required>Required</div> </div> </label> <label> <strong>Password:</strong> <input name=password type=password ng-model=vm.command.password ng-minlength=8 required/> <div ng-messages=vm.form.password.$error ng-if=\"vm.form.password.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required>Required</div> <div ng-message=minlength>Password must be a minimum of 8 characters long</div> </div> </label> <label> <strong>Confirm Password:</strong> <input name=passwordConfirm type=password ng-model=vm.command.confirmPassword required compare-to=vm.command.password /> <div ng-messages=vm.form.passwordConfirm.$error ng-if=\"vm.form.passwordConfirm.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required>Required</div> <div ng-message=compareTo>Passwords must match</div> </div> </label> <button type=submit>Change Password</button> <button type=button ng-click=vm.close()>Close</button> </div> </form>");

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(867)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, selectResetOption_tpl_html_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function openSelectResetOption($modal) {
        return $modal.open({
            template: selectResetOption_tpl_html_1.default,
            controller: 'SelectResetOptionCtrl as vm'
        }).result;
    }
    exports.openSelectResetOption = openSelectResetOption;
    var SelectResetOptionCtrl = (function () {
        SelectResetOptionCtrl.$inject = ["$modalInstance"];
        function SelectResetOptionCtrl($modalInstance) {
            this.instance = $modalInstance;
        }
        SelectResetOptionCtrl.prototype.question = function () {
            this.instance.close({ question: true });
        };
        SelectResetOptionCtrl.prototype.email = function () {
            this.instance.close({ email: true });
        };
        SelectResetOptionCtrl.prototype.close = function () {
            this.instance.close();
        };
        return SelectResetOptionCtrl;
    }());
    exports.default = angular.module('aps.controller.selectResetOption', [])
        .controller('SelectResetOptionCtrl', SelectResetOptionCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<h2 class=modal-header>Reset Your Password</h2> <div class=container> <div><button type=button ng-click=vm.email()>Send an Email</button></div> <div><button type=button ng-click=vm.question()>Answer Security Question</button></div> <div><button type=button ng-click=vm.close()>Cancel</button></div> </div>");

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"col-lg-12 text-center\"><img class=\"aps-logo signin-logo\"/></div> <div class=signin-panel> <div class=row> <div class=\"large-12 columns\"> <form name=signIn.form ng-submit=signIn.signIn() novalidate> <h4>Sign in</h4> <div ng-if=!signIn.form.tokenMode> <input type=text name=username ng-model=signIn.username placeholder=username required/> <div ng-messages=signIn.form.username.$error ng-if=\"signIn.form.username.$dirty || signIn.form.$submitted\" role=alert> <div ng-message=required class=\"required req-w\"> <div class=arrow-up></div>Required </div> </div> <input type=password ng-model=signIn.password placeholder=password /> <div ng-messages=signIn.form.password.$error ng-if=\"signIn.form.password.$dirty || signIn.form.$submitted\" role=alert> <div ng-message=required class=\"required req-w\"> <div class=arrow-up></div>Required </div> </div> <div style=width:100%;float:left> <a class=left ng-click=signIn.forgotPassword() style=margin-top:15px;font-size:.85em>Forgot Password</a> <button type=submit class=\"button radius right\">Sign in</button> </div> </div> <div ng-if=signIn.form.tokenMode> <input type=hidden name=username ng-model=signIn.username placeholder=username /> <input type=hidden ng-model=signIn.password placeholder=password /> <input type=text ng-model=signIn.code placeholder=code required/> <div ng-messages=signIn.form.code.$error ng-if=\"signIn.form.code.$dirty || signIn.form.$submitted\" role=alert> <div ng-message=required class=\"required req-w\"> <div class=arrow-up></div>Required </div> </div> <label>{{signIn.form.message}}</label> <div style=width:100%;float:left> <button type=submit class=\"button radius right\">Sign in</button> </div> </div> </form> </div> </div> </div>");

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(870), __webpack_require__(872), __webpack_require__(3), __webpack_require__(874), __webpack_require__(52), __webpack_require__(7), __webpack_require__(8), __webpack_require__(4)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, changePassword_controller_1, editUser_controller_1, constant_module_1, users_tpl_html_1, user_service_1, authData_service_1, navigation_service_1, loader_service_1) {
    "use strict";
    usersCtrl.$inject = ["userService", "authDataService", "navigationService", "loaderService", "$modal"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [changePassword_controller_1.default, editUser_controller_1.default, user_service_1.default, authData_service_1.default, navigation_service_1.default,
        loader_service_1.default];
    exports.default = angular.module('aps.controller.users', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.USERS,
            url: '/admin/users',
            controller: 'UsersCtrl as usersCtrl',
            template: users_tpl_html_1.default,
            data: {
                pageTitle: 'Users',
                authorizePlantAdmin: true
            }
        });
    }])
        .controller('UsersCtrl', usersCtrl)
        .name;
    function usersCtrl(userService, authDataService, navigationService, loaderService, $modal) {
        var vm = this;
        vm.permissions = '';
        vm.orderBy = 'userName';
        vm.showDeleted = false;
        vm.isAdmin = authDataService.isAdmin();
        vm.refresh = function () {
            if (!vm.isAdmin && !vm.plant) {
                return;
            }
            loaderService.loadingPromise(userService.getUsers((vm.plant ? vm.plant.id : null), (vm.role ? vm.role.id : null), vm.showDeleted)
                .then(function (users) {
                vm.users = _.filter(users, function (u) {
                    return !u.isSystemUser && (vm.isAdmin || u.plant === vm.plant.name);
                });
                if (vm.permissions) {
                    vm.users = _.filter(vm.users, function (u) {
                        return vm.permissions === 'sysadmin' && u.isSysAdmin || _.includes(u.plantAdmins, vm.permissions);
                    });
                }
            }));
        };
        vm.refresh();
        var securityQuestions;
        userService.getSecurityQuestions()
            .then(function (questions) {
            securityQuestions = questions;
        });
        userService.getAssignableRoles()
            .then(function (data) {
            vm.roles = data;
        });
        navigationService.getNavigation()
            .then(function (navigation) {
            var plants = navigation.plants();
            vm.plants = _.filter(plants, function (plant) {
                return authDataService.isPlantAdmin(plant.id);
            });
            if (!vm.isAdmin) {
                vm.plant = _.first(vm.plants);
                vm.refresh();
            }
        });
        var openEditDialog = function (user) {
            var result = editUser_controller_1.openEditUser({
                id: user ? user.id : undefined,
                questions: securityQuestions,
                roles: vm.roles,
                plants: vm.plants
            }, $modal);
            result.then(function (editedUser) {
                if (editedUser) {
                    switch (editedUser.roles.length) {
                        case 0:
                            editedUser.role = 'None';
                            break;
                        case 1:
                            editedUser.role = editedUser.roles[0].roleName;
                            break;
                        default:
                            editedUser.role = 'Multiple';
                            break;
                    }
                    var plants = _.uniq(_.map(_.flatten(_.map(editedUser.roles, 'plants')), 'name'));
                    switch (plants.length) {
                        case 0:
                            editedUser.plant = 'None';
                            break;
                        case 1:
                            editedUser.plant = plants[0];
                            break;
                        default:
                            editedUser.plant = 'Multiple';
                            break;
                    }
                    if (user) {
                        if (editedUser.isDeleted && !vm.showDeleted) {
                            _.remove(vm.users, user);
                            return;
                        }
                        _.assign(user, editedUser);
                        return;
                    }
                    vm.users.push(editedUser);
                }
            });
        };
        vm.addUser = function () {
            openEditDialog(undefined);
        };
        vm.editUser = function (user) {
            openEditDialog(user);
        };
        vm.changePassword = function (user) {
            changePassword_controller_1.openAdminChangePassword(user, $modal);
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(4), __webpack_require__(6), __webpack_require__(52), __webpack_require__(871)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, loader_service_1, notify_service_1, user_service_1, changePassword_tpl_html_1) {
    "use strict";
    adminChangePasswordCtrl.$inject = ["$modalInstance", "loaderService", "notifyService", "userService", "user"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, notify_service_1.default, user_service_1.default];
    function openAdminChangePassword(user, $modal) {
        return $modal.open({
            template: changePassword_tpl_html_1.default,
            controller: 'AdminChangePasswordCtrl as changePasswordCtrl',
            resolve: {
                user: function () {
                    return user;
                }
            }
        }).result;
    }
    exports.openAdminChangePassword = openAdminChangePassword;
    exports.default = angular.module('aps.controller.adminChangePassword', requires)
        .controller('AdminChangePasswordCtrl', adminChangePasswordCtrl)
        .name;
    function adminChangePasswordCtrl($modalInstance, loaderService, notifyService, userService, user) {
        var vm = this;
        vm.user = {
            id: user.id
        };
        vm.userName = user.userName;
        vm.change = function () {
            if (vm.form.$invalid) {
                return;
            }
            loaderService.loadingPromise(userService.changePassword(vm.user)
                .then(function () {
                $modalInstance.close();
                notifyService.success('Password changed for ' + user.userName);
            }, notifyService.handleApiErrors));
        };
        vm.close = function () {
            $modalInstance.close();
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<form name=changePasswordCtrl.form ng-submit=changePasswordCtrl.change() novalidate> <h2 class=modal-header>Change Password</h2> <div class=container> <label> <strong>User Name:</strong> <span ng-bind=changePasswordCtrl.userName></span> </label> <label> <strong>Password:</strong> <input name=password type=password ng-model=changePasswordCtrl.user.password ng-minlength=8 required has-lower has-upper has-number/> <div ng-messages=changePasswordCtrl.form.password.$error ng-if=\"changePasswordCtrl.form.password.$dirty || changePasswordCtrl.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=minlength class=req-w><div class=arrow-up></div>Password must be a minimum of 8 characters long</div> <div ng-message=hasLower class=req-w><div class=arrow-up></div>Password must have one or more lowercase letters</div> <div ng-message=hasUpper class=req-w><div class=arrow-up></div>Password must have one or more uppercase letters</div> <div ng-message=hasNumber class=req-w><div class=arrow-up></div>Password must have one or more numbers</div> </div> </label> <label> <strong>Confirm Password:</strong> </label> <input name=passwordConfirm type=password ng-model=changePasswordCtrl.user.passwordConfirm required compare-to=changePasswordCtrl.user.password /> <div ng-messages=changePasswordCtrl.form.passwordConfirm.$error ng-if=\"changePasswordCtrl.form.passwordConfirm.$dirty || changePasswordCtrl.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=compareTo class=req-w><div class=arrow-up></div>Passwords must match</div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-12 columns\"> <div class=\"right dialog-footer\"> <button type=submit class=button>Change Password</button> <button type=button ng-click=changePasswordCtrl.close() class=\"button secondary\">Close</button> </div> </div> </div> </div> </form>");

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(4), __webpack_require__(6), __webpack_require__(52), __webpack_require__(12), __webpack_require__(8), __webpack_require__(7), __webpack_require__(9), __webpack_require__(873)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, loader_service_1, notify_service_1, user_service_1, newguid_service_1, navigation_service_1, authData_service_1, uiUtility_service_1, editUser_tpl_html_1) {
    "use strict";
    editUserCtrl.$inject = ["$modalInstance", "loaderService", "notifyService", "userService", "newGuidService", "navigationService", "authDataService", "data", "uiUtilityService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, notify_service_1.default, user_service_1.default, newguid_service_1.default, navigation_service_1.default,
        authData_service_1.default, uiUtility_service_1.default];
    function openEditUser(data, $modal) {
        return $modal.open({
            template: editUser_tpl_html_1.default,
            controller: 'EditUserCtrl as vm',
            resolve: {
                data: function () {
                    return data;
                }
            }
        }).result;
    }
    exports.openEditUser = openEditUser;
    exports.default = angular.module('aps.controller.editUser', requires)
        .controller('EditUserCtrl', editUserCtrl)
        .name;
    function editUserCtrl($modalInstance, loaderService, notifyService, userService, newGuidService, navigationService, authDataService, data, uiUtilityService) {
        var vm = this;
        vm.questions = data.questions;
        vm.roles = function () {
            if (!vm.user) {
                return data.roles;
            }
            var roles = [];
            _.forEach(data.roles, function (role) {
                if (_.find(vm.user.roles, { roleId: role.id })) {
                    return;
                }
                roles.push(role);
            });
            return roles;
        };
        vm.selectedRole = _.first(vm.roles());
        navigationService.getNavigation().then(function (nav) {
            vm.plants = [];
            vm.isEdit = false;
            if (data.id) {
                loaderService.loadingPromise(userService.getUser(data.id)
                    .then(function (user) {
                    vm.user = user;
                    vm.user.displayDefectsByNumber = vm.user.displayDefectsByNumber.toString();
                    _.forEach(vm.user.roles, applyRoleFunctions);
                    vm.isEdit = true;
                    vm.selectedRole = _.first(vm.roles());
                    _.forEach(nav.plants(), function (p) {
                        vm.plants.push({ id: p.id, name: p.name, selected: _.includes(user.plantAdmins, p.id) });
                    });
                }));
            }
            else {
                vm.user = {
                    roles: [],
                    isSysAdmin: false,
                    plantAdmins: [],
                    displayDefectsByNumber: true
                };
                _.forEach(nav.plants(), function (p) {
                    vm.plants.push({ id: p.id, name: p.name, selected: false });
                });
                newGuidService.getNewGuid('user').then(function (id) { vm.user.id = id; });
            }
        });
        var applyRoleFunctions = function (role) {
            role.availablePlants = function () {
                if (!role.roleRequiresPlants) {
                    return [];
                }
                var plants = [];
                _.forEach(data.plants, function (plant) {
                    if (_.find(role.plants, { id: plant.id })) {
                        return;
                    }
                    plants.push(plant);
                });
                return plants;
            };
            role.selectedPlant = _.first(role.availablePlants());
            role.addPlant = function () {
                if (!role.selectedPlant) {
                    return;
                }
                role.plants.push(role.selectedPlant);
                role.selectedPlant = _.first(role.availablePlants());
            };
            role.removePlant = function (plant) {
                _.remove(role.plants, plant);
                if (!role.selectedPlant) {
                    role.selectedPlant = _.first(role.availablePlants());
                }
            };
            role.invalid = function () {
                if (role.roleRequiresPlants && role.plants.length === 0) {
                    return 'A minimum of one plant is required for this role';
                }
                return undefined;
            };
        };
        vm.addRole = function () {
            if (!vm.selectedRole) {
                return;
            }
            var userRole = {
                roleId: vm.selectedRole.id,
                roleName: vm.selectedRole.name,
                roleRequiresPlants: vm.selectedRole.requiresPlants,
                roleLocation: vm.selectedRole.location,
                plants: []
            };
            applyRoleFunctions(userRole);
            if (userRole.roleRequiresPlants && userRole.availablePlants().length === 1) {
                userRole.addPlant();
            }
            vm.user.roles.push(userRole);
            vm.selectedRole = _.first(vm.roles());
        };
        vm.removeRole = function (role) {
            _.remove(vm.user.roles, role);
            if (!vm.selectedRole) {
                vm.selectedRole = _.first(vm.roles());
            }
        };
        vm.rolesInvalid = function () {
            return vm.user.roles.length === 0;
        };
        vm.nameChanged = function () {
            if (vm.user.firstName && vm.user.lastName) {
                userService.getGeneratedUserName(vm.user.id, vm.user.firstName, vm.user.lastName).then(function (userName) {
                    vm.user.userName = userName;
                });
            }
            else {
                vm.user.userName = undefined;
            }
        };
        vm.deletedChanged = function () {
            if (!vm.user.isDeleted) {
                return;
            }
            uiUtilityService.confirm('Are you sure you want to disable this user?').then(function (confirmed) {
                vm.user.isDeleted = confirmed;
            });
        };
        vm.save = function () {
            if (vm.form.$invalid ||
                vm.rolesInvalid()) {
                return;
            }
            for (var i = 0; i < vm.user.roles.length; i++) {
                if (vm.user.roles[i].invalid()) {
                    return;
                }
            }
            _.forEach(vm.user.roles, function (role) {
                role.plantIds = _.map(role.plants, function (plant) { return plant.id; });
            });
            vm.user.plantAdmins = [];
            _.forEach(vm.plants, function (p) {
                if (p.selected) {
                    vm.user.plantAdmins.push(p.id);
                }
            });
            if (vm.user.email === '') {
                vm.user.email = null;
            }
            var submit;
            if (vm.isEdit) {
                submit = userService.editUser(vm.user);
            }
            else {
                submit = userService.addUser(vm.user);
            }
            loaderService.loadingPromise(submit.then(function () {
                $modalInstance.close(vm.user);
            }, notifyService.handleApiErrors));
        };
        vm.close = function () {
            $modalInstance.close();
        };
        vm.isSysAdminEnabled = function () {
            return authDataService.isAdmin();
        };
        vm.isPlantAdminEnabled = function (plantId) {
            return !(vm.user && vm.user.isSysAdmin) && authDataService.isPlantAdmin(plantId);
        };
        vm.isSysAdminChanged = function () {
            if (vm.user && vm.user.isSysAdmin) {
                _.forEach(vm.plants, function (p) {
                    p.selected = false;
                });
            }
        };
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<form name=vm.form ng-submit=vm.save() novalidate ng-if=vm.user> <h2 class=modal-header>User</h2> <div class=container> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-6 columns\" ng-if=vm.user.userName> <label> <span class=\"required notated\">*</span>User Name: <span ng-bind=vm.user.userName style=\"float:left;clear:both;width:100%;padding:5px 0 0 7px\"></span> </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-6 columns\"> <label> <span class=\"required notated\">*</span>First Name: <input name=firstName type=text ng-model=vm.user.firstName ng-change=vm.nameChanged() required/> <div ng-messages=vm.form.firstName.$error ng-if=\"vm.form.firstName.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-6 columns\"> <label> <span class=\"required notated\">*</span>Last Name: <input name=lastName type=text ng-model=vm.user.lastName ng-change=vm.nameChanged() required/> <div ng-messages=vm.form.lastName.$error ng-if=\"vm.form.lastName.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-6 columns\" ng-if=!vm.isEdit> <div> <label> <span class=\"required notated\">*</span>Password: <input name=password type=password ng-model=vm.user.password required ng-minlength=8 has-lower has-upper has-number/> <div ng-messages=vm.form.password.$error ng-if=\"vm.form.password.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=minlength class=req-w><div class=arrow-up></div>Password must be a minimum of 8 characters long</div> <div ng-message=hasLower class=req-w><div class=arrow-up></div>Password must have one or more lowercase letters</div> <div ng-message=hasUpper class=req-w><div class=arrow-up></div>Password must have one or more uppercase letters</div> <div ng-message=hasNumber class=req-w><div class=arrow-up></div>Password must have one or more numbers</div> </div> </label> </div> </div> <div class=\"small-6 columns\" ng-if=!vm.isEdit> <label> <span class=\"required notated\">*</span>Confirm Password: <input name=passwordConfirm type=password ng-model=vm.user.passwordConfirm required compare-to=vm.user.password /> <div ng-messages=vm.form.passwordConfirm.$error ng-if=\"vm.form.passwordConfirm.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> <div ng-message=compareTo class=req-w><div class=arrow-up></div>Passwords must match</div> </div> </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-6 columns\"> <label> Email: <input name=email type=email ng-model=vm.user.email /> <div ng-messages=vm.form.email.$error ng-if=\"vm.form.email.$dirty || vm.form.$submitted\" role=alert> <div ng-message=email class=req-w><div class=arrow-up></div>Must be a valid email address</div> </div> </label> </div> <div class=\"small-6 columns\"> <label> Phone Number: <input name=phoneNumber type=tel ng-model=vm.user.phoneNumber /> <div ng-messages=vm.form.phoneNumber.$error ng-if=\"vm.form.phoneNumber.$dirty || vm.form.$submitted\" role=alert> <div ng-message=tel class=req-w><div class=arrow-up></div>Must be a valid telephone number</div> </div> </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-6 columns\"> <label> Security Question: <select name=question ng-model=vm.user.securityQuestionId> <option value=\"\">-- Select a security question --</option> <option ng-repeat=\"question in vm.questions\" value=\"{{question.id}}\">{{question.question}}</option> </select> </label> </div> <div class=\"small-6 columns\" ng-if=vm.user.securityQuestionId> <label> <span class=\"required notated\">*</span>Security Answer: <input name=answer type=text ng-model=vm.user.securityAnswer required/> <div ng-messages=vm.form.answer.$error ng-if=\"vm.form.answer.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-6 columns\"> <label> Defect Display: <select name=displayDefectsAs ng-model=vm.user.displayDefectsByNumber> <option value=true>Display by Number</option> <option value=false>Display by Abbreviation</option> </select> </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns\" ng-if=vm.isEdit> <label> Disable User <input type=checkbox ng-model=vm.user.isDeleted ng-change=vm.deletedChanged() /> </label> </div> <div class=\"small-9 columns\" ng-if=vm.isEdit> <label> Is Token Never Expired <input type=checkbox ng-model=vm.user.isTokenNeverExpired ng-disabled=!vm.isSysAdminEnabled() /> </label> </div> </div> <h4>Admin Permissions</h4> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns\"> <label> <input type=checkbox ng-model=vm.user.isSysAdmin ng-disabled=!vm.isSysAdminEnabled() ng-change=vm.isSysAdminChanged() /> System Admin </label> </div> <div class=\"small-3 columns\" ng-repeat=\"plant in vm.plants\"> <label> <input type=checkbox ng-model=plant.selected ng-disabled=!vm.isPlantAdminEnabled(plant.id) /> {{ plant.name }} </label> </div> <div class=\"small-3 columns\" ng-if=\"vm.plants.length < 7\"></div> </div> <h4><span class=\"required notated\">*</span>Roles</h4> <div class=req-w ng-if=\"vm.rolesInvalid() && vm.form.$submitted\"> <div class=arrow-up></div> A role is required for a user </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div ng-if=\"vm.roles().length > 0\"> <div class=\"small-6 columns\"> <select name=role ng-model=vm.selectedRole ng-options=\"role.name for role in vm.roles() | orderBy: 'name'\" class=pull-left style=float:left;width:70%> </select> <button type=button type=\"button tiny\" style=\"float:left;margin:-1px 0 0 10px;font-size:.65em;padding:12px 15px\" ng-click=vm.addRole() class=\"button small\">Add Role</button> </div> </div> </div> <ul class=\"row user-manage\" style=\"margin:0 -20px;width:auto;list-style:none\"> <li ng-repeat=\"role in vm.user.roles\" class=user-block> <strong>{{role.roleName}}</strong> <a ng-click=vm.removeRole(role) style=font-size:.65em><i class=\"fa fa-times\" style=color:red></i> Remove Role</a> <div class=req-w ng-if=\"role.invalid() && vm.form.$submitted\" style=top:2px> <div class=arrow-up></div> {{role.invalid()}} </div> <ul ng-if=\"role.plants && role.plants.length > 0\"> <li ng-repeat=\"plant in role.plants\" style=font-size:1em> {{plant.name}} <a ng-click=role.removePlant(plant) style=font-size:.65em><i class=\"fa fa-times\" style=color:red></i> Remove Plant</a> </li> </ul> <div ng-if=\"role.availablePlants().length > 0\" style=margin-top:10px> <select ng-model=role.selectedPlant ng-options=\"plant.name for plant in role.availablePlants()\" style=float:left;width:70%> </select><button type=button ng-click=role.addPlant() class=\"button tiny\" style=\"float:left;margin:-1px 0 0 10px;font-size:.65em;padding:12px 15px\">Add Plant</button> </div> </li> </ul> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-12 columns\"> <div class=\"right dialog-footer\"> <button type=submit class=button>Save</button> <button type=button ng-click=vm.close() class=\"button secondary\">Close</button> </div> </div> </div> </div> </form>");

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <div class=body-header> <h2>Users</h2> <button class=\"button small\" ng-click=usersCtrl.addUser() style=position:relative;top:20px>Add User</button> </div> <label class=\"small-3 columns\"> Plant: <select ng-model=usersCtrl.plant ng-options=\"plant.name for plant in usersCtrl.plants\" ng-change=usersCtrl.refresh()> <option value=\"\" ng-if=usersCtrl.isAdmin>--- Any Plant ---</option> </select> </label> <label class=\"small-3 columns\"> Role: <select ng-model=usersCtrl.role ng-options=\"role.name for role in usersCtrl.roles | orderBy: 'name'\" ng-change=usersCtrl.refresh()> <option value=\"\">--- Any Role ---</option> </select> </label> <label class=\"small-3 columns\"> Permissions: <select ng-model=usersCtrl.permissions ng-change=usersCtrl.refresh()> <option value=\"\">--- Any Permissions ---</option> <option value=sysadmin>System Admin</option> <option ng-repeat=\"p in usersCtrl.plants\" value=\"{{p.id}}\">{{p.name}} Admin</option> </select> </label> <label class=\"small-3 columns\"> Sort by: <select ng-model=usersCtrl.orderBy> <option value=userName>User Name</option> <option value=\"firstName + lastName\">First Name</option> <option value=\"lastName + firstName\">Last Name</option> <option value=email>E-mail</option> <option value=\"role + userName\">Role</option> <option value=\"plant + userName\">Plant</option> </select> </label> <label class=\"small-3 columns\"> <br/> <input type=checkbox ng-model=usersCtrl.showDeleted ng-change=usersCtrl.refresh() /> Show Disabled Users </label> <table class=history-t> <thead> <tr> <th>User Name</th> <th>First Name</th> <th>Last Name</th> <th>E-mail</th> <th>Phone Number</th> <th>Role</th> <th>Plant</th> <th></th> <th></th> </tr> </thead> <tbody> <tr ng-repeat=\"user in usersCtrl.users | orderBy: usersCtrl.orderBy\"> <td>{{user.userName}}</td> <td>{{user.firstName}}</td> <td>{{user.lastName}}</td> <td>{{user.email}}</td> <td>{{user.phoneNumber}}</td> <td>{{user.role}}</td> <td>{{user.plant}}</td> <td><button type=button class=\"button tiny\" style=margin:0 ng-click=usersCtrl.editUser(user)>Edit User</button></td> <td><button type=button class=\"button tiny\" style=margin:0 ng-click=usersCtrl.changePassword(user)>Change Password</button></td> </tr> </tbody> </table> </div>");

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(3), __webpack_require__(876), __webpack_require__(4), __webpack_require__(116), __webpack_require__(877), __webpack_require__(879), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, constant_module_1, TiamaDefectMappings_tpl_html_1, loader_service_1, tiamaDefectMapping_service_1, editTiamaDefectMapping_controller_1, addTiamaDefectMapping_controller_1, _) {
    "use strict";
    tiamaDefectMappingsCtrl.$inject = ["$modal", "loaderService", "tiamaDefectMappingService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, tiamaDefectMapping_service_1.default, editTiamaDefectMapping_controller_1.default, addTiamaDefectMapping_controller_1.default];
    exports.default = angular.module('aps.controller.tiamaDefectMappings', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.VIEW_TIAMA_DEFECT_MAPPINGS,
            url: '/tiamaDefectMappings',
            controller: 'tiamaDefectMappingsCtrl as vm',
            template: TiamaDefectMappings_tpl_html_1.default,
            data: {
                pageTitle: 'Tiama Defect Mappings'
            }
        });
    }])
        .controller('tiamaDefectMappingsCtrl', tiamaDefectMappingsCtrl)
        .name;
    function tiamaDefectMappingsCtrl($modal, loaderService, tiamaDefectMappingService) {
        var vm = {};
        vm.displayTiamaDefectMappings = function () {
            loaderService.loadingPromise(tiamaDefectMappingService
                .getTiamaDefectMappings().then(function (data) {
                vm.tiamaDefectMappings = data;
            }));
            return;
        };
        vm.editTiamaDefect = function (tiamaDefectId) {
            var result = editTiamaDefectMapping_controller_1.openEditTiamaDefectMapping({
                tiamaDefectId: tiamaDefectId
            }, $modal);
            result.then(function (data) {
                if ((data || '') !== '') {
                    if ((data.action || '') !== '') {
                        switch (data.action) {
                            case 'return':
                                updateEditedTiamaDefect(data.tiamaDefectMapping);
                                break;
                            default:
                                break;
                        }
                    }
                }
            });
        };
        vm.addTiamaDefectMapping = function () {
            var result = addTiamaDefectMapping_controller_1.openAddTiamaDefectMapping($modal);
            result.then(function (data) {
                if ((data || '') !== '') {
                    var item = {};
                    item.id = data.tiamaDefectMapping.id;
                    item.machineType = data.tiamaDefectMapping.machineType;
                    item.sensor = data.tiamaDefectMapping.sensor;
                    item.counter = data.tiamaDefectMapping.counter;
                    item.defectTypeId = data.tiamaDefectMapping.defectTypeId;
                    item.defectTypeName = data.tiamaDefectMapping.defectTypeName;
                    vm.tiamaDefectMappings.push(item);
                }
            });
        };
        var updateEditedTiamaDefect = function (tiamaDefectMapping) {
            if ((tiamaDefectMapping || '') !== '') {
                var tiamaDefectMappingUpdated = _.find(vm.tiamaDefectMappings, function (item) {
                    return item.id === tiamaDefectMapping.id;
                });
                if ((tiamaDefectMappingUpdated || '') !== '') {
                    tiamaDefectMappingUpdated.id = tiamaDefectMapping.id;
                    tiamaDefectMappingUpdated.machineType = tiamaDefectMapping.machineType;
                    tiamaDefectMappingUpdated.sensor = tiamaDefectMapping.sensor;
                    tiamaDefectMappingUpdated.counter = tiamaDefectMapping.counter;
                    tiamaDefectMappingUpdated.defectTypeId = tiamaDefectMapping.defectTypeId;
                    tiamaDefectMappingUpdated.defectTypeName = tiamaDefectMapping.defectTypeName;
                }
            }
        };
        vm.displayTiamaDefectMappings();
        return vm;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <div class=body-header> <h2>Tiama Defect Mappings</h2> <a href=\"\" class=\"button small\" ng-click=vm.addTiamaDefectMapping()>Add A Tiama Defect</a> </div> <table class=history-t> <tr> <thead> <th>Machine Type</th> <th>Sensor</th> <th>Counter</th> <th>Defect Type Name</th> </thead> </tr> <tr ng-repeat=\"defect in vm.tiamaDefectMappings\" ng-click=vm.editTiamaDefect(defect.id)> <td ng-bind=defect.machineType></td> <td ng-bind=defect.sensor></td> <td ng-bind=defect.counter></td> <td ng-bind=defect.defectTypeName></td> </tr> </table> </div> ");

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(4), __webpack_require__(116), __webpack_require__(6), __webpack_require__(25), __webpack_require__(878), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, loader_service_1, tiamaDefectMapping_service_1, notify_service_1, defectType_service_1, editTiamaDefectMapping_tpl_html_1, aps_enums_1) {
    "use strict";
    editTiamaDefectMappingCtrl.$inject = ["$modalInstance", "data", "loaderService", "tiamaDefectMappingService", "notifyService", "defectTypeService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, tiamaDefectMapping_service_1.default, notify_service_1.default, defectType_service_1.default];
    exports.default = angular.module('aps.controller.editTiamaDefectMapping', requires)
        .controller('EditTiamaDefectMappingCtrl', editTiamaDefectMappingCtrl)
        .name;
    function openEditTiamaDefectMapping(data, $modal) {
        return $modal.open({
            template: editTiamaDefectMapping_tpl_html_1.default,
            controller: 'EditTiamaDefectMappingCtrl as vm',
            resolve: {
                data: function () {
                    return data;
                }
            }
        }).result;
    }
    exports.openEditTiamaDefectMapping = openEditTiamaDefectMapping;
    function editTiamaDefectMappingCtrl($modalInstance, data, loaderService, tiamaDefectMappingService, notifyService, defectTypeService) {
        var vm = this;
        vm.tiamaDefectId = data.tiamaDefectId;
        vm.machineTypes = [
            { value: aps_enums_1.apsEnums.DataPointConfigType.MX4Counter, text: 'MX4' },
            { value: aps_enums_1.apsEnums.DataPointConfigType.MultiCounter, text: 'MULTI' },
            { value: aps_enums_1.apsEnums.DataPointConfigType.McalCounter, text: 'MCAL' }
        ];
        var promise1 = defectTypeService.getDefectTypesAll()
            .then(function (defectTypesAll) {
            vm.defectTypes = defectTypesAll;
        }, notifyService.handleApiErrors);
        loaderService.loadingPromise(promise1);
        var promise = tiamaDefectMappingService.getTiamaDefectMapping(vm.tiamaDefectId)
            .then(function (tiamaDefectMapping) {
            vm.tiamaDefectMapping = tiamaDefectMapping;
        }, notifyService.handleApiErrors);
        loaderService.loadingPromise(promise);
        var postTiamaDefectMapping = function () {
            var promise = tiamaDefectMappingService.updateTiamaDefectMapping(vm.tiamaDefectMapping)
                .then(function () {
                vm.tiamaDefectMapping.defectTypeName = getDefectTypeName(vm.tiamaDefectMapping.defectTypeId);
                var data = {
                    action: 'return',
                    tiamaDefectMapping: vm.tiamaDefectMapping
                };
                $modalInstance.close(data);
            }, notifyService.handleApiErrors);
            loaderService.loadingPromise(promise);
        };
        var getDefectTypeName = function (defectId) {
            var defectType = _.find(vm.defectTypes, function (item) {
                return item.key === defectId;
            });
            if ((defectType || '') !== '') {
                return defectType.value;
            }
        };
        vm.submitTiamaDefectMapping = function () {
            if (vm.form.$invalid) {
                return;
            }
            postTiamaDefectMapping();
        };
        vm.cancel = function () {
            $modalInstance.close({
                action: 'close',
                tiamaDefectId: vm.tiamaDefectId
            });
        };
        return vm;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=edit> <h2 class=modal-header> Editing Tiama Defect </h2> <form name=vm.form ng-submit=vm.submitTiamaDefectMapping() novalidate> <div class=row style=\"margin:1em -30px;width:auto\"> <div class=\"small-6 columns\"> <span class=\"required notated\">*</span>Machine Type <select ng-model=vm.tiamaDefectMapping.machineType name=machineTypes required> <option value=\"{{types.text}}\" ng-repeat=\"types in vm.machineTypes | orderBy : 'text'\">{{types.text}}</option> </select> </div> <div class=\"small-6 columns\"> <span class=\"required notated\">*</span>Defect Type <select ng-model=vm.tiamaDefectMapping.defectTypeId name=defectTypes required> <option value=\"{{types.key}}\" ng-repeat=\"types in vm.defectTypes | orderBy : 'value'\">{{types.value}}</option> </select> </div> </div> <div class=row style=\"margin:1em -30px;width:auto\"> <div class=\"small-6 columns\"> <span class=\"required notated\">*</span>Sensor <input type=text name=sensor ng-model=vm.tiamaDefectMapping.sensor required/> </div> <div class=\"small-6 columns\"> <span class=\"required notated\">*</span>Counter <input type=text name=counter ng-model=vm.tiamaDefectMapping.counter required/> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-12 columns\"> <span class=required>* Required Fields</span> <div class=\"right dialog-footer\"> <button type=submit class=button>Save</button> <button type=button class=\"button secondary\" ng-click=vm.cancel()>Close</button> </div> </div> </div> </form> </div> ");

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(4), __webpack_require__(12), __webpack_require__(116), __webpack_require__(9), __webpack_require__(6), __webpack_require__(25), __webpack_require__(880), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, loader_service_1, newguid_service_1, tiamaDefectMapping_service_1, uiUtility_service_1, notify_service_1, defectType_service_1, addTiamaDefectMapping_tpl_html_1, aps_enums_1) {
    "use strict";
    addTiamaDefectMappingCtrl.$inject = ["$modalInstance", "loaderService", "newGuidService", "tiamaDefectMappingService", "notifyService", "defectTypeService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default,
        uiUtility_service_1.default,
        tiamaDefectMapping_service_1.default,
        notify_service_1.default,
        newguid_service_1.default,
        defectType_service_1.default];
    function openAddTiamaDefectMapping($modal) {
        return $modal.open({
            template: addTiamaDefectMapping_tpl_html_1.default,
            controller: 'AddTiamaDefectMappingCtrl as vm'
        }).result;
    }
    exports.openAddTiamaDefectMapping = openAddTiamaDefectMapping;
    exports.default = angular.module('aps.controller.addTiamaDefectMapping', requires)
        .controller('AddTiamaDefectMappingCtrl', addTiamaDefectMappingCtrl)
        .name;
    function addTiamaDefectMappingCtrl($modalInstance, loaderService, newGuidService, tiamaDefectMappingService, notifyService, defectTypeService) {
        var vm = this;
        vm.tiamaDefectMapping = {};
        newGuidService.getNewGuid('tiamaDefectMapping').then(function (data) {
            vm.tiamaDefectMapping.id = data;
        });
        vm.machineTypes = [
            { value: aps_enums_1.apsEnums.EquipmentType.MX4, text: 'MX4' },
            { value: aps_enums_1.apsEnums.EquipmentType.Multi, text: 'MULTI' },
            { value: aps_enums_1.apsEnums.EquipmentType.Mcal, text: 'MCAL' }
        ];
        var promise1 = defectTypeService.getDefectTypesAll()
            .then(function (defectTypesAll) {
            vm.defectTypes = defectTypesAll;
        }, notifyService.handleApiErrors);
        loaderService.loadingPromise(promise1);
        var postTiamaDefectMapping = function () {
            var promise = tiamaDefectMappingService.addTiamaDefectMapping(vm.tiamaDefectMapping)
                .then(function () {
                vm.tiamaDefectMapping.defectTypeName = getDefectTypeName(vm.tiamaDefectMapping.defectTypeId);
                var data = {
                    action: 'return',
                    tiamaDefectMapping: vm.tiamaDefectMapping
                };
                $modalInstance.close(data);
            }, notifyService.handleApiErrors);
            loaderService.loadingPromise(promise);
        };
        var getDefectTypeName = function (defectId) {
            var defectType = _.find(vm.defectTypes, function (item) {
                return item.key === defectId;
            });
            if ((defectType || '') !== '') {
                return defectType.value;
            }
        };
        vm.submitTiamaDefectMapping = function () {
            if (vm.form.$invalid) {
                return;
            }
            postTiamaDefectMapping();
        };
        vm.cancel = function () {
            $modalInstance.close();
        };
        return vm;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=edit> <h2 class=modal-header> Add Tiama Defect </h2> <form name=vm.form ng-submit=vm.submitTiamaDefectMapping() novalidate> <div class=row style=\"margin:1em -30px;width:auto\"> <div class=\"small-6 columns\"> <span class=\"required notated\">*</span>Machine Type <select ng-model=vm.tiamaDefectMapping.machineType name=machineTypes required> <option value=\"{{types.text}}\" ng-repeat=\"types in vm.machineTypes | orderBy : 'text'\">{{types.text}}</option> </select> </div> <div class=\"small-6 columns\"> <span class=\"required notated\">*</span>Defect Type <select ng-model=vm.tiamaDefectMapping.defectTypeId name=defectTypes required> <option value=\"{{types.key}}\" ng-repeat=\"types in vm.defectTypes | orderBy : 'value'\">{{types.value}}</option> </select> </div> </div> <div class=row style=\"margin:1em -30px;width:auto\"> <div class=\"small-6 columns\"> <span class=\"required notated\">*</span>Sensor <input type=text name=sensor ng-model=vm.tiamaDefectMapping.sensor required/> </div> <div class=\"small-6 columns\"> <span class=\"required notated\">*</span>Counter <input type=text name=counter ng-model=vm.tiamaDefectMapping.counter required/> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-12 columns\"> <span class=required>* Required Fields</span> <div class=\"right dialog-footer\"> <button type=button class=\"button secondary\" ng-click=vm.cancel()>Close</button> <button type=submit class=button>Add Tiama Defect</button> </div> </div> </div> </form> </div> ");

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(3), __webpack_require__(882), __webpack_require__(7), __webpack_require__(311), __webpack_require__(2), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, constant_module_1, plantPerformance_tpl_html_1, authData_service_1, plantPerformance_service_1, _, moment) {
    "use strict";
    plantPerformanceConfig.$inject = ["$stateProvider"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [authData_service_1.default, plantPerformance_service_1.default];
    function plantPerformanceConfig($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.PLANT_PERFORMANCE,
            url: '/plant-performance-dashboard',
            controller: 'PlantPerformanceCtrl as vm',
            template: plantPerformance_tpl_html_1.default,
            data: { pageTitle: 'Company Performance' }
        });
    }
    var PlantPerformanceCtrl = (function () {
        PlantPerformanceCtrl.$inject = ["locationsService", "navigationService", "loaderService", "plantPerformanceService", "$state"];
        function PlantPerformanceCtrl(locationsService, navigationService, loaderService, plantPerformanceService, $state) {
            var _this = this;
            this.helpText = "  \n    <div class=\"header\">\n      Performance Dashboard\n    </div>\n    <div class=\"subheader\">\n      <span> Data Source:  </span>\n      <span class=\"detail\">Legacy AS400</span>\n    </div>             \n    <div class=\"subheader\">\n      <u>Plant/Tank</u>:\n    </div>  \n    <div class=\"detail\">\n      At the plant or tank level, <b>Pack To Melt (PTM)</b> is displayed for the most recent \n      date that data is available (see upper right of screen for exact date).  \n      This is displayed in the <b>Daily PTM</b> column (e.g. \"1/29 PTM\"), the <b>MTD PTM</b> column (e.g. \"JAN PTM\"), and \n      the <b>YTD PTM</b> column (e.g. \"2020 PTM\").\n      The <b>previous year</b> value is listed for comparison in the <b>PY</b> columns (e.g. \"Jan 2019\" and \"2019 PTM\").<br/><br/>\n      <span class=\"formula\">PTM = Packed Tons / Melted Tons * 100</span><br/>\n      <span class=\"footnote\">[where Melted Tons > 0]</span><br/><br/>\n      Melted Tons is taken from the Materials Usage / Commodity File in the legacy system, summarized by plant, tank, and date.<br/><br/>\n      <span class=\"formula\">Melted Tons = SUM(LBS * Yield / 100 / 2000)</span><br/>\n      <span class=\"footnote\">[where LBS is # of batcheds * pounds of material and Yield \n        is % of material consumed from Commodity File]</span><br/><br/>\n      Packed Tons is taken from the Job Records system in legacy, summarized by plant, tank, and date.<br/><br/>\n      <span class=\"formula\">Packed Tons = SUM(Weight * Gross * .0045)</span><br/>\n      <span class=\"footnote\">[where .0045 is 144/32000 to convert oz-gross to tons]</span>\n    </div>         \n    <div class=\"detail\">\n      <b>Annual Operating Plan (AOP)</b> values are also displayed for MTD and YTD comparisons.  The AOP values are pulled from \n      yearly spreadsheets maintained at corporate.\n    </div>  \n    <div class=\"detail\">\n      The <b>MTD PTM</b> and <b>YTD PTM</b> columns are also color coded at the plant level to indicate the current % of AOP. \n      The values will be highlighted in <span class=\"red\">red</span> for any \n      percent <b>below 100</b> and <span class=\"green\">green</span> for \n      anything <b>100% and above</b>.<br/><br/>\n      <span class=\"formula\">% of AOP = PTM / AOP * 100</span>\n    </div>\n    <div class=\"subheader\">\n        <u>Shop</u>:\n    </div>   \n    <div class=\"detail\">\n      At the shop level, Percent Pack is displayed for the most recent date that data is available (see upper \n        right of screen for exact date)\n      This is displayed in the <b>Daily PTM</b> column, the <b>MTD PTM</b> column (PTM percent for the month), and \n      the <b>YTD PTM</b> column (PTM percent for the year).\n      The <b>previous year</b> value is listed for comparison in the <b>PY</b> columns.<br/><br/>\n      Percent Pack is calculated from data in the Job Records system in legacy.  All records where \n      speed > 0 and production hours > 0 are included.<br/><br/>\n      <span class=\"formula\">% Pack = rounded to tenths(Gross / Shearcuts * 100)</span><br/>\n      <span class=\"footnote\">[where shearcuts > 0]</span><br/><br/>\n      <span class=\"formula\">Shearcuts = Actual Speed * 60 * Actual Hours / 144</span>\n    </div>  \n    <div class=\"detail\">\n      <b>Annual Operating Plan (AOP)</b> values are also displayed for MTD and YTD comparisons.  The AOP values are pulled from \n      yearly spreadsheets maintained at corporate.\n    </div>  \n    <div class=\"detail\">\n      The <b>MTD PTM</b> and <b>YTD PTM</b> columns are also color coded at the plant level to indicate the current % of AOP. \n      The values will be highlighted in <span class=\"red\">red</span> for any \n      percent <b>below 100</b> and <span class=\"green\">green</span> for anything <b>100% and above</b>.<br/><br/>\n      <span class=\"formula\">% of AOP = PTM (in this case Percent Pack) / AOP * 100</span>\n    </div>\n  ";
            this.$state = $state;
            var promise = locationsService.initialize().then(function () {
                return navigationService.getNavigation().then(function (nav) {
                    _this.navigation = nav;
                    _this.plantList = nav.plants().filter(function (x) { return !x.isDisabled; });
                    plantPerformanceService.getSnapshotData().then(function (data) {
                        _this.dataItems = data.snapshotDataItems.map(function (x) { return _this.calculatePercents(x); });
                        _this.plantData = _.filter(_this.dataItems, function (plants) {
                            return plants.shopId == null && plants.tankId == null && _this.plantList.some(function (x) { return x.name === plants.plantName; });
                        });
                        _this.plantVisiblity = _this.plantData.map(function (x) { return ({ plantName: x.plantName, isVisible: true }); });
                        _this.dailyPackDate = data.dataThru;
                        _this.yearFormat = moment(_this.dailyPackDate).year().toString();
                        _this.monthFormat = moment(_this.dailyPackDate).format('MMM').toUpperCase();
                        _this.dayFormat = moment(_this.dailyPackDate).format('M/DD');
                        _this.pyFormat = (moment(_this.dailyPackDate).year() - 1).toString();
                    });
                });
            });
            loaderService.loadingPromise(promise);
        }
        PlantPerformanceCtrl.prototype.calculatePercents = function (item) {
            item.percentOfAopMonth = ((Math.round(item.monthPercent * 10) / 10) / (Math.round(item.aopMonth * 10) / 10)) * 100;
            item.percentOfAopYear = ((Math.round(item.yearPercent * 10) / 10) / (Math.round(item.aopYear * 10) / 10)) * 100;
            item.monthStatus = this.getStatus(item.percentOfAopMonth);
            item.yearStatus = this.getStatus(item.percentOfAopYear);
            return item;
        };
        PlantPerformanceCtrl.prototype.getStatus = function (percent) {
            if (percent >= 100) {
                return "pass";
            }
            return "fail";
        };
        PlantPerformanceCtrl.prototype.goToPlant = function (plantLocationId, tankNumber, shopNumber) {
            var selectedPlant = _.find(this.plantList, function (plants) { return plants.id === plantLocationId; });
            this.navigation.selectPlant(selectedPlant);
            if (shopNumber != null) {
                this.navigation.selectPlantShop(selectedPlant, _.find(selectedPlant.shops, function (shops) { return shops.name === shopNumber; }));
            }
            var selectedLocation = shopNumber != null ? "Shop " + shopNumber : tankNumber != null ? "Tank " + tankNumber : "";
            this.$state.go(constant_module_1.States.PLANT_PERFORMANCE_CHARTS, { selectedLocation: selectedLocation });
        };
        PlantPerformanceCtrl.prototype.getTanks = function (plantId) {
            return _.filter(this.dataItems, function (items) { return items.plantId === plantId && items.tankId != null && items.shopId == null; });
        };
        PlantPerformanceCtrl.prototype.getShops = function (plantId, tankId) {
            return _.filter(this.dataItems, function (items) { return items.plantId === plantId && items.tankId === tankId && items.shopId != null; });
        };
        PlantPerformanceCtrl.prototype.displayPlant = function (plantName) {
            return _.find(this.plantVisiblity, function (plants) { return plants.plantName === plantName; }).isVisible;
        };
        PlantPerformanceCtrl.prototype.togglePlantVisiblity = function (plantName) {
            _.find(this.plantVisiblity, function (plants) { return plants.plantName === plantName; }).isVisible =
                !_.find(this.plantVisiblity, function (plants) { return plants.plantName === plantName; }).isVisible;
        };
        PlantPerformanceCtrl.prototype.showHelp = function () {
            this.toggleHelpWindow();
        };
        PlantPerformanceCtrl.prototype.toggleHelpWindow = function () {
            this.showHelpWindow = !this.showHelpWindow;
        };
        return PlantPerformanceCtrl;
    }());
    exports.default = angular.module('aps.controller.plantperformancedashboard', requires)
        .config(plantPerformanceConfig)
        .controller('PlantPerformanceCtrl', PlantPerformanceCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <div class=plantPerformance> <div class=body-header> <h2>Company Performance</h2> <div class=aopLegend> <span class=pass>PTM</span> &gt;= 100% of AOP &nbsp;&nbsp;&nbsp; <span class=fail>PTM</span> &lt; 100% of AOP </div> <div class=packDate>as of {{vm.dailyPackDate}}</div> </div> <hr> </div> <div class=plantPerformanceSnapshot ng-if=\"vm.plantData && vm.plantData.length\"> <div class=snapshotHeader> <div class=snapshotHeaderContent> <div class=\"small-2 columns helpcircle\"> <a ng-click=vm.showHelp()><i class=\"fa fa-info-circle fa-bigger\"></i></a> <div class=notation><span class=link>**</span> shop is PTP, not PTM</div> </div> <div class=\"small-1 columns plantPerformanceColumnHeader leftBorder rightBorder\">{{vm.dayFormat}} PTM</div> <div class=\"small-3 columns plantPerformanceColumnHeader\">{{vm.monthFormat}} PTM</div> <div class=\"small-1 columns plantPerformanceColumnHeader secondary\">{{vm.monthFormat}} AOP</div> <div class=\"small-1 columns plantPerformanceColumnHeader secondary rightBorder\">{{vm.monthFormat}} {{vm.pyFormat}}</div> <div class=\"small-3 columns plantPerformanceColumnHeader\">{{vm.yearFormat}} PTM</div> <div class=\"small-1 columns plantPerformanceColumnHeader secondary\">{{vm.yearFormat}} AOP</div> <div class=\"small-1 columns plantPerformanceColumnHeader secondary\">{{vm.pyFormat}} PTM</div> </div> </div> <div class=contentPadding> <div ng-repeat=\"plant in vm.plantData | orderBy : 'plantName'\" class=plant-dash> <div class=\"plantPerformanceDataItemRow plantRow\"> <div class=\"small-2 columns plantName\"> <i class=\"fa fa-caret-up caret\" ng-if=vm.displayPlant(plant.plantName) ng-click=vm.togglePlantVisiblity(plant.plantName)></i> <i class=\"fa fa-caret-down caret\" ng-if=!vm.displayPlant(plant.plantName) ng-click=vm.togglePlantVisiblity(plant.plantName)></i> <a ng-click=vm.goToPlant(plant.plantLocationId) style=font-size:.9em>{{::plant.plantName}}</a> </div> <div class=\"small-1 columns plantPerformanceDataItem rightBorder leftBorder\">{{::plant.dayPercent | number: 1}}</div> <div class=\"small-3 columns plantPerformanceDataItem\"> <span class=\"{{::plant.monthStatus}}\">{{::plant.monthPercent | number: 1}}</span> </div> <div class=\"small-1 columns plantPerformanceDataItem secondary\">{{::plant.aopMonth | number: 1}}</div> <div class=\"small-1 columns plantPerformanceDataItem secondary rightBorder\">{{::plant.pyMonthPercent | number: 1}}</div> <div class=\"small-3 columns plantPerformanceDataItem\"> <span class=\"{{::plant.yearStatus}}\">{{::plant.yearPercent | number: 1}}</span> </div> <div class=\"small-1 columns plantPerformanceDataItem secondary\">{{::plant.aopYear | number: 1}}</div> <div class=\"small-1 columns plantPerformanceDataItem secondary\">{{::plant.pyYearPercent | number: 1}}</div> </div> <div ng-repeat=\"tank in vm.getTanks(plant.plantId) | orderBy : 'tankId'\" ng-if=vm.displayPlant(plant.plantName) class=plantPerformanceDataItemRow> <div class=\"plantPerformanceDataItemRow tankRow\"> <div class=\"small-2 columns tankColumn\"><a ng-click=\"vm.goToPlant(plant.plantLocationId, tank.tankId)\">Tank {{::tank.tankId}}</a></div> <div class=\"small-1 columns plantPerformanceDataItem rightBorder leftBorder\">{{::tank.dayPercent | number: 1}}</div> <div class=\"small-3 columns plantPerformanceDataItem\"> <span class=\"{{::tank.monthStatus}}\">{{::tank.monthPercent | number: 1}}</span> </div> <div class=\"small-1 columns plantPerformanceDataItem secondary\">{{::tank.aopMonth | number: 1}}</div> <div class=\"small-1 columns plantPerformanceDataItem secondary rightBorder\">{{::tank.pyMonthPercent | number: 1}}</div> <div class=\"small-3 columns plantPerformanceDataItem\"> <span class=\"{{::tank.yearStatus}}\">{{::tank.yearPercent | number: 1}}</span> </div> <div class=\"small-1 columns plantPerformanceDataItem secondary\">{{::tank.aopYear | number: 1}}</div> <div class=\"small-1 columns plantPerformanceDataItem secondary\">{{::tank.pyYearPercent | number: 1}}</div> </div> <div ng-repeat=\"shop in vm.getShops(plant.plantId, tank.tankId) | orderBy : 'shopId'\" class=plantPerformanceDataItemRow> <div class=\"plantPerformanceDataItemRow shopRow\"> <div class=\"small-2 columns shopColumn\"><a ng-click=\"vm.goToPlant(plant.plantLocationId, tank.tankId, shop.shopId)\">Shop {{::shop.shopId}} **</a></div> <div class=\"small-1 columns plantPerformanceDataItem rightBorder leftBorder\">{{::shop.dayPercent | number: 1}}</div> <div class=\"small-3 columns plantPerformanceDataItem\"> <span class=\"{{::shop.monthStatus}}\">{{::shop.monthPercent | number: 1}}</span> </div> <div class=\"small-1 columns plantPerformanceDataItem secondary\">{{::shop.aopMonth | number: 1}}</div> <div class=\"small-1 columns plantPerformanceDataItem secondary rightBorder\">{{::shop.pyMonthPercent | number: 1}}</div> <div class=\"small-3 columns plantPerformanceDataItem\"> <span class=\"{{::shop.yearStatus}}\">{{::shop.yearPercent | number: 1}}</span> </div> <div class=\"small-1 columns plantPerformanceDataItem secondary\">{{::shop.aopYear | number: 1}}</div> <div class=\"small-1 columns plantPerformanceDataItem secondary\">{{::shop.pyYearPercent | number: 1}}</div> </div> </div> </div> </div> <div style=padding-bottom:10px> &nbsp; </div> </div> </div> <div ng-if=\"!vm.plantData || !vm.plantData.length\" style=padding-top:70px> Loading data... </div> <div ng-if=vm.showHelpWindow class=charthelpdetails> <div class=windowclose> <a><i class=\"fa fa-times-circle fa-bigger\" ng-click=vm.toggleHelpWindow()></i></a> </div> <div class=tooltiptext ng-bind-html=vm.helpText> </div> </div> </div> ");

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(3), __webpack_require__(884), __webpack_require__(7), __webpack_require__(34), __webpack_require__(117), __webpack_require__(312), __webpack_require__(885), __webpack_require__(311), __webpack_require__(2), __webpack_require__(5), __webpack_require__(1), __webpack_require__(886)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, constant_module_1, plantPerformanceCharts_tpl_html_1, authData_service_1, Highcharts, highcharts_more_1, solid_gauge_1, pattern_fill_1, plantPerformance_service_1, _, aps_enums_1, moment, chartConfig_service_1) {
    "use strict";
    plantPerformanceChartConfig.$inject = ["$stateProvider"];
    Object.defineProperty(exports, "__esModule", { value: true });
    highcharts_more_1.default(Highcharts);
    solid_gauge_1.default(Highcharts);
    pattern_fill_1.default(Highcharts);
    var requires = [authData_service_1.default, plantPerformance_service_1.default, chartConfig_service_1.default];
    var shortPercentType;
    var longPercentType;
    var red = '#f04124';
    var green = '#358753';
    function plantPerformanceChartConfig($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.PLANT_PERFORMANCE_CHARTS,
            url: '/plant-peformance-charts',
            params: {
                'selectedLocation': ''
            },
            controller: 'PlantPerformanceChartsCtrl as vm',
            template: plantPerformanceCharts_tpl_html_1.default,
            data: { pageTitle: 'Company Performance Charts' }
        });
    }
    function genericChart() {
        return {
            restrict: 'E',
            template: '<div></div>',
            scope: {
                options: '='
            },
            link: function (scope, element) {
                var chart = Highcharts.chart(element[0], scope.options);
                scope.$watch('options', function (newVal) {
                    if (newVal) {
                        chart.update(scope.options);
                    }
                }, true);
            }
        };
    }
    var PlantPerformanceChartsCtrl = (function () {
        PlantPerformanceChartsCtrl.$inject = ["locationsService", "navigationService", "loaderService", "plantPerformanceService", "$stateParams", "chartConfigService"];
        function PlantPerformanceChartsCtrl(locationsService, navigationService, loaderService, plantPerformanceService, $stateParams, chartConfigService) {
            var _this = this;
            this.isTank = false;
            this.isShop = false;
            this.showHelpWindow = false;
            this.helpText = "";
            this.locationsService = locationsService;
            this.plantPerformanceService = plantPerformanceService;
            this.chartConfigService = chartConfigService;
            Highcharts.setOptions({
                lang: {
                    thousandsSep: ','
                }
            });
            var promise = locationsService.initialize().then(function () {
                return navigationService.getNavigation().then(function (nav) {
                    _this.plants = nav.plants();
                    _this.selectedPlant = nav.selectedPlant;
                    _this.updatePlant($stateParams['selectedLocation']);
                });
            });
            loaderService.loadingPromise(promise);
            this.setMonthInfo();
            this.dailyChartConfig = chartConfigService.getDailyPackChartConfig();
            this.monthlyChartConfig = chartConfigService.getMonthlyPackChartConfig();
            this.ytdChartConfig = chartConfigService.getYearlyPackChartConfig();
            this.dailyFurnaceChartConfig = chartConfigService.getDailyFurnaceChartConfig();
            this.monthlyFurnaceChartConfig = chartConfigService.getMonthlyFurnaceChartConfig();
            this.ytdFurnaceChartConfig = chartConfigService.getYearlyFurnaceChartConfig();
            this.dailyLineHoldsChartConfig = chartConfigService.getDailyLineHoldsChartConfig();
        }
        PlantPerformanceChartsCtrl.prototype.showHelp = function (chartType) {
            if (this.showHelpWindow) {
                this.showHelpWindow = false;
            }
            this.helpText = this.chartConfigService.getHelpText(chartType, this.isShop);
            this.toggleHelpWindow();
        };
        PlantPerformanceChartsCtrl.prototype.toggleHelpWindow = function () {
            this.showHelpWindow = !this.showHelpWindow;
        };
        PlantPerformanceChartsCtrl.prototype.getMonthList = function (maxDate) {
            var startDate = moment(maxDate);
            var months = [];
            for (var i = 0; i < 12; i++) {
                months.push({ id: (startDate.format("MM/01/YYYY")), name: startDate.format("MMMM YYYY") });
                startDate.add("M", -1);
            }
            return months;
        };
        PlantPerformanceChartsCtrl.prototype.updatePlant = function (selectedLocationString) {
            if (selectedLocationString === void 0) { selectedLocationString = null; }
            this.locations = _.filter(this.locationsService.getPlantLocations(this.selectedPlant), function (locations) { return locations.locationType !== aps_enums_1.apsEnums.LocationType.Other; });
            this.selectedLocation = _.find(this.locations, function (item) { return item.name === "Plant"; });
            if (selectedLocationString != null && selectedLocationString !== "") {
                this.selectedLocation = _.find(this.locations, function (location) { return location.name === selectedLocationString; });
            }
            this.loadCharts();
        };
        PlantPerformanceChartsCtrl.prototype.updateLocation = function () {
            this.loadCharts();
        };
        PlantPerformanceChartsCtrl.prototype.updateMonth = function () {
            this.loadCharts();
        };
        PlantPerformanceChartsCtrl.prototype.setMonthInfo = function () {
            if (this.months == null) {
                this.months = this.getMonthList(moment().date() === 1 ? moment().add(-1, 'M').format("YYYYMMDD") : moment().format("YYYYMMDD"));
                this.selectedMonth = _.head(this.months);
            }
        };
        PlantPerformanceChartsCtrl.prototype.loadCharts = function () {
            this.isTank = false;
            this.isShop = false;
            this.selectedMonthName = moment(this.selectedMonth.id).format("MMM").toUpperCase();
            this.selectedYear = moment(this.selectedMonth.id).format("YYYY");
            this.selectedPreviousYear = (moment(this.selectedMonth.id).year() - 1).toString();
            if (this.selectedLocation.locationType === aps_enums_1.apsEnums.LocationType.Shop) {
                this.isShop = true;
                shortPercentType = "PTP";
                longPercentType = "Pack To Pull";
            }
            else {
                if (this.selectedLocation.locationType === aps_enums_1.apsEnums.LocationType.Tank) {
                    this.isTank = true;
                }
                shortPercentType = "PTM";
                longPercentType = "Pack To Melt";
            }
            this.loadPackChart();
            this.loadPackProducts();
            if (this.isTank) {
                this.loadFurnaceCharts();
            }
            if (this.isShop) {
                this.loadShopCharts();
            }
        };
        PlantPerformanceChartsCtrl.prototype.loadPackChart = function () {
            var _this = this;
            this.plantPerformanceService.getPackChartData(this.selectedLocation, this.selectedMonth == null ? moment().month().toString() : this.selectedMonth.id).then(function (data) {
                _this.dailyChartConfig.xAxis.categories = data.currentYearDaily.map(function (x) { return moment(x.startDate).format("MM/DD"); });
                _this.dailyChartConfig.series[0].data = data.currentYearDaily.map(function (x) { return x.percent; });
                _this.dailyChartConfig.series[1].data = data.previousYearDaily.map(function (x) { return x.percent; });
                _this.dailyChartConfig.yAxis.plotLines[0].value = data.aopDay;
                _this.dailyChartConfig.yAxis.plotLines[0].label.text = _this.selectedMonthName + ' ' + _this.selectedYear
                    + " AOP (" + _this.dailyChartConfig.yAxis.plotLines[0].value.toFixed(1) + "%)";
                _this.dailyChartConfig.title.text = '<b>' + _this.selectedMonthName + ' '
                    + _this.selectedYear + ' ' + shortPercentType + '</b>';
                _this.dailyChartConfig.series[0].name =
                    _this.selectedYear + ' ' + longPercentType;
                _this.dailyChartConfig.series[1].name =
                    _this.selectedPreviousYear + ' ' + longPercentType;
                _this.monthlyChartConfig.xAxis.categories = data.currentYearMonthly.map(function (x) { return moment(x.startDate).format("MM/YYYY"); });
                _this.monthlyChartConfig.series[0].data = data.currentYearMonthly.map(function (x) { return x.percent; });
                _this.monthlyChartConfig.series[1].data = data.aopMonthly.map(function (x) { return x.percent; });
                _this.monthlyChartConfig.series[2].data = data.previousYearMonthly.map(function (x) { return x.percent; });
                _this.monthlyChartConfig.series[3].data = data.currentYearMonthly.map(function (x) { return ((x.percent / _.find(data.aopMonthly, function (y) { return y.startDate === x.startDate; }).percent) * 100); });
                _this.monthlyChartConfig.title.text = '<b>' + _this.selectedYear + ' '
                    + shortPercentType + '</b>';
                _this.monthlyChartConfig.series[0].name = _this.selectedYear + ' '
                    + longPercentType;
                _this.monthlyChartConfig.series[1].name = _this.selectedYear + ' AOP';
                _this.monthlyChartConfig.series[2].name = _this.selectedPreviousYear
                    + ' ' + longPercentType;
                _this.ytdChartConfig.series[0].data[0] = data.ytd;
                _this.ytdChartConfig.yAxis.stops = _this.getPackGaugeColor(data.ytd, data.aopYear);
                _this.ytdChartConfig.yAxis.plotLines[0].value = data.aopYear;
                _this.ytdChartConfig.yAxis.plotLines[0].label.text = _this.selectedYear + " AOP (" + data.aopYear.toFixed(1) + "%)";
                _this.ytdChartConfig.series[0].dataLabels.format =
                    '<div style="text-align:center;">' +
                        '<span style="font-size:10px;">' + _this.selectedYear + ' ' + shortPercentType + '</span><br/>' +
                        '<span style="font-size:10px">' + data.ytd.toFixed(1) + '%</span><br/>' +
                        '</div>';
            });
        };
        PlantPerformanceChartsCtrl.prototype.loadPackProducts = function () {
            var _this = this;
            this.plantPerformanceService.getPackProductsInfo(this.selectedLocation, this.selectedMonth.id).then(function (data) {
                _this.monthlyTopFive = data.monthlyTopFivePackProducts;
                _this.monthlyBottomFive = data.monthlyBottomFivePackProducts;
                _this.yearlyTopFive = data.yearlyTopFivePackProducts;
                _this.yearlyBottomFive = data.yearlyBottomFivePackProducts;
            });
        };
        PlantPerformanceChartsCtrl.prototype.loadFurnaceCharts = function () {
            var _this = this;
            this.plantPerformanceService.getFurnaceChartData(this.selectedLocation, this.selectedMonth.id).then(function (data) {
                _this.dailyFurnaceChartConfig.xAxis.categories = data.furnaceDailyDataItems.map(function (x) { return moment(x.startDate).format("MM/DD"); });
                if (data.furnaceCapacityItems != null && data.furnaceCapacityItems.length > 0) {
                    _this.dailyFurnaceChartConfig.yAxis[0].max = _.maxBy(data.furnaceCapacityItems, function (x) { return x.nominal; }).nominal + 100;
                }
                _this.dailyFurnaceChartConfig.series[0].data = data.furnaceDailyDataItems.map(function (x) { return x.tonsPulled; });
                _this.dailyFurnaceChartConfig.series[1].data = data.furnaceDailyDataItems.map(function (x) { return x.tonsPacked; });
                _this.dailyFurnaceChartConfig.series[2].data = data.furnaceDailyDataItems.map(function (x) { return ((x.tonsPulled /
                    (_this.getNominalCapacityForDate(data.furnaceCapacityItems, x.startDate) * x.days))
                    * 100); });
                _this.dailyFurnaceChartConfig.title.text = '<b>' + _this.selectedMonthName
                    + ' ' + _this.selectedYear + ' Furnace Utilization</b><br/>'
                    + _this.getCapacityTextForMonth(data.furnaceCapacityItems);
                _this.dailyFurnaceChartConfig.series[0].name = 'Tons Melted';
                _this.dailyFurnaceChartConfig.series[1].name = 'Tons Packed';
                _this.monthlyFurnaceChartConfig.xAxis.categories = data.furnaceMonthlyDataItems.map(function (x) { return moment(x.startDate).format("MM/YYYY"); });
                if (data.furnaceCapacityItems != null && data.furnaceCapacityItems.length > 0) {
                    _this.monthlyFurnaceChartConfig.yAxis[0].max = _.maxBy(data.furnaceCapacityItems, function (x) { return x.nominal; }).nominal * 31;
                }
                _this.monthlyFurnaceChartConfig.series[0].data = data.furnaceMonthlyDataItems.map(function (x) { return x.tonsPulled; });
                _this.monthlyFurnaceChartConfig.series[1].data = data.furnaceMonthlyDataItems.map(function (x) { return x.tonsPacked; });
                _this.monthlyFurnaceChartConfig.series[2].data = data.furnaceMonthlyDataItems.map(function (x) { return ((x.tonsPulled /
                    (_this.getNominalCapacityForDate(data.furnaceCapacityItems, x.startDate) * x.days))
                    * 100); });
                _this.monthlyFurnaceChartConfig.title.text = '<b>' + _this.selectedYear
                    + ' Furnace Utilization</b><br/>'
                    + _this.getCapacityText(data.furnaceCapacityItems);
                _this.monthlyFurnaceChartConfig.series[0].name = 'Tons Melted';
                _this.monthlyFurnaceChartConfig.series[1].name = 'Tons Packed';
                _this.ytdFurnaceChartConfig.series[0].data[0] = data.furnaceYTDUtilization;
                _this.ytdFurnaceChartConfig.yAxis.stops = _this.getFurnaceGaugeColor(data.furnaceYTDUtilization);
                _this.ytdFurnaceChartConfig.series[0].dataLabels.format =
                    '<div style="text-align:center;">' +
                        '<span style="font-size:10px;">' + _this.selectedYear + '</span><br/>' +
                        '<span style="font-size:10px">Furnace Util.</span><br/>' +
                        '<span style="font-size:10px">' + data.furnaceYTDUtilization.toFixed(1) + '%</span><br/>' +
                        '</div>';
            });
        };
        PlantPerformanceChartsCtrl.prototype.loadShopCharts = function () {
            var _this = this;
            this.plantPerformanceService.getLineItemHoldsData(this.selectedLocation, this.selectedMonth.id).then(function (data) {
                _this.dailyLineHoldsChartConfig.xAxis.categories = data.map(function (x) { return moment(x.startDate).format("MM/DD"); });
                _this.dailyLineHoldsChartConfig.series[0].data = data.map(function (x) { return (x.lineHolds / x.gross) * 100; });
                _this.dailyLineHoldsChartConfig.title.text = '<b>' + _this.selectedMonthName + ' ' + _this.selectedYear + ' % Line Holds</b>';
            });
        };
        PlantPerformanceChartsCtrl.prototype.getCapacityTextForMonth = function (capacityItems) {
            var month = new Date(this.selectedMonth.id);
            var capacityMatches = capacityItems.filter(function (x) { return (x.startDate == null || moment(x.startDate).isBefore(month)) &&
                (x.endDate == null || moment(x.endDate).isAfter(month)); });
            return this.getCapacityText(capacityMatches);
        };
        PlantPerformanceChartsCtrl.prototype.getCapacityText = function (capacityItems) {
            var capacityText = '<span class="capacityText">';
            if (capacityItems.length === 1) {
                capacityText += "Nominal Capacity: " + capacityItems[0].nominal + "&nbsp;&nbsp;&nbsp;";
                capacityText += "Environmental Capacity: " + capacityItems[0].environmental;
            }
            else {
                capacityItems.forEach(function (x) {
                    var startDate = x.startDate == null ? 'Unknown' : moment(x.startDate).utc().format("MM/DD/YYYY");
                    var endDate = x.endDate == null ? 'Current' : moment(x.endDate).utc().format("MM/DD/YYYY");
                    capacityText += startDate + " - " + endDate
                        + "&nbsp;&nbsp;&nbsp;" + "Nominal Capacity: "
                        + x.nominal + "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
                        "Environmental Capacity: " + x.environmental + '</br>';
                });
            }
            capacityText += '</span>';
            return capacityText;
        };
        PlantPerformanceChartsCtrl.prototype.getNominalCapacityForDate = function (furnaceCapacityItems, selectedDate) {
            var capacityItem = _.find(furnaceCapacityItems, function (y) {
                return (y.startDate == null || moment(selectedDate).isSameOrAfter(moment(y.startDate).utc().format("MM/DD/YYYY")))
                    && (y.endDate == null || moment(selectedDate).isSameOrBefore(moment(y.endDate).utc().format("MM/DD/YYYY")));
            });
            return capacityItem == null ? 0 : capacityItem.nominal;
        };
        PlantPerformanceChartsCtrl.prototype.getPackGaugeColor = function (packPercent, aop) {
            var value = (packPercent / aop) * 100;
            switch (true) {
                case (value >= 100):
                    return [
                        [0, green],
                        [1, green]
                    ];
                default:
                    return [
                        [0, red],
                        [1, red]
                    ];
            }
        };
        PlantPerformanceChartsCtrl.prototype.getFurnaceGaugeColor = function (percent) {
            switch (true) {
                case (percent >= 95):
                    return [
                        [0, green],
                        [1, green]
                    ];
                default:
                    return [
                        [0, red],
                        [1, red]
                    ];
            }
        };
        return PlantPerformanceChartsCtrl;
    }());
    exports.default = angular.module('aps.controller.plantPerformanceCharts', requires)
        .config(plantPerformanceChartConfig)
        .controller('PlantPerformanceChartsCtrl', PlantPerformanceChartsCtrl)
        .directive('dailyChart', genericChart)
        .directive('monthlyChart', genericChart)
        .directive('ytdChart', genericChart)
        .directive('dailyFurnaceChart', genericChart)
        .directive('monthlyFurnaceChart', genericChart)
        .directive('ytdFurnaceChart', genericChart)
        .directive('dailyLineholdsChart', genericChart)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <div class=plantPerformanceChartHeader> <div class=body-header> <h2>Company Performance - {{vm.selectedPlant.name}} ({{vm.selectedLocation.name}})</h2> </div> </div> <div class=plantPerformanceRow> <ng-form name=commonForm> <div class=plantPerformanceChartSubheader> <div class=\"small-2 columns filter\"> <label> Plant:&nbsp; <select ng-model=vm.selectedPlant ng-options=\"plant as plant.name for plant in vm.plants\" ng-change=vm.updatePlant() name=selectedPlant> </select> </label> </div> <div class=\"small-2 columns filter left\"> <label> Location:&nbsp; <select name=selectedLocation ng-model=vm.selectedLocation ng-options=\"location as location.name for location in vm.locations\" ng-change=vm.updateLocation()> </select> </label> </div> <div class=\"small-2 columns filter left\"> <label> Month:&nbsp; <select name=selectedMonth ng-model=vm.selectedMonth ng-options=\"month as month.name for month in vm.months\" ng-change=vm.updateMonth()> </select> </label> </div> <!-- YTD Pack to Melt chart --> <div class=ytdChart> <div class=charthelpgauge> <a ng-click=\"vm.showHelp('yearly')\"><i class=\"fa fa-info-circle fa-bigger\"></i></a> </div> <ytd-chart class=plantPerformanceChart options=vm.ytdChartConfig></ytd-chart> </div> <!-- YTD Furnace Utilization chart --> <div class=ytdChart ng-if=vm.isTank> <div class=charthelpgauge> <a ng-click=\"vm.showHelp('yearlyFurnace')\"><i class=\"fa fa-info-circle fa-bigger\"></i></a> </div> <ytd-furnace-chart class=\"plantPerformanceChart furnaceGauge\" options=vm.ytdFurnaceChartConfig></ytd-furnace-chart> </div> </div> </ng-form> </div> <div class=\"plantPerformanceRow chartScrollSection\"> <!-- Daily Pack to Melt chart --> <div class=plantPerformanceChartContainer> <div class=charthelp> <a ng-click=\"vm.showHelp('daily')\"><i class=\"fa fa-info-circle fa-bigger\"></i></a> </div> <daily-chart class=plantPerformanceChart options=vm.dailyChartConfig></daily-chart> </div> </div> <div class=plantPerformanceRow> <!-- Monthly Pack to Melt chart --> <div class=plantPerformanceChartContainer> <div class=charthelp> <a ng-click=\"vm.showHelp('monthly')\"><i class=\"fa fa-info-circle fa-bigger\"></i></a> </div> <monthly-chart class=plantPerformanceChart options=vm.monthlyChartConfig></monthly-chart> </div> </div> <div class=plantPerformanceRow ng-if=vm.isTank> <!-- Daily Furnace Utilization Info (for Tanks only) --> <div class=plantPerformanceChartContainer> <div class=charthelp> <a ng-click=\"vm.showHelp('dailyFurnace')\"><i class=\"fa fa-info-circle fa-bigger\"></i></a> </div> <daily-furnace-chart class=plantPerformanceChart options=vm.dailyFurnaceChartConfig><daily-furnace-chart> </daily-furnace-chart></daily-furnace-chart></div> </div> <div class=plantPerformanceRow ng-if=vm.isTank> <!-- Monthly Furnace Utilization Info (for Tanks only) --> <div class=plantPerformanceChartContainer> <div class=charthelp> <a ng-click=\"vm.showHelp('monthlyFurnace')\"><i class=\"fa fa-info-circle fa-bigger\"></i></a> </div> <monthly-furnace-chart class=plantPerformanceChart options=vm.monthlyFurnaceChartConfig><monthly-furnace-chart> </monthly-furnace-chart></monthly-furnace-chart></div> </div> <div class=plantPerformanceRow ng-if=vm.isShop> <!-- Daily Line Item Holds Info (for Shops only) --> <div class=plantPerformanceChartContainer> <div class=charthelp> <a ng-click=\"vm.showHelp('lineHolds')\"><i class=\"fa fa-info-circle fa-bigger\"></i></a> </div> <daily-lineholds-chart class=plantPerformanceChart options=vm.dailyLineHoldsChartConfig><daily-lineholds-chart> </daily-lineholds-chart></daily-lineholds-chart></div> </div> <div class=plantPerformanceRow> <!-- Top 5 for selected month  --> <div class=plantPerformancePackProducts> <h5><a ng-click=\"vm.showHelp('packProducts')\"><i class=\"fa fa-info-circle fa-bigger\"></i></a> Top 5 Pack Products for {{vm.selectedMonth.name}}</h5> <table class=history-t> <thead> <tr> <th>Mold</th> <th>Description</th> <th>Size</th> <th>Finish</th> <th>% Pack</th> </tr> </thead> <tbody> <tr ng-repeat=\"product in vm.monthlyTopFive\" style=cursor:auto> <td><b>{{::product.mold}}</b></td> <td class=moldDescription>{{::product.description}}</td> <td class=size>{{::product.size}}</td> <td class=finish>{{::product.finish}}</td> <td><b>{{::product.percentPack.toFixed(1)}}%</b></td> </tr> </tbody> </table> </div> <!-- Top 5 for selected year  --> <div class=plantPerformancePackProducts> <h5>Top 5 Pack Products for {{vm.selectedMonth.id.substring(6)}}</h5> <table class=history-t> <thead> <tr> <th>Mold</th> <th>Description</th> <th>Size</th> <th>Finish</th> <th>% Pack</th> </tr> </thead> <tbody> <tr ng-repeat=\"product in vm.yearlyTopFive\" style=cursor:auto> <td><b>{{::product.mold}}</b></td> <td class=moldDescription>{{::product.description}}</td> <td class=size>{{::product.size}}</td> <td class=finish>{{::product.finish}}</td> <td><b>{{::product.percentPack.toFixed(1)}}%</b></td> </tr> </tbody> </table> </div> </div> <div class=plantPerformanceRow style=clear:both> <!-- Bottom 5 for selected month  --> <div class=plantPerformancePackProducts> <h5>Bottom 5 Pack Products for {{vm.selectedMonth.name}}</h5> <table class=history-t> <thead> <tr> <th>Mold</th> <th>Description</th> <th>Size</th> <th>Finish</th> <th>% Pack</th> </tr> </thead> <tbody> <tr ng-repeat=\"product in vm.monthlyBottomFive\" style=cursor:auto> <td><b>{{::product.mold}}</b></td> <td class=moldDescription>{{::product.description}}</td> <td class=size>{{::product.size}}</td> <td class=finish>{{::product.finish}}</td> <td><b>{{::product.percentPack.toFixed(1)}}%</b></td> </tr> </tbody> </table> </div> <!-- Bottom 5 for selected year  --> <div class=plantPerformancePackProducts> <h5>Bottom 5 Pack Products for {{vm.selectedMonth.id.substring(6)}} </h5> <table class=history-t> <thead> <tr> <th>Mold</th> <th>Description</th> <th>Size</th> <th>Finish</th> <th>% Pack</th> </tr> </thead> <tbody> <tr ng-repeat=\"product in vm.yearlyBottomFive\" style=cursor:auto> <td><b>{{::product.mold}}</b></td> <td class=moldDescription>{{::product.description}}</td> <td class=size>{{::product.size}}</td> <td class=finish>{{::product.finish}}</td> <td><b>{{::product.percentPack.toFixed(1)}}%</b></td> </tr> </tbody> </table> <br/> </div> </div> <div ng-if=vm.showHelpWindow class=charthelpdetails> <div class=windowclose> <a><i class=\"fa fa-times-circle fa-bigger\" ng-click=vm.toggleHelpWindow()></i></a> </div> <div class=tooltiptext ng-bind-html=vm.helpText> </div> </div> </div> ");

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 Highcharts JS v7.2.2 (2020-08-24)

 Module for adding patterns and images as point fills.

 (c) 2010-2019 Highsoft AS
 Author: Torstein Hnsi, ystein Moseng

 License: www.highcharts.com/license
*/
(function(c){"object"===typeof module&&module.exports?(c["default"]=c,module.exports=c): true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(96)], __WEBPACK_AMD_DEFINE_RESULT__ = (function(f){c(f);c.Highcharts=f;return c}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):c("undefined"!==typeof Highcharts?Highcharts:void 0)})(function(c){function f(e,c,f,n){e.hasOwnProperty(c)||(e[c]=n.apply(null,f))}c=c?c._modules:{};f(c,"modules/pattern-fill.src.js",[c["parts/Globals.js"],c["parts/Utilities.js"]],function(e,c){function f(a,b){a=JSON.stringify(a);
var q=a.length||0,d=0,c=0;if(b){b=Math.max(Math.floor(q/500),1);for(var e=0;e<q;e+=b)d+=a.charCodeAt(e);d&=d}for(;c<q;++c)b=a.charCodeAt(c),d=(d<<5)-d+b,d&=d;return d.toString(16).replace("-","1")}var n=c.erase,p=c.pick;c=e.addEvent;var u=e.wrap,t=e.merge;e.Point.prototype.calculatePatternDimensions=function(a){if(!a.width||!a.height){var b=this.graphic&&(this.graphic.getBBox&&this.graphic.getBBox(!0)||this.graphic.element&&this.graphic.element.getBBox())||{},c=this.shapeArgs;c&&(b.width=c.width||
b.width,b.height=c.height||b.height,b.x=c.x||b.x,b.y=c.y||b.y);if(a.image){if(!b.width||!b.height){a._width="defer";a._height="defer";return}a.aspectRatio&&(b.aspectRatio=b.width/b.height,a.aspectRatio>b.aspectRatio?b.aspectWidth=b.height*a.aspectRatio:b.aspectHeight=b.width/a.aspectRatio);a._width=a.width||Math.ceil(b.aspectWidth||b.width);a._height=a.height||Math.ceil(b.aspectHeight||b.height)}a.width||(a._x=a.x||0,a._x+=b.x-Math.round(b.aspectWidth?Math.abs(b.aspectWidth-b.width)/2:0));a.height||
(a._y=a.y||0,a._y+=b.y-Math.round(b.aspectHeight?Math.abs(b.aspectHeight-b.height)/2:0))}};e.SVGRenderer.prototype.addPattern=function(a,b){b=p(b,!0);var c=e.animObject(b),d=a.width||a._width||32,g=a.height||a._height||32,f=a.color||"#343434",k=a.id,n=this,l=function(a){n.rect(0,0,d,g).attr({fill:a}).add(h)};k||(this.idCounter=this.idCounter||0,k="highcharts-pattern-"+(this.chartIndex||0)+"-"+this.idCounter,++this.idCounter);this.defIds=this.defIds||[];if(!(-1<this.defIds.indexOf(k))){this.defIds.push(k);
var h=this.createElement("pattern").attr({id:k,patternUnits:"userSpaceOnUse",patternContentUnits:a.patternContentUnits||"userSpaceOnUse",width:d,height:g,x:a._x||a.x||0,y:a._y||a.y||0}).add(this.defs);h.id=k;if(a.path){var m=a.path;a.backgroundColor&&l(a.backgroundColor);l={d:m.d||m};this.styledMode||(l.stroke=m.stroke||f,l["stroke-width"]=p(m.strokeWidth,2),l.fill=m.fill||"none");m.transform&&(l.transform=m.transform);this.createElement("path").attr(l).add(h);h.color=f}else a.image&&(b?this.image(a.image,
0,0,d,g,function(){this.animate({opacity:p(a.opacity,1)},c);e.removeEvent(this.element,"load")}).attr({opacity:0}).add(h):this.image(a.image,0,0,d,g).add(h));a.image&&b||void 0===a.opacity||[].forEach.call(h.element.childNodes,function(b){b.setAttribute("opacity",a.opacity)});this.patternElements=this.patternElements||{};return this.patternElements[k]=h}};u(e.Series.prototype,"getColor",function(a){var b=this.options.color;b&&b.pattern&&!b.pattern.color?(delete this.options.color,a.apply(this,Array.prototype.slice.call(arguments,
1)),b.pattern.color=this.color,this.color=this.options.color=b):a.apply(this,Array.prototype.slice.call(arguments,1))});c(e.Series,"render",function(){var a=this.chart.isResizing;(this.isDirtyData||a||!this.chart.hasRendered)&&(this.points||[]).forEach(function(b){var c=b.options&&b.options.color;c&&c.pattern&&(!a||b.shapeArgs&&b.shapeArgs.width&&b.shapeArgs.height?b.calculatePatternDimensions(c.pattern):(c.pattern._width="defer",c.pattern._height="defer"))})});c(e.Point,"afterInit",function(){var a=
this.options.color;a&&a.pattern&&("string"===typeof a.pattern.path&&(a.pattern.path={d:a.pattern.path}),this.color=this.options.color=t(this.series.options.color,a))});e.addEvent(e.SVGRenderer,"complexColor",function(a){var b=a.args[0],c=a.args[1];a=a.args[2];var d=b.pattern,g="#343434";if(!d)return!0;if(d.image||"string"===typeof d.path||d.path&&d.path.d){var r=(r=a.parentNode&&a.parentNode.getAttribute("class"))&&-1<r.indexOf("highcharts-legend");"defer"!==d._width&&"defer"!==d._height||e.Point.prototype.calculatePatternDimensions.call({graphic:{element:a}},
d);if(r||!d.id)d=t({},d),d.id="highcharts-pattern-"+(this.chartIndex||0)+"-"+f(d)+f(d,!0);this.addPattern(d,!this.forExport&&p(d.animation,this.globalAnimation,{duration:100}));g="url("+this.url+"#"+d.id+")"}else g=d.color||g;a.setAttribute(c,g);b.toString=function(){return g};return!1});e.addEvent(e.Chart,"endResize",function(){(this.renderer&&this.renderer.defIds||[]).filter(function(a){return a&&a.indexOf&&0===a.indexOf("highcharts-pattern-")}).length&&(this.series.forEach(function(a){a.points.forEach(function(a){(a=
a.options&&a.options.color)&&a.pattern&&(a.pattern._width="defer",a.pattern._height="defer")})}),this.redraw(!1))});e.addEvent(e.Chart,"redraw",function(){var a=[],b=this.renderer,c=(b.defIds||[]).filter(function(a){return a.indexOf&&0===a.indexOf("highcharts-pattern-")});c.length&&([].forEach.call(this.renderTo.querySelectorAll('[color^="url(#"], [fill^="url(#"], [stroke^="url(#"]'),function(b){(b=b.getAttribute("fill")||b.getAttribute("color")||b.getAttribute("stroke"))&&a.push(b.substring(b.indexOf("url(#")+
5).replace(")",""))}),c.forEach(function(c){-1===a.indexOf(c)&&(n(b.defIds,c),b.patternElements[c]&&(b.patternElements[c].destroy(),delete b.patternElements[c]))}))});e.Chart.prototype.callbacks.push(function(a){var b=e.getOptions().colors,c=a.index,d=a.options.chart.forExport;"M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11;M 0 10 L 10 0 M -1 1 L 1 -1 M 9 11 L 11 9;M 3 0 L 3 10 M 8 0 L 8 10;M 0 3 L 10 3 M 0 8 L 10 8;M 0 3 L 5 3 L 5 0 M 5 10 L 5 7 L 10 7;M 3 3 L 8 3 L 8 8 L 3 8 Z;M 5 5 m -4 0 a 4 4 0 1 1 8 0 a 4 4 0 1 1 -8 0;M 10 3 L 5 3 L 5 0 M 5 10 L 5 7 L 0 7;M 2 5 L 5 2 L 8 5 L 5 8 Z;M 0 0 L 5 10 L 10 0".split(";").forEach(function(e,
f){a.renderer.addPattern({id:"highcharts-default-pattern-"+(c&&!d?c+"-":"")+f,path:e,color:b[f],width:10,height:10})})})});f(c,"masters/modules/pattern-fill.src.js",[],function(){})});
//# sourceMappingURL=pattern-fill.js.map

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(34), __webpack_require__(117), __webpack_require__(312)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, http_service_1, Highcharts, highcharts_more_1, solid_gauge_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    highcharts_more_1.default(Highcharts);
    solid_gauge_1.default(Highcharts);
    var perecentText = 'Percent';
    var aopMonthText = 'AOP Month';
    var percentOfAopText = '% of AOP';
    var tonsText = 'Tons';
    var furnaceUtilizationText = 'Furnace Utilization';
    var percentLineHoldsText = '% Line Holds';
    var chartHeight = 275;
    var red = '#f04124';
    var green = '#358753';
    var gray = '#A5A2A2';
    var black = '#000000';
    var white = '#FFFFFF';
    var lightBlue = '#BBDEFB';
    var darkBlue = '#0303BA';
    var legendInstructions = 'click on any item in the legend above to hide it from the chart';
    var ChartConfigServiceImpl = (function () {
        ChartConfigServiceImpl.$inject = ["httpService"];
        function ChartConfigServiceImpl(httpService) {
            this.packProductHelpText = "\n  <div class=\"header\">\n    Top 5 / Bottom 5 Pack Products\n  </div>\n  <div class=\"subheader\">\n    <span> Data Source: </span>\n    <span class=\"detail\">Legacy AS400</span>\n  </div>    \n  <div class=\"detail\">"
                + "This section displays the top 5 and bottom 5 products for the selected plant, tank, or shop, "
                + "based on <b>Percent Pack</b> for the selected month and/or year.\n  </div> \n  <div class=\"detail\">\n    Percent Pack is calculated from data in Job Records in the legacy AS400 system.  \n    All records where speed > 0 and production hours > 0 are included.<br/>\n  </div>\n  <div class=\"detail\">\n    <span class=\"formula\">% Pack = rounded to tenths(Gross / Shearcuts * 100)</span><br/>\n    <span class=\"footnote\">[where shearcuts > 0]</span><br/><br/>\n    <span class=\"formula\">Shearcuts = Actual Speed * 60 * Actual Hours / 144</span>\n  </div>\n  ";
            this.dailyPackChartConfig = {
                chart: {
                    alignTicks: true,
                    zoomType: 'xy',
                    height: chartHeight,
                    spacingBottom: 5,
                    borderWidth: 2,
                    borderColor: '#DDDDDD'
                },
                credits: {
                    enabled: false
                },
                title: {
                    text: '',
                    margin: 0,
                    useHTML: true
                },
                subtitle: {
                    text: legendInstructions,
                    align: 'center',
                    verticalAlign: 'bottom',
                    y: -5,
                    style: {
                        color: gray
                    }
                },
                xAxis: {
                    categories: []
                },
                tooltip: {
                    valueDecimals: 1,
                    valueSuffix: '%'
                },
                yAxis: {
                    title: {
                        text: perecentText
                    },
                    max: 125,
                    tickInterval: 25,
                    plotLines: [{
                            color: black,
                            dashStyle: 'dash',
                            value: 0,
                            width: 3,
                            label: {
                                text: aopMonthText,
                                style: {
                                    color: black
                                }
                            }
                        }]
                },
                plotOptions: {
                    column: {
                        dataLabels: {
                            enabled: true,
                            rotation: -90,
                            color: white,
                            align: 'right',
                            format: '{point.y:.1f}',
                            y: 10,
                            style: {
                                fontSize: '11px',
                                fontFamily: 'Verdana, sans-serif'
                            }
                        }
                    }
                },
                series: [{
                        type: 'column',
                        data: [],
                        color: black,
                        name: ''
                    },
                    {
                        type: 'column',
                        data: [],
                        color: darkBlue,
                        name: ''
                    },
                ],
                responsive: {
                    rules: [{
                            condition: {
                                maxWidth: 400
                            },
                            chartOptions: {
                                plotOptions: {
                                    column: {
                                        dataLabels: {
                                            enabled: false
                                        }
                                    }
                                }
                            }
                        }]
                }
            };
            this.dailyPTMHelpText = "\n    <div class=\"header\">\n      Month To Date PTM\n    </div>\n    <div class=\"subheader\">\n      <span> Data Source: </span>\n      <span class=\"detail\">Legacy AS400</span>\n    </div>    \n    <div class=\"detail\">The chart displays <b>Current Year (CY) and Previous Year (PY) Pack To Melt</b>\n     for each day in the selected month. <br/> <span class=\"footnote\">(PTM is displayed only when a plant \n      or tank is selected on the dashboard; when a shop is selected, PTP is displayed.)</span>\n    </div>\n    <div class=\"detail\">\n      A <span class=\"green\">green trend line</span> is also displayed, showing the <b>Annual Operating Plan \n      (AOP)</b> value for the selected month,\n      making it easy to see how each day is measuring up to the planned amount.  \n      The AOP values are pulled from yearly spreadsheets maintained at corporate.\n    </div>\n    <div class=\"detail\">\n      <span class=\"formula\">PTM = Packed Tons / Melted Tons * 100</span><br/>\n      <span class=\"footnote\">[where Melted Tons > 0]</span>\n    </div>\n    <div class=\"detail\">\n      <b>Melted Tons</b> is taken from the Materials Usage / Commodity File in the legacy AS400 system, \n      summarized by plant, tank, and date.<br/>\n      <span class=\"formula\">Melted Tons = SUM(LBS * Yield / 100 / 2000)</span><br/>\n      <span class=\"footnote\">[where LBS is # of batches * pounds of material and Yield is % of \n        material consumed from Commodity File]</span>\n    </div>\n    <div class=\"detail\">\n      <b>Packed Tons</b> is taken from Job Records in the legacy AS400 system, summarized by \n      plant, tank, and date.<br/>\n      <span class=\"formula\">Packed Tons = SUM(Weight * Gross * .0045)</span><br/>\n      <span class=\"footnote\">[where .0045 is 144/32000 to convert oz-gross to tons]</span>\n    </div>\n    ";
            this.dailyPackHelpText = "\n    <div class=\"header\">\n      Month To Date PTP\n    </div>\n    <div class=\"subheader\">\n      <span> Data Source: </span>\n      <span class=\"detail\">Legacy AS400</span>\n    </div>    \n    <div class=\"detail\">\n      The chart displays <b>Current Year (CY) and Previous Year (PY) Pack To Pull</b> for \n      each day in the selected month.<br/>\n      <span class=\"footnote\">(PTP is displayed only when a shop is selected on the dashboard; \n        when a plant or tank is selected, PTM is displayed.)</span>\n    </div>\n    <div class=\"detail\">\n      A <span class=\"green\">green trend line</span> is also displayed, showing the <b>\n      Annual Operating Plan (AOP)</b> value for the selected month, making it easy to see \n      how each day is measuring up to the planned amount.  The AOP values are pulled \n      from yearly spreadsheets maintained at corporate.\n    </div>\n    <div class=\"detail\">\n      Pack to Pull is calculated from data in Job Records in the legacy AS400 system.  \n      All records where speed > 0 and production hours > 0 are included.<br/>\n    </div>\n    <div class=\"detail\">\n      <span class=\"formula\">PTP = rounded to tenths(Gross / Shearcuts * 100)</span><br/>\n      <span class=\"footnote\">[where shearcuts > 0]</span><br/><br/>\n      <span class=\"formula\">Shearcuts = Actual Speed * 60 * Actual Hours / 144</span>\n    </div>\n    ";
            this.monthlyPackChartConfig = {
                chart: {
                    alignTicks: true,
                    zoomType: 'xy',
                    height: chartHeight,
                    spacingBottom: 5,
                    borderWidth: 2,
                    borderColor: '#DDDDDD'
                },
                credits: {
                    enabled: false
                },
                title: {
                    text: '',
                    margin: 0,
                    useHTML: true
                },
                subtitle: {
                    text: legendInstructions,
                    align: 'center',
                    verticalAlign: 'bottom',
                    y: -5,
                    style: {
                        color: gray
                    }
                },
                plotOptions: {
                    column: {
                        dataLabels: {
                            enabled: true,
                            rotation: -90,
                            color: white,
                            align: 'right',
                            format: '{point.y:.1f}',
                            y: 10,
                            style: {
                                fontSize: '11px',
                                fontFamily: 'Verdana, sans-serif'
                            }
                        }
                    },
                    spline: {
                        marker: {
                            radius: 7
                        }
                    }
                },
                xAxis: {
                    categories: []
                },
                tooltip: {
                    valueDecimals: 1,
                    valueSuffix: '%'
                },
                yAxis: {
                    title: {
                        text: perecentText
                    },
                    max: 125,
                    tickInterval: 25
                },
                series: [{
                        type: 'column',
                        data: [],
                        color: black,
                        name: ''
                    },
                    {
                        type: 'column',
                        data: [],
                        name: '',
                        color: lightBlue
                    },
                    {
                        type: 'column',
                        data: [],
                        color: darkBlue,
                        name: ''
                    },
                    {
                        type: 'spline',
                        name: percentOfAopText,
                        data: [],
                        color: red,
                        zones: [
                            {
                                value: 100,
                                color: red
                            },
                            {
                                color: green
                            }
                        ]
                    }],
                responsive: {
                    rules: [{
                            condition: {
                                maxWidth: 400
                            },
                            chartOptions: {
                                plotOptions: {
                                    column: {
                                        dataLabels: {
                                            enabled: false
                                        }
                                    }
                                }
                            }
                        }]
                }
            };
            this.monthlyPTMHelpText = "\n    <div class=\"header\">\n      Year To Date PTM\n    </div>\n    <div class=\"subheader\">\n      <span> Data Source: </span>\n      <span class=\"detail\">Legacy AS400</span>\n    </div>    \n    <div class=\"detail\">\n      The chart displays <b>Current Year (CY) and Previous Year (PY) Pack To Melt</b>, as well as \n      <b>Annual Operating Plan (AOP)</b> values, for each month in the current year.  \n      The AOP values are pulled from yearly spreadsheets maintained at corporate.<br/>  \n      <span class=\"footnote\">(PTM is displayed only when a plant or tank is selected on the dashboard; \n        when a shop is selected, PTP is displayed.)</span>\n    </div>\n    <div class=\"detail\">\n      The <b>% of AOP</b> is also displayed as a line graph.  The line markers will \n      be <span class=\"red\">red</span> for any percent <b>below 100</b>\n       and <span class=\"green\">green</span> for anything <b>100% and above</b>.<br/><br/>\n      <span class=\"formula\">% of AOP = CY Pack to Melt / AOP * 100</span>\n    </div>\n    <div class=\"detail\">\n      <span class=\"formula\">PTM = Packed Tons / Melted Tons * 100</span><br/>\n      <span class=\"footnote\">[where Melted Tons > 0]</span>\n    </div>\n    <div class=\"detail\">\n      <b>Melted Tons</b> is taken from the Materials Usage / Commodity File in the legacy \n      AS400 system, summarized by plant, tank, and date.<br/>\n      <span class=\"formula\">Melted Tons = SUM(LBS * Yield / 100 / 2000)</span><br/>\n      <span class=\"footnote\">[where LBS is # of batches * pounds of material and \n        Yield is % of material consumed from Commodity File]</span>\n    </div>\n    <div class=\"detail\">\n      <b>Packed Tons</b> is taken from Job Records in the legacy AS400 system, summarized by \n      plant, tank, and date.<br/>\n      <span class=\"formula\">Packed Tons = SUM(Weight * Gross * .0045)</span><br/>\n      <span class=\"footnote\">[where .0045 is 144/32000 to convert oz-gross to tons]</span>\n    </div>\n    ";
            this.monthlyPackHelpText = "\n    <div class=\"header\">\n      Year To Date PTP\n    </div>\n    <div class=\"subheader\">\n      <span> Data Source: </span>\n      <span class=\"detail\">Legacy AS400</span>\n    </div>    \n    <div class=\"detail\">\n      The chart displays <b>Current Year (CY) and Previous Year (PY) Pack To Pull</b>, as\n       well as <b>Annual Operating Plan (AOP)</b> values, for each month in the current year.  \n      The AOP values are pulled from yearly spreadsheets maintained at corporate.<br/>  \n      <span class=\"footnote\">(PTP is displayed only when a shop is selected on the dashboard;\n         when a plant or tank is selected, PTM is displayed.)</span>\n    </div>\n    <div class=\"detail\">\n      The <b>% of AOP</b> is also displayed as a line graph.  The line markers will\n       be <span class=\"red\">red</span> for any percent <b>below 100</b> and <span class=\"green\">green</span>\n        for anything <b>100% and above</b>.<br/><br/>\n      <span class=\"formula\">% of AOP = CY Percent Pack / AOP * 100</span>\n    </div>\n    <div class=\"detail\">\n      PTP is calculated from data in Job Records in the legacy AS400 system.  \n      All records where speed > 0 and production hours > 0 are included.<br/>\n    </div>\n    <div class=\"detail\">\n      <span class=\"formula\">PTP = rounded to tenths(Gross / Shearcuts * 100)</span><br/>\n      <span class=\"footnote\">[where shearcuts > 0]</span><br/><br/>\n      <span class=\"formula\">Shearcuts = Actual Speed * 60 * Actual Hours / 144</span>\n    </div>\n    ";
            this.ytdPackChartConfig = {
                chart: {
                    type: 'solidgauge',
                    width: 280,
                    height: 100
                },
                title: 'null',
                pane: {
                    center: ['30%', '85%'],
                    size: '170%',
                    startAngle: -90,
                    endAngle: 90,
                    background: {
                        backgroundColor: Highcharts.defaultOptions.legend.backgroundColor || '#EEE',
                        innerRadius: '75%',
                        outerRadius: '100%',
                        shape: 'arc'
                    }
                },
                tooltip: {
                    enabled: false
                },
                credits: {
                    enabled: false
                },
                yAxis: {
                    min: 0,
                    max: 100,
                    stops: [],
                    lineWidth: 0,
                    minorTickInterval: null,
                    tickAmount: 2,
                    title: {
                        text: '',
                        useHTML: true,
                        y: -30,
                        x: 50
                    },
                    labels: {
                        y: 16,
                    },
                    plotLines: [{
                            color: green,
                            width: 1,
                            value: 0,
                            zIndex: 10,
                            label: {
                                text: "",
                                x: 40,
                                y: -10,
                                style: {
                                    color: black,
                                    fontSize: "10px"
                                }
                            }
                        }]
                },
                plotOptions: {
                    solidgauge: {
                        innerRadius: '75%',
                        dataLabels: {
                            y: 5,
                            borderWidth: 0,
                            useHTML: true
                        }
                    }
                },
                series: [{
                        data: [],
                        dataLabels: {
                            format: '',
                            x: 0,
                            y: -1
                        }
                    }]
            };
            this.yearlyPTMHelpText = "\n    <div class=\"header\">\n      YTD PTM\n    </div>\n    <div class=\"subheader\">\n      <span> Data Source: </span>\n      <span class=\"detail\">Legacy AS400</span>\n    </div>    \n    <div class=\"detail\">\n      This gauge chart displays the year-to-date <b>Pack To Melt</b> percentage.        \n      <span class=\"footnote\">(PTM is displayed only when a plant or tank is selected\n         on the dashboard; when a shop is selected, PTP is displayed.)</span>\n    </div>\n    <div class=\"detail\">\n      A <span class=\"green\">green trend line</span> is also displayed, showing the <b>Annual\n       Operating Plan (AOP)</b> value for the current year,\n      making it easy to see how the year is measuring up to the planned amount.  The AOP values\n       are pulled from yearly spreadsheets maintained at corporate.\n    </div>\n    <div class=\"detail\">\n      The <b>% of AOP</b> determines the color of the gauge chart.  It will show\n       as <span class=\"red\">red</span> for any percent of AOP <b>below 100</b> and\n        <span class=\"green\">green</span> for anything <b>100% and above</b>.<br/><br/>\n      <span class=\"formula\">% of AOP = YTD Pack to Melt / AOP * 100</span>\n    </div>\n    <div class=\"detail\">\n      <span class=\"formula\">PTM = Packed Tons / Melted Tons * 100</span><br/>\n      <span class=\"footnote\">[where Melted Tons > 0]</span>\n    </div>\n    <div class=\"detail\">\n      <b>Melted Tons</b> is taken from the Materials Usage / Commodity File in the legacy\n       AS400 system, summarized by plant, tank, and date.<br/>\n      <span class=\"formula\">Melted Tons = SUM(LBS * Yield / 100 / 2000)</span><br/>\n      <span class=\"footnote\">[where LBS is # of batches * pounds of material and Yield is % of\n         material consumed from Commodity File]</span>\n    </div>\n    <div class=\"detail\">\n      <b>Packed Tons</b> is taken from Job Records in the legacy AS400 system, summarized by\n       plant, tank, and date.<br/>\n      <span class=\"formula\">Packed Tons = SUM(Weight * Gross * .0045)</span><br/>\n      <span class=\"footnote\">[where .0045 is 144/32000 to convert oz-gross to tons]</span>\n    </div>\n    ";
            this.yearlyPackHelpText = "\n    <div class=\"header\">\n      YTD PTP\n    </div>\n    <div class=\"subheader\">\n      <span> Data Source: </span>\n      <span class=\"detail\">Legacy AS400</span>\n    </div>    \n    <div class=\"detail\">\n      This gauge chart displays the year-to-date <b>Percent Pack</b> percentage. \n      <span class=\"footnote\">(PTP is displayed only when a shop is selected on the dashboard;\n         when a plant or tank is selected, PTM is displayed.)</span>\n    </div>\n    <div class=\"detail\">\n      A <span class=\"green\">green trend line</span> is also displayed, showing the <b>Annual Operating\n       Plan (AOP)</b> value for the current year,\n      making it easy to see how the year is measuring up to the planned amount.  The AOP values\n       are pulled from \n      yearly spreadsheets maintained at corporate.\n    </div>\n    <div class=\"detail\">\n      The <b>% of AOP</b> determines the color of the gauge chart.  It will show\n       as <span class=\"red\">red</span> for any percent of AOP <b>below 100</b>\n        and <span class=\"green\">green</span> for anything <b>100% and above</b>.<br/><br/>\n      <span class=\"formula\">% of AOP = YTD Percent Pack / AOP * 100</span>\n    </div>\n    <div class=\"detail\">\n      PTP is calculated from data in Job Records in the legacy AS400 system.  \n      All records where speed > 0 and production hours > 0 are included.<br/>\n    </div>\n    <div class=\"detail\">\n      <span class=\"formula\">PTP = rounded to tenths(Gross / Shearcuts * 100)</span><br/>\n      <span class=\"footnote\">[where shearcuts > 0]</span><br/><br/>\n      <span class=\"formula\">Shearcuts = Actual Speed * 60 * Actual Hours / 144</span>\n    </div>\n    ";
            this.dailyFurnaceChartConfig = {
                chart: {
                    alignTicks: true,
                    zoomType: 'xy',
                    height: chartHeight,
                    spacingBottom: 5,
                    borderWidth: 2,
                    borderColor: '#DDDDDD'
                },
                credits: {
                    enabled: false
                },
                title: {
                    text: '',
                    margin: 0,
                    useHTML: true
                },
                subtitle: {
                    text: legendInstructions,
                    align: 'center',
                    verticalAlign: 'bottom',
                    y: -5,
                    style: {
                        color: gray
                    }
                },
                plotOptions: {
                    column: {
                        dataLabels: {
                            enabled: true,
                            rotation: -90,
                            color: white,
                            align: 'right',
                            format: '{point.y:.1f}',
                            y: 10,
                            style: {
                                fontSize: '11px',
                                fontFamily: 'Verdana, sans-serif'
                            }
                        }
                    },
                    spline: {
                        marker: {
                            radius: 7
                        }
                    }
                },
                xAxis: {
                    categories: []
                },
                tooltip: {
                    valueDecimals: 1
                },
                yAxis: [{
                        title: {
                            text: tonsText
                        }
                    },
                    {
                        title: {
                            text: perecentText
                        },
                        endOnTick: false,
                        startOnTick: false,
                        opposite: true,
                        tickInterval: 10,
                        min: 40,
                        max: 100
                    }],
                series: [{
                        type: 'column',
                        data: [],
                        color: black,
                        name: ''
                    },
                    {
                        type: 'column',
                        data: [],
                        name: '',
                        color: darkBlue
                    },
                    {
                        type: 'spline',
                        name: furnaceUtilizationText,
                        data: [],
                        yAxis: 1,
                        color: red,
                        tooltip: {
                            headerFormat: '<span style="font-size: 10px">{point.key}</span><br/><span '
                                + 'style="color:{point.color}">●</span><span>' + furnaceUtilizationText + ':</span>',
                            pointFormat: '<b>{point.y}%</b>'
                        },
                        zones: [
                            {
                                value: 95,
                                color: red
                            },
                            {
                                color: green
                            }
                        ]
                    }],
                responsive: {
                    rules: [{
                            condition: {
                                maxWidth: 400
                            },
                            chartOptions: {
                                plotOptions: {
                                    column: {
                                        dataLabels: {
                                            enabled: false
                                        }
                                    }
                                }
                            }
                        }]
                }
            };
            this.dailyFurnaceHelpText = "\n    <div class=\"header\">\n      Month to Date Furnace Utilization\n    </div>\n    <div class=\"subheader\">\n      <span> Data Source: </span>\n      <span class=\"detail\">Legacy AS400</span>\n    </div>    \n    <div class=\"detail\">\n      The chart displays the <b>Tons Melted, Tons Packed, and Furnace Utilization Percentage</b>\n       for the selected tank, for each day in the selected month.\n    </div>    \n    <div class=\"detail\">\n      <b>Tons Melted</b> is taken from the Materials Usage / Commodity File in the legacy\n       AS400 system, summarized by plant, tank, and date.<br/><br/>\n      <span class=\"formula\">Tons Melted = SUM(LBS * Yield / 100 / 2000)</span><br/>\n      <span class=\"footnote\">[where LBS is # of batches * pounds of material and Yield is % of material consumed from Commodity File]</span>\n    </div>\n    <div class=\"detail\">\n      <b>Tons Packed</b> is taken from Job Records in the legacy AS400 system, summarized by plant, tank, and date.<br/><br/>\n      <span class=\"formula\">Tons Packed = SUM(Weight * Gross * .0045)</span><br/>\n      <span class=\"footnote\">[where .0045 is 144/32000 to convert oz-gross to tons]</span>\n    </div>    \n    <div class=\"detail\">\n      <b>Furnace Utilization</b> is calculated from data in the Materials Usage / Commodity\n       File in the legacy AS400 system, summarized by plant, tank, and date.\n      That data is compared against the Nominal Capacity for each furnace.  \n      The Nominal Capacity values are pulled from yearly spreadsheets maintained at corporate.  The\n       Nominal and Environmental Capacities are listed below the titles in the Month to Date and\n        Year to Date Furnace Utilization charts for reference.<br/>\n    </div>\n    <div class=\"detail\">\n      <span class=\"formula\">Furnace Utilization = Tons Melted / Nominal Capacity * # of days * 100</span> \n    </div>    \n    <div class=\"detail\">\n      The Furnace Utilization line markers are <span class=\"red\">red</span> for any percent <b>below\n       95</b> and <span class=\"green\">green</span> for anything <b>95% and above</b>.     \n    </div>\n    ";
            this.monthlyFurnaceChartConfig = {
                chart: {
                    alignTicks: true,
                    zoomType: 'xy',
                    height: chartHeight,
                    spacingBottom: 5,
                    borderWidth: 2,
                    borderColor: '#DDDDDD'
                },
                credits: {
                    enabled: false
                },
                title: {
                    text: '',
                    margin: 0,
                    useHTML: true
                },
                subtitle: {
                    text: legendInstructions,
                    align: 'center',
                    verticalAlign: 'bottom',
                    y: -5,
                    style: {
                        color: gray
                    }
                },
                plotOptions: {
                    column: {
                        dataLabels: {
                            enabled: true,
                            rotation: -90,
                            color: white,
                            align: 'right',
                            format: '{point.y:.1f}',
                            y: 10,
                            style: {
                                fontSize: '11px',
                                fontFamily: 'Verdana, sans-serif'
                            }
                        }
                    },
                    spline: {
                        marker: {
                            radius: 7
                        }
                    }
                },
                xAxis: {
                    categories: []
                },
                tooltip: {
                    valueDecimals: 1
                },
                yAxis: [{
                        title: {
                            text: tonsText
                        }
                    },
                    {
                        title: {
                            text: perecentText
                        },
                        endOnTick: false,
                        startOnTick: false,
                        opposite: true,
                        tickInterval: 10,
                        min: 40,
                        max: 100
                    }],
                series: [{
                        type: 'column',
                        data: [],
                        color: black,
                        name: ''
                    },
                    {
                        type: 'column',
                        data: [],
                        name: '',
                        color: darkBlue
                    },
                    {
                        type: 'spline',
                        name: furnaceUtilizationText,
                        data: [],
                        yAxis: 1,
                        color: red,
                        tooltip: {
                            headerFormat: '<span style="font-size: 10px">{point.key}</span><br/>'
                                + '<span style="color:{point.color}">●</span><span>' + furnaceUtilizationText + ':</span>',
                            pointFormat: '<b>{point.y}%</b>'
                        },
                        zones: [
                            {
                                value: 95,
                                color: red
                            },
                            {
                                color: green
                            }
                        ]
                    }],
                responsive: {
                    rules: [{
                            condition: {
                                maxWidth: 400
                            },
                            chartOptions: {
                                plotOptions: {
                                    column: {
                                        dataLabels: {
                                            enabled: false
                                        }
                                    }
                                }
                            }
                        }]
                }
            };
            this.monthlyFurnaceHelpText = "\n  <div class=\"header\">\n    Year to Date Furnace Utilization\n  </div>\n  <div class=\"subheader\">\n    <span> Data Source: </span>\n    <span class=\"detail\">Legacy AS400</span>\n  </div>    \n  <div class=\"detail\">\n    The chart displays the <b>Tons Melted, Tons Packed, and Furnace Utilization Percentage</b> for\n     the selected tank, for each month in the current year.\n  </div>    \n  <div class=\"detail\">\n    <b>Tons Melted</b> is taken from the Materials Usage / Commodity File in the legacy AS400 system,\n     summarized by plant, tank, and date.<br/><br/>\n    <span class=\"formula\">Tons Melted = SUM(LBS * Yield / 100 / 2000)</span><br/>\n    <span class=\"footnote\">[where LBS is # of batches * pounds of material and Yield is % of material consumed from Commodity File]</span>\n  </div>\n  <div class=\"detail\">\n    <b>Tons Packed</b> is taken from Job Records in the legacy AS400 system, summarized by plant, tank, and date.<br/><br/>\n    <span class=\"formula\">Tons Packed = SUM(Weight * Gross * .0045)</span><br/>\n    <span class=\"footnote\">[where .0045 is 144/32000 to convert oz-gross to tons]</span>\n  </div>    \n  <div class=\"detail\">\n    <b>Furnace Utilization</b> is calculated from data in the Materials Usage / Commodity\n     File in the legacy AS400 system, summarized by plant, tank, and date.\n    That data is compared against the Nominal Capacity for each furnace.  \n    The Nominal Capacity values are pulled from yearly spreadsheets maintained at corporate.  The\n     Nominal and Environmental Capacities are listed below the titles in the Month to Date and Year\n      to Date Furnace Utilization charts for reference.<br/>\n  </div>\n  <div class=\"detail\">\n    <span class=\"formula\">Furnace Utilization = Tons Melted / Nominal Capacity * # of days * 100</span> \n  </div>    \n  <div class=\"detail\">\n    The Furnace Utilization line markers are <span class=\"red\">red</span> for any percent <b>below\n     95</b> and <span class=\"green\">green</span> for anything <b>95% and above</b>.     \n  </div>\n    ";
            this.ytdFurnaceChartConfig = {
                chart: {
                    type: 'solidgauge',
                    width: 280,
                    height: 100
                },
                title: "null",
                pane: {
                    center: ['30%', '85%'],
                    size: '170%',
                    startAngle: -90,
                    endAngle: 90,
                    background: {
                        backgroundColor: Highcharts.defaultOptions.legend.backgroundColor || '#EEE',
                        innerRadius: '75%',
                        outerRadius: '100%',
                        shape: 'arc'
                    }
                },
                tooltip: {
                    enabled: false
                },
                credits: {
                    enabled: false
                },
                yAxis: {
                    min: 0,
                    max: 100,
                    stops: [],
                    lineWidth: 0,
                    minorTickInterval: null,
                    tickAmount: 2,
                    title: {
                        text: '',
                        useHTML: true,
                        y: -30,
                        x: 50
                    },
                    labels: {
                        y: 16,
                    }
                },
                plotOptions: {
                    solidgauge: {
                        innerRadius: '75%',
                        dataLabels: {
                            y: 5,
                            borderWidth: 0,
                            useHTML: true
                        }
                    }
                },
                series: [{
                        data: [],
                        dataLabels: {
                            format: '',
                            x: 0,
                            y: 6
                        }
                    }]
            };
            this.ytdFurnaceHelpText = "\n    <div class=\"header\">\n      YTD Furnace Utilization\n    </div>\n    <div class=\"subheader\">\n      <span> Data Source: </span>\n      <span class=\"detail\">Legacy AS400</span>\n    </div>    \n    <div class=\"detail\">\n      This gauge chart displays the year-to-date <b>Furnace Utilization</b> percentage for the selected tank.\n    </div>    \n    <div class=\"detail\">\n      The <b>Furnace Utilization %</b> determines the color of the gauge chart.  It will show\n       as <span class=\"red\">red</span> for any furnace utilization <b>below 95</b> and\n        <span class=\"green\">green</span> for anything <b>95% and above</b>.      \n    </div>\n    <div class=\"detail\">\n      Furnace Utilization is calculated from data in the Materials Usage / Commodity File in the\n       legacy AS400 system, summarized by plant, tank, and date.\n      That data is compared against the Nominal Capacity for each furnace.  \n      The Nominal Capacity values are pulled from yearly spreadsheets maintained at corporate.  The\n       Nominal and Environmental Capacities are listed below the titles in the Month to Date and\n        Year to Date Furnace Utilization charts for reference.<br/>\n    </div>\n    <div class=\"detail\">\n      <span class=\"formula\">Furnace Utilization = Melted Tons / Nominal Capacity * # of days * 100</span> \n    </div>\n    <div class=\"detail\">      \n      <span class=\"formula\">Melted Tons = SUM(LBS * Yield / 100 / 2000)</span><br/>\n      <span class=\"footnote\">[where LBS is # of batches * pounds of material and Yield is % of material consumed from Commodity File]</span>\n    </div>\n    ";
            this.dailyLineHoldsChartConfig = {
                chart: {
                    alignTicks: true,
                    zoomType: 'xy',
                    height: chartHeight,
                    spacingBottom: 5,
                    borderWidth: 2,
                    borderColor: '#DDDDDD'
                },
                credits: {
                    enabled: false
                },
                title: {
                    text: '',
                    margin: 0,
                    useHTML: true
                },
                subtitle: {
                    text: legendInstructions,
                    align: 'center',
                    verticalAlign: 'bottom',
                    y: -5,
                    style: {
                        color: gray
                    }
                },
                plotOptions: {
                    column: {
                        dataLabels: {
                            enabled: true,
                            rotation: -90,
                            color: white,
                            align: 'right',
                            format: '{point.y:.1f}',
                            y: 10,
                            style: {
                                fontSize: '11px',
                                fontFamily: 'Verdana, sans-serif'
                            }
                        }
                    },
                    spline: {
                        marker: {
                            radius: 7
                        }
                    }
                },
                xAxis: {
                    categories: []
                },
                tooltip: {
                    valueDecimals: 1
                },
                yAxis: [
                    {
                        title: {
                            text: perecentText
                        },
                        endOnTick: false,
                        startOnTick: false,
                        tickAmount: 4
                    }
                ],
                series: [
                    {
                        type: 'spline',
                        name: percentLineHoldsText,
                        data: [],
                        color: darkBlue,
                        tooltip: {
                            headerFormat: '<span style="font-size: 10px">{point.key}</span><br/>'
                                + '<span style="color:{point.color}">●</span><span>' + percentLineHoldsText + ':</span>',
                            pointFormat: '<b>{point.y}%</b>'
                        },
                    }
                ],
                responsive: {
                    rules: [{
                            condition: {
                                maxWidth: 400
                            },
                            chartOptions: {
                                plotOptions: {
                                    column: {
                                        dataLabels: {
                                            enabled: false
                                        }
                                    }
                                }
                            }
                        }]
                }
            };
            this.lineHoldsHelpText = "\n  <div class=\"header\">\n    Month to Date % Line Holds\n  </div>\n  <div class=\"subheader\">\n    <span> Data Source: </span>\n    <span class=\"detail\">Legacy AS400</span>\n  </div>    \n  <div class=\"detail\">\n    The chart displays <b>% Line Holds</b> for each day in the selected month.       \n  </div>  \n  <div class=\"detail\">\n    % Line Holds is calculated from data in Job Records in the legacy AS400 system.  \n    All records where speed > 0 and production hours > 0 are included.<br/>\n  </div>\n  <div class=\"detail\">\n    <span class=\"formula\">% Line Holds = rounded to tenths(Line Holds / Gross * 100)</span><br/>\n    <span class=\"footnote\">[where gross > 0]</span><br/><br/>\n  </div>\n  ";
            this.httpService = httpService;
        }
        ChartConfigServiceImpl.prototype.getDailyPackChartConfig = function () {
            return this.dailyPackChartConfig;
        };
        ChartConfigServiceImpl.prototype.getMonthlyPackChartConfig = function () {
            return this.monthlyPackChartConfig;
        };
        ChartConfigServiceImpl.prototype.getYearlyPackChartConfig = function () {
            return this.ytdPackChartConfig;
        };
        ChartConfigServiceImpl.prototype.getDailyFurnaceChartConfig = function () {
            return this.dailyFurnaceChartConfig;
        };
        ChartConfigServiceImpl.prototype.getMonthlyFurnaceChartConfig = function () {
            return this.monthlyFurnaceChartConfig;
        };
        ChartConfigServiceImpl.prototype.getYearlyFurnaceChartConfig = function () {
            return this.ytdFurnaceChartConfig;
        };
        ChartConfigServiceImpl.prototype.getDailyLineHoldsChartConfig = function () {
            return this.dailyLineHoldsChartConfig;
        };
        ChartConfigServiceImpl.prototype.getHelpText = function (chartType, isShop) {
            if (chartType === 'daily') {
                if (isShop) {
                    return this.dailyPackHelpText;
                }
                return this.dailyPTMHelpText;
            }
            if (chartType === 'monthly') {
                if (isShop) {
                    return this.monthlyPackHelpText;
                }
                return this.monthlyPTMHelpText;
            }
            if (chartType === 'yearly') {
                if (isShop) {
                    return this.yearlyPackHelpText;
                }
                return this.yearlyPTMHelpText;
            }
            if (chartType === 'packProducts') {
                return this.packProductHelpText;
            }
            if (chartType === 'lineHolds') {
                return this.lineHoldsHelpText;
            }
            if (chartType === 'dailyFurnace') {
                return this.dailyFurnaceHelpText;
            }
            if (chartType === 'monthlyFurnace') {
                return this.monthlyFurnaceHelpText;
            }
            if (chartType === 'yearlyFurnace') {
                return this.ytdFurnaceHelpText;
            }
            return "help text not found";
        };
        return ChartConfigServiceImpl;
    }());
    exports.default = angular
        .module('aps.services.chartConfigService', [http_service_1.default])
        .service('chartConfigService', ChartConfigServiceImpl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(3), __webpack_require__(888), __webpack_require__(5), __webpack_require__(4), __webpack_require__(23), __webpack_require__(8), __webpack_require__(889), __webpack_require__(28), __webpack_require__(74), __webpack_require__(6), __webpack_require__(25), __webpack_require__(7), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, constant_module_1, MachineDefectMappings_tpl_html_1, aps_enums_1, loader_service_1, shops_service_1, navigation_service_1, machineDefectMapping_service_1, lineConfigs_service_1, defect_service_1, notify_service_1, defectType_service_1, authData_service_1, _) {
    "use strict";
    machineDefectMappingsCtrl.$inject = ["$modal", "loaderService", "machineDefectMappingService", "lineConfigsService", "defectService", "defectTypeService", "notifyService", "shopService", "navigationService", "authDataService"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default,
        machineDefectMapping_service_1.default,
        lineConfigs_service_1.default, defect_service_1.default, defectType_service_1.default,
        notify_service_1.default, shops_service_1.default, navigation_service_1.default, authData_service_1.default];
    exports.default = angular.module('aps.controller.machineDefectMappings', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.VIEW_MACHINE_DEFECT_MAPPINGS,
            url: '/machineDefectMappings',
            controller: 'machineDefectMappingsCtrl as vm',
            template: MachineDefectMappings_tpl_html_1.default,
            data: {
                pageTitle: 'Machine Defect Mappings'
            }
        });
    }])
        .controller('machineDefectMappingsCtrl', machineDefectMappingsCtrl)
        .name;
    function machineDefectMappingsCtrl($modal, loaderService, machineDefectMappingService, lineConfigsService, defectService, defectTypeService, notifyService, shopService, navigationService, authDataService) {
        var vm = {};
        vm.populateMachineList = function () {
            var _this = this;
            loaderService.loadingPromise(lineConfigsService
                .getLineEquipmentNames()
                .then(function (results) {
                _this.lineEquipmentNames = results.filter(function (a) {
                    return a.name === "CD"
                        || a.name === "WBF"
                        || a.name === "WSI"
                        || a.name === "MX4"
                        || a.name === "MULTI"
                        || a.name === "MCAL"
                        || a.name === "FLXBC"
                        || a.name === "FLXM";
                });
            }));
        };
        vm.populateDefectLossTypes = function () {
            var _this = this;
            loaderService.loadingPromise(defectService
                .getDefectLossTypes().then(function (data) {
                _this.defectLossTypes = data;
            }));
            return;
        };
        vm.populateStandardDefects = function () {
            var promise = defectTypeService.getDefectTypesAndClassificationsNoExclusion()
                .then(function (defectTypesAndClassifications) {
                vm.defectTypes = defectTypesAndClassifications.types;
            }, notifyService.handleApiErrors);
            loaderService.loadingPromise(promise);
            return;
        };
        vm.populateMachineDefects = function (machineName) {
            var _this = this;
            this.machineDefectMappings = null;
            var plantid = vm.plant != undefined ? vm.plant.value : null;
            var shopid = vm.selectedShop != undefined ? vm.selectedShop.id : null;
            if (machineName) {
                loaderService.loadingPromise(machineDefectMappingService
                    .getMachineDefectMappings(machineName, plantid, shopid).then(function (data) {
                    _this.machineDefectMappings = data;
                }));
            }
            return;
        };
        vm.populateMachineDefectsToBeCopied = function (machineName) {
            vm.machineDefectMappings = [];
            var plantIdSrc = vm.plantSrc != undefined ? vm.plantSrc.value : null;
            var shopIdSrc = vm.selectedShopSrc != undefined ? vm.selectedShopSrc.id : null;
            var plantIdDst = vm.plant != undefined ? vm.plant.value : null;
            var shopIdDst = vm.selectedShop != undefined ? vm.selectedShop.id : null;
            if (machineName) {
                loaderService.loadingPromise(machineDefectMappingService
                    .getMachineDefectMappingsForCloning(machineName, plantIdSrc, shopIdSrc, plantIdDst, shopIdDst).then(function (data) {
                    _.each(data, function (item) {
                        var newItem = {
                            id: item.id,
                            lineEquipmentNameId: item.lineEquipmentNameId,
                            lineEquipmentName: item.lineEquipmentName,
                            machineDataPointId: item.machineDataPointId,
                            defectTypeId: item.defectTypeId,
                            lossTypeId: item.lossTypeId,
                            alias: item.alias,
                            extensionTag1: item.extensionTag1,
                            extensionTag2: item.extensionTag2,
                            extensionTag3: item.extensionTag3,
                            severity: item.severity,
                            displayOrder: item.displayOrder,
                            plantId: plantIdDst,
                            shopId: shopIdDst,
                            headerId: item.headerId,
                            machineDataPoint: item.machineDataPoint,
                            isDirty: true,
                            isNew: item.isNew,
                            isIgnored: item.isIgnored
                        };
                        vm.machineDefectMappings.push(newItem);
                    });
                }));
            }
            return;
        };
        vm.getSeverityName = function (id) {
            var defectType = _.find(this.defectTypes, { id: id });
            if (defectType) {
                return aps_enums_1.apsEnums.Severity[defectType.severity];
            }
            return '';
        };
        vm.saveChanges = function () {
            var _this = this;
            if (this.machineDefectMappings && this.machineDefectMappings.length > 0) {
                var promise = machineDefectMappingService.saveMachineDefectMappings(this.machineDefectMappings)
                    .then(function () {
                    alert('Changes saved successfully!');
                    _this.onSelectedEquipmentNameChanged();
                })
                    .catch(notifyService.handleApiErrors);
                loaderService.loadingPromise(promise);
            }
        };
        vm.onSelectedEquipmentNameChanged = function () {
            this.populateMachineDefects(this.selectedEquipmentName);
        };
        vm.initializePlantShops = function () {
            var _this = this;
            var promise = shopService.getShops().then(function (data) {
                vm.shops = data;
                vm.plantNameList = [];
                var plantList = _.uniq(_.map(vm.shops, 'plantName')).sort();
                _.each(plantList, function (name) {
                    var found = _.find(vm.shops, { plantName: name });
                    if (found) {
                        var data_1 = {
                            key: found.plantName,
                            value: found.plantId
                        };
                        vm.plantNameList.push(data_1);
                    }
                });
                return navigationService.getNavigation().then(function (nav) {
                    vm.plant = _.find(vm.plantNameList, { key: nav.selectedPlant.name, value: nav.selectedPlant.id });
                    _this.setPlantAdminForSelectedPlant();
                });
            });
            loaderService.loadingPromise(promise);
        };
        vm.onPlanChanged = function () {
            this.machineDefectMappings = null;
            this.selectedShop = null;
            this.selectedEquipmentName = null;
            this.setPlantAdminForSelectedPlant();
        };
        vm.onShopChanged = function () {
            this.onSelectedEquipmentNameChanged();
        };
        vm.onCopyPlanChanged = function () {
            this.selectedShopSrc = null;
        };
        vm.setPlantAdminForSelectedPlant = function () {
            this.isPlantAdminOfSelectedPlant = !(this.plant) ? authDataService.isAPSIOAdmin() : authDataService.isJobChangeSupervisor(this.plant.value);
        };
        vm.initializePlantShops();
        vm.populateMachineList();
        vm.populateStandardDefects();
        vm.populateDefectLossTypes();
        return vm;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <div class=body-header> <h2><b>Defect Types Mappings:</b>&nbsp;&nbsp;&nbsp;&nbsp; {{(vm.plant ? vm.plant.key: 'All Plant Default') + (vm.selectedShop ? ' - Shop ' + vm.selectedShop.name: '') + (vm.selectedEquipmentName ? ' - Equipment - ' + vm.selectedEquipmentName + ' ' + ( vm.machineDefectMappings? '(' + vm.machineDefectMappings.length + ' sensors)': ''): '') }}</h2> </div> <div class=row style=\"margin:10px 0 -20px 0;width:auto\"> <div class=row style=\"margin:30px -30px -30px -30px;width:auto\"> <div class=\"small-2 columns\"> <label> Plant: <select ng-model=vm.plant name=machineTypes ng-options=\"p.key for p in vm.plantNameList | orderBy : 'key'\" ng-change=vm.onPlanChanged()> <option value=\"\">All Plants</option> </select> </label> </div> <div class=\"small-1 columns\"> <label> Shop: <select name=selectedShop ng-disabled=!vm.plant ng-model=vm.selectedShop ng-options=\"shop as 'shop ' + shop.name for shop in vm.shops | filter : vm.plant.value\" ng-change=vm.onShopChanged()> <option value=\"\">All</option> </select> </label> </div> <div class=\"small-1 columns\"> <label> Machine: <select id=machineList ng-model=vm.selectedEquipmentName ng-options=\"c.name as c.name for c in vm.lineEquipmentNames | orderBy: 'name'\" ng-change=vm.onSelectedEquipmentNameChanged()> <option value=\"\">....</option> </select> </label> </div> <div class=\"small-3 columns\"> <label ng-if=\"vm.plant && vm.isPlantAdminOfSelectedPlant\"> {{'Copying from ' + (vm.plantSrc ? vm.plantSrc.key: 'Companys Default')  + (vm.selectedShopSrc ? ' shop ' + vm.selectedShopSrc.name: '') }}&nbsp; <select name=machineTypes ng-model=vm.plantSrc ng-options=\"p.key for p in vm.plantNameList | orderBy : 'key'\" ng-change=vm.onCopyPlanChanged()> <option value=\"\">All Plants</option> </select> </label> </div> <div class=\"small-1 columns\"> <label>&nbsp; <select ng-if=\"vm.plant && vm.isPlantAdminOfSelectedPlant\" name=selectedShopSrc ng-disabled=!vm.plantSrc ng-model=vm.selectedShopSrc ng-options=\"shop as 'shop ' + shop.name for shop in vm.shops | filter : vm.plantSrc.value\"> <option value=\"\">....</option> </select> </label> </div> <div class=\"small-2 columns\"> <button ng-if=\"vm.plant && vm.isPlantAdminOfSelectedPlant\" ng-click=vm.populateMachineDefectsToBeCopied(vm.selectedEquipmentName) class=\"button small\" style=position:relative;top:14px>Pull Copy</button> </div> <div class=\"small-2 columns\"> <button ng-if=vm.isPlantAdminOfSelectedPlant ng-click=vm.saveChanges() class=\"button small\" style=position:relative;top:14px>Save Changes</button> </div> </div> <div ng-if=vm.searched class=row style=\"margin:100px -30px -30px -30px;width:auto;text-align:center\"> <span>No Mapping Exists!!!!</span> </div> </div> <table ng-if=vm.machineDefectMappings class=history-t> <tr> <thead> <th style=width:60px>Default</th> <th style=width:240px>Machine Defect</th> <th style=width:60px>Ignore</th> <th style=width:220px>Mapping Alias</th> <th style=width:220px>APS Defect Type</th> <th style=width:100px>Severity</th> <th style=width:130px>Loss Type</th> <th>Machine Sensor</th> </thead> </tr> <tr ng-repeat=\"mapping in vm.machineDefectMappings | orderBy:'machineDataPoint.config'\"> <td style=text-align:center> <input type=checkbox ng-model=mapping.isNew disabled=disabled /> </td> <td ng-bind=mapping.machineDataPoint.name></td> <td style=text-align:center> <input type=checkbox ng-model=mapping.isIgnored /> </td> <td> <input name=alias maxlength=64 type=text ng-model=mapping.alias /> </td> <td> <select ng-model=mapping.defectTypeId name=defectTypes ng-options=\"c.id as c.name for c in vm.defectTypes | orderBy: 'name'\"> <option value=\"\">N/A</option> </select> </td> <td ng-bind=vm.getSeverityName(mapping.defectTypeId)></td> <td> <select id=lossType ng-model=mapping.lossTypeId ng-options=\"c.id as c.name for c in vm.defectLossTypes | orderBy: 'name'\"> <option value=\"\">N/A</option> </select> </td> <td ng-bind=mapping.machineDataPoint.config></td> </tr> </table> </div> ");

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(10), __webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, http_service_1, constant_module_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.services.machineDefectMapping', [http_service_1.default])
        .service('machineDefectMappingService', ["httpService", function (httpService) {
        function getMachineDefectMappings(machineName, plantId, shopId) {
            return httpService.get(constant_module_1.Endpoints.MACHINE_DEFECT_MAPPINGS, { machineName: machineName, plantId: plantId, shopId: shopId });
        }
        function getMachineDefectMappingsForCloning(machineName, plantId, shopId, plantIdDst, shopIdDst) {
            return httpService.get(constant_module_1.Endpoints.MACHINE_DEFECT_MAPPINGS_FOR_CLONING, { machineName: machineName, plantId: plantId, shopId: shopId, plantIdDst: plantIdDst, shopIdDst: shopIdDst });
        }
        var saveMachineDefectMappings = function (machineDefects) {
            return httpService.post(constant_module_1.Endpoints.MACHINE_DEFECT_MAPPINGS, machineDefects);
        };
        return {
            getMachineDefectMappings: getMachineDefectMappings,
            getMachineDefectMappingsForCloning: getMachineDefectMappingsForCloning,
            saveMachineDefectMappings: saveMachineDefectMappings,
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(3), __webpack_require__(891), __webpack_require__(4), __webpack_require__(16), __webpack_require__(7), __webpack_require__(8), __webpack_require__(5), __webpack_require__(43)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, constant_module_1, productionShiftReport_tpl_html_1, loader_service_1, report_service_1, authData_service_1, navigation_service_1, aps_enums_1, environment_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, report_service_1.default, authData_service_1.default, navigation_service_1.default, environment_1.default];
    var ProductionShiftReportCtrl = (function () {
        ProductionShiftReportCtrl.$inject = ["$state", "$stateParams", "navigationService", "reportService", "loaderService", "authDataService", "environment", "$q"];
        function ProductionShiftReportCtrl($state, $stateParams, navigationService, reportService, loaderService, authDataService, environment, $q) {
            var _this = this;
            var vm = this;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.loaderService = loaderService;
            this.reportService = reportService;
            this.authDataService = authDataService;
            this.environment = environment;
            this.$q = $q;
            this.showExcel = true;
            this.reportDate = moment().add(-1, 'days').toDate();
            var promise = navigationService.getNavigation().then(function (navModel) {
                _this.plants = navModel.plants();
                _this.selectedPlant = navModel.selectedPlant;
                _this.loadState($stateParams);
            });
            this.appPath = this.environment.API_PATH;
            loaderService.loadingPromise(promise.then(function () {
                if ($stateParams.userId == 'd7660000-ff45-0003-cea2-08d59f072b0f') {
                    _this.showExcel = false;
                    _this.generateReport(false);
                }
            }));
        }
        ProductionShiftReportCtrl.prototype.loadState = function (params) {
            if (params.reportPlantId && params.reportPlantId !== params.plantId) {
                var plant = _.find(this.plants, { id: params.reportPlantId });
                if (plant) {
                    this.selectedPlant = plant;
                }
            }
            if (params.reportDate) {
                var reportDate = moment(params.reportDate);
                if (reportDate.isValid()) {
                    this.reportDate = reportDate.toDate();
                }
            }
        };
        ProductionShiftReportCtrl.prototype.saveState = function () {
            var reportPlantId = this.selectedPlant ? this.selectedPlant.id : undefined;
            if (reportPlantId === this.$stateParams.plantId) {
                reportPlantId = undefined;
            }
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportPlantId: reportPlantId,
                reportDate: this.reportDate ? this.reportDate.toISOString() : undefined
            };
            this.$state.transitionTo(this.$state.current.name, params);
        };
        ProductionShiftReportCtrl.prototype.getMaxMachineSections = function () {
            return new Array(this.maxMachineSections);
        };
        ProductionShiftReportCtrl.prototype.getMachineName = function (shop, index) {
            var machine = shop.shifts[1].lineItem.machineLosses[index];
            return machine == null ? '' : machine.machineName;
        };
        ProductionShiftReportCtrl.prototype.getMachineLossForShift = function (shift, index) {
            var machine = shift.lineItem.machineLosses[index];
            return machine == null ? '' : machine.loss.toFixed(1);
        };
        ProductionShiftReportCtrl.prototype.getMachineLossForShop = function (shop, index) {
            if (shop.shopTotals == null || shop.shopTotals.machineLosses == null) {
                return null;
            }
            var machine = shop.shopTotals.machineLosses[index];
            return machine == null ? '' : machine.loss.toFixed(1);
        };
        ProductionShiftReportCtrl.prototype.getMachineLossForLine = function (shift, machineIndex, line) {
            var machine = shift.lineItem.machineLosses[machineIndex];
            var lineDetail = machine == null ? null : _.find(machine.lineDetail, function (detail) { return detail.line == line; });
            return lineDetail == null ? '' : lineDetail.lossPercentage.toFixed(1);
        };
        ProductionShiftReportCtrl.prototype.getDistinctLinesForShop = function (losses) {
            return _.uniq(_.flatten(losses.map(function (obj) {
                return obj.lineDetail.map(function (obj2) {
                    return obj2.line;
                });
            })));
        };
        ProductionShiftReportCtrl.prototype.updatePlant = function () {
            this.report = null;
        };
        ProductionShiftReportCtrl.prototype.generateReport = function (regenerate) {
            if (this.form.$invalid) {
                return;
            }
            this.saveState();
            this.loaderService.loadingPromise(this.runReport());
            this.formattedReportDate = moment(this.reportDate).format("dddd, MM/DD/YYYY");
            if (this.formattedReportDate.indexOf("Friday") == -1 && this.formattedReportDate.indexOf("Saturday") == -1) {
                this.isWeekend = false;
            }
            else {
                this.isWeekend = true;
            }
            this.isPreRelease = false;
            if (this.selectedPlant.id === 'bbdf0000-3a00-000d-d6c3-08d2e5fa8dd2') {
                this.isPreRelease = true;
            }
        };
        ProductionShiftReportCtrl.prototype.exportToExcel = function () {
            this.loaderService.loadingPromise(this.reportService.exportToExcel(aps_enums_1.apsEnums.ExcelExports.ProductionReport, this.selectedPlant.id, this.reportDate));
        };
        ;
        ProductionShiftReportCtrl.prototype.setMaxMachines = function () {
            var maxMachines = 0;
            _.forEach(this.report.shops, function (shop) {
                _.forEach(shop.shifts, function (shift) {
                    var machineCount = shift.lineItem.machineLosses.length;
                    if (machineCount > maxMachines) {
                        maxMachines = machineCount;
                    }
                });
            });
            this.maxMachineSections = maxMachines;
        };
        ProductionShiftReportCtrl.prototype.runReport = function () {
            var _this = this;
            var promise = this.reportService.getProductionShiftReport(this.selectedPlant.id, this.reportDate);
            promise.then(function (report) {
                _this.report = report;
                _this.setMaxMachines();
            });
            return promise;
        };
        return ProductionShiftReportCtrl;
    }());
    exports.default = angular.module('aps.controller.productionShiftReport', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.PRODUCTION_SHIFT_REPORT,
            url: '/productionShiftReportV1',
            params: {
                reportDate: { dynamic: true },
                reportPlantId: { dynamic: true }
            },
            controller: 'ProductionShiftReportCtrl as vm',
            template: productionShiftReport_tpl_html_1.default,
            data: {
                pageTitle: 'Production Shift Report'
            }
        });
    }])
        .controller('ProductionShiftReportCtrl', ProductionShiftReportCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div class=body-header> <h2>Production Shift Report</h2> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-6 columns\"> <label> <span class=\"required notated\">*</span>Plant <select ng-model=vm.selectedPlant ng-options=\"plant as plant.name for plant in vm.plants\" ng-change=vm.updatePlant() name=selectedPlant required> <option value=\"\">-- Select a Plant --</option> </select> <div ng-messages=vm.form.selectedPlant.$error ng-if=\"vm.form.selectedPlant.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> <div class=\"small-6 columns\"> <label> <span class=\"required notated\">*</span>Report Date <input type=date ng-model=vm.reportDate name=reportDate required/> <div ng-messages=vm.form.reportDate.$error ng-if=\"vm.form.reportDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns\"> <button type=submit class=button>Generate Report</button> </div> </div> <div id=MainReport class=\"row shiftReport\" ng-if=\"vm.report != null\" style=\"margin:0 -25px;width:auto\"> <div class=header> <div class=\"left leftAlign\"><b>{{vm.selectedPlant.name}} Shift Report - {{ vm.formattedReportDate }}</b></div> <div style=width:100%;padding-right:235px><a ng-if=vm.showExcel ng-click=vm.exportToExcel() class=right>Save as Excel</a></div> </div> <div class=header style=color:red ng-show=vm.isWeekend>Weekend reports are preliminary only and are finalized on Monday</div> <div class=header style=color:red ng-show=vm.isPreRelease>This is a PRE-RELEASE of the production report</div> <!-- Main Shift Data Section--> <div class=row ng-repeat=\"shop in vm.report.shops\"> <table class=shopSection> <thead> <tr> <th class=sectionHeader rowspan=2>Shop</th> <th class=sectionHeader rowspan=2>Shift</th> <th class=\"sectionHeader moldColumn\" rowspan=2>Mold</th> <th class=sectionHeader rowspan=2>Short Item</th> <th class=sectionHeader rowspan=2>Weight</th> <th class=\"sectionHeader speedColumn\" rowspan=2>Prod <br/>Speed</th> <th class=sectionHeader rowspan=2>JCI</th> <th class=sectionHeader rowspan=2>KCR</th> <th class=\"sectionHeader headerspan\" colspan=3>Pallets</th> <th class=sectionHeader rowspan=2>% <br/>Downtime</th> <th class=sectionHeader rowspan=2>Downtime<br/>Tons</th> <th class=sectionHeader rowspan=2>Melted Tons</th> <th class=sectionHeader rowspan=2>Packed Tons</th> <!-- Downtime code column will go here - Phase 2 --> <th class=\"sectionHeader heEfficiencyColumn\" rowspan=2>HE <br/>Eff</th> <!-- HE Loss columns will go here - Phase 2 --> <th ng-repeat=\"x in vm.getMaxMachineSections() track by $index\" class=\"sectionHeader machineColumn\" rowspan=2> {{ vm.getMachineName(shop, $index)}} </th> <th class=\"sectionHeader totRejColumn\" rowspan=2>Tot <br/>Rej</th> <!-- Remove for now as we don't have this --> <!-- <th class=\"sectionHeader\" rowspan=\"2\">PTP <br/>E1</th> --> <th class=\"sectionHeader ptpColumn\" rowspan=2>PTM</th> <!-- <th class=\"sectionHeader ptpColumn\" rowspan=\"2\">PTP</th> --> </tr> <tr> <th class=\"sectionHeader palletColumn\">A</th> <th class=\"sectionHeader palletColumn\">H</th> <th class=\"sectionHeader palletColumn\">R</th> </tr> </thead> <tbody> <tr ng-repeat-start=\"shift in shop.shifts\" ng-class-even=\"'even'\"> <td ng-class=\"{'sectionData': !vm.showLines, 'sectionDataWithLines': vm.showLines, 'noTopBorder': $index===0}\" class=\"sectionData leftAlign\">{{shop.shopName}}</td> <td class=\"sectionData leftAlign\">{{shift.shiftName}}</td> <td class=\"sectionData leftAlign\">{{shift.mold}}</td> <td class=\"sectionData leftAlign\">{{shift.lineItem.shortItem}}</td> <td class=sectionData>{{shift.weight | number: 2}}</td> <td class=sectionData>{{shift.speed | number: 1}}</td> <td class=sectionData>{{shift.jci | number : 1}}</td> <td class=sectionData>{{shift.lineItem.kcr | number : 1}}</td> <td class=sectionData>{{shift.lineItem.acceptedPallets}}</td> <td class=sectionData>{{shift.lineItem.heldPallets}}</td> <td class=sectionData>{{shift.lineItem.reintroducedPallets}}</td> <td class=sectionData>{{shift.lineItem.percentDowntime | number : 1}}</td> <td class=sectionData>{{shift.lineItem.downtimeTons | number: 1}}</td> <td class=sectionData>{{ ((shift.lineItem.meltedOunces * 0.0625) / 2000) | number : 1}}</td> <td class=sectionData>{{ ((shift.lineItem.packedOunces * 0.0625) / 2000) | number : 1}}</td> <!-- Downtime code column will go here - Phase 2 --> <td ng-class=\"{'sectionData': !vm.showLines, 'sectionDataWithLines': vm.showLines, 'noTopBorder': $index===0}\"> {{shift.lineItem.heEfficiency | number : 1}}</td> <!-- HE Loss columns will go here - Phase 2 --> <td ng-class=\"{'sectionData': !vm.showLines, 'sectionDataWithLines': vm.showLines, 'noTopBorder': $parent.$index===0}\" ng-repeat=\"x in vm.getMaxMachineSections() track by $index\"> {{ vm.getMachineLossForShift(shift, $index)}} </td> <td ng-class=\"{'sectionData': !vm.showLines, 'sectionDataWithLines': vm.showLines, 'noTopBorder': $index===0}\"> {{shift.lineItem.totalRejected | number : 1}}</td> <!-- Commented out until we have this data --> <!-- <td ng-class=\"{'sectionData': !vm.showLines, 'sectionDataWithLines': vm.showLines, 'noTopBorder': $index===0}\">{{shift.lineItem.e1PTM | number : 1}}</td> --> <td ng-class=\"{'sectionData': !vm.showLines, 'sectionDataWithLines': vm.showLines, 'noTopBorder': $index===0}\">{{shift.lineItem.apsPTM | number : 1}}</td> <!-- <td ng-class=\"{'sectionData': !vm.showLines, 'sectionDataWithLines': vm.showLines, 'noTopBorder': $index===0}\">{{shift.lineItem.apsPTP | number : 1}}</td> --> </tr> <tr ng-repeat-end ng-repeat=\"line in vm.getDistinctLinesForShop(shift.lineItem.machineLosses)\" ng-if=vm.showLines ng-class=\"{'even': $parent.$parent.$odd}\"> <td colspan=13></td> <td class=rowHeader>Line {{line}}</td> <td ng-class=\"{'sectionDataWithLines': vm.getMachineLossForLine(shift, $index, line) != '', 'sectionDataRightBorder': $last}\" ng-repeat=\"x in vm.getMaxMachineSections() track by $index\"> {{ vm.getMachineLossForLine(shift, $index, line)}} </td> </tr> </tbody> <tfoot> <tr> <td class=\"sectionFooter leftAlign\" colspan=4>{{shop.shopName}}</td> <td class=sectionFooter>{{shop.shopShiftWeightAverage | number: 2}}</td> <td class=\"sectionFooter leftAlign\" colspan=2></td> <td class=sectionFooter>{{shop.shopTotals.kcr | number : 1}}</td> <td class=sectionFooter>{{shop.shopTotals.acceptedPallets}}</td> <td class=sectionFooter>{{shop.shopTotals.heldPallets}}</td> <td class=sectionFooter>{{shop.shopTotals.reintroducedPallets}}</td> <td class=sectionFooter>{{shop.shopTotals.percentDowntime | number : 1}}</td> <td class=sectionFooter>{{shop.shopTotals.downtimeTons | number : 1}}</td> <td class=sectionFooter>{{ ((shop.shopTotals.meltedOunces * 0.0625) / 2000) | number : 1}}</td> <td class=sectionFooter>{{ ((shop.shopTotals.packedOunces * 0.0625) / 2000) | number : 1}}</td> <!-- Downtime code column will go here - Phase 2 --> <td class=sectionFooter>{{shop.shopTotals.heEfficiency | number : 1}}</td> <!-- HE Loss columns will go here - Phase 2 --> <td class=sectionFooter ng-repeat=\"x in vm.getMaxMachineSections() track by $index\"> {{ vm.getMachineLossForShop(shop, $index)}} </td> <td class=sectionFooter>{{shop.shopTotals.totalRejected | number : 1}}</td> <!-- Commented out until we have this data --> <!-- <td class=\"sectionFooter\">{{shop.shopTotals.e1PTM | number : 1}}</td> --> <td class=sectionFooter>{{shop.shopTotals.apsPTM | number : 1}}</td> <!-- <td class=\"sectionFooter\">{{shop.shopTotals.apsPTP | number : 1}}</td>  --> </tr> </tfoot> </table> </div> <!-- Furnace Utilization Section --> <div class=\"row left\" ng-if=\"vm.report.furnaceUtilization != null\"> <table class=furnaceUtilizationSection> <thead> <tr> <th class=sectionHeader>Furn</th> <th class=sectionHeader>Util. Rate</th> <th class=sectionHeader>Melted Tons</th> <th class=sectionHeader>Packed Tons</th> <th class=sectionHeader>KCR</th> <th class=sectionHeader>PTM</th> <th class=sectionHeader>Pal</th> <th class=sectionHeader>Held Pal</th> <th class=sectionHeader>% Held</th> </tr> </thead> <tbody> <tr ng-repeat=\"furnace in vm.report.furnaceUtilization.furnaceItems\" ng-class-even=\"'even'\"> <td class=\"sectionData leftAlign\">{{furnace.name}}</td> <td class=sectionData>{{furnace.utilization | number: 1}}</td> <td class=sectionData>{{furnace.grossTons | number: 1}}</td> <td class=sectionData>{{furnace.packedTons | number: 1}}</td> <td class=sectionData>{{furnace.kcr | number: 1}}</td> <td class=sectionData>{{furnace.ptm | number: 1}}</td> <td class=sectionData>{{furnace.allPallets}}</td> <td class=sectionData>{{furnace.heldPallets}}</td> <td class=sectionData>{{furnace.percentHeld | number: 2}}</td> </tr> </tbody> <tfoot> <tr> <td class=\"sectionFooter leftAlign\">{{vm.report.furnaceUtilization.plantTotals.name}}</td> <td class=sectionFooter>{{vm.report.furnaceUtilization.plantTotals.utilization | number: 1}}</td> <td class=sectionFooter>{{vm.report.furnaceUtilization.plantTotals.grossTons | number: 1}}</td> <td class=sectionFooter>{{vm.report.furnaceUtilization.plantTotals.packedTons | number: 1}}</td> <td class=sectionFooter>{{vm.report.furnaceUtilization.plantTotals.kcr | number: 1}}</td> <td class=sectionFooter>{{vm.report.furnaceUtilization.plantTotals.ptm | number: 1}}</td> <td class=sectionFooter>{{vm.report.furnaceUtilization.plantTotals.allPallets}}</td> <td class=sectionFooter>{{vm.report.furnaceUtilization.plantTotals.heldPallets | number: 1}}</td> <td class=sectionFooter>{{vm.report.furnaceUtilization.plantTotals.percentHeld | number: 1}}</td> </tr> </tfoot> </table> </div> <!-- Gross/Packed Tons Section --> <div class=\"row left\" ng-if=\"vm.report.grossPackedTons != null\"> <table class=grossTonsSection> <thead> <tr> <th></th> <th class=sectionHeader>Day</th> <th class=sectionHeader>Month</th> <th class=sectionHeader>Month AOP</th> <th class=sectionHeader>Year</th> <th class=sectionHeader>Year AOP</th> </tr> </thead> <tbody> <tr> <td class=rowHeader>Melted Tons</td> <td class=sectionData>{{vm.report.grossPackedTons.grossTons.day | number: 1}}</td> <td class=sectionData>{{vm.report.grossPackedTons.grossTons.month | number: 1}}</td> <td class=sectionData>{{vm.report.grossPackedTons.grossTons.monthAop | number: 1}}</td> <td class=sectionData>{{vm.report.grossPackedTons.grossTons.year | number: 1}}</td> <td class=sectionData>{{vm.report.grossPackedTons.grossTons.yearAop | number: 1}}</td> </tr> <tr class=even> <td class=\"rowHeader last\">Packed Tons</td> <td class=sectionData>{{vm.report.grossPackedTons.packedTons.day | number: 1}}</td> <td class=sectionData>{{vm.report.grossPackedTons.packedTons.month | number: 1}}</td> <td class=sectionData>{{vm.report.grossPackedTons.packedTons.monthAop | number: 1}}</td> <td class=sectionData>{{vm.report.grossPackedTons.packedTons.year | number: 1}}</td> <td class=sectionData>{{vm.report.grossPackedTons.packedTons.yearAop | number: 1}}</td> </tr> </tbody> </table> </div> <!-- Tank Data Section --> <div class=row ng-if=\"vm.report.tankData != null\"> <table class=tankSection> <thead> <tr> <th class=sectionHeader>Furn</th> <th class=sectionHeader>Consum. <br/>(kcal/Kg)</th> <th class=sectionHeader>Consum. <br/>(MMBTU/ton)</th> <th class=sectionHeader>Cullet <br/>%</th> <th class=sectionHeader>Seeds</th> <th class=sectionHeader>Throat <br/>Temp.</th> <th class=sectionHeader>BW OPT</th> <th class=sectionHeader>Bot Temp.</th> <th class=sectionHeader>Glass <br/>Density</th> <th class=sectionHeader>Nox</th> <th class=sectionHeader>Sox</th> </tr> </thead> <tbody> <tr ng-repeat=\"tank in vm.report.tankData.tankItems\" ng-class-even=\"'even'\"> <td class=\"sectionData leftAlign\">{{tank.name}}</td> <td class=sectionData>{{tank.meltEnergyKcalKg | number: 1}}</td> <td class=sectionData>{{tank.meltEnergy | number: 1}}</td> <td class=sectionData>{{tank.culletPercent | number: 1}}</td> <td class=sectionData>{{tank.seed | number: 3}}</td> <td class=sectionData>{{tank.throatTemp | number: 1}}</td> <td class=sectionData>{{tank.bwOpt | number: 1}}</td> <td class=sectionData>{{tank.botTemp | number: 1}}</td> <td class=sectionData>{{tank.glassDensity | number: 4}}</td> <td class=sectionData>{{tank.nox | number: 1}}</td> <td class=sectionData>{{tank.sox | number: 1}}</td> </tr> <tr> <td class=leftAlign colspan=11 style=font-size:.7em;font-style:italic>* Certain furnace data may not be available on weekends</td> </tr> </tbody> </table> </div> <!-- PTM Section --> <div class=\"row left\" ng-if=\"vm.report.packToMeltSummary != null\"> <table class=ptmSection> <thead> <tr> <th class=\"sectionHeader headerspan\" colspan=12>PTM/PTP</th> </tr> <tr> <th class=sectionHeader></th> <th ng-repeat=\"shift in vm.report.packToMeltSummary.totals.shifts\" class=sectionHeader>{{shift.name}} </th> <th class=sectionHeader>Day</th> <th class=\"sectionHeader secondaryHeader\">Previous<br/>Day</th> <th class=sectionHeader>Month</th> <th class=sectionHeader>Month<br/>AOP</th> <th class=\"sectionHeader secondaryHeader\">Previous<br/>Month</th> <th class=sectionHeader>Year</th> <th class=sectionHeader>Year<br/>AOP</th> <th class=\"sectionHeader secondaryHeader\">Previous<br/>Year</th> </tr> </thead> <tbody> <tr ng-repeat=\"shop in vm.report.packToMeltSummary.shops\" ng-class-even=\"'even'\"> <td class=\"sectionData leftAlign\">Shop {{shop.name}} (PTP)</td> <td ng-repeat=\"shift in shop.shifts\" class=sectionData>{{shift.ptp | number: 1}}</td> <td class=sectionData>{{shop.day | number: 1}}</td> <td class=\"sectionData secondaryData\">{{shop.previousDay | number: 1}}</td> <td class=sectionData>{{shop.month | number: 1}}</td> <td class=sectionData>{{shop.monthAop | number: 1}}</td> <td class=\"sectionData secondaryData\">{{shop.previousMonth | number: 1}}</td> <td class=sectionData>{{shop.year | number: 1}}</td> <td class=sectionData>{{shop.yearAop | number: 1}}</td> <td class=\"sectionData secondaryData\">{{shop.previousYear | number: 1}}</td> </tr> </tbody> <tfoot> <tr ng-repeat=\"tank in vm.report.packToMeltSummary.tanks\"> <td class=\"sectionSubfooter leftAlign\">Tank {{tank.name}} (PTM)</td> <td ng-repeat=\"shift in tank.shifts\" class=sectionSubfooter>{{shift.ptm | number: 1}}</td> <td class=sectionSubfooter>{{tank.day | number: 1}}</td> <td class=\"sectionSubfooter secondaryData\">{{tank.previousDay | number: 1}}</td> <td class=sectionSubfooter>{{tank.month | number: 1}}</td> <td class=sectionSubfooter>{{tank.monthAop | number: 1}}</td> <td class=\"sectionSubfooter secondaryData\">{{tank.previousMonth | number: 1}}</td> <td class=sectionSubfooter>{{tank.year | number: 1}}</td> <td class=sectionSubfooter>{{tank.yearAop | number: 1}}</td> <td class=\"sectionSubfooter secondaryData\">{{tank.previousYear | number: 1}}</td> </tr> <tr> <td class=\"sectionFooter leftAlign\">Plant (PTM)</td> <td ng-repeat=\"shift in vm.report.packToMeltSummary.totals.shifts\" class=sectionFooter>{{shift.ptm | number: 1}}</td> <td class=sectionFooter>{{vm.report.packToMeltSummary.totals.day | number: 1}}</td> <td class=\"sectionFooter secondaryData\">{{vm.report.packToMeltSummary.totals.previousDay | number: 1}} </td> <td class=sectionFooter>{{vm.report.packToMeltSummary.totals.month | number: 1}}</td> <td class=sectionFooter>{{vm.report.packToMeltSummary.totals.monthAop | number: 1}}</td> <td class=\"sectionFooter secondaryData\">{{vm.report.packToMeltSummary.totals.previousMonth | number: 1}} </td> <td class=sectionFooter>{{vm.report.packToMeltSummary.totals.year | number: 1}}</td> <td class=sectionFooter>{{vm.report.packToMeltSummary.totals.yearAop | number: 1}}</td> <td class=\"sectionFooter secondaryData\">{{vm.report.packToMeltSummary.totals.previousYear | number: 1}} </td> </tr> </tfoot> </table> </div> <!-- KCR Section --> <div class=\"row left\" ng-if=\"vm.report.kcrSummary != null\"> <table class=kcrSection> <thead> <tr> <th class=\"sectionHeader headerspan\" colspan=6>KCR</th> </tr> <tr> <th class=sectionHeader></th> <th class=sectionHeader>Day<br/></th> <th class=sectionHeader>Month</th> <th class=sectionHeader>Year</th> </tr> </thead> <tbody> <tr ng-repeat=\"shop in vm.report.kcrSummary.shops\" ng-class-even=\"'even'\"> <td class=sectionData>Shop {{shop.name}}</td> <td class=sectionData>{{shop.day | number: 1}}</td> <td class=sectionData>{{shop.month | number: 1}}</td> <td class=sectionData>{{shop.year | number: 1}}</td> </tr> </tbody> <tfoot> <tr ng-repeat=\"tank in vm.report.kcrSummary.tanks\"> <td class=sectionSubfooter>Tank {{tank.name}}</td> <td class=sectionSubfooter>{{tank.day | number: 1}}</td> <td class=sectionSubfooter>{{tank.month | number: 1}}</td> <td class=sectionSubfooter>{{tank.year | number: 1}}</td> </tr> <tr> <td class=sectionFooter>Plant</td> <td class=sectionFooter>{{vm.report.kcrSummary.totals.day | number: 1}}</td> <td class=sectionFooter>{{vm.report.kcrSummary.totals.month | number: 1}}</td> <td class=sectionFooter>{{vm.report.kcrSummary.totals.year | number: 1}}</td> </tr> </tfoot> </table> </div> <!-- JCI Section --> <div class=\"row left\" ng-if=\"vm.report.jciSummary != null\"> <table class=kcrSection> <thead> <tr> <th class=\"sectionHeader headerspan\" colspan=6>JCI</th> </tr> <tr> <th class=sectionHeader></th> <th class=sectionHeader>Day<br/></th> <th class=sectionHeader>Month</th> <th class=sectionHeader>Year</th> </tr> </thead> <tbody> <tr ng-repeat=\"shop in vm.report.jciSummary.shops\" ng-class-even=\"'even'\"> <td class=sectionData>Shop {{shop.name}}</td> <td class=sectionData>{{shop.day | number: 1}}</td> <td class=sectionData>{{shop.month | number: 1}}</td> <td class=sectionData>{{shop.year | number: 1}}</td> </tr> </tbody> <tfoot> <tr ng-repeat=\"tank in vm.report.jciSummary.tanks\"> <td class=sectionSubfooter>Tank {{tank.name}}</td> <td class=sectionSubfooter>{{tank.day | number: 1}}</td> <td class=sectionSubfooter>{{tank.month | number: 1}}</td> <td class=sectionSubfooter>{{tank.year | number: 1}}</td> </tr> <tr> <td class=sectionFooter>Plant</td> <td class=sectionFooter>{{vm.report.jciSummary.totals.day | number: 1}}</td> <td class=sectionFooter>{{vm.report.jciSummary.totals.month | number: 1}}</td> <td class=sectionFooter>{{vm.report.jciSummary.totals.year | number: 1}}</td> </tr> </tfoot> </table> </div> <div style=\"padding:300px 0 0 0\"> <div class=shiftReportLegend ng-if=\"vm.report != null\"> <div style=page-break-after:always> &nbsp; </div> <div class=heading> Definitions and Calculations (sample data) </div> <div> <hr> </div> <!-- Shift row section 1 --> <div class=section> <div class=image> <img src=" + __webpack_require__(313) + "> </div> <div class=helpText> <table> <tr> <td class=columnName>Shop</td> <td class=definition>Shop name</td> <td class=calculation></td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Shift</td> <td class=definition>Shift abbreviation</td> <td class=calculation>D = Day, E = Evening, N = Night</td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Mold</td> <td class=definition>Job mold and finish</td> <td class=calculation></td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Short Item</td> <td class=definition>Short item number</td> <td class=calculation></td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Weight</td> <td class=definition>Average weight recorded over job run/shift</td> <td class=calculation></td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Prod Speed</td> <td class=definition>Machine speed calculated from shears or machine pulses</td> <td class=calculation></td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>JCI</td> <td class=definition>Job Change Index</td> <td class=calculation>For new jobs, calculation is: (First 12 Hours End Of Line Counts) / (Theoretical 12 Hours of Production) * 100</td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>KCR</td> <td class=definition></td> <td class=calculation>Square root &#8730; (Speed * Average weight in grams) / Machine sections / Number of gobs)</td> <td class=source>source: APS</td> </tr> </table> </div> </div> <div> <hr> </div> <!-- Shift row section 2 --> <div class=section> <div class=image> <img src=" + __webpack_require__(314) + "> </div> <div class=helpText> <table> <tr> <td class=columnName>Pallets</td> <td class=definition>Pallets during shift</td> <td class=calculation>A = Accepted, H = Held, R = Reintroduced</td> <td class=source>source: WMS</td> </tr> <tr> <td class=columnName>% Downtime</td> <td class=definition>Percent downtime during job run/shift</td> <td class=calculation>((Total downtime minutes from linesheet + Streaming Minutes)/ Total available machine section minutes) * 100</td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Downtime Tons</td> <td class=definition>Downtime Tons from streaming glass during job run/shift</td> <td class=calculation>(Speed * Weight * (Total downtime minutes from linesheet)) + Streaming Tons</td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Melted Tons</td> <td class=definition>Melted tons during job run/shift</td> <td class=calculation>(Speed * Weight * (TotalTime - StreamingTime)) + Streaming Tons</td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Packed Tons</td> <td class=definition>Packed tons during shift</td> <td class=calculation>WMS bottle count * Weight</td> <td class=source>source: APS & WMS</td> </tr> <tr> <td class=columnName>HE Eff</td> <td class=definition>Hot end efficiency</td> <td class=calculation>(LEHR In/ SHEARS) * 100</td> <td class=source>source: APS</td> </tr> </table> </div> </div> <div> <hr> </div> <!-- Shift row section 3 --> <div class=section> <div class=image> <img src=" + __webpack_require__(315) + "> </div> <div class=helpText> <table> <tr> <td class=columnName>HE</td> <td class=definition>Hot End Loss %</td> <td class=calculation>((Shears - Lehr in) / Shears) * 100</td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>LEHR LOSS</td> <td class=definition>% Lost in Lehr</td> <td class=calculation>((Lehr in - Lehr out) / Lehr in) * 100</td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>FLXBC, FLXM, CD, SQR, WSI, etc.</td> <td class=definition>Shop-specific machine loss</td> <td class=calculation>(Equipment reject / Equipment inspect) * 100</td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Tot Rej</td> <td class=definition>% of overall loss</td> <td class=calculation>(Overall loss count / Shears) * 100</td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>PTM</td> <td class=definition>Pack to Melt</td> <td class=calculation>(Packed tons / Melted tons) * 100</td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>PTP</td> <td class=definition>Pack to Pull</td> <td class=calculation>(Packed tons) / ((Melted tons) - Downtime Tons(affectsPTP)) * 100</td> <td class=source>source: APS</td> </tr> </table> </div> </div> <div> <hr> </div> <!-- Furnace Utilization section --> <div class=section> <div class=image> <img src=" + __webpack_require__(316) + "> </div> <div class=helpText> <table> <tr> <td class=columnName>Furn</td> <td class=definition>Furnace name</td> <td class=calculation></td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Util. Rate</td> <td class=definition>Furnace utilization rate</td> <td class=calculation>(Tons melted / Nominal capacity) * 100</td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Melted Tons</td> <td class=definition>Total melted tons for the furnace</td> <td class=calculation>Compiled from shop melted tons</td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Packed Tons</td> <td class=definition>Total packed tons for the furnace</td> <td class=calculation>Compiled from shop packed tons</td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>KCR</td> <td class=definition></td> <td class=calculation>Compiled from shop Kcr</td> <td class=source></td> </tr> <tr> <td class=columnName>PTM</td> <td class=definition>Pack to melt</td> <td class=calculation>(Packed tons / Melted tons) * 100</td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Pal</td> <td class=definition>Total pallets</td> <td class=calculation>Sum of total (accepted pallets + held pallets - reintroduced pallets) </td> <td class=source>source: WMS</td> </tr> <tr> <td class=columnName>Held Pal</td> <td class=definition>Total held pallets</td> <td class=calculation>Sum of total held pallets</td> <td class=source>source: WMS</td> </tr> <tr> <td class=columnName>% Held</td> <td class=definition>% of pallets held</td> <td class=calculation>(Total held / (Total pallets + Total held - Total reintroduced)) * 100</td> <td class=source>source: WMS</td> </tr> </table> </div> </div> <div> <hr> </div> <!-- Melted/Packed Tons section --> <div class=section> <div class=image> <img src=" + __webpack_require__(317) + "> </div> <div class=helpText> <table> <tr> <td class=columnName>Day/Month/Year</td> <td class=definition>Total accumulated melted tons</td> <td class=calculation></td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Month AOP/Year AOP</td> <td class=definition>Annual operating plan numbers</td> <td class=calculation></td> <td class=source>source: AOP spreadsheets</td> </tr> </table> </div> </div> <!--          <div>\r\n            <hr>\r\n          </div>--> <!-- Tank Data section --> <!--      <div class=\"section\">\r\n            <div class=\"image\">\r\n              <img ng-src=\"{{vm.appPath}}/static/ProductionShiftReportSection6.png\">\r\n            </div>\r\n            <div class=\"helpText\">\r\n\r\n            </div>\r\n          </div>--> <div> <hr> </div> <!-- PTM/PTP section --> <div class=section> <div class=image> <img src=" + __webpack_require__(318) + "> </div> <div class=helpText> <table> <tr> <td class=columnName>D/E/N</td> <td class=definition>Shift abbreviation</td> <td class=calculation>D = Day, E = Evening, N = Night</td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Day/Month/Year</td> <td class=definition>Pack to melt or Pack to pull</td> <td class=calculation>PTP = (PTM - glass lost in downtime)</td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Previous Day/Month/Year</td> <td class=definition>Accumulated PTM/PTP trends</td> <td class=calculation></td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Month AOP/Year AOP</td> <td class=definition>Accumulated annual operating plan numbers</td> <td class=calculation></td> <td class=source>source: APS</td> </tr> </table> </div> </div> <div> <hr> </div> <!-- KCR section --> <div class=section> <div class=image> <img src=" + __webpack_require__(319) + "> </div> <div class=helpText> <table> <tr> <td class=columnName>Day</td> <td class=definition>Average day Kcr</td> <td class=calculation></td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Month</td> <td class=definition>Average month Kcr</td> <td class=calculation></td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Year</td> <td class=definition>Average year Kcr</td> <td class=calculation></td> <td class=source>source: APS</td> </tr> </table> </div> </div> </div> </div> </div> </form> </div>");

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(3), __webpack_require__(893), __webpack_require__(4), __webpack_require__(16), __webpack_require__(7), __webpack_require__(8), __webpack_require__(43)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, constant_module_1, productionShiftReportV2_tpl_html_1, loader_service_1, report_service_1, authData_service_1, navigation_service_1, environment_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, report_service_1.default, authData_service_1.default, navigation_service_1.default, environment_1.default];
    var ProductionShiftReportCtrlV2 = (function () {
        ProductionShiftReportCtrlV2.$inject = ["$state", "$stateParams", "navigationService", "reportService", "loaderService", "authDataService", "environment", "$q"];
        function ProductionShiftReportCtrlV2($state, $stateParams, navigationService, reportService, loaderService, authDataService, environment, $q) {
            var _this = this;
            var vm = this;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.loaderService = loaderService;
            this.reportService = reportService;
            this.authDataService = authDataService;
            this.environment = environment;
            this.$q = $q;
            this.showExcel = true;
            this.reportDate = moment().add(-1, 'days').toDate();
            var promise = navigationService.getNavigation().then(function (navModel) {
                _this.plants = navModel.plants();
                _this.selectedPlant = navModel.selectedPlant;
                _this.loadState($stateParams);
            });
            this.appPath = this.environment.API_PATH;
            loaderService.loadingPromise(promise.then(function () {
            }));
        }
        ProductionShiftReportCtrlV2.prototype.loadState = function (params) {
            if (params.reportPlantId && params.reportPlantId !== params.plantId) {
                var plant = _.find(this.plants, { id: params.reportPlantId });
                if (plant) {
                    this.selectedPlant = plant;
                }
            }
            if (params.reportDate) {
                var reportDate = moment(params.reportDate);
                if (reportDate.isValid()) {
                    this.reportDate = reportDate.toDate();
                }
            }
        };
        ProductionShiftReportCtrlV2.prototype.saveState = function () {
            var reportPlantId = this.selectedPlant ? this.selectedPlant.id : undefined;
            if (reportPlantId === this.$stateParams.plantId) {
                reportPlantId = undefined;
            }
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportPlantId: reportPlantId,
                reportDate: this.reportDate ? this.reportDate.toISOString() : undefined
            };
            this.$state.transitionTo(this.$state.current.name, params);
        };
        ProductionShiftReportCtrlV2.prototype.getMaxMachineSections = function () {
            return new Array(this.maxMachineSections);
        };
        ProductionShiftReportCtrlV2.prototype.getMachineName = function (shop, index) {
            var machine = shop.shifts[1].lineItem.machineLosses[index];
            return machine == null ? '' : machine.machineName;
        };
        ProductionShiftReportCtrlV2.prototype.getMachineLossForShift = function (shift, index) {
            var machine = shift.lineItem.machineLosses[index];
            return machine == null ? '' : machine.loss.toFixed(1);
        };
        ProductionShiftReportCtrlV2.prototype.getMachineLossForShop = function (shop, index) {
            if (shop.shopTotals == null || shop.shopTotals.machineLosses == null) {
                return null;
            }
            var machine = shop.shopTotals.machineLosses[index];
            return machine == null ? '' : machine.loss.toFixed(1);
        };
        ProductionShiftReportCtrlV2.prototype.getMachineLossForLine = function (shift, machineIndex, line) {
            var machine = shift.lineItem.machineLosses[machineIndex];
            var lineDetail = machine == null ? null : _.find(machine.lineDetail, function (detail) { return detail.line == line; });
            return lineDetail == null ? '' : lineDetail.lossPercentage.toFixed(1);
        };
        ProductionShiftReportCtrlV2.prototype.getDistinctLinesForShop = function (losses) {
            return _.uniq(_.flatten(losses.map(function (obj) {
                return obj.lineDetail.map(function (obj2) {
                    return obj2.line;
                });
            })));
        };
        ProductionShiftReportCtrlV2.prototype.updatePlant = function () {
            this.report = null;
        };
        ProductionShiftReportCtrlV2.prototype.generateReport = function (regenerate) {
            if (this.form.$invalid) {
                return;
            }
            this.saveState();
            this.loaderService.loadingPromise(this.runReport());
            this.formattedReportDate = moment(this.reportDate).format("dddd, MM/DD/YYYY");
            if (this.formattedReportDate.indexOf("Friday") == -1 && this.formattedReportDate.indexOf("Saturday") == -1) {
                this.isWeekend = false;
            }
            else {
                this.isWeekend = true;
            }
            this.isPreRelease = false;
            if (this.selectedPlant.id === 'bbdf0000-3a00-000d-d6c3-08d2e5fa8dd2') {
                this.isPreRelease = true;
            }
        };
        ProductionShiftReportCtrlV2.prototype.exportToExcel = function () {
            this.loaderService.loadingPromise(this.reportService.exportToExcelV2(this.selectedPlant.name, this.reportDate, this.report.excel));
        };
        ;
        ProductionShiftReportCtrlV2.prototype.exportToPDF = function () {
            this.loaderService.loadingPromise(this.reportService.exportToPDFV2(this.selectedPlant.name, this.reportDate, this.report.pdf));
        };
        ;
        ProductionShiftReportCtrlV2.prototype.setMaxMachines = function () {
            var maxMachines = 0;
            _.forEach(this.report.shops, function (shop) {
                _.forEach(shop.shifts, function (shift) {
                    var machineCount = shift.lineItem.machineLosses.length;
                    if (machineCount > maxMachines) {
                        maxMachines = machineCount;
                    }
                });
            });
            this.maxMachineSections = maxMachines;
        };
        ProductionShiftReportCtrlV2.prototype.runReport = function () {
            var _this = this;
            var fomratdateonly = new Date(moment(this.reportDate).format("MM/DD/YYYY"));
            var promise = this.reportService.getProductionShiftReportV2(this.selectedPlant.id, fomratdateonly);
            promise.then(function (report) {
                _this.report = report;
                _this.setMaxMachines();
            });
            return promise;
        };
        return ProductionShiftReportCtrlV2;
    }());
    exports.default = angular.module('aps.controller.productionShiftReportV2', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.PRODUCTION_SHIFT_REPORTV2,
            url: '/productionShiftReportV2',
            params: {
                reportDate: { dynamic: true },
                reportPlantId: { dynamic: true }
            },
            controller: 'ProductionShiftReportCtrlV2 as vm',
            template: productionShiftReportV2_tpl_html_1.default,
            data: {
                pageTitle: 'Production Shift Report'
            }
        });
    }])
        .controller('ProductionShiftReportCtrlV2', ProductionShiftReportCtrlV2)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div class=body-header> <h2>Production Shift Report V2</h2> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-6 columns\"> <label> <span class=\"required notated\">*</span>Plant <select ng-model=vm.selectedPlant ng-options=\"plant as plant.name for plant in vm.plants\" ng-change=vm.updatePlant() name=selectedPlant required> <option value=\"\">-- Select a Plant --</option> </select> <div ng-messages=vm.form.selectedPlant.$error ng-if=\"vm.form.selectedPlant.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> <div class=\"small-6 columns\"> <label> <span class=\"required notated\">*</span>Report Date <input type=date ng-model=vm.reportDate name=reportDate required/> <div ng-messages=vm.form.reportDate.$error ng-if=\"vm.form.reportDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns\"> <button type=submit class=button>Generate Report</button> </div> </div> <div id=MainReport class=\"row shiftReport prod-shift-repV2\" ng-if=\"vm.report != null\" style=\"margin:0 -25px;width:auto\"> <div class=header style=\"width:100%;padding:35px 10px\"> <div class=\"left leftAlign\"><b>{{vm.selectedPlant.name}} Shift Report - {{ vm.formattedReportDate }}</b></div> <div class=\"right rightAlign\"> <a ng-if=vm.showExcel ng-click=vm.exportToExcel() style=padding-right:35px>Save as Excel</a> <a ng-if=vm.showExcel ng-click=vm.exportToPDF()>Save as PDF</a> </div> </div> <div class=header style=color:red ng-show=vm.isWeekend>Weekend reports are preliminary only and are finalized on Monday</div> <div class=header style=color:red ng-show=vm.isPreRelease>This is a PRE-RELEASE of the production report</div> <!-- Main Shift Data Section--> <div class=row ng-repeat=\"shop in vm.report.shops\"> <table class=shopSection ng-disabled=disabled> <thead> <tr> <th class=sectionHeader rowspan=2>Shop</th> <th class=sectionHeader rowspan=2>Shift</th> <th class=sectionHeader rowspan=2>Crew</th> <th class=\"sectionHeader moldColumn\" rowspan=2>Mold</th> <th class=sectionHeader rowspan=2>Short Item</th> <th class=sectionHeader rowspan=2>Weight</th> <th class=\"sectionHeader speedColumn\" rowspan=2>Prod <br/>Speed</th> <th class=sectionHeader rowspan=2>JCI</th> <!-- <th class=\"sectionHeader\" rowspan=\"2\">KCR</th> --> <th class=\"sectionHeader headerspan\" colspan=3>Pallets</th> <!-- <th class=\"sectionHeader\" rowspan=\"2\">% <br />Downtime</th>\r\n              <th class=\"sectionHeader\" rowspan=\"2\">Downtime<br />Tons</th> --> <th class=sectionHeader rowspan=2>Pulled Tons</th> <th class=sectionHeader rowspan=2>Packed Tons</th> <!-- Downtime code column will go here - Phase 2 --> <th class=\"sectionHeader heEfficiencyColumn\" rowspan=2>HE <br/>Eff</th> <!-- HE Loss columns will go here - Phase 2 --> <th ng-repeat=\"x in vm.getMaxMachineSections() track by $index\" class=\"sectionHeader machineColumn\" rowspan=2> {{ vm.getMachineName(shop, $index)}} </th> <th class=\"sectionHeader totRejColumn\" rowspan=2>Tot <br/>Rej</th> <!-- Remove for now as we don't have this --> <!-- <th class=\"sectionHeader\" rowspan=\"2\">PTP <br/>E1</th> --> <th class=\"sectionHeader ptpColumn\" rowspan=2>PTM</th> <!-- <th class=\"sectionHeader ptpColumn\" rowspan=\"2\">PTP</th> --> </tr> <tr> <th class=\"sectionHeader palletColumn\">A</th> <th class=\"sectionHeader palletColumn\">H</th> <th class=\"sectionHeader palletColumn\">R</th> </tr> </thead> <tbody> <tr ng-repeat-start=\"shift in shop.shifts\" ng-class-even=\"'even'\" ng-class=\"{'disableshops': shift.mold.includes('9999')}\"> <td ng-class=\"{'sectionData': !vm.showLines, 'sectionDataWithLines': vm.showLines, 'noTopBorder': $index===0}\" class=\"sectionData leftAlign\">{{shop.shopName}}</td> <td class=\"sectionData leftAlign\">{{shift.shiftName}}</td> <td class=\"sectionData centerAlign\">{{shift.lineItem.crewCode}}</td> <td class=\"sectionData leftAlign\">{{shift.mold}}</td> <td class=\"sectionData leftAlign\">{{shift.lineItem.shortItem}}</td> <td class=sectionData>{{shift.weight | number: 2}}</td> <td class=sectionData>{{shift.speed | number: 1}}</td> <td class=sectionData>{{shift.jci | number : 1}}</td> <!-- <td class=\"sectionData\">{{shift.lineItem.kcr | number : 1}}</td> --> <td class=sectionData>{{shift.lineItem.acceptedPallets}}</td> <td class=sectionData>{{shift.lineItem.heldPallets}}</td> <td class=sectionData>{{shift.lineItem.reintroducedPallets}}</td> <!-- <td class=\"sectionData\">{{shift.lineItem.percentDowntime | number : 1}}</td>\r\n              <td class=\"sectionData\">{{shift.lineItem.downtimeTons | number: 1}}</td> --> <td class=sectionData>{{ ((shift.lineItem.meltedOunces * 0.0625) / 2000) | number : 1}}</td> <td class=sectionData>{{ ((shift.lineItem.packedOunces * 0.0625) / 2000) | number : 1}}</td> <!-- Downtime code column will go here - Phase 2 --> <td ng-class=\"{'sectionData': !vm.showLines, 'sectionDataWithLines': vm.showLines, 'noTopBorder': $index===0}\"> {{shift.lineItem.heEfficiency | number : 1}}</td> <!-- HE Loss columns will go here - Phase 2 --> <td ng-class=\"{'sectionData': !vm.showLines, 'sectionDataWithLines': vm.showLines, 'noTopBorder': $parent.$index===0}\" ng-repeat=\"x in vm.getMaxMachineSections() track by $index\"> {{ vm.getMachineLossForShift(shift, $index)}} </td> <td ng-class=\"{'sectionData': !vm.showLines, 'sectionDataWithLines': vm.showLines, 'noTopBorder': $index===0}\"> {{shift.lineItem.totalRejected | number : 1}}</td> <!-- Commented out until we have this data --> <!-- <td ng-class=\"{'sectionData': !vm.showLines, 'sectionDataWithLines': vm.showLines, 'noTopBorder': $index===0}\">{{shift.lineItem.e1PTM | number : 1}}</td> --> <td ng-class=\"{'sectionData': !vm.showLines, 'sectionDataWithLines': vm.showLines, 'noTopBorder': $index===0}\">{{shift.lineItem.apsPTM | number : 1}}</td> <!-- <td ng-class=\"{'sectionData': !vm.showLines, 'sectionDataWithLines': vm.showLines, 'noTopBorder': $index===0}\">{{shift.lineItem.apsPTP | number : 1}}</td> --> </tr> <tr ng-repeat-end ng-repeat=\"line in vm.getDistinctLinesForShop(shift.lineItem.machineLosses)\" ng-if=vm.showLines ng-class=\"{'even': $parent.$parent.$odd}\"> <td colspan=13></td> <td class=rowHeader>Line {{line}}</td> <td ng-class=\"{'sectionDataWithLines': vm.getMachineLossForLine(shift, $index, line) != '', 'sectionDataRightBorder': $last}\" ng-repeat=\"x in vm.getMaxMachineSections() track by $index\"> {{ vm.getMachineLossForLine(shift, $index, line)}} </td> </tr> </tbody> <tfoot> <tr> <td class=\"sectionFooter leftAlign\" colspan=4>{{shop.shopName}}</td> <td class=sectionFooter>{{shop.shopShiftWeightAverage | number: 2}}</td> <td class=\"sectionFooter leftAlign\" colspan=3></td> <!-- <td class=\"sectionFooter\">{{shop.shopTotals.kcr | number : 1}}</td> --> <td class=sectionFooter>{{shop.shopTotals.acceptedPallets}}</td> <td class=sectionFooter>{{shop.shopTotals.heldPallets}}</td> <td class=sectionFooter>{{shop.shopTotals.reintroducedPallets}}</td> <!-- <td class=\"sectionFooter\">{{shop.shopTotals.percentDowntime | number : 1}}</td>\r\n              <td class=\"sectionFooter\">{{shop.shopTotals.downtimeTons | number : 1}}</td> --> <td class=sectionFooter>{{ ((shop.shopTotals.meltedOunces * 0.0625) / 2000) | number : 1}}</td> <td class=sectionFooter>{{ ((shop.shopTotals.packedOunces * 0.0625) / 2000) | number : 1}}</td> <!-- Downtime code column will go here - Phase 2 --> <td class=sectionFooter>{{shop.shopTotals.heEfficiency | number : 1}}</td> <!-- HE Loss columns will go here - Phase 2 --> <td class=sectionFooter ng-repeat=\"x in vm.getMaxMachineSections() track by $index\"> {{ vm.getMachineLossForShop(shop, $index)}} </td> <td class=sectionFooter>{{shop.shopTotals.totalRejected | number : 1}}</td> <!-- Commented out until we have this data --> <!-- <td class=\"sectionFooter\">{{shop.shopTotals.e1PTM | number : 1}}</td> --> <td class=sectionFooter>{{shop.shopTotals.apsPTM | number : 1}}</td> <!-- <td class=\"sectionFooter\">{{shop.shopTotals.apsPTP | number : 1}}</td>  --> </tr> </tfoot> </table> </div> <!-- Furnace Utilization Section --> <div class=\"row left\" ng-if=\"vm.report.furnaceUtilization != null\"> <table class=furnaceUtilizationSection> <thead> <tr> <th class=sectionHeader>Furn</th> <th class=sectionHeader>Util. Rate</th> <th class=sectionHeader>Melted Tons</th> <th class=sectionHeader>Packed Tons</th> <!-- <th class=\"sectionHeader\">KCR</th> --> <th class=sectionHeader>PTM</th> <th class=sectionHeader>Pal</th> <th class=sectionHeader>Held Pal</th> <th class=sectionHeader>% Held</th> </tr> </thead> <tbody> <tr ng-repeat=\"furnace in vm.report.furnaceUtilization.furnaceItems\" ng-class-even=\"'even'\"> <td class=\"sectionData leftAlign\">{{furnace.name}}</td> <td class=sectionData>{{furnace.utilization | number: 1}}</td> <td class=sectionData>{{furnace.grossTons | number: 1}}</td> <td class=sectionData>{{furnace.packedTons | number: 1}}</td> <!-- <td class=\"sectionData\">{{furnace.kcr | number: 1}}</td> --> <td class=sectionData>{{furnace.ptm | number: 1}}</td> <td class=sectionData>{{furnace.allPallets}}</td> <td class=sectionData>{{furnace.heldPallets}}</td> <td class=sectionData>{{furnace.percentHeld | number: 2}}</td> </tr> </tbody> <tfoot> <tr> <td class=\"sectionFooter leftAlign\">{{vm.report.furnaceUtilization.plantTotals.name}}</td> <td class=sectionFooter>{{vm.report.furnaceUtilization.plantTotals.utilization | number: 1}}</td> <td class=sectionFooter>{{vm.report.furnaceUtilization.plantTotals.grossTons | number: 1}}</td> <td class=sectionFooter>{{vm.report.furnaceUtilization.plantTotals.packedTons | number: 1}}</td> <!-- <td class=\"sectionFooter\">{{vm.report.furnaceUtilization.plantTotals.kcr | number: 1}}</td> --> <td class=sectionFooter>{{vm.report.furnaceUtilization.plantTotals.ptm | number: 1}}</td> <td class=sectionFooter>{{vm.report.furnaceUtilization.plantTotals.allPallets}}</td> <td class=sectionFooter>{{vm.report.furnaceUtilization.plantTotals.heldPallets | number: 1}}</td> <td class=sectionFooter>{{vm.report.furnaceUtilization.plantTotals.percentHeld | number: 1}}</td> </tr> </tfoot> </table> </div> <br/> <!-- Gross/Packed Tons Section --> <div class=\"row left\" ng-if=\"vm.report.grossPackedTons != null\"> <table class=grossTonsSection> <thead> <tr> <th></th> <th class=sectionHeader>Day</th> <th class=sectionHeader>Month</th> <th class=sectionHeader>Month AOP</th> <th class=sectionHeader>Year</th> <th class=sectionHeader>Year AOP</th> </tr> </thead> <tbody> <tr> <td class=rowHeader>Melted Tons</td> <td class=sectionData>{{vm.report.grossPackedTons.grossTons.day | number: 1}}</td> <td class=sectionData>{{vm.report.grossPackedTons.grossTons.month | number: 1}}</td> <td class=sectionData>{{vm.report.grossPackedTons.grossTons.monthAop | number: 1}}</td> <td class=sectionData>{{vm.report.grossPackedTons.grossTons.year | number: 1}}</td> <td class=sectionData>{{vm.report.grossPackedTons.grossTons.yearAop | number: 1}}</td> </tr> <tr class=even> <td class=\"rowHeader last\">Packed Tons</td> <td class=sectionData>{{vm.report.grossPackedTons.packedTons.day | number: 1}}</td> <td class=sectionData>{{vm.report.grossPackedTons.packedTons.month | number: 1}}</td> <td class=sectionData>{{vm.report.grossPackedTons.packedTons.monthAop | number: 1}}</td> <td class=sectionData>{{vm.report.grossPackedTons.packedTons.year | number: 1}}</td> <td class=sectionData>{{vm.report.grossPackedTons.packedTons.yearAop | number: 1}}</td> </tr> </tbody> </table> </div> <!-- Tank Data Section --> <!-- <div class=\"row\" ng-if=\"vm.report.tankData != null\">\r\n        <table class=\"tankSection\">\r\n          <thead>\r\n            <tr>\r\n              <th class=\"sectionHeader\">Furn</th>\r\n              <th class=\"sectionHeader\">Consum. <br />(kcal/Kg)</th>\r\n              <th class=\"sectionHeader\">Consum. <br />(MMBTU/ton)</th>\r\n              <th class=\"sectionHeader\">Cullet <br />%</th>\r\n              <th class=\"sectionHeader\">Seeds</th>\r\n              <th class=\"sectionHeader\">Throat <br />Temp.</th>\r\n              <th class=\"sectionHeader\">BW OPT</th>\r\n              <th class=\"sectionHeader\">Bot Temp.</th>\r\n              <th class=\"sectionHeader\">Glass <br />Density</th>\r\n              <th class=\"sectionHeader\">Nox</th>\r\n              <th class=\"sectionHeader\">Sox</th>\r\n            </tr>\r\n          </thead>\r\n          <tbody>\r\n            <tr ng-repeat=\"tank in vm.report.tankData.tankItems\" ng-class-even=\"'even'\">\r\n              <td class=\"sectionData leftAlign\">{{tank.name}}</td>\r\n              <td class=\"sectionData\">{{tank.meltEnergyKcalKg | number: 1}}</td>\r\n              <td class=\"sectionData\">{{tank.meltEnergy | number: 1}}</td>\r\n              <td class=\"sectionData\">{{tank.culletPercent | number: 1}}</td>\r\n              <td class=\"sectionData\">{{tank.seed | number: 3}}</td>\r\n              <td class=\"sectionData\">{{tank.throatTemp | number: 1}}</td>\r\n              <td class=\"sectionData\">{{tank.bwOpt | number: 1}}</td>\r\n              <td class=\"sectionData\">{{tank.botTemp | number: 1}}</td>\r\n              <td class=\"sectionData\">{{tank.glassDensity | number: 4}}</td>\r\n              <td class=\"sectionData\">{{tank.nox | number: 1}}</td>\r\n              <td class=\"sectionData\">{{tank.sox | number: 1}}</td>\r\n            </tr>\r\n            <tr>\r\n              <td class=\"leftAlign\" colspan=\"11\" style=\"font-size: .7em; font-style: italic;\">* Certain furnace data may not be available on weekends</td>\r\n            </tr>\r\n          </tbody>\r\n        </table>\r\n      </div> --> <!-- PTM Section --> <div class=\"row left\" ng-if=\"vm.report.packToMeltSummary != null\" style=margin-right:25px;margin-bottom:25px> <table class=ptmSection> <thead> <tr> <th class=\"sectionHeader headerspan\" colspan=12>PTM/PTP</th> </tr> <tr> <th class=sectionHeader></th> <th ng-repeat=\"shift in vm.report.packToMeltSummary.totals.shifts\" class=sectionHeader>{{shift.name}} </th> <th class=sectionHeader>Day</th> <th class=\"sectionHeader secondaryHeader\">Previous<br/>Day</th> <th class=sectionHeader>Month</th> <th class=sectionHeader>Month<br/>AOP</th> <th class=\"sectionHeader secondaryHeader\">Previous<br/>Month</th> <!-- <th class=\"sectionHeader\">Year</th>\r\n              <th class=\"sectionHeader\">Year<br />AOP</th>\r\n              <th class=\"sectionHeader secondaryHeader\">Previous<br />Year</th> --> </tr> </thead> <tbody> <tr ng-repeat=\"shop in vm.report.packToMeltSummary.shops\" ng-class-even=\"'even'\"> <td class=\"sectionData leftAlign\">Shop {{shop.name}} (PTP)</td> <td ng-repeat=\"shift in shop.shifts\" class=sectionData>{{shift.ptp | number: 1}}</td> <td class=sectionData>{{shop.day | number: 1}}</td> <td class=\"sectionData secondaryData\">{{shop.previousDay | number: 1}}</td> <td class=sectionData>{{shop.month | number: 1}}</td> <td class=sectionData>{{shop.monthAop | number: 1}}</td> <td class=\"sectionData secondaryData\">{{shop.previousMonth | number: 1}}</td> <!-- <td class=\"sectionData\">{{shop.year | number: 1}}</td>\r\n              <td class=\"sectionData\">{{shop.yearAop | number: 1}}</td>\r\n              <td class=\"sectionData secondaryData\">{{shop.previousYear | number: 1}}</td> --> </tr> </tbody> <tfoot> <tr ng-repeat=\"tank in vm.report.packToMeltSummary.tanks\"> <td class=\"sectionSubfooter leftAlign\">Tank {{tank.name}} (PTM)</td> <td ng-repeat=\"shift in tank.shifts\" class=sectionSubfooter>{{shift.ptm | number: 1}}</td> <td class=sectionSubfooter>{{tank.day | number: 1}}</td> <td class=\"sectionSubfooter secondaryData\">{{tank.previousDay | number: 1}}</td> <td class=sectionSubfooter>{{tank.month | number: 1}}</td> <td class=sectionSubfooter>{{tank.monthAop | number: 1}}</td> <td class=\"sectionSubfooter secondaryData\">{{tank.previousMonth | number: 1}}</td> <!-- <td class=\"sectionSubfooter\">{{tank.year | number: 1}}</td>\r\n              <td class=\"sectionSubfooter\">{{tank.yearAop | number: 1}}</td>\r\n              <td class=\"sectionSubfooter secondaryData\">{{tank.previousYear | number: 1}}</td> --> </tr> <tr> <td class=\"sectionFooter leftAlign\">Plant (PTM)</td> <td ng-repeat=\"shift in vm.report.packToMeltSummary.totals.shifts\" class=sectionFooter>{{shift.ptm | number: 1}}</td> <td class=sectionFooter>{{vm.report.packToMeltSummary.totals.day | number: 1}}</td> <td class=\"sectionFooter secondaryData\">{{vm.report.packToMeltSummary.totals.previousDay | number: 1}} </td> <td class=sectionFooter>{{vm.report.packToMeltSummary.totals.month | number: 1}}</td> <td class=sectionFooter>{{vm.report.packToMeltSummary.totals.monthAop | number: 1}}</td> <td class=\"sectionFooter secondaryData\">{{vm.report.packToMeltSummary.totals.previousMonth | number: 1}}</td> <!-- <td class=\"sectionFooter\">{{vm.report.packToMeltSummary.totals.year | number: 1}}</td>\r\n              <td class=\"sectionFooter\">{{vm.report.packToMeltSummary.totals.yearAop | number: 1}}</td>\r\n              <td class=\"sectionFooter secondaryData\">{{vm.report.packToMeltSummary.totals.previousYear | number: 1}}</td> --> </tr> </tfoot> </table> </div> <!-- KCR Section --> <!-- <div class=\"row left\" ng-if=\"vm.report.kcrSummary != null\">\r\n        <table class=\"kcrSection\">\r\n          <thead>\r\n            <tr>\r\n              <th class=\"sectionHeader headerspan\" colspan=\"6\">KCR</th>\r\n            </tr>\r\n            <tr>\r\n              <th class=\"sectionHeader\"></th>\r\n              <th class=\"sectionHeader\">Day<br /></th>\r\n              <th class=\"sectionHeader\">Month</th>\r\n              <th class=\"sectionHeader\">Year</th>\r\n            </tr>\r\n          </thead>\r\n          <tbody>\r\n            <tr ng-repeat=\"shop in vm.report.kcrSummary.shops\" ng-class-even=\"'even'\">\r\n              <td class=\"sectionData\">Shop {{shop.name}}</td>\r\n              <td class=\"sectionData\">{{shop.day | number: 1}}</td>\r\n              <td class=\"sectionData\">{{shop.month | number: 1}}</td>\r\n              <td class=\"sectionData\">{{shop.year | number: 1}}</td>\r\n            </tr>\r\n          </tbody>\r\n          <tfoot>\r\n            <tr ng-repeat=\"tank in vm.report.kcrSummary.tanks\">\r\n              <td class=\"sectionSubfooter\">Tank {{tank.name}}</td>\r\n              <td class=\"sectionSubfooter\">{{tank.day | number: 1}}</td>\r\n              <td class=\"sectionSubfooter\">{{tank.month | number: 1}}</td>\r\n              <td class=\"sectionSubfooter\">{{tank.year | number: 1}}</td>\r\n            </tr>\r\n            <tr>\r\n              <td class=\"sectionFooter\">Plant</td>\r\n              <td class=\"sectionFooter\">{{vm.report.kcrSummary.totals.day | number: 1}}</td>\r\n              <td class=\"sectionFooter\">{{vm.report.kcrSummary.totals.month | number: 1}}</td>\r\n              <td class=\"sectionFooter\">{{vm.report.kcrSummary.totals.year | number: 1}}</td>\r\n            </tr>\r\n          </tfoot>\r\n        </table>\r\n      </div> --> <!-- JCI Section --> <div class=row ng-if=\"vm.report.jciSummary != null\"> <table class=kcrSection> <thead> <tr> <th class=\"sectionHeader headerspan\" colspan=6>JCI</th> </tr> <tr> <th class=sectionHeader></th> <th class=sectionHeader>Day<br/></th> <th class=sectionHeader>Month</th> <!-- <th class=\"sectionHeader\">Year</th> --> </tr> </thead> <tbody> <tr ng-repeat=\"shop in vm.report.jciSummary.shops\" ng-class-even=\"'even'\"> <td class=sectionData>Shop {{shop.name}}</td> <td class=sectionData>{{shop.day | number: 1}}</td> <td class=sectionData>{{shop.month | number: 1}}</td> <!-- <td class=\"sectionData\">{{shop.year | number: 1}}</td> --> </tr> </tbody> <tfoot> <tr ng-repeat=\"tank in vm.report.jciSummary.tanks\"> <td class=sectionSubfooter>Tank {{tank.name}}</td> <td class=sectionSubfooter>{{tank.day | number: 1}}</td> <td class=sectionSubfooter>{{tank.month | number: 1}}</td> <!-- <td class=\"sectionSubfooter\">{{tank.year | number: 1}}</td> --> </tr> <tr> <td class=sectionFooter>Plant</td> <td class=sectionFooter>{{vm.report.jciSummary.totals.day | number: 1}}</td> <td class=sectionFooter>{{vm.report.jciSummary.totals.month | number: 1}}</td> <!-- <td class=\"sectionFooter\">{{vm.report.jciSummary.totals.year | number: 1}}</td> --> </tr> </tfoot> </table> </div> <div style=padding-top:50px> <div class=shiftReportLegend ng-if=\"vm.report != null\"> <div style=page-break-after:always> &nbsp; </div> <div class=heading> Definitions and Calculations (sample data) </div> <div> <hr> </div> <!-- Shift row section 1 --> <div class=section> <div class=image> <img src=" + __webpack_require__(313) + "> </div> <div class=helpText> <table> <tr> <td class=columnName>Shop</td> <td class=definition>Shop name</td> <td class=calculation></td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Shift</td> <td class=definition>Shift abbreviation</td> <td class=calculation>D = Day, E = Evening, N = Night</td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Mold</td> <td class=definition>Job mold and finish</td> <td class=calculation></td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Short Item</td> <td class=definition>Short item number</td> <td class=calculation></td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Weight</td> <td class=definition>Average weight recorded over job run/shift</td> <td class=calculation></td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Prod Speed</td> <td class=definition>Machine speed calculated from shears or machine pulses</td> <td class=calculation></td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>JCI</td> <td class=definition>Job Change Index</td> <td class=calculation>For new jobs, calculation is: (First 12 Hours Pallets(Bottles) Produced) / (Theoretical 12 Hours of Production) * 100</td> <td class=source>source: WMS</td> </tr> <!-- <tr>\r\n                  <td class=\"columnName\">KCR</td>\r\n                  <td class=\"definition\"></td>\r\n                  <td class=\"calculation\">Square root &#8730; (Speed * Average weight in grams) / Machine sections /\r\n                    Number of gobs)</td>\r\n                  <td class=\"source\">source: APS</td>\r\n                </tr> --> </table> </div> </div> <div> <hr> </div> <!-- Shift row section 2 --> <div class=section> <div class=image> <img src=" + __webpack_require__(314) + "> </div> <div class=helpText> <table> <tr> <td class=columnName>Pallets</td> <td class=definition>Pallets during shift</td> <td class=calculation>A = Accepted, H = Held, R = Reintroduced</td> <td class=source>source: WMS</td> </tr> <!-- <tr>\r\n                  <td class=\"columnName\">% Downtime</td>\r\n                  <td class=\"definition\">Percent downtime during job run/shift</td>\r\n                  <td class=\"calculation\">((Total downtime minutes from linesheet + Streaming Minutes)/ Total available machine section\r\n                    minutes) * 100</td>\r\n                  <td class=\"source\">source: APS</td>\r\n                </tr>\r\n                <tr>\r\n                  <td class=\"columnName\">Downtime Tons</td>\r\n                  <td class=\"definition\">Downtime Tons from streaming glass during job run/shift</td>\r\n                  <td class=\"calculation\">(Speed * Weight * (Total downtime minutes from linesheet)) + Streaming Tons</td>\r\n                  <td class=\"source\">source: APS</td>\r\n                </tr> --> <tr> <td class=columnName>Pulled Tons</td> <td class=definition>Pulled tons during job run/shift</td> <td class=calculation>Speed * Weight * TotalTime </td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Packed Tons</td> <td class=definition>Packed tons during shift</td> <td class=calculation>WMS bottle count * Weight</td> <td class=source>source: APS & WMS</td> </tr> <tr> <td class=columnName>HE Eff</td> <td class=definition>Hot end efficiency</td> <td class=calculation>(LEHR In/ SHEARS) * 100</td> <td class=source>source: APS</td> </tr> </table> </div> </div> <div> <hr> </div> <!-- Shift row section 3 --> <div class=section> <div class=image> <img src=" + __webpack_require__(315) + "> </div> <div class=helpText> <table> <tr> <td class=columnName>HE</td> <td class=definition>Hot End Loss %</td> <td class=calculation>((Shears - Lehr in) / Shears) * 100</td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>LEHR LOSS</td> <td class=definition>% Lost in Lehr</td> <td class=calculation>((Lehr in - Lehr out) / Lehr in) * 100</td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>FLXBC, FLXM, CD, SQR, WSI, etc.</td> <td class=definition>Shop-specific machine loss</td> <td class=calculation>(Equipment reject / Equipment inspect) * 100</td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Tot Rej</td> <td class=definition>% of overall loss</td> <td class=calculation>(Overall loss count / Shears) * 100</td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>PTM</td> <td class=definition>Pack to Melt</td> <td class=calculation>(Packed tons / Melted tons) * 100</td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>PTP</td> <td class=definition>Pack to Pull</td> <td class=calculation>(Packed tons) / ((Melted tons)) * 100</td> <!-- <td class=\"calculation\">(Packed tons) / ((Melted tons) - Downtime Tons(affectsPTP)) * 100</td> --> <td class=source>source: APS</td> </tr> </table> </div> </div> <div> <hr> </div> <!-- Furnace Utilization section --> <div class=section> <div class=image> <img src=" + __webpack_require__(316) + "> </div> <div class=helpText> <table> <tr> <td class=columnName>Furn</td> <td class=definition>Furnace name</td> <td class=calculation></td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Util. Rate</td> <td class=definition>Furnace utilization rate</td> <td class=calculation>(Tons melted / Nominal capacity) * 100</td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Melted Tons</td> <td class=definition>Total melted tons for the furnace</td> <td class=calculation>Compiled from shop melted tons</td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Packed Tons</td> <td class=definition>Total packed tons for the furnace</td> <td class=calculation>Compiled from shop packed tons</td> <td class=source>source: APS</td> </tr> <!-- <tr>\r\n                  <td class=\"columnName\">KCR</td>\r\n                  <td class=\"definition\"></td>\r\n                  <td class=\"calculation\">Compiled from shop Kcr</td>\r\n                  <td class=\"source\"></td>\r\n                </tr> --> <tr> <td class=columnName>PTM</td> <td class=definition>Pack to melt</td> <td class=calculation>(Packed tons / Melted tons) * 100</td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Pal</td> <td class=definition>Total pallets</td> <td class=calculation>Sum of total (accepted pallets + held pallets - reintroduced pallets) </td> <td class=source>source: WMS</td> </tr> <tr> <td class=columnName>Held Pal</td> <td class=definition>Total held pallets</td> <td class=calculation>Sum of total held pallets</td> <td class=source>source: WMS</td> </tr> <tr> <td class=columnName>% Held</td> <td class=definition>% of pallets held</td> <td class=calculation>(Total held / (Total pallets + Total held - Total reintroduced)) * 100</td> <td class=source>source: WMS</td> </tr> </table> </div> </div> <div> <hr> </div> <!-- Melted/Packed Tons section --> <div class=section> <div class=image> <img src=" + __webpack_require__(317) + "> </div> <div class=helpText> <table> <tr> <td class=columnName>Day/Month/Year</td> <td class=definition>Total accumulated melted tons</td> <td class=calculation></td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Month AOP/Year AOP</td> <td class=definition>Annual operating plan numbers</td> <td class=calculation></td> <td class=source>source: AOP spreadsheets</td> </tr> </table> </div> </div> <!--          <div>\r\n            <hr>\r\n          </div>--> <!-- Tank Data section --> <!--      <div class=\"section\">\r\n            <div class=\"image\">\r\n              <img ng-src=\"{{vm.appPath}}/static/ProductionShiftReportSection6.png\">\r\n            </div>\r\n            <div class=\"helpText\">\r\n\r\n            </div>\r\n          </div>--> <div> <hr> </div> <!-- PTM/PTP section --> <div class=section> <div class=image> <img src=" + __webpack_require__(318) + "> </div> <div class=helpText> <table> <tr> <td class=columnName>D/E/N</td> <td class=definition>Shift abbreviation</td> <td class=calculation>D = Day, E = Evening, N = Night</td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Day/Month/Year</td> <td class=definition>Pack to melt or Pack to pull</td> <td class=calculation>PTP = (PTM - glass lost in downtime)</td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Previous Day/Month/Year</td> <td class=definition>Accumulated PTM/PTP trends</td> <td class=calculation></td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Month AOP/Year AOP</td> <td class=definition>Accumulated annual operating plan numbers</td> <td class=calculation></td> <td class=source>source: APS</td> </tr> </table> </div> </div> <div> <hr> </div> <!-- KCR section\r\n          <div class=\"section\">\r\n            <div class=\"image\">\r\n              <img src=\"" + __webpack_require__(319) + "\">\r\n            </div>\r\n            <div class=\"helpText\">\r\n              <table>\r\n                <tr>\r\n                  <td class=\"columnName\">Day</td>\r\n                  <td class=\"definition\">Average day Kcr</td>\r\n                  <td class=\"calculation\"></td>\r\n                  <td class=\"source\">source: APS</td>\r\n                </tr>\r\n                <tr>\r\n                  <td class=\"columnName\">Month</td>\r\n                  <td class=\"definition\">Average month Kcr</td>\r\n                  <td class=\"calculation\"></td>\r\n                  <td class=\"source\">source: APS</td>\r\n                </tr>\r\n                <tr>\r\n                  <td class=\"columnName\">Year</td>\r\n                  <td class=\"definition\">Average year Kcr</td>\r\n                  <td class=\"calculation\"></td>\r\n                  <td class=\"source\">source: APS</td>\r\n                </tr>\r\n              </table>\r\n            </div>\r\n          </div> --> </div> </div> </div> </form> </div>");

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(3), __webpack_require__(895), __webpack_require__(4), __webpack_require__(16), __webpack_require__(91), __webpack_require__(7), __webpack_require__(8), __webpack_require__(111), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, constant_module_1, downtimeShiftReport_tpl_html_1, loader_service_1, report_service_1, downtime_service_1, authData_service_1, navigation_service_1, downtime_1, lodash_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, downtime_service_1.default, report_service_1.default, authData_service_1.default, navigation_service_1.default];
    var DowntimeShiftReportCtrl = (function () {
        DowntimeShiftReportCtrl.$inject = ["$state", "$stateParams", "navigationService", "reportService", "downtimeService", "loaderService", "authDataService", "notifyService", "$q"];
        function DowntimeShiftReportCtrl($state, $stateParams, navigationService, reportService, downtimeService, loaderService, authDataService, notifyService, $q) {
            var _this = this;
            var vm = this;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.loaderService = loaderService;
            this.reportService = reportService;
            this.downtimeService = downtimeService;
            this.authDataService = authDataService;
            this.notifyService = notifyService;
            this.$q = $q;
            this.reportDate = moment().add(-1, 'days').toDate();
            var now = moment().add(1, 'hours').startOf('hour');
            this.reportEndDate = now.toDate();
            this.reportStartDate = now.clone().subtract(1, 'days').toDate();
            this.isSingleDayReport = true;
            var promise = navigationService.getNavigation().then(function (navModel) {
                _this.plants = navModel.plants();
                _this.selectedPlant = navModel.selectedPlant;
                return _this.loadState($stateParams).then(function (data) {
                    vm.downtimeTypes = data.downtimeTypes;
                    var streamId = '00000000-0000-0000-0000-000000000000';
                    var toolChangeId = 'bbdf0000-3a00-000d-c122-08d2e5fba957';
                    vm.downtimeTypes.push(new downtime_1.DowntimeType(streamId, 'Streaming'));
                    vm.downtimeTypes.push(new downtime_1.DowntimeType(toolChangeId, 'Tool Change'));
                });
            });
            loaderService.loadingPromise(promise);
        }
        DowntimeShiftReportCtrl.prototype.loadState = function (params) {
            if (params.reportPlantId && params.reportPlantId !== params.plantId) {
                var plant = _.find(this.plants, { id: params.reportPlantId });
                if (plant) {
                    this.selectedPlant = plant;
                }
            }
            if (params.reportDate) {
                var reportDate = moment(params.reportDate);
                if (reportDate.isValid()) {
                    this.reportDate = reportDate.toDate();
                }
            }
            if (params.startDate) {
                var startDate = moment(params.startDate);
                if (startDate.isValid()) {
                    this.startDate = startDate.toDate();
                }
            }
            return this.getDowntimeTypes();
        };
        DowntimeShiftReportCtrl.prototype.machineOnly = function () {
            this.report = null;
            if (this.showLines) {
                this.showLines = false;
            }
            else {
                this.showLines = true;
            }
        };
        DowntimeShiftReportCtrl.prototype.updatePlant = function () {
            this.report = null;
        };
        DowntimeShiftReportCtrl.prototype.radioChange = function (type) {
            if (type === 'single') {
                this.isSingleDayReport = true;
            }
            else {
                this.isSingleDayReport = false;
            }
        };
        DowntimeShiftReportCtrl.prototype.saveState = function () {
            var reportPlantId = this.selectedPlant ? this.selectedPlant.id : undefined;
            if (reportPlantId === this.$stateParams.plantId) {
                reportPlantId = undefined;
            }
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportPlantId: reportPlantId,
                reportDate: this.reportDate ? this.reportDate.toISOString() : undefined,
                startDate: this.startDate ? this.startDate.toISOString() : undefined,
                endDate: this.endDate ? this.endDate.toISOString() : undefined
            };
            this.$state.transitionTo(this.$state.current.name, params);
        };
        DowntimeShiftReportCtrl.prototype.generateReport = function (regenerate) {
            if (this.form.$invalid) {
                return;
            }
            if (!this.isSingleDayReport) {
                var diff = moment(this.endDate).diff(this.startDate, 'days');
                if (diff > 185) {
                    this.notifyService.error('Date range cannot exceed 6 months');
                    return;
                }
                if (this.endDate < this.startDate) {
                    this.notifyService.error('Report End Date should be greater than Report Start Date');
                    return;
                }
            }
            this.saveState();
            this.loaderService.loadingPromise(this.runReport());
            this.formattedReportDate = moment(this.reportDate).format("dddd, MM/DD/YYYY");
        };
        DowntimeShiftReportCtrl.prototype.runReport = function () {
            var _this = this;
            var downtimeTypeId = null;
            if (this.downtimeType) {
                downtimeTypeId = this.downtimeType.downtimeTypeId;
            }
            var req = {
                isSingleDayReport: this.isSingleDayReport,
                plantId: this.selectedPlant.id,
                reportDate: this.reportDate,
                startDate: this.startDate,
                endDate: this.endDate,
                areaId: downtimeTypeId
            };
            var promise = this.reportService.getDowntimeShiftReport(req);
            promise.then(function (result) {
                var report = result.items;
                _this.summary = result.summaries;
                _this.summaryByArea = result.summariesByArea;
                if (_this.showLines) {
                    _.forEach(report, function (i) {
                        i.downtimeDetailsReportItems = _.filter(i.downtimeDetailsReportItems, function (di) { return di.entireMachine === true; });
                        i.downtimeSummaryReportItems = _.filter(i.downtimeSummaryReportItems, function (di) { return di.section === null; });
                    });
                    report = _.filter(report, function (x) { return x.downtimeDetailsReportItems.length > 0; });
                }
                if (!_this.isSingleDayReport) {
                    _this.showReportData = false;
                    var start = moment(_this.startDate).format("dddd, MM/DD/YYYY");
                    var end = moment(_this.endDate).format("dddd, MM/DD/YYYY");
                    _this.tableToCsv2(result.items, start + '-' + end + '_downtime_summary.csv');
                }
                else {
                    _this.showReportData = true;
                }
                _this.report = report;
            });
            return promise;
        };
        DowntimeShiftReportCtrl.prototype.getSectionName = function (summaryItem) {
            return summaryItem.nameSection.replace(" ", "");
        };
        DowntimeShiftReportCtrl.prototype.getShiftRows = function (detailsItem, shiftName) {
            this.shiftName = shiftName;
            return detailsItem.filter(function (x) { return x.shiftName == shiftName; }).length;
        };
        DowntimeShiftReportCtrl.prototype.getColumnMark = function (sectionName, columnName) {
            return (sectionName.filter(function (x) { return x == columnName; }).length > 0) ? "X" : "";
        };
        DowntimeShiftReportCtrl.prototype.getSummaryShiftRows = function (item) {
            var a = Array.from(lodash_1.flatten(item.shift));
            var cnt = 0;
            _.forEach(a, function (i) {
                cnt += Array.from(lodash_1.flatten(i.reasons)).length;
            });
            return cnt;
        };
        DowntimeShiftReportCtrl.prototype.getSummaryAreaRows = function (item) {
            return Array.from(lodash_1.flatten(item.areas)).length;
        };
        DowntimeShiftReportCtrl.prototype.getSummaryReasonRows = function (item) {
            return Array.from(lodash_1.flatten(item.reasons)).length;
        };
        DowntimeShiftReportCtrl.prototype.getShopDowntime = function (item, isentireMachine) {
            var a = Array.from(lodash_1.flatten(item.shift));
            var sum = 0;
            _.forEach(a, function (i) {
                var b = Array.from(lodash_1.flatten(i.reasons));
                _.forEach(b, function (k) {
                    if (k.entireMachine && isentireMachine) {
                        sum += k.totalMinute;
                    }
                    else if (!k.entireMachine && !isentireMachine) {
                        sum += k.totalMinute;
                    }
                });
            });
            return sum;
        };
        DowntimeShiftReportCtrl.prototype.getShopDowntime2 = function (item) {
            var a = Array.from(lodash_1.flatten(item.shift));
            var sum = 0;
            _.forEach(a, function (i) {
                var b = Array.from(lodash_1.flatten(i.reasons));
                _.forEach(b, function (k) {
                    sum += k.totalMinute;
                });
            });
            return sum;
        };
        DowntimeShiftReportCtrl.prototype.getPlantDowntime = function (items) {
            var _this = this;
            var a = Array.from(lodash_1.flatten(items));
            var sum = 0;
            _.forEach(a, function (i) {
                sum += _this.getShopDowntime2(i);
            });
            return sum;
        };
        DowntimeShiftReportCtrl.prototype.getShopAreaDowntime = function (item, isentireMachine) {
            var a = Array.from(lodash_1.flatten(item.areas));
            var sum = 0;
            _.forEach(a, function (i) {
                if (i.entireMachine && isentireMachine) {
                    sum += i.totalMinute;
                }
                else if (!i.entireMachine && !isentireMachine) {
                    sum += i.totalMinute;
                }
            });
            return sum;
        };
        DowntimeShiftReportCtrl.prototype.getShopAreaDowntime2 = function (item) {
            var a = Array.from(lodash_1.flatten(item.areas));
            var sum = 0;
            _.forEach(a, function (i) {
                sum += i.totalMinute;
            });
            return sum;
        };
        DowntimeShiftReportCtrl.prototype.getPlantAreaDowntime = function (items) {
            var _this = this;
            var a = Array.from(lodash_1.flatten(items));
            var sum = 0;
            _.forEach(a, function (i) {
                sum += _this.getShopAreaDowntime2(i);
            });
            return sum;
        };
        DowntimeShiftReportCtrl.prototype.getDowntimeTypes = function () {
            return this.downtimeService.getDowntimeTypesAndReasons();
        };
        DowntimeShiftReportCtrl.prototype.tableToCsv = function (tableId, exportAsFileName, exclusionList, mergedColCount, columnCount) {
            var headers = this.summary.map(function (x) { return x.shopName; });
            var rows = document.getElementById(tableId).rows;
            var result = "";
            var cols = Array.apply(null, Array(mergedColCount)).map(function (x, i) { return ''; });
            var _loop_1 = function () {
                var data = "";
                if (row > 0 && mergedColCount && mergedColCount > 0) {
                    var c = rows[row].cells[0].innerText.trim();
                    if (rows[row].cells.length == 1) {
                        if (headers.indexOf(c) > -1) {
                            cols[0] = c;
                        }
                        else {
                            cols[1] = c;
                        }
                    }
                    else {
                        if (exclusionList && exclusionList.indexOf(c) > -1) {
                            return "continue";
                        }
                        else {
                            _.forEach(cols, function (col) {
                                data += '"' + col + '",';
                            });
                        }
                    }
                }
                for (var column = 0; column < rows[row].cells.length; column++) {
                    if (row == 0) {
                        data += '"' + rows[row].cells[column].innerText.trim() + '",';
                    }
                    else {
                        if (rows[row].cells.length > 1) {
                            data += '"' + rows[row].cells[column].innerText.trim() + '",';
                        }
                    }
                }
                if (data.split(',').length >= (columnCount - 1)) {
                    data += "\n";
                }
                result += data;
            };
            for (var row = 0; row < rows.length; row++) {
                _loop_1();
            }
            if (navigator.msSaveBlob) {
                navigator.msSaveBlob(new Blob([result], { type: 'text/csv;charset=utf-8;' }), exportAsFileName);
            }
            else {
                var a = document.createElement("a");
                a.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(result);
                a.target = '_blank';
                a.download = exportAsFileName;
                document.body.appendChild(a);
                a.click();
            }
        };
        DowntimeShiftReportCtrl.prototype.tableToCsv2 = function (items, exportAsFileName) {
            var result = "Shop, Shift, Date, Time, Reason, Area, Machine, Section, Cavity, MachineMinutes, SectionMinutes, Comments";
            result += "\n";
            for (var i = 0; i < items.length; i++) {
                var currentshop = items[i];
                for (var j = 0; j < currentshop.downtimeDetailsReportItems.length; j++) {
                    var currentshift = currentshop.downtimeDetailsReportItems[j];
                    result += '"' + currentshop.shopName + '",';
                    result += '"' + currentshift.shiftName + '",';
                    result += '"' + moment(currentshift.startTime).format("YYYY-MM-DD") + '",';
                    result += '"' + moment(currentshift.startTime).format("HH:mm:ss") + '",';
                    result += '"' + currentshift.reason + '",';
                    result += '"' + currentshift.downtimeArea + '",';
                    result += '"' + currentshift.machineName + '",';
                    result += currentshift.section == null ? '"' + 'N/A' + '",' : '"' + currentshift.section + '",';
                    result += currentshift.gobName == null ? '"' + 'N/A' + '",' : '"' + currentshift.gobName + '",';
                    result += currentshift.entireMachine == true ? '"' + currentshift.duration + '",' : '"' + ' ' + '",';
                    result += currentshift.entireMachine == false ? '"' + currentshift.duration + '",' : '"' + ' ' + '",';
                    result += currentshift.comment == null ? '"' + '' + '",' : '"' + currentshift.comment + '",';
                    result += "\n";
                }
            }
            var a = document.createElement("a");
            a.href = 'data:attachment/csv;charset=utf-8,' + encodeURIComponent(result);
            a.target = '_blank';
            a.download = exportAsFileName;
            document.body.appendChild(a);
            a.click();
        };
        return DowntimeShiftReportCtrl;
    }());
    exports.default = angular.module('aps.controller.downtimeShiftReport', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.DOWNTIME_SHIFT_REPORT,
            url: '/DowntimeShiftReport',
            params: {
                reportDate: { dynamic: true },
                reportPlantId: { dynamic: true }
            },
            controller: 'DowntimeShiftReportCtrl as vm',
            template: downtimeShiftReport_tpl_html_1.default,
            data: {
                pageTitle: 'Downtime Shift Report'
            }
        });
    }])
        .controller('DowntimeShiftReportCtrl', DowntimeShiftReportCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<style>.sectionData{border-bottom:solid 1px #dbd9d9}</style> <div class=main-table-w> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div class=body-header> <h2>Downtime Shift Report</h2> </div> <br> <br> <br> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-4 columns\"> <label> <input type=radio name=occurrence ng-model=vm.isSingleDayReport ng-change=\"vm.radioChange('single')\" ng-value=true /> Single Day Report </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-4 columns\"> <label> <input type=radio name=occurrence ng-model=vm.isSingleDayReport ng-change=\"vm.radioChange('multi')\" ng-value=false /> Multi Day Report(CSV Only) </label> </div> <div class=\"small-4 columns\"> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>Plant <select ng-model=vm.selectedPlant ng-options=\"plant as plant.name for plant in vm.plants\" ng-change=vm.updatePlant() name=selectedPlant required> <option value=\"\">-- Select a Plant --</option> </select> <div ng-messages=vm.form.selectedPlant.$error ng-if=\"vm.form.selectedPlant.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> <div class=\"small-3 columns\"> <label> Area <select name=type ng-model=vm.downtimeType ng-options=\"cls.downtimeTypeDescription for cls in vm.downtimeTypes | orderBy: 'downtimeTypeDescription' \"> <option value=\"\">-- All Areas --</option> </select> </label> </div> <div ng-if=vm.isSingleDayReport> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>Report Date <input type=date ng-model=vm.reportDate name=reportDate required/> <div ng-messages=vm.form.reportDate.$error ng-if=\"vm.form.reportDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> </div> <div ng-if=!vm.isSingleDayReport> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>Report Start Date <input type=datetime-local date-time-picker ng-model=vm.reportStartDate name=reportStartDate time-model=vm.startDate time-zone=vm.selectedPlant.timeZoneId required/> <div ng-messages=vm.form.reportStartDate.$error ng-if=\"vm.form.reportStartDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>Report End Date <input type=datetime-local date-time-picker ng-model=vm.reportEndDate name=reportEndDate time-model=vm.endDate time-zone=vm.selectedPlant.timeZoneId required/> <div ng-messages=vm.form.reportEndDate.$error ng-if=\"vm.form.reportEndDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns\"> <button type=submit class=button>Generate Report</button> </div> </div> <div class=row style=\"margin:0 -25px;width:auto\"> <div class=\"small-12 large-6 columns\"> <div class=header ng-if=\"vm.report != null && !vm.isSingleDayReport && !vm.showReportData\"> <div><b>File has been downloaded </b> </div> </div> </div> </div> <div class=row style=\"margin:0 -25px;width:auto\"> <div class=\"small-12 large-6 columns\"> <div class=header ng-if=\"(vm.report != null && vm.summary != null && vm.summary.length == 0 && vm.isSingleDayReport && vm.showReportData)\"> <div><b>No records found matching filter criteria</b> </div> </div> <div ng-if=\"vm.report != null && vm.summary != null && vm.summary.length > 0 && vm.isSingleDayReport && vm.showReportData\" class=\"row shiftReport\"> <div class=header> <div><b>{{vm.selectedPlant.name}} Downtime Summary- {{ vm.formattedReportDate }}</b> <a href=# ng-click=\"$event.preventDefault();vm.tableToCsv('tblSummary',vm.formattedReportDate + '_downtime_summary.csv', ['Total', 'Plant Total'], 2, 5)\">[To CSV]</a> </div> </div> <div class=row> <!-- Shop Header --> <table class=shopSection id=tblSummary> <thead> <tr> <th class=sectionHeader>Shop</th> <th class=sectionHeader>Shift</th> <th class=\"sectionHeader headerspan\" colspan=2>Downtime</th> <th class=sectionHeader>Reason</th> <th class=sectionHeader>Area</th> </tr> <tr> <th class=sectionHeader></th> <th class=sectionHeader></th> <th class=\"sectionHeader newpalletColumn\">Machine Mins</th> <th class=\"sectionHeader newpalletColumn\">Sectional Mins</th> <th class=sectionHeader></th> <th class=sectionHeader></th> </tr> </thead> <!-- Shop Summary --> <tbody ng-repeat=\"shop in vm.summary\" style=text-align:center> <tr> <!-- Show the Shop column just once and span it over the total number of detail rows --> <td class=\"sectionData mergedColumn\" rowspan=\"{{vm.getSummaryShiftRows(shop) + 5}}\"> <h4>{{shop.shopName}}</h4> </td> </tr> <tr ng-repeat-start=\"shift in shop.shift track by $index\"> <!-- Show the shift name only if this is the first time that shift is being shown; otherwise hide the column and let the rowspan take over --> <td class=sectionData rowspan=\"{{vm.getSummaryReasonRows(shift) + 1}}\"> {{shift.shiftName}} </td> </tr> <tr ng-repeat-end ng-repeat=\"re in shift.reasons track by $index\"> <td class=sectionData> {{re.entireMachine? re.totalMinute:\"\"}} </td> <td class=sectionData> {{re.entireMachine? \"\":re.totalMinute}} </td> <td class=sectionData> {{re.reason}} </td> <td class=sectionData> {{re.downtimeType}} </td> </tr> <tr ng-repeat-end style=background-color:#ebf5fb> <td class=sectionData> <h6>Total</h6> </td> <td class=sectionData style=color:red!important;font-size:medium> {{vm.getShopDowntime(shop, true)}} </td> <td class=sectionData style=color:red!important;font-size:medium> {{vm.getShopDowntime(shop, false)}} </td> <td class=sectionData colspan=2></td> </tr> </tbody> <tr> <td class=sectionData colspan=2> <h4>Plant Total</h4> </td> <td class=sectionData style=color:red!important;font-size:medium> {{vm.getPlantDowntime(vm.summary)}} </td> <td class=sectionData colspan=3></td> </tr> </table> </div> </div> </div> <div class=\"small-12 large-6 columns\"> <div ng-if=\"vm.report != null && vm.summary != null && vm.summary.length > 0 && vm.isSingleDayReport && vm.showReportData\" class=\"row shiftReport\"> <div class=header> <div><b>{{vm.selectedPlant.name}} Downtime by Area - {{ vm.formattedReportDate }}</b> <a href=# ng-click=\"$event.preventDefault();vm.tableToCsv('tblSummarybyArea',vm.formattedReportDate + '_downtime_by_area.csv', ['Total', 'Plant Total'], 1, 3)\">[To CSV]</a> </div> </div> <div class=row> <!-- Shop Header --> <table class=shopSection id=tblSummarybyArea> <thead> <tr> <th class=sectionHeader>Shop</th> <th class=\"sectionHeader headerspan\" colspan=2>Downtime</th> <th class=sectionHeader>Area</th> </tr> <tr> <th class=sectionHeader></th> <th class=\"sectionHeader newpalletColumn\">Machine Mins</th> <th class=\"sectionHeader newpalletColumn\">Sectional Mins</th> <th class=sectionHeader></th> </tr> </thead> <!-- Shop Summary --> <tbody ng-repeat=\"shop in vm.summaryByArea\" style=text-align:center> <tr> <!-- Show the Shop column just once and span it over the total number of detail rows --> <td class=\"sectionData mergedColumn\" rowspan=\"{{vm.getSummaryAreaRows(shop) + 1}}\"> <h4>{{shop.shopName}}</h4> </td> </tr> <tr ng-repeat=\"area in shop.areas track by $index\"> <td class=sectionData> {{area.entireMachine ? area.totalMinute : \"\"}} </td> <td class=sectionData> {{area.entireMachine ? \"\" :area.totalMinute}} </td> <td class=sectionData> {{area.downtimeType}} </td> </tr> <tr style=background-color:#ebf5fb rowspan=2> <td class=sectionData> <h6>Total</h6> </td> <td class=sectionData style=color:red!important;font-size:medium> {{vm.getShopAreaDowntime(shop, true)}} </td> <td class=sectionData style=color:red!important;font-size:medium> {{vm.getShopAreaDowntime(shop, false)}} </td> <td class=sectionData></td> </tr> </tbody> <tr> <td class=sectionData> <h4>Plant Total</h4> </td> <td class=sectionData style=color:red!important;font-size:medium> {{vm.getPlantAreaDowntime(vm.summaryByArea)}} </td> <td class=sectionData colspan=3></td> </tr> </table> </div> </div> </div> </div> <div class=\"row shiftReport\" ng-if=\"vm.report != null && vm.summary != null && vm.summary.length > 0 && vm.isSingleDayReport && vm.showReportData\" style=\"margin:0 -25px;width:auto\"> <div class=header> <div class=\"left leftAlign\"><b>{{vm.selectedPlant.name}} Downtime Shift Report - {{ vm.formattedReportDate }}</b></div> </div> </div> <!-- Repeat this table for each shop returned in the report object --> <div class=\"row shiftReport\" ng-if=\"vm.report != null && vm.summary != null && vm.summary.length > 0 && vm.isSingleDayReport && vm.showReportData\" ng-repeat=\"shop in vm.report\" style=\"margin:0 -25px;width:auto\"> <div class=row> <!-- Shop Header --> <table class=shopSection> <thead> <tr> <th class=sectionHeader>Shop</th> <th class=sectionHeader>Shift</th> <th class=sectionHeader>Time</th> <th class=sectionHeader>Min</th> <th class=sectionHeader>Code</th> <th class=sectionHeader>Stop description</th> <!-- Ignore \"All Machine\" column for now --> <!-- <th class=\"sectionHeader\">All <br />Machine<br />A</th> --> <th class=sectionHeader ng-repeat=\"summaryItem in shop.downtimeSummaryReportItems\" class=sectionHeader> {{ vm.getSectionName(summaryItem)}} </th> </tr> </thead> <!-- Shop Detail --> <tbody style=text-align:center> <tr> <!-- Show the Shop column just once and span it over the total number of detail rows --> <td class=\"sectionData mergedColumn\" rowspan=\"{{shop.downtimeDetailsReportItems.length + 1}}\"> {{shop.shopName}} </td> </tr> <tr ng-repeat=\"detailItem in shop.downtimeDetailsReportItems track by $index\"> <!-- Show the shift name only if this is the first time that shift is being shown; otherwise hide the column and let the rowspan take over --> <td ng-if=\"vm.shiftName != detailItem.shiftName\" class=\"sectionData mergedColumn\" rowspan=\"{{ vm.getShiftRows(shop.downtimeDetailsReportItems, detailItem.shiftName) }}\"> {{detailItem.shiftName}} </td> <td class=sectionData> {{detailItem.startTime | date:'hh:mm a'}} </td> <td class=sectionData> {{detailItem.duration}} </td> <td class=sectionData> <!-- Code goes here --> </td> <td class=sectionData> {{detailItem.downtimeType}} - {{detailItem.reason}} </td> <!-- Repeat the \"X\" columns for every section in the header --> <td class=sectionData ng-repeat=\"summaryItem in shop.downtimeSummaryReportItems\"> <!-- Only show an \"X\" if the item section matches the column section; otherwise leave it blank --> {{ vm.getColumnMark(detailItem.nameSection, summaryItem.nameSection) }} </td> </tr> </tbody> </table> </div> </div> <!-- Repeat this table for each shop returned in the report object --> </form> </div>");

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(3), __webpack_require__(897), __webpack_require__(4), __webpack_require__(16), __webpack_require__(91), __webpack_require__(7), __webpack_require__(8), __webpack_require__(6), __webpack_require__(34), __webpack_require__(111)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, constant_module_1, downtimeShiftReportInsight_tpl_html_1, loader_service_1, report_service_1, downtime_service_1, authData_service_1, navigation_service_1, notify_service_1, Highcharts, downtime_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, downtime_service_1.default, report_service_1.default, authData_service_1.default, navigation_service_1.default, notify_service_1.default];
    var downtimeShiftReportInsightCtrl = (function () {
        downtimeShiftReportInsightCtrl.$inject = ["$state", "$stateParams", "navigationService", "reportService", "downtimeService", "loaderService", "authDataService", "notifyService", "$q"];
        function downtimeShiftReportInsightCtrl($state, $stateParams, navigationService, reportService, downtimeService, loaderService, authDataService, notifyService, $q) {
            var _this = this;
            this.updatePlant = function () {
                _this.availableShops = _this.selectedPlant.shops;
                if (_this.selectedShops.length > 0) {
                    _this.selectedShops = [];
                }
            };
            this.addArea = function () {
                if (_this.downtimeType === null || _this.downtimeType === undefined) {
                    _this.selectedAreas = [];
                    _this.downtimeTypes.forEach(function (element) {
                        _this.selectedAreas.push(element);
                    });
                    _this.availableAreas = [];
                }
                else {
                    var exisitng = _this.selectedAreas.filter(function (x) { return x.downtimeTypeId == _this.downtimeType.downtimeTypeId; });
                    if (exisitng.length === 0) {
                        _this.selectedAreas.push(_this.downtimeType);
                        _.remove(_this.availableAreas, _this.downtimeType);
                    }
                }
            };
            this.removeArea = function (area) {
                _.remove(_this.selectedAreas, area);
                _this.availableAreas.push(area);
            };
            this.addShop = function () {
                if (_this.selectedShop === null || _this.selectedShop === undefined) {
                    _this.selectedShops = [];
                    _this.selectedPlant.shops.forEach(function (element) {
                        _this.selectedShops.push(element);
                    });
                    _this.availableShops = [];
                }
                else {
                    var exisitng = _this.selectedShops.filter(function (x) { return x.id == _this.selectedShop.id; });
                    if (exisitng.length === 0) {
                        _this.selectedShops.push(_this.selectedShop);
                        _.remove(_this.availableShops, _this.selectedShop);
                    }
                }
            };
            this.removeShop = function (shop) {
                _.remove(_this.selectedShops, shop);
                _this.availableShops.push(shop);
            };
            var vm = this;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.loaderService = loaderService;
            this.reportService = reportService;
            this.downtimeService = downtimeService;
            this.authDataService = authDataService;
            this.notifyService = notifyService;
            this.$q = $q;
            var now = moment().add(1, 'hours').startOf('hour');
            this.uiEndDate = now.toDate();
            this.uiStartDate = now.clone().subtract(1, 'days').toDate();
            var promise = navigationService.getNavigation().then(function (navModel) {
                _this.plants = navModel.plants();
                _this.selectedPlant = navModel.selectedPlant;
                return _this.loadState($stateParams).then(function (data) {
                    vm.downtimeTypes = data.downtimeTypes;
                    var streamId = '00000000-0000-0000-0000-000000000000';
                    var toolChangeId = 'bbdf0000-3a00-000d-c122-08d2e5fba957';
                    vm.downtimeTypes.push(new downtime_1.DowntimeType(streamId, 'Streaming'));
                    vm.downtimeTypes.push(new downtime_1.DowntimeType(toolChangeId, 'Tool Change'));
                    vm.availableAreas = vm.downtimeTypes;
                    vm.selectedAreas = [];
                    vm.availableShops = _.clone(vm.selectedPlant.shops);
                    vm.selectedShops = [];
                });
            });
            loaderService.loadingPromise(promise);
        }
        downtimeShiftReportInsightCtrl.prototype.loadState = function (params) {
            if (params.reportPlantId && params.reportShopId && params.reportShopId !== params.shopId) {
                var plant = _.find(this.plants, { id: params.reportPlantId });
                if (plant) {
                    var shop = _.find(plant.shops, { id: params.reportShopId });
                    if (shop) {
                        this.selectedPlant = plant;
                    }
                }
            }
            if (params.startDate) {
                var startDate = moment(params.startDate);
                if (startDate.isValid()) {
                    this.startDate = startDate.toDate();
                }
            }
            return this.getDowntimeTypes();
        };
        downtimeShiftReportInsightCtrl.prototype.saveState = function () {
            var reportPlantId = this.selectedPlant ? this.selectedPlant.id : undefined;
            if (reportPlantId === this.$stateParams.plantId) {
                reportPlantId = undefined;
            }
            var reportShopId = this.selectedShop ? this.selectedShop.id : undefined;
            if (reportShopId === this.$stateParams.shopId) {
                reportShopId = undefined;
            }
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportPlantId: reportPlantId,
                reportShopId: reportShopId,
                startDate: this.startDate ? this.startDate.toISOString() : undefined,
                endDate: this.endDate ? this.endDate.toISOString() : undefined
            };
            this.$state.transitionTo(this.$state.current.name, params);
        };
        downtimeShiftReportInsightCtrl.prototype.generateReport = function (regenerate) {
            if (this.form.$invalid) {
                return;
            }
            var diff = moment(this.endDate).diff(this.startDate, 'days');
            if (diff > 185) {
                this.notifyService.error('Date range cannot exceed 6 months');
                return;
            }
            this.saveState();
            this.loaderService.loadingPromise(this.runReport());
        };
        downtimeShiftReportInsightCtrl.prototype.runReport = function () {
            var _this = this;
            var req = {
                plantId: this.selectedPlant.id,
                startDate: this.startDate,
                endDate: this.endDate,
                shopIds: [],
                areaIds: []
            };
            if (this.selectedShops.length > 0) {
                this.selectedShops.forEach(function (element) {
                    req.shopIds.push(element.id);
                });
            }
            if (this.selectedAreas.length > 0) {
                this.selectedAreas.forEach(function (element) {
                    req.areaIds.push(element.downtimeTypeId);
                });
            }
            var promise = this.reportService.getDowntimeInsight(req);
            promise.then(function (result) {
                _this.createChart('container_area', _this.getSeriesOptionByArea(result.trend_Area));
                _this.createChart('container_reason', _this.getSeriesOptionByReason(result.trend_Reason));
                _this.createBarChart('container_Top_Reason', _this.getSeries(result.top5_Reason, 'reason'), _this.getCategoryByReason(result.top5_Reason));
                _this.createBarChart('container_Top_Area', _this.getSeries(result.top5_Area, 'area'), _this.getCategoryByArea(result.top5_Area));
            });
            return promise;
        };
        downtimeShiftReportInsightCtrl.prototype.getSeries = function (data, type) {
            var seriesData = [];
            var item = {
                name: '',
                colorByPoint: true,
                data: [],
                dataLabels: []
            };
            data.forEach(function (x) {
                x.details.forEach(function (y) {
                    item.data.push(y.downtimeTotal);
                });
            });
            data.forEach(function (x) {
                x.details.forEach(function (y) {
                    item.dataLabels.push({
                        align: 'center',
                        zIndex: -1,
                        formatter: function () {
                            return formatter(this, data, type);
                        }
                    });
                });
            });
            seriesData.push(item);
            return seriesData;
        };
        downtimeShiftReportInsightCtrl.prototype.getCategoryByArea = function (data) {
            var categoryData = [];
            data.forEach(function (x) {
                categoryData.push(x.area);
            });
            return categoryData;
        };
        downtimeShiftReportInsightCtrl.prototype.getCategoryByReason = function (data) {
            var categoryData = [];
            data.forEach(function (x) {
                categoryData.push(x.reason);
            });
            return categoryData;
        };
        downtimeShiftReportInsightCtrl.prototype.getSeriesOptionByArea = function (data) {
            var seriesOptions = [];
            var i = 0;
            data.forEach(function (x) {
                var item = [];
                x.details.forEach(function (y) {
                    var datapoint = {
                        x: y.epoch,
                        y: y.downtimeTotal
                    };
                    item.push(datapoint);
                });
                seriesOptions[i] = {
                    name: x.area,
                    data: item
                };
                i++;
            });
            return seriesOptions;
        };
        downtimeShiftReportInsightCtrl.prototype.getSeriesOptionByReason = function (data) {
            var seriesOptions = [];
            var i = 0;
            data.forEach(function (x) {
                var item = [];
                x.details.forEach(function (y) {
                    var datapoint = {
                        x: y.epoch,
                        y: y.downtimeTotal
                    };
                    item.push(datapoint);
                });
                seriesOptions[i] = {
                    name: x.reason,
                    data: item
                };
                i++;
            });
            return seriesOptions;
        };
        downtimeShiftReportInsightCtrl.prototype.createBarChart = function (containerName, seriesData, categoryData) {
            Highcharts.chart(containerName, {
                chart: {
                    type: 'column',
                    zoomType: 'y'
                },
                title: {
                    text: ''
                },
                xAxis: {
                    categories: categoryData,
                    title: {
                        text: ''
                    }
                },
                yAxis: [{
                        min: 0,
                        title: {
                            text: 'Downtime in Minutes'
                        }
                    }],
                legend: {
                    enabled: false,
                    shadow: false
                },
                plotOptions: {
                    column: {
                        grouping: false,
                        shadow: false,
                        pointWidth: 30,
                        dataLabels: {
                            enabled: true
                        }
                    }
                },
                series: seriesData,
                credits: { enabled: false }
            });
        };
        downtimeShiftReportInsightCtrl.prototype.createChart = function (containerId, seriesOptions) {
            Highcharts.chart(containerId, {
                title: {
                    text: ''
                },
                time: {
                    useUTC: false
                },
                xAxis: {
                    type: 'datetime',
                    title: {
                        text: ''
                    },
                    dateTimeLabelFormats: {
                        second: '%l:%M:%S %p',
                        minute: '%l:%M %p',
                        hour: '%l %p',
                        day: '%m/%d/%Y',
                        month: '%m/%d/%Y',
                        year: '%m/%d/%Y'
                    }
                },
                yAxis: {
                    labels: {
                        formatter: function () {
                            return (this.value > 0 ? ' + ' : '') + this.value;
                        }
                    },
                    title: {
                        text: 'Downtime in Minutes'
                    },
                    plotLines: [{
                            value: 0,
                            width: 2,
                            color: 'silver'
                        }]
                },
                series: seriesOptions,
                credits: { enabled: false }
            });
        };
        downtimeShiftReportInsightCtrl.prototype.getDowntimeTypes = function () {
            return this.downtimeService.getDowntimeTypesAndReasons();
        };
        return downtimeShiftReportInsightCtrl;
    }());
    exports.default = angular.module('aps.controller.downtimeShiftReportInsight', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.DOWNTIME_SHIFT_REPORT_INSIGHT,
            url: '/downtimeShiftReportInsight',
            params: {
                startDate: { dynamic: true },
                reportPlantId: { dynamic: true }
            },
            controller: 'downtimeShiftReportInsightCtrl as vm',
            template: downtimeShiftReportInsight_tpl_html_1.default,
            data: {
                pageTitle: 'Downtime Shift Report Trends'
            }
        });
    }])
        .controller('downtimeShiftReportInsightCtrl', downtimeShiftReportInsightCtrl)
        .name;
    function formatter(baseSeries, data, type) {
        var predicate = (_a = {}, _a[type] = baseSeries.key, _a);
        var seriesdata = _.find(data, predicate);
        return seriesdata.details[0].downtimeTotal;
        var _a;
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<style>.sectionData{border-bottom:solid 1px #dbd9d9}</style> <div class=main-table-w> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div class=body-header> <h2>Downtime Shift Report Insight</h2> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-2 columns\"> <label> <span class=\"required notated\">*</span>Plant <select ng-model=vm.selectedPlant ng-options=\"plant as plant.name for plant in vm.plants\" ng-change=vm.updatePlant() name=selectedPlant required> <option value=\"\">-- Select a Plant --</option> </select> <div ng-messages=vm.form.selectedPlant.$error ng-if=\"vm.form.selectedPlant.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>Start Date <input type=datetime-local date-time-picker ng-model=vm.uiStartDate time-model=vm.startDate time-zone=vm.selectedPlant.timeZoneId name=reportStartDate required/> <div ng-messages=vm.form.reportStartDate.$error ng-if=\"vm.form.reportStartDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>End Date <input type=datetime-local date-time-picker ng-model=vm.uiEndDate time-model=vm.endDate time-zone=vm.selectedPlant.timeZoneId ng-model=vm.reportEndDate name=reportEndDate required/> <div ng-messages=vm.form.reportEndDate.$error ng-if=\"vm.form.reportEndDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> <div class=\"small-2 columns\"> <button type=submit class=\"button small\" style=position:relative;top:14px>Get Charts</button> </div> <div class=\"small-2 columns\"> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-2 columns\"> <label> Area <select name=type ng-model=vm.downtimeType ng-options=\"cls.downtimeTypeDescription for cls in vm.availableAreas | orderBy: 'downtimeTypeDescription' \"> <option value=\"\">-- All Areas --</option> </select> </label> </div> <div class=\"small-1 columns\"> <button type=button style=position:relative;top:22px;font-size:.6em ng-click=vm.addArea() class=\"button tiny\">Add Areas</button> </div> <div class=\"small-9 columns\"> <ul class=\"row area-manage\" style=\"margin:0 0;width:auto;list-style:none\"> <li ng-if=\"vm.selectedAreas.length > 0\" class=area-block> <strong>Selected Areas:</strong> <ul> <li ng-repeat=\"area in vm.selectedAreas\" style=font-size:1em;display:inline> {{area.downtimeTypeDescription}} <a ng-click=vm.removeArea(area) style=font-size:.65em><i class=\"fa fa-times\" style=color:red></i>Remove</a> </li> <ul> </ul></ul></li> </ul> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-2 columns\"> <label> Shop <select name=selectedShop ng-model=vm.selectedShop ng-options=\"shop as shop.name for shop in vm.availableShops | orderBy: 'name'\"> <option value=\"\">--All Shops--</option> </select> </label> </div> <div class=\"small-1 columns\"> <button type=button style=position:relative;top:22px;font-size:.6em ng-click=vm.addShop() class=\"button tiny\">Add Shops</button> </div> <div class=\"small-9 columns\"> <ul class=\"row area-manage\" style=\"margin:0 0;width:auto;list-style:none\"> <li ng-if=\"vm.selectedShops.length > 0\" class=area-block> <strong>Selected Shops:</strong> <ul> <li ng-repeat=\"shop in vm.selectedShops\" style=font-size:1em;display:inline> {{shop.name}} <a ng-click=vm.removeShop(shop) style=font-size:.65em><i class=\"fa fa-times\" style=color:red></i>Remove</a> </li> <ul> </ul></ul></li> </ul> </div> </div> <div class=row style=\"margin:0 -25px;width:auto;border-top:1px solid\"> <div class=\"col-lg-5 columns\"> <div class=text-center> <h4>Trending by Area</h4> </div> <div id=container_area style=width:100%;height:310px></div> </div> <div class=\"col-lg-4 columns\" style=\"border-left:1px solid\"> <div class=text-center> <h4>Top 5 Areas</h4> </div> <div id=container_Top_Area style=width:100%;height:310px></div> </div> <div class=\"col-lg-3 columns\" style=\"border-left:1px solid\"> <div class=text-center> <h4>Top 5 Reasons</h4> </div> <div id=container_Top_Reason style=width:140%;height:310px></div> </div> </div> <div class=row style=\"margin:0 -25px;width:auto;border-top:1px solid\"> <div class=text-center> <h4>Trending by Reason</h4> </div> <div id=container_reason style=width:100%;height:550px></div> </div> </form> </div>");

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(34), __webpack_require__(1), __webpack_require__(899), __webpack_require__(9), __webpack_require__(4), __webpack_require__(16), __webpack_require__(11), __webpack_require__(3), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, Highcharts, moment, dumpGateTimeReport_tpl_html_1, uiUtility_service_1, loader_service_1, report_service_1, dateutility_service_1, constant_module_1, navigation_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [uiUtility_service_1.default, loader_service_1.default, report_service_1.default, navigation_service_1.default];
    var DumpGateTimeReportCtrl = (function () {
        DumpGateTimeReportCtrl.$inject = ["$state", "$stateParams", "navigationService", "plantService", "reportService", "loaderService", "uiUtilityService", "$q"];
        function DumpGateTimeReportCtrl($state, $stateParams, navigationService, plantService, reportService, loaderService, uiUtilityService, $q) {
            var _this = this;
            this.reportStartDate = new Date();
            this.reportEndDate = new Date();
            var vm = this;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.loaderService = loaderService;
            this.reportService = reportService;
            this.uiUtilityService = uiUtilityService;
            this.$q = $q;
            this.reportEndDate.setHours(7);
            this.reportEndDate.setMinutes(0);
            this.reportEndDate.setSeconds(0);
            this.reportStartDate.setDate(this.reportEndDate.getDate() - 1);
            this.reportStartDate.setHours(7);
            this.reportStartDate.setMinutes(0);
            this.reportStartDate.setSeconds(0);
            var navPromise = navigationService.getNavigation().then(function (navModel) {
                _this.plants = navModel.plants();
                _this.selectedPlant = navModel.selectedPlant;
                _this.selectedShop = navModel.selectedShop;
            });
            var plantsPromise = plantService.getPlants().then(function (plants) {
                _this.shiftPlants = plants;
            });
            var promise = $q.all([navPromise, plantsPromise]).then(function () {
                _this.updatePlant();
                _this.loadState($stateParams);
                return _this.generateReport();
            });
            loaderService.loadingPromise(promise);
        }
        DumpGateTimeReportCtrl.prototype.updatePlant = function () {
            var _this = this;
            var shiftPlant = this.shiftPlants.filter(function (p) { return p.id === _this.selectedPlant.id; })[0];
            this.shifts = shiftPlant.shiftSchedules.map(function (s) {
                return {
                    id: s.id,
                    name: s.name
                };
            });
        };
        DumpGateTimeReportCtrl.prototype.loadState = function (params) {
            if (params.reportPlantId && params.reportShopId && params.reportShopId !== params.shopId) {
                var plant = _.find(this.plants, { id: params.reportPlantId });
                if (plant) {
                    var shop = _.find(plant.shops, { id: params.reportShopId });
                    if (shop) {
                        this.selectedPlant = plant;
                        this.selectedShop = shop;
                    }
                }
            }
            if (params.startDate) {
                this.reportStartDate = new Date(params.startDate);
            }
            if (params.endDate) {
                this.reportEndDate = new Date(params.endDate);
            }
            return this.$q.when();
        };
        DumpGateTimeReportCtrl.prototype.saveState = function () {
            var reportShopId = this.selectedShop ? this.selectedShop.id : undefined;
            if (reportShopId === this.$stateParams.shopId) {
                reportShopId = undefined;
            }
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportPlantId: (reportShopId && this.selectedPlant) ? this.selectedPlant.id : undefined,
                reportShopId: reportShopId,
                startDate: this.reportStartDate ? this.reportStartDate.toString() : undefined,
                endDate: this.reportEndDate ? this.reportEndDate.toString() : undefined,
            };
            this.$state.transitionTo(this.$state.current.name, params);
        };
        DumpGateTimeReportCtrl.prototype.generateReport = function () {
            if (this.form.$invalid) {
                return;
            }
            this.saveState();
            this.loaderService.loadingPromise(this.runDumpGateTimeReport());
        };
        DumpGateTimeReportCtrl.prototype.runDumpGateTimeReport = function () {
            var _this = this;
            if (this.selectedShop == null) {
                this.reportShopId = '';
                this.reportShopName = '';
            }
            else {
                this.reportShopId = this.selectedShop.id;
                this.reportShopName = this.selectedShop.name;
            }
            if (this.selectedShift == null) {
                this.reportShiftId = '';
                this.reportShiftName = '';
            }
            else {
                this.reportShiftId = this.selectedShift.id;
                this.reportShiftName = this.selectedShift.name;
            }
            this.reportTimeZoneId = this.selectedPlant.timeZoneId;
            this.dumpGateTimeItems = null;
            this.searchPerformed = false;
            var promise = this.reportService.getDumpGateTimeReport(this.selectedPlant.id, this.reportShopId, this.reportShiftId, this.reportStartDate, this.reportEndDate);
            promise.then(function (data) {
                _this.searchPerformed = true;
                if (data === null || data.length === 0) {
                    return;
                }
                _this.dumpGateTimeItems = data;
                _this.reportTotalDuration = data.reduce(function (accumulator, currentValue) { return accumulator + currentValue.totalSeconds; }, 0);
                _this.reportTotalEvents = data.reduce(function (accumulator, currentValue) { return accumulator + currentValue.timesOpened; }, 0);
                _this.createChart('chart_area', _this.getChartSeries(_this.buildSeries(_this.dumpGateTimeItems, _this.reportStartDate, _this.reportEndDate)));
            });
            return promise;
        };
        DumpGateTimeReportCtrl.prototype.buildSeries = function (data, startDate, endDate) {
            var series = [];
            var uniqueShops = _.uniq(data.map(function (d) { return d.shopName; })).sort();
            uniqueShops.forEach(function (shop) {
                var shopData = data.filter(function (d) { return d.shopName === shop; });
                var shopSeries = [];
                var _loop_1 = function (currentdate) {
                    var dateElements = shopData.filter(function (x) { return x.dbDate.toDateString() === currentdate.toDateString(); });
                    shopSeries.push({
                        dbDate: new Date(currentdate.toDateString()),
                        totalSeconds: dateElements.reduce(function (sum, current) { return sum + current.totalSeconds / 60; }, 0)
                    });
                };
                for (var currentdate = new Date(startDate.toDateString()); currentdate < endDate; currentdate.setDate(currentdate.getDate() + 1)) {
                    _loop_1(currentdate);
                }
                series.push({
                    plantName: data[0].plantName,
                    shopName: shop,
                    details: shopSeries
                });
            });
            return series;
        };
        DumpGateTimeReportCtrl.prototype.formatTime = function (time) {
            return dateutility_service_1.default.formatTime(time, this.selectedPlant.timeZoneId);
        };
        DumpGateTimeReportCtrl.prototype.formatDuration = function (totalSeconds) {
            return totalSeconds / 3600 - (totalSeconds / 3600 % 1) + ":" + moment(totalSeconds * 1000).format("mm:ss");
        };
        DumpGateTimeReportCtrl.prototype.getChartSeries = function (data) {
            var seriesOptions = [];
            var i = 0;
            data.forEach(function (series) {
                var items = [];
                series.details.forEach(function (item) {
                    var datapoint = {
                        x: item.dbDate,
                        y: item.totalSeconds
                    };
                    items.push(datapoint);
                });
                seriesOptions[i] = {
                    name: series.shopName,
                    data: items
                };
                i++;
            });
            return seriesOptions;
        };
        DumpGateTimeReportCtrl.prototype.createChart = function (containerId, seriesOptions) {
            Highcharts.chart(containerId, {
                title: {
                    text: this.selectedPlant.name + " Dump Gate Time by Date"
                },
                time: {
                    useUTC: false
                },
                xAxis: {
                    type: 'datetime',
                    title: {
                        text: 'Date'
                    },
                    tickInterval: 24 * 3600 * 1000,
                    dateTimeLabelFormats: {
                        second: '%l:%M:%S %p',
                        minute: '%l:%M %p',
                        hour: '%l %p',
                        day: '%m/%d/%Y',
                        month: '%m/%d/%Y',
                        year: '%m/%d/%Y'
                    }
                },
                tooltip: {
                    formatter: function () {
                        return moment(this.x).format("MM/DD/YYYY") + "<br/>" + this.series.name + ": <strong>" + this.y.toFixed(2) + "</strong>";
                    }
                },
                yAxis: {
                    labels: {
                        formatter: function () {
                            return (this.value > 0 ? ' + ' : '') + this.value.toFixed(2);
                        }
                    },
                    title: {
                        text: 'Time in Minutes'
                    },
                    plotLines: [{
                            value: 0,
                            width: 2,
                            color: 'silver'
                        }]
                },
                series: seriesOptions,
                credits: { enabled: false }
            });
        };
        DumpGateTimeReportCtrl.prototype.exportToCsv = function () {
            var _this = this;
            var shopName = this.reportShopName !== "" ? this.reportShopName : 'All';
            var result = "Local Time, Plant, Tank, Shop, Shift, Duration, Dump Events";
            result += "\n";
            this.dumpGateTimeItems.forEach(function (row) {
                result += '"' + _this.formatTime(row.dbDate) + '",';
                result += '"' + row.plantName + '",';
                result += '"' + row.tankName + '",';
                result += '"' + row.shopName + '",';
                result += '"' + row.shiftName + '",';
                result += '"' + _this.formatDuration(row.totalSeconds) + '",';
                result += '"' + row.timesOpened + '"';
                result += "\n";
            });
            result += '"","","","",Total,';
            result += '"' + this.formatDuration(this.reportTotalDuration) + '",';
            result += '"' + this.reportTotalEvents + '"' + "\n";
            var a = document.createElement("a");
            a.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(result);
            a.target = '_blank';
            a.download = this.dumpGateTimeItems[0].plantName + '_' + shopName + '_DumpTime_' + moment(this.startDate).format("MM_DD_YYYY") + '.csv';
            document.body.appendChild(a);
            a.click();
        };
        return DumpGateTimeReportCtrl;
    }());
    exports.default = angular.module('aps.controller.dumpGateTimeReport', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.DUMPGATETIME_REPORT,
            url: '/admin/reports/dumpgatetime?startDate&endDate&reportPlantId&reportShopId',
            params: {
                startDate: { dynamic: true },
                endDate: { dynamic: true },
                reportPlantId: { dynamic: true },
                reportShopId: { dynamic: true },
            },
            controller: 'DumpGateTimeReportCtrl as vm',
            template: dumpGateTimeReport_tpl_html_1.default,
            data: {
                pageTitle: 'Dump Gate Time Report'
            }
        });
    }])
        .controller('DumpGateTimeReportCtrl', DumpGateTimeReportCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <div class=body-header> <h2>Dump Gate Time Report</h2> </div> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-2 columns\"> <label>Plant <select ng-model=vm.selectedPlant ng-options=\"plant as plant.name for plant in vm.plants\" ng-change=vm.updatePlant() name=selectedPlant required> </select> </label> </div> <div class=\"small-2 columns\"> <label>Shop <select id=shopDropdown name=selectedShop ng-model=vm.selectedShop ng-options=\"shop as shop.name for shop in vm.selectedPlant.shops\" ng-disabled=\"vm.requirePlantSelection && !vm.selectedPlant\" ng-required=vm.requireShopSelection> <option value=\"\">-- all --</option> </select> </label> </div> <div class=\"small-2 columns\"> <label>Shift <select id=shiftDropdown name=selectedShift ng-model=vm.selectedShift ng-options=\"shift as shift.name for shift in vm.shifts\"> <option value=\"\" selected=selected>-- all --</option> </select> </label> </div> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>Start Date <input type=datetime-local date-time-picker ng-model=vm.reportStartDate name=reportStartDate time-model=vm.startDate time-zone=vm.selectedPlant.timeZoneId required/> <div ng-messages=vm.form.reportStartDate.$error ng-if=\"vm.form.reportStartDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>End Date <input type=datetime-local date-time-picker ng-model=vm.reportEndDate name=reportEndDate time-model=vm.endDate time-zone=vm.selectedPlant.timeZoneId required/> <div ng-messages=vm.form.reportEndDate.$error ng-if=\"vm.form.reportEndDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-12 columns\"> <button type=submit class=button>Generate Report</button> </div> </div> </form> <div ng-if=\"(!vm.dumpGateTimeItems || !vm.dumpGateTimeItems.length) && vm.searchPerformed\"> No Dump Gate Time records found </div> <div ng-hide=\"!vm.dumpGateTimeItems || !vm.dumpGateTimeItems.length\"> <div class=row style=\"width:auto;border:1px solid\"> <div id=chart_area style=width:100%></div> </div> <br/> <div class=row> <a href=# class=right ng-click=$event.preventDefault();vm.exportToCsv();>Save as CSV </a> <div style=\"margin:0 -30px;width:auto\"> <table id=tblDumpTime class=history-t style=\"border:1px solid #a1b2bd\"> <thead> <tr> <th>Local Time ({{vm.reportTimeZoneId}})</th> <th>Plant</th> <th>Tank</th> <th>Shop</th> <th>Shift</th> <th>Duration (h:mm:ss)</th> <th>Dump Events</th> </tr> </thead> <tbody> <tr ng-repeat=\"dumpGateTime in vm.dumpGateTimeItems\" style=margin-bottom:2px> <td>{{ vm.formatTime(dumpGateTime.dbDate) }}</td> <td>{{ dumpGateTime.plantName }}</td> <td>{{ dumpGateTime.tankName }}</td> <td>{{ dumpGateTime.shopName }}</td> <td>{{ dumpGateTime.shiftName }}</td> <td>{{ dumpGateTime.totalSeconds/3600 - (dumpGateTime.totalSeconds/3600%1)}}:{{ (dumpGateTime.totalSeconds *1000) | date:'mm:ss' }}</td> <td>{{ dumpGateTime.timesOpened }}</td> </tr> </tbody> <tfoot style=background-color:#a0ccec;font-size:1em;font-weight:700> <tr> <td></td> <td></td> <td></td> <td></td> <td>Total</td> <td>{{vm.reportTotalDuration/3600 - (vm.reportTotalDuration/3600%1)}}:{{ (vm.reportTotalDuration*1000) | date:'mm:ss' }}</td> <td>{{vm.reportTotalEvents}}</td> </tr> </tfoot> </table> </div> </div> </div> </div>");

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(3), __webpack_require__(901), __webpack_require__(4), __webpack_require__(903), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, constant_module_1, productionKPIs_tpl_html_1, loader_service_1, kpi_service_1, moment) {
    "use strict";
    productionKPIsConfig.$inject = ["$stateProvider"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, kpi_service_1.default];
    function productionKPIsConfig($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.KPIS,
            url: '/production-kpis',
            controller: 'ProductionKPIsCtrl as vm',
            template: productionKPIs_tpl_html_1.default,
            data: { pageTitle: 'Production KPIs' }
        });
    }
    var ProductionKPIsCtrl = (function () {
        ProductionKPIsCtrl.$inject = ["loaderService", "$state", "$stateParams", "kpiService"];
        function ProductionKPIsCtrl(loaderService, $state, $stateParams, kpiService) {
            var _this = this;
            this.allPlants = [
                { id: 7, name: '07-JAX' },
                { id: 12, name: '12-SHA' },
                { id: 14, name: '14-WR' },
                { id: 15, name: '15-HEN' },
                { id: 41, name: '41-ELM' },
                { id: 42, name: '42-LAW' }
            ];
            this.plantList = this.allPlants.slice();
            this.lightgray = 'lightgray';
            this.red = 'red';
            this.green = 'green';
            this.yellow = 'yellow';
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.loaderService = loaderService;
            this.kpiService = kpiService;
            this.loadState($stateParams);
            var maxDatePromise = this.kpiService.getLastUpdatedDates();
            maxDatePromise.then(function (data) {
                _this.reportDate = moment().add(-1, 'days').toDate();
                _this.asOfDate = data.legacyDataLastUpdatedDate;
                _this.maxLegacyDate = _this.asOfDate;
                _this.maxSafetyDate = data.safetyDataLastUpdatedDate == "" ? "unknown" : data.safetyDataLastUpdatedDate;
                _this.maxQualityDate = data.qualityDataLastUpdatedDate == "" ? "unknown" : data.qualityDataLastUpdatedDate;
            });
        }
        ProductionKPIsCtrl.prototype.generateReport = function () {
            if (this.form.$invalid) {
                return;
            }
            this.plantList = this.allPlants.slice();
            if (this.reportDate > new Date('2024-11-20')) {
                this.plantList = this.plantList.filter(function (plant) { return plant.id !== 7; });
            }
            this.showReport = false;
            this.saveState();
            this.asOfDate = moment(this.reportDate).format("dddd, MM/DD/YYYY");
            this.loaderService.loadingPromise(this.runReport());
        };
        ProductionKPIsCtrl.prototype.runReport = function () {
            var _this = this;
            var monthlyPromise = this.kpiService.getMonthlyProductionKPIs(this.asOfDate);
            monthlyPromise.then(function (data) {
                _this.monthlyKPIs = data;
                _this.setCellColors(_this.monthlyKPIs, false);
                var dailyPromise = _this.kpiService.getDailyProductionKPIs(_this.asOfDate);
                dailyPromise.then(function (data) {
                    _this.dailyKPIs = data;
                    _this.setCellColors(_this.dailyKPIs, true);
                    _this.showReport = true;
                });
            });
            return monthlyPromise;
        };
        ProductionKPIsCtrl.prototype.setCellColors = function (plantKPIs, isDay) {
            var _this = this;
            plantKPIs.forEach(function (plantKPI) {
                plantKPI.safetyColor = _this.setSafetyColor(plantKPI.safetyCount);
                plantKPI.qualityColor = _this.setQualityColor(plantKPI.qualityCount);
                plantKPI.tonsColor = _this.setTonsPackedColor(plantKPI.tonsPacked, _this.monthlyKPIs.filter(function (x) { return x.plant == plantKPI.plant; })[0].aopTonsPacked, isDay ? 1 : _this.reportDate.getDate());
                plantKPI.packToMeltColor = _this.setPTMColor(plantKPI.packToMelt, plantKPI.aopPackToMelt);
                plantKPI.furnaceUtilizationColor = _this.setFurnaceUtilizationColor(plantKPI.furnaceUtilization);
            });
        };
        ProductionKPIsCtrl.prototype.setSafetyColor = function (count) {
            if (count == null || count == 999) {
                return this.lightgray;
            }
            if (count == 0) {
                return this.green;
            }
            return this.red;
        };
        ProductionKPIsCtrl.prototype.setQualityColor = function (count) {
            if (count == null || count == 999) {
                return this.lightgray;
            }
            if (count == 0) {
                return this.green;
            }
            return this.red;
        };
        ProductionKPIsCtrl.prototype.setTonsPackedColor = function (tons, aop, days) {
            var proratedAOP = (aop / this.reportDate.getDate()) * days;
            if (tons > proratedAOP) {
                return this.green;
            }
            if (tons == proratedAOP) {
                return this.yellow;
            }
            return this.red;
        };
        ProductionKPIsCtrl.prototype.setPTMColor = function (ptm, aopPTM) {
            if (ptm > aopPTM) {
                return this.green;
            }
            if (aopPTM - ptm <= 1) {
                return this.yellow;
            }
            return this.red;
        };
        ProductionKPIsCtrl.prototype.setFurnaceUtilizationColor = function (utilization) {
            if (utilization > 95.0) {
                return this.green;
            }
            if (utilization >= 80.0) {
                return this.yellow;
            }
            return this.red;
        };
        ProductionKPIsCtrl.prototype.loadState = function (params) {
            if (params.reportDate) {
                var reportDate = moment(params.reportDate);
                if (reportDate.isValid()) {
                    this.reportDate = reportDate.toDate();
                }
            }
        };
        ProductionKPIsCtrl.prototype.saveState = function () {
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportDate: this.reportDate ? this.reportDate.toISOString() : undefined
            };
            this.$state.transitionTo(this.$state.current.name, params);
        };
        ProductionKPIsCtrl.prototype.getKPI = function (plant, item, isDay) {
            var plantKPIs = isDay ? this.dailyKPIs : this.monthlyKPIs;
            if (plantKPIs != null) {
                switch (item) {
                    case 'safety':
                        var safetyCount = plantKPIs.filter(function (x) { return x.plant == plant; })[0].safetyCount;
                        return safetyCount == null ? "(not available)" : plantKPIs.filter(function (x) { return x.plant == plant; })[0].safetyCount.toFixed(0);
                    case 'safetyColor':
                        return plantKPIs.filter(function (x) { return x.plant == plant; })[0].safetyColor;
                    case 'quality':
                        var qualityCount = plantKPIs.filter(function (x) { return x.plant == plant; })[0].qualityCount;
                        return qualityCount == null ? "(not available)" : plantKPIs.filter(function (x) { return x.plant == plant; })[0].qualityCount.toFixed(0);
                    case 'qualityColor':
                        return plantKPIs.filter(function (x) { return x.plant == plant; })[0].qualityColor;
                    case 'tons':
                        return plantKPIs.filter(function (x) { return x.plant == plant; })[0].tonsPacked.toFixed(1);
                    case 'tonsColor':
                        return plantKPIs.filter(function (x) { return x.plant == plant; })[0].tonsColor;
                    case 'aop':
                        return this.monthlyKPIs.filter(function (x) { return x.plant == plant; })[0].aopTonsPacked.toFixed(1);
                    case 'ptm':
                        return plantKPIs.filter(function (x) { return x.plant == plant; })[0].packToMelt.toFixed(1);
                    case 'ptmColor':
                        return plantKPIs.filter(function (x) { return x.plant == plant; })[0].packToMeltColor;
                    case 'utilization':
                        return plantKPIs.filter(function (x) { return x.plant == plant; })[0].furnaceUtilization.toFixed(1);
                    case 'utilizationColor':
                        return plantKPIs.filter(function (x) { return x.plant == plant; })[0].furnaceUtilizationColor;
                    case 'legacy':
                        return plantKPIs.filter(function (x) { return x.plant == plant; })[0].isLegacy == true ? "*" : '';
                    default:
                        return null;
                }
            }
        };
        return ProductionKPIsCtrl;
    }());
    exports.default = angular.module('aps.controller.productionkpis', requires)
        .config(productionKPIsConfig)
        .controller('ProductionKPIsCtrl', ProductionKPIsCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div> <div class=body-header> <h2>Production KPIs</h2> </div> <hr> </div> <div class=row style=\"margin:0 -25px\"> <div class=\"small-2 columns\"> <label> <span class=\"required notated\">*</span>Report Date <input type=date ng-model=vm.reportDate name=reportDate required/> <div ng-messages=vm.form.reportDate.$error ng-if=\"vm.form.reportDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w><div class=arrow-up></div>Required</div> </div> </label> </div> <div class=\"small-3 columns kpi-report-button\"> <button type=submit class=button>Generate Report</button> </div> <div class=\"small-3 columns kpi-date kpi-legacy-date\"> Latest manual data available: <br/>{{ vm.maxLegacyDate }} </div> <div class=\"small-3 columns kpi-date\"> Latest safety data available: <br/>{{ vm.maxSafetyDate }} </div> <div class=\"small-3 columns kpi-date\"> Latest quality data available: <br/>{{ vm.maxQualityDate }} </div> </div> <div class=production-kpis ng-if=vm.showReport> <div class=kpi-header> <div class=kpi-logo> <img src=" + __webpack_require__(902) + " height=75> </div> <div>Production KPIs</div> <div>Daily and Month-To-Date</div> <div class=kpi-header-bottom> As of {{vm.asOfDate }} </div> </div> <div class=legacy> * = legacy (non-APS) data </div> <div class=kpi-data> <div class=kpi-data-section> <div class=data-header> DAILY </div> <div class=data> <table> <thead> <tr> <th></th> <th ng-repeat=\"plant in vm.plantList | orderBy : 'id'\">{{plant.name}}</th> </tr> </thead> <tbody> <tr> <td class=kpi-row-label>Safety</td> <td ng-repeat=\"plant in vm.plantList | orderBy : 'id'\" class=\"kpi-data-column {{ vm.getKPI(plant.id,'safetyColor', true)}}\">{{ vm.getKPI(plant.id,'safety', true)}}</td> </tr> <tr> <td class=kpi-row-label>Quality</td> <td ng-repeat=\"plant in vm.plantList | orderBy : 'id'\" class=\"kpi-data-column {{ vm.getKPI(plant.id,'qualityColor', true)}}\">{{ vm.getKPI(plant.id,'quality', true)}}</td> </tr> <tr> <td class=kpi-row-label>Tons Packed</td> <td ng-repeat=\"plant in vm.plantList | orderBy : 'id'\" class=\"kpi-data-column {{ vm.getKPI(plant.id,'tonsColor', true)}}\">{{ vm.getKPI(plant.id,'tons', true)}} {{ vm.getKPI(plant.id,'legacy', true)}}</td> </tr> <tr> <td class=kpi-row-label>Pack-to-Melt</td> <td ng-repeat=\"plant in vm.plantList | orderBy : 'id'\" class=\"kpi-data-column {{ vm.getKPI(plant.id,'ptmColor', true)}}\">{{ vm.getKPI(plant.id,'ptm', true)}}% {{ vm.getKPI(plant.id,'legacy', true)}}</td> </tr> <tr> <td class=kpi-row-label>Furnace Utilization</td> <td ng-repeat=\"plant in vm.plantList | orderBy : 'id'\" class=\"kpi-data-column {{ vm.getKPI(plant.id,'utilizationColor', true)}}\">{{ vm.getKPI(plant.id,'utilization', true)}}% {{ vm.getKPI(plant.id,'legacy', true)}}</td> </tr> </tbody> </table> </div> </div> <div class=kpi-data-section> <div class=data-header> MONTH-TO-DATE </div> <div class=data> <table> <thead> <tr> <th></th> <th ng-repeat=\"plant in vm.plantList | orderBy : 'id'\">{{plant.name}}</th> </tr> </thead> <tbody> <tr> <td class=kpi-row-label>Safety</td> <td ng-repeat=\"plant in vm.plantList | orderBy : 'id'\" class=\"kpi-data-column {{ vm.getKPI(plant.id,'safetyColor', false)}}\">{{ vm.getKPI(plant.id,'safety', false)}}</td> </tr> <tr> <td class=kpi-row-label>Quality</td> <td ng-repeat=\"plant in vm.plantList | orderBy : 'id'\" class=\"kpi-data-column {{ vm.getKPI(plant.id,'qualityColor', false)}}\">{{ vm.getKPI(plant.id,'quality', false)}}</td> </tr> <tr> <td class=kpi-row-label>Tons Packed</td> <td ng-repeat=\"plant in vm.plantList | orderBy : 'id'\" class=\"kpi-data-column {{ vm.getKPI(plant.id,'tonsColor', false)}}\">{{ vm.getKPI(plant.id,'tons', false)}} {{ vm.getKPI(plant.id,'legacy', true)}}</td> </tr> <tr> <td class=kpi-row-label>AOP Tons Packed</td> <td ng-repeat=\"plant in vm.plantList | orderBy : 'id'\" class=\"kpi-data-column lightgray\">{{ vm.getKPI(plant.id,'aop', false)}}</td> </tr> <tr> <td class=kpi-row-label>Pack-to-Melt</td> <td ng-repeat=\"plant in vm.plantList | orderBy : 'id'\" class=\"kpi-data-column {{ vm.getKPI(plant.id,'ptmColor', false)}}\">{{ vm.getKPI(plant.id,'ptm', false)}}% {{ vm.getKPI(plant.id,'legacy', true)}}</td> </tr> <tr> <td class=kpi-row-label>Furnace Utilization</td> <td ng-repeat=\"plant in vm.plantList | orderBy : 'id'\" class=\"kpi-data-column {{ vm.getKPI(plant.id,'utilizationColor', false)}}\">{{ vm.getKPI(plant.id,'utilization', false)}}% {{ vm.getKPI(plant.id,'legacy', true)}}</td> </tr> </tbody> </table> </div> </div> <div class=kpi-legend> <div class=\"legend-section kpi-data-section\"> <div class=legend-header> Safety </div> <div> Recordable Accidents </div> <div> <table class=legend-table> <tr> <td class=\"kpi-data-column green halfWidth\">0</td> <td class=\"kpi-data-column red halfWidth\">&gt; 0</td> </tr> </table> </div> </div> <div class=\"legend-section kpi-data-section\"> <div class=legend-header> Quality </div> <div> \"A\" and \"B\" Complaints Only </div> <div> <table class=legend-table> <tr> <td class=\"kpi-data-column green halfWidth\">0</td> <td class=\"kpi-data-column red halfWidth\">&gt; 0</td> </tr> </table> </div> </div> <div class=\"legend-section kpi-data-section\"> <div class=legend-header> Tons Packed </div> <div> AOP Tons Packed / # of Days in Month </div> <div> <table class=legend-table> <tr> <td class=\"kpi-data-column green thirdWidth\">&gt; AOP</td> <td class=\"kpi-data-column yellow thirdWidth\">= AOP</td> <td class=\"kpi-data-column red thirdWidth\">&lt; AOP</td> </tr> </table> </div> </div> <div class=\"legend-section kpi-data-section\"> <div class=legend-header> Pack-to-Melt </div> <div> % is Actual PTM </div> <div> Color based on the AOP PTM % </div> <div> <table class=legend-table> <tr> <td class=\"kpi-data-column green thirdWidth\">&gt; AOP</td> <td class=\"kpi-data-column yellow thirdWidth\">0.1% - 1.0%</td> <td class=\"kpi-data-column red thirdWidth\">&gt; 1.0%</td> </tr> </table> </div> </div> <div class=\"legend-section kpi-data-section\"> <div class=legend-header> Furnace Capacity </div> <div> % is Actual vs Max Permitted </div> <div> Environmental Tonnage Limit </div> <div> <table class=legend-table> <tr> <td class=\"kpi-data-column green thirdWidth\">&gt; 95.0%</td> <td class=\"kpi-data-column yellow\" style=width:40%!important>95.0% - 80.0%</td> <td class=\"kpi-data-column red thirdWidth\">&lt; 80.0%</td> </tr> </table> </div> </div> <div class=\"legend-section kpi-data-section\"> <div class=legend-header> AOP Tons Packed </div> <div> AOP Tons Packed / # Days MTH * MTD Days </div> <div> <table class=legend-table> <tr> <td class=\"kpi-data-column green thirdWidth\">&gt; AOP</td> <td class=\"kpi-data-column yellow thirdWidth\">= AOP</td> <td class=\"kpi-data-column red thirdWidth\">&lt; AOP</td> </tr> </table> </div> </div> </div> </div> </div> </form> </div> ");

/***/ }),
/* 902 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(3), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, constant_module_1, http_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var KpiServiceImpl = (function () {
        KpiServiceImpl.$inject = ["httpService"];
        function KpiServiceImpl(httpService) {
            this.httpService = httpService;
        }
        KpiServiceImpl.prototype.getDailyProductionKPIs = function (selectedDate) {
            return this.httpService.get(constant_module_1.Endpoints.PRODUCTION_KPIS_DAILY, {
                selectedDate: selectedDate
            });
        };
        KpiServiceImpl.prototype.getMonthlyProductionKPIs = function (selectedDate) {
            return this.httpService.get(constant_module_1.Endpoints.PRODUCTION_KPIS_MONTHLY, {
                selectedDate: selectedDate
            });
        };
        KpiServiceImpl.prototype.getLastUpdatedDates = function () {
            return this.httpService.get(constant_module_1.Endpoints.PRODUCTION_KPIS_LAST_UPDATED_DATES, {});
        };
        return KpiServiceImpl;
    }());
    exports.default = angular
        .module('aps.services.kpiService', [http_service_1.default])
        .service('kpiService', KpiServiceImpl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(3), __webpack_require__(905), __webpack_require__(4), __webpack_require__(16), __webpack_require__(906), __webpack_require__(7), __webpack_require__(8), __webpack_require__(33), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, constant_module_1, measure_tpl_html_1, loader_service_1, report_service_1, measure_service_1, authData_service_1, navigation_service_1, equipment_service_1, aps_enums_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, measure_service_1.default, report_service_1.default, authData_service_1.default, navigation_service_1.default, equipment_service_1.default];
    var MeasureCtrl = (function () {
        MeasureCtrl.$inject = ["$state", "$stateParams", "navigationService", "reportService", "measureService", "loaderService", "authDataService", "notifyService", "equipmentService", "$q"];
        function MeasureCtrl($state, $stateParams, navigationService, reportService, measureService, loaderService, authDataService, notifyService, equipmentService, $q) {
            var _this = this;
            this.updateItems = function () {
                _this.measureService.getPlantItems(_this.selectedPlant.id)
                    .then(function (Items) {
                    _this.availableItems = Items;
                });
            };
            this.updatePlant = function () {
                _this.noRecords = false;
                _this.equipmentService.get(_this.selectedPlant.id).then(function (data) {
                    _this.isWXGEquipemntConfigured = data.filter(function (x) { return x.isDeleted === false && (x.type == aps_enums_1.apsEnums.EquipmentType.WFG || x.type == aps_enums_1.apsEnums.EquipmentType.WSG); }).length > 0;
                    if (!_this.isWXGEquipemntConfigured) {
                        _this.occurenceType = 'Minilab';
                        _this.isMinilab = true;
                    }
                    else {
                        _this.occurenceType = 'Minilab';
                        _this.isMinilab = true;
                    }
                });
                _this.availableShops = _this.selectedPlant.shops;
                if (_this.selectedShops.length > 0) {
                    _this.selectedShops = [];
                }
                _this.updateItems();
            };
            this.addShop = function () {
                _this.noRecords = false;
                if (_this.selectedShop === null || _this.selectedShop === undefined) {
                    _this.selectedShops = [];
                    _this.selectedPlant.shops.forEach(function (element) {
                        _this.selectedShops.push(element);
                    });
                    _this.availableShops = [];
                }
                else {
                    var existing = _this.selectedShops.filter(function (x) { return x.id == _this.selectedShop.id; });
                    if (existing.length === 0) {
                        _this.selectedShops.push(_this.selectedShop);
                        _.remove(_this.availableShops, _this.selectedShop);
                    }
                }
            };
            this.removeShop = function (shop) {
                _.remove(_this.selectedShops, shop);
                _this.availableShops.push(shop);
            };
            var vm = this;
            this.occurenceType = 'Minilab';
            this.isMinilab = true;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.loaderService = loaderService;
            this.reportService = reportService;
            this.measureService = measureService;
            this.equipmentService = equipmentService;
            this.authDataService = authDataService;
            this.notifyService = notifyService;
            this.$q = $q;
            this.isWXGEquipemntConfigured = false;
            var now = moment().add(1, 'hours').startOf('hour');
            this.reportEndDate = now.toDate();
            this.noRecords = false;
            this.reportStartDate = now.clone().subtract(1, 'days').toDate();
            this.futureDate = now.clone().add(1, 'days').toDate();
            var promise = navigationService.getNavigation().then(function (navModel) {
                _this.plants = navModel.plants().filter(function (x) { return !x.isDisabled; });
                _this.selectedPlant = navModel.selectedPlant;
                _this.selectedShops = [];
                _this.updatePlant();
                return _this.loadState($stateParams).then(function () {
                    vm.availableShops = _.clone(vm.selectedPlant.shops);
                });
            });
            loaderService.loadingPromise(promise);
        }
        MeasureCtrl.prototype.loadState = function (params) {
            if (params.reportPlantId && params.reportShopId && params.reportShopId !== params.shopId) {
                var plant = _.find(this.plants, { id: params.reportPlantId });
                if (plant) {
                    var shop = _.find(plant.shops, { id: params.reportShopId });
                    if (shop) {
                        this.selectedPlant = plant;
                    }
                }
            }
            if (params.startDate) {
                var startDate = moment(params.startDate);
                if (startDate.isValid()) {
                    this.startDate = startDate.toDate();
                }
            }
            return this.$q.when();
        };
        MeasureCtrl.prototype.radioChange = function (type) {
            if (type === 'Minilab') {
                this.isMinilab = true;
                this.isWFG = false;
                this.isWSG = false;
            }
            else if (type === 'Wsg') {
                this.isWSG = true;
                this.isMinilab = false;
                this.isWFG = false;
            }
            else {
                this.isMinilab = false;
                this.isWFG = true;
                this.isWSG = false;
            }
        };
        MeasureCtrl.prototype.saveState = function () {
            var reportPlantId = this.selectedPlant ? this.selectedPlant.id : undefined;
            if (reportPlantId === this.$stateParams.plantId) {
                reportPlantId = undefined;
            }
            var reportShopId = this.selectedShop ? this.selectedShop.id : undefined;
            if (reportShopId === this.$stateParams.shopId) {
                reportShopId = undefined;
            }
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportPlantId: reportPlantId,
                reportShopId: reportShopId,
                startDate: this.startDate ? this.startDate : undefined,
                endDate: this.endDate ? this.endDate : undefined
            };
            this.$state.transitionTo(this.$state.current.name, params);
        };
        MeasureCtrl.prototype.generateCSV = function (regenerate) {
            if (this.form.$invalid) {
                return;
            }
            var diff = moment(this.endDate).diff(this.startDate, 'days');
            if (diff > 91) {
                this.notifyService.error('Date range cannot exceed 3 months');
                return;
            }
            if (this.startDate >= this.futureDate) {
                this.notifyService.error("Please select a valid Start Date");
                return;
            }
            if (this.endDate < this.startDate) {
                this.notifyService.error('End Date should be greater than Start Date');
                return;
            }
            if (!this.selectedItem && this.isMinilab) {
                this.notifyService.error('Please Enter a value for Item');
                return;
            }
            this.saveState();
            this.loaderService.loadingPromise(this.runCSV());
        };
        MeasureCtrl.prototype.runCSV = function () {
            var _this = this;
            var items = [];
            this.selectedShops.forEach(function (element) {
                items.push(element.id);
            });
            var csvPromise;
            if (this.isMinilab) {
                csvPromise = this.measureService.exportToCSV(this.selectedPlant.id, this.startDate, this.endDate, items, this.selectedItem);
            }
            else {
                if (this.isWFG) {
                    csvPromise = this.measureService.wxgexportToCSV(this.selectedPlant.id, this.startDate, this.endDate, 1);
                }
                else {
                    csvPromise = this.measureService.wxgexportToCSV(this.selectedPlant.id, this.startDate, this.endDate, 0);
                }
            }
            csvPromise.then(function (result) {
                _this.noRecords = false;
                if (result.indexOf("No Records") != -1) {
                    _this.noRecords = true;
                    return;
                }
                var start = moment(_this.startDate).format("dddd, MM/DD/YYYY");
                var end = moment(_this.endDate).format("dddd, MM/DD/YYYY");
                var a = document.createElement("a");
                a.href = 'data:attachment/csv;charset=utf-8,' + result;
                a.target = '_blank';
                if (_this.isMinilab) {
                    a.download = _this.selectedPlant.name + '-MiniLab' + '-Item_' + _this.selectedItem + '-' + start + '-' + end + '.csv';
                }
                else {
                    if (_this.isWFG) {
                        a.download = _this.selectedPlant.name + '-WFG' + '-' + start + '-' + end + '.csv';
                    }
                    else {
                        a.download = _this.selectedPlant.name + '-WSG' + '-' + start + '-' + end + '.csv';
                    }
                }
                document.body.appendChild(a);
                a.click();
            });
            return csvPromise;
        };
        return MeasureCtrl;
    }());
    exports.default = angular.module('aps.controller.measure', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.MEASURE,
            url: '/measure',
            controller: 'MeasureCtrl as vm',
            template: measure_tpl_html_1.default,
            data: {
                pageTitle: 'Measure Data Import', v2Uri: 'aps/dashboard/plant/measurement'
            }
        });
    }])
        .controller('MeasureCtrl', MeasureCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<style>.sectionData{border-bottom:solid 1px #dbd9d9}</style> <div class=main-table-w> <form name=vm.form ng-submit=vm.generateCSV() novalidate> <div class=\"body-header bs-mb-4\"> <h2>Measurement Data</h2> </div> <!-- <div class=\"row\" style=\"margin:0 -30px;width:auto;\">\r\n      <div class=\"small-4 columns\">\r\n        <label>\r\n          <input type=\"radio\" name=\"occurrence\" ng-model=\"vm.isSingleDayReport\" ng-change=\"vm.radioChange('multi')\"\r\n            ng-value=\"false\" />\r\n          Multi Day Report(CSV Only)\r\n        </label>\r\n      </div>\r\n      <div class=\"small-4 columns\">\r\n      </div>\r\n    </div> --> <div class=row style=\"margin:0 -30px;width:auto;display:flex\"> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>Plant <select ng-model=vm.selectedPlant ng-options=\"plant as plant.name for plant in vm.plants\" ng-change=vm.updatePlant() name=selectedPlant required> <option value=\"\">-- Select a Plant --</option> </select> <div ng-messages=vm.form.selectedPlant.$error ng-if=\"vm.form.selectedPlant.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>Start Date <input type=datetime-local date-time-picker ng-model=vm.reportStartDate name=reportStartDate time-model=vm.startDate time-zone=vm.selectedPlant.timeZoneId required/> <div ng-messages=vm.form.reportStartDate.$error ng-if=\"vm.form.reportStartDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>End Date <input type=datetime-local date-time-picker ng-model=vm.reportEndDate name=reportEndDate time-model=vm.endDate time-zone=vm.selectedPlant.timeZoneId required/> <div ng-messages=vm.form.reportEndDate.$error ng-if=\"vm.form.reportEndDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> <div class=\"small-3 columns\" ng-if=vm.isMinilab> <label> <span class=\"required notated\">*</span>Item </label> <input name=item type=text ng-model=vm.selectedItem ng-select=vm.updateItem() typeahead-on-select=vm.updateItem() typeahead=\"item for item in vm.availableItems | filter:$viewValue | limitTo:8\" autofill=off autocomplete=off placeholder=\"Enter an Item\"/> <div ng-messages=vm.form.selectedItem.$error ng-if=\"vm.form.seletedItem.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div> Required </div> </div> </div> </div> <div class=row style=\"margin:15px -30px;width:auto\"> <div class=\"large-8 columns\" style=display:flex> <label class=bs-mr-4> <input type=radio name=occurrence ng-model=vm.occurenceType ng-change=\"vm.radioChange('Minilab')\" ng-value=\"'Minilab'\"/> MiniLab Data </label> <label class=bs-mr-4> <input type=radio name=occurrence ng-model=vm.occurenceType ng-change=\"vm.radioChange('Wsg')\" ng-value=\"'Wsg'\" ng-disabled=!vm.isWXGEquipemntConfigured data-toggle=tooltip title=\"{{ vm.isWXGEquipemntConfigured ? '' : 'Equipement is not configured.'}}\"/> Wsg Data </label> <label> <input type=radio name=occurrence ng-model=vm.occurenceType ng-change=\"vm.radioChange('Wfg')\" ng-value=\"'Wfg'\" ng-disabled=!vm.isWXGEquipemntConfigured data-toggle=tooltip title=\"{{ vm.isWXGEquipemntConfigured ? '' : 'Equipement is not configured.'}}\"/> Wfg Data </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\" ng-if=vm.isMinilab> <div class=\"small-2 columns\"> <label> Shop <select name=selectedShop ng-model=vm.selectedShop ng-options=\"shop as shop.name for shop in vm.availableShops | orderBy: 'name'\"> <option value=\"\">--All Shops--</option> </select> </label> </div> <div class=\"small-1 columns\"> <button type=button style=position:relative;top:22px;font-size:.6em ng-click=vm.addShop() class=\"button tiny\">Add Shops</button> </div> <div class=\"small-9 columns\"> <ul class=\"row area-manage\" style=\"margin:0 0;width:auto;list-style:none\"> <li ng-if=\"vm.selectedShops.length > 0\" class=area-block> <strong>Selected Shops:</strong> <ul> <li ng-repeat=\"shop in vm.selectedShops\" style=font-size:1em;display:inline> {{shop.name}} <a ng-click=vm.removeShop(shop) style=font-size:.65em><i class=\"fa fa-times\" style=color:red></i>Remove</a> </li> <ul> </ul></ul></li> </ul> </div> </div> <div class=row style=\"margin:10px -30px;width:auto\"> <div class=\"small-5 columns\"> <button type=submit class=button>{{vm.isMinilab ? 'Export MiniLab CSV' : vm.isWSG ? 'Export Wsg CSV' :'Export Wfg CSV'}}</button> </div> </div> <div class=row style=\"margin:0 -25px;width:auto\"> <div class=\"small-12 large-6 columns\"> <div class=header ng-if=vm.noRecords> <div><b>No records found matching filter criteria</b> </div> </div> </div> </div> </form> </div>");

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(3), __webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, constant_module_1, http_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [http_service_1.default];
    var measureServiceImpl = (function () {
        measureServiceImpl.$inject = ["httpService"];
        function measureServiceImpl(httpService) {
            this.httpService = httpService;
        }
        measureServiceImpl.prototype.getPlantItems = function (plantId) {
            return this.httpService.get(constant_module_1.Endpoints.MEASURE_PLANT_ITEMS, { plantId: plantId });
        };
        measureServiceImpl.prototype.exportToCSV = function (plantId, startDate, endDate, shops, item) {
            var req = {
                plantId: plantId,
                startDate: startDate.toLocaleString(),
                endDate: endDate.toLocaleString(),
                shopIds: shops,
                item: item
            };
            return this.httpService.post(constant_module_1.Endpoints.MEASURE_MINILAB, req);
        };
        measureServiceImpl.prototype.wxgexportToCSV = function (plantId, startDate, endDate, type) {
            var req = {
                plantId: plantId,
                startDate: startDate.toLocaleString(),
                endDate: endDate.toLocaleString(),
            };
            return this.httpService.post(constant_module_1.Endpoints.MEASURE_WXG + '?type=' + type, req);
        };
        return measureServiceImpl;
    }());
    exports.default = angular
        .module('aps.services.measureService', [http_service_1.default])
        .service('measureService', measureServiceImpl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(3), __webpack_require__(908), __webpack_require__(4), __webpack_require__(909), __webpack_require__(8), __webpack_require__(5), __webpack_require__(61), __webpack_require__(76)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, constant_module_1, scorecardChecklist_tpl_html_1, loader_service_1, scorecard_service_1, navigation_service_1, aps_enums_1, checkListReportDetails_controller_1, Chart) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, scorecard_service_1.default, navigation_service_1.default];
    var ScorecardCtrl = (function () {
        ScorecardCtrl.$inject = ["checkListsService", "$state", "$stateParams", "navigationService", "scorecardService", "loaderService", "notifyService", "$modal", "$q", "$timeout"];
        function ScorecardCtrl(checkListsService, $state, $stateParams, navigationService, scorecardService, loaderService, notifyService, $modal, $q, $timeout) {
            var _this = this;
            this.barChartsData = [];
            this.scoreCardSummeryEnum = {
                totalChecks: "Total Checks",
                passedChecks: "Passed Checks",
                failedChecks: "Failed Checks",
                incompleteChecks: "Incomplete Checks",
            };
            var vm = this;
            this.checkListsService = checkListsService;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.loaderService = loaderService;
            this.scorecardService = scorecardService;
            this.notifyService = notifyService;
            this.$modal = $modal;
            this.$q = $q;
            this.$timeout = $timeout;
            var now = moment().startOf('hour');
            this.reportStartDate = now.clone().toDate();
            this.futureDate = now.clone().add(1, 'days').toDate();
            this.reportData = null;
            var promise = navigationService.getNavigation().then(function (navModel) {
                _this.plants = navModel.plants();
                _this.selectedPlant = navModel.selectedPlant;
                _this.checkfilter = aps_enums_1.apsEnums.CheckListReportFilter.AllCheckLists;
                return _this.loadState($stateParams);
            });
            loaderService.loadingPromise(promise);
            this.chartOptions = {
                chart: {
                    type: "pieChart",
                    x: function (d) { return d.label; },
                    y: function (d) { return d.value; },
                    height: 450,
                    width: 450,
                    showLabels: true,
                    responsive: true,
                    duration: 500,
                    labelThreshold: 0.03,
                    labelSunbeamLayout: false,
                    labelsOutside: false,
                    donut: true,
                    donutRatio: 0.35,
                    transitionDuration: 500,
                    showLegend: false,
                    showControls: false,
                    legend: {
                        margin: {
                            top: 5,
                            right: 30,
                            bottom: 5,
                            left: 0,
                        },
                    },
                    pie: {
                        dispatch: {
                            elementClick: function (e) {
                                if (e.data.shopFailedSummaries) {
                                    vm.generateBarChart(e);
                                }
                                else {
                                    return;
                                }
                            }
                        }
                    }
                }
            };
        }
        ScorecardCtrl.prototype.generateBarChart = function (e) {
            var _this = this;
            this.barChartsData = [{
                    title: e.data.label.length > 65 ? e.data.label.slice(0, 65) + '...' : e.data.label,
                    labels: e.data.shopFailedSummaries.map(function (x) { return 'Shop ' + x.shopName; }),
                    values: e.data.shopFailedSummaries.map(function (x) { return Math.round(x.count); })
                }];
            if (this.failedSummaryBarChart !== undefined && this.failedSummaryBarChart.ctx !== null) {
                this.failedSummaryBarChart.data.datasets[0].data = [];
                this.failedSummaryBarChart.data.labels = this.barChartsData[0].labels;
                this.failedSummaryBarChart.data.datasets[0].label = this.barChartsData[0].title;
                this.failedSummaryBarChart.data.datasets[0].data = this.barChartsData[0].values;
                this.failedSummaryBarChart.update();
                return;
            }
            this.$timeout(function () {
                var ctx = document.getElementById('failedSummaryBarChart');
                if (!ctx)
                    return;
                _this.failedSummaryBarChart = new Chart(ctx.getContext('2d'), {
                    type: 'bar',
                    data: {
                        labels: _this.barChartsData[0].labels,
                        datasets: [{
                                label: _this.barChartsData[0].title,
                                data: _this.barChartsData[0].values,
                                backgroundColor: [
                                    'rgba(255, 99, 132, 0.2)',
                                    'rgba(54, 162, 235, 0.2)',
                                    'rgba(255, 206, 86, 0.2)',
                                    'rgba(75, 192, 192, 0.2)',
                                    'rgba(153, 102, 255, 0.2)',
                                    'rgba(255, 159, 64, 0.2)'
                                ],
                                borderColor: [
                                    'rgba(255, 99, 132, 1)',
                                    'rgba(54, 162, 235, 1)',
                                    'rgba(255, 206, 86, 1)',
                                    'rgba(75, 192, 192, 1)',
                                    'rgba(153, 102, 255, 1)',
                                    'rgba(255, 159, 64, 1)'
                                ],
                                borderWidth: 1,
                            }]
                    },
                    options: {
                        responsive: true,
                        scales: {
                            xAxes: [{
                                    gridLines: { display: false },
                                }],
                            yAxes: [{
                                    type: 'linear',
                                    gridLines: { display: false },
                                    ticks: {
                                        min: 0,
                                    }
                                }]
                        }
                    }
                });
            }, 0);
        };
        ScorecardCtrl.prototype.loadState = function (params) {
            if (params.reportPlantId) {
                var plant = _.find(this.plants, { id: params.reportPlantId });
                this.selectedPlant = plant;
            }
            if (params.reportStartDate) {
                var reportStartDate = moment(params.reportStartDate);
                if (reportStartDate.isValid()) {
                    this.reportStartDate = reportStartDate.toDate();
                }
            }
            this.generateReport();
            return this.$q.when();
        };
        ScorecardCtrl.prototype.saveState = function () {
            var reportPlantId = this.selectedPlant ? this.selectedPlant.id : undefined;
            if (reportPlantId === this.$stateParams.plantId) {
                reportPlantId = undefined;
            }
            var params = {
                plantId: this.$stateParams.plantId,
                shopId: this.$stateParams.shopId,
                userId: this.$stateParams.userId,
                reportPlantId: reportPlantId,
                reportStartDate: this.reportStartDate ? this.reportStartDate : undefined,
            };
            this.$state.transitionTo(this.$state.current.name, params);
        };
        ScorecardCtrl.prototype.generateReport = function () {
            if (this.form.$invalid) {
                return;
            }
            if (this.reportStartDate >= this.futureDate) {
                this.notifyService.error("Report Date shouldn't be in the future");
                return;
            }
            this.saveState();
            this.curatedShops = this.selectedPlant.shops;
            if (this.selectedPlant.name.indexOf("Jack") === 0) {
                this.curatedShops = this.selectedPlant.shops.slice(0, 2);
            }
            else if (this.selectedPlant.name.indexOf("War") === 0) {
                this.curatedShops = this.selectedPlant.shops.slice(0, 3);
            }
            this.loaderService.loadingPromise(this.runReport());
        };
        ScorecardCtrl.prototype.runReport = function () {
            var _this = this;
            var promise = this.scorecardService.getScorecardChecklists(this.selectedPlant.id, this.reportStartDate);
            promise.then(function (result) {
                _this.reportData = result;
                _this.processPieChart(result);
            });
            return promise;
        };
        ScorecardCtrl.prototype.processPieChart = function (result) {
            var _this = this;
            if (this.failedSummaryBarChart !== undefined) {
                this.failedSummaryBarChart.destroy();
            }
            this.scorecardWeeklySummary = [];
            this.scorecardFailedSummaries = [];
            if (!_.isEmpty(result.scorecardWeeklySummary)) {
                this.scorecardWeeklySummary = Object.keys(result.scorecardWeeklySummary)
                    .filter(function (item) { return item !== "totalChecks"; })
                    .map(function (key) {
                    return {
                        label: _this.scoreCardSummeryEnum[key],
                        value: result.scorecardWeeklySummary[key]
                    };
                });
            }
            if (!_.isEmpty(result.scorecardFailedSummaries)) {
                this.scorecardFailedSummaries = result.scorecardFailedSummaries.map(function (i) {
                    return {
                        label: i["failedCheckName"],
                        value: i["count"],
                        shopFailedSummaries: i["shopFailedSummaries"]
                    };
                }).sort(function (a, b) { return b.value - a.value; })
                    .slice(0, 10);
            }
            this.pieCharts = [
                {
                    id: "Weekly Summary",
                    data: this.scorecardWeeklySummary,
                    labelType: function (d) {
                        return d.data.label + " - " + Math.round(d.data.value / result.scorecardWeeklySummary["totalChecks"] * 100) + "%";
                    },
                },
                {
                    id: "Failed Summary",
                    data: this.scorecardFailedSummaries,
                    labelType: "percent",
                },
            ];
        };
        ScorecardCtrl.prototype.getChartOptions = function (chartId) {
            var pieChart = this.pieCharts.find(function (chart) { return chart.id === chartId; });
            this.chartOptions.chart.labelType = pieChart.labelType;
            this.chartOptions.chart.title = pieChart.id;
            return this.chartOptions;
        };
        ScorecardCtrl.prototype.exportToExcel = function () {
            this.loaderService.loadingPromise(this.scorecardService.exportToExcelV2(this.selectedPlant.name, this.reportStartDate, this.reportData.excel));
        };
        ScorecardCtrl.prototype.openModal = function (chekInstanceData) {
            var _this = this;
            var promise = this.checkListsService.getCheckListReportDetail(chekInstanceData.id, chekInstanceData.plantLocationId, chekInstanceData.scheduledOn, this.checkfilter);
            this.loaderService.loadingPromise(promise);
            promise.then(function (data) {
                checkListReportDetails_controller_1.openCheckListReportDetails({
                    checkListInstance: chekInstanceData,
                    detail: data
                }, _this.$modal);
            });
        };
        ScorecardCtrl.prototype.updatePlant = function () {
            this.reportData = null;
        };
        ScorecardCtrl.prototype.getFormattedDate = function (currentDate) {
            var utc = new Date(currentDate.getUTCFullYear(), currentDate.getUTCMonth(), currentDate.getUTCDate(), currentDate.getUTCHours(), currentDate.getUTCMinutes(), currentDate.getUTCSeconds());
            return moment(utc).format("dddd, MM/DD/YYYY");
        };
        ScorecardCtrl.prototype.isroleunique = function (role) {
            return (role === "Production Superintendent" || role === "Plant Manager");
        };
        ScorecardCtrl.prototype.getShopcount = function () {
            return this.curatedShops.length;
        };
        ScorecardCtrl.prototype.getOuterColor = function (shop, role, processDate) {
            var now = moment().startOf('hour').toDate();
            if (processDate > now && role.indexOf("Plant Manager") === -1) {
                return '';
            }
            else if (role.indexOf("Plant Manager") !== -1) {
                var allchecklists = [];
                this.reportData.scorecardCheckListItems.forEach(function (x) {
                    x.scorecardDetailItems.forEach(function (y) {
                        allchecklists.push(y);
                    });
                });
                var filteredbyRole = allchecklists.filter(function (x) { return x.roleName === role && x.status === aps_enums_1.apsEnums.CheckListStatus.Complete; });
                if (filteredbyRole.length > 0) {
                    return 'green';
                }
                else {
                    return 'red';
                }
            }
            else if (role.indexOf("Superintendent") !== -1) {
                var filtered = _.find(this.reportData.scorecardCheckListItems, function (x) { return x.processDate === processDate; });
                var filteredbyRoleandStatus = filtered.scorecardDetailItems.filter(function (x) {
                    return x.roleName === role && x.status === aps_enums_1.apsEnums.CheckListStatus.Complete;
                });
                var filteredbyRole = filtered.scorecardDetailItems.filter(function (x) { return x.roleName === role; });
                if (filteredbyRole.length > 0 && filteredbyRoleandStatus.length > 0) {
                    return 'green';
                }
                else {
                    return 'red';
                }
            }
            else {
                var filtered = _.find(this.reportData.scorecardCheckListItems, function (x) { return x.processDate === processDate; });
                var filteredbyRoleandStatus = filtered.scorecardDetailItems.filter(function (x) {
                    return x.roleName === role && x.shopName === shop.name && x.status === aps_enums_1.apsEnums.CheckListStatus.Complete;
                });
                var filteredbyRole = filtered.scorecardDetailItems.filter(function (x) { return x.roleName === role && x.shopName === shop.name; });
                if (filteredbyRole.length > 0 && filteredbyRole.length === filteredbyRoleandStatus.length) {
                    return 'green';
                }
                else if (filteredbyRoleandStatus.length > 0) {
                    return 'yellow';
                }
                else {
                    return 'red';
                }
            }
        };
        ScorecardCtrl.prototype.scorecardExists = function () {
            var allchecklists = [];
            if (this.reportData) {
                this.reportData.scorecardCheckListItems.forEach(function (x) { return x.scorecardDetailItems.forEach(function (y) { return allchecklists.push(y); }); });
                return allchecklists.length > 0;
            }
            return false;
        };
        ScorecardCtrl.prototype.getDescription = function (shop, role, processDate) {
            var now = moment().startOf('hour').toDate();
            if (processDate > now) {
                var allchecklists = [];
                return allchecklists;
            }
            if (role.indexOf("Plant Manager") !== -1) {
                var allchecklists = [];
                var allchecklists1 = [];
                this.reportData.scorecardCheckListItems.forEach(function (x) {
                    x.scorecardDetailItems.forEach(function (y) { return allchecklists1.push(y); });
                });
                var filteredbyRole = allchecklists1.filter(function (x) { return x.roleName === role && x.status === aps_enums_1.apsEnums.CheckListStatus.Complete; });
                var filterByWeek = allchecklists1.filter(function (x) { return x.roleName === role; });
                if (filteredbyRole.length > 0) {
                    allchecklists.push(filteredbyRole[0]);
                    return allchecklists;
                }
                else {
                    allchecklists.push(filterByWeek[0]);
                    return allchecklists;
                }
            }
            else if (role.indexOf("Superintendent") !== -1) {
                var allchecklists = [];
                var filtered = _.find(this.reportData.scorecardCheckListItems, function (x) { return x.processDate === processDate; });
                var filteredbyRole = filtered.scorecardDetailItems.filter(function (x) { return x.roleName === role; });
                var filteredbyRoleAndStatus = filtered.scorecardDetailItems.filter(function (x) {
                    return x.roleName === role && x.status === aps_enums_1.apsEnums.CheckListStatus.Complete;
                });
                if (filteredbyRoleAndStatus.length > 0) {
                    allchecklists.push(filteredbyRoleAndStatus[0]);
                    return allchecklists;
                }
                else {
                    allchecklists.push(filteredbyRole[0]);
                    return allchecklists;
                }
            }
            else {
                var filtered = _.find(this.reportData.scorecardCheckListItems, function (x) { return x.processDate === processDate; });
                var filteredbyRole = filtered.scorecardDetailItems.filter(function (x) { return x.roleName === role && x.shopName === shop.name; });
                return filteredbyRole;
            }
        };
        return ScorecardCtrl;
    }());
    exports.default = angular.module('aps.controller.scorecard', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.SCORECARD,
            url: '/scorecard',
            controller: 'ScorecardCtrl as vm',
            template: scorecardChecklist_tpl_html_1.default,
            data: {
                pageTitle: 'Scorecard Checklist',
                v2Uri: 'aps/reports/lpa-score-card'
            }
        });
    }])
        .controller('ScorecardCtrl', ScorecardCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<style>.sectionData{border-bottom:solid 1px #dbd9d9}</style> <div class=main-table-w> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div class=body-header> <h2>LPA Scorecard</h2> </div> <br> <br> <br> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>Plant <select ng-model=vm.selectedPlant ng-options=\"plant as plant.name for plant in vm.plants\" ng-change=vm.updatePlant() name=selectedPlant required> <option value=\"\">-- Select a Plant --</option> </select> <div ng-messages=vm.form.selectedPlant.$error ng-if=\"vm.form.selectedPlant.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> <div class=\"small-3 columns\"> <label> <span class=\"required notated\">*</span>Report Date <input type=date ng-model=vm.reportStartDate name=reportStartDate required/> <div ng-messages=vm.form.reportStartDate.$error ng-if=\"vm.form.reportStartDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> <div class=\"small-3 columns\"> </div> </div> <div class=row style=\"margin:0 -30px;max-width:100rem\"> <div class=\"small-3 columns\"> <button type=submit class=button>Show Scorecard</button> </div> <div ng-if=vm.scorecardExists() class=right> <a ng-if=vm.reportData.weeklyFile ng-click=vm.exportToExcel()>Save as Excel</a> </div> </div> <div class=row style=\"margin:0 -25px;width:auto\"> <div class=\"small-12 large-5 columns\"> <div class=header ng-if=!vm.scorecardExists()> <div><b>No Scorecard Checklist found</b> </div> </div> </div> </div> <div style=width:auto> <div ng-if=vm.scorecardExists()> <div class=flex-container-responsive ng-if=vm.reportData.weeklyFile> <div ng-repeat=\"chart in vm.pieCharts\" ng-if=\"chart.data.length > 0\" class=flex-pieChart> <nvd3 options=vm.getChartOptions(chart.id) data=chart.data></nvd3> </div> <div class=flex-pieChart> <canvas id=failedSummaryBarChart width=100 height=90></canvas> </div> </div> <div class=flex-container-responsive> <div class=flex-item-responsive ng-repeat=\"currentdate in vm.reportData.scorecardCheckListItems\"> <div class=scoreReport> <div class=header style=text-align:center> <span><b>{{vm.getFormattedDate(currentdate.processDate)}}</b></span> </div> <div> <!-- Shop Header --> <table class=shopSection id=tblSummary style=min-width:90%> <thead> <tr> <th></th> <th ng-repeat=\"shop in vm.curatedShops\" class=sectionHeader>Shop {{shop.name}}</th> </tr> </thead> <tbody> <tr ng-repeat=\"role in currentdate.roles\"> <th style=font-size:12px;min-width:60px;text-align:left>{{ role}}</th> <td style=\"border:1px solid #000;vertical-align:text-top\" ng-style=\"{'background-color': vm.getOuterColor('', role, currentdate.processDate)}\" ; ng-if=vm.isroleunique(role) colspan=\"{{vm.getShopcount() +1 }}\"> <div style=\"padding:5px 2px;text-align:center;min-width:70px\"> <div ng-repeat=\"description in vm.getDescription(shop, role, currentdate.processDate)\"> <b ng-click=vm.openModal(description.checkInstanceData) style=\"font-size:12px; {{description.color}}\" data-toggle=tooltip data-placement=top data-html=true title=\"{{description.toolTipText}}\"> {{description.displayName}}</b> </div> </div> </td> <td style=\"border:1px solid #000;vertical-align:text-top\" ng-style=\"{'background-color': vm.getOuterColor(shop, role, currentdate.processDate)}\" ; ng-if=!vm.isroleunique(role) ng-repeat=\"shop in vm.curatedShops\"> <div style=\"padding:5px 2px;text-align:center;min-width:70px\"> <div ng-repeat=\"description in vm.getDescription(shop, role, currentdate.processDate)\"> <b ng-click=vm.openModal(description.checkInstanceData) style=\"font-size:12px; {{description.color}}\" data-toggle=tooltip data-placement=top data-html=true title=\"{{description.toolTipText}}\"> {{description.displayName}}</b> </div> </div> </td> </tr> </tbody> </table> </div> </div> </div> </div> </div> </div> </form> </div>");

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(3), __webpack_require__(10), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, constant_module_1, http_service_1, moment) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var scorecardServiceImpl = (function () {
        scorecardServiceImpl.$inject = ["httpService"];
        function scorecardServiceImpl(httpService) {
            this.httpService = httpService;
        }
        scorecardServiceImpl.prototype.getScorecardChecklists = function (plantId, reportDate) {
            return this.httpService.get(constant_module_1.Endpoints.SCORECARD, { plantId: plantId, reportDate: reportDate });
        };
        scorecardServiceImpl.prototype.exportToExcelV2 = function (plantName, productionDate, b64Data) {
            var byteCharacters = atob(b64Data);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            var url = window.URL.createObjectURL(blob);
            var anchor = document.createElement('a');
            var reportDate = moment(productionDate).format("MM/DD/YYYY");
            anchor.download = 'ScoreCardReport_' + plantName + '_' + reportDate + '.xlsx';
            anchor.href = url;
            anchor.click();
        };
        return scorecardServiceImpl;
    }());
    exports.default = angular
        .module('aps.services.scorecardService', [http_service_1.default])
        .service('scorecardService', scorecardServiceImpl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(1), __webpack_require__(911), __webpack_require__(3), __webpack_require__(4), __webpack_require__(6), __webpack_require__(16), __webpack_require__(8), __webpack_require__(7), __webpack_require__(2), __webpack_require__(913)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, moment, editHotEndBonus_controller_1, constant_module_1, loader_service_1, notify_service_1, report_service_1, navigation_service_1, authData_service_1, _, hotEndBonusReport_tpl_html_1) {
    "use strict";
    hotEndBonusConfig.$inject = ["$stateProvider"];
    hotEndBonusController.$inject = ["loaderService", "reportService", "notifyService", "navigationService", "authDataService", "holidaysService", "$modal"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, report_service_1.default, navigation_service_1.default, editHotEndBonus_controller_1.default,
        authData_service_1.default, notify_service_1.default];
    exports.default = angular.module('aps.controller.hotEndBonusReport', requires)
        .config(hotEndBonusConfig)
        .controller('HotEndBonusCtrl', hotEndBonusController)
        .name;
    function hotEndBonusConfig($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.HOT_END_BONUS,
            url: '/admin/hotEndBonusReport',
            controller: 'HotEndBonusCtrl as vm',
            template: hotEndBonusReport_tpl_html_1.default,
            data: {
                pageTitle: 'Hot End Bonus Report'
            }
        });
    }
    var SignOffUsers = (function () {
        function SignOffUsers() {
        }
        return SignOffUsers;
    }());
    function hotEndBonusController(loaderService, reportService, notifyService, navigationService, authDataService, holidaysService, $modal) {
        var vm = {};
        var loadingPromise = navigationService.getNavigation().then(function (nav) {
            vm.plants = nav.plants();
            if (nav.selectedPlant && _.includes(vm.plants, nav.selectedPlant)) {
                vm.selectedPlant = nav.selectedPlant;
            }
            else {
                vm.selectedPlant = _.first(vm.plants);
                vm.selectedShop = nav.selectedShop;
            }
        });
        var holidayPromise = holidaysService.getHolidays(moment().year()).then(function (holidays) {
            vm.holidays = holidays;
        });
        loaderService.loadingPromise(holidayPromise);
        loaderService.loadingPromise(loadingPromise);
        vm.edit = edit;
        vm.reportDate = moment().add(-1, 'days').toDate();
        vm.formattedReportDate = moment(vm.reportDate).format("dddd, MM/DD/YYYY");
        vm.minDate = moment().add(-365, 'days').toDate();
        vm.generateReport = generateReport;
        vm.signOff = signOff;
        vm.getSignOff = getSignOff;
        return vm;
        function checkIfEditable() {
            var today = new Date();
            today.setHours(0, 0, 0, 0);
            var currentDay = today.getDay();
            var currentWeekStart = new Date(today.getTime());
            currentWeekStart.setDate(today.getDate() - currentDay);
            var lastWeekStart = new Date(currentWeekStart.getTime());
            lastWeekStart.setDate(currentWeekStart.getDate() - 7);
            var lastWeekEnd = new Date(currentWeekStart.getTime());
            lastWeekEnd.setDate(currentWeekStart.getDate() - 1);
            var isSunday = currentDay === 0;
            var isMonday = currentDay === 1;
            var isTuesday = currentDay === 2;
            var yesterday = new Date(today.getTime());
            yesterday.setDate(today.getDate() - 1);
            var isMondayHoliday = vm.holidays.some(function (holiday) {
                var h = new Date(holiday.date.getTime());
                h.setHours(0, 0, 0, 0);
                return h.getTime() === yesterday.getTime();
            });
            var reportDate = new Date(vm.reportDate.getTime());
            reportDate.setHours(0, 0, 0, 0);
            var isInCurrentWeek = reportDate >= currentWeekStart && reportDate <= today;
            var isInLastWeek = reportDate >= lastWeekStart && reportDate <= lastWeekEnd;
            var canEditLastWeek = isInLastWeek && (isSunday || isMonday || (isTuesday && isMondayHoliday));
            return isInCurrentWeek || canEditLastWeek;
        }
        function generateReport() {
            vm.iseditable = checkIfEditable();
            vm.formattedReportDate = moment(vm.reportDate).format("dddd, MM/DD/YYYY");
            var promise = runReport();
            loaderService.loadingPromise(promise);
            getSignOff();
            return promise;
        }
        function runReport() {
            var fomratdateonly = new Date(moment(vm.reportDate).format("MM/DD/YYYY"));
            vm.hotEndBonuses = null;
            return reportService.getPlantHotEndBonus(vm.selectedPlant.id, fomratdateonly).then(function (reportItem) {
                vm.hotEndBonuses = reportItem;
            }, notifyService.handleApiErrors);
        }
        function getSignOff() {
            var currentUser = authDataService.getUserData();
            var plantId = vm.selectedPlant.id;
            var productionDate = new Date(moment(vm.reportDate).format("MM/DD/YYYY"));
            return reportService.getHotEndSignOff(plantId, productionDate).then(function (signOffitem) {
                vm.sigOffData = signOffitem;
                vm.userList = vm.sigOffData.signOffUsers != undefined ? JSON.parse(vm.sigOffData.signOffUsers) : null;
                vm.isSignedOff = vm.userList != null ? (vm.userList.filter(function (x) { return x.UserId == currentUser.id; }).length === 0 ? false : true) : false;
            });
        }
        function signOff() {
            var signedDate = new Date().toLocaleDateString('en-US');
            var signedTime = new Date().toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit'
            });
            var signOffDate = (signedDate + " " + signedTime).toString();
            var currentUser = authDataService.getUserData();
            var plantId = this.selectedPlant.id;
            var productionDate = new Date(moment(vm.reportDate).format("MM/DD/YYYY"));
            var user = currentUser.id + "," + currentUser.fullName + "," + signOffDate;
            var newUser = { UserId: currentUser.id, UserName: currentUser.fullName, SignedOffDate: signOffDate };
            if (vm.isSignedOff) {
                vm.userList = (vm.userList === null || vm.userList === undefined || vm.userList.length == 0) ? [] : vm.userList;
                vm.userList.push(newUser);
            }
            else {
                _.remove(vm.userList, function (x) { return x.UserId == currentUser.id; });
            }
            var hotEndCommand = {
                plantId: plantId,
                productionDate: productionDate,
                isSignedOff: vm.isSignedOff,
                signOffUsers: user
            };
            return reportService.updateSignOffUsers(hotEndCommand);
        }
        function edit(instance) {
            var result = editHotEndBonus_controller_1.openEditHotEndBonus({
                plant: vm.selectedPlant,
                hotEndBonusItem: instance,
                productionDate: vm.reportDate
            }, $modal);
            result.then(function (result) {
                if (!result) {
                    return;
                }
                var shopname = _.find(vm.selectedPlant.shops, { id: result.shopId }).name;
                vm.hotEndBonuses.shopDetailItems.filter(function (x) { return x.shopName == shopname; })[0].hotEndBonusItems.splice(vm.hotEndBonuses.shopDetailItems.filter(function (x) { return x.shopName == shopname; })[0].hotEndBonusItems.indexOf(instance), 1, result);
            });
        }
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(4), __webpack_require__(6), __webpack_require__(16), __webpack_require__(912)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, loader_service_1, notify_service_1, report_service_1, editHotEndBonus_tpl_html_1) {
    "use strict";
    editHotEndBonus.$inject = ["reportService", "loaderService", "notifyService", "data", "$modalInstance"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [loader_service_1.default, notify_service_1.default, report_service_1.default];
    function openEditHotEndBonus(data, $modal) {
        return $modal.open({
            template: editHotEndBonus_tpl_html_1.default,
            controller: 'EditHotEndBonusCtrl as vm',
            resolve: {
                data: function () {
                    return data;
                }
            }
        }).result;
    }
    exports.openEditHotEndBonus = openEditHotEndBonus;
    exports.default = angular.module('aps.controller.editHotEndBonus', requires)
        .controller('EditHotEndBonusCtrl', editHotEndBonus)
        .name;
    function editHotEndBonus(reportService, loaderService, notifyService, data, $modalInstance) {
        var vm = {};
        vm.shopShiftText = 'Shop : ' + _.find(data.plant.shops, { id: data.hotEndBonusItem.shopId }).name + ' Shift : ' + data.hotEndBonusItem.shift;
        vm.maxTime = calculateShiftDuration(data.hotEndBonusItem.productionDate, data.hotEndBonusItem.shiftTime);
        vm.save = save;
        vm.cancel = cancel;
        vm.ProdHrsEarned = ProdHrsEarned;
        vm.PerformancePercent = PerformancePercent;
        vm.WeightedAmount = WeightedAmount;
        vm.showHelp = null;
        vm.showHelpWindow = false;
        vm.helpText = null;
        vm.toggleHelpWindow = null;
        if (data.hotEndBonusItem) {
            vm.originalhotEndRecord = data.hotEndBonusItem;
            vm.hotEndBonusCommand = {
                id: data.hotEndBonusItem.id,
                plantId: data.hotEndBonusItem.plantId,
                shopId: data.hotEndBonusItem.shopId,
                jobRunId: data.hotEndBonusItem.jobRunId,
                productionDate: data.hotEndBonusItem.productionDate,
                shift: data.hotEndBonusItem.shift,
                jobChangeAllowance: data.hotEndBonusItem.jobChangeAllowance,
                startupAllowance: data.hotEndBonusItem.startupAllowance,
                production: data.hotEndBonusItem.production,
                totalTime: data.hotEndBonusItem.totalTime,
                bonusPercent: data.hotEndBonusItem.bonusPercent,
                performancePercent: data.hotEndBonusItem.performancePercent,
                productionHrsEarned: data.hotEndBonusItem.productionHrsEarned,
                weightedAmount: data.hotEndBonusItem.weightedAmount,
                hasBeenModified: true
            };
        }
        vm.toggleHelpWindow = function () {
            vm.showHelpWindow = !vm.showHelpWindow;
        };
        vm.showHelp = function () {
            vm.helpText = getHelpText();
            vm.toggleHelpWindow();
        };
        function getHelpText() {
            return " \n    <div class=\"header\">\n     <u>Startup Allowance</u>\n    </div>   \n    <div class=\"row hotendBonusReport\"\n    <div>\n      First Shift Operating Hours after Job Change\n    </div>    \n    <div>     \n    <table cellpadding=\"1\" cellspacing=\"1\" class=\"history-t\">\n  <tr>\n    <th>Allowance</th>\n    <th>1</th>\n    <th>2</th>\n    <th>3</th>\n    <th>4</th>\n    <th>5</th>\n    <th>6</th>\n    <th>7</th>\n    <th>8</th>\n  </tr>\n  <tr>\n    <td>First Shift Allowance</td>\n    <td>0.67</td>\n    <td>1.11</td>\n    <td>1.39</td>\n    <td>1.58</td>\n    <td>1.69</td>\n    <td>1.78</td>\n    <td>1.85</td>\n    <td>1.91</td>\n  </tr>\n  <tr>\n    <td>Second Shift Allowance</td>\n    <td>1.30</td>\n    <td>0.91</td>\n    <td>0.68</td>\n    <td>0.54</td>\n    <td>0.47</td>\n    <td>0.42</td>\n    <td>0.38</td>\n    <td>0.35</td>\n  </tr>\n  <tr>\n    <td>Third Shift Allowance</td>\n    <td>0.32</td>\n    <td>0.30</td>\n    <td>0.28</td>\n    <td>0.26</td>\n    <td>0.24</td>\n    <td>0.22</td>\n    <td>0.21</td>\n    <td>0.20</td>\n  </tr>\n  <tr>\n    <td>Fourth Shift Allowance</td>\n    <td>0.17</td>\n    <td>0.14</td>\n    <td>0.11</td>\n    <td>0.08</td>\n    <td>0.06</td>\n    <td>0.04</td>\n    <td>0.02</td>\n    <td>--</td>\n  </tr>\n</table>\n</div>\n</div>\n      ";
        }
        return vm;
        function ProdHrsEarned() {
            var val = vm.originalhotEndRecord.standardGobsPerHour > 0 ? ((vm.hotEndBonusCommand.production / vm.originalhotEndRecord.standardGobsPerHour) + vm.hotEndBonusCommand.jobChangeAllowance + vm.hotEndBonusCommand.startupAllowance) : 0;
            return roundDecimal(val);
        }
        function PerformancePercent() {
            var val = vm.ProdHrsEarned() / (vm.hotEndBonusCommand.totalTime / (60 * (data.hotEndBonusItem.isDoubleMachine ? 2 : 1))) * 100;
            return val ? val : 0;
        }
        function WeightedAmount() {
            var val = vm.originalhotEndRecord.bonusPercent * (vm.hotEndBonusCommand.totalTime / (60 * (data.hotEndBonusItem.isDoubleMachine ? 2 : 1)));
            return roundDecimal(val);
        }
        function roundDecimal(value) {
            return (value && value >= 0) ? Math.round(value * 100.0) / 100.0 : 0;
        }
        function isDST(date) {
            var january = new Date(date.getFullYear(), 0, 1);
            var july = new Date(date.getFullYear(), 6, 1);
            var standardTimezoneOffset = Math.max(january.getTimezoneOffset(), july.getTimezoneOffset());
            return date.getTimezoneOffset() < standardTimezoneOffset;
        }
        function calculateShiftDuration(shiftStart, shiftEnd) {
            var start = new Date(shiftStart);
            var end = new Date(shiftEnd);
            if (end < start) {
                end.setDate(end.getDate() + 1);
            }
            var startIsDST = isDST(start);
            var endIsDST = isDST(end);
            var shiftDuration = (data.hotEndBonusItem.isDoubleMachine) ? 960 : 480;
            if ((data.hotEndBonusItem.shift === '3' || data.hotEndBonusItem.shift === 'N') && (startIsDST !== endIsDST)) {
                if (startIsDST) {
                    shiftDuration += (60 * (data.hotEndBonusItem.isDoubleMachine ? 2 : 1));
                }
                else {
                    shiftDuration -= (60 * (data.hotEndBonusItem.isDoubleMachine ? 2 : 1));
                }
            }
            return shiftDuration;
        }
        function save() {
            if (vm.form.$invalid) {
                return;
            }
            vm.hotEndBonusCommand.productionHrsEarned = ProdHrsEarned();
            vm.hotEndBonusCommand.performancePercent = roundDecimal(PerformancePercent());
            vm.hotEndBonusCommand.weightedAmount = roundDecimal(WeightedAmount());
            loaderService.loadingPromise(reportService.updateHotEndBonus(vm.hotEndBonusCommand)
                .then(function () {
                $modalInstance.close(__assign({}, vm.originalhotEndRecord, vm.hotEndBonusCommand)), notifyService.handleApiErrors;
            }));
        }
        function cancel() {
            $modalInstance.close();
        }
    }
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div> <h2 class=modal-header>Edit Hot End Bonus Record {{vm.shopShiftText}}</h2> <form name=vm.form ng-submit=vm.save() novalidate> <div class=container style=\"margin:0 -30px\"> <div class=row> <div class=\"large-4 columns\"> <label><span class=\"required notated\">*</span>Production: <input name=production type=number ng-model=vm.hotEndBonusCommand.production required step=0.01 /> <div ng-messages=vm.form.production.$error ng-if=\"vm.form.production.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> <div class=\"large-4 columns\"> <label><span class=\"required notated\">*</span>Minutes: <input name=totalTime type=number ng-model=vm.hotEndBonusCommand.totalTime required step=1 min=0 ng-max=vm.maxTime /> <div ng-messages=vm.form.totalTime.$error ng-if=\"vm.form.totalTime.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=min class=req-w> <div class=arrow-up></div>Must be between 0 and {{vm.maxTime}} </div> <div ng-message=max class=req-w> <div class=arrow-up></div>Must be between 0 and {{vm.maxTime}} </div> </div> </label> </div> </div> <div class=row> <div class=\"large-4 columns\"> <label><span class=\"required notated\">*</span>Job Change Allowance: <input name=jobChangeAllowance type=number ng-model=vm.hotEndBonusCommand.jobChangeAllowance required step=0.01 min=0 max=6.85 /> <div ng-messages=vm.form.jobChangeAllowance.$error ng-if=\"vm.form.jobChangeAllowance.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=min class=req-w> <div class=arrow-up></div>Must be between 0 and 6.85 hours </div> <div ng-message=max class=req-w> <div class=arrow-up></div>Must be between 0 and 6.85 hours </div> </div> </label> </div> <div class=\"large-4 columns\"> <label><span class=\"required notated\">*</span>Start Up Allowance: <a ng-click=vm.showHelp()><i class=\"fa fa-info-circle fa-bigger\"></i></a> <input name=startupAllowance type=number ng-model=vm.hotEndBonusCommand.startupAllowance required step=0.01 min=0 max=1.92 /> <div ng-messages=vm.form.startupAllowance.$error ng-if=\"vm.form.startupAllowance.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=min class=req-w> <div class=arrow-up></div>Must be between 0 and 1.92 hours </div> <div ng-message=max class=req-w> <div class=arrow-up></div>Must be between 0 and 1.92 hours </div> </div> </label> </div> </div> <div class=row> <div class=\"large-4 columns\"> <label>Production Hours Earned: <span>{{vm.ProdHrsEarned()}}</span> </label> </div> <div class=\"large-4 columns\"> <label>Performance Percent: <span>{{vm.PerformancePercent()}} %</span> </label> </div> <!-- <div class=\"large-3 columns\">\r\n          <label>Bonus Percent:\r\n            <span>{{vm.BonusPercent()}} %</span>\r\n          </label>\r\n        </div> --> <div class=\"large-4 columns\"> <label>Weighted Amount: <span>{{vm.WeightedAmount()}}</span> </label> </div> </div> <div class=row> <div class=\"large-12 columns\"> <span class=required>* Required Fields</span> <div class=\"right dialog-footer\"> <button ng-click=vm.cancel() type=button class=\"button secondary\">Cancel</button> <button class=button type=submit>Save Data</button> </div> </div> </div> <div ng-if=vm.showHelpWindow class=modalhelpdetails> <div class=windowclose> <a><i class=\"fa fa-times-circle fa-bigger\" ng-click=vm.toggleHelpWindow()></i></a> </div> <div class=tooltiptext ng-bind-html=vm.helpText> </div> </div> </div> </form> </div>");

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <form name=vm.form ng-submit=vm.generateReport() novalidate> <div class=body-header> <h2>Hot End Bonus Report</h2> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-6 columns\"> <label> <span class=\"required notated\">*</span>Plant <select ng-model=vm.selectedPlant ng-options=\"plant as plant.name for plant in vm.plants\" ng-change=vm.updatePlant() name=selectedPlant required> <option value=\"\">-- Select a Plant --</option> </select> <div ng-messages=vm.form.selectedPlant.$error ng-if=\"vm.form.selectedPlant.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> </div> </label> </div> <div class=\"small-6 columns\"> <label> <span class=\"required notated\">*</span>Date <input type=date ng-model=vm.reportDate name=reportDate min=\"{{vm.minDate | date: 'yyyy-MM-dd'}}\" required/> <div ng-messages=vm.form.reportDate.$error ng-if=\"vm.form.reportDate.$dirty || vm.form.$submitted\" role=alert> <div ng-message=required class=req-w> <div class=arrow-up></div>Required </div> <div ng-message=\"min, max\" class=req-w> <div class=arrow-up></div>Past Date can be 60 days from today </div> </div> </label> </div> </div> <div class=row style=\"margin:0 -30px;width:auto\"> <div class=\"small-3 columns\"> <button type=submit class=button>Get Data</button> </div> </div> </form> <div style=\"margin:0 25px;width:auto\"> <div ng-if=\"vm.hotEndBonuses.shopDetailItems.length == 0 || vm.hotEndBonuses.shopDetailItems === null || vm.hotEndBonuses === null\" style=text-align:center> Currently no data for this Plant, Data would be refreshed at 9am for previous day production </div> <div ng-if=\"vm.hotEndBonuses.shopDetailItems.length > 0\" style=margin-bottom:20px> <div style=text-align:center><b>Hot End Bonus Report - {{vm.selectedPlant.name}} {{vm.formattedReportDate}}</b></div> <div ng-if=\"vm.sigOffData !== null\" style=float:right;margin-top:-20px> <label style=font-size:1rem> <input ng-disabled=!vm.iseditable type=checkbox ng-change=vm.signOff() ng-model=vm.isSignedOff /> <b>Sign Off</b> </label> <b ng-if=\"vm.userList.length > 0\"> Signed Off by below Users</b><br> <div ng-repeat=\"user in vm.userList\"> {{user.UserName}}, {{user.SignedOffDate}} </div> </div> </div> <div class=hotendBonusReport style=margin-top:50px ng-repeat=\"shop in vm.hotEndBonuses.shopDetailItems\"> <div class=header> <div class=center style=text-align:left><b>Shop : {{shop.shopName}}</b></div> </div> <table cellpadding=1 cellspacing=1 ng-if=\"shop.hotEndBonusItems && shop.hotEndBonusItems.length > 0\" class=history-t> <thead> <tr> <th>Shift</th> <th>Mold</th> <th>Finish</th> <th>Process</th> <th>Sections</th> <th>Gobs</th> <th>StandardPack</th> <th rowspan=2>Standard Gobs/Hr</th> <!-- <th>GoodGross</th>\r\n            <th>HeldGross</th> --> <th rowspan=2>JobChange Allowance</th> <th rowspan=2>Startup Allowance</th> <th>Production</th> <th rowspan=2>ProductionHrs Earned</th> <th rowspan=2>Performance Percent</th> <th rowspan=2>Bonus Percent</th> <th>OperatorHours</th> <th>WeightedAmount</th> <th rowspan=2>ShopPercent</th> </tr> </thead> <tbody> <tr ng-repeat=\"instance in shop.hotEndBonusItems\"> <td>{{ instance.shift }}</td> <td>{{ instance.mold }}</td> <td>{{ instance.finish }}</td> <td>{{ instance.process }}</td> <td>{{ instance.sections }}</td> <td>{{ instance.gobs }}</td> <td>{{ instance.standardPack }}</td> <td>{{ instance.standardGobsPerHour }}</td> <!-- <td>{{ instance.goodGross }}</td>\r\n            <td>{{ instance.heldGross }}</td> --> <td>{{ instance.jobChangeAllowance }}</td> <td>{{ instance.startupAllowance }}</td> <td>{{ instance.production }}</td> <td>{{ instance.productionHrsEarned }}</td> <td>{{ instance.performancePercent }}</td> <td>{{ instance.bonusPercent }}</td> <td>{{ instance.totalTime / 60 }}</td> <td>{{ instance.weightedAmount }}</td> <td><button ng-click=vm.edit(instance) ng-disabled=!vm.iseditable class=\"button tiny\" style=margin:0 en>Edit</button></td> <!-- <td><button ng-click=\"vm.edit(instance)\" ng-disabled =\"vm.iseditable\" class=\"button tiny\" style=\"margin:0\" en>Edit</button></td> --> </tr> <tbody> </tbody><tfoot> <td class=sectionFooter colspan=12>Shop: {{shop.shopName}} Totals</td> <td class=sectionFooter colspan=2>Job Change: {{shop.total.isJobChange}}</td> <td class=sectionFooter>{{shop.total.totalTime / 60}}</td> <td class=sectionFooter>{{shop.total.weightedAmount}}</td> <td class=sectionFooter><b>{{shop.total.percent}} %</b></td> </tfoot></tbody><tfoot> </tfoot></table> </div> <div class=hotendBonusReport ng-if=\"vm.hotEndBonuses.plantTotal !=null\" style=\"margin-top:30px 10px 0\"> <div class=header> <div class=center style=text-align:center><b>Totals</b></div> </div> <table cellpadding=1 cellspacing=1 class=history-t> <thead> <tr> <th>Plant OperatorHours</th> <th>Plant WeightedAmount</th> <th>Plant Percent</th> </tr> </thead> <tbody> <tr> <td>{{ vm.hotEndBonuses.plantTotal.totalTime }}</td> <td>{{ vm.hotEndBonuses.plantTotal.weightedAmount }}</td> <td>{{ vm.hotEndBonuses.plantTotal.percent }}</td> </tr> <tbody> </tbody></tbody></table> </div> </div> <div style=\"padding:50px 200px 0 0\"> <div class=shiftReportLegend ng-if=\"vm.hotEndBonuses != null\"> <div style=page-break-after:always> &nbsp; </div> <div class=heading> <u>Definitions & Calculations</u> </div> <!-- Shift row section 1 --> <div class=section> <div class=helpText style=\"padding:0 0 0 400px\"> <table> <tr> <td class=columnName>Shift</td> <td class=definition>Shift abbreviation</td> <td class=calculation>D = Day, A/E = Afternoon/Evening, N = Night</td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Mold/Finish</td> <td class=definition>Job mold and finish</td> <td class=calculation></td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>Process</td> <td class=definition>Job Run Process</td> <td class=calculation>BB, NNPB, PB</td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>StandardPack</td> <td class=definition>Default StandardPack for the Mold</td> <td class=calculation></td> <td class=source>source: WMS</td> </tr> <tr> <td class=columnName>standardGobs/Hour</td> <td class=definition>Default StandardGobs Per Hour for that Mold, Section, Gob</td> <td class=calculation></td> <td class=source>source: WMS</td> </tr> <tr> <td class=columnName>ProductionHrsEarned</td> <td class=definition>Converting Production to Hours </td> <td class=calculation>Sum(jobChangeAllowance + startupAllowance + (production / standardGobsPerHour))</td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>OperatorHours</td> <td class=definition>Total hours for the shift </td> <td class=calculation></td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>PerformancePercent</td> <td class=definition></td> <td class=calculation>productionHrsEarned / operatorHours </td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>WeightedAmount</td> <td class=definition></td> <td class=calculation>bonusPercent * operatorHours </td> <td class=source>source: APS</td> </tr> <tr> <td class=columnName>ShopPercent</td> <td class=definition></td> <td class=calculation>sum(weightedAmount) / sum(operatorHours) </td> <td class=source>source: APS</td> </tr> </table> </div> </div> </div> </div> </div>");

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(915), __webpack_require__(5), __webpack_require__(3), __webpack_require__(27), __webpack_require__(26), __webpack_require__(9), __webpack_require__(28), __webpack_require__(4), __webpack_require__(8), __webpack_require__(7), __webpack_require__(48), __webpack_require__(81), __webpack_require__(50), __webpack_require__(320)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, ccc_tpl_html_1, aps_enums_1, constant_module_1, enums_1, counts_service_1, uiUtility_service_1, lineConfigs_service_1, loader_service_1, navigation_service_1, authData_service_1, groupRejects_service_1, equipmentRejects_controller_1, interval_factory_1, mapping_functions_1) {
    "use strict";
    countsConfig.$inject = ["$stateProvider"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [counts_service_1.default, uiUtility_service_1.default, lineConfigs_service_1.default, loader_service_1.default,
        navigation_service_1.default, authData_service_1.default, groupRejects_service_1.default, equipmentRejects_controller_1.default];
    function countsConfig($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.COUNTS_CAVITY_CORRELATION,
            url: '/CountsCavityCorrelation',
            controller: 'CountsCavityCorrelationCtrl as vm',
            template: ccc_tpl_html_1.default,
            data: {
                pageTitle: 'Counts Cavity Correlation', v2Uri: 'aps/dashboard/operator/cavity-correlation'
            }
        });
    }
    var CountsCavityCorrelationCtrl = (function () {
        CountsCavityCorrelationCtrl.$inject = ["$state", "$interval", "$stateParams", "$q", "$scope", "countsService", "loaderService", "authDataService", "uiUtilityService", "navigationService"];
        function CountsCavityCorrelationCtrl($state, $interval, $stateParams, $q, $scope, countsService, loaderService, authDataService, uiUtilityService, navigationService) {
            var _this = this;
            this.loading = false;
            this.userId = null;
            this.shopId = null;
            this.interval = null;
            this.model = null;
            this.areas = [];
            this.plant = null;
            this.shop = null;
            this.hub = null;
            this.countDisplayIntervalOptions = null;
            this.canDisableLine = false;
            this.cavities = [];
            this.hasCavities = false;
            this.navigationUrls = {
                buttons: [
                    { 'name': 'Horizontal Counts', 'value': 'horizontal', 'selected': false },
                    { 'name': 'Vertical Counts', 'value': 'vertical', 'selected': false },
                    { 'name': 'Vertical Counts (v2)', 'value': 'vc2', 'selected': false },
                ],
                select: function (button) {
                    var stateParams = {
                        plantId: _this.$stateParams.plantId,
                        shopId: _this.$stateParams.shopId,
                        userId: _this.$stateParams.userId,
                    };
                    switch (button.value) {
                        case "horizontal":
                            _this.$state.go(constant_module_1.States.COUNTS_HORIZONTAL, stateParams);
                            break;
                        case "vertical":
                            _this.$state.go(constant_module_1.States.COUNTS_VERTICAL, stateParams);
                            break;
                        case "vc2":
                            _this.$state.go(constant_module_1.States.COUNTS_VERTICAL_V2, stateParams);
                            break;
                    }
                }
            };
            this.$state = $state;
            this.$interval = $interval;
            this.$stateParams = $stateParams;
            this.$q = $q;
            this.$scope = $scope;
            this.authDataService = authDataService;
            this.userId = $stateParams.userId;
            this.countDisplayIntervalOptions = uiUtilityService.getListOptionsFromEnum(enums_1.apsDisplayEnums.CountDisplayInterval, null, null, function (o) { return o; });
            this.countsInterval = authDataService.getCountInterval();
            this.countsService = countsService;
            this.loaderService = loaderService;
            this.canDisableLine = authDataService.isPlantOrAPSIOAdminForCurrentPlant();
            this.navigationService = navigationService;
            this.barClick = function (summary) {
                var reportStateParams = {
                    plantId: _this.$stateParams.plantId,
                    shopId: _this.$stateParams.shopId,
                    userId: _this.$stateParams.userId,
                    reportPlantId: _this.$stateParams.plantId,
                    reportShopId: _this.$stateParams.shopId,
                    startDate: _this.reportDate.Start.toISOString(),
                    endDate: _this.reportDate.End ? _this.reportDate.End.toISOString() : undefined,
                    autoRun: true,
                    cavity: summary.cavity
                };
                _this.$state.go(constant_module_1.States.CAVITY_CORRELATION, reportStateParams);
            };
            this.registerDestroy();
            this.loaderService.setAppLoading(true);
            this.plantShopsPromise().then(function () {
                _this.countsPromise().then(function () {
                    _this.cavityCorrelationPromise().then(function () {
                        _this.startInterval().then(function () {
                            _this.loaderService.setAppLoading(false);
                        });
                    });
                });
            });
        }
        CountsCavityCorrelationCtrl.prototype.countsIntervalChanged = function () {
            this.authDataService.setCountInterval(this.countsInterval);
            this.update();
        };
        CountsCavityCorrelationCtrl.prototype.plantShopsPromise = function () {
            var _this = this;
            return this.navigationService.getNavigation().then(function (navModel) {
                _this.plant = navModel.selectedPlant;
                _this.shop = navModel.selectedShop;
            });
        };
        CountsCavityCorrelationCtrl.prototype.countsPromise = function () {
            var _this = this;
            return this.countsService.getLineCounts(this.shop.id, this.plant, this.countsInterval, this.canDisableLine)
                .then(function (result) {
                _this.model = result;
                _this.areas = mapping_functions_1.mapModelToAreas(_this.model);
                for (var id in _this.model.equipment) {
                    if (_this.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.HEYE
                        || _this.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.CheckDetector
                        || _this.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.MX4
                        || _this.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.Mcal
                        || _this.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.Multi
                        || _this.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.FlexBC
                        || _this.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.FlexM
                        || _this.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.WBF) {
                        _this.hasCavities = true;
                        break;
                    }
                }
            });
        };
        CountsCavityCorrelationCtrl.prototype.cavityCorrelationPromise = function () {
            var _this = this;
            this.reportDate = mapping_functions_1.getReportDate(this.model.shopConfig, this.countsInterval);
            return this.countsService.getCavityCorrelation(this.shop.id, this.reportDate.Start, this.reportDate.End)
                .then(function (cavities) {
                _this.cavities = cavities;
            });
        };
        CountsCavityCorrelationCtrl.prototype.startInterval = function () {
            var _this = this;
            return this.$q(function (resolve) {
                _this.destroyInterval();
                _this.interval = new interval_factory_1.Interval(_this.update.bind(_this), _this.$interval, 5 * 60 * 1000);
                _this.interval.start();
                resolve();
            });
        };
        CountsCavityCorrelationCtrl.prototype.registerDestroy = function () {
            var _this = this;
            this.$scope.$on('$destroy', function () {
                _this.destroyInterval();
            });
        };
        CountsCavityCorrelationCtrl.prototype.destroyInterval = function () {
            if (this.interval != null) {
                this.interval.destroy();
                this.interval = null;
            }
        };
        CountsCavityCorrelationCtrl.prototype.update = function () {
            var _this = this;
            this.reportDate = mapping_functions_1.getReportDate(this.model.shopConfig, this.countsInterval);
            var promise = this.countsService.getCavityCorrelation(this.shop.id, this.reportDate.Start, this.reportDate.End)
                .then(function (cavities) {
                _this.cavities = cavities;
            });
            this.loaderService.loadingPromise(promise);
        };
        return CountsCavityCorrelationCtrl;
    }());
    exports.default = angular.module('aps.controller.countsCavityCorrelation', requires)
        .config(countsConfig)
        .controller('CountsCavityCorrelationCtrl', CountsCavityCorrelationCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row-flex ag-header\"> <div class=\"ag-header-plant ag-header-box\"> <span class=ag-plant-name>{{vm.plant.name || \"...\"}}</span> <span class=ag-shop>Shop {{vm.shop.name}}</span> </div> <div class=\"ag-header-count-interval ag-header-box\"> <label> <span>Viewing Count Data For:</span> <select style=width:120px id=countsInterval ng-model=vm.countsInterval ng-options=\"t.value as t.text for t in vm.countDisplayIntervalOptions\" ng-change=vm.countsIntervalChanged() class=form-control></select> </label> </div> <div class=\"ag-header-btnarray ag-header-box\"> <btn-array options=vm.navigationUrls /> </div> <div ng-show=vm.loading class=\"spinner-border text-primary ag-header-box\" role=status> <span class=sr-only>Loading...</span> </div> </div> <div class=row-flex ng-show=vm.errorMessage> <div class=\"alert alert-danger\" role=alert> {{vm.errorMessage}} </div> </div> <div ng-hide=vm.loading style=\"padding:.625em 1.6%\"> <aps-cavity-correlation-summary-graph ng-if=\"vm.selectedTab === vm.countsTab.CavityCorrelation\" cavities=vm.cavities cavity-selected=vm.barClick> </aps-cavity-correlation-summary-graph> </div>");

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(917), __webpack_require__(5), __webpack_require__(3), __webpack_require__(27), __webpack_require__(26), __webpack_require__(9), __webpack_require__(28), __webpack_require__(4), __webpack_require__(8), __webpack_require__(7), __webpack_require__(48), __webpack_require__(81), __webpack_require__(50), __webpack_require__(320)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, cce_tpl_html_1, aps_enums_1, constant_module_1, enums_1, counts_service_1, uiUtility_service_1, lineConfigs_service_1, loader_service_1, navigation_service_1, authData_service_1, groupRejects_service_1, equipmentRejects_controller_1, interval_factory_1, mapping_functions_1) {
    "use strict";
    countsConfig.$inject = ["$stateProvider"];
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [counts_service_1.default, uiUtility_service_1.default, lineConfigs_service_1.default, loader_service_1.default,
        navigation_service_1.default, authData_service_1.default, groupRejects_service_1.default, equipmentRejects_controller_1.default];
    function countsConfig($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.COUNTS_CAVITY_EFFICIENCY,
            url: '/CountsCavityEfficiency',
            controller: 'CountsCavityEfficiencyCtrl as vm',
            template: cce_tpl_html_1.default,
            data: { pageTitle: 'Counts Cavity Efficiency' }
        });
    }
    var CountsCavityEfficiencyCtrl = (function () {
        CountsCavityEfficiencyCtrl.$inject = ["$state", "$interval", "$stateParams", "$q", "$scope", "countsService", "loaderService", "authDataService", "uiUtilityService", "navigationService"];
        function CountsCavityEfficiencyCtrl($state, $interval, $stateParams, $q, $scope, countsService, loaderService, authDataService, uiUtilityService, navigationService) {
            var _this = this;
            this.loading = false;
            this.userId = null;
            this.shopId = null;
            this.interval = null;
            this.model = null;
            this.areas = [];
            this.plant = null;
            this.shop = null;
            this.hub = null;
            this.countDisplayIntervalOptions = null;
            this.canDisableLine = false;
            this.cavities = [];
            this.hasCavities = false;
            this.errorMessage = null;
            this.navigationUrls = {
                buttons: [
                    { 'name': 'Horizontal Counts', 'value': 'horizontal', 'selected': false },
                    { 'name': 'Vertical Counts', 'value': 'vertical', 'selected': false },
                    { 'name': 'Vertical Counts (v2)', 'value': 'vc2', 'selected': false },
                ],
                select: function (button) {
                    var stateParams = {
                        plantId: _this.$stateParams.plantId,
                        shopId: _this.$stateParams.shopId,
                        userId: _this.$stateParams.userId,
                    };
                    switch (button.value) {
                        case "horizontal":
                            _this.$state.go(constant_module_1.States.COUNTS_HORIZONTAL, stateParams);
                            break;
                        case "vertical":
                            _this.$state.go(constant_module_1.States.COUNTS_VERTICAL, stateParams);
                            break;
                        case "vc2":
                            _this.$state.go(constant_module_1.States.COUNTS_VERTICAL_V2, stateParams);
                            break;
                    }
                }
            };
            this.$state = $state;
            this.$interval = $interval;
            this.$stateParams = $stateParams;
            this.$q = $q;
            this.$scope = $scope;
            this.authDataService = authDataService;
            this.userId = $stateParams.userId;
            this.countDisplayIntervalOptions = uiUtilityService.getListOptionsFromEnum(enums_1.apsDisplayEnums.CountDisplayInterval, null, null, function (o) { return o; });
            this.countsInterval = authDataService.getCountInterval();
            this.countsService = countsService;
            this.loaderService = loaderService;
            this.canDisableLine = authDataService.isPlantOrAPSIOAdminForCurrentPlant();
            this.navigationService = navigationService;
            this.barClick = function (summary) {
                var reportStateParams = {
                    plantId: _this.$stateParams.plantId,
                    shopId: _this.$stateParams.shopId,
                    userId: _this.$stateParams.userId,
                    reportPlantId: _this.$stateParams.plantId,
                    reportShopId: _this.$stateParams.shopId,
                    startDate: _this.reportDate.Start.toISOString(),
                    endDate: _this.reportDate.End ? _this.reportDate.End.toISOString() : undefined,
                    autoRun: true,
                    cavity: summary.cavity
                };
                _this.$state.go(constant_module_1.States.CAVITY_EFFICIENCY, reportStateParams);
            };
            this.registerDestroy();
            this.loaderService.setAppLoading(true);
            this.plantShopsPromise().then(function () {
                _this.countsPromise().then(function () {
                    _this.cavityEfficiencyPromise().then(function () {
                        _this.startInterval().then(function () {
                            _this.loaderService.setAppLoading(false);
                        });
                    });
                });
            }, function (err) {
                console.log(err);
                _this.errorMessage = err;
            });
        }
        CountsCavityEfficiencyCtrl.prototype.countsIntervalChanged = function () {
            this.authDataService.setCountInterval(this.countsInterval);
            this.update();
        };
        CountsCavityEfficiencyCtrl.prototype.plantShopsPromise = function () {
            var _this = this;
            return this.navigationService.getNavigation().then(function (navModel) {
                _this.plant = navModel.selectedPlant;
                _this.shop = navModel.selectedShop;
            });
        };
        CountsCavityEfficiencyCtrl.prototype.countsPromise = function () {
            var _this = this;
            return this.countsService.getLineCounts(this.shop.id, this.plant, this.countsInterval, this.canDisableLine)
                .then(function (result) {
                _this.model = result;
                _this.areas = mapping_functions_1.mapModelToAreas(_this.model);
                for (var id in _this.model.equipment) {
                    if (_this.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.HEYE
                        || _this.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.CheckDetector
                        || _this.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.MX4
                        || _this.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.Mcal
                        || _this.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.Multi
                        || _this.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.FlexBC
                        || _this.model.equipment[id].type === aps_enums_1.apsEnums.LineEquipmentType.FlexM) {
                        _this.hasCavities = true;
                        break;
                    }
                }
            });
        };
        CountsCavityEfficiencyCtrl.prototype.cavityEfficiencyPromise = function () {
            var _this = this;
            this.reportDate = mapping_functions_1.getReportDate(this.model.shopConfig, this.countsInterval);
            return this.countsService.getCavityEfficiency(this.shop.id, this.reportDate.Start, this.reportDate.End)
                .then(function (cavities) {
                _this.cavities = cavities;
            });
        };
        CountsCavityEfficiencyCtrl.prototype.startInterval = function () {
            var _this = this;
            return this.$q(function (resolve) {
                _this.destroyInterval();
                _this.interval = new interval_factory_1.Interval(_this.update.bind(_this), _this.$interval, 5 * 60 * 1000);
                _this.interval.start();
                resolve();
            });
        };
        CountsCavityEfficiencyCtrl.prototype.registerDestroy = function () {
            var _this = this;
            this.$scope.$on('$destroy', function () {
                _this.destroyInterval();
            });
        };
        CountsCavityEfficiencyCtrl.prototype.destroyInterval = function () {
            if (this.interval != null) {
                this.interval.destroy();
                this.interval = null;
            }
        };
        CountsCavityEfficiencyCtrl.prototype.update = function () {
            var _this = this;
            this.reportDate = mapping_functions_1.getReportDate(this.model.shopConfig, this.countsInterval);
            var promise = this.countsService.getCavityEfficiency(this.shop.id, this.reportDate.Start, this.reportDate.End)
                .then(function (cavities) {
                _this.cavities = cavities;
            }, function (err) {
                console.log(err);
                _this.errorMessage = err;
            });
            this.loaderService.loadingPromise(promise);
        };
        return CountsCavityEfficiencyCtrl;
    }());
    exports.default = angular.module('aps.controller.countsCavityEfficiency', requires)
        .config(countsConfig)
        .controller('CountsCavityEfficiencyCtrl', CountsCavityEfficiencyCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"row-flex ag-header\"> <div class=\"ag-header-plant ag-header-box\"> <span class=ag-plant-name>{{vm.plant.name || \"...\"}}</span> <span class=ag-shop>Shop {{vm.shop.name}}</span> </div> <div class=\"ag-header-count-interval ag-header-box\"> <label> <span>Viewing Count Data For:</span> <select style=width:120px id=countsInterval ng-model=vm.countsInterval ng-options=\"t.value as t.text for t in vm.countDisplayIntervalOptions\" ng-change=vm.countsIntervalChanged() class=form-control></select> </label> </div> <div class=\"ag-header-btnarray ag-header-box\"> <btn-array options=vm.navigationUrls /> </div> <div ng-show=vm.loading class=\"spinner-border text-primary ag-header-box\" role=status> <span class=sr-only>Loading...</span> </div> </div> <div class=row-flex ng-show=vm.errorMessage> <div class=\"alert alert-danger\" role=alert> {{vm.errorMessage}} </div> </div> <div class=row-flex> <div class=col-md-12> <div style=\"padding:.625em 1.6%;height:500px\"> <aps-cavity-efficiency-summary-graph ng-if=\"vm.selectedTab === vm.countsTab.CavityEfficiency\" cavities=vm.cavities cavity-selected=vm.barClick style=height:500px;width:100%> </aps-cavity-efficiency-summary-graph> </div> </div> </div>");

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(2), __webpack_require__(1), __webpack_require__(919), __webpack_require__(3), __webpack_require__(5), __webpack_require__(9), __webpack_require__(4), __webpack_require__(57), __webpack_require__(26), __webpack_require__(23), __webpack_require__(8), __webpack_require__(25)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, _, moment, dataPointHistoryReport_template_html_1, constant_module_1, aps_enums_1, uiUtility_service_1, loader_service_1, dataPoints_service_1, counts_service_1, shops_service_1, navigation_service_1, defectType_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var requires = [uiUtility_service_1.default, loader_service_1.default, counts_service_1.default,
        shops_service_1.default, navigation_service_1.default, defectType_service_1.default,
        dataPoints_service_1.default];
    var DataPointHistoryReortItem = (function () {
        function DataPointHistoryReortItem() {
        }
        return DataPointHistoryReortItem;
    }());
    var DataPointHistoryReportCtrl = (function () {
        DataPointHistoryReportCtrl.$inject = ["$state", "$stateParams", "$q", "navigationService", "shopService", "dataPointService", "countsService", "loaderService", "notifyService"];
        function DataPointHistoryReportCtrl($state, $stateParams, $q, navigationService, shopService, dataPointService, countsService, loaderService, notifyService) {
            var _this = this;
            this.requirePlantSelection = true;
            this.requireShopSelection = true;
            this.countInterval = aps_enums_1.apsEnums.CountInterval.TenMinutes.toString();
            this.selectedDataPoints = [];
            this.dates = new Array();
            this.table = {};
            this.today = moment().toDate();
            this.yesterday = moment().subtract(1, 'days').toDate();
            this.selectedRange = null;
            this.options = {
                title: {
                    text: ''
                },
                xAxis: {
                    categories: [],
                },
                legend: {
                    layout: 'vertical',
                    align: 'right',
                    verticalAlign: 'middle'
                },
                plotOptions: {
                    series: {
                        label: {
                            connectorAllowed: false
                        }
                    }
                },
                series: [],
                responsive: {
                    rules: [{
                            condition: {
                                maxWidth: 500
                            },
                            chartOptions: {
                                legend: {
                                    layout: 'horizontal',
                                    align: 'center',
                                    verticalAlign: 'bottom'
                                }
                            }
                        }]
                },
                credits: {
                    enabled: false
                }
            };
            this.ranges = {
                "1": [
                    {
                        name: "Last 10 Minutes",
                        start: function () { return moment().subtract(10, 'minute'); },
                        end: function () { return moment(); }
                    },
                    {
                        name: "Last 30 Minutes",
                        start: function () { return moment().subtract(30, 'minute'); },
                        end: function () { return moment(); }
                    },
                    {
                        name: "Last Hour",
                        start: function () { return moment().subtract(1, 'hour'); },
                        end: function () { return moment(); }
                    },
                    {
                        name: "Last 2 Hours",
                        start: function () { return moment().subtract(2, 'hour'); },
                        end: function () { return moment(); }
                    }
                ],
                "2": [
                    {
                        name: "Last Hour",
                        start: function () { return moment().subtract(1, 'hour'); },
                        end: function () { return moment(); }
                    },
                    {
                        name: "Last 2 Hours",
                        start: function () { return moment().subtract(2, 'hour'); },
                        end: function () { return moment(); }
                    },
                    {
                        name: "Last 4 Hours",
                        start: function () { return moment().subtract(4, 'hour'); },
                        end: function () { return moment(); }
                    },
                    {
                        name: "Last 8 Hours",
                        start: function () { return moment().subtract(8, 'hour'); },
                        end: function () { return moment(); }
                    }
                ],
                "3": [
                    {
                        name: "Last 4 Hour",
                        start: function () { return moment().subtract(4, 'hour'); },
                        end: function () { return moment(); }
                    },
                    {
                        name: "Last 8 Hours",
                        start: function () { return moment().subtract(8, 'hour'); },
                        end: function () { return moment(); }
                    },
                    {
                        name: "Last 24 Hours",
                        start: function () { return moment().subtract(24, 'hour'); },
                        end: function () { return moment(); }
                    },
                    {
                        name: "Last 40 Hours",
                        start: function () { return moment().subtract(40, 'hour'); },
                        end: function () { return moment(); }
                    }
                ],
                "4": [
                    {
                        name: "Last 3 days",
                        start: function () { return moment().subtract(3, 'day'); },
                        end: function () { return moment(); }
                    },
                    {
                        name: "Last 7 days",
                        start: function () { return moment().subtract(7, 'day'); },
                        end: function () { return moment(); }
                    },
                    {
                        name: "Last 15 days",
                        start: function () { return moment().subtract(15, 'day'); },
                        end: function () { return moment(); }
                    }
                ],
                "5": [
                    {
                        name: "Today",
                        start: function () { return moment(); },
                        end: function () { return moment(); }
                    },
                    {
                        name: "Yesterday",
                        start: function () { return moment().subtract(2, 'day'); },
                        end: function () { return moment(); }
                    },
                    {
                        name: "Last 7 Days",
                        start: function () { return moment().subtract(7, 'day'); },
                        end: function () { return moment(); }
                    },
                    {
                        name: "Last 15 Days",
                        start: function () { return moment().subtract(15, 'day'); },
                        end: function () { return moment(); }
                    },
                    {
                        name: "Last 30 Days",
                        start: function () { return moment().subtract(30, 'day'); },
                        end: function () { return moment(); }
                    },
                    {
                        name: "This Month",
                        start: function () { return moment().subtract(1, 'month'); },
                        end: function () { return moment(); }
                    },
                    {
                        name: "Last Month",
                        start: function () { return moment().subtract(2, 'month'); },
                        end: function () { return moment().subtract(1, 'month'); }
                    },
                ]
            };
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.$q = $q;
            this.navigationService = navigationService;
            this.shopService = shopService;
            this.dataPointService = dataPointService;
            this.countsService = countsService;
            this.loaderService = loaderService;
            this.notifyService = notifyService;
            var now = moment().add(1, 'hours').startOf('hour');
            this.endDate = now.toDate();
            this.startDate = now.clone().subtract(1, 'days').toDate();
            var promise = navigationService.getNavigation().then(function (nav) {
                _this.plants = nav.plants();
                _this.selectedPlant = nav.selectedPlant;
                _this.selectedShop = nav.selectedShop;
            }).then(function () {
                _this.loadDataPoints(_this.selectedPlant.id);
            });
            loaderService.loadingPromise(promise);
        }
        DataPointHistoryReportCtrl.prototype.loadDataPoints = function (plantId) {
            var _this = this;
            return this.dataPointService.get(plantId).then(function (dataPoints) {
                _this.dataPoints = dataPoints;
            });
        };
        DataPointHistoryReportCtrl.prototype.plantSelected = function ($event) {
            try {
                this.loadDataPoints(this.selectedPlant.id).then(function () {
                    console.log("plant selected.");
                });
            }
            finally {
                if ($event === null)
                    return;
                $event.stopPropagation();
                $event.preventDefault();
            }
        };
        DataPointHistoryReportCtrl.prototype.addClicked = function ($event) {
            try {
                if (this.selectedDataPoint === null)
                    return;
                if (this.selectedDataPoints.indexOf(this.selectedDataPoint) === -1 && this.selectedDataPoints.length < 6) {
                    this.selectedDataPoints.push(this.selectedDataPoint);
                }
                else if (this.selectedDataPoints.length === 6) {
                    this.notifyService.error('The Maximum limit is 6');
                }
                this.selectedDataPoint = null;
            }
            finally {
                $event.stopPropagation();
                $event.preventDefault();
            }
        };
        DataPointHistoryReportCtrl.prototype.selectItem = function (dataPoint) {
            this.selectedDataPoint = dataPoint;
        };
        DataPointHistoryReportCtrl.prototype.removeClicked = function ($event, removeDp) {
            try {
                if (removeDp === null) {
                    return;
                }
                this.selectedDataPoints = this.selectedDataPoints.filter(function (dp) {
                    return dp !== removeDp;
                });
            }
            finally {
                $event.stopPropagation();
                $event.preventDefault();
            }
        };
        DataPointHistoryReportCtrl.prototype.runReport = function () {
            var _this = this;
            this.table = {};
            this.dates = [];
            this.data = [];
            this.options.xAxis = {
                categories: []
            };
            this.options.series = [];
            this.data = new Array();
            var promises = [];
            angular.forEach(this.selectedDataPoints, function (dataPoint) {
                var promise = _this.countsService.getByDatapointId(dataPoint.id, _this.startDate, _this.endDate, _this.countInterval)
                    .then(function (response) {
                    var item = new DataPointHistoryReortItem();
                    item.data = response;
                    item.dataPoint = dataPoint;
                    _this.data.push(item);
                });
                promises.push(promise);
            });
            return this.$q.all(promises).then(function () {
                console.log("report completed.", _this.data.length);
                var distinct = function (value, index, self) {
                    return self.indexOf(value) === index;
                };
                var sortDate = function (a, b) {
                    return b.valueOf() - a.valueOf();
                };
                var fmt = function (x) { return moment(x).format("L LT"); };
                angular.forEach(_this.data, function (row) {
                    _this.dates = _.union(_this.dates, row.data.map(function (d) {
                        return d.intervalStart;
                    }));
                });
                var cats = _this.dates
                    .filter(distinct)
                    .sort(sortDate)
                    .reverse()
                    .map(fmt)
                    .filter(distinct);
                var xaxis = {
                    categories: cats,
                    labels: {
                        rotation: -45,
                        style: {
                            fontSize: '13px',
                            fontFamily: 'Verdana, sans-serif'
                        }
                    }
                };
                _this.options.xAxis = xaxis;
                _this.options.series = [];
                var table = {};
                angular.forEach(cats, function (date) {
                    var row = {};
                    table[date] = row;
                });
                angular.forEach(_this.data, function (dp) {
                    var points = dp.data.sort(function (a, b) {
                        return sortDate(a.intervalStart, b.intervalEnd);
                    });
                    angular.forEach(points, function (v) {
                        table[fmt(v.intervalStart)][dp.dataPoint.name] = v.value;
                    });
                });
                var value = function (row, col) {
                    var v = table[row][col];
                    return v;
                };
                var values = function (col) {
                    var m = Object.keys(table).map(function (row) {
                        var v = value(row, col);
                        return v;
                    });
                    return m;
                };
                var series = function (dps) {
                    var m = dps.map(function (dp) {
                        var d = {
                            name: dp.name,
                            data: values(dp.name)
                        };
                        return d;
                    });
                    return m;
                };
                _this.options.series = series(_this.selectedDataPoints);
                _this.table = table;
            });
        };
        DataPointHistoryReportCtrl.prototype.tableKeys = function () {
            return Object.keys(this.table);
        };
        DataPointHistoryReportCtrl.prototype.selectedRangeChanged = function ($event) {
            if (angular.isDefined(this.selectedRange)) {
                var a = this.selectedRange;
                if (a === null) {
                    this.uiStartDate = null;
                    this.uiEndDate = null;
                    this.startDate = null;
                    this.endDate = null;
                }
                else {
                    this.uiStartDate = a.start().format("L LT");
                    this.uiEndDate = a.end().format("L LT");
                    this.startDate = a.start().toDate();
                    this.endDate = a.end().toDate();
                }
            }
        };
        DataPointHistoryReportCtrl.prototype.getSelectedRanges = function () {
            if (this.countInterval === null)
                return [];
            var selectedRanges = this.ranges[this.countInterval.toString()];
            return selectedRanges;
        };
        DataPointHistoryReportCtrl.prototype.submit = function ($event) {
            try {
                if (this.form.$invalid) {
                    return;
                }
                var loadPromise = this.runReport();
                this.loaderService.loadingPromise(loadPromise);
            }
            finally {
                if ($event == null)
                    return;
                $event.stopPropagation();
                $event.preventDefault();
            }
        };
        return DataPointHistoryReportCtrl;
    }());
    exports.default = angular.module('aps.controller.dataPointHistoryReport', requires)
        .config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state({
            name: constant_module_1.States.COUNTS_DATA_POINT_HISTORY,
            url: '/admin/reports/dataPointHistoryReport?'
                + 'startDate&'
                + 'endDate&'
                + 'orderBy&'
                + 'autoRun&'
                + 'reportPlantId&'
                + 'reportShopId',
            params: {
                startDate: { dynamic: true },
                endDate: { dynamic: true },
                orderBy: { dynamic: true },
                autoRun: { dynamic: true },
                reportPlantId: { dynamic: true },
                reportShopId: { dynamic: true },
            },
            controller: 'DataPointHistoryReportCtrl as vm',
            template: dataPointHistoryReport_template_html_1.default,
            data: {
                pageTitle: 'Data Point History',
                authorizeAPSIOAdmin: true
            }
        });
    }])
        .controller('DataPointHistoryReportCtrl', DataPointHistoryReportCtrl)
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<div class=main-table-w> <h2>Data Point History Report</h2> </div> <div class=row-flex> <div class=col-md-12> <form name=vm.form ng-submit=vm.submit($event) novalidate> <!--<div class=\"body-header\">--> <div class=row-flex> <button type=submit name=submitBtn id=submitBtn class=\"button small\"> Submit </button> </div> <div class=row-flex style=padding-left:0;padding-right:0> <!-- plant --> <div class=\"small-2 columns\" style=padding-left:0;padding-right:4px> <label> <span class=\"required notated\" ng-if=vm.requirePlantSelection>*</span> <span>Plant</span> <select name=selectedPlant class=bs-form-control ng-model=vm.selectedPlant ng-options=\"plant as plant.name for plant in vm.plants\" ng-change=vm.plantSelected($event) ng-required=vm.requirePlantSelection> <option value=\"\">-- {{vm.requirePlantSelection ? 'Select a Plant' : 'Any Plant' }} --</option> </select> <span ng-messages=vm.form.selectedPlant.$error ng-if=\"vm.form.selectedPlant.$dirty || vm.form.$submitted\" role=alert> <span ng-message=required class=req-w> <span class=arrow-up></span>Required </span> </span> </label> </div> <!-- dataPointId --> <div class=\"small-2 columns\" style=padding-left:4px;padding-right:4px;margin-top:2px> <label> <span>Data Point ID</span> <span class=\"bs-input-group bs-mb-3\"> <div class=dp-dropdown> <input type=text id=searchText autocomplete=off name=selectedDataPoint ng-model=vm.selectedDataPoint.name placeholder=\"Type to search...\"/> <ul class=dp-dropdown-content> <li ng-repeat=\"dp in vm.dataPoints | filter:vm.selectedDataPoint.name\" ng-click=vm.selectItem(dp)> {{ dp.name }} </li> </ul> <button class=\"bs-btn bs-btn-outline-secondary bs-btn-sm\" style=height:37px;position:absolute;right:0;border-color:#ccc type=button ng-click=vm.addClicked($event)> <i class=\"fa fa-plus\"></i> </button> </div> </span> </label> </div> <!-- counts interval --> <div class=\"small-2 columns\" style=padding-left:4px;padding-right:4px> <label> <span class=\"required notated\">*</span> <span>Count Interval</span> <select name=countInterval ng-model=vm.countInterval class=bs-form-control> <option value=\"\" ng-selected=true>-- Count Interval --</option> <option value=1>Minute [1]</option> <option value=2>10 Minutes [2]</option> <option value=3>Hour [3]</option> <option value=4>Shift [4]</option> <option value=5>Day [5]</option> </select> </label> </div> <!-- range selector --> <div class=\"small-2 columns\" style=padding-left:4px;padding-right:4px> <label> <span class=\"required notated\">*</span> <span>Ranges</span> <select name=range class=bs-form-control ng-model=vm.selectedRange ng-change=vm.selectedRangeChanged($event) ng-options=\"range.name for range in vm.getSelectedRanges()\"> </select> </label> </div> <!-- start date --> <div class=\"small-2 columns\" style=padding-left:4px;padding-right:4px> <label> <span class=\"required notated\">*</span> <span>Start Date</span> <input type=text name=startDate class=bs-form-control ng-model=vm.uiStartDate disabled=disabled /> </label> </div> <!-- end date --> <div class=\"small-2 columns\" style=padding-left:4px;padding-right:0> <label> <span class=\"required notated\">*</span> <span>End Date</span> <input type=text name=endDate class=bs-form-control ng-model=vm.uiEndDate disabled=disabled /> </label> </div> </div> <div class=row-flex> <!-- table of selected data points --> <div class=\"small-12 columns\" style=padding-left:0;padding-right:0> <h5 style=margin-bottom:0;padding-bottom:0> <span class=\"required notated\">*</span> <span>Selected Data Points</span> </h5> <table class=history-t style=margin-top:0;padding-top:0> <thead tabindex=0> <tr> <th class=cursor-hand>Data Point ID</th> <th class=cursor-hand>Data Point Name</th> <th class=cursor-hand>Action</th> </tr> </thead> <tbody> <tr ng-repeat=\"dp in vm.selectedDataPoints\" ng-class=\"{'text-danger': dp.plantId != vm.selectedPlant.id}\"> <td> <i ng-if=\"dp.plantId==vm.selectedPlant.id\" class=\"fa fa-check text-success\"></i> <i ng-if=\"dp.plantId!=vm.selectedPlant.id\" class=\"fa fa-exclamation text-danger\" data-toggle=tooltip data-placement=top title=\"Invalid Data Point Id\"></i> <span>{{dp.id || dp}}</span> </td> <td>{{dp.name}}</td> <td> <button type=button class=\"button tiny bg-red\" style=margin:0 ng-click=\"vm.removeClicked($event, dp)\"> <i class=\"fa fa-trash\"></i> </button> </td> </tr> </tbody> </table> </div> </div> </form> </div> </div> <div class=row-flex> <div class=col-md-12> <h5>Data Point History Chart</h5> <div style=height:550px;width:100% class=ag-box> <high-chart options=vm.options id=barchart style=display:block;height:550px> </high-chart> </div> </div> </div> <div>&nbsp;</div> <div class=row-flex> <div class=col-md-12> <h5>Data Point History Table</h5> <div> <div class=box> <table class=\"history-t no-margin no-padding\"> <thead role=button tabindex=0> <tr> <th>Date</th> <th ng-repeat=\"dp in vm.selectedDataPoints\">{{dp.name}}</th> </tr> </thead> <tbody> <tr class=cursor-hand ng-class-even=\"'x-tr'\" ng-repeat=\"(key, value) in vm.table\"> <td>{{key}}</td> <td ng-repeat=\"dp in vm.selectedDataPoints\">{{value[dp.name]}}</td> </tr> </tbody> </table> </div> </div> </div> </div> ");

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(0), __webpack_require__(7)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports, angular, authData_service_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = angular.module('aps.interceptors', [authData_service_1.default])
        .factory('httpInterceptors', ["$q", "$location", "authDataService", function ($q, $location, authDataService) {
        return {
            'request': function (config) {
                var userId = authDataService.getUserId();
                if (!userId) {
                    userId = $location.search().userId;
                    if (userId) {
                        authDataService.setUserId(userId);
                    }
                }
                var token = authDataService.getToken();
                if (token) {
                    config.headers.Authorization = 'Bearer ' + token;
                }
                return config;
            },
            'responseError': function (response) {
                if (response.status === 401) {
                    authDataService.clearToken();
                    $location.url('/signIn');
                }
                return $q.reject(response);
            }
        };
    }])
        .name;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

// Should already be required, here for clarity
__webpack_require__(0);

// Load Angular and dependent libs
__webpack_require__(321);
__webpack_require__(923);

// Now load Angular Material
__webpack_require__(925);

// Export namespace
module.exports = 'ngMaterial';


/***/ }),
/* 922 */,
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(924);
module.exports = 'ngAria';


/***/ }),
/* 924 */
/***/ (function(module, exports) {

/**
 * @license AngularJS v1.8.3
 * (c) 2010-2020 Google LLC. http://angularjs.org
 * License: MIT
 */
(function(window, angular) {'use strict';

/**
 * @ngdoc module
 * @name ngAria
 * @description
 *
 * The `ngAria` module provides support for common
 * [<abbr title="Accessible Rich Internet Applications">ARIA</abbr>](http://www.w3.org/TR/wai-aria/)
 * attributes that convey state or semantic information about the application for users
 * of assistive technologies, such as screen readers.
 *
 * ## Usage
 *
 * For ngAria to do its magic, simply include the module `ngAria` as a dependency. The following
 * directives are supported:
 * `ngModel`, `ngChecked`, `ngReadonly`, `ngRequired`, `ngValue`, `ngDisabled`, `ngShow`, `ngHide`,
 * `ngClick`, `ngDblClick`, and `ngMessages`.
 *
 * Below is a more detailed breakdown of the attributes handled by ngAria:
 *
 * | Directive                                   | Supported Attributes                                                                                |
 * |---------------------------------------------|-----------------------------------------------------------------------------------------------------|
 * | {@link ng.directive:ngModel ngModel}        | aria-checked, aria-valuemin, aria-valuemax, aria-valuenow, aria-invalid, aria-required, input roles |
 * | {@link ng.directive:ngDisabled ngDisabled}  | aria-disabled                                                                                       |
 * | {@link ng.directive:ngRequired ngRequired}  | aria-required                                                                                       |
 * | {@link ng.directive:ngChecked ngChecked}    | aria-checked                                                                                        |
 * | {@link ng.directive:ngReadonly ngReadonly}  | aria-readonly                                                                                       |
 * | {@link ng.directive:ngValue ngValue}        | aria-checked                                                                                        |
 * | {@link ng.directive:ngShow ngShow}          | aria-hidden                                                                                         |
 * | {@link ng.directive:ngHide ngHide}          | aria-hidden                                                                                         |
 * | {@link ng.directive:ngDblclick ngDblclick}  | tabindex                                                                                            |
 * | {@link module:ngMessages ngMessages}        | aria-live                                                                                           |
 * | {@link ng.directive:ngClick ngClick}        | tabindex, keydown event, button role                                                                |
 *
 * Find out more information about each directive by reading the
 * {@link guide/accessibility ngAria Developer Guide}.
 *
 * ## Example
 * Using ngDisabled with ngAria:
 * ```html
 * <md-checkbox ng-disabled="disabled">
 * ```
 * Becomes:
 * ```html
 * <md-checkbox ng-disabled="disabled" aria-disabled="true">
 * ```
 *
 * ## Disabling Specific Attributes
 * It is possible to disable individual attributes added by ngAria with the
 * {@link ngAria.$ariaProvider#config config} method. For more details, see the
 * {@link guide/accessibility Developer Guide}.
 *
 * ## Disabling `ngAria` on Specific Elements
 * It is possible to make `ngAria` ignore a specific element, by adding the `ng-aria-disable`
 * attribute on it. Note that only the element itself (and not its child elements) will be ignored.
 */
var ARIA_DISABLE_ATTR = 'ngAriaDisable';

var ngAriaModule = angular.module('ngAria', ['ng']).
                        info({ angularVersion: '1.8.3' }).
                        provider('$aria', $AriaProvider);

/**
* Internal Utilities
*/
var nativeAriaNodeNames = ['BUTTON', 'A', 'INPUT', 'TEXTAREA', 'SELECT', 'DETAILS', 'SUMMARY'];

var isNodeOneOf = function(elem, nodeTypeArray) {
  if (nodeTypeArray.indexOf(elem[0].nodeName) !== -1) {
    return true;
  }
};
/**
 * @ngdoc provider
 * @name $ariaProvider
 * @this
 *
 * @description
 *
 * Used for configuring the ARIA attributes injected and managed by ngAria.
 *
 * ```js
 * angular.module('myApp', ['ngAria'], function config($ariaProvider) {
 *   $ariaProvider.config({
 *     ariaValue: true,
 *     tabindex: false
 *   });
 * });
 *```
 *
 * ## Dependencies
 * Requires the {@link ngAria} module to be installed.
 *
 */
function $AriaProvider() {
  var config = {
    ariaHidden: true,
    ariaChecked: true,
    ariaReadonly: true,
    ariaDisabled: true,
    ariaRequired: true,
    ariaInvalid: true,
    ariaValue: true,
    tabindex: true,
    bindKeydown: true,
    bindRoleForClick: true
  };

  /**
   * @ngdoc method
   * @name $ariaProvider#config
   *
   * @param {object} config object to enable/disable specific ARIA attributes
   *
   *  - **ariaHidden** – `{boolean}` – Enables/disables aria-hidden tags
   *  - **ariaChecked** – `{boolean}` – Enables/disables aria-checked tags
   *  - **ariaReadonly** – `{boolean}` – Enables/disables aria-readonly tags
   *  - **ariaDisabled** – `{boolean}` – Enables/disables aria-disabled tags
   *  - **ariaRequired** – `{boolean}` – Enables/disables aria-required tags
   *  - **ariaInvalid** – `{boolean}` – Enables/disables aria-invalid tags
   *  - **ariaValue** – `{boolean}` – Enables/disables aria-valuemin, aria-valuemax and
   *    aria-valuenow tags
   *  - **tabindex** – `{boolean}` – Enables/disables tabindex tags
   *  - **bindKeydown** – `{boolean}` – Enables/disables keyboard event binding on non-interactive
   *    elements (such as `div` or `li`) using ng-click, making them more accessible to users of
   *    assistive technologies
   *  - **bindRoleForClick** – `{boolean}` – Adds role=button to non-interactive elements (such as
   *    `div` or `li`) using ng-click, making them more accessible to users of assistive
   *    technologies
   *
   * @description
   * Enables/disables various ARIA attributes
   */
  this.config = function(newConfig) {
    config = angular.extend(config, newConfig);
  };

  function watchExpr(attrName, ariaAttr, nativeAriaNodeNames, negate) {
    return function(scope, elem, attr) {
      if (attr.hasOwnProperty(ARIA_DISABLE_ATTR)) return;

      var ariaCamelName = attr.$normalize(ariaAttr);
      if (config[ariaCamelName] && !isNodeOneOf(elem, nativeAriaNodeNames) && !attr[ariaCamelName]) {
        scope.$watch(attr[attrName], function(boolVal) {
          // ensure boolean value
          boolVal = negate ? !boolVal : !!boolVal;
          elem.attr(ariaAttr, boolVal);
        });
      }
    };
  }
  /**
   * @ngdoc service
   * @name $aria
   *
   * @description
   *
   * The $aria service contains helper methods for applying common
   * [ARIA](http://www.w3.org/TR/wai-aria/) attributes to HTML directives.
   *
   * ngAria injects common accessibility attributes that tell assistive technologies when HTML
   * elements are enabled, selected, hidden, and more. To see how this is performed with ngAria,
   * let's review a code snippet from ngAria itself:
   *
   *```js
   * ngAriaModule.directive('ngDisabled', ['$aria', function($aria) {
   *   return $aria.$$watchExpr('ngDisabled', 'aria-disabled', nativeAriaNodeNames, false);
   * }])
   *```
   * Shown above, the ngAria module creates a directive with the same signature as the
   * traditional `ng-disabled` directive. But this ngAria version is dedicated to
   * solely managing accessibility attributes on custom elements. The internal `$aria` service is
   * used to watch the boolean attribute `ngDisabled`. If it has not been explicitly set by the
   * developer, `aria-disabled` is injected as an attribute with its value synchronized to the
   * value in `ngDisabled`.
   *
   * Because ngAria hooks into the `ng-disabled` directive, developers do not have to do
   * anything to enable this feature. The `aria-disabled` attribute is automatically managed
   * simply as a silent side-effect of using `ng-disabled` with the ngAria module.
   *
   * The full list of directives that interface with ngAria:
   * * **ngModel**
   * * **ngChecked**
   * * **ngReadonly**
   * * **ngRequired**
   * * **ngDisabled**
   * * **ngValue**
   * * **ngShow**
   * * **ngHide**
   * * **ngClick**
   * * **ngDblclick**
   * * **ngMessages**
   *
   * Read the {@link guide/accessibility ngAria Developer Guide} for a thorough explanation of each
   * directive.
   *
   *
   * ## Dependencies
   * Requires the {@link ngAria} module to be installed.
   */
  this.$get = function() {
    return {
      config: function(key) {
        return config[key];
      },
      $$watchExpr: watchExpr
    };
  };
}


ngAriaModule.directive('ngShow', ['$aria', function($aria) {
  return $aria.$$watchExpr('ngShow', 'aria-hidden', [], true);
}])
.directive('ngHide', ['$aria', function($aria) {
  return $aria.$$watchExpr('ngHide', 'aria-hidden', [], false);
}])
.directive('ngValue', ['$aria', function($aria) {
  return $aria.$$watchExpr('ngValue', 'aria-checked', nativeAriaNodeNames, false);
}])
.directive('ngChecked', ['$aria', function($aria) {
  return $aria.$$watchExpr('ngChecked', 'aria-checked', nativeAriaNodeNames, false);
}])
.directive('ngReadonly', ['$aria', function($aria) {
  return $aria.$$watchExpr('ngReadonly', 'aria-readonly', nativeAriaNodeNames, false);
}])
.directive('ngRequired', ['$aria', function($aria) {
  return $aria.$$watchExpr('ngRequired', 'aria-required', nativeAriaNodeNames, false);
}])
.directive('ngModel', ['$aria', function($aria) {

  function shouldAttachAttr(attr, normalizedAttr, elem, allowNonAriaNodes) {
    return $aria.config(normalizedAttr) &&
      !elem.attr(attr) &&
      (allowNonAriaNodes || !isNodeOneOf(elem, nativeAriaNodeNames)) &&
      (elem.attr('type') !== 'hidden' || elem[0].nodeName !== 'INPUT');
  }

  function shouldAttachRole(role, elem) {
    // if element does not have role attribute
    // AND element type is equal to role (if custom element has a type equaling shape) <-- remove?
    // AND element is not in nativeAriaNodeNames
    return !elem.attr('role') && (elem.attr('type') === role) && !isNodeOneOf(elem, nativeAriaNodeNames);
  }

  function getShape(attr, elem) {
    var type = attr.type,
        role = attr.role;

    return ((type || role) === 'checkbox' || role === 'menuitemcheckbox') ? 'checkbox' :
           ((type || role) === 'radio'    || role === 'menuitemradio') ? 'radio' :
           (type === 'range'              || role === 'progressbar' || role === 'slider') ? 'range' : '';
  }

  return {
    restrict: 'A',
    require: 'ngModel',
    priority: 200, //Make sure watches are fired after any other directives that affect the ngModel value
    compile: function(elem, attr) {
      if (attr.hasOwnProperty(ARIA_DISABLE_ATTR)) return;

      var shape = getShape(attr, elem);

      return {
        post: function(scope, elem, attr, ngModel) {
          var needsTabIndex = shouldAttachAttr('tabindex', 'tabindex', elem, false);

          function ngAriaWatchModelValue() {
            return ngModel.$modelValue;
          }

          function getRadioReaction(newVal) {
            // Strict comparison would cause a BC
            // eslint-disable-next-line eqeqeq
            var boolVal = (attr.value == ngModel.$viewValue);
            elem.attr('aria-checked', boolVal);
          }

          function getCheckboxReaction() {
            elem.attr('aria-checked', !ngModel.$isEmpty(ngModel.$viewValue));
          }

          switch (shape) {
            case 'radio':
            case 'checkbox':
              if (shouldAttachRole(shape, elem)) {
                elem.attr('role', shape);
              }
              if (shouldAttachAttr('aria-checked', 'ariaChecked', elem, false)) {
                scope.$watch(ngAriaWatchModelValue, shape === 'radio' ?
                    getRadioReaction : getCheckboxReaction);
              }
              if (needsTabIndex) {
                elem.attr('tabindex', 0);
              }
              break;
            case 'range':
              if (shouldAttachRole(shape, elem)) {
                elem.attr('role', 'slider');
              }
              if ($aria.config('ariaValue')) {
                var needsAriaValuemin = !elem.attr('aria-valuemin') &&
                    (attr.hasOwnProperty('min') || attr.hasOwnProperty('ngMin'));
                var needsAriaValuemax = !elem.attr('aria-valuemax') &&
                    (attr.hasOwnProperty('max') || attr.hasOwnProperty('ngMax'));
                var needsAriaValuenow = !elem.attr('aria-valuenow');

                if (needsAriaValuemin) {
                  attr.$observe('min', function ngAriaValueMinReaction(newVal) {
                    elem.attr('aria-valuemin', newVal);
                  });
                }
                if (needsAriaValuemax) {
                  attr.$observe('max', function ngAriaValueMinReaction(newVal) {
                    elem.attr('aria-valuemax', newVal);
                  });
                }
                if (needsAriaValuenow) {
                  scope.$watch(ngAriaWatchModelValue, function ngAriaValueNowReaction(newVal) {
                    elem.attr('aria-valuenow', newVal);
                  });
                }
              }
              if (needsTabIndex) {
                elem.attr('tabindex', 0);
              }
              break;
          }

          if (!attr.hasOwnProperty('ngRequired') && ngModel.$validators.required
            && shouldAttachAttr('aria-required', 'ariaRequired', elem, false)) {
            // ngModel.$error.required is undefined on custom controls
            attr.$observe('required', function() {
              elem.attr('aria-required', !!attr['required']);
            });
          }

          if (shouldAttachAttr('aria-invalid', 'ariaInvalid', elem, true)) {
            scope.$watch(function ngAriaInvalidWatch() {
              return ngModel.$invalid;
            }, function ngAriaInvalidReaction(newVal) {
              elem.attr('aria-invalid', !!newVal);
            });
          }
        }
      };
    }
  };
}])
.directive('ngDisabled', ['$aria', function($aria) {
  return $aria.$$watchExpr('ngDisabled', 'aria-disabled', nativeAriaNodeNames, false);
}])
.directive('ngMessages', function() {
  return {
    restrict: 'A',
    require: '?ngMessages',
    link: function(scope, elem, attr, ngMessages) {
      if (attr.hasOwnProperty(ARIA_DISABLE_ATTR)) return;

      if (!elem.attr('aria-live')) {
        elem.attr('aria-live', 'assertive');
      }
    }
  };
})
.directive('ngClick',['$aria', '$parse', function($aria, $parse) {
  return {
    restrict: 'A',
    compile: function(elem, attr) {
      if (attr.hasOwnProperty(ARIA_DISABLE_ATTR)) return;

      var fn = $parse(attr.ngClick);
      return function(scope, elem, attr) {

        if (!isNodeOneOf(elem, nativeAriaNodeNames)) {

          if ($aria.config('bindRoleForClick') && !elem.attr('role')) {
            elem.attr('role', 'button');
          }

          if ($aria.config('tabindex') && !elem.attr('tabindex')) {
            elem.attr('tabindex', 0);
          }

          if ($aria.config('bindKeydown') && !attr.ngKeydown && !attr.ngKeypress && !attr.ngKeyup) {
            elem.on('keydown', function(event) {
              var keyCode = event.which || event.keyCode;

              if (keyCode === 13 || keyCode === 32) {
                // If the event is triggered on a non-interactive element ...
                if (nativeAriaNodeNames.indexOf(event.target.nodeName) === -1 && !event.target.isContentEditable) {
                  // ... prevent the default browser behavior (e.g. scrolling when pressing spacebar)
                  // See https://github.com/angular/angular.js/issues/16664
                  event.preventDefault();
                }
                scope.$apply(callback);
              }

              function callback() {
                fn(scope, { $event: event });
              }
            });
          }
        }
      };
    }
  };
}])
.directive('ngDblclick', ['$aria', function($aria) {
  return function(scope, elem, attr) {
    if (attr.hasOwnProperty(ARIA_DISABLE_ATTR)) return;

    if ($aria.config('tabindex') && !elem.attr('tabindex') && !isNodeOneOf(elem, nativeAriaNodeNames)) {
      elem.attr('tabindex', 0);
    }
  };
}]);


})(window, window.angular);


/***/ }),
/* 925 */
/***/ (function(module, exports) {

/*!
 * AngularJS Material Design
 * https://github.com/angular/material
 * @license MIT
 * v1.2.5
 */
(function( window, angular, undefined ){
"use strict";

(function(){
"use strict";

angular.module('ngMaterial', ["ng","ngAnimate","ngAria","material.core","material.core.animate","material.core.gestures","material.core.interaction","material.core.layout","material.core.meta","material.core.theming.palette","material.core.theming","material.components.autocomplete","material.components.backdrop","material.components.bottomSheet","material.components.button","material.components.card","material.components.checkbox","material.components.chips","material.components.colors","material.components.content","material.components.datepicker","material.components.dialog","material.components.divider","material.components.fabActions","material.components.fabShared","material.components.fabSpeedDial","material.components.fabToolbar","material.components.gridList","material.components.icon","material.components.input","material.components.list","material.components.menu","material.components.menuBar","material.components.navBar","material.components.panel","material.components.progressCircular","material.components.progressLinear","material.components.radioButton","material.components.select","material.components.showHide","material.components.sidenav","material.components.slider","material.components.sticky","material.components.subheader","material.components.swipe","material.components.switch","material.components.tabs","material.components.toast","material.components.toolbar","material.components.tooltip","material.components.truncate","material.components.virtualRepeat","material.components.whiteframe"]);
})();
(function(){
"use strict";

/**
 * Initialization function that validates environment
 * requirements.
 */
DetectNgTouch.$inject = ["$log", "$injector"];
MdCoreConfigure.$inject = ["$provide", "$mdThemingProvider"];
rAFDecorator.$inject = ["$delegate"];
qDecorator.$inject = ["$delegate"];
angular
  .module('material.core', [
    'ngAnimate',
    'material.core.animate',
    'material.core.layout',
    'material.core.interaction',
    'material.core.gestures',
    'material.core.theming'
  ])
  .config(MdCoreConfigure)
  .run(DetectNgTouch);


/**
 * Detect if the ng-Touch module is also being used.
 * Warn if detected.
 * @ngInject
 */
function DetectNgTouch($log, $injector) {
  if ($injector.has('$swipe')) {
    var msg = "" +
      "You are using the ngTouch module. \n" +
      "AngularJS Material already has mobile click, tap, and swipe support... \n" +
      "ngTouch is not supported with AngularJS Material!";
    $log.warn(msg);
  }
}

/**
 * @ngInject
 */
function MdCoreConfigure($provide, $mdThemingProvider) {

  $provide.decorator('$$rAF', ['$delegate', rAFDecorator]);
  $provide.decorator('$q', ['$delegate', qDecorator]);

  $mdThemingProvider.theme('default')
    .primaryPalette('indigo')
    .accentPalette('pink')
    .warnPalette('deep-orange')
    .backgroundPalette('grey');
}

/**
 * @ngInject
 */
function rAFDecorator($delegate) {
  /**
   * Use this to throttle events that come in often.
   * The throttled function will always use the *last* invocation before the
   * coming frame.
   *
   * For example, window resize events that fire many times a second:
   * If we set to use an raf-throttled callback on window resize, then
   * our callback will only be fired once per frame, with the last resize
   * event that happened before that frame.
   *
   * @param {function} cb function to debounce
   */
  $delegate.throttle = function(cb) {
    var queuedArgs, alreadyQueued, queueCb, context;
    return function debounced() {
      queuedArgs = arguments;
      context = this;
      queueCb = cb;
      if (!alreadyQueued) {
        alreadyQueued = true;
        $delegate(function() {
          queueCb.apply(context, Array.prototype.slice.call(queuedArgs));
          alreadyQueued = false;
        });
      }
    };
  };
  return $delegate;
}

/**
 * @ngInject
 */
function qDecorator($delegate) {
  /**
   * Adds a shim for $q.resolve for AngularJS version that don't have it,
   * so we don't have to think about it.
   *
   * via https://github.com/angular/angular.js/pull/11987
   */

  // TODO(crisbeto): this won't be necessary once we drop AngularJS 1.3
  if (!$delegate.resolve) {
    $delegate.resolve = $delegate.when;
  }
  return $delegate;
}

})();
(function(){
"use strict";


MdAutofocusDirective.$inject = ["$parse"];angular.module('material.core')
  .directive('mdAutofocus', MdAutofocusDirective);

/**
 * @ngdoc directive
 * @name mdAutofocus
 * @module material.core.util
 *
 * @description
 *
 * `[md-autofocus]` provides an optional way to identify the focused element when a `$mdDialog`,
 * `$mdBottomSheet`, `$mdMenu` or `$mdSidenav` opens or upon page load for input-like elements.
 *
 * When one of these opens, it will find the first nested element with the `[md-autofocus]`
 * attribute directive and optional expression. An expression may be specified as the directive
 * value to enable conditional activation of the autofocus.
 *
 * @usage
 *
 * ### Dialog
 * <hljs lang="html">
 * <md-dialog>
 *   <form>
 *     <md-input-container>
 *       <label for="testInput">Label</label>
 *       <input id="testInput" type="text" md-autofocus>
 *     </md-input-container>
 *   </form>
 * </md-dialog>
 * </hljs>
 *
 * ### Bottomsheet
 * <hljs lang="html">
 * <md-bottom-sheet class="md-list md-has-header">
 *  <md-subheader>Comment Actions</md-subheader>
 *  <md-list>
 *    <md-list-item ng-repeat="item in items">
 *
 *      <md-button md-autofocus="$index == 2">
 *        <md-icon md-svg-src="{{item.icon}}"></md-icon>
 *        <span class="md-inline-list-icon-label">{{ item.name }}</span>
 *      </md-button>
 *
 *    </md-list-item>
 *  </md-list>
 * </md-bottom-sheet>
 * </hljs>
 *
 * ### Autocomplete
 * <hljs lang="html">
 *   <md-autocomplete
 *       md-autofocus
 *       md-selected-item="selectedItem"
 *       md-search-text="searchText"
 *       md-items="item in getMatches(searchText)"
 *       md-item-text="item.display">
 *     <span md-highlight-text="searchText">{{item.display}}</span>
 *   </md-autocomplete>
 * </hljs>
 *
 * ### Sidenav
 * <hljs lang="html">
 * <div layout="row" ng-controller="MyController">
 *   <md-sidenav md-component-id="left" class="md-sidenav-left">
 *     Left Nav!
 *   </md-sidenav>
 *
 *   <md-content>
 *     Center Content
 *     <md-button ng-click="openLeftMenu()">
 *       Open Left Menu
 *     </md-button>
 *   </md-content>
 *
 *   <md-sidenav md-component-id="right"
 *     md-is-locked-open="$mdMedia('min-width: 333px')"
 *     class="md-sidenav-right">
 *     <form>
 *       <md-input-container>
 *         <label for="testInput">Test input</label>
 *         <input id="testInput" type="text"
 *                ng-model="data" md-autofocus>
 *       </md-input-container>
 *     </form>
 *   </md-sidenav>
 * </div>
 * </hljs>
 **/
function MdAutofocusDirective($parse) {
  return {
    restrict: 'A',
    link: {
      pre: preLink
    }
  };

  function preLink(scope, element, attr) {
    var attrExp = attr.mdAutoFocus || attr.mdAutofocus || attr.mdSidenavFocus;

    // Initially update the expression by manually parsing the expression as per $watch source.
    updateExpression($parse(attrExp)(scope));

    // Only watch the expression if it is not empty.
    if (attrExp) {
      scope.$watch(attrExp, updateExpression);
    }

    /**
     * Updates the autofocus class which is used to determine whether the attribute
     * expression evaluates to true or false.
     * @param {string|boolean} value Attribute Value
     */
    function updateExpression(value) {

      // Rather than passing undefined to the jqLite toggle class function we explicitly set the
      // value to true. Otherwise the class will be just toggled instead of being forced.
      if (angular.isUndefined(value)) {
        value = true;
      }

      element.toggleClass('md-autofocus', !!value);
    }
  }

}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.core.colorUtil
 * @description
 * Color Util
 */
angular
  .module('material.core')
  .factory('$mdColorUtil', ColorUtilFactory);

function ColorUtilFactory() {
  /**
   * Converts hex value to RGBA string
   * @param color {string}
   * @returns {string}
   */
  function hexToRgba (color) {
    var hex   = color[ 0 ] === '#' ? color.substr(1) : color,
      dig   = hex.length / 3,
      red   = hex.substr(0, dig),
      green = hex.substr(dig, dig),
      blue  = hex.substr(dig * 2);
    if (dig === 1) {
      red += red;
      green += green;
      blue += blue;
    }
    return 'rgba(' + parseInt(red, 16) + ',' + parseInt(green, 16) + ',' + parseInt(blue, 16) + ',0.1)';
  }

  /**
   * Converts rgba value to hex string
   * @param {string} color
   * @returns {string}
   */
  function rgbaToHex(color) {
    color = color.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);

    var hex = (color && color.length === 4) ? "#" +
    ("0" + parseInt(color[1],10).toString(16)).slice(-2) +
    ("0" + parseInt(color[2],10).toString(16)).slice(-2) +
    ("0" + parseInt(color[3],10).toString(16)).slice(-2) : '';

    return hex.toUpperCase();
  }

  /**
   * Converts an RGB color to RGBA
   * @param {string} color
   * @returns {string}
   */
  function rgbToRgba (color) {
    return color.replace(')', ', 0.1)').replace('(', 'a(');
  }

  /**
   * Converts an RGBA color to RGB
   * @param {string} color
   * @returns {string}
   */
  function rgbaToRgb (color) {
    return color
      ? color.replace('rgba', 'rgb').replace(/,[^),]+\)/, ')')
      : 'rgb(0,0,0)';
  }

  return {
    rgbaToHex: rgbaToHex,
    hexToRgba: hexToRgba,
    rgbToRgba: rgbToRgba,
    rgbaToRgb: rgbaToRgb
  };
}

})();
(function(){
"use strict";

angular.module('material.core')
.factory('$mdConstant', MdConstantFactory);

/**
 * Factory function that creates the grab-bag $mdConstant service.
 * @ngInject
 */
function MdConstantFactory() {

  var prefixTestEl = document.createElement('div');
  var vendorPrefix = getVendorPrefix(prefixTestEl);
  var isWebkit = /webkit/i.test(vendorPrefix);
  var SPECIAL_CHARS_REGEXP = /([:\-_]+(.))/g;

  /**
   * @param {string} name CSS property name
   * @return {string} the property name supported by the browser
   */
  function vendorProperty(name) {
    // Add a dash between the prefix and name, to be able to transform the string into camelcase.
    var prefixedName = vendorPrefix + '-' + name;
    var ucPrefix = camelCase(prefixedName);
    var lcPrefix = ucPrefix.charAt(0).toLowerCase() + ucPrefix.substring(1);

    return hasStyleProperty(prefixTestEl, name)     ? name     :       // The current browser supports the un-prefixed property
           hasStyleProperty(prefixTestEl, ucPrefix) ? ucPrefix :       // The current browser only supports the prefixed property.
           hasStyleProperty(prefixTestEl, lcPrefix) ? lcPrefix : name; // Some browsers are only supporting the prefix in lowercase.
  }

  function hasStyleProperty(testElement, property) {
    return angular.isDefined(testElement.style[property]);
  }

  /**
   * @param {!string} input value to convert to camelCase
   * @return {string} camelCased version of the input string
   */
  function camelCase(input) {
    return input.replace(SPECIAL_CHARS_REGEXP, function(matches, separator, letter, offset) {
      return offset ? letter.toUpperCase() : letter;
    });
  }

  function getVendorPrefix(testElement) {
    var prop, match;
    var vendorRegex = /^(Moz|webkit|ms)(?=[A-Z])/;

    for (prop in testElement.style) {
      if (match = vendorRegex.exec(prop)) {
        return match[0];
      }
    }
  }

  var self = {
    isInputKey : function(e) { return (e.keyCode >= 31 && e.keyCode <= 90); },
    isNumPadKey : function(e) { return (3 === e.location && e.keyCode >= 97 && e.keyCode <= 105); },
    isMetaKey: function(e) { return (e.keyCode >= 91 && e.keyCode <= 93); },
    isFnLockKey: function(e) { return (e.keyCode >= 112 && e.keyCode <= 145); },
    isNavigationKey : function(e) {
      var kc = self.KEY_CODE, NAVIGATION_KEYS =  [kc.SPACE, kc.ENTER, kc.UP_ARROW, kc.DOWN_ARROW];
      return (NAVIGATION_KEYS.indexOf(e.keyCode) != -1);
    },
    hasModifierKey: function(e) {
      return e.ctrlKey || e.metaKey || e.altKey;
    },

    /**
     * Maximum size, in pixels, that can be explicitly set to an element. The actual value varies
     * between browsers, but IE11 has the very lowest size at a mere 1,533,917px. Ideally we could
     * compute this value, but Firefox always reports an element to have a size of zero if it
     * goes over the max, meaning that we'd have to binary search for the value.
     */
    ELEMENT_MAX_PIXELS: 1533917,

    /**
     * Priority for a directive that should run before the directives from ngAria.
     */
    BEFORE_NG_ARIA: 210,

    /**
     * Common Keyboard actions and their associated keycode.
     */
    KEY_CODE: {
      COMMA: 188,
      SEMICOLON : 186,
      ENTER: 13,
      ESCAPE: 27,
      SPACE: 32,
      PAGE_UP: 33,
      PAGE_DOWN: 34,
      END: 35,
      HOME: 36,
      LEFT_ARROW : 37,
      UP_ARROW : 38,
      RIGHT_ARROW : 39,
      DOWN_ARROW : 40,
      TAB : 9,
      BACKSPACE: 8,
      DELETE: 46
    },

    /**
     * Vendor prefixed CSS properties to be used to support the given functionality in older browsers
     * as well.
     */
    CSS: {
      /* Constants */
      TRANSITIONEND: 'transitionend' + (isWebkit ? ' webkitTransitionEnd' : ''),
      ANIMATIONEND: 'animationend' + (isWebkit ? ' webkitAnimationEnd' : ''),

      TRANSFORM: vendorProperty('transform'),
      TRANSFORM_ORIGIN: vendorProperty('transformOrigin'),
      TRANSITION: vendorProperty('transition'),
      TRANSITION_DURATION: vendorProperty('transitionDuration'),
      ANIMATION_PLAY_STATE: vendorProperty('animationPlayState'),
      ANIMATION_DURATION: vendorProperty('animationDuration'),
      ANIMATION_NAME: vendorProperty('animationName'),
      ANIMATION_TIMING: vendorProperty('animationTimingFunction'),
      ANIMATION_DIRECTION: vendorProperty('animationDirection')
    },

    /**
     * As defined in core/style/_variables.scss
     *
     * $layout-breakpoint-xs:     600px !default;
     * $layout-breakpoint-sm:     960px !default;
     * $layout-breakpoint-md:     1280px !default;
     * $layout-breakpoint-lg:     1920px !default;
     *
     */
    MEDIA: {
      'xs'        : '(max-width: 599px)'                         ,
      'gt-xs'     : '(min-width: 600px)'                         ,
      'sm'        : '(min-width: 600px) and (max-width: 959px)'  ,
      'gt-sm'     : '(min-width: 960px)'                         ,
      'md'        : '(min-width: 960px) and (max-width: 1279px)' ,
      'gt-md'     : '(min-width: 1280px)'                        ,
      'lg'        : '(min-width: 1280px) and (max-width: 1919px)',
      'gt-lg'     : '(min-width: 1920px)'                        ,
      'xl'        : '(min-width: 1920px)'                        ,
      'landscape' : '(orientation: landscape)'                   ,
      'portrait'  : '(orientation: portrait)'                    ,
      'print' : 'print'
    },

    MEDIA_PRIORITY: [
      'xl',
      'gt-lg',
      'lg',
      'gt-md',
      'md',
      'gt-sm',
      'sm',
      'gt-xs',
      'xs',
      'landscape',
      'portrait',
      'print'
    ]
  };

  return self;
}

})();
(function(){
"use strict";

  angular
    .module('material.core')
    .config(["$provide", function($provide){
       $provide.decorator('$mdUtil', ['$delegate', function ($delegate){
           /**
            * Inject the iterator facade to easily support iteration and accessors
            * @see iterator below
            */
           $delegate.iterator = MdIterator;

           return $delegate;
         }
       ]);
     }]);

  /**
   * iterator is a list facade to easily support iteration and accessors/
   *
   * @param {any[]} items Array list which this iterator will enumerate
   * @param {boolean=} reloop enables iterator to consider the list as an endless loop
   * @return {{add: add, next: (function()), last: (function(): any|null), previous: (function()), count: (function(): number), hasNext: (function(*=): Array.length|*|number|boolean), inRange: (function(*): boolean), remove: remove, contains: (function(*=): *|boolean), itemAt: (function(*=): any|null), findBy: (function(*, *): *[]), hasPrevious: (function(*=): Array.length|*|number|boolean), items: (function(): *[]), indexOf: (function(*=): number), first: (function(): any|null)}}
   * @constructor
   */
  function MdIterator(items, reloop) {
    var trueFn = function() { return true; };

    if (items && !angular.isArray(items)) {
      items = Array.prototype.slice.call(items);
    }

    reloop = !!reloop;
    var _items = items || [];

    // Published API
    return {
      items: getItems,
      count: count,

      inRange: inRange,
      contains: contains,
      indexOf: indexOf,
      itemAt: itemAt,

      findBy: findBy,

      add: add,
      remove: remove,

      first: first,
      last: last,
      next: angular.bind(null, findSubsequentItem, false),
      previous: angular.bind(null, findSubsequentItem, true),

      hasPrevious: hasPrevious,
      hasNext: hasNext
    };

    /**
     * Publish copy of the enumerable set
     * @returns {Array|*}
     */
    function getItems() {
      return [].concat(_items);
    }

    /**
     * Determine length of the list
     * @returns {Array.length|*|number}
     */
    function count() {
      return _items.length;
    }

    /**
     * Is the index specified valid
     * @param index
     * @returns {Array.length|*|number|boolean}
     */
    function inRange(index) {
      return _items.length && (index > -1) && (index < _items.length);
    }

    /**
     * Can the iterator proceed to the next item in the list; relative to
     * the specified item.
     *
     * @param item
     * @returns {Array.length|*|number|boolean}
     */
    function hasNext(item) {
      return item ? inRange(indexOf(item) + 1) : false;
    }

    /**
     * Can the iterator proceed to the previous item in the list; relative to
     * the specified item.
     *
     * @param item
     * @returns {Array.length|*|number|boolean}
     */
    function hasPrevious(item) {
      return item ? inRange(indexOf(item) - 1) : false;
    }

    /**
     * Get item at specified index/position
     * @param index
     * @returns {*}
     */
    function itemAt(index) {
      return inRange(index) ? _items[index] : null;
    }

    /**
     * Find all elements matching the key/value pair
     * otherwise return null
     *
     * @param val
     * @param key
     *
     * @return array
     */
    function findBy(key, val) {
      return _items.filter(function(item) {
        return item[key] === val;
      });
    }

    /**
     * Add item to list
     * @param item
     * @param index
     * @returns {*}
     */
    function add(item, index) {
      if (!item) return -1;

      if (!angular.isNumber(index)) {
        index = _items.length;
      }

      _items.splice(index, 0, item);

      return indexOf(item);
    }

    /**
     * Remove item from list...
     * @param item
     */
    function remove(item) {
      if (contains(item)){
        _items.splice(indexOf(item), 1);
      }
    }

    /**
     * Get the zero-based index of the target item
     * @param item
     * @returns {*}
     */
    function indexOf(item) {
      return _items.indexOf(item);
    }

    /**
     * Boolean existence check
     * @param item
     * @returns {boolean}
     */
    function contains(item) {
      return item && (indexOf(item) > -1);
    }

    /**
     * Return first item in the list
     * @returns {*}
     */
    function first() {
      return _items.length ? _items[0] : null;
    }

    /**
     * Return last item in the list...
     * @returns {*}
     */
    function last() {
      return _items.length ? _items[_items.length - 1] : null;
    }

    /**
     * Find the next item. If reloop is true and at the end of the list, it will go back to the
     * first item. If given, the `validate` callback will be used to determine whether the next item
     * is valid. If not valid, it will try to find the next item again.
     *
     * @param {boolean} backwards Specifies the direction of searching (forwards/backwards)
     * @param {*} item The item whose subsequent item we are looking for
     * @param {Function=} validate The `validate` function
     * @param {integer=} limit The recursion limit
     *
     * @returns {*} The subsequent item or null
     */
    function findSubsequentItem(backwards, item, validate, limit) {
      validate = validate || trueFn;

      var curIndex = indexOf(item);
      while (true) {
        if (!inRange(curIndex)) return null;

        var nextIndex = curIndex + (backwards ? -1 : 1);
        var foundItem = null;
        if (inRange(nextIndex)) {
          foundItem = _items[nextIndex];
        } else if (reloop) {
          foundItem = backwards ? last() : first();
          nextIndex = indexOf(foundItem);
        }

        if ((foundItem === null) || (nextIndex === limit)) return null;
        if (validate(foundItem)) return foundItem;

        if (angular.isUndefined(limit)) limit = nextIndex;

        curIndex = nextIndex;
      }
    }
  }


})();
(function(){
"use strict";


mdMediaFactory.$inject = ["$mdConstant", "$rootScope", "$window"];angular.module('material.core')
.factory('$mdMedia', mdMediaFactory);

/**
 * @ngdoc service
 * @name $mdMedia
 * @module material.core
 *
 * @description
 * `$mdMedia` is used to evaluate whether a given media query is true or false given the
 * current device's screen / window size. The media query will be re-evaluated on resize, allowing
 * you to register a watch.
 *
 * `$mdMedia` also has pre-programmed support for media queries that match the layout breakpoints:
 *
 *  <table class="md-api-table">
 *    <thead>
 *    <tr>
 *      <th>Breakpoint</th>
 *      <th>mediaQuery</th>
 *    </tr>
 *    </thead>
 *    <tbody>
 *    <tr>
 *      <td>xs</td>
 *      <td>(max-width: 599px)</td>
 *    </tr>
 *    <tr>
 *      <td>gt-xs</td>
 *      <td>(min-width: 600px)</td>
 *    </tr>
 *    <tr>
 *      <td>sm</td>
 *      <td>(min-width: 600px) and (max-width: 959px)</td>
 *    </tr>
 *    <tr>
 *      <td>gt-sm</td>
 *      <td>(min-width: 960px)</td>
 *    </tr>
 *    <tr>
 *      <td>md</td>
 *      <td>(min-width: 960px) and (max-width: 1279px)</td>
 *    </tr>
 *    <tr>
 *      <td>gt-md</td>
 *      <td>(min-width: 1280px)</td>
 *    </tr>
 *    <tr>
 *      <td>lg</td>
 *      <td>(min-width: 1280px) and (max-width: 1919px)</td>
 *    </tr>
 *    <tr>
 *      <td>gt-lg</td>
 *      <td>(min-width: 1920px)</td>
 *    </tr>
 *    <tr>
 *      <td>xl</td>
 *      <td>(min-width: 1920px)</td>
 *    </tr>
 *    <tr>
 *      <td>landscape</td>
 *      <td>landscape</td>
 *    </tr>
 *    <tr>
 *      <td>portrait</td>
 *      <td>portrait</td>
 *    </tr>
 *    <tr>
 *      <td>print</td>
 *      <td>print</td>
 *    </tr>
 *    </tbody>
 *  </table>
 *
 *  See Material Design's <a href="https://material.google.com/layout/responsive-ui.html">Layout - Adaptive UI</a> for more details.
 *
 *  <a href="https://material.io/archive/guidelines/layout/responsive-ui.html#">
 *  <img src="https://material-design.storage.googleapis.com/publish/material_v_4/material_ext_publish/0B8olV15J7abPSGFxemFiQVRtb1k/layout_adaptive_breakpoints_01.png" width="100%" height="100%"></img>
 *  </a>
 *
 * @returns {boolean} a boolean representing whether or not the given media query is true or false.
 *
 * @usage
 * <hljs lang="js">
 * app.controller('MyController', function($mdMedia, $scope) {
 *   $scope.$watch(function() { return $mdMedia('lg'); }, function(big) {
 *     $scope.bigScreen = big;
 *   });
 *
 *   $scope.screenIsSmall = $mdMedia('sm');
 *   $scope.customQuery = $mdMedia('(min-width: 1234px)');
 *   $scope.anotherCustom = $mdMedia('max-width: 300px');
 * });
 * </hljs>
 */

/* @ngInject */
function mdMediaFactory($mdConstant, $rootScope, $window) {
  var queries = {};
  var mqls = {};
  var results = {};
  var normalizeCache = {};

  $mdMedia.getResponsiveAttribute = getResponsiveAttribute;
  $mdMedia.getQuery = getQuery;
  $mdMedia.watchResponsiveAttributes = watchResponsiveAttributes;

  return $mdMedia;

  function $mdMedia(query) {
    var validated = queries[query];
    if (angular.isUndefined(validated)) {
      validated = queries[query] = validate(query);
    }

    var result = results[validated];
    if (angular.isUndefined(result)) {
      result = add(validated);
    }

    return result;
  }

  function validate(query) {
    return $mdConstant.MEDIA[query] ||
           ((query.charAt(0) !== '(') ? ('(' + query + ')') : query);
  }

  function add(query) {
    var result = mqls[query];
    if (!result) {
      result = mqls[query] = $window.matchMedia(query);
    }

    result.addListener(onQueryChange);
    return (results[result.media] = !!result.matches);
  }

  function onQueryChange(query) {
    $rootScope.$evalAsync(function() {
      results[query.media] = !!query.matches;
    });
  }

  function getQuery(name) {
    return mqls[name];
  }

  function getResponsiveAttribute(attrs, attrName) {
    for (var i = 0; i < $mdConstant.MEDIA_PRIORITY.length; i++) {
      var mediaName = $mdConstant.MEDIA_PRIORITY[i];
      if (!mqls[queries[mediaName]].matches) {
        continue;
      }

      var normalizedName = getNormalizedName(attrs, attrName + '-' + mediaName);
      if (attrs[normalizedName]) {
        return attrs[normalizedName];
      }
    }

    // fallback on unprefixed
    return attrs[getNormalizedName(attrs, attrName)];
  }

  function watchResponsiveAttributes(attrNames, attrs, watchFn) {
    var unwatchFns = [];
    attrNames.forEach(function(attrName) {
      var normalizedName = getNormalizedName(attrs, attrName);
      if (angular.isDefined(attrs[normalizedName])) {
        unwatchFns.push(
            attrs.$observe(normalizedName, angular.bind(void 0, watchFn, null)));
      }

      for (var mediaName in $mdConstant.MEDIA) {
        normalizedName = getNormalizedName(attrs, attrName + '-' + mediaName);
        if (angular.isDefined(attrs[normalizedName])) {
          unwatchFns.push(
              attrs.$observe(normalizedName, angular.bind(void 0, watchFn, mediaName)));
        }
      }
    });

    return function unwatch() {
      unwatchFns.forEach(function(fn) { fn(); });
    };
  }

  // Improves performance dramatically
  function getNormalizedName(attrs, attrName) {
    return normalizeCache[attrName] ||
        (normalizeCache[attrName] = attrs.$normalize(attrName));
  }
}

})();
(function(){
"use strict";

angular
  .module('material.core')
  .config(["$provide", function($provide) {
    $provide.decorator('$mdUtil', ['$delegate', function ($delegate) {

      // Inject the prefixer into our original $mdUtil service.
      $delegate.prefixer = MdPrefixer;

      return $delegate;
    }]);
  }]);

/**
 * @param {string|string[]} initialAttributes
 * @param {boolean} buildSelector
 * @return {string|string[]|{buildSelector: (function(string|string[]): string),
 *   buildList: (function(string|string[]): string[]),
 *   hasAttribute: (function(JQLite|Element, string): HTMLElement),
 *   removeAttribute: (function(JQLite|Element, string): void)}}
 * @constructor
 */
function MdPrefixer(initialAttributes, buildSelector) {
  var PREFIXES = ['data', 'x'];

  if (initialAttributes) {
    // The prefixer also accepts attributes as a parameter, and immediately builds a list or selector for
    // the specified attributes.
    return buildSelector ? _buildSelector(initialAttributes) : _buildList(initialAttributes);
  }

  return {
    buildList: _buildList,
    buildSelector: _buildSelector,
    hasAttribute: _hasAttribute,
    removeAttribute: _removeAttribute
  };

  function _buildList(attributes) {
    attributes = angular.isArray(attributes) ? attributes : [attributes];

    attributes.forEach(function(item) {
      PREFIXES.forEach(function(prefix) {
        attributes.push(prefix + '-' + item);
      });
    });

    return attributes;
  }

  function _buildSelector(attributes) {
    attributes = angular.isArray(attributes) ? attributes : [attributes];

    return _buildList(attributes)
      .map(function(item) {
        return '[' + item + ']';
      })
      .join(',');
  }

  function _hasAttribute(element, attribute) {
    element = _getNativeElement(element);

    if (!element) {
      return false;
    }

    var prefixedAttrs = _buildList(attribute);

    for (var i = 0; i < prefixedAttrs.length; i++) {
      if (element.hasAttribute(prefixedAttrs[i])) {
        return true;
      }
    }

    return false;
  }

  function _removeAttribute(element, attribute) {
    element = _getNativeElement(element);

    if (!element) {
      return;
    }

    _buildList(attribute).forEach(function(prefixedAttribute) {
      element.removeAttribute(prefixedAttribute);
    });
  }

  /**
   * Transforms a jqLite or DOM element into a HTML element.
   * This is useful when supporting jqLite elements and DOM elements at
   * same time.
   * @param element {JQLite|Element} Element to be parsed
   * @returns {HTMLElement} Parsed HTMLElement
   */
  function _getNativeElement(element) {
    element =  element[0] || element;

    if (element.nodeType) {
      return element;
    }
  }

}

})();
(function(){
"use strict";

/*
 * This var has to be outside the angular factory, otherwise when
 * there are multiple material apps on the same page, each app
 * will create its own instance of this array and the app's IDs
 * will not be unique.
 */
UtilFactory.$inject = ["$document", "$timeout", "$compile", "$rootScope", "$$mdAnimate", "$interpolate", "$log", "$rootElement", "$window", "$$rAF"];
var nextUniqueId = 0, isIos, isAndroid, isFirefox;

// Support material-tools builds.
if (window.navigator) {
  var userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
  isIos = userAgent.match(/ipad|iphone|ipod/i);
  isAndroid = userAgent.match(/android/i);
  isFirefox = userAgent.match(/(firefox|minefield)/i);
}

/**
 * @ngdoc module
 * @name material.core.util
 * @description
 * Util
 */
angular
.module('material.core')
.factory('$mdUtil', UtilFactory);

/**
 * @ngInject
 */
function UtilFactory($document, $timeout, $compile, $rootScope, $$mdAnimate, $interpolate, $log,
                     $rootElement, $window, $$rAF) {
  // Setup some core variables for the processTemplate method
  var startSymbol = $interpolate.startSymbol(),
    endSymbol = $interpolate.endSymbol(),
    usesStandardSymbols = ((startSymbol === '{{') && (endSymbol === '}}'));

  // Polyfill document.contains for IE11.
  document.contains || (document.contains = function (node) {
    return document.body.contains(node);
  });

  /**
   * Checks if the target element has the requested style by key
   * @param {DOMElement|JQLite} target Target element
   * @param {string} key Style key
   * @param {string=} expectedVal Optional expected value
   * @returns {boolean} Whether the target element has the style or not
   */
  var hasComputedStyle = function (target, key, expectedVal) {
    var hasValue = false;

    if (target && target.length) {
      var computedStyles = $window.getComputedStyle(target[0]);
      hasValue = angular.isDefined(computedStyles[key]) &&
        (expectedVal ? computedStyles[key] == expectedVal : true);
    }

    return hasValue;
  };

  function validateCssValue(value) {
    return !value ? '0' :
      hasPx(value) || hasPercent(value) ? value : value + 'px';
  }

  function hasPx(value) {
    return String(value).indexOf('px') > -1;
  }

  function hasPercent(value) {
    return String(value).indexOf('%') > -1;
  }

  var $mdUtil = {
    dom: {},
    isIos: isIos,
    isAndroid: isAndroid,
    now: window.performance && window.performance.now ?
      angular.bind(window.performance, window.performance.now) : Date.now || function() {
      return new Date().getTime();
    },

    /**
     * Cross-version compatibility method to retrieve an option of a ngModel controller,
     * which supports the breaking changes in the AngularJS snapshot (SHA 87a2ff76af5d0a9268d8eb84db5755077d27c84c).
     * @param {!ngModel.NgModelController} ngModelCtrl
     * @param {!string} optionName
     * @returns {string|number|boolean|Object|undefined}
     */
    getModelOption: function (ngModelCtrl, optionName) {
      if (!ngModelCtrl.$options) {
        return;
      }

      var $options = ngModelCtrl.$options;

      // The newer versions of AngularJS introduced a getOption function and made the option values
      // no longer visible on the $options object.
      return $options.getOption ? $options.getOption(optionName) : $options[optionName];
    },

    /**
     * Determines the current 'dir'ectional value based on the value of 'dir'
     * attribute of the element. If that is not defined, it will try to use
     * a 'dir' attribute of the body or html tag.
     *
     * @param {Object=} attrs a hash object with key-value pairs of normalized
     *     attribute names and their corresponding attribute values.
     * @returns {boolean} true if the element's passed in attributes,
     *     the document, or the body indicates RTL mode, false otherwise.
     */
    isRtl: function(attrs) {
      var dir = angular.isDefined(attrs) && attrs.hasOwnProperty('dir') && attrs.dir;

      switch (dir) {
        case 'ltr':
          return false;

        case 'rtl':
          return true;
      }

      return ($document[0].dir === 'rtl' || $document[0].body.dir === 'rtl');
    },

    /**
     * Bi-directional accessor/mutator used to easily update an element's
     * property based on the current 'dir'ectional value.
     */
    bidi: function(element, property, lValue, rValue) {
      var ltr = !this.isRtl();

      // If accessor
      if (arguments.length == 0) return ltr ? 'ltr' : 'rtl';

      // If mutator
      var elem = angular.element(element);

      if (ltr && angular.isDefined(lValue)) {
        elem.css(property, validateCssValue(lValue));
      }
      else if (!ltr && angular.isDefined(rValue)) {
        elem.css(property, validateCssValue(rValue));
      }
    },

    bidiProperty: function (element, lProperty, rProperty, value) {
      var ltr = !this.isRtl();

      var elem = angular.element(element);

      if (ltr && angular.isDefined(lProperty)) {
        elem.css(lProperty, validateCssValue(value));
        elem.css(rProperty, '');
      }
      else if (!ltr && angular.isDefined(rProperty)) {
        elem.css(rProperty, validateCssValue(value));
        elem.css(lProperty, '');
      }
    },

    clientRect: function(element, offsetParent, isOffsetRect) {
      var node = getNode(element);
      offsetParent = getNode(offsetParent || node.offsetParent || document.body);
      var nodeRect = node.getBoundingClientRect();

      // The user can ask for an offsetRect: a rect relative to the offsetParent,
      // or a clientRect: a rect relative to the page
      var offsetRect = isOffsetRect ?
        offsetParent.getBoundingClientRect() :
        {left: 0, top: 0, width: 0, height: 0};
      return {
        left: nodeRect.left - offsetRect.left,
        top: nodeRect.top - offsetRect.top,
        width: nodeRect.width,
        height: nodeRect.height
      };
    },
    offsetRect: function(element, offsetParent) {
      return $mdUtil.clientRect(element, offsetParent, true);
    },

    /**
     * Annoying method to copy nodes to an array, thanks to IE.
     * @param nodes
     * @return {Array}
     */
    nodesToArray: function(nodes) {
      var results = [], i;
      nodes = nodes || [];

      for (i = 0; i < nodes.length; ++i) {
        results.push(nodes.item(i));
      }
      return results;
    },

    /**
     * Determines the absolute position of the viewport.
     * Useful when making client rectangles absolute.
     * @returns {number}
     */
    getViewportTop: function() {
      // If body scrolling is disabled, then use the cached viewport top value, otherwise get it
      // fresh from the $window.
      if ($mdUtil.disableScrollAround._count && $mdUtil.disableScrollAround._viewPortTop) {
        return $mdUtil.disableScrollAround._viewPortTop;
      } else {
        return $window.scrollY || $window.pageYOffset || 0;
      }
    },

    /**
     * Finds the proper focus target by searching the DOM.
     *
     * @param {!JQLite} containerEl
     * @param {string=} attributeVal
     * @returns {JQLite|undefined}
     */
    findFocusTarget: function(containerEl, attributeVal) {
      var AUTO_FOCUS = this.prefixer('md-autofocus', true);
      var elToFocus;

      elToFocus = scanForFocusable(containerEl, attributeVal || AUTO_FOCUS);

      // Scan for fallback to 'universal' API
      if (!elToFocus) {
        elToFocus = scanForFocusable(containerEl, AUTO_FOCUS);
      }

      return elToFocus;

      /**
       * Can target and nested children for specified Selector (attribute)
       * whose value may be an expression that evaluates to True/False.
       * @param {!JQLite} target
       * @param {!string} selector
       * @return {JQLite|undefined}
       */
      function scanForFocusable(target, selector) {
        var elFound, items = target[0].querySelectorAll(selector);

        // Find the last child element with the focus attribute
        if (items && items.length) {
          items.length && angular.forEach(items, function(it) {
            it = angular.element(it);

            // Check the element for the md-autofocus class to ensure any associated expression
            // evaluated to true.
            var isFocusable = it.hasClass('md-autofocus');
            if (isFocusable) elFound = it;
          });
        }
        return elFound;
      }
    },

    /**
     * Disables scroll around the passed parent element.
     * @param {Element|JQLite=} element Origin Element (not used)
     * @param {Element|JQLite=} parent Element to disable scrolling within.
     *   Defaults to body if none supplied.
     * @param {Object=} options Object of options to modify functionality
     *   - disableScrollMask Boolean of whether or not to create a scroll mask element or
     *     use the passed parent element.
     */
    disableScrollAround: function(element, parent, options) {
      options = options || {};

      $mdUtil.disableScrollAround._count = Math.max(0, $mdUtil.disableScrollAround._count || 0);
      $mdUtil.disableScrollAround._count++;

      if ($mdUtil.disableScrollAround._restoreScroll) {
        return $mdUtil.disableScrollAround._restoreScroll;
      }

      var body = $document[0].body;
      var restoreBody = disableBodyScroll();
      var restoreElement = disableElementScroll(parent, options);

      return $mdUtil.disableScrollAround._restoreScroll = function() {
        if (--$mdUtil.disableScrollAround._count <= 0) {
          delete $mdUtil.disableScrollAround._viewPortTop;
          restoreBody();
          restoreElement();
          delete $mdUtil.disableScrollAround._restoreScroll;
        }
      };

      /**
       * Creates a virtual scrolling mask to prevent touchmove, keyboard, scrollbar clicking,
       * and wheel events.
       * @param {!Element|!JQLite} elementToDisable
       * @param {Object=} scrollMaskOptions Object of options to modify functionality
       *   - disableScrollMask Boolean of whether or not to create a scroll mask element or
       *     use the passed parent element.
       * @returns {Function}
       */
      function disableElementScroll(elementToDisable, scrollMaskOptions) {
        var scrollMask;
        var wrappedElementToDisable = angular.element(elementToDisable || body);

        if (scrollMaskOptions.disableScrollMask) {
          scrollMask = wrappedElementToDisable;
        } else {
          scrollMask = angular.element(
            '<div class="md-scroll-mask">' +
            '  <div class="md-scroll-mask-bar"></div>' +
            '</div>');
          wrappedElementToDisable.append(scrollMask);
        }

        /**
         * @param {Event} $event
         */
        function preventDefault($event) {
          $event.preventDefault();
        }

        scrollMask.on('wheel touchmove', preventDefault);

        return function restoreElementScroll() {
          scrollMask.off('wheel touchmove', preventDefault);

          if (!scrollMaskOptions.disableScrollMask && scrollMask[0].parentNode) {
            scrollMask[0].parentNode.removeChild(scrollMask[0]);
          }
        };
      }

      // Converts the body to a position fixed block and translate it to the proper scroll position
      function disableBodyScroll() {
        var documentElement = $document[0].documentElement;

        var prevDocumentStyle = documentElement.style.cssText || '';
        var prevBodyStyle = body.style.cssText || '';

        var viewportTop = $mdUtil.getViewportTop();
        $mdUtil.disableScrollAround._viewPortTop = viewportTop;
        var clientWidth = body.clientWidth;
        var hasVerticalScrollbar = body.scrollHeight > body.clientHeight + 1;

        // Scroll may be set on <html> element (for example by overflow-y: scroll)
        // but Chrome is reporting the scrollTop position always on <body>.
        // scrollElement will allow to restore the scrollTop position to proper target.
        var scrollElement = documentElement.scrollTop > 0 ? documentElement : body;

        if (hasVerticalScrollbar) {
          angular.element(body).css({
            position: 'fixed',
            width: '100%',
            top: -viewportTop + 'px'
          });
        }

        if (body.clientWidth < clientWidth) {
          body.style.overflow = 'hidden';
        }

        return function restoreScroll() {
          // Reset the inline style CSS to the previous.
          body.style.cssText = prevBodyStyle;
          documentElement.style.cssText = prevDocumentStyle;

          // The scroll position while being fixed
          scrollElement.scrollTop = viewportTop;
        };
      }

    },

    enableScrolling: function() {
      var restoreFn = this.disableScrollAround._restoreScroll;
      restoreFn && restoreFn();
    },

    floatingScrollbars: function() {
      if (this.floatingScrollbars.cached === undefined) {
        var tempNode = angular.element('<div><div></div></div>').css({
          width: '100%',
          'z-index': -1,
          position: 'absolute',
          height: '35px',
          'overflow-y': 'scroll'
        });
        tempNode.children().css('height', '60px');

        $document[0].body.appendChild(tempNode[0]);
        this.floatingScrollbars.cached =
          (tempNode[0].offsetWidth === tempNode[0].childNodes[0].offsetWidth);
        tempNode.remove();
      }
      return this.floatingScrollbars.cached;
    },

    /**
     * Mobile safari only allows you to set focus in click event listeners.
     * @param {Element|JQLite} element to focus
     */
    forceFocus: function(element) {
      var node = element[0] || element;

      document.addEventListener('click', function focusOnClick(ev) {
        if (ev.target === node && ev.$focus) {
          node.focus();
          ev.stopImmediatePropagation();
          ev.preventDefault();
          node.removeEventListener('click', focusOnClick);
        }
      }, true);

      var newEvent = document.createEvent('MouseEvents');
      newEvent.initMouseEvent('click', false, true, window, {}, 0, 0, 0, 0,
        false, false, false, false, 0, null);
      newEvent.$material = true;
      newEvent.$focus = true;
      node.dispatchEvent(newEvent);
    },

    /**
     * facade to build md-backdrop element with desired styles
     * NOTE: Use $compile to trigger backdrop postLink function
     */
    createBackdrop: function(scope, addClass) {
      return $compile($mdUtil.supplant('<md-backdrop class="{0}">', [addClass]))(scope);
    },

    /**
     * supplant() method from Crockford's `Remedial Javascript`
     * Equivalent to use of $interpolate; without dependency on
     * interpolation symbols and scope. Note: the '{<token>}' can
     * be property names, property chains, or array indices.
     */
    supplant: function(template, values, pattern) {
      pattern = pattern || /\{([^{}]*)\}/g;
      return template.replace(pattern, function(a, b) {
        var p = b.split('.'),
          r = values;
        try {
          for (var s in p) {
            if (p.hasOwnProperty(s)) {
              r = r[p[s]];
            }
          }
        } catch (e) {
          r = a;
        }
        return (typeof r === 'string' || typeof r === 'number') ? r : a;
      });
    },

    fakeNgModel: function() {
      return {
        $fake: true,
        $setTouched: angular.noop,
        $setViewValue: function(value) {
          this.$viewValue = value;
          this.$render(value);
          this.$viewChangeListeners.forEach(function(cb) {
            cb();
          });
        },
        $isEmpty: function(value) {
          return ('' + value).length === 0;
        },
        $parsers: [],
        $formatters: [],
        $viewChangeListeners: [],
        $render: angular.noop
      };
    },

    /**
     * @param {Function} func original function to be debounced
     * @param {number} wait number of milliseconds to delay (since last debounce reset).
     *  Default value 10 msecs.
     * @param {Object} scope in which to apply the function after debouncing ends
     * @param {boolean} invokeApply should the $timeout trigger $digest() dirty checking
     * @return {Function} A function, that, as long as it continues to be invoked, will not be
     *  triggered. The function will be called after it stops being called for N milliseconds.
     */
    debounce: function(func, wait, scope, invokeApply) {
      var timer;

      return function debounced() {
        var context = scope,
            args = Array.prototype.slice.call(arguments);

        $timeout.cancel(timer);
        timer = $timeout(function() {

          timer = undefined;
          func.apply(context, args);

        }, wait || 10, invokeApply);
      };
    },

    /**
     * The function will not be called unless it has been more than `delay` milliseconds since the
     * last call.
     * @param {Function} func original function to throttle
     * @param {number} delay number of milliseconds to delay
     * @return {Function} a function that can only be triggered every `delay` milliseconds.
     */
    throttle: function throttle(func, delay) {
      var recent;
      return function throttled() {
        var context = this;
        var args = arguments;
        var now = $mdUtil.now();

        if (!recent || (now - recent > delay)) {
          func.apply(context, args);
          recent = now;
        }
      };
    },

    /**
     * Measures the number of milliseconds taken to run the provided callback
     * function. Uses a high-precision timer if available.
     */
    time: function time(cb) {
      var start = $mdUtil.now();
      cb();
      return $mdUtil.now() - start;
    },

    /**
     * Create an implicit getter that caches its `getter()`
     * lookup value
     */
    valueOnUse : function (scope, key, getter) {
      var value = null, args = Array.prototype.slice.call(arguments);
      var params = (args.length > 3) ? args.slice(3) : [];

      Object.defineProperty(scope, key, {
        get: function () {
          if (value === null) value = getter.apply(scope, params);
          return value;
        }
      });
    },

    /**
     * Get a unique ID.
     *
     * @returns {string} an unique numeric string
     */
    nextUid: function() {
      return '' + nextUniqueId++;
    },

    /**
     * Stop watchers and events from firing on a scope without destroying it,
     * by disconnecting it from its parent and its siblings' linked lists.
     * @param {Object} scope to disconnect
     */
    disconnectScope: function disconnectScope(scope) {
      if (!scope) return;

      // we can't destroy the root scope or a scope that has been already destroyed
      if (scope.$root === scope) return;
      if (scope.$$destroyed) return;

      var parent = scope.$parent;
      scope.$$disconnected = true;

      // See Scope.$destroy
      if (parent.$$childHead === scope) parent.$$childHead = scope.$$nextSibling;
      if (parent.$$childTail === scope) parent.$$childTail = scope.$$prevSibling;
      if (scope.$$prevSibling) scope.$$prevSibling.$$nextSibling = scope.$$nextSibling;
      if (scope.$$nextSibling) scope.$$nextSibling.$$prevSibling = scope.$$prevSibling;

      scope.$$nextSibling = scope.$$prevSibling = null;

    },

    /**
     * Undo the effects of disconnectScope().
     * @param {Object} scope to reconnect
     */
    reconnectScope: function reconnectScope(scope) {
      if (!scope) return;

      // we can't disconnect the root node or scope already disconnected
      if (scope.$root === scope) return;
      if (!scope.$$disconnected) return;

      var child = scope;

      var parent = child.$parent;
      child.$$disconnected = false;
      // See Scope.$new for this logic...
      child.$$prevSibling = parent.$$childTail;
      if (parent.$$childHead) {
        parent.$$childTail.$$nextSibling = child;
        parent.$$childTail = child;
      } else {
        parent.$$childHead = parent.$$childTail = child;
      }
    },

    /**
     * Get an element's siblings matching a given tag name.
     *
     * @param {JQLite|angular.element|HTMLElement} element Element to start walking the DOM from
     * @param {string} tagName HTML tag name to match against
     * @returns {Object[]} JQLite
     */
    getSiblings: function getSiblings(element, tagName) {
      var upperCasedTagName = tagName.toUpperCase();
      if (element instanceof angular.element) {
        element = element[0];
      }
      var siblings = Array.prototype.filter.call(element.parentNode.children, function(node) {
        return element !== node && node.tagName.toUpperCase() === upperCasedTagName;
      });
      return siblings.map(function (sibling) {
        return angular.element(sibling);
      });
    },

    /**
     * getClosest replicates jQuery.closest() to walk up the DOM tree until it finds a matching
     * nodeName.
     *
     * @param {Node} el Element to start walking the DOM from
     * @param {string|function} validateWith If a string is passed, it will be evaluated against
     * each of the parent nodes' tag name. If a function is passed, the loop will call it with each
     * of the parents and will use the return value to determine whether the node is a match.
     * @param {boolean=} onlyParent Only start checking from the parent element, not `el`.
     * @returns {Node|null} closest matching parent Node or null if not found
     */
    getClosest: function getClosest(el, validateWith, onlyParent) {
      if (angular.isString(validateWith)) {
        var tagName = validateWith.toUpperCase();
        validateWith = function(el) {
          return el.nodeName.toUpperCase() === tagName;
        };
      }

      if (el instanceof angular.element) el = el[0];
      if (onlyParent) el = el.parentNode;
      if (!el) return null;

      do {
        if (validateWith(el)) {
          return el;
        }
      } while (el = el.parentNode);

      return null;
    },

    /**
     * Build polyfill for the Node.contains feature (if needed)
     * @param {Node} node
     * @param {Node} child
     * @returns {Node}
     */
    elementContains: function(node, child) {
      var hasContains = (window.Node && window.Node.prototype && Node.prototype.contains);
      var findFn = hasContains ? angular.bind(node, node.contains) : angular.bind(node, function(arg) {
        // compares the positions of two nodes and returns a bitmask
        return (node === child) || !!(this.compareDocumentPosition(arg) & 16);
      });

      return findFn(child);
    },

    /**
     * Functional equivalent for $element.filter(‘md-bottom-sheet’)
     * useful with interimElements where the element and its container are important...
     *
     * @param {JQLite} element to scan
     * @param {string} nodeName of node to find (e.g. 'md-dialog')
     * @param {boolean=} scanDeep optional flag to allow deep scans; defaults to 'false'.
     * @param {boolean=} warnNotFound optional flag to enable log warnings; defaults to false
     */
    extractElementByName: function(element, nodeName, scanDeep, warnNotFound) {
      var found = scanTree(element);
      if (!found && !!warnNotFound) {
        $log.warn($mdUtil.supplant("Unable to find node '{0}' in element '{1}'.",[nodeName, element[0].outerHTML]));
      }

      return angular.element(found || element);

      /**
       * Breadth-First tree scan for element with matching `nodeName`
       */
      function scanTree(element) {
        return scanLevel(element) || (scanDeep ? scanChildren(element) : null);
      }

      /**
       * Case-insensitive scan of current elements only (do not descend).
       */
      function scanLevel(element) {
        if (element) {
          for (var i = 0, len = element.length; i < len; i++) {
            if (element[i].nodeName.toLowerCase() === nodeName) {
              return element[i];
            }
          }
        }
        return null;
      }

      /**
       * Scan children of specified node
       */
      function scanChildren(element) {
        var found;
        if (element) {
          for (var i = 0, len = element.length; i < len; i++) {
            var target = element[i];
            if (!found) {
              for (var j = 0, numChild = target.childNodes.length; j < numChild; j++) {
                found = found || scanTree([target.childNodes[j]]);
              }
            }
          }
        }
        return found;
      }

    },

    /**
     * Give optional properties with no value a boolean true if attr provided or false otherwise
     */
    initOptionalProperties: function(scope, attr, defaults) {
      defaults = defaults || {};
      angular.forEach(scope.$$isolateBindings, function(binding, key) {
        if (binding.optional && angular.isUndefined(scope[key])) {
          var attrIsDefined = angular.isDefined(attr[binding.attrName]);
          scope[key] = angular.isDefined(defaults[key]) ? defaults[key] : attrIsDefined;
        }
      });
    },

    /**
     * Alternative to $timeout calls with 0 delay.
     * nextTick() coalesces all calls within a single frame
     * to minimize $digest thrashing
     *
     * @param {Function} callback function to be called after the tick
     * @param {boolean=} digest true to call $rootScope.$digest() after callback
     * @param {Object=} scope associated with callback. If the scope is destroyed, the callback will
     *  be skipped.
     * @returns {*}
     */
    nextTick: function(callback, digest, scope) {
      // grab function reference for storing state details
      var nextTick = $mdUtil.nextTick;
      var timeout = nextTick.timeout;
      var queue = nextTick.queue || [];

      // add callback to the queue
      queue.push({scope: scope, callback: callback});

      // set default value for digest
      if (digest == null) digest = true;

      // store updated digest/queue values
      nextTick.digest = nextTick.digest || digest;
      nextTick.queue = queue;

      // either return existing timeout or create a new one
      return timeout || (nextTick.timeout = $timeout(processQueue, 0, false));

      /**
       * Grab a copy of the current queue
       * Clear the queue for future use
       * Process the existing queue
       * Trigger digest if necessary
       */
      function processQueue() {
        var queue = nextTick.queue;
        var digest = nextTick.digest;

        nextTick.queue = [];
        nextTick.timeout = null;
        nextTick.digest = false;

        queue.forEach(function(queueItem) {
          var skip = queueItem.scope && queueItem.scope.$$destroyed;
          if (!skip) {
            queueItem.callback();
          }
        });

        if (digest) $rootScope.$digest();
      }
    },

    /**
     * Processes a template and replaces the start/end symbols if the application has
     * overridden them.
     *
     * @param template The template to process whose start/end tags may be replaced.
     * @returns {*}
     */
    processTemplate: function(template) {
      if (usesStandardSymbols) {
        return template;
      } else {
        if (!template || !angular.isString(template)) return template;
        return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
      }
    },

    /**
     * Scan up dom hierarchy for enabled parent;
     */
    getParentWithPointerEvents: function (element) {
      var parent = element.parent();

      // jqLite might return a non-null, but still empty, parent; so check for parent and length
      while (hasComputedStyle(parent, 'pointer-events', 'none')) {
        parent = parent.parent();
      }

      return parent;
    },

    getNearestContentElement: function (element) {
      var current = element.parent()[0];
      // Look for the nearest parent md-content, stopping at the rootElement.
      while (current && current !== $rootElement[0] && current !== document.body && current.nodeName.toUpperCase() !== 'MD-CONTENT') {
        current = current.parentNode;
      }
      return current;
    },

    /**
     * Checks if the current browser is natively supporting the `sticky` position.
     * @returns {string} supported sticky property name
     */
    checkStickySupport: function() {
      var stickyProp;
      var testEl = angular.element('<div>');
      $document[0].body.appendChild(testEl[0]);

      var stickyProps = ['sticky', '-webkit-sticky'];
      for (var i = 0; i < stickyProps.length; ++i) {
        testEl.css({
          position: stickyProps[i],
          top: 0,
          'z-index': 2
        });

        if (testEl.css('position') == stickyProps[i]) {
          stickyProp = stickyProps[i];
          break;
        }
      }

      testEl.remove();

      return stickyProp;
    },

    /**
     * Parses an attribute value, mostly a string.
     * By default checks for negated values and returns `false´ if present.
     * Negated values are: (native falsy) and negative strings like:
     * `false` or `0`.
     * @param value Attribute value which should be parsed.
     * @param negatedCheck When set to false, won't check for negated values.
     * @returns {boolean}
     */
    parseAttributeBoolean: function(value, negatedCheck) {
      return value === '' || !!value && (negatedCheck === false || value !== 'false' && value !== '0');
    },

    hasComputedStyle: hasComputedStyle,

    /**
     * Returns true if the parent form of the element has been submitted.
     * @param element An AngularJS or HTML5 element.
     * @returns {boolean}
     */
    isParentFormSubmitted: function(element) {
      var parent = $mdUtil.getClosest(element, 'form');
      var form = parent ? angular.element(parent).controller('form') : null;

      return form ? form.$submitted : false;
    },

    /**
     * Animate the requested element's scrollTop to the requested scrollPosition with basic easing.
     * @param {!Element} element The element to scroll.
     * @param {number} scrollEnd The new/final scroll position.
     * @param {number=} duration Duration of the scroll. Default is 1000ms.
     */
    animateScrollTo: function(element, scrollEnd, duration) {
      var scrollStart = element.scrollTop;
      var scrollChange = scrollEnd - scrollStart;
      var scrollingDown = scrollStart < scrollEnd;
      var startTime = $mdUtil.now();

      $$rAF(scrollChunk);

      function scrollChunk() {
        var newPosition = calculateNewPosition();

        element.scrollTop = newPosition;

        if (scrollingDown ? newPosition < scrollEnd : newPosition > scrollEnd) {
          $$rAF(scrollChunk);
        }
      }

      function calculateNewPosition() {
        var easeDuration = duration || 1000;
        var currentTime = $mdUtil.now() - startTime;

        return ease(currentTime, scrollStart, scrollChange, easeDuration);
      }

      function ease(currentTime, start, change, duration) {
        // If the duration has passed (which can occur if our app loses focus due to $$rAF), jump
        // straight to the proper position
        if (currentTime > duration) {
          return start + change;
        }

        var ts = (currentTime /= duration) * currentTime;
        var tc = ts * currentTime;

        return start + change * (-2 * tc + 3 * ts);
      }
    },

    /**
     * Provides an easy mechanism for removing duplicates from an array.
     *
     *    var myArray = [1, 2, 2, 3, 3, 3, 4, 4, 4, 4];
     *
     *    $mdUtil.uniq(myArray) => [1, 2, 3, 4]
     *
     * @param {Array} array The array whose unique values should be returned.
     * @returns {Array|void} A copy of the array containing only unique values.
     */
    uniq: function(array) {
      if (!array) { return; }

      return array.filter(function(value, index, self) {
        return self.indexOf(value) === index;
      });
    },

    /**
     * Gets the inner HTML content of the given HTMLElement.
     * Only intended for use with SVG or Symbol elements in IE11.
     * @param {Element} element
     * @returns {string} the inner HTML of the element passed in
     */
    getInnerHTML: function(element) {
      // For SVG or Symbol elements, innerHTML returns `undefined` in IE.
      // Reference: https://stackoverflow.com/q/28129956/633107
      // The XMLSerializer API is supported on IE11 and is the recommended workaround.
      var serializer = new XMLSerializer();

      return Array.prototype.map.call(element.childNodes, function (child) {
        return serializer.serializeToString(child);
      }).join('');
    },

    /**
     * Gets the outer HTML content of the given HTMLElement.
     * Only intended for use with SVG or Symbol elements in IE11.
     * @param {Element} element
     * @returns {string} the outer HTML of the element passed in
     */
    getOuterHTML: function(element) {
      // For SVG or Symbol elements, outerHTML returns `undefined` in IE.
      // Reference: https://stackoverflow.com/q/29888050/633107
      // The XMLSerializer API is supported on IE11 and is the recommended workaround.
      var serializer = new XMLSerializer();
      return serializer.serializeToString(element);
    },

    /**
     * Support: IE 9-11 only
     * documentMode is an IE-only property
     * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
     */
    msie: window.document.documentMode,

    getTouchAction: function() {
      var testEl = document.createElement('div');
      var vendorPrefixes = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];

      for (var i = 0; i < vendorPrefixes.length; i++) {
        var prefix = vendorPrefixes[i];
        var property = prefix ? prefix + 'TouchAction' : 'touchAction';
        if (angular.isDefined(testEl.style[property])) {
          return property;
        }
      }
    },

    /**
     * @param {Event} event the event to calculate the bubble path for
     * @return {EventTarget[]} the set of nodes that this event could bubble up to
     */
    getEventPath: function(event) {
      var path = [];
      var currentTarget = event.target;
      while (currentTarget) {
        path.push(currentTarget);
        currentTarget = currentTarget.parentElement;
      }
      if (path.indexOf(window) === -1 && path.indexOf(document) === -1)
        path.push(document);
      if (path.indexOf(window) === -1)
        path.push(window);
      return path;
    },

    /**
     * Gets the string the user has entered and removes Regex identifiers
     * @param {string} term
     * @returns {string} sanitized string
     */
    sanitize: function(term) {
      if (!term) return term;
      return term.replace(/[\\^$*+?.()|{}[]/g, '\\$&');
    },

    /**********************************************************************************************
     * The following functions were sourced from
     * https://github.com/angular/components/blob/3c37e4b1c1cb74a3d0a90d173240fc730d21d9d4/src/cdk/a11y/interactivity-checker/interactivity-checker.ts
     **********************************************************************************************/

    /**
     * Gets whether an element is disabled.
     * @param {HTMLElement} element Element to be checked.
     * @returns {boolean} Whether the element is disabled.
     */
    isDisabled: function(element) {
      // This does not capture some cases, such as a non-form control with a disabled attribute or
      // a form control inside of a disabled form, but should capture the most common cases.
      return element.hasAttribute('disabled');
    },

    /**
     * Gets whether an element is visible for the purposes of interactivity.
     *
     * This will capture states like `display: none` and `visibility: hidden`, but not things like
     * being clipped by an `overflow: hidden` parent or being outside the viewport.
     *
     * @param {HTMLElement} element
     * @returns {boolean} Whether the element is visible.
     */
    isVisible: function(element) {
      return $mdUtil.hasGeometry(element) && getComputedStyle(element).visibility === 'visible';
    },

    /**
     * Gets whether an element can be reached via Tab key.
     * Assumes that the element has already been checked with isFocusable.
     * @param {HTMLElement} element Element to be checked.
     * @returns {boolean} Whether the element is tabbable.
     */
    isTabbable: function(element) {
      var frameElement = $mdUtil.getFrameElement($mdUtil.getWindow(element));

      if (frameElement) {
        // Frame elements inherit their tabindex onto all child elements.
        if ($mdUtil.getTabIndexValue(frameElement) === -1) {
          return false;
        }

        // Browsers disable tabbing to an element inside of an invisible frame.
        if (!$mdUtil.isVisible(frameElement)) {
          return false;
        }
      }

      var nodeName = element.nodeName.toLowerCase();
      var tabIndexValue = $mdUtil.getTabIndexValue(element);

      if (element.hasAttribute('contenteditable')) {
        return tabIndexValue !== -1;
      }

      if (nodeName === 'iframe' || nodeName === 'object') {
        // The frame or object's content may be tabbable depending on the content, but it's
        // not possibly to reliably detect the content of the frames. We always consider such
        // elements as non-tabbable.
        return false;
      }

      // In iOS, the browser only considers some specific elements as tabbable.
      if (isIos && !$mdUtil.isPotentiallyTabbableIOS(element)) {
        return false;
      }

      if (nodeName === 'audio') {
        // Audio elements without controls enabled are never tabbable, regardless
        // of the tabindex attribute explicitly being set.
        if (!element.hasAttribute('controls')) {
          return false;
        }
        // Audio elements with controls are by default tabbable unless the
        // tabindex attribute is set to `-1` explicitly.
        return tabIndexValue !== -1;
      }

      if (nodeName === 'video') {
        // For all video elements, if the tabindex attribute is set to `-1`, the video
        // is not tabbable. Note: We cannot rely on the default `HTMLElement.tabIndex`
        // property as that one is set to `-1` in Chrome, Edge and Safari v13.1. The
        // tabindex attribute is the source of truth here.
        if (tabIndexValue === -1) {
          return false;
        }
        // If the tabindex is explicitly set, and not `-1` (as per check before), the
        // video element is always tabbable (regardless of whether it has controls or not).
        if (tabIndexValue !== null) {
          return true;
        }
        // Otherwise (when no explicit tabindex is set), a video is only tabbable if it
        // has controls enabled. Firefox is special as videos are always tabbable regardless
        // of whether there are controls or not.
        return isFirefox || element.hasAttribute('controls');
      }

      return element.tabIndex >= 0;
    },

    /**
     * Gets whether an element can be focused by the user.
     * @param {HTMLElement} element Element to be checked.
     * @returns {boolean} Whether the element is focusable.
     */
    isFocusable: function(element) {
      // Perform checks in order of left to most expensive.
      // Again, naive approach that does not capture many edge cases and browser quirks.
      return $mdUtil.isPotentiallyFocusable(element) && !$mdUtil.isDisabled(element) &&
        $mdUtil.isVisible(element);
    },

    /**
     * Gets whether an element is potentially focusable without taking current visible/disabled
     * state into account.
     * @param {HTMLElement} element
     * @returns {boolean}
     */
    isPotentiallyFocusable: function(element) {
      // Inputs are potentially focusable *unless* they're type="hidden".
      if ($mdUtil.isHiddenInput(element)) {
        return false;
      }

      return $mdUtil.isNativeFormElement(element) ||
        $mdUtil.isAnchorWithHref(element) ||
        element.hasAttribute('contenteditable') ||
        $mdUtil.hasValidTabIndex(element);
    },

    /**
     * Checks whether the specified element is potentially tabbable on iOS.
     * @param {HTMLElement} element
     * @returns {boolean}
     */
    isPotentiallyTabbableIOS: function(element) {
      var nodeName = element.nodeName.toLowerCase();
        var inputType = nodeName === 'input' && element.type;

      return inputType === 'text'
        || inputType === 'password'
        || nodeName === 'select'
        || nodeName === 'textarea';
    },

    /**
     * Returns the parsed tabindex from the element attributes instead of returning the
     * evaluated tabindex from the browsers defaults.
     * @param {HTMLElement} element
     * @returns {null|number}
     */
    getTabIndexValue: function(element) {
      if (!$mdUtil.hasValidTabIndex(element)) {
        return null;
      }

      // See browser issue in Gecko https://bugzilla.mozilla.org/show_bug.cgi?id=1128054
      var tabIndex = parseInt(element.getAttribute('tabindex') || '', 10);

      return isNaN(tabIndex) ? -1 : tabIndex;
    },

    /**
     * Gets whether an element has a valid tabindex.
     * @param {HTMLElement} element
     * @returns {boolean}
     */
    hasValidTabIndex: function(element) {
      if (!element.hasAttribute('tabindex') || element.tabIndex === undefined) {
        return false;
      }

      var tabIndex = element.getAttribute('tabindex');

      // IE11 parses tabindex="" as the value "-32768"
      if (tabIndex == '-32768') {
        return false;
      }

      return !!(tabIndex && !isNaN(parseInt(tabIndex, 10)));
    },

    /**
     * Checks whether the specified element has any geometry / rectangles.
     * @param {HTMLElement} element
     * @returns {boolean}
     */
    hasGeometry: function(element) {
      // Use logic from jQuery to check for an invisible element.
      // See https://github.com/jquery/jquery/blob/8969732518470a7f8e654d5bc5be0b0076cb0b87/src/css/hiddenVisibleSelectors.js#L9
      return !!(element.offsetWidth || element.offsetHeight ||
        (typeof element.getClientRects === 'function' && element.getClientRects().length));
    },

    /**
     * Returns the frame element from a window object. Since browsers like MS Edge throw errors if
     * the frameElement property is being accessed from a different host address, this property
     * should be accessed carefully.
     * @param {Window} window
     * @returns {null|HTMLElement}
     */
    getFrameElement: function(window) {
      try {
        return window.frameElement;
      } catch (error) {
        return null;
      }
    },

    /**
     * Gets the parent window of a DOM node with regards of being inside of an iframe.
     * @param {HTMLElement} node
     * @returns {Window}
     */
    getWindow: function(node) {
      // ownerDocument is null if `node` itself *is* a document.
      return node.ownerDocument && node.ownerDocument.defaultView || window;
    },

    /**
     * Gets whether an element's
     * @param {Node} element
     * @returns {boolean}
     */
    isNativeFormElement: function(element) {
      var nodeName = element.nodeName.toLowerCase();
      return nodeName === 'input' ||
        nodeName === 'select' ||
        nodeName === 'button' ||
        nodeName === 'textarea';
    },

    /**
     * Gets whether an element is an `<input type="hidden">`.
     * @param {HTMLElement} element
     * @returns {boolean}
     */
    isHiddenInput: function(element) {
      return $mdUtil.isInputElement(element) && element.type == 'hidden';
    },

    /**
     * Gets whether an element is an anchor that has an href attribute.
     * @param {HTMLElement} element
     * @returns {boolean}
     */
    isAnchorWithHref: function(element) {
      return $mdUtil.isAnchorElement(element) && element.hasAttribute('href');
    },

    /**
     * Gets whether an element is an input element.
     * @param {HTMLElement} element
     * @returns {boolean}
     */
    isInputElement: function(element) {
      return element.nodeName.toLowerCase() == 'input';
    },

    /**
     * Gets whether an element is an anchor element.
     * @param {HTMLElement} element
     * @returns {boolean}
     */
    isAnchorElement: function(element) {
      return element.nodeName.toLowerCase() == 'a';
    },

    /**********************************************************************************************
     * The following two functions were sourced from
     * https://github.com/angular/components/blob/3c37e4b1c1cb74a3d0a90d173240fc730d21d9d4/src/cdk/a11y/focus-trap/focus-trap.ts#L268-L311
     **********************************************************************************************/

    /**
     * Get the first tabbable element from a DOM subtree (inclusive).
     * @param {HTMLElement} root
     * @returns {HTMLElement|null}
     */
    getFirstTabbableElement: function(root) {
      if ($mdUtil.isFocusable(root) && $mdUtil.isTabbable(root)) {
        return root;
      }

      // Iterate in DOM order. Note that IE doesn't have `children` for SVG so we fall
      // back to `childNodes` which includes text nodes, comments etc.
      var children = root.children || root.childNodes;

      for (var i = 0; i < children.length; i++) {
        var tabbableChild = children[i].nodeType === $document[0].ELEMENT_NODE ?
          $mdUtil.getFirstTabbableElement(children[i]) : null;

        if (tabbableChild) {
          return tabbableChild;
        }
      }

      return null;
    },

    /**
     * Get the last tabbable element from a DOM subtree (inclusive).
     * @param {HTMLElement} root
     * @returns {HTMLElement|null}
     */
    getLastTabbableElement: function(root) {
      if ($mdUtil.isFocusable(root) && $mdUtil.isTabbable(root)) {
        return root;
      }

      // Iterate in reverse DOM order.
      var children = root.children || root.childNodes;

      for (var i = children.length - 1; i >= 0; i--) {
        var tabbableChild = children[i].nodeType === $document[0].ELEMENT_NODE ?
          $mdUtil.getLastTabbableElement(children[i]) : null;

        if (tabbableChild) {
          return tabbableChild;
        }
      }

      return null;
    }
  };

  // Instantiate other namespace utility methods

  $mdUtil.dom.animator = $$mdAnimate($mdUtil);

  return $mdUtil;

  function getNode(el) {
    return el[0] || el;
  }
}

/**
 * Since removing jQuery from the demos, some code that uses `element.focus()` is broken.
 * We need to add `element.focus()`, because it's testable unlike `element[0].focus`.
 */
angular.element.prototype.focus = angular.element.prototype.focus || function() {
  if (this.length) {
    this[0].focus();
  }
  return this;
};

angular.element.prototype.blur = angular.element.prototype.blur || function() {
  if (this.length) {
    this[0].blur();
  }
  return this;
};

})();
(function(){
"use strict";

// Polyfill angular < 1.4 (provide $animateCss)
angular
  .module('material.core')
  .factory('$$mdAnimate', ["$q", "$timeout", "$mdConstant", "$animateCss", function($q, $timeout, $mdConstant, $animateCss) {
     // Since $$mdAnimate is injected into $mdUtil... use a wrapper function
     // to subsequently inject $mdUtil as an argument to the AnimateDomUtils
     return function($mdUtil) {
       return AnimateDomUtils($mdUtil, $q, $timeout, $mdConstant, $animateCss);
     };
   }]);

/**
 * Factory function that requires special injections
 */
function AnimateDomUtils($mdUtil, $q, $timeout, $mdConstant, $animateCss) {
  var self;
  return self = {
    translate3d : function(target, from, to, options) {
      return $animateCss(target, {
        from: from,
        to: to,
        addClass: options.transitionInClass,
        removeClass: options.transitionOutClass,
        duration: options.duration
      })
      .start()
      .then(function() {
          // Resolve with reverser function...
          return reverseTranslate;
      });

      /**
       * Specific reversal of the request translate animation above...
       */
      function reverseTranslate (newFrom) {
        return $animateCss(target, {
           to: newFrom || from,
           addClass: options.transitionOutClass,
           removeClass: options.transitionInClass,
           duration: options.duration
        }).start();
      }
    },

    /**
     * Listen for transitionEnd event (with optional timeout)
     * Announce completion or failure via promise handlers
     */
    waitTransitionEnd: function (element, opts) {
      var TIMEOUT = 3000; // fallback is 3 secs

      return $q(function(resolve, reject){
        opts = opts || { };

        // If there is no transition is found, resolve immediately
        //
        // NOTE: using $mdUtil.nextTick() causes delays/issues
        if (noTransitionFound(opts.cachedTransitionStyles)) {
          TIMEOUT = 0;
        }

        var timer = $timeout(finished, opts.timeout || TIMEOUT);
        element.on($mdConstant.CSS.TRANSITIONEND, finished);

        /**
         * Upon timeout or transitionEnd, reject or resolve (respectively) this promise.
         * NOTE: Make sure this transitionEnd didn't bubble up from a child
         */
        function finished(ev) {
          if (ev && ev.target !== element[0]) return;

          if (ev) $timeout.cancel(timer);
          element.off($mdConstant.CSS.TRANSITIONEND, finished);

          // Never reject since ngAnimate may cause timeouts due missed transitionEnd events
          resolve();
        }

        /**
         * Checks whether or not there is a transition.
         *
         * @param styles The cached styles to use for the calculation. If null, getComputedStyle()
         * will be used.
         *
         * @returns {boolean} True if there is no transition/duration; false otherwise.
         */
        function noTransitionFound(styles) {
          styles = styles || window.getComputedStyle(element[0]);

          return styles.transitionDuration === '0s' ||
            (!styles.transition && !styles.transitionProperty);
        }
      });
    },

    calculateTransformValues: function (element, originator) {
      var origin = originator.element;
      var bounds = originator.bounds;

      if (origin || bounds) {
        var originBnds = origin ? self.clientRect(origin) || currentBounds() : self.copyRect(bounds);
        var dialogRect = self.copyRect(element[0].getBoundingClientRect());
        var dialogCenterPt = self.centerPointFor(dialogRect);
        var originCenterPt = self.centerPointFor(originBnds);

        return {
          centerX: originCenterPt.x - dialogCenterPt.x,
          centerY: originCenterPt.y - dialogCenterPt.y,
          scaleX: Math.round(100 * Math.min(0.5, originBnds.width / dialogRect.width)) / 100,
          scaleY: Math.round(100 * Math.min(0.5, originBnds.height / dialogRect.height)) / 100
        };
      }
      return {centerX: 0, centerY: 0, scaleX: 0.5, scaleY: 0.5};

      /**
       * This is a fallback if the origin information is no longer valid, then the
       * origin bounds simply becomes the current bounds for the dialogContainer's parent.
       * @returns {null|DOMRect}
       */
      function currentBounds() {
        var container = element ? element.parent() : null;
        var parent = container ? container.parent() : null;

        return parent ? self.clientRect(parent) : null;
      }
    },

    /**
     * Calculate the zoom transform from dialog to origin.
     *
     * We use this to set the dialog position immediately;
     * then the md-transition-in actually translates back to
     * `translate3d(0,0,0) scale(1.0)`...
     *
     * NOTE: all values are rounded to the nearest integer
     */
    calculateZoomToOrigin: function (element, originator) {
      var zoomTemplate = "translate3d( {centerX}px, {centerY}px, 0 ) scale( {scaleX}, {scaleY} )";
      var buildZoom = angular.bind(null, $mdUtil.supplant, zoomTemplate);

      return buildZoom(self.calculateTransformValues(element, originator));
    },

    /**
     * Calculate the slide transform from panel to origin.
     * NOTE: all values are rounded to the nearest integer
     */
    calculateSlideToOrigin: function (element, originator) {
      var slideTemplate = "translate3d( {centerX}px, {centerY}px, 0 )";
      var buildSlide = angular.bind(null, $mdUtil.supplant, slideTemplate);

      return buildSlide(self.calculateTransformValues(element, originator));
    },

    /**
     * Enhance raw values to represent valid css stylings...
     */
    toCss : function(raw) {
      var css = { };
      var lookups = 'left top right bottom width height x y min-width min-height max-width max-height';

      angular.forEach(raw, function(value,key) {
        if (angular.isUndefined(value)) return;

        if (lookups.indexOf(key) >= 0) {
          css[key] = value + 'px';
        } else {
          switch (key) {
            case 'transition':
              convertToVendor(key, $mdConstant.CSS.TRANSITION, value);
              break;
            case 'transform':
              convertToVendor(key, $mdConstant.CSS.TRANSFORM, value);
              break;
            case 'transformOrigin':
              convertToVendor(key, $mdConstant.CSS.TRANSFORM_ORIGIN, value);
              break;
            case 'font-size':
              css['font-size'] = value; // font sizes aren't always in px
              break;
          }
        }
      });

      return css;

      function convertToVendor(key, vendor, value) {
        angular.forEach(vendor.split(' '), function (key) {
          css[key] = value;
        });
      }
    },

    /**
     * Convert the translate CSS value to key/value pair(s).
     * @param {string} transform
     * @param {boolean=} addTransition
     * @param {string=} transition
     * @return {Object} object containing CSS translate key/value pair(s)
     */
    toTransformCss: function (transform, addTransition, transition) {
      var css = {};
      angular.forEach($mdConstant.CSS.TRANSFORM.split(' '), function (key) {
        css[key] = transform;
      });

      if (addTransition) {
        transition = transition || "all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1) !important";
        css.transition = transition;
      }

      return css;
    },

    /**
     * Clone the Rect and calculate the height/width if needed.
     * @param {DOMRect} source
     * @param {DOMRect=} destination
     * @returns {null|DOMRect}
     */
    copyRect: function (source, destination) {
      if (!source) return null;

      destination = destination || {};

      angular.forEach('left top right bottom width height'.split(' '), function (key) {
        destination[key] = Math.round(source[key]);
      });

      destination.width = destination.width || (destination.right - destination.left);
      destination.height = destination.height || (destination.bottom - destination.top);

      return destination;
    },

    /**
     * Calculate ClientRect of element; return null if hidden or zero size.
     * @param {Element|string} element
     * @returns {null|DOMRect}
     */
    clientRect: function (element) {
      var bounds = angular.element(element)[0].getBoundingClientRect();
      var isPositiveSizeClientRect = function (rect) {
        return rect && (rect.width > 0) && (rect.height > 0);
      };

      // If the event origin element has zero size, it has probably been hidden.
      return isPositiveSizeClientRect(bounds) ? self.copyRect(bounds) : null;
    },

    /**
     * Calculate 'rounded' center point of Rect
     * @param {DOMRect} targetRect
     * @returns {{x: number, y: number}}
     */
    centerPointFor: function (targetRect) {
      return targetRect ? {
        x: Math.round(targetRect.left + (targetRect.width / 2)),
        y: Math.round(targetRect.top + (targetRect.height / 2))
      } : { x : 0, y : 0 };
    }
  };
}


})();
(function(){
"use strict";

if (angular.version.minor >= 4) {
  angular.module('material.core.animate', []);
} else {
(function() {
  "use strict";

  var forEach = angular.forEach;

  var WEBKIT = angular.isDefined(document.documentElement.style.WebkitAppearance);
  var TRANSITION_PROP = WEBKIT ? 'WebkitTransition' : 'transition';
  var ANIMATION_PROP = WEBKIT ? 'WebkitAnimation' : 'animation';
  var PREFIX = WEBKIT ? '-webkit-' : '';

  var TRANSITION_EVENTS = (WEBKIT ? 'webkitTransitionEnd ' : '') + 'transitionend';
  var ANIMATION_EVENTS = (WEBKIT ? 'webkitAnimationEnd ' : '') + 'animationend';

  var $$ForceReflowFactory = ['$document', function($document) {
    return function() {
      return $document[0].body.clientWidth + 1;
    };
  }];

  var $$rAFMutexFactory = ['$$rAF', function($$rAF) {
    return function() {
      var passed = false;
      $$rAF(function() {
        passed = true;
      });
      return function(fn) {
        passed ? fn() : $$rAF(fn);
      };
    };
  }];

  var $$AnimateRunnerFactory = ['$q', '$$rAFMutex', function($q, $$rAFMutex) {
    var INITIAL_STATE = 0;
    var DONE_PENDING_STATE = 1;
    var DONE_COMPLETE_STATE = 2;

    function AnimateRunner(host) {
      this.setHost(host);

      this._doneCallbacks = [];
      this._runInAnimationFrame = $$rAFMutex();
      this._state = 0;
    }

    AnimateRunner.prototype = {
      setHost: function(host) {
        this.host = host || {};
      },

      done: function(fn) {
        if (this._state === DONE_COMPLETE_STATE) {
          fn();
        } else {
          this._doneCallbacks.push(fn);
        }
      },

      progress: angular.noop,

      getPromise: function() {
        if (!this.promise) {
          var self = this;
          this.promise = $q(function(resolve, reject) {
            self.done(function(status) {
              status === false ? reject() : resolve();
            });
          });
        }
        return this.promise;
      },

      then: function(resolveHandler, rejectHandler) {
        return this.getPromise().then(resolveHandler, rejectHandler);
      },

      'catch': function(handler) {
        return this.getPromise()['catch'](handler);
      },

      'finally': function(handler) {
        return this.getPromise()['finally'](handler);
      },

      pause: function() {
        if (this.host.pause) {
          this.host.pause();
        }
      },

      resume: function() {
        if (this.host.resume) {
          this.host.resume();
        }
      },

      end: function() {
        if (this.host.end) {
          this.host.end();
        }
        this._resolve(true);
      },

      cancel: function() {
        if (this.host.cancel) {
          this.host.cancel();
        }
        this._resolve(false);
      },

      complete: function(response) {
        var self = this;
        if (self._state === INITIAL_STATE) {
          self._state = DONE_PENDING_STATE;
          self._runInAnimationFrame(function() {
            self._resolve(response);
          });
        }
      },

      _resolve: function(response) {
        if (this._state !== DONE_COMPLETE_STATE) {
          forEach(this._doneCallbacks, function(fn) {
            fn(response);
          });
          this._doneCallbacks.length = 0;
          this._state = DONE_COMPLETE_STATE;
        }
      }
    };

    // Polyfill AnimateRunner.all which is used by input animations
    AnimateRunner.all = function(runners, callback) {
      var count = 0;
      var status = true;
      forEach(runners, function(runner) {
        runner.done(onProgress);
      });

      function onProgress(response) {
        status = status && response;
        if (++count === runners.length) {
          callback(status);
        }
      }
    };

    return AnimateRunner;
  }];

  angular
    .module('material.core.animate', [])
    .factory('$$forceReflow', $$ForceReflowFactory)
    .factory('$$AnimateRunner', $$AnimateRunnerFactory)
    .factory('$$rAFMutex', $$rAFMutexFactory)
    .factory('$animateCss', ['$window', '$$rAF', '$$AnimateRunner', '$$forceReflow', '$$jqLite', '$timeout', '$animate',
                     function($window,   $$rAF,   $$AnimateRunner,   $$forceReflow,   $$jqLite,   $timeout, $animate) {

      function init(element, options) {

        var temporaryStyles = [];
        var node = getDomNode(element);
        var areAnimationsAllowed = node && $animate.enabled();

        var hasCompleteStyles = false;
        var hasCompleteClasses = false;

        if (areAnimationsAllowed) {
          if (options.transitionStyle) {
            temporaryStyles.push([PREFIX + 'transition', options.transitionStyle]);
          }

          if (options.keyframeStyle) {
            temporaryStyles.push([PREFIX + 'animation', options.keyframeStyle]);
          }

          if (options.delay) {
            temporaryStyles.push([PREFIX + 'transition-delay', options.delay + 's']);
          }

          if (options.duration) {
            temporaryStyles.push([PREFIX + 'transition-duration', options.duration + 's']);
          }

          hasCompleteStyles = options.keyframeStyle ||
              (options.to && (options.duration > 0 || options.transitionStyle));
          hasCompleteClasses = !!options.addClass || !!options.removeClass;

          blockTransition(element, true);
        }

        var hasCompleteAnimation = areAnimationsAllowed && (hasCompleteStyles || hasCompleteClasses);

        applyAnimationFromStyles(element, options);

        var animationClosed = false;
        var events, eventFn;

        return {
          close: $window.close,
          start: function() {
            var runner = new $$AnimateRunner();
            waitUntilQuiet(function() {
              blockTransition(element, false);
              if (!hasCompleteAnimation) {
                return close();
              }

              forEach(temporaryStyles, function(entry) {
                var key = entry[0];
                var value = entry[1];
                node.style[camelCase(key)] = value;
              });

              applyClasses(element, options);

              var timings = computeTimings(element);
              if (timings.duration === 0) {
                return close();
              }

              var moreStyles = [];

              if (options.easing) {
                if (timings.transitionDuration) {
                  moreStyles.push([PREFIX + 'transition-timing-function', options.easing]);
                }
                if (timings.animationDuration) {
                  moreStyles.push([PREFIX + 'animation-timing-function', options.easing]);
                }
              }

              if (options.delay && timings.animationDelay) {
                moreStyles.push([PREFIX + 'animation-delay', options.delay + 's']);
              }

              if (options.duration && timings.animationDuration) {
                moreStyles.push([PREFIX + 'animation-duration', options.duration + 's']);
              }

              forEach(moreStyles, function(entry) {
                var key = entry[0];
                var value = entry[1];
                node.style[camelCase(key)] = value;
                temporaryStyles.push(entry);
              });

              var maxDelay = timings.delay;
              var maxDelayTime = maxDelay * 1000;
              var maxDuration = timings.duration;
              var maxDurationTime = maxDuration * 1000;
              var startTime = Date.now();

              events = [];
              if (timings.transitionDuration) {
                events.push(TRANSITION_EVENTS);
              }
              if (timings.animationDuration) {
                events.push(ANIMATION_EVENTS);
              }
              events = events.join(' ');
              eventFn = function(event) {
                event.stopPropagation();
                var ev = event.originalEvent || event;
                var timeStamp = ev.timeStamp || Date.now();
                var elapsedTime = parseFloat(ev.elapsedTime.toFixed(3));
                if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
                  close();
                }
              };
              element.on(events, eventFn);

              applyAnimationToStyles(element, options);

              $timeout(close, maxDelayTime + maxDurationTime * 1.5, false);
            });

            return runner;

            function close() {
              if (animationClosed) return;
              animationClosed = true;

              if (events && eventFn) {
                element.off(events, eventFn);
              }
              applyClasses(element, options);
              applyAnimationStyles(element, options);
              forEach(temporaryStyles, function(entry) {
                node.style[camelCase(entry[0])] = '';
              });
              runner.complete(true);
              return runner;
            }
          }
        };
      }

      function applyClasses(element, options) {
        if (options.addClass) {
          $$jqLite.addClass(element, options.addClass);
          options.addClass = null;
        }
        if (options.removeClass) {
          $$jqLite.removeClass(element, options.removeClass);
          options.removeClass = null;
        }
      }

      function computeTimings(element) {
        var node = getDomNode(element);
        var cs = $window.getComputedStyle(node);
        var tdr = parseMaxTime(cs[prop('transitionDuration')]);
        var adr = parseMaxTime(cs[prop('animationDuration')]);
        var tdy = parseMaxTime(cs[prop('transitionDelay')]);
        var ady = parseMaxTime(cs[prop('animationDelay')]);

        adr *= (parseInt(cs[prop('animationIterationCount')], 10) || 1);
        var duration = Math.max(adr, tdr);
        var delay = Math.max(ady, tdy);

        return {
          duration: duration,
          delay: delay,
          animationDuration: adr,
          transitionDuration: tdr,
          animationDelay: ady,
          transitionDelay: tdy
        };

        function prop(key) {
          return WEBKIT ? 'Webkit' + key.charAt(0).toUpperCase() + key.substr(1)
                        : key;
        }
      }

      function parseMaxTime(str) {
        var maxValue = 0;
        var values = (str || "").split(/\s*,\s*/);
        forEach(values, function(value) {
          // it's always safe to consider only second values and omit `ms` values since
          // getComputedStyle will always handle the conversion for us
          if (value.charAt(value.length - 1) == 's') {
            value = value.substring(0, value.length - 1);
          }
          value = parseFloat(value) || 0;
          maxValue = maxValue ? Math.max(value, maxValue) : value;
        });
        return maxValue;
      }

      var cancelLastRAFRequest;
      var rafWaitQueue = [];
      function waitUntilQuiet(callback) {
        if (cancelLastRAFRequest) {
          cancelLastRAFRequest(); // cancels the request
        }
        rafWaitQueue.push(callback);
        cancelLastRAFRequest = $$rAF(function() {
          cancelLastRAFRequest = null;

          // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
          // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
          var pageWidth = $$forceReflow();

          // we use a for loop to ensure that if the queue is changed
          // during this looping then it will consider new requests
          for (var i = 0; i < rafWaitQueue.length; i++) {
            rafWaitQueue[i](pageWidth);
          }
          rafWaitQueue.length = 0;
        });
      }

      function applyAnimationStyles(element, options) {
        applyAnimationFromStyles(element, options);
        applyAnimationToStyles(element, options);
      }

      function applyAnimationFromStyles(element, options) {
        if (options.from) {
          element.css(options.from);
          options.from = null;
        }
      }

      function applyAnimationToStyles(element, options) {
        if (options.to) {
          element.css(options.to);
          options.to = null;
        }
      }

      function getDomNode(element) {
        for (var i = 0; i < element.length; i++) {
          if (element[i].nodeType === 1) return element[i];
        }
      }

      function blockTransition(element, bool) {
        var node = getDomNode(element);
        var key = camelCase(PREFIX + 'transition-delay');
        node.style[key] = bool ? '-9999s' : '';
      }

      return init;
    }]);

  /**
   * Older browsers [FF31] expect camelCase
   * property keys.
   * e.g.
   *  animation-duration --> animationDuration
   */
  function camelCase(str) {
    return str.replace(/-[a-z]/g, function(str) {
      return str.charAt(1).toUpperCase();
    });
  }

})();

}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.core.aria
 * @description
 * Aria Expectations for AngularJS Material components.
 */
MdAriaService.$inject = ["$$rAF", "$log", "$window", "$interpolate"];
angular
  .module('material.core')
  .provider('$mdAria', MdAriaProvider);

/**
 * @ngdoc service
 * @name $mdAriaProvider
 * @module material.core.aria
 *
 * @description
 *
 * Modify options of the `$mdAria` service, which will be used by most of the AngularJS Material
 * components.
 *
 * You are able to disable `$mdAria` warnings, by using the following markup.
 *
 * <hljs lang="js">
 *   app.config(function($mdAriaProvider) {
 *     // Globally disables all ARIA warnings.
 *     $mdAriaProvider.disableWarnings();
 *   });
 * </hljs>
 *
 */
function MdAriaProvider() {

  var config = {
    /** Whether we should show ARIA warnings in the console if labels are missing on the element */
    showWarnings: true
  };

  return {
    disableWarnings: disableWarnings,
    $get: ["$$rAF", "$log", "$window", "$interpolate", function($$rAF, $log, $window, $interpolate) {
      return MdAriaService.apply(config, arguments);
    }]
  };

  /**
   * @ngdoc method
   * @name $mdAriaProvider#disableWarnings
   * @description Disables all ARIA warnings generated by AngularJS Material.
   */
  function disableWarnings() {
    config.showWarnings = false;
  }
}

/*
 * @ngInject
 */
function MdAriaService($$rAF, $log, $window, $interpolate) {

  // Load the showWarnings option from the current context and store it inside of a scope variable,
  // because the context will be probably lost in some function calls.
  var showWarnings = this.showWarnings;

  return {
    expect: expect,
    expectAsync: expectAsync,
    expectWithText: expectWithText,
    expectWithoutText: expectWithoutText,
    getText: getText,
    hasAriaLabel: hasAriaLabel,
    parentHasAriaLabel: parentHasAriaLabel
  };

  /**
   * Check if expected attribute has been specified on the target element or child
   * @param {string|JQLite} element
   * @param {string} attrName
   * @param {string=} defaultValue What to set the attr to if no value is found
   */
  function expect(element, attrName, defaultValue) {

    var node = angular.element(element)[0] || element;

    // if node exists and neither it nor its children have the attribute
    if (node &&
       ((!node.hasAttribute(attrName) ||
        node.getAttribute(attrName).length === 0) &&
        !childHasAttribute(node, attrName))) {

      defaultValue = angular.isString(defaultValue) ? defaultValue.trim() : '';
      if (defaultValue.length) {
        element.attr(attrName, defaultValue);
      } else if (showWarnings) {
        $log.warn('ARIA: Attribute "', attrName, '", required for accessibility, is missing on node:', node);
      }

    }
  }

  function expectAsync(element, attrName, defaultValueGetter) {
    // Problem: when retrieving the element's contents synchronously to find the label,
    // the text may not be defined yet in the case of a binding.
    // There is a higher chance that a binding will be defined if we wait one frame.
    $$rAF(function() {
        expect(element, attrName, defaultValueGetter());
    });
  }

  function expectWithText(element, attrName) {
    var content = getText(element) || "";
    var hasBinding = content.indexOf($interpolate.startSymbol()) > -1;

    if (hasBinding) {
      expectAsync(element, attrName, function() {
        return getText(element);
      });
    } else {
      expect(element, attrName, content);
    }
  }

  function expectWithoutText(element, attrName) {
    var content = getText(element);
    var hasBinding = content.indexOf($interpolate.startSymbol()) > -1;

    if (!hasBinding && !content) {
      expect(element, attrName, content);
    }
  }

  /**
   * @param {Element|JQLite} element
   * @returns {string}
   */
  function getText(element) {
    element = element[0] || element;
    var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null, false);
    var text = '';

    var node;
    while (node = walker.nextNode()) {
      if (!isAriaHiddenNode(node)) {
        text += node.textContent;
      }
    }

    return text.trim() || '';

    /**
     * @param {Node} node
     * @returns {boolean}
     */
    function isAriaHiddenNode(node) {
      while (node.parentNode && (node = node.parentNode) !== element) {
        if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') {
          return true;
        }
      }
    }
  }

  function childHasAttribute(node, attrName) {
    var hasChildren = node.hasChildNodes(),
        hasAttr = false;

    function isHidden(el) {
      var style = el.currentStyle ? el.currentStyle : $window.getComputedStyle(el);
      return (style.display === 'none');
    }

    if (hasChildren) {
      var children = node.childNodes;
      for (var i=0; i < children.length; i++) {
        var child = children[i];
        if (child.nodeType === 1 && child.hasAttribute(attrName)) {
          if (!isHidden(child)) {
            hasAttr = true;
          }
        }
      }
    }
    return hasAttr;
  }

  /**
   * Check if expected element has aria label attribute
   * @param element
   */
  function hasAriaLabel(element) {
    var node = angular.element(element)[0] || element;

    /* Check if compatible node type (ie: not HTML Document node) */
    if (!node.hasAttribute) {
      return false;
    }

    /* Check label or description attributes */
    return node.hasAttribute('aria-label') || node.hasAttribute('aria-labelledby') || node.hasAttribute('aria-describedby');
  }

  /**
   * Check if expected element's parent has aria label attribute and has valid role and tagName
   * @param {string|JQLite|Node & ParentNode} element
   * @param {number=} level Number of levels deep search should be performed
   */
  function parentHasAriaLabel(element, level) {
    level = level || 1;
    var node = angular.element(element)[0] || element;
    if (!node.parentNode) {
      return false;
    }
    if (performCheck(node.parentNode)) {
      return true;
    }
    level--;
    if (level) {
      return parentHasAriaLabel(node.parentNode, level);
    }
    return false;

    function performCheck(parentNode) {
      if (!hasAriaLabel(parentNode)) {
        return false;
      }
      /* Perform role block-list check */
      if (parentNode.hasAttribute('role')) {
        switch (parentNode.getAttribute('role').toLowerCase()) {
          case 'command':
          case 'definition':
          case 'directory':
          case 'grid':
          case 'list':
          case 'listitem':
          case 'log':
          case 'marquee':
          case 'menu':
          case 'menubar':
          case 'note':
          case 'presentation':
          case 'separator':
          case 'scrollbar':
          case 'status':
          case 'tablist':
            return false;
        }
      }
      /* Perform tagName block-list check */
      switch (parentNode.tagName.toLowerCase()) {
        case 'abbr':
        case 'acronym':
        case 'address':
        case 'applet':
        case 'audio':
        case 'b':
        case 'bdi':
        case 'bdo':
        case 'big':
        case 'blockquote':
        case 'br':
        case 'canvas':
        case 'caption':
        case 'center':
        case 'cite':
        case 'code':
        case 'col':
        case 'data':
        case 'dd':
        case 'del':
        case 'dfn':
        case 'dir':
        case 'div':
        case 'dl':
        case 'em':
        case 'embed':
        case 'fieldset':
        case 'figcaption':
        case 'font':
        case 'h1':
        case 'h2':
        case 'h3':
        case 'h4':
        case 'h5':
        case 'h6':
        case 'hgroup':
        case 'html':
        case 'i':
        case 'ins':
        case 'isindex':
        case 'kbd':
        case 'keygen':
        case 'label':
        case 'legend':
        case 'li':
        case 'map':
        case 'mark':
        case 'menu':
        case 'object':
        case 'ol':
        case 'output':
        case 'pre':
        case 'presentation':
        case 'q':
        case 'rt':
        case 'ruby':
        case 'samp':
        case 'small':
        case 'source':
        case 'span':
        case 'status':
        case 'strike':
        case 'strong':
        case 'sub':
        case 'sup':
        case 'svg':
        case 'tbody':
        case 'td':
        case 'th':
        case 'thead':
        case 'time':
        case 'tr':
        case 'track':
        case 'tt':
        case 'ul':
        case 'var':
          return false;
      }
      return true;
    }
  }
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.core.compiler
 * @description
 * AngularJS Material template and element compiler.
 */
angular
  .module('material.core')
  .provider('$mdCompiler', MdCompilerProvider);

MdCompilerProvider.$inject = ['$compileProvider'];
function MdCompilerProvider() {

  this.$get = ["$q", "$templateRequest", "$injector", "$compile", "$controller",
    function($q, $templateRequest, $injector, $compile, $controller) {
      return new MdCompilerService($q, $templateRequest, $injector, $compile, $controller);
    }];

  /**
   * @ngdoc service
   * @name $mdCompiler
   * @module material.core.compiler
   * @description
   * The $mdCompiler service is an abstraction of AngularJS's compiler, that allows developers
   * to compile an element with options like in a Directive Definition Object.
   *
   * > The compiler powers a lot of components inside of AngularJS Material.
   * > Like the `$mdPanel` or `$mdDialog` services.
   *
   * @usage
   *
   * Basic Usage with a template
   *
   * <hljs lang="js">
   *   $mdCompiler.compile({
   *     templateUrl: 'modal.html',
   *     controller: 'ModalCtrl',
   *     locals: {
   *       modal: myModalInstance;
   *     }
   *   }).then(function (compileData) {
   *     compileData.element; // Compiled DOM element
   *     compileData.link(myScope); // Instantiate controller and link element to scope.
   *   });
   * </hljs>
   *
   * Example with a content element
   *
   * <hljs lang="js">
   *
   *   // Create a virtual element and link it manually.
   *   // The compiler doesn't need to recompile the element each time.
   *   var myElement = $compile('<span>Test</span>')(myScope);
   *
   *   $mdCompiler.compile({
   *     contentElement: myElement
   *   }).then(function (compileData) {
   *     compileData.element // Content Element (same as above)
   *     compileData.link // This does nothing when using a contentElement.
   *   });
   * </hljs>
   *
   * > Content Element is a significant performance improvement when the developer already knows
   * > that the compiled element will be always the same and the scope will not change either.
   *
   * The `contentElement` option also supports DOM elements which will be temporary removed and
   * restored at its old position.
   *
   * <hljs lang="js">
   *   var domElement = document.querySelector('#myElement');
   *
   *   $mdCompiler.compile({
   *     contentElement: myElement
   *   }).then(function (compileData) {
   *     compileData.element // Content Element (same as above)
   *     compileData.link // This does nothing when using a contentElement.
   *   });
   * </hljs>
   *
   * The `$mdCompiler` can also query for the element in the DOM itself.
   *
   * <hljs lang="js">
   *   $mdCompiler.compile({
   *     contentElement: '#myElement'
   *   }).then(function (compileData) {
   *     compileData.element // Content Element (same as above)
   *     compileData.link // This does nothing when using a contentElement.
   *   });
   * </hljs>
   *
   */
  function MdCompilerService($q, $templateRequest, $injector, $compile, $controller) {

    /**
     * @private @const
     * @type {!IQService}
     */
    this.$q = $q;

    /**
     * @private @const
     * @type {!ITemplateRequestService}
     */
    this.$templateRequest = $templateRequest;

    /**
     * @private @const
     * @type {!IInjectorService}
     */
    this.$injector = $injector;

    /**
     * @private @const
     * @type{!ICompileService}
     */
    this.$compile = $compile;

    /**
     * @private @const
     * @type {!IControllerService}
     */
    this.$controller = $controller;
  }

  /**
   * @ngdoc method
   * @name $mdCompiler#compile
   * @description
   *
   * A method to compile a HTML template with the AngularJS compiler.
   * The `$mdCompiler` is wrapper around the AngularJS compiler and provides extra functionality
   * like controller instantiation or async resolves.
   *
   * @param {!Object} options An options object, with the following properties:
   *
   *    - `controller` - `{string|function}` Controller fn that should be associated with
   *         newly created scope or the name of a registered controller if passed as a string.
   *    - `controllerAs` - `{string=}` A controller alias name. If present the controller will be
   *         published to scope under the `controllerAs` name.
   *    - `contentElement` - `{string|Element}`: Instead of using a template, which will be
   *         compiled each time, you can also use a DOM element.<br/>
   *    - `template` - `{string=}` An html template as a string.
   *    - `templateUrl` - `{string=}` A path to an html template.
   *    - `transformTemplate` - `{function(template)=}` A function which transforms the template after
   *        it is loaded. It will be given the template string as a parameter, and should
   *        return a a new string representing the transformed template.
   *    - `resolve` - `{Object.<string, function>=}` - An optional map of dependencies which should
   *        be injected into the controller. If any of these dependencies are promises, the compiler
   *        will wait for them all to be resolved, or if one is rejected before the controller is
   *        instantiated `compile()` will fail..
   *      * `key` - `{string}`: a name of a dependency to be injected into the controller.
   *      * `factory` - `{string|function}`: If `string` then it is an alias for a service.
   *        Otherwise if function, then it is injected and the return value is treated as the
   *        dependency. If the result is a promise, it is resolved before its value is
   *        injected into the controller.
   *
   * @returns {Q.Promise<{element: JQLite, link: Function, locals: Object, cleanup: any,
   *  controller: Object=}>} promise A promise, which will be resolved with a `compileData` object.
   *  `compileData` has the following properties:
   *
   *   - `element` - `{JQLite}`: an uncompiled element matching the provided template.
   *   - `link` - `{function(scope)}`: A link function, which, when called, will compile
   *     the element and instantiate the provided controller (if given).
   *   - `locals` - `{Object}`: The locals which will be passed into the controller once `link` is
   *     called. If `bindToController` is true, they will be copied to the ctrl instead
   */
  MdCompilerService.prototype.compile = function(options) {
    if (options.contentElement) {
      return this._prepareContentElement(options);
    } else {
      return this._compileTemplate(options);
    }
  };

  /**
   * Instead of compiling any template, the compiler just fetches an existing HTML element from the
   * DOM and provides a restore function to put the element back it old DOM position.
   * @param {!Object} options Options to be used for the compiler.
   * @returns {Q.Promise<{element: JQLite, link: Function, locals: Object, cleanup: any}>}
   */
  MdCompilerService.prototype._prepareContentElement = function(options) {

    var contentElement = this._fetchContentElement(options);

    return this.$q.resolve({
      element: contentElement.element,
      cleanup: contentElement.restore,
      locals: {},
      link: function() {
        return contentElement.element;
      }
    });

  };

  /**
   * Compiles a template by considering all options and waiting for all resolves to be ready.
   * @param {!Object} options Compile options
   * @returns {!Q.Promise<{element: JQLite, link: Function, locals: Object, cleanup: any}>} Compile
   *  data with link function.
   */
  MdCompilerService.prototype._compileTemplate = function(options) {

    var self = this;
    var templateUrl = options.templateUrl;
    var template = options.template || '';
    var resolve = angular.extend({}, options.resolve);
    var locals = angular.extend({}, options.locals);
    var transformTemplate = options.transformTemplate || angular.identity;

    // Take resolve values and invoke them.
    // Resolves can either be a string (value: 'MyRegisteredAngularConst'),
    // or an invokable 'factory' of sorts: (value: function ValueGetter($dependency) {})
    angular.forEach(resolve, function(value, key) {
      if (angular.isString(value)) {
        resolve[key] = self.$injector.get(value);
      } else {
        resolve[key] = self.$injector.invoke(value);
      }
    });

    // Add the locals, which are just straight values to inject
    // eg locals: { three: 3 }, will inject three into the controller
    angular.extend(resolve, locals);

    if (templateUrl) {
      resolve.$$ngTemplate = this.$templateRequest(templateUrl);
    } else {
      resolve.$$ngTemplate = this.$q.when(template);
    }


    // Wait for all the resolves to finish if they are promises
    return this.$q.all(resolve).then(function(locals) {

      var template = transformTemplate(locals.$$ngTemplate, options);
      var element = options.element || angular.element('<div>').html(template.trim()).contents();

      return self._compileElement(locals, element, options);
    });

  };

  /**
   * Method to compile an element with the given options.
   * @param {!Object} locals Locals to be injected to the controller if present
   * @param {!JQLite} element Element to be compiled and linked
   * @param {!Object} options Options to be used for linking.
   * @returns {!{element: JQLite, link: Function, locals: Object, cleanup: any, controller: Object}} Compile data with link function.
   */
  MdCompilerService.prototype._compileElement = function(locals, element, options) {
    var self = this;
    var ngLinkFn = this.$compile(element);

    var compileData = {
      element: element,
      cleanup: element.remove.bind(element),
      locals: locals,
      link: linkFn
    };

    function linkFn(scope) {
      locals.$scope = scope;

      // Instantiate controller if the developer provided one.
      if (options.controller) {

        var injectLocals = angular.extend({}, locals, {
          $element: element
        });

        // Create the specified controller instance.
        var ctrl = self._createController(options, injectLocals, locals);

        // Registering extra $destroy listeners should be avoided.
        // Only register the listener if the controller implements a $onDestroy hook.
        if (angular.isFunction(ctrl.$onDestroy)) {
          scope.$on('$destroy', function() {
            // Call the $onDestroy hook if it's present on the controller.
            angular.isFunction(ctrl.$onDestroy) && ctrl.$onDestroy();
          });
        }

        // Unique identifier for AngularJS Route ngView controllers.
        element.data('$ngControllerController', ctrl);
        element.children().data('$ngControllerController', ctrl);

        // Expose the instantiated controller to the compile data
        compileData.controller = ctrl;
      }

      // Invoke the AngularJS $compile link function.
      return ngLinkFn(scope);
    }

    return compileData;

  };

  /**
   * Creates and instantiates a new controller with the specified options.
   * @param {!Object} options Options that include the controller function or string.
   * @param {!Object} injectLocals Locals to to be provided in the controller DI.
   * @param {!Object} locals Locals to be injected to the controller.
   * @returns {!Object} Created controller instance.
   */
  MdCompilerService.prototype._createController = function(options, injectLocals, locals) {
    var ctrl = this.$controller(options.controller, injectLocals);

    if (options.bindToController) {
      angular.extend(ctrl, locals);
    }

    if (options.controllerAs) {
      injectLocals.$scope[options.controllerAs] = ctrl;
    }

    // Call the $onInit hook if it's present on the controller.
    angular.isFunction(ctrl.$onInit) && ctrl.$onInit();

    return ctrl;
  };

  /**
   * Fetches an element removing it from the DOM and using it temporary for the compiler.
   * Elements which were fetched will be restored after use.
   * @param {!Object} options Options to be used for the compilation.
   * @returns {{element: !JQLite, restore: !function}}
   */
  MdCompilerService.prototype._fetchContentElement = function(options) {
    var contentEl = options.contentElement;
    var restoreFn;

    if (angular.isString(contentEl)) {
      contentEl = document.querySelector(contentEl);
      restoreFn = createRestoreFn(contentEl);
    } else {
      contentEl = contentEl[0] || contentEl;

      // When the element is visible in the DOM, then we restore it at close of the dialog.
      // Otherwise it will be removed from the DOM after close.
      if (document.contains(contentEl)) {
        restoreFn = createRestoreFn(contentEl);
      } else {
        restoreFn = function() {
          if (contentEl.parentNode) {
            contentEl.parentNode.removeChild(contentEl);
          }
        };
      }
    }

    return {
      element: angular.element(contentEl),
      restore: restoreFn
    };

    function createRestoreFn(element) {
      var parent = element.parentNode;
      var nextSibling = element.nextElementSibling;

      return function() {
        if (!nextSibling) {
          // When the element didn't had any sibling, then it can be simply appended to the
          // parent, because it plays no role, which index it had before.
          parent.appendChild(element);
        } else {
          // When the element had a sibling, which marks the previous position of the element
          // in the DOM, we insert it correctly before the sibling, to have the same index as
          // before.
          parent.insertBefore(element, nextSibling);
        }
      };
    }
  };
}


})();
(function(){
"use strict";


MdGesture.$inject = ["$$MdGestureHandler", "$$rAF", "$timeout", "$mdUtil"];
attachToDocument.$inject = ["$mdGesture", "$$MdGestureHandler", "$mdUtil"];var HANDLERS = {};

/**
 * The state of the current 'pointer'. The pointer represents the state of the current touch.
 * It contains normalized x and y coordinates from DOM events,
 * as well as other information abstracted from the DOM.
 */
var pointer, lastPointer, maxClickDistance = 6;
var forceSkipClickHijack = false, disableAllGestures = false;

/**
 * The position of the most recent click if that click was on a label element.
 * @type {{x: number, y: number}|null}
 */
var lastLabelClickPos = null;

/**
 * Used to attach event listeners once when multiple ng-apps are running.
 * @type {boolean}
 */
var isInitialized = false;

/**
 * @ngdoc module
 * @name material.core.gestures
 * @description
 * AngularJS Material Gesture handling for touch devices.
 * This module replaced the usage of the HammerJS library.
 */
angular
  .module('material.core.gestures', [])
  .provider('$mdGesture', MdGestureProvider)
  .factory('$$MdGestureHandler', MdGestureHandler)
  .run(attachToDocument);

/**
 * @ngdoc service
 * @name $mdGestureProvider
 * @module material.core.gestures
 *
 * @description
 * In some scenarios on mobile devices (without jQuery), the click events should NOT be hijacked.
 * `$mdGestureProvider` is used to configure the Gesture module to ignore or skip click hijacking
 * on mobile devices.
 *
 * You can also change the max click distance, `6px` by default, if you have issues on some touch
 * screens.
 *
 * <hljs lang="js">
 *   app.config(function($mdGestureProvider) {
 *
 *     // For mobile devices without jQuery loaded, do not
 *     // intercept click events during the capture phase.
 *     $mdGestureProvider.skipClickHijack();
 *
 *     // If hijacking clicks, you may want to change the default click distance
 *     $mdGestureProvider.setMaxClickDistance(12);
 *   });
 * </hljs>
 *
 */
function MdGestureProvider() { }

MdGestureProvider.prototype = {

  /**
   * @ngdoc method
   * @name $mdGestureProvider#disableAll
   *
   * @description
   * Disable all gesture detection. This can be beneficial to application performance
   * and memory usage.
   */
  disableAll: function () {
    disableAllGestures = true;
  },

  // Publish access to setter to configure a variable BEFORE the
  // $mdGesture service is instantiated...
  /**
   * @ngdoc method
   * @name $mdGestureProvider#skipClickHijack
   *
   * @description
   * Tell the AngularJS Material Gesture module to skip (or ignore) click hijacking on mobile devices.
   */
  skipClickHijack: function() {
    return forceSkipClickHijack = true;
  },

  /**
   * @ngdoc method
   * @name $mdGestureProvider#setMaxClickDistance
   * @param clickDistance {string} Distance in pixels. I.e. `12px`.
   * @description
   * Set the max distance from the origin of the touch event to trigger touch handlers.
   */
  setMaxClickDistance: function(clickDistance) {
    maxClickDistance = parseInt(clickDistance);
  },

  /**
   * $get is used to build an instance of $mdGesture
   * @ngInject
   */
  $get : ["$$MdGestureHandler", "$$rAF", "$timeout", "$mdUtil", function($$MdGestureHandler, $$rAF, $timeout, $mdUtil) {
       return new MdGesture($$MdGestureHandler, $$rAF, $timeout, $mdUtil);
  }]
};



/**
 * MdGesture factory construction function
 * @ngInject
 */
function MdGesture($$MdGestureHandler, $$rAF, $timeout, $mdUtil) {
  var touchActionProperty = $mdUtil.getTouchAction();
  var hasJQuery = (typeof window.jQuery !== 'undefined') && (angular.element === window.jQuery);

  var self = {
    handler: addHandler,
    register: register,
    isAndroid: $mdUtil.isAndroid,
    isIos: $mdUtil.isIos,
    // On mobile w/out jQuery, we normally intercept clicks. Should we skip that?
    isHijackingClicks: ($mdUtil.isIos || $mdUtil.isAndroid) && !hasJQuery && !forceSkipClickHijack
  };

  if (self.isHijackingClicks) {
    self.handler('click', {
      options: {
        maxDistance: maxClickDistance
      },
      onEnd: checkDistanceAndEmit('click')
    });

    self.handler('focus', {
      options: {
        maxDistance: maxClickDistance
      },
      onEnd: function(ev, pointer) {
        if (pointer.distance < this.state.options.maxDistance && canFocus(ev.target)) {
          this.dispatchEvent(ev, 'focus', pointer);
          ev.target.focus();
        }
      }
    });

    self.handler('mouseup', {
      options: {
        maxDistance: maxClickDistance
      },
      onEnd: checkDistanceAndEmit('mouseup')
    });

    self.handler('mousedown', {
      onStart: function(ev) {
        this.dispatchEvent(ev, 'mousedown');
      }
    });
  }

  function checkDistanceAndEmit(eventName) {
    return function(ev, pointer) {
      if (pointer.distance < this.state.options.maxDistance) {
        this.dispatchEvent(ev, eventName, pointer);
      }
    };
  }

  /**
   * Register an element to listen for a handler.
   * This allows an element to override the default options for a handler.
   * Additionally, some handlers like drag and hold only dispatch events if
   * the domEvent happens inside an element that's registered to listen for these events.
   *
   * @see GestureHandler for how overriding of default options works.
   * @example $mdGesture.register(myElement, 'drag', { minDistance: 20, horizontal: false })
   */
  function register(element, handlerName, options) {
    var handler = HANDLERS[handlerName.replace(/^\$md./, '')];
    if (!handler) {
      throw new Error('Failed to register element with handler ' + handlerName + '. ' +
      'Available handlers: ' + Object.keys(HANDLERS).join(', '));
    }
    return handler.registerElement(element, options);
  }

  /*
   * add a handler to $mdGesture. see below.
   */
  function addHandler(name, definition) {
    var handler = new $$MdGestureHandler(name);
    angular.extend(handler, definition);
    HANDLERS[name] = handler;

    return self;
  }

  /**
   * Register handlers. These listen to touch/start/move events, interpret them,
   * and dispatch gesture events depending on options & conditions. These are all
   * instances of GestureHandler.
   * @see GestureHandler
   */
  return self
    /*
     * The press handler dispatches an event on touchdown/touchend.
     * It's a simple abstraction of touch/mouse/pointer start and end.
     */
    .handler('press', {
      onStart: function (ev, pointer) {
        this.dispatchEvent(ev, '$md.pressdown');
      },
      onEnd: function (ev, pointer) {
        this.dispatchEvent(ev, '$md.pressup');
      }
    })

    /*
     * The hold handler dispatches an event if the user keeps their finger within
     * the same <maxDistance> area for <delay> ms.
     * The hold handler will only run if a parent of the touch target is registered
     * to listen for hold events through $mdGesture.register()
     */
    .handler('hold', {
      options: {
        maxDistance: 6,
        delay: 500
      },
      onCancel: function () {
        $timeout.cancel(this.state.timeout);
      },
      onStart: function (ev, pointer) {
        // For hold, require a parent to be registered with $mdGesture.register()
        // Because we prevent scroll events, this is necessary.
        if (!this.state.registeredParent) return this.cancel();

        this.state.pos = {x: pointer.x, y: pointer.y};
        this.state.timeout = $timeout(angular.bind(this, function holdDelayFn() {
          this.dispatchEvent(ev, '$md.hold');
          this.cancel(); // we're done!
        }), this.state.options.delay, false);
      },
      onMove: function (ev, pointer) {
        // Don't scroll while waiting for hold.
        // If we don't preventDefault touchmove events here, Android will assume we don't
        // want to listen to anymore touch events. It will start scrolling and stop sending
        // touchmove events.
        if (!touchActionProperty && ev.type === 'touchmove') ev.preventDefault();

        // If the user moves greater than <maxDistance> pixels, stop the hold timer
        // set in onStart
        var dx = this.state.pos.x - pointer.x;
        var dy = this.state.pos.y - pointer.y;
        if (Math.sqrt(dx * dx + dy * dy) > this.options.maxDistance) {
          this.cancel();
        }
      },
      onEnd: function () {
        this.onCancel();
      }
    })

    /*
     * The drag handler dispatches a drag event if the user holds and moves his finger greater than
     * <minDistance> px in the x or y direction, depending on options.horizontal.
     * The drag will be cancelled if the user moves his finger greater than <minDistance>*<cancelMultiplier> in
     * the perpendicular direction. Eg if the drag is horizontal and the user moves his finger <minDistance>*<cancelMultiplier>
     * pixels vertically, this handler won't consider the move part of a drag.
     */
    .handler('drag', {
      options: {
        minDistance: 6,
        horizontal: true,
        cancelMultiplier: 1.5
      },
      /**
       * @param {angular.JQLite} element where touch action styles need to be adjusted
       * @param {{horizontal: boolean}=} options object whose horizontal property can specify to
       *  apply 'pan-y' or 'pan-x' touch actions.
       */
      onSetup: function(element, options) {
        if (touchActionProperty) {
          // We check for horizontal to be false, because otherwise we would overwrite the default opts.
          this.oldTouchAction = element[0].style[touchActionProperty];
          element[0].style[touchActionProperty] = options.horizontal ? 'pan-y' : 'pan-x';
        }
      },
      /**
       * @param {angular.JQLite} element where styles need to be cleaned up
       */
      onCleanup: function(element) {
        if (this.oldTouchAction) {
          element[0].style[touchActionProperty] = this.oldTouchAction;
        } else {
          element[0].style[touchActionProperty] = null;
        }
      },
      onStart: function (ev) {
        // For drag, require a parent to be registered with $mdGesture.register()
        if (!this.state.registeredParent) this.cancel();
      },
      onMove: function (ev, pointer) {
        var shouldStartDrag, shouldCancel;
        // Don't scroll while deciding if this touchmove qualifies as a drag event.
        // If we don't preventDefault touchmove events here, Android will assume we don't
        // want to listen to anymore touch events. It will start scrolling and stop sending
        // touchmove events.
        if (!touchActionProperty && ev.type === 'touchmove') ev.preventDefault();

        if (!this.state.dragPointer) {
          if (this.state.options.horizontal) {
            shouldStartDrag = Math.abs(pointer.distanceX) > this.state.options.minDistance;
            shouldCancel = Math.abs(pointer.distanceY) > this.state.options.minDistance * this.state.options.cancelMultiplier;
          } else {
            shouldStartDrag = Math.abs(pointer.distanceY) > this.state.options.minDistance;
            shouldCancel = Math.abs(pointer.distanceX) > this.state.options.minDistance * this.state.options.cancelMultiplier;
          }

          if (shouldStartDrag) {
            // Create a new pointer representing this drag, starting at this point where the drag started.
            this.state.dragPointer = makeStartPointer(ev);
            updatePointerState(ev, this.state.dragPointer);
            this.dispatchEvent(ev, '$md.dragstart', this.state.dragPointer);

          } else if (shouldCancel) {
            this.cancel();
          }
        } else {
          this.dispatchDragMove(ev);
        }
      },
      // Only dispatch dragmove events every frame; any more is unnecessary
      dispatchDragMove: $$rAF.throttle(function (ev) {
        // Make sure the drag didn't stop while waiting for the next frame
        if (this.state.isRunning) {
          updatePointerState(ev, this.state.dragPointer);
          this.dispatchEvent(ev, '$md.drag', this.state.dragPointer);
        }
      }),
      onEnd: function (ev, pointer) {
        if (this.state.dragPointer) {
          updatePointerState(ev, this.state.dragPointer);
          this.dispatchEvent(ev, '$md.dragend', this.state.dragPointer);
        }
      }
    })

    /*
     * The swipe handler will dispatch a swipe event if, on the end of a touch,
     * the velocity and distance were high enough.
     */
    .handler('swipe', {
      options: {
        minVelocity: 0.65,
        minDistance: 10
      },
      onEnd: function (ev, pointer) {
        var eventType;

        if (Math.abs(pointer.velocityX) > this.state.options.minVelocity &&
          Math.abs(pointer.distanceX) > this.state.options.minDistance) {
          eventType = pointer.directionX == 'left' ? '$md.swipeleft' : '$md.swiperight';
          this.dispatchEvent(ev, eventType);
        }
        else if (Math.abs(pointer.velocityY) > this.state.options.minVelocity &&
          Math.abs(pointer.distanceY) > this.state.options.minDistance) {
          eventType = pointer.directionY == 'up' ? '$md.swipeup' : '$md.swipedown';
          this.dispatchEvent(ev, eventType);
        }
      }
    });
}

/**
 * MdGestureHandler
 * A GestureHandler is an object which is able to dispatch custom dom events
 * based on native dom {touch,pointer,mouse}{start,move,end} events.
 *
 * A gesture will manage its lifecycle through the start,move,end, and cancel
 * functions, which are called by native dom events.
 *
 * A gesture has the concept of 'options' (eg. a swipe's required velocity), which can be
 * overridden by elements registering through $mdGesture.register().
 */
function GestureHandler (name) {
  this.name = name;
  this.state = {};
}

function MdGestureHandler() {
  var hasJQuery =  (typeof window.jQuery !== 'undefined') && (angular.element === window.jQuery);

  GestureHandler.prototype = {
    options: {},
    // jQuery listeners don't work with custom DOMEvents, so we have to dispatch events
    // differently when jQuery is loaded
    dispatchEvent: hasJQuery ?  jQueryDispatchEvent : nativeDispatchEvent,

    // These are overridden by the registered handler
    onSetup: angular.noop,
    onCleanup: angular.noop,
    onStart: angular.noop,
    onMove: angular.noop,
    onEnd: angular.noop,
    onCancel: angular.noop,

    // onStart sets up a new state for the handler, which includes options from the
    // nearest registered parent element of ev.target.
    start: function (ev, pointer) {
      if (this.state.isRunning) return;
      var parentTarget = this.getNearestParent(ev.target);
      // Get the options from the nearest registered parent
      var parentTargetOptions = parentTarget && parentTarget.$mdGesture[this.name] || {};

      this.state = {
        isRunning: true,
        // Override the default options with the nearest registered parent's options
        options: angular.extend({}, this.options, parentTargetOptions),
        // Pass in the registered parent node to the state so the onStart listener can use
        registeredParent: parentTarget
      };
      this.onStart(ev, pointer);
    },
    move: function (ev, pointer) {
      if (!this.state.isRunning) return;
      this.onMove(ev, pointer);
    },
    end: function (ev, pointer) {
      if (!this.state.isRunning) return;
      this.state.isRunning = false;
      this.onEnd(ev, pointer);
    },
    cancel: function (ev, pointer) {
      this.onCancel(ev, pointer);
      this.state = {};
    },

    // Find and return the nearest parent element that has been registered to
    // listen for this handler via $mdGesture.register(element, 'handlerName').
    getNearestParent: function (node) {
      var current = node;
      while (current) {
        if ((current.$mdGesture || {})[this.name]) {
          return current;
        }
        current = current.parentNode;
      }
      return null;
    },

    // Called from $mdGesture.register when an element registers itself with a handler.
    // Store the options the user gave on the DOMElement itself. These options will
    // be retrieved with getNearestParent when the handler starts.
    registerElement: function (element, options) {
      var self = this;
      element[0].$mdGesture = element[0].$mdGesture || {};
      element[0].$mdGesture[this.name] = options || {};
      element.on('$destroy', onDestroy);

      self.onSetup(element, options || {});

      return onDestroy;

      function onDestroy() {
        delete element[0].$mdGesture[self.name];
        element.off('$destroy', onDestroy);

        self.onCleanup(element, options || {});
      }
    }
  };

  return GestureHandler;

  /**
   * Dispatch an event with jQuery
   * TODO: Make sure this sends bubbling events
   *
   * @param srcEvent the original DOM touch event that started this.
   * @param eventType the name of the custom event to send (eg 'click' or '$md.drag')
   * @param eventPointer the pointer object that matches this event.
   */
  function jQueryDispatchEvent(srcEvent, eventType, eventPointer) {
    eventPointer = eventPointer || pointer;
    var eventObj = new angular.element.Event(eventType);

    eventObj.$material = true;
    eventObj.pointer = eventPointer;
    eventObj.srcEvent = srcEvent;

    angular.extend(eventObj, {
      clientX: eventPointer.x,
      clientY: eventPointer.y,
      screenX: eventPointer.x,
      screenY: eventPointer.y,
      pageX: eventPointer.x,
      pageY: eventPointer.y,
      ctrlKey: srcEvent.ctrlKey,
      altKey: srcEvent.altKey,
      shiftKey: srcEvent.shiftKey,
      metaKey: srcEvent.metaKey
    });
    angular.element(eventPointer.target).trigger(eventObj);
  }

  /**
   * NOTE: nativeDispatchEvent is very performance sensitive.
   * @param srcEvent the original DOM touch event that started this.
   * @param eventType the name of the custom event to send (eg 'click' or '$md.drag')
   * @param eventPointer the pointer object that matches this event.
   */
  function nativeDispatchEvent(srcEvent, eventType, eventPointer) {
    eventPointer = eventPointer || pointer;
    var eventObj;

    if (eventType === 'click' || eventType === 'mouseup' || eventType === 'mousedown') {
      if (typeof window.MouseEvent === "function") {
        eventObj = new MouseEvent(eventType, {
          bubbles: true,
          cancelable: true,
          screenX: Number(srcEvent.screenX),
          screenY: Number(srcEvent.screenY),
          clientX: Number(eventPointer.x),
          clientY: Number(eventPointer.y),
          ctrlKey: srcEvent.ctrlKey,
          altKey: srcEvent.altKey,
          shiftKey: srcEvent.shiftKey,
          metaKey: srcEvent.metaKey,
          button: srcEvent.button,
          buttons: srcEvent.buttons,
          relatedTarget: srcEvent.relatedTarget || null
        });
      } else {
        eventObj = document.createEvent('MouseEvents');
        // This has been deprecated
        // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/initMouseEvent
        eventObj.initMouseEvent(
          eventType, true, true, window, srcEvent.detail,
          eventPointer.x, eventPointer.y, eventPointer.x, eventPointer.y,
          srcEvent.ctrlKey, srcEvent.altKey, srcEvent.shiftKey, srcEvent.metaKey,
          srcEvent.button, srcEvent.relatedTarget || null
        );
      }
    } else {
      if (typeof window.CustomEvent === "function") {
        eventObj = new CustomEvent(eventType, {
          bubbles: true,
          cancelable: true,
          detail: {}
        });
      } else {
        // This has been deprecated
        // https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/initCustomEvent
        eventObj = document.createEvent('CustomEvent');
        eventObj.initCustomEvent(eventType, true, true, {});
      }
    }
    eventObj.$material = true;
    eventObj.pointer = eventPointer;
    eventObj.srcEvent = srcEvent;
    eventPointer.target.dispatchEvent(eventObj);
  }
}

/**
 * Attach Gestures: hook document and check shouldHijack clicks
 * @ngInject
 */
function attachToDocument($mdGesture, $$MdGestureHandler, $mdUtil) {
  if (disableAllGestures) {
    return;
  }

  if (!isInitialized && $mdGesture.isHijackingClicks) {
    /*
     * If hijack clicks is true, we preventDefault any click that wasn't
     * sent by AngularJS Material. This is because on older Android & iOS, a false, or 'ghost',
     * click event will be sent ~400ms after a touchend event happens.
     * The only way to know if this click is real is to prevent any normal
     * click events, and add a flag to events sent by material so we know not to prevent those.
     *
     * Two exceptions to click events that should be prevented are:
     *  - click events sent by the keyboard (eg form submit)
     *  - events that originate from an Ionic app
     */
    document.addEventListener('click'    , clickHijacker     , true);
    document.addEventListener('mouseup'  , mouseInputHijacker, true);
    document.addEventListener('mousedown', mouseInputHijacker, true);
    document.addEventListener('focus'    , mouseInputHijacker, true);

    isInitialized = true;
  }

  function mouseInputHijacker(ev) {
    var isKeyClick = !ev.clientX && !ev.clientY;

    if (
      !isKeyClick &&
      !ev.$material &&
      !ev.isIonicTap &&
      !isInputEventFromLabelClick(ev) &&
      (ev.type !== 'mousedown' || (!canFocus(ev.target) && !canFocus(document.activeElement)))
    ) {
      ev.preventDefault();
      ev.stopPropagation();
    }
  }

  /**
   * Ignore click events that don't come from AngularJS Material, Ionic, Input Label clicks,
   * or key presses that generate click events. This helps to ignore the ghost tap events on
   * older mobile browsers that get sent after a 300-400ms delay.
   * @param ev MouseEvent or modified MouseEvent with $material, pointer, and other fields
   */
  function clickHijacker(ev) {
    var isKeyClick;
    if ($mdUtil.isIos) {
      isKeyClick = angular.isDefined(ev.webkitForce) && ev.webkitForce === 0;
    } else {
      isKeyClick = ev.clientX === 0 && ev.clientY === 0;
    }
    if (!isKeyClick && !ev.$material && !ev.isIonicTap && !isInputEventFromLabelClick(ev)) {
      ev.preventDefault();
      ev.stopPropagation();
      lastLabelClickPos = null;
    } else {
      lastLabelClickPos = null;
      if (ev.target.tagName.toLowerCase() === 'label') {
        lastLabelClickPos = {x: ev.x, y: ev.y};
      }
    }
  }


  // Listen to all events to cover all platforms.
  var START_EVENTS = 'mousedown touchstart pointerdown';
  var MOVE_EVENTS = 'mousemove touchmove pointermove';
  var END_EVENTS = 'mouseup mouseleave touchend touchcancel pointerup pointercancel';

  angular.element(document)
    .on(START_EVENTS, gestureStart)
    .on(MOVE_EVENTS, gestureMove)
    .on(END_EVENTS, gestureEnd)
    // For testing
    .on('$$mdGestureReset', function gestureClearCache () {
      lastPointer = pointer = null;
    });

  /**
   * When a DOM event happens, run all registered gesture handlers' lifecycle
   * methods which match the DOM event.
   * Eg. when a 'touchstart' event happens, runHandlers('start') will call and
   * run `handler.cancel()` and `handler.start()` on all registered handlers.
   */
  function runHandlers(handlerEvent, event) {
    var handler;
    for (var name in HANDLERS) {
      handler = HANDLERS[name];
      if (handler instanceof $$MdGestureHandler) {

        if (handlerEvent === 'start') {
          // Run cancel to reset any handlers' state
          handler.cancel();
        }
        handler[handlerEvent](event, pointer);
      }
    }
  }

  /*
   * gestureStart vets if a start event is legitimate (and not part of a 'ghost click' from iOS/Android)
   * If it is legitimate, we initiate the pointer state and mark the current pointer's type
   * For example, for a touchstart event, mark the current pointer as a 'touch' pointer, so mouse events
   * won't effect it.
   */
  function gestureStart(ev) {
    // If we're already touched down, abort
    if (pointer) return;

    var now = +Date.now();

    // iOS & old android bug: after a touch event, a click event is sent 350 ms later.
    // If <400ms have passed, don't allow an event of a different type than the previous event
    if (lastPointer && !typesMatch(ev, lastPointer) && (now - lastPointer.endTime < 1500)) {
      return;
    }

    pointer = makeStartPointer(ev);

    runHandlers('start', ev);
  }

  /**
   * If a move event happens of the right type, update the pointer and run all the move handlers.
   * "of the right type": if a mousemove happens but our pointer started with a touch event, do
   * nothing.
   */
  function gestureMove(ev) {
    if (!pointer || !typesMatch(ev, pointer)) return;

    updatePointerState(ev, pointer);
    runHandlers('move', ev);
  }

  /**
   * If an end event happens of the right type, update the pointer, run endHandlers, and save the
   * pointer as 'lastPointer'.
   */
  function gestureEnd(ev) {
    if (!pointer || !typesMatch(ev, pointer)) return;

    updatePointerState(ev, pointer);
    pointer.endTime = +Date.now();

    if (ev.type !== 'pointercancel') {
      runHandlers('end', ev);
    }

    lastPointer = pointer;
    pointer = null;
  }

}

// ********************
// Module Functions
// ********************

/*
 * Initiate the pointer. x, y, and the pointer's type.
 */
function makeStartPointer(ev) {
  var point = getEventPoint(ev);
  var startPointer = {
    startTime: +Date.now(),
    target: ev.target,
    // 'p' for pointer events, 'm' for mouse, 't' for touch
    type: ev.type.charAt(0)
  };
  startPointer.startX = startPointer.x = point.pageX;
  startPointer.startY = startPointer.y = point.pageY;
  return startPointer;
}

/*
 * return whether the pointer's type matches the event's type.
 * Eg if a touch event happens but the pointer has a mouse type, return false.
 */
function typesMatch(ev, pointer) {
  return ev && pointer && ev.type.charAt(0) === pointer.type;
}

/**
 * Gets whether the given event is an input event that was caused by clicking on an
 * associated label element.
 *
 * This is necessary because the browser will, upon clicking on a label element, fire an
 * *extra* click event on its associated input (if any). mdGesture is able to flag the label
 * click as with `$material` correctly, but not the second input click.
 *
 * In order to determine whether an input event is from a label click, we compare the (x, y) for
 * the event to the (x, y) for the most recent label click (which is cleared whenever a non-label
 * click occurs). Unfortunately, there are no event properties that tie the input and the label
 * together (such as relatedTarget).
 *
 * @param {MouseEvent} event
 * @returns {boolean}
 */
function isInputEventFromLabelClick(event) {
  return lastLabelClickPos
      && lastLabelClickPos.x === event.x
      && lastLabelClickPos.y === event.y;
}

/*
 * Update the given pointer based upon the given DOMEvent.
 * Distance, velocity, direction, duration, etc
 */
function updatePointerState(ev, pointer) {
  var point = getEventPoint(ev);
  var x = pointer.x = point.pageX;
  var y = pointer.y = point.pageY;

  pointer.distanceX = x - pointer.startX;
  pointer.distanceY = y - pointer.startY;
  pointer.distance = Math.sqrt(
    pointer.distanceX * pointer.distanceX + pointer.distanceY * pointer.distanceY
  );

  pointer.directionX = pointer.distanceX > 0 ? 'right' : pointer.distanceX < 0 ? 'left' : '';
  pointer.directionY = pointer.distanceY > 0 ? 'down' : pointer.distanceY < 0 ? 'up' : '';

  pointer.duration = +Date.now() - pointer.startTime;
  pointer.velocityX = pointer.distanceX / pointer.duration;
  pointer.velocityY = pointer.distanceY / pointer.duration;
}

/**
 * Normalize the point where the DOM event happened whether it's touch or mouse.
 * @returns point event obj with pageX and pageY on it.
 */
function getEventPoint(ev) {
  ev = ev.originalEvent || ev; // support jQuery events
  return (ev.touches && ev.touches[0]) ||
    (ev.changedTouches && ev.changedTouches[0]) ||
    ev;
}

/** Checks whether an element can be focused. */
function canFocus(element) {
  return (
    !!element &&
    element.getAttribute('tabindex') !== '-1' &&
    !element.hasAttribute('disabled') &&
    (
      element.hasAttribute('tabindex') ||
      element.hasAttribute('href') ||
      element.isContentEditable ||
      ['INPUT', 'SELECT', 'BUTTON', 'TEXTAREA', 'VIDEO', 'AUDIO'].indexOf(element.nodeName) !== -1
    )
  );
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.core.interaction
 * @description
 * User interaction detection to provide proper accessibility.
 */
MdInteractionService.$inject = ["$timeout", "$mdUtil", "$rootScope"];
angular
  .module('material.core.interaction', [])
  .service('$mdInteraction', MdInteractionService);


/**
 * @ngdoc service
 * @name $mdInteraction
 * @module material.core.interaction
 *
 * @description
 *
 * Service which keeps track of the last interaction type and validates them for several browsers.
 * The service hooks into the document's body and listens for touch, mouse and keyboard events.
 *
 * The most recent interaction type can be retrieved by calling the `getLastInteractionType` method.
 *
 * Here is an example markup for using the interaction service.
 *
 * <hljs lang="js">
 *   var lastType = $mdInteraction.getLastInteractionType();
 *
 *   if (lastType === 'keyboard') {
 *     // We only restore the focus for keyboard users.
 *     restoreFocus();
 *   }
 * </hljs>
 *
 */
function MdInteractionService($timeout, $mdUtil, $rootScope) {
  this.$timeout = $timeout;
  this.$mdUtil = $mdUtil;
  this.$rootScope = $rootScope;

  // IE browsers can also trigger pointer events, which also leads to an interaction.
  this.pointerEvent = 'MSPointerEvent' in window ? 'MSPointerDown' : 'PointerEvent' in window ? 'pointerdown' : null;
  this.bodyElement = angular.element(document.body);
  this.isBuffering = false;
  this.bufferTimeout = null;
  this.lastInteractionType = null;
  this.lastInteractionTime = null;
  this.inputHandler = this.onInputEvent.bind(this);
  this.bufferedInputHandler = this.onBufferInputEvent.bind(this);

  // Type Mappings for the different events
  // There will be three three interaction types
  // `keyboard`, `mouse` and `touch`
  // type `pointer` will be evaluated in `pointerMap` for IE Browser events
  this.inputEventMap = {
    'keydown': 'keyboard',
    'mousedown': 'mouse',
    'mouseenter': 'mouse',
    'touchstart': 'touch',
    'pointerdown': 'pointer',
    'MSPointerDown': 'pointer'
  };

  // IE PointerDown events will be validated in `touch` or `mouse`
  // Index numbers referenced here: https://msdn.microsoft.com/library/windows/apps/hh466130.aspx
  this.iePointerMap = {
    2: 'touch',
    3: 'touch',
    4: 'mouse'
  };

  this.initializeEvents();
  this.$rootScope.$on('$destroy', this.deregister.bind(this));
}

/**
 * Removes all event listeners created by $mdInteration on the
 * body element.
 */
MdInteractionService.prototype.deregister = function() {

    this.bodyElement.off('keydown mousedown', this.inputHandler);

    if ('ontouchstart' in document.documentElement) {
      this.bodyElement.off('touchstart', this.bufferedInputHandler);
    }

    if (this.pointerEvent) {
      this.bodyElement.off(this.pointerEvent, this.inputHandler);
    }

};

/**
 * Initializes the interaction service, by registering all interaction events to the
 * body element.
 */
MdInteractionService.prototype.initializeEvents = function() {

  this.bodyElement.on('keydown mousedown', this.inputHandler);

  if ('ontouchstart' in document.documentElement) {
    this.bodyElement.on('touchstart', this.bufferedInputHandler);
  }

  if (this.pointerEvent) {
    this.bodyElement.on(this.pointerEvent, this.inputHandler);
  }

};

/**
 * Event listener for normal interaction events, which should be tracked.
 * @param event {MouseEvent|KeyboardEvent|PointerEvent|TouchEvent}
 */
MdInteractionService.prototype.onInputEvent = function(event) {
  if (this.isBuffering) {
    return;
  }

  var type = this.inputEventMap[event.type];

  if (type === 'pointer') {
    type = this.iePointerMap[event.pointerType] || event.pointerType;
  }

  this.lastInteractionType = type;
  this.lastInteractionTime = this.$mdUtil.now();
};

/**
 * Event listener for interaction events which should be buffered (touch events).
 * @param event {TouchEvent}
 */
MdInteractionService.prototype.onBufferInputEvent = function(event) {
  this.$timeout.cancel(this.bufferTimeout);

  this.onInputEvent(event);
  this.isBuffering = true;

  // The timeout of 650ms is needed to delay the touchstart, because otherwise the touch will call
  // the `onInput` function multiple times.
  this.bufferTimeout = this.$timeout(function() {
    this.isBuffering = false;
  }.bind(this), 650, false);

};

/**
 * @ngdoc method
 * @name $mdInteraction#getLastInteractionType
 * @description Retrieves the last interaction type triggered in body.
 * @returns {string|null} Last interaction type.
 */
MdInteractionService.prototype.getLastInteractionType = function() {
  return this.lastInteractionType;
};

/**
 * @ngdoc method
 * @name $mdInteraction#isUserInvoked
 * @description Method to detect whether any interaction happened recently or not.
 * @param {number=} checkDelay Time to check for any interaction to have been triggered.
 * @returns {boolean} Whether there was any interaction or not.
 */
MdInteractionService.prototype.isUserInvoked = function(checkDelay) {
  var delay = angular.isNumber(checkDelay) ? checkDelay : 15;

  // Check for any interaction to be within the specified check time.
  return this.lastInteractionTime >= this.$mdUtil.now() - delay;
};

})();
(function(){
"use strict";

angular.module('material.core')
  .provider('$$interimElement', InterimElementProvider);

/**
 * @ngdoc service
 * @name $$interimElementProvider
 * @module material.core.interimElement
 *
 * @description
 *
 * Factory that constructs `$$interimElement.$service` services.
 * Used internally in material design for elements that appear on screen temporarily.
 * The service provides a promise-like API for interacting with the temporary
 * elements.
 *
 * <hljs lang="js">
 *   app.service('$mdToast', function($$interimElement) {
 *     var $mdToast = $$interimElement(toastDefaultOptions);
 *     return $mdToast;
 *   });
 * </hljs>
 *
 * @param {object=} defaultOptions Options used by default for the `show` method on the service.
 *
 * @returns {$$interimElement.$service}
 */

function InterimElementProvider() {
  InterimElementFactory.$inject = ["$document", "$q", "$rootScope", "$timeout", "$rootElement", "$animate", "$mdUtil", "$mdCompiler", "$mdTheming", "$injector", "$exceptionHandler"];
  createInterimElementProvider.$get = InterimElementFactory;
  return createInterimElementProvider;

  /**
   * Returns a new provider which allows configuration of a new interimElement
   * service. Allows configuration of default options & methods for options,
   * as well as configuration of 'preset' methods (eg dialog.basic(): basic is a preset method)
   */
  function createInterimElementProvider(interimFactoryName) {
    factory.$inject = ["$$interimElement", "$injector"];
    var EXPOSED_METHODS = ['onHide', 'onShow', 'onRemove'];

    var customMethods = {};
    var providerConfig = {
      presets: {}
    };

    var provider = {
      setDefaults: setDefaults,
      addPreset: addPreset,
      addMethod: addMethod,
      $get: factory
    };

    /**
     * all interim elements will come with the 'build' preset
     */
    provider.addPreset('build', {
      methods: ['controller', 'controllerAs', 'resolve', 'multiple',
        'template', 'templateUrl', 'themable', 'transformTemplate', 'parent', 'contentElement']
    });

    return provider;

    /**
     * Save the configured defaults to be used when the factory is instantiated
     */
    function setDefaults(definition) {
      providerConfig.optionsFactory = definition.options;
      providerConfig.methods = (definition.methods || []).concat(EXPOSED_METHODS);
      return provider;
    }

    /**
     * Add a method to the factory that isn't specific to any interim element operations
     */
    function addMethod(name, fn) {
      customMethods[name] = fn;
      return provider;
    }

    /**
     * Save the configured preset to be used when the factory is instantiated
     */
    function addPreset(name, definition) {
      definition = definition || {};
      definition.methods = definition.methods || [];
      definition.options = definition.options || function() { return {}; };

      if (/^cancel|hide|show$/.test(name)) {
        throw new Error("Preset '" + name + "' in " + interimFactoryName + " is reserved!");
      }
      if (definition.methods.indexOf('_options') > -1) {
        throw new Error("Method '_options' in " + interimFactoryName + " is reserved!");
      }
      providerConfig.presets[name] = {
        methods: definition.methods.concat(EXPOSED_METHODS),
        optionsFactory: definition.options,
        argOption: definition.argOption
      };
      return provider;
    }

    function addPresetMethod(presetName, methodName, method) {
      providerConfig.presets[presetName][methodName] = method;
    }

    /**
     * Create a factory that has the given methods & defaults implementing interimElement
     */
    /* @ngInject */
    function factory($$interimElement, $injector) {
      var defaultMethods;
      var defaultOptions;
      var interimElementService = $$interimElement();

      /*
       * publicService is what the developer will be using.
       * It has methods hide(), cancel(), show(), build(), and any other
       * presets which were set during the config phase.
       */
      var publicService = {
        hide: interimElementService.hide,
        cancel: interimElementService.cancel,
        show: showInterimElement,

        // Special internal method to destroy an interim element without animations
        // used when navigation changes causes a $scope.$destroy() action
        destroy : destroyInterimElement
      };


      defaultMethods = providerConfig.methods || [];
      // This must be invoked after the publicService is initialized
      defaultOptions = invokeFactory(providerConfig.optionsFactory, {});

      // Copy over the simple custom methods
      angular.forEach(customMethods, function(fn, name) {
        publicService[name] = fn;
      });

      angular.forEach(providerConfig.presets, function(definition, name) {
        var presetDefaults = invokeFactory(definition.optionsFactory, {});
        var presetMethods = (definition.methods || []).concat(defaultMethods);

        // Every interimElement built with a preset has a field called `$type`,
        // which matches the name of the preset.
        // Eg in preset 'confirm', options.$type === 'confirm'
        angular.extend(presetDefaults, { $type: name });

        // This creates a preset class which has setter methods for every
        // method given in the `.addPreset()` function, as well as every
        // method given in the `.setDefaults()` function.
        //
        // @example
        // .setDefaults({
        //   methods: ['hasBackdrop', 'clickOutsideToClose', 'escapeToClose', 'targetEvent'],
        //   options: dialogDefaultOptions
        // })
        // .addPreset('alert', {
        //   methods: ['title', 'ok'],
        //   options: alertDialogOptions
        // })
        //
        // Set values will be passed to the options when interimElement.show() is called.
        function Preset(opts) {
          this._options = angular.extend({}, presetDefaults, opts);
        }
        angular.forEach(presetMethods, function(name) {
          Preset.prototype[name] = function(value) {
            this._options[name] = value;
            return this;
          };
        });

        // Create shortcut method for one-linear methods
        if (definition.argOption) {
          var methodName = 'show' + name.charAt(0).toUpperCase() + name.slice(1);
          publicService[methodName] = function(arg) {
            var config = publicService[name](arg);
            return publicService.show(config);
          };
        }

        // eg $mdDialog.alert() will return a new alert preset
        publicService[name] = function(arg) {
          // If argOption is supplied, eg `argOption: 'content'`, then we assume
          // if the argument is not an options object then it is the `argOption` option.
          //
          // @example `$mdToast.simple('hello')` // sets options.content to hello
          //                                     // because argOption === 'content'
          if (arguments.length && definition.argOption &&
              !angular.isObject(arg) && !angular.isArray(arg))  {

            return (new Preset())[definition.argOption](arg);

          } else {
            return new Preset(arg);
          }

        };
      });

      return publicService;

      /**
       *
       */
      function showInterimElement(opts) {
        // opts is either a preset which stores its options on an _options field,
        // or just an object made up of options
        opts = opts || { };
        if (opts._options) opts = opts._options;

        return interimElementService.show(
          angular.extend({}, defaultOptions, opts)
        );
      }

      /**
       *  Special method to hide and destroy an interimElement WITHOUT
       *  any 'leave` or hide animations ( an immediate force hide/remove )
       *
       *  NOTE: This calls the onRemove() subclass method for each component...
       *  which must have code to respond to `options.$destroy == true`
       */
      function destroyInterimElement(opts) {
          return interimElementService.destroy(opts);
      }

      /**
       * Helper to call $injector.invoke with a local of the factory name for
       * this provider.
       * If an $mdDialog is providing options for a dialog and tries to inject
       * $mdDialog, a circular dependency error will happen.
       * We get around that by manually injecting $mdDialog as a local.
       */
      function invokeFactory(factory, defaultVal) {
        var locals = {};
        locals[interimFactoryName] = publicService;
        return $injector.invoke(factory || function() { return defaultVal; }, {}, locals);
      }
    }
  }

  /* @ngInject */
  function InterimElementFactory($document, $q, $rootScope, $timeout, $rootElement, $animate,
                                 $mdUtil, $mdCompiler, $mdTheming, $injector, $exceptionHandler) {
    return function createInterimElementService() {
      var SHOW_CANCELLED = false;

      /**
       * @ngdoc service
       * @name $$interimElementProvider.$service
       *
       * @description
       * A service used to control inserting and removing of an element from the DOM.
       * It is used by $mdBottomSheet, $mdDialog, $mdToast, $mdMenu, $mdPanel, and $mdSelect.
       */
      var service;

      var showPromises = []; // Promises for the interim's which are currently opening.
      var hidePromises = []; // Promises for the interim's which are currently hiding.
      var showingInterims = []; // Interim elements which are currently showing up.

      // Publish instance $$interimElement service;
      return service = {
        show: show,
        hide: waitForInterim(hide),
        cancel: waitForInterim(cancel),
        destroy : destroy,
        $injector_: $injector
      };

      /**
       * @ngdoc method
       * @name $$interimElementProvider.$service#show
       * @kind function
       *
       * @description
       * Adds the `$interimElement` to the DOM and returns a special promise that will be resolved
       * or rejected with hide or cancel, respectively.
       *
       * @param {Object} options map of options and values
       * @returns {Promise} a Promise that will be resolved when hide() is called or rejected when
       *  cancel() is called.
       */
      function show(options) {
        options = options || {};
        var interimElement = new InterimElement(options || {});

        // When an interim element is currently showing, we have to cancel it.
        // Just hiding it, will resolve the InterimElement's promise, the promise should be
        // rejected instead.
        var hideAction = options.multiple ? $q.resolve() : $q.all(showPromises);

        if (!options.multiple) {
          // Wait for all opening interim's to finish their transition.
          hideAction = hideAction.then(function() {
            // Wait for all closing and showing interim's to be completely closed.
            var promiseArray = hidePromises.concat(showingInterims.map(service.cancel));
            return $q.all(promiseArray);
          });
        }

        var showAction = hideAction.then(function() {

          return interimElement
            .show()
            .then(function () {
              showingInterims.push(interimElement);
            })
            .catch(function (reason) {
              return reason;
            })
            .finally(function() {
              showPromises.splice(showPromises.indexOf(showAction), 1);
            });

        });

        showPromises.push(showAction);

        // In AngularJS 1.6+, exceptions inside promises will cause a rejection. We need to handle
        // the rejection and only log it if it's an error.
        interimElement.deferred.promise.catch(function(fault) {
          if (fault instanceof Error) {
            $exceptionHandler(fault);
          }

          return fault;
        });

        // Return a promise that will be resolved when the interim
        // element is hidden or cancelled...
        return interimElement.deferred.promise;
      }

      /**
       * @ngdoc method
       * @name $$interimElementProvider.$service#hide
       * @kind function
       *
       * @description
       * Removes the `$interimElement` from the DOM and resolves the Promise returned from `show()`.
       *
       * @param {*} reason Data used to resolve the Promise
       * @param {object} options map of options and values
       * @returns {Promise} a Promise that will be resolved after the element has been removed
       *  from the DOM.
       */
      function hide(reason, options) {
        options = options || {};

        if (options.closeAll) {
          // We have to make a shallow copy of the array, because otherwise the map will break.
          return $q.all(showingInterims.slice().reverse().map(closeElement));
        } else if (options.closeTo !== undefined) {
          return $q.all(showingInterims.slice(options.closeTo).map(closeElement));
        }

        // Hide the latest showing interim element.
        return closeElement(showingInterims[showingInterims.length - 1]);

        /**
         * @param {InterimElement} interim element to close
         * @returns {Promise<InterimElement>}
         */
        function closeElement(interim) {
          if (!interim) {
            return $q.when(reason);
          }

          var hideAction = interim
            .remove(reason, false, options || { })
            .catch(function(reason) { return reason; })
            .finally(function() {
              hidePromises.splice(hidePromises.indexOf(hideAction), 1);
            });

          showingInterims.splice(showingInterims.indexOf(interim), 1);
          hidePromises.push(hideAction);

          return interim.deferred.promise;
        }
      }

      /**
       * @ngdoc method
       * @name $$interimElementProvider.$service#cancel
       * @kind function
       *
       * @description
       * Removes the `$interimElement` from the DOM and rejects the Promise returned from `show()`.
       *
       * @param {*} reason Data used to resolve the Promise
       * @param {object} options map of options and values
       * @returns {Promise} Promise that will be resolved after the element has been removed
       *  from the DOM.
       */
      function cancel(reason, options) {
        var interim = showingInterims.pop();
        if (!interim) {
          return $q.when(reason);
        }

        var cancelAction = interim
          .remove(reason, true, options || {})
          .catch(function(reason) { return reason; })
          .finally(function() {
            hidePromises.splice(hidePromises.indexOf(cancelAction), 1);
          });

        hidePromises.push(cancelAction);

        // Since AngularJS 1.6.7, promises will be logged to $exceptionHandler when the promise
        // is not handling the rejection. We create a pseudo catch handler, which will prevent the
        // promise from being logged to the $exceptionHandler.
        return interim.deferred.promise.catch(angular.noop);
      }

      /**
       * Creates a function to wait for at least one interim element to be available.
       * @param callbackFn Function to be used as callback
       * @returns {Function}
       */
      function waitForInterim(callbackFn) {
        return function() {
          var fnArguments = arguments;

          if (!showingInterims.length) {
            // When there are still interim's opening, then wait for the first interim element to
            // finish its open animation.
            if (showPromises.length) {
              return showPromises[0].finally(function () {
                return callbackFn.apply(service, fnArguments);
              });
            }

            return $q.when("No interim elements currently showing up.");
          }

          return callbackFn.apply(service, fnArguments);
        };
      }

      /**
       * @ngdoc method
       * @name $$interimElementProvider.$service#destroy
       * @kind function
       *
       * Special method to quick-remove the interim element without running animations. This is
       * useful when the parent component has been or is being destroyed.
       *
       * Note: interim elements are in "interim containers".
       */
      function destroy(targetEl) {
        var interim = !targetEl ? showingInterims.shift() : null;

        var parentEl = angular.element(targetEl).length && angular.element(targetEl)[0].parentNode;

        if (parentEl) {
          // Try to find the interim in the stack which corresponds to the supplied DOM element.
          var filtered = showingInterims.filter(function(entry) {
            return entry.options.element[0] === parentEl;
          });

          // Note: This function might be called when the element already has been removed,
          // in which case we won't find any matches.
          if (filtered.length) {
            interim = filtered[0];
            showingInterims.splice(showingInterims.indexOf(interim), 1);
          }
        }

        return interim ? interim.remove(SHOW_CANCELLED, false, { '$destroy': true }) :
                         $q.when(SHOW_CANCELLED);
      }

      /*
       * Internal Interim Element Object
       * Used internally to manage the DOM element and related data
       */
      function InterimElement(options) {
        var self, element, showAction = $q.when(true);

        options = configureScopeAndTransitions(options);

        return self = {
          options : options,
          deferred: $q.defer(),
          show    : createAndTransitionIn,
          remove  : transitionOutAndRemove
        };

        /**
         * Compile, link, and show this interim element. Use optional autoHide and transition-in
         * effects.
         * @return {Q.Promise}
         */
        function createAndTransitionIn() {
          return $q(function(resolve, reject) {

            // Trigger onCompiling callback before the compilation starts.
            // This is useful, when modifying options, which can be influenced by developers.
            options.onCompiling && options.onCompiling(options);

            compileElement(options)
              .then(function(compiledData) {
                element = linkElement(compiledData, options);

                // Expose the cleanup function from the compiler.
                options.cleanupElement = compiledData.cleanup;

                showAction = showElement(element, options, compiledData.controller)
                  .then(resolve, rejectAll);
              }).catch(rejectAll);

            function rejectAll(fault) {
              // Force the '$md<xxx>.show()' promise to reject
              self.deferred.reject(fault);

              // Continue rejection propagation
              reject(fault);
            }
          });
        }

        /**
         * After the show process has finished/rejected:
         * - announce 'removing',
         * - perform the transition-out, and
         * - perform optional clean up scope.
         */
        function transitionOutAndRemove(response, isCancelled, opts) {

          // abort if the show() and compile failed
          if (!element) return $q.when(false);

          options = angular.extend(options || {}, opts || {});
          options.cancelAutoHide && options.cancelAutoHide();
          options.element.triggerHandler('$mdInterimElementRemove');

          if (options.$destroy === true) {

            return hideElement(options.element, options).then(function(){
              (isCancelled && rejectAll(response)) || resolveAll(response);
            });

          } else {
            $q.when(showAction).finally(function() {
              hideElement(options.element, options).then(function() {
                isCancelled ? rejectAll(response) : resolveAll(response);
              }, rejectAll);
            });

            return self.deferred.promise;
          }


          /**
           * The `show()` returns a promise that will be resolved when the interim
           * element is hidden or cancelled...
           */
          function resolveAll(response) {
            self.deferred.resolve(response);
          }

          /**
           * Force the '$md<xxx>.show()' promise to reject
           */
          function rejectAll(fault) {
            self.deferred.reject(fault);
          }
        }

        /**
         * Prepare optional isolated scope and prepare $animate with default enter and leave
         * transitions for the new element instance.
         */
        function configureScopeAndTransitions(options) {
          options = options || { };
          if (options.template) {
            options.template = $mdUtil.processTemplate(options.template);
          }

          return angular.extend({
            preserveScope: false,
            cancelAutoHide : angular.noop,
            scope: options.scope || $rootScope.$new(options.isolateScope),

            /**
             * Default usage to enable $animate to transition-in; can be easily overridden via 'options'
             */
            onShow: function transitionIn(scope, element, options) {
              return $animate.enter(element, options.parent);
            },

            /**
             * Default usage to enable $animate to transition-out; can be easily overridden via 'options'
             */
            onRemove: function transitionOut(scope, element) {
              // Element could be undefined if a new element is shown before
              // the old one finishes compiling.
              return element && $animate.leave(element) || $q.when();
            }
          }, options);

        }

        /**
         * Compile an element with a templateUrl, controller, and locals
         * @param {Object} options
         * @return {Q.Promise<{element: JQLite=, link: Function, locals: Object, cleanup: any=,
         *  controller: Object=}>}
         */
        function compileElement(options) {

          var compiled = !options.skipCompile ? $mdCompiler.compile(options) : null;

          return compiled || $q(function (resolve) {
              resolve({
                locals: {},
                link: function () {
                  return options.element;
                }
              });
            });
        }

        /**
         * Link an element with compiled configuration
         * @param {{element: JQLite=, link: Function, locals: Object, controller: Object=}} compileData
         * @param {Object} options
         * @return {JQLite}
         */
        function linkElement(compileData, options) {
          angular.extend(compileData.locals, options);

          var element = compileData.link(options.scope);

          // Search for parent at insertion time, if not specified
          options.element = element;
          options.parent = findParent(element, options);
          if (options.themable) $mdTheming(element);

          return element;
        }

        /**
         * Search for parent at insertion time, if not specified.
         * @param {JQLite} element
         * @param {Object} options
         * @return {JQLite}
         */
        function findParent(element, options) {
          var parent = options.parent;

          // Search for parent at insertion time, if not specified
          if (angular.isFunction(parent)) {
            parent = parent(options.scope, element, options);
          } else if (angular.isString(parent)) {
            parent = angular.element($document[0].querySelector(parent));
          } else {
            parent = angular.element(parent);
          }

          // If parent querySelector/getter function fails, or it's just null,
          // find a default.
          if (!(parent || {}).length) {
            var el;
            if ($rootElement[0] && $rootElement[0].querySelector) {
              el = $rootElement[0].querySelector(':not(svg) > body');
            }
            if (!el) el = $rootElement[0];
            if (el.nodeName === '#comment') {
              el = $document[0].body;
            }
            return angular.element(el);
          }

          return parent;
        }

        /**
         * If auto-hide is enabled, start timer and prepare cancel function
         */
        function startAutoHide() {
          var autoHideTimer, cancelAutoHide = angular.noop;

          if (options.hideDelay) {
            autoHideTimer = $timeout(service.hide, options.hideDelay) ;
            cancelAutoHide = function() {
              $timeout.cancel(autoHideTimer);
            };
          }

          // Cache for subsequent use
          options.cancelAutoHide = function() {
            cancelAutoHide();
            options.cancelAutoHide = undefined;
          };
        }

        /**
         * Show the element (with transitions), notify complete and start optional auto hiding
         * timer.
         * @param {JQLite} element
         * @param {Object} options
         * @param {Object} controller
         * @return {Q.Promise<JQLite>}
         */
        function showElement(element, options, controller) {
          // Trigger onShowing callback before the `show()` starts
          var notifyShowing = options.onShowing || angular.noop;
          // Trigger onComplete callback when the `show()` finishes
          var notifyComplete = options.onComplete || angular.noop;

          // Necessary for consistency between AngularJS 1.5 and 1.6.
          try {
            // This fourth controller parameter is used by $mdDialog in beforeShow().
            notifyShowing(options.scope, element, options, controller);
          } catch (e) {
            return $q.reject(e);
          }

          return $q(function (resolve, reject) {
            try {
              // Start transitionIn
              $q.when(options.onShow(options.scope, element, options))
                .then(function () {
                  notifyComplete(options.scope, element, options);
                  startAutoHide();

                  resolve(element);
                }, reject);

            } catch (e) {
              reject(e.message);
            }
          });
        }

        function hideElement(element, options) {
          var announceRemoving = options.onRemoving || angular.noop;

          return $q(function (resolve, reject) {
            try {
              // Start transitionIn
              var action = $q.when(options.onRemove(options.scope, element, options) || true);

              // Trigger callback *before* the remove operation starts
              announceRemoving(element, action);

              if (options.$destroy) {
                // For $destroy, onRemove should be synchronous
                resolve(element);

                if (!options.preserveScope && options.scope) {
                  // scope destroy should still be be done after the current digest is done
                  action.then(function() { options.scope.$destroy(); });
                }
              } else {
                // Wait until transition-out is done
                action.then(function () {
                  if (!options.preserveScope && options.scope) {
                    options.scope.$destroy();
                  }

                  resolve(element);
                }, reject);
              }
            } catch (e) {
              reject(e.message);
            }
          });
        }

      }
    };
  }
}

})();
(function(){
"use strict";

(function() {
  'use strict';

  var $mdUtil, $interpolate, $log;

  var SUFFIXES = /(-gt)?-(sm|md|lg|print)/g;
  var WHITESPACE = /\s+/g;

  var FLEX_OPTIONS = ['grow', 'initial', 'auto', 'none', 'noshrink', 'nogrow'];
  var LAYOUT_OPTIONS = ['row', 'column'];
  var ALIGNMENT_MAIN_AXIS= ["", "start", "center", "end", "stretch", "space-around", "space-between"];
  var ALIGNMENT_CROSS_AXIS= ["", "start", "center", "end", "stretch"];

  var config = {
    /**
     * Enable directive attribute-to-class conversions
     * Developers can use `<body md-layout-css />` to quickly
     * disable the Layout directives and prohibit the injection of Layout classNames
     */
    enabled: true,

    /**
     * List of mediaQuery breakpoints and associated suffixes
     *   [
     *    { suffix: "sm", mediaQuery: "screen and (max-width: 599px)" },
     *    { suffix: "md", mediaQuery: "screen and (min-width: 600px) and (max-width: 959px)" }
     *   ]
     */
    breakpoints: []
  };

  registerLayoutAPI(angular.module('material.core.layout', ['ng']));

  /**
   *   registerLayoutAPI()
   *
   *   The original AngularJS Material Layout solution used attribute selectors and CSS.
   *
   *  ```html
   *  <div layout="column"> My Content </div>
   *  ```
   *
   *  ```css
   *  [layout] {
   *    box-sizing: border-box;
   *    display:flex;
   *  }
   *  [layout=column] {
   *    flex-direction : column
   *  }
   *  ```
   *
   *  Use of attribute selectors creates significant performance impacts in some
   *  browsers... mainly IE.
   *
   *  This module registers directives that allow the same layout attributes to be
   *  interpreted and converted to class selectors. The directive will add equivalent classes to
   *  each element that contains a Layout directive.
   *
   * ```html
   *   <div layout="column" class="layout layout-column"> My Content </div>
   * ```
   *
   *  ```css
   *  .layout {
   *    box-sizing: border-box;
   *    display:flex;
   *  }
   *  .layout-column {
   *    flex-direction : column
   *  }
   *  ```
   */
  function registerLayoutAPI(module){
    var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
    var SPECIAL_CHARS_REGEXP = /([:\-_]+(.))/g;

    // NOTE: these are also defined in constants::MEDIA_PRIORITY and constants::MEDIA
    var BREAKPOINTS     = ["", "xs", "gt-xs", "sm", "gt-sm", "md", "gt-md", "lg", "gt-lg", "xl", "print"];
    var API_WITH_VALUES = ["layout", "flex", "flex-order", "flex-offset", "layout-align"];
    var API_NO_VALUES   = ["show", "hide", "layout-padding", "layout-margin"];


    // Build directive registration functions for the standard Layout API... for all breakpoints.
    angular.forEach(BREAKPOINTS, function(mqb) {

      // Attribute directives with expected, observable value(s)
      angular.forEach(API_WITH_VALUES, function(name){
        var fullName = mqb ? name + "-" + mqb : name;
        module.directive(directiveNormalize(fullName), attributeWithObserve(fullName));
      });

      // Attribute directives with no expected value(s)
      angular.forEach(API_NO_VALUES, function(name){
        var fullName = mqb ? name + "-" + mqb : name;
        module.directive(directiveNormalize(fullName), attributeWithoutValue(fullName));
      });

    });

    // Register other, special directive functions for the Layout features:
    module
      .provider('$$mdLayout', function() {
        // Publish internal service for Layouts
        return {
          $get : angular.noop,
          validateAttributeValue : validateAttributeValue,
          validateAttributeUsage : validateAttributeUsage,
          /**
           * Easy way to disable/enable the Layout API.
           * When disabled, this stops all attribute-to-classname generations
           */
          disableLayouts  : function(isDisabled) {
            config.enabled =  (isDisabled !== true);
          }
        };
      })

      .directive('mdLayoutCss'        , disableLayoutDirective)
      .directive('ngCloak'            , buildCloakInterceptor('ng-cloak'))

      .directive('layoutWrap'   , attributeWithoutValue('layout-wrap'))
      .directive('layoutNowrap' , attributeWithoutValue('layout-nowrap'))
      .directive('layoutNoWrap' , attributeWithoutValue('layout-no-wrap'))
      .directive('layoutFill'   , attributeWithoutValue('layout-fill'))

      // Determine if
      .config(detectDisabledLayouts);

    /**
     * Converts snake_case to camelCase.
     * Also there is special case for Moz prefix starting with upper case letter.
     * @param name Name to normalize
     */
    function directiveNormalize(name) {
      return name
        .replace(PREFIX_REGEXP, '')
        .replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
          return offset ? letter.toUpperCase() : letter;
        });
    }
  }


  /**
    * Detect if any of the HTML tags has a [md-layouts-disabled] attribute;
    * If yes, then immediately disable all layout API features
    *
    * Note: this attribute should be specified on either the HTML or BODY tags
    * @ngInject
    */
   function detectDisabledLayouts() {
     var isDisabled = !!document.querySelector('[md-layouts-disabled]');
     config.enabled = !isDisabled;
   }

  /**
   * Special directive that will disable ALL Layout conversions of layout
   * attribute(s) to classname(s).
   *
   * <link rel="stylesheet" href="angular-material.min.css">
   * <link rel="stylesheet" href="angular-material.layout.css">
   *
   * <body md-layout-css>
   *  ...
   * </body>
   *
   * Note: Using md-layout-css directive requires the developer to load the Material
   * Layout Attribute stylesheet (which only uses attribute selectors):
   *
   *       `angular-material.layout.css`
   *
   * Another option is to use the LayoutProvider to configure and disable the attribute
   * conversions; this would obviate the use of the `md-layout-css` directive
   */
  function disableLayoutDirective() {
    // Return a 1x-only, first-match attribute directive
    config.enabled = false;

    return {
      restrict : 'A',
      priority : '900'
    };
  }

  /**
   * Tail-hook ngCloak to delay the uncloaking while Layout transformers
   * finish processing. Eliminates flicker with Material.Layouts
   */
  function buildCloakInterceptor(className) {
    return ['$timeout', function($timeout){
      return {
        restrict : 'A',
        priority : -10,   // run after normal ng-cloak
        compile  : function(element) {
          if (!config.enabled) return angular.noop;

          // Re-add the cloak
          element.addClass(className);

          return function(scope, element) {
            // Wait while layout injectors configure, then uncloak
            // NOTE: $rAF does not delay enough... and this is a 1x-only event,
            //       $timeout is acceptable.
            $timeout(function(){
              element.removeClass(className);
            }, 10, false);
          };
        }
      };
    }];
  }


  // *********************************************************************************
  //
  // These functions create registration functions for AngularJS Material Layout attribute
  // directives. This provides easy translation to switch AngularJS Material attribute selectors to
  // CLASS selectors and directives; which has huge performance implications for IE Browsers.
  //
  // *********************************************************************************

  /**
   * Creates a directive registration function where a possible dynamic attribute
   * value will be observed/watched.
   * @param {string} className attribute name; eg `layout-gt-md` with value ="row"
   */
  function attributeWithObserve(className) {

    return ['$mdUtil', '$interpolate', "$log", function(_$mdUtil_, _$interpolate_, _$log_) {
      $mdUtil = _$mdUtil_;
      $interpolate = _$interpolate_;
      $log = _$log_;

      return {
        restrict: 'A',
        compile: function(element, attr) {
          var linkFn;
          if (config.enabled) {
            // immediately replace static (non-interpolated) invalid values...

            validateAttributeUsage(className, attr, element, $log);

            validateAttributeValue(className,
              getNormalizedAttrValue(className, attr, ""),
              buildUpdateFn(element, className, attr)
            );

            linkFn = translateWithValueToCssClass;
          }

          // Use for postLink to account for transforms after ng-transclude.
          return linkFn || angular.noop;
        }
      };
    }];

    /**
     * Observe deprecated layout attributes and update the element's layout classes to match.
     */
    function translateWithValueToCssClass(scope, element, attrs) {
      var updateFn = updateClassWithValue(element, className, attrs);
      var unwatch = attrs.$observe(attrs.$normalize(className), updateFn);

      updateFn(getNormalizedAttrValue(className, attrs, ""));
      scope.$on("$destroy", function() { unwatch(); });
    }
  }

  /**
   * Creates a registration function for AngularJS Material Layout attribute directive.
   * This is a `simple` transpose of attribute usage to class usage; where we ignore
   * any attribute value.
   */
  function attributeWithoutValue(className) {
    return ['$mdUtil', '$interpolate', "$log", function(_$mdUtil_, _$interpolate_, _$log_) {
      $mdUtil = _$mdUtil_;
      $interpolate = _$interpolate_;
      $log = _$log_;

      return {
        restrict: 'A',
        compile: function(element, attr) {
          var linkFn;
          if (config.enabled) {
            // immediately replace static (non-interpolated) invalid values...

            validateAttributeValue(className,
              getNormalizedAttrValue(className, attr, ""),
              buildUpdateFn(element, className, attr)
            );

            translateToCssClass(null, element);

            // Use for postLink to account for transforms after ng-transclude.
            linkFn = translateToCssClass;
          }

          return linkFn || angular.noop;
        }
      };
    }];

    /**
     * Add transformed class selector.
     */
    function translateToCssClass(scope, element) {
      element.addClass(className);
    }
  }

  /**
   * After link-phase, do NOT remove deprecated layout attribute selector.
   * Instead watch the attribute so interpolated data-bindings to layout
   * selectors will continue to be supported.
   *
   * $observe() the className and update with new class (after removing the last one)
   *
   * e.g. `layout="{{layoutDemo.direction}}"` will update...
   *
   * NOTE: The value must match one of the specified styles in the CSS.
   * For example `flex-gt-md="{{size}}`  where `scope.size == 47` will NOT work since
   * only breakpoints for 0, 5, 10, 15... 100, 33, 34, 66, 67 are defined.
   */
  function updateClassWithValue(element, className) {
    var lastClass;

    return function updateClassFn(newValue) {
      var value = validateAttributeValue(className, newValue || "");
      if (angular.isDefined(value)) {
        if (lastClass) element.removeClass(lastClass);
        lastClass = !value ? className : className + "-" + value.trim().replace(WHITESPACE, "-");
        element.addClass(lastClass);
      }
    };
  }

  /**
   * Centralize warnings for known flexbox issues (especially IE-related issues)
   */
  function validateAttributeUsage(className, attr, element, $log){
    var message, usage, url;
    var nodeName = element[0].nodeName.toLowerCase();

    switch (className.replace(SUFFIXES,"")) {
      case "flex":
        if ((nodeName === "md-button") || (nodeName === "fieldset")){
          // @see https://github.com/philipwalton/flexbugs#9-some-html-elements-cant-be-flex-containers
          // Use <div flex> wrapper inside (preferred) or outside

          usage = "<" + nodeName + " " + className + "></" + nodeName + ">";
          url = "https://github.com/philipwalton/flexbugs#9-some-html-elements-cant-be-flex-containers";
          message = "Markup '{0}' may not work as expected in IE Browsers. Consult '{1}' for details.";

          $log.warn($mdUtil.supplant(message, [usage, url]));
        }
    }
  }


  /**
   * For the Layout attribute value, validate or replace with default fallback value.
   */
  function validateAttributeValue(className, value, updateFn) {
    var origValue = value;

    if (!needsInterpolation(value)) {
      switch (className.replace(SUFFIXES,"")) {
        case 'layout'        :
          if (!findIn(value, LAYOUT_OPTIONS)) {
            value = LAYOUT_OPTIONS[0];    // 'row';
          }
          break;

        case 'flex'          :
          if (!findIn(value, FLEX_OPTIONS)) {
            if (isNaN(value)) {
              value = '';
            }
          }
          break;

        case 'flex-offset' :
        case 'flex-order'    :
          if (!value || isNaN(+value)) {
            value = '0';
          }
          break;

        case 'layout-align'  :
          var axis = extractAlignAxis(value);
          value = $mdUtil.supplant("{main}-{cross}",axis);
          break;

        case 'layout-padding' :
        case 'layout-margin'  :
        case 'layout-fill'    :
        case 'layout-wrap'    :
        case 'layout-nowrap' :
          value = '';
          break;
      }

      if (value !== origValue) {
        (updateFn || angular.noop)(value);
      }
    }

    return value ? value.trim() : "";
  }

  /**
   * Replace current attribute value with fallback value
   */
  function buildUpdateFn(element, className, attrs) {
    return function updateAttrValue(fallback) {
      if (!needsInterpolation(fallback)) {
        // Do not modify the element's attribute value; so
        // uses '<ui-layout layout="/api/sidebar.html" />' will not
        // be affected. Just update the attrs value.
        attrs[attrs.$normalize(className)] = fallback;
      }
    };
  }

  /**
   * See if the original value has interpolation symbols:
   * e.g.  flex-gt-md="{{triggerPoint}}"
   */
  function needsInterpolation(value) {
    return (value || "").indexOf($interpolate.startSymbol()) > -1;
  }

  function getNormalizedAttrValue(className, attrs, defaultVal) {
    var normalizedAttr = attrs.$normalize(className);
    return attrs[normalizedAttr] ? attrs[normalizedAttr].trim().replace(WHITESPACE, "-") :
      defaultVal || null;
  }

  function findIn(item, list, replaceWith) {
    item = replaceWith && item ? item.replace(WHITESPACE, replaceWith) : item;

    var found = false;
    if (item) {
      list.forEach(function(it) {
        it = replaceWith ? it.replace(WHITESPACE, replaceWith) : it;
        found = found || (it === item);
      });
    }
    return found;
  }

  function extractAlignAxis(attrValue) {
    var axis = {
      main : "start",
      cross: "stretch"
    }, values;

    attrValue = (attrValue || "");

    if (attrValue.indexOf("-") === 0 || attrValue.indexOf(" ") === 0) {
      // For missing main-axis values
      attrValue = "none" + attrValue;
    }

    values = attrValue.toLowerCase().trim().replace(WHITESPACE, "-").split("-");
    if (values.length && (values[0] === "space")) {
      // for main-axis values of "space-around" or "space-between"
      values = [values[0]+"-"+values[1],values[2]];
    }

    if (values.length > 0) axis.main  = values[0] || axis.main;
    if (values.length > 1) axis.cross = values[1] || axis.cross;

    if (ALIGNMENT_MAIN_AXIS.indexOf(axis.main) < 0)   axis.main = "start";
    if (ALIGNMENT_CROSS_AXIS.indexOf(axis.cross) < 0) axis.cross = "stretch";

    return axis;
  }
})();

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.core.liveannouncer
 * @description
 * AngularJS Material Live Announcer to provide accessibility for Voice Readers.
 */
MdLiveAnnouncer.$inject = ["$timeout"];
angular
  .module('material.core')
  .service('$mdLiveAnnouncer', MdLiveAnnouncer);

/**
 * @ngdoc service
 * @name $mdLiveAnnouncer
 * @module material.core.liveannouncer
 *
 * @description
 *
 * Service to announce messages to supported screenreaders.
 *
 * > The `$mdLiveAnnouncer` service is internally used for components to provide proper accessibility.
 *
 * <hljs lang="js">
 *   module.controller('AppCtrl', function($mdLiveAnnouncer) {
 *     // Basic announcement (Polite Mode)
 *     $mdLiveAnnouncer.announce('Hey Google');
 *
 *     // Custom announcement (Assertive Mode)
 *     $mdLiveAnnouncer.announce('Hey Google', 'assertive');
 *   });
 * </hljs>
 *
 */
function MdLiveAnnouncer($timeout) {
  /** @private @const @type {!angular.$timeout} */
  this._$timeout = $timeout;

  /** @private @const @type {!HTMLElement} */
  this._liveElement = this._createLiveElement();

  /** @private @const @type {!number} */
  this._announceTimeout = 100;
}

/**
 * @ngdoc method
 * @name $mdLiveAnnouncer#announce
 * @description Announces messages to supported screenreaders.
 * @param {string} message Message to be announced to the screenreader
 * @param {'off'|'polite'|'assertive'} politeness The politeness of the announcer element.
 */
MdLiveAnnouncer.prototype.announce = function(message, politeness) {
  if (!politeness) {
    politeness = 'polite';
  }

  var self = this;

  self._liveElement.textContent = '';
  self._liveElement.setAttribute('aria-live', politeness);

  // This 100ms timeout is necessary for some browser + screen-reader combinations:
  // - Both JAWS and NVDA over IE11 will not announce anything without a non-zero timeout.
  // - With Chrome and IE11 with NVDA or JAWS, a repeated (identical) message won't be read a
  //   second time without clearing and then using a non-zero delay.
  // (using JAWS 17 at time of this writing).
  self._$timeout(function() {
    self._liveElement.textContent = message;
  }, self._announceTimeout, false);
};

/**
 * Creates a live announcer element, which listens for DOM changes and announces them
 * to the screenreaders.
 * @returns {!HTMLElement}
 * @private
 */
MdLiveAnnouncer.prototype._createLiveElement = function() {
  var liveEl = document.createElement('div');

  liveEl.classList.add('md-visually-hidden');
  liveEl.setAttribute('role', 'status');
  liveEl.setAttribute('aria-atomic', 'true');
  liveEl.setAttribute('aria-live', 'polite');

  document.body.appendChild(liveEl);

  return liveEl;
};

})();
(function(){
"use strict";

/**
 * @ngdoc service
 * @name $$mdMeta
 * @module material.core.meta
 *
 * @description
 *
 * A provider and a service that simplifies meta tags access
 *
 * Note: This is intended only for use with dynamic meta tags such as browser color and title.
 * Tags that are only processed when the page is rendered (such as `charset`, and `http-equiv`)
 * will not work since `$$mdMeta` adds the tags after the page has already been loaded.
 *
 * ```js
 * app.config(function($$mdMetaProvider) {
 *   var removeMeta = $$mdMetaProvider.setMeta('meta-name', 'content');
 *   var metaValue  = $$mdMetaProvider.getMeta('meta-name'); // -> 'content'
 *
 *   removeMeta();
 * });
 *
 * app.controller('myController', function($$mdMeta) {
 *   var removeMeta = $$mdMeta.setMeta('meta-name', 'content');
 *   var metaValue  = $$mdMeta.getMeta('meta-name'); // -> 'content'
 *
 *   removeMeta();
 * });
 * ```
 *
 * @returns {$$mdMeta.$service}
 *
 */
angular.module('material.core.meta', [])
  .provider('$$mdMeta', function () {
    var head = angular.element(document.head);
    var metaElements = {};

    /**
     * Checks if the requested element was written manually and maps it
     *
     * @param {string} name meta tag 'name' attribute value
     * @returns {boolean} returns true if there is an element with the requested name
     */
    function mapExistingElement(name) {
      if (metaElements[name]) {
        return true;
      }

      var element = document.getElementsByName(name)[0];

      if (!element) {
        return false;
      }

      metaElements[name] = angular.element(element);

      return true;
    }

    /**
     * @ngdoc method
     * @name $$mdMeta#setMeta
     *
     * @description
     * Creates meta element with the 'name' and 'content' attributes,
     * if the meta tag is already created than we replace the 'content' value
     *
     * @param {string} name meta tag 'name' attribute value
     * @param {string} content meta tag 'content' attribute value
     * @returns {function} remove function
     *
     */
    function setMeta(name, content) {
      mapExistingElement(name);

      if (!metaElements[name]) {
        var newMeta = angular.element('<meta name="' + name + '" content="' + content + '"/>');
        head.append(newMeta);
        metaElements[name] = newMeta;
      }
      else {
        metaElements[name].attr('content', content);
      }

      return function () {
        metaElements[name].attr('content', '');
        metaElements[name].remove();
        delete metaElements[name];
      };
    }

    /**
     * @ngdoc method
     * @name $$mdMeta#getMeta
     *
     * @description
     * Gets the 'content' attribute value of the wanted meta element
     *
     * @param {string} name meta tag 'name' attribute value
     * @returns {string} content attribute value
     */
    function getMeta(name) {
      if (!mapExistingElement(name)) {
        throw Error('$$mdMeta: could not find a meta tag with the name \'' + name + '\'');
      }

      return metaElements[name].attr('content');
    }

    var module = {
      setMeta: setMeta,
      getMeta: getMeta
    };

    return angular.extend({}, module, {
      $get: function () {
        return module;
      }
    });
  });
})();
(function(){
"use strict";

  /**
   * @ngdoc module
   * @name material.core.componentRegistry
   *
   * @description
   * A component instance registration service.
   * Note: currently this as a private service in the SideNav component.
   */
  ComponentRegistry.$inject = ["$log", "$q"];
  angular.module('material.core')
    .factory('$mdComponentRegistry', ComponentRegistry);

  /*
   * @private
   * @ngdoc factory
   * @name ComponentRegistry
   * @module material.core.componentRegistry
   *
   */
  function ComponentRegistry($log, $q) {

    var self;
    var instances = [];
    var pendings = { };

    return self = {
      /**
       * Used to print an error when an instance for a handle isn't found.
       */
      notFoundError: function(handle, msgContext) {
        $log.error((msgContext || "") + 'No instance found for handle', handle);
      },
      /**
       * Return all registered instances as an array.
       */
      getInstances: function() {
        return instances;
      },

      /**
       * Get a registered instance.
       * @param handle the String handle to look up for a registered instance.
       */
      get: function(handle) {
        if (!isValidID(handle)) return null;

        var i, j, instance;
        for (i = 0, j = instances.length; i < j; i++) {
          instance = instances[i];
          if (instance.$$mdHandle === handle) {
            return instance;
          }
        }
        return null;
      },

      /**
       * Register an instance.
       * @param instance the instance to register
       * @param handle the handle to identify the instance under.
       */
      register: function(instance, handle) {
        if (!handle) return angular.noop;

        instance.$$mdHandle = handle;
        instances.push(instance);
        resolveWhen();

        return deregister;

        /**
         * Remove registration for an instance
         */
        function deregister() {
          var index = instances.indexOf(instance);
          if (index !== -1) {
            instances.splice(index, 1);
          }
        }

        /**
         * Resolve any pending promises for this instance
         */
        function resolveWhen() {
          var dfd = pendings[handle];
          if (dfd) {
            dfd.forEach(function (promise) {
              promise.resolve(instance);
            });
            delete pendings[handle];
          }
        }
      },

      /**
       * Async accessor to registered component instance
       * If not available then a promise is created to notify
       * all listeners when the instance is registered.
       */
      when : function(handle) {
        if (isValidID(handle)) {
          var deferred = $q.defer();
          var instance = self.get(handle);

          if (instance)  {
            deferred.resolve(instance);
          } else {
            if (pendings[handle] === undefined) {
              pendings[handle] = [];
            }
            pendings[handle].push(deferred);
          }

          return deferred.promise;
        }
        return $q.reject("Invalid `md-component-id` value.");
      }

    };

    function isValidID(handle){
      return handle && (handle !== "");
    }

  }

})();
(function(){
"use strict";

(function() {
  'use strict';

  /**
   * @ngdoc service
   * @name $mdButtonInkRipple
   * @module material.core
   *
   * @description
   * Provides ripple effects for md-button.  See $mdInkRipple service for all possible configuration options.
   *
   * @param {object=} scope Scope within the current context
   * @param {object=} element The element the ripple effect should be applied to
   * @param {object=} options (Optional) Configuration options to override the default ripple configuration
   */

  MdButtonInkRipple.$inject = ["$mdInkRipple"];
  angular.module('material.core')
    .factory('$mdButtonInkRipple', MdButtonInkRipple);

  function MdButtonInkRipple($mdInkRipple) {
    return {
      attach: function attachRipple(scope, element, options) {
        options = angular.extend(optionsForElement(element), options);

        return $mdInkRipple.attach(scope, element, options);
      }
    };

    function optionsForElement(element) {
      if (element.hasClass('md-icon-button')) {
        return {
          isMenuItem: element.hasClass('md-menu-item'),
          fitRipple: true,
          center: true
        };
      } else {
        return {
          isMenuItem: element.hasClass('md-menu-item'),
          dimBackground: true
        };
      }
    }
  }
})();

})();
(function(){
"use strict";

(function() {
  'use strict';

    /**
   * @ngdoc service
   * @name $mdCheckboxInkRipple
   * @module material.core
   *
   * @description
   * Provides ripple effects for md-checkbox.  See $mdInkRipple service for all possible configuration options.
   *
   * @param {object=} scope Scope within the current context
   * @param {object=} element The element the ripple effect should be applied to
   * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
   */

  MdCheckboxInkRipple.$inject = ["$mdInkRipple"];
  angular.module('material.core')
    .factory('$mdCheckboxInkRipple', MdCheckboxInkRipple);

  function MdCheckboxInkRipple($mdInkRipple) {
    return {
      attach: attach
    };

    function attach(scope, element, options) {
      return $mdInkRipple.attach(scope, element, angular.extend({
        center: true,
        dimBackground: false,
        fitRipple: true
      }, options));
    }
  }
})();

})();
(function(){
"use strict";

(function() {
  'use strict';

  /**
   * @ngdoc service
   * @name $mdListInkRipple
   * @module material.core
   *
   * @description
   * Provides ripple effects for md-list.  See $mdInkRipple service for all possible configuration options.
   *
   * @param {object=} scope Scope within the current context
   * @param {object=} element The element the ripple effect should be applied to
   * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
   */

  MdListInkRipple.$inject = ["$mdInkRipple"];
  angular.module('material.core')
    .factory('$mdListInkRipple', MdListInkRipple);

  function MdListInkRipple($mdInkRipple) {
    return {
      attach: attach
    };

    function attach(scope, element, options) {
      return $mdInkRipple.attach(scope, element, angular.extend({
        center: false,
        dimBackground: true,
        outline: false,
        rippleSize: 'full'
      }, options));
    }
  }
})();

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.core.ripple
 * @description
 * Ripple
 */
InkRippleCtrl.$inject = ["$scope", "$element", "rippleOptions", "$window", "$timeout", "$mdUtil", "$mdColorUtil"];
InkRippleDirective.$inject = ["$mdButtonInkRipple", "$mdCheckboxInkRipple"];
angular.module('material.core')
    .provider('$mdInkRipple', InkRippleProvider)
    .directive('mdInkRipple', InkRippleDirective)
    .directive('mdNoInk', attrNoDirective)
    .directive('mdNoBar', attrNoDirective)
    .directive('mdNoStretch', attrNoDirective);

var DURATION = 450;

/**
 * @ngdoc directive
 * @name mdInkRipple
 * @module material.core.ripple
 *
 * @description
 * The `md-ink-ripple` directive allows you to specify the ripple color or if a ripple is allowed.
 *
 * @param {string|boolean} md-ink-ripple A color string `#FF0000` or boolean (`false` or `0`) for
 *  preventing ripple
 *
 * @usage
 * ### String values
 * <hljs lang="html">
 *   <ANY md-ink-ripple="#FF0000">
 *     Ripples in red
 *   </ANY>
 *
 *   <ANY md-ink-ripple="false">
 *     Not rippling
 *   </ANY>
 * </hljs>
 *
 * ### Interpolated values
 * <hljs lang="html">
 *   <ANY md-ink-ripple="{{ randomColor() }}">
 *     Ripples with the return value of 'randomColor' function
 *   </ANY>
 *
 *   <ANY md-ink-ripple="{{ canRipple() }}">
 *     Ripples if 'canRipple' function return value is not 'false' or '0'
 *   </ANY>
 * </hljs>
 */
function InkRippleDirective ($mdButtonInkRipple, $mdCheckboxInkRipple) {
  return {
    controller: angular.noop,
    link:       function (scope, element, attr) {
      attr.hasOwnProperty('mdInkRippleCheckbox')
          ? $mdCheckboxInkRipple.attach(scope, element)
          : $mdButtonInkRipple.attach(scope, element);
    }
  };
}

/**
 * @ngdoc service
 * @name $mdInkRipple
 * @module material.core.ripple
 *
 * @description
 * `$mdInkRipple` is a service for adding ripples to any element.
 *
 * @usage
 * <hljs lang="js">
 * app.factory('$myElementInkRipple', function($mdInkRipple) {
 *   return {
 *     attach: function (scope, element, options) {
 *       return $mdInkRipple.attach(scope, element, angular.extend({
 *         center: false,
 *         dimBackground: true
 *       }, options));
 *     }
 *   };
 * });
 *
 * app.controller('myController', function ($scope, $element, $myElementInkRipple) {
 *   $scope.onClick = function (ev) {
 *     $myElementInkRipple.attach($scope, angular.element(ev.target), { center: true });
 *   }
 * });
 * </hljs>
 */

/**
 * @ngdoc service
 * @name $mdInkRippleProvider
 * @module material.core.ripple
 *
 * @description
  * If you want to disable ink ripples globally, for all components, you can call the
 * `disableInkRipple` method in your app's config.
 *
 *
 * @usage
 * <hljs lang="js">
 * app.config(function ($mdInkRippleProvider) {
 *   $mdInkRippleProvider.disableInkRipple();
 * });
 * </hljs>
 */

function InkRippleProvider () {
  var isDisabledGlobally = false;

  return {
    disableInkRipple: disableInkRipple,
    $get: ["$injector", function($injector) {
      return { attach: attach };

      /**
       * @ngdoc method
       * @name $mdInkRipple#attach
       *
       * @description
       * Attaching given scope, element and options to inkRipple controller
       *
       * @param {object=} scope Scope within the current context
       * @param {object=} element The element the ripple effect should be applied to
       * @param {object=} options (Optional) Configuration options to override the defaultRipple configuration
       * * `center` -  Whether the ripple should start from the center of the container element
       * * `dimBackground` - Whether the background should be dimmed with the ripple color
       * * `colorElement` - The element the ripple should take its color from, defined by css property `color`
       * * `fitRipple` - Whether the ripple should fill the element
       */
      function attach (scope, element, options) {
        if (isDisabledGlobally || element.controller('mdNoInk')) return angular.noop;
        return $injector.instantiate(InkRippleCtrl, {
          $scope:        scope,
          $element:      element,
          rippleOptions: options
        });
      }
    }]
  };

  /**
   * @ngdoc method
   * @name $mdInkRippleProvider#disableInkRipple
   *
   * @description
   * A config-time method that, when called, disables ripples globally.
   */
  function disableInkRipple () {
    isDisabledGlobally = true;
  }
}

/**
 * Controller used by the ripple service in order to apply ripples
 * @ngInject
 */
function InkRippleCtrl ($scope, $element, rippleOptions, $window, $timeout, $mdUtil, $mdColorUtil) {
  this.$window    = $window;
  this.$timeout   = $timeout;
  this.$mdUtil    = $mdUtil;
  this.$mdColorUtil    = $mdColorUtil;
  this.$scope     = $scope;
  this.$element   = $element;
  this.options    = rippleOptions;
  this.mousedown  = false;
  this.ripples    = [];
  this.timeout    = null; // Stores a reference to the most-recent ripple timeout
  this.lastRipple = null;

  $mdUtil.valueOnUse(this, 'container', this.createContainer);

  this.$element.addClass('md-ink-ripple');

  // attach method for unit tests
  ($element.controller('mdInkRipple') || {}).createRipple = angular.bind(this, this.createRipple);
  ($element.controller('mdInkRipple') || {}).setColor = angular.bind(this, this.color);

  this.bindEvents();
}


/**
 * Either remove or unlock any remaining ripples when the user mouses off of the element (either by
 * mouseup or mouseleave event)
 */
function autoCleanup (self, cleanupFn) {
  if (self.mousedown || self.lastRipple) {
    self.mousedown = false;
    self.$mdUtil.nextTick(angular.bind(self, cleanupFn), false);
  }
}


/**
 * Returns the color that the ripple should be (either based on CSS or hard-coded)
 * @returns {string}
 */
InkRippleCtrl.prototype.color = function (value) {
  var self = this;

  // If assigning a color value, apply it to background and the ripple color
  if (angular.isDefined(value)) {
    self._color = self._parseColor(value);
  }

  // If color lookup, use assigned, defined, or inherited
  return self._color || self._parseColor(self.inkRipple()) || self._parseColor(getElementColor());

  /**
   * Finds the color element and returns its text color for use as default ripple color
   * @returns {string}
   */
  function getElementColor () {
    var items = self.options && self.options.colorElement ? self.options.colorElement : [];
    var elem =  items.length ? items[ 0 ] : self.$element[ 0 ];

    return elem ? self.$window.getComputedStyle(elem).color : 'rgb(0,0,0)';
  }
};

/**
 * Updating the ripple colors based on the current inkRipple value
 * or the element's computed style color
 */
InkRippleCtrl.prototype.calculateColor = function () {
  return this.color();
};


/**
 * Takes a string color and converts it to RGBA format
 * @param {string} color
 * @param {number} multiplier
 * @returns {string}
 */
InkRippleCtrl.prototype._parseColor = function parseColor (color, multiplier) {
  multiplier = multiplier || 1;
  var colorUtil = this.$mdColorUtil;

  if (!color) return;
  if (color.indexOf('rgba') === 0) return color.replace(/\d?\.?\d*\s*\)\s*$/, (0.1 * multiplier).toString() + ')');
  if (color.indexOf('rgb') === 0) return colorUtil.rgbToRgba(color);
  if (color.indexOf('#') === 0) return colorUtil.hexToRgba(color);

};

/**
 * Binds events to the root element for
 */
InkRippleCtrl.prototype.bindEvents = function () {
  this.$element.on('mousedown', angular.bind(this, this.handleMousedown));
  this.$element.on('mouseup touchend', angular.bind(this, this.handleMouseup));
  this.$element.on('mouseleave', angular.bind(this, this.handleMouseup));
  this.$element.on('touchmove', angular.bind(this, this.handleTouchmove));
};

/**
 * Create a new ripple on every mousedown event from the root element
 * @param event {MouseEvent}
 */
InkRippleCtrl.prototype.handleMousedown = function (event) {
  if (this.mousedown) return;

  // When jQuery is loaded, we have to get the original event
  if (event.hasOwnProperty('originalEvent')) event = event.originalEvent;
  this.mousedown = true;
  if (this.options.center) {
    this.createRipple(this.container.prop('clientWidth') / 2, this.container.prop('clientWidth') / 2);
  } else {

    // We need to calculate the relative coordinates if the target is a sublayer of the ripple element
    if (event.srcElement !== this.$element[0]) {
      var layerRect = this.$element[0].getBoundingClientRect();
      var layerX = event.clientX - layerRect.left;
      var layerY = event.clientY - layerRect.top;

      this.createRipple(layerX, layerY);
    } else {
      this.createRipple(event.offsetX, event.offsetY);
    }
  }
};

/**
 * Either remove or unlock any remaining ripples when the user mouses off of the element (either by
 * mouseup, touchend or mouseleave event)
 */
InkRippleCtrl.prototype.handleMouseup = function () {
  this.$timeout(function () {
    autoCleanup(this, this.clearRipples);
  }.bind(this));
};

/**
 * Either remove or unlock any remaining ripples when the user mouses off of the element (by
 * touchmove)
 */
InkRippleCtrl.prototype.handleTouchmove = function () {
  autoCleanup(this, this.deleteRipples);
};

/**
 * Cycles through all ripples and attempts to remove them.
 */
InkRippleCtrl.prototype.deleteRipples = function () {
  for (var i = 0; i < this.ripples.length; i++) {
    this.ripples[ i ].remove();
  }
};

/**
 * Cycles through all ripples and attempts to remove them with fade.
 * Depending on logic within `fadeInComplete`, some removals will be postponed.
 */
InkRippleCtrl.prototype.clearRipples = function () {
  for (var i = 0; i < this.ripples.length; i++) {
    this.fadeInComplete(this.ripples[ i ]);
  }
};

/**
 * Creates the ripple container element
 * @returns {*}
 */
InkRippleCtrl.prototype.createContainer = function () {
  var container = angular.element('<div class="md-ripple-container"></div>');
  this.$element.append(container);
  return container;
};

InkRippleCtrl.prototype.clearTimeout = function () {
  if (this.timeout) {
    this.$timeout.cancel(this.timeout);
    this.timeout = null;
  }
};

InkRippleCtrl.prototype.isRippleAllowed = function () {
  var element = this.$element[0];
  do {
    if (!element.tagName || element.tagName === 'BODY') break;

    if (element && angular.isFunction(element.hasAttribute)) {
      if (element.hasAttribute('disabled')) return false;
      if (this.inkRipple() === 'false' || this.inkRipple() === '0') return false;
    }

  } while (element = element.parentNode);
  return true;
};

/**
 * The attribute `md-ink-ripple` may be a static or interpolated
 * color value OR a boolean indicator (used to disable ripples)
 */
InkRippleCtrl.prototype.inkRipple = function () {
  return this.$element.attr('md-ink-ripple');
};

/**
 * Creates a new ripple and adds it to the container.  Also tracks ripple in `this.ripples`.
 * @param left
 * @param top
 */
InkRippleCtrl.prototype.createRipple = function (left, top) {
  if (!this.isRippleAllowed()) return;

  var ctrl        = this;
  var colorUtil   = ctrl.$mdColorUtil;
  var ripple      = angular.element('<div class="md-ripple"></div>');
  var width       = this.$element.prop('clientWidth');
  var height      = this.$element.prop('clientHeight');
  var x           = Math.max(Math.abs(width - left), left) * 2;
  var y           = Math.max(Math.abs(height - top), top) * 2;
  var size        = getSize(this.options.fitRipple, x, y);
  var color       = this.calculateColor();

  ripple.css({
    left:            left + 'px',
    top:             top + 'px',
    background:      'black',
    width:           size + 'px',
    height:          size + 'px',
    backgroundColor: colorUtil.rgbaToRgb(color),
    borderColor:     colorUtil.rgbaToRgb(color)
  });
  this.lastRipple = ripple;

  // we only want one timeout to be running at a time
  this.clearTimeout();
  this.timeout    = this.$timeout(function () {
    ctrl.clearTimeout();
    if (!ctrl.mousedown) ctrl.fadeInComplete(ripple);
  }, DURATION * 0.35, false);

  if (this.options.dimBackground) this.container.css({ backgroundColor: color });
  this.container.append(ripple);
  this.ripples.push(ripple);
  ripple.addClass('md-ripple-placed');

  this.$mdUtil.nextTick(function () {

    ripple.addClass('md-ripple-scaled md-ripple-active');
    ctrl.$timeout(function () {
      ctrl.clearRipples();
    }, DURATION, false);

  }, false);

  function getSize (fit, x, y) {
    return fit
        ? Math.max(x, y)
        : Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
  }
};



/**
 * After fadeIn finishes, either kicks off the fade-out animation or queues the element for removal on mouseup
 * @param ripple
 */
InkRippleCtrl.prototype.fadeInComplete = function (ripple) {
  if (this.lastRipple === ripple) {
    if (!this.timeout && !this.mousedown) {
      this.removeRipple(ripple);
    }
  } else {
    this.removeRipple(ripple);
  }
};

/**
 * Kicks off the animation for removing a ripple
 * @param ripple {Element}
 */
InkRippleCtrl.prototype.removeRipple = function (ripple) {
  var ctrl  = this;
  var index = this.ripples.indexOf(ripple);
  if (index < 0) return;
  this.ripples.splice(this.ripples.indexOf(ripple), 1);
  ripple.removeClass('md-ripple-active');
  ripple.addClass('md-ripple-remove');
  if (this.ripples.length === 0) this.container.css({ backgroundColor: '' });
  // use a 2-second timeout in order to allow for the animation to finish
  // we don't actually care how long the animation takes
  this.$timeout(function () {
    ctrl.fadeOutComplete(ripple);
  }, DURATION, false);
};

/**
 * Removes the provided ripple from the DOM
 * @param ripple
 */
InkRippleCtrl.prototype.fadeOutComplete = function (ripple) {
  ripple.remove();
  this.lastRipple = null;
};

/**
 * Used to create an empty directive.  This is used to track flag-directives whose children may have
 * functionality based on them.
 *
 * Example: `md-no-ink` will potentially be used by all child directives.
 */
function attrNoDirective () {
  return { controller: angular.noop };
}

})();
(function(){
"use strict";

(function() {
  'use strict';

    /**
   * @ngdoc service
   * @name $mdTabInkRipple
   * @module material.core
   *
   * @description
   * Provides ripple effects for md-tabs.  See $mdInkRipple service for all possible configuration options.
   *
   * @param {object=} scope Scope within the current context
   * @param {object=} element The element the ripple effect should be applied to
   * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
   */

  MdTabInkRipple.$inject = ["$mdInkRipple"];
  angular.module('material.core')
    .factory('$mdTabInkRipple', MdTabInkRipple);

  function MdTabInkRipple($mdInkRipple) {
    return {
      attach: attach
    };

    function attach(scope, element, options) {
      return $mdInkRipple.attach(scope, element, angular.extend({
        center: false,
        dimBackground: true,
        outline: false,
        rippleSize: 'full'
      }, options));
    }
  }
})();

})();
(function(){
"use strict";

angular.module('material.core.theming.palette', [])
.constant('$mdColorPalette', {
  'red': {
    '50': '#ffebee',
    '100': '#ffcdd2',
    '200': '#ef9a9a',
    '300': '#e57373',
    '400': '#ef5350',
    '500': '#f44336',
    '600': '#e53935',
    '700': '#d32f2f',
    '800': '#c62828',
    '900': '#b71c1c',
    'A100': '#ff8a80',
    'A200': '#ff5252',
    'A400': '#ff1744',
    'A700': '#d50000',
    'contrastDefaultColor': 'light',
    'contrastDarkColors': '50 100 200 300 400 500 600 A100 A200 A400',
    'contrastStrongLightColors': '700 800 900 A700'
  },
  'pink': {
    '50': '#fce4ec',
    '100': '#f8bbd0',
    '200': '#f48fb1',
    '300': '#f06292',
    '400': '#ec407a',
    '500': '#e91e63',
    '600': '#d81b60',
    '700': '#c2185b',
    '800': '#ad1457',
    '900': '#880e4f',
    'A100': '#ff80ab',
    'A200': '#ff4081',
    'A400': '#f50057',
    'A700': '#c51162',
    'contrastDefaultColor': 'light',
    'contrastDarkColors': '50 100 200 300 400 A100 A200 A400',
    // White on 500 does not meet the minimum 4.5 contrast ratio (at 4.34),
    // but it's worse with a dark foreground (3.61).
    'contrastStrongLightColors': '500 600 700 800 900 A700'
  },
  'purple': {
    '50': '#f3e5f5',
    '100': '#e1bee7',
    '200': '#ce93d8',
    '300': '#ba68c8',
    '400': '#ab47bc',
    '500': '#9c27b0',
    '600': '#8e24aa',
    '700': '#7b1fa2',
    '800': '#6a1b9a',
    '900': '#4a148c',
    'A100': '#ea80fc',
    'A200': '#e040fb',
    'A400': '#d500f9',
    'A700': '#aa00ff',
    'contrastDefaultColor': 'light',
    'contrastDarkColors': '50 100 200 300 A100 A200 A400',
    'contrastStrongLightColors': '400 500 600 700 800 900 A700'
  },
  'deep-purple': {
    '50': '#ede7f6',
    '100': '#d1c4e9',
    '200': '#b39ddb',
    '300': '#9575cd',
    '400': '#7e57c2',
    '500': '#673ab7',
    '600': '#5e35b1',
    '700': '#512da8',
    '800': '#4527a0',
    '900': '#311b92',
    'A100': '#b388ff',
    'A200': '#7c4dff',
    'A400': '#651fff',
    'A700': '#6200ea',
    'contrastDefaultColor': 'light',
    'contrastDarkColors': '50 100 200 300 A100',
    'contrastStrongLightColors': '400 500 600 700 800 900 A200 A400 A700'
  },
  'indigo': {
    '50': '#e8eaf6',
    '100': '#c5cae9',
    '200': '#9fa8da',
    '300': '#7986cb',
    '400': '#5c6bc0',
    '500': '#3f51b5',
    '600': '#3949ab',
    '700': '#303f9f',
    '800': '#283593',
    '900': '#1a237e',
    'A100': '#8c9eff',
    'A200': '#536dfe',
    'A400': '#3d5afe',
    'A700': '#304ffe',
    'contrastDefaultColor': 'light',
    'contrastDarkColors': '50 100 200 300 A100 A200',
    'contrastStrongLightColors': '400 500 600 700 800 900 A400 A700'
  },
  'blue': {
    '50': '#e3f2fd',
    '100': '#bbdefb',
    '200': '#90caf9',
    '300': '#64b5f6',
    '400': '#42a5f5',
    '500': '#2196f3',
    '600': '#1e88e5',
    '700': '#1976d2',
    '800': '#1565c0',
    '900': '#0d47a1',
    'A100': '#82b1ff',
    'A200': '#448aff',
    'A400': '#2979ff',
    'A700': '#2962ff',
    'contrastDefaultColor': 'light',
    // White on A400 does not meet the minimum 4.5 contrast ratio (at 3.98),
    // but it's worse with a dark foreground (3.94).
    'contrastDarkColors': '50 100 200 300 400 500 600 A100 A200',
    'contrastStrongLightColors': '700 800 900 A400 A700'
  },
  'light-blue': {
    '50': '#e1f5fe',
    '100': '#b3e5fc',
    '200': '#81d4fa',
    '300': '#4fc3f7',
    '400': '#29b6f6',
    '500': '#03a9f4',
    '600': '#039be5',
    '700': '#0288d1',
    '800': '#0277bd',
    '900': '#01579b',
    'A100': '#80d8ff',
    'A200': '#40c4ff',
    'A400': '#00b0ff',
    'A700': '#0091ea',
    'contrastDefaultColor': 'dark',
    // Dark on 700 does not meet the minimum 4.5 contrast ratio (at 4.07),
    // but it's worse with a white foreground (3.85).
    'contrastStrongLightColors': '800 900 A700'
  },
  'cyan': {
    '50': '#e0f7fa',
    '100': '#b2ebf2',
    '200': '#80deea',
    '300': '#4dd0e1',
    '400': '#26c6da',
    '500': '#00bcd4',
    '600': '#00acc1',
    '700': '#0097a7',
    '800': '#00838f',
    '900': '#006064',
    'A100': '#84ffff',
    'A200': '#18ffff',
    'A400': '#00e5ff',
    'A700': '#00b8d4',
    'contrastDefaultColor': 'dark',
    // Dark on 700 does not meet the minimum 4.5 contrast ratio (at 4.47),
    // but it's worse with a white foreground (3.5).
    'contrastStrongLightColors': '800 900'
  },
  'teal': {
    '50': '#e0f2f1',
    '100': '#b2dfdb',
    '200': '#80cbc4',
    '300': '#4db6ac',
    '400': '#26a69a',
    '500': '#009688',
    '600': '#00897b',
    '700': '#00796b',
    '800': '#00695c',
    '900': '#004d40',
    'A100': '#a7ffeb',
    'A200': '#64ffda',
    'A400': '#1de9b6',
    'A700': '#00bfa5',
    'contrastDefaultColor': 'dark',
    // Dark on 500 does not meet the minimum 4.5 contrast ratio (at 4.27),
    // but it's worse with a white foreground (3.67).
    // White on 600 does not meet the minimum 4.5 contrast ratio (at 4.31),
    // but it's worse with a dark foreground (3.64).
    'contrastStrongLightColors': '600 700 800 900'
  },
  'green': {
    '50': '#e8f5e9',
    '100': '#c8e6c9',
    '200': '#a5d6a7',
    '300': '#81c784',
    '400': '#66bb6a',
    '500': '#4caf50',
    '600': '#43a047',
    '700': '#388e3c',
    '800': '#2e7d32',
    '900': '#1b5e20',
    'A100': '#b9f6ca',
    'A200': '#69f0ae',
    'A400': '#00e676',
    'A700': '#00c853',
    'contrastDefaultColor': 'dark',
    // White on 700 does not meet the minimum 4.5 contrast ratio (at 4.11),
    // but it's worse with a dark foreground (3.81).
    'contrastStrongLightColors': '700 800 900'
  },
  'light-green': {
    '50': '#f1f8e9',
    '100': '#dcedc8',
    '200': '#c5e1a5',
    '300': '#aed581',
    '400': '#9ccc65',
    '500': '#8bc34a',
    '600': '#7cb342',
    '700': '#689f38',
    '800': '#558b2f',
    '900': '#33691e',
    'A100': '#ccff90',
    'A200': '#b2ff59',
    'A400': '#76ff03',
    'A700': '#64dd17',
    'contrastDefaultColor': 'dark',
    'contrastStrongLightColors': '800 900'
  },
  'lime': {
    '50': '#f9fbe7',
    '100': '#f0f4c3',
    '200': '#e6ee9c',
    '300': '#dce775',
    '400': '#d4e157',
    '500': '#cddc39',
    '600': '#c0ca33',
    '700': '#afb42b',
    '800': '#9e9d24',
    '900': '#827717',
    'A100': '#f4ff81',
    'A200': '#eeff41',
    'A400': '#c6ff00',
    'A700': '#aeea00',
    'contrastDefaultColor': 'dark',
    'contrastStrongLightColors': '900'
  },
  'yellow': {
    '50': '#fffde7',
    '100': '#fff9c4',
    '200': '#fff59d',
    '300': '#fff176',
    '400': '#ffee58',
    '500': '#ffeb3b',
    '600': '#fdd835',
    '700': '#fbc02d',
    '800': '#f9a825',
    '900': '#f57f17',
    'A100': '#ffff8d',
    'A200': '#ffff00',
    'A400': '#ffea00',
    'A700': '#ffd600',
    'contrastDefaultColor': 'dark'
  },
  'amber': {
    '50': '#fff8e1',
    '100': '#ffecb3',
    '200': '#ffe082',
    '300': '#ffd54f',
    '400': '#ffca28',
    '500': '#ffc107',
    '600': '#ffb300',
    '700': '#ffa000',
    '800': '#ff8f00',
    '900': '#ff6f00',
    'A100': '#ffe57f',
    'A200': '#ffd740',
    'A400': '#ffc400',
    'A700': '#ffab00',
    'contrastDefaultColor': 'dark'
  },
  'orange': {
    '50': '#fff3e0',
    '100': '#ffe0b2',
    '200': '#ffcc80',
    '300': '#ffb74d',
    '400': '#ffa726',
    '500': '#ff9800',
    '600': '#fb8c00',
    '700': '#f57c00',
    '800': '#ef6c00',
    '900': '#e65100',
    'A100': '#ffd180',
    'A200': '#ffab40',
    'A400': '#ff9100',
    'A700': '#ff6d00',
    'contrastDefaultColor': 'dark',
    'contrastStrongLightColors': '900'
  },
  'deep-orange': {
    '50': '#fbe9e7',
    '100': '#ffccbc',
    '200': '#ffab91',
    '300': '#ff8a65',
    '400': '#ff7043',
    '500': '#ff5722',
    '600': '#f4511e',
    '700': '#e64a19',
    '800': '#d84315',
    '900': '#bf360c',
    'A100': '#ff9e80',
    'A200': '#ff6e40',
    'A400': '#ff3d00',
    'A700': '#dd2c00',
    'contrastDefaultColor': 'dark',
    // Dark on 700 does not meet the minimum 4.5 contrast ratio (at 4.01),
    // but it's worse with a white foreground (3.91).
    // White on 800 does not meet the minimum 4.5 contrast ratio (at 4.43),
    // but it's worse with a dark foreground (3.54).
    'contrastStrongLightColors': '800 900 A400 A700',
  },
  'brown': {
    '50': '#efebe9',
    '100': '#d7ccc8',
    '200': '#bcaaa4',
    '300': '#a1887f',
    '400': '#8d6e63',
    '500': '#795548',
    '600': '#6d4c41',
    '700': '#5d4037',
    '800': '#4e342e',
    '900': '#3e2723',
    'A100': '#d7ccc8',
    'A200': '#bcaaa4',
    'A400': '#8d6e63',
    'A700': '#5d4037',
    'contrastDefaultColor': 'light',
    'contrastDarkColors': '50 100 200 300 A100 A200',
    'contrastStrongLightColors': '400 500 600 700 800 900 A400 A700'
  },
  'grey': {
    '50': '#fafafa',
    '100': '#f5f5f5',
    '200': '#eeeeee',
    '300': '#e0e0e0',
    '400': '#bdbdbd',
    '500': '#9e9e9e',
    '600': '#757575',
    '700': '#616161',
    '800': '#424242',
    '900': '#212121',
    'A100': '#ffffff',
    'A200': '#000000',
    'A400': '#303030',
    'A700': '#616161',
    'contrastDefaultColor': 'dark',
    'contrastLightColors': '700 800 900 A200 A400 A700',
    'contrastStrongLightColors': '600'
  },
  'blue-grey': {
    '50': '#eceff1',
    '100': '#cfd8dc',
    '200': '#b0bec5',
    '300': '#90a4ae',
    '400': '#78909c',
    '500': '#607d8b',
    '600': '#546e7a',
    '700': '#455a64',
    '800': '#37474f',
    '900': '#263238',
    'A100': '#cfd8dc',
    'A200': '#b0bec5',
    'A400': '#78909c',
    'A700': '#455a64',
    'contrastDefaultColor': 'light',
    'contrastDarkColors': '50 100 200 300 400 A100 A200 A400',
    // White on 500 does not meet the minimum 4.5 contrast ratio (at 4.37),
    // but it's worse with a dark foreground.
    'contrastStrongLightColors': '500 600 700 800 900 A700'
  }
});

})();
(function(){
"use strict";

(function(angular) {
  'use strict';
/**
 * @ngdoc module
 * @name material.core.theming
 * @description
 * Theming
 */
detectDisabledThemes.$inject = ["$mdThemingProvider"];
ThemingDirective.$inject = ["$mdTheming", "$interpolate", "$parse", "$mdUtil", "$q", "$log"];
ThemableDirective.$inject = ["$mdTheming"];
ThemingProvider.$inject = ["$mdColorPalette", "$$mdMetaProvider"];
generateAllThemes.$inject = ["$injector", "$mdTheming"];
angular.module('material.core.theming', ['material.core.theming.palette', 'material.core.meta'])
  .directive('mdTheme', ThemingDirective)
  .directive('mdThemable', ThemableDirective)
  .directive('mdThemesDisabled', disableThemesDirective)
  .provider('$mdTheming', ThemingProvider)
  .config(detectDisabledThemes)
  .run(generateAllThemes);

/**
 * Detect if the HTML or the BODY tags has a [md-themes-disabled] attribute
 * If yes, then immediately disable all theme stylesheet generation and DOM injection
 */
/**
 * @ngInject
 */
function detectDisabledThemes($mdThemingProvider) {
  var isDisabled = !!document.querySelector('[md-themes-disabled]');
  $mdThemingProvider.disableTheming(isDisabled);
}

/**
 * @ngdoc service
 * @name $mdThemingProvider
 * @module material.core.theming
 *
 * @description Provider to configure the `$mdTheming` service.
 *
 * ### Default Theme
 * The `$mdThemingProvider` uses by default the following theme configuration:
 *
 * - Primary Palette: `Blue`
 * - Accent Palette: `Pink`
 * - Warn Palette: `Deep-Orange`
 * - Background Palette: `Grey`
 *
 * If you don't want to use the `md-theme` directive on the elements itself, you may want to overwrite
 * the default theme.<br/>
 * This can be done by using the following markup.
 *
 * <hljs lang="js">
 *   myAppModule.config(function($mdThemingProvider) {
 *     $mdThemingProvider
 *       .theme('default')
 *       .primaryPalette('blue')
 *       .accentPalette('teal')
 *       .warnPalette('red')
 *       .backgroundPalette('grey');
 *   });
 * </hljs>
 *

 * ### Dynamic Themes
 *
 * By default, if you change a theme at runtime, the `$mdTheming` service will not detect those changes.<br/>
 * If you have an application, which changes its theme on runtime, you have to enable theme watching.
 *
 * <hljs lang="js">
 *   myAppModule.config(function($mdThemingProvider) {
 *     // Enable theme watching.
 *     $mdThemingProvider.alwaysWatchTheme(true);
 *   });
 * </hljs>
 *
 * ### Custom Theme Styles
 *
 * Sometimes you may want to use your own theme styles for some custom components.<br/>
 * You are able to register your own styles by using the following markup.
 *
 * <hljs lang="js">
 *   myAppModule.config(function($mdThemingProvider) {
 *     // Register our custom stylesheet into the theming provider.
 *     $mdThemingProvider.registerStyles(STYLESHEET);
 *   });
 * </hljs>
 *
 * The `registerStyles` method only accepts strings as value, so you're actually not able to load an external
 * stylesheet file into the `$mdThemingProvider`.
 *
 * If it's necessary to load an external stylesheet, we suggest using a bundler, which supports including raw content,
 * like [raw-loader](https://github.com/webpack/raw-loader) for `webpack`.
 *
 * <hljs lang="js">
 *   myAppModule.config(function($mdThemingProvider) {
 *     // Register your custom stylesheet into the theming provider.
 *     $mdThemingProvider.registerStyles(require('../styles/my-component.theme.css'));
 *   });
 * </hljs>
 *
 * ### Browser color
 *
 * Enables browser header coloring
 * for more info please visit:
 * https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color
 *
 * Options parameter: <br/>
 * `theme`   - A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme. <br/>
 * `palette` - Can be any one of the basic material design palettes, extended defined palettes and 'primary',
 *             'accent', 'background' and 'warn'. Default is `primary`. <br/>
 * `hue`     - The hue from the selected palette. Default is `800`<br/>
 *
 * <hljs lang="js">
 *   myAppModule.config(function($mdThemingProvider) {
 *     // Enable browser color
 *     $mdThemingProvider.enableBrowserColor({
 *       theme: 'myTheme', // Default is 'default'
 *       palette: 'accent', // Default is 'primary', any basic material palette and extended palettes are available
 *       hue: '200' // Default is '800'
 *     });
 *   });
 * </hljs>
 */

/**
 * Some Example Valid Theming Expressions
 * =======================================
 *
 * Intention group expansion: (valid for primary, accent, warn, background)
 *
 * {{primary-100}} - grab shade 100 from the primary palette
 * {{primary-100-0.7}} - grab shade 100, apply opacity of 0.7
 * {{primary-100-contrast}} - grab shade 100's contrast color
 * {{primary-hue-1}} - grab the shade assigned to hue-1 from the primary palette
 * {{primary-hue-1-0.7}} - apply 0.7 opacity to primary-hue-1
 * {{primary-color}} - Generates .md-hue-1, .md-hue-2, .md-hue-3 with configured shades set for each hue
 * {{primary-color-0.7}} - Apply 0.7 opacity to each of the above rules
 * {{primary-contrast}} - Generates .md-hue-1, .md-hue-2, .md-hue-3 with configured contrast (ie. text) color shades set for each hue
 * {{primary-contrast-0.7}} - Apply 0.7 opacity to each of the above rules
 * {{primary-contrast-divider}} - Apply divider opacity to contrast color
 *
 * Foreground expansion: Applies rgba to black/white foreground text
 *
 * Old Foreground Expressions:
 * {{foreground-1}} - used for primary text
 * {{foreground-2}} - used for secondary text/divider
 * {{foreground-3}} - used for disabled text
 * {{foreground-4}} - used for dividers
 *
 * New Foreground Expressions:
 *
 * Apply primary text color for contrasting with default background
 *  {{background-default-contrast}} - default opacity
 *  {{background-default-contrast-secondary}} - opacity for secondary text
 *  {{background-default-contrast-hint}} - opacity for hints and placeholders
 *  {{background-default-contrast-disabled}} - opacity for disabled text
 *  {{background-default-contrast-divider}} - opacity for dividers
 *
 * Apply contrast color for specific shades
 *  {{background-50-contrast-icon}} - Apply contrast color for icon on background's shade 50 hue
 */

// In memory generated CSS rules; registered by theme.name
var GENERATED = { };

// In memory storage of defined themes and color palettes (both loaded by CSS, and user specified)
var PALETTES;

// Text colors are automatically generated based on background color when not specified
// Custom palettes can provide override colors
// @see https://material.io/archive/guidelines/style/color.html#color-usability
var DARK_FOREGROUND = {
  name: 'dark',
};
var LIGHT_FOREGROUND = {
  name: 'light',
};

var DARK_SHADOW = '1px 1px 0px rgba(0,0,0,0.4), -1px -1px 0px rgba(0,0,0,0.4)';
var LIGHT_SHADOW = '';

var DARK_CONTRAST_COLOR = colorToRgbaArray('rgba(0,0,0,0.87)');
var LIGHT_CONTRAST_COLOR = colorToRgbaArray('rgba(255,255,255,0.87)');
var STRONG_LIGHT_CONTRAST_COLOR = colorToRgbaArray('rgb(255,255,255)');

var THEME_COLOR_TYPES = ['primary', 'accent', 'warn', 'background'];
var DEFAULT_COLOR_TYPE = 'primary';

// A color in a theme will use these hues by default, if not specified by user.
var LIGHT_DEFAULT_HUES = {
  'accent': {
    'default': 'A200',
    'hue-1': 'A100',
    'hue-2': 'A400',
    'hue-3': 'A700'
  },
  'background': {
    'default': '50',
    'hue-1': 'A100',
    'hue-2': '100',
    'hue-3': '300'
  }
};

var DARK_DEFAULT_HUES = {
  'background': {
    'default': 'A400',
    'hue-1': '800',
    'hue-2': '900',
    'hue-3': 'A200'
  }
};

// Icon opacity values (active/inactive) from
// https://material.io/archive/guidelines/style/color.html#color-usability
var DARK_CONTRAST_OPACITY = {
  'icon': 0.54,
  'secondary': 0.54,
  'disabled': 0.38,
  'hint': 0.38,
  'divider': 0.12,
};

var LIGHT_CONTRAST_OPACITY = {
  'icon': 0.87,
  'secondary': 0.7,
  'disabled': 0.5,
  'hint': 0.5,
  'divider': 0.12
};

// Icon opacity values (active/inactive) from
// https://material.io/archive/guidelines/style/color.html#color-usability
var STRONG_LIGHT_CONTRAST_OPACITY = {
  'icon': 1.0,
  'secondary': 0.7,
  'disabled': 0.5,
  'hint': 0.5,
  'divider': 0.12
};

THEME_COLOR_TYPES.forEach(function(colorType) {
  // Color types with unspecified default hues will use these default hue values
  var defaultDefaultHues = {
    'default': '500',
    'hue-1': '300',
    'hue-2': '800',
    'hue-3': 'A100'
  };
  if (!LIGHT_DEFAULT_HUES[colorType]) LIGHT_DEFAULT_HUES[colorType] = defaultDefaultHues;
  if (!DARK_DEFAULT_HUES[colorType]) DARK_DEFAULT_HUES[colorType] = defaultDefaultHues;
});

var VALID_HUE_VALUES = [
  '50', '100', '200', '300', '400', '500', '600',
  '700', '800', '900', 'A100', 'A200', 'A400', 'A700'
];

var themeConfig = {
  disableTheming : false,   // Generate our themes at run time; also disable stylesheet DOM injection
  generateOnDemand : false, // Whether or not themes are to be generated on-demand (vs. eagerly).
  registeredStyles : [],    // Custom styles registered to be used in the theming of custom components.
  nonce : null              // Nonce to be added as an attribute to the generated themes style tags.
};

/**
 *
 */
function ThemingProvider($mdColorPalette, $$mdMetaProvider) {
  ThemingService.$inject = ["$rootScope", "$mdUtil", "$q", "$log"];
  PALETTES = { };
  var THEMES = { };

  var themingProvider;

  var alwaysWatchTheme = false;
  var defaultTheme = 'default';

  // Load JS Defined Palettes
  angular.extend(PALETTES, $mdColorPalette);

  // Default theme defined in core.js

  /**
   * Adds `theme-color` and `msapplication-navbutton-color` meta tags with the color parameter
   * @param {string} color Hex value of the wanted browser color
   * @returns {function} Remove function of the meta tags
   */
  var setBrowserColor = function (color) {
    // Chrome, Firefox OS and Opera
    var removeChrome = $$mdMetaProvider.setMeta('theme-color', color);
    // Windows Phone
    var removeWindows = $$mdMetaProvider.setMeta('msapplication-navbutton-color', color);

    return function () {
      removeChrome();
      removeWindows();
    };
  };

  /**
   * @ngdoc method
   * @name $mdThemingProvider#enableBrowserColor
   * @description
   * Enables browser header coloring. For more info please visit
   * <a href="https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color">
   *   Web Fundamentals</a>.
   * @param {object=} options Options for the browser color, which include:<br/>
   * - `theme` - `{string}`: A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme. <br/>
   * - `palette` - `{string}`:  Can be any one of the basic material design palettes, extended defined palettes, or `primary`,
   *  `accent`, `background`, and `warn`. Default is `primary`.<br/>
   * - `hue` -  `{string}`: The hue from the selected palette. Default is `800`.<br/>
   * @returns {function} Function that removes the browser coloring when called.
   */
  var enableBrowserColor = function (options) {
    options = angular.isObject(options) ? options : {};

    var theme = options.theme || 'default';
    var hue = options.hue || '800';

    var palette = PALETTES[options.palette] ||
      PALETTES[THEMES[theme].colors[options.palette || 'primary'].name];

    var color = angular.isObject(palette[hue]) ? palette[hue].hex : palette[hue];
    if (color.substr(0, 1) !== '#') color = '#' + color;

    return setBrowserColor(color);
  };

  return themingProvider = {
    definePalette: definePalette,
    extendPalette: extendPalette,
    theme: registerTheme,

    /**
     * return a read-only clone of the current theme configuration
     */
    configuration : function() {
      return angular.extend({ }, themeConfig, {
        defaultTheme : defaultTheme,
        alwaysWatchTheme : alwaysWatchTheme,
        registeredStyles : [].concat(themeConfig.registeredStyles)
      });
    },

    /**
     * @ngdoc method
     * @name $mdThemingProvider#disableTheming
     * @description
     * An easier way to disable theming without having to use `.constant("$MD_THEME_CSS","");`.
     * This disables all dynamic theme style sheet generations and injections.
     * @param {boolean=} isDisabled Disable all dynamic theme style sheet generations and injections
     *  if `true` or `undefined`.
     */
    disableTheming: function(isDisabled) {
      themeConfig.disableTheming = angular.isUndefined(isDisabled) || !!isDisabled;
    },

    /**
     * @ngdoc method
     * @name $mdThemingProvider#registerStyles
     * @param {string} styles The styles to be appended to AngularJS Material's built in theme CSS.
     */
    registerStyles: function(styles) {
      themeConfig.registeredStyles.push(styles);
    },

    /**
     * @ngdoc method
     * @name $mdThemingProvider#setNonce
     * @param {string} nonceValue The nonce to be added as an attribute to the theme style tags.
     * Setting a value allows the use of CSP policy without using the `'unsafe-inline'` directive.
     * The string must already be base64 encoded. You can use `btoa(string)` to do this encoding.
     * In your CSP's `style-src`, you would then add an entry for `'nonce-nonceValue'`.
     */
    setNonce: function(nonceValue) {
      themeConfig.nonce = nonceValue;
    },

    generateThemesOnDemand: function(onDemand) {
      themeConfig.generateOnDemand = onDemand;
    },

    /**
     * @ngdoc method
     * @name $mdThemingProvider#setDefaultTheme
     * @param {string} theme Default theme name to be applied to elements.
     *  Default value is `default`.
     */
    setDefaultTheme: function(theme) {
      defaultTheme = theme;
    },

    /**
     * @ngdoc method
     * @name $mdThemingProvider#alwaysWatchTheme
     * @param {boolean} alwaysWatch Whether or not to always watch themes for changes and re-apply
     * classes when they change. Default is `false`. Enabling can reduce performance.
     */
    alwaysWatchTheme: function(alwaysWatch) {
      alwaysWatchTheme = alwaysWatch;
    },

    enableBrowserColor: enableBrowserColor,

    $get: ThemingService,
    _LIGHT_DEFAULT_HUES: LIGHT_DEFAULT_HUES,
    _DARK_DEFAULT_HUES: DARK_DEFAULT_HUES,
    _PALETTES: PALETTES,
    _THEMES: THEMES,
    _parseRules: parseRules,
    _rgba: rgba
  };

  /**
   * @ngdoc method
   * @name $mdThemingProvider#definePalette
   * @description
   * In the event that you need to define a custom color palette, you can use this function to
   * make it available to your theme for use in its intention groups.<br>
   * Note that you must specify all hues in the definition map.
   * @param {string} name Name of palette being defined
   * @param {object} map Palette definition that includes hue definitions and contrast colors:
   * - `'50'` - `{string}`: HEX color
   * - `'100'` - `{string}`: HEX color
   * - `'200'` - `{string}`: HEX color
   * - `'300'` - `{string}`: HEX color
   * - `'400'` - `{string}`: HEX color
   * - `'500'` - `{string}`: HEX color
   * - `'600'` - `{string}`: HEX color
   * - `'700'` - `{string}`: HEX color
   * - `'800'` - `{string}`: HEX color
   * - `'900'` - `{string}`: HEX color
   * - `'A100'` - `{string}`: HEX color
   * - `'A200'` - `{string}`: HEX color
   * - `'A400'` - `{string}`: HEX color
   * - `'A700'` - `{string}`: HEX color
   * - `'contrastDefaultColor'` - `{string}`: `light` or `dark`
   * - `'contrastDarkColors'` - `{string[]}`: Hues which should use dark contrast colors (i.e. raised button text).
   *  For example: `['50', '100', '200', '300', '400', 'A100']`.
   * - `'contrastLightColors'` - `{string[]}`: Hues which should use light contrast colors (i.e. raised button text).
   *  For example: `['500', '600', '700', '800', '900', 'A200', 'A400', 'A700']`.
   */
  function definePalette(name, map) {
    map = map || {};
    PALETTES[name] = checkPaletteValid(name, map);
    return themingProvider;
  }

  /**
   * @ngdoc method
   * @name $mdThemingProvider#extendPalette
   * @description
   * Sometimes it is easier to extend an existing color palette and then change a few properties,
   * rather than defining a whole new palette.
   * @param {string} name Name of palette being extended
   * @param {object} map Palette definition that includes optional hue definitions and contrast colors:
   * - `'50'` - `{string}`: HEX color
   * - `'100'` - `{string}`: HEX color
   * - `'200'` - `{string}`: HEX color
   * - `'300'` - `{string}`: HEX color
   * - `'400'` - `{string}`: HEX color
   * - `'500'` - `{string}`: HEX color
   * - `'600'` - `{string}`: HEX color
   * - `'700'` - `{string}`: HEX color
   * - `'800'` - `{string}`: HEX color
   * - `'900'` - `{string}`: HEX color
   * - `'A100'` - `{string}`: HEX color
   * - `'A200'` - `{string}`: HEX color
   * - `'A400'` - `{string}`: HEX color
   * - `'A700'` - `{string}`: HEX color
   * - `'contrastDefaultColor'` - `{string}`: `light` or `dark`
   * - `'contrastDarkColors'` - `{string[]}`: Hues which should use dark contrast colors (i.e. raised button text).
   *  For example: `['50', '100', '200', '300', '400', 'A100']`.
   * - `'contrastLightColors'` - `{string[]}`: Hues which should use light contrast colors (i.e. raised button text).
   *  For example: `['500', '600', '700', '800', '900', 'A200', 'A400', 'A700']`.
   *  @returns {object} A new object which is a copy of the given palette, `name`,
   *    with variables from `map` overwritten.
   */
  function extendPalette(name, map) {
    return checkPaletteValid(name,  angular.extend({}, PALETTES[name] || {}, map));
  }

  // Make sure that palette has all required hues
  function checkPaletteValid(name, map) {
    var missingColors = VALID_HUE_VALUES.filter(function(field) {
      return !map[field];
    });
    if (missingColors.length) {
      throw new Error("Missing colors %1 in palette %2!"
                      .replace('%1', missingColors.join(', '))
                      .replace('%2', name));
    }

    return map;
  }

  /**
   * @ngdoc method
   * @name $mdThemingProvider#theme
   * @description
   * Register a theme (which is a collection of color palettes); i.e. `warn`, `accent`,
   * `background`, and `primary`.<br>
   * Optionally inherit from an existing theme.
   * @param {string} name Name of theme being registered
   * @param {string=} inheritFrom Existing theme name to inherit from
   */
  function registerTheme(name, inheritFrom) {
    if (THEMES[name]) return THEMES[name];

    inheritFrom = inheritFrom || 'default';

    var parentTheme = typeof inheritFrom === 'string' ? THEMES[inheritFrom] : inheritFrom;
    var theme = new Theme(name);

    if (parentTheme) {
      angular.forEach(parentTheme.colors, function(color, colorType) {
        theme.colors[colorType] = {
          name: color.name,
          // Make sure a COPY of the hues is given to the child color,
          // not the same reference.
          hues: angular.extend({}, color.hues)
        };
      });
    }
    THEMES[name] = theme;

    return theme;
  }

  function Theme(name) {
    var self = this;
    self.name = name;
    self.colors = {};

    self.dark = setDark;
    setDark(false);

    function setDark(isDark) {
      isDark = arguments.length === 0 ? true : !!isDark;

      // If no change, abort
      if (isDark === self.isDark) return;

      self.isDark = isDark;

      self.foregroundPalette = self.isDark ? LIGHT_FOREGROUND : DARK_FOREGROUND;
      self.foregroundShadow = self.isDark ? DARK_SHADOW : LIGHT_SHADOW;

      // Light and dark themes have different default hues.
      // Go through each existing color type for this theme, and for every
      // hue value that is still the default hue value from the previous light/dark setting,
      // set it to the default hue value from the new light/dark setting.
      var newDefaultHues = self.isDark ? DARK_DEFAULT_HUES : LIGHT_DEFAULT_HUES;
      var oldDefaultHues = self.isDark ? LIGHT_DEFAULT_HUES : DARK_DEFAULT_HUES;
      angular.forEach(newDefaultHues, function(newDefaults, colorType) {
        var color = self.colors[colorType];
        var oldDefaults = oldDefaultHues[colorType];
        if (color) {
          for (var hueName in color.hues) {
            if (color.hues[hueName] === oldDefaults[hueName]) {
              color.hues[hueName] = newDefaults[hueName];
            }
          }
        }
      });

      return self;
    }

    THEME_COLOR_TYPES.forEach(function(colorType) {
      var defaultHues = (self.isDark ? DARK_DEFAULT_HUES : LIGHT_DEFAULT_HUES)[colorType];
      self[colorType + 'Palette'] = function setPaletteType(paletteName, hues) {
        var color = self.colors[colorType] = {
          name: paletteName,
          hues: angular.extend({}, defaultHues, hues)
        };

        Object.keys(color.hues).forEach(function(name) {
          if (!defaultHues[name]) {
            throw new Error("Invalid hue name '%1' in theme %2's %3 color %4. Available hue names: %4"
              .replace('%1', name)
              .replace('%2', self.name)
              .replace('%3', paletteName)
              .replace('%4', Object.keys(defaultHues).join(', '))
            );
          }
        });
        Object.keys(color.hues).map(function(key) {
          return color.hues[key];
        }).forEach(function(hueValue) {
          if (VALID_HUE_VALUES.indexOf(hueValue) === -1) {
            throw new Error("Invalid hue value '%1' in theme %2's %3 color %4. Available hue values: %5"
              .replace('%1', hueValue)
              .replace('%2', self.name)
              .replace('%3', colorType)
              .replace('%4', paletteName)
              .replace('%5', VALID_HUE_VALUES.join(', '))
            );
          }
        });
        return self;
      };
    });
  }

  /**
   * @ngdoc service
   * @name $mdTheming
   * @module material.core.theming
   * @description
   * Service that makes an element apply theming related <b>classes</b> to itself.
   *
   * For more information on the hue objects, their default values, as well as valid hue values, please visit <a ng-href="Theming/03_configuring_a_theme#specifying-custom-hues-for-color-intentions">the custom hues section of Configuring a Theme</a>.
   *
   * <hljs lang="js">
   * // Example component directive that we want to apply theming classes to.
   * app.directive('myFancyDirective', function($mdTheming) {
   *   return {
   *     restrict: 'AE',
   *     link: function(scope, element, attrs) {
   *       // Initialize the service using our directive's element
   *       $mdTheming(element);
   *
   *       $mdTheming.defineTheme('myTheme', {
   *         primary: 'blue',
   *         primaryHues: {
   *           default: '500',
   *           hue-1: '300',
   *           hue-2: '900',
   *           hue-3: 'A100'
   *         },
   *         accent: 'pink',
   *         accentHues: {
   *           default: '600',
   *           hue-1: '300',
   *           hue-2: '200',
   *           hue-3: 'A500'
   *         },
   *         warn: 'red',
   *         // It's not necessary to specify all hues in the object.
   *         warnHues: {
   *           default: '200',
   *           hue-3: 'A100'
   *         },
   *         // It's not necessary to specify custom hues at all.
   *         background: 'grey',
   *         dark: true
   *       });
   *       // Your directive's custom code here.
   *     }
   *   };
   * });
   * </hljs>
   * @param {element=} element Element that will have theming classes applied to it.
   */

  /**
   * @ngdoc property
   * @name $mdTheming#THEMES
   * @description
   * Property to get all the themes defined
   * @returns {object} All the themes defined with their properties.
   */

  /**
   * @ngdoc property
   * @name $mdTheming#PALETTES
   * @description
   * Property to get all the palettes defined
   * @returns {object} All the palettes defined with their colors.
   */

  /**
   * @ngdoc method
   * @name $mdTheming#registered
   * @description
   * Determine is specified theme name is a valid, registered theme
   * @param {string} themeName the theme to check if registered
   * @returns {boolean} whether the theme is registered or not
   */

  /**
   * @ngdoc method
   * @name $mdTheming#defaultTheme
   * @description
   * Returns the default theme
   * @returns {string} The default theme
   */

  /**
   * @ngdoc method
   * @name $mdTheming#generateTheme
   * @description
   * Lazy generate themes - by default, every theme is generated when defined.
   * You can disable this in the configuration section using the
   * `$mdThemingProvider.generateThemesOnDemand(true);`
   *
   * The theme name that is passed in must match the name of the theme that was defined as part of
   * the configuration block.
   *
   * @param {string} name theme name to generate
   */

  /**
   * @ngdoc method
   * @name $mdTheming#setBrowserColor
   * @description
   * Enables browser header coloring. For more info please visit
   * <a href="https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color">
   *   Web Fundamentals</a>.
   * @param {object=} options Options for the browser color, which include:<br/>
   * - `theme` - `{string}`: A defined theme via `$mdThemeProvider` to use the palettes from.
   *    Default is `default` theme. <br/>
   * - `palette` - `{string}`:  Can be any one of the basic material design palettes, extended
   *    defined palettes, or `primary`, `accent`, `background`, and `warn`. Default is `primary`.
   * <br/>
   * - `hue` -  `{string}`: The hue from the selected palette. Default is `800`.<br/>
   * @returns {function} Function that removes the browser coloring when called.
   */

  /**
   * @ngdoc method
   * @name $mdTheming#defineTheme
   * @description
   * Dynamically define a theme by using an options object that contains palette names.
   *
   * @param {string} name Theme name to define
   * @param {object} options Theme definition options
   *
   * Options are:<br/>
   * - `primary` - `{string}`: The name of the primary palette to use in the theme.<br/>
   * - `primaryHues` - `{object=}`: Override hues for primary palette.<br/>
   * - `accent` - `{string}`: The name of the accent palette to use in the theme.<br/>
   * - `accentHues` - `{object=}`: Override hues for accent palette.<br/>
   * - `warn` - `{string}`: The name of the warn palette to use in the theme.<br/>
   * - `warnHues` - `{object=}`: Override hues for warn palette.<br/>
   * - `background` - `{string}`: The name of the background palette to use in the theme.<br/>
   * - `backgroundHues` - `{object=}`: Override hues for background palette.<br/>
   * - `dark` - `{boolean}`: Indicates if it's a dark theme.<br/>
   * @returns {Promise<string>} A resolved promise with the new theme name.
   */

  /* @ngInject */
  function ThemingService($rootScope, $mdUtil, $q, $log) {
    // Allow us to be invoked via a linking function signature.
    var applyTheme = function (scope, el) {
      if (el === undefined) { el = scope; scope = undefined; }
      if (scope === undefined) { scope = $rootScope; }
      applyTheme.inherit(el, el);
    };

    Object.defineProperty(applyTheme, 'THEMES', {
      get: function () {
        return angular.extend({}, THEMES);
      }
    });
    Object.defineProperty(applyTheme, 'PALETTES', {
      get: function () {
        return angular.extend({}, PALETTES);
      }
    });
    Object.defineProperty(applyTheme, 'ALWAYS_WATCH', {
      get: function () {
        return alwaysWatchTheme;
      }
    });
    applyTheme.inherit = inheritTheme;
    applyTheme.registered = registered;
    applyTheme.defaultTheme = function() { return defaultTheme; };
    applyTheme.generateTheme = function(name) { generateTheme(THEMES[name], name, themeConfig.nonce); };
    applyTheme.defineTheme = function(name, options) {
      options = options || {};

      var theme = registerTheme(name);

      if (options.primary) {
        theme.primaryPalette(options.primary, options.primaryHues);
      }
      if (options.accent) {
        theme.accentPalette(options.accent, options.accentHues);
      }
      if (options.warn) {
        theme.warnPalette(options.warn, options.warnHues);
      }
      if (options.background) {
        theme.backgroundPalette(options.background, options.backgroundHues);
      }
      if (options.dark){
        theme.dark();
      }

      this.generateTheme(name);

      return $q.resolve(name);
    };
    applyTheme.setBrowserColor = enableBrowserColor;

    return applyTheme;

    /**
     * Determine is specified theme name is a valid, registered theme
     */
    function registered(themeName) {
      if (themeName === undefined || themeName === '') return true;
      return applyTheme.THEMES[themeName] !== undefined;
    }

    /**
     * Get theme name for the element, then update with Theme CSS class
     */
    function inheritTheme (el, parent) {
      var ctrl = parent.controller('mdTheme') || el.data('$mdThemeController');
      var scope = el.scope();

      updateThemeClass(lookupThemeName());

      if (ctrl) {
        var watchTheme = alwaysWatchTheme ||
                         ctrl.$shouldWatch ||
                         $mdUtil.parseAttributeBoolean(el.attr('md-theme-watch'));

        if (watchTheme || ctrl.isAsyncTheme) {
          var clearNameWatcher = function () {
            if (unwatch) {
              unwatch();
              unwatch = undefined;
            }
          };

          var unwatch = ctrl.registerChanges(function(name) {
            updateThemeClass(name);

            if (!watchTheme) {
              clearNameWatcher();
            }
          });

          if (scope) {
            scope.$on('$destroy', clearNameWatcher);
          } else {
            el.on('$destroy', clearNameWatcher);
          }
        }
      }

      /**
       * Find the theme name from the parent controller or element data
       */
      function lookupThemeName() {
        // As a few components (dialog) add their controllers later, we should also watch for a controller init.
        return ctrl && ctrl.$mdTheme || (defaultTheme === 'default' ? '' : defaultTheme);
      }

      /**
       * Remove old theme class and apply a new one
       * NOTE: if not a valid theme name, then the current name is not changed
       */
      function updateThemeClass(theme) {
        if (!theme) return;
        if (!registered(theme)) {
          $log.warn('Attempted to use unregistered theme \'' + theme + '\'. ' +
                    'Register it with $mdThemingProvider.theme().');
        }

        var oldTheme = el.data('$mdThemeName');
        if (oldTheme) el.removeClass('md-' + oldTheme +'-theme');
        el.addClass('md-' + theme + '-theme');
        el.data('$mdThemeName', theme);
        if (ctrl) {
          el.data('$mdThemeController', ctrl);
        }
      }
    }

  }
}

function ThemingDirective($mdTheming, $interpolate, $parse, $mdUtil, $q, $log) {
  return {
    priority: 101, // has to be more than 100 to be before interpolation (issue on IE)
    link: {
      pre: function(scope, el, attrs) {
        var registeredCallbacks = [];

        var startSymbol = $interpolate.startSymbol();
        var endSymbol = $interpolate.endSymbol();

        var theme = attrs.mdTheme.trim();

        var hasInterpolation =
          theme.substr(0, startSymbol.length) === startSymbol &&
          theme.lastIndexOf(endSymbol) === theme.length - endSymbol.length;

        var oneTimeOperator = '::';
        var oneTimeBind = attrs.mdTheme
            .split(startSymbol).join('')
            .split(endSymbol).join('')
            .trim()
            .substr(0, oneTimeOperator.length) === oneTimeOperator;

        var getTheme = function () {
          var interpolation = $interpolate(attrs.mdTheme)(scope);
          return $parse(interpolation)(scope) || interpolation;
        };

        var ctrl = {
          isAsyncTheme: angular.isFunction(getTheme()) || angular.isFunction(getTheme().then),
          registerChanges: function (cb, context) {
            if (context) {
              cb = angular.bind(context, cb);
            }

            registeredCallbacks.push(cb);

            return function () {
              var index = registeredCallbacks.indexOf(cb);

              if (index > -1) {
                registeredCallbacks.splice(index, 1);
              }
            };
          },
          $setTheme: function (theme) {
            if (!$mdTheming.registered(theme)) {
              $log.warn('attempted to use unregistered theme \'' + theme + '\'');
            }

            ctrl.$mdTheme = theme;

            // Iterating backwards to support unregistering during iteration
            // http://stackoverflow.com/a/9882349/890293
            // we don't use `reverse()` of array because it mutates the array and we don't want it
            // to get re-indexed
            for (var i = registeredCallbacks.length; i--;) {
              registeredCallbacks[i](theme);
            }
          },
          $shouldWatch: $mdUtil.parseAttributeBoolean(el.attr('md-theme-watch')) ||
                        $mdTheming.ALWAYS_WATCH ||
                        (hasInterpolation && !oneTimeBind)
        };

        el.data('$mdThemeController', ctrl);

        var setParsedTheme = function (theme) {
          if (typeof theme === 'string') {
            return ctrl.$setTheme(theme);
          }

          $q.when(angular.isFunction(theme) ?  theme() : theme)
            .then(function(name) {
              ctrl.$setTheme(name);
            });
        };

        setParsedTheme(getTheme());

        var unwatch = scope.$watch(getTheme, function(theme) {
          if (theme) {
            setParsedTheme(theme);

            if (!ctrl.$shouldWatch) {
              unwatch();
            }
          }
        });
      }
    }
  };
}

/**
 * Special directive that will disable ALL runtime Theme style generation and DOM injection
 *
 * <link rel="stylesheet" href="angular-material.min.css">
 * <link rel="stylesheet" href="angular-material.themes.css">
 *
 * <body md-themes-disabled>
 *  ...
 * </body>
 *
 * Note: Using md-themes-css directive requires the developer to load external
 * theme stylesheets; e.g. custom themes from Material-Tools:
 *
 *       `angular-material.themes.css`
 *
 * Another option is to use the ThemingProvider to configure and disable the attribute
 * conversions; this would obviate the use of the `md-themes-css` directive
 *
 */
function disableThemesDirective() {
  themeConfig.disableTheming = true;

  // Return a 1x-only, first-match attribute directive
  return {
    restrict : 'A',
    priority : '900'
  };
}

function ThemableDirective($mdTheming) {
  return $mdTheming;
}

function parseRules(theme, colorType, rules) {
  checkValidPalette(theme, colorType);

  rules = rules.replace(/THEME_NAME/g, theme.name);
  var themeNameRegex = new RegExp('\\.md-' + theme.name + '-theme', 'g');
  // Matches '{{ primary-color }}', etc
  var hueRegex = new RegExp('([\'"])?{{\\s*([a-zA-Z]+)-?(color|default)?-?(contrast)?-?((?:\\d\\.?\\d*)|(?:[a-zA-Z]+))?\\s*}}(["\'])?','g');
  var simpleVariableRegex = /'?"?{{\s*([a-zA-Z]+)-(A?\d+|hue-[0-3]|shadow|default)-?(contrast)?-?((?:\d\.?\d*)|(?:[a-zA-Z]+))?\s*}}'?"?/g;
  var defaultBgHue = theme.colors['background'].hues['default'];
  var defaultBgContrastType = PALETTES[theme.colors['background'].name][defaultBgHue].contrastType;

  // find and replace simple variables where we use a specific hue, not an entire palette
  // eg. "{{primary-100}}"
  // \(' + THEME_COLOR_TYPES.join('\|') + '\)'
  rules = rules.replace(simpleVariableRegex, function(match, colorType, hue, contrast, opacity) {
    var regexColorType = colorType;
    if (colorType === 'foreground') {
      if (hue === 'shadow') {
        return theme.foregroundShadow;
      } else if (theme.foregroundPalette[hue]) {
        // Use user defined palette number (ie: foreground-2)
        return rgba(colorToRgbaArray(theme.foregroundPalette[hue]));
      } else if (theme.foregroundPalette['1']){
        return rgba(colorToRgbaArray(theme.foregroundPalette['1']));
      }
      // Default to background-default-contrast-{opacity}
      colorType = 'background';
      contrast = 'contrast';
      if (!opacity && hue) {
        // Convert references to legacy hues to opacities (i.e. foreground-4 to *-divider)
        switch (hue) {
          // hue-1 uses default opacity
          case '2':
            opacity = 'secondary';
            break;
          case '3':
            opacity = 'disabled';
            break;
          case '4':
            opacity = 'divider';
        }
      }
      hue = 'default';
    }

    // `default` is also accepted as a hue-value, because the background palettes are
    // using it as a name for the default hue.
    if (hue.indexOf('hue') === 0 || hue === 'default') {
      hue = theme.colors[colorType].hues[hue];
    }

    var colorDetails = (PALETTES[ theme.colors[colorType].name ][hue] || '');

    // If user has specified a foreground color, use those
    if (colorType === 'background' && contrast && regexColorType !== 'foreground' &&
        colorDetails.contrastType === defaultBgContrastType) {
      // Don't process if colorType was changed
      switch (opacity) {
        case 'secondary':
        case 'icon':
          if (theme.foregroundPalette['2']) {
            return rgba(colorToRgbaArray(theme.foregroundPalette['2']));
          }
          break;
        case 'disabled':
        case 'hint':
          if (theme.foregroundPalette['3']) {
            return rgba(colorToRgbaArray(theme.foregroundPalette['3']));
          }
          break;
        case 'divider':
          if (theme.foregroundPalette['4']) {
            return rgba(colorToRgbaArray(theme.foregroundPalette['4']));
          }
          break;
        default:
          if (theme.foregroundPalette['1']) {
            return rgba(colorToRgbaArray(theme.foregroundPalette['1']));
          }
          break;
      }
    }

    if (contrast && opacity) {
      opacity = colorDetails.opacity[opacity] || opacity;
    }

    return rgba(colorDetails[contrast ? 'contrast' : 'value'], opacity);
  });

  var generatedRules = [];

  // For each type, generate rules for each hue (ie. default, md-hue-1, md-hue-2, md-hue-3)
  angular.forEach(['default', 'hue-1', 'hue-2', 'hue-3'], function(hueName) {
    var newRule = rules
      .replace(hueRegex, function(match, _, matchedColorType, hueType, contrast, opacity) {
        var color = theme.colors[matchedColorType];
        var palette = PALETTES[color.name];
        var hueValue = color.hues[hueName];
        if (contrast && opacity) {
          opacity = palette[hueValue].opacity[opacity] || opacity;
        }
        return rgba(palette[hueValue][hueType === 'color' ? 'value' : 'contrast'], opacity);
      });
    if (hueName !== 'default') {
      newRule = newRule.replace(themeNameRegex, '.md-' + theme.name + '-theme.md-' + hueName);
    }

    // Don't apply a selector rule to the default theme, making it easier to override
    // styles of the base-component
    if (theme.name === 'default') {
      var themeRuleRegex = /((?:\s|>|\.|\w|-|:|\(|\)|\[|]|"|'|=)*)\.md-default-theme((?:\s|>|\.|\w|-|:|\(|\)|\[|]|"|'|=)*)/g;

      newRule = newRule.replace(themeRuleRegex, function(match, start, end) {
        return match + ', ' + start + end;
      });
    }
    generatedRules.push(newRule);
  });

  return generatedRules;
}

var rulesByType = {};

// Generate our themes at run time given the state of THEMES and PALETTES
function generateAllThemes($injector, $mdTheming) {
  var head = document.head;
  var firstChild = head ? head.firstElementChild : null;
  var themeCss = !themeConfig.disableTheming && $injector.has('$MD_THEME_CSS') ? $injector.get('$MD_THEME_CSS') : '';

  // Append our custom registered styles to the theme stylesheet.
  themeCss += themeConfig.registeredStyles.join('');

  if (!firstChild) return;
  if (themeCss.length === 0) return; // no rules, so no point in running this expensive task

  // Expose contrast colors for palettes to ensure that text is always readable
  angular.forEach(PALETTES, sanitizePalette);

  // MD_THEME_CSS is a string generated by the build process that includes all the themeable
  // components as templates

  // Break the CSS into individual rules
  var rules = splitCss(themeCss).map(function(rule) {
    return rule.trim();
  });

  THEME_COLOR_TYPES.forEach(function(type) {
    rulesByType[type] = '';
  });

  // Sort the rules based on type, allowing us to do color substitution on a per-type basis
  rules.forEach(function(rule) {
    // First: test that if the rule has '.md-accent', it goes into the accent set of rules
    for (var i = 0, type; type = THEME_COLOR_TYPES[i]; i++) {
      if (rule.indexOf('.md-' + type) > -1) {
        return rulesByType[type] += rule;
      }
    }

    // If no eg 'md-accent' class is found, try to just find 'accent' in the rule and guess from
    // there
    for (i = 0; type = THEME_COLOR_TYPES[i]; i++) {
      if (rule.indexOf(type) > -1) {
        return rulesByType[type] += rule;
      }
    }

    // Default to the primary array
    return rulesByType[DEFAULT_COLOR_TYPE] += rule;
  });

  // If themes are being generated on-demand, quit here. The user will later manually
  // call generateTheme to do this on a theme-by-theme basis.
  if (themeConfig.generateOnDemand) return;

  angular.forEach($mdTheming.THEMES, function(theme) {
    if (!GENERATED[theme.name] && !($mdTheming.defaultTheme() !== 'default' && theme.name === 'default')) {
      generateTheme(theme, theme.name, themeConfig.nonce);
    }
  });


  // *************************
  // Internal functions
  // *************************

  /**
   * The user specifies a 'default' contrast color as either light or dark, then explicitly lists
   * which hues are the opposite contrast (eg. A100 has dark, A200 has light).
   * @param {!object} palette to sanitize
   */
  function sanitizePalette(palette) {
    var defaultContrast = palette.contrastDefaultColor;
    var lightColors = palette.contrastLightColors || [];
    var strongLightColors = palette.contrastStrongLightColors || [];
    var darkColors = palette.contrastDarkColors || [];

    // These colors are provided as space-separated lists
    if (typeof lightColors === 'string') lightColors = lightColors.split(' ');
    if (typeof strongLightColors === 'string') strongLightColors = strongLightColors.split(' ');
    if (typeof darkColors === 'string') darkColors = darkColors.split(' ');

    // Cleanup after ourselves
    delete palette.contrastDefaultColor;
    delete palette.contrastLightColors;
    delete palette.contrastStrongLightColors;
    delete palette.contrastDarkColors;

    /**
     * @param {string} hueName
     * @return {'dark'|'light'|'strongLight'}
     */
    function getContrastType(hueName) {
      if (defaultContrast === 'light' ? darkColors.indexOf(hueName) !== -1  :
        (lightColors.indexOf(hueName) === -1 && strongLightColors.indexOf(hueName) === -1)) {
        return 'dark';
      }
      if (strongLightColors.indexOf(hueName) !== -1) {
        return 'strongLight';
      }
      return 'light';
    }

    /**
     * @param {'dark'|'light'|'strongLight'} contrastType
     * @return {[number, number, number]} [red, green, blue] array
     */
    function getContrastColor(contrastType) {
      switch (contrastType) {
        default:
        case 'strongLight':
          return STRONG_LIGHT_CONTRAST_COLOR;
        case 'light':
          return LIGHT_CONTRAST_COLOR;
        case 'dark':
          return DARK_CONTRAST_COLOR;
      }
    }

    /**
     * @param {'dark'|'light'|'strongLight'} contrastType
     * @return {{secondary: number, divider: number, hint: number, icon: number, disabled: number}}
     */
    function getOpacityValues(contrastType) {
      switch (contrastType) {
        default:
        case 'strongLight':
          return STRONG_LIGHT_CONTRAST_OPACITY;
        case 'light':
          return LIGHT_CONTRAST_OPACITY;
        case 'dark':
          return DARK_CONTRAST_OPACITY;
      }
    }
    // Change { 'A100': '#fffeee' } to { 'A100': { value: '#fffeee', contrast:DARK_CONTRAST_COLOR }
    angular.forEach(palette, function(hueValue, hueName) {
      if (angular.isObject(hueValue)) return; // Already converted
      // Map everything to rgb colors
      var rgbValue = colorToRgbaArray(hueValue);
      if (!rgbValue) {
        throw new Error("Color %1, in palette %2's hue %3, is invalid. Hex or rgb(a) color expected."
                        .replace('%1', hueValue)
                        .replace('%2', palette.name)
                        .replace('%3', hueName));
      }

      var contrastType = getContrastType(hueName);
      palette[hueName] = {
        hex: palette[hueName],
        value: rgbValue,
        contrastType: contrastType,
        contrast: getContrastColor(contrastType),
        opacity: getOpacityValues(contrastType)
      };
    });
  }

  /**
   * @param {string} themeCss
   * @returns {[]} a string representing a CSS file that is split, producing an array with a rule
   *  at each index.
   */
  function splitCss(themeCss) {
    var result = [];
    var currentRule = '';
    var openedCurlyBrackets = 0;
    var closedCurlyBrackets = 0;

    for (var i = 0; i < themeCss.length; i++) {
      var character = themeCss.charAt(i);

      // Check for content in quotes
      if (character === '\'' || character === '"') {
        // Append text in quotes to current rule
        var textInQuotes = themeCss.substring(i, themeCss.indexOf(character, i + 1));
        currentRule += textInQuotes;

        // Jump to the closing quote char
        i += textInQuotes.length;
      } else {
        currentRule += character;

        if (character === '}') {
          closedCurlyBrackets++;
          if (closedCurlyBrackets === openedCurlyBrackets) {
            closedCurlyBrackets = 0;
            openedCurlyBrackets = 0;
            result.push(currentRule);
            currentRule = '';
          }
        } else if (character === '{') {
          openedCurlyBrackets++;
        }
      }
    }
    // Add comments added after last valid rule.
    if (currentRule !== '') {
      result.push(currentRule);
    }

    return result;
  }
}

function generateTheme(theme, name, nonce) {
  var head = document.head;
  var firstChild = head ? head.firstElementChild : null;

  if (!GENERATED[name]) {
    // For each theme, use the color palettes specified for
    // `primary`, `warn` and `accent` to generate CSS rules.
    THEME_COLOR_TYPES.forEach(function(colorType) {
      var styleStrings = parseRules(theme, colorType, rulesByType[colorType]);
      while (styleStrings.length) {
        var styleContent = styleStrings.shift();
        if (styleContent) {
          var style = document.createElement('style');
          style.setAttribute('md-theme-style', '');
          if (nonce) {
            style.setAttribute('nonce', nonce);
          }
          style.appendChild(document.createTextNode(styleContent));
          head.insertBefore(style, firstChild);
        }
      }
    });

    GENERATED[theme.name] = true;
  }

}


function checkValidPalette(theme, colorType) {
  // If theme attempts to use a palette that doesnt exist, throw error
  if (!PALETTES[ (theme.colors[colorType] || {}).name ]) {
    throw new Error(
      "You supplied an invalid color palette for theme %1's %2 palette. Available palettes: %3"
                    .replace('%1', theme.name)
                    .replace('%2', colorType)
                    .replace('%3', Object.keys(PALETTES).join(', '))
    );
  }
}

/**
 * @param {string} clr rbg or rgba color
 * @return {number[]|undefined} [red, green, blue] array if it can be computed
 */
function colorToRgbaArray(clr) {
  if (angular.isArray(clr) && clr.length === 3) return clr;
  if (/^rgb/.test(clr)) {
    return clr.replace(/(^\s*rgba?\(|\)\s*$)/g, '').split(',').map(function(value, i) {
      return i === 3 ? parseFloat(value) : parseInt(value, 10);
    });
  }
  if (clr.charAt(0) === '#') clr = clr.substring(1);
  if (!/^([a-fA-F0-9]{3}){1,2}$/g.test(clr)) return;

  var dig = clr.length / 3;
  var red = clr.substr(0, dig);
  var grn = clr.substr(dig, dig);
  var blu = clr.substr(dig * 2);
  if (dig === 1) {
    red += red;
    grn += grn;
    blu += blu;
  }
  return [parseInt(red, 16), parseInt(grn, 16), parseInt(blu, 16)];
}

function rgba(rgbArray, opacity) {
  if (!rgbArray) return "rgb('0,0,0')";

  if (rgbArray.length === 4) {
    rgbArray = angular.copy(rgbArray);
    opacity ? rgbArray.pop() : opacity = rgbArray.pop();
  }
  return opacity && (typeof opacity == 'number' || (typeof opacity == 'string' && opacity.length)) ?
    'rgba(' + rgbArray.join(',') + ',' + opacity + ')' :
    'rgb(' + rgbArray.join(',') + ')';
}


})(window.angular);

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.autocomplete
 */
/*
 * @see js folder for autocomplete implementation
 */
angular.module('material.components.autocomplete', [
  'material.core',
  'material.components.icon',
  'material.components.virtualRepeat'
]);

})();
(function(){
"use strict";


MdAutocompleteCtrl.$inject = ["$scope", "$element", "$mdUtil", "$mdConstant", "$mdTheming", "$window", "$animate", "$rootElement", "$attrs", "$q", "$log", "$mdLiveAnnouncer"];angular
    .module('material.components.autocomplete')
    .controller('MdAutocompleteCtrl', MdAutocompleteCtrl);

var ITEM_HEIGHT   = 48,
    MAX_ITEMS     = 5,
    MENU_PADDING  = 8,
    INPUT_PADDING = 2, // Padding provided by `md-input-container`
    MODE_STANDARD = 'standard',
    MODE_VIRTUAL = 'virtual';

function MdAutocompleteCtrl ($scope, $element, $mdUtil, $mdConstant, $mdTheming, $window,
                             $animate, $rootElement, $attrs, $q, $log, $mdLiveAnnouncer) {

  // Internal Variables.
  var ctrl                 = this,
      itemParts            = $scope.itemsExpr.split(/ in /i),
      itemExpr             = itemParts[ 1 ],
      elements             = null,
      cache                = {},
      noBlur               = false,
      selectedItemWatchers = [],
      hasFocus             = false,
      fetchesInProgress    = 0,
      enableWrapScroll     = null,
      inputModelCtrl       = null,
      debouncedOnResize    = $mdUtil.debounce(onWindowResize),
      mode                 = MODE_VIRTUAL; // default

  /**
   * The root document element. This is used for attaching a top-level click handler to
   * close the options panel when a click outside said panel occurs. We use `documentElement`
   * instead of body because, when scrolling is disabled, some browsers consider the body element
   * to be completely off the screen and propagate events directly to the html element.
   * @type {!Object} angular.JQLite
   */
  ctrl.documentElement = angular.element(document.documentElement);

  // Public Exported Variables with handlers
  defineProperty('hidden', handleHiddenChange, true);

  // Public Exported Variables
  ctrl.scope = $scope;
  ctrl.parent = $scope.$parent;
  ctrl.itemName = itemParts[0];
  ctrl.matches = [];
  ctrl.loading = false;
  ctrl.hidden = true;
  ctrl.index = -1;
  ctrl.activeOption = null;
  ctrl.id = $mdUtil.nextUid();
  ctrl.isDisabled = null;
  ctrl.isRequired = null;
  ctrl.isReadonly = null;
  ctrl.hasNotFound = false;
  ctrl.selectedMessage = $scope.selectedMessage || 'selected';
  ctrl.noMatchMessage = $scope.noMatchMessage || 'There are no matches available.';
  ctrl.singleMatchMessage = $scope.singleMatchMessage || 'There is 1 match available.';
  ctrl.multipleMatchStartMessage = $scope.multipleMatchStartMessage || 'There are ';
  ctrl.multipleMatchEndMessage = $scope.multipleMatchEndMessage || ' matches available.';
  ctrl.defaultEscapeOptions = 'clear';

  // Public Exported Methods
  ctrl.keydown = keydown;
  ctrl.blur = blur;
  ctrl.focus = focus;
  ctrl.clear = clearValue;
  ctrl.select = select;
  ctrl.listEnter = onListEnter;
  ctrl.listLeave = onListLeave;
  ctrl.focusInput = focusInputElement;
  ctrl.getCurrentDisplayValue = getCurrentDisplayValue;
  ctrl.registerSelectedItemWatcher = registerSelectedItemWatcher;
  ctrl.unregisterSelectedItemWatcher = unregisterSelectedItemWatcher;
  ctrl.notFoundVisible = notFoundVisible;
  ctrl.loadingIsVisible = loadingIsVisible;
  ctrl.positionDropdown = positionDropdown;

  /**
   * Report types to be used for the $mdLiveAnnouncer
   * @enum {number} Unique flag id.
   */
  var ReportType = {
    Count: 1,
    Selected: 2
  };

  return init();

  // initialization methods

  /**
   * Initialize the controller, setup watchers, gather elements
   */
  function init () {

    $mdUtil.initOptionalProperties($scope, $attrs, {
      searchText: '',
      selectedItem: null,
      clearButton: false,
      disableVirtualRepeat: false,
    });

    $mdTheming($element);
    configureWatchers();
    $mdUtil.nextTick(function () {

      gatherElements();
      moveDropdown();

      // Touch devices often do not send a click event on tap. We still want to focus the input
      // and open the options pop-up in these cases.
      $element.on('touchstart', focusInputElement);

      // Forward all focus events to the input element when autofocus is enabled
      if ($scope.autofocus) {
        $element.on('focus', focusInputElement);
      }
      if ($scope.inputAriaDescribedBy) {
        elements.input.setAttribute('aria-describedby', $scope.inputAriaDescribedBy);
      }
      if (!$scope.floatingLabel) {
        if ($scope.inputAriaLabel) {
          elements.input.setAttribute('aria-label', $scope.inputAriaLabel);
        } else if ($scope.inputAriaLabelledBy) {
          elements.input.setAttribute('aria-labelledby', $scope.inputAriaLabelledBy);
        } else if ($scope.placeholder) {
          // If no aria-label or aria-labelledby references are defined, then just label using the
          // placeholder.
          elements.input.setAttribute('aria-label', $scope.placeholder);
        }
      }
    });
  }

  function updateModelValidators() {
    if (!$scope.requireMatch || !inputModelCtrl) return;

    inputModelCtrl.$setValidity('md-require-match', !!$scope.selectedItem || !$scope.searchText);
  }

  /**
   * Calculates the dropdown's position and applies the new styles to the menu element
   * @returns {*}
   */
  function positionDropdown () {
    if (!elements) {
      return $mdUtil.nextTick(positionDropdown, false, $scope);
    }

    var dropdownHeight = ($scope.dropdownItems || MAX_ITEMS) * ITEM_HEIGHT;
    var hrect  = elements.wrap.getBoundingClientRect(),
        vrect  = elements.snap.getBoundingClientRect(),
        root   = elements.root.getBoundingClientRect(),
        top    = vrect.bottom - root.top,
        bot    = root.bottom - vrect.top,
        left   = hrect.left - root.left,
        width  = hrect.width,
        offset = getVerticalOffset(),
        position = $scope.dropdownPosition,
        styles, enoughBottomSpace, enoughTopSpace;
    var bottomSpace = root.bottom - vrect.bottom - MENU_PADDING + $mdUtil.getViewportTop();
    var topSpace = vrect.top - MENU_PADDING;

    // Automatically determine dropdown placement based on available space in viewport.
    if (!position) {
      enoughTopSpace = topSpace > dropdownHeight;
      enoughBottomSpace = bottomSpace > dropdownHeight;
      if (enoughBottomSpace) {
        position = 'bottom';
      } else if (enoughTopSpace) {
        position = 'top';
      } else {
        position = topSpace > bottomSpace ? 'top' : 'bottom';
      }
    }
    // Adjust the width to account for the padding provided by `md-input-container`
    if ($attrs.mdFloatingLabel) {
      left += INPUT_PADDING;
      width -= INPUT_PADDING * 2;
    }
    styles = {
      left:     left + 'px',
      minWidth: width + 'px',
      maxWidth: Math.max(hrect.right - root.left, root.right - hrect.left) - MENU_PADDING + 'px'
    };

    if (position === 'top') {
      styles.top       = 'auto';
      styles.bottom    = bot + 'px';
      styles.maxHeight = Math.min(dropdownHeight, topSpace) + 'px';
    } else {
      bottomSpace = root.bottom - hrect.bottom - MENU_PADDING + $mdUtil.getViewportTop();

      styles.top       = (top - offset) + 'px';
      styles.bottom    = 'auto';
      styles.maxHeight = Math.min(dropdownHeight, bottomSpace) + 'px';
    }

    elements.$.scrollContainer.css(styles);
    $mdUtil.nextTick(correctHorizontalAlignment, false, $scope);

    /**
     * Calculates the vertical offset for floating label examples to account for ngMessages
     * @returns {number}
     */
    function getVerticalOffset () {
      var offset = 0;
      var inputContainer = $element.find('md-input-container');
      if (inputContainer.length) {
        var input = inputContainer.find('input');
        offset = inputContainer.prop('offsetHeight');
        offset -= input.prop('offsetTop');
        offset -= input.prop('offsetHeight');
        // add in the height left up top for the floating label text
        offset += inputContainer.prop('offsetTop');
      }
      return offset;
    }

    /**
     * Makes sure that the menu doesn't go off of the screen on either side.
     */
    function correctHorizontalAlignment () {
      var dropdown = elements.scrollContainer.getBoundingClientRect(),
          styles   = {};
      if (dropdown.right > root.right) {
        styles.left = (hrect.right - dropdown.width) + 'px';
      }
      elements.$.scrollContainer.css(styles);
    }
  }

  /**
   * Moves the dropdown menu to the body tag in order to avoid z-index and overflow issues.
   */
  function moveDropdown () {
    if (!elements.$.root.length) return;
    $mdTheming(elements.$.scrollContainer);
    elements.$.scrollContainer.detach();
    elements.$.root.append(elements.$.scrollContainer);
    if ($animate.pin) $animate.pin(elements.$.scrollContainer, $rootElement);
  }

  /**
   * Sends focus to the input element.
   */
  function focusInputElement () {
    elements.input.focus();
  }

  /**
   * Update the activeOption based on the selected item in the listbox.
   * The activeOption is used in the template to set the aria-activedescendant attribute, which
   * enables screen readers to properly handle visual focus within the listbox and announce the
   * item's place in the list. I.e. "List item 3 of 50". Anytime that `ctrl.index` changes, this
   * function needs to be called to update the activeOption.
   */
  function updateActiveOption() {
    var selectedOption = elements.scroller.querySelector('.selected');
    if (selectedOption) {
      ctrl.activeOption = selectedOption.id;
    } else {
      ctrl.activeOption = null;
    }
  }

  /**
   * Sets up any watchers used by autocomplete
   */
  function configureWatchers () {
    var wait = parseInt($scope.delay, 10) || 0;

    $attrs.$observe('disabled', function (value) { ctrl.isDisabled = $mdUtil.parseAttributeBoolean(value, false); });
    $attrs.$observe('required', function (value) { ctrl.isRequired = $mdUtil.parseAttributeBoolean(value, false); });
    $attrs.$observe('readonly', function (value) { ctrl.isReadonly = $mdUtil.parseAttributeBoolean(value, false); });

    $scope.$watch('searchText', wait ? $mdUtil.debounce(handleSearchText, wait) : handleSearchText);
    $scope.$watch('selectedItem', selectedItemChange);

    angular.element($window).on('resize', debouncedOnResize);

    $scope.$on('$destroy', cleanup);
  }

  /**
   * Removes any events or leftover elements created by this controller
   */
  function cleanup () {
    if (!ctrl.hidden) {
      $mdUtil.enableScrolling();
    }

    angular.element($window).off('resize', debouncedOnResize);

    if (elements){
      var items = ['ul', 'scroller', 'scrollContainer', 'input'];
      angular.forEach(items, function(key){
        elements.$[key].remove();
      });
    }
  }

  /**
   * Event handler to be called whenever the window resizes.
   */
  function onWindowResize() {
    if (!ctrl.hidden) {
      positionDropdown();
    }
  }

  /**
   * Gathers all of the elements needed for this controller
   */
  function gatherElements () {

    var snapWrap = gatherSnapWrap();

    elements = {
      main:  $element[0],
      scrollContainer: $element[0].querySelector('.md-virtual-repeat-container, .md-standard-list-container'),
      scroller: $element[0].querySelector('.md-virtual-repeat-scroller, .md-standard-list-scroller'),
      ul:    $element.find('ul')[0],
      input: $element.find('input')[0],
      wrap:  snapWrap.wrap,
      snap:  snapWrap.snap,
      root:  document.body,
    };

    elements.li   = elements.ul.getElementsByTagName('li');
    elements.$    = getAngularElements(elements);
    mode = elements.scrollContainer.classList.contains('md-standard-list-container') ? MODE_STANDARD : MODE_VIRTUAL;
    inputModelCtrl = elements.$.input.controller('ngModel');
  }

  /**
   * Gathers the snap and wrap elements
   *
   */
  function gatherSnapWrap() {
    var element;
    var value;
    for (element = $element; element.length; element = element.parent()) {
      value = element.attr('md-autocomplete-snap');
      if (angular.isDefined(value)) break;
    }

    if (element.length) {
      return {
        snap: element[0],
        wrap: (value.toLowerCase() === 'width') ? element[0] : $element.find('md-autocomplete-wrap')[0]
      };
    }

    var wrap = $element.find('md-autocomplete-wrap')[0];
    return {
      snap: wrap,
      wrap: wrap
    };
  }

  /**
   * Gathers angular-wrapped versions of each element
   * @param elements
   * @returns {{}}
   */
  function getAngularElements (elements) {
    var obj = {};
    for (var key in elements) {
      if (elements.hasOwnProperty(key)) obj[ key ] = angular.element(elements[ key ]);
    }
    return obj;
  }

  // event/change handlers

  /**
   * @param {Event} $event
   */
  function preventDefault($event) {
    $event.preventDefault();
  }

  /**
   * @param {Event} $event
   */
  function stopPropagation($event) {
    $event.stopPropagation();
  }

  /**
   * Handles changes to the `hidden` property.
   * @param {boolean} hidden true to hide the options pop-up, false to show it.
   * @param {boolean} oldHidden the previous value of hidden
   */
  function handleHiddenChange (hidden, oldHidden) {
    var scrollContainerElement;

    if (elements) {
      scrollContainerElement = angular.element(elements.scrollContainer);
    }
    if (!hidden && oldHidden) {
      positionDropdown();

      // Report in polite mode, because the screen reader should finish the default description of
      // the input element.
      reportMessages(true, ReportType.Count | ReportType.Selected);

      if (elements) {
        $mdUtil.disableScrollAround(elements.scrollContainer);
        enableWrapScroll = disableElementScrollEvents(elements.wrap);
        if ($mdUtil.isIos) {
          ctrl.documentElement.on('touchend', handleTouchOutsidePanel);
          if (scrollContainerElement) {
            scrollContainerElement.on('touchstart touchmove touchend', stopPropagation);
          }
        }
        ctrl.index = getDefaultIndex();
        $mdUtil.nextTick(function() {
          updateActiveOption();
          updateScroll();
        });
      }
    } else if (hidden && !oldHidden) {
      if ($mdUtil.isIos) {
        ctrl.documentElement.off('touchend', handleTouchOutsidePanel);
        if (scrollContainerElement) {
          scrollContainerElement.off('touchstart touchmove touchend', stopPropagation);
        }
      }
      $mdUtil.enableScrolling();

      if (enableWrapScroll) {
        enableWrapScroll();
        enableWrapScroll = null;
      }
    }
  }

  /**
   * Handling touch events that bubble up to the document is required for closing the dropdown
   * panel on touch outside of the options pop-up panel on iOS.
   * @param {Event} $event
   */
  function handleTouchOutsidePanel($event) {
    ctrl.hidden = true;
    // iOS does not blur the pop-up for touches on the scroll mask, so we have to do it.
    doBlur(true);
  }

  /**
   * Disables scrolling for a specific element.
   * @param {!string|!DOMElement} element to disable scrolling
   * @return {Function} function to call to re-enable scrolling for the element
   */
  function disableElementScrollEvents(element) {
    var elementToDisable = angular.element(element);
    elementToDisable.on('wheel touchmove', preventDefault);

    return function() {
      elementToDisable.off('wheel touchmove', preventDefault);
    };
  }

  /**
   * When the user mouses over the dropdown menu, ignore blur events.
   */
  function onListEnter () {
    noBlur = true;
  }

  /**
   * When the user's mouse leaves the menu, blur events may hide the menu again.
   */
  function onListLeave () {
    if (!hasFocus && !ctrl.hidden) elements.input.focus();
    noBlur = false;
    ctrl.hidden = shouldHide();
  }

  /**
   * Handles changes to the selected item.
   * @param selectedItem
   * @param previousSelectedItem
   */
  function selectedItemChange (selectedItem, previousSelectedItem) {

    updateModelValidators();

    if (selectedItem) {
      getDisplayValue(selectedItem).then(function (val) {
        $scope.searchText = val;
        handleSelectedItemChange(selectedItem, previousSelectedItem);
      });
    } else if (previousSelectedItem && $scope.searchText) {
      getDisplayValue(previousSelectedItem).then(function(displayValue) {
        // Clear the searchText, when the selectedItem is set to null.
        // Do not clear the searchText, when the searchText isn't matching with the previous
        // selected item.
        if (angular.isString($scope.searchText)
          && displayValue.toString().toLowerCase() === $scope.searchText.toLowerCase()) {
          $scope.searchText = '';
        }
      });
    }

    if (selectedItem !== previousSelectedItem) {
      announceItemChange();
    }
  }

  /**
   * Use the user-defined expression to announce changes each time a new item is selected
   */
  function announceItemChange () {
    angular.isFunction($scope.itemChange) &&
      $scope.itemChange(getItemAsNameVal($scope.selectedItem));
  }

  /**
   * Use the user-defined expression to announce changes each time the search text is changed
   */
  function announceTextChange () {
    angular.isFunction($scope.textChange) && $scope.textChange();
  }

  /**
   * Calls any external watchers listening for the selected item.  Used in conjunction with
   * `registerSelectedItemWatcher`.
   * @param selectedItem
   * @param previousSelectedItem
   */
  function handleSelectedItemChange (selectedItem, previousSelectedItem) {
    selectedItemWatchers.forEach(function (watcher) {
      watcher(selectedItem, previousSelectedItem);
    });
  }

  /**
   * Register a function to be called when the selected item changes.
   * @param cb
   */
  function registerSelectedItemWatcher (cb) {
    if (selectedItemWatchers.indexOf(cb) === -1) {
      selectedItemWatchers.push(cb);
    }
  }

  /**
   * Unregister a function previously registered for selected item changes.
   * @param cb
   */
  function unregisterSelectedItemWatcher (cb) {
    var i = selectedItemWatchers.indexOf(cb);
    if (i !== -1) {
      selectedItemWatchers.splice(i, 1);
    }
  }

  /**
   * Handles changes to the searchText property.
   * @param {string} searchText
   * @param {string} previousSearchText
   */
  function handleSearchText (searchText, previousSearchText) {
    ctrl.index = getDefaultIndex();

    // do nothing on init
    if (searchText === previousSearchText) return;

    updateModelValidators();

    getDisplayValue($scope.selectedItem).then(function (val) {
      // clear selected item if search text no longer matches it
      if (searchText !== val) {
        $scope.selectedItem = null;

        // trigger change event if available
        if (searchText !== previousSearchText) {
          announceTextChange();
        }

        // cancel results if search text is not long enough
        if (!isMinLengthMet()) {
          ctrl.matches = [];

          setLoading(false);
          reportMessages(true, ReportType.Count);

        } else {
          handleQuery();
        }
      }
    });

  }

  /**
   * Handles input blur event, determines if the dropdown should hide.
   * @param {Event=} $event
   */
  function blur($event) {
    hasFocus = false;

    if (!noBlur) {
      ctrl.hidden = shouldHide();
      evalAttr('ngBlur', { $event: $event });
    } else if (angular.isObject($event)) {
      $event.stopImmediatePropagation();
    }
  }

  /**
   * Force blur on input element
   * @param {boolean} forceBlur
   */
  function doBlur(forceBlur) {
    if (forceBlur) {
      noBlur = false;
      hasFocus = false;
    }
    elements.input.blur();
  }

  /**
   * Handles input focus event, determines if the dropdown should show.
   */
  function focus($event) {
    hasFocus = true;

    if (isSearchable() && isMinLengthMet()) {
      handleQuery();
    }

    ctrl.hidden = shouldHide();

    evalAttr('ngFocus', { $event: $event });
  }

  /**
   * Handles keyboard input.
   * @param event
   */
  function keydown (event) {
    switch (event.keyCode) {
      case $mdConstant.KEY_CODE.DOWN_ARROW:
        if (ctrl.loading || hasSelection()) return;
        event.stopPropagation();
        event.preventDefault();
        ctrl.index = ctrl.index + 1 > ctrl.matches.length - 1 ? 0 : Math.min(ctrl.index + 1, ctrl.matches.length - 1);
        $mdUtil.nextTick(updateActiveOption);
        updateScroll();
        break;
      case $mdConstant.KEY_CODE.UP_ARROW:
        if (ctrl.loading || hasSelection()) return;
        event.stopPropagation();
        event.preventDefault();
        ctrl.index = ctrl.index - 1 < 0 ? ctrl.matches.length - 1 : Math.max(0, ctrl.index - 1);
        $mdUtil.nextTick(updateActiveOption);
        updateScroll();
        break;
      case $mdConstant.KEY_CODE.TAB:
        // If we hit tab, assume that we've left the list so it will close
        onListLeave();

        if (ctrl.hidden || ctrl.loading || ctrl.index < 0 || ctrl.matches.length < 1) return;
        select(ctrl.index);
        break;
      case $mdConstant.KEY_CODE.ENTER:
        if (ctrl.hidden || ctrl.loading || ctrl.index < 0 || ctrl.matches.length < 1) return;
        if (hasSelection()) return;
        event.stopImmediatePropagation();
        event.preventDefault();
        select(ctrl.index);
        break;
      case $mdConstant.KEY_CODE.ESCAPE:
        event.preventDefault(); // Prevent browser from always clearing input
        if (!shouldProcessEscape()) return;
        event.stopPropagation();

        clearSelectedItem();
        if ($scope.searchText && hasEscapeOption('clear')) {
          clearSearchText();
        }

        // Manually hide (needed for mdNotFound support)
        ctrl.hidden = true;

        if (hasEscapeOption('blur')) {
          // Force the component to blur if they hit escape
          doBlur(true);
        }

        break;
      default:
    }
  }

  // getters

  /**
   * Returns the minimum length needed to display the dropdown.
   * @returns {*}
   */
  function getMinLength () {
    return angular.isNumber($scope.minLength) ? $scope.minLength : 1;
  }

  /**
   * Returns the display value for an item.
   * @param {*} item
   * @returns {*}
   */
  function getDisplayValue (item) {
    return $q.when(getItemText(item) || item).then(function(itemText) {
      if (itemText && !angular.isString(itemText)) {
        $log.warn('md-autocomplete: Could not resolve display value to a string. ' +
          'Please check the `md-item-text` attribute.');
      }

      return itemText;
    });

    /**
     * Getter function to invoke user-defined expression (in the directive)
     * to convert your object to a single string.
     * @param {*} item
     * @returns {string|null}
     */
    function getItemText (item) {
      return (item && $scope.itemText) ? $scope.itemText(getItemAsNameVal(item)) : null;
    }
  }

  /**
   * Returns the locals object for compiling item templates.
   * @param {*} item
   * @returns {Object|undefined}
   */
  function getItemAsNameVal (item) {
    if (!item) {
      return undefined;
    }

    var locals = {};
    if (ctrl.itemName) {
      locals[ ctrl.itemName ] = item;
    }

    return locals;
  }

  /**
   * Returns the default index based on whether or not autoselect is enabled.
   * @returns {number} 0 if autoselect is enabled, -1 if not.
   */
  function getDefaultIndex () {
    return $scope.autoselect ? 0 : -1;
  }

  /**
   * Sets the loading parameter and updates the hidden state.
   * @param value {boolean} Whether or not the component is currently loading.
   */
  function setLoading(value) {
    if (ctrl.loading !== value) {
      ctrl.loading = value;
    }

    // Always refresh the hidden variable as something else might have changed
    ctrl.hidden = shouldHide();
  }

  /**
   * Determines if the menu should be hidden.
   * @returns {boolean} true if the menu should be hidden
   */
  function shouldHide () {
    return !shouldShow();
  }

  /**
   * Determines whether the autocomplete is able to query within the current state.
   * @returns {boolean} true if the query can be run
   */
  function isSearchable() {
    if (ctrl.loading && !hasMatches()) {
      // No query when query is in progress.
      return false;
    } else if (hasSelection()) {
      // No query if there is already a selection
      return false;
    }
    else if (!hasFocus) {
      // No query if the input does not have focus
      return false;
    }
    return true;
  }

  /**
   * @returns {boolean} if the escape keydown should be processed, return true.
   *  Otherwise return false.
   */
  function shouldProcessEscape() {
    return hasEscapeOption('blur') || !ctrl.hidden || ctrl.loading || hasEscapeOption('clear') && $scope.searchText;
  }

  /**
   * @param {string} option check if this option is set
   * @returns {boolean} if the specified escape option is set, return true. Return false otherwise.
   */
  function hasEscapeOption(option) {
    if (!angular.isString($scope.escapeOptions)) {
      return ctrl.defaultEscapeOptions.indexOf(option) !== -1;
    } else {
      return $scope.escapeOptions.toLowerCase().indexOf(option) !== -1;
    }
  }

  /**
   * Determines if the menu should be shown.
   * @returns {boolean} true if the menu should be shown
   */
  function shouldShow() {
    if (ctrl.isReadonly) {
      // Don't show if read only is set
      return false;
    } else if (!isSearchable()) {
      // Don't show if a query is in progress, there is already a selection,
      // or the input is not focused.
      return false;
    }
    return (isMinLengthMet() && hasMatches()) || notFoundVisible();
  }

  /**
   * @returns {boolean} true if the search text has matches.
   */
  function hasMatches() {
    return ctrl.matches.length ? true : false;
  }

  /**
   * @returns {boolean} true if the autocomplete has a valid selection.
   */
  function hasSelection() {
    return ctrl.scope.selectedItem ? true : false;
  }

  /**
   * @returns {boolean} true if the loading indicator is, or should be, visible.
   */
  function loadingIsVisible() {
    return ctrl.loading && !hasSelection();
  }

  /**
   * @returns {*} the display value of the current item.
   */
  function getCurrentDisplayValue () {
    return getDisplayValue(ctrl.matches[ ctrl.index ]);
  }

  /**
   * Determines if the minimum length is met by the search text.
   * @returns {*} true if the minimum length is met by the search text
   */
  function isMinLengthMet () {
    return ($scope.searchText || '').length >= getMinLength();
  }

  // actions

  /**
   * Defines a public property with a handler and a default value.
   * @param {string} key
   * @param {Function} handler function
   * @param {*} defaultValue default value
   */
  function defineProperty (key, handler, defaultValue) {
    Object.defineProperty(ctrl, key, {
      get: function () { return defaultValue; },
      set: function (newValue) {
        var oldValue = defaultValue;
        defaultValue        = newValue;
        handler(newValue, oldValue);
      }
    });
  }

  /**
   * Selects the item at the given index.
   * @param {number} index to select
   */
  function select (index) {
    // force form to update state for validation
    $mdUtil.nextTick(function () {
      getDisplayValue(ctrl.matches[ index ]).then(function (val) {
        var ngModel = elements.$.input.controller('ngModel');
        $mdLiveAnnouncer.announce(val + ' ' + ctrl.selectedMessage, 'assertive');
        ngModel.$setViewValue(val);
        ngModel.$render();
      }).finally(function () {
        $scope.selectedItem = ctrl.matches[ index ];
        setLoading(false);
      });
    }, false);
  }

  /**
   * Clears the searchText value and selected item.
   * @param {Event} $event
   */
  function clearValue ($event) {
    if ($event) {
      $event.stopPropagation();
    }
    clearSelectedItem();
    clearSearchText();
  }

  /**
   * Clears the selected item
   */
  function clearSelectedItem () {
    // Reset our variables
    ctrl.index = -1;
    $mdUtil.nextTick(updateActiveOption);
    ctrl.matches = [];
  }

  /**
   * Clears the searchText value
   */
  function clearSearchText () {
    // Set the loading to true so we don't see flashes of content.
    // The flashing will only occur when an async request is running.
    // So the loading process will stop when the results had been retrieved.
    setLoading(true);

    $scope.searchText = '';

    // Normally, triggering the change / input event is unnecessary, because the browser detects it properly.
    // But some browsers are not detecting it properly, which means that we have to trigger the event.
    // Using the `input` is not working properly, because for example IE11 is not supporting the `input` event.
    // The `change` event is a good alternative and is supported by all supported browsers.
    var eventObj = document.createEvent('CustomEvent');
    eventObj.initCustomEvent('change', true, true, { value: '' });
    elements.input.dispatchEvent(eventObj);

    // For some reason, firing the above event resets the value of $scope.searchText if
    // $scope.searchText has a space character at the end, so we blank it one more time and then
    // focus.
    elements.input.blur();
    $scope.searchText = '';
    elements.input.focus();
  }

  /**
   * Fetches the results for the provided search text.
   * @param searchText
   */
  function fetchResults (searchText) {
    var items = $scope.$parent.$eval(itemExpr),
        term  = searchText.toLowerCase(),
        isList = angular.isArray(items),
        isPromise = !!items.then; // Every promise should contain a `then` property

    if (isList) onResultsRetrieved(items);
    else if (isPromise) handleAsyncResults(items);

    function handleAsyncResults(items) {
      if (!items) return;

      items = $q.when(items);
      fetchesInProgress++;
      setLoading(true);

      $mdUtil.nextTick(function () {
          items
            .then(onResultsRetrieved)
            .finally(function(){
              if (--fetchesInProgress === 0) {
                setLoading(false);
              }
            });
      },true, $scope);
    }

    function onResultsRetrieved(matches) {
      cache[term] = matches;

      // Just cache the results if the request is now outdated.
      // The request becomes outdated, when the new searchText has changed during the result fetching.
      if ((searchText || '') !== ($scope.searchText || '')) {
        return;
      }

      handleResults(matches);
    }
  }


  /**
   * Reports given message types to supported screen readers.
   * @param {boolean} isPolite Whether the announcement should be polite.
   * @param {!number} types Message flags to be reported to the screen reader.
   */
  function reportMessages(isPolite, types) {
    var politeness = isPolite ? 'polite' : 'assertive';
    var messages = [];

    if (types & ReportType.Selected && ctrl.index !== -1) {
      messages.push(getCurrentDisplayValue());
    }

    if (types & ReportType.Count) {
      messages.push($q.resolve(getCountMessage()));
    }

    $q.all(messages).then(function(data) {
      $mdLiveAnnouncer.announce(data.join(' '), politeness);
    });
  }

  /**
   * @returns {string} the ARIA message for how many results match the current query.
   */
  function getCountMessage () {
    switch (ctrl.matches.length) {
      case 0:
        return ctrl.noMatchMessage;
      case 1:
        return ctrl.singleMatchMessage;
      default:
        return ctrl.multipleMatchStartMessage + ctrl.matches.length + ctrl.multipleMatchEndMessage;
    }
  }

  /**
   * Makes sure that the focused element is within view.
   */
  function updateScroll () {
    if (!elements.li[0]) return;
    if (mode === MODE_STANDARD) {
      updateStandardScroll();
    } else {
      updateVirtualScroll();
    }
  }

  function updateVirtualScroll() {
    // elements in virtual scroll have consistent heights
    var optionHeight = elements.li[0].offsetHeight,
        top = optionHeight * Math.max(0, ctrl.index),
        bottom = top + optionHeight,
        containerHeight = elements.scroller.clientHeight,
        scrollTop = elements.scroller.scrollTop;

    if (top < scrollTop) {
      scrollTo(top);
    } else if (bottom > scrollTop + containerHeight) {
      scrollTo(bottom - containerHeight);
    }
  }

  function updateStandardScroll() {
    // elements in standard scroll have variable heights
    var selected =  elements.li[Math.max(0, ctrl.index)];
    var containerHeight = elements.scrollContainer.offsetHeight,
        top = selected && selected.offsetTop || 0,
        bottom = top + selected.clientHeight,
        scrollTop = elements.scrollContainer.scrollTop;

    if (top < scrollTop) {
      scrollTo(top);
    } else if (bottom > scrollTop + containerHeight) {
      scrollTo(bottom - containerHeight);
    }
  }

  function isPromiseFetching() {
    return fetchesInProgress !== 0;
  }

  function scrollTo (offset) {
    if (mode === MODE_STANDARD) {
      elements.scrollContainer.scrollTop = offset;
    } else {
      elements.$.scrollContainer.controller('mdVirtualRepeatContainer').scrollTo(offset);
    }
  }

  function notFoundVisible () {
    var textLength = (ctrl.scope.searchText || '').length;

    return ctrl.hasNotFound && !hasMatches() && (!ctrl.loading || isPromiseFetching()) && textLength >= getMinLength() && (hasFocus || noBlur) && !hasSelection();
  }

  /**
   * Starts the query to gather the results for the current searchText.  Attempts to return cached
   * results first, then forwards the process to `fetchResults` if necessary.
   */
  function handleQuery () {
    var searchText = $scope.searchText || '';
    var term = searchText.toLowerCase();

    // If caching is enabled and the current searchText is stored in the cache
    if (!$scope.noCache && cache[term]) {
      // The results should be handled as same as a normal un-cached request does.
      handleResults(cache[term]);
    } else {
      fetchResults(searchText);
    }

    ctrl.hidden = shouldHide();
  }

  /**
   * Handles the retrieved results by showing them in the autocompletes dropdown.
   * @param results Retrieved results
   */
  function handleResults(results) {
    ctrl.matches = results;
    ctrl.hidden  = shouldHide();

    // If loading is in progress, then we'll end the progress. This is needed for example,
    // when the `clear` button was clicked, because there we always show the loading process, to prevent flashing.
    if (ctrl.loading) setLoading(false);

    if ($scope.selectOnMatch) selectItemOnMatch();

    positionDropdown();
    reportMessages(true, ReportType.Count);
  }

  /**
   * If there is only one matching item and the search text matches its display value exactly,
   * automatically select that item.  Note: This function is only called if the user uses the
   * `md-select-on-match` flag.
   */
  function selectItemOnMatch () {
    var searchText = $scope.searchText,
        matches    = ctrl.matches,
        item       = matches[ 0 ];
    if (matches.length === 1) getDisplayValue(item).then(function (displayValue) {
      var isMatching = searchText === displayValue;
      if ($scope.matchInsensitive && !isMatching) {
        isMatching = searchText.toLowerCase() === displayValue.toLowerCase();
      }

      if (isMatching) {
        select(0);
      }
    });
  }

  /**
   * Evaluates an attribute expression against the parent scope.
   * @param {String} attr Name of the attribute to be evaluated.
   * @param {Object?} locals Properties to be injected into the evaluation context.
   */
 function evalAttr(attr, locals) {
    if ($attrs[attr]) {
      $scope.$parent.$eval($attrs[attr], locals || {});
    }
  }

}

})();
(function(){
"use strict";


MdAutocomplete.$inject = ["$$mdSvgRegistry"];angular
    .module('material.components.autocomplete')
    .directive('mdAutocomplete', MdAutocomplete);

/**
 * @ngdoc directive
 * @name mdAutocomplete
 * @module material.components.autocomplete
 *
 * @description
 * `<md-autocomplete>` is a special input component with a drop-down of all possible matches to a
 *     custom query. This component allows you to provide real-time suggestions as the user types
 *     in the input area.
 *
 * To start, you will need to specify the required parameters and provide a template for your
 *     results. The content inside `md-autocomplete` will be treated as a template.
 *
 * In more complex cases, you may want to include other content such as a message to display when
 *     no matches were found.  You can do this by wrapping your template in `md-item-template` and
 *     adding a tag for `md-not-found`.  An example of this is shown below.
 *
 * To reset the displayed value you must clear both values for `md-search-text` and
 * `md-selected-item`.
 *
 * ### Validation
 *
 * You can use `ng-messages` to include validation the same way that you would normally validate;
 *     however, if you want to replicate a standard input with a floating label, you will have to
 *     do the following:
 *
 * - Make sure that your template is wrapped in `md-item-template`
 * - Add your `ng-messages` code inside of `md-autocomplete`
 * - Add your validation properties to `md-autocomplete` (ie. `required`)
 * - Add a `name` to `md-autocomplete` (to be used on the generated `input`)
 *
 * There is an example below of how this should look.
 *
 * ### Snapping Drop-Down
 *
 * You can cause the autocomplete drop-down to snap to an ancestor element by applying the
 *     `md-autocomplete-snap` attribute to that element. You can also snap to the width of
 *     the `md-autocomplete-snap` element by setting the attribute's value to `width`
 *     (ie. `md-autocomplete-snap="width"`).
 *
 * ### Notes
 *
 * **Autocomplete Dropdown Items Rendering**
 *
 * The `md-autocomplete` uses the the <a ng-href="api/directive/mdVirtualRepeat">
 *   mdVirtualRepeat</a> directive for displaying the results inside of the dropdown.<br/>
 *
 * > When encountering issues regarding the item template please take a look at the
 *   <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeatContainer</a> documentation.
 *
 * **Autocomplete inside of a Virtual Repeat**
 *
 * When using the `md-autocomplete` directive inside of a
 * <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeatContainer</a> the dropdown items
 * might not update properly, because caching of the results is enabled by default.
 *
 * The autocomplete will then show invalid dropdown items, because the Virtual Repeat only updates
 * the scope bindings rather than re-creating the `md-autocomplete`. This means that the previous
 * cached results will be used.
 *
 * > To avoid such problems, ensure that the autocomplete does not cache any results via
 * `md-no-cache="true"`:
 *
 * <hljs lang="html">
 *   <md-autocomplete
 *       md-no-cache="true"
 *       md-selected-item="selectedItem"
 *       md-items="item in items"
 *       md-search-text="searchText"
 *       md-item-text="item.display">
 *     <span>{{ item.display }}</span>
 *   </md-autocomplete>
 * </hljs>
 *
 *
 * @param {expression} md-items An expression in the format of `item in results` to iterate over
 *     matches for your search.<br/><br/>
 *     The `results` expression can be also a function, which returns the results synchronously
 *     or asynchronously (per Promise).
 * @param {expression=} md-selected-item-change An expression to be run each time a new item is
 *     selected.
 * @param {expression=} md-search-text-change An expression to be run each time the search text
 *     updates.
 * @param {expression=} md-search-text A model to bind the search query text to.
 * @param {object=} md-selected-item A model to bind the selected item to.
 * @param {expression=} md-item-text An expression that will convert your object to a single string.
 * @param {string=} placeholder Placeholder text that will be forwarded to the input.
 * @param {boolean=} md-no-cache Disables the internal caching that happens in autocomplete.
 * @param {boolean=} ng-disabled Determines whether or not to disable the input field.
 * @param {boolean=} md-require-match When set to true, the autocomplete will add a validator,
 *     which will evaluate to false, when no item is currently selected.
 * @param {number=} md-min-length Specifies the minimum length of text before autocomplete will
 *     make suggestions.
 * @param {number=} md-delay Specifies the amount of time (in milliseconds) to wait before looking
 *     for results.
 * @param {boolean=} md-clear-button Whether the clear button for the autocomplete input should show
 *     up or not. When `md-floating-label` is set, defaults to false, defaults to true otherwise.
 * @param {boolean=} md-autofocus If true, the autocomplete will be automatically focused when a
 *     `$mdDialog`, `$mdBottomsheet` or `$mdSidenav`, which contains the autocomplete, is opening.
 *     <br/><br/>
 *     Also the autocomplete will immediately focus the input element.
 * @param {boolean=} md-no-asterisk When present, asterisk will not be appended to the floating
 *     label.
 * @param {boolean=} md-autoselect If set to true, the first item will be automatically selected
 *     in the dropdown upon open.
 * @param {string=} md-input-name The name attribute given to the input element to be used with
 *     FormController.
 * @param {string=} md-menu-class This class will be applied to the dropdown menu for styling.
 * @param {string=} md-menu-container-class This class will be applied to the parent container
 *     of the dropdown panel.
 * @param {string=} md-input-class This will be applied to the input for styling. This attribute
 *     is only valid when a `md-floating-label` is defined.
 * @param {string=} md-floating-label This will add a floating label to autocomplete and wrap it in
 *     `md-input-container`.
 * @param {string=} md-select-on-focus When present the input's text will be automatically selected
 *     on focus.
 * @param {string=} md-input-id An ID to be added to the input element.
 * @param {number=} md-input-minlength The minimum length for the input's value for validation.
 * @param {number=} md-input-maxlength The maximum length for the input's value for validation.
 * @param {boolean=} md-select-on-match When set, autocomplete will automatically select
 *     the item if the search text is an exact match. <br/><br/>
 *     An exact match is when only one match is displayed.
 * @param {boolean=} md-match-case-insensitive When set and using `md-select-on-match`, autocomplete
 *     will select on case-insensitive match.
 * @param {string=} md-escape-options Override escape key logic. Default is `clear`.<br/>
 *     Options: `blur`, `clear`, `none`.
 * @param {string=} md-dropdown-items Specifies the maximum amount of items to be shown in
 *     the dropdown.<br/><br/>
 *     When the dropdown doesn't fit into the viewport, the dropdown will shrink
 *     as much as possible.
 * @param {string=} md-dropdown-position Overrides the default dropdown position. Options: `top`,
 *    `bottom`.
 * @param {string=} input-aria-describedby A space-separated list of element IDs. This should
 *     contain the IDs of any elements that describe this autocomplete. Screen readers will read the
 *     content of these elements at the end of announcing that the autocomplete has been selected
 *     and describing its current state. The descriptive elements do not need to be visible on the
 *     page.
 * @param {string=} input-aria-labelledby A space-separated list of element IDs. The ideal use case
 *     is that this would contain the ID of a `<label>` element that is associated with this
 *     autocomplete. This will only have affect when `md-floating-label` is not defined.<br><br>
 *     For `<label id="state">US State</label>`, you would set this to
 *     `input-aria-labelledby="state"`.
 * @param {string=} input-aria-label A label that will be applied to the autocomplete's input.
 *    This will be announced by screen readers before the placeholder.
 *    This will only have affect when `md-floating-label` is not defined. If you define both
 *    `input-aria-label` and `input-aria-labelledby`, then `input-aria-label` will take precedence.
 * @param {string=} md-selected-message Attribute to specify the text that the screen reader will
 *    announce after a value is selected. Default is: "selected". If `Alaska` is selected in the
 *    options panel, it will read "Alaska selected". You will want to override this when your app
 *    runs in a non-English locale.
 * @param {string=} md-no-match-message Attribute to specify the text that the screen reader will
 *    announce after a query returns no matching results.
 *    Default is: "There are no matches available.". You will want to override this when your app
 *    runs in a non-English locale.
 * @param {string=} md-single-match-message Attribute to specify the text that the screen reader
 *    will announce after a query returns a single matching result.
 *    Default is: "There is 1 match available.". You will want to override this when your app
 *    runs in a non-English locale.
 * @param {string=} md-multiple-match-start-message Attribute to specify the text that the screen
 *    reader will announce after a query returns multiple matching results. The number of matching
 *    results will be read after this text. Default is: "There are ". You will want to override this
 *    when your app runs in a non-English locale.
 * @param {string=} md-multiple-match-end-message Attribute to specify the text that the screen
 *    reader will announce after a query returns multiple matching results. The number of matching
 *    results will be read before this text. Default is: " matches available.". You will want to
 *    override this when your app runs in a non-English locale.
 * @param {boolean=} ng-trim If set to false, the search text will be not trimmed automatically.
 *     Defaults to true.
 * @param {string=} ng-pattern Adds the pattern validator to the ngModel of the search text.
 *     See the [ngPattern Directive](https://docs.angularjs.org/api/ng/directive/ngPattern)
 *     for more details.
 * @param {string=} md-mode Specify the repeat mode for suggestion lists. Acceptable values include
 *     `virtual` (md-virtual-repeat) and `standard` (ng-repeat). See the
 *     `Specifying Repeat Mode` example for mode details. Default is `virtual`.
 *
 * @usage
 * ### Basic Example
 * <hljs lang="html">
 *   <md-autocomplete
 *       md-selected-item="selectedItem"
 *       md-search-text="searchText"
 *       md-items="item in getMatches(searchText)"
 *       md-item-text="item.display">
 *     <span md-highlight-text="searchText">{{item.display}}</span>
 *   </md-autocomplete>
 * </hljs>
 *
 * ### Example with "not found" message
 * <hljs lang="html">
 * <md-autocomplete
 *     md-selected-item="selectedItem"
 *     md-search-text="searchText"
 *     md-items="item in getMatches(searchText)"
 *     md-item-text="item.display">
 *   <md-item-template>
 *     <span md-highlight-text="searchText">{{item.display}}</span>
 *   </md-item-template>
 *   <md-not-found>
 *     No matches found.
 *   </md-not-found>
 * </md-autocomplete>
 * </hljs>
 *
 * In this example, our code utilizes `md-item-template` and `md-not-found` to specify the
 *     different parts that make up our component.
 *
 * ### Clear button for the input
 * By default, the clear button is displayed when there is input. This aligns with the spec's
 * [Search Pattern](https://material.io/archive/guidelines/patterns/search.html#search-in-app-search).
 * In floating label mode, when `md-floating-label="My Label"` is applied, the clear button is not
 * displayed by default (see the spec's
 * [Autocomplete Text Field](https://material.io/archive/guidelines/components/text-fields.html#text-fields-layout)).
 *
 * Nevertheless, developers are able to explicitly toggle the clear button for all autocomplete
 * components with `md-clear-button`.
 *
 * <hljs lang="html">
 *   <md-autocomplete ... md-clear-button="true"></md-autocomplete>
 *   <md-autocomplete ... md-clear-button="false"></md-autocomplete>
 * </hljs>
 *
 * In previous versions, the clear button was always hidden when the component was disabled.
 * This changed in `1.1.5` to give the developer control of this behavior. This example
 * will hide the clear button only when the component is disabled.
 *
 * <hljs lang="html">
 *   <md-autocomplete ... ng-disabled="disabled" md-clear-button="!disabled"></md-autocomplete>
 * </hljs>
 *
 * ### Example with validation
 * <hljs lang="html">
 * <form name="autocompleteForm">
 *   <md-autocomplete
 *       required
 *       md-input-name="autocomplete"
 *       md-selected-item="selectedItem"
 *       md-search-text="searchText"
 *       md-items="item in getMatches(searchText)"
 *       md-item-text="item.display">
 *     <md-item-template>
 *       <span md-highlight-text="searchText">{{item.display}}</span>
 *     </md-item-template>
 *     <div ng-messages="autocompleteForm.autocomplete.$error">
 *       <div ng-message="required">This field is required</div>
 *     </div>
 *   </md-autocomplete>
 * </form>
 * </hljs>
 *
 * In this example, our code utilizes `md-item-template` and `ng-messages` to specify
 *     input validation for the field.
 *
 * ### Asynchronous Results
 * The autocomplete items expression also supports promises, which will resolve with the query
 * results.
 *
 * <hljs lang="js">
 *   function AppController($scope, $http) {
 *     $scope.query = function(searchText) {
 *       return $http
 *         .get(BACKEND_URL + '/items/' + searchText)
 *         .then(function(data) {
 *           // Map the response object to the data object.
 *           return data;
 *         });
 *     };
 *   }
 * </hljs>
 *
 * <hljs lang="html">
 *   <md-autocomplete
 *       md-selected-item="selectedItem"
 *       md-search-text="searchText"
 *       md-items="item in query(searchText)">
 *     <md-item-template>
 *       <span md-highlight-text="searchText">{{item}}</span>
 *     </md-item-template>
 * </md-autocomplete>
 * </hljs>
 *
 * ### Specifying Repeat Mode
 * You can use `md-mode` to specify whether to use standard or virtual lists for
 * rendering autocomplete options.
 * The `md-mode` accepts two values:
 * - `virtual` (default) Uses `md-virtual-repeat` to render list items. Virtual
 *    mode requires you to have consistent heights for all suggestions.
 * - `standard` uses `ng-repeat` to render list items. This allows you to have
 *    options of varying heights.
 *
 * Note that using 'standard' mode will require you to address any list
 * performance issues (e.g. pagination) separately within your application.
 *
 * <hljs lang="html">
 *   <md-autocomplete
 *       md-selected-item="selectedItem"
 *       md-search-text="searchText"
 *       md-items="item in getMatches(searchText)"
 *       md-item-text="item.display"
 *       md-mode="standard">
 *     <span md-highlight-text="searchText">{{item.display}}</span>
 *   </md-autocomplete>
 * </hljs>
 */
function MdAutocomplete ($$mdSvgRegistry) {
  var REPEAT_STANDARD = 'standard';
  var REPEAT_VIRTUAL = 'virtual';
  var REPEAT_MODES = [REPEAT_STANDARD, REPEAT_VIRTUAL];

  /** get a valid repeat mode from an md-mode attribute string. */
  function getRepeatMode(modeStr) {
    if (!modeStr) { return REPEAT_VIRTUAL; }
    modeStr = modeStr.toLowerCase();
    return  REPEAT_MODES.indexOf(modeStr) > -1 ? modeStr : REPEAT_VIRTUAL;
  }

  return {
    controller:   'MdAutocompleteCtrl',
    controllerAs: '$mdAutocompleteCtrl',
    scope:        {
      inputName:          '@mdInputName',
      inputMinlength:     '@mdInputMinlength',
      inputMaxlength:     '@mdInputMaxlength',
      searchText:         '=?mdSearchText',
      selectedItem:       '=?mdSelectedItem',
      itemsExpr:          '@mdItems',
      itemText:           '&mdItemText',
      placeholder:        '@placeholder',
      inputAriaDescribedBy: '@?inputAriaDescribedby',
      inputAriaLabelledBy: '@?inputAriaLabelledby',
      inputAriaLabel:     '@?inputAriaLabel',
      noCache:            '=?mdNoCache',
      requireMatch:       '=?mdRequireMatch',
      selectOnMatch:      '=?mdSelectOnMatch',
      matchInsensitive:   '=?mdMatchCaseInsensitive',
      itemChange:         '&?mdSelectedItemChange',
      textChange:         '&?mdSearchTextChange',
      minLength:          '=?mdMinLength',
      delay:              '=?mdDelay',
      autofocus:          '=?mdAutofocus',
      floatingLabel:      '@?mdFloatingLabel',
      autoselect:         '=?mdAutoselect',
      menuClass:          '@?mdMenuClass',
      menuContainerClass: '@?mdMenuContainerClass',
      inputClass:         '@?mdInputClass',
      inputId:            '@?mdInputId',
      escapeOptions:      '@?mdEscapeOptions',
      dropdownItems:      '=?mdDropdownItems',
      dropdownPosition:   '@?mdDropdownPosition',
      clearButton:        '=?mdClearButton',
      selectedMessage:    '@?mdSelectedMessage',
      noMatchMessage:     '@?mdNoMatchMessage',
      singleMatchMessage: '@?mdSingleMatchMessage',
      multipleMatchStartMessage: '@?mdMultipleMatchStartMessage',
      multipleMatchEndMessage: '@?mdMultipleMatchEndMessage',
      mdMode: '=?mdMode'
    },
    compile: function(tElement, tAttrs) {
      var attributes = ['md-select-on-focus', 'md-no-asterisk', 'ng-trim', 'ng-pattern'];
      var input = tElement.find('input');

      attributes.forEach(function(attribute) {
        var attrValue = tAttrs[tAttrs.$normalize(attribute)];

        if (attrValue !== null) {
          input.attr(attribute, attrValue);
        }
      });

      return function(scope, element, attrs, ctrl) {
        // Retrieve the state of using a md-not-found template by using our attribute, which will
        // be added to the element in the template function.
        ctrl.hasNotFound = !!element.attr('md-has-not-found');

        // By default the inset autocomplete should show the clear button when not explicitly
        // overwritten or in floating label mode.
        if (!angular.isDefined(attrs.mdClearButton) && !scope.floatingLabel) {
          scope.clearButton = true;
        }

        scope.mdMode = getRepeatMode(attrs.mdMode);

        // Stop click events from bubbling up to the document and triggering a flicker of the
        // options panel while still supporting ng-click to be placed on md-autocomplete.
        element.on('click touchstart touchend', function(event) {
          event.stopPropagation();
        });
      };
    },
    template: function (element, attr) {
      var noItemsTemplate = getNoItemsTemplate(),
          itemTemplate    = getItemTemplate(),
          leftover        = element.html(),
          tabindex        = attr.tabindex;

      // Set our attribute for the link function above which runs later.
      // We will set an attribute, because otherwise the stored variables will be trashed when
      // removing the element is hidden while retrieving the template. For example when using ngIf.
      if (noItemsTemplate) element.attr('md-has-not-found', true);

      // Always set our tabindex of the autocomplete directive to -1, because our input
      // will hold the actual tabindex.
      element.attr('tabindex', '-1');

      return '\
        <md-autocomplete-wrap\
            ng-class="{ \'md-whiteframe-z1\': !floatingLabel, \
                        \'md-menu-showing\': !$mdAutocompleteCtrl.hidden, \
                        \'md-show-clear-button\': !!clearButton }">\
          ' + getInputElement() + '\
          ' + getClearButton() + '\
          <md-progress-linear\
              class="' + (attr.mdFloatingLabel ? 'md-inline' : '') + '"\
              ng-if="$mdAutocompleteCtrl.loadingIsVisible()"\
              md-mode="indeterminate"></md-progress-linear>\
          ' + getContainer(attr.mdMenuContainerClass, attr.mdMode) + '\
            <ul class="md-autocomplete-suggestions"\
                ng-class="::menuClass"\
                id="ul-{{$mdAutocompleteCtrl.id}}"\
                ng-mouseup="$mdAutocompleteCtrl.focusInput()"\
                role="listbox">\
              <li class="md-autocomplete-suggestion" ' + getRepeatType(attr.mdMode) + ' ="item in $mdAutocompleteCtrl.matches"\
                  ng-class="{ selected: $index === $mdAutocompleteCtrl.index }"\
                  ng-attr-id="{{\'md-option-\' + $mdAutocompleteCtrl.id + \'-\' + $index}}"\
                  ng-click="$mdAutocompleteCtrl.select($index)"\
                  role="option"\
                  aria-setsize="{{$mdAutocompleteCtrl.matches.length}}"\
                  aria-posinset="{{$index+1}}"\
                  aria-selected="{{$index === $mdAutocompleteCtrl.index ? true : false}}" \
                  md-extra-name="$mdAutocompleteCtrl.itemName">\
                  ' + itemTemplate + '\
                  </li>' + noItemsTemplate + '\
            </ul>\
          '  + getContainerClosingTags(attr.mdMode) + '\
        </md-autocomplete-wrap>';

      function getItemTemplate() {
        var templateTag = element.find('md-item-template').detach(),
            html = templateTag.length ? templateTag.html() : element.html();
        if (!templateTag.length) element.empty();
        return '<md-autocomplete-parent-scope md-autocomplete-replace>' + html +
               '</md-autocomplete-parent-scope>';
      }

      function getNoItemsTemplate() {
        var templateTag = element.find('md-not-found').detach(),
            template = templateTag.length ? templateTag.html() : '';
        return template
            ? '<li ng-if="$mdAutocompleteCtrl.notFoundVisible()" class="md-autocomplete-suggestion"\
                         md-autocomplete-parent-scope>' + template + '</li>'
            : '';
      }

      function getContainer(menuContainerClass, repeatMode) {
        // prepend a space if needed
        menuContainerClass = menuContainerClass ? ' ' + menuContainerClass : '';

        if (isVirtualRepeatDisabled(repeatMode)) {
          return '\
            <div \
                ng-hide="$mdAutocompleteCtrl.hidden"\
                class="md-standard-list-container md-autocomplete-suggestions-container md-whiteframe-z1' + menuContainerClass + '"\
                ng-class="{ \'md-not-found\': $mdAutocompleteCtrl.notFoundVisible() }"\
                ng-mouseenter="$mdAutocompleteCtrl.listEnter()"\
                ng-mouseleave="$mdAutocompleteCtrl.listLeave()"\
                role="presentation">\
              <div class="md-standard-list-scroller" role="presentation">';
        }

        return '\
          <md-virtual-repeat-container\
              md-auto-shrink\
              md-auto-shrink-min="1"\
              ng-hide="$mdAutocompleteCtrl.hidden"\
              class="md-virtual-repeat-container md-autocomplete-suggestions-container md-whiteframe-z1' + menuContainerClass + '"\
              ng-class="{ \'md-not-found\': $mdAutocompleteCtrl.notFoundVisible() }"\
              ng-mouseenter="$mdAutocompleteCtrl.listEnter()"\
              ng-mouseleave="$mdAutocompleteCtrl.listLeave()"\
              role="presentation">';
      }

      function getContainerClosingTags(repeatMode) {
        return isVirtualRepeatDisabled(repeatMode) ?
            '   </div>\
              </div>\
            </div>' : '</md-virtual-repeat-container>';
      }

      function getRepeatType(repeatMode) {
        return isVirtualRepeatDisabled(repeatMode)  ?
          'ng-repeat' : 'md-virtual-repeat';
      }

      function isVirtualRepeatDisabled(repeatMode) {
        // ensure we have a valid repeat mode
        var correctedRepeatMode = getRepeatMode(repeatMode);
        return correctedRepeatMode !== REPEAT_VIRTUAL;
      }

      function getInputElement () {
        if (attr.mdFloatingLabel) {
          return '\
            <md-input-container ng-if="floatingLabel">\
              <label>{{floatingLabel}}</label>\
              <input type="text"\
                ' + (tabindex != null ? 'tabindex="' + tabindex + '"' : '') + '\
                id="{{inputId || \'fl-input-\' + $mdAutocompleteCtrl.id}}"\
                name="{{inputName || \'fl-input-\' + $mdAutocompleteCtrl.id }}"\
                ng-class="::inputClass"\
                autocomplete="off"\
                ng-required="$mdAutocompleteCtrl.isRequired"\
                ng-readonly="$mdAutocompleteCtrl.isReadonly"\
                ng-minlength="inputMinlength"\
                ng-maxlength="inputMaxlength"\
                ng-disabled="$mdAutocompleteCtrl.isDisabled"\
                ng-model="$mdAutocompleteCtrl.scope.searchText"\
                ng-model-options="{ allowInvalid: true }"\
                ng-mousedown="$mdAutocompleteCtrl.focusInput()"\
                ng-keydown="$mdAutocompleteCtrl.keydown($event)"\
                ng-blur="$mdAutocompleteCtrl.blur($event)"\
                ng-focus="$mdAutocompleteCtrl.focus($event)"\
                aria-label="{{floatingLabel}}"\
                ng-attr-aria-autocomplete="{{$mdAutocompleteCtrl.isDisabled ? undefined : \'list\'}}"\
                ng-attr-role="{{$mdAutocompleteCtrl.isDisabled ? undefined : \'combobox\'}}"\
                aria-haspopup="{{!$mdAutocompleteCtrl.isDisabled}}"\
                aria-expanded="{{!$mdAutocompleteCtrl.hidden}}"\
                ng-attr-aria-owns="{{$mdAutocompleteCtrl.hidden || $mdAutocompleteCtrl.isDisabled ? undefined : \'ul-\' + $mdAutocompleteCtrl.id}}"\
                ng-attr-aria-activedescendant="{{!$mdAutocompleteCtrl.hidden && $mdAutocompleteCtrl.activeOption ? $mdAutocompleteCtrl.activeOption : undefined}}">\
              <div md-autocomplete-parent-scope md-autocomplete-replace>' + leftover + '</div>\
            </md-input-container>';
        } else {
          return '\
            <input type="text"\
              ' + (tabindex != null ? 'tabindex="' + tabindex + '"' : '') + '\
              id="{{inputId || \'input-\' + $mdAutocompleteCtrl.id}}"\
              name="{{inputName || \'input-\' + $mdAutocompleteCtrl.id }}"\
              ng-class="::inputClass"\
              ng-if="!floatingLabel"\
              autocomplete="off"\
              ng-required="$mdAutocompleteCtrl.isRequired"\
              ng-disabled="$mdAutocompleteCtrl.isDisabled"\
              ng-readonly="$mdAutocompleteCtrl.isReadonly"\
              ng-minlength="inputMinlength"\
              ng-maxlength="inputMaxlength"\
              ng-model="$mdAutocompleteCtrl.scope.searchText"\
              ng-mousedown="$mdAutocompleteCtrl.focusInput()"\
              ng-keydown="$mdAutocompleteCtrl.keydown($event)"\
              ng-blur="$mdAutocompleteCtrl.blur($event)"\
              ng-focus="$mdAutocompleteCtrl.focus($event)"\
              placeholder="{{placeholder}}"\
              aria-label="{{placeholder}}"\
              ng-attr-aria-autocomplete="{{$mdAutocompleteCtrl.isDisabled ? undefined : \'list\'}}"\
              ng-attr-role="{{$mdAutocompleteCtrl.isDisabled ? undefined : \'combobox\'}}"\
              aria-haspopup="{{!$mdAutocompleteCtrl.isDisabled}}"\
              aria-expanded="{{!$mdAutocompleteCtrl.hidden}}"\
              ng-attr-aria-owns="{{$mdAutocompleteCtrl.hidden || $mdAutocompleteCtrl.isDisabled ? undefined : \'ul-\' + $mdAutocompleteCtrl.id}}"\
              ng-attr-aria-activedescendant="{{!$mdAutocompleteCtrl.hidden && $mdAutocompleteCtrl.activeOption ? $mdAutocompleteCtrl.activeOption : undefined}}">';
        }
      }

      function getClearButton() {
        return '' +
          '<button ' +
              'type="button" ' +
              'aria-label="Clear Input" ' +
              'tabindex="0" ' +
              'ng-if="clearButton && $mdAutocompleteCtrl.scope.searchText" ' +
              'ng-click="$mdAutocompleteCtrl.clear($event)">' +
            '<md-icon md-svg-src="' + $$mdSvgRegistry.mdClose + '"></md-icon>' +
          '</button>';
        }
    }
  };
}

})();
(function(){
"use strict";


MdAutocompleteItemScopeDirective.$inject = ["$compile", "$mdUtil"];angular
  .module('material.components.autocomplete')
  .directive('mdAutocompleteParentScope', MdAutocompleteItemScopeDirective);

function MdAutocompleteItemScopeDirective($compile, $mdUtil) {
  return {
    restrict: 'AE',
    compile: compile,
    terminal: true,
    transclude: 'element'
  };

  function compile(tElement, tAttr, transclude) {
    return function postLink(scope, element, attr) {
      var ctrl = scope.$mdAutocompleteCtrl;
      var newScope = ctrl.parent.$new();
      var itemName = ctrl.itemName;

      // Watch for changes to our scope's variables and copy them to the new scope
      watchVariable('$index', '$index');
      watchVariable('item', itemName);

      // Ensure that $digest calls on our scope trigger $digest on newScope.
      connectScopes();

      // Link the element against newScope.
      transclude(newScope, function(clone) {
        element.after(clone);
      });

      /**
       * Creates a watcher for variables that are copied from the parent scope
       * @param variable
       * @param alias
       */
      function watchVariable(variable, alias) {
        newScope[alias] = scope[variable];

        scope.$watch(variable, function(value) {
          $mdUtil.nextTick(function() {
            newScope[alias] = value;
          });
        });
      }

      /**
       * Creates watchers on scope and newScope that ensure that for any
       * $digest of scope, newScope is also $digested.
       */
      function connectScopes() {
        var scopeDigesting = false;
        var newScopeDigesting = false;

        scope.$watch(function() {
          if (newScopeDigesting || scopeDigesting) {
            return;
          }

          scopeDigesting = true;
          scope.$$postDigest(function() {
            if (!newScopeDigesting) {
              newScope.$digest();
            }

            scopeDigesting = newScopeDigesting = false;
          });
        });

        newScope.$watch(function() {
          newScopeDigesting = true;
        });
      }
    };
  }
}
})();
(function(){
"use strict";


MdHighlightCtrl.$inject = ["$scope", "$element", "$attrs", "$mdUtil"];angular
    .module('material.components.autocomplete')
    .controller('MdHighlightCtrl', MdHighlightCtrl);

function MdHighlightCtrl ($scope, $element, $attrs, $mdUtil) {
  this.$scope = $scope;
  this.$element = $element;
  this.$attrs = $attrs;
  this.$mdUtil = $mdUtil;

  // Cache the Regex to avoid rebuilding each time.
  this.regex = null;
}

MdHighlightCtrl.prototype.init = function(unsafeTermFn, unsafeContentFn) {

  this.flags = this.$attrs.mdHighlightFlags || '';

  this.unregisterFn = this.$scope.$watch(function($scope) {
    return {
      term: unsafeTermFn($scope),
      contentText: unsafeContentFn($scope)
    };
  }.bind(this), this.onRender.bind(this), true);

  this.$element.on('$destroy', this.unregisterFn);
};

/**
 * Triggered once a new change has been recognized and the highlighted
 * text needs to be updated.
 */
MdHighlightCtrl.prototype.onRender = function(state, prevState) {

  var contentText = state.contentText;

  /* Update the regex if it's outdated, because we don't want to rebuilt it constantly. */
  if (this.regex === null || state.term !== prevState.term) {
    this.regex = this.createRegex(state.term, this.flags);
  }

  /* If a term is available apply the regex to the content */
  if (state.term) {
    this.applyRegex(contentText);
  } else {
    this.$element.text(contentText);
  }

};

/**
 * Decomposes the specified text into different tokens (whether match or not).
 * Breaking down the string guarantees proper XSS protection due to the native browser
 * escaping of unsafe text.
 */
MdHighlightCtrl.prototype.applyRegex = function(text) {
  var tokens = this.resolveTokens(text);

  this.$element.empty();

  tokens.forEach(function (token) {

    if (token.isMatch) {
      var tokenEl = angular.element('<span class="highlight">').text(token.text);

      this.$element.append(tokenEl);
    } else {
      this.$element.append(document.createTextNode(token));
    }

  }.bind(this));

};

  /**
 * Decomposes the specified text into different tokens by running the regex against the text.
 */
MdHighlightCtrl.prototype.resolveTokens = function(string) {
  var tokens = [];
  var lastIndex = 0;

  // Use replace here, because it supports global and single regular expressions at same time.
  string.replace(this.regex, function(match, index) {
    appendToken(lastIndex, index);

    tokens.push({
      text: match,
      isMatch: true
    });

    lastIndex = index + match.length;
  });

  // Append the missing text as a token.
  appendToken(lastIndex);

  return tokens;

  function appendToken(from, to) {
    var targetText = string.slice(from, to);
    targetText && tokens.push(targetText);
  }
};

/** Creates a regex for the specified text with the given flags. */
MdHighlightCtrl.prototype.createRegex = function(term, flags) {
  var startFlag = '', endFlag = '';
  var regexTerm = this.$mdUtil.sanitize(term);

  if (flags.indexOf('^') >= 0) startFlag = '^';
  if (flags.indexOf('$') >= 0) endFlag = '$';

  return new RegExp(startFlag + regexTerm + endFlag, flags.replace(/[$^]/g, ''));
};

})();
(function(){
"use strict";


MdHighlight.$inject = ["$interpolate", "$parse"];angular
    .module('material.components.autocomplete')
    .directive('mdHighlightText', MdHighlight);

/**
 * @ngdoc directive
 * @name mdHighlightText
 * @module material.components.autocomplete
 *
 * @description
 * The `md-highlight-text` directive allows you to specify text that should be highlighted within
 *     an element.  Highlighted text will be wrapped in `<span class="highlight"></span>` which can
 *     be styled through CSS.  Please note that child elements may not be used with this directive.
 *
 * @param {string} md-highlight-text A model to be searched for
 * @param {string=} md-highlight-flags A list of flags (loosely based on JavaScript RexExp flags).
 * #### **Supported flags**:
 * - `g`: Find all matches within the provided text
 * - `i`: Ignore case when searching for matches
 * - `$`: Only match if the text ends with the search term
 * - `^`: Only match if the text begins with the search term
 *
 * @usage
 * <hljs lang="html">
 * <input placeholder="Enter a search term..." ng-model="searchTerm" type="text" />
 * <ul>
 *   <li ng-repeat="result in results" md-highlight-text="searchTerm" md-highlight-flags="i">
 *     {{result.text}}
 *   </li>
 * </ul>
 * </hljs>
 */

function MdHighlight ($interpolate, $parse) {
  return {
    terminal: true,
    controller: 'MdHighlightCtrl',
    compile: function mdHighlightCompile(tElement, tAttr) {
      var termExpr = $parse(tAttr.mdHighlightText);
      var unsafeContentExpr = $interpolate(tElement.html());

      return function mdHighlightLink(scope, element, attr, ctrl) {
        ctrl.init(termExpr, unsafeContentExpr);
      };
    }
  };
}

})();
(function(){
"use strict";

/*
 * @ngdoc module
 * @name material.components.backdrop
 * @description Backdrop
 */

/**
 * @ngdoc directive
 * @name mdBackdrop
 * @module material.components.backdrop
 *
 * @restrict E
 *
 * @description
 * `<md-backdrop>` is a backdrop element used by other components, such as dialog and bottom sheet.
 * Apply class `opaque` to make the backdrop use the theme backdrop color.
 *
 */

angular
  .module('material.components.backdrop', ['material.core'])
  .directive('mdBackdrop', ["$mdTheming", "$mdUtil", "$animate", "$rootElement", "$window", "$log", "$$rAF", "$document", function BackdropDirective($mdTheming, $mdUtil, $animate, $rootElement, $window, $log, $$rAF, $document) {
    var ERROR_CSS_POSITION = '<md-backdrop> may not work properly in a scrolled, static-positioned parent container.';

    return {
      restrict: 'E',
      link: postLink
    };

    function postLink(scope, element, attrs) {
      // backdrop may be outside the $rootElement, tell ngAnimate to animate regardless
      if ($animate.pin) $animate.pin(element, $rootElement);

      var bodyStyles;

      $$rAF(function() {
        // If body scrolling has been disabled using mdUtil.disableBodyScroll(),
        // adjust the 'backdrop' height to account for the fixed 'body' top offset.
        // Note that this can be pretty expensive and is better done inside the $$rAF.
        bodyStyles = $window.getComputedStyle($document[0].body);

        if (bodyStyles.position === 'fixed') {
          var resizeHandler = $mdUtil.debounce(function(){
            bodyStyles = $window.getComputedStyle($document[0].body);
            resize();
          }, 60, null, false);

          resize();
          angular.element($window).on('resize', resizeHandler);

          scope.$on('$destroy', function() {
            angular.element($window).off('resize', resizeHandler);
          });
        }

        // Often $animate.enter() is used to append the backDrop element
        // so let's wait until $animate is done...
        var parent = element.parent();

        if (parent.length) {
          if (parent[0].nodeName === 'BODY') {
            element.css('position', 'fixed');
          }

          var styles = $window.getComputedStyle(parent[0]);

          if (styles.position === 'static') {
            // backdrop uses position:absolute and will not work properly with parent position:static (default)
            $log.warn(ERROR_CSS_POSITION);
          }

          // Only inherit the parent if the backdrop has a parent.
          $mdTheming.inherit(element, parent);
        }
      });

      function resize() {
        var viewportHeight = parseInt(bodyStyles.height, 10) + Math.abs(parseInt(bodyStyles.top, 10));
        element.css('height', viewportHeight + 'px');
      }
    }

  }]);

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.bottomSheet
 * @description
 * BottomSheet
 */
MdBottomSheetDirective.$inject = ["$mdBottomSheet"];
MdBottomSheetProvider.$inject = ["$$interimElementProvider"];
angular
  .module('material.components.bottomSheet', [
    'material.core',
    'material.components.backdrop'
  ])
  .directive('mdBottomSheet', MdBottomSheetDirective)
  .provider('$mdBottomSheet', MdBottomSheetProvider);

/* @ngInject */
function MdBottomSheetDirective($mdBottomSheet) {
  return {
    restrict: 'E',
    link : function postLink(scope, element) {
      element.addClass('_md');     // private md component indicator for styling

      // When navigation force destroys an interimElement, then
      // listen and $destroy() that interim instance...
      scope.$on('$destroy', function() {
        $mdBottomSheet.destroy();
      });
    }
  };
}


/**
 * @ngdoc service
 * @name $mdBottomSheet
 * @module material.components.bottomSheet
 *
 * @description
 * `$mdBottomSheet` opens a bottom sheet over the app and provides a simple promise API.
 *
 * ## Restrictions
 *
 * - The bottom sheet's template must have an outer `<md-bottom-sheet>` element.
 * - Add the `md-grid` class to the bottom sheet for a grid layout.
 * - Add the `md-list` class to the bottom sheet for a list layout.
 *
 * @usage
 * <hljs lang="html">
 * <div ng-controller="MyController">
 *   <md-button ng-click="openBottomSheet()">
 *     Open a Bottom Sheet!
 *   </md-button>
 * </div>
 * </hljs>
 * <hljs lang="js">
 * var app = angular.module('app', ['ngMaterial']);
 * app.controller('MyController', function($scope, $mdBottomSheet) {
 *   $scope.openBottomSheet = function() {
 *     $mdBottomSheet.show({
 *       template: '<md-bottom-sheet>' +
 *       'Hello! <md-button ng-click="closeBottomSheet()">Close</md-button>' +
 *       '</md-bottom-sheet>'
 *     })
 *
 *     // Fires when the hide() method is used
 *     .then(function() {
 *       console.log('You clicked the button to close the bottom sheet!');
 *     })
 *
 *     // Fires when the cancel() method is used
 *     .catch(function() {
 *       console.log('You hit escape or clicked the backdrop to close.');
 *     });
 *   };
 *
 *   $scope.closeBottomSheet = function($scope, $mdBottomSheet) {
 *     $mdBottomSheet.hide();
 *   }
 *
 * });
 * </hljs>
 *
 * ### Custom Presets
 * Developers are also able to create their own preset, which can be easily used without repeating
 * their options each time.
 *
 * <hljs lang="js">
 *   $mdBottomSheetProvider.addPreset('testPreset', {
 *     options: function() {
 *       return {
 *         template:
 *           '<md-bottom-sheet>' +
 *             'This is a custom preset' +
 *           '</md-bottom-sheet>',
 *         controllerAs: 'bottomSheet',
 *         bindToController: true,
 *         clickOutsideToClose: true,
 *         escapeToClose: true
 *       };
 *     }
 *   });
 * </hljs>
 *
 * After you create your preset during the config phase, you can easily access it.
 *
 * <hljs lang="js">
 *   $mdBottomSheet.show(
 *     $mdBottomSheet.testPreset()
 *   );
 * </hljs>
 */

/**
 * @ngdoc method
 * @name $mdBottomSheet#show
 *
 * @description
 * Show a bottom sheet with the specified options.
 *
 * <em><b>Note:</b> You should <b>always</b> provide a `.catch()` method in case the user hits the
 * `esc` key or clicks the background to close. In this case, the `cancel()` method will
 * automatically be called on the bottom sheet which will `reject()` the promise. See the @usage
 * section above for an example.
 *
 * Newer versions of Angular will throw a `Possibly unhandled rejection` exception if you forget
 * this.</em>
 *
 * @param {Object} optionsOrPreset Either provide an `$mdBottomSheetPreset` defined during the
 * config phase or an options object, with the following properties:
 *
 *   - `templateUrl` - `{string=}`: The url of an html template file that will
 *   be used as the content of the bottom sheet. Restrictions: the template must
 *   have an outer `md-bottom-sheet` element.
 *   - `template` - `{string=}`: Same as templateUrl, except this is an actual
 *   template string.
 *   - `scope` - `{Object=}`: the scope to link the template / controller to. If none is specified,
 *   it will create a new child scope. This scope will be destroyed when the bottom sheet is
 *   removed unless `preserveScope` is set to true.
 *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed.
 *   Default is false
 *   - `controller` - `{string=}`: The controller to associate with this bottom sheet.
 *   - `locals` - `{string=}`: An object containing key/value pairs. The keys will be used as names
 *   of values to inject into the controller. For example, `locals: {three: 3}` would inject
 *   `three` into the controller with the value of 3.
 *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click outside the bottom sheet to
 *     close it. Default true.
 *   - `bindToController` - `{boolean=}`: When set to true, the locals will be bound to the
 *   controller instance and available in it's $onInit function.
 *   - `disableBackdrop` - `{boolean=}`: When set to true, the bottomsheet will not show a backdrop.
 *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to close the bottom sheet.
 *     Default true.
 *   - `isLockedOpen` - `{boolean=}`: Disables all default ways of closing the bottom sheet.
 *   **Note:** this will override the `clickOutsideToClose` and `escapeToClose` options, leaving
 *   only the `hide` and `cancel` methods as ways of closing the bottom sheet. Defaults to false.
 *   - `resolve` - `{Object=}`: Similar to locals, except it takes promises as values
 *   and the bottom sheet will not open until the promises resolve.
 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
 *   - `parent` - `{element=}`: The element to append the bottom sheet to. The `parent` may be a
 *   `function`, `string`, `Object`, or null. Defaults to appending to the body of the root element
 *   (or the root element) of the application.
 *   e.g. angular.element(document.getElementById('content')) or "#content"
 *   - `disableParentScroll` - `{boolean=}`: Whether to disable scrolling while the bottom sheet is
 *   open. Default true.
 *
 * @returns {promise} A promise that can be resolved with `$mdBottomSheet.hide()` or
 * rejected with `$mdBottomSheet.cancel()`.
 */

/**
 * @ngdoc method
 * @name $mdBottomSheet#hide
 *
 * @description
 * Hide the existing bottom sheet and resolve the promise returned from
 * `$mdBottomSheet.show()`. This call will close the most recently opened/current bottom sheet (if
 * any).
 *
 * <em><b>Note:</b> Use a `.then()` on your `.show()` to handle this callback.</em>
 *
 * @param {*=} response An argument for the resolved promise.
 *
 */

/**
 * @ngdoc method
 * @name $mdBottomSheet#cancel
 *
 * @description
 * Hide the existing bottom sheet and reject the promise returned from
 * `$mdBottomSheet.show()`.
 *
 * <em><b>Note:</b> Use a `.catch()` on your `.show()` to handle this callback.</em>
 *
 * @param {*=} response An argument for the rejected promise.
 *
 */

function MdBottomSheetProvider($$interimElementProvider) {
  // how fast we need to flick down to close the sheet, pixels/ms
  bottomSheetDefaults.$inject = ["$animate", "$mdConstant", "$mdUtil", "$mdTheming", "$mdBottomSheet", "$rootElement", "$mdGesture", "$log"];
  var CLOSING_VELOCITY = 0.5;
  var PADDING = 80; // same as css

  return $$interimElementProvider('$mdBottomSheet')
    .setDefaults({
      methods: ['disableParentScroll', 'escapeToClose', 'clickOutsideToClose'],
      options: bottomSheetDefaults
    });

  /* @ngInject */
  function bottomSheetDefaults($animate, $mdConstant, $mdUtil, $mdTheming, $mdBottomSheet, $rootElement,
                               $mdGesture, $log) {
    var backdrop;

    return {
      themable: true,
      onShow: onShow,
      onRemove: onRemove,
      disableBackdrop: false,
      escapeToClose: true,
      clickOutsideToClose: true,
      disableParentScroll: true,
      isLockedOpen: false
    };

    function onShow(scope, element, options) {
      element = $mdUtil.extractElementByName(element, 'md-bottom-sheet');

      // prevent tab focus or click focus on the bottom-sheet container
      element.attr('tabindex', '-1');

      // Once the md-bottom-sheet has `ng-cloak` applied on his template the opening animation will not work properly.
      // This is a very common problem, so we have to notify the developer about this.
      if (element.hasClass('ng-cloak')) {
        var message = '$mdBottomSheet: using `<md-bottom-sheet ng-cloak>` will affect the bottom-sheet opening animations.';
        $log.warn(message, element[0]);
      }

      if (options.isLockedOpen) {
        options.clickOutsideToClose = false;
        options.escapeToClose = false;
      } else {
        options.cleanupGestures = registerGestures(element, options.parent);
      }

      if (!options.disableBackdrop) {
        // Add a backdrop that will close on click
        backdrop = $mdUtil.createBackdrop(scope, "md-bottom-sheet-backdrop md-opaque");

        // Prevent mouse focus on backdrop; ONLY programmatic focus allowed.
        // This allows clicks on backdrop to propagate to the $rootElement and
        // ESC key events to be detected properly.
        backdrop[0].tabIndex = -1;

        if (options.clickOutsideToClose) {
          backdrop.on('click', function() {
            $mdUtil.nextTick($mdBottomSheet.cancel, true);
          });
        }

        $mdTheming.inherit(backdrop, options.parent);

        $animate.enter(backdrop, options.parent, null);
      }

      $mdTheming.inherit(element, options.parent);

      if (options.disableParentScroll) {
        options.restoreScroll = $mdUtil.disableScrollAround(element, options.parent);
      }

      return $animate.enter(element, options.parent, backdrop)
        .then(function() {
          var focusable = $mdUtil.findFocusTarget(element) || angular.element(
            element[0].querySelector('button') ||
            element[0].querySelector('a') ||
            element[0].querySelector($mdUtil.prefixer('ng-click', true))
          ) || backdrop;

          if (options.escapeToClose) {
            options.rootElementKeyupCallback = function(e) {
              if (e.keyCode === $mdConstant.KEY_CODE.ESCAPE) {
                $mdUtil.nextTick($mdBottomSheet.cancel, true);
              }
            };

            $rootElement.on('keyup', options.rootElementKeyupCallback);
            focusable && focusable.focus();
          }
        });

    }

    function onRemove(scope, element, options) {
      if (!options.disableBackdrop) $animate.leave(backdrop);

      return $animate.leave(element).then(function() {
        if (options.disableParentScroll) {
          options.restoreScroll();
          delete options.restoreScroll;
        }

        options.cleanupGestures && options.cleanupGestures();
      });
    }

    /**
     * Adds the drag gestures to the bottom sheet.
     * @param {JQLite} element where CSS transitions will be applied
     * @param {JQLite} parent used for registering gesture listeners
     * @return {Function} function that removes gesture listeners that were set up by
     *  registerGestures()
     */
    function registerGestures(element, parent) {
      var deregister = $mdGesture.register(parent, 'drag', { horizontal: false });
      parent.on('$md.dragstart', onDragStart)
        .on('$md.drag', onDrag)
        .on('$md.dragend', onDragEnd);

      return function cleanupGestures() {
        deregister();
        parent.off('$md.dragstart', onDragStart);
        parent.off('$md.drag', onDrag);
        parent.off('$md.dragend', onDragEnd);
      };

      function onDragStart() {
        // Disable transitions on transform so that it feels fast
        element.css($mdConstant.CSS.TRANSITION_DURATION, '0ms');
      }

      function onDrag(ev) {
        var transform = ev.pointer.distanceY;
        if (transform < 5) {
          // Slow down drag when trying to drag up, and stop after PADDING
          transform = Math.max(-PADDING, transform / 2);
        }
        element.css($mdConstant.CSS.TRANSFORM, 'translate3d(0,' + (PADDING + transform) + 'px,0)');
      }

      function onDragEnd(ev) {
        if (ev.pointer.distanceY > 0 &&
            (ev.pointer.distanceY > 20 || Math.abs(ev.pointer.velocityY) > CLOSING_VELOCITY)) {
          var distanceRemaining = element.prop('offsetHeight') - ev.pointer.distanceY;
          var transitionDuration = Math.min(distanceRemaining / ev.pointer.velocityY * 0.75, 500);
          element.css($mdConstant.CSS.TRANSITION_DURATION, transitionDuration + 'ms');
          $mdUtil.nextTick($mdBottomSheet.cancel, true);
        } else {
          element.css($mdConstant.CSS.TRANSITION_DURATION, '');
          element.css($mdConstant.CSS.TRANSFORM, '');
        }
      }
    }
  }
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.button
 * @description
 *
 * Button
 */
MdButtonDirective.$inject = ["$mdButtonInkRipple", "$mdTheming", "$mdAria", "$mdInteraction"];
MdAnchorDirective.$inject = ["$mdTheming"];
angular
    .module('material.components.button', ['material.core'])
    .directive('mdButton', MdButtonDirective)
    .directive('a', MdAnchorDirective);


/**
 * @private
 * @restrict E
 *
 * @description
 * `a` is an anchor directive used to inherit theme colors for md-primary, md-accent, etc.
 *
 * @usage
 *
 * <hljs lang="html">
 *  <md-content md-theme="myTheme">
 *    <a href="#chapter1" class="md-accent"></a>
 *  </md-content>
 * </hljs>
 */
function MdAnchorDirective($mdTheming) {
  return {
    restrict : 'E',
    link : function postLink(scope, element) {
      // Make sure to inherit theme so stand-alone anchors
      // support theme colors for md-primary, md-accent, etc.
      $mdTheming(element);
    }
  };
}


/**
 * @ngdoc directive
 * @name mdButton
 * @module material.components.button
 *
 * @restrict E
 *
 * @description
 * `<md-button>` is a button directive with optional ink ripples (default enabled).
 *
 * If you supply a `href` or `ng-href` attribute, it will become an `<a>` element. Otherwise, it
 * will become a `<button>` element. As per the
 * [Material Design specifications](https://material.google.com/style/color.html#color-color-palette)
 * the FAB button background is filled with the accent color [by default]. The primary color palette
 * may be used with the `md-primary` class.
 *
 * Developers can also change the color palette of the button, by using the following classes
 * - `md-primary`
 * - `md-accent`
 * - `md-warn`
 *
 * See for example
 *
 * <hljs lang="html">
 *   <md-button class="md-primary">Primary Button</md-button>
 * </hljs>
 *
 * Button can be also raised, which means that they will use the current color palette to fill the button.
 *
 * <hljs lang="html">
 *   <md-button class="md-accent md-raised">Raised and Accent Button</md-button>
 * </hljs>
 *
 * It is also possible to disable the focus effect on the button, by using the following markup.
 *
 * <hljs lang="html">
 *   <md-button class="md-no-focus">No Focus Style</md-button>
 * </hljs>
 *
 * @param {string=} aria-label Adds alternative text to button for accessibility, useful for icon buttons.
 * If no default text is found, a warning will be logged.
 * @param {boolean=} md-no-ink If present, disable ink ripple effects.
 * @param {string=} md-ripple-size Overrides the default ripple size logic. Options: `full`, `partial`, `auto`.
 * @param {expression=} ng-disabled Disable the button when the expression is truthy.
 * @param {expression=} ng-blur Expression evaluated when focus is removed from the button.
 *
 * @usage
 *
 * Regular buttons:
 *
 * <hljs lang="html">
 *  <md-button> Flat Button </md-button>
 *  <md-button href="http://google.com"> Flat link </md-button>
 *  <md-button class="md-raised"> Raised Button </md-button>
 *  <md-button ng-disabled="true"> Disabled Button </md-button>
 *  <md-button>
 *    <md-icon md-svg-src="your/icon.svg"></md-icon>
 *    Register Now
 *  </md-button>
 * </hljs>
 *
 * FAB buttons:
 *
 * <hljs lang="html">
 *  <md-button class="md-fab" aria-label="FAB">
 *    <md-icon md-svg-src="your/icon.svg"></md-icon>
 *  </md-button>
 *  <!-- mini-FAB -->
 *  <md-button class="md-fab md-mini" aria-label="Mini FAB">
 *    <md-icon md-svg-src="your/icon.svg"></md-icon>
 *  </md-button>
 *  <!-- Button with SVG Icon -->
 *  <md-button class="md-icon-button" aria-label="Custom Icon Button">
 *    <md-icon md-svg-icon="path/to/your.svg"></md-icon>
 *  </md-button>
 * </hljs>
 */
function MdButtonDirective($mdButtonInkRipple, $mdTheming, $mdAria, $mdInteraction) {

  return {
    restrict: 'EA',
    replace: true,
    transclude: true,
    template: getTemplate,
    link: postLink
  };

  function isAnchor(attr) {
    return angular.isDefined(attr.href) || angular.isDefined(attr.ngHref) || angular.isDefined(attr.ngLink) || angular.isDefined(attr.uiSref);
  }

  function getTemplate(element, attr) {
    if (isAnchor(attr)) {
      return '<a class="md-button" ng-transclude></a>';
    } else {
      // If buttons don't have type="button", they will submit forms automatically.
      var btnType = (typeof attr.type === 'undefined') ? 'button' : attr.type;
      return '<button class="md-button" type="' + btnType + '" ng-transclude></button>';
    }
  }

  function postLink(scope, element, attr) {
    $mdTheming(element);
    $mdButtonInkRipple.attach(scope, element);

    // Use async expect to support possible bindings in the button label
    $mdAria.expectWithoutText(element, 'aria-label');

    // For anchor elements, we have to set tabindex manually when the element is disabled.
    // We don't do this for md-nav-bar anchors as the component manages its own tabindex values.
    if (isAnchor(attr) && angular.isDefined(attr.ngDisabled) &&
        !element.hasClass('_md-nav-button')) {
      scope.$watch(attr.ngDisabled, function(isDisabled) {
        element.attr('tabindex', isDisabled ? -1 : 0);
      });
    }

    // disabling click event when disabled is true
    element.on('click', function(e){
      if (attr.disabled === true) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    });

    if (!element.hasClass('md-no-focus')) {

      element.on('focus', function() {

        // Only show the focus effect when being focused through keyboard interaction or programmatically
        if (!$mdInteraction.isUserInvoked() || $mdInteraction.getLastInteractionType() === 'keyboard') {
          element.addClass('md-focused');
        }

      });

      element.on('blur', function() {
        element.removeClass('md-focused');
      });
    }

  }

}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.card
 *
 * @description
 * Card components.
 */
mdCardDirective.$inject = ["$mdTheming"];
angular.module('material.components.card', [
    'material.core'
  ])
  .directive('mdCard', mdCardDirective);


/**
 * @ngdoc directive
 * @name mdCard
 * @module material.components.card
 *
 * @restrict E
 *
 * @description
 * The `<md-card>` directive is a container element used within `<md-content>` containers.
 *
 * An image included as a direct descendant will fill the card's width. If you want to avoid this,
 * you can add the `md-image-no-fill` class to the parent element. The `<md-card-content>`
 * container will wrap text content and provide padding. An `<md-card-footer>` element can be
 * optionally included to put content flush against the bottom edge of the card.
 *
 * Action buttons can be included in an `<md-card-actions>` element, similar to `<md-dialog-actions>`.
 * You can then position buttons using layout attributes.
 *
 * Card is built with:
 * * `<md-card-header>` - Header for the card, holds avatar, text and squared image
 *  - `<md-card-avatar>` - Card avatar
 *    - `md-user-avatar` - Class for user image
 *    - `<md-icon>`
 *  - `<md-card-header-text>` - Contains elements for the card description
 *    - `md-title` - Class for the card title
 *    - `md-subhead` - Class for the card sub header
 * * `<img>` - Image for the card
 * * `<md-card-title>` - Card content title
 *  - `<md-card-title-text>`
 *    - `md-headline` - Class for the card content title
 *    - `md-subhead` - Class for the card content sub header
 *  - `<md-card-title-media>` - Squared image within the title
 *    - `md-media-sm` - Class for small image
 *    - `md-media-md` - Class for medium image
 *    - `md-media-lg` - Class for large image
 *    - `md-media-xl` - Class for extra large image
 * * `<md-card-content>` - Card content
 * * `<md-card-actions>` - Card actions
 *  - `<md-card-icon-actions>` - Icon actions
 *
 * Cards have constant width and variable heights; where the maximum height is limited to what can
 * fit within a single view on a platform, but it can temporarily expand as needed.
 *
 * @usage
 * ### Card with optional footer
 * <hljs lang="html">
 * <md-card>
 *  <img src="card-image.png" class="md-card-image" alt="image caption">
 *  <md-card-content>
 *    <h2>Card headline</h2>
 *    <p>Card content</p>
 *  </md-card-content>
 *  <md-card-footer>
 *    Card footer
 *  </md-card-footer>
 * </md-card>
 * </hljs>
 *
 * ### Card with actions
 * <hljs lang="html">
 * <md-card>
 *  <img src="card-image.png" class="md-card-image" alt="image caption">
 *  <md-card-content>
 *    <h2>Card headline</h2>
 *    <p>Card content</p>
 *  </md-card-content>
 *  <md-card-actions layout="row" layout-align="end center">
 *    <md-button>Action 1</md-button>
 *    <md-button>Action 2</md-button>
 *  </md-card-actions>
 * </md-card>
 * </hljs>
 *
 * ### Card with header, image, title actions and content
 * <hljs lang="html">
 * <md-card>
 *   <md-card-header>
 *     <md-card-avatar>
 *       <img class="md-user-avatar" src="avatar.png"/>
 *     </md-card-avatar>
 *     <md-card-header-text>
 *       <span class="md-title">Title</span>
 *       <span class="md-subhead">Sub header</span>
 *     </md-card-header-text>
 *   </md-card-header>
 *   <img ng-src="card-image.png" class="md-card-image" alt="image caption">
 *   <md-card-title>
 *     <md-card-title-text>
 *       <span class="md-headline">Card headline</span>
 *       <span class="md-subhead">Card subheader</span>
 *     </md-card-title-text>
 *   </md-card-title>
 *   <md-card-actions layout="row" layout-align="start center">
 *     <md-button>Action 1</md-button>
 *     <md-button>Action 2</md-button>
 *     <md-card-icon-actions>
 *       <md-button class="md-icon-button" aria-label="icon">
 *         <md-icon md-svg-icon="icon"></md-icon>
 *       </md-button>
 *     </md-card-icon-actions>
 *   </md-card-actions>
 *   <md-card-content>
 *     <p>
 *      Card content
 *     </p>
 *   </md-card-content>
 * </md-card>
 * </hljs>
 */
function mdCardDirective($mdTheming) {
  return {
    restrict: 'E',
    link: function ($scope, $element, attr) {
      $element.addClass('_md');     // private md component indicator for styling
      $mdTheming($element);
    }
  };
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.checkbox
 * @description Checkbox module!
 */
MdCheckboxDirective.$inject = ["inputDirective", "$mdAria", "$mdConstant", "$mdTheming", "$mdUtil", "$mdInteraction"];
angular
  .module('material.components.checkbox', ['material.core'])
  .directive('mdCheckbox', MdCheckboxDirective);

/**
 * @ngdoc directive
 * @name mdCheckbox
 * @module material.components.checkbox
 * @restrict E
 *
 * @description
 * The checkbox directive is used like the normal
 * [angular checkbox](https://docs.angularjs.org/api/ng/input/input%5Bcheckbox%5D).
 *
 * As per the [Material Design spec](https://material.io/archive/guidelines/style/color.html#color-color-palette)
 * the checkbox is in the accent color by default. The primary color palette may be used with
 * the `md-primary` class.
 *
 * @param {expression} ng-model Assignable angular expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {expression=} ng-true-value The value to which the expression should be set when selected.
 * @param {expression=} ng-false-value The value to which the expression should be set when not
 *    selected.
 * @param {expression=} ng-change Expression to be executed when the model value changes.
 * @param {boolean=} md-no-ink If present, disable ink ripple effects.
 * @param {string=} aria-label Adds label to checkbox for accessibility.
 *    Defaults to checkbox's text. If no default text is found, a warning will be logged.
 * @param {expression=} md-indeterminate This determines when the checkbox should be rendered as
 *    'indeterminate'. If a truthy expression or no value is passed in the checkbox renders in the
 *    md-indeterminate state. If falsy expression is passed in it just looks like a normal unchecked
 *    checkbox. The indeterminate, checked, and unchecked states are mutually exclusive. A box
 *    cannot be in any two states at the same time. Adding the 'md-indeterminate' attribute
 *    overrides any checked/unchecked rendering logic. When using the 'md-indeterminate' attribute
 *    use 'ng-checked' to define rendering logic instead of using 'ng-model'.
 * @param {expression=} ng-checked If this expression evaluates as truthy, the 'md-checked' css
 *    class is added to the checkbox and it will appear checked.
 *
 * @usage
 * <hljs lang="html">
 * <md-checkbox ng-model="isChecked" aria-label="Finished?">
 *   Finished ?
 * </md-checkbox>
 *
 * <md-checkbox md-no-ink ng-model="hasInk" aria-label="No Ink Effects">
 *   No Ink Effects
 * </md-checkbox>
 *
 * <md-checkbox ng-disabled="true" ng-model="isDisabled" aria-label="Disabled">
 *   Disabled
 * </md-checkbox>
 *
 * </hljs>
 *
 */
function MdCheckboxDirective(inputDirective, $mdAria, $mdConstant, $mdTheming, $mdUtil, $mdInteraction) {
  inputDirective = inputDirective[0];

  return {
    restrict: 'E',
    transclude: true,
    require: ['^?mdInputContainer', '?ngModel', '?^form'],
    priority: $mdConstant.BEFORE_NG_ARIA,
    template:
      '<div class="md-container" md-ink-ripple md-ink-ripple-checkbox>' +
        '<div class="md-icon"></div>' +
      '</div>' +
      '<div ng-transclude class="md-label"></div>',
    compile: compile
  };

  // **********************************************************
  // Private Methods
  // **********************************************************

  function compile (tElement, tAttrs) {
    tAttrs.$set('tabindex', tAttrs.tabindex || '0');
    tAttrs.$set('type', 'checkbox');
    tAttrs.$set('role', tAttrs.type);
    tElement.addClass('md-auto-horizontal-margin');

    return  {
      pre: function(scope, element) {
        // Attach a click handler during preLink, in order to immediately stop propagation
        // (especially for ng-click) when the checkbox is disabled.
        element.on('click', function(e) {
          if (this.hasAttribute('disabled')) {
            e.stopImmediatePropagation();
          }
        });
      },
      post: postLink
    };

    function postLink(scope, element, attr, ctrls) {
      var isIndeterminate;
      var containerCtrl = ctrls[0];
      var ngModelCtrl = ctrls[1] || $mdUtil.fakeNgModel();
      var formCtrl = ctrls[2];
      var labelHasLink = element.find('a').length > 0;

      // The original component structure is not accessible when the checkbox's label contains a link.
      // In order to keep backwards compatibility, we're only changing the structure of the component
      // when we detect a link within the label. Using a span after the md-checkbox and attaching it
      // via aria-labelledby allows screen readers to find and work with the link within the label.
      if (labelHasLink) {
        var labelId = 'label-' + $mdUtil.nextUid();
        attr.$set('aria-labelledby', labelId);

        var label = element.children()[1];
        // Use jQLite here since ChildNode.remove() is not supported in IE11.
        angular.element(label).remove();
        label.removeAttribute('ng-transclude');
        label.className = 'md-checkbox-link-label';
        label.setAttribute('id', labelId);
        element.after(label);
        // Make sure that clicking on the label still causes the checkbox to be toggled, when appropriate.
        var externalLabel = element.next();
        externalLabel.on('click', listener);
      }

      if (containerCtrl) {
        var isErrorGetter = containerCtrl.isErrorGetter || function() {
          return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (formCtrl && formCtrl.$submitted));
        };

        containerCtrl.input = element;

        scope.$watch(isErrorGetter, containerCtrl.setInvalid);
      }

      $mdTheming(element);

      // Redirect focus events to the root element, because IE11 is always focusing the container element instead
      // of the md-checkbox element. This causes issues when using ngModelOptions: `updateOnBlur`
      element.children().on('focus', function() {
        element.focus();
      });

      if ($mdUtil.parseAttributeBoolean(attr.mdIndeterminate)) {
        setIndeterminateState();
        scope.$watch(attr.mdIndeterminate, setIndeterminateState);
      }

      if (attr.ngChecked) {
        scope.$watch(scope.$eval.bind(scope, attr.ngChecked), function(value) {
          ngModelCtrl.$setViewValue(value);
          ngModelCtrl.$render();
        });
      }

      $$watchExpr('ngDisabled', 'tabindex', {
        true: '-1',
        false: attr.tabindex
      });

      // Don't emit a warning when the label has a link within it. In that case we'll use
      // aria-labelledby to point to another span that should be read as the label.
      if (!labelHasLink) {
        $mdAria.expectWithText(element, 'aria-label');
      }

      // Reuse the original input[type=checkbox] directive from AngularJS core.
      // This is a bit hacky as we need our own event listener and own render
      // function.
      inputDirective.link.pre(scope, {
        on: angular.noop,
        0: {}
      }, attr, [ngModelCtrl]);

      element.on('click', listener)
        .on('keypress', keypressHandler)
        .on('focus', function() {
          if ($mdInteraction.getLastInteractionType() === 'keyboard') {
            element.addClass('md-focused');
          }
        })
        .on('blur', function() {
          element.removeClass('md-focused');
        });

      ngModelCtrl.$render = render;

      function $$watchExpr(expr, htmlAttr, valueOpts) {
        if (attr[expr]) {
          scope.$watch(attr[expr], function(val) {
            if (valueOpts[val]) {
              element.attr(htmlAttr, valueOpts[val]);
            }
          });
        }
      }

      /**
       * @param {KeyboardEvent} ev 'keypress' event to handle
       */
      function keypressHandler(ev) {
        var keyCode = ev.which || ev.keyCode;
        var submit, form;

        ev.preventDefault();
        switch (keyCode) {
          case $mdConstant.KEY_CODE.SPACE:
            element.addClass('md-focused');
            listener(ev);
            break;
          case $mdConstant.KEY_CODE.ENTER:
            // Match the behavior of the native <input type="checkbox">.
            // When the enter key is pressed while focusing a native checkbox inside a form,
            // the browser will trigger a `click` on the first non-disabled submit button/input
            // in the form. Note that this is different from text inputs, which
            // will directly submit the form without needing a submit button/input to be present.
            form = $mdUtil.getClosest(ev.target, 'form');
            if (form) {
              submit = form.querySelector('button[type="submit"]:enabled, input[type="submit"]:enabled');
              if (submit) {
                submit.click();
              }
            }
            break;
        }
      }

      function listener(ev) {
        // skipToggle boolean is used by the switch directive to prevent the click event
        // when releasing the drag. There will be always a click if releasing the drag over the checkbox.
        // If the click came from a link in the checkbox, don't toggle the value.
        // We want the link to be opened without changing the value in this case.
        if (element[0].hasAttribute('disabled') || scope.skipToggle || ev.target.tagName === 'A') {
          return;
        }

        scope.$apply(function() {
          // Toggle the checkbox value...
          var viewValue = attr.ngChecked && attr.ngClick ? attr.checked : !ngModelCtrl.$viewValue;

          ngModelCtrl.$setViewValue(viewValue, ev && ev.type);
          ngModelCtrl.$render();
        });
      }

      function render() {
        // Cast the $viewValue to a boolean since it could be undefined
        var checked = !!ngModelCtrl.$viewValue && !isIndeterminate;
        element.toggleClass('md-checked', checked);
        if (!isIndeterminate) {
          if (checked) {
            element.attr('aria-checked', 'true');
          } else {
            element.attr('aria-checked', 'false');
          }
        }
      }

      /**
       * @param {string=} newValue
       */
      function setIndeterminateState(newValue) {
        isIndeterminate = newValue !== false;
        if (isIndeterminate) {
          element.attr('aria-checked', 'mixed');
        }
        element.toggleClass('md-indeterminate', isIndeterminate);
        ngModelCtrl.$render();
      }
    }
  }
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.chips
 */
/*
 * @see js folder for chips implementation
 */
angular.module('material.components.chips', [
  'material.core',
  'material.components.autocomplete'
]);

})();
(function(){
"use strict";


MdChipCtrl.$inject = ["$scope", "$element", "$mdConstant", "$timeout", "$mdUtil"];angular
  .module('material.components.chips')
  .controller('MdChipCtrl', MdChipCtrl);

/**
 * Controller for the MdChip component. Responsible for handling keyboard
 * events and editing the chip if needed.
 *
 * @param $scope
 * @param $element
 * @param $mdConstant
 * @param $timeout
 * @param $mdUtil
 * @constructor
 */
function MdChipCtrl ($scope, $element, $mdConstant, $timeout, $mdUtil) {
  /**
   * @type {$scope}
   */
  this.$scope = $scope;

  /**
   * @type {$element}
   */
  this.$element = $element;

  /**
   * @type {$mdConstant}
   */
  this.$mdConstant = $mdConstant;

  /**
   * @type {$timeout}
   */
  this.$timeout = $timeout;

  /**
   * @type {$mdUtil}
   */
  this.$mdUtil = $mdUtil;

  /**
   * @type {boolean}
   */
  this.isEditing = false;

  /**
   * @type {MdChipsCtrl}
   */
  this.parentController = undefined;

  /**
   * @type {boolean}
   */
  this.enableChipEdit = false;
}


/**
 * @param {MdChipsCtrl} controller
 */
MdChipCtrl.prototype.init = function(controller) {
  this.parentController = controller;
  this.enableChipEdit = this.parentController.enableChipEdit;

  if (this.enableChipEdit) {
    this.$element.on('keydown', this.chipKeyDown.bind(this));
    this.$element.on('dblclick', this.chipMouseDoubleClick.bind(this));
    this.getChipContent().addClass('_md-chip-content-edit-is-enabled');
  }
};


/**
 * @return {Object} first element with the md-chip-content class
 */
MdChipCtrl.prototype.getChipContent = function() {
  var chipContents = this.$element[0].getElementsByClassName('md-chip-content');
  return angular.element(chipContents[0]);
};


/**
 * When editing the chip, if the user modifies the existing contents, we'll get a span back and
 * need to ignore text elements as they only contain blank space.
 * `children()` ignores text elements.
 *
 * When editing the chip, if the user deletes the contents and then enters some new content
 * we'll only get a text element back.
 * @return {Object} jQuery object representing the content element of the chip
 */
MdChipCtrl.prototype.getContentElement = function() {
  var contentElement = angular.element(this.getChipContent().children()[0]);
  if (!contentElement || contentElement.length === 0) {
    contentElement = angular.element(this.getChipContent().contents()[0]);
  }
  return contentElement;
};


/**
 * @return {number} index of this chip
 */
MdChipCtrl.prototype.getChipIndex = function() {
  return parseInt(this.$element.attr('index'));
};


/**
 * Update the chip's contents, focus the chip if it's selected, and exit edit mode.
 * If the contents were updated to be empty, remove the chip and re-focus the input element.
 */
MdChipCtrl.prototype.goOutOfEditMode = function() {
  if (!this.isEditing) {
    return;
  }

  this.isEditing = false;
  this.$element.removeClass('_md-chip-editing');
  this.getChipContent()[0].contentEditable = 'false';
  var chipIndex = this.getChipIndex();

  var content = this.getContentElement().text();
  if (content) {
    this.parentController.updateChipContents(chipIndex, content);

    this.$mdUtil.nextTick(function() {
      if (this.parentController.selectedChip === chipIndex) {
        this.parentController.focusChip(chipIndex);
      }
    }.bind(this));
  } else {
    this.parentController.removeChipAndFocusInput(chipIndex);
  }
};


/**
 * Given an HTML element. Selects contents of it.
 * @param {Element} node
 */
MdChipCtrl.prototype.selectNodeContents = function(node) {
  var range, selection;
  if (document.body.createTextRange) {
    range = document.body.createTextRange();
    range.moveToElementText(node);
    range.select();
  } else if (window.getSelection) {
    selection = window.getSelection();
    range = document.createRange();
    range.selectNodeContents(node);
    selection.removeAllRanges();
    selection.addRange(range);
  }
};


/**
 * Presents an input element to edit the contents of the chip.
 */
MdChipCtrl.prototype.goInEditMode = function() {
  this.isEditing = true;
  this.$element.addClass('_md-chip-editing');
  this.getChipContent()[0].contentEditable = 'true';
  this.getChipContent().on('blur', function() {
    this.goOutOfEditMode();
  }.bind(this));

  this.selectNodeContents(this.getChipContent()[0]);
};


/**
 * Handles the keydown event on the chip element. If enable-chip-edit attribute is
 * set to true, space or enter keys can trigger going into edit mode. Enter can also
 * trigger submitting if the chip is already being edited.
 * @param {KeyboardEvent} event
 */
MdChipCtrl.prototype.chipKeyDown = function(event) {
  if (!this.isEditing &&
    (event.keyCode === this.$mdConstant.KEY_CODE.ENTER ||
      event.keyCode === this.$mdConstant.KEY_CODE.SPACE)) {
    event.preventDefault();
    this.goInEditMode();
  } else if (this.isEditing && event.keyCode === this.$mdConstant.KEY_CODE.ENTER) {
    event.preventDefault();
    this.goOutOfEditMode();
  }
};


/**
 * Enter edit mode if we're not already editing and the enable-chip-edit attribute is enabled.
 */
MdChipCtrl.prototype.chipMouseDoubleClick = function() {
  if (this.enableChipEdit && !this.isEditing) {
    this.goInEditMode();
  }
};

})();
(function(){
"use strict";


MdChip.$inject = ["$mdTheming", "$mdUtil", "$compile", "$timeout"];angular
  .module('material.components.chips')
  .directive('mdChip', MdChip);

/**
 * @ngdoc directive
 * @name mdChip
 * @module material.components.chips
 *
 * @description
 * `<md-chip>` is a component used within `<md-chips>`. It is responsible for rendering an
 * individual chip.
 *
 *
 * @usage
 * <hljs lang="html">
 *   <md-chips>
 *     <md-chip>{{$chip}}</md-chip>
 *   </md-chips>
 * </hljs>
 *
 */

/**
 * MDChip Directive Definition
 *
 * @param $mdTheming
 * @param $mdUtil
 * @param $compile
 * @param $timeout
 * @ngInject
 */
function MdChip($mdTheming, $mdUtil, $compile, $timeout) {
  return {
    restrict: 'E',
    require: ['^?mdChips', 'mdChip'],
    link: postLink,
    controller: 'MdChipCtrl'
  };

  function postLink(scope, element, attr, ctrls) {
    var chipsController = ctrls.shift();
    var chipController = ctrls.shift();
    var chipContentElement = angular.element(element[0].querySelector('.md-chip-content'));

    $mdTheming(element);

    if (chipsController) {
      chipController.init(chipsController);

      // When a chip is blurred, make sure to unset (or reset) the selected chip so that tabbing
      // through elements works properly
      chipContentElement.on('blur', function() {
        chipsController.resetSelectedChip();
        chipsController.$scope.$applyAsync();
      });
    }

    // Use $timeout to ensure we run AFTER the element has been added to the DOM so we can focus it.
    $timeout(function() {
      if (!chipsController) {
        return;
      }

      if (chipsController.shouldFocusLastChip) {
        chipsController.focusLastChipThenInput();
      }
    });
  }
}

})();
(function(){
"use strict";


MdChipRemove.$inject = ["$timeout"];angular
    .module('material.components.chips')
    .directive('mdChipRemove', MdChipRemove);

/**
 * @ngdoc directive
 * @name mdChipRemove
 * @restrict A
 * @module material.components.chips
 *
 * @description
 * Indicates that the associated element should be used as the delete button template for all chips.
 * The associated element must be a child of `md-chips`.
 *
 * The provided button template will be appended to each chip and will remove the associated chip
 * on click.
 *
 * The button is not styled or themed based on the theme set on the `md-chips` component. A theme
 * class and custom icon can be specified in your template.
 *
 * You can also specify the `type` of the button in your template.
 *
 * @usage
 * ### With Standard Chips
 * <hljs lang="html">
 *   <md-chips ...>
 *     <button md-chip-remove type="button" aria-label="Remove {{$chip}}">
 *       <md-icon md-svg-icon="md-cancel"></md-icon>
 *     </button>
 *   </md-chips>
 * </hljs>
 *
 * ### With Object Chips
 * <hljs lang="html">
 *   <md-chips ...>
 *     <button md-chip-remove type="button" aria-label="Remove {{$chip.name}}">
 *       <md-icon md-svg-icon="md-cancel"></md-icon>
 *     </button>
 *   </md-chips>
 * </hljs>
 */


/**
 * MdChipRemove Directive Definition.
 *
 * @param $timeout
 * @returns {{restrict: string, require: string[], link: Function, scope: boolean}}
 * @constructor
 */
function MdChipRemove ($timeout) {
  return {
    restrict: 'A',
    require: '^mdChips',
    scope: false,
    link: postLink
  };

  function postLink(scope, element, attr, ctrl) {
    element.on('click', function() {
      scope.$apply(function() {
        ctrl.removeChip(scope.$$replacedScope.$index);
      });
    });

    // Child elements aren't available until after a $timeout tick as they are hidden by an
    // `ng-if`. see http://goo.gl/zIWfuw
    $timeout(function() {
      element.attr({ 'tabindex': '-1', 'aria-hidden': 'true' });
      element.find('button').attr('tabindex', '-1');
    });
  }
}

})();
(function(){
"use strict";


MdChipTransclude.$inject = ["$compile"];angular
    .module('material.components.chips')
    .directive('mdChipTransclude', MdChipTransclude);

function MdChipTransclude ($compile) {
  return {
    restrict: 'EA',
    terminal: true,
    link: link,
    scope: false
  };
  function link (scope, element, attr) {
    var ctrl = scope.$parent.$mdChipsCtrl,
        newScope = ctrl.parent.$new(false, ctrl.parent);
    newScope.$$replacedScope = scope;
    newScope.$chip = scope.$chip;
    newScope.$index = scope.$index;
    newScope.$mdChipsCtrl = ctrl;

    var newHtml = ctrl.$scope.$eval(attr.mdChipTransclude);

    element.html(newHtml);
    $compile(element.contents())(newScope);
  }
}

})();
(function(){
"use strict";

/**
 * The default chip append delay.
 *
 * @type {number}
 */
MdChipsCtrl.$inject = ["$scope", "$attrs", "$mdConstant", "$log", "$element", "$timeout", "$mdUtil", "$mdLiveAnnouncer", "$exceptionHandler"];
var DEFAULT_CHIP_APPEND_DELAY = 300;

angular
    .module('material.components.chips')
    .controller('MdChipsCtrl', MdChipsCtrl);

/**
 * Controller for the MdChips component. Responsible for adding to and
 * removing from the list of chips, marking chips as selected, and binding to
 * the models of various input components.
 *
 * @param $scope
 * @param $attrs
 * @param $mdConstant
 * @param $log
 * @param $element
 * @param $timeout
 * @param $mdUtil
 * @param $mdLiveAnnouncer
 * @param $exceptionHandler
 * @constructor
 */
function MdChipsCtrl ($scope, $attrs, $mdConstant, $log, $element, $timeout, $mdUtil,
                      $mdLiveAnnouncer, $exceptionHandler) {
  /** @type {Function} **/
  this.$timeout = $timeout;

  /** @type {Object} */
  this.$mdConstant = $mdConstant;

  /** @type {angular.$scope} */
  this.$scope = $scope;

  /** @type {angular.$scope} */
  this.parent = $scope.$parent;

  /** @type {$mdUtil} */
  this.$mdUtil = $mdUtil;

  /** @type {$log} */
  this.$log = $log;

  /** @type {$mdLiveAnnouncer} */
  this.$mdLiveAnnouncer = $mdLiveAnnouncer;

  /** @type {$exceptionHandler} */
  this.$exceptionHandler = $exceptionHandler;

  /** @type {$element} */
  this.$element = $element;

  /** @type {$attrs} */
  this.$attrs = $attrs;

  /** @type {angular.NgModelController} */
  this.ngModelCtrl = null;

  /** @type {angular.NgModelController} */
  this.userInputNgModelCtrl = null;

  /** @type {MdAutocompleteCtrl} */
  this.autocompleteCtrl = null;

  /** @type {Element} */
  this.userInputElement = null;

  /** @type {Array.<Object>} */
  this.items = [];

  /** @type {number} */
  this.selectedChip = -1;

  /** @type {string} */
  this.enableChipEdit = $mdUtil.parseAttributeBoolean($attrs.mdEnableChipEdit);

  /** @type {string} */
  this.addOnBlur = $mdUtil.parseAttributeBoolean($attrs.mdAddOnBlur);

  /**
   * The class names to apply to the autocomplete or input.
   * @type {string}
   */
  this.inputClass = '';

  /**
   * The text to be used as the aria-label for the input.
   * @type {string}
   */
  this.inputAriaLabel = 'Chips input.';

  /**
   * Label text to describe the chips container. Used to give context and instructions to screen
   * reader users when the chips container is selected.
   * @type {string}
   */
  this.containerHint = 'Chips container. Use arrow keys to select chips.';

  /**
   * Label text to describe the chips container when it is empty. Used to give context and
   * instructions to screen reader users when the chips container is selected and it contains
   * no chips.
   * @type {string}
   */
  this.containerEmptyHint =
    'Chips container. Enter the text area, then type text, and press enter to add a chip.';

  /**
   * Hidden hint text for how to delete a chip. Used to give context to screen readers.
   * @type {string}
   */
  this.deleteHint = 'Press delete to remove this chip.';

  /**
   * Hidden label for the delete button. Used to give context to screen readers.
   * @type {string}
   */
  this.deleteButtonLabel = 'Remove';

  /**
   * Model used by the input element.
   * @type {string}
   */
  this.chipBuffer = '';

  /**
   * Whether to use the transformChip expression to transform the chip buffer
   * before appending it to the list.
   * @type {boolean}
   */
  this.useTransformChip = false;

  /**
   * Whether to use the onAdd expression to notify of chip additions.
   * @type {boolean}
   */
  this.useOnAdd = false;

  /**
   * Whether to use the onRemove expression to notify of chip removals.
   * @type {boolean}
   */
  this.useOnRemove = false;

  /**
   * The ID of the chips wrapper which is used to build unique IDs for the chips and the aria-owns
   * attribute.
   *
   * Defaults to '_md-chips-wrapper-' plus a unique number.
   *
   * @type {string}
   */
  this.wrapperId = '';

  /**
   * Array of unique numbers which will be auto-generated any time the items change, and is used to
   * create unique IDs for the aria-owns attribute.
   *
   * @type {Array<number>}
   */
  this.contentIds = [];

  /**
   * The index of the chip that should have it's `tabindex` property set to `0` so it is selectable
   * via the keyboard.
   *
   * @type {number|null}
   */
  this.ariaTabIndex = null;

  /**
   * After appending a chip, the chip will be focused for this number of milliseconds before the
   * input is refocused.
   *
   * **Note:** This is **required** for compatibility with certain screen readers in order for
   * them to properly allow keyboard access.
   *
   * @type {number}
   */
  this.chipAppendDelay = DEFAULT_CHIP_APPEND_DELAY;

  /**
   * Collection of functions to call to un-register watchers
   *
   * @type {Array}
   */
  this.deRegister = [];

  /**
   * The screen reader will announce the chip content followed by this message when a chip is added.
   * @type {string}
   */
  this.addedMessage = 'added';

  /**
   * The screen reader will announce the chip content followed by this message when a chip is
   * removed.
   * @type {string}
   */
  this.removedMessage = 'removed';

  this.init();
}

/**
 * Initializes variables and sets up watchers
 */
MdChipsCtrl.prototype.init = function() {
  var ctrl = this;

  // Set the wrapper ID
  this.wrapperId = '_md-chips-wrapper-' + this.$mdUtil.nextUid();

  // If we're using static chips, then we need to initialize a few things.
  if (!this.$element.attr('ng-model')) {
    this.setupStaticChips();
  }

  // Setup a watcher which manages the role and aria-owns attributes.
  // This is never called for static chips since items is not defined.
  this.deRegister.push(
    this.$scope.$watchCollection('$mdChipsCtrl.items', function() {
      // Make sure our input and wrapper have the correct ARIA attributes
      ctrl.setupInputAria();
      ctrl.setupWrapperAria();
    })
  );

  this.deRegister.push(
    this.$attrs.$observe('mdChipAppendDelay', function(newValue) {
      ctrl.chipAppendDelay = parseInt(newValue) || DEFAULT_CHIP_APPEND_DELAY;
    })
  );
};

/**
 * Destructor for cleanup
 */
MdChipsCtrl.prototype.$onDestroy = function $onDestroy() {
  var $destroyFn;
  while (($destroyFn = this.deRegister.pop())) {
    $destroyFn.call(this);
  }
};

/**
 * If we have an input, ensure it has the appropriate ARIA attributes.
 */
MdChipsCtrl.prototype.setupInputAria = function() {
  var input = this.$element.find('input');

  // If we have no input, just return
  if (!input) {
    return;
  }

  input.attr('role', 'textbox');
  input.attr('aria-multiline', true);
  if (this.inputAriaDescribedBy) {
    input.attr('aria-describedby', this.inputAriaDescribedBy);
  }
  if (this.inputAriaLabelledBy) {
    input.attr('aria-labelledby', this.inputAriaLabelledBy);
    input.removeAttr('aria-label');
  } else {
    input.attr('aria-label', this.inputAriaLabel);
  }
};

/**
 * Ensure our wrapper has the appropriate ARIA attributes.
 */
MdChipsCtrl.prototype.setupWrapperAria = function() {
  var ctrl = this,
      wrapper = this.$element.find('md-chips-wrap');

  if (this.items && this.items.length) {
    // Dynamically add the listbox role on every change because it must be removed when there are
    // no items.
    wrapper.attr('role', 'listbox');

    // Generate some random (but unique) IDs for each chip
    this.contentIds = this.items.map(function() {
      return ctrl.wrapperId + '-chip-' + ctrl.$mdUtil.nextUid();
    });

    // Use the contentIDs above to generate the aria-owns attribute
    wrapper.attr('aria-owns', this.contentIds.join(' '));
    wrapper.attr('aria-label', this.containerHint);
  } else {
    // If we have no items, then the role and aria-owns attributes MUST be removed
    wrapper.removeAttr('role');
    wrapper.removeAttr('aria-owns');
    wrapper.attr('aria-label', this.containerEmptyHint);
  }
};

/**
 * Apply specific roles and aria attributes for static chips
 */
MdChipsCtrl.prototype.setupStaticChips = function() {
  var ctrl = this, i, staticChips;
  var wrapper = this.$element.find('md-chips-wrap');

  this.$timeout(function() {
    wrapper.attr('role', 'list');
    staticChips = wrapper[0].children;
    for (i = 0; i < staticChips.length; i++) {
      staticChips[i].setAttribute('role', 'listitem');
      staticChips[i].setAttribute('aria-setsize', staticChips.length);
    }
    if (ctrl.inputAriaDescribedBy) {
      wrapper.attr('aria-describedby', ctrl.inputAriaDescribedBy);
    }
    if (ctrl.inputAriaLabelledBy) {
      wrapper.attr('aria-labelledby', ctrl.inputAriaLabelledBy);
      wrapper.removeAttr('aria-label');
    } else {
      wrapper.attr('aria-label', ctrl.inputAriaLabel);
    }
  }, 10);
};

/**
 * Handles the keydown event on the input element: by default <enter> appends
 * the buffer to the chip list, while backspace removes the last chip in the
 * list if the current buffer is empty.
 * @param {jQuery.Event|KeyboardEvent} event
 */
MdChipsCtrl.prototype.inputKeydown = function(event) {
  var chipBuffer = this.getChipBuffer();

  // If we have an autocomplete, and it handled the event, we have nothing to do
  if (this.autocompleteCtrl && event.isDefaultPrevented && event.isDefaultPrevented()) {
    return;
  }

  if (event.keyCode === this.$mdConstant.KEY_CODE.BACKSPACE) {
    // Only select and focus the previous chip, if the current caret position of the
    // input element is at the beginning.
    if (this.getCursorPosition(event.target) !== 0) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (this.items.length) {
      this.selectAndFocusChipSafe(this.items.length - 1);
    }

    return;
  }

  // By default <enter> appends the buffer to the chip list.
  if (!this.separatorKeys || this.separatorKeys.length < 1) {
    this.separatorKeys = [this.$mdConstant.KEY_CODE.ENTER];
  }

  // Support additional separator key codes in an array of `md-separator-keys`.
  if (this.separatorKeys.indexOf(event.keyCode) !== -1) {
    if ((this.autocompleteCtrl && this.requireMatch) || !chipBuffer) return;
    event.preventDefault();

    // Only append the chip and reset the chip buffer if the max chips limit isn't reached.
    if (this.hasMaxChipsReached()) return;

    this.appendChip(chipBuffer.trim());
    this.resetChipBuffer();

    return false;
  }
};

/**
 * Returns the cursor position of the specified input element.
 * @param {HTMLInputElement} element relevant input element
 * @returns {Number} Cursor Position of the input.
 */
MdChipsCtrl.prototype.getCursorPosition = function(element) {
  /*
   * Figure out whether the current input for the chips buffer is valid for using
   * the selectionStart / end property to retrieve the cursor position.
   * Some browsers do not allow the use of those attributes, on different input types.
   */
  try {
    if (element.selectionStart === element.selectionEnd) {
      return element.selectionStart;
    }
  } catch (e) {
    if (!element.value) {
      return 0;
    }
  }
};


/**
 * Updates the content of the chip at given index
 * @param {number} chipIndex
 * @param {string} chipContents
 */
MdChipsCtrl.prototype.updateChipContents = function(chipIndex, chipContents) {
  if (chipIndex >= 0 && chipIndex < this.items.length) {
    this.items[chipIndex] = chipContents;
    this.updateNgModel(true);
  }
};


/**
 * @return {boolean} true if a chip is currently being edited. False otherwise.
 */
MdChipsCtrl.prototype.isEditingChip = function() {
  return !!this.$element[0].querySelector('._md-chip-editing');
};

/**
 * @param {string|Object} chip contents of a single chip
 * @returns {boolean} true if the chip is an Object, false otherwise.
 * @private
 */
MdChipsCtrl.prototype._isChipObject = function(chip) {
  return angular.isObject(chip);
};

/**
 * @returns {boolean} true if chips can be removed, false otherwise.
 */
MdChipsCtrl.prototype.isRemovable = function() {
  // Return false if we have static chips
  if (!this.ngModelCtrl) {
    return false;
  }

  return this.readonly ? this.removable :
         angular.isDefined(this.removable) ? this.removable : true;
};

/**
 * Handles the keydown event on the chip elements: backspace removes the selected chip, arrow
 * keys switch which chip is active.
 * @param {KeyboardEvent} event
 */
MdChipsCtrl.prototype.chipKeydown = function (event) {
  if (this.getChipBuffer()) return;
  if (this.isEditingChip()) return;

  switch (event.keyCode) {
    case this.$mdConstant.KEY_CODE.BACKSPACE:
    case this.$mdConstant.KEY_CODE.DELETE:
      if (this.selectedChip < 0) return;
      event.preventDefault();
      // Cancel the delete action only after the event cancel. Otherwise the page will go back.
      if (!this.isRemovable()) return;
      this.removeAndSelectAdjacentChip(this.selectedChip, event);
      break;
    case this.$mdConstant.KEY_CODE.LEFT_ARROW:
      event.preventDefault();
      // By default, allow selection of -1 which will focus the input; if we're readonly, don't go
      // below 0.
      if (this.selectedChip < 0 || (this.readonly && this.selectedChip === 0)) {
        this.selectedChip = this.items.length;
      }
      if (this.items.length) this.selectAndFocusChipSafe(this.selectedChip - 1);
      break;
    case this.$mdConstant.KEY_CODE.RIGHT_ARROW:
      event.preventDefault();
      this.selectAndFocusChipSafe(this.selectedChip + 1);
      break;
    case this.$mdConstant.KEY_CODE.ESCAPE:
    case this.$mdConstant.KEY_CODE.TAB:
      if (this.selectedChip < 0) return;
      event.preventDefault();
      this.onFocus();
      break;
  }
};

/**
 * Get the input's placeholder - uses `placeholder` when list is empty and `secondary-placeholder`
 * when the list is non-empty. If `secondary-placeholder` is not provided, `placeholder` is used
 * always.
 * @returns {string}
 */
MdChipsCtrl.prototype.getPlaceholder = function() {
  // Allow `secondary-placeholder` to be blank.
  var useSecondary = (this.items && this.items.length &&
      (this.secondaryPlaceholder === '' || this.secondaryPlaceholder));
  return useSecondary ? this.secondaryPlaceholder : this.placeholder;
};

/**
 * Removes chip at {@code index} and selects the adjacent chip.
 * @param {number} index adjacent chip to select
 * @param {Event=} event
 */
MdChipsCtrl.prototype.removeAndSelectAdjacentChip = function(index, event) {
  var self = this;
  var selIndex = self.getAdjacentChipIndex(index);
  var wrap = this.$element[0].querySelector('md-chips-wrap');
  var chip = this.$element[0].querySelector('md-chip[index="' + index + '"]');

  self.removeChip(index, event);

  // The double-timeout is currently necessary to ensure that the DOM has finalized and the select()
  // will find the proper chip since the selection is index-based.
  //
  // TODO: Investigate calling from within chip $scope.$on('$destroy') to reduce/remove timeouts
  self.$timeout(function() {
    self.$timeout(function() {
      self.selectAndFocusChipSafe(selIndex);
    });
  });
};

/**
 * Sets the selected chip index to -1.
 */
MdChipsCtrl.prototype.resetSelectedChip = function() {
  this.selectedChip = -1;
  this.ariaTabIndex = null;
};

/**
 * Gets the index of an adjacent chip to select after deletion. Adjacency is
 * determined as the next chip in the list, unless the target chip is the
 * last in the list, then it is the chip immediately preceding the target. If
 * there is only one item in the list, -1 is returned (select none).
 * The number returned is the index to select AFTER the target has been removed.
 * If the current chip is not selected, then -1 is returned to select none.
 * @param {number} index
 * @returns {number}
 */
MdChipsCtrl.prototype.getAdjacentChipIndex = function(index) {
  var len = this.items.length - 1;
  return (len === 0) ? -1 :
      (index === len) ? index - 1 : index;
};

/**
 * Append the contents of the buffer to the chip list. This method will first
 * call out to the md-transform-chip method, if provided.
 * @param {string} newChip chip buffer contents that will be used to create the new chip
 */
MdChipsCtrl.prototype.appendChip = function(newChip) {
  this.shouldFocusLastChip = !this.addOnBlur;
  if (this.useTransformChip && this.transformChip) {
    var transformedChip = this.transformChip({'$chip': newChip});

    // Check to make sure the chip is defined before assigning it, otherwise, we'll just assume
    // they want the string version.
    if (angular.isDefined(transformedChip)) {
      newChip = transformedChip;
    }
  }

  // If items contains an identical object to newChip, do not append
  if (angular.isObject(newChip)) {
    var identical = this.items.some(function(item) {
      return angular.equals(newChip, item);
    });
    if (identical) return;
  }

  // Check for a null (but not undefined), or existing chip and cancel appending
  if (newChip == null || this.items.indexOf(newChip) + 1) return;

  // Append the new chip onto our list
  var length = this.items.push(newChip);
  var index = length - 1;

  this.updateNgModel();

  // Tell screen reader users that the chip was successfully added.
  // TODO add a way for developers to specify which field of the object should be announced here.
  var chipContent = angular.isObject(newChip) ? '' : newChip;
  this.$mdLiveAnnouncer.announce(chipContent + ' ' + this.addedMessage, 'assertive');

  // If the md-on-add attribute is specified, send a chip addition event
  if (this.useOnAdd && this.onAdd) {
    this.onAdd({ '$chip': newChip, '$index': index });
  }
};

/**
 * Sets whether to use the md-transform-chip expression. This expression is
 * bound to scope and controller in {@code MdChipsDirective} as
 * {@code transformChip}. Due to the nature of directive scope bindings, the
 * controller cannot know on its own/from the scope whether an expression was
 * actually provided.
 */
MdChipsCtrl.prototype.useTransformChipExpression = function() {
  this.useTransformChip = true;
};

/**
 * Sets whether to use the md-on-add expression. This expression is
 * bound to scope and controller in {@code MdChipsDirective} as
 * {@code onAdd}. Due to the nature of directive scope bindings, the
 * controller cannot know on its own/from the scope whether an expression was
 * actually provided.
 */
MdChipsCtrl.prototype.useOnAddExpression = function() {
  this.useOnAdd = true;
};

/**
 * Sets whether to use the md-on-remove expression. This expression is
 * bound to scope and controller in {@code MdChipsDirective} as
 * {@code onRemove}. Due to the nature of directive scope bindings, the
 * controller cannot know on its own/from the scope whether an expression was
 * actually provided.
 */
MdChipsCtrl.prototype.useOnRemoveExpression = function() {
  this.useOnRemove = true;
};

/**
 * Sets whether to use the md-on-select expression. This expression is
 * bound to scope and controller in {@code MdChipsDirective} as
 * {@code onSelect}. Due to the nature of directive scope bindings, the
 * controller cannot know on its own/from the scope whether an expression was
 * actually provided.
 */
MdChipsCtrl.prototype.useOnSelectExpression = function() {
  this.useOnSelect = true;
};

/**
 * Gets the input buffer. The input buffer can be the model bound to the
 * default input item {@code this.chipBuffer}, the {@code selectedItem}
 * model of an {@code md-autocomplete}, or, through some magic, the model
 * bound to any input or text area element found within a
 * {@code md-input-container} element.
 * @return {string} the input buffer
 */
MdChipsCtrl.prototype.getChipBuffer = function() {
  var chipBuffer =  !this.userInputElement ? this.chipBuffer :
                     this.userInputNgModelCtrl ? this.userInputNgModelCtrl.$viewValue :
                     this.userInputElement[0].value;

  // Ensure that the chip buffer is always a string. For example, the input element buffer
  // might be falsy.
  return angular.isString(chipBuffer) ? chipBuffer : '';
};

/**
 * Resets the input buffer for either the internal input or user provided input element.
 */
MdChipsCtrl.prototype.resetChipBuffer = function() {
  if (this.userInputElement) {
    if (this.userInputNgModelCtrl) {
      this.userInputNgModelCtrl.$setViewValue('');
      this.userInputNgModelCtrl.$render();
    } else {
      this.userInputElement[0].value = '';
    }
  } else {
    this.chipBuffer = '';
  }
};

/**
 * @returns {boolean} true if the max chips limit has been reached, false otherwise.
 */
MdChipsCtrl.prototype.hasMaxChipsReached = function() {
  if (angular.isString(this.maxChips)) {
    this.maxChips = parseInt(this.maxChips, 10) || 0;
  }

  return this.maxChips > 0 && this.items.length >= this.maxChips;
};

/**
 * Updates the validity properties for the ngModel.
 *
 * TODO add the md-max-chips validator to this.ngModelCtrl.validators so that the validation will
 * be performed automatically.
 */
MdChipsCtrl.prototype.validateModel = function() {
  this.ngModelCtrl.$setValidity('md-max-chips', !this.hasMaxChipsReached());
  this.ngModelCtrl.$validate(); // rerun any registered validators
};

/**
 * Function to handle updating the model, validation, and change notification when a chip
 * is added, removed, or changed.
 * @param {boolean=} skipValidation true to skip calling validateModel()
 */
MdChipsCtrl.prototype.updateNgModel = function(skipValidation) {
  if (!skipValidation) {
    this.validateModel();
  }
  // This will trigger ng-change to fire, even in cases where $setViewValue() would not.
  angular.forEach(this.ngModelCtrl.$viewChangeListeners, function(listener) {
    try {
      listener();
    } catch (e) {
      this.$exceptionHandler(e);
    }
  });
};

/**
 * Removes the chip at the given index.
 * @param {number} index of chip to remove
 * @param {Event=} event optionally passed to the onRemove callback
 */
MdChipsCtrl.prototype.removeChip = function(index, event) {
  var removed = this.items.splice(index, 1);

  this.updateNgModel();
  this.ngModelCtrl.$setDirty();

  // Tell screen reader users that the chip was successfully removed.
  // TODO add a way for developers to specify which field of the object should be announced here.
  var chipContent = angular.isObject(removed[0]) ? '' : removed[0];
  this.$mdLiveAnnouncer.announce(chipContent + ' ' + this.removedMessage, 'assertive');

  if (removed && removed.length && this.useOnRemove && this.onRemove) {
    this.onRemove({ '$chip': removed[0], '$index': index, '$event': event });
  }
};

/**
 * @param {number} index location of chip to remove
 * @param {Event=} $event
 */
MdChipsCtrl.prototype.removeChipAndFocusInput = function (index, $event) {
  this.removeChip(index, $event);

  if (this.autocompleteCtrl) {
    // Always hide the autocomplete dropdown before focusing the autocomplete input.
    // Wait for the input to move horizontally, because the chip was removed.
    // This can lead to an incorrect dropdown position.
    this.autocompleteCtrl.hidden = true;
    this.$mdUtil.nextTick(this.onFocus.bind(this));
  } else {
    this.onFocus();
  }

};
/**
 * Selects the chip at `index`,
 * @param {number} index location of chip to select and focus
 */
MdChipsCtrl.prototype.selectAndFocusChipSafe = function(index) {
  // If we have no chips, or are asked to select a chip before the first, just focus the input
  if (!this.items.length || index === -1) {
    return this.focusInput();
  }

  // If we are asked to select a chip greater than the number of chips...
  if (index >= this.items.length) {
    if (this.readonly) {
      // If we are readonly, jump back to the start (because we have no input)
      index = 0;
    } else {
      // If we are not readonly, we should attempt to focus the input
      return this.onFocus();
    }
  }

  index = Math.max(index, 0);
  index = Math.min(index, this.items.length - 1);

  this.selectChip(index);
  this.focusChip(index);
};

/**
 * Focus last chip, then focus the input. This is needed for screen reader support.
 */
MdChipsCtrl.prototype.focusLastChipThenInput = function() {
  var ctrl = this;

  ctrl.shouldFocusLastChip = false;

  ctrl.focusChip(this.items.length - 1);

  ctrl.$timeout(function() {
    ctrl.focusInput();
  }, ctrl.chipAppendDelay);
};

/**
 * Focus the input element.
 */
MdChipsCtrl.prototype.focusInput = function() {
  this.selectChip(-1);
  this.onFocus();
};

/**
 * Marks the chip at the given index as selected.
 * @param {number} index location of chip to select
 */
MdChipsCtrl.prototype.selectChip = function(index) {
  if (index >= -1 && index <= this.items.length) {
    this.selectedChip = index;

    // Fire the onSelect if provided
    if (this.useOnSelect && this.onSelect) {
      this.onSelect({'$chip': this.items[index] });
    }
  } else {
    this.$log.warn('Selected Chip index out of bounds; ignoring.');
  }
};

/**
 * Call {@code focus()} on the chip at {@code index}
 * @param {number} index location of chip to focus
 */
MdChipsCtrl.prototype.focusChip = function(index) {
  var chipContent = this.$element[0].querySelector(
    'md-chip[index="' + index + '"] .md-chip-content'
  );

  this.ariaTabIndex = index;

  chipContent.focus();
};

/**
 * Configures the required interactions with the ngModel Controller.
 * Specifically, set {@code this.items} to the {@code NgModelController#$viewValue}.
 * @param {NgModelController} ngModelCtrl
 */
MdChipsCtrl.prototype.configureNgModel = function(ngModelCtrl) {
  this.ngModelCtrl = ngModelCtrl;

  var self = this;

  // in chips the meaning of $isEmpty changes
  ngModelCtrl.$isEmpty = function(value) {
    return !value || value.length === 0;
  };

  ngModelCtrl.$render = function() {
    // model is updated. do something.
    self.items = self.ngModelCtrl.$viewValue;
  };
};

MdChipsCtrl.prototype.onFocus = function () {
  var input = this.$element[0].querySelector('input');
  input && input.focus();
  this.resetSelectedChip();
};

MdChipsCtrl.prototype.onInputFocus = function () {
  this.inputHasFocus = true;

  // Make sure we have the appropriate ARIA attributes
  this.setupInputAria();

  // Make sure we don't have any chips selected
  this.resetSelectedChip();
};

MdChipsCtrl.prototype.onInputBlur = function () {
  this.inputHasFocus = false;

  if (this.shouldAddOnBlur()) {
    this.appendChip(this.getChipBuffer().trim());
    this.resetChipBuffer();
  }
};

/**
 * Configure event bindings on input element.
 * @param {angular.element} inputElement
 */
MdChipsCtrl.prototype.configureInput = function configureInput(inputElement) {
  // Find the NgModelCtrl for the input element
  var ngModelCtrl = inputElement.controller('ngModel');
  var ctrl = this;

  if (ngModelCtrl) {

    // sync touched-state from inner input to chips-element
    this.deRegister.push(
      this.$scope.$watch(
        function() {
          return ngModelCtrl.$touched;
        },
        function(isTouched) {
          isTouched && ctrl.ngModelCtrl.$setTouched();
        }
      )
    );

    // sync dirty-state from inner input to chips-element
    this.deRegister.push(
      this.$scope.$watch(
        function() {
          return ngModelCtrl.$dirty;
        },
        function(isDirty) {
          isDirty && ctrl.ngModelCtrl.$setDirty();
        }
      )
    );
  }
};

/**
 * Configure event bindings on a user-provided input element.
 * @param {angular.element} inputElement
 */
MdChipsCtrl.prototype.configureUserInput = function(inputElement) {
  this.userInputElement = inputElement;

  // Find the NgModelCtrl for the input element
  var ngModelCtrl = inputElement.controller('ngModel');
  // `.controller` will look in the parent as well.
  if (ngModelCtrl !== this.ngModelCtrl) {
    this.userInputNgModelCtrl = ngModelCtrl;
  }

  var scope = this.$scope;
  var ctrl = this;

  // Run all of the events using evalAsync because a focus may fire a blur in the same digest loop
  var scopeApplyFn = function(event, fn) {
    scope.$evalAsync(angular.bind(ctrl, fn, event));
  };

  // Bind to keydown and focus events of input
  inputElement
      .attr({ tabindex: 0 })
      .on('keydown', function(event) { scopeApplyFn(event, ctrl.inputKeydown); })
      .on('focus', function(event) { scopeApplyFn(event, ctrl.onInputFocus); })
      .on('blur', function(event) { scopeApplyFn(event, ctrl.onInputBlur); });
};

/**
 * @param {MdAutocompleteCtrl} ctrl controller from the autocomplete component
 */
MdChipsCtrl.prototype.configureAutocomplete = function(ctrl) {
  if (ctrl) {
    this.autocompleteCtrl = ctrl;
    // Update the default container empty hint when we're inside of an autocomplete.
    if (!this.$element.attr('container-empty-hint')) {
      this.containerEmptyHint = 'Chips container with autocompletion. Enter the text area, ' +
        'type text to search, and then use the up and down arrow keys to select an option. ' +
        'Press enter to add the selected option as a chip.';
      this.setupWrapperAria();
    }

    ctrl.registerSelectedItemWatcher(angular.bind(this, function (item) {
      if (item) {
        // Only append the chip and reset the chip buffer if the max chips limit isn't reached.
        if (this.hasMaxChipsReached()) return;

        this.appendChip(item);
        this.resetChipBuffer();
      }
    }));

    this.$element.find('input')
        .on('focus',angular.bind(this, this.onInputFocus))
        .on('blur', angular.bind(this, this.onInputBlur));
  }
};

/**
 * @returns {boolean} Whether the current chip buffer should be added on input blur or not.
 */
MdChipsCtrl.prototype.shouldAddOnBlur = function() {

  // Update the custom ngModel validators from the chips component.
  this.validateModel();

  var chipBuffer = this.getChipBuffer().trim();
  // If the model value is empty and required is set on the element, then the model will be invalid.
  // In that case, we still want to allow adding the chip. The main (but not only) case we want
  // to disallow is adding a chip on blur when md-max-chips validation fails.
  var isModelValid = this.ngModelCtrl.$isEmpty(this.ngModelCtrl.$modelValue) ||
    this.ngModelCtrl.$valid;
  var isAutocompleteShowing = this.autocompleteCtrl && !this.autocompleteCtrl.hidden;

  if (this.userInputNgModelCtrl) {
    isModelValid = isModelValid && this.userInputNgModelCtrl.$valid;
  }

  return this.addOnBlur && !this.requireMatch && chipBuffer && isModelValid &&
    !isAutocompleteShowing;
};

/**
 * @returns {boolean} true if the input or a chip is focused. False otherwise.
 */
MdChipsCtrl.prototype.hasFocus = function () {
  return this.inputHasFocus || this.selectedChip >= 0;
};

/**
 * @param {number} index location of content id
 * @returns {number} unique id for the aria-owns attribute
 */
MdChipsCtrl.prototype.contentIdFor = function(index) {
  return this.contentIds[index];
};

})();
(function(){
"use strict";

  
  MdChips.$inject = ["$mdTheming", "$mdUtil", "$compile", "$log", "$timeout", "$$mdSvgRegistry"];angular
      .module('material.components.chips')
      .directive('mdChips', MdChips);

  /**
   * @ngdoc directive
   * @name mdChips
   * @module material.components.chips
   *
   * @description
   * `<md-chips>` is an input component for building lists of strings or objects. The list items are
   * displayed as 'chips'. This component can make use of an `<input>` element or an
   * `<md-autocomplete>` element.
   *
   * ### Custom templates
   * A custom template may be provided to render the content of each chip. This is achieved by
   * specifying an `<md-chip-template>` element containing the custom content as a child of
   * `<md-chips>`.
   *
   * Note: Any attributes on
   * `<md-chip-template>` will be dropped as only the innerHTML is used for the chip template. The
   * variables `$chip` and `$index` are available in the scope of `<md-chip-template>`, representing
   * the chip object and its index in the list of chips, respectively.
   * To override the chip delete control, include an element (ideally a button) with the attribute
   * `md-chip-remove`. A click listener to remove the chip will be added automatically. The element
   * is also placed as a sibling to the chip content (on which there are also click listeners) to
   * avoid a nested ng-click situation.
   *
   * <!-- Note: We no longer want to include this in the site docs; but it should remain here for
   * future developers and those looking at the documentation.
   *
   * <h3> Pending Features </h3>
   * <ul style="padding-left:20px;">
   *
   *   <ul>Style
   *     <li>Colors for hover, press states (ripple?).</li>
   *   </ul>
   *
   *   <ul>Validation
   *     <li>allow a validation callback</li>
   *     <li>highlighting style for invalid chips</li>
   *   </ul>
   *
   *   <ul>Item mutation
   *     <li>Support `
   *       <md-chip-edit>` template, show/hide the edit element on tap/click? double tap/double
   *       click?
   *     </li>
   *   </ul>
   *
   *   <ul>Truncation and Disambiguation (?)
   *     <li>Truncate chip text where possible, but do not truncate entries such that two are
   *     indistinguishable.</li>
   *   </ul>
   *
   *   <ul>Drag and Drop
   *     <li>Drag and drop chips between related `<md-chips>` elements.
   *     </li>
   *   </ul>
   * </ul>
   *
   * //-->
   *
   * Sometimes developers want to limit the amount of possible chips.<br/>
   * You can specify the maximum amount of chips by using the following markup.
   *
   * <hljs lang="html">
   *   <md-chips
   *       ng-model="myItems"
   *       placeholder="Add an item"
   *       md-max-chips="5">
   *   </md-chips>
   * </hljs>
   *
   * In some cases, you have an autocomplete inside of the `md-chips`.<br/>
   * When the maximum amount of chips has been reached, you can also disable the autocomplete
   * selection.<br/>
   * Here is an example markup.
   *
   * <hljs lang="html">
   *   <md-chips ng-model="myItems" md-max-chips="5">
   *     <md-autocomplete ng-hide="myItems.length > 5" ...></md-autocomplete>
   *   </md-chips>
   * </hljs>
   *
   * ### Accessibility
   *
   * The `md-chips` component supports keyboard and screen reader users since Version 1.1.2. In
   * order to achieve this, we modified the chips behavior to select newly appended chips for
   * `300ms` before re-focusing the input and allowing the user to type.
   *
   * For most users, this delay is small enough that it will not be noticeable but allows certain
   * screen readers to function properly (JAWS and NVDA in particular).
   *
   * We introduced a new `md-chip-append-delay` option to allow developers to better control this
   * behavior.
   *
   * Please refer to the documentation of this option (below) for more information.
   *
   * @param {expression} ng-model Assignable AngularJS expression to be data-bound to the list of
   *    chips. The expression should evaluate to a `string` or `Object` Array. The type of this
   *    array should align with the return value of `md-transform-chip`.
   * @param {expression=} ng-change AngularJS expression to be executed on chip addition, removal,
   *    or content change.
   * @param {string=} placeholder Placeholder text that will be forwarded to the input.
   * @param {string=} secondary-placeholder Placeholder text that will be forwarded to the input,
   *    displayed when there is at least one item in the list
   * @param {boolean=} md-removable Enables or disables the deletion of chips through the
   *    removal icon or the Delete/Backspace key. Defaults to true.
   * @param {boolean=} readonly Disables list manipulation (deleting or adding list items), hiding
   *    the input and delete buttons. If no `ng-model` is provided, the chips will automatically be
   *    marked as readonly.<br/><br/>
   *    When `md-removable` is not defined, the `md-remove` behavior will be overwritten and
   *    disabled.
   * @param {boolean=} md-enable-chip-edit Set this to `"true"` to enable editing of chip contents.
   *    The user can go into edit mode by pressing the `space` or `enter` keys, or by double
   *    clicking on the chip. Chip editing is only supported for chips using the basic template.
   *    **Note:** This attribute is only evaluated once; it is not watched.
   * @param {boolean=} ng-required Whether ng-model is allowed to be empty or not.
   * @param {number=} md-max-chips The maximum number of chips allowed to add through user input.
   *    <br/><br/>The validation property `md-max-chips` can be used when the max chips
   *    amount is reached.
   * @param {boolean=} md-add-on-blur When set to `"true"`, the remaining text inside of the input
   *    will be converted into a new chip on blur.
   *    **Note:** This attribute is only evaluated once; it is not watched.
   * @param {expression} md-transform-chip An expression of form `myFunction($chip)` that when
   *    called expects one of the following return values:
   *    - an object representing the `$chip` input string
   *    - `undefined` to simply add the `$chip` input string, or
   *    - `null` to prevent the chip from being appended
   * @param {expression=} md-on-add An expression which will be called when a chip has been
   *    added with `$chip` and `$index` available as parameters.
   * @param {expression=} md-on-remove An expression which will be called when a chip has been
   *    removed with `$chip`, `$index`, and `$event` available as parameters.
   * @param {expression=} md-on-select An expression which will be called when a chip is selected.
   * @param {boolean=} md-require-match If true, and the chips template contains an autocomplete,
   *    only allow selection of pre-defined chips (i.e. you cannot add new ones).
   * @param {string=} md-input-class This class will be applied to the child input for custom
   *    styling. If you are using an `md-autocomplete`, then you need to put this attribute on the
   *    `md-autocomplete` rather than the `md-chips`.
   * @param {string=} input-aria-describedby A space-separated list of element IDs. This should
   *     contain the IDs of any elements that describe this autocomplete. Screen readers will read
   *     the content of these elements at the end of announcing that the chips input has been
   *     selected and describing its current state. The descriptive elements do not need to be
   *     visible on the page.
   * @param {string=} input-aria-labelledby A space-separated list of element IDs. The ideal use
   *    case is that this would contain the ID of a `<label>` element that is associated with these
   *    chips.<br><br>
   *    For `<label id="state">US State</label>`, you would set this to
   *    `input-aria-labelledby="state"`.
   * @param {string=} input-aria-label A string read by screen readers to identify the input.
   *    For static chips, this will be applied to the chips container.
   * @param {string=} container-hint A string read by screen readers informing users of how to
   *    navigate the chips when there are chips. Only applies when `ng-model` is defined.
   * @param {string=} container-empty-hint A string read by screen readers informing users of how to
   *    add chips when there are no chips. You will want to use this to override the default when
   *    in a non-English locale. Only applies when `ng-model` is defined.
   * @param {string=} delete-hint A string read by screen readers instructing users that pressing
   *    the delete key will remove the chip. You will want to use this to override the default when
   *    in a non-English locale.
   * @param {string=} delete-button-label Text for the `aria-label` of the button with the
   *    `md-chip-remove` class. If the chip is an Object, then this will be the only text in the
   *    label. Otherwise, this is prepended to the string representation of the chip. Defaults to
   *    "Remove", which would be "Remove Apple" for a chip that contained the string "Apple".
   *    You will want to use this to override the default when in a non-English locale.
   * @param {string=} md-removed-message Screen readers will announce this message following the
   *    chips contents. The default is `"removed"`. If a chip with the content of "Apple" was
   *    removed, the screen reader would read "Apple removed". You will want to use this to override
   *    the default when in a non-English locale.
   * @param {string=} md-added-message Screen readers will announce this message following the
   *    chips contents. The default is `"added"`. If a chip with the content of "Apple" was
   *    created, the screen reader would read "Apple added". You will want to use this to override
   *    the default when in a non-English locale.
   * @param {expression=} md-separator-keys An array of key codes used to separate chips.
   * @param {string=} md-chip-append-delay The number of milliseconds that the component will select
   *    a newly appended chip before allowing a user to type into the input. This is **necessary**
   *    for keyboard accessibility for screen readers. It defaults to 300ms and any number less than
   *    300 can cause issues with screen readers (particularly JAWS and sometimes NVDA).
   *
   *    _Available since Version 1.1.2._
   *
   *    **Note:** You can safely set this to `0` in one of the following two instances:
   *
   *    1. You are targeting an iOS or Safari-only application (where users would use VoiceOver) or
   *    only ChromeVox users.
   *
   *    2. If you have utilized the `md-separator-keys` to disable the `enter` keystroke in
   *    favor of another one (such as `,` or `;`).
   *
   * @usage
   * <hljs lang="html">
   *   <md-chips
   *       ng-model="myItems"
   *       placeholder="Add an item"
   *       readonly="isReadOnly">
   *   </md-chips>
   * </hljs>
   *
   * <h3>Validation</h3>
   * When using [ngMessages](https://docs.angularjs.org/api/ngMessages), you can show errors based
   * on our custom validators.
   * <hljs lang="html">
   *   <form name="userForm">
   *     <md-chips
   *       name="fruits"
   *       ng-model="myItems"
   *       placeholder="Add an item"
   *       md-max-chips="5">
   *     </md-chips>
   *     <div ng-messages="userForm.fruits.$error" ng-if="userForm.$dirty">
   *       <div ng-message="md-max-chips">You reached the maximum amount of chips</div>
   *    </div>
   *   </form>
   * </hljs>
   *
   */

  // TODO add a way for developers to specify which field of the object should used in the
  // aria-label.
  var MD_CHIPS_TEMPLATE = '\
      <md-chips-wrap\
          id="{{$mdChipsCtrl.wrapperId}}"\
          tabindex="{{$mdChipsCtrl.readonly ? 0 : -1}}"\
          ng-keydown="$mdChipsCtrl.chipKeydown($event)"\
          ng-class="{ \'md-focused\': $mdChipsCtrl.hasFocus(), \
                      \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly,\
                      \'md-removable\': $mdChipsCtrl.isRemovable() }"\
          class="md-chips">\
        <md-chip ng-repeat="$chip in $mdChipsCtrl.items"\
            index="{{$index}}" \
            ng-class="{\'md-focused\': $mdChipsCtrl.selectedChip == $index, \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly}">\
          <div class="md-chip-content"\
              tabindex="{{$mdChipsCtrl.ariaTabIndex === $index ? 0 : -1}}"\
              id="{{$mdChipsCtrl.contentIdFor($index)}}"\
              role="option"\
              aria-selected="{{$mdChipsCtrl.selectedChip === $index}}"\
              aria-setsize="{{$mdChipsCtrl.items.length}}"\
              aria-posinset="{{$index+1}}"\
              ng-click="!$mdChipsCtrl.readonly && $mdChipsCtrl.focusChip($index)"\
              aria-label="{{$mdChipsCtrl._isChipObject($chip) ? \'\' : $chip + \'. \'}}{{$mdChipsCtrl.isRemovable() ? \'\' + $mdChipsCtrl.deleteHint : \'\'}}" \
              ng-focus="!$mdChipsCtrl.readonly && $mdChipsCtrl.selectChip($index)"\
              md-chip-transclude="$mdChipsCtrl.chipContentsTemplate"></div>\
          <div ng-if="$mdChipsCtrl.isRemovable()"\
               class="md-chip-remove-container"\
               tabindex="-1"\
               md-chip-transclude="$mdChipsCtrl.chipRemoveTemplate"></div>\
        </md-chip>\
        <div class="md-chip-input-container" ng-if="!$mdChipsCtrl.readonly && $mdChipsCtrl.ngModelCtrl">\
          <div md-chip-transclude="$mdChipsCtrl.chipInputTemplate"></div>\
        </div>\
      </md-chips-wrap>';

  var CHIP_INPUT_TEMPLATE = '\
        <input\
            class="md-input{{ $mdChipsCtrl.inputClass ? \' \' + $mdChipsCtrl.inputClass: \'\'}}"\
            tabindex="0"\
            aria-label="{{$mdChipsCtrl.inputAriaLabel}}"\
            placeholder="{{$mdChipsCtrl.getPlaceholder()}}"\
            ng-model="$mdChipsCtrl.chipBuffer"\
            ng-focus="$mdChipsCtrl.onInputFocus()"\
            ng-blur="$mdChipsCtrl.onInputBlur()"\
            ng-keydown="$mdChipsCtrl.inputKeydown($event)">';

  var CHIP_DEFAULT_TEMPLATE = '\
      <span>{{$chip}}</span>';

  var CHIP_REMOVE_TEMPLATE = '\
      <button\
          class="md-chip-remove"\
          ng-if="$mdChipsCtrl.isRemovable()"\
          ng-click="$mdChipsCtrl.removeChipAndFocusInput($$replacedScope.$index, $event)"\
          type="button"\
          tabindex="-1"\
          aria-label="{{$mdChipsCtrl.deleteButtonLabel}}{{$mdChipsCtrl._isChipObject($chip) ? \'\' : \' \' + $chip}}">\
        <md-icon md-svg-src="{{$mdChipsCtrl.mdCloseIcon}}" aria-hidden="true"></md-icon>\
      </button>';

  /**
   * MDChips Directive Definition
   */
  function MdChips ($mdTheming, $mdUtil, $compile, $log, $timeout, $$mdSvgRegistry) {
    // Run our templates through $mdUtil.processTemplate() to allow custom start/end symbols
    var templates = getTemplates();

    return {
      template: function(element, attrs) {
        // Clone the element into an attribute. By prepending the attribute
        // name with '$', AngularJS won't write it into the DOM. The cloned
        // element propagates to the link function via the attrs argument,
        // where various contained-elements can be consumed.
        attrs['$mdUserTemplate'] = element.clone();
        return templates.chips;
      },
      require: ['mdChips'],
      restrict: 'E',
      controller: 'MdChipsCtrl',
      controllerAs: '$mdChipsCtrl',
      bindToController: true,
      compile: compile,
      scope: {
        readonly: '=?readonly',
        removable: '=?mdRemovable',
        placeholder: '@?',
        secondaryPlaceholder: '@?',
        maxChips: '@?mdMaxChips',
        transformChip: '&mdTransformChip',
        onAdd: '&?mdOnAdd',
        onRemove: '&?mdOnRemove',
        addedMessage: '@?mdAddedMessage',
        removedMessage: '@?mdRemovedMessage',
        onSelect: '&?mdOnSelect',
        inputClass: '@?mdInputClass',
        inputAriaDescribedBy: '@?inputAriaDescribedby',
        inputAriaLabelledBy: '@?inputAriaLabelledby',
        inputAriaLabel: '@?',
        containerHint: '@?',
        containerEmptyHint: '@?',
        deleteHint: '@?',
        deleteButtonLabel: '@?',
        separatorKeys: '=?mdSeparatorKeys',
        requireMatch: '=?mdRequireMatch',
        chipAppendDelayString: '@?mdChipAppendDelay',
        ngChange: '&?'
      }
    };

    /**
     * Builds the final template for `md-chips` and returns the postLink function.
     *
     * Building the template involves 3 key components:
     * static chips
     * chip template
     * input control
     *
     * If no `ng-model` is provided, only the static chip work needs to be done.
     *
     * If no user-passed `md-chip-template` exists, the default template is used. This resulting
     * template is appended to the chip content element.
     *
     * The remove button may be overridden by passing an element with an md-chip-remove attribute.
     *
     * If an `input` or `md-autocomplete` element is provided by the caller, it is set aside for
     * transclusion later. The transclusion happens in `postLink` as the parent scope is required.
     * If no user input is provided, a default one is appended to the input container node in the
     * template.
     *
     * Static Chips (i.e. `md-chip` elements passed from the caller) are gathered and set aside for
     * transclusion in the `postLink` function.
     *
     *
     * @param element
     * @param attr
     * @returns {Function}
     */
    function compile(element, attr) {
      // Grab the user template from attr and reset the attribute to null.
      var userTemplate = attr['$mdUserTemplate'];
      attr['$mdUserTemplate'] = null;

      var chipTemplate = getTemplateByQuery('md-chips>md-chip-template');

      var chipRemoveSelector = $mdUtil
        .prefixer()
        .buildList('md-chip-remove')
        .map(function(attr) {
          return 'md-chips>*[' + attr + ']';
        })
        .join(',');

      // Set the chip remove, chip contents and chip input templates. The link function will put
      // them on the scope for transclusion later.
      var chipRemoveTemplate   = getTemplateByQuery(chipRemoveSelector) || templates.remove,
          chipContentsTemplate = chipTemplate || templates.default,
          chipInputTemplate    = getTemplateByQuery('md-chips>md-autocomplete')
              || getTemplateByQuery('md-chips>input')
              || templates.input,
          staticChips = userTemplate.find('md-chip');

      // Warn of malformed template. See #2545
      if (userTemplate[0].querySelector('md-chip-template>*[md-chip-remove]')) {
        $log.warn('invalid placement of md-chip-remove within md-chip-template.');
      }

      function getTemplateByQuery (query) {
        if (!attr.ngModel) return;
        var element = userTemplate[0].querySelector(query);
        return element && element.outerHTML;
      }

      /**
       * Configures controller and transcludes.
       */
      return function postLink(scope, element, attrs, controllers) {
        $mdUtil.initOptionalProperties(scope, attr);

        $mdTheming(element);
        var mdChipsCtrl = controllers[0];
        if (chipTemplate) {
          // Chip editing functionality assumes we are using the default chip template.
          mdChipsCtrl.enableChipEdit = false;
        }

        mdChipsCtrl.chipContentsTemplate = chipContentsTemplate;
        mdChipsCtrl.chipRemoveTemplate   = chipRemoveTemplate;
        mdChipsCtrl.chipInputTemplate    = chipInputTemplate;

        mdChipsCtrl.mdCloseIcon = $$mdSvgRegistry.mdCancel;

        element
            .attr({ tabindex: -1 })
            .on('focus', function () { mdChipsCtrl.onFocus(); })
            .on('click', function () {
              if (!mdChipsCtrl.readonly && mdChipsCtrl.selectedChip === -1) {
                mdChipsCtrl.onFocus();
              }
            });

        if (attr.ngModel) {
          mdChipsCtrl.configureNgModel(element.controller('ngModel'));

          // If an `md-transform-chip` attribute was set, tell the controller to use the expression
          // before appending chips.
          if (attrs.mdTransformChip) mdChipsCtrl.useTransformChipExpression();

          // If an `md-on-add` attribute was set, tell the controller to use the expression
          // when adding chips.
          if (attrs.mdOnAdd) mdChipsCtrl.useOnAddExpression();

          // If an `md-on-remove` attribute was set, tell the controller to use the expression
          // when removing chips.
          if (attrs.mdOnRemove) mdChipsCtrl.useOnRemoveExpression();

          // If an `md-on-select` attribute was set, tell the controller to use the expression
          // when selecting chips.
          if (attrs.mdOnSelect) mdChipsCtrl.useOnSelectExpression();

          // The md-autocomplete and input elements won't be compiled until after this directive
          // is complete (due to their nested nature). Wait a tick before looking for them to
          // configure the controller.
          if (chipInputTemplate !== templates.input) {
            // The autocomplete will not appear until the readonly attribute is not true (i.e.
            // false or undefined), so we have to watch the readonly and then on the next tick
            // after the chip transclusion has run, we can configure the autocomplete and user
            // input.
            scope.$watch('$mdChipsCtrl.readonly', function(readonly) {
              if (!readonly) {

                $mdUtil.nextTick(function(){

                  if (chipInputTemplate.indexOf('<md-autocomplete') === 0) {
                    var autocompleteEl = element.find('md-autocomplete');
                    mdChipsCtrl.configureAutocomplete(autocompleteEl.controller('mdAutocomplete'));
                  }

                  mdChipsCtrl.configureUserInput(element.find('input'));
                });
              }
            });
          }

          // At the next tick, if we find an input, make sure it has the md-input class
          $mdUtil.nextTick(function() {
            var input = element.find('input');

            if (input) {
              mdChipsCtrl.configureInput(input);
              input.toggleClass('md-input', true);
            }
          });
        }

        // Compile with the parent's scope and prepend any static chips to the wrapper.
        if (staticChips.length > 0) {
          var compiledStaticChips = $compile(staticChips.clone())(scope.$parent);
          $timeout(function() { element.find('md-chips-wrap').prepend(compiledStaticChips); });
        }
      };
    }

    function getTemplates() {
      return {
        chips: $mdUtil.processTemplate(MD_CHIPS_TEMPLATE),
        input: $mdUtil.processTemplate(CHIP_INPUT_TEMPLATE),
        default: $mdUtil.processTemplate(CHIP_DEFAULT_TEMPLATE),
        remove: $mdUtil.processTemplate(CHIP_REMOVE_TEMPLATE)
      };
    }
  }

})();
(function(){
"use strict";


MdContactChipsCtrl.$inject = ["$attrs", "$element", "$timeout"];angular
    .module('material.components.chips')
    .controller('MdContactChipsCtrl', MdContactChipsCtrl);

/**
 * Controller for the MdContactChips component
 * @constructor
 */
function MdContactChipsCtrl ($attrs, $element, $timeout) {
  /** @type {$element} */
  this.$element = $element;

  /** @type {$attrs} */
  this.$attrs = $attrs;

  /** @type {Function} */
  this.$timeout = $timeout;

  /** @type {Object} */
  this.selectedItem = null;

  /** @type {string} */
  this.searchText = '';

  /**
   * Collection of functions to call to un-register watchers
   * @type {Array}
   */
  this.deRegister = [];

  this.init();
}

MdContactChipsCtrl.prototype.init = function() {
  var ctrl = this;
  var deRegister = this.deRegister;
  var element = this.$element;

  // Setup a watcher which manages chips a11y messages and autocomplete aria.
  // Timeout required to allow the child elements to be compiled.
  this.$timeout(function() {
    deRegister.push(
      element.find('md-chips').controller('mdChips').$scope.$watchCollection('$mdChipsCtrl.items', function() {
        // Make sure our input and wrapper have the correct ARIA attributes
        ctrl.setupChipsAria();
        ctrl.setupAutocompleteAria();
      })
    );
  });
};

MdContactChipsCtrl.prototype.setupChipsAria = function() {
  var chips = this.$element.find('md-chips');
  var chipsCtrl = chips.controller('mdChips');

  // Configure MdChipsCtrl
  if (this.removedMessage) {
    chipsCtrl.removedMessage = this.removedMessage;
  }
  if (this.containerHint) {
    chipsCtrl.containerHint = this.containerHint;
  }
  if (this.containerEmptyHint) {
    // Apply attribute to avoid the hint being overridden by MdChipsCtrl.configureAutocomplete()
    chips.attr('container-empty-hint', this.containerEmptyHint);
    chipsCtrl.containerEmptyHint = this.containerEmptyHint;
  }
  if (this.deleteHint) {
    chipsCtrl.deleteHint = this.deleteHint;
  }
  if (this.inputAriaLabel) {
    chipsCtrl.inputAriaLabel = this.inputAriaLabel;
  }
  if (this.inputClass) {
    chipsCtrl.inputClass = this.inputClass;
  }
};

MdContactChipsCtrl.prototype.setupAutocompleteAria = function() {
  var autocompleteInput = this.$element.find('md-chips-wrap').find('md-autocomplete').find('input');

  // Set attributes on the input of the md-autocomplete
  if (this.inputAriaDescribedBy) {
    autocompleteInput.attr('aria-describedby', this.inputAriaDescribedBy);
  }
  if (this.inputAriaLabelledBy) {
    autocompleteInput.removeAttr('aria-label');
    autocompleteInput.attr('aria-labelledby', this.inputAriaLabelledBy);
  }
};

MdContactChipsCtrl.prototype.queryContact = function(searchText) {
  return this.contactQuery({'$query': searchText});
};

MdContactChipsCtrl.prototype.inputKeydown = function(event) {
  if (!this.separatorKeys || this.separatorKeys.indexOf(event.keyCode) < 0) {
    return;
  }

  event.stopPropagation();
  event.preventDefault();

  var autocompleteCtrl = angular.element(event.target).controller('mdAutocomplete');
  autocompleteCtrl.select(autocompleteCtrl.index);
};

MdContactChipsCtrl.prototype.itemName = function(item) {
  return item[this.contactName];
};

/**
 * Destructor for cleanup
 */
MdContactChipsCtrl.prototype.$onDestroy = function $onDestroy() {
  var $destroyFn;
  while (($destroyFn = this.deRegister.pop())) {
    $destroyFn.call(this);
  }
};

})();
(function(){
"use strict";


MdContactChips.$inject = ["$mdTheming", "$mdUtil"];angular
  .module('material.components.chips')
  .directive('mdContactChips', MdContactChips);

/**
 * @ngdoc directive
 * @name mdContactChips
 * @module material.components.chips
 *
 * @description
 * `<md-contact-chips>` is an input component based on `md-chips` and makes use of an
 * `md-autocomplete` element. The component allows the caller to supply a query expression which
 * returns  a list of possible contacts. The user can select one of these and add it to the list of
 * chips.
 *
 * You may also use the <a ng-href="api/directive/mdHighlightText">md-highlight-flags</a> attribute
 * along with its parameters to control the appearance of the matched text inside of the contacts'
 * autocomplete popup.
 *
 * @param {expression} ng-model Assignable AngularJS expression to be data-bound to the list of
 *    contact chips. The expression should evaluate to an `Object` Array.
 * @param {expression=} ng-change AngularJS expression to be executed on chip addition, removal,
 *    or content change.
 * @param {string=} placeholder Placeholder text that will be forwarded to the input.
 * @param {string=} secondary-placeholder Placeholder text that will be forwarded to the input,
 *    displayed when there is at least on item in the list
 * @param {expression} md-contacts An expression expected to return contacts matching the search
 *    test, `$query`. If this expression involves a promise, a loading bar is displayed while
 *    waiting for it to resolve.
 * @param {string} md-contact-name The field name of the contact object representing the
 *    contact's name.
 * @param {string} md-contact-email The field name of the contact object representing the
 *    contact's email address.
 * @param {string} md-contact-image The field name of the contact object representing the
 *    contact's image.
 * @param {number=} md-max-chips The maximum number of chips allowed to add through user input.
 *    <br/><br/>The validation property `md-max-chips` can be used when the max chips
 *    amount is reached.
 * @param {number=} md-min-length Specifies the minimum length of text before autocomplete will
 *    make suggestions
 * @param {string=} md-input-class This class will be applied to the child `md-autocomplete` for
 *    custom styling.
 * @param {string=} input-aria-describedby A space-separated list of element IDs. This should
 *     contain the IDs of any elements that describe this autocomplete. Screen readers will read
 *     the content of these elements at the end of announcing that the chips input has been
 *     selected and describing its current state. The descriptive elements do not need to be
 *     visible on the page.
 * @param {string=} input-aria-labelledby A space-separated list of element IDs. The ideal use
 *    case is that this would contain the ID of a `<label>` element that is associated with these
 *    chips.<br><br>
 *    For `<label id="state">US State</label>`, you would set this to
 *    `input-aria-labelledby="state"`.
 * @param {string=} input-aria-label A string read by screen readers to identify the input.
 *    For static chips, this will be applied to the chips container.
 * @param {string=} container-hint A string read by screen readers informing users of how to
 *    navigate the chips when there are chips.
 * @param {string=} container-empty-hint A string read by screen readers informing users of how to
 *    add chips when there are no chips. You will want to use this to override the default when
 *    in a non-English locale.
 * @param {string=} delete-hint A string read by screen readers instructing users that pressing
 *    the delete key will remove the chip. You will want to use this to override the default when
 *    in a non-English locale.
 * @param {string=} md-removed-message Screen readers will announce this message following the
 *    chips contents. The default is `"removed"`. If a chip with the content of "Apple" was
 *    removed, the screen reader would read "Apple removed". You will want to use this to override
 *    the default when in a non-English locale.
 *
 *
 * @usage
 * <hljs lang="html">
 *   <md-contact-chips
 *       ng-model="ctrl.contacts"
 *       md-contacts="ctrl.querySearch($query)"
 *       md-contact-name="name"
 *       md-contact-image="image"
 *       md-contact-email="email"
 *       placeholder="To">
 *   </md-contact-chips>
 * </hljs>
 *
 */


var MD_CONTACT_CHIPS_TEMPLATE = '\
      <md-chips class="md-contact-chips"\
          ng-model="$mdContactChipsCtrl.contacts"\
          ng-change="$mdContactChipsCtrl.ngChange($mdContactChipsCtrl.contacts)"\
          md-require-match="$mdContactChipsCtrl.requireMatch"\
          md-max-chips="{{$mdContactChipsCtrl.maxChips}}"\
          md-chip-append-delay="{{$mdContactChipsCtrl.chipAppendDelay}}"\
          md-separator-keys="$mdContactChipsCtrl.separatorKeys"\
          md-autocomplete-snap>\
          <md-autocomplete\
              md-menu-class="md-contact-chips-suggestions"\
              md-selected-item="$mdContactChipsCtrl.selectedItem"\
              md-search-text="$mdContactChipsCtrl.searchText"\
              md-items="item in $mdContactChipsCtrl.queryContact($mdContactChipsCtrl.searchText)"\
              md-item-text="$mdContactChipsCtrl.itemName(item)"\
              md-no-cache="true"\
              md-min-length="$mdContactChipsCtrl.minLength"\
              md-autoselect\
              ng-attr-md-input-class="{{$mdContactChipsCtrl.inputClass}}"\
              ng-keydown="$mdContactChipsCtrl.inputKeydown($event)"\
              placeholder="{{$mdContactChipsCtrl.contacts.length === 0 ?\
                  $mdContactChipsCtrl.placeholder : $mdContactChipsCtrl.secondaryPlaceholder}}">\
            <div class="md-contact-suggestion">\
              <img \
                  ng-src="{{item[$mdContactChipsCtrl.contactImage]}}"\
                  alt="{{item[$mdContactChipsCtrl.contactName]}}"\
                  ng-if="item[$mdContactChipsCtrl.contactImage]" />\
              <span class="md-contact-name" md-highlight-text="$mdContactChipsCtrl.searchText"\
                    md-highlight-flags="{{$mdContactChipsCtrl.highlightFlags}}">\
                {{item[$mdContactChipsCtrl.contactName]}}\
              </span>\
              <span class="md-contact-email" >{{item[$mdContactChipsCtrl.contactEmail]}}</span>\
            </div>\
          </md-autocomplete>\
          <md-chip-template>\
            <div class="md-contact-avatar">\
              <img \
                  ng-src="{{$chip[$mdContactChipsCtrl.contactImage]}}"\
                  alt="{{$chip[$mdContactChipsCtrl.contactName]}}"\
                  ng-if="$chip[$mdContactChipsCtrl.contactImage]" />\
            </div>\
            <div class="md-contact-name">\
              {{$chip[$mdContactChipsCtrl.contactName]}}\
            </div>\
          </md-chip-template>\
      </md-chips>';


/**
 * MDContactChips Directive Definition
 *
 * @param $mdTheming
 * @param $mdUtil
 * @returns {*}
 * @ngInject
 */
function MdContactChips($mdTheming, $mdUtil) {
  return {
    template: function(element, attrs) {
      return MD_CONTACT_CHIPS_TEMPLATE;
    },
    restrict: 'E',
    controller: 'MdContactChipsCtrl',
    controllerAs: '$mdContactChipsCtrl',
    bindToController: true,
    compile: compile,
    scope: {
      contactQuery: '&mdContacts',
      placeholder: '@?',
      secondaryPlaceholder: '@?',
      contactName: '@mdContactName',
      contactImage: '@mdContactImage',
      contactEmail: '@mdContactEmail',
      contacts: '=ngModel',
      ngChange: '&?',
      requireMatch: '=?mdRequireMatch',
      minLength: '=?mdMinLength',
      maxChips: '=?mdMaxChips',
      highlightFlags: '@?mdHighlightFlags',
      chipAppendDelay: '@?mdChipAppendDelay',
      separatorKeys: '=?mdSeparatorKeys',
      removedMessage: '@?mdRemovedMessage',
      inputClass: '@?mdInputClass',
      inputAriaDescribedBy: '@?inputAriaDescribedby',
      inputAriaLabelledBy: '@?inputAriaLabelledby',
      inputAriaLabel: '@?',
      containerHint: '@?',
      containerEmptyHint: '@?',
      deleteHint: '@?'
    }
  };

  function compile(element, attr) {
    return function postLink(scope, element, attrs, controllers) {
      var contactChipsController = controllers;

      $mdUtil.initOptionalProperties(scope, attr);
      $mdTheming(element);

      element.attr('tabindex', '-1');

      attrs.$observe('mdChipAppendDelay', function(newValue) {
        contactChipsController.chipAppendDelay = newValue;
      });
    };
  }
}

})();
(function(){
"use strict";

(function () {
  "use strict";

  /**
   *  Use a RegExp to check if the `md-colors="<expression>"` is static string
   *  or one that should be observed and dynamically interpolated.
   */
  MdColorsDirective.$inject = ["$mdColors", "$mdUtil", "$log", "$parse"];
  MdColorsService.$inject = ["$mdTheming", "$mdUtil", "$log"];
  var STATIC_COLOR_EXPRESSION = /^{((\s|,)*?["'a-zA-Z-]+?\s*?:\s*?(['"])[a-zA-Z0-9-.]*(['"]))+\s*}$/;
  var colorPalettes = null;

  /**
   * @ngdoc module
   * @name material.components.colors
   *
   * @description
   * Define $mdColors service and a `md-colors=""` attribute directive
   */
  angular
    .module('material.components.colors', ['material.core'])
    .directive('mdColors', MdColorsDirective)
    .service('$mdColors', MdColorsService);

  /**
   * @ngdoc service
   * @name $mdColors
   * @module material.components.colors
   *
   * @description
   * By default, defining a theme does not make its colors available for applying to non AngularJS
   * Material elements. The `$mdColors` service is used by the `md-color` directive to convert a
   * set of color expressions to RGBA values and then apply those values to the element as CSS
   * property values.
   *
   * @usage
   * Getting a color based on a theme
   *
   *  <hljs lang="js">
   *    angular.controller('myCtrl', function ($mdColors) {
   *      var color = $mdColors.getThemeColor('myTheme-primary-900-0.5');
   *      ...
   *    });
   *  </hljs>
   *
   * Applying a color from a palette to an element
   * <hljs lang="js">
   *   app.directive('myDirective', function($mdColors) {
   *     return {
   *       ...
   *       link: function (scope, elem) {
   *         $mdColors.applyThemeColors(elem, {color: 'red-A200-0.2'});
   *       }
   *    }
   *   });
   * </hljs>
   */
  function MdColorsService($mdTheming, $mdUtil, $log) {
    colorPalettes = colorPalettes || Object.keys($mdTheming.PALETTES);

    // Publish service instance
    return {
      applyThemeColors: applyThemeColors,
      getThemeColor: getThemeColor,
      hasTheme: hasTheme
    };

    // ********************************************
    // Internal Methods
    // ********************************************

    /**
     * @ngdoc method
     * @name $mdColors#applyThemeColors
     *
     * @description
     * Lookup a set of colors by hue, theme, and palette, then apply those colors
     * with the provided opacity (via `rgba()`) to the specified CSS property.
     *
     * @param {angular.element} element the element to apply the styles to
     * @param {Object} colorExpression Keys are CSS properties and values are strings representing
     * the `theme-palette-hue-opacity` of the desired color. For example:
     * `{'color': 'red-A200-0.3', 'background-color': 'myTheme-primary-700-0.8'}`. Theme, hue, and
     * opacity are optional.
     */
    function applyThemeColors(element, colorExpression) {
      try {
        if (colorExpression) {
          // Assign the calculate RGBA color values directly as inline CSS
          element.css(interpolateColors(colorExpression));
        }
      } catch (e) {
        $log.error(e.message);
      }
    }

    /**
     * @ngdoc method
     * @name $mdColors#getThemeColor
     *
     * @description
     * Get a parsed RGBA color using a string representing the `theme-palette-hue-opacity` of the
     * desired color.
     *
     * @param {string} expression color expression like `'red-A200-0.3'` or
     *  `'myTheme-primary-700-0.8'`. Theme, hue, and opacity are optional.
     * @returns {string} a CSS color value like `rgba(211, 47, 47, 0.8)`
     */
    function getThemeColor(expression) {
      var color = extractColorOptions(expression);

      return parseColor(color);
    }

    /**
     * Return the parsed color
     * @param {{hue: *, theme: any, palette: *, opacity: (*|string|number)}} color hash map of color
     *  definitions
     * @param {boolean=} contrast whether use contrast color for foreground. Defaults to false.
     * @returns {string} rgba color string
     */
    function parseColor(color, contrast) {
      contrast = contrast || false;
      var rgbValues = $mdTheming.PALETTES[color.palette][color.hue];

      rgbValues = contrast ? rgbValues.contrast : rgbValues.value;

      return $mdUtil.supplant('rgba({0}, {1}, {2}, {3})',
        [rgbValues[0], rgbValues[1], rgbValues[2], rgbValues[3] || color.opacity]
      );
    }

    /**
     * Convert the color expression into an object with scope-interpolated values
     * Then calculate the rgba() values based on the theme color parts
     * @param {Object} themeColors json object, keys are css properties and values are string of
     * the wanted color, for example: `{color: 'red-A200-0.3'}`.
     * @return {Object} Hashmap of CSS properties with associated `rgba()` string values
     */
    function interpolateColors(themeColors) {
      var rgbColors = {};

      var hasColorProperty = themeColors.hasOwnProperty('color');

      angular.forEach(themeColors, function (value, key) {
        var color = extractColorOptions(value);
        var hasBackground = key.indexOf('background') > -1;

        rgbColors[key] = parseColor(color);
        if (hasBackground && !hasColorProperty) {
          rgbColors.color = parseColor(color, true);
        }
      });

      return rgbColors;
    }

    /**
     * Check if expression has defined theme
     * For instance:
     *   'myTheme-primary' => true
     *   'red-800' => false
     * @param {string} expression color expression like 'red-800', 'red-A200-0.3',
     *   'myTheme-primary', or 'myTheme-primary-400'
     * @return {boolean} true if the expression has a theme part, false otherwise.
     */
    function hasTheme(expression) {
      return angular.isDefined($mdTheming.THEMES[expression.split('-')[0]]);
    }

    /**
     * For the evaluated expression, extract the color parts into a hash map
     * @param {string} expression color expression like 'red-800', 'red-A200-0.3',
     *   'myTheme-primary', or 'myTheme-primary-400'
     * @returns {{hue: *, theme: any, palette: *, opacity: (*|string|number)}}
     */
    function extractColorOptions(expression) {
      var parts = expression.split('-');
      var hasTheme = angular.isDefined($mdTheming.THEMES[parts[0]]);
      var theme = hasTheme ? parts.splice(0, 1)[0] : $mdTheming.defaultTheme();

      return {
        theme: theme,
        palette: extractPalette(parts, theme),
        hue: extractHue(parts, theme),
        opacity: parts[2] || 1
      };
    }

    /**
     * Calculate the theme palette name
     * @param {Array} parts
     * @param {string} theme name
     * @return {string}
     */
    function extractPalette(parts, theme) {
      // If the next section is one of the palettes we assume it's a two word palette
      // Two word palette can be also written in camelCase, forming camelCase to dash-case

      var isTwoWord = parts.length > 1 && colorPalettes.indexOf(parts[1]) !== -1;
      var palette = parts[0].replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();

      if (isTwoWord)  palette = parts[0] + '-' + parts.splice(1, 1);

      if (colorPalettes.indexOf(palette) === -1) {
        // If the palette is not in the palette list it's one of primary/accent/warn/background
        var scheme = $mdTheming.THEMES[theme].colors[palette];
        if (!scheme) {
          throw new Error($mdUtil.supplant(
            'mdColors: couldn\'t find \'{palette}\' in the palettes.',
            {palette: palette}));
        }
        palette = scheme.name;
      }

      return palette;
    }

    /**
     * @param {Array} parts
     * @param {string} theme name
     * @return {*}
     */
    function extractHue(parts, theme) {
      var themeColors = $mdTheming.THEMES[theme].colors;

      if (parts[1] === 'hue') {
        var hueNumber = parseInt(parts.splice(2, 1)[0], 10);

        if (hueNumber < 1 || hueNumber > 3) {
          throw new Error($mdUtil.supplant(
            'mdColors: \'hue-{hueNumber}\' is not a valid hue, can be only \'hue-1\', \'hue-2\' and \'hue-3\'',
            {hueNumber: hueNumber}));
        }
        parts[1] = 'hue-' + hueNumber;

        if (!(parts[0] in themeColors)) {
          throw new Error($mdUtil.supplant(
            'mdColors: \'hue-x\' can only be used with [{availableThemes}], but was used with \'{usedTheme}\'',
            {
            availableThemes: Object.keys(themeColors).join(', '),
            usedTheme: parts[0]
          }));
        }

        return themeColors[parts[0]].hues[parts[1]];
      }

      return parts[1] || themeColors[parts[0] in themeColors ? parts[0] : 'primary'].hues['default'];
    }
  }

  /**
   * @ngdoc directive
   * @name mdColors
   * @module material.components.colors
   *
   * @restrict A
   *
   * @description
   * `mdColors` directive will apply the theme-based color expression as RGBA CSS style values.
   *
   *   The format will be similar to the colors defined in the Sass files:
   *
   *   ## `[?theme]-[palette]-[?hue]-[?opacity]`
   *   - [theme]    - default value is the default theme
   *   - [palette]  - can be either palette name or primary/accent/warn/background
   *   - [hue]      - default is 500 (hue-x can be used with primary/accent/warn/background)
   *   - [opacity]  - default is 1
   *
   *
   *   > `?` indicates optional parameter
   *
   * @usage
   * <hljs lang="html">
   *   <div md-colors="{background: 'myTheme-accent-900-0.43'}">
   *     <div md-colors="{color: 'red-A100', 'border-color': 'primary-600'}">
   *       <span>Color demo</span>
   *     </div>
   *   </div>
   * </hljs>
   *
   * The `mdColors` directive will automatically watch for changes in the expression if it recognizes
   * an interpolation expression or a function. For performance options, you can use `::` prefix to
   * the `md-colors` expression to indicate a one-time data binding.
   *
   * <hljs lang="html">
   *   <md-card md-colors="::{background: '{{theme}}-primary-700'}">
   *   </md-card>
   * </hljs>
   */
  function MdColorsDirective($mdColors, $mdUtil, $log, $parse) {
    return {
      restrict: 'A',
      require: ['^?mdTheme'],
      compile: function (tElem, tAttrs) {
        var shouldWatch = shouldColorsWatch();

        return function (scope, element, attrs, ctrl) {
          var mdThemeController = ctrl[0];

          var lastColors = {};

          /**
           * @param {string=} theme
           * @return {Object} colors found in the specified theme
           */
          var parseColors = function (theme) {
            if (typeof theme !== 'string') {
              theme = '';
            }

            if (!attrs.mdColors) {
              attrs.mdColors = '{}';
            }

            /**
             * Json.parse() does not work because the keys are not quoted;
             * use $parse to convert to a hash map
             */
            var colors = $parse(attrs.mdColors)(scope);

            /**
             * If mdTheme is defined higher up the DOM tree,
             * we add mdTheme's theme to the colors which don't specify a theme.
             *
             * @example
             * <hljs lang="html">
             *   <div md-theme="myTheme">
             *     <div md-colors="{background: 'primary-600'}">
             *       <span md-colors="{background: 'mySecondTheme-accent-200'}">Color demo</span>
             *     </div>
             *   </div>
             * </hljs>
             *
             * 'primary-600' will be changed to 'myTheme-primary-600',
             * but 'mySecondTheme-accent-200' will not be changed since it has a theme defined.
             */
            if (mdThemeController) {
              Object.keys(colors).forEach(function (prop) {
                var color = colors[prop];
                if (!$mdColors.hasTheme(color)) {
                  colors[prop] = (theme || mdThemeController.$mdTheme) + '-' + color;
                }
              });
            }

            cleanElement(colors);

            return colors;
          };

          /**
           * @param {Object} colors
           */
          var cleanElement = function (colors) {
            if (!angular.equals(colors, lastColors)) {
              var keys = Object.keys(lastColors);

              if (lastColors.background && !keys.color) {
                keys.push('color');
              }

              keys.forEach(function (key) {
                element.css(key, '');
              });
            }

            lastColors = colors;
          };

          /**
           * Registering for mgTheme changes and asking mdTheme controller run our callback whenever
           * a theme changes.
           */
          var unregisterChanges = angular.noop;

          if (mdThemeController) {
            unregisterChanges = mdThemeController.registerChanges(function (theme) {
              $mdColors.applyThemeColors(element, parseColors(theme));
            });
          }

          scope.$on('$destroy', function () {
            unregisterChanges();
          });

          try {
            if (shouldWatch) {
              scope.$watch(parseColors, angular.bind(this,
                $mdColors.applyThemeColors, element
              ), true);
            }
            else {
              $mdColors.applyThemeColors(element, parseColors());
            }

          }
          catch (e) {
            $log.error(e.message);
          }

        };

        /**
         * @return {boolean}
         */
        function shouldColorsWatch() {
          // Simulate 1x binding and mark mdColorsWatch == false
          var rawColorExpression = tAttrs.mdColors;
          var bindOnce = rawColorExpression.indexOf('::') > -1;
          var isStatic = bindOnce ? true : STATIC_COLOR_EXPRESSION.test(tAttrs.mdColors);

          // Remove it for the postLink...
          tAttrs.mdColors = rawColorExpression.replace('::', '');

          var hasWatchAttr = angular.isDefined(tAttrs.mdColorsWatch);

          return (bindOnce || isStatic) ? false :
            hasWatchAttr ? $mdUtil.parseAttributeBoolean(tAttrs.mdColorsWatch) : true;
        }
      }
    };
  }
})();

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.content
 *
 * @description
 * Scrollable content
 */
mdContentDirective.$inject = ["$mdTheming"];
angular.module('material.components.content', [
  'material.core'
])
  .directive('mdContent', mdContentDirective);

/**
 * @ngdoc directive
 * @name mdContent
 * @module material.components.content
 *
 * @restrict E
 *
 * @description
 *
 * The `<md-content>` directive is a container element useful for scrollable content. It achieves
 * this by setting the CSS `overflow` property to `auto` so that content can properly scroll.
 *
 * In general, `<md-content>` components are not designed to be nested inside one another. If
 * possible, it is better to make them siblings. This often results in a better user experience as
 * having nested scrollbars may confuse the user.
 *
 * ## Troubleshooting
 *
 * In some cases, you may wish to apply the `md-no-momentum` class to ensure that Safari's
 * momentum scrolling is disabled. Momentum scrolling can cause flickering issues while scrolling
 * SVG icons and some other components.
 *
 * Additionally, we now also offer the `md-no-flicker` class which can be applied to any element
 * and uses a Webkit-specific filter of `blur(0px)` that forces GPU rendering of all elements
 * inside (which eliminates the flicker on iOS devices).
 *
 * _<b>Note:</b> Forcing an element to render on the GPU can have unintended side-effects, especially
 * related to the z-index of elements. Please use with caution and only on the elements needed._
 *
 * @usage
 *
 * Add the `[layout-padding]` attribute to make the content padded.
 *
 * <hljs lang="html">
 *  <md-content layout-padding>
 *      Lorem ipsum dolor sit amet, ne quod novum mei.
 *  </md-content>
 * </hljs>
 */

function mdContentDirective($mdTheming) {
  return {
    restrict: 'E',
    controller: ['$scope', '$element', ContentController],
    link: function(scope, element) {
      element.addClass('_md');     // private md component indicator for styling

      $mdTheming(element);
      scope.$broadcast('$mdContentLoaded', element);

      iosScrollFix(element[0]);
    }
  };

  function ContentController($scope, $element) {
    this.$scope = $scope;
    this.$element = $element;
  }
}

function iosScrollFix(node) {
  // IOS FIX:
  // If we scroll where there is no more room for the webview to scroll,
  // by default the webview itself will scroll up and down, this looks really
  // bad.  So if we are scrolling to the very top or bottom, add/subtract one
  angular.element(node).on('$md.pressdown', function(ev) {
    // Only touch events
    if (ev.pointer.type !== 't') return;
    // Don't let a child content's touchstart ruin it for us.
    if (ev.$materialScrollFixed) return;
    ev.$materialScrollFixed = true;

    if (node.scrollTop === 0) {
      node.scrollTop = 1;
    } else if (node.scrollHeight === node.scrollTop + node.offsetHeight) {
      node.scrollTop -= 1;
    }
  });
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.datepicker
 * @description Module for the datepicker component.
 */

angular.module('material.components.datepicker', [
  'material.core',
  'material.components.icon',
  'material.components.virtualRepeat'
]);

})();
(function(){
"use strict";

(function() {
  'use strict';

  /**
   * @ngdoc directive
   * @name mdCalendar
   * @module material.components.datepicker
   *
   * @param {Date} ng-model The component's model. Should be a Date object.
   * @param {Object=} ng-model-options Allows tuning of the way in which `ng-model` is being
   *  updated. Also allows for a timezone to be specified.
   *  <a href="https://docs.angularjs.org/api/ng/directive/ngModelOptions#usage">Read more at the
   *  ngModelOptions docs.</a>
   * @param {Date=} md-min-date Expression representing the minimum date.
   * @param {Date=} md-max-date Expression representing the maximum date.
   * @param {(function(Date): boolean)=} md-date-filter Function expecting a date and returning a
   *  boolean whether it can be selected in "day" mode or not.
   * @param {(function(Date): boolean)=} md-month-filter Function expecting a date and returning a
   *  boolean whether it can be selected in "month" mode or not.
   * @param {String=} md-current-view Current view of the calendar. Can be either "month" or "year".
   * @param {String=} md-mode Restricts the user to only selecting a value from a particular view.
   *  This option can be used if the user is only supposed to choose from a certain date type
   *  (e.g. only selecting the month). Can be either "month" or "day". **Note** that this will
   *  overwrite the `md-current-view` value.
   *
   * @description
   * `<md-calendar>` is a component that renders a calendar that can be used to select a date.
   * It is a part of the `<md-datepicker>` pane, however it can also be used on it's own.
   *
   * @usage
   *
   * <hljs lang="html">
   *   <md-calendar ng-model="birthday"></md-calendar>
   * </hljs>
   */
  CalendarCtrl.$inject = ["$element", "$scope", "$$mdDateUtil", "$mdUtil", "$mdConstant", "$mdTheming", "$$rAF", "$attrs", "$mdDateLocale", "$filter", "$document"];
  calendarDirective.$inject = ["inputDirective"];
  angular.module('material.components.datepicker')
    .directive('mdCalendar', calendarDirective);

  // TODO(jelbourn): Mac Cmd + left / right == Home / End
  // TODO(jelbourn): Refactor month element creation to use cloneNode (performance).
  // TODO(jelbourn): Define virtual scrolling constants (compactness) users can override.
  // TODO(jelbourn): Animated month transition on ng-model change (virtual-repeat)
  // TODO(jelbourn): Scroll snapping (virtual repeat)
  // TODO(jelbourn): Remove superfluous row from short months (virtual-repeat)
  // TODO(jelbourn): Month headers stick to top when scrolling.
  // TODO(jelbourn): Previous month opacity is lowered when partially scrolled out of view.
  // TODO(jelbourn): Support md-calendar standalone on a page (as a tabstop w/ aria-live
  //     announcement and key handling).
  // TODO Read-only calendar (not just date-picker).

  function calendarDirective(inputDirective) {
    return {
      template: function(tElement, tAttr) {
        // This allows the calendar to work, without a datepicker. This ensures that the virtual
        // repeater scrolls to the proper place on load by deferring the execution until the next
        // digest. It's necessary only if the calendar is used without a datepicker, otherwise it's
        // already wrapped in an ngIf.
        var extraAttrs = tAttr.hasOwnProperty('ngIf') ? '' : 'ng-if="calendarCtrl.isInitialized"';
        return '' +
          '<div ng-switch="calendarCtrl.currentView" ' + extraAttrs + '>' +
            '<md-calendar-year ng-switch-when="year"></md-calendar-year>' +
            '<md-calendar-month ng-switch-default></md-calendar-month>' +
          '</div>';
      },
      scope: {
        minDate: '=mdMinDate',
        maxDate: '=mdMaxDate',
        dateFilter: '=mdDateFilter',
        monthFilter: '=mdMonthFilter',

        // These need to be prefixed, because Angular resets
        // any changes to the value due to bindToController.
        _mode: '@mdMode',
        _currentView: '@mdCurrentView'
      },
      require: ['ngModel', 'mdCalendar'],
      controller: CalendarCtrl,
      controllerAs: 'calendarCtrl',
      bindToController: true,
      link: function(scope, element, attrs, controllers) {
        var ngModelCtrl = controllers[0];
        var mdCalendarCtrl = controllers[1];
        mdCalendarCtrl.configureNgModel(ngModelCtrl, inputDirective);
      }
    };
  }

  /**
   * Occasionally the hideVerticalScrollbar method might read an element's
   * width as 0, because it hasn't been laid out yet. This value will be used
   * as a fallback, in order to prevent scenarios where the element's width
   * would otherwise have been set to 0. This value is the "usual" width of a
   * calendar within a floating calendar pane.
   */
  var FALLBACK_WIDTH = 340;

  /** Next identifier for calendar instance. */
  var nextUniqueId = 0;

  /** Maps the `md-mode` values to their corresponding calendar views. */
  var MODE_MAP = {
    day: 'month',
    month: 'year'
  };

  /**
   * Controller for the mdCalendar component.
   * @ngInject @constructor
   */
  function CalendarCtrl($element, $scope, $$mdDateUtil, $mdUtil, $mdConstant, $mdTheming, $$rAF,
                        $attrs, $mdDateLocale, $filter, $document) {
    $mdTheming($element);

    /**
     * @final
     * @type {!JQLite}
     */
    this.$element = $element;

    /**
     * @final
     * @type {!angular.Scope}
     */
    this.$scope = $scope;

    /**
     * @final
     * @type {!angular.$attrs} Current attributes object for the element
     */
    this.$attrs = $attrs;

    /** @final */
    this.dateUtil = $$mdDateUtil;

    /** @final */
    this.$mdUtil = $mdUtil;

    /** @final */
    this.keyCode = $mdConstant.KEY_CODE;

    /** @final */
    this.$$rAF = $$rAF;

    /** @final */
    this.$mdDateLocale = $mdDateLocale;

    /** @final The built-in Angular date filter. */
    this.ngDateFilter = $filter('date');

    /**
     * @final
     * @type {Date}
     */
    this.today = this.dateUtil.createDateAtMidnight();

    /** @type {!ngModel.NgModelController} */
    this.ngModelCtrl = undefined;

    /** @type {string} Class applied to the selected date cell. */
    this.SELECTED_DATE_CLASS = 'md-calendar-selected-date';

    /** @type {string} Class applied to the cell for today. */
    this.TODAY_CLASS = 'md-calendar-date-today';

    /** @type {string} Class applied to the focused cell. */
    this.FOCUSED_DATE_CLASS = 'md-focus';

    /**
     * @final
     * @type {number} Unique ID for this calendar instance.
     */
    this.id = nextUniqueId++;

    /**
     * The date that is currently focused or showing in the calendar. This will initially be set
     * to the ng-model value if set, otherwise to today. It will be updated as the user navigates
     * to other months. The cell corresponding to the displayDate does not necessarily always have
     * focus in the document (such as for cases when the user is scrolling the calendar).
     * @type {Date}
     */
    this.displayDate = null;

    /**
     * Allows restricting the calendar to only allow selecting a month or a day.
     * @type {'month'|'day'|null}
     */
    this.mode = null;

    /**
     * The selected date. Keep track of this separately from the ng-model value so that we
     * can know, when the ng-model value changes, what the previous value was before it's updated
     * in the component's UI.
     *
     * @type {Date}
     */
    this.selectedDate = null;

    /**
     * The first date that can be rendered by the calendar. The default is taken
     * from the mdDateLocale provider and is limited by the mdMinDate.
     * @type {Date}
     */
    this.firstRenderableDate = null;

    /**
     * The last date that can be rendered by the calendar. The default comes
     * from the mdDateLocale provider and is limited by the maxDate.
     * @type {Date}
     */
    this.lastRenderableDate = null;

    /**
     * Used to toggle initialize the root element in the next digest.
     * @type {boolean}
     */
    this.isInitialized = false;

    /**
     * Cache for the  width of the element without a scrollbar. Used to hide the scrollbar later on
     * and to avoid extra reflows when switching between views.
     * @type {number}
     */
    this.width = 0;

    /**
     * Caches the width of the scrollbar in order to be used when hiding it and to avoid extra reflows.
     * @type {number}
     */
    this.scrollbarWidth = 0;

    /**
     * @type {boolean} set to true if the calendar is being used "standalone" (outside of a
     *  md-datepicker).
     */
    this.standaloneMode = false;

    // Unless the user specifies so, the calendar should not be a tab stop.
    // This is necessary because ngAria might add a tabindex to anything with an ng-model
    // (based on whether or not the user has turned that particular feature on/off).
    if (!$attrs.tabindex) {
      $element.attr('tabindex', '-1');
    }

    var boundKeyHandler = angular.bind(this, this.handleKeyEvent);

    // If use the md-calendar directly in the body without datepicker,
    // handleKeyEvent will disable other inputs on the page.
    // So only apply the handleKeyEvent on the body when the md-calendar inside datepicker,
    // otherwise apply on the calendar element only.

    var handleKeyElement;
    if ($element.parent().hasClass('md-datepicker-calendar')) {
      handleKeyElement = angular.element($document[0].body);
    } else {
      this.standaloneMode = true;
      handleKeyElement = $element;
    }

    // Bind the keydown handler to the body, in order to handle cases where the focused
    // element gets removed from the DOM and stops propagating click events.
    handleKeyElement.on('keydown', boundKeyHandler);

    $scope.$on('$destroy', function() {
      handleKeyElement.off('keydown', boundKeyHandler);
    });

    // For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
    // manually call the $onInit hook.
    if (angular.version.major === 1 && angular.version.minor <= 4) {
      this.$onInit();
    }
  }

  /**
   * AngularJS Lifecycle hook for newer AngularJS versions.
   * Bindings are not guaranteed to have been assigned in the controller, but they are in the
   * $onInit hook.
   */
  CalendarCtrl.prototype.$onInit = function() {
    /**
     * The currently visible calendar view. Note the prefix on the scope value,
     * which is necessary, because the datepicker seems to reset the real one value if the
     * calendar is open, but the `currentView` on the datepicker's scope is empty.
     * @type {String}
     */
    if (this._mode && MODE_MAP.hasOwnProperty(this._mode)) {
      this.currentView = MODE_MAP[this._mode];
      this.mode = this._mode;
    } else {
      this.currentView = this._currentView || 'month';
      this.mode = null;
    }

    if (this.minDate && this.minDate > this.$mdDateLocale.firstRenderableDate) {
      this.firstRenderableDate = this.minDate;
    } else {
      this.firstRenderableDate = this.$mdDateLocale.firstRenderableDate;
    }

    if (this.maxDate && this.maxDate < this.$mdDateLocale.lastRenderableDate) {
      this.lastRenderableDate = this.maxDate;
    } else {
      this.lastRenderableDate = this.$mdDateLocale.lastRenderableDate;
    }
  };

  /**
   * Sets up the controller's reference to ngModelController.
   * @param {!ngModel.NgModelController} ngModelCtrl Instance of the ngModel controller.
   * @param {Object} inputDirective Config for AngularJS's `input` directive.
   */
  CalendarCtrl.prototype.configureNgModel = function(ngModelCtrl, inputDirective) {
    var self = this;
    self.ngModelCtrl = ngModelCtrl;

    // The component needs to be [type="date"] in order to be picked up by AngularJS.
    this.$attrs.$set('type', 'date');

    // Invoke the `input` directive link function, adding a stub for the element.
    // This allows us to re-use AngularJS' logic for setting the timezone via ng-model-options.
    // It works by calling the link function directly which then adds the proper `$parsers` and
    // `$formatters` to the NgModelController.
    inputDirective[0].link.pre(this.$scope, {
      on: angular.noop,
      val: angular.noop,
      0: {}
    }, this.$attrs, [ngModelCtrl]);

    ngModelCtrl.$render = function() {
      var value = this.$viewValue, convertedDate;

      // In the case where a conversion is needed, the $viewValue here will be a string like
      // "2020-05-10" instead of a Date object.
      if (!self.dateUtil.isValidDate(value)) {
        convertedDate = self.dateUtil.removeLocalTzAndReparseDate(new Date(value));
        if (self.dateUtil.isValidDate(convertedDate)) {
          value = convertedDate;
        }
      }

      // Notify the child scopes of any changes.
      self.$scope.$broadcast('md-calendar-parent-changed', value);

      // Set up the selectedDate if it hasn't been already.
      if (!self.selectedDate) {
        self.selectedDate = value;
      }

      // Also set up the displayDate.
      if (!self.displayDate) {
        self.displayDate = self.selectedDate || self.today;
      }
    };

    self.$mdUtil.nextTick(function() {
      self.isInitialized = true;
    });
  };

  /**
   * Sets the ng-model value for the calendar and emits a change event.
   * @param {Date} date new value for the calendar
   */
  CalendarCtrl.prototype.setNgModelValue = function(date) {
    var timezone = this.$mdUtil.getModelOption(this.ngModelCtrl, 'timezone');
    var value = this.dateUtil.createDateAtMidnight(date);
    this.focusDate(value);
    this.$scope.$emit('md-calendar-change', value);
    // Using the timezone when the offset is negative (GMT+X) causes the previous day to be
    // selected here. This check avoids that.
    if (timezone == null || value.getTimezoneOffset() < 0) {
      this.ngModelCtrl.$setViewValue(this.ngDateFilter(value, 'yyyy-MM-dd'), 'default');
    } else {
      this.ngModelCtrl.$setViewValue(this.ngDateFilter(value, 'yyyy-MM-dd', timezone), 'default');
    }
    this.ngModelCtrl.$render();
    return value;
  };

  /**
   * Sets the current view that should be visible in the calendar
   * @param {string} newView View name to be set.
   * @param {number|Date} time Date object or a timestamp for the new display date.
   */
  CalendarCtrl.prototype.setCurrentView = function(newView, time) {
    var self = this;

    self.$mdUtil.nextTick(function() {
      self.currentView = newView;

      if (time) {
        self.displayDate = angular.isDate(time) ? time : new Date(time);
      }
    });
  };

  /**
   * Focus the cell corresponding to the given date.
   * @param {Date=} date The date to be focused.
   */
  CalendarCtrl.prototype.focusDate = function(date) {
    if (this.dateUtil.isValidDate(date)) {
      var previousFocus = this.$element[0].querySelector('.' + this.FOCUSED_DATE_CLASS);
      if (previousFocus) {
        previousFocus.classList.remove(this.FOCUSED_DATE_CLASS);
      }

      var cellId = this.getDateId(date, this.currentView);
      var cell = document.getElementById(cellId);
      if (cell) {
        cell.classList.add(this.FOCUSED_DATE_CLASS);
        cell.focus();
        this.displayDate = date;
      }
    } else {
      var rootElement = this.$element[0].querySelector('[ng-switch]');

      if (rootElement) {
        rootElement.focus();
      }
    }
  };

  /**
   * Highlights a date cell on the calendar and changes the selected date.
   * @param {Date=} date Date to be marked as selected.
   */
  CalendarCtrl.prototype.changeSelectedDate = function(date) {
    var selectedDateClass = this.SELECTED_DATE_CLASS;
    var prevDateCell = this.$element[0].querySelector('.' + selectedDateClass);

    // Remove the selected class from the previously selected date, if any.
    if (prevDateCell) {
      prevDateCell.classList.remove(selectedDateClass);
      prevDateCell.setAttribute('aria-selected', 'false');
    }

    // Apply the select class to the new selected date if it is set.
    if (date) {
      var dateCell = document.getElementById(this.getDateId(date, this.currentView));
      if (dateCell) {
        dateCell.classList.add(selectedDateClass);
        dateCell.setAttribute('aria-selected', 'true');
      }
    }

    this.selectedDate = date;
  };

  /**
   * Normalizes the key event into an action name. The action will be broadcast
   * to the child controllers.
   * @param {KeyboardEvent} event
   * @returns {string} The action that should be taken, or null if the key
   *  does not match a calendar shortcut.
   */
  CalendarCtrl.prototype.getActionFromKeyEvent = function(event) {
    var keyCode = this.keyCode;

    switch (event.which) {
      case keyCode.ENTER: return 'select';

      case keyCode.RIGHT_ARROW: return 'move-right';
      case keyCode.LEFT_ARROW: return 'move-left';

      case keyCode.DOWN_ARROW: return event.metaKey ? 'move-page-down' : 'move-row-down';
      case keyCode.UP_ARROW: return event.metaKey ? 'move-page-up' : 'move-row-up';

      case keyCode.PAGE_DOWN: return 'move-page-down';
      case keyCode.PAGE_UP: return 'move-page-up';

      case keyCode.HOME: return 'start';
      case keyCode.END: return 'end';

      default: return null;
    }
  };

  /**
   * Handles a key event in the calendar with the appropriate action.
   * The action will either
   *  - select the focused date
   *  - navigate to focus a new date
   *  - emit a md-calendar-close event if in a md-datepicker panel
   *  - emit a md-calendar-parent-action
   *  - delegate to normal tab order if the TAB key is pressed in standalone mode
   * @param {KeyboardEvent} event
   */
  CalendarCtrl.prototype.handleKeyEvent = function(event) {
    var self = this;

    this.$scope.$apply(function() {
      // Capture escape and emit back up so that a wrapping component
      // (such as a date-picker) can decide to close.
      if (event.which === self.keyCode.ESCAPE ||
          (event.which === self.keyCode.TAB && !self.standaloneMode)) {
        self.$scope.$emit('md-calendar-close');

        if (event.which === self.keyCode.TAB) {
          event.preventDefault();
        }

        return;
      } else if (event.which === self.keyCode.TAB && self.standaloneMode) {
        // delegate to the normal tab order if the TAB key is pressed in standalone mode
        return;
      }

      // Broadcast the action that any child controllers should take.
      var action = self.getActionFromKeyEvent(event);
      if (action) {
        event.preventDefault();
        event.stopPropagation();
        self.$scope.$broadcast('md-calendar-parent-action', action);
      }
    });
  };

  /**
   * Hides the vertical scrollbar on the calendar scroller of a child controller by
   * setting the width on the calendar scroller and the `overflow: hidden` wrapper
   * around the scroller, and then setting a padding-right on the scroller equal
   * to the width of the browser's scrollbar.
   *
   * This will cause a reflow.
   *
   * @param {object} childCtrl The child controller whose scrollbar should be hidden.
   */
  CalendarCtrl.prototype.hideVerticalScrollbar = function(childCtrl) {
    var self = this;
    var element = childCtrl.$element[0];
    var scrollMask = element.querySelector('.md-calendar-scroll-mask');

    if (self.width > 0) {
      setWidth();
    } else {
      self.$$rAF(function() {
        var scroller = childCtrl.calendarScroller;

        self.scrollbarWidth = scroller.offsetWidth - scroller.clientWidth;
        self.width = element.querySelector('table').offsetWidth;
        setWidth();
      });
    }

    function setWidth() {
      var width = self.width || FALLBACK_WIDTH;
      var scrollbarWidth = self.scrollbarWidth;
      var scroller = childCtrl.calendarScroller;

      scrollMask.style.width = width + 'px';
      scroller.style.width = (width + scrollbarWidth) + 'px';
      scroller.style.paddingRight = scrollbarWidth + 'px';
    }
  };

  /**
   * Gets an identifier for a date unique to the calendar instance for internal
   * purposes. Not to be displayed.
   * @param {Date} date The date for which the id is being generated
   * @param {string} namespace Namespace for the id. (month, year etc.)
   * @returns {string}
   */
  CalendarCtrl.prototype.getDateId = function(date, namespace) {
    if (!namespace) {
      throw new Error('A namespace for the date id has to be specified.');
    }

    return [
      'md',
      this.id,
      namespace,
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    ].join('-');
  };

  /**
   * Util to trigger an extra digest on a parent scope, in order to to ensure that
   * any child virtual repeaters have updated. This is necessary, because the virtual
   * repeater doesn't update the $index the first time around since the content isn't
   * in place yet. The case, in which this is an issue, is when the repeater has less
   * than a page of content (e.g. a month or year view has a min or max date).
   */
  CalendarCtrl.prototype.updateVirtualRepeat = function() {
    var scope = this.$scope;
    var virtualRepeatResizeListener = scope.$on('$md-resize-enable', function() {
      if (!scope.$$phase) {
        scope.$apply();
      }

      virtualRepeatResizeListener();
    });
  };
})();

})();
(function(){
"use strict";

(function() {
  'use strict';

  CalendarMonthCtrl.$inject = ["$element", "$scope", "$animate", "$q", "$$mdDateUtil", "$mdDateLocale"];
  angular.module('material.components.datepicker')
    .directive('mdCalendarMonth', calendarDirective);

  /**
   * Height of one calendar month tbody. This must be made known to the virtual-repeat and is
   * subsequently used for scrolling to specific months.
   */
  var TBODY_HEIGHT = 265;

  /**
   * Height of a calendar month with a single row. This is needed to calculate the offset for
   * rendering an extra month in virtual-repeat that only contains one row.
   */
  var TBODY_SINGLE_ROW_HEIGHT = 45;

  /** Private directive that represents a list of months inside the calendar. */
  function calendarDirective() {
    return {
      template:
        '<table aria-hidden="true" class="md-calendar-day-header"><thead></thead></table>' +
        '<div class="md-calendar-scroll-mask">' +
        '<md-virtual-repeat-container class="md-calendar-scroll-container" ' +
              'md-offset-size="' + (TBODY_SINGLE_ROW_HEIGHT - TBODY_HEIGHT) + '">' +
            '<table role="grid" tabindex="0" class="md-calendar" aria-readonly="true">' +
              '<tbody ' +
                  'md-calendar-month-body ' +
                  'role="rowgroup" ' +
                  'md-virtual-repeat="i in monthCtrl.items" ' +
                  'md-month-offset="$index" ' +
                  'class="md-calendar-month" ' +
                  'md-start-index="monthCtrl.getSelectedMonthIndex()" ' +
                  'md-item-size="' + TBODY_HEIGHT + '">' +

                // The <tr> ensures that the <tbody> will always have the
                // proper height, even if it's empty. If it's content is
                // compiled, the <tr> will be overwritten.
                '<tr aria-hidden="true" md-force-height="\'' + TBODY_HEIGHT + 'px\'"></tr>' +
              '</tbody>' +
            '</table>' +
          '</md-virtual-repeat-container>' +
        '</div>',
      require: ['^^mdCalendar', 'mdCalendarMonth'],
      controller: CalendarMonthCtrl,
      controllerAs: 'monthCtrl',
      bindToController: true,
      link: function(scope, element, attrs, controllers) {
        var calendarCtrl = controllers[0];
        var monthCtrl = controllers[1];
        monthCtrl.initialize(calendarCtrl);
      }
    };
  }

  /**
   * Controller for the calendar month component.
   * @ngInject @constructor
   */
  function CalendarMonthCtrl($element, $scope, $animate, $q,
    $$mdDateUtil, $mdDateLocale) {

    /** @final {!angular.JQLite} */
    this.$element = $element;

    /** @final {!angular.Scope} */
    this.$scope = $scope;

    /** @final {!angular.$animate} */
    this.$animate = $animate;

    /** @final {!angular.$q} */
    this.$q = $q;

    /** @final */
    this.dateUtil = $$mdDateUtil;

    /** @final */
    this.dateLocale = $mdDateLocale;

    /** @final {HTMLElement} */
    this.calendarScroller = $element[0].querySelector('.md-virtual-repeat-scroller');

    /** @type {boolean} */
    this.isInitialized = false;

    /** @type {boolean} */
    this.isMonthTransitionInProgress = false;

    var self = this;

    /**
     * Handles a click event on a date cell.
     * Created here so that every cell can use the same function instance.
     * @this {HTMLTableCellElement} The cell that was clicked.
     */
    this.cellClickHandler = function() {
      var timestamp = $$mdDateUtil.getTimestampFromNode(this);
      self.$scope.$apply(function() {
        // The timestamp has to be converted to a valid date.
        self.calendarCtrl.setNgModelValue(new Date(timestamp));
      });
    };

    /**
     * Handles click events on the month headers. Switches
     * the calendar to the year view.
     * @this {HTMLTableCellElement} The cell that was clicked.
     */
    this.headerClickHandler = function() {
      self.calendarCtrl.setCurrentView('year', $$mdDateUtil.getTimestampFromNode(this));
    };
  }

  /** Initialization **/

  /**
   * Initialize the controller by saving a reference to the calendar and
   * setting up the object that will be iterated by the virtual repeater.
   */
  CalendarMonthCtrl.prototype.initialize = function(calendarCtrl) {
    /**
     * Dummy array-like object for virtual-repeat to iterate over. The length is the total
     * number of months that can be viewed. We add 2 months: one to include the current month
     * and one for the last dummy month.
     *
     * This is shorter than ideal because of a (potential) Firefox bug
     * https://bugzilla.mozilla.org/show_bug.cgi?id=1181658.
     */

    this.items = {
      length: this.dateUtil.getMonthDistance(
        calendarCtrl.firstRenderableDate,
        calendarCtrl.lastRenderableDate
      ) + 2
    };

    this.calendarCtrl = calendarCtrl;
    this.attachScopeListeners();
    calendarCtrl.updateVirtualRepeat();

    // Fire the initial render, since we might have missed it the first time it fired.
    calendarCtrl.ngModelCtrl && calendarCtrl.ngModelCtrl.$render();
  };

  /**
   * Gets the "index" of the currently selected date as it would be in the virtual-repeat.
   * @returns {number} the "index" of the currently selected date
   */
  CalendarMonthCtrl.prototype.getSelectedMonthIndex = function() {
    var calendarCtrl = this.calendarCtrl;

    return this.dateUtil.getMonthDistance(
      calendarCtrl.firstRenderableDate,
      calendarCtrl.displayDate || calendarCtrl.selectedDate || calendarCtrl.today
    );
  };

  /**
   * Change the date that is being shown in the calendar. If the given date is in a different
   * month, the displayed month will be transitioned.
   * @param {Date} date
   */
  CalendarMonthCtrl.prototype.changeDisplayDate = function(date) {
    // Initialization is deferred until this function is called because we want to reflect
    // the starting value of ngModel.
    if (!this.isInitialized) {
      this.buildWeekHeader();
      this.calendarCtrl.hideVerticalScrollbar(this);
      this.isInitialized = true;
      return this.$q.when();
    }

    // If trying to show an invalid date or a transition is in progress, do nothing.
    if (!this.dateUtil.isValidDate(date) || this.isMonthTransitionInProgress) {
      return this.$q.when();
    }

    this.isMonthTransitionInProgress = true;
    var animationPromise = this.animateDateChange(date);

    this.calendarCtrl.displayDate = date;

    var self = this;
    animationPromise.then(function() {
      self.isMonthTransitionInProgress = false;
    });

    return animationPromise;
  };

  /**
   * Animates the transition from the calendar's current month to the given month.
   * @param {Date} date
   * @returns {angular.$q.Promise} The animation promise.
   */
  CalendarMonthCtrl.prototype.animateDateChange = function(date) {
    if (this.dateUtil.isValidDate(date)) {
      var monthDistance = this.dateUtil.getMonthDistance(this.calendarCtrl.firstRenderableDate, date);
      this.calendarScroller.scrollTop = monthDistance * TBODY_HEIGHT;
    }

    return this.$q.when();
  };

  /**
   * Builds and appends a day-of-the-week header to the calendar.
   * This should only need to be called once during initialization.
   */
  CalendarMonthCtrl.prototype.buildWeekHeader = function() {
    var firstDayOfWeek = this.dateLocale.firstDayOfWeek;
    var shortDays = this.dateLocale.shortDays;

    var row = document.createElement('tr');
    for (var i = 0; i < 7; i++) {
      var th = document.createElement('th');
      th.textContent = shortDays[(i + firstDayOfWeek) % 7];
      row.appendChild(th);
    }

    this.$element.find('thead').append(row);
  };

  /**
   * Attaches listeners for the scope events that are broadcast by the calendar.
   */
  CalendarMonthCtrl.prototype.attachScopeListeners = function() {
    var self = this;

    self.$scope.$on('md-calendar-parent-changed', function(event, value) {
      self.calendarCtrl.changeSelectedDate(value);
      self.changeDisplayDate(value);
    });

    self.$scope.$on('md-calendar-parent-action', angular.bind(this, this.handleKeyEvent));
  };

  /**
   * Handles the month-specific keyboard interactions.
   * @param {Object} event Scope event object passed by the calendar.
   * @param {String} action Action, corresponding to the key that was pressed.
   */
  CalendarMonthCtrl.prototype.handleKeyEvent = function(event, action) {
    var calendarCtrl = this.calendarCtrl;
    var displayDate = calendarCtrl.displayDate;

    if (action === 'select') {
      calendarCtrl.setNgModelValue(displayDate);
    } else {
      var date = null;
      var dateUtil = this.dateUtil;

      switch (action) {
        case 'move-right': date = dateUtil.incrementDays(displayDate, 1); break;
        case 'move-left': date = dateUtil.incrementDays(displayDate, -1); break;

        case 'move-page-down': date = dateUtil.incrementMonths(displayDate, 1); break;
        case 'move-page-up': date = dateUtil.incrementMonths(displayDate, -1); break;

        case 'move-row-down': date = dateUtil.incrementDays(displayDate, 7); break;
        case 'move-row-up': date = dateUtil.incrementDays(displayDate, -7); break;

        case 'start': date = dateUtil.getFirstDateOfMonth(displayDate); break;
        case 'end': date = dateUtil.getLastDateOfMonth(displayDate); break;
      }

      if (date) {
        date = this.dateUtil.clampDate(date, calendarCtrl.minDate, calendarCtrl.maxDate);

        this.changeDisplayDate(date).then(function() {
          calendarCtrl.focusDate(date);
        });
      }
    }
  };
})();

})();
(function(){
"use strict";

(function() {
  'use strict';

  mdCalendarMonthBodyDirective.$inject = ["$compile", "$$mdSvgRegistry"];
  CalendarMonthBodyCtrl.$inject = ["$element", "$$mdDateUtil", "$mdDateLocale"];
  angular.module('material.components.datepicker')
      .directive('mdCalendarMonthBody', mdCalendarMonthBodyDirective);

  /**
   * Private directive consumed by md-calendar-month. Having this directive lets the calender use
   * md-virtual-repeat and also cleanly separates the month DOM construction functions from
   * the rest of the calendar controller logic.
   * @ngInject
   */
  function mdCalendarMonthBodyDirective($compile, $$mdSvgRegistry) {
    var ARROW_ICON = $compile('<md-icon md-svg-src="' +
      $$mdSvgRegistry.mdTabsArrow + '"></md-icon>')({})[0];

    return {
      require: ['^^mdCalendar', '^^mdCalendarMonth', 'mdCalendarMonthBody'],
      scope: { offset: '=mdMonthOffset' },
      controller: CalendarMonthBodyCtrl,
      controllerAs: 'mdMonthBodyCtrl',
      bindToController: true,
      link: function(scope, element, attrs, controllers) {
        var calendarCtrl = controllers[0];
        var monthCtrl = controllers[1];
        var monthBodyCtrl = controllers[2];

        monthBodyCtrl.calendarCtrl = calendarCtrl;
        monthBodyCtrl.monthCtrl = monthCtrl;
        monthBodyCtrl.arrowIcon = ARROW_ICON.cloneNode(true);

        // The virtual-repeat re-uses the same DOM elements, so there are only a limited number
        // of repeated items that are linked, and then those elements have their bindings updated.
        // Since the months are not generated by bindings, we simply regenerate the entire thing
        // when the binding (offset) changes.
        scope.$watch(function() { return monthBodyCtrl.offset; }, function(offset) {
          if (angular.isNumber(offset)) {
            monthBodyCtrl.generateContent();
          }
        });
      }
    };
  }

  /**
   * Controller for a single calendar month.
   * @ngInject @constructor
   */
  function CalendarMonthBodyCtrl($element, $$mdDateUtil, $mdDateLocale) {
    /**
     * @final
     * @type {!JQLite}
     */
    this.$element = $element;

    /** @final */
    this.dateUtil = $$mdDateUtil;

    /** @final */
    this.dateLocale = $mdDateLocale;

    /** @type {Object} Reference to the month view. */
    this.monthCtrl = null;

    /** @type {Object} Reference to the calendar. */
    this.calendarCtrl = null;

    /**
     * Number of months from the start of the month "items" that the currently rendered month
     * occurs. Set via angular data binding.
     * @type {number|null}
     */
    this.offset = null;

    /**
     * Date cell to focus after appending the month to the document.
     * @type {HTMLElement}
     */
    this.focusAfterAppend = null;
  }

  /** Generate and append the content for this month to the directive element. */
  CalendarMonthBodyCtrl.prototype.generateContent = function() {
    var date = this.dateUtil.incrementMonths(this.calendarCtrl.firstRenderableDate, this.offset);

    this.$element
      .empty()
      .append(this.buildCalendarForMonth(date));

    if (this.focusAfterAppend) {
      this.focusAfterAppend.classList.add(this.calendarCtrl.FOCUSED_DATE_CLASS);
      this.focusAfterAppend = null;
    }
  };

  /**
   * Creates a single cell to contain a date in the calendar with all appropriate
   * attributes and classes added. If a date is given, the cell content will be set
   * based on the date.
   * @param {Date=} opt_date
   * @returns {HTMLElement}
   */
  CalendarMonthBodyCtrl.prototype.buildDateCell = function(opt_date) {
    var monthCtrl = this.monthCtrl;
    var calendarCtrl = this.calendarCtrl;

    // TODO(jelbourn): cloneNode is likely a faster way of doing this.
    var cell = document.createElement('td');
    cell.tabIndex = -1;
    cell.classList.add('md-calendar-date');
    cell.setAttribute('role', 'gridcell');

    if (opt_date) {
      cell.setAttribute('tabindex', '-1');
      cell.setAttribute('aria-label', this.dateLocale.longDateFormatter(opt_date));
      cell.id = calendarCtrl.getDateId(opt_date, 'month');

      // Use `data-timestamp` attribute because IE10 does not support the `dataset` property.
      cell.setAttribute('data-timestamp', opt_date.getTime());

      // TODO(jelourn): Doing these comparisons for class addition during generation might be slow.
      // It may be better to finish the construction and then query the node and add the class.
      if (this.dateUtil.isSameDay(opt_date, calendarCtrl.today)) {
        cell.classList.add(calendarCtrl.TODAY_CLASS);
      }

      if (this.dateUtil.isValidDate(calendarCtrl.selectedDate) &&
          this.dateUtil.isSameDay(opt_date, calendarCtrl.selectedDate)) {
        cell.classList.add(calendarCtrl.SELECTED_DATE_CLASS);
        cell.setAttribute('aria-selected', 'true');
      }

      var cellText = this.dateLocale.dates[opt_date.getDate()];

      if (this.isDateEnabled(opt_date)) {
        // Add a indicator for select, hover, and focus states.
        var selectionIndicator = document.createElement('span');
        selectionIndicator.classList.add('md-calendar-date-selection-indicator');
        selectionIndicator.textContent = cellText;
        cell.appendChild(selectionIndicator);
        cell.addEventListener('click', monthCtrl.cellClickHandler);

        if (calendarCtrl.displayDate && this.dateUtil.isSameDay(opt_date, calendarCtrl.displayDate)) {
          this.focusAfterAppend = cell;
        }
      } else {
        cell.classList.add('md-calendar-date-disabled');
        cell.textContent = cellText;
      }
    }

    return cell;
  };

  /**
   * Check whether date is in range and enabled
   * @param {Date=} opt_date
   * @return {boolean} Whether the date is enabled.
   */
  CalendarMonthBodyCtrl.prototype.isDateEnabled = function(opt_date) {
    return this.dateUtil.isDateWithinRange(opt_date,
          this.calendarCtrl.minDate, this.calendarCtrl.maxDate) &&
          (!angular.isFunction(this.calendarCtrl.dateFilter)
           || this.calendarCtrl.dateFilter(opt_date));
  };

  /**
   * Builds a `tr` element for the calendar grid.
   * @param rowNumber The week number within the month.
   * @returns {HTMLElement}
   */
  CalendarMonthBodyCtrl.prototype.buildDateRow = function(rowNumber) {
    var row = document.createElement('tr');
    row.setAttribute('role', 'row');

    // Because of an NVDA bug (with Firefox), the row needs an aria-label in order
    // to prevent the entire row being read aloud when the user moves between rows.
    // See http://community.nvda-project.org/ticket/4643.
    row.setAttribute('aria-label', this.dateLocale.weekNumberFormatter(rowNumber));

    return row;
  };

  /**
   * Builds the <tbody> content for the given date's month.
   * @param {Date=} opt_dateInMonth
   * @returns {DocumentFragment} A document fragment containing the <tr> elements.
   */
  CalendarMonthBodyCtrl.prototype.buildCalendarForMonth = function(opt_dateInMonth) {
    var date = this.dateUtil.isValidDate(opt_dateInMonth) ? opt_dateInMonth : new Date();

    var firstDayOfMonth = this.dateUtil.getFirstDateOfMonth(date);
    var firstDayOfTheWeek = this.getLocaleDay_(firstDayOfMonth);
    var numberOfDaysInMonth = this.dateUtil.getNumberOfDaysInMonth(date);

    // Store rows for the month in a document fragment so that we can append them all at once.
    var monthBody = document.createDocumentFragment();

    var rowNumber = 1;
    var row = this.buildDateRow(rowNumber);
    monthBody.appendChild(row);

    // If this is the final month in the list of items, only the first week should render,
    // so we should return immediately after the first row is complete and has been
    // attached to the body.
    var isFinalMonth = this.offset === this.monthCtrl.items.length - 1;

    // Add a label for the month. If the month starts on a Sun/Mon/Tues, the month label
    // goes on a row above the first of the month. Otherwise, the month label takes up the first
    // two cells of the first row.
    var blankCellOffset = 0;
    var monthLabelCell = document.createElement('td');
    var monthLabelCellContent = document.createElement('span');
    var calendarCtrl = this.calendarCtrl;

    monthLabelCellContent.textContent = this.dateLocale.monthHeaderFormatter(date);
    monthLabelCell.appendChild(monthLabelCellContent);
    monthLabelCell.classList.add('md-calendar-month-label');
    // If the entire month is after the max date, render the label as a disabled state.
    if (calendarCtrl.maxDate && firstDayOfMonth > calendarCtrl.maxDate) {
      monthLabelCell.classList.add('md-calendar-month-label-disabled');
    // If the user isn't supposed to be able to change views, render the
    // label as usual, but disable the clicking functionality.
    } else if (!calendarCtrl.mode) {
      monthLabelCell.addEventListener('click', this.monthCtrl.headerClickHandler);
      monthLabelCell.setAttribute('data-timestamp', firstDayOfMonth.getTime());
      monthLabelCell.setAttribute('aria-label', this.dateLocale.monthFormatter(date));
      monthLabelCell.classList.add('md-calendar-label-clickable');
      monthLabelCell.appendChild(this.arrowIcon.cloneNode(true));
    }

    if (firstDayOfTheWeek <= 2) {
      monthLabelCell.setAttribute('colspan', '7');

      var monthLabelRow = this.buildDateRow();
      monthLabelRow.appendChild(monthLabelCell);
      monthBody.insertBefore(monthLabelRow, row);

      if (isFinalMonth) {
        return monthBody;
      }
    } else {
      blankCellOffset = 3;
      monthLabelCell.setAttribute('colspan', '3');
      row.appendChild(monthLabelCell);
    }

    // Add a blank cell for each day of the week that occurs before the first of the month.
    // For example, if the first day of the month is a Tuesday, add blank cells for Sun and Mon.
    // The blankCellOffset is needed in cases where the first N cells are used by the month label.
    for (var i = blankCellOffset; i < firstDayOfTheWeek; i++) {
      row.appendChild(this.buildDateCell());
    }

    // Add a cell for each day of the month, keeping track of the day of the week so that
    // we know when to start a new row.
    var dayOfWeek = firstDayOfTheWeek;
    var iterationDate = firstDayOfMonth;
    for (var d = 1; d <= numberOfDaysInMonth; d++) {
      // If we've reached the end of the week, start a new row.
      if (dayOfWeek === 7) {
        // We've finished the first row, so we're done if this is the final month.
        if (isFinalMonth) {
          return monthBody;
        }
        dayOfWeek = 0;
        rowNumber++;
        row = this.buildDateRow(rowNumber);
        monthBody.appendChild(row);
      }

      iterationDate.setDate(d);
      var cell = this.buildDateCell(iterationDate);
      row.appendChild(cell);

      dayOfWeek++;
    }

    // Ensure that the last row of the month has 7 cells.
    while (row.childNodes.length < 7) {
      row.appendChild(this.buildDateCell());
    }

    // Ensure that all months have 6 rows. This is necessary for now because the virtual-repeat
    // requires that all items have exactly the same height.
    while (monthBody.childNodes.length < 6) {
      var whitespaceRow = this.buildDateRow();
      for (var j = 0; j < 7; j++) {
        whitespaceRow.appendChild(this.buildDateCell());
      }
      monthBody.appendChild(whitespaceRow);
    }

    return monthBody;
  };

  /**
   * Gets the day-of-the-week index for a date for the current locale.
   * @private
   * @param {Date} date
   * @returns {number} The column index of the date in the calendar.
   */
  CalendarMonthBodyCtrl.prototype.getLocaleDay_ = function(date) {
    return (date.getDay() + (7 - this.dateLocale.firstDayOfWeek)) % 7;
  };
})();

})();
(function(){
"use strict";

(function() {
  'use strict';

  CalendarYearCtrl.$inject = ["$element", "$scope", "$animate", "$q", "$$mdDateUtil", "$mdUtil"];
  angular.module('material.components.datepicker')
    .directive('mdCalendarYear', calendarDirective);

  /**
   * Height of one calendar year tbody. This must be made known to the virtual-repeat and is
   * subsequently used for scrolling to specific years.
   */
  var TBODY_HEIGHT = 88;

  /** Private component, representing a list of years in the calendar. */
  function calendarDirective() {
    return {
      template:
        '<div class="md-calendar-scroll-mask">' +
          '<md-virtual-repeat-container class="md-calendar-scroll-container">' +
            '<table role="grid" tabindex="0" class="md-calendar" aria-readonly="true">' +
              '<tbody ' +
                  'md-calendar-year-body ' +
                  'role="rowgroup" ' +
                  'md-virtual-repeat="i in yearCtrl.items" ' +
                  'md-year-offset="$index" class="md-calendar-year" ' +
                  'md-start-index="yearCtrl.getFocusedYearIndex()" ' +
                  'md-item-size="' + TBODY_HEIGHT + '">' +
                // The <tr> ensures that the <tbody> will have the proper
                // height, even though it may be empty.
                '<tr aria-hidden="true" md-force-height="\'' + TBODY_HEIGHT + 'px\'"></tr>' +
              '</tbody>' +
            '</table>' +
          '</md-virtual-repeat-container>' +
        '</div>',
      require: ['^^mdCalendar', 'mdCalendarYear'],
      controller: CalendarYearCtrl,
      controllerAs: 'yearCtrl',
      bindToController: true,
      link: function(scope, element, attrs, controllers) {
        var calendarCtrl = controllers[0];
        var yearCtrl = controllers[1];
        yearCtrl.initialize(calendarCtrl);
      }
    };
  }

  /**
   * Controller for the mdCalendar component.
   * @ngInject @constructor
   */
  function CalendarYearCtrl($element, $scope, $animate, $q, $$mdDateUtil, $mdUtil) {

    /** @final {!angular.JQLite} */
    this.$element = $element;

    /** @final {!angular.Scope} */
    this.$scope = $scope;

    /** @final {!angular.$animate} */
    this.$animate = $animate;

    /** @final {!angular.$q} */
    this.$q = $q;

    /** @final */
    this.dateUtil = $$mdDateUtil;

    /** @final {HTMLElement} */
    this.calendarScroller = $element[0].querySelector('.md-virtual-repeat-scroller');

    /** @type {boolean} */
    this.isInitialized = false;

    /** @type {boolean} */
    this.isMonthTransitionInProgress = false;

    /** @final */
    this.$mdUtil = $mdUtil;

    var self = this;

    /**
     * Handles a click event on a date cell.
     * Created here so that every cell can use the same function instance.
     * @this {HTMLTableCellElement} The cell that was clicked.
     */
    this.cellClickHandler = function() {
      self.onTimestampSelected($$mdDateUtil.getTimestampFromNode(this));
    };
  }

  /**
   * Initialize the controller by saving a reference to the calendar and
   * setting up the object that will be iterated by the virtual repeater.
   */
  CalendarYearCtrl.prototype.initialize = function(calendarCtrl) {
    /**
     * Dummy array-like object for virtual-repeat to iterate over. The length is the total
     * number of years that can be viewed. We add 1 extra in order to include the current year.
     */

    this.items = {
      length: this.dateUtil.getYearDistance(
        calendarCtrl.firstRenderableDate,
        calendarCtrl.lastRenderableDate
      ) + 1
    };

    this.calendarCtrl = calendarCtrl;
    this.attachScopeListeners();
    calendarCtrl.updateVirtualRepeat();

    // Fire the initial render, since we might have missed it the first time it fired.
    calendarCtrl.ngModelCtrl && calendarCtrl.ngModelCtrl.$render();
  };

  /**
   * Gets the "index" of the currently selected date as it would be in the virtual-repeat.
   * @returns {number}
   */
  CalendarYearCtrl.prototype.getFocusedYearIndex = function() {
    var calendarCtrl = this.calendarCtrl;

    return this.dateUtil.getYearDistance(
      calendarCtrl.firstRenderableDate,
      calendarCtrl.displayDate || calendarCtrl.selectedDate || calendarCtrl.today
    );
  };

  /**
   * Change the date that is highlighted in the calendar.
   * @param {Date} date
   */
  CalendarYearCtrl.prototype.changeDate = function(date) {
    // Initialization is deferred until this function is called because we want to reflect
    // the starting value of ngModel.
    if (!this.isInitialized) {
      this.calendarCtrl.hideVerticalScrollbar(this);
      this.isInitialized = true;
      return this.$q.when();
    } else if (this.dateUtil.isValidDate(date) && !this.isMonthTransitionInProgress) {
      var self = this;
      var animationPromise = this.animateDateChange(date);

      self.isMonthTransitionInProgress = true;
      self.calendarCtrl.displayDate = date;

      return animationPromise.then(function() {
        self.isMonthTransitionInProgress = false;
      });
    }
  };

  /**
   * Animates the transition from the calendar's current month to the given month.
   * @param {Date} date
   * @returns {angular.$q.Promise} The animation promise.
   */
  CalendarYearCtrl.prototype.animateDateChange = function(date) {
    if (this.dateUtil.isValidDate(date)) {
      var monthDistance = this.dateUtil.getYearDistance(this.calendarCtrl.firstRenderableDate, date);
      this.calendarScroller.scrollTop = monthDistance * TBODY_HEIGHT;
    }

    return this.$q.when();
  };

  /**
   * Handles the year-view-specific keyboard interactions.
   * @param {Object} event Scope event object passed by the calendar.
   * @param {String} action Action, corresponding to the key that was pressed.
   */
  CalendarYearCtrl.prototype.handleKeyEvent = function(event, action) {
    var self = this;
    var calendarCtrl = self.calendarCtrl;
    var displayDate = calendarCtrl.displayDate;

    if (action === 'select') {
      self.changeDate(displayDate).then(function() {
        self.onTimestampSelected(displayDate);
      });
    } else {
      var date = null;
      var dateUtil = self.dateUtil;

      switch (action) {
        case 'move-right': date = dateUtil.incrementMonths(displayDate, 1); break;
        case 'move-left': date = dateUtil.incrementMonths(displayDate, -1); break;

        case 'move-row-down': date = dateUtil.incrementMonths(displayDate, 6); break;
        case 'move-row-up': date = dateUtil.incrementMonths(displayDate, -6); break;
      }

      if (date) {
        var min = calendarCtrl.minDate ? dateUtil.getFirstDateOfMonth(calendarCtrl.minDate) : null;
        var max = calendarCtrl.maxDate ? dateUtil.getFirstDateOfMonth(calendarCtrl.maxDate) : null;
        date = dateUtil.getFirstDateOfMonth(self.dateUtil.clampDate(date, min, max));

        self.changeDate(date).then(function() {
          calendarCtrl.focusDate(date);
        });
      }
    }
  };

  /**
   * Attaches listeners for the scope events that are broadcast by the calendar.
   */
  CalendarYearCtrl.prototype.attachScopeListeners = function() {
    var self = this;

    self.$scope.$on('md-calendar-parent-changed', function(event, value) {
      self.calendarCtrl.changeSelectedDate(value ? self.dateUtil.getFirstDateOfMonth(value) : value);
      self.changeDate(value);
    });

    self.$scope.$on('md-calendar-parent-action', angular.bind(self, self.handleKeyEvent));
  };

  /**
   * Handles the behavior when a date is selected. Depending on the `mode`
   * of the calendar, this can either switch back to the calendar view or
   * set the model value.
   * @param {number} timestamp The selected timestamp.
   */
  CalendarYearCtrl.prototype.onTimestampSelected = function(timestamp) {
    var calendarCtrl = this.calendarCtrl;

    if (calendarCtrl.mode) {
      this.$mdUtil.nextTick(function() {
        // The timestamp has to be converted to a valid date.
        calendarCtrl.setNgModelValue(new Date(timestamp));
      });
    } else {
      calendarCtrl.setCurrentView('month', timestamp);
    }
  };
})();

})();
(function(){
"use strict";

(function() {
  'use strict';

  CalendarYearBodyCtrl.$inject = ["$element", "$$mdDateUtil", "$mdDateLocale"];
  angular.module('material.components.datepicker')
      .directive('mdCalendarYearBody', mdCalendarYearDirective);

  /**
   * Private component, consumed by the md-calendar-year, which separates the DOM construction logic
   * and allows for the year view to use md-virtual-repeat.
   */
  function mdCalendarYearDirective() {
    return {
      require: ['^^mdCalendar', '^^mdCalendarYear', 'mdCalendarYearBody'],
      scope: { offset: '=mdYearOffset' },
      controller: CalendarYearBodyCtrl,
      controllerAs: 'mdYearBodyCtrl',
      bindToController: true,
      link: function(scope, element, attrs, controllers) {
        var calendarCtrl = controllers[0];
        var yearCtrl = controllers[1];
        var yearBodyCtrl = controllers[2];

        yearBodyCtrl.calendarCtrl = calendarCtrl;
        yearBodyCtrl.yearCtrl = yearCtrl;

        scope.$watch(function() { return yearBodyCtrl.offset; }, function(offset) {
          if (angular.isNumber(offset)) {
            yearBodyCtrl.generateContent();
          }
        });
      }
    };
  }

  /**
   * Controller for a single year.
   * @ngInject @constructor
   */
  function CalendarYearBodyCtrl($element, $$mdDateUtil, $mdDateLocale) {
    /**
     * @final
     * @type {!JQLite}
     */
    this.$element = $element;

    /** @final */
    this.dateUtil = $$mdDateUtil;

    /** @final */
    this.dateLocale = $mdDateLocale;

    /** @type {Object} Reference to the calendar. */
    this.calendarCtrl = null;

    /** @type {Object} Reference to the year view. */
    this.yearCtrl = null;

    /**
     * Number of months from the start of the month "items" that the currently rendered month
     * occurs. Set via angular data binding.
     * @type {number|null}
     */
    this.offset = null;

    /**
     * Date cell to focus after appending the month to the document.
     * @type {HTMLElement}
     */
    this.focusAfterAppend = null;
  }

  /** Generate and append the content for this year to the directive element. */
  CalendarYearBodyCtrl.prototype.generateContent = function() {
    var date = this.dateUtil.incrementYears(this.calendarCtrl.firstRenderableDate, this.offset);

    this.$element
      .empty()
      .append(this.buildCalendarForYear(date));

    if (this.focusAfterAppend) {
      this.focusAfterAppend.classList.add(this.calendarCtrl.FOCUSED_DATE_CLASS);
      this.focusAfterAppend = null;
    }
  };

  /**
   * Creates a single cell to contain a year in the calendar.
   * @param {number} year Four-digit year.
   * @param {number} month Zero-indexed month.
   * @returns {HTMLElement}
   */
  CalendarYearBodyCtrl.prototype.buildMonthCell = function(year, month) {
    var calendarCtrl = this.calendarCtrl;
    var yearCtrl = this.yearCtrl;
    var cell = this.buildBlankCell();

    // Represent this month/year as a date.
    var firstOfMonth = new Date(year, month, 1);
    cell.setAttribute('aria-label', this.dateLocale.monthFormatter(firstOfMonth));
    cell.id = calendarCtrl.getDateId(firstOfMonth, 'year');

    // Use `data-timestamp` attribute because IE10 does not support the `dataset` property.
    cell.setAttribute('data-timestamp', String(firstOfMonth.getTime()));

    if (this.dateUtil.isSameMonthAndYear(firstOfMonth, calendarCtrl.today)) {
      cell.classList.add(calendarCtrl.TODAY_CLASS);
    }

    if (this.dateUtil.isValidDate(calendarCtrl.selectedDate) &&
        this.dateUtil.isSameMonthAndYear(firstOfMonth, calendarCtrl.selectedDate)) {
      cell.classList.add(calendarCtrl.SELECTED_DATE_CLASS);
      cell.setAttribute('aria-selected', 'true');
    }

    var cellText = this.dateLocale.shortMonths[month];

    if (this.dateUtil.isMonthWithinRange(
          firstOfMonth, calendarCtrl.minDate, calendarCtrl.maxDate) &&
      (!angular.isFunction(calendarCtrl.monthFilter) ||
        calendarCtrl.monthFilter(firstOfMonth))) {
      var selectionIndicator = document.createElement('span');
      selectionIndicator.classList.add('md-calendar-date-selection-indicator');
      selectionIndicator.textContent = cellText;
      cell.appendChild(selectionIndicator);
      cell.addEventListener('click', yearCtrl.cellClickHandler);

      if (calendarCtrl.displayDate &&
          this.dateUtil.isSameMonthAndYear(firstOfMonth, calendarCtrl.displayDate)) {
        this.focusAfterAppend = cell;
      }
    } else {
      cell.classList.add('md-calendar-date-disabled');
      cell.textContent = cellText;
    }

    return cell;
  };

  /**
   * Builds a blank cell.
   * @return {HTMLElement}
   */
  CalendarYearBodyCtrl.prototype.buildBlankCell = function() {
    var cell = document.createElement('td');
    cell.tabIndex = -1;
    cell.classList.add('md-calendar-date');
    cell.setAttribute('role', 'gridcell');

    cell.setAttribute('tabindex', '-1');
    return cell;
  };

  /**
   * Builds the <tbody> content for the given year.
   * @param {Date} date Date for which the content should be built.
   * @returns {DocumentFragment} A document fragment containing the months within the year.
   */
  CalendarYearBodyCtrl.prototype.buildCalendarForYear = function(date) {
    // Store rows for the month in a document fragment so that we can append them all at once.
    var year = date.getFullYear();
    var yearBody = document.createDocumentFragment();

    var monthCell, i;
    // First row contains label and Jan-Jun.
    var firstRow = document.createElement('tr');
    var labelCell = document.createElement('td');
    labelCell.className = 'md-calendar-month-label';
    labelCell.textContent = String(year);
    firstRow.appendChild(labelCell);

    for (i = 0; i < 6; i++) {
      firstRow.appendChild(this.buildMonthCell(year, i));
    }
    yearBody.appendChild(firstRow);

    // Second row contains a blank cell and Jul-Dec.
    var secondRow = document.createElement('tr');
    secondRow.appendChild(this.buildBlankCell());
    for (i = 6; i < 12; i++) {
      secondRow.appendChild(this.buildMonthCell(year, i));
    }
    yearBody.appendChild(secondRow);

    return yearBody;
  };
})();

})();
(function(){
"use strict";

(function() {
  'use strict';

  /**
   * @ngdoc service
   * @name $mdDateLocaleProvider
   * @module material.components.datepicker
   *
   * @description
   * The `$mdDateLocaleProvider` is the provider that creates the `$mdDateLocale` service.
   * This provider that allows the user to specify messages, formatters, and parsers for date
   * internationalization. The `$mdDateLocale` service itself is consumed by AngularJS Material
   * components that deal with dates
   * (i.e. <a ng-href="api/directive/mdDatepicker">mdDatepicker</a>).
   *
   * @property {Array<string>} months Array of month names (in order).
   * @property {Array<string>} shortMonths Array of abbreviated month names.
   * @property {Array<string>} days Array of the days of the week (in order).
   * @property {Array<string>} shortDays Array of abbreviated days of the week.
   * @property {Array<string>} dates Array of dates of the month. Only necessary for locales
   *  using a numeral system other than [1, 2, 3...].
   * @property {Array<string>} firstDayOfWeek The first day of the week. Sunday = 0, Monday = 1,
   *  etc.
   * @property {function(string): Date} parseDate Function that converts a date string to a Date
   *  object (the date portion).
   * @property {function(Date, string): string} formatDate Function to format a date object to a
   *  string. The datepicker directive also provides the time zone, if it was specified.
   * @property {function(Date): string} monthHeaderFormatter Function that returns the label for
   *  a month given a date.
   * @property {function(Date): string} monthFormatter Function that returns the full name of a month
   *  for a given date.
   * @property {function(number): string} weekNumberFormatter Function that returns a label for
   *  a week given the week number.
   * @property {function(Date): string} longDateFormatter Function that formats a date into a long
   *  `aria-label` that is read by the screen reader when the focused date changes.
   * @property {string} msgCalendar Translation of the label "Calendar" for the current locale.
   * @property {string} msgOpenCalendar Translation of the button label "Open calendar" for the
   *  current locale.
   * @property {Date} firstRenderableDate The date from which the datepicker calendar will begin
   *  rendering. Note that this will be ignored if a minimum date is set.
   *  Defaults to January 1st 1880.
   * @property {Date} lastRenderableDate The last date that will be rendered by the datepicker
   *  calendar. Note that this will be ignored if a maximum date is set.
   *  Defaults to January 1st 2130.
   * @property {function(string): boolean} isDateComplete Function to determine whether a string
   *  makes sense to be parsed to a `Date` object. Returns `true` if the date appears to be complete
   *  and parsing should occur. By default, this checks for 3 groups of text or numbers separated
   *  by delimiters. This means that by default, date strings must include a month, day, and year
   *  to be parsed and for the model to be updated.
   *
   * @usage
   * <hljs lang="js">
   * myAppModule.config(function($mdDateLocaleProvider) {
   *
   *     // Example of a French localization.
   *     $mdDateLocaleProvider.months = ['janvier', 'février', 'mars', ...];
   *     $mdDateLocaleProvider.shortMonths = ['janv', 'févr', 'mars', ...];
   *     $mdDateLocaleProvider.days = ['dimanche', 'lundi', 'mardi', ...];
   *     $mdDateLocaleProvider.shortDays = ['Di', 'Lu', 'Ma', ...];
   *
   *     // Can change week display to start on Monday.
   *     $mdDateLocaleProvider.firstDayOfWeek = 1;
   *
   *     // Optional.
   *     $mdDateLocaleProvider.dates = [1, 2, 3, 4, 5, 6, ...];
   *
   *     // Example uses moment.js to parse and format dates.
   *     $mdDateLocaleProvider.parseDate = function(dateString) {
   *       var m = moment(dateString, 'L', true);
   *       return m.isValid() ? m.toDate() : new Date(NaN);
   *     };
   *
   *     $mdDateLocaleProvider.formatDate = function(date) {
   *       var m = moment(date);
   *       return m.isValid() ? m.format('L') : '';
   *     };
   *
   *     // Allow only a day and month to be specified.
   *     // This is required if using the 'M/D' format with moment.js.
   *     $mdDateLocaleProvider.isDateComplete = function(dateString) {
   *       dateString = dateString.trim();
   *
   *       // Look for two chunks of content (either numbers or text) separated by delimiters.
   *       var re = /^(([a-zA-Z]{3,}|[0-9]{1,4})([ .,]+|[/-]))([a-zA-Z]{3,}|[0-9]{1,4})/;
   *       return re.test(dateString);
   *     };
   *
   *     $mdDateLocaleProvider.monthHeaderFormatter = function(date) {
   *       return myShortMonths[date.getMonth()] + ' ' + date.getFullYear();
   *     };
   *
   *     // In addition to date display, date components also need localized messages
   *     // for aria-labels for screen-reader users.
   *
   *     $mdDateLocaleProvider.weekNumberFormatter = function(weekNumber) {
   *       return 'Semaine ' + weekNumber;
   *     };
   *
   *     $mdDateLocaleProvider.msgCalendar = 'Calendrier';
   *     $mdDateLocaleProvider.msgOpenCalendar = 'Ouvrir le calendrier';
   *
   *     // You can also set when your calendar begins and ends.
   *     $mdDateLocaleProvider.firstRenderableDate = new Date(1776, 6, 4);
   *     $mdDateLocaleProvider.lastRenderableDate = new Date(2012, 11, 21);
   * });
   * </hljs>
   *
   */
  angular.module('material.components.datepicker').config(["$provide", function($provide) {
    // TODO(jelbourn): Assert provided values are correctly formatted. Need assertions.

    /** @constructor */
    function DateLocaleProvider() {
      /** Array of full month names. E.g., ['January', 'February', ...] */
      this.months = null;

      /** Array of abbreviated month names. E.g., ['Jan', 'Feb', ...] */
      this.shortMonths = null;

      /** Array of full day of the week names. E.g., ['Monday', 'Tuesday', ...] */
      this.days = null;

      /** Array of abbreviated dat of the week names. E.g., ['M', 'T', ...] */
      this.shortDays = null;

      /** Array of dates of a month (1 - 31). Characters might be different in some locales. */
      this.dates = null;

      /** Index of the first day of the week. 0 = Sunday, 1 = Monday, etc. */
      this.firstDayOfWeek = 0;

      /**
       * Function that converts the date portion of a Date to a string.
       * @type {(function(Date): string)}
       */
      this.formatDate = null;

      /**
       * Function that converts a date string to a Date object (the date portion)
       * @type {function(string): Date}
       */
      this.parseDate = null;

      /**
       * Function that formats a Date into a month header string.
       * @type {function(Date): string}
       */
      this.monthHeaderFormatter = null;

      /**
       * Function that formats a week number into a label for the week.
       * @type {function(number): string}
       */
      this.weekNumberFormatter = null;

      /**
       * Function that formats a date into a long aria-label that is read
       * when the focused date changes.
       * @type {function(Date): string}
       */
      this.longDateFormatter = null;

      /**
       * Function to determine whether a string makes sense to be
       * parsed to a Date object.
       * @type {function(string): boolean}
       */
      this.isDateComplete = null;

      /**
       * ARIA label for the calendar "dialog" used in the datepicker.
       * @type {string}
       */
      this.msgCalendar = '';

      /**
       * ARIA label for the datepicker's "Open calendar" buttons.
       * @type {string}
       */
      this.msgOpenCalendar = '';
    }

    /**
     * Factory function that returns an instance of the dateLocale service.
     * @ngInject
     * @param $locale
     * @param $filter
     * @returns {DateLocale}
     */
    DateLocaleProvider.prototype.$get = function($locale, $filter) {
      /**
       * Default date-to-string formatting function.
       * @param {!Date} date
       * @param {string=} timezone
       * @returns {string}
       */
      function defaultFormatDate(date, timezone) {
        if (!date) {
          return '';
        }

        // All of the dates created through ng-material *should* be set to midnight.
        // If we encounter a date where the localeTime shows at 11pm instead of midnight,
        // we have run into an issue with DST where we need to increment the hour by one:
        // var d = new Date(1992, 9, 8, 0, 0, 0);
        // d.toLocaleString(); // == "10/7/1992, 11:00:00 PM"
        var localeTime = date.toLocaleTimeString();
        var formatDate = date;
        if (date.getHours() === 0 &&
            (localeTime.indexOf('11:') !== -1 || localeTime.indexOf('23:') !== -1)) {
          formatDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 1, 0, 0);
        }

        return $filter('date')(formatDate, 'M/d/yyyy', timezone);
      }

      /**
       * Default string-to-date parsing function.
       * @param {string|number} dateString
       * @returns {!Date}
       */
      function defaultParseDate(dateString) {
        return new Date(dateString);
      }

      /**
       * Default function to determine whether a string makes sense to be
       * parsed to a Date object.
       *
       * This is very permissive and is just a basic check to ensure that
       * things like single integers aren't able to be parsed into dates.
       * @param {string} dateString
       * @returns {boolean}
       */
      function defaultIsDateComplete(dateString) {
        dateString = dateString.trim();

        // Looks for three chunks of content (either numbers or text) separated
        // by delimiters.
        var re = /^(([a-zA-Z]{3,}|[0-9]{1,4})([ .,]+|[/-])){2}([a-zA-Z]{3,}|[0-9]{1,4})$/;
        return re.test(dateString);
      }

      /**
       * Default date-to-string formatter to get a month header.
       * @param {!Date} date
       * @returns {string}
       */
      function defaultMonthHeaderFormatter(date) {
        return service.shortMonths[date.getMonth()] + ' ' + date.getFullYear();
      }

      /**
       * Default formatter for a month.
       * @param {!Date} date
       * @returns {string}
       */
      function defaultMonthFormatter(date) {
        return service.months[date.getMonth()] + ' ' + date.getFullYear();
      }

      /**
       * Default week number formatter.
       * @param number
       * @returns {string}
       */
      function defaultWeekNumberFormatter(number) {
        return 'Week ' + number;
      }

      /**
       * Default formatter for date cell aria-labels.
       * @param {!Date} date
       * @returns {string}
       */
      function defaultLongDateFormatter(date) {
        // Example: 'Thursday June 18 2015'
        return [
          service.days[date.getDay()],
          service.months[date.getMonth()],
          service.dates[date.getDate()],
          date.getFullYear()
        ].join(' ');
      }

      // The default "short" day strings are the first character of each day,
      // e.g., "Monday" => "M".
      var defaultShortDays = $locale.DATETIME_FORMATS.SHORTDAY.map(function(day) {
        return day.substring(0, 1);
      });

      // The default dates are simply the numbers 1 through 31.
      var defaultDates = Array(32);
      for (var i = 1; i <= 31; i++) {
        defaultDates[i] = i;
      }

      // Default ARIA messages are in English (US).
      var defaultMsgCalendar = 'Calendar';
      var defaultMsgOpenCalendar = 'Open calendar';

      // Default start/end dates that are rendered in the calendar.
      var defaultFirstRenderableDate = new Date(1880, 0, 1);
      var defaultLastRendereableDate = new Date(defaultFirstRenderableDate.getFullYear() + 250, 0, 1);

      var service = {
        months: this.months || $locale.DATETIME_FORMATS.MONTH,
        shortMonths: this.shortMonths || $locale.DATETIME_FORMATS.SHORTMONTH,
        days: this.days || $locale.DATETIME_FORMATS.DAY,
        shortDays: this.shortDays || defaultShortDays,
        dates: this.dates || defaultDates,
        firstDayOfWeek: this.firstDayOfWeek || 0,
        formatDate: this.formatDate || defaultFormatDate,
        parseDate: this.parseDate || defaultParseDate,
        isDateComplete: this.isDateComplete || defaultIsDateComplete,
        monthHeaderFormatter: this.monthHeaderFormatter || defaultMonthHeaderFormatter,
        monthFormatter: this.monthFormatter || defaultMonthFormatter,
        weekNumberFormatter: this.weekNumberFormatter || defaultWeekNumberFormatter,
        longDateFormatter: this.longDateFormatter || defaultLongDateFormatter,
        msgCalendar: this.msgCalendar || defaultMsgCalendar,
        msgOpenCalendar: this.msgOpenCalendar || defaultMsgOpenCalendar,
        firstRenderableDate: this.firstRenderableDate || defaultFirstRenderableDate,
        lastRenderableDate: this.lastRenderableDate || defaultLastRendereableDate
      };

      return service;
    };
    DateLocaleProvider.prototype.$get.$inject = ["$locale", "$filter"];

    $provide.provider('$mdDateLocale', new DateLocaleProvider());
  }]);
})();

})();
(function(){
"use strict";

(function() {
  'use strict';

  /**
   * Utility for performing date calculations to facilitate operation of the calendar and
   * datepicker.
   */
  angular.module('material.components.datepicker').factory('$$mdDateUtil', ["$mdDateLocale", function($mdDateLocale) {
    return {
      getFirstDateOfMonth: getFirstDateOfMonth,
      getNumberOfDaysInMonth: getNumberOfDaysInMonth,
      getDateInNextMonth: getDateInNextMonth,
      getDateInPreviousMonth: getDateInPreviousMonth,
      isInNextMonth: isInNextMonth,
      isInPreviousMonth: isInPreviousMonth,
      getDateMidpoint: getDateMidpoint,
      isSameMonthAndYear: isSameMonthAndYear,
      getWeekOfMonth: getWeekOfMonth,
      incrementDays: incrementDays,
      incrementMonths: incrementMonths,
      getLastDateOfMonth: getLastDateOfMonth,
      isSameDay: isSameDay,
      getMonthDistance: getMonthDistance,
      isValidDate: isValidDate,
      setDateTimeToMidnight: setDateTimeToMidnight,
      createDateAtMidnight: createDateAtMidnight,
      isDateWithinRange: isDateWithinRange,
      incrementYears: incrementYears,
      getYearDistance: getYearDistance,
      clampDate: clampDate,
      getTimestampFromNode: getTimestampFromNode,
      isMonthWithinRange: isMonthWithinRange,
      removeLocalTzAndReparseDate: removeLocalTzAndReparseDate
    };

    /**
     * Gets the first day of the month for the given date's month.
     * @param {Date} date
     * @returns {Date}
     */
    function getFirstDateOfMonth(date) {
      return new Date(date.getFullYear(), date.getMonth(), 1);
    }

    /**
     * Gets the number of days in the month for the given date's month.
     * @param date
     * @returns {number}
     */
    function getNumberOfDaysInMonth(date) {
      return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    }

    /**
     * Get an arbitrary date in the month after the given date's month.
     * @param date
     * @returns {Date}
     */
    function getDateInNextMonth(date) {
      return new Date(date.getFullYear(), date.getMonth() + 1, 1);
    }

    /**
     * Get an arbitrary date in the month before the given date's month.
     * @param date
     * @returns {Date}
     */
    function getDateInPreviousMonth(date) {
      return new Date(date.getFullYear(), date.getMonth() - 1, 1);
    }

    /**
     * Gets whether two dates have the same month and year.
     * @param {Date} d1
     * @param {Date} d2
     * @returns {boolean}
     */
    function isSameMonthAndYear(d1, d2) {
      return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth();
    }

    /**
     * Gets whether two dates are the same day (not not necessarily the same time).
     * @param {Date} d1
     * @param {Date} d2
     * @returns {boolean}
     */
    function isSameDay(d1, d2) {
      return d1.getDate() == d2.getDate() && isSameMonthAndYear(d1, d2);
    }

    /**
     * Gets whether a date is in the month immediately after some date.
     * @param {Date} startDate The date from which to compare.
     * @param {Date} endDate The date to check.
     * @returns {boolean}
     */
    function isInNextMonth(startDate, endDate) {
      var nextMonth = getDateInNextMonth(startDate);
      return isSameMonthAndYear(nextMonth, endDate);
    }

    /**
     * Gets whether a date is in the month immediately before some date.
     * @param {Date} startDate The date from which to compare.
     * @param {Date} endDate The date to check.
     * @returns {boolean}
     */
    function isInPreviousMonth(startDate, endDate) {
      var previousMonth = getDateInPreviousMonth(startDate);
      return isSameMonthAndYear(endDate, previousMonth);
    }

    /**
     * Gets the midpoint between two dates.
     * @param {Date} d1
     * @param {Date} d2
     * @returns {Date}
     */
    function getDateMidpoint(d1, d2) {
      return createDateAtMidnight((d1.getTime() + d2.getTime()) / 2);
    }

    /**
     * Gets the week of the month that a given date occurs in.
     * @param {Date} date
     * @returns {number} Index of the week of the month (zero-based).
     */
    function getWeekOfMonth(date) {
      var firstDayOfMonth = getFirstDateOfMonth(date);
      return Math.floor((firstDayOfMonth.getDay() + date.getDate() - 1) / 7);
    }

    /**
     * Gets a new date incremented by the given number of days. Number of days can be negative.
     * @param {Date} date
     * @param {number} numberOfDays
     * @returns {Date}
     */
    function incrementDays(date, numberOfDays) {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate() + numberOfDays);
    }

    /**
     * Gets a new date incremented by the given number of months. Number of months can be negative.
     * If the date of the given month does not match the target month, the date will be set to the
     * last day of the month.
     * @param {Date} date
     * @param {number} numberOfMonths
     * @returns {Date}
     */
    function incrementMonths(date, numberOfMonths) {
      // If the same date in the target month does not actually exist, the Date object will
      // automatically advance *another* month by the number of missing days.
      // For example, if you try to go from Jan. 30 to Feb. 30, you'll end up on March 2.
      // So, we check if the month overflowed and go to the last day of the target month instead.
      var dateInTargetMonth = new Date(date.getFullYear(), date.getMonth() + numberOfMonths, 1);
      var numberOfDaysInMonth = getNumberOfDaysInMonth(dateInTargetMonth);
      if (numberOfDaysInMonth < date.getDate()) {
        dateInTargetMonth.setDate(numberOfDaysInMonth);
      } else {
        dateInTargetMonth.setDate(date.getDate());
      }

      return dateInTargetMonth;
    }

    /**
     * Get the integer distance between two months. This *only* considers the month and year
     * portion of the Date instances.
     *
     * @param {Date} start
     * @param {Date} end
     * @returns {number} Number of months between `start` and `end`. If `end` is before `start`
     *     chronologically, this number will be negative.
     */
    function getMonthDistance(start, end) {
      return (12 * (end.getFullYear() - start.getFullYear())) + (end.getMonth() - start.getMonth());
    }

    /**
     * Gets the last day of the month for the given date.
     * @param {Date} date
     * @returns {Date}
     */
    function getLastDateOfMonth(date) {
      return new Date(date.getFullYear(), date.getMonth(), getNumberOfDaysInMonth(date));
    }

    /**
     * Checks whether a date is valid.
     * @param {Date} date
     * @return {boolean} Whether the date is a valid Date.
     */
    function isValidDate(date) {
      return date && date.getTime && !isNaN(date.getTime());
    }

    /**
     * Sets a date's time to midnight.
     * @param {Date} date
     */
    function setDateTimeToMidnight(date) {
      if (isValidDate(date)) {
        date.setHours(0, 0, 0, 0);
      }
    }

    /**
     * Creates a date with the time set to midnight.
     * Drop-in replacement for two forms of the Date constructor via opt_value.
     * @param {number|Date=} opt_value Leave undefined for a Date representing now. Or use a
     *  single value representing the number of seconds since the Unix Epoch or a Date object.
     * @return {Date} New date with time set to midnight.
     */
    function createDateAtMidnight(opt_value) {
      var date;
      if (angular.isDate(opt_value)) {
        date = opt_value;
      } else if (angular.isNumber(opt_value)) {
        date = new Date(opt_value);
      } else {
        date = new Date();
      }
      setDateTimeToMidnight(date);
      return date;
    }

     /**
      * Checks if a date is within a min and max range, ignoring the time component.
      * If minDate or maxDate are not dates, they are ignored.
      * @param {Date} date
      * @param {Date} minDate
      * @param {Date} maxDate
      */
     function isDateWithinRange(date, minDate, maxDate) {
       var dateAtMidnight = createDateAtMidnight(date);
       var minDateAtMidnight = isValidDate(minDate) ? createDateAtMidnight(minDate) : null;
       var maxDateAtMidnight = isValidDate(maxDate) ? createDateAtMidnight(maxDate) : null;
       return (!minDateAtMidnight || minDateAtMidnight <= dateAtMidnight) &&
           (!maxDateAtMidnight || maxDateAtMidnight >= dateAtMidnight);
     }

    /**
     * Gets a new date incremented by the given number of years. Number of years can be negative.
     * See `incrementMonths` for notes on overflow for specific dates.
     * @param {Date} date
     * @param {number} numberOfYears
     * @returns {Date}
     */
     function incrementYears(date, numberOfYears) {
       return incrementMonths(date, numberOfYears * 12);
     }

     /**
      * Get the integer distance between two years. This *only* considers the year portion of the
      * Date instances.
      *
      * @param {Date} start
      * @param {Date} end
      * @returns {number} Number of months between `start` and `end`. If `end` is before `start`
      *     chronologically, this number will be negative.
      */
     function getYearDistance(start, end) {
       return end.getFullYear() - start.getFullYear();
     }

     /**
      * Clamps a date between a minimum and a maximum date.
      * @param {Date} date Date to be clamped
      * @param {Date=} minDate Minimum date
      * @param {Date=} maxDate Maximum date
      * @return {Date}
      */
     function clampDate(date, minDate, maxDate) {
       var boundDate = date;
       if (minDate && date < minDate) {
         boundDate = new Date(minDate.getTime());
       }
       if (maxDate && date > maxDate) {
         boundDate = new Date(maxDate.getTime());
       }
       return boundDate;
     }

     /**
      * Extracts and parses the timestamp from a DOM node.
      * @param  {HTMLElement} node Node from which the timestamp will be extracted.
      * @return {number} Time since epoch.
      */
     function getTimestampFromNode(node) {
       if (node && node.hasAttribute('data-timestamp')) {
         return Number(node.getAttribute('data-timestamp'));
       }
     }

     /**
      * Checks if a month is within a min and max range, ignoring the date and time components.
      * If minDate or maxDate are not dates, they are ignored.
      * @param {Date} date
      * @param {Date} minDate
      * @param {Date} maxDate
      */
     function isMonthWithinRange(date, minDate, maxDate) {
       var month = date.getMonth();
       var year = date.getFullYear();

       return (!minDate || minDate.getFullYear() < year || minDate.getMonth() <= month) &&
        (!maxDate || maxDate.getFullYear() > year || maxDate.getMonth() >= month);
     }

    /**
     * @param {Date} value date in local timezone
     * @return {Date} date with local timezone offset removed
     */
    function removeLocalTzAndReparseDate(value) {
      var dateValue, formattedDate;
      // Remove the local timezone offset before calling formatDate.
      dateValue = new Date(value.getTime() + 60000 * value.getTimezoneOffset());
      formattedDate = $mdDateLocale.formatDate(dateValue);
      // parseDate only works with a date formatted by formatDate when using Moment validation.
      return $mdDateLocale.parseDate(formattedDate);
    }
  }]);
})();

})();
(function(){
"use strict";

(function() {
  'use strict';

  // TODO(jelbourn): forward more attributes to the internal input (required, autofocus, etc.)
  // TODO(jelbourn): something better for mobile (calendar panel takes up entire screen?)
  // TODO(jelbourn): input behavior (masking? auto-complete?)

  DatePickerCtrl.$inject = ["$scope", "$element", "$attrs", "$window", "$mdConstant", "$mdTheming", "$mdUtil", "$mdDateLocale", "$$mdDateUtil", "$$rAF", "$filter", "$timeout"];
  datePickerDirective.$inject = ["$$mdSvgRegistry", "$mdUtil", "$mdAria", "inputDirective"];
  angular.module('material.components.datepicker')
      .directive('mdDatepicker', datePickerDirective);

  /**
   * @ngdoc directive
   * @name mdDatepicker
   * @module material.components.datepicker
   *
   * @param {Date} ng-model The component's model. Expects either a JavaScript Date object or a
   *  value that can be parsed into one (e.g. a ISO 8601 string).
   * @param {Object=} ng-model-options Allows tuning of the way in which `ng-model` is being
   *  updated. Also allows for a timezone to be specified.
   *  <a href="https://docs.angularjs.org/api/ng/directive/ngModelOptions#usage">
   *    Read more at the ngModelOptions docs.</a>
   * @param {expression=} ng-change Expression evaluated when the model value changes.
   * @param {expression=} ng-focus Expression evaluated when the input is focused or the calendar
   *  is opened.
   * @param {expression=} ng-blur Expression evaluated when focus is removed from the input or the
   *  calendar is closed.
   * @param {boolean=} ng-disabled Whether the datepicker is disabled.
   * @param {boolean=} ng-required Whether a value is required for the datepicker.
   * @param {Date=} md-min-date Expression representing a min date (inclusive).
   * @param {Date=} md-max-date Expression representing a max date (inclusive).
   * @param {(function(Date): boolean)=} md-date-filter Function expecting a date and returning a
   *  boolean whether it can be selected in "day" mode or not. Returning false will also trigger a
   *  `filtered` model validation error.
   * @param {(function(Date): boolean)=} md-month-filter Function expecting a date and returning a
   *  boolean whether it can be selected in "month" mode or not. Returning false will also trigger a
   *  `filtered` model validation error.
   * @param {string=} md-placeholder The date input placeholder value.
   * @param {string=} md-open-on-focus When present, the calendar will be opened when the input
   *  is focused.
   * @param {Boolean=} md-is-open Expression that can be used to open the datepicker's calendar
   *  on-demand.
   * @param {string=} md-current-view Default open view of the calendar pane. Can be either
   *  "month" or "year".
   * @param {string=} md-mode Restricts the user to only selecting a value from a particular view.
   *  This option can be used if the user is only supposed to choose from a certain date type
   *  (e.g. only selecting the month).
   * Can be either "month" or "day". **Note** that this will overwrite the `md-current-view` value.
   * @param {string=} md-hide-icons Determines which datepicker icons should be hidden. Note that
   *  this may cause the datepicker to not align properly with other components.
   *  **Use at your own risk.** Possible values are:
   * * `"all"` - Hides all icons.
   * * `"calendar"` - Only hides the calendar icon.
   * * `"triangle"` - Only hides the triangle icon.
   * @param {Object=} md-date-locale Allows for the values from the `$mdDateLocaleProvider` to be
   * overwritten on a per-element basis (e.g. `msgOpenCalendar` can be overwritten with
   * `md-date-locale="{ msgOpenCalendar: 'Open a special calendar' }"`).
   * @param {string=} input-aria-describedby A space-separated list of element IDs. This should
   *  contain the IDs of any elements that describe this datepicker. Screen readers will read the
   *  content of these elements at the end of announcing that the datepicker has been selected
   *  and describing its current state. The descriptive elements do not need to be visible on the
   *  page.
   * @param {string=} input-aria-labelledby A space-separated list of element IDs. The ideal use
   *  case is that this would contain the ID of a `<label>` element should be associated with this
   *  datepicker. This is necessary when using `md-datepicker` inside of an `md-input-container`
   *  with a `<label>`.<br><br>
   *  For `<label id="start-date">Start Date</label>`, you would set this to
   *  `input-aria-labelledby="start-date"`.
   *
   * @description
   * `<md-datepicker>` is a component used to select a single date.
   * For information on how to configure internationalization for the date picker,
   * see <a ng-href="api/service/$mdDateLocaleProvider">$mdDateLocaleProvider</a>.
   *
   * This component supports
   * [ngMessages](https://docs.angularjs.org/api/ngMessages/directive/ngMessages).
   * Supported attributes are:
   * * `required`: whether a required date is not set.
   * * `mindate`: whether the selected date is before the minimum allowed date.
   * * `maxdate`: whether the selected date is after the maximum allowed date.
   * * `debounceInterval`: ms to delay input processing (since last debounce reset);
   *    default value 500ms
   *
   * @usage
   * <hljs lang="html">
   *   <md-datepicker ng-model="birthday"></md-datepicker>
   * </hljs>
   *
   */

  function datePickerDirective($$mdSvgRegistry, $mdUtil, $mdAria, inputDirective) {
    return {
      template: function(tElement, tAttrs) {
        // Buttons are not in the tab order because users can open the calendar via keyboard
        // interaction on the text input, and multiple tab stops for one component (picker)
        // may be confusing.
        var hiddenIcons = tAttrs.mdHideIcons;
        var inputAriaDescribedby = tAttrs.inputAriaDescribedby;
        var inputAriaLabelledby = tAttrs.inputAriaLabelledby;
        var ariaLabelValue = tAttrs.ariaLabel || tAttrs.mdPlaceholder;
        var ngModelOptions = tAttrs.ngModelOptions;

        var calendarButton = (hiddenIcons === 'all' || hiddenIcons === 'calendar') ? '' :
          '<md-button class="md-datepicker-button md-icon-button" type="button" ' +
              'tabindex="-1" aria-hidden="true" ' +
              'ng-click="ctrl.openCalendarPane($event)">' +
            '<md-icon class="md-datepicker-calendar-icon" aria-label="md-calendar" ' +
                     'md-svg-src="' + $$mdSvgRegistry.mdCalendar + '"></md-icon>' +
          '</md-button>';

        var triangleButton = '';

        if (hiddenIcons !== 'all' && hiddenIcons !== 'triangle') {
          triangleButton = '' +
            '<md-button type="button" md-no-ink ' +
              'class="md-datepicker-triangle-button md-icon-button" ' +
              'ng-click="ctrl.openCalendarPane($event)" ' +
              'aria-label="{{::ctrl.locale.msgOpenCalendar}}">' +
            '<div class="md-datepicker-expand-triangle"></div>' +
          '</md-button>';

          tElement.addClass(HAS_TRIANGLE_ICON_CLASS);
        }

        return calendarButton +
        '<div class="md-datepicker-input-container" ng-class="{\'md-datepicker-focused\': ctrl.isFocused}">' +
          '<input ' +
            (ariaLabelValue ? 'aria-label="' + ariaLabelValue + '" ' : '') +
            (inputAriaDescribedby ? 'aria-describedby="' + inputAriaDescribedby + '" ' : '') +
            (inputAriaLabelledby ? 'aria-labelledby="' + inputAriaLabelledby + '" ' : '') +
            'class="md-datepicker-input" ' +
            'aria-haspopup="dialog" ' +
            'ng-focus="ctrl.setFocused(true)" ' +
            'ng-blur="ctrl.setFocused(false)"> ' +
            triangleButton +
        '</div>' +

        // This pane will be detached from here and re-attached to the document body.
        '<div class="md-datepicker-calendar-pane md-whiteframe-z1" id="{{::ctrl.calendarPaneId}}">' +
          '<div class="md-datepicker-input-mask">' +
            '<div class="md-datepicker-input-mask-opaque"></div>' +
          '</div>' +
          '<div class="md-datepicker-calendar">' +
            '<md-calendar role="dialog" aria-label="{{::ctrl.locale.msgCalendar}}" ' +
                'md-current-view="{{::ctrl.currentView}}" ' +
                'md-mode="{{::ctrl.mode}}" ' +
                'md-min-date="ctrl.minDate" ' +
                'md-max-date="ctrl.maxDate" ' +
                'md-date-filter="ctrl.dateFilter" ' +
                'md-month-filter="ctrl.monthFilter" ' +
                (ngModelOptions ? 'ng-model-options="' + ngModelOptions + '" ' : '') +
                'ng-model="ctrl.date" ng-if="ctrl.isCalendarOpen">' +
            '</md-calendar>' +
          '</div>' +
        '</div>';
      },
      require: ['ngModel', 'mdDatepicker', '?^mdInputContainer', '?^form'],
      scope: {
        minDate: '=mdMinDate',
        maxDate: '=mdMaxDate',
        placeholder: '@mdPlaceholder',
        currentView: '@mdCurrentView',
        mode: '@mdMode',
        dateFilter: '=mdDateFilter',
        monthFilter: '=mdMonthFilter',
        isOpen: '=?mdIsOpen',
        debounceInterval: '=mdDebounceInterval',
        dateLocale: '=mdDateLocale'
      },
      controller: DatePickerCtrl,
      controllerAs: 'ctrl',
      bindToController: true,
      link: function(scope, element, attr, controllers) {
        var ngModelCtrl = controllers[0];
        var mdDatePickerCtrl = controllers[1];
        var mdInputContainer = controllers[2];
        var parentForm = controllers[3];
        var mdNoAsterisk = $mdUtil.parseAttributeBoolean(attr.mdNoAsterisk);

        mdDatePickerCtrl.configureNgModel(ngModelCtrl, mdInputContainer, inputDirective);

        if (mdInputContainer) {
          // We need to move the spacer after the datepicker itself,
          // because md-input-container adds it after the
          // md-datepicker-input by default. The spacer gets wrapped in a
          // div, because it floats and gets aligned next to the datepicker.
          // There are easier ways of working around this with CSS (making the
          // datepicker 100% wide, change the `display` etc.), however they
          // break the alignment with any other form controls.
          var spacer = element[0].querySelector('.md-errors-spacer');

          if (spacer) {
            element.after(angular.element('<div>').append(spacer));
          }

          mdInputContainer.setHasPlaceholder(attr.mdPlaceholder);
          mdInputContainer.input = element;
          mdInputContainer.element
            .addClass(INPUT_CONTAINER_CLASS)
            .toggleClass(HAS_CALENDAR_ICON_CLASS,
              attr.mdHideIcons !== 'calendar' && attr.mdHideIcons !== 'all');

          if (!mdInputContainer.label) {
            $mdAria.expect(element, 'aria-label', attr.mdPlaceholder);
          } else if (!mdNoAsterisk) {
            attr.$observe('required', function(value) {
              mdInputContainer.label.toggleClass('md-required', !!value);
            });
          }

          scope.$watch(mdInputContainer.isErrorGetter || function() {
            return ngModelCtrl.$invalid && (ngModelCtrl.$touched ||
              (parentForm && parentForm.$submitted));
          }, mdInputContainer.setInvalid);
        } else if (parentForm) {
          // If invalid, highlights the input when the parent form is submitted.
          var parentSubmittedWatcher = scope.$watch(function() {
            return parentForm.$submitted;
          }, function(isSubmitted) {
            if (isSubmitted) {
              mdDatePickerCtrl.updateErrorState();
              parentSubmittedWatcher();
            }
          });
        }
      }
    };
  }

  /** Additional offset for the input's `size` attribute, which is updated based on its content. */
  var EXTRA_INPUT_SIZE = 3;

  /** Class applied to the container if the date is invalid. */
  var INVALID_CLASS = 'md-datepicker-invalid';

  /** Class applied to the datepicker when it's open. */
  var OPEN_CLASS = 'md-datepicker-open';

  /** Class applied to the md-input-container, if a datepicker is placed inside it */
  var INPUT_CONTAINER_CLASS = '_md-datepicker-floating-label';

  /** Class to be applied when the calendar icon is enabled. */
  var HAS_CALENDAR_ICON_CLASS = '_md-datepicker-has-calendar-icon';

  /** Class to be applied when the triangle icon is enabled. */
  var HAS_TRIANGLE_ICON_CLASS = '_md-datepicker-has-triangle-icon';

  /** Default time in ms to debounce input event by. */
  var DEFAULT_DEBOUNCE_INTERVAL = 500;

  /**
   * Height of the calendar pane used to check if the pane is going outside the boundary of
   * the viewport. See calendar.scss for how $md-calendar-height is computed; an extra 20px is
   * also added to space the pane away from the exact edge of the screen.
   *
   *  This is computed statically now, but can be changed to be measured if the circumstances
   *  of calendar sizing are changed.
   */
  var CALENDAR_PANE_HEIGHT = 368;

  /**
   * Width of the calendar pane used to check if the pane is going outside the boundary of
   * the viewport. See calendar.scss for how $md-calendar-width is computed; an extra 20px is
   * also added to space the pane away from the exact edge of the screen.
   *
   *  This is computed statically now, but can be changed to be measured if the circumstances
   *  of calendar sizing are changed.
   */
  var CALENDAR_PANE_WIDTH = 360;

  /** Used for checking whether the current user agent is on iOS or Android. */
  var IS_MOBILE_REGEX = /ipad|iphone|ipod|android/i;

  /**
   * Controller for md-datepicker.
   *
   * @ngInject @constructor
   */
  function DatePickerCtrl($scope, $element, $attrs, $window, $mdConstant, $mdTheming, $mdUtil,
                          $mdDateLocale, $$mdDateUtil, $$rAF, $filter, $timeout) {

    /** @final */
    this.$window = $window;

    /** @final */
    this.dateUtil = $$mdDateUtil;

    /** @final */
    this.$mdConstant = $mdConstant;

    /** @final */
    this.$mdUtil = $mdUtil;

    /** @final */
    this.$$rAF = $$rAF;

    /** @final */
    this.$mdDateLocale = $mdDateLocale;

    /** @final */
    this.$timeout = $timeout;

    /**
     * The root document element. This is used for attaching a top-level click handler to
     * close the calendar panel when a click outside said panel occurs. We use `documentElement`
     * instead of body because, when scrolling is disabled, some browsers consider the body element
     * to be completely off the screen and propagate events directly to the html element.
     * @type {!JQLite}
     */
    this.documentElement = angular.element(document.documentElement);

    /** @type {!ngModel.NgModelController} */
    this.ngModelCtrl = null;

    /** @type {HTMLInputElement} */
    this.inputElement = $element[0].querySelector('input');

    /**
     * @final
     * @type {!JQLite}
     */
    this.ngInputElement = angular.element(this.inputElement);

    /** @type {HTMLElement} */
    this.inputContainer = $element[0].querySelector('.md-datepicker-input-container');

    /** @type {HTMLElement} Floating calendar pane. */
    this.calendarPane = $element[0].querySelector('.md-datepicker-calendar-pane');

    /** @type {HTMLElement} Calendar icon button. */
    this.calendarButton = $element[0].querySelector('.md-datepicker-button');

    /**
     * Element covering everything but the input in the top of the floating calendar pane.
     * @type {!JQLite}
     */
    this.inputMask = angular.element($element[0].querySelector('.md-datepicker-input-mask-opaque'));

    /**
     * @final
     * @type {!JQLite}
     */
    this.$element = $element;

    /**
     * @final
     * @type {!angular.Attributes}
     */
    this.$attrs = $attrs;

    /**
     * @final
     * @type {!angular.Scope}
     */
    this.$scope = $scope;

    /**
     * This holds the model that will be used by the calendar.
     * @type {Date|null|undefined}
     */
    this.date = null;

    /** @type {boolean} */
    this.isFocused = false;

    /** @type {boolean} */
    this.isDisabled = undefined;
    this.setDisabled($element[0].disabled || angular.isString($attrs.disabled));

    /** @type {boolean} Whether the date-picker's calendar pane is open. */
    this.isCalendarOpen = false;

    /** @type {boolean} Whether the calendar should open when the input is focused. */
    this.openOnFocus = $attrs.hasOwnProperty('mdOpenOnFocus');

    /** @type {Object} Instance of the mdInputContainer controller */
    this.mdInputContainer = null;

    /**
     * Element from which the calendar pane was opened. Keep track of this so that we can return
     * focus to it when the pane is closed.
     * @type {HTMLElement}
     */
    this.calendarPaneOpenedFrom = null;

    /** @type {String} Unique id for the calendar pane. */
    this.calendarPaneId = 'md-date-pane-' + $mdUtil.nextUid();

    /** Pre-bound click handler is saved so that the event listener can be removed. */
    this.bodyClickHandler = angular.bind(this, this.handleBodyClick);

    /**
     * Name of the event that will trigger a close. Necessary to sniff the browser, because
     * the resize event doesn't make sense on mobile and can have a negative impact since it
     * triggers whenever the browser zooms in on a focused input.
     */
    this.windowEventName = IS_MOBILE_REGEX.test(
      navigator.userAgent || navigator.vendor || window.opera
    ) ? 'orientationchange' : 'resize';

    /** Pre-bound close handler so that the event listener can be removed. */
    this.windowEventHandler = $mdUtil.debounce(angular.bind(this, this.closeCalendarPane), 100);

    /** Pre-bound handler for the window blur event. Allows for it to be removed later. */
    this.windowBlurHandler = angular.bind(this, this.handleWindowBlur);

    /** The built-in AngularJS date filter. */
    this.ngDateFilter = $filter('date');

    /** @type {Number} Extra margin for the left side of the floating calendar pane. */
    this.leftMargin = 20;

    /** @type {Number} Extra margin for the top of the floating calendar. Gets determined on the first open. */
    this.topMargin = null;

    // Unless the user specifies so, the datepicker should not be a tab stop.
    // This is necessary because ngAria might add a tabindex to anything with an ng-model
    // (based on whether or not the user has turned that particular feature on/off).
    if ($attrs.tabindex) {
      this.ngInputElement.attr('tabindex', $attrs.tabindex);
      $attrs.$set('tabindex', null);
    } else {
      $attrs.$set('tabindex', '-1');
    }

    $attrs.$set('aria-owns', this.calendarPaneId);

    $mdTheming($element);
    $mdTheming(angular.element(this.calendarPane));

    var self = this;

    $scope.$on('$destroy', function() {
      self.detachCalendarPane();
    });

    if ($attrs.mdIsOpen) {
      $scope.$watch('ctrl.isOpen', function(shouldBeOpen) {
        if (shouldBeOpen) {
          self.openCalendarPane({
            target: self.inputElement
          });
        } else {
          self.closeCalendarPane();
        }
      });
    }

    // For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are
    // pre-assigned, manually call the $onInit hook.
    if (angular.version.major === 1 && angular.version.minor <= 4) {
      this.$onInit();
    }
  }

  /**
   * AngularJS Lifecycle hook for newer AngularJS versions.
   * Bindings are not guaranteed to have been assigned in the controller, but they are in the
   * $onInit hook.
   */
  DatePickerCtrl.prototype.$onInit = function() {

    /**
     * Holds locale-specific formatters, parsers, labels etc. Allows
     * the user to override specific ones from the $mdDateLocale provider.
     * @type {!Object}
     */
    this.locale = this.dateLocale ? angular.extend({}, this.$mdDateLocale, this.dateLocale)
      : this.$mdDateLocale;

    this.installPropertyInterceptors();
    this.attachChangeListeners();
    this.attachInteractionListeners();
  };

  /**
   * Sets up the controller's reference to ngModelController and
   * applies AngularJS's `input[type="date"]` directive.
   * @param {!angular.NgModelController} ngModelCtrl Instance of the ngModel controller.
   * @param {Object} mdInputContainer Instance of the mdInputContainer controller.
   * @param {Object} inputDirective Config for AngularJS's `input` directive.
   */
  DatePickerCtrl.prototype.configureNgModel = function(ngModelCtrl, mdInputContainer, inputDirective) {
    this.ngModelCtrl = ngModelCtrl;
    this.mdInputContainer = mdInputContainer;

    // The input needs to be [type="date"] in order to be picked up by AngularJS.
    this.$attrs.$set('type', 'date');

    // Invoke the `input` directive link function, adding a stub for the element.
    // This allows us to re-use AngularJS's logic for setting the timezone via ng-model-options.
    // It works by calling the link function directly which then adds the proper `$parsers` and
    // `$formatters` to the ngModel controller.
    inputDirective[0].link.pre(this.$scope, {
      on: angular.noop,
      val: angular.noop,
      0: {}
    }, this.$attrs, [ngModelCtrl]);

    var self = this;

    // Responds to external changes to the model value.
    self.ngModelCtrl.$formatters.push(function(value) {
      var parsedValue = angular.isDefined(value) ? value : null;

      if (!(value instanceof Date)) {
        parsedValue = Date.parse(value);

        // `parsedValue` is the time since epoch if valid or `NaN` if invalid.
        if (!isNaN(parsedValue) && angular.isNumber(parsedValue)) {
          value = new Date(parsedValue);
        }

        if (value && !(value instanceof Date)) {
          throw Error(
            'The ng-model for md-datepicker must be a Date instance or a value ' +
              'that can be parsed into a date. Currently the model is of type: ' + typeof value
          );
        }
      }

      self.onExternalChange(value);

      return value;
    });

    // Responds to external error state changes (e.g. ng-required based on another input).
    ngModelCtrl.$viewChangeListeners.unshift(angular.bind(this, this.updateErrorState));

    // Forwards any events from the input to the root element. This is necessary to get `updateOn`
    // working for events that don't bubble (e.g. 'blur') since AngularJS binds the handlers to
    // the `<md-datepicker>`.
    var updateOn = self.$mdUtil.getModelOption(ngModelCtrl, 'updateOn');

    if (updateOn) {
      this.ngInputElement.on(
        updateOn,
        angular.bind(this.$element, this.$element.triggerHandler, updateOn)
      );
    }
  };

  /**
   * Attach event listeners for both the text input and the md-calendar.
   * Events are used instead of ng-model so that updates don't infinitely update the other
   * on a change. This should also be more performant than using a $watch.
   */
  DatePickerCtrl.prototype.attachChangeListeners = function() {
    var self = this;

    self.$scope.$on('md-calendar-change', function(event, date) {
      self.setModelValue(date);
      self.onExternalChange(date);
      self.closeCalendarPane();
    });

    self.ngInputElement.on('input', angular.bind(self, self.resizeInputElement));

    var debounceInterval = angular.isDefined(this.debounceInterval) ?
        this.debounceInterval : DEFAULT_DEBOUNCE_INTERVAL;
    self.ngInputElement.on('input', self.$mdUtil.debounce(self.handleInputEvent,
        debounceInterval, self));
  };

  /** Attach event listeners for user interaction. */
  DatePickerCtrl.prototype.attachInteractionListeners = function() {
    var self = this;
    var $scope = this.$scope;
    var keyCodes = this.$mdConstant.KEY_CODE;

    // Add event listener through angular so that we can triggerHandler in unit tests.
    self.ngInputElement.on('keydown', function(event) {
      if (event.altKey && event.keyCode === keyCodes.DOWN_ARROW) {
        self.openCalendarPane(event);
        $scope.$digest();
      }
    });

    if (self.openOnFocus) {
      self.ngInputElement.on('focus', angular.bind(self, self.openCalendarPane));
      self.ngInputElement.on('click', function(event) {
        event.stopPropagation();
      });
      self.ngInputElement.on('pointerdown',function(event) {
        if (event.target && event.target.setPointerCapture) {
          event.target.setPointerCapture(event.pointerId);
        }
      });

      angular.element(self.$window).on('blur', self.windowBlurHandler);

      $scope.$on('$destroy', function() {
        angular.element(self.$window).off('blur', self.windowBlurHandler);
      });
    }

    $scope.$on('md-calendar-close', function() {
      self.closeCalendarPane();
    });
  };

  /**
   * Capture properties set to the date-picker and imperatively handle internal changes.
   * This is done to avoid setting up additional $watches.
   */
  DatePickerCtrl.prototype.installPropertyInterceptors = function() {
    var self = this;

    if (this.$attrs.ngDisabled) {
      // The expression is to be evaluated against the directive element's scope and not
      // the directive's isolate scope.
      var scope = this.$scope.$parent;

      if (scope) {
        scope.$watch(this.$attrs.ngDisabled, function(isDisabled) {
          self.setDisabled(isDisabled);
        });
      }
    }

    Object.defineProperty(this, 'placeholder', {
      get: function() { return self.inputElement.placeholder; },
      set: function(value) { self.inputElement.placeholder = value || ''; }
    });
  };

  /**
   * Sets whether the date-picker is disabled.
   * @param {boolean} isDisabled
   */
  DatePickerCtrl.prototype.setDisabled = function(isDisabled) {
    this.isDisabled = isDisabled;
    this.inputElement.disabled = isDisabled;

    if (this.calendarButton) {
      this.calendarButton.disabled = isDisabled;
    }
  };

  /**
   * Sets the custom ngModel.$error flags to be consumed by ngMessages. Flags are:
   *   - mindate: whether the selected date is before the minimum date.
   *   - maxdate: whether the selected flag is after the maximum date.
   *   - filtered: whether the selected date is allowed by the custom filtering function.
   *   - valid: whether the entered text input is a valid date
   *
   * The 'required' flag is handled automatically by ngModel.
   *
   * @param {Date=} opt_date Date to check. If not given, defaults to the datepicker's model value.
   */
  DatePickerCtrl.prototype.updateErrorState = function(opt_date) {
    var date;
    if (opt_date) {
      date = new Date(opt_date.valueOf());
    } else {
      if (angular.isString(this.ngModelCtrl.$modelValue)) {
        date = new Date(this.ngModelCtrl.$modelValue);
      } else {
        date = angular.copy(this.ngModelCtrl.$modelValue);
      }
    }

    // Clear any existing errors to get rid of anything that's no longer relevant.
    this.clearErrorState();

    if (this.dateUtil.isValidDate(date)) {
      // Force all dates to midnight in order to ignore the time portion.
      date = this.dateUtil.createDateAtMidnight(date);

      if (this.dateUtil.isValidDate(this.minDate)) {
        var minDate = this.dateUtil.createDateAtMidnight(this.minDate);
        this.ngModelCtrl.$setValidity('mindate', date >= minDate);
      }

      if (this.dateUtil.isValidDate(this.maxDate)) {
        var maxDate = this.dateUtil.createDateAtMidnight(this.maxDate);
        this.ngModelCtrl.$setValidity('maxdate', date <= maxDate);
      }

      if (angular.isFunction(this.dateFilter)) {
        this.ngModelCtrl.$setValidity('filtered', this.dateFilter(date));
      }

      if (angular.isFunction(this.monthFilter)) {
        this.ngModelCtrl.$setValidity('filtered', this.monthFilter(date));
      }
    } else {
      // The date is seen as "not a valid date" if there is *something* set
      // (i.e.., not null or undefined), but that something isn't a valid date.
      this.ngModelCtrl.$setValidity('valid', date == null);
    }

    var input = this.inputElement.value;
    var parsedDate = this.locale.parseDate(input);

    if (!this.isInputValid(input, parsedDate) && this.ngModelCtrl.$valid) {
      this.ngModelCtrl.$setValidity('valid', date == null);
    }

    angular.element(this.inputContainer).toggleClass(INVALID_CLASS,
      this.ngModelCtrl.$invalid && (this.ngModelCtrl.$touched || this.ngModelCtrl.$submitted));
  };

  /**
   * Check to see if the input is valid, as the validation should fail if the model is invalid.
   *
   * @param {string} inputString
   * @param {Date} parsedDate
   * @return {boolean} Whether the input is valid
   */
  DatePickerCtrl.prototype.isInputValid = function (inputString, parsedDate) {
    return inputString === '' || (
      this.dateUtil.isValidDate(parsedDate) &&
      this.locale.isDateComplete(inputString) &&
      this.isDateEnabled(parsedDate)
    );
  };

  /** Clears any error flags set by `updateErrorState`. */
  DatePickerCtrl.prototype.clearErrorState = function() {
    this.inputContainer.classList.remove(INVALID_CLASS);
    ['mindate', 'maxdate', 'filtered', 'valid'].forEach(function(field) {
      this.ngModelCtrl.$setValidity(field, true);
    }, this);
  };

  /** Resizes the input element based on the size of its content. */
  DatePickerCtrl.prototype.resizeInputElement = function() {
    this.inputElement.size = this.inputElement.value.length + EXTRA_INPUT_SIZE;
  };

  /**
   * Sets the model value if the user input is a valid date.
   * Adds an invalid class to the input element if not.
   */
  DatePickerCtrl.prototype.handleInputEvent = function() {
    var inputString = this.inputElement.value;
    var parsedDate = inputString ? this.locale.parseDate(inputString) : null;
    this.dateUtil.setDateTimeToMidnight(parsedDate);

    // An input string is valid if it is either empty (representing no date)
    // or if it parses to a valid date that the user is allowed to select.
    var isValidInput = this.isInputValid(inputString, parsedDate);

    // The datepicker's model is only updated when there is a valid input.
    if (isValidInput) {
      this.setModelValue(parsedDate);
      this.date = parsedDate;
    }

    this.updateErrorState(parsedDate);
  };

  /**
   * Check whether date is in range and enabled
   * @param {Date=} opt_date
   * @return {boolean} Whether the date is enabled.
   */
  DatePickerCtrl.prototype.isDateEnabled = function(opt_date) {
    return this.dateUtil.isDateWithinRange(opt_date, this.minDate, this.maxDate) &&
          (!angular.isFunction(this.dateFilter) || this.dateFilter(opt_date)) &&
          (!angular.isFunction(this.monthFilter) || this.monthFilter(opt_date));
  };

  /** Position and attach the floating calendar to the document. */
  DatePickerCtrl.prototype.attachCalendarPane = function() {
    var calendarPane = this.calendarPane;
    var body = document.body;

    calendarPane.style.transform = '';
    this.$element.addClass(OPEN_CLASS);
    this.mdInputContainer && this.mdInputContainer.element.addClass(OPEN_CLASS);
    angular.element(body).addClass('md-datepicker-is-showing');

    var elementRect = this.inputContainer.getBoundingClientRect();
    var bodyRect = body.getBoundingClientRect();

    if (!this.topMargin || this.topMargin < 0) {
      this.topMargin =
        (this.inputMask.parent().prop('clientHeight')
          - this.ngInputElement.prop('clientHeight')) / 2;
    }

    // Check to see if the calendar pane would go off the screen. If so, adjust position
    // accordingly to keep it within the viewport.
    var paneTop = elementRect.top - bodyRect.top - this.topMargin;
    var paneLeft = elementRect.left - bodyRect.left - this.leftMargin;

    // If ng-material has disabled body scrolling (for example, if a dialog is open),
    // then it's possible that the already-scrolled body has a negative top/left. In this case,
    // we want to treat the "real" top as (0 - bodyRect.top). In a normal scrolling situation,
    // though, the top of the viewport should just be the body's scroll position.
    var viewportTop = (bodyRect.top < 0 && document.body.scrollTop === 0) ?
        -bodyRect.top :
        document.body.scrollTop;

    var viewportLeft = (bodyRect.left < 0 && document.body.scrollLeft === 0) ?
        -bodyRect.left :
        document.body.scrollLeft;

    var viewportBottom = viewportTop + this.$window.innerHeight;
    var viewportRight = viewportLeft + this.$window.innerWidth;

    // Creates an overlay with a hole the same size as element. We remove a pixel or two
    // on each end to make it overlap slightly. The overlay's background is added in
    // the theme in the form of a box-shadow with a huge spread.
    this.inputMask.css({
      position: 'absolute',
      left: this.leftMargin + 'px',
      top: this.topMargin + 'px',
      width: (elementRect.width - 1) + 'px',
      height: (elementRect.height - 2) + 'px'
    });

    // If the right edge of the pane would be off the screen and shifting it left by the
    // difference would not go past the left edge of the screen. If the calendar pane is too
    // big to fit on the screen at all, move it to the left of the screen and scale the entire
    // element down to fit.
    if (paneLeft + CALENDAR_PANE_WIDTH > viewportRight) {
      if (viewportRight - CALENDAR_PANE_WIDTH > 0) {
        paneLeft = viewportRight - CALENDAR_PANE_WIDTH;
      } else {
        paneLeft = viewportLeft;
        var scale = this.$window.innerWidth / CALENDAR_PANE_WIDTH;
        calendarPane.style.transform = 'scale(' + scale + ')';
      }

      calendarPane.classList.add('md-datepicker-pos-adjusted');
    }

    // If the bottom edge of the pane would be off the screen and shifting it up by the
    // difference would not go past the top edge of the screen.
    if (paneTop + CALENDAR_PANE_HEIGHT > viewportBottom &&
        viewportBottom - CALENDAR_PANE_HEIGHT > viewportTop) {
      paneTop = viewportBottom - CALENDAR_PANE_HEIGHT;
      calendarPane.classList.add('md-datepicker-pos-adjusted');
    }

    calendarPane.style.left = paneLeft + 'px';
    calendarPane.style.top = paneTop + 'px';
    document.body.appendChild(calendarPane);

    // Add CSS class after one frame to trigger open animation.
    this.$$rAF(function() {
      calendarPane.classList.add('md-pane-open');
    });
  };

  /** Detach the floating calendar pane from the document. */
  DatePickerCtrl.prototype.detachCalendarPane = function() {
    this.$element.removeClass(OPEN_CLASS);
    this.mdInputContainer && this.mdInputContainer.element.removeClass(OPEN_CLASS);
    angular.element(document.body).removeClass('md-datepicker-is-showing');
    this.calendarPane.classList.remove('md-pane-open');
    this.calendarPane.classList.remove('md-datepicker-pos-adjusted');

    if (this.isCalendarOpen) {
      this.$mdUtil.enableScrolling();
    }

    if (this.calendarPane.parentNode) {
      // Use native DOM removal because we do not want any of the
      // angular state of this element to be disposed.
      this.calendarPane.parentNode.removeChild(this.calendarPane);
    }
  };

  /**
   * Open the floating calendar pane.
   * @param {MouseEvent|KeyboardEvent|{target: HTMLInputElement}} event
   */
  DatePickerCtrl.prototype.openCalendarPane = function(event) {
    if (!this.isCalendarOpen && !this.isDisabled && !this.inputFocusedOnWindowBlur) {
      this.isCalendarOpen = this.isOpen = true;
      this.calendarPaneOpenedFrom = event.target;

      // Because the calendar pane is attached directly to the body, it is possible that the
      // rest of the component (input, etc) is in a different scrolling container, such as
      // an md-content. This means that, if the container is scrolled, the pane would remain
      // stationary. To remedy this, we disable scrolling while the calendar pane is open, which
      // also matches the native behavior for things like `<select>` on Mac and Windows.
      this.$mdUtil.disableScrollAround(this.calendarPane);

      this.attachCalendarPane();
      this.focusCalendar();
      this.evalAttr('ngFocus');

      // Attach click listener inside of a timeout because, if this open call was triggered by a
      // click, we don't want it to be immediately propagated up to the body and handled.
      var self = this;
      this.$mdUtil.nextTick(function() {
        // Use 'touchstart` in addition to click in order to work on iOS Safari, where click
        // events aren't propagated under most circumstances.
        // See http://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        self.documentElement.on('click touchstart', self.bodyClickHandler);
      }, false);

      window.addEventListener(this.windowEventName, this.windowEventHandler);
    } else if (this.inputFocusedOnWindowBlur) {
      this.resetInputFocused();
    }
  };

  /** Close the floating calendar pane. */
  DatePickerCtrl.prototype.closeCalendarPane = function() {
    if (this.isCalendarOpen) {
      var self = this;

      self.detachCalendarPane();
      self.ngModelCtrl.$setTouched();
      self.evalAttr('ngBlur');

      self.documentElement.off('click touchstart', self.bodyClickHandler);
      window.removeEventListener(self.windowEventName, self.windowEventHandler);

      self.calendarPaneOpenedFrom.focus();
      self.calendarPaneOpenedFrom = null;

      if (self.openOnFocus) {
        // Ensures that all focus events have fired before resetting
        // the calendar. Prevents the calendar from reopening immediately
        // in IE when md-open-on-focus is set. Also it needs to trigger
        // a digest, in order to prevent issues where the calendar wasn't
        // showing up on the next open.
        self.$timeout(reset);
      } else {
        reset();
      }
    }

    function reset() {
      self.isCalendarOpen = self.isOpen = false;
    }
  };

  /** Gets the controller instance for the calendar in the floating pane. */
  DatePickerCtrl.prototype.getCalendarCtrl = function() {
    return angular.element(this.calendarPane.querySelector('md-calendar')).controller('mdCalendar');
  };

  /** Focus the calendar in the floating pane. */
  DatePickerCtrl.prototype.focusCalendar = function() {
    // Use a timeout in order to allow the calendar to be rendered, as it is gated behind an ng-if.
    var self = this;
    this.$mdUtil.nextTick(function() {
      self.getCalendarCtrl().focusDate(self.date);
    }, false);
  };

  /**
   * Sets whether the input is currently focused.
   * @param {boolean} isFocused
   */
  DatePickerCtrl.prototype.setFocused = function(isFocused) {
    if (!isFocused) {
      this.ngModelCtrl.$setTouched();
    }

    // The ng* expressions shouldn't be evaluated when mdOpenOnFocus is on,
    // because they also get called when the calendar is opened/closed.
    if (!this.openOnFocus) {
      this.evalAttr(isFocused ? 'ngFocus' : 'ngBlur');
    }

    this.isFocused = isFocused;
  };

  /**
   * Handles a click on the document body when the floating calendar pane is open.
   * Closes the floating calendar pane if the click is not inside of it.
   * @param {MouseEvent} event
   */
  DatePickerCtrl.prototype.handleBodyClick = function(event) {
    if (this.isCalendarOpen) {
      var isInCalendar = this.$mdUtil.getClosest(event.target, 'md-calendar');

      if (!isInCalendar) {
        this.closeCalendarPane();
      }

      this.$scope.$digest();
    }
  };

  /**
   * Handles the event when the user navigates away from the current tab. Keeps track of
   * whether the input was focused when the event happened, in order to prevent the calendar
   * from re-opening.
   */
  DatePickerCtrl.prototype.handleWindowBlur = function() {
    this.inputFocusedOnWindowBlur = document.activeElement === this.inputElement;
  };

  /**
   * Reset the flag inputFocusedOnWindowBlur to default state, to permit user to open calendar
   * again when he back to tab with calendar focused.
   */
  DatePickerCtrl.prototype.resetInputFocused = function() {
    this.inputFocusedOnWindowBlur = false;
  };

  /**
   * Evaluates an attribute expression against the parent scope.
   * @param {String} attr Name of the attribute to be evaluated.
   */
  DatePickerCtrl.prototype.evalAttr = function(attr) {
    if (this.$attrs[attr]) {
      this.$scope.$parent.$eval(this.$attrs[attr]);
    }
  };

  /**
   * Sets the ng-model value by first converting the date object into a string. Converting it
   * is necessary, in order to pass AngularJS's `input[type="date"]` validations. AngularJS turns
   * the value into a Date object afterwards, before setting it on the model.
   * @param {Date=} value Date to be set as the model value.
   */
  DatePickerCtrl.prototype.setModelValue = function(value) {
    var timezone = this.$mdUtil.getModelOption(this.ngModelCtrl, 'timezone');
    // Using the timezone when the offset is negative (GMT+X) causes the previous day to be
    // set as the model value here. This check avoids that.
    if (timezone == null || value == null || value.getTimezoneOffset() < 0) {
      this.ngModelCtrl.$setViewValue(this.ngDateFilter(value, 'yyyy-MM-dd'), 'default');
    } else {
      this.ngModelCtrl.$setViewValue(this.ngDateFilter(value, 'yyyy-MM-dd', timezone), 'default');
    }
  };

  /**
   * Updates the datepicker when a model change occurred externally.
   * @param {Date=} value Value that was set to the model.
   */
  DatePickerCtrl.prototype.onExternalChange = function(value) {
    var self = this;
    var timezone = this.$mdUtil.getModelOption(this.ngModelCtrl, 'timezone');

    // Update the model used by the calendar.
    if (this.dateUtil.isValidDate(value) && timezone != null && value.getTimezoneOffset() >= 0) {
      this.date = this.dateUtil.removeLocalTzAndReparseDate(value);
    } else {
      this.date = value;
    }
    // Using the timezone when the offset is negative (GMT+X) causes the previous day to be
    // used here. This check avoids that.
    if (timezone == null || value == null || value.getTimezoneOffset() < 0) {
      this.inputElement.value = this.locale.formatDate(value);
    } else {
      this.inputElement.value = this.locale.formatDate(value, timezone);
    }
    this.mdInputContainer && this.mdInputContainer.setHasValue(!!value);
    this.resizeInputElement();
    // This is often called from the $formatters section of the $validators pipeline.
    // In that case, we need to delay to let $render and $validate run, so that the checks for
    // error state are accurate.
    this.$mdUtil.nextTick(function() {self.updateErrorState();}, false, self.$scope);
  };
})();

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.dialog
 */
MdDialogDirective.$inject = ["$$rAF", "$mdTheming", "$mdDialog"];
MdDialogProvider.$inject = ["$$interimElementProvider"];
angular
  .module('material.components.dialog', [
    'material.core',
    'material.components.backdrop'
  ])
  .directive('mdDialog', MdDialogDirective)
  .provider('$mdDialog', MdDialogProvider);

/**
 * @ngdoc directive
 * @name mdDialog
 * @module material.components.dialog
 *
 * @restrict E
 *
 * @description
 * `<md-dialog>` - The dialog's template must be inside this element.
 *
 * Inside, use an `<md-dialog-content>` element for the dialog's content, and use
 * an `<md-dialog-actions>` element for the dialog's actions.
 *
 * ## CSS
 * - `.md-dialog-content` - class that sets the padding on the content as the spec file
 *
 * ## Notes
 * - If you specify an `id` for the `<md-dialog>`, the `<md-dialog-content>` will have the same `id`
 * prefixed with `dialogContent_`.
 *
 * @usage
 * ### Dialog template
 * <hljs lang="html">
 * <md-dialog aria-label="List dialog">
 *   <md-dialog-content>
 *     <md-list>
 *       <md-list-item ng-repeat="item in items">
 *         <p>Number {{item}}</p>
 *       </md-list-item>
 *     </md-list>
 *   </md-dialog-content>
 *   <md-dialog-actions>
 *     <md-button ng-click="closeDialog()" class="md-primary">Close Dialog</md-button>
 *   </md-dialog-actions>
 * </md-dialog>
 * </hljs>
 */
function MdDialogDirective($$rAF, $mdTheming, $mdDialog) {
  return {
    restrict: 'E',
    link: function(scope, element) {
      element.addClass('_md');     // private md component indicator for styling

      $mdTheming(element);
      $$rAF(function() {
        var images;
        var content = element[0].querySelector('md-dialog-content');

        if (content) {
          images = content.getElementsByTagName('img');
          addOverflowClass();
          // delayed image loading may impact scroll height, check after images are loaded
          angular.element(images).on('load', addOverflowClass);
        }

        scope.$on('$destroy', function() {
          $mdDialog.destroy(element);
        });

        /**
         *
         */
        function addOverflowClass() {
          element.toggleClass('md-content-overflow', content.scrollHeight > content.clientHeight);
        }


      });
    }
  };
}

/**
 * @ngdoc service
 * @name $mdDialog
 * @module material.components.dialog
 *
 * @description
 * `$mdDialog` opens a dialog over the app to inform users about critical information or require
 *  them to make decisions. There are two approaches for setup: a simple promise API
 *  and regular object syntax.
 *
 * ## Restrictions
 *
 * - The dialog is always given an isolate scope.
 * - The dialog's template must have an outer `<md-dialog>` element.
 *   Inside, use an `<md-dialog-content>` element for the dialog's content, and use
 *   an `<md-dialog-actions>` element for the dialog's actions.
 * - Dialogs must cover the entire application to keep interactions inside of them.
 * Use the `parent` option to change where dialogs are appended.
 *
 * ## Sizing
 * - Complex dialogs can be sized with `flex="percentage"`, i.e. `flex="66"`.
 * - Default max-width is 80% of the `rootElement` or `parent`.
 *
 * ## CSS
 * - `.md-dialog-content` - class that sets the padding on the content as the spec file
 *
 * @usage
 * <hljs lang="html">
 * <div ng-app="demoApp" ng-controller="AppController as ctrl">
 *   <div>
 *     <md-button ng-click="ctrl.showAlert()" class="md-raised md-warn">
 *       Basic Alert!
 *       </md-button>
 *   </div>
 *   <div>
 *     <md-button ng-click="ctrl.showDialog($event)" class="md-raised">
 *       Custom Dialog
 *       </md-button>
 *   </div>
 * </div>
 * </hljs>
 *
 * ### JavaScript: object syntax
 * <hljs lang="js">
 * (function(angular, undefined) {
 *   "use strict";
 *
 *   angular
 *    .module('demoApp', ['ngMaterial'])
 *    .controller('AppCtrl', AppController);
 *
 *   function AppController($mdDialog) {
 *     var alert;
 *     var ctrl = this;
 *     ctrl.showAlert = showAlert;
 *     ctrl.showDialog = showDialog;
 *     ctrl.items = [1, 2, 3];
 *
 *     // Internal method
 *     function showAlert() {
 *       alert = $mdDialog.alert({
 *         title: 'Attention',
 *         textContent: 'This is an example of how simple dialogs can be!',
 *         ok: 'Close'
 *       });
 *
 *       $mdDialog
 *         .show( alert )
 *         .finally(function() {
 *           alert = undefined;
 *         });
 *     }
 *
 *     function showDialog($event) {
 *        var parentEl = angular.element(document.body);
 *        $mdDialog.show({
 *          parent: parentEl,
 *          targetEvent: $event,
 *          template:
 *            '<md-dialog aria-label="List dialog">' +
 *            '  <md-dialog-content>'+
 *            '    <md-list>'+
 *            '      <md-list-item ng-repeat="item in ctrl.items">'+
 *            '       <p>Number {{item}}</p>' +
 *            '      </md-item>'+
 *            '    </md-list>'+
 *            '  </md-dialog-content>' +
 *            '  <md-dialog-actions>' +
 *            '    <md-button ng-click="ctrl.closeDialog()" class="md-primary">' +
 *            '      Close Dialog' +
 *            '    </md-button>' +
 *            '  </md-dialog-actions>' +
 *            '</md-dialog>',
 *          locals: {
 *            items: ctrl.items
 *          },
 *          controller: DialogController
 *          controllerAs: 'ctrl'
 *       });
 *       function DialogController($mdDialog) {
 *         this.closeDialog = function() {
 *           $mdDialog.hide();
 *         }
 *       }
 *     }
 *   }
 * })(angular);
 * </hljs>
 *
 * ### Multiple Dialogs
 * Using the `multiple` option for the `$mdDialog` service allows developers to show multiple
 * dialogs at the same time.
 *
 * <hljs lang="js">
 *   // From plain options
 *   $mdDialog.show({
 *     multiple: true
 *   });
 *
 *   // From a dialog preset
 *   $mdDialog.show(
 *     $mdDialog
 *       .alert()
 *       .multiple(true)
 *   );
 *
 * </hljs>
 *
 * ### Pre-Rendered Dialogs
 * By using the `contentElement` option, it is possible to use an already existing element in the
 * DOM.
 *
 * > Pre-rendered dialogs will be not linked to any scope and will not instantiate any new
 * > controller.<br/>
 * > You can manually link the elements to a scope or instantiate a controller from the template
 * > (using `ng-controller`).
 *
 * <hljs lang="js">
 *   function showPrerenderedDialog() {
 *     $mdDialog.show({
 *       contentElement: '#myStaticDialog',
 *       parent: angular.element(document.body)
 *     });
 *   }
 * </hljs>
 *
 * When using a string as value, `$mdDialog` will automatically query the DOM for the specified CSS
 * selector.
 *
 * <hljs lang="html">
 *   <div style="visibility: hidden">
 *     <div class="md-dialog-container" id="myStaticDialog">
 *       <md-dialog>
 *         This is a pre-rendered dialog.
 *       </md-dialog>
 *     </div>
 *   </div>
 * </hljs>
 *
 * **Notice**: It is important, to use the `.md-dialog-container` as the content element, otherwise
 * the dialog will not show up.
 *
 * It also possible to use a DOM element for the `contentElement` option.
 * - `contentElement: document.querySelector('#myStaticDialog')`
 * - `contentElement: angular.element(TEMPLATE)`
 *
 * When using a `template` as content element, it will be not compiled upon open.
 * This allows you to compile the element yourself and use it each time the dialog opens.
 *
 * ### Custom Presets
 * Developers are also able to create their own preset, which can be used without repeating
 * their options each time.
 *
 * <hljs lang="js">
 *   $mdDialogProvider.addPreset('testPreset', {
 *     options: function() {
 *       return {
 *         template:
 *           '<md-dialog>' +
 *             'This is a custom preset' +
 *           '</md-dialog>',
 *         controllerAs: 'dialog',
 *         bindToController: true,
 *         clickOutsideToClose: true,
 *         escapeToClose: true
 *       };
 *     }
 *   });
 * </hljs>
 *
 * After creating your preset in the `config` phase, you can access it.
 *
 * <hljs lang="js">
 *   $mdDialog.show(
 *     $mdDialog.testPreset()
 *   );
 * </hljs>
 *
 * ### JavaScript: promise API syntax, custom dialog template
 *
 * <hljs lang="js">
 * (function(angular, undefined) {
 *   "use strict";
 *
 *   angular
 *     .module('demoApp', ['ngMaterial'])
 *     .controller('EmployeeController', EmployeeController)
 *     .controller('GreetingController', GreetingController);
 *
 *   // Fictitious Employee Editor to show how to use simple and complex dialogs.
 *
 *   function EmployeeController($mdDialog) {
 *     var alert;
 *     var ctrl = this;
 *
 *     ctrl.showAlert = showAlert;
 *     ctrl.showGreeting = showCustomGreeting;
 *
 *     ctrl.hasAlert = function() { return !!alert };
 *     ctrl.userName = ctrl.userName || 'Bobby';
 *
 *     // Dialog #1 - Show simple alert dialog and cache reference to dialog instance
 *
 *     function showAlert() {
 *       alert = $mdDialog.alert()
 *         .title('Attention, ' + ctrl.userName)
 *         .textContent('This is an example of how simple dialogs can be!')
 *         .ok('Close');
 *
 *       $mdDialog
 *         .show(alert)
 *         .finally(function() {
 *           alert = undefined;
 *         });
 *     }
 *
 *     // Dialog #2 - Demonstrate more complex dialogs construction and popup.
 *
 *     function showCustomGreeting($event) {
 *       $mdDialog.show({
 *         targetEvent: $event,
 *         template:
 *           '<md-dialog>' +
 *           '  <md-dialog-content>Hello {{ ctrl.employee }}!</md-dialog-content>' +
 *           '  <md-dialog-actions>' +
 *           '    <md-button ng-click="ctrl.closeDialog()" class="md-primary">' +
 *           '      Close Greeting' +
 *           '    </md-button>' +
 *           '  </md-dialog-actions>' +
 *           '</md-dialog>',
 *         controller: GreetingController,
 *         controllerAs: 'ctrl',
 *         onComplete: afterShowAnimation,
 *         locals: { employee: ctrl.userName }
 *       });
 *
 *       // When the 'enter' animation finishes...
 *       function afterShowAnimation(scope, element, options) {
 *         // post-show code here: DOM element focus, etc.
 *       }
 *     }
 *   }
 *
 *   // Greeting controller used with the 'showCustomGreeting()' custom dialog
 *   function GreetingController($mdDialog, $log) {
 *     var ctrl = this;
 *     this.$log = $log;
 *
 *     ctrl.closeDialog = function() {
 *       // Hides the most recent dialog shown.
 *       // No specific dialog instance reference is needed.
 *       $mdDialog.hide();
 *     };
 *   }
 *
 *   GreetingController.prototype.$onInit = function() {
 *     // Assigned from the locals options passed to $mdDialog.show.
 *     this.$log.log('Employee Name: ', ctrl.employee);
 *   };
 *
 * })(angular);
 * </hljs>
 */

/**
 * @ngdoc method
 * @name $mdDialog#alert
 *
 * @description
 * Builds a preconfigured dialog with the specified message.
 *
 * @returns {Object} a dialog preset with the chainable configuration methods:
 *
 * - `title(string)` - Sets the alert title.
 * - `textContent(string)` - Sets the alert message.
 * - `htmlContent(string)` - Sets the alert message as HTML. Requires the `ngSanitize`
 *     module to be loaded. HTML is not run through AngularJS' compiler.
 * - `ok(string)` - Sets the alert "Okay" button text.
 * - `theme(string)` - Sets the theme of the alert dialog.
 * - `targetEvent(DOMClickEvent=)` - A click's event object. When passed in as an
 *     option, the location of the click will be used as the starting point for the opening
 *     animation of the the dialog.
 */

/**
 * @ngdoc method
 * @name $mdDialog#confirm
 *
 * @description
 * Builds a preconfigured dialog with the specified message. You can call show and the promise
 * returned will be resolved if the user clicks the confirm action on the dialog. The promise will
 * be rejected if the user clicks the cancel action or dismisses the dialog.
 *
 * @returns {Object} a dialog preset with the chainable configuration methods:
 *
 * Additionally, it supports the following methods:
 *
 * - `title(string)` - Sets the confirm title.
 * - `textContent(string)` - Sets the confirm message.
 * - `htmlContent(string)` - Sets the confirm message as HTML. Requires the `ngSanitize`
 *     module to be loaded. HTML is not run through AngularJS' compiler.
 * - `ok(string)` - Sets the confirm "Okay" button text.
 * - `cancel(string)` - Sets the confirm "Cancel" button text.
 * - `theme(string)` - Sets the theme of the confirm dialog.
 * - `targetEvent(DOMClickEvent=)` - A click's event object. When passed in as an
 *     option, the location of the click will be used as the starting point for the opening
 *     animation of the the dialog.
 */

/**
 * @ngdoc method
 * @name $mdDialog#prompt
 *
 * @description
 * Builds a preconfigured dialog with the specified message and input box. You can call show and the
 * promise returned will be resolved, if the user clicks the prompt action on the dialog, passing
 * the input value as the first argument. The promise will be rejected if the user clicks the cancel
 * action or dismisses the dialog.
 *
 * @returns {Object} a dialog preset with the chainable configuration methods:
 *
 * Additionally, it supports the following methods:
 *
 * - `title(string)` - Sets the prompt title.
 * - `textContent(string)` - Sets the prompt message.
 * - `htmlContent(string)` - Sets the prompt message as HTML. Requires the `ngSanitize`
 *     module to be loaded. HTML is not run through AngularJS' compiler.
 * - `placeholder(string)` - Sets the placeholder text for the input.
 * - `required(boolean)` - Sets the input required value.
 * - `initialValue(string)` - Sets the initial value for the prompt input.
 * - `ok(string)` - Sets the prompt "Okay" button text.
 * - `cancel(string)` - Sets the prompt "Cancel" button text.
 * - `theme(string)` - Sets the theme of the prompt dialog.
 * - `targetEvent(DOMClickEvent=)` - A click's event object. When passed in as an
 *     option, the location of the click will be used as the starting point for the opening
 *     animation of the the dialog.
 */

/**
 * @ngdoc method
 * @name $mdDialog#show
 *
 * @description
 * Show a dialog with the specified options.
 *
 * @param {Object} optionsOrPreset Either provide a dialog preset returned from `alert()`,
 * `prompt()`, or `confirm()`; or an options object with the following properties:
 *   - `templateUrl` - `{string=}`: The url of a template that will be used as the content
 *      of the dialog.
 *   - `template` - `{string=}`: HTML template to show in the dialog. This **must** be trusted HTML
 *      with respect to AngularJS' [$sce service](https://docs.angularjs.org/api/ng/service/$sce).
 *      This template should **never** be constructed with any kind of user input or user data.
 *   - `contentElement` - `{string|Element}`: Instead of using a template, which will be compiled
 *      each time a dialog opens, you can also use a DOM element.<br/>
 *     * When specifying an element, which is present on the DOM, `$mdDialog` will temporary fetch
 *     the element into the dialog and restores it at the old DOM position upon close.
 *     * When specifying a string, the string be used as a CSS selector, to lookup for the element
 *     in the DOM.
 *   - `autoWrap` - `{boolean=}`: Whether or not to automatically wrap the template with a
 *     `<md-dialog>` tag if one is not provided. Defaults to true. Can be disabled if you provide a
 *     custom dialog directive.
 *   - `targetEvent` - `{DOMClickEvent=}`: A click's event object. When passed in as an option,
 *     the location of the click will be used as the starting point for the opening animation
 *     of the the dialog.
 *   - `openFrom` - `{string|Element|Object}`: The query selector, DOM element or the Rect object
 *     that is used to determine the bounds (top, left, height, width) from which the Dialog will
 *     originate.
 *   - `closeTo` - `{string|Element|Object}`: The query selector, DOM element or the Rect object
 *     that is used to determine the bounds (top, left, height, width) to which the Dialog will
 *     target.
 *   - `scope` - `{Object=}`: the scope to link the template / controller to. If none is specified,
 *     it will create a new isolate scope.
 *     This scope will be destroyed when the dialog is removed unless `preserveScope` is set to
 *     true.
 *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed.
 *     Default is false
 *   - `disableParentScroll` - `{boolean=}`: Whether to disable scrolling while the dialog is open.
 *     Default true.
 *   - `hasBackdrop` - `{boolean=}`: Whether there should be an opaque backdrop behind the dialog.
 *     Default true.
 *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click outside the dialog to
 *     close it. Default false.
 *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to close the dialog.
 *     Default true.
 *   - `focusOnOpen` - `{boolean=}`: An option to override focus behavior on open. Only disable if
 *     focusing some other way, as focus management is required for dialogs to be accessible.
 *     Defaults to true.
 *   - `controller` - `{Function|string=}`: The controller to associate with the dialog. The
 *     controller will be injected with the local `$mdDialog`, which passes along a scope for the
 *     dialog.
 *   - `locals` - `{Object=}`: An object containing key/value pairs. The keys will be used as names
 *     of values to inject into the controller. For example, `locals: {three: 3}` would inject
 *     `three` into the controller, with the value 3. If `bindToController` is true, they will be
 *     copied to the controller instead.
 *   - `bindToController` - `bool`: bind the locals to the controller, instead of passing them in.
 *   - `resolve` - `{Function=}`: Similar to locals, except it takes as values functions that return
 *     promises, and the dialog will not open until all of the promises resolve.
 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
 *   - `parent` - `{element=}`: The element to append the dialog to. Defaults to appending
 *     to the root element of the application.
 *   - `onShowing` - `Function(scope, element, options: Object=, controller: Object)=`: Callback
 *     function used to notify the show() animation is starting.
 *   - `onComplete` - `Function(scope, element, options: Object=)=`: Callback function used to
 *     notify when the show() animation is finished.
 *   - `onRemoving` - `Function(element, removePromise)`: Callback function used to announce the
 *      close/hide() action is starting. This allows developers to run custom animations
 *      in parallel with the close animations.
 *   - `fullscreen` `{boolean=}`: An option to toggle whether the dialog should show in fullscreen
 *      or not. Defaults to `false`.
 *   - `multiple` `{boolean=}`: An option to allow this dialog to display over one that's currently
 *     open.
 * @returns {Promise} A promise that can be resolved with `$mdDialog.hide()` or
 * rejected with `$mdDialog.cancel()`.
 */

/**
 * @ngdoc method
 * @name $mdDialog#hide
 *
 * @description
 * Hide an existing dialog and resolve the promise returned from `$mdDialog.show()`.
 *
 * @param {*=} response An argument for the resolved promise.
 *
 * @returns {promise} A promise that is resolved when the dialog has been closed.
 */

/**
 * @ngdoc method
 * @name $mdDialog#cancel
 *
 * @description
 * Hide an existing dialog and reject the promise returned from `$mdDialog.show()`.
 *
 * @param {*=} response An argument for the rejected promise.
 *
 * @returns {promise} A promise that is resolved when the dialog has been closed.
 */

function MdDialogProvider($$interimElementProvider) {
  // Elements to capture and redirect focus when the user presses tab at the dialog boundary.
  MdDialogController.$inject = ["$mdDialog", "$mdConstant"];
  dialogDefaultOptions.$inject = ["$mdDialog", "$mdAria", "$mdUtil", "$mdConstant", "$animate", "$document", "$window", "$rootElement", "$log", "$injector", "$mdTheming", "$interpolate", "$mdInteraction"];
  var topFocusTrap, bottomFocusTrap;
  var removeFocusTrap;

  return $$interimElementProvider('$mdDialog')
    .setDefaults({
      methods: ['disableParentScroll', 'hasBackdrop', 'clickOutsideToClose', 'escapeToClose',
          'targetEvent', 'closeTo', 'openFrom', 'parent', 'fullscreen', 'multiple'],
      options: dialogDefaultOptions
    })
    .addPreset('alert', {
      methods: ['title', 'htmlContent', 'textContent', 'ariaLabel', 'ok', 'theme',
          'css'],
      options: advancedDialogOptions
    })
    .addPreset('confirm', {
      methods: ['title', 'htmlContent', 'textContent', 'ariaLabel', 'ok', 'cancel',
          'theme', 'css'],
      options: advancedDialogOptions
    })
    .addPreset('prompt', {
      methods: ['title', 'htmlContent', 'textContent', 'initialValue', 'placeholder', 'ariaLabel',
          'ok', 'cancel', 'theme', 'css', 'required'],
      options: advancedDialogOptions
    });

  /* @ngInject */
  function advancedDialogOptions() {
    return {
      template: [
        '<md-dialog md-theme="{{ dialog.theme || dialog.defaultTheme }}" aria-label="{{ dialog.ariaLabel }}" ng-class="dialog.css">',
        '  <md-dialog-content class="md-dialog-content" role="document" tabIndex="-1">',
        '    <h2 class="md-title">{{ dialog.title }}</h2>',
        '    <div ng-if="::dialog.mdHtmlContent" class="md-dialog-content-body" ',
        '        ng-bind-html="::dialog.mdHtmlContent"></div>',
        '    <div ng-if="::!dialog.mdHtmlContent" class="md-dialog-content-body">',
        '      <p>{{::dialog.mdTextContent}}</p>',
        '    </div>',
        '    <md-input-container md-no-float ng-if="::dialog.$type == \'prompt\'" class="md-prompt-input-container">',
        '      <input ng-keypress="dialog.keypress($event)" md-autofocus ng-model="dialog.result" ' +
        '             placeholder="{{::dialog.placeholder}}" ng-required="dialog.required">',
        '    </md-input-container>',
        '  </md-dialog-content>',
        '  <md-dialog-actions>',
        '    <md-button ng-if="dialog.$type === \'confirm\' || dialog.$type === \'prompt\'"' +
        '               ng-click="dialog.abort()" class="md-primary md-cancel-button">',
        '      {{ dialog.cancel }}',
        '    </md-button>',
        '    <md-button ng-click="dialog.hide()" class="md-primary md-confirm-button" md-autofocus="dialog.$type===\'alert\'"' +
        '               ng-disabled="dialog.required && !dialog.result">',
        '      {{ dialog.ok }}',
        '    </md-button>',
        '  </md-dialog-actions>',
        '</md-dialog>'
      ].join('').replace(/\s\s+/g, ''),
      controller: MdDialogController,
      controllerAs: 'dialog',
      bindToController: true,
    };
  }

  /**
   * Controller for the md-dialog interim elements
   * @ngInject
   */
  function MdDialogController($mdDialog, $mdConstant) {
    // For compatibility with AngularJS 1.6+, we should always use the $onInit hook in
    // interimElements. The $mdCompiler simulates the $onInit hook for all versions.
    this.$onInit = function() {
      var isPrompt = this.$type === 'prompt';

      if (isPrompt && this.initialValue) {
        this.result = this.initialValue;
      }

      this.hide = function() {
        $mdDialog.hide(isPrompt ? this.result : true);
      };
      this.abort = function() {
        $mdDialog.cancel();
      };
      this.keypress = function($event) {
        var invalidPrompt = isPrompt && this.required && !angular.isDefined(this.result);

        if ($event.keyCode === $mdConstant.KEY_CODE.ENTER && !invalidPrompt) {
          $mdDialog.hide(this.result);
        }
      };
    };
  }

  /* @ngInject */
  function dialogDefaultOptions($mdDialog, $mdAria, $mdUtil, $mdConstant, $animate, $document,
                                $window, $rootElement, $log, $injector, $mdTheming, $interpolate,
                                $mdInteraction) {
    return {
      hasBackdrop: true,
      isolateScope: true,
      onCompiling: beforeCompile,
      onShow: onShow,
      onShowing: beforeShow,
      onRemove: onRemove,
      clickOutsideToClose: false,
      escapeToClose: true,
      targetEvent: null,
      closeTo: null,
      openFrom: null,
      focusOnOpen: true,
      disableParentScroll: true,
      autoWrap: true,
      fullscreen: false,
      transformTemplate: function(template, options) {
        // Make the dialog container focusable, because otherwise the focus will be always
        // redirected to an element outside of the container, and the focus trap won't work.
        // Also the tabindex is needed for the `escapeToClose` functionality, because
        // the keyDown event can't be triggered when the focus is outside of the container.
        var startSymbol = $interpolate.startSymbol();
        var endSymbol = $interpolate.endSymbol();
        var theme = startSymbol + (options.themeWatch ? '' : '::') + 'theme' + endSymbol;
        var themeAttr = (options.hasTheme) ? 'md-theme="'+theme+'"': '';
        return '<div class="md-dialog-container" tabindex="-1" ' + themeAttr + '>' + validatedTemplate(template) + '</div>';

        /**
         * The specified template should contain a <md-dialog> wrapper element....
         */
        function validatedTemplate(template) {
          if (options.autoWrap && !/<\/md-dialog>/g.test(template)) {
            return '<md-dialog>' + (template || '') + '</md-dialog>';
          } else {
            return template || '';
          }
        }
      }
    };

    function beforeCompile(options) {
      // Automatically apply the theme, if the user didn't specify a theme explicitly.
      // Those option changes need to be done, before the compilation has started, because otherwise
      // the option changes will be not available in the $mdCompilers locales.
      options.defaultTheme = $mdTheming.defaultTheme();

      detectTheming(options);
    }

    function beforeShow(scope, element, options, controller) {

      if (controller) {
        var mdHtmlContent = controller.htmlContent || options.htmlContent || '';
        var mdTextContent = controller.textContent || options.textContent || '';

        if (mdHtmlContent && !$injector.has('$sanitize')) {
          throw Error('The ngSanitize module must be loaded in order to use htmlContent.');
        }

        if (mdHtmlContent && mdTextContent) {
          throw Error('md-dialog cannot have both `htmlContent` and `textContent`');
        }

        // Only assign the content if nothing throws, otherwise it'll still be compiled.
        controller.mdHtmlContent = mdHtmlContent;
        controller.mdTextContent = mdTextContent;
      }
    }

    /** Show method for dialogs */
    function onShow(scope, element, options) {
      angular.element($document[0].body).addClass('md-dialog-is-showing');

      var dialogElement = element.find('md-dialog');

      // Once a dialog has `ng-cloak` applied on his template the dialog animation will not work
      // properly. This is a very common problem, so we have to notify the developer about this.
      if (dialogElement.hasClass('ng-cloak')) {
        var message =
          '$mdDialog: using `<md-dialog ng-cloak>` will affect the dialog opening animations.';
        $log.warn(message, element[0]);
      }

      captureParentAndFromToElements(options);
      configureAria(dialogElement, options);
      showBackdrop(scope, element, options);
      activateListeners(element, options);

      return dialogPopIn(element, options)
        .then(function() {
          lockScreenReader(element, options);
          focusOnOpen();
        });

      /**
       * For alerts, focus on content... otherwise focus on the close button (or equivalent)
       */
      function focusOnOpen() {
        if (options.focusOnOpen) {
          var target = $mdUtil.findFocusTarget(element) || findCloseButton() || dialogElement;
          target.focus();
        }

        /**
         * If no element with class dialog-close, try to find the last
         * button child in md-dialog-actions and assume it is a close button.
         *
         * If we find no actions at all, log a warning to the console.
         */
        function findCloseButton() {
          return element[0].querySelector('.dialog-close, md-dialog-actions button:last-child');
        }
      }
    }

    /**
     * Remove function for all dialogs
     */
    function onRemove(scope, element, options) {
      options.deactivateListeners();
      options.unlockScreenReader();
      options.hideBackdrop(options.$destroy);

      // Remove the focus traps that we added earlier for keeping focus within the dialog.
      if (removeFocusTrap) {
        removeFocusTrap();
        removeFocusTrap = null;
      }

      // For navigation $destroy events, do a quick, non-animated removal,
      // but for normal closes (from clicks, etc) animate the removal
      return options.$destroy ? detachAndClean() : animateRemoval().then(detachAndClean);

      /**
       * For normal closes, animate the removal.
       * For forced closes (like $destroy events), skip the animations
       */
      function animateRemoval() {
        return dialogPopOut(element, options);
      }

      /**
       * Detach the element
       */
      function detachAndClean() {
        angular.element($document[0].body).removeClass('md-dialog-is-showing');

        // Reverse the container stretch if using a content element.
        if (options.contentElement) {
          options.reverseContainerStretch();
        }

        // Exposed cleanup function from the $mdCompiler.
        options.cleanupElement();

        // Restores the focus to the origin element if the last interaction upon opening was a keyboard.
        if (!options.$destroy && options.originInteraction === 'keyboard') {
          options.origin.focus();
        }
      }
    }

    function detectTheming(options) {
      // Once the user specifies a targetEvent, we will automatically try to find the correct
      // nested theme.
      var targetEl;
      if (options.targetEvent && options.targetEvent.target) {
        targetEl = angular.element(options.targetEvent.target);
      }

      var themeCtrl = targetEl && targetEl.controller('mdTheme');

      options.hasTheme = (!!themeCtrl);

      if (!options.hasTheme) {
        return;
      }

      options.themeWatch = themeCtrl.$shouldWatch;

      var theme = options.theme || themeCtrl.$mdTheme;

      if (theme) {
        options.scope.theme = theme;
      }

      var unwatch = themeCtrl.registerChanges(function (newTheme) {
        options.scope.theme = newTheme;

        if (!options.themeWatch) {
          unwatch();
        }
      });
    }

    /**
     * Capture originator/trigger/from/to element information (if available)
     * and the parent container for the dialog; defaults to the $rootElement
     * unless overridden in the options.parent
     */
    function captureParentAndFromToElements(options) {
          options.origin = angular.extend({
            element: null,
            bounds: null,
            focus: angular.noop
          }, options.origin || {});

          options.parent   = getDomElement(options.parent, $rootElement);
          options.closeTo  = getBoundingClientRect(getDomElement(options.closeTo));
          options.openFrom = getBoundingClientRect(getDomElement(options.openFrom));

          if (options.targetEvent) {
            options.origin = getBoundingClientRect(options.targetEvent.target, options.origin);
            options.originInteraction = $mdInteraction.getLastInteractionType();
          }


          /**
           * Identify the bounding RECT for the target element
           *
           */
          function getBoundingClientRect (element, orig) {
            var source = angular.element((element || {}));
            if (source && source.length) {
              // Compute and save the target element's bounding rect, so that if the
              // element is hidden when the dialog closes, we can shrink the dialog
              // back to the same position it expanded from.
              //
              // Checking if the source is a rect object or a DOM element
              var bounds = {top:0,left:0,height:0,width:0};
              var hasFn = angular.isFunction(source[0].getBoundingClientRect);

              return angular.extend(orig || {}, {
                  element : hasFn ? source : undefined,
                  bounds  : hasFn ? source[0].getBoundingClientRect() : angular.extend({}, bounds, source[0]),
                  focus   : angular.bind(source, source.focus),
              });
            }
          }

          /**
           * If the specifier is a simple string selector, then query for
           * the DOM element.
           */
          function getDomElement(element, defaultElement) {
            if (angular.isString(element)) {
              element = $document[0].querySelector(element);
            }

            // If we have a reference to a raw dom element, always wrap it in jqLite
            return angular.element(element || defaultElement);
          }

        }

    /**
     * Listen for escape keys and outside clicks to auto close
     */
    function activateListeners(element, options) {
      var window = angular.element($window);
      var onWindowResize = $mdUtil.debounce(function() {
        stretchDialogContainerToViewport(element, options);
      }, 60);

      var removeListeners = [];
      var smartClose = function() {
        // Only 'confirm' dialogs have a cancel button... escape/clickOutside will
        // cancel or fallback to hide.
        var closeFn = (options.$type === 'alert') ? $mdDialog.hide : $mdDialog.cancel;
        $mdUtil.nextTick(closeFn, true);
      };

      if (options.escapeToClose) {
        var parentTarget = options.parent;
        var keyHandlerFn = function(ev) {
          if (ev.keyCode === $mdConstant.KEY_CODE.ESCAPE) {
            ev.stopImmediatePropagation();
            ev.preventDefault();

            smartClose();
          }
        };

        // Add keydown listeners
        element.on('keydown', keyHandlerFn);
        parentTarget.on('keydown', keyHandlerFn);

        // Queue remove listeners function
        removeListeners.push(function() {
          element.off('keydown', keyHandlerFn);
          parentTarget.off('keydown', keyHandlerFn);
        });
      }

      // Register listener to update dialog on window resize
      window.on('resize', onWindowResize);

      removeListeners.push(function() {
        window.off('resize', onWindowResize);
      });

      if (options.clickOutsideToClose) {
        var target = element;
        var sourceElem;

        // Keep track of the element on which the mouse originally went down
        // so that we can only close the backdrop when the 'click' started on it.
        // A simple 'click' handler does not work,
        // it sets the target object as the element the mouse went down on.
        var mousedownHandler = function(ev) {
          sourceElem = ev.target;
        };

        // We check if our original element and the target is the backdrop
        // because if the original was the backdrop and the target was inside the dialog
        // we don't want to dialog to close.
        var mouseupHandler = function(ev) {
          if (sourceElem === target[0] && ev.target === target[0]) {
            ev.stopPropagation();
            ev.preventDefault();

            smartClose();
          }
        };

        // Add listeners
        target.on('mousedown', mousedownHandler);
        target.on('mouseup', mouseupHandler);

        // Queue remove listeners function
        removeListeners.push(function() {
          target.off('mousedown', mousedownHandler);
          target.off('mouseup', mouseupHandler);
        });
      }

      // Attach specific `remove` listener handler
      options.deactivateListeners = function() {
        removeListeners.forEach(function(removeFn) {
          removeFn();
        });
        options.deactivateListeners = null;
      };
    }

    /**
     * Show modal backdrop element...
     */
    function showBackdrop(scope, element, options) {

      if (options.disableParentScroll) {
        // !! DO this before creating the backdrop; since disableScrollAround()
        //    configures the scroll offset; which is used by mdBackDrop postLink()
        options.restoreScroll = $mdUtil.disableScrollAround(element, options.parent);
      }

      if (options.hasBackdrop) {
        options.backdrop = $mdUtil.createBackdrop(scope, "md-dialog-backdrop md-opaque");
        $animate.enter(options.backdrop, options.parent);
      }

      /**
       * Hide modal backdrop element...
       */
      options.hideBackdrop = function hideBackdrop($destroy) {
        if (options.backdrop) {
          if ($destroy) {
            options.backdrop.remove();
          } else {
            $animate.leave(options.backdrop);
          }
        }

        if (options.disableParentScroll) {
          options.restoreScroll && options.restoreScroll();
          delete options.restoreScroll;
        }

        options.hideBackdrop = null;
      };
    }

    /**
     * Inject ARIA-specific attributes appropriate for Dialogs
     */
    function configureAria(element, options) {

      var role = (options.$type === 'alert') ? 'alertdialog' : 'dialog';
      var dialogContent = element.find('md-dialog-content');
      var existingDialogId = element.attr('id');
      var dialogContentId = 'dialogContent_' + (existingDialogId || $mdUtil.nextUid());

      element.attr({
        'role': role,
        'tabIndex': '-1'
      });

      if (dialogContent.length === 0) {
        dialogContent = element;
        // If the dialog element already had an ID, don't clobber it.
        if (existingDialogId) {
          dialogContentId = existingDialogId;
        }
      }

      dialogContent.attr('id', dialogContentId);
      element.attr('aria-describedby', dialogContentId);

      if (options.ariaLabel) {
        $mdAria.expect(element, 'aria-label', options.ariaLabel);
      }
      else {
        $mdAria.expectAsync(element, 'aria-label', function() {
          // If dialog title is specified, set aria-label with it
          // See https://github.com/angular/material/issues/10582
          if (options.title) {
            return options.title;
          } else {
            var words = dialogContent.text().split(/\s+/);
            if (words.length > 3) words = words.slice(0, 3).concat('...');
            return words.join(' ');
          }
        });
      }

      // Set up elements before and after the dialog content to capture focus and
      // redirect back into the dialog.
      topFocusTrap = document.createElement('div');
      topFocusTrap.classList.add('md-dialog-focus-trap');
      topFocusTrap.tabIndex = 0;

      bottomFocusTrap = topFocusTrap.cloneNode(false);

      /**
       * When focus is about to move out of the end of the dialog, we intercept it and redirect it
       * back to the md-dialog element.
       * When focus is about to move out of the start of the dialog, we intercept it and redirect it
       * back to the last focusable element in the md-dialog.
       * @param {FocusEvent} event
       */
      var focusHandler = function(event) {
        if (event.target && event.target.nextSibling &&
            event.target.nextSibling.nodeName === 'MD-DIALOG') {
          var lastFocusableElement = $mdUtil.getLastTabbableElement(element[0]);
          if (angular.isElement(lastFocusableElement)) {
            lastFocusableElement.focus();
          }
        } else {
          element.focus();
        }
      };

      topFocusTrap.addEventListener('focus', focusHandler);
      bottomFocusTrap.addEventListener('focus', focusHandler);

      removeFocusTrap = function () {
        topFocusTrap.removeEventListener('focus', focusHandler);
        bottomFocusTrap.removeEventListener('focus', focusHandler);

        if (topFocusTrap && topFocusTrap.parentNode) {
          topFocusTrap.parentNode.removeChild(topFocusTrap);
        }

        if (bottomFocusTrap && bottomFocusTrap.parentNode) {
          bottomFocusTrap.parentNode.removeChild(bottomFocusTrap);
        }
      };

      // The top focus trap inserted immediately before the md-dialog element (as a sibling).
      // The bottom focus trap is inserted immediately after the md-dialog element (as a sibling).
      element[0].parentNode.insertBefore(topFocusTrap, element[0]);
      element.after(bottomFocusTrap);
    }

    /**
     * Prevents screen reader interaction behind modal window on swipe interfaces.
     */
    function lockScreenReader(element, options) {
      var isHidden = true;

      // get raw DOM node
      walkDOM(element[0]);

      options.unlockScreenReader = function () {
        isHidden = false;
        walkDOM(element[0]);

        options.unlockScreenReader = null;
      };

      /**
       * Get all of an element's parent elements up the DOM tree.
       * @param {Node & ParentNode} element the element to start from
       * @return {Element[]} The parent elements
       */
      function getParents(element) {
        var parents = [];
        while (element.parentNode) {
          if (element === document.body) {
            return parents;
          }
          var children = element.parentNode.children;
          for (var i = 0; i < children.length; i++) {
            // skip over child if it is an ascendant of the dialog
            // a script or style tag, or a live region.
            if (element !== children[i] &&
                !isNodeOneOf(children[i], ['SCRIPT', 'STYLE']) &&
                !children[i].hasAttribute('aria-live')) {
              parents.push(children[i]);
            }
          }
          element = element.parentNode;
        }
        return parents;
      }

      /**
       * Walk DOM to apply or remove aria-hidden on sibling nodes and parent sibling nodes.
       * @param {Element} element the element to start from when walking up the DOM
       * @returns {void}
       */
      function walkDOM(element) {
        var elements = getParents(element);
        for (var i = 0; i < elements.length; i++) {
          elements[i].setAttribute('aria-hidden', isHidden);
        }
      }
    }

    /**
     * Ensure the dialog container fill-stretches to the viewport.
     * @param {JQLite} container dialog container
     * @param {Object} options
     * @returns {function(): void} function that reverts the modified styles
     */
    function stretchDialogContainerToViewport(container, options) {
      var isFixed = $window.getComputedStyle($document[0].body).position === 'fixed';
      var backdrop = options.backdrop ? $window.getComputedStyle(options.backdrop[0]) : null;
      var height = backdrop ?
        Math.min($document[0].body.clientHeight, Math.ceil(Math.abs(parseInt(backdrop.height, 10))))
        : 0;

      var previousStyles = {
        top: container.css('top'),
        height: container.css('height')
      };

      // If the body is fixed, determine the distance to the viewport in relative from the parent.
      var parentTop = Math.abs(options.parent[0].getBoundingClientRect().top);

      container.css({
        top: (isFixed ? parentTop : 0) + 'px',
        height: height ? height + 'px' : '100%'
      });

      return function() {
        // Reverts the modified styles back to the previous values.
        // This is needed for contentElements, which should have the same styles after close
        // as before.
        container.css(previousStyles);
      };
    }

    /**
     * Dialog open and pop-in animation.
     * @param {JQLite} container dialog container
     * @param {Object} options
     * @returns {*}
     */
    function dialogPopIn(container, options) {
      // Add the `md-dialog-container` to the DOM
      options.parent.append(container);
      options.reverseContainerStretch = stretchDialogContainerToViewport(container, options);

      var dialogEl = container.find('md-dialog');
      var animator = $mdUtil.dom.animator;
      var buildTranslateToOrigin = animator.calculateZoomToOrigin;
      var translateOptions = {transitionInClass: 'md-transition-in', transitionOutClass: 'md-transition-out'};
      var from = animator.toTransformCss(buildTranslateToOrigin(dialogEl, options.openFrom || options.origin));
      var to = animator.toTransformCss("");  // defaults to center display (or parent or $rootElement)

      dialogEl.toggleClass('md-dialog-fullscreen', !!options.fullscreen);

      return animator
        .translate3d(dialogEl, from, to, translateOptions)
        .then(function(animateReversal) {

          // Build a reversal translate function synced to this translation...
          options.reverseAnimate = function() {
            delete options.reverseAnimate;

            if (options.closeTo) {
              // Using the opposite classes to create a close animation to the closeTo element
              translateOptions = {transitionInClass: 'md-transition-out', transitionOutClass: 'md-transition-in'};
              from = to;
              to = animator.toTransformCss(buildTranslateToOrigin(dialogEl, options.closeTo));

              return animator
                .translate3d(dialogEl, from, to,translateOptions);
            }

            return animateReversal(
              to = animator.toTransformCss(
                // in case the origin element has moved or is hidden,
                // let's recalculate the translateCSS
                buildTranslateToOrigin(dialogEl, options.origin)
              )
            );
          };

          // Function to revert the generated animation styles on the dialog element.
          // Useful when using a contentElement instead of a template.
          options.clearAnimate = function() {
            delete options.clearAnimate;

            // Remove the transition classes, added from $animateCSS, since those can't be removed
            // by reversely running the animator.
            dialogEl.removeClass([
              translateOptions.transitionOutClass,
              translateOptions.transitionInClass
            ].join(' '));

            // Run the animation reversely to remove the previous added animation styles.
            return animator.translate3d(dialogEl, to, animator.toTransformCss(''), {});
          };

          return true;
        });
    }

    /**
     * Dialog close and pop-out animation.
     * @param {JQLite} container dialog container
     * @param {Object} options
     * @returns {*}
     */
    function dialogPopOut(container, options) {
      return options.reverseAnimate().then(function() {
        if (options.contentElement) {
          // When we use a contentElement, we want the element to be the same as before.
          // That means, that we have to clear all the animation properties, like transform.
          options.clearAnimate();
        }
      });
    }

    /**
     * Utility function to filter out raw DOM nodes.
     * @param {Node} elem
     * @param {string[]} nodeTypeArray
     * @returns {boolean}
     */
    function isNodeOneOf(elem, nodeTypeArray) {
      return nodeTypeArray.indexOf(elem.nodeName) !== -1;
    }
  }
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.divider
 * @description Divider module!
 */
MdDividerDirective.$inject = ["$mdTheming"];
angular.module('material.components.divider', [
  'material.core'
])
  .directive('mdDivider', MdDividerDirective);

/**
 * @ngdoc directive
 * @name mdDivider
 * @module material.components.divider
 * @restrict E
 *
 * @description
 * Dividers group and separate content within lists and page layouts using strong visual and spatial distinctions. This divider is a thin rule, lightweight enough to not distract the user from content.
 *
 * @param {boolean=} md-inset Add this attribute to activate the inset divider style.
 * @usage
 * <hljs lang="html">
 * <md-divider></md-divider>
 *
 * <md-divider md-inset></md-divider>
 * </hljs>
 *
 */
function MdDividerDirective($mdTheming) {
  return {
    restrict: 'E',
    link: $mdTheming
  };
}

})();
(function(){
"use strict";

(function() {
  'use strict';

  /**
   * @ngdoc module
   * @name material.components.fabActions
   */
  MdFabActionsDirective.$inject = ["$mdUtil"];
  angular
    .module('material.components.fabActions', ['material.core'])
    .directive('mdFabActions', MdFabActionsDirective);

  /**
   * @ngdoc directive
   * @name mdFabActions
   * @module material.components.fabActions
   *
   * @restrict E
   *
   * @description
   * The `<md-fab-actions>` directive is used inside of a `<md-fab-speed-dial>` or
   * `<md-fab-toolbar>` directive to mark an element (or elements) as the actions and setup the
   * proper event listeners.
   *
   * @usage
   * See the `<md-fab-speed-dial>` or `<md-fab-toolbar>` directives for example usage.
   */
  function MdFabActionsDirective($mdUtil) {
    return {
      restrict: 'E',

      require: ['^?mdFabSpeedDial', '^?mdFabToolbar'],

      compile: function(element, attributes) {
        var children = element.children();
        var actionItemButtons;
        var hasNgRepeat = $mdUtil.prefixer().hasAttribute(children, 'ng-repeat');

        // Action item buttons should not be in the tab order when the speed dial is closed.
        actionItemButtons = element.find('md-button');
        angular.forEach(actionItemButtons, function(button) {
          button.setAttribute('tabindex', -1);
        });

        // Support both ng-repeat and static content
        if (hasNgRepeat) {
          children.addClass('md-fab-action-item');
        } else {
          // Wrap every child in a new div and add a class that we can scale/fling independently
          children.wrap('<div class="md-fab-action-item">');
        }
      }
    };
  }
})();

})();
(function(){
"use strict";

(function() {
  'use strict';

  MdFabController.$inject = ["$scope", "$element", "$animate", "$mdUtil", "$mdConstant", "$timeout"];
  angular.module('material.components.fabShared', ['material.core'])
    .controller('MdFabController', MdFabController);

  function MdFabController($scope, $element, $animate, $mdUtil, $mdConstant, $timeout) {
    var ctrl = this;
    var initialAnimationAttempts = 0;

    // NOTE: We use async eval(s) below to avoid conflicts with any existing digest loops

    ctrl.open = function() {
      $scope.$evalAsync("ctrl.isOpen = true");
    };

    ctrl.close = function() {
      // Async eval to avoid conflicts with existing digest loops
      $scope.$evalAsync("ctrl.isOpen = false");

      // Focus the trigger when the element closes so users can still tab to the next item
      $element.find('md-fab-trigger')[0].focus();
    };

    // Toggle the open/close state when the trigger is clicked
    ctrl.toggle = function() {
      $scope.$evalAsync("ctrl.isOpen = !ctrl.isOpen");
    };

    /*
     * AngularJS Lifecycle hook for newer AngularJS versions.
     * Bindings are not guaranteed to have been assigned in the controller, but they are in the
     * $onInit hook.
     */
    ctrl.$onInit = function() {
      setupDefaults();
      setupListeners();
      setupWatchers();

      fireInitialAnimations();
    };

    // For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
    // manually call the $onInit hook.
    if (angular.version.major === 1 && angular.version.minor <= 4) {
      this.$onInit();
    }

    function setupDefaults() {
      // Set the default direction to 'down' if none is specified
      ctrl.direction = ctrl.direction || 'down';

      // Set the default to be closed
      ctrl.isOpen = ctrl.isOpen || false;

      // Start the keyboard interaction at the first action
      resetActionIndex();

      // Add an animations waiting class so we know not to run
      $element.addClass('md-animations-waiting');
    }

    function setupListeners() {
      var eventTypes = [
        'click', 'focusin', 'focusout'
      ];

      // Add our listeners
      angular.forEach(eventTypes, function(eventType) {
        $element.on(eventType, parseEvents);
      });

      // Remove our listeners when destroyed
      $scope.$on('$destroy', function() {
        angular.forEach(eventTypes, function(eventType) {
          $element.off(eventType, parseEvents);
        });

        // remove any attached keyboard handlers in case element is removed while
        // speed dial is open
        disableKeyboard();
      });
    }

    var closeTimeout;

    /**
     * @param {MouseEvent} event
     */
    function parseEvents(event) {
      // If the event is a click, just handle it
      if (event.type == 'click') {
        handleItemClick(event);
      }

      // If we focusout, set a timeout to close the element
      if (event.type == 'focusout' && !closeTimeout) {
        closeTimeout = $timeout(function() {
          ctrl.close();
        }, 100, false);
      }

      // If we see a focusin and there is a timeout about to run, cancel it so we stay open
      if (event.type == 'focusin' && closeTimeout) {
        $timeout.cancel(closeTimeout);
        closeTimeout = null;
      }
    }

    function resetActionIndex() {
      ctrl.currentActionIndex = -1;
    }

    function setupWatchers() {
      // Watch for changes to the direction and update classes/attributes
      $scope.$watch('ctrl.direction', function(newDir, oldDir) {
        // Add the appropriate classes so we can target the direction in the CSS
        $animate.removeClass($element, 'md-' + oldDir);
        $animate.addClass($element, 'md-' + newDir);

        // Reset the action index since it may have changed
        resetActionIndex();
      });

      var trigger, actions;

      // Watch for changes to md-open
      $scope.$watch('ctrl.isOpen', function(isOpen) {
        // Reset the action index since it may have changed
        resetActionIndex();

        // We can't get the trigger/actions outside of the watch because the component hasn't been
        // linked yet, so we wait until the first watch fires to cache them.
        if (!trigger || !actions) {
          trigger = getTriggerElement();
          actions = getActionsElement();
        }

        if (isOpen) {
          enableKeyboard();
        } else {
          disableKeyboard();
        }

        var toAdd = isOpen ? 'md-is-open' : '';
        var toRemove = isOpen ? '' : 'md-is-open';

        // Set the proper ARIA attributes
        trigger.attr('aria-haspopup', true);
        trigger.attr('aria-expanded', isOpen);
        actions.attr('aria-hidden', !isOpen);

        // Animate the CSS classes
        $animate.setClass($element, toAdd, toRemove);
      });
    }

    function fireInitialAnimations() {
      // If the element is actually visible on the screen
      if ($element[0].scrollHeight > 0) {
        // Fire our animation
        $animate.addClass($element, '_md-animations-ready').then(function() {
          // Remove the waiting class
          $element.removeClass('md-animations-waiting');
        });
      }

      // Otherwise, try for up to 1 second before giving up
      else if (initialAnimationAttempts < 10) {
        $timeout(fireInitialAnimations, 100);

        // Increment our counter
        initialAnimationAttempts = initialAnimationAttempts + 1;
      }
    }

    function enableKeyboard() {
      $element.on('keydown', keyPressed);

      // On the next tick, setup a check for outside clicks; we do this on the next tick to avoid
      // clicks/touches that result in the isOpen attribute changing (e.g. a bound radio button)
      $mdUtil.nextTick(function() {
        angular.element(document).on('click touchend', checkForOutsideClick);
      });
    }

    function disableKeyboard() {
      $element.off('keydown', keyPressed);
      angular.element(document).off('click touchend', checkForOutsideClick);
    }

    function checkForOutsideClick(event) {
      if (event.target) {
        var closestTrigger = $mdUtil.getClosest(event.target, 'md-fab-trigger');
        var closestActions = $mdUtil.getClosest(event.target, 'md-fab-actions');

        if (!closestTrigger && !closestActions) {
          ctrl.close();
        }
      }
    }

    /**
     * @param {KeyboardEvent} event
     * @returns {boolean}
     */
    function keyPressed(event) {
      switch (event.which) {
        case $mdConstant.KEY_CODE.ESCAPE: ctrl.close(); event.preventDefault(); return false;
        case $mdConstant.KEY_CODE.LEFT_ARROW: doKeyLeft(event); return false;
        case $mdConstant.KEY_CODE.UP_ARROW: doKeyUp(event); return false;
        case $mdConstant.KEY_CODE.RIGHT_ARROW: doKeyRight(event); return false;
        case $mdConstant.KEY_CODE.DOWN_ARROW: doKeyDown(event); return false;
        case $mdConstant.KEY_CODE.TAB: doShift(event); return false;
      }
    }

    function doActionPrev(event) {
      focusAction(event, -1);
    }

    function doActionNext(event) {
      focusAction(event, 1);
    }

    function focusAction(event, direction) {
      var actions = getActionsElement()[0].querySelectorAll('.md-fab-action-item');
      var previousActionIndex = ctrl.currentActionIndex;

      // Increment/decrement the counter with restrictions
      ctrl.currentActionIndex = ctrl.currentActionIndex + direction;
      ctrl.currentActionIndex = Math.min(actions.length - 1, ctrl.currentActionIndex);
      ctrl.currentActionIndex = Math.max(0, ctrl.currentActionIndex);

      // Let Tab and Shift+Tab escape if we're trying to move past the start/end.
      if (event.which !== $mdConstant.KEY_CODE.TAB ||
          previousActionIndex !== ctrl.currentActionIndex) {
        // Focus the element
        var focusElement = angular.element(actions[ctrl.currentActionIndex]).children()[0];
        focusElement.focus();

        // Make sure the event doesn't bubble and cause something else
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }

    function doKeyLeft(event) {
      if (ctrl.direction === 'left') {
        doActionNext(event);
      } else {
        doActionPrev(event);
      }
    }

    function doKeyUp(event) {
      if (ctrl.direction === 'down') {
        doActionPrev(event);
      } else {
        doActionNext(event);
      }
    }

    function doKeyRight(event) {
      if (ctrl.direction === 'left') {
        doActionPrev(event);
      } else {
        doActionNext(event);
      }
    }

    function doKeyDown(event) {
      if (ctrl.direction === 'up') {
        doActionPrev(event);
      } else {
        doActionNext(event);
      }
    }

    function doShift(event) {
      if (event.shiftKey) {
        doActionPrev(event);
      } else {
        doActionNext(event);
      }
    }

    /**
     * @param {Node} element
     * @returns {Node|null}
     */
    function getClosestButton(element) {
      return $mdUtil.getClosest(element, 'button') || $mdUtil.getClosest(element, 'md-button');
    }

    /**
     * @param {Node} element
     * @returns {Node|null}
     */
    function getClosestTrigger(element) {
      return $mdUtil.getClosest(element, 'md-fab-trigger');
    }

    /**
     * @param {Node} element
     * @returns {Node|null}
     */
    function getClosestAction(element) {
      return $mdUtil.getClosest(element, 'md-fab-actions');
    }

    /**
     * @param {MouseEvent|FocusEvent} event
     */
    function handleItemClick(event) {
      var closestButton = event.target ? getClosestButton(event.target) : null;

      // Check that the button in the trigger is not disabled
      if (closestButton && !closestButton.disabled) {
        if (getClosestTrigger(event.target)) {
          ctrl.toggle();
        }
      }

      if (getClosestAction(event.target)) {
        ctrl.close();
      }
    }

    function getTriggerElement() {
      return $element.find('md-fab-trigger');
    }

    function getActionsElement() {
      return $element.find('md-fab-actions');
    }
  }
})();

})();
(function(){
"use strict";

(function() {
  'use strict';

  /**
   * The duration of the CSS animation in milliseconds.
   *
   * @type {number}
   */
  MdFabSpeedDialFlingAnimation.$inject = ["$timeout"];
  MdFabSpeedDialScaleAnimation.$inject = ["$timeout"];
  var cssAnimationDuration = 300;

  /**
   * @ngdoc module
   * @name material.components.fabSpeedDial
   */
  angular
    // Declare our module
    .module('material.components.fabSpeedDial', [
      'material.core',
      'material.components.fabShared',
      'material.components.fabActions'
    ])

    // Register our directive
    .directive('mdFabSpeedDial', MdFabSpeedDialDirective)

    // Register our custom animations
    .animation('.md-fling', MdFabSpeedDialFlingAnimation)
    .animation('.md-scale', MdFabSpeedDialScaleAnimation)

    // Register a service for each animation so that we can easily inject them into unit tests
    .service('mdFabSpeedDialFlingAnimation', MdFabSpeedDialFlingAnimation)
    .service('mdFabSpeedDialScaleAnimation', MdFabSpeedDialScaleAnimation);

  /**
   * @ngdoc directive
   * @name mdFabSpeedDial
   * @module material.components.fabSpeedDial
   *
   * @restrict E
   *
   * @description
   * The `<md-fab-speed-dial>` directive is used to present a series of popup elements (usually
   * `<md-button>`s) for quick access to common actions.
   *
   * There are currently two animations available by applying one of the following classes to
   * the component:
   *
   *  - `md-fling` - The speed dial items appear from underneath the trigger and move into their
   *    appropriate positions.
   *  - `md-scale` - The speed dial items appear in their proper places by scaling from 0% to 100%.
   *
   * You may also easily position the trigger by applying one one of the following classes to the
   * `<md-fab-speed-dial>` element:
   *  - `md-fab-top-left`
   *  - `md-fab-top-right`
   *  - `md-fab-bottom-left`
   *  - `md-fab-bottom-right`
   *
   * These CSS classes use `position: absolute`, so you need to ensure that the container element
   * also uses `position: absolute` or `position: relative` in order for them to work.
   *
   * Additionally, you may use the standard `ng-mouseenter` and `ng-mouseleave` directives to
   * open or close the speed dial. However, if you wish to allow users to hover over the empty
   * space where the actions will appear, you must also add the `md-hover-full` class to the speed
   * dial element. Without this, the hover effect will only occur on top of the trigger.
   *
   * See the demos for more information.
   *
   * ## Troubleshooting
   *
   * If your speed dial shows the closing animation upon launch, you may need to use `ng-cloak` on
   * the parent container to ensure that it is only visible once ready. We have plans to remove this
   * necessity in the future.
   *
   * @usage
   * <hljs lang="html">
   * <md-fab-speed-dial md-direction="up" class="md-fling">
   *   <md-fab-trigger>
   *     <md-button aria-label="Add..."><md-icon md-svg-src="/img/icons/plus.svg"></md-icon></md-button>
   *   </md-fab-trigger>
   *
   *   <md-fab-actions>
   *     <md-button aria-label="Add User">
   *       <md-icon md-svg-src="/img/icons/user.svg"></md-icon>
   *     </md-button>
   *
   *     <md-button aria-label="Add Group">
   *       <md-icon md-svg-src="/img/icons/group.svg"></md-icon>
   *     </md-button>
   *   </md-fab-actions>
   * </md-fab-speed-dial>
   * </hljs>
   *
   * @param {string} md-direction From which direction you would like the speed dial to appear
   * relative to the trigger element.
   * @param {expression=} md-open Programmatically control whether or not the speed-dial is visible.
   */
  function MdFabSpeedDialDirective() {
    return {
      restrict: 'E',

      scope: {
        direction: '@?mdDirection',
        isOpen: '=?mdOpen'
      },

      bindToController: true,
      controller: 'MdFabController',
      controllerAs: 'ctrl',

      link: FabSpeedDialLink
    };

    function FabSpeedDialLink(scope, element) {
      // Prepend an element to hold our CSS variables so we can use them in the animations below
      element.prepend('<div class="_md-css-variables"></div>');
    }
  }

  function MdFabSpeedDialFlingAnimation($timeout) {
    function delayDone(done) { $timeout(done, cssAnimationDuration, false); }

    function runAnimation(element) {
      // Don't run if we are still waiting and we are not ready
      if (element.hasClass('md-animations-waiting') && !element.hasClass('_md-animations-ready')) {
        return;
      }

      var el = element[0];
      var ctrl = element.controller('mdFabSpeedDial');
      var items = el.querySelectorAll('.md-fab-action-item');

      // Grab our trigger element
      var triggerElement = el.querySelector('md-fab-trigger');

      // Grab our element which stores CSS variables
      var variablesElement = el.querySelector('._md-css-variables');

      // Setup JS variables based on our CSS variables
      var startZIndex = parseInt(window.getComputedStyle(variablesElement).zIndex);

      // Always reset the items to their natural position/state
      angular.forEach(items, function(item, index) {
        var styles = item.style;

        styles.transform = styles.webkitTransform = '';
        styles.transitionDelay = '';
        styles.opacity = ctrl.isOpen ? 1 : 0;

        // Make the items closest to the trigger have the highest z-index
        styles.zIndex = (items.length - index) + startZIndex;
      });

      // Set the trigger to be above all of the actions so they disappear behind it.
      triggerElement.style.zIndex = startZIndex + items.length + 1;

      // If the control is closed, hide the items behind the trigger
      if (!ctrl.isOpen) {
        angular.forEach(items, function(item, index) {
          var newPosition, axis;
          var styles = item.style;

          // Make sure to account for differences in the dimensions of the trigger verses the items
          // so that we can properly center everything; this helps hide the item's shadows behind
          // the trigger.
          var triggerItemHeightOffset = (triggerElement.clientHeight - item.clientHeight) / 2;
          var triggerItemWidthOffset = (triggerElement.clientWidth - item.clientWidth) / 2;

          switch (ctrl.direction) {
            case 'up':
              newPosition = (item.scrollHeight * (index + 1) + triggerItemHeightOffset);
              axis = 'Y';
              break;
            case 'down':
              newPosition = -(item.scrollHeight * (index + 1) + triggerItemHeightOffset);
              axis = 'Y';
              break;
            case 'left':
              newPosition = (item.scrollWidth * (index + 1) + triggerItemWidthOffset);
              axis = 'X';
              break;
            case 'right':
              newPosition = -(item.scrollWidth * (index + 1) + triggerItemWidthOffset);
              axis = 'X';
              break;
          }

          var newTranslate = 'translate' + axis + '(' + newPosition + 'px)';

          styles.transform = styles.webkitTransform = newTranslate;
        });
      }
    }

    return {
      addClass: function(element, className, done) {
        if (element.hasClass('md-fling')) {
          runAnimation(element);
          delayDone(done);
        } else {
          done();
        }
      },
      removeClass: function(element, className, done) {
        runAnimation(element);
        delayDone(done);
      }
    };
  }

  function MdFabSpeedDialScaleAnimation($timeout) {
    function delayDone(done) { $timeout(done, cssAnimationDuration, false); }

    var delay = 65;

    function runAnimation(element) {
      var el = element[0];
      var ctrl = element.controller('mdFabSpeedDial');
      var items = el.querySelectorAll('.md-fab-action-item');

      // Grab our element which stores CSS variables
      var variablesElement = el.querySelector('._md-css-variables');

      // Setup JS variables based on our CSS variables
      var startZIndex = parseInt(window.getComputedStyle(variablesElement).zIndex);

      // Always reset the items to their natural position/state
      angular.forEach(items, function(item, index) {
        var styles = item.style,
          offsetDelay = index * delay;

        styles.opacity = ctrl.isOpen ? 1 : 0;
        styles.transform = styles.webkitTransform = ctrl.isOpen ? 'scale(1)' : 'scale(0)';
        styles.transitionDelay = (ctrl.isOpen ? offsetDelay : (items.length - offsetDelay)) + 'ms';

        // Make the items closest to the trigger have the highest z-index
        styles.zIndex = (items.length - index) + startZIndex;
      });
    }

    return {
      addClass: function(element, className, done) {
        runAnimation(element);
        delayDone(done);
      },

      removeClass: function(element, className, done) {
        runAnimation(element);
        delayDone(done);
      }
    };
  }
})();

})();
(function(){
"use strict";

(function() {
  'use strict';

  /**
   * @ngdoc module
   * @name material.components.fabToolbar
   */
  angular
    // Declare our module
    .module('material.components.fabToolbar', [
      'material.core',
      'material.components.fabShared',
      'material.components.fabActions'
    ])

    // Register our directive
    .directive('mdFabToolbar', MdFabToolbarDirective)

    // Register our custom animations
    .animation('.md-fab-toolbar', MdFabToolbarAnimation)

    // Register a service for the animation so that we can easily inject it into unit tests
    .service('mdFabToolbarAnimation', MdFabToolbarAnimation);

  /**
   * @ngdoc directive
   * @name mdFabToolbar
   * @module material.components.fabToolbar
   *
   * @restrict E
   *
   * @description
   *
   * The `<md-fab-toolbar>` directive is used to present a toolbar of elements (usually `<md-button>`s)
   * for quick access to common actions when a floating action button is activated (via click or
   * keyboard navigation).
   *
   * You may also easily position the trigger by applying one one of the following classes to the
   * `<md-fab-toolbar>` element:
   *  - `md-fab-top-left`
   *  - `md-fab-top-right`
   *  - `md-fab-bottom-left`
   *  - `md-fab-bottom-right`
   *
   * These CSS classes use `position: absolute`, so you need to ensure that the container element
   * also uses `position: absolute` or `position: relative` in order for them to work.
   *
   * @usage
   *
   * <hljs lang="html">
   * <md-fab-toolbar md-direction='left'>
   *   <md-fab-trigger>
   *     <md-button aria-label="Add..."><md-icon md-svg-src="/img/icons/plus.svg"></md-icon></md-button>
   *   </md-fab-trigger>
   *
   *   <md-toolbar>
   *    <md-fab-actions>
   *      <md-button aria-label="Add User">
   *        <md-icon md-svg-src="/img/icons/user.svg"></md-icon>
   *      </md-button>
   *
   *      <md-button aria-label="Add Group">
   *        <md-icon md-svg-src="/img/icons/group.svg"></md-icon>
   *      </md-button>
   *    </md-fab-actions>
   *   </md-toolbar>
   * </md-fab-toolbar>
   * </hljs>
   *
   * @param {string} md-direction From which direction you would like the toolbar items to appear
   * relative to the trigger element. Supports `left` and `right` directions.
   * @param {expression=} md-open Programmatically control whether or not the toolbar is visible.
   */
  function MdFabToolbarDirective() {
    return {
      restrict: 'E',
      transclude: true,
      template: '<div class="md-fab-toolbar-wrapper">' +
      '  <div class="md-fab-toolbar-content" ng-transclude></div>' +
      '</div>',

      scope: {
        direction: '@?mdDirection',
        isOpen: '=?mdOpen'
      },

      bindToController: true,
      controller: 'MdFabController',
      controllerAs: 'ctrl',

      link: link
    };

    function link(scope, element, attributes) {
      // Add the base class for animations
      element.addClass('md-fab-toolbar');

      // Prepend the background element to the trigger's button
      element.find('md-fab-trigger').find('button')
        .prepend('<div class="md-fab-toolbar-background"></div>');
    }
  }

  function MdFabToolbarAnimation() {

    function runAnimation(element, className, done) {
      // If no className was specified, don't do anything
      if (!className) {
        return;
      }

      var el = element[0];
      var ctrl = element.controller('mdFabToolbar');

      // Grab the relevant child elements
      var backgroundElement = el.querySelector('.md-fab-toolbar-background');
      var triggerElement = el.querySelector('md-fab-trigger button');
      var toolbarElement = el.querySelector('md-toolbar');
      var iconElement = el.querySelector('md-fab-trigger button md-icon');
      var actions = element.find('md-fab-actions').children();

      // If we have both elements, use them to position the new background
      if (triggerElement && backgroundElement) {
        // Get our variables
        var color = window.getComputedStyle(triggerElement).getPropertyValue('background-color');
        var width = el.offsetWidth;
        var height = el.offsetHeight;

        // Make it twice as big as it should be since we scale from the center
        var scale = 2 * (width / triggerElement.offsetWidth);

        // Set some basic styles no matter what animation we're doing
        backgroundElement.style.backgroundColor = color;
        backgroundElement.style.borderRadius = width + 'px';

        // If we're open
        if (ctrl.isOpen) {
          // Turn on toolbar pointer events when closed
          toolbarElement.style.pointerEvents = 'inherit';

          backgroundElement.style.width = triggerElement.offsetWidth + 'px';
          backgroundElement.style.height = triggerElement.offsetHeight + 'px';
          backgroundElement.style.transform = 'scale(' + scale + ')';

          // Set the next close animation to have the proper delays
          backgroundElement.style.transitionDelay = '0ms';
          iconElement && (iconElement.style.transitionDelay = '.3s');

          // Apply a transition delay to actions
          angular.forEach(actions, function(action, index) {
            action.style.transitionDelay = (actions.length - index) * 25 + 'ms';
          });
        } else {
          // Turn off toolbar pointer events when closed
          toolbarElement.style.pointerEvents = 'none';

          // Scale it back down to the trigger's size
          backgroundElement.style.transform = 'scale(1)';

          // Reset the position
          backgroundElement.style.top = '0';

          if (element.hasClass('md-right')) {
            backgroundElement.style.left = '0';
            backgroundElement.style.right = null;
          }

          if (element.hasClass('md-left')) {
            backgroundElement.style.right = '0';
            backgroundElement.style.left = null;
          }

          // Set the next open animation to have the proper delays
          backgroundElement.style.transitionDelay = '200ms';
          iconElement && (iconElement.style.transitionDelay = '0ms');

          // Apply a transition delay to actions
          angular.forEach(actions, function(action, index) {
            action.style.transitionDelay = 200 + (index * 25) + 'ms';
          });
        }
      }
    }

    return {
      addClass: function(element, className, done) {
        runAnimation(element, className, done);
        done();
      },

      removeClass: function(element, className, done) {
        runAnimation(element, className, done);
        done();
      }
    };
  }
})();

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.gridList
 */
GridListController.$inject = ["$mdUtil"];
GridLayoutFactory.$inject = ["$mdUtil"];
GridListDirective.$inject = ["$interpolate", "$mdConstant", "$mdGridLayout", "$mdMedia", "$mdUtil"];
GridTileDirective.$inject = ["$mdMedia"];
angular.module('material.components.gridList', ['material.core'])
       .directive('mdGridList', GridListDirective)
       .directive('mdGridTile', GridTileDirective)
       .directive('mdGridTileFooter', GridTileCaptionDirective)
       .directive('mdGridTileHeader', GridTileCaptionDirective)
       .factory('$mdGridLayout', GridLayoutFactory);

/**
 * @ngdoc directive
 * @name mdGridList
 * @module material.components.gridList
 * @restrict E
 * @description
 * Grid lists are an alternative to standard list views. Grid lists are distinct
 * from grids used for layouts and other visual presentations.
 *
 * A grid list is best suited to presenting a homogenous data type, typically
 * images, and is optimized for visual comprehension and differentiating between
 * like data types.
 *
 * A grid list is a continuous element consisting of tessellated, regular
 * subdivisions called cells that contain tiles (`md-grid-tile`).
 *
 * <img src="//material-design.storage.googleapis.com/publish/v_2/material_ext_publish/0Bx4BSt6jniD7OVlEaXZ5YmU1Xzg/components_grids_usage2.png"
 *    style="width: 300px; height: auto; margin-right: 16px;" alt="Concept of grid explained visually">
 * <img src="//material-design.storage.googleapis.com/publish/v_2/material_ext_publish/0Bx4BSt6jniD7VGhsOE5idWlJWXM/components_grids_usage3.png"
 *    style="width: 300px; height: auto;" alt="Grid concepts legend">
 *
 * Cells are arrayed vertically and horizontally within the grid.
 *
 * Tiles hold content and can span one or more cells vertically or horizontally.
 *
 * ### Responsive Attributes
 *
 * The `md-grid-list` directive supports "responsive" attributes, which allow
 * different `md-cols`, `md-gutter` and `md-row-height` values depending on the
 * currently matching media query.
 *
 * In order to set a responsive attribute, first define the fallback value with
 * the standard attribute name, then add additional attributes with the
 * following convention: `{base-attribute-name}-{media-query-name}="{value}"`
 * (ie. `md-cols-lg="8"`)
 *
 * @param {number} md-cols Number of columns in the grid.
 * @param {string} md-row-height One of
 * <ul>
 *   <li>CSS length - Fixed height rows (eg. `8px` or `1rem`)</li>
 *   <li>`{width}:{height}` - Ratio of width to height (eg.
 *   `md-row-height="16:9"`)</li>
 *   <li>`"fit"` - Height will be determined by subdividing the available
 *   height by the number of rows</li>
 * </ul>
 * @param {string=} md-gutter The amount of space between tiles in CSS units
 *     (default 1px)
 * @param {expression=} md-on-layout Expression to evaluate after layout. Event
 *     object is available as `$event`, and contains performance information.
 *
 * @usage
 * Basic:
 * <hljs lang="html">
 * <md-grid-list md-cols="5" md-gutter="1em" md-row-height="4:3">
 *   <md-grid-tile></md-grid-tile>
 * </md-grid-list>
 * </hljs>
 *
 * Fixed-height rows:
 * <hljs lang="html">
 * <md-grid-list md-cols="4" md-row-height="200px" ...>
 *   <md-grid-tile></md-grid-tile>
 * </md-grid-list>
 * </hljs>
 *
 * Fit rows:
 * <hljs lang="html">
 * <md-grid-list md-cols="4" md-row-height="fit" style="height: 400px;" ...>
 *   <md-grid-tile></md-grid-tile>
 * </md-grid-list>
 * </hljs>
 *
 * Using responsive attributes:
 * <hljs lang="html">
 * <md-grid-list
 *     md-cols-sm="2"
 *     md-cols-md="4"
 *     md-cols-lg="8"
 *     md-cols-gt-lg="12"
 *     ...>
 *   <md-grid-tile></md-grid-tile>
 * </md-grid-list>
 * </hljs>
 */
function GridListDirective($interpolate, $mdConstant, $mdGridLayout, $mdMedia, $mdUtil) {
  return {
    restrict: 'E',
    controller: GridListController,
    scope: {
      mdOnLayout: '&'
    },
    link: postLink
  };

  function postLink(scope, element, attrs, ctrl) {
    element.addClass('_md');     // private md component indicator for styling

    // Apply semantics
    element.attr('role', 'list');

    // Provide the controller with a way to trigger layouts.
    ctrl.layoutDelegate = layoutDelegate;

    var invalidateLayout = angular.bind(ctrl, ctrl.invalidateLayout),
        unwatchAttrs = watchMedia();
      scope.$on('$destroy', unwatchMedia);

    /**
     * Watches for changes in media, invalidating layout as necessary.
     */
    function watchMedia() {
      for (var mediaName in $mdConstant.MEDIA) {
        $mdMedia(mediaName); // initialize
        $mdMedia.getQuery($mdConstant.MEDIA[mediaName])
            .addListener(invalidateLayout);
      }
      return $mdMedia.watchResponsiveAttributes(
          ['md-cols', 'md-row-height', 'md-gutter'], attrs, layoutIfMediaMatch);
    }

    function unwatchMedia() {
      ctrl.layoutDelegate = angular.noop;

      unwatchAttrs();
      for (var mediaName in $mdConstant.MEDIA) {
        $mdMedia.getQuery($mdConstant.MEDIA[mediaName])
            .removeListener(invalidateLayout);
      }
    }

    /**
     * Performs grid layout if the provided mediaName matches the currently
     * active media type.
     */
    function layoutIfMediaMatch(mediaName) {
      if (mediaName == null) {
        // TODO(shyndman): It would be nice to only layout if we have
        // instances of attributes using this media type
        ctrl.invalidateLayout();
      } else if ($mdMedia(mediaName)) {
        ctrl.invalidateLayout();
      }
    }

    var lastLayoutProps;

    /**
     * Invokes the layout engine, and uses its results to lay out our
     * tile elements.
     *
     * @param {boolean} tilesInvalidated Whether tiles have been
     *    added/removed/moved since the last layout. This is to avoid situations
     *    where tiles are replaced with properties identical to their removed
     *    counterparts.
     */
    function layoutDelegate(tilesInvalidated) {
      var tiles = getTileElements();
      var props = {
        tileSpans: getTileSpans(tiles),
        colCount: getColumnCount(),
        rowMode: getRowMode(),
        rowHeight: getRowHeight(),
        gutter: getGutter()
      };

      if (!tilesInvalidated && angular.equals(props, lastLayoutProps)) {
        return;
      }

      var performance =
        $mdGridLayout(props.colCount, props.tileSpans, tiles)
          .map(function(tilePositions, rowCount) {
            return {
              grid: {
                element: element,
                style: getGridStyle(props.colCount, rowCount,
                    props.gutter, props.rowMode, props.rowHeight)
              },
              tiles: tilePositions.map(function(ps, i) {
                return {
                  element: angular.element(tiles[i]),
                  style: getTileStyle(ps.position, ps.spans,
                      props.colCount, rowCount,
                      props.gutter, props.rowMode, props.rowHeight)
                };
              })
            };
          })
          .reflow()
          .performance();

      // Report layout
      scope.mdOnLayout({
        $event: {
          performance: performance
        }
      });

      lastLayoutProps = props;
    }

    // Use $interpolate to do some simple string interpolation as a convenience.

    var startSymbol = $interpolate.startSymbol();
    var endSymbol = $interpolate.endSymbol();

    // Returns an expression wrapped in the interpolator's start and end symbols.
    function expr(exprStr) {
      return startSymbol + exprStr + endSymbol;
    }

    // The amount of space a single 1x1 tile would take up (either width or height), used as
    // a basis for other calculations. This consists of taking the base size percent (as would be
    // if evenly dividing the size between cells), and then subtracting the size of one gutter.
    // However, since there are no gutters on the edges, each tile only uses a fration
    // (gutterShare = numGutters / numCells) of the gutter size. (Imagine having one gutter per
    // tile, and then breaking up the extra gutter on the edge evenly among the cells).
    var UNIT = $interpolate(expr('share') + '% - (' + expr('gutter') + ' * ' + expr('gutterShare') + ')');

    // The horizontal or vertical position of a tile, e.g., the 'top' or 'left' property value.
    // The position comes the size of a 1x1 tile plus gutter for each previous tile in the
    // row/column (offset).
    var POSITION  = $interpolate('calc((' + expr('unit') + ' + ' + expr('gutter') + ') * ' + expr('offset') + ')');

    // The actual size of a tile, e.g., width or height, taking rowSpan or colSpan into account.
    // This is computed by multiplying the base unit by the rowSpan/colSpan, and then adding back
    // in the space that the gutter would normally have used (which was already accounted for in
    // the base unit calculation).
    var DIMENSION = $interpolate('calc((' + expr('unit') + ') * ' + expr('span') + ' + (' + expr('span') + ' - 1) * ' + expr('gutter') + ')');

    /**
     * Gets the styles applied to a tile element described by the given parameters.
     * @param {{row: number, col: number}} position The row and column indices of the tile.
     * @param {{row: number, col: number}} spans The rowSpan and colSpan of the tile.
     * @param {number} colCount The number of columns.
     * @param {number} rowCount The number of rows.
     * @param {string} gutter The amount of space between tiles. This will be something like
     *     '5px' or '2em'.
     * @param {string} rowMode The row height mode. Can be one of:
     *     'fixed': all rows have a fixed size, given by rowHeight,
     *     'ratio': row height defined as a ratio to width, or
     *     'fit': fit to the grid-list element height, divinding evenly among rows.
     * @param {string|number} rowHeight The height of a row. This is only used for 'fixed' mode and
     *     for 'ratio' mode. For 'ratio' mode, this is the *ratio* of width-to-height (e.g., 0.75).
     * @returns {Object} Map of CSS properties to be applied to the style element. Will define
     *     values for top, left, width, height, marginTop, and paddingTop.
     */
    function getTileStyle(position, spans, colCount, rowCount, gutter, rowMode, rowHeight) {
      // TODO(shyndman): There are style caching opportunities here.

      // Percent of the available horizontal space that one column takes up.
      var hShare = (1 / colCount) * 100;

      // Fraction of the gutter size that each column takes up.
      var hGutterShare = (colCount - 1) / colCount;

      // Base horizontal size of a column.
      var hUnit = UNIT({share: hShare, gutterShare: hGutterShare, gutter: gutter});

      // The width and horizontal position of each tile is always calculated the same way, but the
      // height and vertical position depends on the rowMode.
      var style = (!$mdUtil.isRtl(attrs)) ? {
          left: POSITION({ unit: hUnit, offset: position.col, gutter: gutter }),
          width: DIMENSION({ unit: hUnit, span: spans.col, gutter: gutter }),
          // resets
          paddingTop: '',
          marginTop: '',
          top: '',
          height: ''
        } : {
        right: POSITION({ unit: hUnit, offset: position.col, gutter: gutter }),
        width: DIMENSION({ unit: hUnit, span: spans.col, gutter: gutter }),
        // resets
        paddingTop: '',
        marginTop: '',
        top: '',
        height: ''
      };

      switch (rowMode) {
        case 'fixed':
          // In fixed mode, simply use the given rowHeight.
          style.top = POSITION({ unit: rowHeight, offset: position.row, gutter: gutter });
          style.height = DIMENSION({ unit: rowHeight, span: spans.row, gutter: gutter });
          break;

        case 'ratio':
          // Percent of the available vertical space that one row takes up. Here, rowHeight holds
          // the ratio value. For example, if the width:height ratio is 4:3, rowHeight = 1.333.
          var vShare = hShare / rowHeight;

          // Base veritcal size of a row.
          var vUnit = UNIT({ share: vShare, gutterShare: hGutterShare, gutter: gutter });

          // padidngTop and marginTop are used to maintain the given aspect ratio, as
          // a percentage-based value for these properties is applied to the *width* of the
          // containing block. See http://www.w3.org/TR/CSS2/box.html#margin-properties
          style.paddingTop = DIMENSION({ unit: vUnit, span: spans.row, gutter: gutter});
          style.marginTop = POSITION({ unit: vUnit, offset: position.row, gutter: gutter });
          break;

        case 'fit':
          // Fraction of the gutter size that each column takes up.
          var vGutterShare = (rowCount - 1) / rowCount;

          // Percent of the available vertical space that one row takes up.
          vShare = (1 / rowCount) * 100;

          // Base vertical size of a row.
          vUnit = UNIT({share: vShare, gutterShare: vGutterShare, gutter: gutter});

          style.top = POSITION({unit: vUnit, offset: position.row, gutter: gutter});
          style.height = DIMENSION({unit: vUnit, span: spans.row, gutter: gutter});
          break;
      }

      return style;
    }

    function getGridStyle(colCount, rowCount, gutter, rowMode, rowHeight) {
      var style = {};

      switch (rowMode) {
        case 'fixed':
          style.height = DIMENSION({ unit: rowHeight, span: rowCount, gutter: gutter });
          style.paddingBottom = '';
          break;

        case 'ratio':
          // rowHeight is width / height
          var hGutterShare = colCount === 1 ? 0 : (colCount - 1) / colCount,
              hShare = (1 / colCount) * 100,
              vShare = hShare * (1 / rowHeight),
              vUnit = UNIT({ share: vShare, gutterShare: hGutterShare, gutter: gutter });

          style.height = '';
          style.paddingBottom = DIMENSION({ unit: vUnit, span: rowCount, gutter: gutter});
          break;

        case 'fit':
          // noop, as the height is user set
          break;
      }

      return style;
    }

    function getTileElements() {
      return [].filter.call(element.children(), function(ele) {
        return ele.tagName == 'MD-GRID-TILE' && !ele.$$mdDestroyed;
      });
    }

    /**
     * Gets an array of objects containing the rowspan and colspan for each tile.
     * @returns {Array<{row: number, col: number}>}
     */
    function getTileSpans(tileElements) {
      return [].map.call(tileElements, function(ele) {
        var ctrl = angular.element(ele).controller('mdGridTile');
        return {
          row: parseInt(
              $mdMedia.getResponsiveAttribute(ctrl.$attrs, 'md-rowspan'), 10) || 1,
          col: parseInt(
              $mdMedia.getResponsiveAttribute(ctrl.$attrs, 'md-colspan'), 10) || 1
        };
      });
    }

    function getColumnCount() {
      var colCount = parseInt($mdMedia.getResponsiveAttribute(attrs, 'md-cols'), 10);
      if (isNaN(colCount)) {
        throw 'md-grid-list: md-cols attribute was not found, or contained a non-numeric value';
      }
      return colCount;
    }

    function getGutter() {
      return applyDefaultUnit($mdMedia.getResponsiveAttribute(attrs, 'md-gutter') || 1);
    }

    function getRowHeight() {
      var rowHeight = $mdMedia.getResponsiveAttribute(attrs, 'md-row-height');
      if (!rowHeight) {
        throw 'md-grid-list: md-row-height attribute was not found';
      }

      switch (getRowMode()) {
        case 'fixed':
          return applyDefaultUnit(rowHeight);
        case 'ratio':
          var whRatio = rowHeight.split(':');
          return parseFloat(whRatio[0]) / parseFloat(whRatio[1]);
        case 'fit':
          return 0; // N/A
      }
    }

    function getRowMode() {
      var rowHeight = $mdMedia.getResponsiveAttribute(attrs, 'md-row-height');
      if (!rowHeight) {
        throw 'md-grid-list: md-row-height attribute was not found';
      }

      if (rowHeight == 'fit') {
        return 'fit';
      } else if (rowHeight.indexOf(':') !== -1) {
        return 'ratio';
      } else {
        return 'fixed';
      }
    }

    function applyDefaultUnit(val) {
      return /\D$/.test(val) ? val : val + 'px';
    }
  }
}

/* @ngInject */
function GridListController($mdUtil) {
  this.layoutInvalidated = false;
  this.tilesInvalidated = false;
  this.$timeout_ = $mdUtil.nextTick;
  this.layoutDelegate = angular.noop;
}

GridListController.prototype = {
  invalidateTiles: function() {
    this.tilesInvalidated = true;
    this.invalidateLayout();
  },

  invalidateLayout: function() {
    if (this.layoutInvalidated) {
      return;
    }
    this.layoutInvalidated = true;
    this.$timeout_(angular.bind(this, this.layout));
  },

  layout: function() {
    try {
      this.layoutDelegate(this.tilesInvalidated);
    } finally {
      this.layoutInvalidated = false;
      this.tilesInvalidated = false;
    }
  }
};


/* @ngInject */
function GridLayoutFactory($mdUtil) {
  var defaultAnimator = GridTileAnimator;

  /**
   * Set the reflow animator callback
   */
  GridLayout.animateWith = function(customAnimator) {
    defaultAnimator = !angular.isFunction(customAnimator) ? GridTileAnimator : customAnimator;
  };

  return GridLayout;

  /**
   * Publish layout function
   */
  function GridLayout(colCount, tileSpans) {
      var self, layoutInfo, gridStyles, layoutTime, mapTime, reflowTime;

      layoutTime = $mdUtil.time(function() {
        layoutInfo = calculateGridFor(colCount, tileSpans);
      });

      return self = {

        /**
         * An array of objects describing each tile's position in the grid.
         */
        layoutInfo: function() {
          return layoutInfo;
        },

        /**
         * Maps grid positioning to an element and a set of styles using the
         * provided updateFn.
         */
        map: function(updateFn) {
          mapTime = $mdUtil.time(function() {
            var info = self.layoutInfo();
            gridStyles = updateFn(info.positioning, info.rowCount);
          });
          return self;
        },

        /**
         * Default animator simply sets the element.css( <styles> ). An alternate
         * animator can be provided as an argument. The function has the following
         * signature:
         *
         *    function({grid: {element: JQLite, style: Object}, tiles: Array<{element: JQLite, style: Object}>)
         */
        reflow: function(animatorFn) {
          reflowTime = $mdUtil.time(function() {
            var animator = animatorFn || defaultAnimator;
            animator(gridStyles.grid, gridStyles.tiles);
          });
          return self;
        },

        /**
         * Timing for the most recent layout run.
         */
        performance: function() {
          return {
            tileCount: tileSpans.length,
            layoutTime: layoutTime,
            mapTime: mapTime,
            reflowTime: reflowTime,
            totalTime: layoutTime + mapTime + reflowTime
          };
        }
      };
    }

  /**
   * Default Gridlist animator simple sets the css for each element;
   * NOTE: any transitions effects must be manually set in the CSS.
   * e.g.
   *
   *  md-grid-tile {
   *    transition: all 700ms ease-out 50ms;
   *  }
   *
   */
  function GridTileAnimator(grid, tiles) {
    grid.element.css(grid.style);
    tiles.forEach(function(t) {
      t.element.css(t.style);
    });
  }

  /**
   * Calculates the positions of tiles.
   *
   * The algorithm works as follows:
   *    An Array<Number> with length colCount (spaceTracker) keeps track of
   *    available tiling positions, where elements of value 0 represents an
   *    empty position. Space for a tile is reserved by finding a sequence of
   *    0s with length <= than the tile's colspan. When such a space has been
   *    found, the occupied tile positions are incremented by the tile's
   *    rowspan value, as these positions have become unavailable for that
   *    many rows.
   *
   *    If the end of a row has been reached without finding space for the
   *    tile, spaceTracker's elements are each decremented by 1 to a minimum
   *    of 0. Rows are searched in this fashion until space is found.
   */
  function calculateGridFor(colCount, tileSpans) {
    var curCol = 0,
        curRow = 0,
        spaceTracker = newSpaceTracker();

    return {
      positioning: tileSpans.map(function(spans, i) {
        return {
          spans: spans,
          position: reserveSpace(spans, i)
        };
      }),
      rowCount: curRow + Math.max.apply(Math, spaceTracker)
    };

    function reserveSpace(spans, i) {
      if (spans.col > colCount) {
        throw 'md-grid-list: Tile at position ' + i + ' has a colspan ' +
            '(' + spans.col + ') that exceeds the column count ' +
            '(' + colCount + ')';
      }

      var start = 0,
          end = 0;

      // TODO(shyndman): This loop isn't strictly necessary if you can
      // determine the minimum number of rows before a space opens up. To do
      // this, recognize that you've iterated across an entire row looking for
      // space, and if so fast-forward by the minimum rowSpan count. Repeat
      // until the required space opens up.
      while (end - start < spans.col) {
        if (curCol >= colCount) {
          nextRow();
          continue;
        }

        start = spaceTracker.indexOf(0, curCol);
        if (start === -1 || (end = findEnd(start + 1)) === -1) {
          start = end = 0;
          nextRow();
          continue;
        }

        curCol = end + 1;
      }

      adjustRow(start, spans.col, spans.row);
      curCol = start + spans.col;

      return {
        col: start,
        row: curRow
      };
    }

    function nextRow() {
      curCol = 0;
      curRow++;
      adjustRow(0, colCount, -1); // Decrement row spans by one
    }

    function adjustRow(from, cols, by) {
      for (var i = from; i < from + cols; i++) {
        spaceTracker[i] = Math.max(spaceTracker[i] + by, 0);
      }
    }

    function findEnd(start) {
      var i;
      for (i = start; i < spaceTracker.length; i++) {
        if (spaceTracker[i] !== 0) {
          return i;
        }
      }

      if (i === spaceTracker.length) {
        return i;
      }
    }

    function newSpaceTracker() {
      var tracker = [];
      for (var i = 0; i < colCount; i++) {
        tracker.push(0);
      }
      return tracker;
    }
  }
}

/**
 * @ngdoc directive
 * @name mdGridTile
 * @module material.components.gridList
 * @restrict E
 * @description
 * Tiles contain the content of an `md-grid-list`. They span one or more grid
 * cells vertically or horizontally, and use `md-grid-tile-{footer,header}` to
 * display secondary content.
 *
 * ### Responsive Attributes
 *
 * The `md-grid-tile` directive supports "responsive" attributes, which allow
 * different `md-rowspan` and `md-colspan` values depending on the currently
 * matching media query.
 *
 * In order to set a responsive attribute, first define the fallback value with
 * the standard attribute name, then add additional attributes with the
 * following convention: `{base-attribute-name}-{media-query-name}="{value}"`
 * (ie. `md-colspan-sm="4"`)
 *
 * @param {number=} md-colspan The number of columns to span (default 1). Cannot
 *    exceed the number of columns in the grid. Supports interpolation.
 * @param {number=} md-rowspan The number of rows to span (default 1). Supports
 *     interpolation.
 *
 * @usage
 * With header:
 * <hljs lang="html">
 * <md-grid-tile>
 *   <md-grid-tile-header>
 *     <h3>This is a header</h3>
 *   </md-grid-tile-header>
 * </md-grid-tile>
 * </hljs>
 *
 * With footer:
 * <hljs lang="html">
 * <md-grid-tile>
 *   <md-grid-tile-footer>
 *     <h3>This is a footer</h3>
 *   </md-grid-tile-footer>
 * </md-grid-tile>
 * </hljs>
 *
 * Spanning multiple rows/columns:
 * <hljs lang="html">
 * <md-grid-tile md-colspan="2" md-rowspan="3">
 * </md-grid-tile>
 * </hljs>
 *
 * Responsive attributes:
 * <hljs lang="html">
 * <md-grid-tile md-colspan="1" md-colspan-sm="3" md-colspan-md="5">
 * </md-grid-tile>
 * </hljs>
 */
function GridTileDirective($mdMedia) {
  return {
    restrict: 'E',
    require: '^mdGridList',
    template: '<figure ng-transclude></figure>',
    transclude: true,
    scope: {},
    // Simple controller that exposes attributes to the grid directive
    controller: ["$attrs", function($attrs) {
      this.$attrs = $attrs;
    }],
    link: postLink
  };

  function postLink(scope, element, attrs, gridCtrl) {
    // Apply semantics
    element.attr('role', 'listitem');

    // If our colspan or rowspan changes, trigger a layout
    var unwatchAttrs = $mdMedia.watchResponsiveAttributes(['md-colspan', 'md-rowspan'],
        attrs, angular.bind(gridCtrl, gridCtrl.invalidateLayout));

    // Tile registration/deregistration
    gridCtrl.invalidateTiles();
    scope.$on('$destroy', function() {
      // Mark the tile as destroyed so it is no longer considered in layout,
      // even if the DOM element sticks around (like during a leave animation)
      element[0].$$mdDestroyed = true;
      unwatchAttrs();
      gridCtrl.invalidateLayout();
    });

    if (angular.isDefined(scope.$parent.$index)) {
      scope.$watch(function() { return scope.$parent.$index; },
        function indexChanged(newIdx, oldIdx) {
          if (newIdx === oldIdx) {
            return;
          }
          gridCtrl.invalidateTiles();
        });
    }
  }
}


function GridTileCaptionDirective() {
  return {
    template: '<figcaption ng-transclude></figcaption>',
    transclude: true
  };
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.icon
 * @description
 * Icon
 */
angular.module('material.components.icon', ['material.core']);

})();
(function(){
"use strict";

angular
  .module('material.components.icon')
  .directive('mdIcon', ['$mdIcon', '$mdTheming', '$mdAria', '$sce', mdIconDirective]);

/**
 * @ngdoc directive
 * @name mdIcon
 * @module material.components.icon
 *
 * @restrict E
 *
 * @description
 * The `md-icon` directive makes it easier to use vector-based icons in your app (as opposed to
 * raster-based icons types like PNG). The directive supports both icon fonts and SVG icons.
 *
 * Icons should be considered view-only elements that should not be used directly as buttons; instead nest a `<md-icon>`
 * inside a `md-button` to add hover and click features.
 *
 * ### Icon fonts
 * Icon fonts are a technique in which you use a font where the glyphs in the font are
 * your icons instead of text. Benefits include a straightforward way to bundle everything into a
 * single HTTP request, simple scaling, easy color changing, and more.
 *
 * `md-icon` lets you consume an icon font by letting you reference specific icons in that font
 * by name rather than character code.
 *
 * When using font-icons, developers must follow three (3) simple steps:
 *
 * <ol>
 * <li>Load the font library. e.g.<br/>
 *    `<link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">`
 * </li>
 * <li>
 *   Use either (a) font-icon class names or (b) a fontset and a font ligature to render the font glyph by
 *   using its textual name _or_ numerical character reference. Note that `material-icons` is the default fontset when
 *   none is specified.
 * </li>
 * <li> Use any of the following templates: <br/>
 *   <ul>
 *     <li>`<md-icon md-font-icon="classname"></md-icon>`</li>
 *     <li>`<md-icon md-font-set="font library classname or alias">textual_name</md-icon>`</li>
 *     <li>`<md-icon> numerical_character_reference </md-icon>`</li>
 *     <li>`<md-icon ng_bind="'textual_name'"></md-icon>`</li>
 *     <li>`<md-icon ng-bind="scopeVariable"></md-icon>`</li>
 *   </ul>
 * </li>
 * </ol>
 *
 * Full details for these steps can be found in the
 * <a href="http://google.github.io/material-design-icons/#icon-font-for-the-web" target="_blank">
 * Material Design Icon font for the web docs</a>.
 *
 * You can browse and search the Material Design icon style <code>.material-icons</code>
 * in the <a href="https://material.io/tools/icons/" target="_blank">Material Design Icons tool</a>.
 *
 * ### SVG
 * For SVGs, the problem with using `<img>` or a CSS `background-image` is that you can't take
 * advantage of some SVG features, such as styling specific parts of the icon with CSS or SVG
 * animation.
 *
 * `md-icon` makes it easier to use SVG icons by *inlining* the SVG into an `<svg>` element in the
 * document. The most straightforward way of referencing an SVG icon is via URL, just like a
 * traditional `<img>`. `$mdIconProvider`, as a convenience, lets you _name_ an icon so you can
 * reference it by name instead of URL throughout your templates.
 *
 * Additionally, you may not want to make separate HTTP requests for every icon, so you can bundle
 * your SVG icons together and pre-load them with `$mdIconProvider` as an icon set. An icon set can
 * also be given a name, which acts as a namespace for individual icons, so you can reference them
 * like `"social:cake"`.
 *
 * When using SVGs, both external SVGs (via URLs) or sets of SVGs (from icon sets) can be
 * easily loaded and used.
 *
 * ### Localization
 *
 * Because an `md-icon` element's text content is not intended to be translated, it is recommended
 * to declare the text content for an `md-icon` element in its start tag. Instead of using the HTML
 * text content, consider using `ng-bind` with a scope variable or literal string.
 *
 * Examples:
 *
 * <ul>
 *   <li>`<md-icon ng-bind="myIconVariable"></md-icon>`</li>
 *   <li>`<md-icon ng-bind="'menu'"></md-icon>`
 * </ul>
 *
 * <h2 id="material_design_icons">Material Design Icons tool</h2>
 * Using the Material Design Icons tool, developers can easily and quickly search for a specific
 * open source Material Design icon. The search is in the top left. Below search, you can select
 * from the new icon themes or filter by icon category.
 *
 * <a href="https://material.io/tools/icons/" target="_blank" style="border-bottom:none;">
 * <img src="https://user-images.githubusercontent.com/3506071/41942584-ef0695d0-796d-11e8-9436-44f25023a111.png"
 *      aria-label="Material Design Icons tool" style="max-width:95%">
 * </a>
 *
 * <div class="md-caption" style="text-align: center; margin-bottom: 24px">
 *  Click on the image above to open the
 *  <a href="https://material.io/tools/icons/" target="_blank">Material Design Icons tool</a>.
 * </div>
 *
 * Click on any icon, then click on the "Selected Icon" chevron to see the slide-up
 * information panel with details regarding a SVG download and information on the font-icon's
 * textual name. This panel also allows you to select a black on transparent or white on transparent
 * icon and to change the icon size. These settings only affect the downloaded icons.
 *
 * @param {string} md-font-icon String name of CSS icon associated with the font-face will be used
 *  to render the icon. Requires the fonts and the named CSS styles to be preloaded.
 * @param {string} md-font-set CSS style name associated with the font library; which will be assigned as
 *  the class for the font-icon ligature. This value may also be an alias that is used to lookup the classname;
 *  internally use `$mdIconProvider.fontSet(<alias>)` to determine the style name.
 * @param {string} md-svg-src String URL (or expression) used to load, cache, and display an
 *  external SVG.
 * @param {string} md-svg-icon md-svg-icon String name used for lookup of the icon from the internal cache;
 *  interpolated strings or expressions may also be used. Specific set names can be used with
 *  the syntax `<set name>:<icon name>`.<br/><br/>
 *  To use icon sets, developers are required to pre-register the sets using the `$mdIconProvider` service.
 * @param {string=} aria-label Labels the icon for accessibility. If an empty string is provided,
 *  the icon will be hidden from the accessibility layer with `aria-hidden="true"`. If there is no
 *  `aria-label` attribute on the icon, we check the following, in order: the `alt` attribute, the
 *  `aria-label` from the parent element, the icon's `md-font-icon` or `md-svg-icon` string, and the
 *  text content inside `<md-icon></md-icon>`. If none of these have any text, the icon is hidden
 *  from the accessibility layer with `aria-hidden="true"`.
 * @param {string=} alt Labels the icon for accessibility. If an empty string is provided and the
 *  icon has no `aria-label`, then the icon will be hidden from accessibility layer with
 *  `aria-hidden="true"`.
 *
 * @usage
 * When using SVGs:
 * <hljs lang="html">
 *
 *<!-- Icon ID; may contain optional icon set prefix.
 *     Icons must be registered using $mdIconProvider. -->
 *<md-icon md-svg-icon="social:android"    aria-label="android " ></md-icon>
 *
 *<!-- Icon urls; may be preloaded in templateCache -->
 *<md-icon md-svg-src="/android.svg"       aria-label="android " ></md-icon>
 *<md-icon md-svg-src="{{ getAndroid() }}" aria-label="android " ></md-icon>
 *
 * </hljs>
 *
 * Use the <code>$mdIconProvider</code> to configure your application with
 * SVG icon sets.
 *
 * <hljs lang="js">
 * angular.module('appSvgIconSets', ['ngMaterial'])
 *   .controller('DemoCtrl', function($scope) {})
 *   .config(function($mdIconProvider) {
 *     $mdIconProvider
 *       .iconSet('social', 'img/icons/sets/social-icons.svg', 24)
 *       .defaultIconSet('img/icons/sets/core-icons.svg', 24);
 *    });
 * </hljs>
 *
 *
 * When using Font Icons with classnames:
 * <hljs lang="html">
 *
 * <md-icon md-font-icon="android" aria-label="android" ></md-icon>
 * <md-icon class="icon_home" aria-label="Home"></md-icon>
 *
 * </hljs>
 *
 * When using Material Font Icons with ligatures:
 * <hljs lang="html">
 *  <!--
 *  For Material Design Icons
 *  The class '.material-icons' is auto-added if a style has NOT been specified
 *  since `material-icons` is the default fontset. So your markup:
 *  -->
 *  <md-icon> face </md-icon>
 *  <!-- becomes this at runtime: -->
 *  <md-icon md-font-set="material-icons"> face </md-icon>
 *  <!-- If the fontset does not support ligature names, then we need to use the ligature unicode.-->
 *  <md-icon> &#xE87C; </md-icon>
 *  <!-- The class '.material-icons' must be manually added if other styles are also specified-->
 *  <md-icon class="material-icons md-light md-48"> face </md-icon>
 * </hljs>
 *
 * When using other Font-Icon libraries:
 *
 * <hljs lang="js">
 *  // Specify a font-icon style alias
 *  angular.config(function($mdIconProvider) {
 *    $mdIconProvider.fontSet('md', 'material-icons');
 *  });
 * </hljs>
 *
 * <hljs lang="html">
 *  <md-icon md-font-set="md">favorite</md-icon>
 * </hljs>
 *
 */
function mdIconDirective($mdIcon, $mdTheming, $mdAria, $sce) {

  return {
    restrict: 'E',
    link : postLink
  };


  /**
   * Directive postLink
   * Supports embedded SVGs, font-icons, & external SVGs.
   * @param {IScope} scope
   * @param {JQLite} element
   * @param {IAttributes} attr
   */
  function postLink(scope, element, attr) {
    $mdTheming(element);
    var lastFontIcon = attr.mdFontIcon;
    var lastFontSet = $mdIcon.fontSet(attr.mdFontSet);

    prepareForFontIcon();

    attr.$observe('mdFontIcon', fontIconChanged);
    attr.$observe('mdFontSet', fontIconChanged);

    /* Provide a default accessibility role of img */
    if (!attr.role) {
      $mdAria.expect(element, 'role', 'img');
      /* manually update attr variable */
      attr.role = 'img';
    }

    // If the aria-label is explicitly set to the empty string, then hide this element from the
    // accessibility layer.
    if (element[0].hasAttribute('aria-label') && attr.ariaLabel === '') {
      element.attr('aria-hidden', true);
    }

    /* Don't process ARIA if already valid */
    if (attr.role === "img" && !attr.ariaHidden && !$mdAria.hasAriaLabel(element)) {
      // If the developer signals to hide this icon from the accessibility layer, do so.
      if (element[0].hasAttribute('alt') && attr.alt === '') {
        element.attr('aria-hidden', true);
      } else if (attr.alt) {
        /* Use the alt text for the aria-label by default, if available. */
        $mdAria.expect(element, 'aria-label', attr.alt);
      } else if ($mdAria.parentHasAriaLabel(element, 2)) {
        /* Parent has ARIA so we will assume it will describe the icon. */
        $mdAria.expect(element, 'aria-hidden', 'true');
      } else if (attr.mdFontIcon || attr.mdSvgIcon || element.text()) {
        /* Use icon name or node's text content as the aria-label */
        $mdAria.expect(element, 'aria-label', attr.mdFontIcon || attr.mdSvgIcon || element.text());
      } else {
        /* No label found, hide this icon from the accessibility layer */
        $mdAria.expect(element, 'aria-hidden', 'true');
      }
    }

    var attrName = attr.$normalize(attr.$attr.mdSvgIcon || attr.$attr.mdSvgSrc || '');
    if (attrName) {
      // Use either pre-configured SVG or URL source, respectively.
      attr.$observe(attrName, function(attrVal) {
        element.empty();
        if (attrVal) {
          $mdIcon(attrVal)
            .then(function(svg) {
            element.empty();
            element.append(svg);
          });
        }
      });
    }

    function prepareForFontIcon() {
      if (!attr.mdSvgIcon && !attr.mdSvgSrc) {
        if (attr.mdFontIcon) {
          element.addClass('md-font ' + attr.mdFontIcon);
        }

        element.addClass(lastFontSet);
      }
    }

    function fontIconChanged() {
      if (!attr.mdSvgIcon && !attr.mdSvgSrc) {
        if (attr.mdFontIcon) {
          element.removeClass(lastFontIcon);
          element.addClass(attr.mdFontIcon);

          lastFontIcon = attr.mdFontIcon;
        }

        var fontSet = $mdIcon.fontSet(attr.mdFontSet);

        if (lastFontSet !== fontSet) {
          element.removeClass(lastFontSet);
          element.addClass(fontSet);

          lastFontSet = fontSet;
        }
      }
    }
  }
}

})();
(function(){
"use strict";

  
MdIconService.$inject = ["config", "$templateRequest", "$q", "$log", "$mdUtil", "$sce"];angular
    .module('material.components.icon')
    .constant('$$mdSvgRegistry', {
        'mdTabsArrow':   'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwb2x5Z29uIHBvaW50cz0iMTUuNCw3LjQgMTQsNiA4LDEyIDE0LDE4IDE1LjQsMTYuNiAxMC44LDEyICIvPjwvZz48L3N2Zz4=',
        'mdClose':       'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik0xOSA2LjQxbC0xLjQxLTEuNDEtNS41OSA1LjU5LTUuNTktNS41OS0xLjQxIDEuNDEgNS41OSA1LjU5LTUuNTkgNS41OSAxLjQxIDEuNDEgNS41OS01LjU5IDUuNTkgNS41OSAxLjQxLTEuNDEtNS41OS01LjU5eiIvPjwvZz48L3N2Zz4=',
        'mdCancel':      'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik0xMiAyYy01LjUzIDAtMTAgNC40Ny0xMCAxMHM0LjQ3IDEwIDEwIDEwIDEwLTQuNDcgMTAtMTAtNC40Ny0xMC0xMC0xMHptNSAxMy41OWwtMS40MSAxLjQxLTMuNTktMy41OS0zLjU5IDMuNTktMS40MS0xLjQxIDMuNTktMy41OS0zLjU5LTMuNTkgMS40MS0xLjQxIDMuNTkgMy41OSAzLjU5LTMuNTkgMS40MSAxLjQxLTMuNTkgMy41OSAzLjU5IDMuNTl6Ii8+PC9nPjwvc3ZnPg==',
        'mdMenu':        'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0zLDZIMjFWOEgzVjZNMywxMUgyMVYxM0gzVjExTTMsMTZIMjFWMThIM1YxNloiIC8+PC9zdmc+',
        'mdToggleArrow': 'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNDggNDgiPjxwYXRoIGQ9Ik0yNCAxNmwtMTIgMTIgMi44MyAyLjgzIDkuMTctOS4xNyA5LjE3IDkuMTcgMi44My0yLjgzeiIvPjxwYXRoIGQ9Ik0wIDBoNDh2NDhoLTQ4eiIgZmlsbD0ibm9uZSIvPjwvc3ZnPg==',
        'mdCalendar':    'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTkgM2gtMVYxaC0ydjJIOFYxSDZ2Mkg1Yy0xLjExIDAtMS45OS45LTEuOTkgMkwzIDE5YzAgMS4xLjg5IDIgMiAyaDE0YzEuMSAwIDItLjkgMi0yVjVjMC0xLjEtLjktMi0yLTJ6bTAgMTZINVY4aDE0djExek03IDEwaDV2NUg3eiIvPjwvc3ZnPg==',
        'mdChecked':     'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik05IDE2LjE3TDQuODMgMTJsLTEuNDIgMS40MUw5IDE5IDIxIDdsLTEuNDEtMS40MXoiLz48L2c+PC9zdmc+'
    })
    .provider('$mdIcon', MdIconProvider);

/**
 * @ngdoc service
 * @name $mdIconProvider
 * @module material.components.icon
 *
 * @description
 * `$mdIconProvider` is used only to register icon IDs with URLs. These configuration features allow
 * icons and icon sets to be pre-registered and associated with source URLs **before** the
 * `<md-icon />` directives are compiled.
 *
 * If using font-icons, the developer is responsible for loading the fonts.
 *
 * If using SVGs, loading of the actual svg files are deferred to on-demand requests and are loaded
 * internally by the `$mdIcon` service using the `$templateRequest` service. When an SVG is
 * requested by name/ID, the `$mdIcon` service searches its registry for the associated source URL;
 * that URL is used to on-demand load and parse the SVG dynamically.
 *
 * The `$templateRequest` service expects the icons source to be loaded over trusted URLs.<br/>
 * This means, when loading icons from an external URL, you have to trust the URL in the
 * `$sceDelegateProvider`.
 *
 * <hljs lang="js">
 *   app.config(function($sceDelegateProvider) {
 *     $sceDelegateProvider.trustedResourceUrlList([
 *       // Adding 'self' to the allow-list, will allow requests from the current origin.
 *       'self',
 *       // Using double asterisks here, will allow all URLs to load.
 *       // However, we recommend only specifying the given domain you want to allow.
 *       '**'
 *     ]);
 *   });
 * </hljs>
 *
 * Read more about the [$sceDelegateProvider](https://docs.angularjs.org/api/ng/provider/$sceDelegateProvider).
 *
 * **Notice:** Most font-icon libraries do not support ligatures (for example `fontawesome`).<br/>
 *  In such cases you are not able to use the icon's ligature name - Like so:
 *
 *  <hljs lang="html">
 *    <md-icon md-font-set="fa">fa-bell</md-icon>
 *  </hljs>
 *
 * You should instead use the given unicode, instead of the ligature name.
 *
 * <p ng-hide="true"> ##// Notice we can't use a hljs element here, because the characters will be escaped.</p>
 *  ```html
 *    <md-icon md-font-set="fa">&#xf0f3</md-icon>
 *  ```
 *
 * All unicode ligatures are prefixed with the `&#x` string.
 *
 * @usage
 * <hljs lang="js">
 *   app.config(function($mdIconProvider) {
 *
 *     // Configure URLs for icons specified by [set:]id.
 *     $mdIconProvider
 *       .defaultFontSet( 'fa' )                   // This sets our default fontset className.
 *       .defaultIconSet('my/app/icons.svg')       // Register a default set of SVG icons
 *       .iconSet('social', 'my/app/social.svg')   // Register a named icon set of SVGs
 *       .icon('android', 'my/app/android.svg')    // Register a specific icon (by name)
 *       .icon('work:chair', 'my/app/chair.svg');  // Register icon in a specific set
 *   });
 * </hljs>
 *
 * SVG icons and icon sets can be easily pre-loaded and cached using either (a) a build process or
 * (b) a runtime **startup** process (shown below):
 *
 * <hljs lang="js">
 *   app.config(function($mdIconProvider) {
 *
 *     // Register a default set of SVG icon definitions
 *     $mdIconProvider.defaultIconSet('my/app/icons.svg')
 *   })
 *   .run(function($templateRequest) {
 *
 *     // Pre-fetch icons sources by URL and cache in the $templateCache...
 *     // subsequent $templateRequest calls will look there first.
 *     var urls = [ 'imy/app/icons.svg', 'img/icons/android.svg'];
 *
 *     angular.forEach(urls, function(url) {
 *       $templateRequest(url);
 *     });
 *   });
 *
 * </hljs>
 *
 * > <b>Note:</b> The loaded SVG data is subsequently cached internally for future requests.
 */

/**
 * @ngdoc method
 * @name $mdIconProvider#icon
 *
 * @description
 * Register a source URL for a specific icon name; the name may include optional 'icon set' name
 * prefix. These icons will later be retrieved from the cache using `$mdIcon(<icon name>)`.
 *
 * @param {string} id Icon name/id used to register the icon
 * @param {string} url specifies the external location for the data file. Used internally by
 *  `$templateRequest` to load the data or as part of the lookup in `$templateCache` if pre-loading
 *  was configured.
 * @param {number=} viewBoxSize Sets the width and height the icon's viewBox.
 *  It is ignored for icons with an existing viewBox. Default size is 24.
 *
 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
 *
 * @usage
 * <hljs lang="js">
 *   app.config(function($mdIconProvider) {
 *
 *     // Configure URLs for icons specified by [set:]id.
 *     $mdIconProvider
 *       .icon('android', 'my/app/android.svg')    // Register a specific icon (by name)
 *       .icon('work:chair', 'my/app/chair.svg');  // Register icon in a specific set
 *   });
 * </hljs>
 */

/**
 * @ngdoc method
 * @name $mdIconProvider#iconSet
 *
 * @description
 * Register a source URL for a 'named' set of icons; group of SVG definitions where each definition
 * has an icon id. Individual icons can be subsequently retrieved from this cached set using
 * `$mdIcon(<icon set name>:<icon name>)`
 *
 * @param {string} id Icon name/id used to register the iconset
 * @param {string} url specifies the external location for the data file. Used internally by
 * `$templateRequest` to load the data or as part of the lookup in `$templateCache` if pre-loading
 * was configured.
 * @param {number=} viewBoxSize Sets the width and height of the viewBox of all icons in the set.
 * It is ignored for icons with an existing viewBox. All icons in the icon set should be the same size.
 * Default value is 24.
 *
 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
 *
 * @usage
 * <hljs lang="js">
 *   app.config(function($mdIconProvider) {
 *
 *     // Configure URLs for icons specified by [set:]id.
 *     $mdIconProvider
 *       .iconSet('social', 'my/app/social.svg');   // Register a named icon set
 *   });
 * </hljs>
 */

/**
 * @ngdoc method
 * @name $mdIconProvider#defaultIconSet
 *
 * @description
 * Register a source URL for the default 'named' set of icons. Unless explicitly registered,
 * subsequent lookups of icons will fail over to search this 'default' icon set.
 * Icon can be retrieved from this cached, default set using `$mdIcon(<name>)`
 *
 * @param {string} url specifies the external location for the data file. Used internally by
 * `$templateRequest` to load the data or as part of the lookup in `$templateCache` if pre-loading
 * was configured.
 * @param {number=} viewBoxSize Sets the width and height of the viewBox of all icons in the set.
 * It is ignored for icons with an existing viewBox. All icons in the icon set should be the same
 * size. Default value is 24.
 *
 * @returns {Object} an `$mdIconProvider` reference; used to support method call chains for the API
 *
 * @usage
 * <hljs lang="js">
 *   app.config(function($mdIconProvider) {
 *
 *     // Configure URLs for icons specified by [set:]id.
 *     $mdIconProvider
 *       .defaultIconSet('my/app/social.svg');   // Register a default icon set
 *   });
 * </hljs>
 */

/**
 * @ngdoc method
 * @name $mdIconProvider#defaultFontSet
 *
 * @description
 * When using Font-Icons, AngularJS Material assumes the the Material Design icons will be used and
 * automatically configures the default `font-set == 'material-icons'`. Note that the font-set
 * references the font-icon library class style that should be applied to the `<md-icon>`.
 *
 * Configuring the default means that the attributes
 * `md-font-set="material-icons"` or `class="material-icons"` do not need to be explicitly declared
 * on the `<md-icon>` markup.
 *
 * For example:<br/>
 * `<md-icon>face</md-icon>` will render as `<span class="material-icons">face</span>`,<br/>
 * and<br/>
 * `<md-icon md-font-set="fa">face</md-icon>` will render as `<span class="fa">face</span>`
 *
 * @param {string} name Name of the font-library style that should be applied to the md-icon DOM
 *  element.
 *
 * @usage
 * <hljs lang="js">
 *   app.config(function($mdIconProvider) {
 *     $mdIconProvider.defaultFontSet('fa');
 *   });
 * </hljs>
 */

/**
 * @ngdoc method
 * @name $mdIconProvider#fontSet
 *
 * @description
 * When using a font-set for `<md-icon>` you must specify the correct font classname in the
 * `md-font-set` attribute. If the font-set className is really long, your markup may become
 * cluttered... an easy solution is to define an `alias` for your font-set:
 *
 * @param {string} alias Alias name of the specified font-set.
 * @param {string} className Name of the class for the font-set.
 *
 * @usage
 * <hljs lang="js">
 *   app.config(function($mdIconProvider) {
 *     // In this case, we set an alias for the `material-icons` font-set.
 *     $mdIconProvider.fontSet('md', 'material-icons');
 *   });
 * </hljs>
 */

/**
 * @ngdoc method
 * @name $mdIconProvider#defaultViewBoxSize
 *
 * @description
 * While `<md-icon>` markup can also be styled with sizing CSS, this method configures
 * the default width **and** height used for all icons; unless overridden by specific CSS.
 * The default sizing is (`24px`, `24px`).
 * @param {number=} viewBoxSize Sets the width and height of the viewBox for an icon or an icon set.
 * All icons in a set should be the same size. The default value is 24.
 *
 * @returns {Object} an `$mdIconProvider` reference; used to support method call chains for the API
 *
 * @usage
 * <hljs lang="js">
 *   app.config(function($mdIconProvider) {
 *
 *     // Configure URLs for icons specified by [set:]id.
 *     $mdIconProvider
 *       .defaultViewBoxSize(36);   // Register a default icon size (width == height)
 *   });
 * </hljs>
 */

var config = {
  defaultViewBoxSize: 24,
  defaultFontSet: 'material-icons',
  fontSets: []
};

function MdIconProvider() {
}

MdIconProvider.prototype = {
  icon: function(id, url, viewBoxSize) {
    if (id.indexOf(':') == -1) id = '$default:' + id;

    config[id] = new ConfigurationItem(url, viewBoxSize);
    return this;
  },

  iconSet: function(id, url, viewBoxSize) {
    config[id] = new ConfigurationItem(url, viewBoxSize);
    return this;
  },

  defaultIconSet: function(url, viewBoxSize) {
    var setName = '$default';

    if (!config[setName]) {
      config[setName] = new ConfigurationItem(url, viewBoxSize);
    }

    config[setName].viewBoxSize = viewBoxSize || config.defaultViewBoxSize;

    return this;
  },

  defaultViewBoxSize: function(viewBoxSize) {
    config.defaultViewBoxSize = viewBoxSize;
    return this;
  },

  /**
   * Register an alias name associated with a font-icon library style ;
   */
  fontSet: function fontSet(alias, className) {
    config.fontSets.push({
      alias: alias,
      fontSet: className || alias
    });
    return this;
  },

  /**
   * Specify a default style name associated with a font-icon library
   * fallback to Material Icons.
   *
   */
  defaultFontSet: function defaultFontSet(className) {
    config.defaultFontSet = !className ? '' : className;
    return this;
  },

  defaultIconSize: function defaultIconSize(iconSize) {
    config.defaultIconSize = iconSize;
    return this;
  },

  $get: ['$templateRequest', '$q', '$log', '$mdUtil', '$sce', function($templateRequest, $q, $log, $mdUtil, $sce) {
    return MdIconService(config, $templateRequest, $q, $log, $mdUtil, $sce);
  }]
};

  /**
   * Configuration item stored in the Icon registry; used for lookups
   * to load if not already cached in the `loaded` cache
   * @param {string} url
   * @param {=number} viewBoxSize
   * @constructor
   */
  function ConfigurationItem(url, viewBoxSize) {
    this.url = url;
    this.viewBoxSize = viewBoxSize || config.defaultViewBoxSize;
  }

/**
 * @ngdoc service
 * @name $mdIcon
 * @module material.components.icon
 *
 * @description
 * The `$mdIcon` service is a function used to lookup SVG icons.
 *
 * @param {string} id Query value for a unique Id or URL. If the argument is a URL, then the service will retrieve the icon element
 * from its internal cache or load the icon and cache it first. If the value is not a URL-type string, then an ID lookup is
 * performed. The Id may be a unique icon ID or may include an iconSet ID prefix.
 *
 * For the **id** query to work properly, this means that all id-to-URL mappings must have been previously configured
 * using the `$mdIconProvider`.
 *
 * @returns {angular.$q.Promise} A promise that gets resolved to a clone of the initial SVG DOM element; which was
 * created from the SVG markup in the SVG data file. If an error occurs (e.g. the icon cannot be found) the promise
 * will get rejected.
 *
 * @usage
 * <hljs lang="js">
 * function SomeDirective($mdIcon) {
 *
 *   // See if the icon has already been loaded, if not then lookup the icon from the
 *   // registry cache, load and cache it for future requests.
 *   // NOTE: Non-URL queries require configuration with $mdIconProvider.
 *   $mdIcon('android').then(function(iconEl)    { element.append(iconEl); });
 *   $mdIcon('work:chair').then(function(iconEl) { element.append(iconEl); });
 *
 *   // Load and cache the external SVG using a URL.
 *   $mdIcon('img/icons/android.svg').then(function(iconEl) {
 *     element.append(iconEl);
 *   });
 * };
 * </hljs>
 *
 * > <b>Note:</b> The `<md-icon>` directive internally uses the `$mdIcon` service to query, load,
 *   and instantiate SVG DOM elements.
 */

/* @ngInject */
function MdIconService(config, $templateRequest, $q, $log, $mdUtil, $sce) {
  var iconCache = {};
  var svgCache = {};
  var urlRegex = /[-\w@:%+.~#?&//=]{2,}\.[a-z]{2,4}\b(\/[-\w@:%+.~#?&//=]*)?/i;
  var dataUrlRegex = /^data:image\/svg\+xml[\s*;\w\-=]*?(base64)?,(.*)$/i;

  Icon.prototype = {clone: cloneSVG, prepare: prepareAndStyle};
  getIcon.fontSet = findRegisteredFontSet;

  // Publish service...
  return getIcon;

  /**
   * Actual $mdIcon service is essentially a lookup function
   * @param {*} id $sce trust wrapper over a URL string, URL, icon registry id, or icon set id
   * @returns {angular.$q.Promise}
   */
  function getIcon(id) {
    id = id || '';

    // If the "id" provided is not a string, the only other valid value is a $sce trust wrapper
    // over a URL string. If the value is not trusted, this will intentionally throw an error
    // because the user is attempted to use an unsafe URL, potentially opening themselves up
    // to an XSS attack.
    if (!angular.isString(id)) {
      id = $sce.getTrustedUrl(id);
    }

    // If already loaded and cached, use a clone of the cached icon.
    // Otherwise either load by URL, or lookup in the registry and then load by URL, and cache.

    if (iconCache[id]) {
      return $q.when(transformClone(iconCache[id]));
    }

    if (urlRegex.test(id) || dataUrlRegex.test(id)) {
      return loadByURL(id).then(cacheIcon(id));
    }

    if (id.indexOf(':') === -1) {
      id = '$default:' + id;
    }

    var load = config[id] ? loadByID : loadFromIconSet;
    return load(id)
      .then(cacheIcon(id));
  }

  /**
   * Lookup a registered fontSet style using its alias.
   * @param {string} alias used to lookup the alias in the array of fontSets
   * @returns {*} matching fontSet or the defaultFontSet if that alias does not match
   */
  function findRegisteredFontSet(alias) {
    var useDefault = angular.isUndefined(alias) || !(alias && alias.length);
    if (useDefault) {
      return config.defaultFontSet;
    }

    var result = alias;
    angular.forEach(config.fontSets, function(fontSet) {
      if (fontSet.alias === alias) {
        result = fontSet.fontSet || result;
      }
    });

    return result;
  }

  /**
   * @param {!Icon} cacheElement cached icon from the iconCache
   * @returns {Icon} cloned Icon element with unique ids
   */
  function transformClone(cacheElement) {
    var clone = cacheElement.clone();
    var newUid = $mdUtil.nextUid();
    var cacheSuffix, svgUrlQuerySelector, i, xlinkHrefValue;
    // These are SVG attributes that can reference element ids.
    var svgUrlAttributes = [
      'clip-path', 'color-profile', 'cursor', 'fill', 'filter', 'href', 'marker-start',
      'marker-mid', 'marker-end', 'mask', 'stroke', 'style', 'vector-effect'
    ];
    var isIeSvg = clone.innerHTML === undefined;

    // Verify that the newUid only contains a number and not some XSS content.
    if (!isFinite(Number(newUid))) {
      throw new Error('Unsafe and unexpected non-number result from $mdUtil.nextUid().');
    }
    cacheSuffix = '_cache' + newUid;

    // For each cached icon, we need to modify the id attributes and references.
    // This is needed because SVG ids are treated as normal DOM ids and should not be duplicated on
    // the page.
    if (clone.id) {
      clone.id += cacheSuffix;
    }

    // Do as much as possible with querySelectorAll as it provides much greater performance
    // than RegEx against serialized DOM.
    angular.forEach(clone.querySelectorAll('[id]'), function(descendantElem) {
      svgUrlQuerySelector = '';
      for (i = 0; i < svgUrlAttributes.length; i++) {
        svgUrlQuerySelector += '[' + svgUrlAttributes[i] + '="url(#' + descendantElem.id + ')"]';
        if (i + 1 < svgUrlAttributes.length) {
          svgUrlQuerySelector += ', ';
        }
      }
      // Append the cacheSuffix to references of the element's id within url(#id) calls.
      angular.forEach(clone.querySelectorAll(svgUrlQuerySelector), function(refItem) {
        updateSvgIdReferences(descendantElem, refItem, isIeSvg, newUid);
      });
      // Handle usages of url(#id) in the SVG's stylesheets
      angular.forEach(clone.querySelectorAll('style'), function(refItem) {
        updateSvgIdReferences(descendantElem, refItem, isIeSvg, newUid);
      });

      // Update ids referenced by the deprecated (in SVG v2) xlink:href XML attribute. The now
      // preferred href attribute is handled above. However, this non-standard XML namespaced
      // attribute cannot be handled in the same way. Explanation of this query selector here:
      // https://stackoverflow.com/q/23034283/633107.
      angular.forEach(clone.querySelectorAll('[*|href]:not([href])'), function(refItem) {
        xlinkHrefValue = refItem.getAttribute('xlink:href');
        if (xlinkHrefValue) {
          xlinkHrefValue = xlinkHrefValue.replace("#" + descendantElem.id, "#" + descendantElem.id + cacheSuffix);
          refItem.setAttribute('xlink:href', xlinkHrefValue);
        }
      });

      descendantElem.id += cacheSuffix;
    });

    return clone;
  }

  /**
   * @param {Element} referencedElement element w/ id that needs to be updated
   * @param {Element} referencingElement element that references the original id
   * @param {boolean} isIeSvg true if we're dealing with an SVG in IE11, false otherwise
   * @param {string} newUid the cache id to add as part of the cache suffix
   */
  function updateSvgIdReferences(referencedElement, referencingElement, isIeSvg, newUid) {
    var svgElement, cacheSuffix;

    // Verify that the newUid only contains a number and not some XSS content.
    if (!isFinite(Number(newUid))) {
      throw new Error('Unsafe and unexpected non-number result for newUid.');
    }
    cacheSuffix = '_cache' + newUid;

    // outerHTML of SVG elements is not supported by IE11
    if (isIeSvg) {
      svgElement = $mdUtil.getOuterHTML(referencingElement);
      svgElement = svgElement.replace("url(#" + referencedElement.id + ")",
        "url(#" + referencedElement.id + cacheSuffix + ")");
      referencingElement.textContent = angular.element(svgElement)[0].innerHTML;
    } else {
      // This use of outerHTML should be safe from XSS attack since we are only injecting the
      // cacheSuffix with content from $mdUtil.nextUid which we verify is a finite number above.
      referencingElement.outerHTML = referencingElement.outerHTML.replace(
        "url(#" + referencedElement.id + ")",
        "url(#" + referencedElement.id + cacheSuffix + ")");
    }
  }

  /**
   * Prepare and cache the loaded icon for the specified `id`.
   * @param {string} id icon cache id
   * @returns {function(*=): *}
   */
  function cacheIcon(id) {

    return function updateCache(icon) {
      iconCache[id] = isIcon(icon) ? icon : new Icon(icon, config[id]);

      return transformClone(iconCache[id]);
    };
  }

  /**
   * Lookup the configuration in the registry, if !registered throw an error
   * otherwise load the icon [on-demand] using the registered URL.
   * @param {string} id icon registry id
   * @returns {angular.$q.Promise}
   */
  function loadByID(id) {
    var iconConfig = config[id];
    return loadByURL(iconConfig.url).then(function(icon) {
      return new Icon(icon, iconConfig);
    });
  }

  /**
   * Loads the file as XML and uses querySelector( <id> ) to find the desired node...
   * @param {string} id icon id in icon set
   * @returns {angular.$q.Promise}
   */
  function loadFromIconSet(id) {
    var setName = id.substring(0, id.lastIndexOf(':')) || '$default';
    var iconSetConfig = config[setName];

    return !iconSetConfig ? announceIdNotFound(id) : loadByURL(iconSetConfig.url).then(extractFromSet);

    function extractFromSet(set) {
      var iconName = id.slice(id.lastIndexOf(':') + 1);
      var icon = set.querySelector('#' + iconName);
      return icon ? new Icon(icon, iconSetConfig) : announceIdNotFound(id);
    }

    function announceIdNotFound(id) {
      var msg = 'icon ' + id + ' not found';
      $log.warn(msg);

      return $q.reject(msg || id);
    }
  }

  /**
   * Load the icon by URL (may use the $templateCache).
   * Extract the data for later conversion to Icon
   * @param {string} url icon URL
   * @returns {angular.$q.Promise}
   */
  function loadByURL(url) {
    /* Load the icon from embedded data URL. */
    function loadByDataUrl(url) {
      var results = dataUrlRegex.exec(url);
      var isBase64 = /base64/i.test(url);
      var data = isBase64 ? window.atob(results[2]) : results[2];

      return $q.when(angular.element(data)[0]);
    }

    /* Load the icon by URL using HTTP. */
    function loadByHttpUrl(url) {
      return $q(function(resolve, reject) {
        // Catch HTTP or generic errors not related to incorrect icon IDs.
        var announceAndReject = function(err) {
            var msg = angular.isString(err) ? err : (err.message || err.data || err.statusText);
            $log.warn(msg);
            reject(err);
          },
          extractSvg = function(response) {
            if (!svgCache[url]) {
              svgCache[url] = angular.element('<div>').append(response)[0].querySelector('svg');
            }
            resolve(svgCache[url]);
          };

        $templateRequest(url, true).then(extractSvg, announceAndReject);
      });
    }

    return dataUrlRegex.test(url)
      ? loadByDataUrl(url)
      : loadByHttpUrl(url);
  }

  /**
   * Check target signature to see if it is an Icon instance.
   * @param {Icon|Element} target
   * @returns {boolean} true if the specified target is an Icon object, false otherwise.
   */
  function isIcon(target) {
    return angular.isDefined(target.element) && angular.isDefined(target.config);
  }

  /**
   * Define the Icon class
   * @param {Element} el
   * @param {=ConfigurationItem} config
   * @constructor
   */
  function Icon(el, config) {
    // If the node is a <symbol>, it won't be rendered so we have to convert it into <svg>.
    if (el && el.tagName.toLowerCase() === 'symbol') {
      var viewbox = el.getAttribute('viewBox');
      // // Check if innerHTML is supported as IE11 does not support innerHTML on SVG elements.
      if (el.innerHTML) {
        el = angular.element('<svg xmlns="http://www.w3.org/2000/svg">')
          .html(el.innerHTML)[0];
      } else {
        el = angular.element('<svg xmlns="http://www.w3.org/2000/svg">')
          .append($mdUtil.getInnerHTML(el))[0];
      }
      if (viewbox) el.setAttribute('viewBox', viewbox);
    }

    if (el && el.tagName.toLowerCase() !== 'svg') {
      el = angular.element(
        '<svg xmlns="http://www.w3.org/2000/svg">').append(el.cloneNode(true))[0];
    }

    // Inject the namespace if not available...
    if (!el.getAttribute('xmlns')) {
      el.setAttribute('xmlns', "http://www.w3.org/2000/svg");
    }

    this.element = el;
    this.config = config;
    this.prepare();
  }

  /**
   *  Prepare the DOM element that will be cached in the
   *  loaded iconCache store.
   */
  function prepareAndStyle() {
    var viewBoxSize = this.config ? this.config.viewBoxSize : config.defaultViewBoxSize;
    angular.forEach({
      'fit': '',
      'height': '100%',
      'width': '100%',
      'preserveAspectRatio': 'xMidYMid meet',
      'viewBox': this.element.getAttribute('viewBox') || ('0 0 ' + viewBoxSize + ' ' + viewBoxSize),
      'focusable': false // Disable IE11s default behavior to make SVGs focusable
    }, function(val, attr) {
      this.element.setAttribute(attr, val);
    }, this);
  }

  /**
   * Clone the Icon DOM element.
   */
  function cloneSVG() {
    // If the element or any of its children have a style attribute, then a CSP policy without
    // 'unsafe-inline' in the style-src directive, will result in a violation.
    return this.element.cloneNode(true);
  }

}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.input
 */
mdInputContainerDirective.$inject = ["$mdTheming", "$parse", "$$rAF"];
inputTextareaDirective.$inject = ["$mdUtil", "$window", "$mdAria", "$timeout", "$mdGesture"];
mdMaxlengthDirective.$inject = ["$animate", "$mdUtil"];
placeholderDirective.$inject = ["$compile"];
ngMessageDirective.$inject = ["$mdUtil"];
mdSelectOnFocusDirective.$inject = ["$document", "$timeout"];
mdInputInvalidMessagesAnimation.$inject = ["$$AnimateRunner", "$animateCss", "$mdUtil"];
ngMessagesAnimation.$inject = ["$$AnimateRunner", "$animateCss", "$mdUtil"];
ngMessageAnimation.$inject = ["$$AnimateRunner", "$animateCss", "$mdUtil", "$log"];
var inputModule = angular.module('material.components.input', [
    'material.core'
  ])
  .directive('mdInputContainer', mdInputContainerDirective)
  .directive('label', labelDirective)
  .directive('input', inputTextareaDirective)
  .directive('textarea', inputTextareaDirective)
  .directive('mdMaxlength', mdMaxlengthDirective)
  .directive('placeholder', placeholderDirective)
  .directive('ngMessages', ngMessagesDirective)
  .directive('ngMessage', ngMessageDirective)
  .directive('ngMessageExp', ngMessageDirective)
  .directive('mdSelectOnFocus', mdSelectOnFocusDirective)

  .animation('.md-input-invalid', mdInputInvalidMessagesAnimation)
  .animation('.md-input-messages-animation', ngMessagesAnimation)
  .animation('.md-input-message-animation', ngMessageAnimation);

// If we are running inside of tests; expose some extra services so that we can test them
if (window._mdMocksIncluded) {
  inputModule.service('$$mdInput', function() {
    return {
      // special accessor to internals... useful for testing
      messages: {
        getElement  : getMessagesElement
      }
    };
  })

  // Register a service for each animation so that we can easily inject them into unit tests
  .service('mdInputInvalidAnimation', mdInputInvalidMessagesAnimation)
  .service('mdInputMessagesAnimation', ngMessagesAnimation)
  .service('mdInputMessageAnimation', ngMessageAnimation);
}

/**
 * @ngdoc directive
 * @name mdInputContainer
 * @module material.components.input
 *
 * @restrict E
 *
 * @description
 * `<md-input-container>` is the parent of any input or textarea element. It can also optionally
 * wrap `<md-select>` elements so that they will be formatted for use in a form.
 *
 * Input and textarea elements will not behave properly unless the md-input-container parent is
 * provided.
 *
 * A single `<md-input-container>` should contain only one `<input>` or `<md-select>` element,
 * otherwise it will throw an error.
 *
 * <b>Exception:</b> Hidden inputs (`<input type="hidden" />`) are ignored and will not throw an
 * error, so you may combine these with other inputs.
 *
 * <b>Note:</b> When using `ngMessages` with your input element, make sure the message and container
 * elements are *block* elements, otherwise animations applied to the messages will not look as
 * intended. Either use a `div` and apply the `ng-message` and `ng-messages` classes respectively,
 * or use the `md-block` class on your element.
 *
 * @param {expression=} md-is-error When the given expression evaluates to `true`, the input
 *   container will go into the error state. Defaults to erroring if the input has been touched and
 *   is invalid.
 * @param {boolean=} md-no-float When present, `placeholder` attributes on the input will not be
 *   converted to floating labels.
 *
 * @usage
 * <hljs lang="html">
 * <md-input-container>
 *   <label>Username</label>
 *   <input type="text" ng-model="user.name">
 * </md-input-container>
 *
 * <md-input-container>
 *   <label>Description</label>
 *   <textarea ng-model="user.description"></textarea>
 * </md-input-container>
 *
 * <md-input-container>
 *   <md-select ng-model="user.state" placeholder="State of Residence">
 *     <md-option ng-value="state" ng-repeat="state in states">{{ state }}</md-option>
 *   </md-select>
 * </md-input-container>
 * </hljs>
 *
 * <h3>When disabling floating labels</h3>
 * <hljs lang="html">
 * <md-input-container md-no-float>
 *   <input type="text" placeholder="Non-Floating Label">
 * </md-input-container>
 * </hljs>
 *
 * <h3>Aligning Form Elements</h3>
 * Wrap your form elements with the `md-inline-form` class in order to align them horizontally
 * within a form.
 *
 * <hljs lang="html">
 * <form class="md-inline-form">
 *   <md-input-container>
 *     <label>Username</label>
 *     <input type="text" ng-model="user.name">
 *   </md-input-container>
 *
 *   <md-input-container>
 *     <label>Description</label>
 *     <textarea ng-model="user.description"></textarea>
 *   </md-input-container>
 *
 *   <md-input-container>
 *     <label>State of Residence</label>
 *     <md-select ng-model="user.state">
 *       <md-option ng-value="state" ng-repeat="state in states">{{ state }}</md-option>
 *     </md-select>
 *   </md-input-container>
 *
 *   <md-input-container>
 *     <label>Enter date</label>
 *     <md-datepicker ng-model="user.submissionDate"></md-datepicker>
 *   </md-input-container>
 *
 *   <md-input-container>
 *     <md-checkbox ng-model="user.licenseAccepted">
 *       I agree to the license terms.
 *     </md-checkbox>
 *   </md-input-container>
 * </form>
 * </hljs>
 */
function mdInputContainerDirective($mdTheming, $parse, $$rAF) {

  ContainerCtrl.$inject = ["$scope", "$element", "$attrs", "$animate"];
  var INPUT_TAGS = ['INPUT', 'TEXTAREA', 'SELECT', 'MD-SELECT'];

  var LEFT_SELECTORS = INPUT_TAGS.reduce(function(selectors, isel) {
    return selectors.concat(['md-icon ~ ' + isel, '.md-icon ~ ' + isel]);
  }, []).join(",");

  var RIGHT_SELECTORS = INPUT_TAGS.reduce(function(selectors, isel) {
    return selectors.concat([isel + ' ~ md-icon', isel + ' ~ .md-icon']);
  }, []).join(",");

  return {
    restrict: 'E',
    compile: compile,
    controller: ContainerCtrl
  };

  function compile(tElement) {
    // Check for both a left & right icon
    var hasLeftIcon = tElement[0].querySelector(LEFT_SELECTORS);
    var hasRightIcon = tElement[0].querySelector(RIGHT_SELECTORS);

    return function postLink(scope, element) {
      $mdTheming(element);

      if (hasLeftIcon || hasRightIcon) {
        // When accessing the element's contents synchronously, they may not be defined yet because
        // of the use of ng-if. If we wait one frame, then the element should be there if the ng-if
        // resolves to true.
        $$rAF(function() {
          // Handle the case where the md-icon element is initially hidden via ng-if from #9529.
          // We don't want to preserve the space for the icon in the case of ng-if, like we do for
          // ng-show.
          // Note that we can't use the same selectors from above because the elements are no longer
          // siblings for textareas at this point due to the insertion of the md-resize-wrapper.
          var iconNotRemoved = element[0].querySelector('md-icon') ||
            element[0].querySelector('.md-icon');
          if (hasLeftIcon && iconNotRemoved) {
            element.addClass('md-icon-left');
          }
          if (hasRightIcon && iconNotRemoved) {
            element.addClass('md-icon-right');
          }
        });
      }
    };
  }

  function ContainerCtrl($scope, $element, $attrs, $animate) {
    var self = this;

    $element.addClass('md-auto-horizontal-margin');

    self.isErrorGetter = $attrs.mdIsError && $parse($attrs.mdIsError);

    self.delegateClick = function() {
      self.input.focus();
    };
    self.element = $element;
    self.setFocused = function(isFocused) {
      $element.toggleClass('md-input-focused', !!isFocused);
    };
    self.setHasValue = function(hasValue) {
      $element.toggleClass('md-input-has-value', !!hasValue);
    };
    self.setHasPlaceholder = function(hasPlaceholder) {
      $element.toggleClass('md-input-has-placeholder', !!hasPlaceholder);
    };
    self.setInvalid = function(isInvalid) {
      if (isInvalid) {
        $animate.addClass($element, 'md-input-invalid');
      } else {
        $animate.removeClass($element, 'md-input-invalid');
      }
    };
    $scope.$watch(function() {
      return self.label && self.input;
    }, function(hasLabelAndInput) {
      if (hasLabelAndInput && !self.label.attr('for')) {
        self.label.attr('for', self.input.attr('id'));
      }
    });
  }
}

function labelDirective() {
  return {
    restrict: 'E',
    require: '^?mdInputContainer',
    link: function(scope, element, attr, containerCtrl) {
      if (!containerCtrl || attr.mdNoFloat || element.hasClass('md-container-ignore')) return;

      containerCtrl.label = element;
      scope.$on('$destroy', function() {
        containerCtrl.label = null;
      });
    }
  };
}

/**
 * @ngdoc directive
 * @name mdInput
 * @restrict E
 * @module material.components.input
 *
 * @description
 * You can use any `<input>` or `<textarea>` element as a child of an `<md-input-container>`. This
 * allows you to build complex forms for data entry.
 *
 * When the input is required and uses a floating label, then the label will automatically contain
 * an asterisk (`*`).<br/>
 * This behavior can be disabled by using the `md-no-asterisk` attribute.
 *
 * @param {number=} md-maxlength The maximum number of characters allowed in this input. If this is
 *   specified, a character counter will be shown underneath the input.<br/><br/>
 *   The purpose of **`md-maxlength`** is exactly to show the max length counter text. If you don't
 *   want the counter text and only need "plain" validation, you can use the "simple" `ng-maxlength`
 *   or maxlength attributes.<br/><br/>
 * @param {boolean=} ng-trim If set to false, the input text will be not trimmed automatically.
 *     Defaults to true.
 * @param {string=} aria-label Aria-label is required when no label is present.  A warning message
 *   will be logged in the console if not present.
 * @param {string=} placeholder An alternative approach to using aria-label when the label is not
 *   PRESENT. The placeholder text is copied to the aria-label attribute.
 * @param {boolean=} md-no-autogrow When present, textareas will not grow automatically.
 * @param {boolean=} md-no-asterisk When present, an asterisk will not be appended to the inputs
 *   floating label.
 * @param {boolean=} md-no-resize Disables the textarea resize handle.
 * @param {number=} max-rows The maximum amount of rows for a textarea.
 * @param {boolean=} md-detect-hidden When present, textareas will be sized properly when they are
 *   revealed after being hidden. This is off by default for performance reasons because it
 *   guarantees a reflow every digest cycle.
 *
 * @usage
 * <hljs lang="html">
 * <md-input-container>
 *   <label>Color</label>
 *   <input type="text" ng-model="color" required md-maxlength="10">
 * </md-input-container>
 * </hljs>
 *
 * <h3>With Errors</h3>
 *
 * `md-input-container` also supports errors using the standard `ng-messages` directives and
 * animates the messages when they become visible using from the `ngEnter`/`ngLeave` events or
 * the `ngShow`/`ngHide` events.
 *
 * By default, the messages will be hidden until the input is in an error state. This is based off
 * of the `md-is-error` expression of the `md-input-container`. This gives the user a chance to
 * fill out the form before the errors become visible.
 *
 * <hljs lang="html">
 * <form name="colorForm">
 *   <md-input-container>
 *     <label>Favorite Color</label>
 *     <input name="favoriteColor" ng-model="favoriteColor" required>
 *     <div ng-messages="colorForm.favoriteColor.$error">
 *       <div ng-message="required">This is required!</div>
 *     </div>
 *   </md-input-container>
 * </form>
 * </hljs>
 *
 * We automatically disable this auto-hiding functionality if you provide any of the following
 * visibility directives on the `ng-messages` container:
 *
 *  - `ng-if`
 *  - `ng-show`/`ng-hide`
 *  - `ng-switch-when`/`ng-switch-default`
 *
 * You can also disable this functionality manually by adding the `md-auto-hide="false"` expression
 * to the `ng-messages` container. This may be helpful if you always want to see the error messages
 * or if you are building your own visibility directive.
 *
 * _<b>Note:</b> The `md-auto-hide` attribute is a static string that is  only checked upon
 * initialization of the `ng-messages` directive to see if it equals the string `false`._
 *
 * <hljs lang="html">
 * <form name="userForm">
 *   <md-input-container>
 *     <label>Last Name</label>
 *     <input name="lastName" ng-model="lastName" required md-maxlength="10" minlength="4">
 *     <div ng-messages="userForm.lastName.$error" ng-show="userForm.lastName.$dirty">
 *       <div ng-message="required">This is required!</div>
 *       <div ng-message="md-maxlength">That's too long!</div>
 *       <div ng-message="minlength">That's too short!</div>
 *     </div>
 *   </md-input-container>
 *   <md-input-container>
 *     <label>Biography</label>
 *     <textarea name="bio" ng-model="biography" required md-maxlength="150"></textarea>
 *     <div ng-messages="userForm.bio.$error" ng-show="userForm.bio.$dirty">
 *       <div ng-message="required">This is required!</div>
 *       <div ng-message="md-maxlength">That's too long!</div>
 *     </div>
 *   </md-input-container>
 *   <md-input-container>
 *     <input aria-label='title' ng-model='title'>
 *   </md-input-container>
 *   <md-input-container>
 *     <input placeholder='title' ng-model='title'>
 *   </md-input-container>
 * </form>
 * </hljs>
 *
 * <h3>Notes</h3>
 *
 * - Requires [ngMessages](https://docs.angularjs.org/api/ngMessages).
 * - Behaves like the [AngularJS input directive](https://docs.angularjs.org/api/ng/directive/input).
 *
 * The `md-input` and `md-input-container` directives use very specific positioning to achieve the
 * error animation effects. Therefore, it is *not* advised to use the Layout system inside of the
 * `<md-input-container>` tags. Instead, use relative or absolute positioning.
 *
 *
 * <h3>Textarea directive</h3>
 * The `textarea` element within a `md-input-container` has the following specific behavior:
 * - By default the `textarea` grows as the user types. This can be disabled via the `md-no-autogrow`
 * attribute.
 * - If a `textarea` has the `rows` attribute, it will treat the `rows` as the minimum height and will
 * continue growing as the user types. For example a textarea with `rows="3"` will be 3 lines of text
 * high initially. If no rows are specified, the directive defaults to 1.
 * - The textarea's height gets set on initialization, as well as while the user is typing. In certain situations
 * (e.g. while animating) the directive might have been initialized, before the element got it's final height. In
 * those cases, you can trigger a resize manually by broadcasting a `md-resize-textarea` event on the scope.
 * - If you want a `textarea` to stop growing at a certain point, you can specify the `max-rows` attribute.
 * - The textarea's bottom border acts as a handle which users can drag, in order to resize the element vertically.
 * Once the user has resized a `textarea`, the autogrowing functionality becomes disabled. If you don't want a
 * `textarea` to be resizeable by the user, you can add the `md-no-resize` attribute.
 */

function inputTextareaDirective($mdUtil, $window, $mdAria, $timeout, $mdGesture) {
  return {
    restrict: 'E',
    require: ['^?mdInputContainer', '?ngModel', '?^form'],
    link: postLink
  };

  function postLink(scope, element, attr, ctrls) {

    var containerCtrl = ctrls[0];
    var hasNgModel = !!ctrls[1];
    var ngModelCtrl = ctrls[1] || $mdUtil.fakeNgModel();
    var parentForm = ctrls[2];
    var isReadonly = angular.isDefined(attr.readonly);
    var mdNoAsterisk = $mdUtil.parseAttributeBoolean(attr.mdNoAsterisk);
    var tagName = element[0].tagName.toLowerCase();


    if (!containerCtrl) return;
    if (attr.type === 'hidden') {
      element.attr('aria-hidden', 'true');
      return;
    } else if (containerCtrl.input) {
      if (containerCtrl.input[0].contains(element[0])) {
        return;
      } else {
        throw new Error("<md-input-container> can only have *one* <input>, <textarea> or <md-select> child element!");
      }
    }
    containerCtrl.input = element;

    setupAttributeWatchers();

    // Add an error spacer div after our input to provide space for the char counter and any ng-messages
    var errorsSpacer = angular.element('<div class="md-errors-spacer">');
    element.after(errorsSpacer);

    var placeholderText = angular.isString(attr.placeholder) ? attr.placeholder.trim() : '';
    if (!containerCtrl.label && !placeholderText.length) {
      $mdAria.expect(element, 'aria-label');
    }

    element.addClass('md-input');
    if (!element.attr('id')) {
      element.attr('id', 'input_' + $mdUtil.nextUid());
    }

    // This works around a Webkit issue where number inputs, placed in a flexbox, that have
    // a `min` and `max` will collapse to about 1/3 of their proper width. Please check #7349
    // for more info. Also note that we don't override the `step` if the user has specified it,
    // in order to prevent some unexpected behaviour.
    if (tagName === 'input' && attr.type === 'number' && attr.min && attr.max && !attr.step) {
      element.attr('step', 'any');
    } else if (tagName === 'textarea') {
      setupTextarea();
    }

    // If the input doesn't have an ngModel, it may have a static value. For that case,
    // we have to do one initial check to determine if the container should be in the
    // "has a value" state.
    if (!hasNgModel) {
      inputCheckValue();
    }

    var isErrorGetter = containerCtrl.isErrorGetter || function() {
      return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (parentForm && parentForm.$submitted));
    };

    scope.$watch(isErrorGetter, containerCtrl.setInvalid);

    // When the developer uses the ngValue directive for the input, we have to observe the attribute, because
    // AngularJS's ngValue directive is just setting the `value` attribute.
    if (attr.ngValue) {
      attr.$observe('value', inputCheckValue);
    }

    ngModelCtrl.$parsers.push(ngModelPipelineCheckValue);
    ngModelCtrl.$formatters.push(ngModelPipelineCheckValue);

    element.on('input', inputCheckValue);

    if (!isReadonly) {
      element
        .on('focus', function(ev) {
          $mdUtil.nextTick(function() {
            containerCtrl.setFocused(true);
          });
        })
        .on('blur', function(ev) {
          $mdUtil.nextTick(function() {
            containerCtrl.setFocused(false);
            inputCheckValue();
          });
        });
    }

    scope.$on('$destroy', function() {
      containerCtrl.setFocused(false);
      containerCtrl.setHasValue(false);
      containerCtrl.input = null;
    });

    /** Gets run through ngModel's pipeline and set the `has-value` class on the container. */
    function ngModelPipelineCheckValue(arg) {
      containerCtrl.setHasValue(!ngModelCtrl.$isEmpty(arg));
      return arg;
    }

    function setupAttributeWatchers() {
      if (containerCtrl.label) {
        attr.$observe('required', function (value) {
          // We don't need to parse the required value, it's always a boolean because of AngularJS'
          // required directive.
          if (containerCtrl.label) {
            containerCtrl.label.toggleClass('md-required', value && !mdNoAsterisk);
          }
        });
      }
    }

    function inputCheckValue() {
      // An input's value counts if its length > 0,
      // or if the input's validity state says it has bad input (eg string in a number input)
      containerCtrl.setHasValue(element.val().length > 0 || (element[0].validity || {}).badInput);
    }

    function setupTextarea() {
      var isAutogrowing = !attr.hasOwnProperty('mdNoAutogrow');

      attachResizeHandle();

      if (!isAutogrowing) return;

      // Can't check if height was or not explicity set,
      // so rows attribute will take precedence if present
      var minRows = attr.hasOwnProperty('rows') ? parseInt(attr.rows) : NaN;
      var maxRows = attr.hasOwnProperty('maxRows') ? parseInt(attr.maxRows) : NaN;
      var scopeResizeListener = scope.$on('md-resize-textarea', growTextarea);
      var lineHeight = null;
      var node = element[0];

      // This timeout is necessary, because the browser needs a little bit
      // of time to calculate the `clientHeight` and `scrollHeight`.
      $timeout(function() {
        $mdUtil.nextTick(growTextarea);
      }, 10, false);

      // We could leverage ngModel's $parsers here, however it
      // isn't reliable, because AngularJS trims the input by default,
      // which means that growTextarea won't fire when newlines and
      // spaces are added.
      element.on('input', growTextarea);

      // We should still use the $formatters, because they fire when
      // the value was changed from outside the textarea.
      if (hasNgModel) {
        ngModelCtrl.$formatters.push(formattersListener);
      }

      if (!minRows) {
        element.attr('rows', 1);
      }

      angular.element($window).on('resize', growTextarea);
      scope.$on('$destroy', disableAutogrow);

      function growTextarea() {
        // temporarily disables element's flex so its height 'runs free'
        element
          .attr('rows', 1)
          .css('height', 'auto')
          .addClass('md-no-flex');

        var height = getHeight();

        if (!lineHeight) {
          // offsetHeight includes padding which can throw off our value
          var originalPadding = element[0].style.padding || '';
          lineHeight = element.css('padding', 0).prop('offsetHeight');
          element[0].style.padding = originalPadding;
        }

        if (minRows && lineHeight) {
          height = Math.max(height, lineHeight * minRows);
        }

        if (maxRows && lineHeight) {
          var maxHeight = lineHeight * maxRows;

          if (maxHeight < height) {
            element.attr('md-no-autogrow', '');
            height = maxHeight;
          } else {
            element.removeAttr('md-no-autogrow');
          }
        }

        if (lineHeight) {
          element.attr('rows', Math.round(height / lineHeight));
        }

        element
          .css('height', height + 'px')
          .removeClass('md-no-flex');
      }

      function getHeight() {
        var offsetHeight = node.offsetHeight;
        var line = node.scrollHeight - offsetHeight;
        return offsetHeight + Math.max(line, 0);
      }

      function formattersListener(value) {
        $mdUtil.nextTick(growTextarea);
        return value;
      }

      function disableAutogrow() {
        if (!isAutogrowing) return;

        isAutogrowing = false;
        angular.element($window).off('resize', growTextarea);
        scopeResizeListener && scopeResizeListener();
        element
          .attr('md-no-autogrow', '')
          .off('input', growTextarea);

        if (hasNgModel) {
          var listenerIndex = ngModelCtrl.$formatters.indexOf(formattersListener);

          if (listenerIndex > -1) {
            ngModelCtrl.$formatters.splice(listenerIndex, 1);
          }
        }
      }

      function attachResizeHandle() {
        if (attr.hasOwnProperty('mdNoResize')) return;

        var handle = angular.element('<div class="md-resize-handle"></div>');
        var isDragging = false;
        var dragStart = null;
        var startHeight = 0;
        var container = containerCtrl.element;
        var dragGestureHandler = $mdGesture.register(handle, 'drag', { horizontal: false });


        element.wrap('<div class="md-resize-wrapper">').after(handle);
        handle.on('mousedown', onMouseDown);

        container
          .on('$md.dragstart', onDragStart)
          .on('$md.drag', onDrag)
          .on('$md.dragend', onDragEnd);

        scope.$on('$destroy', function() {
          handle
            .off('mousedown', onMouseDown)
            .remove();

          container
            .off('$md.dragstart', onDragStart)
            .off('$md.drag', onDrag)
            .off('$md.dragend', onDragEnd);

          dragGestureHandler();
          handle = null;
          container = null;
          dragGestureHandler = null;
        });

        function onMouseDown(ev) {
          ev.preventDefault();
          isDragging = true;
          dragStart = ev.clientY;
          startHeight = parseFloat(element.css('height')) || element.prop('offsetHeight');
        }

        function onDragStart(ev) {
          if (!isDragging) return;
          ev.preventDefault();
          disableAutogrow();
          container.addClass('md-input-resized');
        }

        function onDrag(ev) {
          if (!isDragging) return;

          element.css('height', (startHeight + ev.pointer.distanceY) + 'px');
        }

        function onDragEnd(ev) {
          if (!isDragging) return;
          isDragging = false;
          container.removeClass('md-input-resized');
        }
      }

      // Attach a watcher to detect when the textarea gets shown.
      if (attr.hasOwnProperty('mdDetectHidden')) {

        var handleHiddenChange = function() {
          var wasHidden = false;

          return function() {
            var isHidden = node.offsetHeight === 0;

            if (isHidden === false && wasHidden === true) {
              growTextarea();
            }

            wasHidden = isHidden;
          };
        }();

        // Check every digest cycle whether the visibility of the textarea has changed.
        // Queue up to run after the digest cycle is complete.
        scope.$watch(function() {
          $mdUtil.nextTick(handleHiddenChange, false);
          return true;
        });
      }
    }
  }
}

function mdMaxlengthDirective($animate, $mdUtil) {
  return {
    restrict: 'A',
    require: ['ngModel', '^mdInputContainer'],
    link: postLink
  };

  function postLink(scope, element, attr, ctrls) {
    var maxlength = parseInt(attr.mdMaxlength);
    if (isNaN(maxlength)) maxlength = -1;
    var ngModelCtrl = ctrls[0];
    var containerCtrl = ctrls[1];
    var charCountEl, errorsSpacer;
    var ngTrim = angular.isDefined(attr.ngTrim) ? $mdUtil.parseAttributeBoolean(attr.ngTrim) : true;
    var isPasswordInput = attr.type === 'password';

    scope.$watch(attr.mdMaxlength, function(value) {
      maxlength = value;
    });

    ngModelCtrl.$validators['md-maxlength'] = function(modelValue, viewValue) {
      if (!angular.isNumber(maxlength) || maxlength < 0) {
        return true;
      }

      // We always update the char count, when the modelValue has changed.
      // Using the $validators for triggering the update works very well.
      renderCharCount();

      var elementVal = element.val() || viewValue;
      if (elementVal === undefined || elementVal === null) {
        elementVal = '';
      }
      elementVal = ngTrim && !isPasswordInput && angular.isString(elementVal) ? elementVal.trim() : elementVal;
      // Force the value into a string since it may be a number,
      // which does not have a length property.
      return String(elementVal).length <= maxlength;
    };

    /**
     * Override the default NgModelController $isEmpty check to take ng-trim, password inputs,
     * etc. into account.
     * @param value {*} the input's value
     * @returns {boolean} true if the input's value should be considered empty, false otherwise
     */
    ngModelCtrl.$isEmpty = function(value) {
      return calculateInputValueLength(value) === 0;
    };

    // Wait until the next tick to ensure that the input has setup the errors spacer where we will
    // append our counter
    $mdUtil.nextTick(function() {
      errorsSpacer = angular.element(containerCtrl.element[0].querySelector('.md-errors-spacer'));
      charCountEl = angular.element('<div class="md-char-counter">');

      // Append our character counter inside the errors spacer
      errorsSpacer.append(charCountEl);

      attr.$observe('ngTrim', function (value) {
        ngTrim = angular.isDefined(value) ? $mdUtil.parseAttributeBoolean(value) : true;
      });

      scope.$watch(attr.mdMaxlength, function(value) {
        if (angular.isNumber(value) && value > 0) {
          if (!charCountEl.parent().length) {
            $animate.enter(charCountEl, errorsSpacer);
          }
          renderCharCount();
        } else {
          $animate.leave(charCountEl);
        }
      });
    });

    /**
     * Calculate the input value's length after coercing it to a string
     * and trimming it if appropriate.
     * @param value {*} the input's value
     * @returns {number} calculated length of the input's value
     */
    function calculateInputValueLength(value) {
      value = ngTrim && !isPasswordInput && angular.isString(value) ? value.trim() : value;
      if (value === undefined || value === null) {
        value = '';
      }
      return String(value).length;
    }

    function renderCharCount() {
      // If we have not been initialized or appended to the body yet; do not render.
      if (!charCountEl || !charCountEl.parent()) {
        return;
      }
      // Force the value into a string since it may be a number,
      // which does not have a length property.
      charCountEl.text(calculateInputValueLength(element.val()) + ' / ' + maxlength);
    }
  }
}

function placeholderDirective($compile) {
  return {
    restrict: 'A',
    require: '^^?mdInputContainer',
    priority: 200,
    link: {
      // Note that we need to do this in the pre-link, as opposed to the post link, if we want to
      // support data bindings in the placeholder. This is necessary, because we have a case where
      // we transfer the placeholder value to the `<label>` and we remove it from the original `<input>`.
      // If we did this in the post-link, AngularJS would have set up the observers already and would be
      // re-adding the attribute, even though we removed it from the element.
      pre: preLink
    }
  };

  function preLink(scope, element, attr, inputContainer) {
    // If there is no input container, just return
    if (!inputContainer) return;

    var label = inputContainer.element.find('label');
    var noFloat = inputContainer.element.attr('md-no-float');

    // If we have a label, or they specify the md-no-float attribute, just return
    if ((label && label.length) || noFloat === '' || scope.$eval(noFloat)) {
      // Add a placeholder class so we can target it in the CSS
      inputContainer.setHasPlaceholder(true);
      return;
    }

    // md-select handles placeholders on it's own
    if (element[0].nodeName !== 'MD-SELECT') {
      // Move the placeholder expression to the label
      var newLabel = angular.element(
        '<label ng-click="delegateClick()" tabindex="-1" aria-hidden="true">' + attr.placeholder +
        '</label>');

      // Note that we unset it via `attr`, in order to get AngularJS
      // to remove any observers that it might have set up. Otherwise
      // the attribute will be added on the next digest.
      attr.$set('placeholder', null);

      // We need to compile the label manually in case it has any bindings.
      // A gotcha here is that we first add the element to the DOM and we compile
      // it later. This is necessary, because if we compile the element beforehand,
      // it won't be able to find the `mdInputContainer` controller.
      inputContainer.element
        .addClass('md-icon-float')
        .prepend(newLabel);

      $compile(newLabel)(scope);
    }
  }
}

/**
 * @ngdoc directive
 * @name mdSelectOnFocus
 * @module material.components.input
 *
 * @restrict A
 *
 * @description
 * The `md-select-on-focus` directive allows you to automatically select the element's input text on focus.
 *
 * <h3>Notes</h3>
 * - The use of `md-select-on-focus` is restricted to `<input>` and `<textarea>` elements.
 *
 * @usage
 * <h3>Using with an Input</h3>
 * <hljs lang="html">
 *
 * <md-input-container>
 *   <label>Auto Select</label>
 *   <input type="text" md-select-on-focus>
 * </md-input-container>
 * </hljs>
 *
 * <h3>Using with a Textarea</h3>
 * <hljs lang="html">
 *
 * <md-input-container>
 *   <label>Auto Select</label>
 *   <textarea md-select-on-focus>This text will be selected on focus.</textarea>
 * </md-input-container>
 *
 * </hljs>
 */
function mdSelectOnFocusDirective($document, $timeout) {

  return {
    restrict: 'A',
    link: postLink
  };

  function postLink(scope, element, attr) {
    if (element[0].nodeName !== 'INPUT' && element[0].nodeName !== "TEXTAREA") return;

    var preventMouseUp = false;

    element
      .on('focus', onFocus)
      .on('mouseup', onMouseUp);

    scope.$on('$destroy', function() {
      element
        .off('focus', onFocus)
        .off('mouseup', onMouseUp);
    });

    function onFocus() {
      preventMouseUp = true;

      $timeout(function() {

        // Use HTMLInputElement#select to fix firefox select issues.
        // The debounce is here for Edge's sake, otherwise the selection doesn't work.
        // Since focus may already have been lost on the input (and because `select()`
        // will re-focus), make sure the element is still active before applying.
        if ($document[0].activeElement === element[0]) {
          element[0].select();
        }

        // This should be reset from inside the `focus`, because the event might
        // have originated from something different than a click, e.g. a keyboard event.
        preventMouseUp = false;
      }, 1, false);
    }

    // Prevents the default action of the first `mouseup` after a focus.
    // This is necessary, because browsers fire a `mouseup` right after the element
    // has been focused. In some browsers (Firefox in particular) this can clear the
    // selection. There are examples of the problem in issue #7487.
    function onMouseUp(event) {
      if (preventMouseUp) {
        event.preventDefault();
      }
    }
  }
}

var visibilityDirectives = ['ngIf', 'ngShow', 'ngHide', 'ngSwitchWhen', 'ngSwitchDefault'];
function ngMessagesDirective() {
  return {
    restrict: 'EA',
    link: postLink,

    // This is optional because we don't want target *all* ngMessage instances, just those inside of
    // mdInputContainer.
    require: '^^?mdInputContainer'
  };

  function postLink(scope, element, attrs, inputContainer) {
    // If we are not a child of an input container, don't do anything
    if (!inputContainer) return;

    // Add our animation class
    element.toggleClass('md-input-messages-animation', true);

    // Add our md-auto-hide class to automatically hide/show messages when container is invalid
    element.toggleClass('md-auto-hide', true);

    // If we see some known visibility directives, remove the md-auto-hide class
    if (attrs.mdAutoHide == 'false' || hasVisibiltyDirective(attrs)) {
      element.toggleClass('md-auto-hide', false);
    }
  }

  function hasVisibiltyDirective(attrs) {
    return visibilityDirectives.some(function(attr) {
      return attrs[attr];
    });
  }
}

function ngMessageDirective($mdUtil) {
  return {
    restrict: 'EA',
    compile: compile,
    priority: 100
  };

  function compile(tElement) {
    if (!isInsideInputContainer(tElement)) {

      // When the current element is inside of a document fragment, then we need to check for an input-container
      // in the postLink, because the element will be later added to the DOM and is currently just in a temporary
      // fragment, which causes the input-container check to fail.
      if (isInsideFragment()) {
        return function (scope, element) {
          if (isInsideInputContainer(element)) {
            // Inside of the postLink function, a ngMessage directive will be a comment element, because it's
            // currently hidden. To access the shown element, we need to use the element from the compile function.
            initMessageElement(tElement);
          }
        };
      }
    } else {
      initMessageElement(tElement);
    }

    function isInsideFragment() {
      var nextNode = tElement[0];
      while (nextNode = nextNode.parentNode) {
        if (nextNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
          return true;
        }
      }
      return false;
    }

    function isInsideInputContainer(element) {
      return !!$mdUtil.getClosest(element, "md-input-container");
    }

    function initMessageElement(element) {
      // Add our animation class
      element.toggleClass('md-input-message-animation', true);
    }
  }
}

var $$AnimateRunner, $animateCss, $mdUtil;

function mdInputInvalidMessagesAnimation($$AnimateRunner, $animateCss, $mdUtil) {
  saveSharedServices($$AnimateRunner, $animateCss, $mdUtil);

  return {
    addClass: function(element, className, done) {
      showInputMessages(element, done);
    }

    // NOTE: We do not need the removeClass method, because the message ng-leave animation will fire
  };
}

function ngMessagesAnimation($$AnimateRunner, $animateCss, $mdUtil) {
  saveSharedServices($$AnimateRunner, $animateCss, $mdUtil);

  return {
    enter: function(element, done) {
      showInputMessages(element, done);
    },

    leave: function(element, done) {
      hideInputMessages(element, done);
    },

    addClass: function(element, className, done) {
      if (className == "ng-hide") {
        hideInputMessages(element, done);
      } else {
        done();
      }
    },

    removeClass: function(element, className, done) {
      if (className == "ng-hide") {
        showInputMessages(element, done);
      } else {
        done();
      }
    }
  };
}

function ngMessageAnimation($$AnimateRunner, $animateCss, $mdUtil, $log) {
  saveSharedServices($$AnimateRunner, $animateCss, $mdUtil, $log);

  return {
    enter: function(element, done) {
      var animator = showMessage(element);

      animator.start().done(done);
    },

    leave: function(element, done) {
      var animator = hideMessage(element);

      animator.start().done(done);
    }
  };
}

function showInputMessages(element, done) {
  var animators = [], animator;
  var messages = getMessagesElement(element);
  var children = messages.children();

  if (messages.length == 0 || children.length == 0) {
    done();
    return;
  }

  angular.forEach(children, function(child) {
    animator = showMessage(angular.element(child));

    animators.push(animator.start());
  });

  $$AnimateRunner.all(animators, done);
}

function hideInputMessages(element, done) {
  var animators = [], animator;
  var messages = getMessagesElement(element);
  var children = messages.children();

  if (messages.length == 0 || children.length == 0) {
    done();
    return;
  }

  angular.forEach(children, function(child) {
    animator = hideMessage(angular.element(child));

    animators.push(animator.start());
  });

  $$AnimateRunner.all(animators, done);
}

function showMessage(element) {
  var height = parseInt(window.getComputedStyle(element[0]).height);
  var topMargin = parseInt(window.getComputedStyle(element[0]).marginTop);

  var messages = getMessagesElement(element);
  var container = getInputElement(element);

  // Check to see if the message is already visible so we can skip
  var alreadyVisible = (topMargin > -height);

  // If we have the md-auto-hide class, the md-input-invalid animation will fire, so we can skip
  if (alreadyVisible || (messages.hasClass('md-auto-hide') && !container.hasClass('md-input-invalid'))) {
    return $animateCss(element, {});
  }

  return $animateCss(element, {
    event: 'enter',
    structural: true,
    from: {"opacity": 0, "margin-top": -height + "px"},
    to: {"opacity": 1, "margin-top": "0"},
    duration: 0.3
  });
}

function hideMessage(element) {
  var height = element[0].offsetHeight;
  var styles = window.getComputedStyle(element[0]);

  // If we are already hidden, just return an empty animation
  if (parseInt(styles.opacity) === 0) {
    return $animateCss(element, {});
  }

  // Otherwise, animate
  return $animateCss(element, {
    event: 'leave',
    structural: true,
    from: {"opacity": 1, "margin-top": 0},
    to: {"opacity": 0, "margin-top": -height + "px"},
    duration: 0.3
  });
}

function getInputElement(element) {
  var inputContainer = element.controller('mdInputContainer');

  return inputContainer.element;
}

function getMessagesElement(element) {
  // If we ARE the messages element, just return ourself
  if (element.hasClass('md-input-messages-animation')) {
    return element;
  }

  // If we are a ng-message element, we need to traverse up the DOM tree
  if (element.hasClass('md-input-message-animation')) {
    return angular.element($mdUtil.getClosest(element, function(node) {
      return node.classList.contains('md-input-messages-animation');
    }));
  }

  // Otherwise, we can traverse down
  return angular.element(element[0].querySelector('.md-input-messages-animation'));
}

function saveSharedServices(_$$AnimateRunner_, _$animateCss_, _$mdUtil_) {
  $$AnimateRunner = _$$AnimateRunner_;
  $animateCss = _$animateCss_;
  $mdUtil = _$mdUtil_;
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.list
 * @description
 * List module
 */
MdListController.$inject = ["$scope", "$element", "$mdListInkRipple"];
mdListDirective.$inject = ["$mdTheming"];
mdListItemDirective.$inject = ["$mdAria", "$mdConstant", "$mdUtil", "$timeout"];
angular.module('material.components.list', [
  'material.core'
])
  .controller('MdListController', MdListController)
  .directive('mdList', mdListDirective)
  .directive('mdListItem', mdListItemDirective);

/**
 * @ngdoc directive
 * @name mdList
 * @module material.components.list
 *
 * @restrict E
 *
 * @description
 * The `<md-list>` directive is a list container for 1..n `<md-list-item>` tags.
 *
 * @usage
 * <hljs lang="html">
 * <md-list>
 *   <md-list-item class="md-2-line" ng-repeat="item in todos">
 *     <md-checkbox ng-model="item.done"></md-checkbox>
 *     <div class="md-list-item-text">
 *       <h3>{{item.title}}</h3>
 *       <p>{{item.description}}</p>
 *     </div>
 *   </md-list-item>
 * </md-list>
 * </hljs>
 */

function mdListDirective($mdTheming) {
  return {
    restrict: 'E',
    compile: function(tEl) {
      tEl[0].setAttribute('role', 'list');
      return $mdTheming;
    }
  };
}
/**
 * @ngdoc directive
 * @name mdListItem
 * @module material.components.list
 *
 * @restrict E
 *
 * @description
 * A `md-list-item` element can be used to represent some information in a row.<br/>
 *
 * @usage
 * ### Single Row Item
 * <hljs lang="html">
 *   <md-list-item>
 *     <span>Single Row Item</span>
 *   </md-list-item>
 * </hljs>
 *
 * ### Multiple Lines
 * By using the following markup, you will be able to have two lines inside of one `md-list-item`.
 *
 * <hljs lang="html">
 *   <md-list-item class="md-2-line">
 *     <div class="md-list-item-text" layout="column">
 *       <p>First Line</p>
 *       <p>Second Line</p>
 *     </div>
 *   </md-list-item>
 * </hljs>
 *
 * It is also possible to have three lines inside of one list item.
 *
 * <hljs lang="html">
 *   <md-list-item class="md-3-line">
 *     <div class="md-list-item-text" layout="column">
 *       <p>First Line</p>
 *       <p>Second Line</p>
 *       <p>Third Line</p>
 *     </div>
 *   </md-list-item>
 * </hljs>
 *
 * ### Secondary Items
 * Secondary items are elements which will be aligned at the end of the `md-list-item`.
 *
 * <hljs lang="html">
 *   <md-list-item>
 *     <span>Single Row Item</span>
 *     <md-button class="md-secondary">
 *       Secondary Button
 *     </md-button>
 *   </md-list-item>
 * </hljs>
 *
 * It also possible to have multiple secondary items inside of one `md-list-item`.
 *
 * <hljs lang="html">
 *   <md-list-item>
 *     <span>Single Row Item</span>
 *     <md-button class="md-secondary">First Button</md-button>
 *     <md-button class="md-secondary">Second Button</md-button>
 *   </md-list-item>
 * </hljs>
 *
 * ### Proxy Item
 * Proxies are elements, which will execute their specific action on click<br/>
 * Currently supported proxy items are
 * - `md-checkbox` (Toggle)
 * - `md-switch` (Toggle)
 * - `md-menu` (Open)
 *
 * This means, when using a supported proxy item inside of `md-list-item`, the list item will
 * automatically become clickable and executes the associated action of the proxy element on click.
 *
 * It is possible to disable this behavior by applying the `md-no-proxy` class to the list item.
 *
 * <hljs lang="html">
 *   <md-list-item class="md-no-proxy">
 *     <span>No Proxy List</span>
 *     <md-checkbox class="md-secondary"></md-checkbox>
 *   </md-list-item>
 * </hljs>
 *
 * Here are a few examples of proxy elements inside of a list item.
 *
 * <hljs lang="html">
 *   <md-list-item>
 *     <span>First Line</span>
 *     <md-checkbox class="md-secondary"></md-checkbox>
 *   </md-list-item>
 * </hljs>
 *
 * The `md-checkbox` element will be automatically detected as a proxy element and will toggle on
 * click.
 *
 * If not provided, an `aria-label` will be applied using the text of the list item.
 * In this case, the following will be applied to the `md-checkbox`:
 * `aria-label="Toggle First Line"`.
 * When localizing your application, you should supply a localized `aria-label`.
 *
 * <hljs lang="html">
 *   <md-list-item>
 *     <span>First Line</span>
 *     <md-switch class="md-secondary"></md-switch>
 *   </md-list-item>
 * </hljs>
 *
 * The recognized `md-switch` will toggle its state, when the user clicks on the `md-list-item`.
 *
 * It is also possible to have a `md-menu` inside of a `md-list-item`.
 *
 * <hljs lang="html">
 *   <md-list-item>
 *     <p>Click anywhere to fire the secondary action</p>
 *     <md-menu class="md-secondary">
 *       <md-button class="md-icon-button">
 *         <md-icon md-svg-icon="communication:message"></md-icon>
 *       </md-button>
 *       <md-menu-content width="4">
 *         <md-menu-item>
 *           <md-button>
 *             Redial
 *           </md-button>
 *         </md-menu-item>
 *         <md-menu-item>
 *           <md-button>
 *             Check voicemail
 *           </md-button>
 *         </md-menu-item>
 *         <md-menu-divider></md-menu-divider>
 *         <md-menu-item>
 *           <md-button>
 *             Notifications
 *           </md-button>
 *         </md-menu-item>
 *       </md-menu-content>
 *     </md-menu>
 *   </md-list-item>
 * </hljs>
 *
 * The menu will automatically open, when the users clicks on the `md-list-item`.<br/>
 *
 * If the developer didn't specify any position mode on the menu, the `md-list-item` will
 * automatically detect the position mode and apply it to the `md-menu`.
 *
 * ### Avatars
 * Sometimes you may want to have avatars inside of the `md-list-item `.<br/>
 * You are able to create an optimized icon for the list item, by applying the `.md-avatar` class on
 * the `<img>` element.
 *
 * <hljs lang="html">
 *   <md-list-item>
 *     <img src="my-avatar.png" class="md-avatar">
 *     <span>Alan Turing</span>
 * </hljs>
 *
 * When using `<md-icon>` for an avatar, you have to use the `.md-avatar-icon` class.
 *
 * <hljs lang="html">
 *   <md-list-item>
 *     <md-icon class="md-avatar-icon" md-svg-icon="social:person"></md-icon>
 *     <span>Timothy Kopra</span>
 *   </md-list-item>
 * </hljs>
 *
 * In cases where you have a `md-list-item`, which doesn't have an avatar,
 * but you want to align it with the other avatar items, you need to use the `.md-offset` class.
 *
 * <hljs lang="html">
 *   <md-list-item class="md-offset">
 *     <span>Jon Doe</span>
 *   </md-list-item>
 * </hljs>
 *
 * ### DOM modification
 * The `md-list-item` component automatically detects if the list item should be clickable.
 *
 * ---
 * If the `md-list-item` is clickable, we wrap all content inside of a `<div>` and create
 * an overlaying button, which will will execute the given actions (like `ng-href`, `ng-click`).
 *
 * We create an overlaying button, instead of wrapping all content inside of the button,
 * because otherwise some elements may not be clickable inside of the button.
 *
 * ---
 * When using a secondary item inside of your list item, the `md-list-item` component will
 * automatically create a secondary container at the end of the `md-list-item`, which contains all
 * secondary items.
 *
 * The secondary item container is not static, because that would cause issues with the overflow
 * of the list item.
 */
function mdListItemDirective($mdAria, $mdConstant, $mdUtil, $timeout) {
  var proxiedTypes = ['md-checkbox', 'md-switch', 'md-menu'];
  return {
    restrict: 'E',
    controller: 'MdListController',

    compile: function(tElement, tAttrs) {

      // Check for proxy controls (no ng-click on parent, and a control inside)
      var secondaryItems = tElement[0].querySelectorAll('.md-secondary');
      var hasProxiedElement;
      var proxyElement;
      var itemContainer = tElement;

      tElement[0].setAttribute('role', 'listitem');

      if (tAttrs.ngClick || tAttrs.ngDblclick ||  tAttrs.ngHref || tAttrs.href || tAttrs.uiSref || tAttrs.ngAttrUiSref) {
        wrapIn('button');
      } else if (!tElement.hasClass('md-no-proxy')) {

        for (var i = 0, type; i < proxiedTypes.length; ++i) {
          proxyElement = tElement[0].querySelector(proxiedTypes[i]);
          if (proxyElement !== null) {
            hasProxiedElement = true;
            break;
          }
        }

        if (hasProxiedElement) {
          wrapIn('div');
        } else {
          tElement.addClass('md-no-proxy');
        }
      }

      wrapSecondaryItems();
      setupToggleAria();

      if (hasProxiedElement && proxyElement.nodeName === "MD-MENU") {
        setupProxiedMenu();
      }

      function setupToggleAria() {
        var toggleTypes = ['md-switch', 'md-checkbox'];
        var toggle;

        for (var i = 0, toggleType; i < toggleTypes.length; ++i) {
          toggle = tElement.find(toggleTypes[i])[0];
          if (toggle) {
            if (!toggle.hasAttribute('aria-label')) {
              var labelElement = tElement.find('p')[0];
              if (!labelElement) {
                labelElement = tElement.find('span')[0];
              }
              if (!labelElement) return;
              toggle.setAttribute('aria-label', 'Toggle ' + labelElement.textContent);
            }
          }
        }
      }

      function setupProxiedMenu() {
        var menuEl = angular.element(proxyElement);

        var isEndAligned = menuEl.parent().hasClass('md-secondary-container') ||
                           proxyElement.parentNode.firstElementChild !== proxyElement;

        var xAxisPosition = 'left';

        if (isEndAligned) {
          // When the proxy item is aligned at the end of the list, we have to set the origin to the end.
          xAxisPosition = 'right';
        }

        // Set the position mode / origin of the proxied menu.
        if (!menuEl.attr('md-position-mode')) {
          menuEl.attr('md-position-mode', xAxisPosition + ' target');
        }

        // Apply menu open binding to menu button
        var menuOpenButton = menuEl.children().eq(0);
        if (!hasClickEvent(menuOpenButton[0])) {
          menuOpenButton.attr('ng-click', '$mdMenu.open($event)');
        }

        if (!menuOpenButton.attr('aria-label')) {
          menuOpenButton.attr('aria-label', 'Open List Menu');
        }
      }

      /**
       * @param {'div'|'button'} type
       */
      function wrapIn(type) {
        if (type === 'div') {
          itemContainer = angular.element('<div class="md-no-style md-list-item-inner">');
          itemContainer.append(tElement.contents());
          tElement.addClass('md-proxy-focus');
        } else {
          // Element which holds the default list-item content.
          itemContainer = angular.element(
            '<div class="md-button md-no-style">' +
            '   <div class="md-list-item-inner"></div>' +
            '</div>'
          );

          // Button which shows ripple and executes primary action.
          var buttonWrap = angular.element('<md-button class="md-no-style"></md-button>');

          moveAttributes(tElement[0], buttonWrap[0]);

          // If there is no aria-label set on the button (previously copied over if present)
          // we determine the label from the content and copy it to the button.
          if (!buttonWrap.attr('aria-label')) {
            buttonWrap.attr('aria-label', $mdAria.getText(tElement));

            // If we set the button's aria-label to the text content, then make the content hidden
            // from screen readers so that it isn't read/traversed twice.
            var listItemInner = itemContainer[0].querySelector('.md-list-item-inner');
            if (listItemInner) {
              listItemInner.setAttribute('aria-hidden', 'true');
            }
          }

          // We allow developers to specify the `md-no-focus` class, to disable the focus style
          // on the button executor. Once more classes should be forwarded, we should probably make
          // the class forward more generic.
          if (tElement.hasClass('md-no-focus')) {
            buttonWrap.addClass('md-no-focus');
          }

          // Append the button wrap before our list-item content, because it will overlay in
          // relative.
          itemContainer.prepend(buttonWrap);
          itemContainer.children().eq(1).append(tElement.contents());

          tElement.addClass('_md-button-wrap');
        }

        tElement[0].setAttribute('tabindex', '-1');
        tElement.append(itemContainer);
      }

      function wrapSecondaryItems() {
        var secondaryItemsWrapper = angular.element('<div class="md-secondary-container">');

        angular.forEach(secondaryItems, function(secondaryItem) {
          wrapSecondaryItem(secondaryItem, secondaryItemsWrapper);
        });

        itemContainer.append(secondaryItemsWrapper);
      }

      /**
       * @param {HTMLElement} secondaryItem
       * @param {HTMLDivElement} container
       */
      function wrapSecondaryItem(secondaryItem, container) {
        // If the current secondary item is not a button, but contains a ng-click attribute,
        // the secondary item will be automatically wrapped inside of a button.
        if (secondaryItem && !isButton(secondaryItem) && secondaryItem.hasAttribute('ng-click')) {

          $mdAria.expect(secondaryItem, 'aria-label');
          var buttonWrapper = angular.element('<md-button class="md-secondary md-icon-button">');

          // Move the attributes from the secondary item to the generated button.
          // We also support some additional attributes from the secondary item,
          // because some developers may use a ngIf, ngHide, ngShow on their item.
          moveAttributes(secondaryItem, buttonWrapper[0], ['ng-if', 'ng-hide', 'ng-show']);

          secondaryItem.setAttribute('tabindex', '-1');
          buttonWrapper.append(secondaryItem);

          secondaryItem = buttonWrapper[0];
        }

        if (secondaryItem &&
            (!hasClickEvent(secondaryItem) ||
              (!tAttrs.ngClick && isProxiedElement(secondaryItem)))) {
          // In this case we remove the secondary class, so we can identify it later, when searching
          // for the proxy items.
          angular.element(secondaryItem).removeClass('md-secondary');
        }

        tElement.addClass('md-with-secondary');
        container.append(secondaryItem);
      }

      /**
       * Moves attributes from a source element to the destination element.
       * By default, the function will copy the most necessary attributes, supported
       * by the button executor for clickable list items.
       * @param {Element} source Element with the specified attributes
       * @param {Element} destination Element which will receive the attributes
       * @param {string|string[]} extraAttrs Additional attributes, which will be moved over
       */
      function moveAttributes(source, destination, extraAttrs) {
        var copiedAttrs = $mdUtil.prefixer([
          'ng-if', 'ng-click', 'ng-dblclick', 'aria-label', 'ng-disabled', 'ui-sref',
          'href', 'ng-href', 'rel', 'target', 'ng-attr-ui-sref', 'ui-sref-opts', 'download'
        ]);

        if (extraAttrs) {
          copiedAttrs = copiedAttrs.concat($mdUtil.prefixer(extraAttrs));
        }

        angular.forEach(copiedAttrs, function(attr) {
          if (source.hasAttribute(attr)) {
            destination.setAttribute(attr, source.getAttribute(attr));
            source.removeAttribute(attr);
          }
        });
      }

      /**
       * @param {HTMLElement} element
       * @return {boolean} true if the element has one of the proxied tags, false otherwise
       */
      function isProxiedElement(element) {
        return proxiedTypes.indexOf(element.nodeName.toLowerCase()) !== -1;
      }

      /**
       * @param {HTMLElement} element
       * @return {boolean} true if the element is a button or md-button, false otherwise
       */
      function isButton(element) {
        var nodeName = element.nodeName.toUpperCase();

        return nodeName === "MD-BUTTON" || nodeName === "BUTTON";
      }

      /**
       * @param {Element} element
       * @return {boolean} true if the element has an ng-click attribute, false otherwise
       */
      function hasClickEvent(element) {
        var attr = element.attributes;
        for (var i = 0; i < attr.length; i++) {
          if (tAttrs.$normalize(attr[i].name) === 'ngClick') {
            return true;
          }
        }
        return false;
      }

      return postLink;

      function postLink($scope, $element, $attr, ctrl) {
        $element.addClass('_md');     // private md component indicator for styling

        var proxies       = [],
            firstElement  = $element[0].firstElementChild,
            isButtonWrap  = $element.hasClass('_md-button-wrap'),
            clickChild    = isButtonWrap ? firstElement.firstElementChild : firstElement,
            hasClick      = clickChild && hasClickEvent(clickChild),
            noProxies     = $element.hasClass('md-no-proxy');

        computeProxies();
        computeClickable();

        if (proxies.length) {
          angular.forEach(proxies, function(proxy) {
            proxy = angular.element(proxy);

            $scope.mouseActive = false;
            proxy.on('mousedown', function() {
              $scope.mouseActive = true;
              $timeout(function() {
                $scope.mouseActive = false;
              }, 100);
            })
            .on('focus', function() {
              if ($scope.mouseActive === false) { $element.addClass('md-focused'); }
              proxy.on('blur', function proxyOnBlur() {
                $element.removeClass('md-focused');
                proxy.off('blur', proxyOnBlur);
              });
            });
          });
        }

        function computeProxies() {
          if (firstElement && firstElement.children && !hasClick && !noProxies) {

            angular.forEach(proxiedTypes, function(type) {
              // All elements which are not capable of being used as a proxy have the .md-secondary
              // class applied. These items were identified in the secondary wrap function.
              angular.forEach(firstElement.querySelectorAll(type + ':not(.md-secondary)'), function(child) {
                proxies.push(child);
              });
            });
          }
        }

        function computeClickable() {
          if (proxies.length === 1 || hasClick) {
            $element.addClass('md-clickable');

            if (!hasClick) {
              ctrl.attachRipple($scope, angular.element($element[0].querySelector('.md-no-style')));
            }
          }
        }

        /**
         * @param {MouseEvent} event
         * @return {boolean}
         */
        function isEventFromControl(event) {
          var forbiddenControls = ['md-slider'];
          var eventBubblePath = $mdUtil.getEventPath(event);

          // If there is no bubble path, then the event was not bubbled.
          if (!eventBubblePath || eventBubblePath.length === 0) {
            return forbiddenControls.indexOf(event.target.tagName.toLowerCase()) !== -1;
          }

          // We iterate the event bubble path up and check for a possible component.
          // Our maximum index to search, is the list item root.
          var maxPath = eventBubblePath.indexOf($element.children()[0]);

          for (var i = 0; i < maxPath; i++) {
            if (forbiddenControls.indexOf(eventBubblePath[i].tagName.toLowerCase()) !== -1) {
              return true;
            }
          }
          return false;
        }

        /**
         * @param {KeyboardEvent} keypressEvent
         */
        var clickChildKeypressListener = function(keypressEvent) {
          if (keypressEvent.target.nodeName !== 'INPUT' &&
              keypressEvent.target.nodeName !== 'TEXTAREA' &&
              !keypressEvent.target.isContentEditable) {
            var keyCode = keypressEvent.which || keypressEvent.keyCode;
            if (keyCode === $mdConstant.KEY_CODE.SPACE) {
              if (clickChild) {
                clickChild.click();
                keypressEvent.preventDefault();
                keypressEvent.stopPropagation();
              }
            }
          }
        };

        if (!hasClick && !proxies.length) {
          clickChild && clickChild.addEventListener('keypress', clickChildKeypressListener);
        }

        $element.off('click');
        $element.off('keypress');
        // Disable ng-aria's "helpful" keydown event that causes our ng-click handlers to be called
        // twice.
        $element.off('keydown');

        if (proxies.length === 1 && clickChild) {
          $element.children().eq(0).on('click', function(clickEvent) {
            // When the event is coming from a control and it should not trigger the proxied element
            // then we are skipping.
            if (isEventFromControl(clickEvent)) return;

            var parentButton = $mdUtil.getClosest(clickEvent.target, 'BUTTON');
            if (!parentButton && clickChild.contains(clickEvent.target)) {
              angular.forEach(proxies, function(proxy) {
                if (clickEvent.target !== proxy && !proxy.contains(clickEvent.target)) {
                  if (proxy.nodeName === 'MD-MENU') {
                    proxy = proxy.children[0];
                  }
                  angular.element(proxy).triggerHandler('click');
                }
              });
            }
          });
        }

        $scope.$on('$destroy', function () {
          clickChild && clickChild.removeEventListener('keypress', clickChildKeypressListener);
        });
      }
    }
  };
}

/*
 * @private
 * @ngdoc controller
 * @name MdListController
 * @module material.components.list
 */
function MdListController($scope, $element, $mdListInkRipple) {
  var ctrl = this;
  ctrl.attachRipple = attachRipple;

  function attachRipple (scope, element) {
    var options = {};
    $mdListInkRipple.attach(scope, element, options);
  }
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.menu
 */

angular.module('material.components.menu', [
  'material.core',
  'material.components.backdrop'
]);

})();
(function(){
"use strict";



MenuController.$inject = ["$mdMenu", "$attrs", "$element", "$scope", "$mdUtil", "$timeout", "$rootScope", "$q", "$log"];
angular
    .module('material.components.menu')
    .controller('mdMenuCtrl', MenuController);

/**
 * @ngInject
 */
function MenuController($mdMenu, $attrs, $element, $scope, $mdUtil, $timeout, $rootScope, $q, $log) {

  var prefixer = $mdUtil.prefixer();
  var menuContainer;
  var self = this;
  var triggerElement;

  this.nestLevel = parseInt($attrs.mdNestLevel, 10) || 0;

  /**
   * Called by our linking fn to provide access to the menu-content
   * element removed during link
   */
  this.init = function init(setMenuContainer, opts) {
    opts = opts || {};
    menuContainer = setMenuContainer;

    // Default element for ARIA attributes has the ngClick or ngMouseenter expression
    triggerElement = $element[0].querySelector(prefixer.buildSelector(['ng-click', 'ng-mouseenter']));
    triggerElement.setAttribute('aria-expanded', 'false');

    this.isInMenuBar = opts.isInMenuBar;
    this.mdMenuBarCtrl = opts.mdMenuBarCtrl;
    this.nestedMenus = $mdUtil.nodesToArray(menuContainer[0].querySelectorAll('.md-nested-menu'));

    menuContainer.on('$mdInterimElementRemove', function() {
      self.isOpen = false;
      $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});
    });
    $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});

    var menuContainerId = 'menu_container_' + $mdUtil.nextUid();
    menuContainer.attr('id', menuContainerId);
    angular.element(triggerElement).attr({
      'aria-owns': menuContainerId,
      'aria-haspopup': 'true'
    });

    $scope.$on('$destroy', angular.bind(this, function() {
      this.disableHoverListener();
      $mdMenu.destroy();
    }));

    menuContainer.on('$destroy', function() {
      $mdMenu.destroy();
    });
  };

  var openMenuTimeout, menuItems, deregisterScopeListeners = [];
  this.enableHoverListener = function() {
    deregisterScopeListeners.push($rootScope.$on('$mdMenuOpen', function(event, el) {
      if (menuContainer[0].contains(el[0])) {
        self.currentlyOpenMenu = el.controller('mdMenu');
        self.isAlreadyOpening = false;
        self.currentlyOpenMenu.registerContainerProxy(self.triggerContainerProxy.bind(self));
      }
    }));
    deregisterScopeListeners.push($rootScope.$on('$mdMenuClose', function(event, el) {
      if (menuContainer[0].contains(el[0])) {
        self.currentlyOpenMenu = undefined;
      }
    }));
    menuItems = angular.element($mdUtil.nodesToArray(menuContainer[0].children[0].children));
    menuItems.on('mouseenter', self.handleMenuItemHover);
    menuItems.on('mouseleave', self.handleMenuItemMouseLeave);
  };

  this.disableHoverListener = function() {
    while (deregisterScopeListeners.length) {
      deregisterScopeListeners.shift()();
    }
    menuItems && menuItems.off('mouseenter', self.handleMenuItemHover);
    menuItems && menuItems.off('mouseleave', self.handleMenuItemMouseLeave);
  };

  this.handleMenuItemHover = function(event) {
    if (self.isAlreadyOpening) return;
    var nestedMenu = (
      event.target.querySelector('md-menu')
        || $mdUtil.getClosest(event.target, 'MD-MENU')
    );
    openMenuTimeout = $timeout(function() {
      if (nestedMenu) {
        nestedMenu = angular.element(nestedMenu).controller('mdMenu');
      }

      if (self.currentlyOpenMenu && self.currentlyOpenMenu != nestedMenu) {
        var closeTo = self.nestLevel + 1;
        self.currentlyOpenMenu.close(true, { closeTo: closeTo });
        self.isAlreadyOpening = !!nestedMenu;
        nestedMenu && nestedMenu.open();
      } else if (nestedMenu && !nestedMenu.isOpen && nestedMenu.open) {
        self.isAlreadyOpening = !!nestedMenu;
        nestedMenu && nestedMenu.open();
      }
    }, nestedMenu ? 100 : 250);
    var focusableTarget = event.currentTarget.querySelector('.md-button:not([disabled])');
    focusableTarget && focusableTarget.focus();
  };

  this.handleMenuItemMouseLeave = function() {
    if (openMenuTimeout) {
      $timeout.cancel(openMenuTimeout);
      openMenuTimeout = undefined;
    }
  };


  /**
   * Uses the $mdMenu interim element service to open the menu contents
   */
  this.open = function openMenu(ev) {
    ev && ev.stopPropagation();
    ev && ev.preventDefault();
    if (self.isOpen) return;
    self.enableHoverListener();
    self.isOpen = true;
    $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});
    triggerElement = triggerElement || (ev ? ev.target : $element[0]);
    triggerElement.setAttribute('aria-expanded', 'true');
    $scope.$emit('$mdMenuOpen', $element);
    $mdMenu.show({
      scope: $scope,
      mdMenuCtrl: self,
      nestLevel: self.nestLevel,
      element: menuContainer,
      target: triggerElement,
      preserveElement: true,
      parent: 'body'
    }).finally(function() {
      triggerElement.setAttribute('aria-expanded', 'false');
      self.disableHoverListener();
    });
  };

  this.onIsOpenChanged = function(isOpen) {
    if (isOpen) {
      menuContainer.attr('aria-hidden', 'false');
      $element[0].classList.add('md-open');
      angular.forEach(self.nestedMenus, function(el) {
        el.classList.remove('md-open');
      });
    } else {
      menuContainer.attr('aria-hidden', 'true');
      $element[0].classList.remove('md-open');
    }
    $scope.$mdMenuIsOpen = self.isOpen;
  };

  this.focusMenuContainer = function focusMenuContainer() {
    var focusTarget = menuContainer[0]
      .querySelector(prefixer.buildSelector(['md-menu-focus-target', 'md-autofocus']));

    if (!focusTarget) focusTarget = menuContainer[0].querySelector('.md-button:not([disabled])');
    focusTarget.focus();
  };

  this.registerContainerProxy = function registerContainerProxy(handler) {
    this.containerProxy = handler;
  };

  this.triggerContainerProxy = function triggerContainerProxy(ev) {
    this.containerProxy && this.containerProxy(ev);
  };

  this.destroy = function() {
    return self.isOpen ? $mdMenu.destroy() : $q.when(false);
  };

  // Use the $mdMenu interim element service to close the menu contents
  this.close = function closeMenu(skipFocus, closeOpts) {
    if (!self.isOpen) return;
    self.isOpen = false;
    $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});

    var eventDetails = angular.extend({}, closeOpts, { skipFocus: skipFocus });
    $scope.$emit('$mdMenuClose', $element, eventDetails);
    $mdMenu.hide(null, closeOpts);

    if (!skipFocus) {
      var el = self.restoreFocusTo || $element.find('button')[0];
      if (el instanceof angular.element) el = el[0];
      if (el) el.focus();
    }
  };

  /**
   * Build a nice object out of our string attribute which specifies the
   * target mode for left and top positioning
   */
  this.positionMode = function positionMode() {
    var attachment = ($attrs.mdPositionMode || 'target').split(' ');

    // If attachment is a single item, duplicate it for our second value.
    // ie. 'target' -> 'target target'
    if (attachment.length === 1) {
      attachment.push(attachment[0]);
    }

    return {
      left: attachment[0],
      top: attachment[1]
    };
  };

  /**
   * Build a nice object out of our string attribute which specifies
   * the offset of top and left in pixels.
   */
  this.offsets = function offsets() {
    var position = ($attrs.mdOffset || '0 0').split(' ').map(parseFloat);
    if (position.length === 2) {
      return {
        left: position[0],
        top: position[1]
      };
    } else if (position.length === 1) {
      return {
        top: position[0],
        left: position[0]
      };
    } else {
      throw Error('Invalid offsets specified. Please follow format <x, y> or <n>');
    }
  };

  // Functionality that is exposed in the view.
  $scope.$mdMenu = {
    open: this.open,
    close: this.close
  };
}

})();
(function(){
"use strict";

/**
 * @ngdoc directive
 * @name mdMenu
 * @module material.components.menu
 * @restrict E
 * @description
 *
 * Menus are elements that open when clicked. They are useful for displaying
 * additional options within the context of an action.
 *
 * Every `md-menu` must specify exactly two child elements. The first element is what is
 * left in the DOM and is used to open the menu. This element is called the trigger element.
 * The trigger element's scope has access to `$mdMenu.open($event)`
 * which it may call to open the menu. By passing $event as argument, the
 * corresponding event is stopped from propagating up the DOM-tree. Similarly, `$mdMenu.close()`
 * can be used to close the menu.
 *
 * The second element is the `md-menu-content` element which represents the
 * contents of the menu when it is open. Typically this will contain `md-menu-item`s,
 * but you can do custom content as well.
 *
 * <hljs lang="html">
 * <md-menu>
 *  <!-- Trigger element is a md-button with an icon -->
 *  <md-button ng-click="$mdMenu.open($event)" class="md-icon-button" aria-label="Open sample menu">
 *    <md-icon md-svg-icon="call:phone"></md-icon>
 *  </md-button>
 *  <md-menu-content>
 *    <md-menu-item><md-button ng-click="doSomething()">Do Something</md-button></md-menu-item>
 *  </md-menu-content>
 * </md-menu>
 * </hljs>

 * ## Sizing Menus
 *
 * The width of the menu when it is open may be specified by specifying a `width`
 * attribute on the `md-menu-content` element.
 * See the [Material Design Spec](https://material.io/archive/guidelines/components/menus.html#menus-simple-menus)
 * for more information.
 *
 * ## Menu Density
 *
 * You can use dense menus by adding the `md-dense` class to the `md-menu-content` element.
 * This reduces the height of menu items, their top and bottom padding, and default font size.
 * Without the `md-dense` class, we use the "mobile" height of `48px`. With the `md-dense` class,
 * we use the "desktop" height of `32px`. We do not support the "dense desktop" option in the spec,
 * which uses a height of `24px`, at this time.
 * See the [Menu Specs](https://material.io/archive/guidelines/components/menus.html#menus-specs)
 * section of the Material Design Spec for more information.
 *
 * ## Aligning Menus
 *
 * When a menu opens, it is important that the content aligns with the trigger element.
 * Failure to align menus can result in jarring experiences for users as content
 * suddenly shifts. To help with this, `md-menu` provides several APIs to help
 * with alignment.
 *
 * ### Target Mode
 *
 * By default, `md-menu` will attempt to align the `md-menu-content` by aligning
 * designated child elements in both the trigger and the menu content.
 *
 * To specify the alignment element in the `trigger` you can use the `md-menu-origin`
 * attribute on a child element. If no `md-menu-origin` is specified, the `md-menu`
 * will be used as the origin element.
 *
 * Similarly, the `md-menu-content` may specify a `md-menu-align-target` for a
 * `md-menu-item` to specify the node that it should try and align with.
 *
 * In this example code, we specify an icon to be our origin element, and an
 * icon in our menu content to be our alignment target. This ensures that both
 * icons are aligned when the menu opens.
 *
 * <hljs lang="html">
 * <md-menu>
 *  <md-button ng-click="$mdMenu.open($event)" class="md-icon-button" aria-label="Open some menu">
 *    <md-icon md-menu-origin md-svg-icon="call:phone"></md-icon>
 *  </md-button>
 *  <md-menu-content>
 *    <md-menu-item>
 *      <md-button ng-click="doSomething()" aria-label="Do something">
 *        <md-icon md-menu-align-target md-svg-icon="call:phone"></md-icon>
 *        Do Something
 *      </md-button>
 *    </md-menu-item>
 *  </md-menu-content>
 * </md-menu>
 * </hljs>
 *
 * ### Position Mode
 *
 * We can specify the origin of the menu by using the `md-position-mode` attribute.
 * This attribute allows specifying the positioning by the `x` and `y` axes.
 *
 * The default mode is `target target`. This mode uses the left and top edges of the origin element
 * to position the menu in LTR layouts. The `x` axis modes will adjust when in RTL layouts.
 *
 * Sometimes you want to specify alignment from the right side of a origin element. For example,
 * if we have a menu on the right side a toolbar, we may want to right align our menu content.
 * We can use `target-right target` to specify a right-oriented alignment target.
 * There is a working example of this in the Menu Position Modes demo.
 *
 * #### Horizontal Positioning Options
 * - `target`
 * - `target-left`
 * - `target-right`
 * - `cascade`
 * - `right`
 * - `left`
 *
 * #### Vertical Positioning Options
 * - `target`
 * - `cascade`
 * - `bottom`
 *
 * ### Menu Offsets
 *
 * It is sometimes unavoidable to need to have a deeper level of control for
 * the positioning of a menu to ensure perfect alignment. `md-menu` provides
 * the `md-offset` attribute to allow pixel-level specificity when adjusting
 * menu positioning.
 *
 * This offset is provided in the format of `x y` or `n` where `n` will be used
 * in both the `x` and `y` axis.
 * For example, to move a menu by `2px` down from the top, we can use:
 *
 * <hljs lang="html">
 * <md-menu md-offset="0 2">
 *   <!-- menu-content -->
 * </md-menu>
 * </hljs>
 *
 * Specifying `md-offset="2 2"` would shift the menu two pixels down and two pixels to the right.
 *
 * ### Auto Focus
 * By default, when a menu opens, `md-menu` focuses the first button in the menu content.
 *
 * Sometimes you would like to focus another menu item instead of the first.<br/>
 * This can be done by applying the `md-autofocus` directive on the given element.
 *
 * <hljs lang="html">
 * <md-menu-item>
 *   <md-button md-autofocus ng-click="doSomething()">
 *     Auto Focus
 *   </md-button>
 * </md-menu-item>
 * </hljs>
 *
 *
 * ### Preventing close
 *
 * Sometimes you would like to be able to click on a menu item without having the menu
 * close. To do this, AngularJS Material exposes the `md-prevent-menu-close` attribute which
 * can be added to a button inside a menu to stop the menu from automatically closing.
 * You can then close the menu either by using `$mdMenu.close()` in the template,
 * or programmatically by injecting `$mdMenu` and calling `$mdMenu.hide()`.
 *
 * <hljs lang="html">
 * <md-menu-content ng-mouseleave="$mdMenu.close()">
 *   <md-menu-item>
 *     <md-button ng-click="doSomething()" aria-label="Do something" md-prevent-menu-close="md-prevent-menu-close">
 *       <md-icon md-menu-align-target md-svg-icon="call:phone"></md-icon>
 *       Do Something
 *     </md-button>
 *   </md-menu-item>
 * </md-menu-content>
 * </hljs>
 *
 * @usage
 * <hljs lang="html">
 * <md-menu>
 *  <md-button ng-click="$mdMenu.open($event)" class="md-icon-button">
 *    <md-icon md-svg-icon="call:phone"></md-icon>
 *  </md-button>
 *  <md-menu-content>
 *    <md-menu-item><md-button ng-click="doSomething()">Do Something</md-button></md-menu-item>
 *  </md-menu-content>
 * </md-menu>
 * </hljs>
 *
 * @param {string=} md-position-mode Specify pre-defined position modes for the `x` and `y` axes.
 *  The default modes are `target target`. This positions the origin of the menu using the left and top edges
 *  of the origin element in LTR layouts.<br>
 *  #### Valid modes for horizontal positioning
 * - `target`
 * - `target-left`
 * - `target-right`
 * - `cascade`
 * - `right`
 * - `left`<br>
 *  #### Valid modes for vertical positioning
 * - `target`
 * - `cascade`
 * - `bottom`
 * @param {string=} md-offset An offset to apply to the dropdown on opening, after positioning.
 *  Defined as `x` and `y` pixel offset values in the form of `x y`.<br>
 *  The default value is `0 0`.
 */
MenuDirective.$inject = ["$mdUtil"];
angular
    .module('material.components.menu')
    .directive('mdMenu', MenuDirective);

/**
 * @ngInject
 */
function MenuDirective($mdUtil) {
  var INVALID_PREFIX = 'Invalid HTML for md-menu: ';
  return {
    restrict: 'E',
    require: ['mdMenu', '?^mdMenuBar'],
    controller: 'mdMenuCtrl', // empty function to be built by link
    scope: true,
    compile: compile
  };

  function compile(templateElement) {
    templateElement.addClass('md-menu');

    var triggerEl = templateElement.children()[0];
    var prefixer = $mdUtil.prefixer();

    if (!prefixer.hasAttribute(triggerEl, 'ng-click')) {
      triggerEl = triggerEl
          .querySelector(prefixer.buildSelector(['ng-click', 'ng-mouseenter'])) || triggerEl;
    }

    var isButtonTrigger = triggerEl.nodeName === 'MD-BUTTON' || triggerEl.nodeName === 'BUTTON';

    if (triggerEl && isButtonTrigger && !triggerEl.hasAttribute('type')) {
      triggerEl.setAttribute('type', 'button');
    }

    if (!triggerEl) {
      throw Error(INVALID_PREFIX + 'Expected the menu to have a trigger element.');
    }

    if (templateElement.children().length !== 2) {
      throw Error(INVALID_PREFIX + 'Expected two children elements. The second element must have a `md-menu-content` element.');
    }

    // Default element for ARIA attributes has the ngClick or ngMouseenter expression
    triggerEl && triggerEl.setAttribute('aria-haspopup', 'true');

    var nestedMenus = templateElement[0].querySelectorAll('md-menu');
    var nestingDepth = parseInt(templateElement[0].getAttribute('md-nest-level'), 10) || 0;
    if (nestedMenus) {
      angular.forEach($mdUtil.nodesToArray(nestedMenus), function(menuEl) {
        if (!menuEl.hasAttribute('md-position-mode')) {
          menuEl.setAttribute('md-position-mode', 'cascade');
        }
        menuEl.classList.add('_md-nested-menu');
        menuEl.setAttribute('md-nest-level', nestingDepth + 1);
      });
    }
    return link;
  }

  function link(scope, element, attr, ctrls) {
    var mdMenuCtrl = ctrls[0];
    var isInMenuBar = !!ctrls[1];
    var mdMenuBarCtrl = ctrls[1];
    // Move everything into a md-menu-container and pass it to the controller
    var menuContainer = angular.element('<div class="_md md-open-menu-container md-whiteframe-z2"></div>');
    var menuContents = element.children()[1];

    element.addClass('_md');     // private md component indicator for styling

    if (!menuContents.hasAttribute('role')) {
      menuContents.setAttribute('role', 'menu');
    }
    menuContainer.append(menuContents);

    element.on('$destroy', function() {
      menuContainer.remove();
    });

    element.append(menuContainer);
    menuContainer[0].style.display = 'none';
    mdMenuCtrl.init(menuContainer, { isInMenuBar: isInMenuBar, mdMenuBarCtrl: mdMenuBarCtrl });
  }
}

})();
(function(){
"use strict";


MenuProvider.$inject = ["$$interimElementProvider"];angular
  .module('material.components.menu')
  .provider('$mdMenu', MenuProvider);

/**
 * Interim element provider for the menu.
 * Handles behavior for a menu while it is open, including:
 *    - handling animating the menu opening/closing
 *    - handling key/mouse events on the menu element
 *    - handling enabling/disabling scroll while the menu is open
 *    - handling redrawing during resizes and orientation changes
 *
 */

function MenuProvider($$interimElementProvider) {
  menuDefaultOptions.$inject = ["$mdUtil", "$mdTheming", "$mdConstant", "$document", "$window", "$q", "$$rAF", "$animateCss", "$animate", "$log"];
  var MENU_EDGE_MARGIN = 8;

  return $$interimElementProvider('$mdMenu')
    .setDefaults({
      methods: ['target'],
      options: menuDefaultOptions
    });

  /* @ngInject */
  function menuDefaultOptions($mdUtil, $mdTheming, $mdConstant, $document, $window, $q, $$rAF,
                              $animateCss, $animate, $log) {

    var prefixer = $mdUtil.prefixer();
    var animator = $mdUtil.dom.animator;

    return {
      parent: 'body',
      onShow: onShow,
      onRemove: onRemove,
      hasBackdrop: true,
      disableParentScroll: true,
      skipCompile: true,
      preserveScope: true,
      multiple: true,
      themable: true
    };

    /**
     * Show modal backdrop element...
     * @returns {function(): void} A function that removes this backdrop
     */
    function showBackdrop(scope, element, options) {
      if (options.nestLevel) return angular.noop;

      // If we are not within a dialog...
      if (options.disableParentScroll && !$mdUtil.getClosest(options.target, 'MD-DIALOG')) {
        // !! DO this before creating the backdrop; since disableScrollAround()
        //    configures the scroll offset; which is used by mdBackDrop postLink()
        options.restoreScroll = $mdUtil.disableScrollAround(options.element, options.parent);
      } else {
        options.disableParentScroll = false;
      }

      if (options.hasBackdrop) {
        options.backdrop = $mdUtil.createBackdrop(scope, "md-menu-backdrop md-click-catcher");

        $animate.enter(options.backdrop, options.backdropParent || $document[0].body);
      }

      /**
       * Hide and destroys the backdrop created by showBackdrop()
       */
      return function hideBackdrop() {
        if (options.backdrop) options.backdrop.remove();
        if (options.disableParentScroll) options.restoreScroll();
      };
    }

    /**
     * Removing the menu element from the DOM and remove all associated event listeners
     * and backdrop
     */
    function onRemove(scope, element, opts) {
      opts.cleanupInteraction();
      opts.cleanupBackdrop();
      opts.cleanupResizing();
      opts.hideBackdrop();

      // Before the menu is closing remove the clickable class.
      element.removeClass('md-clickable');

      // For navigation $destroy events, do a quick, non-animated removal,
      // but for normal closes (from clicks, etc) animate the removal

      return (opts.$destroy === true) ? detachAndClean() : animateRemoval().then(detachAndClean);

      /**
       * For normal closes, animate the removal.
       * For forced closes (like $destroy events), skip the animations
       */
      function animateRemoval() {
        return $animateCss(element, {addClass: 'md-leave'}).start();
      }

      /**
       * Detach the element
       */
      function detachAndClean() {
        element.removeClass('md-active');
        detachElement(element, opts);
        opts.alreadyOpen = false;
      }

    }

    /**
     * Inserts and configures the staged Menu element into the DOM, positioning it,
     * and wiring up various interaction events
     */
    function onShow(scope, element, opts) {
      sanitizeAndConfigure(opts);

      if (opts.menuContentEl[0]) {
        // Inherit the theme from the target element.
        $mdTheming.inherit(opts.menuContentEl, opts.target);
      } else {
        $log.warn(
          '$mdMenu: Menu elements should always contain a `md-menu-content` element,' +
          'otherwise interactivity features will not work properly.',
          element
        );
      }

      // Register various listeners to move menu on resize/orientation change
      opts.cleanupResizing = startRepositioningOnResize();
      opts.hideBackdrop = showBackdrop(scope, element, opts);

      // Return the promise for when our menu is done animating in
      return showMenu()
        .then(function(response) {
          opts.alreadyOpen = true;
          opts.cleanupInteraction = activateInteraction();
          opts.cleanupBackdrop = setupBackdrop();

          // Since the menu finished its animation, mark the menu as clickable.
          element.addClass('md-clickable');

          return response;
        });

      /**
       * Place the menu into the DOM and call positioning related functions
       */
      function showMenu() {
        opts.parent.append(element);
        element[0].style.display = '';

        return $q(function(resolve) {
          var position = calculateMenuPosition(element, opts);

          element.removeClass('md-leave');

          // Animate the menu scaling, and opacity [from its position origin (default == top-left)]
          // to normal scale.
          $animateCss(element, {
            addClass: 'md-active',
            from: animator.toCss(position),
            to: animator.toCss({transform: ''})
          })
          .start()
          .then(resolve);

        });
      }

      /**
       * Check for valid opts and set some useful defaults
       */
      function sanitizeAndConfigure() {
        if (!opts.target) {
          throw Error(
            '$mdMenu.show() expected a target to animate from in options.target'
          );
        }
        angular.extend(opts, {
          alreadyOpen: false,
          isRemoved: false,
          target: angular.element(opts.target), // make sure it's not a naked DOM node
          parent: angular.element(opts.parent),
          menuContentEl: angular.element(element[0].querySelector('md-menu-content'))
        });
      }

      /**
       * Configure various resize listeners for screen changes
       */
      function startRepositioningOnResize() {

        var repositionMenu = (function(target, options) {
          return $$rAF.throttle(function() {
            if (opts.isRemoved) return;
            var position = calculateMenuPosition(target, options);

            target.css(animator.toCss(position));
          });
        })(element, opts);

        $window.addEventListener('resize', repositionMenu);
        $window.addEventListener('orientationchange', repositionMenu);

        return function stopRepositioningOnResize() {

          // Disable resizing handlers
          $window.removeEventListener('resize', repositionMenu);
          $window.removeEventListener('orientationchange', repositionMenu);

        };
      }

      /**
       * Sets up the backdrop and listens for click elements.
       * Once the backdrop will be clicked, the menu will automatically close.
       * @returns {!Function} Function to remove the backdrop.
       */
      function setupBackdrop() {
        if (!opts.backdrop) return angular.noop;

        opts.backdrop.on('click', onBackdropClick);

        return function() {
          opts.backdrop.off('click', onBackdropClick);
        };
      }

      /**
       * Function to be called whenever the backdrop is clicked.
       * @param {!MouseEvent} event
       */
      function onBackdropClick(event) {
        event.preventDefault();
        event.stopPropagation();

        scope.$apply(function() {
          opts.mdMenuCtrl.close(true, { closeAll: true });
        });
      }

      /**
       * Activate interaction on the menu. Resolves the focus target and closes the menu on
       * escape or option click.
       * @returns {!Function} Function to deactivate the interaction listeners.
       */
      function activateInteraction() {
        if (!opts.menuContentEl[0]) return angular.noop;

        // Wire up keyboard listeners.
        // - Close on escape,
        // - focus next item on down arrow,
        // - focus prev item on up
        opts.menuContentEl.on('keydown', onMenuKeyDown);
        opts.menuContentEl[0].addEventListener('click', captureClickListener, true);

        // kick off initial focus in the menu on the first enabled element
        var focusTarget = opts.menuContentEl[0]
          .querySelector(prefixer.buildSelector(['md-menu-focus-target', 'md-autofocus']));

        if (!focusTarget) {
          var childrenLen = opts.menuContentEl[0].children.length;
          for (var childIndex = 0; childIndex < childrenLen; childIndex++) {
            var child = opts.menuContentEl[0].children[childIndex];
            focusTarget = child.querySelector('.md-button:not([disabled])');
            if (focusTarget) {
              break;
            }
            // Need to check the attribute as well since this might be a custom element whose
            // disabled property is undefined.
            if (child.firstElementChild && !child.firstElementChild.disabled &&
                !child.firstElementChild.getAttribute('disabled')) {
              focusTarget = child.firstElementChild;
              break;
            }
          }
        }

        focusTarget && focusTarget.focus();

        return function cleanupInteraction() {
          opts.menuContentEl.off('keydown', onMenuKeyDown);
          opts.menuContentEl[0].removeEventListener('click', captureClickListener, true);
        };

        // ************************************
        // internal functions
        // ************************************

        function onMenuKeyDown(ev) {
          var handled;
          switch (ev.keyCode) {
            case $mdConstant.KEY_CODE.ESCAPE:
              if (opts.nestLevel) {
                opts.mdMenuCtrl.close();
              } else {
                opts.mdMenuCtrl.close(false, { closeAll: true });
              }
              handled = true;
              break;
            case $mdConstant.KEY_CODE.TAB:
              opts.mdMenuCtrl.close(false, { closeAll: true });
              // Don't prevent default or stop propagation on this event as we want tab
              // to move the focus to the next focusable element on the page.
              handled = false;
              break;
            case $mdConstant.KEY_CODE.UP_ARROW:
              if (!focusMenuItem(ev, opts.menuContentEl, opts, -1) && !opts.nestLevel) {
                opts.mdMenuCtrl.triggerContainerProxy(ev);
              }
              handled = true;
              break;
            case $mdConstant.KEY_CODE.DOWN_ARROW:
              if (!focusMenuItem(ev, opts.menuContentEl, opts, 1) && !opts.nestLevel) {
                opts.mdMenuCtrl.triggerContainerProxy(ev);
              }
              handled = true;
              break;
            case $mdConstant.KEY_CODE.LEFT_ARROW:
              if (opts.nestLevel) {
                opts.mdMenuCtrl.close();
              } else {
                opts.mdMenuCtrl.triggerContainerProxy(ev);
              }
              handled = true;
              break;
            case $mdConstant.KEY_CODE.RIGHT_ARROW:
              var parentMenu = $mdUtil.getClosest(ev.target, 'MD-MENU');
              if (parentMenu && parentMenu != opts.parent[0]) {
                ev.target.click();
              } else {
                opts.mdMenuCtrl.triggerContainerProxy(ev);
              }
              handled = true;
              break;
          }
          if (handled) {
            ev.preventDefault();
            ev.stopImmediatePropagation();
          }
        }

        function onBackdropClick(e) {
          e.preventDefault();
          e.stopPropagation();
          scope.$apply(function() {
            opts.mdMenuCtrl.close(true, { closeAll: true });
          });
        }

        // Close menu on menu item click, if said menu-item is not disabled
        function captureClickListener(e) {
          var target = e.target;
          // Traverse up the event until we get to the menuContentEl to see if
          // there is an ng-click and that the ng-click is not disabled
          do {
            if (target == opts.menuContentEl[0]) return;
            if ((hasAnyAttribute(target, ['ng-click', 'ng-href', 'ui-sref']) ||
                target.nodeName == 'BUTTON' || target.nodeName == 'MD-BUTTON') && !hasAnyAttribute(target, ['md-prevent-menu-close'])) {
              var closestMenu = $mdUtil.getClosest(target, 'MD-MENU');
              if (!target.hasAttribute('disabled') && (!closestMenu || closestMenu == opts.parent[0])) {
                close();
              }
              break;
            }
          } while (target = target.parentNode);

          function close() {
            scope.$apply(function() {
              opts.mdMenuCtrl.close(true, { closeAll: true });
            });
          }

          function hasAnyAttribute(target, attrs) {
            if (!target) return false;

            for (var i = 0, attr; attr = attrs[i]; ++i) {
              if (prefixer.hasAttribute(target, attr)) {
                return true;
              }
            }

            return false;
          }
        }

      }
    }

    /**
     * Takes a keypress event and focuses the next/previous menu
     * item from the emitting element
     * @param {event} e - The origin keypress event
     * @param {angular.element} menuEl - The menu element
     * @param {object} opts - The interim element options for the mdMenu
     * @param {number} direction - The direction to move in (+1 = next, -1 = prev)
     */
    function focusMenuItem(e, menuEl, opts, direction) {
      var currentItem = $mdUtil.getClosest(e.target, 'MD-MENU-ITEM');

      var items = $mdUtil.nodesToArray(menuEl[0].children);
      var currentIndex = items.indexOf(currentItem);

      // Traverse through our elements in the specified direction (+/-1) and try to
      // focus them until we find one that accepts focus
      var didFocus;
      for (var i = currentIndex + direction; i >= 0 && i < items.length; i = i + direction) {
        var focusTarget = items[i].querySelector('.md-button');
        didFocus = attemptFocus(focusTarget);
        if (didFocus) {
          break;
        }
      }
      return didFocus;
    }

    /**
     * Attempts to focus an element. Checks whether that element is the currently
     * focused element after attempting.
     * @param {HTMLElement} el - the element to attempt focus on
     * @returns {boolean} - whether the element was successfully focused
     */
    function attemptFocus(el) {
      if (el && el.getAttribute('tabindex') != -1) {
        el.focus();
        return ($document[0].activeElement == el);
      }
    }

    /**
     * Use browser to remove this element without triggering a $destroy event
     */
    function detachElement(element, opts) {
      if (!opts.preserveElement) {
        if (toNode(element).parentNode === toNode(opts.parent)) {
          toNode(opts.parent).removeChild(toNode(element));
        }
      } else {
        toNode(element).style.display = 'none';
      }
    }

    /**
     * Computes menu position and sets the style on the menu container
     * @param {HTMLElement} el - the menu container element
     * @param {object} opts - the interim element options object
     */
    function calculateMenuPosition(el, opts) {

      var containerNode = el[0],
        openMenuNode = el[0].firstElementChild,
        openMenuNodeRect = openMenuNode.getBoundingClientRect(),
        boundryNode = $document[0].body,
        boundryNodeRect = boundryNode.getBoundingClientRect();

      var menuStyle = $window.getComputedStyle(openMenuNode);

      var originNode = opts.target[0].querySelector(prefixer.buildSelector('md-menu-origin')) || opts.target[0],
        originNodeRect = originNode.getBoundingClientRect();

      var bounds = {
        left: boundryNodeRect.left + MENU_EDGE_MARGIN,
        top: Math.max(boundryNodeRect.top, 0) + MENU_EDGE_MARGIN,
        bottom: Math.max(boundryNodeRect.bottom, Math.max(boundryNodeRect.top, 0) + boundryNodeRect.height) - MENU_EDGE_MARGIN,
        right: boundryNodeRect.right - MENU_EDGE_MARGIN
      };

      var alignTarget, alignTargetRect = { top:0, left : 0, right:0, bottom:0 }, existingOffsets  = { top:0, left : 0, right:0, bottom:0  };
      var positionMode = opts.mdMenuCtrl.positionMode();

      if (positionMode.top === 'target' || positionMode.left === 'target' || positionMode.left === 'target-right') {
        alignTarget = firstVisibleChild();
        if (alignTarget) {
          // TODO: Allow centering on an arbitrary node, for now center on first menu-item's child
          alignTarget = alignTarget.firstElementChild || alignTarget;
          alignTarget = alignTarget.querySelector(prefixer.buildSelector('md-menu-align-target')) || alignTarget;
          alignTargetRect = alignTarget.getBoundingClientRect();

          existingOffsets = {
            top: parseFloat(containerNode.style.top || 0),
            left: parseFloat(containerNode.style.left || 0)
          };
        }
      }

      var position = {};
      var transformOrigin = 'top ';

      switch (positionMode.top) {
        case 'target':
          position.top = existingOffsets.top + originNodeRect.top - alignTargetRect.top;
          break;
        case 'cascade':
          position.top = originNodeRect.top - parseFloat(menuStyle.paddingTop) - originNode.style.top;
          break;
        case 'bottom':
          position.top = originNodeRect.top + originNodeRect.height;
          break;
        default:
          throw new Error('Invalid target mode "' + positionMode.top + '" specified for md-menu on Y axis.');
      }

      var rtl = $mdUtil.isRtl(el);

      switch (positionMode.left) {
        case 'target':
          position.left = existingOffsets.left + originNodeRect.left - alignTargetRect.left;
          transformOrigin += rtl ? 'right'  : 'left';
          break;
        case 'target-left':
          position.left = originNodeRect.left;
          transformOrigin += 'left';
          break;
        case 'target-right':
          position.left = originNodeRect.right - openMenuNodeRect.width + (openMenuNodeRect.right - alignTargetRect.right);
          transformOrigin += 'right';
          break;
        case 'cascade':
          var willFitRight = rtl ? (originNodeRect.left - openMenuNodeRect.width) < bounds.left : (originNodeRect.right + openMenuNodeRect.width) < bounds.right;
          position.left = willFitRight ? originNodeRect.right - originNode.style.left : originNodeRect.left - originNode.style.left - openMenuNodeRect.width;
          transformOrigin += willFitRight ? 'left' : 'right';
          break;
        case 'right':
          if (rtl) {
            position.left = originNodeRect.right - originNodeRect.width;
            transformOrigin += 'left';
          } else {
            position.left = originNodeRect.right - openMenuNodeRect.width;
            transformOrigin += 'right';
          }
          break;
        case 'left':
          if (rtl) {
            position.left = originNodeRect.right - openMenuNodeRect.width;
            transformOrigin += 'right';
          } else {
            position.left = originNodeRect.left;
            transformOrigin += 'left';
          }
          break;
        default:
          throw new Error('Invalid target mode "' + positionMode.left + '" specified for md-menu on X axis.');
      }

      var offsets = opts.mdMenuCtrl.offsets();
      position.top += offsets.top;
      position.left += offsets.left;

      clamp(position);

      var scaleX = Math.round(100 * Math.min(originNodeRect.width / containerNode.offsetWidth, 1.0)) / 100;
      var scaleY = Math.round(100 * Math.min(originNodeRect.height / containerNode.offsetHeight, 1.0)) / 100;

      return {
        top: Math.round(position.top),
        left: Math.round(position.left),
        // Animate a scale out if we aren't just repositioning
        transform: !opts.alreadyOpen ? $mdUtil.supplant('scale({0},{1})', [scaleX, scaleY]) : undefined,
        transformOrigin: transformOrigin
      };

      /**
       * Clamps the repositioning of the menu within the confines of
       * bounding element (often the screen/body)
       */
      function clamp(pos) {
        pos.top = Math.max(Math.min(pos.top, bounds.bottom - containerNode.offsetHeight), bounds.top);
        pos.left = Math.max(Math.min(pos.left, bounds.right - containerNode.offsetWidth), bounds.left);
      }

      /**
       * Gets the first visible child in the openMenuNode
       * Necessary incase menu nodes are being dynamically hidden
       */
      function firstVisibleChild() {
        for (var i = 0; i < openMenuNode.children.length; ++i) {
          if ($window.getComputedStyle(openMenuNode.children[i]).display != 'none') {
            return openMenuNode.children[i];
          }
        }
      }
    }
  }
  function toNode(el) {
    if (el instanceof angular.element) {
      el = el[0];
    }
    return el;
  }
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.menuBar
 */

angular.module('material.components.menuBar', [
  'material.core',
  'material.components.icon',
  'material.components.menu'
]);

})();
(function(){
"use strict";


MenuBarController.$inject = ["$scope", "$rootScope", "$element", "$attrs", "$mdConstant", "$document", "$mdUtil", "$timeout"];
angular
  .module('material.components.menuBar')
  .controller('MenuBarController', MenuBarController);

var BOUND_MENU_METHODS = ['handleKeyDown', 'handleMenuHover', 'scheduleOpenHoveredMenu', 'cancelScheduledOpen'];

/**
 * @ngInject
 */
function MenuBarController($scope, $rootScope, $element, $attrs, $mdConstant, $document, $mdUtil, $timeout) {
  this.$element = $element;
  this.$attrs = $attrs;
  this.$mdConstant = $mdConstant;
  this.$mdUtil = $mdUtil;
  this.$document = $document;
  this.$scope = $scope;
  this.$rootScope = $rootScope;
  this.$timeout = $timeout;

  var self = this;
  angular.forEach(BOUND_MENU_METHODS, function(methodName) {
    self[methodName] = angular.bind(self, self[methodName]);
  });
}

MenuBarController.prototype.init = function() {
  var $element = this.$element;
  var $mdUtil = this.$mdUtil;
  var $scope = this.$scope;

  var self = this;
  var deregisterFns = [];
  $element.on('keydown', this.handleKeyDown);
  this.parentToolbar = $mdUtil.getClosest($element, 'MD-TOOLBAR');

  deregisterFns.push(this.$rootScope.$on('$mdMenuOpen', function(event, el) {
    if (self.getMenus().indexOf(el[0]) != -1) {
      $element[0].classList.add('md-open');
      el[0].classList.add('md-open');
      self.currentlyOpenMenu = el.controller('mdMenu');
      self.currentlyOpenMenu.registerContainerProxy(self.handleKeyDown);
      self.enableOpenOnHover();
    }
  }));

  deregisterFns.push(this.$rootScope.$on('$mdMenuClose', function(event, el, opts) {
    var rootMenus = self.getMenus();
    if (rootMenus.indexOf(el[0]) != -1) {
      $element[0].classList.remove('md-open');
      el[0].classList.remove('md-open');
    }

    var ctrl = angular.element(el[0]).controller('mdMenu');
    if (ctrl.isInMenuBar && ctrl.mdMenuBarCtrl === self) {
      var parentMenu = el[0];
      while (parentMenu && rootMenus.indexOf(parentMenu) == -1) {
        parentMenu = $mdUtil.getClosest(parentMenu, 'MD-MENU', true);
      }
      if (parentMenu) {
        if (!opts.skipFocus) parentMenu.querySelector('button:not([disabled])').focus();
        self.currentlyOpenMenu = undefined;
      }
      self.disableOpenOnHover();
      self.setKeyboardMode(true);
    }
  }));

  $scope.$on('$destroy', function() {
    self.disableOpenOnHover();
    while (deregisterFns.length) {
      deregisterFns.shift()();
    }
  });


  this.setKeyboardMode(true);
};

MenuBarController.prototype.setKeyboardMode = function(enabled) {
  if (enabled) this.$element[0].classList.add('md-keyboard-mode');
  else this.$element[0].classList.remove('md-keyboard-mode');
};

MenuBarController.prototype.enableOpenOnHover = function() {
  if (this.openOnHoverEnabled) return;

  var self = this;

  self.openOnHoverEnabled = true;

  if (self.parentToolbar) {
    self.parentToolbar.classList.add('md-has-open-menu');

    // Needs to be on the next tick so it doesn't close immediately.
    self.$mdUtil.nextTick(function() {
      angular.element(self.parentToolbar).on('click', self.handleParentClick);
    }, false);
  }

  angular
    .element(self.getMenus())
    .on('mouseenter', self.handleMenuHover);
};

MenuBarController.prototype.handleMenuHover = function(e) {
  this.setKeyboardMode(false);
  if (this.openOnHoverEnabled) {
    this.scheduleOpenHoveredMenu(e);
  }
};

MenuBarController.prototype.disableOpenOnHover = function() {
  if (!this.openOnHoverEnabled) return;

  this.openOnHoverEnabled = false;

  if (this.parentToolbar) {
    this.parentToolbar.classList.remove('md-has-open-menu');
    angular.element(this.parentToolbar).off('click', this.handleParentClick);
  }

  angular
    .element(this.getMenus())
    .off('mouseenter', this.handleMenuHover);
};

MenuBarController.prototype.scheduleOpenHoveredMenu = function(e) {
  var menuEl = angular.element(e.currentTarget);
  var menuCtrl = menuEl.controller('mdMenu');
  this.setKeyboardMode(false);
  this.scheduleOpenMenu(menuCtrl);
};

MenuBarController.prototype.scheduleOpenMenu = function(menuCtrl) {
  var self = this;
  var $timeout = this.$timeout;
  if (menuCtrl != self.currentlyOpenMenu) {
    $timeout.cancel(self.pendingMenuOpen);
    self.pendingMenuOpen = $timeout(function() {
      self.pendingMenuOpen = undefined;
      if (self.currentlyOpenMenu) {
        self.currentlyOpenMenu.close(true, { closeAll: true });
      }
      menuCtrl.open();
    }, 200, false);
  }
};

MenuBarController.prototype.handleKeyDown = function(e) {
  var keyCodes = this.$mdConstant.KEY_CODE;
  var currentMenu = this.currentlyOpenMenu;
  var wasOpen = currentMenu && currentMenu.isOpen;
  this.setKeyboardMode(true);
  var handled, newMenu, newMenuCtrl;
  switch (e.keyCode) {
    case keyCodes.DOWN_ARROW:
      if (currentMenu) {
        currentMenu.focusMenuContainer();
      } else {
        this.openFocusedMenu();
      }
      handled = true;
      break;
    case keyCodes.UP_ARROW:
      currentMenu && currentMenu.close();
      handled = true;
      break;
    case keyCodes.LEFT_ARROW:
      newMenu = this.focusMenu(-1);
      if (wasOpen) {
        newMenuCtrl = angular.element(newMenu).controller('mdMenu');
        this.scheduleOpenMenu(newMenuCtrl);
      }
      handled = true;
      break;
    case keyCodes.RIGHT_ARROW:
      newMenu = this.focusMenu(+1);
      if (wasOpen) {
        newMenuCtrl = angular.element(newMenu).controller('mdMenu');
        this.scheduleOpenMenu(newMenuCtrl);
      }
      handled = true;
      break;
  }
  if (handled) {
    e && e.preventDefault && e.preventDefault();
    e && e.stopImmediatePropagation && e.stopImmediatePropagation();
  }
};

MenuBarController.prototype.focusMenu = function(direction) {
  var menus = this.getMenus();
  var focusedIndex = this.getFocusedMenuIndex();

  if (focusedIndex == -1) { focusedIndex = this.getOpenMenuIndex(); }

  var changed = false;

  if (focusedIndex == -1) { focusedIndex = 0; changed = true; }
  else if (
    direction < 0 && focusedIndex > 0 ||
    direction > 0 && focusedIndex < menus.length - direction
  ) {
    focusedIndex += direction;
    changed = true;
  }
  if (changed) {
    menus[focusedIndex].querySelector('button').focus();
    return menus[focusedIndex];
  }
};

MenuBarController.prototype.openFocusedMenu = function() {
  var menu = this.getFocusedMenu();
  menu && angular.element(menu).controller('mdMenu').open();
};

MenuBarController.prototype.getMenus = function() {
  var $element = this.$element;
  return this.$mdUtil.nodesToArray($element[0].children)
    .filter(function(el) { return el.nodeName == 'MD-MENU'; });
};

MenuBarController.prototype.getFocusedMenu = function() {
  return this.getMenus()[this.getFocusedMenuIndex()];
};

MenuBarController.prototype.getFocusedMenuIndex = function() {
  var $mdUtil = this.$mdUtil;
  var focusedEl = $mdUtil.getClosest(
    this.$document[0].activeElement,
    'MD-MENU'
  );
  if (!focusedEl) return -1;

  var focusedIndex = this.getMenus().indexOf(focusedEl);
  return focusedIndex;
};

MenuBarController.prototype.getOpenMenuIndex = function() {
  var menus = this.getMenus();
  for (var i = 0; i < menus.length; ++i) {
    if (menus[i].classList.contains('md-open')) return i;
  }
  return -1;
};

MenuBarController.prototype.handleParentClick = function(event) {
  var openMenu = this.querySelector('md-menu.md-open');

  if (openMenu && !openMenu.contains(event.target)) {
    angular.element(openMenu).controller('mdMenu').close(true, {
      closeAll: true
    });
  }
};

})();
(function(){
"use strict";

/**
 * @ngdoc directive
 * @name mdMenuBar
 * @module material.components.menuBar
 * @restrict E
 * @description
 *
 * Menu bars are containers that hold multiple menus. They change the behavior and appearance
 * of the `md-menu` directive to behave similar to an operating system provided menu.
 *
 * @usage
 * <hljs lang="html">
 * <md-menu-bar>
 *   <md-menu>
 *     <button ng-click="$mdMenu.open()">
 *       File
 *     </button>
 *     <md-menu-content>
 *       <md-menu-item>
 *         <md-button ng-click="ctrl.sampleAction('share', $event)">
 *           Share...
 *         </md-button>
 *       </md-menu-item>
 *       <md-menu-divider></md-menu-divider>
 *       <md-menu-item>
 *       <md-menu-item>
 *         <md-menu>
 *           <md-button ng-click="$mdMenu.open()">New</md-button>
 *           <md-menu-content>
 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Document', $event)">Document</md-button></md-menu-item>
 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Spreadsheet', $event)">Spreadsheet</md-button></md-menu-item>
 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Presentation', $event)">Presentation</md-button></md-menu-item>
 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Form', $event)">Form</md-button></md-menu-item>
 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Drawing', $event)">Drawing</md-button></md-menu-item>
 *           </md-menu-content>
 *         </md-menu>
 *       </md-menu-item>
 *     </md-menu-content>
 *   </md-menu>
 * </md-menu-bar>
 * </hljs>
 *
 * ## Menu Bar Controls
 *
 * You may place `md-menu-item`s that function as controls within menu bars.
 * There are two modes that are exposed via the `type` attribute of the `md-menu-item`.
 * `type="checkbox"` will function as a boolean control for the `ng-model` attribute of the
 * `md-menu-item`. `type="radio"` will function like a radio button, setting the `ngModel`
 * to the `string` value of the `value` attribute. If you need non-string values, you can use
 * `ng-value` to provide an expression (this is similar to how angular's native `input[type=radio]`
 * works.
 *
 * If you want either to disable closing the opened menu when clicked, you can add the
 * `md-prevent-menu-close` attribute to the `md-menu-item`. The attribute will be forwarded to the
 * `button` element that is generated.
 *
 * <hljs lang="html">
 * <md-menu-bar>
 *  <md-menu>
 *    <button ng-click="$mdMenu.open()">
 *      Sample Menu
 *    </button>
 *    <md-menu-content>
 *      <md-menu-item type="checkbox" ng-model="settings.allowChanges" md-prevent-menu-close>
 *        Allow changes
 *      </md-menu-item>
 *      <md-menu-divider></md-menu-divider>
 *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="1">Mode 1</md-menu-item>
 *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="2">Mode 2</md-menu-item>
 *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="3">Mode 3</md-menu-item>
 *    </md-menu-content>
 *  </md-menu>
 * </md-menu-bar>
 * </hljs>
 *
 *
 * ### Nesting Menus
 *
 * Menus may be nested within menu bars. This is commonly called cascading menus.
 * To nest a menu place the nested menu inside the content of the `md-menu-item`.
 * <hljs lang="html">
 * <md-menu-item>
 *   <md-menu>
 *     <button ng-click="$mdMenu.open()">New</md-button>
 *     <md-menu-content>
 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Document', $event)">Document</md-button></md-menu-item>
 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Spreadsheet', $event)">Spreadsheet</md-button></md-menu-item>
 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Presentation', $event)">Presentation</md-button></md-menu-item>
 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Form', $event)">Form</md-button></md-menu-item>
 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Drawing', $event)">Drawing</md-button></md-menu-item>
 *     </md-menu-content>
 *   </md-menu>
 * </md-menu-item>
 * </hljs>
 *
 */

MenuBarDirective.$inject = ["$mdUtil", "$mdTheming"];
angular
  .module('material.components.menuBar')
  .directive('mdMenuBar', MenuBarDirective);

/* @ngInject */
function MenuBarDirective($mdUtil, $mdTheming) {
  return {
    restrict: 'E',
    require: 'mdMenuBar',
    controller: 'MenuBarController',

    compile: function compile(templateEl, templateAttrs) {
      if (!templateAttrs.ariaRole) {
        templateEl[0].setAttribute('role', 'menubar');
      }
      angular.forEach(templateEl[0].children, function(menuEl) {
        if (menuEl.nodeName == 'MD-MENU') {
          if (!menuEl.hasAttribute('md-position-mode')) {
            menuEl.setAttribute('md-position-mode', 'left bottom');

            // Since we're in the compile function and actual `md-buttons` are not compiled yet,
            // we need to query for possible `md-buttons` as well.
            menuEl.querySelector('button, a, md-button').setAttribute('role', 'menuitem');
          }
          var contentEls = $mdUtil.nodesToArray(menuEl.querySelectorAll('md-menu-content'));
          angular.forEach(contentEls, function(contentEl) {
            contentEl.classList.add('md-menu-bar-menu');
            contentEl.classList.add('md-dense');
            if (!contentEl.hasAttribute('width')) {
              contentEl.setAttribute('width', 5);
            }
          });
        }
      });

      // Mark the child menu items that they're inside a menu bar. This is necessary,
      // because mnMenuItem has special behaviour during compilation, depending on
      // whether it is inside a mdMenuBar. We can usually figure this out via the DOM,
      // however if a directive that uses documentFragment is applied to the child (e.g. ngRepeat),
      // the element won't have a parent and won't compile properly.
      templateEl.find('md-menu-item').addClass('md-in-menu-bar');

      return function postLink(scope, el, attr, ctrl) {
        el.addClass('_md');     // private md component indicator for styling
        $mdTheming(scope, el);
        ctrl.init();
      };
    }
  };

}

})();
(function(){
"use strict";


angular
  .module('material.components.menuBar')
  .directive('mdMenuDivider', MenuDividerDirective);


function MenuDividerDirective() {
  return {
    restrict: 'E',
    compile: function(templateEl, templateAttrs) {
      if (!templateAttrs.role) {
        templateEl[0].setAttribute('role', 'separator');
      }
    }
  };
}

})();
(function(){
"use strict";


MenuItemController.$inject = ["$scope", "$element", "$attrs"];
angular
  .module('material.components.menuBar')
  .controller('MenuItemController', MenuItemController);


/**
 * @ngInject
 */
function MenuItemController($scope, $element, $attrs) {
  this.$element = $element;
  this.$attrs = $attrs;
  this.$scope = $scope;
}

MenuItemController.prototype.init = function(ngModel) {
  var $element = this.$element;
  var $attrs = this.$attrs;

  this.ngModel = ngModel;
  if ($attrs.type == 'checkbox' || $attrs.type == 'radio') {
    this.mode  = $attrs.type;
    this.iconEl = $element[0].children[0];
    this.buttonEl = $element[0].children[1];
    if (ngModel) {
      // Clear ngAria set attributes
      this.initClickListeners();
    }
  }
};

// ngAria auto sets attributes on a menu-item with a ngModel.
// We don't want this because our content (buttons) get the focus
// and set their own aria attributes appropritately. Having both
// breaks NVDA / JAWS. This undeoes ngAria's attrs.
MenuItemController.prototype.clearNgAria = function() {
  var el = this.$element[0];
  var clearAttrs = ['role', 'tabindex', 'aria-invalid', 'aria-checked'];
  angular.forEach(clearAttrs, function(attr) {
    el.removeAttribute(attr);
  });
};

MenuItemController.prototype.initClickListeners = function() {
  var self = this;
  var ngModel = this.ngModel;
  var $scope = this.$scope;
  var $attrs = this.$attrs;
  var $element = this.$element;
  var mode = this.mode;

  this.handleClick = angular.bind(this, this.handleClick);

  var icon = this.iconEl;
  var button = angular.element(this.buttonEl);
  var handleClick = this.handleClick;

  $attrs.$observe('disabled', setDisabled);
  setDisabled($attrs.disabled);

  ngModel.$render = function render() {
    self.clearNgAria();
    if (isSelected()) {
      icon.style.display = '';
      button.attr('aria-checked', 'true');
    } else {
      icon.style.display = 'none';
      button.attr('aria-checked', 'false');
    }
  };

  $scope.$$postDigest(ngModel.$render);

  function isSelected() {
    if (mode == 'radio') {
      var val = $attrs.ngValue ? $scope.$eval($attrs.ngValue) : $attrs.value;
      return ngModel.$modelValue == val;
    } else {
      return ngModel.$modelValue;
    }
  }

  function setDisabled(disabled) {
    if (disabled) {
      button.off('click', handleClick);
    } else {
      button.on('click', handleClick);
    }
  }
};

MenuItemController.prototype.handleClick = function(e) {
  var mode = this.mode;
  var ngModel = this.ngModel;
  var $attrs = this.$attrs;
  var newVal;
  if (mode == 'checkbox') {
    newVal = !ngModel.$modelValue;
  } else if (mode == 'radio') {
    newVal = $attrs.ngValue ? this.$scope.$eval($attrs.ngValue) : $attrs.value;
  }
  ngModel.$setViewValue(newVal);
  ngModel.$render();
};

})();
(function(){
"use strict";


MenuItemDirective.$inject = ["$mdUtil", "$mdConstant", "$$mdSvgRegistry"];
angular
  .module('material.components.menuBar')
  .directive('mdMenuItem', MenuItemDirective);

 /* @ngInject */
function MenuItemDirective($mdUtil, $mdConstant, $$mdSvgRegistry) {
  return {
    controller: 'MenuItemController',
    require: ['mdMenuItem', '?ngModel'],
    priority: $mdConstant.BEFORE_NG_ARIA,
    compile: function(templateEl, templateAttrs) {
      var type = templateAttrs.type;
      var inMenuBarClass = 'md-in-menu-bar';

      // Note: This allows us to show the `check` icon for the md-menu-bar items.
      // The `md-in-menu-bar` class is set by the mdMenuBar directive.
      if ((type === 'checkbox' || type === 'radio') && templateEl.hasClass(inMenuBarClass)) {
        var text = templateEl[0].textContent;
        var buttonEl = angular.element('<md-button type="button"></md-button>');
        var iconTemplate = '<md-icon md-svg-src="' + $$mdSvgRegistry.mdChecked + '"></md-icon>';

        buttonEl.html(text);
        buttonEl.attr('tabindex', '0');

        if (angular.isDefined(templateAttrs.mdPreventMenuClose)) {
          buttonEl.attr('md-prevent-menu-close', templateAttrs.mdPreventMenuClose);
        }

        templateEl.html('');
        templateEl.append(angular.element(iconTemplate));
        templateEl.append(buttonEl);
        templateEl.addClass('md-indent').removeClass(inMenuBarClass);

        setDefault('role', type === 'checkbox' ? 'menuitemcheckbox' : 'menuitemradio', buttonEl);
        moveAttrToButton('ng-disabled');

      } else {
        setDefault('role', 'menuitem', templateEl[0].querySelector('md-button, button, a'));
      }


      return function(scope, el, attrs, ctrls) {
        var ctrl = ctrls[0];
        var ngModel = ctrls[1];
        ctrl.init(ngModel);
      };

      function setDefault(attr, val, el) {
        el = el || templateEl;
        if (el instanceof angular.element) {
          el = el[0];
        }
        if (!el.hasAttribute(attr)) {
          el.setAttribute(attr, val);
        }
      }

      function moveAttrToButton(attribute) {
        var attributes = $mdUtil.prefixer(attribute);

        angular.forEach(attributes, function(attr) {
          if (templateEl[0].hasAttribute(attr)) {
            var val = templateEl[0].getAttribute(attr);
            buttonEl[0].setAttribute(attr, val);
            templateEl[0].removeAttribute(attr);
          }
        });
      }
    }
  };
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.navBar
 */
MdNavBar.$inject = ["$mdAria", "$mdTheming", "$window", "$mdUtil"];
MdNavBarController.$inject = ["$element", "$scope", "$timeout", "$mdConstant"];
MdNavItem.$inject = ["$mdAria", "$$rAF", "$mdUtil", "$window"];
MdNavItemController.$inject = ["$element"];
angular.module('material.components.navBar', ['material.core'])
    .controller('MdNavBarController', MdNavBarController)
    .directive('mdNavBar', MdNavBar)
    .controller('MdNavItemController', MdNavItemController)
    .directive('mdNavItem', MdNavItem);

/**
 * @ngdoc directive
 * @name mdNavBar
 * @module material.components.navBar
 *
 * @restrict E
 *
 * @description
 * The `<md-nav-bar>` directive renders a list of material tabs that can be used
 * for top-level page navigation. Unlike `<md-tabs>`, it has no concept of a tab
 * body and no bar pagination.
 *
 * Because it deals with page navigation, certain routing concepts are built-in.
 * Route changes via `ng-href`, `ui-sref`, or `ng-click` events are supported.
 * Alternatively, the user could simply watch the value of `md-selected-nav-item`
 * (`currentNavItem` in the below example) for changes.
 *
 * Accessibility functionality is implemented as a
 * <a href="https://www.w3.org/TR/wai-aria-1.0/complete#tablist">
 *   tablist</a> with
 * <a href="https://www.w3.org/TR/wai-aria-1.0/complete#tab">tabs</a>.
 * We've kept the `role="navigation"` on the `<nav>`, for backwards compatibility, even though
 *  it is not required in the
 * <a href="https://www.w3.org/TR/wai-aria-practices/#aria_lh_navigation">
 *   latest Working Group Note from December 2017</a>.
 *
 * <h3>Keyboard Navigation</h3>
 * - `Tab`/`Shift+Tab` moves the focus to the next/previous interactive element on the page
 * - `Enter`/`Space` selects the focused nav item and navigates to display the item's contents
 * - `Right`/`Down` moves focus to the next nav item, wrapping at the end
 * - `Left`/`Up` moves focus to the previous nav item, wrapping at the end
 * - `Home`/`End` moves the focus to the first/last nav item
 *
 * @param {string=} md-selected-nav-item The name of the current tab; this must
 *     match the `name` attribute of `<md-nav-item>`.
 * @param {boolean=} md-no-ink-bar If set to true, the ink bar will be hidden.
 * @param {string=} nav-bar-aria-label An `aria-label` applied to the `md-nav-bar`'s tablist
 * for accessibility.
 *
 * @usage
 * <hljs lang="html">
 *  <md-nav-bar md-selected-nav-item="currentNavItem">
 *    <md-nav-item md-nav-click="goto('page1')" name="page1">
 *      Page One
 *    </md-nav-item>
 *    <md-nav-item md-nav-href="#page2" name="page3">Page Two</md-nav-item>
 *    <md-nav-item md-nav-sref="page3" name="page2">Page Three</md-nav-item>
 *    <md-nav-item
 *      md-nav-sref="app.page4"
 *      sref-opts="{reload: true, notify: true}"
 *      name="page4">
 *      Page Four
 *    </md-nav-item>
 *  </md-nav-bar>
 *</hljs>
 * <hljs lang="js">
 * (function() {
 *   'use strict';
 *
 *    $rootScope.$on('$routeChangeSuccess', function(event, current) {
 *      $scope.currentLink = getCurrentLinkFromRoute(current);
 *    });
 * });
 * </hljs>
 */
/**
 * @param $mdAria
 * @param $mdTheming
 * @param $window
 * @param $mdUtil
 * @constructor
 * @ngInject
 */
function MdNavBar($mdAria, $mdTheming, $window, $mdUtil) {
  return {
    restrict: 'E',
    transclude: true,
    controller: MdNavBarController,
    controllerAs: 'ctrl',
    bindToController: true,
    scope: {
      'mdSelectedNavItem': '=?',
      'mdNoInkBar': '=?',
      'navBarAriaLabel': '@?',
    },
    template:
      '<div class="md-nav-bar">' +
        '<nav role="navigation">' +
          '<ul class="_md-nav-bar-list" ng-transclude role="tablist" ' +
            'ng-focus="ctrl.onFocus()" ' + // Deprecated but kept for now in order to not break tests
            'aria-label="{{ctrl.navBarAriaLabel}}">' +
          '</ul>' +
        '</nav>' +
        '<md-nav-ink-bar ng-hide="ctrl.mdNoInkBar"></md-nav-ink-bar>' +
      '</div>',
    link: function(scope, element, attrs, ctrl) {

      ctrl.width = $window.innerWidth;

      function onResize() {
        if (ctrl.width !== $window.innerWidth) {
          ctrl.updateSelectedTabInkBar();
          ctrl.width = $window.innerWidth;
          scope.$digest();
        }
      }

      function cleanUp() {
        angular.element($window).off('resize', onResize);
      }

      angular.element($window).on('resize', $mdUtil.debounce(onResize, 300));
      scope.$on('$destroy', cleanUp);

      $mdTheming(element);
      if (!ctrl.navBarAriaLabel) {
        $mdAria.expectAsync(element, 'aria-label', angular.noop);
      }
    },
  };
}

/**
 * Controller for the nav-bar component.
 * Accessibility functionality is implemented as a tablist
 * (https://www.w3.org/TR/wai-aria-1.0/complete#tablist) and
 * tabs (https://www.w3.org/TR/wai-aria-1.0/complete#tab).
 *
 * @param {!JQLite} $element
 * @param {!IScope} $scope
 * @param {!ITimeoutService} $timeout
 * @param {!Object} $mdConstant
 * @constructor
 * @final
 * @ngInject
 */
function MdNavBarController($element, $scope, $timeout, $mdConstant) {
  // Injected variables
  /**
   * @private @const
   * @type {!ITimeoutService}
   */
  this._$timeout = $timeout;

  /**
   * @private @const
   * @type {!IScope}
   */
  this._$scope = $scope;

  /**
   * @private @const
   * @type {!Object}
   */
  this._$mdConstant = $mdConstant;

  // Data-bound variables.
  /** @type {?string} */
  this.mdSelectedNavItem;

  /** @type {?string} */
  this.navBarAriaLabel;

  // State variables.
  /** @type {?HTMLElement} */
  this._navBarEl = $element[0];

  /** @type {?JQLite} */
  this._inkbar;

  var self = this;
  // need to wait for transcluded content to be available
  var deregisterTabWatch = this._$scope.$watch(function() {
    return self._navBarEl.querySelectorAll('._md-nav-button').length;
  },
  function(newLength) {
    if (newLength > 0) {
      self._initTabs();
      deregisterTabWatch();
    }
  });
}

/**
 * Initializes the tab components once they exist.
 * @private
 */
MdNavBarController.prototype._initTabs = function() {
  this._inkbar = angular.element(this._navBarEl.querySelector('md-nav-ink-bar'));

  var self = this;
  this._$timeout(function() {
    self._updateTabs(self.mdSelectedNavItem, null);
  });

  this._$scope.$watch('ctrl.mdSelectedNavItem', function(newValue, oldValue) {
    // Wait a digest before update tabs for products doing
    // anything dynamic in the template.
    self._$timeout(function() {
      self._updateTabs(newValue, oldValue);
    });
  });
};

/**
 * Set the current tab to be selected.
 * @param {string|undefined} newValue New current tab name.
 * @param {string|undefined|null} oldValue Previous tab name.
 * @private
 */
MdNavBarController.prototype._updateTabs = function(newValue, oldValue) {
  var self = this;
  var tabs = this._getTabs();
  var sameTab = newValue === oldValue;

  // this._getTabs can return null if nav-bar has not yet been initialized
  if (!tabs) return;

  var newIndex = -1;
  var newTab = this._getTabByName(newValue);
  var oldTab = this._getTabByName(oldValue);

  if (oldTab) {
    oldTab.setSelected(false);
  }

  if (newTab) {
    newTab.setSelected(true);
    newIndex = tabs.indexOf(newTab);
  }

  this._$timeout(function() {
    self._updateInkBarStyles(newTab, newIndex);
    // Don't change focus when there is no newTab, the new and old tabs are the same, or when
    // called from MdNavBarController._initTabs() which would have no oldTab defined.
    if (newTab && oldTab && !sameTab) {
      self._moveFocus(oldTab, newTab);
    }
  });
};

/**
 * Repositions the ink bar to the selected tab.
 * @param {MdNavItemController} tab the nav item that should have ink bar styles applied
 * @param {number=} newIndex the index of the newly selected nav item
 * @private
 */
MdNavBarController.prototype._updateInkBarStyles = function(tab, newIndex) {
  this._inkbar.css({display: newIndex < 0 ? 'none' : ''});

  if (tab) {
    var tabEl = tab.getButtonEl();
    var left = tabEl.offsetLeft;
    var tabWidth = tabEl.offsetWidth;
    var navBarWidth = this._navBarEl.getBoundingClientRect().width;
    var scale = tabWidth / navBarWidth;
    var translate = left / navBarWidth * 100;

    this._inkbar.css({ transform: 'translateX(' + translate + '%) scaleX(' + scale + ')' });
  }
};

/**
 * Updates ink bar to match current tab.
 */
MdNavBarController.prototype.updateSelectedTabInkBar = function() {
  this._updateInkBarStyles(this._getSelectedTab());
};

/**
 * Returns an array of the current tabs.
 * @return {Array<!MdNavItemController>}
 * @private
 */
MdNavBarController.prototype._getTabs = function() {
  var controllers = Array.prototype.slice.call(
    this._navBarEl.querySelectorAll('.md-nav-item'))
    .map(function(el) {
      return angular.element(el).controller('mdNavItem');
    });
  return controllers.indexOf(undefined) ? controllers : [];
};

/**
 * Returns the tab with the specified name.
 * @param {string} name The name of the tab, found in its name attribute.
 * @return {MdNavItemController}
 * @private
 */
MdNavBarController.prototype._getTabByName = function(name) {
  return this._findTab(function(tab) {
    return tab.getName() === name;
  });
};

/**
 * Returns the selected tab.
 * @return {MdNavItemController}
 * @private
 */
MdNavBarController.prototype._getSelectedTab = function() {
  return this._findTab(function(tab) {
    return tab.isSelected();
  });
};

/**
 * Returns the focused tab.
 * @return {MdNavItemController}
 */
MdNavBarController.prototype.getFocusedTab = function() {
  return this._findTab(function(tab) {
    return tab.hasFocus();
  });
};

/**
 * Find a tab that matches the specified function, starting from the first tab.
 * @param {Function} fn
 * @param {number=} startIndex index to start at. Defaults to 0.
 * @returns {MdNavItemController|null}
 * @private
 */
MdNavBarController.prototype._findTab = function(fn, startIndex) {
  var tabs = this._getTabs(), i;
  if (startIndex == null) {
    startIndex = 0;
  }
  for (i = startIndex; i < tabs.length; i++) {
    if (fn(tabs[i])) {
      return tabs[i];
    }
  }
  return null;
};

/**
 * Find a tab that matches the specified function, going backwards from the end of the list.
 * @param {Function} fn
 * @param {number=} startIndex index to start at. Defaults to tabs.length - 1.
 * @returns {MdNavItemController}
 * @private
 */
MdNavBarController.prototype._findTabReverse = function(fn, startIndex) {
  var tabs = this._getTabs();
  if (startIndex === undefined || startIndex === null) {
    startIndex = tabs.length - 1;
  }
  for (var i = startIndex; i >= 0 ; i--) {
    if (fn(tabs[i])) {
      return tabs[i];
    }
  }
  return null;
};

/**
 * Direct focus to the selected tab when focus enters the nav bar.
 */
MdNavBarController.prototype.onFocus = function() {
  var tab = this._getSelectedTab();
  if (tab && !tab.isFocused) {
    tab.setFocused(true);
  }
};

/**
 * Move focus from oldTab to newTab.
 * @param {!MdNavItemController} oldTab
 * @param {!MdNavItemController} newTab
 * @private
 */
MdNavBarController.prototype._moveFocus = function(oldTab, newTab) {
  oldTab.setFocused(false);
  newTab.setFocused(true);
};

/**
 * Focus the first tab.
 * @private
 */
MdNavBarController.prototype._focusFirstTab = function() {
  var tabs = this._getTabs();
  if (!tabs) return;
  var tabToFocus = this._findTab(function(tab) {
    return tab._isEnabled();
  });
  if (tabToFocus) {
    this._moveFocus(this.getFocusedTab(), tabToFocus);
  }
};

/**
 * Focus the last tab.
 * @private
 */
MdNavBarController.prototype._focusLastTab = function() {
  var tabs = this._getTabs();
  if (!tabs) return;
  var tabToFocus = this._findTabReverse(function(tab) {
    return tab._isEnabled();
  });
  if (tabToFocus) {
    this._moveFocus(this.getFocusedTab(), tabToFocus);
  }
};

/**
 * Focus the next non-disabled tab.
 * @param {number} focusedTabIndex the index of the currently focused tab
 * @private
 */
MdNavBarController.prototype._focusNextTab = function(focusedTabIndex) {
  var tabs = this._getTabs();
  if (!tabs) return;
  var tabToFocus = this._findTab(function(tab) {
    return tab._isEnabled();
  }, focusedTabIndex + 1);
  if (tabToFocus) {
    this._moveFocus(this.getFocusedTab(), tabToFocus);
  } else {
    this._focusFirstTab();
  }
};

/**
 * Focus the previous non-disabled tab.
 * @param {number} focusedTabIndex the index of the currently focused tab
 * @private
 */
MdNavBarController.prototype._focusPreviousTab = function(focusedTabIndex) {
  var tabs = this._getTabs();
  if (!tabs) return;
  var tabToFocus = this._findTabReverse(function(tab) {
    return tab._isEnabled();
  }, focusedTabIndex - 1);
  if (tabToFocus) {
    this._moveFocus(this.getFocusedTab(), tabToFocus);
  } else {
    this._focusLastTab();
  }
};

/**
 * Responds to keydown events.
 * Calls to preventDefault() stop the page from scrolling when changing focus in the nav-bar.
 * @param {!KeyboardEvent} e
 */
MdNavBarController.prototype.onKeydown = function(e) {
  var keyCodes = this._$mdConstant.KEY_CODE;
  var tabs = this._getTabs();
  var focusedTab = this.getFocusedTab();
  if (!focusedTab || !tabs) return;

  var focusedTabIndex = tabs.indexOf(focusedTab);

  // use arrow keys to navigate between tabs
  switch (e.keyCode) {
    case keyCodes.UP_ARROW:
    case keyCodes.LEFT_ARROW:
      e.preventDefault();
      this._focusPreviousTab(focusedTabIndex);
      break;
    case keyCodes.DOWN_ARROW:
    case keyCodes.RIGHT_ARROW:
      e.preventDefault();
      this._focusNextTab(focusedTabIndex);
      break;
    case keyCodes.SPACE:
    case keyCodes.ENTER:
      // timeout to avoid a "digest already in progress" console error
      this._$timeout(function() {
        focusedTab.getButtonEl().click();
      });
      break;
    case keyCodes.HOME:
      e.preventDefault();
      this._focusFirstTab();
      break;
    case keyCodes.END:
      e.preventDefault();
      this._focusLastTab();
      break;
  }
};

/**
 * @ngdoc directive
 * @name mdNavItem
 * @module material.components.navBar
 *
 * @restrict E
 *
 * @description
 * `<md-nav-item>` describes a page navigation link within the `<md-nav-bar>` component.
 * It renders an `<md-button>` as the actual link.
 *
 * Exactly one of the `md-nav-click`, `md-nav-href`, or `md-nav-sref` attributes are required
 * to be specified.
 *
 * @param {string=} nav-item-aria-label Allows setting or overriding the label that is announced by
 *     a screen reader for the nav item's button. If this is not set, the nav item's transcluded
 *     content will be announced. Make sure to set this if the nav item's transcluded content does
 *     not include descriptive text, for example only an icon.
 * @param {expression=} md-nav-click Expression which will be evaluated when the
 *     link is clicked to change the page. Renders as an `ng-click`.
 * @param {string=} md-nav-href url to transition to when this link is clicked.
 *     Renders as an `ng-href`.
 * @param {string=} md-nav-sref UI-Router state to transition to when this link is
 *     clicked. Renders as a `ui-sref`.
 * @param {string} name The name of this link. Used by the nav bar to know
 *     which link is currently selected.
 * @param {!object=} sref-opts UI-Router options that are passed to the `$state.go()` function. See
 *     the <a ng-href="https://ui-router.github.io/docs/latest/interfaces/transition.transitionoptions.html"
 *     target="_blank">UI-Router documentation for details</a>.
 *
 * @usage
 * See <a ng-href="api/directive/mdNavBar">md-nav-bar</a> for usage.
 */
/**
 * @param $mdAria
 * @param $$rAF
 * @param $mdUtil
 * @param $window
 * @constructor
 * @ngInject
 */
function MdNavItem($mdAria, $$rAF, $mdUtil, $window) {
  return {
    restrict: 'E',
    require: ['mdNavItem', '^mdNavBar'],
    controller: MdNavItemController,
    bindToController: true,
    controllerAs: 'ctrl',
    replace: true,
    transclude: true,
    template: function(tElement, tAttrs) {
      var hasNavClick = tAttrs.mdNavClick;
      var hasNavHref = tAttrs.mdNavHref;
      var hasNavSref = tAttrs.mdNavSref;
      var hasSrefOpts = tAttrs.srefOpts;
      var navigationAttribute;
      var navigationOptions;
      var buttonTemplate;

      // Cannot specify more than one nav attribute
      if ((hasNavClick ? 1 : 0) + (hasNavHref ? 1 : 0) + (hasNavSref ? 1 : 0) > 1) {
        throw Error(
          'Please do not specify more than one of the md-nav-click, md-nav-href, ' +
          'or md-nav-sref attributes per nav-item directive.'
        );
      }

      if (hasNavClick !== undefined && hasNavClick !== null) {
        navigationAttribute = 'ng-click="ctrl.mdNavClick()"';
      } else if (hasNavHref !== undefined && hasNavHref !== null) {
        navigationAttribute = 'ng-href="{{ctrl.mdNavHref}}"';
      } else if (hasNavSref !== undefined && hasNavSref !== null) {
        navigationAttribute = 'ui-sref="{{ctrl.mdNavSref}}"';
      } else {
        throw Error(
          'Please specify at least one of the md-nav-click, md-nav-href, or md-nav-sref ' +
          'attributes per nav-item directive.');
      }

      navigationOptions = hasSrefOpts ? 'ui-sref-opts="{{ctrl.srefOpts}}" ' : '';

      if (navigationAttribute) {
        buttonTemplate = '' +
          '<md-button class="_md-nav-button md-accent" ' +
            'ng-class="ctrl.getNgClassMap()" ' +
            'ng-blur="ctrl.setFocused(false)" ' +
            'ng-disabled="ctrl.disabled" ' +
            'tabindex="-1" ' +
            'role="tab" ' +
            'ng-attr-aria-label="{{ctrl.navItemAriaLabel ? ctrl.navItemAriaLabel : undefined}}" ' +
            'aria-selected="{{ctrl.isSelected()}}" ' +
            navigationOptions +
            navigationAttribute + '>' +
            '<span ng-transclude class="_md-nav-button-text"></span>' +
          '</md-button>';
      }

      return '' +
        '<li class="md-nav-item" ' +
          'role="presentation">' +
          (buttonTemplate || '') +
        '</li>';
    },
    scope: {
      'mdNavClick': '&?',
      'mdNavHref': '@?',
      'mdNavSref': '@?',
      'srefOpts': '=?',
      'name': '@',
      'navItemAriaLabel': '@?',
    },
    link: function(scope, element, attrs, controllers) {
      var disconnect;
      var mdNavItem;
      var mdNavBar;
      var navButton;

      // When accessing the element's contents synchronously, they
      // may not be defined yet because of transclusion. There is a higher
      // chance that it will be accessible if we wait one frame.
      $$rAF(function() {
        mdNavItem = controllers[0];
        mdNavBar = controllers[1];
        navButton = angular.element(element[0].querySelector('._md-nav-button'));

        if (!mdNavItem.name) {
          mdNavItem.name = angular.element(element[0]
              .querySelector('._md-nav-button-text')).text().trim();
        }

        navButton.on('keydown', function($event) {
          mdNavBar.onKeydown($event);
        });

        navButton.on('focus', function() {
          mdNavItem._focused = true;
        });

        navButton.on('click', function() {
          // This triggers a watcher on mdNavBar.mdSelectedNavItem which calls
          // MdNavBarController._updateTabs() after a $timeout. That function calls
          // MdNavItemController.setSelected() for the old tab with false and the new tab with true.
          mdNavBar.mdSelectedNavItem = mdNavItem.name;
          scope.$apply();
        });

        // Get the disabled attribute value first, then setup observing of value changes
        mdNavItem.disabled = $mdUtil.parseAttributeBoolean(attrs['disabled'], false);
        if ('MutationObserver' in $window) {
          var config = {attributes: true, attributeFilter: ['disabled']};
          var targetNode = element[0];
          var mutationCallback = function(mutationList) {
            $mdUtil.nextTick(function() {
              mdNavItem.disabled = $mdUtil.parseAttributeBoolean(attrs[mutationList[0].attributeName], false);
            });
          };
          var observer = new MutationObserver(mutationCallback);
          observer.observe(targetNode, config);
          disconnect = observer.disconnect.bind(observer);
        } else {
          attrs.$observe('disabled', function (value) {
            mdNavItem.disabled = $mdUtil.parseAttributeBoolean(value, false);
          });
        }

        if (!mdNavItem.navItemAriaLabel) {
          $mdAria.expectWithText(navButton, 'aria-label');
        }
      });

      scope.$on('destroy', function() {
        navButton.off('keydown');
        navButton.off('focus');
        navButton.off('click');
        disconnect();
      });
    }
  };
}

/**
 * Controller for the nav-item component.
 * @param {!JQLite} $element
 * @constructor
 * @final
 * @ngInject
 */
function MdNavItemController($element) {

  /**
   * @private @const
   * @type {!JQLite}
   */
  this._$element = $element;

  // Data-bound variables

  /**
   * @const
   * @type {?Function}
   */
  this.mdNavClick;

  /**
   * @const
   * @type {?string}
   */
  this.mdNavHref;

  /**
   * @const
   * @type {?string}
   */
  this.mdNavSref;
  /**
   * @const
   * @type {?Object}
   */
  this.srefOpts;
  /**
   * @const
   * @type {?string}
   */
  this.name;

  /**
   * @const
   * @type {string}
   */
  this.navItemAriaLabel;

  // State variables
  /**
   * @private
   * @type {boolean}
   */
  this._selected = false;

  /**
   * @type {boolean}
   */
  this.isFocused = false;
}

/**
 * Returns a map of class names and values for use by ng-class.
 * @return {!Object<string,boolean>}
 */
MdNavItemController.prototype.getNgClassMap = function() {
  return {
    'md-active': this._selected,
    'md-primary': this._selected,
    'md-unselected': !this._selected,
    'md-focused': this.isFocused,
  };
};

/**
 * Get the name attribute of the tab.
 * @return {string}
 */
MdNavItemController.prototype.getName = function() {
  return this.name;
};

/**
 * Get the button element associated with the tab.
 * @return {!Element}
 */
MdNavItemController.prototype.getButtonEl = function() {
  return this._$element[0].querySelector('._md-nav-button');
};

/**
 * Set the selected state of the tab and updates the tabindex.
 * This function is called for the oldTab and newTab when selection changes.
 * @param {boolean} isSelected true to select the tab, false to deselect the tab
 */
MdNavItemController.prototype.setSelected = function(isSelected) {
  this._selected = isSelected;
  if (isSelected) {
    // https://www.w3.org/TR/wai-aria-practices/examples/tabs/tabs-2/tabs.html suggests that we call
    // removeAttribute('tabindex') here, but that causes our unit tests to fail due to
    // document.activeElement staying set to the body instead of the focused nav button.
    this.getButtonEl().setAttribute('tabindex', '0');
  } else {
    this.getButtonEl().setAttribute('tabindex', '-1');
  }
};

/**
 * @return {boolean}
 */
MdNavItemController.prototype.isSelected = function() {
  return this._selected;
};

/**
 * Set the focused state of the tab.
 * @param {boolean} isFocused
 */
MdNavItemController.prototype.setFocused = function(isFocused) {
  this.isFocused = isFocused;

  if (isFocused) {
    this.getButtonEl().focus();
  }
};

/**
 * @return {boolean} true if the tab has focus, false if not.
 */
MdNavItemController.prototype.hasFocus = function() {
  return this.isFocused;
};

/**
 * @return {boolean} true if the tab is enabled, false if disabled.
 * @private
 */
MdNavItemController.prototype._isEnabled = function() {
  return !this._$element.attr('disabled');
};

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.panel
 */
MdPanelService.$inject = ["presets", "$rootElement", "$rootScope", "$injector", "$window"];
angular
  .module('material.components.panel', [
    'material.core',
    'material.components.backdrop'
  ])
  .provider('$mdPanel', MdPanelProvider);


/*****************************************************************************
 *                            PUBLIC DOCUMENTATION                           *
 *****************************************************************************/


/**
 * @ngdoc service
 * @name $mdPanelProvider
 * @module material.components.panel
 *
 * @description
 * `$mdPanelProvider` allows users to create configuration presets that will be
 * stored within a cached presets object. When the configuration is needed, the
 * user can request the preset by passing it as the first parameter in the
 * `$mdPanel.create` or `$mdPanel.open` methods.
 *
 * @usage
 * <hljs lang="js">
 * (function(angular, undefined) {
 *   'use strict';
 *
 *   angular
 *       .module('demoApp', ['ngMaterial'])
 *       .config(DemoConfig)
 *       .controller('DemoCtrl', DemoCtrl)
 *       .controller('DemoMenuCtrl', DemoMenuCtrl);
 *
 *   function DemoConfig($mdPanelProvider) {
 *     $mdPanelProvider.definePreset('demoPreset', {
 *       attachTo: angular.element(document.body),
 *       controller: DemoMenuCtrl,
 *       controllerAs: 'ctrl',
 *       template: '' +
 *           '<div class="menu-panel" md-whiteframe="4">' +
 *           '  <div class="menu-content">' +
 *           '    <div class="menu-item" ng-repeat="item in ctrl.items">' +
 *           '      <button class="md-button">' +
 *           '        <span>{{item}}</span>' +
 *           '      </button>' +
 *           '    </div>' +
 *           '    <md-divider></md-divider>' +
 *           '    <div class="menu-item">' +
 *           '      <button class="md-button" ng-click="ctrl.closeMenu()">' +
 *           '        <span>Close Menu</span>' +
 *           '      </button>' +
 *           '    </div>' +
 *           '  </div>' +
 *           '</div>',
 *       panelClass: 'menu-panel-container',
 *       focusOnOpen: false,
 *       zIndex: 100,
 *       propagateContainerEvents: true,
 *       groupName: 'menus'
 *     });
 *   }
 *
 *   function PanelProviderCtrl($mdPanel) {
 *     this.navigation = {
 *       name: 'navigation',
 *       items: [
 *         'Home',
 *         'About',
 *         'Contact'
 *       ]
 *     };
 *     this.favorites = {
 *       name: 'favorites',
 *       items: [
 *         'Add to Favorites'
 *       ]
 *     };
 *     this.more = {
 *       name: 'more',
 *       items: [
 *         'Account',
 *         'Sign Out'
 *       ]
 *     };
 *
 *     $mdPanel.newPanelGroup('menus', {
 *       maxOpen: 2
 *     });
 *
 *     this.showMenu = function($event, menu) {
 *       $mdPanel.open('demoPreset', {
 *         id: 'menu_' + menu.name,
 *         position: $mdPanel.newPanelPosition()
 *             .relativeTo($event.target)
 *             .addPanelPosition(
 *               $mdPanel.xPosition.ALIGN_START,
 *               $mdPanel.yPosition.BELOW
 *             ),
 *         locals: {
 *           items: menu.items
 *         },
 *         openFrom: $event
 *       });
 *     };
 *   }
 *
 *   function PanelMenuCtrl(mdPanelRef) {
 *     // 'mdPanelRef' is injected in the controller.
 *     this.closeMenu = function() {
 *       if (mdPanelRef) {
 *         mdPanelRef.close();
 *       }
 *     };
 *   }
 * })(angular);
 * </hljs>
 */

/**
 * @ngdoc method
 * @name $mdPanelProvider#definePreset
 * @description
 * Takes the passed in preset name and preset configuration object and adds it
 * to the `_presets` object of the provider. This `_presets` object is then
 * passed along to the `$mdPanel` service.
 *
 * @param {string} name Preset name.
 * @param {!Object} preset Specific configuration object that can contain any
 *     and all of the parameters available within the `$mdPanel.create` method.
 *     However, parameters that pertain to id, position, animation, and user
 *     interaction are not allowed and will be removed from the preset
 *     configuration.
 */


/*****************************************************************************
 *                               MdPanel Service                             *
 *****************************************************************************/


/**
 * @ngdoc service
 * @name $mdPanel
 * @module material.components.panel
 *
 * @description
 * `$mdPanel` is a robust, low-level service for creating floating panels on
 * the screen. It can be used to implement tooltips, dialogs, pop-ups, etc.
 *
 * The following types, referenced below, have separate documentation:
 * - <a ng-href="api/type/MdPanelAnimation">MdPanelAnimation</a> from `$mdPanel.newPanelAnimation()`
 * - <a ng-href="api/type/MdPanelPosition">MdPanelPosition</a> from `$mdPanel.newPanelPosition()`
 * - <a ng-href="api/type/MdPanelRef">MdPanelRef</a> from the `$mdPanel.open()` Promise or
 * injected in the panel's controller
 *
 * @usage
 * <hljs lang="js">
 * (function(angular, undefined) {
 *   'use strict';
 *
 *   angular
 *       .module('demoApp', ['ngMaterial'])
 *       .controller('DemoDialogController', DialogController)
 *       .controller('DemoCtrl', function($mdPanel) {
 *
 *     var panelRef;
 *
 *     function showPanel($event) {
 *       var panelPosition = $mdPanel.newPanelPosition()
 *           .absolute()
 *           .top('50%')
 *           .left('50%');
 *
 *       var panelAnimation = $mdPanel.newPanelAnimation()
 *           .openFrom($event)
 *           .duration(200)
 *           .closeTo('.show-button')
 *           .withAnimation($mdPanel.animation.SCALE);
 *
 *       var config = {
 *         attachTo: angular.element(document.body),
 *         controller: DialogController,
 *         controllerAs: 'ctrl',
 *         position: panelPosition,
 *         animation: panelAnimation,
 *         targetEvent: $event,
 *         templateUrl: 'dialog-template.html',
 *         clickOutsideToClose: true,
 *         escapeToClose: true,
 *         focusOnOpen: true
 *       };
 *
 *       $mdPanel.open(config)
 *           .then(function(result) {
 *             panelRef = result;
 *           });
 *     }
 *   }
 *
 *   function DialogController(MdPanelRef) {
 *     function closeDialog() {
 *       if (MdPanelRef) MdPanelRef.close();
 *     }
 *   }
 * })(angular);
 * </hljs>
 */

/**
 * @ngdoc method
 * @name $mdPanel#create
 * @description
 * Creates a panel with the specified options.
 *
 * @param {!Object=} config Specific configuration object that may contain the
 *     following properties:
 *
 *   - `id` - `{string=}`: An ID to track the panel by. When an ID is provided,
 *     the created panel is added to a tracked panels object. Any subsequent
 *     requests made to create a panel with that ID are ignored. This is useful
 *     in having the panel service not open multiple panels from the same user
 *     interaction when there is no backdrop and events are propagated. Defaults
 *     to an arbitrary string that is not tracked.
 *   - `template` - `{string=}`: HTML template to show in the panel. This
 *     **must** be trusted HTML with respect to AngularJS’s
 *     [$sce service](https://docs.angularjs.org/api/ng/service/$sce).
 *   - `templateUrl` - `{string=}`: The URL that will be used as the content of
 *     the panel.
 *   - `contentElement` - `{(string|!JQLite|!Element)=}`: Pre-compiled
 *     element to be used as the panel's content.
 *   - `controller` - `{(function|string)=}`: The controller to associate with
 *     the panel. The controller can inject a reference to the returned
 *     panelRef, which allows the panel to be closed, hidden, and shown. Any
 *     fields passed in through locals or resolve will be bound to the
 *     controller.
 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on
 *     the scope.
 *   - `bindToController` - `{boolean=}`: Binds locals to the controller
 *     instead of passing them in. Defaults to true, as this is a best
 *     practice.
 *   - `locals` - `{Object=}`: An object containing key/value pairs. The keys
 *     will be used as names of values to inject into the controller. For
 *     example, `locals: {three: 3}` would inject `three` into the controller,
 *     with the value 3. 'mdPanelRef' is a reserved key, and will always
 *     be set to the created `MdPanelRef` instance.
 *   - `resolve` - `{Object=}`: Similar to locals, except it takes promises as
 *     values. The panel will not open until all of the promises resolve.
 *   - `attachTo` - `{(string|!JQLite|!Element)=}`: The element to
 *     attach the panel to. Defaults to appending to the root element of the
 *     application.
 *   - `propagateContainerEvents` - `{boolean=}`: Whether pointer or touch
 *     events should be allowed to propagate 'go through' the container, aka the
 *     wrapper, of the panel. Defaults to false.
 *   - `panelClass` - `{string=}`: A css class to apply to the panel element.
 *     This class should define any borders, box-shadow, etc. for the panel.
 *   - `zIndex` - `{number=}`: The z-index to place the panel at.
 *     Defaults to 80.
 *   - `position` - `{MdPanelPosition=}`: An MdPanelPosition object that
 *     specifies the alignment of the panel. For more information, see
 *     `MdPanelPosition`.
 *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click
 *     outside the panel to close it. Defaults to false.
 *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to
 *     close the panel. Defaults to false.
 *   - `onCloseSuccess` - `{function(!panelRef, string)=}`: Function that is
 *     called after the close successfully finishes. The first parameter passed
 *     into this function is the current panelRef and the 2nd is an optional
 *     string explaining the close reason. The currently supported closeReasons
 *     can be found in the `MdPanelRef.closeReasons` enum. These are by default
 *     passed along by the panel.
 *   - `trapFocus` - `{boolean=}`: Whether focus should be trapped within the
 *     panel. If `trapFocus` is true, the user will not be able to interact
 *     with the rest of the page until the panel is dismissed. Defaults to
 *     false.
 *   - `focusOnOpen` - `{boolean=}`: An option to override focus behavior on
 *     open. Only disable if focusing some other way, as focus management is
 *     required for panels to be accessible. Defaults to true.
 *   - `fullscreen` - `{boolean=}`: Whether the panel should be full screen.
 *     Applies the class `._md-panel-fullscreen` to the panel on open. Defaults
 *     to false.
 *   - `animation` - `{MdPanelAnimation=}`: An MdPanelAnimation object that
 *     specifies the animation of the panel. For more information, see
 *     `MdPanelAnimation`.
 *   - `hasBackdrop` - `{boolean=}`: Whether there should be an opaque backdrop
 *     behind the panel. Defaults to false.
 *   - `disableParentScroll` - `{boolean=}`: Whether the user can scroll the
 *     page behind the panel. Defaults to false.
 *   - `onDomAdded` - `{function=}`: Callback function used to announce when
 *     the panel is added to the DOM.
 *   - `onOpenComplete` - `{function=}`: Callback function used to announce
 *     when the open() action is finished.
 *   - `onRemoving` - `{function=}`: Callback function used to announce the
 *     close/hide() action is starting.
 *   - `onDomRemoved` - `{function=}`: Callback function used to announce when
 *     the panel is removed from the DOM.
 *   - `origin` - `{(string|!JQLite|!Element)=}`: The element to focus
 *     on when the panel closes. This is commonly the element which triggered
 *     the opening of the panel. If you do not use `origin`, you need to control
 *     the focus manually.
 *   - `groupName` - `{(string|!Array<string>)=}`: A group name or an array of
 *     group names. The group name is used for creating a group of panels. The
 *     group is used for configuring the number of open panels and identifying
 *     specific behaviors for groups. For instance, all tooltips could be
 *     identified using the same groupName.
 *
 * @returns {!MdPanelRef} panelRef
 */

/**
 * @ngdoc method
 * @name $mdPanel#open
 * @description
 * Calls the create method above, then opens the panel. This is a shortcut for
 * creating and then calling open manually. If custom methods need to be
 * called when the panel is added to the DOM or opened, do not use this method.
 * Instead create the panel, chain promises on the domAdded and openComplete
 * methods, and call open from the returned panelRef.
 *
 * @param {!Object=} config Specific configuration object that may contain
 *     the properties defined in `$mdPanel.create`.
 * @returns {!Q.IPromise<!MdPanelRef>} panelRef A promise that resolves
 *     to an instance of the panel.
 */

/**
 * @ngdoc method
 * @name $mdPanel#newPanelPosition
 * @description
 * Returns a new instance of the MdPanelPosition object. Use this to create
 * the position config object.
 *
 * @returns {!MdPanelPosition} panelPosition
 */

/**
 * @ngdoc method
 * @name $mdPanel#newPanelAnimation
 * @description
 * Returns a new instance of the MdPanelAnimation object. Use this to create
 * the animation config object.
 *
 * @returns {!MdPanelAnimation} panelAnimation
 */

/**
 * @ngdoc method
 * @name $mdPanel#setGroupMaxOpen
 * @description
 * Sets the maximum number of panels in a group that can be opened at a given
 * time.
 *
 * @param {string} groupName The name of the group to configure.
 * @param {number} maxOpen The maximum number of panels that can be
 *     opened. Infinity can be passed in to remove the maxOpen limit.
 */


/*****************************************************************************
 *                                 MdPanelRef                                *
 *****************************************************************************/


/**
 * @ngdoc type
 * @name MdPanelRef
 * @module material.components.panel
 * @description
 * A reference to a created panel. This reference contains a unique id for the
 * panel, along with the following properties:
 *
 *   - `id` - `{string}`: The unique id for the panel. This id is used to track
 *     when a panel was interacted with.
 *   - `config` - `{!Object=}`: The entire config object that was used in
 *     create.
 *   - `isAttached` - `{boolean}`: Whether the panel is attached to the DOM.
 *     Visibility to the user does not factor into isAttached.
 *   - `panelContainer` - `{JQLite}`: The wrapper element containing the
 *     panel. This property is added in order to have access to the `addClass`,
 *     `removeClass`, `toggleClass`, etc methods.
 *   - `panelEl` - `{JQLite}`: The panel element. This property is added
 *     in order to have access to the `addClass`, `removeClass`, `toggleClass`,
 *     etc methods.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#open
 * @description
 * Attaches and shows the panel.
 *
 * @returns {!Q.IPromise} A promise that is resolved when the panel is
 *     opened.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#close
 * @description
 * Hides and detaches the panel. Note that this will **not** destroy the panel.
 * If you don't intend on using the panel again, call the {@link #destroy
 * destroy} method afterwards.
 *
 * @returns {!Q.IPromise} A promise that is resolved when the panel is
 *     closed.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#attach
 * @description
 * Create the panel elements and attach them to the DOM. The panel will be
 * hidden by default.
 *
 * @returns {!Q.IPromise} A promise that is resolved when the panel is
 *     attached.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#detach
 * @description
 * Removes the panel from the DOM. This will NOT hide the panel before removing
 * it.
 *
 * @returns {!Q.IPromise} A promise that is resolved when the panel is
 *     detached.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#show
 * @description
 * Shows the panel.
 *
 * @returns {!Q.IPromise} A promise that is resolved when the panel has
 *     shown and animations are completed.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#hide
 * @description
 * Hides the panel.
 *
 * @returns {!Q.IPromise} A promise that is resolved when the panel has
 *     hidden and animations are completed.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#destroy
 * @description
 * Destroys the panel. The panel cannot be opened again after this is called.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#updatePosition
 * @description
 * Updates the position configuration of a panel. Use this to update the
 * position of a panel that is open, without having to close and re-open the
 * panel.
 *
 * @param {!MdPanelPosition} position
 */

/**
 * @ngdoc method
 * @name MdPanelRef#addToGroup
 * @description
 * Adds a panel to a group if the panel does not exist within the group already.
 * A panel can only exist within a single group.
 *
 * @param {string} groupName The name of the group to add the panel to.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#removeFromGroup
 * @description
 * Removes a panel from a group if the panel exists within that group. The group
 * must be created ahead of time.
 *
 * @param {string} groupName The name of the group.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#registerInterceptor
 * @description
 * Registers an interceptor with the panel. The callback should return a promise,
 * which will allow the action to continue when it gets resolved, or will
 * prevent an action if it is rejected. The interceptors are called sequentially
 * and it reverse order. `type` must be one of the following
 * values available on `$mdPanel.interceptorTypes`:
 * * `CLOSE` - Gets called before the panel begins closing.
 *
 * @param {string} type Type of interceptor.
 * @param {!Q.IPromise<any>} callback Callback to be registered.
 * @returns {!MdPanelRef}
 */

/**
 * @ngdoc method
 * @name MdPanelRef#removeInterceptor
 * @description
 * Removes a registered interceptor.
 *
 * @param {string} type Type of interceptor to be removed.
 * @param {function(): !Q.IPromise<any>} callback Interceptor to be removed.
 * @returns {!MdPanelRef}
 */

/**
 * @ngdoc method
 * @name MdPanelRef#removeAllInterceptors
 * @description
 * Removes all interceptors. If a type is supplied, only the
 * interceptors of that type will be cleared.
 *
 * @param {string=} type Type of interceptors to be removed.
 * @returns {!MdPanelRef}
 */

/**
 * @ngdoc method
 * @name MdPanelRef#updateAnimation
 * @description
 * Updates the animation configuration for a panel. You can use this to change
 * the panel's animation without having to re-create it.
 *
 * @param {!MdPanelAnimation} animation
 */


/*****************************************************************************
 *                               MdPanelPosition                            *
 *****************************************************************************/


/**
 * @ngdoc type
 * @name MdPanelPosition
 * @module material.components.panel
 * @description
 *
 * Object for configuring the position of the panel.
 *
 * @usage
 *
 * #### Centering the panel
 *
 * <hljs lang="js">
 * new MdPanelPosition().absolute().center();
 * </hljs>
 *
 * #### Overlapping the panel with an element
 *
 * <hljs lang="js">
 * new MdPanelPosition()
 *     .relativeTo(someElement)
 *     .addPanelPosition(
 *       $mdPanel.xPosition.ALIGN_START,
 *       $mdPanel.yPosition.ALIGN_TOPS
 *     );
 * </hljs>
 *
 * #### Aligning the panel with the bottom of an element
 *
 * <hljs lang="js">
 * new MdPanelPosition()
 *     .relativeTo(someElement)
 *     .addPanelPosition($mdPanel.xPosition.CENTER, $mdPanel.yPosition.BELOW);
 * </hljs>
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#absolute
 * @description
 * Positions the panel absolutely relative to the parent element. If the parent
 * is document.body, this is equivalent to positioning the panel absolutely
 * within the viewport.
 *
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#relativeTo
 * @description
 * Positions the panel relative to a specific element.
 *
 * @param {string|!Element|!JQLite} element Query selector, DOM element,
 *     or angular element to position the panel with respect to.
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#top
 * @description
 * Sets the value of `top` for the panel. Clears any previously set vertical
 * position.
 *
 * @param {string=} top Value of `top`. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#bottom
 * @description
 * Sets the value of `bottom` for the panel. Clears any previously set vertical
 * position.
 *
 * @param {string=} bottom Value of `bottom`. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#start
 * @description
 * Sets the panel to the start of the page - `left` if `ltr` or `right` for
 * `rtl`. Clears any previously set horizontal position.
 *
 * @param {string=} start Value of position. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#end
 * @description
 * Sets the panel to the end of the page - `right` if `ltr` or `left` for `rtl`.
 * Clears any previously set horizontal position.
 *
 * @param {string=} end Value of position. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#left
 * @description
 * Sets the value of `left` for the panel. Clears any previously set
 * horizontal position.
 *
 * @param {string=} left Value of `left`. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#right
 * @description
 * Sets the value of `right` for the panel. Clears any previously set
 * horizontal position.
 *
 * @param {string=} right Value of `right`. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#centerHorizontally
 * @description
 * Centers the panel horizontally in the viewport. Clears any previously set
 * horizontal position.
 *
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#centerVertically
 * @description
 * Centers the panel vertically in the viewport. Clears any previously set
 * vertical position.
 *
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#center
 * @description
 * Centers the panel horizontally and vertically in the viewport. This is
 * equivalent to calling both `centerHorizontally` and `centerVertically`.
 * Clears any previously set horizontal and vertical positions.
 *
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#addPanelPosition
 * @description
 * Sets the x and y position for the panel relative to another element. Can be
 * called multiple times to specify an ordered list of panel positions. The
 * first position which allows the panel to be completely on-screen will be
 * chosen; the last position will be chose whether it is on-screen or not.
 *
 * xPosition must be one of the following values available on
 * $mdPanel.xPosition:
 *
 *
 * CENTER | ALIGN_START | ALIGN_END | OFFSET_START | OFFSET_END
 *
 * <pre>
 *    *************
 *    *           *
 *    *   PANEL   *
 *    *           *
 *    *************
 *   A B    C    D E
 *
 * A: OFFSET_START (for LTR displays)
 * B: ALIGN_START (for LTR displays)
 * C: CENTER
 * D: ALIGN_END (for LTR displays)
 * E: OFFSET_END (for LTR displays)
 * </pre>
 *
 * yPosition must be one of the following values available on
 * $mdPanel.yPosition:
 *
 * CENTER | ALIGN_TOPS | ALIGN_BOTTOMS | ABOVE | BELOW
 *
 * <pre>
 *   F
 *   G *************
 *     *           *
 *   H *   PANEL   *
 *     *           *
 *   I *************
 *   J
 *
 * F: BELOW
 * G: ALIGN_TOPS
 * H: CENTER
 * I: ALIGN_BOTTOMS
 * J: ABOVE
 * </pre>
 *
 * @param {string} xPosition
 * @param {string} yPosition
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#withOffsetX
 * @description
 * Sets the value of the offset in the x-direction.
 *
 * @param {string|number} offsetX
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#withOffsetY
 * @description
 * Sets the value of the offset in the y-direction.
 *
 * @param {string|number} offsetY
 * @returns {!MdPanelPosition}
 */


/*****************************************************************************
 *                               MdPanelAnimation                            *
 *****************************************************************************/


/**
 * @ngdoc type
 * @name MdPanelAnimation
 * @module material.components.panel
 * @description
 * Animation configuration object. To use, create an MdPanelAnimation with the
 * desired properties, then pass the object as part of $mdPanel creation.
 *
 * @usage
 *
 * <hljs lang="js">
 * var panelAnimation = new MdPanelAnimation()
 *     .openFrom(myButtonEl)
 *     .duration(1337)
 *     .closeTo('.my-button')
 *     .withAnimation($mdPanel.animation.SCALE);
 *
 * $mdPanel.create({
 *   animation: panelAnimation
 * });
 * </hljs>
 */

/**
 * @ngdoc method
 * @name MdPanelAnimation#openFrom
 * @description
 * Specifies where to start the open animation. `openFrom` accepts a
 * click event object, query selector, DOM element, or a Rect object that
 * is used to determine the bounds. When passed a click event, the location
 * of the click will be used as the position to start the animation.
 *
 * @param {string|!Element|!Event|{top: number, left: number}}
 * @returns {!MdPanelAnimation}
 */

/**
 * @ngdoc method
 * @name MdPanelAnimation#closeTo
 * @description
 * Specifies where to animate the panel close. `closeTo` accepts a
 * query selector, DOM element, or a Rect object that is used to determine
 * the bounds.
 *
 * @param {string|!Element|{top: number, left: number}}
 * @returns {!MdPanelAnimation}
 */

/**
 * @ngdoc method
 * @name MdPanelAnimation#withAnimation
 * @description
 * Specifies the animation class.
 *
 * There are several default animations that can be used: `$mdPanel.animation.`
 *  - `SLIDE`: The panel slides in and out from the specified
 *       elements. It will not fade in or out.
 *  - `SCALE`: The panel scales in and out. Slide and fade are
 *       included in this animation.
 *  - `FADE`: The panel fades in and out.
 *
 * Custom classes will by default fade in and out unless
 * `transition: opacity 1ms` is added to the to custom class.
 *
 * @param {string|{open: string, close: string}} cssClass
 * @returns {!MdPanelAnimation}
 */

/**
 * @ngdoc method
 * @name MdPanelAnimation#duration
 * @description
 * Specifies the duration of the animation in milliseconds. The `duration`
 * method accepts either a number or an object with separate open and close
 * durations.
 *
 * @param {number|{open: number, close: number}} duration
 * @returns {!MdPanelAnimation}
 */


/*****************************************************************************
 *                            PUBLIC DOCUMENTATION                           *
 *****************************************************************************/


var MD_PANEL_Z_INDEX = 80;
var MD_PANEL_HIDDEN = '_md-panel-hidden';
var FOCUS_TRAP_TEMPLATE;

var _presets = {};


/**
 * A provider that is used for creating presets for the panel API.
 * @final @constructor @ngInject
 */
function MdPanelProvider() {
  return {
    'definePreset': definePreset,
    'getAllPresets': getAllPresets,
    'clearPresets': clearPresets,
    '$get': $getProvider()
  };
}


/**
 * Takes the passed in panel configuration object and adds it to the `_presets`
 * object at the specified name.
 * @param {string} name Name of the preset to set.
 * @param {!Object} preset Specific configuration object that can contain any
 *     and all of the parameters available within the `$mdPanel.create` method.
 *     However, parameters that pertain to id, position, animation, and user
 *     interaction are not allowed and will be removed from the preset
 *     configuration.
 */
function definePreset(name, preset) {
  if (!name || !preset) {
    throw new Error('mdPanelProvider: The panel preset definition is ' +
        'malformed. The name and preset object are required.');
  } else if (_presets.hasOwnProperty(name)) {
    throw new Error('mdPanelProvider: The panel preset you have requested ' +
        'has already been defined.');
  }

  // Delete any property on the preset that is not allowed.
  delete preset.id;
  delete preset.position;
  delete preset.animation;

  _presets[name] = preset;
}


/**
 * Gets a clone of the `_presets`.
 * @return {!Object}
 */
function getAllPresets() {
  return angular.copy(_presets);
}


/**
 * Clears all of the stored presets.
 */
function clearPresets() {
  _presets = {};
}


/**
 * Represents the `$get` method of the AngularJS provider. From here, a new
 * reference to the MdPanelService is returned where the needed arguments are
 * passed in including the MdPanelProvider `_presets`.
 * @param {!Object} _presets
 * @param {!JQLite} $rootElement
 * @param {!angular.Scope} $rootScope
 * @param {!IInjectorService} $injector
 * @param {!IWindowService} $window
 */
function $getProvider() {
  return [
    '$rootElement', '$rootScope', '$injector', '$window',
    function($rootElement, $rootScope, $injector, $window) {
      return new MdPanelService(_presets, $rootElement, $rootScope,
          $injector, $window);
    }
  ];
}

/**
 * @param {string|[]} value
 * @returns {[]} the input string wrapped in an Array or the original Array
 */
function coerceToArray(value) {
  if (angular.isString(value)) {
    value = [value];
  }
  return value;
}

/*****************************************************************************
 *                               MdPanel Service                             *
 *****************************************************************************/


/**
 * A service that is used for controlling/displaying panels on the screen.
 * @param {!Object} presets
 * @param {!JQLite} $rootElement
 * @param {!angular.Scope} $rootScope
 * @param {!IInjectorService} $injector
 * @param {!IWindowService} $window
 * @final @constructor @ngInject
 */
function MdPanelService(presets, $rootElement, $rootScope, $injector, $window) {
  /**
   * Default config options for the panel.
   * Anything angular related needs to be done later. Therefore
   *     scope: $rootScope.$new(true),
   *     attachTo: $rootElement,
   * are added later.
   * @private {!Object}
   */
  this._defaultConfigOptions = {
    bindToController: true,
    clickOutsideToClose: false,
    disableParentScroll: false,
    escapeToClose: false,
    focusOnOpen: true,
    fullscreen: false,
    hasBackdrop: false,
    propagateContainerEvents: false,
    transformTemplate: angular.bind(this, this._wrapTemplate),
    trapFocus: false,
    zIndex: MD_PANEL_Z_INDEX
  };

  /** @private {!Object} */
  this._config = {};

  /** @private {!Object} */
  this._presets = presets;

  /** @private @const */
  this._$rootElement = $rootElement;

  /** @private @const */
  this._$rootScope = $rootScope;

  /** @private @const */
  this._$injector = $injector;

  /** @private @const */
  this._$window = $window;

  /** @private @const */
  this._$mdUtil = this._$injector.get('$mdUtil');

  /** @private {!Object<string, !MdPanelRef>} */
  this._trackedPanels = {};

  /**
   * @private {!Object<string,
   *     {panels: !Array<!MdPanelRef>,
   *     openPanels: !Array<!MdPanelRef>,
   *     maxOpen: number}>}
   */
  this._groups = Object.create(null);

  /**
   * Default animations that can be used within the panel.
   * @type {enum}
   */
  this.animation = MdPanelAnimation.animation;

  /**
   * Possible values of xPosition for positioning the panel relative to
   * another element.
   * @type {enum}
   */
  this.xPosition = MdPanelPosition.xPosition;

  /**
   * Possible values of yPosition for positioning the panel relative to
   * another element.
   * @type {enum}
   */
  this.yPosition = MdPanelPosition.yPosition;

  /**
   * Possible values for the interceptors that can be registered on a panel.
   * @type {enum}
   */
  this.interceptorTypes = MdPanelRef.interceptorTypes;

  /**
   * Possible values for closing of a panel.
   * @type {enum}
   */
  this.closeReasons = MdPanelRef.closeReasons;

  /**
   * Possible values of absolute position.
   * @type {enum}
   */
  this.absPosition = MdPanelPosition.absPosition;
}


/**
 * Creates a panel with the specified options.
 * @param {string|Object=} preset Name of a preset configuration that can be used to
 *     extend the panel configuration.
 * @param {!Object=} config Configuration object for the panel.
 * @returns {!MdPanelRef}
 */
MdPanelService.prototype.create = function(preset, config) {
  if (typeof preset === 'string') {
    preset = this._getPresetByName(preset);
  } else if (typeof preset === 'object' &&
      (angular.isUndefined(config) || !config)) {
    config = preset;
    preset = {};
  }

  preset = preset || {};
  config = config || {};

  // If the passed-in config contains an ID and the ID is within _trackedPanels,
  // return the tracked panel after updating its config with the passed-in
  // config.
  if (angular.isDefined(config.id) && this._trackedPanels[config.id]) {
    var trackedPanel = this._trackedPanels[config.id];
    angular.extend(trackedPanel.config, config);
    return trackedPanel;
  }

  // Combine the passed-in config, the _defaultConfigOptions, and the preset
  // configuration into the `_config`.
  this._config = angular.extend({
    // If no ID is set within the passed-in config, then create an arbitrary ID.
    id: config.id || 'panel_' + this._$mdUtil.nextUid(),
    scope: this._$rootScope.$new(true),
    attachTo: this._$rootElement
  }, this._defaultConfigOptions, config, preset);

  // Create the panelRef and add it to the `_trackedPanels` object.
  var panelRef = new MdPanelRef(this._config, this._$injector);
  this._trackedPanels[this._config.id] = panelRef;

  // Add the panel to each of its requested groups.
  if (this._config.groupName) {
    this._config.groupName = coerceToArray(this._config.groupName);
    angular.forEach(this._config.groupName, function(group) {
      panelRef.addToGroup(group);
    });
  }

  this._config.scope.$on('$destroy', angular.bind(panelRef, panelRef.detach));

  return panelRef;
};


/**
 * Creates and opens a panel with the specified options.
 * @param {string=} preset Name of a preset configuration that can be used to
 *     extend the panel configuration.
 * @param {!Object=} config Configuration object for the panel.
 * @returns {!Q.IPromise<!MdPanelRef>} The panel created from create.
 */
MdPanelService.prototype.open = function(preset, config) {
  var panelRef = this.create(preset, config);
  return panelRef.open().then(function() {
    return panelRef;
  });
};


/**
 * Gets a specific preset configuration object saved within `_presets`.
 * @param {string} preset Name of the preset to search for.
 * @returns {!Object} The preset configuration object.
 */
MdPanelService.prototype._getPresetByName = function(preset) {
  if (!this._presets[preset]) {
    throw new Error('mdPanel: The panel preset configuration that you ' +
        'requested does not exist. Use the $mdPanelProvider to create a ' +
        'preset before requesting one.');
  }
  return this._presets[preset];
};


/**
 * Returns a new instance of the MdPanelPosition. Use this to create the
 * positioning object.
 * @returns {!MdPanelPosition}
 */
MdPanelService.prototype.newPanelPosition = function() {
  return new MdPanelPosition(this._$injector);
};


/**
 * Returns a new instance of the MdPanelAnimation. Use this to create the
 * animation object.
 * @returns {!MdPanelAnimation}
 */
MdPanelService.prototype.newPanelAnimation = function() {
  return new MdPanelAnimation(this._$injector);
};


/**
 * @ngdoc method
 * @name $mdPanel#newPanelGroup
 * @description
 * Creates a panel group and adds it to a tracked list of panel groups.
 * @param {string} groupName Name of the group to create.
 * @param {{maxOpen: number}=} config Configuration object that may contain the following
 *  properties:
 *
 *   - `maxOpen`: The maximum number of panels that are allowed open within a defined panel group.
 *
 * @returns {!{panels: !Array<!MdPanelRef>, openPanels: !Array<!MdPanelRef>, maxOpen: number}}
 *  the new panel group
 */
MdPanelService.prototype.newPanelGroup = function(groupName, config) {
  if (!this._groups[groupName]) {
    config = config || {};
    this._groups[groupName] = {
      panels: [],
      openPanels: [],
      maxOpen: config.maxOpen > 0 ? config.maxOpen : Infinity
    };
  }
  return this._groups[groupName];
};


/**
 * Sets the maximum number of panels in a group that can be opened at a given
 * time.
 * @param {string} groupName The name of the group to configure.
 * @param {number} maxOpen The maximum number of panels that can be
 *     opened. Infinity can be passed in to remove the maxOpen limit.
 */
MdPanelService.prototype.setGroupMaxOpen = function(groupName, maxOpen) {
  if (this._groups[groupName]) {
    this._groups[groupName].maxOpen = maxOpen;
  } else {
    throw new Error('mdPanel: Group does not exist yet. Call newPanelGroup().');
  }
};


/**
 * Determines if the current number of open panels within a group exceeds the
 * limit of allowed open panels.
 * @param {string} groupName The name of the group to check.
 * @returns {boolean} true if open count does exceed maxOpen and false if not.
 * @private
 */
MdPanelService.prototype._openCountExceedsMaxOpen = function(groupName) {
  if (this._groups[groupName]) {
    var group = this._groups[groupName];
    return group.maxOpen > 0 && group.openPanels.length > group.maxOpen;
  }
  return false;
};


/**
 * Closes the first open panel within a specific group.
 * @param {string} groupName The name of the group.
 * @private
 */
MdPanelService.prototype._closeFirstOpenedPanel = function(groupName) {
  var group = this._groups[groupName];
  if (group && group.openPanels.length) {
    group.openPanels[0].close();
  }
};


/**
 * Wraps the user's template in three elements:
 * - md-panel-outer-wrapper - covers the entire `attachTo` element.
 * - md-panel-inner-wrapper - handles the positioning.
 * - md-panel - contains the user's content and deals with the animations.
 * @param {string} origTemplate The original template.
 * @returns {string} The wrapped template.
 * @private
 */
MdPanelService.prototype._wrapTemplate = function(origTemplate) {
  var template = origTemplate || '';

  // The panel should be initially rendered offscreen so we can calculate
  // height and width for positioning.
  return '' +
      '<div class="md-panel-outer-wrapper">' +
        '<div class="md-panel-inner-wrapper _md-panel-offscreen">' +
          '<div class="md-panel _md-panel-offscreen">' + template + '</div>' +
        '</div>' +
      '</div>';
};


/**
 * Wraps a content element in a `md-panel-outer-wrapper`, as well as
 * a `md-panel-inner-wrapper`, and positions it off-screen. Allows for
 * proper control over positioning and animations.
 * @param {!JQLite} contentElement Element to be wrapped.
 * @return {!JQLite} Wrapper element.
 * @private
 */
MdPanelService.prototype._wrapContentElement = function(contentElement) {
  var outerWrapper = angular.element(
    '<div class="md-panel-outer-wrapper">' +
      '<div class="md-panel-inner-wrapper _md-panel-offscreen"></div>' +
    '</div>'
  );

  contentElement.addClass('md-panel _md-panel-offscreen');
  outerWrapper.children().eq(0).append(contentElement);

  return outerWrapper;
};


/*****************************************************************************
 *                                 MdPanelRef                                *
 *****************************************************************************/


/**
 * A reference to a created panel. This reference contains a unique id for the
 * panel, along with properties/functions used to control the panel.
 * @param {!Object} config
 * @param {!IInjectorService} $injector
 * @final @constructor
 */
function MdPanelRef(config, $injector) {
  // Injected variables.
  /** @private @const {!IQService} */
  this._$q = $injector.get('$q');

  /** @private @const {!angular.$mdCompiler} */
  this._$mdCompiler = $injector.get('$mdCompiler');

  /** @private @const {!angular.$mdConstant} */
  this._$mdConstant = $injector.get('$mdConstant');

  /** @private @const {!angular.$mdUtil} */
  this._$mdUtil = $injector.get('$mdUtil');

  /** @private @const {!angular.$mdTheming} */
  this._$mdTheming = $injector.get('$mdTheming');

  /** @private @const {!IRootScopeService} */
  this._$rootScope = $injector.get('$rootScope');

  /** @private @const {!angular.$animate} */
  this._$animate = $injector.get('$animate');

  /** @private @const {!MdPanelRef} */
  this._$mdPanel = $injector.get('$mdPanel');

  /** @private @const {!ILogService} */
  this._$log = $injector.get('$log');

  /** @private @const {!IWindowService} */
  this._$window = $injector.get('$window');

  /** @private @const {!Function} */
  this._$$rAF = $injector.get('$$rAF');

  // Public variables.
  /**
   * Unique id for the panelRef.
   * @type {string}
   */
  this.id = config.id;

  /** @type {!Object} */
  this.config = config;

  /** @type {!JQLite|undefined} */
  this.panelContainer = undefined;

  /** @type {!JQLite|undefined} */
  this.panelEl = undefined;

  /** @type {!JQLite|undefined} */
  this.innerWrapper = undefined;

  /**
   * Whether the panel is attached. This is synchronous. When attach is called,
   * isAttached is set to true. When detach is called, isAttached is set to
   * false.
   * @type {boolean}
   */
  this.isAttached = false;

  // Private variables.
  /** @private {Array<function()>} */
  this._removeListeners = [];

  /** @private {!JQLite|undefined} */
  this._topFocusTrap = undefined;

  /** @private {!JQLite|undefined} */
  this._bottomFocusTrap = undefined;

  /** @private {!$mdPanel|undefined} */
  this._backdropRef = undefined;

  /** @private {Function?} */
  this._restoreScroll = null;

  /**
   * Keeps track of all the panel interceptors.
   * @private {!Object}
   */
  this._interceptors = Object.create(null);

  /**
   * Cleanup function, provided by `$mdCompiler` and assigned after the element
   * has been compiled. When `contentElement` is used, the function is used to
   * restore the element to it's proper place in the DOM.
   * @private {Function|null}
   */
  this._compilerCleanup = null;

  /**
   * Cache for saving and restoring element inline styles, CSS classes etc.
   * @type {{styles: string, classes: string}}
   */
  this._restoreCache = {
    styles: '',
    classes: ''
  };
}


MdPanelRef.interceptorTypes = {
  CLOSE: 'onClose'
};


/**
 * Opens an already created and configured panel. If the panel is already
 * visible, does nothing.
 * @returns {!Q.IPromise<!MdPanelRef>} A promise that is resolved when
 *     the panel is opened and animations finish.
 */
MdPanelRef.prototype.open = function() {
  var self = this;
  return this._$q(function(resolve, reject) {
    var done = self._done(resolve, self);
    var show = self._simpleBind(self.show, self);
    var checkGroupMaxOpen = function() {
      if (self.config.groupName) {
        self.config.groupName = coerceToArray(self.config.groupName);
        angular.forEach(self.config.groupName, function(group) {
          if (self._$mdPanel._openCountExceedsMaxOpen(group)) {
            self._$mdPanel._closeFirstOpenedPanel(group);
          }
        });
      }
    };

    self.attach()
        .then(show)
        .then(checkGroupMaxOpen)
        .then(done)
        .catch(reject);
  });
};


/**
 * Closes the panel.
 * @param {string} closeReason The event type that triggered the close.
 * @returns {!Q.IPromise<!MdPanelRef>} A promise that is resolved when
 *     the panel is closed and animations finish.
 */
MdPanelRef.prototype.close = function(closeReason) {
  var self = this;

  return this._$q(function(resolve, reject) {
    self._callInterceptors(MdPanelRef.interceptorTypes.CLOSE).then(function() {
      var done = self._done(resolve, self);
      var detach = self._simpleBind(self.detach, self);
      var onCloseSuccess = self.config['onCloseSuccess'] || angular.noop;
      onCloseSuccess = angular.bind(self, onCloseSuccess, self, closeReason);

      self.hide()
          .then(detach)
          .then(done)
          .then(onCloseSuccess)
          .catch(reject);
    }, reject);
  });
};


/**
 * Attaches the panel. The panel will be hidden afterwards.
 * @returns {!Q.IPromise<!MdPanelRef>} A promise that is resolved when
 *     the panel is attached.
 */
MdPanelRef.prototype.attach = function() {
  if (this.isAttached && this.panelEl) {
    return this._$q.when(this);
  }

  var self = this;
  return this._$q(function(resolve, reject) {
    var done = self._done(resolve, self);
    var onDomAdded = self.config['onDomAdded'] || angular.noop;
    var addListeners = function(response) {
      self.isAttached = true;
      self._addEventListeners();
      return response;
    };

    self._$q.all([
        self._createBackdrop(),
        self._createPanel()
            .then(addListeners)
            .catch(reject)
    ]).then(onDomAdded)
      .then(done)
      .catch(reject);
  });
};


/**
 * Only detaches the panel. Will NOT hide the panel first.
 * @returns {!Q.IPromise<!MdPanelRef>} A promise that is resolved when
 *     the panel is detached.
 */
MdPanelRef.prototype.detach = function() {
  if (!this.isAttached) {
    return this._$q.when(this);
  }

  var self = this;
  var onDomRemoved = self.config['onDomRemoved'] || angular.noop;

  var detachFn = function() {
    self._removeEventListeners();

    // Remove the focus traps that we added earlier for keeping focus within
    // the panel.
    if (self._topFocusTrap && self._topFocusTrap.parentNode) {
      self._topFocusTrap.parentNode.removeChild(self._topFocusTrap);
    }

    if (self._bottomFocusTrap && self._bottomFocusTrap.parentNode) {
      self._bottomFocusTrap.parentNode.removeChild(self._bottomFocusTrap);
    }

    if (self._restoreCache.classes) {
      self.panelEl[0].className = self._restoreCache.classes;
    }

    // Either restore the saved styles or clear the ones set by mdPanel.
    self.panelEl[0].style.cssText = self._restoreCache.styles || '';

    self._compilerCleanup();
    self.panelContainer.remove();
    self.isAttached = false;
    return self._$q.when(self);
  };

  if (this._restoreScroll) {
    this._restoreScroll();
    this._restoreScroll = null;
  }

  return this._$q(function(resolve, reject) {
    var done = self._done(resolve, self);

    self._$q.all([
      detachFn(),
      self._backdropRef ? self._backdropRef.detach() : true
    ]).then(onDomRemoved)
      .then(done)
      .catch(reject);
  });
};


/**
 * Destroys the panel. The Panel cannot be opened again after this.
 */
MdPanelRef.prototype.destroy = function() {
  var self = this;
  if (this.config.groupName) {
    this.config.groupName = coerceToArray(this.config.groupName);
    angular.forEach(this.config.groupName, function(group) {
      self.removeFromGroup(group);
    });
  }
  this.config.scope.$destroy();
  this.config.locals = null;
  this.config.onDomAdded = null;
  this.config.onDomRemoved = null;
  this.config.onRemoving = null;
  this.config.onOpenComplete = null;
  this._interceptors = undefined;
};


/**
 * Shows the panel.
 * @returns {!Q.IPromise<!MdPanelRef>} A promise that is resolved when
 *     the panel has shown and animations finish.
 */
MdPanelRef.prototype.show = function() {
  if (!this.panelContainer) {
    return this._$q(function(resolve, reject) {
      reject('mdPanel: Panel does not exist yet. Call open() or attach().');
    });
  }

  if (!this.panelContainer.hasClass(MD_PANEL_HIDDEN)) {
    return this._$q.when(this);
  }

  var self = this;
  var animatePromise = function() {
    self.panelContainer.removeClass(MD_PANEL_HIDDEN);
    return self._animateOpen();
  };

  return this._$q(function(resolve, reject) {
    var done = self._done(resolve, self);
    var onOpenComplete = self.config['onOpenComplete'] || angular.noop;
    var addToGroupOpen = function() {
      if (self.config.groupName) {
        self.config.groupName = coerceToArray(self.config.groupName);
        angular.forEach(self.config.groupName, function(group) {
          group = self._$mdPanel._groups[group];
          if (group) {
            group.openPanels.push(self);
          }
        });
      }
    };

    self._$q.all([
      self._backdropRef ? self._backdropRef.show() : self,
      animatePromise().then(function() { self._focusOnOpen(); }, reject)
    ]).then(onOpenComplete)
      .then(addToGroupOpen)
      .then(done)
      .catch(reject);
  });
};


/**
 * Hides the panel.
 * @returns {!Q.IPromise<!MdPanelRef>} A promise that is resolved when
 *     the panel has hidden and animations finish.
 */
MdPanelRef.prototype.hide = function() {
  if (!this.panelContainer) {
    return this._$q(function(resolve, reject) {
      reject('mdPanel: Panel does not exist yet. Call open() or attach().');
    });
  }

  if (this.panelContainer.hasClass(MD_PANEL_HIDDEN)) {
    return this._$q.when(this);
  }

  var self = this;

  return this._$q(function(resolve, reject) {
    var done = self._done(resolve, self);
    var onRemoving = self.config['onRemoving'] || angular.noop;
    var hidePanel = function() {
      self.panelContainer.addClass(MD_PANEL_HIDDEN);
    };
    var removeFromGroupOpen = function() {
      if (self.config.groupName) {
        var index;
        self.config.groupName = coerceToArray(self.config.groupName);
        angular.forEach(self.config.groupName, function(group) {
          group = self._$mdPanel._groups[group];
          index = group.openPanels.indexOf(self);
          if (index > -1) {
            group.openPanels.splice(index, 1);
          }
        });
      }
    };
    var focusOnOrigin = function() {
      var origin = self.config['origin'];
      if (origin) {
        getElement(origin).focus();
      }
    };

    self._$q.all([
      self._backdropRef ? self._backdropRef.hide() : self,
      self._animateClose()
          .then(onRemoving)
          .then(hidePanel)
          .then(removeFromGroupOpen)
          .then(focusOnOrigin)
          .catch(reject)
    ]).then(done, reject);
  });
};

/**
 * Compiles the panel, according to the passed in config and appends it to
 * the DOM. Helps normalize differences in the compilation process between
 * using a string template and a content element.
 * @returns {!Q.IPromise<!MdPanelRef>} Promise that is resolved when
 *     the element has been compiled and added to the DOM.
 * @private
 */
MdPanelRef.prototype._compile = function() {
  var self = this;

  // Compile the element via $mdCompiler. Note that when using a
  // contentElement, the element isn't actually being compiled, rather the
  // compiler saves it's place in the DOM and provides a way of restoring it.
  return self._$mdCompiler.compile(self.config).then(function(compileData) {
    var config = self.config;

    if (config.contentElement) {
      var panelEl = compileData.element;

      // Since mdPanel modifies the inline styles and CSS classes, we need
      // to save them in order to be able to restore on close.
      self._restoreCache.styles = panelEl[0].style.cssText;
      self._restoreCache.classes = panelEl[0].className;

      self.panelContainer = self._$mdPanel._wrapContentElement(panelEl);
      self.panelEl = panelEl;
    } else {
      self.panelContainer = compileData.link(config['scope']);
      self.panelEl = angular.element(
        self.panelContainer[0].querySelector('.md-panel')
      );
    }

    // Save a reference to the inner wrapper.
    self.innerWrapper = angular.element(
      self.panelContainer[0].querySelector('.md-panel-inner-wrapper')
    );

    // Save a reference to the cleanup function from the compiler.
    self._compilerCleanup = compileData.cleanup;

    // Attach the panel to the proper place in the DOM.
    getElement(self.config['attachTo']).append(self.panelContainer);

    return self;
  });
};


/**
 * Creates a panel and adds it to the dom.
 * @returns {!Q.IPromise} A promise that is resolved when the panel is
 *     created.
 * @private
 */
MdPanelRef.prototype._createPanel = function() {
  var self = this;

  return this._$q(function(resolve, reject) {
    if (!self.config.locals) {
      self.config.locals = {};
    }

    self.config.locals.mdPanelRef = self;

    self._compile().then(function() {
      if (self.config['disableParentScroll']) {
        self._restoreScroll = self._$mdUtil.disableScrollAround(
          null,
          self.panelContainer,
          { disableScrollMask: true }
        );
      }

      // Add a custom CSS class to the panel element.
      if (self.config['panelClass']) {
        self.panelEl.addClass(self.config['panelClass']);
      }

      // Handle click and touch events for the panel container.
      if (self.config['propagateContainerEvents']) {
        self.panelContainer.css('pointer-events', 'none');
        self.panelEl.css('pointer-events', 'all');
      }

      // Panel may be outside the $rootElement, tell ngAnimate to animate
      // regardless.
      if (self._$animate.pin) {
        self._$animate.pin(
          self.panelContainer,
          getElement(self.config['attachTo'])
        );
      }

      self._configureTrapFocus();
      self._addStyles().then(function() {
        resolve(self);
      }, reject);
    }, reject);

  });
};


/**
 * Adds the styles for the panel, such as positioning and z-index. Also,
 * themes the panel element and panel container using `$mdTheming`.
 * @returns {!Q.IPromise<!MdPanelRef>}
 * @private
 */
MdPanelRef.prototype._addStyles = function() {
  var self = this;
  return this._$q(function(resolve) {
    self.panelContainer.css('z-index', self.config['zIndex']);
    self.innerWrapper.css('z-index', self.config['zIndex'] + 1);

    var hideAndResolve = function() {
      // Theme the element and container.
      self._setTheming();

      // Remove offscreen classes and add hidden class.
      self.panelEl.removeClass('_md-panel-offscreen');
      self.innerWrapper.removeClass('_md-panel-offscreen');
      self.panelContainer.addClass(MD_PANEL_HIDDEN);

      resolve(self);
    };

    if (self.config['fullscreen']) {
      self.panelEl.addClass('_md-panel-fullscreen');
      hideAndResolve();
      return; // Don't setup positioning.
    }

    var positionConfig = self.config['position'];
    if (!positionConfig) {
      hideAndResolve();
      return; // Don't setup positioning.
    }

    // Wait for angular to finish processing the template
    self._$rootScope['$$postDigest'](function() {
      // Position it correctly. This is necessary so that the panel will have a
      // defined height and width.
      self._updatePosition(true);

      // Theme the element and container.
      self._setTheming();

      resolve(self);
    });
  });
};


/**
 * Sets the `$mdTheming` classes on the `panelContainer` and `panelEl`.
 * @private
 */
MdPanelRef.prototype._setTheming = function() {
  this._$mdTheming(this.panelEl);
  this._$mdTheming(this.panelContainer);
};


/**
 * Updates the position configuration of a panel
 * @param {!MdPanelPosition} position
 */
MdPanelRef.prototype.updatePosition = function(position) {
  if (!this.panelContainer) {
    throw new Error(
        'mdPanel: Panel does not exist yet. Call open() or attach().');
  }

  this.config['position'] = position;
  this._updatePosition();
};


/**
 * Calculates and updates the position of the panel.
 * @param {boolean=} init
 * @private
 */
MdPanelRef.prototype._updatePosition = function(init) {
  var positionConfig = this.config['position'];

  if (positionConfig) {
    positionConfig._setPanelPosition(this.innerWrapper);

    // Hide the panel now that position is known.
    if (init) {
      this.panelEl.removeClass('_md-panel-offscreen');
      this.innerWrapper.removeClass('_md-panel-offscreen');
      this.panelContainer.addClass(MD_PANEL_HIDDEN);
    }

    this.innerWrapper.css(
      MdPanelPosition.absPosition.TOP,
      positionConfig.getTop()
    );
    this.innerWrapper.css(
      MdPanelPosition.absPosition.BOTTOM,
      positionConfig.getBottom()
    );
    this.innerWrapper.css(
      MdPanelPosition.absPosition.LEFT,
      positionConfig.getLeft()
    );
    this.innerWrapper.css(
      MdPanelPosition.absPosition.RIGHT,
      positionConfig.getRight()
    );
  }
};


/**
 * Focuses on the panel or the first focus target.
 * @private
 */
MdPanelRef.prototype._focusOnOpen = function() {
  if (this.config['focusOnOpen']) {
    // Wait for the template to finish rendering to guarantee md-autofocus has
    // finished adding the class md-autofocus, otherwise the focusable element
    // isn't available to focus.
    var self = this;
    this._$rootScope['$$postDigest'](function() {
      var target = self._$mdUtil.findFocusTarget(self.panelEl) ||
          self.panelEl;
      target.focus();
    });
  }
};


/**
 * Shows the backdrop.
 * @returns {!Q.IPromise} A promise that is resolved when the backdrop
 *     is created and attached.
 * @private
 */
MdPanelRef.prototype._createBackdrop = function() {
  if (this.config.hasBackdrop) {
    if (!this._backdropRef) {
      var backdropAnimation = this._$mdPanel.newPanelAnimation()
          .openFrom(this.config.attachTo)
          .withAnimation({
            open: '_md-opaque-enter',
            close: '_md-opaque-leave'
          });

      if (this.config.animation) {
        backdropAnimation.duration(this.config.animation._rawDuration);
      }

      var backdropConfig = {
        animation: backdropAnimation,
        attachTo: this.config.attachTo,
        focusOnOpen: false,
        panelClass: '_md-panel-backdrop',
        zIndex: this.config.zIndex - 1
      };

      this._backdropRef = this._$mdPanel.create(backdropConfig);
    }
    if (!this._backdropRef.isAttached) {
      return this._backdropRef.attach();
    }
  }
};


/**
 * Listen for escape keys and outside clicks to auto close.
 * @private
 */
MdPanelRef.prototype._addEventListeners = function() {
  this._configureEscapeToClose();
  this._configureClickOutsideToClose();
  this._configureScrollListener();
};


/**
 * Remove event listeners added in _addEventListeners.
 * @private
 */
MdPanelRef.prototype._removeEventListeners = function() {
  this._removeListeners && this._removeListeners.forEach(function(removeFn) {
    removeFn();
  });
  this._removeListeners = [];
};


/**
 * Setup the escapeToClose event listeners.
 * @private
 */
MdPanelRef.prototype._configureEscapeToClose = function() {
  if (this.config['escapeToClose']) {
    var parentTarget = getElement(this.config['attachTo']);
    var self = this;

    var keyHandlerFn = function(ev) {
      if (ev.keyCode === self._$mdConstant.KEY_CODE.ESCAPE) {
        ev.stopPropagation();
        ev.preventDefault();

        self.close(MdPanelRef.closeReasons.ESCAPE);
      }
    };

    // Add keydown listeners
    this.panelContainer.on('keydown', keyHandlerFn);
    parentTarget.on('keydown', keyHandlerFn);

    // Queue remove listeners function
    this._removeListeners.push(function() {
      self.panelContainer.off('keydown', keyHandlerFn);
      parentTarget.off('keydown', keyHandlerFn);
    });
  }
};


/**
 * Setup the clickOutsideToClose event listeners.
 * @private
 */
MdPanelRef.prototype._configureClickOutsideToClose = function() {
  if (this.config['clickOutsideToClose']) {
    var target = this.config['propagateContainerEvents'] ?
        angular.element(document.body) :
        this.panelContainer;
    var sourceEl;

    // Keep track of the element on which the mouse originally went down
    // so that we can only close the backdrop when the 'click' started on it.
    // A simple 'click' handler does not work, it sets the target object as the
    // element the mouse went down on.
    var mousedownHandler = function(ev) {
      sourceEl = ev.target;
    };

    // We check if our original element and the target is the backdrop
    // because if the original was the backdrop and the target was inside the
    // panel we don't want to panel to close.
    var self = this;
    var mouseupHandler = function(ev) {
      if (self.config['propagateContainerEvents']) {

        // We check if the sourceEl of the event is the panel element or one
        // of it's children. If it is not, then close the panel.
        if (sourceEl !== self.panelEl[0] && !self.panelEl[0].contains(sourceEl)) {
          self.close();
        }

      } else if (sourceEl === target[0] && ev.target === target[0]) {
        ev.stopPropagation();
        ev.preventDefault();

        self.close(MdPanelRef.closeReasons.CLICK_OUTSIDE);
      }
    };

    // Add listeners
    target.on('mousedown', mousedownHandler);
    target.on('mouseup', mouseupHandler);

    // Queue remove listeners function
    this._removeListeners.push(function() {
      target.off('mousedown', mousedownHandler);
      target.off('mouseup', mouseupHandler);
    });
  }
};


/**
 * Configures the listeners for updating the panel position on scroll.
 * @private
*/
MdPanelRef.prototype._configureScrollListener = function() {
  // No need to bind the event if scrolling is disabled.
  if (!this.config['disableParentScroll']) {
    var updatePosition = angular.bind(this, this._updatePosition);
    var debouncedUpdatePosition = this._$$rAF.throttle(updatePosition);
    var self = this;

    var onScroll = function() {
      debouncedUpdatePosition();
    };

    // Add listeners.
    this._$window.addEventListener('scroll', onScroll, true);

    // Queue remove listeners function.
    this._removeListeners.push(function() {
      self._$window.removeEventListener('scroll', onScroll, true);
    });
  }
};


/**
 * Setup the focus traps. These traps will wrap focus when tabbing past the
 * panel. When shift-tabbing, the focus will stick in place.
 * @private
 */
MdPanelRef.prototype._configureTrapFocus = function() {
  // Focus doesn't remain inside of the panel without this.
  this.panelEl.attr('tabIndex', '-1');
  if (this.config['trapFocus']) {
    var element = this.panelEl;
    // Set up elements before and after the panel to capture focus and
    // redirect back into the panel.
    if (!FOCUS_TRAP_TEMPLATE) {
      var template = document.createElement('div');
      template.className = '_md-panel-focus-trap';
      template.tabIndex = 0;
      FOCUS_TRAP_TEMPLATE = angular.element(template);
    }
    this._topFocusTrap = FOCUS_TRAP_TEMPLATE.clone()[0];
    this._bottomFocusTrap = FOCUS_TRAP_TEMPLATE.clone()[0];

    // When focus is about to move out of the panel, we want to intercept it
    // and redirect it back to the panel element.
    var focusHandler = function() {
      element.focus();
    };
    this._topFocusTrap.addEventListener('focus', focusHandler);
    this._bottomFocusTrap.addEventListener('focus', focusHandler);

    // Queue remove listeners function
    this._removeListeners.push(this._simpleBind(function() {
      this._topFocusTrap.removeEventListener('focus', focusHandler);
      this._bottomFocusTrap.removeEventListener('focus', focusHandler);
    }, this));

    // The top focus trap inserted immediately before the md-panel element (as
    // a sibling). The bottom focus trap inserted immediately after the
    // md-panel element (as a sibling).
    element[0].parentNode.insertBefore(this._topFocusTrap, element[0]);
    element.after(this._bottomFocusTrap);
  }
};


/**
 * Updates the animation of a panel.
 * @param {!MdPanelAnimation} animation
 */
MdPanelRef.prototype.updateAnimation = function(animation) {
  this.config['animation'] = animation;

  if (this._backdropRef) {
    this._backdropRef.config.animation.duration(animation._rawDuration);
  }
};


/**
 * Animate the panel opening.
 * @returns {!Q.IPromise} A promise that is resolved when the panel has
 *     animated open.
 * @private
 */
MdPanelRef.prototype._animateOpen = function() {
  this.panelContainer.addClass('md-panel-is-showing');
  var animationConfig = this.config['animation'];
  if (!animationConfig) {
    // Promise is in progress, return it.
    this.panelContainer.addClass('_md-panel-shown');
    return this._$q.when(this);
  }

  var self = this;
  return this._$q(function(resolve) {
    var done = self._done(resolve, self);
    var warnAndOpen = function() {
      self._$log.warn(
          'mdPanel: MdPanel Animations failed. ' +
          'Showing panel without animating.');
      done();
    };

    animationConfig.animateOpen(self.panelEl)
        .then(done, warnAndOpen);
  });
};


/**
 * Animate the panel closing.
 * @returns {!Q.IPromise} A promise that is resolved when the panel has animated closed.
 * @private
 */
MdPanelRef.prototype._animateClose = function() {
  var self = this;
  var animationConfig = this.config['animation'];

  if (!animationConfig) {
    this.panelContainer.removeClass('md-panel-is-showing');
    this.panelContainer.removeClass('_md-panel-shown');
    return this._$q.when(this);
  } else {
    return this._$q(function (resolve) {
      var done = function () {
        self.panelContainer.removeClass('md-panel-is-showing');
        // Remove the transform so that re-used panels don't accumulate transforms.
        self.panelEl.css('transform', '');
        resolve(self);
      };
      var warnAndClose = function () {
        self._$log.warn(
          'mdPanel: MdPanel Animations failed. Hiding panel without animating.');
        done();
      };

      animationConfig.animateClose(self.panelEl).then(done, warnAndClose);
    });
  }
};


/**
 * Registers a interceptor with the panel. The callback should return a promise,
 * which will allow the action to continue when it gets resolved, or will
 * prevent an action if it is rejected.
 * @param {string} type Type of interceptor.
 * @param {!Q.IPromise<!any>} callback Callback to be registered.
 * @returns {!MdPanelRef}
 */
MdPanelRef.prototype.registerInterceptor = function(type, callback) {
  var error = null;

  if (!angular.isString(type)) {
    error = 'Interceptor type must be a string, instead got ' + typeof type;
  } else if (!angular.isFunction(callback)) {
    error = 'Interceptor callback must be a function, instead got ' + typeof callback;
  }

  if (error) {
    throw new Error('MdPanel: ' + error);
  }

  var interceptors = this._interceptors[type] = this._interceptors[type] || [];

  if (interceptors.indexOf(callback) === -1) {
    interceptors.push(callback);
  }

  return this;
};


/**
 * Removes a registered interceptor.
 * @param {string} type Type of interceptor to be removed.
 * @param {Function} callback Interceptor to be removed.
 * @returns {!MdPanelRef}
 */
MdPanelRef.prototype.removeInterceptor = function(type, callback) {
  var index = this._interceptors[type] ?
    this._interceptors[type].indexOf(callback) : -1;

  if (index > -1) {
    this._interceptors[type].splice(index, 1);
  }

  return this;
};


/**
 * Removes all interceptors.
 * @param {string=} type Type of interceptors to be removed.
 *     If ommited, all interceptors types will be removed.
 * @returns {!MdPanelRef}
 */
MdPanelRef.prototype.removeAllInterceptors = function(type) {
  if (type) {
    this._interceptors[type] = [];
  } else {
    this._interceptors = Object.create(null);
  }

  return this;
};


/**
 * Invokes all the interceptors of a certain type sequantially in
 *     reverse order. Works in a similar way to `$q.all`, except it
 *     respects the order of the functions.
 * @param {string} type Type of interceptors to be invoked.
 * @returns {!Q.IPromise<!MdPanelRef>}
 * @private
 */
MdPanelRef.prototype._callInterceptors = function(type) {
  var self = this;
  var $q = self._$q;
  var interceptors = self._interceptors && self._interceptors[type] || [];

  return interceptors.reduceRight(function(promise, interceptor) {
    var isPromiseLike = interceptor && angular.isFunction(interceptor.then);
    var response = isPromiseLike ? interceptor : null;

    /**
    * For interceptors to reject/cancel subsequent portions of the chain, simply
    * return a `$q.reject(<value>)`
    */
    return promise.then(function() {
      if (!response) {
        try {
          response = interceptor(self);
        } catch (e) {
          response = $q.reject(e);
        }
      }

     return response;
    });
  }, $q.resolve(self));
};


/**
 * Faster, more basic than angular.bind
 * http://jsperf.com/angular-bind-vs-custom-vs-native
 * @param {function} callback
 * @param {!Object} self
 * @return {function} Callback function with a bound self.
 */
MdPanelRef.prototype._simpleBind = function(callback, self) {
  return function(value) {
    return callback.apply(self, value);
  };
};


/**
 * @param {function|IQResolveReject} callback
 * @param {!Object} self
 * @return {function} Callback function with a self param.
 */
MdPanelRef.prototype._done = function(callback, self) {
  return function() {
    callback(self);
  };
};


/**
 * Adds a panel to a group if the panel does not exist within the group already.
 * A panel can only exist within a single group.
 * @param {string} groupName The name of the group.
 */
MdPanelRef.prototype.addToGroup = function(groupName) {
  if (!this._$mdPanel._groups[groupName]) {
    this._$mdPanel.newPanelGroup(groupName);
  }

  var group = this._$mdPanel._groups[groupName];
  var index = group.panels.indexOf(this);

  if (index < 0) {
    group.panels.push(this);
  }
};


/**
 * Removes a panel from a group if the panel exists within that group. The group
 * must be created ahead of time.
 * @param {string} groupName The name of the group.
 */
MdPanelRef.prototype.removeFromGroup = function(groupName) {
  if (!this._$mdPanel._groups[groupName]) {
    throw new Error('mdPanel: The group ' + groupName + ' does not exist.');
  }

  var group = this._$mdPanel._groups[groupName];
  var index = group.panels.indexOf(this);

  if (index > -1) {
    group.panels.splice(index, 1);
  }
};


/**
 * Possible default closeReasons for the close function.
 * @enum {string}
 */
MdPanelRef.closeReasons = {
  CLICK_OUTSIDE: 'clickOutsideToClose',
  ESCAPE: 'escapeToClose',
};


/*****************************************************************************
 *                               MdPanelPosition                             *
 *****************************************************************************/


/**
 * Position configuration object. To use, create an MdPanelPosition with the
 * desired properties, then pass the object as part of $mdPanel creation.
 *
 * Example:
 *
 * var panelPosition = new MdPanelPosition()
 *     .relativeTo(myButtonEl)
 *     .addPanelPosition(
 *       $mdPanel.xPosition.CENTER,
 *       $mdPanel.yPosition.ALIGN_TOPS
 *     );
 *
 * $mdPanel.create({
 *   position: panelPosition
 * });
 *
 * @param {!IInjectorService} $injector
 * @final @constructor
 */
function MdPanelPosition($injector) {
  /** @private @const {!IWindowService} */
  this._$window = $injector.get('$window');

  /** @private {boolean} */
  this._isRTL = $injector.get('$mdUtil').isRtl();

  /** @private @const {!angular.$mdConstant} */
  this._$mdConstant = $injector.get('$mdConstant');

  /** @private {boolean} */
  this._absolute = false;

  /** @private {!JQLite} */
  this._relativeToEl = undefined;

  /** @private {string} */
  this._top = '';

  /** @private {string} */
  this._bottom = '';

  /** @private {string} */
  this._left = '';

  /** @private {string} */
  this._right = '';

  /** @private {!Array<string>} */
  this._translateX = [];

  /** @private {!Array<string>} */
  this._translateY = [];

  /** @private {!Array<{x:string, y:string}>} */
  this._positions = [];

  /** @private {?{x:string, y:string}} */
  this._actualPosition = undefined;
}


/**
 * Possible values of xPosition.
 * @enum {string}
 */
MdPanelPosition.xPosition = {
  CENTER: 'center',
  ALIGN_START: 'align-start',
  ALIGN_END: 'align-end',
  OFFSET_START: 'offset-start',
  OFFSET_END: 'offset-end'
};


/**
 * Possible values of yPosition.
 * @enum {string}
 */
MdPanelPosition.yPosition = {
  CENTER: 'center',
  ALIGN_TOPS: 'align-tops',
  ALIGN_BOTTOMS: 'align-bottoms',
  ABOVE: 'above',
  BELOW: 'below'
};


/**
 * Possible values of absolute position.
 * @enum {string}
 */
MdPanelPosition.absPosition = {
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left'
};

/**
 * Margin between the edges of a panel and the viewport.
 * @const {number}
 */
MdPanelPosition.viewportMargin = 8;


/**
 * Sets absolute positioning for the panel.
 * @return {!MdPanelPosition}
 */
MdPanelPosition.prototype.absolute = function() {
  this._absolute = true;
  return this;
};


/**
 * Sets the value of a position for the panel. Clears any previously set
 * position.
 * @param {string} position Position to set
 * @param {string=} value Value of the position. Defaults to '0'.
 * @returns {!MdPanelPosition}
 * @private
 */
MdPanelPosition.prototype._setPosition = function(position, value) {
  if (position === MdPanelPosition.absPosition.RIGHT ||
      position === MdPanelPosition.absPosition.LEFT) {
    this._left = this._right = '';
  } else if (
      position === MdPanelPosition.absPosition.BOTTOM ||
      position === MdPanelPosition.absPosition.TOP) {
    this._top = this._bottom = '';
  } else {
    var positions = Object.keys(MdPanelPosition.absPosition).join()
        .toLowerCase();

    throw new Error('mdPanel: Position must be one of ' + positions + '.');
  }

  this['_' +  position] = angular.isString(value) ? value : '0';

  return this;
};


/**
 * Sets the value of `top` for the panel. Clears any previously set vertical
 * position.
 * @param {string=} top Value of `top`. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.top = function(top) {
  return this._setPosition(MdPanelPosition.absPosition.TOP, top);
};


/**
 * Sets the value of `bottom` for the panel. Clears any previously set vertical
 * position.
 * @param {string=} bottom Value of `bottom`. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.bottom = function(bottom) {
  return this._setPosition(MdPanelPosition.absPosition.BOTTOM, bottom);
};


/**
 * Sets the panel to the start of the page - `left` if `ltr` or `right` for
 * `rtl`. Clears any previously set horizontal position.
 * @param {string=} start Value of position. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.start = function(start) {
  var position = this._isRTL ? MdPanelPosition.absPosition.RIGHT : MdPanelPosition.absPosition.LEFT;
  return this._setPosition(position, start);
};


/**
 * Sets the panel to the end of the page - `right` if `ltr` or `left` for `rtl`.
 * Clears any previously set horizontal position.
 * @param {string=} end Value of position. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.end = function(end) {
  var position = this._isRTL ? MdPanelPosition.absPosition.LEFT : MdPanelPosition.absPosition.RIGHT;
  return this._setPosition(position, end);
};


/**
 * Sets the value of `left` for the panel. Clears any previously set
 * horizontal position.
 * @param {string=} left Value of `left`. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.left = function(left) {
  return this._setPosition(MdPanelPosition.absPosition.LEFT, left);
};


/**
 * Sets the value of `right` for the panel. Clears any previously set
 * horizontal position.
 * @param {string=} right Value of `right`. Defaults to '0'.
 * @returns {!MdPanelPosition}
*/
MdPanelPosition.prototype.right = function(right) {
  return this._setPosition(MdPanelPosition.absPosition.RIGHT, right);
};


/**
 * Centers the panel horizontally in the viewport. Clears any previously set
 * horizontal position.
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.centerHorizontally = function() {
  this._left = '50%';
  this._right = '';
  this._translateX = ['-50%'];
  return this;
};


/**
 * Centers the panel vertically in the viewport. Clears any previously set
 * vertical position.
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.centerVertically = function() {
  this._top = '50%';
  this._bottom = '';
  this._translateY = ['-50%'];
  return this;
};


/**
 * Centers the panel horizontally and vertically in the viewport. This is
 * equivalent to calling both `centerHorizontally` and `centerVertically`.
 * Clears any previously set horizontal and vertical positions.
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.center = function() {
  return this.centerHorizontally().centerVertically();
};


/**
 * Sets element for relative positioning.
 * @param {string|!Element|!JQLite} element Query selector, DOM element,
 *     or angular element to set the panel relative to.
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.relativeTo = function(element) {
  this._absolute = false;
  this._relativeToEl = getElement(element);
  return this;
};


/**
 * Sets the x and y positions for the panel relative to another element.
 * @param {string} xPosition must be one of the MdPanelPosition.xPosition
 *     values.
 * @param {string} yPosition must be one of the MdPanelPosition.yPosition
 *     values.
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.addPanelPosition = function(xPosition, yPosition) {
  if (!this._relativeToEl) {
    throw new Error('mdPanel: addPanelPosition can only be used with ' +
        'relative positioning. Set relativeTo first.');
  }

  validatePosition(MdPanelPosition.xPosition, xPosition);
  validatePosition(MdPanelPosition.yPosition, yPosition);

  this._positions.push({
    x: xPosition,
    y: yPosition
  });

  return this;
};


/**
 * Sets the value of the offset in the x-direction. This will add to any
 * previously set offsets.
 * @param {string|number|function(MdPanelPosition): string} offsetX
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.withOffsetX = function(offsetX) {
  this._translateX.push(addUnits(offsetX));
  return this;
};


/**
 * Sets the value of the offset in the y-direction. This will add to any
 * previously set offsets.
 * @param {string|number|function(MdPanelPosition): string} offsetY
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.withOffsetY = function(offsetY) {
  this._translateY.push(addUnits(offsetY));
  return this;
};


/**
 * Gets the value of `top` for the panel.
 * @returns {string}
 */
MdPanelPosition.prototype.getTop = function() {
  return this._top;
};


/**
 * Gets the value of `bottom` for the panel.
 * @returns {string}
 */
MdPanelPosition.prototype.getBottom = function() {
  return this._bottom;
};


/**
 * Gets the value of `left` for the panel.
 * @returns {string}
 */
MdPanelPosition.prototype.getLeft = function() {
  return this._left;
};


/**
 * Gets the value of `right` for the panel.
 * @returns {string}
 */
MdPanelPosition.prototype.getRight = function() {
  return this._right;
};


/**
 * Gets the value of `transform` for the panel.
 * @returns {string} representation of the translateX and translateY rules and values
 */
MdPanelPosition.prototype.getTransform = function() {
  var translateX = this._reduceTranslateValues('translateX', this._translateX);
  var translateY = this._reduceTranslateValues('translateY', this._translateY);

  // It's important to trim the result, because the browser will ignore the set
  // operation if the string contains only whitespace.
  return (translateX + ' ' + translateY).trim();
};


/**
 * Sets the `transform` value for an element.
 * @param {!JQLite} el
 * @returns {!JQLite}
 * @private
 */
MdPanelPosition.prototype._setTransform = function(el) {
  return el.css(this._$mdConstant.CSS.TRANSFORM, this.getTransform());
};


/**
 * True if the panel is completely on-screen with this positioning; false
 * otherwise.
 * @param {!JQLite} el
 * @return {boolean}
 * @private
 */
MdPanelPosition.prototype._isOnscreen = function(el) {
  // this works because we always use fixed positioning for the panel,
  // which is relative to the viewport.
  var left = parseInt(this.getLeft());
  var top = parseInt(this.getTop());

  if (this._translateX.length || this._translateY.length) {
    var prefixedTransform = this._$mdConstant.CSS.TRANSFORM;
    var offsets = getComputedTranslations(el, prefixedTransform);
    left += offsets.x;
    top += offsets.y;
  }

  var right = left + el[0].offsetWidth;
  var bottom = top + el[0].offsetHeight;

  return (left >= 0) &&
    (top >= 0) &&
    (bottom <= this._$window.innerHeight) &&
    (right <= this._$window.innerWidth);
};


/**
 * Gets the first x/y position that can fit on-screen.
 * @returns {{x: string, y: string}}
 */
MdPanelPosition.prototype.getActualPosition = function() {
  return this._actualPosition;
};


/**
 * Reduces a list of translate values to a string that can be used within
 * transform.
 * @param {string} translateFn
 * @param {!Array<string>} values
 * @returns {string}
 * @private
 */
MdPanelPosition.prototype._reduceTranslateValues =
    function(translateFn, values) {
      return values.map(function(translation) {
        var translationValue = angular.isFunction(translation) ?
            addUnits(translation(this)) : translation;
        return translateFn + '(' + translationValue + ')';
      }, this).join(' ');
    };


/**
 * Sets the panel position based on the created panel element and best x/y
 * positioning.
 * @param {!JQLite} el
 * @private
 */
MdPanelPosition.prototype._setPanelPosition = function(el) {
  // Remove the class in case it has been added before.
  el.removeClass('_md-panel-position-adjusted');

  // Only calculate the position if necessary.
  if (this._absolute) {
    this._setTransform(el);
    return;
  }

  if (this._actualPosition) {
    this._calculatePanelPosition(el, this._actualPosition);
    this._setTransform(el);
    this._constrainToViewport(el);
    return;
  }

  for (var i = 0; i < this._positions.length; i++) {
    this._actualPosition = this._positions[i];
    this._calculatePanelPosition(el, this._actualPosition);
    this._setTransform(el);

    if (this._isOnscreen(el)) {
      return;
    }
  }

  this._constrainToViewport(el);
};


/**
 * Constrains a panel's position to the viewport.
 * @param {!JQLite} el
 * @private
 */
MdPanelPosition.prototype._constrainToViewport = function(el) {
  var margin = MdPanelPosition.viewportMargin;
  var initialTop = this._top;
  var initialLeft = this._left;

  if (this.getTop()) {
    var top = parseInt(this.getTop());
    var bottom = el[0].offsetHeight + top;
    var viewportHeight = this._$window.innerHeight;

    if (top < margin) {
      this._top = margin + 'px';
    } else if (bottom > viewportHeight) {
      this._top = top - (bottom - viewportHeight + margin) + 'px';
    }
  }

  if (this.getLeft()) {
    var left = parseInt(this.getLeft());
    var right = el[0].offsetWidth + left;
    var viewportWidth = this._$window.innerWidth;

    if (left < margin) {
      this._left = margin + 'px';
    } else if (right > viewportWidth) {
      this._left = left - (right - viewportWidth + margin) + 'px';
    }
  }

  // Class that can be used to re-style the panel if it was repositioned.
  el.toggleClass(
    '_md-panel-position-adjusted',
    this._top !== initialTop || this._left !== initialLeft
  );
};


/**
 * Switches between 'start' and 'end'.
 * @param {string} position Horizontal position of the panel
 * @returns {string} Reversed position
 * @private
 */
MdPanelPosition.prototype._reverseXPosition = function(position) {
  if (position === MdPanelPosition.xPosition.CENTER) {
    return position;
  }

  var start = 'start';
  var end = 'end';

  return position.indexOf(start) > -1 ? position.replace(start, end) : position.replace(end, start);
};


/**
 * Handles horizontal positioning in rtl or ltr environments.
 * @param {string} position Horizontal position of the panel
 * @returns {string} The correct position according the page direction
 * @private
 */
MdPanelPosition.prototype._bidi = function(position) {
  return this._isRTL ? this._reverseXPosition(position) : position;
};


/**
 * Calculates the panel position based on the created panel element and the
 * provided positioning.
 * @param {!JQLite} el
 * @param {!{x:string, y:string}} position
 * @private
 */
MdPanelPosition.prototype._calculatePanelPosition = function(el, position) {

  var panelBounds = el[0].getBoundingClientRect();
  var panelWidth = Math.max(panelBounds.width, el[0].clientWidth);
  var panelHeight = Math.max(panelBounds.height, el[0].clientHeight);

  var targetBounds = this._relativeToEl[0].getBoundingClientRect();

  var targetLeft = targetBounds.left;
  var targetRight = targetBounds.right;
  var targetWidth = targetBounds.width;

  switch (this._bidi(position.x)) {
    case MdPanelPosition.xPosition.OFFSET_START:
      this._left = targetLeft - panelWidth + 'px';
      break;
    case MdPanelPosition.xPosition.ALIGN_END:
      this._left = targetRight - panelWidth + 'px';
      break;
    case MdPanelPosition.xPosition.CENTER:
      var left = targetLeft + (0.5 * targetWidth) - (0.5 * panelWidth);
      this._left = left + 'px';
      break;
    case MdPanelPosition.xPosition.ALIGN_START:
      this._left = targetLeft + 'px';
      break;
    case MdPanelPosition.xPosition.OFFSET_END:
      this._left = targetRight + 'px';
      break;
  }

  var targetTop = targetBounds.top;
  var targetBottom = targetBounds.bottom;
  var targetHeight = targetBounds.height;

  switch (position.y) {
    case MdPanelPosition.yPosition.ABOVE:
      this._top = targetTop - panelHeight + 'px';
      break;
    case MdPanelPosition.yPosition.ALIGN_BOTTOMS:
      this._top = targetBottom - panelHeight + 'px';
      break;
    case MdPanelPosition.yPosition.CENTER:
      var top = targetTop + (0.5 * targetHeight) - (0.5 * panelHeight);
      this._top = top + 'px';
      break;
    case MdPanelPosition.yPosition.ALIGN_TOPS:
      this._top = targetTop + 'px';
      break;
    case MdPanelPosition.yPosition.BELOW:
      this._top = targetBottom + 'px';
      break;
  }
};


/*****************************************************************************
 *                               MdPanelAnimation                            *
 *****************************************************************************/


/**
 * Animation configuration object. To use, create an MdPanelAnimation with the
 * desired properties, then pass the object as part of $mdPanel creation.
 *
 * Example:
 *
 * var panelAnimation = new MdPanelAnimation()
 *     .openFrom(myButtonEl)
 *     .closeTo('.my-button')
 *     .withAnimation($mdPanel.animation.SCALE);
 *
 * $mdPanel.create({
 *   animation: panelAnimation
 * });
 *
 * @param {!IInjectorService} $injector
 * @final @constructor
 */
function MdPanelAnimation($injector) {
  /** @private @const {!angular.$mdUtil} */
  this._$mdUtil = $injector.get('$mdUtil');

  /**
   * @private {{element: !JQLite|undefined, bounds: !DOMRect}|
   *     undefined}
   */
  this._openFrom;

  /**
   * @private {{element: !JQLite|undefined, bounds: !DOMRect}|
   *     undefined}
   */
  this._closeTo;

  /** @private {string|{open: string, close: string}} */
  this._animationClass = '';

  /** @private {number} */
  this._openDuration;

  /** @private {number} */
  this._closeDuration;

  /** @private {number|{open: number, close: number}} */
  this._rawDuration;
}


/**
 * Possible default animations.
 * @enum {string}
 */
MdPanelAnimation.animation = {
  SLIDE: 'md-panel-animate-slide',
  SCALE: 'md-panel-animate-scale',
  FADE: 'md-panel-animate-fade'
};


/**
 * Specifies where to start the open animation. `openFrom` accepts a
 * click event object, query selector, DOM element, or a Rect object that
 * is used to determine the bounds. When passed a click event, the location
 * of the click will be used as the position to start the animation.
 * @param {string|!Element|!Event|{top: number, left: number}} openFrom
 * @returns {!MdPanelAnimation}
 */
MdPanelAnimation.prototype.openFrom = function(openFrom) {
  // Check if 'openFrom' is an Event.
  openFrom = openFrom.target ? openFrom.target : openFrom;

  this._openFrom = this._getPanelAnimationTarget(openFrom);

  if (!this._closeTo) {
    this._closeTo = this._openFrom;
  }
  return this;
};


/**
 * Specifies where to animate the panel close. `closeTo` accepts a
 * query selector, DOM element, or a Rect object that is used to determine
 * the bounds.
 * @param {string|!Element|{top: number, left: number}} closeTo
 * @returns {!MdPanelAnimation}
 */
MdPanelAnimation.prototype.closeTo = function(closeTo) {
  this._closeTo = this._getPanelAnimationTarget(closeTo);
  return this;
};


/**
 * Specifies the duration of the animation in milliseconds.
 * @param {number|{open: number, close: number}} duration
 * @returns {!MdPanelAnimation}
 */
MdPanelAnimation.prototype.duration = function(duration) {
  if (duration) {
    if (angular.isNumber(duration)) {
      this._openDuration = this._closeDuration = toSeconds(duration);
    } else if (angular.isObject(duration)) {
      this._openDuration = toSeconds(duration.open);
      this._closeDuration = toSeconds(duration.close);
    }
  }

  // Save the original value so it can be passed to the backdrop.
  this._rawDuration = duration;

  return this;

  function toSeconds(value) {
    if (angular.isNumber(value)) return value / 1000;
  }
};


/**
 * Returns the element and bounds for the animation target.
 * @param {string|!Element|{top: number, left: number}} location
 * @returns {{element: !JQLite|undefined, bounds: !DOMRect}}
 * @private
 */
MdPanelAnimation.prototype._getPanelAnimationTarget = function(location) {
  if (angular.isDefined(location.top) || angular.isDefined(location.left)) {
    return {
      element: undefined,
      bounds: {
        top: location.top || 0,
        left: location.left || 0
      }
    };
  } else {
    return this._getBoundingClientRect(getElement(location));
  }
};


/**
 * Specifies the animation class.
 *
 * There are several default animations that can be used:
 * (MdPanelAnimation.animation)
 *   SLIDE: The panel slides in and out from the specified
 *        elements.
 *   SCALE: The panel scales in and out.
 *   FADE: The panel fades in and out.
 *
 * @param {string|{open: string, close: string}} cssClass
 * @returns {!MdPanelAnimation}
 */
MdPanelAnimation.prototype.withAnimation = function(cssClass) {
  this._animationClass = cssClass;
  return this;
};


/**
 * Animate the panel open.
 * @param {!JQLite} panelEl
 * @returns {!Q.IPromise} A promise that is resolved when the open
 *     animation is complete.
 */
MdPanelAnimation.prototype.animateOpen = function(panelEl) {
  var animator = this._$mdUtil.dom.animator;

  this._fixBounds(panelEl);
  var animationOptions = {};

  // Include the panel transformations when calculating the animations.
  var panelTransform = panelEl[0].style.transform || '';

  var openFrom = animator.toTransformCss(panelTransform);
  var openTo = animator.toTransformCss(panelTransform);

  switch (this._animationClass) {
    case MdPanelAnimation.animation.SLIDE:
      // Slide should start with opacity: 1.
      panelEl.css('opacity', '1');

      animationOptions = {
        transitionInClass: '_md-panel-animate-enter',
        transitionOutClass: '_md-panel-animate-leave',
      };

      var openSlide = animator.calculateSlideToOrigin(
              panelEl, this._openFrom) || '';
      openFrom = animator.toTransformCss(openSlide + ' ' + panelTransform);
      break;

    case MdPanelAnimation.animation.SCALE:
      animationOptions = {
        transitionInClass: '_md-panel-animate-enter'
      };

      var openScale = animator.calculateZoomToOrigin(
              panelEl, this._openFrom) || '';
      openFrom = animator.toTransformCss(panelTransform + ' ' + openScale);
      break;

    case MdPanelAnimation.animation.FADE:
      animationOptions = {
        transitionInClass: '_md-panel-animate-enter'
      };
      break;

    default:
      if (angular.isString(this._animationClass)) {
        animationOptions = {
          transitionInClass: this._animationClass
        };
      } else {
        animationOptions = {
          transitionInClass: this._animationClass['open'],
          transitionOutClass: this._animationClass['close'],
        };
      }
  }

  animationOptions.duration = this._openDuration;

  return animator
      .translate3d(panelEl, openFrom, openTo, animationOptions);
};


/**
 * Animate the panel close.
 * @param {!JQLite} panelEl
 * @returns {!Q.IPromise} A promise that resolves when the close animation is complete.
 */
MdPanelAnimation.prototype.animateClose = function(panelEl) {
  var animator = this._$mdUtil.dom.animator;
  var reverseAnimationOptions = {};

  // Include the panel transformations when calculating the animations.
  var panelTransform = panelEl[0].style.transform || '';

  var closeFrom = animator.toTransformCss(panelTransform);
  var closeTo = animator.toTransformCss(panelTransform);

  switch (this._animationClass) {
    case MdPanelAnimation.animation.SLIDE:
      // Slide should start with opacity: 1.
      panelEl.css('opacity', '1');
      reverseAnimationOptions = {
        transitionInClass: '_md-panel-animate-leave',
        transitionOutClass: '_md-panel-animate-enter _md-panel-animate-leave'
      };

      var closeSlide = animator.calculateSlideToOrigin(panelEl, this._closeTo) || '';
      closeTo = animator.toTransformCss(closeSlide + ' ' + panelTransform);
      break;

    case MdPanelAnimation.animation.SCALE:
      reverseAnimationOptions = {
        transitionInClass: '_md-panel-animate-scale-out _md-panel-animate-leave',
        transitionOutClass: '_md-panel-animate-scale-out _md-panel-animate-enter _md-panel-animate-leave'
      };

      var closeScale = animator.calculateZoomToOrigin(panelEl, this._closeTo) || '';
      closeTo = animator.toTransformCss(panelTransform + ' ' + closeScale);
      break;

    case MdPanelAnimation.animation.FADE:
      reverseAnimationOptions = {
        transitionInClass: '_md-panel-animate-fade-out _md-panel-animate-leave',
        transitionOutClass: '_md-panel-animate-fade-out _md-panel-animate-enter _md-panel-animate-leave'
      };
      break;

    default:
      if (angular.isString(this._animationClass)) {
        reverseAnimationOptions = {
          transitionOutClass: this._animationClass
        };
      } else {
        reverseAnimationOptions = {
          transitionInClass: this._animationClass['close'],
          transitionOutClass: this._animationClass['open']
        };
      }
  }

  reverseAnimationOptions.duration = this._closeDuration;

  return animator
      .translate3d(panelEl, closeFrom, closeTo, reverseAnimationOptions);
};


/**
 * Set the height and width to match the panel if not provided.
 * @param {!JQLite} panelEl
 * @private
 */
MdPanelAnimation.prototype._fixBounds = function(panelEl) {
  var panelWidth = panelEl[0].offsetWidth;
  var panelHeight = panelEl[0].offsetHeight;

  if (this._openFrom && this._openFrom.bounds.height == null) {
    this._openFrom.bounds.height = panelHeight;
  }
  if (this._openFrom && this._openFrom.bounds.width == null) {
    this._openFrom.bounds.width = panelWidth;
  }
  if (this._closeTo && this._closeTo.bounds.height == null) {
    this._closeTo.bounds.height = panelHeight;
  }
  if (this._closeTo && this._closeTo.bounds.width == null) {
    this._closeTo.bounds.width = panelWidth;
  }
};


/**
 * Identify the bounding RECT for the target element.
 * @param {!JQLite} element
 * @returns {{element: !JQLite|undefined, bounds: !DOMRect}}
 * @private
 */
MdPanelAnimation.prototype._getBoundingClientRect = function(element) {
  if (element instanceof angular.element) {
    return {
      element: element,
      bounds: element[0].getBoundingClientRect()
    };
  }
};


/*****************************************************************************
 *                                Util Methods                               *
 *****************************************************************************/


/**
 * Returns the angular element associated with a css selector or element.
 * @param el {string|!JQLite|!Element}
 * @returns {!JQLite}
 */
function getElement(el) {
  var queryResult = angular.isString(el) ?
      document.querySelector(el) : el;
  return angular.element(queryResult);
}

/**
 * Gets the computed values for an element's translateX and translateY in px.
 * @param {!JQLite|!Element} el the element to evaluate
 * @param {string} property
 * @return {{x: number, y: number}} an element's translateX and translateY in px
 */
function getComputedTranslations(el, property) {
  // The transform being returned by `getComputedStyle` is in the format:
  // `matrix(a, b, c, d, translateX, translateY)` if defined and `none`
  // if the element doesn't have a transform.
  var transform = getComputedStyle(el[0] || el)[property];
  var openIndex = transform.indexOf('(');
  var closeIndex = transform.lastIndexOf(')');
  var output = { x: 0, y: 0 };

  if (openIndex > -1 && closeIndex > -1) {
    var parsedValues = transform
      .substring(openIndex + 1, closeIndex)
      .split(', ')
      .slice(-2);

    output.x = parseInt(parsedValues[0]);
    output.y = parseInt(parsedValues[1]);
  }

  return output;
}

/*
 * Ensures that a value is a valid position name. Throw an exception if not.
 * @param {Object} positionMap Object against which the value will be checked.
 * @param {string} value
 */
function validatePosition(positionMap, value) {
  // empty is ok
  if (value === null || angular.isUndefined(value)) {
    return;
  }

  var positionKeys = Object.keys(positionMap);
  var positionValues = [];

  for (var key, i = 0; key = positionKeys[i]; i++) {
    var position = positionMap[key];
    positionValues.push(position);

    if (position === value) {
      return;
    }
  }

  throw new Error('Panel position only accepts the following values:\n' +
    positionValues.join(' | '));
}

/**
 * Adds units to a number value.
 * @param {string|number} value
 * @return {string}
 */
function addUnits(value) {
  return angular.isNumber(value) ? value + 'px' : value;
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.progressCircular
 * @description Module for a circular progressbar
 */

angular.module('material.components.progressCircular', ['material.core']);

})();
(function(){
"use strict";

/**
 * @ngdoc directive
 * @name mdProgressCircular
 * @module material.components.progressCircular
 * @restrict E
 *
 * @description
 * The circular progress directive is used to make loading content in your app as delightful and
 * painless as possible by minimizing the amount of visual change a user sees before they can view
 * and interact with content.
 *
 * For operations where the percentage of the operation completed can be determined, use a
 * determinate indicator. They give users a quick sense of how long an operation will take.
 *
 * For operations where the user is asked to wait a moment while something finishes up, and it’s
 * not necessary to expose what's happening behind the scenes and how long it will take, use an
 * indeterminate indicator.
 *
 * @param {string} md-mode Select from one of two modes: **'determinate'** and **'indeterminate'**.
 *
 * Note: if the `md-mode` value is set as undefined or specified as not 1 of the two (2) valid modes, then **'indeterminate'**
 * will be auto-applied as the mode.
 *
 * Note: if not configured, the `md-mode="indeterminate"` will be auto injected as an attribute.
 * If `value=""` is also specified, however, then `md-mode="determinate"` would be auto-injected instead.
 * @param {number=} value In determinate mode, this number represents the percentage of the
 *     circular progress. Default: 0
 * @param {number=} md-diameter This specifies the diameter of the circular progress. The value
 * should be a pixel-size value (eg '100'). If this attribute is
 * not present then a default value of '50px' is assumed.
 *
 * @param {boolean=} ng-disabled Determines whether to disable the progress element.
 *
 * @usage
 * <hljs lang="html">
 * <md-progress-circular md-mode="determinate" value="..."></md-progress-circular>
 *
 * <md-progress-circular md-mode="determinate" ng-value="..."></md-progress-circular>
 *
 * <md-progress-circular md-mode="determinate" value="..." md-diameter="100"></md-progress-circular>
 *
 * <md-progress-circular md-mode="indeterminate"></md-progress-circular>
 * </hljs>
 */

MdProgressCircularDirective.$inject = ["$window", "$mdProgressCircular", "$mdTheming", "$mdUtil", "$interval", "$log"];
angular
  .module('material.components.progressCircular')
  .directive('mdProgressCircular', MdProgressCircularDirective);

/* @ngInject */
function MdProgressCircularDirective($window, $mdProgressCircular, $mdTheming,
                                     $mdUtil, $interval, $log) {

  // Note that this shouldn't use use $$rAF, because it can cause an infinite loop
  // in any tests that call $animate.flush.
  var rAF = $window.requestAnimationFrame ||
            $window.webkitRequestAnimationFrame ||
            angular.noop;

  var cAF = $window.cancelAnimationFrame ||
            $window.webkitCancelAnimationFrame ||
            $window.webkitCancelRequestAnimationFrame ||
            angular.noop;

  var MODE_DETERMINATE = 'determinate';
  var MODE_INDETERMINATE = 'indeterminate';
  var DISABLED_CLASS = '_md-progress-circular-disabled';
  var INDETERMINATE_CLASS = 'md-mode-indeterminate';

  return {
    restrict: 'E',
    scope: {
      value: '@',
      mdDiameter: '@',
      mdMode: '@'
    },
    template:
      '<svg xmlns="http://www.w3.org/2000/svg">' +
        '<path fill="none"/>' +
      '</svg>',
    compile: function(element, attrs) {
      element.attr({
        'aria-valuemin': 0,
        'aria-valuemax': 100,
        'role': 'progressbar'
      });

      if (angular.isUndefined(attrs.mdMode)) {
        var mode = attrs.hasOwnProperty('value') ? MODE_DETERMINATE : MODE_INDETERMINATE;
        attrs.$set('mdMode', mode);
      } else {
        attrs.$set('mdMode', attrs.mdMode.trim());
      }

      return MdProgressCircularLink;
    }
  };

  function MdProgressCircularLink(scope, element, attrs) {
    var node = element[0];
    var svg = angular.element(node.querySelector('svg'));
    var path = angular.element(node.querySelector('path'));
    var startIndeterminate = $mdProgressCircular.startIndeterminate;
    var endIndeterminate = $mdProgressCircular.endIndeterminate;
    var iterationCount = 0;
    var lastAnimationId = 0;
    var lastDrawFrame;
    var interval;

    $mdTheming(element);
    element.toggleClass(DISABLED_CLASS, attrs.hasOwnProperty('disabled'));

    // If the mode is indeterminate, it doesn't need to
    // wait for the next digest. It can start right away.
    if (scope.mdMode === MODE_INDETERMINATE){
      startIndeterminateAnimation();
    }

    scope.$on('$destroy', function(){
      cleanupIndeterminateAnimation();

      if (lastDrawFrame) {
        cAF(lastDrawFrame);
      }
    });

    scope.$watchGroup(['value', 'mdMode', function() {
      var isDisabled = node.disabled;

      // Sometimes the browser doesn't return a boolean, in
      // which case we should check whether the attribute is
      // present.
      if (isDisabled === true || isDisabled === false){
        return isDisabled;
      }

      return angular.isDefined(element.attr('disabled'));
    }], function(newValues, oldValues) {
      var mode = newValues[1];
      var isDisabled = newValues[2];
      var wasDisabled = oldValues[2];
      var diameter = 0;
      var strokeWidth = 0;

      if (isDisabled !== wasDisabled) {
        element.toggleClass(DISABLED_CLASS, !!isDisabled);
      }

      if (isDisabled) {
        cleanupIndeterminateAnimation();
      } else {
        if (mode !== MODE_DETERMINATE && mode !== MODE_INDETERMINATE) {
          mode = MODE_INDETERMINATE;
          attrs.$set('mdMode', mode);
        }

        if (mode === MODE_INDETERMINATE) {
          if (oldValues[1] === MODE_DETERMINATE) {
            diameter = getSize(scope.mdDiameter);
            strokeWidth = getStroke(diameter);
            path.attr('d', getSvgArc(diameter, strokeWidth, true));
            path.attr('stroke-dasharray', getDashLength(diameter, strokeWidth, 75));
          }
          startIndeterminateAnimation();
        } else {
          var newValue = clamp(newValues[0]);
          var oldValue = clamp(oldValues[0]);

          cleanupIndeterminateAnimation();

          if (oldValues[1] === MODE_INDETERMINATE) {
            diameter = getSize(scope.mdDiameter);
            strokeWidth = getStroke(diameter);
            path.attr('d', getSvgArc(diameter, strokeWidth, false));
            path.attr('stroke-dasharray', getDashLength(diameter, strokeWidth, 100));
          }

          element.attr('aria-valuenow', newValue);
          renderCircle(oldValue, newValue);
        }
      }

    });

    // This is in a separate watch in order to avoid layout, unless
    // the value has actually changed.
    scope.$watch('mdDiameter', function(newValue) {
      var diameter = getSize(newValue);
      var strokeWidth = getStroke(diameter);
      var value = clamp(scope.value);
      var transformOrigin = (diameter / 2) + 'px';
      var dimensions = {
        width: diameter + 'px',
        height: diameter + 'px'
      };

      // The viewBox has to be applied via setAttribute, because it is
      // case-sensitive. If jQuery is included in the page, `.attr` lowercases
      // all attribute names.
      svg[0].setAttribute('viewBox', '0 0 ' + diameter + ' ' + diameter);

      // Usually viewBox sets the dimensions for the SVG, however that doesn't
      // seem to be the case on IE10.
      // Important! The transform origin has to be set from here and it has to
      // be in the format of "Ypx Ypx Ypx", otherwise the rotation wobbles in
      // IE and Edge, because they don't account for the stroke width when
      // rotating. Also "center" doesn't help in this case, it has to be a
      // precise value.
      svg
        .css(dimensions)
        .css('transform-origin', transformOrigin + ' ' + transformOrigin + ' ' + transformOrigin);

      element.css(dimensions);

      path.attr('stroke-width', strokeWidth);
      path.attr('stroke-linecap', 'square');
      if (scope.mdMode == MODE_INDETERMINATE) {
        path.attr('d', getSvgArc(diameter, strokeWidth, true));
        path.attr('stroke-dasharray', getDashLength(diameter, strokeWidth, 75));
        path.attr('stroke-dashoffset', getDashOffset(diameter, strokeWidth, 1, 75));
      } else {
        path.attr('d', getSvgArc(diameter, strokeWidth, false));
        path.attr('stroke-dasharray', getDashLength(diameter, strokeWidth, 100));
        path.attr('stroke-dashoffset', getDashOffset(diameter, strokeWidth, 0, 100));
        renderCircle(value, value);
      }

    });

    function renderCircle(animateFrom, animateTo, easing, duration, iterationCount, maxValue) {
      var id = ++lastAnimationId;
      var startTime = $mdUtil.now();
      var changeInValue = animateTo - animateFrom;
      var diameter = getSize(scope.mdDiameter);
      var strokeWidth = getStroke(diameter);
      var ease = easing || $mdProgressCircular.easeFn;
      var animationDuration = duration || $mdProgressCircular.duration;
      var rotation = -90 * (iterationCount || 0);
      var dashLimit = maxValue || 100;

      // No need to animate it if the values are the same
      if (animateTo === animateFrom) {
        renderFrame(animateTo);
      } else {
        lastDrawFrame = rAF(function animation() {
          var currentTime = $window.Math.max(0, $window.Math.min($mdUtil.now() - startTime, animationDuration));

          renderFrame(ease(currentTime, animateFrom, changeInValue, animationDuration));

          // Do not allow overlapping animations
          if (id === lastAnimationId && currentTime < animationDuration) {
            lastDrawFrame = rAF(animation);
          }
        });
      }

      function renderFrame(value) {
        path.attr('stroke-dashoffset', getDashOffset(diameter, strokeWidth, value, dashLimit));
        path.attr('transform','rotate(' + (rotation) + ' ' + diameter/2 + ' ' + diameter/2 + ')');
      }
    }

    function animateIndeterminate() {
      renderCircle(
        startIndeterminate,
        endIndeterminate,
        $mdProgressCircular.easeFnIndeterminate,
        $mdProgressCircular.durationIndeterminate,
        iterationCount,
        75
      );

      // The %4 technically isn't necessary, but it keeps the rotation
      // under 360, instead of becoming a crazy large number.
      iterationCount = ++iterationCount % 4;

    }

    function startIndeterminateAnimation() {
      if (!interval) {
        // Note that this interval isn't supposed to trigger a digest.
        interval = $interval(
          animateIndeterminate,
          $mdProgressCircular.durationIndeterminate,
          0,
          false
        );

        animateIndeterminate();

        element
          .addClass(INDETERMINATE_CLASS)
          .removeAttr('aria-valuenow');
      }
    }

    function cleanupIndeterminateAnimation() {
      if (interval) {
        $interval.cancel(interval);
        interval = null;
        element.removeClass(INDETERMINATE_CLASS);
      }
    }
  }

  /**
   * Returns SVG path data for progress circle
   * Syntax spec: https://www.w3.org/TR/SVG/paths.html#PathDataEllipticalArcCommands
   *
   * @param {number} diameter Diameter of the container.
   * @param {number} strokeWidth Stroke width to be used when drawing circle
   * @param {boolean} indeterminate Use if progress circle will be used for indeterminate
   *
   * @returns {string} String representation of an SVG arc.
   */
  function getSvgArc(diameter, strokeWidth, indeterminate) {
    var radius = diameter / 2;
    var offset = strokeWidth / 2;
    var start = radius + ',' + offset; // ie: (25, 2.5) or 12 o'clock
    var end = offset + ',' + radius;   // ie: (2.5, 25) or  9 o'clock
    var arcRadius = radius - offset;
    return 'M' + start
         + 'A' + arcRadius + ',' + arcRadius + ' 0 1 1 ' + end // 75% circle
         + (indeterminate ? '' : 'A' + arcRadius + ',' + arcRadius + ' 0 0 1 ' + start); // loop to start
  }

  /**
   * Return stroke length for progress circle
   *
   * @param {number} diameter Diameter of the container.
   * @param {number} strokeWidth Stroke width to be used when drawing circle
   * @param {number} value Percentage of circle (between 0 and 100)
   * @param {number} maxArcLength Maximum length of arc as a percentage of circle (between 0 and 100)
   *
   * @returns {number} Stroke length for progress circle
   */
  function getDashOffset(diameter, strokeWidth, value, maxArcLength) {
    return getSpinnerCircumference(diameter, strokeWidth) * ((maxArcLength - value) / 100);
  }

  /**
   * Limits a value between 0 and 100.
   */
  function clamp(value) {
    return $window.Math.max(0, $window.Math.min(value || 0, 100));
  }

  /**
   * Determines the size of a progress circle, based on the provided
   * value in the following formats: `X`, `Ypx`, `Z%`.
   */
  function getSize(value) {
    var defaultValue = $mdProgressCircular.progressSize;

    if (value) {
      var parsed = parseFloat(value);

      if (value.lastIndexOf('%') === value.length - 1) {
        parsed = (parsed / 100) * defaultValue;
      }

      return parsed;
    }

    return defaultValue;
  }

  /**
   * Determines the circle's stroke width, based on
   * the provided diameter.
   */
  function getStroke(diameter) {
    return $mdProgressCircular.strokeWidth / 100 * diameter;
  }

  /**
   * Return length of the dash
   *
   * @param {number} diameter Diameter of the container.
   * @param {number} strokeWidth Stroke width to be used when drawing circle
   * @param {number} value Percentage of circle (between 0 and 100)
   *
   * @returns {number} Length of the dash
   */
  function getDashLength(diameter, strokeWidth, value) {
    return getSpinnerCircumference(diameter, strokeWidth) * (value / 100);
  }

  /**
   * Return circumference of the spinner
   *
   * @param {number} diameter Diameter of the container.
   * @param {number} strokeWidth Stroke width to be used when drawing circle
   *
   * @returns {number} Circumference of the spinner
   */
  function getSpinnerCircumference(diameter, strokeWidth) {
    return ((diameter - strokeWidth) * $window.Math.PI);
  }

}

})();
(function(){
"use strict";

/**
 * @ngdoc service
 * @name $mdProgressCircular
 * @module material.components.progressCircular
 *
 * @description
 * Allows the user to specify the default options for the `progressCircular` directive.
 *
 * @property {number} progressSize Diameter of the progress circle in pixels.
 * @property {number} strokeWidth Width of the circle's stroke as a percentage of the circle's size.
 * @property {number} duration Length of the circle animation in milliseconds.
 * @property {function} easeFn Default easing animation function.
 * @property {object} easingPresets Collection of pre-defined easing functions.
 *
 * @property {number} durationIndeterminate Duration of the indeterminate animation.
 * @property {number} startIndeterminate Indeterminate animation start point.
 * @property {number} endIndeterminate Indeterminate animation end point.
 * @property {function} easeFnIndeterminate Easing function to be used when animating
 * between the indeterminate values.
 *
 * @property {(function(object): object)} configure Used to modify the default options.
 *
 * @usage
 * <hljs lang="js">
 *   myAppModule.config(function($mdProgressCircularProvider) {
 *
 *     // Example of changing the default progress options.
 *     $mdProgressCircularProvider.configure({
 *       progressSize: 100,
 *       strokeWidth: 20,
 *       duration: 800
 *     });
 * });
 * </hljs>
 *
 */

angular
  .module('material.components.progressCircular')
  .provider("$mdProgressCircular", MdProgressCircularProvider);

function MdProgressCircularProvider() {
  var progressConfig = {
    progressSize: 50,
    strokeWidth: 10,
    duration: 100,
    easeFn: linearEase,

    durationIndeterminate: 1333,
    startIndeterminate: 1,
    endIndeterminate: 149,
    easeFnIndeterminate: materialEase,

    easingPresets: {
      linearEase: linearEase,
      materialEase: materialEase
    }
  };

  return {
    configure: function(options) {
      progressConfig = angular.extend(progressConfig, options || {});
      return progressConfig;
    },
    $get: function() { return progressConfig; }
  };

  function linearEase(t, b, c, d) {
    return c * t / d + b;
  }

  function materialEase(t, b, c, d) {
    // via http://www.timotheegroleau.com/Flash/experiments/easing_function_generator.htm
    // with settings of [0, 0, 1, 1]
    var ts = (t /= d) * t;
    var tc = ts * t;
    return b + c * (6 * tc * ts + -15 * ts * ts + 10 * tc);
  }
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.progressLinear
 * @description Linear Progress module!
 */
MdProgressLinearDirective.$inject = ["$mdTheming", "$mdUtil", "$log"];
angular.module('material.components.progressLinear', [
  'material.core'
])
  .directive('mdProgressLinear', MdProgressLinearDirective);

/**
 * @ngdoc directive
 * @name mdProgressLinear
 * @module material.components.progressLinear
 * @restrict E
 *
 * @description
 * The linear progress directive is used to make loading content
 * in your app as delightful and painless as possible by minimizing
 * the amount of visual change a user sees before they can view
 * and interact with content.
 *
 * Each operation should only be represented by one activity indicator
 * For example: one refresh operation should not display both a
 * refresh bar and an activity circle.
 *
 * For operations where the percentage of the operation completed
 * can be determined, use a determinate indicator. They give users
 * a quick sense of how long an operation will take.
 *
 * For operations where the user is asked to wait a moment while
 * something finishes up, and it’s not necessary to expose what's
 * happening behind the scenes and how long it will take, use an
 * indeterminate indicator.
 *
 * @param {string} md-mode Select from one of four modes: determinate, indeterminate, buffer or query.
 *
 * Note: if the `md-mode` value is set as undefined or specified as 1 of the four (4) valid modes, then `indeterminate`
 * will be auto-applied as the mode.
 *
 * Note: if not configured, the `md-mode="indeterminate"` will be auto injected as an attribute. If `value=""` is also specified, however,
 * then `md-mode="determinate"` would be auto-injected instead.
 * @param {number=} value In determinate and buffer modes, this number represents the percentage of the primary progress bar. Default: 0
 * @param {number=} md-buffer-value In the buffer mode, this number represents the percentage of the secondary progress bar. Default: 0
 * @param {boolean=} ng-disabled Determines whether to disable the progress element.
 *
 * @usage
 * <hljs lang="html">
 * <md-progress-linear md-mode="determinate" value="..."></md-progress-linear>
 *
 * <md-progress-linear md-mode="determinate" ng-value="..."></md-progress-linear>
 *
 * <md-progress-linear md-mode="indeterminate"></md-progress-linear>
 *
 * <md-progress-linear md-mode="buffer" value="..." md-buffer-value="..."></md-progress-linear>
 *
 * <md-progress-linear md-mode="query"></md-progress-linear>
 * </hljs>
 */
function MdProgressLinearDirective($mdTheming, $mdUtil, $log) {
  var MODE_DETERMINATE = "determinate";
  var MODE_INDETERMINATE = "indeterminate";
  var MODE_BUFFER = "buffer";
  var MODE_QUERY = "query";
  var DISABLED_CLASS = "_md-progress-linear-disabled";

  return {
    restrict: 'E',
    template: '<div class="md-container">' +
      '<div class="md-dashed"></div>' +
      '<div class="md-bar md-bar1"></div>' +
      '<div class="md-bar md-bar2"></div>' +
      '</div>',
    compile: compile
  };

  function compile(tElement, tAttrs, transclude) {
    tElement.attr('aria-valuemin', 0);
    tElement.attr('aria-valuemax', 100);
    tElement.attr('role', 'progressbar');

    return postLink;
  }
  function postLink(scope, element, attr) {
    $mdTheming(element);

    var lastMode;
    var isDisabled = attr.hasOwnProperty('disabled');
    var toVendorCSS = $mdUtil.dom.animator.toCss;
    var bar1 = angular.element(element[0].querySelector('.md-bar1'));
    var bar2 = angular.element(element[0].querySelector('.md-bar2'));
    var container = angular.element(element[0].querySelector('.md-container'));

    element
      .attr('md-mode', mode())
      .toggleClass(DISABLED_CLASS, isDisabled);

    validateMode();
    watchAttributes();

    /**
     * Watch the value, md-buffer-value, and md-mode attributes
     */
    function watchAttributes() {
      attr.$observe('value', function(value) {
        var percentValue = clamp(value);
        element.attr('aria-valuenow', percentValue);

        if (mode() != MODE_QUERY) animateIndicator(bar2, percentValue);
      });

      attr.$observe('mdBufferValue', function(value) {
        animateIndicator(bar1, clamp(value));
      });

      attr.$observe('disabled', function(value) {
        if (value === true || value === false) {
          isDisabled = !!value;
        } else {
          isDisabled = angular.isDefined(value);
        }

        element.toggleClass(DISABLED_CLASS, isDisabled);
        container.toggleClass(lastMode, !isDisabled);
      });

      attr.$observe('mdMode', function(mode) {
        if (lastMode) container.removeClass(lastMode);

        switch (mode) {
          case MODE_QUERY:
          case MODE_BUFFER:
          case MODE_DETERMINATE:
          case MODE_INDETERMINATE:
            container.addClass(lastMode = "md-mode-" + mode);
            break;
          default:
            container.addClass(lastMode = "md-mode-" + MODE_INDETERMINATE);
            break;
        }
      });
    }

    /**
     * Auto-defaults the mode to either `determinate` or `indeterminate` mode; if not specified
     */
    function validateMode() {
      if (angular.isUndefined(attr.mdMode)) {
        var hasValue = angular.isDefined(attr.value);
        var mode = hasValue ? MODE_DETERMINATE : MODE_INDETERMINATE;
        var info = "Auto-adding the missing md-mode='{0}' to the ProgressLinear element";
        element.attr("md-mode", mode);
        attr.mdMode = mode;
      }
    }

    /**
     * Is the md-mode a valid option?
     */
    function mode() {
      var value = (attr.mdMode || "").trim();
      if (value) {
        switch (value) {
          case MODE_DETERMINATE:
          case MODE_INDETERMINATE:
          case MODE_BUFFER:
          case MODE_QUERY:
            break;
          default:
            value = MODE_INDETERMINATE;
            break;
        }
      }
      return value;
    }

    /**
     * Manually set CSS to animate the Determinate indicator based on the specified
     * percentage value (0-100).
     */
    function animateIndicator(target, value) {
      if (isDisabled || !mode()) return;

      var to = $mdUtil.supplant("translateX({0}%) scale({1},1)", [(value-100)/2, value/100]);
      var styles = toVendorCSS({ transform : to });
      angular.element(target).css(styles);
    }
  }

  /**
   * Clamps the value to be between 0 and 100.
   * @param {number} value The value to clamp.
   * @returns {number}
   */
  function clamp(value) {
    return Math.max(0, Math.min(value || 0, 100));
  }
}


})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.radioButton
 * @description radioButton module!
 */
mdRadioGroupDirective.$inject = ["$mdUtil", "$mdConstant", "$mdTheming", "$timeout"];
mdRadioButtonDirective.$inject = ["$mdAria", "$mdUtil", "$mdTheming"];
angular.module('material.components.radioButton', [
  'material.core'
])
  .directive('mdRadioGroup', mdRadioGroupDirective)
  .directive('mdRadioButton', mdRadioButtonDirective);

/**
 * @type {Readonly<{NEXT: number, CURRENT: number, PREVIOUS: number}>}
 */
var incrementSelection = Object.freeze({PREVIOUS: -1, CURRENT: 0, NEXT: 1});

/**
 * @ngdoc directive
 * @module material.components.radioButton
 * @name mdRadioGroup
 *
 * @restrict E
 *
 * @description
 * The `<md-radio-group>` directive identifies a grouping
 * container for the 1..n grouped radio buttons; specified using nested
 * `<md-radio-button>` elements.
 *
 * The radio button uses the accent color by default. The primary color palette may be used with
 * the `md-primary` class.
 *
 * Note: `<md-radio-group>` and `<md-radio-button>` handle `tabindex` differently
 * than the native `<input type="radio">` controls. Whereas the native controls
 * force the user to tab through all the radio buttons, `<md-radio-group>`
 * is focusable and by default the `<md-radio-button>`s are not.
 *
 * @param {string} ng-model Assignable angular expression to data-bind to.
 * @param {string=} ng-change AngularJS expression to be executed when input changes due to user
 *    interaction.
 * @param {boolean=} md-no-ink If present, disables ink ripple effects.
 *
 * @usage
 * <hljs lang="html">
 * <md-radio-group ng-model="selected">
 *   <md-radio-button ng-repeat="item in items"
 *                    ng-value="item.value" aria-label="{{item.label}}">
 *     {{ item.label }}
 *   </md-radio-button>
 * </md-radio-group>
 * </hljs>
 */
function mdRadioGroupDirective($mdUtil, $mdConstant, $mdTheming, $timeout) {
  RadioGroupController.prototype = createRadioGroupControllerProto();

  return {
    restrict: 'E',
    controller: ['$element', RadioGroupController],
    require: ['mdRadioGroup', '?ngModel'],
    link: { pre: linkRadioGroup }
  };

  function linkRadioGroup(scope, element, attr, controllers) {
    // private md component indicator for styling
    element.addClass('_md');
    $mdTheming(element);

    var radioGroupController = controllers[0];
    var ngModelCtrl = controllers[1] || $mdUtil.fakeNgModel();

    radioGroupController.init(ngModelCtrl);

    scope.mouseActive = false;

    element
      .attr({
        'role': 'radiogroup',
        'tabIndex': element.attr('tabindex') || '0'
      })
      .on('keydown', keydownListener)
      .on('mousedown', function() {
        scope.mouseActive = true;
        $timeout(function() {
          scope.mouseActive = false;
        }, 100);
      })
      .on('focus', function() {
        if (scope.mouseActive === false) {
          radioGroupController.$element.addClass('md-focused');
        }
      })
      .on('blur', function() {
        radioGroupController.$element.removeClass('md-focused');
      });

    // Initially set the first radio button as the aria-activedescendant. This will be overridden
    // if a 'checked' radio button gets rendered. We need to wait for the nextTick here so that the
    // radio buttons have their id values assigned.
    $mdUtil.nextTick(function () {
      var radioButtons = getRadioButtons(radioGroupController.$element);
      if (radioButtons.count() &&
          !radioGroupController.$element[0].hasAttribute('aria-activedescendant')) {
        radioGroupController.setActiveDescendant(radioButtons.first().id);
      }
    });

    /**
     * Apply the md-focused class if it isn't already applied.
     */
    function setFocus() {
      if (!element.hasClass('md-focused')) { element.addClass('md-focused'); }
    }

    /**
     * @param {KeyboardEvent} keyboardEvent
     */
    function keydownListener(keyboardEvent) {
      var keyCode = keyboardEvent.which || keyboardEvent.keyCode;

      // Only listen to events that we originated ourselves
      // so that we don't trigger on things like arrow keys in inputs.
      if (keyCode !== $mdConstant.KEY_CODE.ENTER &&
          keyboardEvent.currentTarget !== keyboardEvent.target) {
        return;
      }

      switch (keyCode) {
        case $mdConstant.KEY_CODE.LEFT_ARROW:
        case $mdConstant.KEY_CODE.UP_ARROW:
          keyboardEvent.preventDefault();
          radioGroupController.selectPrevious();
          setFocus();
          break;

        case $mdConstant.KEY_CODE.RIGHT_ARROW:
        case $mdConstant.KEY_CODE.DOWN_ARROW:
          keyboardEvent.preventDefault();
          radioGroupController.selectNext();
          setFocus();
          break;

        case $mdConstant.KEY_CODE.SPACE:
          keyboardEvent.preventDefault();
          radioGroupController.selectCurrent();
          break;

        case $mdConstant.KEY_CODE.ENTER:
          var form = angular.element($mdUtil.getClosest(element[0], 'form'));
          if (form.length > 0) {
            form.triggerHandler('submit');
          }
          break;
      }
    }
  }

  /**
   * @param {JQLite} $element
   * @constructor
   */
  function RadioGroupController($element) {
    this._radioButtonRenderFns = [];
    this.$element = $element;
  }

  function createRadioGroupControllerProto() {
    return {
      init: function(ngModelCtrl) {
        this._ngModelCtrl = ngModelCtrl;
        this._ngModelCtrl.$render = angular.bind(this, this.render);
      },
      add: function(rbRender) {
        this._radioButtonRenderFns.push(rbRender);
      },
      remove: function(rbRender) {
        var index = this._radioButtonRenderFns.indexOf(rbRender);
        if (index !== -1) {
          this._radioButtonRenderFns.splice(index, 1);
        }
      },
      render: function() {
        this._radioButtonRenderFns.forEach(function(rbRender) {
          rbRender();
        });
      },
      setViewValue: function(value, eventType) {
        this._ngModelCtrl.$setViewValue(value, eventType);
        // update the other radio buttons as well
        this.render();
      },
      getViewValue: function() {
        return this._ngModelCtrl.$viewValue;
      },
      selectCurrent: function() {
        return changeSelectedButton(this.$element, incrementSelection.CURRENT);
      },
      selectNext: function() {
        return changeSelectedButton(this.$element, incrementSelection.NEXT);
      },
      selectPrevious: function() {
        return changeSelectedButton(this.$element, incrementSelection.PREVIOUS);
      },
      setActiveDescendant: function (radioId) {
        this.$element.attr('aria-activedescendant', radioId);
      },
      isDisabled: function() {
        return this.$element[0].hasAttribute('disabled');
      }
    };
  }

  /**
   * Coerce all child radio buttons into an array, then wrap them in an iterator.
   * @param parent {!JQLite}
   * @return {{add: add, next: (function()), last: (function(): any|null), previous: (function()), count: (function(): number), hasNext: (function(*=): Array.length|*|number|boolean), inRange: (function(*): boolean), remove: remove, contains: (function(*=): *|boolean), itemAt: (function(*=): any|null), findBy: (function(*, *): *[]), hasPrevious: (function(*=): Array.length|*|number|boolean), items: (function(): *[]), indexOf: (function(*=): number), first: (function(): any|null)}}
   */
  function getRadioButtons(parent) {
    return $mdUtil.iterator(parent[0].querySelectorAll('md-radio-button'), true);
  }

  /**
   * Change the radio group's selected button by a given increment.
   * If no button is selected, select the first button.
   * @param {JQLite} parent the md-radio-group
   * @param {incrementSelection} increment enum that determines whether the next or
   *  previous button is clicked. For current, only the first button is selected, otherwise the
   *  current selection is maintained (by doing nothing).
   */
  function changeSelectedButton(parent, increment) {
    var buttons = getRadioButtons(parent);
    var target;

    if (buttons.count()) {
      var validate = function (button) {
        // If disabled, then NOT valid
        return !angular.element(button).attr("disabled");
      };

      var selected = parent[0].querySelector('md-radio-button.md-checked');
      if (!selected) {
        target = buttons.first();
      } else if (increment === incrementSelection.PREVIOUS ||
                 increment === incrementSelection.NEXT) {
        target = buttons[
          increment === incrementSelection.PREVIOUS ? 'previous' : 'next'
        ](selected, validate);
      }

      if (target) {
        // Activate radioButton's click listener (triggerHandler won't create a real click event)
        angular.element(target).triggerHandler('click');
      }
    }
  }
}

/**
 * @ngdoc directive
 * @module material.components.radioButton
 * @name mdRadioButton
 *
 * @restrict E
 *
 * @description
 * The `<md-radio-button>`directive is the child directive required to be used within `<md-radio-group>` elements.
 *
 * While similar to the `<input type="radio" ng-model="" value="">` directive,
 * the `<md-radio-button>` directive provides ink effects, ARIA support, and
 * supports use within named radio groups.
 *
 * One of `value` or `ng-value` must be set so that the `md-radio-group`'s model is set properly when the
 * `md-radio-button` is selected.
 *
 * @param {string} value The value to which the model should be set when selected.
 * @param {string} ng-value AngularJS expression which sets the value to which the model should
 *    be set when selected.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} aria-label Adds label to radio button for accessibility.
 *    Defaults to radio button's text. If no text content is available, a warning will be logged.
 *
 * @usage
 * <hljs lang="html">
 *
 * <md-radio-button value="1" aria-label="Label 1">
 *   Label 1
 * </md-radio-button>
 *
 * <md-radio-button ng-value="specialValue" aria-label="Green">
 *   Green
 * </md-radio-button>
 *
 * </hljs>
 *
 */
function mdRadioButtonDirective($mdAria, $mdUtil, $mdTheming) {

  var CHECKED_CSS = 'md-checked';

  return {
    restrict: 'E',
    require: '^mdRadioGroup',
    transclude: true,
    template: '<div class="md-container" md-ink-ripple md-ink-ripple-checkbox>' +
                '<div class="md-off"></div>' +
                '<div class="md-on"></div>' +
              '</div>' +
              '<div ng-transclude class="md-label"></div>',
    link: link
  };

  function link(scope, element, attr, radioGroupController) {
    var lastChecked;

    $mdTheming(element);
    configureAria(element);
    element.addClass('md-auto-horizontal-margin');

    // ngAria overwrites the aria-checked inside a $watch for ngValue.
    // We should defer the initialization until all the watches have fired.
    // This can also be fixed by removing the `lastChecked` check, but that'll
    // cause more DOM manipulation on each digest.
    if (attr.ngValue) {
      $mdUtil.nextTick(initialize, false);
    } else {
      initialize();
    }

    /**
     * Initializes the component.
     */
    function initialize() {
      if (!radioGroupController) {
        throw 'RadioButton: No RadioGroupController could be found.';
      }

      radioGroupController.add(render);
      attr.$observe('value', render);

      element
        .on('click', listener)
        .on('$destroy', function() {
          radioGroupController.remove(render);
        });
    }

    /**
     * On click functionality.
     */
    function listener(ev) {
      if (element[0].hasAttribute('disabled') || radioGroupController.isDisabled()) return;

      scope.$apply(function() {
        radioGroupController.setViewValue(attr.value, ev && ev.type);
      });
    }

    /**
     * Add or remove the `.md-checked` class from the RadioButton (and conditionally its parent).
     * Update the `aria-activedescendant` attribute.
     */
    function render() {
      var checked = radioGroupController.getViewValue() == attr.value;

      if (checked === lastChecked) return;

      if (element[0] && element[0].parentNode &&
          element[0].parentNode.nodeName.toLowerCase() !== 'md-radio-group') {
        // If the radioButton is inside a div, then add class so highlighting will work.
        element.parent().toggleClass(CHECKED_CSS, checked);
      }

      if (checked) {
        radioGroupController.setActiveDescendant(element.attr('id'));
      }

      lastChecked = checked;

      element
        .attr('aria-checked', checked)
        .toggleClass(CHECKED_CSS, checked);
    }

    /**
     * Inject ARIA-specific attributes appropriate for each radio button
     */
    function configureAria(element) {
      element.attr({
        id: attr.id || 'radio_' + $mdUtil.nextUid(),
        role: 'radio',
        'aria-checked': 'false'
      });

      $mdAria.expectWithText(element, 'aria-label');
    }
  }
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.select
 */

/***************************************************

 ### TODO ###
 - [ ] Abstract placement logic in $mdSelect service to $mdMenu service

 ***************************************************/

SelectDirective.$inject = ["$mdSelect", "$mdUtil", "$mdConstant", "$mdTheming", "$mdAria", "$parse", "$sce"];
SelectMenuDirective.$inject = ["$parse", "$mdUtil", "$mdConstant", "$mdTheming"];
OptionDirective.$inject = ["$mdButtonInkRipple", "$mdUtil", "$mdTheming"];
SelectProvider.$inject = ["$$interimElementProvider"];
OptionController.$inject = ["$element"];
var SELECT_EDGE_MARGIN = 8;
var selectNextId = 0;
var CHECKBOX_SELECTION_INDICATOR;

angular.module('material.components.select', [
    'material.core',
    'material.components.backdrop'
  ])
  .directive('mdSelect', SelectDirective)
  .directive('mdSelectMenu', SelectMenuDirective)
  .directive('mdOption', OptionDirective)
  .directive('mdOptgroup', OptgroupDirective)
  .directive('mdSelectHeader', SelectHeaderDirective)
  .provider('$mdSelect', SelectProvider);

/**
 * @ngdoc directive
 * @name mdSelect
 * @restrict E
 * @module material.components.select
 *
 * @description Displays a select box, bound to an `ng-model`. Selectable options are defined using
 * the <a ng-href="api/directive/mdOption">md-option</a> element directive. Options can be grouped
 * using the <a ng-href="api/directive/mdOptgroup">md-optgroup</a> element directive.
 *
 * When the select is required and uses a floating label, then the label will automatically contain
 * an asterisk (`*`). This behavior can be disabled by using the `md-no-asterisk` attribute.
 *
 * By default, the select will display with an underline to match other form elements. This can be
 * disabled by applying the `md-no-underline` CSS class.
 *
 * @param {expression} ng-model Assignable angular expression to data-bind to.
 * @param {expression=} ng-change Expression to be executed when the model value changes.
 * @param {boolean=} multiple When present, allows for more than one option to be selected.
 *  The model is an array with the selected choices. **Note:** This attribute is only evaluated
 *  once; it is not watched.
 * @param {expression=} md-on-close Expression to be evaluated when the select is closed.
 * @param {expression=} md-on-open Expression to be evaluated when opening the select.
 *  Will hide the select options and show a spinner until the evaluated promise resolves.
 * @param {expression=} md-selected-text Expression to be evaluated that will return a string
 *  to be displayed as a placeholder in the select input box when it is closed. The value
 *  will be treated as *text* (not html).
 * @param {expression=} md-selected-html Expression to be evaluated that will return a string
 *  to be displayed as a placeholder in the select input box when it is closed. The value
 *  will be treated as *html*. The value must either be explicitly marked as trustedHtml or
 *  the ngSanitize module must be loaded.
 * @param {string=} placeholder Placeholder hint text.
 * @param {boolean=} md-no-asterisk When set to true, an asterisk will not be appended to the
 *  floating label. **Note:** This attribute is only evaluated once; it is not watched.
 * @param {string=} aria-label Optional label for accessibility. Only necessary if no explicit label
 *  is present.
 * @param {string=} md-container-class Class list to get applied to the `.md-select-menu-container`
 *  element (for custom styling).
 * @param {string=} md-select-only-option If specified, a `<md-select>` will automatically select
 * it's first option, if it only has one.
 *
 * @usage
 * With a placeholder (label and aria-label are added dynamically)
 * <hljs lang="html">
 *   <md-input-container>
 *     <md-select
 *       ng-model="someModel"
 *       placeholder="Select a state">
 *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
 *     </md-select>
 *   </md-input-container>
 * </hljs>
 *
 * With an explicit label
 * <hljs lang="html">
 *   <md-input-container>
 *     <label>State</label>
 *     <md-select
 *       ng-model="someModel">
 *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
 *     </md-select>
 *   </md-input-container>
 * </hljs>
 *
 * Using the `md-select-header` element directive
 *
 * When a developer needs to put more than just a text label in the `md-select-menu`, they should
 * use one or more `md-select-header`s. These elements can contain custom HTML which can be styled
 * as desired. Use cases for this element include a sticky search bar and custom option group
 * labels.
 *
 * <hljs lang="html">
 *   <md-input-container>
 *     <md-select ng-model="someModel">
 *       <md-select-header>
 *         <span> Neighborhoods - </span>
 *       </md-select-header>
 *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
 *     </md-select>
 *   </md-input-container>
 * </hljs>
 *
 * ## Selects and object equality
 * When using a `md-select` to pick from a list of objects, it is important to realize how javascript handles
 * equality. Consider the following example:
 * <hljs lang="js">
 * angular.controller('MyCtrl', function($scope) {
 *   $scope.users = [
 *     { id: 1, name: 'Bob' },
 *     { id: 2, name: 'Alice' },
 *     { id: 3, name: 'Steve' }
 *   ];
 *   $scope.selectedUser = { id: 1, name: 'Bob' };
 * });
 * </hljs>
 * <hljs lang="html">
 * <div ng-controller="MyCtrl">
 *   <md-select ng-model="selectedUser">
 *     <md-option ng-value="user" ng-repeat="user in users">{{ user.name }}</md-option>
 *   </md-select>
 * </div>
 * </hljs>
 *
 * At first one might expect that the select should be populated with "Bob" as the selected user.
 * However, this is not true. To determine whether something is selected,
 * `ngModelController` is looking at whether `$scope.selectedUser == (any user in $scope.users);`;
 *
 * Javascript's `==` operator does not check for deep equality (ie. that all properties
 * on the object are the same), but instead whether the objects are *the same object in memory*.
 * In this case, we have two instances of identical objects, but they exist in memory as unique
 * entities. Because of this, the select will have no value populated for a selected user.
 *
 * To get around this, `ngModelController` provides a `track by` option that allows us to specify a
 * different expression which will be used for the equality operator. As such, we can update our
 * `html` to make use of this by specifying the `ng-model-options="{trackBy: '$value.id'}"` on the
 * `md-select` element. This converts our equality expression to be
 * `$scope.selectedUser.id == (any id in $scope.users.map(function(u) { return u.id; }));`
 * which results in Bob being selected as desired.
 *
 * **Note:** We do not support AngularJS's `track by` syntax. For instance
 *  `ng-options="user in users track by user.id"` will not work with `md-select`.
 *
 * Working HTML:
 * <hljs lang="html">
 * <div ng-controller="MyCtrl">
 *   <md-select ng-model="selectedUser" ng-model-options="{trackBy: '$value.id'}">
 *     <md-option ng-value="user" ng-repeat="user in users">{{ user.name }}</md-option>
 *   </md-select>
 * </div>
 * </hljs>
 */
function SelectDirective($mdSelect, $mdUtil, $mdConstant, $mdTheming, $mdAria, $parse, $sce) {
  return {
    restrict: 'E',
    require: ['^?mdInputContainer', 'mdSelect', 'ngModel', '?^form'],
    compile: compile,
    controller: function() {
    } // empty placeholder controller to be initialized in link
  };

  /**
   * @param {JQLite} tElement
   * @param {IAttributes} tAttrs
   * @return {postLink}
   */
  function compile(tElement, tAttrs) {
    var isMultiple = $mdUtil.parseAttributeBoolean(tAttrs.multiple);
    tElement.addClass('md-auto-horizontal-margin');

    // add the select value that will hold our placeholder or selected option value
    var valueEl = angular.element('<md-select-value><span></span></md-select-value>');
    valueEl.append('<span class="md-select-icon" aria-hidden="true"></span>');
    valueEl.addClass('md-select-value');
    if (!valueEl[0].hasAttribute('id')) {
      valueEl.attr('id', 'select_value_label_' + $mdUtil.nextUid());
    }

    // There's got to be an md-content inside. If there's not one, let's add it.
    var mdContentEl = tElement.find('md-content');
    if (!mdContentEl.length) {
      tElement.append(angular.element('<md-content>').append(tElement.contents()));
      mdContentEl = tElement.find('md-content');
    }
    mdContentEl.attr('role', 'listbox');
    mdContentEl.attr('tabindex', '-1');

    if (isMultiple) {
      mdContentEl.attr('aria-multiselectable', 'true');
    } else {
      mdContentEl.attr('aria-multiselectable', 'false');
    }

    // Add progress spinner for md-options-loading
    if (tAttrs.mdOnOpen) {

      // Show progress indicator while loading async
      // Use ng-hide for `display:none` so the indicator does not interfere with the options list
      tElement
        .find('md-content')
        .prepend(angular.element(
          '<div>' +
          ' <md-progress-circular md-mode="indeterminate" ng-if="$$loadingAsyncDone === false"' +
          ' md-diameter="25px"></md-progress-circular>' +
          '</div>'
        ));

      // Hide list [of item options] while loading async
      tElement
        .find('md-option')
        .attr('ng-show', '$$loadingAsyncDone');
    }

    if (tAttrs.name) {
      var autofillClone = angular.element('<select class="md-visually-hidden"></select>');
      autofillClone.attr({
        'name': tAttrs.name,
        'aria-hidden': 'true',
        'tabindex': '-1'
      });
      var opts = tElement.find('md-option');
      angular.forEach(opts, function(el) {
        var newEl = angular.element('<option>' + el.innerHTML + '</option>');
        if (el.hasAttribute('ng-value')) {
          newEl.attr('ng-value', el.getAttribute('ng-value'));
        }
        else if (el.hasAttribute('value')) {
          newEl.attr('value', el.getAttribute('value'));
        }
        autofillClone.append(newEl);
      });

      // Adds an extra option that will hold the selected value for the
      // cases where the select is a part of a non-AngularJS form. This can be done with a ng-model,
      // however if the `md-option` is being `ng-repeat`-ed, AngularJS seems to insert a similar
      // `option` node, but with a value of `? string: <value> ?` which would then get submitted.
      // This also goes around having to prepend a dot to the name attribute.
      autofillClone.append(
        '<option ng-value="' + tAttrs.ngModel + '" selected></option>'
      );

      tElement.parent().append(autofillClone);
    }

    // Use everything that's left inside element.contents() as the contents of the menu
    var multipleContent = isMultiple ? 'multiple' : '';
    var ngModelOptions = tAttrs.ngModelOptions ? $mdUtil.supplant('ng-model-options="{0}"', [tAttrs.ngModelOptions]) : '';
    var selectTemplate = '' +
      '<div class="md-select-menu-container" aria-hidden="true" role="presentation">' +
      '  <md-select-menu role="presentation" {0} {1}>{2}</md-select-menu>' +
      '</div>';

    selectTemplate = $mdUtil.supplant(selectTemplate, [multipleContent, ngModelOptions,  tElement.html()]);
    tElement.empty().append(valueEl);
    tElement.append(selectTemplate);

    if (!tAttrs.tabindex) {
      tAttrs.$set('tabindex', 0);
    }

    return function postLink(scope, element, attrs, ctrls) {
      var untouched = true;
      var isDisabled;

      var containerCtrl = ctrls[0];
      var mdSelectCtrl = ctrls[1];
      var ngModelCtrl = ctrls[2];
      var formCtrl = ctrls[3];
      // grab a reference to the select menu value label
      var selectValueElement = element.find('md-select-value');
      var isReadonly = angular.isDefined(attrs.readonly);
      var disableAsterisk = $mdUtil.parseAttributeBoolean(attrs.mdNoAsterisk);
      var stopMdMultipleWatch;
      var userDefinedLabelledby = angular.isDefined(attrs.ariaLabelledby);
      var listboxContentElement = element.find('md-content');
      var initialPlaceholder = element.attr('placeholder');

      if (disableAsterisk) {
        element.addClass('md-no-asterisk');
      }

      if (containerCtrl) {
        var isErrorGetter = containerCtrl.isErrorGetter || function() {
          return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (formCtrl && formCtrl.$submitted));
        };

        if (containerCtrl.input) {
          // We ignore inputs that are in the md-select-header.
          // One case where this might be useful would be adding as searchbox.
          if (element.find('md-select-header').find('input')[0] !== containerCtrl.input[0]) {
            throw new Error("<md-input-container> can only have *one* child <input>, <textarea>, or <select> element!");
          }
        }

        containerCtrl.input = element;
        if (!containerCtrl.label) {
          $mdAria.expect(element, 'aria-label', initialPlaceholder);
          var selectLabel = element.attr('aria-label');
          if (!selectLabel) {
            selectLabel = initialPlaceholder;
          }
          listboxContentElement.attr('aria-label', selectLabel);
        } else {
          containerCtrl.label.attr('aria-hidden', 'true');
          listboxContentElement.attr('aria-label', containerCtrl.label.text());
          containerCtrl.setHasPlaceholder(!!initialPlaceholder);
        }

        var stopInvalidWatch = scope.$watch(isErrorGetter, containerCtrl.setInvalid);
      }

      var selectContainer, selectScope, selectMenuCtrl;

      selectContainer = findSelectContainer();
      $mdTheming(element);

      var originalRender = ngModelCtrl.$render;
      ngModelCtrl.$render = function() {
        originalRender();
        syncSelectValueText();
        inputCheckValue();
      };

      var stopPlaceholderObserver = attrs.$observe('placeholder', ngModelCtrl.$render);

      var stopRequiredObserver = attrs.$observe('required', function (value) {
        if (containerCtrl && containerCtrl.label) {
          // Toggle the md-required class on the input containers label, because the input container
          // is automatically applying the asterisk indicator on the label.
          containerCtrl.label.toggleClass('md-required', value && !disableAsterisk);
        }
        element.removeAttr('aria-required');
        if (value) {
          listboxContentElement.attr('aria-required', 'true');
        } else {
          listboxContentElement.removeAttr('aria-required');
        }
      });

      /**
       * Set the contents of the md-select-value element. This element's contents are announced by
       * screen readers and used for displaying the value of the select in both single and multiple
       * selection modes.
       * @param {string=} text A sanitized and trusted HTML string or a pure text string from user
       *  input.
       */
      mdSelectCtrl.setSelectValueText = function(text) {
        var useDefaultText = text === undefined || text === '';
        // Whether the select label has been given via user content rather than the internal
        // template of <md-option>
        var isSelectLabelFromUser = false;

        mdSelectCtrl.setIsPlaceholder(!text);

        if (attrs.mdSelectedText && attrs.mdSelectedHtml) {
          throw Error('md-select cannot have both `md-selected-text` and `md-selected-html`');
        }

        if (attrs.mdSelectedText || attrs.mdSelectedHtml) {
          text = $parse(attrs.mdSelectedText || attrs.mdSelectedHtml)(scope);
          isSelectLabelFromUser = true;
        } else if (useDefaultText) {
          // Use placeholder attribute, otherwise fallback to the md-input-container label
          var tmpPlaceholder = attrs.placeholder ||
              (containerCtrl && containerCtrl.label ? containerCtrl.label.text() : '');

          text = tmpPlaceholder || '';
          isSelectLabelFromUser = true;
        }

        var target = selectValueElement.children().eq(0);

        if (attrs.mdSelectedHtml) {
          // Using getTrustedHtml will run the content through $sanitize if it is not already
          // explicitly trusted. If the ngSanitize module is not loaded, this will
          // *correctly* throw an sce error.
          target.html($sce.getTrustedHtml(text));
        } else if (isSelectLabelFromUser) {
          target.text(text);
        } else {
          // If we've reached this point, the text is not user-provided.
          target.html(text);
        }

        if (useDefaultText) {
          // Avoid screen readers double announcing the label name when no value has been selected
          selectValueElement.attr('aria-hidden', 'true');
          if (!userDefinedLabelledby) {
            element.removeAttr('aria-labelledby');
          }
        } else {
          selectValueElement.removeAttr('aria-hidden');
          if (!userDefinedLabelledby) {
            element.attr('aria-labelledby', element[0].id + ' ' + selectValueElement[0].id);
          }
        }
      };

      /**
       * @param {boolean} isPlaceholder true to mark the md-select-value element and
       *  input container, if one exists, with classes for styling when a placeholder is present.
       *  false to remove those classes.
       */
      mdSelectCtrl.setIsPlaceholder = function(isPlaceholder) {
          if (isPlaceholder) {
            selectValueElement.addClass('md-select-placeholder');
            // Don't hide the floating label if the md-select has a placeholder.
            if (containerCtrl && containerCtrl.label && !element.attr('placeholder')) {
              containerCtrl.label.addClass('md-placeholder');
            }
          } else {
            selectValueElement.removeClass('md-select-placeholder');
            if (containerCtrl && containerCtrl.label && !element.attr('placeholder')) {
              containerCtrl.label.removeClass('md-placeholder');
            }
          }
      };

      if (!isReadonly) {
        var handleBlur = function(event) {
          // Attach before ngModel's blur listener to stop propagation of blur event
          // and prevent setting $touched.
          if (untouched) {
            untouched = false;
            if (selectScope._mdSelectIsOpen) {
              event.stopImmediatePropagation();
            }
          }

          containerCtrl && containerCtrl.setFocused(false);
          inputCheckValue();
        };
        var handleFocus = function() {
          // Always focus the container (if we have one) so floating labels and other styles are
          // applied properly
          containerCtrl && containerCtrl.setFocused(true);
        };

        element.on('focus', handleFocus);
        element.on('blur', handleBlur);
      }

      mdSelectCtrl.triggerClose = function() {
        $parse(attrs.mdOnClose)(scope);
      };

      scope.$$postDigest(function() {
        initAriaLabel();
        syncSelectValueText();
      });

      function initAriaLabel() {
        var labelText = element.attr('aria-label') || element.attr('placeholder');
        if (!labelText && containerCtrl && containerCtrl.label) {
          labelText = containerCtrl.label.text();
        }
        $mdAria.expect(element, 'aria-label', labelText);
      }

      var stopSelectedLabelsWatcher = scope.$watch(function() {
        return selectMenuCtrl.getSelectedLabels();
      }, syncSelectValueText);

      function syncSelectValueText() {
        selectMenuCtrl = selectMenuCtrl ||
          selectContainer.find('md-select-menu').controller('mdSelectMenu');
        mdSelectCtrl.setSelectValueText(selectMenuCtrl.getSelectedLabels());
      }

      // TODO add tests for mdMultiple
      // TODO add docs for mdMultiple
      var stopMdMultipleObserver = attrs.$observe('mdMultiple', function(val) {
        if (stopMdMultipleWatch) {
          stopMdMultipleWatch();
        }
        var parser = $parse(val);
        stopMdMultipleWatch = scope.$watch(function() {
          return parser(scope);
        }, function(multiple, prevVal) {
          var selectMenu = selectContainer.find('md-select-menu');
          // assume compiler did a good job
          if (multiple === undefined && prevVal === undefined) {
            return;
          }
          if (multiple) {
            var setMultipleAttrs = {'multiple': 'multiple'};
            element.attr(setMultipleAttrs);
            selectMenu.attr(setMultipleAttrs);
          } else {
            element.removeAttr('multiple');
            selectMenu.removeAttr('multiple');
          }
          element.find('md-content').attr('aria-multiselectable', multiple ? 'true' : 'false');

          if (selectContainer) {
            selectMenuCtrl.setMultiple(Boolean(multiple));
            originalRender = ngModelCtrl.$render;
            ngModelCtrl.$render = function() {
              originalRender();
              syncSelectValueText();
              inputCheckValue();
            };
            ngModelCtrl.$render();
          }
        });
      });

      var stopDisabledObserver = attrs.$observe('disabled', function(disabled) {
        if (angular.isString(disabled)) {
          disabled = true;
        }
        // Prevent click event being registered twice
        if (isDisabled !== undefined && isDisabled === disabled) {
          return;
        }
        isDisabled = disabled;
        if (disabled) {
          element
            .attr({'aria-disabled': 'true'})
            .removeAttr('tabindex')
            .removeAttr('aria-expanded')
            .removeAttr('aria-haspopup')
            .off('click', openSelect)
            .off('keydown', handleKeypress);
        } else {
          element
            .attr({
              'tabindex': attrs.tabindex,
              'aria-haspopup': 'listbox'
            })
            .removeAttr('aria-disabled')
            .on('click', openSelect)
            .on('keydown', handleKeypress);
        }
      });

      if (!attrs.hasOwnProperty('disabled') && !attrs.hasOwnProperty('ngDisabled')) {
        element.attr({'aria-disabled': 'false'});
        element.on('click', openSelect);
        element.on('keydown', handleKeypress);
      }

      var ariaAttrs = {
        role: 'button',
        'aria-haspopup': 'listbox'
      };

      if (!element[0].hasAttribute('id')) {
        ariaAttrs.id = 'select_' + $mdUtil.nextUid();
      }

      var containerId = 'select_container_' + $mdUtil.nextUid();
      selectContainer.attr('id', containerId);
      var listboxContentId = 'select_listbox_' + $mdUtil.nextUid();
      selectContainer.find('md-content').attr('id', listboxContentId);
      // Only add aria-owns if element ownership is NOT represented in the DOM.
      if (!element.find('md-select-menu').length) {
        ariaAttrs['aria-owns'] = listboxContentId;
      }
      element.attr(ariaAttrs);

      scope.$on('$destroy', function() {
        stopRequiredObserver && stopRequiredObserver();
        stopDisabledObserver && stopDisabledObserver();
        stopMdMultipleWatch && stopMdMultipleWatch();
        stopMdMultipleObserver && stopMdMultipleObserver();
        stopSelectedLabelsWatcher && stopSelectedLabelsWatcher();
        stopPlaceholderObserver && stopPlaceholderObserver();
        stopInvalidWatch && stopInvalidWatch();

        element.off('focus');
        element.off('blur');

        $mdSelect
          .destroy()
          .finally(function() {
            if (containerCtrl) {
              containerCtrl.setFocused(false);
              containerCtrl.setHasValue(false);
              containerCtrl.input = null;
            }
            ngModelCtrl.$setTouched();
          });
      });

      function inputCheckValue() {
        // The select counts as having a value if one or more options are selected,
        // or if the input's validity state says it has bad input (eg: string in a number input).
        // We must do this on nextTick as the $render is sometimes invoked on nextTick.
        $mdUtil.nextTick(function () {
          containerCtrl && containerCtrl.setHasValue(
            selectMenuCtrl.getSelectedLabels().length > 0 || (element[0].validity || {}).badInput);
        });
      }

      function findSelectContainer() {
        var selectContainer = angular.element(
          element[0].querySelector('.md-select-menu-container')
        );
        selectScope = scope;
        attrs.mdContainerClass && selectContainer.addClass(attrs.mdContainerClass);
        selectMenuCtrl = selectContainer.find('md-select-menu').controller('mdSelectMenu');
        selectMenuCtrl.init(ngModelCtrl, attrs);
        element.on('$destroy', function() {
          selectContainer.remove();
        });
        return selectContainer;
      }

      /**
       * Determine if the select menu should be opened or an option in the select menu should be
       * selected.
       * @param {KeyboardEvent} e keyboard event to handle
       */
      function handleKeypress(e) {
        if ($mdConstant.isNavigationKey(e)) {
          // prevent page scrolling on interaction
          e.preventDefault();
          openSelect(e);
        } else {
          if (shouldHandleKey(e, $mdConstant)) {
            e.preventDefault();

            var node = selectMenuCtrl.optNodeForKeyboardSearch(e);
            if (!node || node.hasAttribute('disabled')) {
              return;
            }
            var optionCtrl = angular.element(node).controller('mdOption');
            if (!selectMenuCtrl.isMultiple) {
              angular.forEach(Object.keys(selectMenuCtrl.selected), function (key) {
                selectMenuCtrl.deselect(key);
              });
            }
            selectMenuCtrl.select(optionCtrl.hashKey, optionCtrl.value);
            selectMenuCtrl.refreshViewValue();
          }
        }
      }

      function openSelect() {
        selectScope._mdSelectIsOpen = true;
        element.attr('aria-expanded', 'true');

        $mdSelect.show({
          scope: selectScope,
          preserveScope: true,
          skipCompile: true,
          element: selectContainer,
          target: element[0],
          selectCtrl: mdSelectCtrl,
          preserveElement: true,
          hasBackdrop: true,
          loadingAsync: attrs.mdOnOpen ? scope.$eval(attrs.mdOnOpen) || true : false
        }).finally(function() {
          selectScope._mdSelectIsOpen = false;
          element.removeAttr('aria-expanded');
          element.removeAttr('aria-activedescendant');
          ngModelCtrl.$setTouched();
        });
      }

    };
  }
}

function SelectMenuDirective($parse, $mdUtil, $mdConstant, $mdTheming) {
  // We want the scope to be set to 'false' so an isolated scope is not created
  // which would interfere with the md-select-header's access to the
  // parent scope.
  SelectMenuController.$inject = ["$scope", "$attrs", "$element"];
  return {
    restrict: 'E',
    require: ['mdSelectMenu'],
    scope: false,
    controller: SelectMenuController,
    link: {pre: preLink}
  };

  // We use preLink instead of postLink to ensure that the select is initialized before
  // its child options run postLink.
  function preLink(scope, element, attrs, ctrls) {
    var selectMenuCtrl = ctrls[0];

    element.addClass('_md');     // private md component indicator for styling

    $mdTheming(element);
    element.on('click', clickListener);
    element.on('keypress', keyListener);

    /**
     * @param {KeyboardEvent} keyboardEvent
     */
    function keyListener(keyboardEvent) {
      if (keyboardEvent.keyCode === 13 || keyboardEvent.keyCode === 32) {
        clickListener(keyboardEvent);
      }
    }

    /**
     * @param {Event} mouseEvent
     * @return {void}
     */
    function clickListener(mouseEvent) {
      var option = $mdUtil.getClosest(mouseEvent.target, 'md-option');
      var optionCtrl = option && angular.element(option).data('$mdOptionController');

      if (!option || !optionCtrl) {
        // Avoid closing the menu when the select header's input is clicked
        if (mouseEvent.target && mouseEvent.target.parentNode &&
          mouseEvent.target.parentNode.tagName === 'MD-SELECT-HEADER') {
          mouseEvent.stopImmediatePropagation();
        }
        return;
      } else if (option.hasAttribute('disabled')) {
        mouseEvent.stopImmediatePropagation();
        return;
      }

      var optionHashKey = selectMenuCtrl.hashGetter(optionCtrl.value);
      var isSelected = angular.isDefined(selectMenuCtrl.selected[optionHashKey]);

      scope.$apply(function() {
        if (selectMenuCtrl.isMultiple) {
          if (isSelected) {
            selectMenuCtrl.deselect(optionHashKey);
          } else {
            selectMenuCtrl.select(optionHashKey, optionCtrl.value);
          }
        } else {
          if (!isSelected) {
            angular.forEach(Object.keys(selectMenuCtrl.selected), function (key) {
              selectMenuCtrl.deselect(key);
            });
            selectMenuCtrl.select(optionHashKey, optionCtrl.value);
          }
        }
        selectMenuCtrl.refreshViewValue();
      });
    }
  }

  function SelectMenuController($scope, $attrs, $element) {
    var self = this;
    var defaultIsEmpty;
    var searchStr = '';
    var clearSearchTimeout, optNodes, optText;
    var CLEAR_SEARCH_AFTER = 300;

    self.isMultiple = angular.isDefined($attrs.multiple);
    // selected is an object with keys matching all of the selected options' hashed values
    self.selected = {};
    // options is an object with keys matching every option's hash value,
    // and values containing an instance of every option's controller.
    self.options = {};

    $scope.$watchCollection(function() {
      return self.options;
    }, function() {
      self.ngModel.$render();
      updateOptionSetSizeAndPosition();
    });

    /**
     * @param {boolean} isMultiple
     */
    self.setMultiple = function(isMultiple) {
      var ngModel = self.ngModel;
      defaultIsEmpty = defaultIsEmpty || ngModel.$isEmpty;
      self.isMultiple = isMultiple;

      if (self.isMultiple) {
        // We want to delay the render method so that the directive has a chance to load before
        // rendering, this prevents the control being marked as dirty onload.
        var loaded = false;
        var delayedRender = function(val) {
          if (!loaded) {
            $mdUtil.nextTick(function () {
              renderMultiple(val);
              loaded = true;
            });
          } else {
            renderMultiple(val);
          }
        };
        ngModel.$validators['md-multiple'] = validateArray;
        ngModel.$render = delayedRender;

        // watchCollection on the model because by default ngModel only watches the model's
        // reference. This allows the developer to also push and pop from their array.
        $scope.$watchCollection(self.modelBinding, function(value) {
          if (validateArray(value)) {
            delayedRender(value);
          }
        });

        ngModel.$isEmpty = function(value) {
          return !value || value.length === 0;
        };
      } else {
        delete ngModel.$validators['md-multiple'];
        ngModel.$render = renderSingular;
      }

      function validateArray(modelValue, viewValue) {
        // If a value is truthy but not an array, reject it.
        // If value is undefined/falsy, accept that it's an empty array.
        return angular.isArray(modelValue || viewValue || []);
      }
    };

    /**
     * @param {KeyboardEvent} keyboardEvent keyboard event to handle
     * @return {Element|HTMLElement|undefined}
     */
    self.optNodeForKeyboardSearch = function(keyboardEvent) {
      var search, i;
      clearSearchTimeout && clearTimeout(clearSearchTimeout);
      clearSearchTimeout = setTimeout(function() {
        clearSearchTimeout = undefined;
        searchStr = '';
        optText = undefined;
        optNodes = undefined;
      }, CLEAR_SEARCH_AFTER);

      searchStr += keyboardEvent.key;
      search = new RegExp('^' + $mdUtil.sanitize(searchStr), 'i');
      if (!optNodes) {
        optNodes = $element.find('md-option');
        optText = new Array(optNodes.length);
        angular.forEach(optNodes, function(el, i) {
          optText[i] = el.textContent.trim();
        });
      }

      for (i = 0; i < optText.length; ++i) {
        if (search.test(optText[i])) {
          return optNodes[i];
        }
      }
    };

    self.init = function(ngModel, parentAttrs) {
      self.ngModel = ngModel;
      self.modelBinding = parentAttrs.ngModel;

      // Setup a more robust version of isEmpty to ensure value is a valid option
      self.ngModel.$isEmpty = function($viewValue) {
        // We have to transform the viewValue into the hashKey, because otherwise the
        // OptionCtrl may not exist. Developers may have specified a trackBy function.
        var hashedValue = self.options[self.hashGetter($viewValue)] ? self.options[self.hashGetter($viewValue)].value : null;
        // Base this check on the default AngularJS $isEmpty() function.
        // eslint-disable-next-line no-self-compare
        return !angular.isDefined(hashedValue) || hashedValue === null || hashedValue === '' || hashedValue !== hashedValue;
      };

      // Allow users to provide `ng-model="foo" ng-model-options="{trackBy: '$value.id'}"` so
      // that we can properly compare objects set on the model to the available options
      //
      // If the user doesn't provide a trackBy, we automatically generate an id for every
      // value passed in with the getId function
      if ($attrs.ngModelOptions) {
        self.hashGetter = function(value) {
          var ngModelOptions = $parse($attrs.ngModelOptions)($scope);
          var trackByOption = ngModelOptions && ngModelOptions.trackBy;

          if (trackByOption) {
            return $parse(trackByOption)($scope, { $value: value });
          } else if (angular.isObject(value)) {
            return getId(value);
          }
          return value;
        };
      } else {
        self.hashGetter = getId;
      }
      self.setMultiple(self.isMultiple);

      /**
       * If the value is an object, get the unique, incremental id of the value.
       * If it's not an object, the value will be converted to a string and then returned.
       * @param value
       * @returns {string}
       */
      function getId(value) {
        if (angular.isObject(value) && !angular.isArray(value)) {
          return 'object_' + (value.$$mdSelectId || (value.$$mdSelectId = ++selectNextId));
        }
        return value + '';
      }

      if (parentAttrs.hasOwnProperty('mdSelectOnlyOption')) {
        $mdUtil.nextTick(function() {
          var optionKeys = Object.keys(self.options);

          if (optionKeys.length === 1) {
            var option = self.options[optionKeys[0]];

            self.deselect(Object.keys(self.selected)[0]);
            self.select(self.hashGetter(option.value), option.value);
            self.refreshViewValue();
            self.ngModel.$setPristine();
          }
        }, false);
      }
    };

    /**
     * @param {string=} id
     */
    self.setActiveDescendant = function(id) {
      if (angular.isDefined(id)) {
        $element.find('md-content').attr('aria-activedescendant', id);
      } else {
        $element.find('md-content').removeAttr('aria-activedescendant');
      }
    };

    /**
     * @param {{mode: string}=} opts options object to allow specifying html (default) or aria mode.
     * @return {string} comma separated set of selected values
     */
    self.getSelectedLabels = function(opts) {
      opts = opts || {};
      var mode = opts.mode || 'html';
      var selectedOptionEls =
        $mdUtil.nodesToArray($element[0].querySelectorAll('md-option[selected]'));

      if (selectedOptionEls.length) {
        var mapFn;

        if (mode === 'html') {
          // Map the given element to its innerHTML string. If the element has a child ripple
          // container remove it from the HTML string, before returning the string.
          mapFn = function(el) {
            // If we do not have a `value` or `ng-value`, assume it is an empty option which clears
            // the select.
            if (el.hasAttribute('md-option-empty')) {
              return '';
            }

            var html = el.innerHTML;

            // Remove the ripple container from the selected option, copying it would cause a CSP
            // violation.
            var rippleContainer = el.querySelector('.md-ripple-container');
            if (rippleContainer) {
              html = html.replace(rippleContainer.outerHTML, '');
            }

            // Remove the checkbox container, because it will cause the label to wrap inside of the
            // placeholder. It should be not displayed inside of the label element.
            var checkboxContainer = el.querySelector('.md-container');
            if (checkboxContainer) {
              html = html.replace(checkboxContainer.outerHTML, '');
            }

            return html;
          };
        } else if (mode === 'aria') {
          mapFn = function(el) {
            return el.hasAttribute('aria-label') ? el.getAttribute('aria-label') : el.textContent;
          };
        }

        // Ensure there are no duplicates; see https://github.com/angular/material/issues/9442
        return $mdUtil.uniq(selectedOptionEls.map(mapFn)).join(', ');
      } else {
        return '';
      }
    };

    /**
     * Mark an option as selected
     * @param {string} hashKey key within the SelectMenuController.options object, which is an
     *  instance of OptionController.
     * @param {OptionController} hashedValue value to associate with the key
     */
    self.select = function(hashKey, hashedValue) {
      var option = self.options[hashKey];
      option && option.setSelected(true, self.isMultiple);
      self.selected[hashKey] = hashedValue;
    };

    /**
     * Mark an option as not selected
     * @param {string} hashKey key within the SelectMenuController.options object, which is an
     *  instance of OptionController.
     */
    self.deselect = function(hashKey) {
      var option = self.options[hashKey];
      option && option.setSelected(false, self.isMultiple);
      delete self.selected[hashKey];
    };

    /**
     * Add an option to the select
     * @param {string} hashKey key within the SelectMenuController.options object, which is an
     *  instance of OptionController.
     * @param {OptionController} optionCtrl instance to associate with the key
     */
    self.addOption = function(hashKey, optionCtrl) {
      if (angular.isDefined(self.options[hashKey])) {
        throw new Error('Duplicate md-option values are not allowed in a select. ' +
          'Duplicate value "' + optionCtrl.value + '" found.');
      }

      self.options[hashKey] = optionCtrl;

      // If this option's value was already in our ngModel, go ahead and select it.
      if (angular.isDefined(self.selected[hashKey])) {
        self.select(hashKey, optionCtrl.value);

        // When the current $modelValue of the ngModel Controller is using the same hash as
        // the current option, which will be added, then we can be sure, that the validation
        // of the option has occurred before the option was added properly.
        // This means, that we have to manually trigger a new validation of the current option.
        if (angular.isDefined(self.ngModel.$$rawModelValue) &&
            self.hashGetter(self.ngModel.$$rawModelValue) === hashKey) {
          self.ngModel.$validate();
        }

        self.refreshViewValue();
      }
    };

    /**
     * Remove an option from the select
     * @param {string} hashKey key within the SelectMenuController.options object, which is an
     *  instance of OptionController.
     */
    self.removeOption = function(hashKey) {
      delete self.options[hashKey];
      // Don't deselect an option when it's removed - the user's ngModel should be allowed
      // to have values that do not match a currently available option.
    };

    self.refreshViewValue = function() {
      var values = [];
      var option;
      for (var hashKey in self.selected) {
        // If this hashKey has an associated option, push that option's value to the model.
        if ((option = self.options[hashKey])) {
          values.push(option.value);
        } else {
          // Otherwise, the given hashKey has no associated option, and we got it
          // from an ngModel value at an earlier time. Push the unhashed value of
          // this hashKey to the model.
          // This allows the developer to put a value in the model that doesn't yet have
          // an associated option.
          values.push(self.selected[hashKey]);
        }
      }

      var newVal = self.isMultiple ? values : values[0];
      var prevVal = self.ngModel.$modelValue;

      if (!equals(prevVal, newVal)) {
        self.ngModel.$setViewValue(newVal);
        self.ngModel.$render();
      }

      function equals(prevVal, newVal) {
        if (self.isMultiple) {
          if (!angular.isArray(prevVal)) {
            // newVal is always an array when self.isMultiple is true
            // thus, if prevVal is not an array they are different
            return false;
          } else if (prevVal.length !== newVal.length) {
            // they are different if they have different length
            return false;
          } else {
            // if they have the same length, then they are different
            // if an item in the newVal array can't be found in the prevVal
            var prevValHashes = prevVal.map(function(prevValItem) {
              return self.hashGetter(prevValItem);
            });
            return newVal.every(function(newValItem) {
              var newValItemHash = self.hashGetter(newValItem);
              return prevValHashes.some(function(prevValHash) {
                return prevValHash === newValItemHash;
              });
            });
          }
        } else {
          return self.hashGetter(prevVal) === self.hashGetter(newVal);
        }
      }
    };

    /**
     * If the options include md-optgroups, then we need to apply aria-setsize and aria-posinset
     * to help screen readers understand the indexes. When md-optgroups are not used, we save on
     * perf and extra attributes by not applying these attributes as they are not needed by screen
     * readers.
     */
    function updateOptionSetSizeAndPosition() {
      var i, options;
      var hasOptGroup = $element.find('md-optgroup');
      if (!hasOptGroup.length) {
        return;
      }

      options = $element.find('md-option');

      for (i = 0; i < options.length; i++) {
        options[i].setAttribute('aria-setsize', options.length);
        options[i].setAttribute('aria-posinset', i + 1);
      }
    }

    function renderMultiple() {
      var newSelectedValues = self.ngModel.$modelValue || self.ngModel.$viewValue || [];
      if (!angular.isArray(newSelectedValues)) {
        return;
      }

      var oldSelected = Object.keys(self.selected);

      var newSelectedHashes = newSelectedValues.map(self.hashGetter);
      var deselected = oldSelected.filter(function(hash) {
        return newSelectedHashes.indexOf(hash) === -1;
      });

      deselected.forEach(self.deselect);
      newSelectedHashes.forEach(function(hashKey, i) {
        self.select(hashKey, newSelectedValues[i]);
      });
    }

    function renderSingular() {
      var value = self.ngModel.$viewValue || self.ngModel.$modelValue;
      Object.keys(self.selected).forEach(self.deselect);
      self.select(self.hashGetter(value), value);
    }
  }
}

/**
 * @ngdoc directive
 * @name mdOption
 * @restrict E
 * @module material.components.select
 *
 * @description Displays an option in a <a ng-href="api/directive/mdSelect">md-select</a> box's
 * dropdown menu. Options can be grouped using
 * <a ng-href="api/directive/mdOptgroup">md-optgroup</a> element directives.
 *
 * ### Option Params
 *
 * When applied, `md-option-empty` will mark the option as "empty" allowing the option to clear the
 * select and put it back in it's default state. You may supply this attribute on any option you
 * wish, however, it is automatically applied to an option whose `value` or `ng-value` are not
 * defined.
 *
 * **Automatically Applied**
 *
 *  - `<md-option>`
 *  - `<md-option value>`
 *  - `<md-option value="">`
 *  - `<md-option ng-value>`
 *  - `<md-option ng-value="">`
 *
 * **NOT Automatically Applied**
 *
 *  - `<md-option ng-value="1">`
 *  - `<md-option ng-value="''">`
 *  - `<md-option ng-value="undefined">`
 *  - `<md-option value="undefined">` (this evaluates to the string `"undefined"`)
 *  - <code ng-non-bindable>&lt;md-option ng-value="{{someValueThatMightBeUndefined}}"&gt;</code>
 *
 * **Note:** A value of `undefined` ***is considered a valid value*** (and does not auto-apply this
 * attribute) since you may wish this to be your "Not Available" or "None" option.
 *
 * **Note:** Using the
 * <a ng-href="https://developer.mozilla.org/en-US/docs/Web/HTML/Element/option#Attributes">value</a>
 * attribute from the `<option>` element (as opposed to the `<md-option>` element's
 * <a ng-href="https://docs.angularjs.org/api/ng/directive/ngValue">ng-value</a>) always evaluates
 * to a `string`. This means that `value="null"` will cause a check against `myValue != "null"`
 * rather than `!myValue` or `myValue != null`.
 * Importantly, this also applies to `number` values. `value="1"` will not match up with an
 * `ng-model` like `$scope.selectedValue = 1`. Use `ng-value="1"` in this case and other cases where
 * you have values that are not strings.
 *
 * **Note:** Please see our <a ng-href="api/directive/mdSelect#selects-and-object-equality">docs on
 * using objects with `md-select`</a> for additional guidance on using the `trackBy` option with
 * `ng-model-options`.
 *
 * @param {expression=} ng-value Binds the given expression to the value of the option.
 * @param {string=} value Attribute to set the value of the option.
 * @param {expression=} ng-repeat <a ng-href="https://docs.angularjs.org/api/ng/directive/ngRepeat">
 *  AngularJS directive</a> that instantiates a template once per item from a collection.
 * @param {expression=} ng-selected <a ng-href="https://docs.angularjs.org/api/ng/directive/ngSelected">
 *  AngularJS directive</a> that adds the `selected` attribute to the option when the expression
 *  evaluates as truthy.
 *
 *  **Note:** Unlike native `option` elements used with AngularJS, `md-option` elements
 *  watch their `selected` attributes for changes and trigger model value changes on `md-select`.
 * @param {boolean=} md-option-empty If the attribute exists, mark the option as "empty" allowing
 * the option to clear the select and put it back in it's default state. You may supply this
 * attribute on any option you wish, however, it is automatically applied to an option whose `value`
 * or `ng-value` are not defined.
 * @param {number=} tabindex The `tabindex` of the option. Defaults to `0`.
 *
 * @usage
 * <hljs lang="html">
 * <md-select ng-model="currentState" placeholder="Select a state">
 *   <md-option ng-value="AL">Alabama</md-option>
 *   <md-option ng-value="AK">Alaska</md-option>
 *   <md-option ng-value="FL">Florida</md-option>
 * </md-select>
 * </hljs>
 *
 * With `ng-repeat`:
 * <hljs lang="html">
 * <md-select ng-model="currentState" placeholder="Select a state">
 *   <md-option ng-value="state" ng-repeat="state in states">{{ state }}</md-option>
 * </md-select>
 * </hljs>
 */
function OptionDirective($mdButtonInkRipple, $mdUtil, $mdTheming) {

  return {
    restrict: 'E',
    require: ['mdOption', '^^mdSelectMenu'],
    controller: OptionController,
    compile: compile
  };

  /**
   * @param {JQLite} element
   * @param {IAttributes} attrs
   * @return {postLink}
   */
  function compile(element, attrs) {
    // Manual transclusion to avoid the extra inner <span> that ng-transclude generates
    element.append(angular.element('<div class="md-text">').append(element.contents()));

    element.attr('tabindex', attrs.tabindex || '0');

    if (!hasDefinedValue(attrs)) {
      element.attr('md-option-empty', '');
    }

    return postLink;
  }

  /**
   * @param {Object} attrs list of attributes from the compile function
   * @return {string|undefined|null} if defined and non-empty, return the value of the option's
   *  value attribute, otherwise return the value of the option's ng-value attribute.
   */
  function hasDefinedValue(attrs) {
    var value = attrs.value;
    var ngValue = attrs.ngValue;

    return value || ngValue;
  }

  function postLink(scope, element, attrs, ctrls) {
    var optionCtrl = ctrls[0];
    var selectMenuCtrl = ctrls[1];

    $mdTheming(element);

    if (selectMenuCtrl.isMultiple) {
      element.addClass('md-checkbox-enabled');
      if (!CHECKBOX_SELECTION_INDICATOR) {
        var indicator = document.createElement('div');
        indicator.className = 'md-container';
        indicator.appendChild(document.createElement('div'));
        indicator.firstChild.className = 'md-icon';
        CHECKBOX_SELECTION_INDICATOR = angular.element(indicator);
      }
      element.prepend(CHECKBOX_SELECTION_INDICATOR.clone());
    }

    if (angular.isDefined(attrs.ngValue)) {
      scope.$watch(attrs.ngValue, function (newValue, oldValue) {
        setOptionValue(newValue, oldValue);
        element.removeAttr('aria-checked');
      });
    } else if (angular.isDefined(attrs.value)) {
      setOptionValue(attrs.value);
    } else {
      scope.$watch(function() {
        return element.text().trim();
      }, setOptionValue);
    }

    attrs.$observe('disabled', function(disabled) {
      if (disabled) {
        element.attr('tabindex', '-1');
      } else {
        element.attr('tabindex', '0');
      }
    });

    scope.$$postDigest(function() {
      attrs.$observe('selected', function(selected) {
        if (!angular.isDefined(selected)) return;
        if (typeof selected == 'string') selected = true;
        if (selected) {
          if (!selectMenuCtrl.isMultiple) {
            selectMenuCtrl.deselect(Object.keys(selectMenuCtrl.selected)[0]);
          }
          selectMenuCtrl.select(optionCtrl.hashKey, optionCtrl.value);
        } else {
          selectMenuCtrl.deselect(optionCtrl.hashKey);
        }
        selectMenuCtrl.refreshViewValue();
      });
    });

    $mdButtonInkRipple.attach(scope, element);
    configureAria();

    /**
     * @param {*} newValue the option's new value
     * @param {*=} oldValue the option's previous value
     * @param {boolean=} prevAttempt true if this had to be attempted again due to an undefined
     *  hashGetter on the selectMenuCtrl, undefined otherwise.
     */
    function setOptionValue(newValue, oldValue, prevAttempt) {
      if (!selectMenuCtrl.hashGetter) {
        if (!prevAttempt) {
          scope.$$postDigest(function() {
            setOptionValue(newValue, oldValue, true);
          });
        }
        return;
      }
      var oldHashKey = selectMenuCtrl.hashGetter(oldValue, scope);
      var newHashKey = selectMenuCtrl.hashGetter(newValue, scope);

      optionCtrl.hashKey = newHashKey;
      optionCtrl.value = newValue;

      selectMenuCtrl.removeOption(oldHashKey, optionCtrl);
      selectMenuCtrl.addOption(newHashKey, optionCtrl);
    }

    scope.$on('$destroy', function() {
      selectMenuCtrl.removeOption(optionCtrl.hashKey, optionCtrl);
    });

    function configureAria() {
      var ariaAttrs = {
        'role': 'option'
      };

      // We explicitly omit the `aria-selected` attribute from single-selection, unselected
      // options. Including the `aria-selected="false"` attributes adds a significant amount of
      // noise to screen-reader users without providing useful information.
      if (selectMenuCtrl.isMultiple) {
        ariaAttrs['aria-selected'] = 'false';
      }

      if (!element[0].hasAttribute('id')) {
        ariaAttrs.id = 'select_option_' + $mdUtil.nextUid();
      }
      element.attr(ariaAttrs);
    }
  }
}

/**
 * @param {JQLite} $element
 * @constructor
 */
function OptionController($element) {
  /**
   * @param {boolean} isSelected
   * @param {boolean=} isMultiple
   */
  this.setSelected = function(isSelected, isMultiple) {
    if (isSelected) {
      $element.attr({
        'selected': 'true',
        'aria-selected': 'true'
      });
    } else if (!isSelected) {
      $element.removeAttr('selected');

      if (isMultiple) {
        $element.attr('aria-selected', 'false');
      } else {
        // We explicitly omit the `aria-selected` attribute from single-selection, unselected
        // options. Including the `aria-selected="false"` attributes adds a significant amount of
        // noise to screen-reader users without providing useful information.
        $element.removeAttr('aria-selected');
      }
    }
  };
}

/**
 * @ngdoc directive
 * @name mdOptgroup
 * @restrict E
 * @module material.components.select
 *
 * @description Displays a label separating groups of
 * <a ng-href="api/directive/mdOption">md-option</a> element directives in a
 * <a ng-href="api/directive/mdSelect">md-select</a> box's dropdown menu.
 *
 * **Note:** When using `md-select-header` element directives within a `md-select`, the labels that
 * would normally be added to the <a ng-href="api/directive/mdOptgroup">md-optgroup</a> directives
 * are omitted, allowing the `md-select-header` to represent the option group label
 * (and possibly more).
 *
 * @usage
 * With label attributes
 * <hljs lang="html">
 * <md-select ng-model="currentState" placeholder="Select a state">
 *   <md-optgroup label="Southern">
 *     <md-option ng-value="AL">Alabama</md-option>
 *     <md-option ng-value="FL">Florida</md-option>
 *   </md-optgroup>
 *   <md-optgroup label="Northern">
 *     <md-option ng-value="AK">Alaska</md-option>
 *     <md-option ng-value="MA">Massachusetts</md-option>
 *   </md-optgroup>
 * </md-select>
 * </hljs>
 *
 * With label elements
 * <hljs lang="html">
 * <md-select ng-model="currentState" placeholder="Select a state">
 *   <md-optgroup>
 *     <label>Southern</label>
 *     <md-option ng-value="AL">Alabama</md-option>
 *     <md-option ng-value="FL">Florida</md-option>
 *   </md-optgroup>
 *   <md-optgroup>
 *     <label>Northern</label>
 *     <md-option ng-value="AK">Alaska</md-option>
 *     <md-option ng-value="MA">Massachusetts</md-option>
 *   </md-optgroup>
 * </md-select>
 * </hljs>
 *
 * @param {string=} label The option group's label.
 */
function OptgroupDirective() {
  return {
    restrict: 'E',
    compile: compile
  };
  function compile(element, attrs) {
    // If we have a select header element, we don't want to add the normal label
    // header.
    if (!hasSelectHeader()) {
      setupLabelElement();
    }
    element.attr('role', 'group');

    function hasSelectHeader() {
      return element.parent().find('md-select-header').length;
    }

    function setupLabelElement() {
      var labelElement = element.find('label');
      if (!labelElement.length) {
        labelElement = angular.element('<label>');
        element.prepend(labelElement);
      }
      labelElement.addClass('md-container-ignore');
      labelElement.attr('aria-hidden', 'true');
      if (attrs.label) {
        labelElement.text(attrs.label);
      }
      element.attr('aria-label', labelElement.text());
    }
  }
}

function SelectHeaderDirective() {
  return {
    restrict: 'E',
  };
}

function SelectProvider($$interimElementProvider) {
  selectDefaultOptions.$inject = ["$mdSelect", "$mdConstant", "$mdUtil", "$window", "$q", "$$rAF", "$animateCss", "$animate", "$document"];
  return $$interimElementProvider('$mdSelect')
    .setDefaults({
      methods: ['target'],
      options: selectDefaultOptions
    });

  /* @ngInject */
  function selectDefaultOptions($mdSelect, $mdConstant, $mdUtil, $window, $q, $$rAF, $animateCss, $animate, $document) {
    var ERROR_TARGET_EXPECTED = "$mdSelect.show() expected a target element in options.target but got '{0}'!";
    var animator = $mdUtil.dom.animator;
    var keyCodes = $mdConstant.KEY_CODE;

    return {
      parent: 'body',
      themable: true,
      onShow: onShow,
      onRemove: onRemove,
      hasBackdrop: true,
      disableParentScroll: true
    };

    /**
     * Interim-element onRemove logic....
     */
    function onRemove(scope, element, opts) {
      var animationRunner = null;
      var destroyListener = scope.$on('$destroy', function() {
        // Listen for the case where the element was destroyed while there was an
        // ongoing close animation. If this happens, we need to end the animation
        // manually.
        animationRunner.end();
      });

      opts = opts || { };
      opts.cleanupInteraction();
      opts.cleanupResizing();
      opts.hideBackdrop();

      // For navigation $destroy events, do a quick, non-animated removal,
      // but for normal closes (from clicks, etc) animate the removal
      return (opts.$destroy === true) ? cleanElement() : animateRemoval().then(cleanElement);

      /**
       * For normal closes (eg clicks), animate the removal.
       * For forced closes (like $destroy events from navigation),
       * skip the animations.
       */
      function animateRemoval() {
        animationRunner = $animateCss(element, {addClass: 'md-leave'});
        return animationRunner.start();
      }

      /**
       * Restore the element to a closed state
       */
      function cleanElement() {
        destroyListener();

        element
          .removeClass('md-active')
          .attr('aria-hidden', 'true')
          .css({
            'display': 'none',
            'top': '',
            'right': '',
            'bottom': '',
            'left': '',
            'font-size': '',
            'min-width': ''
          });

        announceClosed(opts);

        if (!opts.$destroy) {
          if (opts.restoreFocus) {
            opts.target.focus();
          } else {
            // Make sure that the container's md-input-focused is removed on backdrop click.
            $mdUtil.nextTick(function() {
              opts.target.triggerHandler('blur');
            }, true);
          }
        }
      }
    }

    /**
     * Interim-element onShow logic.
     */
    function onShow(scope, element, opts) {

      watchAsyncLoad();
      sanitizeAndConfigure(scope, opts);

      opts.hideBackdrop = showBackdrop(scope, element, opts);

      return showDropDown(scope, element, opts)
        .then(function(response) {
          element.attr('aria-hidden', 'false');
          opts.alreadyOpen = true;
          opts.cleanupInteraction = activateInteraction();
          opts.cleanupResizing = activateResizing();
          opts.contentEl[0].focus();

          return response;
        }, opts.hideBackdrop);

      // ************************************
      // Closure Functions
      // ************************************

      /**
       * Attach the select DOM element(s) and animate to the correct positions and scale.
       */
      function showDropDown(scope, element, opts) {
        if (opts.parent !== element.parent()) {
          element.parent().attr('aria-owns', element.find('md-content').attr('id'));
        }

        opts.parent.append(element);

        return $q(function(resolve, reject) {
          try {
            $animateCss(element, {removeClass: 'md-leave', duration: 0})
              .start()
              .then(positionAndFocusMenu)
              .then(resolve);

          } catch (e) {
            reject(e);
          }
        });
      }

      /**
       * Initialize container and dropDown menu positions/scale, then animate to show.
       * @return {*} a Promise that resolves after the menu is animated in and an item is focused
       */
      function positionAndFocusMenu() {
        return $q(function(resolve) {
          if (opts.isRemoved) return $q.reject(false);

          var info = calculateMenuPositions(scope, element, opts);

          info.container.element.css(animator.toCss(info.container.styles));
          info.dropDown.element.css(animator.toCss(info.dropDown.styles));

          $$rAF(function() {
            element.addClass('md-active');
            info.dropDown.element.css(animator.toCss({transform: ''}));
            autoFocus(opts.focusedNode);

            resolve();
          });

        });
      }

      /**
       * Show modal backdrop element.
       */
      function showBackdrop(scope, element, options) {

        // If we are not within a dialog...
        if (options.disableParentScroll && !$mdUtil.getClosest(options.target, 'MD-DIALOG')) {
          // !! DO this before creating the backdrop; since disableScrollAround()
          //    configures the scroll offset; which is used by mdBackDrop postLink()
          options.restoreScroll = $mdUtil.disableScrollAround(options.element, options.parent);
        } else {
          options.disableParentScroll = false;
        }

        if (options.hasBackdrop) {
          // Override duration to immediately show invisible backdrop
          options.backdrop = $mdUtil.createBackdrop(scope, "md-select-backdrop md-click-catcher");
          $animate.enter(options.backdrop, $document[0].body, null, {duration: 0});
        }

        /**
         * Hide modal backdrop element...
         */
        return function hideBackdrop() {
          if (options.backdrop) options.backdrop.remove();
          if (options.disableParentScroll) options.restoreScroll();

          delete options.restoreScroll;
        };
      }

      /**
       * @param {Element|HTMLElement|null=} previousNode
       * @param {Element|HTMLElement} node
       * @param {SelectMenuController|Function|object=} menuController SelectMenuController instance
       */
      function focusOptionNode(previousNode, node, menuController) {
        var listboxContentNode = opts.contentEl[0];

        if (node) {
          if (previousNode) {
            previousNode.classList.remove('md-focused');
          }

          node.classList.add('md-focused');
          if (menuController && menuController.setActiveDescendant) {
            menuController.setActiveDescendant(node.id);
          }

          // Scroll the node into view if needed.
          if (listboxContentNode.scrollHeight > listboxContentNode.clientHeight) {
            var scrollBottom = listboxContentNode.clientHeight + listboxContentNode.scrollTop;
            var nodeBottom = node.offsetTop + node.offsetHeight;
            if (nodeBottom > scrollBottom) {
              listboxContentNode.scrollTop = nodeBottom - listboxContentNode.clientHeight;
            } else if (node.offsetTop < listboxContentNode.scrollTop) {
              listboxContentNode.scrollTop = node.offsetTop;
            }
          }
          opts.focusedNode = node;
          if (menuController && menuController.refreshViewValue) {
            menuController.refreshViewValue();
          }
        }
      }

      /**
       * @param {Element|HTMLElement} nodeToFocus
       */
      function autoFocus(nodeToFocus) {
        var selectMenuController;
        if (nodeToFocus && !nodeToFocus.hasAttribute('disabled')) {
          selectMenuController = opts.selectEl.controller('mdSelectMenu');
          focusOptionNode(null, nodeToFocus, selectMenuController);
        }
      }

      /**
       * Check for valid opts and set some useful defaults
       */
      function sanitizeAndConfigure(scope, options) {
        var selectMenuElement = element.find('md-select-menu');

        if (!options.target) {
          throw new Error($mdUtil.supplant(ERROR_TARGET_EXPECTED, [options.target]));
        }

        angular.extend(options, {
          isRemoved: false,
          target: angular.element(options.target), // make sure it's not a naked DOM node
          parent: angular.element(options.parent),
          selectEl: selectMenuElement,
          contentEl: element.find('md-content'),
          optionNodes: selectMenuElement[0].getElementsByTagName('md-option')
        });
      }

      /**
       * Configure various resize listeners for screen changes
       */
      function activateResizing() {
        var debouncedOnResize = (function(scope, target, options) {

          return function() {
            if (options.isRemoved) return;

            var updates = calculateMenuPositions(scope, target, options);
            var container = updates.container;
            var dropDown = updates.dropDown;

            container.element.css(animator.toCss(container.styles));
            dropDown.element.css(animator.toCss(dropDown.styles));
          };

        })(scope, element, opts);

        var window = angular.element($window);
        window.on('resize', debouncedOnResize);
        window.on('orientationchange', debouncedOnResize);

        // Publish deactivation closure...
        return function deactivateResizing() {

          // Disable resizing handlers
          window.off('resize', debouncedOnResize);
          window.off('orientationchange', debouncedOnResize);
        };
      }

      /**
       * If asynchronously loading, watch and update internal '$$loadingAsyncDone' flag.
       */
      function watchAsyncLoad() {
        if (opts.loadingAsync && !opts.isRemoved) {
          scope.$$loadingAsyncDone = false;

          $q.when(opts.loadingAsync)
            .then(function() {
              scope.$$loadingAsyncDone = true;
              delete opts.loadingAsync;
            }).then(function() {
              $$rAF(positionAndFocusMenu);
            });
        }
      }

      function activateInteraction() {
        if (opts.isRemoved) {
          return;
        }

        var dropDown = opts.selectEl;
        var selectMenuController = dropDown.controller('mdSelectMenu') || {};

        element.addClass('md-clickable');

        // Close on backdrop click
        opts.backdrop && opts.backdrop.on('click', onBackdropClick);

        // Escape to close
        // Cycling of options, and closing on enter
        dropDown.on('keydown', onMenuKeyDown);
        dropDown.on('click', checkCloseMenu);

        return function cleanupInteraction() {
          opts.backdrop && opts.backdrop.off('click', onBackdropClick);
          dropDown.off('keydown', onMenuKeyDown);
          dropDown.off('click', checkCloseMenu);

          element.removeClass('md-clickable');
          opts.isRemoved = true;
        };

        // ************************************
        // Closure Functions
        // ************************************

        function onBackdropClick(e) {
          e.preventDefault();
          e.stopPropagation();
          opts.restoreFocus = false;
          $mdUtil.nextTick($mdSelect.hide, true);
        }

        function onMenuKeyDown(ev) {
          ev.preventDefault();
          ev.stopPropagation();

          switch (ev.keyCode) {
            case keyCodes.UP_ARROW:
              return focusPrevOption();
            case keyCodes.DOWN_ARROW:
              return focusNextOption();
            case keyCodes.SPACE:
            case keyCodes.ENTER:
              if (opts.focusedNode) {
                dropDown.triggerHandler({
                  type: 'click',
                  target: opts.focusedNode
                });
                ev.preventDefault();
              }
              checkCloseMenu(ev);
              break;
            case keyCodes.TAB:
            case keyCodes.ESCAPE:
              ev.stopPropagation();
              ev.preventDefault();
              opts.restoreFocus = true;
              $mdUtil.nextTick($mdSelect.hide, true);
              break;
            default:
              if (shouldHandleKey(ev, $mdConstant)) {
                var optNode = selectMenuController.optNodeForKeyboardSearch(ev);
                if (optNode && !optNode.hasAttribute('disabled')) {
                  focusOptionNode(opts.focusedNode, optNode, selectMenuController);
                }
              }
          }
        }

        /**
         * Change the focus to another option. If there is no focused option, focus the first
         * option. If there is a focused option, then use the direction to determine if we should
         * focus the previous or next option in the list.
         * @param {'next'|'prev'} direction
         */
        function focusOption(direction) {
          var optionsArray = $mdUtil.nodesToArray(opts.optionNodes);
          var index = optionsArray.indexOf(opts.focusedNode);
          var prevOption = optionsArray[index];
          var newOption;

          do {
            if (index === -1) {
              // We lost the previously focused element, reset to first option
              index = 0;
            } else if (direction === 'next' && index < optionsArray.length - 1) {
              index++;
            } else if (direction === 'prev' && index > 0) {
              index--;
            }
            newOption = optionsArray[index];
            if (newOption.hasAttribute('disabled')) {
              newOption = null;
            }
          } while (!newOption && index < optionsArray.length - 1 && index > 0);

          focusOptionNode(prevOption, newOption, selectMenuController);
        }

        function focusNextOption() {
          focusOption('next');
        }

        function focusPrevOption() {
          focusOption('prev');
        }

        /**
         * @param {KeyboardEvent|MouseEvent} event
         */
        function checkCloseMenu(event) {
          if (event && (event.type === 'click') && (event.currentTarget !== dropDown[0])) {
            return;
          }
          if (mouseOnScrollbar()) {
            return;
          }

          if (opts.focusedNode && opts.focusedNode.hasAttribute &&
              !opts.focusedNode.hasAttribute('disabled')) {
            event.preventDefault();
            event.stopPropagation();
            if (!selectMenuController.isMultiple) {
              opts.restoreFocus = true;

              $mdUtil.nextTick(function () {
                $mdSelect.hide(selectMenuController.ngModel.$viewValue);
                opts.focusedNode.classList.remove('md-focused');
              }, true);
            }
          }

          /**
           * check if the mouseup event was on a scrollbar
           */
          function mouseOnScrollbar() {
            var clickOnScrollbar = false;
            if (event && (event.currentTarget.children.length > 0)) {
              var child = event.currentTarget.children[0];
              var hasScrollbar = child.scrollHeight > child.clientHeight;
              if (hasScrollbar && child.children.length > 0) {
                var relPosX = event.pageX - event.currentTarget.getBoundingClientRect().left;
                if (relPosX > child.querySelector('md-option').offsetWidth)
                  clickOnScrollbar = true;
              }
            }
            return clickOnScrollbar;
          }
        }
      }
    }

    /**
     * To notify listeners that the Select menu has closed,
     * trigger the [optional] user-defined expression
     */
    function announceClosed(opts) {
      var mdSelect = opts.selectCtrl;
      if (mdSelect) {
        var menuController = opts.selectEl.controller('mdSelectMenu');
        mdSelect.setSelectValueText(menuController ? menuController.getSelectedLabels() : '');
        mdSelect.triggerClose();
      }
    }


    /**
     * Calculate the menu positions after an event like options changing, screen resizing, or
     * animations finishing.
     * @param {Object} scope
     * @param element
     * @param opts
     * @return {{container: {styles: {top: number, left: number, 'font-size': *, 'min-width': number}, element: Object}, dropDown: {styles: {transform: string, transformOrigin: string}, element: Object}}}
     */
    function calculateMenuPositions(scope, element, opts) {
      var
        containerNode = element[0],
        targetNode = opts.target[0].children[0], // target the label
        parentNode = $document[0].body,
        selectNode = opts.selectEl[0],
        contentNode = opts.contentEl[0],
        parentRect = parentNode.getBoundingClientRect(),
        targetRect = targetNode.getBoundingClientRect(),
        shouldOpenAroundTarget = false,
        bounds = {
          left: parentRect.left + SELECT_EDGE_MARGIN,
          top: SELECT_EDGE_MARGIN,
          bottom: parentRect.height - SELECT_EDGE_MARGIN,
          right: parentRect.width - SELECT_EDGE_MARGIN - ($mdUtil.floatingScrollbars() ? 16 : 0)
        },
        spaceAvailable = {
          top: targetRect.top - bounds.top,
          left: targetRect.left - bounds.left,
          right: bounds.right - (targetRect.left + targetRect.width),
          bottom: bounds.bottom - (targetRect.top + targetRect.height)
        },
        maxWidth = parentRect.width - SELECT_EDGE_MARGIN * 2,
        selectedNode = selectNode.querySelector('md-option[selected]'),
        optionNodes = selectNode.getElementsByTagName('md-option'),
        optgroupNodes = selectNode.getElementsByTagName('md-optgroup'),
        isScrollable = calculateScrollable(element, contentNode),
        centeredNode;

      var loading = isPromiseLike(opts.loadingAsync);
      if (!loading) {
        // If a selected node, center around that
        if (selectedNode) {
          centeredNode = selectedNode;
          // If there are option groups, center around the first option group
        } else if (optgroupNodes.length) {
          centeredNode = optgroupNodes[0];
          // Otherwise - if we are not loading async - center around the first optionNode
        } else if (optionNodes.length) {
          centeredNode = optionNodes[0];
          // In case there are no options, center on whatever's in there... (eg progress indicator)
        } else {
          centeredNode = contentNode.firstElementChild || contentNode;
        }
      } else {
        // If loading, center on progress indicator
        centeredNode = contentNode.firstElementChild || contentNode;
      }

      if (contentNode.offsetWidth > maxWidth) {
        contentNode.style['max-width'] = maxWidth + 'px';
      } else {
        contentNode.style.maxWidth = null;
      }
      if (shouldOpenAroundTarget) {
        contentNode.style['min-width'] = targetRect.width + 'px';
      }

      // Remove padding before we compute the position of the menu
      if (isScrollable) {
        selectNode.classList.add('md-overflow');
      }

      var focusedNode = centeredNode;
      if ((focusedNode.tagName || '').toUpperCase() === 'MD-OPTGROUP') {
        focusedNode = optionNodes[0] || contentNode.firstElementChild || contentNode;
        centeredNode = focusedNode;
      }
      // Cache for autoFocus()
      opts.focusedNode = focusedNode;

      // Get the selectMenuRect *after* max-width is possibly set above
      containerNode.style.display = 'block';
      var selectMenuRect = selectNode.getBoundingClientRect();
      var centeredRect = getOffsetRect(centeredNode);

      if (centeredNode) {
        var centeredStyle = $window.getComputedStyle(centeredNode);
        centeredRect.paddingLeft = parseInt(centeredStyle.paddingLeft, 10) || 0;
        centeredRect.paddingRight = parseInt(centeredStyle.paddingRight, 10) || 0;
      }

      if (isScrollable) {
        var scrollBuffer = contentNode.offsetHeight / 2;
        contentNode.scrollTop = centeredRect.top + centeredRect.height / 2 - scrollBuffer;

        if (spaceAvailable.top < scrollBuffer) {
          contentNode.scrollTop = Math.min(
            centeredRect.top,
            contentNode.scrollTop + scrollBuffer - spaceAvailable.top
          );
        } else if (spaceAvailable.bottom < scrollBuffer) {
          contentNode.scrollTop = Math.max(
            centeredRect.top + centeredRect.height - selectMenuRect.height,
            contentNode.scrollTop - scrollBuffer + spaceAvailable.bottom
          );
        }
      }

      var left, top, transformOrigin, minWidth, fontSize;
      if (shouldOpenAroundTarget) {
        left = targetRect.left;
        top = targetRect.top + targetRect.height;
        transformOrigin = '50% 0';
        if (top + selectMenuRect.height > bounds.bottom) {
          top = targetRect.top - selectMenuRect.height;
          transformOrigin = '50% 100%';
        }
      } else {
        left = (targetRect.left + centeredRect.left - centeredRect.paddingLeft);
        top = Math.floor(targetRect.top + targetRect.height / 2 - centeredRect.height / 2 -
            centeredRect.top + contentNode.scrollTop) + 2;

        transformOrigin = (centeredRect.left + targetRect.width / 2) + 'px ' +
          (centeredRect.top + centeredRect.height / 2 - contentNode.scrollTop) + 'px 0px';

        minWidth = Math.min(targetRect.width + centeredRect.paddingLeft + centeredRect.paddingRight, maxWidth);

        fontSize = window.getComputedStyle(targetNode)['font-size'];
      }

      // Keep left and top within the window
      var containerRect = containerNode.getBoundingClientRect();
      var scaleX = Math.round(100 * Math.min(targetRect.width / selectMenuRect.width, 1.0)) / 100;
      var scaleY = Math.round(100 * Math.min(targetRect.height / selectMenuRect.height, 1.0)) / 100;

      return {
        container: {
          element: angular.element(containerNode),
          styles: {
            left: Math.floor(clamp(bounds.left, left, bounds.right - minWidth)),
            top: Math.floor(clamp(bounds.top, top, bounds.bottom - containerRect.height)),
            'min-width': minWidth,
            'font-size': fontSize
          }
        },
        dropDown: {
          element: angular.element(selectNode),
          styles: {
            transformOrigin: transformOrigin,
            transform: !opts.alreadyOpen ? $mdUtil.supplant('scale({0},{1})', [scaleX, scaleY]) : ""
          }
        }
      };
    }
  }

  function isPromiseLike(obj) {
    return obj && angular.isFunction(obj.then);
  }

  function clamp(min, n, max) {
    return Math.max(min, Math.min(n, max));
  }

  function getOffsetRect(node) {
    return node ? {
      left: node.offsetLeft,
      top: node.offsetTop,
      width: node.offsetWidth,
      height: node.offsetHeight
    } : {left: 0, top: 0, width: 0, height: 0};
  }

  function calculateScrollable(element, contentNode) {
    var isScrollable = false;

    try {
      var oldDisplay = element[0].style.display;

      // Set the element's display to block so that this calculation is correct
      element[0].style.display = 'block';

      isScrollable = contentNode.scrollHeight > contentNode.offsetHeight;

      // Reset it back afterwards
      element[0].style.display = oldDisplay;
    } finally {
      // Nothing to do
    }
    return isScrollable;
  }
}

function shouldHandleKey(ev, $mdConstant) {
  var char = String.fromCharCode(ev.keyCode);
  var isNonUsefulKey = (ev.keyCode <= 31);

  return (char && char.length && !isNonUsefulKey &&
    !$mdConstant.isMetaKey(ev) && !$mdConstant.isFnLockKey(ev) && !$mdConstant.hasModifierKey(ev));
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.showHide
 */

// Add additional handlers to ng-show and ng-hide that notify directives
// contained within that they should recompute their size.
// These run in addition to AngularJS's built-in ng-hide and ng-show directives.
angular.module('material.components.showHide', [
  'material.core'
])
  .directive('ngShow', createDirective('ngShow', true))
  .directive('ngHide', createDirective('ngHide', false));


function createDirective(name, targetValue) {
  return ['$mdUtil', '$window', function($mdUtil, $window) {
    return {
      restrict: 'A',
      multiElement: true,
      link: function($scope, $element, $attr) {
        var unregister = $scope.$on('$md-resize-enable', function() {
          unregister();

          var node = $element[0];
          var cachedTransitionStyles = node.nodeType === $window.Node.ELEMENT_NODE ?
            $window.getComputedStyle(node) : {};

          $scope.$watch($attr[name], function(value) {
            if (!!value === targetValue) {
              $mdUtil.nextTick(function() {
                $scope.$broadcast('$md-resize');
              });

              var opts = {
                cachedTransitionStyles: cachedTransitionStyles
              };

              $mdUtil.dom.animator.waitTransitionEnd($element, opts).then(function() {
                $scope.$broadcast('$md-resize');
              });
            }
          });
        });
      }
    };
  }];
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.sidenav
 *
 * @description
 * A Sidenav component.
 */
SidenavService.$inject = ["$mdComponentRegistry", "$mdUtil", "$q", "$log"];
SidenavDirective.$inject = ["$mdMedia", "$mdUtil", "$mdConstant", "$mdTheming", "$mdInteraction", "$animate", "$compile", "$parse", "$log", "$q", "$document", "$window", "$$rAF"];
SidenavController.$inject = ["$scope", "$attrs", "$mdComponentRegistry", "$q", "$interpolate"];
angular
  .module('material.components.sidenav', [
    'material.core',
    'material.components.backdrop'
  ])
  .factory('$mdSidenav', SidenavService)
  .directive('mdSidenav', SidenavDirective)
  .controller('$mdSidenavController', SidenavController);


/**
 * @ngdoc service
 * @name $mdSidenav
 * @module material.components.sidenav
 *
 * @description
 * `$mdSidenav` makes it easy to interact with multiple sidenavs in an app. When looking up a
 * sidenav instance, you can either look it up synchronously or wait for it to be initialized
 * asynchronously. This is done by passing the second argument to `$mdSidenav`.
 *
 * @usage
 * <hljs lang="js">
 * // Async lookup for sidenav instance; will resolve when the instance is available
 * $mdSidenav(componentId, true).then(function(instance) {
 *   $log.debug( componentId + "is now ready" );
 * });
 * // Sync lookup for sidenav instance; this will resolve immediately.
 * $mdSidenav(componentId).then(function(instance) {
 *   $log.debug( componentId + "is now ready" );
 * });
 * // Async toggle the given sidenav;
 * // when instance is known ready and lazy lookup is not needed.
 * $mdSidenav(componentId)
 *    .toggle()
 *    .then(function(){
 *      $log.debug('toggled');
 *    });
 * // Async open the given sidenav
 * $mdSidenav(componentId)
 *    .open()
 *    .then(function(){
 *      $log.debug('opened');
 *    });
 * // Async close the given sidenav
 * $mdSidenav(componentId)
 *    .close()
 *    .then(function(){
 *      $log.debug('closed');
 *    });
 * // Async lookup for sidenav instance
 * $mdSidenav(componentId, true).then(function(instance) {
 *   // On close callback to handle close, backdrop click, or escape key pressed.
 *   // Callback happens BEFORE the close action occurs.
 *   instance.onClose(function() {
 *     $log.debug('closing');
 *   });
 * });
 * // Sync check to see if the specified sidenav is set to be open
 * $mdSidenav(componentId).isOpen();
 * // Sync check to whether given sidenav is locked open
 * // If this is true, the sidenav will be open regardless of close()
 * $mdSidenav(componentId).isLockedOpen();
 * </hljs>
 */
function SidenavService($mdComponentRegistry, $mdUtil, $q, $log) {
  var errorMsg = "SideNav '{0}' is not available! Did you use md-component-id='{0}'?";
  var service = {
    find: findInstance,      //  sync  - returns proxy API
    waitFor: waitForInstance //  async - returns promise
  };

  /**
   * Service API that supports three (3) usages:
   * $mdSidenav().find("left")               // sync (must already exist) or returns undefined
   * $mdSidenav("left").toggle();            // sync (must already exist) or returns reject promise;
   * $mdSidenav("left",true).then(function(left) { // async returns instance when available
   *  left.toggle();
   * });
   */
  return function(handle, enableWait) {
    if (angular.isUndefined(handle)) {
      return service;
    }

    var shouldWait = enableWait === true;
    var instance = service.find(handle, shouldWait);
    return !instance && shouldWait ? service.waitFor(handle) :
           !instance && angular.isUndefined(enableWait) ? addLegacyAPI(service, handle) : instance;
  };

  /**
   * For failed instance/handle lookups, older-clients expect an response object with noops
   * that include `rejected promise APIs`
   * @param service
   * @param handle
   * @returns {Object}
   */
  function addLegacyAPI(service, handle) {
    var falseFn = function() {
      return false;
    };
    var rejectFn = function() {
      return $q.when($mdUtil.supplant(errorMsg, [handle || ""]));
    };

    return angular.extend({
      isLockedOpen: falseFn,
      isOpen: falseFn,
      toggle: rejectFn,
      open: rejectFn,
      close: rejectFn,
      onClose: angular.noop,
      then: function(callback) {
        return waitForInstance(handle).then(callback || angular.noop);
      }
    }, service);
  }

  /**
   * Synchronously lookup the controller instance for the specified sidNav instance which has been
   * registered with the markup `md-component-id`
   */
  function findInstance(handle, shouldWait) {
    var instance = $mdComponentRegistry.get(handle);

    if (!instance && !shouldWait) {
      // Report missing instance
      $log.error($mdUtil.supplant(errorMsg, [handle || ""]));

      // The component has not registered itself... most like NOT yet created
      // return null to indicate that the Sidenav is not in the DOM
      return undefined;
    }
    return instance;
  }

  /**
   * Asynchronously wait for the component instantiation,
   * Deferred lookup of component instance using $component registry
   */
  function waitForInstance(handle) {
    return $mdComponentRegistry.when(handle).catch($log.error);
  }
}

/**
 * @ngdoc directive
 * @name mdSidenav
 * @module material.components.sidenav
 * @restrict E
 *
 * @description
 * A Sidenav component that can be opened and closed programmatically.
 *
 * By default, upon opening it will slide out on top of the main content area.
 *
 * For keyboard and screen reader accessibility, focus is sent to the sidenav wrapper by default.
 * It can be overridden with the `md-autofocus` directive on the child element you want focused.
 *
 * @usage
 * <hljs lang="html">
 * <div layout="row" ng-controller="MyController">
 *   <md-sidenav md-component-id="left" class="md-sidenav-left">
 *     Left Nav!
 *   </md-sidenav>
 *
 *   <md-content>
 *     Center Content
 *     <md-button ng-click="openLeftMenu()">
 *       Open Left Menu
 *     </md-button>
 *   </md-content>
 *
 *   <md-sidenav md-component-id="right"
 *     md-is-locked-open="$mdMedia('min-width: 333px')"
 *     class="md-sidenav-right">
 *     <form>
 *       <md-input-container>
 *         <label for="testInput">Test input</label>
 *         <input id="testInput" type="text"
 *                ng-model="data" md-autofocus>
 *       </md-input-container>
 *     </form>
 *   </md-sidenav>
 * </div>
 * </hljs>
 *
 * <hljs lang="js">
 * var app = angular.module('myApp', ['ngMaterial']);
 * app.controller('MyController', function($scope, $mdSidenav) {
 *   $scope.openLeftMenu = function() {
 *     $mdSidenav('left').toggle();
 *   };
 * });
 * </hljs>
 *
 * @param {expression=} md-is-open A model bound to whether the sidenav is opened.
 * @param {boolean=} md-disable-backdrop When present in the markup, the sidenav will not show a
 *  backdrop.
 * @param {boolean=} md-disable-close-events When present in the markup, clicking the backdrop or
 *  pressing the 'Escape' key will not close the sidenav.
 * @param {string=} md-component-id componentId to use with $mdSidenav service.
 * @param {expression=} md-is-locked-open When this expression evaluates to true,
 * the sidenav "locks open": it falls into the content's flow instead of appearing over it. This
 * overrides the `md-is-open` attribute.
 *
 * The `$mdMedia()` service is exposed to the `md-is-locked-open` attribute, which
 * can be given a media query or one of the `sm`, `gt-sm`, `md`, `gt-md`, `lg` or `gt-lg` presets.
 * <br><br>Examples:
 *
 *   Lock open when `true`:<br>
 *   `<md-sidenav md-is-locked-open="shouldLockOpen"></md-sidenav>`
 *
 *   Lock open when the width is `1000px` or greater:<br>
 *   `<md-sidenav md-is-locked-open="$mdMedia('min-width: 1000px')"></md-sidenav>`
 *
 *   Lock open on small screens:<br>
 *   `<md-sidenav md-is-locked-open="$mdMedia('sm')"></md-sidenav>`
 *
 * @param {string=} md-disable-scroll-target Selector, pointing to an element, whose scrolling will
 * be disabled when the sidenav is opened. By default this is the sidenav's direct parent.
 */
function SidenavDirective($mdMedia, $mdUtil, $mdConstant, $mdTheming, $mdInteraction, $animate,
                          $compile, $parse, $log, $q, $document, $window, $$rAF) {
  return {
    restrict: 'E',
    scope: {
      isOpen: '=?mdIsOpen'
    },
    controller: '$mdSidenavController',
    compile: function(element) {
      element.addClass('md-closed').attr('tabIndex', '-1');
      return postLink;
    }
  };

  /**
   * Directive Post Link function...
   */
  function postLink(scope, element, attr, sidenavCtrl) {
    var lastParentOverFlow;
    var backdrop;
    var disableScrollTarget = null;
    var disableCloseEvents;
    var triggeringInteractionType;
    var triggeringElement = null;
    var previousContainerStyles;
    var promise = $q.when(true);
    var isLockedOpenParsed = $parse(attr.mdIsLockedOpen);
    var ngWindow = angular.element($window);
    var isLocked = function() {
      return isLockedOpenParsed(scope.$parent, {
        $mdMedia: $mdMedia
      });
    };

    if (attr.mdDisableScrollTarget) {
      disableScrollTarget = $document[0].querySelector(attr.mdDisableScrollTarget);

      if (disableScrollTarget) {
        disableScrollTarget = angular.element(disableScrollTarget);
      } else {
        $log.warn($mdUtil.supplant('mdSidenav: couldn\'t find element matching ' +
          'selector "{selector}". Falling back to parent.',
          { selector: attr.mdDisableScrollTarget }));
      }
    }

    if (!disableScrollTarget) {
      disableScrollTarget = element.parent();
    }

    // Only create the backdrop if the backdrop isn't disabled.
    if (!attr.hasOwnProperty('mdDisableBackdrop')) {
      backdrop = $mdUtil.createBackdrop(scope, "md-sidenav-backdrop md-opaque ng-enter");
    }

    // If md-disable-close-events is set on the sidenav we will disable
    // backdrop click and Escape key events
    if (attr.hasOwnProperty('mdDisableCloseEvents')) {
      disableCloseEvents = true;
    }

    element.addClass('_md');     // private md component indicator for styling
    $mdTheming(element);

    // The backdrop should inherit the sidenavs theme,
    // because the backdrop will take its parent theme by default.
    if (backdrop) $mdTheming.inherit(backdrop, element);

    element.on('$destroy', function() {
      backdrop && backdrop.remove();
      sidenavCtrl.destroy();
    });

    scope.$on('$destroy', function(){
      backdrop && backdrop.remove();
    });

    scope.$watch(isLocked, updateIsLocked);
    scope.$watch('isOpen', updateIsOpen);


    // Publish special accessor for the Controller instance
    sidenavCtrl.$toggleOpen = toggleOpen;

    /**
     * Toggle the DOM classes to indicate `locked`
     * @param isLocked
     * @param oldValue
     */
    function updateIsLocked(isLocked, oldValue) {
      scope.isLockedOpen = isLocked;
      if (isLocked === oldValue) {
        element.toggleClass('md-locked-open', !!isLocked);
      } else {
        $animate[isLocked ? 'addClass' : 'removeClass'](element, 'md-locked-open');
      }
      if (backdrop) {
        backdrop.toggleClass('md-locked-open', !!isLocked);
      }
    }

    /**
     * Toggle the SideNav view and attach/detach listeners
     * @param {boolean} isOpen
     */
    function updateIsOpen(isOpen) {
      var focusEl = $mdUtil.findFocusTarget(element) || element;
      var parent = element.parent();
      var restorePositioning;

      // If the user hasn't set the disable close events property we are adding
      // click and escape events to close the sidenav
      if (!disableCloseEvents) {
        parent[isOpen ? 'on' : 'off']('keydown', onKeyDown);
        if (backdrop) backdrop[isOpen ? 'on' : 'off']('click', close);
      }

      restorePositioning = updateContainerPositions(parent, isOpen);

      if (isOpen) {
        // Capture upon opening..
        triggeringElement = $document[0].activeElement;
        triggeringInteractionType = $mdInteraction.getLastInteractionType();
      }

      disableParentScroll(isOpen);

      return promise = $q.all([
        isOpen && backdrop ? $animate.enter(backdrop, parent) : backdrop ?
                             $animate.leave(backdrop) : $q.when(true),
        $animate[isOpen ? 'removeClass' : 'addClass'](element, 'md-closed')
      ]).then(function() {
        // Perform focus when animations are ALL done...
        if (scope.isOpen) {
          $$rAF(function() {
            // Notifies child components that the sidenav was opened. Should wait
            // a frame in order to allow for the element height to be computed.
            ngWindow.triggerHandler('resize');
          });

          focusEl && focusEl.focus();
        }

        // Restores the positioning on the sidenav and backdrop.
        restorePositioning && restorePositioning();
      });
    }

    function updateContainerPositions(parent, willOpen) {
      var drawerEl = element[0];
      var scrollTop = parent[0].scrollTop;

      if (willOpen && scrollTop) {
        previousContainerStyles = {
          top: drawerEl.style.top,
          bottom: drawerEl.style.bottom,
          height: drawerEl.style.height
        };

        // When the parent is scrolled down, then we want to be able to show the sidenav at the
        // current scroll position. We're moving the sidenav down to the correct scroll position
        // and apply the height of the parent, to increase the performance. Using 100% as height,
        // will impact the performance heavily.
        var positionStyle = {
          top: scrollTop + 'px',
          bottom: 'auto',
          height: parent[0].clientHeight + 'px'
        };

        // Apply the new position styles to the sidenav and backdrop.
        element.css(positionStyle);
        backdrop.css(positionStyle);
      }

      // When the sidenav is closing and we have previous defined container styles,
      // then we return a restore function, which resets the sidenav and backdrop.
      if (!willOpen && previousContainerStyles) {
        return function() {
          drawerEl.style.top = previousContainerStyles.top;
          drawerEl.style.bottom = previousContainerStyles.bottom;
          drawerEl.style.height = previousContainerStyles.height;

          backdrop[0].style.top = null;
          backdrop[0].style.bottom = null;
          backdrop[0].style.height = null;

          previousContainerStyles = null;
        };
      }
    }

    /**
     * Prevent parent scrolling (when the SideNav is open)
     */
    function disableParentScroll(disabled) {
      if (disabled && !lastParentOverFlow) {
        lastParentOverFlow = disableScrollTarget.css('overflow');
        disableScrollTarget.css('overflow', 'hidden');
      } else if (angular.isDefined(lastParentOverFlow)) {
        disableScrollTarget.css('overflow', lastParentOverFlow);
        lastParentOverFlow = undefined;
      }
    }

    /**
     * Toggle the sideNav view and publish a promise to be resolved when
     * the view animation finishes.
     * @param {boolean} isOpen true to open the sidenav, false to close it
     * @returns {*} promise to be resolved when the view animation finishes
     */
    function toggleOpen(isOpen) {
      if (scope.isOpen === isOpen) {
        return $q.when(true);
      } else {
        if (scope.isOpen && sidenavCtrl.onCloseCb) sidenavCtrl.onCloseCb();

        return $q(function(resolve) {
          // Toggle value to force an async `updateIsOpen()` to run
          scope.isOpen = isOpen;

          $mdUtil.nextTick(function() {
            // When the current `updateIsOpen()` animation finishes
            promise.then(function(result) {

              if (!scope.isOpen && triggeringElement && triggeringInteractionType === 'keyboard') {
                // reset focus to originating element (if available) upon close
                triggeringElement.focus();
                triggeringElement = null;
              }

              resolve(result);
            });
          });
        });
      }
    }

    /**
     * Auto-close sideNav when the `escape` key is pressed.
     * @param {KeyboardEvent} ev keydown event
     */
    function onKeyDown(ev) {
      var isEscape = (ev.keyCode === $mdConstant.KEY_CODE.ESCAPE);
      return isEscape ? close(ev) : $q.when(true);
    }

    /**
     * With backdrop `clicks` or `escape` key-press, immediately apply the CSS close transition...
     * Then notify the controller to close() and perform its own actions.
     * @param {Event} ev
     * @returns {*}
     */
    function close(ev) {
      ev.preventDefault();

      return sidenavCtrl.close();
    }
  }
}

/*
 * @private
 * @ngdoc controller
 * @name SidenavController
 * @module material.components.sidenav
 */
function SidenavController($scope, $attrs, $mdComponentRegistry, $q, $interpolate) {
  var self = this;

  // Use Default internal method until overridden by directive postLink

  // Synchronous getters
  self.isOpen = function() { return !!$scope.isOpen; };
  self.isLockedOpen = function() { return !!$scope.isLockedOpen; };

  // Synchronous setters
  self.onClose = function (callback) {
    self.onCloseCb = callback;
    return self;
  };

  // Async actions
  self.open   = function() { return self.$toggleOpen(true);  };
  self.close  = function() { return self.$toggleOpen(false); };
  self.toggle = function() { return self.$toggleOpen(!$scope.isOpen);  };
  self.$toggleOpen = function(value) { return $q.when($scope.isOpen = value); };

  // Evaluate the component id.
  var rawId = $attrs.mdComponentId;
  var hasDataBinding = rawId && rawId.indexOf($interpolate.startSymbol()) > -1;
  var componentId = hasDataBinding ? $interpolate(rawId)($scope.$parent) : rawId;

  // Register the component.
  self.destroy = $mdComponentRegistry.register(self, componentId);

  // Watch and update the component, if the id has changed.
  if (hasDataBinding) {
    $attrs.$observe('mdComponentId', function(id) {
      if (id && id !== self.$$mdHandle) {
        // `destroy` only deregisters the old component id so we can add the new one.
        self.destroy();
        self.destroy = $mdComponentRegistry.register(self, id);
      }
    });
  }
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.slider
 */
SliderDirective.$inject = ["$$rAF", "$window", "$mdAria", "$mdUtil", "$mdConstant", "$mdTheming", "$mdGesture", "$parse", "$log", "$timeout"];
angular.module('material.components.slider', [
  'material.core'
])
.directive('mdSlider', SliderDirective)
.directive('mdSliderContainer', SliderContainerDirective);

/**
 * @type {number} the page size used for stepping when page up/down keys are pressed.
 */
var stepPageSize = 10;
/**
 * @type {number} the multiplier applied to a step when the arrow key is pressed along with
 *  alt, meta, or ctrl.
 */
var modifierMultiplier = 4;

/**
 * @ngdoc directive
 * @name mdSliderContainer
 * @module material.components.slider
 * @restrict E
 * @description
 * The `<md-slider-container>` can hold the slider with two other elements.
 * In this case, the other elements are a `span` for the label and an `input` for displaying
 * the model value.
 *
 * @usage
 * <hljs lang="html">
 *  <md-slider-container>
 *    <span>Red</span>
 *    <md-slider min="0" max="255" ng-model="color.red" aria-label="red" id="red-slider">
 *    </md-slider>
 *    <md-input-container>
 *      <input type="number" ng-model="color.red" aria-label="Red" aria-controls="red-slider">
 *    </md-input-container>
 *  </md-slider-container>
 * </hljs>
 */
function SliderContainerDirective() {
  return {
    controller: function () {},
    compile: function (elem) {
      var slider = elem.find('md-slider');

      if (!slider) {
        return;
      }

      var vertical = slider.attr('md-vertical');

      if (vertical !== undefined) {
        elem.attr('md-vertical', '');
      }

      if (!slider.attr('flex')) {
        slider.attr('flex', '');
      }

      return function postLink(scope, element, attr, ctrl) {
        element.addClass('_md');     // private md component indicator for styling

        // We have to manually stop the $watch on ngDisabled because it exists
        // on the parent scope, and won't be automatically destroyed when
        // the component is destroyed.
        function setDisable(value) {
          element.children().attr('disabled', value);
          element.find('input').attr('disabled', value);
        }

        var stopDisabledWatch = angular.noop;

        if (attr.disabled) {
          setDisable(true);
        }
        else if (attr.ngDisabled) {
          stopDisabledWatch = scope.$watch(attr.ngDisabled, function (value) {
            setDisable(value);
          });
        }

        scope.$on('$destroy', function () {
          stopDisabledWatch();
        });

        var initialMaxWidth;

        /**
         * @param {number} length of the input's string value
         */
        ctrl.fitInputWidthToTextLength = function (length) {
          var input = element[0].querySelector('md-input-container');

          if (input) {
            var computedStyle = getComputedStyle(input);
            var minWidth = parseInt(computedStyle.minWidth);
            var padding = parseInt(computedStyle.paddingLeft) + parseInt(computedStyle.paddingRight);

            initialMaxWidth = initialMaxWidth || parseInt(computedStyle.maxWidth);
            var newMaxWidth = Math.max(initialMaxWidth, minWidth + padding + (minWidth / 2 * length));

            input.style.maxWidth = newMaxWidth + 'px';
          }
        };
      };
    }
  };
}

/**
 * @ngdoc directive
 * @name mdSlider
 * @module material.components.slider
 * @restrict E
 * @description
 * The `<md-slider>` component allows the user to choose from a range of values.
 *
 * As per the [Material Design spec](https://material.io/archive/guidelines/style/color.html#color-color-system)
 * the slider is in the accent color by default. The primary color palette may be used with
 * the `md-primary` class.
 *
 * The slider has two modes:
 * - "normal" mode where the user slides between a wide range of values
 * - "discrete" mode where the user slides between only a few select values
 *
 * To enable discrete mode, add the `md-discrete` attribute to a slider
 * and use the `step` attribute to change the distance between
 * values the user is allowed to pick.
 *
 * When using the keyboard:
 * - pressing the arrow keys will increase or decrease the slider's value by one step
 * - holding the Meta, Control, or Alt key while pressing the arrow keys will
 *   move the slider four steps at a time
 * - pressing the Home key will move the slider to the first allowed value
 * - pressing the End key will move the slider to the last allowed value
 * - pressing the Page Up key will increase the slider value by ten
 * - pressing the Page Down key will decrease the slider value by ten
 *
 * @usage
 * <h4>Normal Mode</h4>
 * <hljs lang="html">
 * <md-slider ng-model="myValue" min="5" max="500">
 * </md-slider>
 * </hljs>
 * <h4>Discrete Mode</h4>
 * <hljs lang="html">
 * <md-slider md-discrete ng-model="myDiscreteValue" step="10" min="10" max="130">
 * </md-slider>
 * </hljs>
 * <h4>Invert Mode</h4>
 * <hljs lang="html">
 * <md-slider md-invert ng-model="myValue" step="10" min="10" max="130">
 * </md-slider>
 * </hljs>
 *
 * @param {expression} ng-model Assignable angular expression to be data-bound.
 *  The expression should evaluate to a `number`.
 * @param {expression=} ng-disabled If this expression evaluates as truthy, the slider will be
 *  disabled.
 * @param {expression=} ng-readonly If this expression evaluates as truthy, the slider will be in
 *  read only mode.
 * @param {boolean=} md-discrete If this attribute exists during initialization, enable discrete
 *  mode. Defaults to `false`.
 * @param {boolean=} md-vertical If this attribute exists during initialization, enable vertical
 *  orientation mode. Defaults to `false`.
 * @param {boolean=} md-invert If this attribute exists during initialization, enable inverted mode.
 *  Defaults to `false`.
 * @param {number=} step The distance between values the user is allowed to pick. Defaults to `1`.
 * @param {number=} min The minimum value the user is allowed to pick. Defaults to `0`.
 * @param {number=} max The maximum value the user is allowed to pick. Defaults to `100`.
 * @param {number=} round The amount of numbers after the decimal point. The maximum is 6 to
 *  prevent scientific notation. Defaults to `3`.
 */
function SliderDirective($$rAF, $window, $mdAria, $mdUtil, $mdConstant, $mdTheming, $mdGesture,
                         $parse, $log, $timeout) {
  return {
    scope: {},
    require: ['?ngModel', '?^mdSliderContainer'],
    template:
      '<div class="md-slider-wrapper">' +
        '<div class="md-slider-content">' +
          '<div class="md-track-container">' +
            '<div class="md-track"></div>' +
            '<div class="md-track md-track-fill"></div>' +
            '<div class="md-track-ticks"></div>' +
          '</div>' +
          '<div class="md-thumb-container">' +
            '<div class="md-thumb"></div>' +
            '<div class="md-focus-thumb"></div>' +
            '<div class="md-focus-ring"></div>' +
            '<div class="md-sign">' +
              '<span class="md-thumb-text"></span>' +
            '</div>' +
            '<div class="md-disabled-thumb"></div>' +
          '</div>' +
        '</div>' +
      '</div>',
    compile: compile
  };

  // **********************************************************
  // Private Methods
  // **********************************************************

  function compile (tElement, tAttrs) {
    var wrapper = angular.element(tElement[0].getElementsByClassName('md-slider-wrapper'));

    var tabIndex = tAttrs.tabindex || 0;
    wrapper.attr('tabindex', tabIndex);

    if (tAttrs.disabled || tAttrs.ngDisabled) wrapper.attr('tabindex', -1);

    wrapper.attr('role', 'slider');

    $mdAria.expect(tElement, 'aria-label');

    return postLink;
  }

  function postLink(scope, element, attr, ctrls) {
    $mdTheming(element);
    var ngModelCtrl = ctrls[0] || {
      // Mock ngModelController if it doesn't exist to give us
      // the minimum functionality needed
      $setViewValue: function(val) {
        this.$viewValue = val;
        this.$viewChangeListeners.forEach(function(cb) { cb(); });
      },
      $parsers: [],
      $formatters: [],
      $viewChangeListeners: []
    };

    var containerCtrl = ctrls[1];
    var container = angular.element($mdUtil.getClosest(element, '_md-slider-container', true));
    var isDisabled = attr.ngDisabled ? angular.bind(null, $parse(attr.ngDisabled), scope.$parent) : function () {
          return element[0].hasAttribute('disabled');
        };

    var thumb = angular.element(element[0].querySelector('.md-thumb'));
    var thumbText = angular.element(element[0].querySelector('.md-thumb-text'));
    var thumbContainer = thumb.parent();
    var trackContainer = angular.element(element[0].querySelector('.md-track-container'));
    var activeTrack = angular.element(element[0].querySelector('.md-track-fill'));
    var tickContainer = angular.element(element[0].querySelector('.md-track-ticks'));
    var wrapper = angular.element(element[0].getElementsByClassName('md-slider-wrapper'));
    var content = angular.element(element[0].getElementsByClassName('md-slider-content'));
    var throttledRefreshDimensions = $mdUtil.throttle(refreshSliderDimensions, 5000);

    // Default values, overridable by attrs
    var DEFAULT_ROUND = 3;
    var vertical = angular.isDefined(attr.mdVertical);
    var discrete = angular.isDefined(attr.mdDiscrete);
    var invert = angular.isDefined(attr.mdInvert);
    angular.isDefined(attr.min) ? attr.$observe('min', updateMin) : updateMin(0);
    angular.isDefined(attr.max) ? attr.$observe('max', updateMax) : updateMax(100);
    angular.isDefined(attr.step)? attr.$observe('step', updateStep) : updateStep(1);
    angular.isDefined(attr.round)? attr.$observe('round', updateRound) : updateRound(DEFAULT_ROUND);

    // We have to manually stop the $watch on ngDisabled because it exists
    // on the parent scope, and won't be automatically destroyed when
    // the component is destroyed.
    var stopDisabledWatch = angular.noop;
    if (attr.ngDisabled) {
      stopDisabledWatch = scope.$parent.$watch(attr.ngDisabled, updateAriaDisabled);
    }

    $mdGesture.register(wrapper, 'drag', { horizontal: !vertical });

    scope.mouseActive = false;

    wrapper
      .on('keydown', keydownListener)
      .on('mousedown', mouseDownListener)
      .on('focus', focusListener)
      .on('blur', blurListener)
      .on('$md.pressdown', onPressDown)
      .on('$md.pressup', onPressUp)
      .on('$md.dragstart', onDragStart)
      .on('$md.drag', onDrag)
      .on('$md.dragend', onDragEnd);

    // On resize, recalculate the slider's dimensions and re-render
    function updateAll() {
      refreshSliderDimensions();
      ngModelRender();
    }
    setTimeout(updateAll, 0);

    var debouncedUpdateAll = $$rAF.throttle(updateAll);
    angular.element($window).on('resize', debouncedUpdateAll);

    scope.$on('$destroy', function() {
      angular.element($window).off('resize', debouncedUpdateAll);
    });

    ngModelCtrl.$render = ngModelRender;
    ngModelCtrl.$viewChangeListeners.push(ngModelRender);
    ngModelCtrl.$formatters.push(minMaxValidator);
    ngModelCtrl.$formatters.push(stepValidator);

    /**
     * Attributes
     */
    var min;
    var max;
    var step;
    var round;
    function updateMin(value) {
      min = parseFloat(value);
      ngModelCtrl.$viewValue = minMaxValidator(ngModelCtrl.$modelValue, min, max);
      wrapper.attr('aria-valuemin', value);
      updateAll();
    }
    function updateMax(value) {
      max = parseFloat(value);
      ngModelCtrl.$viewValue = minMaxValidator(ngModelCtrl.$modelValue, min, max);
      wrapper.attr('aria-valuemax', value);
      updateAll();
    }
    function updateStep(value) {
      step = parseFloat(value);
    }
    function updateRound(value) {
      // Set max round digits to 6, after 6 the input uses scientific notation
      round = minMaxValidator(parseInt(value), 0, 6);
    }
    function updateAriaDisabled() {
      element.attr('aria-disabled', !!isDisabled());
    }

    // Draw the ticks with canvas.
    // The alternative to drawing ticks with canvas is to draw one element for each tick,
    // which could quickly become a performance bottleneck.
    var tickCanvas, tickCtx;
    function redrawTicks() {
      if (!discrete || isDisabled()) return;
      if (angular.isUndefined(step))         return;

      if (step <= 0) {
        var msg = 'Slider step value must be greater than zero when in discrete mode';
        $log.error(msg);
        throw new Error(msg);
      }

      var numSteps = Math.floor((max - min) / step);
      if (!tickCanvas) {
        tickCanvas = angular.element('<canvas>').css('position', 'absolute');
        tickContainer.append(tickCanvas);

        tickCtx = tickCanvas[0].getContext('2d');
      }

      var dimensions = getSliderDimensions();

      // If `dimensions` doesn't have height and width it might be the first attempt so we will refresh dimensions
      if (dimensions && !dimensions.height && !dimensions.width) {
        refreshSliderDimensions();
        dimensions = sliderDimensions;
      }

      tickCanvas[0].width = dimensions.width;
      tickCanvas[0].height = dimensions.height;

      var distance;
      for (var i = 0; i <= numSteps; i++) {
        var trackTicksStyle = $window.getComputedStyle(tickContainer[0]);
        tickCtx.fillStyle = trackTicksStyle.color || 'black';

        distance = Math.floor((vertical ? dimensions.height : dimensions.width) * (i / numSteps));

        tickCtx.fillRect(vertical ? 0 : distance - 1,
          vertical ? distance - 1 : 0,
          vertical ? dimensions.width : 2,
          vertical ? 2 : dimensions.height);
      }
    }

    function clearTicks() {
      if (tickCanvas && tickCtx) {
        var dimensions = getSliderDimensions();
        tickCtx.clearRect(0, 0, dimensions.width, dimensions.height);
      }
    }

    /**
     * Refreshing Dimensions
     */
    var sliderDimensions = {};
    refreshSliderDimensions();
    function refreshSliderDimensions() {
      sliderDimensions = trackContainer[0].getBoundingClientRect();
    }
    function getSliderDimensions() {
      throttledRefreshDimensions();
      return sliderDimensions;
    }

    /**
     * left/right/up/down arrow listener
     * @param {!KeyboardEvent} ev
     */
    function keydownListener(ev) {
      if (isDisabled()) return;
      var keyCodes = $mdConstant.KEY_CODE;

      var changeAmount;
      switch (ev.keyCode) {
        case keyCodes.DOWN_ARROW:
        case keyCodes.LEFT_ARROW:
          ev.preventDefault();
          changeAmount = -step;
          break;
        case keyCodes.UP_ARROW:
        case keyCodes.RIGHT_ARROW:
          ev.preventDefault();
          changeAmount = step;
          break;
        case keyCodes.PAGE_DOWN:
          ev.preventDefault();
          changeAmount = -step * stepPageSize;
          break;
        case keyCodes.PAGE_UP:
          ev.preventDefault();
          changeAmount = step * stepPageSize;
          break;
        case keyCodes.HOME:
          ev.preventDefault();
          ev.stopPropagation();
          updateValue(min);
          break;
        case keyCodes.END:
          ev.preventDefault();
          ev.stopPropagation();
          updateValue(max);
          break;
      }
      if (changeAmount) {
        changeAmount = invert ? -changeAmount : changeAmount;
        if (ev.metaKey || ev.ctrlKey || ev.altKey) {
          changeAmount *= modifierMultiplier;
        }
        ev.preventDefault();
        ev.stopPropagation();
        updateValue(ngModelCtrl.$viewValue + changeAmount);
      }
    }

    /**
     * @param value new slider value used for setting the model value
     */
    function updateValue(value) {
      scope.$evalAsync(function() {
        setModelValue(value);
      });
    }

    function mouseDownListener() {
      redrawTicks();

      scope.mouseActive = true;
      wrapper.removeClass('md-focused');

      $timeout(function() {
        scope.mouseActive = false;
      }, 100);
    }

    function focusListener() {
      if (scope.mouseActive === false) {
        wrapper.addClass('md-focused');
      }
    }

    function blurListener() {
      wrapper.removeClass('md-focused');
      element.removeClass('md-active');
      clearTicks();
    }

    /**
     * ngModel setters and validators
     */
    function setModelValue(value) {
      ngModelCtrl.$setViewValue(minMaxValidator(stepValidator(value)));
    }
    function ngModelRender() {
      if (isNaN(ngModelCtrl.$viewValue)) {
        ngModelCtrl.$viewValue = ngModelCtrl.$modelValue;
      }

      ngModelCtrl.$viewValue = minMaxValidator(ngModelCtrl.$viewValue);

      var percent = valueToPercent(ngModelCtrl.$viewValue);
      scope.modelValue = ngModelCtrl.$viewValue;
      wrapper.attr('aria-valuenow', ngModelCtrl.$viewValue);
      setSliderPercent(percent);
      thumbText.text(ngModelCtrl.$viewValue);
    }

    function minMaxValidator(value, minValue, maxValue) {
      if (angular.isNumber(value)) {
        minValue = angular.isNumber(minValue) ? minValue : min;
        maxValue = angular.isNumber(maxValue) ? maxValue : max;

        return Math.max(minValue, Math.min(maxValue, value));
      }
    }

    function stepValidator(value) {
      if (angular.isNumber(value)) {
        var formattedValue = (Math.round((value - min) / step) * step + min);
        formattedValue = (Math.round(formattedValue * Math.pow(10, round)) / Math.pow(10, round));

        if (containerCtrl && containerCtrl.fitInputWidthToTextLength) {
          $mdUtil.debounce(function () {
            containerCtrl.fitInputWidthToTextLength(formattedValue.toString().length);
          }, 100)();
        }

        return formattedValue;
      }
    }

    /**
     * @param {number} percent 0-1
     */
    function setSliderPercent(percent) {

      percent = clamp(percent);

      var thumbPosition = (percent * 100) + '%';
      var activeTrackPercent = invert ? (1 - percent) * 100 + '%' : thumbPosition;

      if (vertical) {
        thumbContainer.css('bottom', thumbPosition);
      }
      else {
        $mdUtil.bidiProperty(thumbContainer, 'left', 'right', thumbPosition);
      }


      activeTrack.css(vertical ? 'height' : 'width', activeTrackPercent);

      element.toggleClass((invert ? 'md-max' : 'md-min'), percent === 0);
      element.toggleClass((invert ? 'md-min' : 'md-max'), percent === 1);
    }

    /**
     * Slide listeners
     */
    var isDragging = false;

    function onPressDown(ev) {
      if (isDisabled()) return;

      element.addClass('md-active');
      element[0].focus();
      refreshSliderDimensions();

      var exactVal = percentToValue(positionToPercent(vertical ? ev.srcEvent.clientY : ev.srcEvent.clientX));
      var closestVal = minMaxValidator(stepValidator(exactVal));
      scope.$apply(function() {
        setModelValue(closestVal);
        setSliderPercent(valueToPercent(closestVal));
      });
    }
    function onPressUp(ev) {
      if (isDisabled()) return;

      element.removeClass('md-dragging');

      var exactVal = percentToValue(positionToPercent(vertical ? ev.srcEvent.clientY : ev.srcEvent.clientX));
      var closestVal = minMaxValidator(stepValidator(exactVal));
      scope.$apply(function() {
        setModelValue(closestVal);
        ngModelRender();
      });
    }
    function onDragStart(ev) {
      if (isDisabled()) return;
      isDragging = true;

      ev.stopPropagation();

      element.addClass('md-dragging');
      setSliderFromEvent(ev);
    }
    function onDrag(ev) {
      if (!isDragging) return;
      ev.stopPropagation();
      setSliderFromEvent(ev);
    }
    function onDragEnd(ev) {
      if (!isDragging) return;
      ev.stopPropagation();
      isDragging = false;
    }

    function setSliderFromEvent(ev) {
      // While panning discrete, update only the
      // visual positioning but not the model value.
      if (discrete) adjustThumbPosition(vertical ? ev.srcEvent.clientY : ev.srcEvent.clientX);
      else            doSlide(vertical ? ev.srcEvent.clientY : ev.srcEvent.clientX);
    }

    /**
     * Slide the UI by changing the model value
     * @param x
     */
    function doSlide(x) {
      scope.$evalAsync(function() {
        setModelValue(percentToValue(positionToPercent(x)));
      });
    }

    /**
     * Slide the UI without changing the model (while dragging/panning)
     * @param x
     */
    function adjustThumbPosition(x) {
      var exactVal = percentToValue(positionToPercent(x));
      var closestVal = minMaxValidator(stepValidator(exactVal));
      setSliderPercent(positionToPercent(x));
      thumbText.text(closestVal);
    }

    /**
    * Clamps the value to be between 0 and 1.
    * @param {number} value The value to clamp.
    * @returns {number}
    */
    function clamp(value) {
      return Math.max(0, Math.min(value || 0, 1));
    }

    /**
     * Convert position on slider to percentage value of offset from beginning...
     * @param position
     * @returns {number}
     */
    function positionToPercent(position) {
      var offset = vertical ? sliderDimensions.top : sliderDimensions.left;
      var size = vertical ? sliderDimensions.height : sliderDimensions.width;
      var calc = (position - offset) / size;

      if (!vertical && $mdUtil.isRtl(attr)) {
        calc = 1 - calc;
      }

      return Math.max(0, Math.min(1, vertical ? 1 - calc : calc));
    }

    /**
     * Convert percentage offset on slide to equivalent model value
     * @param percent
     * @returns {*}
     */
    function percentToValue(percent) {
      var adjustedPercent = invert ? (1 - percent) : percent;
      return (min + adjustedPercent * (max - min));
    }

    function valueToPercent(val) {
      var percent = (val - min) / (max - min);
      return invert ? (1 - percent) : percent;
    }
  }
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.sticky
 * @description
 * Sticky effects for md.
 */
MdSticky.$inject = ["$mdConstant", "$$rAF", "$mdUtil", "$compile"];
angular
  .module('material.components.sticky', [
    'material.core',
    'material.components.content'
  ])
  .factory('$mdSticky', MdSticky);

/**
 * @ngdoc service
 * @name $mdSticky
 * @module material.components.sticky
 *
 * @description
 * The `$mdSticky` service provides the capability to make elements sticky, even when the browser
 * does not support `position: sticky`.
 *
 * Whenever the current browser supports stickiness natively, the `$mdSticky` service will leverage
 * the native browser's sticky functionality.
 *
 * By default the `$mdSticky` service compiles the cloned element, when not specified through the
 * `stickyClone` parameter, in the same scope as the actual element lives.
 *
 * @usage
 * <hljs lang="js">
 *   angular.module('myModule')
 *     .directive('stickyText', function($mdSticky) {
 *       return {
 *         restrict: 'E',
 *         template: '<span>Sticky Text</span>',
 *         link: function(scope, element) {
 *           $mdSticky(scope, element);
 *         }
 *       };
 *     });
 * </hljs>
 *
 * <h3>Notes</h3>
 * When using an element which contains a compiled directive that changes the DOM structure
 * during compilation, you should compile the clone yourself.
 *
 * An example of this usage can be found below:
 * <hljs lang="js">
 *   angular.module('myModule')
 *     .directive('stickySelect', function($mdSticky, $compile) {
 *       var SELECT_TEMPLATE =
 *         '<md-select ng-model="selected">' +
 *         '  <md-option>Option 1</md-option>' +
 *         '</md-select>';
 *
 *       return {
 *         restrict: 'E',
 *         replace: true,
 *         template: SELECT_TEMPLATE,
 *         link: function(scope, element) {
 *           $mdSticky(scope, element, $compile(SELECT_TEMPLATE)(scope));
 *         }
 *       };
 *     });
 * </hljs>
 *
 * @returns {function(IScope, JQLite, ITemplateLinkingFunction=): void} `$mdSticky` returns a
 *   function that takes three arguments:
 *   - `scope`: the scope to use when compiling the clone and listening for the `$destroy` event,
 *      which triggers removal of the clone
 *   - `element`: the element that will be 'sticky'
 *   - `stickyClone`: An optional clone of the element (returned from AngularJS'
 *      [$compile service](https://docs.angularjs.org/api/ng/service/$compile#usage)),
 *      that will be shown when the user starts scrolling past the original element. If not
 *      provided, the result of `element.clone()` will be used and compiled in the given scope.
 */
function MdSticky($mdConstant, $$rAF, $mdUtil, $compile) {

  var browserStickySupport = $mdUtil.checkStickySupport();

  /**
   * Registers an element as sticky, used internally by directives to register themselves.
   */
  return function registerStickyElement(scope, element, stickyClone) {
    var contentCtrl = element.controller('mdContent');
    if (!contentCtrl) return;

    if (browserStickySupport) {
      element.css({
        position: browserStickySupport,
        top: 0,
        'z-index': 2
      });
    } else {
      var $$sticky = contentCtrl.$element.data('$$sticky');
      if (!$$sticky) {
        $$sticky = setupSticky(contentCtrl);
        contentCtrl.$element.data('$$sticky', $$sticky);
      }

      // Compile our cloned element, when cloned in this service, into the given scope.
      var cloneElement = stickyClone || $compile(element.clone())(scope);

      var deregister = $$sticky.add(element, cloneElement);
      scope.$on('$destroy', deregister);
    }
  };

  function setupSticky(contentCtrl) {
    var contentEl = contentCtrl.$element;

    // Refresh elements is very expensive, so we use the debounced
    // version when possible.
    var debouncedRefreshElements = $$rAF.throttle(refreshElements);

    // setupAugmentedScrollEvents gives us `$scrollstart` and `$scroll`,
    // more reliable than `scroll` on android.
    setupAugmentedScrollEvents(contentEl);
    contentEl.on('$scrollstart', debouncedRefreshElements);
    contentEl.on('$scroll', onScroll);

    var self;
    return self = {
      prev: null,
      current: null, // the currently stickied item
      next: null,
      items: [],
      add: add,
      refreshElements: refreshElements
    };

    /***************
     * Public
     ***************/
    // Add an element and its sticky clone to this content's sticky collection
    function add(element, stickyClone) {
      stickyClone.addClass('md-sticky-clone');

      var item = {
        element: element,
        clone: stickyClone
      };
      self.items.push(item);

      $mdUtil.nextTick(function() {
        contentEl.prepend(item.clone);
      });

      debouncedRefreshElements();

      return function remove() {
        self.items.forEach(function(item, index) {
          if (item.element[0] === element[0]) {
            self.items.splice(index, 1);
            item.clone.remove();
          }
        });
        debouncedRefreshElements();
      };
    }

    function refreshElements() {
      // Sort our collection of elements by their current position in the DOM.
      // We need to do this because our elements' order of being added may not
      // be the same as their order of display.
      self.items.forEach(refreshPosition);
      self.items = self.items.sort(function(a, b) {
        return a.top < b.top ? -1 : 1;
      });

      // Find which item in the list should be active,
      // based upon the content's current scroll position
      var item;
      var currentScrollTop = contentEl.prop('scrollTop');
      for (var i = self.items.length - 1; i >= 0; i--) {
        if (currentScrollTop > self.items[i].top) {
          item = self.items[i];
          break;
        }
      }
      setCurrentItem(item);
    }

    /***************
     * Private
     ***************/

    // Find the `top` of an item relative to the content element,
    // and also the height.
    function refreshPosition(item) {
      // Find the top of an item by adding to the offsetHeight until we reach the
      // content element.
      var current = item.element[0];
      item.top = 0;
      item.left = 0;
      item.right = 0;
      while (current && current !== contentEl[0]) {
        item.top += current.offsetTop;
        item.left += current.offsetLeft;
        if (current.offsetParent) {
          // Compute offsetRight
          item.right += current.offsetParent.offsetWidth - current.offsetWidth - current.offsetLeft;
        }
        current = current.offsetParent;
      }
      item.height = item.element.prop('offsetHeight');

      var defaultVal = $mdUtil.floatingScrollbars() ? '0' : undefined;
      $mdUtil.bidi(item.clone, 'margin-left', item.left, defaultVal);
      $mdUtil.bidi(item.clone, 'margin-right', defaultVal, item.right);
    }

    // As we scroll, push in and select the correct sticky element.
    function onScroll() {
      var scrollTop = contentEl.prop('scrollTop');
      var isScrollingDown = scrollTop > (onScroll.prevScrollTop || 0);

      // Store the previous scroll so we know which direction we are scrolling
      onScroll.prevScrollTop = scrollTop;

      //
      // AT TOP (not scrolling)
      //
      if (scrollTop === 0) {
        // If we're at the top, just clear the current item and return
        setCurrentItem(null);
        return;
      }

      //
      // SCROLLING DOWN (going towards the next item)
      //
      if (isScrollingDown) {

        // If we've scrolled down past the next item's position, sticky it and return
        if (self.next && self.next.top <= scrollTop) {
          setCurrentItem(self.next);
          return;
        }

        // If the next item is close to the current one, push the current one up out of the way
        if (self.current && self.next && self.next.top - scrollTop <= self.next.height) {
          translate(self.current, scrollTop + (self.next.top - self.next.height - scrollTop));
          return;
        }
      }

      //
      // SCROLLING UP (not at the top & not scrolling down; must be scrolling up)
      //
      if (!isScrollingDown) {

        // If we've scrolled up past the previous item's position, sticky it and return
        if (self.current && self.prev && scrollTop < self.current.top) {
          setCurrentItem(self.prev);
          return;
        }

        // If the next item is close to the current one, pull the current one down into view
        if (self.next && self.current && (scrollTop >= (self.next.top - self.current.height))) {
          translate(self.current, scrollTop + (self.next.top - scrollTop - self.current.height));
          return;
        }
      }

      //
      // Otherwise, just move the current item to the proper place (scrolling up or down)
      //
      if (self.current) {
        translate(self.current, scrollTop);
      }
    }

    function setCurrentItem(item) {
      if (self.current === item) return;
      // Deactivate currently active item
      if (self.current) {
        translate(self.current, null);
        setStickyState(self.current, null);
      }

      // Activate new item if given
      if (item) {
        setStickyState(item, 'active');
      }

      self.current = item;
      var index = self.items.indexOf(item);
      // If index === -1, index + 1 = 0. It works out.
      self.next = self.items[index + 1];
      self.prev = self.items[index - 1];
      setStickyState(self.next, 'next');
      setStickyState(self.prev, 'prev');
    }

    function setStickyState(item, state) {
      if (!item || item.state === state) return;
      if (item.state) {
        item.clone.attr('sticky-prev-state', item.state);
        item.element.attr('sticky-prev-state', item.state);
      }
      item.clone.attr('sticky-state', state);
      item.element.attr('sticky-state', state);
      item.state = state;
    }

    function translate(item, amount) {
      if (!item) return;
      if (amount === null || amount === undefined) {
        if (item.translateY) {
          item.translateY = null;
          item.clone.css($mdConstant.CSS.TRANSFORM, '');
        }
      } else {
        item.translateY = amount;

        $mdUtil.bidi(item.clone, $mdConstant.CSS.TRANSFORM,
          'translate3d(' + item.left + 'px,' + amount + 'px,0)',
          'translateY(' + amount + 'px)'
        );
      }
    }
  }


  // Android 4.4 don't accurately give scroll events.
  // To fix this problem, we setup a fake scroll event. We say:
  // > If a scroll or touchmove event has happened in the last DELAY milliseconds,
  //   then send a `$scroll` event every animationFrame.
  // Additionally, we add $scrollstart and $scrollend events.
  function setupAugmentedScrollEvents(element) {
    var SCROLL_END_DELAY = 200;
    var isScrolling;
    var lastScrollTime;
    element.on('scroll touchmove', function() {
      if (!isScrolling) {
        isScrolling = true;
        $$rAF.throttle(loopScrollEvent);
        element.triggerHandler('$scrollstart');
      }
      element.triggerHandler('$scroll');
      lastScrollTime = +$mdUtil.now();
    });

    function loopScrollEvent() {
      if (+$mdUtil.now() - lastScrollTime > SCROLL_END_DELAY) {
        isScrolling = false;
        element.triggerHandler('$scrollend');
      } else {
        element.triggerHandler('$scroll');
        $$rAF.throttle(loopScrollEvent);
      }
    }
  }

}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.subheader
 * @description
 * SubHeader module
 *
 *  Subheaders are special list tiles that delineate distinct sections of a
 *  list or grid list and are typically related to the current filtering or
 *  sorting criteria. Subheader tiles are either displayed inline with tiles or
 *  can be associated with content, for example, in an adjacent column.
 *
 *  Upon scrolling, subheaders remain pinned to the top of the screen and remain
 *  pinned until pushed on or off screen by the next subheader. @see [Material
 *  Design Specifications](https://material.io/archive/guidelines/components/subheaders.html)
 *
 *  > To improve the visual grouping of content, use the system color for your subheaders.
 *
 */
MdSubheaderDirective.$inject = ["$mdSticky", "$compile", "$mdTheming", "$mdUtil", "$mdAria"];
angular
  .module('material.components.subheader', [
    'material.core',
    'material.components.sticky'
  ])
  .directive('mdSubheader', MdSubheaderDirective);

/**
 * @ngdoc directive
 * @name mdSubheader
 * @module material.components.subheader
 *
 * @restrict E
 *
 * @description
 * The `md-subheader` directive creates a sticky subheader for a section.
 *
 * Developers are able to disable the stickiness of the subheader by using the following markup
 *
 * <hljs lang="html">
 *   <md-subheader class="md-no-sticky">Not Sticky</md-subheader>
 * </hljs>
 *
 * ### Notes
 * - The `md-subheader` directive uses the <a ng-href="api/service/$mdSticky">$mdSticky</a> service
 * to make the subheader sticky.
 *
 * > Whenever the current browser doesn't support stickiness natively, the subheader
 * will be compiled twice to create a sticky clone of the subheader.
 *
 * @usage
 * <hljs lang="html">
 * <md-subheader>Online Friends</md-subheader>
 * </hljs>
 */

function MdSubheaderDirective($mdSticky, $compile, $mdTheming, $mdUtil, $mdAria) {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: (
    '<div class="md-subheader _md">' +
    '  <div class="md-subheader-inner">' +
    '    <div class="md-subheader-content"></div>' +
    '  </div>' +
    '</div>'
    ),
    link: function postLink(scope, element, attr, controllers, transclude) {
      $mdTheming(element);
      element.addClass('_md');

      // Remove the ngRepeat attribute from the root element, because we don't want to compile
      // the ngRepeat for the sticky clone again.
      $mdUtil.prefixer().removeAttribute(element, 'ng-repeat');

      var outerHTML = element[0].outerHTML;

      function getContent(el) {
        return angular.element(el[0].querySelector('.md-subheader-content'));
      }

      // Set the ARIA attributes on the original element since it keeps it's original place in
      // the DOM, whereas the clones are in reverse order. Should be done after the outerHTML,
      // in order to avoid having multiple element be marked as headers.
      attr.$set('role', 'heading');
      $mdAria.expect(element, 'aria-level', '2');

      // Transclude the user-given contents of the subheader
      // the conventional way.
      transclude(scope, function(clone) {
        getContent(element).append(clone);
      });

      // Create another clone, that uses the outer and inner contents
      // of the element, that will be 'stickied' as the user scrolls.
      if (!element.hasClass('md-no-sticky')) {
        transclude(scope, function(clone) {
          // If the user adds an ng-if or ng-repeat directly to the md-subheader element, the
          // compiled clone below will only be a comment tag (since they replace their elements with
          // a comment) which cannot be properly passed to the $mdSticky; so we wrap it in our own
          // DIV to ensure we have something $mdSticky can use
          var wrapper = $compile('<div class="md-subheader-wrapper" aria-hidden="true">' + outerHTML + '</div>')(scope);

          // Delay initialization until after any `ng-if`/`ng-repeat`/etc has finished before
          // attempting to create the clone
          $mdUtil.nextTick(function() {
            // Append our transcluded clone into the wrapper.
            // We don't have to recompile the element again, because the clone is already
            // compiled in it's transclusion scope. If we recompile the outerHTML of the new clone, we would lose
            // our ngIf's and other previous registered bindings / properties.
            getContent(wrapper).append(clone);
          });

          // Make the element sticky and provide the stickyClone our self, to avoid recompilation of the subheader
          // element.
          $mdSticky(scope, element, wrapper);
        });
      }
    }
  };
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.swipe
 * @description Swipe module!
 */
/**
 * @ngdoc directive
 * @module material.components.swipe
 * @name mdSwipeLeft
 *
 * @restrict A
 *
 * @description
 * The md-swipe-left directive allows you to specify custom behavior when an element is swiped
 * left.
 *
 * ### Notes
 * - The `$event.currentTarget` of the swiped element will be `null`, but you can get a
 * reference to the element that actually holds the `md-swipe-left` directive by using
 * `$target.current`
 *
 * > You can see this in action on the <a ng-href="demo/swipe">demo page</a> (Look at the Developer
 * Tools console while swiping).
 *
 * @usage
 * <hljs lang="html">
 * <div md-swipe-left="onSwipeLeft($event, $target)">Swipe me left!</div>
 * </hljs>
 */
/**
 * @ngdoc directive
 * @module material.components.swipe
 * @name mdSwipeRight
 *
 * @restrict A
 *
 * @description
 * The md-swipe-right directive allows you to specify custom behavior when an element is swiped
 * right.
 *
 * ### Notes
 * - The `$event.currentTarget` of the swiped element will be `null`, but you can get a
 * reference to the element that actually holds the `md-swipe-right` directive by using
 * `$target.current`
 *
 * > You can see this in action on the <a ng-href="demo/swipe">demo page</a> (Look at the Developer
 * Tools console while swiping).
 *
 * @usage
 * <hljs lang="html">
 * <div md-swipe-right="onSwipeRight($event, $target)">Swipe me right!</div>
 * </hljs>
 */
/**
 * @ngdoc directive
 * @module material.components.swipe
 * @name mdSwipeUp
 *
 * @restrict A
 *
 * @description
 * The md-swipe-up directive allows you to specify custom behavior when an element is swiped
 * up.
 *
 * ### Notes
 * - The `$event.currentTarget` of the swiped element will be `null`, but you can get a
 * reference to the element that actually holds the `md-swipe-up` directive by using
 * `$target.current`
 *
 * > You can see this in action on the <a ng-href="demo/swipe">demo page</a> (Look at the Developer
 * Tools console while swiping).
 *
 * @usage
 * <hljs lang="html">
 * <div md-swipe-up="onSwipeUp($event, $target)">Swipe me up!</div>
 * </hljs>
 */
/**
 * @ngdoc directive
 * @module material.components.swipe
 * @name mdSwipeDown
 *
 * @restrict A
 *
 * @description
 * The md-swipe-down directive allows you to specify custom behavior when an element is swiped
 * down.
 *
 * ### Notes
 * - The `$event.currentTarget` of the swiped element will be `null`, but you can get a
 * reference to the element that actually holds the `md-swipe-down` directive by using
 * `$target.current`
 *
 * > You can see this in action on the <a ng-href="demo/swipe">demo page</a> (Look at the Developer
 * Tools console while swiping).
 *
 * @usage
 * <hljs lang="html">
 * <div md-swipe-down="onSwipeDown($event, $target)">Swipe me down!</div>
 * </hljs>
 */

angular.module('material.components.swipe', ['material.core'])
    .directive('mdSwipeLeft', getDirective('SwipeLeft'))
    .directive('mdSwipeRight', getDirective('SwipeRight'))
    .directive('mdSwipeUp', getDirective('SwipeUp'))
    .directive('mdSwipeDown', getDirective('SwipeDown'));

function getDirective(name) {
    DirectiveFactory.$inject = ["$parse"];
  var directiveName = 'md' + name;
  var eventName = '$md.' + name.toLowerCase();

  return DirectiveFactory;

  /* @ngInject */
  function DirectiveFactory($parse) {
      return { restrict: 'A', link: postLink };
      function postLink(scope, element, attr) {
        var fn = $parse(attr[directiveName]);
        element.on(eventName, function(ev) {
          var currentTarget = ev.currentTarget;
          scope.$applyAsync(function() { fn(scope, { $event: ev, $target: { current: currentTarget } }); });
        });
      }
    }
}



})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.switch
 */

MdSwitch.$inject = ["mdCheckboxDirective", "$mdUtil", "$mdConstant", "$parse", "$$rAF", "$mdGesture", "$timeout"];
angular.module('material.components.switch', [
  'material.core',
  'material.components.checkbox'
])
  .directive('mdSwitch', MdSwitch);

/**
 * @ngdoc directive
 * @module material.components.switch
 * @name mdSwitch
 * @restrict E
 *
 * The switch directive is used very much like the normal [angular checkbox](https://docs.angularjs.org/api/ng/input/input%5Bcheckbox%5D).
 *
 * As per the [Material Design spec](https://material.io/archive/guidelines/style/color.html#color-color-system)
 * the switch is in the accent color by default. The primary color palette may be used with
 * the `md-primary` class.
 *
 * @param {expression} ng-model Assignable angular expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {expression=} ng-true-value The value to which the expression should be set when selected.
 * @param {expression=} ng-false-value The value to which the expression should be set when not selected.
 * @param {expression=} ng-change Expression to be executed when the model value changes.
 * @param {expression=} ng-disabled En/Disable based on the expression.
 * @param {boolean=} md-no-ink Use of attribute indicates use of ripple ink effects.
 * @param {string=} aria-label Publish the button label used by screen-readers for accessibility. Defaults to the switch's text.
 * @param {boolean=} md-invert When set to true, the switch will be inverted.
 *
 * @usage
 * <hljs lang="html">
 * <md-switch ng-model="isActive" aria-label="Finished?">
 *   Finished ?
 * </md-switch>
 *
 * <md-switch md-no-ink ng-model="hasInk" aria-label="No Ink Effects">
 *   No Ink Effects
 * </md-switch>
 *
 * <md-switch ng-disabled="true" ng-model="isDisabled" aria-label="Disabled">
 *   Disabled
 * </md-switch>
 *
 * </hljs>
 */
function MdSwitch(mdCheckboxDirective, $mdUtil, $mdConstant, $parse, $$rAF, $mdGesture, $timeout) {
  var checkboxDirective = mdCheckboxDirective[0];

  return {
    restrict: 'E',
    priority: $mdConstant.BEFORE_NG_ARIA,
    transclude: true,
    template:
      '<div class="md-container">' +
        '<div class="md-bar"></div>' +
        '<div class="md-thumb-container">' +
          '<div class="md-thumb" md-ink-ripple md-ink-ripple-checkbox></div>' +
        '</div>'+
      '</div>' +
      '<div ng-transclude class="md-label"></div>',
    require: ['^?mdInputContainer', '?ngModel', '?^form'],
    compile: mdSwitchCompile
  };

  function mdSwitchCompile(element, attr) {
    var checkboxLink = checkboxDirective.compile(element, attr).post;
    // No transition on initial load.
    element.addClass('md-dragging');

    return function (scope, element, attr, ctrls) {
      var containerCtrl = ctrls[0];
      var ngModel = ctrls[1] || $mdUtil.fakeNgModel();
      var formCtrl = ctrls[2];

      var disabledGetter = null;
      if (attr.disabled != null) {
        disabledGetter = function() { return true; };
      } else if (attr.ngDisabled) {
        disabledGetter = $parse(attr.ngDisabled);
      }

      var thumbContainer = angular.element(element[0].querySelector('.md-thumb-container'));
      var switchContainer = angular.element(element[0].querySelector('.md-container'));
      var labelContainer = angular.element(element[0].querySelector('.md-label'));

      // no transition on initial load
      $$rAF(function() {
        element.removeClass('md-dragging');
      });

      checkboxLink(scope, element, attr, ctrls);

      if (disabledGetter) {
        scope.$watch(disabledGetter, function(isDisabled) {
          element.attr('tabindex', isDisabled ? -1 : 0);
        });
      }

      attr.$observe('mdInvert', function(newValue) {
        var isInverted = $mdUtil.parseAttributeBoolean(newValue);

        isInverted ? element.prepend(labelContainer) : element.prepend(switchContainer);

        // Toggle a CSS class to update the margin.
        element.toggleClass('md-inverted', isInverted);
      });

      // These events are triggered by setup drag
      $mdGesture.register(switchContainer, 'drag');
      switchContainer
        .on('$md.dragstart', onDragStart)
        .on('$md.drag', onDrag)
        .on('$md.dragend', onDragEnd);

      var drag;
      function onDragStart(ev) {
        // Don't go if the switch is disabled.
        if (disabledGetter && disabledGetter(scope)) return;
        ev.stopPropagation();

        element.addClass('md-dragging');
        drag = {width: thumbContainer.prop('offsetWidth')};
      }

      function onDrag(ev) {
        if (!drag) return;
        ev.stopPropagation();
        ev.srcEvent && ev.srcEvent.preventDefault();

        var percent = ev.pointer.distanceX / drag.width;

        // if checked, start from right. else, start from left
        var translate = ngModel.$viewValue ?  1 + percent : percent;
        // Make sure the switch stays inside its bounds, 0-1%
        translate = Math.max(0, Math.min(1, translate));

        thumbContainer.css($mdConstant.CSS.TRANSFORM, 'translate3d(' + (100*translate) + '%,0,0)');
        drag.translate = translate;
      }

      function onDragEnd(ev) {
        if (!drag) return;
        ev.stopPropagation();

        element.removeClass('md-dragging');
        thumbContainer.css($mdConstant.CSS.TRANSFORM, '');

        // We changed if there is no distance (this is a click a click),
        // or if the drag distance is >50% of the total.
        var isChanged = ngModel.$viewValue ? drag.translate < 0.5 : drag.translate > 0.5;
        if (isChanged) {
          applyModelValue(!ngModel.$viewValue);
        }
        drag = null;

        // Wait for incoming mouse click
        scope.skipToggle = true;
        $timeout(function() {
          scope.skipToggle = false;
        }, 1);
      }

      function applyModelValue(newValue) {
        scope.$apply(function() {
          ngModel.$setViewValue(newValue);
          ngModel.$render();
        });
      }

    };
  }


}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.tabs
 * @description
 *
 *  Tabs, created with the `<md-tabs>` directive provide *tabbed* navigation with different styles.
 *  The Tabs component consists of clickable tabs that are aligned horizontally side-by-side.
 *
 *  Features include support for:
 *
 *  - static or dynamic tabs,
 *  - responsive designs,
 *  - accessibility support (ARIA),
 *  - tab pagination,
 *  - external or internal tab content,
 *  - focus indicators and arrow-key navigations,
 *  - programmatic lookup and access to tab controllers, and
 *  - dynamic transitions through different tab contents.
 *
 */
/*
 * @see js folder for tabs implementation
 */
angular.module('material.components.tabs', [
  'material.core',
  'material.components.icon'
]);

})();
(function(){
"use strict";

angular
.module('material.components.tabs')
.service('MdTabsPaginationService', MdTabsPaginationService);

/**
 * @private
 * @module material.components.tabs
 * @name MdTabsPaginationService
 * @description Provides many standalone functions to ease in pagination calculations.
 *
 * Most functions accept the elements and the current offset.
 *
 * The `elements` parameter is typically the value returned from the `getElements()` function of the
 * tabsController.
 *
 * The `offset` parameter is always positive regardless of LTR or RTL (we simply make the LTR one
 * negative when we apply our transform). This is typically the `ctrl.leftOffset` variable in the
 * tabsController.
 *
 * @returns MdTabsPaginationService
 * @constructor
 */
function MdTabsPaginationService() {
  return {
    decreasePageOffset: decreasePageOffset,
    increasePageOffset: increasePageOffset,
    getTabOffsets: getTabOffsets,
    getTotalTabsWidth: getTotalTabsWidth
  };

  /**
   * Returns the offset for the next decreasing page.
   *
   * @param elements
   * @param currentOffset
   * @returns {number}
   */
  function decreasePageOffset(elements, currentOffset) {
    var canvas       = elements.canvas,
        tabOffsets   = getTabOffsets(elements),
        i, firstVisibleTabOffset;

    // Find the first fully visible tab in offset range
    for (i = 0; i < tabOffsets.length; i++) {
      if (tabOffsets[i] >= currentOffset) {
        firstVisibleTabOffset = tabOffsets[i];
        break;
      }
    }

    // Return (the first visible tab offset - the tabs container width) without going negative
    return Math.max(0, firstVisibleTabOffset - canvas.clientWidth);
  }

  /**
   * Returns the offset for the next increasing page.
   *
   * @param elements
   * @param currentOffset
   * @returns {number}
   */
  function increasePageOffset(elements, currentOffset) {
    var canvas       = elements.canvas,
        maxOffset    = getTotalTabsWidth(elements) - canvas.clientWidth,
        tabOffsets   = getTabOffsets(elements),
        i, firstHiddenTabOffset;

    // Find the first partially (or fully) invisible tab
    for (i = 0; i < tabOffsets.length, tabOffsets[i] <= currentOffset + canvas.clientWidth; i++) {
      firstHiddenTabOffset = tabOffsets[i];
    }

    // Return the offset of the first hidden tab, or the maximum offset (whichever is smaller)
    return Math.min(maxOffset, firstHiddenTabOffset);
  }

  /**
   * Returns the offsets of all of the tabs based on their widths.
   *
   * @param elements
   * @returns {number[]}
   */
  function getTabOffsets(elements) {
    var i, tab, currentOffset = 0, offsets = [];

    for (i = 0; i < elements.tabs.length; i++) {
      tab = elements.tabs[i];
      offsets.push(currentOffset);
      currentOffset += tab.offsetWidth;
    }

    return offsets;
  }

  /**
   * Sum the width of all tabs.
   *
   * @param elements
   * @returns {number}
   */
  function getTotalTabsWidth(elements) {
    var sum = 0, i, tab;

    for (i = 0; i < elements.tabs.length; i++) {
      tab = elements.tabs[i];
      sum += tab.offsetWidth;
    }

    return sum;
  }

}

})();
(function(){
"use strict";

/**
 * @ngdoc directive
 * @name mdTab
 * @module material.components.tabs
 *
 * @restrict E
 *
 * @description
 * The `<md-tab>` is a nested directive used within `<md-tabs>` to specify a tab with a **label**
 * and optional *view content*.
 *
 * If the `label` attribute is not specified, then an optional `<md-tab-label>` tag can be used to
 * specify more complex tab header markup. If neither the **label** nor the **md-tab-label** are
 * specified, then the nested markup of the `<md-tab>` is used as the tab header markup.
 *
 * Please note that if you use `<md-tab-label>`, your content **MUST** be wrapped in the
 * `<md-tab-body>` tag.  This is to define a clear separation between the tab content and the tab
 * label.
 *
 * This container is used by the TabsController to show/hide the active tab's content view. This
 * synchronization is automatically managed by the internal TabsController whenever the tab
 * selection changes. Selection changes can be initiated via data binding changes, programmatic
 * invocation, or user gestures.
 *
 * @param {string=} label Optional attribute to specify a simple string as the tab label
 * @param {boolean=} ng-disabled If present and expression evaluates to truthy, disabled tab
 *  selection.
 * @param {string=} md-tab-class Optional attribute to specify a class that will be applied to the
 *  tab's button
 * @param {expression=} md-on-deselect Expression to be evaluated after the tab has been
 *  de-selected.
 * @param {expression=} md-on-select Expression to be evaluated after the tab has been selected.
 * @param {boolean=} md-active When true, sets the active tab.  Note: There can only be one active
 *  tab at a time.
 *
 *
 * @usage
 *
 * <hljs lang="html">
 * <md-tab label="My Tab" md-tab-class="my-content-tab" ng-disabled md-on-select="onSelect()"
 *         md-on-deselect="onDeselect()">
 *   <h3>My Tab content</h3>
 * </md-tab>
 *
 * <md-tab>
 *   <md-tab-label>
 *     <h3>My Tab</h3>
 *   </md-tab-label>
 *   <md-tab-body>
 *     <p>
 *       Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque
 *       laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi
 *       architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit
 *       aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione
 *       voluptatem sequi nesciunt.
 *     </p>
 *   </md-tab-body>
 * </md-tab>
 * </hljs>
 *
 */
angular
    .module('material.components.tabs')
    .directive('mdTab', MdTab);

function MdTab () {
  return {
    require:  '^?mdTabs',
    terminal: true,
    compile:  function (element, attr) {
      var label = firstChild(element, 'md-tab-label'),
          body  = firstChild(element, 'md-tab-body');

      if (label.length === 0) {
        label = angular.element('<md-tab-label></md-tab-label>');
        if (attr.label) label.text(attr.label);
        else label.append(element.contents());

        if (body.length === 0) {
          var contents = element.contents().detach();
          body         = angular.element('<md-tab-body></md-tab-body>');
          body.append(contents);
        }
      }

      element.append(label);
      if (body.html()) element.append(body);

      return postLink;
    },
    scope:    {
      active:   '=?mdActive',
      disabled: '=?ngDisabled',
      select:   '&?mdOnSelect',
      deselect: '&?mdOnDeselect',
      tabClass: '@mdTabClass'
    }
  };

  function postLink (scope, element, attr, ctrl) {
    if (!ctrl) return;
    var index = ctrl.getTabElementIndex(element),
        body  = firstChild(element, 'md-tab-body').remove(),
        label = firstChild(element, 'md-tab-label').remove(),
        data  = ctrl.insertTab({
          scope:    scope,
          parent:   scope.$parent,
          index:    index,
          element:  element,
          template: body.html(),
          label:    label.html()
        }, index);

    scope.select   = scope.select || angular.noop;
    scope.deselect = scope.deselect || angular.noop;

    scope.$watch('active', function (active) { if (active) ctrl.select(data.getIndex(), true); });
    scope.$watch('disabled', function () { ctrl.refreshIndex(); });
    scope.$watch(
        function () {
          return ctrl.getTabElementIndex(element);
        },
        function (newIndex) {
          data.index = newIndex;
          ctrl.updateTabOrder();
        }
    );
    scope.$on('$destroy', function () { ctrl.removeTab(data); });
  }

  function firstChild (element, tagName) {
    var children = element[0].children;
    for (var i = 0, len = children.length; i < len; i++) {
      var child = children[i];
      if (child.tagName === tagName.toUpperCase()) return angular.element(child);
    }
    return angular.element();
  }
}

})();
(function(){
"use strict";

angular
    .module('material.components.tabs')
    .directive('mdTabItem', MdTabItem);

function MdTabItem () {
  return {
    require: '^?mdTabs',
    link:    function link (scope, element, attr, ctrl) {
      if (!ctrl) return;
      ctrl.attachRipple(scope, element);
    }
  };
}

})();
(function(){
"use strict";

angular
    .module('material.components.tabs')
    .directive('mdTabLabel', MdTabLabel);

function MdTabLabel () {
  return { terminal: true };
}


})();
(function(){
"use strict";


MdTabScroll.$inject = ["$parse"];angular.module('material.components.tabs')
    .directive('mdTabScroll', MdTabScroll);

function MdTabScroll ($parse) {
  return {
    restrict: 'A',
    compile: function ($element, attr) {
      var fn = $parse(attr.mdTabScroll, null, true);
      return function ngEventHandler (scope, element) {
        element.on('wheel', function (event) {
          scope.$apply(function () { fn(scope, { $event: event }); });
        });
      };
    }
  };
}

})();
(function(){
"use strict";


MdTabsController.$inject = ["$scope", "$element", "$window", "$mdConstant", "$mdTabInkRipple", "$mdUtil", "$animateCss", "$attrs", "$compile", "$mdTheming", "$mdInteraction", "$timeout", "MdTabsPaginationService"];angular
    .module('material.components.tabs')
    .controller('MdTabsController', MdTabsController);

/**
 * @ngInject
 */
function MdTabsController ($scope, $element, $window, $mdConstant, $mdTabInkRipple, $mdUtil,
                           $animateCss, $attrs, $compile, $mdTheming, $mdInteraction, $timeout,
                           MdTabsPaginationService) {
  // define private properties
  var ctrl      = this,
      locked    = false,
      queue     = [],
      destroyed = false,
      loaded    = false;

  // Define public methods
  ctrl.$onInit            = $onInit;
  ctrl.updatePagination   = $mdUtil.debounce(updatePagination, 100);
  ctrl.redirectFocus      = redirectFocus;
  ctrl.attachRipple       = attachRipple;
  ctrl.insertTab          = insertTab;
  ctrl.removeTab          = removeTab;
  ctrl.select             = select;
  ctrl.scroll             = scroll;
  ctrl.nextPage           = nextPage;
  ctrl.previousPage       = previousPage;
  ctrl.keydown            = keydown;
  ctrl.canPageForward     = canPageForward;
  ctrl.canPageBack        = canPageBack;
  ctrl.refreshIndex       = refreshIndex;
  ctrl.incrementIndex     = incrementIndex;
  ctrl.getTabElementIndex = getTabElementIndex;
  ctrl.updateInkBarStyles = $mdUtil.debounce(updateInkBarStyles, 100);
  ctrl.updateTabOrder     = $mdUtil.debounce(updateTabOrder, 100);
  ctrl.getFocusedTabId    = getFocusedTabId;

  // For AngularJS 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
  // manually call the $onInit hook.
  if (angular.version.major === 1 && angular.version.minor <= 4) {
    this.$onInit();
  }

  /**
   * AngularJS Lifecycle hook for newer AngularJS versions.
   * Bindings are not guaranteed to have been assigned in the controller, but they are in the
   * $onInit hook.
   */
  function $onInit() {
    // Define one-way bindings
    defineOneWayBinding('stretchTabs', handleStretchTabs);

    // Define public properties with change handlers
    defineProperty('focusIndex', handleFocusIndexChange, ctrl.selectedIndex || 0);
    defineProperty('offsetLeft', handleOffsetChange, 0);
    defineProperty('hasContent', handleHasContent, false);
    defineProperty('maxTabWidth', handleMaxTabWidth, getMaxTabWidth());
    defineProperty('shouldPaginate', handleShouldPaginate, false);

    // Define boolean attributes
    defineBooleanAttribute('noInkBar', handleInkBar);
    defineBooleanAttribute('dynamicHeight', handleDynamicHeight);
    defineBooleanAttribute('noPagination');
    defineBooleanAttribute('swipeContent');
    defineBooleanAttribute('autoselect');
    defineBooleanAttribute('noSelectClick');
    defineBooleanAttribute('centerTabs', handleCenterTabs);
    defineBooleanAttribute('enableDisconnect');

    // Define public properties
    ctrl.scope             = $scope;
    ctrl.parent            = $scope.$parent;
    ctrl.tabs              = [];
    ctrl.lastSelectedIndex = null;
    ctrl.hasFocus          = false;
    ctrl.styleTabItemFocus = false;
    ctrl.shouldCenterTabs  = shouldCenterTabs();
    ctrl.tabContentPrefix  = 'tab-content-';
    ctrl.navigationHint = 'Use the left and right arrow keys to navigate between tabs';

    // Setup the tabs controller after all bindings are available.
    setupTabsController();
  }

  /**
   * Perform setup for the controller, setup events and watcher(s)
   */
  function setupTabsController () {
    ctrl.selectedIndex = ctrl.selectedIndex || 0;
    compileTemplate();
    configureWatchers();
    bindEvents();
    $mdTheming($element);
    $mdUtil.nextTick(function () {
      updateHeightFromContent();
      adjustOffset();
      updateInkBarStyles();
      ctrl.tabs[ ctrl.selectedIndex ] && ctrl.tabs[ ctrl.selectedIndex ].scope.select();
      loaded = true;
      updatePagination();
    });
  }

  /**
   * Compiles the template provided by the user.  This is passed as an attribute from the tabs
   * directive's template function.
   */
  function compileTemplate () {
    var template = $attrs.$mdTabsTemplate,
        element  = angular.element($element[0].querySelector('md-tab-data'));

    element.html(template);
    $compile(element.contents())(ctrl.parent);
    delete $attrs.$mdTabsTemplate;
  }

  /**
   * Binds events used by the tabs component.
   */
  function bindEvents () {
    angular.element($window).on('resize', handleWindowResize);
    $scope.$on('$destroy', cleanup);
  }

  /**
   * Configure watcher(s) used by Tabs
   */
  function configureWatchers () {
    $scope.$watch('$mdTabsCtrl.selectedIndex', handleSelectedIndexChange);
  }

  /**
   * Creates a one-way binding manually rather than relying on AngularJS's isolated scope
   * @param key
   * @param handler
   */
  function defineOneWayBinding (key, handler) {
    var attr = $attrs.$normalize('md-' + key);
    if (handler) defineProperty(key, handler);
    $attrs.$observe(attr, function (newValue) { ctrl[ key ] = newValue; });
  }

  /**
   * Defines boolean attributes with default value set to true. I.e. md-stretch-tabs with no value
   * will be treated as being truthy.
   * @param {string} key
   * @param {Function=} handler
   */
  function defineBooleanAttribute (key, handler) {
    var attr = $attrs.$normalize('md-' + key);
    if (handler) defineProperty(key, handler, undefined);
    if ($attrs.hasOwnProperty(attr)) updateValue($attrs[attr]);
    $attrs.$observe(attr, updateValue);
    function updateValue (newValue) {
      ctrl[ key ] = newValue !== 'false';
    }
  }

  /**
   * Remove any events defined by this controller
   */
  function cleanup () {
    destroyed = true;
    angular.element($window).off('resize', handleWindowResize);
  }

  // Change handlers

  /**
   * Toggles stretch tabs class and updates inkbar when tab stretching changes.
   */
  function handleStretchTabs () {
    var elements = getElements();
    angular.element(elements.wrapper).toggleClass('md-stretch-tabs', shouldStretchTabs());
    updateInkBarStyles();
  }

  /**
   * Update the value of ctrl.shouldCenterTabs.
   */
  function handleCenterTabs () {
    ctrl.shouldCenterTabs = shouldCenterTabs();
  }

  /**
   * @param {number} newWidth new max tab width in pixels
   * @param {number} oldWidth previous max tab width in pixels
   */
  function handleMaxTabWidth (newWidth, oldWidth) {
    if (newWidth !== oldWidth) {
      var elements = getElements();

      // Set the max width for the real tabs
      angular.forEach(elements.tabs, function(tab) {
        tab.style.maxWidth = newWidth + 'px';
      });

      // Set the max width for the dummy tabs too
      angular.forEach(elements.dummies, function(tab) {
        tab.style.maxWidth = newWidth + 'px';
      });

      $mdUtil.nextTick(ctrl.updateInkBarStyles);
    }
  }

  function handleShouldPaginate (newValue, oldValue) {
    if (newValue !== oldValue) {
      ctrl.maxTabWidth      = getMaxTabWidth();
      ctrl.shouldCenterTabs = shouldCenterTabs();
      $mdUtil.nextTick(function () {
        ctrl.maxTabWidth = getMaxTabWidth();
        adjustOffset(ctrl.selectedIndex);
      });
    }
  }

  /**
   * Add/remove the `md-no-tab-content` class depending on `ctrl.hasContent`
   * @param {boolean} hasContent
   */
  function handleHasContent (hasContent) {
    $element[ hasContent ? 'removeClass' : 'addClass' ]('md-no-tab-content');
  }

  /**
   * Apply ctrl.offsetLeft to the paging element when it changes
   * @param {string|number} left
   */
  function handleOffsetChange (left) {
    var newValue = ((ctrl.shouldCenterTabs || isRtl() ? '' : '-') + left + 'px');

    // Fix double-negative which can happen with RTL support
    newValue = newValue.replace('--', '');

    angular.element(getElements().paging).css($mdConstant.CSS.TRANSFORM,
                                              'translate(' + newValue + ', 0)');
    $scope.$broadcast('$mdTabsPaginationChanged');
  }

  /**
   * Update the UI whenever `ctrl.focusIndex` is updated
   * @param {number} newIndex
   * @param {number} oldIndex
   */
  function handleFocusIndexChange (newIndex, oldIndex) {
    if (newIndex === oldIndex) return;
    if (!getElements().tabs[ newIndex ]) return;
    adjustOffset();
    redirectFocus();
  }

  /**
   * Update the UI whenever the selected index changes. Calls user-defined select/deselect methods.
   * @param {number} newValue selected index's new value
   * @param {number} oldValue selected index's previous value
   */
  function handleSelectedIndexChange (newValue, oldValue) {
    if (newValue === oldValue) return;

    ctrl.selectedIndex     = getNearestSafeIndex(newValue);
    ctrl.lastSelectedIndex = oldValue;
    ctrl.updateInkBarStyles();
    updateHeightFromContent();
    adjustOffset(newValue);
    $scope.$broadcast('$mdTabsChanged');
    ctrl.tabs[ oldValue ] && ctrl.tabs[ oldValue ].scope.deselect();
    ctrl.tabs[ newValue ] && ctrl.tabs[ newValue ].scope.select();
  }

  function getTabElementIndex(tabEl){
    var tabs = $element[0].getElementsByTagName('md-tab');
    return Array.prototype.indexOf.call(tabs, tabEl[0]);
  }

  /**
   * Queues up a call to `handleWindowResize` when a resize occurs while the tabs component is
   * hidden.
   */
  function handleResizeWhenVisible () {
    // if there is already a watcher waiting for resize, do nothing
    if (handleResizeWhenVisible.watcher) return;
    // otherwise, we will abuse the $watch function to check for visible
    handleResizeWhenVisible.watcher = $scope.$watch(function () {
      // since we are checking for DOM size, we use $mdUtil.nextTick() to wait for after the DOM updates
      $mdUtil.nextTick(function () {
        // if the watcher has already run (ie. multiple digests in one cycle), do nothing
        if (!handleResizeWhenVisible.watcher) return;

        if ($element.prop('offsetParent')) {
          handleResizeWhenVisible.watcher();
          handleResizeWhenVisible.watcher = null;

          handleWindowResize();
        }
      }, false);
    });
  }

  // Event handlers / actions

  /**
   * Handle user keyboard interactions
   * @param {KeyboardEvent} event keydown event
   */
  function keydown (event) {
    switch (event.keyCode) {
      case $mdConstant.KEY_CODE.LEFT_ARROW:
        event.preventDefault();
        incrementIndex(-1, true);
        break;
      case $mdConstant.KEY_CODE.RIGHT_ARROW:
        event.preventDefault();
        incrementIndex(1, true);
        break;
      case $mdConstant.KEY_CODE.SPACE:
      case $mdConstant.KEY_CODE.ENTER:
        event.preventDefault();
        if (!locked) select(ctrl.focusIndex);
        break;
      case $mdConstant.KEY_CODE.TAB:
        // On tabbing out of the tablist, reset hasFocus to reset ng-focused and
        // its md-focused class if the focused tab is not the active tab.
        if (ctrl.focusIndex !== ctrl.selectedIndex) {
          ctrl.focusIndex = ctrl.selectedIndex;
        }
        break;
    }
  }

  /**
   * Update the selected index. Triggers a click event on the original `md-tab` element in order
   * to fire user-added click events if canSkipClick or `md-no-select-click` are false.
   * @param index
   * @param canSkipClick Optionally allow not firing the click event if `md-no-select-click` is also true.
   */
  function select (index, canSkipClick) {
    if (!locked) ctrl.focusIndex = ctrl.selectedIndex = index;
    // skip the click event if noSelectClick is enabled
    if (canSkipClick && ctrl.noSelectClick) return;
    // nextTick is required to prevent errors in user-defined click events
    $mdUtil.nextTick(function () {
      ctrl.tabs[ index ].element.triggerHandler('click');
    }, false);
  }

  /**
   * When pagination is on, this makes sure the selected index is in view.
   * @param {WheelEvent} event
   */
  function scroll (event) {
    if (!ctrl.shouldPaginate) return;
    event.preventDefault();
    if (event.deltaY) {
      ctrl.offsetLeft = fixOffset(ctrl.offsetLeft + event.deltaY);
    } else if (event.deltaX) {
      ctrl.offsetLeft = fixOffset(ctrl.offsetLeft + event.deltaX);
    }
  }

  /**
   * Slides the tabs over approximately one page forward.
   */
  function nextPage () {
    if (!ctrl.canPageForward()) { return; }

    var newOffset = MdTabsPaginationService.increasePageOffset(getElements(), ctrl.offsetLeft);

    ctrl.offsetLeft = fixOffset(newOffset);
  }

  /**
   * Slides the tabs over approximately one page backward.
   */
  function previousPage () {
    if (!ctrl.canPageBack()) { return; }

    var newOffset = MdTabsPaginationService.decreasePageOffset(getElements(), ctrl.offsetLeft);

    // Set the new offset
    ctrl.offsetLeft = fixOffset(newOffset);
  }

  /**
   * Update size calculations when the window is resized.
   */
  function handleWindowResize () {
    ctrl.lastSelectedIndex = ctrl.selectedIndex;
    ctrl.offsetLeft        = fixOffset(ctrl.offsetLeft);

    $mdUtil.nextTick(function () {
      ctrl.updateInkBarStyles();
      updatePagination();
    });
  }

  /**
   * Hides or shows the tabs ink bar.
   * @param {boolean} hide A Boolean (not just truthy/falsy) value to determine whether the class
   * should be added or removed.
   */
  function handleInkBar (hide) {
    angular.element(getElements().inkBar).toggleClass('ng-hide', hide);
  }

  /**
   * Enables or disables tabs dynamic height.
   * @param {boolean} value A Boolean (not just truthy/falsy) value to determine whether the class
   * should be added or removed.
   */
  function handleDynamicHeight (value) {
    $element.toggleClass('md-dynamic-height', value);
  }

  /**
   * Remove a tab from the data and select the nearest valid tab.
   * @param {Object} tabData tab to remove
   */
  function removeTab (tabData) {
    if (destroyed) return;
    var selectedIndex = ctrl.selectedIndex,
        tab           = ctrl.tabs.splice(tabData.getIndex(), 1)[ 0 ];
    refreshIndex();
    // when removing a tab, if the selected index did not change, we have to manually trigger the
    //   tab select/deselect events
    if (ctrl.selectedIndex === selectedIndex) {
      tab.scope.deselect();
      ctrl.tabs[ ctrl.selectedIndex ] && ctrl.tabs[ ctrl.selectedIndex ].scope.select();
    }
    $mdUtil.nextTick(function () {
      updatePagination();
      ctrl.offsetLeft = fixOffset(ctrl.offsetLeft);
    });
  }

  /**
   * Create an entry in the tabs array for a new tab at the specified index.
   * @param {Object} tabData tab to insert
   * @param {number} index location to insert the new tab
   * @returns {Object} the inserted tab
   */
  function insertTab (tabData, index) {
    var hasLoaded = loaded;
    var proto = {
          getIndex:     function () { return ctrl.tabs.indexOf(tab); },
          isActive:     function () { return this.getIndex() === ctrl.selectedIndex; },
          isLeft:       function () { return this.getIndex() < ctrl.selectedIndex; },
          isRight:      function () { return this.getIndex() > ctrl.selectedIndex; },
          shouldRender: function () { return ctrl.dynamicHeight || this.isActive(); },
          hasFocus:     function () {
            return ctrl.styleTabItemFocus
                && ctrl.hasFocus && this.getIndex() === ctrl.focusIndex;
          },
          id:           $mdUtil.nextUid(),
          hasContent: !!(tabData.template && tabData.template.trim())
    };
    var tab = angular.extend(proto, tabData);

    if (angular.isDefined(index)) {
      ctrl.tabs.splice(index, 0, tab);
    } else {
      ctrl.tabs.push(tab);
    }
    processQueue();
    updateHasContent();

    $mdUtil.nextTick(function () {
      updatePagination();
      setAriaControls(tab);

      // if autoselect is enabled, select the newly added tab
      if (hasLoaded && ctrl.autoselect) {
        $mdUtil.nextTick(function () {
          $mdUtil.nextTick(function () { select(ctrl.tabs.indexOf(tab)); });
        });
      }
    });
    return tab;
  }

  // Getter methods

  /**
   * Gathers references to all of the DOM elements used by this controller.
   * @returns {Object}
   */
  function getElements () {
    var elements = {};
    var node = $element[0];

    // gather tab bar elements
    elements.wrapper = node.querySelector('md-tabs-wrapper');
    elements.canvas  = elements.wrapper.querySelector('md-tabs-canvas');
    elements.paging  = elements.canvas.querySelector('md-pagination-wrapper');
    elements.inkBar  = elements.paging.querySelector('md-ink-bar');
    elements.nextButton = node.querySelector('md-next-button');
    elements.prevButton = node.querySelector('md-prev-button');

    elements.contents = node.querySelectorAll('md-tabs-content-wrapper > md-tab-content');
    elements.tabs    = elements.paging.querySelectorAll('md-tab-item');
    elements.dummies = elements.canvas.querySelectorAll('md-dummy-tab');

    return elements;
  }

  /**
   * Determines whether or not the left pagination arrow should be enabled.
   * @returns {boolean}
   */
  function canPageBack () {
    // This works for both LTR and RTL
    return ctrl.offsetLeft > 0;
  }

  /**
   * Determines whether or not the right pagination arrow should be enabled.
   * @returns {*|boolean}
   */
  function canPageForward () {
    var elements = getElements();
    var lastTab = elements.tabs[ elements.tabs.length - 1 ];

    if (isRtl()) {
      return ctrl.offsetLeft < elements.paging.offsetWidth - elements.canvas.offsetWidth;
    }

    return lastTab && lastTab.offsetLeft + lastTab.offsetWidth > elements.canvas.clientWidth +
        ctrl.offsetLeft;
  }

  /**
   * Returns currently focused tab item's element ID
   */
  function getFocusedTabId() {
    var focusedTab = ctrl.tabs[ctrl.focusIndex];
    if (!focusedTab || !focusedTab.id) {
      return null;
    }
    return 'tab-item-' + focusedTab.id;
  }

  /**
   * Determines if the UI should stretch the tabs to fill the available space.
   * @returns {*}
   */
  function shouldStretchTabs () {
    switch (ctrl.stretchTabs) {
      case 'always':
        return true;
      case 'never':
        return false;
      default:
        return !ctrl.shouldPaginate
            && $window.matchMedia('(max-width: 600px)').matches;
    }
  }

  /**
   * Determines if the tabs should appear centered.
   * @returns {boolean}
   */
  function shouldCenterTabs () {
    return ctrl.centerTabs && !ctrl.shouldPaginate;
  }

  /**
   * Determines if pagination is necessary to display the tabs within the available space.
   * @returns {boolean} true if pagination is necessary, false otherwise
   */
  function shouldPaginate () {
    var shouldPaginate;
    if (ctrl.noPagination || !loaded) return false;
    var canvasWidth = $element.prop('clientWidth');

    angular.forEach(getElements().tabs, function (tab) {
      canvasWidth -= tab.offsetWidth;
    });

    shouldPaginate = canvasWidth < 0;
    // Work around width calculation issues on IE11 when pagination is enabled.
    // Don't do this on other browsers because it breaks scroll to new tab animation.
    if ($mdUtil.msie) {
      if (shouldPaginate) {
        getElements().paging.style.width = '999999px';
      } else {
        getElements().paging.style.width = undefined;
      }
    }
    return shouldPaginate;
  }

  /**
   * Finds the nearest tab index that is available. This is primarily used for when the active
   * tab is removed.
   * @param newIndex
   * @returns {*}
   */
  function getNearestSafeIndex (newIndex) {
    if (newIndex === -1) return -1;
    var maxOffset = Math.max(ctrl.tabs.length - newIndex, newIndex),
        i, tab;
    for (i = 0; i <= maxOffset; i++) {
      tab = ctrl.tabs[ newIndex + i ];
      if (tab && (tab.scope.disabled !== true)) return tab.getIndex();
      tab = ctrl.tabs[ newIndex - i ];
      if (tab && (tab.scope.disabled !== true)) return tab.getIndex();
    }
    return newIndex;
  }

  // Utility methods

  /**
   * Defines a property using a getter and setter in order to trigger a change handler without
   * using `$watch` to observe changes.
   * @param {PropertyKey} key
   * @param {Function} handler
   * @param {any} value
   */
  function defineProperty (key, handler, value) {
    Object.defineProperty(ctrl, key, {
      get: function () { return value; },
      set: function (newValue) {
        var oldValue = value;
        value        = newValue;
        handler && handler(newValue, oldValue);
      }
    });
  }

  /**
   * Updates whether or not pagination should be displayed.
   */
  function updatePagination () {
    ctrl.maxTabWidth = getMaxTabWidth();
    ctrl.shouldPaginate = shouldPaginate();
  }

  /**
   * @param {Array<HTMLElement>} tabs tab item elements for use in computing total width
   * @returns {number} the width of the tabs in the specified array in pixels
   */
  function calcTabsWidth(tabs) {
    var width = 0;

    angular.forEach(tabs, function (tab) {
      // Uses the larger value between `getBoundingClientRect().width` and `offsetWidth`.  This
      // prevents `offsetWidth` value from being rounded down and causing wrapping issues, but
      // also handles scenarios where `getBoundingClientRect()` is inaccurate (ie. tabs inside
      // of a dialog).
      width += Math.max(tab.offsetWidth, tab.getBoundingClientRect().width);
    });

    return Math.ceil(width);
  }

  /**
   * @returns {number} either the max width as constrained by the container or the max width from
   * the 2017 version of the Material Design spec.
   */
  function getMaxTabWidth() {
    var elements = getElements(),
      containerWidth = elements.canvas.clientWidth,

      // See https://material.io/archive/guidelines/components/tabs.html#tabs-specs
      specMax = 264;

    // Do the spec maximum, or the canvas width; whichever is *smaller* (tabs larger than the canvas
    // width can break the pagination) but not less than 0
    return Math.max(0, Math.min(containerWidth - 1, specMax));
  }

  /**
   * Re-orders the tabs and updates the selected and focus indexes to their new positions.
   * This is triggered by `tabDirective.js` when the user's tabs have been re-ordered.
   */
  function updateTabOrder () {
    var selectedItem   = ctrl.tabs[ ctrl.selectedIndex ],
        focusItem      = ctrl.tabs[ ctrl.focusIndex ];
    ctrl.tabs          = ctrl.tabs.sort(function (a, b) {
      return a.index - b.index;
    });
    ctrl.selectedIndex = ctrl.tabs.indexOf(selectedItem);
    ctrl.focusIndex    = ctrl.tabs.indexOf(focusItem);
  }

  /**
   * This moves the selected or focus index left or right. This is used by the keydown handler.
   * @param {number} inc amount to increment
   * @param {boolean} focus true to increment the focus index, false to increment the selected index
   */
  function incrementIndex (inc, focus) {
    var newIndex,
        key   = focus ? 'focusIndex' : 'selectedIndex',
        index = ctrl[ key ];
    for (newIndex = index + inc;
         ctrl.tabs[ newIndex ] && ctrl.tabs[ newIndex ].scope.disabled;
         newIndex += inc) { /* do nothing */ }

    newIndex = (index + inc + ctrl.tabs.length) % ctrl.tabs.length;

    if (ctrl.tabs[ newIndex ]) {
      ctrl[ key ] = newIndex;
    }
  }

  /**
   * This is used to forward focus to tab container elements. This method is necessary to avoid
   * animation issues when attempting to focus an item that is out of view.
   */
  function redirectFocus () {
    ctrl.styleTabItemFocus = ($mdInteraction.getLastInteractionType() === 'keyboard');
    var tabToFocus = getElements().tabs[ctrl.focusIndex];
    if (tabToFocus) {
      tabToFocus.focus();
    }
  }

  /**
   * Forces the pagination to move the focused tab into view.
   * @param {number=} index of tab to have its offset adjusted
   */
  function adjustOffset (index) {
    var elements = getElements();

    if (!angular.isNumber(index)) index = ctrl.focusIndex;
    if (!elements.tabs[ index ]) return;
    if (ctrl.shouldCenterTabs) return;
    var tab         = elements.tabs[ index ],
        left        = tab.offsetLeft,
        right       = tab.offsetWidth + left,
        extraOffset = 32;

    // If we are selecting the first tab (in LTR and RTL), always set the offset to 0
    if (index === 0) {
      ctrl.offsetLeft = 0;
      return;
    }

    if (isRtl()) {
      var tabWidthsBefore = calcTabsWidth(Array.prototype.slice.call(elements.tabs, 0, index));
      var tabWidthsIncluding = calcTabsWidth(Array.prototype.slice.call(elements.tabs, 0, index + 1));

      ctrl.offsetLeft = Math.min(ctrl.offsetLeft, fixOffset(tabWidthsBefore));
      ctrl.offsetLeft = Math.max(ctrl.offsetLeft, fixOffset(tabWidthsIncluding - elements.canvas.clientWidth));
    } else {
      ctrl.offsetLeft = Math.max(ctrl.offsetLeft, fixOffset(right - elements.canvas.clientWidth + extraOffset));
      ctrl.offsetLeft = Math.min(ctrl.offsetLeft, fixOffset(left));
    }
  }

  /**
   * Iterates through all queued functions and clears the queue. This is used for functions that
   * are called before the UI is ready, such as size calculations.
   */
  function processQueue () {
    queue.forEach(function (func) { $mdUtil.nextTick(func); });
    queue = [];
  }

  /**
   * Determines if the tab content area is needed.
   */
  function updateHasContent () {
    var hasContent = false;
    var i;

    for (i = 0; i < ctrl.tabs.length; i++) {
      if (ctrl.tabs[i].hasContent) {
        hasContent = true;
        break;
      }
    }

    ctrl.hasContent = hasContent;
  }

  /**
   * Moves the indexes to their nearest valid values.
   */
  function refreshIndex () {
    ctrl.selectedIndex = getNearestSafeIndex(ctrl.selectedIndex);
    ctrl.focusIndex    = getNearestSafeIndex(ctrl.focusIndex);
  }

  /**
   * Calculates the content height of the current tab.
   * @returns {*}
   */
  function updateHeightFromContent () {
    if (!ctrl.dynamicHeight) return $element.css('height', '');
    if (!ctrl.tabs.length) return queue.push(updateHeightFromContent);

    var elements = getElements();

    var tabContent    = elements.contents[ ctrl.selectedIndex ],
        contentHeight = tabContent ? tabContent.offsetHeight : 0,
        tabsHeight    = elements.wrapper.offsetHeight,
        newHeight     = contentHeight + tabsHeight,
        currentHeight = $element.prop('clientHeight');

    if (currentHeight === newHeight) return;

    // Adjusts calculations for when the buttons are bottom-aligned since this relies on absolute
    // positioning.  This should probably be cleaned up if a cleaner solution is possible.
    if ($element.attr('md-align-tabs') === 'bottom') {
      currentHeight -= tabsHeight;
      newHeight -= tabsHeight;
      // Need to include bottom border in these calculations
      if ($element.attr('md-border-bottom') !== undefined) {
        ++currentHeight;
      }
    }

    // Lock during animation so the user can't change tabs
    locked = true;

    var fromHeight = { height: currentHeight + 'px' },
        toHeight = { height: newHeight + 'px' };

    // Set the height to the current, specific pixel height to fix a bug on iOS where the height
    // first animates to 0, then back to the proper height causing a visual glitch
    $element.css(fromHeight);

    // Animate the height from the old to the new
    $animateCss($element, {
      from: fromHeight,
      to: toHeight,
      easing: 'cubic-bezier(0.35, 0, 0.25, 1)',
      duration: 0.5
    }).start().done(function () {
      // Then (to fix the same iOS issue as above), disable transitions and remove the specific
      // pixel height so the height can size with browser width/content changes, etc.
      $element.css({
        transition: 'none',
        height: ''
      });

      // In the next tick, re-allow transitions (if we do it all at once, $element.css is "smart"
      // enough to batch it for us instead of doing it immediately, which undoes the original
      // transition: none)
      $mdUtil.nextTick(function() {
        $element.css('transition', '');
      });

      // And unlock so tab changes can occur
      locked = false;
    });
  }

  /**
   * Repositions the ink bar to the selected tab.
   * Parameters are used when calling itself recursively when md-center-tabs is used as we need to
   * run two passes to properly center the tabs. These parameters ensure that we only run two passes
   * and that we don't run indefinitely.
   * @param {number=} previousTotalWidth previous width of pagination wrapper
   * @param {number=} previousWidthOfTabItems previous width of all tab items
   */
  function updateInkBarStyles (previousTotalWidth, previousWidthOfTabItems) {
    if (ctrl.noInkBar) {
      return;
    }
    var elements = getElements();

    if (!elements.tabs[ ctrl.selectedIndex ]) {
      angular.element(elements.inkBar).css({ left: 'auto', right: 'auto' });
      return;
    }

    if (!ctrl.tabs.length) {
      queue.push(ctrl.updateInkBarStyles);
      return;
    }
    // If the element is not visible, we will not be able to calculate sizes until it becomes
    // visible. We should treat that as a resize event rather than just updating the ink bar.
    if (!$element.prop('offsetParent')) {
      handleResizeWhenVisible();
      return;
    }

    var index      = ctrl.selectedIndex,
        totalWidth = elements.paging.offsetWidth,
        tab        = elements.tabs[ index ],
        left       = tab.offsetLeft,
        right      = totalWidth - left - tab.offsetWidth;

    if (ctrl.shouldCenterTabs) {
      // We need to use the same calculate process as in the pagination wrapper, to avoid rounding
      // deviations.
      var totalWidthOfTabItems = calcTabsWidth(elements.tabs);

      if (totalWidth > totalWidthOfTabItems &&
          previousTotalWidth !== totalWidth &&
          previousWidthOfTabItems !== totalWidthOfTabItems) {
        $timeout(updateInkBarStyles, 0, true, totalWidth, totalWidthOfTabItems);
      }
    }
    updateInkBarClassName();
    angular.element(elements.inkBar).css({ left: left + 'px', right: right + 'px' });
  }

  /**
   * Adds left/right classes so that the ink bar will animate properly.
   */
  function updateInkBarClassName () {
    var elements = getElements();
    var newIndex = ctrl.selectedIndex,
        oldIndex = ctrl.lastSelectedIndex,
        ink      = angular.element(elements.inkBar);
    if (!angular.isNumber(oldIndex)) return;
    ink
        .toggleClass('md-left', newIndex < oldIndex)
        .toggleClass('md-right', newIndex > oldIndex);
  }

  /**
   * Takes an offset value and makes sure that it is within the min/max allowed values.
   * @param {number} value
   * @returns {number}
   */
  function fixOffset (value) {
    var elements = getElements();

    if (!elements.tabs.length || !ctrl.shouldPaginate) return 0;

    var lastTab    = elements.tabs[ elements.tabs.length - 1 ],
        totalWidth = lastTab.offsetLeft + lastTab.offsetWidth;

    if (isRtl()) {
      value = Math.min(elements.paging.offsetWidth - elements.canvas.clientWidth, value);
      value = Math.max(0, value);
    } else {
      value = Math.max(0, value);
      value = Math.min(totalWidth - elements.canvas.clientWidth, value);
    }

    return value;
  }

  /**
   * Attaches a ripple to the tab item element.
   * @param scope
   * @param element
   */
  function attachRipple (scope, element) {
    var elements = getElements();
    var options = { colorElement: angular.element(elements.inkBar) };
    $mdTabInkRipple.attach(scope, element, options);
  }

  /**
   * Sets the `aria-controls` attribute to the elements that correspond to the passed-in tab.
   * @param tab
   */
  function setAriaControls (tab) {
    if (tab.hasContent) {
      var nodes = $element[0].querySelectorAll('[md-tab-id="' + tab.id + '"]');
      angular.element(nodes).attr('aria-controls', ctrl.tabContentPrefix + tab.id);
    }
  }

  function isRtl() {
    return $mdUtil.isRtl($attrs);
  }
}

})();
(function(){
"use strict";

/**
 * @ngdoc directive
 * @name mdTabs
 * @module material.components.tabs
 *
 * @restrict E
 *
 * @description
 * The `<md-tabs>` directive serves as the container for 1..n
 * <a ng-href="api/directive/mdTab">`<md-tab>`</a> child directives.
 * In turn, the nested `<md-tab>` directive is used to specify a tab label for the
 * **header button** and <i>optional</i> tab view content that will be associated with each tab
 * button.
 *
 * Below is the markup for its simplest usage:
 *
 *  <hljs lang="html">
 *  <md-tabs>
 *    <md-tab label="Tab #1"></md-tab>
 *    <md-tab label="Tab #2"></md-tab>
 *    <md-tab label="Tab #3"></md-tab>
 *  </md-tabs>
 *  </hljs>
 *
 * Tabs support three (3) usage scenarios:
 *
 *  1. Tabs (buttons only)
 *  2. Tabs with internal view content
 *  3. Tabs with external view content
 *
 * **Tabs-only** support is useful when tab buttons are used for custom navigation regardless of any
 * other components, content, or views.
 *
 * <blockquote><b>Note:</b> If you are using the Tabs component for page-level navigation, please
 * use the <a ng-href="./api/directive/mdNavBar">NavBar component</a> instead. It handles this
 * case a more natively and more performantly.</blockquote>
 *
 * **Tabs with internal views** are the traditional usage where each tab has associated view
 * content and the view switching is managed internally by the Tabs component.
 *
 * **Tabs with external view content** is often useful when content associated with each tab is
 * independently managed and data-binding notifications announce tab selection changes.
 *
 * Additional features include:
 *
 * *  Content can include any markup.
 * *  If a tab is disabled while active/selected, then the next tab will be auto-selected.
 *
 * ### Theming
 *
 * By default, tabs use your app's accent color for the selected tab's text and ink bar.
 *
 * You can use the theming classes to change the color of the `md-tabs` background:
 * * Applying `class="md-primary"` will use your app's primary color for the background, your
 *   accent color for the ink bar, and your primary palette's contrast color for the text of the
 *   selected tab.
 *   * When using the `md-primary` class, you can add the `md-no-ink-bar-color` class to make the
 *     ink bar use your theme's primary contrast color instead of the accent color.
 * * Applying `class="md-accent"` will use your app's accent color for the background and your
 *   accent palette's contrast color for the text and ink bar of the selected tab.
 * * Applying `class="md-warn"` will use your app's warn color for the background and your
 *   warn palette's contrast color for the text and ink bar of the selected tab.
 *
 * ### Explanation of tab stretching
 *
 * Initially, tabs will have an inherent size.  This size will either be defined by how much space
 * is needed to accommodate their text or set by the user through CSS.
 * Calculations will be based on this size.
 *
 * On mobile devices, tabs will be expanded to fill the available horizontal space.
 * When this happens, all tabs will become the same size.
 *
 * On desktops, by default, stretching will never occur.
 *
 * This default behavior can be overridden through the `md-stretch-tabs` attribute.
 * Here is a table showing when stretching will occur:
 *
 * `md-stretch-tabs` | mobile    | desktop
 * ------------------|-----------|--------
 * `auto`            | stretched | ---
 * `always`          | stretched | stretched
 * `never`           | ---       | ---
 *
 * @param {number=} md-selected Index of the active/selected tab.
 * @param {expression=} md-no-ink-bar If `true` or no value, disables the selection ink bar.
 * @param {string=} md-align-tabs Attribute to indicate position of tab buttons: `bottom` or `top`;
 *  Default is `top`.
 * @param {string=} md-stretch-tabs Attribute to indicate whether or not to stretch tabs: `auto`,
 *  `always`, or `never`; Default is `auto`.
 * @param {expression=} md-dynamic-height If `true` or no value, the tab wrapper will resize based
 *  on the contents of the selected tab.
 * @param {boolean=} md-border-bottom If the attribute is present, shows a solid `1px` border
 *  between the tabs and their content.
 * @param {boolean=} md-center-tabs If the attribute is present, tabs will be centered provided
 *  there is no need for pagination.
 * @param {boolean=} md-no-pagination If the attribute is present, pagination will remain off.
 * @param {expression=} md-swipe-content When enabled, swipe gestures will be enabled for the content
 *  area to allow swiping between tabs.
 * @param {boolean=} md-enable-disconnect When enabled, scopes will be disconnected for tabs that
 *  are not being displayed. This provides a performance boost, but may also cause unexpected
 *  issues. It is not recommended for most users.
 * @param {boolean=} md-autoselect If the attribute is present, any tabs added after the initial
 *  load will be automatically selected.
 * @param {boolean=} md-no-select-click When true, click events will not be fired when the value of
 *  `md-active` on an `md-tab` changes. This is useful when using tabs with UI-Router's child
 *  states, as triggering a click event in that case can cause an extra tab change to occur.
 * @param {string=} md-navigation-hint Attribute to override the default `tablist` navigation hint
 *  that screen readers will announce to provide instructions for navigating between tabs. This is
 *  desirable when you want the hint to be in a different language. Default is "Use the left and
 *  right arrow keys to navigate between tabs".
 *
 * @usage
 * <hljs lang="html">
 * <md-tabs md-selected="selectedIndex">
 *   <img ng-src="img/angular.png" class="centered" alt="Angular icon">
 *   <md-tab
 *       ng-repeat="tab in tabs | orderBy:predicate:reversed"
 *       md-on-select="onTabSelected(tab)"
 *       md-on-deselect="announceDeselected(tab)"
 *       ng-disabled="tab.disabled">
 *     <md-tab-label>
 *       {{tab.title}}
 *       <img src="img/removeTab.png" ng-click="removeTab(tab)" class="delete" alt="Remove tab">
 *     </md-tab-label>
 *     <md-tab-body>
 *       {{tab.content}}
 *     </md-tab-body>
 *   </md-tab>
 * </md-tabs>
 * </hljs>
 *
 */
MdTabs.$inject = ["$$mdSvgRegistry"];
angular
    .module('material.components.tabs')
    .directive('mdTabs', MdTabs);

function MdTabs ($$mdSvgRegistry) {
  return {
    scope:            {
      navigationHint: '@?mdNavigationHint',
      selectedIndex: '=?mdSelected'
    },
    template:         function (element, attr) {
      attr.$mdTabsTemplate = element.html();
      return '' +
        '<md-tabs-wrapper> ' +
          '<md-tab-data></md-tab-data> ' +
          '<md-prev-button ' +
              'tabindex="-1" ' +
              'role="button" ' +
              'aria-label="Previous Page" ' +
              'aria-disabled="{{!$mdTabsCtrl.canPageBack()}}" ' +
              'ng-class="{ \'md-disabled\': !$mdTabsCtrl.canPageBack() }" ' +
              'ng-if="$mdTabsCtrl.shouldPaginate" ' +
              'ng-click="$mdTabsCtrl.previousPage()"> ' +
            '<md-icon md-svg-src="'+ $$mdSvgRegistry.mdTabsArrow +'"></md-icon> ' +
          '</md-prev-button> ' +
          '<md-next-button ' +
              'tabindex="-1" ' +
              'role="button" ' +
              'aria-label="Next Page" ' +
              'aria-disabled="{{!$mdTabsCtrl.canPageForward()}}" ' +
              'ng-class="{ \'md-disabled\': !$mdTabsCtrl.canPageForward() }" ' +
              'ng-if="$mdTabsCtrl.shouldPaginate" ' +
              'ng-click="$mdTabsCtrl.nextPage()"> ' +
            '<md-icon md-svg-src="'+ $$mdSvgRegistry.mdTabsArrow +'"></md-icon> ' +
          '</md-next-button> ' +
          '<md-tabs-canvas ' +
              'tabindex="{{ $mdTabsCtrl.hasFocus ? -1 : 0 }}" ' +
              'ng-focus="$mdTabsCtrl.redirectFocus()" ' +
              'ng-class="{ ' +
                  '\'md-paginated\': $mdTabsCtrl.shouldPaginate, ' +
                  '\'md-center-tabs\': $mdTabsCtrl.shouldCenterTabs ' +
              '}" ' +
              'ng-keydown="$mdTabsCtrl.keydown($event)"> ' +
            '<md-pagination-wrapper ' +
                'ng-class="{ \'md-center-tabs\': $mdTabsCtrl.shouldCenterTabs }" ' +
                'md-tab-scroll="$mdTabsCtrl.scroll($event)" ' +
                'role="tablist" ' +
                'aria-label="{{::$mdTabsCtrl.navigationHint}}">' +
              '<md-tab-item ' +
                  'tabindex="{{ tab.isActive() ? 0 : -1 }}" ' +
                  'class="md-tab {{::tab.scope.tabClass}}" ' +
                  'ng-repeat="tab in $mdTabsCtrl.tabs" ' +
                  'role="tab" ' +
                  'id="tab-item-{{::tab.id}}" ' +
                  'md-tab-id="{{::tab.id}}" ' +
                  'aria-selected="{{tab.isActive()}}" ' +
                  'aria-disabled="{{tab.scope.disabled || \'false\'}}" ' +
                  'ng-click="$mdTabsCtrl.select(tab.getIndex())" ' +
                  'ng-focus="$mdTabsCtrl.hasFocus = true" ' +
                  'ng-blur="$mdTabsCtrl.hasFocus = false" ' +
                  'ng-class="{ ' +
                      '\'md-active\':    tab.isActive(), ' +
                      '\'md-focused\':   tab.hasFocus(), ' +
                      '\'md-disabled\':  tab.scope.disabled ' +
                  '}" ' +
                  'ng-disabled="tab.scope.disabled" ' +
                  'md-swipe-left="$mdTabsCtrl.nextPage()" ' +
                  'md-swipe-right="$mdTabsCtrl.previousPage()" ' +
                  'md-tabs-template="::tab.label" ' +
                  'md-scope="::tab.parent"></md-tab-item> ' +
              '<md-ink-bar></md-ink-bar> ' +
            '</md-pagination-wrapper> ' +
            '<md-tabs-dummy-wrapper aria-hidden="true" class="md-visually-hidden md-dummy-wrapper"> ' +
              '<md-dummy-tab ' +
                  'class="md-tab" ' +
                  'tabindex="-1" ' +
                  'ng-focus="$mdTabsCtrl.hasFocus = true" ' +
                  'ng-blur="$mdTabsCtrl.hasFocus = false" ' +
                  'ng-repeat="tab in $mdTabsCtrl.tabs" ' +
                  'md-tabs-template="::tab.label" ' +
                  'md-scope="::tab.parent"></md-dummy-tab> ' +
            '</md-tabs-dummy-wrapper> ' +
          '</md-tabs-canvas> ' +
        '</md-tabs-wrapper> ' +
        '<md-tabs-content-wrapper ng-show="$mdTabsCtrl.hasContent && $mdTabsCtrl.selectedIndex >= 0" class="_md"> ' +
          '<md-tab-content ' +
              'id="{{:: $mdTabsCtrl.tabContentPrefix + tab.id}}" ' +
              'class="_md" ' +
              'role="tabpanel" ' +
              'aria-labelledby="tab-item-{{::tab.id}}" ' +
              'md-swipe-left="$mdTabsCtrl.swipeContent && $mdTabsCtrl.incrementIndex(1)" ' +
              'md-swipe-right="$mdTabsCtrl.swipeContent && $mdTabsCtrl.incrementIndex(-1)" ' +
              'ng-if="tab.hasContent" ' +
              'ng-repeat="(index, tab) in $mdTabsCtrl.tabs" ' +
              'ng-class="{ ' +
                '\'md-no-transition\': $mdTabsCtrl.lastSelectedIndex == null, ' +
                '\'md-active\':        tab.isActive(), ' +
                '\'md-left\':          tab.isLeft(), ' +
                '\'md-right\':         tab.isRight(), ' +
                '\'md-no-scroll\':     $mdTabsCtrl.dynamicHeight ' +
              '}"> ' +
            '<div ' +
                'md-tabs-template="::tab.template" ' +
                'md-connected-if="tab.isActive()" ' +
                'md-scope="::tab.parent" ' +
                'ng-if="$mdTabsCtrl.enableDisconnect || tab.shouldRender()"></div> ' +
          '</md-tab-content> ' +
        '</md-tabs-content-wrapper>';
    },
    controller:       'MdTabsController',
    controllerAs:     '$mdTabsCtrl',
    bindToController: true
  };
}

})();
(function(){
"use strict";


MdTabsDummyWrapper.$inject = ["$mdUtil", "$window"];angular
  .module('material.components.tabs')
  .directive('mdTabsDummyWrapper', MdTabsDummyWrapper);

/**
 * @private
 *
 * @param $mdUtil
 * @param $window
 * @returns {{require: string, link: link}}
 * @constructor
 *
 * @ngInject
 */
function MdTabsDummyWrapper ($mdUtil, $window) {
  return {
    require: '^?mdTabs',
    link:    function link (scope, element, attr, ctrl) {
      if (!ctrl) return;

      var observer;
      var disconnect;

      var mutationCallback = function() {
        ctrl.updatePagination();
        ctrl.updateInkBarStyles();
      };

      if ('MutationObserver' in $window) {
        var config = {
          childList: true,
          subtree: true,
          // Per https://bugzilla.mozilla.org/show_bug.cgi?id=1138368, browsers will not fire
          // the childList mutation, once a <span> element's innerText changes.
          // The characterData of the <span> element will change.
          characterData: true
        };

        observer = new MutationObserver(mutationCallback);
        observer.observe(element[0], config);
        disconnect = observer.disconnect.bind(observer);
      } else {
        var debounced = $mdUtil.debounce(mutationCallback, 15, null, false);

        element.on('DOMSubtreeModified', debounced);
        disconnect = element.off.bind(element, 'DOMSubtreeModified', debounced);
      }

      // Disconnect the observer
      scope.$on('$destroy', function() {
        disconnect();
      });
    }
  };
}

})();
(function(){
"use strict";


MdTabsTemplate.$inject = ["$compile", "$mdUtil"];angular
    .module('material.components.tabs')
    .directive('mdTabsTemplate', MdTabsTemplate);

function MdTabsTemplate ($compile, $mdUtil) {
  return {
    restrict: 'A',
    link:     link,
    scope:    {
      template:     '=mdTabsTemplate',
      connected:    '=?mdConnectedIf',
      compileScope: '=mdScope'
    },
    require:  '^?mdTabs'
  };
  function link (scope, element, attr, ctrl) {
    if (!ctrl) return;

    var compileScope = ctrl.enableDisconnect ? scope.compileScope.$new() : scope.compileScope;

    element.html(scope.template);
    $compile(element.contents())(compileScope);

    return $mdUtil.nextTick(handleScope);

    function handleScope () {
      scope.$watch('connected', function (value) { value === false ? disconnect() : reconnect(); });
      scope.$on('$destroy', reconnect);
    }

    function disconnect () {
      if (ctrl.enableDisconnect) $mdUtil.disconnectScope(compileScope);
    }

    function reconnect () {
      if (ctrl.enableDisconnect) $mdUtil.reconnectScope(compileScope);
    }
  }
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.toast
 * @description
 * Toast and Snackbar component.
 */
MdToastDirective.$inject = ["$mdToast"];
MdToastProvider.$inject = ["$$interimElementProvider"];
angular.module('material.components.toast', [
  'material.core',
  'material.components.button'
])
  .directive('mdToast', MdToastDirective)
  .provider('$mdToast', MdToastProvider);

/* @ngInject */
function MdToastDirective($mdToast) {
  return {
    restrict: 'E',
    link: function postLink(scope, element) {
      element.addClass('_md');     // private md component indicator for styling

      // When navigation force destroys an interimElement, then
      // listen and $destroy() that interim instance...
      scope.$on('$destroy', function() {
        $mdToast.destroy();
      });
    }
  };
}

/**
 * @ngdoc service
 * @name $mdToast
 * @module material.components.toast
 *
 * @description
 * `$mdToast` is a service to build a toast notification on any position
 * on the screen with an optional duration, and provides a simple promise API.
 *
 * The toast will be always positioned at the `bottom`, when the screen size is
 * between `600px` and `959px` (`sm` breakpoint)
 *
 * ## Restrictions on custom toasts
 * - The toast's template must have an outer `<md-toast>` element.
 * - For a toast action, use element with class `md-action`.
 * - Add the class `md-capsule` for curved corners.
 *
 * ### Custom Presets
 * Developers are also able to create their own preset, which can be easily used without repeating
 * their options each time.
 *
 * <hljs lang="js">
 *   $mdToastProvider.addPreset('testPreset', {
 *     options: function() {
 *       return {
 *         template:
 *           '<md-toast>' +
 *             '<div class="md-toast-content">' +
 *               'This is a custom preset' +
 *             '</div>' +
 *           '</md-toast>',
 *         controllerAs: 'toast',
 *         bindToController: true
 *       };
 *     }
 *   });
 * </hljs>
 *
 * After you created your preset at config phase, you can easily access it.
 *
 * <hljs lang="js">
 *   $mdToast.show(
 *     $mdToast.testPreset()
 *   );
 * </hljs>
 *
 * ## Parent container notes
 *
 * The toast is positioned using absolute positioning relative to its first non-static parent
 * container. Thus, if the requested parent container uses static positioning, we will temporarily
 * set its positioning to `relative` while the toast is visible and reset it when the toast is
 * hidden.
 *
 * Because of this, it is usually best to ensure that the parent container has a fixed height and
 * prevents scrolling by setting the `overflow: hidden;` style. Since the position is based off of
 * the parent's height, the toast may be mispositioned if you allow the parent to scroll.
 *
 * You can, however, have a scrollable element inside of the container; just make sure the
 * container itself does not scroll.
 *
 * <hljs lang="html">
 * <div layout-fill id="toast-container">
 *   <md-content>
 *     I can have lots of content and scroll!
 *   </md-content>
 * </div>
 * </hljs>
 *
 * @usage
 * <hljs lang="html">
 * <div ng-controller="MyController">
 *   <md-button ng-click="openToast()">
 *     Open a Toast!
 *   </md-button>
 * </div>
 * </hljs>
 *
 * <hljs lang="js">
 * var app = angular.module('app', ['ngMaterial']);
 * app.controller('MyController', function($scope, $mdToast) {
 *   $scope.openToast = function($event) {
 *     $mdToast.show($mdToast.simple().textContent('Hello!'));
 *     // Could also do $mdToast.showSimple('Hello');
 *   };
 * });
 * </hljs>
 */

/**
 * @ngdoc method
 * @name $mdToast#showSimple
 *
 * @param {string} message The message to display inside the toast
 * @description
 * Convenience method which builds and shows a simple toast.
 *
 * @returns {promise} A promise that can be resolved with `$mdToast.hide()`.
 */

/**
 * @ngdoc method
 * @name $mdToast#simple
 *
 * @description
 * Builds a preconfigured toast.
 *
 * @returns {obj} a `$mdToastPreset` with the following chainable configuration methods.
 *
 * _**Note:** These configuration methods are provided in addition to the methods provided by
 * the `build()` and `show()` methods below._
 *
 * <table class="md-api-table methods">
 *    <thead>
 *      <tr>
 *        <th>Method</th>
 *        <th>Description</th>
 *      </tr>
 *    </thead>
 *    <tbody>
 *      <tr>
 *        <td>`.textContent(string)`</td>
 *        <td>Sets the toast content to the specified string</td>
 *      </tr>
 *      <tr>
 *        <td>`.action(string)`</td>
 *        <td>
 *          Adds an action button. <br/>
 *          If clicked, the promise (returned from `show()`) will resolve with the value `'ok'`;
 *          otherwise, it is resolved with `true` after a `hideDelay` timeout.
 *        </td>
 *      </tr>
 *      <tr>
 *        <td>`.actionKey(string)`</td>
 *        <td>
 *          Adds a hotkey for the action button to the page. <br/>
 *          If the `actionKey` and `Control` key are pressed, the toast's action will be triggered.
 *        </td>
 *      </tr>
 *      <tr>
 *        <td>`.actionHint(string)`</td>
 *        <td>
 *          Text that a screen reader will announce to let the user know how to activate the
 *          action. <br>
 *          If an `actionKey` is defined, this defaults to:
 *          'Press Control-"`actionKey`" to ' followed by the `action`.
 *        </td>
 *      </tr>
 *      <tr>
 *        <td>`.dismissHint(string)`</td>
 *        <td>
 *          Text that a screen reader will announce to let the user know how to dismiss the toast.
 *          <br>Defaults to: "Press Escape to dismiss."
 *        </td>
 *      </tr>
 *      <tr>
 *        <td>`.highlightAction(boolean)`</td>
 *        <td>
 *          Whether or not the action button will have an additional highlight class.<br/>
 *          By default the `accent` color will be applied to the action button.
 *        </td>
 *      </tr>
 *      <tr>
 *        <td>`.highlightClass(string)`</td>
 *        <td>
 *          If set, the given class will be applied to the highlighted action button.<br/>
 *          This allows you to specify the highlight color easily. Highlight classes are
 *          `md-primary`, `md-warn`, and `md-accent`
 *        </td>
 *      </tr>
 *      <tr>
 *        <td>`.capsule(boolean)`</td>
 *        <td>
 *          Whether or not to add the `md-capsule` class to the toast to provide rounded corners
 *        </td>
 *      </tr>
 *      <tr>
 *        <td>`.theme(string)`</td>
 *        <td>
 *          Sets the theme on the toast to the requested theme. Default is `$mdThemingProvider`'s
 *          default.
 *        </td>
 *      </tr>
 *      <tr>
 *        <td>`.toastClass(string)`</td>
 *        <td>Sets a class on the toast element</td>
 *      </tr>
 *    </tbody>
 * </table>
 */

/**
 * @ngdoc method
 * @name $mdToast#updateTextContent
 *
 * @description
 * Updates the content of an existing toast. Useful for updating things like counts, etc.
 */

/**
 * @ngdoc method
 * @name $mdToast#build
 *
 * @description
 * Creates a custom `$mdToastPreset` that you can configure.
 *
 * @returns {obj} a `$mdToastPreset` with the chainable configuration methods for shows' options
 *   (see below).
 */

/**
 * @ngdoc method
 * @name $mdToast#show
 *
 * @description Shows the toast.
 *
 * @param {Object} optionsOrPreset Either provide an `$mdToastPreset` returned from `simple()`
 * and `build()`, or an options object with the following properties:
 *
 *   - `templateUrl` - `{string=}`: The url of an html template file that will
 *     be used as the content of the toast. Restrictions: the template must
 *     have an outer `md-toast` element.
 *   - `template` - `{string=}`: Same as templateUrl, except this is an actual
 *     template string.
 *   - `autoWrap` - `{boolean=}`: Whether or not to automatically wrap the template content with a
 *     `<div class="md-toast-content">` if one is not provided. Defaults to true. Can be disabled
 *     if you provide a custom toast directive.
 *   - `scope` - `{Object=}`: the scope to link the template / controller to. If none is specified,
 *     it will create a new child scope. This scope will be destroyed when the toast is removed
 *     unless `preserveScope` is set to true.
 *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed.
 *     Default is false
 *   - `hideDelay` - `{number=}`: The number of milliseconds the toast should stay active before
 *     automatically closing. Set to `0` or `false` to have the toast stay open until closed
 *     manually via an action in the toast, a hotkey, or a swipe gesture. For accessibility, toasts
 *     should not automatically close when they contain an action.<br>
 *     Defaults to: `3000`.
 *   - `position` - `{string=}`: Sets the position of the toast. <br/>
 *     Available: any combination of `'bottom'`, `'left'`, `'top'`, `'right'`, `'end'`, and
 *     `'start'`. The properties `'end'` and `'start'` are dynamic and can be used for RTL support.
 *     <br/>
 *     Default combination: `'bottom left'`.
 *   - `toastClass` - `{string=}`: A class to set on the toast element.
 *   - `controller` - `{string=}`: The controller to associate with this toast.
 *     The controller will be injected the local `$mdToast.hide()`, which is a function
 *     used to hide the toast.
 *   - `locals` - `{Object=}`: An object containing key/value pairs. The keys will be used as names
 *     of values to inject into the controller. For example, `locals: {three: 3}` would inject
 *     `three` into the controller with the value of 3.
 *   - `bindToController` - `{boolean=}`: bind the locals to the controller, instead of passing
 *     them in.
 *   - `resolve` - `{Object=}`: Similar to locals, except it takes promises as values
 *     and the toast will not open until the promises resolve.
 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
 *   - `parent` - `{element=}`: The element to append the toast to. Defaults to appending
 *     to the root element of the application.
 *
 * @returns {promise} A promise that can be resolved with `$mdToast.hide()`. `$mdToast.hide()` will
 * resolve either with the boolean value `true` or the value passed as an argument to
 * `$mdToast.hide()`.
 */

/**
 * @ngdoc method
 * @name $mdToast#hide
 *
 * @description
 * Hide an existing toast and resolve the promise returned from `$mdToast.show()`.
 *
 * @param {*=} response An argument for the resolved promise.
 *
 * @returns {promise} A promise that is called when the existing element is removed from the DOM.
 * The promise is resolved with either the Boolean value `true` or the value passed as the
 * argument to `$mdToast.hide()`.
 */

function MdToastProvider($$interimElementProvider) {
  // Differentiate promise resolves: hide timeout (value == true) and hide action clicks
  // (value == ok).
  MdToastController.$inject = ["$mdToast", "$scope", "$log"];
  toastDefaultOptions.$inject = ["$animate", "$mdToast", "$mdUtil", "$mdMedia", "$document", "$q"];
  var ACTION_RESOLVE = 'ok';

  var activeToastContent;
  var $mdToast = $$interimElementProvider('$mdToast')
    .setDefaults({
      methods: ['position', 'hideDelay', 'capsule', 'parent', 'position', 'toastClass'],
      options: toastDefaultOptions
    })
    .addPreset('simple', {
      argOption: 'textContent',
      methods: ['textContent', 'action', 'actionKey', 'actionHint', 'highlightAction',
                'highlightClass', 'theme', 'parent', 'dismissHint'],
      options: /* @ngInject */ ["$mdToast", "$mdTheming", function($mdToast, $mdTheming) {
        return {
          template:
            '<md-toast md-theme="{{ toast.theme }}" ng-class="{\'md-capsule\': toast.capsule}">' +
            '  <div class="md-toast-content" aria-live="polite" aria-relevant="all">' +
            '    <span class="md-toast-text">' +
            '      {{ toast.content }}' +
            '    </span>' +
            '    <span class="md-visually-hidden">{{ toast.dismissHint }}</span>' +
            '    <span class="md-visually-hidden" ng-if="toast.action && toast.actionKey">' +
            '      {{ toast.actionHint }}' +
            '    </span>' +
            '    <md-button class="md-action" ng-if="toast.action" ng-click="toast.resolve()" ' +
            '               ng-class="highlightClasses">' +
            '      {{ toast.action }}' +
            '    </md-button>' +
            '  </div>' +
            '</md-toast>',
          controller: MdToastController,
          theme: $mdTheming.defaultTheme(),
          controllerAs: 'toast',
          bindToController: true
        };
      }]
    })
    .addMethod('updateTextContent', updateTextContent);

    function updateTextContent(newContent) {
      activeToastContent = newContent;
    }

    return $mdToast;

  /**
   * Controller for the Toast interim elements.
   * @ngInject
   */
  function MdToastController($mdToast, $scope, $log) {
    // For compatibility with AngularJS 1.6+, we should always use the $onInit hook in
    // interimElements. The $mdCompiler simulates the $onInit hook for all versions.
    this.$onInit = function() {
      var self = this;

      if (self.highlightAction) {
        $scope.highlightClasses = [
          'md-highlight',
          self.highlightClass
        ];
      }

      // If an action is defined and no actionKey is specified, then log a warning.
      if (self.action && !self.actionKey) {
        $log.warn('Toasts with actions should define an actionKey for accessibility.',
          'Details: https://material.angularjs.org/latest/api/service/$mdToast#mdtoast-simple');
      }

      if (self.actionKey && !self.actionHint) {
        self.actionHint = 'Press Control-"' + self.actionKey + '" to ';
      }

      if (!self.dismissHint) {
        self.dismissHint = 'Press Escape to dismiss.';
      }

      $scope.$watch(function() { return activeToastContent; }, function() {
        self.content = activeToastContent;
      });

      this.resolve = function() {
        $mdToast.hide(ACTION_RESOLVE);
      };
    };
  }

  /* @ngInject */
  function toastDefaultOptions($animate, $mdToast, $mdUtil, $mdMedia, $document, $q) {
    var SWIPE_EVENTS = '$md.swipeleft $md.swiperight $md.swipeup $md.swipedown';
    return {
      onShow: onShow,
      onRemove: onRemove,
      toastClass: '',
      position: 'bottom left',
      themable: true,
      hideDelay: 3000,
      autoWrap: true,
      transformTemplate: function(template, options) {
        var shouldAddWrapper = options.autoWrap && template && !/md-toast-content/g.test(template);

        if (shouldAddWrapper) {
          // Root element of template will be <md-toast>. We need to wrap all of its content inside
          // of <div class="md-toast-content">. All templates provided here should be static,
          // developer-controlled content (meaning we're not attempting to guard against XSS).
          var templateRoot = document.createElement('md-template');
          templateRoot.innerHTML = template;

          // Iterate through all root children, to detect possible md-toast directives.
          for (var i = 0; i < templateRoot.children.length; i++) {
            if (templateRoot.children[i].nodeName === 'MD-TOAST') {
              var wrapper = angular.element('<div class="md-toast-content">');

              // Wrap the children of the `md-toast` directive in jqLite, to be able to append
              // multiple nodes with the same execution.
              wrapper.append(angular.element(templateRoot.children[i].childNodes));

              // Append the new wrapped element to the `md-toast` directive.
              templateRoot.children[i].appendChild(wrapper[0]);
            }
          }

          // We have to return the innerHTML, because we do not want to have the `md-template`
          // element to be the root element of our interimElement.
          return templateRoot.innerHTML;
        }

        return template || '';
      }
    };

    /**
     * @param {{toast: {actionKey: string=}}=} scope
     * @param {JQLite} element
     * @param {Object.<string, string>} options
     * @return {*}
     */
    function onShow(scope, element, options) {
      activeToastContent = options.textContent;

      var isSmScreen = !$mdMedia('gt-sm');

      element = $mdUtil.extractElementByName(element, 'md-toast', true);
      options.element = element;

      options.onSwipe = function(ev) {
        // Add the relevant swipe class to the element so it can animate correctly
        var swipe = ev.type.replace('$md.','');
        var direction = swipe.replace('swipe', '');

        // If the swipe direction is down/up but the toast came from top/bottom don't fade away
        // Unless the screen is small, then the toast always on bottom
        if ((direction === 'down' && options.position.indexOf('top') !== -1 && !isSmScreen) ||
            (direction === 'up' && (options.position.indexOf('bottom') !== -1 || isSmScreen))) {
          return;
        }

        if ((direction === 'left' || direction === 'right') && isSmScreen) {
          return;
        }

        element.addClass('md-' + swipe);
        $mdUtil.nextTick($mdToast.cancel);
      };
      options.openClass = toastOpenClass(options.position);

      element.addClass(options.toastClass);

      // 'top left' -> 'md-top md-left'
      options.parent.addClass(options.openClass);

      // static is the default position
      if ($mdUtil.hasComputedStyle(options.parent, 'position', 'static')) {
        options.parent.css('position', 'relative');
      }

      setupActionKeyListener(scope.toast && scope.toast.actionKey ?
        scope.toast.actionKey : undefined);

      element.on(SWIPE_EVENTS, options.onSwipe);

      var verticalPositionDefined = false;
      var positionClasses = options.position.split(' ').map(function (position) {
        if (position) {
          var className = 'md-' + position;
          if (className === 'md-top' || className === 'md-bottom') {
            verticalPositionDefined = true;
          }
          return className;
        }
        return 'md-bottom';
      });
      // If only "right" or "left" are defined, default to a vertical position of "bottom"
      // as documented.
      if (!verticalPositionDefined) {
        positionClasses.push('md-bottom');
      }
      element.addClass(isSmScreen ? 'md-bottom' : positionClasses.join(' '));

      if (options.parent) {
        options.parent.addClass('md-toast-animating');
      }
      return $animate.enter(element, options.parent).then(function() {
        if (options.parent) {
          options.parent.removeClass('md-toast-animating');
        }
      });
    }

    /**
     * @param {Object} scope the toast's scope
     * @param {JQLite} element the toast to be removed
     * @param {Object} options
     * @return {Promise<*>} a Promise to remove the element immediately or to animate it out.
     */
    function onRemove(scope, element, options) {
      if (scope.toast && scope.toast.actionKey) {
        removeActionKeyListener();
      }
      element.off(SWIPE_EVENTS, options.onSwipe);
      if (options.parent) options.parent.addClass('md-toast-animating');
      if (options.openClass) options.parent.removeClass(options.openClass);

      // Don't run the leave animation if the element has already been destroyed.
      return ((options.$destroy === true) ? $q.when(element.remove()) : $animate.leave(element))
        .then(function () {
          if (options.parent) options.parent.removeClass('md-toast-animating');
          if ($mdUtil.hasComputedStyle(options.parent, 'position', 'static')) {
            options.parent.css('position', '');
          }
        });
    }

    function toastOpenClass(position) {
      // For mobile, always open full-width on bottom
      if (!$mdMedia('gt-xs')) {
        return 'md-toast-open-bottom';
      }

      return 'md-toast-open-' + (position.indexOf('top') > -1 ? 'top' : 'bottom');
    }

    /**
     * @param {string} actionKey
     */
    function setupActionKeyListener(actionKey) {
      /**
       * @param {KeyboardEvent} event
       */
      var handleKeyDown = function(event) {
        if (event.key === 'Escape') {
          $mdToast.hide(false);
        }
        if (actionKey && event.key === actionKey && event.ctrlKey) {
          $mdToast.hide(ACTION_RESOLVE);
        }
      };
      $document.on('keydown', handleKeyDown);
    }

    function removeActionKeyListener() {
      $document.off('keydown');
    }
  }
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.toolbar
 */
mdToolbarDirective.$inject = ["$$rAF", "$mdConstant", "$mdUtil", "$mdTheming", "$animate", "$timeout"];
angular.module('material.components.toolbar', [
  'material.core',
  'material.components.content'
])
  .directive('mdToolbar', mdToolbarDirective);

/**
 * @ngdoc directive
 * @name mdToolbar
 * @module material.components.toolbar
 * @restrict E
 * @description
 * `md-toolbar` is used to place a toolbar in your app.
 *
 * Toolbars are usually used above a content area to display the title of the
 * current page, and show relevant action buttons for that page.
 *
 * You can change the height of the toolbar by adding either the
 * `md-medium-tall` or `md-tall` class to the toolbar.
 *
 * @usage
 * <hljs lang="html">
 * <div layout="column" layout-fill>
 *   <md-toolbar>
 *
 *     <div class="md-toolbar-tools">
 *       <h2 md-truncate flex>My App's Title</h2>
 *
 *       <md-button>
 *         Right Bar Button
 *       </md-button>
 *     </div>
 *
 *   </md-toolbar>
 *   <md-content>
 *     Hello!
 *   </md-content>
 * </div>
 * </hljs>
 *
 * <i><b>Note:</b> The code above shows usage with the `md-truncate` component which provides an
 * ellipsis if the title is longer than the width of the Toolbar.</i>
 *
 * ## CSS & Styles
 *
 * The `<md-toolbar>` provides a few custom CSS classes that you may use to enhance the
 * functionality of your toolbar.
 *
 * <div>
 * <docs-css-api-table>
 *
 *   <docs-css-selector code="md-toolbar .md-toolbar-tools">
 *     The `md-toolbar-tools` class provides quite a bit of automatic styling for your toolbar
 *     buttons and text. When applied, it will center the buttons and text vertically for you.
 *   </docs-css-selector>
 *
 * </docs-css-api-table>
 * </div>
 *
 * ### Private Classes
 *
 * Currently, the only private class is the `md-toolbar-transitions` class. All other classes are
 * considered public.
 *
 * @param {boolean=} md-scroll-shrink Whether the header should shrink away as
 * the user scrolls down, and reveal itself as the user scrolls up.
 *
 * _**Note (1):** for scrollShrink to work, the toolbar must be a sibling of a
 * `md-content` element, placed before it. See the scroll shrink demo._
 *
 * _**Note (2):** The `md-scroll-shrink` attribute is only parsed on component
 * initialization, it does not watch for scope changes._
 *
 *
 * @param {number=} md-shrink-speed-factor How much to change the speed of the toolbar's
 * shrinking by. For example, if 0.25 is given then the toolbar will shrink
 * at one fourth the rate at which the user scrolls down. Default 0.5.
 *
 */

function mdToolbarDirective($$rAF, $mdConstant, $mdUtil, $mdTheming, $animate, $timeout) {
  var translateY = angular.bind(null, $mdUtil.supplant, 'translate3d(0,{0}px,0)');

  return {
    template: '',
    restrict: 'E',

    link: function(scope, element, attr) {

      element.addClass('_md');     // private md component indicator for styling
      $mdTheming(element);

      $mdUtil.nextTick(function () {
        element.addClass('_md-toolbar-transitions');     // adding toolbar transitions after digest
      }, false);

      if (angular.isDefined(attr.mdScrollShrink)) {
        setupScrollShrink();
      }

      function setupScrollShrink() {

        var toolbarHeight;
        var contentElement;
        var disableScrollShrink = angular.noop;

        // Current "y" position of scroll
        // Store the last scroll top position
        var y = 0;
        var prevScrollTop = 0;
        var shrinkSpeedFactor = attr.mdShrinkSpeedFactor || 0.5;

        var debouncedContentScroll = $$rAF.throttle(onContentScroll);
        var debouncedUpdateHeight = $mdUtil.debounce(updateToolbarHeight, 5 * 1000);

        // Wait for $mdContentLoaded event from mdContent directive.
        // If the mdContent element is a sibling of our toolbar, hook it up
        // to scroll events.

        scope.$on('$mdContentLoaded', onMdContentLoad);

        // If the toolbar is used inside an ng-if statement, we may miss the
        // $mdContentLoaded event, so we attempt to fake it if we have a
        // md-content close enough.

        attr.$observe('mdScrollShrink', onChangeScrollShrink);

        // If the toolbar has ngShow or ngHide we need to update height immediately as it changed
        // and not wait for $mdUtil.debounce to happen

        if (attr.ngShow) { scope.$watch(attr.ngShow, updateToolbarHeight); }
        if (attr.ngHide) { scope.$watch(attr.ngHide, updateToolbarHeight); }

        // If the scope is destroyed (which could happen with ng-if), make sure
        // to disable scroll shrinking again

        scope.$on('$destroy', disableScrollShrink);

        /**
         * @param {string} shrinkWithScroll value of md-scroll-shrink attribute
         */
        function onChangeScrollShrink(shrinkWithScroll) {
          var closestContent = $mdUtil.getSiblings(element, 'md-content');

          // If there are content elements, fake the call using the first content element.
          // This might still fail if the content element isn't a sibling of the toolbar.
          if (!contentElement && closestContent.length) {
            onMdContentLoad(null, closestContent[0]);
          }

          // Evaluate the expression
          shrinkWithScroll = scope.$eval(shrinkWithScroll);

          // Disable only if the attribute's expression evaluates to false
          if (shrinkWithScroll === false) {
            disableScrollShrink();
          } else {
            disableScrollShrink = enableScrollShrink();
          }
        }

        /**
         * @param {null} $event $mdContentLoaded always has a null event
         * @param {JQLite} newContentEl JQLite object containing an md-content
         */
        function onMdContentLoad($event, newContentEl) {
          // Toolbar and content must be siblings
          if (newContentEl && element.parent()[0] === newContentEl.parent()[0]) {
            // unhook old content event listener if exists
            if (contentElement) {
              contentElement.off('scroll', debouncedContentScroll);
            }

            contentElement = newContentEl;
            disableScrollShrink = enableScrollShrink();
          }
        }

        /**
         *
         */
        function onContentScroll(e) {
          var scrollTop = e ? e.target.scrollTop : prevScrollTop;

          debouncedUpdateHeight();

          y = Math.min(
            toolbarHeight / shrinkSpeedFactor,
            Math.max(0, y + scrollTop - prevScrollTop)
          );

          element.css($mdConstant.CSS.TRANSFORM, translateY([-y * shrinkSpeedFactor]));
          contentElement.css($mdConstant.CSS.TRANSFORM, translateY([(toolbarHeight - y) * shrinkSpeedFactor]));

          prevScrollTop = scrollTop;

          $mdUtil.nextTick(function() {
            var hasWhiteFrame = element.hasClass('md-whiteframe-z1');

            if (hasWhiteFrame && !y) {
              $animate.removeClass(element, 'md-whiteframe-z1');
            } else if (!hasWhiteFrame && y) {
              $animate.addClass(element, 'md-whiteframe-z1');
            }
          });

        }

        /**
         *
         */
        function enableScrollShrink() {
          if (!contentElement)     return angular.noop;           // no md-content

          contentElement.on('scroll', debouncedContentScroll);
          contentElement.attr('scroll-shrink', 'true');

          $timeout(updateToolbarHeight);

          return function disableScrollShrink() {
            contentElement.off('scroll', debouncedContentScroll);
            contentElement.attr('scroll-shrink', 'false');

            updateToolbarHeight();
          };
        }

        /**
         *
         */
        function updateToolbarHeight() {
          toolbarHeight = element.prop('offsetHeight');
          // Add a negative margin-top the size of the toolbar to the content el.
          // The content will start transformed down the toolbarHeight amount,
          // so everything looks normal.
          //
          // As the user scrolls down, the content will be transformed up slowly
          // to put the content underneath where the toolbar was.
          var margin = (-toolbarHeight * shrinkSpeedFactor) + 'px';

          contentElement.css({
            "margin-top": margin,
            "margin-bottom": margin
          });

          onContentScroll();
        }

      }

    }
  };

}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.tooltip
 */
MdTooltipDirective.$inject = ["$timeout", "$window", "$$rAF", "$document", "$interpolate", "$mdUtil", "$mdPanel", "$$mdTooltipRegistry"];
angular
    .module('material.components.tooltip', [
      'material.core',
      'material.components.panel'
    ])
    .directive('mdTooltip', MdTooltipDirective)
    .service('$$mdTooltipRegistry', MdTooltipRegistry);


/**
 * @ngdoc directive
 * @name mdTooltip
 * @module material.components.tooltip
 * @description
 * Tooltips are used to describe elements that are interactive and primarily
 * graphical (not textual).
 *
 * Place a `<md-tooltip>` as a child of the element it describes.
 *
 * A tooltip will activate when the user hovers over, focuses, or touches the
 * parent element.
 *
 * @usage
 * <hljs lang="html">
 *   <md-button class="md-fab md-accent" aria-label="Play">
 *     <md-tooltip>Play Music</md-tooltip>
 *     <md-icon md-svg-src="img/icons/ic_play_arrow_24px.svg"></md-icon>
 *   </md-button>
 * </hljs>
 *
 * @param {number=} md-z-index The visual level that the tooltip will appear
 *     in comparison with the rest of the elements of the application.
 * @param {expression=} md-visible Boolean bound to whether the tooltip is
 *     currently visible.
 * @param {number=} md-delay How many milliseconds to wait to show the tooltip
 *     after the user hovers over, focuses, or touches the parent element.
 *     Defaults to 0ms on non-touch devices and 75ms on touch.
 * @param {boolean=} md-autohide If present or provided with a boolean value,
 *     the tooltip will hide on mouse leave, regardless of focus.
 * @param {string=} md-direction The direction that the tooltip is shown,
 *     relative to the parent element. Supports top, right, bottom, and left.
 *     Defaults to bottom.
 */
function MdTooltipDirective($timeout, $window, $$rAF, $document, $interpolate,
    $mdUtil, $mdPanel, $$mdTooltipRegistry) {

  var ENTER_EVENTS = 'focus touchstart mouseenter';
  var LEAVE_EVENTS = 'blur touchcancel mouseleave';
  var TOOLTIP_DEFAULT_Z_INDEX = 100;
  var TOOLTIP_DEFAULT_SHOW_DELAY = 0;
  var TOOLTIP_DEFAULT_DIRECTION = 'bottom';
  var TOOLTIP_DIRECTIONS = {
    top: { x: $mdPanel.xPosition.CENTER, y: $mdPanel.yPosition.ABOVE },
    right: { x: $mdPanel.xPosition.OFFSET_END, y: $mdPanel.yPosition.CENTER },
    bottom: { x: $mdPanel.xPosition.CENTER, y: $mdPanel.yPosition.BELOW },
    left: { x: $mdPanel.xPosition.OFFSET_START, y: $mdPanel.yPosition.CENTER }
  };

  return {
    restrict: 'E',
    priority: 210, // Before ngAria
    scope: {
      mdZIndex: '=?mdZIndex',
      mdDelay: '=?mdDelay',
      mdVisible: '=?mdVisible',
      mdAutohide: '=?mdAutohide',
      mdDirection: '@?mdDirection' // Do not expect expressions.
    },
    link: linkFunc
  };

  function linkFunc(scope, element, attr) {
    // Set constants.
    var tooltipId = 'md-tooltip-' + $mdUtil.nextUid();
    var parent = $mdUtil.getParentWithPointerEvents(element);
    var debouncedOnResize = $$rAF.throttle(updatePosition);
    var mouseActive = false;
    var origin, position, panelPosition, panelRef, autohide, showTimeout,
        elementFocusedOnWindowBlur = null;

    // Set defaults
    setDefaults();

    // Set parent aria-label.
    addAriaLabel();

    // Remove the element from its current DOM position.
    element.detach();

    updatePosition();
    bindEvents();
    configureWatchers();

    function setDefaults() {
      scope.mdZIndex = scope.mdZIndex || TOOLTIP_DEFAULT_Z_INDEX;
      scope.mdDelay = scope.mdDelay || TOOLTIP_DEFAULT_SHOW_DELAY;
      if (!TOOLTIP_DIRECTIONS[scope.mdDirection]) {
        scope.mdDirection = TOOLTIP_DEFAULT_DIRECTION;
      }
    }

    function addAriaLabel(labelText) {
      // Only interpolate the text from the HTML element because otherwise the custom text could
      // be interpolated twice and cause XSS violations.
      var interpolatedText = labelText || $interpolate(element.text().trim())(scope.$parent);

      // Only add the `aria-label` to the parent if there isn't already one, if there isn't an
      // already present `aria-labelledby`, or if the previous `aria-label` was added by the
      // tooltip directive.
      if (
        (!parent.attr('aria-label') && !parent.attr('aria-labelledby')) ||
        parent.attr('md-labeled-by-tooltip')
      ) {
        parent.attr('aria-label', interpolatedText);

        // Set the `md-labeled-by-tooltip` attribute if it has not already been set.
        if (!parent.attr('md-labeled-by-tooltip')) {
          parent.attr('md-labeled-by-tooltip', tooltipId);
        }
      }
    }

    function updatePosition() {
      setDefaults();

      // If the panel has already been created, remove the current origin
      // class from the panel element.
      if (panelRef && panelRef.panelEl) {
        panelRef.panelEl.removeClass(origin);
      }

      // Set the panel element origin class based off of the current
      // mdDirection.
      origin = 'md-origin-' + scope.mdDirection;

      // Create the position of the panel based off of the mdDirection.
      position = TOOLTIP_DIRECTIONS[scope.mdDirection];

      // Using the newly created position object, use the MdPanel
      // panelPosition API to build the panel's position.
      panelPosition = $mdPanel.newPanelPosition()
          .relativeTo(parent)
          .addPanelPosition(position.x, position.y);

      // If the panel has already been created, add the new origin class to
      // the panel element and update it's position with the panelPosition.
      if (panelRef && panelRef.panelEl) {
        panelRef.panelEl.addClass(origin);
        panelRef.updatePosition(panelPosition);
      }
    }

    function bindEvents() {
      // Add a mutationObserver where there is support for it and the need
      // for it in the form of viable host(parent[0]).
      if (parent[0] && 'MutationObserver' in $window) {
        // Use a mutationObserver to tackle #2602.
        var attributeObserver = new MutationObserver(function(mutations) {
          if (isDisabledMutation(mutations)) {
            $mdUtil.nextTick(function() {
              setVisible(false);
            });
          }
        });

        attributeObserver.observe(parent[0], {
          attributes: true
        });
      }

      elementFocusedOnWindowBlur = false;

      $$mdTooltipRegistry.register('scroll', windowScrollEventHandler, true);
      $$mdTooltipRegistry.register('blur', windowBlurEventHandler);
      $$mdTooltipRegistry.register('resize', debouncedOnResize);

      scope.$on('$destroy', onDestroy);

      // To avoid 'synthetic clicks', we listen to mousedown instead of
      // 'click'.
      parent.on('mousedown', mousedownEventHandler);
      parent.on(ENTER_EVENTS, enterEventHandler);

      function isDisabledMutation(mutations) {
        mutations.some(function(mutation) {
          return mutation.attributeName === 'disabled' && parent[0].disabled;
        });
        return false;
      }

      function windowScrollEventHandler() {
        setVisible(false);
      }

      function windowBlurEventHandler() {
        elementFocusedOnWindowBlur = document.activeElement === parent[0];
      }

      function enterEventHandler($event) {
        // Prevent the tooltip from showing when the window is receiving
        // focus.
        if ($event.type === 'focus' && elementFocusedOnWindowBlur) {
          elementFocusedOnWindowBlur = false;
        } else if (!scope.mdVisible) {
          parent.on(LEAVE_EVENTS, leaveEventHandler);
          setVisible(true);

          // If the user is on a touch device, we should bind the tap away
          // after the 'touched' in order to prevent the tooltip being
          // removed immediately.
          if ($event.type === 'touchstart') {
            parent.one('touchend', function() {
              $mdUtil.nextTick(function() {
                $document.one('touchend', leaveEventHandler);
              }, false);
            });
          }
        }
      }

      function leaveEventHandler() {
        autohide = scope.hasOwnProperty('mdAutohide') ?
            scope.mdAutohide :
            attr.hasOwnProperty('mdAutohide');

        if (autohide || mouseActive ||
            $document[0].activeElement !== parent[0]) {
          // When a show timeout is currently in progress, then we have
          // to cancel it, otherwise the tooltip will remain showing
          // without focus or hover.
          if (showTimeout) {
            $timeout.cancel(showTimeout);
            setVisible.queued = false;
            showTimeout = null;
          }

          parent.off(LEAVE_EVENTS, leaveEventHandler);
          parent.triggerHandler('blur');
          setVisible(false);
        }
        mouseActive = false;
      }

      function mousedownEventHandler() {
        mouseActive = true;
      }

      function onDestroy() {
        $$mdTooltipRegistry.deregister('scroll', windowScrollEventHandler, true);
        $$mdTooltipRegistry.deregister('blur', windowBlurEventHandler);
        $$mdTooltipRegistry.deregister('resize', debouncedOnResize);

        parent
            .off(ENTER_EVENTS, enterEventHandler)
            .off(LEAVE_EVENTS, leaveEventHandler)
            .off('mousedown', mousedownEventHandler);

        // Trigger the handler in case any of the tooltips are
        // still visible.
        leaveEventHandler();
        attributeObserver && attributeObserver.disconnect();
      }
    }

    function configureWatchers() {
      if (element[0] && 'MutationObserver' in $window) {
        var attributeObserver = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.attributeName === 'md-visible' &&
                !scope.visibleWatcher) {
              scope.visibleWatcher = scope.$watch('mdVisible',
                  onVisibleChanged);
            }
          });
        });

        attributeObserver.observe(element[0], {
          attributes: true
        });

        // Build watcher only if mdVisible is being used.
        if (attr.hasOwnProperty('mdVisible')) {
          scope.visibleWatcher = scope.$watch('mdVisible',
              onVisibleChanged);
        }
      } else {
        // MutationObserver not supported
        scope.visibleWatcher = scope.$watch('mdVisible', onVisibleChanged);
      }

      // Direction watcher
      scope.$watch('mdDirection', updatePosition);

      // Clean up if the element or parent was removed via jqLite's .remove.
      // A couple of notes:
      //   - In these cases the scope might not have been destroyed, which
      //     is why we destroy it manually. An example of this can be having
      //     `md-visible="false"` and adding tooltips while they're
      //     invisible. If `md-visible` becomes true, at some point, you'd
      //     usually get a lot of tooltips.
      //   - We use `.one`, not `.on`, because this only needs to fire once.
      //     If we were using `.on`, it would get thrown into an infinite
      //     loop.
      //   - This kicks off the scope's `$destroy` event which finishes the
      //     cleanup.
      element.one('$destroy', onElementDestroy);
      parent.one('$destroy', onElementDestroy);
      scope.$on('$destroy', function() {
        setVisible(false);
        panelRef && panelRef.destroy();
        attributeObserver && attributeObserver.disconnect();
        element.remove();
      });

      // Updates the aria-label when the element text changes. This watch
      // doesn't need to be set up if the element doesn't have any data
      // bindings.
      if (element.text().indexOf($interpolate.startSymbol()) > -1) {
        scope.$watch(function() {
          return element.text().trim();
        }, addAriaLabel);
      }

      function onElementDestroy() {
        scope.$destroy();
      }
    }

    function setVisible(value) {
      // Break if passed value is already in queue or there is no queue and
      // passed value is current in the controller.
      if (setVisible.queued && setVisible.value === !!value ||
          !setVisible.queued && scope.mdVisible === !!value) {
        return;
      }
      setVisible.value = !!value;

      if (!setVisible.queued) {
        if (value) {
          setVisible.queued = true;
          showTimeout = $timeout(function() {
            scope.mdVisible = setVisible.value;
            setVisible.queued = false;
            showTimeout = null;
            if (!scope.visibleWatcher) {
              onVisibleChanged(scope.mdVisible);
            }
          }, scope.mdDelay);
        } else {
          $mdUtil.nextTick(function() {
            scope.mdVisible = false;
            if (!scope.visibleWatcher) {
              onVisibleChanged(false);
            }
          });
        }
      }
    }

    function onVisibleChanged(isVisible) {
      isVisible ? showTooltip() : hideTooltip();
    }

    function showTooltip() {
      // Do not show the tooltip if the text is empty.
      if (!element[0].textContent.trim()) {
        throw new Error('Text for the tooltip has not been provided. ' +
            'Please include text within the mdTooltip element.');
      }

      if (!panelRef) {
        var attachTo = angular.element(document.body);
        var panelAnimation = $mdPanel.newPanelAnimation()
            .openFrom(parent)
            .closeTo(parent)
            .withAnimation({
              open: 'md-show',
              close: 'md-hide'
            });

        var panelConfig = {
          id: tooltipId,
          attachTo: attachTo,
          contentElement: element,
          propagateContainerEvents: true,
          panelClass: 'md-tooltip',
          animation: panelAnimation,
          position: panelPosition,
          zIndex: scope.mdZIndex,
          focusOnOpen: false,
          onDomAdded: function() {
            panelRef.panelEl.addClass(origin);
          }
        };

        panelRef = $mdPanel.create(panelConfig);
      }

      panelRef.open().then(function() {
        panelRef.panelEl.attr('role', 'tooltip');
      });
    }

    function hideTooltip() {
      panelRef && panelRef.close();
    }
  }

}


/**
 * Service that is used to reduce the amount of listeners that are being
 * registered on the `window` by the tooltip component. Works by collecting
 * the individual event handlers and dispatching them from a global handler.
 *
 * @ngInject
 */
function MdTooltipRegistry() {
  var listeners = {};
  var ngWindow = angular.element(window);

  return {
    register: register,
    deregister: deregister
  };

  /**
   * Global event handler that dispatches the registered handlers in the
   * service.
   * @param {!Event} event Event object passed in by the browser
   */
  function globalEventHandler(event) {
    if (listeners[event.type]) {
      listeners[event.type].forEach(function(currentHandler) {
        currentHandler.call(this, event);
      }, this);
    }
  }

  /**
   * Registers a new handler with the service.
   * @param {string} type Type of event to be registered.
   * @param {!Function} handler Event handler.
   * @param {boolean} useCapture Whether to use event capturing.
   */
  function register(type, handler, useCapture) {
    var handlers = listeners[type] = listeners[type] || [];

    if (!handlers.length) {
      useCapture ? window.addEventListener(type, globalEventHandler, true) :
          ngWindow.on(type, globalEventHandler);
    }

    if (handlers.indexOf(handler) === -1) {
      handlers.push(handler);
    }
  }

  /**
   * Removes an event handler from the service.
   * @param {string} type Type of event handler.
   * @param {!Function} handler The event handler itself.
   * @param {boolean} useCapture Whether the event handler used event capturing.
   */
  function deregister(type, handler, useCapture) {
    var handlers = listeners[type];
    var index = handlers ? handlers.indexOf(handler) : -1;

    if (index > -1) {
      handlers.splice(index, 1);

      if (handlers.length === 0) {
        useCapture ? window.removeEventListener(type, globalEventHandler, true) :
            ngWindow.off(type, globalEventHandler);
      }
    }
  }
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.truncate
 */
MdTruncateController.$inject = ["$element"];
angular.module('material.components.truncate', ['material.core'])
  .directive('mdTruncate', MdTruncateDirective);

/**
 * @ngdoc directive
 * @name mdTruncate
 * @module material.components.truncate
 * @restrict AE
 * @description
 *
 * The `md-truncate` component displays a label that will automatically clip text which is wider
 * than the component. By default, it displays an ellipsis, but you may apply the `md-clip` CSS
 * class to override this default and use a standard "clipping" approach.
 *
 * <i><b>Note:</b> The `md-truncate` component does not automatically adjust it's width. You must
 * provide the `flex` attribute, or some other CSS-based width management. See the
 * <a ng-href="./demo/truncate">demos</a> for examples.</i>
 *
 * @usage
 *
 * ### As an Element
 *
 * <hljs lang="html">
 *   <div layout="row">
 *     <md-button>Back</md-button>
 *
 *     <md-truncate flex>Chapter 1 - The Way of the Old West</md-truncate>
 *
 *     <md-button>Forward</md-button>
 *   </div>
 * </hljs>
 *
 * ### As an Attribute
 *
 * <hljs lang="html">
 *   <h2 md-truncate style="max-width: 100px;">Some Title With a Lot of Text</h2>
 * </hljs>
 *
 * ## CSS & Styles
 *
 * `<md-truncate>` provides two CSS classes that you may use to control the type of clipping.
 *
 * <i><b>Note:</b> The `md-truncate` also applies a setting of `width: 0;` when used with the `flex`
 * attribute to fix an issue with the flex element not shrinking properly.</i>
 *
 * <div>
 * <docs-css-api-table>
 *
 *   <docs-css-selector code=".md-ellipsis">
 *     Assigns the "ellipsis" behavior (default) which will cut off mid-word and append an ellipsis
 *     (&hellip;) to the end of the text.
 *   </docs-css-selector>
 *
 *   <docs-css-selector code=".md-clip">
 *     Assigns the "clipping" behavior which will simply chop off the text. This may happen
 *     mid-word or even mid-character.
 *   </docs-css-selector>
 *
 * </docs-css-api-table>
 * </div>
 */
function MdTruncateDirective() {
  return {
    restrict: 'AE',

    controller: MdTruncateController
  };
}

/**
 * Controller for the <md-truncate> component.
 *
 * @param $element The md-truncate element.
 *
 * @constructor
 * @ngInject
 */
function MdTruncateController($element) {
  $element.addClass('md-truncate');
}

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.virtualRepeat
 */
VirtualRepeatContainerController.$inject = ["$$rAF", "$mdUtil", "$mdConstant", "$parse", "$rootScope", "$window", "$scope", "$element", "$attrs"];
VirtualRepeatController.$inject = ["$scope", "$element", "$attrs", "$browser", "$document", "$rootScope", "$$rAF", "$mdUtil"];
VirtualRepeatDirective.$inject = ["$parse"];
angular.module('material.components.virtualRepeat', [
  'material.core',
  'material.components.showHide'
])
.directive('mdVirtualRepeatContainer', VirtualRepeatContainerDirective)
.directive('mdVirtualRepeat', VirtualRepeatDirective)
.directive('mdForceHeight', ForceHeightDirective);


/**
 * @ngdoc directive
 * @name mdVirtualRepeatContainer
 * @module material.components.virtualRepeat
 * @restrict E
 * @description
 * `md-virtual-repeat-container` provides the scroll container for
 * <a ng-href="api/directive/mdVirtualRepeat">md-virtual-repeat</a>.
 *
 * VirtualRepeat is a limited substitute for `ng-repeat` that renders only
 * enough DOM nodes to fill the container, recycling them as the user scrolls.
 *
 * Once an element is not visible anymore, the Virtual Repeat recycles the element and reuses it
 * for another visible item by replacing the previous data set with the set of currently visible
 * elements.
 *
 * ### Common Issues
 *
 * - When having one-time bindings inside of the view template, the Virtual Repeat will not properly
 *   update the bindings for new items, since the view will be recycled.
 * - Directives inside of a Virtual Repeat will be only compiled (linked) once, because those
 *   items will be recycled and used for other items.
 *   The Virtual Repeat just updates the scope bindings.
 *
 *
 * ### Notes
 *
 * > The VirtualRepeat is a similar implementation to the Android
 * [RecyclerView](https://developer.android.com/reference/android/support/v7/widget/RecyclerView.html).
 *
 * <!-- This comment forces a break between blockquotes //-->
 *
 * > Please also review the <a ng-href="api/directive/mdVirtualRepeat">mdVirtualRepeat</a>
 * documentation for more information.
 *
 *
 * @usage
 * <hljs lang="html">
 *
 * <md-virtual-repeat-container md-top-index="topIndex">
 *   <div md-virtual-repeat="i in items" md-item-size="20">Hello {{i}}!</div>
 * </md-virtual-repeat-container>
 * </hljs>
 *
 * @param {boolean=} md-auto-shrink When present and the container will shrink to fit
 *     the number of items in the `md-virtual-repeat`.
 * @param {number=} md-auto-shrink-min Minimum number of items that md-auto-shrink
 *     will shrink to. Default: `0`.
 * @param {boolean=} md-orient-horizontal Whether the container should scroll horizontally.
 *     The default is `false` which indicates vertical orientation and scrolling.
 * @param {number=} md-top-index Binds the index of the item that is at the top of the scroll
 *     container to `$scope`. It can both read and set the scroll position.
 */
function VirtualRepeatContainerDirective() {
  return {
    controller: VirtualRepeatContainerController,
    template: virtualRepeatContainerTemplate,
    compile: function virtualRepeatContainerCompile($element, $attrs) {
      $element
          .addClass('md-virtual-repeat-container')
          .addClass($attrs.hasOwnProperty('mdOrientHorizontal')
              ? 'md-orient-horizontal'
              : 'md-orient-vertical');
    }
  };
}


function virtualRepeatContainerTemplate($element) {
  return '<div class="md-virtual-repeat-scroller" role="presentation">' +
    '<div class="md-virtual-repeat-sizer" role="presentation"></div>' +
    '<div class="md-virtual-repeat-offsetter" role="presentation">' +
      $element[0].innerHTML +
    '</div></div>';
}

/**
 * Number of additional elements to render above and below the visible area inside
 * of the virtual repeat container. A higher number results in less flicker when scrolling
 * very quickly in Safari, but comes with a higher rendering and dirty-checking cost.
 * @const {number}
 */
var NUM_EXTRA = 3;

/** @ngInject */
function VirtualRepeatContainerController($$rAF, $mdUtil, $mdConstant, $parse, $rootScope, $window,
                                          $scope, $element, $attrs) {
  this.$rootScope = $rootScope;
  this.$scope = $scope;
  this.$element = $element;
  this.$attrs = $attrs;

  /** @type {number} The width or height of the container */
  this.size = 0;
  /** @type {number} The scroll width or height of the scroller */
  this.scrollSize = 0;
  /** @type {number} The scrollLeft or scrollTop of the scroller */
  this.scrollOffset = 0;
  /** @type {boolean} Whether the scroller is oriented horizontally */
  this.horizontal = this.$attrs.hasOwnProperty('mdOrientHorizontal');
  /** @type {!VirtualRepeatController} The repeater inside of this container */
  this.repeater = null;
  /** @type {boolean} Whether auto-shrink is enabled */
  this.autoShrink = this.$attrs.hasOwnProperty('mdAutoShrink');
  /** @type {number} Minimum number of items to auto-shrink to */
  this.autoShrinkMin = parseInt(this.$attrs.mdAutoShrinkMin, 10) || 0;
  /** @type {?number} Original container size when shrank */
  this.originalSize = null;
  /** @type {number} Amount to offset the total scroll size by. */
  this.offsetSize = parseInt(this.$attrs.mdOffsetSize, 10) || 0;
  /** @type {?string} height or width element style on the container prior to auto-shrinking. */
  this.oldElementSize = null;
  /** @type {!number} Maximum amount of pixels allowed for a single DOM element */
  this.maxElementPixels = $mdConstant.ELEMENT_MAX_PIXELS;
  /** @type {string}  Direction of the text */
  this.ltr = !$mdUtil.isRtl(this.$attrs);

  if (this.$attrs.mdTopIndex) {
    /** @type {function(angular.Scope): number} Binds to topIndex on AngularJS scope */
    this.bindTopIndex = $parse(this.$attrs.mdTopIndex);
    /** @type {number} The index of the item that is at the top of the scroll container */
    this.topIndex = this.bindTopIndex(this.$scope);

    if (!angular.isDefined(this.topIndex)) {
      this.topIndex = 0;
      this.bindTopIndex.assign(this.$scope, 0);
    }

    this.$scope.$watch(this.bindTopIndex, angular.bind(this, function(newIndex) {
      if (newIndex !== this.topIndex) {
        this.scrollToIndex(newIndex);
      }
    }));
  } else {
    this.topIndex = 0;
  }

  this.scroller = $element[0].querySelector('.md-virtual-repeat-scroller');
  this.sizer = this.scroller.querySelector('.md-virtual-repeat-sizer');
  this.offsetter = this.scroller.querySelector('.md-virtual-repeat-offsetter');

  // After the DOM stabilizes, measure the initial size of the container and
  // make a best effort at re-measuring as it changes.
  var boundUpdateSize = angular.bind(this, this.updateSize);

  $$rAF(angular.bind(this, function() {
    boundUpdateSize();

    var debouncedUpdateSize = $mdUtil.debounce(boundUpdateSize, 10, null, false);
    var jWindow = angular.element($window);

    // Make one more attempt to get the size if it is 0.
    // This is not by any means a perfect approach, but there's really no
    // silver bullet here.
    if (!this.size) {
      debouncedUpdateSize();
    }

    jWindow.on('resize', debouncedUpdateSize);
    $scope.$on('$destroy', function() {
      jWindow.off('resize', debouncedUpdateSize);
    });

    $scope.$emit('$md-resize-enable');
    $scope.$on('$md-resize', boundUpdateSize);
  }));
}


/** Called by the md-virtual-repeat inside of the container at startup. */
VirtualRepeatContainerController.prototype.register = function(repeaterCtrl) {
  this.repeater = repeaterCtrl;

  angular.element(this.scroller)
      .on('scroll wheel touchmove touchend', angular.bind(this, this.handleScroll_));
};


/** @return {boolean} Whether the container is configured for horizontal scrolling. */
VirtualRepeatContainerController.prototype.isHorizontal = function() {
  return this.horizontal;
};


/** @return {number} The size (width or height) of the container. */
VirtualRepeatContainerController.prototype.getSize = function() {
  return this.size;
};


/**
 * Resizes the container.
 * @private
 * @param {number} size The new size to set.
 */
VirtualRepeatContainerController.prototype.setSize_ = function(size) {
  var dimension = this.getDimensionName_();

  this.size = size;
  this.$element[0].style[dimension] = size + 'px';
};


VirtualRepeatContainerController.prototype.unsetSize_ = function() {
  this.$element[0].style[this.getDimensionName_()] = this.oldElementSize;
  this.oldElementSize = null;
};


/** Instructs the container to re-measure its size. */
VirtualRepeatContainerController.prototype.updateSize = function() {
  // If the original size is already determined, we can skip the update.
  if (this.originalSize) return;

  var size = this.isHorizontal()
      ? this.$element[0].clientWidth
      : this.$element[0].clientHeight;

  if (size) {
    this.size = size;
  }

  // Recheck the scroll position after updating the size. This resolves
  // problems that can result if the scroll position was measured while the
  // element was display: none or detached from the document.
  this.handleScroll_();

  this.repeater && this.repeater.containerUpdated();
};


/** @return {number} The container's scrollHeight or scrollWidth. */
VirtualRepeatContainerController.prototype.getScrollSize = function() {
  return this.scrollSize;
};

/**
 * @returns {string} either width or height dimension
 * @private
 */
VirtualRepeatContainerController.prototype.getDimensionName_ = function() {
  return this.isHorizontal() ? 'width' : 'height';
};


/**
 * Sets the scroller element to the specified size.
 * @private
 * @param {number} size The new size.
 */
VirtualRepeatContainerController.prototype.sizeScroller_ = function(size) {
  var dimension =  this.getDimensionName_();
  var crossDimension = this.isHorizontal() ? 'height' : 'width';

  // Clear any existing dimensions.
  this.sizer.innerHTML = '';

  // If the size falls within the browser's maximum explicit size for a single element, we can
  // set the size and be done. Otherwise, we have to create children that add up the the desired
  // size.
  if (size < this.maxElementPixels) {
    this.sizer.style[dimension] = size + 'px';
  } else {
    this.sizer.style[dimension] = 'auto';
    this.sizer.style[crossDimension] = 'auto';

    // Divide the total size we have to render into N max-size pieces.
    var numChildren = Math.floor(size / this.maxElementPixels);

    // Element template to clone for each max-size piece.
    var sizerChild = document.createElement('div');
    sizerChild.style[dimension] = this.maxElementPixels + 'px';
    sizerChild.style[crossDimension] = '1px';

    for (var i = 0; i < numChildren; i++) {
      this.sizer.appendChild(sizerChild.cloneNode(false));
    }

    // Re-use the element template for the remainder.
    sizerChild.style[dimension] = (size - (numChildren * this.maxElementPixels)) + 'px';
    this.sizer.appendChild(sizerChild);
  }
};


/**
 * If auto-shrinking is enabled, shrinks or unshrinks as appropriate.
 * @private
 * @param {number} size The new size.
 */
VirtualRepeatContainerController.prototype.autoShrink_ = function(size) {
  var shrinkSize = Math.max(size, this.autoShrinkMin * this.repeater.getItemSize());

  if (this.autoShrink && shrinkSize !== this.size) {
    if (this.oldElementSize === null) {
      this.oldElementSize = this.$element[0].style[this.getDimensionName_()];
    }

    var currentSize = this.originalSize || this.size;

    if (!currentSize || shrinkSize < currentSize) {
      if (!this.originalSize) {
        this.originalSize = this.size;
      }

      // Now we update the containers size, because shrinking is enabled.
      this.setSize_(shrinkSize);
    } else if (this.originalSize !== null) {
      // Set the size back to our initial size.
      this.unsetSize_();

      var _originalSize = this.originalSize;
      this.originalSize = null;

      // We determine the repeaters size again, if the original size was zero.
      // The originalSize needs to be null, to be able to determine the size.
      if (!_originalSize) this.updateSize();

      // Apply the original size or the determined size back to the container, because
      // it has been overwritten before, in the shrink block.
      this.setSize_(_originalSize || this.size);
    }

    this.repeater.containerUpdated();
  }
};


/**
 * Sets the scrollHeight or scrollWidth. Called by the repeater based on
 * its item count and item size.
 * @param {number} itemsSize The total size of the items.
 */
VirtualRepeatContainerController.prototype.setScrollSize = function(itemsSize) {
  var size = itemsSize + this.offsetSize;
  if (this.scrollSize === size) return;

  this.sizeScroller_(size);
  this.autoShrink_(size);
  this.scrollSize = size;
};


/** @return {number} The container's current scroll offset. */
VirtualRepeatContainerController.prototype.getScrollOffset = function() {
  return this.scrollOffset;
};

/**
 * Scrolls to a given scrollTop position.
 * @param {number} position
 */
VirtualRepeatContainerController.prototype.scrollTo = function(position) {
  this.scroller[this.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = position;
  this.handleScroll_();
};

/**
 * Scrolls the item with the given index to the top of the scroll container.
 * @param {number} index
 */
VirtualRepeatContainerController.prototype.scrollToIndex = function(index) {
  var itemSize = this.repeater.getItemSize();
  var itemsLength = this.repeater.itemsLength;
  if (index > itemsLength) {
    index = itemsLength - 1;
  }
  this.scrollTo(itemSize * index);
};

VirtualRepeatContainerController.prototype.resetScroll = function() {
  this.scrollTo(0);
};


VirtualRepeatContainerController.prototype.handleScroll_ = function() {
  if (!this.ltr && !this.maxSize) {
    this.scroller.scrollLeft = this.scrollSize;
    this.maxSize = this.scroller.scrollLeft;
  }
  var offset = this.isHorizontal() ?
      (this.ltr ? this.scroller.scrollLeft : this.maxSize - this.scroller.scrollLeft)
      : this.scroller.scrollTop;
  if (this.scrollSize < this.size) return;
  if (offset > this.scrollSize - this.size) {
    offset = this.scrollSize - this.size;
  }
  if (offset === this.scrollOffset) return;

  var itemSize = this.repeater.getItemSize();
  if (!itemSize) return;

  var numItems = Math.max(0, Math.floor(offset / itemSize) - NUM_EXTRA);

  var transform = (this.isHorizontal() ? 'translateX(' : 'translateY(') +
      (!this.isHorizontal() || this.ltr ? (numItems * itemSize) : - (numItems * itemSize))  + 'px)';

  this.scrollOffset = offset;
  this.offsetter.style.webkitTransform = transform;
  this.offsetter.style.transform = transform;

  if (this.bindTopIndex) {
    var topIndex = Math.floor(offset / itemSize);
    if (topIndex !== this.topIndex && topIndex < this.repeater.getItemCount()) {
      this.topIndex = topIndex;
      this.bindTopIndex.assign(this.$scope, topIndex);
      if (!this.$rootScope.$$phase) this.$scope.$digest();
    }
  }

  this.repeater.containerUpdated();
};


/**
 * @ngdoc directive
 * @name mdVirtualRepeat
 * @module material.components.virtualRepeat
 * @restrict A
 * @priority 1000
 * @description
 * The `md-virtual-repeat` attribute is applied to a template that is repeated using virtual
 * scrolling. This provides smooth and performant scrolling through very large lists of elements.
 *
 * Virtual repeat is a limited substitute for `ng-repeat` that renders only
 * enough DOM nodes to fill the container, recycling them as the user scrolls.
 *
 * ### Notes
 *
 * - Arrays are supported for iteration by default.
 * - An object can used use if `md-on-demand` is specified and the object implements the interface
 *   described in the `md-on-demand` <a ng-href="#attributes">documentation</a>.
 * - `trackBy`, `as` alias, and `(key, value)` syntax from `ng-repeat` are not supported.
 *
 * ### On-Demand Async Item Loading
 *
 * When using the `md-on-demand` attribute and loading some asynchronous data,
 * the `getItemAtIndex` function will mostly return nothing.
 *
 * <hljs lang="js">
 *   DynamicItems.prototype.getItemAtIndex = function(index) {
 *     if (this.pages[index]) {
 *       return this.pages[index];
 *     } else {
 *       // This is an asynchronous action and does not return any value.
 *       this.loadPage(index);
 *     }
 *   };
 * </hljs>
 *
 * This means that the Virtual Repeat will not have any value for the given index.<br/>
 * After the data loading completes, the user expects the Virtual Repeat to recognize the change.
 *
 * To make sure that the Virtual Repeat properly detects any change, you need to run the operation
 * in another digest.
 *
 * <hljs lang="js">
 *   DynamicItems.prototype.loadPage = function(index) {
 *     var self = this;
 *
 *     // Trigger a new digest by using $timeout
 *     $timeout(function() {
 *       self.pages[index] = Data;
 *     });
 *   };
 * </hljs>
 *
 * > <b>Note:</b> Please also review the
 *   <a ng-href="api/directive/mdVirtualRepeatContainer">VirtualRepeatContainer</a> documentation
 *   for more information.
 *
 * @usage
 * <hljs lang="html">
 * <md-virtual-repeat-container>
 *   <div md-virtual-repeat="i in items">Hello {{i}}!</div>
 * </md-virtual-repeat-container>
 *
 * <md-virtual-repeat-container md-orient-horizontal>
 *   <div md-virtual-repeat="i in items" md-item-size="20">Hello {{i}}!</div>
 * </md-virtual-repeat-container>
 * </hljs>
 *
 * @param {expression=} md-extra-name Evaluates to an additional name to which the current iterated
 *   item can be assigned on the repeated scope (needed for use in `md-autocomplete`).
 * @param {number=} md-item-size Optional height or width of the repeated elements (which **must be
 *   identical for each element**). Virtual repeat will attempt to read the size from the DOM,
 *   if missing, but it still assumes that all repeated nodes have the **same height**
 *   (when scrolling vertically) or **same width** (when scrolling horizontally).
 * @param {boolean=} md-on-demand When present, treats the `md-virtual-repeat` argument as an object
 *   that can fetch rows rather than an array.
 *
 *   **NOTE:** This object **must** implement the following interface with two methods:
 *
 *   - `getItemAtIndex` - `{function(index): Object}`: The item at that `index` or `null` if it is
 *     not yet loaded (it should start downloading the item in that case).
 *   - `getLength` - `{function(): number}`: The data length to which the repeater container
 *     should be sized. Ideally, when the count is known, this method should return it.
 *     Otherwise, return a higher number than the currently loaded items to produce an
 *     infinite-scroll behavior.
 */
function VirtualRepeatDirective($parse) {
  return {
    controller: VirtualRepeatController,
    priority: 1000,
    require: ['mdVirtualRepeat', '^^mdVirtualRepeatContainer'],
    restrict: 'A',
    terminal: true,
    transclude: 'element',
    compile: function VirtualRepeatCompile($element, $attrs) {
      var expression = $attrs.mdVirtualRepeat;
      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)\s*$/);
      var repeatName = match[1];
      var repeatListExpression = $parse(match[2]);
      var extraName = $attrs.mdExtraName && $parse($attrs.mdExtraName);

      return function VirtualRepeatLink($scope, $element, $attrs, ctrl, $transclude) {
        ctrl[0].link_(ctrl[1], $transclude, repeatName, repeatListExpression, extraName);
      };
    }
  };
}


/** @ngInject */
function VirtualRepeatController($scope, $element, $attrs, $browser, $document, $rootScope,
    $$rAF, $mdUtil) {
  this.$scope = $scope;
  this.$element = $element;
  this.$attrs = $attrs;
  this.$browser = $browser;
  this.$document = $document;
  this.$mdUtil = $mdUtil;
  this.$rootScope = $rootScope;
  this.$$rAF = $$rAF;

  /** @type {boolean} Whether we are in on-demand mode. */
  this.onDemand = $mdUtil.parseAttributeBoolean($attrs.mdOnDemand);
  /** @type {!Function} Backup reference to $browser.$$checkUrlChange */
  this.browserCheckUrlChange = $browser.$$checkUrlChange;
  /** @type {number} Most recent starting repeat index (based on scroll offset) */
  this.newStartIndex = 0;
  /** @type {number} Most recent ending repeat index (based on scroll offset) */
  this.newEndIndex = 0;
  /** @type {number} Most recent end visible index (based on scroll offset) */
  this.newVisibleEnd = 0;
  /** @type {number} Previous starting repeat index (based on scroll offset) */
  this.startIndex = 0;
  /** @type {number} Previous ending repeat index (based on scroll offset) */
  this.endIndex = 0;
  /** @type {?number} Height/width of repeated elements. */
  this.itemSize = $scope.$eval($attrs.mdItemSize) || null;

  /** @type {boolean} Whether this is the first time that items are rendered. */
  this.isFirstRender = true;

  /**
   * @private {boolean} Whether the items in the list are already being updated. Used to prevent
   *     nested calls to virtualRepeatUpdate_.
   */
  this.isVirtualRepeatUpdating_ = false;

  /** @type {number} Most recently seen length of items. */
  this.itemsLength = 0;

  /**
   * @type {!Function} Unwatch callback for item size (when md-items-size is
   *     not specified), or angular.noop otherwise.
   */
  this.unwatchItemSize_ = angular.noop;

  /**
   * Presently rendered blocks by repeat index.
   * @type {Object<number, !VirtualRepeatController.Block>}
   */
  this.blocks = {};
  /** @type {Array<!VirtualRepeatController.Block>} A pool of presently unused blocks. */
  this.pooledBlocks = [];

  $scope.$on('$destroy', angular.bind(this, this.cleanupBlocks_));
}


/**
 * An object representing a repeated item.
 * @typedef {{element: !jqLite, new: boolean, scope: !angular.Scope}}
 */
VirtualRepeatController.Block;


/**
 * Called at startup by the md-virtual-repeat postLink function.
 * @param {!VirtualRepeatContainerController} container The container's controller.
 * @param {!Function} transclude The repeated element's bound transclude function.
 * @param {string} repeatName The left hand side of the repeat expression, indicating
 *     the name for each item in the array.
 * @param {!Function} repeatListExpression A compiled expression based on the right hand side
 *     of the repeat expression. Points to the array to repeat over.
 * @param {string|undefined} extraName The optional extra repeatName.
 */
VirtualRepeatController.prototype.link_ =
    function(container, transclude, repeatName, repeatListExpression, extraName) {
  this.container = container;
  this.transclude = transclude;
  this.repeatName = repeatName;
  this.rawRepeatListExpression = repeatListExpression;
  this.extraName = extraName;
  this.sized = false;

  this.repeatListExpression = angular.bind(this, this.repeatListExpression_);

  this.container.register(this);
};


/** @private Cleans up unused blocks. */
VirtualRepeatController.prototype.cleanupBlocks_ = function() {
  angular.forEach(this.pooledBlocks, function cleanupBlock(block) {
    block.element.remove();
  });
};


/** @private Attempts to set itemSize by measuring a repeated element in the dom */
VirtualRepeatController.prototype.readItemSize_ = function() {
  if (this.itemSize) {
    // itemSize was successfully read in a different asynchronous call.
    return;
  }

  this.items = this.repeatListExpression(this.$scope);
  this.parentNode = this.$element[0].parentNode;
  var block = this.getBlock_(0);
  if (!block.element[0].parentNode) {
    this.parentNode.appendChild(block.element[0]);
  }

  this.itemSize = block.element[0][
      this.container.isHorizontal() ? 'offsetWidth' : 'offsetHeight'] || null;

  this.blocks[0] = block;
  this.poolBlock_(0);

  if (this.itemSize) {
    this.containerUpdated();
  }
};


/**
 * Returns the user-specified repeat list, transforming it into an array-like
 * object in the case of infinite scroll/dynamic load mode.
 * @param {!angular.Scope} scope The scope.
 * @return {!Array|!Object} An array or array-like object for iteration.
 */
VirtualRepeatController.prototype.repeatListExpression_ = function(scope) {
  var repeatList = this.rawRepeatListExpression(scope);

  if (this.onDemand && repeatList) {
    var virtualList = new VirtualRepeatModelArrayLike(repeatList);
    virtualList.$$includeIndexes(this.newStartIndex, this.newVisibleEnd);
    return virtualList;
  } else {
    return repeatList;
  }
};


/**
 * Called by the container. Informs us that the container's scroll or size has
 * changed.
 */
VirtualRepeatController.prototype.containerUpdated = function() {
  // If itemSize is unknown, attempt to measure it.
  if (!this.itemSize) {
    // Make sure to clean up watchers if we can (see #8178)
    if (this.unwatchItemSize_ && this.unwatchItemSize_ !== angular.noop){
      this.unwatchItemSize_();
    }
    this.unwatchItemSize_ = this.$scope.$watchCollection(
        this.repeatListExpression,
        angular.bind(this, function(items) {
          if (items && items.length) {
            this.readItemSize_();
          }
        }));
    if (!this.$rootScope.$$phase) this.$scope.$digest();

    return;
  } else if (!this.sized) {
    this.items = this.repeatListExpression(this.$scope);
  }

  if (!this.sized) {
    this.unwatchItemSize_();
    this.sized = true;
    this.$scope.$watchCollection(this.repeatListExpression,
        angular.bind(this, function(items, oldItems) {
          if (!this.isVirtualRepeatUpdating_) {
            this.virtualRepeatUpdate_(items, oldItems);
          }
        }));
  }

  this.updateIndexes_();

  if (this.newStartIndex !== this.startIndex ||
      this.newEndIndex !== this.endIndex ||
      this.container.getScrollOffset() > this.container.getScrollSize()) {
    if (this.items instanceof VirtualRepeatModelArrayLike) {
      this.items.$$includeIndexes(this.newStartIndex, this.newEndIndex);
    }
    this.virtualRepeatUpdate_(this.items, this.items);
  }
};


/**
 * Called by the container. Returns the size of a single repeated item.
 * @return {?number} size of a repeated item.
 */
VirtualRepeatController.prototype.getItemSize = function() {
  return this.itemSize;
};


/**
 * Called by the container.
 * @return {?number} the most recently seen length of items.
 */
VirtualRepeatController.prototype.getItemCount = function() {
  return this.itemsLength;
};


/**
 * Updates the order and visible offset of repeated blocks in response to scrolling
 * or updates to `items`.
 * @param {Array} items visible elements
 * @param {Array} oldItems previously visible elements
 * @private
 */
VirtualRepeatController.prototype.virtualRepeatUpdate_ = function(items, oldItems) {
  this.isVirtualRepeatUpdating_ = true;

  var itemsLength = items && items.length || 0;
  var lengthChanged = false;

  // If the number of items shrank, keep the scroll position.
  if (this.items && itemsLength < this.items.length && this.container.getScrollOffset() !== 0) {
    this.items = items;
    var previousScrollOffset = this.container.getScrollOffset();
    this.container.resetScroll();
    this.container.scrollTo(previousScrollOffset);
  }

  if (itemsLength !== this.itemsLength) {
    lengthChanged = true;
    this.itemsLength = itemsLength;
  }

  this.items = items;
  if (items !== oldItems || lengthChanged) {
    this.updateIndexes_();
  }

  this.parentNode = this.$element[0].parentNode;

  if (lengthChanged) {
    this.container.setScrollSize(itemsLength * this.itemSize);
  }

  // Detach and pool any blocks that are no longer in the viewport.
  Object.keys(this.blocks).forEach(function(blockIndex) {
    var index = parseInt(blockIndex, 10);
    if (index < this.newStartIndex || index >= this.newEndIndex) {
      this.poolBlock_(index);
    }
  }, this);

  // Add needed blocks.
  // For performance reasons, temporarily block browser url checks as we digest
  // the restored block scopes ($$checkUrlChange reads window.location to
  // check for changes and trigger route change, etc, which we don't need when
  // trying to scroll at 60fps).
  this.$browser.$$checkUrlChange = angular.noop;

  var i, block,
      newStartBlocks = [],
      newEndBlocks = [];

  // Collect blocks at the top.
  for (i = this.newStartIndex; i < this.newEndIndex && this.blocks[i] == null; i++) {
    block = this.getBlock_(i);
    this.updateBlock_(block, i);
    newStartBlocks.push(block);
  }

  // Update blocks that are already rendered.
  for (; this.blocks[i] != null; i++) {
    this.updateBlock_(this.blocks[i], i);
  }
  var maxIndex = i - 1;

  // Collect blocks at the end.
  for (; i < this.newEndIndex; i++) {
    block = this.getBlock_(i);
    this.updateBlock_(block, i);
    newEndBlocks.push(block);
  }

  // Attach collected blocks to the document.
  if (newStartBlocks.length) {
    this.parentNode.insertBefore(
        this.domFragmentFromBlocks_(newStartBlocks),
        this.$element[0].nextSibling);
  }
  if (newEndBlocks.length) {
    this.parentNode.insertBefore(
        this.domFragmentFromBlocks_(newEndBlocks),
        this.blocks[maxIndex] && this.blocks[maxIndex].element[0].nextSibling);
  }

  // Restore $$checkUrlChange.
  this.$browser.$$checkUrlChange = this.browserCheckUrlChange;

  this.startIndex = this.newStartIndex;
  this.endIndex = this.newEndIndex;

  if (this.isFirstRender) {
    this.isFirstRender = false;
    var firstRenderStartIndex = this.$attrs.mdStartIndex ?
      this.$scope.$eval(this.$attrs.mdStartIndex) :
      this.container.topIndex;

    // The first call to virtualRepeatUpdate_ may not be when the virtual repeater is ready.
    // Introduce a slight delay so that the update happens when it is actually ready.
    this.$mdUtil.nextTick(function() {
      this.container.scrollToIndex(firstRenderStartIndex);
    }.bind(this));
  }

  this.isVirtualRepeatUpdating_ = false;
};


/**
 * @param {number} index Where the block is to be in the repeated list.
 * @return {!VirtualRepeatController.Block} A new or pooled block to place at the specified index.
 * @private
 */
VirtualRepeatController.prototype.getBlock_ = function(index) {
  if (this.pooledBlocks.length) {
    return this.pooledBlocks.pop();
  }

  var block;
  this.transclude(angular.bind(this, function(clone, scope) {
    block = {
      element: clone,
      new: true,
      scope: scope
    };

    this.updateScope_(scope, index);
    this.parentNode.appendChild(clone[0]);
  }));

  return block;
};


/**
 * Updates and if not in a digest cycle, digests the specified block's scope to the data
 * at the specified index.
 * @param {!VirtualRepeatController.Block} block The block whose scope should be updated.
 * @param {number} index The index to set.
 * @private
 */
VirtualRepeatController.prototype.updateBlock_ = function(block, index) {
  this.blocks[index] = block;

  if (!block.new &&
      (block.scope.$index === index && block.scope[this.repeatName] === this.items[index])) {
    return;
  }
  block.new = false;

  // Update and digest the block's scope.
  this.updateScope_(block.scope, index);

  // Perform digest before reattaching the block.
  // Any resulting synchronous DOM mutations should be much faster as a result.
  // This might break some directives.
  if (!this.$rootScope.$$phase) {
    block.scope.$digest();
  }
};


/**
 * Updates scope to the data at the specified index.
 * @param {!angular.Scope} scope The scope which should be updated.
 * @param {number} index The index to set.
 * @private
 */
VirtualRepeatController.prototype.updateScope_ = function(scope, index) {
  scope.$index = index;
  scope[this.repeatName] = this.items && this.items[index];
  if (this.extraName) scope[this.extraName(this.$scope)] = this.items[index];
};


/**
 * Pools the block at the specified index (Pulls its element out of the dom and stores it).
 * @param {number} index The index at which the block to pool is stored.
 * @private
 */
VirtualRepeatController.prototype.poolBlock_ = function(index) {
  this.pooledBlocks.push(this.blocks[index]);
  this.parentNode.removeChild(this.blocks[index].element[0]);
  delete this.blocks[index];
};


/**
 * Produces a dom fragment containing the elements from the list of blocks.
 * @param {!Array<!VirtualRepeatController.Block>} blocks The blocks whose elements
 *     should be added to the document fragment.
 * @return {DocumentFragment}
 * @private
 */
VirtualRepeatController.prototype.domFragmentFromBlocks_ = function(blocks) {
  var fragment = this.$document[0].createDocumentFragment();
  blocks.forEach(function(block) {
    fragment.appendChild(block.element[0]);
  });
  return fragment;
};


/**
 * Updates start and end indexes based on length of repeated items and container size.
 * @private
 */
VirtualRepeatController.prototype.updateIndexes_ = function() {
  var itemsLength = this.items ? this.items.length : 0;
  var containerLength = Math.ceil(this.container.getSize() / this.itemSize);

  this.newStartIndex = Math.max(0, Math.min(
      itemsLength - containerLength,
      Math.floor(this.container.getScrollOffset() / this.itemSize)));
  this.newVisibleEnd = this.newStartIndex + containerLength + NUM_EXTRA;
  this.newEndIndex = Math.min(itemsLength, this.newVisibleEnd);
  this.newStartIndex = Math.max(0, this.newStartIndex - NUM_EXTRA);
};

/**
 * This VirtualRepeatModelArrayLike class enforces the interface requirements
 * for infinite scrolling within a mdVirtualRepeatContainer.
 *
 * @param {Object} model An object with this interface must implement the following interface with
 * two (2) methods:
 *
 * getItemAtIndex: function(index) -> item at that index or null if it is not yet
 *     loaded (It should start downloading the item in that case).
 *
 * getLength: function() -> number The data length to which the repeater container
 *     should be sized. Ideally, when the count is known, this method should return it.
 *     Otherwise, return a higher number than the currently loaded items to produce an
 *     infinite-scroll behavior.
 *
 * @usage
 * <hljs lang="html">
 *  <md-virtual-repeat-container md-orient-horizontal>
 *    <div md-virtual-repeat="i in items" md-on-demand>
 *      Hello {{i}}!
 *    </div>
 *  </md-virtual-repeat-container>
 * </hljs>
 *
 */
function VirtualRepeatModelArrayLike(model) {
  if (!angular.isFunction(model.getItemAtIndex) ||
      !angular.isFunction(model.getLength)) {
    throw Error('When md-on-demand is enabled, the Object passed to md-virtual-repeat must ' +
        'implement functions getItemAtIndex() and getLength().');
  }

  this.model = model;
}

/**
 * @param {number} start
 * @param {number} end
 */
VirtualRepeatModelArrayLike.prototype.$$includeIndexes = function(start, end) {
  for (var i = start; i < end; i++) {
    if (!this.hasOwnProperty(i)) {
      this[i] = this.model.getItemAtIndex(i);
    }
  }
  this.length = this.model.getLength();
};

/**
 * @ngdoc directive
 * @name mdForceHeight
 * @module material.components.virtualRepeat
 * @restrict A
 * @description
 *
 * Force an element to have a certain `px` height. This is used in place of a style tag in order to
 * conform to the
 * <a href="https://developer.mozilla.org/docs/Web/HTTP/Headers/Content-Security-Policy/script-src">
 *   Content Security Policy</a> regarding `unsafe-inline` `<style>` tags.
 *
 * This directive is related to <a ng-href="api/directive/mdVirtualRepeat">mdVirtualRepeat</a>.
 *
 * @usage
 * <hljs lang="html">
 *   <div md-force-height="'100px'"></div>
 * </hljs>
 */
function ForceHeightDirective($mdUtil) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      var height = scope.$eval(attrs.mdForceHeight) || null;

      if (height && element) {
        element[0].style.height = height;
      }
    }
  };
}
ForceHeightDirective.$inject = ['$mdUtil'];

})();
(function(){
"use strict";

/**
 * @ngdoc module
 * @name material.components.whiteframe
 */
MdWhiteframeDirective.$inject = ["$log"];
angular
  .module('material.components.whiteframe', ['material.core'])
  .directive('mdWhiteframe', MdWhiteframeDirective);

/**
 * @ngdoc directive
 * @module material.components.whiteframe
 * @name mdWhiteframe
 *
 * @description
 * The md-whiteframe directive allows you to apply an elevation shadow to an element.
 *
 * The attribute values needs to be a number between 1 and 24 or -1.
 * When set to -1 no style is applied.
 *
 * ### Notes
 * - If there is no value specified it defaults to 4dp.
 * - If the value is not valid it defaults to 4dp.

 * @usage
 * <hljs lang="html">
 * <div md-whiteframe="3">
 *   <span>Elevation of 3dp</span>
 * </div>
 * </hljs>
 *
 * <hljs lang="html">
 * <div md-whiteframe="-1">
 *   <span>No elevation shadow applied</span>
 * </div>
 * </hljs>
 *
 * <hljs lang="html">
 * <div ng-init="elevation = 5" md-whiteframe="{{elevation}}">
 *   <span>Elevation of 5dp with an interpolated value</span>
 * </div>
 * </hljs>
 */
function MdWhiteframeDirective($log) {
  var DISABLE_DP = -1;
  var MIN_DP = 1;
  var MAX_DP = 24;
  var DEFAULT_DP = 4;

  return {
    link: postLink
  };

  function postLink(scope, element, attr) {
    var oldClass = '';

    attr.$observe('mdWhiteframe', function(elevation) {
      elevation = parseInt(elevation, 10) || DEFAULT_DP;

      if (elevation != DISABLE_DP && (elevation > MAX_DP || elevation < MIN_DP)) {
        $log.warn('md-whiteframe attribute value is invalid. It should be a number between ' + MIN_DP + ' and ' + MAX_DP, element[0]);
        elevation = DEFAULT_DP;
      }

      var newClass = elevation == DISABLE_DP ? '' : 'md-whiteframe-' + elevation + 'dp';
      attr.$updateClass(newClass, oldClass);
      oldClass = newClass;
    });
  }
}


})();
(function(){ 
angular.module("material.core").constant("$MD_THEME_CSS", "md-autocomplete.md-THEME_NAME-theme{background:\"{{background-hue-1}}\"}md-autocomplete.md-THEME_NAME-theme[disabled]:not([md-floating-label]){background:\"{{background-hue-2}}\"}md-autocomplete.md-THEME_NAME-theme button md-icon path{fill:\"{{background-600}}\"}md-autocomplete.md-THEME_NAME-theme button:after{background:\"{{background-600-0.3}}\"}md-autocomplete.md-THEME_NAME-theme input{color:\"{{foreground-1}}\"}md-autocomplete.md-THEME_NAME-theme.md-accent md-input-container.md-input-focused .md-input{border-color:\"{{accent-color}}\"}md-autocomplete.md-THEME_NAME-theme.md-accent md-input-container.md-input-focused label,md-autocomplete.md-THEME_NAME-theme.md-accent md-input-container.md-input-focused md-icon{color:\"{{accent-color}}\"}md-autocomplete.md-THEME_NAME-theme.md-accent md-progress-linear .md-container{background-color:\"{{accent-100}}\"}md-autocomplete.md-THEME_NAME-theme.md-accent md-progress-linear .md-bar{background-color:\"{{accent-color}}\"}md-autocomplete.md-THEME_NAME-theme.md-warn md-input-container.md-input-focused .md-input{border-color:\"{{warn-A700}}\"}md-autocomplete.md-THEME_NAME-theme.md-warn md-input-container.md-input-focused label,md-autocomplete.md-THEME_NAME-theme.md-warn md-input-container.md-input-focused md-icon{color:\"{{warn-A700}}\"}md-autocomplete.md-THEME_NAME-theme.md-warn md-progress-linear .md-container{background-color:\"{{warn-100}}\"}md-autocomplete.md-THEME_NAME-theme.md-warn md-progress-linear .md-bar{background-color:\"{{warn-color}}\"}.md-autocomplete-standard-list-container.md-THEME_NAME-theme,.md-autocomplete-suggestions-container.md-THEME_NAME-theme{background:\"{{background-hue-1}}\"}.md-autocomplete-standard-list-container.md-THEME_NAME-theme .md-autocomplete-suggestion,.md-autocomplete-suggestions-container.md-THEME_NAME-theme .md-autocomplete-suggestion{color:\"{{foreground-1}}\"}.md-autocomplete-standard-list-container.md-THEME_NAME-theme .md-autocomplete-suggestion.selected,.md-autocomplete-standard-list-container.md-THEME_NAME-theme .md-autocomplete-suggestion:hover,.md-autocomplete-suggestions-container.md-THEME_NAME-theme .md-autocomplete-suggestion.selected,.md-autocomplete-suggestions-container.md-THEME_NAME-theme .md-autocomplete-suggestion:hover{background:\"{{background-500-0.18}}\"}md-backdrop{background-color:\"{{background-900-0.0}}\"}md-backdrop.md-opaque.md-THEME_NAME-theme{background-color:\"{{background-900-1.0}}\"}md-bottom-sheet.md-THEME_NAME-theme{background-color:\"{{background-color}}\";border-top-color:\"{{background-hue-3}}\"}md-bottom-sheet.md-THEME_NAME-theme.md-list md-list-item{color:\"{{foreground-1}}\"}md-bottom-sheet.md-THEME_NAME-theme .md-subheader{background-color:\"{{background-color}}\";color:\"{{foreground-1}}\"}.md-button.md-THEME_NAME-theme:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme:not([disabled]):hover{background-color:\"{{background-500-0.2}}\"}.md-button.md-THEME_NAME-theme:not([disabled]).md-icon-button:hover{background-color:transparent}.md-button.md-THEME_NAME-theme.md-fab{background-color:\"{{accent-color}}\";color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-fab md-icon{color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-fab:not([disabled]):hover{background-color:\"{{accent-A700}}\"}.md-button.md-THEME_NAME-theme.md-primary{color:\"{{primary-color}}\"}.md-button.md-THEME_NAME-theme.md-primary.md-fab,.md-button.md-THEME_NAME-theme.md-primary.md-raised{background-color:\"{{primary-color}}\";color:\"{{primary-contrast}}\"}.md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]) md-icon,.md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]) md-icon{color:\"{{primary-contrast}}\"}.md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]):hover,.md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]):hover{background-color:\"{{primary-600}}\"}.md-button.md-THEME_NAME-theme.md-primary:not([disabled]) md-icon{color:\"{{primary-color}}\"}.md-button.md-THEME_NAME-theme.md-raised{background-color:\"{{background-50}}\";color:\"{{background-900}}\"}.md-button.md-THEME_NAME-theme.md-raised:not([disabled]) md-icon{color:\"{{background-900}}\"}.md-button.md-THEME_NAME-theme.md-raised:not([disabled]):hover{background-color:\"{{background-50}}\"}.md-button.md-THEME_NAME-theme.md-raised:not([disabled]).md-focused{background-color:\"{{background-200}}\"}.md-button.md-THEME_NAME-theme.md-warn{color:\"{{warn-color}}\"}.md-button.md-THEME_NAME-theme.md-warn.md-fab,.md-button.md-THEME_NAME-theme.md-warn.md-raised{background-color:\"{{warn-color}}\";color:\"{{warn-contrast}}\"}.md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]) md-icon,.md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]) md-icon{color:\"{{warn-contrast}}\"}.md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]):hover,.md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]):hover{background-color:\"{{warn-600}}\"}.md-button.md-THEME_NAME-theme.md-warn:not([disabled]) md-icon{color:\"{{warn-color}}\"}.md-button.md-THEME_NAME-theme.md-accent{color:\"{{accent-color}}\"}.md-button.md-THEME_NAME-theme.md-accent.md-fab,.md-button.md-THEME_NAME-theme.md-accent.md-raised{background-color:\"{{accent-color}}\";color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]) md-icon,.md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]) md-icon{color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]):hover,.md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]):hover{background-color:\"{{accent-A700}}\"}.md-button.md-THEME_NAME-theme.md-accent:not([disabled]) md-icon{color:\"{{accent-color}}\"}.md-button.md-THEME_NAME-theme.md-accent[disabled],.md-button.md-THEME_NAME-theme.md-fab[disabled],.md-button.md-THEME_NAME-theme.md-raised[disabled],.md-button.md-THEME_NAME-theme.md-warn[disabled],.md-button.md-THEME_NAME-theme[disabled]{color:\"{{foreground-3}}\";cursor:default}.md-button.md-THEME_NAME-theme.md-accent[disabled] md-icon,.md-button.md-THEME_NAME-theme.md-fab[disabled] md-icon,.md-button.md-THEME_NAME-theme.md-raised[disabled] md-icon,.md-button.md-THEME_NAME-theme.md-warn[disabled] md-icon,.md-button.md-THEME_NAME-theme[disabled] md-icon{color:\"{{foreground-3}}\"}.md-button.md-THEME_NAME-theme.md-fab[disabled],.md-button.md-THEME_NAME-theme.md-raised[disabled]{background-color:\"{{foreground-4}}\"}.md-button.md-THEME_NAME-theme[disabled]{background-color:transparent}._md a.md-THEME_NAME-theme:not(.md-button).md-primary{color:\"{{primary-color}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-primary:hover{color:\"{{primary-700}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-accent{color:\"{{accent-color}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-accent:hover{color:\"{{accent-A700}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-warn{color:\"{{warn-color}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-warn:hover{color:\"{{warn-700}}\"}md-card.md-THEME_NAME-theme{background-color:\"{{background-hue-1}}\";border-radius:2px;color:\"{{foreground-1}}\"}md-card.md-THEME_NAME-theme .md-card-image{border-radius:2px 2px 0 0}md-card.md-THEME_NAME-theme md-card-header md-card-avatar md-icon{background-color:\"{{foreground-3}}\";color:\"{{background-color}}\"}md-card.md-THEME_NAME-theme md-card-header md-card-header-text .md-subhead,md-card.md-THEME_NAME-theme md-card-title md-card-title-text:not(:only-child) .md-subhead{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme .md-ripple{color:\"{{accent-A700}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-ripple{color:\"{{background-600}}\"}md-checkbox.md-THEME_NAME-theme.md-checked.md-focused .md-container:before{background-color:\"{{accent-color-0.26}}\"}md-checkbox.md-THEME_NAME-theme .md-ink-ripple{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-ink-ripple{color:\"{{accent-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-icon{background-color:\"{{accent-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-icon:after{border-color:\"{{background-default}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-ripple{color:\"{{primary-600}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ripple{color:\"{{background-600}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-ink-ripple{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple{color:\"{{primary-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-icon{background-color:\"{{primary-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked.md-focused .md-container:before{background-color:\"{{primary-color-0.26}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-icon:after{border-color:\"{{primary-contrast-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-indeterminate[disabled] .md-container{color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn .md-ripple{color:\"{{warn-600}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn .md-ink-ripple{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple{color:\"{{warn-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-icon{background-color:\"{{warn-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked.md-focused:not([disabled]) .md-container:before{background-color:\"{{warn-color-0.26}}\"}md-checkbox.md-THEME_NAME-theme[disabled]:not(.md-checked) .md-icon{border-color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme[disabled].md-checked .md-icon{background-color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme[disabled] .md-label{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips{box-shadow:0 1px \"{{foreground-4}}\"}md-chips.md-THEME_NAME-theme .md-chips.md-focused{box-shadow:0 2px \"{{primary-color}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input{color:\"{{foreground-1}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::-webkit-input-placeholder{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input:-ms-input-placeholder{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::-ms-input-placeholder{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::placeholder{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input:-moz-placeholder,md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::-moz-placeholder{color:\"{{foreground-3}}\";opacity:1}md-chips.md-THEME_NAME-theme md-chip{background:\"{{background-300}}\";color:\"{{background-800}}\"}md-chips.md-THEME_NAME-theme md-chip md-icon{color:\"{{background-700}}\"}md-chips.md-THEME_NAME-theme md-chip.md-focused{background:\"{{primary-color}}\";color:\"{{primary-contrast}}\"}md-chips.md-THEME_NAME-theme md-chip.md-focused md-icon{color:\"{{primary-contrast}}\"}md-chips.md-THEME_NAME-theme md-chip._md-chip-editing{background:transparent;color:\"{{background-800}}\"}md-chips.md-THEME_NAME-theme .md-chip-remove-container button.md-chip-remove md-icon,md-chips.md-THEME_NAME-theme .md-chip-remove-container buttonmd-chip-remove md-icon{fill:\"{{foreground-2}}\";color:\"{{foreground-2}}\"}.md-contact-suggestion span.md-contact-email{color:\"{{background-400}}\"}md-content.md-THEME_NAME-theme{background-color:\"{{background-default}}\";color:\"{{foreground-1}}\"}.md-THEME_NAME-theme .md-calendar{background:\"{{background-hue-1}}\";color:\"{{foreground-1-0.87}}\"}.md-THEME_NAME-theme .md-calendar tr:last-child td{border-bottom-color:\"{{background-hue-2}}\"}.md-THEME_NAME-theme .md-calendar-day-header{background:\"{{background-500-0.32}}\";color:\"{{foreground-1-0.87}}\"}.md-THEME_NAME-theme .md-calendar-date.md-calendar-date-today .md-calendar-date-selection-indicator{border:1px solid \"{{primary-500}}\"}.md-THEME_NAME-theme .md-calendar-date.md-calendar-date-today.md-calendar-date-disabled{color:\"{{primary-500-0.6}}\"}.md-calendar-date.md-focus .md-THEME_NAME-theme .md-calendar-date-selection-indicator,.md-THEME_NAME-theme .md-calendar-date-selection-indicator:hover{background:\"{{background-500-0.32}}\"}.md-THEME_NAME-theme .md-calendar-date.md-calendar-selected-date .md-calendar-date-selection-indicator,.md-THEME_NAME-theme .md-calendar-date.md-focus.md-calendar-selected-date .md-calendar-date-selection-indicator{background:\"{{primary-500}}\";border-color:transparent;color:\"{{primary-500-contrast}}\"}.md-THEME_NAME-theme .md-calendar-date-disabled,.md-THEME_NAME-theme .md-calendar-month-label-disabled{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-calendar-month-label md-icon,.md-THEME_NAME-theme .md-datepicker-input{color:\"{{foreground-1}}\"}.md-THEME_NAME-theme .md-datepicker-input::-webkit-input-placeholder{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-datepicker-input:-ms-input-placeholder{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-datepicker-input::-ms-input-placeholder{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-datepicker-input::placeholder{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-datepicker-input:-moz-placeholder,.md-THEME_NAME-theme .md-datepicker-input::-moz-placeholder{color:\"{{foreground-3}}\";opacity:1}.md-THEME_NAME-theme .md-datepicker-input-container{border-bottom-color:\"{{foreground-4}}\"}.md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused{border-bottom-color:\"{{primary-color}}\"}.md-accent .md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused{border-bottom-color:\"{{accent-color}}\"}.md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-invalid,.md-warn .md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused{border-bottom-color:\"{{warn-A700}}\"}.md-THEME_NAME-theme .md-datepicker-calendar-pane{border-color:\"{{background-hue-1}}\"}.md-THEME_NAME-theme .md-datepicker-triangle-button .md-datepicker-expand-triangle{border-top-color:\"{{foreground-2}}\"}.md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon{color:\"{{primary-color}}\"}.md-accent .md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon,.md-THEME_NAME-theme .md-datepicker-open.md-accent .md-datepicker-calendar-icon{color:\"{{accent-color}}\"}.md-THEME_NAME-theme .md-datepicker-open.md-warn .md-datepicker-calendar-icon,.md-warn .md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon{color:\"{{warn-A700}}\"}.md-THEME_NAME-theme .md-datepicker-calendar{background:\"{{background-hue-1}}\"}.md-THEME_NAME-theme .md-datepicker-input-mask-opaque{box-shadow:0 0 0 9999px \"{{background-hue-1}}\"}.md-THEME_NAME-theme .md-datepicker-open .md-datepicker-input-container{background:\"{{background-hue-1}}\"}md-dialog.md-THEME_NAME-theme{background-color:\"{{background-hue-1}}\";border-radius:4px;color:\"{{foreground-1}}\"}md-dialog.md-THEME_NAME-theme.md-content-overflow md-dialog-actions{border-top-color:\"{{foreground-4}}\"}md-divider.md-THEME_NAME-theme{border-color:\"{{foreground-4}}\"}md-fab-speed-dial.md-THEME_NAME-theme md-fab-trigger .md-fab.md-button[disabled]{background-color:\"{{foreground-4}}\"}md-fab-speed-dial.md-THEME_NAME-theme md-fab-actions .md-fab-action-item .md-button.md-fab.md-raised.md-mini.md-focused,md-fab-speed-dial.md-THEME_NAME-theme md-fab-actions .md-fab-action-item .md-button.md-fab.md-raised.md-mini:hover{background-color:\"{{background-500}}\"}md-icon.md-THEME_NAME-theme{color:\"{{foreground-2}}\"}md-icon.md-THEME_NAME-theme.md-primary{color:\"{{primary-color}}\"}md-icon.md-THEME_NAME-theme.md-accent{color:\"{{accent-color}}\"}md-icon.md-THEME_NAME-theme.md-warn{color:\"{{warn-color}}\"}md-input-container.md-THEME_NAME-theme .md-input{border-color:\"{{background-default-contrast-divider}}\";color:\"{{background-default-contrast}}\"}md-input-container.md-THEME_NAME-theme .md-input::-webkit-input-placeholder{color:\"{{background-default-contrast-secondary}}\"}md-input-container.md-THEME_NAME-theme .md-input:-ms-input-placeholder{color:\"{{background-default-contrast-secondary}}\"}md-input-container.md-THEME_NAME-theme .md-input::-ms-input-placeholder{color:\"{{background-default-contrast-secondary}}\"}md-input-container.md-THEME_NAME-theme .md-input::placeholder{color:\"{{background-default-contrast-secondary}}\"}md-input-container.md-THEME_NAME-theme .md-input:-moz-placeholder,md-input-container.md-THEME_NAME-theme .md-input::-moz-placeholder{color:\"{{background-default-contrast-secondary}}\";opacity:1}md-input-container.md-THEME_NAME-theme>md-icon{color:\"{{background-default-contrast}}\"}md-input-container.md-THEME_NAME-theme .md-placeholder,md-input-container.md-THEME_NAME-theme label{color:\"{{background-default-contrast-secondary}}\"}md-input-container.md-THEME_NAME-theme label.md-required:after{color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-focused):not(.md-input-invalid) label.md-required:after{color:\"{{background-default-contrast-secondary}}\"}md-input-container.md-THEME_NAME-theme .md-input-message-animation,md-input-container.md-THEME_NAME-theme .md-input-messages-animation{color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme .md-input-message-animation .md-char-counter,md-input-container.md-THEME_NAME-theme .md-input-messages-animation .md-char-counter{color:\"{{background-default-contrast}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input::-webkit-input-placeholder{color:\"{{background-default-contrast-secondary}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input:-ms-input-placeholder{color:\"{{background-default-contrast-secondary}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input::-ms-input-placeholder{color:\"{{background-default-contrast-secondary}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input::placeholder{color:\"{{background-default-contrast-secondary}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input:-moz-placeholder,md-input-container.md-THEME_NAME-theme.md-input-focused .md-input::-moz-placeholder{color:\"{{background-default-contrast-secondary}}\";opacity:1}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-has-value label{color:\"{{background-default-contrast-secondary}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused .md-input,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-resized .md-input{border-color:\"{{primary-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused md-icon{color:\"{{primary-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent .md-input{border-color:\"{{accent-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent md-icon{color:\"{{accent-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn .md-input{border-color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn md-icon{color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme.md-input-invalid .md-input{border-color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme.md-input-invalid .md-char-counter,md-input-container.md-THEME_NAME-theme.md-input-invalid .md-input-message-animation,md-input-container.md-THEME_NAME-theme.md-input-invalid label{color:\"{{warn-A700}}\"}[disabled] md-input-container.md-THEME_NAME-theme .md-input,md-input-container.md-THEME_NAME-theme .md-input[disabled]{background-image:linear-gradient(90deg,\"{{background-default-contrast-disabled}}\" 0,\"{{background-default-contrast-disabled}}\" 33%,transparent 0);background-image:-ms-linear-gradient(left,transparent 0,\"{{background-default-contrast-disabled}}\" 100%);border-bottom-color:transparent;color:\"{{background-default-contrast-disabled}}\"}md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text h3,md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text h4,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text h3,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text h4{color:\"{{foreground-1}}\"}md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text p,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text p{color:\"{{foreground-2}}\"}md-list.md-THEME_NAME-theme .md-proxy-focus.md-focused div.md-no-style{background-color:\"{{background-100}}\"}md-list.md-THEME_NAME-theme md-list-item .md-avatar-icon{background-color:\"{{foreground-3}}\";color:\"{{background-color}}\"}md-list.md-THEME_NAME-theme md-list-item>md-icon{color:\"{{foreground-2}}\"}md-list.md-THEME_NAME-theme md-list-item>md-icon.md-highlight{color:\"{{primary-color}}\"}md-list.md-THEME_NAME-theme md-list-item>md-icon.md-highlight.md-accent{color:\"{{accent-color}}\"}md-menu-content.md-THEME_NAME-theme{background-color:\"{{background-hue-1}}\"}md-menu-content.md-THEME_NAME-theme md-menu-item{color:\"{{foreground-1}}\"}md-menu-content.md-THEME_NAME-theme md-menu-item md-icon{color:\"{{foreground-2}}\"}md-menu-content.md-THEME_NAME-theme md-menu-item .md-button[disabled],md-menu-content.md-THEME_NAME-theme md-menu-item .md-button[disabled] md-icon{color:\"{{foreground-3}}\"}md-menu-content.md-THEME_NAME-theme md-menu-divider{background-color:\"{{foreground-4}}\"}md-menu-bar.md-THEME_NAME-theme>button.md-button{border-radius:2px;color:\"{{foreground-1}}\"}md-menu-bar.md-THEME_NAME-theme md-menu>button{color:\"{{foreground-1}}\"}md-menu-bar.md-THEME_NAME-theme md-menu.md-open>button,md-menu-bar.md-THEME_NAME-theme md-menu>button:focus{background-color:\"{{ background-500-0.18}}\";outline:none}md-menu-bar.md-THEME_NAME-theme.md-open:not(.md-keyboard-mode) md-menu:hover>button{background-color:\"{{ background-500-0.18}}\"}md-menu-bar.md-THEME_NAME-theme:not(.md-keyboard-mode):not(.md-open) md-menu button:focus,md-menu-bar.md-THEME_NAME-theme:not(.md-keyboard-mode):not(.md-open) md-menu button:hover{background:transparent}md-menu-content.md-THEME_NAME-theme .md-menu>.md-button:after{color:\"{{foreground-2}}\"}md-menu-content.md-THEME_NAME-theme .md-menu.md-open>.md-button{background-color:\"{{ background-500-0.18}}\"}md-toolbar.md-THEME_NAME-theme.md-menu-toolbar{background-color:\"{{background-hue-1}}\";color:\"{{foreground-1}}\"}md-toolbar.md-THEME_NAME-theme.md-menu-toolbar md-toolbar-filler{background-color:\"{{primary-color}}\";color:\"{{primary-contrast}}\"}md-toolbar.md-THEME_NAME-theme.md-menu-toolbar md-toolbar-filler md-icon{color:\"{{primary-contrast}}\"}md-nav-bar.md-THEME_NAME-theme .md-nav-bar{background-color:transparent;border-color:\"{{foreground-4}}\"}md-nav-bar.md-THEME_NAME-theme .md-button._md-nav-button.md-unselected{color:\"{{foreground-2}}\"}md-nav-bar.md-THEME_NAME-theme .md-button._md-nav-button[disabled]{color:\"{{foreground-3}}\"}md-nav-bar.md-THEME_NAME-theme md-nav-ink-bar{background:\"{{accent-color}}\";color:\"{{accent-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar{background-color:\"{{accent-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button{color:\"{{accent-A100}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button.md-active,md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{accent-contrast}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{accent-contrast-0.1}}\"}md-nav-bar.md-THEME_NAME-theme.md-accent>.md-nav-bar md-nav-ink-bar{background:\"{{primary-600-1}}\";color:\"{{primary-600-1}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar{background-color:\"{{warn-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button{color:\"{{warn-100}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button.md-active,md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{warn-contrast}}\"}md-nav-bar.md-THEME_NAME-theme.md-warn>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{warn-contrast-0.1}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar{background-color:\"{{primary-color}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button{color:\"{{primary-100}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button.md-active,md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{primary-contrast}}\"}md-nav-bar.md-THEME_NAME-theme.md-primary>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{primary-contrast-0.1}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar{background-color:\"{{primary-color}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button{color:\"{{primary-100}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-active,md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{primary-contrast}}\"}md-toolbar>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{primary-contrast-0.1}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar{background-color:\"{{accent-color}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button{color:\"{{accent-A100}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-active,md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{accent-contrast}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{accent-contrast-0.1}}\"}md-toolbar.md-accent>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar md-nav-ink-bar{background:\"{{primary-600-1}}\";color:\"{{primary-600-1}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar{background-color:\"{{warn-color}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button{color:\"{{warn-100}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-active,md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{color:\"{{warn-contrast}}\"}md-toolbar.md-warn>md-nav-bar.md-THEME_NAME-theme>.md-nav-bar .md-button._md-nav-button.md-focused{background:\"{{warn-contrast-0.1}}\"}._md-panel-backdrop.md-THEME_NAME-theme{background-color:\"{{background-900-1.0}}\"}md-progress-circular.md-THEME_NAME-theme path{stroke:\"{{primary-color}}\"}md-progress-circular.md-THEME_NAME-theme.md-warn path{stroke:\"{{warn-color}}\"}md-progress-circular.md-THEME_NAME-theme.md-accent path{stroke:\"{{accent-color}}\"}md-progress-linear.md-THEME_NAME-theme .md-container{background-color:\"{{primary-100}}\"}md-progress-linear.md-THEME_NAME-theme .md-bar{background-color:\"{{primary-color}}\"}md-progress-linear.md-THEME_NAME-theme.md-warn .md-container{background-color:\"{{warn-100}}\"}md-progress-linear.md-THEME_NAME-theme.md-warn .md-bar{background-color:\"{{warn-color}}\"}md-progress-linear.md-THEME_NAME-theme.md-accent .md-container{background-color:\"{{accent-100}}\"}md-progress-linear.md-THEME_NAME-theme.md-accent .md-bar{background-color:\"{{accent-color}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-primary .md-bar1{background-color:\"{{primary-100}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-primary .md-dashed:before{background:radial-gradient(\"{{primary-100}}\" 0,\"{{primary-100}}\" 16%,transparent 42%)}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-warn .md-bar1{background-color:\"{{warn-100}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-warn .md-dashed:before{background:radial-gradient(\"{{warn-100}}\" 0,\"{{warn-100}}\" 16%,transparent 42%)}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-accent .md-bar1{background-color:\"{{accent-100}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-accent .md-dashed:before{background:radial-gradient(\"{{accent-100}}\" 0,\"{{accent-100}}\" 16%,transparent 42%)}md-radio-button.md-THEME_NAME-theme .md-off{border-color:\"{{foreground-2}}\"}md-radio-button.md-THEME_NAME-theme .md-on{background-color:\"{{accent-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme.md-checked .md-off{border-color:\"{{accent-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme.md-checked .md-ink-ripple{color:\"{{accent-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme .md-container .md-ripple{color:\"{{accent-A700}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-on,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-on{background-color:\"{{primary-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-off{border-color:\"{{primary-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-ink-ripple{color:\"{{primary-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-container .md-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-container .md-ripple{color:\"{{primary-600}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-on,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-on{background-color:\"{{warn-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-off{border-color:\"{{warn-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-ink-ripple{color:\"{{warn-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-container .md-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-container .md-ripple{color:\"{{warn-600}}\"}md-radio-button.md-THEME_NAME-theme[disabled],md-radio-group.md-THEME_NAME-theme[disabled]{color:\"{{foreground-3}}\"}md-radio-button.md-THEME_NAME-theme[disabled] .md-container .md-off,md-radio-button.md-THEME_NAME-theme[disabled] .md-container .md-on,md-radio-group.md-THEME_NAME-theme[disabled] .md-container .md-off,md-radio-group.md-THEME_NAME-theme[disabled] .md-container .md-on{border-color:\"{{foreground-3}}\"}md-radio-group.md-THEME_NAME-theme .md-checked .md-ink-ripple{color:\"{{accent-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme .md-checked:not([disabled]).md-primary .md-ink-ripple,md-radio-group.md-THEME_NAME-theme.md-primary .md-checked:not([disabled]) .md-ink-ripple{color:\"{{primary-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme.md-focused.ng-empty>md-radio-button:first-child .md-container:before{background-color:\"{{foreground-3-0.26}}\"}md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked .md-container:before{background-color:\"{{accent-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked.md-primary .md-container:before,md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty).md-primary .md-checked .md-container:before{background-color:\"{{primary-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked.md-warn .md-container:before,md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty).md-warn .md-checked .md-container:before{background-color:\"{{warn-color-0.26}}\"}md-input-container md-select.md-THEME_NAME-theme .md-select-value span:first-child:after{color:\"{{warn-A700}}\"}md-input-container:not(.md-input-focused):not(.md-input-invalid) md-select.md-THEME_NAME-theme .md-select-value span:first-child:after{color:\"{{foreground-3}}\"}md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-THEME_NAME-theme .md-select-value,md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-THEME_NAME-theme .md-select-value.md-select-placeholder{color:\"{{primary-color}}\"}md-input-container.md-input-invalid md-select.md-THEME_NAME-theme .md-select-value{border-bottom-color:\"{{warn-A700}}\"!important;color:\"{{warn-A700}}\"!important}md-input-container.md-input-invalid md-select.md-THEME_NAME-theme.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-input-container:not(.md-input-invalid).md-input-focused.md-accent .md-select-value{border-color:\"{{accent-color}}\"}md-input-container:not(.md-input-invalid).md-input-focused.md-accent .md-select-value span{color:\"{{accent-color}}\"}md-input-container:not(.md-input-invalid).md-input-focused.md-warn .md-select-value{border-color:\"{{warn-A700}}\"}md-input-container:not(.md-input-invalid).md-input-focused.md-warn .md-select-value span{color:\"{{warn-A700}}\"}md-select.md-THEME_NAME-theme[disabled] .md-select-value{background-image:linear-gradient(90deg,\"{{foreground-3}}\" 0,\"{{foreground-3}}\" 33%,transparent 0);background-image:-ms-linear-gradient(left,transparent 0,\"{{foreground-3}}\" 100%);border-bottom-color:transparent}md-select.md-THEME_NAME-theme .md-select-value{border-bottom-color:\"{{foreground-4}}\"}md-select.md-THEME_NAME-theme .md-select-value.md-select-placeholder{color:\"{{foreground-3}}\"}md-select.md-THEME_NAME-theme .md-select-value span:first-child:after{color:\"{{warn-A700}}\"}md-select.md-THEME_NAME-theme.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme.ng-invalid.ng-touched .md-select-value{border-bottom-color:\"{{warn-A700}}\"!important;color:\"{{warn-A700}}\"!important}md-select.md-THEME_NAME-theme.ng-invalid.ng-touched.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme:not([disabled]):focus .md-select-value{border-bottom-color:\"{{primary-color}}\";color:\"{{ foreground-1 }}\"}md-select.md-THEME_NAME-theme:not([disabled]):focus .md-select-value.md-select-placeholder{color:\"{{ foreground-1 }}\"}md-select.md-THEME_NAME-theme:not([disabled]):focus.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme:not([disabled]):focus.md-accent .md-select-value{border-bottom-color:\"{{accent-color}}\"}md-select.md-THEME_NAME-theme:not([disabled]):focus.md-warn .md-select-value{border-bottom-color:\"{{warn-color}}\"}md-select.md-THEME_NAME-theme[disabled] .md-select-icon,md-select.md-THEME_NAME-theme[disabled] .md-select-value,md-select.md-THEME_NAME-theme[disabled] .md-select-value.md-select-placeholder{color:\"{{foreground-3}}\"}md-select.md-THEME_NAME-theme .md-select-icon{color:\"{{foreground-2}}\"}md-select-menu.md-THEME_NAME-theme md-content{background-color:\"{{background-hue-1}}\"}md-select-menu.md-THEME_NAME-theme md-content md-optgroup{color:\"{{foreground-2}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option{color:\"{{foreground-1}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[disabled] .md-text{color:\"{{foreground-3}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option:not([disabled]):hover{background-color:\"{{background-500-0.10}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option:not([disabled]).md-focused,md-select-menu.md-THEME_NAME-theme md-content md-option:not([disabled]):focus{background-color:\"{{background-500-0.18}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected]{color:\"{{primary-500}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected].md-focused,md-select-menu.md-THEME_NAME-theme md-content md-option[selected]:focus{color:\"{{primary-600}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected].md-accent{color:\"{{accent-color}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected].md-accent.md-focused,md-select-menu.md-THEME_NAME-theme md-content md-option[selected].md-accent:focus{color:\"{{accent-A700}}\"}.md-checkbox-enabled.md-THEME_NAME-theme .md-ripple{color:\"{{primary-600}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-ripple{color:\"{{background-600}}\"}.md-checkbox-enabled.md-THEME_NAME-theme .md-ink-ripple{color:\"{{foreground-2}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-ink-ripple{color:\"{{primary-color-0.87}}\"}.md-checkbox-enabled.md-THEME_NAME-theme:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-icon{background-color:\"{{primary-color-0.87}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected].md-focused .md-container:before{background-color:\"{{primary-color-0.26}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-icon:after{border-color:\"{{primary-contrast-0.87}}\"}.md-checkbox-enabled.md-THEME_NAME-theme .md-indeterminate[disabled] .md-container{color:\"{{foreground-3}}\"}.md-checkbox-enabled.md-THEME_NAME-theme md-option .md-text{color:\"{{foreground-1}}\"}md-sidenav.md-THEME_NAME-theme,md-sidenav.md-THEME_NAME-theme md-content{background-color:\"{{background-hue-1}}\"}md-slider.md-THEME_NAME-theme .md-track{background-color:\"{{foreground-3}}\"}md-slider.md-THEME_NAME-theme .md-track-ticks{color:\"{{background-contrast}}\"}md-slider.md-THEME_NAME-theme .md-focus-ring{background-color:\"{{accent-A200-0.2}}\"}md-slider.md-THEME_NAME-theme .md-disabled-thumb{background-color:\"{{background-color}}\";border-color:\"{{background-color}}\"}md-slider.md-THEME_NAME-theme.md-min .md-thumb:after{background-color:\"{{background-color}}\";border-color:\"{{foreground-3}}\"}md-slider.md-THEME_NAME-theme.md-min .md-focus-ring{background-color:\"{{foreground-3-0.38}}\"}md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-thumb:after{background-color:\"{{background-contrast}}\";border-color:transparent}md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-sign{background-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-sign:after{border-top-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme.md-min[md-discrete][md-vertical] .md-sign:after{border-left-color:\"{{background-400}}\";border-top-color:transparent}md-slider.md-THEME_NAME-theme .md-track.md-track-fill{background-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-thumb:after{background-color:\"{{accent-color}}\";border-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-sign{background-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-sign:after{border-top-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme[md-vertical] .md-sign:after{border-left-color:\"{{accent-color}}\";border-top-color:transparent}md-slider.md-THEME_NAME-theme .md-thumb-text{color:\"{{accent-contrast}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-focus-ring{background-color:\"{{warn-200-0.38}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-track.md-track-fill{background-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-thumb:after{background-color:\"{{warn-color}}\";border-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-sign{background-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-sign:after{border-top-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn[md-vertical] .md-sign:after{border-left-color:\"{{warn-color}}\";border-top-color:transparent}md-slider.md-THEME_NAME-theme.md-warn .md-thumb-text{color:\"{{warn-contrast}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-focus-ring{background-color:\"{{primary-200-0.38}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-track.md-track-fill{background-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-thumb:after{background-color:\"{{primary-color}}\";border-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-sign{background-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-sign:after{border-top-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary[md-vertical] .md-sign:after{border-left-color:\"{{primary-color}}\";border-top-color:transparent}md-slider.md-THEME_NAME-theme.md-primary .md-thumb-text{color:\"{{primary-contrast}}\"}md-slider.md-THEME_NAME-theme[disabled] .md-thumb:after{border-color:transparent}md-slider.md-THEME_NAME-theme[disabled]:not(.md-min) .md-thumb:after,md-slider.md-THEME_NAME-theme[disabled][md-discrete] .md-thumb:after{background-color:\"{{foreground-3}}\";border-color:transparent}md-slider.md-THEME_NAME-theme[disabled][readonly] .md-sign{background-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme[disabled][readonly] .md-sign:after{border-top-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme[disabled][readonly][md-vertical] .md-sign:after{border-left-color:\"{{background-400}}\";border-top-color:transparent}md-slider.md-THEME_NAME-theme[disabled][readonly] .md-disabled-thumb{background-color:transparent;border-color:transparent}md-slider-container[disabled]>:first-child:not(md-slider),md-slider-container[disabled]>:last-child:not(md-slider){color:\"{{foreground-3}}\"}.md-subheader.md-THEME_NAME-theme{background-color:\"{{background-default}}\";color:\"{{ foreground-2-0.54 }}\"}.md-subheader.md-THEME_NAME-theme.md-primary{color:\"{{primary-color}}\"}.md-subheader.md-THEME_NAME-theme.md-accent{color:\"{{accent-color}}\"}.md-subheader.md-THEME_NAME-theme.md-warn{color:\"{{warn-color}}\"}md-switch.md-THEME_NAME-theme .md-ink-ripple{color:\"{{background-500}}\"}md-switch.md-THEME_NAME-theme .md-thumb{background-color:\"{{background-50}}\"}md-switch.md-THEME_NAME-theme .md-bar{background-color:\"{{background-500}}\"}md-switch.md-THEME_NAME-theme.md-focused:not(.md-checked) .md-thumb:before,md-switch.md-THEME_NAME-theme.md-focused[disabled] .md-thumb:before{background-color:\"{{foreground-4}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]) .md-ink-ripple{color:\"{{accent-color}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]) .md-thumb{background-color:\"{{accent-color}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]) .md-bar{background-color:\"{{accent-color-0.5}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]).md-focused .md-thumb:before{background-color:\"{{accent-color-0.26}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]).md-primary .md-ink-ripple{color:\"{{primary-color}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]).md-primary .md-thumb{background-color:\"{{primary-color}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]).md-primary .md-bar{background-color:\"{{primary-color-0.5}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]).md-primary.md-focused .md-thumb:before{background-color:\"{{primary-color-0.26}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]).md-warn .md-ink-ripple{color:\"{{warn-color}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]).md-warn .md-thumb{background-color:\"{{warn-color}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]).md-warn .md-bar{background-color:\"{{warn-color-0.5}}\"}md-switch.md-THEME_NAME-theme.md-checked:not([disabled]).md-warn.md-focused .md-thumb:before{background-color:\"{{warn-color-0.26}}\"}md-switch.md-THEME_NAME-theme[disabled] .md-thumb{background-color:\"{{background-400}}\"}md-switch.md-THEME_NAME-theme[disabled] .md-bar{background-color:\"{{foreground-4}}\"}md-tabs.md-THEME_NAME-theme md-tabs-wrapper{background-color:transparent;border-color:\"{{foreground-4}}\"}md-tabs.md-THEME_NAME-theme md-next-button md-icon,md-tabs.md-THEME_NAME-theme md-prev-button md-icon{color:\"{{foreground-2}}\"}md-tabs.md-THEME_NAME-theme md-ink-bar{background:\"{{accent-color}}\";color:\"{{accent-color}}\"}md-tabs.md-THEME_NAME-theme .md-tab{color:\"{{foreground-2}}\"}md-tabs.md-THEME_NAME-theme .md-tab[disabled],md-tabs.md-THEME_NAME-theme .md-tab[disabled] md-icon{color:\"{{foreground-3}}\"}md-tabs.md-THEME_NAME-theme .md-tab.md-active,md-tabs.md-THEME_NAME-theme .md-tab.md-active md-icon,md-tabs.md-THEME_NAME-theme .md-tab.md-focused,md-tabs.md-THEME_NAME-theme .md-tab.md-focused md-icon{color:\"{{accent-color}}\"}md-tabs.md-THEME_NAME-theme .md-tab.md-focused{background:\"{{primary-color-0.1}}\"}md-tabs.md-THEME_NAME-theme .md-tab .md-ripple-container{color:\"{{accent-A100}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper{background-color:\"{{accent-500}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper md-next-button md-icon,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper md-prev-button md-icon{color:\"{{accent-500-contrast-0.7}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{accent-500-contrast-1}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{accent-500-contrast-0.1}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{background:\"{{accent-500-contrast}}\";color:\"{{accent-500-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper{background-color:\"{{primary-color}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper md-next-button md-icon,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper md-prev-button md-icon{color:\"{{primary-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{primary-contrast-0.7}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{primary-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{primary-contrast-0.1}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{background:\"{{accent-color}}\";color:\"{{accent-color}}\"}md-tabs.md-THEME_NAME-theme.md-primary.md-no-ink-bar-color>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{background:\"{{primary-contrast}}\";color:\"{{primary-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper{background-color:\"{{warn-500}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper md-next-button md-icon,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper md-prev-button md-icon{color:\"{{warn-500-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{warn-500-contrast-0.7}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{warn-500-contrast-1}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{warn-500-contrast-0.1}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{background:\"{{warn-500-contrast}}\";color:\"{{warn-500-contrast}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper{background-color:\"{{primary-color}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper md-next-button md-icon,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper md-prev-button md-icon{color:\"{{primary-contrast}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{primary-contrast-0.7}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{primary-contrast}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{primary-contrast-0.1}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{background:\"{{accent-color}}\";color:\"{{accent-color}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme.md-no-ink-bar-color>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{background:\"{{primary-contrast}}\";color:\"{{primary-contrast}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper{background-color:\"{{accent-500}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper md-next-button md-icon,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper md-prev-button md-icon{color:\"{{accent-500-contrast-0.7}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{accent-500-contrast-1}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{accent-500-contrast-0.1}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{background:\"{{accent-500-contrast}}\";color:\"{{accent-500-contrast}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper{background-color:\"{{warn-500}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper md-next-button md-icon,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper md-prev-button md-icon{color:\"{{warn-500-contrast}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{warn-500-contrast-0.7}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{warn-500-contrast-1}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{warn-500-contrast-0.1}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{background:\"{{warn-500-contrast}}\";color:\"{{warn-500-contrast}}\"}md-toast.md-THEME_NAME-theme .md-toast-content{background-color:#323232;color:\"{{background-50}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button{color:\"{{background-50}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight{color:\"{{accent-color}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight.md-primary{color:\"{{primary-color}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight.md-warn{color:\"{{warn-color}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar){background-color:\"{{primary-color}}\";color:\"{{primary-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-icon{fill:\"{{primary-contrast}}\";color:\"{{primary-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) .md-button[disabled] md-icon{fill:\"{{primary-contrast-0.26}}\";color:\"{{primary-contrast-0.26}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float] .md-input{border-color:\"{{primary-default-contrast-divider}}\";color:\"{{primary-default-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float] .md-input::-webkit-input-placeholder{color:\"{{primary-default-contrast-hint}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float] .md-input:-ms-input-placeholder{color:\"{{primary-default-contrast-hint}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float] .md-input::-ms-input-placeholder{color:\"{{primary-default-contrast-hint}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float] .md-input::placeholder{color:\"{{primary-default-contrast-hint}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float] .md-input:-moz-placeholder,md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float] .md-input::-moz-placeholder{color:\"{{primary-default-contrast-hint}}\";opacity:1}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float].md-input-focused .md-input::-webkit-input-placeholder{color:\"{{primary-default-contrast-secondary}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float].md-input-focused .md-input:-ms-input-placeholder{color:\"{{primary-default-contrast-secondary}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float].md-input-focused .md-input::-ms-input-placeholder{color:\"{{primary-default-contrast-secondary}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float].md-input-focused .md-input::placeholder{color:\"{{primary-default-contrast-secondary}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float].md-input-focused .md-input:-moz-placeholder,md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float].md-input-focused .md-input::-moz-placeholder{color:\"{{primary-default-contrast-secondary}}\";opacity:1}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float]:not(.md-input-invalid).md-input-focused .md-input,md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float]:not(.md-input-invalid).md-input-resized .md-input{border-color:\"{{primary-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float]:not(.md-input-invalid).md-input-focused.md-accent .md-input{border-color:\"{{accent-color}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-input-container[md-no-float]:not(.md-input-invalid).md-input-focused.md-warn .md-input{border-color:\"{{warn-A700}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent{background-color:\"{{accent-500}}\";color:\"{{accent-500-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent .md-ink-ripple{color:\"{{accent-500-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-icon{fill:\"{{accent-500-contrast}}\";color:\"{{accent-500-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent .md-button[disabled] md-icon{fill:\"{{accent-500-contrast-0.26}}\";color:\"{{accent-500-contrast-0.26}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float] .md-input{border-color:\"{{accent-500-contrast-divider}}\";color:\"{{accent-500-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float] .md-input::-webkit-input-placeholder{color:\"{{accent-500-contrast-hint}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float] .md-input:-ms-input-placeholder{color:\"{{accent-500-contrast-hint}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float] .md-input::-ms-input-placeholder{color:\"{{accent-500-contrast-hint}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float] .md-input::placeholder{color:\"{{accent-500-contrast-hint}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float] .md-input:-moz-placeholder,md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float] .md-input::-moz-placeholder{color:\"{{accent-500-contrast-hint}}\";opacity:1}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float].md-input-focused .md-input::-webkit-input-placeholder{color:\"{{accent-500-contrast-secondary}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float].md-input-focused .md-input:-ms-input-placeholder{color:\"{{accent-500-contrast-secondary}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float].md-input-focused .md-input::-ms-input-placeholder{color:\"{{accent-500-contrast-secondary}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float].md-input-focused .md-input::placeholder{color:\"{{accent-500-contrast-secondary}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float].md-input-focused .md-input:-moz-placeholder,md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float].md-input-focused .md-input::-moz-placeholder{color:\"{{accent-500-contrast-secondary}}\";opacity:1}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float]:not(.md-input-invalid).md-input-focused .md-input,md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float]:not(.md-input-invalid).md-input-resized .md-input{border-color:\"{{primary-color}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float]:not(.md-input-invalid).md-input-focused.md-accent .md-input{border-color:\"{{accent-500-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-input-container[md-no-float]:not(.md-input-invalid).md-input-focused.md-warn .md-input{border-color:\"{{warn-A700}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn{background-color:\"{{warn-500}}\";color:\"{{warn-500-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-icon{fill:\"{{warn-500-contrast}}\";color:\"{{warn-500-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float] .md-input{border-color:\"{{warn-500-contrast-divider}}\";color:\"{{warn-500-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float] .md-input::-webkit-input-placeholder{color:\"{{warn-500-contrast-hint}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float] .md-input:-ms-input-placeholder{color:\"{{warn-500-contrast-hint}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float] .md-input::-ms-input-placeholder{color:\"{{warn-500-contrast-hint}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float] .md-input::placeholder{color:\"{{warn-500-contrast-hint}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float] .md-input:-moz-placeholder,md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float] .md-input::-moz-placeholder{color:\"{{warn-500-contrast-hint}}\";opacity:1}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float].md-input-focused .md-input::-webkit-input-placeholder{color:\"{{warn-500-contrast-secondary}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float].md-input-focused .md-input:-ms-input-placeholder{color:\"{{warn-500-contrast-secondary}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float].md-input-focused .md-input::-ms-input-placeholder{color:\"{{warn-500-contrast-secondary}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float].md-input-focused .md-input::placeholder{color:\"{{warn-500-contrast-secondary}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float].md-input-focused .md-input:-moz-placeholder,md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float].md-input-focused .md-input::-moz-placeholder{color:\"{{warn-500-contrast-secondary}}\";opacity:1}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float]:not(.md-input-invalid).md-input-focused .md-input,md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float]:not(.md-input-invalid).md-input-resized .md-input{border-color:\"{{primary-color}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float]:not(.md-input-invalid).md-input-focused.md-accent .md-input{border-color:\"{{accent-color}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn md-input-container[md-no-float]:not(.md-input-invalid).md-input-focused.md-warn .md-input{border-color:\"{{warn-500-contrast}}\"}.md-panel.md-tooltip.md-THEME_NAME-theme{background-color:\"{{background-700}}\";color:\"{{background-700-contrast}}\"}body.md-THEME_NAME-theme,html.md-THEME_NAME-theme{background-color:\"{{background-color}}\";color:\"{{foreground-1}}\"}"); 
})();


})(window, window.angular);;window.ngMaterial={version:{full: "1.2.5"}};

/***/ }),
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__, exports, __webpack_require__(1047), __webpack_require__(1048), __webpack_require__(1049), __webpack_require__(1050), __webpack_require__(1051), __webpack_require__(1052), __webpack_require__(1053), __webpack_require__(1054), __webpack_require__(1055), __webpack_require__(1056)], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 1047 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

/*! angular-dimple - 2.0.1 - 2015-03-18
*   https://github.com/esripdx/angular-dimple
*   Licensed ISC
*   forked to prefix directives */
(function(){
'use strict';
angular.module('angular-dimple', [
  'angular-dimple.graph',
  'angular-dimple.legend',
  'angular-dimple.x',
  'angular-dimple.y',
  'angular-dimple.scaledColor',
  'angular-dimple.r',
  'angular-dimple.line',
  'angular-dimple.bar',
  'angular-dimple.stacked-bar',
  'angular-dimple.area',
  'angular-dimple.stacked-area',
  'angular-dimple.scatter-plot',
  'angular-dimple.ring'
])

.constant('MODULE_VERSION', '0.0.1')

.value('defaults', {
  foo: 'bar'
});
angular.module('angular-dimple.area', [])

.directive('dimpleArea', [function () {
  return {
    restrict: 'E',
    replace: true,
    require: ['dimpleArea', '^dimpleGraph'],
    controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {
    }],
    link: function($scope, $element, $attrs, $controllers) {
      var graphController = $controllers[1];
      var areaController = $controllers[0];
      var chart = graphController.getChart();

      function addArea () {
        var area;
        if ($attrs.value) {
          area = chart.addSeries([$attrs.field], dimple.plot.area);
          graphController.filter($attrs);
          area.lineMarkers = true;
        } else {
          var values = dimple.getUniqueValues($scope.data, $attrs.field);
          angular.forEach(values, function(value){
            area = chart.addSeries([$attrs.field], dimple.plot.area);
            graphController.filter($attrs);
            area.lineMarkers = true;
          });
        }
        graphController.draw();
      }

      $scope.$watch('dataReady', function(newValue, oldValue) {
        if (newValue === true) {
          addArea();
        }
      });
    }
  };
}]);


angular.module('angular-dimple.bar', [])

.directive('dimpleBar', [function () {
  return {
    restrict: 'E',
    replace: true,
    require: ['dimpleBar', '^dimpleGraph'],
    controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {
    }],
    link: function($scope, $element, $attrs, $controllers) {
      var graphController = $controllers[1];
      var lineController = $controllers[0];
      var chart = graphController.getChart();

      function appendText (svg, rect, textYPosition, textToAppend, textAnchor, xOffset) {
        textAnchor = textAnchor || "middle";
        var x = xOffset > 0 ? xOffset
          : (textAnchor === "middle" ? rect.x + rect.width / 2
            : (textAnchor === "end" ? (rect.x + rect.width - 6) : rect.x + 6));
        svg.append("text")
        // Position in the centre of the shape (vertical position is
        // manually set due to cross-browser problems with baseline)
          .attr("x", x)
          .attr("y", rect.y + textYPosition)
          // Centre align
          .style("text-anchor", textAnchor || "middle")
          .style("font-size", "10px")
          .style("font-family", "sans-serif")
          // Make it a little transparent to tone down the black
          .style("opacity", 0.6)
          // Prevent text cursor on hover and allow tooltips
          .style("pointer-events", "none")
          // Format the number
          .text(textToAppend);
      }

      function addBar () {
        var filteredData;
        var bar = chart.addSeries([$attrs.field], dimple.plot.bar);

        if ($scope.dimpleClick) {
          bar.addEventHandler('click', function(e) {
            $scope.dimpleClick(e);
          });
        }

        if ($attrs && $attrs.showLabels && $attrs.showLabels === 'true') {
          bar.afterDraw = function(shape, data) {
              // Get the shape as a d3 selection
            var s = d3.select(shape),
                rect = {
                  x: parseFloat(s.attr("x")),
                  y: parseFloat(s.attr("y")),
                  width: parseFloat(s.attr("width")),
                  height: parseFloat(s.attr("height"))
                };
            // Add a text label for the value
            var isHorizontal = $attrs.isHorizontal && $attrs.isHorizontal === 'true';
            var offset = 14;
            var textAnchor = $attrs.textAnchor || "middle";
            var barData = _.find(this.chart.data, function (d) {
              return d && d.Label && d.Label.length > 0 && (d.Label[0] === data.cx || d.Label[0] === data.cy);
            });

            var xOffset = 0;
            var yOffset = 0;
            if (isHorizontal) {
              yOffset = 0 - offset;
              if (rect.width < 40) {
                var anchorOffset = textAnchor === "middle" ? 25
                  : (textAnchor === "end" ? 45 : 5);
                xOffset = rect.x + rect.width + anchorOffset;
              }
            } else {
              var requiredHeight = offset;
              if (barData) {
                requiredHeight = offset * barData.Label.length;
              }

              if (requiredHeight > rect.height) {
                yOffset = 0 - requiredHeight - 8;
              }
            }

            // the label from the data provided
            appendText(this.chart.svg, rect, yOffset + offset, data.yValue, textAnchor, xOffset);
            if (barData) {
              // skip the first item as it's a key
              for (var ldi = 1; ldi < barData.Label.length; ldi++) {
                appendText(this.chart.svg, rect, yOffset + (offset * (ldi + 1)), barData.Label[ldi], textAnchor, xOffset);
              }
            }
          };
        }

        graphController.filter($attrs);
        graphController.draw();
      }

      $scope.$watch('dataReady', function(newValue, oldValue) {
        if (newValue === true) {
          addBar();
        }
      });
    }
  };
}]);
angular.module('angular-dimple.graph', [])

.directive('dimpleGraph', ['$timeout', function ($timeout) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      data: '=',
      color: '=',
      dimpleClick: '=',
      overrideTooltip: '=',
      overrideMin: '=',
      overrideMax: '=',
      wrapXLabels: '=',
      barColorOverride: '=',
      onTooltip: '='
    },
    require: ['dimpleGraph'],
    transclude: true,
    link: function (scope, element, attrs, controllers, transclude) {
      var graphController = controllers[0];
      graphController._createChart();
      scope.dataReady = false;
      scope.filters = [];

      var chart = graphController.getChart();
      var transition;
      if (attrs.transition) {
        transition = attrs.transition;
      } else {
        transition = 750;
      }

      var hideOutOfRangeValues = function (chart) {
        if (_.isUndefined(scope.overrideMin) && _.isUndefined(scope.overrideMax)) {
          return;
        }

        _.each(chart.series, function (series) {
            series.shapes.style('opacity', function (d) {
              var hideElement = false;
              var elementValue = d.y;

              if (!_.isUndefined(scope.overrideMin) && (elementValue < scope.overrideMin)) {
                hideElement = true;
              }

              if (!_.isUndefined(scope.overrideMax) && (scope.overrideMax < elementValue)) {
                hideElement = true;
              }

              return (hideElement ? 0 : 0.8);
            });
        });
      };

      var wrapXLabels = function (chart) {
        if (!scope.wrapXLabels) { return; }

        var tickWidth = 1000;

        // see [Wrapping Long Labels](http://bl.ocks.org/mbostock/7555321#index.html)
        var insertLinebreaks = function (d) {
          var rect = this.getBBox();
          var middleX = (rect.width / 2);
          var origMiddle = rect.x + middleX;

          var text = d3.select(this),
              words = text.text().split(/\s+/).reverse(),
              word,
              line = [],
              lineNumber = 0,
              lineHeight = 1.1, // ems
              y = text.attr("y"),
              dy = parseFloat(text.attr("dy")),
              tspan = text.text(null).append("tspan").attr("x", origMiddle).attr("y", y).attr("dy", dy + "em");

          while (word = words.pop()) {
            line.push(word);
            tspan.text(line.join(" "));
            if (tspan.node().getComputedTextLength() > tickWidth) {
              line.pop();
              tspan.text(line.join(" "));
              line = [word];
              tspan = text.append("tspan").attr("x", origMiddle).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
            }
          }
        }

        _.each(chart.axes, function (axis) {
          if ("x" === axis.position) {
            var numTicks = axis.shapes.selectAll('.tick')[0].length;
            var axisWidth = axis.shapes[0][0].getBBox().width;
            tickWidth = axisWidth / numTicks;

            axis.shapes.selectAll('text').each(insertLinebreaks);
          }
        });
      };

      var setChartColors = function (chart) {
        if (scope.barColorOverride) {
          _.forOwn(scope.barColorOverride, function (hexColor, key) {
            chart.assignColor(key, hexColor);
          });
        }
      };

      scope.$watch('data', function(newValue, oldValue) {
        if (newValue) {
          scope.dataReady = true;
          graphController.setData();
          setChartColors(chart);

          chart.draw(transition);

          $timeout(function () {
            hideOutOfRangeValues(chart);
            wrapXLabels(chart);
          }, 10 + transition);
        }
      });

      transclude(scope, function(clone){
        element.append(clone);
      });
    },
    controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {
      var chart;

      var id = (Math.random() * 1e9).toString(36).replace(".", "_");
      $element.append('<div class="dimple-graph" id="dng-'+ id +'"></div>');

      this._createChart = function () {
        // create an svg element

        var width = $attrs.width ? $attrs.width : '100%';
        var height = $attrs.height ? $attrs.height : '100%';

        var svg = dimple.newSvg('#dng-'+ id +'', width, height);
        var data = $scope.data;

        // create the dimple chart using the d3 selection of our <svg> element
        chart = new dimple.chart(svg, data);

        if ($attrs.margin) {
          var margins = $attrs.margin;
          if (margins.length !== 4) {
              margins = $attrs.margin.split("|");
              switch (margins.length) {
                  case 3:
                    margins.push("0");
                    break;
                  case 2:
                    margins.push(margins[0]);
                    margins.push(margins[1]);
                    break;
                  case 1:
                      margins.push(margins[0]);
                      margins.push(margins[0]);
                      margins.push(margins[0]);
                    break;
              }
          }
          chart.setMargins(margins[0].trim(), margins[1].trim(), margins[2].trim(), margins[3].trim());
        } else {
          var marginLeft = 60;
          if ($attrs.dimpleMarginLeft) {
            marginLeft = $attrs.dimpleMarginLeft;
          }
          chart.setMargins(marginLeft, 60, 20, 40);
        }

        // auto style
        var autoStyle = $attrs.autoStyle === 'false' ? true : false;
        chart.noFormats = autoStyle;

        // Apply palette styles
        if ($attrs.color) {
          var palette = $scope.color;
          for (var i = 0; i < palette.length; i++ ) {
            chart.assignColor(palette[i].name, palette[i].fill, palette[i].stroke, palette[i].opacity);
          }
        }

        if ($attrs.defaultColor) {
          chart.defaultColors = [
            new dimple.color($attrs.defaultColor)
          ];
        }
      };


      this.getChart = function () {
        return chart;
      };

      this.setData = function () {
        chart.data = $scope.data;
      };

      this.draw = function () {
        chart.draw();
      };

      this.getID = function () {
        return id;
      };

      this.filter = function (attrs) {
        if (attrs.value !== undefined) {
          $scope.filters.push(attrs.value);
        }
        if ($scope.filters.length) {
          chart.data = dimple.filterData($scope.data, attrs.field, $scope.filters);
        }

        if (attrs.filter !== undefined) {
          var thisFilter = attrs.filter.split(':');
          var field = thisFilter[0];
          var value = [thisFilter[1]];
          chart.data = dimple.filterData($scope.data, field, value);
        }
      };

    }]
  };
}]);
angular.module('angular-dimple.legend', [])

.directive('dimpleGraphLegend', [function () {
  return {
    restrict: 'E',
    replace: true,
    require: ['dimpleGraphLegend', '^dimpleGraph'],
    controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {
    }],
    link: function($scope, $element, $attrs, $controllers) {
      var graphController = $controllers[1];
      var chart = graphController.getChart();

      function addLegend () {
        var left = $attrs.left ? $attrs.left : "10%";
        var top = $attrs.top ? $attrs.top : "4%";
        var height = $attrs.height ? $attrs.height : "10%";
        var width = $attrs.width ? $attrs.width : "90%";
        var position = $attrs.position ? $attrs.position : 'left';
        chart.addLegend(left, top, width, height, position);
      }

      $scope.$watch('dataReady', function(newValue, oldValue) {
        if (newValue === true) {
          addLegend();
        }
      });
    }
  };
}]);
angular.module('angular-dimple.line', [])

.directive('dimpleLine', [function () {
  return {
    restrict: 'E',
    replace: true,
    require: ['dimpleLine', '^dimpleGraph'],
    controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {
    }],
    link: function($scope, $element, $attrs, $controllers) {
      var graphController = $controllers[1];
      var chart = graphController.getChart();
      var drawn = false;

      function addLine () {
        var filteredData;
        var line = chart.addSeries([$attrs.field], dimple.plot.line);
        graphController.filter($attrs);
        line.lineMarkers = true;
        graphController.draw();
      }

      $scope.$watch('dataReady', function(newValue, oldValue) {
        if (newValue === true) {
          addLine();
        }
      });

    }
  };
}]);
angular.module('angular-dimple.r', [])

.directive('dimpleR', [function () {
  return {
    restrict: 'E',
    replace: true,
    require: ['dimpleR', '^dimpleGraph'],
    controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {
    }],
    link: function($scope, $element, $attrs, $controllers) {
      var graphController = $controllers[1];
      var chart = graphController.getChart();

      function addAxis () {
        var r = chart.addMeasureAxis('p', $attrs.field);

        if ($attrs.title && $attrs.title !== "null") {
          r.title = $attrs.title;
        } else if ($attrs.title == "null") {
          r.title = null;
        }
      }

      $scope.$watch('data', function(newValue, oldValue) {
        if (newValue) {
          addAxis();
        }
      });
    }
  };
}]);
angular.module('angular-dimple.ring', [])

.directive('dimpleRing', [function () {
  return {
    restrict: 'E',
    replace: true,
    require: ['dimpleRing', '^dimpleGraph'],
    controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {
    }],
    link: function($scope, $element, $attrs, $controllers) {
      var graphController = $controllers[1];
      var areaController = $controllers[0];
      var chart = graphController.getChart();

      function setData (data, series) {
        series.data = data;
      }

      function addRing () {
        var thickness;
        var ring = chart.addSeries([$attrs.field], dimple.plot.pie);
        if ($attrs.thickness && !$attrs.diameter) {
          thickness = (100 - $attrs.thickness) + '%';
          ring.innerRadius = thickness;
        } else if ($attrs.thickness && $attrs.diameter) {
          thickness = ($attrs.diameter - $attrs.thickness) + '%';
          ring.innerRadius = thickness;
        } else {
          ring.innerRadius = "50%";
        }

        if ($attrs.diameter) {
          ring.outerRadius = ($attrs.diameter) + '%';
        }
        graphController.filter($attrs);
        graphController.draw();
      }

      $scope.$watch('data', function(newValue, oldValue) {
        if (newValue) {
          addRing();
        }
      });
    }
  };
}]);


angular.module('angular-dimple.scatter-plot', [])

.directive('dimpleScatterPlot', [function () {
  return {
    restrict: 'E',
    replace: true,
    require: ['dimpleScatterPlot', '^dimpleGraph'],
    controller: [function() {}],
    link: function($scope, $element, $attrs, $controllers) {
      var graphController = $controllers[1];
      var chart = graphController.getChart();

      function addScatterPlot () {
        if ($attrs.dotSizeScaler) {
          var z = chart.addMeasureAxis('z', $attrs.dotSizeScaler);
          z.overrideMin = 0;
          z.overrideMax = 100;
        }

        var array = [];

        if ($attrs.series){ array.push($attrs.series); }
        array.push($attrs.field);
        if ($attrs.label || $attrs.label === '') { array.push($attrs.label); }
        var scatterPlot = chart.addSeries(array, dimple.plot.bubble);
        scatterPlot.aggregate = dimple.aggregateMethod.avg;
        graphController.filter($attrs);
        graphController.draw();

        if ($scope.overrideTooltip) {
          scatterPlot.getTooltipText = function (e) {
            return $scope.overrideTooltip(e);
          }
        }
      }

      $scope.$watch('dataReady', function(newValue, oldValue) {
        if (newValue === true) {
          addScatterPlot();
        }
      });
    }
  };
}]);
angular.module('angular-dimple.stacked-area', [])

.directive('dimpleStackedArea', [function () {
  return {
    restrict: 'E',
    replace: true,
    require: ['dimpleStackedArea', '^dimpleGraph'],
    controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {
    }],
    link: function($scope, $element, $attrs, $controllers) {
      var graphController = $controllers[1];
      var areaController = $controllers[0];
      var chart = graphController.getChart();

      function addArea () {
        var area;
        if ($attrs.series) {
          area = chart.addSeries([$attrs.series], dimple.plot.area);
        } else {
          area = chart.addSeries([$attrs.field], dimple.plot.area);
        }
        graphController.filter($attrs);
        area.lineMarkers = false;
        graphController.draw();
      }

      $scope.$watch('dataReady', function(newValue, oldValue) {
        if (newValue === true) {
          addArea();
        }
      });
    }
  };
}]);
angular.module('angular-dimple.stacked-bar', [])

.directive('dimpleStackedBar', [function () {
  return {
    restrict: 'E',
    replace: true,
    require: ['dimpleStackedBar', '^dimpleGraph'],
    controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {
    }],
    link: function($scope, $element, $attrs, $controllers) {
      var graphController = $controllers[1];
      var lineController = $controllers[0];
      var chart = graphController.getChart();

      function addBar () {
        var bar;
        if ($attrs.series) {
          bar = chart.addSeries([$attrs.series], dimple.plot.bar);
        } else {
          bar = chart.addSeries([$attrs.field], dimple.plot.bar);
        }

        if ($attrs.orderBy) {
          bar.addOrderRule($attrs.orderBy);
        } else if ($attrs.orderByDesc) {
          bar.addOrderRule($attrs.orderByDesc, true);
        }

        if ($scope.onTooltip) {
          bar.getTooltipText = function(e) { return $scope.onTooltip(e) };
        }

        if ($scope.dimpleClick) {
          bar.addEventHandler('click', function(e) {
            $scope.dimpleClick(e);
          });
        }

        graphController.filter($attrs);
        graphController.draw();
      }

      $scope.$watch('dataReady', function(newValue, oldValue) {
        if (newValue === true) {
          addBar();
        }
      });
    }
  };
}]);
angular.module('angular-dimple.x', [])

.directive('dimpleX', [function () {
  return {
    restrict: 'E',
    replace: true,
    require: ['dimpleX', '^dimpleGraph'],
    controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {
    }],
    link: function($scope, $element, $attrs, $controllers) {
      var graphController = $controllers[1];
      var chart = graphController.getChart();

      function addAxis () {
        var x;
        if ($attrs.groupBy) {
          if ($attrs.type == 'Measure') {
            x = chart.addMeasureAxis('x', [$attrs.groupBy, $attrs.field]);
          } else if ($attrs.type == 'Percent') {
            x = chart.addPctAxis('x', $attrs.field);
          } else if ($attrs.type == 'Time') {
            x = chart.addTimeAxis('x', $attrs.field);
            if ($attrs.format) {
              x.tickFormat = $attrs.format;
            }
          } else {
            x = chart.addCategoryAxis('x', [$attrs.groupBy, $attrs.field]);
          }
          if ($attrs.orderBy) {
            x.addGroupOrderRule($attrs.orderBy);
          }
          if ($attrs.orderByDesc) {
            x.addGroupOrderRule($attrs.orderByDesc, true);
          }
        } else {
          if ($attrs.type == 'Measure') {
            x = chart.addMeasureAxis('x', $attrs.field);
          } else if ($attrs.type == 'Percent') {
            x = chart.addPctAxis('x', $attrs.field);
          } else if ($attrs.type == 'Time') {
            x = chart.addTimeAxis('x', $attrs.field);
            if ($attrs.format) {
              x.tickFormat = $attrs.format;
            }
          } else {
            x = chart.addCategoryAxis('x', $attrs.field);
          }

          if ($attrs.orderBy) {
            if ($attrs.orderWithData) {
              var orderArray = _.chain($scope.data).sortBy($attrs.orderBy).map($attrs.field).value();
              x.addOrderRule(orderArray);
            } else {
              x.addOrderRule($attrs.orderBy);
            }
          }
          if ($attrs.orderByDesc) {
            x.addOrderRule($attrs.orderByDesc, true);
          }
        }

        if ($attrs.title && $attrs.title !== "null") {
          x.title = $attrs.title;
        } else if ($attrs.title == "null") {
          x.title = null;
        }

        if ($attrs.fontSize) {
          x.fontSize = $attrs.fontSize;
        }

        if ($scope.wrapXLabels) {
          x.autoRotateLabel = false;
        }

        if ($attrs.showGridlines) {
          x.showGridlines = true;
        }
      }

      $scope.$watch('dataReady', function(newValue, oldValue) {
        if (newValue === true) {
          addAxis();
        }
      });
    }
  };
}]);
angular.module('angular-dimple.y', [])

.directive('dimpleY', [function () {
  return {
    restrict: 'E',
    replace: true,
    require: ['dimpleY', '^dimpleGraph'],
    controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {
    }],
    link: function($scope, $element, $attrs, $controllers) {
      var graphController = $controllers[1];
      var chart = graphController.getChart();

      function addAxis () {
        var y;
        if ($attrs.groupBy) {
          if ($attrs.type == 'Category') {
            y = chart.addCategoryAxis('y', $attrs.field);
          } else if ($attrs.type == 'Percent') {
            y = chart.addPctAxis('y', $attrs.field);
          } else if ($attrs.type == 'Time') {
            y = chart.addTimeAxis('y', $attrs.field);
            if ($attrs.format) {
              y.tickFormat = $attrs.format;
            }
          } else {
            y = chart.addMeasureAxis('y', $attrs.field);
          }
          if ($attrs.orderBy) {
            y.addGroupOrderRule($attrs.orderBy);
          }
        } else {
          if ($attrs.type == 'Category') {
            y = chart.addCategoryAxis('y', $attrs.field);
          } else if ($attrs.type == 'Percent') {
            y = chart.addPctAxis('y', $attrs.field);
          } else if ($attrs.type == 'Time') {
            y = chart.addTimeAxis('y', $attrs.field);
            if ($attrs.format) {
              y.tickFormat = $attrs.format;
            }
          } else {
            y = chart.addMeasureAxis('y', $attrs.field);
          }
          if ($attrs.orderBy) {
            y.addOrderRule($attrs.orderBy);
          }
        }

        if ($attrs.title && $attrs.title !== "null") {
          y.title = $attrs.title;
        } else if ($attrs.title == "null") {
          y.title = null;
        }

        if ($scope.overrideMin) {
          y.overrideMin = $scope.overrideMin;
        }
        if ($scope.overrideMax) {
          y.overrideMax = $scope.overrideMax;
        }

        if ($attrs.fontSize) {
          y.fontSize = $attrs.fontSize;
        }

        if ($attrs.showGridlines) {
          y.showGridlines = true;
        }
      }

      $scope.$watch('dataReady', function(newValue, oldValue) {
        if (newValue === true) {
          addAxis();
        }
      });
    }
  };
}]);
angular.module('angular-dimple.scaledColor', [])

.directive('dimpleScaledColor', [function () {
  return {
    restrict: 'E',
    replace: true,
    require: ['dimpleScaledColor', '^dimpleGraph'],
    controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs) {
    }],
    link: function($scope, $element, $attrs, $controllers) {
      var graphController = $controllers[1];
      var chart = graphController.getChart();

      function addAxis () {
        chart.addColorAxis($attrs.field);
      }

      $scope.$watch('dataReady', function(newValue, oldValue) {
        if (newValue === true) {
          addAxis();
        }
      });
    }
  };
}]);
})();

/***/ }),
/* 1058 */
/***/ (function(module, exports) {


appInsightsService.$inject = ["environment", "$window"];angular.module("aps.services.appInsights", [])
  .service("appInsightsService", appInsightsService);

function appInsightsService(environment, $window) {
  function initialize($transitions) {
    if (!environment.APP_INSIGHTS_KEY) {
      return;
    }

    var appInsights=$window.appInsights||function(config){
      function i(config){t[config]=function(){var i=arguments;t.queue.push(function(){t[config].apply(t,i)})}}var t={config:config},u=document,e=window,o="script",s="AuthenticatedUserContext",h="start",c="stop",l="Track",a=l+"Event",v=l+"Page",y=u.createElement(o),r,f;y.src=config.url||"https://az416426.vo.msecnd.net/scripts/a/ai.0.js";u.getElementsByTagName(o)[0].parentNode.appendChild(y);try{t.cookie=u.cookie}catch(p){}for(t.queue=[],t.version="1.0",r=["Event","Exception","Metric","PageView","Trace","Dependency"];r.length;)i("track"+r.pop());return i("set"+s),i("clear"+s),i(h+a),i(c+a),i(h+v),i(c+v),i("flush"),config.disableExceptionTracking||(r="onerror",i("_"+r),f=e[r],e[r]=function(config,i,u,e,o){var s=f&&f(config,i,u,e,o);return s!==!0&&t["_"+r](config,i,u,e,o),s}),t
    }({
      instrumentationKey: environment.APP_INSIGHTS_KEY
    });

    $window.appInsights=appInsights;

    if ($transitions) {
      $transitions.onSuccess({ }, function(transition) {
        var to = transition.$to();
        try {
          appInsights.trackPageView(to.name, null, transition.params('to'));
        }
        catch (e) {
          // ignore
        }
      });
    }
  }

  return {
    initialize: initialize
  };
}


/***/ })
],[378]);


// WEBPACK FOOTER //
// app-04225486e1426e4cf5dc.js